// File auto-generated using graphql-codegen. Do not edit manually. Run `npm run dev:gen-phase-3-prod` to regenerate.
// noinspection JSUnusedGlobalSymbols

/* eslint-disable */

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
export type Maybe<T> = T | null | undefined;
export type InputMaybe<T> = T | null | undefined;
export type Exact<T extends { [key: string]: unknown }> = {
  [K in keyof T]: T[K];
};
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & {
  [SubKey in K]?: Maybe<T[SubKey]>;
};
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & {
  [SubKey in K]: Maybe<T[SubKey]>;
};
const defaultOptions = {} as const;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
  Buffer: any;
  Date: any;
  /** The `JSON` scalar type represents JSON values as specified by [ECMA-404](http://www.ecma-international.org/publications/files/ECMA-ST/ECMA-404.pdf). */
  JSON: any;
  /** The `JSONObject` scalar type represents JSON objects as specified by [ECMA-404](http://www.ecma-international.org/publications/files/ECMA-ST/ECMA-404.pdf). */
  JSONObject: any;
  /** The `ID` scalar type represents a unique MongoDB identifier in collection. MongoDB by default use 12-byte ObjectId value (https://docs.mongodb.com/manual/reference/bson-types/#objectid). But MongoDB also may accepts string or integer as correct values for _id field. */
  MongoID: any;
  /** The string representation of JavaScript regexp. You may provide it with flags "/^abc.*\/i" or without flags like "^abc.*". More info about RegExp characters and flags: https://developer.mozilla.org/en-US/docs/Web/JavaScript/Guide/Regular_Expressions */
  RegExpAsString: any;
};

export type AbilityRule = {
  __typename?: 'AbilityRule';
  action: Scalars['String'];
  conditions?: Maybe<Scalars['JSON']>;
  inverted: Scalars['Boolean'];
  reason?: Maybe<Scalars['String']>;
  subject: Scalars['String'];
};

export type Actuator = DeviceInterface & {
  __typename: 'Actuator';
  _id: Scalars['String'];
  alertTypes?: Maybe<DeviceAlertTypes>;
  chartTypes: Array<ChartType>;
  controlMode?: Maybe<ActuatorControlMode>;
  controlled?: Maybe<DeviceControlled>;
  defaultPosition?: Maybe<ActuatorDefaultPosition>;
  dependentDeviceIds: Array<Maybe<Scalars['String']>>;
  deviceAlerts: Array<Maybe<Alert>>;
  deviceId?: Maybe<Scalars['String']>;
  deviceIdentifier?: Maybe<Scalars['String']>;
  deviceMetrics?: Maybe<Array<Maybe<DeviceMetric>>>;
  displayName?: Maybe<Scalars['String']>;
  hasPendingUpdates: Scalars['Boolean'];
  installation?: Maybe<DeviceInstallation>;
  isConfigured?: Maybe<Scalars['Boolean']>;
  isControlled: Scalars['Boolean'];
  isPoweredOn?: Maybe<Scalars['Boolean']>;
  location?: Maybe<Scalars['String']>;
  meta?: Maybe<DeviceMeta>;
  modelChangeOperation?: Maybe<Scalars['String']>;
  modelType?: Maybe<Scalars['String']>;
  /** The name of the device */
  name?: Maybe<Scalars['String']>;
  panel?: Maybe<Panel>;
  panelId?: Maybe<Scalars['String']>;
  position?: Maybe<ActuatorPosition>;
  powerState?: Maybe<DevicePowerState>;
  property?: Maybe<Property>;
  propertyId: Scalars['String'];
  source?: Maybe<Source>;
  sourceAlerts: Array<Maybe<Alert>>;
  sourceId?: Maybe<Scalars['String']>;
  timestamp?: Maybe<Scalars['Float']>;
  type?: Maybe<EnumDKeyDeviceType>;
  typeDisplayName: Scalars['String'];
  unit?: Maybe<Unit>;
  unitId: Scalars['String'];
  updateDescription?: Maybe<Scalars['JSON']>;
  updateStatus?: Maybe<Scalars['Boolean']>;
  vpp?: Maybe<VirtualPowerPlant>;
  vppId?: Maybe<Scalars['String']>;
  zone?: Maybe<Zone>;
  zoneId?: Maybe<Scalars['String']>;
};

export type ActuatorDeviceAlertsArgs = {
  filter?: InputMaybe<FilterFindManyAlertInput>;
  limit?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<SortFindManyAlertInput>;
};

export type ActuatorSourceAlertsArgs = {
  filter?: InputMaybe<FilterFindManyAlertInput>;
  limit?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<SortFindManyAlertInput>;
};

export type ActuatorControlMode = {
  __typename?: 'ActuatorControlMode';
  id?: Maybe<Scalars['String']>;
  observedAt?: Maybe<Scalars['Float']>;
  previousId?: Maybe<Scalars['String']>;
  timestamp?: Maybe<Scalars['Float']>;
  units?: Maybe<Scalars['String']>;
  updatePending?: Maybe<Scalars['Boolean']>;
  value?: Maybe<EnumActuatorControlModeValue>;
};

export type ActuatorDefaultPosition = {
  __typename?: 'ActuatorDefaultPosition';
  id?: Maybe<Scalars['String']>;
  observedAt?: Maybe<Scalars['Float']>;
  previousId?: Maybe<Scalars['String']>;
  timestamp?: Maybe<Scalars['Float']>;
  units?: Maybe<Scalars['String']>;
  updatePending?: Maybe<Scalars['Boolean']>;
  value?: Maybe<Scalars['Float']>;
};

export type ActuatorPosition = {
  __typename?: 'ActuatorPosition';
  id?: Maybe<Scalars['String']>;
  observedAt?: Maybe<Scalars['Float']>;
  previousId?: Maybe<Scalars['String']>;
  timestamp?: Maybe<Scalars['Float']>;
  units?: Maybe<Scalars['String']>;
  updatePending?: Maybe<Scalars['Boolean']>;
  value?: Maybe<Scalars['Float']>;
};

export type ActuatorUpdateInput = {
  controlMode?: InputMaybe<Scalars['String']>;
  position?: InputMaybe<Scalars['Float']>;
};

export type ActuatorUpdateOptions = {
  forcePush?: InputMaybe<Scalars['Boolean']>;
};

export type AdjustmentInterface = {
  type: Scalars['String'];
};

export type AggregateCategoricalChartSeries = IChartSeries & {
  __typename?: 'AggregateCategoricalChartSeries';
  aggregateInterval: Scalars['String'];
  data: Array<AggregateCategoricalDatapoint>;
  deviceId: Scalars['String'];
  distinctValues: Array<Scalars['String']>;
  readingType: Scalars['String'];
  units?: Maybe<Scalars['String']>;
};

export type AggregateCategoricalDatapoint = IDatapoint & {
  __typename?: 'AggregateCategoricalDatapoint';
  deviceId: Scalars['String'];
  id: Scalars['String'];
  readingType: Scalars['String'];
  timestamp: Scalars['String'];
  values: Scalars['JSONObject'];
};

export enum AirFlowUnit {
  Cfm = 'CFM',
  Lps = 'LPS',
}

export type Alert = {
  __typename: 'Alert';
  _id: Scalars['String'];
  affectedDevice?: Maybe<Device>;
  affectedProperty?: Maybe<Property>;
  affectedSource?: Maybe<Source>;
  affectedUnit?: Maybe<Unit>;
  alertCategory?: Maybe<AlertCategory>;
  alertTrigger?: Maybe<AlertTrigger>;
  building?: Maybe<AlertBuilding>;
  device?: Maybe<AlertDevice>;
  id?: Maybe<Scalars['String']>;
  initiated?: Maybe<Scalars['Float']>;
  meta?: Maybe<AlertMeta>;
  modelChangeOperation?: Maybe<Scalars['String']>;
  modelType?: Maybe<Scalars['String']>;
  panel?: Maybe<AlertPanel>;
  property?: Maybe<AlertProperty>;
  severity?: Maybe<Scalars['String']>;
  sourceId?: Maybe<Scalars['String']>;
  type?: Maybe<AlertType>;
  unit?: Maybe<AlertUnit>;
  updateDescription?: Maybe<Scalars['JSON']>;
  updated?: Maybe<Scalars['Float']>;
  zone?: Maybe<AlertZone>;
};

export type AlertAlertCategoryInput = {
  id?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
};

export type AlertAlertTriggerInput = {
  id?: InputMaybe<Scalars['String']>;
  key?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
};

export type AlertBuilding = {
  __typename?: 'AlertBuilding';
  id?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
};

export type AlertBuildingInput = {
  id?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
};

export type AlertCategory = {
  __typename: 'AlertCategory';
  _id: Scalars['String'];
  description?: Maybe<Scalars['String']>;
  key: Scalars['String'];
  modelChangeOperation?: Maybe<Scalars['String']>;
  modelType?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  propertyId: Scalars['String'];
  updateDescription?: Maybe<Scalars['JSON']>;
};

/** List of items with pagination. */
export type AlertCategoryPaginatedAlertCategories = {
  __typename?: 'AlertCategoryPaginatedAlertCategories';
  /** Total object count. */
  count?: Maybe<Scalars['Int']>;
  /** Array of objects. */
  items?: Maybe<Array<AlertCategory>>;
  /** Information to aid in pagination. */
  pageInfo: PaginationInfo;
};

export type AlertDevice = {
  __typename?: 'AlertDevice';
  id: Scalars['String'];
  model?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  role?: Maybe<Scalars['String']>;
  type: Scalars['String'];
  version?: Maybe<Scalars['String']>;
};

export type AlertDeviceInput = {
  id: Scalars['String'];
  model?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  role?: InputMaybe<Scalars['String']>;
  type: Scalars['String'];
  version?: InputMaybe<Scalars['String']>;
};

export type AlertMeta = {
  __typename?: 'AlertMeta';
  id_str?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Float']>;
  message?: Maybe<Scalars['String']>;
  portName?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['String']>;
};

export type AlertMetaInput = {
  id_str?: InputMaybe<Scalars['String']>;
  limit?: InputMaybe<Scalars['Float']>;
  message?: InputMaybe<Scalars['String']>;
  portName?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<Scalars['String']>;
};

export type AlertNotification = {
  __typename: 'AlertNotification';
  _id: Scalars['String'];
  alertId: Scalars['String'];
  deliveryAttemptCount: Scalars['Float'];
  externalId?: Maybe<Scalars['String']>;
  lastDeliveryAttemptStatus: EnumAlertNotificationLastDeliveryAttemptStatus;
  lastDeliveryAttemptTimestamp?: Maybe<Scalars['Float']>;
  modelChangeOperation?: Maybe<Scalars['String']>;
  modelType?: Maybe<Scalars['String']>;
  notificationMethod: EnumAlertNotificationNotificationMethod;
  notificationType: EnumAlertNotificationNotificationType;
  recipient: Scalars['String'];
  timestamp: Scalars['Float'];
  updateDescription?: Maybe<Scalars['JSON']>;
};

/** List of items with pagination. */
export type AlertNotificationPaginatedAlertNotifications = {
  __typename?: 'AlertNotificationPaginatedAlertNotifications';
  /** Total object count. */
  count?: Maybe<Scalars['Int']>;
  /** Array of objects. */
  items?: Maybe<Array<AlertNotification>>;
  /** Information to aid in pagination. */
  pageInfo: PaginationInfo;
};

export type AlertOptOut = {
  __typename: 'AlertOptOut';
  _id: Scalars['String'];
  modelChangeOperation?: Maybe<Scalars['String']>;
  modelType?: Maybe<Scalars['String']>;
  optOutMethod: EnumAlertOptOutOptOutMethod;
  optOutTimestamp: Scalars['Float'];
  recipient: Scalars['String'];
  updateDescription?: Maybe<Scalars['JSON']>;
};

/** List of items with pagination. */
export type AlertOptOutPaginatedAlertOptOuts = {
  __typename?: 'AlertOptOutPaginatedAlertOptOuts';
  /** Total object count. */
  count?: Maybe<Scalars['Int']>;
  /** Array of objects. */
  items?: Maybe<Array<AlertOptOut>>;
  /** Information to aid in pagination. */
  pageInfo: PaginationInfo;
};

/** List of items with pagination. */
export type AlertPaginatedAlerts = {
  __typename?: 'AlertPaginatedAlerts';
  /** Total object count. */
  count?: Maybe<Scalars['Int']>;
  /** Array of objects. */
  items?: Maybe<Array<Alert>>;
  /** Information to aid in pagination. */
  pageInfo: PaginationInfo;
};

export type AlertPanel = {
  __typename?: 'AlertPanel';
  id?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
};

export type AlertPanelInput = {
  id?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
};

export type AlertProperty = {
  __typename?: 'AlertProperty';
  contact?: Maybe<AlertPropertyContact>;
  id?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
};

export type AlertPropertyContact = {
  __typename?: 'AlertPropertyContact';
  email?: Maybe<Scalars['String']>;
  email2?: Maybe<Scalars['String']>;
  email3?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  smsNumber?: Maybe<Scalars['String']>;
  smsNumber2?: Maybe<Scalars['String']>;
  smsNumber3?: Maybe<Scalars['String']>;
  smsOptInStatus1?: Maybe<EnumAlertPropertyContactSmsOptInStatus1>;
  smsOptInStatus2?: Maybe<EnumAlertPropertyContactSmsOptInStatus2>;
  smsOptInStatus3?: Maybe<EnumAlertPropertyContactSmsOptInStatus3>;
  smsOptInTimestamp1?: Maybe<Scalars['Float']>;
  smsOptInTimestamp2?: Maybe<Scalars['Float']>;
  smsOptInTimestamp3?: Maybe<Scalars['Float']>;
};

export type AlertPropertyContactInput = {
  email?: InputMaybe<Scalars['String']>;
  email2?: InputMaybe<Scalars['String']>;
  email3?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  smsNumber?: InputMaybe<Scalars['String']>;
  smsNumber2?: InputMaybe<Scalars['String']>;
  smsNumber3?: InputMaybe<Scalars['String']>;
  smsOptInStatus1?: InputMaybe<EnumAlertPropertyContactSmsOptInStatus1>;
  smsOptInStatus2?: InputMaybe<EnumAlertPropertyContactSmsOptInStatus2>;
  smsOptInStatus3?: InputMaybe<EnumAlertPropertyContactSmsOptInStatus3>;
  smsOptInTimestamp1?: InputMaybe<Scalars['Float']>;
  smsOptInTimestamp2?: InputMaybe<Scalars['Float']>;
  smsOptInTimestamp3?: InputMaybe<Scalars['Float']>;
};

export type AlertPropertyInput = {
  contact?: InputMaybe<AlertPropertyContactInput>;
  id?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
};

export type AlertSubscription = {
  __typename: 'AlertSubscription';
  _id: Scalars['String'];
  alertTrigger?: Maybe<AlertTrigger>;
  alertTriggerId: Scalars['String'];
  device: Device;
  deviceId?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  modelChangeOperation?: Maybe<Scalars['String']>;
  modelType?: Maybe<Scalars['String']>;
  property?: Maybe<Property>;
  propertyId?: Maybe<Scalars['String']>;
  sms?: Maybe<Scalars['String']>;
  unit?: Maybe<Unit>;
  unitCategoryId?: Maybe<Scalars['String']>;
  unitId?: Maybe<Scalars['String']>;
  updateDescription?: Maybe<Scalars['JSON']>;
  userId?: Maybe<Scalars['String']>;
  viaEmail?: Maybe<Scalars['Boolean']>;
  viaSms?: Maybe<Scalars['Boolean']>;
};

/** List of items with pagination. */
export type AlertSubscriptionPaginatedAlertSubscriptions = {
  __typename?: 'AlertSubscriptionPaginatedAlertSubscriptions';
  /** Total object count. */
  count?: Maybe<Scalars['Int']>;
  /** Array of objects. */
  items?: Maybe<Array<AlertSubscription>>;
  /** Information to aid in pagination. */
  pageInfo: PaginationInfo;
};

export type AlertSubscriptionSpecification = {
  /** The id of the alert trigger acting as the basis for the subscription */
  id: Scalars['String'];
  /** Whether or not the alert notification should be sent via email */
  viaEmail?: InputMaybe<Scalars['Boolean']>;
  /** Whether or not the alert notification should be sent via SMS */
  viaSms?: InputMaybe<Scalars['Boolean']>;
};

export type AlertTrigger = {
  __typename: 'AlertTrigger';
  _id: Scalars['String'];
  alertCategory?: Maybe<AlertCategory>;
  alertCategoryId: Scalars['String'];
  editMode: Scalars['Float'];
  enabled: Scalars['Boolean'];
  entityTypes: Array<Maybe<Scalars['String']>>;
  key: Scalars['String'];
  legacyKey?: Maybe<Scalars['String']>;
  modelChangeOperation?: Maybe<Scalars['String']>;
  modelType?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  propertyId: Scalars['String'];
  triggerCriteria?: Maybe<AlertTriggerTriggerCriteria>;
  updateDescription?: Maybe<Scalars['JSON']>;
};

/** List of items with pagination. */
export type AlertTriggerPaginatedAlertTriggers = {
  __typename?: 'AlertTriggerPaginatedAlertTriggers';
  /** Total object count. */
  count?: Maybe<Scalars['Int']>;
  /** Array of objects. */
  items?: Maybe<Array<AlertTrigger>>;
  /** Information to aid in pagination. */
  pageInfo: PaginationInfo;
};

export type AlertTriggerTriggerCriteria = {
  __typename?: 'AlertTriggerTriggerCriteria';
  basisName: Scalars['String'];
  basisType: EnumAlertTriggerTriggerCriteriaBasisType;
  levels?: Maybe<Scalars['Float']>;
  selectionCriteria: AlertTriggerTriggerCriteriaSelectionCriteria;
};

export type AlertTriggerTriggerCriteriaSelectionCriteria = {
  __typename?: 'AlertTriggerTriggerCriteriaSelectionCriteria';
  compoundOperator?: Maybe<AlertTriggerTriggerCriteriaSelectionCriteriaCompoundOperator>;
  criteria?: Maybe<
    Array<Maybe<AlertTriggerTriggerCriteriaSelectionCriteriaCriterion>>
  >;
  criterion?: Maybe<AlertTriggerTriggerCriteriaSelectionCriteriaCriterion>;
  simpleOperator?: Maybe<AlertTriggerTriggerCriteriaSelectionCriteriaSimpleOperator>;
};

export type AlertTriggerTriggerCriteriaSelectionCriteriaCompoundOperator = {
  __typename?: 'AlertTriggerTriggerCriteriaSelectionCriteriaCompoundOperator';
  criteria: Scalars['JSON'];
  id: Scalars['String'];
  operator: EnumAlertTriggerTriggerCriteriaSelectionCriteriaCompoundOperatorOperator;
};

export type AlertTriggerTriggerCriteriaSelectionCriteriaCriterion = {
  __typename?: 'AlertTriggerTriggerCriteriaSelectionCriteriaCriterion';
  comparator: EnumAlertTriggerTriggerCriteriaSelectionCriteriaCriterionComparator;
  editable?: Maybe<Scalars['Boolean']>;
  id: Scalars['String'];
  legacyPath?: Maybe<Scalars['String']>;
  selectionPath: Scalars['String'];
  template?: Maybe<Scalars['String']>;
  valueType: EnumAlertTriggerTriggerCriteriaSelectionCriteriaCriterionValueType;
  values: Array<Maybe<Scalars['String']>>;
};

export type AlertTriggerTriggerCriteriaSelectionCriteriaSimpleOperator = {
  __typename?: 'AlertTriggerTriggerCriteriaSelectionCriteriaSimpleOperator';
  criteria?: Maybe<
    Array<Maybe<AlertTriggerTriggerCriteriaSelectionCriteriaCriterion>>
  >;
  criterion?: Maybe<AlertTriggerTriggerCriteriaSelectionCriteriaCriterion>;
  id: Scalars['String'];
  operator: EnumAlertTriggerTriggerCriteriaSelectionCriteriaSimpleOperatorOperator;
};

export type AlertType = {
  __typename?: 'AlertType';
  id?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
};

export type AlertTypeInput = {
  id?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
};

export type AlertUnit = {
  __typename?: 'AlertUnit';
  id?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
};

export type AlertUnitInput = {
  id?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
};

export type AlertZone = {
  __typename?: 'AlertZone';
  id?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
};

export type AlertZoneInput = {
  id?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
};

export type Application = {
  __typename?: 'Application';
  name: Scalars['String'];
};

export type AuthenticationProfile = {
  __typename: 'AuthenticationProfile';
  _id: Scalars['String'];
  /** Returns a list of associated authenticator devices. */
  authenticatorDevices: Array<Maybe<AuthenticatorDevice>>;
  currentChallenge?: Maybe<Scalars['String']>;
  currentChallengeExpiresAt?: Maybe<Scalars['Float']>;
  externalId?: Maybe<Scalars['String']>;
  factors?: Maybe<Array<Maybe<AuthenticationProfileFactors>>>;
  failedAttempts?: Maybe<Scalars['Float']>;
  initialFactors?: Maybe<Array<Maybe<AuthenticationProfileInitialFactors>>>;
  lastFailedLogin?: Maybe<Scalars['Float']>;
  lastLogin?: Maybe<Scalars['Float']>;
  lockedAt?: Maybe<Scalars['Float']>;
  modelChangeOperation?: Maybe<Scalars['String']>;
  modelType?: Maybe<Scalars['String']>;
  updateDescription?: Maybe<Scalars['JSON']>;
  userId: Scalars['String'];
};

export type AuthenticationProfileFactors = {
  __typename: 'AuthenticationProfileFactors';
  _id?: Maybe<Scalars['String']>;
  credentialBoundTo?: Maybe<Scalars['String']>;
  engine?: Maybe<EnumAuthenticationProfileFactorsEngine>;
  externalId?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  order: Scalars['Float'];
  preferred?: Maybe<Scalars['Boolean']>;
  primary?: Maybe<Scalars['Boolean']>;
  sufficient?: Maybe<Scalars['Boolean']>;
  type: EnumAuthenticationProfileFactorsType;
  value?: Maybe<Scalars['String']>;
};

export type AuthenticationProfileInitialFactors = {
  __typename: 'AuthenticationProfileInitialFactors';
  _id?: Maybe<Scalars['String']>;
  autoSatisfy?: Maybe<Scalars['Boolean']>;
  credentialBoundTo?: Maybe<Scalars['String']>;
  endpointId?: Maybe<Scalars['String']>;
  engine?: Maybe<EnumAuthenticationProfileInitialFactorsEngine>;
  expiration?: Maybe<Scalars['Float']>;
  factorId?: Maybe<Scalars['String']>;
};

/** List of items with pagination. */
export type AuthenticationProfilePaginatedAuthenticationProfiles = {
  __typename?: 'AuthenticationProfilePaginatedAuthenticationProfiles';
  /** Total object count. */
  count?: Maybe<Scalars['Int']>;
  /** Array of objects. */
  items?: Maybe<Array<AuthenticationProfile>>;
  /** Information to aid in pagination. */
  pageInfo: PaginationInfo;
};

export type AuthenticatorDevice = {
  __typename: 'AuthenticatorDevice';
  _id: Scalars['String'];
  aaguid?: Maybe<Scalars['String']>;
  counter?: Maybe<Scalars['Float']>;
  createdAt?: Maybe<Scalars['Float']>;
  credentialBackedUp?: Maybe<Scalars['Boolean']>;
  credentialBoundTo?: Maybe<Scalars['String']>;
  credentialDeviceType?: Maybe<Scalars['String']>;
  credentialEcosystem?: Maybe<EnumAuthenticatorDeviceCredentialEcosystem>;
  credentialID?: Maybe<Scalars['Buffer']>;
  credentialIsExternal?: Maybe<Scalars['Boolean']>;
  credentialOS?: Maybe<EnumAuthenticatorDeviceCredentialOs>;
  credentialPublicKey?: Maybe<Scalars['Buffer']>;
  credentialType?: Maybe<Scalars['String']>;
  deviceName?: Maybe<Scalars['String']>;
  deviceType?: Maybe<Scalars['String']>;
  endpointId?: Maybe<Scalars['String']>;
  enforceUserVerification?: Maybe<Scalars['Boolean']>;
  lastUsed?: Maybe<Scalars['Float']>;
  modelChangeOperation?: Maybe<Scalars['String']>;
  modelType?: Maybe<Scalars['String']>;
  transports?: Maybe<Array<Maybe<Scalars['String']>>>;
  updateDescription?: Maybe<Scalars['JSON']>;
  userId?: Maybe<Scalars['String']>;
  userVerified?: Maybe<Scalars['Boolean']>;
};

/** List of items with pagination. */
export type AuthenticatorDevicePaginatedAuthenticatorDevices = {
  __typename?: 'AuthenticatorDevicePaginatedAuthenticatorDevices';
  /** Total object count. */
  count?: Maybe<Scalars['Int']>;
  /** Array of objects. */
  items?: Maybe<Array<AuthenticatorDevice>>;
  /** Information to aid in pagination. */
  pageInfo: PaginationInfo;
};

export type AuthorizationProfile = {
  __typename: 'AuthorizationProfile';
  _id: Scalars['String'];
  accessibleProperties: Array<Maybe<Property>>;
  apiToken?: Maybe<Scalars['String']>;
  currentChallenge?: Maybe<Scalars['String']>;
  currentChallengeExpiration?: Maybe<Scalars['Float']>;
  installerProperties?: Maybe<Array<Maybe<Scalars['String']>>>;
  isInstaller?: Maybe<Scalars['Boolean']>;
  isManager?: Maybe<Scalars['Boolean']>;
  isResident?: Maybe<Scalars['Boolean']>;
  isSuper?: Maybe<Scalars['Boolean']>;
  isViewer?: Maybe<Scalars['Boolean']>;
  managerProperties: Array<Maybe<Scalars['String']>>;
  modelChangeOperation?: Maybe<Scalars['String']>;
  modelType?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  residentProperty?: Maybe<Scalars['String']>;
  residentUnit?: Maybe<Scalars['String']>;
  updateDescription?: Maybe<Scalars['JSON']>;
  user?: Maybe<User>;
  userId?: Maybe<Scalars['String']>;
  viewerProperties?: Maybe<Array<Maybe<Scalars['String']>>>;
};

/** List of items with pagination. */
export type AuthorizationProfilePaginatedAuthorizationProfiles = {
  __typename?: 'AuthorizationProfilePaginatedAuthorizationProfiles';
  /** Total object count. */
  count?: Maybe<Scalars['Int']>;
  /** Array of objects. */
  items?: Maybe<Array<AuthorizationProfile>>;
  /** Information to aid in pagination. */
  pageInfo: PaginationInfo;
};

export type Bng = SourceInterface & {
  __typename: 'BNG';
  _id: Scalars['String'];
  alerts: Array<Maybe<Alert>>;
  /** Returns the authorization profile associated with the user. */
  inUse: Scalars['Boolean'];
  localUrl?: Maybe<Scalars['String']>;
  modelChangeOperation?: Maybe<Scalars['String']>;
  modelType?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  panels: Array<Maybe<Panel>>;
  property?: Maybe<Property>;
  propertyId?: Maybe<Scalars['String']>;
  timestamp?: Maybe<Scalars['Float']>;
  type?: Maybe<EnumDKeySourceType>;
  units: Array<Maybe<Unit>>;
  updateDescription?: Maybe<Scalars['JSON']>;
  url?: Maybe<Scalars['String']>;
  zones: Array<Maybe<Zone>>;
};

export type BngAlertsArgs = {
  filter?: InputMaybe<FilterFindManyAlertInput>;
  limit?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<SortFindManyAlertInput>;
};

export type BngPanelsArgs = {
  filter?: InputMaybe<FilterFindManyPanelInput>;
  limit?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<SortFindManyPanelInput>;
};

export type BngUnitsArgs = {
  filter?: InputMaybe<FilterFindManyUnitInput>;
  limit?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<SortFindManyUnitInput>;
};

export type BngZonesArgs = {
  filter?: InputMaybe<FilterFindManyZoneInput>;
  limit?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<SortFindManyZoneInput>;
};

export type BatteryManagementSystem = DeviceInterface & {
  __typename: 'BatteryManagementSystem';
  _id: Scalars['String'];
  alertTypes?: Maybe<DeviceAlertTypes>;
  batteryEfficiency?: Maybe<BatteryManagementSystemBatteryEfficiency>;
  cellCurrents?: Maybe<Array<Maybe<BatteryManagementSystemCellCurrents>>>;
  cellCycleCounts?: Maybe<Array<Maybe<BatteryManagementSystemCellCycleCounts>>>;
  cellTemperatures?: Maybe<
    Array<Maybe<BatteryManagementSystemCellTemperatures>>
  >;
  cellVoltages?: Maybe<Array<Maybe<BatteryManagementSystemCellVoltages>>>;
  chartTypes: Array<ChartType>;
  controlled?: Maybe<DeviceControlled>;
  current?: Maybe<BatteryManagementSystemCurrent>;
  dependentDeviceIds: Array<Maybe<Scalars['String']>>;
  deviceAlerts: Array<Maybe<Alert>>;
  deviceId?: Maybe<Scalars['String']>;
  deviceIdentifier?: Maybe<Scalars['String']>;
  deviceMetrics?: Maybe<Array<Maybe<DeviceMetric>>>;
  displayName?: Maybe<Scalars['String']>;
  hasPendingUpdates: Scalars['Boolean'];
  installation?: Maybe<DeviceInstallation>;
  inverterId?: Maybe<Scalars['String']>;
  isConfigured?: Maybe<Scalars['Boolean']>;
  isControlled: Scalars['Boolean'];
  isPoweredOn?: Maybe<Scalars['Boolean']>;
  location?: Maybe<Scalars['String']>;
  meta?: Maybe<DeviceMeta>;
  modelChangeOperation?: Maybe<Scalars['String']>;
  modelType?: Maybe<Scalars['String']>;
  /** The name of the device */
  name?: Maybe<Scalars['String']>;
  panel?: Maybe<Panel>;
  panelId?: Maybe<Scalars['String']>;
  powerState?: Maybe<DevicePowerState>;
  property?: Maybe<Property>;
  propertyId: Scalars['String'];
  source?: Maybe<Source>;
  sourceAlerts: Array<Maybe<Alert>>;
  sourceId?: Maybe<Scalars['String']>;
  stateOfCharge?: Maybe<BatteryManagementSystemStateOfCharge>;
  stateOfHealth?: Maybe<BatteryManagementSystemStateOfHealth>;
  temperature?: Maybe<BatteryManagementSystemTemperature>;
  timestamp?: Maybe<Scalars['Float']>;
  type?: Maybe<EnumDKeyDeviceType>;
  typeDisplayName: Scalars['String'];
  unit?: Maybe<Unit>;
  unitId: Scalars['String'];
  updateDescription?: Maybe<Scalars['JSON']>;
  updateStatus?: Maybe<Scalars['Boolean']>;
  voltage?: Maybe<BatteryManagementSystemVoltage>;
  vpp?: Maybe<VirtualPowerPlant>;
  vppId?: Maybe<Scalars['String']>;
  zone?: Maybe<Zone>;
  zoneId?: Maybe<Scalars['String']>;
};

export type BatteryManagementSystemDeviceAlertsArgs = {
  filter?: InputMaybe<FilterFindManyAlertInput>;
  limit?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<SortFindManyAlertInput>;
};

export type BatteryManagementSystemSourceAlertsArgs = {
  filter?: InputMaybe<FilterFindManyAlertInput>;
  limit?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<SortFindManyAlertInput>;
};

export type BatteryManagementSystemBatteryEfficiency = {
  __typename?: 'BatteryManagementSystemBatteryEfficiency';
  id?: Maybe<Scalars['String']>;
  observedAt?: Maybe<Scalars['Float']>;
  previousId?: Maybe<Scalars['String']>;
  timestamp?: Maybe<Scalars['Float']>;
  units?: Maybe<Scalars['String']>;
  updatePending?: Maybe<Scalars['Boolean']>;
  value?: Maybe<Scalars['Float']>;
};

export type BatteryManagementSystemCellCurrents = {
  __typename?: 'BatteryManagementSystemCellCurrents';
  id?: Maybe<Scalars['String']>;
  observedAt?: Maybe<Scalars['Float']>;
  previousId?: Maybe<Scalars['String']>;
  timestamp?: Maybe<Scalars['Float']>;
  units?: Maybe<Scalars['String']>;
  updatePending?: Maybe<Scalars['Boolean']>;
  value?: Maybe<Scalars['Float']>;
};

export type BatteryManagementSystemCellCycleCounts = {
  __typename?: 'BatteryManagementSystemCellCycleCounts';
  id?: Maybe<Scalars['String']>;
  observedAt?: Maybe<Scalars['Float']>;
  previousId?: Maybe<Scalars['String']>;
  timestamp?: Maybe<Scalars['Float']>;
  units?: Maybe<Scalars['String']>;
  updatePending?: Maybe<Scalars['Boolean']>;
  value?: Maybe<Scalars['Float']>;
};

export type BatteryManagementSystemCellTemperatures = {
  __typename?: 'BatteryManagementSystemCellTemperatures';
  id?: Maybe<Scalars['String']>;
  observedAt?: Maybe<Scalars['Float']>;
  previousId?: Maybe<Scalars['String']>;
  timestamp?: Maybe<Scalars['Float']>;
  units?: Maybe<Scalars['String']>;
  updatePending?: Maybe<Scalars['Boolean']>;
  value?: Maybe<Scalars['Float']>;
};

export type BatteryManagementSystemCellVoltages = {
  __typename?: 'BatteryManagementSystemCellVoltages';
  id?: Maybe<Scalars['String']>;
  observedAt?: Maybe<Scalars['Float']>;
  previousId?: Maybe<Scalars['String']>;
  timestamp?: Maybe<Scalars['Float']>;
  units?: Maybe<Scalars['String']>;
  updatePending?: Maybe<Scalars['Boolean']>;
  value?: Maybe<Scalars['Float']>;
};

export type BatteryManagementSystemCurrent = {
  __typename?: 'BatteryManagementSystemCurrent';
  id?: Maybe<Scalars['String']>;
  observedAt?: Maybe<Scalars['Float']>;
  previousId?: Maybe<Scalars['String']>;
  timestamp?: Maybe<Scalars['Float']>;
  units?: Maybe<Scalars['String']>;
  updatePending?: Maybe<Scalars['Boolean']>;
  value?: Maybe<Scalars['Float']>;
};

export type BatteryManagementSystemStateOfCharge = {
  __typename?: 'BatteryManagementSystemStateOfCharge';
  id?: Maybe<Scalars['String']>;
  observedAt?: Maybe<Scalars['Float']>;
  previousId?: Maybe<Scalars['String']>;
  timestamp?: Maybe<Scalars['Float']>;
  units?: Maybe<Scalars['String']>;
  updatePending?: Maybe<Scalars['Boolean']>;
  value?: Maybe<Scalars['Float']>;
};

export type BatteryManagementSystemStateOfHealth = {
  __typename?: 'BatteryManagementSystemStateOfHealth';
  id?: Maybe<Scalars['String']>;
  observedAt?: Maybe<Scalars['Float']>;
  previousId?: Maybe<Scalars['String']>;
  timestamp?: Maybe<Scalars['Float']>;
  units?: Maybe<Scalars['String']>;
  updatePending?: Maybe<Scalars['Boolean']>;
  value?: Maybe<Scalars['Float']>;
};

export type BatteryManagementSystemTemperature = {
  __typename?: 'BatteryManagementSystemTemperature';
  id?: Maybe<Scalars['String']>;
  observedAt?: Maybe<Scalars['Float']>;
  previousId?: Maybe<Scalars['String']>;
  timestamp?: Maybe<Scalars['Float']>;
  units?: Maybe<Scalars['String']>;
  updatePending?: Maybe<Scalars['Boolean']>;
  value?: Maybe<Scalars['Float']>;
};

export type BatteryManagementSystemVoltage = {
  __typename?: 'BatteryManagementSystemVoltage';
  id?: Maybe<Scalars['String']>;
  observedAt?: Maybe<Scalars['Float']>;
  previousId?: Maybe<Scalars['String']>;
  timestamp?: Maybe<Scalars['Float']>;
  units?: Maybe<Scalars['String']>;
  updatePending?: Maybe<Scalars['Boolean']>;
  value?: Maybe<Scalars['Float']>;
};

export type Boiler = DeviceInterface & {
  __typename: 'Boiler';
  _id: Scalars['String'];
  alertTypes?: Maybe<DeviceAlertTypes>;
  boilerPumpSpeed?: Maybe<BoilerBoilerPumpSpeed>;
  boilerPumpSpeed1?: Maybe<BoilerBoilerPumpSpeed1>;
  boilerPumpSpeed2?: Maybe<BoilerBoilerPumpSpeed2>;
  chartTypes: Array<ChartType>;
  controlled?: Maybe<DeviceControlled>;
  dependentDeviceIds: Array<Maybe<Scalars['String']>>;
  deviceAlerts: Array<Maybe<Alert>>;
  deviceId?: Maybe<Scalars['String']>;
  deviceIdentifier?: Maybe<Scalars['String']>;
  deviceMetrics?: Maybe<Array<Maybe<DeviceMetric>>>;
  displayName?: Maybe<Scalars['String']>;
  firingRate?: Maybe<BoilerFiringRate>;
  firingRate1?: Maybe<BoilerFiringRate1>;
  firingRate2?: Maybe<BoilerFiringRate2>;
  flueTemperature?: Maybe<BoilerFlueTemperature>;
  flueTemperature1?: Maybe<BoilerFlueTemperature1>;
  flueTemperature2?: Maybe<BoilerFlueTemperature2>;
  hasBoilerPumpSpeed?: Maybe<Scalars['Boolean']>;
  hasFiringRate?: Maybe<Scalars['Boolean']>;
  hasFlueTemperature?: Maybe<Scalars['Boolean']>;
  hasInletTemperature?: Maybe<Scalars['Boolean']>;
  hasModules?: Maybe<Scalars['Boolean']>;
  hasOutdoorTemperature?: Maybe<Scalars['Boolean']>;
  hasOutletTemperature?: Maybe<Scalars['Boolean']>;
  hasPendingUpdates: Scalars['Boolean'];
  inletTemperature?: Maybe<BoilerInletTemperature>;
  inletTemperature1?: Maybe<BoilerInletTemperature1>;
  inletTemperature2?: Maybe<BoilerInletTemperature2>;
  installation?: Maybe<DeviceInstallation>;
  isConfigured?: Maybe<Scalars['Boolean']>;
  isControlled: Scalars['Boolean'];
  isPoweredOn?: Maybe<Scalars['Boolean']>;
  location?: Maybe<Scalars['String']>;
  meta?: Maybe<DeviceMeta>;
  modelChangeOperation?: Maybe<Scalars['String']>;
  modelType?: Maybe<Scalars['String']>;
  /** The name of the device */
  name?: Maybe<Scalars['String']>;
  outdoorTemperature?: Maybe<DeviceReadingNumeric>;
  outletTemperature?: Maybe<BoilerOutletTemperature>;
  outletTemperature1?: Maybe<BoilerOutletTemperature1>;
  outletTemperature2?: Maybe<BoilerOutletTemperature2>;
  panel?: Maybe<Panel>;
  panelId?: Maybe<Scalars['String']>;
  powerState?: Maybe<DevicePowerState>;
  property?: Maybe<Property>;
  propertyId: Scalars['String'];
  role?: Maybe<Scalars['String']>;
  source?: Maybe<Source>;
  sourceAlerts: Array<Maybe<Alert>>;
  sourceId?: Maybe<Scalars['String']>;
  temperature?: Maybe<BoilerTemperature>;
  timestamp?: Maybe<Scalars['Float']>;
  type?: Maybe<EnumDKeyDeviceType>;
  typeDisplayName: Scalars['String'];
  unit?: Maybe<Unit>;
  unitId: Scalars['String'];
  updateDescription?: Maybe<Scalars['JSON']>;
  updateStatus?: Maybe<Scalars['Boolean']>;
  vpp?: Maybe<VirtualPowerPlant>;
  vppId?: Maybe<Scalars['String']>;
  zone?: Maybe<Zone>;
  zoneId?: Maybe<Scalars['String']>;
};

export type BoilerDeviceAlertsArgs = {
  filter?: InputMaybe<FilterFindManyAlertInput>;
  limit?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<SortFindManyAlertInput>;
};

export type BoilerSourceAlertsArgs = {
  filter?: InputMaybe<FilterFindManyAlertInput>;
  limit?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<SortFindManyAlertInput>;
};

export type BoilerBoilerPumpSpeed = {
  __typename?: 'BoilerBoilerPumpSpeed';
  id?: Maybe<Scalars['String']>;
  observedAt?: Maybe<Scalars['Float']>;
  previousId?: Maybe<Scalars['String']>;
  timestamp?: Maybe<Scalars['Float']>;
  units?: Maybe<Scalars['String']>;
  updatePending?: Maybe<Scalars['Boolean']>;
  value?: Maybe<Scalars['Float']>;
};

export type BoilerBoilerPumpSpeed1 = {
  __typename?: 'BoilerBoilerPumpSpeed1';
  id?: Maybe<Scalars['String']>;
  observedAt?: Maybe<Scalars['Float']>;
  previousId?: Maybe<Scalars['String']>;
  timestamp?: Maybe<Scalars['Float']>;
  units?: Maybe<Scalars['String']>;
  updatePending?: Maybe<Scalars['Boolean']>;
  value?: Maybe<Scalars['Float']>;
};

export type BoilerBoilerPumpSpeed2 = {
  __typename?: 'BoilerBoilerPumpSpeed2';
  id?: Maybe<Scalars['String']>;
  observedAt?: Maybe<Scalars['Float']>;
  previousId?: Maybe<Scalars['String']>;
  timestamp?: Maybe<Scalars['Float']>;
  units?: Maybe<Scalars['String']>;
  updatePending?: Maybe<Scalars['Boolean']>;
  value?: Maybe<Scalars['Float']>;
};

export type BoilerFiringRate = {
  __typename?: 'BoilerFiringRate';
  id?: Maybe<Scalars['String']>;
  observedAt?: Maybe<Scalars['Float']>;
  previousId?: Maybe<Scalars['String']>;
  timestamp?: Maybe<Scalars['Float']>;
  units?: Maybe<Scalars['String']>;
  updatePending?: Maybe<Scalars['Boolean']>;
  value?: Maybe<Scalars['Float']>;
};

export type BoilerFiringRate1 = {
  __typename?: 'BoilerFiringRate1';
  id?: Maybe<Scalars['String']>;
  observedAt?: Maybe<Scalars['Float']>;
  previousId?: Maybe<Scalars['String']>;
  timestamp?: Maybe<Scalars['Float']>;
  units?: Maybe<Scalars['String']>;
  updatePending?: Maybe<Scalars['Boolean']>;
  value?: Maybe<Scalars['Float']>;
};

export type BoilerFiringRate2 = {
  __typename?: 'BoilerFiringRate2';
  id?: Maybe<Scalars['String']>;
  observedAt?: Maybe<Scalars['Float']>;
  previousId?: Maybe<Scalars['String']>;
  timestamp?: Maybe<Scalars['Float']>;
  units?: Maybe<Scalars['String']>;
  updatePending?: Maybe<Scalars['Boolean']>;
  value?: Maybe<Scalars['Float']>;
};

export type BoilerFlueTemperature = {
  __typename?: 'BoilerFlueTemperature';
  id?: Maybe<Scalars['String']>;
  observedAt?: Maybe<Scalars['Float']>;
  previousId?: Maybe<Scalars['String']>;
  timestamp?: Maybe<Scalars['Float']>;
  units?: Maybe<Scalars['String']>;
  updatePending?: Maybe<Scalars['Boolean']>;
  value?: Maybe<Scalars['Float']>;
};

export type BoilerFlueTemperature1 = {
  __typename?: 'BoilerFlueTemperature1';
  id?: Maybe<Scalars['String']>;
  observedAt?: Maybe<Scalars['Float']>;
  previousId?: Maybe<Scalars['String']>;
  timestamp?: Maybe<Scalars['Float']>;
  units?: Maybe<Scalars['String']>;
  updatePending?: Maybe<Scalars['Boolean']>;
  value?: Maybe<Scalars['Float']>;
};

export type BoilerFlueTemperature2 = {
  __typename?: 'BoilerFlueTemperature2';
  id?: Maybe<Scalars['String']>;
  observedAt?: Maybe<Scalars['Float']>;
  previousId?: Maybe<Scalars['String']>;
  timestamp?: Maybe<Scalars['Float']>;
  units?: Maybe<Scalars['String']>;
  updatePending?: Maybe<Scalars['Boolean']>;
  value?: Maybe<Scalars['Float']>;
};

export type BoilerInletTemperature = {
  __typename?: 'BoilerInletTemperature';
  id?: Maybe<Scalars['String']>;
  observedAt?: Maybe<Scalars['Float']>;
  previousId?: Maybe<Scalars['String']>;
  timestamp?: Maybe<Scalars['Float']>;
  units?: Maybe<Scalars['String']>;
  updatePending?: Maybe<Scalars['Boolean']>;
  value?: Maybe<Scalars['Float']>;
};

export type BoilerInletTemperature1 = {
  __typename?: 'BoilerInletTemperature1';
  id?: Maybe<Scalars['String']>;
  observedAt?: Maybe<Scalars['Float']>;
  previousId?: Maybe<Scalars['String']>;
  timestamp?: Maybe<Scalars['Float']>;
  units?: Maybe<Scalars['String']>;
  updatePending?: Maybe<Scalars['Boolean']>;
  value?: Maybe<Scalars['Float']>;
};

export type BoilerInletTemperature2 = {
  __typename?: 'BoilerInletTemperature2';
  id?: Maybe<Scalars['String']>;
  observedAt?: Maybe<Scalars['Float']>;
  previousId?: Maybe<Scalars['String']>;
  timestamp?: Maybe<Scalars['Float']>;
  units?: Maybe<Scalars['String']>;
  updatePending?: Maybe<Scalars['Boolean']>;
  value?: Maybe<Scalars['Float']>;
};

export type BoilerOutletTemperature = {
  __typename?: 'BoilerOutletTemperature';
  id?: Maybe<Scalars['String']>;
  observedAt?: Maybe<Scalars['Float']>;
  previousId?: Maybe<Scalars['String']>;
  timestamp?: Maybe<Scalars['Float']>;
  units?: Maybe<Scalars['String']>;
  updatePending?: Maybe<Scalars['Boolean']>;
  value?: Maybe<Scalars['Float']>;
};

export type BoilerOutletTemperature1 = {
  __typename?: 'BoilerOutletTemperature1';
  id?: Maybe<Scalars['String']>;
  observedAt?: Maybe<Scalars['Float']>;
  previousId?: Maybe<Scalars['String']>;
  timestamp?: Maybe<Scalars['Float']>;
  units?: Maybe<Scalars['String']>;
  updatePending?: Maybe<Scalars['Boolean']>;
  value?: Maybe<Scalars['Float']>;
};

export type BoilerOutletTemperature2 = {
  __typename?: 'BoilerOutletTemperature2';
  id?: Maybe<Scalars['String']>;
  observedAt?: Maybe<Scalars['Float']>;
  previousId?: Maybe<Scalars['String']>;
  timestamp?: Maybe<Scalars['Float']>;
  units?: Maybe<Scalars['String']>;
  updatePending?: Maybe<Scalars['Boolean']>;
  value?: Maybe<Scalars['Float']>;
};

export type BoilerTemperature = {
  __typename?: 'BoilerTemperature';
  id?: Maybe<Scalars['String']>;
  observedAt?: Maybe<Scalars['Float']>;
  previousId?: Maybe<Scalars['String']>;
  timestamp?: Maybe<Scalars['Float']>;
  units?: Maybe<Scalars['String']>;
  updatePending?: Maybe<Scalars['Boolean']>;
  value?: Maybe<Scalars['Float']>;
};

export type Building = {
  __typename: 'Building';
  _id: Scalars['String'];
  floors: Array<Maybe<Floor>>;
  /** Returns the authorization profile associated with the user. */
  inUse: Scalars['Boolean'];
  modelChangeOperation?: Maybe<Scalars['String']>;
  modelType?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  number?: Maybe<Scalars['Float']>;
  property?: Maybe<Property>;
  propertyId: Scalars['String'];
  units: Array<Maybe<Unit>>;
  updateDescription?: Maybe<Scalars['JSON']>;
};

export type BuildingFloorsArgs = {
  filter?: InputMaybe<FilterFindManyFloorInput>;
  limit?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<SortFindManyFloorInput>;
};

export type BuildingUnitsArgs = {
  filter?: InputMaybe<FilterFindManyUnitInput>;
  limit?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<SortFindManyUnitInput>;
};

/** List of items with pagination. */
export type BuildingPaginatedBuildings = {
  __typename?: 'BuildingPaginatedBuildings';
  /** Total object count. */
  count?: Maybe<Scalars['Int']>;
  /** Array of objects. */
  items?: Maybe<Array<Building>>;
  /** Information to aid in pagination. */
  pageInfo: PaginationInfo;
};

export type BulkConfigCommitResult = {
  __typename?: 'BulkConfigCommitResult';
  deviceId: Scalars['String'];
};

export type BulkConfigError = {
  __typename?: 'BulkConfigError';
  deviceId?: Maybe<Scalars['String']>;
  deviceName?: Maybe<Scalars['String']>;
  deviceType?: Maybe<Scalars['String']>;
  message?: Maybe<Scalars['String']>;
};

export type BulkConfigSetpointChanges = {
  autoMode?: InputMaybe<Scalars['String']>;
  cool: Scalars['Float'];
  heat: Scalars['Float'];
  modify: Scalars['Boolean'];
  target?: InputMaybe<Scalars['Float']>;
  units: Scalars['String'];
};

export type BulkConfigSetpointLimitsInput = {
  profileId?: InputMaybe<Scalars['String']>;
  propertyIds: Array<Scalars['String']>;
};

export type BulkConfigStatus = {
  __typename?: 'BulkConfigStatus';
  completedCount?: Maybe<Scalars['Float']>;
  errorCount?: Maybe<Scalars['Float']>;
  errors: Array<Maybe<BulkConfigError>>;
  initiatorId?: Maybe<Scalars['String']>;
  initiatorType?: Maybe<Scalars['String']>;
  isComplete?: Maybe<Scalars['Boolean']>;
  percentProcessed?: Maybe<Scalars['Float']>;
  totalCount?: Maybe<Scalars['Float']>;
};

export type BulkConfigThermostatsChanges = {
  fanButton: Scalars['String'];
  fanMode: Scalars['String'];
  lockoutLevel: Scalars['String'];
  opMode: Scalars['String'];
  setpoints: BulkConfigSetpointChanges;
  systemType: Scalars['String'];
};

export type BulkConfigThermostatsFilters = {
  opMode: Scalars['String'];
  systemType: Scalars['String'];
};

export type BulkConfigThermostatsInput = {
  buildingIds: Array<Scalars['String']>;
  config: BulkConfigThermostatsChanges;
  cuGroups: Array<Scalars['String']>;
  filters: BulkConfigThermostatsFilters;
  floorIds: Array<Scalars['String']>;
  propertyId: Scalars['String'];
  unitTypes: Array<Scalars['String']>;
};

export type BulkConfigValidationResult = {
  __typename?: 'BulkConfigValidationResult';
  deviceIds: Array<Scalars['String']>;
  devices?: Maybe<Array<BulkThermostatCompatibility>>;
  numConfigurable: Scalars['Int'];
  numOffline: Scalars['Int'];
  numOnline: Scalars['Int'];
  numSupported: Scalars['Int'];
  numTStats: Scalars['Int'];
};

export type BulkThermostatCompatibility = {
  __typename?: 'BulkThermostatCompatibility';
  autoMode: Scalars['String'];
  compatible: Scalars['Boolean'];
  deviceId: Scalars['String'];
  needsChange: Scalars['Boolean'];
  previewState: Scalars['String'];
  reason: Scalars['String'];
  sourceType: Scalars['String'];
};

export type BulkThermostatOutcome = {
  __typename?: 'BulkThermostatOutcome';
  deviceId: Scalars['String'];
  error?: Maybe<Scalars['String']>;
  success: Scalars['Boolean'];
};

export type CategoricalChartSeries = IChartSeries & {
  __typename?: 'CategoricalChartSeries';
  data: Array<CategoricalDatapoint>;
  deviceId: Scalars['String'];
  distinctValues: Array<Scalars['String']>;
  readingType: Scalars['String'];
  units?: Maybe<Scalars['String']>;
};

export type CategoricalDatapoint = IDatapoint & {
  __typename?: 'CategoricalDatapoint';
  deviceId: Scalars['String'];
  id: Scalars['String'];
  readingType: Scalars['String'];
  timestamp: Scalars['String'];
  value: Scalars['String'];
};

export type ChartData = {
  __typename?: 'ChartData';
  /** The type of chart data */
  chartType: ChartType;
  /** The series data for the chart */
  series: Array<IChartSeries>;
  /** The visualization type for the chart */
  visType: ChartVisType;
};

export enum ChartType {
  ActuatorControlMode = 'ACTUATOR_CONTROL_MODE',
  ActuatorPosition = 'ACTUATOR_POSITION',
  AirhandlerFanAirflow = 'AIRHANDLER_FAN_AIRFLOW',
  AirhandlerIndoorRh = 'AIRHANDLER_INDOOR_RH',
  AirhandlerServiceTime = 'AIRHANDLER_SERVICE_TIME',
  AirhandlerSupplyFanStaticPressure = 'AIRHANDLER_SUPPLY_FAN_STATIC_PRESSURE',
  AirhandlerTemperature = 'AIRHANDLER_TEMPERATURE',
  BatteryManagementSystemBatteryEfficiency = 'BATTERY_MANAGEMENT_SYSTEM_BATTERY_EFFICIENCY',
  BatteryManagementSystemCurrent = 'BATTERY_MANAGEMENT_SYSTEM_CURRENT',
  BatteryManagementSystemStateOfCharge = 'BATTERY_MANAGEMENT_SYSTEM_STATE_OF_CHARGE',
  BatteryManagementSystemStateOfHealth = 'BATTERY_MANAGEMENT_SYSTEM_STATE_OF_HEALTH',
  BatteryManagementSystemTemperature = 'BATTERY_MANAGEMENT_SYSTEM_TEMPERATURE',
  BatteryManagementSystemVoltage = 'BATTERY_MANAGEMENT_SYSTEM_VOLTAGE',
  BoilerFiringRate = 'BOILER_FIRING_RATE',
  BoilerFlueTemperature = 'BOILER_FLUE_TEMPERATURE',
  BoilerInletTemperature = 'BOILER_INLET_TEMPERATURE',
  BoilerOutletTemperature = 'BOILER_OUTLET_TEMPERATURE',
  BoilerPumpSpeed = 'BOILER_PUMP_SPEED',
  BuildingEnergyEfficiency = 'BUILDING_ENERGY_EFFICIENCY',
  BuildingOccupancy = 'BUILDING_OCCUPANCY',
  ChillerAmbientTemperature = 'CHILLER_AMBIENT_TEMPERATURE',
  ChillerChilledReturnTemperature = 'CHILLER_CHILLED_RETURN_TEMPERATURE',
  ChillerChilledSupplyTemperature = 'CHILLER_CHILLED_SUPPLY_TEMPERATURE',
  ChillerCoolSetpoint = 'CHILLER_COOL_SETPOINT',
  ChillerOnOffState = 'CHILLER_ON_OFF_STATE',
  ContactState = 'CONTACT_STATE',
  EnergyConsumerEnergyConsumed = 'ENERGY_CONSUMER_ENERGY_CONSUMED',
  EnergyConsumerPeakDemand = 'ENERGY_CONSUMER_PEAK_DEMAND',
  EnergyConsumerPowerDemand = 'ENERGY_CONSUMER_POWER_DEMAND',
  EnergyConsumerPowerFactor = 'ENERGY_CONSUMER_POWER_FACTOR',
  EnergyControllerChargeRegulationStatus = 'ENERGY_CONTROLLER_CHARGE_REGULATION_STATUS',
  EnergyControllerCurrentAtMpp = 'ENERGY_CONTROLLER_CURRENT_AT_MPP',
  EnergyControllerEnergyGenerated = 'ENERGY_CONTROLLER_ENERGY_GENERATED',
  EnergyControllerRotorSpeedAtMpp = 'ENERGY_CONTROLLER_ROTOR_SPEED_AT_MPP',
  EnergyControllerVoltageAtMpp = 'ENERGY_CONTROLLER_VOLTAGE_AT_MPP',
  EnergyConverterChargeRate = 'ENERGY_CONVERTER_CHARGE_RATE',
  EnergyConverterDischargeRate = 'ENERGY_CONVERTER_DISCHARGE_RATE',
  EnergyConverterEfficiency = 'ENERGY_CONVERTER_EFFICIENCY',
  EnergyConverterInputVoltage = 'ENERGY_CONVERTER_INPUT_VOLTAGE',
  EnergyConverterOutputVoltage = 'ENERGY_CONVERTER_OUTPUT_VOLTAGE',
  EnergyConverterPowerOutput = 'ENERGY_CONVERTER_POWER_OUTPUT',
  EnergyInverterAvailabilityStatus = 'ENERGY_INVERTER_AVAILABILITY_STATUS',
  EnergyInverterEfficiency = 'ENERGY_INVERTER_EFFICIENCY',
  EnergyInverterFrequency = 'ENERGY_INVERTER_FREQUENCY',
  EnergyInverterPowerInputBattery = 'ENERGY_INVERTER_POWER_INPUT_BATTERY',
  EnergyInverterPowerInputKinetic = 'ENERGY_INVERTER_POWER_INPUT_KINETIC',
  EnergyInverterPowerOutput = 'ENERGY_INVERTER_POWER_OUTPUT',
  EnergyInverterReactivePower = 'ENERGY_INVERTER_REACTIVE_POWER',
  EnergyInverterTemperature = 'ENERGY_INVERTER_TEMPERATURE',
  EnergyInverterVoltageOutput = 'ENERGY_INVERTER_VOLTAGE_OUTPUT',
  EnergyMeterCurrent = 'ENERGY_METER_CURRENT',
  EnergyMeterEnergyConsumed = 'ENERGY_METER_ENERGY_CONSUMED',
  EnergyMeterFrequency = 'ENERGY_METER_FREQUENCY',
  EnergyMeterOutputEnabled = 'ENERGY_METER_OUTPUT_ENABLED',
  EnergyMeterPowerDemand = 'ENERGY_METER_POWER_DEMAND',
  EnergyMeterPowerFactor = 'ENERGY_METER_POWER_FACTOR',
  EnergyMeterVoltage = 'ENERGY_METER_VOLTAGE',
  EnergyRectifierEfficiency = 'ENERGY_RECTIFIER_EFFICIENCY',
  EnergyRectifierOutputVoltage = 'ENERGY_RECTIFIER_OUTPUT_VOLTAGE',
  EnergyStorageCoolingSystemCoolingHeatingStatus = 'ENERGY_STORAGE_COOLING_SYSTEM_COOLING_HEATING_STATUS',
  EnergyStorageCoolingSystemTemperature = 'ENERGY_STORAGE_COOLING_SYSTEM_TEMPERATURE',
  EnergyStorageSystemChargeRate = 'ENERGY_STORAGE_SYSTEM_CHARGE_RATE',
  EnergyStorageSystemCurrent = 'ENERGY_STORAGE_SYSTEM_CURRENT',
  EnergyStorageSystemCycleCount = 'ENERGY_STORAGE_SYSTEM_CYCLE_COUNT',
  EnergyStorageSystemDischargeRate = 'ENERGY_STORAGE_SYSTEM_DISCHARGE_RATE',
  EnergyStorageSystemEfficiency = 'ENERGY_STORAGE_SYSTEM_EFFICIENCY',
  EnergyStorageSystemEnergyCapacity = 'ENERGY_STORAGE_SYSTEM_ENERGY_CAPACITY',
  EnergyStorageSystemModeOfOperation = 'ENERGY_STORAGE_SYSTEM_MODE_OF_OPERATION',
  EnergyStorageSystemPowerRating = 'ENERGY_STORAGE_SYSTEM_POWER_RATING',
  EnergyStorageSystemTemperature = 'ENERGY_STORAGE_SYSTEM_TEMPERATURE',
  EnergyStorageSystemVoltage = 'ENERGY_STORAGE_SYSTEM_VOLTAGE',
  EnergySupplierSolarAzimuth = 'ENERGY_SUPPLIER_SOLAR_AZIMUTH',
  EnergySupplierSolarDegradation = 'ENERGY_SUPPLIER_SOLAR_DEGRADATION',
  EnergySupplierSolarInverterStatus = 'ENERGY_SUPPLIER_SOLAR_INVERTER_STATUS',
  EnergySupplierSolarIrradiance = 'ENERGY_SUPPLIER_SOLAR_IRRADIANCE',
  EnergySupplierSolarPanelTemperature = 'ENERGY_SUPPLIER_SOLAR_PANEL_TEMPERATURE',
  EnergySupplierSolarShading = 'ENERGY_SUPPLIER_SOLAR_SHADING',
  EnergySupplierSolarTiltAngle = 'ENERGY_SUPPLIER_SOLAR_TILT_ANGLE',
  EnergySupplierUtilityContractedCapacity = 'ENERGY_SUPPLIER_UTILITY_CONTRACTED_CAPACITY',
  EnergySupplierUtilityMeteringAccuracy = 'ENERGY_SUPPLIER_UTILITY_METERING_ACCURACY',
  EnergySupplierUtilityTariffRate = 'ENERGY_SUPPLIER_UTILITY_TARIFF_RATE',
  EnergySupplierWindSystemCutInSpeed = 'ENERGY_SUPPLIER_WIND_SYSTEM_CUT_IN_SPEED',
  EnergySupplierWindSystemCutOutSpeed = 'ENERGY_SUPPLIER_WIND_SYSTEM_CUT_OUT_SPEED',
  EnergySupplierWindSystemGeneratorTemperature = 'ENERGY_SUPPLIER_WIND_SYSTEM_GENERATOR_TEMPERATURE',
  EnergySupplierWindSystemPitchAngle = 'ENERGY_SUPPLIER_WIND_SYSTEM_PITCH_ANGLE',
  EnergySupplierWindSystemRotorSpeed = 'ENERGY_SUPPLIER_WIND_SYSTEM_ROTOR_SPEED',
  EnergySupplierWindSystemVibrationLevel = 'ENERGY_SUPPLIER_WIND_SYSTEM_VIBRATION_LEVEL',
  EnergySupplierWindSystemWindDirection = 'ENERGY_SUPPLIER_WIND_SYSTEM_WIND_DIRECTION',
  EnergySupplierWindSystemWindSpeed = 'ENERGY_SUPPLIER_WIND_SYSTEM_WIND_SPEED',
  EnergySwitchPanelCircuitCurrent = 'ENERGY_SWITCH_PANEL_CIRCUIT_CURRENT',
  EnergySwitchPanelCircuitEnergyConsumed = 'ENERGY_SWITCH_PANEL_CIRCUIT_ENERGY_CONSUMED',
  EnergySwitchPanelCircuitFrequency = 'ENERGY_SWITCH_PANEL_CIRCUIT_FREQUENCY',
  EnergySwitchPanelCircuitPowerDemand = 'ENERGY_SWITCH_PANEL_CIRCUIT_POWER_DEMAND',
  EnergySwitchPanelCircuitPowerFactor = 'ENERGY_SWITCH_PANEL_CIRCUIT_POWER_FACTOR',
  EnergySwitchPanelCircuitVoltage = 'ENERGY_SWITCH_PANEL_CIRCUIT_VOLTAGE',
  EnergySwitchPanelPowerInput = 'ENERGY_SWITCH_PANEL_POWER_INPUT',
  FireSuppressionSystemFireSuppressionStatus = 'FIRE_SUPPRESSION_SYSTEM_FIRE_SUPPRESSION_STATUS',
  FireSuppressionSystemSensorStatus = 'FIRE_SUPPRESSION_SYSTEM_SENSOR_STATUS',
  FireSuppressionSystemSuppressantLevel = 'FIRE_SUPPRESSION_SYSTEM_SUPPRESSANT_LEVEL',
  Humidity = 'HUMIDITY',
  KineticEnergyManagementSystemBearingTemperature = 'KINETIC_ENERGY_MANAGEMENT_SYSTEM_BEARING_TEMPERATURE',
  KineticEnergyManagementSystemCurrentEnergyStored = 'KINETIC_ENERGY_MANAGEMENT_SYSTEM_CURRENT_ENERGY_STORED',
  KineticEnergyManagementSystemCycleCount = 'KINETIC_ENERGY_MANAGEMENT_SYSTEM_CYCLE_COUNT',
  KineticEnergyManagementSystemGeneratorCurrent = 'KINETIC_ENERGY_MANAGEMENT_SYSTEM_GENERATOR_CURRENT',
  KineticEnergyManagementSystemGeneratorVoltage = 'KINETIC_ENERGY_MANAGEMENT_SYSTEM_GENERATOR_VOLTAGE',
  KineticEnergyManagementSystemRotorSpeed = 'KINETIC_ENERGY_MANAGEMENT_SYSTEM_ROTOR_SPEED',
  KineticEnergyManagementSystemSpinDownTime = 'KINETIC_ENERGY_MANAGEMENT_SYSTEM_SPIN_DOWN_TIME',
  KineticEnergyManagementSystemStateOfHealth = 'KINETIC_ENERGY_MANAGEMENT_SYSTEM_STATE_OF_HEALTH',
  KineticEnergyManagementSystemSystemEfficiency = 'KINETIC_ENERGY_MANAGEMENT_SYSTEM_SYSTEM_EFFICIENCY',
  KineticEnergyManagementSystemVacuumPressure = 'KINETIC_ENERGY_MANAGEMENT_SYSTEM_VACUUM_PRESSURE',
  KineticEnergyManagementSystemVibrationMetrics = 'KINETIC_ENERGY_MANAGEMENT_SYSTEM_VIBRATION_METRICS',
  Occupancy = 'OCCUPANCY',
  PmActiveEnergyFwd = 'PM_ACTIVE_ENERGY_FWD',
  PmActiveEnergyRev = 'PM_ACTIVE_ENERGY_REV',
  PmActivePower = 'PM_ACTIVE_POWER',
  PmCurrent = 'PM_CURRENT',
  PmFrequency = 'PM_FREQUENCY',
  PmPowerFactor = 'PM_POWER_FACTOR',
  PmVoltage = 'PM_VOLTAGE',
  Pressure = 'PRESSURE',
  PumpCurrentSpeed = 'PUMP_CURRENT_SPEED',
  PumpDriveOutputEnergy = 'PUMP_DRIVE_OUTPUT_ENERGY',
  PumpDriveOutputPower = 'PUMP_DRIVE_OUTPUT_POWER',
  PumpOnOffState = 'PUMP_ON_OFF_STATE',
  PumpTargetSpeed = 'PUMP_TARGET_SPEED',
  RelayDeviceIsOn = 'RELAY_DEVICE_IS_ON',
  SolarManagementSystemAzimuth = 'SOLAR_MANAGEMENT_SYSTEM_AZIMUTH',
  SolarManagementSystemDegradationRate = 'SOLAR_MANAGEMENT_SYSTEM_DEGRADATION_RATE',
  SolarManagementSystemPanelTemperature = 'SOLAR_MANAGEMENT_SYSTEM_PANEL_TEMPERATURE',
  SolarManagementSystemShadingFactor = 'SOLAR_MANAGEMENT_SYSTEM_SHADING_FACTOR',
  SolarManagementSystemSolarIrradiance = 'SOLAR_MANAGEMENT_SYSTEM_SOLAR_IRRADIANCE',
  SolarManagementSystemTiltAngle = 'SOLAR_MANAGEMENT_SYSTEM_TILT_ANGLE',
  SpoActivePower = 'SPO_ACTIVE_POWER',
  SpoApparentPower = 'SPO_APPARENT_POWER',
  SpoCumulativePower = 'SPO_CUMULATIVE_POWER',
  SpoCurrent = 'SPO_CURRENT',
  SpoIsOn = 'SPO_IS_ON',
  SpoPowerFactor = 'SPO_POWER_FACTOR',
  SpoVoltage = 'SPO_VOLTAGE',
  Temperature = 'TEMPERATURE',
  TenantEnergyEfficiency = 'TENANT_ENERGY_EFFICIENCY',
  TenantOccupancy = 'TENANT_OCCUPANCY',
  TstatCoolSetpoint = 'TSTAT_COOL_SETPOINT',
  TstatFanMode = 'TSTAT_FAN_MODE',
  TstatFanState = 'TSTAT_FAN_STATE',
  TstatHeatSetpoint = 'TSTAT_HEAT_SETPOINT',
  TstatOperatingMode = 'TSTAT_OPERATING_MODE',
  TstatOperatingState = 'TSTAT_OPERATING_STATE',
  TstatPowerMode = 'TSTAT_POWER_MODE',
  TstatPowerState = 'TSTAT_POWER_STATE',
  TstatSetpoint = 'TSTAT_SETPOINT',
  TstatSystemType = 'TSTAT_SYSTEM_TYPE',
  UtilityEnergyExported = 'UTILITY_ENERGY_EXPORTED',
  UtilityGridFrequency = 'UTILITY_GRID_FREQUENCY',
  UtilityRevenueGenerated = 'UTILITY_REVENUE_GENERATED',
  VirtualPowerPlantOperationalStatus = 'VIRTUAL_POWER_PLANT_OPERATIONAL_STATUS',
  Voltage = 'VOLTAGE',
  VppParticipantConnected = 'VPP_PARTICIPANT_CONNECTED',
  VppParticipantDisconnected = 'VPP_PARTICIPANT_DISCONNECTED',
  VppParticipantLastConnected = 'VPP_PARTICIPANT_LAST_CONNECTED',
  VppParticipantPowerState = 'VPP_PARTICIPANT_POWER_STATE',
  WindManagementSystemBladeCondition = 'WIND_MANAGEMENT_SYSTEM_BLADE_CONDITION',
  WindManagementSystemBrakeStatus = 'WIND_MANAGEMENT_SYSTEM_BRAKE_STATUS',
  WindManagementSystemGeneratorTemperature = 'WIND_MANAGEMENT_SYSTEM_GENERATOR_TEMPERATURE',
  WindManagementSystemIceDetectionStatus = 'WIND_MANAGEMENT_SYSTEM_ICE_DETECTION_STATUS',
  WindManagementSystemModeOfOperation = 'WIND_MANAGEMENT_SYSTEM_MODE_OF_OPERATION',
  WindManagementSystemPitchAngle = 'WIND_MANAGEMENT_SYSTEM_PITCH_ANGLE',
  WindManagementSystemRotorSpeed = 'WIND_MANAGEMENT_SYSTEM_ROTOR_SPEED',
  WindManagementSystemVibrationLevel = 'WIND_MANAGEMENT_SYSTEM_VIBRATION_LEVEL',
  WindManagementSystemWindDirection = 'WIND_MANAGEMENT_SYSTEM_WIND_DIRECTION',
  WindManagementSystemWindSpeed = 'WIND_MANAGEMENT_SYSTEM_WIND_SPEED',
  WindManagementSystemYawControlStatus = 'WIND_MANAGEMENT_SYSTEM_YAW_CONTROL_STATUS',
  ZmbCpuTemperature = 'ZMB_CPU_TEMPERATURE',
  ZmbRequests = 'ZMB_REQUESTS',
  ZmbSystemUptime = 'ZMB_SYSTEM_UPTIME',
}

export enum ChartVisType {
  Area = 'AREA',
  CategoricalLine = 'CATEGORICAL_LINE',
  NumericLine = 'NUMERIC_LINE',
  NumericStep = 'NUMERIC_STEP',
}

export type Chiller = DeviceInterface & {
  __typename: 'Chiller';
  _id: Scalars['String'];
  alertTypes?: Maybe<DeviceAlertTypes>;
  ambientTemperature?: Maybe<ChillerAmbientTemperature>;
  chartTypes: Array<ChartType>;
  chilledReturnTemperature?: Maybe<ChillerChilledReturnTemperature>;
  chilledSupplyTemperature?: Maybe<ChillerChilledSupplyTemperature>;
  controlled?: Maybe<DeviceControlled>;
  coolSetpoint?: Maybe<ChillerCoolSetpoint>;
  dependentDeviceIds: Array<Maybe<Scalars['String']>>;
  deviceAlerts: Array<Maybe<Alert>>;
  deviceId?: Maybe<Scalars['String']>;
  deviceIdentifier?: Maybe<Scalars['String']>;
  deviceMetrics?: Maybe<Array<Maybe<DeviceMetric>>>;
  displayName?: Maybe<Scalars['String']>;
  hasPendingUpdates: Scalars['Boolean'];
  installation?: Maybe<DeviceInstallation>;
  isConfigured?: Maybe<Scalars['Boolean']>;
  isControlled: Scalars['Boolean'];
  isPoweredOn?: Maybe<Scalars['Boolean']>;
  location?: Maybe<Scalars['String']>;
  meta?: Maybe<DeviceMeta>;
  modelChangeOperation?: Maybe<Scalars['String']>;
  modelType?: Maybe<Scalars['String']>;
  /** The name of the device */
  name?: Maybe<Scalars['String']>;
  panel?: Maybe<Panel>;
  panelId?: Maybe<Scalars['String']>;
  powerState?: Maybe<DevicePowerState>;
  property?: Maybe<Property>;
  propertyId: Scalars['String'];
  source?: Maybe<Source>;
  sourceAlerts: Array<Maybe<Alert>>;
  sourceId?: Maybe<Scalars['String']>;
  timestamp?: Maybe<Scalars['Float']>;
  type?: Maybe<EnumDKeyDeviceType>;
  typeDisplayName: Scalars['String'];
  unit?: Maybe<Unit>;
  unitId: Scalars['String'];
  updateDescription?: Maybe<Scalars['JSON']>;
  updateStatus?: Maybe<Scalars['Boolean']>;
  vpp?: Maybe<VirtualPowerPlant>;
  vppId?: Maybe<Scalars['String']>;
  zone?: Maybe<Zone>;
  zoneId?: Maybe<Scalars['String']>;
};

export type ChillerDeviceAlertsArgs = {
  filter?: InputMaybe<FilterFindManyAlertInput>;
  limit?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<SortFindManyAlertInput>;
};

export type ChillerSourceAlertsArgs = {
  filter?: InputMaybe<FilterFindManyAlertInput>;
  limit?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<SortFindManyAlertInput>;
};

export type ChillerAmbientTemperature = {
  __typename?: 'ChillerAmbientTemperature';
  id?: Maybe<Scalars['String']>;
  observedAt?: Maybe<Scalars['Float']>;
  previousId?: Maybe<Scalars['String']>;
  timestamp?: Maybe<Scalars['Float']>;
  units?: Maybe<Scalars['String']>;
  updatePending?: Maybe<Scalars['Boolean']>;
  value?: Maybe<Scalars['Float']>;
};

export type ChillerChilledReturnTemperature = {
  __typename?: 'ChillerChilledReturnTemperature';
  id?: Maybe<Scalars['String']>;
  observedAt?: Maybe<Scalars['Float']>;
  previousId?: Maybe<Scalars['String']>;
  timestamp?: Maybe<Scalars['Float']>;
  units?: Maybe<Scalars['String']>;
  updatePending?: Maybe<Scalars['Boolean']>;
  value?: Maybe<Scalars['Float']>;
};

export type ChillerChilledSupplyTemperature = {
  __typename?: 'ChillerChilledSupplyTemperature';
  id?: Maybe<Scalars['String']>;
  observedAt?: Maybe<Scalars['Float']>;
  previousId?: Maybe<Scalars['String']>;
  timestamp?: Maybe<Scalars['Float']>;
  units?: Maybe<Scalars['String']>;
  updatePending?: Maybe<Scalars['Boolean']>;
  value?: Maybe<Scalars['Float']>;
};

export type ChillerCoolSetpoint = {
  __typename?: 'ChillerCoolSetpoint';
  id?: Maybe<Scalars['String']>;
  observedAt?: Maybe<Scalars['Float']>;
  previousId?: Maybe<Scalars['String']>;
  timestamp?: Maybe<Scalars['Float']>;
  units?: Maybe<Scalars['String']>;
  updatePending?: Maybe<Scalars['Boolean']>;
  value?: Maybe<Scalars['Float']>;
};

export type Conductor = SourceInterface & {
  __typename: 'Conductor';
  _id: Scalars['String'];
  alerts: Array<Maybe<Alert>>;
  buildingId?: Maybe<Scalars['String']>;
  conductorUniqueId?: Maybe<Scalars['String']>;
  /** Returns the authorization profile associated with the user. */
  inUse: Scalars['Boolean'];
  lastDiscoveryMappingProposal?: Maybe<Scalars['JSON']>;
  lastDiscoveryResults?: Maybe<Scalars['JSON']>;
  lastDiscoveryResultsUrl?: Maybe<Scalars['String']>;
  lastDiscoveryRunId?: Maybe<Scalars['String']>;
  lastDiscoveryStatus?: Maybe<Scalars['String']>;
  lastDiscoveryStatusUrl?: Maybe<Scalars['String']>;
  maxReportingTime?: Maybe<Scalars['Float']>;
  modelChangeOperation?: Maybe<Scalars['String']>;
  modelType?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  panels: Array<Maybe<Panel>>;
  property?: Maybe<Property>;
  propertyId?: Maybe<Scalars['String']>;
  timestamp?: Maybe<Scalars['Float']>;
  tolerances?: Maybe<ConductorTolerances>;
  type?: Maybe<EnumDKeySourceType>;
  units: Array<Maybe<Unit>>;
  updateDescription?: Maybe<Scalars['JSON']>;
  url?: Maybe<Scalars['String']>;
  zones: Array<Maybe<Zone>>;
};

export type ConductorAlertsArgs = {
  filter?: InputMaybe<FilterFindManyAlertInput>;
  limit?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<SortFindManyAlertInput>;
};

export type ConductorPanelsArgs = {
  filter?: InputMaybe<FilterFindManyPanelInput>;
  limit?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<SortFindManyPanelInput>;
};

export type ConductorUnitsArgs = {
  filter?: InputMaybe<FilterFindManyUnitInput>;
  limit?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<SortFindManyUnitInput>;
};

export type ConductorZonesArgs = {
  filter?: InputMaybe<FilterFindManyZoneInput>;
  limit?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<SortFindManyZoneInput>;
};

export type ConductorCommissioningDraftPatchInput = {
  devices?: InputMaybe<Array<ConductorProposedDeviceInput>>;
  floors?: InputMaybe<Array<ConductorProposedFloorInput>>;
  mode?: InputMaybe<Scalars['String']>;
  needsReview?: InputMaybe<Array<Scalars['String']>>;
  units?: InputMaybe<Array<ConductorProposedUnitInput>>;
};

export type ConductorCommissioningDraftView = {
  __typename: 'ConductorCommissioningDraftView';
  _id: Scalars['String'];
  acknowledgedAt?: Maybe<Scalars['Date']>;
  buildingId: Scalars['String'];
  createdAt?: Maybe<Scalars['Date']>;
  devices?: Maybe<Array<ConductorProposedDevice>>;
  discoveryFingerprint: Scalars['String'];
  floors?: Maybe<Array<ConductorProposedFloor>>;
  mode: Scalars['String'];
  needsReview: Array<Scalars['String']>;
  propertyId: Scalars['String'];
  resolvedIds?: Maybe<Scalars['JSON']>;
  resolvedMappings?: Maybe<Scalars['JSON']>;
  revision: Scalars['Float'];
  runId: Scalars['String'];
  sourceId: Scalars['String'];
  status: Scalars['String'];
  units?: Maybe<Array<ConductorProposedUnit>>;
  updatedAt?: Maybe<Scalars['Date']>;
  validationErrors?: Maybe<Array<ConductorCommissioningValidationError>>;
};

export type ConductorCommissioningValidationError = {
  __typename?: 'ConductorCommissioningValidationError';
  field?: Maybe<Scalars['String']>;
  key?: Maybe<Scalars['String']>;
  message: Scalars['String'];
  stage: Scalars['String'];
};

export type ConductorDiscoveryStatus = {
  __typename?: 'ConductorDiscoveryStatus';
  aiAudit?: Maybe<Scalars['JSON']>;
  isComplete: Scalars['Boolean'];
  message?: Maybe<Scalars['String']>;
  progressPercent?: Maybe<Scalars['Float']>;
  proposedMappings?: Maybe<Scalars['JSON']>;
  results?: Maybe<Scalars['JSON']>;
  runId: Scalars['String'];
  sourceId: Scalars['String'];
  status: Scalars['String'];
  unallocated?: Maybe<Scalars['JSON']>;
};

export type ConductorGenericSensor = DeviceInterface & {
  __typename: 'ConductorGenericSensor';
  _id: Scalars['String'];
  alarmState?: Maybe<ConductorGenericSensorAlarmState>;
  alertTypes?: Maybe<DeviceAlertTypes>;
  chartTypes: Array<ChartType>;
  controlled?: Maybe<DeviceControlled>;
  counterValue?: Maybe<ConductorGenericSensorCounterValue>;
  dependentDeviceIds: Array<Maybe<Scalars['String']>>;
  deviceAlerts: Array<Maybe<Alert>>;
  deviceId?: Maybe<Scalars['String']>;
  deviceIdentifier?: Maybe<Scalars['String']>;
  deviceMetrics?: Maybe<Array<Maybe<DeviceMetric>>>;
  displayName?: Maybe<Scalars['String']>;
  fanSpeed?: Maybe<ConductorGenericSensorFanSpeed>;
  hasPendingUpdates: Scalars['Boolean'];
  humidity?: Maybe<ConductorGenericSensorHumidity>;
  installation?: Maybe<DeviceInstallation>;
  isConfigured?: Maybe<Scalars['Boolean']>;
  isControlled: Scalars['Boolean'];
  isPoweredOn?: Maybe<Scalars['Boolean']>;
  location?: Maybe<Scalars['String']>;
  meta?: Maybe<DeviceMeta>;
  modelChangeOperation?: Maybe<Scalars['String']>;
  modelType?: Maybe<Scalars['String']>;
  /** The name of the device */
  name?: Maybe<Scalars['String']>;
  panel?: Maybe<Panel>;
  panelId?: Maybe<Scalars['String']>;
  powerState?: Maybe<DevicePowerState>;
  property?: Maybe<Property>;
  propertyId: Scalars['String'];
  resetCount?: Maybe<ConductorGenericSensorResetCount>;
  setpoint?: Maybe<ConductorGenericSensorSetpoint>;
  source?: Maybe<Source>;
  sourceAlerts: Array<Maybe<Alert>>;
  sourceId?: Maybe<Scalars['String']>;
  supportsResetCounters?: Maybe<Scalars['Boolean']>;
  systemMode?: Maybe<ConductorGenericSensorSystemMode>;
  temperature?: Maybe<ConductorGenericSensorTemperature>;
  timestamp?: Maybe<Scalars['Float']>;
  type?: Maybe<EnumDKeyDeviceType>;
  typeDisplayName: Scalars['String'];
  unit?: Maybe<Unit>;
  unitId: Scalars['String'];
  updateDescription?: Maybe<Scalars['JSON']>;
  updateStatus?: Maybe<Scalars['Boolean']>;
  vpp?: Maybe<VirtualPowerPlant>;
  vppId?: Maybe<Scalars['String']>;
  zone?: Maybe<Zone>;
  zoneId?: Maybe<Scalars['String']>;
};

export type ConductorGenericSensorDeviceAlertsArgs = {
  filter?: InputMaybe<FilterFindManyAlertInput>;
  limit?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<SortFindManyAlertInput>;
};

export type ConductorGenericSensorSourceAlertsArgs = {
  filter?: InputMaybe<FilterFindManyAlertInput>;
  limit?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<SortFindManyAlertInput>;
};

export type ConductorGenericSensorAlarmState = {
  __typename?: 'ConductorGenericSensorAlarmState';
  id?: Maybe<Scalars['String']>;
  observedAt?: Maybe<Scalars['Float']>;
  previousId?: Maybe<Scalars['String']>;
  timestamp?: Maybe<Scalars['Float']>;
  units?: Maybe<Scalars['String']>;
  updatePending?: Maybe<Scalars['Boolean']>;
  value?: Maybe<Scalars['Boolean']>;
};

export type ConductorGenericSensorCounterValue = {
  __typename?: 'ConductorGenericSensorCounterValue';
  id?: Maybe<Scalars['String']>;
  observedAt?: Maybe<Scalars['Float']>;
  previousId?: Maybe<Scalars['String']>;
  timestamp?: Maybe<Scalars['Float']>;
  units?: Maybe<Scalars['String']>;
  updatePending?: Maybe<Scalars['Boolean']>;
  value?: Maybe<Scalars['Float']>;
};

export type ConductorGenericSensorFanSpeed = {
  __typename?: 'ConductorGenericSensorFanSpeed';
  id?: Maybe<Scalars['String']>;
  observedAt?: Maybe<Scalars['Float']>;
  previousId?: Maybe<Scalars['String']>;
  timestamp?: Maybe<Scalars['Float']>;
  units?: Maybe<Scalars['String']>;
  updatePending?: Maybe<Scalars['Boolean']>;
  value?: Maybe<Scalars['Float']>;
};

export type ConductorGenericSensorHumidity = {
  __typename?: 'ConductorGenericSensorHumidity';
  id?: Maybe<Scalars['String']>;
  observedAt?: Maybe<Scalars['Float']>;
  previousId?: Maybe<Scalars['String']>;
  timestamp?: Maybe<Scalars['Float']>;
  units?: Maybe<Scalars['String']>;
  updatePending?: Maybe<Scalars['Boolean']>;
  value?: Maybe<Scalars['Float']>;
};

export type ConductorGenericSensorResetCount = {
  __typename?: 'ConductorGenericSensorResetCount';
  id?: Maybe<Scalars['String']>;
  observedAt?: Maybe<Scalars['Float']>;
  previousId?: Maybe<Scalars['String']>;
  timestamp?: Maybe<Scalars['Float']>;
  units?: Maybe<Scalars['String']>;
  updatePending?: Maybe<Scalars['Boolean']>;
  value?: Maybe<Scalars['Float']>;
};

export type ConductorGenericSensorSetpoint = {
  __typename?: 'ConductorGenericSensorSetpoint';
  id?: Maybe<Scalars['String']>;
  observedAt?: Maybe<Scalars['Float']>;
  previousId?: Maybe<Scalars['String']>;
  timestamp?: Maybe<Scalars['Float']>;
  units?: Maybe<Scalars['String']>;
  updatePending?: Maybe<Scalars['Boolean']>;
  value?: Maybe<Scalars['Float']>;
};

export type ConductorGenericSensorSystemMode = {
  __typename?: 'ConductorGenericSensorSystemMode';
  id?: Maybe<Scalars['String']>;
  observedAt?: Maybe<Scalars['Float']>;
  previousId?: Maybe<Scalars['String']>;
  timestamp?: Maybe<Scalars['Float']>;
  units?: Maybe<Scalars['String']>;
  updatePending?: Maybe<Scalars['Boolean']>;
  value?: Maybe<Scalars['Float']>;
};

export type ConductorGenericSensorTemperature = {
  __typename?: 'ConductorGenericSensorTemperature';
  id?: Maybe<Scalars['String']>;
  observedAt?: Maybe<Scalars['Float']>;
  previousId?: Maybe<Scalars['String']>;
  timestamp?: Maybe<Scalars['Float']>;
  units?: Maybe<Scalars['String']>;
  updatePending?: Maybe<Scalars['Boolean']>;
  value?: Maybe<Scalars['Float']>;
};

export type ConductorHierarchyEvidence = {
  __typename?: 'ConductorHierarchyEvidence';
  source: Scalars['String'];
  value: Scalars['String'];
};

export type ConductorHierarchyEvidenceInput = {
  source: Scalars['String'];
  value: Scalars['String'];
};

export type ConductorProposedDevice = {
  __typename?: 'ConductorProposedDevice';
  confidence: Scalars['Float'];
  deviceType: Scalars['String'];
  discoveredDeviceId: Scalars['String'];
  enabledCommands: Array<Scalars['String']>;
  enabledMetrics: Array<Scalars['String']>;
  evidence?: Maybe<Array<ConductorHierarchyEvidence>>;
  ignored?: Maybe<Scalars['Boolean']>;
  key: Scalars['String'];
  originalLabel: Scalars['String'];
  proposedName: Scalars['String'];
  supportedCommands: Array<Scalars['String']>;
  supportedMetrics: Array<Scalars['String']>;
  unitKey?: Maybe<Scalars['String']>;
};

export type ConductorProposedDeviceInput = {
  confidence: Scalars['Float'];
  deviceType: Scalars['String'];
  discoveredDeviceId: Scalars['String'];
  enabledCommands: Array<Scalars['String']>;
  enabledMetrics: Array<Scalars['String']>;
  evidence?: InputMaybe<Array<ConductorHierarchyEvidenceInput>>;
  ignored?: InputMaybe<Scalars['Boolean']>;
  key: Scalars['String'];
  originalLabel: Scalars['String'];
  proposedName: Scalars['String'];
  supportedCommands: Array<Scalars['String']>;
  supportedMetrics: Array<Scalars['String']>;
  unitKey?: InputMaybe<Scalars['String']>;
};

export type ConductorProposedFloor = {
  __typename?: 'ConductorProposedFloor';
  confidence: Scalars['Float'];
  evidence?: Maybe<Array<ConductorHierarchyEvidence>>;
  existingFloorId?: Maybe<Scalars['String']>;
  key: Scalars['String'];
  name: Scalars['String'];
  number?: Maybe<Scalars['Float']>;
};

export type ConductorProposedFloorInput = {
  confidence: Scalars['Float'];
  evidence?: InputMaybe<Array<ConductorHierarchyEvidenceInput>>;
  existingFloorId?: InputMaybe<Scalars['String']>;
  key: Scalars['String'];
  name: Scalars['String'];
  number?: InputMaybe<Scalars['Float']>;
};

export type ConductorProposedUnit = {
  __typename?: 'ConductorProposedUnit';
  confidence: Scalars['Float'];
  evidence?: Maybe<Array<ConductorHierarchyEvidence>>;
  existingUnitId?: Maybe<Scalars['String']>;
  floorKey?: Maybe<Scalars['String']>;
  key: Scalars['String'];
  name: Scalars['String'];
  type: Scalars['String'];
};

export type ConductorProposedUnitInput = {
  confidence: Scalars['Float'];
  evidence?: InputMaybe<Array<ConductorHierarchyEvidenceInput>>;
  existingUnitId?: InputMaybe<Scalars['String']>;
  floorKey?: InputMaybe<Scalars['String']>;
  key: Scalars['String'];
  name: Scalars['String'];
  type: Scalars['String'];
};

export type ConductorTolerances = {
  __typename?: 'ConductorTolerances';
  humidity?: Maybe<Scalars['Float']>;
  temperature?: Maybe<Scalars['Float']>;
};

export enum ConductorTransportMode {
  Auto = 'AUTO',
  Bacnet = 'BACNET',
  WebDirect = 'WEB_DIRECT',
}

export type ControlGroup = {
  __typename: 'ControlGroup';
  _id: Scalars['String'];
  attributes: Scalars['JSON'];
  automationEnabled?: Maybe<Scalars['Boolean']>;
  deviceDetails?: Maybe<Scalars['JSON']>;
  devices: Array<Device>;
  displayName?: Maybe<Scalars['String']>;
  groupedDevices: Array<Maybe<ControlGroupGroupedDevices>>;
  masterDevice?: Maybe<Device>;
  masterDeviceId?: Maybe<Scalars['String']>;
  modelChangeOperation?: Maybe<Scalars['String']>;
  modelType?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  property?: Maybe<Property>;
  propertyId: Scalars['String'];
  type: Scalars['String'];
  unit?: Maybe<Unit>;
  unitId: Scalars['String'];
  updateDescription?: Maybe<Scalars['JSON']>;
};

export type ControlGroupGroupedDevices = {
  __typename: 'ControlGroupGroupedDevices';
  _id: Scalars['String'];
  deviceId: Scalars['String'];
  displayOrder: Scalars['Float'];
  name: Scalars['String'];
  type: Scalars['String'];
};

export type ControlGroupGroupedDevicesInput = {
  _id: Scalars['String'];
  deviceId: Scalars['String'];
  displayOrder: Scalars['Float'];
  name: Scalars['String'];
  type: Scalars['String'];
};

/** List of items with pagination. */
export type ControlGroupPaginatedControlGroups = {
  __typename?: 'ControlGroupPaginatedControlGroups';
  /** Total object count. */
  count?: Maybe<Scalars['Int']>;
  /** Array of objects. */
  items?: Maybe<Array<ControlGroup>>;
  /** Information to aid in pagination. */
  pageInfo: PaginationInfo;
};

export type Controller = DeviceInterface & {
  __typename: 'Controller';
  _id: Scalars['String'];
  activeAlarmCount?: Maybe<ControllerActiveAlarmCount>;
  alertTypes?: Maybe<DeviceAlertTypes>;
  chartTypes: Array<ChartType>;
  communicationState?: Maybe<ControllerCommunicationState>;
  controlled?: Maybe<DeviceControlled>;
  controller_loop?: Maybe<ControllerController_Loop>;
  dependentDeviceIds: Array<Maybe<Scalars['String']>>;
  deviceAlerts: Array<Maybe<Alert>>;
  deviceId?: Maybe<Scalars['String']>;
  deviceIdentifier?: Maybe<Scalars['String']>;
  deviceMetrics?: Maybe<Array<Maybe<DeviceMetric>>>;
  displayName?: Maybe<Scalars['String']>;
  hasPendingUpdates: Scalars['Boolean'];
  installation?: Maybe<DeviceInstallation>;
  isConfigured?: Maybe<Scalars['Boolean']>;
  isControlled: Scalars['Boolean'];
  isPoweredOn?: Maybe<Scalars['Boolean']>;
  location?: Maybe<Scalars['String']>;
  meta?: Maybe<DeviceMeta>;
  modelChangeOperation?: Maybe<Scalars['String']>;
  modelType?: Maybe<Scalars['String']>;
  /** The name of the device */
  name?: Maybe<Scalars['String']>;
  panel?: Maybe<Panel>;
  panelId?: Maybe<Scalars['String']>;
  powerState?: Maybe<DevicePowerState>;
  property?: Maybe<Property>;
  propertyId: Scalars['String'];
  resetCount?: Maybe<ControllerResetCount>;
  source?: Maybe<Source>;
  sourceAlerts: Array<Maybe<Alert>>;
  sourceId?: Maybe<Scalars['String']>;
  supervisor_controller?: Maybe<ControllerSupervisor_Controller>;
  timestamp?: Maybe<Scalars['Float']>;
  type?: Maybe<EnumDKeyDeviceType>;
  typeDisplayName: Scalars['String'];
  unit?: Maybe<Unit>;
  unitId: Scalars['String'];
  updateDescription?: Maybe<Scalars['JSON']>;
  updateStatus?: Maybe<Scalars['Boolean']>;
  vpp?: Maybe<VirtualPowerPlant>;
  vppId?: Maybe<Scalars['String']>;
  zone?: Maybe<Zone>;
  zoneId?: Maybe<Scalars['String']>;
};

export type ControllerDeviceAlertsArgs = {
  filter?: InputMaybe<FilterFindManyAlertInput>;
  limit?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<SortFindManyAlertInput>;
};

export type ControllerSourceAlertsArgs = {
  filter?: InputMaybe<FilterFindManyAlertInput>;
  limit?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<SortFindManyAlertInput>;
};

export type ControllerActiveAlarmCount = {
  __typename?: 'ControllerActiveAlarmCount';
  id?: Maybe<Scalars['String']>;
  observedAt?: Maybe<Scalars['Float']>;
  previousId?: Maybe<Scalars['String']>;
  timestamp?: Maybe<Scalars['Float']>;
  units?: Maybe<Scalars['String']>;
  updatePending?: Maybe<Scalars['Boolean']>;
  value?: Maybe<Scalars['Float']>;
};

export type ControllerCommunicationState = {
  __typename?: 'ControllerCommunicationState';
  id?: Maybe<Scalars['String']>;
  observedAt?: Maybe<Scalars['Float']>;
  previousId?: Maybe<Scalars['String']>;
  timestamp?: Maybe<Scalars['Float']>;
  units?: Maybe<Scalars['String']>;
  updatePending?: Maybe<Scalars['Boolean']>;
  value?: Maybe<Scalars['Boolean']>;
};

export type ControllerController_Loop = {
  __typename?: 'ControllerController_loop';
  id?: Maybe<Scalars['String']>;
  observedAt?: Maybe<Scalars['Float']>;
  previousId?: Maybe<Scalars['String']>;
  timestamp?: Maybe<Scalars['Float']>;
  units?: Maybe<Scalars['String']>;
  updatePending?: Maybe<Scalars['Boolean']>;
  value?: Maybe<EnumControllerController_LoopValue>;
};

export type ControllerResetCount = {
  __typename?: 'ControllerResetCount';
  id?: Maybe<Scalars['String']>;
  observedAt?: Maybe<Scalars['Float']>;
  previousId?: Maybe<Scalars['String']>;
  timestamp?: Maybe<Scalars['Float']>;
  units?: Maybe<Scalars['String']>;
  updatePending?: Maybe<Scalars['Boolean']>;
  value?: Maybe<Scalars['Float']>;
};

export type ControllerSupervisor_Controller = {
  __typename?: 'ControllerSupervisor_controller';
  id?: Maybe<Scalars['String']>;
  observedAt?: Maybe<Scalars['Float']>;
  previousId?: Maybe<Scalars['String']>;
  timestamp?: Maybe<Scalars['Float']>;
  units?: Maybe<Scalars['String']>;
  updatePending?: Maybe<Scalars['Boolean']>;
  value?: Maybe<EnumControllerSupervisor_ControllerValue>;
};

export type Core = SourceInterface & {
  __typename: 'Core';
  _id: Scalars['String'];
  alerts: Array<Maybe<Alert>>;
  /** Returns the authorization profile associated with the user. */
  inUse: Scalars['Boolean'];
  maxReportingTime?: Maybe<Scalars['Float']>;
  modelChangeOperation?: Maybe<Scalars['String']>;
  modelType?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  panels: Array<Maybe<Panel>>;
  property?: Maybe<Property>;
  propertyId?: Maybe<Scalars['String']>;
  timestamp?: Maybe<Scalars['Float']>;
  tolerances?: Maybe<CoreTolerances>;
  type?: Maybe<EnumDKeySourceType>;
  units: Array<Maybe<Unit>>;
  updateDescription?: Maybe<Scalars['JSON']>;
  url?: Maybe<Scalars['String']>;
  zones: Array<Maybe<Zone>>;
};

export type CoreAlertsArgs = {
  filter?: InputMaybe<FilterFindManyAlertInput>;
  limit?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<SortFindManyAlertInput>;
};

export type CorePanelsArgs = {
  filter?: InputMaybe<FilterFindManyPanelInput>;
  limit?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<SortFindManyPanelInput>;
};

export type CoreUnitsArgs = {
  filter?: InputMaybe<FilterFindManyUnitInput>;
  limit?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<SortFindManyUnitInput>;
};

export type CoreZonesArgs = {
  filter?: InputMaybe<FilterFindManyZoneInput>;
  limit?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<SortFindManyZoneInput>;
};

export type CoreTolerances = {
  __typename?: 'CoreTolerances';
  humidity?: Maybe<Scalars['Float']>;
  temperature?: Maybe<Scalars['Float']>;
  voltage?: Maybe<Scalars['Float']>;
};

export type CreateIngestionInput = {
  date: Scalars['Date'];
  fileName: Scalars['String'];
  s3FileName: Scalars['String'];
  status: Scalars['String'];
};

export type CreateOneAlertTriggerInput = {
  alertCategoryId?: InputMaybe<Scalars['String']>;
  editMode?: InputMaybe<Scalars['Float']>;
  enabled?: InputMaybe<Scalars['Boolean']>;
  entityTypes?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  key?: InputMaybe<Scalars['String']>;
  legacyKey?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  propertyId?: InputMaybe<Scalars['String']>;
  triggerCriteria?: InputMaybe<CreateOneAlertTriggerTriggerCriteriaInput>;
};

export type CreateOneAlertTriggerTriggerCriteriaInput = {
  basisName?: InputMaybe<Scalars['String']>;
  basisType?: InputMaybe<EnumAlertTriggerTriggerCriteriaBasisType>;
  levels?: InputMaybe<Scalars['Float']>;
  selectionCriteria?: InputMaybe<CreateOneAlertTriggerTriggerCriteriaSelectionCriteriaInput>;
};

export type CreateOneAlertTriggerTriggerCriteriaSelectionCriteriaCompoundOperatorInput =
  {
    criteria?: InputMaybe<Scalars['JSON']>;
    id?: InputMaybe<Scalars['String']>;
    operator?: InputMaybe<EnumAlertTriggerTriggerCriteriaSelectionCriteriaCompoundOperatorOperator>;
  };

export type CreateOneAlertTriggerTriggerCriteriaSelectionCriteriaCriterionInput =
  {
    comparator: EnumAlertTriggerTriggerCriteriaSelectionCriteriaCriterionComparator;
    editable?: InputMaybe<Scalars['Boolean']>;
    id: Scalars['String'];
    legacyPath?: InputMaybe<Scalars['String']>;
    selectionPath: Scalars['String'];
    template?: InputMaybe<Scalars['String']>;
    valueType: EnumAlertTriggerTriggerCriteriaSelectionCriteriaCriterionValueType;
    values: Array<InputMaybe<Scalars['String']>>;
  };

export type CreateOneAlertTriggerTriggerCriteriaSelectionCriteriaInput = {
  compoundOperator?: InputMaybe<CreateOneAlertTriggerTriggerCriteriaSelectionCriteriaCompoundOperatorInput>;
  criteria?: InputMaybe<
    Array<
      InputMaybe<CreateOneAlertTriggerTriggerCriteriaSelectionCriteriaCriterionInput>
    >
  >;
  criterion?: InputMaybe<CreateOneAlertTriggerTriggerCriteriaSelectionCriteriaCriterionInput>;
  simpleOperator?: InputMaybe<CreateOneAlertTriggerTriggerCriteriaSelectionCriteriaSimpleOperatorInput>;
};

export type CreateOneAlertTriggerTriggerCriteriaSelectionCriteriaSimpleOperatorInput =
  {
    criteria?: InputMaybe<
      Array<
        InputMaybe<CreateOneAlertTriggerTriggerCriteriaSelectionCriteriaCriterionInput>
      >
    >;
    criterion?: InputMaybe<CreateOneAlertTriggerTriggerCriteriaSelectionCriteriaCriterionInput>;
    id?: InputMaybe<Scalars['String']>;
    operator?: InputMaybe<EnumAlertTriggerTriggerCriteriaSelectionCriteriaSimpleOperatorOperator>;
  };

export type CreateOneAuthorizationProfileInput = {
  apiToken?: InputMaybe<Scalars['String']>;
  currentChallenge?: InputMaybe<Scalars['String']>;
  currentChallengeExpiration?: InputMaybe<Scalars['Float']>;
  installerProperties?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  isInstaller?: InputMaybe<Scalars['Boolean']>;
  isManager?: InputMaybe<Scalars['Boolean']>;
  isResident?: InputMaybe<Scalars['Boolean']>;
  isSuper?: InputMaybe<Scalars['Boolean']>;
  isViewer?: InputMaybe<Scalars['Boolean']>;
  managerProperties?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  residentProperty?: InputMaybe<Scalars['String']>;
  residentUnit?: InputMaybe<Scalars['String']>;
  viewerProperties?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type CreateOneBngInput = {
  localUrl: Scalars['String'];
  name: Scalars['String'];
  propertyId: Scalars['String'];
  url: Scalars['String'];
};

export type CreateOneBuildingInput = {
  name?: InputMaybe<Scalars['String']>;
  number?: InputMaybe<Scalars['Float']>;
  propertyId?: InputMaybe<Scalars['String']>;
};

export type CreateOneConductorInput = {
  buildingId: Scalars['String'];
  maxReportingTime?: InputMaybe<Scalars['Float']>;
  name: Scalars['String'];
  propertyId: Scalars['String'];
  tolerances?: InputMaybe<CreateOneConductorTolerancesInput>;
  url: Scalars['String'];
};

export type CreateOneConductorTolerancesInput = {
  humidity?: InputMaybe<Scalars['Float']>;
  temperature?: InputMaybe<Scalars['Float']>;
};

export type CreateOneControlGroupInput = {
  attributes: Scalars['JSON'];
  automationEnabled?: InputMaybe<Scalars['Boolean']>;
  groupedDevices: Array<InputMaybe<ControlGroupGroupedDevicesInput>>;
  masterDeviceId?: InputMaybe<Scalars['String']>;
  name: Scalars['String'];
  propertyId: Scalars['String'];
  type: Scalars['String'];
  unitId: Scalars['String'];
};

export type CreateOneCoreInput = {
  maxReportingTime?: InputMaybe<Scalars['Float']>;
  name: Scalars['String'];
  propertyId: Scalars['String'];
  tolerances?: InputMaybe<CreateOneCoreTolerancesInput>;
  url: Scalars['String'];
};

export type CreateOneCoreTolerancesInput = {
  humidity?: InputMaybe<Scalars['Float']>;
  temperature?: InputMaybe<Scalars['Float']>;
  voltage?: InputMaybe<Scalars['Float']>;
};

export type CreateOneHmmInput = {
  maxReportingTime?: InputMaybe<Scalars['Float']>;
  name: Scalars['String'];
  propertyId: Scalars['String'];
  tolerances?: InputMaybe<CreateOneHmmTolerancesInput>;
  url: Scalars['String'];
};

export type CreateOneHmmTolerancesInput = {
  temperature?: InputMaybe<Scalars['Float']>;
};

export type CreateOneOrganizationHqAddressInput = {
  city?: InputMaybe<Scalars['String']>;
  country?: InputMaybe<Scalars['String']>;
  line1?: InputMaybe<Scalars['String']>;
  line2?: InputMaybe<Scalars['String']>;
  postalCode?: InputMaybe<Scalars['String']>;
  state?: InputMaybe<Scalars['String']>;
};

export type CreateOneOrganizationInput = {
  description?: InputMaybe<Scalars['String']>;
  hqAddress?: InputMaybe<CreateOneOrganizationHqAddressInput>;
  hqEmail?: InputMaybe<Scalars['String']>;
  hqPhone?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  parentOrganizationId?: InputMaybe<Scalars['String']>;
};

export type CreateOnePlmContractInput = {
  baselineMethod?: InputMaybe<EnumPlmContractBaselineMethod>;
  contractId?: InputMaybe<Scalars['String']>;
  dispatcherIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  incentiveDescription?: InputMaybe<Scalars['String']>;
  maximumEventsPerSeason?: InputMaybe<Scalars['Float']>;
  meterIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  minimumReductionKW?: InputMaybe<Scalars['Float']>;
  name?: InputMaybe<Scalars['String']>;
  notificationEmail?: InputMaybe<Scalars['String']>;
  partnerId?: InputMaybe<Scalars['String']>;
  penaltyForNonCompliance?: InputMaybe<Scalars['Float']>;
  programId?: InputMaybe<Scalars['String']>;
  propertyIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  scopeType?: InputMaybe<EnumPlmContractScopeType>;
  status?: InputMaybe<EnumPlmContractStatus>;
  utilityId?: InputMaybe<Scalars['String']>;
};

export type CreateOnePlmCurtailmentPlanInput = {
  applicableSeasons?: InputMaybe<
    Array<InputMaybe<EnumPlmCurtailmentPlanApplicableSeasons>>
  >;
  description?: InputMaybe<Scalars['String']>;
  durationMinutes?: InputMaybe<Scalars['Float']>;
  estimatedReductionKW?: InputMaybe<Scalars['Float']>;
  name?: InputMaybe<Scalars['String']>;
  organizationId?: InputMaybe<Scalars['String']>;
};

export type CreateOnePlmCurtailmentTaskCachedDeviceStateInput = {
  coolSetpoint?: InputMaybe<Scalars['Float']>;
  coolSetpointAdjustmentMode?: InputMaybe<EnumPlmCurtailmentTaskCachedDeviceStateCoolSetpointAdjustmentMode>;
  fanMode?: InputMaybe<Scalars['String']>;
  fanSpeed?: InputMaybe<Scalars['String']>;
  freshAirSetpoint?: InputMaybe<Scalars['Float']>;
  heatSetpoint?: InputMaybe<Scalars['Float']>;
  heatSetpointAdjustmentMode?: InputMaybe<EnumPlmCurtailmentTaskCachedDeviceStateHeatSetpointAdjustmentMode>;
  isOn?: InputMaybe<Scalars['Boolean']>;
  keypadLockoutLevel?: InputMaybe<Scalars['String']>;
  maxCoolSetpointLimit?: InputMaybe<Scalars['Float']>;
  maxHeatSetpointLimit?: InputMaybe<Scalars['Float']>;
  minCoolSetpointLimit?: InputMaybe<Scalars['Float']>;
  minHeatSetpointLimit?: InputMaybe<Scalars['Float']>;
  operatingMode?: InputMaybe<Scalars['String']>;
  rhSetpoint?: InputMaybe<Scalars['Float']>;
  type: EnumPlmCurtailmentTaskCachedDeviceStateType;
  ventilationMode?: InputMaybe<Scalars['String']>;
};

export type CreateOnePlmCurtailmentTaskInput = {
  batchId?: InputMaybe<Scalars['Float']>;
  cachedDeviceState?: InputMaybe<CreateOnePlmCurtailmentTaskCachedDeviceStateInput>;
  deviceId?: InputMaybe<Scalars['String']>;
  deviceType?: InputMaybe<Scalars['String']>;
  endedAt?: InputMaybe<Scalars['Float']>;
  estimatedReductionKW?: InputMaybe<Scalars['Float']>;
  plmCurtailmentActionId?: InputMaybe<Scalars['String']>;
  plmEventResponseId?: InputMaybe<Scalars['String']>;
  propertyId?: InputMaybe<Scalars['String']>;
  resolvedTargetedAdjustments?: InputMaybe<CreateOnePlmCurtailmentTaskCachedDeviceStateInput>;
  scheduledEnd?: InputMaybe<Scalars['Float']>;
  scheduledStart?: InputMaybe<Scalars['Float']>;
  startedAt?: InputMaybe<Scalars['Float']>;
  status?: InputMaybe<EnumPlmCurtailmentTaskStatus>;
  statusMessage?: InputMaybe<Scalars['String']>;
  targetedAdjustments?: InputMaybe<CreateOnePlmCurtailmentTaskCachedDeviceStateInput>;
  unitId?: InputMaybe<Scalars['String']>;
  updateRetryCount?: InputMaybe<Scalars['Float']>;
  verifiedAt?: InputMaybe<Scalars['Float']>;
  verifyAttempts?: InputMaybe<Scalars['Float']>;
};

export type CreateOnePlmEventInput = {
  contractId?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['Float']>;
  duration?: InputMaybe<Scalars['Float']>;
  notificationHeaders?: InputMaybe<Scalars['JSON']>;
  notificationMethod?: InputMaybe<EnumPlmEventNotificationMethod>;
  notificationPayload?: InputMaybe<Scalars['String']>;
  notificationReceivedAt?: InputMaybe<Scalars['Float']>;
  programId?: InputMaybe<Scalars['String']>;
  reductionTarget?: InputMaybe<Scalars['Float']>;
  sourceExternalId?: InputMaybe<Scalars['String']>;
  sourceVendor?: InputMaybe<Scalars['String']>;
  startTime?: InputMaybe<Scalars['Float']>;
  status?: InputMaybe<EnumPlmEventStatus>;
  updatedAt?: InputMaybe<Scalars['Float']>;
};

export type CreateOnePlmEventResponseInput = {
  actualEnd?: InputMaybe<Scalars['Float']>;
  actualStart?: InputMaybe<Scalars['Float']>;
  createdAt?: InputMaybe<Scalars['Float']>;
  curtailmentPlanId?: InputMaybe<Scalars['String']>;
  eventId?: InputMaybe<Scalars['String']>;
  responseSentAt?: InputMaybe<Scalars['Float']>;
  responseStatus?: InputMaybe<EnumPlmEventResponseResponseStatus>;
  scheduledEnd?: InputMaybe<Scalars['Float']>;
  scheduledStart?: InputMaybe<Scalars['Float']>;
  updatedAt?: InputMaybe<Scalars['Float']>;
};

export type CreateOnePlmPartnerContactInput = {
  email?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  phone?: InputMaybe<Scalars['String']>;
};

export type CreateOnePlmPartnerInput = {
  contact?: InputMaybe<CreateOnePlmPartnerContactInput>;
  description?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  partnerType?: InputMaybe<EnumPlmPartnerPartnerType>;
};

export type CreateOnePlmProgramInput = {
  endDate?: InputMaybe<Scalars['Float']>;
  hostPartnerId?: InputMaybe<Scalars['String']>;
  hostUtilityId?: InputMaybe<Scalars['String']>;
  incentiveDescription?: InputMaybe<Scalars['String']>;
  maximumEventDurationMinutes?: InputMaybe<Scalars['Float']>;
  maximumEventsPerSeason?: InputMaybe<Scalars['Float']>;
  maximumNotificationLeadTimeMinutes?: InputMaybe<Scalars['Float']>;
  measurementIntervalMinutes?: InputMaybe<Scalars['Float']>;
  minimumEventDurationMinutes?: InputMaybe<Scalars['Float']>;
  minimumEventsPerSeason?: InputMaybe<Scalars['Float']>;
  name?: InputMaybe<Scalars['String']>;
  notificationLeadTimeMinutes?: InputMaybe<Scalars['Float']>;
  participationType?: InputMaybe<EnumPlmProgramParticipationType>;
  partnerId?: InputMaybe<Scalars['String']>;
  programId?: InputMaybe<Scalars['String']>;
  season?: InputMaybe<EnumPlmProgramSeason>;
  startDate?: InputMaybe<Scalars['Float']>;
  utilityId?: InputMaybe<Scalars['String']>;
};

export type CreateOnePlmUtilityContactInput = {
  email?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  phone?: InputMaybe<Scalars['String']>;
};

export type CreateOnePlmUtilityInput = {
  contact?: InputMaybe<CreateOnePlmUtilityContactInput>;
  description?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
};

export type CreateOnePropertyAddressInput = {
  city?: InputMaybe<Scalars['String']>;
  line1?: InputMaybe<Scalars['String']>;
  line2?: InputMaybe<Scalars['String']>;
  postalCode?: InputMaybe<Scalars['String']>;
  state?: InputMaybe<Scalars['String']>;
};

export type CreateOnePropertyAlertLimitsInput = {
  plant?: InputMaybe<CreateOnePropertyAlertLimitsPlantInput>;
  units?: InputMaybe<CreateOnePropertyAlertLimitsUnitsInput>;
};

export type CreateOnePropertyAlertLimitsPlantDhwInput = {
  temperature?: InputMaybe<CreateOnePropertyAlertLimitsPlantDhwTemperatureInput>;
};

export type CreateOnePropertyAlertLimitsPlantDhwTemperatureInput = {
  max?: InputMaybe<Scalars['Float']>;
  min?: InputMaybe<Scalars['Float']>;
};

export type CreateOnePropertyAlertLimitsPlantInput = {
  dhw?: InputMaybe<CreateOnePropertyAlertLimitsPlantDhwInput>;
  loops?: InputMaybe<CreateOnePropertyAlertLimitsPlantLoopsInput>;
};

export type CreateOnePropertyAlertLimitsPlantLoopsInput = {
  pressure?: InputMaybe<CreateOnePropertyAlertLimitsPlantLoopsPressureInput>;
  temperature?: InputMaybe<CreateOnePropertyAlertLimitsPlantLoopsTemperatureInput>;
};

export type CreateOnePropertyAlertLimitsPlantLoopsPressureInput = {
  max?: InputMaybe<Scalars['Float']>;
  min?: InputMaybe<Scalars['Float']>;
};

export type CreateOnePropertyAlertLimitsPlantLoopsTemperatureInput = {
  max?: InputMaybe<Scalars['Float']>;
  min?: InputMaybe<Scalars['Float']>;
};

export type CreateOnePropertyAlertLimitsUnitsHumidityInput = {
  max?: InputMaybe<Scalars['Float']>;
  min?: InputMaybe<Scalars['Float']>;
};

export type CreateOnePropertyAlertLimitsUnitsInput = {
  humidity?: InputMaybe<CreateOnePropertyAlertLimitsUnitsHumidityInput>;
  temperature?: InputMaybe<CreateOnePropertyAlertLimitsUnitsTemperatureInput>;
};

export type CreateOnePropertyAlertLimitsUnitsTemperatureInput = {
  max?: InputMaybe<Scalars['Float']>;
  min?: InputMaybe<Scalars['Float']>;
};

export type CreateOnePropertyAlertTypesInput = {
  deviceAlert?: InputMaybe<Scalars['Boolean']>;
  deviceMetric?: InputMaybe<Scalars['Boolean']>;
  deviceOffline?: InputMaybe<Scalars['Boolean']>;
  equipmentAlarm?: InputMaybe<Scalars['Boolean']>;
  sourceOffline?: InputMaybe<Scalars['Boolean']>;
};

export type CreateOnePropertyContactInput = {
  email?: InputMaybe<Scalars['String']>;
  email2?: InputMaybe<Scalars['String']>;
  email3?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  smsNumber?: InputMaybe<Scalars['String']>;
  smsNumber2?: InputMaybe<Scalars['String']>;
  smsNumber3?: InputMaybe<Scalars['String']>;
  smsOptInStatus1?: InputMaybe<EnumPropertyContactSmsOptInStatus1>;
  smsOptInStatus2?: InputMaybe<EnumPropertyContactSmsOptInStatus2>;
  smsOptInStatus3?: InputMaybe<EnumPropertyContactSmsOptInStatus3>;
  smsOptInTimestamp1?: InputMaybe<Scalars['Float']>;
  smsOptInTimestamp2?: InputMaybe<Scalars['Float']>;
  smsOptInTimestamp3?: InputMaybe<Scalars['Float']>;
};

export type CreateOnePropertyInput = {
  address?: InputMaybe<CreateOnePropertyAddressInput>;
  alertLimits?: InputMaybe<CreateOnePropertyAlertLimitsInput>;
  alertTypes?: InputMaybe<CreateOnePropertyAlertTypesInput>;
  contact?: InputMaybe<CreateOnePropertyContactInput>;
  floorLabel?: InputMaybe<Scalars['String']>;
  hasSecondaryHeatSource?: InputMaybe<Scalars['Boolean']>;
  imageUrl?: InputMaybe<Scalars['String']>;
  maintMgr?: InputMaybe<CreateOnePropertyMaintMgrInput>;
  organizationId?: InputMaybe<Scalars['String']>;
  owner?: InputMaybe<CreateOnePropertyOwnerInput>;
  propMgr?: InputMaybe<CreateOnePropertyPropMgrInput>;
  tempDisplayUnits?: InputMaybe<Scalars['String']>;
  thermostatScheduleTemplateId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['String']>;
  title?: InputMaybe<Scalars['String']>;
  unitsSummary?: InputMaybe<CreateOnePropertyUnitsSummaryInput>;
  zonePolicyId?: InputMaybe<Scalars['String']>;
};

export type CreateOnePropertyMaintMgrInput = {
  email?: InputMaybe<Scalars['String']>;
  mobile?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
};

export type CreateOnePropertyOwnerInput = {
  email?: InputMaybe<Scalars['String']>;
  mobile?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  phone?: InputMaybe<Scalars['String']>;
};

export type CreateOnePropertyPropMgrInput = {
  email?: InputMaybe<Scalars['String']>;
  mobile?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  phone?: InputMaybe<Scalars['String']>;
};

export type CreateOnePropertyUnitsSummaryInput = {
  count?: InputMaybe<Scalars['Float']>;
  majorAlerts?: InputMaybe<Scalars['Float']>;
  minorAlerts?: InputMaybe<Scalars['Float']>;
};

export type CreateOneSetpointProfileCoolInput = {
  max?: InputMaybe<Scalars['Float']>;
  min?: InputMaybe<Scalars['Float']>;
};

export type CreateOneSetpointProfileHeatInput = {
  max?: InputMaybe<Scalars['Float']>;
  min?: InputMaybe<Scalars['Float']>;
};

export type CreateOneSetpointProfileInput = {
  cool?: InputMaybe<CreateOneSetpointProfileCoolInput>;
  createdAt?: InputMaybe<Scalars['Float']>;
  createdBy?: InputMaybe<Scalars['String']>;
  heat?: InputMaybe<CreateOneSetpointProfileHeatInput>;
  name?: InputMaybe<Scalars['String']>;
  propagated?: InputMaybe<Scalars['Boolean']>;
  properties?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  type?: InputMaybe<EnumSetpointProfileType>;
  units?: InputMaybe<EnumSetpointProfileUnits>;
  updatedAt?: InputMaybe<Scalars['Float']>;
  updatedBy?: InputMaybe<Scalars['String']>;
};

export type CreateOneSystemNotificationInput = {
  acknowledgedAt?: InputMaybe<Scalars['Float']>;
  createdAt?: InputMaybe<Scalars['Float']>;
  displayDuration?: InputMaybe<Scalars['Float']>;
  displayEnd?: InputMaybe<Scalars['Float']>;
  displayStart?: InputMaybe<Scalars['Float']>;
  entityId?: InputMaybe<Scalars['String']>;
  entityType?: InputMaybe<EnumSystemNotificationEntityType>;
  link?: InputMaybe<Scalars['String']>;
  message?: InputMaybe<Scalars['String']>;
  requireAcknowledgement?: InputMaybe<Scalars['Boolean']>;
  seenAt?: InputMaybe<Scalars['Float']>;
  seenBy?: InputMaybe<
    Array<InputMaybe<CreateOneSystemNotificationSeenByInput>>
  >;
};

export type CreateOneSystemNotificationSeenByInput = {
  _id?: InputMaybe<Scalars['MongoID']>;
  seenAt?: InputMaybe<Scalars['Float']>;
  userId?: InputMaybe<Scalars['String']>;
};

export type CreateOneThermostatScheduleTemplateInput = {
  _id?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  propertyId?: InputMaybe<Scalars['String']>;
  setpointLimitProfileId?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<CreateOneThermostatScheduleTemplateValueInput>;
};

export type CreateOneThermostatScheduleTemplateValueInput = {
  id?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  units?: InputMaybe<Scalars['String']>;
  updatePending?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<Scalars['JSON']>;
};

export type CreateOneUnitAlertTypesInput = {
  deviceAlert?: InputMaybe<Scalars['Boolean']>;
  deviceMetric?: InputMaybe<Scalars['Boolean']>;
  deviceOffline?: InputMaybe<Scalars['Boolean']>;
  equipmentAlarm?: InputMaybe<Scalars['Boolean']>;
  sourceOffline?: InputMaybe<Scalars['Boolean']>;
};

export type CreateOneUnitDevicesSummaryInput = {
  count?: InputMaybe<Scalars['Float']>;
  majorAlerts?: InputMaybe<Scalars['Float']>;
  minorAlerts?: InputMaybe<Scalars['Float']>;
  proxy?: InputMaybe<CreateOneUnitDevicesSummaryProxyInput>;
};

export type CreateOneUnitDevicesSummaryProxyInput = {
  coolSetpoint?: InputMaybe<Scalars['Float']>;
  heatSetpoint?: InputMaybe<Scalars['Float']>;
  humidity?: InputMaybe<Scalars['Float']>;
  isOffline?: InputMaybe<Scalars['Boolean']>;
  operatingMode?: InputMaybe<Scalars['String']>;
  operatingState?: InputMaybe<Scalars['String']>;
  setpointCoolMin?: InputMaybe<Scalars['Float']>;
  setpointHeatMax?: InputMaybe<Scalars['Float']>;
  setpointProfileName?: InputMaybe<Scalars['String']>;
  setpointProfileType?: InputMaybe<Scalars['String']>;
  temperature?: InputMaybe<Scalars['Float']>;
  type?: InputMaybe<Scalars['String']>;
};

export type CreateOneUnitInput = {
  alertTypes?: InputMaybe<CreateOneUnitAlertTypesInput>;
  buildingId?: InputMaybe<Scalars['String']>;
  cuid?: InputMaybe<Scalars['String']>;
  devicesSummary?: InputMaybe<CreateOneUnitDevicesSummaryInput>;
  floorId?: InputMaybe<Scalars['String']>;
  hasPanels?: InputMaybe<Scalars['Boolean']>;
  name?: InputMaybe<Scalars['String']>;
  propertyId?: InputMaybe<Scalars['String']>;
  resident?: InputMaybe<CreateOneUnitResidentInput>;
  sourceId?: InputMaybe<Scalars['String']>;
  tempDisplayUnits?: InputMaybe<Scalars['String']>;
  thermostatScheduleTemplateId?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<Scalars['String']>;
  zonePolicyId?: InputMaybe<Scalars['String']>;
};

export type CreateOneUnitResidentInput = {
  email?: InputMaybe<Scalars['String']>;
  mobile?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  phone?: InputMaybe<Scalars['String']>;
};

export type CreateOneUserEmailsInput = {
  address?: InputMaybe<Scalars['String']>;
  externalId?: InputMaybe<Scalars['String']>;
  verified?: InputMaybe<Scalars['Boolean']>;
};

export type CreateOneUserInput = {
  createdAt?: InputMaybe<Scalars['Date']>;
  emails?: InputMaybe<Array<InputMaybe<CreateOneUserEmailsInput>>>;
  externalId?: InputMaybe<Scalars['String']>;
  heartbeat?: InputMaybe<Scalars['Date']>;
  mobileSession?: InputMaybe<CreateOneUserMobileSessionInput>;
  profile?: InputMaybe<CreateOneUserProfileInput>;
  services?: InputMaybe<CreateOneUserServicesInput>;
  session?: InputMaybe<CreateOneUserSessionInput>;
  state?: InputMaybe<Scalars['String']>;
  username?: InputMaybe<Scalars['String']>;
};

export type CreateOneUserMobileSessionInput = {
  appName?: InputMaybe<Scalars['String']>;
  packageName?: InputMaybe<Scalars['String']>;
  version?: InputMaybe<Scalars['String']>;
  versionCode?: InputMaybe<Scalars['String']>;
};

export type CreateOneUserProfileInput = {
  emailOptInStatus?: InputMaybe<Scalars['String']>;
  emailOptInStatusTimestamp?: InputMaybe<Scalars['Float']>;
  historyMap?: InputMaybe<Scalars['JSON']>;
  mobile?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  preferredAirFlowUnits?: InputMaybe<EnumUserProfilePreferredAirFlowUnits>;
  preferredUnits?: InputMaybe<EnumUserProfilePreferredUnits>;
  smsOptInStatus?: InputMaybe<Scalars['String']>;
  smsOptInStatusTimestamp?: InputMaybe<Scalars['Float']>;
};

export type CreateOneUserServicesInput = {
  password?: InputMaybe<CreateOneUserServicesPasswordInput>;
  resume?: InputMaybe<CreateOneUserServicesResumeInput>;
};

export type CreateOneUserServicesPasswordInput = {
  bcrypt?: InputMaybe<Scalars['String']>;
  enroll?: InputMaybe<Scalars['String']>;
  externalId?: InputMaybe<Scalars['String']>;
  reset?: InputMaybe<Scalars['String']>;
};

export type CreateOneUserServicesResumeInput = {
  loginTokens?: InputMaybe<
    Array<InputMaybe<CreateOneUserServicesResumeLoginTokensInput>>
  >;
};

export type CreateOneUserServicesResumeLoginTokensInput = {
  hashedToken?: InputMaybe<Scalars['String']>;
  when?: InputMaybe<Scalars['Date']>;
};

export type CreateOneUserSessionInput = {
  isMobile?: InputMaybe<Scalars['Boolean']>;
};

export type CreateOneZonePolicyInput = {
  name?: InputMaybe<Scalars['String']>;
  properties?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  rules?: InputMaybe<Array<InputMaybe<ZonePolicyRulesInput>>>;
};

export type DataExportJob = {
  __typename: 'DataExportJob';
  _id: Scalars['String'];
  artifacts: Array<DataExportJobArtifact>;
  awsTaskArn?: Maybe<Scalars['String']>;
  completedAt?: Maybe<Scalars['Date']>;
  currentStep?: Maybe<Scalars['String']>;
  endDate: Scalars['Date'];
  errorDetails?: Maybe<Scalars['String']>;
  errorMessage?: Maybe<Scalars['String']>;
  modelChangeOperation?: Maybe<Scalars['String']>;
  modelType?: Maybe<Scalars['String']>;
  progress: Scalars['Float'];
  propertyId: Scalars['String'];
  propertyTitle: Scalars['String'];
  reportTypes: Array<Maybe<Scalars['String']>>;
  requestedByUserId: Scalars['String'];
  s3Bucket?: Maybe<Scalars['String']>;
  s3Key?: Maybe<Scalars['String']>;
  startDate: Scalars['Date'];
  startedAt?: Maybe<Scalars['Date']>;
  status: EnumDataExportJobStatus;
  submittedAt: Scalars['Date'];
  updateDescription?: Maybe<Scalars['JSON']>;
  updatedAt: Scalars['Date'];
};

export type DataExportJobArtifact = {
  __typename?: 'DataExportJobArtifact';
  bucket: Scalars['String'];
  contentType: Scalars['String'];
  key: Scalars['String'];
  kind: Scalars['String'];
};

/** List of items with pagination. */
export type DataExportJobPaginatedDataExportJobs = {
  __typename?: 'DataExportJobPaginatedDataExportJobs';
  /** Total object count. */
  count?: Maybe<Scalars['Int']>;
  /** Array of objects. */
  items?: Maybe<Array<DataExportJob>>;
  /** Information to aid in pagination. */
  pageInfo: PaginationInfo;
};

export type Device = DeviceInterface & {
  __typename: 'Device';
  _id: Scalars['String'];
  alertTypes?: Maybe<DeviceAlertTypes>;
  chartTypes: Array<ChartType>;
  controlled?: Maybe<DeviceControlled>;
  dependentDeviceIds: Array<Maybe<Scalars['String']>>;
  deviceAlerts: Array<Maybe<Alert>>;
  deviceId?: Maybe<Scalars['String']>;
  deviceIdentifier?: Maybe<Scalars['String']>;
  deviceMetrics?: Maybe<Array<Maybe<DeviceMetric>>>;
  hasPendingUpdates: Scalars['Boolean'];
  installation?: Maybe<DeviceInstallation>;
  isConfigured?: Maybe<Scalars['Boolean']>;
  isControlled: Scalars['Boolean'];
  isPoweredOn?: Maybe<Scalars['Boolean']>;
  location?: Maybe<Scalars['String']>;
  meta?: Maybe<DeviceMeta>;
  modelChangeOperation?: Maybe<Scalars['String']>;
  modelType?: Maybe<Scalars['String']>;
  /** The name of the device */
  name?: Maybe<Scalars['String']>;
  panel?: Maybe<Panel>;
  panelId?: Maybe<Scalars['String']>;
  powerState?: Maybe<DevicePowerState>;
  property?: Maybe<Property>;
  propertyId: Scalars['String'];
  source?: Maybe<Source>;
  sourceAlerts: Array<Maybe<Alert>>;
  sourceId?: Maybe<Scalars['String']>;
  timestamp?: Maybe<Scalars['Float']>;
  type?: Maybe<EnumDKeyDeviceType>;
  typeDisplayName: Scalars['String'];
  unit?: Maybe<Unit>;
  unitId: Scalars['String'];
  updateDescription?: Maybe<Scalars['JSON']>;
  updateStatus?: Maybe<Scalars['Boolean']>;
  vpp?: Maybe<VirtualPowerPlant>;
  vppId?: Maybe<Scalars['String']>;
  zone?: Maybe<Zone>;
  zoneId?: Maybe<Scalars['String']>;
};

export type DeviceDeviceAlertsArgs = {
  filter?: InputMaybe<FilterFindManyAlertInput>;
  limit?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<SortFindManyAlertInput>;
};

export type DeviceSourceAlertsArgs = {
  filter?: InputMaybe<FilterFindManyAlertInput>;
  limit?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<SortFindManyAlertInput>;
};

export type DeviceAlertTypes = {
  __typename?: 'DeviceAlertTypes';
  deviceAlert?: Maybe<Scalars['Boolean']>;
  deviceMetric?: Maybe<Scalars['Boolean']>;
  deviceOffline?: Maybe<Scalars['Boolean']>;
  equipmentAlarm?: Maybe<Scalars['Boolean']>;
  sourceOffline?: Maybe<Scalars['Boolean']>;
};

export type DeviceControlled = {
  __typename?: 'DeviceControlled';
  id?: Maybe<Scalars['String']>;
  observedAt?: Maybe<Scalars['Float']>;
  previousId?: Maybe<Scalars['String']>;
  timestamp?: Maybe<Scalars['Float']>;
  units?: Maybe<Scalars['String']>;
  updatePending?: Maybe<Scalars['Boolean']>;
  value?: Maybe<Scalars['Boolean']>;
};

export type DeviceEditsInput = {
  name?: InputMaybe<Scalars['String']>;
};

export type DeviceInstallation = {
  __typename?: 'DeviceInstallation';
  count?: Maybe<Scalars['Float']>;
  message?: Maybe<Scalars['String']>;
  paired?: Maybe<Scalars['Boolean']>;
  pairedTo?: Maybe<Scalars['String']>;
  previousStatus?: Maybe<Scalars['String']>;
  rawDeviceId?: Maybe<Scalars['String']>;
  replacingDeviceId?: Maybe<Scalars['String']>;
  status: Scalars['Float'];
};

export type DeviceInterface = {
  _id: Scalars['String'];
  alertTypes?: Maybe<DeviceAlertTypes>;
  chartTypes: Array<ChartType>;
  controlled?: Maybe<DeviceControlled>;
  dependentDeviceIds: Array<Maybe<Scalars['String']>>;
  deviceAlerts: Array<Maybe<Alert>>;
  deviceId?: Maybe<Scalars['String']>;
  deviceIdentifier?: Maybe<Scalars['String']>;
  deviceMetrics?: Maybe<Array<Maybe<DeviceMetric>>>;
  hasPendingUpdates: Scalars['Boolean'];
  installation?: Maybe<DeviceInstallation>;
  isConfigured?: Maybe<Scalars['Boolean']>;
  isControlled: Scalars['Boolean'];
  isPoweredOn?: Maybe<Scalars['Boolean']>;
  location?: Maybe<Scalars['String']>;
  meta?: Maybe<DeviceMeta>;
  modelChangeOperation?: Maybe<Scalars['String']>;
  modelType?: Maybe<Scalars['String']>;
  /** The name of the device */
  name?: Maybe<Scalars['String']>;
  panel?: Maybe<Panel>;
  panelId?: Maybe<Scalars['String']>;
  powerState?: Maybe<DevicePowerState>;
  property?: Maybe<Property>;
  propertyId: Scalars['String'];
  source?: Maybe<Source>;
  sourceAlerts: Array<Maybe<Alert>>;
  sourceId?: Maybe<Scalars['String']>;
  timestamp?: Maybe<Scalars['Float']>;
  type?: Maybe<EnumDKeyDeviceType>;
  typeDisplayName: Scalars['String'];
  unit?: Maybe<Unit>;
  unitId: Scalars['String'];
  updateDescription?: Maybe<Scalars['JSON']>;
  updateStatus?: Maybe<Scalars['Boolean']>;
  vpp?: Maybe<VirtualPowerPlant>;
  vppId?: Maybe<Scalars['String']>;
  zone?: Maybe<Zone>;
  zoneId?: Maybe<Scalars['String']>;
};

export type DeviceInterfaceDeviceAlertsArgs = {
  filter?: InputMaybe<FilterFindManyAlertInput>;
  limit?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<SortFindManyAlertInput>;
};

export type DeviceInterfaceSourceAlertsArgs = {
  filter?: InputMaybe<FilterFindManyAlertInput>;
  limit?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<SortFindManyAlertInput>;
};

export type DeviceMeta = {
  __typename?: 'DeviceMeta';
  city_id?: Maybe<Scalars['String']>;
  display?: Maybe<DeviceMetaDisplay>;
  localAddr?: Maybe<Scalars['String']>;
  local_addr?: Maybe<Scalars['String']>;
  location?: Maybe<Scalars['String']>;
  loopType?: Maybe<Scalars['String']>;
  manufacturer?: Maybe<Scalars['String']>;
  metrics?: Maybe<Scalars['JSON']>;
  model?: Maybe<Scalars['String']>;
  modelNumber?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  plmActive?: Maybe<Scalars['Boolean']>;
  remoteSensorId?: Maybe<Scalars['String']>;
  remoteSensorOperating?: Maybe<Scalars['Boolean']>;
  serialNumber?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
  version?: Maybe<Scalars['String']>;
};

export type DeviceMetaDisplay = {
  __typename?: 'DeviceMetaDisplay';
  humidity?: Maybe<Scalars['Float']>;
  temperature?: Maybe<Scalars['Float']>;
};

export type DeviceMetric = {
  __typename?: 'DeviceMetric';
  key: Scalars['String'];
  value: DeviceMetricSpec;
};

export type DeviceMetricSpec = {
  __typename?: 'DeviceMetricSpec';
  allowedValues?: Maybe<Array<Scalars['String']>>;
  defaultUnit?: Maybe<Scalars['String']>;
  defaultValue?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  displayValue?: Maybe<Scalars['String']>;
  readOnly?: Maybe<Scalars['Boolean']>;
  streamId?: Maybe<Scalars['String']>;
  timestamp?: Maybe<Scalars['String']>;
  unit?: Maybe<Scalars['String']>;
  units?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['String']>;
  valueStep?: Maybe<Scalars['Float']>;
  valueType?: Maybe<Scalars['String']>;
};

export type DevicePowerState = {
  __typename?: 'DevicePowerState';
  id?: Maybe<Scalars['String']>;
  observedAt?: Maybe<Scalars['Float']>;
  previousId?: Maybe<Scalars['String']>;
  timestamp?: Maybe<Scalars['Float']>;
  units?: Maybe<Scalars['String']>;
  updatePending?: Maybe<Scalars['Boolean']>;
  value?: Maybe<EnumDevicePowerStateValue>;
};

export type DeviceReading = {
  __typename: 'DeviceReading';
  _id: Scalars['String'];
  dateTime: Scalars['Float'];
  deviceUid: Scalars['String'];
  measurementType: Scalars['String'];
  modelChangeOperation?: Maybe<Scalars['String']>;
  modelType?: Maybe<Scalars['String']>;
  series: EnumDeviceReadingSeries;
  sourceId: Scalars['String'];
  updateDescription?: Maybe<Scalars['JSON']>;
  value: Scalars['Float'];
};

export type DeviceReadingNumeric = {
  __typename?: 'DeviceReadingNumeric';
  timestamp?: Maybe<Scalars['String']>;
  units?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['Float']>;
};

/** List of items with pagination. */
export type DeviceReadingPaginatedDeviceReadings = {
  __typename?: 'DeviceReadingPaginatedDeviceReadings';
  /** Total object count. */
  count?: Maybe<Scalars['Int']>;
  /** Array of objects. */
  items?: Maybe<Array<DeviceReading>>;
  /** Information to aid in pagination. */
  pageInfo: PaginationInfo;
};

export type DoorSensor = DeviceInterface & {
  __typename: 'DoorSensor';
  _id: Scalars['String'];
  alertTypes?: Maybe<DeviceAlertTypes>;
  chartTypes: Array<ChartType>;
  contactState?: Maybe<DoorSensorContactState>;
  controlled?: Maybe<DeviceControlled>;
  dependentDeviceIds: Array<Maybe<Scalars['String']>>;
  deviceAlerts: Array<Maybe<Alert>>;
  deviceId?: Maybe<Scalars['String']>;
  deviceIdentifier?: Maybe<Scalars['String']>;
  deviceMetrics?: Maybe<Array<Maybe<DeviceMetric>>>;
  displayName?: Maybe<Scalars['String']>;
  hasContactState?: Maybe<Scalars['Boolean']>;
  hasPendingUpdates: Scalars['Boolean'];
  installation?: Maybe<DeviceInstallation>;
  isConfigured?: Maybe<Scalars['Boolean']>;
  isControlled: Scalars['Boolean'];
  isPoweredOn?: Maybe<Scalars['Boolean']>;
  location?: Maybe<Scalars['String']>;
  meta?: Maybe<DeviceMeta>;
  modelChangeOperation?: Maybe<Scalars['String']>;
  modelType?: Maybe<Scalars['String']>;
  /** The name of the device */
  name?: Maybe<Scalars['String']>;
  panel?: Maybe<Panel>;
  panelId?: Maybe<Scalars['String']>;
  powerState?: Maybe<DevicePowerState>;
  property?: Maybe<Property>;
  propertyId: Scalars['String'];
  source?: Maybe<Source>;
  sourceAlerts: Array<Maybe<Alert>>;
  sourceId?: Maybe<Scalars['String']>;
  timestamp?: Maybe<Scalars['Float']>;
  type?: Maybe<EnumDKeyDeviceType>;
  typeDisplayName: Scalars['String'];
  unit?: Maybe<Unit>;
  unitId: Scalars['String'];
  updateDescription?: Maybe<Scalars['JSON']>;
  updateStatus?: Maybe<Scalars['Boolean']>;
  voltage?: Maybe<DoorSensorVoltage>;
  vpp?: Maybe<VirtualPowerPlant>;
  vppId?: Maybe<Scalars['String']>;
  zone?: Maybe<Zone>;
  zoneId?: Maybe<Scalars['String']>;
};

export type DoorSensorDeviceAlertsArgs = {
  filter?: InputMaybe<FilterFindManyAlertInput>;
  limit?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<SortFindManyAlertInput>;
};

export type DoorSensorSourceAlertsArgs = {
  filter?: InputMaybe<FilterFindManyAlertInput>;
  limit?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<SortFindManyAlertInput>;
};

export type DoorSensorContactState = {
  __typename?: 'DoorSensorContactState';
  id?: Maybe<Scalars['String']>;
  observedAt?: Maybe<Scalars['Float']>;
  previousId?: Maybe<Scalars['String']>;
  timestamp?: Maybe<Scalars['Float']>;
  units?: Maybe<Scalars['String']>;
  updatePending?: Maybe<Scalars['Boolean']>;
  value?: Maybe<Scalars['String']>;
};

export type DoorSensorVoltage = {
  __typename?: 'DoorSensorVoltage';
  id?: Maybe<Scalars['String']>;
  observedAt?: Maybe<Scalars['Float']>;
  previousId?: Maybe<Scalars['String']>;
  timestamp?: Maybe<Scalars['Float']>;
  units?: Maybe<Scalars['String']>;
  updatePending?: Maybe<Scalars['Boolean']>;
  value?: Maybe<Scalars['Float']>;
};

export type EnergyConsumerBuilding = {
  __typename: 'EnergyConsumerBuilding';
  _id: Scalars['String'];
  chartTypes: Array<ChartType>;
  circuitId?: Maybe<Scalars['String']>;
  connected?: Maybe<EnergyConsumerBuildingConnected>;
  converterId?: Maybe<Scalars['String']>;
  disconnectedAt?: Maybe<EnergyConsumerBuildingDisconnectedAt>;
  displayName?: Maybe<Scalars['String']>;
  energyEfficiencyScore?: Maybe<EnergyConsumerBuildingEnergyEfficiencyScore>;
  energySwitchPanelId?: Maybe<Scalars['String']>;
  inverterId?: Maybe<Scalars['String']>;
  lastConnectedAt?: Maybe<EnergyConsumerBuildingLastConnectedAt>;
  location?: Maybe<Scalars['String']>;
  meterId?: Maybe<Scalars['String']>;
  modelChangeOperation?: Maybe<Scalars['String']>;
  modelType?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  occupancy?: Maybe<EnergyConsumerBuildingOccupancy>;
  powerState?: Maybe<EnergyConsumerBuildingPowerState>;
  propertyId?: Maybe<Scalars['String']>;
  tariffRateSell?: Maybe<EnergyConsumerBuildingTariffRateSell>;
  timestamp?: Maybe<Scalars['Float']>;
  unitId?: Maybe<Scalars['String']>;
  updateDescription?: Maybe<Scalars['JSON']>;
  updateStatus?: Maybe<Scalars['Boolean']>;
  vppId?: Maybe<Scalars['String']>;
};

export type EnergyConsumerBuildingConnected = {
  __typename?: 'EnergyConsumerBuildingConnected';
  id?: Maybe<Scalars['String']>;
  observedAt?: Maybe<Scalars['Float']>;
  previousId?: Maybe<Scalars['String']>;
  timestamp?: Maybe<Scalars['Float']>;
  units?: Maybe<Scalars['String']>;
  updatePending?: Maybe<Scalars['Boolean']>;
  value?: Maybe<Scalars['Boolean']>;
};

export type EnergyConsumerBuildingDisconnectedAt = {
  __typename?: 'EnergyConsumerBuildingDisconnectedAt';
  id?: Maybe<Scalars['String']>;
  observedAt?: Maybe<Scalars['Float']>;
  previousId?: Maybe<Scalars['String']>;
  timestamp?: Maybe<Scalars['Float']>;
  units?: Maybe<Scalars['String']>;
  updatePending?: Maybe<Scalars['Boolean']>;
  value?: Maybe<Scalars['Float']>;
};

export type EnergyConsumerBuildingEnergyEfficiencyScore = {
  __typename?: 'EnergyConsumerBuildingEnergyEfficiencyScore';
  id?: Maybe<Scalars['String']>;
  observedAt?: Maybe<Scalars['Float']>;
  previousId?: Maybe<Scalars['String']>;
  timestamp?: Maybe<Scalars['Float']>;
  units?: Maybe<Scalars['String']>;
  updatePending?: Maybe<Scalars['Boolean']>;
  value?: Maybe<Scalars['Float']>;
};

export type EnergyConsumerBuildingLastConnectedAt = {
  __typename?: 'EnergyConsumerBuildingLastConnectedAt';
  id?: Maybe<Scalars['String']>;
  observedAt?: Maybe<Scalars['Float']>;
  previousId?: Maybe<Scalars['String']>;
  timestamp?: Maybe<Scalars['Float']>;
  units?: Maybe<Scalars['String']>;
  updatePending?: Maybe<Scalars['Boolean']>;
  value?: Maybe<Scalars['Float']>;
};

export type EnergyConsumerBuildingOccupancy = {
  __typename?: 'EnergyConsumerBuildingOccupancy';
  id?: Maybe<Scalars['String']>;
  observedAt?: Maybe<Scalars['Float']>;
  previousId?: Maybe<Scalars['String']>;
  timestamp?: Maybe<Scalars['Float']>;
  units?: Maybe<Scalars['String']>;
  updatePending?: Maybe<Scalars['Boolean']>;
  value?: Maybe<Scalars['Float']>;
};

/** List of items with pagination. */
export type EnergyConsumerBuildingPaginatedEnergyConsumerBuildings = {
  __typename?: 'EnergyConsumerBuildingPaginatedEnergyConsumerBuildings';
  /** Total object count. */
  count?: Maybe<Scalars['Int']>;
  /** Array of objects. */
  items?: Maybe<Array<EnergyConsumerBuilding>>;
  /** Information to aid in pagination. */
  pageInfo: PaginationInfo;
};

export type EnergyConsumerBuildingPowerState = {
  __typename?: 'EnergyConsumerBuildingPowerState';
  id?: Maybe<Scalars['String']>;
  observedAt?: Maybe<Scalars['Float']>;
  previousId?: Maybe<Scalars['String']>;
  timestamp?: Maybe<Scalars['Float']>;
  units?: Maybe<Scalars['String']>;
  updatePending?: Maybe<Scalars['Boolean']>;
  value?: Maybe<EnumEnergyConsumerBuildingPowerStateValue>;
};

export type EnergyConsumerBuildingTariffRateSell = {
  __typename?: 'EnergyConsumerBuildingTariffRateSell';
  id?: Maybe<Scalars['String']>;
  observedAt?: Maybe<Scalars['Float']>;
  previousId?: Maybe<Scalars['String']>;
  timestamp?: Maybe<Scalars['Float']>;
  units?: Maybe<Scalars['String']>;
  updatePending?: Maybe<Scalars['Boolean']>;
  value?: Maybe<Scalars['Float']>;
};

export type EnergyConsumerTenant = {
  __typename: 'EnergyConsumerTenant';
  _id: Scalars['String'];
  buildingId?: Maybe<Scalars['String']>;
  chartTypes: Array<ChartType>;
  circuitId?: Maybe<Scalars['String']>;
  connected?: Maybe<EnergyConsumerBuildingConnected>;
  contactName?: Maybe<Scalars['String']>;
  contactPhone?: Maybe<Scalars['String']>;
  converterId?: Maybe<Scalars['String']>;
  disconnectedAt?: Maybe<EnergyConsumerBuildingDisconnectedAt>;
  displayName?: Maybe<Scalars['String']>;
  energyEfficiencyScore?: Maybe<EnergyConsumerTenantEnergyEfficiencyScore>;
  energySwitchPanelId?: Maybe<Scalars['String']>;
  inverterId?: Maybe<Scalars['String']>;
  lastConnectedAt?: Maybe<EnergyConsumerBuildingLastConnectedAt>;
  location?: Maybe<Scalars['String']>;
  meterId?: Maybe<Scalars['String']>;
  modelChangeOperation?: Maybe<Scalars['String']>;
  modelType?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  occupancy?: Maybe<EnergyConsumerTenantOccupancy>;
  powerState?: Maybe<EnergyConsumerBuildingPowerState>;
  propertyId?: Maybe<Scalars['String']>;
  tariffRateSell?: Maybe<EnergyConsumerBuildingTariffRateSell>;
  timestamp?: Maybe<Scalars['Float']>;
  unitId?: Maybe<Scalars['String']>;
  updateDescription?: Maybe<Scalars['JSON']>;
  updateStatus?: Maybe<Scalars['Boolean']>;
  vppId?: Maybe<Scalars['String']>;
};

export type EnergyConsumerTenantEnergyEfficiencyScore = {
  __typename?: 'EnergyConsumerTenantEnergyEfficiencyScore';
  id?: Maybe<Scalars['String']>;
  observedAt?: Maybe<Scalars['Float']>;
  previousId?: Maybe<Scalars['String']>;
  timestamp?: Maybe<Scalars['Float']>;
  units?: Maybe<Scalars['String']>;
  updatePending?: Maybe<Scalars['Boolean']>;
  value?: Maybe<Scalars['Float']>;
};

export type EnergyConsumerTenantOccupancy = {
  __typename?: 'EnergyConsumerTenantOccupancy';
  id?: Maybe<Scalars['String']>;
  observedAt?: Maybe<Scalars['Float']>;
  previousId?: Maybe<Scalars['String']>;
  timestamp?: Maybe<Scalars['Float']>;
  units?: Maybe<Scalars['String']>;
  updatePending?: Maybe<Scalars['Boolean']>;
  value?: Maybe<Scalars['Float']>;
};

/** List of items with pagination. */
export type EnergyConsumerTenantPaginatedEnergyConsumerTenants = {
  __typename?: 'EnergyConsumerTenantPaginatedEnergyConsumerTenants';
  /** Total object count. */
  count?: Maybe<Scalars['Int']>;
  /** Array of objects. */
  items?: Maybe<Array<EnergyConsumerTenant>>;
  /** Information to aid in pagination. */
  pageInfo: PaginationInfo;
};

export type EnergyConsumerUtility = {
  __typename: 'EnergyConsumerUtility';
  _id: Scalars['String'];
  chartTypes: Array<ChartType>;
  circuitId?: Maybe<Scalars['String']>;
  connected?: Maybe<EnergyConsumerBuildingConnected>;
  contractStatus?: Maybe<EnergyConsumerUtilityContractStatus>;
  converterId?: Maybe<Scalars['String']>;
  disconnectedAt?: Maybe<EnergyConsumerBuildingDisconnectedAt>;
  displayName?: Maybe<Scalars['String']>;
  energySwitchPanelId?: Maybe<Scalars['String']>;
  exportAllowance?: Maybe<EnergyConsumerUtilityExportAllowance>;
  gridFrequency?: Maybe<EnergyConsumerUtilityGridFrequency>;
  interconnectionCapacity?: Maybe<EnergyConsumerUtilityInterconnectionCapacity>;
  inverterId?: Maybe<Scalars['String']>;
  lastConnectedAt?: Maybe<EnergyConsumerBuildingLastConnectedAt>;
  location?: Maybe<Scalars['String']>;
  meterId?: Maybe<Scalars['String']>;
  modelChangeOperation?: Maybe<Scalars['String']>;
  modelType?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  powerState?: Maybe<EnergyConsumerBuildingPowerState>;
  propertyId?: Maybe<Scalars['String']>;
  tariffRateSell?: Maybe<EnergyConsumerBuildingTariffRateSell>;
  timestamp?: Maybe<Scalars['Float']>;
  unitId?: Maybe<Scalars['String']>;
  updateDescription?: Maybe<Scalars['JSON']>;
  updateStatus?: Maybe<Scalars['Boolean']>;
  vppId?: Maybe<Scalars['String']>;
};

export type EnergyConsumerUtilityContractStatus = {
  __typename?: 'EnergyConsumerUtilityContractStatus';
  id?: Maybe<Scalars['String']>;
  observedAt?: Maybe<Scalars['Float']>;
  previousId?: Maybe<Scalars['String']>;
  timestamp?: Maybe<Scalars['Float']>;
  units?: Maybe<Scalars['String']>;
  updatePending?: Maybe<Scalars['Boolean']>;
  value?: Maybe<Scalars['String']>;
};

export type EnergyConsumerUtilityExportAllowance = {
  __typename?: 'EnergyConsumerUtilityExportAllowance';
  id?: Maybe<Scalars['String']>;
  observedAt?: Maybe<Scalars['Float']>;
  previousId?: Maybe<Scalars['String']>;
  timestamp?: Maybe<Scalars['Float']>;
  units?: Maybe<Scalars['String']>;
  updatePending?: Maybe<Scalars['Boolean']>;
  value?: Maybe<Scalars['Float']>;
};

export type EnergyConsumerUtilityGridFrequency = {
  __typename?: 'EnergyConsumerUtilityGridFrequency';
  id?: Maybe<Scalars['String']>;
  observedAt?: Maybe<Scalars['Float']>;
  previousId?: Maybe<Scalars['String']>;
  timestamp?: Maybe<Scalars['Float']>;
  units?: Maybe<Scalars['String']>;
  updatePending?: Maybe<Scalars['Boolean']>;
  value?: Maybe<Scalars['Float']>;
};

export type EnergyConsumerUtilityInterconnectionCapacity = {
  __typename?: 'EnergyConsumerUtilityInterconnectionCapacity';
  id?: Maybe<Scalars['String']>;
  observedAt?: Maybe<Scalars['Float']>;
  previousId?: Maybe<Scalars['String']>;
  timestamp?: Maybe<Scalars['Float']>;
  units?: Maybe<Scalars['String']>;
  updatePending?: Maybe<Scalars['Boolean']>;
  value?: Maybe<Scalars['Float']>;
};

/** List of items with pagination. */
export type EnergyConsumerUtilityPaginatedEnergyConsumerUtilities = {
  __typename?: 'EnergyConsumerUtilityPaginatedEnergyConsumerUtilities';
  /** Total object count. */
  count?: Maybe<Scalars['Int']>;
  /** Array of objects. */
  items?: Maybe<Array<EnergyConsumerUtility>>;
  /** Information to aid in pagination. */
  pageInfo: PaginationInfo;
};

export type EnergyController = DeviceInterface & {
  __typename: 'EnergyController';
  _id: Scalars['String'];
  alertTypes?: Maybe<DeviceAlertTypes>;
  availabilityStatus?: Maybe<EnergyControllerAvailabilityStatus>;
  chargeRegulationStatus?: Maybe<EnergyControllerChargeRegulationStatus>;
  chartTypes: Array<ChartType>;
  controlled?: Maybe<DeviceControlled>;
  currentAtMpp?: Maybe<EnergyControllerCurrentAtMpp>;
  currentPowerOutput?: Maybe<Scalars['Float']>;
  dependentDeviceIds: Array<Maybe<Scalars['String']>>;
  deviceAlerts: Array<Maybe<Alert>>;
  deviceId?: Maybe<Scalars['String']>;
  deviceIdentifier?: Maybe<Scalars['String']>;
  deviceMetrics?: Maybe<Array<Maybe<DeviceMetric>>>;
  displayName?: Maybe<Scalars['String']>;
  energyGenerated?: Maybe<EnergyControllerEnergyGenerated>;
  hasPendingUpdates: Scalars['Boolean'];
  installation?: Maybe<DeviceInstallation>;
  isConfigured?: Maybe<Scalars['Boolean']>;
  isControlled: Scalars['Boolean'];
  isPoweredOn?: Maybe<Scalars['Boolean']>;
  location?: Maybe<Scalars['String']>;
  meta?: Maybe<DeviceMeta>;
  modelChangeOperation?: Maybe<Scalars['String']>;
  modelType?: Maybe<Scalars['String']>;
  /** The name of the device */
  name?: Maybe<Scalars['String']>;
  panel?: Maybe<Panel>;
  panelId?: Maybe<Scalars['String']>;
  peakPowerOutput?: Maybe<Scalars['Float']>;
  powerState?: Maybe<DevicePowerState>;
  property?: Maybe<Property>;
  propertyId: Scalars['String'];
  rectifierId?: Maybe<Scalars['String']>;
  rotorSpeedAtMPP?: Maybe<EnergyControllerRotorSpeedAtMpp>;
  source?: Maybe<Source>;
  sourceAlerts: Array<Maybe<Alert>>;
  sourceId?: Maybe<Scalars['String']>;
  timestamp?: Maybe<Scalars['Float']>;
  totalEnergySupplied?: Maybe<Scalars['Float']>;
  type?: Maybe<EnumDKeyDeviceType>;
  typeDisplayName: Scalars['String'];
  unit?: Maybe<Unit>;
  unitId: Scalars['String'];
  updateDescription?: Maybe<Scalars['JSON']>;
  updateStatus?: Maybe<Scalars['Boolean']>;
  voltageAtMpp?: Maybe<EnergyControllerVoltageAtMpp>;
  vpp?: Maybe<VirtualPowerPlant>;
  vppId?: Maybe<Scalars['String']>;
  zone?: Maybe<Zone>;
  zoneId?: Maybe<Scalars['String']>;
};

export type EnergyControllerDeviceAlertsArgs = {
  filter?: InputMaybe<FilterFindManyAlertInput>;
  limit?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<SortFindManyAlertInput>;
};

export type EnergyControllerSourceAlertsArgs = {
  filter?: InputMaybe<FilterFindManyAlertInput>;
  limit?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<SortFindManyAlertInput>;
};

export type EnergyControllerAvailabilityStatus = {
  __typename?: 'EnergyControllerAvailabilityStatus';
  id?: Maybe<Scalars['String']>;
  observedAt?: Maybe<Scalars['Float']>;
  previousId?: Maybe<Scalars['String']>;
  timestamp?: Maybe<Scalars['Float']>;
  units?: Maybe<Scalars['String']>;
  updatePending?: Maybe<Scalars['Boolean']>;
  value?: Maybe<EnumEnergyControllerAvailabilityStatusValue>;
};

export type EnergyControllerChargeRegulationStatus = {
  __typename?: 'EnergyControllerChargeRegulationStatus';
  id?: Maybe<Scalars['String']>;
  observedAt?: Maybe<Scalars['Float']>;
  previousId?: Maybe<Scalars['String']>;
  timestamp?: Maybe<Scalars['Float']>;
  units?: Maybe<Scalars['String']>;
  updatePending?: Maybe<Scalars['Boolean']>;
  value?: Maybe<EnumEnergyControllerChargeRegulationStatusValue>;
};

export type EnergyControllerCurrentAtMpp = {
  __typename?: 'EnergyControllerCurrentAtMpp';
  id?: Maybe<Scalars['String']>;
  observedAt?: Maybe<Scalars['Float']>;
  previousId?: Maybe<Scalars['String']>;
  timestamp?: Maybe<Scalars['Float']>;
  units?: Maybe<Scalars['String']>;
  updatePending?: Maybe<Scalars['Boolean']>;
  value?: Maybe<Scalars['Float']>;
};

export type EnergyControllerEnergyGenerated = {
  __typename?: 'EnergyControllerEnergyGenerated';
  id?: Maybe<Scalars['String']>;
  observedAt?: Maybe<Scalars['Float']>;
  previousId?: Maybe<Scalars['String']>;
  timestamp?: Maybe<Scalars['Float']>;
  units?: Maybe<Scalars['String']>;
  updatePending?: Maybe<Scalars['Boolean']>;
  value?: Maybe<Scalars['Float']>;
};

export type EnergyControllerRotorSpeedAtMpp = {
  __typename?: 'EnergyControllerRotorSpeedAtMPP';
  id?: Maybe<Scalars['String']>;
  observedAt?: Maybe<Scalars['Float']>;
  previousId?: Maybe<Scalars['String']>;
  timestamp?: Maybe<Scalars['Float']>;
  units?: Maybe<Scalars['String']>;
  updatePending?: Maybe<Scalars['Boolean']>;
  value?: Maybe<Scalars['Float']>;
};

export type EnergyControllerVoltageAtMpp = {
  __typename?: 'EnergyControllerVoltageAtMpp';
  id?: Maybe<Scalars['String']>;
  observedAt?: Maybe<Scalars['Float']>;
  previousId?: Maybe<Scalars['String']>;
  timestamp?: Maybe<Scalars['Float']>;
  units?: Maybe<Scalars['String']>;
  updatePending?: Maybe<Scalars['Boolean']>;
  value?: Maybe<Scalars['Float']>;
};

export type EnergyConverter = DeviceInterface & {
  __typename: 'EnergyConverter';
  _id: Scalars['String'];
  alertTypes?: Maybe<DeviceAlertTypes>;
  chargeRate?: Maybe<EnergyConverterChargeRate>;
  chartTypes: Array<ChartType>;
  controlled?: Maybe<DeviceControlled>;
  dependentDeviceIds: Array<Maybe<Scalars['String']>>;
  deviceAlerts: Array<Maybe<Alert>>;
  deviceId?: Maybe<Scalars['String']>;
  deviceIdentifier?: Maybe<Scalars['String']>;
  deviceMetrics?: Maybe<Array<Maybe<DeviceMetric>>>;
  dischargeRate?: Maybe<EnergyConverterDischargeRate>;
  displayName?: Maybe<Scalars['String']>;
  efficiency?: Maybe<EnergyConverterEfficiency>;
  hasPendingUpdates: Scalars['Boolean'];
  inputVoltage?: Maybe<EnergyConverterInputVoltage>;
  installation?: Maybe<DeviceInstallation>;
  isConfigured?: Maybe<Scalars['Boolean']>;
  isControlled: Scalars['Boolean'];
  isPoweredOn?: Maybe<Scalars['Boolean']>;
  location?: Maybe<Scalars['String']>;
  meta?: Maybe<DeviceMeta>;
  modelChangeOperation?: Maybe<Scalars['String']>;
  modelType?: Maybe<Scalars['String']>;
  /** The name of the device */
  name?: Maybe<Scalars['String']>;
  outputVoltage?: Maybe<EnergyConverterOutputVoltage>;
  panel?: Maybe<Panel>;
  panelId?: Maybe<Scalars['String']>;
  powerOutput?: Maybe<EnergyConverterPowerOutput>;
  powerState?: Maybe<DevicePowerState>;
  property?: Maybe<Property>;
  propertyId: Scalars['String'];
  source?: Maybe<Source>;
  sourceAlerts: Array<Maybe<Alert>>;
  sourceId?: Maybe<Scalars['String']>;
  timestamp?: Maybe<Scalars['Float']>;
  type?: Maybe<EnumDKeyDeviceType>;
  typeDisplayName: Scalars['String'];
  unit?: Maybe<Unit>;
  unitId: Scalars['String'];
  updateDescription?: Maybe<Scalars['JSON']>;
  updateStatus?: Maybe<Scalars['Boolean']>;
  vpp?: Maybe<VirtualPowerPlant>;
  vppId?: Maybe<Scalars['String']>;
  zone?: Maybe<Zone>;
  zoneId?: Maybe<Scalars['String']>;
};

export type EnergyConverterDeviceAlertsArgs = {
  filter?: InputMaybe<FilterFindManyAlertInput>;
  limit?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<SortFindManyAlertInput>;
};

export type EnergyConverterSourceAlertsArgs = {
  filter?: InputMaybe<FilterFindManyAlertInput>;
  limit?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<SortFindManyAlertInput>;
};

export type EnergyConverterChargeRate = {
  __typename?: 'EnergyConverterChargeRate';
  id?: Maybe<Scalars['String']>;
  observedAt?: Maybe<Scalars['Float']>;
  previousId?: Maybe<Scalars['String']>;
  timestamp?: Maybe<Scalars['Float']>;
  units?: Maybe<Scalars['String']>;
  updatePending?: Maybe<Scalars['Boolean']>;
  value?: Maybe<Scalars['Float']>;
};

export type EnergyConverterDischargeRate = {
  __typename?: 'EnergyConverterDischargeRate';
  id?: Maybe<Scalars['String']>;
  observedAt?: Maybe<Scalars['Float']>;
  previousId?: Maybe<Scalars['String']>;
  timestamp?: Maybe<Scalars['Float']>;
  units?: Maybe<Scalars['String']>;
  updatePending?: Maybe<Scalars['Boolean']>;
  value?: Maybe<Scalars['Float']>;
};

export type EnergyConverterEfficiency = {
  __typename?: 'EnergyConverterEfficiency';
  id?: Maybe<Scalars['String']>;
  observedAt?: Maybe<Scalars['Float']>;
  previousId?: Maybe<Scalars['String']>;
  timestamp?: Maybe<Scalars['Float']>;
  units?: Maybe<Scalars['String']>;
  updatePending?: Maybe<Scalars['Boolean']>;
  value?: Maybe<Scalars['Float']>;
};

export type EnergyConverterInputVoltage = {
  __typename?: 'EnergyConverterInputVoltage';
  id?: Maybe<Scalars['String']>;
  observedAt?: Maybe<Scalars['Float']>;
  previousId?: Maybe<Scalars['String']>;
  timestamp?: Maybe<Scalars['Float']>;
  units?: Maybe<Scalars['String']>;
  updatePending?: Maybe<Scalars['Boolean']>;
  value?: Maybe<Scalars['Float']>;
};

export type EnergyConverterOutputVoltage = {
  __typename?: 'EnergyConverterOutputVoltage';
  id?: Maybe<Scalars['String']>;
  observedAt?: Maybe<Scalars['Float']>;
  previousId?: Maybe<Scalars['String']>;
  timestamp?: Maybe<Scalars['Float']>;
  units?: Maybe<Scalars['String']>;
  updatePending?: Maybe<Scalars['Boolean']>;
  value?: Maybe<Scalars['Float']>;
};

export type EnergyConverterPowerOutput = {
  __typename?: 'EnergyConverterPowerOutput';
  id?: Maybe<Scalars['String']>;
  observedAt?: Maybe<Scalars['Float']>;
  previousId?: Maybe<Scalars['String']>;
  timestamp?: Maybe<Scalars['Float']>;
  units?: Maybe<Scalars['String']>;
  updatePending?: Maybe<Scalars['Boolean']>;
  value?: Maybe<Scalars['Float']>;
};

export type EnergyInverter = DeviceInterface & {
  __typename: 'EnergyInverter';
  _id: Scalars['String'];
  alertTypes?: Maybe<DeviceAlertTypes>;
  availabilityStatus?: Maybe<EnergyInverterAvailabilityStatus>;
  chargeRate?: Maybe<EnergyInverterChargeRate>;
  chartTypes: Array<ChartType>;
  controlled?: Maybe<DeviceControlled>;
  controllerId?: Maybe<Scalars['String']>;
  dependentDeviceIds: Array<Maybe<Scalars['String']>>;
  deviceAlerts: Array<Maybe<Alert>>;
  deviceId?: Maybe<Scalars['String']>;
  deviceIdentifier?: Maybe<Scalars['String']>;
  deviceMetrics?: Maybe<Array<Maybe<DeviceMetric>>>;
  dischargeRate?: Maybe<EnergyInverterDischargeRate>;
  displayName?: Maybe<Scalars['String']>;
  efficiency?: Maybe<EnergyInverterEfficiency>;
  frequency?: Maybe<EnergyInverterFrequency>;
  hasPendingUpdates: Scalars['Boolean'];
  installation?: Maybe<DeviceInstallation>;
  inverterTemperature?: Maybe<EnergyInverterInverterTemperature>;
  isConfigured?: Maybe<Scalars['Boolean']>;
  isControlled: Scalars['Boolean'];
  isPoweredOn?: Maybe<Scalars['Boolean']>;
  location?: Maybe<Scalars['String']>;
  meta?: Maybe<DeviceMeta>;
  modelChangeOperation?: Maybe<Scalars['String']>;
  modelType?: Maybe<Scalars['String']>;
  /** The name of the device */
  name?: Maybe<Scalars['String']>;
  panel?: Maybe<Panel>;
  panelId?: Maybe<Scalars['String']>;
  powerInputBattery?: Maybe<EnergyInverterPowerInputBattery>;
  powerInputKinetic?: Maybe<EnergyInverterPowerInputKinetic>;
  powerOutput?: Maybe<EnergyInverterPowerOutput>;
  powerRating?: Maybe<EnergyInverterPowerRating>;
  powerState?: Maybe<DevicePowerState>;
  property?: Maybe<Property>;
  propertyId: Scalars['String'];
  reactivePower?: Maybe<EnergyInverterReactivePower>;
  rectifierId?: Maybe<Scalars['String']>;
  source?: Maybe<Source>;
  sourceAlerts: Array<Maybe<Alert>>;
  sourceId?: Maybe<Scalars['String']>;
  timestamp?: Maybe<Scalars['Float']>;
  type?: Maybe<EnumDKeyDeviceType>;
  typeDisplayName: Scalars['String'];
  unit?: Maybe<Unit>;
  unitId: Scalars['String'];
  updateDescription?: Maybe<Scalars['JSON']>;
  updateStatus?: Maybe<Scalars['Boolean']>;
  voltageOutput?: Maybe<EnergyInverterVoltageOutput>;
  vpp?: Maybe<VirtualPowerPlant>;
  vppId?: Maybe<Scalars['String']>;
  zone?: Maybe<Zone>;
  zoneId?: Maybe<Scalars['String']>;
};

export type EnergyInverterDeviceAlertsArgs = {
  filter?: InputMaybe<FilterFindManyAlertInput>;
  limit?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<SortFindManyAlertInput>;
};

export type EnergyInverterSourceAlertsArgs = {
  filter?: InputMaybe<FilterFindManyAlertInput>;
  limit?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<SortFindManyAlertInput>;
};

export type EnergyInverterAvailabilityStatus = {
  __typename?: 'EnergyInverterAvailabilityStatus';
  id?: Maybe<Scalars['String']>;
  observedAt?: Maybe<Scalars['Float']>;
  previousId?: Maybe<Scalars['String']>;
  timestamp?: Maybe<Scalars['Float']>;
  units?: Maybe<Scalars['String']>;
  updatePending?: Maybe<Scalars['Boolean']>;
  value?: Maybe<EnumEnergyInverterAvailabilityStatusValue>;
};

export type EnergyInverterChargeRate = {
  __typename?: 'EnergyInverterChargeRate';
  id?: Maybe<Scalars['String']>;
  observedAt?: Maybe<Scalars['Float']>;
  previousId?: Maybe<Scalars['String']>;
  timestamp?: Maybe<Scalars['Float']>;
  units?: Maybe<Scalars['String']>;
  updatePending?: Maybe<Scalars['Boolean']>;
  value?: Maybe<Scalars['Float']>;
};

export type EnergyInverterDischargeRate = {
  __typename?: 'EnergyInverterDischargeRate';
  id?: Maybe<Scalars['String']>;
  observedAt?: Maybe<Scalars['Float']>;
  previousId?: Maybe<Scalars['String']>;
  timestamp?: Maybe<Scalars['Float']>;
  units?: Maybe<Scalars['String']>;
  updatePending?: Maybe<Scalars['Boolean']>;
  value?: Maybe<Scalars['Float']>;
};

export type EnergyInverterEfficiency = {
  __typename?: 'EnergyInverterEfficiency';
  id?: Maybe<Scalars['String']>;
  observedAt?: Maybe<Scalars['Float']>;
  previousId?: Maybe<Scalars['String']>;
  timestamp?: Maybe<Scalars['Float']>;
  units?: Maybe<Scalars['String']>;
  updatePending?: Maybe<Scalars['Boolean']>;
  value?: Maybe<Scalars['Float']>;
};

export type EnergyInverterFrequency = {
  __typename?: 'EnergyInverterFrequency';
  id?: Maybe<Scalars['String']>;
  observedAt?: Maybe<Scalars['Float']>;
  previousId?: Maybe<Scalars['String']>;
  timestamp?: Maybe<Scalars['Float']>;
  units?: Maybe<Scalars['String']>;
  updatePending?: Maybe<Scalars['Boolean']>;
  value?: Maybe<Scalars['Float']>;
};

export type EnergyInverterInverterTemperature = {
  __typename?: 'EnergyInverterInverterTemperature';
  id?: Maybe<Scalars['String']>;
  observedAt?: Maybe<Scalars['Float']>;
  previousId?: Maybe<Scalars['String']>;
  timestamp?: Maybe<Scalars['Float']>;
  units?: Maybe<Scalars['String']>;
  updatePending?: Maybe<Scalars['Boolean']>;
  value?: Maybe<Scalars['Float']>;
};

export type EnergyInverterPowerInputBattery = {
  __typename?: 'EnergyInverterPowerInputBattery';
  id?: Maybe<Scalars['String']>;
  observedAt?: Maybe<Scalars['Float']>;
  previousId?: Maybe<Scalars['String']>;
  timestamp?: Maybe<Scalars['Float']>;
  units?: Maybe<Scalars['String']>;
  updatePending?: Maybe<Scalars['Boolean']>;
  value?: Maybe<Scalars['Float']>;
};

export type EnergyInverterPowerInputKinetic = {
  __typename?: 'EnergyInverterPowerInputKinetic';
  id?: Maybe<Scalars['String']>;
  observedAt?: Maybe<Scalars['Float']>;
  previousId?: Maybe<Scalars['String']>;
  timestamp?: Maybe<Scalars['Float']>;
  units?: Maybe<Scalars['String']>;
  updatePending?: Maybe<Scalars['Boolean']>;
  value?: Maybe<Scalars['Float']>;
};

export type EnergyInverterPowerOutput = {
  __typename?: 'EnergyInverterPowerOutput';
  id?: Maybe<Scalars['String']>;
  observedAt?: Maybe<Scalars['Float']>;
  previousId?: Maybe<Scalars['String']>;
  timestamp?: Maybe<Scalars['Float']>;
  units?: Maybe<Scalars['String']>;
  updatePending?: Maybe<Scalars['Boolean']>;
  value?: Maybe<Scalars['Float']>;
};

export type EnergyInverterPowerRating = {
  __typename?: 'EnergyInverterPowerRating';
  id?: Maybe<Scalars['String']>;
  observedAt?: Maybe<Scalars['Float']>;
  previousId?: Maybe<Scalars['String']>;
  timestamp?: Maybe<Scalars['Float']>;
  units?: Maybe<Scalars['String']>;
  updatePending?: Maybe<Scalars['Boolean']>;
  value?: Maybe<Scalars['Float']>;
};

export type EnergyInverterReactivePower = {
  __typename?: 'EnergyInverterReactivePower';
  id?: Maybe<Scalars['String']>;
  observedAt?: Maybe<Scalars['Float']>;
  previousId?: Maybe<Scalars['String']>;
  timestamp?: Maybe<Scalars['Float']>;
  units?: Maybe<Scalars['String']>;
  updatePending?: Maybe<Scalars['Boolean']>;
  value?: Maybe<Scalars['Float']>;
};

export type EnergyInverterVoltageOutput = {
  __typename?: 'EnergyInverterVoltageOutput';
  id?: Maybe<Scalars['String']>;
  observedAt?: Maybe<Scalars['Float']>;
  previousId?: Maybe<Scalars['String']>;
  timestamp?: Maybe<Scalars['Float']>;
  units?: Maybe<Scalars['String']>;
  updatePending?: Maybe<Scalars['Boolean']>;
  value?: Maybe<Scalars['Float']>;
};

export type EnergyMeter = DeviceInterface & {
  __typename: 'EnergyMeter';
  _id: Scalars['String'];
  alertTypes?: Maybe<DeviceAlertTypes>;
  chartTypes: Array<ChartType>;
  controlled?: Maybe<DeviceControlled>;
  current?: Maybe<EnergyMeterCurrent>;
  dependentDeviceIds: Array<Maybe<Scalars['String']>>;
  deviceAlerts: Array<Maybe<Alert>>;
  deviceId?: Maybe<Scalars['String']>;
  deviceIdentifier?: Maybe<Scalars['String']>;
  deviceMetrics?: Maybe<Array<Maybe<DeviceMetric>>>;
  displayName?: Maybe<Scalars['String']>;
  energyConsumed?: Maybe<EnergyMeterEnergyConsumed>;
  frequency?: Maybe<EnergyMeterFrequency>;
  hasPendingUpdates: Scalars['Boolean'];
  installation?: Maybe<DeviceInstallation>;
  isConfigured?: Maybe<Scalars['Boolean']>;
  isControlled: Scalars['Boolean'];
  isPoweredOn?: Maybe<Scalars['Boolean']>;
  location?: Maybe<Scalars['String']>;
  meta?: Maybe<DeviceMeta>;
  modelChangeOperation?: Maybe<Scalars['String']>;
  modelType?: Maybe<Scalars['String']>;
  /** The name of the device */
  name?: Maybe<Scalars['String']>;
  outputEnabled?: Maybe<EnergyMeterOutputEnabled>;
  panel?: Maybe<Panel>;
  panelId?: Maybe<Scalars['String']>;
  powerDemand?: Maybe<EnergyMeterPowerDemand>;
  powerFactor?: Maybe<EnergyMeterPowerFactor>;
  powerState?: Maybe<DevicePowerState>;
  property?: Maybe<Property>;
  propertyId: Scalars['String'];
  source?: Maybe<Source>;
  sourceAlerts: Array<Maybe<Alert>>;
  sourceId?: Maybe<Scalars['String']>;
  timestamp?: Maybe<Scalars['Float']>;
  type?: Maybe<EnumDKeyDeviceType>;
  typeDisplayName: Scalars['String'];
  unit?: Maybe<Unit>;
  unitId: Scalars['String'];
  updateDescription?: Maybe<Scalars['JSON']>;
  updateStatus?: Maybe<Scalars['Boolean']>;
  voltage?: Maybe<EnergyMeterVoltage>;
  vpp?: Maybe<VirtualPowerPlant>;
  vppId?: Maybe<Scalars['String']>;
  zone?: Maybe<Zone>;
  zoneId?: Maybe<Scalars['String']>;
};

export type EnergyMeterDeviceAlertsArgs = {
  filter?: InputMaybe<FilterFindManyAlertInput>;
  limit?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<SortFindManyAlertInput>;
};

export type EnergyMeterSourceAlertsArgs = {
  filter?: InputMaybe<FilterFindManyAlertInput>;
  limit?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<SortFindManyAlertInput>;
};

export type EnergyMeterCurrent = {
  __typename?: 'EnergyMeterCurrent';
  id?: Maybe<Scalars['String']>;
  observedAt?: Maybe<Scalars['Float']>;
  previousId?: Maybe<Scalars['String']>;
  timestamp?: Maybe<Scalars['Float']>;
  units?: Maybe<Scalars['String']>;
  updatePending?: Maybe<Scalars['Boolean']>;
  value?: Maybe<Scalars['Float']>;
};

export type EnergyMeterEnergyConsumed = {
  __typename?: 'EnergyMeterEnergyConsumed';
  id?: Maybe<Scalars['String']>;
  observedAt?: Maybe<Scalars['Float']>;
  previousId?: Maybe<Scalars['String']>;
  timestamp?: Maybe<Scalars['Float']>;
  units?: Maybe<Scalars['String']>;
  updatePending?: Maybe<Scalars['Boolean']>;
  value?: Maybe<Scalars['Float']>;
};

export type EnergyMeterFrequency = {
  __typename?: 'EnergyMeterFrequency';
  id?: Maybe<Scalars['String']>;
  observedAt?: Maybe<Scalars['Float']>;
  previousId?: Maybe<Scalars['String']>;
  timestamp?: Maybe<Scalars['Float']>;
  units?: Maybe<Scalars['String']>;
  updatePending?: Maybe<Scalars['Boolean']>;
  value?: Maybe<Scalars['Float']>;
};

export type EnergyMeterOutputEnabled = {
  __typename?: 'EnergyMeterOutputEnabled';
  id?: Maybe<Scalars['String']>;
  observedAt?: Maybe<Scalars['Float']>;
  previousId?: Maybe<Scalars['String']>;
  timestamp?: Maybe<Scalars['Float']>;
  units?: Maybe<Scalars['String']>;
  updatePending?: Maybe<Scalars['Boolean']>;
  value?: Maybe<Scalars['Boolean']>;
};

export type EnergyMeterPowerDemand = {
  __typename?: 'EnergyMeterPowerDemand';
  id?: Maybe<Scalars['String']>;
  observedAt?: Maybe<Scalars['Float']>;
  previousId?: Maybe<Scalars['String']>;
  timestamp?: Maybe<Scalars['Float']>;
  units?: Maybe<Scalars['String']>;
  updatePending?: Maybe<Scalars['Boolean']>;
  value?: Maybe<Scalars['Float']>;
};

export type EnergyMeterPowerFactor = {
  __typename?: 'EnergyMeterPowerFactor';
  id?: Maybe<Scalars['String']>;
  observedAt?: Maybe<Scalars['Float']>;
  previousId?: Maybe<Scalars['String']>;
  timestamp?: Maybe<Scalars['Float']>;
  units?: Maybe<Scalars['String']>;
  updatePending?: Maybe<Scalars['Boolean']>;
  value?: Maybe<Scalars['Float']>;
};

export type EnergyMeterVoltage = {
  __typename?: 'EnergyMeterVoltage';
  id?: Maybe<Scalars['String']>;
  observedAt?: Maybe<Scalars['Float']>;
  previousId?: Maybe<Scalars['String']>;
  timestamp?: Maybe<Scalars['Float']>;
  units?: Maybe<Scalars['String']>;
  updatePending?: Maybe<Scalars['Boolean']>;
  value?: Maybe<Scalars['Float']>;
};

export type EnergyRectifier = DeviceInterface & {
  __typename: 'EnergyRectifier';
  _id: Scalars['String'];
  alertTypes?: Maybe<DeviceAlertTypes>;
  chartTypes: Array<ChartType>;
  controlled?: Maybe<DeviceControlled>;
  dependentDeviceIds: Array<Maybe<Scalars['String']>>;
  deviceAlerts: Array<Maybe<Alert>>;
  deviceId?: Maybe<Scalars['String']>;
  deviceIdentifier?: Maybe<Scalars['String']>;
  deviceMetrics?: Maybe<Array<Maybe<DeviceMetric>>>;
  displayName?: Maybe<Scalars['String']>;
  hasPendingUpdates: Scalars['Boolean'];
  installation?: Maybe<DeviceInstallation>;
  isConfigured?: Maybe<Scalars['Boolean']>;
  isControlled: Scalars['Boolean'];
  isPoweredOn?: Maybe<Scalars['Boolean']>;
  location?: Maybe<Scalars['String']>;
  meta?: Maybe<DeviceMeta>;
  modelChangeOperation?: Maybe<Scalars['String']>;
  modelType?: Maybe<Scalars['String']>;
  /** The name of the device */
  name?: Maybe<Scalars['String']>;
  outputVoltage?: Maybe<EnergyRectifierOutputVoltage>;
  panel?: Maybe<Panel>;
  panelId?: Maybe<Scalars['String']>;
  powerState?: Maybe<DevicePowerState>;
  property?: Maybe<Property>;
  propertyId: Scalars['String'];
  rectifierEfficiency?: Maybe<EnergyRectifierRectifierEfficiency>;
  source?: Maybe<Source>;
  sourceAlerts: Array<Maybe<Alert>>;
  sourceId?: Maybe<Scalars['String']>;
  timestamp?: Maybe<Scalars['Float']>;
  type?: Maybe<EnumDKeyDeviceType>;
  typeDisplayName: Scalars['String'];
  unit?: Maybe<Unit>;
  unitId: Scalars['String'];
  updateDescription?: Maybe<Scalars['JSON']>;
  updateStatus?: Maybe<Scalars['Boolean']>;
  vpp?: Maybe<VirtualPowerPlant>;
  vppId?: Maybe<Scalars['String']>;
  zone?: Maybe<Zone>;
  zoneId?: Maybe<Scalars['String']>;
};

export type EnergyRectifierDeviceAlertsArgs = {
  filter?: InputMaybe<FilterFindManyAlertInput>;
  limit?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<SortFindManyAlertInput>;
};

export type EnergyRectifierSourceAlertsArgs = {
  filter?: InputMaybe<FilterFindManyAlertInput>;
  limit?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<SortFindManyAlertInput>;
};

export type EnergyRectifierOutputVoltage = {
  __typename?: 'EnergyRectifierOutputVoltage';
  id?: Maybe<Scalars['String']>;
  observedAt?: Maybe<Scalars['Float']>;
  previousId?: Maybe<Scalars['String']>;
  timestamp?: Maybe<Scalars['Float']>;
  units?: Maybe<Scalars['String']>;
  updatePending?: Maybe<Scalars['Boolean']>;
  value?: Maybe<Scalars['Float']>;
};

export type EnergyRectifierRectifierEfficiency = {
  __typename?: 'EnergyRectifierRectifierEfficiency';
  id?: Maybe<Scalars['String']>;
  observedAt?: Maybe<Scalars['Float']>;
  previousId?: Maybe<Scalars['String']>;
  timestamp?: Maybe<Scalars['Float']>;
  units?: Maybe<Scalars['String']>;
  updatePending?: Maybe<Scalars['Boolean']>;
  value?: Maybe<Scalars['Float']>;
};

export type EnergyStorageBatterySystem = {
  __typename: 'EnergyStorageBatterySystem';
  _id: Scalars['String'];
  batteryManagementSystemId?: Maybe<Scalars['String']>;
  chartTypes: Array<ChartType>;
  connected?: Maybe<EnergyConsumerBuildingConnected>;
  controllerId?: Maybe<Scalars['String']>;
  converterId?: Maybe<Scalars['String']>;
  coolingSystemId?: Maybe<Scalars['String']>;
  disconnectedAt?: Maybe<EnergyConsumerBuildingDisconnectedAt>;
  displayName?: Maybe<Scalars['String']>;
  fireSuppressionSystemId?: Maybe<Scalars['String']>;
  inverterId?: Maybe<Scalars['String']>;
  lastConnectedAt?: Maybe<EnergyConsumerBuildingLastConnectedAt>;
  location?: Maybe<Scalars['String']>;
  maintenanceScheduleStatus?: Maybe<EnergyStorageBatterySystemMaintenanceScheduleStatus>;
  maximumEnergyCapacity?: Maybe<EnergyStorageBatterySystemMaximumEnergyCapacity>;
  modeOfOperation?: Maybe<EnergyStorageBatterySystemModeOfOperation>;
  modelChangeOperation?: Maybe<Scalars['String']>;
  modelType?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  powerState?: Maybe<EnergyConsumerBuildingPowerState>;
  propertyId?: Maybe<Scalars['String']>;
  timestamp?: Maybe<Scalars['Float']>;
  unitId?: Maybe<Scalars['String']>;
  updateDescription?: Maybe<Scalars['JSON']>;
  updateStatus?: Maybe<Scalars['Boolean']>;
  vppId?: Maybe<Scalars['String']>;
};

export type EnergyStorageBatterySystemMaintenanceScheduleStatus = {
  __typename?: 'EnergyStorageBatterySystemMaintenanceScheduleStatus';
  id?: Maybe<Scalars['String']>;
  observedAt?: Maybe<Scalars['Float']>;
  previousId?: Maybe<Scalars['String']>;
  timestamp?: Maybe<Scalars['Float']>;
  units?: Maybe<Scalars['String']>;
  updatePending?: Maybe<Scalars['Boolean']>;
  value?: Maybe<EnumEnergyStorageBatterySystemMaintenanceScheduleStatusValue>;
};

export type EnergyStorageBatterySystemMaximumEnergyCapacity = {
  __typename?: 'EnergyStorageBatterySystemMaximumEnergyCapacity';
  id?: Maybe<Scalars['String']>;
  observedAt?: Maybe<Scalars['Float']>;
  previousId?: Maybe<Scalars['String']>;
  timestamp?: Maybe<Scalars['Float']>;
  units?: Maybe<Scalars['String']>;
  updatePending?: Maybe<Scalars['Boolean']>;
  value?: Maybe<Scalars['Float']>;
};

export type EnergyStorageBatterySystemModeOfOperation = {
  __typename?: 'EnergyStorageBatterySystemModeOfOperation';
  id?: Maybe<Scalars['String']>;
  observedAt?: Maybe<Scalars['Float']>;
  previousId?: Maybe<Scalars['String']>;
  timestamp?: Maybe<Scalars['Float']>;
  units?: Maybe<Scalars['String']>;
  updatePending?: Maybe<Scalars['Boolean']>;
  value?: Maybe<EnumEnergyStorageBatterySystemModeOfOperationValue>;
};

/** List of items with pagination. */
export type EnergyStorageBatterySystemPaginatedEnergyStorageBatterySystems = {
  __typename?: 'EnergyStorageBatterySystemPaginatedEnergyStorageBatterySystems';
  /** Total object count. */
  count?: Maybe<Scalars['Int']>;
  /** Array of objects. */
  items?: Maybe<Array<EnergyStorageBatterySystem>>;
  /** Information to aid in pagination. */
  pageInfo: PaginationInfo;
};

export type EnergyStorageCoolingSystem = DeviceInterface & {
  __typename: 'EnergyStorageCoolingSystem';
  _id: Scalars['String'];
  alertTypes?: Maybe<DeviceAlertTypes>;
  chartTypes: Array<ChartType>;
  controlled?: Maybe<DeviceControlled>;
  coolingHeatingStatus?: Maybe<EnergyStorageCoolingSystemCoolingHeatingStatus>;
  dependentDeviceIds: Array<Maybe<Scalars['String']>>;
  deviceAlerts: Array<Maybe<Alert>>;
  deviceId?: Maybe<Scalars['String']>;
  deviceIdentifier?: Maybe<Scalars['String']>;
  deviceMetrics?: Maybe<Array<Maybe<DeviceMetric>>>;
  displayName?: Maybe<Scalars['String']>;
  hasPendingUpdates: Scalars['Boolean'];
  installation?: Maybe<DeviceInstallation>;
  isConfigured?: Maybe<Scalars['Boolean']>;
  isControlled: Scalars['Boolean'];
  isPoweredOn?: Maybe<Scalars['Boolean']>;
  location?: Maybe<Scalars['String']>;
  meta?: Maybe<DeviceMeta>;
  modelChangeOperation?: Maybe<Scalars['String']>;
  modelType?: Maybe<Scalars['String']>;
  /** The name of the device */
  name?: Maybe<Scalars['String']>;
  panel?: Maybe<Panel>;
  panelId?: Maybe<Scalars['String']>;
  powerState?: Maybe<DevicePowerState>;
  property?: Maybe<Property>;
  propertyId: Scalars['String'];
  source?: Maybe<Source>;
  sourceAlerts: Array<Maybe<Alert>>;
  sourceId?: Maybe<Scalars['String']>;
  temperature?: Maybe<EnergyStorageCoolingSystemTemperature>;
  timestamp?: Maybe<Scalars['Float']>;
  type?: Maybe<EnumDKeyDeviceType>;
  typeDisplayName: Scalars['String'];
  unit?: Maybe<Unit>;
  unitId: Scalars['String'];
  updateDescription?: Maybe<Scalars['JSON']>;
  updateStatus?: Maybe<Scalars['Boolean']>;
  vpp?: Maybe<VirtualPowerPlant>;
  vppId?: Maybe<Scalars['String']>;
  zone?: Maybe<Zone>;
  zoneId?: Maybe<Scalars['String']>;
};

export type EnergyStorageCoolingSystemDeviceAlertsArgs = {
  filter?: InputMaybe<FilterFindManyAlertInput>;
  limit?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<SortFindManyAlertInput>;
};

export type EnergyStorageCoolingSystemSourceAlertsArgs = {
  filter?: InputMaybe<FilterFindManyAlertInput>;
  limit?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<SortFindManyAlertInput>;
};

export type EnergyStorageCoolingSystemCoolingHeatingStatus = {
  __typename?: 'EnergyStorageCoolingSystemCoolingHeatingStatus';
  id?: Maybe<Scalars['String']>;
  observedAt?: Maybe<Scalars['Float']>;
  previousId?: Maybe<Scalars['String']>;
  timestamp?: Maybe<Scalars['Float']>;
  units?: Maybe<Scalars['String']>;
  updatePending?: Maybe<Scalars['Boolean']>;
  value?: Maybe<EnumEnergyStorageCoolingSystemCoolingHeatingStatusValue>;
};

export type EnergyStorageCoolingSystemTemperature = {
  __typename?: 'EnergyStorageCoolingSystemTemperature';
  id?: Maybe<Scalars['String']>;
  observedAt?: Maybe<Scalars['Float']>;
  previousId?: Maybe<Scalars['String']>;
  timestamp?: Maybe<Scalars['Float']>;
  units?: Maybe<Scalars['String']>;
  updatePending?: Maybe<Scalars['Boolean']>;
  value?: Maybe<Scalars['Float']>;
};

export type EnergyStorageKineticSystem = {
  __typename: 'EnergyStorageKineticSystem';
  _id: Scalars['String'];
  chartTypes: Array<ChartType>;
  connected?: Maybe<EnergyConsumerBuildingConnected>;
  controllerId?: Maybe<Scalars['String']>;
  converterId?: Maybe<Scalars['String']>;
  coolingSystemId?: Maybe<Scalars['String']>;
  disconnectedAt?: Maybe<EnergyConsumerBuildingDisconnectedAt>;
  displayName?: Maybe<Scalars['String']>;
  fireSuppressionSystemId?: Maybe<Scalars['String']>;
  inverterId?: Maybe<Scalars['String']>;
  kemsId?: Maybe<Scalars['String']>;
  lastConnectedAt?: Maybe<EnergyConsumerBuildingLastConnectedAt>;
  location?: Maybe<Scalars['String']>;
  maintenanceScheduleStatus?: Maybe<EnergyStorageBatterySystemMaintenanceScheduleStatus>;
  maximumEnergyCapacity?: Maybe<EnergyStorageBatterySystemMaximumEnergyCapacity>;
  modeOfOperation?: Maybe<EnergyStorageBatterySystemModeOfOperation>;
  modelChangeOperation?: Maybe<Scalars['String']>;
  modelType?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  powerState?: Maybe<EnergyConsumerBuildingPowerState>;
  propertyId?: Maybe<Scalars['String']>;
  timestamp?: Maybe<Scalars['Float']>;
  unitId?: Maybe<Scalars['String']>;
  updateDescription?: Maybe<Scalars['JSON']>;
  updateStatus?: Maybe<Scalars['Boolean']>;
  vppId?: Maybe<Scalars['String']>;
};

/** List of items with pagination. */
export type EnergyStorageKineticSystemPaginatedEnergyStorageKineticSystems = {
  __typename?: 'EnergyStorageKineticSystemPaginatedEnergyStorageKineticSystems';
  /** Total object count. */
  count?: Maybe<Scalars['Int']>;
  /** Array of objects. */
  items?: Maybe<Array<EnergyStorageKineticSystem>>;
  /** Information to aid in pagination. */
  pageInfo: PaginationInfo;
};

export type EnergySupplierSolarSystem = {
  __typename: 'EnergySupplierSolarSystem';
  _id: Scalars['String'];
  azimuth?: Maybe<EnergySupplierSolarSystemAzimuth>;
  chartTypes: Array<ChartType>;
  connected?: Maybe<EnergyConsumerBuildingConnected>;
  controllerId?: Maybe<Scalars['String']>;
  disconnectedAt?: Maybe<EnergyConsumerBuildingDisconnectedAt>;
  displayName?: Maybe<Scalars['String']>;
  inverterId?: Maybe<Scalars['String']>;
  lastConnectedAt?: Maybe<EnergyConsumerBuildingLastConnectedAt>;
  location?: Maybe<Scalars['String']>;
  maximumPowerOutput?: Maybe<Scalars['Float']>;
  modelChangeOperation?: Maybe<Scalars['String']>;
  modelType?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  powerState?: Maybe<EnergyConsumerBuildingPowerState>;
  propertyId?: Maybe<Scalars['String']>;
  smsId?: Maybe<Scalars['String']>;
  tiltAngle?: Maybe<EnergySupplierSolarSystemTiltAngle>;
  timestamp?: Maybe<Scalars['Float']>;
  unitId?: Maybe<Scalars['String']>;
  updateDescription?: Maybe<Scalars['JSON']>;
  updateStatus?: Maybe<Scalars['Boolean']>;
  vppId?: Maybe<Scalars['String']>;
};

export type EnergySupplierSolarSystemAzimuth = {
  __typename?: 'EnergySupplierSolarSystemAzimuth';
  id?: Maybe<Scalars['String']>;
  observedAt?: Maybe<Scalars['Float']>;
  previousId?: Maybe<Scalars['String']>;
  timestamp?: Maybe<Scalars['Float']>;
  units?: Maybe<Scalars['String']>;
  updatePending?: Maybe<Scalars['Boolean']>;
  value?: Maybe<Scalars['Float']>;
};

/** List of items with pagination. */
export type EnergySupplierSolarSystemPaginatedEnergySupplierSolarSystems = {
  __typename?: 'EnergySupplierSolarSystemPaginatedEnergySupplierSolarSystems';
  /** Total object count. */
  count?: Maybe<Scalars['Int']>;
  /** Array of objects. */
  items?: Maybe<Array<EnergySupplierSolarSystem>>;
  /** Information to aid in pagination. */
  pageInfo: PaginationInfo;
};

export type EnergySupplierSolarSystemTiltAngle = {
  __typename?: 'EnergySupplierSolarSystemTiltAngle';
  id?: Maybe<Scalars['String']>;
  observedAt?: Maybe<Scalars['Float']>;
  previousId?: Maybe<Scalars['String']>;
  timestamp?: Maybe<Scalars['Float']>;
  units?: Maybe<Scalars['String']>;
  updatePending?: Maybe<Scalars['Boolean']>;
  value?: Maybe<Scalars['Float']>;
};

export type EnergySupplierUtility = {
  __typename: 'EnergySupplierUtility';
  _id: Scalars['String'];
  chartTypes: Array<ChartType>;
  connected?: Maybe<EnergyConsumerBuildingConnected>;
  contractedCapacity?: Maybe<EnergySupplierUtilityContractedCapacity>;
  controllerId?: Maybe<Scalars['String']>;
  disconnectedAt?: Maybe<EnergyConsumerBuildingDisconnectedAt>;
  displayName?: Maybe<Scalars['String']>;
  inverterId?: Maybe<Scalars['String']>;
  lastConnectedAt?: Maybe<EnergyConsumerBuildingLastConnectedAt>;
  location?: Maybe<Scalars['String']>;
  maximumPowerOutput?: Maybe<Scalars['Float']>;
  meteringAccuracy?: Maybe<EnergySupplierUtilityMeteringAccuracy>;
  modelChangeOperation?: Maybe<Scalars['String']>;
  modelType?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  powerState?: Maybe<EnergyConsumerBuildingPowerState>;
  propertyId?: Maybe<Scalars['String']>;
  tariffRate?: Maybe<EnergySupplierUtilityTariffRate>;
  timestamp?: Maybe<Scalars['Float']>;
  unitId?: Maybe<Scalars['String']>;
  updateDescription?: Maybe<Scalars['JSON']>;
  updateStatus?: Maybe<Scalars['Boolean']>;
  vppId?: Maybe<Scalars['String']>;
};

export type EnergySupplierUtilityContractedCapacity = {
  __typename?: 'EnergySupplierUtilityContractedCapacity';
  id?: Maybe<Scalars['String']>;
  observedAt?: Maybe<Scalars['Float']>;
  previousId?: Maybe<Scalars['String']>;
  timestamp?: Maybe<Scalars['Float']>;
  units?: Maybe<Scalars['String']>;
  updatePending?: Maybe<Scalars['Boolean']>;
  value?: Maybe<Scalars['Float']>;
};

export type EnergySupplierUtilityMeteringAccuracy = {
  __typename?: 'EnergySupplierUtilityMeteringAccuracy';
  id?: Maybe<Scalars['String']>;
  observedAt?: Maybe<Scalars['Float']>;
  previousId?: Maybe<Scalars['String']>;
  timestamp?: Maybe<Scalars['Float']>;
  units?: Maybe<Scalars['String']>;
  updatePending?: Maybe<Scalars['Boolean']>;
  value?: Maybe<Scalars['Float']>;
};

/** List of items with pagination. */
export type EnergySupplierUtilityPaginatedEnergySupplierUtilities = {
  __typename?: 'EnergySupplierUtilityPaginatedEnergySupplierUtilities';
  /** Total object count. */
  count?: Maybe<Scalars['Int']>;
  /** Array of objects. */
  items?: Maybe<Array<EnergySupplierUtility>>;
  /** Information to aid in pagination. */
  pageInfo: PaginationInfo;
};

export type EnergySupplierUtilityTariffRate = {
  __typename?: 'EnergySupplierUtilityTariffRate';
  id?: Maybe<Scalars['String']>;
  observedAt?: Maybe<Scalars['Float']>;
  previousId?: Maybe<Scalars['String']>;
  timestamp?: Maybe<Scalars['Float']>;
  units?: Maybe<Scalars['String']>;
  updatePending?: Maybe<Scalars['Boolean']>;
  value?: Maybe<Scalars['Float']>;
};

export type EnergySupplierWindSystem = {
  __typename: 'EnergySupplierWindSystem';
  _id: Scalars['String'];
  chartTypes: Array<ChartType>;
  connected?: Maybe<EnergyConsumerBuildingConnected>;
  controllerId?: Maybe<Scalars['String']>;
  cutInSpeed?: Maybe<EnergySupplierWindSystemCutInSpeed>;
  cutOutSpeed?: Maybe<EnergySupplierWindSystemCutOutSpeed>;
  disconnectedAt?: Maybe<EnergyConsumerBuildingDisconnectedAt>;
  displayName?: Maybe<Scalars['String']>;
  inverterId?: Maybe<Scalars['String']>;
  lastConnectedAt?: Maybe<EnergyConsumerBuildingLastConnectedAt>;
  location?: Maybe<Scalars['String']>;
  maximumPowerOutput?: Maybe<Scalars['Float']>;
  modeOfOperation?: Maybe<EnergySupplierWindSystemModeOfOperation>;
  modelChangeOperation?: Maybe<Scalars['String']>;
  modelType?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  powerState?: Maybe<EnergyConsumerBuildingPowerState>;
  propertyId?: Maybe<Scalars['String']>;
  rectifierId?: Maybe<Scalars['String']>;
  timestamp?: Maybe<Scalars['Float']>;
  unitId?: Maybe<Scalars['String']>;
  updateDescription?: Maybe<Scalars['JSON']>;
  updateStatus?: Maybe<Scalars['Boolean']>;
  vppId?: Maybe<Scalars['String']>;
  wmsId?: Maybe<Scalars['String']>;
};

export type EnergySupplierWindSystemCutInSpeed = {
  __typename?: 'EnergySupplierWindSystemCutInSpeed';
  id?: Maybe<Scalars['String']>;
  observedAt?: Maybe<Scalars['Float']>;
  previousId?: Maybe<Scalars['String']>;
  timestamp?: Maybe<Scalars['Float']>;
  units?: Maybe<Scalars['String']>;
  updatePending?: Maybe<Scalars['Boolean']>;
  value?: Maybe<Scalars['Float']>;
};

export type EnergySupplierWindSystemCutOutSpeed = {
  __typename?: 'EnergySupplierWindSystemCutOutSpeed';
  id?: Maybe<Scalars['String']>;
  observedAt?: Maybe<Scalars['Float']>;
  previousId?: Maybe<Scalars['String']>;
  timestamp?: Maybe<Scalars['Float']>;
  units?: Maybe<Scalars['String']>;
  updatePending?: Maybe<Scalars['Boolean']>;
  value?: Maybe<Scalars['Float']>;
};

export type EnergySupplierWindSystemModeOfOperation = {
  __typename?: 'EnergySupplierWindSystemModeOfOperation';
  id?: Maybe<Scalars['String']>;
  observedAt?: Maybe<Scalars['Float']>;
  previousId?: Maybe<Scalars['String']>;
  timestamp?: Maybe<Scalars['Float']>;
  units?: Maybe<Scalars['String']>;
  updatePending?: Maybe<Scalars['Boolean']>;
  value?: Maybe<EnumEnergySupplierWindSystemModeOfOperationValue>;
};

/** List of items with pagination. */
export type EnergySupplierWindSystemPaginatedEnergySupplierWindSystems = {
  __typename?: 'EnergySupplierWindSystemPaginatedEnergySupplierWindSystems';
  /** Total object count. */
  count?: Maybe<Scalars['Int']>;
  /** Array of objects. */
  items?: Maybe<Array<EnergySupplierWindSystem>>;
  /** Information to aid in pagination. */
  pageInfo: PaginationInfo;
};

export type EnergySwitchPanel = DeviceInterface & {
  __typename: 'EnergySwitchPanel';
  _id: Scalars['String'];
  alertTypes?: Maybe<DeviceAlertTypes>;
  chartTypes: Array<ChartType>;
  controlled?: Maybe<DeviceControlled>;
  dependentDeviceIds: Array<Maybe<Scalars['String']>>;
  deviceAlerts: Array<Maybe<Alert>>;
  deviceId?: Maybe<Scalars['String']>;
  deviceIdentifier?: Maybe<Scalars['String']>;
  deviceMetrics?: Maybe<Array<Maybe<DeviceMetric>>>;
  displayName?: Maybe<Scalars['String']>;
  hasPendingUpdates: Scalars['Boolean'];
  installation?: Maybe<DeviceInstallation>;
  isConfigured?: Maybe<Scalars['Boolean']>;
  isControlled: Scalars['Boolean'];
  isPoweredOn?: Maybe<Scalars['Boolean']>;
  location?: Maybe<Scalars['String']>;
  maxCircuits?: Maybe<Scalars['Float']>;
  meta?: Maybe<DeviceMeta>;
  modelChangeOperation?: Maybe<Scalars['String']>;
  modelType?: Maybe<Scalars['String']>;
  /** The name of the device */
  name?: Maybe<Scalars['String']>;
  panel?: Maybe<Panel>;
  panelId?: Maybe<Scalars['String']>;
  powerInput?: Maybe<EnergySwitchPanelPowerInput>;
  powerState?: Maybe<DevicePowerState>;
  property?: Maybe<Property>;
  propertyId: Scalars['String'];
  source?: Maybe<Source>;
  sourceAlerts: Array<Maybe<Alert>>;
  sourceId?: Maybe<Scalars['String']>;
  timestamp?: Maybe<Scalars['Float']>;
  type?: Maybe<EnumDKeyDeviceType>;
  typeDisplayName: Scalars['String'];
  unit?: Maybe<Unit>;
  unitId: Scalars['String'];
  updateDescription?: Maybe<Scalars['JSON']>;
  updateStatus?: Maybe<Scalars['Boolean']>;
  vpp?: Maybe<VirtualPowerPlant>;
  vppId?: Maybe<Scalars['String']>;
  zone?: Maybe<Zone>;
  zoneId?: Maybe<Scalars['String']>;
};

export type EnergySwitchPanelDeviceAlertsArgs = {
  filter?: InputMaybe<FilterFindManyAlertInput>;
  limit?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<SortFindManyAlertInput>;
};

export type EnergySwitchPanelSourceAlertsArgs = {
  filter?: InputMaybe<FilterFindManyAlertInput>;
  limit?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<SortFindManyAlertInput>;
};

export type EnergySwitchPanelCircuit = DeviceInterface & {
  __typename: 'EnergySwitchPanelCircuit';
  _id: Scalars['String'];
  alertTypes?: Maybe<DeviceAlertTypes>;
  chartTypes: Array<ChartType>;
  controlled?: Maybe<DeviceControlled>;
  current?: Maybe<EnergySwitchPanelCircuitCurrent>;
  dependentDeviceIds: Array<Maybe<Scalars['String']>>;
  deviceAlerts: Array<Maybe<Alert>>;
  deviceId?: Maybe<Scalars['String']>;
  deviceIdentifier?: Maybe<Scalars['String']>;
  deviceMetrics?: Maybe<Array<Maybe<DeviceMetric>>>;
  displayName?: Maybe<Scalars['String']>;
  energyConsumed?: Maybe<EnergySwitchPanelCircuitEnergyConsumed>;
  energySwitchPanelId?: Maybe<Scalars['String']>;
  frequency?: Maybe<EnergySwitchPanelCircuitFrequency>;
  hasPendingUpdates: Scalars['Boolean'];
  installation?: Maybe<DeviceInstallation>;
  isConfigured?: Maybe<Scalars['Boolean']>;
  isControlled: Scalars['Boolean'];
  isPoweredOn?: Maybe<Scalars['Boolean']>;
  location?: Maybe<Scalars['String']>;
  meta?: Maybe<DeviceMeta>;
  modelChangeOperation?: Maybe<Scalars['String']>;
  modelType?: Maybe<Scalars['String']>;
  /** The name of the device */
  name?: Maybe<Scalars['String']>;
  outputEnabled?: Maybe<EnergySwitchPanelCircuitOutputEnabled>;
  panel?: Maybe<Panel>;
  panelId?: Maybe<Scalars['String']>;
  powerDemand?: Maybe<EnergySwitchPanelCircuitPowerDemand>;
  powerFactor?: Maybe<EnergySwitchPanelCircuitPowerFactor>;
  powerState?: Maybe<DevicePowerState>;
  property?: Maybe<Property>;
  propertyId: Scalars['String'];
  source?: Maybe<Source>;
  sourceAlerts: Array<Maybe<Alert>>;
  sourceId?: Maybe<Scalars['String']>;
  timestamp?: Maybe<Scalars['Float']>;
  type?: Maybe<EnumDKeyDeviceType>;
  typeDisplayName: Scalars['String'];
  unit?: Maybe<Unit>;
  unitId: Scalars['String'];
  updateDescription?: Maybe<Scalars['JSON']>;
  updateStatus?: Maybe<Scalars['Boolean']>;
  voltage?: Maybe<EnergySwitchPanelCircuitVoltage>;
  vpp?: Maybe<VirtualPowerPlant>;
  vppId?: Maybe<Scalars['String']>;
  zone?: Maybe<Zone>;
  zoneId?: Maybe<Scalars['String']>;
};

export type EnergySwitchPanelCircuitDeviceAlertsArgs = {
  filter?: InputMaybe<FilterFindManyAlertInput>;
  limit?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<SortFindManyAlertInput>;
};

export type EnergySwitchPanelCircuitSourceAlertsArgs = {
  filter?: InputMaybe<FilterFindManyAlertInput>;
  limit?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<SortFindManyAlertInput>;
};

export type EnergySwitchPanelCircuitCurrent = {
  __typename?: 'EnergySwitchPanelCircuitCurrent';
  id?: Maybe<Scalars['String']>;
  observedAt?: Maybe<Scalars['Float']>;
  previousId?: Maybe<Scalars['String']>;
  timestamp?: Maybe<Scalars['Float']>;
  units?: Maybe<Scalars['String']>;
  updatePending?: Maybe<Scalars['Boolean']>;
  value?: Maybe<Scalars['Float']>;
};

export type EnergySwitchPanelCircuitEnergyConsumed = {
  __typename?: 'EnergySwitchPanelCircuitEnergyConsumed';
  id?: Maybe<Scalars['String']>;
  observedAt?: Maybe<Scalars['Float']>;
  previousId?: Maybe<Scalars['String']>;
  timestamp?: Maybe<Scalars['Float']>;
  units?: Maybe<Scalars['String']>;
  updatePending?: Maybe<Scalars['Boolean']>;
  value?: Maybe<Scalars['Float']>;
};

export type EnergySwitchPanelCircuitFrequency = {
  __typename?: 'EnergySwitchPanelCircuitFrequency';
  id?: Maybe<Scalars['String']>;
  observedAt?: Maybe<Scalars['Float']>;
  previousId?: Maybe<Scalars['String']>;
  timestamp?: Maybe<Scalars['Float']>;
  units?: Maybe<Scalars['String']>;
  updatePending?: Maybe<Scalars['Boolean']>;
  value?: Maybe<Scalars['Float']>;
};

export type EnergySwitchPanelCircuitOutputEnabled = {
  __typename?: 'EnergySwitchPanelCircuitOutputEnabled';
  id?: Maybe<Scalars['String']>;
  observedAt?: Maybe<Scalars['Float']>;
  previousId?: Maybe<Scalars['String']>;
  timestamp?: Maybe<Scalars['Float']>;
  units?: Maybe<Scalars['String']>;
  updatePending?: Maybe<Scalars['Boolean']>;
  value?: Maybe<Scalars['Boolean']>;
};

export type EnergySwitchPanelCircuitPowerDemand = {
  __typename?: 'EnergySwitchPanelCircuitPowerDemand';
  id?: Maybe<Scalars['String']>;
  observedAt?: Maybe<Scalars['Float']>;
  previousId?: Maybe<Scalars['String']>;
  timestamp?: Maybe<Scalars['Float']>;
  units?: Maybe<Scalars['String']>;
  updatePending?: Maybe<Scalars['Boolean']>;
  value?: Maybe<Scalars['Float']>;
};

export type EnergySwitchPanelCircuitPowerFactor = {
  __typename?: 'EnergySwitchPanelCircuitPowerFactor';
  id?: Maybe<Scalars['String']>;
  observedAt?: Maybe<Scalars['Float']>;
  previousId?: Maybe<Scalars['String']>;
  timestamp?: Maybe<Scalars['Float']>;
  units?: Maybe<Scalars['String']>;
  updatePending?: Maybe<Scalars['Boolean']>;
  value?: Maybe<Scalars['Float']>;
};

export type EnergySwitchPanelCircuitVoltage = {
  __typename?: 'EnergySwitchPanelCircuitVoltage';
  id?: Maybe<Scalars['String']>;
  observedAt?: Maybe<Scalars['Float']>;
  previousId?: Maybe<Scalars['String']>;
  timestamp?: Maybe<Scalars['Float']>;
  units?: Maybe<Scalars['String']>;
  updatePending?: Maybe<Scalars['Boolean']>;
  value?: Maybe<Scalars['Float']>;
};

export type EnergySwitchPanelPowerInput = {
  __typename?: 'EnergySwitchPanelPowerInput';
  id?: Maybe<Scalars['String']>;
  observedAt?: Maybe<Scalars['Float']>;
  previousId?: Maybe<Scalars['String']>;
  timestamp?: Maybe<Scalars['Float']>;
  units?: Maybe<Scalars['String']>;
  updatePending?: Maybe<Scalars['Boolean']>;
  value?: Maybe<Scalars['Float']>;
};

export type EntityCriteriaCompoundOperatorInput = {
  criteria: EntitySelectionCriteriaInput;
  id: Scalars['String'];
  invert?: InputMaybe<Scalars['Boolean']>;
  operator: Scalars['String'];
};

export type EntityCriteriaSimpleOperatorInput = {
  criteria: Array<TieredEntitySelectionCriterionInput>;
  id: Scalars['String'];
  invert?: InputMaybe<Scalars['Boolean']>;
  operator: Scalars['String'];
};

export type EntitySelectionCriteriaInput = {
  compoundOperators?: InputMaybe<Array<EntityCriteriaCompoundOperatorInput>>;
  criteria: Array<TieredEntitySelectionCriterionInput>;
  simpleOperators?: InputMaybe<Array<EntityCriteriaSimpleOperatorInput>>;
};

export enum EnumActuatorControlModeValue {
  Auto = 'Auto',
  Hand = 'Hand',
}

export enum EnumAlertNotificationLastDeliveryAttemptStatus {
  Error = 'Error',
  Rejected = 'Rejected',
  Success = 'Success',
  Unattempted = 'Unattempted',
}

export enum EnumAlertNotificationNotificationMethod {
  Email = 'Email',
  Sms = 'SMS',
}

export enum EnumAlertNotificationNotificationType {
  Alert = 'Alert',
  OptInConfirmation = 'OptInConfirmation',
  OptInRejection = 'OptInRejection',
  OptInRequest = 'OptInRequest',
  OptOutConfirmation = 'OptOutConfirmation',
}

export enum EnumAlertOptOutOptOutMethod {
  SmsNo = 'SMS_NO',
  SmsStop = 'SMS_STOP',
}

export enum EnumAlertPropertyContactSmsOptInStatus1 {
  OptedOut = 'opted_out',
  Pending = 'pending',
  Rejected = 'rejected',
  Removed = 'removed',
  Stopped = 'stopped',
  Subscribed = 'subscribed',
  Unsent = 'unsent',
}

export enum EnumAlertPropertyContactSmsOptInStatus2 {
  OptedOut = 'opted_out',
  Pending = 'pending',
  Rejected = 'rejected',
  Removed = 'removed',
  Stopped = 'stopped',
  Subscribed = 'subscribed',
  Unsent = 'unsent',
}

export enum EnumAlertPropertyContactSmsOptInStatus3 {
  OptedOut = 'opted_out',
  Pending = 'pending',
  Rejected = 'rejected',
  Removed = 'removed',
  Stopped = 'stopped',
  Subscribed = 'subscribed',
  Unsent = 'unsent',
}

export enum EnumAlertTriggerTriggerCriteriaBasisType {
  Alert = 'ALERT',
  Device = 'DEVICE',
  Source = 'SOURCE',
}

export enum EnumAlertTriggerTriggerCriteriaSelectionCriteriaCompoundOperatorOperator {
  And = 'AND',
  Nor = 'NOR',
  Or = 'OR',
}

export enum EnumAlertTriggerTriggerCriteriaSelectionCriteriaCriterionComparator {
  EqualTo = 'EQUAL_TO',
  GreaterThan = 'GREATER_THAN',
  GreaterThanOrEqualTo = 'GREATER_THAN_OR_EQUAL_TO',
  InCollection = 'IN_COLLECTION',
  InRange = 'IN_RANGE',
  LessThan = 'LESS_THAN',
  LessThanOrEqualTo = 'LESS_THAN_OR_EQUAL_TO',
  NotEqualTo = 'NOT_EQUAL_TO',
  NotInCollection = 'NOT_IN_COLLECTION',
  NotInRange = 'NOT_IN_RANGE',
}

export enum EnumAlertTriggerTriggerCriteriaSelectionCriteriaCriterionValueType {
  Airflow = 'AIRFLOW',
  Boolean = 'BOOLEAN',
  Date = 'DATE',
  Humidity = 'HUMIDITY',
  Number = 'NUMBER',
  Pressure = 'PRESSURE',
  String = 'STRING',
  Temperature = 'TEMPERATURE',
}

export enum EnumAlertTriggerTriggerCriteriaSelectionCriteriaSimpleOperatorOperator {
  And = 'AND',
  Nor = 'NOR',
  Or = 'OR',
}

export enum EnumAuthenticationProfileFactorsEngine {
  Default = 'DEFAULT',
  Stytch = 'STYTCH',
}

export enum EnumAuthenticationProfileFactorsType {
  Email = 'EMAIL',
  OtpEmail = 'OTP_EMAIL',
  OtpSms = 'OTP_SMS',
  Passkey = 'PASSKEY',
  Password = 'PASSWORD',
  SmartAlexa = 'SMART_ALEXA',
  Totp = 'TOTP',
  WebAuthN = 'WEB_AUTH_N',
}

export enum EnumAuthenticationProfileInitialFactorsEngine {
  Default = 'DEFAULT',
  Stytch = 'STYTCH',
  Unspecified = 'UNSPECIFIED',
}

export enum EnumAuthenticatorDeviceCredentialEcosystem {
  Apple = 'APPLE',
  Google = 'GOOGLE',
  Microsoft = 'MICROSOFT',
  None = 'NONE',
}

export enum EnumAuthenticatorDeviceCredentialOs {
  Android = 'ANDROID',
  Ios = 'IOS',
  Macos = 'MACOS',
  None = 'NONE',
  Windows = 'WINDOWS',
}

export enum EnumControllerController_LoopValue {
  Off = 'Off',
  On = 'On',
}

export enum EnumControllerSupervisor_ControllerValue {
  Off = 'Off',
  On = 'On',
}

export enum EnumDKeyDeviceType {
  Actuator = 'Actuator',
  BatteryManagementSystem = 'BatteryManagementSystem',
  Boiler = 'Boiler',
  Chiller = 'Chiller',
  ConductorGenericSensor = 'ConductorGenericSensor',
  Controller = 'Controller',
  DoorSensor = 'DoorSensor',
  EnergyController = 'EnergyController',
  EnergyConverter = 'EnergyConverter',
  EnergyInverter = 'EnergyInverter',
  EnergyMeter = 'EnergyMeter',
  EnergyRectifier = 'EnergyRectifier',
  EnergyStorageCoolingSystem = 'EnergyStorageCoolingSystem',
  EnergySwitchPanel = 'EnergySwitchPanel',
  EnergySwitchPanelCircuit = 'EnergySwitchPanelCircuit',
  FireSuppressionSystem = 'FireSuppressionSystem',
  Gpio = 'GPIO',
  IndoorAirHandler = 'IndoorAirHandler',
  IndoorSensor = 'IndoorSensor',
  KineticEnergyManagementSystem = 'KineticEnergyManagementSystem',
  LeakDetector = 'LeakDetector',
  Loop = 'Loop',
  ModbusAirHandler = 'ModbusAirHandler',
  OccupancySensor = 'OccupancySensor',
  OpenWeather = 'OpenWeather',
  OutdoorSensor = 'OutdoorSensor',
  PowerMonitor = 'PowerMonitor',
  PressureSensor = 'PressureSensor',
  RelayDevice = 'RelayDevice',
  SmartPowerOutlet = 'SmartPowerOutlet',
  SolarManagementSystem = 'SolarManagementSystem',
  Thermistor = 'Thermistor',
  Thermostat = 'Thermostat',
  VsdPump = 'VSDPump',
  WindManagementSystem = 'WindManagementSystem',
  WindowSensor = 'WindowSensor',
  Z210Pump = 'Z210Pump',
}

export enum EnumDKeySourceType {
  Bng = 'BNG',
  Conductor = 'Conductor',
  Core = 'Core',
  Hmm = 'HMM',
}

export enum EnumDataExportJobStatus {
  Completed = 'completed',
  Failed = 'failed',
  InProgress = 'in_progress',
  Queued = 'queued',
}

export enum EnumDevicePowerStateValue {
  Off = 'Off',
  On = 'On',
}

export enum EnumDeviceReadingSeries {
  Hourly = 'HOURLY',
}

export enum EnumDeviceType {
  Actuator = 'Actuator',
  BatteryManagementSystem = 'BatteryManagementSystem',
  Boiler = 'Boiler',
  Chiller = 'Chiller',
  ConductorGenericSensor = 'ConductorGenericSensor',
  Controller = 'Controller',
  DoorSensor = 'DoorSensor',
  EnergyConsumerBuilding = 'EnergyConsumerBuilding',
  EnergyConsumerTenant = 'EnergyConsumerTenant',
  EnergyConsumerUtility = 'EnergyConsumerUtility',
  EnergyController = 'EnergyController',
  EnergyConverter = 'EnergyConverter',
  EnergyInverter = 'EnergyInverter',
  EnergyMeter = 'EnergyMeter',
  EnergyRectifier = 'EnergyRectifier',
  EnergyStorageCoolingSystem = 'EnergyStorageCoolingSystem',
  EnergySwitchPanel = 'EnergySwitchPanel',
  EnergySwitchPanelCircuit = 'EnergySwitchPanelCircuit',
  FireSuppressionSystem = 'FireSuppressionSystem',
  Gpio = 'GPIO',
  IndoorAirHandler = 'IndoorAirHandler',
  IndoorSensor = 'IndoorSensor',
  KineticEnergyManagementSystem = 'KineticEnergyManagementSystem',
  LeakDetector = 'LeakDetector',
  Loop = 'Loop',
  ModbusAirHandler = 'ModbusAirHandler',
  OccupancySensor = 'OccupancySensor',
  OpenWeather = 'OpenWeather',
  OutdoorSensor = 'OutdoorSensor',
  PowerMonitor = 'PowerMonitor',
  PressureSensor = 'PressureSensor',
  RelayDevice = 'RelayDevice',
  SmartPowerOutlet = 'SmartPowerOutlet',
  SolarManagementSystem = 'SolarManagementSystem',
  Thermistor = 'Thermistor',
  Thermostat = 'Thermostat',
  VsdPump = 'VSDPump',
  WindManagementSystem = 'WindManagementSystem',
  WindowSensor = 'WindowSensor',
  Z210Pump = 'Z210Pump',
}

export enum EnumEnergyConsumerBuildingPowerStateValue {
  Off = 'Off',
  On = 'On',
}

export enum EnumEnergyControllerAvailabilityStatusValue {
  Degraded = 'Degraded',
  Maintenance = 'Maintenance',
  Offline = 'Offline',
  Online = 'Online',
  Standby = 'Standby',
}

export enum EnumEnergyControllerChargeRegulationStatusValue {
  Absorption = 'Absorption',
  Bulk = 'Bulk',
  Equalization = 'Equalization',
  Float = 'Float',
  Off = 'Off',
}

export enum EnumEnergyInverterAvailabilityStatusValue {
  Degraded = 'Degraded',
  Maintenance = 'Maintenance',
  Offline = 'Offline',
  Online = 'Online',
  Standby = 'Standby',
}

export enum EnumEnergyStorageBatterySystemMaintenanceScheduleStatusValue {
  Completed = 'Completed',
  Due = 'Due',
  InProgress = 'InProgress',
  Pending = 'Pending',
}

export enum EnumEnergyStorageBatterySystemModeOfOperationValue {
  Charging = 'Charging',
  Discharging = 'Discharging',
  Fault = 'Fault',
  Idle = 'Idle',
  Maintenance = 'Maintenance',
  SpinningDown = 'SpinningDown',
  SpinningUp = 'SpinningUp',
  Standby = 'Standby',
}

export enum EnumEnergyStorageCoolingSystemCoolingHeatingStatusValue {
  CoolingOn = 'CoolingOn',
  HeatingOn = 'HeatingOn',
  Off = 'Off',
  Standby = 'Standby',
}

export enum EnumEnergySupplierWindSystemModeOfOperationValue {
  Fault = 'Fault',
  Maintenance = 'Maintenance',
  Operating = 'Operating',
  Stopped = 'Stopped',
}

export enum EnumFireSuppressionSystemFireSuppressionStatusValue {
  Active = 'Active',
  Fault = 'Fault',
  Idle = 'Idle',
  MaintenanceRequired = 'MaintenanceRequired',
  PreAlarm = 'PreAlarm',
  Testing = 'Testing',
}

export enum EnumFireSuppressionSystemSensorStatusValue {
  Fault = 'FAULT',
  Heat = 'HEAT',
  Ok = 'OK',
  Smoke = 'SMOKE',
}

export enum EnumHistoricAlertPort {
  NA = 'N_A',
}

export enum EnumHistoricAlertPropertyContactSmsOptInStatus1 {
  OptedOut = 'opted_out',
  Pending = 'pending',
  Rejected = 'rejected',
  Removed = 'removed',
  Stopped = 'stopped',
  Subscribed = 'subscribed',
  Unsent = 'unsent',
}

export enum EnumHistoricAlertPropertyContactSmsOptInStatus2 {
  OptedOut = 'opted_out',
  Pending = 'pending',
  Rejected = 'rejected',
  Removed = 'removed',
  Stopped = 'stopped',
  Subscribed = 'subscribed',
  Unsent = 'unsent',
}

export enum EnumHistoricAlertPropertyContactSmsOptInStatus3 {
  OptedOut = 'opted_out',
  Pending = 'pending',
  Rejected = 'rejected',
  Removed = 'removed',
  Stopped = 'stopped',
  Subscribed = 'subscribed',
  Unsent = 'unsent',
}

export enum EnumIndoorAirHandlerIndoorFanStatusValue {
  Off = 'Off',
  On = 'On',
}

export enum EnumOccupancySensorOccupancyValue {
  Off = 'Off',
  On = 'On',
}

export enum EnumPanelType {
  Device = 'Device',
  Gpio = 'GPIO',
  Loop = 'Loop',
}

export enum EnumPlmContractBaselineMethod {
  AdjustedAvgPrior5DaysBaseline = 'AdjustedAvgPrior5DaysBaseline',
  Average10PriorWeekdaysBaseline = 'Average10PriorWeekdaysBaseline',
  DayOfAdjustmentBaseline = 'DayOfAdjustmentBaseline',
  ManualBaseline = 'ManualBaseline',
  RollingAvgPriorBaseline = 'RollingAvgPriorBaseline',
  SameDayLastWeekBaseline = 'SameDayLastWeekBaseline',
  WeatherNormalizedBaseline = 'WeatherNormalizedBaseline',
}

export enum EnumPlmContractScopeType {
  Meter = 'meter',
  Property = 'property',
}

export enum EnumPlmContractStatus {
  Active = 'active',
  Draft = 'draft',
  Expired = 'expired',
  Terminated = 'terminated',
}

export enum EnumPlmCurtailmentActionDeviceType {
  ModbusAirHandler = 'ModbusAirHandler',
  SmartPowerOutlet = 'SmartPowerOutlet',
  Thermostat = 'Thermostat',
}

export enum EnumPlmCurtailmentPlanApplicableSeasons {
  Summer = 'SUMMER',
  Winter = 'WINTER',
  YearRound = 'YEAR_ROUND',
}

export enum EnumPlmCurtailmentTaskCachedDeviceStateCoolSetpointAdjustmentMode {
  Absolute = 'ABSOLUTE',
  RelativeOffset = 'RELATIVE_OFFSET',
}

export enum EnumPlmCurtailmentTaskCachedDeviceStateHeatSetpointAdjustmentMode {
  Absolute = 'ABSOLUTE',
  RelativeOffset = 'RELATIVE_OFFSET',
}

export enum EnumPlmCurtailmentTaskCachedDeviceStateType {
  ModbusAirHandler = 'ModbusAirHandler',
  SmartPowerOutlet = 'SmartPowerOutlet',
  Thermostat = 'Thermostat',
}

export enum EnumPlmCurtailmentTaskStatus {
  AbortRetry = 'abort_retry',
  Aborted = 'aborted',
  Active = 'active',
  CompleteRetry = 'complete_retry',
  Completed = 'completed',
  Error = 'error',
  ExecuteRetry = 'execute_retry',
  Missed = 'missed',
  Pending = 'pending',
  Scheduled = 'scheduled',
  StoppingAborted = 'stopping_aborted',
  StoppingCompleted = 'stopping_completed',
}

export enum EnumPlmEventNotificationMethod {
  Api = 'api',
  Email = 'email',
  Webhook = 'webhook',
}

export enum EnumPlmEventResponseResponseStatus {
  Aborted = 'aborted',
  Active = 'active',
  Cancelled = 'cancelled',
  Completed = 'completed',
  Created = 'created',
  Declined = 'declined',
  PendingApproval = 'pendingApproval',
  Resumed = 'resumed',
  Scheduled = 'scheduled',
  Suspended = 'suspended',
}

export enum EnumPlmEventStatus {
  Aborted = 'aborted',
  Active = 'active',
  Cancelled = 'cancelled',
  Completed = 'completed',
  Failed = 'failed',
  Planned = 'planned',
  Scheduled = 'scheduled',
}

export enum EnumPlmIngressEventSource {
  Email = 'email',
  Webhook = 'webhook',
}

export enum EnumPlmIngressEventStatus {
  Failed = 'failed',
  Pending = 'pending',
  Processed = 'processed',
}

export enum EnumPlmNotificationParticipationStatus {
  Exempt = 'exempt',
  OptedIn = 'optedIn',
  OptedOut = 'optedOut',
}

export enum EnumPlmNotificationSource {
  Api = 'api',
  Email = 'email',
  Manual = 'manual',
}

export enum EnumPlmPartnerPartnerType {
  Aggregator = 'aggregator',
  Utility = 'utility',
}

export enum EnumPlmProgramParticipationType {
  Mandatory = 'Mandatory',
  OptIn = 'OptIn',
}

export enum EnumPlmProgramSeason {
  Summer = 'Summer',
  Winter = 'Winter',
  YearRound = 'YearRound',
}

export enum EnumPropertyContactSmsOptInStatus1 {
  OptedOut = 'opted_out',
  Pending = 'pending',
  Rejected = 'rejected',
  Removed = 'removed',
  Stopped = 'stopped',
  Subscribed = 'subscribed',
  Unsent = 'unsent',
}

export enum EnumPropertyContactSmsOptInStatus2 {
  OptedOut = 'opted_out',
  Pending = 'pending',
  Rejected = 'rejected',
  Removed = 'removed',
  Stopped = 'stopped',
  Subscribed = 'subscribed',
  Unsent = 'unsent',
}

export enum EnumPropertyContactSmsOptInStatus3 {
  OptedOut = 'opted_out',
  Pending = 'pending',
  Rejected = 'rejected',
  Removed = 'removed',
  Stopped = 'stopped',
  Subscribed = 'subscribed',
  Unsent = 'unsent',
}

export enum EnumScheduleType {
  Custom = 'CUSTOM',
  None = 'NONE',
  SameEveryDay = 'SAME_EVERY_DAY',
  WeekdayWeekend = 'WEEKDAY_WEEKEND',
}

export enum EnumScheduledTaskStatus {
  Cancelled = 'CANCELLED',
  Complete = 'COMPLETE',
  Failed = 'FAILED',
  InProgress = 'IN_PROGRESS',
  Pending = 'PENDING',
}

export enum EnumSetpointProfileType {
  Default = 'default',
}

export enum EnumSetpointProfileUnits {
  C = 'C',
}

export enum EnumSystemNotificationEntityType {
  General = 'General',
  Organization = 'Organization',
  Property = 'Property',
  Unit = 'Unit',
  User = 'User',
}

export enum EnumThermostatDeviceSpecThermostatControlContract {
  CombinedV1 = 'combined_v1',
  SeparatePowerV1 = 'separate_power_v1',
}

export enum EnumThermostatDeviceSpecThermostatSupportedAutoModeType {
  Dual = 'dual',
  None = 'none',
  Single = 'single',
}

export enum EnumThermostatFanModeValue {
  Auto = 'Auto',
  High = 'High',
  Low = 'Low',
  Medium = 'Medium',
  Medium1 = 'Medium1',
  Medium2 = 'Medium2',
  Moderate = 'Moderate',
  On = 'On',
  SmartAhu = 'SmartAHU',
}

export enum EnumThermostatFanSpeedValue {
  Auto = 'Auto',
  High = 'High',
  Low = 'Low',
  Medium = 'Medium',
  Medium1 = 'Medium1',
  Medium2 = 'Medium2',
}

export enum EnumThermostatFanStateValue {
  Off = 'Off',
  On = 'On',
  Stage2 = 'Stage2',
  Stage3 = 'Stage3',
  Unknown = 'Unknown',
}

export enum EnumThermostatHoldStateValue {
  Off = 'Off',
  On = 'On',
}

export enum EnumThermostatOperatingModeValue {
  Auto = 'Auto',
  Cool = 'Cool',
  Fan = 'Fan',
  Heat = 'Heat',
  Off = 'Off',
}

export enum EnumThermostatOperatingStateValue {
  Cooling = 'Cooling',
  Heating = 'Heating',
  Idle = 'Idle',
  Off = 'Off',
  Unknown = 'Unknown',
}

export enum EnumThermostatPairingStateValue {
  PairingActive = 'PAIRING_ACTIVE',
  PairingInactive = 'PAIRING_INACTIVE',
  Unpaired = 'UNPAIRED',
}

export enum EnumThermostatPowerModeValue {
  Off = 'Off',
  On = 'On',
}

export enum EnumThermostatProgModeValue {
  ScheduleMode = 'SCHEDULE_MODE',
  SimpleSetpointMode = 'SIMPLE_SETPOINT_MODE',
}

export enum EnumThermostatSchedVisibilityModeValue {
  SchedProgOff = 'SCHED_PROG_OFF',
  SchedProgOn = 'SCHED_PROG_ON',
}

export enum EnumThermostatSetpointChangeSourceValue {
  ManualChange = 'MANUAL_CHANGE',
  ScheduleChange = 'SCHEDULE_CHANGE',
}

export enum EnumThermostatSystemTypeValue {
  AlternateHeat = 'AlternateHeat',
  CoolOnly = 'CoolOnly',
  HeatAndCool = 'HeatAndCool',
  HeatOnly = 'HeatOnly',
  HeatPump = 'HeatPump',
  HeatWithFan = 'HeatWithFan',
  SmartAhu = 'SmartAHU',
}

export enum EnumThermostatTempDisplayModeValue {
  C = 'C',
  F = 'F',
}

export enum EnumThermostatThermostatControlCommandStatus {
  Confirmed = 'confirmed',
  Pending = 'pending',
  Rejected = 'rejected',
  Unconfirmed = 'unconfirmed',
}

export enum EnumUserProfilePreferredAirFlowUnits {
  Cfm = 'CFM',
  Lps = 'LPS',
}

export enum EnumUserProfilePreferredUnits {
  C = 'C',
  F = 'F',
}

export enum EnumVirtualPowerPlantOperationalStatusValue {
  Active = 'Active',
  Maintenance = 'Maintenance',
  Standby = 'Standby',
}

export enum EnumWindManagementSystemBladeConditionValue {
  Damaged = 'Damaged',
  Normal = 'Normal',
  Worn = 'Worn',
}

export enum EnumWindManagementSystemBrakeStatusValue {
  Off = 'Off',
  On = 'On',
}

export enum EnumWindManagementSystemIceDetectionStatusValue {
  Error = 'Error',
  IceDetected = 'IceDetected',
  NoIce = 'NoIce',
}

export enum EnumWindManagementSystemYawControlStatusValue {
  Adjusting = 'Adjusting',
  Aligned = 'Aligned',
  Error = 'Error',
}

export enum EnumZonePolicyRulesSourceMultiplicity {
  All = 'ALL',
  Any = 'ANY',
}

export enum EnumZonePolicyRulesTargetMultiplicity {
  All = 'ALL',
  Any = 'ANY',
}

export enum EnumZonePolicyRulesType {
  MapReset = 'MAP_RESET',
  Sync = 'SYNC',
}

export type ErrorInterface = {
  /** Generic error message */
  message?: Maybe<Scalars['String']>;
};

export type FilterApplicationInput = {
  _id?: InputMaybe<Scalars['String']>;
};

export type FilterCountActuatorControlModeInput = {
  id?: InputMaybe<Scalars['String']>;
  observedAt?: InputMaybe<Scalars['Float']>;
  previousId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  units?: InputMaybe<Scalars['String']>;
  updatePending?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<EnumActuatorControlModeValue>;
};

export type FilterCountActuatorDefaultPositionInput = {
  id?: InputMaybe<Scalars['String']>;
  observedAt?: InputMaybe<Scalars['Float']>;
  previousId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  units?: InputMaybe<Scalars['String']>;
  updatePending?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<Scalars['Float']>;
};

export type FilterCountActuatorInput = {
  AND?: InputMaybe<Array<FilterCountDeviceInput>>;
  OR?: InputMaybe<Array<FilterCountDeviceInput>>;
  _id?: InputMaybe<Scalars['String']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterCountDeviceOperatorsInput>;
  alertTypes?: InputMaybe<FilterCountDeviceAlertTypesInput>;
  controlMode?: InputMaybe<FilterCountActuatorControlModeInput>;
  controlled?: InputMaybe<FilterCountDeviceControlledInput>;
  defaultPosition?: InputMaybe<FilterCountActuatorDefaultPositionInput>;
  deviceId?: InputMaybe<Scalars['String']>;
  installation?: InputMaybe<FilterCountDeviceInstallationInput>;
  location?: InputMaybe<Scalars['String']>;
  meta?: InputMaybe<FilterCountDeviceMetaInput>;
  /** The name of the device */
  name?: InputMaybe<Scalars['String']>;
  panelId?: InputMaybe<Scalars['String']>;
  position?: InputMaybe<FilterCountActuatorPositionInput>;
  powerState?: InputMaybe<FilterCountDevicePowerStateInput>;
  propertyId?: InputMaybe<Scalars['String']>;
  sourceId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  unitId?: InputMaybe<Scalars['String']>;
  updateStatus?: InputMaybe<Scalars['Boolean']>;
  vppId?: InputMaybe<Scalars['String']>;
  zoneId?: InputMaybe<Scalars['String']>;
};

export type FilterCountActuatorPositionInput = {
  id?: InputMaybe<Scalars['String']>;
  observedAt?: InputMaybe<Scalars['Float']>;
  previousId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  units?: InputMaybe<Scalars['String']>;
  updatePending?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<Scalars['Float']>;
};

export type FilterCountAlertAlertCategoryInput = {
  id?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
};

export type FilterCountAlertAlertTriggerInput = {
  id?: InputMaybe<Scalars['String']>;
  key?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
};

export type FilterCountAlertBuildingInput = {
  id?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
};

export type FilterCountAlertCategoryInput = {
  AND?: InputMaybe<Array<FilterCountAlertCategoryInput>>;
  OR?: InputMaybe<Array<FilterCountAlertCategoryInput>>;
  _id?: InputMaybe<Scalars['String']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterCountAlertCategoryOperatorsInput>;
  description?: InputMaybe<Scalars['String']>;
  key?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  propertyId?: InputMaybe<Scalars['String']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterCountAlertCategoryOperatorsInput = {
  _id?: InputMaybe<FilterCountAlertCategory_IdOperatorsInput>;
  propertyId?: InputMaybe<FilterCountAlertCategoryPropertyIdOperatorsInput>;
};

export type FilterCountAlertCategoryPropertyIdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['String']>;
  gte?: InputMaybe<Scalars['String']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  lt?: InputMaybe<Scalars['String']>;
  lte?: InputMaybe<Scalars['String']>;
  ne?: InputMaybe<Scalars['String']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']>;
};

export type FilterCountAlertCategory_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['String']>;
  gte?: InputMaybe<Scalars['String']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  lt?: InputMaybe<Scalars['String']>;
  lte?: InputMaybe<Scalars['String']>;
  ne?: InputMaybe<Scalars['String']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']>;
};

export type FilterCountAlertDeviceInput = {
  id?: InputMaybe<Scalars['String']>;
  model?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  role?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<Scalars['String']>;
  version?: InputMaybe<Scalars['String']>;
};

export type FilterCountAlertInput = {
  AND?: InputMaybe<Array<FilterCountAlertInput>>;
  OR?: InputMaybe<Array<FilterCountAlertInput>>;
  _id?: InputMaybe<Scalars['String']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterCountAlertOperatorsInput>;
  alertCategory?: InputMaybe<FilterCountAlertAlertCategoryInput>;
  alertTrigger?: InputMaybe<FilterCountAlertAlertTriggerInput>;
  building?: InputMaybe<FilterCountAlertBuildingInput>;
  device?: InputMaybe<FilterCountAlertDeviceInput>;
  id?: InputMaybe<Scalars['String']>;
  initiated?: InputMaybe<Scalars['Float']>;
  meta?: InputMaybe<FilterCountAlertMetaInput>;
  panel?: InputMaybe<FilterCountAlertPanelInput>;
  property?: InputMaybe<FilterCountAlertPropertyInput>;
  sourceId?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<FilterCountAlertTypeInput>;
  unit?: InputMaybe<FilterCountAlertUnitInput>;
  updated?: InputMaybe<Scalars['Float']>;
  zone?: InputMaybe<FilterCountAlertZoneInput>;
};

export type FilterCountAlertMetaInput = {
  id_str?: InputMaybe<Scalars['String']>;
  limit?: InputMaybe<Scalars['Float']>;
  message?: InputMaybe<Scalars['String']>;
  portName?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<Scalars['String']>;
};

export type FilterCountAlertNotificationAlertIdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['String']>;
  gte?: InputMaybe<Scalars['String']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  lt?: InputMaybe<Scalars['String']>;
  lte?: InputMaybe<Scalars['String']>;
  ne?: InputMaybe<Scalars['String']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']>;
};

export type FilterCountAlertNotificationInput = {
  AND?: InputMaybe<Array<FilterCountAlertNotificationInput>>;
  OR?: InputMaybe<Array<FilterCountAlertNotificationInput>>;
  _id?: InputMaybe<Scalars['String']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterCountAlertNotificationOperatorsInput>;
  alertId?: InputMaybe<Scalars['String']>;
  deliveryAttemptCount?: InputMaybe<Scalars['Float']>;
  externalId?: InputMaybe<Scalars['String']>;
  lastDeliveryAttemptStatus?: InputMaybe<EnumAlertNotificationLastDeliveryAttemptStatus>;
  lastDeliveryAttemptTimestamp?: InputMaybe<Scalars['Float']>;
  notificationMethod?: InputMaybe<EnumAlertNotificationNotificationMethod>;
  notificationType?: InputMaybe<EnumAlertNotificationNotificationType>;
  recipient?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterCountAlertNotificationOperatorsInput = {
  _id?: InputMaybe<FilterCountAlertNotification_IdOperatorsInput>;
  alertId?: InputMaybe<FilterCountAlertNotificationAlertIdOperatorsInput>;
};

export type FilterCountAlertNotification_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['String']>;
  gte?: InputMaybe<Scalars['String']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  lt?: InputMaybe<Scalars['String']>;
  lte?: InputMaybe<Scalars['String']>;
  ne?: InputMaybe<Scalars['String']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterCountAlertOperatorsInput = {
  _id?: InputMaybe<FilterCountAlert_IdOperatorsInput>;
  property?: InputMaybe<FilterCountAlertPropertyOperatorsInput>;
  unit?: InputMaybe<FilterCountAlertUnitOperatorsInput>;
};

export type FilterCountAlertOptOutInput = {
  AND?: InputMaybe<Array<FilterCountAlertOptOutInput>>;
  OR?: InputMaybe<Array<FilterCountAlertOptOutInput>>;
  _id?: InputMaybe<Scalars['String']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterCountAlertOptOutOperatorsInput>;
  optOutMethod?: InputMaybe<EnumAlertOptOutOptOutMethod>;
  optOutTimestamp?: InputMaybe<Scalars['Float']>;
  recipient?: InputMaybe<Scalars['String']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterCountAlertOptOutOperatorsInput = {
  _id?: InputMaybe<FilterCountAlertOptOut_IdOperatorsInput>;
  recipient?: InputMaybe<FilterCountAlertOptOutRecipientOperatorsInput>;
};

export type FilterCountAlertOptOutRecipientOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['String']>;
  gte?: InputMaybe<Scalars['String']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  lt?: InputMaybe<Scalars['String']>;
  lte?: InputMaybe<Scalars['String']>;
  ne?: InputMaybe<Scalars['String']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']>;
};

export type FilterCountAlertOptOut_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['String']>;
  gte?: InputMaybe<Scalars['String']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  lt?: InputMaybe<Scalars['String']>;
  lte?: InputMaybe<Scalars['String']>;
  ne?: InputMaybe<Scalars['String']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']>;
};

export type FilterCountAlertPanelInput = {
  id?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
};

export type FilterCountAlertPropertyContactInput = {
  email?: InputMaybe<Scalars['String']>;
  email2?: InputMaybe<Scalars['String']>;
  email3?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  smsNumber?: InputMaybe<Scalars['String']>;
  smsNumber2?: InputMaybe<Scalars['String']>;
  smsNumber3?: InputMaybe<Scalars['String']>;
  smsOptInStatus1?: InputMaybe<EnumAlertPropertyContactSmsOptInStatus1>;
  smsOptInStatus2?: InputMaybe<EnumAlertPropertyContactSmsOptInStatus2>;
  smsOptInStatus3?: InputMaybe<EnumAlertPropertyContactSmsOptInStatus3>;
  smsOptInTimestamp1?: InputMaybe<Scalars['Float']>;
  smsOptInTimestamp2?: InputMaybe<Scalars['Float']>;
  smsOptInTimestamp3?: InputMaybe<Scalars['Float']>;
};

export type FilterCountAlertPropertyIdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['String']>;
  gte?: InputMaybe<Scalars['String']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  lt?: InputMaybe<Scalars['String']>;
  lte?: InputMaybe<Scalars['String']>;
  ne?: InputMaybe<Scalars['String']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']>;
};

export type FilterCountAlertPropertyInput = {
  contact?: InputMaybe<FilterCountAlertPropertyContactInput>;
  id?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
};

export type FilterCountAlertPropertyOperatorsInput = {
  id?: InputMaybe<FilterCountAlertPropertyIdOperatorsInput>;
};

export type FilterCountAlertSubscriptionAlertTriggerIdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['String']>;
  gte?: InputMaybe<Scalars['String']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  lt?: InputMaybe<Scalars['String']>;
  lte?: InputMaybe<Scalars['String']>;
  ne?: InputMaybe<Scalars['String']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']>;
};

export type FilterCountAlertSubscriptionInput = {
  AND?: InputMaybe<Array<FilterCountAlertSubscriptionInput>>;
  OR?: InputMaybe<Array<FilterCountAlertSubscriptionInput>>;
  _id?: InputMaybe<Scalars['String']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterCountAlertSubscriptionOperatorsInput>;
  alertTriggerId?: InputMaybe<Scalars['String']>;
  deviceId?: InputMaybe<Scalars['String']>;
  email?: InputMaybe<Scalars['String']>;
  propertyId?: InputMaybe<Scalars['String']>;
  sms?: InputMaybe<Scalars['String']>;
  unitCategoryId?: InputMaybe<Scalars['String']>;
  unitId?: InputMaybe<Scalars['String']>;
  userId?: InputMaybe<Scalars['String']>;
  viaEmail?: InputMaybe<Scalars['Boolean']>;
  viaSms?: InputMaybe<Scalars['Boolean']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterCountAlertSubscriptionOperatorsInput = {
  _id?: InputMaybe<FilterCountAlertSubscription_IdOperatorsInput>;
  alertTriggerId?: InputMaybe<FilterCountAlertSubscriptionAlertTriggerIdOperatorsInput>;
};

export type FilterCountAlertSubscription_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['String']>;
  gte?: InputMaybe<Scalars['String']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  lt?: InputMaybe<Scalars['String']>;
  lte?: InputMaybe<Scalars['String']>;
  ne?: InputMaybe<Scalars['String']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']>;
};

export type FilterCountAlertTriggerInput = {
  AND?: InputMaybe<Array<FilterCountAlertTriggerInput>>;
  OR?: InputMaybe<Array<FilterCountAlertTriggerInput>>;
  _id?: InputMaybe<Scalars['String']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterCountAlertTriggerOperatorsInput>;
  alertCategoryId?: InputMaybe<Scalars['String']>;
  editMode?: InputMaybe<Scalars['Float']>;
  enabled?: InputMaybe<Scalars['Boolean']>;
  entityTypes?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  key?: InputMaybe<Scalars['String']>;
  legacyKey?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  propertyId?: InputMaybe<Scalars['String']>;
  triggerCriteria?: InputMaybe<FilterCountAlertTriggerTriggerCriteriaInput>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterCountAlertTriggerOperatorsInput = {
  _id?: InputMaybe<FilterCountAlertTrigger_IdOperatorsInput>;
  propertyId?: InputMaybe<FilterCountAlertTriggerPropertyIdOperatorsInput>;
};

export type FilterCountAlertTriggerPropertyIdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['String']>;
  gte?: InputMaybe<Scalars['String']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  lt?: InputMaybe<Scalars['String']>;
  lte?: InputMaybe<Scalars['String']>;
  ne?: InputMaybe<Scalars['String']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']>;
};

export type FilterCountAlertTriggerTriggerCriteriaInput = {
  basisName?: InputMaybe<Scalars['String']>;
  basisType?: InputMaybe<EnumAlertTriggerTriggerCriteriaBasisType>;
  levels?: InputMaybe<Scalars['Float']>;
  selectionCriteria?: InputMaybe<FilterCountAlertTriggerTriggerCriteriaSelectionCriteriaInput>;
};

export type FilterCountAlertTriggerTriggerCriteriaSelectionCriteriaCompoundOperatorInput =
  {
    criteria?: InputMaybe<Scalars['JSON']>;
    id?: InputMaybe<Scalars['String']>;
    operator?: InputMaybe<EnumAlertTriggerTriggerCriteriaSelectionCriteriaCompoundOperatorOperator>;
  };

export type FilterCountAlertTriggerTriggerCriteriaSelectionCriteriaCriterionInput =
  {
    comparator: EnumAlertTriggerTriggerCriteriaSelectionCriteriaCriterionComparator;
    editable?: InputMaybe<Scalars['Boolean']>;
    id: Scalars['String'];
    legacyPath?: InputMaybe<Scalars['String']>;
    selectionPath: Scalars['String'];
    template?: InputMaybe<Scalars['String']>;
    valueType: EnumAlertTriggerTriggerCriteriaSelectionCriteriaCriterionValueType;
    values: Array<InputMaybe<Scalars['String']>>;
  };

export type FilterCountAlertTriggerTriggerCriteriaSelectionCriteriaInput = {
  compoundOperator?: InputMaybe<FilterCountAlertTriggerTriggerCriteriaSelectionCriteriaCompoundOperatorInput>;
  criteria?: InputMaybe<
    Array<
      InputMaybe<FilterCountAlertTriggerTriggerCriteriaSelectionCriteriaCriterionInput>
    >
  >;
  criterion?: InputMaybe<FilterCountAlertTriggerTriggerCriteriaSelectionCriteriaCriterionInput>;
  simpleOperator?: InputMaybe<FilterCountAlertTriggerTriggerCriteriaSelectionCriteriaSimpleOperatorInput>;
};

export type FilterCountAlertTriggerTriggerCriteriaSelectionCriteriaSimpleOperatorInput =
  {
    criteria?: InputMaybe<
      Array<
        InputMaybe<FilterCountAlertTriggerTriggerCriteriaSelectionCriteriaCriterionInput>
      >
    >;
    criterion?: InputMaybe<FilterCountAlertTriggerTriggerCriteriaSelectionCriteriaCriterionInput>;
    id?: InputMaybe<Scalars['String']>;
    operator?: InputMaybe<EnumAlertTriggerTriggerCriteriaSelectionCriteriaSimpleOperatorOperator>;
  };

export type FilterCountAlertTrigger_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['String']>;
  gte?: InputMaybe<Scalars['String']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  lt?: InputMaybe<Scalars['String']>;
  lte?: InputMaybe<Scalars['String']>;
  ne?: InputMaybe<Scalars['String']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']>;
};

export type FilterCountAlertTypeInput = {
  id?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
};

export type FilterCountAlertUnitIdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['String']>;
  gte?: InputMaybe<Scalars['String']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  lt?: InputMaybe<Scalars['String']>;
  lte?: InputMaybe<Scalars['String']>;
  ne?: InputMaybe<Scalars['String']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']>;
};

export type FilterCountAlertUnitInput = {
  id?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
};

export type FilterCountAlertUnitOperatorsInput = {
  id?: InputMaybe<FilterCountAlertUnitIdOperatorsInput>;
};

export type FilterCountAlertZoneInput = {
  id?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
};

export type FilterCountAlert_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['String']>;
  gte?: InputMaybe<Scalars['String']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  lt?: InputMaybe<Scalars['String']>;
  lte?: InputMaybe<Scalars['String']>;
  ne?: InputMaybe<Scalars['String']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']>;
};

export type FilterCountAuthenticationProfileFactorsInput = {
  _id?: InputMaybe<Scalars['String']>;
  credentialBoundTo?: InputMaybe<Scalars['String']>;
  engine?: InputMaybe<EnumAuthenticationProfileFactorsEngine>;
  externalId?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  order?: InputMaybe<Scalars['Float']>;
  preferred?: InputMaybe<Scalars['Boolean']>;
  primary?: InputMaybe<Scalars['Boolean']>;
  sufficient?: InputMaybe<Scalars['Boolean']>;
  type?: InputMaybe<EnumAuthenticationProfileFactorsType>;
  value?: InputMaybe<Scalars['String']>;
};

export type FilterCountAuthenticationProfileInitialFactorsInput = {
  _id?: InputMaybe<Scalars['String']>;
  autoSatisfy?: InputMaybe<Scalars['Boolean']>;
  credentialBoundTo?: InputMaybe<Scalars['String']>;
  endpointId?: InputMaybe<Scalars['String']>;
  engine?: InputMaybe<EnumAuthenticationProfileInitialFactorsEngine>;
  expiration?: InputMaybe<Scalars['Float']>;
  factorId?: InputMaybe<Scalars['String']>;
};

export type FilterCountAuthenticationProfileInput = {
  AND?: InputMaybe<Array<FilterCountAuthenticationProfileInput>>;
  OR?: InputMaybe<Array<FilterCountAuthenticationProfileInput>>;
  _id?: InputMaybe<Scalars['String']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterCountAuthenticationProfileOperatorsInput>;
  currentChallenge?: InputMaybe<Scalars['String']>;
  currentChallengeExpiresAt?: InputMaybe<Scalars['Float']>;
  externalId?: InputMaybe<Scalars['String']>;
  factors?: InputMaybe<
    Array<InputMaybe<FilterCountAuthenticationProfileFactorsInput>>
  >;
  failedAttempts?: InputMaybe<Scalars['Float']>;
  initialFactors?: InputMaybe<
    Array<InputMaybe<FilterCountAuthenticationProfileInitialFactorsInput>>
  >;
  lastFailedLogin?: InputMaybe<Scalars['Float']>;
  lastLogin?: InputMaybe<Scalars['Float']>;
  lockedAt?: InputMaybe<Scalars['Float']>;
  userId?: InputMaybe<Scalars['String']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterCountAuthenticationProfileOperatorsInput = {
  _id?: InputMaybe<FilterCountAuthenticationProfile_IdOperatorsInput>;
};

export type FilterCountAuthenticationProfile_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['String']>;
  gte?: InputMaybe<Scalars['String']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  lt?: InputMaybe<Scalars['String']>;
  lte?: InputMaybe<Scalars['String']>;
  ne?: InputMaybe<Scalars['String']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']>;
};

export type FilterCountAuthenticatorDeviceInput = {
  AND?: InputMaybe<Array<FilterCountAuthenticatorDeviceInput>>;
  OR?: InputMaybe<Array<FilterCountAuthenticatorDeviceInput>>;
  _id?: InputMaybe<Scalars['String']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterCountAuthenticatorDeviceOperatorsInput>;
  aaguid?: InputMaybe<Scalars['String']>;
  counter?: InputMaybe<Scalars['Float']>;
  createdAt?: InputMaybe<Scalars['Float']>;
  credentialBackedUp?: InputMaybe<Scalars['Boolean']>;
  credentialBoundTo?: InputMaybe<Scalars['String']>;
  credentialDeviceType?: InputMaybe<Scalars['String']>;
  credentialEcosystem?: InputMaybe<EnumAuthenticatorDeviceCredentialEcosystem>;
  credentialID?: InputMaybe<Scalars['Buffer']>;
  credentialIsExternal?: InputMaybe<Scalars['Boolean']>;
  credentialOS?: InputMaybe<EnumAuthenticatorDeviceCredentialOs>;
  credentialPublicKey?: InputMaybe<Scalars['Buffer']>;
  credentialType?: InputMaybe<Scalars['String']>;
  deviceName?: InputMaybe<Scalars['String']>;
  deviceType?: InputMaybe<Scalars['String']>;
  endpointId?: InputMaybe<Scalars['String']>;
  enforceUserVerification?: InputMaybe<Scalars['Boolean']>;
  lastUsed?: InputMaybe<Scalars['Float']>;
  transports?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  userId?: InputMaybe<Scalars['String']>;
  userVerified?: InputMaybe<Scalars['Boolean']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterCountAuthenticatorDeviceOperatorsInput = {
  _id?: InputMaybe<FilterCountAuthenticatorDevice_IdOperatorsInput>;
  userId?: InputMaybe<FilterCountAuthenticatorDeviceUserIdOperatorsInput>;
};

export type FilterCountAuthenticatorDeviceUserIdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['String']>;
  gte?: InputMaybe<Scalars['String']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  lt?: InputMaybe<Scalars['String']>;
  lte?: InputMaybe<Scalars['String']>;
  ne?: InputMaybe<Scalars['String']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']>;
};

export type FilterCountAuthenticatorDevice_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['String']>;
  gte?: InputMaybe<Scalars['String']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  lt?: InputMaybe<Scalars['String']>;
  lte?: InputMaybe<Scalars['String']>;
  ne?: InputMaybe<Scalars['String']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']>;
};

export type FilterCountAuthorizationProfileInput = {
  AND?: InputMaybe<Array<FilterCountAuthorizationProfileInput>>;
  OR?: InputMaybe<Array<FilterCountAuthorizationProfileInput>>;
  _id?: InputMaybe<Scalars['String']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterCountAuthorizationProfileOperatorsInput>;
  apiToken?: InputMaybe<Scalars['String']>;
  currentChallenge?: InputMaybe<Scalars['String']>;
  currentChallengeExpiration?: InputMaybe<Scalars['Float']>;
  installerProperties?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  isInstaller?: InputMaybe<Scalars['Boolean']>;
  isManager?: InputMaybe<Scalars['Boolean']>;
  isResident?: InputMaybe<Scalars['Boolean']>;
  isSuper?: InputMaybe<Scalars['Boolean']>;
  isViewer?: InputMaybe<Scalars['Boolean']>;
  managerProperties?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  name?: InputMaybe<Scalars['String']>;
  residentProperty?: InputMaybe<Scalars['String']>;
  residentUnit?: InputMaybe<Scalars['String']>;
  userId?: InputMaybe<Scalars['String']>;
  viewerProperties?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterCountAuthorizationProfileOperatorsInput = {
  _id?: InputMaybe<FilterCountAuthorizationProfile_IdOperatorsInput>;
};

export type FilterCountAuthorizationProfile_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['String']>;
  gte?: InputMaybe<Scalars['String']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  lt?: InputMaybe<Scalars['String']>;
  lte?: InputMaybe<Scalars['String']>;
  ne?: InputMaybe<Scalars['String']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']>;
};

export type FilterCountBngInput = {
  AND?: InputMaybe<Array<FilterCountSourceInput>>;
  OR?: InputMaybe<Array<FilterCountSourceInput>>;
  _id?: InputMaybe<Scalars['String']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterCountSourceOperatorsInput>;
  localUrl?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  propertyId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  url?: InputMaybe<Scalars['String']>;
};

export type FilterCountBatteryManagementSystemBatteryEfficiencyInput = {
  id?: InputMaybe<Scalars['String']>;
  observedAt?: InputMaybe<Scalars['Float']>;
  previousId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  units?: InputMaybe<Scalars['String']>;
  updatePending?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<Scalars['Float']>;
};

export type FilterCountBatteryManagementSystemCellCurrentsInput = {
  id?: InputMaybe<Scalars['String']>;
  observedAt?: InputMaybe<Scalars['Float']>;
  previousId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  units?: InputMaybe<Scalars['String']>;
  updatePending?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<Scalars['Float']>;
};

export type FilterCountBatteryManagementSystemCellCycleCountsInput = {
  id?: InputMaybe<Scalars['String']>;
  observedAt?: InputMaybe<Scalars['Float']>;
  previousId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  units?: InputMaybe<Scalars['String']>;
  updatePending?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<Scalars['Float']>;
};

export type FilterCountBatteryManagementSystemCellTemperaturesInput = {
  id?: InputMaybe<Scalars['String']>;
  observedAt?: InputMaybe<Scalars['Float']>;
  previousId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  units?: InputMaybe<Scalars['String']>;
  updatePending?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<Scalars['Float']>;
};

export type FilterCountBatteryManagementSystemCellVoltagesInput = {
  id?: InputMaybe<Scalars['String']>;
  observedAt?: InputMaybe<Scalars['Float']>;
  previousId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  units?: InputMaybe<Scalars['String']>;
  updatePending?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<Scalars['Float']>;
};

export type FilterCountBatteryManagementSystemCurrentInput = {
  id?: InputMaybe<Scalars['String']>;
  observedAt?: InputMaybe<Scalars['Float']>;
  previousId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  units?: InputMaybe<Scalars['String']>;
  updatePending?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<Scalars['Float']>;
};

export type FilterCountBatteryManagementSystemInput = {
  AND?: InputMaybe<Array<FilterCountDeviceInput>>;
  OR?: InputMaybe<Array<FilterCountDeviceInput>>;
  _id?: InputMaybe<Scalars['String']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterCountDeviceOperatorsInput>;
  alertTypes?: InputMaybe<FilterCountDeviceAlertTypesInput>;
  batteryEfficiency?: InputMaybe<FilterCountBatteryManagementSystemBatteryEfficiencyInput>;
  cellCurrents?: InputMaybe<
    Array<InputMaybe<FilterCountBatteryManagementSystemCellCurrentsInput>>
  >;
  cellCycleCounts?: InputMaybe<
    Array<InputMaybe<FilterCountBatteryManagementSystemCellCycleCountsInput>>
  >;
  cellTemperatures?: InputMaybe<
    Array<InputMaybe<FilterCountBatteryManagementSystemCellTemperaturesInput>>
  >;
  cellVoltages?: InputMaybe<
    Array<InputMaybe<FilterCountBatteryManagementSystemCellVoltagesInput>>
  >;
  controlled?: InputMaybe<FilterCountDeviceControlledInput>;
  current?: InputMaybe<FilterCountBatteryManagementSystemCurrentInput>;
  deviceId?: InputMaybe<Scalars['String']>;
  installation?: InputMaybe<FilterCountDeviceInstallationInput>;
  inverterId?: InputMaybe<Scalars['String']>;
  location?: InputMaybe<Scalars['String']>;
  meta?: InputMaybe<FilterCountDeviceMetaInput>;
  /** The name of the device */
  name?: InputMaybe<Scalars['String']>;
  panelId?: InputMaybe<Scalars['String']>;
  powerState?: InputMaybe<FilterCountDevicePowerStateInput>;
  propertyId?: InputMaybe<Scalars['String']>;
  sourceId?: InputMaybe<Scalars['String']>;
  stateOfCharge?: InputMaybe<FilterCountBatteryManagementSystemStateOfChargeInput>;
  stateOfHealth?: InputMaybe<FilterCountBatteryManagementSystemStateOfHealthInput>;
  temperature?: InputMaybe<FilterCountBatteryManagementSystemTemperatureInput>;
  timestamp?: InputMaybe<Scalars['Float']>;
  unitId?: InputMaybe<Scalars['String']>;
  updateStatus?: InputMaybe<Scalars['Boolean']>;
  voltage?: InputMaybe<FilterCountBatteryManagementSystemVoltageInput>;
  vppId?: InputMaybe<Scalars['String']>;
  zoneId?: InputMaybe<Scalars['String']>;
};

export type FilterCountBatteryManagementSystemStateOfChargeInput = {
  id?: InputMaybe<Scalars['String']>;
  observedAt?: InputMaybe<Scalars['Float']>;
  previousId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  units?: InputMaybe<Scalars['String']>;
  updatePending?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<Scalars['Float']>;
};

export type FilterCountBatteryManagementSystemStateOfHealthInput = {
  id?: InputMaybe<Scalars['String']>;
  observedAt?: InputMaybe<Scalars['Float']>;
  previousId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  units?: InputMaybe<Scalars['String']>;
  updatePending?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<Scalars['Float']>;
};

export type FilterCountBatteryManagementSystemTemperatureInput = {
  id?: InputMaybe<Scalars['String']>;
  observedAt?: InputMaybe<Scalars['Float']>;
  previousId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  units?: InputMaybe<Scalars['String']>;
  updatePending?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<Scalars['Float']>;
};

export type FilterCountBatteryManagementSystemVoltageInput = {
  id?: InputMaybe<Scalars['String']>;
  observedAt?: InputMaybe<Scalars['Float']>;
  previousId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  units?: InputMaybe<Scalars['String']>;
  updatePending?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<Scalars['Float']>;
};

export type FilterCountBoilerBoilerPumpSpeed1Input = {
  id?: InputMaybe<Scalars['String']>;
  observedAt?: InputMaybe<Scalars['Float']>;
  previousId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  units?: InputMaybe<Scalars['String']>;
  updatePending?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<Scalars['Float']>;
};

export type FilterCountBoilerBoilerPumpSpeed2Input = {
  id?: InputMaybe<Scalars['String']>;
  observedAt?: InputMaybe<Scalars['Float']>;
  previousId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  units?: InputMaybe<Scalars['String']>;
  updatePending?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<Scalars['Float']>;
};

export type FilterCountBoilerBoilerPumpSpeedInput = {
  id?: InputMaybe<Scalars['String']>;
  observedAt?: InputMaybe<Scalars['Float']>;
  previousId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  units?: InputMaybe<Scalars['String']>;
  updatePending?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<Scalars['Float']>;
};

export type FilterCountBoilerFiringRate1Input = {
  id?: InputMaybe<Scalars['String']>;
  observedAt?: InputMaybe<Scalars['Float']>;
  previousId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  units?: InputMaybe<Scalars['String']>;
  updatePending?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<Scalars['Float']>;
};

export type FilterCountBoilerFiringRate2Input = {
  id?: InputMaybe<Scalars['String']>;
  observedAt?: InputMaybe<Scalars['Float']>;
  previousId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  units?: InputMaybe<Scalars['String']>;
  updatePending?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<Scalars['Float']>;
};

export type FilterCountBoilerFiringRateInput = {
  id?: InputMaybe<Scalars['String']>;
  observedAt?: InputMaybe<Scalars['Float']>;
  previousId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  units?: InputMaybe<Scalars['String']>;
  updatePending?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<Scalars['Float']>;
};

export type FilterCountBoilerFlueTemperature1Input = {
  id?: InputMaybe<Scalars['String']>;
  observedAt?: InputMaybe<Scalars['Float']>;
  previousId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  units?: InputMaybe<Scalars['String']>;
  updatePending?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<Scalars['Float']>;
};

export type FilterCountBoilerFlueTemperature2Input = {
  id?: InputMaybe<Scalars['String']>;
  observedAt?: InputMaybe<Scalars['Float']>;
  previousId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  units?: InputMaybe<Scalars['String']>;
  updatePending?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<Scalars['Float']>;
};

export type FilterCountBoilerFlueTemperatureInput = {
  id?: InputMaybe<Scalars['String']>;
  observedAt?: InputMaybe<Scalars['Float']>;
  previousId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  units?: InputMaybe<Scalars['String']>;
  updatePending?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<Scalars['Float']>;
};

export type FilterCountBoilerInletTemperature1Input = {
  id?: InputMaybe<Scalars['String']>;
  observedAt?: InputMaybe<Scalars['Float']>;
  previousId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  units?: InputMaybe<Scalars['String']>;
  updatePending?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<Scalars['Float']>;
};

export type FilterCountBoilerInletTemperature2Input = {
  id?: InputMaybe<Scalars['String']>;
  observedAt?: InputMaybe<Scalars['Float']>;
  previousId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  units?: InputMaybe<Scalars['String']>;
  updatePending?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<Scalars['Float']>;
};

export type FilterCountBoilerInletTemperatureInput = {
  id?: InputMaybe<Scalars['String']>;
  observedAt?: InputMaybe<Scalars['Float']>;
  previousId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  units?: InputMaybe<Scalars['String']>;
  updatePending?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<Scalars['Float']>;
};

export type FilterCountBoilerInput = {
  AND?: InputMaybe<Array<FilterCountDeviceInput>>;
  OR?: InputMaybe<Array<FilterCountDeviceInput>>;
  _id?: InputMaybe<Scalars['String']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterCountDeviceOperatorsInput>;
  alertTypes?: InputMaybe<FilterCountDeviceAlertTypesInput>;
  boilerPumpSpeed?: InputMaybe<FilterCountBoilerBoilerPumpSpeedInput>;
  boilerPumpSpeed1?: InputMaybe<FilterCountBoilerBoilerPumpSpeed1Input>;
  boilerPumpSpeed2?: InputMaybe<FilterCountBoilerBoilerPumpSpeed2Input>;
  controlled?: InputMaybe<FilterCountDeviceControlledInput>;
  deviceId?: InputMaybe<Scalars['String']>;
  firingRate?: InputMaybe<FilterCountBoilerFiringRateInput>;
  firingRate1?: InputMaybe<FilterCountBoilerFiringRate1Input>;
  firingRate2?: InputMaybe<FilterCountBoilerFiringRate2Input>;
  flueTemperature?: InputMaybe<FilterCountBoilerFlueTemperatureInput>;
  flueTemperature1?: InputMaybe<FilterCountBoilerFlueTemperature1Input>;
  flueTemperature2?: InputMaybe<FilterCountBoilerFlueTemperature2Input>;
  inletTemperature?: InputMaybe<FilterCountBoilerInletTemperatureInput>;
  inletTemperature1?: InputMaybe<FilterCountBoilerInletTemperature1Input>;
  inletTemperature2?: InputMaybe<FilterCountBoilerInletTemperature2Input>;
  installation?: InputMaybe<FilterCountDeviceInstallationInput>;
  location?: InputMaybe<Scalars['String']>;
  meta?: InputMaybe<FilterCountDeviceMetaInput>;
  /** The name of the device */
  name?: InputMaybe<Scalars['String']>;
  outletTemperature?: InputMaybe<FilterCountBoilerOutletTemperatureInput>;
  outletTemperature1?: InputMaybe<FilterCountBoilerOutletTemperature1Input>;
  outletTemperature2?: InputMaybe<FilterCountBoilerOutletTemperature2Input>;
  panelId?: InputMaybe<Scalars['String']>;
  powerState?: InputMaybe<FilterCountDevicePowerStateInput>;
  propertyId?: InputMaybe<Scalars['String']>;
  role?: InputMaybe<Scalars['String']>;
  sourceId?: InputMaybe<Scalars['String']>;
  temperature?: InputMaybe<FilterCountBoilerTemperatureInput>;
  timestamp?: InputMaybe<Scalars['Float']>;
  unitId?: InputMaybe<Scalars['String']>;
  updateStatus?: InputMaybe<Scalars['Boolean']>;
  vppId?: InputMaybe<Scalars['String']>;
  zoneId?: InputMaybe<Scalars['String']>;
};

export type FilterCountBoilerOutletTemperature1Input = {
  id?: InputMaybe<Scalars['String']>;
  observedAt?: InputMaybe<Scalars['Float']>;
  previousId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  units?: InputMaybe<Scalars['String']>;
  updatePending?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<Scalars['Float']>;
};

export type FilterCountBoilerOutletTemperature2Input = {
  id?: InputMaybe<Scalars['String']>;
  observedAt?: InputMaybe<Scalars['Float']>;
  previousId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  units?: InputMaybe<Scalars['String']>;
  updatePending?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<Scalars['Float']>;
};

export type FilterCountBoilerOutletTemperatureInput = {
  id?: InputMaybe<Scalars['String']>;
  observedAt?: InputMaybe<Scalars['Float']>;
  previousId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  units?: InputMaybe<Scalars['String']>;
  updatePending?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<Scalars['Float']>;
};

export type FilterCountBoilerTemperatureInput = {
  id?: InputMaybe<Scalars['String']>;
  observedAt?: InputMaybe<Scalars['Float']>;
  previousId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  units?: InputMaybe<Scalars['String']>;
  updatePending?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<Scalars['Float']>;
};

export type FilterCountBuildingInput = {
  AND?: InputMaybe<Array<FilterCountBuildingInput>>;
  OR?: InputMaybe<Array<FilterCountBuildingInput>>;
  _id?: InputMaybe<Scalars['String']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterCountBuildingOperatorsInput>;
  name?: InputMaybe<Scalars['String']>;
  number?: InputMaybe<Scalars['Float']>;
  propertyId?: InputMaybe<Scalars['String']>;
};

export type FilterCountBuildingNameOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['String']>;
  gte?: InputMaybe<Scalars['String']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  lt?: InputMaybe<Scalars['String']>;
  lte?: InputMaybe<Scalars['String']>;
  ne?: InputMaybe<Scalars['String']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterCountBuildingOperatorsInput = {
  _id?: InputMaybe<FilterCountBuilding_IdOperatorsInput>;
  name?: InputMaybe<FilterCountBuildingNameOperatorsInput>;
};

export type FilterCountBuilding_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['String']>;
  gte?: InputMaybe<Scalars['String']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  lt?: InputMaybe<Scalars['String']>;
  lte?: InputMaybe<Scalars['String']>;
  ne?: InputMaybe<Scalars['String']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']>;
};

export type FilterCountChillerAmbientTemperatureInput = {
  id?: InputMaybe<Scalars['String']>;
  observedAt?: InputMaybe<Scalars['Float']>;
  previousId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  units?: InputMaybe<Scalars['String']>;
  updatePending?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<Scalars['Float']>;
};

export type FilterCountChillerChilledReturnTemperatureInput = {
  id?: InputMaybe<Scalars['String']>;
  observedAt?: InputMaybe<Scalars['Float']>;
  previousId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  units?: InputMaybe<Scalars['String']>;
  updatePending?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<Scalars['Float']>;
};

export type FilterCountChillerChilledSupplyTemperatureInput = {
  id?: InputMaybe<Scalars['String']>;
  observedAt?: InputMaybe<Scalars['Float']>;
  previousId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  units?: InputMaybe<Scalars['String']>;
  updatePending?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<Scalars['Float']>;
};

export type FilterCountChillerCoolSetpointInput = {
  id?: InputMaybe<Scalars['String']>;
  observedAt?: InputMaybe<Scalars['Float']>;
  previousId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  units?: InputMaybe<Scalars['String']>;
  updatePending?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<Scalars['Float']>;
};

export type FilterCountChillerInput = {
  AND?: InputMaybe<Array<FilterCountDeviceInput>>;
  OR?: InputMaybe<Array<FilterCountDeviceInput>>;
  _id?: InputMaybe<Scalars['String']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterCountDeviceOperatorsInput>;
  alertTypes?: InputMaybe<FilterCountDeviceAlertTypesInput>;
  ambientTemperature?: InputMaybe<FilterCountChillerAmbientTemperatureInput>;
  chilledReturnTemperature?: InputMaybe<FilterCountChillerChilledReturnTemperatureInput>;
  chilledSupplyTemperature?: InputMaybe<FilterCountChillerChilledSupplyTemperatureInput>;
  controlled?: InputMaybe<FilterCountDeviceControlledInput>;
  coolSetpoint?: InputMaybe<FilterCountChillerCoolSetpointInput>;
  deviceId?: InputMaybe<Scalars['String']>;
  installation?: InputMaybe<FilterCountDeviceInstallationInput>;
  location?: InputMaybe<Scalars['String']>;
  meta?: InputMaybe<FilterCountDeviceMetaInput>;
  /** The name of the device */
  name?: InputMaybe<Scalars['String']>;
  panelId?: InputMaybe<Scalars['String']>;
  powerState?: InputMaybe<FilterCountDevicePowerStateInput>;
  propertyId?: InputMaybe<Scalars['String']>;
  sourceId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  unitId?: InputMaybe<Scalars['String']>;
  updateStatus?: InputMaybe<Scalars['Boolean']>;
  vppId?: InputMaybe<Scalars['String']>;
  zoneId?: InputMaybe<Scalars['String']>;
};

export type FilterCountConductorGenericSensorAlarmStateInput = {
  id?: InputMaybe<Scalars['String']>;
  observedAt?: InputMaybe<Scalars['Float']>;
  previousId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  units?: InputMaybe<Scalars['String']>;
  updatePending?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<Scalars['Boolean']>;
};

export type FilterCountConductorGenericSensorCounterValueInput = {
  id?: InputMaybe<Scalars['String']>;
  observedAt?: InputMaybe<Scalars['Float']>;
  previousId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  units?: InputMaybe<Scalars['String']>;
  updatePending?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<Scalars['Float']>;
};

export type FilterCountConductorGenericSensorFanSpeedInput = {
  id?: InputMaybe<Scalars['String']>;
  observedAt?: InputMaybe<Scalars['Float']>;
  previousId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  units?: InputMaybe<Scalars['String']>;
  updatePending?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<Scalars['Float']>;
};

export type FilterCountConductorGenericSensorHumidityInput = {
  id?: InputMaybe<Scalars['String']>;
  observedAt?: InputMaybe<Scalars['Float']>;
  previousId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  units?: InputMaybe<Scalars['String']>;
  updatePending?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<Scalars['Float']>;
};

export type FilterCountConductorGenericSensorInput = {
  AND?: InputMaybe<Array<FilterCountDeviceInput>>;
  OR?: InputMaybe<Array<FilterCountDeviceInput>>;
  _id?: InputMaybe<Scalars['String']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterCountDeviceOperatorsInput>;
  alarmState?: InputMaybe<FilterCountConductorGenericSensorAlarmStateInput>;
  alertTypes?: InputMaybe<FilterCountDeviceAlertTypesInput>;
  controlled?: InputMaybe<FilterCountDeviceControlledInput>;
  counterValue?: InputMaybe<FilterCountConductorGenericSensorCounterValueInput>;
  deviceId?: InputMaybe<Scalars['String']>;
  fanSpeed?: InputMaybe<FilterCountConductorGenericSensorFanSpeedInput>;
  humidity?: InputMaybe<FilterCountConductorGenericSensorHumidityInput>;
  installation?: InputMaybe<FilterCountDeviceInstallationInput>;
  location?: InputMaybe<Scalars['String']>;
  meta?: InputMaybe<FilterCountDeviceMetaInput>;
  /** The name of the device */
  name?: InputMaybe<Scalars['String']>;
  panelId?: InputMaybe<Scalars['String']>;
  powerState?: InputMaybe<FilterCountDevicePowerStateInput>;
  propertyId?: InputMaybe<Scalars['String']>;
  resetCount?: InputMaybe<FilterCountConductorGenericSensorResetCountInput>;
  setpoint?: InputMaybe<FilterCountConductorGenericSensorSetpointInput>;
  sourceId?: InputMaybe<Scalars['String']>;
  systemMode?: InputMaybe<FilterCountConductorGenericSensorSystemModeInput>;
  temperature?: InputMaybe<FilterCountConductorGenericSensorTemperatureInput>;
  timestamp?: InputMaybe<Scalars['Float']>;
  unitId?: InputMaybe<Scalars['String']>;
  updateStatus?: InputMaybe<Scalars['Boolean']>;
  vppId?: InputMaybe<Scalars['String']>;
  zoneId?: InputMaybe<Scalars['String']>;
};

export type FilterCountConductorGenericSensorResetCountInput = {
  id?: InputMaybe<Scalars['String']>;
  observedAt?: InputMaybe<Scalars['Float']>;
  previousId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  units?: InputMaybe<Scalars['String']>;
  updatePending?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<Scalars['Float']>;
};

export type FilterCountConductorGenericSensorSetpointInput = {
  id?: InputMaybe<Scalars['String']>;
  observedAt?: InputMaybe<Scalars['Float']>;
  previousId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  units?: InputMaybe<Scalars['String']>;
  updatePending?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<Scalars['Float']>;
};

export type FilterCountConductorGenericSensorSystemModeInput = {
  id?: InputMaybe<Scalars['String']>;
  observedAt?: InputMaybe<Scalars['Float']>;
  previousId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  units?: InputMaybe<Scalars['String']>;
  updatePending?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<Scalars['Float']>;
};

export type FilterCountConductorGenericSensorTemperatureInput = {
  id?: InputMaybe<Scalars['String']>;
  observedAt?: InputMaybe<Scalars['Float']>;
  previousId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  units?: InputMaybe<Scalars['String']>;
  updatePending?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<Scalars['Float']>;
};

export type FilterCountConductorInput = {
  AND?: InputMaybe<Array<FilterCountSourceInput>>;
  OR?: InputMaybe<Array<FilterCountSourceInput>>;
  _id?: InputMaybe<Scalars['String']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterCountSourceOperatorsInput>;
  buildingId?: InputMaybe<Scalars['String']>;
  conductorUniqueId?: InputMaybe<Scalars['String']>;
  lastDiscoveryMappingProposal?: InputMaybe<Scalars['JSON']>;
  lastDiscoveryResults?: InputMaybe<Scalars['JSON']>;
  lastDiscoveryResultsUrl?: InputMaybe<Scalars['String']>;
  lastDiscoveryRunId?: InputMaybe<Scalars['String']>;
  lastDiscoveryStatus?: InputMaybe<Scalars['String']>;
  lastDiscoveryStatusUrl?: InputMaybe<Scalars['String']>;
  maxReportingTime?: InputMaybe<Scalars['Float']>;
  name?: InputMaybe<Scalars['String']>;
  propertyId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  tolerances?: InputMaybe<FilterCountConductorTolerancesInput>;
  url?: InputMaybe<Scalars['String']>;
};

export type FilterCountConductorTolerancesInput = {
  humidity?: InputMaybe<Scalars['Float']>;
  temperature?: InputMaybe<Scalars['Float']>;
};

export type FilterCountControlGroupGroupedDevicesInput = {
  _id?: InputMaybe<Scalars['String']>;
  deviceId?: InputMaybe<Scalars['String']>;
  displayOrder?: InputMaybe<Scalars['Float']>;
  name?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<Scalars['String']>;
};

export type FilterCountControlGroupInput = {
  AND?: InputMaybe<Array<FilterCountControlGroupInput>>;
  OR?: InputMaybe<Array<FilterCountControlGroupInput>>;
  _id?: InputMaybe<Scalars['String']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterCountControlGroupOperatorsInput>;
  attributes?: InputMaybe<Scalars['JSON']>;
  automationEnabled?: InputMaybe<Scalars['Boolean']>;
  groupedDevices?: InputMaybe<
    Array<InputMaybe<FilterCountControlGroupGroupedDevicesInput>>
  >;
  masterDeviceId?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  propertyId?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<Scalars['String']>;
  unitId?: InputMaybe<Scalars['String']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterCountControlGroupOperatorsInput = {
  _id?: InputMaybe<FilterCountControlGroup_IdOperatorsInput>;
  propertyId?: InputMaybe<FilterCountControlGroupPropertyIdOperatorsInput>;
  unitId?: InputMaybe<FilterCountControlGroupUnitIdOperatorsInput>;
};

export type FilterCountControlGroupPropertyIdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['String']>;
  gte?: InputMaybe<Scalars['String']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  lt?: InputMaybe<Scalars['String']>;
  lte?: InputMaybe<Scalars['String']>;
  ne?: InputMaybe<Scalars['String']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']>;
};

export type FilterCountControlGroupUnitIdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['String']>;
  gte?: InputMaybe<Scalars['String']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  lt?: InputMaybe<Scalars['String']>;
  lte?: InputMaybe<Scalars['String']>;
  ne?: InputMaybe<Scalars['String']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']>;
};

export type FilterCountControlGroup_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['String']>;
  gte?: InputMaybe<Scalars['String']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  lt?: InputMaybe<Scalars['String']>;
  lte?: InputMaybe<Scalars['String']>;
  ne?: InputMaybe<Scalars['String']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']>;
};

export type FilterCountControllerActiveAlarmCountInput = {
  id?: InputMaybe<Scalars['String']>;
  observedAt?: InputMaybe<Scalars['Float']>;
  previousId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  units?: InputMaybe<Scalars['String']>;
  updatePending?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<Scalars['Float']>;
};

export type FilterCountControllerCommunicationStateInput = {
  id?: InputMaybe<Scalars['String']>;
  observedAt?: InputMaybe<Scalars['Float']>;
  previousId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  units?: InputMaybe<Scalars['String']>;
  updatePending?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<Scalars['Boolean']>;
};

export type FilterCountControllerController_LoopInput = {
  id?: InputMaybe<Scalars['String']>;
  observedAt?: InputMaybe<Scalars['Float']>;
  previousId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  units?: InputMaybe<Scalars['String']>;
  updatePending?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<EnumControllerController_LoopValue>;
};

export type FilterCountControllerInput = {
  AND?: InputMaybe<Array<FilterCountDeviceInput>>;
  OR?: InputMaybe<Array<FilterCountDeviceInput>>;
  _id?: InputMaybe<Scalars['String']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterCountDeviceOperatorsInput>;
  activeAlarmCount?: InputMaybe<FilterCountControllerActiveAlarmCountInput>;
  alertTypes?: InputMaybe<FilterCountDeviceAlertTypesInput>;
  communicationState?: InputMaybe<FilterCountControllerCommunicationStateInput>;
  controlled?: InputMaybe<FilterCountDeviceControlledInput>;
  controller_loop?: InputMaybe<FilterCountControllerController_LoopInput>;
  deviceId?: InputMaybe<Scalars['String']>;
  installation?: InputMaybe<FilterCountDeviceInstallationInput>;
  location?: InputMaybe<Scalars['String']>;
  meta?: InputMaybe<FilterCountDeviceMetaInput>;
  /** The name of the device */
  name?: InputMaybe<Scalars['String']>;
  panelId?: InputMaybe<Scalars['String']>;
  powerState?: InputMaybe<FilterCountDevicePowerStateInput>;
  propertyId?: InputMaybe<Scalars['String']>;
  resetCount?: InputMaybe<FilterCountControllerResetCountInput>;
  sourceId?: InputMaybe<Scalars['String']>;
  supervisor_controller?: InputMaybe<FilterCountControllerSupervisor_ControllerInput>;
  timestamp?: InputMaybe<Scalars['Float']>;
  unitId?: InputMaybe<Scalars['String']>;
  updateStatus?: InputMaybe<Scalars['Boolean']>;
  vppId?: InputMaybe<Scalars['String']>;
  zoneId?: InputMaybe<Scalars['String']>;
};

export type FilterCountControllerResetCountInput = {
  id?: InputMaybe<Scalars['String']>;
  observedAt?: InputMaybe<Scalars['Float']>;
  previousId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  units?: InputMaybe<Scalars['String']>;
  updatePending?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<Scalars['Float']>;
};

export type FilterCountControllerSupervisor_ControllerInput = {
  id?: InputMaybe<Scalars['String']>;
  observedAt?: InputMaybe<Scalars['Float']>;
  previousId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  units?: InputMaybe<Scalars['String']>;
  updatePending?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<EnumControllerSupervisor_ControllerValue>;
};

export type FilterCountCoreInput = {
  AND?: InputMaybe<Array<FilterCountSourceInput>>;
  OR?: InputMaybe<Array<FilterCountSourceInput>>;
  _id?: InputMaybe<Scalars['String']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterCountSourceOperatorsInput>;
  maxReportingTime?: InputMaybe<Scalars['Float']>;
  name?: InputMaybe<Scalars['String']>;
  propertyId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  tolerances?: InputMaybe<FilterCountCoreTolerancesInput>;
  url?: InputMaybe<Scalars['String']>;
};

export type FilterCountCoreTolerancesInput = {
  humidity?: InputMaybe<Scalars['Float']>;
  temperature?: InputMaybe<Scalars['Float']>;
  voltage?: InputMaybe<Scalars['Float']>;
};

export type FilterCountDataExportJobArtifactsInput = {
  _id?: InputMaybe<Scalars['MongoID']>;
  bucket?: InputMaybe<Scalars['String']>;
  contentType?: InputMaybe<Scalars['String']>;
  key?: InputMaybe<Scalars['String']>;
  kind?: InputMaybe<Scalars['String']>;
};

export type FilterCountDataExportJobInput = {
  AND?: InputMaybe<Array<FilterCountDataExportJobInput>>;
  OR?: InputMaybe<Array<FilterCountDataExportJobInput>>;
  _id?: InputMaybe<Scalars['String']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterCountDataExportJobOperatorsInput>;
  artifacts?: InputMaybe<
    Array<InputMaybe<FilterCountDataExportJobArtifactsInput>>
  >;
  awsTaskArn?: InputMaybe<Scalars['String']>;
  completedAt?: InputMaybe<Scalars['Date']>;
  currentStep?: InputMaybe<Scalars['String']>;
  endDate?: InputMaybe<Scalars['Date']>;
  errorDetails?: InputMaybe<Scalars['String']>;
  errorMessage?: InputMaybe<Scalars['String']>;
  progress?: InputMaybe<Scalars['Float']>;
  propertyId?: InputMaybe<Scalars['String']>;
  propertyTitle?: InputMaybe<Scalars['String']>;
  reportTypes?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  requestedByUserId?: InputMaybe<Scalars['String']>;
  s3Bucket?: InputMaybe<Scalars['String']>;
  s3Key?: InputMaybe<Scalars['String']>;
  startDate?: InputMaybe<Scalars['Date']>;
  startedAt?: InputMaybe<Scalars['Date']>;
  status?: InputMaybe<EnumDataExportJobStatus>;
  submittedAt?: InputMaybe<Scalars['Date']>;
  updatedAt?: InputMaybe<Scalars['Date']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterCountDataExportJobOperatorsInput = {
  _id?: InputMaybe<FilterCountDataExportJob_IdOperatorsInput>;
  propertyId?: InputMaybe<FilterCountDataExportJobPropertyIdOperatorsInput>;
  requestedByUserId?: InputMaybe<FilterCountDataExportJobRequestedByUserIdOperatorsInput>;
  status?: InputMaybe<FilterCountDataExportJobStatusOperatorsInput>;
};

export type FilterCountDataExportJobPropertyIdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['String']>;
  gte?: InputMaybe<Scalars['String']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  lt?: InputMaybe<Scalars['String']>;
  lte?: InputMaybe<Scalars['String']>;
  ne?: InputMaybe<Scalars['String']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']>;
};

export type FilterCountDataExportJobRequestedByUserIdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['String']>;
  gte?: InputMaybe<Scalars['String']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  lt?: InputMaybe<Scalars['String']>;
  lte?: InputMaybe<Scalars['String']>;
  ne?: InputMaybe<Scalars['String']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']>;
};

export type FilterCountDataExportJobStatusOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<EnumDataExportJobStatus>;
  gte?: InputMaybe<EnumDataExportJobStatus>;
  in?: InputMaybe<Array<InputMaybe<EnumDataExportJobStatus>>>;
  lt?: InputMaybe<EnumDataExportJobStatus>;
  lte?: InputMaybe<EnumDataExportJobStatus>;
  ne?: InputMaybe<EnumDataExportJobStatus>;
  nin?: InputMaybe<Array<InputMaybe<EnumDataExportJobStatus>>>;
};

export type FilterCountDataExportJob_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['String']>;
  gte?: InputMaybe<Scalars['String']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  lt?: InputMaybe<Scalars['String']>;
  lte?: InputMaybe<Scalars['String']>;
  ne?: InputMaybe<Scalars['String']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']>;
};

export type FilterCountDeviceAlertTypesInput = {
  deviceAlert?: InputMaybe<Scalars['Boolean']>;
  deviceMetric?: InputMaybe<Scalars['Boolean']>;
  deviceOffline?: InputMaybe<Scalars['Boolean']>;
  equipmentAlarm?: InputMaybe<Scalars['Boolean']>;
  sourceOffline?: InputMaybe<Scalars['Boolean']>;
};

export type FilterCountDeviceControlledInput = {
  id?: InputMaybe<Scalars['String']>;
  observedAt?: InputMaybe<Scalars['Float']>;
  previousId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  units?: InputMaybe<Scalars['String']>;
  updatePending?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<Scalars['Boolean']>;
};

export type FilterCountDeviceInput = {
  AND?: InputMaybe<Array<FilterCountDeviceInput>>;
  OR?: InputMaybe<Array<FilterCountDeviceInput>>;
  _id?: InputMaybe<Scalars['String']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterCountDeviceOperatorsInput>;
  alertTypes?: InputMaybe<FilterCountDeviceAlertTypesInput>;
  controlled?: InputMaybe<FilterCountDeviceControlledInput>;
  deviceId?: InputMaybe<Scalars['String']>;
  installation?: InputMaybe<FilterCountDeviceInstallationInput>;
  location?: InputMaybe<Scalars['String']>;
  meta?: InputMaybe<FilterCountDeviceMetaInput>;
  /** The name of the device */
  name?: InputMaybe<Scalars['String']>;
  panelId?: InputMaybe<Scalars['String']>;
  powerState?: InputMaybe<FilterCountDevicePowerStateInput>;
  propertyId?: InputMaybe<Scalars['String']>;
  sourceId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  type?: InputMaybe<EnumDKeyDeviceType>;
  unitId?: InputMaybe<Scalars['String']>;
  updateStatus?: InputMaybe<Scalars['Boolean']>;
  vppId?: InputMaybe<Scalars['String']>;
  zoneId?: InputMaybe<Scalars['String']>;
};

export type FilterCountDeviceInstallationInput = {
  count?: InputMaybe<Scalars['Float']>;
  message?: InputMaybe<Scalars['String']>;
  paired?: InputMaybe<Scalars['Boolean']>;
  pairedTo?: InputMaybe<Scalars['String']>;
  previousStatus?: InputMaybe<Scalars['String']>;
  rawDeviceId?: InputMaybe<Scalars['String']>;
  replacingDeviceId?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<Scalars['Float']>;
};

export type FilterCountDeviceMetaDisplayInput = {
  humidity?: InputMaybe<Scalars['Float']>;
  temperature?: InputMaybe<Scalars['Float']>;
};

export type FilterCountDeviceMetaInput = {
  city_id?: InputMaybe<Scalars['String']>;
  display?: InputMaybe<FilterCountDeviceMetaDisplayInput>;
  localAddr?: InputMaybe<Scalars['String']>;
  local_addr?: InputMaybe<Scalars['String']>;
  location?: InputMaybe<Scalars['String']>;
  loopType?: InputMaybe<Scalars['String']>;
  manufacturer?: InputMaybe<Scalars['String']>;
  metrics?: InputMaybe<Scalars['JSON']>;
  model?: InputMaybe<Scalars['String']>;
  modelNumber?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  plmActive?: InputMaybe<Scalars['Boolean']>;
  remoteSensorId?: InputMaybe<Scalars['String']>;
  remoteSensorOperating?: InputMaybe<Scalars['Boolean']>;
  serialNumber?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<Scalars['String']>;
  version?: InputMaybe<Scalars['String']>;
};

export type FilterCountDeviceNameOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['String']>;
  gte?: InputMaybe<Scalars['String']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  lt?: InputMaybe<Scalars['String']>;
  lte?: InputMaybe<Scalars['String']>;
  ne?: InputMaybe<Scalars['String']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterCountDeviceOperatorsInput = {
  _id?: InputMaybe<FilterCountDevice_IdOperatorsInput>;
  name?: InputMaybe<FilterCountDeviceNameOperatorsInput>;
  propertyId?: InputMaybe<FilterCountDevicePropertyIdOperatorsInput>;
  type?: InputMaybe<FilterCountDeviceTypeOperatorsInput>;
  unitId?: InputMaybe<FilterCountDeviceUnitIdOperatorsInput>;
};

export type FilterCountDevicePowerStateInput = {
  id?: InputMaybe<Scalars['String']>;
  observedAt?: InputMaybe<Scalars['Float']>;
  previousId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  units?: InputMaybe<Scalars['String']>;
  updatePending?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<EnumDevicePowerStateValue>;
};

export type FilterCountDevicePropertyIdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['String']>;
  gte?: InputMaybe<Scalars['String']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  lt?: InputMaybe<Scalars['String']>;
  lte?: InputMaybe<Scalars['String']>;
  ne?: InputMaybe<Scalars['String']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']>;
};

export type FilterCountDeviceReadingDeviceUidOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['String']>;
  gte?: InputMaybe<Scalars['String']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  lt?: InputMaybe<Scalars['String']>;
  lte?: InputMaybe<Scalars['String']>;
  ne?: InputMaybe<Scalars['String']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']>;
};

export type FilterCountDeviceReadingInput = {
  AND?: InputMaybe<Array<FilterCountDeviceReadingInput>>;
  OR?: InputMaybe<Array<FilterCountDeviceReadingInput>>;
  _id?: InputMaybe<Scalars['String']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterCountDeviceReadingOperatorsInput>;
  dateTime?: InputMaybe<Scalars['Float']>;
  deviceUid?: InputMaybe<Scalars['String']>;
  measurementType?: InputMaybe<Scalars['String']>;
  series?: InputMaybe<EnumDeviceReadingSeries>;
  sourceId?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<Scalars['Float']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterCountDeviceReadingOperatorsInput = {
  _id?: InputMaybe<FilterCountDeviceReading_IdOperatorsInput>;
  deviceUid?: InputMaybe<FilterCountDeviceReadingDeviceUidOperatorsInput>;
};

export type FilterCountDeviceReading_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['String']>;
  gte?: InputMaybe<Scalars['String']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  lt?: InputMaybe<Scalars['String']>;
  lte?: InputMaybe<Scalars['String']>;
  ne?: InputMaybe<Scalars['String']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']>;
};

export type FilterCountDeviceTypeOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<EnumDeviceType>;
  gte?: InputMaybe<EnumDeviceType>;
  in?: InputMaybe<Array<InputMaybe<EnumDeviceType>>>;
  lt?: InputMaybe<EnumDeviceType>;
  lte?: InputMaybe<EnumDeviceType>;
  ne?: InputMaybe<EnumDeviceType>;
  nin?: InputMaybe<Array<InputMaybe<EnumDeviceType>>>;
};

export type FilterCountDeviceUnitIdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['String']>;
  gte?: InputMaybe<Scalars['String']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  lt?: InputMaybe<Scalars['String']>;
  lte?: InputMaybe<Scalars['String']>;
  ne?: InputMaybe<Scalars['String']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']>;
};

export type FilterCountDevice_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['String']>;
  gte?: InputMaybe<Scalars['String']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  lt?: InputMaybe<Scalars['String']>;
  lte?: InputMaybe<Scalars['String']>;
  ne?: InputMaybe<Scalars['String']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']>;
};

export type FilterCountDoorSensorContactStateInput = {
  id?: InputMaybe<Scalars['String']>;
  observedAt?: InputMaybe<Scalars['Float']>;
  previousId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  units?: InputMaybe<Scalars['String']>;
  updatePending?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<Scalars['String']>;
};

export type FilterCountDoorSensorInput = {
  AND?: InputMaybe<Array<FilterCountDeviceInput>>;
  OR?: InputMaybe<Array<FilterCountDeviceInput>>;
  _id?: InputMaybe<Scalars['String']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterCountDeviceOperatorsInput>;
  alertTypes?: InputMaybe<FilterCountDeviceAlertTypesInput>;
  contactState?: InputMaybe<FilterCountDoorSensorContactStateInput>;
  controlled?: InputMaybe<FilterCountDeviceControlledInput>;
  deviceId?: InputMaybe<Scalars['String']>;
  installation?: InputMaybe<FilterCountDeviceInstallationInput>;
  location?: InputMaybe<Scalars['String']>;
  meta?: InputMaybe<FilterCountDeviceMetaInput>;
  /** The name of the device */
  name?: InputMaybe<Scalars['String']>;
  panelId?: InputMaybe<Scalars['String']>;
  powerState?: InputMaybe<FilterCountDevicePowerStateInput>;
  propertyId?: InputMaybe<Scalars['String']>;
  sourceId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  unitId?: InputMaybe<Scalars['String']>;
  updateStatus?: InputMaybe<Scalars['Boolean']>;
  voltage?: InputMaybe<FilterCountDoorSensorVoltageInput>;
  vppId?: InputMaybe<Scalars['String']>;
  zoneId?: InputMaybe<Scalars['String']>;
};

export type FilterCountDoorSensorVoltageInput = {
  id?: InputMaybe<Scalars['String']>;
  observedAt?: InputMaybe<Scalars['Float']>;
  previousId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  units?: InputMaybe<Scalars['String']>;
  updatePending?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<Scalars['Float']>;
};

export type FilterCountEnergyConsumerBuildingConnectedInput = {
  id?: InputMaybe<Scalars['String']>;
  observedAt?: InputMaybe<Scalars['Float']>;
  previousId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  units?: InputMaybe<Scalars['String']>;
  updatePending?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<Scalars['Boolean']>;
};

export type FilterCountEnergyConsumerBuildingDisconnectedAtInput = {
  id?: InputMaybe<Scalars['String']>;
  observedAt?: InputMaybe<Scalars['Float']>;
  previousId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  units?: InputMaybe<Scalars['String']>;
  updatePending?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<Scalars['Float']>;
};

export type FilterCountEnergyConsumerBuildingEnergyEfficiencyScoreInput = {
  id?: InputMaybe<Scalars['String']>;
  observedAt?: InputMaybe<Scalars['Float']>;
  previousId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  units?: InputMaybe<Scalars['String']>;
  updatePending?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<Scalars['Float']>;
};

export type FilterCountEnergyConsumerBuildingInput = {
  AND?: InputMaybe<Array<FilterCountEnergyConsumerBuildingInput>>;
  OR?: InputMaybe<Array<FilterCountEnergyConsumerBuildingInput>>;
  _id?: InputMaybe<Scalars['String']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterCountEnergyConsumerBuildingOperatorsInput>;
  circuitId?: InputMaybe<Scalars['String']>;
  connected?: InputMaybe<FilterCountEnergyConsumerBuildingConnectedInput>;
  converterId?: InputMaybe<Scalars['String']>;
  disconnectedAt?: InputMaybe<FilterCountEnergyConsumerBuildingDisconnectedAtInput>;
  energyEfficiencyScore?: InputMaybe<FilterCountEnergyConsumerBuildingEnergyEfficiencyScoreInput>;
  energySwitchPanelId?: InputMaybe<Scalars['String']>;
  inverterId?: InputMaybe<Scalars['String']>;
  lastConnectedAt?: InputMaybe<FilterCountEnergyConsumerBuildingLastConnectedAtInput>;
  location?: InputMaybe<Scalars['String']>;
  meterId?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  occupancy?: InputMaybe<FilterCountEnergyConsumerBuildingOccupancyInput>;
  powerState?: InputMaybe<FilterCountEnergyConsumerBuildingPowerStateInput>;
  propertyId?: InputMaybe<Scalars['String']>;
  tariffRateSell?: InputMaybe<FilterCountEnergyConsumerBuildingTariffRateSellInput>;
  timestamp?: InputMaybe<Scalars['Float']>;
  unitId?: InputMaybe<Scalars['String']>;
  updateStatus?: InputMaybe<Scalars['Boolean']>;
  vppId?: InputMaybe<Scalars['String']>;
};

export type FilterCountEnergyConsumerBuildingLastConnectedAtInput = {
  id?: InputMaybe<Scalars['String']>;
  observedAt?: InputMaybe<Scalars['Float']>;
  previousId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  units?: InputMaybe<Scalars['String']>;
  updatePending?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<Scalars['Float']>;
};

export type FilterCountEnergyConsumerBuildingOccupancyInput = {
  id?: InputMaybe<Scalars['String']>;
  observedAt?: InputMaybe<Scalars['Float']>;
  previousId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  units?: InputMaybe<Scalars['String']>;
  updatePending?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<Scalars['Float']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterCountEnergyConsumerBuildingOperatorsInput = {
  _id?: InputMaybe<FilterCountEnergyConsumerBuilding_IdOperatorsInput>;
};

export type FilterCountEnergyConsumerBuildingPowerStateInput = {
  id?: InputMaybe<Scalars['String']>;
  observedAt?: InputMaybe<Scalars['Float']>;
  previousId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  units?: InputMaybe<Scalars['String']>;
  updatePending?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<EnumEnergyConsumerBuildingPowerStateValue>;
};

export type FilterCountEnergyConsumerBuildingTariffRateSellInput = {
  id?: InputMaybe<Scalars['String']>;
  observedAt?: InputMaybe<Scalars['Float']>;
  previousId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  units?: InputMaybe<Scalars['String']>;
  updatePending?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<Scalars['Float']>;
};

export type FilterCountEnergyConsumerBuilding_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['String']>;
  gte?: InputMaybe<Scalars['String']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  lt?: InputMaybe<Scalars['String']>;
  lte?: InputMaybe<Scalars['String']>;
  ne?: InputMaybe<Scalars['String']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']>;
};

export type FilterCountEnergyConsumerTenantEnergyEfficiencyScoreInput = {
  id?: InputMaybe<Scalars['String']>;
  observedAt?: InputMaybe<Scalars['Float']>;
  previousId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  units?: InputMaybe<Scalars['String']>;
  updatePending?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<Scalars['Float']>;
};

export type FilterCountEnergyConsumerTenantInput = {
  AND?: InputMaybe<Array<FilterCountEnergyConsumerTenantInput>>;
  OR?: InputMaybe<Array<FilterCountEnergyConsumerTenantInput>>;
  _id?: InputMaybe<Scalars['String']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterCountEnergyConsumerTenantOperatorsInput>;
  buildingId?: InputMaybe<Scalars['String']>;
  circuitId?: InputMaybe<Scalars['String']>;
  connected?: InputMaybe<FilterCountEnergyConsumerBuildingConnectedInput>;
  contactName?: InputMaybe<Scalars['String']>;
  contactPhone?: InputMaybe<Scalars['String']>;
  converterId?: InputMaybe<Scalars['String']>;
  disconnectedAt?: InputMaybe<FilterCountEnergyConsumerBuildingDisconnectedAtInput>;
  energyEfficiencyScore?: InputMaybe<FilterCountEnergyConsumerTenantEnergyEfficiencyScoreInput>;
  energySwitchPanelId?: InputMaybe<Scalars['String']>;
  inverterId?: InputMaybe<Scalars['String']>;
  lastConnectedAt?: InputMaybe<FilterCountEnergyConsumerBuildingLastConnectedAtInput>;
  location?: InputMaybe<Scalars['String']>;
  meterId?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  occupancy?: InputMaybe<FilterCountEnergyConsumerTenantOccupancyInput>;
  powerState?: InputMaybe<FilterCountEnergyConsumerBuildingPowerStateInput>;
  propertyId?: InputMaybe<Scalars['String']>;
  tariffRateSell?: InputMaybe<FilterCountEnergyConsumerBuildingTariffRateSellInput>;
  timestamp?: InputMaybe<Scalars['Float']>;
  unitId?: InputMaybe<Scalars['String']>;
  updateStatus?: InputMaybe<Scalars['Boolean']>;
  vppId?: InputMaybe<Scalars['String']>;
};

export type FilterCountEnergyConsumerTenantOccupancyInput = {
  id?: InputMaybe<Scalars['String']>;
  observedAt?: InputMaybe<Scalars['Float']>;
  previousId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  units?: InputMaybe<Scalars['String']>;
  updatePending?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<Scalars['Float']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterCountEnergyConsumerTenantOperatorsInput = {
  _id?: InputMaybe<FilterCountEnergyConsumerTenant_IdOperatorsInput>;
};

export type FilterCountEnergyConsumerTenant_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['String']>;
  gte?: InputMaybe<Scalars['String']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  lt?: InputMaybe<Scalars['String']>;
  lte?: InputMaybe<Scalars['String']>;
  ne?: InputMaybe<Scalars['String']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']>;
};

export type FilterCountEnergyConsumerUtilityContractStatusInput = {
  id?: InputMaybe<Scalars['String']>;
  observedAt?: InputMaybe<Scalars['Float']>;
  previousId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  units?: InputMaybe<Scalars['String']>;
  updatePending?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<Scalars['String']>;
};

export type FilterCountEnergyConsumerUtilityExportAllowanceInput = {
  id?: InputMaybe<Scalars['String']>;
  observedAt?: InputMaybe<Scalars['Float']>;
  previousId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  units?: InputMaybe<Scalars['String']>;
  updatePending?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<Scalars['Float']>;
};

export type FilterCountEnergyConsumerUtilityGridFrequencyInput = {
  id?: InputMaybe<Scalars['String']>;
  observedAt?: InputMaybe<Scalars['Float']>;
  previousId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  units?: InputMaybe<Scalars['String']>;
  updatePending?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<Scalars['Float']>;
};

export type FilterCountEnergyConsumerUtilityInput = {
  AND?: InputMaybe<Array<FilterCountEnergyConsumerUtilityInput>>;
  OR?: InputMaybe<Array<FilterCountEnergyConsumerUtilityInput>>;
  _id?: InputMaybe<Scalars['String']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterCountEnergyConsumerUtilityOperatorsInput>;
  circuitId?: InputMaybe<Scalars['String']>;
  connected?: InputMaybe<FilterCountEnergyConsumerBuildingConnectedInput>;
  contractStatus?: InputMaybe<FilterCountEnergyConsumerUtilityContractStatusInput>;
  converterId?: InputMaybe<Scalars['String']>;
  disconnectedAt?: InputMaybe<FilterCountEnergyConsumerBuildingDisconnectedAtInput>;
  energySwitchPanelId?: InputMaybe<Scalars['String']>;
  exportAllowance?: InputMaybe<FilterCountEnergyConsumerUtilityExportAllowanceInput>;
  gridFrequency?: InputMaybe<FilterCountEnergyConsumerUtilityGridFrequencyInput>;
  interconnectionCapacity?: InputMaybe<FilterCountEnergyConsumerUtilityInterconnectionCapacityInput>;
  inverterId?: InputMaybe<Scalars['String']>;
  lastConnectedAt?: InputMaybe<FilterCountEnergyConsumerBuildingLastConnectedAtInput>;
  location?: InputMaybe<Scalars['String']>;
  meterId?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  powerState?: InputMaybe<FilterCountEnergyConsumerBuildingPowerStateInput>;
  propertyId?: InputMaybe<Scalars['String']>;
  tariffRateSell?: InputMaybe<FilterCountEnergyConsumerBuildingTariffRateSellInput>;
  timestamp?: InputMaybe<Scalars['Float']>;
  unitId?: InputMaybe<Scalars['String']>;
  updateStatus?: InputMaybe<Scalars['Boolean']>;
  vppId?: InputMaybe<Scalars['String']>;
};

export type FilterCountEnergyConsumerUtilityInterconnectionCapacityInput = {
  id?: InputMaybe<Scalars['String']>;
  observedAt?: InputMaybe<Scalars['Float']>;
  previousId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  units?: InputMaybe<Scalars['String']>;
  updatePending?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<Scalars['Float']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterCountEnergyConsumerUtilityOperatorsInput = {
  _id?: InputMaybe<FilterCountEnergyConsumerUtility_IdOperatorsInput>;
};

export type FilterCountEnergyConsumerUtility_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['String']>;
  gte?: InputMaybe<Scalars['String']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  lt?: InputMaybe<Scalars['String']>;
  lte?: InputMaybe<Scalars['String']>;
  ne?: InputMaybe<Scalars['String']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']>;
};

export type FilterCountEnergyControllerAvailabilityStatusInput = {
  id?: InputMaybe<Scalars['String']>;
  observedAt?: InputMaybe<Scalars['Float']>;
  previousId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  units?: InputMaybe<Scalars['String']>;
  updatePending?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<EnumEnergyControllerAvailabilityStatusValue>;
};

export type FilterCountEnergyControllerChargeRegulationStatusInput = {
  id?: InputMaybe<Scalars['String']>;
  observedAt?: InputMaybe<Scalars['Float']>;
  previousId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  units?: InputMaybe<Scalars['String']>;
  updatePending?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<EnumEnergyControllerChargeRegulationStatusValue>;
};

export type FilterCountEnergyControllerCurrentAtMppInput = {
  id?: InputMaybe<Scalars['String']>;
  observedAt?: InputMaybe<Scalars['Float']>;
  previousId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  units?: InputMaybe<Scalars['String']>;
  updatePending?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<Scalars['Float']>;
};

export type FilterCountEnergyControllerEnergyGeneratedInput = {
  id?: InputMaybe<Scalars['String']>;
  observedAt?: InputMaybe<Scalars['Float']>;
  previousId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  units?: InputMaybe<Scalars['String']>;
  updatePending?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<Scalars['Float']>;
};

export type FilterCountEnergyControllerInput = {
  AND?: InputMaybe<Array<FilterCountDeviceInput>>;
  OR?: InputMaybe<Array<FilterCountDeviceInput>>;
  _id?: InputMaybe<Scalars['String']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterCountDeviceOperatorsInput>;
  alertTypes?: InputMaybe<FilterCountDeviceAlertTypesInput>;
  availabilityStatus?: InputMaybe<FilterCountEnergyControllerAvailabilityStatusInput>;
  chargeRegulationStatus?: InputMaybe<FilterCountEnergyControllerChargeRegulationStatusInput>;
  controlled?: InputMaybe<FilterCountDeviceControlledInput>;
  currentAtMpp?: InputMaybe<FilterCountEnergyControllerCurrentAtMppInput>;
  deviceId?: InputMaybe<Scalars['String']>;
  energyGenerated?: InputMaybe<FilterCountEnergyControllerEnergyGeneratedInput>;
  installation?: InputMaybe<FilterCountDeviceInstallationInput>;
  location?: InputMaybe<Scalars['String']>;
  meta?: InputMaybe<FilterCountDeviceMetaInput>;
  /** The name of the device */
  name?: InputMaybe<Scalars['String']>;
  panelId?: InputMaybe<Scalars['String']>;
  powerState?: InputMaybe<FilterCountDevicePowerStateInput>;
  propertyId?: InputMaybe<Scalars['String']>;
  rectifierId?: InputMaybe<Scalars['String']>;
  rotorSpeedAtMPP?: InputMaybe<FilterCountEnergyControllerRotorSpeedAtMppInput>;
  sourceId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  unitId?: InputMaybe<Scalars['String']>;
  updateStatus?: InputMaybe<Scalars['Boolean']>;
  voltageAtMpp?: InputMaybe<FilterCountEnergyControllerVoltageAtMppInput>;
  vppId?: InputMaybe<Scalars['String']>;
  zoneId?: InputMaybe<Scalars['String']>;
};

export type FilterCountEnergyControllerRotorSpeedAtMppInput = {
  id?: InputMaybe<Scalars['String']>;
  observedAt?: InputMaybe<Scalars['Float']>;
  previousId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  units?: InputMaybe<Scalars['String']>;
  updatePending?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<Scalars['Float']>;
};

export type FilterCountEnergyControllerVoltageAtMppInput = {
  id?: InputMaybe<Scalars['String']>;
  observedAt?: InputMaybe<Scalars['Float']>;
  previousId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  units?: InputMaybe<Scalars['String']>;
  updatePending?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<Scalars['Float']>;
};

export type FilterCountEnergyConverterChargeRateInput = {
  id?: InputMaybe<Scalars['String']>;
  observedAt?: InputMaybe<Scalars['Float']>;
  previousId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  units?: InputMaybe<Scalars['String']>;
  updatePending?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<Scalars['Float']>;
};

export type FilterCountEnergyConverterDischargeRateInput = {
  id?: InputMaybe<Scalars['String']>;
  observedAt?: InputMaybe<Scalars['Float']>;
  previousId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  units?: InputMaybe<Scalars['String']>;
  updatePending?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<Scalars['Float']>;
};

export type FilterCountEnergyConverterEfficiencyInput = {
  id?: InputMaybe<Scalars['String']>;
  observedAt?: InputMaybe<Scalars['Float']>;
  previousId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  units?: InputMaybe<Scalars['String']>;
  updatePending?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<Scalars['Float']>;
};

export type FilterCountEnergyConverterInput = {
  AND?: InputMaybe<Array<FilterCountDeviceInput>>;
  OR?: InputMaybe<Array<FilterCountDeviceInput>>;
  _id?: InputMaybe<Scalars['String']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterCountDeviceOperatorsInput>;
  alertTypes?: InputMaybe<FilterCountDeviceAlertTypesInput>;
  chargeRate?: InputMaybe<FilterCountEnergyConverterChargeRateInput>;
  controlled?: InputMaybe<FilterCountDeviceControlledInput>;
  deviceId?: InputMaybe<Scalars['String']>;
  dischargeRate?: InputMaybe<FilterCountEnergyConverterDischargeRateInput>;
  efficiency?: InputMaybe<FilterCountEnergyConverterEfficiencyInput>;
  inputVoltage?: InputMaybe<FilterCountEnergyConverterInputVoltageInput>;
  installation?: InputMaybe<FilterCountDeviceInstallationInput>;
  location?: InputMaybe<Scalars['String']>;
  meta?: InputMaybe<FilterCountDeviceMetaInput>;
  /** The name of the device */
  name?: InputMaybe<Scalars['String']>;
  outputVoltage?: InputMaybe<FilterCountEnergyConverterOutputVoltageInput>;
  panelId?: InputMaybe<Scalars['String']>;
  powerOutput?: InputMaybe<FilterCountEnergyConverterPowerOutputInput>;
  powerState?: InputMaybe<FilterCountDevicePowerStateInput>;
  propertyId?: InputMaybe<Scalars['String']>;
  sourceId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  unitId?: InputMaybe<Scalars['String']>;
  updateStatus?: InputMaybe<Scalars['Boolean']>;
  vppId?: InputMaybe<Scalars['String']>;
  zoneId?: InputMaybe<Scalars['String']>;
};

export type FilterCountEnergyConverterInputVoltageInput = {
  id?: InputMaybe<Scalars['String']>;
  observedAt?: InputMaybe<Scalars['Float']>;
  previousId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  units?: InputMaybe<Scalars['String']>;
  updatePending?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<Scalars['Float']>;
};

export type FilterCountEnergyConverterOutputVoltageInput = {
  id?: InputMaybe<Scalars['String']>;
  observedAt?: InputMaybe<Scalars['Float']>;
  previousId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  units?: InputMaybe<Scalars['String']>;
  updatePending?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<Scalars['Float']>;
};

export type FilterCountEnergyConverterPowerOutputInput = {
  id?: InputMaybe<Scalars['String']>;
  observedAt?: InputMaybe<Scalars['Float']>;
  previousId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  units?: InputMaybe<Scalars['String']>;
  updatePending?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<Scalars['Float']>;
};

export type FilterCountEnergyInverterAvailabilityStatusInput = {
  id?: InputMaybe<Scalars['String']>;
  observedAt?: InputMaybe<Scalars['Float']>;
  previousId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  units?: InputMaybe<Scalars['String']>;
  updatePending?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<EnumEnergyInverterAvailabilityStatusValue>;
};

export type FilterCountEnergyInverterChargeRateInput = {
  id?: InputMaybe<Scalars['String']>;
  observedAt?: InputMaybe<Scalars['Float']>;
  previousId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  units?: InputMaybe<Scalars['String']>;
  updatePending?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<Scalars['Float']>;
};

export type FilterCountEnergyInverterDischargeRateInput = {
  id?: InputMaybe<Scalars['String']>;
  observedAt?: InputMaybe<Scalars['Float']>;
  previousId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  units?: InputMaybe<Scalars['String']>;
  updatePending?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<Scalars['Float']>;
};

export type FilterCountEnergyInverterEfficiencyInput = {
  id?: InputMaybe<Scalars['String']>;
  observedAt?: InputMaybe<Scalars['Float']>;
  previousId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  units?: InputMaybe<Scalars['String']>;
  updatePending?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<Scalars['Float']>;
};

export type FilterCountEnergyInverterFrequencyInput = {
  id?: InputMaybe<Scalars['String']>;
  observedAt?: InputMaybe<Scalars['Float']>;
  previousId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  units?: InputMaybe<Scalars['String']>;
  updatePending?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<Scalars['Float']>;
};

export type FilterCountEnergyInverterInput = {
  AND?: InputMaybe<Array<FilterCountDeviceInput>>;
  OR?: InputMaybe<Array<FilterCountDeviceInput>>;
  _id?: InputMaybe<Scalars['String']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterCountDeviceOperatorsInput>;
  alertTypes?: InputMaybe<FilterCountDeviceAlertTypesInput>;
  availabilityStatus?: InputMaybe<FilterCountEnergyInverterAvailabilityStatusInput>;
  chargeRate?: InputMaybe<FilterCountEnergyInverterChargeRateInput>;
  controlled?: InputMaybe<FilterCountDeviceControlledInput>;
  controllerId?: InputMaybe<Scalars['String']>;
  deviceId?: InputMaybe<Scalars['String']>;
  dischargeRate?: InputMaybe<FilterCountEnergyInverterDischargeRateInput>;
  efficiency?: InputMaybe<FilterCountEnergyInverterEfficiencyInput>;
  frequency?: InputMaybe<FilterCountEnergyInverterFrequencyInput>;
  installation?: InputMaybe<FilterCountDeviceInstallationInput>;
  inverterTemperature?: InputMaybe<FilterCountEnergyInverterInverterTemperatureInput>;
  location?: InputMaybe<Scalars['String']>;
  meta?: InputMaybe<FilterCountDeviceMetaInput>;
  /** The name of the device */
  name?: InputMaybe<Scalars['String']>;
  panelId?: InputMaybe<Scalars['String']>;
  powerInputBattery?: InputMaybe<FilterCountEnergyInverterPowerInputBatteryInput>;
  powerInputKinetic?: InputMaybe<FilterCountEnergyInverterPowerInputKineticInput>;
  powerOutput?: InputMaybe<FilterCountEnergyInverterPowerOutputInput>;
  powerRating?: InputMaybe<FilterCountEnergyInverterPowerRatingInput>;
  powerState?: InputMaybe<FilterCountDevicePowerStateInput>;
  propertyId?: InputMaybe<Scalars['String']>;
  reactivePower?: InputMaybe<FilterCountEnergyInverterReactivePowerInput>;
  rectifierId?: InputMaybe<Scalars['String']>;
  sourceId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  unitId?: InputMaybe<Scalars['String']>;
  updateStatus?: InputMaybe<Scalars['Boolean']>;
  voltageOutput?: InputMaybe<FilterCountEnergyInverterVoltageOutputInput>;
  vppId?: InputMaybe<Scalars['String']>;
  zoneId?: InputMaybe<Scalars['String']>;
};

export type FilterCountEnergyInverterInverterTemperatureInput = {
  id?: InputMaybe<Scalars['String']>;
  observedAt?: InputMaybe<Scalars['Float']>;
  previousId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  units?: InputMaybe<Scalars['String']>;
  updatePending?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<Scalars['Float']>;
};

export type FilterCountEnergyInverterPowerInputBatteryInput = {
  id?: InputMaybe<Scalars['String']>;
  observedAt?: InputMaybe<Scalars['Float']>;
  previousId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  units?: InputMaybe<Scalars['String']>;
  updatePending?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<Scalars['Float']>;
};

export type FilterCountEnergyInverterPowerInputKineticInput = {
  id?: InputMaybe<Scalars['String']>;
  observedAt?: InputMaybe<Scalars['Float']>;
  previousId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  units?: InputMaybe<Scalars['String']>;
  updatePending?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<Scalars['Float']>;
};

export type FilterCountEnergyInverterPowerOutputInput = {
  id?: InputMaybe<Scalars['String']>;
  observedAt?: InputMaybe<Scalars['Float']>;
  previousId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  units?: InputMaybe<Scalars['String']>;
  updatePending?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<Scalars['Float']>;
};

export type FilterCountEnergyInverterPowerRatingInput = {
  id?: InputMaybe<Scalars['String']>;
  observedAt?: InputMaybe<Scalars['Float']>;
  previousId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  units?: InputMaybe<Scalars['String']>;
  updatePending?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<Scalars['Float']>;
};

export type FilterCountEnergyInverterReactivePowerInput = {
  id?: InputMaybe<Scalars['String']>;
  observedAt?: InputMaybe<Scalars['Float']>;
  previousId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  units?: InputMaybe<Scalars['String']>;
  updatePending?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<Scalars['Float']>;
};

export type FilterCountEnergyInverterVoltageOutputInput = {
  id?: InputMaybe<Scalars['String']>;
  observedAt?: InputMaybe<Scalars['Float']>;
  previousId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  units?: InputMaybe<Scalars['String']>;
  updatePending?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<Scalars['Float']>;
};

export type FilterCountEnergyMeterCurrentInput = {
  id?: InputMaybe<Scalars['String']>;
  observedAt?: InputMaybe<Scalars['Float']>;
  previousId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  units?: InputMaybe<Scalars['String']>;
  updatePending?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<Scalars['Float']>;
};

export type FilterCountEnergyMeterEnergyConsumedInput = {
  id?: InputMaybe<Scalars['String']>;
  observedAt?: InputMaybe<Scalars['Float']>;
  previousId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  units?: InputMaybe<Scalars['String']>;
  updatePending?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<Scalars['Float']>;
};

export type FilterCountEnergyMeterFrequencyInput = {
  id?: InputMaybe<Scalars['String']>;
  observedAt?: InputMaybe<Scalars['Float']>;
  previousId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  units?: InputMaybe<Scalars['String']>;
  updatePending?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<Scalars['Float']>;
};

export type FilterCountEnergyMeterInput = {
  AND?: InputMaybe<Array<FilterCountDeviceInput>>;
  OR?: InputMaybe<Array<FilterCountDeviceInput>>;
  _id?: InputMaybe<Scalars['String']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterCountDeviceOperatorsInput>;
  alertTypes?: InputMaybe<FilterCountDeviceAlertTypesInput>;
  controlled?: InputMaybe<FilterCountDeviceControlledInput>;
  current?: InputMaybe<FilterCountEnergyMeterCurrentInput>;
  deviceId?: InputMaybe<Scalars['String']>;
  energyConsumed?: InputMaybe<FilterCountEnergyMeterEnergyConsumedInput>;
  frequency?: InputMaybe<FilterCountEnergyMeterFrequencyInput>;
  installation?: InputMaybe<FilterCountDeviceInstallationInput>;
  location?: InputMaybe<Scalars['String']>;
  meta?: InputMaybe<FilterCountDeviceMetaInput>;
  /** The name of the device */
  name?: InputMaybe<Scalars['String']>;
  outputEnabled?: InputMaybe<FilterCountEnergyMeterOutputEnabledInput>;
  panelId?: InputMaybe<Scalars['String']>;
  powerDemand?: InputMaybe<FilterCountEnergyMeterPowerDemandInput>;
  powerFactor?: InputMaybe<FilterCountEnergyMeterPowerFactorInput>;
  powerState?: InputMaybe<FilterCountDevicePowerStateInput>;
  propertyId?: InputMaybe<Scalars['String']>;
  sourceId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  unitId?: InputMaybe<Scalars['String']>;
  updateStatus?: InputMaybe<Scalars['Boolean']>;
  voltage?: InputMaybe<FilterCountEnergyMeterVoltageInput>;
  vppId?: InputMaybe<Scalars['String']>;
  zoneId?: InputMaybe<Scalars['String']>;
};

export type FilterCountEnergyMeterOutputEnabledInput = {
  id?: InputMaybe<Scalars['String']>;
  observedAt?: InputMaybe<Scalars['Float']>;
  previousId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  units?: InputMaybe<Scalars['String']>;
  updatePending?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<Scalars['Boolean']>;
};

export type FilterCountEnergyMeterPowerDemandInput = {
  id?: InputMaybe<Scalars['String']>;
  observedAt?: InputMaybe<Scalars['Float']>;
  previousId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  units?: InputMaybe<Scalars['String']>;
  updatePending?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<Scalars['Float']>;
};

export type FilterCountEnergyMeterPowerFactorInput = {
  id?: InputMaybe<Scalars['String']>;
  observedAt?: InputMaybe<Scalars['Float']>;
  previousId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  units?: InputMaybe<Scalars['String']>;
  updatePending?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<Scalars['Float']>;
};

export type FilterCountEnergyMeterVoltageInput = {
  id?: InputMaybe<Scalars['String']>;
  observedAt?: InputMaybe<Scalars['Float']>;
  previousId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  units?: InputMaybe<Scalars['String']>;
  updatePending?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<Scalars['Float']>;
};

export type FilterCountEnergyRectifierInput = {
  AND?: InputMaybe<Array<FilterCountDeviceInput>>;
  OR?: InputMaybe<Array<FilterCountDeviceInput>>;
  _id?: InputMaybe<Scalars['String']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterCountDeviceOperatorsInput>;
  alertTypes?: InputMaybe<FilterCountDeviceAlertTypesInput>;
  controlled?: InputMaybe<FilterCountDeviceControlledInput>;
  deviceId?: InputMaybe<Scalars['String']>;
  installation?: InputMaybe<FilterCountDeviceInstallationInput>;
  location?: InputMaybe<Scalars['String']>;
  meta?: InputMaybe<FilterCountDeviceMetaInput>;
  /** The name of the device */
  name?: InputMaybe<Scalars['String']>;
  outputVoltage?: InputMaybe<FilterCountEnergyRectifierOutputVoltageInput>;
  panelId?: InputMaybe<Scalars['String']>;
  powerState?: InputMaybe<FilterCountDevicePowerStateInput>;
  propertyId?: InputMaybe<Scalars['String']>;
  rectifierEfficiency?: InputMaybe<FilterCountEnergyRectifierRectifierEfficiencyInput>;
  sourceId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  unitId?: InputMaybe<Scalars['String']>;
  updateStatus?: InputMaybe<Scalars['Boolean']>;
  vppId?: InputMaybe<Scalars['String']>;
  zoneId?: InputMaybe<Scalars['String']>;
};

export type FilterCountEnergyRectifierOutputVoltageInput = {
  id?: InputMaybe<Scalars['String']>;
  observedAt?: InputMaybe<Scalars['Float']>;
  previousId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  units?: InputMaybe<Scalars['String']>;
  updatePending?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<Scalars['Float']>;
};

export type FilterCountEnergyRectifierRectifierEfficiencyInput = {
  id?: InputMaybe<Scalars['String']>;
  observedAt?: InputMaybe<Scalars['Float']>;
  previousId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  units?: InputMaybe<Scalars['String']>;
  updatePending?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<Scalars['Float']>;
};

export type FilterCountEnergyStorageBatterySystemInput = {
  AND?: InputMaybe<Array<FilterCountEnergyStorageBatterySystemInput>>;
  OR?: InputMaybe<Array<FilterCountEnergyStorageBatterySystemInput>>;
  _id?: InputMaybe<Scalars['String']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterCountEnergyStorageBatterySystemOperatorsInput>;
  batteryManagementSystemId?: InputMaybe<Scalars['String']>;
  connected?: InputMaybe<FilterCountEnergyConsumerBuildingConnectedInput>;
  controllerId?: InputMaybe<Scalars['String']>;
  converterId?: InputMaybe<Scalars['String']>;
  coolingSystemId?: InputMaybe<Scalars['String']>;
  disconnectedAt?: InputMaybe<FilterCountEnergyConsumerBuildingDisconnectedAtInput>;
  fireSuppressionSystemId?: InputMaybe<Scalars['String']>;
  inverterId?: InputMaybe<Scalars['String']>;
  lastConnectedAt?: InputMaybe<FilterCountEnergyConsumerBuildingLastConnectedAtInput>;
  location?: InputMaybe<Scalars['String']>;
  maintenanceScheduleStatus?: InputMaybe<FilterCountEnergyStorageBatterySystemMaintenanceScheduleStatusInput>;
  maximumEnergyCapacity?: InputMaybe<FilterCountEnergyStorageBatterySystemMaximumEnergyCapacityInput>;
  modeOfOperation?: InputMaybe<FilterCountEnergyStorageBatterySystemModeOfOperationInput>;
  name?: InputMaybe<Scalars['String']>;
  powerState?: InputMaybe<FilterCountEnergyConsumerBuildingPowerStateInput>;
  propertyId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  unitId?: InputMaybe<Scalars['String']>;
  updateStatus?: InputMaybe<Scalars['Boolean']>;
  vppId?: InputMaybe<Scalars['String']>;
};

export type FilterCountEnergyStorageBatterySystemMaintenanceScheduleStatusInput =
  {
    id?: InputMaybe<Scalars['String']>;
    observedAt?: InputMaybe<Scalars['Float']>;
    previousId?: InputMaybe<Scalars['String']>;
    timestamp?: InputMaybe<Scalars['Float']>;
    units?: InputMaybe<Scalars['String']>;
    updatePending?: InputMaybe<Scalars['Boolean']>;
    value?: InputMaybe<EnumEnergyStorageBatterySystemMaintenanceScheduleStatusValue>;
  };

export type FilterCountEnergyStorageBatterySystemMaximumEnergyCapacityInput = {
  id?: InputMaybe<Scalars['String']>;
  observedAt?: InputMaybe<Scalars['Float']>;
  previousId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  units?: InputMaybe<Scalars['String']>;
  updatePending?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<Scalars['Float']>;
};

export type FilterCountEnergyStorageBatterySystemModeOfOperationInput = {
  id?: InputMaybe<Scalars['String']>;
  observedAt?: InputMaybe<Scalars['Float']>;
  previousId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  units?: InputMaybe<Scalars['String']>;
  updatePending?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<EnumEnergyStorageBatterySystemModeOfOperationValue>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterCountEnergyStorageBatterySystemOperatorsInput = {
  _id?: InputMaybe<FilterCountEnergyStorageBatterySystem_IdOperatorsInput>;
};

export type FilterCountEnergyStorageBatterySystem_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['String']>;
  gte?: InputMaybe<Scalars['String']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  lt?: InputMaybe<Scalars['String']>;
  lte?: InputMaybe<Scalars['String']>;
  ne?: InputMaybe<Scalars['String']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']>;
};

export type FilterCountEnergyStorageCoolingSystemCoolingHeatingStatusInput = {
  id?: InputMaybe<Scalars['String']>;
  observedAt?: InputMaybe<Scalars['Float']>;
  previousId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  units?: InputMaybe<Scalars['String']>;
  updatePending?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<EnumEnergyStorageCoolingSystemCoolingHeatingStatusValue>;
};

export type FilterCountEnergyStorageCoolingSystemInput = {
  AND?: InputMaybe<Array<FilterCountDeviceInput>>;
  OR?: InputMaybe<Array<FilterCountDeviceInput>>;
  _id?: InputMaybe<Scalars['String']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterCountDeviceOperatorsInput>;
  alertTypes?: InputMaybe<FilterCountDeviceAlertTypesInput>;
  controlled?: InputMaybe<FilterCountDeviceControlledInput>;
  coolingHeatingStatus?: InputMaybe<FilterCountEnergyStorageCoolingSystemCoolingHeatingStatusInput>;
  deviceId?: InputMaybe<Scalars['String']>;
  installation?: InputMaybe<FilterCountDeviceInstallationInput>;
  location?: InputMaybe<Scalars['String']>;
  meta?: InputMaybe<FilterCountDeviceMetaInput>;
  /** The name of the device */
  name?: InputMaybe<Scalars['String']>;
  panelId?: InputMaybe<Scalars['String']>;
  powerState?: InputMaybe<FilterCountDevicePowerStateInput>;
  propertyId?: InputMaybe<Scalars['String']>;
  sourceId?: InputMaybe<Scalars['String']>;
  temperature?: InputMaybe<FilterCountEnergyStorageCoolingSystemTemperatureInput>;
  timestamp?: InputMaybe<Scalars['Float']>;
  unitId?: InputMaybe<Scalars['String']>;
  updateStatus?: InputMaybe<Scalars['Boolean']>;
  vppId?: InputMaybe<Scalars['String']>;
  zoneId?: InputMaybe<Scalars['String']>;
};

export type FilterCountEnergyStorageCoolingSystemTemperatureInput = {
  id?: InputMaybe<Scalars['String']>;
  observedAt?: InputMaybe<Scalars['Float']>;
  previousId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  units?: InputMaybe<Scalars['String']>;
  updatePending?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<Scalars['Float']>;
};

export type FilterCountEnergyStorageKineticSystemInput = {
  AND?: InputMaybe<Array<FilterCountEnergyStorageKineticSystemInput>>;
  OR?: InputMaybe<Array<FilterCountEnergyStorageKineticSystemInput>>;
  _id?: InputMaybe<Scalars['String']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterCountEnergyStorageKineticSystemOperatorsInput>;
  connected?: InputMaybe<FilterCountEnergyConsumerBuildingConnectedInput>;
  controllerId?: InputMaybe<Scalars['String']>;
  converterId?: InputMaybe<Scalars['String']>;
  coolingSystemId?: InputMaybe<Scalars['String']>;
  disconnectedAt?: InputMaybe<FilterCountEnergyConsumerBuildingDisconnectedAtInput>;
  fireSuppressionSystemId?: InputMaybe<Scalars['String']>;
  inverterId?: InputMaybe<Scalars['String']>;
  kemsId?: InputMaybe<Scalars['String']>;
  lastConnectedAt?: InputMaybe<FilterCountEnergyConsumerBuildingLastConnectedAtInput>;
  location?: InputMaybe<Scalars['String']>;
  maintenanceScheduleStatus?: InputMaybe<FilterCountEnergyStorageBatterySystemMaintenanceScheduleStatusInput>;
  maximumEnergyCapacity?: InputMaybe<FilterCountEnergyStorageBatterySystemMaximumEnergyCapacityInput>;
  modeOfOperation?: InputMaybe<FilterCountEnergyStorageBatterySystemModeOfOperationInput>;
  name?: InputMaybe<Scalars['String']>;
  powerState?: InputMaybe<FilterCountEnergyConsumerBuildingPowerStateInput>;
  propertyId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  unitId?: InputMaybe<Scalars['String']>;
  updateStatus?: InputMaybe<Scalars['Boolean']>;
  vppId?: InputMaybe<Scalars['String']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterCountEnergyStorageKineticSystemOperatorsInput = {
  _id?: InputMaybe<FilterCountEnergyStorageKineticSystem_IdOperatorsInput>;
};

export type FilterCountEnergyStorageKineticSystem_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['String']>;
  gte?: InputMaybe<Scalars['String']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  lt?: InputMaybe<Scalars['String']>;
  lte?: InputMaybe<Scalars['String']>;
  ne?: InputMaybe<Scalars['String']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']>;
};

export type FilterCountEnergySupplierSolarSystemAzimuthInput = {
  id?: InputMaybe<Scalars['String']>;
  observedAt?: InputMaybe<Scalars['Float']>;
  previousId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  units?: InputMaybe<Scalars['String']>;
  updatePending?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<Scalars['Float']>;
};

export type FilterCountEnergySupplierSolarSystemInput = {
  AND?: InputMaybe<Array<FilterCountEnergySupplierSolarSystemInput>>;
  OR?: InputMaybe<Array<FilterCountEnergySupplierSolarSystemInput>>;
  _id?: InputMaybe<Scalars['String']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterCountEnergySupplierSolarSystemOperatorsInput>;
  azimuth?: InputMaybe<FilterCountEnergySupplierSolarSystemAzimuthInput>;
  connected?: InputMaybe<FilterCountEnergyConsumerBuildingConnectedInput>;
  controllerId?: InputMaybe<Scalars['String']>;
  disconnectedAt?: InputMaybe<FilterCountEnergyConsumerBuildingDisconnectedAtInput>;
  inverterId?: InputMaybe<Scalars['String']>;
  lastConnectedAt?: InputMaybe<FilterCountEnergyConsumerBuildingLastConnectedAtInput>;
  location?: InputMaybe<Scalars['String']>;
  maximumPowerOutput?: InputMaybe<Scalars['Float']>;
  name?: InputMaybe<Scalars['String']>;
  powerState?: InputMaybe<FilterCountEnergyConsumerBuildingPowerStateInput>;
  propertyId?: InputMaybe<Scalars['String']>;
  smsId?: InputMaybe<Scalars['String']>;
  tiltAngle?: InputMaybe<FilterCountEnergySupplierSolarSystemTiltAngleInput>;
  timestamp?: InputMaybe<Scalars['Float']>;
  unitId?: InputMaybe<Scalars['String']>;
  updateStatus?: InputMaybe<Scalars['Boolean']>;
  vppId?: InputMaybe<Scalars['String']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterCountEnergySupplierSolarSystemOperatorsInput = {
  _id?: InputMaybe<FilterCountEnergySupplierSolarSystem_IdOperatorsInput>;
};

export type FilterCountEnergySupplierSolarSystemTiltAngleInput = {
  id?: InputMaybe<Scalars['String']>;
  observedAt?: InputMaybe<Scalars['Float']>;
  previousId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  units?: InputMaybe<Scalars['String']>;
  updatePending?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<Scalars['Float']>;
};

export type FilterCountEnergySupplierSolarSystem_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['String']>;
  gte?: InputMaybe<Scalars['String']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  lt?: InputMaybe<Scalars['String']>;
  lte?: InputMaybe<Scalars['String']>;
  ne?: InputMaybe<Scalars['String']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']>;
};

export type FilterCountEnergySupplierUtilityContractedCapacityInput = {
  id?: InputMaybe<Scalars['String']>;
  observedAt?: InputMaybe<Scalars['Float']>;
  previousId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  units?: InputMaybe<Scalars['String']>;
  updatePending?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<Scalars['Float']>;
};

export type FilterCountEnergySupplierUtilityInput = {
  AND?: InputMaybe<Array<FilterCountEnergySupplierUtilityInput>>;
  OR?: InputMaybe<Array<FilterCountEnergySupplierUtilityInput>>;
  _id?: InputMaybe<Scalars['String']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterCountEnergySupplierUtilityOperatorsInput>;
  connected?: InputMaybe<FilterCountEnergyConsumerBuildingConnectedInput>;
  contractedCapacity?: InputMaybe<FilterCountEnergySupplierUtilityContractedCapacityInput>;
  controllerId?: InputMaybe<Scalars['String']>;
  disconnectedAt?: InputMaybe<FilterCountEnergyConsumerBuildingDisconnectedAtInput>;
  inverterId?: InputMaybe<Scalars['String']>;
  lastConnectedAt?: InputMaybe<FilterCountEnergyConsumerBuildingLastConnectedAtInput>;
  location?: InputMaybe<Scalars['String']>;
  maximumPowerOutput?: InputMaybe<Scalars['Float']>;
  meteringAccuracy?: InputMaybe<FilterCountEnergySupplierUtilityMeteringAccuracyInput>;
  name?: InputMaybe<Scalars['String']>;
  powerState?: InputMaybe<FilterCountEnergyConsumerBuildingPowerStateInput>;
  propertyId?: InputMaybe<Scalars['String']>;
  tariffRate?: InputMaybe<FilterCountEnergySupplierUtilityTariffRateInput>;
  timestamp?: InputMaybe<Scalars['Float']>;
  unitId?: InputMaybe<Scalars['String']>;
  updateStatus?: InputMaybe<Scalars['Boolean']>;
  vppId?: InputMaybe<Scalars['String']>;
};

export type FilterCountEnergySupplierUtilityMeteringAccuracyInput = {
  id?: InputMaybe<Scalars['String']>;
  observedAt?: InputMaybe<Scalars['Float']>;
  previousId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  units?: InputMaybe<Scalars['String']>;
  updatePending?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<Scalars['Float']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterCountEnergySupplierUtilityOperatorsInput = {
  _id?: InputMaybe<FilterCountEnergySupplierUtility_IdOperatorsInput>;
};

export type FilterCountEnergySupplierUtilityTariffRateInput = {
  id?: InputMaybe<Scalars['String']>;
  observedAt?: InputMaybe<Scalars['Float']>;
  previousId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  units?: InputMaybe<Scalars['String']>;
  updatePending?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<Scalars['Float']>;
};

export type FilterCountEnergySupplierUtility_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['String']>;
  gte?: InputMaybe<Scalars['String']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  lt?: InputMaybe<Scalars['String']>;
  lte?: InputMaybe<Scalars['String']>;
  ne?: InputMaybe<Scalars['String']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']>;
};

export type FilterCountEnergySupplierWindSystemCutInSpeedInput = {
  id?: InputMaybe<Scalars['String']>;
  observedAt?: InputMaybe<Scalars['Float']>;
  previousId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  units?: InputMaybe<Scalars['String']>;
  updatePending?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<Scalars['Float']>;
};

export type FilterCountEnergySupplierWindSystemCutOutSpeedInput = {
  id?: InputMaybe<Scalars['String']>;
  observedAt?: InputMaybe<Scalars['Float']>;
  previousId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  units?: InputMaybe<Scalars['String']>;
  updatePending?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<Scalars['Float']>;
};

export type FilterCountEnergySupplierWindSystemInput = {
  AND?: InputMaybe<Array<FilterCountEnergySupplierWindSystemInput>>;
  OR?: InputMaybe<Array<FilterCountEnergySupplierWindSystemInput>>;
  _id?: InputMaybe<Scalars['String']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterCountEnergySupplierWindSystemOperatorsInput>;
  connected?: InputMaybe<FilterCountEnergyConsumerBuildingConnectedInput>;
  controllerId?: InputMaybe<Scalars['String']>;
  cutInSpeed?: InputMaybe<FilterCountEnergySupplierWindSystemCutInSpeedInput>;
  cutOutSpeed?: InputMaybe<FilterCountEnergySupplierWindSystemCutOutSpeedInput>;
  disconnectedAt?: InputMaybe<FilterCountEnergyConsumerBuildingDisconnectedAtInput>;
  inverterId?: InputMaybe<Scalars['String']>;
  lastConnectedAt?: InputMaybe<FilterCountEnergyConsumerBuildingLastConnectedAtInput>;
  location?: InputMaybe<Scalars['String']>;
  maximumPowerOutput?: InputMaybe<Scalars['Float']>;
  modeOfOperation?: InputMaybe<FilterCountEnergySupplierWindSystemModeOfOperationInput>;
  name?: InputMaybe<Scalars['String']>;
  powerState?: InputMaybe<FilterCountEnergyConsumerBuildingPowerStateInput>;
  propertyId?: InputMaybe<Scalars['String']>;
  rectifierId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  unitId?: InputMaybe<Scalars['String']>;
  updateStatus?: InputMaybe<Scalars['Boolean']>;
  vppId?: InputMaybe<Scalars['String']>;
  wmsId?: InputMaybe<Scalars['String']>;
};

export type FilterCountEnergySupplierWindSystemModeOfOperationInput = {
  id?: InputMaybe<Scalars['String']>;
  observedAt?: InputMaybe<Scalars['Float']>;
  previousId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  units?: InputMaybe<Scalars['String']>;
  updatePending?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<EnumEnergySupplierWindSystemModeOfOperationValue>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterCountEnergySupplierWindSystemOperatorsInput = {
  _id?: InputMaybe<FilterCountEnergySupplierWindSystem_IdOperatorsInput>;
};

export type FilterCountEnergySupplierWindSystem_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['String']>;
  gte?: InputMaybe<Scalars['String']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  lt?: InputMaybe<Scalars['String']>;
  lte?: InputMaybe<Scalars['String']>;
  ne?: InputMaybe<Scalars['String']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']>;
};

export type FilterCountEnergySwitchPanelCircuitCurrentInput = {
  id?: InputMaybe<Scalars['String']>;
  observedAt?: InputMaybe<Scalars['Float']>;
  previousId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  units?: InputMaybe<Scalars['String']>;
  updatePending?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<Scalars['Float']>;
};

export type FilterCountEnergySwitchPanelCircuitEnergyConsumedInput = {
  id?: InputMaybe<Scalars['String']>;
  observedAt?: InputMaybe<Scalars['Float']>;
  previousId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  units?: InputMaybe<Scalars['String']>;
  updatePending?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<Scalars['Float']>;
};

export type FilterCountEnergySwitchPanelCircuitFrequencyInput = {
  id?: InputMaybe<Scalars['String']>;
  observedAt?: InputMaybe<Scalars['Float']>;
  previousId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  units?: InputMaybe<Scalars['String']>;
  updatePending?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<Scalars['Float']>;
};

export type FilterCountEnergySwitchPanelCircuitInput = {
  AND?: InputMaybe<Array<FilterCountDeviceInput>>;
  OR?: InputMaybe<Array<FilterCountDeviceInput>>;
  _id?: InputMaybe<Scalars['String']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterCountDeviceOperatorsInput>;
  alertTypes?: InputMaybe<FilterCountDeviceAlertTypesInput>;
  controlled?: InputMaybe<FilterCountDeviceControlledInput>;
  current?: InputMaybe<FilterCountEnergySwitchPanelCircuitCurrentInput>;
  deviceId?: InputMaybe<Scalars['String']>;
  energyConsumed?: InputMaybe<FilterCountEnergySwitchPanelCircuitEnergyConsumedInput>;
  energySwitchPanelId?: InputMaybe<Scalars['String']>;
  frequency?: InputMaybe<FilterCountEnergySwitchPanelCircuitFrequencyInput>;
  installation?: InputMaybe<FilterCountDeviceInstallationInput>;
  location?: InputMaybe<Scalars['String']>;
  meta?: InputMaybe<FilterCountDeviceMetaInput>;
  /** The name of the device */
  name?: InputMaybe<Scalars['String']>;
  outputEnabled?: InputMaybe<FilterCountEnergySwitchPanelCircuitOutputEnabledInput>;
  panelId?: InputMaybe<Scalars['String']>;
  powerDemand?: InputMaybe<FilterCountEnergySwitchPanelCircuitPowerDemandInput>;
  powerFactor?: InputMaybe<FilterCountEnergySwitchPanelCircuitPowerFactorInput>;
  powerState?: InputMaybe<FilterCountDevicePowerStateInput>;
  propertyId?: InputMaybe<Scalars['String']>;
  sourceId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  unitId?: InputMaybe<Scalars['String']>;
  updateStatus?: InputMaybe<Scalars['Boolean']>;
  voltage?: InputMaybe<FilterCountEnergySwitchPanelCircuitVoltageInput>;
  vppId?: InputMaybe<Scalars['String']>;
  zoneId?: InputMaybe<Scalars['String']>;
};

export type FilterCountEnergySwitchPanelCircuitOutputEnabledInput = {
  id?: InputMaybe<Scalars['String']>;
  observedAt?: InputMaybe<Scalars['Float']>;
  previousId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  units?: InputMaybe<Scalars['String']>;
  updatePending?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<Scalars['Boolean']>;
};

export type FilterCountEnergySwitchPanelCircuitPowerDemandInput = {
  id?: InputMaybe<Scalars['String']>;
  observedAt?: InputMaybe<Scalars['Float']>;
  previousId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  units?: InputMaybe<Scalars['String']>;
  updatePending?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<Scalars['Float']>;
};

export type FilterCountEnergySwitchPanelCircuitPowerFactorInput = {
  id?: InputMaybe<Scalars['String']>;
  observedAt?: InputMaybe<Scalars['Float']>;
  previousId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  units?: InputMaybe<Scalars['String']>;
  updatePending?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<Scalars['Float']>;
};

export type FilterCountEnergySwitchPanelCircuitVoltageInput = {
  id?: InputMaybe<Scalars['String']>;
  observedAt?: InputMaybe<Scalars['Float']>;
  previousId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  units?: InputMaybe<Scalars['String']>;
  updatePending?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<Scalars['Float']>;
};

export type FilterCountEnergySwitchPanelInput = {
  AND?: InputMaybe<Array<FilterCountDeviceInput>>;
  OR?: InputMaybe<Array<FilterCountDeviceInput>>;
  _id?: InputMaybe<Scalars['String']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterCountDeviceOperatorsInput>;
  alertTypes?: InputMaybe<FilterCountDeviceAlertTypesInput>;
  controlled?: InputMaybe<FilterCountDeviceControlledInput>;
  deviceId?: InputMaybe<Scalars['String']>;
  installation?: InputMaybe<FilterCountDeviceInstallationInput>;
  location?: InputMaybe<Scalars['String']>;
  maxCircuits?: InputMaybe<Scalars['Float']>;
  meta?: InputMaybe<FilterCountDeviceMetaInput>;
  /** The name of the device */
  name?: InputMaybe<Scalars['String']>;
  panelId?: InputMaybe<Scalars['String']>;
  powerInput?: InputMaybe<FilterCountEnergySwitchPanelPowerInputInput>;
  powerState?: InputMaybe<FilterCountDevicePowerStateInput>;
  propertyId?: InputMaybe<Scalars['String']>;
  sourceId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  unitId?: InputMaybe<Scalars['String']>;
  updateStatus?: InputMaybe<Scalars['Boolean']>;
  vppId?: InputMaybe<Scalars['String']>;
  zoneId?: InputMaybe<Scalars['String']>;
};

export type FilterCountEnergySwitchPanelPowerInputInput = {
  id?: InputMaybe<Scalars['String']>;
  observedAt?: InputMaybe<Scalars['Float']>;
  previousId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  units?: InputMaybe<Scalars['String']>;
  updatePending?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<Scalars['Float']>;
};

export type FilterCountFireSuppressionSystemFireSuppressionStatusInput = {
  id?: InputMaybe<Scalars['String']>;
  observedAt?: InputMaybe<Scalars['Float']>;
  previousId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  units?: InputMaybe<Scalars['String']>;
  updatePending?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<EnumFireSuppressionSystemFireSuppressionStatusValue>;
};

export type FilterCountFireSuppressionSystemInput = {
  AND?: InputMaybe<Array<FilterCountDeviceInput>>;
  OR?: InputMaybe<Array<FilterCountDeviceInput>>;
  _id?: InputMaybe<Scalars['String']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterCountDeviceOperatorsInput>;
  alertTypes?: InputMaybe<FilterCountDeviceAlertTypesInput>;
  controlled?: InputMaybe<FilterCountDeviceControlledInput>;
  deviceId?: InputMaybe<Scalars['String']>;
  fireSuppressionStatus?: InputMaybe<FilterCountFireSuppressionSystemFireSuppressionStatusInput>;
  installation?: InputMaybe<FilterCountDeviceInstallationInput>;
  location?: InputMaybe<Scalars['String']>;
  meta?: InputMaybe<FilterCountDeviceMetaInput>;
  /** The name of the device */
  name?: InputMaybe<Scalars['String']>;
  panelId?: InputMaybe<Scalars['String']>;
  powerState?: InputMaybe<FilterCountDevicePowerStateInput>;
  propertyId?: InputMaybe<Scalars['String']>;
  sensorStatus?: InputMaybe<FilterCountFireSuppressionSystemSensorStatusInput>;
  sourceId?: InputMaybe<Scalars['String']>;
  suppressantLevel?: InputMaybe<FilterCountFireSuppressionSystemSuppressantLevelInput>;
  timestamp?: InputMaybe<Scalars['Float']>;
  unitId?: InputMaybe<Scalars['String']>;
  updateStatus?: InputMaybe<Scalars['Boolean']>;
  vppId?: InputMaybe<Scalars['String']>;
  zoneId?: InputMaybe<Scalars['String']>;
};

export type FilterCountFireSuppressionSystemSensorStatusInput = {
  id?: InputMaybe<Scalars['String']>;
  observedAt?: InputMaybe<Scalars['Float']>;
  previousId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  units?: InputMaybe<Scalars['String']>;
  updatePending?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<EnumFireSuppressionSystemSensorStatusValue>;
};

export type FilterCountFireSuppressionSystemSuppressantLevelInput = {
  id?: InputMaybe<Scalars['String']>;
  observedAt?: InputMaybe<Scalars['Float']>;
  previousId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  units?: InputMaybe<Scalars['String']>;
  updatePending?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<Scalars['Float']>;
};

export type FilterCountFloorInput = {
  AND?: InputMaybe<Array<FilterCountFloorInput>>;
  OR?: InputMaybe<Array<FilterCountFloorInput>>;
  _id?: InputMaybe<Scalars['String']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterCountFloorOperatorsInput>;
  buildingId?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  number?: InputMaybe<Scalars['Float']>;
  propertyId?: InputMaybe<Scalars['String']>;
};

export type FilterCountFloorNameOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['String']>;
  gte?: InputMaybe<Scalars['String']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  lt?: InputMaybe<Scalars['String']>;
  lte?: InputMaybe<Scalars['String']>;
  ne?: InputMaybe<Scalars['String']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterCountFloorOperatorsInput = {
  _id?: InputMaybe<FilterCountFloor_IdOperatorsInput>;
  name?: InputMaybe<FilterCountFloorNameOperatorsInput>;
};

export type FilterCountFloor_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['String']>;
  gte?: InputMaybe<Scalars['String']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  lt?: InputMaybe<Scalars['String']>;
  lte?: InputMaybe<Scalars['String']>;
  ne?: InputMaybe<Scalars['String']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']>;
};

export type FilterCountGpioInput = {
  AND?: InputMaybe<Array<FilterCountDeviceInput>>;
  OR?: InputMaybe<Array<FilterCountDeviceInput>>;
  _id?: InputMaybe<Scalars['String']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterCountDeviceOperatorsInput>;
  alertTypes?: InputMaybe<FilterCountDeviceAlertTypesInput>;
  controlled?: InputMaybe<FilterCountDeviceControlledInput>;
  deviceId?: InputMaybe<Scalars['String']>;
  installation?: InputMaybe<FilterCountDeviceInstallationInput>;
  location?: InputMaybe<Scalars['String']>;
  meta?: InputMaybe<FilterCountDeviceMetaInput>;
  /** The name of the device */
  name?: InputMaybe<Scalars['String']>;
  panelId?: InputMaybe<Scalars['String']>;
  powerState?: InputMaybe<FilterCountDevicePowerStateInput>;
  propertyId?: InputMaybe<Scalars['String']>;
  sourceId?: InputMaybe<Scalars['String']>;
  state?: InputMaybe<FilterCountGpioStateInput>;
  timestamp?: InputMaybe<Scalars['Float']>;
  unitId?: InputMaybe<Scalars['String']>;
  updateStatus?: InputMaybe<Scalars['Boolean']>;
  vppId?: InputMaybe<Scalars['String']>;
  zoneId?: InputMaybe<Scalars['String']>;
};

export type FilterCountGpioStateInput = {
  id?: InputMaybe<Scalars['String']>;
  observedAt?: InputMaybe<Scalars['Float']>;
  previousId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  units?: InputMaybe<Scalars['String']>;
  updatePending?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<Scalars['Boolean']>;
};

export type FilterCountHmmInput = {
  AND?: InputMaybe<Array<FilterCountSourceInput>>;
  OR?: InputMaybe<Array<FilterCountSourceInput>>;
  _id?: InputMaybe<Scalars['String']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterCountSourceOperatorsInput>;
  hmmUniqueId?: InputMaybe<Scalars['String']>;
  maxReportingTime?: InputMaybe<Scalars['Float']>;
  name?: InputMaybe<Scalars['String']>;
  propertyId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  tolerances?: InputMaybe<FilterCountHmmTolerancesInput>;
  url?: InputMaybe<Scalars['String']>;
};

export type FilterCountHmmTolerancesInput = {
  temperature?: InputMaybe<Scalars['Float']>;
};

export type FilterCountHistoricAlertAlertCategoryInput = {
  id?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
};

export type FilterCountHistoricAlertAlertTriggerInput = {
  id?: InputMaybe<Scalars['String']>;
  key?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
};

export type FilterCountHistoricAlertBuildingInput = {
  id?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
};

export type FilterCountHistoricAlertDeviceInput = {
  id?: InputMaybe<Scalars['String']>;
  model?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  role?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<Scalars['String']>;
  version?: InputMaybe<Scalars['String']>;
};

export type FilterCountHistoricAlertInput = {
  AND?: InputMaybe<Array<FilterCountHistoricAlertInput>>;
  OR?: InputMaybe<Array<FilterCountHistoricAlertInput>>;
  _id?: InputMaybe<Scalars['String']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterCountHistoricAlertOperatorsInput>;
  alertCategory?: InputMaybe<FilterCountHistoricAlertAlertCategoryInput>;
  alertTrigger?: InputMaybe<FilterCountHistoricAlertAlertTriggerInput>;
  building?: InputMaybe<FilterCountHistoricAlertBuildingInput>;
  device?: InputMaybe<FilterCountHistoricAlertDeviceInput>;
  id?: InputMaybe<Scalars['String']>;
  initiated?: InputMaybe<Scalars['Float']>;
  meta?: InputMaybe<FilterCountHistoricAlertMetaInput>;
  panel?: InputMaybe<FilterCountHistoricAlertPanelInput>;
  port?: InputMaybe<EnumHistoricAlertPort>;
  property?: InputMaybe<FilterCountHistoricAlertPropertyInput>;
  resolved?: InputMaybe<Scalars['Float']>;
  sourceId?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<FilterCountHistoricAlertTypeInput>;
  unit?: InputMaybe<FilterCountHistoricAlertUnitInput>;
  updated?: InputMaybe<Scalars['Float']>;
  zone?: InputMaybe<FilterCountHistoricAlertZoneInput>;
};

export type FilterCountHistoricAlertMetaInput = {
  id_str?: InputMaybe<Scalars['String']>;
  limit?: InputMaybe<Scalars['Float']>;
  message?: InputMaybe<Scalars['String']>;
  portName?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<Scalars['String']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterCountHistoricAlertOperatorsInput = {
  _id?: InputMaybe<FilterCountHistoricAlert_IdOperatorsInput>;
};

export type FilterCountHistoricAlertPanelInput = {
  id?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
};

export type FilterCountHistoricAlertPropertyContactInput = {
  email?: InputMaybe<Scalars['String']>;
  email2?: InputMaybe<Scalars['String']>;
  email3?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  smsNumber?: InputMaybe<Scalars['String']>;
  smsNumber2?: InputMaybe<Scalars['String']>;
  smsNumber3?: InputMaybe<Scalars['String']>;
  smsOptInStatus1?: InputMaybe<EnumHistoricAlertPropertyContactSmsOptInStatus1>;
  smsOptInStatus2?: InputMaybe<EnumHistoricAlertPropertyContactSmsOptInStatus2>;
  smsOptInStatus3?: InputMaybe<EnumHistoricAlertPropertyContactSmsOptInStatus3>;
  smsOptInTimestamp1?: InputMaybe<Scalars['Float']>;
  smsOptInTimestamp2?: InputMaybe<Scalars['Float']>;
  smsOptInTimestamp3?: InputMaybe<Scalars['Float']>;
};

export type FilterCountHistoricAlertPropertyInput = {
  contact?: InputMaybe<FilterCountHistoricAlertPropertyContactInput>;
  id?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
};

export type FilterCountHistoricAlertTypeInput = {
  id?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
};

export type FilterCountHistoricAlertUnitInput = {
  id?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
};

export type FilterCountHistoricAlertZoneInput = {
  id?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
};

export type FilterCountHistoricAlert_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['String']>;
  gte?: InputMaybe<Scalars['String']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  lt?: InputMaybe<Scalars['String']>;
  lte?: InputMaybe<Scalars['String']>;
  ne?: InputMaybe<Scalars['String']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']>;
};

export type FilterCountHistoricReadingDeviceIdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['String']>;
  gte?: InputMaybe<Scalars['String']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  lt?: InputMaybe<Scalars['String']>;
  lte?: InputMaybe<Scalars['String']>;
  ne?: InputMaybe<Scalars['String']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']>;
};

export type FilterCountHistoricReadingInput = {
  AND?: InputMaybe<Array<FilterCountHistoricReadingInput>>;
  OR?: InputMaybe<Array<FilterCountHistoricReadingInput>>;
  _id?: InputMaybe<Scalars['String']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterCountHistoricReadingOperatorsInput>;
  deviceId?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  sourceId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  type?: InputMaybe<Scalars['String']>;
  units?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<Scalars['String']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterCountHistoricReadingOperatorsInput = {
  _id?: InputMaybe<FilterCountHistoricReading_IdOperatorsInput>;
  deviceId?: InputMaybe<FilterCountHistoricReadingDeviceIdOperatorsInput>;
};

export type FilterCountHistoricReading_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['String']>;
  gte?: InputMaybe<Scalars['String']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  lt?: InputMaybe<Scalars['String']>;
  lte?: InputMaybe<Scalars['String']>;
  ne?: InputMaybe<Scalars['String']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']>;
};

export type FilterCountIndoorAirHandlerCoolSetpointInput = {
  id?: InputMaybe<Scalars['String']>;
  observedAt?: InputMaybe<Scalars['Float']>;
  previousId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  units?: InputMaybe<Scalars['String']>;
  updatePending?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<Scalars['Float']>;
};

export type FilterCountIndoorAirHandlerFanSpeedInput = {
  id?: InputMaybe<Scalars['String']>;
  observedAt?: InputMaybe<Scalars['Float']>;
  previousId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  units?: InputMaybe<Scalars['String']>;
  updatePending?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<Scalars['String']>;
};

export type FilterCountIndoorAirHandlerHeatSetpointInput = {
  id?: InputMaybe<Scalars['String']>;
  observedAt?: InputMaybe<Scalars['Float']>;
  previousId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  units?: InputMaybe<Scalars['String']>;
  updatePending?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<Scalars['Float']>;
};

export type FilterCountIndoorAirHandlerIndoorFanStatusInput = {
  id?: InputMaybe<Scalars['String']>;
  observedAt?: InputMaybe<Scalars['Float']>;
  previousId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  units?: InputMaybe<Scalars['String']>;
  updatePending?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<EnumIndoorAirHandlerIndoorFanStatusValue>;
};

export type FilterCountIndoorAirHandlerInput = {
  AND?: InputMaybe<Array<FilterCountDeviceInput>>;
  OR?: InputMaybe<Array<FilterCountDeviceInput>>;
  _id?: InputMaybe<Scalars['String']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterCountDeviceOperatorsInput>;
  alertTypes?: InputMaybe<FilterCountDeviceAlertTypesInput>;
  altDeviceId?: InputMaybe<Scalars['String']>;
  controlled?: InputMaybe<FilterCountDeviceControlledInput>;
  coolSetpoint?: InputMaybe<FilterCountIndoorAirHandlerCoolSetpointInput>;
  deviceId?: InputMaybe<Scalars['String']>;
  fanSpeed?: InputMaybe<FilterCountIndoorAirHandlerFanSpeedInput>;
  heatSetpoint?: InputMaybe<FilterCountIndoorAirHandlerHeatSetpointInput>;
  indoorFanStatus?: InputMaybe<FilterCountIndoorAirHandlerIndoorFanStatusInput>;
  installation?: InputMaybe<FilterCountDeviceInstallationInput>;
  location?: InputMaybe<Scalars['String']>;
  maxCoolSetpointLimit?: InputMaybe<FilterCountIndoorAirHandlerMaxCoolSetpointLimitInput>;
  maxHeatSetpointLimit?: InputMaybe<FilterCountIndoorAirHandlerMaxHeatSetpointLimitInput>;
  meta?: InputMaybe<FilterCountDeviceMetaInput>;
  minCoolSetpointLimit?: InputMaybe<FilterCountIndoorAirHandlerMinCoolSetpointLimitInput>;
  minHeatSetpointLimit?: InputMaybe<FilterCountIndoorAirHandlerMinHeatSetpointLimitInput>;
  /** The name of the device */
  name?: InputMaybe<Scalars['String']>;
  operatingMode?: InputMaybe<FilterCountIndoorAirHandlerOperatingModeInput>;
  operatingState?: InputMaybe<FilterCountIndoorAirHandlerOperatingStateInput>;
  panelId?: InputMaybe<Scalars['String']>;
  powerState?: InputMaybe<FilterCountDevicePowerStateInput>;
  propertyId?: InputMaybe<Scalars['String']>;
  sourceId?: InputMaybe<Scalars['String']>;
  temperature?: InputMaybe<FilterCountIndoorAirHandlerTemperatureInput>;
  timestamp?: InputMaybe<Scalars['Float']>;
  unitId?: InputMaybe<Scalars['String']>;
  updateStatus?: InputMaybe<Scalars['Boolean']>;
  vppId?: InputMaybe<Scalars['String']>;
  zoneId?: InputMaybe<Scalars['String']>;
};

export type FilterCountIndoorAirHandlerMaxCoolSetpointLimitInput = {
  id?: InputMaybe<Scalars['String']>;
  observedAt?: InputMaybe<Scalars['Float']>;
  previousId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  units?: InputMaybe<Scalars['String']>;
  updatePending?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<Scalars['Float']>;
};

export type FilterCountIndoorAirHandlerMaxHeatSetpointLimitInput = {
  id?: InputMaybe<Scalars['String']>;
  observedAt?: InputMaybe<Scalars['Float']>;
  previousId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  units?: InputMaybe<Scalars['String']>;
  updatePending?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<Scalars['Float']>;
};

export type FilterCountIndoorAirHandlerMinCoolSetpointLimitInput = {
  id?: InputMaybe<Scalars['String']>;
  observedAt?: InputMaybe<Scalars['Float']>;
  previousId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  units?: InputMaybe<Scalars['String']>;
  updatePending?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<Scalars['Float']>;
};

export type FilterCountIndoorAirHandlerMinHeatSetpointLimitInput = {
  id?: InputMaybe<Scalars['String']>;
  observedAt?: InputMaybe<Scalars['Float']>;
  previousId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  units?: InputMaybe<Scalars['String']>;
  updatePending?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<Scalars['Float']>;
};

export type FilterCountIndoorAirHandlerOperatingModeInput = {
  id?: InputMaybe<Scalars['String']>;
  observedAt?: InputMaybe<Scalars['Float']>;
  previousId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  units?: InputMaybe<Scalars['String']>;
  updatePending?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<Scalars['String']>;
};

export type FilterCountIndoorAirHandlerOperatingStateInput = {
  id?: InputMaybe<Scalars['String']>;
  observedAt?: InputMaybe<Scalars['Float']>;
  previousId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  units?: InputMaybe<Scalars['String']>;
  updatePending?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<Scalars['String']>;
};

export type FilterCountIndoorAirHandlerTemperatureInput = {
  id?: InputMaybe<Scalars['String']>;
  observedAt?: InputMaybe<Scalars['Float']>;
  previousId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  units?: InputMaybe<Scalars['String']>;
  updatePending?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<Scalars['Float']>;
};

export type FilterCountIndoorSensorHumidityInput = {
  id?: InputMaybe<Scalars['String']>;
  observedAt?: InputMaybe<Scalars['Float']>;
  previousId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  units?: InputMaybe<Scalars['String']>;
  updatePending?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<Scalars['Float']>;
};

export type FilterCountIndoorSensorInput = {
  AND?: InputMaybe<Array<FilterCountDeviceInput>>;
  OR?: InputMaybe<Array<FilterCountDeviceInput>>;
  _id?: InputMaybe<Scalars['String']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterCountDeviceOperatorsInput>;
  alertTypes?: InputMaybe<FilterCountDeviceAlertTypesInput>;
  controlled?: InputMaybe<FilterCountDeviceControlledInput>;
  deviceId?: InputMaybe<Scalars['String']>;
  humidity?: InputMaybe<FilterCountIndoorSensorHumidityInput>;
  installation?: InputMaybe<FilterCountDeviceInstallationInput>;
  location?: InputMaybe<Scalars['String']>;
  meta?: InputMaybe<FilterCountDeviceMetaInput>;
  /** The name of the device */
  name?: InputMaybe<Scalars['String']>;
  occupancy?: InputMaybe<FilterCountIndoorSensorOccupancyInput>;
  panelId?: InputMaybe<Scalars['String']>;
  powerState?: InputMaybe<FilterCountDevicePowerStateInput>;
  propertyId?: InputMaybe<Scalars['String']>;
  sourceId?: InputMaybe<Scalars['String']>;
  temperature?: InputMaybe<FilterCountIndoorSensorTemperatureInput>;
  timestamp?: InputMaybe<Scalars['Float']>;
  unitId?: InputMaybe<Scalars['String']>;
  updateStatus?: InputMaybe<Scalars['Boolean']>;
  voltage?: InputMaybe<FilterCountIndoorSensorVoltageInput>;
  vppId?: InputMaybe<Scalars['String']>;
  zoneId?: InputMaybe<Scalars['String']>;
};

export type FilterCountIndoorSensorOccupancyInput = {
  timestamp?: InputMaybe<Scalars['Float']>;
};

export type FilterCountIndoorSensorTemperatureInput = {
  id?: InputMaybe<Scalars['String']>;
  observedAt?: InputMaybe<Scalars['Float']>;
  previousId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  units?: InputMaybe<Scalars['String']>;
  updatePending?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<Scalars['Float']>;
};

export type FilterCountIndoorSensorVoltageInput = {
  id?: InputMaybe<Scalars['String']>;
  observedAt?: InputMaybe<Scalars['Float']>;
  previousId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  units?: InputMaybe<Scalars['String']>;
  updatePending?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<Scalars['Float']>;
};

export type FilterCountIngestionInput = {
  AND?: InputMaybe<Array<FilterCountIngestionInput>>;
  OR?: InputMaybe<Array<FilterCountIngestionInput>>;
  _id?: InputMaybe<Scalars['String']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterCountIngestionOperatorsInput>;
  date?: InputMaybe<Scalars['Date']>;
  fileName?: InputMaybe<Scalars['String']>;
  s3FileName?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<Scalars['String']>;
  userId?: InputMaybe<Scalars['String']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterCountIngestionOperatorsInput = {
  _id?: InputMaybe<FilterCountIngestion_IdOperatorsInput>;
};

export type FilterCountIngestion_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['String']>;
  gte?: InputMaybe<Scalars['String']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  lt?: InputMaybe<Scalars['String']>;
  lte?: InputMaybe<Scalars['String']>;
  ne?: InputMaybe<Scalars['String']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']>;
};

export type FilterCountKineticEnergyManagementSystemBearingTemperatureInput = {
  id?: InputMaybe<Scalars['String']>;
  observedAt?: InputMaybe<Scalars['Float']>;
  previousId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  units?: InputMaybe<Scalars['String']>;
  updatePending?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<Scalars['Float']>;
};

export type FilterCountKineticEnergyManagementSystemCurrentEnergyStoredInput = {
  id?: InputMaybe<Scalars['String']>;
  observedAt?: InputMaybe<Scalars['Float']>;
  previousId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  units?: InputMaybe<Scalars['String']>;
  updatePending?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<Scalars['Float']>;
};

export type FilterCountKineticEnergyManagementSystemCycleCountInput = {
  id?: InputMaybe<Scalars['String']>;
  observedAt?: InputMaybe<Scalars['Float']>;
  previousId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  units?: InputMaybe<Scalars['String']>;
  updatePending?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<Scalars['Float']>;
};

export type FilterCountKineticEnergyManagementSystemGeneratorCurrentInput = {
  id?: InputMaybe<Scalars['String']>;
  observedAt?: InputMaybe<Scalars['Float']>;
  previousId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  units?: InputMaybe<Scalars['String']>;
  updatePending?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<Scalars['Float']>;
};

export type FilterCountKineticEnergyManagementSystemGeneratorVoltageInput = {
  id?: InputMaybe<Scalars['String']>;
  observedAt?: InputMaybe<Scalars['Float']>;
  previousId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  units?: InputMaybe<Scalars['String']>;
  updatePending?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<Scalars['Float']>;
};

export type FilterCountKineticEnergyManagementSystemInput = {
  AND?: InputMaybe<Array<FilterCountDeviceInput>>;
  OR?: InputMaybe<Array<FilterCountDeviceInput>>;
  _id?: InputMaybe<Scalars['String']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterCountDeviceOperatorsInput>;
  alertTypes?: InputMaybe<FilterCountDeviceAlertTypesInput>;
  bearingTemperature?: InputMaybe<FilterCountKineticEnergyManagementSystemBearingTemperatureInput>;
  controlled?: InputMaybe<FilterCountDeviceControlledInput>;
  currentEnergyStored?: InputMaybe<FilterCountKineticEnergyManagementSystemCurrentEnergyStoredInput>;
  cycleCount?: InputMaybe<FilterCountKineticEnergyManagementSystemCycleCountInput>;
  deviceId?: InputMaybe<Scalars['String']>;
  generatorCurrent?: InputMaybe<FilterCountKineticEnergyManagementSystemGeneratorCurrentInput>;
  generatorVoltage?: InputMaybe<FilterCountKineticEnergyManagementSystemGeneratorVoltageInput>;
  installation?: InputMaybe<FilterCountDeviceInstallationInput>;
  location?: InputMaybe<Scalars['String']>;
  meta?: InputMaybe<FilterCountDeviceMetaInput>;
  /** The name of the device */
  name?: InputMaybe<Scalars['String']>;
  panelId?: InputMaybe<Scalars['String']>;
  powerState?: InputMaybe<FilterCountDevicePowerStateInput>;
  propertyId?: InputMaybe<Scalars['String']>;
  rotorSpeed?: InputMaybe<FilterCountKineticEnergyManagementSystemRotorSpeedInput>;
  sourceId?: InputMaybe<Scalars['String']>;
  spinDownTime?: InputMaybe<FilterCountKineticEnergyManagementSystemSpinDownTimeInput>;
  stateOfHealth?: InputMaybe<FilterCountKineticEnergyManagementSystemStateOfHealthInput>;
  systemEfficiency?: InputMaybe<FilterCountKineticEnergyManagementSystemSystemEfficiencyInput>;
  timestamp?: InputMaybe<Scalars['Float']>;
  unitId?: InputMaybe<Scalars['String']>;
  updateStatus?: InputMaybe<Scalars['Boolean']>;
  vacuumPressure?: InputMaybe<FilterCountKineticEnergyManagementSystemVacuumPressureInput>;
  vibrationMetrics?: InputMaybe<FilterCountKineticEnergyManagementSystemVibrationMetricsInput>;
  vppId?: InputMaybe<Scalars['String']>;
  zoneId?: InputMaybe<Scalars['String']>;
};

export type FilterCountKineticEnergyManagementSystemRotorSpeedInput = {
  id?: InputMaybe<Scalars['String']>;
  observedAt?: InputMaybe<Scalars['Float']>;
  previousId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  units?: InputMaybe<Scalars['String']>;
  updatePending?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<Scalars['Float']>;
};

export type FilterCountKineticEnergyManagementSystemSpinDownTimeInput = {
  id?: InputMaybe<Scalars['String']>;
  observedAt?: InputMaybe<Scalars['Float']>;
  previousId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  units?: InputMaybe<Scalars['String']>;
  updatePending?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<Scalars['Float']>;
};

export type FilterCountKineticEnergyManagementSystemStateOfHealthInput = {
  id?: InputMaybe<Scalars['String']>;
  observedAt?: InputMaybe<Scalars['Float']>;
  previousId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  units?: InputMaybe<Scalars['String']>;
  updatePending?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<Scalars['Float']>;
};

export type FilterCountKineticEnergyManagementSystemSystemEfficiencyInput = {
  id?: InputMaybe<Scalars['String']>;
  observedAt?: InputMaybe<Scalars['Float']>;
  previousId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  units?: InputMaybe<Scalars['String']>;
  updatePending?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<Scalars['Float']>;
};

export type FilterCountKineticEnergyManagementSystemVacuumPressureInput = {
  id?: InputMaybe<Scalars['String']>;
  observedAt?: InputMaybe<Scalars['Float']>;
  previousId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  units?: InputMaybe<Scalars['String']>;
  updatePending?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<Scalars['Float']>;
};

export type FilterCountKineticEnergyManagementSystemVibrationMetricsInput = {
  id?: InputMaybe<Scalars['String']>;
  observedAt?: InputMaybe<Scalars['Float']>;
  previousId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  units?: InputMaybe<Scalars['String']>;
  updatePending?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<Scalars['Float']>;
};

export type FilterCountLeakDetectorBatteryVoltageMinThresholdInput = {
  id?: InputMaybe<Scalars['String']>;
  observedAt?: InputMaybe<Scalars['Float']>;
  previousId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  units?: InputMaybe<Scalars['String']>;
  updatePending?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<Scalars['Float']>;
};

export type FilterCountLeakDetectorBatteryVoltageMinThresholdReachedInput = {
  id?: InputMaybe<Scalars['String']>;
  observedAt?: InputMaybe<Scalars['Float']>;
  previousId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  units?: InputMaybe<Scalars['String']>;
  updatePending?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<Scalars['Boolean']>;
};

export type FilterCountLeakDetectorInput = {
  AND?: InputMaybe<Array<FilterCountDeviceInput>>;
  OR?: InputMaybe<Array<FilterCountDeviceInput>>;
  _id?: InputMaybe<Scalars['String']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterCountDeviceOperatorsInput>;
  alertTypes?: InputMaybe<FilterCountDeviceAlertTypesInput>;
  batteryVoltageMinThreshold?: InputMaybe<FilterCountLeakDetectorBatteryVoltageMinThresholdInput>;
  batteryVoltageMinThresholdReached?: InputMaybe<FilterCountLeakDetectorBatteryVoltageMinThresholdReachedInput>;
  controlled?: InputMaybe<FilterCountDeviceControlledInput>;
  deviceId?: InputMaybe<Scalars['String']>;
  installation?: InputMaybe<FilterCountDeviceInstallationInput>;
  leakStatus1?: InputMaybe<FilterCountLeakDetectorLeakStatus1Input>;
  leakStatus2?: InputMaybe<FilterCountLeakDetectorLeakStatus2Input>;
  location?: InputMaybe<Scalars['String']>;
  meta?: InputMaybe<FilterCountDeviceMetaInput>;
  /** The name of the device */
  name?: InputMaybe<Scalars['String']>;
  panelId?: InputMaybe<Scalars['String']>;
  powerState?: InputMaybe<FilterCountDevicePowerStateInput>;
  propertyId?: InputMaybe<Scalars['String']>;
  sourceId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  unitId?: InputMaybe<Scalars['String']>;
  updateStatus?: InputMaybe<Scalars['Boolean']>;
  voltage?: InputMaybe<FilterCountLeakDetectorVoltageInput>;
  vppId?: InputMaybe<Scalars['String']>;
  zoneId?: InputMaybe<Scalars['String']>;
};

export type FilterCountLeakDetectorLeakStatus1Input = {
  id?: InputMaybe<Scalars['String']>;
  observedAt?: InputMaybe<Scalars['Float']>;
  previousId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  units?: InputMaybe<Scalars['String']>;
  updatePending?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<Scalars['Boolean']>;
};

export type FilterCountLeakDetectorLeakStatus2Input = {
  id?: InputMaybe<Scalars['String']>;
  observedAt?: InputMaybe<Scalars['Float']>;
  previousId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  units?: InputMaybe<Scalars['String']>;
  updatePending?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<Scalars['Boolean']>;
};

export type FilterCountLeakDetectorVoltageInput = {
  id?: InputMaybe<Scalars['String']>;
  observedAt?: InputMaybe<Scalars['Float']>;
  previousId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  units?: InputMaybe<Scalars['String']>;
  updatePending?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<Scalars['Float']>;
};

export type FilterCountLoopIndoorTemperatureInput = {
  id?: InputMaybe<Scalars['String']>;
  observedAt?: InputMaybe<Scalars['Float']>;
  previousId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  units?: InputMaybe<Scalars['String']>;
  updatePending?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<Scalars['Float']>;
};

export type FilterCountLoopInput = {
  AND?: InputMaybe<Array<FilterCountDeviceInput>>;
  OR?: InputMaybe<Array<FilterCountDeviceInput>>;
  _id?: InputMaybe<Scalars['String']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterCountDeviceOperatorsInput>;
  alertTypes?: InputMaybe<FilterCountDeviceAlertTypesInput>;
  controlled?: InputMaybe<FilterCountDeviceControlledInput>;
  deviceId?: InputMaybe<Scalars['String']>;
  indoorTemperature?: InputMaybe<FilterCountLoopIndoorTemperatureInput>;
  installation?: InputMaybe<FilterCountDeviceInstallationInput>;
  location?: InputMaybe<Scalars['String']>;
  meta?: InputMaybe<FilterCountDeviceMetaInput>;
  /** The name of the device */
  name?: InputMaybe<Scalars['String']>;
  panelId?: InputMaybe<Scalars['String']>;
  powerState?: InputMaybe<FilterCountDevicePowerStateInput>;
  propertyId?: InputMaybe<Scalars['String']>;
  returnTemperature?: InputMaybe<FilterCountLoopReturnTemperatureInput>;
  role?: InputMaybe<Scalars['String']>;
  sourceId?: InputMaybe<Scalars['String']>;
  supplyTemperature?: InputMaybe<FilterCountLoopSupplyTemperatureInput>;
  timestamp?: InputMaybe<Scalars['Float']>;
  unitId?: InputMaybe<Scalars['String']>;
  updateStatus?: InputMaybe<Scalars['Boolean']>;
  vppId?: InputMaybe<Scalars['String']>;
  zoneId?: InputMaybe<Scalars['String']>;
};

export type FilterCountLoopReturnTemperatureInput = {
  id?: InputMaybe<Scalars['String']>;
  observedAt?: InputMaybe<Scalars['Float']>;
  previousId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  units?: InputMaybe<Scalars['String']>;
  updatePending?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<Scalars['Float']>;
};

export type FilterCountLoopSupplyTemperatureInput = {
  id?: InputMaybe<Scalars['String']>;
  observedAt?: InputMaybe<Scalars['Float']>;
  previousId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  units?: InputMaybe<Scalars['String']>;
  updatePending?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<Scalars['Float']>;
};

export type FilterCountModbusAirHandlerAhuCoolSetpointInput = {
  id?: InputMaybe<Scalars['String']>;
  observedAt?: InputMaybe<Scalars['Float']>;
  previousId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  units?: InputMaybe<Scalars['String']>;
  updatePending?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<Scalars['Float']>;
};

export type FilterCountModbusAirHandlerAhuHeatSetpointInput = {
  id?: InputMaybe<Scalars['String']>;
  observedAt?: InputMaybe<Scalars['Float']>;
  previousId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  units?: InputMaybe<Scalars['String']>;
  updatePending?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<Scalars['Float']>;
};

export type FilterCountModbusAirHandlerAhuMaxHeatSetpointLimitInput = {
  id?: InputMaybe<Scalars['String']>;
  observedAt?: InputMaybe<Scalars['Float']>;
  previousId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  units?: InputMaybe<Scalars['String']>;
  updatePending?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<Scalars['Float']>;
};

export type FilterCountModbusAirHandlerAhuMinCoolSetpointLimitInput = {
  id?: InputMaybe<Scalars['String']>;
  observedAt?: InputMaybe<Scalars['Float']>;
  previousId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  units?: InputMaybe<Scalars['String']>;
  updatePending?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<Scalars['Float']>;
};

export type FilterCountModbusAirHandlerAhuModbusIdInput = {
  id?: InputMaybe<Scalars['String']>;
  observedAt?: InputMaybe<Scalars['Float']>;
  previousId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  units?: InputMaybe<Scalars['String']>;
  updatePending?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<Scalars['Float']>;
};

export type FilterCountModbusAirHandlerAirExchangeModeOnInput = {
  id?: InputMaybe<Scalars['String']>;
  observedAt?: InputMaybe<Scalars['Float']>;
  previousId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  units?: InputMaybe<Scalars['String']>;
  updatePending?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<Scalars['Boolean']>;
};

export type FilterCountModbusAirHandlerAirflowUnitsInput = {
  id?: InputMaybe<Scalars['String']>;
  observedAt?: InputMaybe<Scalars['Float']>;
  previousId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  units?: InputMaybe<Scalars['String']>;
  updatePending?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<Scalars['String']>;
};

export type FilterCountModbusAirHandlerAlarmAirRestrictionInput = {
  id?: InputMaybe<Scalars['String']>;
  observedAt?: InputMaybe<Scalars['Float']>;
  previousId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  units?: InputMaybe<Scalars['String']>;
  updatePending?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<Scalars['Boolean']>;
};

export type FilterCountModbusAirHandlerAlarmB1SensorFailInput = {
  id?: InputMaybe<Scalars['String']>;
  observedAt?: InputMaybe<Scalars['Float']>;
  previousId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  units?: InputMaybe<Scalars['String']>;
  updatePending?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<Scalars['Boolean']>;
};

export type FilterCountModbusAirHandlerAlarmB2SensorFailInput = {
  id?: InputMaybe<Scalars['String']>;
  observedAt?: InputMaybe<Scalars['Float']>;
  previousId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  units?: InputMaybe<Scalars['String']>;
  updatePending?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<Scalars['Boolean']>;
};

export type FilterCountModbusAirHandlerAlarmB3SensorFailInput = {
  id?: InputMaybe<Scalars['String']>;
  observedAt?: InputMaybe<Scalars['Float']>;
  previousId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  units?: InputMaybe<Scalars['String']>;
  updatePending?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<Scalars['Boolean']>;
};

export type FilterCountModbusAirHandlerAlarmB4SensorFailInput = {
  id?: InputMaybe<Scalars['String']>;
  observedAt?: InputMaybe<Scalars['Float']>;
  previousId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  units?: InputMaybe<Scalars['String']>;
  updatePending?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<Scalars['Boolean']>;
};

export type FilterCountModbusAirHandlerAlarmB6SensorFailInput = {
  id?: InputMaybe<Scalars['String']>;
  observedAt?: InputMaybe<Scalars['Float']>;
  previousId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  units?: InputMaybe<Scalars['String']>;
  updatePending?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<Scalars['Boolean']>;
};

export type FilterCountModbusAirHandlerAlarmChangeFiltersInput = {
  id?: InputMaybe<Scalars['String']>;
  observedAt?: InputMaybe<Scalars['Float']>;
  previousId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  units?: InputMaybe<Scalars['String']>;
  updatePending?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<Scalars['Boolean']>;
};

export type FilterCountModbusAirHandlerAlarmChangeHepaInput = {
  id?: InputMaybe<Scalars['String']>;
  observedAt?: InputMaybe<Scalars['Float']>;
  previousId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  units?: InputMaybe<Scalars['String']>;
  updatePending?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<Scalars['Boolean']>;
};

export type FilterCountModbusAirHandlerAlarmClockBoardInput = {
  id?: InputMaybe<Scalars['String']>;
  observedAt?: InputMaybe<Scalars['Float']>;
  previousId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  units?: InputMaybe<Scalars['String']>;
  updatePending?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<Scalars['Boolean']>;
};

export type FilterCountModbusAirHandlerAlarmCompressorFailInput = {
  id?: InputMaybe<Scalars['String']>;
  observedAt?: InputMaybe<Scalars['Float']>;
  previousId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  units?: InputMaybe<Scalars['String']>;
  updatePending?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<Scalars['Boolean']>;
};

export type FilterCountModbusAirHandlerAlarmExhaustFanStoppedInput = {
  id?: InputMaybe<Scalars['String']>;
  observedAt?: InputMaybe<Scalars['Float']>;
  previousId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  units?: InputMaybe<Scalars['String']>;
  updatePending?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<Scalars['Boolean']>;
};

export type FilterCountModbusAirHandlerAlarmExtendedMemoryInput = {
  id?: InputMaybe<Scalars['String']>;
  observedAt?: InputMaybe<Scalars['Float']>;
  previousId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  units?: InputMaybe<Scalars['String']>;
  updatePending?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<Scalars['Boolean']>;
};

export type FilterCountModbusAirHandlerAlarmFanAbReversedInput = {
  id?: InputMaybe<Scalars['String']>;
  observedAt?: InputMaybe<Scalars['Float']>;
  previousId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  units?: InputMaybe<Scalars['String']>;
  updatePending?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<Scalars['Boolean']>;
};

export type FilterCountModbusAirHandlerAlarmFanANegPressureOpt1Input = {
  id?: InputMaybe<Scalars['String']>;
  observedAt?: InputMaybe<Scalars['Float']>;
  previousId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  units?: InputMaybe<Scalars['String']>;
  updatePending?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<Scalars['Boolean']>;
};

export type FilterCountModbusAirHandlerAlarmFanANegPressureOpt2Input = {
  id?: InputMaybe<Scalars['String']>;
  observedAt?: InputMaybe<Scalars['Float']>;
  previousId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  units?: InputMaybe<Scalars['String']>;
  updatePending?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<Scalars['Boolean']>;
};

export type FilterCountModbusAirHandlerAlarmGlobalAlarmInput = {
  id?: InputMaybe<Scalars['String']>;
  observedAt?: InputMaybe<Scalars['Float']>;
  previousId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  units?: InputMaybe<Scalars['String']>;
  updatePending?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<Scalars['Boolean']>;
};

export type FilterCountModbusAirHandlerAlarmHighPressureInput = {
  id?: InputMaybe<Scalars['String']>;
  observedAt?: InputMaybe<Scalars['Float']>;
  previousId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  units?: InputMaybe<Scalars['String']>;
  updatePending?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<Scalars['Boolean']>;
};

export type FilterCountModbusAirHandlerAlarmLowPressureInput = {
  id?: InputMaybe<Scalars['String']>;
  observedAt?: InputMaybe<Scalars['Float']>;
  previousId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  units?: InputMaybe<Scalars['String']>;
  updatePending?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<Scalars['Boolean']>;
};

export type FilterCountModbusAirHandlerAlarmRefrigerantLeakInput = {
  id?: InputMaybe<Scalars['String']>;
  observedAt?: InputMaybe<Scalars['Float']>;
  previousId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  units?: InputMaybe<Scalars['String']>;
  updatePending?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<Scalars['Boolean']>;
};

export type FilterCountModbusAirHandlerAlarmSupplyFanStoppedInput = {
  id?: InputMaybe<Scalars['String']>;
  observedAt?: InputMaybe<Scalars['Float']>;
  previousId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  units?: InputMaybe<Scalars['String']>;
  updatePending?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<Scalars['Boolean']>;
};

export type FilterCountModbusAirHandlerAllowTenantChangeRhSetpointInput = {
  id?: InputMaybe<Scalars['String']>;
  observedAt?: InputMaybe<Scalars['Float']>;
  previousId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  units?: InputMaybe<Scalars['String']>;
  updatePending?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<Scalars['Boolean']>;
};

export type FilterCountModbusAirHandlerAllowTenantChangeTempSetpointsInput = {
  id?: InputMaybe<Scalars['String']>;
  observedAt?: InputMaybe<Scalars['Float']>;
  previousId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  units?: InputMaybe<Scalars['String']>;
  updatePending?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<Scalars['Boolean']>;
};

export type FilterCountModbusAirHandlerAllowTenantOnOffInput = {
  id?: InputMaybe<Scalars['String']>;
  observedAt?: InputMaybe<Scalars['Float']>;
  previousId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  units?: InputMaybe<Scalars['String']>;
  updatePending?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<Scalars['Boolean']>;
};

export type FilterCountModbusAirHandlerAltitudeInput = {
  id?: InputMaybe<Scalars['String']>;
  observedAt?: InputMaybe<Scalars['Float']>;
  previousId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  units?: InputMaybe<Scalars['String']>;
  updatePending?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<Scalars['Float']>;
};

export type FilterCountModbusAirHandlerAuxCoolingEnabledInput = {
  id?: InputMaybe<Scalars['String']>;
  observedAt?: InputMaybe<Scalars['Float']>;
  previousId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  units?: InputMaybe<Scalars['String']>;
  updatePending?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<Scalars['Boolean']>;
};

export type FilterCountModbusAirHandlerBiosVersionInput = {
  id?: InputMaybe<Scalars['String']>;
  observedAt?: InputMaybe<Scalars['Float']>;
  previousId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  units?: InputMaybe<Scalars['String']>;
  updatePending?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<Scalars['Float']>;
};

export type FilterCountModbusAirHandlerBootVersionInput = {
  id?: InputMaybe<Scalars['String']>;
  observedAt?: InputMaybe<Scalars['Float']>;
  previousId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  units?: InputMaybe<Scalars['String']>;
  updatePending?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<Scalars['Float']>;
};

export type FilterCountModbusAirHandlerCompressorOnInput = {
  id?: InputMaybe<Scalars['String']>;
  observedAt?: InputMaybe<Scalars['Float']>;
  previousId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  units?: InputMaybe<Scalars['String']>;
  updatePending?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<Scalars['Boolean']>;
};

export type FilterCountModbusAirHandlerConditionedTemperatureInput = {
  id?: InputMaybe<Scalars['String']>;
  observedAt?: InputMaybe<Scalars['Float']>;
  previousId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  units?: InputMaybe<Scalars['String']>;
  updatePending?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<Scalars['Float']>;
};

export type FilterCountModbusAirHandlerDamperPositionInput = {
  id?: InputMaybe<Scalars['String']>;
  observedAt?: InputMaybe<Scalars['Float']>;
  previousId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  units?: InputMaybe<Scalars['String']>;
  updatePending?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<Scalars['String']>;
};

export type FilterCountModbusAirHandlerDefrostTemperatureInput = {
  id?: InputMaybe<Scalars['String']>;
  observedAt?: InputMaybe<Scalars['Float']>;
  previousId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  units?: InputMaybe<Scalars['String']>;
  updatePending?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<Scalars['Float']>;
};

export type FilterCountModbusAirHandlerEnableTenantModeInput = {
  id?: InputMaybe<Scalars['String']>;
  observedAt?: InputMaybe<Scalars['Float']>;
  previousId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  units?: InputMaybe<Scalars['String']>;
  updatePending?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<Scalars['Boolean']>;
};

export type FilterCountModbusAirHandlerExhaustFanAirflowInput = {
  id?: InputMaybe<Scalars['String']>;
  observedAt?: InputMaybe<Scalars['Float']>;
  previousId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  units?: InputMaybe<Scalars['String']>;
  updatePending?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<Scalars['Float']>;
};

export type FilterCountModbusAirHandlerExhaustFanOnInput = {
  id?: InputMaybe<Scalars['String']>;
  observedAt?: InputMaybe<Scalars['Float']>;
  previousId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  units?: InputMaybe<Scalars['String']>;
  updatePending?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<Scalars['Boolean']>;
};

export type FilterCountModbusAirHandlerFiltersServiceTimeInput = {
  id?: InputMaybe<Scalars['String']>;
  observedAt?: InputMaybe<Scalars['Float']>;
  previousId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  units?: InputMaybe<Scalars['String']>;
  updatePending?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<Scalars['Float']>;
};

export type FilterCountModbusAirHandlerFreshAirSetpointInput = {
  id?: InputMaybe<Scalars['String']>;
  observedAt?: InputMaybe<Scalars['Float']>;
  previousId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  units?: InputMaybe<Scalars['String']>;
  updatePending?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<Scalars['Float']>;
};

export type FilterCountModbusAirHandlerGTerminalOnInput = {
  id?: InputMaybe<Scalars['String']>;
  observedAt?: InputMaybe<Scalars['Float']>;
  previousId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  units?: InputMaybe<Scalars['String']>;
  updatePending?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<Scalars['Boolean']>;
};

export type FilterCountModbusAirHandlerHTerminalOnInput = {
  id?: InputMaybe<Scalars['String']>;
  observedAt?: InputMaybe<Scalars['Float']>;
  previousId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  units?: InputMaybe<Scalars['String']>;
  updatePending?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<Scalars['Boolean']>;
};

export type FilterCountModbusAirHandlerHeatPumpModeOnInput = {
  id?: InputMaybe<Scalars['String']>;
  observedAt?: InputMaybe<Scalars['Float']>;
  previousId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  units?: InputMaybe<Scalars['String']>;
  updatePending?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<Scalars['Boolean']>;
};

export type FilterCountModbusAirHandlerHeatingElementOnInput = {
  id?: InputMaybe<Scalars['String']>;
  observedAt?: InputMaybe<Scalars['Float']>;
  previousId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  units?: InputMaybe<Scalars['String']>;
  updatePending?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<Scalars['Boolean']>;
};

export type FilterCountModbusAirHandlerHepaServiceTimeInput = {
  id?: InputMaybe<Scalars['String']>;
  observedAt?: InputMaybe<Scalars['Float']>;
  previousId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  units?: InputMaybe<Scalars['String']>;
  updatePending?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<Scalars['Float']>;
};

export type FilterCountModbusAirHandlerIndoorRhInput = {
  id?: InputMaybe<Scalars['String']>;
  observedAt?: InputMaybe<Scalars['Float']>;
  previousId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  units?: InputMaybe<Scalars['String']>;
  updatePending?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<Scalars['Float']>;
};

export type FilterCountModbusAirHandlerIndoorTemperatureInput = {
  id?: InputMaybe<Scalars['String']>;
  observedAt?: InputMaybe<Scalars['Float']>;
  previousId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  units?: InputMaybe<Scalars['String']>;
  updatePending?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<Scalars['Float']>;
};

export type FilterCountModbusAirHandlerInput = {
  AND?: InputMaybe<Array<FilterCountDeviceInput>>;
  OR?: InputMaybe<Array<FilterCountDeviceInput>>;
  _id?: InputMaybe<Scalars['String']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterCountDeviceOperatorsInput>;
  ahuCoolSetpoint?: InputMaybe<FilterCountModbusAirHandlerAhuCoolSetpointInput>;
  ahuHeatSetpoint?: InputMaybe<FilterCountModbusAirHandlerAhuHeatSetpointInput>;
  ahuMaxHeatSetpointLimit?: InputMaybe<FilterCountModbusAirHandlerAhuMaxHeatSetpointLimitInput>;
  ahuMinCoolSetpointLimit?: InputMaybe<FilterCountModbusAirHandlerAhuMinCoolSetpointLimitInput>;
  ahuModbusId?: InputMaybe<FilterCountModbusAirHandlerAhuModbusIdInput>;
  airExchangeModeOn?: InputMaybe<FilterCountModbusAirHandlerAirExchangeModeOnInput>;
  airflowUnits?: InputMaybe<FilterCountModbusAirHandlerAirflowUnitsInput>;
  alarmAirRestriction?: InputMaybe<FilterCountModbusAirHandlerAlarmAirRestrictionInput>;
  alarmB1SensorFail?: InputMaybe<FilterCountModbusAirHandlerAlarmB1SensorFailInput>;
  alarmB2SensorFail?: InputMaybe<FilterCountModbusAirHandlerAlarmB2SensorFailInput>;
  alarmB3SensorFail?: InputMaybe<FilterCountModbusAirHandlerAlarmB3SensorFailInput>;
  alarmB4SensorFail?: InputMaybe<FilterCountModbusAirHandlerAlarmB4SensorFailInput>;
  alarmB6SensorFail?: InputMaybe<FilterCountModbusAirHandlerAlarmB6SensorFailInput>;
  alarmChangeFilters?: InputMaybe<FilterCountModbusAirHandlerAlarmChangeFiltersInput>;
  alarmChangeHepa?: InputMaybe<FilterCountModbusAirHandlerAlarmChangeHepaInput>;
  alarmClockBoard?: InputMaybe<FilterCountModbusAirHandlerAlarmClockBoardInput>;
  alarmCompressorFail?: InputMaybe<FilterCountModbusAirHandlerAlarmCompressorFailInput>;
  alarmExhaustFanStopped?: InputMaybe<FilterCountModbusAirHandlerAlarmExhaustFanStoppedInput>;
  alarmExtendedMemory?: InputMaybe<FilterCountModbusAirHandlerAlarmExtendedMemoryInput>;
  alarmFanABReversed?: InputMaybe<FilterCountModbusAirHandlerAlarmFanAbReversedInput>;
  alarmFanANegPressureOpt1?: InputMaybe<FilterCountModbusAirHandlerAlarmFanANegPressureOpt1Input>;
  alarmFanANegPressureOpt2?: InputMaybe<FilterCountModbusAirHandlerAlarmFanANegPressureOpt2Input>;
  alarmGlobalAlarm?: InputMaybe<FilterCountModbusAirHandlerAlarmGlobalAlarmInput>;
  alarmHighPressure?: InputMaybe<FilterCountModbusAirHandlerAlarmHighPressureInput>;
  alarmLowPressure?: InputMaybe<FilterCountModbusAirHandlerAlarmLowPressureInput>;
  alarmRefrigerantLeak?: InputMaybe<FilterCountModbusAirHandlerAlarmRefrigerantLeakInput>;
  alarmSupplyFanStopped?: InputMaybe<FilterCountModbusAirHandlerAlarmSupplyFanStoppedInput>;
  alertTypes?: InputMaybe<FilterCountDeviceAlertTypesInput>;
  allowTenantChangeRHSetpoint?: InputMaybe<FilterCountModbusAirHandlerAllowTenantChangeRhSetpointInput>;
  allowTenantChangeTempSetpoints?: InputMaybe<FilterCountModbusAirHandlerAllowTenantChangeTempSetpointsInput>;
  allowTenantOnOff?: InputMaybe<FilterCountModbusAirHandlerAllowTenantOnOffInput>;
  altitude?: InputMaybe<FilterCountModbusAirHandlerAltitudeInput>;
  auxCoolingEnabled?: InputMaybe<FilterCountModbusAirHandlerAuxCoolingEnabledInput>;
  biosVersion?: InputMaybe<FilterCountModbusAirHandlerBiosVersionInput>;
  bootVersion?: InputMaybe<FilterCountModbusAirHandlerBootVersionInput>;
  compressorOn?: InputMaybe<FilterCountModbusAirHandlerCompressorOnInput>;
  conditionedTemperature?: InputMaybe<FilterCountModbusAirHandlerConditionedTemperatureInput>;
  controlled?: InputMaybe<FilterCountDeviceControlledInput>;
  damperPosition?: InputMaybe<FilterCountModbusAirHandlerDamperPositionInput>;
  defrostTemperature?: InputMaybe<FilterCountModbusAirHandlerDefrostTemperatureInput>;
  deviceId?: InputMaybe<Scalars['String']>;
  enableTenantMode?: InputMaybe<FilterCountModbusAirHandlerEnableTenantModeInput>;
  exhaustFanAirflow?: InputMaybe<FilterCountModbusAirHandlerExhaustFanAirflowInput>;
  exhaustFanOn?: InputMaybe<FilterCountModbusAirHandlerExhaustFanOnInput>;
  filtersServiceTime?: InputMaybe<FilterCountModbusAirHandlerFiltersServiceTimeInput>;
  freshAirSetpoint?: InputMaybe<FilterCountModbusAirHandlerFreshAirSetpointInput>;
  gTerminalOn?: InputMaybe<FilterCountModbusAirHandlerGTerminalOnInput>;
  hTerminalOn?: InputMaybe<FilterCountModbusAirHandlerHTerminalOnInput>;
  heatPumpModeOn?: InputMaybe<FilterCountModbusAirHandlerHeatPumpModeOnInput>;
  heatingElementOn?: InputMaybe<FilterCountModbusAirHandlerHeatingElementOnInput>;
  hepaServiceTime?: InputMaybe<FilterCountModbusAirHandlerHepaServiceTimeInput>;
  indoorRH?: InputMaybe<FilterCountModbusAirHandlerIndoorRhInput>;
  indoorTemperature?: InputMaybe<FilterCountModbusAirHandlerIndoorTemperatureInput>;
  installation?: InputMaybe<FilterCountDeviceInstallationInput>;
  location?: InputMaybe<Scalars['String']>;
  meta?: InputMaybe<FilterCountDeviceMetaInput>;
  /** The name of the device */
  name?: InputMaybe<Scalars['String']>;
  outsideTemperature?: InputMaybe<FilterCountModbusAirHandlerOutsideTemperatureInput>;
  panelId?: InputMaybe<Scalars['String']>;
  powerState?: InputMaybe<FilterCountDevicePowerStateInput>;
  propertyId?: InputMaybe<Scalars['String']>;
  recirculationModeOn?: InputMaybe<FilterCountModbusAirHandlerRecirculationModeOnInput>;
  resetFiltersServiceTime?: InputMaybe<FilterCountModbusAirHandlerResetFiltersServiceTimeInput>;
  resetHepaServiceTime?: InputMaybe<FilterCountModbusAirHandlerResetHepaServiceTimeInput>;
  reversibleValveOnWhen?: InputMaybe<FilterCountModbusAirHandlerReversibleValveOnWhenInput>;
  rhSetpoint?: InputMaybe<FilterCountModbusAirHandlerRhSetpointInput>;
  showerDetectorEnabled?: InputMaybe<FilterCountModbusAirHandlerShowerDetectorEnabledInput>;
  softwareReleaseType?: InputMaybe<FilterCountModbusAirHandlerSoftwareReleaseTypeInput>;
  softwareVersion?: InputMaybe<FilterCountModbusAirHandlerSoftwareVersionInput>;
  sourceId?: InputMaybe<Scalars['String']>;
  supplyFanAirflow?: InputMaybe<FilterCountModbusAirHandlerSupplyFanAirflowInput>;
  supplyFanOn?: InputMaybe<FilterCountModbusAirHandlerSupplyFanOnInput>;
  supplyFanStaticPressureH2O?: InputMaybe<FilterCountModbusAirHandlerSupplyFanStaticPressureH2OInput>;
  systemAutoMode?: InputMaybe<FilterCountModbusAirHandlerSystemAutoModeInput>;
  systemOnOff?: InputMaybe<FilterCountModbusAirHandlerSystemOnOffInput>;
  temperatureUnits?: InputMaybe<FilterCountModbusAirHandlerTemperatureUnitsInput>;
  tenantModePassword?: InputMaybe<FilterCountModbusAirHandlerTenantModePasswordInput>;
  timestamp?: InputMaybe<Scalars['Float']>;
  unitId?: InputMaybe<Scalars['String']>;
  updateStatus?: InputMaybe<Scalars['Boolean']>;
  ventilationMode?: InputMaybe<FilterCountModbusAirHandlerVentilationModeInput>;
  vppId?: InputMaybe<Scalars['String']>;
  wTerminalOn?: InputMaybe<FilterCountModbusAirHandlerWTerminalOnInput>;
  winterRhAdjustEnabled?: InputMaybe<FilterCountModbusAirHandlerWinterRhAdjustEnabledInput>;
  yTerminalOn?: InputMaybe<FilterCountModbusAirHandlerYTerminalOnInput>;
  zmbAhuRequestsSent?: InputMaybe<FilterCountModbusAirHandlerZmbAhuRequestsSentInput>;
  zmbAhuRequestsSentFailed?: InputMaybe<FilterCountModbusAirHandlerZmbAhuRequestsSentFailedInput>;
  zmbAirHandlerAlarm?: InputMaybe<FilterCountModbusAirHandlerZmbAirHandlerAlarmInput>;
  zmbCoreRequestsRecvd?: InputMaybe<FilterCountModbusAirHandlerZmbCoreRequestsRecvdInput>;
  zmbCpuTemperature?: InputMaybe<FilterCountModbusAirHandlerZmbCpuTemperatureInput>;
  zmbFirmwareVersion?: InputMaybe<FilterCountModbusAirHandlerZmbFirmwareVersionInput>;
  zmbGlobalAlarm?: InputMaybe<FilterCountModbusAirHandlerZmbGlobalAlarmInput>;
  zmbLeakDetected?: InputMaybe<FilterCountModbusAirHandlerZmbLeakDetectedInput>;
  zmbLeakDetectorInstalled?: InputMaybe<FilterCountModbusAirHandlerZmbLeakDetectorInstalledInput>;
  zmbModbusRequestDelay?: InputMaybe<FilterCountModbusAirHandlerZmbModbusRequestDelayInput>;
  zmbPollingFrequency?: InputMaybe<FilterCountModbusAirHandlerZmbPollingFrequencyInput>;
  zmbRequestsRecvdInvalid?: InputMaybe<FilterCountModbusAirHandlerZmbRequestsRecvdInvalidInput>;
  zmbSystemUptime?: InputMaybe<FilterCountModbusAirHandlerZmbSystemUptimeInput>;
  zmbThermostatAlarm?: InputMaybe<FilterCountModbusAirHandlerZmbThermostatAlarmInput>;
  zmbTstatRequestsRecvd?: InputMaybe<FilterCountModbusAirHandlerZmbTstatRequestsRecvdInput>;
  zoneId?: InputMaybe<Scalars['String']>;
};

export type FilterCountModbusAirHandlerOutsideTemperatureInput = {
  id?: InputMaybe<Scalars['String']>;
  observedAt?: InputMaybe<Scalars['Float']>;
  previousId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  units?: InputMaybe<Scalars['String']>;
  updatePending?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<Scalars['Float']>;
};

export type FilterCountModbusAirHandlerRecirculationModeOnInput = {
  id?: InputMaybe<Scalars['String']>;
  observedAt?: InputMaybe<Scalars['Float']>;
  previousId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  units?: InputMaybe<Scalars['String']>;
  updatePending?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<Scalars['Boolean']>;
};

export type FilterCountModbusAirHandlerResetFiltersServiceTimeInput = {
  id?: InputMaybe<Scalars['String']>;
  observedAt?: InputMaybe<Scalars['Float']>;
  previousId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  units?: InputMaybe<Scalars['String']>;
  updatePending?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<Scalars['String']>;
};

export type FilterCountModbusAirHandlerResetHepaServiceTimeInput = {
  id?: InputMaybe<Scalars['String']>;
  observedAt?: InputMaybe<Scalars['Float']>;
  previousId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  units?: InputMaybe<Scalars['String']>;
  updatePending?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<Scalars['String']>;
};

export type FilterCountModbusAirHandlerReversibleValveOnWhenInput = {
  id?: InputMaybe<Scalars['String']>;
  observedAt?: InputMaybe<Scalars['Float']>;
  previousId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  units?: InputMaybe<Scalars['String']>;
  updatePending?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<Scalars['String']>;
};

export type FilterCountModbusAirHandlerRhSetpointInput = {
  id?: InputMaybe<Scalars['String']>;
  observedAt?: InputMaybe<Scalars['Float']>;
  previousId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  units?: InputMaybe<Scalars['String']>;
  updatePending?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<Scalars['Float']>;
};

export type FilterCountModbusAirHandlerShowerDetectorEnabledInput = {
  id?: InputMaybe<Scalars['String']>;
  observedAt?: InputMaybe<Scalars['Float']>;
  previousId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  units?: InputMaybe<Scalars['String']>;
  updatePending?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<Scalars['Boolean']>;
};

export type FilterCountModbusAirHandlerSoftwareReleaseTypeInput = {
  id?: InputMaybe<Scalars['String']>;
  observedAt?: InputMaybe<Scalars['Float']>;
  previousId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  units?: InputMaybe<Scalars['String']>;
  updatePending?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<Scalars['String']>;
};

export type FilterCountModbusAirHandlerSoftwareVersionInput = {
  id?: InputMaybe<Scalars['String']>;
  observedAt?: InputMaybe<Scalars['Float']>;
  previousId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  units?: InputMaybe<Scalars['String']>;
  updatePending?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<Scalars['Float']>;
};

export type FilterCountModbusAirHandlerSupplyFanAirflowInput = {
  id?: InputMaybe<Scalars['String']>;
  observedAt?: InputMaybe<Scalars['Float']>;
  previousId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  units?: InputMaybe<Scalars['String']>;
  updatePending?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<Scalars['Float']>;
};

export type FilterCountModbusAirHandlerSupplyFanOnInput = {
  id?: InputMaybe<Scalars['String']>;
  observedAt?: InputMaybe<Scalars['Float']>;
  previousId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  units?: InputMaybe<Scalars['String']>;
  updatePending?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<Scalars['Boolean']>;
};

export type FilterCountModbusAirHandlerSupplyFanStaticPressureH2OInput = {
  id?: InputMaybe<Scalars['String']>;
  observedAt?: InputMaybe<Scalars['Float']>;
  previousId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  units?: InputMaybe<Scalars['String']>;
  updatePending?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<Scalars['Float']>;
};

export type FilterCountModbusAirHandlerSystemAutoModeInput = {
  id?: InputMaybe<Scalars['String']>;
  observedAt?: InputMaybe<Scalars['Float']>;
  previousId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  units?: InputMaybe<Scalars['String']>;
  updatePending?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<Scalars['String']>;
};

export type FilterCountModbusAirHandlerSystemOnOffInput = {
  id?: InputMaybe<Scalars['String']>;
  observedAt?: InputMaybe<Scalars['Float']>;
  previousId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  units?: InputMaybe<Scalars['String']>;
  updatePending?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<Scalars['String']>;
};

export type FilterCountModbusAirHandlerTemperatureUnitsInput = {
  id?: InputMaybe<Scalars['String']>;
  observedAt?: InputMaybe<Scalars['Float']>;
  previousId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  units?: InputMaybe<Scalars['String']>;
  updatePending?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<Scalars['String']>;
};

export type FilterCountModbusAirHandlerTenantModePasswordInput = {
  id?: InputMaybe<Scalars['String']>;
  observedAt?: InputMaybe<Scalars['Float']>;
  previousId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  units?: InputMaybe<Scalars['String']>;
  updatePending?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<Scalars['String']>;
};

export type FilterCountModbusAirHandlerVentilationModeInput = {
  id?: InputMaybe<Scalars['String']>;
  observedAt?: InputMaybe<Scalars['Float']>;
  previousId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  units?: InputMaybe<Scalars['String']>;
  updatePending?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<Scalars['String']>;
};

export type FilterCountModbusAirHandlerWTerminalOnInput = {
  id?: InputMaybe<Scalars['String']>;
  observedAt?: InputMaybe<Scalars['Float']>;
  previousId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  units?: InputMaybe<Scalars['String']>;
  updatePending?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<Scalars['Boolean']>;
};

export type FilterCountModbusAirHandlerWinterRhAdjustEnabledInput = {
  id?: InputMaybe<Scalars['String']>;
  observedAt?: InputMaybe<Scalars['Float']>;
  previousId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  units?: InputMaybe<Scalars['String']>;
  updatePending?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<Scalars['Boolean']>;
};

export type FilterCountModbusAirHandlerYTerminalOnInput = {
  id?: InputMaybe<Scalars['String']>;
  observedAt?: InputMaybe<Scalars['Float']>;
  previousId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  units?: InputMaybe<Scalars['String']>;
  updatePending?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<Scalars['Boolean']>;
};

export type FilterCountModbusAirHandlerZmbAhuRequestsSentFailedInput = {
  id?: InputMaybe<Scalars['String']>;
  observedAt?: InputMaybe<Scalars['Float']>;
  previousId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  units?: InputMaybe<Scalars['String']>;
  updatePending?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<Scalars['Float']>;
};

export type FilterCountModbusAirHandlerZmbAhuRequestsSentInput = {
  id?: InputMaybe<Scalars['String']>;
  observedAt?: InputMaybe<Scalars['Float']>;
  previousId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  units?: InputMaybe<Scalars['String']>;
  updatePending?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<Scalars['Float']>;
};

export type FilterCountModbusAirHandlerZmbAirHandlerAlarmInput = {
  id?: InputMaybe<Scalars['String']>;
  observedAt?: InputMaybe<Scalars['Float']>;
  previousId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  units?: InputMaybe<Scalars['String']>;
  updatePending?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<Scalars['Boolean']>;
};

export type FilterCountModbusAirHandlerZmbCoreRequestsRecvdInput = {
  id?: InputMaybe<Scalars['String']>;
  observedAt?: InputMaybe<Scalars['Float']>;
  previousId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  units?: InputMaybe<Scalars['String']>;
  updatePending?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<Scalars['Float']>;
};

export type FilterCountModbusAirHandlerZmbCpuTemperatureInput = {
  id?: InputMaybe<Scalars['String']>;
  observedAt?: InputMaybe<Scalars['Float']>;
  previousId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  units?: InputMaybe<Scalars['String']>;
  updatePending?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<Scalars['Float']>;
};

export type FilterCountModbusAirHandlerZmbFirmwareVersionInput = {
  id?: InputMaybe<Scalars['String']>;
  observedAt?: InputMaybe<Scalars['Float']>;
  previousId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  units?: InputMaybe<Scalars['String']>;
  updatePending?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<Scalars['String']>;
};

export type FilterCountModbusAirHandlerZmbGlobalAlarmInput = {
  id?: InputMaybe<Scalars['String']>;
  observedAt?: InputMaybe<Scalars['Float']>;
  previousId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  units?: InputMaybe<Scalars['String']>;
  updatePending?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<Scalars['Boolean']>;
};

export type FilterCountModbusAirHandlerZmbLeakDetectedInput = {
  id?: InputMaybe<Scalars['String']>;
  observedAt?: InputMaybe<Scalars['Float']>;
  previousId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  units?: InputMaybe<Scalars['String']>;
  updatePending?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<Scalars['Boolean']>;
};

export type FilterCountModbusAirHandlerZmbLeakDetectorInstalledInput = {
  id?: InputMaybe<Scalars['String']>;
  observedAt?: InputMaybe<Scalars['Float']>;
  previousId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  units?: InputMaybe<Scalars['String']>;
  updatePending?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<Scalars['Boolean']>;
};

export type FilterCountModbusAirHandlerZmbModbusRequestDelayInput = {
  id?: InputMaybe<Scalars['String']>;
  observedAt?: InputMaybe<Scalars['Float']>;
  previousId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  units?: InputMaybe<Scalars['String']>;
  updatePending?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<Scalars['Float']>;
};

export type FilterCountModbusAirHandlerZmbPollingFrequencyInput = {
  id?: InputMaybe<Scalars['String']>;
  observedAt?: InputMaybe<Scalars['Float']>;
  previousId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  units?: InputMaybe<Scalars['String']>;
  updatePending?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<Scalars['Float']>;
};

export type FilterCountModbusAirHandlerZmbRequestsRecvdInvalidInput = {
  id?: InputMaybe<Scalars['String']>;
  observedAt?: InputMaybe<Scalars['Float']>;
  previousId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  units?: InputMaybe<Scalars['String']>;
  updatePending?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<Scalars['Float']>;
};

export type FilterCountModbusAirHandlerZmbSystemUptimeInput = {
  id?: InputMaybe<Scalars['String']>;
  observedAt?: InputMaybe<Scalars['Float']>;
  previousId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  units?: InputMaybe<Scalars['String']>;
  updatePending?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<Scalars['Float']>;
};

export type FilterCountModbusAirHandlerZmbThermostatAlarmInput = {
  id?: InputMaybe<Scalars['String']>;
  observedAt?: InputMaybe<Scalars['Float']>;
  previousId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  units?: InputMaybe<Scalars['String']>;
  updatePending?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<Scalars['Boolean']>;
};

export type FilterCountModbusAirHandlerZmbTstatRequestsRecvdInput = {
  id?: InputMaybe<Scalars['String']>;
  observedAt?: InputMaybe<Scalars['Float']>;
  previousId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  units?: InputMaybe<Scalars['String']>;
  updatePending?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<Scalars['Float']>;
};

export type FilterCountOauthAccessTokenClientIdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['String']>;
  gte?: InputMaybe<Scalars['String']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  lt?: InputMaybe<Scalars['String']>;
  lte?: InputMaybe<Scalars['String']>;
  ne?: InputMaybe<Scalars['String']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']>;
};

export type FilterCountOauthAccessTokenInput = {
  AND?: InputMaybe<Array<FilterCountOauthAccessTokenInput>>;
  OR?: InputMaybe<Array<FilterCountOauthAccessTokenInput>>;
  _id?: InputMaybe<Scalars['String']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterCountOauthAccessTokenOperatorsInput>;
  accessToken?: InputMaybe<Scalars['String']>;
  clientId?: InputMaybe<Scalars['String']>;
  expires?: InputMaybe<Scalars['Float']>;
  userId?: InputMaybe<Scalars['String']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterCountOauthAccessTokenOperatorsInput = {
  _id?: InputMaybe<FilterCountOauthAccessToken_IdOperatorsInput>;
  clientId?: InputMaybe<FilterCountOauthAccessTokenClientIdOperatorsInput>;
};

export type FilterCountOauthAccessToken_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['String']>;
  gte?: InputMaybe<Scalars['String']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  lt?: InputMaybe<Scalars['String']>;
  lte?: InputMaybe<Scalars['String']>;
  ne?: InputMaybe<Scalars['String']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']>;
};

export type FilterCountOauthAuthCodeClientIdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['String']>;
  gte?: InputMaybe<Scalars['String']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  lt?: InputMaybe<Scalars['String']>;
  lte?: InputMaybe<Scalars['String']>;
  ne?: InputMaybe<Scalars['String']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']>;
};

export type FilterCountOauthAuthCodeInput = {
  AND?: InputMaybe<Array<FilterCountOauthAuthCodeInput>>;
  OR?: InputMaybe<Array<FilterCountOauthAuthCodeInput>>;
  _id?: InputMaybe<Scalars['String']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterCountOauthAuthCodeOperatorsInput>;
  authCode?: InputMaybe<Scalars['String']>;
  clientId?: InputMaybe<Scalars['String']>;
  expires?: InputMaybe<Scalars['Float']>;
  userId?: InputMaybe<Scalars['String']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterCountOauthAuthCodeOperatorsInput = {
  _id?: InputMaybe<FilterCountOauthAuthCode_IdOperatorsInput>;
  clientId?: InputMaybe<FilterCountOauthAuthCodeClientIdOperatorsInput>;
};

export type FilterCountOauthAuthCode_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['String']>;
  gte?: InputMaybe<Scalars['String']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  lt?: InputMaybe<Scalars['String']>;
  lte?: InputMaybe<Scalars['String']>;
  ne?: InputMaybe<Scalars['String']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']>;
};

export type FilterCountOauthClientClientIdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['String']>;
  gte?: InputMaybe<Scalars['String']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  lt?: InputMaybe<Scalars['String']>;
  lte?: InputMaybe<Scalars['String']>;
  ne?: InputMaybe<Scalars['String']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']>;
};

export type FilterCountOauthClientInput = {
  AND?: InputMaybe<Array<FilterCountOauthClientInput>>;
  OR?: InputMaybe<Array<FilterCountOauthClientInput>>;
  _id?: InputMaybe<Scalars['String']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterCountOauthClientOperatorsInput>;
  active?: InputMaybe<Scalars['Boolean']>;
  brand?: InputMaybe<Scalars['String']>;
  clientId?: InputMaybe<Scalars['String']>;
  clientSecret?: InputMaybe<Scalars['String']>;
  redirectUri?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  serviceDescription?: InputMaybe<Scalars['String']>;
  serviceName?: InputMaybe<Scalars['String']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterCountOauthClientOperatorsInput = {
  _id?: InputMaybe<FilterCountOauthClient_IdOperatorsInput>;
  clientId?: InputMaybe<FilterCountOauthClientClientIdOperatorsInput>;
};

export type FilterCountOauthClient_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['String']>;
  gte?: InputMaybe<Scalars['String']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  lt?: InputMaybe<Scalars['String']>;
  lte?: InputMaybe<Scalars['String']>;
  ne?: InputMaybe<Scalars['String']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']>;
};

export type FilterCountOccupancySensorInput = {
  AND?: InputMaybe<Array<FilterCountDeviceInput>>;
  OR?: InputMaybe<Array<FilterCountDeviceInput>>;
  _id?: InputMaybe<Scalars['String']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterCountDeviceOperatorsInput>;
  alertTypes?: InputMaybe<FilterCountDeviceAlertTypesInput>;
  controlled?: InputMaybe<FilterCountDeviceControlledInput>;
  deviceId?: InputMaybe<Scalars['String']>;
  installation?: InputMaybe<FilterCountDeviceInstallationInput>;
  location?: InputMaybe<Scalars['String']>;
  meta?: InputMaybe<FilterCountDeviceMetaInput>;
  /** The name of the device */
  name?: InputMaybe<Scalars['String']>;
  occupancy?: InputMaybe<FilterCountOccupancySensorOccupancyInput>;
  panelId?: InputMaybe<Scalars['String']>;
  powerState?: InputMaybe<FilterCountDevicePowerStateInput>;
  propertyId?: InputMaybe<Scalars['String']>;
  sourceId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  unitId?: InputMaybe<Scalars['String']>;
  updateStatus?: InputMaybe<Scalars['Boolean']>;
  voltage?: InputMaybe<FilterCountOccupancySensorVoltageInput>;
  vppId?: InputMaybe<Scalars['String']>;
  zoneId?: InputMaybe<Scalars['String']>;
};

export type FilterCountOccupancySensorOccupancyInput = {
  id?: InputMaybe<Scalars['String']>;
  observedAt?: InputMaybe<Scalars['Float']>;
  previousId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  units?: InputMaybe<Scalars['String']>;
  updatePending?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<EnumOccupancySensorOccupancyValue>;
};

export type FilterCountOccupancySensorVoltageInput = {
  id?: InputMaybe<Scalars['String']>;
  observedAt?: InputMaybe<Scalars['Float']>;
  previousId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  units?: InputMaybe<Scalars['String']>;
  updatePending?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<Scalars['Float']>;
};

export type FilterCountOpenWeatherInput = {
  AND?: InputMaybe<Array<FilterCountDeviceInput>>;
  OR?: InputMaybe<Array<FilterCountDeviceInput>>;
  _id?: InputMaybe<Scalars['String']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterCountDeviceOperatorsInput>;
  alertTypes?: InputMaybe<FilterCountDeviceAlertTypesInput>;
  controlled?: InputMaybe<FilterCountDeviceControlledInput>;
  deviceId?: InputMaybe<Scalars['String']>;
  installation?: InputMaybe<FilterCountDeviceInstallationInput>;
  location?: InputMaybe<Scalars['String']>;
  meta?: InputMaybe<FilterCountDeviceMetaInput>;
  /** The name of the device */
  name?: InputMaybe<Scalars['String']>;
  panelId?: InputMaybe<Scalars['String']>;
  powerState?: InputMaybe<FilterCountDevicePowerStateInput>;
  propertyId?: InputMaybe<Scalars['String']>;
  sourceId?: InputMaybe<Scalars['String']>;
  temperature?: InputMaybe<FilterCountOpenWeatherTemperatureInput>;
  timestamp?: InputMaybe<Scalars['Float']>;
  unitId?: InputMaybe<Scalars['String']>;
  updateStatus?: InputMaybe<Scalars['Boolean']>;
  vppId?: InputMaybe<Scalars['String']>;
  zoneId?: InputMaybe<Scalars['String']>;
};

export type FilterCountOpenWeatherTemperatureInput = {
  id?: InputMaybe<Scalars['String']>;
  observedAt?: InputMaybe<Scalars['Float']>;
  previousId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  units?: InputMaybe<Scalars['String']>;
  updatePending?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<Scalars['Float']>;
};

export type FilterCountOrganizationHqAddressInput = {
  city?: InputMaybe<Scalars['String']>;
  country?: InputMaybe<Scalars['String']>;
  line1?: InputMaybe<Scalars['String']>;
  line2?: InputMaybe<Scalars['String']>;
  postalCode?: InputMaybe<Scalars['String']>;
  state?: InputMaybe<Scalars['String']>;
};

export type FilterCountOrganizationInput = {
  AND?: InputMaybe<Array<FilterCountOrganizationInput>>;
  OR?: InputMaybe<Array<FilterCountOrganizationInput>>;
  _id?: InputMaybe<Scalars['String']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterCountOrganizationOperatorsInput>;
  description?: InputMaybe<Scalars['String']>;
  hqAddress?: InputMaybe<FilterCountOrganizationHqAddressInput>;
  hqEmail?: InputMaybe<Scalars['String']>;
  hqPhone?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  parentOrganizationId?: InputMaybe<Scalars['String']>;
};

export type FilterCountOrganizationNameOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['String']>;
  gte?: InputMaybe<Scalars['String']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  lt?: InputMaybe<Scalars['String']>;
  lte?: InputMaybe<Scalars['String']>;
  ne?: InputMaybe<Scalars['String']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterCountOrganizationOperatorsInput = {
  _id?: InputMaybe<FilterCountOrganization_IdOperatorsInput>;
  name?: InputMaybe<FilterCountOrganizationNameOperatorsInput>;
  parentOrganizationId?: InputMaybe<FilterCountOrganizationParentOrganizationIdOperatorsInput>;
};

export type FilterCountOrganizationParentOrganizationIdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['String']>;
  gte?: InputMaybe<Scalars['String']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  lt?: InputMaybe<Scalars['String']>;
  lte?: InputMaybe<Scalars['String']>;
  ne?: InputMaybe<Scalars['String']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']>;
};

export type FilterCountOrganization_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['String']>;
  gte?: InputMaybe<Scalars['String']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  lt?: InputMaybe<Scalars['String']>;
  lte?: InputMaybe<Scalars['String']>;
  ne?: InputMaybe<Scalars['String']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']>;
};

export type FilterCountOutdoorSensorInput = {
  AND?: InputMaybe<Array<FilterCountDeviceInput>>;
  OR?: InputMaybe<Array<FilterCountDeviceInput>>;
  _id?: InputMaybe<Scalars['String']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterCountDeviceOperatorsInput>;
  alertTypes?: InputMaybe<FilterCountDeviceAlertTypesInput>;
  controlled?: InputMaybe<FilterCountDeviceControlledInput>;
  deviceId?: InputMaybe<Scalars['String']>;
  installation?: InputMaybe<FilterCountDeviceInstallationInput>;
  location?: InputMaybe<Scalars['String']>;
  meta?: InputMaybe<FilterCountDeviceMetaInput>;
  /** The name of the device */
  name?: InputMaybe<Scalars['String']>;
  panelId?: InputMaybe<Scalars['String']>;
  powerState?: InputMaybe<FilterCountDevicePowerStateInput>;
  propertyId?: InputMaybe<Scalars['String']>;
  sourceId?: InputMaybe<Scalars['String']>;
  temperature?: InputMaybe<FilterCountOutdoorSensorTemperatureInput>;
  timestamp?: InputMaybe<Scalars['Float']>;
  unitId?: InputMaybe<Scalars['String']>;
  updateStatus?: InputMaybe<Scalars['Boolean']>;
  vppId?: InputMaybe<Scalars['String']>;
  zoneId?: InputMaybe<Scalars['String']>;
};

export type FilterCountOutdoorSensorTemperatureInput = {
  id?: InputMaybe<Scalars['String']>;
  observedAt?: InputMaybe<Scalars['Float']>;
  previousId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  units?: InputMaybe<Scalars['String']>;
  updatePending?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<Scalars['Float']>;
};

export type FilterCountPanelInput = {
  AND?: InputMaybe<Array<FilterCountPanelInput>>;
  OR?: InputMaybe<Array<FilterCountPanelInput>>;
  _id?: InputMaybe<Scalars['String']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterCountPanelOperatorsInput>;
  name?: InputMaybe<Scalars['String']>;
  propertyId?: InputMaybe<Scalars['String']>;
  role?: InputMaybe<Scalars['String']>;
  sourceId?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<EnumPanelType>;
  unitId?: InputMaybe<Scalars['String']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterCountPanelOperatorsInput = {
  _id?: InputMaybe<FilterCountPanel_IdOperatorsInput>;
  propertyId?: InputMaybe<FilterCountPanelPropertyIdOperatorsInput>;
  unitId?: InputMaybe<FilterCountPanelUnitIdOperatorsInput>;
};

export type FilterCountPanelPropertyIdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['String']>;
  gte?: InputMaybe<Scalars['String']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  lt?: InputMaybe<Scalars['String']>;
  lte?: InputMaybe<Scalars['String']>;
  ne?: InputMaybe<Scalars['String']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']>;
};

export type FilterCountPanelUnitIdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['String']>;
  gte?: InputMaybe<Scalars['String']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  lt?: InputMaybe<Scalars['String']>;
  lte?: InputMaybe<Scalars['String']>;
  ne?: InputMaybe<Scalars['String']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']>;
};

export type FilterCountPanel_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['String']>;
  gte?: InputMaybe<Scalars['String']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  lt?: InputMaybe<Scalars['String']>;
  lte?: InputMaybe<Scalars['String']>;
  ne?: InputMaybe<Scalars['String']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']>;
};

export type FilterCountPlmContractContractIdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['String']>;
  gte?: InputMaybe<Scalars['String']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  lt?: InputMaybe<Scalars['String']>;
  lte?: InputMaybe<Scalars['String']>;
  ne?: InputMaybe<Scalars['String']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']>;
};

export type FilterCountPlmContractInput = {
  AND?: InputMaybe<Array<FilterCountPlmContractInput>>;
  OR?: InputMaybe<Array<FilterCountPlmContractInput>>;
  _id?: InputMaybe<Scalars['String']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterCountPlmContractOperatorsInput>;
  baselineMethod?: InputMaybe<EnumPlmContractBaselineMethod>;
  contractId?: InputMaybe<Scalars['String']>;
  dispatcherIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  incentiveDescription?: InputMaybe<Scalars['String']>;
  maximumEventsPerSeason?: InputMaybe<Scalars['Float']>;
  meterIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  minimumReductionKW?: InputMaybe<Scalars['Float']>;
  name?: InputMaybe<Scalars['String']>;
  notificationEmail?: InputMaybe<Scalars['String']>;
  partnerId?: InputMaybe<Scalars['String']>;
  penaltyForNonCompliance?: InputMaybe<Scalars['Float']>;
  programId?: InputMaybe<Scalars['String']>;
  propertyIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  scopeType?: InputMaybe<EnumPlmContractScopeType>;
  status?: InputMaybe<EnumPlmContractStatus>;
  utilityId?: InputMaybe<Scalars['String']>;
};

export type FilterCountPlmContractNotificationEmailOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['String']>;
  gte?: InputMaybe<Scalars['String']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  lt?: InputMaybe<Scalars['String']>;
  lte?: InputMaybe<Scalars['String']>;
  ne?: InputMaybe<Scalars['String']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterCountPlmContractOperatorsInput = {
  _id?: InputMaybe<FilterCountPlmContract_IdOperatorsInput>;
  contractId?: InputMaybe<FilterCountPlmContractContractIdOperatorsInput>;
  notificationEmail?: InputMaybe<FilterCountPlmContractNotificationEmailOperatorsInput>;
  programId?: InputMaybe<FilterCountPlmContractProgramIdOperatorsInput>;
};

export type FilterCountPlmContractProgramIdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['String']>;
  gte?: InputMaybe<Scalars['String']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  lt?: InputMaybe<Scalars['String']>;
  lte?: InputMaybe<Scalars['String']>;
  ne?: InputMaybe<Scalars['String']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']>;
};

export type FilterCountPlmContract_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['String']>;
  gte?: InputMaybe<Scalars['String']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  lt?: InputMaybe<Scalars['String']>;
  lte?: InputMaybe<Scalars['String']>;
  ne?: InputMaybe<Scalars['String']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']>;
};

export type FilterCountPlmCurtailmentActionDeviceTypeOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<EnumPlmCurtailmentActionDeviceType>;
  gte?: InputMaybe<EnumPlmCurtailmentActionDeviceType>;
  in?: InputMaybe<Array<InputMaybe<EnumPlmCurtailmentActionDeviceType>>>;
  lt?: InputMaybe<EnumPlmCurtailmentActionDeviceType>;
  lte?: InputMaybe<EnumPlmCurtailmentActionDeviceType>;
  ne?: InputMaybe<EnumPlmCurtailmentActionDeviceType>;
  nin?: InputMaybe<Array<InputMaybe<EnumPlmCurtailmentActionDeviceType>>>;
};

export type FilterCountPlmCurtailmentActionEstimatedReductionKwOperatorsInput =
  {
    exists?: InputMaybe<Scalars['Boolean']>;
    gt?: InputMaybe<Scalars['Float']>;
    gte?: InputMaybe<Scalars['Float']>;
    in?: InputMaybe<Array<InputMaybe<Scalars['Float']>>>;
    lt?: InputMaybe<Scalars['Float']>;
    lte?: InputMaybe<Scalars['Float']>;
    ne?: InputMaybe<Scalars['Float']>;
    nin?: InputMaybe<Array<InputMaybe<Scalars['Float']>>>;
  };

export type FilterCountPlmCurtailmentActionInput = {
  AND?: InputMaybe<Array<FilterCountPlmCurtailmentActionInput>>;
  OR?: InputMaybe<Array<FilterCountPlmCurtailmentActionInput>>;
  _id?: InputMaybe<Scalars['String']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterCountPlmCurtailmentActionOperatorsInput>;
  autoBatch?: InputMaybe<Scalars['Boolean']>;
  batchCount?: InputMaybe<Scalars['Float']>;
  batchDuration?: InputMaybe<Scalars['Float']>;
  batchStartTimeOffset?: InputMaybe<Scalars['Float']>;
  description?: InputMaybe<Scalars['String']>;
  deviceType?: InputMaybe<EnumPlmCurtailmentActionDeviceType>;
  estimatedReductionKW?: InputMaybe<Scalars['Float']>;
  name?: InputMaybe<Scalars['String']>;
  plmCurtailmentPlanId?: InputMaybe<Scalars['String']>;
  startTimeOffset?: InputMaybe<Scalars['Float']>;
  targetDevices?: InputMaybe<Scalars['JSON']>;
  targetedAdjustments?: InputMaybe<FilterCountPlmCurtailmentTaskCachedDeviceStateInput>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterCountPlmCurtailmentActionOperatorsInput = {
  _id?: InputMaybe<FilterCountPlmCurtailmentAction_IdOperatorsInput>;
  deviceType?: InputMaybe<FilterCountPlmCurtailmentActionDeviceTypeOperatorsInput>;
  estimatedReductionKW?: InputMaybe<FilterCountPlmCurtailmentActionEstimatedReductionKwOperatorsInput>;
  plmCurtailmentPlanId?: InputMaybe<FilterCountPlmCurtailmentActionPlmCurtailmentPlanIdOperatorsInput>;
};

export type FilterCountPlmCurtailmentActionPlmCurtailmentPlanIdOperatorsInput =
  {
    exists?: InputMaybe<Scalars['Boolean']>;
    gt?: InputMaybe<Scalars['String']>;
    gte?: InputMaybe<Scalars['String']>;
    in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    lt?: InputMaybe<Scalars['String']>;
    lte?: InputMaybe<Scalars['String']>;
    ne?: InputMaybe<Scalars['String']>;
    nin?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    regex?: InputMaybe<Scalars['RegExpAsString']>;
  };

export type FilterCountPlmCurtailmentAction_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['String']>;
  gte?: InputMaybe<Scalars['String']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  lt?: InputMaybe<Scalars['String']>;
  lte?: InputMaybe<Scalars['String']>;
  ne?: InputMaybe<Scalars['String']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']>;
};

export type FilterCountPlmCurtailmentPlanDurationMinutesOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['Float']>;
  gte?: InputMaybe<Scalars['Float']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Float']>>>;
  lt?: InputMaybe<Scalars['Float']>;
  lte?: InputMaybe<Scalars['Float']>;
  ne?: InputMaybe<Scalars['Float']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Float']>>>;
};

export type FilterCountPlmCurtailmentPlanEstimatedReductionKwOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['Float']>;
  gte?: InputMaybe<Scalars['Float']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Float']>>>;
  lt?: InputMaybe<Scalars['Float']>;
  lte?: InputMaybe<Scalars['Float']>;
  ne?: InputMaybe<Scalars['Float']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Float']>>>;
};

export type FilterCountPlmCurtailmentPlanInput = {
  AND?: InputMaybe<Array<FilterCountPlmCurtailmentPlanInput>>;
  OR?: InputMaybe<Array<FilterCountPlmCurtailmentPlanInput>>;
  _id?: InputMaybe<Scalars['String']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterCountPlmCurtailmentPlanOperatorsInput>;
  applicableSeasons?: InputMaybe<
    Array<InputMaybe<EnumPlmCurtailmentPlanApplicableSeasons>>
  >;
  description?: InputMaybe<Scalars['String']>;
  durationMinutes?: InputMaybe<Scalars['Float']>;
  estimatedReductionKW?: InputMaybe<Scalars['Float']>;
  name?: InputMaybe<Scalars['String']>;
  organizationId?: InputMaybe<Scalars['String']>;
};

export type FilterCountPlmCurtailmentPlanNameOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['String']>;
  gte?: InputMaybe<Scalars['String']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  lt?: InputMaybe<Scalars['String']>;
  lte?: InputMaybe<Scalars['String']>;
  ne?: InputMaybe<Scalars['String']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterCountPlmCurtailmentPlanOperatorsInput = {
  _id?: InputMaybe<FilterCountPlmCurtailmentPlan_IdOperatorsInput>;
  durationMinutes?: InputMaybe<FilterCountPlmCurtailmentPlanDurationMinutesOperatorsInput>;
  estimatedReductionKW?: InputMaybe<FilterCountPlmCurtailmentPlanEstimatedReductionKwOperatorsInput>;
  name?: InputMaybe<FilterCountPlmCurtailmentPlanNameOperatorsInput>;
  organizationId?: InputMaybe<FilterCountPlmCurtailmentPlanOrganizationIdOperatorsInput>;
};

export type FilterCountPlmCurtailmentPlanOrganizationIdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['String']>;
  gte?: InputMaybe<Scalars['String']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  lt?: InputMaybe<Scalars['String']>;
  lte?: InputMaybe<Scalars['String']>;
  ne?: InputMaybe<Scalars['String']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']>;
};

export type FilterCountPlmCurtailmentPlan_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['String']>;
  gte?: InputMaybe<Scalars['String']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  lt?: InputMaybe<Scalars['String']>;
  lte?: InputMaybe<Scalars['String']>;
  ne?: InputMaybe<Scalars['String']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']>;
};

export type FilterCountPlmCurtailmentTaskCachedDeviceStateInput = {
  coolSetpoint?: InputMaybe<Scalars['Float']>;
  coolSetpointAdjustmentMode?: InputMaybe<EnumPlmCurtailmentTaskCachedDeviceStateCoolSetpointAdjustmentMode>;
  fanMode?: InputMaybe<Scalars['String']>;
  fanSpeed?: InputMaybe<Scalars['String']>;
  freshAirSetpoint?: InputMaybe<Scalars['Float']>;
  heatSetpoint?: InputMaybe<Scalars['Float']>;
  heatSetpointAdjustmentMode?: InputMaybe<EnumPlmCurtailmentTaskCachedDeviceStateHeatSetpointAdjustmentMode>;
  isOn?: InputMaybe<Scalars['Boolean']>;
  keypadLockoutLevel?: InputMaybe<Scalars['String']>;
  maxCoolSetpointLimit?: InputMaybe<Scalars['Float']>;
  maxHeatSetpointLimit?: InputMaybe<Scalars['Float']>;
  minCoolSetpointLimit?: InputMaybe<Scalars['Float']>;
  minHeatSetpointLimit?: InputMaybe<Scalars['Float']>;
  operatingMode?: InputMaybe<Scalars['String']>;
  rhSetpoint?: InputMaybe<Scalars['Float']>;
  type?: InputMaybe<EnumPlmCurtailmentTaskCachedDeviceStateType>;
  ventilationMode?: InputMaybe<Scalars['String']>;
};

export type FilterCountPlmCurtailmentTaskDeviceIdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['String']>;
  gte?: InputMaybe<Scalars['String']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  lt?: InputMaybe<Scalars['String']>;
  lte?: InputMaybe<Scalars['String']>;
  ne?: InputMaybe<Scalars['String']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']>;
};

export type FilterCountPlmCurtailmentTaskInput = {
  AND?: InputMaybe<Array<FilterCountPlmCurtailmentTaskInput>>;
  OR?: InputMaybe<Array<FilterCountPlmCurtailmentTaskInput>>;
  _id?: InputMaybe<Scalars['String']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterCountPlmCurtailmentTaskOperatorsInput>;
  batchId?: InputMaybe<Scalars['Float']>;
  cachedDeviceState?: InputMaybe<FilterCountPlmCurtailmentTaskCachedDeviceStateInput>;
  deviceId?: InputMaybe<Scalars['String']>;
  deviceType?: InputMaybe<Scalars['String']>;
  endedAt?: InputMaybe<Scalars['Float']>;
  estimatedReductionKW?: InputMaybe<Scalars['Float']>;
  plmCurtailmentActionId?: InputMaybe<Scalars['String']>;
  plmEventResponseId?: InputMaybe<Scalars['String']>;
  propertyId?: InputMaybe<Scalars['String']>;
  resolvedTargetedAdjustments?: InputMaybe<FilterCountPlmCurtailmentTaskCachedDeviceStateInput>;
  scheduledEnd?: InputMaybe<Scalars['Float']>;
  scheduledStart?: InputMaybe<Scalars['Float']>;
  startedAt?: InputMaybe<Scalars['Float']>;
  status?: InputMaybe<EnumPlmCurtailmentTaskStatus>;
  statusMessage?: InputMaybe<Scalars['String']>;
  targetedAdjustments?: InputMaybe<FilterCountPlmCurtailmentTaskCachedDeviceStateInput>;
  unitId?: InputMaybe<Scalars['String']>;
  updateRetryCount?: InputMaybe<Scalars['Float']>;
  verifiedAt?: InputMaybe<Scalars['Float']>;
  verifyAttempts?: InputMaybe<Scalars['Float']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterCountPlmCurtailmentTaskOperatorsInput = {
  _id?: InputMaybe<FilterCountPlmCurtailmentTask_IdOperatorsInput>;
  deviceId?: InputMaybe<FilterCountPlmCurtailmentTaskDeviceIdOperatorsInput>;
};

export type FilterCountPlmCurtailmentTask_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['String']>;
  gte?: InputMaybe<Scalars['String']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  lt?: InputMaybe<Scalars['String']>;
  lte?: InputMaybe<Scalars['String']>;
  ne?: InputMaybe<Scalars['String']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']>;
};

export type FilterCountPlmEventContractIdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['String']>;
  gte?: InputMaybe<Scalars['String']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  lt?: InputMaybe<Scalars['String']>;
  lte?: InputMaybe<Scalars['String']>;
  ne?: InputMaybe<Scalars['String']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']>;
};

export type FilterCountPlmEventInput = {
  AND?: InputMaybe<Array<FilterCountPlmEventInput>>;
  OR?: InputMaybe<Array<FilterCountPlmEventInput>>;
  _id?: InputMaybe<Scalars['String']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterCountPlmEventOperatorsInput>;
  contractId?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['Float']>;
  duration?: InputMaybe<Scalars['Float']>;
  notificationHeaders?: InputMaybe<Scalars['JSON']>;
  notificationMethod?: InputMaybe<EnumPlmEventNotificationMethod>;
  notificationPayload?: InputMaybe<Scalars['String']>;
  notificationReceivedAt?: InputMaybe<Scalars['Float']>;
  programId?: InputMaybe<Scalars['String']>;
  reductionTarget?: InputMaybe<Scalars['Float']>;
  sourceExternalId?: InputMaybe<Scalars['String']>;
  sourceVendor?: InputMaybe<Scalars['String']>;
  startTime?: InputMaybe<Scalars['Float']>;
  status?: InputMaybe<EnumPlmEventStatus>;
  updatedAt?: InputMaybe<Scalars['Float']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterCountPlmEventOperatorsInput = {
  _id?: InputMaybe<FilterCountPlmEvent_IdOperatorsInput>;
  contractId?: InputMaybe<FilterCountPlmEventContractIdOperatorsInput>;
  programId?: InputMaybe<FilterCountPlmEventProgramIdOperatorsInput>;
  sourceVendor?: InputMaybe<FilterCountPlmEventSourceVendorOperatorsInput>;
  startTime?: InputMaybe<FilterCountPlmEventStartTimeOperatorsInput>;
  status?: InputMaybe<FilterCountPlmEventStatusOperatorsInput>;
};

export type FilterCountPlmEventProgramIdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['String']>;
  gte?: InputMaybe<Scalars['String']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  lt?: InputMaybe<Scalars['String']>;
  lte?: InputMaybe<Scalars['String']>;
  ne?: InputMaybe<Scalars['String']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']>;
};

export type FilterCountPlmEventResponseCurtailmentPlanIdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['String']>;
  gte?: InputMaybe<Scalars['String']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  lt?: InputMaybe<Scalars['String']>;
  lte?: InputMaybe<Scalars['String']>;
  ne?: InputMaybe<Scalars['String']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']>;
};

export type FilterCountPlmEventResponseEventIdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['String']>;
  gte?: InputMaybe<Scalars['String']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  lt?: InputMaybe<Scalars['String']>;
  lte?: InputMaybe<Scalars['String']>;
  ne?: InputMaybe<Scalars['String']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']>;
};

export type FilterCountPlmEventResponseInput = {
  AND?: InputMaybe<Array<FilterCountPlmEventResponseInput>>;
  OR?: InputMaybe<Array<FilterCountPlmEventResponseInput>>;
  _id?: InputMaybe<Scalars['String']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterCountPlmEventResponseOperatorsInput>;
  actualEnd?: InputMaybe<Scalars['Float']>;
  actualStart?: InputMaybe<Scalars['Float']>;
  createdAt?: InputMaybe<Scalars['Float']>;
  curtailmentPlanId?: InputMaybe<Scalars['String']>;
  eventId?: InputMaybe<Scalars['String']>;
  propertyId?: InputMaybe<Scalars['String']>;
  responseSentAt?: InputMaybe<Scalars['Float']>;
  responseStatus?: InputMaybe<EnumPlmEventResponseResponseStatus>;
  scheduledEnd?: InputMaybe<Scalars['Float']>;
  scheduledStart?: InputMaybe<Scalars['Float']>;
  updatedAt?: InputMaybe<Scalars['Float']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterCountPlmEventResponseOperatorsInput = {
  _id?: InputMaybe<FilterCountPlmEventResponse_IdOperatorsInput>;
  curtailmentPlanId?: InputMaybe<FilterCountPlmEventResponseCurtailmentPlanIdOperatorsInput>;
  eventId?: InputMaybe<FilterCountPlmEventResponseEventIdOperatorsInput>;
  propertyId?: InputMaybe<FilterCountPlmEventResponsePropertyIdOperatorsInput>;
  responseSentAt?: InputMaybe<FilterCountPlmEventResponseResponseSentAtOperatorsInput>;
  responseStatus?: InputMaybe<FilterCountPlmEventResponseResponseStatusOperatorsInput>;
  scheduledStart?: InputMaybe<FilterCountPlmEventResponseScheduledStartOperatorsInput>;
};

export type FilterCountPlmEventResponsePropertyIdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['String']>;
  gte?: InputMaybe<Scalars['String']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  lt?: InputMaybe<Scalars['String']>;
  lte?: InputMaybe<Scalars['String']>;
  ne?: InputMaybe<Scalars['String']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']>;
};

export type FilterCountPlmEventResponseResponseSentAtOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['Float']>;
  gte?: InputMaybe<Scalars['Float']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Float']>>>;
  lt?: InputMaybe<Scalars['Float']>;
  lte?: InputMaybe<Scalars['Float']>;
  ne?: InputMaybe<Scalars['Float']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Float']>>>;
};

export type FilterCountPlmEventResponseResponseStatusOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<EnumPlmEventResponseResponseStatus>;
  gte?: InputMaybe<EnumPlmEventResponseResponseStatus>;
  in?: InputMaybe<Array<InputMaybe<EnumPlmEventResponseResponseStatus>>>;
  lt?: InputMaybe<EnumPlmEventResponseResponseStatus>;
  lte?: InputMaybe<EnumPlmEventResponseResponseStatus>;
  ne?: InputMaybe<EnumPlmEventResponseResponseStatus>;
  nin?: InputMaybe<Array<InputMaybe<EnumPlmEventResponseResponseStatus>>>;
};

export type FilterCountPlmEventResponseScheduledStartOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['Float']>;
  gte?: InputMaybe<Scalars['Float']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Float']>>>;
  lt?: InputMaybe<Scalars['Float']>;
  lte?: InputMaybe<Scalars['Float']>;
  ne?: InputMaybe<Scalars['Float']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Float']>>>;
};

export type FilterCountPlmEventResponse_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['String']>;
  gte?: InputMaybe<Scalars['String']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  lt?: InputMaybe<Scalars['String']>;
  lte?: InputMaybe<Scalars['String']>;
  ne?: InputMaybe<Scalars['String']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']>;
};

export type FilterCountPlmEventSourceVendorOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['String']>;
  gte?: InputMaybe<Scalars['String']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  lt?: InputMaybe<Scalars['String']>;
  lte?: InputMaybe<Scalars['String']>;
  ne?: InputMaybe<Scalars['String']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']>;
};

export type FilterCountPlmEventStartTimeOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['Float']>;
  gte?: InputMaybe<Scalars['Float']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Float']>>>;
  lt?: InputMaybe<Scalars['Float']>;
  lte?: InputMaybe<Scalars['Float']>;
  ne?: InputMaybe<Scalars['Float']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Float']>>>;
};

export type FilterCountPlmEventStatusOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<EnumPlmEventStatus>;
  gte?: InputMaybe<EnumPlmEventStatus>;
  in?: InputMaybe<Array<InputMaybe<EnumPlmEventStatus>>>;
  lt?: InputMaybe<EnumPlmEventStatus>;
  lte?: InputMaybe<EnumPlmEventStatus>;
  ne?: InputMaybe<EnumPlmEventStatus>;
  nin?: InputMaybe<Array<InputMaybe<EnumPlmEventStatus>>>;
};

export type FilterCountPlmEvent_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['String']>;
  gte?: InputMaybe<Scalars['String']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  lt?: InputMaybe<Scalars['String']>;
  lte?: InputMaybe<Scalars['String']>;
  ne?: InputMaybe<Scalars['String']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']>;
};

export type FilterCountPlmExternalMeterMappingInput = {
  AND?: InputMaybe<Array<FilterCountPlmExternalMeterMappingInput>>;
  OR?: InputMaybe<Array<FilterCountPlmExternalMeterMappingInput>>;
  _id?: InputMaybe<Scalars['String']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterCountPlmExternalMeterMappingOperatorsInput>;
  meterId?: InputMaybe<Scalars['String']>;
  partnerId?: InputMaybe<Scalars['String']>;
  propertyId?: InputMaybe<Scalars['String']>;
  providerAttributes?: InputMaybe<Scalars['JSON']>;
  vendor?: InputMaybe<Scalars['String']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterCountPlmExternalMeterMappingOperatorsInput = {
  _id?: InputMaybe<FilterCountPlmExternalMeterMapping_IdOperatorsInput>;
  propertyId?: InputMaybe<FilterCountPlmExternalMeterMappingPropertyIdOperatorsInput>;
  vendor?: InputMaybe<FilterCountPlmExternalMeterMappingVendorOperatorsInput>;
};

export type FilterCountPlmExternalMeterMappingPropertyIdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['String']>;
  gte?: InputMaybe<Scalars['String']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  lt?: InputMaybe<Scalars['String']>;
  lte?: InputMaybe<Scalars['String']>;
  ne?: InputMaybe<Scalars['String']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']>;
};

export type FilterCountPlmExternalMeterMappingVendorOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['String']>;
  gte?: InputMaybe<Scalars['String']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  lt?: InputMaybe<Scalars['String']>;
  lte?: InputMaybe<Scalars['String']>;
  ne?: InputMaybe<Scalars['String']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']>;
};

export type FilterCountPlmExternalMeterMapping_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['String']>;
  gte?: InputMaybe<Scalars['String']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  lt?: InputMaybe<Scalars['String']>;
  lte?: InputMaybe<Scalars['String']>;
  ne?: InputMaybe<Scalars['String']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']>;
};

export type FilterCountPlmIngressEventInput = {
  AND?: InputMaybe<Array<FilterCountPlmIngressEventInput>>;
  OR?: InputMaybe<Array<FilterCountPlmIngressEventInput>>;
  _id?: InputMaybe<Scalars['String']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterCountPlmIngressEventOperatorsInput>;
  headers?: InputMaybe<Scalars['JSON']>;
  lastError?: InputMaybe<Scalars['String']>;
  plmEventId?: InputMaybe<Scalars['String']>;
  processedAt?: InputMaybe<Scalars['Float']>;
  rawPayload?: InputMaybe<Scalars['String']>;
  receivedAt?: InputMaybe<Scalars['Float']>;
  source?: InputMaybe<EnumPlmIngressEventSource>;
  status?: InputMaybe<EnumPlmIngressEventStatus>;
  vendorKey?: InputMaybe<Scalars['String']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterCountPlmIngressEventOperatorsInput = {
  _id?: InputMaybe<FilterCountPlmIngressEvent_IdOperatorsInput>;
  status?: InputMaybe<FilterCountPlmIngressEventStatusOperatorsInput>;
  vendorKey?: InputMaybe<FilterCountPlmIngressEventVendorKeyOperatorsInput>;
};

export type FilterCountPlmIngressEventStatusOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<EnumPlmIngressEventStatus>;
  gte?: InputMaybe<EnumPlmIngressEventStatus>;
  in?: InputMaybe<Array<InputMaybe<EnumPlmIngressEventStatus>>>;
  lt?: InputMaybe<EnumPlmIngressEventStatus>;
  lte?: InputMaybe<EnumPlmIngressEventStatus>;
  ne?: InputMaybe<EnumPlmIngressEventStatus>;
  nin?: InputMaybe<Array<InputMaybe<EnumPlmIngressEventStatus>>>;
};

export type FilterCountPlmIngressEventVendorKeyOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['String']>;
  gte?: InputMaybe<Scalars['String']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  lt?: InputMaybe<Scalars['String']>;
  lte?: InputMaybe<Scalars['String']>;
  ne?: InputMaybe<Scalars['String']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']>;
};

export type FilterCountPlmIngressEvent_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['String']>;
  gte?: InputMaybe<Scalars['String']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  lt?: InputMaybe<Scalars['String']>;
  lte?: InputMaybe<Scalars['String']>;
  ne?: InputMaybe<Scalars['String']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']>;
};

export type FilterCountPlmNotificationActivationTimeOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['Date']>;
  gte?: InputMaybe<Scalars['Date']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Date']>>>;
  lt?: InputMaybe<Scalars['Date']>;
  lte?: InputMaybe<Scalars['Date']>;
  ne?: InputMaybe<Scalars['Date']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Date']>>>;
};

export type FilterCountPlmNotificationContractIdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['String']>;
  gte?: InputMaybe<Scalars['String']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  lt?: InputMaybe<Scalars['String']>;
  lte?: InputMaybe<Scalars['String']>;
  ne?: InputMaybe<Scalars['String']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']>;
};

export type FilterCountPlmNotificationInput = {
  AND?: InputMaybe<Array<FilterCountPlmNotificationInput>>;
  OR?: InputMaybe<Array<FilterCountPlmNotificationInput>>;
  _id?: InputMaybe<Scalars['String']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterCountPlmNotificationOperatorsInput>;
  activationTime?: InputMaybe<Scalars['Date']>;
  contractId?: InputMaybe<Scalars['String']>;
  deactivationTime?: InputMaybe<Scalars['Date']>;
  participationStatus?: InputMaybe<EnumPlmNotificationParticipationStatus>;
  partnerId?: InputMaybe<Scalars['String']>;
  payload?: InputMaybe<Scalars['String']>;
  programId?: InputMaybe<Scalars['String']>;
  receivedAt?: InputMaybe<Scalars['Date']>;
  responseSentAt?: InputMaybe<Scalars['Date']>;
  source?: InputMaybe<EnumPlmNotificationSource>;
  utilityId?: InputMaybe<Scalars['String']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterCountPlmNotificationOperatorsInput = {
  _id?: InputMaybe<FilterCountPlmNotification_IdOperatorsInput>;
  activationTime?: InputMaybe<FilterCountPlmNotificationActivationTimeOperatorsInput>;
  contractId?: InputMaybe<FilterCountPlmNotificationContractIdOperatorsInput>;
  partnerId?: InputMaybe<FilterCountPlmNotificationPartnerIdOperatorsInput>;
  programId?: InputMaybe<FilterCountPlmNotificationProgramIdOperatorsInput>;
};

export type FilterCountPlmNotificationPartnerIdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['String']>;
  gte?: InputMaybe<Scalars['String']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  lt?: InputMaybe<Scalars['String']>;
  lte?: InputMaybe<Scalars['String']>;
  ne?: InputMaybe<Scalars['String']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']>;
};

export type FilterCountPlmNotificationProgramIdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['String']>;
  gte?: InputMaybe<Scalars['String']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  lt?: InputMaybe<Scalars['String']>;
  lte?: InputMaybe<Scalars['String']>;
  ne?: InputMaybe<Scalars['String']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']>;
};

export type FilterCountPlmNotification_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['String']>;
  gte?: InputMaybe<Scalars['String']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  lt?: InputMaybe<Scalars['String']>;
  lte?: InputMaybe<Scalars['String']>;
  ne?: InputMaybe<Scalars['String']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']>;
};

export type FilterCountPlmPartnerContactInput = {
  email?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  phone?: InputMaybe<Scalars['String']>;
};

export type FilterCountPlmPartnerInput = {
  AND?: InputMaybe<Array<FilterCountPlmPartnerInput>>;
  OR?: InputMaybe<Array<FilterCountPlmPartnerInput>>;
  _id?: InputMaybe<Scalars['String']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterCountPlmPartnerOperatorsInput>;
  contact?: InputMaybe<FilterCountPlmPartnerContactInput>;
  description?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  partnerType?: InputMaybe<EnumPlmPartnerPartnerType>;
};

export type FilterCountPlmPartnerNameOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['String']>;
  gte?: InputMaybe<Scalars['String']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  lt?: InputMaybe<Scalars['String']>;
  lte?: InputMaybe<Scalars['String']>;
  ne?: InputMaybe<Scalars['String']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterCountPlmPartnerOperatorsInput = {
  _id?: InputMaybe<FilterCountPlmPartner_IdOperatorsInput>;
  name?: InputMaybe<FilterCountPlmPartnerNameOperatorsInput>;
};

export type FilterCountPlmPartner_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['String']>;
  gte?: InputMaybe<Scalars['String']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  lt?: InputMaybe<Scalars['String']>;
  lte?: InputMaybe<Scalars['String']>;
  ne?: InputMaybe<Scalars['String']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']>;
};

export type FilterCountPlmProgramHostPartnerIdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['String']>;
  gte?: InputMaybe<Scalars['String']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  lt?: InputMaybe<Scalars['String']>;
  lte?: InputMaybe<Scalars['String']>;
  ne?: InputMaybe<Scalars['String']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']>;
};

export type FilterCountPlmProgramInput = {
  AND?: InputMaybe<Array<FilterCountPlmProgramInput>>;
  OR?: InputMaybe<Array<FilterCountPlmProgramInput>>;
  _id?: InputMaybe<Scalars['String']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterCountPlmProgramOperatorsInput>;
  endDate?: InputMaybe<Scalars['Float']>;
  hostPartnerId?: InputMaybe<Scalars['String']>;
  hostUtilityId?: InputMaybe<Scalars['String']>;
  incentiveDescription?: InputMaybe<Scalars['String']>;
  maximumEventDurationMinutes?: InputMaybe<Scalars['Float']>;
  maximumEventsPerSeason?: InputMaybe<Scalars['Float']>;
  maximumNotificationLeadTimeMinutes?: InputMaybe<Scalars['Float']>;
  measurementIntervalMinutes?: InputMaybe<Scalars['Float']>;
  minimumEventDurationMinutes?: InputMaybe<Scalars['Float']>;
  minimumEventsPerSeason?: InputMaybe<Scalars['Float']>;
  name?: InputMaybe<Scalars['String']>;
  notificationLeadTimeMinutes?: InputMaybe<Scalars['Float']>;
  participationType?: InputMaybe<EnumPlmProgramParticipationType>;
  partnerId?: InputMaybe<Scalars['String']>;
  programId?: InputMaybe<Scalars['String']>;
  season?: InputMaybe<EnumPlmProgramSeason>;
  startDate?: InputMaybe<Scalars['Float']>;
  utilityId?: InputMaybe<Scalars['String']>;
};

export type FilterCountPlmProgramNameOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['String']>;
  gte?: InputMaybe<Scalars['String']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  lt?: InputMaybe<Scalars['String']>;
  lte?: InputMaybe<Scalars['String']>;
  ne?: InputMaybe<Scalars['String']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterCountPlmProgramOperatorsInput = {
  _id?: InputMaybe<FilterCountPlmProgram_IdOperatorsInput>;
  hostPartnerId?: InputMaybe<FilterCountPlmProgramHostPartnerIdOperatorsInput>;
  name?: InputMaybe<FilterCountPlmProgramNameOperatorsInput>;
  partnerId?: InputMaybe<FilterCountPlmProgramPartnerIdOperatorsInput>;
  programId?: InputMaybe<FilterCountPlmProgramProgramIdOperatorsInput>;
};

export type FilterCountPlmProgramPartnerIdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['String']>;
  gte?: InputMaybe<Scalars['String']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  lt?: InputMaybe<Scalars['String']>;
  lte?: InputMaybe<Scalars['String']>;
  ne?: InputMaybe<Scalars['String']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']>;
};

export type FilterCountPlmProgramProgramIdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['String']>;
  gte?: InputMaybe<Scalars['String']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  lt?: InputMaybe<Scalars['String']>;
  lte?: InputMaybe<Scalars['String']>;
  ne?: InputMaybe<Scalars['String']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']>;
};

export type FilterCountPlmProgram_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['String']>;
  gte?: InputMaybe<Scalars['String']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  lt?: InputMaybe<Scalars['String']>;
  lte?: InputMaybe<Scalars['String']>;
  ne?: InputMaybe<Scalars['String']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']>;
};

export type FilterCountPlmUtilityContactInput = {
  email?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  phone?: InputMaybe<Scalars['String']>;
};

export type FilterCountPlmUtilityInput = {
  AND?: InputMaybe<Array<FilterCountPlmUtilityInput>>;
  OR?: InputMaybe<Array<FilterCountPlmUtilityInput>>;
  _id?: InputMaybe<Scalars['String']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterCountPlmUtilityOperatorsInput>;
  contact?: InputMaybe<FilterCountPlmUtilityContactInput>;
  description?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
};

export type FilterCountPlmUtilityNameOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['String']>;
  gte?: InputMaybe<Scalars['String']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  lt?: InputMaybe<Scalars['String']>;
  lte?: InputMaybe<Scalars['String']>;
  ne?: InputMaybe<Scalars['String']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterCountPlmUtilityOperatorsInput = {
  _id?: InputMaybe<FilterCountPlmUtility_IdOperatorsInput>;
  name?: InputMaybe<FilterCountPlmUtilityNameOperatorsInput>;
};

export type FilterCountPlmUtility_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['String']>;
  gte?: InputMaybe<Scalars['String']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  lt?: InputMaybe<Scalars['String']>;
  lte?: InputMaybe<Scalars['String']>;
  ne?: InputMaybe<Scalars['String']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']>;
};

export type FilterCountPowerMonitorFrequencyInput = {
  id?: InputMaybe<Scalars['String']>;
  observedAt?: InputMaybe<Scalars['Float']>;
  previousId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  units?: InputMaybe<Scalars['String']>;
  updatePending?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<Scalars['Float']>;
};

export type FilterCountPowerMonitorInput = {
  AND?: InputMaybe<Array<FilterCountDeviceInput>>;
  OR?: InputMaybe<Array<FilterCountDeviceInput>>;
  _id?: InputMaybe<Scalars['String']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterCountDeviceOperatorsInput>;
  alertTypes?: InputMaybe<FilterCountDeviceAlertTypesInput>;
  controlled?: InputMaybe<FilterCountDeviceControlledInput>;
  deviceId?: InputMaybe<Scalars['String']>;
  frequency?: InputMaybe<FilterCountPowerMonitorFrequencyInput>;
  installation?: InputMaybe<FilterCountDeviceInstallationInput>;
  location?: InputMaybe<Scalars['String']>;
  meta?: InputMaybe<FilterCountDeviceMetaInput>;
  /** The name of the device */
  name?: InputMaybe<Scalars['String']>;
  panelId?: InputMaybe<Scalars['String']>;
  phaseAActiveEnergyFwd?: InputMaybe<FilterCountPowerMonitorPhaseAActiveEnergyFwdInput>;
  phaseAActiveEnergyRev?: InputMaybe<FilterCountPowerMonitorPhaseAActiveEnergyRevInput>;
  phaseAActivePower?: InputMaybe<FilterCountPowerMonitorPhaseAActivePowerInput>;
  phaseACurrent?: InputMaybe<FilterCountPowerMonitorPhaseACurrentInput>;
  phaseAFrequency?: InputMaybe<FilterCountPowerMonitorPhaseAFrequencyInput>;
  phaseAPowerFactor?: InputMaybe<FilterCountPowerMonitorPhaseAPowerFactorInput>;
  phaseAVoltage?: InputMaybe<FilterCountPowerMonitorPhaseAVoltageInput>;
  phaseBActiveEnergyFwd?: InputMaybe<FilterCountPowerMonitorPhaseBActiveEnergyFwdInput>;
  phaseBActiveEnergyRev?: InputMaybe<FilterCountPowerMonitorPhaseBActiveEnergyRevInput>;
  phaseBActivePower?: InputMaybe<FilterCountPowerMonitorPhaseBActivePowerInput>;
  phaseBCurrent?: InputMaybe<FilterCountPowerMonitorPhaseBCurrentInput>;
  phaseBFrequency?: InputMaybe<FilterCountPowerMonitorPhaseBFrequencyInput>;
  phaseBPowerFactor?: InputMaybe<FilterCountPowerMonitorPhaseBPowerFactorInput>;
  phaseBVoltage?: InputMaybe<FilterCountPowerMonitorPhaseBVoltageInput>;
  phaseCActiveEnergyFwd?: InputMaybe<FilterCountPowerMonitorPhaseCActiveEnergyFwdInput>;
  phaseCActiveEnergyRev?: InputMaybe<FilterCountPowerMonitorPhaseCActiveEnergyRevInput>;
  phaseCActivePower?: InputMaybe<FilterCountPowerMonitorPhaseCActivePowerInput>;
  phaseCCurrent?: InputMaybe<FilterCountPowerMonitorPhaseCCurrentInput>;
  phaseCFrequency?: InputMaybe<FilterCountPowerMonitorPhaseCFrequencyInput>;
  phaseCPowerFactor?: InputMaybe<FilterCountPowerMonitorPhaseCPowerFactorInput>;
  phaseCVoltage?: InputMaybe<FilterCountPowerMonitorPhaseCVoltageInput>;
  powerState?: InputMaybe<FilterCountDevicePowerStateInput>;
  propertyId?: InputMaybe<Scalars['String']>;
  sourceId?: InputMaybe<Scalars['String']>;
  threePhaseTotalActiveEnergyFwd?: InputMaybe<FilterCountPowerMonitorThreePhaseTotalActiveEnergyFwdInput>;
  threePhaseTotalActiveEnergyRev?: InputMaybe<FilterCountPowerMonitorThreePhaseTotalActiveEnergyRevInput>;
  timestamp?: InputMaybe<Scalars['Float']>;
  totalActivePower?: InputMaybe<FilterCountPowerMonitorTotalActivePowerInput>;
  totalPowerFactor?: InputMaybe<FilterCountPowerMonitorTotalPowerFactorInput>;
  unitId?: InputMaybe<Scalars['String']>;
  updateStatus?: InputMaybe<Scalars['Boolean']>;
  vppId?: InputMaybe<Scalars['String']>;
  zoneId?: InputMaybe<Scalars['String']>;
};

export type FilterCountPowerMonitorPhaseAActiveEnergyFwdInput = {
  id?: InputMaybe<Scalars['String']>;
  observedAt?: InputMaybe<Scalars['Float']>;
  previousId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  units?: InputMaybe<Scalars['String']>;
  updatePending?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<Scalars['Float']>;
};

export type FilterCountPowerMonitorPhaseAActiveEnergyRevInput = {
  id?: InputMaybe<Scalars['String']>;
  observedAt?: InputMaybe<Scalars['Float']>;
  previousId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  units?: InputMaybe<Scalars['String']>;
  updatePending?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<Scalars['Float']>;
};

export type FilterCountPowerMonitorPhaseAActivePowerInput = {
  id?: InputMaybe<Scalars['String']>;
  observedAt?: InputMaybe<Scalars['Float']>;
  previousId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  units?: InputMaybe<Scalars['String']>;
  updatePending?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<Scalars['Float']>;
};

export type FilterCountPowerMonitorPhaseACurrentInput = {
  id?: InputMaybe<Scalars['String']>;
  observedAt?: InputMaybe<Scalars['Float']>;
  previousId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  units?: InputMaybe<Scalars['String']>;
  updatePending?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<Scalars['Float']>;
};

export type FilterCountPowerMonitorPhaseAFrequencyInput = {
  id?: InputMaybe<Scalars['String']>;
  observedAt?: InputMaybe<Scalars['Float']>;
  previousId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  units?: InputMaybe<Scalars['String']>;
  updatePending?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<Scalars['Float']>;
};

export type FilterCountPowerMonitorPhaseAPowerFactorInput = {
  id?: InputMaybe<Scalars['String']>;
  observedAt?: InputMaybe<Scalars['Float']>;
  previousId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  units?: InputMaybe<Scalars['String']>;
  updatePending?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<Scalars['Float']>;
};

export type FilterCountPowerMonitorPhaseAVoltageInput = {
  id?: InputMaybe<Scalars['String']>;
  observedAt?: InputMaybe<Scalars['Float']>;
  previousId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  units?: InputMaybe<Scalars['String']>;
  updatePending?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<Scalars['Float']>;
};

export type FilterCountPowerMonitorPhaseBActiveEnergyFwdInput = {
  id?: InputMaybe<Scalars['String']>;
  observedAt?: InputMaybe<Scalars['Float']>;
  previousId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  units?: InputMaybe<Scalars['String']>;
  updatePending?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<Scalars['Float']>;
};

export type FilterCountPowerMonitorPhaseBActiveEnergyRevInput = {
  id?: InputMaybe<Scalars['String']>;
  observedAt?: InputMaybe<Scalars['Float']>;
  previousId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  units?: InputMaybe<Scalars['String']>;
  updatePending?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<Scalars['Float']>;
};

export type FilterCountPowerMonitorPhaseBActivePowerInput = {
  id?: InputMaybe<Scalars['String']>;
  observedAt?: InputMaybe<Scalars['Float']>;
  previousId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  units?: InputMaybe<Scalars['String']>;
  updatePending?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<Scalars['Float']>;
};

export type FilterCountPowerMonitorPhaseBCurrentInput = {
  id?: InputMaybe<Scalars['String']>;
  observedAt?: InputMaybe<Scalars['Float']>;
  previousId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  units?: InputMaybe<Scalars['String']>;
  updatePending?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<Scalars['Float']>;
};

export type FilterCountPowerMonitorPhaseBFrequencyInput = {
  id?: InputMaybe<Scalars['String']>;
  observedAt?: InputMaybe<Scalars['Float']>;
  previousId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  units?: InputMaybe<Scalars['String']>;
  updatePending?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<Scalars['Float']>;
};

export type FilterCountPowerMonitorPhaseBPowerFactorInput = {
  id?: InputMaybe<Scalars['String']>;
  observedAt?: InputMaybe<Scalars['Float']>;
  previousId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  units?: InputMaybe<Scalars['String']>;
  updatePending?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<Scalars['Float']>;
};

export type FilterCountPowerMonitorPhaseBVoltageInput = {
  id?: InputMaybe<Scalars['String']>;
  observedAt?: InputMaybe<Scalars['Float']>;
  previousId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  units?: InputMaybe<Scalars['String']>;
  updatePending?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<Scalars['Float']>;
};

export type FilterCountPowerMonitorPhaseCActiveEnergyFwdInput = {
  id?: InputMaybe<Scalars['String']>;
  observedAt?: InputMaybe<Scalars['Float']>;
  previousId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  units?: InputMaybe<Scalars['String']>;
  updatePending?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<Scalars['Float']>;
};

export type FilterCountPowerMonitorPhaseCActiveEnergyRevInput = {
  id?: InputMaybe<Scalars['String']>;
  observedAt?: InputMaybe<Scalars['Float']>;
  previousId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  units?: InputMaybe<Scalars['String']>;
  updatePending?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<Scalars['Float']>;
};

export type FilterCountPowerMonitorPhaseCActivePowerInput = {
  id?: InputMaybe<Scalars['String']>;
  observedAt?: InputMaybe<Scalars['Float']>;
  previousId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  units?: InputMaybe<Scalars['String']>;
  updatePending?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<Scalars['Float']>;
};

export type FilterCountPowerMonitorPhaseCCurrentInput = {
  id?: InputMaybe<Scalars['String']>;
  observedAt?: InputMaybe<Scalars['Float']>;
  previousId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  units?: InputMaybe<Scalars['String']>;
  updatePending?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<Scalars['Float']>;
};

export type FilterCountPowerMonitorPhaseCFrequencyInput = {
  id?: InputMaybe<Scalars['String']>;
  observedAt?: InputMaybe<Scalars['Float']>;
  previousId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  units?: InputMaybe<Scalars['String']>;
  updatePending?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<Scalars['Float']>;
};

export type FilterCountPowerMonitorPhaseCPowerFactorInput = {
  id?: InputMaybe<Scalars['String']>;
  observedAt?: InputMaybe<Scalars['Float']>;
  previousId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  units?: InputMaybe<Scalars['String']>;
  updatePending?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<Scalars['Float']>;
};

export type FilterCountPowerMonitorPhaseCVoltageInput = {
  id?: InputMaybe<Scalars['String']>;
  observedAt?: InputMaybe<Scalars['Float']>;
  previousId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  units?: InputMaybe<Scalars['String']>;
  updatePending?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<Scalars['Float']>;
};

export type FilterCountPowerMonitorThreePhaseTotalActiveEnergyFwdInput = {
  id?: InputMaybe<Scalars['String']>;
  observedAt?: InputMaybe<Scalars['Float']>;
  previousId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  units?: InputMaybe<Scalars['String']>;
  updatePending?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<Scalars['Float']>;
};

export type FilterCountPowerMonitorThreePhaseTotalActiveEnergyRevInput = {
  id?: InputMaybe<Scalars['String']>;
  observedAt?: InputMaybe<Scalars['Float']>;
  previousId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  units?: InputMaybe<Scalars['String']>;
  updatePending?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<Scalars['Float']>;
};

export type FilterCountPowerMonitorTotalActivePowerInput = {
  id?: InputMaybe<Scalars['String']>;
  observedAt?: InputMaybe<Scalars['Float']>;
  previousId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  units?: InputMaybe<Scalars['String']>;
  updatePending?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<Scalars['Float']>;
};

export type FilterCountPowerMonitorTotalPowerFactorInput = {
  id?: InputMaybe<Scalars['String']>;
  observedAt?: InputMaybe<Scalars['Float']>;
  previousId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  units?: InputMaybe<Scalars['String']>;
  updatePending?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<Scalars['Float']>;
};

export type FilterCountPressureSensorInput = {
  AND?: InputMaybe<Array<FilterCountDeviceInput>>;
  OR?: InputMaybe<Array<FilterCountDeviceInput>>;
  _id?: InputMaybe<Scalars['String']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterCountDeviceOperatorsInput>;
  alertTypes?: InputMaybe<FilterCountDeviceAlertTypesInput>;
  controlled?: InputMaybe<FilterCountDeviceControlledInput>;
  deviceId?: InputMaybe<Scalars['String']>;
  installation?: InputMaybe<FilterCountDeviceInstallationInput>;
  location?: InputMaybe<Scalars['String']>;
  meta?: InputMaybe<FilterCountDeviceMetaInput>;
  /** The name of the device */
  name?: InputMaybe<Scalars['String']>;
  panelId?: InputMaybe<Scalars['String']>;
  powerState?: InputMaybe<FilterCountDevicePowerStateInput>;
  pressure?: InputMaybe<FilterCountPressureSensorPressureInput>;
  propertyId?: InputMaybe<Scalars['String']>;
  role?: InputMaybe<Scalars['String']>;
  sourceId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  unitId?: InputMaybe<Scalars['String']>;
  updateStatus?: InputMaybe<Scalars['Boolean']>;
  vppId?: InputMaybe<Scalars['String']>;
  zoneId?: InputMaybe<Scalars['String']>;
};

export type FilterCountPressureSensorPressureInput = {
  id?: InputMaybe<Scalars['String']>;
  observedAt?: InputMaybe<Scalars['Float']>;
  previousId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  units?: InputMaybe<Scalars['String']>;
  updatePending?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<Scalars['Float']>;
};

export type FilterCountPropertyAddressInput = {
  city?: InputMaybe<Scalars['String']>;
  line1?: InputMaybe<Scalars['String']>;
  line2?: InputMaybe<Scalars['String']>;
  postalCode?: InputMaybe<Scalars['String']>;
  state?: InputMaybe<Scalars['String']>;
};

export type FilterCountPropertyAlertLimitsInput = {
  plant?: InputMaybe<FilterCountPropertyAlertLimitsPlantInput>;
  units?: InputMaybe<FilterCountPropertyAlertLimitsUnitsInput>;
};

export type FilterCountPropertyAlertLimitsPlantDhwInput = {
  temperature?: InputMaybe<FilterCountPropertyAlertLimitsPlantDhwTemperatureInput>;
};

export type FilterCountPropertyAlertLimitsPlantDhwTemperatureInput = {
  max?: InputMaybe<Scalars['Float']>;
  min?: InputMaybe<Scalars['Float']>;
};

export type FilterCountPropertyAlertLimitsPlantInput = {
  dhw?: InputMaybe<FilterCountPropertyAlertLimitsPlantDhwInput>;
  loops?: InputMaybe<FilterCountPropertyAlertLimitsPlantLoopsInput>;
};

export type FilterCountPropertyAlertLimitsPlantLoopsInput = {
  pressure?: InputMaybe<FilterCountPropertyAlertLimitsPlantLoopsPressureInput>;
  temperature?: InputMaybe<FilterCountPropertyAlertLimitsPlantLoopsTemperatureInput>;
};

export type FilterCountPropertyAlertLimitsPlantLoopsPressureInput = {
  max?: InputMaybe<Scalars['Float']>;
  min?: InputMaybe<Scalars['Float']>;
};

export type FilterCountPropertyAlertLimitsPlantLoopsTemperatureInput = {
  max?: InputMaybe<Scalars['Float']>;
  min?: InputMaybe<Scalars['Float']>;
};

export type FilterCountPropertyAlertLimitsUnitsHumidityInput = {
  max?: InputMaybe<Scalars['Float']>;
  min?: InputMaybe<Scalars['Float']>;
};

export type FilterCountPropertyAlertLimitsUnitsInput = {
  humidity?: InputMaybe<FilterCountPropertyAlertLimitsUnitsHumidityInput>;
  temperature?: InputMaybe<FilterCountPropertyAlertLimitsUnitsTemperatureInput>;
};

export type FilterCountPropertyAlertLimitsUnitsTemperatureInput = {
  max?: InputMaybe<Scalars['Float']>;
  min?: InputMaybe<Scalars['Float']>;
};

export type FilterCountPropertyAlertTypesInput = {
  deviceAlert?: InputMaybe<Scalars['Boolean']>;
  deviceMetric?: InputMaybe<Scalars['Boolean']>;
  deviceOffline?: InputMaybe<Scalars['Boolean']>;
  equipmentAlarm?: InputMaybe<Scalars['Boolean']>;
  sourceOffline?: InputMaybe<Scalars['Boolean']>;
};

export type FilterCountPropertyContactInput = {
  email?: InputMaybe<Scalars['String']>;
  email2?: InputMaybe<Scalars['String']>;
  email3?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  smsNumber?: InputMaybe<Scalars['String']>;
  smsNumber2?: InputMaybe<Scalars['String']>;
  smsNumber3?: InputMaybe<Scalars['String']>;
  smsOptInStatus1?: InputMaybe<EnumPropertyContactSmsOptInStatus1>;
  smsOptInStatus2?: InputMaybe<EnumPropertyContactSmsOptInStatus2>;
  smsOptInStatus3?: InputMaybe<EnumPropertyContactSmsOptInStatus3>;
  smsOptInTimestamp1?: InputMaybe<Scalars['Float']>;
  smsOptInTimestamp2?: InputMaybe<Scalars['Float']>;
  smsOptInTimestamp3?: InputMaybe<Scalars['Float']>;
};

export type FilterCountPropertyInput = {
  AND?: InputMaybe<Array<FilterCountPropertyInput>>;
  OR?: InputMaybe<Array<FilterCountPropertyInput>>;
  _id?: InputMaybe<Scalars['String']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterCountPropertyOperatorsInput>;
  address?: InputMaybe<FilterCountPropertyAddressInput>;
  alertLimits?: InputMaybe<FilterCountPropertyAlertLimitsInput>;
  alertTypes?: InputMaybe<FilterCountPropertyAlertTypesInput>;
  contact?: InputMaybe<FilterCountPropertyContactInput>;
  floorLabel?: InputMaybe<Scalars['String']>;
  hasSecondaryHeatSource?: InputMaybe<Scalars['Boolean']>;
  imageUrl?: InputMaybe<Scalars['String']>;
  maintMgr?: InputMaybe<FilterCountPropertyMaintMgrInput>;
  organizationId?: InputMaybe<Scalars['String']>;
  owner?: InputMaybe<FilterCountPropertyOwnerInput>;
  propMgr?: InputMaybe<FilterCountPropertyPropMgrInput>;
  setpointProfileId?: InputMaybe<Scalars['String']>;
  tempDisplayUnits?: InputMaybe<Scalars['String']>;
  thermostatScheduleTemplateId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['String']>;
  title?: InputMaybe<Scalars['String']>;
  unitsSummary?: InputMaybe<FilterCountPropertyUnitsSummaryInput>;
  zonePolicyId?: InputMaybe<Scalars['String']>;
};

export type FilterCountPropertyMaintMgrInput = {
  email?: InputMaybe<Scalars['String']>;
  mobile?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterCountPropertyOperatorsInput = {
  _id?: InputMaybe<FilterCountProperty_IdOperatorsInput>;
  title?: InputMaybe<FilterCountPropertyTitleOperatorsInput>;
  unitsSummary?: InputMaybe<FilterCountPropertyUnitsSummaryOperatorsInput>;
};

export type FilterCountPropertyOwnerInput = {
  email?: InputMaybe<Scalars['String']>;
  mobile?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  phone?: InputMaybe<Scalars['String']>;
};

export type FilterCountPropertyPropMgrInput = {
  email?: InputMaybe<Scalars['String']>;
  mobile?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  phone?: InputMaybe<Scalars['String']>;
};

export type FilterCountPropertyTitleOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['String']>;
  gte?: InputMaybe<Scalars['String']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  lt?: InputMaybe<Scalars['String']>;
  lte?: InputMaybe<Scalars['String']>;
  ne?: InputMaybe<Scalars['String']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']>;
};

export type FilterCountPropertyUnitsSummaryCountOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['Float']>;
  gte?: InputMaybe<Scalars['Float']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Float']>>>;
  lt?: InputMaybe<Scalars['Float']>;
  lte?: InputMaybe<Scalars['Float']>;
  ne?: InputMaybe<Scalars['Float']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Float']>>>;
};

export type FilterCountPropertyUnitsSummaryInput = {
  count?: InputMaybe<Scalars['Float']>;
  majorAlerts?: InputMaybe<Scalars['Float']>;
  minorAlerts?: InputMaybe<Scalars['Float']>;
};

export type FilterCountPropertyUnitsSummaryMajorAlertsOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['Float']>;
  gte?: InputMaybe<Scalars['Float']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Float']>>>;
  lt?: InputMaybe<Scalars['Float']>;
  lte?: InputMaybe<Scalars['Float']>;
  ne?: InputMaybe<Scalars['Float']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Float']>>>;
};

export type FilterCountPropertyUnitsSummaryOperatorsInput = {
  count?: InputMaybe<FilterCountPropertyUnitsSummaryCountOperatorsInput>;
  majorAlerts?: InputMaybe<FilterCountPropertyUnitsSummaryMajorAlertsOperatorsInput>;
};

export type FilterCountProperty_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['String']>;
  gte?: InputMaybe<Scalars['String']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  lt?: InputMaybe<Scalars['String']>;
  lte?: InputMaybe<Scalars['String']>;
  ne?: InputMaybe<Scalars['String']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']>;
};

export type FilterCountRelayDeviceInput = {
  AND?: InputMaybe<Array<FilterCountDeviceInput>>;
  OR?: InputMaybe<Array<FilterCountDeviceInput>>;
  _id?: InputMaybe<Scalars['String']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterCountDeviceOperatorsInput>;
  alertTypes?: InputMaybe<FilterCountDeviceAlertTypesInput>;
  controlled?: InputMaybe<FilterCountDeviceControlledInput>;
  deviceId?: InputMaybe<Scalars['String']>;
  installation?: InputMaybe<FilterCountDeviceInstallationInput>;
  isOn?: InputMaybe<FilterCountRelayDeviceIsOnInput>;
  location?: InputMaybe<Scalars['String']>;
  meta?: InputMaybe<FilterCountDeviceMetaInput>;
  /** The name of the device */
  name?: InputMaybe<Scalars['String']>;
  panelId?: InputMaybe<Scalars['String']>;
  powerState?: InputMaybe<FilterCountDevicePowerStateInput>;
  propertyId?: InputMaybe<Scalars['String']>;
  sourceId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  unitId?: InputMaybe<Scalars['String']>;
  updateStatus?: InputMaybe<Scalars['Boolean']>;
  vppId?: InputMaybe<Scalars['String']>;
  zoneId?: InputMaybe<Scalars['String']>;
};

export type FilterCountRelayDeviceIsOnInput = {
  id?: InputMaybe<Scalars['String']>;
  observedAt?: InputMaybe<Scalars['Float']>;
  previousId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  units?: InputMaybe<Scalars['String']>;
  updatePending?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<Scalars['Boolean']>;
};

export type FilterCountScheduledTaskInput = {
  AND?: InputMaybe<Array<FilterCountScheduledTaskInput>>;
  OR?: InputMaybe<Array<FilterCountScheduledTaskInput>>;
  _id?: InputMaybe<Scalars['String']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterCountScheduledTaskOperatorsInput>;
  completedAt?: InputMaybe<Scalars['Float']>;
  createdAt?: InputMaybe<Scalars['Float']>;
  errorMessage?: InputMaybe<Scalars['String']>;
  executionTimeMs?: InputMaybe<Scalars['Float']>;
  instanceId?: InputMaybe<Scalars['String']>;
  maxRetries?: InputMaybe<Scalars['Float']>;
  methodName?: InputMaybe<Scalars['String']>;
  modelName?: InputMaybe<Scalars['String']>;
  priority?: InputMaybe<Scalars['Float']>;
  retryCount?: InputMaybe<Scalars['Float']>;
  scheduledAt?: InputMaybe<Scalars['Float']>;
  startedAt?: InputMaybe<Scalars['Float']>;
  status?: InputMaybe<EnumScheduledTaskStatus>;
  updatedAt?: InputMaybe<Scalars['Float']>;
};

export type FilterCountScheduledTaskModelNameOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['String']>;
  gte?: InputMaybe<Scalars['String']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  lt?: InputMaybe<Scalars['String']>;
  lte?: InputMaybe<Scalars['String']>;
  ne?: InputMaybe<Scalars['String']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterCountScheduledTaskOperatorsInput = {
  _id?: InputMaybe<FilterCountScheduledTask_IdOperatorsInput>;
  modelName?: InputMaybe<FilterCountScheduledTaskModelNameOperatorsInput>;
  priority?: InputMaybe<FilterCountScheduledTaskPriorityOperatorsInput>;
  scheduledAt?: InputMaybe<FilterCountScheduledTaskScheduledAtOperatorsInput>;
  status?: InputMaybe<FilterCountScheduledTaskStatusOperatorsInput>;
};

export type FilterCountScheduledTaskPriorityOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['Float']>;
  gte?: InputMaybe<Scalars['Float']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Float']>>>;
  lt?: InputMaybe<Scalars['Float']>;
  lte?: InputMaybe<Scalars['Float']>;
  ne?: InputMaybe<Scalars['Float']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Float']>>>;
};

export type FilterCountScheduledTaskScheduledAtOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['Float']>;
  gte?: InputMaybe<Scalars['Float']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Float']>>>;
  lt?: InputMaybe<Scalars['Float']>;
  lte?: InputMaybe<Scalars['Float']>;
  ne?: InputMaybe<Scalars['Float']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Float']>>>;
};

export type FilterCountScheduledTaskStatusOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<EnumScheduledTaskStatus>;
  gte?: InputMaybe<EnumScheduledTaskStatus>;
  in?: InputMaybe<Array<InputMaybe<EnumScheduledTaskStatus>>>;
  lt?: InputMaybe<EnumScheduledTaskStatus>;
  lte?: InputMaybe<EnumScheduledTaskStatus>;
  ne?: InputMaybe<EnumScheduledTaskStatus>;
  nin?: InputMaybe<Array<InputMaybe<EnumScheduledTaskStatus>>>;
};

export type FilterCountScheduledTask_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['String']>;
  gte?: InputMaybe<Scalars['String']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  lt?: InputMaybe<Scalars['String']>;
  lte?: InputMaybe<Scalars['String']>;
  ne?: InputMaybe<Scalars['String']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']>;
};

export type FilterCountSetpointProfileCoolInput = {
  max?: InputMaybe<Scalars['Float']>;
  min?: InputMaybe<Scalars['Float']>;
};

export type FilterCountSetpointProfileHeatInput = {
  max?: InputMaybe<Scalars['Float']>;
  min?: InputMaybe<Scalars['Float']>;
};

export type FilterCountSetpointProfileInput = {
  AND?: InputMaybe<Array<FilterCountSetpointProfileInput>>;
  OR?: InputMaybe<Array<FilterCountSetpointProfileInput>>;
  _id?: InputMaybe<Scalars['String']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterCountSetpointProfileOperatorsInput>;
  cool?: InputMaybe<FilterCountSetpointProfileCoolInput>;
  createdAt?: InputMaybe<Scalars['Float']>;
  createdBy?: InputMaybe<Scalars['String']>;
  heat?: InputMaybe<FilterCountSetpointProfileHeatInput>;
  name?: InputMaybe<Scalars['String']>;
  propagated?: InputMaybe<Scalars['Boolean']>;
  properties?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  type?: InputMaybe<EnumSetpointProfileType>;
  units?: InputMaybe<EnumSetpointProfileUnits>;
  updatedAt?: InputMaybe<Scalars['Float']>;
  updatedBy?: InputMaybe<Scalars['String']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterCountSetpointProfileOperatorsInput = {
  _id?: InputMaybe<FilterCountSetpointProfile_IdOperatorsInput>;
  properties?: InputMaybe<FilterCountSetpointProfilePropertiesOperatorsInput>;
};

export type FilterCountSetpointProfilePropertiesOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['String']>;
  gte?: InputMaybe<Scalars['String']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  lt?: InputMaybe<Scalars['String']>;
  lte?: InputMaybe<Scalars['String']>;
  ne?: InputMaybe<Scalars['String']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']>;
};

export type FilterCountSetpointProfile_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['String']>;
  gte?: InputMaybe<Scalars['String']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  lt?: InputMaybe<Scalars['String']>;
  lte?: InputMaybe<Scalars['String']>;
  ne?: InputMaybe<Scalars['String']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']>;
};

export type FilterCountSmartPowerOutletActivePowerInput = {
  id?: InputMaybe<Scalars['String']>;
  observedAt?: InputMaybe<Scalars['Float']>;
  previousId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  units?: InputMaybe<Scalars['String']>;
  updatePending?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<Scalars['Float']>;
};

export type FilterCountSmartPowerOutletApparentPowerInput = {
  id?: InputMaybe<Scalars['String']>;
  observedAt?: InputMaybe<Scalars['Float']>;
  previousId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  units?: InputMaybe<Scalars['String']>;
  updatePending?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<Scalars['Float']>;
};

export type FilterCountSmartPowerOutletCumulativePowerInput = {
  id?: InputMaybe<Scalars['String']>;
  observedAt?: InputMaybe<Scalars['Float']>;
  previousId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  units?: InputMaybe<Scalars['String']>;
  updatePending?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<Scalars['Float']>;
};

export type FilterCountSmartPowerOutletInput = {
  AND?: InputMaybe<Array<FilterCountDeviceInput>>;
  OR?: InputMaybe<Array<FilterCountDeviceInput>>;
  _id?: InputMaybe<Scalars['String']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterCountDeviceOperatorsInput>;
  activePower?: InputMaybe<FilterCountSmartPowerOutletActivePowerInput>;
  alertTypes?: InputMaybe<FilterCountDeviceAlertTypesInput>;
  apparentPower?: InputMaybe<FilterCountSmartPowerOutletApparentPowerInput>;
  controlled?: InputMaybe<FilterCountDeviceControlledInput>;
  cumulativePower?: InputMaybe<FilterCountSmartPowerOutletCumulativePowerInput>;
  cumulativePowerOffset?: InputMaybe<Scalars['Float']>;
  cumulativePowerResetTime?: InputMaybe<Scalars['Float']>;
  deviceId?: InputMaybe<Scalars['String']>;
  installation?: InputMaybe<FilterCountDeviceInstallationInput>;
  isOn?: InputMaybe<FilterCountSmartPowerOutletIsOnInput>;
  location?: InputMaybe<Scalars['String']>;
  meta?: InputMaybe<FilterCountDeviceMetaInput>;
  /** The name of the device */
  name?: InputMaybe<Scalars['String']>;
  panelId?: InputMaybe<Scalars['String']>;
  powerFactor?: InputMaybe<FilterCountSmartPowerOutletPowerFactorInput>;
  powerState?: InputMaybe<FilterCountDevicePowerStateInput>;
  propertyId?: InputMaybe<Scalars['String']>;
  rmsCurrent?: InputMaybe<FilterCountSmartPowerOutletRmsCurrentInput>;
  rmsVoltage?: InputMaybe<FilterCountSmartPowerOutletRmsVoltageInput>;
  sourceId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  unitId?: InputMaybe<Scalars['String']>;
  updateStatus?: InputMaybe<Scalars['Boolean']>;
  vppId?: InputMaybe<Scalars['String']>;
  zoneId?: InputMaybe<Scalars['String']>;
};

export type FilterCountSmartPowerOutletIsOnInput = {
  id?: InputMaybe<Scalars['String']>;
  observedAt?: InputMaybe<Scalars['Float']>;
  previousId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  units?: InputMaybe<Scalars['String']>;
  updatePending?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<Scalars['Boolean']>;
};

export type FilterCountSmartPowerOutletPowerFactorInput = {
  id?: InputMaybe<Scalars['String']>;
  observedAt?: InputMaybe<Scalars['Float']>;
  previousId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  units?: InputMaybe<Scalars['String']>;
  updatePending?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<Scalars['Float']>;
};

export type FilterCountSmartPowerOutletRmsCurrentInput = {
  id?: InputMaybe<Scalars['String']>;
  observedAt?: InputMaybe<Scalars['Float']>;
  previousId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  units?: InputMaybe<Scalars['String']>;
  updatePending?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<Scalars['Float']>;
};

export type FilterCountSmartPowerOutletRmsVoltageInput = {
  id?: InputMaybe<Scalars['String']>;
  observedAt?: InputMaybe<Scalars['Float']>;
  previousId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  units?: InputMaybe<Scalars['String']>;
  updatePending?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<Scalars['Float']>;
};

export type FilterCountSolarManagementSystemAzimuthInput = {
  id?: InputMaybe<Scalars['String']>;
  observedAt?: InputMaybe<Scalars['Float']>;
  previousId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  units?: InputMaybe<Scalars['String']>;
  updatePending?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<Scalars['Float']>;
};

export type FilterCountSolarManagementSystemDegradationRateInput = {
  id?: InputMaybe<Scalars['String']>;
  observedAt?: InputMaybe<Scalars['Float']>;
  previousId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  units?: InputMaybe<Scalars['String']>;
  updatePending?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<Scalars['Float']>;
};

export type FilterCountSolarManagementSystemInput = {
  AND?: InputMaybe<Array<FilterCountDeviceInput>>;
  OR?: InputMaybe<Array<FilterCountDeviceInput>>;
  _id?: InputMaybe<Scalars['String']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterCountDeviceOperatorsInput>;
  alertTypes?: InputMaybe<FilterCountDeviceAlertTypesInput>;
  azimuth?: InputMaybe<FilterCountSolarManagementSystemAzimuthInput>;
  controlled?: InputMaybe<FilterCountDeviceControlledInput>;
  degradationRate?: InputMaybe<FilterCountSolarManagementSystemDegradationRateInput>;
  deviceId?: InputMaybe<Scalars['String']>;
  installation?: InputMaybe<FilterCountDeviceInstallationInput>;
  isTrackerSystem?: InputMaybe<FilterCountSolarManagementSystemIsTrackerSystemInput>;
  location?: InputMaybe<Scalars['String']>;
  meta?: InputMaybe<FilterCountDeviceMetaInput>;
  /** The name of the device */
  name?: InputMaybe<Scalars['String']>;
  panelCurrents?: InputMaybe<
    Array<InputMaybe<FilterCountSolarManagementSystemPanelCurrentsInput>>
  >;
  panelId?: InputMaybe<Scalars['String']>;
  panelTemperature?: InputMaybe<FilterCountSolarManagementSystemPanelTemperatureInput>;
  panelVoltages?: InputMaybe<
    Array<InputMaybe<FilterCountSolarManagementSystemPanelVoltagesInput>>
  >;
  powerState?: InputMaybe<FilterCountDevicePowerStateInput>;
  propertyId?: InputMaybe<Scalars['String']>;
  shadingFactor?: InputMaybe<FilterCountSolarManagementSystemShadingFactorInput>;
  solarIrradiance?: InputMaybe<FilterCountSolarManagementSystemSolarIrradianceInput>;
  sourceId?: InputMaybe<Scalars['String']>;
  tiltAngle?: InputMaybe<FilterCountSolarManagementSystemTiltAngleInput>;
  timestamp?: InputMaybe<Scalars['Float']>;
  unitId?: InputMaybe<Scalars['String']>;
  updateStatus?: InputMaybe<Scalars['Boolean']>;
  vppId?: InputMaybe<Scalars['String']>;
  zoneId?: InputMaybe<Scalars['String']>;
};

export type FilterCountSolarManagementSystemIsTrackerSystemInput = {
  id?: InputMaybe<Scalars['String']>;
  observedAt?: InputMaybe<Scalars['Float']>;
  previousId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  units?: InputMaybe<Scalars['String']>;
  updatePending?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<Scalars['Boolean']>;
};

export type FilterCountSolarManagementSystemPanelCurrentsInput = {
  id?: InputMaybe<Scalars['String']>;
  observedAt?: InputMaybe<Scalars['Float']>;
  previousId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  units?: InputMaybe<Scalars['String']>;
  updatePending?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<Scalars['Float']>;
};

export type FilterCountSolarManagementSystemPanelTemperatureInput = {
  id?: InputMaybe<Scalars['String']>;
  observedAt?: InputMaybe<Scalars['Float']>;
  previousId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  units?: InputMaybe<Scalars['String']>;
  updatePending?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<Scalars['Float']>;
};

export type FilterCountSolarManagementSystemPanelVoltagesInput = {
  id?: InputMaybe<Scalars['String']>;
  observedAt?: InputMaybe<Scalars['Float']>;
  previousId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  units?: InputMaybe<Scalars['String']>;
  updatePending?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<Scalars['Float']>;
};

export type FilterCountSolarManagementSystemShadingFactorInput = {
  id?: InputMaybe<Scalars['String']>;
  observedAt?: InputMaybe<Scalars['Float']>;
  previousId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  units?: InputMaybe<Scalars['String']>;
  updatePending?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<Scalars['Float']>;
};

export type FilterCountSolarManagementSystemSolarIrradianceInput = {
  id?: InputMaybe<Scalars['String']>;
  observedAt?: InputMaybe<Scalars['Float']>;
  previousId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  units?: InputMaybe<Scalars['String']>;
  updatePending?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<Scalars['Float']>;
};

export type FilterCountSolarManagementSystemTiltAngleInput = {
  id?: InputMaybe<Scalars['String']>;
  observedAt?: InputMaybe<Scalars['Float']>;
  previousId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  units?: InputMaybe<Scalars['String']>;
  updatePending?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<Scalars['Float']>;
};

export type FilterCountSourceInput = {
  AND?: InputMaybe<Array<FilterCountSourceInput>>;
  OR?: InputMaybe<Array<FilterCountSourceInput>>;
  _id?: InputMaybe<Scalars['String']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterCountSourceOperatorsInput>;
  name?: InputMaybe<Scalars['String']>;
  propertyId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  type?: InputMaybe<EnumDKeySourceType>;
  url?: InputMaybe<Scalars['String']>;
};

export type FilterCountSourceNameOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['String']>;
  gte?: InputMaybe<Scalars['String']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  lt?: InputMaybe<Scalars['String']>;
  lte?: InputMaybe<Scalars['String']>;
  ne?: InputMaybe<Scalars['String']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterCountSourceOperatorsInput = {
  _id?: InputMaybe<FilterCountSource_IdOperatorsInput>;
  name?: InputMaybe<FilterCountSourceNameOperatorsInput>;
};

export type FilterCountSource_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['String']>;
  gte?: InputMaybe<Scalars['String']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  lt?: InputMaybe<Scalars['String']>;
  lte?: InputMaybe<Scalars['String']>;
  ne?: InputMaybe<Scalars['String']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']>;
};

export type FilterCountSystemNotificationCreatedAtOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['Float']>;
  gte?: InputMaybe<Scalars['Float']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Float']>>>;
  lt?: InputMaybe<Scalars['Float']>;
  lte?: InputMaybe<Scalars['Float']>;
  ne?: InputMaybe<Scalars['Float']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Float']>>>;
};

export type FilterCountSystemNotificationDisplayEndOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['Float']>;
  gte?: InputMaybe<Scalars['Float']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Float']>>>;
  lt?: InputMaybe<Scalars['Float']>;
  lte?: InputMaybe<Scalars['Float']>;
  ne?: InputMaybe<Scalars['Float']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Float']>>>;
};

export type FilterCountSystemNotificationDisplayStartOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['Float']>;
  gte?: InputMaybe<Scalars['Float']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Float']>>>;
  lt?: InputMaybe<Scalars['Float']>;
  lte?: InputMaybe<Scalars['Float']>;
  ne?: InputMaybe<Scalars['Float']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Float']>>>;
};

export type FilterCountSystemNotificationEntityIdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['String']>;
  gte?: InputMaybe<Scalars['String']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  lt?: InputMaybe<Scalars['String']>;
  lte?: InputMaybe<Scalars['String']>;
  ne?: InputMaybe<Scalars['String']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']>;
};

export type FilterCountSystemNotificationEntityTypeOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<EnumSystemNotificationEntityType>;
  gte?: InputMaybe<EnumSystemNotificationEntityType>;
  in?: InputMaybe<Array<InputMaybe<EnumSystemNotificationEntityType>>>;
  lt?: InputMaybe<EnumSystemNotificationEntityType>;
  lte?: InputMaybe<EnumSystemNotificationEntityType>;
  ne?: InputMaybe<EnumSystemNotificationEntityType>;
  nin?: InputMaybe<Array<InputMaybe<EnumSystemNotificationEntityType>>>;
};

export type FilterCountSystemNotificationInput = {
  AND?: InputMaybe<Array<FilterCountSystemNotificationInput>>;
  OR?: InputMaybe<Array<FilterCountSystemNotificationInput>>;
  _id?: InputMaybe<Scalars['String']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterCountSystemNotificationOperatorsInput>;
  acknowledgedAt?: InputMaybe<Scalars['Float']>;
  createdAt?: InputMaybe<Scalars['Float']>;
  displayDuration?: InputMaybe<Scalars['Float']>;
  displayEnd?: InputMaybe<Scalars['Float']>;
  displayStart?: InputMaybe<Scalars['Float']>;
  entityId?: InputMaybe<Scalars['String']>;
  entityType?: InputMaybe<EnumSystemNotificationEntityType>;
  link?: InputMaybe<Scalars['String']>;
  message?: InputMaybe<Scalars['String']>;
  requireAcknowledgement?: InputMaybe<Scalars['Boolean']>;
  seenAt?: InputMaybe<Scalars['Float']>;
  seenBy?: InputMaybe<
    Array<InputMaybe<FilterCountSystemNotificationSeenByInput>>
  >;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterCountSystemNotificationOperatorsInput = {
  _id?: InputMaybe<FilterCountSystemNotification_IdOperatorsInput>;
  createdAt?: InputMaybe<FilterCountSystemNotificationCreatedAtOperatorsInput>;
  displayEnd?: InputMaybe<FilterCountSystemNotificationDisplayEndOperatorsInput>;
  displayStart?: InputMaybe<FilterCountSystemNotificationDisplayStartOperatorsInput>;
  entityId?: InputMaybe<FilterCountSystemNotificationEntityIdOperatorsInput>;
  entityType?: InputMaybe<FilterCountSystemNotificationEntityTypeOperatorsInput>;
  seenBy?: InputMaybe<FilterCountSystemNotificationSeenByOperatorsInput>;
};

export type FilterCountSystemNotificationSeenByInput = {
  _id?: InputMaybe<Scalars['MongoID']>;
  seenAt?: InputMaybe<Scalars['Float']>;
  userId?: InputMaybe<Scalars['String']>;
};

export type FilterCountSystemNotificationSeenByOperatorsInput = {
  userId?: InputMaybe<FilterCountSystemNotificationSeenByUserIdOperatorsInput>;
};

export type FilterCountSystemNotificationSeenByUserIdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['String']>;
  gte?: InputMaybe<Scalars['String']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  lt?: InputMaybe<Scalars['String']>;
  lte?: InputMaybe<Scalars['String']>;
  ne?: InputMaybe<Scalars['String']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']>;
};

export type FilterCountSystemNotification_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['String']>;
  gte?: InputMaybe<Scalars['String']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  lt?: InputMaybe<Scalars['String']>;
  lte?: InputMaybe<Scalars['String']>;
  ne?: InputMaybe<Scalars['String']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']>;
};

export type FilterCountThermistorInput = {
  AND?: InputMaybe<Array<FilterCountDeviceInput>>;
  OR?: InputMaybe<Array<FilterCountDeviceInput>>;
  _id?: InputMaybe<Scalars['String']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterCountDeviceOperatorsInput>;
  alertTypes?: InputMaybe<FilterCountDeviceAlertTypesInput>;
  controlled?: InputMaybe<FilterCountDeviceControlledInput>;
  deviceId?: InputMaybe<Scalars['String']>;
  installation?: InputMaybe<FilterCountDeviceInstallationInput>;
  location?: InputMaybe<Scalars['String']>;
  meta?: InputMaybe<FilterCountDeviceMetaInput>;
  /** The name of the device */
  name?: InputMaybe<Scalars['String']>;
  panelId?: InputMaybe<Scalars['String']>;
  powerState?: InputMaybe<FilterCountDevicePowerStateInput>;
  propertyId?: InputMaybe<Scalars['String']>;
  role?: InputMaybe<Scalars['String']>;
  sourceId?: InputMaybe<Scalars['String']>;
  temperature?: InputMaybe<FilterCountThermistorTemperatureInput>;
  timestamp?: InputMaybe<Scalars['Float']>;
  unitId?: InputMaybe<Scalars['String']>;
  updateStatus?: InputMaybe<Scalars['Boolean']>;
  vppId?: InputMaybe<Scalars['String']>;
  zoneId?: InputMaybe<Scalars['String']>;
};

export type FilterCountThermistorTemperatureInput = {
  id?: InputMaybe<Scalars['String']>;
  observedAt?: InputMaybe<Scalars['Float']>;
  previousId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  units?: InputMaybe<Scalars['String']>;
  updatePending?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<Scalars['Float']>;
};

export type FilterCountThermostatAirDirectionInput = {
  id?: InputMaybe<Scalars['String']>;
  observedAt?: InputMaybe<Scalars['Float']>;
  previousId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  units?: InputMaybe<Scalars['String']>;
  updatePending?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<Scalars['String']>;
};

export type FilterCountThermostatCoolSetpointInput = {
  id?: InputMaybe<Scalars['String']>;
  observedAt?: InputMaybe<Scalars['Float']>;
  previousId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  units?: InputMaybe<Scalars['String']>;
  updatePending?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<Scalars['Float']>;
};

export type FilterCountThermostatDeviceSpecInput = {
  thermostat?: InputMaybe<FilterCountThermostatDeviceSpecThermostatInput>;
  version?: InputMaybe<Scalars['String']>;
};

export type FilterCountThermostatDeviceSpecThermostatInput = {
  controlContract?: InputMaybe<EnumThermostatDeviceSpecThermostatControlContract>;
  keypadLockoutLevels?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  modbusRTU?: InputMaybe<Scalars['Boolean']>;
  numberOfDailyTransitions?: InputMaybe<Scalars['Float']>;
  numberOfWeeklyTransitions?: InputMaybe<Scalars['Float']>;
  secondaryHeatSource?: InputMaybe<FilterCountThermostatDeviceSpecThermostatSecondaryHeatSourceInput>;
  setpointLimits?: InputMaybe<FilterCountThermostatDeviceSpecThermostatSetpointLimitsInput>;
  supportedAutoModeType?: InputMaybe<EnumThermostatDeviceSpecThermostatSupportedAutoModeType>;
  units?: InputMaybe<Scalars['String']>;
};

export type FilterCountThermostatDeviceSpecThermostatSecondaryHeatSourceInput =
  {
    alternateHeat?: InputMaybe<Scalars['Boolean']>;
    auxiliaryHeat?: InputMaybe<Scalars['Boolean']>;
  };

export type FilterCountThermostatDeviceSpecThermostatSetpointLimitsCoolInput = {
  max?: InputMaybe<Scalars['Float']>;
  min?: InputMaybe<Scalars['Float']>;
};

export type FilterCountThermostatDeviceSpecThermostatSetpointLimitsInput = {
  cool?: InputMaybe<FilterCountThermostatDeviceSpecThermostatSetpointLimitsCoolInput>;
  heat?: InputMaybe<FilterCountThermostatDeviceSpecThermostatSetpointLimitsCoolInput>;
};

export type FilterCountThermostatFanModeInput = {
  id?: InputMaybe<Scalars['String']>;
  observedAt?: InputMaybe<Scalars['Float']>;
  previousId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  units?: InputMaybe<Scalars['String']>;
  updatePending?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<EnumThermostatFanModeValue>;
};

export type FilterCountThermostatFanSpeedInput = {
  id?: InputMaybe<Scalars['String']>;
  observedAt?: InputMaybe<Scalars['Float']>;
  previousId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  units?: InputMaybe<Scalars['String']>;
  updatePending?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<EnumThermostatFanSpeedValue>;
};

export type FilterCountThermostatFanStateInput = {
  id?: InputMaybe<Scalars['String']>;
  observedAt?: InputMaybe<Scalars['Float']>;
  previousId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  units?: InputMaybe<Scalars['String']>;
  updatePending?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<EnumThermostatFanStateValue>;
};

export type FilterCountThermostatHeatSetpointInput = {
  id?: InputMaybe<Scalars['String']>;
  observedAt?: InputMaybe<Scalars['Float']>;
  previousId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  units?: InputMaybe<Scalars['String']>;
  updatePending?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<Scalars['Float']>;
};

export type FilterCountThermostatHoldDurationInput = {
  id?: InputMaybe<Scalars['String']>;
  observedAt?: InputMaybe<Scalars['Float']>;
  previousId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  units?: InputMaybe<Scalars['String']>;
  updatePending?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<Scalars['Float']>;
};

export type FilterCountThermostatHoldEndInput = {
  id?: InputMaybe<Scalars['String']>;
  observedAt?: InputMaybe<Scalars['Float']>;
  previousId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  units?: InputMaybe<Scalars['String']>;
  updatePending?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<Scalars['Float']>;
};

export type FilterCountThermostatHoldExpiryTimeInput = {
  id?: InputMaybe<Scalars['String']>;
  observedAt?: InputMaybe<Scalars['Float']>;
  previousId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  units?: InputMaybe<Scalars['String']>;
  updatePending?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<Scalars['Float']>;
};

export type FilterCountThermostatHoldStateInput = {
  id?: InputMaybe<Scalars['String']>;
  observedAt?: InputMaybe<Scalars['Float']>;
  previousId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  units?: InputMaybe<Scalars['String']>;
  updatePending?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<EnumThermostatHoldStateValue>;
};

export type FilterCountThermostatHumidityInput = {
  id?: InputMaybe<Scalars['String']>;
  observedAt?: InputMaybe<Scalars['Float']>;
  previousId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  units?: InputMaybe<Scalars['String']>;
  updatePending?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<Scalars['Float']>;
};

export type FilterCountThermostatInput = {
  AND?: InputMaybe<Array<FilterCountDeviceInput>>;
  OR?: InputMaybe<Array<FilterCountDeviceInput>>;
  _id?: InputMaybe<Scalars['String']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterCountDeviceOperatorsInput>;
  airDirection?: InputMaybe<FilterCountThermostatAirDirectionInput>;
  alertTypes?: InputMaybe<FilterCountDeviceAlertTypesInput>;
  controlled?: InputMaybe<FilterCountDeviceControlledInput>;
  coolSetpoint?: InputMaybe<FilterCountThermostatCoolSetpointInput>;
  deviceId?: InputMaybe<Scalars['String']>;
  deviceSpec?: InputMaybe<FilterCountThermostatDeviceSpecInput>;
  fanMode?: InputMaybe<FilterCountThermostatFanModeInput>;
  fanSpeed?: InputMaybe<FilterCountThermostatFanSpeedInput>;
  fanState?: InputMaybe<FilterCountThermostatFanStateInput>;
  heatSetpoint?: InputMaybe<FilterCountThermostatHeatSetpointInput>;
  holdDuration?: InputMaybe<FilterCountThermostatHoldDurationInput>;
  holdEnd?: InputMaybe<FilterCountThermostatHoldEndInput>;
  holdExpiryTime?: InputMaybe<FilterCountThermostatHoldExpiryTimeInput>;
  holdState?: InputMaybe<FilterCountThermostatHoldStateInput>;
  humidity?: InputMaybe<FilterCountThermostatHumidityInput>;
  installation?: InputMaybe<FilterCountDeviceInstallationInput>;
  keypadLockoutLevel?: InputMaybe<FilterCountThermostatKeypadLockoutLevelInput>;
  lastScheduleChange?: InputMaybe<FilterCountThermostatLastScheduleChangeInput>;
  lastSetpointChange?: InputMaybe<FilterCountThermostatLastSetpointChangeInput>;
  localControlPermissions?: InputMaybe<FilterCountThermostatLocalControlPermissionsInput>;
  location?: InputMaybe<Scalars['String']>;
  maxCoolSetpointLimit?: InputMaybe<FilterCountThermostatMaxCoolSetpointLimitInput>;
  maxHeatSetpointLimit?: InputMaybe<FilterCountThermostatMaxHeatSetpointLimitInput>;
  maxSetpoint?: InputMaybe<FilterCountThermostatMaxSetpointInput>;
  meta?: InputMaybe<FilterCountDeviceMetaInput>;
  minCoolSetpointLimit?: InputMaybe<FilterCountThermostatMinCoolSetpointLimitInput>;
  minHeatSetpointLimit?: InputMaybe<FilterCountThermostatMinHeatSetpointLimitInput>;
  minSetpoint?: InputMaybe<FilterCountThermostatMinSetpointInput>;
  /** The name of the device */
  name?: InputMaybe<Scalars['String']>;
  operatingMode?: InputMaybe<FilterCountThermostatOperatingModeInput>;
  operatingState?: InputMaybe<FilterCountThermostatOperatingStateInput>;
  pairingState?: InputMaybe<FilterCountThermostatPairingStateInput>;
  panelId?: InputMaybe<Scalars['String']>;
  passCode?: InputMaybe<FilterCountThermostatPassCodeInput>;
  pendingSchedule?: InputMaybe<FilterCountThermostatPendingScheduleInput>;
  powerMode?: InputMaybe<FilterCountThermostatPowerModeInput>;
  powerState?: InputMaybe<FilterCountDevicePowerStateInput>;
  progMode?: InputMaybe<FilterCountThermostatProgModeInput>;
  propertyId?: InputMaybe<Scalars['String']>;
  remoteSensorTempDelta?: InputMaybe<FilterCountThermostatRemoteSensorTempDeltaInput>;
  schedVisibilityMode?: InputMaybe<FilterCountThermostatSchedVisibilityModeInput>;
  schedule?: InputMaybe<FilterCountThermostatScheduleInput>;
  setpoint?: InputMaybe<FilterCountThermostatSetpointInput>;
  setpointChangeSource?: InputMaybe<FilterCountThermostatSetpointChangeSourceInput>;
  showFanButton?: InputMaybe<FilterCountThermostatShowFanButtonInput>;
  sourceId?: InputMaybe<Scalars['String']>;
  systemType?: InputMaybe<FilterCountThermostatSystemTypeInput>;
  tempDisplayMode?: InputMaybe<FilterCountThermostatTempDisplayModeInput>;
  temperature?: InputMaybe<FilterCountThermostatTemperatureInput>;
  thermostatControlCommand?: InputMaybe<FilterCountThermostatThermostatControlCommandInput>;
  thermostatScheduleTemplateId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  uiOptions?: InputMaybe<FilterCountThermostatUiOptionsInput>;
  unitId?: InputMaybe<Scalars['String']>;
  updateStatus?: InputMaybe<Scalars['Boolean']>;
  useCustomSchedule?: InputMaybe<Scalars['Boolean']>;
  useCustomSetpointLimits?: InputMaybe<Scalars['Boolean']>;
  vppId?: InputMaybe<Scalars['String']>;
  zoneId?: InputMaybe<Scalars['String']>;
};

export type FilterCountThermostatKeypadLockoutLevelInput = {
  id?: InputMaybe<Scalars['String']>;
  observedAt?: InputMaybe<Scalars['Float']>;
  previousId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  units?: InputMaybe<Scalars['String']>;
  updatePending?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<Scalars['String']>;
};

export type FilterCountThermostatLastScheduleChangeInput = {
  id?: InputMaybe<Scalars['String']>;
  observedAt?: InputMaybe<Scalars['Float']>;
  previousId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  units?: InputMaybe<Scalars['String']>;
  updatePending?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<Scalars['Float']>;
};

export type FilterCountThermostatLastSetpointChangeInput = {
  id?: InputMaybe<Scalars['String']>;
  observedAt?: InputMaybe<Scalars['Float']>;
  previousId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  units?: InputMaybe<Scalars['String']>;
  updatePending?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<Scalars['Float']>;
};

export type FilterCountThermostatLocalControlPermissionsInput = {
  id?: InputMaybe<Scalars['String']>;
  observedAt?: InputMaybe<Scalars['Float']>;
  previousId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  units?: InputMaybe<Scalars['String']>;
  updatePending?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<Scalars['JSON']>;
};

export type FilterCountThermostatMaxCoolSetpointLimitInput = {
  id?: InputMaybe<Scalars['String']>;
  observedAt?: InputMaybe<Scalars['Float']>;
  previousId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  units?: InputMaybe<Scalars['String']>;
  updatePending?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<Scalars['Float']>;
};

export type FilterCountThermostatMaxHeatSetpointLimitInput = {
  id?: InputMaybe<Scalars['String']>;
  observedAt?: InputMaybe<Scalars['Float']>;
  previousId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  units?: InputMaybe<Scalars['String']>;
  updatePending?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<Scalars['Float']>;
};

export type FilterCountThermostatMaxSetpointInput = {
  id?: InputMaybe<Scalars['String']>;
  observedAt?: InputMaybe<Scalars['Float']>;
  previousId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  units?: InputMaybe<Scalars['String']>;
  updatePending?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<Scalars['Float']>;
};

export type FilterCountThermostatMinCoolSetpointLimitInput = {
  id?: InputMaybe<Scalars['String']>;
  observedAt?: InputMaybe<Scalars['Float']>;
  previousId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  units?: InputMaybe<Scalars['String']>;
  updatePending?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<Scalars['Float']>;
};

export type FilterCountThermostatMinHeatSetpointLimitInput = {
  id?: InputMaybe<Scalars['String']>;
  observedAt?: InputMaybe<Scalars['Float']>;
  previousId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  units?: InputMaybe<Scalars['String']>;
  updatePending?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<Scalars['Float']>;
};

export type FilterCountThermostatMinSetpointInput = {
  id?: InputMaybe<Scalars['String']>;
  observedAt?: InputMaybe<Scalars['Float']>;
  previousId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  units?: InputMaybe<Scalars['String']>;
  updatePending?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<Scalars['Float']>;
};

export type FilterCountThermostatOperatingModeInput = {
  id?: InputMaybe<Scalars['String']>;
  observedAt?: InputMaybe<Scalars['Float']>;
  previousId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  units?: InputMaybe<Scalars['String']>;
  updatePending?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<EnumThermostatOperatingModeValue>;
};

export type FilterCountThermostatOperatingStateInput = {
  id?: InputMaybe<Scalars['String']>;
  observedAt?: InputMaybe<Scalars['Float']>;
  previousId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  units?: InputMaybe<Scalars['String']>;
  updatePending?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<EnumThermostatOperatingStateValue>;
};

export type FilterCountThermostatPairingStateInput = {
  id?: InputMaybe<Scalars['String']>;
  observedAt?: InputMaybe<Scalars['Float']>;
  previousId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  units?: InputMaybe<Scalars['String']>;
  updatePending?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<EnumThermostatPairingStateValue>;
};

export type FilterCountThermostatPassCodeInput = {
  id?: InputMaybe<Scalars['String']>;
  observedAt?: InputMaybe<Scalars['Float']>;
  previousId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  units?: InputMaybe<Scalars['String']>;
  updatePending?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<Scalars['Float']>;
};

export type FilterCountThermostatPendingScheduleInput = {
  id?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  units?: InputMaybe<Scalars['String']>;
  updatePending?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<Scalars['JSON']>;
};

export type FilterCountThermostatPowerModeInput = {
  id?: InputMaybe<Scalars['String']>;
  observedAt?: InputMaybe<Scalars['Float']>;
  previousId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  units?: InputMaybe<Scalars['String']>;
  updatePending?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<EnumThermostatPowerModeValue>;
};

export type FilterCountThermostatProgModeInput = {
  id?: InputMaybe<Scalars['String']>;
  observedAt?: InputMaybe<Scalars['Float']>;
  previousId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  units?: InputMaybe<Scalars['String']>;
  updatePending?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<EnumThermostatProgModeValue>;
};

export type FilterCountThermostatRemoteSensorTempDeltaInput = {
  id?: InputMaybe<Scalars['String']>;
  observedAt?: InputMaybe<Scalars['Float']>;
  previousId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  units?: InputMaybe<Scalars['String']>;
  updatePending?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<Scalars['Float']>;
};

export type FilterCountThermostatSchedVisibilityModeInput = {
  id?: InputMaybe<Scalars['String']>;
  observedAt?: InputMaybe<Scalars['Float']>;
  previousId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  units?: InputMaybe<Scalars['String']>;
  updatePending?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<EnumThermostatSchedVisibilityModeValue>;
};

export type FilterCountThermostatScheduleInput = {
  id?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  units?: InputMaybe<Scalars['String']>;
  updatePending?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<Scalars['JSON']>;
};

export type FilterCountThermostatScheduleProfileInput = {
  AND?: InputMaybe<Array<FilterCountThermostatScheduleProfileInput>>;
  OR?: InputMaybe<Array<FilterCountThermostatScheduleProfileInput>>;
  _id?: InputMaybe<Scalars['String']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterCountThermostatScheduleProfileOperatorsInput>;
  name?: InputMaybe<Scalars['String']>;
  propertyId?: InputMaybe<Scalars['String']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterCountThermostatScheduleProfileOperatorsInput = {
  _id?: InputMaybe<FilterCountThermostatScheduleProfile_IdOperatorsInput>;
  propertyId?: InputMaybe<FilterCountThermostatScheduleProfilePropertyIdOperatorsInput>;
};

export type FilterCountThermostatScheduleProfilePropertyIdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['String']>;
  gte?: InputMaybe<Scalars['String']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  lt?: InputMaybe<Scalars['String']>;
  lte?: InputMaybe<Scalars['String']>;
  ne?: InputMaybe<Scalars['String']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']>;
};

export type FilterCountThermostatScheduleProfile_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['String']>;
  gte?: InputMaybe<Scalars['String']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  lt?: InputMaybe<Scalars['String']>;
  lte?: InputMaybe<Scalars['String']>;
  ne?: InputMaybe<Scalars['String']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']>;
};

export type FilterCountThermostatScheduleTemplateInput = {
  AND?: InputMaybe<Array<FilterCountThermostatScheduleTemplateInput>>;
  OR?: InputMaybe<Array<FilterCountThermostatScheduleTemplateInput>>;
  _id?: InputMaybe<Scalars['String']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterCountThermostatScheduleTemplateOperatorsInput>;
  name?: InputMaybe<Scalars['String']>;
  propertyId?: InputMaybe<Scalars['String']>;
  setpointLimitProfileId?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<FilterCountThermostatScheduleTemplateValueInput>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterCountThermostatScheduleTemplateOperatorsInput = {
  _id?: InputMaybe<FilterCountThermostatScheduleTemplate_IdOperatorsInput>;
  propertyId?: InputMaybe<FilterCountThermostatScheduleTemplatePropertyIdOperatorsInput>;
};

export type FilterCountThermostatScheduleTemplatePropertyIdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['String']>;
  gte?: InputMaybe<Scalars['String']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  lt?: InputMaybe<Scalars['String']>;
  lte?: InputMaybe<Scalars['String']>;
  ne?: InputMaybe<Scalars['String']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']>;
};

export type FilterCountThermostatScheduleTemplateValueInput = {
  id?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  units?: InputMaybe<Scalars['String']>;
  updatePending?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<Scalars['JSON']>;
};

export type FilterCountThermostatScheduleTemplate_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['String']>;
  gte?: InputMaybe<Scalars['String']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  lt?: InputMaybe<Scalars['String']>;
  lte?: InputMaybe<Scalars['String']>;
  ne?: InputMaybe<Scalars['String']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']>;
};

export type FilterCountThermostatSetpointChangeSourceInput = {
  id?: InputMaybe<Scalars['String']>;
  observedAt?: InputMaybe<Scalars['Float']>;
  previousId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  units?: InputMaybe<Scalars['String']>;
  updatePending?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<EnumThermostatSetpointChangeSourceValue>;
};

export type FilterCountThermostatSetpointInput = {
  id?: InputMaybe<Scalars['String']>;
  observedAt?: InputMaybe<Scalars['Float']>;
  previousId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  units?: InputMaybe<Scalars['String']>;
  updatePending?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<Scalars['Float']>;
};

export type FilterCountThermostatShowFanButtonInput = {
  id?: InputMaybe<Scalars['String']>;
  observedAt?: InputMaybe<Scalars['Float']>;
  previousId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  units?: InputMaybe<Scalars['String']>;
  updatePending?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<Scalars['Boolean']>;
};

export type FilterCountThermostatSystemTypeInput = {
  id?: InputMaybe<Scalars['String']>;
  observedAt?: InputMaybe<Scalars['Float']>;
  previousId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  units?: InputMaybe<Scalars['String']>;
  updatePending?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<EnumThermostatSystemTypeValue>;
};

export type FilterCountThermostatTempDisplayModeInput = {
  id?: InputMaybe<Scalars['String']>;
  observedAt?: InputMaybe<Scalars['Float']>;
  previousId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  units?: InputMaybe<Scalars['String']>;
  updatePending?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<EnumThermostatTempDisplayModeValue>;
};

export type FilterCountThermostatTemperatureInput = {
  id?: InputMaybe<Scalars['String']>;
  observedAt?: InputMaybe<Scalars['Float']>;
  previousId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  units?: InputMaybe<Scalars['String']>;
  updatePending?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<Scalars['Float']>;
};

export type FilterCountThermostatThermostatControlCommandInput = {
  commandId?: InputMaybe<Scalars['String']>;
  confirmation?: InputMaybe<Scalars['JSON']>;
  error?: InputMaybe<Scalars['String']>;
  expiresAt?: InputMaybe<Scalars['Float']>;
  requestedAt?: InputMaybe<Scalars['Float']>;
  requestedValues?: InputMaybe<Scalars['JSON']>;
  status?: InputMaybe<EnumThermostatThermostatControlCommandStatus>;
};

export type FilterCountThermostatUiOptionsInput = {
  id?: InputMaybe<Scalars['String']>;
  observedAt?: InputMaybe<Scalars['Float']>;
  previousId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  units?: InputMaybe<Scalars['String']>;
  updatePending?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<Scalars['Float']>;
};

export type FilterCountUnitAlertTypesInput = {
  deviceAlert?: InputMaybe<Scalars['Boolean']>;
  deviceMetric?: InputMaybe<Scalars['Boolean']>;
  deviceOffline?: InputMaybe<Scalars['Boolean']>;
  equipmentAlarm?: InputMaybe<Scalars['Boolean']>;
  sourceOffline?: InputMaybe<Scalars['Boolean']>;
};

export type FilterCountUnitBuildingIdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['String']>;
  gte?: InputMaybe<Scalars['String']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  lt?: InputMaybe<Scalars['String']>;
  lte?: InputMaybe<Scalars['String']>;
  ne?: InputMaybe<Scalars['String']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']>;
};

export type FilterCountUnitDevicesSummaryInput = {
  count?: InputMaybe<Scalars['Float']>;
  majorAlerts?: InputMaybe<Scalars['Float']>;
  minorAlerts?: InputMaybe<Scalars['Float']>;
  proxy?: InputMaybe<FilterCountUnitDevicesSummaryProxyInput>;
};

export type FilterCountUnitDevicesSummaryProxyInput = {
  coolSetpoint?: InputMaybe<Scalars['Float']>;
  heatSetpoint?: InputMaybe<Scalars['Float']>;
  humidity?: InputMaybe<Scalars['Float']>;
  isOffline?: InputMaybe<Scalars['Boolean']>;
  operatingMode?: InputMaybe<Scalars['String']>;
  operatingState?: InputMaybe<Scalars['String']>;
  setpointCoolMin?: InputMaybe<Scalars['Float']>;
  setpointHeatMax?: InputMaybe<Scalars['Float']>;
  setpointProfileName?: InputMaybe<Scalars['String']>;
  setpointProfileType?: InputMaybe<Scalars['String']>;
  temperature?: InputMaybe<Scalars['Float']>;
  type?: InputMaybe<Scalars['String']>;
};

export type FilterCountUnitInput = {
  AND?: InputMaybe<Array<FilterCountUnitInput>>;
  OR?: InputMaybe<Array<FilterCountUnitInput>>;
  _id?: InputMaybe<Scalars['String']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterCountUnitOperatorsInput>;
  alertTypes?: InputMaybe<FilterCountUnitAlertTypesInput>;
  buildingId?: InputMaybe<Scalars['String']>;
  cuid?: InputMaybe<Scalars['String']>;
  devicesSummary?: InputMaybe<FilterCountUnitDevicesSummaryInput>;
  floorId?: InputMaybe<Scalars['String']>;
  hasPanels?: InputMaybe<Scalars['Boolean']>;
  name?: InputMaybe<Scalars['String']>;
  propertyId?: InputMaybe<Scalars['String']>;
  resident?: InputMaybe<FilterCountUnitResidentInput>;
  setpointProfileId?: InputMaybe<Scalars['String']>;
  sourceId?: InputMaybe<Scalars['String']>;
  tempDisplayUnits?: InputMaybe<Scalars['String']>;
  thermostatScheduleTemplateId?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<Scalars['String']>;
  zonePolicyId?: InputMaybe<Scalars['String']>;
};

export type FilterCountUnitNameOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['String']>;
  gte?: InputMaybe<Scalars['String']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  lt?: InputMaybe<Scalars['String']>;
  lte?: InputMaybe<Scalars['String']>;
  ne?: InputMaybe<Scalars['String']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterCountUnitOperatorsInput = {
  _id?: InputMaybe<FilterCountUnit_IdOperatorsInput>;
  buildingId?: InputMaybe<FilterCountUnitBuildingIdOperatorsInput>;
  name?: InputMaybe<FilterCountUnitNameOperatorsInput>;
  propertyId?: InputMaybe<FilterCountUnitPropertyIdOperatorsInput>;
};

export type FilterCountUnitPropertyIdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['String']>;
  gte?: InputMaybe<Scalars['String']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  lt?: InputMaybe<Scalars['String']>;
  lte?: InputMaybe<Scalars['String']>;
  ne?: InputMaybe<Scalars['String']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']>;
};

export type FilterCountUnitResidentInput = {
  email?: InputMaybe<Scalars['String']>;
  mobile?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  phone?: InputMaybe<Scalars['String']>;
};

export type FilterCountUnit_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['String']>;
  gte?: InputMaybe<Scalars['String']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  lt?: InputMaybe<Scalars['String']>;
  lte?: InputMaybe<Scalars['String']>;
  ne?: InputMaybe<Scalars['String']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']>;
};

export type FilterCountUserEmailsInput = {
  address?: InputMaybe<Scalars['String']>;
  externalId?: InputMaybe<Scalars['String']>;
  verified?: InputMaybe<Scalars['Boolean']>;
};

export type FilterCountUserHistoryInput = {
  AND?: InputMaybe<Array<FilterCountUserHistoryInput>>;
  OR?: InputMaybe<Array<FilterCountUserHistoryInput>>;
  _id?: InputMaybe<Scalars['String']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterCountUserHistoryOperatorsInput>;
  currentIndex?: InputMaybe<Scalars['Float']>;
  deviceId?: InputMaybe<Scalars['String']>;
  history?: InputMaybe<Scalars['JSON']>;
  lastAccessedAt?: InputMaybe<Scalars['Float']>;
  userId?: InputMaybe<Scalars['String']>;
};

export type FilterCountUserHistoryLastAccessedAtOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['Float']>;
  gte?: InputMaybe<Scalars['Float']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Float']>>>;
  lt?: InputMaybe<Scalars['Float']>;
  lte?: InputMaybe<Scalars['Float']>;
  ne?: InputMaybe<Scalars['Float']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Float']>>>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterCountUserHistoryOperatorsInput = {
  _id?: InputMaybe<FilterCountUserHistory_IdOperatorsInput>;
  lastAccessedAt?: InputMaybe<FilterCountUserHistoryLastAccessedAtOperatorsInput>;
  userId?: InputMaybe<FilterCountUserHistoryUserIdOperatorsInput>;
};

export type FilterCountUserHistoryUserIdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['String']>;
  gte?: InputMaybe<Scalars['String']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  lt?: InputMaybe<Scalars['String']>;
  lte?: InputMaybe<Scalars['String']>;
  ne?: InputMaybe<Scalars['String']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']>;
};

export type FilterCountUserHistory_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['String']>;
  gte?: InputMaybe<Scalars['String']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  lt?: InputMaybe<Scalars['String']>;
  lte?: InputMaybe<Scalars['String']>;
  ne?: InputMaybe<Scalars['String']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']>;
};

export type FilterCountUserInput = {
  AND?: InputMaybe<Array<FilterCountUserInput>>;
  OR?: InputMaybe<Array<FilterCountUserInput>>;
  _id?: InputMaybe<Scalars['String']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterCountUserOperatorsInput>;
  createdAt?: InputMaybe<Scalars['Date']>;
  emails?: InputMaybe<Array<InputMaybe<FilterCountUserEmailsInput>>>;
  externalId?: InputMaybe<Scalars['String']>;
  heartbeat?: InputMaybe<Scalars['Date']>;
  mobileSession?: InputMaybe<FilterCountUserMobileSessionInput>;
  profile?: InputMaybe<FilterCountUserProfileInput>;
  services?: InputMaybe<FilterCountUserServicesInput>;
  session?: InputMaybe<FilterCountUserSessionInput>;
  state?: InputMaybe<Scalars['String']>;
  username?: InputMaybe<Scalars['String']>;
};

export type FilterCountUserMobileSessionInput = {
  appName?: InputMaybe<Scalars['String']>;
  packageName?: InputMaybe<Scalars['String']>;
  version?: InputMaybe<Scalars['String']>;
  versionCode?: InputMaybe<Scalars['String']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterCountUserOperatorsInput = {
  _id?: InputMaybe<FilterCountUser_IdOperatorsInput>;
};

export type FilterCountUserProfileInput = {
  emailOptInStatus?: InputMaybe<Scalars['String']>;
  emailOptInStatusTimestamp?: InputMaybe<Scalars['Float']>;
  historyMap?: InputMaybe<Scalars['JSON']>;
  mobile?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  preferredAirFlowUnits?: InputMaybe<EnumUserProfilePreferredAirFlowUnits>;
  preferredUnits?: InputMaybe<EnumUserProfilePreferredUnits>;
  smsOptInStatus?: InputMaybe<Scalars['String']>;
  smsOptInStatusTimestamp?: InputMaybe<Scalars['Float']>;
};

export type FilterCountUserServicesInput = {
  password?: InputMaybe<FilterCountUserServicesPasswordInput>;
  resume?: InputMaybe<FilterCountUserServicesResumeInput>;
};

export type FilterCountUserServicesPasswordInput = {
  bcrypt?: InputMaybe<Scalars['String']>;
  enroll?: InputMaybe<Scalars['String']>;
  externalId?: InputMaybe<Scalars['String']>;
  reset?: InputMaybe<Scalars['String']>;
};

export type FilterCountUserServicesResumeInput = {
  loginTokens?: InputMaybe<
    Array<InputMaybe<FilterCountUserServicesResumeLoginTokensInput>>
  >;
};

export type FilterCountUserServicesResumeLoginTokensInput = {
  hashedToken?: InputMaybe<Scalars['String']>;
  when?: InputMaybe<Scalars['Date']>;
};

export type FilterCountUserSessionInput = {
  isMobile?: InputMaybe<Scalars['Boolean']>;
};

export type FilterCountUser_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['String']>;
  gte?: InputMaybe<Scalars['String']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  lt?: InputMaybe<Scalars['String']>;
  lte?: InputMaybe<Scalars['String']>;
  ne?: InputMaybe<Scalars['String']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']>;
};

export type FilterCountVsdPumpCurrentSpeedInput = {
  id?: InputMaybe<Scalars['String']>;
  observedAt?: InputMaybe<Scalars['Float']>;
  previousId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  units?: InputMaybe<Scalars['String']>;
  updatePending?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<Scalars['Float']>;
};

export type FilterCountVsdPumpDriveModeInput = {
  id?: InputMaybe<Scalars['String']>;
  observedAt?: InputMaybe<Scalars['Float']>;
  previousId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  units?: InputMaybe<Scalars['String']>;
  updatePending?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<Scalars['String']>;
};

export type FilterCountVsdPumpDriveOutputEnergyInput = {
  id?: InputMaybe<Scalars['String']>;
  observedAt?: InputMaybe<Scalars['Float']>;
  previousId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  units?: InputMaybe<Scalars['String']>;
  updatePending?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<Scalars['Float']>;
};

export type FilterCountVsdPumpDriveOutputPowerInput = {
  id?: InputMaybe<Scalars['String']>;
  observedAt?: InputMaybe<Scalars['Float']>;
  previousId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  units?: InputMaybe<Scalars['String']>;
  updatePending?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<Scalars['Float']>;
};

export type FilterCountVsdPumpInput = {
  AND?: InputMaybe<Array<FilterCountDeviceInput>>;
  OR?: InputMaybe<Array<FilterCountDeviceInput>>;
  _id?: InputMaybe<Scalars['String']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterCountDeviceOperatorsInput>;
  alertTypes?: InputMaybe<FilterCountDeviceAlertTypesInput>;
  controlled?: InputMaybe<FilterCountDeviceControlledInput>;
  currentSpeed?: InputMaybe<FilterCountVsdPumpCurrentSpeedInput>;
  deviceId?: InputMaybe<Scalars['String']>;
  driveMode?: InputMaybe<FilterCountVsdPumpDriveModeInput>;
  driveOutputEnergy?: InputMaybe<FilterCountVsdPumpDriveOutputEnergyInput>;
  driveOutputPower?: InputMaybe<FilterCountVsdPumpDriveOutputPowerInput>;
  installation?: InputMaybe<FilterCountDeviceInstallationInput>;
  location?: InputMaybe<Scalars['String']>;
  meta?: InputMaybe<FilterCountDeviceMetaInput>;
  /** The name of the device */
  name?: InputMaybe<Scalars['String']>;
  panelId?: InputMaybe<Scalars['String']>;
  powerState?: InputMaybe<FilterCountDevicePowerStateInput>;
  propertyId?: InputMaybe<Scalars['String']>;
  returnTemperature?: InputMaybe<FilterCountVsdPumpReturnTemperatureInput>;
  role?: InputMaybe<Scalars['String']>;
  sourceId?: InputMaybe<Scalars['String']>;
  stopOrStart?: InputMaybe<FilterCountVsdPumpStopOrStartInput>;
  supplyTemperature?: InputMaybe<FilterCountVsdPumpSupplyTemperatureInput>;
  targetSpeed?: InputMaybe<FilterCountVsdPumpTargetSpeedInput>;
  timestamp?: InputMaybe<Scalars['Float']>;
  unitId?: InputMaybe<Scalars['String']>;
  updateStatus?: InputMaybe<Scalars['Boolean']>;
  vppId?: InputMaybe<Scalars['String']>;
  zoneId?: InputMaybe<Scalars['String']>;
};

export type FilterCountVsdPumpReturnTemperatureInput = {
  id?: InputMaybe<Scalars['String']>;
  observedAt?: InputMaybe<Scalars['Float']>;
  previousId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  units?: InputMaybe<Scalars['String']>;
  updatePending?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<Scalars['Float']>;
};

export type FilterCountVsdPumpStopOrStartInput = {
  id?: InputMaybe<Scalars['String']>;
  observedAt?: InputMaybe<Scalars['Float']>;
  previousId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  units?: InputMaybe<Scalars['String']>;
  updatePending?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<Scalars['Float']>;
};

export type FilterCountVsdPumpSupplyTemperatureInput = {
  id?: InputMaybe<Scalars['String']>;
  observedAt?: InputMaybe<Scalars['Float']>;
  previousId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  units?: InputMaybe<Scalars['String']>;
  updatePending?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<Scalars['Float']>;
};

export type FilterCountVsdPumpTargetSpeedInput = {
  id?: InputMaybe<Scalars['String']>;
  observedAt?: InputMaybe<Scalars['Float']>;
  previousId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  units?: InputMaybe<Scalars['String']>;
  updatePending?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<Scalars['Float']>;
};

export type FilterCountVirtualPowerPlantInput = {
  AND?: InputMaybe<Array<FilterCountVirtualPowerPlantInput>>;
  OR?: InputMaybe<Array<FilterCountVirtualPowerPlantInput>>;
  _id?: InputMaybe<Scalars['String']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterCountVirtualPowerPlantOperatorsInput>;
  inverterId?: InputMaybe<Scalars['String']>;
  location?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  operationalStatus?: InputMaybe<FilterCountVirtualPowerPlantOperationalStatusInput>;
  propertyId?: InputMaybe<Scalars['String']>;
  sourceId?: InputMaybe<Scalars['String']>;
  switchPanelId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  unitId?: InputMaybe<Scalars['String']>;
  updateStatus?: InputMaybe<Scalars['Boolean']>;
};

export type FilterCountVirtualPowerPlantOperationalStatusInput = {
  id?: InputMaybe<Scalars['String']>;
  observedAt?: InputMaybe<Scalars['Float']>;
  previousId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  units?: InputMaybe<Scalars['String']>;
  updatePending?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<EnumVirtualPowerPlantOperationalStatusValue>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterCountVirtualPowerPlantOperatorsInput = {
  _id?: InputMaybe<FilterCountVirtualPowerPlant_IdOperatorsInput>;
};

export type FilterCountVirtualPowerPlant_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['String']>;
  gte?: InputMaybe<Scalars['String']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  lt?: InputMaybe<Scalars['String']>;
  lte?: InputMaybe<Scalars['String']>;
  ne?: InputMaybe<Scalars['String']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']>;
};

export type FilterCountWindManagementSystemBladeConditionInput = {
  id?: InputMaybe<Scalars['String']>;
  observedAt?: InputMaybe<Scalars['Float']>;
  previousId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  units?: InputMaybe<Scalars['String']>;
  updatePending?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<EnumWindManagementSystemBladeConditionValue>;
};

export type FilterCountWindManagementSystemBrakeStatusInput = {
  id?: InputMaybe<Scalars['String']>;
  observedAt?: InputMaybe<Scalars['Float']>;
  previousId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  units?: InputMaybe<Scalars['String']>;
  updatePending?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<EnumWindManagementSystemBrakeStatusValue>;
};

export type FilterCountWindManagementSystemGeneratorTemperatureInput = {
  id?: InputMaybe<Scalars['String']>;
  observedAt?: InputMaybe<Scalars['Float']>;
  previousId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  units?: InputMaybe<Scalars['String']>;
  updatePending?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<Scalars['Float']>;
};

export type FilterCountWindManagementSystemIceDetectionStatusInput = {
  id?: InputMaybe<Scalars['String']>;
  observedAt?: InputMaybe<Scalars['Float']>;
  previousId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  units?: InputMaybe<Scalars['String']>;
  updatePending?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<EnumWindManagementSystemIceDetectionStatusValue>;
};

export type FilterCountWindManagementSystemInput = {
  AND?: InputMaybe<Array<FilterCountDeviceInput>>;
  OR?: InputMaybe<Array<FilterCountDeviceInput>>;
  _id?: InputMaybe<Scalars['String']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterCountDeviceOperatorsInput>;
  alertTypes?: InputMaybe<FilterCountDeviceAlertTypesInput>;
  bladeCondition?: InputMaybe<FilterCountWindManagementSystemBladeConditionInput>;
  brakeStatus?: InputMaybe<FilterCountWindManagementSystemBrakeStatusInput>;
  controlled?: InputMaybe<FilterCountDeviceControlledInput>;
  deviceId?: InputMaybe<Scalars['String']>;
  generatorTemperature?: InputMaybe<FilterCountWindManagementSystemGeneratorTemperatureInput>;
  iceDetectionStatus?: InputMaybe<FilterCountWindManagementSystemIceDetectionStatusInput>;
  installation?: InputMaybe<FilterCountDeviceInstallationInput>;
  location?: InputMaybe<Scalars['String']>;
  meta?: InputMaybe<FilterCountDeviceMetaInput>;
  /** The name of the device */
  name?: InputMaybe<Scalars['String']>;
  panelId?: InputMaybe<Scalars['String']>;
  pitchAngle?: InputMaybe<FilterCountWindManagementSystemPitchAngleInput>;
  powerState?: InputMaybe<FilterCountDevicePowerStateInput>;
  propertyId?: InputMaybe<Scalars['String']>;
  rotorSpeed?: InputMaybe<FilterCountWindManagementSystemRotorSpeedInput>;
  sourceId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  unitId?: InputMaybe<Scalars['String']>;
  updateStatus?: InputMaybe<Scalars['Boolean']>;
  vibrationLevel?: InputMaybe<FilterCountWindManagementSystemVibrationLevelInput>;
  vppId?: InputMaybe<Scalars['String']>;
  windDirection?: InputMaybe<FilterCountWindManagementSystemWindDirectionInput>;
  windSpeed?: InputMaybe<FilterCountWindManagementSystemWindSpeedInput>;
  yawControlStatus?: InputMaybe<FilterCountWindManagementSystemYawControlStatusInput>;
  zoneId?: InputMaybe<Scalars['String']>;
};

export type FilterCountWindManagementSystemPitchAngleInput = {
  id?: InputMaybe<Scalars['String']>;
  observedAt?: InputMaybe<Scalars['Float']>;
  previousId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  units?: InputMaybe<Scalars['String']>;
  updatePending?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<Scalars['Float']>;
};

export type FilterCountWindManagementSystemRotorSpeedInput = {
  id?: InputMaybe<Scalars['String']>;
  observedAt?: InputMaybe<Scalars['Float']>;
  previousId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  units?: InputMaybe<Scalars['String']>;
  updatePending?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<Scalars['Float']>;
};

export type FilterCountWindManagementSystemVibrationLevelInput = {
  id?: InputMaybe<Scalars['String']>;
  observedAt?: InputMaybe<Scalars['Float']>;
  previousId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  units?: InputMaybe<Scalars['String']>;
  updatePending?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<Scalars['Float']>;
};

export type FilterCountWindManagementSystemWindDirectionInput = {
  id?: InputMaybe<Scalars['String']>;
  observedAt?: InputMaybe<Scalars['Float']>;
  previousId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  units?: InputMaybe<Scalars['String']>;
  updatePending?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<Scalars['Float']>;
};

export type FilterCountWindManagementSystemWindSpeedInput = {
  id?: InputMaybe<Scalars['String']>;
  observedAt?: InputMaybe<Scalars['Float']>;
  previousId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  units?: InputMaybe<Scalars['String']>;
  updatePending?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<Scalars['Float']>;
};

export type FilterCountWindManagementSystemYawControlStatusInput = {
  id?: InputMaybe<Scalars['String']>;
  observedAt?: InputMaybe<Scalars['Float']>;
  previousId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  units?: InputMaybe<Scalars['String']>;
  updatePending?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<EnumWindManagementSystemYawControlStatusValue>;
};

export type FilterCountWindowSensorContactStateInput = {
  id?: InputMaybe<Scalars['String']>;
  observedAt?: InputMaybe<Scalars['Float']>;
  previousId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  units?: InputMaybe<Scalars['String']>;
  updatePending?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<Scalars['String']>;
};

export type FilterCountWindowSensorInput = {
  AND?: InputMaybe<Array<FilterCountDeviceInput>>;
  OR?: InputMaybe<Array<FilterCountDeviceInput>>;
  _id?: InputMaybe<Scalars['String']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterCountDeviceOperatorsInput>;
  alertTypes?: InputMaybe<FilterCountDeviceAlertTypesInput>;
  contactState?: InputMaybe<FilterCountWindowSensorContactStateInput>;
  controlled?: InputMaybe<FilterCountDeviceControlledInput>;
  deviceId?: InputMaybe<Scalars['String']>;
  installation?: InputMaybe<FilterCountDeviceInstallationInput>;
  location?: InputMaybe<Scalars['String']>;
  meta?: InputMaybe<FilterCountDeviceMetaInput>;
  /** The name of the device */
  name?: InputMaybe<Scalars['String']>;
  panelId?: InputMaybe<Scalars['String']>;
  powerState?: InputMaybe<FilterCountDevicePowerStateInput>;
  propertyId?: InputMaybe<Scalars['String']>;
  sourceId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  unitId?: InputMaybe<Scalars['String']>;
  updateStatus?: InputMaybe<Scalars['Boolean']>;
  voltage?: InputMaybe<FilterCountWindowSensorVoltageInput>;
  vppId?: InputMaybe<Scalars['String']>;
  zoneId?: InputMaybe<Scalars['String']>;
};

export type FilterCountWindowSensorVoltageInput = {
  id?: InputMaybe<Scalars['String']>;
  observedAt?: InputMaybe<Scalars['Float']>;
  previousId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  units?: InputMaybe<Scalars['String']>;
  updatePending?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<Scalars['Float']>;
};

export type FilterCountZ210PumpActivePumpInput = {
  id?: InputMaybe<Scalars['String']>;
  previousId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  units?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<Scalars['Float']>;
};

export type FilterCountZ210PumpCurrentSpeedInput = {
  id?: InputMaybe<Scalars['String']>;
  observedAt?: InputMaybe<Scalars['Float']>;
  previousId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  units?: InputMaybe<Scalars['String']>;
  updatePending?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<Scalars['Float']>;
};

export type FilterCountZ210PumpInput = {
  AND?: InputMaybe<Array<FilterCountDeviceInput>>;
  OR?: InputMaybe<Array<FilterCountDeviceInput>>;
  _id?: InputMaybe<Scalars['String']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterCountDeviceOperatorsInput>;
  activePump?: InputMaybe<FilterCountZ210PumpActivePumpInput>;
  alertTypes?: InputMaybe<FilterCountDeviceAlertTypesInput>;
  controlled?: InputMaybe<FilterCountDeviceControlledInput>;
  currentSpeed?: InputMaybe<FilterCountZ210PumpCurrentSpeedInput>;
  deviceId?: InputMaybe<Scalars['String']>;
  installation?: InputMaybe<FilterCountDeviceInstallationInput>;
  location?: InputMaybe<Scalars['String']>;
  meta?: InputMaybe<FilterCountDeviceMetaInput>;
  /** The name of the device */
  name?: InputMaybe<Scalars['String']>;
  panelId?: InputMaybe<Scalars['String']>;
  powerState?: InputMaybe<FilterCountDevicePowerStateInput>;
  propertyId?: InputMaybe<Scalars['String']>;
  role?: InputMaybe<Scalars['String']>;
  sourceId?: InputMaybe<Scalars['String']>;
  targetSpeed?: InputMaybe<FilterCountZ210PumpTargetSpeedInput>;
  timestamp?: InputMaybe<Scalars['Float']>;
  unitId?: InputMaybe<Scalars['String']>;
  updateStatus?: InputMaybe<Scalars['Boolean']>;
  vppId?: InputMaybe<Scalars['String']>;
  zoneId?: InputMaybe<Scalars['String']>;
};

export type FilterCountZ210PumpTargetSpeedInput = {
  id?: InputMaybe<Scalars['String']>;
  observedAt?: InputMaybe<Scalars['Float']>;
  previousId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  units?: InputMaybe<Scalars['String']>;
  updatePending?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<Scalars['Float']>;
};

export type FilterCountZoneInput = {
  AND?: InputMaybe<Array<FilterCountZoneInput>>;
  OR?: InputMaybe<Array<FilterCountZoneInput>>;
  _id?: InputMaybe<Scalars['String']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterCountZoneOperatorsInput>;
  airHandlerId?: InputMaybe<Scalars['String']>;
  bngSourceId?: InputMaybe<Scalars['String']>;
  controller?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  pairedSensorId?: InputMaybe<Scalars['String']>;
  propertyId?: InputMaybe<Scalars['String']>;
  role?: InputMaybe<Scalars['String']>;
  sourceId?: InputMaybe<Scalars['String']>;
  thermostatId?: InputMaybe<Scalars['String']>;
  unitId?: InputMaybe<Scalars['String']>;
  zonePolicyId?: InputMaybe<Scalars['String']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterCountZoneOperatorsInput = {
  _id?: InputMaybe<FilterCountZone_IdOperatorsInput>;
  propertyId?: InputMaybe<FilterCountZonePropertyIdOperatorsInput>;
  unitId?: InputMaybe<FilterCountZoneUnitIdOperatorsInput>;
};

export type FilterCountZonePolicyInput = {
  AND?: InputMaybe<Array<FilterCountZonePolicyInput>>;
  OR?: InputMaybe<Array<FilterCountZonePolicyInput>>;
  _id?: InputMaybe<Scalars['MongoID']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterCountZonePolicyOperatorsInput>;
  name?: InputMaybe<Scalars['String']>;
  properties?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  rules?: InputMaybe<Array<InputMaybe<FilterCountZonePolicyRulesInput>>>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterCountZonePolicyOperatorsInput = {
  _id?: InputMaybe<FilterCountZonePolicy_IdOperatorsInput>;
};

export type FilterCountZonePolicyRulesInput = {
  source?: InputMaybe<FilterCountZonePolicyRulesSourceInput>;
  target?: InputMaybe<FilterCountZonePolicyRulesTargetInput>;
  type?: InputMaybe<EnumZonePolicyRulesType>;
};

export type FilterCountZonePolicyRulesSourceAttributesInput = {
  contactState?: InputMaybe<Scalars['String']>;
  coolSetpoint?: InputMaybe<Scalars['String']>;
  fanSpeed?: InputMaybe<Scalars['String']>;
  heatSetpoint?: InputMaybe<Scalars['String']>;
  indoorFanStatus?: InputMaybe<Scalars['String']>;
  keypadLockoutLevel?: InputMaybe<Scalars['String']>;
  operatingMode?: InputMaybe<Scalars['String']>;
  operatingState?: InputMaybe<Scalars['String']>;
};

export type FilterCountZonePolicyRulesSourceInput = {
  attributes?: InputMaybe<FilterCountZonePolicyRulesSourceAttributesInput>;
  deviceType?: InputMaybe<Scalars['String']>;
  multiplicity?: InputMaybe<EnumZonePolicyRulesSourceMultiplicity>;
};

export type FilterCountZonePolicyRulesTargetAttributesInput = {
  coolSetpoint?: InputMaybe<Scalars['String']>;
  heatSetpoint?: InputMaybe<Scalars['String']>;
  isOn?: InputMaybe<Scalars['String']>;
  keypadLockoutLevel?: InputMaybe<Scalars['String']>;
  relayState?: InputMaybe<Scalars['String']>;
};

export type FilterCountZonePolicyRulesTargetInput = {
  attributes?: InputMaybe<FilterCountZonePolicyRulesTargetAttributesInput>;
  deviceType?: InputMaybe<Scalars['String']>;
  multiplicity?: InputMaybe<EnumZonePolicyRulesTargetMultiplicity>;
};

export type FilterCountZonePolicy_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['MongoID']>;
  gte?: InputMaybe<Scalars['MongoID']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']>>>;
  lt?: InputMaybe<Scalars['MongoID']>;
  lte?: InputMaybe<Scalars['MongoID']>;
  ne?: InputMaybe<Scalars['MongoID']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']>>>;
};

export type FilterCountZonePropertyIdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['String']>;
  gte?: InputMaybe<Scalars['String']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  lt?: InputMaybe<Scalars['String']>;
  lte?: InputMaybe<Scalars['String']>;
  ne?: InputMaybe<Scalars['String']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']>;
};

export type FilterCountZoneUnitIdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['String']>;
  gte?: InputMaybe<Scalars['String']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  lt?: InputMaybe<Scalars['String']>;
  lte?: InputMaybe<Scalars['String']>;
  ne?: InputMaybe<Scalars['String']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']>;
};

export type FilterCountZone_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['String']>;
  gte?: InputMaybe<Scalars['String']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  lt?: InputMaybe<Scalars['String']>;
  lte?: InputMaybe<Scalars['String']>;
  ne?: InputMaybe<Scalars['String']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']>;
};

export type FilterFindManyActuatorControlModeInput = {
  id?: InputMaybe<Scalars['String']>;
  observedAt?: InputMaybe<Scalars['Float']>;
  previousId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  units?: InputMaybe<Scalars['String']>;
  updatePending?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<EnumActuatorControlModeValue>;
};

export type FilterFindManyActuatorDefaultPositionInput = {
  id?: InputMaybe<Scalars['String']>;
  observedAt?: InputMaybe<Scalars['Float']>;
  previousId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  units?: InputMaybe<Scalars['String']>;
  updatePending?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<Scalars['Float']>;
};

export type FilterFindManyActuatorInput = {
  AND?: InputMaybe<Array<FilterFindManyDeviceInput>>;
  OR?: InputMaybe<Array<FilterFindManyDeviceInput>>;
  _id?: InputMaybe<Scalars['String']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterFindManyDeviceOperatorsInput>;
  alertTypes?: InputMaybe<FilterFindManyDeviceAlertTypesInput>;
  controlMode?: InputMaybe<FilterFindManyActuatorControlModeInput>;
  controlled?: InputMaybe<FilterFindManyDeviceControlledInput>;
  defaultPosition?: InputMaybe<FilterFindManyActuatorDefaultPositionInput>;
  deviceId?: InputMaybe<Scalars['String']>;
  installation?: InputMaybe<FilterFindManyDeviceInstallationInput>;
  location?: InputMaybe<Scalars['String']>;
  meta?: InputMaybe<FilterFindManyDeviceMetaInput>;
  /** The name of the device */
  name?: InputMaybe<Scalars['String']>;
  panelId?: InputMaybe<Scalars['String']>;
  position?: InputMaybe<FilterFindManyActuatorPositionInput>;
  powerState?: InputMaybe<FilterFindManyDevicePowerStateInput>;
  propertyId?: InputMaybe<Scalars['String']>;
  sourceId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  unitId?: InputMaybe<Scalars['String']>;
  updateStatus?: InputMaybe<Scalars['Boolean']>;
  vppId?: InputMaybe<Scalars['String']>;
  zoneId?: InputMaybe<Scalars['String']>;
};

export type FilterFindManyActuatorPositionInput = {
  id?: InputMaybe<Scalars['String']>;
  observedAt?: InputMaybe<Scalars['Float']>;
  previousId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  units?: InputMaybe<Scalars['String']>;
  updatePending?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<Scalars['Float']>;
};

export type FilterFindManyAlertAlertCategoryInput = {
  id?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
};

export type FilterFindManyAlertAlertTriggerInput = {
  id?: InputMaybe<Scalars['String']>;
  key?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
};

export type FilterFindManyAlertBuildingInput = {
  id?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
};

export type FilterFindManyAlertCategoryInput = {
  AND?: InputMaybe<Array<FilterFindManyAlertCategoryInput>>;
  OR?: InputMaybe<Array<FilterFindManyAlertCategoryInput>>;
  _id?: InputMaybe<Scalars['String']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterFindManyAlertCategoryOperatorsInput>;
  description?: InputMaybe<Scalars['String']>;
  key?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  propertyId?: InputMaybe<Scalars['String']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterFindManyAlertCategoryOperatorsInput = {
  _id?: InputMaybe<FilterFindManyAlertCategory_IdOperatorsInput>;
  propertyId?: InputMaybe<FilterFindManyAlertCategoryPropertyIdOperatorsInput>;
};

export type FilterFindManyAlertCategoryPropertyIdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['String']>;
  gte?: InputMaybe<Scalars['String']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  lt?: InputMaybe<Scalars['String']>;
  lte?: InputMaybe<Scalars['String']>;
  ne?: InputMaybe<Scalars['String']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']>;
};

export type FilterFindManyAlertCategory_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['String']>;
  gte?: InputMaybe<Scalars['String']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  lt?: InputMaybe<Scalars['String']>;
  lte?: InputMaybe<Scalars['String']>;
  ne?: InputMaybe<Scalars['String']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']>;
};

export type FilterFindManyAlertDeviceInput = {
  id?: InputMaybe<Scalars['String']>;
  model?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  role?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<Scalars['String']>;
  version?: InputMaybe<Scalars['String']>;
};

export type FilterFindManyAlertInput = {
  AND?: InputMaybe<Array<FilterFindManyAlertInput>>;
  OR?: InputMaybe<Array<FilterFindManyAlertInput>>;
  _id?: InputMaybe<Scalars['String']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterFindManyAlertOperatorsInput>;
  alertCategory?: InputMaybe<FilterFindManyAlertAlertCategoryInput>;
  alertTrigger?: InputMaybe<FilterFindManyAlertAlertTriggerInput>;
  building?: InputMaybe<FilterFindManyAlertBuildingInput>;
  device?: InputMaybe<FilterFindManyAlertDeviceInput>;
  id?: InputMaybe<Scalars['String']>;
  initiated?: InputMaybe<Scalars['Float']>;
  meta?: InputMaybe<FilterFindManyAlertMetaInput>;
  panel?: InputMaybe<FilterFindManyAlertPanelInput>;
  property?: InputMaybe<FilterFindManyAlertPropertyInput>;
  sourceId?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<FilterFindManyAlertTypeInput>;
  unit?: InputMaybe<FilterFindManyAlertUnitInput>;
  updated?: InputMaybe<Scalars['Float']>;
  zone?: InputMaybe<FilterFindManyAlertZoneInput>;
};

export type FilterFindManyAlertMetaInput = {
  id_str?: InputMaybe<Scalars['String']>;
  limit?: InputMaybe<Scalars['Float']>;
  message?: InputMaybe<Scalars['String']>;
  portName?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<Scalars['String']>;
};

export type FilterFindManyAlertNotificationAlertIdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['String']>;
  gte?: InputMaybe<Scalars['String']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  lt?: InputMaybe<Scalars['String']>;
  lte?: InputMaybe<Scalars['String']>;
  ne?: InputMaybe<Scalars['String']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']>;
};

export type FilterFindManyAlertNotificationInput = {
  AND?: InputMaybe<Array<FilterFindManyAlertNotificationInput>>;
  OR?: InputMaybe<Array<FilterFindManyAlertNotificationInput>>;
  _id?: InputMaybe<Scalars['String']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterFindManyAlertNotificationOperatorsInput>;
  alertId?: InputMaybe<Scalars['String']>;
  deliveryAttemptCount?: InputMaybe<Scalars['Float']>;
  externalId?: InputMaybe<Scalars['String']>;
  lastDeliveryAttemptStatus?: InputMaybe<EnumAlertNotificationLastDeliveryAttemptStatus>;
  lastDeliveryAttemptTimestamp?: InputMaybe<Scalars['Float']>;
  notificationMethod?: InputMaybe<EnumAlertNotificationNotificationMethod>;
  notificationType?: InputMaybe<EnumAlertNotificationNotificationType>;
  recipient?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterFindManyAlertNotificationOperatorsInput = {
  _id?: InputMaybe<FilterFindManyAlertNotification_IdOperatorsInput>;
  alertId?: InputMaybe<FilterFindManyAlertNotificationAlertIdOperatorsInput>;
};

export type FilterFindManyAlertNotification_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['String']>;
  gte?: InputMaybe<Scalars['String']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  lt?: InputMaybe<Scalars['String']>;
  lte?: InputMaybe<Scalars['String']>;
  ne?: InputMaybe<Scalars['String']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterFindManyAlertOperatorsInput = {
  _id?: InputMaybe<FilterFindManyAlert_IdOperatorsInput>;
  property?: InputMaybe<FilterFindManyAlertPropertyOperatorsInput>;
  unit?: InputMaybe<FilterFindManyAlertUnitOperatorsInput>;
};

export type FilterFindManyAlertOptOutInput = {
  AND?: InputMaybe<Array<FilterFindManyAlertOptOutInput>>;
  OR?: InputMaybe<Array<FilterFindManyAlertOptOutInput>>;
  _id?: InputMaybe<Scalars['String']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterFindManyAlertOptOutOperatorsInput>;
  optOutMethod?: InputMaybe<EnumAlertOptOutOptOutMethod>;
  optOutTimestamp?: InputMaybe<Scalars['Float']>;
  recipient?: InputMaybe<Scalars['String']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterFindManyAlertOptOutOperatorsInput = {
  _id?: InputMaybe<FilterFindManyAlertOptOut_IdOperatorsInput>;
  recipient?: InputMaybe<FilterFindManyAlertOptOutRecipientOperatorsInput>;
};

export type FilterFindManyAlertOptOutRecipientOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['String']>;
  gte?: InputMaybe<Scalars['String']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  lt?: InputMaybe<Scalars['String']>;
  lte?: InputMaybe<Scalars['String']>;
  ne?: InputMaybe<Scalars['String']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']>;
};

export type FilterFindManyAlertOptOut_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['String']>;
  gte?: InputMaybe<Scalars['String']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  lt?: InputMaybe<Scalars['String']>;
  lte?: InputMaybe<Scalars['String']>;
  ne?: InputMaybe<Scalars['String']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']>;
};

export type FilterFindManyAlertPanelInput = {
  id?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
};

export type FilterFindManyAlertPropertyContactInput = {
  email?: InputMaybe<Scalars['String']>;
  email2?: InputMaybe<Scalars['String']>;
  email3?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  smsNumber?: InputMaybe<Scalars['String']>;
  smsNumber2?: InputMaybe<Scalars['String']>;
  smsNumber3?: InputMaybe<Scalars['String']>;
  smsOptInStatus1?: InputMaybe<EnumAlertPropertyContactSmsOptInStatus1>;
  smsOptInStatus2?: InputMaybe<EnumAlertPropertyContactSmsOptInStatus2>;
  smsOptInStatus3?: InputMaybe<EnumAlertPropertyContactSmsOptInStatus3>;
  smsOptInTimestamp1?: InputMaybe<Scalars['Float']>;
  smsOptInTimestamp2?: InputMaybe<Scalars['Float']>;
  smsOptInTimestamp3?: InputMaybe<Scalars['Float']>;
};

export type FilterFindManyAlertPropertyIdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['String']>;
  gte?: InputMaybe<Scalars['String']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  lt?: InputMaybe<Scalars['String']>;
  lte?: InputMaybe<Scalars['String']>;
  ne?: InputMaybe<Scalars['String']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']>;
};

export type FilterFindManyAlertPropertyInput = {
  contact?: InputMaybe<FilterFindManyAlertPropertyContactInput>;
  id?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
};

export type FilterFindManyAlertPropertyOperatorsInput = {
  id?: InputMaybe<FilterFindManyAlertPropertyIdOperatorsInput>;
};

export type FilterFindManyAlertSubscriptionAlertTriggerIdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['String']>;
  gte?: InputMaybe<Scalars['String']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  lt?: InputMaybe<Scalars['String']>;
  lte?: InputMaybe<Scalars['String']>;
  ne?: InputMaybe<Scalars['String']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']>;
};

export type FilterFindManyAlertSubscriptionInput = {
  AND?: InputMaybe<Array<FilterFindManyAlertSubscriptionInput>>;
  OR?: InputMaybe<Array<FilterFindManyAlertSubscriptionInput>>;
  _id?: InputMaybe<Scalars['String']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterFindManyAlertSubscriptionOperatorsInput>;
  alertTriggerId?: InputMaybe<Scalars['String']>;
  deviceId?: InputMaybe<Scalars['String']>;
  email?: InputMaybe<Scalars['String']>;
  propertyId?: InputMaybe<Scalars['String']>;
  sms?: InputMaybe<Scalars['String']>;
  unitCategoryId?: InputMaybe<Scalars['String']>;
  unitId?: InputMaybe<Scalars['String']>;
  userId?: InputMaybe<Scalars['String']>;
  viaEmail?: InputMaybe<Scalars['Boolean']>;
  viaSms?: InputMaybe<Scalars['Boolean']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterFindManyAlertSubscriptionOperatorsInput = {
  _id?: InputMaybe<FilterFindManyAlertSubscription_IdOperatorsInput>;
  alertTriggerId?: InputMaybe<FilterFindManyAlertSubscriptionAlertTriggerIdOperatorsInput>;
};

export type FilterFindManyAlertSubscription_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['String']>;
  gte?: InputMaybe<Scalars['String']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  lt?: InputMaybe<Scalars['String']>;
  lte?: InputMaybe<Scalars['String']>;
  ne?: InputMaybe<Scalars['String']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']>;
};

export type FilterFindManyAlertTriggerInput = {
  AND?: InputMaybe<Array<FilterFindManyAlertTriggerInput>>;
  OR?: InputMaybe<Array<FilterFindManyAlertTriggerInput>>;
  _id?: InputMaybe<Scalars['String']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterFindManyAlertTriggerOperatorsInput>;
  alertCategoryId?: InputMaybe<Scalars['String']>;
  editMode?: InputMaybe<Scalars['Float']>;
  enabled?: InputMaybe<Scalars['Boolean']>;
  entityTypes?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  key?: InputMaybe<Scalars['String']>;
  legacyKey?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  propertyId?: InputMaybe<Scalars['String']>;
  triggerCriteria?: InputMaybe<FilterFindManyAlertTriggerTriggerCriteriaInput>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterFindManyAlertTriggerOperatorsInput = {
  _id?: InputMaybe<FilterFindManyAlertTrigger_IdOperatorsInput>;
  propertyId?: InputMaybe<FilterFindManyAlertTriggerPropertyIdOperatorsInput>;
};

export type FilterFindManyAlertTriggerPropertyIdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['String']>;
  gte?: InputMaybe<Scalars['String']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  lt?: InputMaybe<Scalars['String']>;
  lte?: InputMaybe<Scalars['String']>;
  ne?: InputMaybe<Scalars['String']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']>;
};

export type FilterFindManyAlertTriggerTriggerCriteriaInput = {
  basisName?: InputMaybe<Scalars['String']>;
  basisType?: InputMaybe<EnumAlertTriggerTriggerCriteriaBasisType>;
  levels?: InputMaybe<Scalars['Float']>;
  selectionCriteria?: InputMaybe<FilterFindManyAlertTriggerTriggerCriteriaSelectionCriteriaInput>;
};

export type FilterFindManyAlertTriggerTriggerCriteriaSelectionCriteriaCompoundOperatorInput =
  {
    criteria?: InputMaybe<Scalars['JSON']>;
    id?: InputMaybe<Scalars['String']>;
    operator?: InputMaybe<EnumAlertTriggerTriggerCriteriaSelectionCriteriaCompoundOperatorOperator>;
  };

export type FilterFindManyAlertTriggerTriggerCriteriaSelectionCriteriaCriterionInput =
  {
    comparator: EnumAlertTriggerTriggerCriteriaSelectionCriteriaCriterionComparator;
    editable?: InputMaybe<Scalars['Boolean']>;
    id: Scalars['String'];
    legacyPath?: InputMaybe<Scalars['String']>;
    selectionPath: Scalars['String'];
    template?: InputMaybe<Scalars['String']>;
    valueType: EnumAlertTriggerTriggerCriteriaSelectionCriteriaCriterionValueType;
    values: Array<InputMaybe<Scalars['String']>>;
  };

export type FilterFindManyAlertTriggerTriggerCriteriaSelectionCriteriaInput = {
  compoundOperator?: InputMaybe<FilterFindManyAlertTriggerTriggerCriteriaSelectionCriteriaCompoundOperatorInput>;
  criteria?: InputMaybe<
    Array<
      InputMaybe<FilterFindManyAlertTriggerTriggerCriteriaSelectionCriteriaCriterionInput>
    >
  >;
  criterion?: InputMaybe<FilterFindManyAlertTriggerTriggerCriteriaSelectionCriteriaCriterionInput>;
  simpleOperator?: InputMaybe<FilterFindManyAlertTriggerTriggerCriteriaSelectionCriteriaSimpleOperatorInput>;
};

export type FilterFindManyAlertTriggerTriggerCriteriaSelectionCriteriaSimpleOperatorInput =
  {
    criteria?: InputMaybe<
      Array<
        InputMaybe<FilterFindManyAlertTriggerTriggerCriteriaSelectionCriteriaCriterionInput>
      >
    >;
    criterion?: InputMaybe<FilterFindManyAlertTriggerTriggerCriteriaSelectionCriteriaCriterionInput>;
    id?: InputMaybe<Scalars['String']>;
    operator?: InputMaybe<EnumAlertTriggerTriggerCriteriaSelectionCriteriaSimpleOperatorOperator>;
  };

export type FilterFindManyAlertTrigger_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['String']>;
  gte?: InputMaybe<Scalars['String']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  lt?: InputMaybe<Scalars['String']>;
  lte?: InputMaybe<Scalars['String']>;
  ne?: InputMaybe<Scalars['String']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']>;
};

export type FilterFindManyAlertTypeInput = {
  id?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
};

export type FilterFindManyAlertUnitIdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['String']>;
  gte?: InputMaybe<Scalars['String']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  lt?: InputMaybe<Scalars['String']>;
  lte?: InputMaybe<Scalars['String']>;
  ne?: InputMaybe<Scalars['String']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']>;
};

export type FilterFindManyAlertUnitInput = {
  id?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
};

export type FilterFindManyAlertUnitOperatorsInput = {
  id?: InputMaybe<FilterFindManyAlertUnitIdOperatorsInput>;
};

export type FilterFindManyAlertZoneInput = {
  id?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
};

export type FilterFindManyAlert_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['String']>;
  gte?: InputMaybe<Scalars['String']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  lt?: InputMaybe<Scalars['String']>;
  lte?: InputMaybe<Scalars['String']>;
  ne?: InputMaybe<Scalars['String']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']>;
};

export type FilterFindManyAuthenticationProfileFactorsInput = {
  _id?: InputMaybe<Scalars['String']>;
  credentialBoundTo?: InputMaybe<Scalars['String']>;
  engine?: InputMaybe<EnumAuthenticationProfileFactorsEngine>;
  externalId?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  order?: InputMaybe<Scalars['Float']>;
  preferred?: InputMaybe<Scalars['Boolean']>;
  primary?: InputMaybe<Scalars['Boolean']>;
  sufficient?: InputMaybe<Scalars['Boolean']>;
  type?: InputMaybe<EnumAuthenticationProfileFactorsType>;
  value?: InputMaybe<Scalars['String']>;
};

export type FilterFindManyAuthenticationProfileInitialFactorsInput = {
  _id?: InputMaybe<Scalars['String']>;
  autoSatisfy?: InputMaybe<Scalars['Boolean']>;
  credentialBoundTo?: InputMaybe<Scalars['String']>;
  endpointId?: InputMaybe<Scalars['String']>;
  engine?: InputMaybe<EnumAuthenticationProfileInitialFactorsEngine>;
  expiration?: InputMaybe<Scalars['Float']>;
  factorId?: InputMaybe<Scalars['String']>;
};

export type FilterFindManyAuthenticationProfileInput = {
  AND?: InputMaybe<Array<FilterFindManyAuthenticationProfileInput>>;
  OR?: InputMaybe<Array<FilterFindManyAuthenticationProfileInput>>;
  _id?: InputMaybe<Scalars['String']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterFindManyAuthenticationProfileOperatorsInput>;
  currentChallenge?: InputMaybe<Scalars['String']>;
  currentChallengeExpiresAt?: InputMaybe<Scalars['Float']>;
  externalId?: InputMaybe<Scalars['String']>;
  factors?: InputMaybe<
    Array<InputMaybe<FilterFindManyAuthenticationProfileFactorsInput>>
  >;
  failedAttempts?: InputMaybe<Scalars['Float']>;
  initialFactors?: InputMaybe<
    Array<InputMaybe<FilterFindManyAuthenticationProfileInitialFactorsInput>>
  >;
  lastFailedLogin?: InputMaybe<Scalars['Float']>;
  lastLogin?: InputMaybe<Scalars['Float']>;
  lockedAt?: InputMaybe<Scalars['Float']>;
  userId?: InputMaybe<Scalars['String']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterFindManyAuthenticationProfileOperatorsInput = {
  _id?: InputMaybe<FilterFindManyAuthenticationProfile_IdOperatorsInput>;
};

export type FilterFindManyAuthenticationProfile_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['String']>;
  gte?: InputMaybe<Scalars['String']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  lt?: InputMaybe<Scalars['String']>;
  lte?: InputMaybe<Scalars['String']>;
  ne?: InputMaybe<Scalars['String']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']>;
};

export type FilterFindManyAuthenticatorDeviceInput = {
  AND?: InputMaybe<Array<FilterFindManyAuthenticatorDeviceInput>>;
  OR?: InputMaybe<Array<FilterFindManyAuthenticatorDeviceInput>>;
  _id?: InputMaybe<Scalars['String']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterFindManyAuthenticatorDeviceOperatorsInput>;
  aaguid?: InputMaybe<Scalars['String']>;
  counter?: InputMaybe<Scalars['Float']>;
  createdAt?: InputMaybe<Scalars['Float']>;
  credentialBackedUp?: InputMaybe<Scalars['Boolean']>;
  credentialBoundTo?: InputMaybe<Scalars['String']>;
  credentialDeviceType?: InputMaybe<Scalars['String']>;
  credentialEcosystem?: InputMaybe<EnumAuthenticatorDeviceCredentialEcosystem>;
  credentialID?: InputMaybe<Scalars['Buffer']>;
  credentialIsExternal?: InputMaybe<Scalars['Boolean']>;
  credentialOS?: InputMaybe<EnumAuthenticatorDeviceCredentialOs>;
  credentialPublicKey?: InputMaybe<Scalars['Buffer']>;
  credentialType?: InputMaybe<Scalars['String']>;
  deviceName?: InputMaybe<Scalars['String']>;
  deviceType?: InputMaybe<Scalars['String']>;
  endpointId?: InputMaybe<Scalars['String']>;
  enforceUserVerification?: InputMaybe<Scalars['Boolean']>;
  lastUsed?: InputMaybe<Scalars['Float']>;
  transports?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  userId?: InputMaybe<Scalars['String']>;
  userVerified?: InputMaybe<Scalars['Boolean']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterFindManyAuthenticatorDeviceOperatorsInput = {
  _id?: InputMaybe<FilterFindManyAuthenticatorDevice_IdOperatorsInput>;
  userId?: InputMaybe<FilterFindManyAuthenticatorDeviceUserIdOperatorsInput>;
};

export type FilterFindManyAuthenticatorDeviceUserIdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['String']>;
  gte?: InputMaybe<Scalars['String']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  lt?: InputMaybe<Scalars['String']>;
  lte?: InputMaybe<Scalars['String']>;
  ne?: InputMaybe<Scalars['String']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']>;
};

export type FilterFindManyAuthenticatorDevice_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['String']>;
  gte?: InputMaybe<Scalars['String']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  lt?: InputMaybe<Scalars['String']>;
  lte?: InputMaybe<Scalars['String']>;
  ne?: InputMaybe<Scalars['String']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']>;
};

export type FilterFindManyAuthorizationProfileInput = {
  AND?: InputMaybe<Array<FilterFindManyAuthorizationProfileInput>>;
  OR?: InputMaybe<Array<FilterFindManyAuthorizationProfileInput>>;
  _id?: InputMaybe<Scalars['String']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterFindManyAuthorizationProfileOperatorsInput>;
  apiToken?: InputMaybe<Scalars['String']>;
  currentChallenge?: InputMaybe<Scalars['String']>;
  currentChallengeExpiration?: InputMaybe<Scalars['Float']>;
  installerProperties?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  isInstaller?: InputMaybe<Scalars['Boolean']>;
  isManager?: InputMaybe<Scalars['Boolean']>;
  isResident?: InputMaybe<Scalars['Boolean']>;
  isSuper?: InputMaybe<Scalars['Boolean']>;
  isViewer?: InputMaybe<Scalars['Boolean']>;
  managerProperties?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  name?: InputMaybe<Scalars['String']>;
  residentProperty?: InputMaybe<Scalars['String']>;
  residentUnit?: InputMaybe<Scalars['String']>;
  userId?: InputMaybe<Scalars['String']>;
  viewerProperties?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterFindManyAuthorizationProfileOperatorsInput = {
  _id?: InputMaybe<FilterFindManyAuthorizationProfile_IdOperatorsInput>;
};

export type FilterFindManyAuthorizationProfile_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['String']>;
  gte?: InputMaybe<Scalars['String']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  lt?: InputMaybe<Scalars['String']>;
  lte?: InputMaybe<Scalars['String']>;
  ne?: InputMaybe<Scalars['String']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']>;
};

export type FilterFindManyBngInput = {
  AND?: InputMaybe<Array<FilterFindManySourceInput>>;
  OR?: InputMaybe<Array<FilterFindManySourceInput>>;
  _id?: InputMaybe<Scalars['String']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterFindManySourceOperatorsInput>;
  localUrl?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  propertyId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  url?: InputMaybe<Scalars['String']>;
};

export type FilterFindManyBatteryManagementSystemBatteryEfficiencyInput = {
  id?: InputMaybe<Scalars['String']>;
  observedAt?: InputMaybe<Scalars['Float']>;
  previousId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  units?: InputMaybe<Scalars['String']>;
  updatePending?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<Scalars['Float']>;
};

export type FilterFindManyBatteryManagementSystemCellCurrentsInput = {
  id?: InputMaybe<Scalars['String']>;
  observedAt?: InputMaybe<Scalars['Float']>;
  previousId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  units?: InputMaybe<Scalars['String']>;
  updatePending?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<Scalars['Float']>;
};

export type FilterFindManyBatteryManagementSystemCellCycleCountsInput = {
  id?: InputMaybe<Scalars['String']>;
  observedAt?: InputMaybe<Scalars['Float']>;
  previousId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  units?: InputMaybe<Scalars['String']>;
  updatePending?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<Scalars['Float']>;
};

export type FilterFindManyBatteryManagementSystemCellTemperaturesInput = {
  id?: InputMaybe<Scalars['String']>;
  observedAt?: InputMaybe<Scalars['Float']>;
  previousId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  units?: InputMaybe<Scalars['String']>;
  updatePending?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<Scalars['Float']>;
};

export type FilterFindManyBatteryManagementSystemCellVoltagesInput = {
  id?: InputMaybe<Scalars['String']>;
  observedAt?: InputMaybe<Scalars['Float']>;
  previousId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  units?: InputMaybe<Scalars['String']>;
  updatePending?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<Scalars['Float']>;
};

export type FilterFindManyBatteryManagementSystemCurrentInput = {
  id?: InputMaybe<Scalars['String']>;
  observedAt?: InputMaybe<Scalars['Float']>;
  previousId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  units?: InputMaybe<Scalars['String']>;
  updatePending?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<Scalars['Float']>;
};

export type FilterFindManyBatteryManagementSystemInput = {
  AND?: InputMaybe<Array<FilterFindManyDeviceInput>>;
  OR?: InputMaybe<Array<FilterFindManyDeviceInput>>;
  _id?: InputMaybe<Scalars['String']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterFindManyDeviceOperatorsInput>;
  alertTypes?: InputMaybe<FilterFindManyDeviceAlertTypesInput>;
  batteryEfficiency?: InputMaybe<FilterFindManyBatteryManagementSystemBatteryEfficiencyInput>;
  cellCurrents?: InputMaybe<
    Array<InputMaybe<FilterFindManyBatteryManagementSystemCellCurrentsInput>>
  >;
  cellCycleCounts?: InputMaybe<
    Array<InputMaybe<FilterFindManyBatteryManagementSystemCellCycleCountsInput>>
  >;
  cellTemperatures?: InputMaybe<
    Array<
      InputMaybe<FilterFindManyBatteryManagementSystemCellTemperaturesInput>
    >
  >;
  cellVoltages?: InputMaybe<
    Array<InputMaybe<FilterFindManyBatteryManagementSystemCellVoltagesInput>>
  >;
  controlled?: InputMaybe<FilterFindManyDeviceControlledInput>;
  current?: InputMaybe<FilterFindManyBatteryManagementSystemCurrentInput>;
  deviceId?: InputMaybe<Scalars['String']>;
  installation?: InputMaybe<FilterFindManyDeviceInstallationInput>;
  inverterId?: InputMaybe<Scalars['String']>;
  location?: InputMaybe<Scalars['String']>;
  meta?: InputMaybe<FilterFindManyDeviceMetaInput>;
  /** The name of the device */
  name?: InputMaybe<Scalars['String']>;
  panelId?: InputMaybe<Scalars['String']>;
  powerState?: InputMaybe<FilterFindManyDevicePowerStateInput>;
  propertyId?: InputMaybe<Scalars['String']>;
  sourceId?: InputMaybe<Scalars['String']>;
  stateOfCharge?: InputMaybe<FilterFindManyBatteryManagementSystemStateOfChargeInput>;
  stateOfHealth?: InputMaybe<FilterFindManyBatteryManagementSystemStateOfHealthInput>;
  temperature?: InputMaybe<FilterFindManyBatteryManagementSystemTemperatureInput>;
  timestamp?: InputMaybe<Scalars['Float']>;
  unitId?: InputMaybe<Scalars['String']>;
  updateStatus?: InputMaybe<Scalars['Boolean']>;
  voltage?: InputMaybe<FilterFindManyBatteryManagementSystemVoltageInput>;
  vppId?: InputMaybe<Scalars['String']>;
  zoneId?: InputMaybe<Scalars['String']>;
};

export type FilterFindManyBatteryManagementSystemStateOfChargeInput = {
  id?: InputMaybe<Scalars['String']>;
  observedAt?: InputMaybe<Scalars['Float']>;
  previousId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  units?: InputMaybe<Scalars['String']>;
  updatePending?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<Scalars['Float']>;
};

export type FilterFindManyBatteryManagementSystemStateOfHealthInput = {
  id?: InputMaybe<Scalars['String']>;
  observedAt?: InputMaybe<Scalars['Float']>;
  previousId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  units?: InputMaybe<Scalars['String']>;
  updatePending?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<Scalars['Float']>;
};

export type FilterFindManyBatteryManagementSystemTemperatureInput = {
  id?: InputMaybe<Scalars['String']>;
  observedAt?: InputMaybe<Scalars['Float']>;
  previousId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  units?: InputMaybe<Scalars['String']>;
  updatePending?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<Scalars['Float']>;
};

export type FilterFindManyBatteryManagementSystemVoltageInput = {
  id?: InputMaybe<Scalars['String']>;
  observedAt?: InputMaybe<Scalars['Float']>;
  previousId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  units?: InputMaybe<Scalars['String']>;
  updatePending?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<Scalars['Float']>;
};

export type FilterFindManyBoilerBoilerPumpSpeed1Input = {
  id?: InputMaybe<Scalars['String']>;
  observedAt?: InputMaybe<Scalars['Float']>;
  previousId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  units?: InputMaybe<Scalars['String']>;
  updatePending?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<Scalars['Float']>;
};

export type FilterFindManyBoilerBoilerPumpSpeed2Input = {
  id?: InputMaybe<Scalars['String']>;
  observedAt?: InputMaybe<Scalars['Float']>;
  previousId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  units?: InputMaybe<Scalars['String']>;
  updatePending?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<Scalars['Float']>;
};

export type FilterFindManyBoilerBoilerPumpSpeedInput = {
  id?: InputMaybe<Scalars['String']>;
  observedAt?: InputMaybe<Scalars['Float']>;
  previousId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  units?: InputMaybe<Scalars['String']>;
  updatePending?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<Scalars['Float']>;
};

export type FilterFindManyBoilerFiringRate1Input = {
  id?: InputMaybe<Scalars['String']>;
  observedAt?: InputMaybe<Scalars['Float']>;
  previousId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  units?: InputMaybe<Scalars['String']>;
  updatePending?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<Scalars['Float']>;
};

export type FilterFindManyBoilerFiringRate2Input = {
  id?: InputMaybe<Scalars['String']>;
  observedAt?: InputMaybe<Scalars['Float']>;
  previousId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  units?: InputMaybe<Scalars['String']>;
  updatePending?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<Scalars['Float']>;
};

export type FilterFindManyBoilerFiringRateInput = {
  id?: InputMaybe<Scalars['String']>;
  observedAt?: InputMaybe<Scalars['Float']>;
  previousId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  units?: InputMaybe<Scalars['String']>;
  updatePending?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<Scalars['Float']>;
};

export type FilterFindManyBoilerFlueTemperature1Input = {
  id?: InputMaybe<Scalars['String']>;
  observedAt?: InputMaybe<Scalars['Float']>;
  previousId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  units?: InputMaybe<Scalars['String']>;
  updatePending?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<Scalars['Float']>;
};

export type FilterFindManyBoilerFlueTemperature2Input = {
  id?: InputMaybe<Scalars['String']>;
  observedAt?: InputMaybe<Scalars['Float']>;
  previousId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  units?: InputMaybe<Scalars['String']>;
  updatePending?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<Scalars['Float']>;
};

export type FilterFindManyBoilerFlueTemperatureInput = {
  id?: InputMaybe<Scalars['String']>;
  observedAt?: InputMaybe<Scalars['Float']>;
  previousId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  units?: InputMaybe<Scalars['String']>;
  updatePending?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<Scalars['Float']>;
};

export type FilterFindManyBoilerInletTemperature1Input = {
  id?: InputMaybe<Scalars['String']>;
  observedAt?: InputMaybe<Scalars['Float']>;
  previousId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  units?: InputMaybe<Scalars['String']>;
  updatePending?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<Scalars['Float']>;
};

export type FilterFindManyBoilerInletTemperature2Input = {
  id?: InputMaybe<Scalars['String']>;
  observedAt?: InputMaybe<Scalars['Float']>;
  previousId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  units?: InputMaybe<Scalars['String']>;
  updatePending?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<Scalars['Float']>;
};

export type FilterFindManyBoilerInletTemperatureInput = {
  id?: InputMaybe<Scalars['String']>;
  observedAt?: InputMaybe<Scalars['Float']>;
  previousId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  units?: InputMaybe<Scalars['String']>;
  updatePending?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<Scalars['Float']>;
};

export type FilterFindManyBoilerInput = {
  AND?: InputMaybe<Array<FilterFindManyDeviceInput>>;
  OR?: InputMaybe<Array<FilterFindManyDeviceInput>>;
  _id?: InputMaybe<Scalars['String']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterFindManyDeviceOperatorsInput>;
  alertTypes?: InputMaybe<FilterFindManyDeviceAlertTypesInput>;
  boilerPumpSpeed?: InputMaybe<FilterFindManyBoilerBoilerPumpSpeedInput>;
  boilerPumpSpeed1?: InputMaybe<FilterFindManyBoilerBoilerPumpSpeed1Input>;
  boilerPumpSpeed2?: InputMaybe<FilterFindManyBoilerBoilerPumpSpeed2Input>;
  controlled?: InputMaybe<FilterFindManyDeviceControlledInput>;
  deviceId?: InputMaybe<Scalars['String']>;
  firingRate?: InputMaybe<FilterFindManyBoilerFiringRateInput>;
  firingRate1?: InputMaybe<FilterFindManyBoilerFiringRate1Input>;
  firingRate2?: InputMaybe<FilterFindManyBoilerFiringRate2Input>;
  flueTemperature?: InputMaybe<FilterFindManyBoilerFlueTemperatureInput>;
  flueTemperature1?: InputMaybe<FilterFindManyBoilerFlueTemperature1Input>;
  flueTemperature2?: InputMaybe<FilterFindManyBoilerFlueTemperature2Input>;
  inletTemperature?: InputMaybe<FilterFindManyBoilerInletTemperatureInput>;
  inletTemperature1?: InputMaybe<FilterFindManyBoilerInletTemperature1Input>;
  inletTemperature2?: InputMaybe<FilterFindManyBoilerInletTemperature2Input>;
  installation?: InputMaybe<FilterFindManyDeviceInstallationInput>;
  location?: InputMaybe<Scalars['String']>;
  meta?: InputMaybe<FilterFindManyDeviceMetaInput>;
  /** The name of the device */
  name?: InputMaybe<Scalars['String']>;
  outletTemperature?: InputMaybe<FilterFindManyBoilerOutletTemperatureInput>;
  outletTemperature1?: InputMaybe<FilterFindManyBoilerOutletTemperature1Input>;
  outletTemperature2?: InputMaybe<FilterFindManyBoilerOutletTemperature2Input>;
  panelId?: InputMaybe<Scalars['String']>;
  powerState?: InputMaybe<FilterFindManyDevicePowerStateInput>;
  propertyId?: InputMaybe<Scalars['String']>;
  role?: InputMaybe<Scalars['String']>;
  sourceId?: InputMaybe<Scalars['String']>;
  temperature?: InputMaybe<FilterFindManyBoilerTemperatureInput>;
  timestamp?: InputMaybe<Scalars['Float']>;
  unitId?: InputMaybe<Scalars['String']>;
  updateStatus?: InputMaybe<Scalars['Boolean']>;
  vppId?: InputMaybe<Scalars['String']>;
  zoneId?: InputMaybe<Scalars['String']>;
};

export type FilterFindManyBoilerOutletTemperature1Input = {
  id?: InputMaybe<Scalars['String']>;
  observedAt?: InputMaybe<Scalars['Float']>;
  previousId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  units?: InputMaybe<Scalars['String']>;
  updatePending?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<Scalars['Float']>;
};

export type FilterFindManyBoilerOutletTemperature2Input = {
  id?: InputMaybe<Scalars['String']>;
  observedAt?: InputMaybe<Scalars['Float']>;
  previousId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  units?: InputMaybe<Scalars['String']>;
  updatePending?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<Scalars['Float']>;
};

export type FilterFindManyBoilerOutletTemperatureInput = {
  id?: InputMaybe<Scalars['String']>;
  observedAt?: InputMaybe<Scalars['Float']>;
  previousId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  units?: InputMaybe<Scalars['String']>;
  updatePending?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<Scalars['Float']>;
};

export type FilterFindManyBoilerTemperatureInput = {
  id?: InputMaybe<Scalars['String']>;
  observedAt?: InputMaybe<Scalars['Float']>;
  previousId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  units?: InputMaybe<Scalars['String']>;
  updatePending?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<Scalars['Float']>;
};

export type FilterFindManyBuildingInput = {
  AND?: InputMaybe<Array<FilterFindManyBuildingInput>>;
  OR?: InputMaybe<Array<FilterFindManyBuildingInput>>;
  _id?: InputMaybe<Scalars['String']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterFindManyBuildingOperatorsInput>;
  name?: InputMaybe<Scalars['String']>;
  number?: InputMaybe<Scalars['Float']>;
  propertyId?: InputMaybe<Scalars['String']>;
  /** Constructs a regular expression search based on the string provided */
  withNameLike?: InputMaybe<Scalars['String']>;
};

export type FilterFindManyBuildingNameOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['String']>;
  gte?: InputMaybe<Scalars['String']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  lt?: InputMaybe<Scalars['String']>;
  lte?: InputMaybe<Scalars['String']>;
  ne?: InputMaybe<Scalars['String']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterFindManyBuildingOperatorsInput = {
  _id?: InputMaybe<FilterFindManyBuilding_IdOperatorsInput>;
  name?: InputMaybe<FilterFindManyBuildingNameOperatorsInput>;
};

export type FilterFindManyBuilding_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['String']>;
  gte?: InputMaybe<Scalars['String']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  lt?: InputMaybe<Scalars['String']>;
  lte?: InputMaybe<Scalars['String']>;
  ne?: InputMaybe<Scalars['String']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']>;
};

export type FilterFindManyChillerAmbientTemperatureInput = {
  id?: InputMaybe<Scalars['String']>;
  observedAt?: InputMaybe<Scalars['Float']>;
  previousId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  units?: InputMaybe<Scalars['String']>;
  updatePending?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<Scalars['Float']>;
};

export type FilterFindManyChillerChilledReturnTemperatureInput = {
  id?: InputMaybe<Scalars['String']>;
  observedAt?: InputMaybe<Scalars['Float']>;
  previousId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  units?: InputMaybe<Scalars['String']>;
  updatePending?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<Scalars['Float']>;
};

export type FilterFindManyChillerChilledSupplyTemperatureInput = {
  id?: InputMaybe<Scalars['String']>;
  observedAt?: InputMaybe<Scalars['Float']>;
  previousId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  units?: InputMaybe<Scalars['String']>;
  updatePending?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<Scalars['Float']>;
};

export type FilterFindManyChillerCoolSetpointInput = {
  id?: InputMaybe<Scalars['String']>;
  observedAt?: InputMaybe<Scalars['Float']>;
  previousId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  units?: InputMaybe<Scalars['String']>;
  updatePending?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<Scalars['Float']>;
};

export type FilterFindManyChillerInput = {
  AND?: InputMaybe<Array<FilterFindManyDeviceInput>>;
  OR?: InputMaybe<Array<FilterFindManyDeviceInput>>;
  _id?: InputMaybe<Scalars['String']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterFindManyDeviceOperatorsInput>;
  alertTypes?: InputMaybe<FilterFindManyDeviceAlertTypesInput>;
  ambientTemperature?: InputMaybe<FilterFindManyChillerAmbientTemperatureInput>;
  chilledReturnTemperature?: InputMaybe<FilterFindManyChillerChilledReturnTemperatureInput>;
  chilledSupplyTemperature?: InputMaybe<FilterFindManyChillerChilledSupplyTemperatureInput>;
  controlled?: InputMaybe<FilterFindManyDeviceControlledInput>;
  coolSetpoint?: InputMaybe<FilterFindManyChillerCoolSetpointInput>;
  deviceId?: InputMaybe<Scalars['String']>;
  installation?: InputMaybe<FilterFindManyDeviceInstallationInput>;
  location?: InputMaybe<Scalars['String']>;
  meta?: InputMaybe<FilterFindManyDeviceMetaInput>;
  /** The name of the device */
  name?: InputMaybe<Scalars['String']>;
  panelId?: InputMaybe<Scalars['String']>;
  powerState?: InputMaybe<FilterFindManyDevicePowerStateInput>;
  propertyId?: InputMaybe<Scalars['String']>;
  sourceId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  unitId?: InputMaybe<Scalars['String']>;
  updateStatus?: InputMaybe<Scalars['Boolean']>;
  vppId?: InputMaybe<Scalars['String']>;
  zoneId?: InputMaybe<Scalars['String']>;
};

export type FilterFindManyConductorGenericSensorAlarmStateInput = {
  id?: InputMaybe<Scalars['String']>;
  observedAt?: InputMaybe<Scalars['Float']>;
  previousId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  units?: InputMaybe<Scalars['String']>;
  updatePending?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<Scalars['Boolean']>;
};

export type FilterFindManyConductorGenericSensorCounterValueInput = {
  id?: InputMaybe<Scalars['String']>;
  observedAt?: InputMaybe<Scalars['Float']>;
  previousId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  units?: InputMaybe<Scalars['String']>;
  updatePending?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<Scalars['Float']>;
};

export type FilterFindManyConductorGenericSensorFanSpeedInput = {
  id?: InputMaybe<Scalars['String']>;
  observedAt?: InputMaybe<Scalars['Float']>;
  previousId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  units?: InputMaybe<Scalars['String']>;
  updatePending?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<Scalars['Float']>;
};

export type FilterFindManyConductorGenericSensorHumidityInput = {
  id?: InputMaybe<Scalars['String']>;
  observedAt?: InputMaybe<Scalars['Float']>;
  previousId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  units?: InputMaybe<Scalars['String']>;
  updatePending?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<Scalars['Float']>;
};

export type FilterFindManyConductorGenericSensorInput = {
  AND?: InputMaybe<Array<FilterFindManyDeviceInput>>;
  OR?: InputMaybe<Array<FilterFindManyDeviceInput>>;
  _id?: InputMaybe<Scalars['String']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterFindManyDeviceOperatorsInput>;
  alarmState?: InputMaybe<FilterFindManyConductorGenericSensorAlarmStateInput>;
  alertTypes?: InputMaybe<FilterFindManyDeviceAlertTypesInput>;
  controlled?: InputMaybe<FilterFindManyDeviceControlledInput>;
  counterValue?: InputMaybe<FilterFindManyConductorGenericSensorCounterValueInput>;
  deviceId?: InputMaybe<Scalars['String']>;
  fanSpeed?: InputMaybe<FilterFindManyConductorGenericSensorFanSpeedInput>;
  humidity?: InputMaybe<FilterFindManyConductorGenericSensorHumidityInput>;
  installation?: InputMaybe<FilterFindManyDeviceInstallationInput>;
  location?: InputMaybe<Scalars['String']>;
  meta?: InputMaybe<FilterFindManyDeviceMetaInput>;
  /** The name of the device */
  name?: InputMaybe<Scalars['String']>;
  panelId?: InputMaybe<Scalars['String']>;
  powerState?: InputMaybe<FilterFindManyDevicePowerStateInput>;
  propertyId?: InputMaybe<Scalars['String']>;
  resetCount?: InputMaybe<FilterFindManyConductorGenericSensorResetCountInput>;
  setpoint?: InputMaybe<FilterFindManyConductorGenericSensorSetpointInput>;
  sourceId?: InputMaybe<Scalars['String']>;
  systemMode?: InputMaybe<FilterFindManyConductorGenericSensorSystemModeInput>;
  temperature?: InputMaybe<FilterFindManyConductorGenericSensorTemperatureInput>;
  timestamp?: InputMaybe<Scalars['Float']>;
  unitId?: InputMaybe<Scalars['String']>;
  updateStatus?: InputMaybe<Scalars['Boolean']>;
  vppId?: InputMaybe<Scalars['String']>;
  zoneId?: InputMaybe<Scalars['String']>;
};

export type FilterFindManyConductorGenericSensorResetCountInput = {
  id?: InputMaybe<Scalars['String']>;
  observedAt?: InputMaybe<Scalars['Float']>;
  previousId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  units?: InputMaybe<Scalars['String']>;
  updatePending?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<Scalars['Float']>;
};

export type FilterFindManyConductorGenericSensorSetpointInput = {
  id?: InputMaybe<Scalars['String']>;
  observedAt?: InputMaybe<Scalars['Float']>;
  previousId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  units?: InputMaybe<Scalars['String']>;
  updatePending?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<Scalars['Float']>;
};

export type FilterFindManyConductorGenericSensorSystemModeInput = {
  id?: InputMaybe<Scalars['String']>;
  observedAt?: InputMaybe<Scalars['Float']>;
  previousId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  units?: InputMaybe<Scalars['String']>;
  updatePending?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<Scalars['Float']>;
};

export type FilterFindManyConductorGenericSensorTemperatureInput = {
  id?: InputMaybe<Scalars['String']>;
  observedAt?: InputMaybe<Scalars['Float']>;
  previousId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  units?: InputMaybe<Scalars['String']>;
  updatePending?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<Scalars['Float']>;
};

export type FilterFindManyConductorInput = {
  AND?: InputMaybe<Array<FilterFindManySourceInput>>;
  OR?: InputMaybe<Array<FilterFindManySourceInput>>;
  _id?: InputMaybe<Scalars['String']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterFindManySourceOperatorsInput>;
  buildingId?: InputMaybe<Scalars['String']>;
  conductorUniqueId?: InputMaybe<Scalars['String']>;
  lastDiscoveryMappingProposal?: InputMaybe<Scalars['JSON']>;
  lastDiscoveryResults?: InputMaybe<Scalars['JSON']>;
  lastDiscoveryResultsUrl?: InputMaybe<Scalars['String']>;
  lastDiscoveryRunId?: InputMaybe<Scalars['String']>;
  lastDiscoveryStatus?: InputMaybe<Scalars['String']>;
  lastDiscoveryStatusUrl?: InputMaybe<Scalars['String']>;
  maxReportingTime?: InputMaybe<Scalars['Float']>;
  name?: InputMaybe<Scalars['String']>;
  propertyId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  tolerances?: InputMaybe<FilterFindManyConductorTolerancesInput>;
  url?: InputMaybe<Scalars['String']>;
};

export type FilterFindManyConductorTolerancesInput = {
  humidity?: InputMaybe<Scalars['Float']>;
  temperature?: InputMaybe<Scalars['Float']>;
};

export type FilterFindManyControlGroupGroupedDevicesInput = {
  _id?: InputMaybe<Scalars['String']>;
  deviceId?: InputMaybe<Scalars['String']>;
  displayOrder?: InputMaybe<Scalars['Float']>;
  name?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<Scalars['String']>;
};

export type FilterFindManyControlGroupInput = {
  AND?: InputMaybe<Array<FilterFindManyControlGroupInput>>;
  OR?: InputMaybe<Array<FilterFindManyControlGroupInput>>;
  _id?: InputMaybe<Scalars['String']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterFindManyControlGroupOperatorsInput>;
  attributes?: InputMaybe<Scalars['JSON']>;
  automationEnabled?: InputMaybe<Scalars['Boolean']>;
  groupedDevices?: InputMaybe<
    Array<InputMaybe<FilterFindManyControlGroupGroupedDevicesInput>>
  >;
  masterDeviceId?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  propertyId?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<Scalars['String']>;
  unitId?: InputMaybe<Scalars['String']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterFindManyControlGroupOperatorsInput = {
  _id?: InputMaybe<FilterFindManyControlGroup_IdOperatorsInput>;
  propertyId?: InputMaybe<FilterFindManyControlGroupPropertyIdOperatorsInput>;
  unitId?: InputMaybe<FilterFindManyControlGroupUnitIdOperatorsInput>;
};

export type FilterFindManyControlGroupPropertyIdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['String']>;
  gte?: InputMaybe<Scalars['String']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  lt?: InputMaybe<Scalars['String']>;
  lte?: InputMaybe<Scalars['String']>;
  ne?: InputMaybe<Scalars['String']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']>;
};

export type FilterFindManyControlGroupUnitIdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['String']>;
  gte?: InputMaybe<Scalars['String']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  lt?: InputMaybe<Scalars['String']>;
  lte?: InputMaybe<Scalars['String']>;
  ne?: InputMaybe<Scalars['String']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']>;
};

export type FilterFindManyControlGroup_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['String']>;
  gte?: InputMaybe<Scalars['String']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  lt?: InputMaybe<Scalars['String']>;
  lte?: InputMaybe<Scalars['String']>;
  ne?: InputMaybe<Scalars['String']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']>;
};

export type FilterFindManyControllerActiveAlarmCountInput = {
  id?: InputMaybe<Scalars['String']>;
  observedAt?: InputMaybe<Scalars['Float']>;
  previousId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  units?: InputMaybe<Scalars['String']>;
  updatePending?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<Scalars['Float']>;
};

export type FilterFindManyControllerCommunicationStateInput = {
  id?: InputMaybe<Scalars['String']>;
  observedAt?: InputMaybe<Scalars['Float']>;
  previousId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  units?: InputMaybe<Scalars['String']>;
  updatePending?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<Scalars['Boolean']>;
};

export type FilterFindManyControllerController_LoopInput = {
  id?: InputMaybe<Scalars['String']>;
  observedAt?: InputMaybe<Scalars['Float']>;
  previousId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  units?: InputMaybe<Scalars['String']>;
  updatePending?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<EnumControllerController_LoopValue>;
};

export type FilterFindManyControllerInput = {
  AND?: InputMaybe<Array<FilterFindManyDeviceInput>>;
  OR?: InputMaybe<Array<FilterFindManyDeviceInput>>;
  _id?: InputMaybe<Scalars['String']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterFindManyDeviceOperatorsInput>;
  activeAlarmCount?: InputMaybe<FilterFindManyControllerActiveAlarmCountInput>;
  alertTypes?: InputMaybe<FilterFindManyDeviceAlertTypesInput>;
  communicationState?: InputMaybe<FilterFindManyControllerCommunicationStateInput>;
  controlled?: InputMaybe<FilterFindManyDeviceControlledInput>;
  controller_loop?: InputMaybe<FilterFindManyControllerController_LoopInput>;
  deviceId?: InputMaybe<Scalars['String']>;
  installation?: InputMaybe<FilterFindManyDeviceInstallationInput>;
  location?: InputMaybe<Scalars['String']>;
  meta?: InputMaybe<FilterFindManyDeviceMetaInput>;
  /** The name of the device */
  name?: InputMaybe<Scalars['String']>;
  panelId?: InputMaybe<Scalars['String']>;
  powerState?: InputMaybe<FilterFindManyDevicePowerStateInput>;
  propertyId?: InputMaybe<Scalars['String']>;
  resetCount?: InputMaybe<FilterFindManyControllerResetCountInput>;
  sourceId?: InputMaybe<Scalars['String']>;
  supervisor_controller?: InputMaybe<FilterFindManyControllerSupervisor_ControllerInput>;
  timestamp?: InputMaybe<Scalars['Float']>;
  unitId?: InputMaybe<Scalars['String']>;
  updateStatus?: InputMaybe<Scalars['Boolean']>;
  vppId?: InputMaybe<Scalars['String']>;
  zoneId?: InputMaybe<Scalars['String']>;
};

export type FilterFindManyControllerResetCountInput = {
  id?: InputMaybe<Scalars['String']>;
  observedAt?: InputMaybe<Scalars['Float']>;
  previousId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  units?: InputMaybe<Scalars['String']>;
  updatePending?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<Scalars['Float']>;
};

export type FilterFindManyControllerSupervisor_ControllerInput = {
  id?: InputMaybe<Scalars['String']>;
  observedAt?: InputMaybe<Scalars['Float']>;
  previousId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  units?: InputMaybe<Scalars['String']>;
  updatePending?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<EnumControllerSupervisor_ControllerValue>;
};

export type FilterFindManyCoreInput = {
  AND?: InputMaybe<Array<FilterFindManySourceInput>>;
  OR?: InputMaybe<Array<FilterFindManySourceInput>>;
  _id?: InputMaybe<Scalars['String']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterFindManySourceOperatorsInput>;
  maxReportingTime?: InputMaybe<Scalars['Float']>;
  name?: InputMaybe<Scalars['String']>;
  propertyId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  tolerances?: InputMaybe<FilterFindManyCoreTolerancesInput>;
  url?: InputMaybe<Scalars['String']>;
};

export type FilterFindManyCoreTolerancesInput = {
  humidity?: InputMaybe<Scalars['Float']>;
  temperature?: InputMaybe<Scalars['Float']>;
  voltage?: InputMaybe<Scalars['Float']>;
};

export type FilterFindManyDataExportJobArtifactsInput = {
  _id?: InputMaybe<Scalars['MongoID']>;
  bucket?: InputMaybe<Scalars['String']>;
  contentType?: InputMaybe<Scalars['String']>;
  key?: InputMaybe<Scalars['String']>;
  kind?: InputMaybe<Scalars['String']>;
};

export type FilterFindManyDataExportJobInput = {
  AND?: InputMaybe<Array<FilterFindManyDataExportJobInput>>;
  OR?: InputMaybe<Array<FilterFindManyDataExportJobInput>>;
  _id?: InputMaybe<Scalars['String']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterFindManyDataExportJobOperatorsInput>;
  artifacts?: InputMaybe<
    Array<InputMaybe<FilterFindManyDataExportJobArtifactsInput>>
  >;
  awsTaskArn?: InputMaybe<Scalars['String']>;
  completedAt?: InputMaybe<Scalars['Date']>;
  currentStep?: InputMaybe<Scalars['String']>;
  endDate?: InputMaybe<Scalars['Date']>;
  errorDetails?: InputMaybe<Scalars['String']>;
  errorMessage?: InputMaybe<Scalars['String']>;
  progress?: InputMaybe<Scalars['Float']>;
  propertyId?: InputMaybe<Scalars['String']>;
  propertyTitle?: InputMaybe<Scalars['String']>;
  reportTypes?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  requestedByUserId?: InputMaybe<Scalars['String']>;
  s3Bucket?: InputMaybe<Scalars['String']>;
  s3Key?: InputMaybe<Scalars['String']>;
  startDate?: InputMaybe<Scalars['Date']>;
  startedAt?: InputMaybe<Scalars['Date']>;
  status?: InputMaybe<EnumDataExportJobStatus>;
  submittedAt?: InputMaybe<Scalars['Date']>;
  updatedAt?: InputMaybe<Scalars['Date']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterFindManyDataExportJobOperatorsInput = {
  _id?: InputMaybe<FilterFindManyDataExportJob_IdOperatorsInput>;
  propertyId?: InputMaybe<FilterFindManyDataExportJobPropertyIdOperatorsInput>;
  requestedByUserId?: InputMaybe<FilterFindManyDataExportJobRequestedByUserIdOperatorsInput>;
  status?: InputMaybe<FilterFindManyDataExportJobStatusOperatorsInput>;
};

export type FilterFindManyDataExportJobPropertyIdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['String']>;
  gte?: InputMaybe<Scalars['String']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  lt?: InputMaybe<Scalars['String']>;
  lte?: InputMaybe<Scalars['String']>;
  ne?: InputMaybe<Scalars['String']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']>;
};

export type FilterFindManyDataExportJobRequestedByUserIdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['String']>;
  gte?: InputMaybe<Scalars['String']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  lt?: InputMaybe<Scalars['String']>;
  lte?: InputMaybe<Scalars['String']>;
  ne?: InputMaybe<Scalars['String']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']>;
};

export type FilterFindManyDataExportJobStatusOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<EnumDataExportJobStatus>;
  gte?: InputMaybe<EnumDataExportJobStatus>;
  in?: InputMaybe<Array<InputMaybe<EnumDataExportJobStatus>>>;
  lt?: InputMaybe<EnumDataExportJobStatus>;
  lte?: InputMaybe<EnumDataExportJobStatus>;
  ne?: InputMaybe<EnumDataExportJobStatus>;
  nin?: InputMaybe<Array<InputMaybe<EnumDataExportJobStatus>>>;
};

export type FilterFindManyDataExportJob_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['String']>;
  gte?: InputMaybe<Scalars['String']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  lt?: InputMaybe<Scalars['String']>;
  lte?: InputMaybe<Scalars['String']>;
  ne?: InputMaybe<Scalars['String']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']>;
};

export type FilterFindManyDeviceAlertTypesInput = {
  deviceAlert?: InputMaybe<Scalars['Boolean']>;
  deviceMetric?: InputMaybe<Scalars['Boolean']>;
  deviceOffline?: InputMaybe<Scalars['Boolean']>;
  equipmentAlarm?: InputMaybe<Scalars['Boolean']>;
  sourceOffline?: InputMaybe<Scalars['Boolean']>;
};

export type FilterFindManyDeviceControlledInput = {
  id?: InputMaybe<Scalars['String']>;
  observedAt?: InputMaybe<Scalars['Float']>;
  previousId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  units?: InputMaybe<Scalars['String']>;
  updatePending?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<Scalars['Boolean']>;
};

export type FilterFindManyDeviceInput = {
  AND?: InputMaybe<Array<FilterFindManyDeviceInput>>;
  OR?: InputMaybe<Array<FilterFindManyDeviceInput>>;
  _id?: InputMaybe<Scalars['String']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterFindManyDeviceOperatorsInput>;
  alertTypes?: InputMaybe<FilterFindManyDeviceAlertTypesInput>;
  controlled?: InputMaybe<FilterFindManyDeviceControlledInput>;
  deviceId?: InputMaybe<Scalars['String']>;
  installation?: InputMaybe<FilterFindManyDeviceInstallationInput>;
  location?: InputMaybe<Scalars['String']>;
  meta?: InputMaybe<FilterFindManyDeviceMetaInput>;
  /** The name of the device */
  name?: InputMaybe<Scalars['String']>;
  panelId?: InputMaybe<Scalars['String']>;
  powerState?: InputMaybe<FilterFindManyDevicePowerStateInput>;
  propertyId?: InputMaybe<Scalars['String']>;
  sourceId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  type?: InputMaybe<EnumDKeyDeviceType>;
  unitId?: InputMaybe<Scalars['String']>;
  updateStatus?: InputMaybe<Scalars['Boolean']>;
  vppId?: InputMaybe<Scalars['String']>;
  zoneId?: InputMaybe<Scalars['String']>;
};

export type FilterFindManyDeviceInstallationInput = {
  count?: InputMaybe<Scalars['Float']>;
  message?: InputMaybe<Scalars['String']>;
  paired?: InputMaybe<Scalars['Boolean']>;
  pairedTo?: InputMaybe<Scalars['String']>;
  previousStatus?: InputMaybe<Scalars['String']>;
  rawDeviceId?: InputMaybe<Scalars['String']>;
  replacingDeviceId?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<Scalars['Float']>;
};

export type FilterFindManyDeviceMetaDisplayInput = {
  humidity?: InputMaybe<Scalars['Float']>;
  temperature?: InputMaybe<Scalars['Float']>;
};

export type FilterFindManyDeviceMetaInput = {
  city_id?: InputMaybe<Scalars['String']>;
  display?: InputMaybe<FilterFindManyDeviceMetaDisplayInput>;
  localAddr?: InputMaybe<Scalars['String']>;
  local_addr?: InputMaybe<Scalars['String']>;
  location?: InputMaybe<Scalars['String']>;
  loopType?: InputMaybe<Scalars['String']>;
  manufacturer?: InputMaybe<Scalars['String']>;
  metrics?: InputMaybe<Scalars['JSON']>;
  model?: InputMaybe<Scalars['String']>;
  modelNumber?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  plmActive?: InputMaybe<Scalars['Boolean']>;
  remoteSensorId?: InputMaybe<Scalars['String']>;
  remoteSensorOperating?: InputMaybe<Scalars['Boolean']>;
  serialNumber?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<Scalars['String']>;
  version?: InputMaybe<Scalars['String']>;
};

export type FilterFindManyDeviceNameOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['String']>;
  gte?: InputMaybe<Scalars['String']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  lt?: InputMaybe<Scalars['String']>;
  lte?: InputMaybe<Scalars['String']>;
  ne?: InputMaybe<Scalars['String']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterFindManyDeviceOperatorsInput = {
  _id?: InputMaybe<FilterFindManyDevice_IdOperatorsInput>;
  name?: InputMaybe<FilterFindManyDeviceNameOperatorsInput>;
  propertyId?: InputMaybe<FilterFindManyDevicePropertyIdOperatorsInput>;
  type?: InputMaybe<FilterFindManyDeviceTypeOperatorsInput>;
  unitId?: InputMaybe<FilterFindManyDeviceUnitIdOperatorsInput>;
};

export type FilterFindManyDevicePowerStateInput = {
  id?: InputMaybe<Scalars['String']>;
  observedAt?: InputMaybe<Scalars['Float']>;
  previousId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  units?: InputMaybe<Scalars['String']>;
  updatePending?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<EnumDevicePowerStateValue>;
};

export type FilterFindManyDevicePropertyIdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['String']>;
  gte?: InputMaybe<Scalars['String']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  lt?: InputMaybe<Scalars['String']>;
  lte?: InputMaybe<Scalars['String']>;
  ne?: InputMaybe<Scalars['String']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']>;
};

export type FilterFindManyDeviceReadingDeviceUidOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['String']>;
  gte?: InputMaybe<Scalars['String']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  lt?: InputMaybe<Scalars['String']>;
  lte?: InputMaybe<Scalars['String']>;
  ne?: InputMaybe<Scalars['String']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']>;
};

export type FilterFindManyDeviceReadingInput = {
  AND?: InputMaybe<Array<FilterFindManyDeviceReadingInput>>;
  OR?: InputMaybe<Array<FilterFindManyDeviceReadingInput>>;
  _id?: InputMaybe<Scalars['String']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterFindManyDeviceReadingOperatorsInput>;
  dateTime?: InputMaybe<Scalars['Float']>;
  deviceUid?: InputMaybe<Scalars['String']>;
  measurementType?: InputMaybe<Scalars['String']>;
  series?: InputMaybe<EnumDeviceReadingSeries>;
  sourceId?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<Scalars['Float']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterFindManyDeviceReadingOperatorsInput = {
  _id?: InputMaybe<FilterFindManyDeviceReading_IdOperatorsInput>;
  deviceUid?: InputMaybe<FilterFindManyDeviceReadingDeviceUidOperatorsInput>;
};

export type FilterFindManyDeviceReading_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['String']>;
  gte?: InputMaybe<Scalars['String']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  lt?: InputMaybe<Scalars['String']>;
  lte?: InputMaybe<Scalars['String']>;
  ne?: InputMaybe<Scalars['String']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']>;
};

export type FilterFindManyDeviceTypeOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<EnumDeviceType>;
  gte?: InputMaybe<EnumDeviceType>;
  in?: InputMaybe<Array<InputMaybe<EnumDeviceType>>>;
  lt?: InputMaybe<EnumDeviceType>;
  lte?: InputMaybe<EnumDeviceType>;
  ne?: InputMaybe<EnumDeviceType>;
  nin?: InputMaybe<Array<InputMaybe<EnumDeviceType>>>;
};

export type FilterFindManyDeviceUnitIdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['String']>;
  gte?: InputMaybe<Scalars['String']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  lt?: InputMaybe<Scalars['String']>;
  lte?: InputMaybe<Scalars['String']>;
  ne?: InputMaybe<Scalars['String']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']>;
};

export type FilterFindManyDevice_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['String']>;
  gte?: InputMaybe<Scalars['String']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  lt?: InputMaybe<Scalars['String']>;
  lte?: InputMaybe<Scalars['String']>;
  ne?: InputMaybe<Scalars['String']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']>;
};

export type FilterFindManyDoorSensorContactStateInput = {
  id?: InputMaybe<Scalars['String']>;
  observedAt?: InputMaybe<Scalars['Float']>;
  previousId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  units?: InputMaybe<Scalars['String']>;
  updatePending?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<Scalars['String']>;
};

export type FilterFindManyDoorSensorInput = {
  AND?: InputMaybe<Array<FilterFindManyDeviceInput>>;
  OR?: InputMaybe<Array<FilterFindManyDeviceInput>>;
  _id?: InputMaybe<Scalars['String']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterFindManyDeviceOperatorsInput>;
  alertTypes?: InputMaybe<FilterFindManyDeviceAlertTypesInput>;
  contactState?: InputMaybe<FilterFindManyDoorSensorContactStateInput>;
  controlled?: InputMaybe<FilterFindManyDeviceControlledInput>;
  deviceId?: InputMaybe<Scalars['String']>;
  installation?: InputMaybe<FilterFindManyDeviceInstallationInput>;
  location?: InputMaybe<Scalars['String']>;
  meta?: InputMaybe<FilterFindManyDeviceMetaInput>;
  /** The name of the device */
  name?: InputMaybe<Scalars['String']>;
  panelId?: InputMaybe<Scalars['String']>;
  powerState?: InputMaybe<FilterFindManyDevicePowerStateInput>;
  propertyId?: InputMaybe<Scalars['String']>;
  sourceId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  unitId?: InputMaybe<Scalars['String']>;
  updateStatus?: InputMaybe<Scalars['Boolean']>;
  voltage?: InputMaybe<FilterFindManyDoorSensorVoltageInput>;
  vppId?: InputMaybe<Scalars['String']>;
  zoneId?: InputMaybe<Scalars['String']>;
};

export type FilterFindManyDoorSensorVoltageInput = {
  id?: InputMaybe<Scalars['String']>;
  observedAt?: InputMaybe<Scalars['Float']>;
  previousId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  units?: InputMaybe<Scalars['String']>;
  updatePending?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<Scalars['Float']>;
};

export type FilterFindManyEnergyConsumerBuildingConnectedInput = {
  id?: InputMaybe<Scalars['String']>;
  observedAt?: InputMaybe<Scalars['Float']>;
  previousId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  units?: InputMaybe<Scalars['String']>;
  updatePending?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<Scalars['Boolean']>;
};

export type FilterFindManyEnergyConsumerBuildingDisconnectedAtInput = {
  id?: InputMaybe<Scalars['String']>;
  observedAt?: InputMaybe<Scalars['Float']>;
  previousId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  units?: InputMaybe<Scalars['String']>;
  updatePending?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<Scalars['Float']>;
};

export type FilterFindManyEnergyConsumerBuildingEnergyEfficiencyScoreInput = {
  id?: InputMaybe<Scalars['String']>;
  observedAt?: InputMaybe<Scalars['Float']>;
  previousId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  units?: InputMaybe<Scalars['String']>;
  updatePending?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<Scalars['Float']>;
};

export type FilterFindManyEnergyConsumerBuildingInput = {
  AND?: InputMaybe<Array<FilterFindManyEnergyConsumerBuildingInput>>;
  OR?: InputMaybe<Array<FilterFindManyEnergyConsumerBuildingInput>>;
  _id?: InputMaybe<Scalars['String']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterFindManyEnergyConsumerBuildingOperatorsInput>;
  circuitId?: InputMaybe<Scalars['String']>;
  connected?: InputMaybe<FilterFindManyEnergyConsumerBuildingConnectedInput>;
  converterId?: InputMaybe<Scalars['String']>;
  disconnectedAt?: InputMaybe<FilterFindManyEnergyConsumerBuildingDisconnectedAtInput>;
  energyEfficiencyScore?: InputMaybe<FilterFindManyEnergyConsumerBuildingEnergyEfficiencyScoreInput>;
  energySwitchPanelId?: InputMaybe<Scalars['String']>;
  inverterId?: InputMaybe<Scalars['String']>;
  lastConnectedAt?: InputMaybe<FilterFindManyEnergyConsumerBuildingLastConnectedAtInput>;
  location?: InputMaybe<Scalars['String']>;
  meterId?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  occupancy?: InputMaybe<FilterFindManyEnergyConsumerBuildingOccupancyInput>;
  powerState?: InputMaybe<FilterFindManyEnergyConsumerBuildingPowerStateInput>;
  propertyId?: InputMaybe<Scalars['String']>;
  tariffRateSell?: InputMaybe<FilterFindManyEnergyConsumerBuildingTariffRateSellInput>;
  timestamp?: InputMaybe<Scalars['Float']>;
  unitId?: InputMaybe<Scalars['String']>;
  updateStatus?: InputMaybe<Scalars['Boolean']>;
  vppId?: InputMaybe<Scalars['String']>;
  /** Constructs a regular expression search based on the string provided */
  withNameLike?: InputMaybe<Scalars['String']>;
};

export type FilterFindManyEnergyConsumerBuildingLastConnectedAtInput = {
  id?: InputMaybe<Scalars['String']>;
  observedAt?: InputMaybe<Scalars['Float']>;
  previousId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  units?: InputMaybe<Scalars['String']>;
  updatePending?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<Scalars['Float']>;
};

export type FilterFindManyEnergyConsumerBuildingOccupancyInput = {
  id?: InputMaybe<Scalars['String']>;
  observedAt?: InputMaybe<Scalars['Float']>;
  previousId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  units?: InputMaybe<Scalars['String']>;
  updatePending?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<Scalars['Float']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterFindManyEnergyConsumerBuildingOperatorsInput = {
  _id?: InputMaybe<FilterFindManyEnergyConsumerBuilding_IdOperatorsInput>;
};

export type FilterFindManyEnergyConsumerBuildingPowerStateInput = {
  id?: InputMaybe<Scalars['String']>;
  observedAt?: InputMaybe<Scalars['Float']>;
  previousId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  units?: InputMaybe<Scalars['String']>;
  updatePending?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<EnumEnergyConsumerBuildingPowerStateValue>;
};

export type FilterFindManyEnergyConsumerBuildingTariffRateSellInput = {
  id?: InputMaybe<Scalars['String']>;
  observedAt?: InputMaybe<Scalars['Float']>;
  previousId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  units?: InputMaybe<Scalars['String']>;
  updatePending?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<Scalars['Float']>;
};

export type FilterFindManyEnergyConsumerBuilding_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['String']>;
  gte?: InputMaybe<Scalars['String']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  lt?: InputMaybe<Scalars['String']>;
  lte?: InputMaybe<Scalars['String']>;
  ne?: InputMaybe<Scalars['String']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']>;
};

export type FilterFindManyEnergyConsumerTenantEnergyEfficiencyScoreInput = {
  id?: InputMaybe<Scalars['String']>;
  observedAt?: InputMaybe<Scalars['Float']>;
  previousId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  units?: InputMaybe<Scalars['String']>;
  updatePending?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<Scalars['Float']>;
};

export type FilterFindManyEnergyConsumerTenantInput = {
  AND?: InputMaybe<Array<FilterFindManyEnergyConsumerTenantInput>>;
  OR?: InputMaybe<Array<FilterFindManyEnergyConsumerTenantInput>>;
  _id?: InputMaybe<Scalars['String']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterFindManyEnergyConsumerTenantOperatorsInput>;
  buildingId?: InputMaybe<Scalars['String']>;
  circuitId?: InputMaybe<Scalars['String']>;
  connected?: InputMaybe<FilterFindManyEnergyConsumerBuildingConnectedInput>;
  contactName?: InputMaybe<Scalars['String']>;
  contactPhone?: InputMaybe<Scalars['String']>;
  converterId?: InputMaybe<Scalars['String']>;
  disconnectedAt?: InputMaybe<FilterFindManyEnergyConsumerBuildingDisconnectedAtInput>;
  energyEfficiencyScore?: InputMaybe<FilterFindManyEnergyConsumerTenantEnergyEfficiencyScoreInput>;
  energySwitchPanelId?: InputMaybe<Scalars['String']>;
  inverterId?: InputMaybe<Scalars['String']>;
  lastConnectedAt?: InputMaybe<FilterFindManyEnergyConsumerBuildingLastConnectedAtInput>;
  location?: InputMaybe<Scalars['String']>;
  meterId?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  occupancy?: InputMaybe<FilterFindManyEnergyConsumerTenantOccupancyInput>;
  powerState?: InputMaybe<FilterFindManyEnergyConsumerBuildingPowerStateInput>;
  propertyId?: InputMaybe<Scalars['String']>;
  tariffRateSell?: InputMaybe<FilterFindManyEnergyConsumerBuildingTariffRateSellInput>;
  timestamp?: InputMaybe<Scalars['Float']>;
  unitId?: InputMaybe<Scalars['String']>;
  updateStatus?: InputMaybe<Scalars['Boolean']>;
  vppId?: InputMaybe<Scalars['String']>;
  /** Constructs a regular expression search based on the string provided */
  withNameLike?: InputMaybe<Scalars['String']>;
};

export type FilterFindManyEnergyConsumerTenantOccupancyInput = {
  id?: InputMaybe<Scalars['String']>;
  observedAt?: InputMaybe<Scalars['Float']>;
  previousId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  units?: InputMaybe<Scalars['String']>;
  updatePending?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<Scalars['Float']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterFindManyEnergyConsumerTenantOperatorsInput = {
  _id?: InputMaybe<FilterFindManyEnergyConsumerTenant_IdOperatorsInput>;
};

export type FilterFindManyEnergyConsumerTenant_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['String']>;
  gte?: InputMaybe<Scalars['String']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  lt?: InputMaybe<Scalars['String']>;
  lte?: InputMaybe<Scalars['String']>;
  ne?: InputMaybe<Scalars['String']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']>;
};

export type FilterFindManyEnergyConsumerUtilityContractStatusInput = {
  id?: InputMaybe<Scalars['String']>;
  observedAt?: InputMaybe<Scalars['Float']>;
  previousId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  units?: InputMaybe<Scalars['String']>;
  updatePending?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<Scalars['String']>;
};

export type FilterFindManyEnergyConsumerUtilityExportAllowanceInput = {
  id?: InputMaybe<Scalars['String']>;
  observedAt?: InputMaybe<Scalars['Float']>;
  previousId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  units?: InputMaybe<Scalars['String']>;
  updatePending?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<Scalars['Float']>;
};

export type FilterFindManyEnergyConsumerUtilityGridFrequencyInput = {
  id?: InputMaybe<Scalars['String']>;
  observedAt?: InputMaybe<Scalars['Float']>;
  previousId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  units?: InputMaybe<Scalars['String']>;
  updatePending?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<Scalars['Float']>;
};

export type FilterFindManyEnergyConsumerUtilityInput = {
  AND?: InputMaybe<Array<FilterFindManyEnergyConsumerUtilityInput>>;
  OR?: InputMaybe<Array<FilterFindManyEnergyConsumerUtilityInput>>;
  _id?: InputMaybe<Scalars['String']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterFindManyEnergyConsumerUtilityOperatorsInput>;
  circuitId?: InputMaybe<Scalars['String']>;
  connected?: InputMaybe<FilterFindManyEnergyConsumerBuildingConnectedInput>;
  contractStatus?: InputMaybe<FilterFindManyEnergyConsumerUtilityContractStatusInput>;
  converterId?: InputMaybe<Scalars['String']>;
  disconnectedAt?: InputMaybe<FilterFindManyEnergyConsumerBuildingDisconnectedAtInput>;
  energySwitchPanelId?: InputMaybe<Scalars['String']>;
  exportAllowance?: InputMaybe<FilterFindManyEnergyConsumerUtilityExportAllowanceInput>;
  gridFrequency?: InputMaybe<FilterFindManyEnergyConsumerUtilityGridFrequencyInput>;
  interconnectionCapacity?: InputMaybe<FilterFindManyEnergyConsumerUtilityInterconnectionCapacityInput>;
  inverterId?: InputMaybe<Scalars['String']>;
  lastConnectedAt?: InputMaybe<FilterFindManyEnergyConsumerBuildingLastConnectedAtInput>;
  location?: InputMaybe<Scalars['String']>;
  meterId?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  powerState?: InputMaybe<FilterFindManyEnergyConsumerBuildingPowerStateInput>;
  propertyId?: InputMaybe<Scalars['String']>;
  tariffRateSell?: InputMaybe<FilterFindManyEnergyConsumerBuildingTariffRateSellInput>;
  timestamp?: InputMaybe<Scalars['Float']>;
  unitId?: InputMaybe<Scalars['String']>;
  updateStatus?: InputMaybe<Scalars['Boolean']>;
  vppId?: InputMaybe<Scalars['String']>;
  /** Constructs a regular expression search based on the string provided */
  withNameLike?: InputMaybe<Scalars['String']>;
};

export type FilterFindManyEnergyConsumerUtilityInterconnectionCapacityInput = {
  id?: InputMaybe<Scalars['String']>;
  observedAt?: InputMaybe<Scalars['Float']>;
  previousId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  units?: InputMaybe<Scalars['String']>;
  updatePending?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<Scalars['Float']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterFindManyEnergyConsumerUtilityOperatorsInput = {
  _id?: InputMaybe<FilterFindManyEnergyConsumerUtility_IdOperatorsInput>;
};

export type FilterFindManyEnergyConsumerUtility_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['String']>;
  gte?: InputMaybe<Scalars['String']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  lt?: InputMaybe<Scalars['String']>;
  lte?: InputMaybe<Scalars['String']>;
  ne?: InputMaybe<Scalars['String']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']>;
};

export type FilterFindManyEnergyControllerAvailabilityStatusInput = {
  id?: InputMaybe<Scalars['String']>;
  observedAt?: InputMaybe<Scalars['Float']>;
  previousId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  units?: InputMaybe<Scalars['String']>;
  updatePending?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<EnumEnergyControllerAvailabilityStatusValue>;
};

export type FilterFindManyEnergyControllerChargeRegulationStatusInput = {
  id?: InputMaybe<Scalars['String']>;
  observedAt?: InputMaybe<Scalars['Float']>;
  previousId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  units?: InputMaybe<Scalars['String']>;
  updatePending?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<EnumEnergyControllerChargeRegulationStatusValue>;
};

export type FilterFindManyEnergyControllerCurrentAtMppInput = {
  id?: InputMaybe<Scalars['String']>;
  observedAt?: InputMaybe<Scalars['Float']>;
  previousId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  units?: InputMaybe<Scalars['String']>;
  updatePending?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<Scalars['Float']>;
};

export type FilterFindManyEnergyControllerEnergyGeneratedInput = {
  id?: InputMaybe<Scalars['String']>;
  observedAt?: InputMaybe<Scalars['Float']>;
  previousId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  units?: InputMaybe<Scalars['String']>;
  updatePending?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<Scalars['Float']>;
};

export type FilterFindManyEnergyControllerInput = {
  AND?: InputMaybe<Array<FilterFindManyDeviceInput>>;
  OR?: InputMaybe<Array<FilterFindManyDeviceInput>>;
  _id?: InputMaybe<Scalars['String']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterFindManyDeviceOperatorsInput>;
  alertTypes?: InputMaybe<FilterFindManyDeviceAlertTypesInput>;
  availabilityStatus?: InputMaybe<FilterFindManyEnergyControllerAvailabilityStatusInput>;
  chargeRegulationStatus?: InputMaybe<FilterFindManyEnergyControllerChargeRegulationStatusInput>;
  controlled?: InputMaybe<FilterFindManyDeviceControlledInput>;
  currentAtMpp?: InputMaybe<FilterFindManyEnergyControllerCurrentAtMppInput>;
  deviceId?: InputMaybe<Scalars['String']>;
  energyGenerated?: InputMaybe<FilterFindManyEnergyControllerEnergyGeneratedInput>;
  installation?: InputMaybe<FilterFindManyDeviceInstallationInput>;
  location?: InputMaybe<Scalars['String']>;
  meta?: InputMaybe<FilterFindManyDeviceMetaInput>;
  /** The name of the device */
  name?: InputMaybe<Scalars['String']>;
  panelId?: InputMaybe<Scalars['String']>;
  powerState?: InputMaybe<FilterFindManyDevicePowerStateInput>;
  propertyId?: InputMaybe<Scalars['String']>;
  rectifierId?: InputMaybe<Scalars['String']>;
  rotorSpeedAtMPP?: InputMaybe<FilterFindManyEnergyControllerRotorSpeedAtMppInput>;
  sourceId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  unitId?: InputMaybe<Scalars['String']>;
  updateStatus?: InputMaybe<Scalars['Boolean']>;
  voltageAtMpp?: InputMaybe<FilterFindManyEnergyControllerVoltageAtMppInput>;
  vppId?: InputMaybe<Scalars['String']>;
  zoneId?: InputMaybe<Scalars['String']>;
};

export type FilterFindManyEnergyControllerRotorSpeedAtMppInput = {
  id?: InputMaybe<Scalars['String']>;
  observedAt?: InputMaybe<Scalars['Float']>;
  previousId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  units?: InputMaybe<Scalars['String']>;
  updatePending?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<Scalars['Float']>;
};

export type FilterFindManyEnergyControllerVoltageAtMppInput = {
  id?: InputMaybe<Scalars['String']>;
  observedAt?: InputMaybe<Scalars['Float']>;
  previousId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  units?: InputMaybe<Scalars['String']>;
  updatePending?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<Scalars['Float']>;
};

export type FilterFindManyEnergyConverterChargeRateInput = {
  id?: InputMaybe<Scalars['String']>;
  observedAt?: InputMaybe<Scalars['Float']>;
  previousId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  units?: InputMaybe<Scalars['String']>;
  updatePending?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<Scalars['Float']>;
};

export type FilterFindManyEnergyConverterDischargeRateInput = {
  id?: InputMaybe<Scalars['String']>;
  observedAt?: InputMaybe<Scalars['Float']>;
  previousId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  units?: InputMaybe<Scalars['String']>;
  updatePending?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<Scalars['Float']>;
};

export type FilterFindManyEnergyConverterEfficiencyInput = {
  id?: InputMaybe<Scalars['String']>;
  observedAt?: InputMaybe<Scalars['Float']>;
  previousId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  units?: InputMaybe<Scalars['String']>;
  updatePending?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<Scalars['Float']>;
};

export type FilterFindManyEnergyConverterInput = {
  AND?: InputMaybe<Array<FilterFindManyDeviceInput>>;
  OR?: InputMaybe<Array<FilterFindManyDeviceInput>>;
  _id?: InputMaybe<Scalars['String']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterFindManyDeviceOperatorsInput>;
  alertTypes?: InputMaybe<FilterFindManyDeviceAlertTypesInput>;
  chargeRate?: InputMaybe<FilterFindManyEnergyConverterChargeRateInput>;
  controlled?: InputMaybe<FilterFindManyDeviceControlledInput>;
  deviceId?: InputMaybe<Scalars['String']>;
  dischargeRate?: InputMaybe<FilterFindManyEnergyConverterDischargeRateInput>;
  efficiency?: InputMaybe<FilterFindManyEnergyConverterEfficiencyInput>;
  inputVoltage?: InputMaybe<FilterFindManyEnergyConverterInputVoltageInput>;
  installation?: InputMaybe<FilterFindManyDeviceInstallationInput>;
  location?: InputMaybe<Scalars['String']>;
  meta?: InputMaybe<FilterFindManyDeviceMetaInput>;
  /** The name of the device */
  name?: InputMaybe<Scalars['String']>;
  outputVoltage?: InputMaybe<FilterFindManyEnergyConverterOutputVoltageInput>;
  panelId?: InputMaybe<Scalars['String']>;
  powerOutput?: InputMaybe<FilterFindManyEnergyConverterPowerOutputInput>;
  powerState?: InputMaybe<FilterFindManyDevicePowerStateInput>;
  propertyId?: InputMaybe<Scalars['String']>;
  sourceId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  unitId?: InputMaybe<Scalars['String']>;
  updateStatus?: InputMaybe<Scalars['Boolean']>;
  vppId?: InputMaybe<Scalars['String']>;
  zoneId?: InputMaybe<Scalars['String']>;
};

export type FilterFindManyEnergyConverterInputVoltageInput = {
  id?: InputMaybe<Scalars['String']>;
  observedAt?: InputMaybe<Scalars['Float']>;
  previousId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  units?: InputMaybe<Scalars['String']>;
  updatePending?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<Scalars['Float']>;
};

export type FilterFindManyEnergyConverterOutputVoltageInput = {
  id?: InputMaybe<Scalars['String']>;
  observedAt?: InputMaybe<Scalars['Float']>;
  previousId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  units?: InputMaybe<Scalars['String']>;
  updatePending?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<Scalars['Float']>;
};

export type FilterFindManyEnergyConverterPowerOutputInput = {
  id?: InputMaybe<Scalars['String']>;
  observedAt?: InputMaybe<Scalars['Float']>;
  previousId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  units?: InputMaybe<Scalars['String']>;
  updatePending?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<Scalars['Float']>;
};

export type FilterFindManyEnergyInverterAvailabilityStatusInput = {
  id?: InputMaybe<Scalars['String']>;
  observedAt?: InputMaybe<Scalars['Float']>;
  previousId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  units?: InputMaybe<Scalars['String']>;
  updatePending?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<EnumEnergyInverterAvailabilityStatusValue>;
};

export type FilterFindManyEnergyInverterChargeRateInput = {
  id?: InputMaybe<Scalars['String']>;
  observedAt?: InputMaybe<Scalars['Float']>;
  previousId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  units?: InputMaybe<Scalars['String']>;
  updatePending?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<Scalars['Float']>;
};

export type FilterFindManyEnergyInverterDischargeRateInput = {
  id?: InputMaybe<Scalars['String']>;
  observedAt?: InputMaybe<Scalars['Float']>;
  previousId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  units?: InputMaybe<Scalars['String']>;
  updatePending?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<Scalars['Float']>;
};

export type FilterFindManyEnergyInverterEfficiencyInput = {
  id?: InputMaybe<Scalars['String']>;
  observedAt?: InputMaybe<Scalars['Float']>;
  previousId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  units?: InputMaybe<Scalars['String']>;
  updatePending?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<Scalars['Float']>;
};

export type FilterFindManyEnergyInverterFrequencyInput = {
  id?: InputMaybe<Scalars['String']>;
  observedAt?: InputMaybe<Scalars['Float']>;
  previousId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  units?: InputMaybe<Scalars['String']>;
  updatePending?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<Scalars['Float']>;
};

export type FilterFindManyEnergyInverterInput = {
  AND?: InputMaybe<Array<FilterFindManyDeviceInput>>;
  OR?: InputMaybe<Array<FilterFindManyDeviceInput>>;
  _id?: InputMaybe<Scalars['String']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterFindManyDeviceOperatorsInput>;
  alertTypes?: InputMaybe<FilterFindManyDeviceAlertTypesInput>;
  availabilityStatus?: InputMaybe<FilterFindManyEnergyInverterAvailabilityStatusInput>;
  chargeRate?: InputMaybe<FilterFindManyEnergyInverterChargeRateInput>;
  controlled?: InputMaybe<FilterFindManyDeviceControlledInput>;
  controllerId?: InputMaybe<Scalars['String']>;
  deviceId?: InputMaybe<Scalars['String']>;
  dischargeRate?: InputMaybe<FilterFindManyEnergyInverterDischargeRateInput>;
  efficiency?: InputMaybe<FilterFindManyEnergyInverterEfficiencyInput>;
  frequency?: InputMaybe<FilterFindManyEnergyInverterFrequencyInput>;
  installation?: InputMaybe<FilterFindManyDeviceInstallationInput>;
  inverterTemperature?: InputMaybe<FilterFindManyEnergyInverterInverterTemperatureInput>;
  location?: InputMaybe<Scalars['String']>;
  meta?: InputMaybe<FilterFindManyDeviceMetaInput>;
  /** The name of the device */
  name?: InputMaybe<Scalars['String']>;
  panelId?: InputMaybe<Scalars['String']>;
  powerInputBattery?: InputMaybe<FilterFindManyEnergyInverterPowerInputBatteryInput>;
  powerInputKinetic?: InputMaybe<FilterFindManyEnergyInverterPowerInputKineticInput>;
  powerOutput?: InputMaybe<FilterFindManyEnergyInverterPowerOutputInput>;
  powerRating?: InputMaybe<FilterFindManyEnergyInverterPowerRatingInput>;
  powerState?: InputMaybe<FilterFindManyDevicePowerStateInput>;
  propertyId?: InputMaybe<Scalars['String']>;
  reactivePower?: InputMaybe<FilterFindManyEnergyInverterReactivePowerInput>;
  rectifierId?: InputMaybe<Scalars['String']>;
  sourceId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  unitId?: InputMaybe<Scalars['String']>;
  updateStatus?: InputMaybe<Scalars['Boolean']>;
  voltageOutput?: InputMaybe<FilterFindManyEnergyInverterVoltageOutputInput>;
  vppId?: InputMaybe<Scalars['String']>;
  zoneId?: InputMaybe<Scalars['String']>;
};

export type FilterFindManyEnergyInverterInverterTemperatureInput = {
  id?: InputMaybe<Scalars['String']>;
  observedAt?: InputMaybe<Scalars['Float']>;
  previousId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  units?: InputMaybe<Scalars['String']>;
  updatePending?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<Scalars['Float']>;
};

export type FilterFindManyEnergyInverterPowerInputBatteryInput = {
  id?: InputMaybe<Scalars['String']>;
  observedAt?: InputMaybe<Scalars['Float']>;
  previousId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  units?: InputMaybe<Scalars['String']>;
  updatePending?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<Scalars['Float']>;
};

export type FilterFindManyEnergyInverterPowerInputKineticInput = {
  id?: InputMaybe<Scalars['String']>;
  observedAt?: InputMaybe<Scalars['Float']>;
  previousId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  units?: InputMaybe<Scalars['String']>;
  updatePending?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<Scalars['Float']>;
};

export type FilterFindManyEnergyInverterPowerOutputInput = {
  id?: InputMaybe<Scalars['String']>;
  observedAt?: InputMaybe<Scalars['Float']>;
  previousId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  units?: InputMaybe<Scalars['String']>;
  updatePending?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<Scalars['Float']>;
};

export type FilterFindManyEnergyInverterPowerRatingInput = {
  id?: InputMaybe<Scalars['String']>;
  observedAt?: InputMaybe<Scalars['Float']>;
  previousId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  units?: InputMaybe<Scalars['String']>;
  updatePending?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<Scalars['Float']>;
};

export type FilterFindManyEnergyInverterReactivePowerInput = {
  id?: InputMaybe<Scalars['String']>;
  observedAt?: InputMaybe<Scalars['Float']>;
  previousId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  units?: InputMaybe<Scalars['String']>;
  updatePending?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<Scalars['Float']>;
};

export type FilterFindManyEnergyInverterVoltageOutputInput = {
  id?: InputMaybe<Scalars['String']>;
  observedAt?: InputMaybe<Scalars['Float']>;
  previousId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  units?: InputMaybe<Scalars['String']>;
  updatePending?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<Scalars['Float']>;
};

export type FilterFindManyEnergyMeterCurrentInput = {
  id?: InputMaybe<Scalars['String']>;
  observedAt?: InputMaybe<Scalars['Float']>;
  previousId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  units?: InputMaybe<Scalars['String']>;
  updatePending?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<Scalars['Float']>;
};

export type FilterFindManyEnergyMeterEnergyConsumedInput = {
  id?: InputMaybe<Scalars['String']>;
  observedAt?: InputMaybe<Scalars['Float']>;
  previousId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  units?: InputMaybe<Scalars['String']>;
  updatePending?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<Scalars['Float']>;
};

export type FilterFindManyEnergyMeterFrequencyInput = {
  id?: InputMaybe<Scalars['String']>;
  observedAt?: InputMaybe<Scalars['Float']>;
  previousId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  units?: InputMaybe<Scalars['String']>;
  updatePending?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<Scalars['Float']>;
};

export type FilterFindManyEnergyMeterInput = {
  AND?: InputMaybe<Array<FilterFindManyDeviceInput>>;
  OR?: InputMaybe<Array<FilterFindManyDeviceInput>>;
  _id?: InputMaybe<Scalars['String']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterFindManyDeviceOperatorsInput>;
  alertTypes?: InputMaybe<FilterFindManyDeviceAlertTypesInput>;
  controlled?: InputMaybe<FilterFindManyDeviceControlledInput>;
  current?: InputMaybe<FilterFindManyEnergyMeterCurrentInput>;
  deviceId?: InputMaybe<Scalars['String']>;
  energyConsumed?: InputMaybe<FilterFindManyEnergyMeterEnergyConsumedInput>;
  frequency?: InputMaybe<FilterFindManyEnergyMeterFrequencyInput>;
  installation?: InputMaybe<FilterFindManyDeviceInstallationInput>;
  location?: InputMaybe<Scalars['String']>;
  meta?: InputMaybe<FilterFindManyDeviceMetaInput>;
  /** The name of the device */
  name?: InputMaybe<Scalars['String']>;
  outputEnabled?: InputMaybe<FilterFindManyEnergyMeterOutputEnabledInput>;
  panelId?: InputMaybe<Scalars['String']>;
  powerDemand?: InputMaybe<FilterFindManyEnergyMeterPowerDemandInput>;
  powerFactor?: InputMaybe<FilterFindManyEnergyMeterPowerFactorInput>;
  powerState?: InputMaybe<FilterFindManyDevicePowerStateInput>;
  propertyId?: InputMaybe<Scalars['String']>;
  sourceId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  unitId?: InputMaybe<Scalars['String']>;
  updateStatus?: InputMaybe<Scalars['Boolean']>;
  voltage?: InputMaybe<FilterFindManyEnergyMeterVoltageInput>;
  vppId?: InputMaybe<Scalars['String']>;
  zoneId?: InputMaybe<Scalars['String']>;
};

export type FilterFindManyEnergyMeterOutputEnabledInput = {
  id?: InputMaybe<Scalars['String']>;
  observedAt?: InputMaybe<Scalars['Float']>;
  previousId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  units?: InputMaybe<Scalars['String']>;
  updatePending?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<Scalars['Boolean']>;
};

export type FilterFindManyEnergyMeterPowerDemandInput = {
  id?: InputMaybe<Scalars['String']>;
  observedAt?: InputMaybe<Scalars['Float']>;
  previousId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  units?: InputMaybe<Scalars['String']>;
  updatePending?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<Scalars['Float']>;
};

export type FilterFindManyEnergyMeterPowerFactorInput = {
  id?: InputMaybe<Scalars['String']>;
  observedAt?: InputMaybe<Scalars['Float']>;
  previousId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  units?: InputMaybe<Scalars['String']>;
  updatePending?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<Scalars['Float']>;
};

export type FilterFindManyEnergyMeterVoltageInput = {
  id?: InputMaybe<Scalars['String']>;
  observedAt?: InputMaybe<Scalars['Float']>;
  previousId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  units?: InputMaybe<Scalars['String']>;
  updatePending?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<Scalars['Float']>;
};

export type FilterFindManyEnergyRectifierInput = {
  AND?: InputMaybe<Array<FilterFindManyDeviceInput>>;
  OR?: InputMaybe<Array<FilterFindManyDeviceInput>>;
  _id?: InputMaybe<Scalars['String']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterFindManyDeviceOperatorsInput>;
  alertTypes?: InputMaybe<FilterFindManyDeviceAlertTypesInput>;
  controlled?: InputMaybe<FilterFindManyDeviceControlledInput>;
  deviceId?: InputMaybe<Scalars['String']>;
  installation?: InputMaybe<FilterFindManyDeviceInstallationInput>;
  location?: InputMaybe<Scalars['String']>;
  meta?: InputMaybe<FilterFindManyDeviceMetaInput>;
  /** The name of the device */
  name?: InputMaybe<Scalars['String']>;
  outputVoltage?: InputMaybe<FilterFindManyEnergyRectifierOutputVoltageInput>;
  panelId?: InputMaybe<Scalars['String']>;
  powerState?: InputMaybe<FilterFindManyDevicePowerStateInput>;
  propertyId?: InputMaybe<Scalars['String']>;
  rectifierEfficiency?: InputMaybe<FilterFindManyEnergyRectifierRectifierEfficiencyInput>;
  sourceId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  unitId?: InputMaybe<Scalars['String']>;
  updateStatus?: InputMaybe<Scalars['Boolean']>;
  vppId?: InputMaybe<Scalars['String']>;
  zoneId?: InputMaybe<Scalars['String']>;
};

export type FilterFindManyEnergyRectifierOutputVoltageInput = {
  id?: InputMaybe<Scalars['String']>;
  observedAt?: InputMaybe<Scalars['Float']>;
  previousId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  units?: InputMaybe<Scalars['String']>;
  updatePending?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<Scalars['Float']>;
};

export type FilterFindManyEnergyRectifierRectifierEfficiencyInput = {
  id?: InputMaybe<Scalars['String']>;
  observedAt?: InputMaybe<Scalars['Float']>;
  previousId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  units?: InputMaybe<Scalars['String']>;
  updatePending?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<Scalars['Float']>;
};

export type FilterFindManyEnergyStorageBatterySystemInput = {
  AND?: InputMaybe<Array<FilterFindManyEnergyStorageBatterySystemInput>>;
  OR?: InputMaybe<Array<FilterFindManyEnergyStorageBatterySystemInput>>;
  _id?: InputMaybe<Scalars['String']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterFindManyEnergyStorageBatterySystemOperatorsInput>;
  batteryManagementSystemId?: InputMaybe<Scalars['String']>;
  connected?: InputMaybe<FilterFindManyEnergyConsumerBuildingConnectedInput>;
  controllerId?: InputMaybe<Scalars['String']>;
  converterId?: InputMaybe<Scalars['String']>;
  coolingSystemId?: InputMaybe<Scalars['String']>;
  disconnectedAt?: InputMaybe<FilterFindManyEnergyConsumerBuildingDisconnectedAtInput>;
  fireSuppressionSystemId?: InputMaybe<Scalars['String']>;
  inverterId?: InputMaybe<Scalars['String']>;
  lastConnectedAt?: InputMaybe<FilterFindManyEnergyConsumerBuildingLastConnectedAtInput>;
  location?: InputMaybe<Scalars['String']>;
  maintenanceScheduleStatus?: InputMaybe<FilterFindManyEnergyStorageBatterySystemMaintenanceScheduleStatusInput>;
  maximumEnergyCapacity?: InputMaybe<FilterFindManyEnergyStorageBatterySystemMaximumEnergyCapacityInput>;
  modeOfOperation?: InputMaybe<FilterFindManyEnergyStorageBatterySystemModeOfOperationInput>;
  name?: InputMaybe<Scalars['String']>;
  powerState?: InputMaybe<FilterFindManyEnergyConsumerBuildingPowerStateInput>;
  propertyId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  unitId?: InputMaybe<Scalars['String']>;
  updateStatus?: InputMaybe<Scalars['Boolean']>;
  vppId?: InputMaybe<Scalars['String']>;
  /** Constructs a regular expression search based on the string provided */
  withNameLike?: InputMaybe<Scalars['String']>;
};

export type FilterFindManyEnergyStorageBatterySystemMaintenanceScheduleStatusInput =
  {
    id?: InputMaybe<Scalars['String']>;
    observedAt?: InputMaybe<Scalars['Float']>;
    previousId?: InputMaybe<Scalars['String']>;
    timestamp?: InputMaybe<Scalars['Float']>;
    units?: InputMaybe<Scalars['String']>;
    updatePending?: InputMaybe<Scalars['Boolean']>;
    value?: InputMaybe<EnumEnergyStorageBatterySystemMaintenanceScheduleStatusValue>;
  };

export type FilterFindManyEnergyStorageBatterySystemMaximumEnergyCapacityInput =
  {
    id?: InputMaybe<Scalars['String']>;
    observedAt?: InputMaybe<Scalars['Float']>;
    previousId?: InputMaybe<Scalars['String']>;
    timestamp?: InputMaybe<Scalars['Float']>;
    units?: InputMaybe<Scalars['String']>;
    updatePending?: InputMaybe<Scalars['Boolean']>;
    value?: InputMaybe<Scalars['Float']>;
  };

export type FilterFindManyEnergyStorageBatterySystemModeOfOperationInput = {
  id?: InputMaybe<Scalars['String']>;
  observedAt?: InputMaybe<Scalars['Float']>;
  previousId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  units?: InputMaybe<Scalars['String']>;
  updatePending?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<EnumEnergyStorageBatterySystemModeOfOperationValue>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterFindManyEnergyStorageBatterySystemOperatorsInput = {
  _id?: InputMaybe<FilterFindManyEnergyStorageBatterySystem_IdOperatorsInput>;
};

export type FilterFindManyEnergyStorageBatterySystem_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['String']>;
  gte?: InputMaybe<Scalars['String']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  lt?: InputMaybe<Scalars['String']>;
  lte?: InputMaybe<Scalars['String']>;
  ne?: InputMaybe<Scalars['String']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']>;
};

export type FilterFindManyEnergyStorageCoolingSystemCoolingHeatingStatusInput =
  {
    id?: InputMaybe<Scalars['String']>;
    observedAt?: InputMaybe<Scalars['Float']>;
    previousId?: InputMaybe<Scalars['String']>;
    timestamp?: InputMaybe<Scalars['Float']>;
    units?: InputMaybe<Scalars['String']>;
    updatePending?: InputMaybe<Scalars['Boolean']>;
    value?: InputMaybe<EnumEnergyStorageCoolingSystemCoolingHeatingStatusValue>;
  };

export type FilterFindManyEnergyStorageCoolingSystemInput = {
  AND?: InputMaybe<Array<FilterFindManyDeviceInput>>;
  OR?: InputMaybe<Array<FilterFindManyDeviceInput>>;
  _id?: InputMaybe<Scalars['String']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterFindManyDeviceOperatorsInput>;
  alertTypes?: InputMaybe<FilterFindManyDeviceAlertTypesInput>;
  controlled?: InputMaybe<FilterFindManyDeviceControlledInput>;
  coolingHeatingStatus?: InputMaybe<FilterFindManyEnergyStorageCoolingSystemCoolingHeatingStatusInput>;
  deviceId?: InputMaybe<Scalars['String']>;
  installation?: InputMaybe<FilterFindManyDeviceInstallationInput>;
  location?: InputMaybe<Scalars['String']>;
  meta?: InputMaybe<FilterFindManyDeviceMetaInput>;
  /** The name of the device */
  name?: InputMaybe<Scalars['String']>;
  panelId?: InputMaybe<Scalars['String']>;
  powerState?: InputMaybe<FilterFindManyDevicePowerStateInput>;
  propertyId?: InputMaybe<Scalars['String']>;
  sourceId?: InputMaybe<Scalars['String']>;
  temperature?: InputMaybe<FilterFindManyEnergyStorageCoolingSystemTemperatureInput>;
  timestamp?: InputMaybe<Scalars['Float']>;
  unitId?: InputMaybe<Scalars['String']>;
  updateStatus?: InputMaybe<Scalars['Boolean']>;
  vppId?: InputMaybe<Scalars['String']>;
  zoneId?: InputMaybe<Scalars['String']>;
};

export type FilterFindManyEnergyStorageCoolingSystemTemperatureInput = {
  id?: InputMaybe<Scalars['String']>;
  observedAt?: InputMaybe<Scalars['Float']>;
  previousId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  units?: InputMaybe<Scalars['String']>;
  updatePending?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<Scalars['Float']>;
};

export type FilterFindManyEnergyStorageKineticSystemInput = {
  AND?: InputMaybe<Array<FilterFindManyEnergyStorageKineticSystemInput>>;
  OR?: InputMaybe<Array<FilterFindManyEnergyStorageKineticSystemInput>>;
  _id?: InputMaybe<Scalars['String']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterFindManyEnergyStorageKineticSystemOperatorsInput>;
  connected?: InputMaybe<FilterFindManyEnergyConsumerBuildingConnectedInput>;
  controllerId?: InputMaybe<Scalars['String']>;
  converterId?: InputMaybe<Scalars['String']>;
  coolingSystemId?: InputMaybe<Scalars['String']>;
  disconnectedAt?: InputMaybe<FilterFindManyEnergyConsumerBuildingDisconnectedAtInput>;
  fireSuppressionSystemId?: InputMaybe<Scalars['String']>;
  inverterId?: InputMaybe<Scalars['String']>;
  kemsId?: InputMaybe<Scalars['String']>;
  lastConnectedAt?: InputMaybe<FilterFindManyEnergyConsumerBuildingLastConnectedAtInput>;
  location?: InputMaybe<Scalars['String']>;
  maintenanceScheduleStatus?: InputMaybe<FilterFindManyEnergyStorageBatterySystemMaintenanceScheduleStatusInput>;
  maximumEnergyCapacity?: InputMaybe<FilterFindManyEnergyStorageBatterySystemMaximumEnergyCapacityInput>;
  modeOfOperation?: InputMaybe<FilterFindManyEnergyStorageBatterySystemModeOfOperationInput>;
  name?: InputMaybe<Scalars['String']>;
  powerState?: InputMaybe<FilterFindManyEnergyConsumerBuildingPowerStateInput>;
  propertyId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  unitId?: InputMaybe<Scalars['String']>;
  updateStatus?: InputMaybe<Scalars['Boolean']>;
  vppId?: InputMaybe<Scalars['String']>;
  /** Constructs a regular expression search based on the string provided */
  withNameLike?: InputMaybe<Scalars['String']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterFindManyEnergyStorageKineticSystemOperatorsInput = {
  _id?: InputMaybe<FilterFindManyEnergyStorageKineticSystem_IdOperatorsInput>;
};

export type FilterFindManyEnergyStorageKineticSystem_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['String']>;
  gte?: InputMaybe<Scalars['String']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  lt?: InputMaybe<Scalars['String']>;
  lte?: InputMaybe<Scalars['String']>;
  ne?: InputMaybe<Scalars['String']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']>;
};

export type FilterFindManyEnergySupplierSolarSystemAzimuthInput = {
  id?: InputMaybe<Scalars['String']>;
  observedAt?: InputMaybe<Scalars['Float']>;
  previousId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  units?: InputMaybe<Scalars['String']>;
  updatePending?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<Scalars['Float']>;
};

export type FilterFindManyEnergySupplierSolarSystemInput = {
  AND?: InputMaybe<Array<FilterFindManyEnergySupplierSolarSystemInput>>;
  OR?: InputMaybe<Array<FilterFindManyEnergySupplierSolarSystemInput>>;
  _id?: InputMaybe<Scalars['String']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterFindManyEnergySupplierSolarSystemOperatorsInput>;
  azimuth?: InputMaybe<FilterFindManyEnergySupplierSolarSystemAzimuthInput>;
  connected?: InputMaybe<FilterFindManyEnergyConsumerBuildingConnectedInput>;
  controllerId?: InputMaybe<Scalars['String']>;
  disconnectedAt?: InputMaybe<FilterFindManyEnergyConsumerBuildingDisconnectedAtInput>;
  inverterId?: InputMaybe<Scalars['String']>;
  lastConnectedAt?: InputMaybe<FilterFindManyEnergyConsumerBuildingLastConnectedAtInput>;
  location?: InputMaybe<Scalars['String']>;
  maximumPowerOutput?: InputMaybe<Scalars['Float']>;
  name?: InputMaybe<Scalars['String']>;
  powerState?: InputMaybe<FilterFindManyEnergyConsumerBuildingPowerStateInput>;
  propertyId?: InputMaybe<Scalars['String']>;
  smsId?: InputMaybe<Scalars['String']>;
  tiltAngle?: InputMaybe<FilterFindManyEnergySupplierSolarSystemTiltAngleInput>;
  timestamp?: InputMaybe<Scalars['Float']>;
  unitId?: InputMaybe<Scalars['String']>;
  updateStatus?: InputMaybe<Scalars['Boolean']>;
  vppId?: InputMaybe<Scalars['String']>;
  /** Constructs a regular expression search based on the string provided */
  withNameLike?: InputMaybe<Scalars['String']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterFindManyEnergySupplierSolarSystemOperatorsInput = {
  _id?: InputMaybe<FilterFindManyEnergySupplierSolarSystem_IdOperatorsInput>;
};

export type FilterFindManyEnergySupplierSolarSystemTiltAngleInput = {
  id?: InputMaybe<Scalars['String']>;
  observedAt?: InputMaybe<Scalars['Float']>;
  previousId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  units?: InputMaybe<Scalars['String']>;
  updatePending?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<Scalars['Float']>;
};

export type FilterFindManyEnergySupplierSolarSystem_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['String']>;
  gte?: InputMaybe<Scalars['String']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  lt?: InputMaybe<Scalars['String']>;
  lte?: InputMaybe<Scalars['String']>;
  ne?: InputMaybe<Scalars['String']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']>;
};

export type FilterFindManyEnergySupplierUtilityContractedCapacityInput = {
  id?: InputMaybe<Scalars['String']>;
  observedAt?: InputMaybe<Scalars['Float']>;
  previousId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  units?: InputMaybe<Scalars['String']>;
  updatePending?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<Scalars['Float']>;
};

export type FilterFindManyEnergySupplierUtilityInput = {
  AND?: InputMaybe<Array<FilterFindManyEnergySupplierUtilityInput>>;
  OR?: InputMaybe<Array<FilterFindManyEnergySupplierUtilityInput>>;
  _id?: InputMaybe<Scalars['String']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterFindManyEnergySupplierUtilityOperatorsInput>;
  connected?: InputMaybe<FilterFindManyEnergyConsumerBuildingConnectedInput>;
  contractedCapacity?: InputMaybe<FilterFindManyEnergySupplierUtilityContractedCapacityInput>;
  controllerId?: InputMaybe<Scalars['String']>;
  disconnectedAt?: InputMaybe<FilterFindManyEnergyConsumerBuildingDisconnectedAtInput>;
  inverterId?: InputMaybe<Scalars['String']>;
  lastConnectedAt?: InputMaybe<FilterFindManyEnergyConsumerBuildingLastConnectedAtInput>;
  location?: InputMaybe<Scalars['String']>;
  maximumPowerOutput?: InputMaybe<Scalars['Float']>;
  meteringAccuracy?: InputMaybe<FilterFindManyEnergySupplierUtilityMeteringAccuracyInput>;
  name?: InputMaybe<Scalars['String']>;
  powerState?: InputMaybe<FilterFindManyEnergyConsumerBuildingPowerStateInput>;
  propertyId?: InputMaybe<Scalars['String']>;
  tariffRate?: InputMaybe<FilterFindManyEnergySupplierUtilityTariffRateInput>;
  timestamp?: InputMaybe<Scalars['Float']>;
  unitId?: InputMaybe<Scalars['String']>;
  updateStatus?: InputMaybe<Scalars['Boolean']>;
  vppId?: InputMaybe<Scalars['String']>;
  /** Constructs a regular expression search based on the string provided */
  withNameLike?: InputMaybe<Scalars['String']>;
};

export type FilterFindManyEnergySupplierUtilityMeteringAccuracyInput = {
  id?: InputMaybe<Scalars['String']>;
  observedAt?: InputMaybe<Scalars['Float']>;
  previousId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  units?: InputMaybe<Scalars['String']>;
  updatePending?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<Scalars['Float']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterFindManyEnergySupplierUtilityOperatorsInput = {
  _id?: InputMaybe<FilterFindManyEnergySupplierUtility_IdOperatorsInput>;
};

export type FilterFindManyEnergySupplierUtilityTariffRateInput = {
  id?: InputMaybe<Scalars['String']>;
  observedAt?: InputMaybe<Scalars['Float']>;
  previousId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  units?: InputMaybe<Scalars['String']>;
  updatePending?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<Scalars['Float']>;
};

export type FilterFindManyEnergySupplierUtility_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['String']>;
  gte?: InputMaybe<Scalars['String']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  lt?: InputMaybe<Scalars['String']>;
  lte?: InputMaybe<Scalars['String']>;
  ne?: InputMaybe<Scalars['String']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']>;
};

export type FilterFindManyEnergySupplierWindSystemCutInSpeedInput = {
  id?: InputMaybe<Scalars['String']>;
  observedAt?: InputMaybe<Scalars['Float']>;
  previousId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  units?: InputMaybe<Scalars['String']>;
  updatePending?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<Scalars['Float']>;
};

export type FilterFindManyEnergySupplierWindSystemCutOutSpeedInput = {
  id?: InputMaybe<Scalars['String']>;
  observedAt?: InputMaybe<Scalars['Float']>;
  previousId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  units?: InputMaybe<Scalars['String']>;
  updatePending?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<Scalars['Float']>;
};

export type FilterFindManyEnergySupplierWindSystemInput = {
  AND?: InputMaybe<Array<FilterFindManyEnergySupplierWindSystemInput>>;
  OR?: InputMaybe<Array<FilterFindManyEnergySupplierWindSystemInput>>;
  _id?: InputMaybe<Scalars['String']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterFindManyEnergySupplierWindSystemOperatorsInput>;
  connected?: InputMaybe<FilterFindManyEnergyConsumerBuildingConnectedInput>;
  controllerId?: InputMaybe<Scalars['String']>;
  cutInSpeed?: InputMaybe<FilterFindManyEnergySupplierWindSystemCutInSpeedInput>;
  cutOutSpeed?: InputMaybe<FilterFindManyEnergySupplierWindSystemCutOutSpeedInput>;
  disconnectedAt?: InputMaybe<FilterFindManyEnergyConsumerBuildingDisconnectedAtInput>;
  inverterId?: InputMaybe<Scalars['String']>;
  lastConnectedAt?: InputMaybe<FilterFindManyEnergyConsumerBuildingLastConnectedAtInput>;
  location?: InputMaybe<Scalars['String']>;
  maximumPowerOutput?: InputMaybe<Scalars['Float']>;
  modeOfOperation?: InputMaybe<FilterFindManyEnergySupplierWindSystemModeOfOperationInput>;
  name?: InputMaybe<Scalars['String']>;
  powerState?: InputMaybe<FilterFindManyEnergyConsumerBuildingPowerStateInput>;
  propertyId?: InputMaybe<Scalars['String']>;
  rectifierId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  unitId?: InputMaybe<Scalars['String']>;
  updateStatus?: InputMaybe<Scalars['Boolean']>;
  vppId?: InputMaybe<Scalars['String']>;
  /** Constructs a regular expression search based on the string provided */
  withNameLike?: InputMaybe<Scalars['String']>;
  wmsId?: InputMaybe<Scalars['String']>;
};

export type FilterFindManyEnergySupplierWindSystemModeOfOperationInput = {
  id?: InputMaybe<Scalars['String']>;
  observedAt?: InputMaybe<Scalars['Float']>;
  previousId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  units?: InputMaybe<Scalars['String']>;
  updatePending?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<EnumEnergySupplierWindSystemModeOfOperationValue>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterFindManyEnergySupplierWindSystemOperatorsInput = {
  _id?: InputMaybe<FilterFindManyEnergySupplierWindSystem_IdOperatorsInput>;
};

export type FilterFindManyEnergySupplierWindSystem_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['String']>;
  gte?: InputMaybe<Scalars['String']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  lt?: InputMaybe<Scalars['String']>;
  lte?: InputMaybe<Scalars['String']>;
  ne?: InputMaybe<Scalars['String']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']>;
};

export type FilterFindManyEnergySwitchPanelCircuitCurrentInput = {
  id?: InputMaybe<Scalars['String']>;
  observedAt?: InputMaybe<Scalars['Float']>;
  previousId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  units?: InputMaybe<Scalars['String']>;
  updatePending?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<Scalars['Float']>;
};

export type FilterFindManyEnergySwitchPanelCircuitEnergyConsumedInput = {
  id?: InputMaybe<Scalars['String']>;
  observedAt?: InputMaybe<Scalars['Float']>;
  previousId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  units?: InputMaybe<Scalars['String']>;
  updatePending?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<Scalars['Float']>;
};

export type FilterFindManyEnergySwitchPanelCircuitFrequencyInput = {
  id?: InputMaybe<Scalars['String']>;
  observedAt?: InputMaybe<Scalars['Float']>;
  previousId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  units?: InputMaybe<Scalars['String']>;
  updatePending?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<Scalars['Float']>;
};

export type FilterFindManyEnergySwitchPanelCircuitInput = {
  AND?: InputMaybe<Array<FilterFindManyDeviceInput>>;
  OR?: InputMaybe<Array<FilterFindManyDeviceInput>>;
  _id?: InputMaybe<Scalars['String']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterFindManyDeviceOperatorsInput>;
  alertTypes?: InputMaybe<FilterFindManyDeviceAlertTypesInput>;
  controlled?: InputMaybe<FilterFindManyDeviceControlledInput>;
  current?: InputMaybe<FilterFindManyEnergySwitchPanelCircuitCurrentInput>;
  deviceId?: InputMaybe<Scalars['String']>;
  energyConsumed?: InputMaybe<FilterFindManyEnergySwitchPanelCircuitEnergyConsumedInput>;
  energySwitchPanelId?: InputMaybe<Scalars['String']>;
  frequency?: InputMaybe<FilterFindManyEnergySwitchPanelCircuitFrequencyInput>;
  installation?: InputMaybe<FilterFindManyDeviceInstallationInput>;
  location?: InputMaybe<Scalars['String']>;
  meta?: InputMaybe<FilterFindManyDeviceMetaInput>;
  /** The name of the device */
  name?: InputMaybe<Scalars['String']>;
  outputEnabled?: InputMaybe<FilterFindManyEnergySwitchPanelCircuitOutputEnabledInput>;
  panelId?: InputMaybe<Scalars['String']>;
  powerDemand?: InputMaybe<FilterFindManyEnergySwitchPanelCircuitPowerDemandInput>;
  powerFactor?: InputMaybe<FilterFindManyEnergySwitchPanelCircuitPowerFactorInput>;
  powerState?: InputMaybe<FilterFindManyDevicePowerStateInput>;
  propertyId?: InputMaybe<Scalars['String']>;
  sourceId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  unitId?: InputMaybe<Scalars['String']>;
  updateStatus?: InputMaybe<Scalars['Boolean']>;
  voltage?: InputMaybe<FilterFindManyEnergySwitchPanelCircuitVoltageInput>;
  vppId?: InputMaybe<Scalars['String']>;
  zoneId?: InputMaybe<Scalars['String']>;
};

export type FilterFindManyEnergySwitchPanelCircuitOutputEnabledInput = {
  id?: InputMaybe<Scalars['String']>;
  observedAt?: InputMaybe<Scalars['Float']>;
  previousId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  units?: InputMaybe<Scalars['String']>;
  updatePending?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<Scalars['Boolean']>;
};

export type FilterFindManyEnergySwitchPanelCircuitPowerDemandInput = {
  id?: InputMaybe<Scalars['String']>;
  observedAt?: InputMaybe<Scalars['Float']>;
  previousId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  units?: InputMaybe<Scalars['String']>;
  updatePending?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<Scalars['Float']>;
};

export type FilterFindManyEnergySwitchPanelCircuitPowerFactorInput = {
  id?: InputMaybe<Scalars['String']>;
  observedAt?: InputMaybe<Scalars['Float']>;
  previousId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  units?: InputMaybe<Scalars['String']>;
  updatePending?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<Scalars['Float']>;
};

export type FilterFindManyEnergySwitchPanelCircuitVoltageInput = {
  id?: InputMaybe<Scalars['String']>;
  observedAt?: InputMaybe<Scalars['Float']>;
  previousId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  units?: InputMaybe<Scalars['String']>;
  updatePending?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<Scalars['Float']>;
};

export type FilterFindManyEnergySwitchPanelInput = {
  AND?: InputMaybe<Array<FilterFindManyDeviceInput>>;
  OR?: InputMaybe<Array<FilterFindManyDeviceInput>>;
  _id?: InputMaybe<Scalars['String']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterFindManyDeviceOperatorsInput>;
  alertTypes?: InputMaybe<FilterFindManyDeviceAlertTypesInput>;
  controlled?: InputMaybe<FilterFindManyDeviceControlledInput>;
  deviceId?: InputMaybe<Scalars['String']>;
  installation?: InputMaybe<FilterFindManyDeviceInstallationInput>;
  location?: InputMaybe<Scalars['String']>;
  maxCircuits?: InputMaybe<Scalars['Float']>;
  meta?: InputMaybe<FilterFindManyDeviceMetaInput>;
  /** The name of the device */
  name?: InputMaybe<Scalars['String']>;
  panelId?: InputMaybe<Scalars['String']>;
  powerInput?: InputMaybe<FilterFindManyEnergySwitchPanelPowerInputInput>;
  powerState?: InputMaybe<FilterFindManyDevicePowerStateInput>;
  propertyId?: InputMaybe<Scalars['String']>;
  sourceId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  unitId?: InputMaybe<Scalars['String']>;
  updateStatus?: InputMaybe<Scalars['Boolean']>;
  vppId?: InputMaybe<Scalars['String']>;
  zoneId?: InputMaybe<Scalars['String']>;
};

export type FilterFindManyEnergySwitchPanelPowerInputInput = {
  id?: InputMaybe<Scalars['String']>;
  observedAt?: InputMaybe<Scalars['Float']>;
  previousId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  units?: InputMaybe<Scalars['String']>;
  updatePending?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<Scalars['Float']>;
};

export type FilterFindManyFireSuppressionSystemFireSuppressionStatusInput = {
  id?: InputMaybe<Scalars['String']>;
  observedAt?: InputMaybe<Scalars['Float']>;
  previousId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  units?: InputMaybe<Scalars['String']>;
  updatePending?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<EnumFireSuppressionSystemFireSuppressionStatusValue>;
};

export type FilterFindManyFireSuppressionSystemInput = {
  AND?: InputMaybe<Array<FilterFindManyDeviceInput>>;
  OR?: InputMaybe<Array<FilterFindManyDeviceInput>>;
  _id?: InputMaybe<Scalars['String']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterFindManyDeviceOperatorsInput>;
  alertTypes?: InputMaybe<FilterFindManyDeviceAlertTypesInput>;
  controlled?: InputMaybe<FilterFindManyDeviceControlledInput>;
  deviceId?: InputMaybe<Scalars['String']>;
  fireSuppressionStatus?: InputMaybe<FilterFindManyFireSuppressionSystemFireSuppressionStatusInput>;
  installation?: InputMaybe<FilterFindManyDeviceInstallationInput>;
  location?: InputMaybe<Scalars['String']>;
  meta?: InputMaybe<FilterFindManyDeviceMetaInput>;
  /** The name of the device */
  name?: InputMaybe<Scalars['String']>;
  panelId?: InputMaybe<Scalars['String']>;
  powerState?: InputMaybe<FilterFindManyDevicePowerStateInput>;
  propertyId?: InputMaybe<Scalars['String']>;
  sensorStatus?: InputMaybe<FilterFindManyFireSuppressionSystemSensorStatusInput>;
  sourceId?: InputMaybe<Scalars['String']>;
  suppressantLevel?: InputMaybe<FilterFindManyFireSuppressionSystemSuppressantLevelInput>;
  timestamp?: InputMaybe<Scalars['Float']>;
  unitId?: InputMaybe<Scalars['String']>;
  updateStatus?: InputMaybe<Scalars['Boolean']>;
  vppId?: InputMaybe<Scalars['String']>;
  zoneId?: InputMaybe<Scalars['String']>;
};

export type FilterFindManyFireSuppressionSystemSensorStatusInput = {
  id?: InputMaybe<Scalars['String']>;
  observedAt?: InputMaybe<Scalars['Float']>;
  previousId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  units?: InputMaybe<Scalars['String']>;
  updatePending?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<EnumFireSuppressionSystemSensorStatusValue>;
};

export type FilterFindManyFireSuppressionSystemSuppressantLevelInput = {
  id?: InputMaybe<Scalars['String']>;
  observedAt?: InputMaybe<Scalars['Float']>;
  previousId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  units?: InputMaybe<Scalars['String']>;
  updatePending?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<Scalars['Float']>;
};

export type FilterFindManyFloorInput = {
  AND?: InputMaybe<Array<FilterFindManyFloorInput>>;
  OR?: InputMaybe<Array<FilterFindManyFloorInput>>;
  _id?: InputMaybe<Scalars['String']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterFindManyFloorOperatorsInput>;
  buildingId?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  number?: InputMaybe<Scalars['Float']>;
  propertyId?: InputMaybe<Scalars['String']>;
  /** Constructs a regular expression search based on the string provided */
  withNameLike?: InputMaybe<Scalars['String']>;
};

export type FilterFindManyFloorNameOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['String']>;
  gte?: InputMaybe<Scalars['String']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  lt?: InputMaybe<Scalars['String']>;
  lte?: InputMaybe<Scalars['String']>;
  ne?: InputMaybe<Scalars['String']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterFindManyFloorOperatorsInput = {
  _id?: InputMaybe<FilterFindManyFloor_IdOperatorsInput>;
  name?: InputMaybe<FilterFindManyFloorNameOperatorsInput>;
};

export type FilterFindManyFloor_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['String']>;
  gte?: InputMaybe<Scalars['String']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  lt?: InputMaybe<Scalars['String']>;
  lte?: InputMaybe<Scalars['String']>;
  ne?: InputMaybe<Scalars['String']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']>;
};

export type FilterFindManyGpioInput = {
  AND?: InputMaybe<Array<FilterFindManyDeviceInput>>;
  OR?: InputMaybe<Array<FilterFindManyDeviceInput>>;
  _id?: InputMaybe<Scalars['String']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterFindManyDeviceOperatorsInput>;
  alertTypes?: InputMaybe<FilterFindManyDeviceAlertTypesInput>;
  controlled?: InputMaybe<FilterFindManyDeviceControlledInput>;
  deviceId?: InputMaybe<Scalars['String']>;
  installation?: InputMaybe<FilterFindManyDeviceInstallationInput>;
  location?: InputMaybe<Scalars['String']>;
  meta?: InputMaybe<FilterFindManyDeviceMetaInput>;
  /** The name of the device */
  name?: InputMaybe<Scalars['String']>;
  panelId?: InputMaybe<Scalars['String']>;
  powerState?: InputMaybe<FilterFindManyDevicePowerStateInput>;
  propertyId?: InputMaybe<Scalars['String']>;
  sourceId?: InputMaybe<Scalars['String']>;
  state?: InputMaybe<FilterFindManyGpioStateInput>;
  timestamp?: InputMaybe<Scalars['Float']>;
  unitId?: InputMaybe<Scalars['String']>;
  updateStatus?: InputMaybe<Scalars['Boolean']>;
  vppId?: InputMaybe<Scalars['String']>;
  zoneId?: InputMaybe<Scalars['String']>;
};

export type FilterFindManyGpioStateInput = {
  id?: InputMaybe<Scalars['String']>;
  observedAt?: InputMaybe<Scalars['Float']>;
  previousId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  units?: InputMaybe<Scalars['String']>;
  updatePending?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<Scalars['Boolean']>;
};

export type FilterFindManyHmmInput = {
  AND?: InputMaybe<Array<FilterFindManySourceInput>>;
  OR?: InputMaybe<Array<FilterFindManySourceInput>>;
  _id?: InputMaybe<Scalars['String']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterFindManySourceOperatorsInput>;
  hmmUniqueId?: InputMaybe<Scalars['String']>;
  maxReportingTime?: InputMaybe<Scalars['Float']>;
  name?: InputMaybe<Scalars['String']>;
  propertyId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  tolerances?: InputMaybe<FilterFindManyHmmTolerancesInput>;
  url?: InputMaybe<Scalars['String']>;
};

export type FilterFindManyHmmTolerancesInput = {
  temperature?: InputMaybe<Scalars['Float']>;
};

export type FilterFindManyHistoricAlertAlertCategoryInput = {
  id?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
};

export type FilterFindManyHistoricAlertAlertTriggerInput = {
  id?: InputMaybe<Scalars['String']>;
  key?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
};

export type FilterFindManyHistoricAlertBuildingInput = {
  id?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
};

export type FilterFindManyHistoricAlertDeviceInput = {
  id?: InputMaybe<Scalars['String']>;
  model?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  role?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<Scalars['String']>;
  version?: InputMaybe<Scalars['String']>;
};

export type FilterFindManyHistoricAlertInput = {
  AND?: InputMaybe<Array<FilterFindManyHistoricAlertInput>>;
  OR?: InputMaybe<Array<FilterFindManyHistoricAlertInput>>;
  _id?: InputMaybe<Scalars['String']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterFindManyHistoricAlertOperatorsInput>;
  alertCategory?: InputMaybe<FilterFindManyHistoricAlertAlertCategoryInput>;
  alertTrigger?: InputMaybe<FilterFindManyHistoricAlertAlertTriggerInput>;
  building?: InputMaybe<FilterFindManyHistoricAlertBuildingInput>;
  device?: InputMaybe<FilterFindManyHistoricAlertDeviceInput>;
  id?: InputMaybe<Scalars['String']>;
  initiated?: InputMaybe<Scalars['Float']>;
  meta?: InputMaybe<FilterFindManyHistoricAlertMetaInput>;
  panel?: InputMaybe<FilterFindManyHistoricAlertPanelInput>;
  port?: InputMaybe<EnumHistoricAlertPort>;
  property?: InputMaybe<FilterFindManyHistoricAlertPropertyInput>;
  resolved?: InputMaybe<Scalars['Float']>;
  sourceId?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<FilterFindManyHistoricAlertTypeInput>;
  unit?: InputMaybe<FilterFindManyHistoricAlertUnitInput>;
  updated?: InputMaybe<Scalars['Float']>;
  zone?: InputMaybe<FilterFindManyHistoricAlertZoneInput>;
};

export type FilterFindManyHistoricAlertMetaInput = {
  id_str?: InputMaybe<Scalars['String']>;
  limit?: InputMaybe<Scalars['Float']>;
  message?: InputMaybe<Scalars['String']>;
  portName?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<Scalars['String']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterFindManyHistoricAlertOperatorsInput = {
  _id?: InputMaybe<FilterFindManyHistoricAlert_IdOperatorsInput>;
};

export type FilterFindManyHistoricAlertPanelInput = {
  id?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
};

export type FilterFindManyHistoricAlertPropertyContactInput = {
  email?: InputMaybe<Scalars['String']>;
  email2?: InputMaybe<Scalars['String']>;
  email3?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  smsNumber?: InputMaybe<Scalars['String']>;
  smsNumber2?: InputMaybe<Scalars['String']>;
  smsNumber3?: InputMaybe<Scalars['String']>;
  smsOptInStatus1?: InputMaybe<EnumHistoricAlertPropertyContactSmsOptInStatus1>;
  smsOptInStatus2?: InputMaybe<EnumHistoricAlertPropertyContactSmsOptInStatus2>;
  smsOptInStatus3?: InputMaybe<EnumHistoricAlertPropertyContactSmsOptInStatus3>;
  smsOptInTimestamp1?: InputMaybe<Scalars['Float']>;
  smsOptInTimestamp2?: InputMaybe<Scalars['Float']>;
  smsOptInTimestamp3?: InputMaybe<Scalars['Float']>;
};

export type FilterFindManyHistoricAlertPropertyInput = {
  contact?: InputMaybe<FilterFindManyHistoricAlertPropertyContactInput>;
  id?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
};

export type FilterFindManyHistoricAlertTypeInput = {
  id?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
};

export type FilterFindManyHistoricAlertUnitInput = {
  id?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
};

export type FilterFindManyHistoricAlertZoneInput = {
  id?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
};

export type FilterFindManyHistoricAlert_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['String']>;
  gte?: InputMaybe<Scalars['String']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  lt?: InputMaybe<Scalars['String']>;
  lte?: InputMaybe<Scalars['String']>;
  ne?: InputMaybe<Scalars['String']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']>;
};

export type FilterFindManyHistoricReadingDeviceIdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['String']>;
  gte?: InputMaybe<Scalars['String']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  lt?: InputMaybe<Scalars['String']>;
  lte?: InputMaybe<Scalars['String']>;
  ne?: InputMaybe<Scalars['String']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']>;
};

export type FilterFindManyHistoricReadingInput = {
  AND?: InputMaybe<Array<FilterFindManyHistoricReadingInput>>;
  OR?: InputMaybe<Array<FilterFindManyHistoricReadingInput>>;
  _id?: InputMaybe<Scalars['String']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterFindManyHistoricReadingOperatorsInput>;
  deviceId?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  sourceId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  type?: InputMaybe<Scalars['String']>;
  units?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<Scalars['String']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterFindManyHistoricReadingOperatorsInput = {
  _id?: InputMaybe<FilterFindManyHistoricReading_IdOperatorsInput>;
  deviceId?: InputMaybe<FilterFindManyHistoricReadingDeviceIdOperatorsInput>;
};

export type FilterFindManyHistoricReading_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['String']>;
  gte?: InputMaybe<Scalars['String']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  lt?: InputMaybe<Scalars['String']>;
  lte?: InputMaybe<Scalars['String']>;
  ne?: InputMaybe<Scalars['String']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']>;
};

export type FilterFindManyIndoorAirHandlerCoolSetpointInput = {
  id?: InputMaybe<Scalars['String']>;
  observedAt?: InputMaybe<Scalars['Float']>;
  previousId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  units?: InputMaybe<Scalars['String']>;
  updatePending?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<Scalars['Float']>;
};

export type FilterFindManyIndoorAirHandlerFanSpeedInput = {
  id?: InputMaybe<Scalars['String']>;
  observedAt?: InputMaybe<Scalars['Float']>;
  previousId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  units?: InputMaybe<Scalars['String']>;
  updatePending?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<Scalars['String']>;
};

export type FilterFindManyIndoorAirHandlerHeatSetpointInput = {
  id?: InputMaybe<Scalars['String']>;
  observedAt?: InputMaybe<Scalars['Float']>;
  previousId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  units?: InputMaybe<Scalars['String']>;
  updatePending?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<Scalars['Float']>;
};

export type FilterFindManyIndoorAirHandlerIndoorFanStatusInput = {
  id?: InputMaybe<Scalars['String']>;
  observedAt?: InputMaybe<Scalars['Float']>;
  previousId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  units?: InputMaybe<Scalars['String']>;
  updatePending?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<EnumIndoorAirHandlerIndoorFanStatusValue>;
};

export type FilterFindManyIndoorAirHandlerInput = {
  AND?: InputMaybe<Array<FilterFindManyDeviceInput>>;
  OR?: InputMaybe<Array<FilterFindManyDeviceInput>>;
  _id?: InputMaybe<Scalars['String']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterFindManyDeviceOperatorsInput>;
  alertTypes?: InputMaybe<FilterFindManyDeviceAlertTypesInput>;
  altDeviceId?: InputMaybe<Scalars['String']>;
  controlled?: InputMaybe<FilterFindManyDeviceControlledInput>;
  coolSetpoint?: InputMaybe<FilterFindManyIndoorAirHandlerCoolSetpointInput>;
  deviceId?: InputMaybe<Scalars['String']>;
  fanSpeed?: InputMaybe<FilterFindManyIndoorAirHandlerFanSpeedInput>;
  heatSetpoint?: InputMaybe<FilterFindManyIndoorAirHandlerHeatSetpointInput>;
  indoorFanStatus?: InputMaybe<FilterFindManyIndoorAirHandlerIndoorFanStatusInput>;
  installation?: InputMaybe<FilterFindManyDeviceInstallationInput>;
  location?: InputMaybe<Scalars['String']>;
  maxCoolSetpointLimit?: InputMaybe<FilterFindManyIndoorAirHandlerMaxCoolSetpointLimitInput>;
  maxHeatSetpointLimit?: InputMaybe<FilterFindManyIndoorAirHandlerMaxHeatSetpointLimitInput>;
  meta?: InputMaybe<FilterFindManyDeviceMetaInput>;
  minCoolSetpointLimit?: InputMaybe<FilterFindManyIndoorAirHandlerMinCoolSetpointLimitInput>;
  minHeatSetpointLimit?: InputMaybe<FilterFindManyIndoorAirHandlerMinHeatSetpointLimitInput>;
  /** The name of the device */
  name?: InputMaybe<Scalars['String']>;
  operatingMode?: InputMaybe<FilterFindManyIndoorAirHandlerOperatingModeInput>;
  operatingState?: InputMaybe<FilterFindManyIndoorAirHandlerOperatingStateInput>;
  panelId?: InputMaybe<Scalars['String']>;
  powerState?: InputMaybe<FilterFindManyDevicePowerStateInput>;
  propertyId?: InputMaybe<Scalars['String']>;
  sourceId?: InputMaybe<Scalars['String']>;
  temperature?: InputMaybe<FilterFindManyIndoorAirHandlerTemperatureInput>;
  timestamp?: InputMaybe<Scalars['Float']>;
  unitId?: InputMaybe<Scalars['String']>;
  updateStatus?: InputMaybe<Scalars['Boolean']>;
  vppId?: InputMaybe<Scalars['String']>;
  zoneId?: InputMaybe<Scalars['String']>;
};

export type FilterFindManyIndoorAirHandlerMaxCoolSetpointLimitInput = {
  id?: InputMaybe<Scalars['String']>;
  observedAt?: InputMaybe<Scalars['Float']>;
  previousId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  units?: InputMaybe<Scalars['String']>;
  updatePending?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<Scalars['Float']>;
};

export type FilterFindManyIndoorAirHandlerMaxHeatSetpointLimitInput = {
  id?: InputMaybe<Scalars['String']>;
  observedAt?: InputMaybe<Scalars['Float']>;
  previousId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  units?: InputMaybe<Scalars['String']>;
  updatePending?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<Scalars['Float']>;
};

export type FilterFindManyIndoorAirHandlerMinCoolSetpointLimitInput = {
  id?: InputMaybe<Scalars['String']>;
  observedAt?: InputMaybe<Scalars['Float']>;
  previousId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  units?: InputMaybe<Scalars['String']>;
  updatePending?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<Scalars['Float']>;
};

export type FilterFindManyIndoorAirHandlerMinHeatSetpointLimitInput = {
  id?: InputMaybe<Scalars['String']>;
  observedAt?: InputMaybe<Scalars['Float']>;
  previousId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  units?: InputMaybe<Scalars['String']>;
  updatePending?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<Scalars['Float']>;
};

export type FilterFindManyIndoorAirHandlerOperatingModeInput = {
  id?: InputMaybe<Scalars['String']>;
  observedAt?: InputMaybe<Scalars['Float']>;
  previousId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  units?: InputMaybe<Scalars['String']>;
  updatePending?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<Scalars['String']>;
};

export type FilterFindManyIndoorAirHandlerOperatingStateInput = {
  id?: InputMaybe<Scalars['String']>;
  observedAt?: InputMaybe<Scalars['Float']>;
  previousId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  units?: InputMaybe<Scalars['String']>;
  updatePending?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<Scalars['String']>;
};

export type FilterFindManyIndoorAirHandlerTemperatureInput = {
  id?: InputMaybe<Scalars['String']>;
  observedAt?: InputMaybe<Scalars['Float']>;
  previousId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  units?: InputMaybe<Scalars['String']>;
  updatePending?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<Scalars['Float']>;
};

export type FilterFindManyIndoorSensorHumidityInput = {
  id?: InputMaybe<Scalars['String']>;
  observedAt?: InputMaybe<Scalars['Float']>;
  previousId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  units?: InputMaybe<Scalars['String']>;
  updatePending?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<Scalars['Float']>;
};

export type FilterFindManyIndoorSensorInput = {
  AND?: InputMaybe<Array<FilterFindManyDeviceInput>>;
  OR?: InputMaybe<Array<FilterFindManyDeviceInput>>;
  _id?: InputMaybe<Scalars['String']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterFindManyDeviceOperatorsInput>;
  alertTypes?: InputMaybe<FilterFindManyDeviceAlertTypesInput>;
  controlled?: InputMaybe<FilterFindManyDeviceControlledInput>;
  deviceId?: InputMaybe<Scalars['String']>;
  humidity?: InputMaybe<FilterFindManyIndoorSensorHumidityInput>;
  installation?: InputMaybe<FilterFindManyDeviceInstallationInput>;
  location?: InputMaybe<Scalars['String']>;
  meta?: InputMaybe<FilterFindManyDeviceMetaInput>;
  /** The name of the device */
  name?: InputMaybe<Scalars['String']>;
  occupancy?: InputMaybe<FilterFindManyIndoorSensorOccupancyInput>;
  panelId?: InputMaybe<Scalars['String']>;
  powerState?: InputMaybe<FilterFindManyDevicePowerStateInput>;
  propertyId?: InputMaybe<Scalars['String']>;
  sourceId?: InputMaybe<Scalars['String']>;
  temperature?: InputMaybe<FilterFindManyIndoorSensorTemperatureInput>;
  timestamp?: InputMaybe<Scalars['Float']>;
  unitId?: InputMaybe<Scalars['String']>;
  updateStatus?: InputMaybe<Scalars['Boolean']>;
  voltage?: InputMaybe<FilterFindManyIndoorSensorVoltageInput>;
  vppId?: InputMaybe<Scalars['String']>;
  zoneId?: InputMaybe<Scalars['String']>;
};

export type FilterFindManyIndoorSensorOccupancyInput = {
  timestamp?: InputMaybe<Scalars['Float']>;
};

export type FilterFindManyIndoorSensorTemperatureInput = {
  id?: InputMaybe<Scalars['String']>;
  observedAt?: InputMaybe<Scalars['Float']>;
  previousId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  units?: InputMaybe<Scalars['String']>;
  updatePending?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<Scalars['Float']>;
};

export type FilterFindManyIndoorSensorVoltageInput = {
  id?: InputMaybe<Scalars['String']>;
  observedAt?: InputMaybe<Scalars['Float']>;
  previousId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  units?: InputMaybe<Scalars['String']>;
  updatePending?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<Scalars['Float']>;
};

export type FilterFindManyIngestionInput = {
  AND?: InputMaybe<Array<FilterFindManyIngestionInput>>;
  OR?: InputMaybe<Array<FilterFindManyIngestionInput>>;
  _id?: InputMaybe<Scalars['String']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterFindManyIngestionOperatorsInput>;
  date?: InputMaybe<Scalars['Date']>;
  fileName?: InputMaybe<Scalars['String']>;
  s3FileName?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<Scalars['String']>;
  userId?: InputMaybe<Scalars['String']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterFindManyIngestionOperatorsInput = {
  _id?: InputMaybe<FilterFindManyIngestion_IdOperatorsInput>;
};

export type FilterFindManyIngestion_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['String']>;
  gte?: InputMaybe<Scalars['String']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  lt?: InputMaybe<Scalars['String']>;
  lte?: InputMaybe<Scalars['String']>;
  ne?: InputMaybe<Scalars['String']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']>;
};

export type FilterFindManyKineticEnergyManagementSystemBearingTemperatureInput =
  {
    id?: InputMaybe<Scalars['String']>;
    observedAt?: InputMaybe<Scalars['Float']>;
    previousId?: InputMaybe<Scalars['String']>;
    timestamp?: InputMaybe<Scalars['Float']>;
    units?: InputMaybe<Scalars['String']>;
    updatePending?: InputMaybe<Scalars['Boolean']>;
    value?: InputMaybe<Scalars['Float']>;
  };

export type FilterFindManyKineticEnergyManagementSystemCurrentEnergyStoredInput =
  {
    id?: InputMaybe<Scalars['String']>;
    observedAt?: InputMaybe<Scalars['Float']>;
    previousId?: InputMaybe<Scalars['String']>;
    timestamp?: InputMaybe<Scalars['Float']>;
    units?: InputMaybe<Scalars['String']>;
    updatePending?: InputMaybe<Scalars['Boolean']>;
    value?: InputMaybe<Scalars['Float']>;
  };

export type FilterFindManyKineticEnergyManagementSystemCycleCountInput = {
  id?: InputMaybe<Scalars['String']>;
  observedAt?: InputMaybe<Scalars['Float']>;
  previousId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  units?: InputMaybe<Scalars['String']>;
  updatePending?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<Scalars['Float']>;
};

export type FilterFindManyKineticEnergyManagementSystemGeneratorCurrentInput = {
  id?: InputMaybe<Scalars['String']>;
  observedAt?: InputMaybe<Scalars['Float']>;
  previousId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  units?: InputMaybe<Scalars['String']>;
  updatePending?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<Scalars['Float']>;
};

export type FilterFindManyKineticEnergyManagementSystemGeneratorVoltageInput = {
  id?: InputMaybe<Scalars['String']>;
  observedAt?: InputMaybe<Scalars['Float']>;
  previousId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  units?: InputMaybe<Scalars['String']>;
  updatePending?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<Scalars['Float']>;
};

export type FilterFindManyKineticEnergyManagementSystemInput = {
  AND?: InputMaybe<Array<FilterFindManyDeviceInput>>;
  OR?: InputMaybe<Array<FilterFindManyDeviceInput>>;
  _id?: InputMaybe<Scalars['String']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterFindManyDeviceOperatorsInput>;
  alertTypes?: InputMaybe<FilterFindManyDeviceAlertTypesInput>;
  bearingTemperature?: InputMaybe<FilterFindManyKineticEnergyManagementSystemBearingTemperatureInput>;
  controlled?: InputMaybe<FilterFindManyDeviceControlledInput>;
  currentEnergyStored?: InputMaybe<FilterFindManyKineticEnergyManagementSystemCurrentEnergyStoredInput>;
  cycleCount?: InputMaybe<FilterFindManyKineticEnergyManagementSystemCycleCountInput>;
  deviceId?: InputMaybe<Scalars['String']>;
  generatorCurrent?: InputMaybe<FilterFindManyKineticEnergyManagementSystemGeneratorCurrentInput>;
  generatorVoltage?: InputMaybe<FilterFindManyKineticEnergyManagementSystemGeneratorVoltageInput>;
  installation?: InputMaybe<FilterFindManyDeviceInstallationInput>;
  location?: InputMaybe<Scalars['String']>;
  meta?: InputMaybe<FilterFindManyDeviceMetaInput>;
  /** The name of the device */
  name?: InputMaybe<Scalars['String']>;
  panelId?: InputMaybe<Scalars['String']>;
  powerState?: InputMaybe<FilterFindManyDevicePowerStateInput>;
  propertyId?: InputMaybe<Scalars['String']>;
  rotorSpeed?: InputMaybe<FilterFindManyKineticEnergyManagementSystemRotorSpeedInput>;
  sourceId?: InputMaybe<Scalars['String']>;
  spinDownTime?: InputMaybe<FilterFindManyKineticEnergyManagementSystemSpinDownTimeInput>;
  stateOfHealth?: InputMaybe<FilterFindManyKineticEnergyManagementSystemStateOfHealthInput>;
  systemEfficiency?: InputMaybe<FilterFindManyKineticEnergyManagementSystemSystemEfficiencyInput>;
  timestamp?: InputMaybe<Scalars['Float']>;
  unitId?: InputMaybe<Scalars['String']>;
  updateStatus?: InputMaybe<Scalars['Boolean']>;
  vacuumPressure?: InputMaybe<FilterFindManyKineticEnergyManagementSystemVacuumPressureInput>;
  vibrationMetrics?: InputMaybe<FilterFindManyKineticEnergyManagementSystemVibrationMetricsInput>;
  vppId?: InputMaybe<Scalars['String']>;
  zoneId?: InputMaybe<Scalars['String']>;
};

export type FilterFindManyKineticEnergyManagementSystemRotorSpeedInput = {
  id?: InputMaybe<Scalars['String']>;
  observedAt?: InputMaybe<Scalars['Float']>;
  previousId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  units?: InputMaybe<Scalars['String']>;
  updatePending?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<Scalars['Float']>;
};

export type FilterFindManyKineticEnergyManagementSystemSpinDownTimeInput = {
  id?: InputMaybe<Scalars['String']>;
  observedAt?: InputMaybe<Scalars['Float']>;
  previousId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  units?: InputMaybe<Scalars['String']>;
  updatePending?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<Scalars['Float']>;
};

export type FilterFindManyKineticEnergyManagementSystemStateOfHealthInput = {
  id?: InputMaybe<Scalars['String']>;
  observedAt?: InputMaybe<Scalars['Float']>;
  previousId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  units?: InputMaybe<Scalars['String']>;
  updatePending?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<Scalars['Float']>;
};

export type FilterFindManyKineticEnergyManagementSystemSystemEfficiencyInput = {
  id?: InputMaybe<Scalars['String']>;
  observedAt?: InputMaybe<Scalars['Float']>;
  previousId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  units?: InputMaybe<Scalars['String']>;
  updatePending?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<Scalars['Float']>;
};

export type FilterFindManyKineticEnergyManagementSystemVacuumPressureInput = {
  id?: InputMaybe<Scalars['String']>;
  observedAt?: InputMaybe<Scalars['Float']>;
  previousId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  units?: InputMaybe<Scalars['String']>;
  updatePending?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<Scalars['Float']>;
};

export type FilterFindManyKineticEnergyManagementSystemVibrationMetricsInput = {
  id?: InputMaybe<Scalars['String']>;
  observedAt?: InputMaybe<Scalars['Float']>;
  previousId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  units?: InputMaybe<Scalars['String']>;
  updatePending?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<Scalars['Float']>;
};

export type FilterFindManyLeakDetectorBatteryVoltageMinThresholdInput = {
  id?: InputMaybe<Scalars['String']>;
  observedAt?: InputMaybe<Scalars['Float']>;
  previousId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  units?: InputMaybe<Scalars['String']>;
  updatePending?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<Scalars['Float']>;
};

export type FilterFindManyLeakDetectorBatteryVoltageMinThresholdReachedInput = {
  id?: InputMaybe<Scalars['String']>;
  observedAt?: InputMaybe<Scalars['Float']>;
  previousId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  units?: InputMaybe<Scalars['String']>;
  updatePending?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<Scalars['Boolean']>;
};

export type FilterFindManyLeakDetectorInput = {
  AND?: InputMaybe<Array<FilterFindManyDeviceInput>>;
  OR?: InputMaybe<Array<FilterFindManyDeviceInput>>;
  _id?: InputMaybe<Scalars['String']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterFindManyDeviceOperatorsInput>;
  alertTypes?: InputMaybe<FilterFindManyDeviceAlertTypesInput>;
  batteryVoltageMinThreshold?: InputMaybe<FilterFindManyLeakDetectorBatteryVoltageMinThresholdInput>;
  batteryVoltageMinThresholdReached?: InputMaybe<FilterFindManyLeakDetectorBatteryVoltageMinThresholdReachedInput>;
  controlled?: InputMaybe<FilterFindManyDeviceControlledInput>;
  deviceId?: InputMaybe<Scalars['String']>;
  installation?: InputMaybe<FilterFindManyDeviceInstallationInput>;
  leakStatus1?: InputMaybe<FilterFindManyLeakDetectorLeakStatus1Input>;
  leakStatus2?: InputMaybe<FilterFindManyLeakDetectorLeakStatus2Input>;
  location?: InputMaybe<Scalars['String']>;
  meta?: InputMaybe<FilterFindManyDeviceMetaInput>;
  /** The name of the device */
  name?: InputMaybe<Scalars['String']>;
  panelId?: InputMaybe<Scalars['String']>;
  powerState?: InputMaybe<FilterFindManyDevicePowerStateInput>;
  propertyId?: InputMaybe<Scalars['String']>;
  sourceId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  unitId?: InputMaybe<Scalars['String']>;
  updateStatus?: InputMaybe<Scalars['Boolean']>;
  voltage?: InputMaybe<FilterFindManyLeakDetectorVoltageInput>;
  vppId?: InputMaybe<Scalars['String']>;
  zoneId?: InputMaybe<Scalars['String']>;
};

export type FilterFindManyLeakDetectorLeakStatus1Input = {
  id?: InputMaybe<Scalars['String']>;
  observedAt?: InputMaybe<Scalars['Float']>;
  previousId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  units?: InputMaybe<Scalars['String']>;
  updatePending?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<Scalars['Boolean']>;
};

export type FilterFindManyLeakDetectorLeakStatus2Input = {
  id?: InputMaybe<Scalars['String']>;
  observedAt?: InputMaybe<Scalars['Float']>;
  previousId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  units?: InputMaybe<Scalars['String']>;
  updatePending?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<Scalars['Boolean']>;
};

export type FilterFindManyLeakDetectorVoltageInput = {
  id?: InputMaybe<Scalars['String']>;
  observedAt?: InputMaybe<Scalars['Float']>;
  previousId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  units?: InputMaybe<Scalars['String']>;
  updatePending?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<Scalars['Float']>;
};

export type FilterFindManyLoopIndoorTemperatureInput = {
  id?: InputMaybe<Scalars['String']>;
  observedAt?: InputMaybe<Scalars['Float']>;
  previousId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  units?: InputMaybe<Scalars['String']>;
  updatePending?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<Scalars['Float']>;
};

export type FilterFindManyLoopInput = {
  AND?: InputMaybe<Array<FilterFindManyDeviceInput>>;
  OR?: InputMaybe<Array<FilterFindManyDeviceInput>>;
  _id?: InputMaybe<Scalars['String']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterFindManyDeviceOperatorsInput>;
  alertTypes?: InputMaybe<FilterFindManyDeviceAlertTypesInput>;
  controlled?: InputMaybe<FilterFindManyDeviceControlledInput>;
  deviceId?: InputMaybe<Scalars['String']>;
  indoorTemperature?: InputMaybe<FilterFindManyLoopIndoorTemperatureInput>;
  installation?: InputMaybe<FilterFindManyDeviceInstallationInput>;
  location?: InputMaybe<Scalars['String']>;
  meta?: InputMaybe<FilterFindManyDeviceMetaInput>;
  /** The name of the device */
  name?: InputMaybe<Scalars['String']>;
  panelId?: InputMaybe<Scalars['String']>;
  powerState?: InputMaybe<FilterFindManyDevicePowerStateInput>;
  propertyId?: InputMaybe<Scalars['String']>;
  returnTemperature?: InputMaybe<FilterFindManyLoopReturnTemperatureInput>;
  role?: InputMaybe<Scalars['String']>;
  sourceId?: InputMaybe<Scalars['String']>;
  supplyTemperature?: InputMaybe<FilterFindManyLoopSupplyTemperatureInput>;
  timestamp?: InputMaybe<Scalars['Float']>;
  unitId?: InputMaybe<Scalars['String']>;
  updateStatus?: InputMaybe<Scalars['Boolean']>;
  vppId?: InputMaybe<Scalars['String']>;
  zoneId?: InputMaybe<Scalars['String']>;
};

export type FilterFindManyLoopReturnTemperatureInput = {
  id?: InputMaybe<Scalars['String']>;
  observedAt?: InputMaybe<Scalars['Float']>;
  previousId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  units?: InputMaybe<Scalars['String']>;
  updatePending?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<Scalars['Float']>;
};

export type FilterFindManyLoopSupplyTemperatureInput = {
  id?: InputMaybe<Scalars['String']>;
  observedAt?: InputMaybe<Scalars['Float']>;
  previousId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  units?: InputMaybe<Scalars['String']>;
  updatePending?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<Scalars['Float']>;
};

export type FilterFindManyModbusAirHandlerAhuCoolSetpointInput = {
  id?: InputMaybe<Scalars['String']>;
  observedAt?: InputMaybe<Scalars['Float']>;
  previousId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  units?: InputMaybe<Scalars['String']>;
  updatePending?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<Scalars['Float']>;
};

export type FilterFindManyModbusAirHandlerAhuHeatSetpointInput = {
  id?: InputMaybe<Scalars['String']>;
  observedAt?: InputMaybe<Scalars['Float']>;
  previousId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  units?: InputMaybe<Scalars['String']>;
  updatePending?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<Scalars['Float']>;
};

export type FilterFindManyModbusAirHandlerAhuMaxHeatSetpointLimitInput = {
  id?: InputMaybe<Scalars['String']>;
  observedAt?: InputMaybe<Scalars['Float']>;
  previousId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  units?: InputMaybe<Scalars['String']>;
  updatePending?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<Scalars['Float']>;
};

export type FilterFindManyModbusAirHandlerAhuMinCoolSetpointLimitInput = {
  id?: InputMaybe<Scalars['String']>;
  observedAt?: InputMaybe<Scalars['Float']>;
  previousId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  units?: InputMaybe<Scalars['String']>;
  updatePending?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<Scalars['Float']>;
};

export type FilterFindManyModbusAirHandlerAhuModbusIdInput = {
  id?: InputMaybe<Scalars['String']>;
  observedAt?: InputMaybe<Scalars['Float']>;
  previousId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  units?: InputMaybe<Scalars['String']>;
  updatePending?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<Scalars['Float']>;
};

export type FilterFindManyModbusAirHandlerAirExchangeModeOnInput = {
  id?: InputMaybe<Scalars['String']>;
  observedAt?: InputMaybe<Scalars['Float']>;
  previousId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  units?: InputMaybe<Scalars['String']>;
  updatePending?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<Scalars['Boolean']>;
};

export type FilterFindManyModbusAirHandlerAirflowUnitsInput = {
  id?: InputMaybe<Scalars['String']>;
  observedAt?: InputMaybe<Scalars['Float']>;
  previousId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  units?: InputMaybe<Scalars['String']>;
  updatePending?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<Scalars['String']>;
};

export type FilterFindManyModbusAirHandlerAlarmAirRestrictionInput = {
  id?: InputMaybe<Scalars['String']>;
  observedAt?: InputMaybe<Scalars['Float']>;
  previousId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  units?: InputMaybe<Scalars['String']>;
  updatePending?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<Scalars['Boolean']>;
};

export type FilterFindManyModbusAirHandlerAlarmB1SensorFailInput = {
  id?: InputMaybe<Scalars['String']>;
  observedAt?: InputMaybe<Scalars['Float']>;
  previousId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  units?: InputMaybe<Scalars['String']>;
  updatePending?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<Scalars['Boolean']>;
};

export type FilterFindManyModbusAirHandlerAlarmB2SensorFailInput = {
  id?: InputMaybe<Scalars['String']>;
  observedAt?: InputMaybe<Scalars['Float']>;
  previousId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  units?: InputMaybe<Scalars['String']>;
  updatePending?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<Scalars['Boolean']>;
};

export type FilterFindManyModbusAirHandlerAlarmB3SensorFailInput = {
  id?: InputMaybe<Scalars['String']>;
  observedAt?: InputMaybe<Scalars['Float']>;
  previousId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  units?: InputMaybe<Scalars['String']>;
  updatePending?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<Scalars['Boolean']>;
};

export type FilterFindManyModbusAirHandlerAlarmB4SensorFailInput = {
  id?: InputMaybe<Scalars['String']>;
  observedAt?: InputMaybe<Scalars['Float']>;
  previousId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  units?: InputMaybe<Scalars['String']>;
  updatePending?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<Scalars['Boolean']>;
};

export type FilterFindManyModbusAirHandlerAlarmB6SensorFailInput = {
  id?: InputMaybe<Scalars['String']>;
  observedAt?: InputMaybe<Scalars['Float']>;
  previousId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  units?: InputMaybe<Scalars['String']>;
  updatePending?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<Scalars['Boolean']>;
};

export type FilterFindManyModbusAirHandlerAlarmChangeFiltersInput = {
  id?: InputMaybe<Scalars['String']>;
  observedAt?: InputMaybe<Scalars['Float']>;
  previousId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  units?: InputMaybe<Scalars['String']>;
  updatePending?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<Scalars['Boolean']>;
};

export type FilterFindManyModbusAirHandlerAlarmChangeHepaInput = {
  id?: InputMaybe<Scalars['String']>;
  observedAt?: InputMaybe<Scalars['Float']>;
  previousId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  units?: InputMaybe<Scalars['String']>;
  updatePending?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<Scalars['Boolean']>;
};

export type FilterFindManyModbusAirHandlerAlarmClockBoardInput = {
  id?: InputMaybe<Scalars['String']>;
  observedAt?: InputMaybe<Scalars['Float']>;
  previousId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  units?: InputMaybe<Scalars['String']>;
  updatePending?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<Scalars['Boolean']>;
};

export type FilterFindManyModbusAirHandlerAlarmCompressorFailInput = {
  id?: InputMaybe<Scalars['String']>;
  observedAt?: InputMaybe<Scalars['Float']>;
  previousId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  units?: InputMaybe<Scalars['String']>;
  updatePending?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<Scalars['Boolean']>;
};

export type FilterFindManyModbusAirHandlerAlarmExhaustFanStoppedInput = {
  id?: InputMaybe<Scalars['String']>;
  observedAt?: InputMaybe<Scalars['Float']>;
  previousId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  units?: InputMaybe<Scalars['String']>;
  updatePending?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<Scalars['Boolean']>;
};

export type FilterFindManyModbusAirHandlerAlarmExtendedMemoryInput = {
  id?: InputMaybe<Scalars['String']>;
  observedAt?: InputMaybe<Scalars['Float']>;
  previousId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  units?: InputMaybe<Scalars['String']>;
  updatePending?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<Scalars['Boolean']>;
};

export type FilterFindManyModbusAirHandlerAlarmFanAbReversedInput = {
  id?: InputMaybe<Scalars['String']>;
  observedAt?: InputMaybe<Scalars['Float']>;
  previousId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  units?: InputMaybe<Scalars['String']>;
  updatePending?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<Scalars['Boolean']>;
};

export type FilterFindManyModbusAirHandlerAlarmFanANegPressureOpt1Input = {
  id?: InputMaybe<Scalars['String']>;
  observedAt?: InputMaybe<Scalars['Float']>;
  previousId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  units?: InputMaybe<Scalars['String']>;
  updatePending?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<Scalars['Boolean']>;
};

export type FilterFindManyModbusAirHandlerAlarmFanANegPressureOpt2Input = {
  id?: InputMaybe<Scalars['String']>;
  observedAt?: InputMaybe<Scalars['Float']>;
  previousId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  units?: InputMaybe<Scalars['String']>;
  updatePending?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<Scalars['Boolean']>;
};

export type FilterFindManyModbusAirHandlerAlarmGlobalAlarmInput = {
  id?: InputMaybe<Scalars['String']>;
  observedAt?: InputMaybe<Scalars['Float']>;
  previousId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  units?: InputMaybe<Scalars['String']>;
  updatePending?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<Scalars['Boolean']>;
};

export type FilterFindManyModbusAirHandlerAlarmHighPressureInput = {
  id?: InputMaybe<Scalars['String']>;
  observedAt?: InputMaybe<Scalars['Float']>;
  previousId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  units?: InputMaybe<Scalars['String']>;
  updatePending?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<Scalars['Boolean']>;
};

export type FilterFindManyModbusAirHandlerAlarmLowPressureInput = {
  id?: InputMaybe<Scalars['String']>;
  observedAt?: InputMaybe<Scalars['Float']>;
  previousId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  units?: InputMaybe<Scalars['String']>;
  updatePending?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<Scalars['Boolean']>;
};

export type FilterFindManyModbusAirHandlerAlarmRefrigerantLeakInput = {
  id?: InputMaybe<Scalars['String']>;
  observedAt?: InputMaybe<Scalars['Float']>;
  previousId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  units?: InputMaybe<Scalars['String']>;
  updatePending?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<Scalars['Boolean']>;
};

export type FilterFindManyModbusAirHandlerAlarmSupplyFanStoppedInput = {
  id?: InputMaybe<Scalars['String']>;
  observedAt?: InputMaybe<Scalars['Float']>;
  previousId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  units?: InputMaybe<Scalars['String']>;
  updatePending?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<Scalars['Boolean']>;
};

export type FilterFindManyModbusAirHandlerAllowTenantChangeRhSetpointInput = {
  id?: InputMaybe<Scalars['String']>;
  observedAt?: InputMaybe<Scalars['Float']>;
  previousId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  units?: InputMaybe<Scalars['String']>;
  updatePending?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<Scalars['Boolean']>;
};

export type FilterFindManyModbusAirHandlerAllowTenantChangeTempSetpointsInput =
  {
    id?: InputMaybe<Scalars['String']>;
    observedAt?: InputMaybe<Scalars['Float']>;
    previousId?: InputMaybe<Scalars['String']>;
    timestamp?: InputMaybe<Scalars['Float']>;
    units?: InputMaybe<Scalars['String']>;
    updatePending?: InputMaybe<Scalars['Boolean']>;
    value?: InputMaybe<Scalars['Boolean']>;
  };

export type FilterFindManyModbusAirHandlerAllowTenantOnOffInput = {
  id?: InputMaybe<Scalars['String']>;
  observedAt?: InputMaybe<Scalars['Float']>;
  previousId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  units?: InputMaybe<Scalars['String']>;
  updatePending?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<Scalars['Boolean']>;
};

export type FilterFindManyModbusAirHandlerAltitudeInput = {
  id?: InputMaybe<Scalars['String']>;
  observedAt?: InputMaybe<Scalars['Float']>;
  previousId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  units?: InputMaybe<Scalars['String']>;
  updatePending?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<Scalars['Float']>;
};

export type FilterFindManyModbusAirHandlerAuxCoolingEnabledInput = {
  id?: InputMaybe<Scalars['String']>;
  observedAt?: InputMaybe<Scalars['Float']>;
  previousId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  units?: InputMaybe<Scalars['String']>;
  updatePending?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<Scalars['Boolean']>;
};

export type FilterFindManyModbusAirHandlerBiosVersionInput = {
  id?: InputMaybe<Scalars['String']>;
  observedAt?: InputMaybe<Scalars['Float']>;
  previousId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  units?: InputMaybe<Scalars['String']>;
  updatePending?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<Scalars['Float']>;
};

export type FilterFindManyModbusAirHandlerBootVersionInput = {
  id?: InputMaybe<Scalars['String']>;
  observedAt?: InputMaybe<Scalars['Float']>;
  previousId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  units?: InputMaybe<Scalars['String']>;
  updatePending?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<Scalars['Float']>;
};

export type FilterFindManyModbusAirHandlerCompressorOnInput = {
  id?: InputMaybe<Scalars['String']>;
  observedAt?: InputMaybe<Scalars['Float']>;
  previousId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  units?: InputMaybe<Scalars['String']>;
  updatePending?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<Scalars['Boolean']>;
};

export type FilterFindManyModbusAirHandlerConditionedTemperatureInput = {
  id?: InputMaybe<Scalars['String']>;
  observedAt?: InputMaybe<Scalars['Float']>;
  previousId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  units?: InputMaybe<Scalars['String']>;
  updatePending?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<Scalars['Float']>;
};

export type FilterFindManyModbusAirHandlerDamperPositionInput = {
  id?: InputMaybe<Scalars['String']>;
  observedAt?: InputMaybe<Scalars['Float']>;
  previousId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  units?: InputMaybe<Scalars['String']>;
  updatePending?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<Scalars['String']>;
};

export type FilterFindManyModbusAirHandlerDefrostTemperatureInput = {
  id?: InputMaybe<Scalars['String']>;
  observedAt?: InputMaybe<Scalars['Float']>;
  previousId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  units?: InputMaybe<Scalars['String']>;
  updatePending?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<Scalars['Float']>;
};

export type FilterFindManyModbusAirHandlerEnableTenantModeInput = {
  id?: InputMaybe<Scalars['String']>;
  observedAt?: InputMaybe<Scalars['Float']>;
  previousId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  units?: InputMaybe<Scalars['String']>;
  updatePending?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<Scalars['Boolean']>;
};

export type FilterFindManyModbusAirHandlerExhaustFanAirflowInput = {
  id?: InputMaybe<Scalars['String']>;
  observedAt?: InputMaybe<Scalars['Float']>;
  previousId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  units?: InputMaybe<Scalars['String']>;
  updatePending?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<Scalars['Float']>;
};

export type FilterFindManyModbusAirHandlerExhaustFanOnInput = {
  id?: InputMaybe<Scalars['String']>;
  observedAt?: InputMaybe<Scalars['Float']>;
  previousId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  units?: InputMaybe<Scalars['String']>;
  updatePending?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<Scalars['Boolean']>;
};

export type FilterFindManyModbusAirHandlerFiltersServiceTimeInput = {
  id?: InputMaybe<Scalars['String']>;
  observedAt?: InputMaybe<Scalars['Float']>;
  previousId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  units?: InputMaybe<Scalars['String']>;
  updatePending?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<Scalars['Float']>;
};

export type FilterFindManyModbusAirHandlerFreshAirSetpointInput = {
  id?: InputMaybe<Scalars['String']>;
  observedAt?: InputMaybe<Scalars['Float']>;
  previousId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  units?: InputMaybe<Scalars['String']>;
  updatePending?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<Scalars['Float']>;
};

export type FilterFindManyModbusAirHandlerGTerminalOnInput = {
  id?: InputMaybe<Scalars['String']>;
  observedAt?: InputMaybe<Scalars['Float']>;
  previousId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  units?: InputMaybe<Scalars['String']>;
  updatePending?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<Scalars['Boolean']>;
};

export type FilterFindManyModbusAirHandlerHTerminalOnInput = {
  id?: InputMaybe<Scalars['String']>;
  observedAt?: InputMaybe<Scalars['Float']>;
  previousId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  units?: InputMaybe<Scalars['String']>;
  updatePending?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<Scalars['Boolean']>;
};

export type FilterFindManyModbusAirHandlerHeatPumpModeOnInput = {
  id?: InputMaybe<Scalars['String']>;
  observedAt?: InputMaybe<Scalars['Float']>;
  previousId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  units?: InputMaybe<Scalars['String']>;
  updatePending?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<Scalars['Boolean']>;
};

export type FilterFindManyModbusAirHandlerHeatingElementOnInput = {
  id?: InputMaybe<Scalars['String']>;
  observedAt?: InputMaybe<Scalars['Float']>;
  previousId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  units?: InputMaybe<Scalars['String']>;
  updatePending?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<Scalars['Boolean']>;
};

export type FilterFindManyModbusAirHandlerHepaServiceTimeInput = {
  id?: InputMaybe<Scalars['String']>;
  observedAt?: InputMaybe<Scalars['Float']>;
  previousId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  units?: InputMaybe<Scalars['String']>;
  updatePending?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<Scalars['Float']>;
};

export type FilterFindManyModbusAirHandlerIndoorRhInput = {
  id?: InputMaybe<Scalars['String']>;
  observedAt?: InputMaybe<Scalars['Float']>;
  previousId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  units?: InputMaybe<Scalars['String']>;
  updatePending?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<Scalars['Float']>;
};

export type FilterFindManyModbusAirHandlerIndoorTemperatureInput = {
  id?: InputMaybe<Scalars['String']>;
  observedAt?: InputMaybe<Scalars['Float']>;
  previousId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  units?: InputMaybe<Scalars['String']>;
  updatePending?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<Scalars['Float']>;
};

export type FilterFindManyModbusAirHandlerInput = {
  AND?: InputMaybe<Array<FilterFindManyDeviceInput>>;
  OR?: InputMaybe<Array<FilterFindManyDeviceInput>>;
  _id?: InputMaybe<Scalars['String']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterFindManyDeviceOperatorsInput>;
  ahuCoolSetpoint?: InputMaybe<FilterFindManyModbusAirHandlerAhuCoolSetpointInput>;
  ahuHeatSetpoint?: InputMaybe<FilterFindManyModbusAirHandlerAhuHeatSetpointInput>;
  ahuMaxHeatSetpointLimit?: InputMaybe<FilterFindManyModbusAirHandlerAhuMaxHeatSetpointLimitInput>;
  ahuMinCoolSetpointLimit?: InputMaybe<FilterFindManyModbusAirHandlerAhuMinCoolSetpointLimitInput>;
  ahuModbusId?: InputMaybe<FilterFindManyModbusAirHandlerAhuModbusIdInput>;
  airExchangeModeOn?: InputMaybe<FilterFindManyModbusAirHandlerAirExchangeModeOnInput>;
  airflowUnits?: InputMaybe<FilterFindManyModbusAirHandlerAirflowUnitsInput>;
  alarmAirRestriction?: InputMaybe<FilterFindManyModbusAirHandlerAlarmAirRestrictionInput>;
  alarmB1SensorFail?: InputMaybe<FilterFindManyModbusAirHandlerAlarmB1SensorFailInput>;
  alarmB2SensorFail?: InputMaybe<FilterFindManyModbusAirHandlerAlarmB2SensorFailInput>;
  alarmB3SensorFail?: InputMaybe<FilterFindManyModbusAirHandlerAlarmB3SensorFailInput>;
  alarmB4SensorFail?: InputMaybe<FilterFindManyModbusAirHandlerAlarmB4SensorFailInput>;
  alarmB6SensorFail?: InputMaybe<FilterFindManyModbusAirHandlerAlarmB6SensorFailInput>;
  alarmChangeFilters?: InputMaybe<FilterFindManyModbusAirHandlerAlarmChangeFiltersInput>;
  alarmChangeHepa?: InputMaybe<FilterFindManyModbusAirHandlerAlarmChangeHepaInput>;
  alarmClockBoard?: InputMaybe<FilterFindManyModbusAirHandlerAlarmClockBoardInput>;
  alarmCompressorFail?: InputMaybe<FilterFindManyModbusAirHandlerAlarmCompressorFailInput>;
  alarmExhaustFanStopped?: InputMaybe<FilterFindManyModbusAirHandlerAlarmExhaustFanStoppedInput>;
  alarmExtendedMemory?: InputMaybe<FilterFindManyModbusAirHandlerAlarmExtendedMemoryInput>;
  alarmFanABReversed?: InputMaybe<FilterFindManyModbusAirHandlerAlarmFanAbReversedInput>;
  alarmFanANegPressureOpt1?: InputMaybe<FilterFindManyModbusAirHandlerAlarmFanANegPressureOpt1Input>;
  alarmFanANegPressureOpt2?: InputMaybe<FilterFindManyModbusAirHandlerAlarmFanANegPressureOpt2Input>;
  alarmGlobalAlarm?: InputMaybe<FilterFindManyModbusAirHandlerAlarmGlobalAlarmInput>;
  alarmHighPressure?: InputMaybe<FilterFindManyModbusAirHandlerAlarmHighPressureInput>;
  alarmLowPressure?: InputMaybe<FilterFindManyModbusAirHandlerAlarmLowPressureInput>;
  alarmRefrigerantLeak?: InputMaybe<FilterFindManyModbusAirHandlerAlarmRefrigerantLeakInput>;
  alarmSupplyFanStopped?: InputMaybe<FilterFindManyModbusAirHandlerAlarmSupplyFanStoppedInput>;
  alertTypes?: InputMaybe<FilterFindManyDeviceAlertTypesInput>;
  allowTenantChangeRHSetpoint?: InputMaybe<FilterFindManyModbusAirHandlerAllowTenantChangeRhSetpointInput>;
  allowTenantChangeTempSetpoints?: InputMaybe<FilterFindManyModbusAirHandlerAllowTenantChangeTempSetpointsInput>;
  allowTenantOnOff?: InputMaybe<FilterFindManyModbusAirHandlerAllowTenantOnOffInput>;
  altitude?: InputMaybe<FilterFindManyModbusAirHandlerAltitudeInput>;
  auxCoolingEnabled?: InputMaybe<FilterFindManyModbusAirHandlerAuxCoolingEnabledInput>;
  biosVersion?: InputMaybe<FilterFindManyModbusAirHandlerBiosVersionInput>;
  bootVersion?: InputMaybe<FilterFindManyModbusAirHandlerBootVersionInput>;
  compressorOn?: InputMaybe<FilterFindManyModbusAirHandlerCompressorOnInput>;
  conditionedTemperature?: InputMaybe<FilterFindManyModbusAirHandlerConditionedTemperatureInput>;
  controlled?: InputMaybe<FilterFindManyDeviceControlledInput>;
  damperPosition?: InputMaybe<FilterFindManyModbusAirHandlerDamperPositionInput>;
  defrostTemperature?: InputMaybe<FilterFindManyModbusAirHandlerDefrostTemperatureInput>;
  deviceId?: InputMaybe<Scalars['String']>;
  enableTenantMode?: InputMaybe<FilterFindManyModbusAirHandlerEnableTenantModeInput>;
  exhaustFanAirflow?: InputMaybe<FilterFindManyModbusAirHandlerExhaustFanAirflowInput>;
  exhaustFanOn?: InputMaybe<FilterFindManyModbusAirHandlerExhaustFanOnInput>;
  filtersServiceTime?: InputMaybe<FilterFindManyModbusAirHandlerFiltersServiceTimeInput>;
  freshAirSetpoint?: InputMaybe<FilterFindManyModbusAirHandlerFreshAirSetpointInput>;
  gTerminalOn?: InputMaybe<FilterFindManyModbusAirHandlerGTerminalOnInput>;
  hTerminalOn?: InputMaybe<FilterFindManyModbusAirHandlerHTerminalOnInput>;
  heatPumpModeOn?: InputMaybe<FilterFindManyModbusAirHandlerHeatPumpModeOnInput>;
  heatingElementOn?: InputMaybe<FilterFindManyModbusAirHandlerHeatingElementOnInput>;
  hepaServiceTime?: InputMaybe<FilterFindManyModbusAirHandlerHepaServiceTimeInput>;
  indoorRH?: InputMaybe<FilterFindManyModbusAirHandlerIndoorRhInput>;
  indoorTemperature?: InputMaybe<FilterFindManyModbusAirHandlerIndoorTemperatureInput>;
  installation?: InputMaybe<FilterFindManyDeviceInstallationInput>;
  location?: InputMaybe<Scalars['String']>;
  meta?: InputMaybe<FilterFindManyDeviceMetaInput>;
  /** The name of the device */
  name?: InputMaybe<Scalars['String']>;
  outsideTemperature?: InputMaybe<FilterFindManyModbusAirHandlerOutsideTemperatureInput>;
  panelId?: InputMaybe<Scalars['String']>;
  powerState?: InputMaybe<FilterFindManyDevicePowerStateInput>;
  propertyId?: InputMaybe<Scalars['String']>;
  recirculationModeOn?: InputMaybe<FilterFindManyModbusAirHandlerRecirculationModeOnInput>;
  resetFiltersServiceTime?: InputMaybe<FilterFindManyModbusAirHandlerResetFiltersServiceTimeInput>;
  resetHepaServiceTime?: InputMaybe<FilterFindManyModbusAirHandlerResetHepaServiceTimeInput>;
  reversibleValveOnWhen?: InputMaybe<FilterFindManyModbusAirHandlerReversibleValveOnWhenInput>;
  rhSetpoint?: InputMaybe<FilterFindManyModbusAirHandlerRhSetpointInput>;
  showerDetectorEnabled?: InputMaybe<FilterFindManyModbusAirHandlerShowerDetectorEnabledInput>;
  softwareReleaseType?: InputMaybe<FilterFindManyModbusAirHandlerSoftwareReleaseTypeInput>;
  softwareVersion?: InputMaybe<FilterFindManyModbusAirHandlerSoftwareVersionInput>;
  sourceId?: InputMaybe<Scalars['String']>;
  supplyFanAirflow?: InputMaybe<FilterFindManyModbusAirHandlerSupplyFanAirflowInput>;
  supplyFanOn?: InputMaybe<FilterFindManyModbusAirHandlerSupplyFanOnInput>;
  supplyFanStaticPressureH2O?: InputMaybe<FilterFindManyModbusAirHandlerSupplyFanStaticPressureH2OInput>;
  systemAutoMode?: InputMaybe<FilterFindManyModbusAirHandlerSystemAutoModeInput>;
  systemOnOff?: InputMaybe<FilterFindManyModbusAirHandlerSystemOnOffInput>;
  temperatureUnits?: InputMaybe<FilterFindManyModbusAirHandlerTemperatureUnitsInput>;
  tenantModePassword?: InputMaybe<FilterFindManyModbusAirHandlerTenantModePasswordInput>;
  timestamp?: InputMaybe<Scalars['Float']>;
  unitId?: InputMaybe<Scalars['String']>;
  updateStatus?: InputMaybe<Scalars['Boolean']>;
  ventilationMode?: InputMaybe<FilterFindManyModbusAirHandlerVentilationModeInput>;
  vppId?: InputMaybe<Scalars['String']>;
  wTerminalOn?: InputMaybe<FilterFindManyModbusAirHandlerWTerminalOnInput>;
  winterRhAdjustEnabled?: InputMaybe<FilterFindManyModbusAirHandlerWinterRhAdjustEnabledInput>;
  yTerminalOn?: InputMaybe<FilterFindManyModbusAirHandlerYTerminalOnInput>;
  zmbAhuRequestsSent?: InputMaybe<FilterFindManyModbusAirHandlerZmbAhuRequestsSentInput>;
  zmbAhuRequestsSentFailed?: InputMaybe<FilterFindManyModbusAirHandlerZmbAhuRequestsSentFailedInput>;
  zmbAirHandlerAlarm?: InputMaybe<FilterFindManyModbusAirHandlerZmbAirHandlerAlarmInput>;
  zmbCoreRequestsRecvd?: InputMaybe<FilterFindManyModbusAirHandlerZmbCoreRequestsRecvdInput>;
  zmbCpuTemperature?: InputMaybe<FilterFindManyModbusAirHandlerZmbCpuTemperatureInput>;
  zmbFirmwareVersion?: InputMaybe<FilterFindManyModbusAirHandlerZmbFirmwareVersionInput>;
  zmbGlobalAlarm?: InputMaybe<FilterFindManyModbusAirHandlerZmbGlobalAlarmInput>;
  zmbLeakDetected?: InputMaybe<FilterFindManyModbusAirHandlerZmbLeakDetectedInput>;
  zmbLeakDetectorInstalled?: InputMaybe<FilterFindManyModbusAirHandlerZmbLeakDetectorInstalledInput>;
  zmbModbusRequestDelay?: InputMaybe<FilterFindManyModbusAirHandlerZmbModbusRequestDelayInput>;
  zmbPollingFrequency?: InputMaybe<FilterFindManyModbusAirHandlerZmbPollingFrequencyInput>;
  zmbRequestsRecvdInvalid?: InputMaybe<FilterFindManyModbusAirHandlerZmbRequestsRecvdInvalidInput>;
  zmbSystemUptime?: InputMaybe<FilterFindManyModbusAirHandlerZmbSystemUptimeInput>;
  zmbThermostatAlarm?: InputMaybe<FilterFindManyModbusAirHandlerZmbThermostatAlarmInput>;
  zmbTstatRequestsRecvd?: InputMaybe<FilterFindManyModbusAirHandlerZmbTstatRequestsRecvdInput>;
  zoneId?: InputMaybe<Scalars['String']>;
};

export type FilterFindManyModbusAirHandlerOutsideTemperatureInput = {
  id?: InputMaybe<Scalars['String']>;
  observedAt?: InputMaybe<Scalars['Float']>;
  previousId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  units?: InputMaybe<Scalars['String']>;
  updatePending?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<Scalars['Float']>;
};

export type FilterFindManyModbusAirHandlerRecirculationModeOnInput = {
  id?: InputMaybe<Scalars['String']>;
  observedAt?: InputMaybe<Scalars['Float']>;
  previousId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  units?: InputMaybe<Scalars['String']>;
  updatePending?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<Scalars['Boolean']>;
};

export type FilterFindManyModbusAirHandlerResetFiltersServiceTimeInput = {
  id?: InputMaybe<Scalars['String']>;
  observedAt?: InputMaybe<Scalars['Float']>;
  previousId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  units?: InputMaybe<Scalars['String']>;
  updatePending?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<Scalars['String']>;
};

export type FilterFindManyModbusAirHandlerResetHepaServiceTimeInput = {
  id?: InputMaybe<Scalars['String']>;
  observedAt?: InputMaybe<Scalars['Float']>;
  previousId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  units?: InputMaybe<Scalars['String']>;
  updatePending?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<Scalars['String']>;
};

export type FilterFindManyModbusAirHandlerReversibleValveOnWhenInput = {
  id?: InputMaybe<Scalars['String']>;
  observedAt?: InputMaybe<Scalars['Float']>;
  previousId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  units?: InputMaybe<Scalars['String']>;
  updatePending?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<Scalars['String']>;
};

export type FilterFindManyModbusAirHandlerRhSetpointInput = {
  id?: InputMaybe<Scalars['String']>;
  observedAt?: InputMaybe<Scalars['Float']>;
  previousId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  units?: InputMaybe<Scalars['String']>;
  updatePending?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<Scalars['Float']>;
};

export type FilterFindManyModbusAirHandlerShowerDetectorEnabledInput = {
  id?: InputMaybe<Scalars['String']>;
  observedAt?: InputMaybe<Scalars['Float']>;
  previousId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  units?: InputMaybe<Scalars['String']>;
  updatePending?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<Scalars['Boolean']>;
};

export type FilterFindManyModbusAirHandlerSoftwareReleaseTypeInput = {
  id?: InputMaybe<Scalars['String']>;
  observedAt?: InputMaybe<Scalars['Float']>;
  previousId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  units?: InputMaybe<Scalars['String']>;
  updatePending?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<Scalars['String']>;
};

export type FilterFindManyModbusAirHandlerSoftwareVersionInput = {
  id?: InputMaybe<Scalars['String']>;
  observedAt?: InputMaybe<Scalars['Float']>;
  previousId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  units?: InputMaybe<Scalars['String']>;
  updatePending?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<Scalars['Float']>;
};

export type FilterFindManyModbusAirHandlerSupplyFanAirflowInput = {
  id?: InputMaybe<Scalars['String']>;
  observedAt?: InputMaybe<Scalars['Float']>;
  previousId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  units?: InputMaybe<Scalars['String']>;
  updatePending?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<Scalars['Float']>;
};

export type FilterFindManyModbusAirHandlerSupplyFanOnInput = {
  id?: InputMaybe<Scalars['String']>;
  observedAt?: InputMaybe<Scalars['Float']>;
  previousId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  units?: InputMaybe<Scalars['String']>;
  updatePending?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<Scalars['Boolean']>;
};

export type FilterFindManyModbusAirHandlerSupplyFanStaticPressureH2OInput = {
  id?: InputMaybe<Scalars['String']>;
  observedAt?: InputMaybe<Scalars['Float']>;
  previousId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  units?: InputMaybe<Scalars['String']>;
  updatePending?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<Scalars['Float']>;
};

export type FilterFindManyModbusAirHandlerSystemAutoModeInput = {
  id?: InputMaybe<Scalars['String']>;
  observedAt?: InputMaybe<Scalars['Float']>;
  previousId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  units?: InputMaybe<Scalars['String']>;
  updatePending?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<Scalars['String']>;
};

export type FilterFindManyModbusAirHandlerSystemOnOffInput = {
  id?: InputMaybe<Scalars['String']>;
  observedAt?: InputMaybe<Scalars['Float']>;
  previousId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  units?: InputMaybe<Scalars['String']>;
  updatePending?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<Scalars['String']>;
};

export type FilterFindManyModbusAirHandlerTemperatureUnitsInput = {
  id?: InputMaybe<Scalars['String']>;
  observedAt?: InputMaybe<Scalars['Float']>;
  previousId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  units?: InputMaybe<Scalars['String']>;
  updatePending?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<Scalars['String']>;
};

export type FilterFindManyModbusAirHandlerTenantModePasswordInput = {
  id?: InputMaybe<Scalars['String']>;
  observedAt?: InputMaybe<Scalars['Float']>;
  previousId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  units?: InputMaybe<Scalars['String']>;
  updatePending?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<Scalars['String']>;
};

export type FilterFindManyModbusAirHandlerVentilationModeInput = {
  id?: InputMaybe<Scalars['String']>;
  observedAt?: InputMaybe<Scalars['Float']>;
  previousId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  units?: InputMaybe<Scalars['String']>;
  updatePending?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<Scalars['String']>;
};

export type FilterFindManyModbusAirHandlerWTerminalOnInput = {
  id?: InputMaybe<Scalars['String']>;
  observedAt?: InputMaybe<Scalars['Float']>;
  previousId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  units?: InputMaybe<Scalars['String']>;
  updatePending?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<Scalars['Boolean']>;
};

export type FilterFindManyModbusAirHandlerWinterRhAdjustEnabledInput = {
  id?: InputMaybe<Scalars['String']>;
  observedAt?: InputMaybe<Scalars['Float']>;
  previousId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  units?: InputMaybe<Scalars['String']>;
  updatePending?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<Scalars['Boolean']>;
};

export type FilterFindManyModbusAirHandlerYTerminalOnInput = {
  id?: InputMaybe<Scalars['String']>;
  observedAt?: InputMaybe<Scalars['Float']>;
  previousId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  units?: InputMaybe<Scalars['String']>;
  updatePending?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<Scalars['Boolean']>;
};

export type FilterFindManyModbusAirHandlerZmbAhuRequestsSentFailedInput = {
  id?: InputMaybe<Scalars['String']>;
  observedAt?: InputMaybe<Scalars['Float']>;
  previousId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  units?: InputMaybe<Scalars['String']>;
  updatePending?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<Scalars['Float']>;
};

export type FilterFindManyModbusAirHandlerZmbAhuRequestsSentInput = {
  id?: InputMaybe<Scalars['String']>;
  observedAt?: InputMaybe<Scalars['Float']>;
  previousId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  units?: InputMaybe<Scalars['String']>;
  updatePending?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<Scalars['Float']>;
};

export type FilterFindManyModbusAirHandlerZmbAirHandlerAlarmInput = {
  id?: InputMaybe<Scalars['String']>;
  observedAt?: InputMaybe<Scalars['Float']>;
  previousId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  units?: InputMaybe<Scalars['String']>;
  updatePending?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<Scalars['Boolean']>;
};

export type FilterFindManyModbusAirHandlerZmbCoreRequestsRecvdInput = {
  id?: InputMaybe<Scalars['String']>;
  observedAt?: InputMaybe<Scalars['Float']>;
  previousId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  units?: InputMaybe<Scalars['String']>;
  updatePending?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<Scalars['Float']>;
};

export type FilterFindManyModbusAirHandlerZmbCpuTemperatureInput = {
  id?: InputMaybe<Scalars['String']>;
  observedAt?: InputMaybe<Scalars['Float']>;
  previousId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  units?: InputMaybe<Scalars['String']>;
  updatePending?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<Scalars['Float']>;
};

export type FilterFindManyModbusAirHandlerZmbFirmwareVersionInput = {
  id?: InputMaybe<Scalars['String']>;
  observedAt?: InputMaybe<Scalars['Float']>;
  previousId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  units?: InputMaybe<Scalars['String']>;
  updatePending?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<Scalars['String']>;
};

export type FilterFindManyModbusAirHandlerZmbGlobalAlarmInput = {
  id?: InputMaybe<Scalars['String']>;
  observedAt?: InputMaybe<Scalars['Float']>;
  previousId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  units?: InputMaybe<Scalars['String']>;
  updatePending?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<Scalars['Boolean']>;
};

export type FilterFindManyModbusAirHandlerZmbLeakDetectedInput = {
  id?: InputMaybe<Scalars['String']>;
  observedAt?: InputMaybe<Scalars['Float']>;
  previousId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  units?: InputMaybe<Scalars['String']>;
  updatePending?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<Scalars['Boolean']>;
};

export type FilterFindManyModbusAirHandlerZmbLeakDetectorInstalledInput = {
  id?: InputMaybe<Scalars['String']>;
  observedAt?: InputMaybe<Scalars['Float']>;
  previousId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  units?: InputMaybe<Scalars['String']>;
  updatePending?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<Scalars['Boolean']>;
};

export type FilterFindManyModbusAirHandlerZmbModbusRequestDelayInput = {
  id?: InputMaybe<Scalars['String']>;
  observedAt?: InputMaybe<Scalars['Float']>;
  previousId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  units?: InputMaybe<Scalars['String']>;
  updatePending?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<Scalars['Float']>;
};

export type FilterFindManyModbusAirHandlerZmbPollingFrequencyInput = {
  id?: InputMaybe<Scalars['String']>;
  observedAt?: InputMaybe<Scalars['Float']>;
  previousId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  units?: InputMaybe<Scalars['String']>;
  updatePending?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<Scalars['Float']>;
};

export type FilterFindManyModbusAirHandlerZmbRequestsRecvdInvalidInput = {
  id?: InputMaybe<Scalars['String']>;
  observedAt?: InputMaybe<Scalars['Float']>;
  previousId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  units?: InputMaybe<Scalars['String']>;
  updatePending?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<Scalars['Float']>;
};

export type FilterFindManyModbusAirHandlerZmbSystemUptimeInput = {
  id?: InputMaybe<Scalars['String']>;
  observedAt?: InputMaybe<Scalars['Float']>;
  previousId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  units?: InputMaybe<Scalars['String']>;
  updatePending?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<Scalars['Float']>;
};

export type FilterFindManyModbusAirHandlerZmbThermostatAlarmInput = {
  id?: InputMaybe<Scalars['String']>;
  observedAt?: InputMaybe<Scalars['Float']>;
  previousId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  units?: InputMaybe<Scalars['String']>;
  updatePending?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<Scalars['Boolean']>;
};

export type FilterFindManyModbusAirHandlerZmbTstatRequestsRecvdInput = {
  id?: InputMaybe<Scalars['String']>;
  observedAt?: InputMaybe<Scalars['Float']>;
  previousId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  units?: InputMaybe<Scalars['String']>;
  updatePending?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<Scalars['Float']>;
};

export type FilterFindManyOauthAccessTokenClientIdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['String']>;
  gte?: InputMaybe<Scalars['String']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  lt?: InputMaybe<Scalars['String']>;
  lte?: InputMaybe<Scalars['String']>;
  ne?: InputMaybe<Scalars['String']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']>;
};

export type FilterFindManyOauthAccessTokenInput = {
  AND?: InputMaybe<Array<FilterFindManyOauthAccessTokenInput>>;
  OR?: InputMaybe<Array<FilterFindManyOauthAccessTokenInput>>;
  _id?: InputMaybe<Scalars['String']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterFindManyOauthAccessTokenOperatorsInput>;
  accessToken?: InputMaybe<Scalars['String']>;
  clientId?: InputMaybe<Scalars['String']>;
  expires?: InputMaybe<Scalars['Float']>;
  userId?: InputMaybe<Scalars['String']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterFindManyOauthAccessTokenOperatorsInput = {
  _id?: InputMaybe<FilterFindManyOauthAccessToken_IdOperatorsInput>;
  clientId?: InputMaybe<FilterFindManyOauthAccessTokenClientIdOperatorsInput>;
};

export type FilterFindManyOauthAccessToken_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['String']>;
  gte?: InputMaybe<Scalars['String']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  lt?: InputMaybe<Scalars['String']>;
  lte?: InputMaybe<Scalars['String']>;
  ne?: InputMaybe<Scalars['String']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']>;
};

export type FilterFindManyOauthAuthCodeClientIdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['String']>;
  gte?: InputMaybe<Scalars['String']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  lt?: InputMaybe<Scalars['String']>;
  lte?: InputMaybe<Scalars['String']>;
  ne?: InputMaybe<Scalars['String']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']>;
};

export type FilterFindManyOauthAuthCodeInput = {
  AND?: InputMaybe<Array<FilterFindManyOauthAuthCodeInput>>;
  OR?: InputMaybe<Array<FilterFindManyOauthAuthCodeInput>>;
  _id?: InputMaybe<Scalars['String']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterFindManyOauthAuthCodeOperatorsInput>;
  authCode?: InputMaybe<Scalars['String']>;
  clientId?: InputMaybe<Scalars['String']>;
  expires?: InputMaybe<Scalars['Float']>;
  userId?: InputMaybe<Scalars['String']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterFindManyOauthAuthCodeOperatorsInput = {
  _id?: InputMaybe<FilterFindManyOauthAuthCode_IdOperatorsInput>;
  clientId?: InputMaybe<FilterFindManyOauthAuthCodeClientIdOperatorsInput>;
};

export type FilterFindManyOauthAuthCode_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['String']>;
  gte?: InputMaybe<Scalars['String']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  lt?: InputMaybe<Scalars['String']>;
  lte?: InputMaybe<Scalars['String']>;
  ne?: InputMaybe<Scalars['String']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']>;
};

export type FilterFindManyOauthClientClientIdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['String']>;
  gte?: InputMaybe<Scalars['String']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  lt?: InputMaybe<Scalars['String']>;
  lte?: InputMaybe<Scalars['String']>;
  ne?: InputMaybe<Scalars['String']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']>;
};

export type FilterFindManyOauthClientInput = {
  AND?: InputMaybe<Array<FilterFindManyOauthClientInput>>;
  OR?: InputMaybe<Array<FilterFindManyOauthClientInput>>;
  _id?: InputMaybe<Scalars['String']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterFindManyOauthClientOperatorsInput>;
  active?: InputMaybe<Scalars['Boolean']>;
  brand?: InputMaybe<Scalars['String']>;
  clientId?: InputMaybe<Scalars['String']>;
  clientSecret?: InputMaybe<Scalars['String']>;
  redirectUri?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  serviceDescription?: InputMaybe<Scalars['String']>;
  serviceName?: InputMaybe<Scalars['String']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterFindManyOauthClientOperatorsInput = {
  _id?: InputMaybe<FilterFindManyOauthClient_IdOperatorsInput>;
  clientId?: InputMaybe<FilterFindManyOauthClientClientIdOperatorsInput>;
};

export type FilterFindManyOauthClient_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['String']>;
  gte?: InputMaybe<Scalars['String']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  lt?: InputMaybe<Scalars['String']>;
  lte?: InputMaybe<Scalars['String']>;
  ne?: InputMaybe<Scalars['String']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']>;
};

export type FilterFindManyOccupancySensorInput = {
  AND?: InputMaybe<Array<FilterFindManyDeviceInput>>;
  OR?: InputMaybe<Array<FilterFindManyDeviceInput>>;
  _id?: InputMaybe<Scalars['String']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterFindManyDeviceOperatorsInput>;
  alertTypes?: InputMaybe<FilterFindManyDeviceAlertTypesInput>;
  controlled?: InputMaybe<FilterFindManyDeviceControlledInput>;
  deviceId?: InputMaybe<Scalars['String']>;
  installation?: InputMaybe<FilterFindManyDeviceInstallationInput>;
  location?: InputMaybe<Scalars['String']>;
  meta?: InputMaybe<FilterFindManyDeviceMetaInput>;
  /** The name of the device */
  name?: InputMaybe<Scalars['String']>;
  occupancy?: InputMaybe<FilterFindManyOccupancySensorOccupancyInput>;
  panelId?: InputMaybe<Scalars['String']>;
  powerState?: InputMaybe<FilterFindManyDevicePowerStateInput>;
  propertyId?: InputMaybe<Scalars['String']>;
  sourceId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  unitId?: InputMaybe<Scalars['String']>;
  updateStatus?: InputMaybe<Scalars['Boolean']>;
  voltage?: InputMaybe<FilterFindManyOccupancySensorVoltageInput>;
  vppId?: InputMaybe<Scalars['String']>;
  zoneId?: InputMaybe<Scalars['String']>;
};

export type FilterFindManyOccupancySensorOccupancyInput = {
  id?: InputMaybe<Scalars['String']>;
  observedAt?: InputMaybe<Scalars['Float']>;
  previousId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  units?: InputMaybe<Scalars['String']>;
  updatePending?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<EnumOccupancySensorOccupancyValue>;
};

export type FilterFindManyOccupancySensorVoltageInput = {
  id?: InputMaybe<Scalars['String']>;
  observedAt?: InputMaybe<Scalars['Float']>;
  previousId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  units?: InputMaybe<Scalars['String']>;
  updatePending?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<Scalars['Float']>;
};

export type FilterFindManyOpenWeatherInput = {
  AND?: InputMaybe<Array<FilterFindManyDeviceInput>>;
  OR?: InputMaybe<Array<FilterFindManyDeviceInput>>;
  _id?: InputMaybe<Scalars['String']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterFindManyDeviceOperatorsInput>;
  alertTypes?: InputMaybe<FilterFindManyDeviceAlertTypesInput>;
  controlled?: InputMaybe<FilterFindManyDeviceControlledInput>;
  deviceId?: InputMaybe<Scalars['String']>;
  installation?: InputMaybe<FilterFindManyDeviceInstallationInput>;
  location?: InputMaybe<Scalars['String']>;
  meta?: InputMaybe<FilterFindManyDeviceMetaInput>;
  /** The name of the device */
  name?: InputMaybe<Scalars['String']>;
  panelId?: InputMaybe<Scalars['String']>;
  powerState?: InputMaybe<FilterFindManyDevicePowerStateInput>;
  propertyId?: InputMaybe<Scalars['String']>;
  sourceId?: InputMaybe<Scalars['String']>;
  temperature?: InputMaybe<FilterFindManyOpenWeatherTemperatureInput>;
  timestamp?: InputMaybe<Scalars['Float']>;
  unitId?: InputMaybe<Scalars['String']>;
  updateStatus?: InputMaybe<Scalars['Boolean']>;
  vppId?: InputMaybe<Scalars['String']>;
  zoneId?: InputMaybe<Scalars['String']>;
};

export type FilterFindManyOpenWeatherTemperatureInput = {
  id?: InputMaybe<Scalars['String']>;
  observedAt?: InputMaybe<Scalars['Float']>;
  previousId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  units?: InputMaybe<Scalars['String']>;
  updatePending?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<Scalars['Float']>;
};

export type FilterFindManyOrganizationHqAddressInput = {
  city?: InputMaybe<Scalars['String']>;
  country?: InputMaybe<Scalars['String']>;
  line1?: InputMaybe<Scalars['String']>;
  line2?: InputMaybe<Scalars['String']>;
  postalCode?: InputMaybe<Scalars['String']>;
  state?: InputMaybe<Scalars['String']>;
};

export type FilterFindManyOrganizationInput = {
  AND?: InputMaybe<Array<FilterFindManyOrganizationInput>>;
  OR?: InputMaybe<Array<FilterFindManyOrganizationInput>>;
  _id?: InputMaybe<Scalars['String']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterFindManyOrganizationOperatorsInput>;
  description?: InputMaybe<Scalars['String']>;
  hqAddress?: InputMaybe<FilterFindManyOrganizationHqAddressInput>;
  hqEmail?: InputMaybe<Scalars['String']>;
  hqPhone?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  parentOrganizationId?: InputMaybe<Scalars['String']>;
};

export type FilterFindManyOrganizationNameOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['String']>;
  gte?: InputMaybe<Scalars['String']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  lt?: InputMaybe<Scalars['String']>;
  lte?: InputMaybe<Scalars['String']>;
  ne?: InputMaybe<Scalars['String']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterFindManyOrganizationOperatorsInput = {
  _id?: InputMaybe<FilterFindManyOrganization_IdOperatorsInput>;
  name?: InputMaybe<FilterFindManyOrganizationNameOperatorsInput>;
  parentOrganizationId?: InputMaybe<FilterFindManyOrganizationParentOrganizationIdOperatorsInput>;
};

export type FilterFindManyOrganizationParentOrganizationIdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['String']>;
  gte?: InputMaybe<Scalars['String']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  lt?: InputMaybe<Scalars['String']>;
  lte?: InputMaybe<Scalars['String']>;
  ne?: InputMaybe<Scalars['String']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']>;
};

export type FilterFindManyOrganization_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['String']>;
  gte?: InputMaybe<Scalars['String']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  lt?: InputMaybe<Scalars['String']>;
  lte?: InputMaybe<Scalars['String']>;
  ne?: InputMaybe<Scalars['String']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']>;
};

export type FilterFindManyOutdoorSensorInput = {
  AND?: InputMaybe<Array<FilterFindManyDeviceInput>>;
  OR?: InputMaybe<Array<FilterFindManyDeviceInput>>;
  _id?: InputMaybe<Scalars['String']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterFindManyDeviceOperatorsInput>;
  alertTypes?: InputMaybe<FilterFindManyDeviceAlertTypesInput>;
  controlled?: InputMaybe<FilterFindManyDeviceControlledInput>;
  deviceId?: InputMaybe<Scalars['String']>;
  installation?: InputMaybe<FilterFindManyDeviceInstallationInput>;
  location?: InputMaybe<Scalars['String']>;
  meta?: InputMaybe<FilterFindManyDeviceMetaInput>;
  /** The name of the device */
  name?: InputMaybe<Scalars['String']>;
  panelId?: InputMaybe<Scalars['String']>;
  powerState?: InputMaybe<FilterFindManyDevicePowerStateInput>;
  propertyId?: InputMaybe<Scalars['String']>;
  sourceId?: InputMaybe<Scalars['String']>;
  temperature?: InputMaybe<FilterFindManyOutdoorSensorTemperatureInput>;
  timestamp?: InputMaybe<Scalars['Float']>;
  unitId?: InputMaybe<Scalars['String']>;
  updateStatus?: InputMaybe<Scalars['Boolean']>;
  vppId?: InputMaybe<Scalars['String']>;
  zoneId?: InputMaybe<Scalars['String']>;
};

export type FilterFindManyOutdoorSensorTemperatureInput = {
  id?: InputMaybe<Scalars['String']>;
  observedAt?: InputMaybe<Scalars['Float']>;
  previousId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  units?: InputMaybe<Scalars['String']>;
  updatePending?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<Scalars['Float']>;
};

export type FilterFindManyPanelInput = {
  AND?: InputMaybe<Array<FilterFindManyPanelInput>>;
  OR?: InputMaybe<Array<FilterFindManyPanelInput>>;
  _id?: InputMaybe<Scalars['String']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterFindManyPanelOperatorsInput>;
  name?: InputMaybe<Scalars['String']>;
  propertyId?: InputMaybe<Scalars['String']>;
  role?: InputMaybe<Scalars['String']>;
  sourceId?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<EnumPanelType>;
  unitId?: InputMaybe<Scalars['String']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterFindManyPanelOperatorsInput = {
  _id?: InputMaybe<FilterFindManyPanel_IdOperatorsInput>;
  propertyId?: InputMaybe<FilterFindManyPanelPropertyIdOperatorsInput>;
  unitId?: InputMaybe<FilterFindManyPanelUnitIdOperatorsInput>;
};

export type FilterFindManyPanelPropertyIdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['String']>;
  gte?: InputMaybe<Scalars['String']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  lt?: InputMaybe<Scalars['String']>;
  lte?: InputMaybe<Scalars['String']>;
  ne?: InputMaybe<Scalars['String']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']>;
};

export type FilterFindManyPanelUnitIdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['String']>;
  gte?: InputMaybe<Scalars['String']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  lt?: InputMaybe<Scalars['String']>;
  lte?: InputMaybe<Scalars['String']>;
  ne?: InputMaybe<Scalars['String']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']>;
};

export type FilterFindManyPanel_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['String']>;
  gte?: InputMaybe<Scalars['String']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  lt?: InputMaybe<Scalars['String']>;
  lte?: InputMaybe<Scalars['String']>;
  ne?: InputMaybe<Scalars['String']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']>;
};

export type FilterFindManyPlmContractContractIdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['String']>;
  gte?: InputMaybe<Scalars['String']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  lt?: InputMaybe<Scalars['String']>;
  lte?: InputMaybe<Scalars['String']>;
  ne?: InputMaybe<Scalars['String']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']>;
};

export type FilterFindManyPlmContractInput = {
  AND?: InputMaybe<Array<FilterFindManyPlmContractInput>>;
  OR?: InputMaybe<Array<FilterFindManyPlmContractInput>>;
  _id?: InputMaybe<Scalars['String']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterFindManyPlmContractOperatorsInput>;
  baselineMethod?: InputMaybe<EnumPlmContractBaselineMethod>;
  contractId?: InputMaybe<Scalars['String']>;
  dispatcherIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  incentiveDescription?: InputMaybe<Scalars['String']>;
  maximumEventsPerSeason?: InputMaybe<Scalars['Float']>;
  meterIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  minimumReductionKW?: InputMaybe<Scalars['Float']>;
  name?: InputMaybe<Scalars['String']>;
  notificationEmail?: InputMaybe<Scalars['String']>;
  partnerId?: InputMaybe<Scalars['String']>;
  penaltyForNonCompliance?: InputMaybe<Scalars['Float']>;
  programId?: InputMaybe<Scalars['String']>;
  propertyIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  scopeType?: InputMaybe<EnumPlmContractScopeType>;
  status?: InputMaybe<EnumPlmContractStatus>;
  utilityId?: InputMaybe<Scalars['String']>;
};

export type FilterFindManyPlmContractNotificationEmailOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['String']>;
  gte?: InputMaybe<Scalars['String']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  lt?: InputMaybe<Scalars['String']>;
  lte?: InputMaybe<Scalars['String']>;
  ne?: InputMaybe<Scalars['String']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterFindManyPlmContractOperatorsInput = {
  _id?: InputMaybe<FilterFindManyPlmContract_IdOperatorsInput>;
  contractId?: InputMaybe<FilterFindManyPlmContractContractIdOperatorsInput>;
  notificationEmail?: InputMaybe<FilterFindManyPlmContractNotificationEmailOperatorsInput>;
  programId?: InputMaybe<FilterFindManyPlmContractProgramIdOperatorsInput>;
};

export type FilterFindManyPlmContractProgramIdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['String']>;
  gte?: InputMaybe<Scalars['String']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  lt?: InputMaybe<Scalars['String']>;
  lte?: InputMaybe<Scalars['String']>;
  ne?: InputMaybe<Scalars['String']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']>;
};

export type FilterFindManyPlmContract_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['String']>;
  gte?: InputMaybe<Scalars['String']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  lt?: InputMaybe<Scalars['String']>;
  lte?: InputMaybe<Scalars['String']>;
  ne?: InputMaybe<Scalars['String']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']>;
};

export type FilterFindManyPlmCurtailmentActionDeviceTypeOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<EnumPlmCurtailmentActionDeviceType>;
  gte?: InputMaybe<EnumPlmCurtailmentActionDeviceType>;
  in?: InputMaybe<Array<InputMaybe<EnumPlmCurtailmentActionDeviceType>>>;
  lt?: InputMaybe<EnumPlmCurtailmentActionDeviceType>;
  lte?: InputMaybe<EnumPlmCurtailmentActionDeviceType>;
  ne?: InputMaybe<EnumPlmCurtailmentActionDeviceType>;
  nin?: InputMaybe<Array<InputMaybe<EnumPlmCurtailmentActionDeviceType>>>;
};

export type FilterFindManyPlmCurtailmentActionEstimatedReductionKwOperatorsInput =
  {
    exists?: InputMaybe<Scalars['Boolean']>;
    gt?: InputMaybe<Scalars['Float']>;
    gte?: InputMaybe<Scalars['Float']>;
    in?: InputMaybe<Array<InputMaybe<Scalars['Float']>>>;
    lt?: InputMaybe<Scalars['Float']>;
    lte?: InputMaybe<Scalars['Float']>;
    ne?: InputMaybe<Scalars['Float']>;
    nin?: InputMaybe<Array<InputMaybe<Scalars['Float']>>>;
  };

export type FilterFindManyPlmCurtailmentActionInput = {
  AND?: InputMaybe<Array<FilterFindManyPlmCurtailmentActionInput>>;
  OR?: InputMaybe<Array<FilterFindManyPlmCurtailmentActionInput>>;
  _id?: InputMaybe<Scalars['String']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterFindManyPlmCurtailmentActionOperatorsInput>;
  autoBatch?: InputMaybe<Scalars['Boolean']>;
  batchCount?: InputMaybe<Scalars['Float']>;
  batchDuration?: InputMaybe<Scalars['Float']>;
  batchStartTimeOffset?: InputMaybe<Scalars['Float']>;
  description?: InputMaybe<Scalars['String']>;
  deviceType?: InputMaybe<EnumPlmCurtailmentActionDeviceType>;
  estimatedReductionKW?: InputMaybe<Scalars['Float']>;
  name?: InputMaybe<Scalars['String']>;
  plmCurtailmentPlanId?: InputMaybe<Scalars['String']>;
  startTimeOffset?: InputMaybe<Scalars['Float']>;
  targetDevices?: InputMaybe<Scalars['JSON']>;
  targetedAdjustments?: InputMaybe<FilterFindManyPlmCurtailmentTaskCachedDeviceStateInput>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterFindManyPlmCurtailmentActionOperatorsInput = {
  _id?: InputMaybe<FilterFindManyPlmCurtailmentAction_IdOperatorsInput>;
  deviceType?: InputMaybe<FilterFindManyPlmCurtailmentActionDeviceTypeOperatorsInput>;
  estimatedReductionKW?: InputMaybe<FilterFindManyPlmCurtailmentActionEstimatedReductionKwOperatorsInput>;
  plmCurtailmentPlanId?: InputMaybe<FilterFindManyPlmCurtailmentActionPlmCurtailmentPlanIdOperatorsInput>;
};

export type FilterFindManyPlmCurtailmentActionPlmCurtailmentPlanIdOperatorsInput =
  {
    exists?: InputMaybe<Scalars['Boolean']>;
    gt?: InputMaybe<Scalars['String']>;
    gte?: InputMaybe<Scalars['String']>;
    in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    lt?: InputMaybe<Scalars['String']>;
    lte?: InputMaybe<Scalars['String']>;
    ne?: InputMaybe<Scalars['String']>;
    nin?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    regex?: InputMaybe<Scalars['RegExpAsString']>;
  };

export type FilterFindManyPlmCurtailmentAction_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['String']>;
  gte?: InputMaybe<Scalars['String']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  lt?: InputMaybe<Scalars['String']>;
  lte?: InputMaybe<Scalars['String']>;
  ne?: InputMaybe<Scalars['String']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']>;
};

export type FilterFindManyPlmCurtailmentPlanDurationMinutesOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['Float']>;
  gte?: InputMaybe<Scalars['Float']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Float']>>>;
  lt?: InputMaybe<Scalars['Float']>;
  lte?: InputMaybe<Scalars['Float']>;
  ne?: InputMaybe<Scalars['Float']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Float']>>>;
};

export type FilterFindManyPlmCurtailmentPlanEstimatedReductionKwOperatorsInput =
  {
    exists?: InputMaybe<Scalars['Boolean']>;
    gt?: InputMaybe<Scalars['Float']>;
    gte?: InputMaybe<Scalars['Float']>;
    in?: InputMaybe<Array<InputMaybe<Scalars['Float']>>>;
    lt?: InputMaybe<Scalars['Float']>;
    lte?: InputMaybe<Scalars['Float']>;
    ne?: InputMaybe<Scalars['Float']>;
    nin?: InputMaybe<Array<InputMaybe<Scalars['Float']>>>;
  };

export type FilterFindManyPlmCurtailmentPlanInput = {
  AND?: InputMaybe<Array<FilterFindManyPlmCurtailmentPlanInput>>;
  OR?: InputMaybe<Array<FilterFindManyPlmCurtailmentPlanInput>>;
  _id?: InputMaybe<Scalars['String']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterFindManyPlmCurtailmentPlanOperatorsInput>;
  applicableSeasons?: InputMaybe<
    Array<InputMaybe<EnumPlmCurtailmentPlanApplicableSeasons>>
  >;
  description?: InputMaybe<Scalars['String']>;
  durationMinutes?: InputMaybe<Scalars['Float']>;
  estimatedReductionKW?: InputMaybe<Scalars['Float']>;
  name?: InputMaybe<Scalars['String']>;
  organizationId?: InputMaybe<Scalars['String']>;
};

export type FilterFindManyPlmCurtailmentPlanNameOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['String']>;
  gte?: InputMaybe<Scalars['String']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  lt?: InputMaybe<Scalars['String']>;
  lte?: InputMaybe<Scalars['String']>;
  ne?: InputMaybe<Scalars['String']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterFindManyPlmCurtailmentPlanOperatorsInput = {
  _id?: InputMaybe<FilterFindManyPlmCurtailmentPlan_IdOperatorsInput>;
  durationMinutes?: InputMaybe<FilterFindManyPlmCurtailmentPlanDurationMinutesOperatorsInput>;
  estimatedReductionKW?: InputMaybe<FilterFindManyPlmCurtailmentPlanEstimatedReductionKwOperatorsInput>;
  name?: InputMaybe<FilterFindManyPlmCurtailmentPlanNameOperatorsInput>;
  organizationId?: InputMaybe<FilterFindManyPlmCurtailmentPlanOrganizationIdOperatorsInput>;
};

export type FilterFindManyPlmCurtailmentPlanOrganizationIdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['String']>;
  gte?: InputMaybe<Scalars['String']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  lt?: InputMaybe<Scalars['String']>;
  lte?: InputMaybe<Scalars['String']>;
  ne?: InputMaybe<Scalars['String']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']>;
};

export type FilterFindManyPlmCurtailmentPlan_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['String']>;
  gte?: InputMaybe<Scalars['String']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  lt?: InputMaybe<Scalars['String']>;
  lte?: InputMaybe<Scalars['String']>;
  ne?: InputMaybe<Scalars['String']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']>;
};

export type FilterFindManyPlmCurtailmentTaskCachedDeviceStateInput = {
  coolSetpoint?: InputMaybe<Scalars['Float']>;
  coolSetpointAdjustmentMode?: InputMaybe<EnumPlmCurtailmentTaskCachedDeviceStateCoolSetpointAdjustmentMode>;
  fanMode?: InputMaybe<Scalars['String']>;
  fanSpeed?: InputMaybe<Scalars['String']>;
  freshAirSetpoint?: InputMaybe<Scalars['Float']>;
  heatSetpoint?: InputMaybe<Scalars['Float']>;
  heatSetpointAdjustmentMode?: InputMaybe<EnumPlmCurtailmentTaskCachedDeviceStateHeatSetpointAdjustmentMode>;
  isOn?: InputMaybe<Scalars['Boolean']>;
  keypadLockoutLevel?: InputMaybe<Scalars['String']>;
  maxCoolSetpointLimit?: InputMaybe<Scalars['Float']>;
  maxHeatSetpointLimit?: InputMaybe<Scalars['Float']>;
  minCoolSetpointLimit?: InputMaybe<Scalars['Float']>;
  minHeatSetpointLimit?: InputMaybe<Scalars['Float']>;
  operatingMode?: InputMaybe<Scalars['String']>;
  rhSetpoint?: InputMaybe<Scalars['Float']>;
  type?: InputMaybe<EnumPlmCurtailmentTaskCachedDeviceStateType>;
  ventilationMode?: InputMaybe<Scalars['String']>;
};

export type FilterFindManyPlmCurtailmentTaskDeviceIdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['String']>;
  gte?: InputMaybe<Scalars['String']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  lt?: InputMaybe<Scalars['String']>;
  lte?: InputMaybe<Scalars['String']>;
  ne?: InputMaybe<Scalars['String']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']>;
};

export type FilterFindManyPlmCurtailmentTaskInput = {
  AND?: InputMaybe<Array<FilterFindManyPlmCurtailmentTaskInput>>;
  OR?: InputMaybe<Array<FilterFindManyPlmCurtailmentTaskInput>>;
  _id?: InputMaybe<Scalars['String']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterFindManyPlmCurtailmentTaskOperatorsInput>;
  batchId?: InputMaybe<Scalars['Float']>;
  cachedDeviceState?: InputMaybe<FilterFindManyPlmCurtailmentTaskCachedDeviceStateInput>;
  deviceId?: InputMaybe<Scalars['String']>;
  deviceType?: InputMaybe<Scalars['String']>;
  endedAt?: InputMaybe<Scalars['Float']>;
  estimatedReductionKW?: InputMaybe<Scalars['Float']>;
  plmCurtailmentActionId?: InputMaybe<Scalars['String']>;
  plmEventResponseId?: InputMaybe<Scalars['String']>;
  propertyId?: InputMaybe<Scalars['String']>;
  resolvedTargetedAdjustments?: InputMaybe<FilterFindManyPlmCurtailmentTaskCachedDeviceStateInput>;
  scheduledEnd?: InputMaybe<Scalars['Float']>;
  scheduledStart?: InputMaybe<Scalars['Float']>;
  startedAt?: InputMaybe<Scalars['Float']>;
  status?: InputMaybe<EnumPlmCurtailmentTaskStatus>;
  statusMessage?: InputMaybe<Scalars['String']>;
  targetedAdjustments?: InputMaybe<FilterFindManyPlmCurtailmentTaskCachedDeviceStateInput>;
  unitId?: InputMaybe<Scalars['String']>;
  updateRetryCount?: InputMaybe<Scalars['Float']>;
  verifiedAt?: InputMaybe<Scalars['Float']>;
  verifyAttempts?: InputMaybe<Scalars['Float']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterFindManyPlmCurtailmentTaskOperatorsInput = {
  _id?: InputMaybe<FilterFindManyPlmCurtailmentTask_IdOperatorsInput>;
  deviceId?: InputMaybe<FilterFindManyPlmCurtailmentTaskDeviceIdOperatorsInput>;
};

export type FilterFindManyPlmCurtailmentTask_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['String']>;
  gte?: InputMaybe<Scalars['String']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  lt?: InputMaybe<Scalars['String']>;
  lte?: InputMaybe<Scalars['String']>;
  ne?: InputMaybe<Scalars['String']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']>;
};

export type FilterFindManyPlmEventContractIdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['String']>;
  gte?: InputMaybe<Scalars['String']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  lt?: InputMaybe<Scalars['String']>;
  lte?: InputMaybe<Scalars['String']>;
  ne?: InputMaybe<Scalars['String']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']>;
};

export type FilterFindManyPlmEventInput = {
  AND?: InputMaybe<Array<FilterFindManyPlmEventInput>>;
  OR?: InputMaybe<Array<FilterFindManyPlmEventInput>>;
  _id?: InputMaybe<Scalars['String']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterFindManyPlmEventOperatorsInput>;
  contractId?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['Float']>;
  duration?: InputMaybe<Scalars['Float']>;
  notificationHeaders?: InputMaybe<Scalars['JSON']>;
  notificationMethod?: InputMaybe<EnumPlmEventNotificationMethod>;
  notificationPayload?: InputMaybe<Scalars['String']>;
  notificationReceivedAt?: InputMaybe<Scalars['Float']>;
  programId?: InputMaybe<Scalars['String']>;
  reductionTarget?: InputMaybe<Scalars['Float']>;
  sourceExternalId?: InputMaybe<Scalars['String']>;
  sourceVendor?: InputMaybe<Scalars['String']>;
  startTime?: InputMaybe<Scalars['Float']>;
  status?: InputMaybe<EnumPlmEventStatus>;
  updatedAt?: InputMaybe<Scalars['Float']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterFindManyPlmEventOperatorsInput = {
  _id?: InputMaybe<FilterFindManyPlmEvent_IdOperatorsInput>;
  contractId?: InputMaybe<FilterFindManyPlmEventContractIdOperatorsInput>;
  programId?: InputMaybe<FilterFindManyPlmEventProgramIdOperatorsInput>;
  sourceVendor?: InputMaybe<FilterFindManyPlmEventSourceVendorOperatorsInput>;
  startTime?: InputMaybe<FilterFindManyPlmEventStartTimeOperatorsInput>;
  status?: InputMaybe<FilterFindManyPlmEventStatusOperatorsInput>;
};

export type FilterFindManyPlmEventProgramIdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['String']>;
  gte?: InputMaybe<Scalars['String']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  lt?: InputMaybe<Scalars['String']>;
  lte?: InputMaybe<Scalars['String']>;
  ne?: InputMaybe<Scalars['String']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']>;
};

export type FilterFindManyPlmEventResponseCurtailmentPlanIdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['String']>;
  gte?: InputMaybe<Scalars['String']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  lt?: InputMaybe<Scalars['String']>;
  lte?: InputMaybe<Scalars['String']>;
  ne?: InputMaybe<Scalars['String']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']>;
};

export type FilterFindManyPlmEventResponseEventIdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['String']>;
  gte?: InputMaybe<Scalars['String']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  lt?: InputMaybe<Scalars['String']>;
  lte?: InputMaybe<Scalars['String']>;
  ne?: InputMaybe<Scalars['String']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']>;
};

export type FilterFindManyPlmEventResponseInput = {
  AND?: InputMaybe<Array<FilterFindManyPlmEventResponseInput>>;
  OR?: InputMaybe<Array<FilterFindManyPlmEventResponseInput>>;
  _id?: InputMaybe<Scalars['String']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterFindManyPlmEventResponseOperatorsInput>;
  actualEnd?: InputMaybe<Scalars['Float']>;
  actualStart?: InputMaybe<Scalars['Float']>;
  createdAt?: InputMaybe<Scalars['Float']>;
  curtailmentPlanId?: InputMaybe<Scalars['String']>;
  eventId?: InputMaybe<Scalars['String']>;
  propertyId?: InputMaybe<Scalars['String']>;
  responseSentAt?: InputMaybe<Scalars['Float']>;
  responseStatus?: InputMaybe<EnumPlmEventResponseResponseStatus>;
  scheduledEnd?: InputMaybe<Scalars['Float']>;
  scheduledStart?: InputMaybe<Scalars['Float']>;
  updatedAt?: InputMaybe<Scalars['Float']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterFindManyPlmEventResponseOperatorsInput = {
  _id?: InputMaybe<FilterFindManyPlmEventResponse_IdOperatorsInput>;
  curtailmentPlanId?: InputMaybe<FilterFindManyPlmEventResponseCurtailmentPlanIdOperatorsInput>;
  eventId?: InputMaybe<FilterFindManyPlmEventResponseEventIdOperatorsInput>;
  propertyId?: InputMaybe<FilterFindManyPlmEventResponsePropertyIdOperatorsInput>;
  responseSentAt?: InputMaybe<FilterFindManyPlmEventResponseResponseSentAtOperatorsInput>;
  responseStatus?: InputMaybe<FilterFindManyPlmEventResponseResponseStatusOperatorsInput>;
  scheduledStart?: InputMaybe<FilterFindManyPlmEventResponseScheduledStartOperatorsInput>;
};

export type FilterFindManyPlmEventResponsePropertyIdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['String']>;
  gte?: InputMaybe<Scalars['String']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  lt?: InputMaybe<Scalars['String']>;
  lte?: InputMaybe<Scalars['String']>;
  ne?: InputMaybe<Scalars['String']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']>;
};

export type FilterFindManyPlmEventResponseResponseSentAtOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['Float']>;
  gte?: InputMaybe<Scalars['Float']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Float']>>>;
  lt?: InputMaybe<Scalars['Float']>;
  lte?: InputMaybe<Scalars['Float']>;
  ne?: InputMaybe<Scalars['Float']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Float']>>>;
};

export type FilterFindManyPlmEventResponseResponseStatusOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<EnumPlmEventResponseResponseStatus>;
  gte?: InputMaybe<EnumPlmEventResponseResponseStatus>;
  in?: InputMaybe<Array<InputMaybe<EnumPlmEventResponseResponseStatus>>>;
  lt?: InputMaybe<EnumPlmEventResponseResponseStatus>;
  lte?: InputMaybe<EnumPlmEventResponseResponseStatus>;
  ne?: InputMaybe<EnumPlmEventResponseResponseStatus>;
  nin?: InputMaybe<Array<InputMaybe<EnumPlmEventResponseResponseStatus>>>;
};

export type FilterFindManyPlmEventResponseScheduledStartOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['Float']>;
  gte?: InputMaybe<Scalars['Float']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Float']>>>;
  lt?: InputMaybe<Scalars['Float']>;
  lte?: InputMaybe<Scalars['Float']>;
  ne?: InputMaybe<Scalars['Float']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Float']>>>;
};

export type FilterFindManyPlmEventResponse_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['String']>;
  gte?: InputMaybe<Scalars['String']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  lt?: InputMaybe<Scalars['String']>;
  lte?: InputMaybe<Scalars['String']>;
  ne?: InputMaybe<Scalars['String']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']>;
};

export type FilterFindManyPlmEventSourceVendorOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['String']>;
  gte?: InputMaybe<Scalars['String']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  lt?: InputMaybe<Scalars['String']>;
  lte?: InputMaybe<Scalars['String']>;
  ne?: InputMaybe<Scalars['String']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']>;
};

export type FilterFindManyPlmEventStartTimeOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['Float']>;
  gte?: InputMaybe<Scalars['Float']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Float']>>>;
  lt?: InputMaybe<Scalars['Float']>;
  lte?: InputMaybe<Scalars['Float']>;
  ne?: InputMaybe<Scalars['Float']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Float']>>>;
};

export type FilterFindManyPlmEventStatusOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<EnumPlmEventStatus>;
  gte?: InputMaybe<EnumPlmEventStatus>;
  in?: InputMaybe<Array<InputMaybe<EnumPlmEventStatus>>>;
  lt?: InputMaybe<EnumPlmEventStatus>;
  lte?: InputMaybe<EnumPlmEventStatus>;
  ne?: InputMaybe<EnumPlmEventStatus>;
  nin?: InputMaybe<Array<InputMaybe<EnumPlmEventStatus>>>;
};

export type FilterFindManyPlmEvent_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['String']>;
  gte?: InputMaybe<Scalars['String']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  lt?: InputMaybe<Scalars['String']>;
  lte?: InputMaybe<Scalars['String']>;
  ne?: InputMaybe<Scalars['String']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']>;
};

export type FilterFindManyPlmExternalMeterMappingInput = {
  AND?: InputMaybe<Array<FilterFindManyPlmExternalMeterMappingInput>>;
  OR?: InputMaybe<Array<FilterFindManyPlmExternalMeterMappingInput>>;
  _id?: InputMaybe<Scalars['String']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterFindManyPlmExternalMeterMappingOperatorsInput>;
  meterId?: InputMaybe<Scalars['String']>;
  partnerId?: InputMaybe<Scalars['String']>;
  propertyId?: InputMaybe<Scalars['String']>;
  providerAttributes?: InputMaybe<Scalars['JSON']>;
  vendor?: InputMaybe<Scalars['String']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterFindManyPlmExternalMeterMappingOperatorsInput = {
  _id?: InputMaybe<FilterFindManyPlmExternalMeterMapping_IdOperatorsInput>;
  propertyId?: InputMaybe<FilterFindManyPlmExternalMeterMappingPropertyIdOperatorsInput>;
  vendor?: InputMaybe<FilterFindManyPlmExternalMeterMappingVendorOperatorsInput>;
};

export type FilterFindManyPlmExternalMeterMappingPropertyIdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['String']>;
  gte?: InputMaybe<Scalars['String']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  lt?: InputMaybe<Scalars['String']>;
  lte?: InputMaybe<Scalars['String']>;
  ne?: InputMaybe<Scalars['String']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']>;
};

export type FilterFindManyPlmExternalMeterMappingVendorOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['String']>;
  gte?: InputMaybe<Scalars['String']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  lt?: InputMaybe<Scalars['String']>;
  lte?: InputMaybe<Scalars['String']>;
  ne?: InputMaybe<Scalars['String']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']>;
};

export type FilterFindManyPlmExternalMeterMapping_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['String']>;
  gte?: InputMaybe<Scalars['String']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  lt?: InputMaybe<Scalars['String']>;
  lte?: InputMaybe<Scalars['String']>;
  ne?: InputMaybe<Scalars['String']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']>;
};

export type FilterFindManyPlmIngressEventInput = {
  AND?: InputMaybe<Array<FilterFindManyPlmIngressEventInput>>;
  OR?: InputMaybe<Array<FilterFindManyPlmIngressEventInput>>;
  _id?: InputMaybe<Scalars['String']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterFindManyPlmIngressEventOperatorsInput>;
  headers?: InputMaybe<Scalars['JSON']>;
  lastError?: InputMaybe<Scalars['String']>;
  plmEventId?: InputMaybe<Scalars['String']>;
  processedAt?: InputMaybe<Scalars['Float']>;
  rawPayload?: InputMaybe<Scalars['String']>;
  receivedAt?: InputMaybe<Scalars['Float']>;
  source?: InputMaybe<EnumPlmIngressEventSource>;
  status?: InputMaybe<EnumPlmIngressEventStatus>;
  vendorKey?: InputMaybe<Scalars['String']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterFindManyPlmIngressEventOperatorsInput = {
  _id?: InputMaybe<FilterFindManyPlmIngressEvent_IdOperatorsInput>;
  status?: InputMaybe<FilterFindManyPlmIngressEventStatusOperatorsInput>;
  vendorKey?: InputMaybe<FilterFindManyPlmIngressEventVendorKeyOperatorsInput>;
};

export type FilterFindManyPlmIngressEventStatusOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<EnumPlmIngressEventStatus>;
  gte?: InputMaybe<EnumPlmIngressEventStatus>;
  in?: InputMaybe<Array<InputMaybe<EnumPlmIngressEventStatus>>>;
  lt?: InputMaybe<EnumPlmIngressEventStatus>;
  lte?: InputMaybe<EnumPlmIngressEventStatus>;
  ne?: InputMaybe<EnumPlmIngressEventStatus>;
  nin?: InputMaybe<Array<InputMaybe<EnumPlmIngressEventStatus>>>;
};

export type FilterFindManyPlmIngressEventVendorKeyOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['String']>;
  gte?: InputMaybe<Scalars['String']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  lt?: InputMaybe<Scalars['String']>;
  lte?: InputMaybe<Scalars['String']>;
  ne?: InputMaybe<Scalars['String']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']>;
};

export type FilterFindManyPlmIngressEvent_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['String']>;
  gte?: InputMaybe<Scalars['String']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  lt?: InputMaybe<Scalars['String']>;
  lte?: InputMaybe<Scalars['String']>;
  ne?: InputMaybe<Scalars['String']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']>;
};

export type FilterFindManyPlmNotificationActivationTimeOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['Date']>;
  gte?: InputMaybe<Scalars['Date']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Date']>>>;
  lt?: InputMaybe<Scalars['Date']>;
  lte?: InputMaybe<Scalars['Date']>;
  ne?: InputMaybe<Scalars['Date']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Date']>>>;
};

export type FilterFindManyPlmNotificationContractIdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['String']>;
  gte?: InputMaybe<Scalars['String']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  lt?: InputMaybe<Scalars['String']>;
  lte?: InputMaybe<Scalars['String']>;
  ne?: InputMaybe<Scalars['String']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']>;
};

export type FilterFindManyPlmNotificationInput = {
  AND?: InputMaybe<Array<FilterFindManyPlmNotificationInput>>;
  OR?: InputMaybe<Array<FilterFindManyPlmNotificationInput>>;
  _id?: InputMaybe<Scalars['String']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterFindManyPlmNotificationOperatorsInput>;
  activationTime?: InputMaybe<Scalars['Date']>;
  contractId?: InputMaybe<Scalars['String']>;
  deactivationTime?: InputMaybe<Scalars['Date']>;
  participationStatus?: InputMaybe<EnumPlmNotificationParticipationStatus>;
  partnerId?: InputMaybe<Scalars['String']>;
  payload?: InputMaybe<Scalars['String']>;
  programId?: InputMaybe<Scalars['String']>;
  receivedAt?: InputMaybe<Scalars['Date']>;
  responseSentAt?: InputMaybe<Scalars['Date']>;
  source?: InputMaybe<EnumPlmNotificationSource>;
  utilityId?: InputMaybe<Scalars['String']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterFindManyPlmNotificationOperatorsInput = {
  _id?: InputMaybe<FilterFindManyPlmNotification_IdOperatorsInput>;
  activationTime?: InputMaybe<FilterFindManyPlmNotificationActivationTimeOperatorsInput>;
  contractId?: InputMaybe<FilterFindManyPlmNotificationContractIdOperatorsInput>;
  partnerId?: InputMaybe<FilterFindManyPlmNotificationPartnerIdOperatorsInput>;
  programId?: InputMaybe<FilterFindManyPlmNotificationProgramIdOperatorsInput>;
};

export type FilterFindManyPlmNotificationPartnerIdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['String']>;
  gte?: InputMaybe<Scalars['String']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  lt?: InputMaybe<Scalars['String']>;
  lte?: InputMaybe<Scalars['String']>;
  ne?: InputMaybe<Scalars['String']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']>;
};

export type FilterFindManyPlmNotificationProgramIdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['String']>;
  gte?: InputMaybe<Scalars['String']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  lt?: InputMaybe<Scalars['String']>;
  lte?: InputMaybe<Scalars['String']>;
  ne?: InputMaybe<Scalars['String']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']>;
};

export type FilterFindManyPlmNotification_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['String']>;
  gte?: InputMaybe<Scalars['String']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  lt?: InputMaybe<Scalars['String']>;
  lte?: InputMaybe<Scalars['String']>;
  ne?: InputMaybe<Scalars['String']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']>;
};

export type FilterFindManyPlmPartnerContactInput = {
  email?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  phone?: InputMaybe<Scalars['String']>;
};

export type FilterFindManyPlmPartnerInput = {
  AND?: InputMaybe<Array<FilterFindManyPlmPartnerInput>>;
  OR?: InputMaybe<Array<FilterFindManyPlmPartnerInput>>;
  _id?: InputMaybe<Scalars['String']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterFindManyPlmPartnerOperatorsInput>;
  contact?: InputMaybe<FilterFindManyPlmPartnerContactInput>;
  description?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  partnerType?: InputMaybe<EnumPlmPartnerPartnerType>;
};

export type FilterFindManyPlmPartnerNameOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['String']>;
  gte?: InputMaybe<Scalars['String']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  lt?: InputMaybe<Scalars['String']>;
  lte?: InputMaybe<Scalars['String']>;
  ne?: InputMaybe<Scalars['String']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterFindManyPlmPartnerOperatorsInput = {
  _id?: InputMaybe<FilterFindManyPlmPartner_IdOperatorsInput>;
  name?: InputMaybe<FilterFindManyPlmPartnerNameOperatorsInput>;
};

export type FilterFindManyPlmPartner_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['String']>;
  gte?: InputMaybe<Scalars['String']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  lt?: InputMaybe<Scalars['String']>;
  lte?: InputMaybe<Scalars['String']>;
  ne?: InputMaybe<Scalars['String']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']>;
};

export type FilterFindManyPlmProgramHostPartnerIdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['String']>;
  gte?: InputMaybe<Scalars['String']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  lt?: InputMaybe<Scalars['String']>;
  lte?: InputMaybe<Scalars['String']>;
  ne?: InputMaybe<Scalars['String']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']>;
};

export type FilterFindManyPlmProgramInput = {
  AND?: InputMaybe<Array<FilterFindManyPlmProgramInput>>;
  OR?: InputMaybe<Array<FilterFindManyPlmProgramInput>>;
  _id?: InputMaybe<Scalars['String']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterFindManyPlmProgramOperatorsInput>;
  endDate?: InputMaybe<Scalars['Float']>;
  hostPartnerId?: InputMaybe<Scalars['String']>;
  hostUtilityId?: InputMaybe<Scalars['String']>;
  incentiveDescription?: InputMaybe<Scalars['String']>;
  maximumEventDurationMinutes?: InputMaybe<Scalars['Float']>;
  maximumEventsPerSeason?: InputMaybe<Scalars['Float']>;
  maximumNotificationLeadTimeMinutes?: InputMaybe<Scalars['Float']>;
  measurementIntervalMinutes?: InputMaybe<Scalars['Float']>;
  minimumEventDurationMinutes?: InputMaybe<Scalars['Float']>;
  minimumEventsPerSeason?: InputMaybe<Scalars['Float']>;
  name?: InputMaybe<Scalars['String']>;
  notificationLeadTimeMinutes?: InputMaybe<Scalars['Float']>;
  participationType?: InputMaybe<EnumPlmProgramParticipationType>;
  partnerId?: InputMaybe<Scalars['String']>;
  programId?: InputMaybe<Scalars['String']>;
  season?: InputMaybe<EnumPlmProgramSeason>;
  startDate?: InputMaybe<Scalars['Float']>;
  utilityId?: InputMaybe<Scalars['String']>;
};

export type FilterFindManyPlmProgramNameOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['String']>;
  gte?: InputMaybe<Scalars['String']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  lt?: InputMaybe<Scalars['String']>;
  lte?: InputMaybe<Scalars['String']>;
  ne?: InputMaybe<Scalars['String']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterFindManyPlmProgramOperatorsInput = {
  _id?: InputMaybe<FilterFindManyPlmProgram_IdOperatorsInput>;
  hostPartnerId?: InputMaybe<FilterFindManyPlmProgramHostPartnerIdOperatorsInput>;
  name?: InputMaybe<FilterFindManyPlmProgramNameOperatorsInput>;
  partnerId?: InputMaybe<FilterFindManyPlmProgramPartnerIdOperatorsInput>;
  programId?: InputMaybe<FilterFindManyPlmProgramProgramIdOperatorsInput>;
};

export type FilterFindManyPlmProgramPartnerIdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['String']>;
  gte?: InputMaybe<Scalars['String']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  lt?: InputMaybe<Scalars['String']>;
  lte?: InputMaybe<Scalars['String']>;
  ne?: InputMaybe<Scalars['String']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']>;
};

export type FilterFindManyPlmProgramProgramIdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['String']>;
  gte?: InputMaybe<Scalars['String']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  lt?: InputMaybe<Scalars['String']>;
  lte?: InputMaybe<Scalars['String']>;
  ne?: InputMaybe<Scalars['String']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']>;
};

export type FilterFindManyPlmProgram_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['String']>;
  gte?: InputMaybe<Scalars['String']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  lt?: InputMaybe<Scalars['String']>;
  lte?: InputMaybe<Scalars['String']>;
  ne?: InputMaybe<Scalars['String']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']>;
};

export type FilterFindManyPlmUtilityContactInput = {
  email?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  phone?: InputMaybe<Scalars['String']>;
};

export type FilterFindManyPlmUtilityInput = {
  AND?: InputMaybe<Array<FilterFindManyPlmUtilityInput>>;
  OR?: InputMaybe<Array<FilterFindManyPlmUtilityInput>>;
  _id?: InputMaybe<Scalars['String']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterFindManyPlmUtilityOperatorsInput>;
  contact?: InputMaybe<FilterFindManyPlmUtilityContactInput>;
  description?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
};

export type FilterFindManyPlmUtilityNameOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['String']>;
  gte?: InputMaybe<Scalars['String']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  lt?: InputMaybe<Scalars['String']>;
  lte?: InputMaybe<Scalars['String']>;
  ne?: InputMaybe<Scalars['String']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterFindManyPlmUtilityOperatorsInput = {
  _id?: InputMaybe<FilterFindManyPlmUtility_IdOperatorsInput>;
  name?: InputMaybe<FilterFindManyPlmUtilityNameOperatorsInput>;
};

export type FilterFindManyPlmUtility_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['String']>;
  gte?: InputMaybe<Scalars['String']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  lt?: InputMaybe<Scalars['String']>;
  lte?: InputMaybe<Scalars['String']>;
  ne?: InputMaybe<Scalars['String']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']>;
};

export type FilterFindManyPowerMonitorFrequencyInput = {
  id?: InputMaybe<Scalars['String']>;
  observedAt?: InputMaybe<Scalars['Float']>;
  previousId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  units?: InputMaybe<Scalars['String']>;
  updatePending?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<Scalars['Float']>;
};

export type FilterFindManyPowerMonitorInput = {
  AND?: InputMaybe<Array<FilterFindManyDeviceInput>>;
  OR?: InputMaybe<Array<FilterFindManyDeviceInput>>;
  _id?: InputMaybe<Scalars['String']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterFindManyDeviceOperatorsInput>;
  alertTypes?: InputMaybe<FilterFindManyDeviceAlertTypesInput>;
  controlled?: InputMaybe<FilterFindManyDeviceControlledInput>;
  deviceId?: InputMaybe<Scalars['String']>;
  frequency?: InputMaybe<FilterFindManyPowerMonitorFrequencyInput>;
  installation?: InputMaybe<FilterFindManyDeviceInstallationInput>;
  location?: InputMaybe<Scalars['String']>;
  meta?: InputMaybe<FilterFindManyDeviceMetaInput>;
  /** The name of the device */
  name?: InputMaybe<Scalars['String']>;
  panelId?: InputMaybe<Scalars['String']>;
  phaseAActiveEnergyFwd?: InputMaybe<FilterFindManyPowerMonitorPhaseAActiveEnergyFwdInput>;
  phaseAActiveEnergyRev?: InputMaybe<FilterFindManyPowerMonitorPhaseAActiveEnergyRevInput>;
  phaseAActivePower?: InputMaybe<FilterFindManyPowerMonitorPhaseAActivePowerInput>;
  phaseACurrent?: InputMaybe<FilterFindManyPowerMonitorPhaseACurrentInput>;
  phaseAFrequency?: InputMaybe<FilterFindManyPowerMonitorPhaseAFrequencyInput>;
  phaseAPowerFactor?: InputMaybe<FilterFindManyPowerMonitorPhaseAPowerFactorInput>;
  phaseAVoltage?: InputMaybe<FilterFindManyPowerMonitorPhaseAVoltageInput>;
  phaseBActiveEnergyFwd?: InputMaybe<FilterFindManyPowerMonitorPhaseBActiveEnergyFwdInput>;
  phaseBActiveEnergyRev?: InputMaybe<FilterFindManyPowerMonitorPhaseBActiveEnergyRevInput>;
  phaseBActivePower?: InputMaybe<FilterFindManyPowerMonitorPhaseBActivePowerInput>;
  phaseBCurrent?: InputMaybe<FilterFindManyPowerMonitorPhaseBCurrentInput>;
  phaseBFrequency?: InputMaybe<FilterFindManyPowerMonitorPhaseBFrequencyInput>;
  phaseBPowerFactor?: InputMaybe<FilterFindManyPowerMonitorPhaseBPowerFactorInput>;
  phaseBVoltage?: InputMaybe<FilterFindManyPowerMonitorPhaseBVoltageInput>;
  phaseCActiveEnergyFwd?: InputMaybe<FilterFindManyPowerMonitorPhaseCActiveEnergyFwdInput>;
  phaseCActiveEnergyRev?: InputMaybe<FilterFindManyPowerMonitorPhaseCActiveEnergyRevInput>;
  phaseCActivePower?: InputMaybe<FilterFindManyPowerMonitorPhaseCActivePowerInput>;
  phaseCCurrent?: InputMaybe<FilterFindManyPowerMonitorPhaseCCurrentInput>;
  phaseCFrequency?: InputMaybe<FilterFindManyPowerMonitorPhaseCFrequencyInput>;
  phaseCPowerFactor?: InputMaybe<FilterFindManyPowerMonitorPhaseCPowerFactorInput>;
  phaseCVoltage?: InputMaybe<FilterFindManyPowerMonitorPhaseCVoltageInput>;
  powerState?: InputMaybe<FilterFindManyDevicePowerStateInput>;
  propertyId?: InputMaybe<Scalars['String']>;
  sourceId?: InputMaybe<Scalars['String']>;
  threePhaseTotalActiveEnergyFwd?: InputMaybe<FilterFindManyPowerMonitorThreePhaseTotalActiveEnergyFwdInput>;
  threePhaseTotalActiveEnergyRev?: InputMaybe<FilterFindManyPowerMonitorThreePhaseTotalActiveEnergyRevInput>;
  timestamp?: InputMaybe<Scalars['Float']>;
  totalActivePower?: InputMaybe<FilterFindManyPowerMonitorTotalActivePowerInput>;
  totalPowerFactor?: InputMaybe<FilterFindManyPowerMonitorTotalPowerFactorInput>;
  unitId?: InputMaybe<Scalars['String']>;
  updateStatus?: InputMaybe<Scalars['Boolean']>;
  vppId?: InputMaybe<Scalars['String']>;
  zoneId?: InputMaybe<Scalars['String']>;
};

export type FilterFindManyPowerMonitorPhaseAActiveEnergyFwdInput = {
  id?: InputMaybe<Scalars['String']>;
  observedAt?: InputMaybe<Scalars['Float']>;
  previousId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  units?: InputMaybe<Scalars['String']>;
  updatePending?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<Scalars['Float']>;
};

export type FilterFindManyPowerMonitorPhaseAActiveEnergyRevInput = {
  id?: InputMaybe<Scalars['String']>;
  observedAt?: InputMaybe<Scalars['Float']>;
  previousId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  units?: InputMaybe<Scalars['String']>;
  updatePending?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<Scalars['Float']>;
};

export type FilterFindManyPowerMonitorPhaseAActivePowerInput = {
  id?: InputMaybe<Scalars['String']>;
  observedAt?: InputMaybe<Scalars['Float']>;
  previousId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  units?: InputMaybe<Scalars['String']>;
  updatePending?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<Scalars['Float']>;
};

export type FilterFindManyPowerMonitorPhaseACurrentInput = {
  id?: InputMaybe<Scalars['String']>;
  observedAt?: InputMaybe<Scalars['Float']>;
  previousId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  units?: InputMaybe<Scalars['String']>;
  updatePending?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<Scalars['Float']>;
};

export type FilterFindManyPowerMonitorPhaseAFrequencyInput = {
  id?: InputMaybe<Scalars['String']>;
  observedAt?: InputMaybe<Scalars['Float']>;
  previousId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  units?: InputMaybe<Scalars['String']>;
  updatePending?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<Scalars['Float']>;
};

export type FilterFindManyPowerMonitorPhaseAPowerFactorInput = {
  id?: InputMaybe<Scalars['String']>;
  observedAt?: InputMaybe<Scalars['Float']>;
  previousId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  units?: InputMaybe<Scalars['String']>;
  updatePending?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<Scalars['Float']>;
};

export type FilterFindManyPowerMonitorPhaseAVoltageInput = {
  id?: InputMaybe<Scalars['String']>;
  observedAt?: InputMaybe<Scalars['Float']>;
  previousId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  units?: InputMaybe<Scalars['String']>;
  updatePending?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<Scalars['Float']>;
};

export type FilterFindManyPowerMonitorPhaseBActiveEnergyFwdInput = {
  id?: InputMaybe<Scalars['String']>;
  observedAt?: InputMaybe<Scalars['Float']>;
  previousId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  units?: InputMaybe<Scalars['String']>;
  updatePending?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<Scalars['Float']>;
};

export type FilterFindManyPowerMonitorPhaseBActiveEnergyRevInput = {
  id?: InputMaybe<Scalars['String']>;
  observedAt?: InputMaybe<Scalars['Float']>;
  previousId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  units?: InputMaybe<Scalars['String']>;
  updatePending?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<Scalars['Float']>;
};

export type FilterFindManyPowerMonitorPhaseBActivePowerInput = {
  id?: InputMaybe<Scalars['String']>;
  observedAt?: InputMaybe<Scalars['Float']>;
  previousId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  units?: InputMaybe<Scalars['String']>;
  updatePending?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<Scalars['Float']>;
};

export type FilterFindManyPowerMonitorPhaseBCurrentInput = {
  id?: InputMaybe<Scalars['String']>;
  observedAt?: InputMaybe<Scalars['Float']>;
  previousId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  units?: InputMaybe<Scalars['String']>;
  updatePending?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<Scalars['Float']>;
};

export type FilterFindManyPowerMonitorPhaseBFrequencyInput = {
  id?: InputMaybe<Scalars['String']>;
  observedAt?: InputMaybe<Scalars['Float']>;
  previousId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  units?: InputMaybe<Scalars['String']>;
  updatePending?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<Scalars['Float']>;
};

export type FilterFindManyPowerMonitorPhaseBPowerFactorInput = {
  id?: InputMaybe<Scalars['String']>;
  observedAt?: InputMaybe<Scalars['Float']>;
  previousId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  units?: InputMaybe<Scalars['String']>;
  updatePending?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<Scalars['Float']>;
};

export type FilterFindManyPowerMonitorPhaseBVoltageInput = {
  id?: InputMaybe<Scalars['String']>;
  observedAt?: InputMaybe<Scalars['Float']>;
  previousId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  units?: InputMaybe<Scalars['String']>;
  updatePending?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<Scalars['Float']>;
};

export type FilterFindManyPowerMonitorPhaseCActiveEnergyFwdInput = {
  id?: InputMaybe<Scalars['String']>;
  observedAt?: InputMaybe<Scalars['Float']>;
  previousId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  units?: InputMaybe<Scalars['String']>;
  updatePending?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<Scalars['Float']>;
};

export type FilterFindManyPowerMonitorPhaseCActiveEnergyRevInput = {
  id?: InputMaybe<Scalars['String']>;
  observedAt?: InputMaybe<Scalars['Float']>;
  previousId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  units?: InputMaybe<Scalars['String']>;
  updatePending?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<Scalars['Float']>;
};

export type FilterFindManyPowerMonitorPhaseCActivePowerInput = {
  id?: InputMaybe<Scalars['String']>;
  observedAt?: InputMaybe<Scalars['Float']>;
  previousId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  units?: InputMaybe<Scalars['String']>;
  updatePending?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<Scalars['Float']>;
};

export type FilterFindManyPowerMonitorPhaseCCurrentInput = {
  id?: InputMaybe<Scalars['String']>;
  observedAt?: InputMaybe<Scalars['Float']>;
  previousId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  units?: InputMaybe<Scalars['String']>;
  updatePending?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<Scalars['Float']>;
};

export type FilterFindManyPowerMonitorPhaseCFrequencyInput = {
  id?: InputMaybe<Scalars['String']>;
  observedAt?: InputMaybe<Scalars['Float']>;
  previousId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  units?: InputMaybe<Scalars['String']>;
  updatePending?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<Scalars['Float']>;
};

export type FilterFindManyPowerMonitorPhaseCPowerFactorInput = {
  id?: InputMaybe<Scalars['String']>;
  observedAt?: InputMaybe<Scalars['Float']>;
  previousId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  units?: InputMaybe<Scalars['String']>;
  updatePending?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<Scalars['Float']>;
};

export type FilterFindManyPowerMonitorPhaseCVoltageInput = {
  id?: InputMaybe<Scalars['String']>;
  observedAt?: InputMaybe<Scalars['Float']>;
  previousId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  units?: InputMaybe<Scalars['String']>;
  updatePending?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<Scalars['Float']>;
};

export type FilterFindManyPowerMonitorThreePhaseTotalActiveEnergyFwdInput = {
  id?: InputMaybe<Scalars['String']>;
  observedAt?: InputMaybe<Scalars['Float']>;
  previousId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  units?: InputMaybe<Scalars['String']>;
  updatePending?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<Scalars['Float']>;
};

export type FilterFindManyPowerMonitorThreePhaseTotalActiveEnergyRevInput = {
  id?: InputMaybe<Scalars['String']>;
  observedAt?: InputMaybe<Scalars['Float']>;
  previousId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  units?: InputMaybe<Scalars['String']>;
  updatePending?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<Scalars['Float']>;
};

export type FilterFindManyPowerMonitorTotalActivePowerInput = {
  id?: InputMaybe<Scalars['String']>;
  observedAt?: InputMaybe<Scalars['Float']>;
  previousId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  units?: InputMaybe<Scalars['String']>;
  updatePending?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<Scalars['Float']>;
};

export type FilterFindManyPowerMonitorTotalPowerFactorInput = {
  id?: InputMaybe<Scalars['String']>;
  observedAt?: InputMaybe<Scalars['Float']>;
  previousId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  units?: InputMaybe<Scalars['String']>;
  updatePending?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<Scalars['Float']>;
};

export type FilterFindManyPressureSensorInput = {
  AND?: InputMaybe<Array<FilterFindManyDeviceInput>>;
  OR?: InputMaybe<Array<FilterFindManyDeviceInput>>;
  _id?: InputMaybe<Scalars['String']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterFindManyDeviceOperatorsInput>;
  alertTypes?: InputMaybe<FilterFindManyDeviceAlertTypesInput>;
  controlled?: InputMaybe<FilterFindManyDeviceControlledInput>;
  deviceId?: InputMaybe<Scalars['String']>;
  installation?: InputMaybe<FilterFindManyDeviceInstallationInput>;
  location?: InputMaybe<Scalars['String']>;
  meta?: InputMaybe<FilterFindManyDeviceMetaInput>;
  /** The name of the device */
  name?: InputMaybe<Scalars['String']>;
  panelId?: InputMaybe<Scalars['String']>;
  powerState?: InputMaybe<FilterFindManyDevicePowerStateInput>;
  pressure?: InputMaybe<FilterFindManyPressureSensorPressureInput>;
  propertyId?: InputMaybe<Scalars['String']>;
  role?: InputMaybe<Scalars['String']>;
  sourceId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  unitId?: InputMaybe<Scalars['String']>;
  updateStatus?: InputMaybe<Scalars['Boolean']>;
  vppId?: InputMaybe<Scalars['String']>;
  zoneId?: InputMaybe<Scalars['String']>;
};

export type FilterFindManyPressureSensorPressureInput = {
  id?: InputMaybe<Scalars['String']>;
  observedAt?: InputMaybe<Scalars['Float']>;
  previousId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  units?: InputMaybe<Scalars['String']>;
  updatePending?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<Scalars['Float']>;
};

export type FilterFindManyPropertyAddressInput = {
  city?: InputMaybe<Scalars['String']>;
  line1?: InputMaybe<Scalars['String']>;
  line2?: InputMaybe<Scalars['String']>;
  postalCode?: InputMaybe<Scalars['String']>;
  state?: InputMaybe<Scalars['String']>;
};

export type FilterFindManyPropertyAlertLimitsInput = {
  plant?: InputMaybe<FilterFindManyPropertyAlertLimitsPlantInput>;
  units?: InputMaybe<FilterFindManyPropertyAlertLimitsUnitsInput>;
};

export type FilterFindManyPropertyAlertLimitsPlantDhwInput = {
  temperature?: InputMaybe<FilterFindManyPropertyAlertLimitsPlantDhwTemperatureInput>;
};

export type FilterFindManyPropertyAlertLimitsPlantDhwTemperatureInput = {
  max?: InputMaybe<Scalars['Float']>;
  min?: InputMaybe<Scalars['Float']>;
};

export type FilterFindManyPropertyAlertLimitsPlantInput = {
  dhw?: InputMaybe<FilterFindManyPropertyAlertLimitsPlantDhwInput>;
  loops?: InputMaybe<FilterFindManyPropertyAlertLimitsPlantLoopsInput>;
};

export type FilterFindManyPropertyAlertLimitsPlantLoopsInput = {
  pressure?: InputMaybe<FilterFindManyPropertyAlertLimitsPlantLoopsPressureInput>;
  temperature?: InputMaybe<FilterFindManyPropertyAlertLimitsPlantLoopsTemperatureInput>;
};

export type FilterFindManyPropertyAlertLimitsPlantLoopsPressureInput = {
  max?: InputMaybe<Scalars['Float']>;
  min?: InputMaybe<Scalars['Float']>;
};

export type FilterFindManyPropertyAlertLimitsPlantLoopsTemperatureInput = {
  max?: InputMaybe<Scalars['Float']>;
  min?: InputMaybe<Scalars['Float']>;
};

export type FilterFindManyPropertyAlertLimitsUnitsHumidityInput = {
  max?: InputMaybe<Scalars['Float']>;
  min?: InputMaybe<Scalars['Float']>;
};

export type FilterFindManyPropertyAlertLimitsUnitsInput = {
  humidity?: InputMaybe<FilterFindManyPropertyAlertLimitsUnitsHumidityInput>;
  temperature?: InputMaybe<FilterFindManyPropertyAlertLimitsUnitsTemperatureInput>;
};

export type FilterFindManyPropertyAlertLimitsUnitsTemperatureInput = {
  max?: InputMaybe<Scalars['Float']>;
  min?: InputMaybe<Scalars['Float']>;
};

export type FilterFindManyPropertyAlertTypesInput = {
  deviceAlert?: InputMaybe<Scalars['Boolean']>;
  deviceMetric?: InputMaybe<Scalars['Boolean']>;
  deviceOffline?: InputMaybe<Scalars['Boolean']>;
  equipmentAlarm?: InputMaybe<Scalars['Boolean']>;
  sourceOffline?: InputMaybe<Scalars['Boolean']>;
};

export type FilterFindManyPropertyContactInput = {
  email?: InputMaybe<Scalars['String']>;
  email2?: InputMaybe<Scalars['String']>;
  email3?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  smsNumber?: InputMaybe<Scalars['String']>;
  smsNumber2?: InputMaybe<Scalars['String']>;
  smsNumber3?: InputMaybe<Scalars['String']>;
  smsOptInStatus1?: InputMaybe<EnumPropertyContactSmsOptInStatus1>;
  smsOptInStatus2?: InputMaybe<EnumPropertyContactSmsOptInStatus2>;
  smsOptInStatus3?: InputMaybe<EnumPropertyContactSmsOptInStatus3>;
  smsOptInTimestamp1?: InputMaybe<Scalars['Float']>;
  smsOptInTimestamp2?: InputMaybe<Scalars['Float']>;
  smsOptInTimestamp3?: InputMaybe<Scalars['Float']>;
};

export type FilterFindManyPropertyInput = {
  AND?: InputMaybe<Array<FilterFindManyPropertyInput>>;
  OR?: InputMaybe<Array<FilterFindManyPropertyInput>>;
  _id?: InputMaybe<Scalars['String']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterFindManyPropertyOperatorsInput>;
  address?: InputMaybe<FilterFindManyPropertyAddressInput>;
  alertLimits?: InputMaybe<FilterFindManyPropertyAlertLimitsInput>;
  alertTypes?: InputMaybe<FilterFindManyPropertyAlertTypesInput>;
  contact?: InputMaybe<FilterFindManyPropertyContactInput>;
  floorLabel?: InputMaybe<Scalars['String']>;
  hasSecondaryHeatSource?: InputMaybe<Scalars['Boolean']>;
  imageUrl?: InputMaybe<Scalars['String']>;
  maintMgr?: InputMaybe<FilterFindManyPropertyMaintMgrInput>;
  organizationId?: InputMaybe<Scalars['String']>;
  owner?: InputMaybe<FilterFindManyPropertyOwnerInput>;
  propMgr?: InputMaybe<FilterFindManyPropertyPropMgrInput>;
  setpointProfileId?: InputMaybe<Scalars['String']>;
  tempDisplayUnits?: InputMaybe<Scalars['String']>;
  thermostatScheduleTemplateId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['String']>;
  title?: InputMaybe<Scalars['String']>;
  unitsSummary?: InputMaybe<FilterFindManyPropertyUnitsSummaryInput>;
  /** Constructs a regular expression search based on the string provided */
  withTitleLike?: InputMaybe<Scalars['String']>;
  zonePolicyId?: InputMaybe<Scalars['String']>;
};

export type FilterFindManyPropertyMaintMgrInput = {
  email?: InputMaybe<Scalars['String']>;
  mobile?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterFindManyPropertyOperatorsInput = {
  _id?: InputMaybe<FilterFindManyProperty_IdOperatorsInput>;
  title?: InputMaybe<FilterFindManyPropertyTitleOperatorsInput>;
  unitsSummary?: InputMaybe<FilterFindManyPropertyUnitsSummaryOperatorsInput>;
};

export type FilterFindManyPropertyOwnerInput = {
  email?: InputMaybe<Scalars['String']>;
  mobile?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  phone?: InputMaybe<Scalars['String']>;
};

export type FilterFindManyPropertyPropMgrInput = {
  email?: InputMaybe<Scalars['String']>;
  mobile?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  phone?: InputMaybe<Scalars['String']>;
};

export type FilterFindManyPropertyTitleOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['String']>;
  gte?: InputMaybe<Scalars['String']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  lt?: InputMaybe<Scalars['String']>;
  lte?: InputMaybe<Scalars['String']>;
  ne?: InputMaybe<Scalars['String']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']>;
};

export type FilterFindManyPropertyUnitsSummaryCountOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['Float']>;
  gte?: InputMaybe<Scalars['Float']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Float']>>>;
  lt?: InputMaybe<Scalars['Float']>;
  lte?: InputMaybe<Scalars['Float']>;
  ne?: InputMaybe<Scalars['Float']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Float']>>>;
};

export type FilterFindManyPropertyUnitsSummaryInput = {
  count?: InputMaybe<Scalars['Float']>;
  majorAlerts?: InputMaybe<Scalars['Float']>;
  minorAlerts?: InputMaybe<Scalars['Float']>;
};

export type FilterFindManyPropertyUnitsSummaryMajorAlertsOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['Float']>;
  gte?: InputMaybe<Scalars['Float']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Float']>>>;
  lt?: InputMaybe<Scalars['Float']>;
  lte?: InputMaybe<Scalars['Float']>;
  ne?: InputMaybe<Scalars['Float']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Float']>>>;
};

export type FilterFindManyPropertyUnitsSummaryOperatorsInput = {
  count?: InputMaybe<FilterFindManyPropertyUnitsSummaryCountOperatorsInput>;
  majorAlerts?: InputMaybe<FilterFindManyPropertyUnitsSummaryMajorAlertsOperatorsInput>;
};

export type FilterFindManyProperty_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['String']>;
  gte?: InputMaybe<Scalars['String']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  lt?: InputMaybe<Scalars['String']>;
  lte?: InputMaybe<Scalars['String']>;
  ne?: InputMaybe<Scalars['String']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']>;
};

export type FilterFindManyRelayDeviceInput = {
  AND?: InputMaybe<Array<FilterFindManyDeviceInput>>;
  OR?: InputMaybe<Array<FilterFindManyDeviceInput>>;
  _id?: InputMaybe<Scalars['String']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterFindManyDeviceOperatorsInput>;
  alertTypes?: InputMaybe<FilterFindManyDeviceAlertTypesInput>;
  controlled?: InputMaybe<FilterFindManyDeviceControlledInput>;
  deviceId?: InputMaybe<Scalars['String']>;
  installation?: InputMaybe<FilterFindManyDeviceInstallationInput>;
  isOn?: InputMaybe<FilterFindManyRelayDeviceIsOnInput>;
  location?: InputMaybe<Scalars['String']>;
  meta?: InputMaybe<FilterFindManyDeviceMetaInput>;
  /** The name of the device */
  name?: InputMaybe<Scalars['String']>;
  panelId?: InputMaybe<Scalars['String']>;
  powerState?: InputMaybe<FilterFindManyDevicePowerStateInput>;
  propertyId?: InputMaybe<Scalars['String']>;
  sourceId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  unitId?: InputMaybe<Scalars['String']>;
  updateStatus?: InputMaybe<Scalars['Boolean']>;
  vppId?: InputMaybe<Scalars['String']>;
  zoneId?: InputMaybe<Scalars['String']>;
};

export type FilterFindManyRelayDeviceIsOnInput = {
  id?: InputMaybe<Scalars['String']>;
  observedAt?: InputMaybe<Scalars['Float']>;
  previousId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  units?: InputMaybe<Scalars['String']>;
  updatePending?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<Scalars['Boolean']>;
};

export type FilterFindManyScheduledTaskInput = {
  AND?: InputMaybe<Array<FilterFindManyScheduledTaskInput>>;
  OR?: InputMaybe<Array<FilterFindManyScheduledTaskInput>>;
  _id?: InputMaybe<Scalars['String']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterFindManyScheduledTaskOperatorsInput>;
  completedAt?: InputMaybe<Scalars['Float']>;
  createdAt?: InputMaybe<Scalars['Float']>;
  errorMessage?: InputMaybe<Scalars['String']>;
  executionTimeMs?: InputMaybe<Scalars['Float']>;
  instanceId?: InputMaybe<Scalars['String']>;
  maxRetries?: InputMaybe<Scalars['Float']>;
  methodName?: InputMaybe<Scalars['String']>;
  modelName?: InputMaybe<Scalars['String']>;
  priority?: InputMaybe<Scalars['Float']>;
  retryCount?: InputMaybe<Scalars['Float']>;
  scheduledAt?: InputMaybe<Scalars['Float']>;
  startedAt?: InputMaybe<Scalars['Float']>;
  status?: InputMaybe<EnumScheduledTaskStatus>;
  updatedAt?: InputMaybe<Scalars['Float']>;
};

export type FilterFindManyScheduledTaskModelNameOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['String']>;
  gte?: InputMaybe<Scalars['String']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  lt?: InputMaybe<Scalars['String']>;
  lte?: InputMaybe<Scalars['String']>;
  ne?: InputMaybe<Scalars['String']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterFindManyScheduledTaskOperatorsInput = {
  _id?: InputMaybe<FilterFindManyScheduledTask_IdOperatorsInput>;
  modelName?: InputMaybe<FilterFindManyScheduledTaskModelNameOperatorsInput>;
  priority?: InputMaybe<FilterFindManyScheduledTaskPriorityOperatorsInput>;
  scheduledAt?: InputMaybe<FilterFindManyScheduledTaskScheduledAtOperatorsInput>;
  status?: InputMaybe<FilterFindManyScheduledTaskStatusOperatorsInput>;
};

export type FilterFindManyScheduledTaskPriorityOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['Float']>;
  gte?: InputMaybe<Scalars['Float']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Float']>>>;
  lt?: InputMaybe<Scalars['Float']>;
  lte?: InputMaybe<Scalars['Float']>;
  ne?: InputMaybe<Scalars['Float']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Float']>>>;
};

export type FilterFindManyScheduledTaskScheduledAtOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['Float']>;
  gte?: InputMaybe<Scalars['Float']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Float']>>>;
  lt?: InputMaybe<Scalars['Float']>;
  lte?: InputMaybe<Scalars['Float']>;
  ne?: InputMaybe<Scalars['Float']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Float']>>>;
};

export type FilterFindManyScheduledTaskStatusOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<EnumScheduledTaskStatus>;
  gte?: InputMaybe<EnumScheduledTaskStatus>;
  in?: InputMaybe<Array<InputMaybe<EnumScheduledTaskStatus>>>;
  lt?: InputMaybe<EnumScheduledTaskStatus>;
  lte?: InputMaybe<EnumScheduledTaskStatus>;
  ne?: InputMaybe<EnumScheduledTaskStatus>;
  nin?: InputMaybe<Array<InputMaybe<EnumScheduledTaskStatus>>>;
};

export type FilterFindManyScheduledTask_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['String']>;
  gte?: InputMaybe<Scalars['String']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  lt?: InputMaybe<Scalars['String']>;
  lte?: InputMaybe<Scalars['String']>;
  ne?: InputMaybe<Scalars['String']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']>;
};

export type FilterFindManySetpointProfileCoolInput = {
  max?: InputMaybe<Scalars['Float']>;
  min?: InputMaybe<Scalars['Float']>;
};

export type FilterFindManySetpointProfileHeatInput = {
  max?: InputMaybe<Scalars['Float']>;
  min?: InputMaybe<Scalars['Float']>;
};

export type FilterFindManySetpointProfileInput = {
  AND?: InputMaybe<Array<FilterFindManySetpointProfileInput>>;
  OR?: InputMaybe<Array<FilterFindManySetpointProfileInput>>;
  _id?: InputMaybe<Scalars['String']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterFindManySetpointProfileOperatorsInput>;
  cool?: InputMaybe<FilterFindManySetpointProfileCoolInput>;
  createdAt?: InputMaybe<Scalars['Float']>;
  createdBy?: InputMaybe<Scalars['String']>;
  heat?: InputMaybe<FilterFindManySetpointProfileHeatInput>;
  name?: InputMaybe<Scalars['String']>;
  propagated?: InputMaybe<Scalars['Boolean']>;
  properties?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  type?: InputMaybe<EnumSetpointProfileType>;
  units?: InputMaybe<EnumSetpointProfileUnits>;
  updatedAt?: InputMaybe<Scalars['Float']>;
  updatedBy?: InputMaybe<Scalars['String']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterFindManySetpointProfileOperatorsInput = {
  _id?: InputMaybe<FilterFindManySetpointProfile_IdOperatorsInput>;
  properties?: InputMaybe<FilterFindManySetpointProfilePropertiesOperatorsInput>;
};

export type FilterFindManySetpointProfilePropertiesOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['String']>;
  gte?: InputMaybe<Scalars['String']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  lt?: InputMaybe<Scalars['String']>;
  lte?: InputMaybe<Scalars['String']>;
  ne?: InputMaybe<Scalars['String']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']>;
};

export type FilterFindManySetpointProfile_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['String']>;
  gte?: InputMaybe<Scalars['String']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  lt?: InputMaybe<Scalars['String']>;
  lte?: InputMaybe<Scalars['String']>;
  ne?: InputMaybe<Scalars['String']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']>;
};

export type FilterFindManySmartPowerOutletActivePowerInput = {
  id?: InputMaybe<Scalars['String']>;
  observedAt?: InputMaybe<Scalars['Float']>;
  previousId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  units?: InputMaybe<Scalars['String']>;
  updatePending?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<Scalars['Float']>;
};

export type FilterFindManySmartPowerOutletApparentPowerInput = {
  id?: InputMaybe<Scalars['String']>;
  observedAt?: InputMaybe<Scalars['Float']>;
  previousId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  units?: InputMaybe<Scalars['String']>;
  updatePending?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<Scalars['Float']>;
};

export type FilterFindManySmartPowerOutletCumulativePowerInput = {
  id?: InputMaybe<Scalars['String']>;
  observedAt?: InputMaybe<Scalars['Float']>;
  previousId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  units?: InputMaybe<Scalars['String']>;
  updatePending?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<Scalars['Float']>;
};

export type FilterFindManySmartPowerOutletInput = {
  AND?: InputMaybe<Array<FilterFindManyDeviceInput>>;
  OR?: InputMaybe<Array<FilterFindManyDeviceInput>>;
  _id?: InputMaybe<Scalars['String']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterFindManyDeviceOperatorsInput>;
  activePower?: InputMaybe<FilterFindManySmartPowerOutletActivePowerInput>;
  alertTypes?: InputMaybe<FilterFindManyDeviceAlertTypesInput>;
  apparentPower?: InputMaybe<FilterFindManySmartPowerOutletApparentPowerInput>;
  controlled?: InputMaybe<FilterFindManyDeviceControlledInput>;
  cumulativePower?: InputMaybe<FilterFindManySmartPowerOutletCumulativePowerInput>;
  cumulativePowerOffset?: InputMaybe<Scalars['Float']>;
  cumulativePowerResetTime?: InputMaybe<Scalars['Float']>;
  deviceId?: InputMaybe<Scalars['String']>;
  installation?: InputMaybe<FilterFindManyDeviceInstallationInput>;
  isOn?: InputMaybe<FilterFindManySmartPowerOutletIsOnInput>;
  location?: InputMaybe<Scalars['String']>;
  meta?: InputMaybe<FilterFindManyDeviceMetaInput>;
  /** The name of the device */
  name?: InputMaybe<Scalars['String']>;
  panelId?: InputMaybe<Scalars['String']>;
  powerFactor?: InputMaybe<FilterFindManySmartPowerOutletPowerFactorInput>;
  powerState?: InputMaybe<FilterFindManyDevicePowerStateInput>;
  propertyId?: InputMaybe<Scalars['String']>;
  rmsCurrent?: InputMaybe<FilterFindManySmartPowerOutletRmsCurrentInput>;
  rmsVoltage?: InputMaybe<FilterFindManySmartPowerOutletRmsVoltageInput>;
  sourceId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  unitId?: InputMaybe<Scalars['String']>;
  updateStatus?: InputMaybe<Scalars['Boolean']>;
  vppId?: InputMaybe<Scalars['String']>;
  zoneId?: InputMaybe<Scalars['String']>;
};

export type FilterFindManySmartPowerOutletIsOnInput = {
  id?: InputMaybe<Scalars['String']>;
  observedAt?: InputMaybe<Scalars['Float']>;
  previousId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  units?: InputMaybe<Scalars['String']>;
  updatePending?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<Scalars['Boolean']>;
};

export type FilterFindManySmartPowerOutletPowerFactorInput = {
  id?: InputMaybe<Scalars['String']>;
  observedAt?: InputMaybe<Scalars['Float']>;
  previousId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  units?: InputMaybe<Scalars['String']>;
  updatePending?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<Scalars['Float']>;
};

export type FilterFindManySmartPowerOutletRmsCurrentInput = {
  id?: InputMaybe<Scalars['String']>;
  observedAt?: InputMaybe<Scalars['Float']>;
  previousId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  units?: InputMaybe<Scalars['String']>;
  updatePending?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<Scalars['Float']>;
};

export type FilterFindManySmartPowerOutletRmsVoltageInput = {
  id?: InputMaybe<Scalars['String']>;
  observedAt?: InputMaybe<Scalars['Float']>;
  previousId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  units?: InputMaybe<Scalars['String']>;
  updatePending?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<Scalars['Float']>;
};

export type FilterFindManySolarManagementSystemAzimuthInput = {
  id?: InputMaybe<Scalars['String']>;
  observedAt?: InputMaybe<Scalars['Float']>;
  previousId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  units?: InputMaybe<Scalars['String']>;
  updatePending?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<Scalars['Float']>;
};

export type FilterFindManySolarManagementSystemDegradationRateInput = {
  id?: InputMaybe<Scalars['String']>;
  observedAt?: InputMaybe<Scalars['Float']>;
  previousId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  units?: InputMaybe<Scalars['String']>;
  updatePending?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<Scalars['Float']>;
};

export type FilterFindManySolarManagementSystemInput = {
  AND?: InputMaybe<Array<FilterFindManyDeviceInput>>;
  OR?: InputMaybe<Array<FilterFindManyDeviceInput>>;
  _id?: InputMaybe<Scalars['String']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterFindManyDeviceOperatorsInput>;
  alertTypes?: InputMaybe<FilterFindManyDeviceAlertTypesInput>;
  azimuth?: InputMaybe<FilterFindManySolarManagementSystemAzimuthInput>;
  controlled?: InputMaybe<FilterFindManyDeviceControlledInput>;
  degradationRate?: InputMaybe<FilterFindManySolarManagementSystemDegradationRateInput>;
  deviceId?: InputMaybe<Scalars['String']>;
  installation?: InputMaybe<FilterFindManyDeviceInstallationInput>;
  isTrackerSystem?: InputMaybe<FilterFindManySolarManagementSystemIsTrackerSystemInput>;
  location?: InputMaybe<Scalars['String']>;
  meta?: InputMaybe<FilterFindManyDeviceMetaInput>;
  /** The name of the device */
  name?: InputMaybe<Scalars['String']>;
  panelCurrents?: InputMaybe<
    Array<InputMaybe<FilterFindManySolarManagementSystemPanelCurrentsInput>>
  >;
  panelId?: InputMaybe<Scalars['String']>;
  panelTemperature?: InputMaybe<FilterFindManySolarManagementSystemPanelTemperatureInput>;
  panelVoltages?: InputMaybe<
    Array<InputMaybe<FilterFindManySolarManagementSystemPanelVoltagesInput>>
  >;
  powerState?: InputMaybe<FilterFindManyDevicePowerStateInput>;
  propertyId?: InputMaybe<Scalars['String']>;
  shadingFactor?: InputMaybe<FilterFindManySolarManagementSystemShadingFactorInput>;
  solarIrradiance?: InputMaybe<FilterFindManySolarManagementSystemSolarIrradianceInput>;
  sourceId?: InputMaybe<Scalars['String']>;
  tiltAngle?: InputMaybe<FilterFindManySolarManagementSystemTiltAngleInput>;
  timestamp?: InputMaybe<Scalars['Float']>;
  unitId?: InputMaybe<Scalars['String']>;
  updateStatus?: InputMaybe<Scalars['Boolean']>;
  vppId?: InputMaybe<Scalars['String']>;
  zoneId?: InputMaybe<Scalars['String']>;
};

export type FilterFindManySolarManagementSystemIsTrackerSystemInput = {
  id?: InputMaybe<Scalars['String']>;
  observedAt?: InputMaybe<Scalars['Float']>;
  previousId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  units?: InputMaybe<Scalars['String']>;
  updatePending?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<Scalars['Boolean']>;
};

export type FilterFindManySolarManagementSystemPanelCurrentsInput = {
  id?: InputMaybe<Scalars['String']>;
  observedAt?: InputMaybe<Scalars['Float']>;
  previousId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  units?: InputMaybe<Scalars['String']>;
  updatePending?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<Scalars['Float']>;
};

export type FilterFindManySolarManagementSystemPanelTemperatureInput = {
  id?: InputMaybe<Scalars['String']>;
  observedAt?: InputMaybe<Scalars['Float']>;
  previousId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  units?: InputMaybe<Scalars['String']>;
  updatePending?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<Scalars['Float']>;
};

export type FilterFindManySolarManagementSystemPanelVoltagesInput = {
  id?: InputMaybe<Scalars['String']>;
  observedAt?: InputMaybe<Scalars['Float']>;
  previousId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  units?: InputMaybe<Scalars['String']>;
  updatePending?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<Scalars['Float']>;
};

export type FilterFindManySolarManagementSystemShadingFactorInput = {
  id?: InputMaybe<Scalars['String']>;
  observedAt?: InputMaybe<Scalars['Float']>;
  previousId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  units?: InputMaybe<Scalars['String']>;
  updatePending?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<Scalars['Float']>;
};

export type FilterFindManySolarManagementSystemSolarIrradianceInput = {
  id?: InputMaybe<Scalars['String']>;
  observedAt?: InputMaybe<Scalars['Float']>;
  previousId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  units?: InputMaybe<Scalars['String']>;
  updatePending?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<Scalars['Float']>;
};

export type FilterFindManySolarManagementSystemTiltAngleInput = {
  id?: InputMaybe<Scalars['String']>;
  observedAt?: InputMaybe<Scalars['Float']>;
  previousId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  units?: InputMaybe<Scalars['String']>;
  updatePending?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<Scalars['Float']>;
};

export type FilterFindManySourceInput = {
  AND?: InputMaybe<Array<FilterFindManySourceInput>>;
  OR?: InputMaybe<Array<FilterFindManySourceInput>>;
  _id?: InputMaybe<Scalars['String']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterFindManySourceOperatorsInput>;
  name?: InputMaybe<Scalars['String']>;
  propertyId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  type?: InputMaybe<EnumDKeySourceType>;
  url?: InputMaybe<Scalars['String']>;
};

export type FilterFindManySourceNameOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['String']>;
  gte?: InputMaybe<Scalars['String']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  lt?: InputMaybe<Scalars['String']>;
  lte?: InputMaybe<Scalars['String']>;
  ne?: InputMaybe<Scalars['String']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterFindManySourceOperatorsInput = {
  _id?: InputMaybe<FilterFindManySource_IdOperatorsInput>;
  name?: InputMaybe<FilterFindManySourceNameOperatorsInput>;
};

export type FilterFindManySource_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['String']>;
  gte?: InputMaybe<Scalars['String']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  lt?: InputMaybe<Scalars['String']>;
  lte?: InputMaybe<Scalars['String']>;
  ne?: InputMaybe<Scalars['String']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']>;
};

export type FilterFindManySystemNotificationCreatedAtOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['Float']>;
  gte?: InputMaybe<Scalars['Float']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Float']>>>;
  lt?: InputMaybe<Scalars['Float']>;
  lte?: InputMaybe<Scalars['Float']>;
  ne?: InputMaybe<Scalars['Float']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Float']>>>;
};

export type FilterFindManySystemNotificationDisplayEndOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['Float']>;
  gte?: InputMaybe<Scalars['Float']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Float']>>>;
  lt?: InputMaybe<Scalars['Float']>;
  lte?: InputMaybe<Scalars['Float']>;
  ne?: InputMaybe<Scalars['Float']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Float']>>>;
};

export type FilterFindManySystemNotificationDisplayStartOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['Float']>;
  gte?: InputMaybe<Scalars['Float']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Float']>>>;
  lt?: InputMaybe<Scalars['Float']>;
  lte?: InputMaybe<Scalars['Float']>;
  ne?: InputMaybe<Scalars['Float']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Float']>>>;
};

export type FilterFindManySystemNotificationEntityIdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['String']>;
  gte?: InputMaybe<Scalars['String']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  lt?: InputMaybe<Scalars['String']>;
  lte?: InputMaybe<Scalars['String']>;
  ne?: InputMaybe<Scalars['String']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']>;
};

export type FilterFindManySystemNotificationEntityTypeOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<EnumSystemNotificationEntityType>;
  gte?: InputMaybe<EnumSystemNotificationEntityType>;
  in?: InputMaybe<Array<InputMaybe<EnumSystemNotificationEntityType>>>;
  lt?: InputMaybe<EnumSystemNotificationEntityType>;
  lte?: InputMaybe<EnumSystemNotificationEntityType>;
  ne?: InputMaybe<EnumSystemNotificationEntityType>;
  nin?: InputMaybe<Array<InputMaybe<EnumSystemNotificationEntityType>>>;
};

export type FilterFindManySystemNotificationInput = {
  AND?: InputMaybe<Array<FilterFindManySystemNotificationInput>>;
  OR?: InputMaybe<Array<FilterFindManySystemNotificationInput>>;
  _id?: InputMaybe<Scalars['String']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterFindManySystemNotificationOperatorsInput>;
  acknowledgedAt?: InputMaybe<Scalars['Float']>;
  createdAt?: InputMaybe<Scalars['Float']>;
  displayDuration?: InputMaybe<Scalars['Float']>;
  displayEnd?: InputMaybe<Scalars['Float']>;
  displayStart?: InputMaybe<Scalars['Float']>;
  entityId?: InputMaybe<Scalars['String']>;
  entityType?: InputMaybe<EnumSystemNotificationEntityType>;
  link?: InputMaybe<Scalars['String']>;
  message?: InputMaybe<Scalars['String']>;
  requireAcknowledgement?: InputMaybe<Scalars['Boolean']>;
  seenAt?: InputMaybe<Scalars['Float']>;
  seenBy?: InputMaybe<
    Array<InputMaybe<FilterFindManySystemNotificationSeenByInput>>
  >;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterFindManySystemNotificationOperatorsInput = {
  _id?: InputMaybe<FilterFindManySystemNotification_IdOperatorsInput>;
  createdAt?: InputMaybe<FilterFindManySystemNotificationCreatedAtOperatorsInput>;
  displayEnd?: InputMaybe<FilterFindManySystemNotificationDisplayEndOperatorsInput>;
  displayStart?: InputMaybe<FilterFindManySystemNotificationDisplayStartOperatorsInput>;
  entityId?: InputMaybe<FilterFindManySystemNotificationEntityIdOperatorsInput>;
  entityType?: InputMaybe<FilterFindManySystemNotificationEntityTypeOperatorsInput>;
  seenBy?: InputMaybe<FilterFindManySystemNotificationSeenByOperatorsInput>;
};

export type FilterFindManySystemNotificationSeenByInput = {
  _id?: InputMaybe<Scalars['MongoID']>;
  seenAt?: InputMaybe<Scalars['Float']>;
  userId?: InputMaybe<Scalars['String']>;
};

export type FilterFindManySystemNotificationSeenByOperatorsInput = {
  userId?: InputMaybe<FilterFindManySystemNotificationSeenByUserIdOperatorsInput>;
};

export type FilterFindManySystemNotificationSeenByUserIdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['String']>;
  gte?: InputMaybe<Scalars['String']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  lt?: InputMaybe<Scalars['String']>;
  lte?: InputMaybe<Scalars['String']>;
  ne?: InputMaybe<Scalars['String']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']>;
};

export type FilterFindManySystemNotification_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['String']>;
  gte?: InputMaybe<Scalars['String']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  lt?: InputMaybe<Scalars['String']>;
  lte?: InputMaybe<Scalars['String']>;
  ne?: InputMaybe<Scalars['String']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']>;
};

export type FilterFindManyThermistorInput = {
  AND?: InputMaybe<Array<FilterFindManyDeviceInput>>;
  OR?: InputMaybe<Array<FilterFindManyDeviceInput>>;
  _id?: InputMaybe<Scalars['String']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterFindManyDeviceOperatorsInput>;
  alertTypes?: InputMaybe<FilterFindManyDeviceAlertTypesInput>;
  controlled?: InputMaybe<FilterFindManyDeviceControlledInput>;
  deviceId?: InputMaybe<Scalars['String']>;
  installation?: InputMaybe<FilterFindManyDeviceInstallationInput>;
  location?: InputMaybe<Scalars['String']>;
  meta?: InputMaybe<FilterFindManyDeviceMetaInput>;
  /** The name of the device */
  name?: InputMaybe<Scalars['String']>;
  panelId?: InputMaybe<Scalars['String']>;
  powerState?: InputMaybe<FilterFindManyDevicePowerStateInput>;
  propertyId?: InputMaybe<Scalars['String']>;
  role?: InputMaybe<Scalars['String']>;
  sourceId?: InputMaybe<Scalars['String']>;
  temperature?: InputMaybe<FilterFindManyThermistorTemperatureInput>;
  timestamp?: InputMaybe<Scalars['Float']>;
  unitId?: InputMaybe<Scalars['String']>;
  updateStatus?: InputMaybe<Scalars['Boolean']>;
  vppId?: InputMaybe<Scalars['String']>;
  zoneId?: InputMaybe<Scalars['String']>;
};

export type FilterFindManyThermistorTemperatureInput = {
  id?: InputMaybe<Scalars['String']>;
  observedAt?: InputMaybe<Scalars['Float']>;
  previousId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  units?: InputMaybe<Scalars['String']>;
  updatePending?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<Scalars['Float']>;
};

export type FilterFindManyThermostatAirDirectionInput = {
  id?: InputMaybe<Scalars['String']>;
  observedAt?: InputMaybe<Scalars['Float']>;
  previousId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  units?: InputMaybe<Scalars['String']>;
  updatePending?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<Scalars['String']>;
};

export type FilterFindManyThermostatCoolSetpointInput = {
  id?: InputMaybe<Scalars['String']>;
  observedAt?: InputMaybe<Scalars['Float']>;
  previousId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  units?: InputMaybe<Scalars['String']>;
  updatePending?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<Scalars['Float']>;
};

export type FilterFindManyThermostatDeviceSpecInput = {
  thermostat?: InputMaybe<FilterFindManyThermostatDeviceSpecThermostatInput>;
  version?: InputMaybe<Scalars['String']>;
};

export type FilterFindManyThermostatDeviceSpecThermostatInput = {
  controlContract?: InputMaybe<EnumThermostatDeviceSpecThermostatControlContract>;
  keypadLockoutLevels?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  modbusRTU?: InputMaybe<Scalars['Boolean']>;
  numberOfDailyTransitions?: InputMaybe<Scalars['Float']>;
  numberOfWeeklyTransitions?: InputMaybe<Scalars['Float']>;
  secondaryHeatSource?: InputMaybe<FilterFindManyThermostatDeviceSpecThermostatSecondaryHeatSourceInput>;
  setpointLimits?: InputMaybe<FilterFindManyThermostatDeviceSpecThermostatSetpointLimitsInput>;
  supportedAutoModeType?: InputMaybe<EnumThermostatDeviceSpecThermostatSupportedAutoModeType>;
  units?: InputMaybe<Scalars['String']>;
};

export type FilterFindManyThermostatDeviceSpecThermostatSecondaryHeatSourceInput =
  {
    alternateHeat?: InputMaybe<Scalars['Boolean']>;
    auxiliaryHeat?: InputMaybe<Scalars['Boolean']>;
  };

export type FilterFindManyThermostatDeviceSpecThermostatSetpointLimitsCoolInput =
  {
    max?: InputMaybe<Scalars['Float']>;
    min?: InputMaybe<Scalars['Float']>;
  };

export type FilterFindManyThermostatDeviceSpecThermostatSetpointLimitsInput = {
  cool?: InputMaybe<FilterFindManyThermostatDeviceSpecThermostatSetpointLimitsCoolInput>;
  heat?: InputMaybe<FilterFindManyThermostatDeviceSpecThermostatSetpointLimitsCoolInput>;
};

export type FilterFindManyThermostatFanModeInput = {
  id?: InputMaybe<Scalars['String']>;
  observedAt?: InputMaybe<Scalars['Float']>;
  previousId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  units?: InputMaybe<Scalars['String']>;
  updatePending?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<EnumThermostatFanModeValue>;
};

export type FilterFindManyThermostatFanSpeedInput = {
  id?: InputMaybe<Scalars['String']>;
  observedAt?: InputMaybe<Scalars['Float']>;
  previousId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  units?: InputMaybe<Scalars['String']>;
  updatePending?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<EnumThermostatFanSpeedValue>;
};

export type FilterFindManyThermostatFanStateInput = {
  id?: InputMaybe<Scalars['String']>;
  observedAt?: InputMaybe<Scalars['Float']>;
  previousId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  units?: InputMaybe<Scalars['String']>;
  updatePending?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<EnumThermostatFanStateValue>;
};

export type FilterFindManyThermostatHeatSetpointInput = {
  id?: InputMaybe<Scalars['String']>;
  observedAt?: InputMaybe<Scalars['Float']>;
  previousId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  units?: InputMaybe<Scalars['String']>;
  updatePending?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<Scalars['Float']>;
};

export type FilterFindManyThermostatHoldDurationInput = {
  id?: InputMaybe<Scalars['String']>;
  observedAt?: InputMaybe<Scalars['Float']>;
  previousId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  units?: InputMaybe<Scalars['String']>;
  updatePending?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<Scalars['Float']>;
};

export type FilterFindManyThermostatHoldEndInput = {
  id?: InputMaybe<Scalars['String']>;
  observedAt?: InputMaybe<Scalars['Float']>;
  previousId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  units?: InputMaybe<Scalars['String']>;
  updatePending?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<Scalars['Float']>;
};

export type FilterFindManyThermostatHoldExpiryTimeInput = {
  id?: InputMaybe<Scalars['String']>;
  observedAt?: InputMaybe<Scalars['Float']>;
  previousId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  units?: InputMaybe<Scalars['String']>;
  updatePending?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<Scalars['Float']>;
};

export type FilterFindManyThermostatHoldStateInput = {
  id?: InputMaybe<Scalars['String']>;
  observedAt?: InputMaybe<Scalars['Float']>;
  previousId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  units?: InputMaybe<Scalars['String']>;
  updatePending?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<EnumThermostatHoldStateValue>;
};

export type FilterFindManyThermostatHumidityInput = {
  id?: InputMaybe<Scalars['String']>;
  observedAt?: InputMaybe<Scalars['Float']>;
  previousId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  units?: InputMaybe<Scalars['String']>;
  updatePending?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<Scalars['Float']>;
};

export type FilterFindManyThermostatInput = {
  AND?: InputMaybe<Array<FilterFindManyDeviceInput>>;
  OR?: InputMaybe<Array<FilterFindManyDeviceInput>>;
  _id?: InputMaybe<Scalars['String']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterFindManyDeviceOperatorsInput>;
  airDirection?: InputMaybe<FilterFindManyThermostatAirDirectionInput>;
  alertTypes?: InputMaybe<FilterFindManyDeviceAlertTypesInput>;
  controlled?: InputMaybe<FilterFindManyDeviceControlledInput>;
  coolSetpoint?: InputMaybe<FilterFindManyThermostatCoolSetpointInput>;
  deviceId?: InputMaybe<Scalars['String']>;
  deviceSpec?: InputMaybe<FilterFindManyThermostatDeviceSpecInput>;
  fanMode?: InputMaybe<FilterFindManyThermostatFanModeInput>;
  fanSpeed?: InputMaybe<FilterFindManyThermostatFanSpeedInput>;
  fanState?: InputMaybe<FilterFindManyThermostatFanStateInput>;
  heatSetpoint?: InputMaybe<FilterFindManyThermostatHeatSetpointInput>;
  holdDuration?: InputMaybe<FilterFindManyThermostatHoldDurationInput>;
  holdEnd?: InputMaybe<FilterFindManyThermostatHoldEndInput>;
  holdExpiryTime?: InputMaybe<FilterFindManyThermostatHoldExpiryTimeInput>;
  holdState?: InputMaybe<FilterFindManyThermostatHoldStateInput>;
  humidity?: InputMaybe<FilterFindManyThermostatHumidityInput>;
  installation?: InputMaybe<FilterFindManyDeviceInstallationInput>;
  keypadLockoutLevel?: InputMaybe<FilterFindManyThermostatKeypadLockoutLevelInput>;
  lastScheduleChange?: InputMaybe<FilterFindManyThermostatLastScheduleChangeInput>;
  lastSetpointChange?: InputMaybe<FilterFindManyThermostatLastSetpointChangeInput>;
  localControlPermissions?: InputMaybe<FilterFindManyThermostatLocalControlPermissionsInput>;
  location?: InputMaybe<Scalars['String']>;
  maxCoolSetpointLimit?: InputMaybe<FilterFindManyThermostatMaxCoolSetpointLimitInput>;
  maxHeatSetpointLimit?: InputMaybe<FilterFindManyThermostatMaxHeatSetpointLimitInput>;
  maxSetpoint?: InputMaybe<FilterFindManyThermostatMaxSetpointInput>;
  meta?: InputMaybe<FilterFindManyDeviceMetaInput>;
  minCoolSetpointLimit?: InputMaybe<FilterFindManyThermostatMinCoolSetpointLimitInput>;
  minHeatSetpointLimit?: InputMaybe<FilterFindManyThermostatMinHeatSetpointLimitInput>;
  minSetpoint?: InputMaybe<FilterFindManyThermostatMinSetpointInput>;
  /** The name of the device */
  name?: InputMaybe<Scalars['String']>;
  operatingMode?: InputMaybe<FilterFindManyThermostatOperatingModeInput>;
  operatingState?: InputMaybe<FilterFindManyThermostatOperatingStateInput>;
  pairingState?: InputMaybe<FilterFindManyThermostatPairingStateInput>;
  panelId?: InputMaybe<Scalars['String']>;
  passCode?: InputMaybe<FilterFindManyThermostatPassCodeInput>;
  pendingSchedule?: InputMaybe<FilterFindManyThermostatPendingScheduleInput>;
  powerMode?: InputMaybe<FilterFindManyThermostatPowerModeInput>;
  powerState?: InputMaybe<FilterFindManyDevicePowerStateInput>;
  progMode?: InputMaybe<FilterFindManyThermostatProgModeInput>;
  propertyId?: InputMaybe<Scalars['String']>;
  remoteSensorTempDelta?: InputMaybe<FilterFindManyThermostatRemoteSensorTempDeltaInput>;
  schedVisibilityMode?: InputMaybe<FilterFindManyThermostatSchedVisibilityModeInput>;
  schedule?: InputMaybe<FilterFindManyThermostatScheduleInput>;
  setpoint?: InputMaybe<FilterFindManyThermostatSetpointInput>;
  setpointChangeSource?: InputMaybe<FilterFindManyThermostatSetpointChangeSourceInput>;
  showFanButton?: InputMaybe<FilterFindManyThermostatShowFanButtonInput>;
  sourceId?: InputMaybe<Scalars['String']>;
  systemType?: InputMaybe<FilterFindManyThermostatSystemTypeInput>;
  tempDisplayMode?: InputMaybe<FilterFindManyThermostatTempDisplayModeInput>;
  temperature?: InputMaybe<FilterFindManyThermostatTemperatureInput>;
  thermostatControlCommand?: InputMaybe<FilterFindManyThermostatThermostatControlCommandInput>;
  thermostatScheduleTemplateId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  uiOptions?: InputMaybe<FilterFindManyThermostatUiOptionsInput>;
  unitId?: InputMaybe<Scalars['String']>;
  updateStatus?: InputMaybe<Scalars['Boolean']>;
  useCustomSchedule?: InputMaybe<Scalars['Boolean']>;
  useCustomSetpointLimits?: InputMaybe<Scalars['Boolean']>;
  vppId?: InputMaybe<Scalars['String']>;
  zoneId?: InputMaybe<Scalars['String']>;
};

export type FilterFindManyThermostatKeypadLockoutLevelInput = {
  id?: InputMaybe<Scalars['String']>;
  observedAt?: InputMaybe<Scalars['Float']>;
  previousId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  units?: InputMaybe<Scalars['String']>;
  updatePending?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<Scalars['String']>;
};

export type FilterFindManyThermostatLastScheduleChangeInput = {
  id?: InputMaybe<Scalars['String']>;
  observedAt?: InputMaybe<Scalars['Float']>;
  previousId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  units?: InputMaybe<Scalars['String']>;
  updatePending?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<Scalars['Float']>;
};

export type FilterFindManyThermostatLastSetpointChangeInput = {
  id?: InputMaybe<Scalars['String']>;
  observedAt?: InputMaybe<Scalars['Float']>;
  previousId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  units?: InputMaybe<Scalars['String']>;
  updatePending?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<Scalars['Float']>;
};

export type FilterFindManyThermostatLocalControlPermissionsInput = {
  id?: InputMaybe<Scalars['String']>;
  observedAt?: InputMaybe<Scalars['Float']>;
  previousId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  units?: InputMaybe<Scalars['String']>;
  updatePending?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<Scalars['JSON']>;
};

export type FilterFindManyThermostatMaxCoolSetpointLimitInput = {
  id?: InputMaybe<Scalars['String']>;
  observedAt?: InputMaybe<Scalars['Float']>;
  previousId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  units?: InputMaybe<Scalars['String']>;
  updatePending?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<Scalars['Float']>;
};

export type FilterFindManyThermostatMaxHeatSetpointLimitInput = {
  id?: InputMaybe<Scalars['String']>;
  observedAt?: InputMaybe<Scalars['Float']>;
  previousId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  units?: InputMaybe<Scalars['String']>;
  updatePending?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<Scalars['Float']>;
};

export type FilterFindManyThermostatMaxSetpointInput = {
  id?: InputMaybe<Scalars['String']>;
  observedAt?: InputMaybe<Scalars['Float']>;
  previousId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  units?: InputMaybe<Scalars['String']>;
  updatePending?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<Scalars['Float']>;
};

export type FilterFindManyThermostatMinCoolSetpointLimitInput = {
  id?: InputMaybe<Scalars['String']>;
  observedAt?: InputMaybe<Scalars['Float']>;
  previousId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  units?: InputMaybe<Scalars['String']>;
  updatePending?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<Scalars['Float']>;
};

export type FilterFindManyThermostatMinHeatSetpointLimitInput = {
  id?: InputMaybe<Scalars['String']>;
  observedAt?: InputMaybe<Scalars['Float']>;
  previousId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  units?: InputMaybe<Scalars['String']>;
  updatePending?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<Scalars['Float']>;
};

export type FilterFindManyThermostatMinSetpointInput = {
  id?: InputMaybe<Scalars['String']>;
  observedAt?: InputMaybe<Scalars['Float']>;
  previousId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  units?: InputMaybe<Scalars['String']>;
  updatePending?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<Scalars['Float']>;
};

export type FilterFindManyThermostatOperatingModeInput = {
  id?: InputMaybe<Scalars['String']>;
  observedAt?: InputMaybe<Scalars['Float']>;
  previousId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  units?: InputMaybe<Scalars['String']>;
  updatePending?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<EnumThermostatOperatingModeValue>;
};

export type FilterFindManyThermostatOperatingStateInput = {
  id?: InputMaybe<Scalars['String']>;
  observedAt?: InputMaybe<Scalars['Float']>;
  previousId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  units?: InputMaybe<Scalars['String']>;
  updatePending?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<EnumThermostatOperatingStateValue>;
};

export type FilterFindManyThermostatPairingStateInput = {
  id?: InputMaybe<Scalars['String']>;
  observedAt?: InputMaybe<Scalars['Float']>;
  previousId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  units?: InputMaybe<Scalars['String']>;
  updatePending?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<EnumThermostatPairingStateValue>;
};

export type FilterFindManyThermostatPassCodeInput = {
  id?: InputMaybe<Scalars['String']>;
  observedAt?: InputMaybe<Scalars['Float']>;
  previousId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  units?: InputMaybe<Scalars['String']>;
  updatePending?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<Scalars['Float']>;
};

export type FilterFindManyThermostatPendingScheduleInput = {
  id?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  units?: InputMaybe<Scalars['String']>;
  updatePending?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<Scalars['JSON']>;
};

export type FilterFindManyThermostatPowerModeInput = {
  id?: InputMaybe<Scalars['String']>;
  observedAt?: InputMaybe<Scalars['Float']>;
  previousId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  units?: InputMaybe<Scalars['String']>;
  updatePending?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<EnumThermostatPowerModeValue>;
};

export type FilterFindManyThermostatProgModeInput = {
  id?: InputMaybe<Scalars['String']>;
  observedAt?: InputMaybe<Scalars['Float']>;
  previousId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  units?: InputMaybe<Scalars['String']>;
  updatePending?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<EnumThermostatProgModeValue>;
};

export type FilterFindManyThermostatRemoteSensorTempDeltaInput = {
  id?: InputMaybe<Scalars['String']>;
  observedAt?: InputMaybe<Scalars['Float']>;
  previousId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  units?: InputMaybe<Scalars['String']>;
  updatePending?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<Scalars['Float']>;
};

export type FilterFindManyThermostatSchedVisibilityModeInput = {
  id?: InputMaybe<Scalars['String']>;
  observedAt?: InputMaybe<Scalars['Float']>;
  previousId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  units?: InputMaybe<Scalars['String']>;
  updatePending?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<EnumThermostatSchedVisibilityModeValue>;
};

export type FilterFindManyThermostatScheduleInput = {
  id?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  units?: InputMaybe<Scalars['String']>;
  updatePending?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<Scalars['JSON']>;
};

export type FilterFindManyThermostatScheduleProfileInput = {
  AND?: InputMaybe<Array<FilterFindManyThermostatScheduleProfileInput>>;
  OR?: InputMaybe<Array<FilterFindManyThermostatScheduleProfileInput>>;
  _id?: InputMaybe<Scalars['String']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterFindManyThermostatScheduleProfileOperatorsInput>;
  name?: InputMaybe<Scalars['String']>;
  propertyId?: InputMaybe<Scalars['String']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterFindManyThermostatScheduleProfileOperatorsInput = {
  _id?: InputMaybe<FilterFindManyThermostatScheduleProfile_IdOperatorsInput>;
  propertyId?: InputMaybe<FilterFindManyThermostatScheduleProfilePropertyIdOperatorsInput>;
};

export type FilterFindManyThermostatScheduleProfilePropertyIdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['String']>;
  gte?: InputMaybe<Scalars['String']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  lt?: InputMaybe<Scalars['String']>;
  lte?: InputMaybe<Scalars['String']>;
  ne?: InputMaybe<Scalars['String']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']>;
};

export type FilterFindManyThermostatScheduleProfile_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['String']>;
  gte?: InputMaybe<Scalars['String']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  lt?: InputMaybe<Scalars['String']>;
  lte?: InputMaybe<Scalars['String']>;
  ne?: InputMaybe<Scalars['String']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']>;
};

export type FilterFindManyThermostatScheduleTemplateInput = {
  AND?: InputMaybe<Array<FilterFindManyThermostatScheduleTemplateInput>>;
  OR?: InputMaybe<Array<FilterFindManyThermostatScheduleTemplateInput>>;
  _id?: InputMaybe<Scalars['String']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterFindManyThermostatScheduleTemplateOperatorsInput>;
  name?: InputMaybe<Scalars['String']>;
  propertyId?: InputMaybe<Scalars['String']>;
  setpointLimitProfileId?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<FilterFindManyThermostatScheduleTemplateValueInput>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterFindManyThermostatScheduleTemplateOperatorsInput = {
  _id?: InputMaybe<FilterFindManyThermostatScheduleTemplate_IdOperatorsInput>;
  propertyId?: InputMaybe<FilterFindManyThermostatScheduleTemplatePropertyIdOperatorsInput>;
};

export type FilterFindManyThermostatScheduleTemplatePropertyIdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['String']>;
  gte?: InputMaybe<Scalars['String']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  lt?: InputMaybe<Scalars['String']>;
  lte?: InputMaybe<Scalars['String']>;
  ne?: InputMaybe<Scalars['String']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']>;
};

export type FilterFindManyThermostatScheduleTemplateValueInput = {
  id?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  units?: InputMaybe<Scalars['String']>;
  updatePending?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<Scalars['JSON']>;
};

export type FilterFindManyThermostatScheduleTemplate_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['String']>;
  gte?: InputMaybe<Scalars['String']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  lt?: InputMaybe<Scalars['String']>;
  lte?: InputMaybe<Scalars['String']>;
  ne?: InputMaybe<Scalars['String']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']>;
};

export type FilterFindManyThermostatSetpointChangeSourceInput = {
  id?: InputMaybe<Scalars['String']>;
  observedAt?: InputMaybe<Scalars['Float']>;
  previousId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  units?: InputMaybe<Scalars['String']>;
  updatePending?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<EnumThermostatSetpointChangeSourceValue>;
};

export type FilterFindManyThermostatSetpointInput = {
  id?: InputMaybe<Scalars['String']>;
  observedAt?: InputMaybe<Scalars['Float']>;
  previousId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  units?: InputMaybe<Scalars['String']>;
  updatePending?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<Scalars['Float']>;
};

export type FilterFindManyThermostatShowFanButtonInput = {
  id?: InputMaybe<Scalars['String']>;
  observedAt?: InputMaybe<Scalars['Float']>;
  previousId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  units?: InputMaybe<Scalars['String']>;
  updatePending?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<Scalars['Boolean']>;
};

export type FilterFindManyThermostatSystemTypeInput = {
  id?: InputMaybe<Scalars['String']>;
  observedAt?: InputMaybe<Scalars['Float']>;
  previousId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  units?: InputMaybe<Scalars['String']>;
  updatePending?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<EnumThermostatSystemTypeValue>;
};

export type FilterFindManyThermostatTempDisplayModeInput = {
  id?: InputMaybe<Scalars['String']>;
  observedAt?: InputMaybe<Scalars['Float']>;
  previousId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  units?: InputMaybe<Scalars['String']>;
  updatePending?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<EnumThermostatTempDisplayModeValue>;
};

export type FilterFindManyThermostatTemperatureInput = {
  id?: InputMaybe<Scalars['String']>;
  observedAt?: InputMaybe<Scalars['Float']>;
  previousId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  units?: InputMaybe<Scalars['String']>;
  updatePending?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<Scalars['Float']>;
};

export type FilterFindManyThermostatThermostatControlCommandInput = {
  commandId?: InputMaybe<Scalars['String']>;
  confirmation?: InputMaybe<Scalars['JSON']>;
  error?: InputMaybe<Scalars['String']>;
  expiresAt?: InputMaybe<Scalars['Float']>;
  requestedAt?: InputMaybe<Scalars['Float']>;
  requestedValues?: InputMaybe<Scalars['JSON']>;
  status?: InputMaybe<EnumThermostatThermostatControlCommandStatus>;
};

export type FilterFindManyThermostatUiOptionsInput = {
  id?: InputMaybe<Scalars['String']>;
  observedAt?: InputMaybe<Scalars['Float']>;
  previousId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  units?: InputMaybe<Scalars['String']>;
  updatePending?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<Scalars['Float']>;
};

export type FilterFindManyUnitAlertTypesInput = {
  deviceAlert?: InputMaybe<Scalars['Boolean']>;
  deviceMetric?: InputMaybe<Scalars['Boolean']>;
  deviceOffline?: InputMaybe<Scalars['Boolean']>;
  equipmentAlarm?: InputMaybe<Scalars['Boolean']>;
  sourceOffline?: InputMaybe<Scalars['Boolean']>;
};

export type FilterFindManyUnitBuildingIdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['String']>;
  gte?: InputMaybe<Scalars['String']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  lt?: InputMaybe<Scalars['String']>;
  lte?: InputMaybe<Scalars['String']>;
  ne?: InputMaybe<Scalars['String']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']>;
};

export type FilterFindManyUnitDevicesSummaryInput = {
  count?: InputMaybe<Scalars['Float']>;
  majorAlerts?: InputMaybe<Scalars['Float']>;
  minorAlerts?: InputMaybe<Scalars['Float']>;
  proxy?: InputMaybe<FilterFindManyUnitDevicesSummaryProxyInput>;
};

export type FilterFindManyUnitDevicesSummaryProxyInput = {
  coolSetpoint?: InputMaybe<Scalars['Float']>;
  heatSetpoint?: InputMaybe<Scalars['Float']>;
  humidity?: InputMaybe<Scalars['Float']>;
  isOffline?: InputMaybe<Scalars['Boolean']>;
  operatingMode?: InputMaybe<Scalars['String']>;
  operatingState?: InputMaybe<Scalars['String']>;
  setpointCoolMin?: InputMaybe<Scalars['Float']>;
  setpointHeatMax?: InputMaybe<Scalars['Float']>;
  setpointProfileName?: InputMaybe<Scalars['String']>;
  setpointProfileType?: InputMaybe<Scalars['String']>;
  temperature?: InputMaybe<Scalars['Float']>;
  type?: InputMaybe<Scalars['String']>;
};

export type FilterFindManyUnitInput = {
  AND?: InputMaybe<Array<FilterFindManyUnitInput>>;
  OR?: InputMaybe<Array<FilterFindManyUnitInput>>;
  _id?: InputMaybe<Scalars['String']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterFindManyUnitOperatorsInput>;
  alertTypes?: InputMaybe<FilterFindManyUnitAlertTypesInput>;
  buildingId?: InputMaybe<Scalars['String']>;
  cuid?: InputMaybe<Scalars['String']>;
  devicesSummary?: InputMaybe<FilterFindManyUnitDevicesSummaryInput>;
  floorId?: InputMaybe<Scalars['String']>;
  hasPanels?: InputMaybe<Scalars['Boolean']>;
  name?: InputMaybe<Scalars['String']>;
  propertyId?: InputMaybe<Scalars['String']>;
  resident?: InputMaybe<FilterFindManyUnitResidentInput>;
  setpointProfileId?: InputMaybe<Scalars['String']>;
  sourceId?: InputMaybe<Scalars['String']>;
  tempDisplayUnits?: InputMaybe<Scalars['String']>;
  thermostatScheduleTemplateId?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<Scalars['String']>;
  /** Constructs a regular expression search based on the string provided */
  withNameLike?: InputMaybe<Scalars['String']>;
  zonePolicyId?: InputMaybe<Scalars['String']>;
};

export type FilterFindManyUnitNameOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['String']>;
  gte?: InputMaybe<Scalars['String']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  lt?: InputMaybe<Scalars['String']>;
  lte?: InputMaybe<Scalars['String']>;
  ne?: InputMaybe<Scalars['String']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterFindManyUnitOperatorsInput = {
  _id?: InputMaybe<FilterFindManyUnit_IdOperatorsInput>;
  buildingId?: InputMaybe<FilterFindManyUnitBuildingIdOperatorsInput>;
  name?: InputMaybe<FilterFindManyUnitNameOperatorsInput>;
  propertyId?: InputMaybe<FilterFindManyUnitPropertyIdOperatorsInput>;
};

export type FilterFindManyUnitPropertyIdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['String']>;
  gte?: InputMaybe<Scalars['String']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  lt?: InputMaybe<Scalars['String']>;
  lte?: InputMaybe<Scalars['String']>;
  ne?: InputMaybe<Scalars['String']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']>;
};

export type FilterFindManyUnitResidentInput = {
  email?: InputMaybe<Scalars['String']>;
  mobile?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  phone?: InputMaybe<Scalars['String']>;
};

export type FilterFindManyUnit_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['String']>;
  gte?: InputMaybe<Scalars['String']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  lt?: InputMaybe<Scalars['String']>;
  lte?: InputMaybe<Scalars['String']>;
  ne?: InputMaybe<Scalars['String']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']>;
};

export type FilterFindManyUserEmailsInput = {
  address?: InputMaybe<Scalars['String']>;
  externalId?: InputMaybe<Scalars['String']>;
  verified?: InputMaybe<Scalars['Boolean']>;
};

export type FilterFindManyUserHistoryInput = {
  AND?: InputMaybe<Array<FilterFindManyUserHistoryInput>>;
  OR?: InputMaybe<Array<FilterFindManyUserHistoryInput>>;
  _id?: InputMaybe<Scalars['String']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterFindManyUserHistoryOperatorsInput>;
  currentIndex?: InputMaybe<Scalars['Float']>;
  deviceId?: InputMaybe<Scalars['String']>;
  history?: InputMaybe<Scalars['JSON']>;
  lastAccessedAt?: InputMaybe<Scalars['Float']>;
  userId?: InputMaybe<Scalars['String']>;
};

export type FilterFindManyUserHistoryLastAccessedAtOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['Float']>;
  gte?: InputMaybe<Scalars['Float']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Float']>>>;
  lt?: InputMaybe<Scalars['Float']>;
  lte?: InputMaybe<Scalars['Float']>;
  ne?: InputMaybe<Scalars['Float']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Float']>>>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterFindManyUserHistoryOperatorsInput = {
  _id?: InputMaybe<FilterFindManyUserHistory_IdOperatorsInput>;
  lastAccessedAt?: InputMaybe<FilterFindManyUserHistoryLastAccessedAtOperatorsInput>;
  userId?: InputMaybe<FilterFindManyUserHistoryUserIdOperatorsInput>;
};

export type FilterFindManyUserHistoryUserIdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['String']>;
  gte?: InputMaybe<Scalars['String']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  lt?: InputMaybe<Scalars['String']>;
  lte?: InputMaybe<Scalars['String']>;
  ne?: InputMaybe<Scalars['String']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']>;
};

export type FilterFindManyUserHistory_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['String']>;
  gte?: InputMaybe<Scalars['String']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  lt?: InputMaybe<Scalars['String']>;
  lte?: InputMaybe<Scalars['String']>;
  ne?: InputMaybe<Scalars['String']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']>;
};

export type FilterFindManyUserInput = {
  AND?: InputMaybe<Array<FilterFindManyUserInput>>;
  OR?: InputMaybe<Array<FilterFindManyUserInput>>;
  _id?: InputMaybe<Scalars['String']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterFindManyUserOperatorsInput>;
  createdAt?: InputMaybe<Scalars['Date']>;
  emails?: InputMaybe<Array<InputMaybe<FilterFindManyUserEmailsInput>>>;
  externalId?: InputMaybe<Scalars['String']>;
  heartbeat?: InputMaybe<Scalars['Date']>;
  mobileSession?: InputMaybe<FilterFindManyUserMobileSessionInput>;
  profile?: InputMaybe<FilterFindManyUserProfileInput>;
  services?: InputMaybe<FilterFindManyUserServicesInput>;
  session?: InputMaybe<FilterFindManyUserSessionInput>;
  state?: InputMaybe<Scalars['String']>;
  username?: InputMaybe<Scalars['String']>;
};

export type FilterFindManyUserMobileSessionInput = {
  appName?: InputMaybe<Scalars['String']>;
  packageName?: InputMaybe<Scalars['String']>;
  version?: InputMaybe<Scalars['String']>;
  versionCode?: InputMaybe<Scalars['String']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterFindManyUserOperatorsInput = {
  _id?: InputMaybe<FilterFindManyUser_IdOperatorsInput>;
};

export type FilterFindManyUserProfileInput = {
  emailOptInStatus?: InputMaybe<Scalars['String']>;
  emailOptInStatusTimestamp?: InputMaybe<Scalars['Float']>;
  historyMap?: InputMaybe<Scalars['JSON']>;
  mobile?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  preferredAirFlowUnits?: InputMaybe<EnumUserProfilePreferredAirFlowUnits>;
  preferredUnits?: InputMaybe<EnumUserProfilePreferredUnits>;
  smsOptInStatus?: InputMaybe<Scalars['String']>;
  smsOptInStatusTimestamp?: InputMaybe<Scalars['Float']>;
};

export type FilterFindManyUserServicesInput = {
  password?: InputMaybe<FilterFindManyUserServicesPasswordInput>;
  resume?: InputMaybe<FilterFindManyUserServicesResumeInput>;
};

export type FilterFindManyUserServicesPasswordInput = {
  bcrypt?: InputMaybe<Scalars['String']>;
  enroll?: InputMaybe<Scalars['String']>;
  externalId?: InputMaybe<Scalars['String']>;
  reset?: InputMaybe<Scalars['String']>;
};

export type FilterFindManyUserServicesResumeInput = {
  loginTokens?: InputMaybe<
    Array<InputMaybe<FilterFindManyUserServicesResumeLoginTokensInput>>
  >;
};

export type FilterFindManyUserServicesResumeLoginTokensInput = {
  hashedToken?: InputMaybe<Scalars['String']>;
  when?: InputMaybe<Scalars['Date']>;
};

export type FilterFindManyUserSessionInput = {
  isMobile?: InputMaybe<Scalars['Boolean']>;
};

export type FilterFindManyUser_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['String']>;
  gte?: InputMaybe<Scalars['String']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  lt?: InputMaybe<Scalars['String']>;
  lte?: InputMaybe<Scalars['String']>;
  ne?: InputMaybe<Scalars['String']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']>;
};

export type FilterFindManyVsdPumpCurrentSpeedInput = {
  id?: InputMaybe<Scalars['String']>;
  observedAt?: InputMaybe<Scalars['Float']>;
  previousId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  units?: InputMaybe<Scalars['String']>;
  updatePending?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<Scalars['Float']>;
};

export type FilterFindManyVsdPumpDriveModeInput = {
  id?: InputMaybe<Scalars['String']>;
  observedAt?: InputMaybe<Scalars['Float']>;
  previousId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  units?: InputMaybe<Scalars['String']>;
  updatePending?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<Scalars['String']>;
};

export type FilterFindManyVsdPumpDriveOutputEnergyInput = {
  id?: InputMaybe<Scalars['String']>;
  observedAt?: InputMaybe<Scalars['Float']>;
  previousId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  units?: InputMaybe<Scalars['String']>;
  updatePending?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<Scalars['Float']>;
};

export type FilterFindManyVsdPumpDriveOutputPowerInput = {
  id?: InputMaybe<Scalars['String']>;
  observedAt?: InputMaybe<Scalars['Float']>;
  previousId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  units?: InputMaybe<Scalars['String']>;
  updatePending?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<Scalars['Float']>;
};

export type FilterFindManyVsdPumpInput = {
  AND?: InputMaybe<Array<FilterFindManyDeviceInput>>;
  OR?: InputMaybe<Array<FilterFindManyDeviceInput>>;
  _id?: InputMaybe<Scalars['String']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterFindManyDeviceOperatorsInput>;
  alertTypes?: InputMaybe<FilterFindManyDeviceAlertTypesInput>;
  controlled?: InputMaybe<FilterFindManyDeviceControlledInput>;
  currentSpeed?: InputMaybe<FilterFindManyVsdPumpCurrentSpeedInput>;
  deviceId?: InputMaybe<Scalars['String']>;
  driveMode?: InputMaybe<FilterFindManyVsdPumpDriveModeInput>;
  driveOutputEnergy?: InputMaybe<FilterFindManyVsdPumpDriveOutputEnergyInput>;
  driveOutputPower?: InputMaybe<FilterFindManyVsdPumpDriveOutputPowerInput>;
  installation?: InputMaybe<FilterFindManyDeviceInstallationInput>;
  location?: InputMaybe<Scalars['String']>;
  meta?: InputMaybe<FilterFindManyDeviceMetaInput>;
  /** The name of the device */
  name?: InputMaybe<Scalars['String']>;
  panelId?: InputMaybe<Scalars['String']>;
  powerState?: InputMaybe<FilterFindManyDevicePowerStateInput>;
  propertyId?: InputMaybe<Scalars['String']>;
  returnTemperature?: InputMaybe<FilterFindManyVsdPumpReturnTemperatureInput>;
  role?: InputMaybe<Scalars['String']>;
  sourceId?: InputMaybe<Scalars['String']>;
  stopOrStart?: InputMaybe<FilterFindManyVsdPumpStopOrStartInput>;
  supplyTemperature?: InputMaybe<FilterFindManyVsdPumpSupplyTemperatureInput>;
  targetSpeed?: InputMaybe<FilterFindManyVsdPumpTargetSpeedInput>;
  timestamp?: InputMaybe<Scalars['Float']>;
  unitId?: InputMaybe<Scalars['String']>;
  updateStatus?: InputMaybe<Scalars['Boolean']>;
  vppId?: InputMaybe<Scalars['String']>;
  zoneId?: InputMaybe<Scalars['String']>;
};

export type FilterFindManyVsdPumpReturnTemperatureInput = {
  id?: InputMaybe<Scalars['String']>;
  observedAt?: InputMaybe<Scalars['Float']>;
  previousId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  units?: InputMaybe<Scalars['String']>;
  updatePending?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<Scalars['Float']>;
};

export type FilterFindManyVsdPumpStopOrStartInput = {
  id?: InputMaybe<Scalars['String']>;
  observedAt?: InputMaybe<Scalars['Float']>;
  previousId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  units?: InputMaybe<Scalars['String']>;
  updatePending?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<Scalars['Float']>;
};

export type FilterFindManyVsdPumpSupplyTemperatureInput = {
  id?: InputMaybe<Scalars['String']>;
  observedAt?: InputMaybe<Scalars['Float']>;
  previousId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  units?: InputMaybe<Scalars['String']>;
  updatePending?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<Scalars['Float']>;
};

export type FilterFindManyVsdPumpTargetSpeedInput = {
  id?: InputMaybe<Scalars['String']>;
  observedAt?: InputMaybe<Scalars['Float']>;
  previousId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  units?: InputMaybe<Scalars['String']>;
  updatePending?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<Scalars['Float']>;
};

export type FilterFindManyVirtualPowerPlantInput = {
  AND?: InputMaybe<Array<FilterFindManyVirtualPowerPlantInput>>;
  OR?: InputMaybe<Array<FilterFindManyVirtualPowerPlantInput>>;
  _id?: InputMaybe<Scalars['String']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterFindManyVirtualPowerPlantOperatorsInput>;
  inverterId?: InputMaybe<Scalars['String']>;
  location?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  operationalStatus?: InputMaybe<FilterFindManyVirtualPowerPlantOperationalStatusInput>;
  propertyId?: InputMaybe<Scalars['String']>;
  sourceId?: InputMaybe<Scalars['String']>;
  switchPanelId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  unitId?: InputMaybe<Scalars['String']>;
  updateStatus?: InputMaybe<Scalars['Boolean']>;
};

export type FilterFindManyVirtualPowerPlantOperationalStatusInput = {
  id?: InputMaybe<Scalars['String']>;
  observedAt?: InputMaybe<Scalars['Float']>;
  previousId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  units?: InputMaybe<Scalars['String']>;
  updatePending?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<EnumVirtualPowerPlantOperationalStatusValue>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterFindManyVirtualPowerPlantOperatorsInput = {
  _id?: InputMaybe<FilterFindManyVirtualPowerPlant_IdOperatorsInput>;
};

export type FilterFindManyVirtualPowerPlant_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['String']>;
  gte?: InputMaybe<Scalars['String']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  lt?: InputMaybe<Scalars['String']>;
  lte?: InputMaybe<Scalars['String']>;
  ne?: InputMaybe<Scalars['String']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']>;
};

export type FilterFindManyWindManagementSystemBladeConditionInput = {
  id?: InputMaybe<Scalars['String']>;
  observedAt?: InputMaybe<Scalars['Float']>;
  previousId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  units?: InputMaybe<Scalars['String']>;
  updatePending?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<EnumWindManagementSystemBladeConditionValue>;
};

export type FilterFindManyWindManagementSystemBrakeStatusInput = {
  id?: InputMaybe<Scalars['String']>;
  observedAt?: InputMaybe<Scalars['Float']>;
  previousId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  units?: InputMaybe<Scalars['String']>;
  updatePending?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<EnumWindManagementSystemBrakeStatusValue>;
};

export type FilterFindManyWindManagementSystemGeneratorTemperatureInput = {
  id?: InputMaybe<Scalars['String']>;
  observedAt?: InputMaybe<Scalars['Float']>;
  previousId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  units?: InputMaybe<Scalars['String']>;
  updatePending?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<Scalars['Float']>;
};

export type FilterFindManyWindManagementSystemIceDetectionStatusInput = {
  id?: InputMaybe<Scalars['String']>;
  observedAt?: InputMaybe<Scalars['Float']>;
  previousId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  units?: InputMaybe<Scalars['String']>;
  updatePending?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<EnumWindManagementSystemIceDetectionStatusValue>;
};

export type FilterFindManyWindManagementSystemInput = {
  AND?: InputMaybe<Array<FilterFindManyDeviceInput>>;
  OR?: InputMaybe<Array<FilterFindManyDeviceInput>>;
  _id?: InputMaybe<Scalars['String']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterFindManyDeviceOperatorsInput>;
  alertTypes?: InputMaybe<FilterFindManyDeviceAlertTypesInput>;
  bladeCondition?: InputMaybe<FilterFindManyWindManagementSystemBladeConditionInput>;
  brakeStatus?: InputMaybe<FilterFindManyWindManagementSystemBrakeStatusInput>;
  controlled?: InputMaybe<FilterFindManyDeviceControlledInput>;
  deviceId?: InputMaybe<Scalars['String']>;
  generatorTemperature?: InputMaybe<FilterFindManyWindManagementSystemGeneratorTemperatureInput>;
  iceDetectionStatus?: InputMaybe<FilterFindManyWindManagementSystemIceDetectionStatusInput>;
  installation?: InputMaybe<FilterFindManyDeviceInstallationInput>;
  location?: InputMaybe<Scalars['String']>;
  meta?: InputMaybe<FilterFindManyDeviceMetaInput>;
  /** The name of the device */
  name?: InputMaybe<Scalars['String']>;
  panelId?: InputMaybe<Scalars['String']>;
  pitchAngle?: InputMaybe<FilterFindManyWindManagementSystemPitchAngleInput>;
  powerState?: InputMaybe<FilterFindManyDevicePowerStateInput>;
  propertyId?: InputMaybe<Scalars['String']>;
  rotorSpeed?: InputMaybe<FilterFindManyWindManagementSystemRotorSpeedInput>;
  sourceId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  unitId?: InputMaybe<Scalars['String']>;
  updateStatus?: InputMaybe<Scalars['Boolean']>;
  vibrationLevel?: InputMaybe<FilterFindManyWindManagementSystemVibrationLevelInput>;
  vppId?: InputMaybe<Scalars['String']>;
  windDirection?: InputMaybe<FilterFindManyWindManagementSystemWindDirectionInput>;
  windSpeed?: InputMaybe<FilterFindManyWindManagementSystemWindSpeedInput>;
  yawControlStatus?: InputMaybe<FilterFindManyWindManagementSystemYawControlStatusInput>;
  zoneId?: InputMaybe<Scalars['String']>;
};

export type FilterFindManyWindManagementSystemPitchAngleInput = {
  id?: InputMaybe<Scalars['String']>;
  observedAt?: InputMaybe<Scalars['Float']>;
  previousId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  units?: InputMaybe<Scalars['String']>;
  updatePending?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<Scalars['Float']>;
};

export type FilterFindManyWindManagementSystemRotorSpeedInput = {
  id?: InputMaybe<Scalars['String']>;
  observedAt?: InputMaybe<Scalars['Float']>;
  previousId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  units?: InputMaybe<Scalars['String']>;
  updatePending?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<Scalars['Float']>;
};

export type FilterFindManyWindManagementSystemVibrationLevelInput = {
  id?: InputMaybe<Scalars['String']>;
  observedAt?: InputMaybe<Scalars['Float']>;
  previousId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  units?: InputMaybe<Scalars['String']>;
  updatePending?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<Scalars['Float']>;
};

export type FilterFindManyWindManagementSystemWindDirectionInput = {
  id?: InputMaybe<Scalars['String']>;
  observedAt?: InputMaybe<Scalars['Float']>;
  previousId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  units?: InputMaybe<Scalars['String']>;
  updatePending?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<Scalars['Float']>;
};

export type FilterFindManyWindManagementSystemWindSpeedInput = {
  id?: InputMaybe<Scalars['String']>;
  observedAt?: InputMaybe<Scalars['Float']>;
  previousId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  units?: InputMaybe<Scalars['String']>;
  updatePending?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<Scalars['Float']>;
};

export type FilterFindManyWindManagementSystemYawControlStatusInput = {
  id?: InputMaybe<Scalars['String']>;
  observedAt?: InputMaybe<Scalars['Float']>;
  previousId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  units?: InputMaybe<Scalars['String']>;
  updatePending?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<EnumWindManagementSystemYawControlStatusValue>;
};

export type FilterFindManyWindowSensorContactStateInput = {
  id?: InputMaybe<Scalars['String']>;
  observedAt?: InputMaybe<Scalars['Float']>;
  previousId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  units?: InputMaybe<Scalars['String']>;
  updatePending?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<Scalars['String']>;
};

export type FilterFindManyWindowSensorInput = {
  AND?: InputMaybe<Array<FilterFindManyDeviceInput>>;
  OR?: InputMaybe<Array<FilterFindManyDeviceInput>>;
  _id?: InputMaybe<Scalars['String']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterFindManyDeviceOperatorsInput>;
  alertTypes?: InputMaybe<FilterFindManyDeviceAlertTypesInput>;
  contactState?: InputMaybe<FilterFindManyWindowSensorContactStateInput>;
  controlled?: InputMaybe<FilterFindManyDeviceControlledInput>;
  deviceId?: InputMaybe<Scalars['String']>;
  installation?: InputMaybe<FilterFindManyDeviceInstallationInput>;
  location?: InputMaybe<Scalars['String']>;
  meta?: InputMaybe<FilterFindManyDeviceMetaInput>;
  /** The name of the device */
  name?: InputMaybe<Scalars['String']>;
  panelId?: InputMaybe<Scalars['String']>;
  powerState?: InputMaybe<FilterFindManyDevicePowerStateInput>;
  propertyId?: InputMaybe<Scalars['String']>;
  sourceId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  unitId?: InputMaybe<Scalars['String']>;
  updateStatus?: InputMaybe<Scalars['Boolean']>;
  voltage?: InputMaybe<FilterFindManyWindowSensorVoltageInput>;
  vppId?: InputMaybe<Scalars['String']>;
  zoneId?: InputMaybe<Scalars['String']>;
};

export type FilterFindManyWindowSensorVoltageInput = {
  id?: InputMaybe<Scalars['String']>;
  observedAt?: InputMaybe<Scalars['Float']>;
  previousId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  units?: InputMaybe<Scalars['String']>;
  updatePending?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<Scalars['Float']>;
};

export type FilterFindManyZ210PumpActivePumpInput = {
  id?: InputMaybe<Scalars['String']>;
  previousId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  units?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<Scalars['Float']>;
};

export type FilterFindManyZ210PumpCurrentSpeedInput = {
  id?: InputMaybe<Scalars['String']>;
  observedAt?: InputMaybe<Scalars['Float']>;
  previousId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  units?: InputMaybe<Scalars['String']>;
  updatePending?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<Scalars['Float']>;
};

export type FilterFindManyZ210PumpInput = {
  AND?: InputMaybe<Array<FilterFindManyDeviceInput>>;
  OR?: InputMaybe<Array<FilterFindManyDeviceInput>>;
  _id?: InputMaybe<Scalars['String']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterFindManyDeviceOperatorsInput>;
  activePump?: InputMaybe<FilterFindManyZ210PumpActivePumpInput>;
  alertTypes?: InputMaybe<FilterFindManyDeviceAlertTypesInput>;
  controlled?: InputMaybe<FilterFindManyDeviceControlledInput>;
  currentSpeed?: InputMaybe<FilterFindManyZ210PumpCurrentSpeedInput>;
  deviceId?: InputMaybe<Scalars['String']>;
  installation?: InputMaybe<FilterFindManyDeviceInstallationInput>;
  location?: InputMaybe<Scalars['String']>;
  meta?: InputMaybe<FilterFindManyDeviceMetaInput>;
  /** The name of the device */
  name?: InputMaybe<Scalars['String']>;
  panelId?: InputMaybe<Scalars['String']>;
  powerState?: InputMaybe<FilterFindManyDevicePowerStateInput>;
  propertyId?: InputMaybe<Scalars['String']>;
  role?: InputMaybe<Scalars['String']>;
  sourceId?: InputMaybe<Scalars['String']>;
  targetSpeed?: InputMaybe<FilterFindManyZ210PumpTargetSpeedInput>;
  timestamp?: InputMaybe<Scalars['Float']>;
  unitId?: InputMaybe<Scalars['String']>;
  updateStatus?: InputMaybe<Scalars['Boolean']>;
  vppId?: InputMaybe<Scalars['String']>;
  zoneId?: InputMaybe<Scalars['String']>;
};

export type FilterFindManyZ210PumpTargetSpeedInput = {
  id?: InputMaybe<Scalars['String']>;
  observedAt?: InputMaybe<Scalars['Float']>;
  previousId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  units?: InputMaybe<Scalars['String']>;
  updatePending?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<Scalars['Float']>;
};

export type FilterFindManyZoneInput = {
  AND?: InputMaybe<Array<FilterFindManyZoneInput>>;
  OR?: InputMaybe<Array<FilterFindManyZoneInput>>;
  _id?: InputMaybe<Scalars['String']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterFindManyZoneOperatorsInput>;
  airHandlerId?: InputMaybe<Scalars['String']>;
  bngSourceId?: InputMaybe<Scalars['String']>;
  controller?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  pairedSensorId?: InputMaybe<Scalars['String']>;
  propertyId?: InputMaybe<Scalars['String']>;
  role?: InputMaybe<Scalars['String']>;
  sourceId?: InputMaybe<Scalars['String']>;
  thermostatId?: InputMaybe<Scalars['String']>;
  unitId?: InputMaybe<Scalars['String']>;
  zonePolicyId?: InputMaybe<Scalars['String']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterFindManyZoneOperatorsInput = {
  _id?: InputMaybe<FilterFindManyZone_IdOperatorsInput>;
  propertyId?: InputMaybe<FilterFindManyZonePropertyIdOperatorsInput>;
  unitId?: InputMaybe<FilterFindManyZoneUnitIdOperatorsInput>;
};

export type FilterFindManyZonePolicyInput = {
  AND?: InputMaybe<Array<FilterFindManyZonePolicyInput>>;
  OR?: InputMaybe<Array<FilterFindManyZonePolicyInput>>;
  _id?: InputMaybe<Scalars['MongoID']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterFindManyZonePolicyOperatorsInput>;
  name?: InputMaybe<Scalars['String']>;
  properties?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  rules?: InputMaybe<Array<InputMaybe<FilterFindManyZonePolicyRulesInput>>>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterFindManyZonePolicyOperatorsInput = {
  _id?: InputMaybe<FilterFindManyZonePolicy_IdOperatorsInput>;
};

export type FilterFindManyZonePolicyRulesInput = {
  source?: InputMaybe<FilterFindManyZonePolicyRulesSourceInput>;
  target?: InputMaybe<FilterFindManyZonePolicyRulesTargetInput>;
  type?: InputMaybe<EnumZonePolicyRulesType>;
};

export type FilterFindManyZonePolicyRulesSourceAttributesInput = {
  contactState?: InputMaybe<Scalars['String']>;
  coolSetpoint?: InputMaybe<Scalars['String']>;
  fanSpeed?: InputMaybe<Scalars['String']>;
  heatSetpoint?: InputMaybe<Scalars['String']>;
  indoorFanStatus?: InputMaybe<Scalars['String']>;
  keypadLockoutLevel?: InputMaybe<Scalars['String']>;
  operatingMode?: InputMaybe<Scalars['String']>;
  operatingState?: InputMaybe<Scalars['String']>;
};

export type FilterFindManyZonePolicyRulesSourceInput = {
  attributes?: InputMaybe<FilterFindManyZonePolicyRulesSourceAttributesInput>;
  deviceType?: InputMaybe<Scalars['String']>;
  multiplicity?: InputMaybe<EnumZonePolicyRulesSourceMultiplicity>;
};

export type FilterFindManyZonePolicyRulesTargetAttributesInput = {
  coolSetpoint?: InputMaybe<Scalars['String']>;
  heatSetpoint?: InputMaybe<Scalars['String']>;
  isOn?: InputMaybe<Scalars['String']>;
  keypadLockoutLevel?: InputMaybe<Scalars['String']>;
  relayState?: InputMaybe<Scalars['String']>;
};

export type FilterFindManyZonePolicyRulesTargetInput = {
  attributes?: InputMaybe<FilterFindManyZonePolicyRulesTargetAttributesInput>;
  deviceType?: InputMaybe<Scalars['String']>;
  multiplicity?: InputMaybe<EnumZonePolicyRulesTargetMultiplicity>;
};

export type FilterFindManyZonePolicy_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['MongoID']>;
  gte?: InputMaybe<Scalars['MongoID']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']>>>;
  lt?: InputMaybe<Scalars['MongoID']>;
  lte?: InputMaybe<Scalars['MongoID']>;
  ne?: InputMaybe<Scalars['MongoID']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']>>>;
};

export type FilterFindManyZonePropertyIdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['String']>;
  gte?: InputMaybe<Scalars['String']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  lt?: InputMaybe<Scalars['String']>;
  lte?: InputMaybe<Scalars['String']>;
  ne?: InputMaybe<Scalars['String']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']>;
};

export type FilterFindManyZoneUnitIdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['String']>;
  gte?: InputMaybe<Scalars['String']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  lt?: InputMaybe<Scalars['String']>;
  lte?: InputMaybe<Scalars['String']>;
  ne?: InputMaybe<Scalars['String']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']>;
};

export type FilterFindManyZone_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['String']>;
  gte?: InputMaybe<Scalars['String']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  lt?: InputMaybe<Scalars['String']>;
  lte?: InputMaybe<Scalars['String']>;
  ne?: InputMaybe<Scalars['String']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']>;
};

export type FilterFindOneActuatorControlModeInput = {
  id?: InputMaybe<Scalars['String']>;
  observedAt?: InputMaybe<Scalars['Float']>;
  previousId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  units?: InputMaybe<Scalars['String']>;
  updatePending?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<EnumActuatorControlModeValue>;
};

export type FilterFindOneActuatorDefaultPositionInput = {
  id?: InputMaybe<Scalars['String']>;
  observedAt?: InputMaybe<Scalars['Float']>;
  previousId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  units?: InputMaybe<Scalars['String']>;
  updatePending?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<Scalars['Float']>;
};

export type FilterFindOneActuatorInput = {
  AND?: InputMaybe<Array<FilterFindOneDeviceInput>>;
  OR?: InputMaybe<Array<FilterFindOneDeviceInput>>;
  _id?: InputMaybe<Scalars['String']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterFindOneDeviceOperatorsInput>;
  alertTypes?: InputMaybe<FilterFindOneDeviceAlertTypesInput>;
  controlMode?: InputMaybe<FilterFindOneActuatorControlModeInput>;
  controlled?: InputMaybe<FilterFindOneDeviceControlledInput>;
  defaultPosition?: InputMaybe<FilterFindOneActuatorDefaultPositionInput>;
  deviceId?: InputMaybe<Scalars['String']>;
  installation?: InputMaybe<FilterFindOneDeviceInstallationInput>;
  location?: InputMaybe<Scalars['String']>;
  meta?: InputMaybe<FilterFindOneDeviceMetaInput>;
  /** The name of the device */
  name?: InputMaybe<Scalars['String']>;
  panelId?: InputMaybe<Scalars['String']>;
  position?: InputMaybe<FilterFindOneActuatorPositionInput>;
  powerState?: InputMaybe<FilterFindOneDevicePowerStateInput>;
  propertyId?: InputMaybe<Scalars['String']>;
  sourceId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  unitId?: InputMaybe<Scalars['String']>;
  updateStatus?: InputMaybe<Scalars['Boolean']>;
  vppId?: InputMaybe<Scalars['String']>;
  zoneId?: InputMaybe<Scalars['String']>;
};

export type FilterFindOneActuatorPositionInput = {
  id?: InputMaybe<Scalars['String']>;
  observedAt?: InputMaybe<Scalars['Float']>;
  previousId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  units?: InputMaybe<Scalars['String']>;
  updatePending?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<Scalars['Float']>;
};

export type FilterFindOneAlertAlertCategoryInput = {
  id?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
};

export type FilterFindOneAlertAlertTriggerInput = {
  id?: InputMaybe<Scalars['String']>;
  key?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
};

export type FilterFindOneAlertBuildingInput = {
  id?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
};

export type FilterFindOneAlertCategoryInput = {
  AND?: InputMaybe<Array<FilterFindOneAlertCategoryInput>>;
  OR?: InputMaybe<Array<FilterFindOneAlertCategoryInput>>;
  _id?: InputMaybe<Scalars['String']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterFindOneAlertCategoryOperatorsInput>;
  description?: InputMaybe<Scalars['String']>;
  key?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  propertyId?: InputMaybe<Scalars['String']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterFindOneAlertCategoryOperatorsInput = {
  _id?: InputMaybe<FilterFindOneAlertCategory_IdOperatorsInput>;
  propertyId?: InputMaybe<FilterFindOneAlertCategoryPropertyIdOperatorsInput>;
};

export type FilterFindOneAlertCategoryPropertyIdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['String']>;
  gte?: InputMaybe<Scalars['String']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  lt?: InputMaybe<Scalars['String']>;
  lte?: InputMaybe<Scalars['String']>;
  ne?: InputMaybe<Scalars['String']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']>;
};

export type FilterFindOneAlertCategory_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['String']>;
  gte?: InputMaybe<Scalars['String']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  lt?: InputMaybe<Scalars['String']>;
  lte?: InputMaybe<Scalars['String']>;
  ne?: InputMaybe<Scalars['String']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']>;
};

export type FilterFindOneAlertDeviceInput = {
  id?: InputMaybe<Scalars['String']>;
  model?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  role?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<Scalars['String']>;
  version?: InputMaybe<Scalars['String']>;
};

export type FilterFindOneAlertInput = {
  AND?: InputMaybe<Array<FilterFindOneAlertInput>>;
  OR?: InputMaybe<Array<FilterFindOneAlertInput>>;
  _id?: InputMaybe<Scalars['String']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterFindOneAlertOperatorsInput>;
  alertCategory?: InputMaybe<FilterFindOneAlertAlertCategoryInput>;
  alertTrigger?: InputMaybe<FilterFindOneAlertAlertTriggerInput>;
  building?: InputMaybe<FilterFindOneAlertBuildingInput>;
  device?: InputMaybe<FilterFindOneAlertDeviceInput>;
  id?: InputMaybe<Scalars['String']>;
  initiated?: InputMaybe<Scalars['Float']>;
  meta?: InputMaybe<FilterFindOneAlertMetaInput>;
  panel?: InputMaybe<FilterFindOneAlertPanelInput>;
  property?: InputMaybe<FilterFindOneAlertPropertyInput>;
  sourceId?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<FilterFindOneAlertTypeInput>;
  unit?: InputMaybe<FilterFindOneAlertUnitInput>;
  updated?: InputMaybe<Scalars['Float']>;
  zone?: InputMaybe<FilterFindOneAlertZoneInput>;
};

export type FilterFindOneAlertMetaInput = {
  id_str?: InputMaybe<Scalars['String']>;
  limit?: InputMaybe<Scalars['Float']>;
  message?: InputMaybe<Scalars['String']>;
  portName?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<Scalars['String']>;
};

export type FilterFindOneAlertNotificationAlertIdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['String']>;
  gte?: InputMaybe<Scalars['String']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  lt?: InputMaybe<Scalars['String']>;
  lte?: InputMaybe<Scalars['String']>;
  ne?: InputMaybe<Scalars['String']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']>;
};

export type FilterFindOneAlertNotificationInput = {
  AND?: InputMaybe<Array<FilterFindOneAlertNotificationInput>>;
  OR?: InputMaybe<Array<FilterFindOneAlertNotificationInput>>;
  _id?: InputMaybe<Scalars['String']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterFindOneAlertNotificationOperatorsInput>;
  alertId?: InputMaybe<Scalars['String']>;
  deliveryAttemptCount?: InputMaybe<Scalars['Float']>;
  externalId?: InputMaybe<Scalars['String']>;
  lastDeliveryAttemptStatus?: InputMaybe<EnumAlertNotificationLastDeliveryAttemptStatus>;
  lastDeliveryAttemptTimestamp?: InputMaybe<Scalars['Float']>;
  notificationMethod?: InputMaybe<EnumAlertNotificationNotificationMethod>;
  notificationType?: InputMaybe<EnumAlertNotificationNotificationType>;
  recipient?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterFindOneAlertNotificationOperatorsInput = {
  _id?: InputMaybe<FilterFindOneAlertNotification_IdOperatorsInput>;
  alertId?: InputMaybe<FilterFindOneAlertNotificationAlertIdOperatorsInput>;
};

export type FilterFindOneAlertNotification_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['String']>;
  gte?: InputMaybe<Scalars['String']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  lt?: InputMaybe<Scalars['String']>;
  lte?: InputMaybe<Scalars['String']>;
  ne?: InputMaybe<Scalars['String']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterFindOneAlertOperatorsInput = {
  _id?: InputMaybe<FilterFindOneAlert_IdOperatorsInput>;
  property?: InputMaybe<FilterFindOneAlertPropertyOperatorsInput>;
  unit?: InputMaybe<FilterFindOneAlertUnitOperatorsInput>;
};

export type FilterFindOneAlertOptOutInput = {
  AND?: InputMaybe<Array<FilterFindOneAlertOptOutInput>>;
  OR?: InputMaybe<Array<FilterFindOneAlertOptOutInput>>;
  _id?: InputMaybe<Scalars['String']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterFindOneAlertOptOutOperatorsInput>;
  optOutMethod?: InputMaybe<EnumAlertOptOutOptOutMethod>;
  optOutTimestamp?: InputMaybe<Scalars['Float']>;
  recipient?: InputMaybe<Scalars['String']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterFindOneAlertOptOutOperatorsInput = {
  _id?: InputMaybe<FilterFindOneAlertOptOut_IdOperatorsInput>;
  recipient?: InputMaybe<FilterFindOneAlertOptOutRecipientOperatorsInput>;
};

export type FilterFindOneAlertOptOutRecipientOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['String']>;
  gte?: InputMaybe<Scalars['String']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  lt?: InputMaybe<Scalars['String']>;
  lte?: InputMaybe<Scalars['String']>;
  ne?: InputMaybe<Scalars['String']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']>;
};

export type FilterFindOneAlertOptOut_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['String']>;
  gte?: InputMaybe<Scalars['String']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  lt?: InputMaybe<Scalars['String']>;
  lte?: InputMaybe<Scalars['String']>;
  ne?: InputMaybe<Scalars['String']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']>;
};

export type FilterFindOneAlertPanelInput = {
  id?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
};

export type FilterFindOneAlertPropertyContactInput = {
  email?: InputMaybe<Scalars['String']>;
  email2?: InputMaybe<Scalars['String']>;
  email3?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  smsNumber?: InputMaybe<Scalars['String']>;
  smsNumber2?: InputMaybe<Scalars['String']>;
  smsNumber3?: InputMaybe<Scalars['String']>;
  smsOptInStatus1?: InputMaybe<EnumAlertPropertyContactSmsOptInStatus1>;
  smsOptInStatus2?: InputMaybe<EnumAlertPropertyContactSmsOptInStatus2>;
  smsOptInStatus3?: InputMaybe<EnumAlertPropertyContactSmsOptInStatus3>;
  smsOptInTimestamp1?: InputMaybe<Scalars['Float']>;
  smsOptInTimestamp2?: InputMaybe<Scalars['Float']>;
  smsOptInTimestamp3?: InputMaybe<Scalars['Float']>;
};

export type FilterFindOneAlertPropertyIdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['String']>;
  gte?: InputMaybe<Scalars['String']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  lt?: InputMaybe<Scalars['String']>;
  lte?: InputMaybe<Scalars['String']>;
  ne?: InputMaybe<Scalars['String']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']>;
};

export type FilterFindOneAlertPropertyInput = {
  contact?: InputMaybe<FilterFindOneAlertPropertyContactInput>;
  id?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
};

export type FilterFindOneAlertPropertyOperatorsInput = {
  id?: InputMaybe<FilterFindOneAlertPropertyIdOperatorsInput>;
};

export type FilterFindOneAlertSubscriptionAlertTriggerIdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['String']>;
  gte?: InputMaybe<Scalars['String']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  lt?: InputMaybe<Scalars['String']>;
  lte?: InputMaybe<Scalars['String']>;
  ne?: InputMaybe<Scalars['String']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']>;
};

export type FilterFindOneAlertSubscriptionInput = {
  AND?: InputMaybe<Array<FilterFindOneAlertSubscriptionInput>>;
  OR?: InputMaybe<Array<FilterFindOneAlertSubscriptionInput>>;
  _id?: InputMaybe<Scalars['String']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterFindOneAlertSubscriptionOperatorsInput>;
  alertTriggerId?: InputMaybe<Scalars['String']>;
  deviceId?: InputMaybe<Scalars['String']>;
  email?: InputMaybe<Scalars['String']>;
  propertyId?: InputMaybe<Scalars['String']>;
  sms?: InputMaybe<Scalars['String']>;
  unitCategoryId?: InputMaybe<Scalars['String']>;
  unitId?: InputMaybe<Scalars['String']>;
  userId?: InputMaybe<Scalars['String']>;
  viaEmail?: InputMaybe<Scalars['Boolean']>;
  viaSms?: InputMaybe<Scalars['Boolean']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterFindOneAlertSubscriptionOperatorsInput = {
  _id?: InputMaybe<FilterFindOneAlertSubscription_IdOperatorsInput>;
  alertTriggerId?: InputMaybe<FilterFindOneAlertSubscriptionAlertTriggerIdOperatorsInput>;
};

export type FilterFindOneAlertSubscription_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['String']>;
  gte?: InputMaybe<Scalars['String']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  lt?: InputMaybe<Scalars['String']>;
  lte?: InputMaybe<Scalars['String']>;
  ne?: InputMaybe<Scalars['String']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']>;
};

export type FilterFindOneAlertTriggerInput = {
  AND?: InputMaybe<Array<FilterFindOneAlertTriggerInput>>;
  OR?: InputMaybe<Array<FilterFindOneAlertTriggerInput>>;
  _id?: InputMaybe<Scalars['String']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterFindOneAlertTriggerOperatorsInput>;
  alertCategoryId?: InputMaybe<Scalars['String']>;
  editMode?: InputMaybe<Scalars['Float']>;
  enabled?: InputMaybe<Scalars['Boolean']>;
  entityTypes?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  key?: InputMaybe<Scalars['String']>;
  legacyKey?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  propertyId?: InputMaybe<Scalars['String']>;
  triggerCriteria?: InputMaybe<FilterFindOneAlertTriggerTriggerCriteriaInput>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterFindOneAlertTriggerOperatorsInput = {
  _id?: InputMaybe<FilterFindOneAlertTrigger_IdOperatorsInput>;
  propertyId?: InputMaybe<FilterFindOneAlertTriggerPropertyIdOperatorsInput>;
};

export type FilterFindOneAlertTriggerPropertyIdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['String']>;
  gte?: InputMaybe<Scalars['String']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  lt?: InputMaybe<Scalars['String']>;
  lte?: InputMaybe<Scalars['String']>;
  ne?: InputMaybe<Scalars['String']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']>;
};

export type FilterFindOneAlertTriggerTriggerCriteriaInput = {
  basisName?: InputMaybe<Scalars['String']>;
  basisType?: InputMaybe<EnumAlertTriggerTriggerCriteriaBasisType>;
  levels?: InputMaybe<Scalars['Float']>;
  selectionCriteria?: InputMaybe<FilterFindOneAlertTriggerTriggerCriteriaSelectionCriteriaInput>;
};

export type FilterFindOneAlertTriggerTriggerCriteriaSelectionCriteriaCompoundOperatorInput =
  {
    criteria?: InputMaybe<Scalars['JSON']>;
    id?: InputMaybe<Scalars['String']>;
    operator?: InputMaybe<EnumAlertTriggerTriggerCriteriaSelectionCriteriaCompoundOperatorOperator>;
  };

export type FilterFindOneAlertTriggerTriggerCriteriaSelectionCriteriaCriterionInput =
  {
    comparator: EnumAlertTriggerTriggerCriteriaSelectionCriteriaCriterionComparator;
    editable?: InputMaybe<Scalars['Boolean']>;
    id: Scalars['String'];
    legacyPath?: InputMaybe<Scalars['String']>;
    selectionPath: Scalars['String'];
    template?: InputMaybe<Scalars['String']>;
    valueType: EnumAlertTriggerTriggerCriteriaSelectionCriteriaCriterionValueType;
    values: Array<InputMaybe<Scalars['String']>>;
  };

export type FilterFindOneAlertTriggerTriggerCriteriaSelectionCriteriaInput = {
  compoundOperator?: InputMaybe<FilterFindOneAlertTriggerTriggerCriteriaSelectionCriteriaCompoundOperatorInput>;
  criteria?: InputMaybe<
    Array<
      InputMaybe<FilterFindOneAlertTriggerTriggerCriteriaSelectionCriteriaCriterionInput>
    >
  >;
  criterion?: InputMaybe<FilterFindOneAlertTriggerTriggerCriteriaSelectionCriteriaCriterionInput>;
  simpleOperator?: InputMaybe<FilterFindOneAlertTriggerTriggerCriteriaSelectionCriteriaSimpleOperatorInput>;
};

export type FilterFindOneAlertTriggerTriggerCriteriaSelectionCriteriaSimpleOperatorInput =
  {
    criteria?: InputMaybe<
      Array<
        InputMaybe<FilterFindOneAlertTriggerTriggerCriteriaSelectionCriteriaCriterionInput>
      >
    >;
    criterion?: InputMaybe<FilterFindOneAlertTriggerTriggerCriteriaSelectionCriteriaCriterionInput>;
    id?: InputMaybe<Scalars['String']>;
    operator?: InputMaybe<EnumAlertTriggerTriggerCriteriaSelectionCriteriaSimpleOperatorOperator>;
  };

export type FilterFindOneAlertTrigger_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['String']>;
  gte?: InputMaybe<Scalars['String']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  lt?: InputMaybe<Scalars['String']>;
  lte?: InputMaybe<Scalars['String']>;
  ne?: InputMaybe<Scalars['String']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']>;
};

export type FilterFindOneAlertTypeInput = {
  id?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
};

export type FilterFindOneAlertUnitIdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['String']>;
  gte?: InputMaybe<Scalars['String']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  lt?: InputMaybe<Scalars['String']>;
  lte?: InputMaybe<Scalars['String']>;
  ne?: InputMaybe<Scalars['String']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']>;
};

export type FilterFindOneAlertUnitInput = {
  id?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
};

export type FilterFindOneAlertUnitOperatorsInput = {
  id?: InputMaybe<FilterFindOneAlertUnitIdOperatorsInput>;
};

export type FilterFindOneAlertZoneInput = {
  id?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
};

export type FilterFindOneAlert_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['String']>;
  gte?: InputMaybe<Scalars['String']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  lt?: InputMaybe<Scalars['String']>;
  lte?: InputMaybe<Scalars['String']>;
  ne?: InputMaybe<Scalars['String']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']>;
};

export type FilterFindOneAuthenticationProfileFactorsInput = {
  _id?: InputMaybe<Scalars['String']>;
  credentialBoundTo?: InputMaybe<Scalars['String']>;
  engine?: InputMaybe<EnumAuthenticationProfileFactorsEngine>;
  externalId?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  order?: InputMaybe<Scalars['Float']>;
  preferred?: InputMaybe<Scalars['Boolean']>;
  primary?: InputMaybe<Scalars['Boolean']>;
  sufficient?: InputMaybe<Scalars['Boolean']>;
  type?: InputMaybe<EnumAuthenticationProfileFactorsType>;
  value?: InputMaybe<Scalars['String']>;
};

export type FilterFindOneAuthenticationProfileInitialFactorsInput = {
  _id?: InputMaybe<Scalars['String']>;
  autoSatisfy?: InputMaybe<Scalars['Boolean']>;
  credentialBoundTo?: InputMaybe<Scalars['String']>;
  endpointId?: InputMaybe<Scalars['String']>;
  engine?: InputMaybe<EnumAuthenticationProfileInitialFactorsEngine>;
  expiration?: InputMaybe<Scalars['Float']>;
  factorId?: InputMaybe<Scalars['String']>;
};

export type FilterFindOneAuthenticationProfileInput = {
  AND?: InputMaybe<Array<FilterFindOneAuthenticationProfileInput>>;
  OR?: InputMaybe<Array<FilterFindOneAuthenticationProfileInput>>;
  _id?: InputMaybe<Scalars['String']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterFindOneAuthenticationProfileOperatorsInput>;
  currentChallenge?: InputMaybe<Scalars['String']>;
  currentChallengeExpiresAt?: InputMaybe<Scalars['Float']>;
  externalId?: InputMaybe<Scalars['String']>;
  factors?: InputMaybe<
    Array<InputMaybe<FilterFindOneAuthenticationProfileFactorsInput>>
  >;
  failedAttempts?: InputMaybe<Scalars['Float']>;
  initialFactors?: InputMaybe<
    Array<InputMaybe<FilterFindOneAuthenticationProfileInitialFactorsInput>>
  >;
  lastFailedLogin?: InputMaybe<Scalars['Float']>;
  lastLogin?: InputMaybe<Scalars['Float']>;
  lockedAt?: InputMaybe<Scalars['Float']>;
  userId?: InputMaybe<Scalars['String']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterFindOneAuthenticationProfileOperatorsInput = {
  _id?: InputMaybe<FilterFindOneAuthenticationProfile_IdOperatorsInput>;
};

export type FilterFindOneAuthenticationProfile_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['String']>;
  gte?: InputMaybe<Scalars['String']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  lt?: InputMaybe<Scalars['String']>;
  lte?: InputMaybe<Scalars['String']>;
  ne?: InputMaybe<Scalars['String']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']>;
};

export type FilterFindOneAuthenticatorDeviceInput = {
  AND?: InputMaybe<Array<FilterFindOneAuthenticatorDeviceInput>>;
  OR?: InputMaybe<Array<FilterFindOneAuthenticatorDeviceInput>>;
  _id?: InputMaybe<Scalars['String']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterFindOneAuthenticatorDeviceOperatorsInput>;
  aaguid?: InputMaybe<Scalars['String']>;
  counter?: InputMaybe<Scalars['Float']>;
  createdAt?: InputMaybe<Scalars['Float']>;
  credentialBackedUp?: InputMaybe<Scalars['Boolean']>;
  credentialBoundTo?: InputMaybe<Scalars['String']>;
  credentialDeviceType?: InputMaybe<Scalars['String']>;
  credentialEcosystem?: InputMaybe<EnumAuthenticatorDeviceCredentialEcosystem>;
  credentialID?: InputMaybe<Scalars['Buffer']>;
  credentialIsExternal?: InputMaybe<Scalars['Boolean']>;
  credentialOS?: InputMaybe<EnumAuthenticatorDeviceCredentialOs>;
  credentialPublicKey?: InputMaybe<Scalars['Buffer']>;
  credentialType?: InputMaybe<Scalars['String']>;
  deviceName?: InputMaybe<Scalars['String']>;
  deviceType?: InputMaybe<Scalars['String']>;
  endpointId?: InputMaybe<Scalars['String']>;
  enforceUserVerification?: InputMaybe<Scalars['Boolean']>;
  lastUsed?: InputMaybe<Scalars['Float']>;
  transports?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  userId?: InputMaybe<Scalars['String']>;
  userVerified?: InputMaybe<Scalars['Boolean']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterFindOneAuthenticatorDeviceOperatorsInput = {
  _id?: InputMaybe<FilterFindOneAuthenticatorDevice_IdOperatorsInput>;
  userId?: InputMaybe<FilterFindOneAuthenticatorDeviceUserIdOperatorsInput>;
};

export type FilterFindOneAuthenticatorDeviceUserIdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['String']>;
  gte?: InputMaybe<Scalars['String']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  lt?: InputMaybe<Scalars['String']>;
  lte?: InputMaybe<Scalars['String']>;
  ne?: InputMaybe<Scalars['String']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']>;
};

export type FilterFindOneAuthenticatorDevice_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['String']>;
  gte?: InputMaybe<Scalars['String']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  lt?: InputMaybe<Scalars['String']>;
  lte?: InputMaybe<Scalars['String']>;
  ne?: InputMaybe<Scalars['String']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']>;
};

export type FilterFindOneAuthorizationProfileInput = {
  AND?: InputMaybe<Array<FilterFindOneAuthorizationProfileInput>>;
  OR?: InputMaybe<Array<FilterFindOneAuthorizationProfileInput>>;
  _id?: InputMaybe<Scalars['String']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterFindOneAuthorizationProfileOperatorsInput>;
  apiToken?: InputMaybe<Scalars['String']>;
  currentChallenge?: InputMaybe<Scalars['String']>;
  currentChallengeExpiration?: InputMaybe<Scalars['Float']>;
  installerProperties?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  isInstaller?: InputMaybe<Scalars['Boolean']>;
  isManager?: InputMaybe<Scalars['Boolean']>;
  isResident?: InputMaybe<Scalars['Boolean']>;
  isSuper?: InputMaybe<Scalars['Boolean']>;
  isViewer?: InputMaybe<Scalars['Boolean']>;
  managerProperties?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  name?: InputMaybe<Scalars['String']>;
  residentProperty?: InputMaybe<Scalars['String']>;
  residentUnit?: InputMaybe<Scalars['String']>;
  userId?: InputMaybe<Scalars['String']>;
  viewerProperties?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterFindOneAuthorizationProfileOperatorsInput = {
  _id?: InputMaybe<FilterFindOneAuthorizationProfile_IdOperatorsInput>;
};

export type FilterFindOneAuthorizationProfile_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['String']>;
  gte?: InputMaybe<Scalars['String']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  lt?: InputMaybe<Scalars['String']>;
  lte?: InputMaybe<Scalars['String']>;
  ne?: InputMaybe<Scalars['String']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']>;
};

export type FilterFindOneBngInput = {
  AND?: InputMaybe<Array<FilterFindOneSourceInput>>;
  OR?: InputMaybe<Array<FilterFindOneSourceInput>>;
  _id?: InputMaybe<Scalars['String']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterFindOneSourceOperatorsInput>;
  localUrl?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  propertyId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  url?: InputMaybe<Scalars['String']>;
};

export type FilterFindOneBatteryManagementSystemBatteryEfficiencyInput = {
  id?: InputMaybe<Scalars['String']>;
  observedAt?: InputMaybe<Scalars['Float']>;
  previousId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  units?: InputMaybe<Scalars['String']>;
  updatePending?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<Scalars['Float']>;
};

export type FilterFindOneBatteryManagementSystemCellCurrentsInput = {
  id?: InputMaybe<Scalars['String']>;
  observedAt?: InputMaybe<Scalars['Float']>;
  previousId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  units?: InputMaybe<Scalars['String']>;
  updatePending?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<Scalars['Float']>;
};

export type FilterFindOneBatteryManagementSystemCellCycleCountsInput = {
  id?: InputMaybe<Scalars['String']>;
  observedAt?: InputMaybe<Scalars['Float']>;
  previousId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  units?: InputMaybe<Scalars['String']>;
  updatePending?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<Scalars['Float']>;
};

export type FilterFindOneBatteryManagementSystemCellTemperaturesInput = {
  id?: InputMaybe<Scalars['String']>;
  observedAt?: InputMaybe<Scalars['Float']>;
  previousId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  units?: InputMaybe<Scalars['String']>;
  updatePending?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<Scalars['Float']>;
};

export type FilterFindOneBatteryManagementSystemCellVoltagesInput = {
  id?: InputMaybe<Scalars['String']>;
  observedAt?: InputMaybe<Scalars['Float']>;
  previousId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  units?: InputMaybe<Scalars['String']>;
  updatePending?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<Scalars['Float']>;
};

export type FilterFindOneBatteryManagementSystemCurrentInput = {
  id?: InputMaybe<Scalars['String']>;
  observedAt?: InputMaybe<Scalars['Float']>;
  previousId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  units?: InputMaybe<Scalars['String']>;
  updatePending?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<Scalars['Float']>;
};

export type FilterFindOneBatteryManagementSystemInput = {
  AND?: InputMaybe<Array<FilterFindOneDeviceInput>>;
  OR?: InputMaybe<Array<FilterFindOneDeviceInput>>;
  _id?: InputMaybe<Scalars['String']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterFindOneDeviceOperatorsInput>;
  alertTypes?: InputMaybe<FilterFindOneDeviceAlertTypesInput>;
  batteryEfficiency?: InputMaybe<FilterFindOneBatteryManagementSystemBatteryEfficiencyInput>;
  cellCurrents?: InputMaybe<
    Array<InputMaybe<FilterFindOneBatteryManagementSystemCellCurrentsInput>>
  >;
  cellCycleCounts?: InputMaybe<
    Array<InputMaybe<FilterFindOneBatteryManagementSystemCellCycleCountsInput>>
  >;
  cellTemperatures?: InputMaybe<
    Array<InputMaybe<FilterFindOneBatteryManagementSystemCellTemperaturesInput>>
  >;
  cellVoltages?: InputMaybe<
    Array<InputMaybe<FilterFindOneBatteryManagementSystemCellVoltagesInput>>
  >;
  controlled?: InputMaybe<FilterFindOneDeviceControlledInput>;
  current?: InputMaybe<FilterFindOneBatteryManagementSystemCurrentInput>;
  deviceId?: InputMaybe<Scalars['String']>;
  installation?: InputMaybe<FilterFindOneDeviceInstallationInput>;
  inverterId?: InputMaybe<Scalars['String']>;
  location?: InputMaybe<Scalars['String']>;
  meta?: InputMaybe<FilterFindOneDeviceMetaInput>;
  /** The name of the device */
  name?: InputMaybe<Scalars['String']>;
  panelId?: InputMaybe<Scalars['String']>;
  powerState?: InputMaybe<FilterFindOneDevicePowerStateInput>;
  propertyId?: InputMaybe<Scalars['String']>;
  sourceId?: InputMaybe<Scalars['String']>;
  stateOfCharge?: InputMaybe<FilterFindOneBatteryManagementSystemStateOfChargeInput>;
  stateOfHealth?: InputMaybe<FilterFindOneBatteryManagementSystemStateOfHealthInput>;
  temperature?: InputMaybe<FilterFindOneBatteryManagementSystemTemperatureInput>;
  timestamp?: InputMaybe<Scalars['Float']>;
  unitId?: InputMaybe<Scalars['String']>;
  updateStatus?: InputMaybe<Scalars['Boolean']>;
  voltage?: InputMaybe<FilterFindOneBatteryManagementSystemVoltageInput>;
  vppId?: InputMaybe<Scalars['String']>;
  zoneId?: InputMaybe<Scalars['String']>;
};

export type FilterFindOneBatteryManagementSystemStateOfChargeInput = {
  id?: InputMaybe<Scalars['String']>;
  observedAt?: InputMaybe<Scalars['Float']>;
  previousId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  units?: InputMaybe<Scalars['String']>;
  updatePending?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<Scalars['Float']>;
};

export type FilterFindOneBatteryManagementSystemStateOfHealthInput = {
  id?: InputMaybe<Scalars['String']>;
  observedAt?: InputMaybe<Scalars['Float']>;
  previousId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  units?: InputMaybe<Scalars['String']>;
  updatePending?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<Scalars['Float']>;
};

export type FilterFindOneBatteryManagementSystemTemperatureInput = {
  id?: InputMaybe<Scalars['String']>;
  observedAt?: InputMaybe<Scalars['Float']>;
  previousId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  units?: InputMaybe<Scalars['String']>;
  updatePending?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<Scalars['Float']>;
};

export type FilterFindOneBatteryManagementSystemVoltageInput = {
  id?: InputMaybe<Scalars['String']>;
  observedAt?: InputMaybe<Scalars['Float']>;
  previousId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  units?: InputMaybe<Scalars['String']>;
  updatePending?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<Scalars['Float']>;
};

export type FilterFindOneBoilerBoilerPumpSpeed1Input = {
  id?: InputMaybe<Scalars['String']>;
  observedAt?: InputMaybe<Scalars['Float']>;
  previousId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  units?: InputMaybe<Scalars['String']>;
  updatePending?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<Scalars['Float']>;
};

export type FilterFindOneBoilerBoilerPumpSpeed2Input = {
  id?: InputMaybe<Scalars['String']>;
  observedAt?: InputMaybe<Scalars['Float']>;
  previousId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  units?: InputMaybe<Scalars['String']>;
  updatePending?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<Scalars['Float']>;
};

export type FilterFindOneBoilerBoilerPumpSpeedInput = {
  id?: InputMaybe<Scalars['String']>;
  observedAt?: InputMaybe<Scalars['Float']>;
  previousId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  units?: InputMaybe<Scalars['String']>;
  updatePending?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<Scalars['Float']>;
};

export type FilterFindOneBoilerFiringRate1Input = {
  id?: InputMaybe<Scalars['String']>;
  observedAt?: InputMaybe<Scalars['Float']>;
  previousId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  units?: InputMaybe<Scalars['String']>;
  updatePending?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<Scalars['Float']>;
};

export type FilterFindOneBoilerFiringRate2Input = {
  id?: InputMaybe<Scalars['String']>;
  observedAt?: InputMaybe<Scalars['Float']>;
  previousId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  units?: InputMaybe<Scalars['String']>;
  updatePending?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<Scalars['Float']>;
};

export type FilterFindOneBoilerFiringRateInput = {
  id?: InputMaybe<Scalars['String']>;
  observedAt?: InputMaybe<Scalars['Float']>;
  previousId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  units?: InputMaybe<Scalars['String']>;
  updatePending?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<Scalars['Float']>;
};

export type FilterFindOneBoilerFlueTemperature1Input = {
  id?: InputMaybe<Scalars['String']>;
  observedAt?: InputMaybe<Scalars['Float']>;
  previousId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  units?: InputMaybe<Scalars['String']>;
  updatePending?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<Scalars['Float']>;
};

export type FilterFindOneBoilerFlueTemperature2Input = {
  id?: InputMaybe<Scalars['String']>;
  observedAt?: InputMaybe<Scalars['Float']>;
  previousId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  units?: InputMaybe<Scalars['String']>;
  updatePending?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<Scalars['Float']>;
};

export type FilterFindOneBoilerFlueTemperatureInput = {
  id?: InputMaybe<Scalars['String']>;
  observedAt?: InputMaybe<Scalars['Float']>;
  previousId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  units?: InputMaybe<Scalars['String']>;
  updatePending?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<Scalars['Float']>;
};

export type FilterFindOneBoilerInletTemperature1Input = {
  id?: InputMaybe<Scalars['String']>;
  observedAt?: InputMaybe<Scalars['Float']>;
  previousId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  units?: InputMaybe<Scalars['String']>;
  updatePending?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<Scalars['Float']>;
};

export type FilterFindOneBoilerInletTemperature2Input = {
  id?: InputMaybe<Scalars['String']>;
  observedAt?: InputMaybe<Scalars['Float']>;
  previousId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  units?: InputMaybe<Scalars['String']>;
  updatePending?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<Scalars['Float']>;
};

export type FilterFindOneBoilerInletTemperatureInput = {
  id?: InputMaybe<Scalars['String']>;
  observedAt?: InputMaybe<Scalars['Float']>;
  previousId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  units?: InputMaybe<Scalars['String']>;
  updatePending?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<Scalars['Float']>;
};

export type FilterFindOneBoilerInput = {
  AND?: InputMaybe<Array<FilterFindOneDeviceInput>>;
  OR?: InputMaybe<Array<FilterFindOneDeviceInput>>;
  _id?: InputMaybe<Scalars['String']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterFindOneDeviceOperatorsInput>;
  alertTypes?: InputMaybe<FilterFindOneDeviceAlertTypesInput>;
  boilerPumpSpeed?: InputMaybe<FilterFindOneBoilerBoilerPumpSpeedInput>;
  boilerPumpSpeed1?: InputMaybe<FilterFindOneBoilerBoilerPumpSpeed1Input>;
  boilerPumpSpeed2?: InputMaybe<FilterFindOneBoilerBoilerPumpSpeed2Input>;
  controlled?: InputMaybe<FilterFindOneDeviceControlledInput>;
  deviceId?: InputMaybe<Scalars['String']>;
  firingRate?: InputMaybe<FilterFindOneBoilerFiringRateInput>;
  firingRate1?: InputMaybe<FilterFindOneBoilerFiringRate1Input>;
  firingRate2?: InputMaybe<FilterFindOneBoilerFiringRate2Input>;
  flueTemperature?: InputMaybe<FilterFindOneBoilerFlueTemperatureInput>;
  flueTemperature1?: InputMaybe<FilterFindOneBoilerFlueTemperature1Input>;
  flueTemperature2?: InputMaybe<FilterFindOneBoilerFlueTemperature2Input>;
  inletTemperature?: InputMaybe<FilterFindOneBoilerInletTemperatureInput>;
  inletTemperature1?: InputMaybe<FilterFindOneBoilerInletTemperature1Input>;
  inletTemperature2?: InputMaybe<FilterFindOneBoilerInletTemperature2Input>;
  installation?: InputMaybe<FilterFindOneDeviceInstallationInput>;
  location?: InputMaybe<Scalars['String']>;
  meta?: InputMaybe<FilterFindOneDeviceMetaInput>;
  /** The name of the device */
  name?: InputMaybe<Scalars['String']>;
  outletTemperature?: InputMaybe<FilterFindOneBoilerOutletTemperatureInput>;
  outletTemperature1?: InputMaybe<FilterFindOneBoilerOutletTemperature1Input>;
  outletTemperature2?: InputMaybe<FilterFindOneBoilerOutletTemperature2Input>;
  panelId?: InputMaybe<Scalars['String']>;
  powerState?: InputMaybe<FilterFindOneDevicePowerStateInput>;
  propertyId?: InputMaybe<Scalars['String']>;
  role?: InputMaybe<Scalars['String']>;
  sourceId?: InputMaybe<Scalars['String']>;
  temperature?: InputMaybe<FilterFindOneBoilerTemperatureInput>;
  timestamp?: InputMaybe<Scalars['Float']>;
  unitId?: InputMaybe<Scalars['String']>;
  updateStatus?: InputMaybe<Scalars['Boolean']>;
  vppId?: InputMaybe<Scalars['String']>;
  zoneId?: InputMaybe<Scalars['String']>;
};

export type FilterFindOneBoilerOutletTemperature1Input = {
  id?: InputMaybe<Scalars['String']>;
  observedAt?: InputMaybe<Scalars['Float']>;
  previousId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  units?: InputMaybe<Scalars['String']>;
  updatePending?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<Scalars['Float']>;
};

export type FilterFindOneBoilerOutletTemperature2Input = {
  id?: InputMaybe<Scalars['String']>;
  observedAt?: InputMaybe<Scalars['Float']>;
  previousId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  units?: InputMaybe<Scalars['String']>;
  updatePending?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<Scalars['Float']>;
};

export type FilterFindOneBoilerOutletTemperatureInput = {
  id?: InputMaybe<Scalars['String']>;
  observedAt?: InputMaybe<Scalars['Float']>;
  previousId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  units?: InputMaybe<Scalars['String']>;
  updatePending?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<Scalars['Float']>;
};

export type FilterFindOneBoilerTemperatureInput = {
  id?: InputMaybe<Scalars['String']>;
  observedAt?: InputMaybe<Scalars['Float']>;
  previousId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  units?: InputMaybe<Scalars['String']>;
  updatePending?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<Scalars['Float']>;
};

export type FilterFindOneBuildingInput = {
  AND?: InputMaybe<Array<FilterFindOneBuildingInput>>;
  OR?: InputMaybe<Array<FilterFindOneBuildingInput>>;
  _id?: InputMaybe<Scalars['String']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterFindOneBuildingOperatorsInput>;
  name?: InputMaybe<Scalars['String']>;
  number?: InputMaybe<Scalars['Float']>;
  propertyId?: InputMaybe<Scalars['String']>;
};

export type FilterFindOneBuildingNameOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['String']>;
  gte?: InputMaybe<Scalars['String']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  lt?: InputMaybe<Scalars['String']>;
  lte?: InputMaybe<Scalars['String']>;
  ne?: InputMaybe<Scalars['String']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterFindOneBuildingOperatorsInput = {
  _id?: InputMaybe<FilterFindOneBuilding_IdOperatorsInput>;
  name?: InputMaybe<FilterFindOneBuildingNameOperatorsInput>;
};

export type FilterFindOneBuilding_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['String']>;
  gte?: InputMaybe<Scalars['String']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  lt?: InputMaybe<Scalars['String']>;
  lte?: InputMaybe<Scalars['String']>;
  ne?: InputMaybe<Scalars['String']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']>;
};

export type FilterFindOneChillerAmbientTemperatureInput = {
  id?: InputMaybe<Scalars['String']>;
  observedAt?: InputMaybe<Scalars['Float']>;
  previousId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  units?: InputMaybe<Scalars['String']>;
  updatePending?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<Scalars['Float']>;
};

export type FilterFindOneChillerChilledReturnTemperatureInput = {
  id?: InputMaybe<Scalars['String']>;
  observedAt?: InputMaybe<Scalars['Float']>;
  previousId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  units?: InputMaybe<Scalars['String']>;
  updatePending?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<Scalars['Float']>;
};

export type FilterFindOneChillerChilledSupplyTemperatureInput = {
  id?: InputMaybe<Scalars['String']>;
  observedAt?: InputMaybe<Scalars['Float']>;
  previousId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  units?: InputMaybe<Scalars['String']>;
  updatePending?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<Scalars['Float']>;
};

export type FilterFindOneChillerCoolSetpointInput = {
  id?: InputMaybe<Scalars['String']>;
  observedAt?: InputMaybe<Scalars['Float']>;
  previousId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  units?: InputMaybe<Scalars['String']>;
  updatePending?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<Scalars['Float']>;
};

export type FilterFindOneChillerInput = {
  AND?: InputMaybe<Array<FilterFindOneDeviceInput>>;
  OR?: InputMaybe<Array<FilterFindOneDeviceInput>>;
  _id?: InputMaybe<Scalars['String']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterFindOneDeviceOperatorsInput>;
  alertTypes?: InputMaybe<FilterFindOneDeviceAlertTypesInput>;
  ambientTemperature?: InputMaybe<FilterFindOneChillerAmbientTemperatureInput>;
  chilledReturnTemperature?: InputMaybe<FilterFindOneChillerChilledReturnTemperatureInput>;
  chilledSupplyTemperature?: InputMaybe<FilterFindOneChillerChilledSupplyTemperatureInput>;
  controlled?: InputMaybe<FilterFindOneDeviceControlledInput>;
  coolSetpoint?: InputMaybe<FilterFindOneChillerCoolSetpointInput>;
  deviceId?: InputMaybe<Scalars['String']>;
  installation?: InputMaybe<FilterFindOneDeviceInstallationInput>;
  location?: InputMaybe<Scalars['String']>;
  meta?: InputMaybe<FilterFindOneDeviceMetaInput>;
  /** The name of the device */
  name?: InputMaybe<Scalars['String']>;
  panelId?: InputMaybe<Scalars['String']>;
  powerState?: InputMaybe<FilterFindOneDevicePowerStateInput>;
  propertyId?: InputMaybe<Scalars['String']>;
  sourceId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  unitId?: InputMaybe<Scalars['String']>;
  updateStatus?: InputMaybe<Scalars['Boolean']>;
  vppId?: InputMaybe<Scalars['String']>;
  zoneId?: InputMaybe<Scalars['String']>;
};

export type FilterFindOneConductorGenericSensorAlarmStateInput = {
  id?: InputMaybe<Scalars['String']>;
  observedAt?: InputMaybe<Scalars['Float']>;
  previousId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  units?: InputMaybe<Scalars['String']>;
  updatePending?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<Scalars['Boolean']>;
};

export type FilterFindOneConductorGenericSensorCounterValueInput = {
  id?: InputMaybe<Scalars['String']>;
  observedAt?: InputMaybe<Scalars['Float']>;
  previousId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  units?: InputMaybe<Scalars['String']>;
  updatePending?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<Scalars['Float']>;
};

export type FilterFindOneConductorGenericSensorFanSpeedInput = {
  id?: InputMaybe<Scalars['String']>;
  observedAt?: InputMaybe<Scalars['Float']>;
  previousId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  units?: InputMaybe<Scalars['String']>;
  updatePending?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<Scalars['Float']>;
};

export type FilterFindOneConductorGenericSensorHumidityInput = {
  id?: InputMaybe<Scalars['String']>;
  observedAt?: InputMaybe<Scalars['Float']>;
  previousId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  units?: InputMaybe<Scalars['String']>;
  updatePending?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<Scalars['Float']>;
};

export type FilterFindOneConductorGenericSensorInput = {
  AND?: InputMaybe<Array<FilterFindOneDeviceInput>>;
  OR?: InputMaybe<Array<FilterFindOneDeviceInput>>;
  _id?: InputMaybe<Scalars['String']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterFindOneDeviceOperatorsInput>;
  alarmState?: InputMaybe<FilterFindOneConductorGenericSensorAlarmStateInput>;
  alertTypes?: InputMaybe<FilterFindOneDeviceAlertTypesInput>;
  controlled?: InputMaybe<FilterFindOneDeviceControlledInput>;
  counterValue?: InputMaybe<FilterFindOneConductorGenericSensorCounterValueInput>;
  deviceId?: InputMaybe<Scalars['String']>;
  fanSpeed?: InputMaybe<FilterFindOneConductorGenericSensorFanSpeedInput>;
  humidity?: InputMaybe<FilterFindOneConductorGenericSensorHumidityInput>;
  installation?: InputMaybe<FilterFindOneDeviceInstallationInput>;
  location?: InputMaybe<Scalars['String']>;
  meta?: InputMaybe<FilterFindOneDeviceMetaInput>;
  /** The name of the device */
  name?: InputMaybe<Scalars['String']>;
  panelId?: InputMaybe<Scalars['String']>;
  powerState?: InputMaybe<FilterFindOneDevicePowerStateInput>;
  propertyId?: InputMaybe<Scalars['String']>;
  resetCount?: InputMaybe<FilterFindOneConductorGenericSensorResetCountInput>;
  setpoint?: InputMaybe<FilterFindOneConductorGenericSensorSetpointInput>;
  sourceId?: InputMaybe<Scalars['String']>;
  systemMode?: InputMaybe<FilterFindOneConductorGenericSensorSystemModeInput>;
  temperature?: InputMaybe<FilterFindOneConductorGenericSensorTemperatureInput>;
  timestamp?: InputMaybe<Scalars['Float']>;
  unitId?: InputMaybe<Scalars['String']>;
  updateStatus?: InputMaybe<Scalars['Boolean']>;
  vppId?: InputMaybe<Scalars['String']>;
  zoneId?: InputMaybe<Scalars['String']>;
};

export type FilterFindOneConductorGenericSensorResetCountInput = {
  id?: InputMaybe<Scalars['String']>;
  observedAt?: InputMaybe<Scalars['Float']>;
  previousId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  units?: InputMaybe<Scalars['String']>;
  updatePending?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<Scalars['Float']>;
};

export type FilterFindOneConductorGenericSensorSetpointInput = {
  id?: InputMaybe<Scalars['String']>;
  observedAt?: InputMaybe<Scalars['Float']>;
  previousId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  units?: InputMaybe<Scalars['String']>;
  updatePending?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<Scalars['Float']>;
};

export type FilterFindOneConductorGenericSensorSystemModeInput = {
  id?: InputMaybe<Scalars['String']>;
  observedAt?: InputMaybe<Scalars['Float']>;
  previousId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  units?: InputMaybe<Scalars['String']>;
  updatePending?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<Scalars['Float']>;
};

export type FilterFindOneConductorGenericSensorTemperatureInput = {
  id?: InputMaybe<Scalars['String']>;
  observedAt?: InputMaybe<Scalars['Float']>;
  previousId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  units?: InputMaybe<Scalars['String']>;
  updatePending?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<Scalars['Float']>;
};

export type FilterFindOneConductorInput = {
  AND?: InputMaybe<Array<FilterFindOneSourceInput>>;
  OR?: InputMaybe<Array<FilterFindOneSourceInput>>;
  _id?: InputMaybe<Scalars['String']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterFindOneSourceOperatorsInput>;
  buildingId?: InputMaybe<Scalars['String']>;
  conductorUniqueId?: InputMaybe<Scalars['String']>;
  lastDiscoveryMappingProposal?: InputMaybe<Scalars['JSON']>;
  lastDiscoveryResults?: InputMaybe<Scalars['JSON']>;
  lastDiscoveryResultsUrl?: InputMaybe<Scalars['String']>;
  lastDiscoveryRunId?: InputMaybe<Scalars['String']>;
  lastDiscoveryStatus?: InputMaybe<Scalars['String']>;
  lastDiscoveryStatusUrl?: InputMaybe<Scalars['String']>;
  maxReportingTime?: InputMaybe<Scalars['Float']>;
  name?: InputMaybe<Scalars['String']>;
  propertyId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  tolerances?: InputMaybe<FilterFindOneConductorTolerancesInput>;
  url?: InputMaybe<Scalars['String']>;
};

export type FilterFindOneConductorTolerancesInput = {
  humidity?: InputMaybe<Scalars['Float']>;
  temperature?: InputMaybe<Scalars['Float']>;
};

export type FilterFindOneControlGroupGroupedDevicesInput = {
  _id?: InputMaybe<Scalars['String']>;
  deviceId?: InputMaybe<Scalars['String']>;
  displayOrder?: InputMaybe<Scalars['Float']>;
  name?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<Scalars['String']>;
};

export type FilterFindOneControlGroupInput = {
  AND?: InputMaybe<Array<FilterFindOneControlGroupInput>>;
  OR?: InputMaybe<Array<FilterFindOneControlGroupInput>>;
  _id?: InputMaybe<Scalars['String']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterFindOneControlGroupOperatorsInput>;
  attributes?: InputMaybe<Scalars['JSON']>;
  automationEnabled?: InputMaybe<Scalars['Boolean']>;
  groupedDevices?: InputMaybe<
    Array<InputMaybe<FilterFindOneControlGroupGroupedDevicesInput>>
  >;
  masterDeviceId?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  propertyId?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<Scalars['String']>;
  unitId?: InputMaybe<Scalars['String']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterFindOneControlGroupOperatorsInput = {
  _id?: InputMaybe<FilterFindOneControlGroup_IdOperatorsInput>;
  propertyId?: InputMaybe<FilterFindOneControlGroupPropertyIdOperatorsInput>;
  unitId?: InputMaybe<FilterFindOneControlGroupUnitIdOperatorsInput>;
};

export type FilterFindOneControlGroupPropertyIdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['String']>;
  gte?: InputMaybe<Scalars['String']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  lt?: InputMaybe<Scalars['String']>;
  lte?: InputMaybe<Scalars['String']>;
  ne?: InputMaybe<Scalars['String']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']>;
};

export type FilterFindOneControlGroupUnitIdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['String']>;
  gte?: InputMaybe<Scalars['String']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  lt?: InputMaybe<Scalars['String']>;
  lte?: InputMaybe<Scalars['String']>;
  ne?: InputMaybe<Scalars['String']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']>;
};

export type FilterFindOneControlGroup_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['String']>;
  gte?: InputMaybe<Scalars['String']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  lt?: InputMaybe<Scalars['String']>;
  lte?: InputMaybe<Scalars['String']>;
  ne?: InputMaybe<Scalars['String']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']>;
};

export type FilterFindOneControllerActiveAlarmCountInput = {
  id?: InputMaybe<Scalars['String']>;
  observedAt?: InputMaybe<Scalars['Float']>;
  previousId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  units?: InputMaybe<Scalars['String']>;
  updatePending?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<Scalars['Float']>;
};

export type FilterFindOneControllerCommunicationStateInput = {
  id?: InputMaybe<Scalars['String']>;
  observedAt?: InputMaybe<Scalars['Float']>;
  previousId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  units?: InputMaybe<Scalars['String']>;
  updatePending?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<Scalars['Boolean']>;
};

export type FilterFindOneControllerController_LoopInput = {
  id?: InputMaybe<Scalars['String']>;
  observedAt?: InputMaybe<Scalars['Float']>;
  previousId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  units?: InputMaybe<Scalars['String']>;
  updatePending?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<EnumControllerController_LoopValue>;
};

export type FilterFindOneControllerInput = {
  AND?: InputMaybe<Array<FilterFindOneDeviceInput>>;
  OR?: InputMaybe<Array<FilterFindOneDeviceInput>>;
  _id?: InputMaybe<Scalars['String']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterFindOneDeviceOperatorsInput>;
  activeAlarmCount?: InputMaybe<FilterFindOneControllerActiveAlarmCountInput>;
  alertTypes?: InputMaybe<FilterFindOneDeviceAlertTypesInput>;
  communicationState?: InputMaybe<FilterFindOneControllerCommunicationStateInput>;
  controlled?: InputMaybe<FilterFindOneDeviceControlledInput>;
  controller_loop?: InputMaybe<FilterFindOneControllerController_LoopInput>;
  deviceId?: InputMaybe<Scalars['String']>;
  installation?: InputMaybe<FilterFindOneDeviceInstallationInput>;
  location?: InputMaybe<Scalars['String']>;
  meta?: InputMaybe<FilterFindOneDeviceMetaInput>;
  /** The name of the device */
  name?: InputMaybe<Scalars['String']>;
  panelId?: InputMaybe<Scalars['String']>;
  powerState?: InputMaybe<FilterFindOneDevicePowerStateInput>;
  propertyId?: InputMaybe<Scalars['String']>;
  resetCount?: InputMaybe<FilterFindOneControllerResetCountInput>;
  sourceId?: InputMaybe<Scalars['String']>;
  supervisor_controller?: InputMaybe<FilterFindOneControllerSupervisor_ControllerInput>;
  timestamp?: InputMaybe<Scalars['Float']>;
  unitId?: InputMaybe<Scalars['String']>;
  updateStatus?: InputMaybe<Scalars['Boolean']>;
  vppId?: InputMaybe<Scalars['String']>;
  zoneId?: InputMaybe<Scalars['String']>;
};

export type FilterFindOneControllerResetCountInput = {
  id?: InputMaybe<Scalars['String']>;
  observedAt?: InputMaybe<Scalars['Float']>;
  previousId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  units?: InputMaybe<Scalars['String']>;
  updatePending?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<Scalars['Float']>;
};

export type FilterFindOneControllerSupervisor_ControllerInput = {
  id?: InputMaybe<Scalars['String']>;
  observedAt?: InputMaybe<Scalars['Float']>;
  previousId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  units?: InputMaybe<Scalars['String']>;
  updatePending?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<EnumControllerSupervisor_ControllerValue>;
};

export type FilterFindOneCoreInput = {
  AND?: InputMaybe<Array<FilterFindOneSourceInput>>;
  OR?: InputMaybe<Array<FilterFindOneSourceInput>>;
  _id?: InputMaybe<Scalars['String']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterFindOneSourceOperatorsInput>;
  maxReportingTime?: InputMaybe<Scalars['Float']>;
  name?: InputMaybe<Scalars['String']>;
  propertyId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  tolerances?: InputMaybe<FilterFindOneCoreTolerancesInput>;
  url?: InputMaybe<Scalars['String']>;
};

export type FilterFindOneCoreTolerancesInput = {
  humidity?: InputMaybe<Scalars['Float']>;
  temperature?: InputMaybe<Scalars['Float']>;
  voltage?: InputMaybe<Scalars['Float']>;
};

export type FilterFindOneDataExportJobArtifactsInput = {
  _id?: InputMaybe<Scalars['MongoID']>;
  bucket?: InputMaybe<Scalars['String']>;
  contentType?: InputMaybe<Scalars['String']>;
  key?: InputMaybe<Scalars['String']>;
  kind?: InputMaybe<Scalars['String']>;
};

export type FilterFindOneDataExportJobInput = {
  AND?: InputMaybe<Array<FilterFindOneDataExportJobInput>>;
  OR?: InputMaybe<Array<FilterFindOneDataExportJobInput>>;
  _id?: InputMaybe<Scalars['String']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterFindOneDataExportJobOperatorsInput>;
  artifacts?: InputMaybe<
    Array<InputMaybe<FilterFindOneDataExportJobArtifactsInput>>
  >;
  awsTaskArn?: InputMaybe<Scalars['String']>;
  completedAt?: InputMaybe<Scalars['Date']>;
  currentStep?: InputMaybe<Scalars['String']>;
  endDate?: InputMaybe<Scalars['Date']>;
  errorDetails?: InputMaybe<Scalars['String']>;
  errorMessage?: InputMaybe<Scalars['String']>;
  progress?: InputMaybe<Scalars['Float']>;
  propertyId?: InputMaybe<Scalars['String']>;
  propertyTitle?: InputMaybe<Scalars['String']>;
  reportTypes?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  requestedByUserId?: InputMaybe<Scalars['String']>;
  s3Bucket?: InputMaybe<Scalars['String']>;
  s3Key?: InputMaybe<Scalars['String']>;
  startDate?: InputMaybe<Scalars['Date']>;
  startedAt?: InputMaybe<Scalars['Date']>;
  status?: InputMaybe<EnumDataExportJobStatus>;
  submittedAt?: InputMaybe<Scalars['Date']>;
  updatedAt?: InputMaybe<Scalars['Date']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterFindOneDataExportJobOperatorsInput = {
  _id?: InputMaybe<FilterFindOneDataExportJob_IdOperatorsInput>;
  propertyId?: InputMaybe<FilterFindOneDataExportJobPropertyIdOperatorsInput>;
  requestedByUserId?: InputMaybe<FilterFindOneDataExportJobRequestedByUserIdOperatorsInput>;
  status?: InputMaybe<FilterFindOneDataExportJobStatusOperatorsInput>;
};

export type FilterFindOneDataExportJobPropertyIdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['String']>;
  gte?: InputMaybe<Scalars['String']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  lt?: InputMaybe<Scalars['String']>;
  lte?: InputMaybe<Scalars['String']>;
  ne?: InputMaybe<Scalars['String']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']>;
};

export type FilterFindOneDataExportJobRequestedByUserIdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['String']>;
  gte?: InputMaybe<Scalars['String']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  lt?: InputMaybe<Scalars['String']>;
  lte?: InputMaybe<Scalars['String']>;
  ne?: InputMaybe<Scalars['String']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']>;
};

export type FilterFindOneDataExportJobStatusOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<EnumDataExportJobStatus>;
  gte?: InputMaybe<EnumDataExportJobStatus>;
  in?: InputMaybe<Array<InputMaybe<EnumDataExportJobStatus>>>;
  lt?: InputMaybe<EnumDataExportJobStatus>;
  lte?: InputMaybe<EnumDataExportJobStatus>;
  ne?: InputMaybe<EnumDataExportJobStatus>;
  nin?: InputMaybe<Array<InputMaybe<EnumDataExportJobStatus>>>;
};

export type FilterFindOneDataExportJob_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['String']>;
  gte?: InputMaybe<Scalars['String']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  lt?: InputMaybe<Scalars['String']>;
  lte?: InputMaybe<Scalars['String']>;
  ne?: InputMaybe<Scalars['String']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']>;
};

export type FilterFindOneDeviceAlertTypesInput = {
  deviceAlert?: InputMaybe<Scalars['Boolean']>;
  deviceMetric?: InputMaybe<Scalars['Boolean']>;
  deviceOffline?: InputMaybe<Scalars['Boolean']>;
  equipmentAlarm?: InputMaybe<Scalars['Boolean']>;
  sourceOffline?: InputMaybe<Scalars['Boolean']>;
};

export type FilterFindOneDeviceControlledInput = {
  id?: InputMaybe<Scalars['String']>;
  observedAt?: InputMaybe<Scalars['Float']>;
  previousId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  units?: InputMaybe<Scalars['String']>;
  updatePending?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<Scalars['Boolean']>;
};

export type FilterFindOneDeviceInput = {
  AND?: InputMaybe<Array<FilterFindOneDeviceInput>>;
  OR?: InputMaybe<Array<FilterFindOneDeviceInput>>;
  _id?: InputMaybe<Scalars['String']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterFindOneDeviceOperatorsInput>;
  alertTypes?: InputMaybe<FilterFindOneDeviceAlertTypesInput>;
  controlled?: InputMaybe<FilterFindOneDeviceControlledInput>;
  deviceId?: InputMaybe<Scalars['String']>;
  installation?: InputMaybe<FilterFindOneDeviceInstallationInput>;
  location?: InputMaybe<Scalars['String']>;
  meta?: InputMaybe<FilterFindOneDeviceMetaInput>;
  /** The name of the device */
  name?: InputMaybe<Scalars['String']>;
  panelId?: InputMaybe<Scalars['String']>;
  powerState?: InputMaybe<FilterFindOneDevicePowerStateInput>;
  propertyId?: InputMaybe<Scalars['String']>;
  sourceId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  type?: InputMaybe<EnumDKeyDeviceType>;
  unitId?: InputMaybe<Scalars['String']>;
  updateStatus?: InputMaybe<Scalars['Boolean']>;
  vppId?: InputMaybe<Scalars['String']>;
  zoneId?: InputMaybe<Scalars['String']>;
};

export type FilterFindOneDeviceInstallationInput = {
  count?: InputMaybe<Scalars['Float']>;
  message?: InputMaybe<Scalars['String']>;
  paired?: InputMaybe<Scalars['Boolean']>;
  pairedTo?: InputMaybe<Scalars['String']>;
  previousStatus?: InputMaybe<Scalars['String']>;
  rawDeviceId?: InputMaybe<Scalars['String']>;
  replacingDeviceId?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<Scalars['Float']>;
};

export type FilterFindOneDeviceMetaDisplayInput = {
  humidity?: InputMaybe<Scalars['Float']>;
  temperature?: InputMaybe<Scalars['Float']>;
};

export type FilterFindOneDeviceMetaInput = {
  city_id?: InputMaybe<Scalars['String']>;
  display?: InputMaybe<FilterFindOneDeviceMetaDisplayInput>;
  localAddr?: InputMaybe<Scalars['String']>;
  local_addr?: InputMaybe<Scalars['String']>;
  location?: InputMaybe<Scalars['String']>;
  loopType?: InputMaybe<Scalars['String']>;
  manufacturer?: InputMaybe<Scalars['String']>;
  metrics?: InputMaybe<Scalars['JSON']>;
  model?: InputMaybe<Scalars['String']>;
  modelNumber?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  plmActive?: InputMaybe<Scalars['Boolean']>;
  remoteSensorId?: InputMaybe<Scalars['String']>;
  remoteSensorOperating?: InputMaybe<Scalars['Boolean']>;
  serialNumber?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<Scalars['String']>;
  version?: InputMaybe<Scalars['String']>;
};

export type FilterFindOneDeviceNameOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['String']>;
  gte?: InputMaybe<Scalars['String']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  lt?: InputMaybe<Scalars['String']>;
  lte?: InputMaybe<Scalars['String']>;
  ne?: InputMaybe<Scalars['String']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterFindOneDeviceOperatorsInput = {
  _id?: InputMaybe<FilterFindOneDevice_IdOperatorsInput>;
  name?: InputMaybe<FilterFindOneDeviceNameOperatorsInput>;
  propertyId?: InputMaybe<FilterFindOneDevicePropertyIdOperatorsInput>;
  type?: InputMaybe<FilterFindOneDeviceTypeOperatorsInput>;
  unitId?: InputMaybe<FilterFindOneDeviceUnitIdOperatorsInput>;
};

export type FilterFindOneDevicePowerStateInput = {
  id?: InputMaybe<Scalars['String']>;
  observedAt?: InputMaybe<Scalars['Float']>;
  previousId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  units?: InputMaybe<Scalars['String']>;
  updatePending?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<EnumDevicePowerStateValue>;
};

export type FilterFindOneDevicePropertyIdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['String']>;
  gte?: InputMaybe<Scalars['String']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  lt?: InputMaybe<Scalars['String']>;
  lte?: InputMaybe<Scalars['String']>;
  ne?: InputMaybe<Scalars['String']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']>;
};

export type FilterFindOneDeviceReadingDeviceUidOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['String']>;
  gte?: InputMaybe<Scalars['String']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  lt?: InputMaybe<Scalars['String']>;
  lte?: InputMaybe<Scalars['String']>;
  ne?: InputMaybe<Scalars['String']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']>;
};

export type FilterFindOneDeviceReadingInput = {
  AND?: InputMaybe<Array<FilterFindOneDeviceReadingInput>>;
  OR?: InputMaybe<Array<FilterFindOneDeviceReadingInput>>;
  _id?: InputMaybe<Scalars['String']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterFindOneDeviceReadingOperatorsInput>;
  dateTime?: InputMaybe<Scalars['Float']>;
  deviceUid?: InputMaybe<Scalars['String']>;
  measurementType?: InputMaybe<Scalars['String']>;
  series?: InputMaybe<EnumDeviceReadingSeries>;
  sourceId?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<Scalars['Float']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterFindOneDeviceReadingOperatorsInput = {
  _id?: InputMaybe<FilterFindOneDeviceReading_IdOperatorsInput>;
  deviceUid?: InputMaybe<FilterFindOneDeviceReadingDeviceUidOperatorsInput>;
};

export type FilterFindOneDeviceReading_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['String']>;
  gte?: InputMaybe<Scalars['String']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  lt?: InputMaybe<Scalars['String']>;
  lte?: InputMaybe<Scalars['String']>;
  ne?: InputMaybe<Scalars['String']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']>;
};

export type FilterFindOneDeviceTypeOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<EnumDeviceType>;
  gte?: InputMaybe<EnumDeviceType>;
  in?: InputMaybe<Array<InputMaybe<EnumDeviceType>>>;
  lt?: InputMaybe<EnumDeviceType>;
  lte?: InputMaybe<EnumDeviceType>;
  ne?: InputMaybe<EnumDeviceType>;
  nin?: InputMaybe<Array<InputMaybe<EnumDeviceType>>>;
};

export type FilterFindOneDeviceUnitIdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['String']>;
  gte?: InputMaybe<Scalars['String']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  lt?: InputMaybe<Scalars['String']>;
  lte?: InputMaybe<Scalars['String']>;
  ne?: InputMaybe<Scalars['String']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']>;
};

export type FilterFindOneDevice_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['String']>;
  gte?: InputMaybe<Scalars['String']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  lt?: InputMaybe<Scalars['String']>;
  lte?: InputMaybe<Scalars['String']>;
  ne?: InputMaybe<Scalars['String']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']>;
};

export type FilterFindOneDoorSensorContactStateInput = {
  id?: InputMaybe<Scalars['String']>;
  observedAt?: InputMaybe<Scalars['Float']>;
  previousId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  units?: InputMaybe<Scalars['String']>;
  updatePending?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<Scalars['String']>;
};

export type FilterFindOneDoorSensorInput = {
  AND?: InputMaybe<Array<FilterFindOneDeviceInput>>;
  OR?: InputMaybe<Array<FilterFindOneDeviceInput>>;
  _id?: InputMaybe<Scalars['String']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterFindOneDeviceOperatorsInput>;
  alertTypes?: InputMaybe<FilterFindOneDeviceAlertTypesInput>;
  contactState?: InputMaybe<FilterFindOneDoorSensorContactStateInput>;
  controlled?: InputMaybe<FilterFindOneDeviceControlledInput>;
  deviceId?: InputMaybe<Scalars['String']>;
  installation?: InputMaybe<FilterFindOneDeviceInstallationInput>;
  location?: InputMaybe<Scalars['String']>;
  meta?: InputMaybe<FilterFindOneDeviceMetaInput>;
  /** The name of the device */
  name?: InputMaybe<Scalars['String']>;
  panelId?: InputMaybe<Scalars['String']>;
  powerState?: InputMaybe<FilterFindOneDevicePowerStateInput>;
  propertyId?: InputMaybe<Scalars['String']>;
  sourceId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  unitId?: InputMaybe<Scalars['String']>;
  updateStatus?: InputMaybe<Scalars['Boolean']>;
  voltage?: InputMaybe<FilterFindOneDoorSensorVoltageInput>;
  vppId?: InputMaybe<Scalars['String']>;
  zoneId?: InputMaybe<Scalars['String']>;
};

export type FilterFindOneDoorSensorVoltageInput = {
  id?: InputMaybe<Scalars['String']>;
  observedAt?: InputMaybe<Scalars['Float']>;
  previousId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  units?: InputMaybe<Scalars['String']>;
  updatePending?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<Scalars['Float']>;
};

export type FilterFindOneEnergyConsumerBuildingConnectedInput = {
  id?: InputMaybe<Scalars['String']>;
  observedAt?: InputMaybe<Scalars['Float']>;
  previousId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  units?: InputMaybe<Scalars['String']>;
  updatePending?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<Scalars['Boolean']>;
};

export type FilterFindOneEnergyConsumerBuildingDisconnectedAtInput = {
  id?: InputMaybe<Scalars['String']>;
  observedAt?: InputMaybe<Scalars['Float']>;
  previousId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  units?: InputMaybe<Scalars['String']>;
  updatePending?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<Scalars['Float']>;
};

export type FilterFindOneEnergyConsumerBuildingEnergyEfficiencyScoreInput = {
  id?: InputMaybe<Scalars['String']>;
  observedAt?: InputMaybe<Scalars['Float']>;
  previousId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  units?: InputMaybe<Scalars['String']>;
  updatePending?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<Scalars['Float']>;
};

export type FilterFindOneEnergyConsumerBuildingInput = {
  AND?: InputMaybe<Array<FilterFindOneEnergyConsumerBuildingInput>>;
  OR?: InputMaybe<Array<FilterFindOneEnergyConsumerBuildingInput>>;
  _id?: InputMaybe<Scalars['String']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterFindOneEnergyConsumerBuildingOperatorsInput>;
  circuitId?: InputMaybe<Scalars['String']>;
  connected?: InputMaybe<FilterFindOneEnergyConsumerBuildingConnectedInput>;
  converterId?: InputMaybe<Scalars['String']>;
  disconnectedAt?: InputMaybe<FilterFindOneEnergyConsumerBuildingDisconnectedAtInput>;
  energyEfficiencyScore?: InputMaybe<FilterFindOneEnergyConsumerBuildingEnergyEfficiencyScoreInput>;
  energySwitchPanelId?: InputMaybe<Scalars['String']>;
  inverterId?: InputMaybe<Scalars['String']>;
  lastConnectedAt?: InputMaybe<FilterFindOneEnergyConsumerBuildingLastConnectedAtInput>;
  location?: InputMaybe<Scalars['String']>;
  meterId?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  occupancy?: InputMaybe<FilterFindOneEnergyConsumerBuildingOccupancyInput>;
  powerState?: InputMaybe<FilterFindOneEnergyConsumerBuildingPowerStateInput>;
  propertyId?: InputMaybe<Scalars['String']>;
  tariffRateSell?: InputMaybe<FilterFindOneEnergyConsumerBuildingTariffRateSellInput>;
  timestamp?: InputMaybe<Scalars['Float']>;
  unitId?: InputMaybe<Scalars['String']>;
  updateStatus?: InputMaybe<Scalars['Boolean']>;
  vppId?: InputMaybe<Scalars['String']>;
};

export type FilterFindOneEnergyConsumerBuildingLastConnectedAtInput = {
  id?: InputMaybe<Scalars['String']>;
  observedAt?: InputMaybe<Scalars['Float']>;
  previousId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  units?: InputMaybe<Scalars['String']>;
  updatePending?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<Scalars['Float']>;
};

export type FilterFindOneEnergyConsumerBuildingOccupancyInput = {
  id?: InputMaybe<Scalars['String']>;
  observedAt?: InputMaybe<Scalars['Float']>;
  previousId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  units?: InputMaybe<Scalars['String']>;
  updatePending?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<Scalars['Float']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterFindOneEnergyConsumerBuildingOperatorsInput = {
  _id?: InputMaybe<FilterFindOneEnergyConsumerBuilding_IdOperatorsInput>;
};

export type FilterFindOneEnergyConsumerBuildingPowerStateInput = {
  id?: InputMaybe<Scalars['String']>;
  observedAt?: InputMaybe<Scalars['Float']>;
  previousId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  units?: InputMaybe<Scalars['String']>;
  updatePending?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<EnumEnergyConsumerBuildingPowerStateValue>;
};

export type FilterFindOneEnergyConsumerBuildingTariffRateSellInput = {
  id?: InputMaybe<Scalars['String']>;
  observedAt?: InputMaybe<Scalars['Float']>;
  previousId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  units?: InputMaybe<Scalars['String']>;
  updatePending?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<Scalars['Float']>;
};

export type FilterFindOneEnergyConsumerBuilding_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['String']>;
  gte?: InputMaybe<Scalars['String']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  lt?: InputMaybe<Scalars['String']>;
  lte?: InputMaybe<Scalars['String']>;
  ne?: InputMaybe<Scalars['String']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']>;
};

export type FilterFindOneEnergyConsumerTenantEnergyEfficiencyScoreInput = {
  id?: InputMaybe<Scalars['String']>;
  observedAt?: InputMaybe<Scalars['Float']>;
  previousId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  units?: InputMaybe<Scalars['String']>;
  updatePending?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<Scalars['Float']>;
};

export type FilterFindOneEnergyConsumerTenantInput = {
  AND?: InputMaybe<Array<FilterFindOneEnergyConsumerTenantInput>>;
  OR?: InputMaybe<Array<FilterFindOneEnergyConsumerTenantInput>>;
  _id?: InputMaybe<Scalars['String']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterFindOneEnergyConsumerTenantOperatorsInput>;
  buildingId?: InputMaybe<Scalars['String']>;
  circuitId?: InputMaybe<Scalars['String']>;
  connected?: InputMaybe<FilterFindOneEnergyConsumerBuildingConnectedInput>;
  contactName?: InputMaybe<Scalars['String']>;
  contactPhone?: InputMaybe<Scalars['String']>;
  converterId?: InputMaybe<Scalars['String']>;
  disconnectedAt?: InputMaybe<FilterFindOneEnergyConsumerBuildingDisconnectedAtInput>;
  energyEfficiencyScore?: InputMaybe<FilterFindOneEnergyConsumerTenantEnergyEfficiencyScoreInput>;
  energySwitchPanelId?: InputMaybe<Scalars['String']>;
  inverterId?: InputMaybe<Scalars['String']>;
  lastConnectedAt?: InputMaybe<FilterFindOneEnergyConsumerBuildingLastConnectedAtInput>;
  location?: InputMaybe<Scalars['String']>;
  meterId?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  occupancy?: InputMaybe<FilterFindOneEnergyConsumerTenantOccupancyInput>;
  powerState?: InputMaybe<FilterFindOneEnergyConsumerBuildingPowerStateInput>;
  propertyId?: InputMaybe<Scalars['String']>;
  tariffRateSell?: InputMaybe<FilterFindOneEnergyConsumerBuildingTariffRateSellInput>;
  timestamp?: InputMaybe<Scalars['Float']>;
  unitId?: InputMaybe<Scalars['String']>;
  updateStatus?: InputMaybe<Scalars['Boolean']>;
  vppId?: InputMaybe<Scalars['String']>;
};

export type FilterFindOneEnergyConsumerTenantOccupancyInput = {
  id?: InputMaybe<Scalars['String']>;
  observedAt?: InputMaybe<Scalars['Float']>;
  previousId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  units?: InputMaybe<Scalars['String']>;
  updatePending?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<Scalars['Float']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterFindOneEnergyConsumerTenantOperatorsInput = {
  _id?: InputMaybe<FilterFindOneEnergyConsumerTenant_IdOperatorsInput>;
};

export type FilterFindOneEnergyConsumerTenant_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['String']>;
  gte?: InputMaybe<Scalars['String']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  lt?: InputMaybe<Scalars['String']>;
  lte?: InputMaybe<Scalars['String']>;
  ne?: InputMaybe<Scalars['String']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']>;
};

export type FilterFindOneEnergyConsumerUtilityContractStatusInput = {
  id?: InputMaybe<Scalars['String']>;
  observedAt?: InputMaybe<Scalars['Float']>;
  previousId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  units?: InputMaybe<Scalars['String']>;
  updatePending?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<Scalars['String']>;
};

export type FilterFindOneEnergyConsumerUtilityExportAllowanceInput = {
  id?: InputMaybe<Scalars['String']>;
  observedAt?: InputMaybe<Scalars['Float']>;
  previousId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  units?: InputMaybe<Scalars['String']>;
  updatePending?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<Scalars['Float']>;
};

export type FilterFindOneEnergyConsumerUtilityGridFrequencyInput = {
  id?: InputMaybe<Scalars['String']>;
  observedAt?: InputMaybe<Scalars['Float']>;
  previousId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  units?: InputMaybe<Scalars['String']>;
  updatePending?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<Scalars['Float']>;
};

export type FilterFindOneEnergyConsumerUtilityInput = {
  AND?: InputMaybe<Array<FilterFindOneEnergyConsumerUtilityInput>>;
  OR?: InputMaybe<Array<FilterFindOneEnergyConsumerUtilityInput>>;
  _id?: InputMaybe<Scalars['String']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterFindOneEnergyConsumerUtilityOperatorsInput>;
  circuitId?: InputMaybe<Scalars['String']>;
  connected?: InputMaybe<FilterFindOneEnergyConsumerBuildingConnectedInput>;
  contractStatus?: InputMaybe<FilterFindOneEnergyConsumerUtilityContractStatusInput>;
  converterId?: InputMaybe<Scalars['String']>;
  disconnectedAt?: InputMaybe<FilterFindOneEnergyConsumerBuildingDisconnectedAtInput>;
  energySwitchPanelId?: InputMaybe<Scalars['String']>;
  exportAllowance?: InputMaybe<FilterFindOneEnergyConsumerUtilityExportAllowanceInput>;
  gridFrequency?: InputMaybe<FilterFindOneEnergyConsumerUtilityGridFrequencyInput>;
  interconnectionCapacity?: InputMaybe<FilterFindOneEnergyConsumerUtilityInterconnectionCapacityInput>;
  inverterId?: InputMaybe<Scalars['String']>;
  lastConnectedAt?: InputMaybe<FilterFindOneEnergyConsumerBuildingLastConnectedAtInput>;
  location?: InputMaybe<Scalars['String']>;
  meterId?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  powerState?: InputMaybe<FilterFindOneEnergyConsumerBuildingPowerStateInput>;
  propertyId?: InputMaybe<Scalars['String']>;
  tariffRateSell?: InputMaybe<FilterFindOneEnergyConsumerBuildingTariffRateSellInput>;
  timestamp?: InputMaybe<Scalars['Float']>;
  unitId?: InputMaybe<Scalars['String']>;
  updateStatus?: InputMaybe<Scalars['Boolean']>;
  vppId?: InputMaybe<Scalars['String']>;
};

export type FilterFindOneEnergyConsumerUtilityInterconnectionCapacityInput = {
  id?: InputMaybe<Scalars['String']>;
  observedAt?: InputMaybe<Scalars['Float']>;
  previousId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  units?: InputMaybe<Scalars['String']>;
  updatePending?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<Scalars['Float']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterFindOneEnergyConsumerUtilityOperatorsInput = {
  _id?: InputMaybe<FilterFindOneEnergyConsumerUtility_IdOperatorsInput>;
};

export type FilterFindOneEnergyConsumerUtility_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['String']>;
  gte?: InputMaybe<Scalars['String']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  lt?: InputMaybe<Scalars['String']>;
  lte?: InputMaybe<Scalars['String']>;
  ne?: InputMaybe<Scalars['String']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']>;
};

export type FilterFindOneEnergyControllerAvailabilityStatusInput = {
  id?: InputMaybe<Scalars['String']>;
  observedAt?: InputMaybe<Scalars['Float']>;
  previousId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  units?: InputMaybe<Scalars['String']>;
  updatePending?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<EnumEnergyControllerAvailabilityStatusValue>;
};

export type FilterFindOneEnergyControllerChargeRegulationStatusInput = {
  id?: InputMaybe<Scalars['String']>;
  observedAt?: InputMaybe<Scalars['Float']>;
  previousId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  units?: InputMaybe<Scalars['String']>;
  updatePending?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<EnumEnergyControllerChargeRegulationStatusValue>;
};

export type FilterFindOneEnergyControllerCurrentAtMppInput = {
  id?: InputMaybe<Scalars['String']>;
  observedAt?: InputMaybe<Scalars['Float']>;
  previousId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  units?: InputMaybe<Scalars['String']>;
  updatePending?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<Scalars['Float']>;
};

export type FilterFindOneEnergyControllerEnergyGeneratedInput = {
  id?: InputMaybe<Scalars['String']>;
  observedAt?: InputMaybe<Scalars['Float']>;
  previousId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  units?: InputMaybe<Scalars['String']>;
  updatePending?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<Scalars['Float']>;
};

export type FilterFindOneEnergyControllerInput = {
  AND?: InputMaybe<Array<FilterFindOneDeviceInput>>;
  OR?: InputMaybe<Array<FilterFindOneDeviceInput>>;
  _id?: InputMaybe<Scalars['String']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterFindOneDeviceOperatorsInput>;
  alertTypes?: InputMaybe<FilterFindOneDeviceAlertTypesInput>;
  availabilityStatus?: InputMaybe<FilterFindOneEnergyControllerAvailabilityStatusInput>;
  chargeRegulationStatus?: InputMaybe<FilterFindOneEnergyControllerChargeRegulationStatusInput>;
  controlled?: InputMaybe<FilterFindOneDeviceControlledInput>;
  currentAtMpp?: InputMaybe<FilterFindOneEnergyControllerCurrentAtMppInput>;
  deviceId?: InputMaybe<Scalars['String']>;
  energyGenerated?: InputMaybe<FilterFindOneEnergyControllerEnergyGeneratedInput>;
  installation?: InputMaybe<FilterFindOneDeviceInstallationInput>;
  location?: InputMaybe<Scalars['String']>;
  meta?: InputMaybe<FilterFindOneDeviceMetaInput>;
  /** The name of the device */
  name?: InputMaybe<Scalars['String']>;
  panelId?: InputMaybe<Scalars['String']>;
  powerState?: InputMaybe<FilterFindOneDevicePowerStateInput>;
  propertyId?: InputMaybe<Scalars['String']>;
  rectifierId?: InputMaybe<Scalars['String']>;
  rotorSpeedAtMPP?: InputMaybe<FilterFindOneEnergyControllerRotorSpeedAtMppInput>;
  sourceId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  unitId?: InputMaybe<Scalars['String']>;
  updateStatus?: InputMaybe<Scalars['Boolean']>;
  voltageAtMpp?: InputMaybe<FilterFindOneEnergyControllerVoltageAtMppInput>;
  vppId?: InputMaybe<Scalars['String']>;
  zoneId?: InputMaybe<Scalars['String']>;
};

export type FilterFindOneEnergyControllerRotorSpeedAtMppInput = {
  id?: InputMaybe<Scalars['String']>;
  observedAt?: InputMaybe<Scalars['Float']>;
  previousId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  units?: InputMaybe<Scalars['String']>;
  updatePending?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<Scalars['Float']>;
};

export type FilterFindOneEnergyControllerVoltageAtMppInput = {
  id?: InputMaybe<Scalars['String']>;
  observedAt?: InputMaybe<Scalars['Float']>;
  previousId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  units?: InputMaybe<Scalars['String']>;
  updatePending?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<Scalars['Float']>;
};

export type FilterFindOneEnergyConverterChargeRateInput = {
  id?: InputMaybe<Scalars['String']>;
  observedAt?: InputMaybe<Scalars['Float']>;
  previousId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  units?: InputMaybe<Scalars['String']>;
  updatePending?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<Scalars['Float']>;
};

export type FilterFindOneEnergyConverterDischargeRateInput = {
  id?: InputMaybe<Scalars['String']>;
  observedAt?: InputMaybe<Scalars['Float']>;
  previousId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  units?: InputMaybe<Scalars['String']>;
  updatePending?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<Scalars['Float']>;
};

export type FilterFindOneEnergyConverterEfficiencyInput = {
  id?: InputMaybe<Scalars['String']>;
  observedAt?: InputMaybe<Scalars['Float']>;
  previousId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  units?: InputMaybe<Scalars['String']>;
  updatePending?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<Scalars['Float']>;
};

export type FilterFindOneEnergyConverterInput = {
  AND?: InputMaybe<Array<FilterFindOneDeviceInput>>;
  OR?: InputMaybe<Array<FilterFindOneDeviceInput>>;
  _id?: InputMaybe<Scalars['String']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterFindOneDeviceOperatorsInput>;
  alertTypes?: InputMaybe<FilterFindOneDeviceAlertTypesInput>;
  chargeRate?: InputMaybe<FilterFindOneEnergyConverterChargeRateInput>;
  controlled?: InputMaybe<FilterFindOneDeviceControlledInput>;
  deviceId?: InputMaybe<Scalars['String']>;
  dischargeRate?: InputMaybe<FilterFindOneEnergyConverterDischargeRateInput>;
  efficiency?: InputMaybe<FilterFindOneEnergyConverterEfficiencyInput>;
  inputVoltage?: InputMaybe<FilterFindOneEnergyConverterInputVoltageInput>;
  installation?: InputMaybe<FilterFindOneDeviceInstallationInput>;
  location?: InputMaybe<Scalars['String']>;
  meta?: InputMaybe<FilterFindOneDeviceMetaInput>;
  /** The name of the device */
  name?: InputMaybe<Scalars['String']>;
  outputVoltage?: InputMaybe<FilterFindOneEnergyConverterOutputVoltageInput>;
  panelId?: InputMaybe<Scalars['String']>;
  powerOutput?: InputMaybe<FilterFindOneEnergyConverterPowerOutputInput>;
  powerState?: InputMaybe<FilterFindOneDevicePowerStateInput>;
  propertyId?: InputMaybe<Scalars['String']>;
  sourceId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  unitId?: InputMaybe<Scalars['String']>;
  updateStatus?: InputMaybe<Scalars['Boolean']>;
  vppId?: InputMaybe<Scalars['String']>;
  zoneId?: InputMaybe<Scalars['String']>;
};

export type FilterFindOneEnergyConverterInputVoltageInput = {
  id?: InputMaybe<Scalars['String']>;
  observedAt?: InputMaybe<Scalars['Float']>;
  previousId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  units?: InputMaybe<Scalars['String']>;
  updatePending?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<Scalars['Float']>;
};

export type FilterFindOneEnergyConverterOutputVoltageInput = {
  id?: InputMaybe<Scalars['String']>;
  observedAt?: InputMaybe<Scalars['Float']>;
  previousId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  units?: InputMaybe<Scalars['String']>;
  updatePending?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<Scalars['Float']>;
};

export type FilterFindOneEnergyConverterPowerOutputInput = {
  id?: InputMaybe<Scalars['String']>;
  observedAt?: InputMaybe<Scalars['Float']>;
  previousId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  units?: InputMaybe<Scalars['String']>;
  updatePending?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<Scalars['Float']>;
};

export type FilterFindOneEnergyInverterAvailabilityStatusInput = {
  id?: InputMaybe<Scalars['String']>;
  observedAt?: InputMaybe<Scalars['Float']>;
  previousId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  units?: InputMaybe<Scalars['String']>;
  updatePending?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<EnumEnergyInverterAvailabilityStatusValue>;
};

export type FilterFindOneEnergyInverterChargeRateInput = {
  id?: InputMaybe<Scalars['String']>;
  observedAt?: InputMaybe<Scalars['Float']>;
  previousId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  units?: InputMaybe<Scalars['String']>;
  updatePending?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<Scalars['Float']>;
};

export type FilterFindOneEnergyInverterDischargeRateInput = {
  id?: InputMaybe<Scalars['String']>;
  observedAt?: InputMaybe<Scalars['Float']>;
  previousId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  units?: InputMaybe<Scalars['String']>;
  updatePending?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<Scalars['Float']>;
};

export type FilterFindOneEnergyInverterEfficiencyInput = {
  id?: InputMaybe<Scalars['String']>;
  observedAt?: InputMaybe<Scalars['Float']>;
  previousId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  units?: InputMaybe<Scalars['String']>;
  updatePending?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<Scalars['Float']>;
};

export type FilterFindOneEnergyInverterFrequencyInput = {
  id?: InputMaybe<Scalars['String']>;
  observedAt?: InputMaybe<Scalars['Float']>;
  previousId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  units?: InputMaybe<Scalars['String']>;
  updatePending?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<Scalars['Float']>;
};

export type FilterFindOneEnergyInverterInput = {
  AND?: InputMaybe<Array<FilterFindOneDeviceInput>>;
  OR?: InputMaybe<Array<FilterFindOneDeviceInput>>;
  _id?: InputMaybe<Scalars['String']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterFindOneDeviceOperatorsInput>;
  alertTypes?: InputMaybe<FilterFindOneDeviceAlertTypesInput>;
  availabilityStatus?: InputMaybe<FilterFindOneEnergyInverterAvailabilityStatusInput>;
  chargeRate?: InputMaybe<FilterFindOneEnergyInverterChargeRateInput>;
  controlled?: InputMaybe<FilterFindOneDeviceControlledInput>;
  controllerId?: InputMaybe<Scalars['String']>;
  deviceId?: InputMaybe<Scalars['String']>;
  dischargeRate?: InputMaybe<FilterFindOneEnergyInverterDischargeRateInput>;
  efficiency?: InputMaybe<FilterFindOneEnergyInverterEfficiencyInput>;
  frequency?: InputMaybe<FilterFindOneEnergyInverterFrequencyInput>;
  installation?: InputMaybe<FilterFindOneDeviceInstallationInput>;
  inverterTemperature?: InputMaybe<FilterFindOneEnergyInverterInverterTemperatureInput>;
  location?: InputMaybe<Scalars['String']>;
  meta?: InputMaybe<FilterFindOneDeviceMetaInput>;
  /** The name of the device */
  name?: InputMaybe<Scalars['String']>;
  panelId?: InputMaybe<Scalars['String']>;
  powerInputBattery?: InputMaybe<FilterFindOneEnergyInverterPowerInputBatteryInput>;
  powerInputKinetic?: InputMaybe<FilterFindOneEnergyInverterPowerInputKineticInput>;
  powerOutput?: InputMaybe<FilterFindOneEnergyInverterPowerOutputInput>;
  powerRating?: InputMaybe<FilterFindOneEnergyInverterPowerRatingInput>;
  powerState?: InputMaybe<FilterFindOneDevicePowerStateInput>;
  propertyId?: InputMaybe<Scalars['String']>;
  reactivePower?: InputMaybe<FilterFindOneEnergyInverterReactivePowerInput>;
  rectifierId?: InputMaybe<Scalars['String']>;
  sourceId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  unitId?: InputMaybe<Scalars['String']>;
  updateStatus?: InputMaybe<Scalars['Boolean']>;
  voltageOutput?: InputMaybe<FilterFindOneEnergyInverterVoltageOutputInput>;
  vppId?: InputMaybe<Scalars['String']>;
  zoneId?: InputMaybe<Scalars['String']>;
};

export type FilterFindOneEnergyInverterInverterTemperatureInput = {
  id?: InputMaybe<Scalars['String']>;
  observedAt?: InputMaybe<Scalars['Float']>;
  previousId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  units?: InputMaybe<Scalars['String']>;
  updatePending?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<Scalars['Float']>;
};

export type FilterFindOneEnergyInverterPowerInputBatteryInput = {
  id?: InputMaybe<Scalars['String']>;
  observedAt?: InputMaybe<Scalars['Float']>;
  previousId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  units?: InputMaybe<Scalars['String']>;
  updatePending?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<Scalars['Float']>;
};

export type FilterFindOneEnergyInverterPowerInputKineticInput = {
  id?: InputMaybe<Scalars['String']>;
  observedAt?: InputMaybe<Scalars['Float']>;
  previousId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  units?: InputMaybe<Scalars['String']>;
  updatePending?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<Scalars['Float']>;
};

export type FilterFindOneEnergyInverterPowerOutputInput = {
  id?: InputMaybe<Scalars['String']>;
  observedAt?: InputMaybe<Scalars['Float']>;
  previousId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  units?: InputMaybe<Scalars['String']>;
  updatePending?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<Scalars['Float']>;
};

export type FilterFindOneEnergyInverterPowerRatingInput = {
  id?: InputMaybe<Scalars['String']>;
  observedAt?: InputMaybe<Scalars['Float']>;
  previousId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  units?: InputMaybe<Scalars['String']>;
  updatePending?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<Scalars['Float']>;
};

export type FilterFindOneEnergyInverterReactivePowerInput = {
  id?: InputMaybe<Scalars['String']>;
  observedAt?: InputMaybe<Scalars['Float']>;
  previousId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  units?: InputMaybe<Scalars['String']>;
  updatePending?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<Scalars['Float']>;
};

export type FilterFindOneEnergyInverterVoltageOutputInput = {
  id?: InputMaybe<Scalars['String']>;
  observedAt?: InputMaybe<Scalars['Float']>;
  previousId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  units?: InputMaybe<Scalars['String']>;
  updatePending?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<Scalars['Float']>;
};

export type FilterFindOneEnergyMeterCurrentInput = {
  id?: InputMaybe<Scalars['String']>;
  observedAt?: InputMaybe<Scalars['Float']>;
  previousId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  units?: InputMaybe<Scalars['String']>;
  updatePending?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<Scalars['Float']>;
};

export type FilterFindOneEnergyMeterEnergyConsumedInput = {
  id?: InputMaybe<Scalars['String']>;
  observedAt?: InputMaybe<Scalars['Float']>;
  previousId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  units?: InputMaybe<Scalars['String']>;
  updatePending?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<Scalars['Float']>;
};

export type FilterFindOneEnergyMeterFrequencyInput = {
  id?: InputMaybe<Scalars['String']>;
  observedAt?: InputMaybe<Scalars['Float']>;
  previousId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  units?: InputMaybe<Scalars['String']>;
  updatePending?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<Scalars['Float']>;
};

export type FilterFindOneEnergyMeterInput = {
  AND?: InputMaybe<Array<FilterFindOneDeviceInput>>;
  OR?: InputMaybe<Array<FilterFindOneDeviceInput>>;
  _id?: InputMaybe<Scalars['String']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterFindOneDeviceOperatorsInput>;
  alertTypes?: InputMaybe<FilterFindOneDeviceAlertTypesInput>;
  controlled?: InputMaybe<FilterFindOneDeviceControlledInput>;
  current?: InputMaybe<FilterFindOneEnergyMeterCurrentInput>;
  deviceId?: InputMaybe<Scalars['String']>;
  energyConsumed?: InputMaybe<FilterFindOneEnergyMeterEnergyConsumedInput>;
  frequency?: InputMaybe<FilterFindOneEnergyMeterFrequencyInput>;
  installation?: InputMaybe<FilterFindOneDeviceInstallationInput>;
  location?: InputMaybe<Scalars['String']>;
  meta?: InputMaybe<FilterFindOneDeviceMetaInput>;
  /** The name of the device */
  name?: InputMaybe<Scalars['String']>;
  outputEnabled?: InputMaybe<FilterFindOneEnergyMeterOutputEnabledInput>;
  panelId?: InputMaybe<Scalars['String']>;
  powerDemand?: InputMaybe<FilterFindOneEnergyMeterPowerDemandInput>;
  powerFactor?: InputMaybe<FilterFindOneEnergyMeterPowerFactorInput>;
  powerState?: InputMaybe<FilterFindOneDevicePowerStateInput>;
  propertyId?: InputMaybe<Scalars['String']>;
  sourceId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  unitId?: InputMaybe<Scalars['String']>;
  updateStatus?: InputMaybe<Scalars['Boolean']>;
  voltage?: InputMaybe<FilterFindOneEnergyMeterVoltageInput>;
  vppId?: InputMaybe<Scalars['String']>;
  zoneId?: InputMaybe<Scalars['String']>;
};

export type FilterFindOneEnergyMeterOutputEnabledInput = {
  id?: InputMaybe<Scalars['String']>;
  observedAt?: InputMaybe<Scalars['Float']>;
  previousId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  units?: InputMaybe<Scalars['String']>;
  updatePending?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<Scalars['Boolean']>;
};

export type FilterFindOneEnergyMeterPowerDemandInput = {
  id?: InputMaybe<Scalars['String']>;
  observedAt?: InputMaybe<Scalars['Float']>;
  previousId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  units?: InputMaybe<Scalars['String']>;
  updatePending?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<Scalars['Float']>;
};

export type FilterFindOneEnergyMeterPowerFactorInput = {
  id?: InputMaybe<Scalars['String']>;
  observedAt?: InputMaybe<Scalars['Float']>;
  previousId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  units?: InputMaybe<Scalars['String']>;
  updatePending?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<Scalars['Float']>;
};

export type FilterFindOneEnergyMeterVoltageInput = {
  id?: InputMaybe<Scalars['String']>;
  observedAt?: InputMaybe<Scalars['Float']>;
  previousId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  units?: InputMaybe<Scalars['String']>;
  updatePending?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<Scalars['Float']>;
};

export type FilterFindOneEnergyRectifierInput = {
  AND?: InputMaybe<Array<FilterFindOneDeviceInput>>;
  OR?: InputMaybe<Array<FilterFindOneDeviceInput>>;
  _id?: InputMaybe<Scalars['String']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterFindOneDeviceOperatorsInput>;
  alertTypes?: InputMaybe<FilterFindOneDeviceAlertTypesInput>;
  controlled?: InputMaybe<FilterFindOneDeviceControlledInput>;
  deviceId?: InputMaybe<Scalars['String']>;
  installation?: InputMaybe<FilterFindOneDeviceInstallationInput>;
  location?: InputMaybe<Scalars['String']>;
  meta?: InputMaybe<FilterFindOneDeviceMetaInput>;
  /** The name of the device */
  name?: InputMaybe<Scalars['String']>;
  outputVoltage?: InputMaybe<FilterFindOneEnergyRectifierOutputVoltageInput>;
  panelId?: InputMaybe<Scalars['String']>;
  powerState?: InputMaybe<FilterFindOneDevicePowerStateInput>;
  propertyId?: InputMaybe<Scalars['String']>;
  rectifierEfficiency?: InputMaybe<FilterFindOneEnergyRectifierRectifierEfficiencyInput>;
  sourceId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  unitId?: InputMaybe<Scalars['String']>;
  updateStatus?: InputMaybe<Scalars['Boolean']>;
  vppId?: InputMaybe<Scalars['String']>;
  zoneId?: InputMaybe<Scalars['String']>;
};

export type FilterFindOneEnergyRectifierOutputVoltageInput = {
  id?: InputMaybe<Scalars['String']>;
  observedAt?: InputMaybe<Scalars['Float']>;
  previousId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  units?: InputMaybe<Scalars['String']>;
  updatePending?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<Scalars['Float']>;
};

export type FilterFindOneEnergyRectifierRectifierEfficiencyInput = {
  id?: InputMaybe<Scalars['String']>;
  observedAt?: InputMaybe<Scalars['Float']>;
  previousId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  units?: InputMaybe<Scalars['String']>;
  updatePending?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<Scalars['Float']>;
};

export type FilterFindOneEnergyStorageBatterySystemInput = {
  AND?: InputMaybe<Array<FilterFindOneEnergyStorageBatterySystemInput>>;
  OR?: InputMaybe<Array<FilterFindOneEnergyStorageBatterySystemInput>>;
  _id?: InputMaybe<Scalars['String']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterFindOneEnergyStorageBatterySystemOperatorsInput>;
  batteryManagementSystemId?: InputMaybe<Scalars['String']>;
  connected?: InputMaybe<FilterFindOneEnergyConsumerBuildingConnectedInput>;
  controllerId?: InputMaybe<Scalars['String']>;
  converterId?: InputMaybe<Scalars['String']>;
  coolingSystemId?: InputMaybe<Scalars['String']>;
  disconnectedAt?: InputMaybe<FilterFindOneEnergyConsumerBuildingDisconnectedAtInput>;
  fireSuppressionSystemId?: InputMaybe<Scalars['String']>;
  inverterId?: InputMaybe<Scalars['String']>;
  lastConnectedAt?: InputMaybe<FilterFindOneEnergyConsumerBuildingLastConnectedAtInput>;
  location?: InputMaybe<Scalars['String']>;
  maintenanceScheduleStatus?: InputMaybe<FilterFindOneEnergyStorageBatterySystemMaintenanceScheduleStatusInput>;
  maximumEnergyCapacity?: InputMaybe<FilterFindOneEnergyStorageBatterySystemMaximumEnergyCapacityInput>;
  modeOfOperation?: InputMaybe<FilterFindOneEnergyStorageBatterySystemModeOfOperationInput>;
  name?: InputMaybe<Scalars['String']>;
  powerState?: InputMaybe<FilterFindOneEnergyConsumerBuildingPowerStateInput>;
  propertyId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  unitId?: InputMaybe<Scalars['String']>;
  updateStatus?: InputMaybe<Scalars['Boolean']>;
  vppId?: InputMaybe<Scalars['String']>;
};

export type FilterFindOneEnergyStorageBatterySystemMaintenanceScheduleStatusInput =
  {
    id?: InputMaybe<Scalars['String']>;
    observedAt?: InputMaybe<Scalars['Float']>;
    previousId?: InputMaybe<Scalars['String']>;
    timestamp?: InputMaybe<Scalars['Float']>;
    units?: InputMaybe<Scalars['String']>;
    updatePending?: InputMaybe<Scalars['Boolean']>;
    value?: InputMaybe<EnumEnergyStorageBatterySystemMaintenanceScheduleStatusValue>;
  };

export type FilterFindOneEnergyStorageBatterySystemMaximumEnergyCapacityInput =
  {
    id?: InputMaybe<Scalars['String']>;
    observedAt?: InputMaybe<Scalars['Float']>;
    previousId?: InputMaybe<Scalars['String']>;
    timestamp?: InputMaybe<Scalars['Float']>;
    units?: InputMaybe<Scalars['String']>;
    updatePending?: InputMaybe<Scalars['Boolean']>;
    value?: InputMaybe<Scalars['Float']>;
  };

export type FilterFindOneEnergyStorageBatterySystemModeOfOperationInput = {
  id?: InputMaybe<Scalars['String']>;
  observedAt?: InputMaybe<Scalars['Float']>;
  previousId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  units?: InputMaybe<Scalars['String']>;
  updatePending?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<EnumEnergyStorageBatterySystemModeOfOperationValue>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterFindOneEnergyStorageBatterySystemOperatorsInput = {
  _id?: InputMaybe<FilterFindOneEnergyStorageBatterySystem_IdOperatorsInput>;
};

export type FilterFindOneEnergyStorageBatterySystem_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['String']>;
  gte?: InputMaybe<Scalars['String']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  lt?: InputMaybe<Scalars['String']>;
  lte?: InputMaybe<Scalars['String']>;
  ne?: InputMaybe<Scalars['String']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']>;
};

export type FilterFindOneEnergyStorageCoolingSystemCoolingHeatingStatusInput = {
  id?: InputMaybe<Scalars['String']>;
  observedAt?: InputMaybe<Scalars['Float']>;
  previousId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  units?: InputMaybe<Scalars['String']>;
  updatePending?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<EnumEnergyStorageCoolingSystemCoolingHeatingStatusValue>;
};

export type FilterFindOneEnergyStorageCoolingSystemInput = {
  AND?: InputMaybe<Array<FilterFindOneDeviceInput>>;
  OR?: InputMaybe<Array<FilterFindOneDeviceInput>>;
  _id?: InputMaybe<Scalars['String']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterFindOneDeviceOperatorsInput>;
  alertTypes?: InputMaybe<FilterFindOneDeviceAlertTypesInput>;
  controlled?: InputMaybe<FilterFindOneDeviceControlledInput>;
  coolingHeatingStatus?: InputMaybe<FilterFindOneEnergyStorageCoolingSystemCoolingHeatingStatusInput>;
  deviceId?: InputMaybe<Scalars['String']>;
  installation?: InputMaybe<FilterFindOneDeviceInstallationInput>;
  location?: InputMaybe<Scalars['String']>;
  meta?: InputMaybe<FilterFindOneDeviceMetaInput>;
  /** The name of the device */
  name?: InputMaybe<Scalars['String']>;
  panelId?: InputMaybe<Scalars['String']>;
  powerState?: InputMaybe<FilterFindOneDevicePowerStateInput>;
  propertyId?: InputMaybe<Scalars['String']>;
  sourceId?: InputMaybe<Scalars['String']>;
  temperature?: InputMaybe<FilterFindOneEnergyStorageCoolingSystemTemperatureInput>;
  timestamp?: InputMaybe<Scalars['Float']>;
  unitId?: InputMaybe<Scalars['String']>;
  updateStatus?: InputMaybe<Scalars['Boolean']>;
  vppId?: InputMaybe<Scalars['String']>;
  zoneId?: InputMaybe<Scalars['String']>;
};

export type FilterFindOneEnergyStorageCoolingSystemTemperatureInput = {
  id?: InputMaybe<Scalars['String']>;
  observedAt?: InputMaybe<Scalars['Float']>;
  previousId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  units?: InputMaybe<Scalars['String']>;
  updatePending?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<Scalars['Float']>;
};

export type FilterFindOneEnergyStorageKineticSystemInput = {
  AND?: InputMaybe<Array<FilterFindOneEnergyStorageKineticSystemInput>>;
  OR?: InputMaybe<Array<FilterFindOneEnergyStorageKineticSystemInput>>;
  _id?: InputMaybe<Scalars['String']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterFindOneEnergyStorageKineticSystemOperatorsInput>;
  connected?: InputMaybe<FilterFindOneEnergyConsumerBuildingConnectedInput>;
  controllerId?: InputMaybe<Scalars['String']>;
  converterId?: InputMaybe<Scalars['String']>;
  coolingSystemId?: InputMaybe<Scalars['String']>;
  disconnectedAt?: InputMaybe<FilterFindOneEnergyConsumerBuildingDisconnectedAtInput>;
  fireSuppressionSystemId?: InputMaybe<Scalars['String']>;
  inverterId?: InputMaybe<Scalars['String']>;
  kemsId?: InputMaybe<Scalars['String']>;
  lastConnectedAt?: InputMaybe<FilterFindOneEnergyConsumerBuildingLastConnectedAtInput>;
  location?: InputMaybe<Scalars['String']>;
  maintenanceScheduleStatus?: InputMaybe<FilterFindOneEnergyStorageBatterySystemMaintenanceScheduleStatusInput>;
  maximumEnergyCapacity?: InputMaybe<FilterFindOneEnergyStorageBatterySystemMaximumEnergyCapacityInput>;
  modeOfOperation?: InputMaybe<FilterFindOneEnergyStorageBatterySystemModeOfOperationInput>;
  name?: InputMaybe<Scalars['String']>;
  powerState?: InputMaybe<FilterFindOneEnergyConsumerBuildingPowerStateInput>;
  propertyId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  unitId?: InputMaybe<Scalars['String']>;
  updateStatus?: InputMaybe<Scalars['Boolean']>;
  vppId?: InputMaybe<Scalars['String']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterFindOneEnergyStorageKineticSystemOperatorsInput = {
  _id?: InputMaybe<FilterFindOneEnergyStorageKineticSystem_IdOperatorsInput>;
};

export type FilterFindOneEnergyStorageKineticSystem_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['String']>;
  gte?: InputMaybe<Scalars['String']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  lt?: InputMaybe<Scalars['String']>;
  lte?: InputMaybe<Scalars['String']>;
  ne?: InputMaybe<Scalars['String']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']>;
};

export type FilterFindOneEnergySupplierSolarSystemAzimuthInput = {
  id?: InputMaybe<Scalars['String']>;
  observedAt?: InputMaybe<Scalars['Float']>;
  previousId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  units?: InputMaybe<Scalars['String']>;
  updatePending?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<Scalars['Float']>;
};

export type FilterFindOneEnergySupplierSolarSystemInput = {
  AND?: InputMaybe<Array<FilterFindOneEnergySupplierSolarSystemInput>>;
  OR?: InputMaybe<Array<FilterFindOneEnergySupplierSolarSystemInput>>;
  _id?: InputMaybe<Scalars['String']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterFindOneEnergySupplierSolarSystemOperatorsInput>;
  azimuth?: InputMaybe<FilterFindOneEnergySupplierSolarSystemAzimuthInput>;
  connected?: InputMaybe<FilterFindOneEnergyConsumerBuildingConnectedInput>;
  controllerId?: InputMaybe<Scalars['String']>;
  disconnectedAt?: InputMaybe<FilterFindOneEnergyConsumerBuildingDisconnectedAtInput>;
  inverterId?: InputMaybe<Scalars['String']>;
  lastConnectedAt?: InputMaybe<FilterFindOneEnergyConsumerBuildingLastConnectedAtInput>;
  location?: InputMaybe<Scalars['String']>;
  maximumPowerOutput?: InputMaybe<Scalars['Float']>;
  name?: InputMaybe<Scalars['String']>;
  powerState?: InputMaybe<FilterFindOneEnergyConsumerBuildingPowerStateInput>;
  propertyId?: InputMaybe<Scalars['String']>;
  smsId?: InputMaybe<Scalars['String']>;
  tiltAngle?: InputMaybe<FilterFindOneEnergySupplierSolarSystemTiltAngleInput>;
  timestamp?: InputMaybe<Scalars['Float']>;
  unitId?: InputMaybe<Scalars['String']>;
  updateStatus?: InputMaybe<Scalars['Boolean']>;
  vppId?: InputMaybe<Scalars['String']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterFindOneEnergySupplierSolarSystemOperatorsInput = {
  _id?: InputMaybe<FilterFindOneEnergySupplierSolarSystem_IdOperatorsInput>;
};

export type FilterFindOneEnergySupplierSolarSystemTiltAngleInput = {
  id?: InputMaybe<Scalars['String']>;
  observedAt?: InputMaybe<Scalars['Float']>;
  previousId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  units?: InputMaybe<Scalars['String']>;
  updatePending?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<Scalars['Float']>;
};

export type FilterFindOneEnergySupplierSolarSystem_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['String']>;
  gte?: InputMaybe<Scalars['String']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  lt?: InputMaybe<Scalars['String']>;
  lte?: InputMaybe<Scalars['String']>;
  ne?: InputMaybe<Scalars['String']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']>;
};

export type FilterFindOneEnergySupplierUtilityContractedCapacityInput = {
  id?: InputMaybe<Scalars['String']>;
  observedAt?: InputMaybe<Scalars['Float']>;
  previousId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  units?: InputMaybe<Scalars['String']>;
  updatePending?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<Scalars['Float']>;
};

export type FilterFindOneEnergySupplierUtilityInput = {
  AND?: InputMaybe<Array<FilterFindOneEnergySupplierUtilityInput>>;
  OR?: InputMaybe<Array<FilterFindOneEnergySupplierUtilityInput>>;
  _id?: InputMaybe<Scalars['String']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterFindOneEnergySupplierUtilityOperatorsInput>;
  connected?: InputMaybe<FilterFindOneEnergyConsumerBuildingConnectedInput>;
  contractedCapacity?: InputMaybe<FilterFindOneEnergySupplierUtilityContractedCapacityInput>;
  controllerId?: InputMaybe<Scalars['String']>;
  disconnectedAt?: InputMaybe<FilterFindOneEnergyConsumerBuildingDisconnectedAtInput>;
  inverterId?: InputMaybe<Scalars['String']>;
  lastConnectedAt?: InputMaybe<FilterFindOneEnergyConsumerBuildingLastConnectedAtInput>;
  location?: InputMaybe<Scalars['String']>;
  maximumPowerOutput?: InputMaybe<Scalars['Float']>;
  meteringAccuracy?: InputMaybe<FilterFindOneEnergySupplierUtilityMeteringAccuracyInput>;
  name?: InputMaybe<Scalars['String']>;
  powerState?: InputMaybe<FilterFindOneEnergyConsumerBuildingPowerStateInput>;
  propertyId?: InputMaybe<Scalars['String']>;
  tariffRate?: InputMaybe<FilterFindOneEnergySupplierUtilityTariffRateInput>;
  timestamp?: InputMaybe<Scalars['Float']>;
  unitId?: InputMaybe<Scalars['String']>;
  updateStatus?: InputMaybe<Scalars['Boolean']>;
  vppId?: InputMaybe<Scalars['String']>;
};

export type FilterFindOneEnergySupplierUtilityMeteringAccuracyInput = {
  id?: InputMaybe<Scalars['String']>;
  observedAt?: InputMaybe<Scalars['Float']>;
  previousId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  units?: InputMaybe<Scalars['String']>;
  updatePending?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<Scalars['Float']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterFindOneEnergySupplierUtilityOperatorsInput = {
  _id?: InputMaybe<FilterFindOneEnergySupplierUtility_IdOperatorsInput>;
};

export type FilterFindOneEnergySupplierUtilityTariffRateInput = {
  id?: InputMaybe<Scalars['String']>;
  observedAt?: InputMaybe<Scalars['Float']>;
  previousId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  units?: InputMaybe<Scalars['String']>;
  updatePending?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<Scalars['Float']>;
};

export type FilterFindOneEnergySupplierUtility_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['String']>;
  gte?: InputMaybe<Scalars['String']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  lt?: InputMaybe<Scalars['String']>;
  lte?: InputMaybe<Scalars['String']>;
  ne?: InputMaybe<Scalars['String']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']>;
};

export type FilterFindOneEnergySupplierWindSystemCutInSpeedInput = {
  id?: InputMaybe<Scalars['String']>;
  observedAt?: InputMaybe<Scalars['Float']>;
  previousId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  units?: InputMaybe<Scalars['String']>;
  updatePending?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<Scalars['Float']>;
};

export type FilterFindOneEnergySupplierWindSystemCutOutSpeedInput = {
  id?: InputMaybe<Scalars['String']>;
  observedAt?: InputMaybe<Scalars['Float']>;
  previousId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  units?: InputMaybe<Scalars['String']>;
  updatePending?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<Scalars['Float']>;
};

export type FilterFindOneEnergySupplierWindSystemInput = {
  AND?: InputMaybe<Array<FilterFindOneEnergySupplierWindSystemInput>>;
  OR?: InputMaybe<Array<FilterFindOneEnergySupplierWindSystemInput>>;
  _id?: InputMaybe<Scalars['String']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterFindOneEnergySupplierWindSystemOperatorsInput>;
  connected?: InputMaybe<FilterFindOneEnergyConsumerBuildingConnectedInput>;
  controllerId?: InputMaybe<Scalars['String']>;
  cutInSpeed?: InputMaybe<FilterFindOneEnergySupplierWindSystemCutInSpeedInput>;
  cutOutSpeed?: InputMaybe<FilterFindOneEnergySupplierWindSystemCutOutSpeedInput>;
  disconnectedAt?: InputMaybe<FilterFindOneEnergyConsumerBuildingDisconnectedAtInput>;
  inverterId?: InputMaybe<Scalars['String']>;
  lastConnectedAt?: InputMaybe<FilterFindOneEnergyConsumerBuildingLastConnectedAtInput>;
  location?: InputMaybe<Scalars['String']>;
  maximumPowerOutput?: InputMaybe<Scalars['Float']>;
  modeOfOperation?: InputMaybe<FilterFindOneEnergySupplierWindSystemModeOfOperationInput>;
  name?: InputMaybe<Scalars['String']>;
  powerState?: InputMaybe<FilterFindOneEnergyConsumerBuildingPowerStateInput>;
  propertyId?: InputMaybe<Scalars['String']>;
  rectifierId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  unitId?: InputMaybe<Scalars['String']>;
  updateStatus?: InputMaybe<Scalars['Boolean']>;
  vppId?: InputMaybe<Scalars['String']>;
  wmsId?: InputMaybe<Scalars['String']>;
};

export type FilterFindOneEnergySupplierWindSystemModeOfOperationInput = {
  id?: InputMaybe<Scalars['String']>;
  observedAt?: InputMaybe<Scalars['Float']>;
  previousId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  units?: InputMaybe<Scalars['String']>;
  updatePending?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<EnumEnergySupplierWindSystemModeOfOperationValue>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterFindOneEnergySupplierWindSystemOperatorsInput = {
  _id?: InputMaybe<FilterFindOneEnergySupplierWindSystem_IdOperatorsInput>;
};

export type FilterFindOneEnergySupplierWindSystem_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['String']>;
  gte?: InputMaybe<Scalars['String']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  lt?: InputMaybe<Scalars['String']>;
  lte?: InputMaybe<Scalars['String']>;
  ne?: InputMaybe<Scalars['String']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']>;
};

export type FilterFindOneEnergySwitchPanelCircuitCurrentInput = {
  id?: InputMaybe<Scalars['String']>;
  observedAt?: InputMaybe<Scalars['Float']>;
  previousId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  units?: InputMaybe<Scalars['String']>;
  updatePending?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<Scalars['Float']>;
};

export type FilterFindOneEnergySwitchPanelCircuitEnergyConsumedInput = {
  id?: InputMaybe<Scalars['String']>;
  observedAt?: InputMaybe<Scalars['Float']>;
  previousId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  units?: InputMaybe<Scalars['String']>;
  updatePending?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<Scalars['Float']>;
};

export type FilterFindOneEnergySwitchPanelCircuitFrequencyInput = {
  id?: InputMaybe<Scalars['String']>;
  observedAt?: InputMaybe<Scalars['Float']>;
  previousId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  units?: InputMaybe<Scalars['String']>;
  updatePending?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<Scalars['Float']>;
};

export type FilterFindOneEnergySwitchPanelCircuitInput = {
  AND?: InputMaybe<Array<FilterFindOneDeviceInput>>;
  OR?: InputMaybe<Array<FilterFindOneDeviceInput>>;
  _id?: InputMaybe<Scalars['String']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterFindOneDeviceOperatorsInput>;
  alertTypes?: InputMaybe<FilterFindOneDeviceAlertTypesInput>;
  controlled?: InputMaybe<FilterFindOneDeviceControlledInput>;
  current?: InputMaybe<FilterFindOneEnergySwitchPanelCircuitCurrentInput>;
  deviceId?: InputMaybe<Scalars['String']>;
  energyConsumed?: InputMaybe<FilterFindOneEnergySwitchPanelCircuitEnergyConsumedInput>;
  energySwitchPanelId?: InputMaybe<Scalars['String']>;
  frequency?: InputMaybe<FilterFindOneEnergySwitchPanelCircuitFrequencyInput>;
  installation?: InputMaybe<FilterFindOneDeviceInstallationInput>;
  location?: InputMaybe<Scalars['String']>;
  meta?: InputMaybe<FilterFindOneDeviceMetaInput>;
  /** The name of the device */
  name?: InputMaybe<Scalars['String']>;
  outputEnabled?: InputMaybe<FilterFindOneEnergySwitchPanelCircuitOutputEnabledInput>;
  panelId?: InputMaybe<Scalars['String']>;
  powerDemand?: InputMaybe<FilterFindOneEnergySwitchPanelCircuitPowerDemandInput>;
  powerFactor?: InputMaybe<FilterFindOneEnergySwitchPanelCircuitPowerFactorInput>;
  powerState?: InputMaybe<FilterFindOneDevicePowerStateInput>;
  propertyId?: InputMaybe<Scalars['String']>;
  sourceId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  unitId?: InputMaybe<Scalars['String']>;
  updateStatus?: InputMaybe<Scalars['Boolean']>;
  voltage?: InputMaybe<FilterFindOneEnergySwitchPanelCircuitVoltageInput>;
  vppId?: InputMaybe<Scalars['String']>;
  zoneId?: InputMaybe<Scalars['String']>;
};

export type FilterFindOneEnergySwitchPanelCircuitOutputEnabledInput = {
  id?: InputMaybe<Scalars['String']>;
  observedAt?: InputMaybe<Scalars['Float']>;
  previousId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  units?: InputMaybe<Scalars['String']>;
  updatePending?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<Scalars['Boolean']>;
};

export type FilterFindOneEnergySwitchPanelCircuitPowerDemandInput = {
  id?: InputMaybe<Scalars['String']>;
  observedAt?: InputMaybe<Scalars['Float']>;
  previousId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  units?: InputMaybe<Scalars['String']>;
  updatePending?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<Scalars['Float']>;
};

export type FilterFindOneEnergySwitchPanelCircuitPowerFactorInput = {
  id?: InputMaybe<Scalars['String']>;
  observedAt?: InputMaybe<Scalars['Float']>;
  previousId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  units?: InputMaybe<Scalars['String']>;
  updatePending?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<Scalars['Float']>;
};

export type FilterFindOneEnergySwitchPanelCircuitVoltageInput = {
  id?: InputMaybe<Scalars['String']>;
  observedAt?: InputMaybe<Scalars['Float']>;
  previousId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  units?: InputMaybe<Scalars['String']>;
  updatePending?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<Scalars['Float']>;
};

export type FilterFindOneEnergySwitchPanelInput = {
  AND?: InputMaybe<Array<FilterFindOneDeviceInput>>;
  OR?: InputMaybe<Array<FilterFindOneDeviceInput>>;
  _id?: InputMaybe<Scalars['String']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterFindOneDeviceOperatorsInput>;
  alertTypes?: InputMaybe<FilterFindOneDeviceAlertTypesInput>;
  controlled?: InputMaybe<FilterFindOneDeviceControlledInput>;
  deviceId?: InputMaybe<Scalars['String']>;
  installation?: InputMaybe<FilterFindOneDeviceInstallationInput>;
  location?: InputMaybe<Scalars['String']>;
  maxCircuits?: InputMaybe<Scalars['Float']>;
  meta?: InputMaybe<FilterFindOneDeviceMetaInput>;
  /** The name of the device */
  name?: InputMaybe<Scalars['String']>;
  panelId?: InputMaybe<Scalars['String']>;
  powerInput?: InputMaybe<FilterFindOneEnergySwitchPanelPowerInputInput>;
  powerState?: InputMaybe<FilterFindOneDevicePowerStateInput>;
  propertyId?: InputMaybe<Scalars['String']>;
  sourceId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  unitId?: InputMaybe<Scalars['String']>;
  updateStatus?: InputMaybe<Scalars['Boolean']>;
  vppId?: InputMaybe<Scalars['String']>;
  zoneId?: InputMaybe<Scalars['String']>;
};

export type FilterFindOneEnergySwitchPanelPowerInputInput = {
  id?: InputMaybe<Scalars['String']>;
  observedAt?: InputMaybe<Scalars['Float']>;
  previousId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  units?: InputMaybe<Scalars['String']>;
  updatePending?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<Scalars['Float']>;
};

export type FilterFindOneFireSuppressionSystemFireSuppressionStatusInput = {
  id?: InputMaybe<Scalars['String']>;
  observedAt?: InputMaybe<Scalars['Float']>;
  previousId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  units?: InputMaybe<Scalars['String']>;
  updatePending?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<EnumFireSuppressionSystemFireSuppressionStatusValue>;
};

export type FilterFindOneFireSuppressionSystemInput = {
  AND?: InputMaybe<Array<FilterFindOneDeviceInput>>;
  OR?: InputMaybe<Array<FilterFindOneDeviceInput>>;
  _id?: InputMaybe<Scalars['String']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterFindOneDeviceOperatorsInput>;
  alertTypes?: InputMaybe<FilterFindOneDeviceAlertTypesInput>;
  controlled?: InputMaybe<FilterFindOneDeviceControlledInput>;
  deviceId?: InputMaybe<Scalars['String']>;
  fireSuppressionStatus?: InputMaybe<FilterFindOneFireSuppressionSystemFireSuppressionStatusInput>;
  installation?: InputMaybe<FilterFindOneDeviceInstallationInput>;
  location?: InputMaybe<Scalars['String']>;
  meta?: InputMaybe<FilterFindOneDeviceMetaInput>;
  /** The name of the device */
  name?: InputMaybe<Scalars['String']>;
  panelId?: InputMaybe<Scalars['String']>;
  powerState?: InputMaybe<FilterFindOneDevicePowerStateInput>;
  propertyId?: InputMaybe<Scalars['String']>;
  sensorStatus?: InputMaybe<FilterFindOneFireSuppressionSystemSensorStatusInput>;
  sourceId?: InputMaybe<Scalars['String']>;
  suppressantLevel?: InputMaybe<FilterFindOneFireSuppressionSystemSuppressantLevelInput>;
  timestamp?: InputMaybe<Scalars['Float']>;
  unitId?: InputMaybe<Scalars['String']>;
  updateStatus?: InputMaybe<Scalars['Boolean']>;
  vppId?: InputMaybe<Scalars['String']>;
  zoneId?: InputMaybe<Scalars['String']>;
};

export type FilterFindOneFireSuppressionSystemSensorStatusInput = {
  id?: InputMaybe<Scalars['String']>;
  observedAt?: InputMaybe<Scalars['Float']>;
  previousId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  units?: InputMaybe<Scalars['String']>;
  updatePending?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<EnumFireSuppressionSystemSensorStatusValue>;
};

export type FilterFindOneFireSuppressionSystemSuppressantLevelInput = {
  id?: InputMaybe<Scalars['String']>;
  observedAt?: InputMaybe<Scalars['Float']>;
  previousId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  units?: InputMaybe<Scalars['String']>;
  updatePending?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<Scalars['Float']>;
};

export type FilterFindOneFloorInput = {
  AND?: InputMaybe<Array<FilterFindOneFloorInput>>;
  OR?: InputMaybe<Array<FilterFindOneFloorInput>>;
  _id?: InputMaybe<Scalars['String']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterFindOneFloorOperatorsInput>;
  buildingId?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  number?: InputMaybe<Scalars['Float']>;
  propertyId?: InputMaybe<Scalars['String']>;
};

export type FilterFindOneFloorNameOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['String']>;
  gte?: InputMaybe<Scalars['String']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  lt?: InputMaybe<Scalars['String']>;
  lte?: InputMaybe<Scalars['String']>;
  ne?: InputMaybe<Scalars['String']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterFindOneFloorOperatorsInput = {
  _id?: InputMaybe<FilterFindOneFloor_IdOperatorsInput>;
  name?: InputMaybe<FilterFindOneFloorNameOperatorsInput>;
};

export type FilterFindOneFloor_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['String']>;
  gte?: InputMaybe<Scalars['String']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  lt?: InputMaybe<Scalars['String']>;
  lte?: InputMaybe<Scalars['String']>;
  ne?: InputMaybe<Scalars['String']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']>;
};

export type FilterFindOneGpioInput = {
  AND?: InputMaybe<Array<FilterFindOneDeviceInput>>;
  OR?: InputMaybe<Array<FilterFindOneDeviceInput>>;
  _id?: InputMaybe<Scalars['String']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterFindOneDeviceOperatorsInput>;
  alertTypes?: InputMaybe<FilterFindOneDeviceAlertTypesInput>;
  controlled?: InputMaybe<FilterFindOneDeviceControlledInput>;
  deviceId?: InputMaybe<Scalars['String']>;
  installation?: InputMaybe<FilterFindOneDeviceInstallationInput>;
  location?: InputMaybe<Scalars['String']>;
  meta?: InputMaybe<FilterFindOneDeviceMetaInput>;
  /** The name of the device */
  name?: InputMaybe<Scalars['String']>;
  panelId?: InputMaybe<Scalars['String']>;
  powerState?: InputMaybe<FilterFindOneDevicePowerStateInput>;
  propertyId?: InputMaybe<Scalars['String']>;
  sourceId?: InputMaybe<Scalars['String']>;
  state?: InputMaybe<FilterFindOneGpioStateInput>;
  timestamp?: InputMaybe<Scalars['Float']>;
  unitId?: InputMaybe<Scalars['String']>;
  updateStatus?: InputMaybe<Scalars['Boolean']>;
  vppId?: InputMaybe<Scalars['String']>;
  zoneId?: InputMaybe<Scalars['String']>;
};

export type FilterFindOneGpioStateInput = {
  id?: InputMaybe<Scalars['String']>;
  observedAt?: InputMaybe<Scalars['Float']>;
  previousId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  units?: InputMaybe<Scalars['String']>;
  updatePending?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<Scalars['Boolean']>;
};

export type FilterFindOneHmmInput = {
  AND?: InputMaybe<Array<FilterFindOneSourceInput>>;
  OR?: InputMaybe<Array<FilterFindOneSourceInput>>;
  _id?: InputMaybe<Scalars['String']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterFindOneSourceOperatorsInput>;
  hmmUniqueId?: InputMaybe<Scalars['String']>;
  maxReportingTime?: InputMaybe<Scalars['Float']>;
  name?: InputMaybe<Scalars['String']>;
  propertyId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  tolerances?: InputMaybe<FilterFindOneHmmTolerancesInput>;
  url?: InputMaybe<Scalars['String']>;
};

export type FilterFindOneHmmTolerancesInput = {
  temperature?: InputMaybe<Scalars['Float']>;
};

export type FilterFindOneHistoricAlertAlertCategoryInput = {
  id?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
};

export type FilterFindOneHistoricAlertAlertTriggerInput = {
  id?: InputMaybe<Scalars['String']>;
  key?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
};

export type FilterFindOneHistoricAlertBuildingInput = {
  id?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
};

export type FilterFindOneHistoricAlertDeviceInput = {
  id?: InputMaybe<Scalars['String']>;
  model?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  role?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<Scalars['String']>;
  version?: InputMaybe<Scalars['String']>;
};

export type FilterFindOneHistoricAlertInput = {
  AND?: InputMaybe<Array<FilterFindOneHistoricAlertInput>>;
  OR?: InputMaybe<Array<FilterFindOneHistoricAlertInput>>;
  _id?: InputMaybe<Scalars['String']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterFindOneHistoricAlertOperatorsInput>;
  alertCategory?: InputMaybe<FilterFindOneHistoricAlertAlertCategoryInput>;
  alertTrigger?: InputMaybe<FilterFindOneHistoricAlertAlertTriggerInput>;
  building?: InputMaybe<FilterFindOneHistoricAlertBuildingInput>;
  device?: InputMaybe<FilterFindOneHistoricAlertDeviceInput>;
  id?: InputMaybe<Scalars['String']>;
  initiated?: InputMaybe<Scalars['Float']>;
  meta?: InputMaybe<FilterFindOneHistoricAlertMetaInput>;
  panel?: InputMaybe<FilterFindOneHistoricAlertPanelInput>;
  port?: InputMaybe<EnumHistoricAlertPort>;
  property?: InputMaybe<FilterFindOneHistoricAlertPropertyInput>;
  resolved?: InputMaybe<Scalars['Float']>;
  sourceId?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<FilterFindOneHistoricAlertTypeInput>;
  unit?: InputMaybe<FilterFindOneHistoricAlertUnitInput>;
  updated?: InputMaybe<Scalars['Float']>;
  zone?: InputMaybe<FilterFindOneHistoricAlertZoneInput>;
};

export type FilterFindOneHistoricAlertMetaInput = {
  id_str?: InputMaybe<Scalars['String']>;
  limit?: InputMaybe<Scalars['Float']>;
  message?: InputMaybe<Scalars['String']>;
  portName?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<Scalars['String']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterFindOneHistoricAlertOperatorsInput = {
  _id?: InputMaybe<FilterFindOneHistoricAlert_IdOperatorsInput>;
};

export type FilterFindOneHistoricAlertPanelInput = {
  id?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
};

export type FilterFindOneHistoricAlertPropertyContactInput = {
  email?: InputMaybe<Scalars['String']>;
  email2?: InputMaybe<Scalars['String']>;
  email3?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  smsNumber?: InputMaybe<Scalars['String']>;
  smsNumber2?: InputMaybe<Scalars['String']>;
  smsNumber3?: InputMaybe<Scalars['String']>;
  smsOptInStatus1?: InputMaybe<EnumHistoricAlertPropertyContactSmsOptInStatus1>;
  smsOptInStatus2?: InputMaybe<EnumHistoricAlertPropertyContactSmsOptInStatus2>;
  smsOptInStatus3?: InputMaybe<EnumHistoricAlertPropertyContactSmsOptInStatus3>;
  smsOptInTimestamp1?: InputMaybe<Scalars['Float']>;
  smsOptInTimestamp2?: InputMaybe<Scalars['Float']>;
  smsOptInTimestamp3?: InputMaybe<Scalars['Float']>;
};

export type FilterFindOneHistoricAlertPropertyInput = {
  contact?: InputMaybe<FilterFindOneHistoricAlertPropertyContactInput>;
  id?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
};

export type FilterFindOneHistoricAlertTypeInput = {
  id?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
};

export type FilterFindOneHistoricAlertUnitInput = {
  id?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
};

export type FilterFindOneHistoricAlertZoneInput = {
  id?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
};

export type FilterFindOneHistoricAlert_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['String']>;
  gte?: InputMaybe<Scalars['String']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  lt?: InputMaybe<Scalars['String']>;
  lte?: InputMaybe<Scalars['String']>;
  ne?: InputMaybe<Scalars['String']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']>;
};

export type FilterFindOneHistoricReadingDeviceIdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['String']>;
  gte?: InputMaybe<Scalars['String']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  lt?: InputMaybe<Scalars['String']>;
  lte?: InputMaybe<Scalars['String']>;
  ne?: InputMaybe<Scalars['String']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']>;
};

export type FilterFindOneHistoricReadingInput = {
  AND?: InputMaybe<Array<FilterFindOneHistoricReadingInput>>;
  OR?: InputMaybe<Array<FilterFindOneHistoricReadingInput>>;
  _id?: InputMaybe<Scalars['String']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterFindOneHistoricReadingOperatorsInput>;
  deviceId?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  sourceId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  type?: InputMaybe<Scalars['String']>;
  units?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<Scalars['String']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterFindOneHistoricReadingOperatorsInput = {
  _id?: InputMaybe<FilterFindOneHistoricReading_IdOperatorsInput>;
  deviceId?: InputMaybe<FilterFindOneHistoricReadingDeviceIdOperatorsInput>;
};

export type FilterFindOneHistoricReading_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['String']>;
  gte?: InputMaybe<Scalars['String']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  lt?: InputMaybe<Scalars['String']>;
  lte?: InputMaybe<Scalars['String']>;
  ne?: InputMaybe<Scalars['String']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']>;
};

export type FilterFindOneIndoorAirHandlerCoolSetpointInput = {
  id?: InputMaybe<Scalars['String']>;
  observedAt?: InputMaybe<Scalars['Float']>;
  previousId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  units?: InputMaybe<Scalars['String']>;
  updatePending?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<Scalars['Float']>;
};

export type FilterFindOneIndoorAirHandlerFanSpeedInput = {
  id?: InputMaybe<Scalars['String']>;
  observedAt?: InputMaybe<Scalars['Float']>;
  previousId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  units?: InputMaybe<Scalars['String']>;
  updatePending?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<Scalars['String']>;
};

export type FilterFindOneIndoorAirHandlerHeatSetpointInput = {
  id?: InputMaybe<Scalars['String']>;
  observedAt?: InputMaybe<Scalars['Float']>;
  previousId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  units?: InputMaybe<Scalars['String']>;
  updatePending?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<Scalars['Float']>;
};

export type FilterFindOneIndoorAirHandlerIndoorFanStatusInput = {
  id?: InputMaybe<Scalars['String']>;
  observedAt?: InputMaybe<Scalars['Float']>;
  previousId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  units?: InputMaybe<Scalars['String']>;
  updatePending?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<EnumIndoorAirHandlerIndoorFanStatusValue>;
};

export type FilterFindOneIndoorAirHandlerInput = {
  AND?: InputMaybe<Array<FilterFindOneDeviceInput>>;
  OR?: InputMaybe<Array<FilterFindOneDeviceInput>>;
  _id?: InputMaybe<Scalars['String']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterFindOneDeviceOperatorsInput>;
  alertTypes?: InputMaybe<FilterFindOneDeviceAlertTypesInput>;
  altDeviceId?: InputMaybe<Scalars['String']>;
  controlled?: InputMaybe<FilterFindOneDeviceControlledInput>;
  coolSetpoint?: InputMaybe<FilterFindOneIndoorAirHandlerCoolSetpointInput>;
  deviceId?: InputMaybe<Scalars['String']>;
  fanSpeed?: InputMaybe<FilterFindOneIndoorAirHandlerFanSpeedInput>;
  heatSetpoint?: InputMaybe<FilterFindOneIndoorAirHandlerHeatSetpointInput>;
  indoorFanStatus?: InputMaybe<FilterFindOneIndoorAirHandlerIndoorFanStatusInput>;
  installation?: InputMaybe<FilterFindOneDeviceInstallationInput>;
  location?: InputMaybe<Scalars['String']>;
  maxCoolSetpointLimit?: InputMaybe<FilterFindOneIndoorAirHandlerMaxCoolSetpointLimitInput>;
  maxHeatSetpointLimit?: InputMaybe<FilterFindOneIndoorAirHandlerMaxHeatSetpointLimitInput>;
  meta?: InputMaybe<FilterFindOneDeviceMetaInput>;
  minCoolSetpointLimit?: InputMaybe<FilterFindOneIndoorAirHandlerMinCoolSetpointLimitInput>;
  minHeatSetpointLimit?: InputMaybe<FilterFindOneIndoorAirHandlerMinHeatSetpointLimitInput>;
  /** The name of the device */
  name?: InputMaybe<Scalars['String']>;
  operatingMode?: InputMaybe<FilterFindOneIndoorAirHandlerOperatingModeInput>;
  operatingState?: InputMaybe<FilterFindOneIndoorAirHandlerOperatingStateInput>;
  panelId?: InputMaybe<Scalars['String']>;
  powerState?: InputMaybe<FilterFindOneDevicePowerStateInput>;
  propertyId?: InputMaybe<Scalars['String']>;
  sourceId?: InputMaybe<Scalars['String']>;
  temperature?: InputMaybe<FilterFindOneIndoorAirHandlerTemperatureInput>;
  timestamp?: InputMaybe<Scalars['Float']>;
  unitId?: InputMaybe<Scalars['String']>;
  updateStatus?: InputMaybe<Scalars['Boolean']>;
  vppId?: InputMaybe<Scalars['String']>;
  zoneId?: InputMaybe<Scalars['String']>;
};

export type FilterFindOneIndoorAirHandlerMaxCoolSetpointLimitInput = {
  id?: InputMaybe<Scalars['String']>;
  observedAt?: InputMaybe<Scalars['Float']>;
  previousId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  units?: InputMaybe<Scalars['String']>;
  updatePending?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<Scalars['Float']>;
};

export type FilterFindOneIndoorAirHandlerMaxHeatSetpointLimitInput = {
  id?: InputMaybe<Scalars['String']>;
  observedAt?: InputMaybe<Scalars['Float']>;
  previousId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  units?: InputMaybe<Scalars['String']>;
  updatePending?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<Scalars['Float']>;
};

export type FilterFindOneIndoorAirHandlerMinCoolSetpointLimitInput = {
  id?: InputMaybe<Scalars['String']>;
  observedAt?: InputMaybe<Scalars['Float']>;
  previousId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  units?: InputMaybe<Scalars['String']>;
  updatePending?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<Scalars['Float']>;
};

export type FilterFindOneIndoorAirHandlerMinHeatSetpointLimitInput = {
  id?: InputMaybe<Scalars['String']>;
  observedAt?: InputMaybe<Scalars['Float']>;
  previousId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  units?: InputMaybe<Scalars['String']>;
  updatePending?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<Scalars['Float']>;
};

export type FilterFindOneIndoorAirHandlerOperatingModeInput = {
  id?: InputMaybe<Scalars['String']>;
  observedAt?: InputMaybe<Scalars['Float']>;
  previousId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  units?: InputMaybe<Scalars['String']>;
  updatePending?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<Scalars['String']>;
};

export type FilterFindOneIndoorAirHandlerOperatingStateInput = {
  id?: InputMaybe<Scalars['String']>;
  observedAt?: InputMaybe<Scalars['Float']>;
  previousId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  units?: InputMaybe<Scalars['String']>;
  updatePending?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<Scalars['String']>;
};

export type FilterFindOneIndoorAirHandlerTemperatureInput = {
  id?: InputMaybe<Scalars['String']>;
  observedAt?: InputMaybe<Scalars['Float']>;
  previousId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  units?: InputMaybe<Scalars['String']>;
  updatePending?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<Scalars['Float']>;
};

export type FilterFindOneIndoorSensorHumidityInput = {
  id?: InputMaybe<Scalars['String']>;
  observedAt?: InputMaybe<Scalars['Float']>;
  previousId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  units?: InputMaybe<Scalars['String']>;
  updatePending?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<Scalars['Float']>;
};

export type FilterFindOneIndoorSensorInput = {
  AND?: InputMaybe<Array<FilterFindOneDeviceInput>>;
  OR?: InputMaybe<Array<FilterFindOneDeviceInput>>;
  _id?: InputMaybe<Scalars['String']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterFindOneDeviceOperatorsInput>;
  alertTypes?: InputMaybe<FilterFindOneDeviceAlertTypesInput>;
  controlled?: InputMaybe<FilterFindOneDeviceControlledInput>;
  deviceId?: InputMaybe<Scalars['String']>;
  humidity?: InputMaybe<FilterFindOneIndoorSensorHumidityInput>;
  installation?: InputMaybe<FilterFindOneDeviceInstallationInput>;
  location?: InputMaybe<Scalars['String']>;
  meta?: InputMaybe<FilterFindOneDeviceMetaInput>;
  /** The name of the device */
  name?: InputMaybe<Scalars['String']>;
  occupancy?: InputMaybe<FilterFindOneIndoorSensorOccupancyInput>;
  panelId?: InputMaybe<Scalars['String']>;
  powerState?: InputMaybe<FilterFindOneDevicePowerStateInput>;
  propertyId?: InputMaybe<Scalars['String']>;
  sourceId?: InputMaybe<Scalars['String']>;
  temperature?: InputMaybe<FilterFindOneIndoorSensorTemperatureInput>;
  timestamp?: InputMaybe<Scalars['Float']>;
  unitId?: InputMaybe<Scalars['String']>;
  updateStatus?: InputMaybe<Scalars['Boolean']>;
  voltage?: InputMaybe<FilterFindOneIndoorSensorVoltageInput>;
  vppId?: InputMaybe<Scalars['String']>;
  zoneId?: InputMaybe<Scalars['String']>;
};

export type FilterFindOneIndoorSensorOccupancyInput = {
  timestamp?: InputMaybe<Scalars['Float']>;
};

export type FilterFindOneIndoorSensorTemperatureInput = {
  id?: InputMaybe<Scalars['String']>;
  observedAt?: InputMaybe<Scalars['Float']>;
  previousId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  units?: InputMaybe<Scalars['String']>;
  updatePending?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<Scalars['Float']>;
};

export type FilterFindOneIndoorSensorVoltageInput = {
  id?: InputMaybe<Scalars['String']>;
  observedAt?: InputMaybe<Scalars['Float']>;
  previousId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  units?: InputMaybe<Scalars['String']>;
  updatePending?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<Scalars['Float']>;
};

export type FilterFindOneIngestionInput = {
  AND?: InputMaybe<Array<FilterFindOneIngestionInput>>;
  OR?: InputMaybe<Array<FilterFindOneIngestionInput>>;
  _id?: InputMaybe<Scalars['String']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterFindOneIngestionOperatorsInput>;
  date?: InputMaybe<Scalars['Date']>;
  fileName?: InputMaybe<Scalars['String']>;
  s3FileName?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<Scalars['String']>;
  userId?: InputMaybe<Scalars['String']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterFindOneIngestionOperatorsInput = {
  _id?: InputMaybe<FilterFindOneIngestion_IdOperatorsInput>;
};

export type FilterFindOneIngestion_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['String']>;
  gte?: InputMaybe<Scalars['String']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  lt?: InputMaybe<Scalars['String']>;
  lte?: InputMaybe<Scalars['String']>;
  ne?: InputMaybe<Scalars['String']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']>;
};

export type FilterFindOneKineticEnergyManagementSystemBearingTemperatureInput =
  {
    id?: InputMaybe<Scalars['String']>;
    observedAt?: InputMaybe<Scalars['Float']>;
    previousId?: InputMaybe<Scalars['String']>;
    timestamp?: InputMaybe<Scalars['Float']>;
    units?: InputMaybe<Scalars['String']>;
    updatePending?: InputMaybe<Scalars['Boolean']>;
    value?: InputMaybe<Scalars['Float']>;
  };

export type FilterFindOneKineticEnergyManagementSystemCurrentEnergyStoredInput =
  {
    id?: InputMaybe<Scalars['String']>;
    observedAt?: InputMaybe<Scalars['Float']>;
    previousId?: InputMaybe<Scalars['String']>;
    timestamp?: InputMaybe<Scalars['Float']>;
    units?: InputMaybe<Scalars['String']>;
    updatePending?: InputMaybe<Scalars['Boolean']>;
    value?: InputMaybe<Scalars['Float']>;
  };

export type FilterFindOneKineticEnergyManagementSystemCycleCountInput = {
  id?: InputMaybe<Scalars['String']>;
  observedAt?: InputMaybe<Scalars['Float']>;
  previousId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  units?: InputMaybe<Scalars['String']>;
  updatePending?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<Scalars['Float']>;
};

export type FilterFindOneKineticEnergyManagementSystemGeneratorCurrentInput = {
  id?: InputMaybe<Scalars['String']>;
  observedAt?: InputMaybe<Scalars['Float']>;
  previousId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  units?: InputMaybe<Scalars['String']>;
  updatePending?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<Scalars['Float']>;
};

export type FilterFindOneKineticEnergyManagementSystemGeneratorVoltageInput = {
  id?: InputMaybe<Scalars['String']>;
  observedAt?: InputMaybe<Scalars['Float']>;
  previousId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  units?: InputMaybe<Scalars['String']>;
  updatePending?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<Scalars['Float']>;
};

export type FilterFindOneKineticEnergyManagementSystemInput = {
  AND?: InputMaybe<Array<FilterFindOneDeviceInput>>;
  OR?: InputMaybe<Array<FilterFindOneDeviceInput>>;
  _id?: InputMaybe<Scalars['String']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterFindOneDeviceOperatorsInput>;
  alertTypes?: InputMaybe<FilterFindOneDeviceAlertTypesInput>;
  bearingTemperature?: InputMaybe<FilterFindOneKineticEnergyManagementSystemBearingTemperatureInput>;
  controlled?: InputMaybe<FilterFindOneDeviceControlledInput>;
  currentEnergyStored?: InputMaybe<FilterFindOneKineticEnergyManagementSystemCurrentEnergyStoredInput>;
  cycleCount?: InputMaybe<FilterFindOneKineticEnergyManagementSystemCycleCountInput>;
  deviceId?: InputMaybe<Scalars['String']>;
  generatorCurrent?: InputMaybe<FilterFindOneKineticEnergyManagementSystemGeneratorCurrentInput>;
  generatorVoltage?: InputMaybe<FilterFindOneKineticEnergyManagementSystemGeneratorVoltageInput>;
  installation?: InputMaybe<FilterFindOneDeviceInstallationInput>;
  location?: InputMaybe<Scalars['String']>;
  meta?: InputMaybe<FilterFindOneDeviceMetaInput>;
  /** The name of the device */
  name?: InputMaybe<Scalars['String']>;
  panelId?: InputMaybe<Scalars['String']>;
  powerState?: InputMaybe<FilterFindOneDevicePowerStateInput>;
  propertyId?: InputMaybe<Scalars['String']>;
  rotorSpeed?: InputMaybe<FilterFindOneKineticEnergyManagementSystemRotorSpeedInput>;
  sourceId?: InputMaybe<Scalars['String']>;
  spinDownTime?: InputMaybe<FilterFindOneKineticEnergyManagementSystemSpinDownTimeInput>;
  stateOfHealth?: InputMaybe<FilterFindOneKineticEnergyManagementSystemStateOfHealthInput>;
  systemEfficiency?: InputMaybe<FilterFindOneKineticEnergyManagementSystemSystemEfficiencyInput>;
  timestamp?: InputMaybe<Scalars['Float']>;
  unitId?: InputMaybe<Scalars['String']>;
  updateStatus?: InputMaybe<Scalars['Boolean']>;
  vacuumPressure?: InputMaybe<FilterFindOneKineticEnergyManagementSystemVacuumPressureInput>;
  vibrationMetrics?: InputMaybe<FilterFindOneKineticEnergyManagementSystemVibrationMetricsInput>;
  vppId?: InputMaybe<Scalars['String']>;
  zoneId?: InputMaybe<Scalars['String']>;
};

export type FilterFindOneKineticEnergyManagementSystemRotorSpeedInput = {
  id?: InputMaybe<Scalars['String']>;
  observedAt?: InputMaybe<Scalars['Float']>;
  previousId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  units?: InputMaybe<Scalars['String']>;
  updatePending?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<Scalars['Float']>;
};

export type FilterFindOneKineticEnergyManagementSystemSpinDownTimeInput = {
  id?: InputMaybe<Scalars['String']>;
  observedAt?: InputMaybe<Scalars['Float']>;
  previousId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  units?: InputMaybe<Scalars['String']>;
  updatePending?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<Scalars['Float']>;
};

export type FilterFindOneKineticEnergyManagementSystemStateOfHealthInput = {
  id?: InputMaybe<Scalars['String']>;
  observedAt?: InputMaybe<Scalars['Float']>;
  previousId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  units?: InputMaybe<Scalars['String']>;
  updatePending?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<Scalars['Float']>;
};

export type FilterFindOneKineticEnergyManagementSystemSystemEfficiencyInput = {
  id?: InputMaybe<Scalars['String']>;
  observedAt?: InputMaybe<Scalars['Float']>;
  previousId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  units?: InputMaybe<Scalars['String']>;
  updatePending?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<Scalars['Float']>;
};

export type FilterFindOneKineticEnergyManagementSystemVacuumPressureInput = {
  id?: InputMaybe<Scalars['String']>;
  observedAt?: InputMaybe<Scalars['Float']>;
  previousId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  units?: InputMaybe<Scalars['String']>;
  updatePending?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<Scalars['Float']>;
};

export type FilterFindOneKineticEnergyManagementSystemVibrationMetricsInput = {
  id?: InputMaybe<Scalars['String']>;
  observedAt?: InputMaybe<Scalars['Float']>;
  previousId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  units?: InputMaybe<Scalars['String']>;
  updatePending?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<Scalars['Float']>;
};

export type FilterFindOneLeakDetectorBatteryVoltageMinThresholdInput = {
  id?: InputMaybe<Scalars['String']>;
  observedAt?: InputMaybe<Scalars['Float']>;
  previousId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  units?: InputMaybe<Scalars['String']>;
  updatePending?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<Scalars['Float']>;
};

export type FilterFindOneLeakDetectorBatteryVoltageMinThresholdReachedInput = {
  id?: InputMaybe<Scalars['String']>;
  observedAt?: InputMaybe<Scalars['Float']>;
  previousId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  units?: InputMaybe<Scalars['String']>;
  updatePending?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<Scalars['Boolean']>;
};

export type FilterFindOneLeakDetectorInput = {
  AND?: InputMaybe<Array<FilterFindOneDeviceInput>>;
  OR?: InputMaybe<Array<FilterFindOneDeviceInput>>;
  _id?: InputMaybe<Scalars['String']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterFindOneDeviceOperatorsInput>;
  alertTypes?: InputMaybe<FilterFindOneDeviceAlertTypesInput>;
  batteryVoltageMinThreshold?: InputMaybe<FilterFindOneLeakDetectorBatteryVoltageMinThresholdInput>;
  batteryVoltageMinThresholdReached?: InputMaybe<FilterFindOneLeakDetectorBatteryVoltageMinThresholdReachedInput>;
  controlled?: InputMaybe<FilterFindOneDeviceControlledInput>;
  deviceId?: InputMaybe<Scalars['String']>;
  installation?: InputMaybe<FilterFindOneDeviceInstallationInput>;
  leakStatus1?: InputMaybe<FilterFindOneLeakDetectorLeakStatus1Input>;
  leakStatus2?: InputMaybe<FilterFindOneLeakDetectorLeakStatus2Input>;
  location?: InputMaybe<Scalars['String']>;
  meta?: InputMaybe<FilterFindOneDeviceMetaInput>;
  /** The name of the device */
  name?: InputMaybe<Scalars['String']>;
  panelId?: InputMaybe<Scalars['String']>;
  powerState?: InputMaybe<FilterFindOneDevicePowerStateInput>;
  propertyId?: InputMaybe<Scalars['String']>;
  sourceId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  unitId?: InputMaybe<Scalars['String']>;
  updateStatus?: InputMaybe<Scalars['Boolean']>;
  voltage?: InputMaybe<FilterFindOneLeakDetectorVoltageInput>;
  vppId?: InputMaybe<Scalars['String']>;
  zoneId?: InputMaybe<Scalars['String']>;
};

export type FilterFindOneLeakDetectorLeakStatus1Input = {
  id?: InputMaybe<Scalars['String']>;
  observedAt?: InputMaybe<Scalars['Float']>;
  previousId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  units?: InputMaybe<Scalars['String']>;
  updatePending?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<Scalars['Boolean']>;
};

export type FilterFindOneLeakDetectorLeakStatus2Input = {
  id?: InputMaybe<Scalars['String']>;
  observedAt?: InputMaybe<Scalars['Float']>;
  previousId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  units?: InputMaybe<Scalars['String']>;
  updatePending?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<Scalars['Boolean']>;
};

export type FilterFindOneLeakDetectorVoltageInput = {
  id?: InputMaybe<Scalars['String']>;
  observedAt?: InputMaybe<Scalars['Float']>;
  previousId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  units?: InputMaybe<Scalars['String']>;
  updatePending?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<Scalars['Float']>;
};

export type FilterFindOneLoopIndoorTemperatureInput = {
  id?: InputMaybe<Scalars['String']>;
  observedAt?: InputMaybe<Scalars['Float']>;
  previousId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  units?: InputMaybe<Scalars['String']>;
  updatePending?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<Scalars['Float']>;
};

export type FilterFindOneLoopInput = {
  AND?: InputMaybe<Array<FilterFindOneDeviceInput>>;
  OR?: InputMaybe<Array<FilterFindOneDeviceInput>>;
  _id?: InputMaybe<Scalars['String']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterFindOneDeviceOperatorsInput>;
  alertTypes?: InputMaybe<FilterFindOneDeviceAlertTypesInput>;
  controlled?: InputMaybe<FilterFindOneDeviceControlledInput>;
  deviceId?: InputMaybe<Scalars['String']>;
  indoorTemperature?: InputMaybe<FilterFindOneLoopIndoorTemperatureInput>;
  installation?: InputMaybe<FilterFindOneDeviceInstallationInput>;
  location?: InputMaybe<Scalars['String']>;
  meta?: InputMaybe<FilterFindOneDeviceMetaInput>;
  /** The name of the device */
  name?: InputMaybe<Scalars['String']>;
  panelId?: InputMaybe<Scalars['String']>;
  powerState?: InputMaybe<FilterFindOneDevicePowerStateInput>;
  propertyId?: InputMaybe<Scalars['String']>;
  returnTemperature?: InputMaybe<FilterFindOneLoopReturnTemperatureInput>;
  role?: InputMaybe<Scalars['String']>;
  sourceId?: InputMaybe<Scalars['String']>;
  supplyTemperature?: InputMaybe<FilterFindOneLoopSupplyTemperatureInput>;
  timestamp?: InputMaybe<Scalars['Float']>;
  unitId?: InputMaybe<Scalars['String']>;
  updateStatus?: InputMaybe<Scalars['Boolean']>;
  vppId?: InputMaybe<Scalars['String']>;
  zoneId?: InputMaybe<Scalars['String']>;
};

export type FilterFindOneLoopReturnTemperatureInput = {
  id?: InputMaybe<Scalars['String']>;
  observedAt?: InputMaybe<Scalars['Float']>;
  previousId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  units?: InputMaybe<Scalars['String']>;
  updatePending?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<Scalars['Float']>;
};

export type FilterFindOneLoopSupplyTemperatureInput = {
  id?: InputMaybe<Scalars['String']>;
  observedAt?: InputMaybe<Scalars['Float']>;
  previousId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  units?: InputMaybe<Scalars['String']>;
  updatePending?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<Scalars['Float']>;
};

export type FilterFindOneModbusAirHandlerAhuCoolSetpointInput = {
  id?: InputMaybe<Scalars['String']>;
  observedAt?: InputMaybe<Scalars['Float']>;
  previousId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  units?: InputMaybe<Scalars['String']>;
  updatePending?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<Scalars['Float']>;
};

export type FilterFindOneModbusAirHandlerAhuHeatSetpointInput = {
  id?: InputMaybe<Scalars['String']>;
  observedAt?: InputMaybe<Scalars['Float']>;
  previousId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  units?: InputMaybe<Scalars['String']>;
  updatePending?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<Scalars['Float']>;
};

export type FilterFindOneModbusAirHandlerAhuMaxHeatSetpointLimitInput = {
  id?: InputMaybe<Scalars['String']>;
  observedAt?: InputMaybe<Scalars['Float']>;
  previousId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  units?: InputMaybe<Scalars['String']>;
  updatePending?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<Scalars['Float']>;
};

export type FilterFindOneModbusAirHandlerAhuMinCoolSetpointLimitInput = {
  id?: InputMaybe<Scalars['String']>;
  observedAt?: InputMaybe<Scalars['Float']>;
  previousId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  units?: InputMaybe<Scalars['String']>;
  updatePending?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<Scalars['Float']>;
};

export type FilterFindOneModbusAirHandlerAhuModbusIdInput = {
  id?: InputMaybe<Scalars['String']>;
  observedAt?: InputMaybe<Scalars['Float']>;
  previousId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  units?: InputMaybe<Scalars['String']>;
  updatePending?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<Scalars['Float']>;
};

export type FilterFindOneModbusAirHandlerAirExchangeModeOnInput = {
  id?: InputMaybe<Scalars['String']>;
  observedAt?: InputMaybe<Scalars['Float']>;
  previousId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  units?: InputMaybe<Scalars['String']>;
  updatePending?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<Scalars['Boolean']>;
};

export type FilterFindOneModbusAirHandlerAirflowUnitsInput = {
  id?: InputMaybe<Scalars['String']>;
  observedAt?: InputMaybe<Scalars['Float']>;
  previousId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  units?: InputMaybe<Scalars['String']>;
  updatePending?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<Scalars['String']>;
};

export type FilterFindOneModbusAirHandlerAlarmAirRestrictionInput = {
  id?: InputMaybe<Scalars['String']>;
  observedAt?: InputMaybe<Scalars['Float']>;
  previousId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  units?: InputMaybe<Scalars['String']>;
  updatePending?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<Scalars['Boolean']>;
};

export type FilterFindOneModbusAirHandlerAlarmB1SensorFailInput = {
  id?: InputMaybe<Scalars['String']>;
  observedAt?: InputMaybe<Scalars['Float']>;
  previousId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  units?: InputMaybe<Scalars['String']>;
  updatePending?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<Scalars['Boolean']>;
};

export type FilterFindOneModbusAirHandlerAlarmB2SensorFailInput = {
  id?: InputMaybe<Scalars['String']>;
  observedAt?: InputMaybe<Scalars['Float']>;
  previousId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  units?: InputMaybe<Scalars['String']>;
  updatePending?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<Scalars['Boolean']>;
};

export type FilterFindOneModbusAirHandlerAlarmB3SensorFailInput = {
  id?: InputMaybe<Scalars['String']>;
  observedAt?: InputMaybe<Scalars['Float']>;
  previousId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  units?: InputMaybe<Scalars['String']>;
  updatePending?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<Scalars['Boolean']>;
};

export type FilterFindOneModbusAirHandlerAlarmB4SensorFailInput = {
  id?: InputMaybe<Scalars['String']>;
  observedAt?: InputMaybe<Scalars['Float']>;
  previousId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  units?: InputMaybe<Scalars['String']>;
  updatePending?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<Scalars['Boolean']>;
};

export type FilterFindOneModbusAirHandlerAlarmB6SensorFailInput = {
  id?: InputMaybe<Scalars['String']>;
  observedAt?: InputMaybe<Scalars['Float']>;
  previousId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  units?: InputMaybe<Scalars['String']>;
  updatePending?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<Scalars['Boolean']>;
};

export type FilterFindOneModbusAirHandlerAlarmChangeFiltersInput = {
  id?: InputMaybe<Scalars['String']>;
  observedAt?: InputMaybe<Scalars['Float']>;
  previousId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  units?: InputMaybe<Scalars['String']>;
  updatePending?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<Scalars['Boolean']>;
};

export type FilterFindOneModbusAirHandlerAlarmChangeHepaInput = {
  id?: InputMaybe<Scalars['String']>;
  observedAt?: InputMaybe<Scalars['Float']>;
  previousId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  units?: InputMaybe<Scalars['String']>;
  updatePending?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<Scalars['Boolean']>;
};

export type FilterFindOneModbusAirHandlerAlarmClockBoardInput = {
  id?: InputMaybe<Scalars['String']>;
  observedAt?: InputMaybe<Scalars['Float']>;
  previousId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  units?: InputMaybe<Scalars['String']>;
  updatePending?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<Scalars['Boolean']>;
};

export type FilterFindOneModbusAirHandlerAlarmCompressorFailInput = {
  id?: InputMaybe<Scalars['String']>;
  observedAt?: InputMaybe<Scalars['Float']>;
  previousId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  units?: InputMaybe<Scalars['String']>;
  updatePending?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<Scalars['Boolean']>;
};

export type FilterFindOneModbusAirHandlerAlarmExhaustFanStoppedInput = {
  id?: InputMaybe<Scalars['String']>;
  observedAt?: InputMaybe<Scalars['Float']>;
  previousId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  units?: InputMaybe<Scalars['String']>;
  updatePending?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<Scalars['Boolean']>;
};

export type FilterFindOneModbusAirHandlerAlarmExtendedMemoryInput = {
  id?: InputMaybe<Scalars['String']>;
  observedAt?: InputMaybe<Scalars['Float']>;
  previousId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  units?: InputMaybe<Scalars['String']>;
  updatePending?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<Scalars['Boolean']>;
};

export type FilterFindOneModbusAirHandlerAlarmFanAbReversedInput = {
  id?: InputMaybe<Scalars['String']>;
  observedAt?: InputMaybe<Scalars['Float']>;
  previousId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  units?: InputMaybe<Scalars['String']>;
  updatePending?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<Scalars['Boolean']>;
};

export type FilterFindOneModbusAirHandlerAlarmFanANegPressureOpt1Input = {
  id?: InputMaybe<Scalars['String']>;
  observedAt?: InputMaybe<Scalars['Float']>;
  previousId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  units?: InputMaybe<Scalars['String']>;
  updatePending?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<Scalars['Boolean']>;
};

export type FilterFindOneModbusAirHandlerAlarmFanANegPressureOpt2Input = {
  id?: InputMaybe<Scalars['String']>;
  observedAt?: InputMaybe<Scalars['Float']>;
  previousId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  units?: InputMaybe<Scalars['String']>;
  updatePending?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<Scalars['Boolean']>;
};

export type FilterFindOneModbusAirHandlerAlarmGlobalAlarmInput = {
  id?: InputMaybe<Scalars['String']>;
  observedAt?: InputMaybe<Scalars['Float']>;
  previousId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  units?: InputMaybe<Scalars['String']>;
  updatePending?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<Scalars['Boolean']>;
};

export type FilterFindOneModbusAirHandlerAlarmHighPressureInput = {
  id?: InputMaybe<Scalars['String']>;
  observedAt?: InputMaybe<Scalars['Float']>;
  previousId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  units?: InputMaybe<Scalars['String']>;
  updatePending?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<Scalars['Boolean']>;
};

export type FilterFindOneModbusAirHandlerAlarmLowPressureInput = {
  id?: InputMaybe<Scalars['String']>;
  observedAt?: InputMaybe<Scalars['Float']>;
  previousId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  units?: InputMaybe<Scalars['String']>;
  updatePending?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<Scalars['Boolean']>;
};

export type FilterFindOneModbusAirHandlerAlarmRefrigerantLeakInput = {
  id?: InputMaybe<Scalars['String']>;
  observedAt?: InputMaybe<Scalars['Float']>;
  previousId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  units?: InputMaybe<Scalars['String']>;
  updatePending?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<Scalars['Boolean']>;
};

export type FilterFindOneModbusAirHandlerAlarmSupplyFanStoppedInput = {
  id?: InputMaybe<Scalars['String']>;
  observedAt?: InputMaybe<Scalars['Float']>;
  previousId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  units?: InputMaybe<Scalars['String']>;
  updatePending?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<Scalars['Boolean']>;
};

export type FilterFindOneModbusAirHandlerAllowTenantChangeRhSetpointInput = {
  id?: InputMaybe<Scalars['String']>;
  observedAt?: InputMaybe<Scalars['Float']>;
  previousId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  units?: InputMaybe<Scalars['String']>;
  updatePending?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<Scalars['Boolean']>;
};

export type FilterFindOneModbusAirHandlerAllowTenantChangeTempSetpointsInput = {
  id?: InputMaybe<Scalars['String']>;
  observedAt?: InputMaybe<Scalars['Float']>;
  previousId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  units?: InputMaybe<Scalars['String']>;
  updatePending?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<Scalars['Boolean']>;
};

export type FilterFindOneModbusAirHandlerAllowTenantOnOffInput = {
  id?: InputMaybe<Scalars['String']>;
  observedAt?: InputMaybe<Scalars['Float']>;
  previousId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  units?: InputMaybe<Scalars['String']>;
  updatePending?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<Scalars['Boolean']>;
};

export type FilterFindOneModbusAirHandlerAltitudeInput = {
  id?: InputMaybe<Scalars['String']>;
  observedAt?: InputMaybe<Scalars['Float']>;
  previousId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  units?: InputMaybe<Scalars['String']>;
  updatePending?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<Scalars['Float']>;
};

export type FilterFindOneModbusAirHandlerAuxCoolingEnabledInput = {
  id?: InputMaybe<Scalars['String']>;
  observedAt?: InputMaybe<Scalars['Float']>;
  previousId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  units?: InputMaybe<Scalars['String']>;
  updatePending?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<Scalars['Boolean']>;
};

export type FilterFindOneModbusAirHandlerBiosVersionInput = {
  id?: InputMaybe<Scalars['String']>;
  observedAt?: InputMaybe<Scalars['Float']>;
  previousId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  units?: InputMaybe<Scalars['String']>;
  updatePending?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<Scalars['Float']>;
};

export type FilterFindOneModbusAirHandlerBootVersionInput = {
  id?: InputMaybe<Scalars['String']>;
  observedAt?: InputMaybe<Scalars['Float']>;
  previousId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  units?: InputMaybe<Scalars['String']>;
  updatePending?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<Scalars['Float']>;
};

export type FilterFindOneModbusAirHandlerCompressorOnInput = {
  id?: InputMaybe<Scalars['String']>;
  observedAt?: InputMaybe<Scalars['Float']>;
  previousId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  units?: InputMaybe<Scalars['String']>;
  updatePending?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<Scalars['Boolean']>;
};

export type FilterFindOneModbusAirHandlerConditionedTemperatureInput = {
  id?: InputMaybe<Scalars['String']>;
  observedAt?: InputMaybe<Scalars['Float']>;
  previousId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  units?: InputMaybe<Scalars['String']>;
  updatePending?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<Scalars['Float']>;
};

export type FilterFindOneModbusAirHandlerDamperPositionInput = {
  id?: InputMaybe<Scalars['String']>;
  observedAt?: InputMaybe<Scalars['Float']>;
  previousId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  units?: InputMaybe<Scalars['String']>;
  updatePending?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<Scalars['String']>;
};

export type FilterFindOneModbusAirHandlerDefrostTemperatureInput = {
  id?: InputMaybe<Scalars['String']>;
  observedAt?: InputMaybe<Scalars['Float']>;
  previousId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  units?: InputMaybe<Scalars['String']>;
  updatePending?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<Scalars['Float']>;
};

export type FilterFindOneModbusAirHandlerEnableTenantModeInput = {
  id?: InputMaybe<Scalars['String']>;
  observedAt?: InputMaybe<Scalars['Float']>;
  previousId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  units?: InputMaybe<Scalars['String']>;
  updatePending?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<Scalars['Boolean']>;
};

export type FilterFindOneModbusAirHandlerExhaustFanAirflowInput = {
  id?: InputMaybe<Scalars['String']>;
  observedAt?: InputMaybe<Scalars['Float']>;
  previousId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  units?: InputMaybe<Scalars['String']>;
  updatePending?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<Scalars['Float']>;
};

export type FilterFindOneModbusAirHandlerExhaustFanOnInput = {
  id?: InputMaybe<Scalars['String']>;
  observedAt?: InputMaybe<Scalars['Float']>;
  previousId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  units?: InputMaybe<Scalars['String']>;
  updatePending?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<Scalars['Boolean']>;
};

export type FilterFindOneModbusAirHandlerFiltersServiceTimeInput = {
  id?: InputMaybe<Scalars['String']>;
  observedAt?: InputMaybe<Scalars['Float']>;
  previousId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  units?: InputMaybe<Scalars['String']>;
  updatePending?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<Scalars['Float']>;
};

export type FilterFindOneModbusAirHandlerFreshAirSetpointInput = {
  id?: InputMaybe<Scalars['String']>;
  observedAt?: InputMaybe<Scalars['Float']>;
  previousId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  units?: InputMaybe<Scalars['String']>;
  updatePending?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<Scalars['Float']>;
};

export type FilterFindOneModbusAirHandlerGTerminalOnInput = {
  id?: InputMaybe<Scalars['String']>;
  observedAt?: InputMaybe<Scalars['Float']>;
  previousId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  units?: InputMaybe<Scalars['String']>;
  updatePending?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<Scalars['Boolean']>;
};

export type FilterFindOneModbusAirHandlerHTerminalOnInput = {
  id?: InputMaybe<Scalars['String']>;
  observedAt?: InputMaybe<Scalars['Float']>;
  previousId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  units?: InputMaybe<Scalars['String']>;
  updatePending?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<Scalars['Boolean']>;
};

export type FilterFindOneModbusAirHandlerHeatPumpModeOnInput = {
  id?: InputMaybe<Scalars['String']>;
  observedAt?: InputMaybe<Scalars['Float']>;
  previousId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  units?: InputMaybe<Scalars['String']>;
  updatePending?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<Scalars['Boolean']>;
};

export type FilterFindOneModbusAirHandlerHeatingElementOnInput = {
  id?: InputMaybe<Scalars['String']>;
  observedAt?: InputMaybe<Scalars['Float']>;
  previousId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  units?: InputMaybe<Scalars['String']>;
  updatePending?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<Scalars['Boolean']>;
};

export type FilterFindOneModbusAirHandlerHepaServiceTimeInput = {
  id?: InputMaybe<Scalars['String']>;
  observedAt?: InputMaybe<Scalars['Float']>;
  previousId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  units?: InputMaybe<Scalars['String']>;
  updatePending?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<Scalars['Float']>;
};

export type FilterFindOneModbusAirHandlerIndoorRhInput = {
  id?: InputMaybe<Scalars['String']>;
  observedAt?: InputMaybe<Scalars['Float']>;
  previousId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  units?: InputMaybe<Scalars['String']>;
  updatePending?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<Scalars['Float']>;
};

export type FilterFindOneModbusAirHandlerIndoorTemperatureInput = {
  id?: InputMaybe<Scalars['String']>;
  observedAt?: InputMaybe<Scalars['Float']>;
  previousId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  units?: InputMaybe<Scalars['String']>;
  updatePending?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<Scalars['Float']>;
};

export type FilterFindOneModbusAirHandlerInput = {
  AND?: InputMaybe<Array<FilterFindOneDeviceInput>>;
  OR?: InputMaybe<Array<FilterFindOneDeviceInput>>;
  _id?: InputMaybe<Scalars['String']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterFindOneDeviceOperatorsInput>;
  ahuCoolSetpoint?: InputMaybe<FilterFindOneModbusAirHandlerAhuCoolSetpointInput>;
  ahuHeatSetpoint?: InputMaybe<FilterFindOneModbusAirHandlerAhuHeatSetpointInput>;
  ahuMaxHeatSetpointLimit?: InputMaybe<FilterFindOneModbusAirHandlerAhuMaxHeatSetpointLimitInput>;
  ahuMinCoolSetpointLimit?: InputMaybe<FilterFindOneModbusAirHandlerAhuMinCoolSetpointLimitInput>;
  ahuModbusId?: InputMaybe<FilterFindOneModbusAirHandlerAhuModbusIdInput>;
  airExchangeModeOn?: InputMaybe<FilterFindOneModbusAirHandlerAirExchangeModeOnInput>;
  airflowUnits?: InputMaybe<FilterFindOneModbusAirHandlerAirflowUnitsInput>;
  alarmAirRestriction?: InputMaybe<FilterFindOneModbusAirHandlerAlarmAirRestrictionInput>;
  alarmB1SensorFail?: InputMaybe<FilterFindOneModbusAirHandlerAlarmB1SensorFailInput>;
  alarmB2SensorFail?: InputMaybe<FilterFindOneModbusAirHandlerAlarmB2SensorFailInput>;
  alarmB3SensorFail?: InputMaybe<FilterFindOneModbusAirHandlerAlarmB3SensorFailInput>;
  alarmB4SensorFail?: InputMaybe<FilterFindOneModbusAirHandlerAlarmB4SensorFailInput>;
  alarmB6SensorFail?: InputMaybe<FilterFindOneModbusAirHandlerAlarmB6SensorFailInput>;
  alarmChangeFilters?: InputMaybe<FilterFindOneModbusAirHandlerAlarmChangeFiltersInput>;
  alarmChangeHepa?: InputMaybe<FilterFindOneModbusAirHandlerAlarmChangeHepaInput>;
  alarmClockBoard?: InputMaybe<FilterFindOneModbusAirHandlerAlarmClockBoardInput>;
  alarmCompressorFail?: InputMaybe<FilterFindOneModbusAirHandlerAlarmCompressorFailInput>;
  alarmExhaustFanStopped?: InputMaybe<FilterFindOneModbusAirHandlerAlarmExhaustFanStoppedInput>;
  alarmExtendedMemory?: InputMaybe<FilterFindOneModbusAirHandlerAlarmExtendedMemoryInput>;
  alarmFanABReversed?: InputMaybe<FilterFindOneModbusAirHandlerAlarmFanAbReversedInput>;
  alarmFanANegPressureOpt1?: InputMaybe<FilterFindOneModbusAirHandlerAlarmFanANegPressureOpt1Input>;
  alarmFanANegPressureOpt2?: InputMaybe<FilterFindOneModbusAirHandlerAlarmFanANegPressureOpt2Input>;
  alarmGlobalAlarm?: InputMaybe<FilterFindOneModbusAirHandlerAlarmGlobalAlarmInput>;
  alarmHighPressure?: InputMaybe<FilterFindOneModbusAirHandlerAlarmHighPressureInput>;
  alarmLowPressure?: InputMaybe<FilterFindOneModbusAirHandlerAlarmLowPressureInput>;
  alarmRefrigerantLeak?: InputMaybe<FilterFindOneModbusAirHandlerAlarmRefrigerantLeakInput>;
  alarmSupplyFanStopped?: InputMaybe<FilterFindOneModbusAirHandlerAlarmSupplyFanStoppedInput>;
  alertTypes?: InputMaybe<FilterFindOneDeviceAlertTypesInput>;
  allowTenantChangeRHSetpoint?: InputMaybe<FilterFindOneModbusAirHandlerAllowTenantChangeRhSetpointInput>;
  allowTenantChangeTempSetpoints?: InputMaybe<FilterFindOneModbusAirHandlerAllowTenantChangeTempSetpointsInput>;
  allowTenantOnOff?: InputMaybe<FilterFindOneModbusAirHandlerAllowTenantOnOffInput>;
  altitude?: InputMaybe<FilterFindOneModbusAirHandlerAltitudeInput>;
  auxCoolingEnabled?: InputMaybe<FilterFindOneModbusAirHandlerAuxCoolingEnabledInput>;
  biosVersion?: InputMaybe<FilterFindOneModbusAirHandlerBiosVersionInput>;
  bootVersion?: InputMaybe<FilterFindOneModbusAirHandlerBootVersionInput>;
  compressorOn?: InputMaybe<FilterFindOneModbusAirHandlerCompressorOnInput>;
  conditionedTemperature?: InputMaybe<FilterFindOneModbusAirHandlerConditionedTemperatureInput>;
  controlled?: InputMaybe<FilterFindOneDeviceControlledInput>;
  damperPosition?: InputMaybe<FilterFindOneModbusAirHandlerDamperPositionInput>;
  defrostTemperature?: InputMaybe<FilterFindOneModbusAirHandlerDefrostTemperatureInput>;
  deviceId?: InputMaybe<Scalars['String']>;
  enableTenantMode?: InputMaybe<FilterFindOneModbusAirHandlerEnableTenantModeInput>;
  exhaustFanAirflow?: InputMaybe<FilterFindOneModbusAirHandlerExhaustFanAirflowInput>;
  exhaustFanOn?: InputMaybe<FilterFindOneModbusAirHandlerExhaustFanOnInput>;
  filtersServiceTime?: InputMaybe<FilterFindOneModbusAirHandlerFiltersServiceTimeInput>;
  freshAirSetpoint?: InputMaybe<FilterFindOneModbusAirHandlerFreshAirSetpointInput>;
  gTerminalOn?: InputMaybe<FilterFindOneModbusAirHandlerGTerminalOnInput>;
  hTerminalOn?: InputMaybe<FilterFindOneModbusAirHandlerHTerminalOnInput>;
  heatPumpModeOn?: InputMaybe<FilterFindOneModbusAirHandlerHeatPumpModeOnInput>;
  heatingElementOn?: InputMaybe<FilterFindOneModbusAirHandlerHeatingElementOnInput>;
  hepaServiceTime?: InputMaybe<FilterFindOneModbusAirHandlerHepaServiceTimeInput>;
  indoorRH?: InputMaybe<FilterFindOneModbusAirHandlerIndoorRhInput>;
  indoorTemperature?: InputMaybe<FilterFindOneModbusAirHandlerIndoorTemperatureInput>;
  installation?: InputMaybe<FilterFindOneDeviceInstallationInput>;
  location?: InputMaybe<Scalars['String']>;
  meta?: InputMaybe<FilterFindOneDeviceMetaInput>;
  /** The name of the device */
  name?: InputMaybe<Scalars['String']>;
  outsideTemperature?: InputMaybe<FilterFindOneModbusAirHandlerOutsideTemperatureInput>;
  panelId?: InputMaybe<Scalars['String']>;
  powerState?: InputMaybe<FilterFindOneDevicePowerStateInput>;
  propertyId?: InputMaybe<Scalars['String']>;
  recirculationModeOn?: InputMaybe<FilterFindOneModbusAirHandlerRecirculationModeOnInput>;
  resetFiltersServiceTime?: InputMaybe<FilterFindOneModbusAirHandlerResetFiltersServiceTimeInput>;
  resetHepaServiceTime?: InputMaybe<FilterFindOneModbusAirHandlerResetHepaServiceTimeInput>;
  reversibleValveOnWhen?: InputMaybe<FilterFindOneModbusAirHandlerReversibleValveOnWhenInput>;
  rhSetpoint?: InputMaybe<FilterFindOneModbusAirHandlerRhSetpointInput>;
  showerDetectorEnabled?: InputMaybe<FilterFindOneModbusAirHandlerShowerDetectorEnabledInput>;
  softwareReleaseType?: InputMaybe<FilterFindOneModbusAirHandlerSoftwareReleaseTypeInput>;
  softwareVersion?: InputMaybe<FilterFindOneModbusAirHandlerSoftwareVersionInput>;
  sourceId?: InputMaybe<Scalars['String']>;
  supplyFanAirflow?: InputMaybe<FilterFindOneModbusAirHandlerSupplyFanAirflowInput>;
  supplyFanOn?: InputMaybe<FilterFindOneModbusAirHandlerSupplyFanOnInput>;
  supplyFanStaticPressureH2O?: InputMaybe<FilterFindOneModbusAirHandlerSupplyFanStaticPressureH2OInput>;
  systemAutoMode?: InputMaybe<FilterFindOneModbusAirHandlerSystemAutoModeInput>;
  systemOnOff?: InputMaybe<FilterFindOneModbusAirHandlerSystemOnOffInput>;
  temperatureUnits?: InputMaybe<FilterFindOneModbusAirHandlerTemperatureUnitsInput>;
  tenantModePassword?: InputMaybe<FilterFindOneModbusAirHandlerTenantModePasswordInput>;
  timestamp?: InputMaybe<Scalars['Float']>;
  unitId?: InputMaybe<Scalars['String']>;
  updateStatus?: InputMaybe<Scalars['Boolean']>;
  ventilationMode?: InputMaybe<FilterFindOneModbusAirHandlerVentilationModeInput>;
  vppId?: InputMaybe<Scalars['String']>;
  wTerminalOn?: InputMaybe<FilterFindOneModbusAirHandlerWTerminalOnInput>;
  winterRhAdjustEnabled?: InputMaybe<FilterFindOneModbusAirHandlerWinterRhAdjustEnabledInput>;
  yTerminalOn?: InputMaybe<FilterFindOneModbusAirHandlerYTerminalOnInput>;
  zmbAhuRequestsSent?: InputMaybe<FilterFindOneModbusAirHandlerZmbAhuRequestsSentInput>;
  zmbAhuRequestsSentFailed?: InputMaybe<FilterFindOneModbusAirHandlerZmbAhuRequestsSentFailedInput>;
  zmbAirHandlerAlarm?: InputMaybe<FilterFindOneModbusAirHandlerZmbAirHandlerAlarmInput>;
  zmbCoreRequestsRecvd?: InputMaybe<FilterFindOneModbusAirHandlerZmbCoreRequestsRecvdInput>;
  zmbCpuTemperature?: InputMaybe<FilterFindOneModbusAirHandlerZmbCpuTemperatureInput>;
  zmbFirmwareVersion?: InputMaybe<FilterFindOneModbusAirHandlerZmbFirmwareVersionInput>;
  zmbGlobalAlarm?: InputMaybe<FilterFindOneModbusAirHandlerZmbGlobalAlarmInput>;
  zmbLeakDetected?: InputMaybe<FilterFindOneModbusAirHandlerZmbLeakDetectedInput>;
  zmbLeakDetectorInstalled?: InputMaybe<FilterFindOneModbusAirHandlerZmbLeakDetectorInstalledInput>;
  zmbModbusRequestDelay?: InputMaybe<FilterFindOneModbusAirHandlerZmbModbusRequestDelayInput>;
  zmbPollingFrequency?: InputMaybe<FilterFindOneModbusAirHandlerZmbPollingFrequencyInput>;
  zmbRequestsRecvdInvalid?: InputMaybe<FilterFindOneModbusAirHandlerZmbRequestsRecvdInvalidInput>;
  zmbSystemUptime?: InputMaybe<FilterFindOneModbusAirHandlerZmbSystemUptimeInput>;
  zmbThermostatAlarm?: InputMaybe<FilterFindOneModbusAirHandlerZmbThermostatAlarmInput>;
  zmbTstatRequestsRecvd?: InputMaybe<FilterFindOneModbusAirHandlerZmbTstatRequestsRecvdInput>;
  zoneId?: InputMaybe<Scalars['String']>;
};

export type FilterFindOneModbusAirHandlerOutsideTemperatureInput = {
  id?: InputMaybe<Scalars['String']>;
  observedAt?: InputMaybe<Scalars['Float']>;
  previousId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  units?: InputMaybe<Scalars['String']>;
  updatePending?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<Scalars['Float']>;
};

export type FilterFindOneModbusAirHandlerRecirculationModeOnInput = {
  id?: InputMaybe<Scalars['String']>;
  observedAt?: InputMaybe<Scalars['Float']>;
  previousId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  units?: InputMaybe<Scalars['String']>;
  updatePending?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<Scalars['Boolean']>;
};

export type FilterFindOneModbusAirHandlerResetFiltersServiceTimeInput = {
  id?: InputMaybe<Scalars['String']>;
  observedAt?: InputMaybe<Scalars['Float']>;
  previousId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  units?: InputMaybe<Scalars['String']>;
  updatePending?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<Scalars['String']>;
};

export type FilterFindOneModbusAirHandlerResetHepaServiceTimeInput = {
  id?: InputMaybe<Scalars['String']>;
  observedAt?: InputMaybe<Scalars['Float']>;
  previousId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  units?: InputMaybe<Scalars['String']>;
  updatePending?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<Scalars['String']>;
};

export type FilterFindOneModbusAirHandlerReversibleValveOnWhenInput = {
  id?: InputMaybe<Scalars['String']>;
  observedAt?: InputMaybe<Scalars['Float']>;
  previousId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  units?: InputMaybe<Scalars['String']>;
  updatePending?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<Scalars['String']>;
};

export type FilterFindOneModbusAirHandlerRhSetpointInput = {
  id?: InputMaybe<Scalars['String']>;
  observedAt?: InputMaybe<Scalars['Float']>;
  previousId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  units?: InputMaybe<Scalars['String']>;
  updatePending?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<Scalars['Float']>;
};

export type FilterFindOneModbusAirHandlerShowerDetectorEnabledInput = {
  id?: InputMaybe<Scalars['String']>;
  observedAt?: InputMaybe<Scalars['Float']>;
  previousId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  units?: InputMaybe<Scalars['String']>;
  updatePending?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<Scalars['Boolean']>;
};

export type FilterFindOneModbusAirHandlerSoftwareReleaseTypeInput = {
  id?: InputMaybe<Scalars['String']>;
  observedAt?: InputMaybe<Scalars['Float']>;
  previousId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  units?: InputMaybe<Scalars['String']>;
  updatePending?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<Scalars['String']>;
};

export type FilterFindOneModbusAirHandlerSoftwareVersionInput = {
  id?: InputMaybe<Scalars['String']>;
  observedAt?: InputMaybe<Scalars['Float']>;
  previousId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  units?: InputMaybe<Scalars['String']>;
  updatePending?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<Scalars['Float']>;
};

export type FilterFindOneModbusAirHandlerSupplyFanAirflowInput = {
  id?: InputMaybe<Scalars['String']>;
  observedAt?: InputMaybe<Scalars['Float']>;
  previousId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  units?: InputMaybe<Scalars['String']>;
  updatePending?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<Scalars['Float']>;
};

export type FilterFindOneModbusAirHandlerSupplyFanOnInput = {
  id?: InputMaybe<Scalars['String']>;
  observedAt?: InputMaybe<Scalars['Float']>;
  previousId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  units?: InputMaybe<Scalars['String']>;
  updatePending?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<Scalars['Boolean']>;
};

export type FilterFindOneModbusAirHandlerSupplyFanStaticPressureH2OInput = {
  id?: InputMaybe<Scalars['String']>;
  observedAt?: InputMaybe<Scalars['Float']>;
  previousId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  units?: InputMaybe<Scalars['String']>;
  updatePending?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<Scalars['Float']>;
};

export type FilterFindOneModbusAirHandlerSystemAutoModeInput = {
  id?: InputMaybe<Scalars['String']>;
  observedAt?: InputMaybe<Scalars['Float']>;
  previousId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  units?: InputMaybe<Scalars['String']>;
  updatePending?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<Scalars['String']>;
};

export type FilterFindOneModbusAirHandlerSystemOnOffInput = {
  id?: InputMaybe<Scalars['String']>;
  observedAt?: InputMaybe<Scalars['Float']>;
  previousId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  units?: InputMaybe<Scalars['String']>;
  updatePending?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<Scalars['String']>;
};

export type FilterFindOneModbusAirHandlerTemperatureUnitsInput = {
  id?: InputMaybe<Scalars['String']>;
  observedAt?: InputMaybe<Scalars['Float']>;
  previousId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  units?: InputMaybe<Scalars['String']>;
  updatePending?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<Scalars['String']>;
};

export type FilterFindOneModbusAirHandlerTenantModePasswordInput = {
  id?: InputMaybe<Scalars['String']>;
  observedAt?: InputMaybe<Scalars['Float']>;
  previousId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  units?: InputMaybe<Scalars['String']>;
  updatePending?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<Scalars['String']>;
};

export type FilterFindOneModbusAirHandlerVentilationModeInput = {
  id?: InputMaybe<Scalars['String']>;
  observedAt?: InputMaybe<Scalars['Float']>;
  previousId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  units?: InputMaybe<Scalars['String']>;
  updatePending?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<Scalars['String']>;
};

export type FilterFindOneModbusAirHandlerWTerminalOnInput = {
  id?: InputMaybe<Scalars['String']>;
  observedAt?: InputMaybe<Scalars['Float']>;
  previousId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  units?: InputMaybe<Scalars['String']>;
  updatePending?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<Scalars['Boolean']>;
};

export type FilterFindOneModbusAirHandlerWinterRhAdjustEnabledInput = {
  id?: InputMaybe<Scalars['String']>;
  observedAt?: InputMaybe<Scalars['Float']>;
  previousId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  units?: InputMaybe<Scalars['String']>;
  updatePending?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<Scalars['Boolean']>;
};

export type FilterFindOneModbusAirHandlerYTerminalOnInput = {
  id?: InputMaybe<Scalars['String']>;
  observedAt?: InputMaybe<Scalars['Float']>;
  previousId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  units?: InputMaybe<Scalars['String']>;
  updatePending?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<Scalars['Boolean']>;
};

export type FilterFindOneModbusAirHandlerZmbAhuRequestsSentFailedInput = {
  id?: InputMaybe<Scalars['String']>;
  observedAt?: InputMaybe<Scalars['Float']>;
  previousId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  units?: InputMaybe<Scalars['String']>;
  updatePending?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<Scalars['Float']>;
};

export type FilterFindOneModbusAirHandlerZmbAhuRequestsSentInput = {
  id?: InputMaybe<Scalars['String']>;
  observedAt?: InputMaybe<Scalars['Float']>;
  previousId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  units?: InputMaybe<Scalars['String']>;
  updatePending?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<Scalars['Float']>;
};

export type FilterFindOneModbusAirHandlerZmbAirHandlerAlarmInput = {
  id?: InputMaybe<Scalars['String']>;
  observedAt?: InputMaybe<Scalars['Float']>;
  previousId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  units?: InputMaybe<Scalars['String']>;
  updatePending?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<Scalars['Boolean']>;
};

export type FilterFindOneModbusAirHandlerZmbCoreRequestsRecvdInput = {
  id?: InputMaybe<Scalars['String']>;
  observedAt?: InputMaybe<Scalars['Float']>;
  previousId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  units?: InputMaybe<Scalars['String']>;
  updatePending?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<Scalars['Float']>;
};

export type FilterFindOneModbusAirHandlerZmbCpuTemperatureInput = {
  id?: InputMaybe<Scalars['String']>;
  observedAt?: InputMaybe<Scalars['Float']>;
  previousId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  units?: InputMaybe<Scalars['String']>;
  updatePending?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<Scalars['Float']>;
};

export type FilterFindOneModbusAirHandlerZmbFirmwareVersionInput = {
  id?: InputMaybe<Scalars['String']>;
  observedAt?: InputMaybe<Scalars['Float']>;
  previousId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  units?: InputMaybe<Scalars['String']>;
  updatePending?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<Scalars['String']>;
};

export type FilterFindOneModbusAirHandlerZmbGlobalAlarmInput = {
  id?: InputMaybe<Scalars['String']>;
  observedAt?: InputMaybe<Scalars['Float']>;
  previousId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  units?: InputMaybe<Scalars['String']>;
  updatePending?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<Scalars['Boolean']>;
};

export type FilterFindOneModbusAirHandlerZmbLeakDetectedInput = {
  id?: InputMaybe<Scalars['String']>;
  observedAt?: InputMaybe<Scalars['Float']>;
  previousId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  units?: InputMaybe<Scalars['String']>;
  updatePending?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<Scalars['Boolean']>;
};

export type FilterFindOneModbusAirHandlerZmbLeakDetectorInstalledInput = {
  id?: InputMaybe<Scalars['String']>;
  observedAt?: InputMaybe<Scalars['Float']>;
  previousId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  units?: InputMaybe<Scalars['String']>;
  updatePending?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<Scalars['Boolean']>;
};

export type FilterFindOneModbusAirHandlerZmbModbusRequestDelayInput = {
  id?: InputMaybe<Scalars['String']>;
  observedAt?: InputMaybe<Scalars['Float']>;
  previousId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  units?: InputMaybe<Scalars['String']>;
  updatePending?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<Scalars['Float']>;
};

export type FilterFindOneModbusAirHandlerZmbPollingFrequencyInput = {
  id?: InputMaybe<Scalars['String']>;
  observedAt?: InputMaybe<Scalars['Float']>;
  previousId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  units?: InputMaybe<Scalars['String']>;
  updatePending?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<Scalars['Float']>;
};

export type FilterFindOneModbusAirHandlerZmbRequestsRecvdInvalidInput = {
  id?: InputMaybe<Scalars['String']>;
  observedAt?: InputMaybe<Scalars['Float']>;
  previousId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  units?: InputMaybe<Scalars['String']>;
  updatePending?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<Scalars['Float']>;
};

export type FilterFindOneModbusAirHandlerZmbSystemUptimeInput = {
  id?: InputMaybe<Scalars['String']>;
  observedAt?: InputMaybe<Scalars['Float']>;
  previousId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  units?: InputMaybe<Scalars['String']>;
  updatePending?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<Scalars['Float']>;
};

export type FilterFindOneModbusAirHandlerZmbThermostatAlarmInput = {
  id?: InputMaybe<Scalars['String']>;
  observedAt?: InputMaybe<Scalars['Float']>;
  previousId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  units?: InputMaybe<Scalars['String']>;
  updatePending?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<Scalars['Boolean']>;
};

export type FilterFindOneModbusAirHandlerZmbTstatRequestsRecvdInput = {
  id?: InputMaybe<Scalars['String']>;
  observedAt?: InputMaybe<Scalars['Float']>;
  previousId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  units?: InputMaybe<Scalars['String']>;
  updatePending?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<Scalars['Float']>;
};

export type FilterFindOneOauthAccessTokenClientIdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['String']>;
  gte?: InputMaybe<Scalars['String']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  lt?: InputMaybe<Scalars['String']>;
  lte?: InputMaybe<Scalars['String']>;
  ne?: InputMaybe<Scalars['String']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']>;
};

export type FilterFindOneOauthAccessTokenInput = {
  AND?: InputMaybe<Array<FilterFindOneOauthAccessTokenInput>>;
  OR?: InputMaybe<Array<FilterFindOneOauthAccessTokenInput>>;
  _id?: InputMaybe<Scalars['String']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterFindOneOauthAccessTokenOperatorsInput>;
  accessToken?: InputMaybe<Scalars['String']>;
  clientId?: InputMaybe<Scalars['String']>;
  expires?: InputMaybe<Scalars['Float']>;
  userId?: InputMaybe<Scalars['String']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterFindOneOauthAccessTokenOperatorsInput = {
  _id?: InputMaybe<FilterFindOneOauthAccessToken_IdOperatorsInput>;
  clientId?: InputMaybe<FilterFindOneOauthAccessTokenClientIdOperatorsInput>;
};

export type FilterFindOneOauthAccessToken_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['String']>;
  gte?: InputMaybe<Scalars['String']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  lt?: InputMaybe<Scalars['String']>;
  lte?: InputMaybe<Scalars['String']>;
  ne?: InputMaybe<Scalars['String']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']>;
};

export type FilterFindOneOauthAuthCodeClientIdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['String']>;
  gte?: InputMaybe<Scalars['String']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  lt?: InputMaybe<Scalars['String']>;
  lte?: InputMaybe<Scalars['String']>;
  ne?: InputMaybe<Scalars['String']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']>;
};

export type FilterFindOneOauthAuthCodeInput = {
  AND?: InputMaybe<Array<FilterFindOneOauthAuthCodeInput>>;
  OR?: InputMaybe<Array<FilterFindOneOauthAuthCodeInput>>;
  _id?: InputMaybe<Scalars['String']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterFindOneOauthAuthCodeOperatorsInput>;
  authCode?: InputMaybe<Scalars['String']>;
  clientId?: InputMaybe<Scalars['String']>;
  expires?: InputMaybe<Scalars['Float']>;
  userId?: InputMaybe<Scalars['String']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterFindOneOauthAuthCodeOperatorsInput = {
  _id?: InputMaybe<FilterFindOneOauthAuthCode_IdOperatorsInput>;
  clientId?: InputMaybe<FilterFindOneOauthAuthCodeClientIdOperatorsInput>;
};

export type FilterFindOneOauthAuthCode_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['String']>;
  gte?: InputMaybe<Scalars['String']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  lt?: InputMaybe<Scalars['String']>;
  lte?: InputMaybe<Scalars['String']>;
  ne?: InputMaybe<Scalars['String']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']>;
};

export type FilterFindOneOauthClientClientIdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['String']>;
  gte?: InputMaybe<Scalars['String']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  lt?: InputMaybe<Scalars['String']>;
  lte?: InputMaybe<Scalars['String']>;
  ne?: InputMaybe<Scalars['String']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']>;
};

export type FilterFindOneOauthClientInput = {
  AND?: InputMaybe<Array<FilterFindOneOauthClientInput>>;
  OR?: InputMaybe<Array<FilterFindOneOauthClientInput>>;
  _id?: InputMaybe<Scalars['String']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterFindOneOauthClientOperatorsInput>;
  active?: InputMaybe<Scalars['Boolean']>;
  brand?: InputMaybe<Scalars['String']>;
  clientId?: InputMaybe<Scalars['String']>;
  clientSecret?: InputMaybe<Scalars['String']>;
  redirectUri?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  serviceDescription?: InputMaybe<Scalars['String']>;
  serviceName?: InputMaybe<Scalars['String']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterFindOneOauthClientOperatorsInput = {
  _id?: InputMaybe<FilterFindOneOauthClient_IdOperatorsInput>;
  clientId?: InputMaybe<FilterFindOneOauthClientClientIdOperatorsInput>;
};

export type FilterFindOneOauthClient_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['String']>;
  gte?: InputMaybe<Scalars['String']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  lt?: InputMaybe<Scalars['String']>;
  lte?: InputMaybe<Scalars['String']>;
  ne?: InputMaybe<Scalars['String']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']>;
};

export type FilterFindOneOccupancySensorInput = {
  AND?: InputMaybe<Array<FilterFindOneDeviceInput>>;
  OR?: InputMaybe<Array<FilterFindOneDeviceInput>>;
  _id?: InputMaybe<Scalars['String']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterFindOneDeviceOperatorsInput>;
  alertTypes?: InputMaybe<FilterFindOneDeviceAlertTypesInput>;
  controlled?: InputMaybe<FilterFindOneDeviceControlledInput>;
  deviceId?: InputMaybe<Scalars['String']>;
  installation?: InputMaybe<FilterFindOneDeviceInstallationInput>;
  location?: InputMaybe<Scalars['String']>;
  meta?: InputMaybe<FilterFindOneDeviceMetaInput>;
  /** The name of the device */
  name?: InputMaybe<Scalars['String']>;
  occupancy?: InputMaybe<FilterFindOneOccupancySensorOccupancyInput>;
  panelId?: InputMaybe<Scalars['String']>;
  powerState?: InputMaybe<FilterFindOneDevicePowerStateInput>;
  propertyId?: InputMaybe<Scalars['String']>;
  sourceId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  unitId?: InputMaybe<Scalars['String']>;
  updateStatus?: InputMaybe<Scalars['Boolean']>;
  voltage?: InputMaybe<FilterFindOneOccupancySensorVoltageInput>;
  vppId?: InputMaybe<Scalars['String']>;
  zoneId?: InputMaybe<Scalars['String']>;
};

export type FilterFindOneOccupancySensorOccupancyInput = {
  id?: InputMaybe<Scalars['String']>;
  observedAt?: InputMaybe<Scalars['Float']>;
  previousId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  units?: InputMaybe<Scalars['String']>;
  updatePending?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<EnumOccupancySensorOccupancyValue>;
};

export type FilterFindOneOccupancySensorVoltageInput = {
  id?: InputMaybe<Scalars['String']>;
  observedAt?: InputMaybe<Scalars['Float']>;
  previousId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  units?: InputMaybe<Scalars['String']>;
  updatePending?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<Scalars['Float']>;
};

export type FilterFindOneOpenWeatherInput = {
  AND?: InputMaybe<Array<FilterFindOneDeviceInput>>;
  OR?: InputMaybe<Array<FilterFindOneDeviceInput>>;
  _id?: InputMaybe<Scalars['String']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterFindOneDeviceOperatorsInput>;
  alertTypes?: InputMaybe<FilterFindOneDeviceAlertTypesInput>;
  controlled?: InputMaybe<FilterFindOneDeviceControlledInput>;
  deviceId?: InputMaybe<Scalars['String']>;
  installation?: InputMaybe<FilterFindOneDeviceInstallationInput>;
  location?: InputMaybe<Scalars['String']>;
  meta?: InputMaybe<FilterFindOneDeviceMetaInput>;
  /** The name of the device */
  name?: InputMaybe<Scalars['String']>;
  panelId?: InputMaybe<Scalars['String']>;
  powerState?: InputMaybe<FilterFindOneDevicePowerStateInput>;
  propertyId?: InputMaybe<Scalars['String']>;
  sourceId?: InputMaybe<Scalars['String']>;
  temperature?: InputMaybe<FilterFindOneOpenWeatherTemperatureInput>;
  timestamp?: InputMaybe<Scalars['Float']>;
  unitId?: InputMaybe<Scalars['String']>;
  updateStatus?: InputMaybe<Scalars['Boolean']>;
  vppId?: InputMaybe<Scalars['String']>;
  zoneId?: InputMaybe<Scalars['String']>;
};

export type FilterFindOneOpenWeatherTemperatureInput = {
  id?: InputMaybe<Scalars['String']>;
  observedAt?: InputMaybe<Scalars['Float']>;
  previousId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  units?: InputMaybe<Scalars['String']>;
  updatePending?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<Scalars['Float']>;
};

export type FilterFindOneOrganizationHqAddressInput = {
  city?: InputMaybe<Scalars['String']>;
  country?: InputMaybe<Scalars['String']>;
  line1?: InputMaybe<Scalars['String']>;
  line2?: InputMaybe<Scalars['String']>;
  postalCode?: InputMaybe<Scalars['String']>;
  state?: InputMaybe<Scalars['String']>;
};

export type FilterFindOneOrganizationInput = {
  AND?: InputMaybe<Array<FilterFindOneOrganizationInput>>;
  OR?: InputMaybe<Array<FilterFindOneOrganizationInput>>;
  _id?: InputMaybe<Scalars['String']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterFindOneOrganizationOperatorsInput>;
  description?: InputMaybe<Scalars['String']>;
  hqAddress?: InputMaybe<FilterFindOneOrganizationHqAddressInput>;
  hqEmail?: InputMaybe<Scalars['String']>;
  hqPhone?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  parentOrganizationId?: InputMaybe<Scalars['String']>;
};

export type FilterFindOneOrganizationNameOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['String']>;
  gte?: InputMaybe<Scalars['String']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  lt?: InputMaybe<Scalars['String']>;
  lte?: InputMaybe<Scalars['String']>;
  ne?: InputMaybe<Scalars['String']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterFindOneOrganizationOperatorsInput = {
  _id?: InputMaybe<FilterFindOneOrganization_IdOperatorsInput>;
  name?: InputMaybe<FilterFindOneOrganizationNameOperatorsInput>;
  parentOrganizationId?: InputMaybe<FilterFindOneOrganizationParentOrganizationIdOperatorsInput>;
};

export type FilterFindOneOrganizationParentOrganizationIdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['String']>;
  gte?: InputMaybe<Scalars['String']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  lt?: InputMaybe<Scalars['String']>;
  lte?: InputMaybe<Scalars['String']>;
  ne?: InputMaybe<Scalars['String']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']>;
};

export type FilterFindOneOrganization_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['String']>;
  gte?: InputMaybe<Scalars['String']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  lt?: InputMaybe<Scalars['String']>;
  lte?: InputMaybe<Scalars['String']>;
  ne?: InputMaybe<Scalars['String']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']>;
};

export type FilterFindOneOutdoorSensorInput = {
  AND?: InputMaybe<Array<FilterFindOneDeviceInput>>;
  OR?: InputMaybe<Array<FilterFindOneDeviceInput>>;
  _id?: InputMaybe<Scalars['String']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterFindOneDeviceOperatorsInput>;
  alertTypes?: InputMaybe<FilterFindOneDeviceAlertTypesInput>;
  controlled?: InputMaybe<FilterFindOneDeviceControlledInput>;
  deviceId?: InputMaybe<Scalars['String']>;
  installation?: InputMaybe<FilterFindOneDeviceInstallationInput>;
  location?: InputMaybe<Scalars['String']>;
  meta?: InputMaybe<FilterFindOneDeviceMetaInput>;
  /** The name of the device */
  name?: InputMaybe<Scalars['String']>;
  panelId?: InputMaybe<Scalars['String']>;
  powerState?: InputMaybe<FilterFindOneDevicePowerStateInput>;
  propertyId?: InputMaybe<Scalars['String']>;
  sourceId?: InputMaybe<Scalars['String']>;
  temperature?: InputMaybe<FilterFindOneOutdoorSensorTemperatureInput>;
  timestamp?: InputMaybe<Scalars['Float']>;
  unitId?: InputMaybe<Scalars['String']>;
  updateStatus?: InputMaybe<Scalars['Boolean']>;
  vppId?: InputMaybe<Scalars['String']>;
  zoneId?: InputMaybe<Scalars['String']>;
};

export type FilterFindOneOutdoorSensorTemperatureInput = {
  id?: InputMaybe<Scalars['String']>;
  observedAt?: InputMaybe<Scalars['Float']>;
  previousId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  units?: InputMaybe<Scalars['String']>;
  updatePending?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<Scalars['Float']>;
};

export type FilterFindOnePanelInput = {
  AND?: InputMaybe<Array<FilterFindOnePanelInput>>;
  OR?: InputMaybe<Array<FilterFindOnePanelInput>>;
  _id?: InputMaybe<Scalars['String']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterFindOnePanelOperatorsInput>;
  name?: InputMaybe<Scalars['String']>;
  propertyId?: InputMaybe<Scalars['String']>;
  role?: InputMaybe<Scalars['String']>;
  sourceId?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<EnumPanelType>;
  unitId?: InputMaybe<Scalars['String']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterFindOnePanelOperatorsInput = {
  _id?: InputMaybe<FilterFindOnePanel_IdOperatorsInput>;
  propertyId?: InputMaybe<FilterFindOnePanelPropertyIdOperatorsInput>;
  unitId?: InputMaybe<FilterFindOnePanelUnitIdOperatorsInput>;
};

export type FilterFindOnePanelPropertyIdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['String']>;
  gte?: InputMaybe<Scalars['String']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  lt?: InputMaybe<Scalars['String']>;
  lte?: InputMaybe<Scalars['String']>;
  ne?: InputMaybe<Scalars['String']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']>;
};

export type FilterFindOnePanelUnitIdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['String']>;
  gte?: InputMaybe<Scalars['String']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  lt?: InputMaybe<Scalars['String']>;
  lte?: InputMaybe<Scalars['String']>;
  ne?: InputMaybe<Scalars['String']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']>;
};

export type FilterFindOnePanel_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['String']>;
  gte?: InputMaybe<Scalars['String']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  lt?: InputMaybe<Scalars['String']>;
  lte?: InputMaybe<Scalars['String']>;
  ne?: InputMaybe<Scalars['String']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']>;
};

export type FilterFindOnePlmContractContractIdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['String']>;
  gte?: InputMaybe<Scalars['String']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  lt?: InputMaybe<Scalars['String']>;
  lte?: InputMaybe<Scalars['String']>;
  ne?: InputMaybe<Scalars['String']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']>;
};

export type FilterFindOnePlmContractInput = {
  AND?: InputMaybe<Array<FilterFindOnePlmContractInput>>;
  OR?: InputMaybe<Array<FilterFindOnePlmContractInput>>;
  _id?: InputMaybe<Scalars['String']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterFindOnePlmContractOperatorsInput>;
  baselineMethod?: InputMaybe<EnumPlmContractBaselineMethod>;
  contractId?: InputMaybe<Scalars['String']>;
  dispatcherIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  incentiveDescription?: InputMaybe<Scalars['String']>;
  maximumEventsPerSeason?: InputMaybe<Scalars['Float']>;
  meterIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  minimumReductionKW?: InputMaybe<Scalars['Float']>;
  name?: InputMaybe<Scalars['String']>;
  notificationEmail?: InputMaybe<Scalars['String']>;
  partnerId?: InputMaybe<Scalars['String']>;
  penaltyForNonCompliance?: InputMaybe<Scalars['Float']>;
  programId?: InputMaybe<Scalars['String']>;
  propertyIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  scopeType?: InputMaybe<EnumPlmContractScopeType>;
  status?: InputMaybe<EnumPlmContractStatus>;
  utilityId?: InputMaybe<Scalars['String']>;
};

export type FilterFindOnePlmContractNotificationEmailOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['String']>;
  gte?: InputMaybe<Scalars['String']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  lt?: InputMaybe<Scalars['String']>;
  lte?: InputMaybe<Scalars['String']>;
  ne?: InputMaybe<Scalars['String']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterFindOnePlmContractOperatorsInput = {
  _id?: InputMaybe<FilterFindOnePlmContract_IdOperatorsInput>;
  contractId?: InputMaybe<FilterFindOnePlmContractContractIdOperatorsInput>;
  notificationEmail?: InputMaybe<FilterFindOnePlmContractNotificationEmailOperatorsInput>;
  programId?: InputMaybe<FilterFindOnePlmContractProgramIdOperatorsInput>;
};

export type FilterFindOnePlmContractProgramIdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['String']>;
  gte?: InputMaybe<Scalars['String']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  lt?: InputMaybe<Scalars['String']>;
  lte?: InputMaybe<Scalars['String']>;
  ne?: InputMaybe<Scalars['String']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']>;
};

export type FilterFindOnePlmContract_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['String']>;
  gte?: InputMaybe<Scalars['String']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  lt?: InputMaybe<Scalars['String']>;
  lte?: InputMaybe<Scalars['String']>;
  ne?: InputMaybe<Scalars['String']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']>;
};

export type FilterFindOnePlmCurtailmentActionDeviceTypeOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<EnumPlmCurtailmentActionDeviceType>;
  gte?: InputMaybe<EnumPlmCurtailmentActionDeviceType>;
  in?: InputMaybe<Array<InputMaybe<EnumPlmCurtailmentActionDeviceType>>>;
  lt?: InputMaybe<EnumPlmCurtailmentActionDeviceType>;
  lte?: InputMaybe<EnumPlmCurtailmentActionDeviceType>;
  ne?: InputMaybe<EnumPlmCurtailmentActionDeviceType>;
  nin?: InputMaybe<Array<InputMaybe<EnumPlmCurtailmentActionDeviceType>>>;
};

export type FilterFindOnePlmCurtailmentActionEstimatedReductionKwOperatorsInput =
  {
    exists?: InputMaybe<Scalars['Boolean']>;
    gt?: InputMaybe<Scalars['Float']>;
    gte?: InputMaybe<Scalars['Float']>;
    in?: InputMaybe<Array<InputMaybe<Scalars['Float']>>>;
    lt?: InputMaybe<Scalars['Float']>;
    lte?: InputMaybe<Scalars['Float']>;
    ne?: InputMaybe<Scalars['Float']>;
    nin?: InputMaybe<Array<InputMaybe<Scalars['Float']>>>;
  };

export type FilterFindOnePlmCurtailmentActionInput = {
  AND?: InputMaybe<Array<FilterFindOnePlmCurtailmentActionInput>>;
  OR?: InputMaybe<Array<FilterFindOnePlmCurtailmentActionInput>>;
  _id?: InputMaybe<Scalars['String']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterFindOnePlmCurtailmentActionOperatorsInput>;
  autoBatch?: InputMaybe<Scalars['Boolean']>;
  batchCount?: InputMaybe<Scalars['Float']>;
  batchDuration?: InputMaybe<Scalars['Float']>;
  batchStartTimeOffset?: InputMaybe<Scalars['Float']>;
  description?: InputMaybe<Scalars['String']>;
  deviceType?: InputMaybe<EnumPlmCurtailmentActionDeviceType>;
  estimatedReductionKW?: InputMaybe<Scalars['Float']>;
  name?: InputMaybe<Scalars['String']>;
  plmCurtailmentPlanId?: InputMaybe<Scalars['String']>;
  startTimeOffset?: InputMaybe<Scalars['Float']>;
  targetDevices?: InputMaybe<Scalars['JSON']>;
  targetedAdjustments?: InputMaybe<FilterFindOnePlmCurtailmentTaskCachedDeviceStateInput>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterFindOnePlmCurtailmentActionOperatorsInput = {
  _id?: InputMaybe<FilterFindOnePlmCurtailmentAction_IdOperatorsInput>;
  deviceType?: InputMaybe<FilterFindOnePlmCurtailmentActionDeviceTypeOperatorsInput>;
  estimatedReductionKW?: InputMaybe<FilterFindOnePlmCurtailmentActionEstimatedReductionKwOperatorsInput>;
  plmCurtailmentPlanId?: InputMaybe<FilterFindOnePlmCurtailmentActionPlmCurtailmentPlanIdOperatorsInput>;
};

export type FilterFindOnePlmCurtailmentActionPlmCurtailmentPlanIdOperatorsInput =
  {
    exists?: InputMaybe<Scalars['Boolean']>;
    gt?: InputMaybe<Scalars['String']>;
    gte?: InputMaybe<Scalars['String']>;
    in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    lt?: InputMaybe<Scalars['String']>;
    lte?: InputMaybe<Scalars['String']>;
    ne?: InputMaybe<Scalars['String']>;
    nin?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
    regex?: InputMaybe<Scalars['RegExpAsString']>;
  };

export type FilterFindOnePlmCurtailmentAction_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['String']>;
  gte?: InputMaybe<Scalars['String']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  lt?: InputMaybe<Scalars['String']>;
  lte?: InputMaybe<Scalars['String']>;
  ne?: InputMaybe<Scalars['String']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']>;
};

export type FilterFindOnePlmCurtailmentPlanDurationMinutesOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['Float']>;
  gte?: InputMaybe<Scalars['Float']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Float']>>>;
  lt?: InputMaybe<Scalars['Float']>;
  lte?: InputMaybe<Scalars['Float']>;
  ne?: InputMaybe<Scalars['Float']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Float']>>>;
};

export type FilterFindOnePlmCurtailmentPlanEstimatedReductionKwOperatorsInput =
  {
    exists?: InputMaybe<Scalars['Boolean']>;
    gt?: InputMaybe<Scalars['Float']>;
    gte?: InputMaybe<Scalars['Float']>;
    in?: InputMaybe<Array<InputMaybe<Scalars['Float']>>>;
    lt?: InputMaybe<Scalars['Float']>;
    lte?: InputMaybe<Scalars['Float']>;
    ne?: InputMaybe<Scalars['Float']>;
    nin?: InputMaybe<Array<InputMaybe<Scalars['Float']>>>;
  };

export type FilterFindOnePlmCurtailmentPlanInput = {
  AND?: InputMaybe<Array<FilterFindOnePlmCurtailmentPlanInput>>;
  OR?: InputMaybe<Array<FilterFindOnePlmCurtailmentPlanInput>>;
  _id?: InputMaybe<Scalars['String']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterFindOnePlmCurtailmentPlanOperatorsInput>;
  applicableSeasons?: InputMaybe<
    Array<InputMaybe<EnumPlmCurtailmentPlanApplicableSeasons>>
  >;
  description?: InputMaybe<Scalars['String']>;
  durationMinutes?: InputMaybe<Scalars['Float']>;
  estimatedReductionKW?: InputMaybe<Scalars['Float']>;
  name?: InputMaybe<Scalars['String']>;
  organizationId?: InputMaybe<Scalars['String']>;
};

export type FilterFindOnePlmCurtailmentPlanNameOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['String']>;
  gte?: InputMaybe<Scalars['String']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  lt?: InputMaybe<Scalars['String']>;
  lte?: InputMaybe<Scalars['String']>;
  ne?: InputMaybe<Scalars['String']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterFindOnePlmCurtailmentPlanOperatorsInput = {
  _id?: InputMaybe<FilterFindOnePlmCurtailmentPlan_IdOperatorsInput>;
  durationMinutes?: InputMaybe<FilterFindOnePlmCurtailmentPlanDurationMinutesOperatorsInput>;
  estimatedReductionKW?: InputMaybe<FilterFindOnePlmCurtailmentPlanEstimatedReductionKwOperatorsInput>;
  name?: InputMaybe<FilterFindOnePlmCurtailmentPlanNameOperatorsInput>;
  organizationId?: InputMaybe<FilterFindOnePlmCurtailmentPlanOrganizationIdOperatorsInput>;
};

export type FilterFindOnePlmCurtailmentPlanOrganizationIdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['String']>;
  gte?: InputMaybe<Scalars['String']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  lt?: InputMaybe<Scalars['String']>;
  lte?: InputMaybe<Scalars['String']>;
  ne?: InputMaybe<Scalars['String']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']>;
};

export type FilterFindOnePlmCurtailmentPlan_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['String']>;
  gte?: InputMaybe<Scalars['String']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  lt?: InputMaybe<Scalars['String']>;
  lte?: InputMaybe<Scalars['String']>;
  ne?: InputMaybe<Scalars['String']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']>;
};

export type FilterFindOnePlmCurtailmentTaskCachedDeviceStateInput = {
  coolSetpoint?: InputMaybe<Scalars['Float']>;
  coolSetpointAdjustmentMode?: InputMaybe<EnumPlmCurtailmentTaskCachedDeviceStateCoolSetpointAdjustmentMode>;
  fanMode?: InputMaybe<Scalars['String']>;
  fanSpeed?: InputMaybe<Scalars['String']>;
  freshAirSetpoint?: InputMaybe<Scalars['Float']>;
  heatSetpoint?: InputMaybe<Scalars['Float']>;
  heatSetpointAdjustmentMode?: InputMaybe<EnumPlmCurtailmentTaskCachedDeviceStateHeatSetpointAdjustmentMode>;
  isOn?: InputMaybe<Scalars['Boolean']>;
  keypadLockoutLevel?: InputMaybe<Scalars['String']>;
  maxCoolSetpointLimit?: InputMaybe<Scalars['Float']>;
  maxHeatSetpointLimit?: InputMaybe<Scalars['Float']>;
  minCoolSetpointLimit?: InputMaybe<Scalars['Float']>;
  minHeatSetpointLimit?: InputMaybe<Scalars['Float']>;
  operatingMode?: InputMaybe<Scalars['String']>;
  rhSetpoint?: InputMaybe<Scalars['Float']>;
  type?: InputMaybe<EnumPlmCurtailmentTaskCachedDeviceStateType>;
  ventilationMode?: InputMaybe<Scalars['String']>;
};

export type FilterFindOnePlmCurtailmentTaskDeviceIdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['String']>;
  gte?: InputMaybe<Scalars['String']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  lt?: InputMaybe<Scalars['String']>;
  lte?: InputMaybe<Scalars['String']>;
  ne?: InputMaybe<Scalars['String']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']>;
};

export type FilterFindOnePlmCurtailmentTaskInput = {
  AND?: InputMaybe<Array<FilterFindOnePlmCurtailmentTaskInput>>;
  OR?: InputMaybe<Array<FilterFindOnePlmCurtailmentTaskInput>>;
  _id?: InputMaybe<Scalars['String']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterFindOnePlmCurtailmentTaskOperatorsInput>;
  batchId?: InputMaybe<Scalars['Float']>;
  cachedDeviceState?: InputMaybe<FilterFindOnePlmCurtailmentTaskCachedDeviceStateInput>;
  deviceId?: InputMaybe<Scalars['String']>;
  deviceType?: InputMaybe<Scalars['String']>;
  endedAt?: InputMaybe<Scalars['Float']>;
  estimatedReductionKW?: InputMaybe<Scalars['Float']>;
  plmCurtailmentActionId?: InputMaybe<Scalars['String']>;
  plmEventResponseId?: InputMaybe<Scalars['String']>;
  propertyId?: InputMaybe<Scalars['String']>;
  resolvedTargetedAdjustments?: InputMaybe<FilterFindOnePlmCurtailmentTaskCachedDeviceStateInput>;
  scheduledEnd?: InputMaybe<Scalars['Float']>;
  scheduledStart?: InputMaybe<Scalars['Float']>;
  startedAt?: InputMaybe<Scalars['Float']>;
  status?: InputMaybe<EnumPlmCurtailmentTaskStatus>;
  statusMessage?: InputMaybe<Scalars['String']>;
  targetedAdjustments?: InputMaybe<FilterFindOnePlmCurtailmentTaskCachedDeviceStateInput>;
  unitId?: InputMaybe<Scalars['String']>;
  updateRetryCount?: InputMaybe<Scalars['Float']>;
  verifiedAt?: InputMaybe<Scalars['Float']>;
  verifyAttempts?: InputMaybe<Scalars['Float']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterFindOnePlmCurtailmentTaskOperatorsInput = {
  _id?: InputMaybe<FilterFindOnePlmCurtailmentTask_IdOperatorsInput>;
  deviceId?: InputMaybe<FilterFindOnePlmCurtailmentTaskDeviceIdOperatorsInput>;
};

export type FilterFindOnePlmCurtailmentTask_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['String']>;
  gte?: InputMaybe<Scalars['String']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  lt?: InputMaybe<Scalars['String']>;
  lte?: InputMaybe<Scalars['String']>;
  ne?: InputMaybe<Scalars['String']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']>;
};

export type FilterFindOnePlmEventContractIdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['String']>;
  gte?: InputMaybe<Scalars['String']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  lt?: InputMaybe<Scalars['String']>;
  lte?: InputMaybe<Scalars['String']>;
  ne?: InputMaybe<Scalars['String']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']>;
};

export type FilterFindOnePlmEventInput = {
  AND?: InputMaybe<Array<FilterFindOnePlmEventInput>>;
  OR?: InputMaybe<Array<FilterFindOnePlmEventInput>>;
  _id?: InputMaybe<Scalars['String']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterFindOnePlmEventOperatorsInput>;
  contractId?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['Float']>;
  duration?: InputMaybe<Scalars['Float']>;
  notificationHeaders?: InputMaybe<Scalars['JSON']>;
  notificationMethod?: InputMaybe<EnumPlmEventNotificationMethod>;
  notificationPayload?: InputMaybe<Scalars['String']>;
  notificationReceivedAt?: InputMaybe<Scalars['Float']>;
  programId?: InputMaybe<Scalars['String']>;
  reductionTarget?: InputMaybe<Scalars['Float']>;
  sourceExternalId?: InputMaybe<Scalars['String']>;
  sourceVendor?: InputMaybe<Scalars['String']>;
  startTime?: InputMaybe<Scalars['Float']>;
  status?: InputMaybe<EnumPlmEventStatus>;
  updatedAt?: InputMaybe<Scalars['Float']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterFindOnePlmEventOperatorsInput = {
  _id?: InputMaybe<FilterFindOnePlmEvent_IdOperatorsInput>;
  contractId?: InputMaybe<FilterFindOnePlmEventContractIdOperatorsInput>;
  programId?: InputMaybe<FilterFindOnePlmEventProgramIdOperatorsInput>;
  sourceVendor?: InputMaybe<FilterFindOnePlmEventSourceVendorOperatorsInput>;
  startTime?: InputMaybe<FilterFindOnePlmEventStartTimeOperatorsInput>;
  status?: InputMaybe<FilterFindOnePlmEventStatusOperatorsInput>;
};

export type FilterFindOnePlmEventProgramIdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['String']>;
  gte?: InputMaybe<Scalars['String']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  lt?: InputMaybe<Scalars['String']>;
  lte?: InputMaybe<Scalars['String']>;
  ne?: InputMaybe<Scalars['String']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']>;
};

export type FilterFindOnePlmEventResponseCurtailmentPlanIdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['String']>;
  gte?: InputMaybe<Scalars['String']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  lt?: InputMaybe<Scalars['String']>;
  lte?: InputMaybe<Scalars['String']>;
  ne?: InputMaybe<Scalars['String']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']>;
};

export type FilterFindOnePlmEventResponseEventIdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['String']>;
  gte?: InputMaybe<Scalars['String']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  lt?: InputMaybe<Scalars['String']>;
  lte?: InputMaybe<Scalars['String']>;
  ne?: InputMaybe<Scalars['String']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']>;
};

export type FilterFindOnePlmEventResponseInput = {
  AND?: InputMaybe<Array<FilterFindOnePlmEventResponseInput>>;
  OR?: InputMaybe<Array<FilterFindOnePlmEventResponseInput>>;
  _id?: InputMaybe<Scalars['String']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterFindOnePlmEventResponseOperatorsInput>;
  actualEnd?: InputMaybe<Scalars['Float']>;
  actualStart?: InputMaybe<Scalars['Float']>;
  createdAt?: InputMaybe<Scalars['Float']>;
  curtailmentPlanId?: InputMaybe<Scalars['String']>;
  eventId?: InputMaybe<Scalars['String']>;
  propertyId?: InputMaybe<Scalars['String']>;
  responseSentAt?: InputMaybe<Scalars['Float']>;
  responseStatus?: InputMaybe<EnumPlmEventResponseResponseStatus>;
  scheduledEnd?: InputMaybe<Scalars['Float']>;
  scheduledStart?: InputMaybe<Scalars['Float']>;
  updatedAt?: InputMaybe<Scalars['Float']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterFindOnePlmEventResponseOperatorsInput = {
  _id?: InputMaybe<FilterFindOnePlmEventResponse_IdOperatorsInput>;
  curtailmentPlanId?: InputMaybe<FilterFindOnePlmEventResponseCurtailmentPlanIdOperatorsInput>;
  eventId?: InputMaybe<FilterFindOnePlmEventResponseEventIdOperatorsInput>;
  propertyId?: InputMaybe<FilterFindOnePlmEventResponsePropertyIdOperatorsInput>;
  responseSentAt?: InputMaybe<FilterFindOnePlmEventResponseResponseSentAtOperatorsInput>;
  responseStatus?: InputMaybe<FilterFindOnePlmEventResponseResponseStatusOperatorsInput>;
  scheduledStart?: InputMaybe<FilterFindOnePlmEventResponseScheduledStartOperatorsInput>;
};

export type FilterFindOnePlmEventResponsePropertyIdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['String']>;
  gte?: InputMaybe<Scalars['String']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  lt?: InputMaybe<Scalars['String']>;
  lte?: InputMaybe<Scalars['String']>;
  ne?: InputMaybe<Scalars['String']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']>;
};

export type FilterFindOnePlmEventResponseResponseSentAtOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['Float']>;
  gte?: InputMaybe<Scalars['Float']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Float']>>>;
  lt?: InputMaybe<Scalars['Float']>;
  lte?: InputMaybe<Scalars['Float']>;
  ne?: InputMaybe<Scalars['Float']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Float']>>>;
};

export type FilterFindOnePlmEventResponseResponseStatusOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<EnumPlmEventResponseResponseStatus>;
  gte?: InputMaybe<EnumPlmEventResponseResponseStatus>;
  in?: InputMaybe<Array<InputMaybe<EnumPlmEventResponseResponseStatus>>>;
  lt?: InputMaybe<EnumPlmEventResponseResponseStatus>;
  lte?: InputMaybe<EnumPlmEventResponseResponseStatus>;
  ne?: InputMaybe<EnumPlmEventResponseResponseStatus>;
  nin?: InputMaybe<Array<InputMaybe<EnumPlmEventResponseResponseStatus>>>;
};

export type FilterFindOnePlmEventResponseScheduledStartOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['Float']>;
  gte?: InputMaybe<Scalars['Float']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Float']>>>;
  lt?: InputMaybe<Scalars['Float']>;
  lte?: InputMaybe<Scalars['Float']>;
  ne?: InputMaybe<Scalars['Float']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Float']>>>;
};

export type FilterFindOnePlmEventResponse_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['String']>;
  gte?: InputMaybe<Scalars['String']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  lt?: InputMaybe<Scalars['String']>;
  lte?: InputMaybe<Scalars['String']>;
  ne?: InputMaybe<Scalars['String']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']>;
};

export type FilterFindOnePlmEventSourceVendorOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['String']>;
  gte?: InputMaybe<Scalars['String']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  lt?: InputMaybe<Scalars['String']>;
  lte?: InputMaybe<Scalars['String']>;
  ne?: InputMaybe<Scalars['String']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']>;
};

export type FilterFindOnePlmEventStartTimeOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['Float']>;
  gte?: InputMaybe<Scalars['Float']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Float']>>>;
  lt?: InputMaybe<Scalars['Float']>;
  lte?: InputMaybe<Scalars['Float']>;
  ne?: InputMaybe<Scalars['Float']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Float']>>>;
};

export type FilterFindOnePlmEventStatusOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<EnumPlmEventStatus>;
  gte?: InputMaybe<EnumPlmEventStatus>;
  in?: InputMaybe<Array<InputMaybe<EnumPlmEventStatus>>>;
  lt?: InputMaybe<EnumPlmEventStatus>;
  lte?: InputMaybe<EnumPlmEventStatus>;
  ne?: InputMaybe<EnumPlmEventStatus>;
  nin?: InputMaybe<Array<InputMaybe<EnumPlmEventStatus>>>;
};

export type FilterFindOnePlmEvent_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['String']>;
  gte?: InputMaybe<Scalars['String']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  lt?: InputMaybe<Scalars['String']>;
  lte?: InputMaybe<Scalars['String']>;
  ne?: InputMaybe<Scalars['String']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']>;
};

export type FilterFindOnePlmExternalMeterMappingInput = {
  AND?: InputMaybe<Array<FilterFindOnePlmExternalMeterMappingInput>>;
  OR?: InputMaybe<Array<FilterFindOnePlmExternalMeterMappingInput>>;
  _id?: InputMaybe<Scalars['String']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterFindOnePlmExternalMeterMappingOperatorsInput>;
  meterId?: InputMaybe<Scalars['String']>;
  partnerId?: InputMaybe<Scalars['String']>;
  propertyId?: InputMaybe<Scalars['String']>;
  providerAttributes?: InputMaybe<Scalars['JSON']>;
  vendor?: InputMaybe<Scalars['String']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterFindOnePlmExternalMeterMappingOperatorsInput = {
  _id?: InputMaybe<FilterFindOnePlmExternalMeterMapping_IdOperatorsInput>;
  propertyId?: InputMaybe<FilterFindOnePlmExternalMeterMappingPropertyIdOperatorsInput>;
  vendor?: InputMaybe<FilterFindOnePlmExternalMeterMappingVendorOperatorsInput>;
};

export type FilterFindOnePlmExternalMeterMappingPropertyIdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['String']>;
  gte?: InputMaybe<Scalars['String']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  lt?: InputMaybe<Scalars['String']>;
  lte?: InputMaybe<Scalars['String']>;
  ne?: InputMaybe<Scalars['String']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']>;
};

export type FilterFindOnePlmExternalMeterMappingVendorOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['String']>;
  gte?: InputMaybe<Scalars['String']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  lt?: InputMaybe<Scalars['String']>;
  lte?: InputMaybe<Scalars['String']>;
  ne?: InputMaybe<Scalars['String']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']>;
};

export type FilterFindOnePlmExternalMeterMapping_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['String']>;
  gte?: InputMaybe<Scalars['String']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  lt?: InputMaybe<Scalars['String']>;
  lte?: InputMaybe<Scalars['String']>;
  ne?: InputMaybe<Scalars['String']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']>;
};

export type FilterFindOnePlmIngressEventInput = {
  AND?: InputMaybe<Array<FilterFindOnePlmIngressEventInput>>;
  OR?: InputMaybe<Array<FilterFindOnePlmIngressEventInput>>;
  _id?: InputMaybe<Scalars['String']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterFindOnePlmIngressEventOperatorsInput>;
  headers?: InputMaybe<Scalars['JSON']>;
  lastError?: InputMaybe<Scalars['String']>;
  plmEventId?: InputMaybe<Scalars['String']>;
  processedAt?: InputMaybe<Scalars['Float']>;
  rawPayload?: InputMaybe<Scalars['String']>;
  receivedAt?: InputMaybe<Scalars['Float']>;
  source?: InputMaybe<EnumPlmIngressEventSource>;
  status?: InputMaybe<EnumPlmIngressEventStatus>;
  vendorKey?: InputMaybe<Scalars['String']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterFindOnePlmIngressEventOperatorsInput = {
  _id?: InputMaybe<FilterFindOnePlmIngressEvent_IdOperatorsInput>;
  status?: InputMaybe<FilterFindOnePlmIngressEventStatusOperatorsInput>;
  vendorKey?: InputMaybe<FilterFindOnePlmIngressEventVendorKeyOperatorsInput>;
};

export type FilterFindOnePlmIngressEventStatusOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<EnumPlmIngressEventStatus>;
  gte?: InputMaybe<EnumPlmIngressEventStatus>;
  in?: InputMaybe<Array<InputMaybe<EnumPlmIngressEventStatus>>>;
  lt?: InputMaybe<EnumPlmIngressEventStatus>;
  lte?: InputMaybe<EnumPlmIngressEventStatus>;
  ne?: InputMaybe<EnumPlmIngressEventStatus>;
  nin?: InputMaybe<Array<InputMaybe<EnumPlmIngressEventStatus>>>;
};

export type FilterFindOnePlmIngressEventVendorKeyOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['String']>;
  gte?: InputMaybe<Scalars['String']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  lt?: InputMaybe<Scalars['String']>;
  lte?: InputMaybe<Scalars['String']>;
  ne?: InputMaybe<Scalars['String']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']>;
};

export type FilterFindOnePlmIngressEvent_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['String']>;
  gte?: InputMaybe<Scalars['String']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  lt?: InputMaybe<Scalars['String']>;
  lte?: InputMaybe<Scalars['String']>;
  ne?: InputMaybe<Scalars['String']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']>;
};

export type FilterFindOnePlmNotificationActivationTimeOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['Date']>;
  gte?: InputMaybe<Scalars['Date']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Date']>>>;
  lt?: InputMaybe<Scalars['Date']>;
  lte?: InputMaybe<Scalars['Date']>;
  ne?: InputMaybe<Scalars['Date']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Date']>>>;
};

export type FilterFindOnePlmNotificationContractIdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['String']>;
  gte?: InputMaybe<Scalars['String']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  lt?: InputMaybe<Scalars['String']>;
  lte?: InputMaybe<Scalars['String']>;
  ne?: InputMaybe<Scalars['String']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']>;
};

export type FilterFindOnePlmNotificationInput = {
  AND?: InputMaybe<Array<FilterFindOnePlmNotificationInput>>;
  OR?: InputMaybe<Array<FilterFindOnePlmNotificationInput>>;
  _id?: InputMaybe<Scalars['String']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterFindOnePlmNotificationOperatorsInput>;
  activationTime?: InputMaybe<Scalars['Date']>;
  contractId?: InputMaybe<Scalars['String']>;
  deactivationTime?: InputMaybe<Scalars['Date']>;
  participationStatus?: InputMaybe<EnumPlmNotificationParticipationStatus>;
  partnerId?: InputMaybe<Scalars['String']>;
  payload?: InputMaybe<Scalars['String']>;
  programId?: InputMaybe<Scalars['String']>;
  receivedAt?: InputMaybe<Scalars['Date']>;
  responseSentAt?: InputMaybe<Scalars['Date']>;
  source?: InputMaybe<EnumPlmNotificationSource>;
  utilityId?: InputMaybe<Scalars['String']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterFindOnePlmNotificationOperatorsInput = {
  _id?: InputMaybe<FilterFindOnePlmNotification_IdOperatorsInput>;
  activationTime?: InputMaybe<FilterFindOnePlmNotificationActivationTimeOperatorsInput>;
  contractId?: InputMaybe<FilterFindOnePlmNotificationContractIdOperatorsInput>;
  partnerId?: InputMaybe<FilterFindOnePlmNotificationPartnerIdOperatorsInput>;
  programId?: InputMaybe<FilterFindOnePlmNotificationProgramIdOperatorsInput>;
};

export type FilterFindOnePlmNotificationPartnerIdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['String']>;
  gte?: InputMaybe<Scalars['String']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  lt?: InputMaybe<Scalars['String']>;
  lte?: InputMaybe<Scalars['String']>;
  ne?: InputMaybe<Scalars['String']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']>;
};

export type FilterFindOnePlmNotificationProgramIdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['String']>;
  gte?: InputMaybe<Scalars['String']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  lt?: InputMaybe<Scalars['String']>;
  lte?: InputMaybe<Scalars['String']>;
  ne?: InputMaybe<Scalars['String']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']>;
};

export type FilterFindOnePlmNotification_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['String']>;
  gte?: InputMaybe<Scalars['String']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  lt?: InputMaybe<Scalars['String']>;
  lte?: InputMaybe<Scalars['String']>;
  ne?: InputMaybe<Scalars['String']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']>;
};

export type FilterFindOnePlmPartnerContactInput = {
  email?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  phone?: InputMaybe<Scalars['String']>;
};

export type FilterFindOnePlmPartnerInput = {
  AND?: InputMaybe<Array<FilterFindOnePlmPartnerInput>>;
  OR?: InputMaybe<Array<FilterFindOnePlmPartnerInput>>;
  _id?: InputMaybe<Scalars['String']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterFindOnePlmPartnerOperatorsInput>;
  contact?: InputMaybe<FilterFindOnePlmPartnerContactInput>;
  description?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  partnerType?: InputMaybe<EnumPlmPartnerPartnerType>;
};

export type FilterFindOnePlmPartnerNameOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['String']>;
  gte?: InputMaybe<Scalars['String']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  lt?: InputMaybe<Scalars['String']>;
  lte?: InputMaybe<Scalars['String']>;
  ne?: InputMaybe<Scalars['String']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterFindOnePlmPartnerOperatorsInput = {
  _id?: InputMaybe<FilterFindOnePlmPartner_IdOperatorsInput>;
  name?: InputMaybe<FilterFindOnePlmPartnerNameOperatorsInput>;
};

export type FilterFindOnePlmPartner_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['String']>;
  gte?: InputMaybe<Scalars['String']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  lt?: InputMaybe<Scalars['String']>;
  lte?: InputMaybe<Scalars['String']>;
  ne?: InputMaybe<Scalars['String']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']>;
};

export type FilterFindOnePlmProgramHostPartnerIdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['String']>;
  gte?: InputMaybe<Scalars['String']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  lt?: InputMaybe<Scalars['String']>;
  lte?: InputMaybe<Scalars['String']>;
  ne?: InputMaybe<Scalars['String']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']>;
};

export type FilterFindOnePlmProgramInput = {
  AND?: InputMaybe<Array<FilterFindOnePlmProgramInput>>;
  OR?: InputMaybe<Array<FilterFindOnePlmProgramInput>>;
  _id?: InputMaybe<Scalars['String']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterFindOnePlmProgramOperatorsInput>;
  endDate?: InputMaybe<Scalars['Float']>;
  hostPartnerId?: InputMaybe<Scalars['String']>;
  hostUtilityId?: InputMaybe<Scalars['String']>;
  incentiveDescription?: InputMaybe<Scalars['String']>;
  maximumEventDurationMinutes?: InputMaybe<Scalars['Float']>;
  maximumEventsPerSeason?: InputMaybe<Scalars['Float']>;
  maximumNotificationLeadTimeMinutes?: InputMaybe<Scalars['Float']>;
  measurementIntervalMinutes?: InputMaybe<Scalars['Float']>;
  minimumEventDurationMinutes?: InputMaybe<Scalars['Float']>;
  minimumEventsPerSeason?: InputMaybe<Scalars['Float']>;
  name?: InputMaybe<Scalars['String']>;
  notificationLeadTimeMinutes?: InputMaybe<Scalars['Float']>;
  participationType?: InputMaybe<EnumPlmProgramParticipationType>;
  partnerId?: InputMaybe<Scalars['String']>;
  programId?: InputMaybe<Scalars['String']>;
  season?: InputMaybe<EnumPlmProgramSeason>;
  startDate?: InputMaybe<Scalars['Float']>;
  utilityId?: InputMaybe<Scalars['String']>;
};

export type FilterFindOnePlmProgramNameOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['String']>;
  gte?: InputMaybe<Scalars['String']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  lt?: InputMaybe<Scalars['String']>;
  lte?: InputMaybe<Scalars['String']>;
  ne?: InputMaybe<Scalars['String']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterFindOnePlmProgramOperatorsInput = {
  _id?: InputMaybe<FilterFindOnePlmProgram_IdOperatorsInput>;
  hostPartnerId?: InputMaybe<FilterFindOnePlmProgramHostPartnerIdOperatorsInput>;
  name?: InputMaybe<FilterFindOnePlmProgramNameOperatorsInput>;
  partnerId?: InputMaybe<FilterFindOnePlmProgramPartnerIdOperatorsInput>;
  programId?: InputMaybe<FilterFindOnePlmProgramProgramIdOperatorsInput>;
};

export type FilterFindOnePlmProgramPartnerIdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['String']>;
  gte?: InputMaybe<Scalars['String']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  lt?: InputMaybe<Scalars['String']>;
  lte?: InputMaybe<Scalars['String']>;
  ne?: InputMaybe<Scalars['String']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']>;
};

export type FilterFindOnePlmProgramProgramIdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['String']>;
  gte?: InputMaybe<Scalars['String']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  lt?: InputMaybe<Scalars['String']>;
  lte?: InputMaybe<Scalars['String']>;
  ne?: InputMaybe<Scalars['String']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']>;
};

export type FilterFindOnePlmProgram_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['String']>;
  gte?: InputMaybe<Scalars['String']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  lt?: InputMaybe<Scalars['String']>;
  lte?: InputMaybe<Scalars['String']>;
  ne?: InputMaybe<Scalars['String']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']>;
};

export type FilterFindOnePlmUtilityContactInput = {
  email?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  phone?: InputMaybe<Scalars['String']>;
};

export type FilterFindOnePlmUtilityInput = {
  AND?: InputMaybe<Array<FilterFindOnePlmUtilityInput>>;
  OR?: InputMaybe<Array<FilterFindOnePlmUtilityInput>>;
  _id?: InputMaybe<Scalars['String']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterFindOnePlmUtilityOperatorsInput>;
  contact?: InputMaybe<FilterFindOnePlmUtilityContactInput>;
  description?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
};

export type FilterFindOnePlmUtilityNameOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['String']>;
  gte?: InputMaybe<Scalars['String']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  lt?: InputMaybe<Scalars['String']>;
  lte?: InputMaybe<Scalars['String']>;
  ne?: InputMaybe<Scalars['String']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterFindOnePlmUtilityOperatorsInput = {
  _id?: InputMaybe<FilterFindOnePlmUtility_IdOperatorsInput>;
  name?: InputMaybe<FilterFindOnePlmUtilityNameOperatorsInput>;
};

export type FilterFindOnePlmUtility_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['String']>;
  gte?: InputMaybe<Scalars['String']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  lt?: InputMaybe<Scalars['String']>;
  lte?: InputMaybe<Scalars['String']>;
  ne?: InputMaybe<Scalars['String']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']>;
};

export type FilterFindOnePowerMonitorFrequencyInput = {
  id?: InputMaybe<Scalars['String']>;
  observedAt?: InputMaybe<Scalars['Float']>;
  previousId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  units?: InputMaybe<Scalars['String']>;
  updatePending?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<Scalars['Float']>;
};

export type FilterFindOnePowerMonitorInput = {
  AND?: InputMaybe<Array<FilterFindOneDeviceInput>>;
  OR?: InputMaybe<Array<FilterFindOneDeviceInput>>;
  _id?: InputMaybe<Scalars['String']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterFindOneDeviceOperatorsInput>;
  alertTypes?: InputMaybe<FilterFindOneDeviceAlertTypesInput>;
  controlled?: InputMaybe<FilterFindOneDeviceControlledInput>;
  deviceId?: InputMaybe<Scalars['String']>;
  frequency?: InputMaybe<FilterFindOnePowerMonitorFrequencyInput>;
  installation?: InputMaybe<FilterFindOneDeviceInstallationInput>;
  location?: InputMaybe<Scalars['String']>;
  meta?: InputMaybe<FilterFindOneDeviceMetaInput>;
  /** The name of the device */
  name?: InputMaybe<Scalars['String']>;
  panelId?: InputMaybe<Scalars['String']>;
  phaseAActiveEnergyFwd?: InputMaybe<FilterFindOnePowerMonitorPhaseAActiveEnergyFwdInput>;
  phaseAActiveEnergyRev?: InputMaybe<FilterFindOnePowerMonitorPhaseAActiveEnergyRevInput>;
  phaseAActivePower?: InputMaybe<FilterFindOnePowerMonitorPhaseAActivePowerInput>;
  phaseACurrent?: InputMaybe<FilterFindOnePowerMonitorPhaseACurrentInput>;
  phaseAFrequency?: InputMaybe<FilterFindOnePowerMonitorPhaseAFrequencyInput>;
  phaseAPowerFactor?: InputMaybe<FilterFindOnePowerMonitorPhaseAPowerFactorInput>;
  phaseAVoltage?: InputMaybe<FilterFindOnePowerMonitorPhaseAVoltageInput>;
  phaseBActiveEnergyFwd?: InputMaybe<FilterFindOnePowerMonitorPhaseBActiveEnergyFwdInput>;
  phaseBActiveEnergyRev?: InputMaybe<FilterFindOnePowerMonitorPhaseBActiveEnergyRevInput>;
  phaseBActivePower?: InputMaybe<FilterFindOnePowerMonitorPhaseBActivePowerInput>;
  phaseBCurrent?: InputMaybe<FilterFindOnePowerMonitorPhaseBCurrentInput>;
  phaseBFrequency?: InputMaybe<FilterFindOnePowerMonitorPhaseBFrequencyInput>;
  phaseBPowerFactor?: InputMaybe<FilterFindOnePowerMonitorPhaseBPowerFactorInput>;
  phaseBVoltage?: InputMaybe<FilterFindOnePowerMonitorPhaseBVoltageInput>;
  phaseCActiveEnergyFwd?: InputMaybe<FilterFindOnePowerMonitorPhaseCActiveEnergyFwdInput>;
  phaseCActiveEnergyRev?: InputMaybe<FilterFindOnePowerMonitorPhaseCActiveEnergyRevInput>;
  phaseCActivePower?: InputMaybe<FilterFindOnePowerMonitorPhaseCActivePowerInput>;
  phaseCCurrent?: InputMaybe<FilterFindOnePowerMonitorPhaseCCurrentInput>;
  phaseCFrequency?: InputMaybe<FilterFindOnePowerMonitorPhaseCFrequencyInput>;
  phaseCPowerFactor?: InputMaybe<FilterFindOnePowerMonitorPhaseCPowerFactorInput>;
  phaseCVoltage?: InputMaybe<FilterFindOnePowerMonitorPhaseCVoltageInput>;
  powerState?: InputMaybe<FilterFindOneDevicePowerStateInput>;
  propertyId?: InputMaybe<Scalars['String']>;
  sourceId?: InputMaybe<Scalars['String']>;
  threePhaseTotalActiveEnergyFwd?: InputMaybe<FilterFindOnePowerMonitorThreePhaseTotalActiveEnergyFwdInput>;
  threePhaseTotalActiveEnergyRev?: InputMaybe<FilterFindOnePowerMonitorThreePhaseTotalActiveEnergyRevInput>;
  timestamp?: InputMaybe<Scalars['Float']>;
  totalActivePower?: InputMaybe<FilterFindOnePowerMonitorTotalActivePowerInput>;
  totalPowerFactor?: InputMaybe<FilterFindOnePowerMonitorTotalPowerFactorInput>;
  unitId?: InputMaybe<Scalars['String']>;
  updateStatus?: InputMaybe<Scalars['Boolean']>;
  vppId?: InputMaybe<Scalars['String']>;
  zoneId?: InputMaybe<Scalars['String']>;
};

export type FilterFindOnePowerMonitorPhaseAActiveEnergyFwdInput = {
  id?: InputMaybe<Scalars['String']>;
  observedAt?: InputMaybe<Scalars['Float']>;
  previousId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  units?: InputMaybe<Scalars['String']>;
  updatePending?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<Scalars['Float']>;
};

export type FilterFindOnePowerMonitorPhaseAActiveEnergyRevInput = {
  id?: InputMaybe<Scalars['String']>;
  observedAt?: InputMaybe<Scalars['Float']>;
  previousId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  units?: InputMaybe<Scalars['String']>;
  updatePending?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<Scalars['Float']>;
};

export type FilterFindOnePowerMonitorPhaseAActivePowerInput = {
  id?: InputMaybe<Scalars['String']>;
  observedAt?: InputMaybe<Scalars['Float']>;
  previousId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  units?: InputMaybe<Scalars['String']>;
  updatePending?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<Scalars['Float']>;
};

export type FilterFindOnePowerMonitorPhaseACurrentInput = {
  id?: InputMaybe<Scalars['String']>;
  observedAt?: InputMaybe<Scalars['Float']>;
  previousId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  units?: InputMaybe<Scalars['String']>;
  updatePending?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<Scalars['Float']>;
};

export type FilterFindOnePowerMonitorPhaseAFrequencyInput = {
  id?: InputMaybe<Scalars['String']>;
  observedAt?: InputMaybe<Scalars['Float']>;
  previousId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  units?: InputMaybe<Scalars['String']>;
  updatePending?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<Scalars['Float']>;
};

export type FilterFindOnePowerMonitorPhaseAPowerFactorInput = {
  id?: InputMaybe<Scalars['String']>;
  observedAt?: InputMaybe<Scalars['Float']>;
  previousId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  units?: InputMaybe<Scalars['String']>;
  updatePending?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<Scalars['Float']>;
};

export type FilterFindOnePowerMonitorPhaseAVoltageInput = {
  id?: InputMaybe<Scalars['String']>;
  observedAt?: InputMaybe<Scalars['Float']>;
  previousId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  units?: InputMaybe<Scalars['String']>;
  updatePending?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<Scalars['Float']>;
};

export type FilterFindOnePowerMonitorPhaseBActiveEnergyFwdInput = {
  id?: InputMaybe<Scalars['String']>;
  observedAt?: InputMaybe<Scalars['Float']>;
  previousId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  units?: InputMaybe<Scalars['String']>;
  updatePending?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<Scalars['Float']>;
};

export type FilterFindOnePowerMonitorPhaseBActiveEnergyRevInput = {
  id?: InputMaybe<Scalars['String']>;
  observedAt?: InputMaybe<Scalars['Float']>;
  previousId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  units?: InputMaybe<Scalars['String']>;
  updatePending?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<Scalars['Float']>;
};

export type FilterFindOnePowerMonitorPhaseBActivePowerInput = {
  id?: InputMaybe<Scalars['String']>;
  observedAt?: InputMaybe<Scalars['Float']>;
  previousId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  units?: InputMaybe<Scalars['String']>;
  updatePending?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<Scalars['Float']>;
};

export type FilterFindOnePowerMonitorPhaseBCurrentInput = {
  id?: InputMaybe<Scalars['String']>;
  observedAt?: InputMaybe<Scalars['Float']>;
  previousId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  units?: InputMaybe<Scalars['String']>;
  updatePending?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<Scalars['Float']>;
};

export type FilterFindOnePowerMonitorPhaseBFrequencyInput = {
  id?: InputMaybe<Scalars['String']>;
  observedAt?: InputMaybe<Scalars['Float']>;
  previousId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  units?: InputMaybe<Scalars['String']>;
  updatePending?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<Scalars['Float']>;
};

export type FilterFindOnePowerMonitorPhaseBPowerFactorInput = {
  id?: InputMaybe<Scalars['String']>;
  observedAt?: InputMaybe<Scalars['Float']>;
  previousId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  units?: InputMaybe<Scalars['String']>;
  updatePending?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<Scalars['Float']>;
};

export type FilterFindOnePowerMonitorPhaseBVoltageInput = {
  id?: InputMaybe<Scalars['String']>;
  observedAt?: InputMaybe<Scalars['Float']>;
  previousId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  units?: InputMaybe<Scalars['String']>;
  updatePending?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<Scalars['Float']>;
};

export type FilterFindOnePowerMonitorPhaseCActiveEnergyFwdInput = {
  id?: InputMaybe<Scalars['String']>;
  observedAt?: InputMaybe<Scalars['Float']>;
  previousId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  units?: InputMaybe<Scalars['String']>;
  updatePending?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<Scalars['Float']>;
};

export type FilterFindOnePowerMonitorPhaseCActiveEnergyRevInput = {
  id?: InputMaybe<Scalars['String']>;
  observedAt?: InputMaybe<Scalars['Float']>;
  previousId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  units?: InputMaybe<Scalars['String']>;
  updatePending?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<Scalars['Float']>;
};

export type FilterFindOnePowerMonitorPhaseCActivePowerInput = {
  id?: InputMaybe<Scalars['String']>;
  observedAt?: InputMaybe<Scalars['Float']>;
  previousId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  units?: InputMaybe<Scalars['String']>;
  updatePending?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<Scalars['Float']>;
};

export type FilterFindOnePowerMonitorPhaseCCurrentInput = {
  id?: InputMaybe<Scalars['String']>;
  observedAt?: InputMaybe<Scalars['Float']>;
  previousId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  units?: InputMaybe<Scalars['String']>;
  updatePending?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<Scalars['Float']>;
};

export type FilterFindOnePowerMonitorPhaseCFrequencyInput = {
  id?: InputMaybe<Scalars['String']>;
  observedAt?: InputMaybe<Scalars['Float']>;
  previousId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  units?: InputMaybe<Scalars['String']>;
  updatePending?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<Scalars['Float']>;
};

export type FilterFindOnePowerMonitorPhaseCPowerFactorInput = {
  id?: InputMaybe<Scalars['String']>;
  observedAt?: InputMaybe<Scalars['Float']>;
  previousId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  units?: InputMaybe<Scalars['String']>;
  updatePending?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<Scalars['Float']>;
};

export type FilterFindOnePowerMonitorPhaseCVoltageInput = {
  id?: InputMaybe<Scalars['String']>;
  observedAt?: InputMaybe<Scalars['Float']>;
  previousId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  units?: InputMaybe<Scalars['String']>;
  updatePending?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<Scalars['Float']>;
};

export type FilterFindOnePowerMonitorThreePhaseTotalActiveEnergyFwdInput = {
  id?: InputMaybe<Scalars['String']>;
  observedAt?: InputMaybe<Scalars['Float']>;
  previousId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  units?: InputMaybe<Scalars['String']>;
  updatePending?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<Scalars['Float']>;
};

export type FilterFindOnePowerMonitorThreePhaseTotalActiveEnergyRevInput = {
  id?: InputMaybe<Scalars['String']>;
  observedAt?: InputMaybe<Scalars['Float']>;
  previousId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  units?: InputMaybe<Scalars['String']>;
  updatePending?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<Scalars['Float']>;
};

export type FilterFindOnePowerMonitorTotalActivePowerInput = {
  id?: InputMaybe<Scalars['String']>;
  observedAt?: InputMaybe<Scalars['Float']>;
  previousId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  units?: InputMaybe<Scalars['String']>;
  updatePending?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<Scalars['Float']>;
};

export type FilterFindOnePowerMonitorTotalPowerFactorInput = {
  id?: InputMaybe<Scalars['String']>;
  observedAt?: InputMaybe<Scalars['Float']>;
  previousId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  units?: InputMaybe<Scalars['String']>;
  updatePending?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<Scalars['Float']>;
};

export type FilterFindOnePressureSensorInput = {
  AND?: InputMaybe<Array<FilterFindOneDeviceInput>>;
  OR?: InputMaybe<Array<FilterFindOneDeviceInput>>;
  _id?: InputMaybe<Scalars['String']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterFindOneDeviceOperatorsInput>;
  alertTypes?: InputMaybe<FilterFindOneDeviceAlertTypesInput>;
  controlled?: InputMaybe<FilterFindOneDeviceControlledInput>;
  deviceId?: InputMaybe<Scalars['String']>;
  installation?: InputMaybe<FilterFindOneDeviceInstallationInput>;
  location?: InputMaybe<Scalars['String']>;
  meta?: InputMaybe<FilterFindOneDeviceMetaInput>;
  /** The name of the device */
  name?: InputMaybe<Scalars['String']>;
  panelId?: InputMaybe<Scalars['String']>;
  powerState?: InputMaybe<FilterFindOneDevicePowerStateInput>;
  pressure?: InputMaybe<FilterFindOnePressureSensorPressureInput>;
  propertyId?: InputMaybe<Scalars['String']>;
  role?: InputMaybe<Scalars['String']>;
  sourceId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  unitId?: InputMaybe<Scalars['String']>;
  updateStatus?: InputMaybe<Scalars['Boolean']>;
  vppId?: InputMaybe<Scalars['String']>;
  zoneId?: InputMaybe<Scalars['String']>;
};

export type FilterFindOnePressureSensorPressureInput = {
  id?: InputMaybe<Scalars['String']>;
  observedAt?: InputMaybe<Scalars['Float']>;
  previousId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  units?: InputMaybe<Scalars['String']>;
  updatePending?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<Scalars['Float']>;
};

export type FilterFindOnePropertyAddressInput = {
  city?: InputMaybe<Scalars['String']>;
  line1?: InputMaybe<Scalars['String']>;
  line2?: InputMaybe<Scalars['String']>;
  postalCode?: InputMaybe<Scalars['String']>;
  state?: InputMaybe<Scalars['String']>;
};

export type FilterFindOnePropertyAlertLimitsInput = {
  plant?: InputMaybe<FilterFindOnePropertyAlertLimitsPlantInput>;
  units?: InputMaybe<FilterFindOnePropertyAlertLimitsUnitsInput>;
};

export type FilterFindOnePropertyAlertLimitsPlantDhwInput = {
  temperature?: InputMaybe<FilterFindOnePropertyAlertLimitsPlantDhwTemperatureInput>;
};

export type FilterFindOnePropertyAlertLimitsPlantDhwTemperatureInput = {
  max?: InputMaybe<Scalars['Float']>;
  min?: InputMaybe<Scalars['Float']>;
};

export type FilterFindOnePropertyAlertLimitsPlantInput = {
  dhw?: InputMaybe<FilterFindOnePropertyAlertLimitsPlantDhwInput>;
  loops?: InputMaybe<FilterFindOnePropertyAlertLimitsPlantLoopsInput>;
};

export type FilterFindOnePropertyAlertLimitsPlantLoopsInput = {
  pressure?: InputMaybe<FilterFindOnePropertyAlertLimitsPlantLoopsPressureInput>;
  temperature?: InputMaybe<FilterFindOnePropertyAlertLimitsPlantLoopsTemperatureInput>;
};

export type FilterFindOnePropertyAlertLimitsPlantLoopsPressureInput = {
  max?: InputMaybe<Scalars['Float']>;
  min?: InputMaybe<Scalars['Float']>;
};

export type FilterFindOnePropertyAlertLimitsPlantLoopsTemperatureInput = {
  max?: InputMaybe<Scalars['Float']>;
  min?: InputMaybe<Scalars['Float']>;
};

export type FilterFindOnePropertyAlertLimitsUnitsHumidityInput = {
  max?: InputMaybe<Scalars['Float']>;
  min?: InputMaybe<Scalars['Float']>;
};

export type FilterFindOnePropertyAlertLimitsUnitsInput = {
  humidity?: InputMaybe<FilterFindOnePropertyAlertLimitsUnitsHumidityInput>;
  temperature?: InputMaybe<FilterFindOnePropertyAlertLimitsUnitsTemperatureInput>;
};

export type FilterFindOnePropertyAlertLimitsUnitsTemperatureInput = {
  max?: InputMaybe<Scalars['Float']>;
  min?: InputMaybe<Scalars['Float']>;
};

export type FilterFindOnePropertyAlertTypesInput = {
  deviceAlert?: InputMaybe<Scalars['Boolean']>;
  deviceMetric?: InputMaybe<Scalars['Boolean']>;
  deviceOffline?: InputMaybe<Scalars['Boolean']>;
  equipmentAlarm?: InputMaybe<Scalars['Boolean']>;
  sourceOffline?: InputMaybe<Scalars['Boolean']>;
};

export type FilterFindOnePropertyContactInput = {
  email?: InputMaybe<Scalars['String']>;
  email2?: InputMaybe<Scalars['String']>;
  email3?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  smsNumber?: InputMaybe<Scalars['String']>;
  smsNumber2?: InputMaybe<Scalars['String']>;
  smsNumber3?: InputMaybe<Scalars['String']>;
  smsOptInStatus1?: InputMaybe<EnumPropertyContactSmsOptInStatus1>;
  smsOptInStatus2?: InputMaybe<EnumPropertyContactSmsOptInStatus2>;
  smsOptInStatus3?: InputMaybe<EnumPropertyContactSmsOptInStatus3>;
  smsOptInTimestamp1?: InputMaybe<Scalars['Float']>;
  smsOptInTimestamp2?: InputMaybe<Scalars['Float']>;
  smsOptInTimestamp3?: InputMaybe<Scalars['Float']>;
};

export type FilterFindOnePropertyInput = {
  AND?: InputMaybe<Array<FilterFindOnePropertyInput>>;
  OR?: InputMaybe<Array<FilterFindOnePropertyInput>>;
  _id?: InputMaybe<Scalars['String']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterFindOnePropertyOperatorsInput>;
  address?: InputMaybe<FilterFindOnePropertyAddressInput>;
  alertLimits?: InputMaybe<FilterFindOnePropertyAlertLimitsInput>;
  alertTypes?: InputMaybe<FilterFindOnePropertyAlertTypesInput>;
  contact?: InputMaybe<FilterFindOnePropertyContactInput>;
  floorLabel?: InputMaybe<Scalars['String']>;
  hasSecondaryHeatSource?: InputMaybe<Scalars['Boolean']>;
  imageUrl?: InputMaybe<Scalars['String']>;
  maintMgr?: InputMaybe<FilterFindOnePropertyMaintMgrInput>;
  organizationId?: InputMaybe<Scalars['String']>;
  owner?: InputMaybe<FilterFindOnePropertyOwnerInput>;
  propMgr?: InputMaybe<FilterFindOnePropertyPropMgrInput>;
  setpointProfileId?: InputMaybe<Scalars['String']>;
  tempDisplayUnits?: InputMaybe<Scalars['String']>;
  thermostatScheduleTemplateId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['String']>;
  title?: InputMaybe<Scalars['String']>;
  unitsSummary?: InputMaybe<FilterFindOnePropertyUnitsSummaryInput>;
  zonePolicyId?: InputMaybe<Scalars['String']>;
};

export type FilterFindOnePropertyMaintMgrInput = {
  email?: InputMaybe<Scalars['String']>;
  mobile?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterFindOnePropertyOperatorsInput = {
  _id?: InputMaybe<FilterFindOneProperty_IdOperatorsInput>;
  title?: InputMaybe<FilterFindOnePropertyTitleOperatorsInput>;
  unitsSummary?: InputMaybe<FilterFindOnePropertyUnitsSummaryOperatorsInput>;
};

export type FilterFindOnePropertyOwnerInput = {
  email?: InputMaybe<Scalars['String']>;
  mobile?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  phone?: InputMaybe<Scalars['String']>;
};

export type FilterFindOnePropertyPropMgrInput = {
  email?: InputMaybe<Scalars['String']>;
  mobile?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  phone?: InputMaybe<Scalars['String']>;
};

export type FilterFindOnePropertyTitleOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['String']>;
  gte?: InputMaybe<Scalars['String']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  lt?: InputMaybe<Scalars['String']>;
  lte?: InputMaybe<Scalars['String']>;
  ne?: InputMaybe<Scalars['String']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']>;
};

export type FilterFindOnePropertyUnitsSummaryCountOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['Float']>;
  gte?: InputMaybe<Scalars['Float']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Float']>>>;
  lt?: InputMaybe<Scalars['Float']>;
  lte?: InputMaybe<Scalars['Float']>;
  ne?: InputMaybe<Scalars['Float']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Float']>>>;
};

export type FilterFindOnePropertyUnitsSummaryInput = {
  count?: InputMaybe<Scalars['Float']>;
  majorAlerts?: InputMaybe<Scalars['Float']>;
  minorAlerts?: InputMaybe<Scalars['Float']>;
};

export type FilterFindOnePropertyUnitsSummaryMajorAlertsOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['Float']>;
  gte?: InputMaybe<Scalars['Float']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Float']>>>;
  lt?: InputMaybe<Scalars['Float']>;
  lte?: InputMaybe<Scalars['Float']>;
  ne?: InputMaybe<Scalars['Float']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Float']>>>;
};

export type FilterFindOnePropertyUnitsSummaryOperatorsInput = {
  count?: InputMaybe<FilterFindOnePropertyUnitsSummaryCountOperatorsInput>;
  majorAlerts?: InputMaybe<FilterFindOnePropertyUnitsSummaryMajorAlertsOperatorsInput>;
};

export type FilterFindOneProperty_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['String']>;
  gte?: InputMaybe<Scalars['String']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  lt?: InputMaybe<Scalars['String']>;
  lte?: InputMaybe<Scalars['String']>;
  ne?: InputMaybe<Scalars['String']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']>;
};

export type FilterFindOneRelayDeviceInput = {
  AND?: InputMaybe<Array<FilterFindOneDeviceInput>>;
  OR?: InputMaybe<Array<FilterFindOneDeviceInput>>;
  _id?: InputMaybe<Scalars['String']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterFindOneDeviceOperatorsInput>;
  alertTypes?: InputMaybe<FilterFindOneDeviceAlertTypesInput>;
  controlled?: InputMaybe<FilterFindOneDeviceControlledInput>;
  deviceId?: InputMaybe<Scalars['String']>;
  installation?: InputMaybe<FilterFindOneDeviceInstallationInput>;
  isOn?: InputMaybe<FilterFindOneRelayDeviceIsOnInput>;
  location?: InputMaybe<Scalars['String']>;
  meta?: InputMaybe<FilterFindOneDeviceMetaInput>;
  /** The name of the device */
  name?: InputMaybe<Scalars['String']>;
  panelId?: InputMaybe<Scalars['String']>;
  powerState?: InputMaybe<FilterFindOneDevicePowerStateInput>;
  propertyId?: InputMaybe<Scalars['String']>;
  sourceId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  unitId?: InputMaybe<Scalars['String']>;
  updateStatus?: InputMaybe<Scalars['Boolean']>;
  vppId?: InputMaybe<Scalars['String']>;
  zoneId?: InputMaybe<Scalars['String']>;
};

export type FilterFindOneRelayDeviceIsOnInput = {
  id?: InputMaybe<Scalars['String']>;
  observedAt?: InputMaybe<Scalars['Float']>;
  previousId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  units?: InputMaybe<Scalars['String']>;
  updatePending?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<Scalars['Boolean']>;
};

export type FilterFindOneScheduledTaskInput = {
  AND?: InputMaybe<Array<FilterFindOneScheduledTaskInput>>;
  OR?: InputMaybe<Array<FilterFindOneScheduledTaskInput>>;
  _id?: InputMaybe<Scalars['String']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterFindOneScheduledTaskOperatorsInput>;
  completedAt?: InputMaybe<Scalars['Float']>;
  createdAt?: InputMaybe<Scalars['Float']>;
  errorMessage?: InputMaybe<Scalars['String']>;
  executionTimeMs?: InputMaybe<Scalars['Float']>;
  instanceId?: InputMaybe<Scalars['String']>;
  maxRetries?: InputMaybe<Scalars['Float']>;
  methodName?: InputMaybe<Scalars['String']>;
  modelName?: InputMaybe<Scalars['String']>;
  priority?: InputMaybe<Scalars['Float']>;
  retryCount?: InputMaybe<Scalars['Float']>;
  scheduledAt?: InputMaybe<Scalars['Float']>;
  startedAt?: InputMaybe<Scalars['Float']>;
  status?: InputMaybe<EnumScheduledTaskStatus>;
  updatedAt?: InputMaybe<Scalars['Float']>;
};

export type FilterFindOneScheduledTaskModelNameOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['String']>;
  gte?: InputMaybe<Scalars['String']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  lt?: InputMaybe<Scalars['String']>;
  lte?: InputMaybe<Scalars['String']>;
  ne?: InputMaybe<Scalars['String']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterFindOneScheduledTaskOperatorsInput = {
  _id?: InputMaybe<FilterFindOneScheduledTask_IdOperatorsInput>;
  modelName?: InputMaybe<FilterFindOneScheduledTaskModelNameOperatorsInput>;
  priority?: InputMaybe<FilterFindOneScheduledTaskPriorityOperatorsInput>;
  scheduledAt?: InputMaybe<FilterFindOneScheduledTaskScheduledAtOperatorsInput>;
  status?: InputMaybe<FilterFindOneScheduledTaskStatusOperatorsInput>;
};

export type FilterFindOneScheduledTaskPriorityOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['Float']>;
  gte?: InputMaybe<Scalars['Float']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Float']>>>;
  lt?: InputMaybe<Scalars['Float']>;
  lte?: InputMaybe<Scalars['Float']>;
  ne?: InputMaybe<Scalars['Float']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Float']>>>;
};

export type FilterFindOneScheduledTaskScheduledAtOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['Float']>;
  gte?: InputMaybe<Scalars['Float']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Float']>>>;
  lt?: InputMaybe<Scalars['Float']>;
  lte?: InputMaybe<Scalars['Float']>;
  ne?: InputMaybe<Scalars['Float']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Float']>>>;
};

export type FilterFindOneScheduledTaskStatusOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<EnumScheduledTaskStatus>;
  gte?: InputMaybe<EnumScheduledTaskStatus>;
  in?: InputMaybe<Array<InputMaybe<EnumScheduledTaskStatus>>>;
  lt?: InputMaybe<EnumScheduledTaskStatus>;
  lte?: InputMaybe<EnumScheduledTaskStatus>;
  ne?: InputMaybe<EnumScheduledTaskStatus>;
  nin?: InputMaybe<Array<InputMaybe<EnumScheduledTaskStatus>>>;
};

export type FilterFindOneScheduledTask_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['String']>;
  gte?: InputMaybe<Scalars['String']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  lt?: InputMaybe<Scalars['String']>;
  lte?: InputMaybe<Scalars['String']>;
  ne?: InputMaybe<Scalars['String']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']>;
};

export type FilterFindOneSetpointProfileCoolInput = {
  max?: InputMaybe<Scalars['Float']>;
  min?: InputMaybe<Scalars['Float']>;
};

export type FilterFindOneSetpointProfileHeatInput = {
  max?: InputMaybe<Scalars['Float']>;
  min?: InputMaybe<Scalars['Float']>;
};

export type FilterFindOneSetpointProfileInput = {
  AND?: InputMaybe<Array<FilterFindOneSetpointProfileInput>>;
  OR?: InputMaybe<Array<FilterFindOneSetpointProfileInput>>;
  _id?: InputMaybe<Scalars['String']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterFindOneSetpointProfileOperatorsInput>;
  cool?: InputMaybe<FilterFindOneSetpointProfileCoolInput>;
  createdAt?: InputMaybe<Scalars['Float']>;
  createdBy?: InputMaybe<Scalars['String']>;
  heat?: InputMaybe<FilterFindOneSetpointProfileHeatInput>;
  name?: InputMaybe<Scalars['String']>;
  propagated?: InputMaybe<Scalars['Boolean']>;
  properties?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  type?: InputMaybe<EnumSetpointProfileType>;
  units?: InputMaybe<EnumSetpointProfileUnits>;
  updatedAt?: InputMaybe<Scalars['Float']>;
  updatedBy?: InputMaybe<Scalars['String']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterFindOneSetpointProfileOperatorsInput = {
  _id?: InputMaybe<FilterFindOneSetpointProfile_IdOperatorsInput>;
  properties?: InputMaybe<FilterFindOneSetpointProfilePropertiesOperatorsInput>;
};

export type FilterFindOneSetpointProfilePropertiesOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['String']>;
  gte?: InputMaybe<Scalars['String']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  lt?: InputMaybe<Scalars['String']>;
  lte?: InputMaybe<Scalars['String']>;
  ne?: InputMaybe<Scalars['String']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']>;
};

export type FilterFindOneSetpointProfile_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['String']>;
  gte?: InputMaybe<Scalars['String']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  lt?: InputMaybe<Scalars['String']>;
  lte?: InputMaybe<Scalars['String']>;
  ne?: InputMaybe<Scalars['String']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']>;
};

export type FilterFindOneSmartPowerOutletActivePowerInput = {
  id?: InputMaybe<Scalars['String']>;
  observedAt?: InputMaybe<Scalars['Float']>;
  previousId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  units?: InputMaybe<Scalars['String']>;
  updatePending?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<Scalars['Float']>;
};

export type FilterFindOneSmartPowerOutletApparentPowerInput = {
  id?: InputMaybe<Scalars['String']>;
  observedAt?: InputMaybe<Scalars['Float']>;
  previousId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  units?: InputMaybe<Scalars['String']>;
  updatePending?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<Scalars['Float']>;
};

export type FilterFindOneSmartPowerOutletCumulativePowerInput = {
  id?: InputMaybe<Scalars['String']>;
  observedAt?: InputMaybe<Scalars['Float']>;
  previousId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  units?: InputMaybe<Scalars['String']>;
  updatePending?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<Scalars['Float']>;
};

export type FilterFindOneSmartPowerOutletInput = {
  AND?: InputMaybe<Array<FilterFindOneDeviceInput>>;
  OR?: InputMaybe<Array<FilterFindOneDeviceInput>>;
  _id?: InputMaybe<Scalars['String']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterFindOneDeviceOperatorsInput>;
  activePower?: InputMaybe<FilterFindOneSmartPowerOutletActivePowerInput>;
  alertTypes?: InputMaybe<FilterFindOneDeviceAlertTypesInput>;
  apparentPower?: InputMaybe<FilterFindOneSmartPowerOutletApparentPowerInput>;
  controlled?: InputMaybe<FilterFindOneDeviceControlledInput>;
  cumulativePower?: InputMaybe<FilterFindOneSmartPowerOutletCumulativePowerInput>;
  cumulativePowerOffset?: InputMaybe<Scalars['Float']>;
  cumulativePowerResetTime?: InputMaybe<Scalars['Float']>;
  deviceId?: InputMaybe<Scalars['String']>;
  installation?: InputMaybe<FilterFindOneDeviceInstallationInput>;
  isOn?: InputMaybe<FilterFindOneSmartPowerOutletIsOnInput>;
  location?: InputMaybe<Scalars['String']>;
  meta?: InputMaybe<FilterFindOneDeviceMetaInput>;
  /** The name of the device */
  name?: InputMaybe<Scalars['String']>;
  panelId?: InputMaybe<Scalars['String']>;
  powerFactor?: InputMaybe<FilterFindOneSmartPowerOutletPowerFactorInput>;
  powerState?: InputMaybe<FilterFindOneDevicePowerStateInput>;
  propertyId?: InputMaybe<Scalars['String']>;
  rmsCurrent?: InputMaybe<FilterFindOneSmartPowerOutletRmsCurrentInput>;
  rmsVoltage?: InputMaybe<FilterFindOneSmartPowerOutletRmsVoltageInput>;
  sourceId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  unitId?: InputMaybe<Scalars['String']>;
  updateStatus?: InputMaybe<Scalars['Boolean']>;
  vppId?: InputMaybe<Scalars['String']>;
  zoneId?: InputMaybe<Scalars['String']>;
};

export type FilterFindOneSmartPowerOutletIsOnInput = {
  id?: InputMaybe<Scalars['String']>;
  observedAt?: InputMaybe<Scalars['Float']>;
  previousId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  units?: InputMaybe<Scalars['String']>;
  updatePending?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<Scalars['Boolean']>;
};

export type FilterFindOneSmartPowerOutletPowerFactorInput = {
  id?: InputMaybe<Scalars['String']>;
  observedAt?: InputMaybe<Scalars['Float']>;
  previousId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  units?: InputMaybe<Scalars['String']>;
  updatePending?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<Scalars['Float']>;
};

export type FilterFindOneSmartPowerOutletRmsCurrentInput = {
  id?: InputMaybe<Scalars['String']>;
  observedAt?: InputMaybe<Scalars['Float']>;
  previousId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  units?: InputMaybe<Scalars['String']>;
  updatePending?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<Scalars['Float']>;
};

export type FilterFindOneSmartPowerOutletRmsVoltageInput = {
  id?: InputMaybe<Scalars['String']>;
  observedAt?: InputMaybe<Scalars['Float']>;
  previousId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  units?: InputMaybe<Scalars['String']>;
  updatePending?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<Scalars['Float']>;
};

export type FilterFindOneSolarManagementSystemAzimuthInput = {
  id?: InputMaybe<Scalars['String']>;
  observedAt?: InputMaybe<Scalars['Float']>;
  previousId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  units?: InputMaybe<Scalars['String']>;
  updatePending?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<Scalars['Float']>;
};

export type FilterFindOneSolarManagementSystemDegradationRateInput = {
  id?: InputMaybe<Scalars['String']>;
  observedAt?: InputMaybe<Scalars['Float']>;
  previousId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  units?: InputMaybe<Scalars['String']>;
  updatePending?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<Scalars['Float']>;
};

export type FilterFindOneSolarManagementSystemInput = {
  AND?: InputMaybe<Array<FilterFindOneDeviceInput>>;
  OR?: InputMaybe<Array<FilterFindOneDeviceInput>>;
  _id?: InputMaybe<Scalars['String']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterFindOneDeviceOperatorsInput>;
  alertTypes?: InputMaybe<FilterFindOneDeviceAlertTypesInput>;
  azimuth?: InputMaybe<FilterFindOneSolarManagementSystemAzimuthInput>;
  controlled?: InputMaybe<FilterFindOneDeviceControlledInput>;
  degradationRate?: InputMaybe<FilterFindOneSolarManagementSystemDegradationRateInput>;
  deviceId?: InputMaybe<Scalars['String']>;
  installation?: InputMaybe<FilterFindOneDeviceInstallationInput>;
  isTrackerSystem?: InputMaybe<FilterFindOneSolarManagementSystemIsTrackerSystemInput>;
  location?: InputMaybe<Scalars['String']>;
  meta?: InputMaybe<FilterFindOneDeviceMetaInput>;
  /** The name of the device */
  name?: InputMaybe<Scalars['String']>;
  panelCurrents?: InputMaybe<
    Array<InputMaybe<FilterFindOneSolarManagementSystemPanelCurrentsInput>>
  >;
  panelId?: InputMaybe<Scalars['String']>;
  panelTemperature?: InputMaybe<FilterFindOneSolarManagementSystemPanelTemperatureInput>;
  panelVoltages?: InputMaybe<
    Array<InputMaybe<FilterFindOneSolarManagementSystemPanelVoltagesInput>>
  >;
  powerState?: InputMaybe<FilterFindOneDevicePowerStateInput>;
  propertyId?: InputMaybe<Scalars['String']>;
  shadingFactor?: InputMaybe<FilterFindOneSolarManagementSystemShadingFactorInput>;
  solarIrradiance?: InputMaybe<FilterFindOneSolarManagementSystemSolarIrradianceInput>;
  sourceId?: InputMaybe<Scalars['String']>;
  tiltAngle?: InputMaybe<FilterFindOneSolarManagementSystemTiltAngleInput>;
  timestamp?: InputMaybe<Scalars['Float']>;
  unitId?: InputMaybe<Scalars['String']>;
  updateStatus?: InputMaybe<Scalars['Boolean']>;
  vppId?: InputMaybe<Scalars['String']>;
  zoneId?: InputMaybe<Scalars['String']>;
};

export type FilterFindOneSolarManagementSystemIsTrackerSystemInput = {
  id?: InputMaybe<Scalars['String']>;
  observedAt?: InputMaybe<Scalars['Float']>;
  previousId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  units?: InputMaybe<Scalars['String']>;
  updatePending?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<Scalars['Boolean']>;
};

export type FilterFindOneSolarManagementSystemPanelCurrentsInput = {
  id?: InputMaybe<Scalars['String']>;
  observedAt?: InputMaybe<Scalars['Float']>;
  previousId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  units?: InputMaybe<Scalars['String']>;
  updatePending?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<Scalars['Float']>;
};

export type FilterFindOneSolarManagementSystemPanelTemperatureInput = {
  id?: InputMaybe<Scalars['String']>;
  observedAt?: InputMaybe<Scalars['Float']>;
  previousId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  units?: InputMaybe<Scalars['String']>;
  updatePending?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<Scalars['Float']>;
};

export type FilterFindOneSolarManagementSystemPanelVoltagesInput = {
  id?: InputMaybe<Scalars['String']>;
  observedAt?: InputMaybe<Scalars['Float']>;
  previousId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  units?: InputMaybe<Scalars['String']>;
  updatePending?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<Scalars['Float']>;
};

export type FilterFindOneSolarManagementSystemShadingFactorInput = {
  id?: InputMaybe<Scalars['String']>;
  observedAt?: InputMaybe<Scalars['Float']>;
  previousId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  units?: InputMaybe<Scalars['String']>;
  updatePending?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<Scalars['Float']>;
};

export type FilterFindOneSolarManagementSystemSolarIrradianceInput = {
  id?: InputMaybe<Scalars['String']>;
  observedAt?: InputMaybe<Scalars['Float']>;
  previousId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  units?: InputMaybe<Scalars['String']>;
  updatePending?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<Scalars['Float']>;
};

export type FilterFindOneSolarManagementSystemTiltAngleInput = {
  id?: InputMaybe<Scalars['String']>;
  observedAt?: InputMaybe<Scalars['Float']>;
  previousId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  units?: InputMaybe<Scalars['String']>;
  updatePending?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<Scalars['Float']>;
};

export type FilterFindOneSourceInput = {
  AND?: InputMaybe<Array<FilterFindOneSourceInput>>;
  OR?: InputMaybe<Array<FilterFindOneSourceInput>>;
  _id?: InputMaybe<Scalars['String']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterFindOneSourceOperatorsInput>;
  name?: InputMaybe<Scalars['String']>;
  propertyId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  type?: InputMaybe<EnumDKeySourceType>;
  url?: InputMaybe<Scalars['String']>;
};

export type FilterFindOneSourceNameOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['String']>;
  gte?: InputMaybe<Scalars['String']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  lt?: InputMaybe<Scalars['String']>;
  lte?: InputMaybe<Scalars['String']>;
  ne?: InputMaybe<Scalars['String']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterFindOneSourceOperatorsInput = {
  _id?: InputMaybe<FilterFindOneSource_IdOperatorsInput>;
  name?: InputMaybe<FilterFindOneSourceNameOperatorsInput>;
};

export type FilterFindOneSource_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['String']>;
  gte?: InputMaybe<Scalars['String']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  lt?: InputMaybe<Scalars['String']>;
  lte?: InputMaybe<Scalars['String']>;
  ne?: InputMaybe<Scalars['String']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']>;
};

export type FilterFindOneSystemNotificationCreatedAtOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['Float']>;
  gte?: InputMaybe<Scalars['Float']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Float']>>>;
  lt?: InputMaybe<Scalars['Float']>;
  lte?: InputMaybe<Scalars['Float']>;
  ne?: InputMaybe<Scalars['Float']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Float']>>>;
};

export type FilterFindOneSystemNotificationDisplayEndOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['Float']>;
  gte?: InputMaybe<Scalars['Float']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Float']>>>;
  lt?: InputMaybe<Scalars['Float']>;
  lte?: InputMaybe<Scalars['Float']>;
  ne?: InputMaybe<Scalars['Float']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Float']>>>;
};

export type FilterFindOneSystemNotificationDisplayStartOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['Float']>;
  gte?: InputMaybe<Scalars['Float']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Float']>>>;
  lt?: InputMaybe<Scalars['Float']>;
  lte?: InputMaybe<Scalars['Float']>;
  ne?: InputMaybe<Scalars['Float']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Float']>>>;
};

export type FilterFindOneSystemNotificationEntityIdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['String']>;
  gte?: InputMaybe<Scalars['String']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  lt?: InputMaybe<Scalars['String']>;
  lte?: InputMaybe<Scalars['String']>;
  ne?: InputMaybe<Scalars['String']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']>;
};

export type FilterFindOneSystemNotificationEntityTypeOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<EnumSystemNotificationEntityType>;
  gte?: InputMaybe<EnumSystemNotificationEntityType>;
  in?: InputMaybe<Array<InputMaybe<EnumSystemNotificationEntityType>>>;
  lt?: InputMaybe<EnumSystemNotificationEntityType>;
  lte?: InputMaybe<EnumSystemNotificationEntityType>;
  ne?: InputMaybe<EnumSystemNotificationEntityType>;
  nin?: InputMaybe<Array<InputMaybe<EnumSystemNotificationEntityType>>>;
};

export type FilterFindOneSystemNotificationInput = {
  AND?: InputMaybe<Array<FilterFindOneSystemNotificationInput>>;
  OR?: InputMaybe<Array<FilterFindOneSystemNotificationInput>>;
  _id?: InputMaybe<Scalars['String']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterFindOneSystemNotificationOperatorsInput>;
  acknowledgedAt?: InputMaybe<Scalars['Float']>;
  createdAt?: InputMaybe<Scalars['Float']>;
  displayDuration?: InputMaybe<Scalars['Float']>;
  displayEnd?: InputMaybe<Scalars['Float']>;
  displayStart?: InputMaybe<Scalars['Float']>;
  entityId?: InputMaybe<Scalars['String']>;
  entityType?: InputMaybe<EnumSystemNotificationEntityType>;
  link?: InputMaybe<Scalars['String']>;
  message?: InputMaybe<Scalars['String']>;
  requireAcknowledgement?: InputMaybe<Scalars['Boolean']>;
  seenAt?: InputMaybe<Scalars['Float']>;
  seenBy?: InputMaybe<
    Array<InputMaybe<FilterFindOneSystemNotificationSeenByInput>>
  >;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterFindOneSystemNotificationOperatorsInput = {
  _id?: InputMaybe<FilterFindOneSystemNotification_IdOperatorsInput>;
  createdAt?: InputMaybe<FilterFindOneSystemNotificationCreatedAtOperatorsInput>;
  displayEnd?: InputMaybe<FilterFindOneSystemNotificationDisplayEndOperatorsInput>;
  displayStart?: InputMaybe<FilterFindOneSystemNotificationDisplayStartOperatorsInput>;
  entityId?: InputMaybe<FilterFindOneSystemNotificationEntityIdOperatorsInput>;
  entityType?: InputMaybe<FilterFindOneSystemNotificationEntityTypeOperatorsInput>;
  seenBy?: InputMaybe<FilterFindOneSystemNotificationSeenByOperatorsInput>;
};

export type FilterFindOneSystemNotificationSeenByInput = {
  _id?: InputMaybe<Scalars['MongoID']>;
  seenAt?: InputMaybe<Scalars['Float']>;
  userId?: InputMaybe<Scalars['String']>;
};

export type FilterFindOneSystemNotificationSeenByOperatorsInput = {
  userId?: InputMaybe<FilterFindOneSystemNotificationSeenByUserIdOperatorsInput>;
};

export type FilterFindOneSystemNotificationSeenByUserIdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['String']>;
  gte?: InputMaybe<Scalars['String']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  lt?: InputMaybe<Scalars['String']>;
  lte?: InputMaybe<Scalars['String']>;
  ne?: InputMaybe<Scalars['String']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']>;
};

export type FilterFindOneSystemNotification_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['String']>;
  gte?: InputMaybe<Scalars['String']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  lt?: InputMaybe<Scalars['String']>;
  lte?: InputMaybe<Scalars['String']>;
  ne?: InputMaybe<Scalars['String']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']>;
};

export type FilterFindOneThermistorInput = {
  AND?: InputMaybe<Array<FilterFindOneDeviceInput>>;
  OR?: InputMaybe<Array<FilterFindOneDeviceInput>>;
  _id?: InputMaybe<Scalars['String']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterFindOneDeviceOperatorsInput>;
  alertTypes?: InputMaybe<FilterFindOneDeviceAlertTypesInput>;
  controlled?: InputMaybe<FilterFindOneDeviceControlledInput>;
  deviceId?: InputMaybe<Scalars['String']>;
  installation?: InputMaybe<FilterFindOneDeviceInstallationInput>;
  location?: InputMaybe<Scalars['String']>;
  meta?: InputMaybe<FilterFindOneDeviceMetaInput>;
  /** The name of the device */
  name?: InputMaybe<Scalars['String']>;
  panelId?: InputMaybe<Scalars['String']>;
  powerState?: InputMaybe<FilterFindOneDevicePowerStateInput>;
  propertyId?: InputMaybe<Scalars['String']>;
  role?: InputMaybe<Scalars['String']>;
  sourceId?: InputMaybe<Scalars['String']>;
  temperature?: InputMaybe<FilterFindOneThermistorTemperatureInput>;
  timestamp?: InputMaybe<Scalars['Float']>;
  unitId?: InputMaybe<Scalars['String']>;
  updateStatus?: InputMaybe<Scalars['Boolean']>;
  vppId?: InputMaybe<Scalars['String']>;
  zoneId?: InputMaybe<Scalars['String']>;
};

export type FilterFindOneThermistorTemperatureInput = {
  id?: InputMaybe<Scalars['String']>;
  observedAt?: InputMaybe<Scalars['Float']>;
  previousId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  units?: InputMaybe<Scalars['String']>;
  updatePending?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<Scalars['Float']>;
};

export type FilterFindOneThermostatAirDirectionInput = {
  id?: InputMaybe<Scalars['String']>;
  observedAt?: InputMaybe<Scalars['Float']>;
  previousId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  units?: InputMaybe<Scalars['String']>;
  updatePending?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<Scalars['String']>;
};

export type FilterFindOneThermostatCoolSetpointInput = {
  id?: InputMaybe<Scalars['String']>;
  observedAt?: InputMaybe<Scalars['Float']>;
  previousId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  units?: InputMaybe<Scalars['String']>;
  updatePending?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<Scalars['Float']>;
};

export type FilterFindOneThermostatDeviceSpecInput = {
  thermostat?: InputMaybe<FilterFindOneThermostatDeviceSpecThermostatInput>;
  version?: InputMaybe<Scalars['String']>;
};

export type FilterFindOneThermostatDeviceSpecThermostatInput = {
  controlContract?: InputMaybe<EnumThermostatDeviceSpecThermostatControlContract>;
  keypadLockoutLevels?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  modbusRTU?: InputMaybe<Scalars['Boolean']>;
  numberOfDailyTransitions?: InputMaybe<Scalars['Float']>;
  numberOfWeeklyTransitions?: InputMaybe<Scalars['Float']>;
  secondaryHeatSource?: InputMaybe<FilterFindOneThermostatDeviceSpecThermostatSecondaryHeatSourceInput>;
  setpointLimits?: InputMaybe<FilterFindOneThermostatDeviceSpecThermostatSetpointLimitsInput>;
  supportedAutoModeType?: InputMaybe<EnumThermostatDeviceSpecThermostatSupportedAutoModeType>;
  units?: InputMaybe<Scalars['String']>;
};

export type FilterFindOneThermostatDeviceSpecThermostatSecondaryHeatSourceInput =
  {
    alternateHeat?: InputMaybe<Scalars['Boolean']>;
    auxiliaryHeat?: InputMaybe<Scalars['Boolean']>;
  };

export type FilterFindOneThermostatDeviceSpecThermostatSetpointLimitsCoolInput =
  {
    max?: InputMaybe<Scalars['Float']>;
    min?: InputMaybe<Scalars['Float']>;
  };

export type FilterFindOneThermostatDeviceSpecThermostatSetpointLimitsInput = {
  cool?: InputMaybe<FilterFindOneThermostatDeviceSpecThermostatSetpointLimitsCoolInput>;
  heat?: InputMaybe<FilterFindOneThermostatDeviceSpecThermostatSetpointLimitsCoolInput>;
};

export type FilterFindOneThermostatFanModeInput = {
  id?: InputMaybe<Scalars['String']>;
  observedAt?: InputMaybe<Scalars['Float']>;
  previousId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  units?: InputMaybe<Scalars['String']>;
  updatePending?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<EnumThermostatFanModeValue>;
};

export type FilterFindOneThermostatFanSpeedInput = {
  id?: InputMaybe<Scalars['String']>;
  observedAt?: InputMaybe<Scalars['Float']>;
  previousId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  units?: InputMaybe<Scalars['String']>;
  updatePending?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<EnumThermostatFanSpeedValue>;
};

export type FilterFindOneThermostatFanStateInput = {
  id?: InputMaybe<Scalars['String']>;
  observedAt?: InputMaybe<Scalars['Float']>;
  previousId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  units?: InputMaybe<Scalars['String']>;
  updatePending?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<EnumThermostatFanStateValue>;
};

export type FilterFindOneThermostatHeatSetpointInput = {
  id?: InputMaybe<Scalars['String']>;
  observedAt?: InputMaybe<Scalars['Float']>;
  previousId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  units?: InputMaybe<Scalars['String']>;
  updatePending?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<Scalars['Float']>;
};

export type FilterFindOneThermostatHoldDurationInput = {
  id?: InputMaybe<Scalars['String']>;
  observedAt?: InputMaybe<Scalars['Float']>;
  previousId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  units?: InputMaybe<Scalars['String']>;
  updatePending?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<Scalars['Float']>;
};

export type FilterFindOneThermostatHoldEndInput = {
  id?: InputMaybe<Scalars['String']>;
  observedAt?: InputMaybe<Scalars['Float']>;
  previousId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  units?: InputMaybe<Scalars['String']>;
  updatePending?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<Scalars['Float']>;
};

export type FilterFindOneThermostatHoldExpiryTimeInput = {
  id?: InputMaybe<Scalars['String']>;
  observedAt?: InputMaybe<Scalars['Float']>;
  previousId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  units?: InputMaybe<Scalars['String']>;
  updatePending?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<Scalars['Float']>;
};

export type FilterFindOneThermostatHoldStateInput = {
  id?: InputMaybe<Scalars['String']>;
  observedAt?: InputMaybe<Scalars['Float']>;
  previousId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  units?: InputMaybe<Scalars['String']>;
  updatePending?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<EnumThermostatHoldStateValue>;
};

export type FilterFindOneThermostatHumidityInput = {
  id?: InputMaybe<Scalars['String']>;
  observedAt?: InputMaybe<Scalars['Float']>;
  previousId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  units?: InputMaybe<Scalars['String']>;
  updatePending?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<Scalars['Float']>;
};

export type FilterFindOneThermostatInput = {
  AND?: InputMaybe<Array<FilterFindOneDeviceInput>>;
  OR?: InputMaybe<Array<FilterFindOneDeviceInput>>;
  _id?: InputMaybe<Scalars['String']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterFindOneDeviceOperatorsInput>;
  airDirection?: InputMaybe<FilterFindOneThermostatAirDirectionInput>;
  alertTypes?: InputMaybe<FilterFindOneDeviceAlertTypesInput>;
  controlled?: InputMaybe<FilterFindOneDeviceControlledInput>;
  coolSetpoint?: InputMaybe<FilterFindOneThermostatCoolSetpointInput>;
  deviceId?: InputMaybe<Scalars['String']>;
  deviceSpec?: InputMaybe<FilterFindOneThermostatDeviceSpecInput>;
  fanMode?: InputMaybe<FilterFindOneThermostatFanModeInput>;
  fanSpeed?: InputMaybe<FilterFindOneThermostatFanSpeedInput>;
  fanState?: InputMaybe<FilterFindOneThermostatFanStateInput>;
  heatSetpoint?: InputMaybe<FilterFindOneThermostatHeatSetpointInput>;
  holdDuration?: InputMaybe<FilterFindOneThermostatHoldDurationInput>;
  holdEnd?: InputMaybe<FilterFindOneThermostatHoldEndInput>;
  holdExpiryTime?: InputMaybe<FilterFindOneThermostatHoldExpiryTimeInput>;
  holdState?: InputMaybe<FilterFindOneThermostatHoldStateInput>;
  humidity?: InputMaybe<FilterFindOneThermostatHumidityInput>;
  installation?: InputMaybe<FilterFindOneDeviceInstallationInput>;
  keypadLockoutLevel?: InputMaybe<FilterFindOneThermostatKeypadLockoutLevelInput>;
  lastScheduleChange?: InputMaybe<FilterFindOneThermostatLastScheduleChangeInput>;
  lastSetpointChange?: InputMaybe<FilterFindOneThermostatLastSetpointChangeInput>;
  localControlPermissions?: InputMaybe<FilterFindOneThermostatLocalControlPermissionsInput>;
  location?: InputMaybe<Scalars['String']>;
  maxCoolSetpointLimit?: InputMaybe<FilterFindOneThermostatMaxCoolSetpointLimitInput>;
  maxHeatSetpointLimit?: InputMaybe<FilterFindOneThermostatMaxHeatSetpointLimitInput>;
  maxSetpoint?: InputMaybe<FilterFindOneThermostatMaxSetpointInput>;
  meta?: InputMaybe<FilterFindOneDeviceMetaInput>;
  minCoolSetpointLimit?: InputMaybe<FilterFindOneThermostatMinCoolSetpointLimitInput>;
  minHeatSetpointLimit?: InputMaybe<FilterFindOneThermostatMinHeatSetpointLimitInput>;
  minSetpoint?: InputMaybe<FilterFindOneThermostatMinSetpointInput>;
  /** The name of the device */
  name?: InputMaybe<Scalars['String']>;
  operatingMode?: InputMaybe<FilterFindOneThermostatOperatingModeInput>;
  operatingState?: InputMaybe<FilterFindOneThermostatOperatingStateInput>;
  pairingState?: InputMaybe<FilterFindOneThermostatPairingStateInput>;
  panelId?: InputMaybe<Scalars['String']>;
  passCode?: InputMaybe<FilterFindOneThermostatPassCodeInput>;
  pendingSchedule?: InputMaybe<FilterFindOneThermostatPendingScheduleInput>;
  powerMode?: InputMaybe<FilterFindOneThermostatPowerModeInput>;
  powerState?: InputMaybe<FilterFindOneDevicePowerStateInput>;
  progMode?: InputMaybe<FilterFindOneThermostatProgModeInput>;
  propertyId?: InputMaybe<Scalars['String']>;
  remoteSensorTempDelta?: InputMaybe<FilterFindOneThermostatRemoteSensorTempDeltaInput>;
  schedVisibilityMode?: InputMaybe<FilterFindOneThermostatSchedVisibilityModeInput>;
  schedule?: InputMaybe<FilterFindOneThermostatScheduleInput>;
  setpoint?: InputMaybe<FilterFindOneThermostatSetpointInput>;
  setpointChangeSource?: InputMaybe<FilterFindOneThermostatSetpointChangeSourceInput>;
  showFanButton?: InputMaybe<FilterFindOneThermostatShowFanButtonInput>;
  sourceId?: InputMaybe<Scalars['String']>;
  systemType?: InputMaybe<FilterFindOneThermostatSystemTypeInput>;
  tempDisplayMode?: InputMaybe<FilterFindOneThermostatTempDisplayModeInput>;
  temperature?: InputMaybe<FilterFindOneThermostatTemperatureInput>;
  thermostatControlCommand?: InputMaybe<FilterFindOneThermostatThermostatControlCommandInput>;
  thermostatScheduleTemplateId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  uiOptions?: InputMaybe<FilterFindOneThermostatUiOptionsInput>;
  unitId?: InputMaybe<Scalars['String']>;
  updateStatus?: InputMaybe<Scalars['Boolean']>;
  useCustomSchedule?: InputMaybe<Scalars['Boolean']>;
  useCustomSetpointLimits?: InputMaybe<Scalars['Boolean']>;
  vppId?: InputMaybe<Scalars['String']>;
  zoneId?: InputMaybe<Scalars['String']>;
};

export type FilterFindOneThermostatKeypadLockoutLevelInput = {
  id?: InputMaybe<Scalars['String']>;
  observedAt?: InputMaybe<Scalars['Float']>;
  previousId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  units?: InputMaybe<Scalars['String']>;
  updatePending?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<Scalars['String']>;
};

export type FilterFindOneThermostatLastScheduleChangeInput = {
  id?: InputMaybe<Scalars['String']>;
  observedAt?: InputMaybe<Scalars['Float']>;
  previousId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  units?: InputMaybe<Scalars['String']>;
  updatePending?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<Scalars['Float']>;
};

export type FilterFindOneThermostatLastSetpointChangeInput = {
  id?: InputMaybe<Scalars['String']>;
  observedAt?: InputMaybe<Scalars['Float']>;
  previousId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  units?: InputMaybe<Scalars['String']>;
  updatePending?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<Scalars['Float']>;
};

export type FilterFindOneThermostatLocalControlPermissionsInput = {
  id?: InputMaybe<Scalars['String']>;
  observedAt?: InputMaybe<Scalars['Float']>;
  previousId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  units?: InputMaybe<Scalars['String']>;
  updatePending?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<Scalars['JSON']>;
};

export type FilterFindOneThermostatMaxCoolSetpointLimitInput = {
  id?: InputMaybe<Scalars['String']>;
  observedAt?: InputMaybe<Scalars['Float']>;
  previousId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  units?: InputMaybe<Scalars['String']>;
  updatePending?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<Scalars['Float']>;
};

export type FilterFindOneThermostatMaxHeatSetpointLimitInput = {
  id?: InputMaybe<Scalars['String']>;
  observedAt?: InputMaybe<Scalars['Float']>;
  previousId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  units?: InputMaybe<Scalars['String']>;
  updatePending?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<Scalars['Float']>;
};

export type FilterFindOneThermostatMaxSetpointInput = {
  id?: InputMaybe<Scalars['String']>;
  observedAt?: InputMaybe<Scalars['Float']>;
  previousId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  units?: InputMaybe<Scalars['String']>;
  updatePending?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<Scalars['Float']>;
};

export type FilterFindOneThermostatMinCoolSetpointLimitInput = {
  id?: InputMaybe<Scalars['String']>;
  observedAt?: InputMaybe<Scalars['Float']>;
  previousId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  units?: InputMaybe<Scalars['String']>;
  updatePending?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<Scalars['Float']>;
};

export type FilterFindOneThermostatMinHeatSetpointLimitInput = {
  id?: InputMaybe<Scalars['String']>;
  observedAt?: InputMaybe<Scalars['Float']>;
  previousId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  units?: InputMaybe<Scalars['String']>;
  updatePending?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<Scalars['Float']>;
};

export type FilterFindOneThermostatMinSetpointInput = {
  id?: InputMaybe<Scalars['String']>;
  observedAt?: InputMaybe<Scalars['Float']>;
  previousId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  units?: InputMaybe<Scalars['String']>;
  updatePending?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<Scalars['Float']>;
};

export type FilterFindOneThermostatOperatingModeInput = {
  id?: InputMaybe<Scalars['String']>;
  observedAt?: InputMaybe<Scalars['Float']>;
  previousId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  units?: InputMaybe<Scalars['String']>;
  updatePending?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<EnumThermostatOperatingModeValue>;
};

export type FilterFindOneThermostatOperatingStateInput = {
  id?: InputMaybe<Scalars['String']>;
  observedAt?: InputMaybe<Scalars['Float']>;
  previousId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  units?: InputMaybe<Scalars['String']>;
  updatePending?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<EnumThermostatOperatingStateValue>;
};

export type FilterFindOneThermostatPairingStateInput = {
  id?: InputMaybe<Scalars['String']>;
  observedAt?: InputMaybe<Scalars['Float']>;
  previousId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  units?: InputMaybe<Scalars['String']>;
  updatePending?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<EnumThermostatPairingStateValue>;
};

export type FilterFindOneThermostatPassCodeInput = {
  id?: InputMaybe<Scalars['String']>;
  observedAt?: InputMaybe<Scalars['Float']>;
  previousId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  units?: InputMaybe<Scalars['String']>;
  updatePending?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<Scalars['Float']>;
};

export type FilterFindOneThermostatPendingScheduleInput = {
  id?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  units?: InputMaybe<Scalars['String']>;
  updatePending?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<Scalars['JSON']>;
};

export type FilterFindOneThermostatPowerModeInput = {
  id?: InputMaybe<Scalars['String']>;
  observedAt?: InputMaybe<Scalars['Float']>;
  previousId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  units?: InputMaybe<Scalars['String']>;
  updatePending?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<EnumThermostatPowerModeValue>;
};

export type FilterFindOneThermostatProgModeInput = {
  id?: InputMaybe<Scalars['String']>;
  observedAt?: InputMaybe<Scalars['Float']>;
  previousId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  units?: InputMaybe<Scalars['String']>;
  updatePending?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<EnumThermostatProgModeValue>;
};

export type FilterFindOneThermostatRemoteSensorTempDeltaInput = {
  id?: InputMaybe<Scalars['String']>;
  observedAt?: InputMaybe<Scalars['Float']>;
  previousId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  units?: InputMaybe<Scalars['String']>;
  updatePending?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<Scalars['Float']>;
};

export type FilterFindOneThermostatSchedVisibilityModeInput = {
  id?: InputMaybe<Scalars['String']>;
  observedAt?: InputMaybe<Scalars['Float']>;
  previousId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  units?: InputMaybe<Scalars['String']>;
  updatePending?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<EnumThermostatSchedVisibilityModeValue>;
};

export type FilterFindOneThermostatScheduleInput = {
  id?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  units?: InputMaybe<Scalars['String']>;
  updatePending?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<Scalars['JSON']>;
};

export type FilterFindOneThermostatScheduleProfileInput = {
  AND?: InputMaybe<Array<FilterFindOneThermostatScheduleProfileInput>>;
  OR?: InputMaybe<Array<FilterFindOneThermostatScheduleProfileInput>>;
  _id?: InputMaybe<Scalars['String']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterFindOneThermostatScheduleProfileOperatorsInput>;
  name?: InputMaybe<Scalars['String']>;
  propertyId?: InputMaybe<Scalars['String']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterFindOneThermostatScheduleProfileOperatorsInput = {
  _id?: InputMaybe<FilterFindOneThermostatScheduleProfile_IdOperatorsInput>;
  propertyId?: InputMaybe<FilterFindOneThermostatScheduleProfilePropertyIdOperatorsInput>;
};

export type FilterFindOneThermostatScheduleProfilePropertyIdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['String']>;
  gte?: InputMaybe<Scalars['String']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  lt?: InputMaybe<Scalars['String']>;
  lte?: InputMaybe<Scalars['String']>;
  ne?: InputMaybe<Scalars['String']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']>;
};

export type FilterFindOneThermostatScheduleProfile_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['String']>;
  gte?: InputMaybe<Scalars['String']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  lt?: InputMaybe<Scalars['String']>;
  lte?: InputMaybe<Scalars['String']>;
  ne?: InputMaybe<Scalars['String']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']>;
};

export type FilterFindOneThermostatScheduleTemplateInput = {
  AND?: InputMaybe<Array<FilterFindOneThermostatScheduleTemplateInput>>;
  OR?: InputMaybe<Array<FilterFindOneThermostatScheduleTemplateInput>>;
  _id?: InputMaybe<Scalars['String']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterFindOneThermostatScheduleTemplateOperatorsInput>;
  name?: InputMaybe<Scalars['String']>;
  propertyId?: InputMaybe<Scalars['String']>;
  setpointLimitProfileId?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<FilterFindOneThermostatScheduleTemplateValueInput>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterFindOneThermostatScheduleTemplateOperatorsInput = {
  _id?: InputMaybe<FilterFindOneThermostatScheduleTemplate_IdOperatorsInput>;
  propertyId?: InputMaybe<FilterFindOneThermostatScheduleTemplatePropertyIdOperatorsInput>;
};

export type FilterFindOneThermostatScheduleTemplatePropertyIdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['String']>;
  gte?: InputMaybe<Scalars['String']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  lt?: InputMaybe<Scalars['String']>;
  lte?: InputMaybe<Scalars['String']>;
  ne?: InputMaybe<Scalars['String']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']>;
};

export type FilterFindOneThermostatScheduleTemplateValueInput = {
  id?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  units?: InputMaybe<Scalars['String']>;
  updatePending?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<Scalars['JSON']>;
};

export type FilterFindOneThermostatScheduleTemplate_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['String']>;
  gte?: InputMaybe<Scalars['String']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  lt?: InputMaybe<Scalars['String']>;
  lte?: InputMaybe<Scalars['String']>;
  ne?: InputMaybe<Scalars['String']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']>;
};

export type FilterFindOneThermostatSetpointChangeSourceInput = {
  id?: InputMaybe<Scalars['String']>;
  observedAt?: InputMaybe<Scalars['Float']>;
  previousId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  units?: InputMaybe<Scalars['String']>;
  updatePending?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<EnumThermostatSetpointChangeSourceValue>;
};

export type FilterFindOneThermostatSetpointInput = {
  id?: InputMaybe<Scalars['String']>;
  observedAt?: InputMaybe<Scalars['Float']>;
  previousId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  units?: InputMaybe<Scalars['String']>;
  updatePending?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<Scalars['Float']>;
};

export type FilterFindOneThermostatShowFanButtonInput = {
  id?: InputMaybe<Scalars['String']>;
  observedAt?: InputMaybe<Scalars['Float']>;
  previousId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  units?: InputMaybe<Scalars['String']>;
  updatePending?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<Scalars['Boolean']>;
};

export type FilterFindOneThermostatSystemTypeInput = {
  id?: InputMaybe<Scalars['String']>;
  observedAt?: InputMaybe<Scalars['Float']>;
  previousId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  units?: InputMaybe<Scalars['String']>;
  updatePending?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<EnumThermostatSystemTypeValue>;
};

export type FilterFindOneThermostatTempDisplayModeInput = {
  id?: InputMaybe<Scalars['String']>;
  observedAt?: InputMaybe<Scalars['Float']>;
  previousId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  units?: InputMaybe<Scalars['String']>;
  updatePending?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<EnumThermostatTempDisplayModeValue>;
};

export type FilterFindOneThermostatTemperatureInput = {
  id?: InputMaybe<Scalars['String']>;
  observedAt?: InputMaybe<Scalars['Float']>;
  previousId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  units?: InputMaybe<Scalars['String']>;
  updatePending?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<Scalars['Float']>;
};

export type FilterFindOneThermostatThermostatControlCommandInput = {
  commandId?: InputMaybe<Scalars['String']>;
  confirmation?: InputMaybe<Scalars['JSON']>;
  error?: InputMaybe<Scalars['String']>;
  expiresAt?: InputMaybe<Scalars['Float']>;
  requestedAt?: InputMaybe<Scalars['Float']>;
  requestedValues?: InputMaybe<Scalars['JSON']>;
  status?: InputMaybe<EnumThermostatThermostatControlCommandStatus>;
};

export type FilterFindOneThermostatUiOptionsInput = {
  id?: InputMaybe<Scalars['String']>;
  observedAt?: InputMaybe<Scalars['Float']>;
  previousId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  units?: InputMaybe<Scalars['String']>;
  updatePending?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<Scalars['Float']>;
};

export type FilterFindOneUnitAlertTypesInput = {
  deviceAlert?: InputMaybe<Scalars['Boolean']>;
  deviceMetric?: InputMaybe<Scalars['Boolean']>;
  deviceOffline?: InputMaybe<Scalars['Boolean']>;
  equipmentAlarm?: InputMaybe<Scalars['Boolean']>;
  sourceOffline?: InputMaybe<Scalars['Boolean']>;
};

export type FilterFindOneUnitBuildingIdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['String']>;
  gte?: InputMaybe<Scalars['String']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  lt?: InputMaybe<Scalars['String']>;
  lte?: InputMaybe<Scalars['String']>;
  ne?: InputMaybe<Scalars['String']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']>;
};

export type FilterFindOneUnitDevicesSummaryInput = {
  count?: InputMaybe<Scalars['Float']>;
  majorAlerts?: InputMaybe<Scalars['Float']>;
  minorAlerts?: InputMaybe<Scalars['Float']>;
  proxy?: InputMaybe<FilterFindOneUnitDevicesSummaryProxyInput>;
};

export type FilterFindOneUnitDevicesSummaryProxyInput = {
  coolSetpoint?: InputMaybe<Scalars['Float']>;
  heatSetpoint?: InputMaybe<Scalars['Float']>;
  humidity?: InputMaybe<Scalars['Float']>;
  isOffline?: InputMaybe<Scalars['Boolean']>;
  operatingMode?: InputMaybe<Scalars['String']>;
  operatingState?: InputMaybe<Scalars['String']>;
  setpointCoolMin?: InputMaybe<Scalars['Float']>;
  setpointHeatMax?: InputMaybe<Scalars['Float']>;
  setpointProfileName?: InputMaybe<Scalars['String']>;
  setpointProfileType?: InputMaybe<Scalars['String']>;
  temperature?: InputMaybe<Scalars['Float']>;
  type?: InputMaybe<Scalars['String']>;
};

export type FilterFindOneUnitInput = {
  AND?: InputMaybe<Array<FilterFindOneUnitInput>>;
  OR?: InputMaybe<Array<FilterFindOneUnitInput>>;
  _id?: InputMaybe<Scalars['String']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterFindOneUnitOperatorsInput>;
  alertTypes?: InputMaybe<FilterFindOneUnitAlertTypesInput>;
  buildingId?: InputMaybe<Scalars['String']>;
  cuid?: InputMaybe<Scalars['String']>;
  devicesSummary?: InputMaybe<FilterFindOneUnitDevicesSummaryInput>;
  floorId?: InputMaybe<Scalars['String']>;
  hasPanels?: InputMaybe<Scalars['Boolean']>;
  name?: InputMaybe<Scalars['String']>;
  propertyId?: InputMaybe<Scalars['String']>;
  resident?: InputMaybe<FilterFindOneUnitResidentInput>;
  setpointProfileId?: InputMaybe<Scalars['String']>;
  sourceId?: InputMaybe<Scalars['String']>;
  tempDisplayUnits?: InputMaybe<Scalars['String']>;
  thermostatScheduleTemplateId?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<Scalars['String']>;
  zonePolicyId?: InputMaybe<Scalars['String']>;
};

export type FilterFindOneUnitNameOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['String']>;
  gte?: InputMaybe<Scalars['String']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  lt?: InputMaybe<Scalars['String']>;
  lte?: InputMaybe<Scalars['String']>;
  ne?: InputMaybe<Scalars['String']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterFindOneUnitOperatorsInput = {
  _id?: InputMaybe<FilterFindOneUnit_IdOperatorsInput>;
  buildingId?: InputMaybe<FilterFindOneUnitBuildingIdOperatorsInput>;
  name?: InputMaybe<FilterFindOneUnitNameOperatorsInput>;
  propertyId?: InputMaybe<FilterFindOneUnitPropertyIdOperatorsInput>;
};

export type FilterFindOneUnitPropertyIdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['String']>;
  gte?: InputMaybe<Scalars['String']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  lt?: InputMaybe<Scalars['String']>;
  lte?: InputMaybe<Scalars['String']>;
  ne?: InputMaybe<Scalars['String']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']>;
};

export type FilterFindOneUnitResidentInput = {
  email?: InputMaybe<Scalars['String']>;
  mobile?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  phone?: InputMaybe<Scalars['String']>;
};

export type FilterFindOneUnit_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['String']>;
  gte?: InputMaybe<Scalars['String']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  lt?: InputMaybe<Scalars['String']>;
  lte?: InputMaybe<Scalars['String']>;
  ne?: InputMaybe<Scalars['String']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']>;
};

export type FilterFindOneUserEmailsInput = {
  address?: InputMaybe<Scalars['String']>;
  externalId?: InputMaybe<Scalars['String']>;
  verified?: InputMaybe<Scalars['Boolean']>;
};

export type FilterFindOneUserHistoryInput = {
  AND?: InputMaybe<Array<FilterFindOneUserHistoryInput>>;
  OR?: InputMaybe<Array<FilterFindOneUserHistoryInput>>;
  _id?: InputMaybe<Scalars['String']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterFindOneUserHistoryOperatorsInput>;
  currentIndex?: InputMaybe<Scalars['Float']>;
  deviceId?: InputMaybe<Scalars['String']>;
  history?: InputMaybe<Scalars['JSON']>;
  lastAccessedAt?: InputMaybe<Scalars['Float']>;
  userId?: InputMaybe<Scalars['String']>;
};

export type FilterFindOneUserHistoryLastAccessedAtOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['Float']>;
  gte?: InputMaybe<Scalars['Float']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Float']>>>;
  lt?: InputMaybe<Scalars['Float']>;
  lte?: InputMaybe<Scalars['Float']>;
  ne?: InputMaybe<Scalars['Float']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Float']>>>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterFindOneUserHistoryOperatorsInput = {
  _id?: InputMaybe<FilterFindOneUserHistory_IdOperatorsInput>;
  lastAccessedAt?: InputMaybe<FilterFindOneUserHistoryLastAccessedAtOperatorsInput>;
  userId?: InputMaybe<FilterFindOneUserHistoryUserIdOperatorsInput>;
};

export type FilterFindOneUserHistoryUserIdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['String']>;
  gte?: InputMaybe<Scalars['String']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  lt?: InputMaybe<Scalars['String']>;
  lte?: InputMaybe<Scalars['String']>;
  ne?: InputMaybe<Scalars['String']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']>;
};

export type FilterFindOneUserHistory_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['String']>;
  gte?: InputMaybe<Scalars['String']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  lt?: InputMaybe<Scalars['String']>;
  lte?: InputMaybe<Scalars['String']>;
  ne?: InputMaybe<Scalars['String']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']>;
};

export type FilterFindOneUserInput = {
  AND?: InputMaybe<Array<FilterFindOneUserInput>>;
  OR?: InputMaybe<Array<FilterFindOneUserInput>>;
  _id?: InputMaybe<Scalars['String']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterFindOneUserOperatorsInput>;
  createdAt?: InputMaybe<Scalars['Date']>;
  emails?: InputMaybe<Array<InputMaybe<FilterFindOneUserEmailsInput>>>;
  externalId?: InputMaybe<Scalars['String']>;
  heartbeat?: InputMaybe<Scalars['Date']>;
  mobileSession?: InputMaybe<FilterFindOneUserMobileSessionInput>;
  profile?: InputMaybe<FilterFindOneUserProfileInput>;
  services?: InputMaybe<FilterFindOneUserServicesInput>;
  session?: InputMaybe<FilterFindOneUserSessionInput>;
  state?: InputMaybe<Scalars['String']>;
  username?: InputMaybe<Scalars['String']>;
};

export type FilterFindOneUserMobileSessionInput = {
  appName?: InputMaybe<Scalars['String']>;
  packageName?: InputMaybe<Scalars['String']>;
  version?: InputMaybe<Scalars['String']>;
  versionCode?: InputMaybe<Scalars['String']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterFindOneUserOperatorsInput = {
  _id?: InputMaybe<FilterFindOneUser_IdOperatorsInput>;
};

export type FilterFindOneUserProfileInput = {
  emailOptInStatus?: InputMaybe<Scalars['String']>;
  emailOptInStatusTimestamp?: InputMaybe<Scalars['Float']>;
  historyMap?: InputMaybe<Scalars['JSON']>;
  mobile?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  preferredAirFlowUnits?: InputMaybe<EnumUserProfilePreferredAirFlowUnits>;
  preferredUnits?: InputMaybe<EnumUserProfilePreferredUnits>;
  smsOptInStatus?: InputMaybe<Scalars['String']>;
  smsOptInStatusTimestamp?: InputMaybe<Scalars['Float']>;
};

export type FilterFindOneUserServicesInput = {
  password?: InputMaybe<FilterFindOneUserServicesPasswordInput>;
  resume?: InputMaybe<FilterFindOneUserServicesResumeInput>;
};

export type FilterFindOneUserServicesPasswordInput = {
  bcrypt?: InputMaybe<Scalars['String']>;
  enroll?: InputMaybe<Scalars['String']>;
  externalId?: InputMaybe<Scalars['String']>;
  reset?: InputMaybe<Scalars['String']>;
};

export type FilterFindOneUserServicesResumeInput = {
  loginTokens?: InputMaybe<
    Array<InputMaybe<FilterFindOneUserServicesResumeLoginTokensInput>>
  >;
};

export type FilterFindOneUserServicesResumeLoginTokensInput = {
  hashedToken?: InputMaybe<Scalars['String']>;
  when?: InputMaybe<Scalars['Date']>;
};

export type FilterFindOneUserSessionInput = {
  isMobile?: InputMaybe<Scalars['Boolean']>;
};

export type FilterFindOneUser_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['String']>;
  gte?: InputMaybe<Scalars['String']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  lt?: InputMaybe<Scalars['String']>;
  lte?: InputMaybe<Scalars['String']>;
  ne?: InputMaybe<Scalars['String']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']>;
};

export type FilterFindOneVsdPumpCurrentSpeedInput = {
  id?: InputMaybe<Scalars['String']>;
  observedAt?: InputMaybe<Scalars['Float']>;
  previousId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  units?: InputMaybe<Scalars['String']>;
  updatePending?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<Scalars['Float']>;
};

export type FilterFindOneVsdPumpDriveModeInput = {
  id?: InputMaybe<Scalars['String']>;
  observedAt?: InputMaybe<Scalars['Float']>;
  previousId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  units?: InputMaybe<Scalars['String']>;
  updatePending?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<Scalars['String']>;
};

export type FilterFindOneVsdPumpDriveOutputEnergyInput = {
  id?: InputMaybe<Scalars['String']>;
  observedAt?: InputMaybe<Scalars['Float']>;
  previousId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  units?: InputMaybe<Scalars['String']>;
  updatePending?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<Scalars['Float']>;
};

export type FilterFindOneVsdPumpDriveOutputPowerInput = {
  id?: InputMaybe<Scalars['String']>;
  observedAt?: InputMaybe<Scalars['Float']>;
  previousId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  units?: InputMaybe<Scalars['String']>;
  updatePending?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<Scalars['Float']>;
};

export type FilterFindOneVsdPumpInput = {
  AND?: InputMaybe<Array<FilterFindOneDeviceInput>>;
  OR?: InputMaybe<Array<FilterFindOneDeviceInput>>;
  _id?: InputMaybe<Scalars['String']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterFindOneDeviceOperatorsInput>;
  alertTypes?: InputMaybe<FilterFindOneDeviceAlertTypesInput>;
  controlled?: InputMaybe<FilterFindOneDeviceControlledInput>;
  currentSpeed?: InputMaybe<FilterFindOneVsdPumpCurrentSpeedInput>;
  deviceId?: InputMaybe<Scalars['String']>;
  driveMode?: InputMaybe<FilterFindOneVsdPumpDriveModeInput>;
  driveOutputEnergy?: InputMaybe<FilterFindOneVsdPumpDriveOutputEnergyInput>;
  driveOutputPower?: InputMaybe<FilterFindOneVsdPumpDriveOutputPowerInput>;
  installation?: InputMaybe<FilterFindOneDeviceInstallationInput>;
  location?: InputMaybe<Scalars['String']>;
  meta?: InputMaybe<FilterFindOneDeviceMetaInput>;
  /** The name of the device */
  name?: InputMaybe<Scalars['String']>;
  panelId?: InputMaybe<Scalars['String']>;
  powerState?: InputMaybe<FilterFindOneDevicePowerStateInput>;
  propertyId?: InputMaybe<Scalars['String']>;
  returnTemperature?: InputMaybe<FilterFindOneVsdPumpReturnTemperatureInput>;
  role?: InputMaybe<Scalars['String']>;
  sourceId?: InputMaybe<Scalars['String']>;
  stopOrStart?: InputMaybe<FilterFindOneVsdPumpStopOrStartInput>;
  supplyTemperature?: InputMaybe<FilterFindOneVsdPumpSupplyTemperatureInput>;
  targetSpeed?: InputMaybe<FilterFindOneVsdPumpTargetSpeedInput>;
  timestamp?: InputMaybe<Scalars['Float']>;
  unitId?: InputMaybe<Scalars['String']>;
  updateStatus?: InputMaybe<Scalars['Boolean']>;
  vppId?: InputMaybe<Scalars['String']>;
  zoneId?: InputMaybe<Scalars['String']>;
};

export type FilterFindOneVsdPumpReturnTemperatureInput = {
  id?: InputMaybe<Scalars['String']>;
  observedAt?: InputMaybe<Scalars['Float']>;
  previousId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  units?: InputMaybe<Scalars['String']>;
  updatePending?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<Scalars['Float']>;
};

export type FilterFindOneVsdPumpStopOrStartInput = {
  id?: InputMaybe<Scalars['String']>;
  observedAt?: InputMaybe<Scalars['Float']>;
  previousId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  units?: InputMaybe<Scalars['String']>;
  updatePending?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<Scalars['Float']>;
};

export type FilterFindOneVsdPumpSupplyTemperatureInput = {
  id?: InputMaybe<Scalars['String']>;
  observedAt?: InputMaybe<Scalars['Float']>;
  previousId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  units?: InputMaybe<Scalars['String']>;
  updatePending?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<Scalars['Float']>;
};

export type FilterFindOneVsdPumpTargetSpeedInput = {
  id?: InputMaybe<Scalars['String']>;
  observedAt?: InputMaybe<Scalars['Float']>;
  previousId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  units?: InputMaybe<Scalars['String']>;
  updatePending?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<Scalars['Float']>;
};

export type FilterFindOneVirtualPowerPlantInput = {
  AND?: InputMaybe<Array<FilterFindOneVirtualPowerPlantInput>>;
  OR?: InputMaybe<Array<FilterFindOneVirtualPowerPlantInput>>;
  _id?: InputMaybe<Scalars['String']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterFindOneVirtualPowerPlantOperatorsInput>;
  inverterId?: InputMaybe<Scalars['String']>;
  location?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  operationalStatus?: InputMaybe<FilterFindOneVirtualPowerPlantOperationalStatusInput>;
  propertyId?: InputMaybe<Scalars['String']>;
  sourceId?: InputMaybe<Scalars['String']>;
  switchPanelId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  unitId?: InputMaybe<Scalars['String']>;
  updateStatus?: InputMaybe<Scalars['Boolean']>;
};

export type FilterFindOneVirtualPowerPlantOperationalStatusInput = {
  id?: InputMaybe<Scalars['String']>;
  observedAt?: InputMaybe<Scalars['Float']>;
  previousId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  units?: InputMaybe<Scalars['String']>;
  updatePending?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<EnumVirtualPowerPlantOperationalStatusValue>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterFindOneVirtualPowerPlantOperatorsInput = {
  _id?: InputMaybe<FilterFindOneVirtualPowerPlant_IdOperatorsInput>;
};

export type FilterFindOneVirtualPowerPlant_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['String']>;
  gte?: InputMaybe<Scalars['String']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  lt?: InputMaybe<Scalars['String']>;
  lte?: InputMaybe<Scalars['String']>;
  ne?: InputMaybe<Scalars['String']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']>;
};

export type FilterFindOneWindManagementSystemBladeConditionInput = {
  id?: InputMaybe<Scalars['String']>;
  observedAt?: InputMaybe<Scalars['Float']>;
  previousId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  units?: InputMaybe<Scalars['String']>;
  updatePending?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<EnumWindManagementSystemBladeConditionValue>;
};

export type FilterFindOneWindManagementSystemBrakeStatusInput = {
  id?: InputMaybe<Scalars['String']>;
  observedAt?: InputMaybe<Scalars['Float']>;
  previousId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  units?: InputMaybe<Scalars['String']>;
  updatePending?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<EnumWindManagementSystemBrakeStatusValue>;
};

export type FilterFindOneWindManagementSystemGeneratorTemperatureInput = {
  id?: InputMaybe<Scalars['String']>;
  observedAt?: InputMaybe<Scalars['Float']>;
  previousId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  units?: InputMaybe<Scalars['String']>;
  updatePending?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<Scalars['Float']>;
};

export type FilterFindOneWindManagementSystemIceDetectionStatusInput = {
  id?: InputMaybe<Scalars['String']>;
  observedAt?: InputMaybe<Scalars['Float']>;
  previousId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  units?: InputMaybe<Scalars['String']>;
  updatePending?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<EnumWindManagementSystemIceDetectionStatusValue>;
};

export type FilterFindOneWindManagementSystemInput = {
  AND?: InputMaybe<Array<FilterFindOneDeviceInput>>;
  OR?: InputMaybe<Array<FilterFindOneDeviceInput>>;
  _id?: InputMaybe<Scalars['String']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterFindOneDeviceOperatorsInput>;
  alertTypes?: InputMaybe<FilterFindOneDeviceAlertTypesInput>;
  bladeCondition?: InputMaybe<FilterFindOneWindManagementSystemBladeConditionInput>;
  brakeStatus?: InputMaybe<FilterFindOneWindManagementSystemBrakeStatusInput>;
  controlled?: InputMaybe<FilterFindOneDeviceControlledInput>;
  deviceId?: InputMaybe<Scalars['String']>;
  generatorTemperature?: InputMaybe<FilterFindOneWindManagementSystemGeneratorTemperatureInput>;
  iceDetectionStatus?: InputMaybe<FilterFindOneWindManagementSystemIceDetectionStatusInput>;
  installation?: InputMaybe<FilterFindOneDeviceInstallationInput>;
  location?: InputMaybe<Scalars['String']>;
  meta?: InputMaybe<FilterFindOneDeviceMetaInput>;
  /** The name of the device */
  name?: InputMaybe<Scalars['String']>;
  panelId?: InputMaybe<Scalars['String']>;
  pitchAngle?: InputMaybe<FilterFindOneWindManagementSystemPitchAngleInput>;
  powerState?: InputMaybe<FilterFindOneDevicePowerStateInput>;
  propertyId?: InputMaybe<Scalars['String']>;
  rotorSpeed?: InputMaybe<FilterFindOneWindManagementSystemRotorSpeedInput>;
  sourceId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  unitId?: InputMaybe<Scalars['String']>;
  updateStatus?: InputMaybe<Scalars['Boolean']>;
  vibrationLevel?: InputMaybe<FilterFindOneWindManagementSystemVibrationLevelInput>;
  vppId?: InputMaybe<Scalars['String']>;
  windDirection?: InputMaybe<FilterFindOneWindManagementSystemWindDirectionInput>;
  windSpeed?: InputMaybe<FilterFindOneWindManagementSystemWindSpeedInput>;
  yawControlStatus?: InputMaybe<FilterFindOneWindManagementSystemYawControlStatusInput>;
  zoneId?: InputMaybe<Scalars['String']>;
};

export type FilterFindOneWindManagementSystemPitchAngleInput = {
  id?: InputMaybe<Scalars['String']>;
  observedAt?: InputMaybe<Scalars['Float']>;
  previousId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  units?: InputMaybe<Scalars['String']>;
  updatePending?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<Scalars['Float']>;
};

export type FilterFindOneWindManagementSystemRotorSpeedInput = {
  id?: InputMaybe<Scalars['String']>;
  observedAt?: InputMaybe<Scalars['Float']>;
  previousId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  units?: InputMaybe<Scalars['String']>;
  updatePending?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<Scalars['Float']>;
};

export type FilterFindOneWindManagementSystemVibrationLevelInput = {
  id?: InputMaybe<Scalars['String']>;
  observedAt?: InputMaybe<Scalars['Float']>;
  previousId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  units?: InputMaybe<Scalars['String']>;
  updatePending?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<Scalars['Float']>;
};

export type FilterFindOneWindManagementSystemWindDirectionInput = {
  id?: InputMaybe<Scalars['String']>;
  observedAt?: InputMaybe<Scalars['Float']>;
  previousId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  units?: InputMaybe<Scalars['String']>;
  updatePending?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<Scalars['Float']>;
};

export type FilterFindOneWindManagementSystemWindSpeedInput = {
  id?: InputMaybe<Scalars['String']>;
  observedAt?: InputMaybe<Scalars['Float']>;
  previousId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  units?: InputMaybe<Scalars['String']>;
  updatePending?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<Scalars['Float']>;
};

export type FilterFindOneWindManagementSystemYawControlStatusInput = {
  id?: InputMaybe<Scalars['String']>;
  observedAt?: InputMaybe<Scalars['Float']>;
  previousId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  units?: InputMaybe<Scalars['String']>;
  updatePending?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<EnumWindManagementSystemYawControlStatusValue>;
};

export type FilterFindOneWindowSensorContactStateInput = {
  id?: InputMaybe<Scalars['String']>;
  observedAt?: InputMaybe<Scalars['Float']>;
  previousId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  units?: InputMaybe<Scalars['String']>;
  updatePending?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<Scalars['String']>;
};

export type FilterFindOneWindowSensorInput = {
  AND?: InputMaybe<Array<FilterFindOneDeviceInput>>;
  OR?: InputMaybe<Array<FilterFindOneDeviceInput>>;
  _id?: InputMaybe<Scalars['String']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterFindOneDeviceOperatorsInput>;
  alertTypes?: InputMaybe<FilterFindOneDeviceAlertTypesInput>;
  contactState?: InputMaybe<FilterFindOneWindowSensorContactStateInput>;
  controlled?: InputMaybe<FilterFindOneDeviceControlledInput>;
  deviceId?: InputMaybe<Scalars['String']>;
  installation?: InputMaybe<FilterFindOneDeviceInstallationInput>;
  location?: InputMaybe<Scalars['String']>;
  meta?: InputMaybe<FilterFindOneDeviceMetaInput>;
  /** The name of the device */
  name?: InputMaybe<Scalars['String']>;
  panelId?: InputMaybe<Scalars['String']>;
  powerState?: InputMaybe<FilterFindOneDevicePowerStateInput>;
  propertyId?: InputMaybe<Scalars['String']>;
  sourceId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  unitId?: InputMaybe<Scalars['String']>;
  updateStatus?: InputMaybe<Scalars['Boolean']>;
  voltage?: InputMaybe<FilterFindOneWindowSensorVoltageInput>;
  vppId?: InputMaybe<Scalars['String']>;
  zoneId?: InputMaybe<Scalars['String']>;
};

export type FilterFindOneWindowSensorVoltageInput = {
  id?: InputMaybe<Scalars['String']>;
  observedAt?: InputMaybe<Scalars['Float']>;
  previousId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  units?: InputMaybe<Scalars['String']>;
  updatePending?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<Scalars['Float']>;
};

export type FilterFindOneZ210PumpActivePumpInput = {
  id?: InputMaybe<Scalars['String']>;
  previousId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  units?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<Scalars['Float']>;
};

export type FilterFindOneZ210PumpCurrentSpeedInput = {
  id?: InputMaybe<Scalars['String']>;
  observedAt?: InputMaybe<Scalars['Float']>;
  previousId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  units?: InputMaybe<Scalars['String']>;
  updatePending?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<Scalars['Float']>;
};

export type FilterFindOneZ210PumpInput = {
  AND?: InputMaybe<Array<FilterFindOneDeviceInput>>;
  OR?: InputMaybe<Array<FilterFindOneDeviceInput>>;
  _id?: InputMaybe<Scalars['String']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterFindOneDeviceOperatorsInput>;
  activePump?: InputMaybe<FilterFindOneZ210PumpActivePumpInput>;
  alertTypes?: InputMaybe<FilterFindOneDeviceAlertTypesInput>;
  controlled?: InputMaybe<FilterFindOneDeviceControlledInput>;
  currentSpeed?: InputMaybe<FilterFindOneZ210PumpCurrentSpeedInput>;
  deviceId?: InputMaybe<Scalars['String']>;
  installation?: InputMaybe<FilterFindOneDeviceInstallationInput>;
  location?: InputMaybe<Scalars['String']>;
  meta?: InputMaybe<FilterFindOneDeviceMetaInput>;
  /** The name of the device */
  name?: InputMaybe<Scalars['String']>;
  panelId?: InputMaybe<Scalars['String']>;
  powerState?: InputMaybe<FilterFindOneDevicePowerStateInput>;
  propertyId?: InputMaybe<Scalars['String']>;
  role?: InputMaybe<Scalars['String']>;
  sourceId?: InputMaybe<Scalars['String']>;
  targetSpeed?: InputMaybe<FilterFindOneZ210PumpTargetSpeedInput>;
  timestamp?: InputMaybe<Scalars['Float']>;
  unitId?: InputMaybe<Scalars['String']>;
  updateStatus?: InputMaybe<Scalars['Boolean']>;
  vppId?: InputMaybe<Scalars['String']>;
  zoneId?: InputMaybe<Scalars['String']>;
};

export type FilterFindOneZ210PumpTargetSpeedInput = {
  id?: InputMaybe<Scalars['String']>;
  observedAt?: InputMaybe<Scalars['Float']>;
  previousId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  units?: InputMaybe<Scalars['String']>;
  updatePending?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<Scalars['Float']>;
};

export type FilterFindOneZoneInput = {
  AND?: InputMaybe<Array<FilterFindOneZoneInput>>;
  OR?: InputMaybe<Array<FilterFindOneZoneInput>>;
  _id?: InputMaybe<Scalars['String']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterFindOneZoneOperatorsInput>;
  airHandlerId?: InputMaybe<Scalars['String']>;
  bngSourceId?: InputMaybe<Scalars['String']>;
  controller?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  pairedSensorId?: InputMaybe<Scalars['String']>;
  propertyId?: InputMaybe<Scalars['String']>;
  role?: InputMaybe<Scalars['String']>;
  sourceId?: InputMaybe<Scalars['String']>;
  thermostatId?: InputMaybe<Scalars['String']>;
  unitId?: InputMaybe<Scalars['String']>;
  zonePolicyId?: InputMaybe<Scalars['String']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterFindOneZoneOperatorsInput = {
  _id?: InputMaybe<FilterFindOneZone_IdOperatorsInput>;
  propertyId?: InputMaybe<FilterFindOneZonePropertyIdOperatorsInput>;
  unitId?: InputMaybe<FilterFindOneZoneUnitIdOperatorsInput>;
};

export type FilterFindOneZonePolicyInput = {
  AND?: InputMaybe<Array<FilterFindOneZonePolicyInput>>;
  OR?: InputMaybe<Array<FilterFindOneZonePolicyInput>>;
  _id?: InputMaybe<Scalars['MongoID']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterFindOneZonePolicyOperatorsInput>;
  name?: InputMaybe<Scalars['String']>;
  properties?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  rules?: InputMaybe<Array<InputMaybe<FilterFindOneZonePolicyRulesInput>>>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterFindOneZonePolicyOperatorsInput = {
  _id?: InputMaybe<FilterFindOneZonePolicy_IdOperatorsInput>;
};

export type FilterFindOneZonePolicyRulesInput = {
  source?: InputMaybe<FilterFindOneZonePolicyRulesSourceInput>;
  target?: InputMaybe<FilterFindOneZonePolicyRulesTargetInput>;
  type?: InputMaybe<EnumZonePolicyRulesType>;
};

export type FilterFindOneZonePolicyRulesSourceAttributesInput = {
  contactState?: InputMaybe<Scalars['String']>;
  coolSetpoint?: InputMaybe<Scalars['String']>;
  fanSpeed?: InputMaybe<Scalars['String']>;
  heatSetpoint?: InputMaybe<Scalars['String']>;
  indoorFanStatus?: InputMaybe<Scalars['String']>;
  keypadLockoutLevel?: InputMaybe<Scalars['String']>;
  operatingMode?: InputMaybe<Scalars['String']>;
  operatingState?: InputMaybe<Scalars['String']>;
};

export type FilterFindOneZonePolicyRulesSourceInput = {
  attributes?: InputMaybe<FilterFindOneZonePolicyRulesSourceAttributesInput>;
  deviceType?: InputMaybe<Scalars['String']>;
  multiplicity?: InputMaybe<EnumZonePolicyRulesSourceMultiplicity>;
};

export type FilterFindOneZonePolicyRulesTargetAttributesInput = {
  coolSetpoint?: InputMaybe<Scalars['String']>;
  heatSetpoint?: InputMaybe<Scalars['String']>;
  isOn?: InputMaybe<Scalars['String']>;
  keypadLockoutLevel?: InputMaybe<Scalars['String']>;
  relayState?: InputMaybe<Scalars['String']>;
};

export type FilterFindOneZonePolicyRulesTargetInput = {
  attributes?: InputMaybe<FilterFindOneZonePolicyRulesTargetAttributesInput>;
  deviceType?: InputMaybe<Scalars['String']>;
  multiplicity?: InputMaybe<EnumZonePolicyRulesTargetMultiplicity>;
};

export type FilterFindOneZonePolicy_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['MongoID']>;
  gte?: InputMaybe<Scalars['MongoID']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']>>>;
  lt?: InputMaybe<Scalars['MongoID']>;
  lte?: InputMaybe<Scalars['MongoID']>;
  ne?: InputMaybe<Scalars['MongoID']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']>>>;
};

export type FilterFindOneZonePropertyIdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['String']>;
  gte?: InputMaybe<Scalars['String']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  lt?: InputMaybe<Scalars['String']>;
  lte?: InputMaybe<Scalars['String']>;
  ne?: InputMaybe<Scalars['String']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']>;
};

export type FilterFindOneZoneUnitIdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['String']>;
  gte?: InputMaybe<Scalars['String']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  lt?: InputMaybe<Scalars['String']>;
  lte?: InputMaybe<Scalars['String']>;
  ne?: InputMaybe<Scalars['String']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']>;
};

export type FilterFindOneZone_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['String']>;
  gte?: InputMaybe<Scalars['String']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  lt?: InputMaybe<Scalars['String']>;
  lte?: InputMaybe<Scalars['String']>;
  ne?: InputMaybe<Scalars['String']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']>;
};

export type FireSuppressionSystem = DeviceInterface & {
  __typename: 'FireSuppressionSystem';
  _id: Scalars['String'];
  alertTypes?: Maybe<DeviceAlertTypes>;
  chartTypes: Array<ChartType>;
  controlled?: Maybe<DeviceControlled>;
  dependentDeviceIds: Array<Maybe<Scalars['String']>>;
  deviceAlerts: Array<Maybe<Alert>>;
  deviceId?: Maybe<Scalars['String']>;
  deviceIdentifier?: Maybe<Scalars['String']>;
  deviceMetrics?: Maybe<Array<Maybe<DeviceMetric>>>;
  displayName?: Maybe<Scalars['String']>;
  fireSuppressionStatus?: Maybe<FireSuppressionSystemFireSuppressionStatus>;
  hasPendingUpdates: Scalars['Boolean'];
  installation?: Maybe<DeviceInstallation>;
  isConfigured?: Maybe<Scalars['Boolean']>;
  isControlled: Scalars['Boolean'];
  isPoweredOn?: Maybe<Scalars['Boolean']>;
  location?: Maybe<Scalars['String']>;
  meta?: Maybe<DeviceMeta>;
  modelChangeOperation?: Maybe<Scalars['String']>;
  modelType?: Maybe<Scalars['String']>;
  /** The name of the device */
  name?: Maybe<Scalars['String']>;
  panel?: Maybe<Panel>;
  panelId?: Maybe<Scalars['String']>;
  powerState?: Maybe<DevicePowerState>;
  property?: Maybe<Property>;
  propertyId: Scalars['String'];
  sensorStatus?: Maybe<FireSuppressionSystemSensorStatus>;
  source?: Maybe<Source>;
  sourceAlerts: Array<Maybe<Alert>>;
  sourceId?: Maybe<Scalars['String']>;
  suppressantLevel?: Maybe<FireSuppressionSystemSuppressantLevel>;
  timestamp?: Maybe<Scalars['Float']>;
  type?: Maybe<EnumDKeyDeviceType>;
  typeDisplayName: Scalars['String'];
  unit?: Maybe<Unit>;
  unitId: Scalars['String'];
  updateDescription?: Maybe<Scalars['JSON']>;
  updateStatus?: Maybe<Scalars['Boolean']>;
  vpp?: Maybe<VirtualPowerPlant>;
  vppId?: Maybe<Scalars['String']>;
  zone?: Maybe<Zone>;
  zoneId?: Maybe<Scalars['String']>;
};

export type FireSuppressionSystemDeviceAlertsArgs = {
  filter?: InputMaybe<FilterFindManyAlertInput>;
  limit?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<SortFindManyAlertInput>;
};

export type FireSuppressionSystemSourceAlertsArgs = {
  filter?: InputMaybe<FilterFindManyAlertInput>;
  limit?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<SortFindManyAlertInput>;
};

export type FireSuppressionSystemFireSuppressionStatus = {
  __typename?: 'FireSuppressionSystemFireSuppressionStatus';
  id?: Maybe<Scalars['String']>;
  observedAt?: Maybe<Scalars['Float']>;
  previousId?: Maybe<Scalars['String']>;
  timestamp?: Maybe<Scalars['Float']>;
  units?: Maybe<Scalars['String']>;
  updatePending?: Maybe<Scalars['Boolean']>;
  value?: Maybe<EnumFireSuppressionSystemFireSuppressionStatusValue>;
};

export type FireSuppressionSystemSensorStatus = {
  __typename?: 'FireSuppressionSystemSensorStatus';
  id?: Maybe<Scalars['String']>;
  observedAt?: Maybe<Scalars['Float']>;
  previousId?: Maybe<Scalars['String']>;
  timestamp?: Maybe<Scalars['Float']>;
  units?: Maybe<Scalars['String']>;
  updatePending?: Maybe<Scalars['Boolean']>;
  value?: Maybe<EnumFireSuppressionSystemSensorStatusValue>;
};

export type FireSuppressionSystemSuppressantLevel = {
  __typename?: 'FireSuppressionSystemSuppressantLevel';
  id?: Maybe<Scalars['String']>;
  observedAt?: Maybe<Scalars['Float']>;
  previousId?: Maybe<Scalars['String']>;
  timestamp?: Maybe<Scalars['Float']>;
  units?: Maybe<Scalars['String']>;
  updatePending?: Maybe<Scalars['Boolean']>;
  value?: Maybe<Scalars['Float']>;
};

export type Floor = {
  __typename: 'Floor';
  _id: Scalars['String'];
  building?: Maybe<Building>;
  buildingId: Scalars['String'];
  modelChangeOperation?: Maybe<Scalars['String']>;
  modelType?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  number?: Maybe<Scalars['Float']>;
  property?: Maybe<Property>;
  propertyId: Scalars['String'];
  units: Array<Maybe<Unit>>;
  updateDescription?: Maybe<Scalars['JSON']>;
};

export type FloorUnitsArgs = {
  filter?: InputMaybe<FilterFindManyUnitInput>;
  limit?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<SortFindManyUnitInput>;
};

/** List of items with pagination. */
export type FloorPaginatedFloors = {
  __typename?: 'FloorPaginatedFloors';
  /** Total object count. */
  count?: Maybe<Scalars['Int']>;
  /** Array of objects. */
  items?: Maybe<Array<Floor>>;
  /** Information to aid in pagination. */
  pageInfo: PaginationInfo;
};

/** Result of forcing resolution of a specific alert. */
export type ForceResolveAlertResult = {
  __typename?: 'ForceResolveAlertResult';
  /** Success message or error description. */
  message: Scalars['String'];
  /** Whether the resolve operation succeeded. */
  success: Scalars['Boolean'];
};

export type Gpio = DeviceInterface & {
  __typename: 'GPIO';
  _id: Scalars['String'];
  alertTypes?: Maybe<DeviceAlertTypes>;
  chartTypes: Array<ChartType>;
  controlled?: Maybe<DeviceControlled>;
  dependentDeviceIds: Array<Maybe<Scalars['String']>>;
  deviceAlerts: Array<Maybe<Alert>>;
  deviceId?: Maybe<Scalars['String']>;
  deviceIdentifier?: Maybe<Scalars['String']>;
  deviceMetrics?: Maybe<Array<Maybe<DeviceMetric>>>;
  displayName?: Maybe<Scalars['String']>;
  hasPendingUpdates: Scalars['Boolean'];
  installation?: Maybe<DeviceInstallation>;
  isConfigured?: Maybe<Scalars['Boolean']>;
  isControlled: Scalars['Boolean'];
  isPoweredOn?: Maybe<Scalars['Boolean']>;
  location?: Maybe<Scalars['String']>;
  meta?: Maybe<DeviceMeta>;
  modelChangeOperation?: Maybe<Scalars['String']>;
  modelType?: Maybe<Scalars['String']>;
  /** The name of the device */
  name?: Maybe<Scalars['String']>;
  panel?: Maybe<Panel>;
  panelId?: Maybe<Scalars['String']>;
  powerState?: Maybe<DevicePowerState>;
  property?: Maybe<Property>;
  propertyId: Scalars['String'];
  source?: Maybe<Source>;
  sourceAlerts: Array<Maybe<Alert>>;
  sourceId?: Maybe<Scalars['String']>;
  state?: Maybe<GpioState>;
  timestamp?: Maybe<Scalars['Float']>;
  type?: Maybe<EnumDKeyDeviceType>;
  typeDisplayName: Scalars['String'];
  unit?: Maybe<Unit>;
  unitId: Scalars['String'];
  updateDescription?: Maybe<Scalars['JSON']>;
  updateStatus?: Maybe<Scalars['Boolean']>;
  vpp?: Maybe<VirtualPowerPlant>;
  vppId?: Maybe<Scalars['String']>;
  zone?: Maybe<Zone>;
  zoneId?: Maybe<Scalars['String']>;
};

export type GpioDeviceAlertsArgs = {
  filter?: InputMaybe<FilterFindManyAlertInput>;
  limit?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<SortFindManyAlertInput>;
};

export type GpioSourceAlertsArgs = {
  filter?: InputMaybe<FilterFindManyAlertInput>;
  limit?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<SortFindManyAlertInput>;
};

export type GpioState = {
  __typename?: 'GPIOState';
  id?: Maybe<Scalars['String']>;
  observedAt?: Maybe<Scalars['Float']>;
  previousId?: Maybe<Scalars['String']>;
  timestamp?: Maybe<Scalars['Float']>;
  units?: Maybe<Scalars['String']>;
  updatePending?: Maybe<Scalars['Boolean']>;
  value?: Maybe<Scalars['Boolean']>;
};

export type Hmm = SourceInterface & {
  __typename: 'HMM';
  _id: Scalars['String'];
  alerts: Array<Maybe<Alert>>;
  hmmUniqueId?: Maybe<Scalars['String']>;
  /** Returns the authorization profile associated with the user. */
  inUse: Scalars['Boolean'];
  maxReportingTime?: Maybe<Scalars['Float']>;
  modelChangeOperation?: Maybe<Scalars['String']>;
  modelType?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  panels: Array<Maybe<Panel>>;
  property?: Maybe<Property>;
  propertyId?: Maybe<Scalars['String']>;
  timestamp?: Maybe<Scalars['Float']>;
  tolerances?: Maybe<HmmTolerances>;
  type?: Maybe<EnumDKeySourceType>;
  units: Array<Maybe<Unit>>;
  updateDescription?: Maybe<Scalars['JSON']>;
  url?: Maybe<Scalars['String']>;
  zones: Array<Maybe<Zone>>;
};

export type HmmAlertsArgs = {
  filter?: InputMaybe<FilterFindManyAlertInput>;
  limit?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<SortFindManyAlertInput>;
};

export type HmmPanelsArgs = {
  filter?: InputMaybe<FilterFindManyPanelInput>;
  limit?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<SortFindManyPanelInput>;
};

export type HmmUnitsArgs = {
  filter?: InputMaybe<FilterFindManyUnitInput>;
  limit?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<SortFindManyUnitInput>;
};

export type HmmZonesArgs = {
  filter?: InputMaybe<FilterFindManyZoneInput>;
  limit?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<SortFindManyZoneInput>;
};

export type HmmTolerances = {
  __typename?: 'HMMTolerances';
  temperature?: Maybe<Scalars['Float']>;
};

export type HistoricAlert = {
  __typename: 'HistoricAlert';
  _id: Scalars['String'];
  alertCategory?: Maybe<HistoricAlertAlertCategory>;
  alertTrigger?: Maybe<HistoricAlertAlertTrigger>;
  building?: Maybe<HistoricAlertBuilding>;
  device: HistoricAlertDevice;
  id: Scalars['String'];
  initiated?: Maybe<Scalars['Float']>;
  meta: HistoricAlertMeta;
  modelChangeOperation?: Maybe<Scalars['String']>;
  modelType?: Maybe<Scalars['String']>;
  panel?: Maybe<HistoricAlertPanel>;
  port?: Maybe<EnumHistoricAlertPort>;
  property?: Maybe<HistoricAlertProperty>;
  resolved?: Maybe<Scalars['Float']>;
  sourceId: Scalars['String'];
  type?: Maybe<HistoricAlertType>;
  unit?: Maybe<HistoricAlertUnit>;
  updateDescription?: Maybe<Scalars['JSON']>;
  updated?: Maybe<Scalars['Float']>;
  zone?: Maybe<HistoricAlertZone>;
};

export type HistoricAlertAlertCategory = {
  __typename?: 'HistoricAlertAlertCategory';
  id?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
};

export type HistoricAlertAlertTrigger = {
  __typename?: 'HistoricAlertAlertTrigger';
  id?: Maybe<Scalars['String']>;
  key?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
};

export type HistoricAlertBuilding = {
  __typename?: 'HistoricAlertBuilding';
  id: Scalars['String'];
  name: Scalars['String'];
};

export type HistoricAlertDevice = {
  __typename?: 'HistoricAlertDevice';
  id: Scalars['String'];
  model?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  role?: Maybe<Scalars['String']>;
  type: Scalars['String'];
  version?: Maybe<Scalars['String']>;
};

export type HistoricAlertMeta = {
  __typename?: 'HistoricAlertMeta';
  id_str?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Float']>;
  message?: Maybe<Scalars['String']>;
  portName?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['String']>;
};

/** List of items with pagination. */
export type HistoricAlertPaginatedHistoricAlerts = {
  __typename?: 'HistoricAlertPaginatedHistoricAlerts';
  /** Total object count. */
  count?: Maybe<Scalars['Int']>;
  /** Array of objects. */
  items?: Maybe<Array<HistoricAlert>>;
  /** Information to aid in pagination. */
  pageInfo: PaginationInfo;
};

export type HistoricAlertPanel = {
  __typename?: 'HistoricAlertPanel';
  id: Scalars['String'];
  name: Scalars['String'];
};

export type HistoricAlertProperty = {
  __typename?: 'HistoricAlertProperty';
  contact: HistoricAlertPropertyContact;
  id: Scalars['String'];
  name: Scalars['String'];
};

export type HistoricAlertPropertyContact = {
  __typename?: 'HistoricAlertPropertyContact';
  email?: Maybe<Scalars['String']>;
  email2?: Maybe<Scalars['String']>;
  email3?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  smsNumber?: Maybe<Scalars['String']>;
  smsNumber2?: Maybe<Scalars['String']>;
  smsNumber3?: Maybe<Scalars['String']>;
  smsOptInStatus1?: Maybe<EnumHistoricAlertPropertyContactSmsOptInStatus1>;
  smsOptInStatus2?: Maybe<EnumHistoricAlertPropertyContactSmsOptInStatus2>;
  smsOptInStatus3?: Maybe<EnumHistoricAlertPropertyContactSmsOptInStatus3>;
  smsOptInTimestamp1?: Maybe<Scalars['Float']>;
  smsOptInTimestamp2?: Maybe<Scalars['Float']>;
  smsOptInTimestamp3?: Maybe<Scalars['Float']>;
};

export type HistoricAlertType = {
  __typename?: 'HistoricAlertType';
  id: Scalars['String'];
  name: Scalars['String'];
};

export type HistoricAlertUnit = {
  __typename?: 'HistoricAlertUnit';
  id?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
};

export type HistoricAlertZone = {
  __typename?: 'HistoricAlertZone';
  id: Scalars['String'];
  name: Scalars['String'];
};

export type HistoricReading = {
  __typename: 'HistoricReading';
  _id: Scalars['String'];
  deviceId: Scalars['String'];
  id: Scalars['String'];
  modelChangeOperation?: Maybe<Scalars['String']>;
  modelType?: Maybe<Scalars['String']>;
  sourceId: Scalars['String'];
  timestamp: Scalars['Float'];
  type: Scalars['String'];
  units?: Maybe<Scalars['String']>;
  updateDescription?: Maybe<Scalars['JSON']>;
  value?: Maybe<Scalars['String']>;
};

/** List of items with pagination. */
export type HistoricReadingPaginatedHistoricReadings = {
  __typename?: 'HistoricReadingPaginatedHistoricReadings';
  /** Total object count. */
  count?: Maybe<Scalars['Int']>;
  /** Array of objects. */
  items?: Maybe<Array<HistoricReading>>;
  /** Information to aid in pagination. */
  pageInfo: PaginationInfo;
};

export type IChartSeries = {
  deviceId: Scalars['String'];
  readingType: Scalars['String'];
  units?: Maybe<Scalars['String']>;
};

export type IDatapoint = {
  deviceId: Scalars['String'];
  id: Scalars['String'];
  readingType: Scalars['String'];
  timestamp: Scalars['String'];
};

export type IndoorAirHandler = DeviceInterface & {
  __typename: 'IndoorAirHandler';
  _id: Scalars['String'];
  alertTypes?: Maybe<DeviceAlertTypes>;
  altDeviceId?: Maybe<Scalars['String']>;
  chartTypes: Array<ChartType>;
  controlled?: Maybe<DeviceControlled>;
  coolSetpoint?: Maybe<IndoorAirHandlerCoolSetpoint>;
  dependentDeviceIds: Array<Maybe<Scalars['String']>>;
  deviceAlerts: Array<Maybe<Alert>>;
  deviceId?: Maybe<Scalars['String']>;
  deviceIdentifier?: Maybe<Scalars['String']>;
  deviceMetrics?: Maybe<Array<Maybe<DeviceMetric>>>;
  displayName?: Maybe<Scalars['String']>;
  fanSpeed?: Maybe<IndoorAirHandlerFanSpeed>;
  hasPendingUpdates: Scalars['Boolean'];
  heatSetpoint?: Maybe<IndoorAirHandlerHeatSetpoint>;
  indoorFanStatus?: Maybe<IndoorAirHandlerIndoorFanStatus>;
  installation?: Maybe<DeviceInstallation>;
  isConfigured?: Maybe<Scalars['Boolean']>;
  isControlled: Scalars['Boolean'];
  isPoweredOn?: Maybe<Scalars['Boolean']>;
  location?: Maybe<Scalars['String']>;
  maxCoolSetpointLimit?: Maybe<IndoorAirHandlerMaxCoolSetpointLimit>;
  maxHeatSetpointLimit?: Maybe<IndoorAirHandlerMaxHeatSetpointLimit>;
  meta?: Maybe<DeviceMeta>;
  minCoolSetpointLimit?: Maybe<IndoorAirHandlerMinCoolSetpointLimit>;
  minHeatSetpointLimit?: Maybe<IndoorAirHandlerMinHeatSetpointLimit>;
  modelChangeOperation?: Maybe<Scalars['String']>;
  modelType?: Maybe<Scalars['String']>;
  /** The name of the device */
  name?: Maybe<Scalars['String']>;
  operatingMode?: Maybe<IndoorAirHandlerOperatingMode>;
  operatingState?: Maybe<IndoorAirHandlerOperatingState>;
  panel?: Maybe<Panel>;
  panelId?: Maybe<Scalars['String']>;
  powerState?: Maybe<DevicePowerState>;
  property?: Maybe<Property>;
  propertyId: Scalars['String'];
  source?: Maybe<Source>;
  sourceAlerts: Array<Maybe<Alert>>;
  sourceId?: Maybe<Scalars['String']>;
  temperature?: Maybe<IndoorAirHandlerTemperature>;
  timestamp?: Maybe<Scalars['Float']>;
  type?: Maybe<EnumDKeyDeviceType>;
  typeDisplayName: Scalars['String'];
  unit?: Maybe<Unit>;
  unitId: Scalars['String'];
  updateDescription?: Maybe<Scalars['JSON']>;
  updateStatus?: Maybe<Scalars['Boolean']>;
  vpp?: Maybe<VirtualPowerPlant>;
  vppId?: Maybe<Scalars['String']>;
  zone?: Maybe<Zone>;
  zoneId?: Maybe<Scalars['String']>;
};

export type IndoorAirHandlerDeviceAlertsArgs = {
  filter?: InputMaybe<FilterFindManyAlertInput>;
  limit?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<SortFindManyAlertInput>;
};

export type IndoorAirHandlerSourceAlertsArgs = {
  filter?: InputMaybe<FilterFindManyAlertInput>;
  limit?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<SortFindManyAlertInput>;
};

export type IndoorAirHandlerCoolSetpoint = {
  __typename?: 'IndoorAirHandlerCoolSetpoint';
  id?: Maybe<Scalars['String']>;
  observedAt?: Maybe<Scalars['Float']>;
  previousId?: Maybe<Scalars['String']>;
  timestamp?: Maybe<Scalars['Float']>;
  units?: Maybe<Scalars['String']>;
  updatePending?: Maybe<Scalars['Boolean']>;
  value?: Maybe<Scalars['Float']>;
};

export type IndoorAirHandlerFanSpeed = {
  __typename?: 'IndoorAirHandlerFanSpeed';
  id?: Maybe<Scalars['String']>;
  observedAt?: Maybe<Scalars['Float']>;
  previousId?: Maybe<Scalars['String']>;
  timestamp?: Maybe<Scalars['Float']>;
  units?: Maybe<Scalars['String']>;
  updatePending?: Maybe<Scalars['Boolean']>;
  value?: Maybe<Scalars['String']>;
};

export type IndoorAirHandlerHeatSetpoint = {
  __typename?: 'IndoorAirHandlerHeatSetpoint';
  id?: Maybe<Scalars['String']>;
  observedAt?: Maybe<Scalars['Float']>;
  previousId?: Maybe<Scalars['String']>;
  timestamp?: Maybe<Scalars['Float']>;
  units?: Maybe<Scalars['String']>;
  updatePending?: Maybe<Scalars['Boolean']>;
  value?: Maybe<Scalars['Float']>;
};

export type IndoorAirHandlerIndoorFanStatus = {
  __typename?: 'IndoorAirHandlerIndoorFanStatus';
  id?: Maybe<Scalars['String']>;
  observedAt?: Maybe<Scalars['Float']>;
  previousId?: Maybe<Scalars['String']>;
  timestamp?: Maybe<Scalars['Float']>;
  units?: Maybe<Scalars['String']>;
  updatePending?: Maybe<Scalars['Boolean']>;
  value?: Maybe<EnumIndoorAirHandlerIndoorFanStatusValue>;
};

export type IndoorAirHandlerMaxCoolSetpointLimit = {
  __typename?: 'IndoorAirHandlerMaxCoolSetpointLimit';
  id?: Maybe<Scalars['String']>;
  observedAt?: Maybe<Scalars['Float']>;
  previousId?: Maybe<Scalars['String']>;
  timestamp?: Maybe<Scalars['Float']>;
  units?: Maybe<Scalars['String']>;
  updatePending?: Maybe<Scalars['Boolean']>;
  value?: Maybe<Scalars['Float']>;
};

export type IndoorAirHandlerMaxHeatSetpointLimit = {
  __typename?: 'IndoorAirHandlerMaxHeatSetpointLimit';
  id?: Maybe<Scalars['String']>;
  observedAt?: Maybe<Scalars['Float']>;
  previousId?: Maybe<Scalars['String']>;
  timestamp?: Maybe<Scalars['Float']>;
  units?: Maybe<Scalars['String']>;
  updatePending?: Maybe<Scalars['Boolean']>;
  value?: Maybe<Scalars['Float']>;
};

export type IndoorAirHandlerMinCoolSetpointLimit = {
  __typename?: 'IndoorAirHandlerMinCoolSetpointLimit';
  id?: Maybe<Scalars['String']>;
  observedAt?: Maybe<Scalars['Float']>;
  previousId?: Maybe<Scalars['String']>;
  timestamp?: Maybe<Scalars['Float']>;
  units?: Maybe<Scalars['String']>;
  updatePending?: Maybe<Scalars['Boolean']>;
  value?: Maybe<Scalars['Float']>;
};

export type IndoorAirHandlerMinHeatSetpointLimit = {
  __typename?: 'IndoorAirHandlerMinHeatSetpointLimit';
  id?: Maybe<Scalars['String']>;
  observedAt?: Maybe<Scalars['Float']>;
  previousId?: Maybe<Scalars['String']>;
  timestamp?: Maybe<Scalars['Float']>;
  units?: Maybe<Scalars['String']>;
  updatePending?: Maybe<Scalars['Boolean']>;
  value?: Maybe<Scalars['Float']>;
};

export type IndoorAirHandlerOperatingMode = {
  __typename?: 'IndoorAirHandlerOperatingMode';
  id?: Maybe<Scalars['String']>;
  observedAt?: Maybe<Scalars['Float']>;
  previousId?: Maybe<Scalars['String']>;
  timestamp?: Maybe<Scalars['Float']>;
  units?: Maybe<Scalars['String']>;
  updatePending?: Maybe<Scalars['Boolean']>;
  value?: Maybe<Scalars['String']>;
};

export type IndoorAirHandlerOperatingState = {
  __typename?: 'IndoorAirHandlerOperatingState';
  id?: Maybe<Scalars['String']>;
  observedAt?: Maybe<Scalars['Float']>;
  previousId?: Maybe<Scalars['String']>;
  timestamp?: Maybe<Scalars['Float']>;
  units?: Maybe<Scalars['String']>;
  updatePending?: Maybe<Scalars['Boolean']>;
  value?: Maybe<Scalars['String']>;
};

export type IndoorAirHandlerTemperature = {
  __typename?: 'IndoorAirHandlerTemperature';
  id?: Maybe<Scalars['String']>;
  observedAt?: Maybe<Scalars['Float']>;
  previousId?: Maybe<Scalars['String']>;
  timestamp?: Maybe<Scalars['Float']>;
  units?: Maybe<Scalars['String']>;
  updatePending?: Maybe<Scalars['Boolean']>;
  value?: Maybe<Scalars['Float']>;
};

export type IndoorSensor = DeviceInterface & {
  __typename: 'IndoorSensor';
  _id: Scalars['String'];
  alertTypes?: Maybe<DeviceAlertTypes>;
  chartTypes: Array<ChartType>;
  controlled?: Maybe<DeviceControlled>;
  dependentDeviceIds: Array<Maybe<Scalars['String']>>;
  deviceAlerts: Array<Maybe<Alert>>;
  deviceId?: Maybe<Scalars['String']>;
  deviceIdentifier?: Maybe<Scalars['String']>;
  deviceMetrics?: Maybe<Array<Maybe<DeviceMetric>>>;
  displayName?: Maybe<Scalars['String']>;
  hasPendingUpdates: Scalars['Boolean'];
  humidity?: Maybe<IndoorSensorHumidity>;
  installation?: Maybe<DeviceInstallation>;
  isConfigured?: Maybe<Scalars['Boolean']>;
  isControlled: Scalars['Boolean'];
  isPoweredOn?: Maybe<Scalars['Boolean']>;
  lastOccupied?: Maybe<Scalars['Float']>;
  location?: Maybe<Scalars['String']>;
  meta?: Maybe<DeviceMeta>;
  modelChangeOperation?: Maybe<Scalars['String']>;
  modelType?: Maybe<Scalars['String']>;
  /** The name of the device */
  name?: Maybe<Scalars['String']>;
  occupancy?: Maybe<IndoorSensorOccupancy>;
  panel?: Maybe<Panel>;
  panelId?: Maybe<Scalars['String']>;
  powerState?: Maybe<DevicePowerState>;
  property?: Maybe<Property>;
  propertyId: Scalars['String'];
  source?: Maybe<Source>;
  sourceAlerts: Array<Maybe<Alert>>;
  sourceId?: Maybe<Scalars['String']>;
  temperature?: Maybe<IndoorSensorTemperature>;
  timestamp?: Maybe<Scalars['Float']>;
  type?: Maybe<EnumDKeyDeviceType>;
  typeDisplayName: Scalars['String'];
  unit?: Maybe<Unit>;
  unitId: Scalars['String'];
  updateDescription?: Maybe<Scalars['JSON']>;
  updateStatus?: Maybe<Scalars['Boolean']>;
  voltage?: Maybe<IndoorSensorVoltage>;
  vpp?: Maybe<VirtualPowerPlant>;
  vppId?: Maybe<Scalars['String']>;
  zone?: Maybe<Zone>;
  zoneId?: Maybe<Scalars['String']>;
};

export type IndoorSensorDeviceAlertsArgs = {
  filter?: InputMaybe<FilterFindManyAlertInput>;
  limit?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<SortFindManyAlertInput>;
};

export type IndoorSensorSourceAlertsArgs = {
  filter?: InputMaybe<FilterFindManyAlertInput>;
  limit?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<SortFindManyAlertInput>;
};

export type IndoorSensorHumidity = {
  __typename?: 'IndoorSensorHumidity';
  id?: Maybe<Scalars['String']>;
  observedAt?: Maybe<Scalars['Float']>;
  previousId?: Maybe<Scalars['String']>;
  timestamp?: Maybe<Scalars['Float']>;
  units?: Maybe<Scalars['String']>;
  updatePending?: Maybe<Scalars['Boolean']>;
  value?: Maybe<Scalars['Float']>;
};

export type IndoorSensorOccupancy = {
  __typename?: 'IndoorSensorOccupancy';
  timestamp?: Maybe<Scalars['Float']>;
};

export type IndoorSensorTemperature = {
  __typename?: 'IndoorSensorTemperature';
  id?: Maybe<Scalars['String']>;
  observedAt?: Maybe<Scalars['Float']>;
  previousId?: Maybe<Scalars['String']>;
  timestamp?: Maybe<Scalars['Float']>;
  units?: Maybe<Scalars['String']>;
  updatePending?: Maybe<Scalars['Boolean']>;
  value?: Maybe<Scalars['Float']>;
};

export type IndoorSensorVoltage = {
  __typename?: 'IndoorSensorVoltage';
  id?: Maybe<Scalars['String']>;
  observedAt?: Maybe<Scalars['Float']>;
  previousId?: Maybe<Scalars['String']>;
  timestamp?: Maybe<Scalars['Float']>;
  units?: Maybe<Scalars['String']>;
  updatePending?: Maybe<Scalars['Boolean']>;
  value?: Maybe<Scalars['Float']>;
};

export type Ingestion = {
  __typename: 'Ingestion';
  _id: Scalars['String'];
  date: Scalars['Date'];
  fileName: Scalars['String'];
  modelChangeOperation?: Maybe<Scalars['String']>;
  modelType?: Maybe<Scalars['String']>;
  s3FileName: Scalars['String'];
  status: Scalars['String'];
  updateDescription?: Maybe<Scalars['JSON']>;
  user?: Maybe<User>;
  userId: Scalars['String'];
};

/** List of items with pagination. */
export type IngestionPaginatedIngestions = {
  __typename?: 'IngestionPaginatedIngestions';
  /** Total object count. */
  count?: Maybe<Scalars['Int']>;
  /** Array of objects. */
  items?: Maybe<Array<Ingestion>>;
  /** Information to aid in pagination. */
  pageInfo: PaginationInfo;
};

export type IngestionUploadInfo = {
  __typename?: 'IngestionUploadInfo';
  credentials: Scalars['String'];
  date: Scalars['String'];
  expiration: Scalars['String'];
  policy: Scalars['String'];
  signature: Scalars['String'];
  url: Scalars['String'];
};

export type InitializeSourceInput = {
  autoDiscovery?: InputMaybe<Scalars['Boolean']>;
  conductorTransportMode?: InputMaybe<ConductorTransportMode>;
  conductorWebCredentialRef?: InputMaybe<Scalars['String']>;
  phase1Simulators?: InputMaybe<Scalars['Boolean']>;
  pushHistoricReadings?: InputMaybe<Scalars['Boolean']>;
  pushMeta?: InputMaybe<Scalars['Boolean']>;
};

export type KineticEnergyManagementSystem = DeviceInterface & {
  __typename: 'KineticEnergyManagementSystem';
  _id: Scalars['String'];
  alertTypes?: Maybe<DeviceAlertTypes>;
  bearingTemperature?: Maybe<KineticEnergyManagementSystemBearingTemperature>;
  chartTypes: Array<ChartType>;
  controlled?: Maybe<DeviceControlled>;
  currentEnergyStored?: Maybe<KineticEnergyManagementSystemCurrentEnergyStored>;
  cycleCount?: Maybe<KineticEnergyManagementSystemCycleCount>;
  dependentDeviceIds: Array<Maybe<Scalars['String']>>;
  deviceAlerts: Array<Maybe<Alert>>;
  deviceId?: Maybe<Scalars['String']>;
  deviceIdentifier?: Maybe<Scalars['String']>;
  deviceMetrics?: Maybe<Array<Maybe<DeviceMetric>>>;
  displayName?: Maybe<Scalars['String']>;
  generatorCurrent?: Maybe<KineticEnergyManagementSystemGeneratorCurrent>;
  generatorVoltage?: Maybe<KineticEnergyManagementSystemGeneratorVoltage>;
  hasPendingUpdates: Scalars['Boolean'];
  installation?: Maybe<DeviceInstallation>;
  isConfigured?: Maybe<Scalars['Boolean']>;
  isControlled: Scalars['Boolean'];
  isPoweredOn?: Maybe<Scalars['Boolean']>;
  location?: Maybe<Scalars['String']>;
  meta?: Maybe<DeviceMeta>;
  modelChangeOperation?: Maybe<Scalars['String']>;
  modelType?: Maybe<Scalars['String']>;
  /** The name of the device */
  name?: Maybe<Scalars['String']>;
  panel?: Maybe<Panel>;
  panelId?: Maybe<Scalars['String']>;
  powerState?: Maybe<DevicePowerState>;
  property?: Maybe<Property>;
  propertyId: Scalars['String'];
  rotorSpeed?: Maybe<KineticEnergyManagementSystemRotorSpeed>;
  source?: Maybe<Source>;
  sourceAlerts: Array<Maybe<Alert>>;
  sourceId?: Maybe<Scalars['String']>;
  spinDownTime?: Maybe<KineticEnergyManagementSystemSpinDownTime>;
  stateOfHealth?: Maybe<KineticEnergyManagementSystemStateOfHealth>;
  systemEfficiency?: Maybe<KineticEnergyManagementSystemSystemEfficiency>;
  timestamp?: Maybe<Scalars['Float']>;
  type?: Maybe<EnumDKeyDeviceType>;
  typeDisplayName: Scalars['String'];
  unit?: Maybe<Unit>;
  unitId: Scalars['String'];
  updateDescription?: Maybe<Scalars['JSON']>;
  updateStatus?: Maybe<Scalars['Boolean']>;
  vacuumPressure?: Maybe<KineticEnergyManagementSystemVacuumPressure>;
  vibrationMetrics?: Maybe<KineticEnergyManagementSystemVibrationMetrics>;
  vpp?: Maybe<VirtualPowerPlant>;
  vppId?: Maybe<Scalars['String']>;
  zone?: Maybe<Zone>;
  zoneId?: Maybe<Scalars['String']>;
};

export type KineticEnergyManagementSystemDeviceAlertsArgs = {
  filter?: InputMaybe<FilterFindManyAlertInput>;
  limit?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<SortFindManyAlertInput>;
};

export type KineticEnergyManagementSystemSourceAlertsArgs = {
  filter?: InputMaybe<FilterFindManyAlertInput>;
  limit?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<SortFindManyAlertInput>;
};

export type KineticEnergyManagementSystemBearingTemperature = {
  __typename?: 'KineticEnergyManagementSystemBearingTemperature';
  id?: Maybe<Scalars['String']>;
  observedAt?: Maybe<Scalars['Float']>;
  previousId?: Maybe<Scalars['String']>;
  timestamp?: Maybe<Scalars['Float']>;
  units?: Maybe<Scalars['String']>;
  updatePending?: Maybe<Scalars['Boolean']>;
  value?: Maybe<Scalars['Float']>;
};

export type KineticEnergyManagementSystemCurrentEnergyStored = {
  __typename?: 'KineticEnergyManagementSystemCurrentEnergyStored';
  id?: Maybe<Scalars['String']>;
  observedAt?: Maybe<Scalars['Float']>;
  previousId?: Maybe<Scalars['String']>;
  timestamp?: Maybe<Scalars['Float']>;
  units?: Maybe<Scalars['String']>;
  updatePending?: Maybe<Scalars['Boolean']>;
  value?: Maybe<Scalars['Float']>;
};

export type KineticEnergyManagementSystemCycleCount = {
  __typename?: 'KineticEnergyManagementSystemCycleCount';
  id?: Maybe<Scalars['String']>;
  observedAt?: Maybe<Scalars['Float']>;
  previousId?: Maybe<Scalars['String']>;
  timestamp?: Maybe<Scalars['Float']>;
  units?: Maybe<Scalars['String']>;
  updatePending?: Maybe<Scalars['Boolean']>;
  value?: Maybe<Scalars['Float']>;
};

export type KineticEnergyManagementSystemGeneratorCurrent = {
  __typename?: 'KineticEnergyManagementSystemGeneratorCurrent';
  id?: Maybe<Scalars['String']>;
  observedAt?: Maybe<Scalars['Float']>;
  previousId?: Maybe<Scalars['String']>;
  timestamp?: Maybe<Scalars['Float']>;
  units?: Maybe<Scalars['String']>;
  updatePending?: Maybe<Scalars['Boolean']>;
  value?: Maybe<Scalars['Float']>;
};

export type KineticEnergyManagementSystemGeneratorVoltage = {
  __typename?: 'KineticEnergyManagementSystemGeneratorVoltage';
  id?: Maybe<Scalars['String']>;
  observedAt?: Maybe<Scalars['Float']>;
  previousId?: Maybe<Scalars['String']>;
  timestamp?: Maybe<Scalars['Float']>;
  units?: Maybe<Scalars['String']>;
  updatePending?: Maybe<Scalars['Boolean']>;
  value?: Maybe<Scalars['Float']>;
};

export type KineticEnergyManagementSystemRotorSpeed = {
  __typename?: 'KineticEnergyManagementSystemRotorSpeed';
  id?: Maybe<Scalars['String']>;
  observedAt?: Maybe<Scalars['Float']>;
  previousId?: Maybe<Scalars['String']>;
  timestamp?: Maybe<Scalars['Float']>;
  units?: Maybe<Scalars['String']>;
  updatePending?: Maybe<Scalars['Boolean']>;
  value?: Maybe<Scalars['Float']>;
};

export type KineticEnergyManagementSystemSpinDownTime = {
  __typename?: 'KineticEnergyManagementSystemSpinDownTime';
  id?: Maybe<Scalars['String']>;
  observedAt?: Maybe<Scalars['Float']>;
  previousId?: Maybe<Scalars['String']>;
  timestamp?: Maybe<Scalars['Float']>;
  units?: Maybe<Scalars['String']>;
  updatePending?: Maybe<Scalars['Boolean']>;
  value?: Maybe<Scalars['Float']>;
};

export type KineticEnergyManagementSystemStateOfHealth = {
  __typename?: 'KineticEnergyManagementSystemStateOfHealth';
  id?: Maybe<Scalars['String']>;
  observedAt?: Maybe<Scalars['Float']>;
  previousId?: Maybe<Scalars['String']>;
  timestamp?: Maybe<Scalars['Float']>;
  units?: Maybe<Scalars['String']>;
  updatePending?: Maybe<Scalars['Boolean']>;
  value?: Maybe<Scalars['Float']>;
};

export type KineticEnergyManagementSystemSystemEfficiency = {
  __typename?: 'KineticEnergyManagementSystemSystemEfficiency';
  id?: Maybe<Scalars['String']>;
  observedAt?: Maybe<Scalars['Float']>;
  previousId?: Maybe<Scalars['String']>;
  timestamp?: Maybe<Scalars['Float']>;
  units?: Maybe<Scalars['String']>;
  updatePending?: Maybe<Scalars['Boolean']>;
  value?: Maybe<Scalars['Float']>;
};

export type KineticEnergyManagementSystemVacuumPressure = {
  __typename?: 'KineticEnergyManagementSystemVacuumPressure';
  id?: Maybe<Scalars['String']>;
  observedAt?: Maybe<Scalars['Float']>;
  previousId?: Maybe<Scalars['String']>;
  timestamp?: Maybe<Scalars['Float']>;
  units?: Maybe<Scalars['String']>;
  updatePending?: Maybe<Scalars['Boolean']>;
  value?: Maybe<Scalars['Float']>;
};

export type KineticEnergyManagementSystemVibrationMetrics = {
  __typename?: 'KineticEnergyManagementSystemVibrationMetrics';
  id?: Maybe<Scalars['String']>;
  observedAt?: Maybe<Scalars['Float']>;
  previousId?: Maybe<Scalars['String']>;
  timestamp?: Maybe<Scalars['Float']>;
  units?: Maybe<Scalars['String']>;
  updatePending?: Maybe<Scalars['Boolean']>;
  value?: Maybe<Scalars['Float']>;
};

export type LeakDetector = DeviceInterface & {
  __typename: 'LeakDetector';
  _id: Scalars['String'];
  alertTypes?: Maybe<DeviceAlertTypes>;
  batteryVoltageMinThreshold?: Maybe<LeakDetectorBatteryVoltageMinThreshold>;
  batteryVoltageMinThresholdReached?: Maybe<LeakDetectorBatteryVoltageMinThresholdReached>;
  chartTypes: Array<ChartType>;
  controlled?: Maybe<DeviceControlled>;
  dependentDeviceIds: Array<Maybe<Scalars['String']>>;
  deviceAlerts: Array<Maybe<Alert>>;
  deviceId?: Maybe<Scalars['String']>;
  deviceIdentifier?: Maybe<Scalars['String']>;
  deviceMetrics?: Maybe<Array<Maybe<DeviceMetric>>>;
  displayName?: Maybe<Scalars['String']>;
  hasPendingUpdates: Scalars['Boolean'];
  installation?: Maybe<DeviceInstallation>;
  isConfigured?: Maybe<Scalars['Boolean']>;
  isControlled: Scalars['Boolean'];
  isPoweredOn?: Maybe<Scalars['Boolean']>;
  leakStatus1?: Maybe<LeakDetectorLeakStatus1>;
  leakStatus2?: Maybe<LeakDetectorLeakStatus2>;
  location?: Maybe<Scalars['String']>;
  meta?: Maybe<DeviceMeta>;
  modelChangeOperation?: Maybe<Scalars['String']>;
  modelType?: Maybe<Scalars['String']>;
  /** The name of the device */
  name?: Maybe<Scalars['String']>;
  panel?: Maybe<Panel>;
  panelId?: Maybe<Scalars['String']>;
  powerState?: Maybe<DevicePowerState>;
  property?: Maybe<Property>;
  propertyId: Scalars['String'];
  source?: Maybe<Source>;
  sourceAlerts: Array<Maybe<Alert>>;
  sourceId?: Maybe<Scalars['String']>;
  timestamp?: Maybe<Scalars['Float']>;
  type?: Maybe<EnumDKeyDeviceType>;
  typeDisplayName: Scalars['String'];
  unit?: Maybe<Unit>;
  unitId: Scalars['String'];
  updateDescription?: Maybe<Scalars['JSON']>;
  updateStatus?: Maybe<Scalars['Boolean']>;
  voltage?: Maybe<LeakDetectorVoltage>;
  vpp?: Maybe<VirtualPowerPlant>;
  vppId?: Maybe<Scalars['String']>;
  zone?: Maybe<Zone>;
  zoneId?: Maybe<Scalars['String']>;
};

export type LeakDetectorDeviceAlertsArgs = {
  filter?: InputMaybe<FilterFindManyAlertInput>;
  limit?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<SortFindManyAlertInput>;
};

export type LeakDetectorSourceAlertsArgs = {
  filter?: InputMaybe<FilterFindManyAlertInput>;
  limit?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<SortFindManyAlertInput>;
};

export type LeakDetectorBatteryVoltageMinThreshold = {
  __typename?: 'LeakDetectorBatteryVoltageMinThreshold';
  id?: Maybe<Scalars['String']>;
  observedAt?: Maybe<Scalars['Float']>;
  previousId?: Maybe<Scalars['String']>;
  timestamp?: Maybe<Scalars['Float']>;
  units?: Maybe<Scalars['String']>;
  updatePending?: Maybe<Scalars['Boolean']>;
  value?: Maybe<Scalars['Float']>;
};

export type LeakDetectorBatteryVoltageMinThresholdReached = {
  __typename?: 'LeakDetectorBatteryVoltageMinThresholdReached';
  id?: Maybe<Scalars['String']>;
  observedAt?: Maybe<Scalars['Float']>;
  previousId?: Maybe<Scalars['String']>;
  timestamp?: Maybe<Scalars['Float']>;
  units?: Maybe<Scalars['String']>;
  updatePending?: Maybe<Scalars['Boolean']>;
  value?: Maybe<Scalars['Boolean']>;
};

export type LeakDetectorLeakStatus1 = {
  __typename?: 'LeakDetectorLeakStatus1';
  id?: Maybe<Scalars['String']>;
  observedAt?: Maybe<Scalars['Float']>;
  previousId?: Maybe<Scalars['String']>;
  timestamp?: Maybe<Scalars['Float']>;
  units?: Maybe<Scalars['String']>;
  updatePending?: Maybe<Scalars['Boolean']>;
  value?: Maybe<Scalars['Boolean']>;
};

export type LeakDetectorLeakStatus2 = {
  __typename?: 'LeakDetectorLeakStatus2';
  id?: Maybe<Scalars['String']>;
  observedAt?: Maybe<Scalars['Float']>;
  previousId?: Maybe<Scalars['String']>;
  timestamp?: Maybe<Scalars['Float']>;
  units?: Maybe<Scalars['String']>;
  updatePending?: Maybe<Scalars['Boolean']>;
  value?: Maybe<Scalars['Boolean']>;
};

export type LeakDetectorVoltage = {
  __typename?: 'LeakDetectorVoltage';
  id?: Maybe<Scalars['String']>;
  observedAt?: Maybe<Scalars['Float']>;
  previousId?: Maybe<Scalars['String']>;
  timestamp?: Maybe<Scalars['Float']>;
  units?: Maybe<Scalars['String']>;
  updatePending?: Maybe<Scalars['Boolean']>;
  value?: Maybe<Scalars['Float']>;
};

export type LeapDispatchTestDataInput = {
  contractId?: InputMaybe<Scalars['String']>;
  contractName?: InputMaybe<Scalars['String']>;
  contractRecordId?: InputMaybe<Scalars['String']>;
  curtailmentDeviceId?: InputMaybe<Scalars['String']>;
  curtailmentDeviceType?: InputMaybe<Scalars['String']>;
  curtailmentPlanId?: InputMaybe<Scalars['String']>;
  dispatcherIds?: InputMaybe<Array<Scalars['String']>>;
  leapMeterId: Scalars['String'];
  maximumEventsPerSeason?: InputMaybe<Scalars['Float']>;
  meterId: Scalars['String'];
  minimumReductionKW?: InputMaybe<Scalars['Float']>;
  notificationEmail?: InputMaybe<Scalars['String']>;
  organizationId?: InputMaybe<Scalars['String']>;
  partnerId?: InputMaybe<Scalars['String']>;
  partnerReference?: InputMaybe<Scalars['String']>;
  programId?: InputMaybe<Scalars['String']>;
  programIdentifier?: InputMaybe<Scalars['String']>;
  programName?: InputMaybe<Scalars['String']>;
  propertyId: Scalars['String'];
  seedCurtailmentPlan?: InputMaybe<Scalars['Boolean']>;
  targetDevices?: InputMaybe<Scalars['JSON']>;
  targetedAdjustments?: InputMaybe<Scalars['JSON']>;
};

export type LeapDispatchTestDataResult = {
  __typename?: 'LeapDispatchTestDataResult';
  contractId: Scalars['String'];
  curtailmentActionId?: Maybe<Scalars['String']>;
  curtailmentPlanId?: Maybe<Scalars['String']>;
  externalMeterMappingId: Scalars['String'];
  partnerId: Scalars['String'];
  programId: Scalars['String'];
  sampleDispatchPayload: Scalars['JSON'];
  seededCollections: Array<Scalars['String']>;
  warnings: Array<Scalars['String']>;
  webhookPath: Scalars['String'];
};

export type LocalControlPermissionPatchInput = {
  expectedValue: Scalars['String'];
  field: Scalars['String'];
  value: Scalars['String'];
};

export type Loop = DeviceInterface & {
  __typename: 'Loop';
  _id: Scalars['String'];
  alertTypes?: Maybe<DeviceAlertTypes>;
  chartTypes: Array<ChartType>;
  controlled?: Maybe<DeviceControlled>;
  dependentDeviceIds: Array<Maybe<Scalars['String']>>;
  deviceAlerts: Array<Maybe<Alert>>;
  deviceId?: Maybe<Scalars['String']>;
  deviceIdentifier?: Maybe<Scalars['String']>;
  deviceMetrics?: Maybe<Array<Maybe<DeviceMetric>>>;
  displayName?: Maybe<Scalars['String']>;
  hasPendingUpdates: Scalars['Boolean'];
  indoorTemperature?: Maybe<LoopIndoorTemperature>;
  installation?: Maybe<DeviceInstallation>;
  isConfigured?: Maybe<Scalars['Boolean']>;
  isControlled: Scalars['Boolean'];
  isPoweredOn?: Maybe<Scalars['Boolean']>;
  location?: Maybe<Scalars['String']>;
  meta?: Maybe<DeviceMeta>;
  modelChangeOperation?: Maybe<Scalars['String']>;
  modelType?: Maybe<Scalars['String']>;
  /** The name of the device */
  name?: Maybe<Scalars['String']>;
  panel?: Maybe<Panel>;
  panelId?: Maybe<Scalars['String']>;
  powerState?: Maybe<DevicePowerState>;
  property?: Maybe<Property>;
  propertyId: Scalars['String'];
  returnTemperature?: Maybe<LoopReturnTemperature>;
  role?: Maybe<Scalars['String']>;
  source?: Maybe<Source>;
  sourceAlerts: Array<Maybe<Alert>>;
  sourceId?: Maybe<Scalars['String']>;
  supplyTemperature?: Maybe<LoopSupplyTemperature>;
  timestamp?: Maybe<Scalars['Float']>;
  type?: Maybe<EnumDKeyDeviceType>;
  typeDisplayName: Scalars['String'];
  unit?: Maybe<Unit>;
  unitId: Scalars['String'];
  updateDescription?: Maybe<Scalars['JSON']>;
  updateStatus?: Maybe<Scalars['Boolean']>;
  vpp?: Maybe<VirtualPowerPlant>;
  vppId?: Maybe<Scalars['String']>;
  zone?: Maybe<Zone>;
  zoneId?: Maybe<Scalars['String']>;
};

export type LoopDeviceAlertsArgs = {
  filter?: InputMaybe<FilterFindManyAlertInput>;
  limit?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<SortFindManyAlertInput>;
};

export type LoopSourceAlertsArgs = {
  filter?: InputMaybe<FilterFindManyAlertInput>;
  limit?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<SortFindManyAlertInput>;
};

export type LoopIndoorTemperature = {
  __typename?: 'LoopIndoorTemperature';
  id?: Maybe<Scalars['String']>;
  observedAt?: Maybe<Scalars['Float']>;
  previousId?: Maybe<Scalars['String']>;
  timestamp?: Maybe<Scalars['Float']>;
  units?: Maybe<Scalars['String']>;
  updatePending?: Maybe<Scalars['Boolean']>;
  value?: Maybe<Scalars['Float']>;
};

export type LoopReturnTemperature = {
  __typename?: 'LoopReturnTemperature';
  id?: Maybe<Scalars['String']>;
  observedAt?: Maybe<Scalars['Float']>;
  previousId?: Maybe<Scalars['String']>;
  timestamp?: Maybe<Scalars['Float']>;
  units?: Maybe<Scalars['String']>;
  updatePending?: Maybe<Scalars['Boolean']>;
  value?: Maybe<Scalars['Float']>;
};

export type LoopSupplyTemperature = {
  __typename?: 'LoopSupplyTemperature';
  id?: Maybe<Scalars['String']>;
  observedAt?: Maybe<Scalars['Float']>;
  previousId?: Maybe<Scalars['String']>;
  timestamp?: Maybe<Scalars['Float']>;
  units?: Maybe<Scalars['String']>;
  updatePending?: Maybe<Scalars['Boolean']>;
  value?: Maybe<Scalars['Float']>;
};

export type MinMax = {
  __typename?: 'MinMax';
  max: Scalars['Float'];
  min: Scalars['Float'];
};

export type ModbusAirHandler = DeviceInterface & {
  __typename: 'ModbusAirHandler';
  _id: Scalars['String'];
  ahuCoolSetpoint?: Maybe<ModbusAirHandlerAhuCoolSetpoint>;
  ahuHeatSetpoint?: Maybe<ModbusAirHandlerAhuHeatSetpoint>;
  ahuMaxHeatSetpointLimit?: Maybe<ModbusAirHandlerAhuMaxHeatSetpointLimit>;
  ahuMinCoolSetpointLimit?: Maybe<ModbusAirHandlerAhuMinCoolSetpointLimit>;
  ahuModbusId?: Maybe<ModbusAirHandlerAhuModbusId>;
  airExchangeModeOn?: Maybe<ModbusAirHandlerAirExchangeModeOn>;
  airflowUnits?: Maybe<ModbusAirHandlerAirflowUnits>;
  alarmAirRestriction?: Maybe<ModbusAirHandlerAlarmAirRestriction>;
  alarmB1SensorFail?: Maybe<ModbusAirHandlerAlarmB1SensorFail>;
  alarmB2SensorFail?: Maybe<ModbusAirHandlerAlarmB2SensorFail>;
  alarmB3SensorFail?: Maybe<ModbusAirHandlerAlarmB3SensorFail>;
  alarmB4SensorFail?: Maybe<ModbusAirHandlerAlarmB4SensorFail>;
  alarmB6SensorFail?: Maybe<ModbusAirHandlerAlarmB6SensorFail>;
  alarmChangeFilters?: Maybe<ModbusAirHandlerAlarmChangeFilters>;
  alarmChangeHepa?: Maybe<ModbusAirHandlerAlarmChangeHepa>;
  alarmClockBoard?: Maybe<ModbusAirHandlerAlarmClockBoard>;
  alarmCompressorFail?: Maybe<ModbusAirHandlerAlarmCompressorFail>;
  alarmExhaustFanStopped?: Maybe<ModbusAirHandlerAlarmExhaustFanStopped>;
  alarmExtendedMemory?: Maybe<ModbusAirHandlerAlarmExtendedMemory>;
  alarmFanABReversed?: Maybe<ModbusAirHandlerAlarmFanAbReversed>;
  alarmFanANegPressureOpt1?: Maybe<ModbusAirHandlerAlarmFanANegPressureOpt1>;
  alarmFanANegPressureOpt2?: Maybe<ModbusAirHandlerAlarmFanANegPressureOpt2>;
  alarmGlobalAlarm?: Maybe<ModbusAirHandlerAlarmGlobalAlarm>;
  alarmHighPressure?: Maybe<ModbusAirHandlerAlarmHighPressure>;
  alarmLowPressure?: Maybe<ModbusAirHandlerAlarmLowPressure>;
  alarmRefrigerantLeak?: Maybe<ModbusAirHandlerAlarmRefrigerantLeak>;
  alarmSupplyFanStopped?: Maybe<ModbusAirHandlerAlarmSupplyFanStopped>;
  alertTypes?: Maybe<DeviceAlertTypes>;
  allowTenantChangeRHSetpoint?: Maybe<ModbusAirHandlerAllowTenantChangeRhSetpoint>;
  allowTenantChangeTempSetpoints?: Maybe<ModbusAirHandlerAllowTenantChangeTempSetpoints>;
  allowTenantOnOff?: Maybe<ModbusAirHandlerAllowTenantOnOff>;
  altitude?: Maybe<ModbusAirHandlerAltitude>;
  auxCoolingEnabled?: Maybe<ModbusAirHandlerAuxCoolingEnabled>;
  biosVersion?: Maybe<ModbusAirHandlerBiosVersion>;
  bootVersion?: Maybe<ModbusAirHandlerBootVersion>;
  chartTypes: Array<ChartType>;
  compressorOn?: Maybe<ModbusAirHandlerCompressorOn>;
  conditionedTemperature?: Maybe<ModbusAirHandlerConditionedTemperature>;
  controlled?: Maybe<DeviceControlled>;
  damperPosition?: Maybe<ModbusAirHandlerDamperPosition>;
  defrostTemperature?: Maybe<ModbusAirHandlerDefrostTemperature>;
  dependentDeviceIds: Array<Maybe<Scalars['String']>>;
  deviceAlerts: Array<Maybe<Alert>>;
  deviceId?: Maybe<Scalars['String']>;
  deviceIdentifier?: Maybe<Scalars['String']>;
  deviceMetrics?: Maybe<Array<Maybe<DeviceMetric>>>;
  displayName?: Maybe<Scalars['String']>;
  enableTenantMode?: Maybe<ModbusAirHandlerEnableTenantMode>;
  exhaustFanAirflow?: Maybe<ModbusAirHandlerExhaustFanAirflow>;
  exhaustFanOn?: Maybe<ModbusAirHandlerExhaustFanOn>;
  filtersServiceTime?: Maybe<ModbusAirHandlerFiltersServiceTime>;
  freshAirSetpoint?: Maybe<ModbusAirHandlerFreshAirSetpoint>;
  gTerminalOn?: Maybe<ModbusAirHandlerGTerminalOn>;
  hTerminalOn?: Maybe<ModbusAirHandlerHTerminalOn>;
  hasPendingUpdates: Scalars['Boolean'];
  heatPumpModeOn?: Maybe<ModbusAirHandlerHeatPumpModeOn>;
  heatingElementOn?: Maybe<ModbusAirHandlerHeatingElementOn>;
  hepaServiceTime?: Maybe<ModbusAirHandlerHepaServiceTime>;
  indoorRH?: Maybe<ModbusAirHandlerIndoorRh>;
  indoorTemperature?: Maybe<ModbusAirHandlerIndoorTemperature>;
  installation?: Maybe<DeviceInstallation>;
  isConfigured?: Maybe<Scalars['Boolean']>;
  isControlled: Scalars['Boolean'];
  isPoweredOn?: Maybe<Scalars['Boolean']>;
  location?: Maybe<Scalars['String']>;
  meta?: Maybe<DeviceMeta>;
  modelChangeOperation?: Maybe<Scalars['String']>;
  modelType?: Maybe<Scalars['String']>;
  /** The name of the device */
  name?: Maybe<Scalars['String']>;
  outsideTemperature?: Maybe<ModbusAirHandlerOutsideTemperature>;
  panel?: Maybe<Panel>;
  panelId?: Maybe<Scalars['String']>;
  powerState?: Maybe<DevicePowerState>;
  property?: Maybe<Property>;
  propertyId: Scalars['String'];
  recirculationModeOn?: Maybe<ModbusAirHandlerRecirculationModeOn>;
  resetFiltersServiceTime?: Maybe<ModbusAirHandlerResetFiltersServiceTime>;
  resetHepaServiceTime?: Maybe<ModbusAirHandlerResetHepaServiceTime>;
  reversibleValveOnWhen?: Maybe<ModbusAirHandlerReversibleValveOnWhen>;
  rhSetpoint?: Maybe<ModbusAirHandlerRhSetpoint>;
  showerDetectorEnabled?: Maybe<ModbusAirHandlerShowerDetectorEnabled>;
  softwareReleaseType?: Maybe<ModbusAirHandlerSoftwareReleaseType>;
  softwareVersion?: Maybe<ModbusAirHandlerSoftwareVersion>;
  source?: Maybe<Source>;
  sourceAlerts: Array<Maybe<Alert>>;
  sourceId?: Maybe<Scalars['String']>;
  supplyFanAirflow?: Maybe<ModbusAirHandlerSupplyFanAirflow>;
  supplyFanOn?: Maybe<ModbusAirHandlerSupplyFanOn>;
  supplyFanStaticPressureH2O?: Maybe<ModbusAirHandlerSupplyFanStaticPressureH2O>;
  systemAutoMode?: Maybe<ModbusAirHandlerSystemAutoMode>;
  systemOnOff?: Maybe<ModbusAirHandlerSystemOnOff>;
  temperatureUnits?: Maybe<ModbusAirHandlerTemperatureUnits>;
  tenantModePassword?: Maybe<ModbusAirHandlerTenantModePassword>;
  timestamp?: Maybe<Scalars['Float']>;
  type?: Maybe<EnumDKeyDeviceType>;
  typeDisplayName: Scalars['String'];
  unit?: Maybe<Unit>;
  unitId: Scalars['String'];
  updateDescription?: Maybe<Scalars['JSON']>;
  updateStatus?: Maybe<Scalars['Boolean']>;
  ventilationMode?: Maybe<ModbusAirHandlerVentilationMode>;
  vpp?: Maybe<VirtualPowerPlant>;
  vppId?: Maybe<Scalars['String']>;
  wTerminalOn?: Maybe<ModbusAirHandlerWTerminalOn>;
  winterRhAdjustEnabled?: Maybe<ModbusAirHandlerWinterRhAdjustEnabled>;
  yTerminalOn?: Maybe<ModbusAirHandlerYTerminalOn>;
  zmbAhuRequestsSent?: Maybe<ModbusAirHandlerZmbAhuRequestsSent>;
  zmbAhuRequestsSentFailed?: Maybe<ModbusAirHandlerZmbAhuRequestsSentFailed>;
  zmbAirHandlerAlarm?: Maybe<ModbusAirHandlerZmbAirHandlerAlarm>;
  zmbCoreRequestsRecvd?: Maybe<ModbusAirHandlerZmbCoreRequestsRecvd>;
  zmbCpuTemperature?: Maybe<ModbusAirHandlerZmbCpuTemperature>;
  zmbFirmwareVersion?: Maybe<ModbusAirHandlerZmbFirmwareVersion>;
  zmbGlobalAlarm?: Maybe<ModbusAirHandlerZmbGlobalAlarm>;
  zmbLeakDetected?: Maybe<ModbusAirHandlerZmbLeakDetected>;
  zmbLeakDetectorInstalled?: Maybe<ModbusAirHandlerZmbLeakDetectorInstalled>;
  zmbModbusRequestDelay?: Maybe<ModbusAirHandlerZmbModbusRequestDelay>;
  zmbPollingFrequency?: Maybe<ModbusAirHandlerZmbPollingFrequency>;
  zmbRequestsRecvdInvalid?: Maybe<ModbusAirHandlerZmbRequestsRecvdInvalid>;
  zmbSystemUptime?: Maybe<ModbusAirHandlerZmbSystemUptime>;
  zmbThermostatAlarm?: Maybe<ModbusAirHandlerZmbThermostatAlarm>;
  zmbTstatRequestsRecvd?: Maybe<ModbusAirHandlerZmbTstatRequestsRecvd>;
  zone?: Maybe<Zone>;
  zoneId?: Maybe<Scalars['String']>;
};

export type ModbusAirHandlerDeviceAlertsArgs = {
  filter?: InputMaybe<FilterFindManyAlertInput>;
  limit?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<SortFindManyAlertInput>;
};

export type ModbusAirHandlerSourceAlertsArgs = {
  filter?: InputMaybe<FilterFindManyAlertInput>;
  limit?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<SortFindManyAlertInput>;
};

export type ModbusAirHandlerAdjustment = AdjustmentInterface & {
  __typename?: 'ModbusAirHandlerAdjustment';
  freshAirSetpoint?: Maybe<Scalars['Float']>;
  rhSetpoint?: Maybe<Scalars['Float']>;
  type: Scalars['String'];
  ventilationMode?: Maybe<Scalars['String']>;
};

export type ModbusAirHandlerAhuCoolSetpoint = {
  __typename?: 'ModbusAirHandlerAhuCoolSetpoint';
  id?: Maybe<Scalars['String']>;
  observedAt?: Maybe<Scalars['Float']>;
  previousId?: Maybe<Scalars['String']>;
  timestamp?: Maybe<Scalars['Float']>;
  units?: Maybe<Scalars['String']>;
  updatePending?: Maybe<Scalars['Boolean']>;
  value?: Maybe<Scalars['Float']>;
};

export type ModbusAirHandlerAhuHeatSetpoint = {
  __typename?: 'ModbusAirHandlerAhuHeatSetpoint';
  id?: Maybe<Scalars['String']>;
  observedAt?: Maybe<Scalars['Float']>;
  previousId?: Maybe<Scalars['String']>;
  timestamp?: Maybe<Scalars['Float']>;
  units?: Maybe<Scalars['String']>;
  updatePending?: Maybe<Scalars['Boolean']>;
  value?: Maybe<Scalars['Float']>;
};

export type ModbusAirHandlerAhuMaxHeatSetpointLimit = {
  __typename?: 'ModbusAirHandlerAhuMaxHeatSetpointLimit';
  id?: Maybe<Scalars['String']>;
  observedAt?: Maybe<Scalars['Float']>;
  previousId?: Maybe<Scalars['String']>;
  timestamp?: Maybe<Scalars['Float']>;
  units?: Maybe<Scalars['String']>;
  updatePending?: Maybe<Scalars['Boolean']>;
  value?: Maybe<Scalars['Float']>;
};

export type ModbusAirHandlerAhuMinCoolSetpointLimit = {
  __typename?: 'ModbusAirHandlerAhuMinCoolSetpointLimit';
  id?: Maybe<Scalars['String']>;
  observedAt?: Maybe<Scalars['Float']>;
  previousId?: Maybe<Scalars['String']>;
  timestamp?: Maybe<Scalars['Float']>;
  units?: Maybe<Scalars['String']>;
  updatePending?: Maybe<Scalars['Boolean']>;
  value?: Maybe<Scalars['Float']>;
};

export type ModbusAirHandlerAhuModbusId = {
  __typename?: 'ModbusAirHandlerAhuModbusId';
  id?: Maybe<Scalars['String']>;
  observedAt?: Maybe<Scalars['Float']>;
  previousId?: Maybe<Scalars['String']>;
  timestamp?: Maybe<Scalars['Float']>;
  units?: Maybe<Scalars['String']>;
  updatePending?: Maybe<Scalars['Boolean']>;
  value?: Maybe<Scalars['Float']>;
};

export type ModbusAirHandlerAirExchangeModeOn = {
  __typename?: 'ModbusAirHandlerAirExchangeModeOn';
  id?: Maybe<Scalars['String']>;
  observedAt?: Maybe<Scalars['Float']>;
  previousId?: Maybe<Scalars['String']>;
  timestamp?: Maybe<Scalars['Float']>;
  units?: Maybe<Scalars['String']>;
  updatePending?: Maybe<Scalars['Boolean']>;
  value?: Maybe<Scalars['Boolean']>;
};

export type ModbusAirHandlerAirflowUnits = {
  __typename?: 'ModbusAirHandlerAirflowUnits';
  id?: Maybe<Scalars['String']>;
  observedAt?: Maybe<Scalars['Float']>;
  previousId?: Maybe<Scalars['String']>;
  timestamp?: Maybe<Scalars['Float']>;
  units?: Maybe<Scalars['String']>;
  updatePending?: Maybe<Scalars['Boolean']>;
  value?: Maybe<Scalars['String']>;
};

export type ModbusAirHandlerAlarmAirRestriction = {
  __typename?: 'ModbusAirHandlerAlarmAirRestriction';
  id?: Maybe<Scalars['String']>;
  observedAt?: Maybe<Scalars['Float']>;
  previousId?: Maybe<Scalars['String']>;
  timestamp?: Maybe<Scalars['Float']>;
  units?: Maybe<Scalars['String']>;
  updatePending?: Maybe<Scalars['Boolean']>;
  value?: Maybe<Scalars['Boolean']>;
};

export type ModbusAirHandlerAlarmB1SensorFail = {
  __typename?: 'ModbusAirHandlerAlarmB1SensorFail';
  id?: Maybe<Scalars['String']>;
  observedAt?: Maybe<Scalars['Float']>;
  previousId?: Maybe<Scalars['String']>;
  timestamp?: Maybe<Scalars['Float']>;
  units?: Maybe<Scalars['String']>;
  updatePending?: Maybe<Scalars['Boolean']>;
  value?: Maybe<Scalars['Boolean']>;
};

export type ModbusAirHandlerAlarmB2SensorFail = {
  __typename?: 'ModbusAirHandlerAlarmB2SensorFail';
  id?: Maybe<Scalars['String']>;
  observedAt?: Maybe<Scalars['Float']>;
  previousId?: Maybe<Scalars['String']>;
  timestamp?: Maybe<Scalars['Float']>;
  units?: Maybe<Scalars['String']>;
  updatePending?: Maybe<Scalars['Boolean']>;
  value?: Maybe<Scalars['Boolean']>;
};

export type ModbusAirHandlerAlarmB3SensorFail = {
  __typename?: 'ModbusAirHandlerAlarmB3SensorFail';
  id?: Maybe<Scalars['String']>;
  observedAt?: Maybe<Scalars['Float']>;
  previousId?: Maybe<Scalars['String']>;
  timestamp?: Maybe<Scalars['Float']>;
  units?: Maybe<Scalars['String']>;
  updatePending?: Maybe<Scalars['Boolean']>;
  value?: Maybe<Scalars['Boolean']>;
};

export type ModbusAirHandlerAlarmB4SensorFail = {
  __typename?: 'ModbusAirHandlerAlarmB4SensorFail';
  id?: Maybe<Scalars['String']>;
  observedAt?: Maybe<Scalars['Float']>;
  previousId?: Maybe<Scalars['String']>;
  timestamp?: Maybe<Scalars['Float']>;
  units?: Maybe<Scalars['String']>;
  updatePending?: Maybe<Scalars['Boolean']>;
  value?: Maybe<Scalars['Boolean']>;
};

export type ModbusAirHandlerAlarmB6SensorFail = {
  __typename?: 'ModbusAirHandlerAlarmB6SensorFail';
  id?: Maybe<Scalars['String']>;
  observedAt?: Maybe<Scalars['Float']>;
  previousId?: Maybe<Scalars['String']>;
  timestamp?: Maybe<Scalars['Float']>;
  units?: Maybe<Scalars['String']>;
  updatePending?: Maybe<Scalars['Boolean']>;
  value?: Maybe<Scalars['Boolean']>;
};

export type ModbusAirHandlerAlarmChangeFilters = {
  __typename?: 'ModbusAirHandlerAlarmChangeFilters';
  id?: Maybe<Scalars['String']>;
  observedAt?: Maybe<Scalars['Float']>;
  previousId?: Maybe<Scalars['String']>;
  timestamp?: Maybe<Scalars['Float']>;
  units?: Maybe<Scalars['String']>;
  updatePending?: Maybe<Scalars['Boolean']>;
  value?: Maybe<Scalars['Boolean']>;
};

export type ModbusAirHandlerAlarmChangeHepa = {
  __typename?: 'ModbusAirHandlerAlarmChangeHepa';
  id?: Maybe<Scalars['String']>;
  observedAt?: Maybe<Scalars['Float']>;
  previousId?: Maybe<Scalars['String']>;
  timestamp?: Maybe<Scalars['Float']>;
  units?: Maybe<Scalars['String']>;
  updatePending?: Maybe<Scalars['Boolean']>;
  value?: Maybe<Scalars['Boolean']>;
};

export type ModbusAirHandlerAlarmClockBoard = {
  __typename?: 'ModbusAirHandlerAlarmClockBoard';
  id?: Maybe<Scalars['String']>;
  observedAt?: Maybe<Scalars['Float']>;
  previousId?: Maybe<Scalars['String']>;
  timestamp?: Maybe<Scalars['Float']>;
  units?: Maybe<Scalars['String']>;
  updatePending?: Maybe<Scalars['Boolean']>;
  value?: Maybe<Scalars['Boolean']>;
};

export type ModbusAirHandlerAlarmCompressorFail = {
  __typename?: 'ModbusAirHandlerAlarmCompressorFail';
  id?: Maybe<Scalars['String']>;
  observedAt?: Maybe<Scalars['Float']>;
  previousId?: Maybe<Scalars['String']>;
  timestamp?: Maybe<Scalars['Float']>;
  units?: Maybe<Scalars['String']>;
  updatePending?: Maybe<Scalars['Boolean']>;
  value?: Maybe<Scalars['Boolean']>;
};

export type ModbusAirHandlerAlarmExhaustFanStopped = {
  __typename?: 'ModbusAirHandlerAlarmExhaustFanStopped';
  id?: Maybe<Scalars['String']>;
  observedAt?: Maybe<Scalars['Float']>;
  previousId?: Maybe<Scalars['String']>;
  timestamp?: Maybe<Scalars['Float']>;
  units?: Maybe<Scalars['String']>;
  updatePending?: Maybe<Scalars['Boolean']>;
  value?: Maybe<Scalars['Boolean']>;
};

export type ModbusAirHandlerAlarmExtendedMemory = {
  __typename?: 'ModbusAirHandlerAlarmExtendedMemory';
  id?: Maybe<Scalars['String']>;
  observedAt?: Maybe<Scalars['Float']>;
  previousId?: Maybe<Scalars['String']>;
  timestamp?: Maybe<Scalars['Float']>;
  units?: Maybe<Scalars['String']>;
  updatePending?: Maybe<Scalars['Boolean']>;
  value?: Maybe<Scalars['Boolean']>;
};

export type ModbusAirHandlerAlarmFanAbReversed = {
  __typename?: 'ModbusAirHandlerAlarmFanABReversed';
  id?: Maybe<Scalars['String']>;
  observedAt?: Maybe<Scalars['Float']>;
  previousId?: Maybe<Scalars['String']>;
  timestamp?: Maybe<Scalars['Float']>;
  units?: Maybe<Scalars['String']>;
  updatePending?: Maybe<Scalars['Boolean']>;
  value?: Maybe<Scalars['Boolean']>;
};

export type ModbusAirHandlerAlarmFanANegPressureOpt1 = {
  __typename?: 'ModbusAirHandlerAlarmFanANegPressureOpt1';
  id?: Maybe<Scalars['String']>;
  observedAt?: Maybe<Scalars['Float']>;
  previousId?: Maybe<Scalars['String']>;
  timestamp?: Maybe<Scalars['Float']>;
  units?: Maybe<Scalars['String']>;
  updatePending?: Maybe<Scalars['Boolean']>;
  value?: Maybe<Scalars['Boolean']>;
};

export type ModbusAirHandlerAlarmFanANegPressureOpt2 = {
  __typename?: 'ModbusAirHandlerAlarmFanANegPressureOpt2';
  id?: Maybe<Scalars['String']>;
  observedAt?: Maybe<Scalars['Float']>;
  previousId?: Maybe<Scalars['String']>;
  timestamp?: Maybe<Scalars['Float']>;
  units?: Maybe<Scalars['String']>;
  updatePending?: Maybe<Scalars['Boolean']>;
  value?: Maybe<Scalars['Boolean']>;
};

export type ModbusAirHandlerAlarmGlobalAlarm = {
  __typename?: 'ModbusAirHandlerAlarmGlobalAlarm';
  id?: Maybe<Scalars['String']>;
  observedAt?: Maybe<Scalars['Float']>;
  previousId?: Maybe<Scalars['String']>;
  timestamp?: Maybe<Scalars['Float']>;
  units?: Maybe<Scalars['String']>;
  updatePending?: Maybe<Scalars['Boolean']>;
  value?: Maybe<Scalars['Boolean']>;
};

export type ModbusAirHandlerAlarmHighPressure = {
  __typename?: 'ModbusAirHandlerAlarmHighPressure';
  id?: Maybe<Scalars['String']>;
  observedAt?: Maybe<Scalars['Float']>;
  previousId?: Maybe<Scalars['String']>;
  timestamp?: Maybe<Scalars['Float']>;
  units?: Maybe<Scalars['String']>;
  updatePending?: Maybe<Scalars['Boolean']>;
  value?: Maybe<Scalars['Boolean']>;
};

export type ModbusAirHandlerAlarmLowPressure = {
  __typename?: 'ModbusAirHandlerAlarmLowPressure';
  id?: Maybe<Scalars['String']>;
  observedAt?: Maybe<Scalars['Float']>;
  previousId?: Maybe<Scalars['String']>;
  timestamp?: Maybe<Scalars['Float']>;
  units?: Maybe<Scalars['String']>;
  updatePending?: Maybe<Scalars['Boolean']>;
  value?: Maybe<Scalars['Boolean']>;
};

export type ModbusAirHandlerAlarmRefrigerantLeak = {
  __typename?: 'ModbusAirHandlerAlarmRefrigerantLeak';
  id?: Maybe<Scalars['String']>;
  observedAt?: Maybe<Scalars['Float']>;
  previousId?: Maybe<Scalars['String']>;
  timestamp?: Maybe<Scalars['Float']>;
  units?: Maybe<Scalars['String']>;
  updatePending?: Maybe<Scalars['Boolean']>;
  value?: Maybe<Scalars['Boolean']>;
};

export type ModbusAirHandlerAlarmSupplyFanStopped = {
  __typename?: 'ModbusAirHandlerAlarmSupplyFanStopped';
  id?: Maybe<Scalars['String']>;
  observedAt?: Maybe<Scalars['Float']>;
  previousId?: Maybe<Scalars['String']>;
  timestamp?: Maybe<Scalars['Float']>;
  units?: Maybe<Scalars['String']>;
  updatePending?: Maybe<Scalars['Boolean']>;
  value?: Maybe<Scalars['Boolean']>;
};

export type ModbusAirHandlerAllowTenantChangeRhSetpoint = {
  __typename?: 'ModbusAirHandlerAllowTenantChangeRHSetpoint';
  id?: Maybe<Scalars['String']>;
  observedAt?: Maybe<Scalars['Float']>;
  previousId?: Maybe<Scalars['String']>;
  timestamp?: Maybe<Scalars['Float']>;
  units?: Maybe<Scalars['String']>;
  updatePending?: Maybe<Scalars['Boolean']>;
  value?: Maybe<Scalars['Boolean']>;
};

export type ModbusAirHandlerAllowTenantChangeTempSetpoints = {
  __typename?: 'ModbusAirHandlerAllowTenantChangeTempSetpoints';
  id?: Maybe<Scalars['String']>;
  observedAt?: Maybe<Scalars['Float']>;
  previousId?: Maybe<Scalars['String']>;
  timestamp?: Maybe<Scalars['Float']>;
  units?: Maybe<Scalars['String']>;
  updatePending?: Maybe<Scalars['Boolean']>;
  value?: Maybe<Scalars['Boolean']>;
};

export type ModbusAirHandlerAllowTenantOnOff = {
  __typename?: 'ModbusAirHandlerAllowTenantOnOff';
  id?: Maybe<Scalars['String']>;
  observedAt?: Maybe<Scalars['Float']>;
  previousId?: Maybe<Scalars['String']>;
  timestamp?: Maybe<Scalars['Float']>;
  units?: Maybe<Scalars['String']>;
  updatePending?: Maybe<Scalars['Boolean']>;
  value?: Maybe<Scalars['Boolean']>;
};

export type ModbusAirHandlerAltitude = {
  __typename?: 'ModbusAirHandlerAltitude';
  id?: Maybe<Scalars['String']>;
  observedAt?: Maybe<Scalars['Float']>;
  previousId?: Maybe<Scalars['String']>;
  timestamp?: Maybe<Scalars['Float']>;
  units?: Maybe<Scalars['String']>;
  updatePending?: Maybe<Scalars['Boolean']>;
  value?: Maybe<Scalars['Float']>;
};

export type ModbusAirHandlerAuxCoolingEnabled = {
  __typename?: 'ModbusAirHandlerAuxCoolingEnabled';
  id?: Maybe<Scalars['String']>;
  observedAt?: Maybe<Scalars['Float']>;
  previousId?: Maybe<Scalars['String']>;
  timestamp?: Maybe<Scalars['Float']>;
  units?: Maybe<Scalars['String']>;
  updatePending?: Maybe<Scalars['Boolean']>;
  value?: Maybe<Scalars['Boolean']>;
};

export type ModbusAirHandlerBiosVersion = {
  __typename?: 'ModbusAirHandlerBiosVersion';
  id?: Maybe<Scalars['String']>;
  observedAt?: Maybe<Scalars['Float']>;
  previousId?: Maybe<Scalars['String']>;
  timestamp?: Maybe<Scalars['Float']>;
  units?: Maybe<Scalars['String']>;
  updatePending?: Maybe<Scalars['Boolean']>;
  value?: Maybe<Scalars['Float']>;
};

export type ModbusAirHandlerBootVersion = {
  __typename?: 'ModbusAirHandlerBootVersion';
  id?: Maybe<Scalars['String']>;
  observedAt?: Maybe<Scalars['Float']>;
  previousId?: Maybe<Scalars['String']>;
  timestamp?: Maybe<Scalars['Float']>;
  units?: Maybe<Scalars['String']>;
  updatePending?: Maybe<Scalars['Boolean']>;
  value?: Maybe<Scalars['Float']>;
};

export type ModbusAirHandlerCompressorOn = {
  __typename?: 'ModbusAirHandlerCompressorOn';
  id?: Maybe<Scalars['String']>;
  observedAt?: Maybe<Scalars['Float']>;
  previousId?: Maybe<Scalars['String']>;
  timestamp?: Maybe<Scalars['Float']>;
  units?: Maybe<Scalars['String']>;
  updatePending?: Maybe<Scalars['Boolean']>;
  value?: Maybe<Scalars['Boolean']>;
};

export type ModbusAirHandlerConditionedTemperature = {
  __typename?: 'ModbusAirHandlerConditionedTemperature';
  id?: Maybe<Scalars['String']>;
  observedAt?: Maybe<Scalars['Float']>;
  previousId?: Maybe<Scalars['String']>;
  timestamp?: Maybe<Scalars['Float']>;
  units?: Maybe<Scalars['String']>;
  updatePending?: Maybe<Scalars['Boolean']>;
  value?: Maybe<Scalars['Float']>;
};

export type ModbusAirHandlerDamperPosition = {
  __typename?: 'ModbusAirHandlerDamperPosition';
  id?: Maybe<Scalars['String']>;
  observedAt?: Maybe<Scalars['Float']>;
  previousId?: Maybe<Scalars['String']>;
  timestamp?: Maybe<Scalars['Float']>;
  units?: Maybe<Scalars['String']>;
  updatePending?: Maybe<Scalars['Boolean']>;
  value?: Maybe<Scalars['String']>;
};

export type ModbusAirHandlerDefrostTemperature = {
  __typename?: 'ModbusAirHandlerDefrostTemperature';
  id?: Maybe<Scalars['String']>;
  observedAt?: Maybe<Scalars['Float']>;
  previousId?: Maybe<Scalars['String']>;
  timestamp?: Maybe<Scalars['Float']>;
  units?: Maybe<Scalars['String']>;
  updatePending?: Maybe<Scalars['Boolean']>;
  value?: Maybe<Scalars['Float']>;
};

export type ModbusAirHandlerEnableTenantMode = {
  __typename?: 'ModbusAirHandlerEnableTenantMode';
  id?: Maybe<Scalars['String']>;
  observedAt?: Maybe<Scalars['Float']>;
  previousId?: Maybe<Scalars['String']>;
  timestamp?: Maybe<Scalars['Float']>;
  units?: Maybe<Scalars['String']>;
  updatePending?: Maybe<Scalars['Boolean']>;
  value?: Maybe<Scalars['Boolean']>;
};

export type ModbusAirHandlerExhaustFanAirflow = {
  __typename?: 'ModbusAirHandlerExhaustFanAirflow';
  id?: Maybe<Scalars['String']>;
  observedAt?: Maybe<Scalars['Float']>;
  previousId?: Maybe<Scalars['String']>;
  timestamp?: Maybe<Scalars['Float']>;
  units?: Maybe<Scalars['String']>;
  updatePending?: Maybe<Scalars['Boolean']>;
  value?: Maybe<Scalars['Float']>;
};

export type ModbusAirHandlerExhaustFanOn = {
  __typename?: 'ModbusAirHandlerExhaustFanOn';
  id?: Maybe<Scalars['String']>;
  observedAt?: Maybe<Scalars['Float']>;
  previousId?: Maybe<Scalars['String']>;
  timestamp?: Maybe<Scalars['Float']>;
  units?: Maybe<Scalars['String']>;
  updatePending?: Maybe<Scalars['Boolean']>;
  value?: Maybe<Scalars['Boolean']>;
};

export type ModbusAirHandlerFiltersServiceTime = {
  __typename?: 'ModbusAirHandlerFiltersServiceTime';
  id?: Maybe<Scalars['String']>;
  observedAt?: Maybe<Scalars['Float']>;
  previousId?: Maybe<Scalars['String']>;
  timestamp?: Maybe<Scalars['Float']>;
  units?: Maybe<Scalars['String']>;
  updatePending?: Maybe<Scalars['Boolean']>;
  value?: Maybe<Scalars['Float']>;
};

export type ModbusAirHandlerFreshAirSetpoint = {
  __typename?: 'ModbusAirHandlerFreshAirSetpoint';
  id?: Maybe<Scalars['String']>;
  observedAt?: Maybe<Scalars['Float']>;
  previousId?: Maybe<Scalars['String']>;
  timestamp?: Maybe<Scalars['Float']>;
  units?: Maybe<Scalars['String']>;
  updatePending?: Maybe<Scalars['Boolean']>;
  value?: Maybe<Scalars['Float']>;
};

export type ModbusAirHandlerGTerminalOn = {
  __typename?: 'ModbusAirHandlerGTerminalOn';
  id?: Maybe<Scalars['String']>;
  observedAt?: Maybe<Scalars['Float']>;
  previousId?: Maybe<Scalars['String']>;
  timestamp?: Maybe<Scalars['Float']>;
  units?: Maybe<Scalars['String']>;
  updatePending?: Maybe<Scalars['Boolean']>;
  value?: Maybe<Scalars['Boolean']>;
};

export type ModbusAirHandlerHTerminalOn = {
  __typename?: 'ModbusAirHandlerHTerminalOn';
  id?: Maybe<Scalars['String']>;
  observedAt?: Maybe<Scalars['Float']>;
  previousId?: Maybe<Scalars['String']>;
  timestamp?: Maybe<Scalars['Float']>;
  units?: Maybe<Scalars['String']>;
  updatePending?: Maybe<Scalars['Boolean']>;
  value?: Maybe<Scalars['Boolean']>;
};

export type ModbusAirHandlerHeatPumpModeOn = {
  __typename?: 'ModbusAirHandlerHeatPumpModeOn';
  id?: Maybe<Scalars['String']>;
  observedAt?: Maybe<Scalars['Float']>;
  previousId?: Maybe<Scalars['String']>;
  timestamp?: Maybe<Scalars['Float']>;
  units?: Maybe<Scalars['String']>;
  updatePending?: Maybe<Scalars['Boolean']>;
  value?: Maybe<Scalars['Boolean']>;
};

export type ModbusAirHandlerHeatingElementOn = {
  __typename?: 'ModbusAirHandlerHeatingElementOn';
  id?: Maybe<Scalars['String']>;
  observedAt?: Maybe<Scalars['Float']>;
  previousId?: Maybe<Scalars['String']>;
  timestamp?: Maybe<Scalars['Float']>;
  units?: Maybe<Scalars['String']>;
  updatePending?: Maybe<Scalars['Boolean']>;
  value?: Maybe<Scalars['Boolean']>;
};

export type ModbusAirHandlerHepaServiceTime = {
  __typename?: 'ModbusAirHandlerHepaServiceTime';
  id?: Maybe<Scalars['String']>;
  observedAt?: Maybe<Scalars['Float']>;
  previousId?: Maybe<Scalars['String']>;
  timestamp?: Maybe<Scalars['Float']>;
  units?: Maybe<Scalars['String']>;
  updatePending?: Maybe<Scalars['Boolean']>;
  value?: Maybe<Scalars['Float']>;
};

export type ModbusAirHandlerIndoorRh = {
  __typename?: 'ModbusAirHandlerIndoorRH';
  id?: Maybe<Scalars['String']>;
  observedAt?: Maybe<Scalars['Float']>;
  previousId?: Maybe<Scalars['String']>;
  timestamp?: Maybe<Scalars['Float']>;
  units?: Maybe<Scalars['String']>;
  updatePending?: Maybe<Scalars['Boolean']>;
  value?: Maybe<Scalars['Float']>;
};

export type ModbusAirHandlerIndoorTemperature = {
  __typename?: 'ModbusAirHandlerIndoorTemperature';
  id?: Maybe<Scalars['String']>;
  observedAt?: Maybe<Scalars['Float']>;
  previousId?: Maybe<Scalars['String']>;
  timestamp?: Maybe<Scalars['Float']>;
  units?: Maybe<Scalars['String']>;
  updatePending?: Maybe<Scalars['Boolean']>;
  value?: Maybe<Scalars['Float']>;
};

export type ModbusAirHandlerOutsideTemperature = {
  __typename?: 'ModbusAirHandlerOutsideTemperature';
  id?: Maybe<Scalars['String']>;
  observedAt?: Maybe<Scalars['Float']>;
  previousId?: Maybe<Scalars['String']>;
  timestamp?: Maybe<Scalars['Float']>;
  units?: Maybe<Scalars['String']>;
  updatePending?: Maybe<Scalars['Boolean']>;
  value?: Maybe<Scalars['Float']>;
};

export type ModbusAirHandlerRecirculationModeOn = {
  __typename?: 'ModbusAirHandlerRecirculationModeOn';
  id?: Maybe<Scalars['String']>;
  observedAt?: Maybe<Scalars['Float']>;
  previousId?: Maybe<Scalars['String']>;
  timestamp?: Maybe<Scalars['Float']>;
  units?: Maybe<Scalars['String']>;
  updatePending?: Maybe<Scalars['Boolean']>;
  value?: Maybe<Scalars['Boolean']>;
};

export type ModbusAirHandlerResetFiltersServiceTime = {
  __typename?: 'ModbusAirHandlerResetFiltersServiceTime';
  id?: Maybe<Scalars['String']>;
  observedAt?: Maybe<Scalars['Float']>;
  previousId?: Maybe<Scalars['String']>;
  timestamp?: Maybe<Scalars['Float']>;
  units?: Maybe<Scalars['String']>;
  updatePending?: Maybe<Scalars['Boolean']>;
  value?: Maybe<Scalars['String']>;
};

export type ModbusAirHandlerResetHepaServiceTime = {
  __typename?: 'ModbusAirHandlerResetHepaServiceTime';
  id?: Maybe<Scalars['String']>;
  observedAt?: Maybe<Scalars['Float']>;
  previousId?: Maybe<Scalars['String']>;
  timestamp?: Maybe<Scalars['Float']>;
  units?: Maybe<Scalars['String']>;
  updatePending?: Maybe<Scalars['Boolean']>;
  value?: Maybe<Scalars['String']>;
};

export type ModbusAirHandlerReversibleValveOnWhen = {
  __typename?: 'ModbusAirHandlerReversibleValveOnWhen';
  id?: Maybe<Scalars['String']>;
  observedAt?: Maybe<Scalars['Float']>;
  previousId?: Maybe<Scalars['String']>;
  timestamp?: Maybe<Scalars['Float']>;
  units?: Maybe<Scalars['String']>;
  updatePending?: Maybe<Scalars['Boolean']>;
  value?: Maybe<Scalars['String']>;
};

export type ModbusAirHandlerRhSetpoint = {
  __typename?: 'ModbusAirHandlerRhSetpoint';
  id?: Maybe<Scalars['String']>;
  observedAt?: Maybe<Scalars['Float']>;
  previousId?: Maybe<Scalars['String']>;
  timestamp?: Maybe<Scalars['Float']>;
  units?: Maybe<Scalars['String']>;
  updatePending?: Maybe<Scalars['Boolean']>;
  value?: Maybe<Scalars['Float']>;
};

export type ModbusAirHandlerShowerDetectorEnabled = {
  __typename?: 'ModbusAirHandlerShowerDetectorEnabled';
  id?: Maybe<Scalars['String']>;
  observedAt?: Maybe<Scalars['Float']>;
  previousId?: Maybe<Scalars['String']>;
  timestamp?: Maybe<Scalars['Float']>;
  units?: Maybe<Scalars['String']>;
  updatePending?: Maybe<Scalars['Boolean']>;
  value?: Maybe<Scalars['Boolean']>;
};

export type ModbusAirHandlerSoftwareReleaseType = {
  __typename?: 'ModbusAirHandlerSoftwareReleaseType';
  id?: Maybe<Scalars['String']>;
  observedAt?: Maybe<Scalars['Float']>;
  previousId?: Maybe<Scalars['String']>;
  timestamp?: Maybe<Scalars['Float']>;
  units?: Maybe<Scalars['String']>;
  updatePending?: Maybe<Scalars['Boolean']>;
  value?: Maybe<Scalars['String']>;
};

export type ModbusAirHandlerSoftwareVersion = {
  __typename?: 'ModbusAirHandlerSoftwareVersion';
  id?: Maybe<Scalars['String']>;
  observedAt?: Maybe<Scalars['Float']>;
  previousId?: Maybe<Scalars['String']>;
  timestamp?: Maybe<Scalars['Float']>;
  units?: Maybe<Scalars['String']>;
  updatePending?: Maybe<Scalars['Boolean']>;
  value?: Maybe<Scalars['Float']>;
};

export type ModbusAirHandlerSupplyFanAirflow = {
  __typename?: 'ModbusAirHandlerSupplyFanAirflow';
  id?: Maybe<Scalars['String']>;
  observedAt?: Maybe<Scalars['Float']>;
  previousId?: Maybe<Scalars['String']>;
  timestamp?: Maybe<Scalars['Float']>;
  units?: Maybe<Scalars['String']>;
  updatePending?: Maybe<Scalars['Boolean']>;
  value?: Maybe<Scalars['Float']>;
};

export type ModbusAirHandlerSupplyFanOn = {
  __typename?: 'ModbusAirHandlerSupplyFanOn';
  id?: Maybe<Scalars['String']>;
  observedAt?: Maybe<Scalars['Float']>;
  previousId?: Maybe<Scalars['String']>;
  timestamp?: Maybe<Scalars['Float']>;
  units?: Maybe<Scalars['String']>;
  updatePending?: Maybe<Scalars['Boolean']>;
  value?: Maybe<Scalars['Boolean']>;
};

export type ModbusAirHandlerSupplyFanStaticPressureH2O = {
  __typename?: 'ModbusAirHandlerSupplyFanStaticPressureH2O';
  id?: Maybe<Scalars['String']>;
  observedAt?: Maybe<Scalars['Float']>;
  previousId?: Maybe<Scalars['String']>;
  timestamp?: Maybe<Scalars['Float']>;
  units?: Maybe<Scalars['String']>;
  updatePending?: Maybe<Scalars['Boolean']>;
  value?: Maybe<Scalars['Float']>;
};

export type ModbusAirHandlerSystemAutoMode = {
  __typename?: 'ModbusAirHandlerSystemAutoMode';
  id?: Maybe<Scalars['String']>;
  observedAt?: Maybe<Scalars['Float']>;
  previousId?: Maybe<Scalars['String']>;
  timestamp?: Maybe<Scalars['Float']>;
  units?: Maybe<Scalars['String']>;
  updatePending?: Maybe<Scalars['Boolean']>;
  value?: Maybe<Scalars['String']>;
};

export type ModbusAirHandlerSystemOnOff = {
  __typename?: 'ModbusAirHandlerSystemOnOff';
  id?: Maybe<Scalars['String']>;
  observedAt?: Maybe<Scalars['Float']>;
  previousId?: Maybe<Scalars['String']>;
  timestamp?: Maybe<Scalars['Float']>;
  units?: Maybe<Scalars['String']>;
  updatePending?: Maybe<Scalars['Boolean']>;
  value?: Maybe<Scalars['String']>;
};

export type ModbusAirHandlerTemperatureUnits = {
  __typename?: 'ModbusAirHandlerTemperatureUnits';
  id?: Maybe<Scalars['String']>;
  observedAt?: Maybe<Scalars['Float']>;
  previousId?: Maybe<Scalars['String']>;
  timestamp?: Maybe<Scalars['Float']>;
  units?: Maybe<Scalars['String']>;
  updatePending?: Maybe<Scalars['Boolean']>;
  value?: Maybe<Scalars['String']>;
};

export type ModbusAirHandlerTenantModePassword = {
  __typename?: 'ModbusAirHandlerTenantModePassword';
  id?: Maybe<Scalars['String']>;
  observedAt?: Maybe<Scalars['Float']>;
  previousId?: Maybe<Scalars['String']>;
  timestamp?: Maybe<Scalars['Float']>;
  units?: Maybe<Scalars['String']>;
  updatePending?: Maybe<Scalars['Boolean']>;
  value?: Maybe<Scalars['String']>;
};

export type ModbusAirHandlerUpdateFields = {
  airflowUnits?: InputMaybe<Scalars['String']>;
};

export type ModbusAirHandlerUpdateInput = {
  ahuModbusId?: InputMaybe<Scalars['Int']>;
  altitude?: InputMaybe<Scalars['Int']>;
  auxCoolingEnabled?: InputMaybe<Scalars['Boolean']>;
  freshAirSetpoint?: InputMaybe<Scalars['Int']>;
  resetFiltersServiceTime?: InputMaybe<Scalars['String']>;
  resetHepaServiceTime?: InputMaybe<Scalars['String']>;
  rhSetpoint?: InputMaybe<Scalars['Float']>;
  showerDetectorEnabled?: InputMaybe<Scalars['Boolean']>;
  ventilationMode?: InputMaybe<Scalars['String']>;
  winterRhAdjustEnabled?: InputMaybe<Scalars['Boolean']>;
  zmbModbusRequestDelay?: InputMaybe<Scalars['Int']>;
  zmbPollingFrequency?: InputMaybe<Scalars['Int']>;
};

export type ModbusAirHandlerUpdateOptions = {
  forcePush?: InputMaybe<Scalars['Boolean']>;
};

export type ModbusAirHandlerVentilationMode = {
  __typename?: 'ModbusAirHandlerVentilationMode';
  id?: Maybe<Scalars['String']>;
  observedAt?: Maybe<Scalars['Float']>;
  previousId?: Maybe<Scalars['String']>;
  timestamp?: Maybe<Scalars['Float']>;
  units?: Maybe<Scalars['String']>;
  updatePending?: Maybe<Scalars['Boolean']>;
  value?: Maybe<Scalars['String']>;
};

export type ModbusAirHandlerWTerminalOn = {
  __typename?: 'ModbusAirHandlerWTerminalOn';
  id?: Maybe<Scalars['String']>;
  observedAt?: Maybe<Scalars['Float']>;
  previousId?: Maybe<Scalars['String']>;
  timestamp?: Maybe<Scalars['Float']>;
  units?: Maybe<Scalars['String']>;
  updatePending?: Maybe<Scalars['Boolean']>;
  value?: Maybe<Scalars['Boolean']>;
};

export type ModbusAirHandlerWinterRhAdjustEnabled = {
  __typename?: 'ModbusAirHandlerWinterRhAdjustEnabled';
  id?: Maybe<Scalars['String']>;
  observedAt?: Maybe<Scalars['Float']>;
  previousId?: Maybe<Scalars['String']>;
  timestamp?: Maybe<Scalars['Float']>;
  units?: Maybe<Scalars['String']>;
  updatePending?: Maybe<Scalars['Boolean']>;
  value?: Maybe<Scalars['Boolean']>;
};

export type ModbusAirHandlerYTerminalOn = {
  __typename?: 'ModbusAirHandlerYTerminalOn';
  id?: Maybe<Scalars['String']>;
  observedAt?: Maybe<Scalars['Float']>;
  previousId?: Maybe<Scalars['String']>;
  timestamp?: Maybe<Scalars['Float']>;
  units?: Maybe<Scalars['String']>;
  updatePending?: Maybe<Scalars['Boolean']>;
  value?: Maybe<Scalars['Boolean']>;
};

export type ModbusAirHandlerZmbAhuRequestsSent = {
  __typename?: 'ModbusAirHandlerZmbAhuRequestsSent';
  id?: Maybe<Scalars['String']>;
  observedAt?: Maybe<Scalars['Float']>;
  previousId?: Maybe<Scalars['String']>;
  timestamp?: Maybe<Scalars['Float']>;
  units?: Maybe<Scalars['String']>;
  updatePending?: Maybe<Scalars['Boolean']>;
  value?: Maybe<Scalars['Float']>;
};

export type ModbusAirHandlerZmbAhuRequestsSentFailed = {
  __typename?: 'ModbusAirHandlerZmbAhuRequestsSentFailed';
  id?: Maybe<Scalars['String']>;
  observedAt?: Maybe<Scalars['Float']>;
  previousId?: Maybe<Scalars['String']>;
  timestamp?: Maybe<Scalars['Float']>;
  units?: Maybe<Scalars['String']>;
  updatePending?: Maybe<Scalars['Boolean']>;
  value?: Maybe<Scalars['Float']>;
};

export type ModbusAirHandlerZmbAirHandlerAlarm = {
  __typename?: 'ModbusAirHandlerZmbAirHandlerAlarm';
  id?: Maybe<Scalars['String']>;
  observedAt?: Maybe<Scalars['Float']>;
  previousId?: Maybe<Scalars['String']>;
  timestamp?: Maybe<Scalars['Float']>;
  units?: Maybe<Scalars['String']>;
  updatePending?: Maybe<Scalars['Boolean']>;
  value?: Maybe<Scalars['Boolean']>;
};

export type ModbusAirHandlerZmbCoreRequestsRecvd = {
  __typename?: 'ModbusAirHandlerZmbCoreRequestsRecvd';
  id?: Maybe<Scalars['String']>;
  observedAt?: Maybe<Scalars['Float']>;
  previousId?: Maybe<Scalars['String']>;
  timestamp?: Maybe<Scalars['Float']>;
  units?: Maybe<Scalars['String']>;
  updatePending?: Maybe<Scalars['Boolean']>;
  value?: Maybe<Scalars['Float']>;
};

export type ModbusAirHandlerZmbCpuTemperature = {
  __typename?: 'ModbusAirHandlerZmbCpuTemperature';
  id?: Maybe<Scalars['String']>;
  observedAt?: Maybe<Scalars['Float']>;
  previousId?: Maybe<Scalars['String']>;
  timestamp?: Maybe<Scalars['Float']>;
  units?: Maybe<Scalars['String']>;
  updatePending?: Maybe<Scalars['Boolean']>;
  value?: Maybe<Scalars['Float']>;
};

export type ModbusAirHandlerZmbFirmwareVersion = {
  __typename?: 'ModbusAirHandlerZmbFirmwareVersion';
  id?: Maybe<Scalars['String']>;
  observedAt?: Maybe<Scalars['Float']>;
  previousId?: Maybe<Scalars['String']>;
  timestamp?: Maybe<Scalars['Float']>;
  units?: Maybe<Scalars['String']>;
  updatePending?: Maybe<Scalars['Boolean']>;
  value?: Maybe<Scalars['String']>;
};

export type ModbusAirHandlerZmbGlobalAlarm = {
  __typename?: 'ModbusAirHandlerZmbGlobalAlarm';
  id?: Maybe<Scalars['String']>;
  observedAt?: Maybe<Scalars['Float']>;
  previousId?: Maybe<Scalars['String']>;
  timestamp?: Maybe<Scalars['Float']>;
  units?: Maybe<Scalars['String']>;
  updatePending?: Maybe<Scalars['Boolean']>;
  value?: Maybe<Scalars['Boolean']>;
};

export type ModbusAirHandlerZmbLeakDetected = {
  __typename?: 'ModbusAirHandlerZmbLeakDetected';
  id?: Maybe<Scalars['String']>;
  observedAt?: Maybe<Scalars['Float']>;
  previousId?: Maybe<Scalars['String']>;
  timestamp?: Maybe<Scalars['Float']>;
  units?: Maybe<Scalars['String']>;
  updatePending?: Maybe<Scalars['Boolean']>;
  value?: Maybe<Scalars['Boolean']>;
};

export type ModbusAirHandlerZmbLeakDetectorInstalled = {
  __typename?: 'ModbusAirHandlerZmbLeakDetectorInstalled';
  id?: Maybe<Scalars['String']>;
  observedAt?: Maybe<Scalars['Float']>;
  previousId?: Maybe<Scalars['String']>;
  timestamp?: Maybe<Scalars['Float']>;
  units?: Maybe<Scalars['String']>;
  updatePending?: Maybe<Scalars['Boolean']>;
  value?: Maybe<Scalars['Boolean']>;
};

export type ModbusAirHandlerZmbModbusRequestDelay = {
  __typename?: 'ModbusAirHandlerZmbModbusRequestDelay';
  id?: Maybe<Scalars['String']>;
  observedAt?: Maybe<Scalars['Float']>;
  previousId?: Maybe<Scalars['String']>;
  timestamp?: Maybe<Scalars['Float']>;
  units?: Maybe<Scalars['String']>;
  updatePending?: Maybe<Scalars['Boolean']>;
  value?: Maybe<Scalars['Float']>;
};

export type ModbusAirHandlerZmbPollingFrequency = {
  __typename?: 'ModbusAirHandlerZmbPollingFrequency';
  id?: Maybe<Scalars['String']>;
  observedAt?: Maybe<Scalars['Float']>;
  previousId?: Maybe<Scalars['String']>;
  timestamp?: Maybe<Scalars['Float']>;
  units?: Maybe<Scalars['String']>;
  updatePending?: Maybe<Scalars['Boolean']>;
  value?: Maybe<Scalars['Float']>;
};

export type ModbusAirHandlerZmbRequestsRecvdInvalid = {
  __typename?: 'ModbusAirHandlerZmbRequestsRecvdInvalid';
  id?: Maybe<Scalars['String']>;
  observedAt?: Maybe<Scalars['Float']>;
  previousId?: Maybe<Scalars['String']>;
  timestamp?: Maybe<Scalars['Float']>;
  units?: Maybe<Scalars['String']>;
  updatePending?: Maybe<Scalars['Boolean']>;
  value?: Maybe<Scalars['Float']>;
};

export type ModbusAirHandlerZmbSystemUptime = {
  __typename?: 'ModbusAirHandlerZmbSystemUptime';
  id?: Maybe<Scalars['String']>;
  observedAt?: Maybe<Scalars['Float']>;
  previousId?: Maybe<Scalars['String']>;
  timestamp?: Maybe<Scalars['Float']>;
  units?: Maybe<Scalars['String']>;
  updatePending?: Maybe<Scalars['Boolean']>;
  value?: Maybe<Scalars['Float']>;
};

export type ModbusAirHandlerZmbThermostatAlarm = {
  __typename?: 'ModbusAirHandlerZmbThermostatAlarm';
  id?: Maybe<Scalars['String']>;
  observedAt?: Maybe<Scalars['Float']>;
  previousId?: Maybe<Scalars['String']>;
  timestamp?: Maybe<Scalars['Float']>;
  units?: Maybe<Scalars['String']>;
  updatePending?: Maybe<Scalars['Boolean']>;
  value?: Maybe<Scalars['Boolean']>;
};

export type ModbusAirHandlerZmbTstatRequestsRecvd = {
  __typename?: 'ModbusAirHandlerZmbTstatRequestsRecvd';
  id?: Maybe<Scalars['String']>;
  observedAt?: Maybe<Scalars['Float']>;
  previousId?: Maybe<Scalars['String']>;
  timestamp?: Maybe<Scalars['Float']>;
  units?: Maybe<Scalars['String']>;
  updatePending?: Maybe<Scalars['Boolean']>;
  value?: Maybe<Scalars['Float']>;
};

export type ModelExecutionConfigInput = {
  modelName: Scalars['String'];
  relatedEntities?: InputMaybe<Array<RelatedEntityConfigInput>>;
  typeField?: InputMaybe<Scalars['String']>;
};

export type MongoError = ErrorInterface & {
  __typename?: 'MongoError';
  /** MongoDB error code */
  code?: Maybe<Scalars['Int']>;
  /** MongoDB error message */
  message?: Maybe<Scalars['String']>;
};

export type Mutation = {
  __typename?: 'Mutation';
  /** Aborts PLM Curtailment Task(s) for a device */
  abortPlmCurtailmentTask: Scalars['Boolean'];
  /** Convenience constructor to add a new chiller device to a property */
  addChillerToUnit: Chiller;
  addPasskey?: Maybe<AuthenticationProfile>;
  /** Approves a PLM event response and schedules it */
  approvePlmEventResponse?: Maybe<PlmEventResponse>;
  /** Cancels or aborts a PLM event response and all associated tasks */
  cancelPlmEventResponse?: Maybe<PlmEventResponse>;
  /** Cancel a scheduled task */
  cancelScheduledTask: Scalars['Boolean'];
  changePassword?: Maybe<User>;
  /** Clear an opt-In via SMS status associated with the supplied phone number and contact index, referencing the supplied property Id */
  clearOptInViaSms?: Maybe<Property>;
  /** Clears update pending status for all top-level metrics on a thermostat */
  clearThermostatUpdateStatus: Thermostat;
  /** Called by client to configure a particular (thermostat) device with its correct setpoint limits. */
  commitBulkConfigSetpointLimits: BulkConfigCommitResult;
  /** Preflight the entire selected batch before sending commands. Physical controller updates are not atomic and are not rolled back. */
  commitBulkConfigThermostatsBatch: Array<BulkThermostatOutcome>;
  /** Called by client to commit the configuration template data to a particular TStat device. */
  commitBulkConfigThermostatsChanges: BulkConfigCommitResult;
  /** Commits operator-approved Conductor discovery mappings. */
  commitConductorDiscoveryMappings?: Maybe<Scalars['JSON']>;
  /** Creates an Alert Trigger with the supplied attributes */
  createAlertTrigger?: Maybe<AlertTrigger>;
  /** Create a new BNG (source) using the supplied attributes. */
  createBng?: Maybe<Bng>;
  /** Creates a building with the supplied attributes */
  createBuilding?: Maybe<Building>;
  /** Create a new Conductor source using the supplied attributes. */
  createConductor?: Maybe<Conductor>;
  createConductorCommissioningDraft: ConductorCommissioningDraftView;
  /** Creates a new control group. */
  createControlGroup: ControlGroup;
  /** Create a new core (source) using the supplied attributes. */
  createCore?: Maybe<Core>;
  /** Create a new HMM (source) using the supplied attributes. */
  createHmm?: Maybe<Hmm>;
  /** Creates a new ingestion document in Mongo */
  createIngestion?: Maybe<Ingestion>;
  /** Creates a new organization */
  createOrganization?: Maybe<Organization>;
  /** Creates a new PLM contract */
  createPlmContract?: Maybe<PlmContract>;
  /** Creates a new PLM Curtailment Action */
  createPlmCurtailmentAction?: Maybe<PlmCurtailmentAction>;
  /** Creates a new PLM curtailment plan */
  createPlmCurtailmentPlan?: Maybe<PlmCurtailmentPlan>;
  /** Creates a new PLM Curtailment Task */
  createPlmCurtailmentTask?: Maybe<PlmCurtailmentTask>;
  /** Creates a new PLM event */
  createPlmEvent?: Maybe<PlmEvent>;
  /** Creates a new PLM event response */
  createPlmEventResponse?: Maybe<PlmEventResponse>;
  /** Creates a new PLM partner */
  createPlmPartner?: Maybe<PlmPartner>;
  /** Creates a new PLM program */
  createPlmProgram?: Maybe<PlmProgram>;
  /** Deprecated compatibility alias for createPlmPartner using partnerType=utility. */
  createPlmUtility?: Maybe<PlmUtility>;
  /** Creates a property with the supplied attributes. */
  createProperty?: Maybe<Property>;
  /** Creates a Setpoint Profile with the supplied attributes. */
  createSetpointProfile?: Maybe<SetpointProfile>;
  /** Creates a new system notification */
  createSystemNotification?: Maybe<SystemNotification>;
  /** Creates a new thermostat schedule template */
  createThermostatScheduleTemplate: Scalars['String'];
  /** Creates a unit with the supplied attributes */
  createUnit?: Maybe<Unit>;
  /** Creates a new user with the supplied attributes */
  createUser?: Maybe<User>;
  createUserApiKey?: Maybe<User>;
  /** Create a zone policy and optionally apply it to selected properties (upload to cores and associate with zones). */
  createZonePolicy?: Maybe<ZonePolicy>;
  /** Detect and Correct Inconsistent Active Alerts: finds stale active alerts (missing device or device timestamp newer than alert initiated), resolves them, and returns a map of resolved alert _id to reason string. */
  daciActiveAlerts?: Maybe<Scalars['JSONObject']>;
  /** Deletes a control group by id. */
  deleteControlGroup: Scalars['Boolean'];
  deleteOrganization: Scalars['Boolean'];
  deletePlmContract: Scalars['Boolean'];
  deletePlmPartner: Scalars['Boolean'];
  deletePlmProgram: Scalars['Boolean'];
  deletePlmUtility: Scalars['Boolean'];
  /** Deletes the property with the supplied id, as well as all connected devices, zones, panels, units, buildings, sources, alerts, historic readings, and aggregated readings. */
  deleteProperty?: Maybe<Scalars['Boolean']>;
  /** Delete a completed or failed quarterly reports data export job and its generated artifacts. */
  deleteQuarterlyReportDataExportJob: DataExportJob;
  deleteSystemNotification: Scalars['Boolean'];
  /** Delete a zone policy: disassociate from all zones on cores, remove from cores, then delete from MongoDB. */
  deleteZonePolicy?: Maybe<ZonePolicy>;
  /** Update editable device attributes */
  editDevice: Device;
  finalizeConductorCommissioningDraft?: Maybe<ConductorCommissioningDraftView>;
  /** Resolves a specific alert by _id via the alert resolution endpoint. */
  forceResolveAlert: ForceResolveAlertResult;
  /** Allows administrators to initiate a password reset for a user */
  initatePasswordReset: Scalars['Boolean'];
  /** Initializes a local weather device for a property, creating necessary unit and panel if needed */
  initializeLocalWeatherDevice: OpenWeather;
  /** Initializes a newly installed source */
  initializeSource?: Maybe<Source>;
  /** Performs maintenance on the UserHistory collection: removes expired records and trims any oversized history arrays. Super-user only. */
  maintainDeviceHistories: Scalars['JSON'];
  /** Legacy: Performs maintenance on User-document historyMap entries. Kept for backward compatibility with older mobile app versions. */
  maintainUserHistories: Scalars['JSON'];
  /** Marks a system notification as acknowledged by updating the acknowledgedAt timestamp */
  markSystemNotificationAcknowledged?: Maybe<SystemNotification>;
  /** Marks a system notification as seen by the current user by adding them to the seenBy array */
  markSystemNotificationSeen?: Maybe<SystemNotification>;
  /** Seeds staging-only LEAP dispatch demo scaffolding. It does not create PLM events, PLM event responses, select curtailment plans, schedule curtailment, or execute curtailment. */
  populateLeapDispatchTestData?: Maybe<LeapDispatchTestDataResult>;
  /** Populate system triggers */
  populateSystemTriggers?: Maybe<Scalars['Boolean']>;
  /** Registers a device for installation based on the provided EUID */
  registerDevice?: Maybe<Scalars['String']>;
  /** Remove an existing alert trigger identified by the supplied id. Throws and exception if the identified alert trigger is not found or is in use. */
  removeAlertTrigger?: Maybe<Scalars['String']>;
  /** Remove an existing bng (source) identified by the supplied id. Throws and exception if the identified bng is not found or is in use. */
  removeBng?: Maybe<Scalars['String']>;
  /** Remove an existing building identified by the supplied id. Throws and exception if the identified building is not found or is in use. */
  removeBuilding?: Maybe<Scalars['String']>;
  /** Remove an existing Conductor source unless a unit still references it. */
  removeConductor?: Maybe<Scalars['String']>;
  /** Remove an existing core (source) identified by the supplied id. Throws and exception if the identified core is not found or is in use. */
  removeCore?: Maybe<Scalars['String']>;
  /** Remove an existing HMM (source) identified by the supplied id. Throws and exception if the identified HMM is not found or is in use. */
  removeHmm?: Maybe<Scalars['String']>;
  /** Deletes the given ingestion document in Mongo */
  removeIngestion: Scalars['String'];
  removePasskey?: Maybe<AuthenticationProfile>;
  /** Removes a PLM Curtailment Action */
  removePlmCurtailmentAction: Scalars['Boolean'];
  /** Removes a PLM curtailment plan */
  removePlmCurtailmentPlan: Scalars['Boolean'];
  /** Removes a PLM Curtailment Task */
  removePlmCurtailmentTask: Scalars['Boolean'];
  removePlmEvent: Scalars['Boolean'];
  removePlmEventResponse: Scalars['Boolean'];
  /** Removes the Setpoint Profile with the supplied identifier provided it is not currently assigned to any properties or units. */
  removeSetpointProfile: Scalars['String'];
  /** Removes the thermostat schedule template and updates all thermostats currently using it */
  removeThermostatScheduleTemplate: Scalars['String'];
  /** Removes the user with the supplied identifier along with its associated authentication and authorization profiles. */
  removeUser: Scalars['String'];
  /** Republishes metadata for a fully commissioned Conductor source */
  republishConductorMetadata?: Maybe<Conductor>;
  /** Reset counters on a Conductor-backed generic sensor */
  resetConductorGenericSensorCounters: Device;
  /** Resets the cumulative power display for a smart power outlet re-starting the tracking at 0. */
  resetCumulativePower: SmartPowerOutlet;
  /** Resets all subscriptions and instructs clients to re-subscribe. */
  resetEntitySubscribers?: Maybe<Scalars['JSONObject']>;
  /** Resumes schedule on a physical thermostat */
  resumeThermostatSchedule: Thermostat;
  retryConductorCommissioningCommit?: Maybe<ConductorCommissioningDraftView>;
  revokeUserApiKey?: Maybe<User>;
  /** Schedule a task to execute at a specific time */
  scheduleTask?: Maybe<ScheduledTask>;
  /** Send an opt-In request SMS to supplied phone number and contact index referencing the supplied property Id */
  sendOptInRequestSms?: Maybe<Property>;
  /** Send a test email to supplied address on behalf of the supplied property name */
  sendTestEmail?: Maybe<Scalars['Boolean']>;
  /**
   * Allows the client to preemptively set the installation status to one of the failure states.
   *     We allow this in the event that one of the core processes times out silently.
   */
  setInstallationStatus: SetInstallationStatusResult;
  /** Submit quarterly reports data export jobs for selected properties. */
  submitQuarterlyReportDataExportJobs: Array<DataExportJob>;
  /** Swaps on/off state of two paired VSD pumps */
  swapVSDPumpOnOffState: Array<VsdPump>;
  testPasskey?: Maybe<Scalars['String']>;
  /** Toggles automationEnabled on the control group identified by id. */
  toggleControlGroupAutomation: ControlGroup;
  /** Unlocks a user account that has been locked due to too many failed login attempts */
  unlockUser: Scalars['Boolean'];
  /**
   * The following is done to 'un-install' a device.  Reset the device installation
   *     status to 0, set device meta to 'undefined', set 'installation.rawDeviceId' to undefined, and
   *     finally unregister the device on its Core so as to make it unmanaged
   */
  unregisterDevice?: Maybe<Scalars['Boolean']>;
  /** Updates position and controlMode values of an Actuator */
  updateActuatorPosition: Actuator;
  /** Updates an existing alert trigger with the supplied identifier using the provided update attributes. */
  updateAlertTrigger: AlertTrigger;
  /** Update an existing bng (source) identified by the supplied id and using the supplied updates to its attributes. */
  updateBng?: Maybe<Bng>;
  /** Updates an existing building with the supplied identifier using the provided update attributes. */
  updateBuilding: Building;
  /** Update an existing Conductor source using the supplied attributes. */
  updateConductor?: Maybe<Conductor>;
  updateConductorCommissioningDraft: ConductorCommissioningDraftView;
  /** Updates an existing control group (masterDeviceId and/or groupedDevices). */
  updateControlGroup: ControlGroup;
  /** Update an existing core (source) identified by the supplied id and using the supplied updates to its attributes. */
  updateCore?: Maybe<Core>;
  /** Upserts the navigation history for the current user on the current device. The device is identified by the edgeDeviceId in the request context. History is trimmed server-side to MAX_HISTORY_LENGTH on every write. */
  updateDeviceHistory?: Maybe<UserHistory>;
  /** Power the device on or off */
  updateDevicePowerState: Device;
  updateEmailAuthorization?: Maybe<User>;
  /** Update an existing HMM (source) identified by the supplied id and using the supplied updates to its attributes. */
  updateHmm?: Maybe<Hmm>;
  /** Updates the given ingestion document in Mongo */
  updateIngestion?: Maybe<Ingestion>;
  /** Updates attributes on a physical modbus air handler */
  updateModbusAirHandler: ModbusAirHandler;
  updateOrganization?: Maybe<Organization>;
  updatePasskey?: Maybe<AuthenticationProfile>;
  updatePlmContract?: Maybe<PlmContract>;
  /** Updates a PLM Curtailment Action */
  updatePlmCurtailmentAction?: Maybe<PlmCurtailmentAction>;
  /** Updates a PLM curtailment plan */
  updatePlmCurtailmentPlan?: Maybe<PlmCurtailmentPlan>;
  /** Updates a PLM Curtailment Task */
  updatePlmCurtailmentTask?: Maybe<PlmCurtailmentTask>;
  updatePlmEvent?: Maybe<PlmEvent>;
  updatePlmEventResponse?: Maybe<PlmEventResponse>;
  updatePlmPartner?: Maybe<PlmPartner>;
  updatePlmProgram?: Maybe<PlmProgram>;
  updatePlmUtility?: Maybe<PlmUtility>;
  /** Updates an existing property with the supplied identifier using the provided updated attributes. */
  updateProperty: Property;
  /** Updates the specified property to use the setpoint limit profile with the provided ID and applies that profile to all thermostats in the property. */
  updatePropertySetpointLimitProfileOverride: Property;
  /** Updates the specified property to use the thermostat schedule template with the provided ID and applies that template to all thermostats in the unit. */
  updatePropertyThermostatScheduleTemplateOverride: Property;
  /** Updates the specified property to use the zone policy with the provided ID and applies that profile to all zones in the property. Note that a blank zone or missing policy id will remove any existing zone policy from all zones on the property. */
  updatePropertyZonePolicyOverride: Property;
  /** Updates on/off state of a Relay Device */
  updateRelayDeviceOnOffState: RelayDevice;
  /** Updates an existing Setpoint Limit Profile with the supplied identifier using the provided, updated attributes. */
  updateSetpointProfile: SetpointProfile;
  /** Updates on/off state of a Smart Power Outlet */
  updateSmartOutletOnOffState: SmartPowerOutlet;
  updateSmsAuthorization?: Maybe<User>;
  updateSystemNotification?: Maybe<SystemNotification>;
  /** Updates attributes on a physical thermostat */
  updateThermostat: Thermostat;
  /** Updates or clear pending schedule on a thermostat device */
  updateThermostatPendingSchedule: Thermostat;
  /** Updates an existing thermostat schedule template with the supplied identifier using the provided updated attributes. */
  updateThermostatScheduleTemplate: ThermostatScheduleTemplate;
  /** Updates an existing unit with the supplied identifier using the provided update attributes. */
  updateUnit: Unit;
  /** Updates the specified unit to use the setpoint limit profile with the provided ID and applies that profile to all thermostats in the unit. */
  updateUnitSetpointLimitProfileOverride: Unit;
  /** Updates the specified unit to use the thermostat schedule template with the provided ID and applies that template to all thermostats in the unit. */
  updateUnitThermostatScheduleTemplateOverride: Unit;
  /** Updates the specified unit to use the zone policy with the provided ID and applies that profile to all zones in the unit. Note that a blank zone or missing policy id will remove any existing zone policy from all zones on the unit. */
  updateUnitZonePolicyOverride: Unit;
  updateUser?: Maybe<User>;
  /** Updates or creates alert subscriptions for the specified user against the specified property using the subscription specifications provided. Removes any previously existing subscriptions for that property and user that are not included in the new set of subscription specs. Returns the new, replacement set of subscriptions for this property for this user. */
  updateUserAlertSubscriptions: Array<AlertSubscription>;
  /** Legacy: Updates the navigation history for the current user on the current device. Kept for backward compatibility with older mobile app versions. */
  updateUserHistory?: Maybe<User>;
  updateUserIdentification?: Maybe<User>;
  /** Updates on/off state of a physical VSD pump */
  updateVSDPumpOnOffState: VsdPump;
  /** Update a zone policy and apply it to the zones on the (updated) selected properties. */
  updateZonePolicy?: Maybe<ZonePolicy>;
  /** Called by client to validate the profiles and properties, and obtain various counts and an array of TStat deviceIds to configure to match their assigned SLP, if any. */
  validateBulkConfigSetpointLimits: BulkConfigValidationResult;
  /** Called by client to validate the config and properties and obtain various counts and an array of TStat deviceIds to configure. */
  validateBulkConfigThermostatsChanges: BulkConfigValidationResult;
};

export type MutationAbortPlmCurtailmentTaskArgs = {
  cancelAll?: InputMaybe<Scalars['Boolean']>;
  deviceId: Scalars['String'];
};

export type MutationAddChillerToUnitArgs = {
  decimalSlaveId?: InputMaybe<Scalars['Int']>;
  location?: InputMaybe<Scalars['String']>;
  model?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  panelId?: InputMaybe<Scalars['String']>;
  role?: InputMaybe<Scalars['String']>;
  sourceId: Scalars['String'];
  unitId: Scalars['String'];
};

export type MutationAddPasskeyArgs = {
  credentialBoundTo: Scalars['String'];
  credentialIsExternal: Scalars['Boolean'];
  credentialOS: Scalars['String'];
  data: Scalars['String'];
  enforceUserVerification: Scalars['Boolean'];
  name: Scalars['String'];
  preferred: Scalars['Boolean'];
  userId: Scalars['String'];
};

export type MutationApprovePlmEventResponseArgs = {
  _id: Scalars['String'];
};

export type MutationCancelPlmEventResponseArgs = {
  _id: Scalars['String'];
};

export type MutationCancelScheduledTaskArgs = {
  taskId: Scalars['String'];
};

export type MutationChangePasswordArgs = {
  confirmPassword: Scalars['String'];
  newPassword: Scalars['String'];
  oldPassword: Scalars['String'];
  userId: Scalars['String'];
};

export type MutationClearOptInViaSmsArgs = {
  contactIndex: Scalars['Int'];
  destinationNumber: Scalars['String'];
  propertyId: Scalars['String'];
};

export type MutationClearThermostatUpdateStatusArgs = {
  deviceId: Scalars['String'];
};

export type MutationCommitBulkConfigSetpointLimitsArgs = {
  deviceId: Scalars['String'];
};

export type MutationCommitBulkConfigThermostatsBatchArgs = {
  deviceIds: Array<Scalars['String']>;
  excludedDeviceIds: Array<Scalars['String']>;
  input: BulkConfigThermostatsInput;
  previewStates: Array<Scalars['String']>;
};

export type MutationCommitBulkConfigThermostatsChangesArgs = {
  deviceId: Scalars['String'];
  input: BulkConfigThermostatsChanges;
};

export type MutationCommitConductorDiscoveryMappingsArgs = {
  mappings: Scalars['JSON'];
  runId: Scalars['String'];
  sourceId: Scalars['String'];
};

export type MutationCreateAlertTriggerArgs = {
  alertTrigger: CreateOneAlertTriggerInput;
};

export type MutationCreateBngArgs = {
  bng: CreateOneBngInput;
};

export type MutationCreateBuildingArgs = {
  building: CreateOneBuildingInput;
};

export type MutationCreateConductorArgs = {
  conductor: CreateOneConductorInput;
};

export type MutationCreateConductorCommissioningDraftArgs = {
  mode?: InputMaybe<Scalars['String']>;
  runId?: InputMaybe<Scalars['String']>;
  sourceId: Scalars['String'];
};

export type MutationCreateControlGroupArgs = {
  record: CreateOneControlGroupInput;
};

export type MutationCreateCoreArgs = {
  core: CreateOneCoreInput;
};

export type MutationCreateHmmArgs = {
  hmm: CreateOneHmmInput;
};

export type MutationCreateIngestionArgs = {
  record: CreateIngestionInput;
};

export type MutationCreateOrganizationArgs = {
  organization: CreateOneOrganizationInput;
};

export type MutationCreatePlmContractArgs = {
  plmContract: CreateOnePlmContractInput;
};

export type MutationCreatePlmCurtailmentActionArgs = {
  action: PlmCurtailmentActionCreateInput;
};

export type MutationCreatePlmCurtailmentPlanArgs = {
  plan: CreateOnePlmCurtailmentPlanInput;
};

export type MutationCreatePlmCurtailmentTaskArgs = {
  action: CreateOnePlmCurtailmentTaskInput;
};

export type MutationCreatePlmEventArgs = {
  record: CreateOnePlmEventInput;
};

export type MutationCreatePlmEventResponseArgs = {
  record: CreateOnePlmEventResponseInput;
};

export type MutationCreatePlmPartnerArgs = {
  plmPartner: CreateOnePlmPartnerInput;
};

export type MutationCreatePlmProgramArgs = {
  plmProgram: CreateOnePlmProgramInput;
};

export type MutationCreatePlmUtilityArgs = {
  plmUtility: CreateOnePlmUtilityInput;
};

export type MutationCreatePropertyArgs = {
  property: CreateOnePropertyInput;
};

export type MutationCreateSetpointProfileArgs = {
  profile: CreateOneSetpointProfileInput;
};

export type MutationCreateSystemNotificationArgs = {
  input: CreateOneSystemNotificationInput;
};

export type MutationCreateThermostatScheduleTemplateArgs = {
  thermostatScheduleTemplate: CreateOneThermostatScheduleTemplateInput;
};

export type MutationCreateUnitArgs = {
  unit: CreateOneUnitInput;
};

export type MutationCreateUserArgs = {
  authorizationProfile: CreateOneAuthorizationProfileInput;
  user: CreateOneUserInput;
};

export type MutationCreateUserApiKeyArgs = {
  userId: Scalars['String'];
};

export type MutationCreateZonePolicyArgs = {
  policy: CreateOneZonePolicyInput;
};

export type MutationDeleteControlGroupArgs = {
  id: Scalars['String'];
};

export type MutationDeleteOrganizationArgs = {
  _id: Scalars['String'];
};

export type MutationDeletePlmContractArgs = {
  _id: Scalars['String'];
};

export type MutationDeletePlmPartnerArgs = {
  _id: Scalars['String'];
};

export type MutationDeletePlmProgramArgs = {
  _id: Scalars['String'];
};

export type MutationDeletePlmUtilityArgs = {
  _id: Scalars['String'];
};

export type MutationDeletePropertyArgs = {
  _id: Scalars['String'];
};

export type MutationDeleteQuarterlyReportDataExportJobArgs = {
  id: Scalars['String'];
};

export type MutationDeleteSystemNotificationArgs = {
  _id: Scalars['String'];
};

export type MutationDeleteZonePolicyArgs = {
  id: Scalars['String'];
};

export type MutationEditDeviceArgs = {
  deviceId: Scalars['String'];
  edits: DeviceEditsInput;
};

export type MutationFinalizeConductorCommissioningDraftArgs = {
  draftId: Scalars['String'];
  expectedDiscoveryFingerprint: Scalars['String'];
  expectedRevision: Scalars['Float'];
  sourceId: Scalars['String'];
};

export type MutationForceResolveAlertArgs = {
  _id: Scalars['String'];
};

export type MutationInitatePasswordResetArgs = {
  userId: Scalars['String'];
};

export type MutationInitializeLocalWeatherDeviceArgs = {
  buildingId?: InputMaybe<Scalars['String']>;
  propertyId: Scalars['String'];
  unitId?: InputMaybe<Scalars['String']>;
};

export type MutationInitializeSourceArgs = {
  id: Scalars['String'];
  options?: InputMaybe<InitializeSourceInput>;
};

export type MutationMarkSystemNotificationAcknowledgedArgs = {
  _id: Scalars['String'];
};

export type MutationMarkSystemNotificationSeenArgs = {
  _id: Scalars['String'];
};

export type MutationPopulateLeapDispatchTestDataArgs = {
  input: LeapDispatchTestDataInput;
};

export type MutationRegisterDeviceArgs = {
  _id: Scalars['String'];
  euid: Scalars['String'];
};

export type MutationRemoveAlertTriggerArgs = {
  _id: Scalars['String'];
};

export type MutationRemoveBngArgs = {
  _id: Scalars['String'];
};

export type MutationRemoveBuildingArgs = {
  _id: Scalars['String'];
};

export type MutationRemoveConductorArgs = {
  _id: Scalars['String'];
};

export type MutationRemoveCoreArgs = {
  _id: Scalars['String'];
};

export type MutationRemoveHmmArgs = {
  _id: Scalars['String'];
};

export type MutationRemoveIngestionArgs = {
  id: Scalars['String'];
};

export type MutationRemovePasskeyArgs = {
  factorId: Scalars['String'];
  userId: Scalars['String'];
};

export type MutationRemovePlmCurtailmentActionArgs = {
  _id: Scalars['String'];
};

export type MutationRemovePlmCurtailmentPlanArgs = {
  _id: Scalars['String'];
};

export type MutationRemovePlmCurtailmentTaskArgs = {
  _id: Scalars['String'];
};

export type MutationRemovePlmEventArgs = {
  id: Scalars['String'];
};

export type MutationRemovePlmEventResponseArgs = {
  id: Scalars['String'];
};

export type MutationRemoveSetpointProfileArgs = {
  id: Scalars['String'];
};

export type MutationRemoveThermostatScheduleTemplateArgs = {
  id: Scalars['String'];
};

export type MutationRemoveUserArgs = {
  userId: Scalars['String'];
};

export type MutationRepublishConductorMetadataArgs = {
  id: Scalars['String'];
};

export type MutationResetConductorGenericSensorCountersArgs = {
  deviceId: Scalars['String'];
};

export type MutationResetCumulativePowerArgs = {
  deviceId: Scalars['String'];
  options?: InputMaybe<SmartPowerOutletResetCumulativePowerOptions>;
};

export type MutationResumeThermostatScheduleArgs = {
  deviceId: Scalars['String'];
};

export type MutationRetryConductorCommissioningCommitArgs = {
  draftId: Scalars['String'];
  sourceId: Scalars['String'];
};

export type MutationRevokeUserApiKeyArgs = {
  userId: Scalars['String'];
};

export type MutationScheduleTaskArgs = {
  instanceId: Scalars['String'];
  maxRetries?: InputMaybe<Scalars['Int']>;
  methodName: Scalars['String'];
  modelName: Scalars['String'];
  priority?: InputMaybe<Scalars['Int']>;
  scheduledAt: Scalars['Float'];
};

export type MutationSendOptInRequestSmsArgs = {
  contactIndex: Scalars['Int'];
  destinationNumber: Scalars['String'];
  propertyId: Scalars['String'];
};

export type MutationSendTestEmailArgs = {
  destinationEmail: Scalars['String'];
  propertyId: Scalars['String'];
};

export type MutationSetInstallationStatusArgs = {
  options: SetInstallationStatusInput;
};

export type MutationSubmitQuarterlyReportDataExportJobsArgs = {
  input: QuarterlyReportDataExportSubmitInput;
};

export type MutationSwapVsdPumpOnOffStateArgs = {
  deviceId1: Scalars['String'];
  deviceId2: Scalars['String'];
};

export type MutationTestPasskeyArgs = {
  data?: InputMaybe<Scalars['String']>;
  userId: Scalars['String'];
};

export type MutationToggleControlGroupAutomationArgs = {
  id: Scalars['String'];
};

export type MutationUnlockUserArgs = {
  userId: Scalars['String'];
};

export type MutationUnregisterDeviceArgs = {
  _id: Scalars['String'];
};

export type MutationUpdateActuatorPositionArgs = {
  deviceId: Scalars['String'];
  options?: InputMaybe<ActuatorUpdateOptions>;
  updates: ActuatorUpdateInput;
};

export type MutationUpdateAlertTriggerArgs = {
  alertTrigger: UpdateOneAlertTriggerInput;
  id: Scalars['String'];
};

export type MutationUpdateBngArgs = {
  _id: Scalars['String'];
  bng: UpdateOneBngInput;
};

export type MutationUpdateBuildingArgs = {
  building: UpdateOneBuildingInput;
  id: Scalars['String'];
};

export type MutationUpdateConductorArgs = {
  _id: Scalars['String'];
  conductor: UpdateOneConductorInput;
};

export type MutationUpdateConductorCommissioningDraftArgs = {
  draftId: Scalars['String'];
  expectedDiscoveryFingerprint: Scalars['String'];
  expectedRevision: Scalars['Float'];
  patch: ConductorCommissioningDraftPatchInput;
  sourceId: Scalars['String'];
};

export type MutationUpdateControlGroupArgs = {
  id: Scalars['String'];
  record: UpdateOneControlGroupInput;
};

export type MutationUpdateCoreArgs = {
  _id: Scalars['String'];
  core: UpdateOneCoreInput;
};

export type MutationUpdateDeviceHistoryArgs = {
  history: Scalars['JSON'];
  userId: Scalars['String'];
};

export type MutationUpdateDevicePowerStateArgs = {
  deviceId: Scalars['String'];
  poweredOn: Scalars['Boolean'];
};

export type MutationUpdateEmailAuthorizationArgs = {
  isAuthorized: Scalars['Boolean'];
  userId: Scalars['String'];
};

export type MutationUpdateHmmArgs = {
  _id: Scalars['String'];
  hmm: UpdateOneHmmInput;
};

export type MutationUpdateIngestionArgs = {
  id: Scalars['String'];
  record: UpdateIngestionInput;
};

export type MutationUpdateModbusAirHandlerArgs = {
  deviceId: Scalars['String'];
  fields?: InputMaybe<ModbusAirHandlerUpdateFields>;
  options?: InputMaybe<ModbusAirHandlerUpdateOptions>;
  updates: ModbusAirHandlerUpdateInput;
};

export type MutationUpdateOrganizationArgs = {
  _id: Scalars['String'];
  organization: UpdateOneOrganizationInput;
};

export type MutationUpdatePasskeyArgs = {
  enforceUserVerification: Scalars['Boolean'];
  factorId: Scalars['String'];
  name: Scalars['String'];
  preferred: Scalars['Boolean'];
  userId: Scalars['String'];
};

export type MutationUpdatePlmContractArgs = {
  _id: Scalars['String'];
  plmContract: UpdateOnePlmContractInput;
};

export type MutationUpdatePlmCurtailmentActionArgs = {
  _id: Scalars['String'];
  action: PlmCurtailmentActionUpdateInput;
};

export type MutationUpdatePlmCurtailmentPlanArgs = {
  _id: Scalars['String'];
  plan: UpdateOnePlmCurtailmentPlanInput;
};

export type MutationUpdatePlmCurtailmentTaskArgs = {
  _id: Scalars['String'];
  action: UpdateOnePlmCurtailmentTaskInput;
};

export type MutationUpdatePlmEventArgs = {
  _id: Scalars['String'];
  plmEvent: UpdateOnePlmEventInput;
};

export type MutationUpdatePlmEventResponseArgs = {
  _id: Scalars['String'];
  plmEventResponse: UpdateOnePlmEventResponseInput;
};

export type MutationUpdatePlmPartnerArgs = {
  _id: Scalars['String'];
  plmPartner: UpdateOnePlmPartnerInput;
};

export type MutationUpdatePlmProgramArgs = {
  _id: Scalars['String'];
  plmProgram: UpdateOnePlmProgramInput;
};

export type MutationUpdatePlmUtilityArgs = {
  _id: Scalars['String'];
  plmUtility: UpdateOnePlmUtilityInput;
};

export type MutationUpdatePropertyArgs = {
  id: Scalars['String'];
  property: UpdateOnePropertyInput;
};

export type MutationUpdatePropertySetpointLimitProfileOverrideArgs = {
  force?: InputMaybe<Scalars['Boolean']>;
  id: Scalars['String'];
  setpointProfileId: Scalars['String'];
};

export type MutationUpdatePropertyThermostatScheduleTemplateOverrideArgs = {
  force?: InputMaybe<Scalars['Boolean']>;
  id: Scalars['String'];
  propertyHasIncompatibleScheduleTemplate?: InputMaybe<Scalars['Boolean']>;
  targetThermostatIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  thermostatScheduleTemplateId: Scalars['String'];
};

export type MutationUpdatePropertyZonePolicyOverrideArgs = {
  force?: InputMaybe<Scalars['Boolean']>;
  id: Scalars['String'];
  zonePolicyId?: InputMaybe<Scalars['String']>;
};

export type MutationUpdateRelayDeviceOnOffStateArgs = {
  deviceId: Scalars['String'];
  options?: InputMaybe<RelayDeviceUpdateOptions>;
  updates: RelayDeviceUpdateInput;
};

export type MutationUpdateSetpointProfileArgs = {
  id: Scalars['String'];
  profile: UpdateOneSetpointProfileInput;
};

export type MutationUpdateSmartOutletOnOffStateArgs = {
  deviceId: Scalars['String'];
  options?: InputMaybe<SmartPowerOutletUpdateOptions>;
  updates: SmartPowerOutletUpdateInput;
};

export type MutationUpdateSmsAuthorizationArgs = {
  isAuthorized: Scalars['Boolean'];
  smsMobile: Scalars['String'];
  userId: Scalars['String'];
};

export type MutationUpdateSystemNotificationArgs = {
  _id: Scalars['String'];
  input: UpdateOneSystemNotificationInput;
};

export type MutationUpdateThermostatArgs = {
  deviceId: Scalars['String'];
  fields?: InputMaybe<ThermostatUpdateFields>;
  options?: InputMaybe<ThermostatUpdateOptions>;
  updates: ThermostatUpdateInput;
};

export type MutationUpdateThermostatPendingScheduleArgs = {
  deviceId: Scalars['String'];
  update: ThermostatPendingScheduleInput;
};

export type MutationUpdateThermostatScheduleTemplateArgs = {
  thermostatScheduleTemplate: UpdateOneThermostatScheduleTemplateInput;
};

export type MutationUpdateUnitArgs = {
  id: Scalars['String'];
  unit: UpdateOneUnitInput;
};

export type MutationUpdateUnitSetpointLimitProfileOverrideArgs = {
  force?: InputMaybe<Scalars['Boolean']>;
  id: Scalars['String'];
  revert?: InputMaybe<Scalars['Boolean']>;
  setpointProfileId: Scalars['String'];
};

export type MutationUpdateUnitThermostatScheduleTemplateOverrideArgs = {
  force?: InputMaybe<Scalars['Boolean']>;
  id: Scalars['String'];
  targetThermostatIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  thermostatScheduleTemplateId: Scalars['String'];
  unitHasIncompatibleScheduleTemplate?: InputMaybe<Scalars['Boolean']>;
};

export type MutationUpdateUnitZonePolicyOverrideArgs = {
  force?: InputMaybe<Scalars['Boolean']>;
  id: Scalars['String'];
  zonePolicyId?: InputMaybe<Scalars['String']>;
};

export type MutationUpdateUserArgs = {
  authorizationProfile?: InputMaybe<UpdateOneAuthorizationProfileInput>;
  user: UpdateOneUserInput;
  userId: Scalars['String'];
};

export type MutationUpdateUserAlertSubscriptionsArgs = {
  alertSubscriptions: Array<AlertSubscriptionSpecification>;
  propertyId: Scalars['String'];
  userId: Scalars['String'];
};

export type MutationUpdateUserHistoryArgs = {
  history: Scalars['JSON'];
  userId: Scalars['String'];
};

export type MutationUpdateUserIdentificationArgs = {
  email: Scalars['String'];
  mobile: Scalars['String'];
  name: Scalars['String'];
  preferredAirFlowUnits: AirFlowUnit;
  preferredUnits: TemperatureUnit;
  userId: Scalars['String'];
};

export type MutationUpdateVsdPumpOnOffStateArgs = {
  deviceId: Scalars['String'];
  options?: InputMaybe<VsdPumpUpdateOptions>;
  updates: VsdPumpUpdateInput;
};

export type MutationUpdateZonePolicyArgs = {
  id?: InputMaybe<Scalars['String']>;
  policy: UpdateOneZonePolicyInput;
};

export type MutationValidateBulkConfigSetpointLimitsArgs = {
  input: BulkConfigSetpointLimitsInput;
};

export type MutationValidateBulkConfigThermostatsChangesArgs = {
  input: BulkConfigThermostatsInput;
};

export type NumericChartSeries = IChartSeries & {
  __typename?: 'NumericChartSeries';
  data: Array<NumericDatapoint>;
  deviceId: Scalars['String'];
  readingType: Scalars['String'];
  units?: Maybe<Scalars['String']>;
};

export type NumericDatapoint = IDatapoint & {
  __typename?: 'NumericDatapoint';
  deviceId: Scalars['String'];
  id: Scalars['String'];
  readingType: Scalars['String'];
  timestamp: Scalars['String'];
  value: Scalars['Float'];
};

export type OauthAccessToken = {
  __typename: 'OauthAccessToken';
  _id: Scalars['String'];
  accessToken: Scalars['String'];
  clientId: Scalars['String'];
  expires: Scalars['Float'];
  modelChangeOperation?: Maybe<Scalars['String']>;
  modelType?: Maybe<Scalars['String']>;
  updateDescription?: Maybe<Scalars['JSON']>;
  userId: Scalars['String'];
};

/** List of items with pagination. */
export type OauthAccessTokenPaginatedOauthAccessTokens = {
  __typename?: 'OauthAccessTokenPaginatedOauthAccessTokens';
  /** Total object count. */
  count?: Maybe<Scalars['Int']>;
  /** Array of objects. */
  items?: Maybe<Array<OauthAccessToken>>;
  /** Information to aid in pagination. */
  pageInfo: PaginationInfo;
};

export type OauthAuthCode = {
  __typename: 'OauthAuthCode';
  _id: Scalars['String'];
  authCode: Scalars['String'];
  clientId: Scalars['String'];
  expires: Scalars['Float'];
  modelChangeOperation?: Maybe<Scalars['String']>;
  modelType?: Maybe<Scalars['String']>;
  updateDescription?: Maybe<Scalars['JSON']>;
  userId: Scalars['String'];
};

/** List of items with pagination. */
export type OauthAuthCodePaginatedOauthAuthCodes = {
  __typename?: 'OauthAuthCodePaginatedOauthAuthCodes';
  /** Total object count. */
  count?: Maybe<Scalars['Int']>;
  /** Array of objects. */
  items?: Maybe<Array<OauthAuthCode>>;
  /** Information to aid in pagination. */
  pageInfo: PaginationInfo;
};

export type OauthClient = {
  __typename: 'OauthClient';
  _id: Scalars['String'];
  active: Scalars['Boolean'];
  brand?: Maybe<Scalars['String']>;
  clientId: Scalars['String'];
  clientSecret: Scalars['String'];
  modelChangeOperation?: Maybe<Scalars['String']>;
  modelType?: Maybe<Scalars['String']>;
  redirectUri: Array<Maybe<Scalars['String']>>;
  serviceDescription?: Maybe<Scalars['String']>;
  serviceName?: Maybe<Scalars['String']>;
  updateDescription?: Maybe<Scalars['JSON']>;
};

/** List of items with pagination. */
export type OauthClientPaginatedOauthClients = {
  __typename?: 'OauthClientPaginatedOauthClients';
  /** Total object count. */
  count?: Maybe<Scalars['Int']>;
  /** Array of objects. */
  items?: Maybe<Array<OauthClient>>;
  /** Information to aid in pagination. */
  pageInfo: PaginationInfo;
};

export type OccupancySensor = DeviceInterface & {
  __typename: 'OccupancySensor';
  _id: Scalars['String'];
  alertTypes?: Maybe<DeviceAlertTypes>;
  chartTypes: Array<ChartType>;
  controlled?: Maybe<DeviceControlled>;
  dependentDeviceIds: Array<Maybe<Scalars['String']>>;
  deviceAlerts: Array<Maybe<Alert>>;
  deviceId?: Maybe<Scalars['String']>;
  deviceIdentifier?: Maybe<Scalars['String']>;
  deviceMetrics?: Maybe<Array<Maybe<DeviceMetric>>>;
  displayName?: Maybe<Scalars['String']>;
  hasOccupancy?: Maybe<Scalars['Boolean']>;
  hasPendingUpdates: Scalars['Boolean'];
  installation?: Maybe<DeviceInstallation>;
  isConfigured?: Maybe<Scalars['Boolean']>;
  isControlled: Scalars['Boolean'];
  isPoweredOn?: Maybe<Scalars['Boolean']>;
  location?: Maybe<Scalars['String']>;
  meta?: Maybe<DeviceMeta>;
  modelChangeOperation?: Maybe<Scalars['String']>;
  modelType?: Maybe<Scalars['String']>;
  /** The name of the device */
  name?: Maybe<Scalars['String']>;
  occupancy?: Maybe<OccupancySensorOccupancy>;
  panel?: Maybe<Panel>;
  panelId?: Maybe<Scalars['String']>;
  powerState?: Maybe<DevicePowerState>;
  property?: Maybe<Property>;
  propertyId: Scalars['String'];
  source?: Maybe<Source>;
  sourceAlerts: Array<Maybe<Alert>>;
  sourceId?: Maybe<Scalars['String']>;
  timestamp?: Maybe<Scalars['Float']>;
  type?: Maybe<EnumDKeyDeviceType>;
  typeDisplayName: Scalars['String'];
  unit?: Maybe<Unit>;
  unitId: Scalars['String'];
  updateDescription?: Maybe<Scalars['JSON']>;
  updateStatus?: Maybe<Scalars['Boolean']>;
  voltage?: Maybe<OccupancySensorVoltage>;
  vpp?: Maybe<VirtualPowerPlant>;
  vppId?: Maybe<Scalars['String']>;
  zone?: Maybe<Zone>;
  zoneId?: Maybe<Scalars['String']>;
};

export type OccupancySensorDeviceAlertsArgs = {
  filter?: InputMaybe<FilterFindManyAlertInput>;
  limit?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<SortFindManyAlertInput>;
};

export type OccupancySensorSourceAlertsArgs = {
  filter?: InputMaybe<FilterFindManyAlertInput>;
  limit?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<SortFindManyAlertInput>;
};

export type OccupancySensorOccupancy = {
  __typename?: 'OccupancySensorOccupancy';
  id?: Maybe<Scalars['String']>;
  observedAt?: Maybe<Scalars['Float']>;
  previousId?: Maybe<Scalars['String']>;
  timestamp?: Maybe<Scalars['Float']>;
  units?: Maybe<Scalars['String']>;
  updatePending?: Maybe<Scalars['Boolean']>;
  value?: Maybe<EnumOccupancySensorOccupancyValue>;
};

export type OccupancySensorVoltage = {
  __typename?: 'OccupancySensorVoltage';
  id?: Maybe<Scalars['String']>;
  observedAt?: Maybe<Scalars['Float']>;
  previousId?: Maybe<Scalars['String']>;
  timestamp?: Maybe<Scalars['Float']>;
  units?: Maybe<Scalars['String']>;
  updatePending?: Maybe<Scalars['Boolean']>;
  value?: Maybe<Scalars['Float']>;
};

export type OpenWeather = DeviceInterface & {
  __typename: 'OpenWeather';
  _id: Scalars['String'];
  alertTypes?: Maybe<DeviceAlertTypes>;
  chartTypes: Array<ChartType>;
  controlled?: Maybe<DeviceControlled>;
  dependentDeviceIds: Array<Maybe<Scalars['String']>>;
  deviceAlerts: Array<Maybe<Alert>>;
  deviceId?: Maybe<Scalars['String']>;
  deviceIdentifier?: Maybe<Scalars['String']>;
  deviceMetrics?: Maybe<Array<Maybe<DeviceMetric>>>;
  displayName?: Maybe<Scalars['String']>;
  hasPendingUpdates: Scalars['Boolean'];
  hasTemperature?: Maybe<Scalars['Boolean']>;
  installation?: Maybe<DeviceInstallation>;
  isConfigured?: Maybe<Scalars['Boolean']>;
  isControlled: Scalars['Boolean'];
  isPoweredOn?: Maybe<Scalars['Boolean']>;
  location?: Maybe<Scalars['String']>;
  meta?: Maybe<DeviceMeta>;
  modelChangeOperation?: Maybe<Scalars['String']>;
  modelType?: Maybe<Scalars['String']>;
  /** The name of the device */
  name?: Maybe<Scalars['String']>;
  panel?: Maybe<Panel>;
  panelId?: Maybe<Scalars['String']>;
  powerState?: Maybe<DevicePowerState>;
  property?: Maybe<Property>;
  propertyId: Scalars['String'];
  source?: Maybe<Source>;
  sourceAlerts: Array<Maybe<Alert>>;
  sourceId?: Maybe<Scalars['String']>;
  temperature?: Maybe<OpenWeatherTemperature>;
  timestamp?: Maybe<Scalars['Float']>;
  type?: Maybe<EnumDKeyDeviceType>;
  typeDisplayName: Scalars['String'];
  unit?: Maybe<Unit>;
  unitId: Scalars['String'];
  updateDescription?: Maybe<Scalars['JSON']>;
  updateStatus?: Maybe<Scalars['Boolean']>;
  vpp?: Maybe<VirtualPowerPlant>;
  vppId?: Maybe<Scalars['String']>;
  zone?: Maybe<Zone>;
  zoneId?: Maybe<Scalars['String']>;
};

export type OpenWeatherDeviceAlertsArgs = {
  filter?: InputMaybe<FilterFindManyAlertInput>;
  limit?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<SortFindManyAlertInput>;
};

export type OpenWeatherSourceAlertsArgs = {
  filter?: InputMaybe<FilterFindManyAlertInput>;
  limit?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<SortFindManyAlertInput>;
};

export type OpenWeatherTemperature = {
  __typename?: 'OpenWeatherTemperature';
  id?: Maybe<Scalars['String']>;
  observedAt?: Maybe<Scalars['Float']>;
  previousId?: Maybe<Scalars['String']>;
  timestamp?: Maybe<Scalars['Float']>;
  units?: Maybe<Scalars['String']>;
  updatePending?: Maybe<Scalars['Boolean']>;
  value?: Maybe<Scalars['Float']>;
};

export type Organization = {
  __typename: 'Organization';
  _id: Scalars['String'];
  curtailmentPlans: Array<Maybe<PlmCurtailmentPlan>>;
  description?: Maybe<Scalars['String']>;
  hqAddress: OrganizationHqAddress;
  hqEmail?: Maybe<Scalars['String']>;
  hqPhone?: Maybe<Scalars['String']>;
  modelChangeOperation?: Maybe<Scalars['String']>;
  modelType?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  parentOrganization?: Maybe<Organization>;
  parentOrganizationId?: Maybe<Scalars['String']>;
  properties: Array<Maybe<Property>>;
  systemNotifications?: Maybe<Array<SystemNotification>>;
  updateDescription?: Maybe<Scalars['JSON']>;
};

export type OrganizationCurtailmentPlansArgs = {
  filter?: InputMaybe<FilterFindManyPlmCurtailmentPlanInput>;
  limit?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<SortFindManyPlmCurtailmentPlanInput>;
};

export type OrganizationPropertiesArgs = {
  filter?: InputMaybe<FilterFindManyPropertyInput>;
  limit?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<SortFindManyPropertyInput>;
};

export type OrganizationHqAddress = {
  __typename?: 'OrganizationHqAddress';
  city: Scalars['String'];
  country: Scalars['String'];
  line1: Scalars['String'];
  line2?: Maybe<Scalars['String']>;
  postalCode: Scalars['String'];
  state: Scalars['String'];
};

/** List of items with pagination. */
export type OrganizationPaginatedOrganizations = {
  __typename?: 'OrganizationPaginatedOrganizations';
  /** Total object count. */
  count?: Maybe<Scalars['Int']>;
  /** Array of objects. */
  items?: Maybe<Array<Organization>>;
  /** Information to aid in pagination. */
  pageInfo: PaginationInfo;
};

export type OutdoorSensor = DeviceInterface & {
  __typename: 'OutdoorSensor';
  _id: Scalars['String'];
  alertTypes?: Maybe<DeviceAlertTypes>;
  chartTypes: Array<ChartType>;
  controlled?: Maybe<DeviceControlled>;
  dependentDeviceIds: Array<Maybe<Scalars['String']>>;
  deviceAlerts: Array<Maybe<Alert>>;
  deviceId?: Maybe<Scalars['String']>;
  deviceIdentifier?: Maybe<Scalars['String']>;
  deviceMetrics?: Maybe<Array<Maybe<DeviceMetric>>>;
  displayName?: Maybe<Scalars['String']>;
  hasPendingUpdates: Scalars['Boolean'];
  installation?: Maybe<DeviceInstallation>;
  isConfigured?: Maybe<Scalars['Boolean']>;
  isControlled: Scalars['Boolean'];
  isPoweredOn?: Maybe<Scalars['Boolean']>;
  location?: Maybe<Scalars['String']>;
  meta?: Maybe<DeviceMeta>;
  modelChangeOperation?: Maybe<Scalars['String']>;
  modelType?: Maybe<Scalars['String']>;
  /** The name of the device */
  name?: Maybe<Scalars['String']>;
  panel?: Maybe<Panel>;
  panelId?: Maybe<Scalars['String']>;
  powerState?: Maybe<DevicePowerState>;
  property?: Maybe<Property>;
  propertyId: Scalars['String'];
  source?: Maybe<Source>;
  sourceAlerts: Array<Maybe<Alert>>;
  sourceId?: Maybe<Scalars['String']>;
  temperature?: Maybe<OutdoorSensorTemperature>;
  timestamp?: Maybe<Scalars['Float']>;
  type?: Maybe<EnumDKeyDeviceType>;
  typeDisplayName: Scalars['String'];
  unit?: Maybe<Unit>;
  unitId: Scalars['String'];
  updateDescription?: Maybe<Scalars['JSON']>;
  updateStatus?: Maybe<Scalars['Boolean']>;
  vpp?: Maybe<VirtualPowerPlant>;
  vppId?: Maybe<Scalars['String']>;
  zone?: Maybe<Zone>;
  zoneId?: Maybe<Scalars['String']>;
};

export type OutdoorSensorDeviceAlertsArgs = {
  filter?: InputMaybe<FilterFindManyAlertInput>;
  limit?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<SortFindManyAlertInput>;
};

export type OutdoorSensorSourceAlertsArgs = {
  filter?: InputMaybe<FilterFindManyAlertInput>;
  limit?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<SortFindManyAlertInput>;
};

export type OutdoorSensorTemperature = {
  __typename?: 'OutdoorSensorTemperature';
  id?: Maybe<Scalars['String']>;
  observedAt?: Maybe<Scalars['Float']>;
  previousId?: Maybe<Scalars['String']>;
  timestamp?: Maybe<Scalars['Float']>;
  units?: Maybe<Scalars['String']>;
  updatePending?: Maybe<Scalars['Boolean']>;
  value?: Maybe<Scalars['Float']>;
};

export type PaginationInfo = {
  __typename?: 'PaginationInfo';
  currentPage: Scalars['Int'];
  hasNextPage?: Maybe<Scalars['Boolean']>;
  hasPreviousPage?: Maybe<Scalars['Boolean']>;
  itemCount?: Maybe<Scalars['Int']>;
  pageCount?: Maybe<Scalars['Int']>;
  perPage: Scalars['Int'];
};

export type Panel = {
  __typename: 'Panel';
  _id: Scalars['String'];
  alerts?: Maybe<Array<Alert>>;
  devices: Array<DeviceInterface>;
  displayName?: Maybe<Scalars['String']>;
  modelChangeOperation?: Maybe<Scalars['String']>;
  modelType?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  property?: Maybe<Property>;
  propertyId: Scalars['String'];
  role?: Maybe<Scalars['String']>;
  source?: Maybe<Source>;
  sourceId: Scalars['String'];
  type: EnumPanelType;
  unit?: Maybe<Unit>;
  unitId: Scalars['String'];
  updateDescription?: Maybe<Scalars['JSON']>;
};

export type PanelDevicesArgs = {
  filter?: InputMaybe<FilterFindManyDeviceInput>;
  limit?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<SortFindManyDeviceInput>;
};

/** List of items with pagination. */
export type PanelPaginatedPanels = {
  __typename?: 'PanelPaginatedPanels';
  /** Total object count. */
  count?: Maybe<Scalars['Int']>;
  /** Array of objects. */
  items?: Maybe<Array<Panel>>;
  /** Information to aid in pagination. */
  pageInfo: PaginationInfo;
};

export type PlmContract = {
  __typename: 'PlmContract';
  _id: Scalars['String'];
  baselineMethod: EnumPlmContractBaselineMethod;
  contractId: Scalars['String'];
  dispatcherIds?: Maybe<Array<Maybe<Scalars['String']>>>;
  dispatchers: Array<Maybe<User>>;
  incentiveDescription?: Maybe<Scalars['String']>;
  maximumEventsPerSeason: Scalars['Float'];
  meterIds?: Maybe<Array<Maybe<Scalars['String']>>>;
  minimumReductionKW: Scalars['Float'];
  modelChangeOperation?: Maybe<Scalars['String']>;
  modelType?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  notificationEmail: Scalars['String'];
  partner?: Maybe<PlmPartner>;
  partnerId: Scalars['String'];
  penaltyForNonCompliance?: Maybe<Scalars['Float']>;
  program?: Maybe<PlmProgram>;
  programId: Scalars['String'];
  properties: Array<Maybe<Property>>;
  propertyIds?: Maybe<Array<Maybe<Scalars['String']>>>;
  scopeType: EnumPlmContractScopeType;
  status: EnumPlmContractStatus;
  updateDescription?: Maybe<Scalars['JSON']>;
  utility?: Maybe<PlmUtility>;
  /** Deprecated compatibility alias for partnerId. */
  utilityId: Scalars['String'];
};

/** List of items with pagination. */
export type PlmContractPaginatedPlmContracts = {
  __typename?: 'PlmContractPaginatedPlmContracts';
  /** Total object count. */
  count?: Maybe<Scalars['Int']>;
  /** Array of objects. */
  items?: Maybe<Array<PlmContract>>;
  /** Information to aid in pagination. */
  pageInfo: PaginationInfo;
};

export type PlmCurtailmentAction = {
  __typename: 'PlmCurtailmentAction';
  _id: Scalars['String'];
  autoBatch?: Maybe<Scalars['Boolean']>;
  batchCount?: Maybe<Scalars['Float']>;
  batchDuration?: Maybe<Scalars['Float']>;
  batchStartTimeOffset?: Maybe<Scalars['Float']>;
  curtailmentPlan?: Maybe<PlmCurtailmentPlan>;
  description: Scalars['String'];
  deviceType: EnumPlmCurtailmentActionDeviceType;
  estimatedReductionKW: Scalars['Float'];
  modelChangeOperation?: Maybe<Scalars['String']>;
  modelType?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  plmCurtailmentPlanId: Scalars['String'];
  startTimeOffset?: Maybe<Scalars['Float']>;
  targetDevices?: Maybe<Scalars['JSON']>;
  targetedAdjustments?: Maybe<Array<Maybe<AdjustmentInterface>>>;
  updateDescription?: Maybe<Scalars['JSON']>;
};

export type PlmCurtailmentActionCreateInput = {
  autoBatch?: InputMaybe<Scalars['Boolean']>;
  batchCount?: InputMaybe<Scalars['Float']>;
  batchDuration?: InputMaybe<Scalars['Float']>;
  batchStartTimeOffset?: InputMaybe<Scalars['Float']>;
  description: Scalars['String'];
  deviceType: Scalars['String'];
  estimatedReductionKW: Scalars['Float'];
  name: Scalars['String'];
  plmCurtailmentPlanId: Scalars['String'];
  startTimeOffset?: InputMaybe<Scalars['Float']>;
  targetDevices?: InputMaybe<Scalars['JSON']>;
  targetedAdjustments: TargetedAdjustmentsInput;
};

/** List of items with pagination. */
export type PlmCurtailmentActionPaginatedPlmCurtailmentActions = {
  __typename?: 'PlmCurtailmentActionPaginatedPlmCurtailmentActions';
  /** Total object count. */
  count?: Maybe<Scalars['Int']>;
  /** Array of objects. */
  items?: Maybe<Array<PlmCurtailmentAction>>;
  /** Information to aid in pagination. */
  pageInfo: PaginationInfo;
};

export type PlmCurtailmentActionUpdateInput = {
  autoBatch?: InputMaybe<Scalars['Boolean']>;
  batchCount?: InputMaybe<Scalars['Float']>;
  batchDuration?: InputMaybe<Scalars['Float']>;
  batchStartTimeOffset?: InputMaybe<Scalars['Float']>;
  description: Scalars['String'];
  deviceType: Scalars['String'];
  estimatedReductionKW: Scalars['Float'];
  name: Scalars['String'];
  plmCurtailmentPlanId: Scalars['String'];
  startTimeOffset?: InputMaybe<Scalars['Float']>;
  targetDevices?: InputMaybe<Scalars['JSON']>;
  targetedAdjustments: TargetedAdjustmentsInput;
};

export type PlmCurtailmentPlan = {
  __typename: 'PlmCurtailmentPlan';
  _id: Scalars['String'];
  applicableSeasons: Array<Maybe<EnumPlmCurtailmentPlanApplicableSeasons>>;
  curtailmentActions: Array<Maybe<PlmCurtailmentAction>>;
  description: Scalars['String'];
  durationMinutes: Scalars['Float'];
  estimatedReductionKW: Scalars['Float'];
  eventResponses: Array<Maybe<PlmEventResponse>>;
  modelChangeOperation?: Maybe<Scalars['String']>;
  modelType?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  organization?: Maybe<Organization>;
  organizationId: Scalars['String'];
  updateDescription?: Maybe<Scalars['JSON']>;
};

export type PlmCurtailmentPlanCurtailmentActionsArgs = {
  filter?: InputMaybe<FilterFindManyPlmCurtailmentActionInput>;
  limit?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<SortFindManyPlmCurtailmentActionInput>;
};

export type PlmCurtailmentPlanEventResponsesArgs = {
  filter?: InputMaybe<FilterFindManyPlmEventResponseInput>;
  limit?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<SortFindManyPlmEventResponseInput>;
};

/** List of items with pagination. */
export type PlmCurtailmentPlanPaginatedPlmCurtailmentPlans = {
  __typename?: 'PlmCurtailmentPlanPaginatedPlmCurtailmentPlans';
  /** Total object count. */
  count?: Maybe<Scalars['Int']>;
  /** Array of objects. */
  items?: Maybe<Array<PlmCurtailmentPlan>>;
  /** Information to aid in pagination. */
  pageInfo: PaginationInfo;
};

export type PlmCurtailmentTask = {
  __typename: 'PlmCurtailmentTask';
  _id: Scalars['String'];
  batchId: Scalars['Float'];
  cachedDeviceState: PlmCurtailmentTaskCachedDeviceState;
  device?: Maybe<Device>;
  deviceId: Scalars['String'];
  deviceType: Scalars['String'];
  endedAt?: Maybe<Scalars['Float']>;
  estimatedReductionKW?: Maybe<Scalars['Float']>;
  modelChangeOperation?: Maybe<Scalars['String']>;
  modelType?: Maybe<Scalars['String']>;
  plmCurtailmentActionId: Scalars['String'];
  plmEventResponseId: Scalars['String'];
  propertyId: Scalars['String'];
  resolvedTargetedAdjustments?: Maybe<PlmCurtailmentTaskCachedDeviceState>;
  scheduledEnd: Scalars['Float'];
  scheduledStart: Scalars['Float'];
  startedAt?: Maybe<Scalars['Float']>;
  status: EnumPlmCurtailmentTaskStatus;
  statusMessage?: Maybe<Scalars['String']>;
  targetedAdjustments: PlmCurtailmentTaskCachedDeviceState;
  unitId: Scalars['String'];
  updateDescription?: Maybe<Scalars['JSON']>;
  updateRetryCount?: Maybe<Scalars['Float']>;
  verifiedAt?: Maybe<Scalars['Float']>;
  verifyAttempts?: Maybe<Scalars['Float']>;
};

export type PlmCurtailmentTaskCachedDeviceState = {
  __typename?: 'PlmCurtailmentTaskCachedDeviceState';
  coolSetpoint?: Maybe<Scalars['Float']>;
  coolSetpointAdjustmentMode?: Maybe<EnumPlmCurtailmentTaskCachedDeviceStateCoolSetpointAdjustmentMode>;
  fanMode?: Maybe<Scalars['String']>;
  fanSpeed?: Maybe<Scalars['String']>;
  freshAirSetpoint?: Maybe<Scalars['Float']>;
  heatSetpoint?: Maybe<Scalars['Float']>;
  heatSetpointAdjustmentMode?: Maybe<EnumPlmCurtailmentTaskCachedDeviceStateHeatSetpointAdjustmentMode>;
  isOn?: Maybe<Scalars['Boolean']>;
  keypadLockoutLevel?: Maybe<Scalars['String']>;
  maxCoolSetpointLimit?: Maybe<Scalars['Float']>;
  maxHeatSetpointLimit?: Maybe<Scalars['Float']>;
  minCoolSetpointLimit?: Maybe<Scalars['Float']>;
  minHeatSetpointLimit?: Maybe<Scalars['Float']>;
  operatingMode?: Maybe<Scalars['String']>;
  rhSetpoint?: Maybe<Scalars['Float']>;
  type: EnumPlmCurtailmentTaskCachedDeviceStateType;
  ventilationMode?: Maybe<Scalars['String']>;
};

export type PlmCurtailmentTaskCachedDeviceStateInput = {
  coolSetpoint?: InputMaybe<Scalars['Float']>;
  coolSetpointAdjustmentMode?: InputMaybe<EnumPlmCurtailmentTaskCachedDeviceStateCoolSetpointAdjustmentMode>;
  fanMode?: InputMaybe<Scalars['String']>;
  fanSpeed?: InputMaybe<Scalars['String']>;
  freshAirSetpoint?: InputMaybe<Scalars['Float']>;
  heatSetpoint?: InputMaybe<Scalars['Float']>;
  heatSetpointAdjustmentMode?: InputMaybe<EnumPlmCurtailmentTaskCachedDeviceStateHeatSetpointAdjustmentMode>;
  isOn?: InputMaybe<Scalars['Boolean']>;
  keypadLockoutLevel?: InputMaybe<Scalars['String']>;
  maxCoolSetpointLimit?: InputMaybe<Scalars['Float']>;
  maxHeatSetpointLimit?: InputMaybe<Scalars['Float']>;
  minCoolSetpointLimit?: InputMaybe<Scalars['Float']>;
  minHeatSetpointLimit?: InputMaybe<Scalars['Float']>;
  operatingMode?: InputMaybe<Scalars['String']>;
  rhSetpoint?: InputMaybe<Scalars['Float']>;
  type: EnumPlmCurtailmentTaskCachedDeviceStateType;
  ventilationMode?: InputMaybe<Scalars['String']>;
};

/** List of items with pagination. */
export type PlmCurtailmentTaskPaginatedPlmCurtailmentTasks = {
  __typename?: 'PlmCurtailmentTaskPaginatedPlmCurtailmentTasks';
  /** Total object count. */
  count?: Maybe<Scalars['Int']>;
  /** Array of objects. */
  items?: Maybe<Array<PlmCurtailmentTask>>;
  /** Information to aid in pagination. */
  pageInfo: PaginationInfo;
};

export type PlmEvent = {
  __typename: 'PlmEvent';
  _id: Scalars['String'];
  contract?: Maybe<PlmContract>;
  contractId: Scalars['String'];
  createdAt: Scalars['Float'];
  duration: Scalars['Float'];
  modelChangeOperation?: Maybe<Scalars['String']>;
  modelType?: Maybe<Scalars['String']>;
  notificationHeaders?: Maybe<Scalars['JSON']>;
  notificationMethod?: Maybe<EnumPlmEventNotificationMethod>;
  notificationPayload?: Maybe<Scalars['String']>;
  notificationReceivedAt?: Maybe<Scalars['Float']>;
  program?: Maybe<PlmProgram>;
  programId: Scalars['String'];
  reductionTarget?: Maybe<Scalars['Float']>;
  responses: Array<Maybe<PlmEventResponse>>;
  sourceExternalId?: Maybe<Scalars['String']>;
  sourceVendor?: Maybe<Scalars['String']>;
  startTime: Scalars['Float'];
  status: EnumPlmEventStatus;
  updateDescription?: Maybe<Scalars['JSON']>;
  updatedAt: Scalars['Float'];
};

export type PlmEventResponsesArgs = {
  filter?: InputMaybe<FilterFindManyPlmEventResponseInput>;
  limit?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<SortFindManyPlmEventResponseInput>;
};

/** List of items with pagination. */
export type PlmEventPaginatedPlmEvents = {
  __typename?: 'PlmEventPaginatedPlmEvents';
  /** Total object count. */
  count?: Maybe<Scalars['Int']>;
  /** Array of objects. */
  items?: Maybe<Array<PlmEvent>>;
  /** Information to aid in pagination. */
  pageInfo: PaginationInfo;
};

export type PlmEventResponse = {
  __typename: 'PlmEventResponse';
  _id: Scalars['String'];
  actualEnd?: Maybe<Scalars['Float']>;
  actualStart?: Maybe<Scalars['Float']>;
  createdAt: Scalars['Float'];
  curtailmentPlan?: Maybe<PlmCurtailmentPlan>;
  curtailmentPlanId?: Maybe<Scalars['String']>;
  event?: Maybe<PlmEvent>;
  eventId: Scalars['String'];
  modelChangeOperation?: Maybe<Scalars['String']>;
  modelType?: Maybe<Scalars['String']>;
  program?: Maybe<PlmProgram>;
  propertyId?: Maybe<Scalars['String']>;
  responseSentAt: Scalars['Float'];
  responseStatus: EnumPlmEventResponseResponseStatus;
  scheduledEnd: Scalars['Float'];
  scheduledStart: Scalars['Float'];
  updateDescription?: Maybe<Scalars['JSON']>;
  updatedAt: Scalars['Float'];
};

/** List of items with pagination. */
export type PlmEventResponsePaginatedPlmEventResponses = {
  __typename?: 'PlmEventResponsePaginatedPlmEventResponses';
  /** Total object count. */
  count?: Maybe<Scalars['Int']>;
  /** Array of objects. */
  items?: Maybe<Array<PlmEventResponse>>;
  /** Information to aid in pagination. */
  pageInfo: PaginationInfo;
};

export type PlmExternalMeterMapping = {
  __typename: 'PlmExternalMeterMapping';
  _id: Scalars['String'];
  meterId: Scalars['String'];
  modelChangeOperation?: Maybe<Scalars['String']>;
  modelType?: Maybe<Scalars['String']>;
  partner?: Maybe<PlmPartner>;
  partnerId: Scalars['String'];
  property?: Maybe<Property>;
  propertyId: Scalars['String'];
  providerAttributes?: Maybe<Scalars['JSON']>;
  updateDescription?: Maybe<Scalars['JSON']>;
  utility?: Maybe<PlmUtility>;
  vendor: Scalars['String'];
};

/** List of items with pagination. */
export type PlmExternalMeterMappingPaginatedPlmExternalMeterMappings = {
  __typename?: 'PlmExternalMeterMappingPaginatedPlmExternalMeterMappings';
  /** Total object count. */
  count?: Maybe<Scalars['Int']>;
  /** Array of objects. */
  items?: Maybe<Array<PlmExternalMeterMapping>>;
  /** Information to aid in pagination. */
  pageInfo: PaginationInfo;
};

export type PlmIngressEvent = {
  __typename: 'PlmIngressEvent';
  _id: Scalars['String'];
  headers?: Maybe<Scalars['JSON']>;
  lastError?: Maybe<Scalars['String']>;
  modelChangeOperation?: Maybe<Scalars['String']>;
  modelType?: Maybe<Scalars['String']>;
  plmEventId?: Maybe<Scalars['String']>;
  processedAt?: Maybe<Scalars['Float']>;
  rawPayload: Scalars['String'];
  receivedAt: Scalars['Float'];
  source: EnumPlmIngressEventSource;
  status: EnumPlmIngressEventStatus;
  updateDescription?: Maybe<Scalars['JSON']>;
  vendorKey: Scalars['String'];
};

/** List of items with pagination. */
export type PlmIngressEventPaginatedPlmIngressEvents = {
  __typename?: 'PlmIngressEventPaginatedPlmIngressEvents';
  /** Total object count. */
  count?: Maybe<Scalars['Int']>;
  /** Array of objects. */
  items?: Maybe<Array<PlmIngressEvent>>;
  /** Information to aid in pagination. */
  pageInfo: PaginationInfo;
};

export type PlmNotification = {
  __typename: 'PlmNotification';
  _id: Scalars['String'];
  activationTime: Scalars['Date'];
  contractId: Scalars['String'];
  deactivationTime: Scalars['Date'];
  modelChangeOperation?: Maybe<Scalars['String']>;
  modelType?: Maybe<Scalars['String']>;
  participationStatus: EnumPlmNotificationParticipationStatus;
  partnerId: Scalars['String'];
  payload: Scalars['String'];
  programId: Scalars['String'];
  receivedAt: Scalars['Date'];
  responseSentAt?: Maybe<Scalars['Date']>;
  source: EnumPlmNotificationSource;
  updateDescription?: Maybe<Scalars['JSON']>;
  /** Deprecated compatibility alias for partnerId. */
  utilityId: Scalars['String'];
};

/** List of items with pagination. */
export type PlmNotificationPaginatedPlmNotifications = {
  __typename?: 'PlmNotificationPaginatedPlmNotifications';
  /** Total object count. */
  count?: Maybe<Scalars['Int']>;
  /** Array of objects. */
  items?: Maybe<Array<PlmNotification>>;
  /** Information to aid in pagination. */
  pageInfo: PaginationInfo;
};

export type PlmPartner = {
  __typename: 'PlmPartner';
  _id: Scalars['String'];
  contact: PlmPartnerContact;
  contracts: Array<Maybe<PlmContract>>;
  description: Scalars['String'];
  hostedPrograms: Array<Maybe<PlmProgram>>;
  modelChangeOperation?: Maybe<Scalars['String']>;
  modelType?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  partnerType: EnumPlmPartnerPartnerType;
  programs: Array<Maybe<PlmProgram>>;
  updateDescription?: Maybe<Scalars['JSON']>;
};

export type PlmPartnerContractsArgs = {
  filter?: InputMaybe<FilterFindManyPlmContractInput>;
  limit?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<SortFindManyPlmContractInput>;
};

export type PlmPartnerHostedProgramsArgs = {
  filter?: InputMaybe<FilterFindManyPlmProgramInput>;
  limit?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<SortFindManyPlmProgramInput>;
};

export type PlmPartnerProgramsArgs = {
  filter?: InputMaybe<FilterFindManyPlmProgramInput>;
  limit?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<SortFindManyPlmProgramInput>;
};

export type PlmPartnerContact = {
  __typename?: 'PlmPartnerContact';
  email?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  phone?: Maybe<Scalars['String']>;
};

/** List of items with pagination. */
export type PlmPartnerPaginatedPlmPartners = {
  __typename?: 'PlmPartnerPaginatedPlmPartners';
  /** Total object count. */
  count?: Maybe<Scalars['Int']>;
  /** Array of objects. */
  items?: Maybe<Array<PlmPartner>>;
  /** Information to aid in pagination. */
  pageInfo: PaginationInfo;
};

export type PlmProgram = {
  __typename: 'PlmProgram';
  _id: Scalars['String'];
  endDate?: Maybe<Scalars['Float']>;
  events: Array<Maybe<PlmEvent>>;
  hostPartner?: Maybe<PlmPartner>;
  hostPartnerId?: Maybe<Scalars['String']>;
  hostUtility?: Maybe<PlmUtility>;
  /** Deprecated compatibility alias for hostPartnerId. */
  hostUtilityId?: Maybe<Scalars['String']>;
  incentiveDescription?: Maybe<Scalars['String']>;
  maximumEventDurationMinutes?: Maybe<Scalars['Float']>;
  maximumEventsPerSeason?: Maybe<Scalars['Float']>;
  maximumNotificationLeadTimeMinutes?: Maybe<Scalars['Float']>;
  measurementIntervalMinutes?: Maybe<Scalars['Float']>;
  minimumEventDurationMinutes?: Maybe<Scalars['Float']>;
  minimumEventsPerSeason?: Maybe<Scalars['Float']>;
  modelChangeOperation?: Maybe<Scalars['String']>;
  modelType?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  notificationLeadTimeMinutes?: Maybe<Scalars['Float']>;
  participationType: EnumPlmProgramParticipationType;
  partner?: Maybe<PlmPartner>;
  partnerId: Scalars['String'];
  programId: Scalars['String'];
  season: EnumPlmProgramSeason;
  startDate: Scalars['Float'];
  updateDescription?: Maybe<Scalars['JSON']>;
  utility?: Maybe<PlmUtility>;
  /** Deprecated compatibility alias for partnerId. */
  utilityId: Scalars['String'];
};

export type PlmProgramEventsArgs = {
  filter?: InputMaybe<FilterFindManyPlmEventInput>;
  limit?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<SortFindManyPlmEventInput>;
};

/** List of items with pagination. */
export type PlmProgramPaginatedPlmPrograms = {
  __typename?: 'PlmProgramPaginatedPlmPrograms';
  /** Total object count. */
  count?: Maybe<Scalars['Int']>;
  /** Array of objects. */
  items?: Maybe<Array<PlmProgram>>;
  /** Information to aid in pagination. */
  pageInfo: PaginationInfo;
};

export type PlmUtility = {
  __typename: 'PlmUtility';
  _id: Scalars['String'];
  contact: PlmUtilityContact;
  contracts: Array<Maybe<PlmContract>>;
  description: Scalars['String'];
  modelChangeOperation?: Maybe<Scalars['String']>;
  modelType?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  programs: Array<Maybe<PlmProgram>>;
  updateDescription?: Maybe<Scalars['JSON']>;
};

export type PlmUtilityContractsArgs = {
  filter?: InputMaybe<FilterFindManyPlmContractInput>;
  limit?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<SortFindManyPlmContractInput>;
};

export type PlmUtilityProgramsArgs = {
  filter?: InputMaybe<FilterFindManyPlmProgramInput>;
  limit?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<SortFindManyPlmProgramInput>;
};

export type PlmUtilityContact = {
  __typename?: 'PlmUtilityContact';
  email?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  phone?: Maybe<Scalars['String']>;
};

/** List of items with pagination. */
export type PlmUtilityPaginatedPlmUtilities = {
  __typename?: 'PlmUtilityPaginatedPlmUtilities';
  /** Total object count. */
  count?: Maybe<Scalars['Int']>;
  /** Array of objects. */
  items?: Maybe<Array<PlmUtility>>;
  /** Information to aid in pagination. */
  pageInfo: PaginationInfo;
};

export type PowerMonitor = DeviceInterface & {
  __typename: 'PowerMonitor';
  _id: Scalars['String'];
  alertTypes?: Maybe<DeviceAlertTypes>;
  chartTypes: Array<ChartType>;
  controlled?: Maybe<DeviceControlled>;
  dependentDeviceIds: Array<Maybe<Scalars['String']>>;
  deviceAlerts: Array<Maybe<Alert>>;
  deviceId?: Maybe<Scalars['String']>;
  deviceIdentifier?: Maybe<Scalars['String']>;
  deviceMetrics?: Maybe<Array<Maybe<DeviceMetric>>>;
  displayName?: Maybe<Scalars['String']>;
  frequency?: Maybe<PowerMonitorFrequency>;
  hasPendingUpdates: Scalars['Boolean'];
  installation?: Maybe<DeviceInstallation>;
  isConfigured?: Maybe<Scalars['Boolean']>;
  isControlled: Scalars['Boolean'];
  isPoweredOn?: Maybe<Scalars['Boolean']>;
  location?: Maybe<Scalars['String']>;
  meta?: Maybe<DeviceMeta>;
  modelChangeOperation?: Maybe<Scalars['String']>;
  modelType?: Maybe<Scalars['String']>;
  /** The name of the device */
  name?: Maybe<Scalars['String']>;
  panel?: Maybe<Panel>;
  panelId?: Maybe<Scalars['String']>;
  phaseAActiveEnergyFwd?: Maybe<PowerMonitorPhaseAActiveEnergyFwd>;
  phaseAActiveEnergyRev?: Maybe<PowerMonitorPhaseAActiveEnergyRev>;
  phaseAActivePower?: Maybe<PowerMonitorPhaseAActivePower>;
  phaseACurrent?: Maybe<PowerMonitorPhaseACurrent>;
  phaseAFrequency?: Maybe<PowerMonitorPhaseAFrequency>;
  phaseAPowerFactor?: Maybe<PowerMonitorPhaseAPowerFactor>;
  phaseAVoltage?: Maybe<PowerMonitorPhaseAVoltage>;
  phaseBActiveEnergyFwd?: Maybe<PowerMonitorPhaseBActiveEnergyFwd>;
  phaseBActiveEnergyRev?: Maybe<PowerMonitorPhaseBActiveEnergyRev>;
  phaseBActivePower?: Maybe<PowerMonitorPhaseBActivePower>;
  phaseBCurrent?: Maybe<PowerMonitorPhaseBCurrent>;
  phaseBFrequency?: Maybe<PowerMonitorPhaseBFrequency>;
  phaseBPowerFactor?: Maybe<PowerMonitorPhaseBPowerFactor>;
  phaseBVoltage?: Maybe<PowerMonitorPhaseBVoltage>;
  phaseCActiveEnergyFwd?: Maybe<PowerMonitorPhaseCActiveEnergyFwd>;
  phaseCActiveEnergyRev?: Maybe<PowerMonitorPhaseCActiveEnergyRev>;
  phaseCActivePower?: Maybe<PowerMonitorPhaseCActivePower>;
  phaseCCurrent?: Maybe<PowerMonitorPhaseCCurrent>;
  phaseCFrequency?: Maybe<PowerMonitorPhaseCFrequency>;
  phaseCPowerFactor?: Maybe<PowerMonitorPhaseCPowerFactor>;
  phaseCVoltage?: Maybe<PowerMonitorPhaseCVoltage>;
  powerState?: Maybe<DevicePowerState>;
  property?: Maybe<Property>;
  propertyId: Scalars['String'];
  source?: Maybe<Source>;
  sourceAlerts: Array<Maybe<Alert>>;
  sourceId?: Maybe<Scalars['String']>;
  supportsPhasedActiveEnergyFwd?: Maybe<Scalars['Boolean']>;
  supportsPhasedActiveEnergyRev?: Maybe<Scalars['Boolean']>;
  supportsPhasedActivePower?: Maybe<Scalars['Boolean']>;
  supportsPhasedFrequencies?: Maybe<Scalars['Boolean']>;
  supportsPhasedPowerFactors?: Maybe<Scalars['Boolean']>;
  supportsTotalActiveEnergyFwd?: Maybe<Scalars['Boolean']>;
  supportsTotalActiveEnergyRev?: Maybe<Scalars['Boolean']>;
  supportsTotalActivePower?: Maybe<Scalars['Boolean']>;
  supportsTotalFrequency?: Maybe<Scalars['Boolean']>;
  supportsTotalPowerFactor?: Maybe<Scalars['Boolean']>;
  threePhaseTotalActiveEnergyFwd?: Maybe<PowerMonitorThreePhaseTotalActiveEnergyFwd>;
  threePhaseTotalActiveEnergyRev?: Maybe<PowerMonitorThreePhaseTotalActiveEnergyRev>;
  timestamp?: Maybe<Scalars['Float']>;
  totalActivePower?: Maybe<PowerMonitorTotalActivePower>;
  totalPowerFactor?: Maybe<PowerMonitorTotalPowerFactor>;
  type?: Maybe<EnumDKeyDeviceType>;
  typeDisplayName: Scalars['String'];
  unit?: Maybe<Unit>;
  unitId: Scalars['String'];
  updateDescription?: Maybe<Scalars['JSON']>;
  updateStatus?: Maybe<Scalars['Boolean']>;
  vpp?: Maybe<VirtualPowerPlant>;
  vppId?: Maybe<Scalars['String']>;
  zone?: Maybe<Zone>;
  zoneId?: Maybe<Scalars['String']>;
};

export type PowerMonitorDeviceAlertsArgs = {
  filter?: InputMaybe<FilterFindManyAlertInput>;
  limit?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<SortFindManyAlertInput>;
};

export type PowerMonitorSourceAlertsArgs = {
  filter?: InputMaybe<FilterFindManyAlertInput>;
  limit?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<SortFindManyAlertInput>;
};

export type PowerMonitorFrequency = {
  __typename?: 'PowerMonitorFrequency';
  id?: Maybe<Scalars['String']>;
  observedAt?: Maybe<Scalars['Float']>;
  previousId?: Maybe<Scalars['String']>;
  timestamp?: Maybe<Scalars['Float']>;
  units?: Maybe<Scalars['String']>;
  updatePending?: Maybe<Scalars['Boolean']>;
  value?: Maybe<Scalars['Float']>;
};

export type PowerMonitorPhaseAActiveEnergyFwd = {
  __typename?: 'PowerMonitorPhaseAActiveEnergyFwd';
  id?: Maybe<Scalars['String']>;
  observedAt?: Maybe<Scalars['Float']>;
  previousId?: Maybe<Scalars['String']>;
  timestamp?: Maybe<Scalars['Float']>;
  units?: Maybe<Scalars['String']>;
  updatePending?: Maybe<Scalars['Boolean']>;
  value?: Maybe<Scalars['Float']>;
};

export type PowerMonitorPhaseAActiveEnergyRev = {
  __typename?: 'PowerMonitorPhaseAActiveEnergyRev';
  id?: Maybe<Scalars['String']>;
  observedAt?: Maybe<Scalars['Float']>;
  previousId?: Maybe<Scalars['String']>;
  timestamp?: Maybe<Scalars['Float']>;
  units?: Maybe<Scalars['String']>;
  updatePending?: Maybe<Scalars['Boolean']>;
  value?: Maybe<Scalars['Float']>;
};

export type PowerMonitorPhaseAActivePower = {
  __typename?: 'PowerMonitorPhaseAActivePower';
  id?: Maybe<Scalars['String']>;
  observedAt?: Maybe<Scalars['Float']>;
  previousId?: Maybe<Scalars['String']>;
  timestamp?: Maybe<Scalars['Float']>;
  units?: Maybe<Scalars['String']>;
  updatePending?: Maybe<Scalars['Boolean']>;
  value?: Maybe<Scalars['Float']>;
};

export type PowerMonitorPhaseACurrent = {
  __typename?: 'PowerMonitorPhaseACurrent';
  id?: Maybe<Scalars['String']>;
  observedAt?: Maybe<Scalars['Float']>;
  previousId?: Maybe<Scalars['String']>;
  timestamp?: Maybe<Scalars['Float']>;
  units?: Maybe<Scalars['String']>;
  updatePending?: Maybe<Scalars['Boolean']>;
  value?: Maybe<Scalars['Float']>;
};

export type PowerMonitorPhaseAFrequency = {
  __typename?: 'PowerMonitorPhaseAFrequency';
  id?: Maybe<Scalars['String']>;
  observedAt?: Maybe<Scalars['Float']>;
  previousId?: Maybe<Scalars['String']>;
  timestamp?: Maybe<Scalars['Float']>;
  units?: Maybe<Scalars['String']>;
  updatePending?: Maybe<Scalars['Boolean']>;
  value?: Maybe<Scalars['Float']>;
};

export type PowerMonitorPhaseAPowerFactor = {
  __typename?: 'PowerMonitorPhaseAPowerFactor';
  id?: Maybe<Scalars['String']>;
  observedAt?: Maybe<Scalars['Float']>;
  previousId?: Maybe<Scalars['String']>;
  timestamp?: Maybe<Scalars['Float']>;
  units?: Maybe<Scalars['String']>;
  updatePending?: Maybe<Scalars['Boolean']>;
  value?: Maybe<Scalars['Float']>;
};

export type PowerMonitorPhaseAVoltage = {
  __typename?: 'PowerMonitorPhaseAVoltage';
  id?: Maybe<Scalars['String']>;
  observedAt?: Maybe<Scalars['Float']>;
  previousId?: Maybe<Scalars['String']>;
  timestamp?: Maybe<Scalars['Float']>;
  units?: Maybe<Scalars['String']>;
  updatePending?: Maybe<Scalars['Boolean']>;
  value?: Maybe<Scalars['Float']>;
};

export type PowerMonitorPhaseBActiveEnergyFwd = {
  __typename?: 'PowerMonitorPhaseBActiveEnergyFwd';
  id?: Maybe<Scalars['String']>;
  observedAt?: Maybe<Scalars['Float']>;
  previousId?: Maybe<Scalars['String']>;
  timestamp?: Maybe<Scalars['Float']>;
  units?: Maybe<Scalars['String']>;
  updatePending?: Maybe<Scalars['Boolean']>;
  value?: Maybe<Scalars['Float']>;
};

export type PowerMonitorPhaseBActiveEnergyRev = {
  __typename?: 'PowerMonitorPhaseBActiveEnergyRev';
  id?: Maybe<Scalars['String']>;
  observedAt?: Maybe<Scalars['Float']>;
  previousId?: Maybe<Scalars['String']>;
  timestamp?: Maybe<Scalars['Float']>;
  units?: Maybe<Scalars['String']>;
  updatePending?: Maybe<Scalars['Boolean']>;
  value?: Maybe<Scalars['Float']>;
};

export type PowerMonitorPhaseBActivePower = {
  __typename?: 'PowerMonitorPhaseBActivePower';
  id?: Maybe<Scalars['String']>;
  observedAt?: Maybe<Scalars['Float']>;
  previousId?: Maybe<Scalars['String']>;
  timestamp?: Maybe<Scalars['Float']>;
  units?: Maybe<Scalars['String']>;
  updatePending?: Maybe<Scalars['Boolean']>;
  value?: Maybe<Scalars['Float']>;
};

export type PowerMonitorPhaseBCurrent = {
  __typename?: 'PowerMonitorPhaseBCurrent';
  id?: Maybe<Scalars['String']>;
  observedAt?: Maybe<Scalars['Float']>;
  previousId?: Maybe<Scalars['String']>;
  timestamp?: Maybe<Scalars['Float']>;
  units?: Maybe<Scalars['String']>;
  updatePending?: Maybe<Scalars['Boolean']>;
  value?: Maybe<Scalars['Float']>;
};

export type PowerMonitorPhaseBFrequency = {
  __typename?: 'PowerMonitorPhaseBFrequency';
  id?: Maybe<Scalars['String']>;
  observedAt?: Maybe<Scalars['Float']>;
  previousId?: Maybe<Scalars['String']>;
  timestamp?: Maybe<Scalars['Float']>;
  units?: Maybe<Scalars['String']>;
  updatePending?: Maybe<Scalars['Boolean']>;
  value?: Maybe<Scalars['Float']>;
};

export type PowerMonitorPhaseBPowerFactor = {
  __typename?: 'PowerMonitorPhaseBPowerFactor';
  id?: Maybe<Scalars['String']>;
  observedAt?: Maybe<Scalars['Float']>;
  previousId?: Maybe<Scalars['String']>;
  timestamp?: Maybe<Scalars['Float']>;
  units?: Maybe<Scalars['String']>;
  updatePending?: Maybe<Scalars['Boolean']>;
  value?: Maybe<Scalars['Float']>;
};

export type PowerMonitorPhaseBVoltage = {
  __typename?: 'PowerMonitorPhaseBVoltage';
  id?: Maybe<Scalars['String']>;
  observedAt?: Maybe<Scalars['Float']>;
  previousId?: Maybe<Scalars['String']>;
  timestamp?: Maybe<Scalars['Float']>;
  units?: Maybe<Scalars['String']>;
  updatePending?: Maybe<Scalars['Boolean']>;
  value?: Maybe<Scalars['Float']>;
};

export type PowerMonitorPhaseCActiveEnergyFwd = {
  __typename?: 'PowerMonitorPhaseCActiveEnergyFwd';
  id?: Maybe<Scalars['String']>;
  observedAt?: Maybe<Scalars['Float']>;
  previousId?: Maybe<Scalars['String']>;
  timestamp?: Maybe<Scalars['Float']>;
  units?: Maybe<Scalars['String']>;
  updatePending?: Maybe<Scalars['Boolean']>;
  value?: Maybe<Scalars['Float']>;
};

export type PowerMonitorPhaseCActiveEnergyRev = {
  __typename?: 'PowerMonitorPhaseCActiveEnergyRev';
  id?: Maybe<Scalars['String']>;
  observedAt?: Maybe<Scalars['Float']>;
  previousId?: Maybe<Scalars['String']>;
  timestamp?: Maybe<Scalars['Float']>;
  units?: Maybe<Scalars['String']>;
  updatePending?: Maybe<Scalars['Boolean']>;
  value?: Maybe<Scalars['Float']>;
};

export type PowerMonitorPhaseCActivePower = {
  __typename?: 'PowerMonitorPhaseCActivePower';
  id?: Maybe<Scalars['String']>;
  observedAt?: Maybe<Scalars['Float']>;
  previousId?: Maybe<Scalars['String']>;
  timestamp?: Maybe<Scalars['Float']>;
  units?: Maybe<Scalars['String']>;
  updatePending?: Maybe<Scalars['Boolean']>;
  value?: Maybe<Scalars['Float']>;
};

export type PowerMonitorPhaseCCurrent = {
  __typename?: 'PowerMonitorPhaseCCurrent';
  id?: Maybe<Scalars['String']>;
  observedAt?: Maybe<Scalars['Float']>;
  previousId?: Maybe<Scalars['String']>;
  timestamp?: Maybe<Scalars['Float']>;
  units?: Maybe<Scalars['String']>;
  updatePending?: Maybe<Scalars['Boolean']>;
  value?: Maybe<Scalars['Float']>;
};

export type PowerMonitorPhaseCFrequency = {
  __typename?: 'PowerMonitorPhaseCFrequency';
  id?: Maybe<Scalars['String']>;
  observedAt?: Maybe<Scalars['Float']>;
  previousId?: Maybe<Scalars['String']>;
  timestamp?: Maybe<Scalars['Float']>;
  units?: Maybe<Scalars['String']>;
  updatePending?: Maybe<Scalars['Boolean']>;
  value?: Maybe<Scalars['Float']>;
};

export type PowerMonitorPhaseCPowerFactor = {
  __typename?: 'PowerMonitorPhaseCPowerFactor';
  id?: Maybe<Scalars['String']>;
  observedAt?: Maybe<Scalars['Float']>;
  previousId?: Maybe<Scalars['String']>;
  timestamp?: Maybe<Scalars['Float']>;
  units?: Maybe<Scalars['String']>;
  updatePending?: Maybe<Scalars['Boolean']>;
  value?: Maybe<Scalars['Float']>;
};

export type PowerMonitorPhaseCVoltage = {
  __typename?: 'PowerMonitorPhaseCVoltage';
  id?: Maybe<Scalars['String']>;
  observedAt?: Maybe<Scalars['Float']>;
  previousId?: Maybe<Scalars['String']>;
  timestamp?: Maybe<Scalars['Float']>;
  units?: Maybe<Scalars['String']>;
  updatePending?: Maybe<Scalars['Boolean']>;
  value?: Maybe<Scalars['Float']>;
};

export type PowerMonitorThreePhaseTotalActiveEnergyFwd = {
  __typename?: 'PowerMonitorThreePhaseTotalActiveEnergyFwd';
  id?: Maybe<Scalars['String']>;
  observedAt?: Maybe<Scalars['Float']>;
  previousId?: Maybe<Scalars['String']>;
  timestamp?: Maybe<Scalars['Float']>;
  units?: Maybe<Scalars['String']>;
  updatePending?: Maybe<Scalars['Boolean']>;
  value?: Maybe<Scalars['Float']>;
};

export type PowerMonitorThreePhaseTotalActiveEnergyRev = {
  __typename?: 'PowerMonitorThreePhaseTotalActiveEnergyRev';
  id?: Maybe<Scalars['String']>;
  observedAt?: Maybe<Scalars['Float']>;
  previousId?: Maybe<Scalars['String']>;
  timestamp?: Maybe<Scalars['Float']>;
  units?: Maybe<Scalars['String']>;
  updatePending?: Maybe<Scalars['Boolean']>;
  value?: Maybe<Scalars['Float']>;
};

export type PowerMonitorTotalActivePower = {
  __typename?: 'PowerMonitorTotalActivePower';
  id?: Maybe<Scalars['String']>;
  observedAt?: Maybe<Scalars['Float']>;
  previousId?: Maybe<Scalars['String']>;
  timestamp?: Maybe<Scalars['Float']>;
  units?: Maybe<Scalars['String']>;
  updatePending?: Maybe<Scalars['Boolean']>;
  value?: Maybe<Scalars['Float']>;
};

export type PowerMonitorTotalPowerFactor = {
  __typename?: 'PowerMonitorTotalPowerFactor';
  id?: Maybe<Scalars['String']>;
  observedAt?: Maybe<Scalars['Float']>;
  previousId?: Maybe<Scalars['String']>;
  timestamp?: Maybe<Scalars['Float']>;
  units?: Maybe<Scalars['String']>;
  updatePending?: Maybe<Scalars['Boolean']>;
  value?: Maybe<Scalars['Float']>;
};

export type PressureSensor = DeviceInterface & {
  __typename: 'PressureSensor';
  _id: Scalars['String'];
  alertTypes?: Maybe<DeviceAlertTypes>;
  chartTypes: Array<ChartType>;
  controlled?: Maybe<DeviceControlled>;
  dependentDeviceIds: Array<Maybe<Scalars['String']>>;
  deviceAlerts: Array<Maybe<Alert>>;
  deviceId?: Maybe<Scalars['String']>;
  deviceIdentifier?: Maybe<Scalars['String']>;
  deviceMetrics?: Maybe<Array<Maybe<DeviceMetric>>>;
  displayName?: Maybe<Scalars['String']>;
  hasPendingUpdates: Scalars['Boolean'];
  hasPressure?: Maybe<Scalars['Boolean']>;
  installation?: Maybe<DeviceInstallation>;
  isConfigured?: Maybe<Scalars['Boolean']>;
  isControlled: Scalars['Boolean'];
  isPoweredOn?: Maybe<Scalars['Boolean']>;
  location?: Maybe<Scalars['String']>;
  meta?: Maybe<DeviceMeta>;
  modelChangeOperation?: Maybe<Scalars['String']>;
  modelType?: Maybe<Scalars['String']>;
  /** The name of the device */
  name?: Maybe<Scalars['String']>;
  panel?: Maybe<Panel>;
  panelId?: Maybe<Scalars['String']>;
  powerState?: Maybe<DevicePowerState>;
  pressure?: Maybe<PressureSensorPressure>;
  property?: Maybe<Property>;
  propertyId: Scalars['String'];
  role?: Maybe<Scalars['String']>;
  source?: Maybe<Source>;
  sourceAlerts: Array<Maybe<Alert>>;
  sourceId?: Maybe<Scalars['String']>;
  timestamp?: Maybe<Scalars['Float']>;
  type?: Maybe<EnumDKeyDeviceType>;
  typeDisplayName: Scalars['String'];
  unit?: Maybe<Unit>;
  unitId: Scalars['String'];
  updateDescription?: Maybe<Scalars['JSON']>;
  updateStatus?: Maybe<Scalars['Boolean']>;
  vpp?: Maybe<VirtualPowerPlant>;
  vppId?: Maybe<Scalars['String']>;
  zone?: Maybe<Zone>;
  zoneId?: Maybe<Scalars['String']>;
};

export type PressureSensorDeviceAlertsArgs = {
  filter?: InputMaybe<FilterFindManyAlertInput>;
  limit?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<SortFindManyAlertInput>;
};

export type PressureSensorSourceAlertsArgs = {
  filter?: InputMaybe<FilterFindManyAlertInput>;
  limit?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<SortFindManyAlertInput>;
};

export type PressureSensorPressure = {
  __typename?: 'PressureSensorPressure';
  id?: Maybe<Scalars['String']>;
  observedAt?: Maybe<Scalars['Float']>;
  previousId?: Maybe<Scalars['String']>;
  timestamp?: Maybe<Scalars['Float']>;
  units?: Maybe<Scalars['String']>;
  updatePending?: Maybe<Scalars['Boolean']>;
  value?: Maybe<Scalars['Float']>;
};

export type Property = {
  __typename: 'Property';
  _id: Scalars['String'];
  address: PropertyAddress;
  alertLimits?: Maybe<PropertyAlertLimits>;
  alertTriggers: Array<Maybe<AlertTrigger>>;
  alertTypes?: Maybe<PropertyAlertTypes>;
  alerts: Array<Maybe<Alert>>;
  assignableSetpointProfiles?: Maybe<Array<SetpointProfile>>;
  assignableZonePolicies?: Maybe<Array<ZonePolicy>>;
  authorizedUsers?: Maybe<Array<User>>;
  availableThermostatScheduleTemplates: Array<
    Maybe<ThermostatScheduleTemplate>
  >;
  buildings: Array<Maybe<Building>>;
  contact?: Maybe<PropertyContact>;
  controlGroups: Array<Maybe<ControlGroup>>;
  cuGroups?: Maybe<Array<Scalars['String']>>;
  devices: Array<DeviceInterface>;
  floorLabel?: Maybe<Scalars['String']>;
  floors: Array<Maybe<Floor>>;
  hasSecondaryHeatSource?: Maybe<Scalars['Boolean']>;
  imageUrl?: Maybe<Scalars['String']>;
  maintMgr?: Maybe<PropertyMaintMgr>;
  modelChangeOperation?: Maybe<Scalars['String']>;
  modelType?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  organization?: Maybe<Organization>;
  organizationId?: Maybe<Scalars['String']>;
  owner?: Maybe<PropertyOwner>;
  paginatedUnits?: Maybe<UnitPaginatedChildDataLoader>;
  panels: Array<Maybe<Panel>>;
  plmContracts: Array<Maybe<PlmContract>>;
  propMgr?: Maybe<PropertyPropMgr>;
  scheduledPlmResponses?: Maybe<Array<PlmEventResponse>>;
  setpointLimitProfile?: Maybe<SetpointProfile>;
  setpointProfileId?: Maybe<Scalars['String']>;
  sources: Array<SourceInterface>;
  systemNotifications?: Maybe<Array<SystemNotification>>;
  tempDisplayUnits?: Maybe<Scalars['String']>;
  thermostatScheduleTemplate?: Maybe<ThermostatScheduleTemplate>;
  thermostatScheduleTemplateId?: Maybe<Scalars['String']>;
  timestamp?: Maybe<Scalars['String']>;
  title: Scalars['String'];
  units: Array<Maybe<Unit>>;
  unitsSummary?: Maybe<PropertyUnitsSummary>;
  updateDescription?: Maybe<Scalars['JSON']>;
  zonePolicy?: Maybe<ZonePolicy>;
  zonePolicyId?: Maybe<Scalars['String']>;
  zones: Array<Maybe<Zone>>;
};

export type PropertyAlertTriggersArgs = {
  filter?: InputMaybe<FilterFindManyAlertTriggerInput>;
  limit?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<SortFindManyAlertTriggerInput>;
};

export type PropertyAlertsArgs = {
  filter?: InputMaybe<FilterFindManyAlertInput>;
  limit?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<SortFindManyAlertInput>;
};

export type PropertyAvailableThermostatScheduleTemplatesArgs = {
  filter?: InputMaybe<FilterFindManyThermostatScheduleTemplateInput>;
  limit?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<SortFindManyThermostatScheduleTemplateInput>;
};

export type PropertyBuildingsArgs = {
  filter?: InputMaybe<FilterFindManyBuildingInput>;
  limit?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<SortFindManyBuildingInput>;
};

export type PropertyControlGroupsArgs = {
  filter?: InputMaybe<FilterFindManyControlGroupInput>;
  limit?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<SortFindManyControlGroupInput>;
};

export type PropertyDevicesArgs = {
  filter?: InputMaybe<FilterFindManyDeviceInput>;
  limit?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<SortFindManyDeviceInput>;
};

export type PropertyFloorsArgs = {
  filter?: InputMaybe<FilterFindManyFloorInput>;
  limit?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<SortFindManyFloorInput>;
};

export type PropertyPaginatedUnitsArgs = {
  filter?: InputMaybe<FilterFindManyUnitInput>;
  page?: InputMaybe<Scalars['Int']>;
  perPage?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<SortFindManyUnitInput>;
};

export type PropertyPanelsArgs = {
  filter?: InputMaybe<FilterFindManyPanelInput>;
  limit?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<SortFindManyPanelInput>;
};

export type PropertyPlmContractsArgs = {
  filter?: InputMaybe<FilterFindManyPlmContractInput>;
  limit?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<SortFindManyPlmContractInput>;
};

export type PropertySourcesArgs = {
  filter?: InputMaybe<FilterFindManySourceInput>;
  limit?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<SortFindManySourceInput>;
};

export type PropertyUnitsArgs = {
  filter?: InputMaybe<FilterFindManyUnitInput>;
  limit?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<SortFindManyUnitInput>;
};

export type PropertyZonesArgs = {
  filter?: InputMaybe<FilterFindManyZoneInput>;
  limit?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<SortFindManyZoneInput>;
};

export type PropertyAddress = {
  __typename?: 'PropertyAddress';
  city?: Maybe<Scalars['String']>;
  line1: Scalars['String'];
  line2?: Maybe<Scalars['String']>;
  postalCode?: Maybe<Scalars['String']>;
  state?: Maybe<Scalars['String']>;
};

export type PropertyAlertLimits = {
  __typename?: 'PropertyAlertLimits';
  plant?: Maybe<PropertyAlertLimitsPlant>;
  units?: Maybe<PropertyAlertLimitsUnits>;
};

export type PropertyAlertLimitsPlant = {
  __typename?: 'PropertyAlertLimitsPlant';
  dhw?: Maybe<PropertyAlertLimitsPlantDhw>;
  loops?: Maybe<PropertyAlertLimitsPlantLoops>;
};

export type PropertyAlertLimitsPlantDhw = {
  __typename?: 'PropertyAlertLimitsPlantDhw';
  temperature?: Maybe<PropertyAlertLimitsPlantDhwTemperature>;
};

export type PropertyAlertLimitsPlantDhwTemperature = {
  __typename?: 'PropertyAlertLimitsPlantDhwTemperature';
  max?: Maybe<Scalars['Float']>;
  min?: Maybe<Scalars['Float']>;
};

export type PropertyAlertLimitsPlantLoops = {
  __typename?: 'PropertyAlertLimitsPlantLoops';
  pressure?: Maybe<PropertyAlertLimitsPlantLoopsPressure>;
  temperature?: Maybe<PropertyAlertLimitsPlantLoopsTemperature>;
};

export type PropertyAlertLimitsPlantLoopsPressure = {
  __typename?: 'PropertyAlertLimitsPlantLoopsPressure';
  max?: Maybe<Scalars['Float']>;
  min?: Maybe<Scalars['Float']>;
};

export type PropertyAlertLimitsPlantLoopsTemperature = {
  __typename?: 'PropertyAlertLimitsPlantLoopsTemperature';
  max?: Maybe<Scalars['Float']>;
  min?: Maybe<Scalars['Float']>;
};

export type PropertyAlertLimitsUnits = {
  __typename?: 'PropertyAlertLimitsUnits';
  humidity?: Maybe<PropertyAlertLimitsUnitsHumidity>;
  temperature?: Maybe<PropertyAlertLimitsUnitsTemperature>;
};

export type PropertyAlertLimitsUnitsHumidity = {
  __typename?: 'PropertyAlertLimitsUnitsHumidity';
  max?: Maybe<Scalars['Float']>;
  min?: Maybe<Scalars['Float']>;
};

export type PropertyAlertLimitsUnitsTemperature = {
  __typename?: 'PropertyAlertLimitsUnitsTemperature';
  max?: Maybe<Scalars['Float']>;
  min?: Maybe<Scalars['Float']>;
};

export type PropertyAlertTypes = {
  __typename?: 'PropertyAlertTypes';
  deviceAlert?: Maybe<Scalars['Boolean']>;
  deviceMetric?: Maybe<Scalars['Boolean']>;
  deviceOffline?: Maybe<Scalars['Boolean']>;
  equipmentAlarm?: Maybe<Scalars['Boolean']>;
  sourceOffline?: Maybe<Scalars['Boolean']>;
};

export type PropertyContact = {
  __typename?: 'PropertyContact';
  email?: Maybe<Scalars['String']>;
  email2?: Maybe<Scalars['String']>;
  email3?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  smsNumber?: Maybe<Scalars['String']>;
  smsNumber2?: Maybe<Scalars['String']>;
  smsNumber3?: Maybe<Scalars['String']>;
  smsOptInStatus1?: Maybe<EnumPropertyContactSmsOptInStatus1>;
  smsOptInStatus2?: Maybe<EnumPropertyContactSmsOptInStatus2>;
  smsOptInStatus3?: Maybe<EnumPropertyContactSmsOptInStatus3>;
  smsOptInTimestamp1?: Maybe<Scalars['Float']>;
  smsOptInTimestamp2?: Maybe<Scalars['Float']>;
  smsOptInTimestamp3?: Maybe<Scalars['Float']>;
};

export type PropertyMaintMgr = {
  __typename?: 'PropertyMaintMgr';
  email?: Maybe<Scalars['String']>;
  mobile?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
};

export type PropertyOwner = {
  __typename?: 'PropertyOwner';
  email?: Maybe<Scalars['String']>;
  mobile?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  phone?: Maybe<Scalars['String']>;
};

/** List of items with pagination. */
export type PropertyPaginatedProperties = {
  __typename?: 'PropertyPaginatedProperties';
  /** Total object count. */
  count?: Maybe<Scalars['Int']>;
  /** Array of objects. */
  items?: Maybe<Array<Property>>;
  /** Information to aid in pagination. */
  pageInfo: PaginationInfo;
};

export type PropertyPlmSummary = {
  __typename?: 'PropertyPlmSummary';
  activeCount: Scalars['Int'];
  firstActiveResponseId?: Maybe<Scalars['String']>;
  nextScheduledStart?: Maybe<Scalars['Float']>;
  propertyId: Scalars['String'];
  scheduledCount: Scalars['Int'];
};

export type PropertyPropMgr = {
  __typename?: 'PropertyPropMgr';
  email?: Maybe<Scalars['String']>;
  mobile?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  phone?: Maybe<Scalars['String']>;
};

export type PropertySummary = {
  __typename?: 'PropertySummary';
  alerts: PropertySummaryAlerts;
  devices: PropertySummaryDevices;
  propertyId: Scalars['String'];
  stats: PropertySummaryStats;
  units: PropertySummaryUnits;
};

export type PropertySummaryAlerts = {
  __typename?: 'PropertySummaryAlerts';
  activeAlertCount: Scalars['Int'];
  alerts: Array<PropertySummaryListItem>;
  propertyId: Scalars['String'];
  statusItems: Array<PropertySummaryListItem>;
};

export type PropertySummaryDevices = {
  __typename?: 'PropertySummaryDevices';
  centralDevices: Array<PropertySummaryListItem>;
  propertyId: Scalars['String'];
  residentialDevices: Array<PropertySummaryListItem>;
};

export type PropertySummaryListItem = {
  __typename?: 'PropertySummaryListItem';
  action?: Maybe<Scalars['String']>;
  color?: Maybe<Scalars['String']>;
  count: Scalars['Int'];
  group?: Maybe<Scalars['String']>;
  label: Scalars['String'];
  options?: Maybe<Array<Maybe<Scalars['String']>>>;
  total?: Maybe<Scalars['Int']>;
};

export type PropertySummaryStat = {
  __typename?: 'PropertySummaryStat';
  ave: Scalars['Float'];
  max: Scalars['Float'];
  min: Scalars['Float'];
};

export type PropertySummaryStats = {
  __typename?: 'PropertySummaryStats';
  humidity?: Maybe<PropertySummaryStat>;
  propertyId: Scalars['String'];
  temperature?: Maybe<PropertySummaryStat>;
};

export type PropertySummaryUnits = {
  __typename?: 'PropertySummaryUnits';
  propertyId: Scalars['String'];
  units: Array<PropertySummaryListItem>;
};

export type PropertyUnitsSummary = {
  __typename?: 'PropertyUnitsSummary';
  count: Scalars['Float'];
  majorAlerts: Scalars['Float'];
  minorAlerts: Scalars['Float'];
};

/** Counts of Mongo updates applied when sync was run with dryRun: false. */
export type PropertyZonePolicySyncApplied = {
  __typename?: 'PropertyZonePolicySyncApplied';
  policiesAddedToProperty: Scalars['Int'];
  zonePolicyIdsCleared: Scalars['Int'];
  zonesUpdated: Scalars['Int'];
};

/** Result of syncing a property with its cores (zone policies and zone–policy assignments). Core is source of truth. */
export type PropertyZonePolicySyncResult = {
  __typename?: 'PropertyZonePolicySyncResult';
  /** Present when dryRun was false; counts of Mongo updates. */
  applied?: Maybe<PropertyZonePolicySyncApplied>;
  coresProcessed: Scalars['Int'];
  coresWithErrors: Scalars['Int'];
  dryRun: Scalars['Boolean'];
  propertyId: Scalars['String'];
  /** Tabular summary of discrepancies and (if not dry run) applied changes. */
  reportTable: Scalars['String'];
  /** Detailed list of report rows (zone/policy discrepancies). */
  rows?: Maybe<Scalars['JSON']>;
};

export type QuarterlyReportDataExportSubmitInput = {
  endDate: Scalars['String'];
  propertyIds: Array<Scalars['String']>;
  startDate: Scalars['String'];
};

export type Query = {
  __typename?: 'Query';
  actuator?: Maybe<Actuator>;
  actuatorById?: Maybe<Actuator>;
  actuatorCount?: Maybe<Scalars['Int']>;
  actuators: Array<Actuator>;
  actuatorsByIds: Array<Actuator>;
  alert?: Maybe<Alert>;
  alertById?: Maybe<Alert>;
  alertCategories: Array<AlertCategory>;
  alertCategoriesByIds: Array<AlertCategory>;
  alertCategory?: Maybe<AlertCategory>;
  alertCategoryById?: Maybe<AlertCategory>;
  alertCategoryCount?: Maybe<Scalars['Int']>;
  alertCount?: Maybe<Scalars['Int']>;
  alertNotification?: Maybe<AlertNotification>;
  /** Find alertNotification by alertId. */
  alertNotificationByAlertId: Array<AlertNotification>;
  alertNotificationById?: Maybe<AlertNotification>;
  /** Find alertNotification by recipient (email or sms number). */
  alertNotificationByRecipient: Array<AlertNotification>;
  alertNotificationCount?: Maybe<Scalars['Int']>;
  alertNotifications: Array<AlertNotification>;
  alertNotificationsByIds: Array<AlertNotification>;
  alertOptOut?: Maybe<AlertOptOut>;
  alertOptOutById?: Maybe<AlertOptOut>;
  alertOptOutCount?: Maybe<Scalars['Int']>;
  alertOptOuts: Array<AlertOptOut>;
  alertOptOutsByIds: Array<AlertOptOut>;
  /** Find alertOptOut by recipient (email or SMS number). */
  alertOptOutsByRecipient: Array<AlertOptOut>;
  alertSubscription?: Maybe<AlertSubscription>;
  alertSubscriptionById?: Maybe<AlertSubscription>;
  alertSubscriptionCount?: Maybe<Scalars['Int']>;
  alertSubscriptions: Array<AlertSubscription>;
  alertSubscriptionsByIds: Array<AlertSubscription>;
  /** Find alert subscriptions associated with the supplied user id. */
  alertSubscriptionsByUserId: Array<AlertSubscription>;
  alertTrigger?: Maybe<AlertTrigger>;
  alertTriggerById?: Maybe<AlertTrigger>;
  alertTriggerCount?: Maybe<Scalars['Int']>;
  alertTriggers: Array<AlertTrigger>;
  alertTriggersByIds: Array<AlertTrigger>;
  /** Custom query matching subscription */
  alertTriggersByPropertyId: Array<AlertTrigger>;
  alerts: Array<Alert>;
  alertsByIds: Array<Alert>;
  /** Find alerts by property id. */
  alertsByPropertyId: Array<Alert>;
  /** Find alerts by unit id. */
  alertsByUnitId: Array<Alert>;
  application?: Maybe<Application>;
  authenticationProfile?: Maybe<AuthenticationProfile>;
  authenticationProfileById?: Maybe<AuthenticationProfile>;
  authenticationProfileCount?: Maybe<Scalars['Int']>;
  authenticationProfiles: Array<AuthenticationProfile>;
  authenticationProfilesByIds: Array<AuthenticationProfile>;
  authenticatorDevice?: Maybe<AuthenticatorDevice>;
  authenticatorDeviceById?: Maybe<AuthenticatorDevice>;
  authenticatorDeviceCount?: Maybe<Scalars['Int']>;
  authenticatorDevices: Array<AuthenticatorDevice>;
  authenticatorDevicesByIds: Array<AuthenticatorDevice>;
  authorizationProfile?: Maybe<AuthorizationProfile>;
  authorizationProfileById?: Maybe<AuthorizationProfile>;
  authorizationProfileCount?: Maybe<Scalars['Int']>;
  authorizationProfiles: Array<AuthorizationProfile>;
  authorizationProfilesByIds: Array<AuthorizationProfile>;
  bNG?: Maybe<Bng>;
  bNGById?: Maybe<Bng>;
  bNGCount?: Maybe<Scalars['Int']>;
  bNGs: Array<Bng>;
  bNGsByIds: Array<Bng>;
  batteryManagementSystem?: Maybe<BatteryManagementSystem>;
  batteryManagementSystemById?: Maybe<BatteryManagementSystem>;
  batteryManagementSystemCount?: Maybe<Scalars['Int']>;
  batteryManagementSystems: Array<BatteryManagementSystem>;
  batteryManagementSystemsByIds: Array<BatteryManagementSystem>;
  boiler?: Maybe<Boiler>;
  boilerById?: Maybe<Boiler>;
  boilerCount?: Maybe<Scalars['Int']>;
  boilers: Array<Boiler>;
  boilersByIds: Array<Boiler>;
  building?: Maybe<Building>;
  buildingById?: Maybe<Building>;
  buildingCount?: Maybe<Scalars['Int']>;
  buildings: Array<Building>;
  buildingsByIds: Array<Building>;
  /** Find building by property id. */
  buildingsByPropertyId: Array<Building>;
  chartData: Array<ChartData>;
  chiller?: Maybe<Chiller>;
  chillerById?: Maybe<Chiller>;
  chillerCount?: Maybe<Scalars['Int']>;
  chillers: Array<Chiller>;
  chillersByIds: Array<Chiller>;
  conductor?: Maybe<Conductor>;
  conductorById?: Maybe<Conductor>;
  conductorCommissioningDraft?: Maybe<ConductorCommissioningDraftView>;
  conductorCount?: Maybe<Scalars['Int']>;
  conductorDiscoveryRun?: Maybe<Scalars['JSON']>;
  conductorGenericSensor?: Maybe<ConductorGenericSensor>;
  conductorGenericSensorById?: Maybe<ConductorGenericSensor>;
  conductorGenericSensorCount?: Maybe<Scalars['Int']>;
  conductorGenericSensors: Array<ConductorGenericSensor>;
  conductorGenericSensorsByIds: Array<ConductorGenericSensor>;
  conductors: Array<Conductor>;
  conductorsByIds: Array<Conductor>;
  controlGroup?: Maybe<ControlGroup>;
  controlGroupById?: Maybe<ControlGroup>;
  controlGroupCount?: Maybe<Scalars['Int']>;
  controlGroups: Array<ControlGroup>;
  controlGroupsByIds: Array<ControlGroup>;
  controller?: Maybe<Controller>;
  controllerById?: Maybe<Controller>;
  controllerCount?: Maybe<Scalars['Int']>;
  controllers: Array<Controller>;
  controllersByIds: Array<Controller>;
  core?: Maybe<Core>;
  coreById?: Maybe<Core>;
  coreCount?: Maybe<Scalars['Int']>;
  cores: Array<Core>;
  coresByIds: Array<Core>;
  dataExportJob?: Maybe<DataExportJob>;
  dataExportJobById?: Maybe<DataExportJob>;
  dataExportJobCount?: Maybe<Scalars['Int']>;
  dataExportJobs: Array<DataExportJob>;
  dataExportJobsByIds: Array<DataExportJob>;
  device?: Maybe<DeviceInterface>;
  deviceById?: Maybe<DeviceInterface>;
  deviceCount?: Maybe<Scalars['Int']>;
  deviceReading?: Maybe<DeviceReading>;
  deviceReadingById?: Maybe<DeviceReading>;
  deviceReadingCount?: Maybe<Scalars['Int']>;
  deviceReadings: Array<DeviceReading>;
  /** Retrieves the device readings for all metrics for a given device */
  deviceReadingsByDeviceId?: Maybe<Array<HistoricReading>>;
  deviceReadingsByIds: Array<DeviceReading>;
  devices: Array<DeviceInterface>;
  devicesByIds: Array<DeviceInterface>;
  doorSensor?: Maybe<DoorSensor>;
  doorSensorById?: Maybe<DoorSensor>;
  doorSensorCount?: Maybe<Scalars['Int']>;
  doorSensors: Array<DoorSensor>;
  doorSensorsByIds: Array<DoorSensor>;
  dummyAggregateCategoricalChartSeries?: Maybe<
    Array<Maybe<AggregateCategoricalChartSeries>>
  >;
  dummyCategoricalChartSeries?: Maybe<Array<Maybe<CategoricalChartSeries>>>;
  dummyNumericChartSeries?: Maybe<Array<Maybe<NumericChartSeries>>>;
  energyConsumerBuilding?: Maybe<EnergyConsumerBuilding>;
  energyConsumerBuildingById?: Maybe<EnergyConsumerBuilding>;
  energyConsumerBuildingCount?: Maybe<Scalars['Int']>;
  energyConsumerBuildings: Array<EnergyConsumerBuilding>;
  energyConsumerBuildingsByIds: Array<EnergyConsumerBuilding>;
  energyConsumerTenant?: Maybe<EnergyConsumerTenant>;
  energyConsumerTenantById?: Maybe<EnergyConsumerTenant>;
  energyConsumerTenantCount?: Maybe<Scalars['Int']>;
  energyConsumerTenants: Array<EnergyConsumerTenant>;
  energyConsumerTenantsByIds: Array<EnergyConsumerTenant>;
  energyConsumerUtilities: Array<EnergyConsumerUtility>;
  energyConsumerUtilitiesByIds: Array<EnergyConsumerUtility>;
  energyConsumerUtility?: Maybe<EnergyConsumerUtility>;
  energyConsumerUtilityById?: Maybe<EnergyConsumerUtility>;
  energyConsumerUtilityCount?: Maybe<Scalars['Int']>;
  energyController?: Maybe<EnergyController>;
  energyControllerById?: Maybe<EnergyController>;
  energyControllerCount?: Maybe<Scalars['Int']>;
  energyControllers: Array<EnergyController>;
  energyControllersByIds: Array<EnergyController>;
  energyConverter?: Maybe<EnergyConverter>;
  energyConverterById?: Maybe<EnergyConverter>;
  energyConverterCount?: Maybe<Scalars['Int']>;
  energyConverters: Array<EnergyConverter>;
  energyConvertersByIds: Array<EnergyConverter>;
  energyInverter?: Maybe<EnergyInverter>;
  energyInverterById?: Maybe<EnergyInverter>;
  energyInverterCount?: Maybe<Scalars['Int']>;
  energyInverters: Array<EnergyInverter>;
  energyInvertersByIds: Array<EnergyInverter>;
  energyMeter?: Maybe<EnergyMeter>;
  energyMeterById?: Maybe<EnergyMeter>;
  energyMeterCount?: Maybe<Scalars['Int']>;
  energyMeters: Array<EnergyMeter>;
  energyMetersByIds: Array<EnergyMeter>;
  energyRectifier?: Maybe<EnergyRectifier>;
  energyRectifierById?: Maybe<EnergyRectifier>;
  energyRectifierCount?: Maybe<Scalars['Int']>;
  energyRectifiers: Array<EnergyRectifier>;
  energyRectifiersByIds: Array<EnergyRectifier>;
  energyStorageBatterySystem?: Maybe<EnergyStorageBatterySystem>;
  energyStorageBatterySystemById?: Maybe<EnergyStorageBatterySystem>;
  energyStorageBatterySystemCount?: Maybe<Scalars['Int']>;
  energyStorageBatterySystems: Array<EnergyStorageBatterySystem>;
  energyStorageBatterySystemsByIds: Array<EnergyStorageBatterySystem>;
  energyStorageCoolingSystem?: Maybe<EnergyStorageCoolingSystem>;
  energyStorageCoolingSystemById?: Maybe<EnergyStorageCoolingSystem>;
  energyStorageCoolingSystemCount?: Maybe<Scalars['Int']>;
  energyStorageCoolingSystems: Array<EnergyStorageCoolingSystem>;
  energyStorageCoolingSystemsByIds: Array<EnergyStorageCoolingSystem>;
  energyStorageKineticSystem?: Maybe<EnergyStorageKineticSystem>;
  energyStorageKineticSystemById?: Maybe<EnergyStorageKineticSystem>;
  energyStorageKineticSystemCount?: Maybe<Scalars['Int']>;
  energyStorageKineticSystems: Array<EnergyStorageKineticSystem>;
  energyStorageKineticSystemsByIds: Array<EnergyStorageKineticSystem>;
  energySupplierSolarSystem?: Maybe<EnergySupplierSolarSystem>;
  energySupplierSolarSystemById?: Maybe<EnergySupplierSolarSystem>;
  energySupplierSolarSystemCount?: Maybe<Scalars['Int']>;
  energySupplierSolarSystems: Array<EnergySupplierSolarSystem>;
  energySupplierSolarSystemsByIds: Array<EnergySupplierSolarSystem>;
  energySupplierUtilities: Array<EnergySupplierUtility>;
  energySupplierUtilitiesByIds: Array<EnergySupplierUtility>;
  energySupplierUtility?: Maybe<EnergySupplierUtility>;
  energySupplierUtilityById?: Maybe<EnergySupplierUtility>;
  energySupplierUtilityCount?: Maybe<Scalars['Int']>;
  energySupplierWindSystem?: Maybe<EnergySupplierWindSystem>;
  energySupplierWindSystemById?: Maybe<EnergySupplierWindSystem>;
  energySupplierWindSystemCount?: Maybe<Scalars['Int']>;
  energySupplierWindSystems: Array<EnergySupplierWindSystem>;
  energySupplierWindSystemsByIds: Array<EnergySupplierWindSystem>;
  energySwitchPanel?: Maybe<EnergySwitchPanel>;
  energySwitchPanelById?: Maybe<EnergySwitchPanel>;
  energySwitchPanelCircuit?: Maybe<EnergySwitchPanelCircuit>;
  energySwitchPanelCircuitById?: Maybe<EnergySwitchPanelCircuit>;
  energySwitchPanelCircuitCount?: Maybe<Scalars['Int']>;
  energySwitchPanelCircuits: Array<EnergySwitchPanelCircuit>;
  energySwitchPanelCircuitsByIds: Array<EnergySwitchPanelCircuit>;
  energySwitchPanelCount?: Maybe<Scalars['Int']>;
  energySwitchPanels: Array<EnergySwitchPanel>;
  energySwitchPanelsByIds: Array<EnergySwitchPanel>;
  entitySubscribers?: Maybe<Scalars['JSONObject']>;
  executeTieredEntitySelection?: Maybe<Scalars['JSON']>;
  fireSuppressionSystem?: Maybe<FireSuppressionSystem>;
  fireSuppressionSystemById?: Maybe<FireSuppressionSystem>;
  fireSuppressionSystemCount?: Maybe<Scalars['Int']>;
  fireSuppressionSystems: Array<FireSuppressionSystem>;
  fireSuppressionSystemsByIds: Array<FireSuppressionSystem>;
  floor?: Maybe<Floor>;
  floorById?: Maybe<Floor>;
  floorCount?: Maybe<Scalars['Int']>;
  floors: Array<Floor>;
  floorsByIds: Array<Floor>;
  gPIO?: Maybe<Gpio>;
  gPIOById?: Maybe<Gpio>;
  gPIOCount?: Maybe<Scalars['Int']>;
  gPIOs: Array<Gpio>;
  gPIOsByIds: Array<Gpio>;
  /**
   * Called by client to obtain most stringent set of setpoint limits used for the tstats in these properties. This single set of conservative limits is used to restrict the setpoints that can be bulk configured on all the tstats in these properties.
   * This is reasonable, because when setting setpoints in Bulk TStat Configuration the user is setting a starting value, which should be a conservatively reasonable value, probably in the middle of most limit ranges.
   */
  getBulkSetpointLimits?: Maybe<SetpointLimits>;
  /** Get upload url and other info required to upload property ingestion spreadsheets to AWS S3 */
  getIngestionUploadInfo?: Maybe<IngestionUploadInfo>;
  hMM?: Maybe<Hmm>;
  hMMById?: Maybe<Hmm>;
  hMMCount?: Maybe<Scalars['Int']>;
  hMMs: Array<Hmm>;
  hMMsByIds: Array<Hmm>;
  historicAlert?: Maybe<HistoricAlert>;
  historicAlertById?: Maybe<HistoricAlert>;
  historicAlertCount?: Maybe<Scalars['Int']>;
  historicAlerts: Array<HistoricAlert>;
  historicAlertsByIds: Array<HistoricAlert>;
  historicReading?: Maybe<HistoricReading>;
  historicReadingById?: Maybe<HistoricReading>;
  historicReadingCount?: Maybe<Scalars['Int']>;
  historicReadings: Array<HistoricReading>;
  /** Custom query matching subscription */
  historicReadingsByDeviceId: Array<HistoricReading>;
  historicReadingsByIds: Array<HistoricReading>;
  indoorAirHandler?: Maybe<IndoorAirHandler>;
  indoorAirHandlerById?: Maybe<IndoorAirHandler>;
  indoorAirHandlerCount?: Maybe<Scalars['Int']>;
  indoorAirHandlers: Array<IndoorAirHandler>;
  indoorAirHandlersByIds: Array<IndoorAirHandler>;
  indoorSensor?: Maybe<IndoorSensor>;
  indoorSensorById?: Maybe<IndoorSensor>;
  indoorSensorCount?: Maybe<Scalars['Int']>;
  indoorSensors: Array<IndoorSensor>;
  indoorSensorsByIds: Array<IndoorSensor>;
  ingestion?: Maybe<Ingestion>;
  ingestionById?: Maybe<Ingestion>;
  ingestionCount?: Maybe<Scalars['Int']>;
  ingestions: Array<Ingestion>;
  ingestionsByIds: Array<Ingestion>;
  kineticEnergyManagementSystem?: Maybe<KineticEnergyManagementSystem>;
  kineticEnergyManagementSystemById?: Maybe<KineticEnergyManagementSystem>;
  kineticEnergyManagementSystemCount?: Maybe<Scalars['Int']>;
  kineticEnergyManagementSystems: Array<KineticEnergyManagementSystem>;
  kineticEnergyManagementSystemsByIds: Array<KineticEnergyManagementSystem>;
  leakDetector?: Maybe<LeakDetector>;
  leakDetectorById?: Maybe<LeakDetector>;
  leakDetectorCount?: Maybe<Scalars['Int']>;
  leakDetectors: Array<LeakDetector>;
  leakDetectorsByIds: Array<LeakDetector>;
  loop?: Maybe<Loop>;
  loopById?: Maybe<Loop>;
  loopCount?: Maybe<Scalars['Int']>;
  loops: Array<Loop>;
  loopsByIds: Array<Loop>;
  modbusAirHandler?: Maybe<ModbusAirHandler>;
  modbusAirHandlerById?: Maybe<ModbusAirHandler>;
  modbusAirHandlerCount?: Maybe<Scalars['Int']>;
  modbusAirHandlers: Array<ModbusAirHandler>;
  modbusAirHandlersByIds: Array<ModbusAirHandler>;
  oauthAccessToken?: Maybe<OauthAccessToken>;
  oauthAccessTokenById?: Maybe<OauthAccessToken>;
  oauthAccessTokenCount?: Maybe<Scalars['Int']>;
  oauthAccessTokens: Array<OauthAccessToken>;
  oauthAccessTokensByIds: Array<OauthAccessToken>;
  oauthAuthCode?: Maybe<OauthAuthCode>;
  oauthAuthCodeById?: Maybe<OauthAuthCode>;
  oauthAuthCodeCount?: Maybe<Scalars['Int']>;
  oauthAuthCodes: Array<OauthAuthCode>;
  oauthAuthCodesByIds: Array<OauthAuthCode>;
  oauthClient?: Maybe<OauthClient>;
  oauthClientById?: Maybe<OauthClient>;
  oauthClientCount?: Maybe<Scalars['Int']>;
  oauthClients: Array<OauthClient>;
  oauthClientsByIds: Array<OauthClient>;
  occupancySensor?: Maybe<OccupancySensor>;
  occupancySensorById?: Maybe<OccupancySensor>;
  occupancySensorCount?: Maybe<Scalars['Int']>;
  occupancySensors: Array<OccupancySensor>;
  occupancySensorsByIds: Array<OccupancySensor>;
  openWeather?: Maybe<OpenWeather>;
  openWeatherById?: Maybe<OpenWeather>;
  openWeatherCount?: Maybe<Scalars['Int']>;
  openWeathers: Array<OpenWeather>;
  openWeathersByIds: Array<OpenWeather>;
  organization?: Maybe<Organization>;
  organizationById?: Maybe<Organization>;
  organizationCount?: Maybe<Scalars['Int']>;
  organizations: Array<Organization>;
  organizationsByIds: Array<Organization>;
  outdoorSensor?: Maybe<OutdoorSensor>;
  outdoorSensorById?: Maybe<OutdoorSensor>;
  outdoorSensorCount?: Maybe<Scalars['Int']>;
  outdoorSensors: Array<OutdoorSensor>;
  outdoorSensorsByIds: Array<OutdoorSensor>;
  paginatedAlertCategories?: Maybe<AlertCategoryPaginatedAlertCategories>;
  paginatedAlertNotifications?: Maybe<AlertNotificationPaginatedAlertNotifications>;
  paginatedAlertOptOuts?: Maybe<AlertOptOutPaginatedAlertOptOuts>;
  paginatedAlertSubscriptions?: Maybe<AlertSubscriptionPaginatedAlertSubscriptions>;
  paginatedAlertTriggers?: Maybe<AlertTriggerPaginatedAlertTriggers>;
  paginatedAlerts?: Maybe<AlertPaginatedAlerts>;
  paginatedAuthenticationProfiles?: Maybe<AuthenticationProfilePaginatedAuthenticationProfiles>;
  paginatedAuthenticatorDevices?: Maybe<AuthenticatorDevicePaginatedAuthenticatorDevices>;
  paginatedAuthorizationProfiles?: Maybe<AuthorizationProfilePaginatedAuthorizationProfiles>;
  paginatedBuildings?: Maybe<BuildingPaginatedBuildings>;
  paginatedControlGroups?: Maybe<ControlGroupPaginatedControlGroups>;
  paginatedDataExportJobs?: Maybe<DataExportJobPaginatedDataExportJobs>;
  paginatedDeviceReadings?: Maybe<DeviceReadingPaginatedDeviceReadings>;
  paginatedEnergyConsumerBuildings?: Maybe<EnergyConsumerBuildingPaginatedEnergyConsumerBuildings>;
  paginatedEnergyConsumerTenants?: Maybe<EnergyConsumerTenantPaginatedEnergyConsumerTenants>;
  paginatedEnergyConsumerUtilities?: Maybe<EnergyConsumerUtilityPaginatedEnergyConsumerUtilities>;
  paginatedEnergyStorageBatterySystems?: Maybe<EnergyStorageBatterySystemPaginatedEnergyStorageBatterySystems>;
  paginatedEnergyStorageKineticSystems?: Maybe<EnergyStorageKineticSystemPaginatedEnergyStorageKineticSystems>;
  paginatedEnergySupplierSolarSystems?: Maybe<EnergySupplierSolarSystemPaginatedEnergySupplierSolarSystems>;
  paginatedEnergySupplierUtilities?: Maybe<EnergySupplierUtilityPaginatedEnergySupplierUtilities>;
  paginatedEnergySupplierWindSystems?: Maybe<EnergySupplierWindSystemPaginatedEnergySupplierWindSystems>;
  paginatedFloors?: Maybe<FloorPaginatedFloors>;
  paginatedHistoricAlerts?: Maybe<HistoricAlertPaginatedHistoricAlerts>;
  paginatedHistoricReadings?: Maybe<HistoricReadingPaginatedHistoricReadings>;
  paginatedIngestions?: Maybe<IngestionPaginatedIngestions>;
  paginatedOauthAccessTokens?: Maybe<OauthAccessTokenPaginatedOauthAccessTokens>;
  paginatedOauthAuthCodes?: Maybe<OauthAuthCodePaginatedOauthAuthCodes>;
  paginatedOauthClients?: Maybe<OauthClientPaginatedOauthClients>;
  paginatedOrganizations?: Maybe<OrganizationPaginatedOrganizations>;
  paginatedPanels?: Maybe<PanelPaginatedPanels>;
  paginatedPlmContracts?: Maybe<PlmContractPaginatedPlmContracts>;
  paginatedPlmCurtailmentActions?: Maybe<PlmCurtailmentActionPaginatedPlmCurtailmentActions>;
  paginatedPlmCurtailmentPlans?: Maybe<PlmCurtailmentPlanPaginatedPlmCurtailmentPlans>;
  paginatedPlmCurtailmentTasks?: Maybe<PlmCurtailmentTaskPaginatedPlmCurtailmentTasks>;
  paginatedPlmEventResponses?: Maybe<PlmEventResponsePaginatedPlmEventResponses>;
  paginatedPlmEvents?: Maybe<PlmEventPaginatedPlmEvents>;
  paginatedPlmExternalMeterMappings?: Maybe<PlmExternalMeterMappingPaginatedPlmExternalMeterMappings>;
  paginatedPlmIngressEvents?: Maybe<PlmIngressEventPaginatedPlmIngressEvents>;
  paginatedPlmNotifications?: Maybe<PlmNotificationPaginatedPlmNotifications>;
  paginatedPlmPartners?: Maybe<PlmPartnerPaginatedPlmPartners>;
  paginatedPlmPrograms?: Maybe<PlmProgramPaginatedPlmPrograms>;
  paginatedPlmUtilities?: Maybe<PlmUtilityPaginatedPlmUtilities>;
  paginatedProperties?: Maybe<PropertyPaginatedProperties>;
  paginatedScheduledTasks?: Maybe<ScheduledTaskPaginatedScheduledTasks>;
  paginatedSetpointProfiles?: Maybe<SetpointProfilePaginatedSetpointProfiles>;
  paginatedSystemNotifications?: Maybe<SystemNotificationPaginatedSystemNotifications>;
  paginatedThermostatScheduleProfiles?: Maybe<ThermostatScheduleProfilePaginatedThermostatScheduleProfiles>;
  paginatedThermostatScheduleTemplates?: Maybe<ThermostatScheduleTemplatePaginatedThermostatScheduleTemplates>;
  paginatedUnits?: Maybe<UnitPaginatedUnits>;
  paginatedUserHistories?: Maybe<UserHistoryPaginatedUserHistories>;
  paginatedUsers?: Maybe<UserPaginatedUsers>;
  paginatedVirtualPowerPlants?: Maybe<VirtualPowerPlantPaginatedVirtualPowerPlants>;
  paginatedZonePolicies?: Maybe<ZonePolicyPaginatedZonePolicies>;
  paginatedZones?: Maybe<ZonePaginatedZones>;
  panel?: Maybe<Panel>;
  panelById?: Maybe<Panel>;
  panelCount?: Maybe<Scalars['Int']>;
  panels: Array<Panel>;
  panelsByIds: Array<Panel>;
  plmContract?: Maybe<PlmContract>;
  plmContractById?: Maybe<PlmContract>;
  plmContractCount?: Maybe<Scalars['Int']>;
  plmContracts: Array<PlmContract>;
  plmContractsByIds: Array<PlmContract>;
  plmCurtailmentAction?: Maybe<PlmCurtailmentAction>;
  plmCurtailmentActionById?: Maybe<PlmCurtailmentAction>;
  plmCurtailmentActionCount?: Maybe<Scalars['Int']>;
  plmCurtailmentActions: Array<PlmCurtailmentAction>;
  plmCurtailmentActionsByIds: Array<PlmCurtailmentAction>;
  plmCurtailmentPlan?: Maybe<PlmCurtailmentPlan>;
  plmCurtailmentPlanById?: Maybe<PlmCurtailmentPlan>;
  plmCurtailmentPlanCount?: Maybe<Scalars['Int']>;
  plmCurtailmentPlans: Array<PlmCurtailmentPlan>;
  plmCurtailmentPlansByIds: Array<PlmCurtailmentPlan>;
  plmCurtailmentTask?: Maybe<PlmCurtailmentTask>;
  plmCurtailmentTaskById?: Maybe<PlmCurtailmentTask>;
  plmCurtailmentTaskCount?: Maybe<Scalars['Int']>;
  plmCurtailmentTasks: Array<PlmCurtailmentTask>;
  /** Find curtailment tasks by actionId. */
  plmCurtailmentTasksByActionId: Array<PlmCurtailmentTask>;
  plmCurtailmentTasksByIds: Array<PlmCurtailmentTask>;
  /** Get all PLM curtailment tasks for a specific property */
  plmCurtailmentTasksByProperty?: Maybe<Array<Maybe<PlmCurtailmentTask>>>;
  /** Find curtailment tasks by propertyId. */
  plmCurtailmentTasksByPropertyId: Array<PlmCurtailmentTask>;
  /** Find curtailment tasks by responseId. */
  plmCurtailmentTasksByResponseId: Array<PlmCurtailmentTask>;
  /** Get all PLM curtailment tasks for a specific device */
  plmCurtailmentTasksForDevice?: Maybe<Array<Maybe<PlmCurtailmentTask>>>;
  plmEvent?: Maybe<PlmEvent>;
  plmEventById?: Maybe<PlmEvent>;
  plmEventCount?: Maybe<Scalars['Int']>;
  plmEventResponse?: Maybe<PlmEventResponse>;
  plmEventResponseById?: Maybe<PlmEventResponse>;
  plmEventResponseCount?: Maybe<Scalars['Int']>;
  plmEventResponses: Array<PlmEventResponse>;
  plmEventResponsesByIds: Array<PlmEventResponse>;
  plmEvents: Array<PlmEvent>;
  plmEventsByIds: Array<PlmEvent>;
  plmExternalMeterMapping?: Maybe<PlmExternalMeterMapping>;
  plmExternalMeterMappingById?: Maybe<PlmExternalMeterMapping>;
  plmExternalMeterMappingCount?: Maybe<Scalars['Int']>;
  plmExternalMeterMappings: Array<PlmExternalMeterMapping>;
  plmExternalMeterMappingsByIds: Array<PlmExternalMeterMapping>;
  plmIngressEvent?: Maybe<PlmIngressEvent>;
  plmIngressEventById?: Maybe<PlmIngressEvent>;
  plmIngressEventCount?: Maybe<Scalars['Int']>;
  plmIngressEvents: Array<PlmIngressEvent>;
  plmIngressEventsByIds: Array<PlmIngressEvent>;
  plmNotification?: Maybe<PlmNotification>;
  plmNotificationById?: Maybe<PlmNotification>;
  plmNotificationCount?: Maybe<Scalars['Int']>;
  plmNotifications: Array<PlmNotification>;
  plmNotificationsByIds: Array<PlmNotification>;
  plmPartner?: Maybe<PlmPartner>;
  plmPartnerById?: Maybe<PlmPartner>;
  plmPartnerCount?: Maybe<Scalars['Int']>;
  plmPartners: Array<PlmPartner>;
  plmPartnersByIds: Array<PlmPartner>;
  plmProgram?: Maybe<PlmProgram>;
  plmProgramById?: Maybe<PlmProgram>;
  plmProgramCount?: Maybe<Scalars['Int']>;
  plmPrograms: Array<PlmProgram>;
  plmProgramsByIds: Array<PlmProgram>;
  plmUtilities: Array<PlmUtility>;
  plmUtilitiesByIds: Array<PlmUtility>;
  plmUtility?: Maybe<PlmUtility>;
  plmUtilityById?: Maybe<PlmUtility>;
  plmUtilityCount?: Maybe<Scalars['Int']>;
  powerMonitor?: Maybe<PowerMonitor>;
  powerMonitorById?: Maybe<PowerMonitor>;
  powerMonitorCount?: Maybe<Scalars['Int']>;
  powerMonitors: Array<PowerMonitor>;
  powerMonitorsByIds: Array<PowerMonitor>;
  pressureSensor?: Maybe<PressureSensor>;
  pressureSensorById?: Maybe<PressureSensor>;
  pressureSensorCount?: Maybe<Scalars['Int']>;
  pressureSensors: Array<PressureSensor>;
  pressureSensorsByIds: Array<PressureSensor>;
  properties: Array<Property>;
  propertiesByIds: Array<Property>;
  property?: Maybe<Property>;
  propertyById?: Maybe<Property>;
  propertyCount?: Maybe<Scalars['Int']>;
  propertyPlmSummaries: Array<PropertyPlmSummary>;
  propertySummary?: Maybe<PropertySummary>;
  propertySummaryAlerts?: Maybe<PropertySummaryAlerts>;
  propertySummaryDevices?: Maybe<PropertySummaryDevices>;
  propertySummaryStats?: Maybe<PropertySummaryStats>;
  propertySummaryUnits?: Maybe<PropertySummaryUnits>;
  /** Create a signed S3 URL for a completed export job. */
  quarterlyReportDataExportJobDownloadUrl: Scalars['String'];
  /** List quarterly reports data export jobs for the current user. */
  quarterlyReportDataExportJobs: Array<DataExportJob>;
  queryableFields?: Maybe<Scalars['JSON']>;
  queryableRelatedTypes?: Maybe<Scalars['JSON']>;
  relayDevice?: Maybe<RelayDevice>;
  relayDeviceById?: Maybe<RelayDevice>;
  relayDeviceCount?: Maybe<Scalars['Int']>;
  relayDevices: Array<RelayDevice>;
  relayDevicesByIds: Array<RelayDevice>;
  /** Retrieve the SMS number for the user to use in resetting their SMS opt-in status. */
  retrieveSmsNumber?: Maybe<Scalars['String']>;
  /** Get scheduled notifications based on user authorization and entity access */
  scheduledNotifications: Array<SystemNotification>;
  scheduledTask?: Maybe<ScheduledTask>;
  /** Get a specific scheduled task by ID */
  scheduledTaskById?: Maybe<ScheduledTask>;
  scheduledTaskCount?: Maybe<Scalars['Int']>;
  /** Get scheduled tasks with optional filtering */
  scheduledTasks: Array<ScheduledTask>;
  scheduledTasksByIds: Array<ScheduledTask>;
  setpointProfile?: Maybe<SetpointProfile>;
  setpointProfileById?: Maybe<SetpointProfile>;
  setpointProfileCount?: Maybe<Scalars['Int']>;
  /** Verify bulk config */
  setpointProfileUpdateVerification?: Maybe<SetpointProfileUpdateVerificationData>;
  setpointProfiles: Array<SetpointProfile>;
  setpointProfilesByIds: Array<SetpointProfile>;
  smartPowerOutlet?: Maybe<SmartPowerOutlet>;
  smartPowerOutletById?: Maybe<SmartPowerOutlet>;
  smartPowerOutletCount?: Maybe<Scalars['Int']>;
  smartPowerOutlets: Array<SmartPowerOutlet>;
  smartPowerOutletsByIds: Array<SmartPowerOutlet>;
  solarManagementSystem?: Maybe<SolarManagementSystem>;
  solarManagementSystemById?: Maybe<SolarManagementSystem>;
  solarManagementSystemCount?: Maybe<Scalars['Int']>;
  solarManagementSystems: Array<SolarManagementSystem>;
  solarManagementSystemsByIds: Array<SolarManagementSystem>;
  source?: Maybe<SourceInterface>;
  sourceById?: Maybe<SourceInterface>;
  sourceCount?: Maybe<Scalars['Int']>;
  sources: Array<SourceInterface>;
  sourcesByIds: Array<SourceInterface>;
  /** Sync MongoDB with Core(s) for a property: fetch zone policies and zones from each core, compare with Mongo, and optionally apply updates so Mongo matches Core (Core is source of truth). Use dryRun: true for a report only. */
  syncPropertyZonePoliciesFromCores?: Maybe<PropertyZonePolicySyncResult>;
  systemNotification?: Maybe<SystemNotification>;
  systemNotificationById?: Maybe<SystemNotification>;
  systemNotificationCount?: Maybe<Scalars['Int']>;
  systemNotifications: Array<SystemNotification>;
  systemNotificationsByIds: Array<SystemNotification>;
  thermistor?: Maybe<Thermistor>;
  thermistorById?: Maybe<Thermistor>;
  thermistorCount?: Maybe<Scalars['Int']>;
  thermistors: Array<Thermistor>;
  thermistorsByIds: Array<Thermistor>;
  thermostat?: Maybe<Thermostat>;
  thermostatById?: Maybe<Thermostat>;
  thermostatCount?: Maybe<Scalars['Int']>;
  thermostatScheduleProfile?: Maybe<ThermostatScheduleProfile>;
  thermostatScheduleProfileById?: Maybe<ThermostatScheduleProfile>;
  thermostatScheduleProfileCount?: Maybe<Scalars['Int']>;
  thermostatScheduleProfiles: Array<ThermostatScheduleProfile>;
  thermostatScheduleProfilesByIds: Array<ThermostatScheduleProfile>;
  thermostatScheduleTemplate?: Maybe<ThermostatScheduleTemplate>;
  thermostatScheduleTemplateById?: Maybe<ThermostatScheduleTemplate>;
  thermostatScheduleTemplateCount?: Maybe<Scalars['Int']>;
  /** Verify thermostat schedule template bulk edit */
  thermostatScheduleTemplateEditVerification?: Maybe<ThermostatScheduleTemplateEditVerificationData>;
  /** Verify thermostat schedule template bulk update */
  thermostatScheduleTemplateUpdateVerification?: Maybe<ThermostatScheduleTemplateUpdateVerificationData>;
  thermostatScheduleTemplates: Array<ThermostatScheduleTemplate>;
  thermostatScheduleTemplatesByIds: Array<ThermostatScheduleTemplate>;
  thermostats: Array<Thermostat>;
  thermostatsByIds: Array<Thermostat>;
  unit?: Maybe<Unit>;
  unitById?: Maybe<Unit>;
  unitCount?: Maybe<Scalars['Int']>;
  units: Array<Unit>;
  unitsByIds: Array<Unit>;
  /** Custom query matching subscription */
  unitsByPropertyId: Array<Unit>;
  user?: Maybe<User>;
  userAbilities: UserAbilities;
  userById?: Maybe<User>;
  userCount?: Maybe<Scalars['Int']>;
  /** Returns the navigation history for the requesting user on the current device. The device is identified by the edgeDeviceId carried in the request context. */
  userDeviceHistory?: Maybe<UserHistory>;
  userHistories: Array<UserHistory>;
  userHistoriesByIds: Array<UserHistory>;
  userHistory?: Maybe<UserHistory>;
  userHistoryById?: Maybe<UserHistory>;
  userHistoryCount?: Maybe<Scalars['Int']>;
  users: Array<User>;
  usersByIds: Array<User>;
  vSDPump?: Maybe<VsdPump>;
  vSDPumpById?: Maybe<VsdPump>;
  vSDPumpCount?: Maybe<Scalars['Int']>;
  vSDPumps: Array<VsdPump>;
  vSDPumpsByIds: Array<VsdPump>;
  virtualPowerPlant?: Maybe<VirtualPowerPlant>;
  virtualPowerPlantById?: Maybe<VirtualPowerPlant>;
  virtualPowerPlantCount?: Maybe<Scalars['Int']>;
  virtualPowerPlants: Array<VirtualPowerPlant>;
  virtualPowerPlantsByIds: Array<VirtualPowerPlant>;
  windManagementSystem?: Maybe<WindManagementSystem>;
  windManagementSystemById?: Maybe<WindManagementSystem>;
  windManagementSystemCount?: Maybe<Scalars['Int']>;
  windManagementSystems: Array<WindManagementSystem>;
  windManagementSystemsByIds: Array<WindManagementSystem>;
  windowSensor?: Maybe<WindowSensor>;
  windowSensorById?: Maybe<WindowSensor>;
  windowSensorCount?: Maybe<Scalars['Int']>;
  windowSensors: Array<WindowSensor>;
  windowSensorsByIds: Array<WindowSensor>;
  z210Pump?: Maybe<Z210Pump>;
  z210PumpById?: Maybe<Z210Pump>;
  z210PumpCount?: Maybe<Scalars['Int']>;
  z210Pumps: Array<Z210Pump>;
  z210PumpsByIds: Array<Z210Pump>;
  zone?: Maybe<Zone>;
  zoneById?: Maybe<Zone>;
  zoneCount?: Maybe<Scalars['Int']>;
  zonePolicies: Array<ZonePolicy>;
  zonePoliciesByIds: Array<ZonePolicy>;
  zonePolicy?: Maybe<ZonePolicy>;
  zonePolicyById?: Maybe<ZonePolicy>;
  zonePolicyCount?: Maybe<Scalars['Int']>;
  /** Verify bulk Zone Policy Update */
  zonePolicyUpdateVerification?: Maybe<ZonePolicyUpdateVerificationData>;
  zones: Array<Zone>;
  zonesByIds: Array<Zone>;
};

export type QueryActuatorArgs = {
  filter?: InputMaybe<FilterFindOneActuatorInput>;
  skip?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<SortFindOneActuatorInput>;
};

export type QueryActuatorByIdArgs = {
  _id: Scalars['String'];
};

export type QueryActuatorCountArgs = {
  filter?: InputMaybe<FilterCountActuatorInput>;
};

export type QueryActuatorsArgs = {
  filter?: InputMaybe<FilterFindManyActuatorInput>;
  limit?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<SortFindManyActuatorInput>;
};

export type QueryActuatorsByIdsArgs = {
  _ids: Array<Scalars['String']>;
  limit?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<SortFindByIdsActuatorInput>;
};

export type QueryAlertArgs = {
  filter?: InputMaybe<FilterFindOneAlertInput>;
  skip?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<SortFindOneAlertInput>;
};

export type QueryAlertByIdArgs = {
  _id: Scalars['String'];
};

export type QueryAlertCategoriesArgs = {
  filter?: InputMaybe<FilterFindManyAlertCategoryInput>;
  limit?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<SortFindManyAlertCategoryInput>;
};

export type QueryAlertCategoriesByIdsArgs = {
  _ids: Array<Scalars['String']>;
  limit?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<SortFindByIdsAlertCategoryInput>;
};

export type QueryAlertCategoryArgs = {
  filter?: InputMaybe<FilterFindOneAlertCategoryInput>;
  skip?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<SortFindOneAlertCategoryInput>;
};

export type QueryAlertCategoryByIdArgs = {
  _id: Scalars['String'];
};

export type QueryAlertCategoryCountArgs = {
  filter?: InputMaybe<FilterCountAlertCategoryInput>;
};

export type QueryAlertCountArgs = {
  filter?: InputMaybe<FilterCountAlertInput>;
};

export type QueryAlertNotificationArgs = {
  filter?: InputMaybe<FilterFindOneAlertNotificationInput>;
  skip?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<SortFindOneAlertNotificationInput>;
};

export type QueryAlertNotificationByAlertIdArgs = {
  alertId: Scalars['String'];
  filter?: InputMaybe<FilteralertNotificationByAlertId>;
  limit?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<SortFindManyAlertNotificationInput>;
};

export type QueryAlertNotificationByIdArgs = {
  _id: Scalars['String'];
};

export type QueryAlertNotificationByRecipientArgs = {
  filter?: InputMaybe<FilteralertNotificationByRecipient>;
  limit?: InputMaybe<Scalars['Int']>;
  recipient: Scalars['String'];
  skip?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<SortFindManyAlertNotificationInput>;
};

export type QueryAlertNotificationCountArgs = {
  filter?: InputMaybe<FilterCountAlertNotificationInput>;
};

export type QueryAlertNotificationsArgs = {
  filter?: InputMaybe<FilterFindManyAlertNotificationInput>;
  limit?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<SortFindManyAlertNotificationInput>;
};

export type QueryAlertNotificationsByIdsArgs = {
  _ids: Array<Scalars['String']>;
  limit?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<SortFindByIdsAlertNotificationInput>;
};

export type QueryAlertOptOutArgs = {
  filter?: InputMaybe<FilterFindOneAlertOptOutInput>;
  skip?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<SortFindOneAlertOptOutInput>;
};

export type QueryAlertOptOutByIdArgs = {
  _id: Scalars['String'];
};

export type QueryAlertOptOutCountArgs = {
  filter?: InputMaybe<FilterCountAlertOptOutInput>;
};

export type QueryAlertOptOutsArgs = {
  filter?: InputMaybe<FilterFindManyAlertOptOutInput>;
  limit?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<SortFindManyAlertOptOutInput>;
};

export type QueryAlertOptOutsByIdsArgs = {
  _ids: Array<Scalars['String']>;
  limit?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<SortFindByIdsAlertOptOutInput>;
};

export type QueryAlertOptOutsByRecipientArgs = {
  filter?: InputMaybe<FilteralertOptOutsByRecipient>;
  limit?: InputMaybe<Scalars['Int']>;
  recipient: Scalars['String'];
  skip?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<SortFindManyAlertOptOutInput>;
};

export type QueryAlertSubscriptionArgs = {
  filter?: InputMaybe<FilterFindOneAlertSubscriptionInput>;
  skip?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<SortFindOneAlertSubscriptionInput>;
};

export type QueryAlertSubscriptionByIdArgs = {
  _id: Scalars['String'];
};

export type QueryAlertSubscriptionCountArgs = {
  filter?: InputMaybe<FilterCountAlertSubscriptionInput>;
};

export type QueryAlertSubscriptionsArgs = {
  filter?: InputMaybe<FilterFindManyAlertSubscriptionInput>;
  limit?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<SortFindManyAlertSubscriptionInput>;
};

export type QueryAlertSubscriptionsByIdsArgs = {
  _ids: Array<Scalars['String']>;
  limit?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<SortFindByIdsAlertSubscriptionInput>;
};

export type QueryAlertSubscriptionsByUserIdArgs = {
  filter?: InputMaybe<FilteralertSubscriptionsByUserId>;
  limit?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<SortFindManyAlertSubscriptionInput>;
  userId: Scalars['String'];
};

export type QueryAlertTriggerArgs = {
  filter?: InputMaybe<FilterFindOneAlertTriggerInput>;
  skip?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<SortFindOneAlertTriggerInput>;
};

export type QueryAlertTriggerByIdArgs = {
  _id: Scalars['String'];
};

export type QueryAlertTriggerCountArgs = {
  filter?: InputMaybe<FilterCountAlertTriggerInput>;
};

export type QueryAlertTriggersArgs = {
  filter?: InputMaybe<FilterFindManyAlertTriggerInput>;
  limit?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<SortFindManyAlertTriggerInput>;
};

export type QueryAlertTriggersByIdsArgs = {
  _ids: Array<Scalars['String']>;
  limit?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<SortFindByIdsAlertTriggerInput>;
};

export type QueryAlertTriggersByPropertyIdArgs = {
  propertyId?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type QueryAlertsArgs = {
  filter?: InputMaybe<FilterFindManyAlertInput>;
  limit?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<SortFindManyAlertInput>;
};

export type QueryAlertsByIdsArgs = {
  _ids: Array<Scalars['String']>;
  limit?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<SortFindByIdsAlertInput>;
};

export type QueryAlertsByPropertyIdArgs = {
  filter?: InputMaybe<FilteralertsByPropertyId>;
  limit?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<SortFindManyAlertInput>;
};

export type QueryAlertsByUnitIdArgs = {
  filter?: InputMaybe<FilteralertsByUnitId>;
  limit?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<SortFindManyAlertInput>;
  unitId?: InputMaybe<Scalars['String']>;
};

export type QueryApplicationArgs = {
  filter?: InputMaybe<FilterApplicationInput>;
};

export type QueryAuthenticationProfileArgs = {
  filter?: InputMaybe<FilterFindOneAuthenticationProfileInput>;
  skip?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<SortFindOneAuthenticationProfileInput>;
};

export type QueryAuthenticationProfileByIdArgs = {
  _id: Scalars['String'];
};

export type QueryAuthenticationProfileCountArgs = {
  filter?: InputMaybe<FilterCountAuthenticationProfileInput>;
};

export type QueryAuthenticationProfilesArgs = {
  filter?: InputMaybe<FilterFindManyAuthenticationProfileInput>;
  limit?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<SortFindManyAuthenticationProfileInput>;
};

export type QueryAuthenticationProfilesByIdsArgs = {
  _ids: Array<Scalars['String']>;
  limit?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<SortFindByIdsAuthenticationProfileInput>;
};

export type QueryAuthenticatorDeviceArgs = {
  filter?: InputMaybe<FilterFindOneAuthenticatorDeviceInput>;
  skip?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<SortFindOneAuthenticatorDeviceInput>;
};

export type QueryAuthenticatorDeviceByIdArgs = {
  _id: Scalars['String'];
};

export type QueryAuthenticatorDeviceCountArgs = {
  filter?: InputMaybe<FilterCountAuthenticatorDeviceInput>;
};

export type QueryAuthenticatorDevicesArgs = {
  filter?: InputMaybe<FilterFindManyAuthenticatorDeviceInput>;
  limit?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<SortFindManyAuthenticatorDeviceInput>;
};

export type QueryAuthenticatorDevicesByIdsArgs = {
  _ids: Array<Scalars['String']>;
  limit?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<SortFindByIdsAuthenticatorDeviceInput>;
};

export type QueryAuthorizationProfileArgs = {
  filter?: InputMaybe<FilterFindOneAuthorizationProfileInput>;
  skip?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<SortFindOneAuthorizationProfileInput>;
};

export type QueryAuthorizationProfileByIdArgs = {
  _id: Scalars['String'];
};

export type QueryAuthorizationProfileCountArgs = {
  filter?: InputMaybe<FilterCountAuthorizationProfileInput>;
};

export type QueryAuthorizationProfilesArgs = {
  filter?: InputMaybe<FilterFindManyAuthorizationProfileInput>;
  limit?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<SortFindManyAuthorizationProfileInput>;
};

export type QueryAuthorizationProfilesByIdsArgs = {
  _ids: Array<Scalars['String']>;
  limit?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<SortFindByIdsAuthorizationProfileInput>;
};

export type QueryBNgArgs = {
  filter?: InputMaybe<FilterFindOneBngInput>;
  skip?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<SortFindOneBngInput>;
};

export type QueryBNgByIdArgs = {
  _id: Scalars['String'];
};

export type QueryBNgCountArgs = {
  filter?: InputMaybe<FilterCountBngInput>;
};

export type QueryBnGsArgs = {
  filter?: InputMaybe<FilterFindManyBngInput>;
  limit?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<SortFindManyBngInput>;
};

export type QueryBnGsByIdsArgs = {
  _ids: Array<Scalars['String']>;
  limit?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<SortFindByIdsBngInput>;
};

export type QueryBatteryManagementSystemArgs = {
  filter?: InputMaybe<FilterFindOneBatteryManagementSystemInput>;
  skip?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<SortFindOneBatteryManagementSystemInput>;
};

export type QueryBatteryManagementSystemByIdArgs = {
  _id: Scalars['String'];
};

export type QueryBatteryManagementSystemCountArgs = {
  filter?: InputMaybe<FilterCountBatteryManagementSystemInput>;
};

export type QueryBatteryManagementSystemsArgs = {
  filter?: InputMaybe<FilterFindManyBatteryManagementSystemInput>;
  limit?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<SortFindManyBatteryManagementSystemInput>;
};

export type QueryBatteryManagementSystemsByIdsArgs = {
  _ids: Array<Scalars['String']>;
  limit?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<SortFindByIdsBatteryManagementSystemInput>;
};

export type QueryBoilerArgs = {
  filter?: InputMaybe<FilterFindOneBoilerInput>;
  skip?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<SortFindOneBoilerInput>;
};

export type QueryBoilerByIdArgs = {
  _id: Scalars['String'];
};

export type QueryBoilerCountArgs = {
  filter?: InputMaybe<FilterCountBoilerInput>;
};

export type QueryBoilersArgs = {
  filter?: InputMaybe<FilterFindManyBoilerInput>;
  limit?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<SortFindManyBoilerInput>;
};

export type QueryBoilersByIdsArgs = {
  _ids: Array<Scalars['String']>;
  limit?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<SortFindByIdsBoilerInput>;
};

export type QueryBuildingArgs = {
  filter?: InputMaybe<FilterFindOneBuildingInput>;
  skip?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<SortFindOneBuildingInput>;
};

export type QueryBuildingByIdArgs = {
  _id: Scalars['String'];
};

export type QueryBuildingCountArgs = {
  filter?: InputMaybe<FilterCountBuildingInput>;
};

export type QueryBuildingsArgs = {
  filter?: InputMaybe<FilterFindManyBuildingInput>;
  limit?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<SortFindManyBuildingInput>;
};

export type QueryBuildingsByIdsArgs = {
  _ids: Array<Scalars['String']>;
  limit?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<SortFindByIdsBuildingInput>;
};

export type QueryBuildingsByPropertyIdArgs = {
  filter?: InputMaybe<FilterbuildingsByPropertyId>;
  limit?: InputMaybe<Scalars['Int']>;
  propertyId: Scalars['String'];
  skip?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<SortFindManyBuildingInput>;
};

export type QueryChartDataArgs = {
  chartTypes: Array<ChartType>;
  deviceIds: Array<Scalars['String']>;
  endDate: Scalars['String'];
  startDate: Scalars['String'];
};

export type QueryChillerArgs = {
  filter?: InputMaybe<FilterFindOneChillerInput>;
  skip?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<SortFindOneChillerInput>;
};

export type QueryChillerByIdArgs = {
  _id: Scalars['String'];
};

export type QueryChillerCountArgs = {
  filter?: InputMaybe<FilterCountChillerInput>;
};

export type QueryChillersArgs = {
  filter?: InputMaybe<FilterFindManyChillerInput>;
  limit?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<SortFindManyChillerInput>;
};

export type QueryChillersByIdsArgs = {
  _ids: Array<Scalars['String']>;
  limit?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<SortFindByIdsChillerInput>;
};

export type QueryConductorArgs = {
  filter?: InputMaybe<FilterFindOneConductorInput>;
  skip?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<SortFindOneConductorInput>;
};

export type QueryConductorByIdArgs = {
  _id: Scalars['String'];
};

export type QueryConductorCommissioningDraftArgs = {
  runId?: InputMaybe<Scalars['String']>;
  sourceId: Scalars['String'];
};

export type QueryConductorCountArgs = {
  filter?: InputMaybe<FilterCountConductorInput>;
};

export type QueryConductorDiscoveryRunArgs = {
  runId?: InputMaybe<Scalars['String']>;
  sourceId: Scalars['String'];
};

export type QueryConductorGenericSensorArgs = {
  filter?: InputMaybe<FilterFindOneConductorGenericSensorInput>;
  skip?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<SortFindOneConductorGenericSensorInput>;
};

export type QueryConductorGenericSensorByIdArgs = {
  _id: Scalars['String'];
};

export type QueryConductorGenericSensorCountArgs = {
  filter?: InputMaybe<FilterCountConductorGenericSensorInput>;
};

export type QueryConductorGenericSensorsArgs = {
  filter?: InputMaybe<FilterFindManyConductorGenericSensorInput>;
  limit?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<SortFindManyConductorGenericSensorInput>;
};

export type QueryConductorGenericSensorsByIdsArgs = {
  _ids: Array<Scalars['String']>;
  limit?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<SortFindByIdsConductorGenericSensorInput>;
};

export type QueryConductorsArgs = {
  filter?: InputMaybe<FilterFindManyConductorInput>;
  limit?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<SortFindManyConductorInput>;
};

export type QueryConductorsByIdsArgs = {
  _ids: Array<Scalars['String']>;
  limit?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<SortFindByIdsConductorInput>;
};

export type QueryControlGroupArgs = {
  filter?: InputMaybe<FilterFindOneControlGroupInput>;
  skip?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<SortFindOneControlGroupInput>;
};

export type QueryControlGroupByIdArgs = {
  _id: Scalars['String'];
};

export type QueryControlGroupCountArgs = {
  filter?: InputMaybe<FilterCountControlGroupInput>;
};

export type QueryControlGroupsArgs = {
  filter?: InputMaybe<FilterFindManyControlGroupInput>;
  limit?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<SortFindManyControlGroupInput>;
};

export type QueryControlGroupsByIdsArgs = {
  _ids: Array<Scalars['String']>;
  limit?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<SortFindByIdsControlGroupInput>;
};

export type QueryControllerArgs = {
  filter?: InputMaybe<FilterFindOneControllerInput>;
  skip?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<SortFindOneControllerInput>;
};

export type QueryControllerByIdArgs = {
  _id: Scalars['String'];
};

export type QueryControllerCountArgs = {
  filter?: InputMaybe<FilterCountControllerInput>;
};

export type QueryControllersArgs = {
  filter?: InputMaybe<FilterFindManyControllerInput>;
  limit?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<SortFindManyControllerInput>;
};

export type QueryControllersByIdsArgs = {
  _ids: Array<Scalars['String']>;
  limit?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<SortFindByIdsControllerInput>;
};

export type QueryCoreArgs = {
  filter?: InputMaybe<FilterFindOneCoreInput>;
  skip?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<SortFindOneCoreInput>;
};

export type QueryCoreByIdArgs = {
  _id: Scalars['String'];
};

export type QueryCoreCountArgs = {
  filter?: InputMaybe<FilterCountCoreInput>;
};

export type QueryCoresArgs = {
  filter?: InputMaybe<FilterFindManyCoreInput>;
  limit?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<SortFindManyCoreInput>;
};

export type QueryCoresByIdsArgs = {
  _ids: Array<Scalars['String']>;
  limit?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<SortFindByIdsCoreInput>;
};

export type QueryDataExportJobArgs = {
  filter?: InputMaybe<FilterFindOneDataExportJobInput>;
  skip?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<SortFindOneDataExportJobInput>;
};

export type QueryDataExportJobByIdArgs = {
  _id: Scalars['String'];
};

export type QueryDataExportJobCountArgs = {
  filter?: InputMaybe<FilterCountDataExportJobInput>;
};

export type QueryDataExportJobsArgs = {
  filter?: InputMaybe<FilterFindManyDataExportJobInput>;
  limit?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<SortFindManyDataExportJobInput>;
};

export type QueryDataExportJobsByIdsArgs = {
  _ids: Array<Scalars['String']>;
  limit?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<SortFindByIdsDataExportJobInput>;
};

export type QueryDeviceArgs = {
  filter?: InputMaybe<FilterFindOneDeviceInput>;
  skip?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<SortFindOneDeviceInput>;
};

export type QueryDeviceByIdArgs = {
  _id: Scalars['String'];
};

export type QueryDeviceCountArgs = {
  filter?: InputMaybe<FilterCountDeviceInput>;
};

export type QueryDeviceReadingArgs = {
  filter?: InputMaybe<FilterFindOneDeviceReadingInput>;
  skip?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<SortFindOneDeviceReadingInput>;
};

export type QueryDeviceReadingByIdArgs = {
  _id: Scalars['String'];
};

export type QueryDeviceReadingCountArgs = {
  filter?: InputMaybe<FilterCountDeviceReadingInput>;
};

export type QueryDeviceReadingsArgs = {
  filter?: InputMaybe<FilterFindManyDeviceReadingInput>;
  limit?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<SortFindManyDeviceReadingInput>;
};

export type QueryDeviceReadingsByDeviceIdArgs = {
  unitId: Scalars['String'];
};

export type QueryDeviceReadingsByIdsArgs = {
  _ids: Array<Scalars['String']>;
  limit?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<SortFindByIdsDeviceReadingInput>;
};

export type QueryDevicesArgs = {
  filter?: InputMaybe<FilterFindManyDeviceInput>;
  limit?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<SortFindManyDeviceInput>;
};

export type QueryDevicesByIdsArgs = {
  _ids: Array<Scalars['String']>;
  limit?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<SortFindByIdsDeviceInput>;
};

export type QueryDoorSensorArgs = {
  filter?: InputMaybe<FilterFindOneDoorSensorInput>;
  skip?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<SortFindOneDoorSensorInput>;
};

export type QueryDoorSensorByIdArgs = {
  _id: Scalars['String'];
};

export type QueryDoorSensorCountArgs = {
  filter?: InputMaybe<FilterCountDoorSensorInput>;
};

export type QueryDoorSensorsArgs = {
  filter?: InputMaybe<FilterFindManyDoorSensorInput>;
  limit?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<SortFindManyDoorSensorInput>;
};

export type QueryDoorSensorsByIdsArgs = {
  _ids: Array<Scalars['String']>;
  limit?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<SortFindByIdsDoorSensorInput>;
};

export type QueryEnergyConsumerBuildingArgs = {
  filter?: InputMaybe<FilterFindOneEnergyConsumerBuildingInput>;
  skip?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<SortFindOneEnergyConsumerBuildingInput>;
};

export type QueryEnergyConsumerBuildingByIdArgs = {
  _id: Scalars['String'];
};

export type QueryEnergyConsumerBuildingCountArgs = {
  filter?: InputMaybe<FilterCountEnergyConsumerBuildingInput>;
};

export type QueryEnergyConsumerBuildingsArgs = {
  filter?: InputMaybe<FilterFindManyEnergyConsumerBuildingInput>;
  limit?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<SortFindManyEnergyConsumerBuildingInput>;
};

export type QueryEnergyConsumerBuildingsByIdsArgs = {
  _ids: Array<Scalars['String']>;
  limit?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<SortFindByIdsEnergyConsumerBuildingInput>;
};

export type QueryEnergyConsumerTenantArgs = {
  filter?: InputMaybe<FilterFindOneEnergyConsumerTenantInput>;
  skip?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<SortFindOneEnergyConsumerTenantInput>;
};

export type QueryEnergyConsumerTenantByIdArgs = {
  _id: Scalars['String'];
};

export type QueryEnergyConsumerTenantCountArgs = {
  filter?: InputMaybe<FilterCountEnergyConsumerTenantInput>;
};

export type QueryEnergyConsumerTenantsArgs = {
  filter?: InputMaybe<FilterFindManyEnergyConsumerTenantInput>;
  limit?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<SortFindManyEnergyConsumerTenantInput>;
};

export type QueryEnergyConsumerTenantsByIdsArgs = {
  _ids: Array<Scalars['String']>;
  limit?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<SortFindByIdsEnergyConsumerTenantInput>;
};

export type QueryEnergyConsumerUtilitiesArgs = {
  filter?: InputMaybe<FilterFindManyEnergyConsumerUtilityInput>;
  limit?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<SortFindManyEnergyConsumerUtilityInput>;
};

export type QueryEnergyConsumerUtilitiesByIdsArgs = {
  _ids: Array<Scalars['String']>;
  limit?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<SortFindByIdsEnergyConsumerUtilityInput>;
};

export type QueryEnergyConsumerUtilityArgs = {
  filter?: InputMaybe<FilterFindOneEnergyConsumerUtilityInput>;
  skip?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<SortFindOneEnergyConsumerUtilityInput>;
};

export type QueryEnergyConsumerUtilityByIdArgs = {
  _id: Scalars['String'];
};

export type QueryEnergyConsumerUtilityCountArgs = {
  filter?: InputMaybe<FilterCountEnergyConsumerUtilityInput>;
};

export type QueryEnergyControllerArgs = {
  filter?: InputMaybe<FilterFindOneEnergyControllerInput>;
  skip?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<SortFindOneEnergyControllerInput>;
};

export type QueryEnergyControllerByIdArgs = {
  _id: Scalars['String'];
};

export type QueryEnergyControllerCountArgs = {
  filter?: InputMaybe<FilterCountEnergyControllerInput>;
};

export type QueryEnergyControllersArgs = {
  filter?: InputMaybe<FilterFindManyEnergyControllerInput>;
  limit?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<SortFindManyEnergyControllerInput>;
};

export type QueryEnergyControllersByIdsArgs = {
  _ids: Array<Scalars['String']>;
  limit?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<SortFindByIdsEnergyControllerInput>;
};

export type QueryEnergyConverterArgs = {
  filter?: InputMaybe<FilterFindOneEnergyConverterInput>;
  skip?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<SortFindOneEnergyConverterInput>;
};

export type QueryEnergyConverterByIdArgs = {
  _id: Scalars['String'];
};

export type QueryEnergyConverterCountArgs = {
  filter?: InputMaybe<FilterCountEnergyConverterInput>;
};

export type QueryEnergyConvertersArgs = {
  filter?: InputMaybe<FilterFindManyEnergyConverterInput>;
  limit?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<SortFindManyEnergyConverterInput>;
};

export type QueryEnergyConvertersByIdsArgs = {
  _ids: Array<Scalars['String']>;
  limit?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<SortFindByIdsEnergyConverterInput>;
};

export type QueryEnergyInverterArgs = {
  filter?: InputMaybe<FilterFindOneEnergyInverterInput>;
  skip?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<SortFindOneEnergyInverterInput>;
};

export type QueryEnergyInverterByIdArgs = {
  _id: Scalars['String'];
};

export type QueryEnergyInverterCountArgs = {
  filter?: InputMaybe<FilterCountEnergyInverterInput>;
};

export type QueryEnergyInvertersArgs = {
  filter?: InputMaybe<FilterFindManyEnergyInverterInput>;
  limit?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<SortFindManyEnergyInverterInput>;
};

export type QueryEnergyInvertersByIdsArgs = {
  _ids: Array<Scalars['String']>;
  limit?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<SortFindByIdsEnergyInverterInput>;
};

export type QueryEnergyMeterArgs = {
  filter?: InputMaybe<FilterFindOneEnergyMeterInput>;
  skip?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<SortFindOneEnergyMeterInput>;
};

export type QueryEnergyMeterByIdArgs = {
  _id: Scalars['String'];
};

export type QueryEnergyMeterCountArgs = {
  filter?: InputMaybe<FilterCountEnergyMeterInput>;
};

export type QueryEnergyMetersArgs = {
  filter?: InputMaybe<FilterFindManyEnergyMeterInput>;
  limit?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<SortFindManyEnergyMeterInput>;
};

export type QueryEnergyMetersByIdsArgs = {
  _ids: Array<Scalars['String']>;
  limit?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<SortFindByIdsEnergyMeterInput>;
};

export type QueryEnergyRectifierArgs = {
  filter?: InputMaybe<FilterFindOneEnergyRectifierInput>;
  skip?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<SortFindOneEnergyRectifierInput>;
};

export type QueryEnergyRectifierByIdArgs = {
  _id: Scalars['String'];
};

export type QueryEnergyRectifierCountArgs = {
  filter?: InputMaybe<FilterCountEnergyRectifierInput>;
};

export type QueryEnergyRectifiersArgs = {
  filter?: InputMaybe<FilterFindManyEnergyRectifierInput>;
  limit?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<SortFindManyEnergyRectifierInput>;
};

export type QueryEnergyRectifiersByIdsArgs = {
  _ids: Array<Scalars['String']>;
  limit?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<SortFindByIdsEnergyRectifierInput>;
};

export type QueryEnergyStorageBatterySystemArgs = {
  filter?: InputMaybe<FilterFindOneEnergyStorageBatterySystemInput>;
  skip?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<SortFindOneEnergyStorageBatterySystemInput>;
};

export type QueryEnergyStorageBatterySystemByIdArgs = {
  _id: Scalars['String'];
};

export type QueryEnergyStorageBatterySystemCountArgs = {
  filter?: InputMaybe<FilterCountEnergyStorageBatterySystemInput>;
};

export type QueryEnergyStorageBatterySystemsArgs = {
  filter?: InputMaybe<FilterFindManyEnergyStorageBatterySystemInput>;
  limit?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<SortFindManyEnergyStorageBatterySystemInput>;
};

export type QueryEnergyStorageBatterySystemsByIdsArgs = {
  _ids: Array<Scalars['String']>;
  limit?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<SortFindByIdsEnergyStorageBatterySystemInput>;
};

export type QueryEnergyStorageCoolingSystemArgs = {
  filter?: InputMaybe<FilterFindOneEnergyStorageCoolingSystemInput>;
  skip?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<SortFindOneEnergyStorageCoolingSystemInput>;
};

export type QueryEnergyStorageCoolingSystemByIdArgs = {
  _id: Scalars['String'];
};

export type QueryEnergyStorageCoolingSystemCountArgs = {
  filter?: InputMaybe<FilterCountEnergyStorageCoolingSystemInput>;
};

export type QueryEnergyStorageCoolingSystemsArgs = {
  filter?: InputMaybe<FilterFindManyEnergyStorageCoolingSystemInput>;
  limit?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<SortFindManyEnergyStorageCoolingSystemInput>;
};

export type QueryEnergyStorageCoolingSystemsByIdsArgs = {
  _ids: Array<Scalars['String']>;
  limit?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<SortFindByIdsEnergyStorageCoolingSystemInput>;
};

export type QueryEnergyStorageKineticSystemArgs = {
  filter?: InputMaybe<FilterFindOneEnergyStorageKineticSystemInput>;
  skip?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<SortFindOneEnergyStorageKineticSystemInput>;
};

export type QueryEnergyStorageKineticSystemByIdArgs = {
  _id: Scalars['String'];
};

export type QueryEnergyStorageKineticSystemCountArgs = {
  filter?: InputMaybe<FilterCountEnergyStorageKineticSystemInput>;
};

export type QueryEnergyStorageKineticSystemsArgs = {
  filter?: InputMaybe<FilterFindManyEnergyStorageKineticSystemInput>;
  limit?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<SortFindManyEnergyStorageKineticSystemInput>;
};

export type QueryEnergyStorageKineticSystemsByIdsArgs = {
  _ids: Array<Scalars['String']>;
  limit?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<SortFindByIdsEnergyStorageKineticSystemInput>;
};

export type QueryEnergySupplierSolarSystemArgs = {
  filter?: InputMaybe<FilterFindOneEnergySupplierSolarSystemInput>;
  skip?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<SortFindOneEnergySupplierSolarSystemInput>;
};

export type QueryEnergySupplierSolarSystemByIdArgs = {
  _id: Scalars['String'];
};

export type QueryEnergySupplierSolarSystemCountArgs = {
  filter?: InputMaybe<FilterCountEnergySupplierSolarSystemInput>;
};

export type QueryEnergySupplierSolarSystemsArgs = {
  filter?: InputMaybe<FilterFindManyEnergySupplierSolarSystemInput>;
  limit?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<SortFindManyEnergySupplierSolarSystemInput>;
};

export type QueryEnergySupplierSolarSystemsByIdsArgs = {
  _ids: Array<Scalars['String']>;
  limit?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<SortFindByIdsEnergySupplierSolarSystemInput>;
};

export type QueryEnergySupplierUtilitiesArgs = {
  filter?: InputMaybe<FilterFindManyEnergySupplierUtilityInput>;
  limit?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<SortFindManyEnergySupplierUtilityInput>;
};

export type QueryEnergySupplierUtilitiesByIdsArgs = {
  _ids: Array<Scalars['String']>;
  limit?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<SortFindByIdsEnergySupplierUtilityInput>;
};

export type QueryEnergySupplierUtilityArgs = {
  filter?: InputMaybe<FilterFindOneEnergySupplierUtilityInput>;
  skip?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<SortFindOneEnergySupplierUtilityInput>;
};

export type QueryEnergySupplierUtilityByIdArgs = {
  _id: Scalars['String'];
};

export type QueryEnergySupplierUtilityCountArgs = {
  filter?: InputMaybe<FilterCountEnergySupplierUtilityInput>;
};

export type QueryEnergySupplierWindSystemArgs = {
  filter?: InputMaybe<FilterFindOneEnergySupplierWindSystemInput>;
  skip?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<SortFindOneEnergySupplierWindSystemInput>;
};

export type QueryEnergySupplierWindSystemByIdArgs = {
  _id: Scalars['String'];
};

export type QueryEnergySupplierWindSystemCountArgs = {
  filter?: InputMaybe<FilterCountEnergySupplierWindSystemInput>;
};

export type QueryEnergySupplierWindSystemsArgs = {
  filter?: InputMaybe<FilterFindManyEnergySupplierWindSystemInput>;
  limit?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<SortFindManyEnergySupplierWindSystemInput>;
};

export type QueryEnergySupplierWindSystemsByIdsArgs = {
  _ids: Array<Scalars['String']>;
  limit?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<SortFindByIdsEnergySupplierWindSystemInput>;
};

export type QueryEnergySwitchPanelArgs = {
  filter?: InputMaybe<FilterFindOneEnergySwitchPanelInput>;
  skip?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<SortFindOneEnergySwitchPanelInput>;
};

export type QueryEnergySwitchPanelByIdArgs = {
  _id: Scalars['String'];
};

export type QueryEnergySwitchPanelCircuitArgs = {
  filter?: InputMaybe<FilterFindOneEnergySwitchPanelCircuitInput>;
  skip?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<SortFindOneEnergySwitchPanelCircuitInput>;
};

export type QueryEnergySwitchPanelCircuitByIdArgs = {
  _id: Scalars['String'];
};

export type QueryEnergySwitchPanelCircuitCountArgs = {
  filter?: InputMaybe<FilterCountEnergySwitchPanelCircuitInput>;
};

export type QueryEnergySwitchPanelCircuitsArgs = {
  filter?: InputMaybe<FilterFindManyEnergySwitchPanelCircuitInput>;
  limit?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<SortFindManyEnergySwitchPanelCircuitInput>;
};

export type QueryEnergySwitchPanelCircuitsByIdsArgs = {
  _ids: Array<Scalars['String']>;
  limit?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<SortFindByIdsEnergySwitchPanelCircuitInput>;
};

export type QueryEnergySwitchPanelCountArgs = {
  filter?: InputMaybe<FilterCountEnergySwitchPanelInput>;
};

export type QueryEnergySwitchPanelsArgs = {
  filter?: InputMaybe<FilterFindManyEnergySwitchPanelInput>;
  limit?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<SortFindManyEnergySwitchPanelInput>;
};

export type QueryEnergySwitchPanelsByIdsArgs = {
  _ids: Array<Scalars['String']>;
  limit?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<SortFindByIdsEnergySwitchPanelInput>;
};

export type QueryExecuteTieredEntitySelectionArgs = {
  options?: InputMaybe<QueryExecutionOptionsInput>;
  selection: TieredEntitySelectionInput;
};

export type QueryFireSuppressionSystemArgs = {
  filter?: InputMaybe<FilterFindOneFireSuppressionSystemInput>;
  skip?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<SortFindOneFireSuppressionSystemInput>;
};

export type QueryFireSuppressionSystemByIdArgs = {
  _id: Scalars['String'];
};

export type QueryFireSuppressionSystemCountArgs = {
  filter?: InputMaybe<FilterCountFireSuppressionSystemInput>;
};

export type QueryFireSuppressionSystemsArgs = {
  filter?: InputMaybe<FilterFindManyFireSuppressionSystemInput>;
  limit?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<SortFindManyFireSuppressionSystemInput>;
};

export type QueryFireSuppressionSystemsByIdsArgs = {
  _ids: Array<Scalars['String']>;
  limit?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<SortFindByIdsFireSuppressionSystemInput>;
};

export type QueryFloorArgs = {
  filter?: InputMaybe<FilterFindOneFloorInput>;
  skip?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<SortFindOneFloorInput>;
};

export type QueryFloorByIdArgs = {
  _id: Scalars['String'];
};

export type QueryFloorCountArgs = {
  filter?: InputMaybe<FilterCountFloorInput>;
};

export type QueryFloorsArgs = {
  filter?: InputMaybe<FilterFindManyFloorInput>;
  limit?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<SortFindManyFloorInput>;
};

export type QueryFloorsByIdsArgs = {
  _ids: Array<Scalars['String']>;
  limit?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<SortFindByIdsFloorInput>;
};

export type QueryGPioArgs = {
  filter?: InputMaybe<FilterFindOneGpioInput>;
  skip?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<SortFindOneGpioInput>;
};

export type QueryGPioByIdArgs = {
  _id: Scalars['String'];
};

export type QueryGPioCountArgs = {
  filter?: InputMaybe<FilterCountGpioInput>;
};

export type QueryGPiOsArgs = {
  filter?: InputMaybe<FilterFindManyGpioInput>;
  limit?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<SortFindManyGpioInput>;
};

export type QueryGPiOsByIdsArgs = {
  _ids: Array<Scalars['String']>;
  limit?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<SortFindByIdsGpioInput>;
};

export type QueryGetBulkSetpointLimitsArgs = {
  input: BulkConfigThermostatsInput;
};

export type QueryHMmArgs = {
  filter?: InputMaybe<FilterFindOneHmmInput>;
  skip?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<SortFindOneHmmInput>;
};

export type QueryHMmByIdArgs = {
  _id: Scalars['String'];
};

export type QueryHMmCountArgs = {
  filter?: InputMaybe<FilterCountHmmInput>;
};

export type QueryHmMsArgs = {
  filter?: InputMaybe<FilterFindManyHmmInput>;
  limit?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<SortFindManyHmmInput>;
};

export type QueryHmMsByIdsArgs = {
  _ids: Array<Scalars['String']>;
  limit?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<SortFindByIdsHmmInput>;
};

export type QueryHistoricAlertArgs = {
  filter?: InputMaybe<FilterFindOneHistoricAlertInput>;
  skip?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<SortFindOneHistoricAlertInput>;
};

export type QueryHistoricAlertByIdArgs = {
  _id: Scalars['String'];
};

export type QueryHistoricAlertCountArgs = {
  filter?: InputMaybe<FilterCountHistoricAlertInput>;
};

export type QueryHistoricAlertsArgs = {
  filter?: InputMaybe<FilterFindManyHistoricAlertInput>;
  limit?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<SortFindManyHistoricAlertInput>;
};

export type QueryHistoricAlertsByIdsArgs = {
  _ids: Array<Scalars['String']>;
  limit?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<SortFindByIdsHistoricAlertInput>;
};

export type QueryHistoricReadingArgs = {
  filter?: InputMaybe<FilterFindOneHistoricReadingInput>;
  skip?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<SortFindOneHistoricReadingInput>;
};

export type QueryHistoricReadingByIdArgs = {
  _id: Scalars['String'];
};

export type QueryHistoricReadingCountArgs = {
  filter?: InputMaybe<FilterCountHistoricReadingInput>;
};

export type QueryHistoricReadingsArgs = {
  filter?: InputMaybe<FilterFindManyHistoricReadingInput>;
  limit?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<SortFindManyHistoricReadingInput>;
};

export type QueryHistoricReadingsByDeviceIdArgs = {
  deviceId?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type QueryHistoricReadingsByIdsArgs = {
  _ids: Array<Scalars['String']>;
  limit?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<SortFindByIdsHistoricReadingInput>;
};

export type QueryIndoorAirHandlerArgs = {
  filter?: InputMaybe<FilterFindOneIndoorAirHandlerInput>;
  skip?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<SortFindOneIndoorAirHandlerInput>;
};

export type QueryIndoorAirHandlerByIdArgs = {
  _id: Scalars['String'];
};

export type QueryIndoorAirHandlerCountArgs = {
  filter?: InputMaybe<FilterCountIndoorAirHandlerInput>;
};

export type QueryIndoorAirHandlersArgs = {
  filter?: InputMaybe<FilterFindManyIndoorAirHandlerInput>;
  limit?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<SortFindManyIndoorAirHandlerInput>;
};

export type QueryIndoorAirHandlersByIdsArgs = {
  _ids: Array<Scalars['String']>;
  limit?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<SortFindByIdsIndoorAirHandlerInput>;
};

export type QueryIndoorSensorArgs = {
  filter?: InputMaybe<FilterFindOneIndoorSensorInput>;
  skip?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<SortFindOneIndoorSensorInput>;
};

export type QueryIndoorSensorByIdArgs = {
  _id: Scalars['String'];
};

export type QueryIndoorSensorCountArgs = {
  filter?: InputMaybe<FilterCountIndoorSensorInput>;
};

export type QueryIndoorSensorsArgs = {
  filter?: InputMaybe<FilterFindManyIndoorSensorInput>;
  limit?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<SortFindManyIndoorSensorInput>;
};

export type QueryIndoorSensorsByIdsArgs = {
  _ids: Array<Scalars['String']>;
  limit?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<SortFindByIdsIndoorSensorInput>;
};

export type QueryIngestionArgs = {
  filter?: InputMaybe<FilterFindOneIngestionInput>;
  skip?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<SortFindOneIngestionInput>;
};

export type QueryIngestionByIdArgs = {
  _id: Scalars['String'];
};

export type QueryIngestionCountArgs = {
  filter?: InputMaybe<FilterCountIngestionInput>;
};

export type QueryIngestionsArgs = {
  filter?: InputMaybe<FilterFindManyIngestionInput>;
  limit?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<SortFindManyIngestionInput>;
};

export type QueryIngestionsByIdsArgs = {
  _ids: Array<Scalars['String']>;
  limit?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<SortFindByIdsIngestionInput>;
};

export type QueryKineticEnergyManagementSystemArgs = {
  filter?: InputMaybe<FilterFindOneKineticEnergyManagementSystemInput>;
  skip?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<SortFindOneKineticEnergyManagementSystemInput>;
};

export type QueryKineticEnergyManagementSystemByIdArgs = {
  _id: Scalars['String'];
};

export type QueryKineticEnergyManagementSystemCountArgs = {
  filter?: InputMaybe<FilterCountKineticEnergyManagementSystemInput>;
};

export type QueryKineticEnergyManagementSystemsArgs = {
  filter?: InputMaybe<FilterFindManyKineticEnergyManagementSystemInput>;
  limit?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<SortFindManyKineticEnergyManagementSystemInput>;
};

export type QueryKineticEnergyManagementSystemsByIdsArgs = {
  _ids: Array<Scalars['String']>;
  limit?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<SortFindByIdsKineticEnergyManagementSystemInput>;
};

export type QueryLeakDetectorArgs = {
  filter?: InputMaybe<FilterFindOneLeakDetectorInput>;
  skip?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<SortFindOneLeakDetectorInput>;
};

export type QueryLeakDetectorByIdArgs = {
  _id: Scalars['String'];
};

export type QueryLeakDetectorCountArgs = {
  filter?: InputMaybe<FilterCountLeakDetectorInput>;
};

export type QueryLeakDetectorsArgs = {
  filter?: InputMaybe<FilterFindManyLeakDetectorInput>;
  limit?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<SortFindManyLeakDetectorInput>;
};

export type QueryLeakDetectorsByIdsArgs = {
  _ids: Array<Scalars['String']>;
  limit?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<SortFindByIdsLeakDetectorInput>;
};

export type QueryLoopArgs = {
  filter?: InputMaybe<FilterFindOneLoopInput>;
  skip?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<SortFindOneLoopInput>;
};

export type QueryLoopByIdArgs = {
  _id: Scalars['String'];
};

export type QueryLoopCountArgs = {
  filter?: InputMaybe<FilterCountLoopInput>;
};

export type QueryLoopsArgs = {
  filter?: InputMaybe<FilterFindManyLoopInput>;
  limit?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<SortFindManyLoopInput>;
};

export type QueryLoopsByIdsArgs = {
  _ids: Array<Scalars['String']>;
  limit?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<SortFindByIdsLoopInput>;
};

export type QueryModbusAirHandlerArgs = {
  filter?: InputMaybe<FilterFindOneModbusAirHandlerInput>;
  skip?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<SortFindOneModbusAirHandlerInput>;
};

export type QueryModbusAirHandlerByIdArgs = {
  _id: Scalars['String'];
};

export type QueryModbusAirHandlerCountArgs = {
  filter?: InputMaybe<FilterCountModbusAirHandlerInput>;
};

export type QueryModbusAirHandlersArgs = {
  filter?: InputMaybe<FilterFindManyModbusAirHandlerInput>;
  limit?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<SortFindManyModbusAirHandlerInput>;
};

export type QueryModbusAirHandlersByIdsArgs = {
  _ids: Array<Scalars['String']>;
  limit?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<SortFindByIdsModbusAirHandlerInput>;
};

export type QueryOauthAccessTokenArgs = {
  filter?: InputMaybe<FilterFindOneOauthAccessTokenInput>;
  skip?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<SortFindOneOauthAccessTokenInput>;
};

export type QueryOauthAccessTokenByIdArgs = {
  _id: Scalars['String'];
};

export type QueryOauthAccessTokenCountArgs = {
  filter?: InputMaybe<FilterCountOauthAccessTokenInput>;
};

export type QueryOauthAccessTokensArgs = {
  filter?: InputMaybe<FilterFindManyOauthAccessTokenInput>;
  limit?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<SortFindManyOauthAccessTokenInput>;
};

export type QueryOauthAccessTokensByIdsArgs = {
  _ids: Array<Scalars['String']>;
  limit?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<SortFindByIdsOauthAccessTokenInput>;
};

export type QueryOauthAuthCodeArgs = {
  filter?: InputMaybe<FilterFindOneOauthAuthCodeInput>;
  skip?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<SortFindOneOauthAuthCodeInput>;
};

export type QueryOauthAuthCodeByIdArgs = {
  _id: Scalars['String'];
};

export type QueryOauthAuthCodeCountArgs = {
  filter?: InputMaybe<FilterCountOauthAuthCodeInput>;
};

export type QueryOauthAuthCodesArgs = {
  filter?: InputMaybe<FilterFindManyOauthAuthCodeInput>;
  limit?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<SortFindManyOauthAuthCodeInput>;
};

export type QueryOauthAuthCodesByIdsArgs = {
  _ids: Array<Scalars['String']>;
  limit?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<SortFindByIdsOauthAuthCodeInput>;
};

export type QueryOauthClientArgs = {
  filter?: InputMaybe<FilterFindOneOauthClientInput>;
  skip?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<SortFindOneOauthClientInput>;
};

export type QueryOauthClientByIdArgs = {
  _id: Scalars['String'];
};

export type QueryOauthClientCountArgs = {
  filter?: InputMaybe<FilterCountOauthClientInput>;
};

export type QueryOauthClientsArgs = {
  filter?: InputMaybe<FilterFindManyOauthClientInput>;
  limit?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<SortFindManyOauthClientInput>;
};

export type QueryOauthClientsByIdsArgs = {
  _ids: Array<Scalars['String']>;
  limit?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<SortFindByIdsOauthClientInput>;
};

export type QueryOccupancySensorArgs = {
  filter?: InputMaybe<FilterFindOneOccupancySensorInput>;
  skip?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<SortFindOneOccupancySensorInput>;
};

export type QueryOccupancySensorByIdArgs = {
  _id: Scalars['String'];
};

export type QueryOccupancySensorCountArgs = {
  filter?: InputMaybe<FilterCountOccupancySensorInput>;
};

export type QueryOccupancySensorsArgs = {
  filter?: InputMaybe<FilterFindManyOccupancySensorInput>;
  limit?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<SortFindManyOccupancySensorInput>;
};

export type QueryOccupancySensorsByIdsArgs = {
  _ids: Array<Scalars['String']>;
  limit?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<SortFindByIdsOccupancySensorInput>;
};

export type QueryOpenWeatherArgs = {
  filter?: InputMaybe<FilterFindOneOpenWeatherInput>;
  skip?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<SortFindOneOpenWeatherInput>;
};

export type QueryOpenWeatherByIdArgs = {
  _id: Scalars['String'];
};

export type QueryOpenWeatherCountArgs = {
  filter?: InputMaybe<FilterCountOpenWeatherInput>;
};

export type QueryOpenWeathersArgs = {
  filter?: InputMaybe<FilterFindManyOpenWeatherInput>;
  limit?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<SortFindManyOpenWeatherInput>;
};

export type QueryOpenWeathersByIdsArgs = {
  _ids: Array<Scalars['String']>;
  limit?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<SortFindByIdsOpenWeatherInput>;
};

export type QueryOrganizationArgs = {
  filter?: InputMaybe<FilterFindOneOrganizationInput>;
  skip?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<SortFindOneOrganizationInput>;
};

export type QueryOrganizationByIdArgs = {
  _id: Scalars['String'];
};

export type QueryOrganizationCountArgs = {
  filter?: InputMaybe<FilterCountOrganizationInput>;
};

export type QueryOrganizationsArgs = {
  filter?: InputMaybe<FilterFindManyOrganizationInput>;
  limit?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<SortFindManyOrganizationInput>;
};

export type QueryOrganizationsByIdsArgs = {
  _ids: Array<Scalars['String']>;
  limit?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<SortFindByIdsOrganizationInput>;
};

export type QueryOutdoorSensorArgs = {
  filter?: InputMaybe<FilterFindOneOutdoorSensorInput>;
  skip?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<SortFindOneOutdoorSensorInput>;
};

export type QueryOutdoorSensorByIdArgs = {
  _id: Scalars['String'];
};

export type QueryOutdoorSensorCountArgs = {
  filter?: InputMaybe<FilterCountOutdoorSensorInput>;
};

export type QueryOutdoorSensorsArgs = {
  filter?: InputMaybe<FilterFindManyOutdoorSensorInput>;
  limit?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<SortFindManyOutdoorSensorInput>;
};

export type QueryOutdoorSensorsByIdsArgs = {
  _ids: Array<Scalars['String']>;
  limit?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<SortFindByIdsOutdoorSensorInput>;
};

export type QueryPaginatedAlertCategoriesArgs = {
  filter?: InputMaybe<FilterFindManyAlertCategoryInput>;
  page?: InputMaybe<Scalars['Int']>;
  perPage?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<SortFindManyAlertCategoryInput>;
};

export type QueryPaginatedAlertNotificationsArgs = {
  filter?: InputMaybe<FilterFindManyAlertNotificationInput>;
  page?: InputMaybe<Scalars['Int']>;
  perPage?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<SortFindManyAlertNotificationInput>;
};

export type QueryPaginatedAlertOptOutsArgs = {
  filter?: InputMaybe<FilterFindManyAlertOptOutInput>;
  page?: InputMaybe<Scalars['Int']>;
  perPage?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<SortFindManyAlertOptOutInput>;
};

export type QueryPaginatedAlertSubscriptionsArgs = {
  filter?: InputMaybe<FilterFindManyAlertSubscriptionInput>;
  page?: InputMaybe<Scalars['Int']>;
  perPage?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<SortFindManyAlertSubscriptionInput>;
};

export type QueryPaginatedAlertTriggersArgs = {
  filter?: InputMaybe<FilterFindManyAlertTriggerInput>;
  page?: InputMaybe<Scalars['Int']>;
  perPage?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<SortFindManyAlertTriggerInput>;
};

export type QueryPaginatedAlertsArgs = {
  filter?: InputMaybe<FilterFindManyAlertInput>;
  page?: InputMaybe<Scalars['Int']>;
  perPage?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<SortFindManyAlertInput>;
};

export type QueryPaginatedAuthenticationProfilesArgs = {
  filter?: InputMaybe<FilterFindManyAuthenticationProfileInput>;
  page?: InputMaybe<Scalars['Int']>;
  perPage?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<SortFindManyAuthenticationProfileInput>;
};

export type QueryPaginatedAuthenticatorDevicesArgs = {
  filter?: InputMaybe<FilterFindManyAuthenticatorDeviceInput>;
  page?: InputMaybe<Scalars['Int']>;
  perPage?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<SortFindManyAuthenticatorDeviceInput>;
};

export type QueryPaginatedAuthorizationProfilesArgs = {
  filter?: InputMaybe<FilterFindManyAuthorizationProfileInput>;
  page?: InputMaybe<Scalars['Int']>;
  perPage?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<SortFindManyAuthorizationProfileInput>;
};

export type QueryPaginatedBuildingsArgs = {
  filter?: InputMaybe<FilterFindManyBuildingInput>;
  page?: InputMaybe<Scalars['Int']>;
  perPage?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<SortFindManyBuildingInput>;
};

export type QueryPaginatedControlGroupsArgs = {
  filter?: InputMaybe<FilterFindManyControlGroupInput>;
  page?: InputMaybe<Scalars['Int']>;
  perPage?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<SortFindManyControlGroupInput>;
};

export type QueryPaginatedDataExportJobsArgs = {
  filter?: InputMaybe<FilterFindManyDataExportJobInput>;
  page?: InputMaybe<Scalars['Int']>;
  perPage?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<SortFindManyDataExportJobInput>;
};

export type QueryPaginatedDeviceReadingsArgs = {
  filter?: InputMaybe<FilterFindManyDeviceReadingInput>;
  page?: InputMaybe<Scalars['Int']>;
  perPage?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<SortFindManyDeviceReadingInput>;
};

export type QueryPaginatedEnergyConsumerBuildingsArgs = {
  filter?: InputMaybe<FilterFindManyEnergyConsumerBuildingInput>;
  page?: InputMaybe<Scalars['Int']>;
  perPage?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<SortFindManyEnergyConsumerBuildingInput>;
};

export type QueryPaginatedEnergyConsumerTenantsArgs = {
  filter?: InputMaybe<FilterFindManyEnergyConsumerTenantInput>;
  page?: InputMaybe<Scalars['Int']>;
  perPage?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<SortFindManyEnergyConsumerTenantInput>;
};

export type QueryPaginatedEnergyConsumerUtilitiesArgs = {
  filter?: InputMaybe<FilterFindManyEnergyConsumerUtilityInput>;
  page?: InputMaybe<Scalars['Int']>;
  perPage?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<SortFindManyEnergyConsumerUtilityInput>;
};

export type QueryPaginatedEnergyStorageBatterySystemsArgs = {
  filter?: InputMaybe<FilterFindManyEnergyStorageBatterySystemInput>;
  page?: InputMaybe<Scalars['Int']>;
  perPage?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<SortFindManyEnergyStorageBatterySystemInput>;
};

export type QueryPaginatedEnergyStorageKineticSystemsArgs = {
  filter?: InputMaybe<FilterFindManyEnergyStorageKineticSystemInput>;
  page?: InputMaybe<Scalars['Int']>;
  perPage?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<SortFindManyEnergyStorageKineticSystemInput>;
};

export type QueryPaginatedEnergySupplierSolarSystemsArgs = {
  filter?: InputMaybe<FilterFindManyEnergySupplierSolarSystemInput>;
  page?: InputMaybe<Scalars['Int']>;
  perPage?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<SortFindManyEnergySupplierSolarSystemInput>;
};

export type QueryPaginatedEnergySupplierUtilitiesArgs = {
  filter?: InputMaybe<FilterFindManyEnergySupplierUtilityInput>;
  page?: InputMaybe<Scalars['Int']>;
  perPage?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<SortFindManyEnergySupplierUtilityInput>;
};

export type QueryPaginatedEnergySupplierWindSystemsArgs = {
  filter?: InputMaybe<FilterFindManyEnergySupplierWindSystemInput>;
  page?: InputMaybe<Scalars['Int']>;
  perPage?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<SortFindManyEnergySupplierWindSystemInput>;
};

export type QueryPaginatedFloorsArgs = {
  filter?: InputMaybe<FilterFindManyFloorInput>;
  page?: InputMaybe<Scalars['Int']>;
  perPage?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<SortFindManyFloorInput>;
};

export type QueryPaginatedHistoricAlertsArgs = {
  filter?: InputMaybe<FilterFindManyHistoricAlertInput>;
  page?: InputMaybe<Scalars['Int']>;
  perPage?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<SortFindManyHistoricAlertInput>;
};

export type QueryPaginatedHistoricReadingsArgs = {
  filter?: InputMaybe<FilterFindManyHistoricReadingInput>;
  page?: InputMaybe<Scalars['Int']>;
  perPage?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<SortFindManyHistoricReadingInput>;
};

export type QueryPaginatedIngestionsArgs = {
  filter?: InputMaybe<FilterFindManyIngestionInput>;
  page?: InputMaybe<Scalars['Int']>;
  perPage?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<SortFindManyIngestionInput>;
};

export type QueryPaginatedOauthAccessTokensArgs = {
  filter?: InputMaybe<FilterFindManyOauthAccessTokenInput>;
  page?: InputMaybe<Scalars['Int']>;
  perPage?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<SortFindManyOauthAccessTokenInput>;
};

export type QueryPaginatedOauthAuthCodesArgs = {
  filter?: InputMaybe<FilterFindManyOauthAuthCodeInput>;
  page?: InputMaybe<Scalars['Int']>;
  perPage?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<SortFindManyOauthAuthCodeInput>;
};

export type QueryPaginatedOauthClientsArgs = {
  filter?: InputMaybe<FilterFindManyOauthClientInput>;
  page?: InputMaybe<Scalars['Int']>;
  perPage?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<SortFindManyOauthClientInput>;
};

export type QueryPaginatedOrganizationsArgs = {
  filter?: InputMaybe<FilterFindManyOrganizationInput>;
  page?: InputMaybe<Scalars['Int']>;
  perPage?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<SortFindManyOrganizationInput>;
};

export type QueryPaginatedPanelsArgs = {
  filter?: InputMaybe<FilterFindManyPanelInput>;
  page?: InputMaybe<Scalars['Int']>;
  perPage?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<SortFindManyPanelInput>;
};

export type QueryPaginatedPlmContractsArgs = {
  filter?: InputMaybe<FilterFindManyPlmContractInput>;
  page?: InputMaybe<Scalars['Int']>;
  perPage?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<SortFindManyPlmContractInput>;
};

export type QueryPaginatedPlmCurtailmentActionsArgs = {
  filter?: InputMaybe<FilterFindManyPlmCurtailmentActionInput>;
  page?: InputMaybe<Scalars['Int']>;
  perPage?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<SortFindManyPlmCurtailmentActionInput>;
};

export type QueryPaginatedPlmCurtailmentPlansArgs = {
  filter?: InputMaybe<FilterFindManyPlmCurtailmentPlanInput>;
  page?: InputMaybe<Scalars['Int']>;
  perPage?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<SortFindManyPlmCurtailmentPlanInput>;
};

export type QueryPaginatedPlmCurtailmentTasksArgs = {
  filter?: InputMaybe<FilterFindManyPlmCurtailmentTaskInput>;
  page?: InputMaybe<Scalars['Int']>;
  perPage?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<SortFindManyPlmCurtailmentTaskInput>;
};

export type QueryPaginatedPlmEventResponsesArgs = {
  filter?: InputMaybe<FilterFindManyPlmEventResponseInput>;
  page?: InputMaybe<Scalars['Int']>;
  perPage?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<SortFindManyPlmEventResponseInput>;
};

export type QueryPaginatedPlmEventsArgs = {
  filter?: InputMaybe<FilterFindManyPlmEventInput>;
  page?: InputMaybe<Scalars['Int']>;
  perPage?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<SortFindManyPlmEventInput>;
};

export type QueryPaginatedPlmExternalMeterMappingsArgs = {
  filter?: InputMaybe<FilterFindManyPlmExternalMeterMappingInput>;
  page?: InputMaybe<Scalars['Int']>;
  perPage?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<SortFindManyPlmExternalMeterMappingInput>;
};

export type QueryPaginatedPlmIngressEventsArgs = {
  filter?: InputMaybe<FilterFindManyPlmIngressEventInput>;
  page?: InputMaybe<Scalars['Int']>;
  perPage?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<SortFindManyPlmIngressEventInput>;
};

export type QueryPaginatedPlmNotificationsArgs = {
  filter?: InputMaybe<FilterFindManyPlmNotificationInput>;
  page?: InputMaybe<Scalars['Int']>;
  perPage?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<SortFindManyPlmNotificationInput>;
};

export type QueryPaginatedPlmPartnersArgs = {
  filter?: InputMaybe<FilterFindManyPlmPartnerInput>;
  page?: InputMaybe<Scalars['Int']>;
  perPage?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<SortFindManyPlmPartnerInput>;
};

export type QueryPaginatedPlmProgramsArgs = {
  filter?: InputMaybe<FilterFindManyPlmProgramInput>;
  page?: InputMaybe<Scalars['Int']>;
  perPage?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<SortFindManyPlmProgramInput>;
};

export type QueryPaginatedPlmUtilitiesArgs = {
  filter?: InputMaybe<FilterFindManyPlmUtilityInput>;
  page?: InputMaybe<Scalars['Int']>;
  perPage?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<SortFindManyPlmUtilityInput>;
};

export type QueryPaginatedPropertiesArgs = {
  filter?: InputMaybe<FilterFindManyPropertyInput>;
  page?: InputMaybe<Scalars['Int']>;
  perPage?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<SortFindManyPropertyInput>;
};

export type QueryPaginatedScheduledTasksArgs = {
  filter?: InputMaybe<FilterFindManyScheduledTaskInput>;
  page?: InputMaybe<Scalars['Int']>;
  perPage?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<SortFindManyScheduledTaskInput>;
};

export type QueryPaginatedSetpointProfilesArgs = {
  filter?: InputMaybe<FilterFindManySetpointProfileInput>;
  page?: InputMaybe<Scalars['Int']>;
  perPage?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<SortFindManySetpointProfileInput>;
};

export type QueryPaginatedSystemNotificationsArgs = {
  filter?: InputMaybe<FilterFindManySystemNotificationInput>;
  page?: InputMaybe<Scalars['Int']>;
  perPage?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<SortFindManySystemNotificationInput>;
};

export type QueryPaginatedThermostatScheduleProfilesArgs = {
  filter?: InputMaybe<FilterFindManyThermostatScheduleProfileInput>;
  page?: InputMaybe<Scalars['Int']>;
  perPage?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<SortFindManyThermostatScheduleProfileInput>;
};

export type QueryPaginatedThermostatScheduleTemplatesArgs = {
  filter?: InputMaybe<FilterFindManyThermostatScheduleTemplateInput>;
  page?: InputMaybe<Scalars['Int']>;
  perPage?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<SortFindManyThermostatScheduleTemplateInput>;
};

export type QueryPaginatedUnitsArgs = {
  filter?: InputMaybe<FilterFindManyUnitInput>;
  page?: InputMaybe<Scalars['Int']>;
  perPage?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<SortFindManyUnitInput>;
};

export type QueryPaginatedUserHistoriesArgs = {
  filter?: InputMaybe<FilterFindManyUserHistoryInput>;
  page?: InputMaybe<Scalars['Int']>;
  perPage?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<SortFindManyUserHistoryInput>;
};

export type QueryPaginatedUsersArgs = {
  filter?: InputMaybe<FilterFindManyUserInput>;
  page?: InputMaybe<Scalars['Int']>;
  perPage?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<SortFindManyUserInput>;
};

export type QueryPaginatedVirtualPowerPlantsArgs = {
  filter?: InputMaybe<FilterFindManyVirtualPowerPlantInput>;
  page?: InputMaybe<Scalars['Int']>;
  perPage?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<SortFindManyVirtualPowerPlantInput>;
};

export type QueryPaginatedZonePoliciesArgs = {
  filter?: InputMaybe<FilterFindManyZonePolicyInput>;
  page?: InputMaybe<Scalars['Int']>;
  perPage?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<SortFindManyZonePolicyInput>;
};

export type QueryPaginatedZonesArgs = {
  filter?: InputMaybe<FilterFindManyZoneInput>;
  page?: InputMaybe<Scalars['Int']>;
  perPage?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<SortFindManyZoneInput>;
};

export type QueryPanelArgs = {
  filter?: InputMaybe<FilterFindOnePanelInput>;
  skip?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<SortFindOnePanelInput>;
};

export type QueryPanelByIdArgs = {
  _id: Scalars['String'];
};

export type QueryPanelCountArgs = {
  filter?: InputMaybe<FilterCountPanelInput>;
};

export type QueryPanelsArgs = {
  filter?: InputMaybe<FilterFindManyPanelInput>;
  limit?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<SortFindManyPanelInput>;
};

export type QueryPanelsByIdsArgs = {
  _ids: Array<Scalars['String']>;
  limit?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<SortFindByIdsPanelInput>;
};

export type QueryPlmContractArgs = {
  filter?: InputMaybe<FilterFindOnePlmContractInput>;
  skip?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<SortFindOnePlmContractInput>;
};

export type QueryPlmContractByIdArgs = {
  _id: Scalars['String'];
};

export type QueryPlmContractCountArgs = {
  filter?: InputMaybe<FilterCountPlmContractInput>;
};

export type QueryPlmContractsArgs = {
  filter?: InputMaybe<FilterFindManyPlmContractInput>;
  limit?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<SortFindManyPlmContractInput>;
};

export type QueryPlmContractsByIdsArgs = {
  _ids: Array<Scalars['String']>;
  limit?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<SortFindByIdsPlmContractInput>;
};

export type QueryPlmCurtailmentActionArgs = {
  filter?: InputMaybe<FilterFindOnePlmCurtailmentActionInput>;
  skip?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<SortFindOnePlmCurtailmentActionInput>;
};

export type QueryPlmCurtailmentActionByIdArgs = {
  _id: Scalars['String'];
};

export type QueryPlmCurtailmentActionCountArgs = {
  filter?: InputMaybe<FilterCountPlmCurtailmentActionInput>;
};

export type QueryPlmCurtailmentActionsArgs = {
  filter?: InputMaybe<FilterFindManyPlmCurtailmentActionInput>;
  limit?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<SortFindManyPlmCurtailmentActionInput>;
};

export type QueryPlmCurtailmentActionsByIdsArgs = {
  _ids: Array<Scalars['String']>;
  limit?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<SortFindByIdsPlmCurtailmentActionInput>;
};

export type QueryPlmCurtailmentPlanArgs = {
  filter?: InputMaybe<FilterFindOnePlmCurtailmentPlanInput>;
  skip?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<SortFindOnePlmCurtailmentPlanInput>;
};

export type QueryPlmCurtailmentPlanByIdArgs = {
  _id: Scalars['String'];
};

export type QueryPlmCurtailmentPlanCountArgs = {
  filter?: InputMaybe<FilterCountPlmCurtailmentPlanInput>;
};

export type QueryPlmCurtailmentPlansArgs = {
  filter?: InputMaybe<FilterFindManyPlmCurtailmentPlanInput>;
  limit?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<SortFindManyPlmCurtailmentPlanInput>;
};

export type QueryPlmCurtailmentPlansByIdsArgs = {
  _ids: Array<Scalars['String']>;
  limit?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<SortFindByIdsPlmCurtailmentPlanInput>;
};

export type QueryPlmCurtailmentTaskArgs = {
  filter?: InputMaybe<FilterFindOnePlmCurtailmentTaskInput>;
  skip?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<SortFindOnePlmCurtailmentTaskInput>;
};

export type QueryPlmCurtailmentTaskByIdArgs = {
  _id: Scalars['String'];
};

export type QueryPlmCurtailmentTaskCountArgs = {
  filter?: InputMaybe<FilterCountPlmCurtailmentTaskInput>;
};

export type QueryPlmCurtailmentTasksArgs = {
  filter?: InputMaybe<FilterFindManyPlmCurtailmentTaskInput>;
  limit?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<SortFindManyPlmCurtailmentTaskInput>;
};

export type QueryPlmCurtailmentTasksByActionIdArgs = {
  filter?: InputMaybe<FilterplmCurtailmentTasksByActionId>;
  limit?: InputMaybe<Scalars['Int']>;
  plmCurtailmentActionId: Scalars['String'];
  skip?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<SortFindManyPlmCurtailmentTaskInput>;
};

export type QueryPlmCurtailmentTasksByIdsArgs = {
  _ids: Array<Scalars['String']>;
  limit?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<SortFindByIdsPlmCurtailmentTaskInput>;
};

export type QueryPlmCurtailmentTasksByPropertyArgs = {
  propertyId: Scalars['String'];
};

export type QueryPlmCurtailmentTasksByPropertyIdArgs = {
  filter?: InputMaybe<FilterplmCurtailmentTasksByPropertyId>;
  limit?: InputMaybe<Scalars['Int']>;
  propertyId: Scalars['String'];
  skip?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<SortFindManyPlmCurtailmentTaskInput>;
};

export type QueryPlmCurtailmentTasksByResponseIdArgs = {
  filter?: InputMaybe<FilterplmCurtailmentTasksByResponseId>;
  limit?: InputMaybe<Scalars['Int']>;
  plmEventResponseId: Scalars['String'];
  skip?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<SortFindManyPlmCurtailmentTaskInput>;
};

export type QueryPlmCurtailmentTasksForDeviceArgs = {
  deviceId: Scalars['String'];
};

export type QueryPlmEventArgs = {
  filter?: InputMaybe<FilterFindOnePlmEventInput>;
  skip?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<SortFindOnePlmEventInput>;
};

export type QueryPlmEventByIdArgs = {
  _id: Scalars['String'];
};

export type QueryPlmEventCountArgs = {
  filter?: InputMaybe<FilterCountPlmEventInput>;
};

export type QueryPlmEventResponseArgs = {
  filter?: InputMaybe<FilterFindOnePlmEventResponseInput>;
  skip?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<SortFindOnePlmEventResponseInput>;
};

export type QueryPlmEventResponseByIdArgs = {
  _id: Scalars['String'];
};

export type QueryPlmEventResponseCountArgs = {
  filter?: InputMaybe<FilterCountPlmEventResponseInput>;
};

export type QueryPlmEventResponsesArgs = {
  filter?: InputMaybe<FilterFindManyPlmEventResponseInput>;
  limit?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<SortFindManyPlmEventResponseInput>;
};

export type QueryPlmEventResponsesByIdsArgs = {
  _ids: Array<Scalars['String']>;
  limit?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<SortFindByIdsPlmEventResponseInput>;
};

export type QueryPlmEventsArgs = {
  filter?: InputMaybe<FilterFindManyPlmEventInput>;
  limit?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<SortFindManyPlmEventInput>;
};

export type QueryPlmEventsByIdsArgs = {
  _ids: Array<Scalars['String']>;
  limit?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<SortFindByIdsPlmEventInput>;
};

export type QueryPlmExternalMeterMappingArgs = {
  filter?: InputMaybe<FilterFindOnePlmExternalMeterMappingInput>;
  skip?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<SortFindOnePlmExternalMeterMappingInput>;
};

export type QueryPlmExternalMeterMappingByIdArgs = {
  _id: Scalars['String'];
};

export type QueryPlmExternalMeterMappingCountArgs = {
  filter?: InputMaybe<FilterCountPlmExternalMeterMappingInput>;
};

export type QueryPlmExternalMeterMappingsArgs = {
  filter?: InputMaybe<FilterFindManyPlmExternalMeterMappingInput>;
  limit?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<SortFindManyPlmExternalMeterMappingInput>;
};

export type QueryPlmExternalMeterMappingsByIdsArgs = {
  _ids: Array<Scalars['String']>;
  limit?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<SortFindByIdsPlmExternalMeterMappingInput>;
};

export type QueryPlmIngressEventArgs = {
  filter?: InputMaybe<FilterFindOnePlmIngressEventInput>;
  skip?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<SortFindOnePlmIngressEventInput>;
};

export type QueryPlmIngressEventByIdArgs = {
  _id: Scalars['String'];
};

export type QueryPlmIngressEventCountArgs = {
  filter?: InputMaybe<FilterCountPlmIngressEventInput>;
};

export type QueryPlmIngressEventsArgs = {
  filter?: InputMaybe<FilterFindManyPlmIngressEventInput>;
  limit?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<SortFindManyPlmIngressEventInput>;
};

export type QueryPlmIngressEventsByIdsArgs = {
  _ids: Array<Scalars['String']>;
  limit?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<SortFindByIdsPlmIngressEventInput>;
};

export type QueryPlmNotificationArgs = {
  filter?: InputMaybe<FilterFindOnePlmNotificationInput>;
  skip?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<SortFindOnePlmNotificationInput>;
};

export type QueryPlmNotificationByIdArgs = {
  _id: Scalars['String'];
};

export type QueryPlmNotificationCountArgs = {
  filter?: InputMaybe<FilterCountPlmNotificationInput>;
};

export type QueryPlmNotificationsArgs = {
  filter?: InputMaybe<FilterFindManyPlmNotificationInput>;
  limit?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<SortFindManyPlmNotificationInput>;
};

export type QueryPlmNotificationsByIdsArgs = {
  _ids: Array<Scalars['String']>;
  limit?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<SortFindByIdsPlmNotificationInput>;
};

export type QueryPlmPartnerArgs = {
  filter?: InputMaybe<FilterFindOnePlmPartnerInput>;
  skip?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<SortFindOnePlmPartnerInput>;
};

export type QueryPlmPartnerByIdArgs = {
  _id: Scalars['String'];
};

export type QueryPlmPartnerCountArgs = {
  filter?: InputMaybe<FilterCountPlmPartnerInput>;
};

export type QueryPlmPartnersArgs = {
  filter?: InputMaybe<FilterFindManyPlmPartnerInput>;
  limit?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<SortFindManyPlmPartnerInput>;
};

export type QueryPlmPartnersByIdsArgs = {
  _ids: Array<Scalars['String']>;
  limit?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<SortFindByIdsPlmPartnerInput>;
};

export type QueryPlmProgramArgs = {
  filter?: InputMaybe<FilterFindOnePlmProgramInput>;
  skip?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<SortFindOnePlmProgramInput>;
};

export type QueryPlmProgramByIdArgs = {
  _id: Scalars['String'];
};

export type QueryPlmProgramCountArgs = {
  filter?: InputMaybe<FilterCountPlmProgramInput>;
};

export type QueryPlmProgramsArgs = {
  filter?: InputMaybe<FilterFindManyPlmProgramInput>;
  limit?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<SortFindManyPlmProgramInput>;
};

export type QueryPlmProgramsByIdsArgs = {
  _ids: Array<Scalars['String']>;
  limit?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<SortFindByIdsPlmProgramInput>;
};

export type QueryPlmUtilitiesArgs = {
  filter?: InputMaybe<FilterFindManyPlmUtilityInput>;
  limit?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<SortFindManyPlmUtilityInput>;
};

export type QueryPlmUtilitiesByIdsArgs = {
  _ids: Array<Scalars['String']>;
  limit?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<SortFindByIdsPlmUtilityInput>;
};

export type QueryPlmUtilityArgs = {
  filter?: InputMaybe<FilterFindOnePlmUtilityInput>;
  skip?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<SortFindOnePlmUtilityInput>;
};

export type QueryPlmUtilityByIdArgs = {
  _id: Scalars['String'];
};

export type QueryPlmUtilityCountArgs = {
  filter?: InputMaybe<FilterCountPlmUtilityInput>;
};

export type QueryPowerMonitorArgs = {
  filter?: InputMaybe<FilterFindOnePowerMonitorInput>;
  skip?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<SortFindOnePowerMonitorInput>;
};

export type QueryPowerMonitorByIdArgs = {
  _id: Scalars['String'];
};

export type QueryPowerMonitorCountArgs = {
  filter?: InputMaybe<FilterCountPowerMonitorInput>;
};

export type QueryPowerMonitorsArgs = {
  filter?: InputMaybe<FilterFindManyPowerMonitorInput>;
  limit?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<SortFindManyPowerMonitorInput>;
};

export type QueryPowerMonitorsByIdsArgs = {
  _ids: Array<Scalars['String']>;
  limit?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<SortFindByIdsPowerMonitorInput>;
};

export type QueryPressureSensorArgs = {
  filter?: InputMaybe<FilterFindOnePressureSensorInput>;
  skip?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<SortFindOnePressureSensorInput>;
};

export type QueryPressureSensorByIdArgs = {
  _id: Scalars['String'];
};

export type QueryPressureSensorCountArgs = {
  filter?: InputMaybe<FilterCountPressureSensorInput>;
};

export type QueryPressureSensorsArgs = {
  filter?: InputMaybe<FilterFindManyPressureSensorInput>;
  limit?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<SortFindManyPressureSensorInput>;
};

export type QueryPressureSensorsByIdsArgs = {
  _ids: Array<Scalars['String']>;
  limit?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<SortFindByIdsPressureSensorInput>;
};

export type QueryPropertiesArgs = {
  filter?: InputMaybe<FilterFindManyPropertyInput>;
  limit?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<SortFindManyPropertyInput>;
};

export type QueryPropertiesByIdsArgs = {
  _ids: Array<Scalars['String']>;
  limit?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<SortFindByIdsPropertyInput>;
};

export type QueryPropertyArgs = {
  filter?: InputMaybe<FilterFindOnePropertyInput>;
  skip?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<SortFindOnePropertyInput>;
};

export type QueryPropertyByIdArgs = {
  _id: Scalars['String'];
};

export type QueryPropertyCountArgs = {
  filter?: InputMaybe<FilterCountPropertyInput>;
};

export type QueryPropertyPlmSummariesArgs = {
  ids: Array<Scalars['String']>;
};

export type QueryPropertySummaryArgs = {
  propertyId: Scalars['String'];
};

export type QueryPropertySummaryAlertsArgs = {
  propertyId: Scalars['String'];
};

export type QueryPropertySummaryDevicesArgs = {
  propertyId: Scalars['String'];
};

export type QueryPropertySummaryStatsArgs = {
  propertyId: Scalars['String'];
};

export type QueryPropertySummaryUnitsArgs = {
  propertyId: Scalars['String'];
};

export type QueryQuarterlyReportDataExportJobDownloadUrlArgs = {
  artifactKind?: InputMaybe<Scalars['String']>;
  id: Scalars['String'];
};

export type QueryQueryableFieldsArgs = {
  modelName?: InputMaybe<QueryableModelFieldsModelNameInput>;
};

export type QueryQueryableRelatedTypesArgs = {
  modelName?: InputMaybe<QueryableRelatedTypesModelNameInput>;
};

export type QueryRelayDeviceArgs = {
  filter?: InputMaybe<FilterFindOneRelayDeviceInput>;
  skip?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<SortFindOneRelayDeviceInput>;
};

export type QueryRelayDeviceByIdArgs = {
  _id: Scalars['String'];
};

export type QueryRelayDeviceCountArgs = {
  filter?: InputMaybe<FilterCountRelayDeviceInput>;
};

export type QueryRelayDevicesArgs = {
  filter?: InputMaybe<FilterFindManyRelayDeviceInput>;
  limit?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<SortFindManyRelayDeviceInput>;
};

export type QueryRelayDevicesByIdsArgs = {
  _ids: Array<Scalars['String']>;
  limit?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<SortFindByIdsRelayDeviceInput>;
};

export type QueryScheduledTaskArgs = {
  filter?: InputMaybe<FilterFindOneScheduledTaskInput>;
  skip?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<SortFindOneScheduledTaskInput>;
};

export type QueryScheduledTaskByIdArgs = {
  taskId: Scalars['String'];
};

export type QueryScheduledTaskCountArgs = {
  filter?: InputMaybe<FilterCountScheduledTaskInput>;
};

export type QueryScheduledTasksArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
  status?: InputMaybe<Scalars['String']>;
};

export type QueryScheduledTasksByIdsArgs = {
  _ids: Array<Scalars['String']>;
  limit?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<SortFindByIdsScheduledTaskInput>;
};

export type QuerySetpointProfileArgs = {
  filter?: InputMaybe<FilterFindOneSetpointProfileInput>;
  skip?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<SortFindOneSetpointProfileInput>;
};

export type QuerySetpointProfileByIdArgs = {
  _id: Scalars['String'];
};

export type QuerySetpointProfileCountArgs = {
  filter?: InputMaybe<FilterCountSetpointProfileInput>;
};

export type QuerySetpointProfileUpdateVerificationArgs = {
  force?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  id: Scalars['String'];
  propertyIds?: InputMaybe<Array<Scalars['String']>>;
  unitId?: InputMaybe<Scalars['String']>;
};

export type QuerySetpointProfilesArgs = {
  filter?: InputMaybe<FilterFindManySetpointProfileInput>;
  limit?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<SortFindManySetpointProfileInput>;
};

export type QuerySetpointProfilesByIdsArgs = {
  _ids: Array<Scalars['String']>;
  limit?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<SortFindByIdsSetpointProfileInput>;
};

export type QuerySmartPowerOutletArgs = {
  filter?: InputMaybe<FilterFindOneSmartPowerOutletInput>;
  skip?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<SortFindOneSmartPowerOutletInput>;
};

export type QuerySmartPowerOutletByIdArgs = {
  _id: Scalars['String'];
};

export type QuerySmartPowerOutletCountArgs = {
  filter?: InputMaybe<FilterCountSmartPowerOutletInput>;
};

export type QuerySmartPowerOutletsArgs = {
  filter?: InputMaybe<FilterFindManySmartPowerOutletInput>;
  limit?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<SortFindManySmartPowerOutletInput>;
};

export type QuerySmartPowerOutletsByIdsArgs = {
  _ids: Array<Scalars['String']>;
  limit?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<SortFindByIdsSmartPowerOutletInput>;
};

export type QuerySolarManagementSystemArgs = {
  filter?: InputMaybe<FilterFindOneSolarManagementSystemInput>;
  skip?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<SortFindOneSolarManagementSystemInput>;
};

export type QuerySolarManagementSystemByIdArgs = {
  _id: Scalars['String'];
};

export type QuerySolarManagementSystemCountArgs = {
  filter?: InputMaybe<FilterCountSolarManagementSystemInput>;
};

export type QuerySolarManagementSystemsArgs = {
  filter?: InputMaybe<FilterFindManySolarManagementSystemInput>;
  limit?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<SortFindManySolarManagementSystemInput>;
};

export type QuerySolarManagementSystemsByIdsArgs = {
  _ids: Array<Scalars['String']>;
  limit?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<SortFindByIdsSolarManagementSystemInput>;
};

export type QuerySourceArgs = {
  filter?: InputMaybe<FilterFindOneSourceInput>;
  skip?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<SortFindOneSourceInput>;
};

export type QuerySourceByIdArgs = {
  _id: Scalars['String'];
};

export type QuerySourceCountArgs = {
  filter?: InputMaybe<FilterCountSourceInput>;
};

export type QuerySourcesArgs = {
  filter?: InputMaybe<FilterFindManySourceInput>;
  limit?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<SortFindManySourceInput>;
};

export type QuerySourcesByIdsArgs = {
  _ids: Array<Scalars['String']>;
  limit?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<SortFindByIdsSourceInput>;
};

export type QuerySyncPropertyZonePoliciesFromCoresArgs = {
  dryRun: Scalars['Boolean'];
  propertyId: Scalars['String'];
};

export type QuerySystemNotificationArgs = {
  filter?: InputMaybe<FilterFindOneSystemNotificationInput>;
  skip?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<SortFindOneSystemNotificationInput>;
};

export type QuerySystemNotificationByIdArgs = {
  _id: Scalars['String'];
};

export type QuerySystemNotificationCountArgs = {
  filter?: InputMaybe<FilterCountSystemNotificationInput>;
};

export type QuerySystemNotificationsArgs = {
  filter?: InputMaybe<FilterFindManySystemNotificationInput>;
  limit?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<SortFindManySystemNotificationInput>;
};

export type QuerySystemNotificationsByIdsArgs = {
  _ids: Array<Scalars['String']>;
  limit?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<SortFindByIdsSystemNotificationInput>;
};

export type QueryThermistorArgs = {
  filter?: InputMaybe<FilterFindOneThermistorInput>;
  skip?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<SortFindOneThermistorInput>;
};

export type QueryThermistorByIdArgs = {
  _id: Scalars['String'];
};

export type QueryThermistorCountArgs = {
  filter?: InputMaybe<FilterCountThermistorInput>;
};

export type QueryThermistorsArgs = {
  filter?: InputMaybe<FilterFindManyThermistorInput>;
  limit?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<SortFindManyThermistorInput>;
};

export type QueryThermistorsByIdsArgs = {
  _ids: Array<Scalars['String']>;
  limit?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<SortFindByIdsThermistorInput>;
};

export type QueryThermostatArgs = {
  filter?: InputMaybe<FilterFindOneThermostatInput>;
  skip?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<SortFindOneThermostatInput>;
};

export type QueryThermostatByIdArgs = {
  _id: Scalars['String'];
};

export type QueryThermostatCountArgs = {
  filter?: InputMaybe<FilterCountThermostatInput>;
};

export type QueryThermostatScheduleProfileArgs = {
  filter?: InputMaybe<FilterFindOneThermostatScheduleProfileInput>;
  skip?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<SortFindOneThermostatScheduleProfileInput>;
};

export type QueryThermostatScheduleProfileByIdArgs = {
  _id: Scalars['String'];
};

export type QueryThermostatScheduleProfileCountArgs = {
  filter?: InputMaybe<FilterCountThermostatScheduleProfileInput>;
};

export type QueryThermostatScheduleProfilesArgs = {
  filter?: InputMaybe<FilterFindManyThermostatScheduleProfileInput>;
  limit?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<SortFindManyThermostatScheduleProfileInput>;
};

export type QueryThermostatScheduleProfilesByIdsArgs = {
  _ids: Array<Scalars['String']>;
  limit?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<SortFindByIdsThermostatScheduleProfileInput>;
};

export type QueryThermostatScheduleTemplateArgs = {
  filter?: InputMaybe<FilterFindOneThermostatScheduleTemplateInput>;
  skip?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<SortFindOneThermostatScheduleTemplateInput>;
};

export type QueryThermostatScheduleTemplateByIdArgs = {
  _id: Scalars['String'];
};

export type QueryThermostatScheduleTemplateCountArgs = {
  filter?: InputMaybe<FilterCountThermostatScheduleTemplateInput>;
};

export type QueryThermostatScheduleTemplateEditVerificationArgs = {
  propertyId?: InputMaybe<Scalars['String']>;
  thermostatScheduleTemplateId?: InputMaybe<Scalars['String']>;
};

export type QueryThermostatScheduleTemplateUpdateVerificationArgs = {
  propertyId?: InputMaybe<Scalars['String']>;
  unitId?: InputMaybe<Scalars['String']>;
};

export type QueryThermostatScheduleTemplatesArgs = {
  filter?: InputMaybe<FilterFindManyThermostatScheduleTemplateInput>;
  limit?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<SortFindManyThermostatScheduleTemplateInput>;
};

export type QueryThermostatScheduleTemplatesByIdsArgs = {
  _ids: Array<Scalars['String']>;
  limit?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<SortFindByIdsThermostatScheduleTemplateInput>;
};

export type QueryThermostatsArgs = {
  filter?: InputMaybe<FilterFindManyThermostatInput>;
  limit?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<SortFindManyThermostatInput>;
};

export type QueryThermostatsByIdsArgs = {
  _ids: Array<Scalars['String']>;
  limit?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<SortFindByIdsThermostatInput>;
};

export type QueryUnitArgs = {
  filter?: InputMaybe<FilterFindOneUnitInput>;
  skip?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<SortFindOneUnitInput>;
};

export type QueryUnitByIdArgs = {
  _id: Scalars['String'];
};

export type QueryUnitCountArgs = {
  filter?: InputMaybe<FilterCountUnitInput>;
};

export type QueryUnitsArgs = {
  filter?: InputMaybe<FilterFindManyUnitInput>;
  limit?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<SortFindManyUnitInput>;
};

export type QueryUnitsByIdsArgs = {
  _ids: Array<Scalars['String']>;
  limit?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<SortFindByIdsUnitInput>;
};

export type QueryUnitsByPropertyIdArgs = {
  propertyId?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type QueryUserArgs = {
  filter?: InputMaybe<FilterFindOneUserInput>;
  skip?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<SortFindOneUserInput>;
};

export type QueryUserByIdArgs = {
  _id: Scalars['String'];
};

export type QueryUserCountArgs = {
  filter?: InputMaybe<FilterCountUserInput>;
};

export type QueryUserDeviceHistoryArgs = {
  userId: Scalars['String'];
};

export type QueryUserHistoriesArgs = {
  filter?: InputMaybe<FilterFindManyUserHistoryInput>;
  limit?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<SortFindManyUserHistoryInput>;
};

export type QueryUserHistoriesByIdsArgs = {
  _ids: Array<Scalars['String']>;
  limit?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<SortFindByIdsUserHistoryInput>;
};

export type QueryUserHistoryArgs = {
  filter?: InputMaybe<FilterFindOneUserHistoryInput>;
  skip?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<SortFindOneUserHistoryInput>;
};

export type QueryUserHistoryByIdArgs = {
  _id: Scalars['String'];
};

export type QueryUserHistoryCountArgs = {
  filter?: InputMaybe<FilterCountUserHistoryInput>;
};

export type QueryUsersArgs = {
  filter?: InputMaybe<FilterFindManyUserInput>;
  limit?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<SortFindManyUserInput>;
};

export type QueryUsersByIdsArgs = {
  _ids: Array<Scalars['String']>;
  limit?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<SortFindByIdsUserInput>;
};

export type QueryVSdPumpArgs = {
  filter?: InputMaybe<FilterFindOneVsdPumpInput>;
  skip?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<SortFindOneVsdPumpInput>;
};

export type QueryVSdPumpByIdArgs = {
  _id: Scalars['String'];
};

export type QueryVSdPumpCountArgs = {
  filter?: InputMaybe<FilterCountVsdPumpInput>;
};

export type QueryVSdPumpsArgs = {
  filter?: InputMaybe<FilterFindManyVsdPumpInput>;
  limit?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<SortFindManyVsdPumpInput>;
};

export type QueryVSdPumpsByIdsArgs = {
  _ids: Array<Scalars['String']>;
  limit?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<SortFindByIdsVsdPumpInput>;
};

export type QueryVirtualPowerPlantArgs = {
  filter?: InputMaybe<FilterFindOneVirtualPowerPlantInput>;
  skip?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<SortFindOneVirtualPowerPlantInput>;
};

export type QueryVirtualPowerPlantByIdArgs = {
  _id: Scalars['String'];
};

export type QueryVirtualPowerPlantCountArgs = {
  filter?: InputMaybe<FilterCountVirtualPowerPlantInput>;
};

export type QueryVirtualPowerPlantsArgs = {
  filter?: InputMaybe<FilterFindManyVirtualPowerPlantInput>;
  limit?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<SortFindManyVirtualPowerPlantInput>;
};

export type QueryVirtualPowerPlantsByIdsArgs = {
  _ids: Array<Scalars['String']>;
  limit?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<SortFindByIdsVirtualPowerPlantInput>;
};

export type QueryWindManagementSystemArgs = {
  filter?: InputMaybe<FilterFindOneWindManagementSystemInput>;
  skip?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<SortFindOneWindManagementSystemInput>;
};

export type QueryWindManagementSystemByIdArgs = {
  _id: Scalars['String'];
};

export type QueryWindManagementSystemCountArgs = {
  filter?: InputMaybe<FilterCountWindManagementSystemInput>;
};

export type QueryWindManagementSystemsArgs = {
  filter?: InputMaybe<FilterFindManyWindManagementSystemInput>;
  limit?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<SortFindManyWindManagementSystemInput>;
};

export type QueryWindManagementSystemsByIdsArgs = {
  _ids: Array<Scalars['String']>;
  limit?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<SortFindByIdsWindManagementSystemInput>;
};

export type QueryWindowSensorArgs = {
  filter?: InputMaybe<FilterFindOneWindowSensorInput>;
  skip?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<SortFindOneWindowSensorInput>;
};

export type QueryWindowSensorByIdArgs = {
  _id: Scalars['String'];
};

export type QueryWindowSensorCountArgs = {
  filter?: InputMaybe<FilterCountWindowSensorInput>;
};

export type QueryWindowSensorsArgs = {
  filter?: InputMaybe<FilterFindManyWindowSensorInput>;
  limit?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<SortFindManyWindowSensorInput>;
};

export type QueryWindowSensorsByIdsArgs = {
  _ids: Array<Scalars['String']>;
  limit?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<SortFindByIdsWindowSensorInput>;
};

export type QueryZ210PumpArgs = {
  filter?: InputMaybe<FilterFindOneZ210PumpInput>;
  skip?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<SortFindOneZ210PumpInput>;
};

export type QueryZ210PumpByIdArgs = {
  _id: Scalars['String'];
};

export type QueryZ210PumpCountArgs = {
  filter?: InputMaybe<FilterCountZ210PumpInput>;
};

export type QueryZ210PumpsArgs = {
  filter?: InputMaybe<FilterFindManyZ210PumpInput>;
  limit?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<SortFindManyZ210PumpInput>;
};

export type QueryZ210PumpsByIdsArgs = {
  _ids: Array<Scalars['String']>;
  limit?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<SortFindByIdsZ210PumpInput>;
};

export type QueryZoneArgs = {
  filter?: InputMaybe<FilterFindOneZoneInput>;
  skip?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<SortFindOneZoneInput>;
};

export type QueryZoneByIdArgs = {
  _id: Scalars['String'];
};

export type QueryZoneCountArgs = {
  filter?: InputMaybe<FilterCountZoneInput>;
};

export type QueryZonePoliciesArgs = {
  filter?: InputMaybe<FilterFindManyZonePolicyInput>;
  limit?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<SortFindManyZonePolicyInput>;
};

export type QueryZonePoliciesByIdsArgs = {
  _ids: Array<Scalars['MongoID']>;
  limit?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<SortFindByIdsZonePolicyInput>;
};

export type QueryZonePolicyArgs = {
  filter?: InputMaybe<FilterFindOneZonePolicyInput>;
  skip?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<SortFindOneZonePolicyInput>;
};

export type QueryZonePolicyByIdArgs = {
  _id: Scalars['MongoID'];
};

export type QueryZonePolicyCountArgs = {
  filter?: InputMaybe<FilterCountZonePolicyInput>;
};

export type QueryZonePolicyUpdateVerificationArgs = {
  force?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  id: Scalars['String'];
  propertyIds?: InputMaybe<Array<Scalars['String']>>;
  unitId?: InputMaybe<Scalars['String']>;
};

export type QueryZonesArgs = {
  filter?: InputMaybe<FilterFindManyZoneInput>;
  limit?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<SortFindManyZoneInput>;
};

export type QueryZonesByIdsArgs = {
  _ids: Array<Scalars['String']>;
  limit?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<SortFindByIdsZoneInput>;
};

export type QueryExecutionOptionsInput = {
  additionalCriteria?: InputMaybe<Scalars['JSON']>;
  cacheResults?: InputMaybe<Scalars['Boolean']>;
  cacheTTL?: InputMaybe<Scalars['Int']>;
  entityTypes?: InputMaybe<Array<Scalars['String']>>;
  limit?: InputMaybe<Scalars['Int']>;
  projection?: InputMaybe<Scalars['JSON']>;
  skip?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<Scalars['JSON']>;
  useQueryHelpers?: InputMaybe<Scalars['Boolean']>;
};

export type QueryableModelFieldsModelNameInput = {
  multiple?: InputMaybe<Array<Scalars['String']>>;
  single?: InputMaybe<Scalars['String']>;
};

export type QueryableRelatedTypesModelNameInput = {
  multiple?: InputMaybe<Array<Scalars['String']>>;
  single?: InputMaybe<Scalars['String']>;
};

export type RelatedEntityConfigInput = {
  relatedEntities?: InputMaybe<Array<InputMaybe<RelatedEntityConfigInput>>>;
  relationshipName: Scalars['String'];
  selectionCriteria?: InputMaybe<EntityCriteriaCompoundOperatorInput>;
};

export type RelayDevice = DeviceInterface & {
  __typename: 'RelayDevice';
  _id: Scalars['String'];
  alertTypes?: Maybe<DeviceAlertTypes>;
  chartTypes: Array<ChartType>;
  controlled?: Maybe<DeviceControlled>;
  dependentDeviceIds: Array<Maybe<Scalars['String']>>;
  deviceAlerts: Array<Maybe<Alert>>;
  deviceId?: Maybe<Scalars['String']>;
  deviceIdentifier?: Maybe<Scalars['String']>;
  deviceMetrics?: Maybe<Array<Maybe<DeviceMetric>>>;
  displayName?: Maybe<Scalars['String']>;
  hasPendingUpdates: Scalars['Boolean'];
  installation?: Maybe<DeviceInstallation>;
  isConfigured?: Maybe<Scalars['Boolean']>;
  isControlled: Scalars['Boolean'];
  isOn?: Maybe<RelayDeviceIsOn>;
  isPoweredOn?: Maybe<Scalars['Boolean']>;
  location?: Maybe<Scalars['String']>;
  meta?: Maybe<DeviceMeta>;
  modelChangeOperation?: Maybe<Scalars['String']>;
  modelType?: Maybe<Scalars['String']>;
  /** The name of the device */
  name?: Maybe<Scalars['String']>;
  panel?: Maybe<Panel>;
  panelId?: Maybe<Scalars['String']>;
  powerState?: Maybe<DevicePowerState>;
  property?: Maybe<Property>;
  propertyId: Scalars['String'];
  source?: Maybe<Source>;
  sourceAlerts: Array<Maybe<Alert>>;
  sourceId?: Maybe<Scalars['String']>;
  timestamp?: Maybe<Scalars['Float']>;
  type?: Maybe<EnumDKeyDeviceType>;
  typeDisplayName: Scalars['String'];
  unit?: Maybe<Unit>;
  unitId: Scalars['String'];
  updateDescription?: Maybe<Scalars['JSON']>;
  updateStatus?: Maybe<Scalars['Boolean']>;
  vpp?: Maybe<VirtualPowerPlant>;
  vppId?: Maybe<Scalars['String']>;
  zone?: Maybe<Zone>;
  zoneId?: Maybe<Scalars['String']>;
};

export type RelayDeviceDeviceAlertsArgs = {
  filter?: InputMaybe<FilterFindManyAlertInput>;
  limit?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<SortFindManyAlertInput>;
};

export type RelayDeviceSourceAlertsArgs = {
  filter?: InputMaybe<FilterFindManyAlertInput>;
  limit?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<SortFindManyAlertInput>;
};

export type RelayDeviceIsOn = {
  __typename?: 'RelayDeviceIsOn';
  id?: Maybe<Scalars['String']>;
  observedAt?: Maybe<Scalars['Float']>;
  previousId?: Maybe<Scalars['String']>;
  timestamp?: Maybe<Scalars['Float']>;
  units?: Maybe<Scalars['String']>;
  updatePending?: Maybe<Scalars['Boolean']>;
  value?: Maybe<Scalars['Boolean']>;
};

export type RelayDeviceUpdateInput = {
  isOn: Scalars['Boolean'];
};

export type RelayDeviceUpdateOptions = {
  forcePush?: InputMaybe<Scalars['Boolean']>;
};

export type RuntimeError = ErrorInterface & {
  __typename?: 'RuntimeError';
  /** Runtime error message */
  message?: Maybe<Scalars['String']>;
};

export type ScheduledTask = {
  __typename: 'ScheduledTask';
  _id: Scalars['String'];
  completedAt?: Maybe<Scalars['Float']>;
  createdAt: Scalars['Float'];
  errorMessage?: Maybe<Scalars['String']>;
  executionTimeMs?: Maybe<Scalars['Float']>;
  instanceId: Scalars['String'];
  maxRetries: Scalars['Float'];
  methodName: Scalars['String'];
  modelChangeOperation?: Maybe<Scalars['String']>;
  modelName: Scalars['String'];
  modelType?: Maybe<Scalars['String']>;
  priority: Scalars['Float'];
  retryCount: Scalars['Float'];
  scheduledAt: Scalars['Float'];
  startedAt?: Maybe<Scalars['Float']>;
  status: EnumScheduledTaskStatus;
  updateDescription?: Maybe<Scalars['JSON']>;
  updatedAt: Scalars['Float'];
};

/** List of items with pagination. */
export type ScheduledTaskPaginatedScheduledTasks = {
  __typename?: 'ScheduledTaskPaginatedScheduledTasks';
  /** Total object count. */
  count?: Maybe<Scalars['Int']>;
  /** Array of objects. */
  items?: Maybe<Array<ScheduledTask>>;
  /** Information to aid in pagination. */
  pageInfo: PaginationInfo;
};

/** Subset of the device fields used when restarting a device installation */
export type SetInstallationStatusInput = {
  /** required unique identifier */
  _id?: InputMaybe<Scalars['String']>;
  message: Scalars['String'];
  rawDeviceId?: InputMaybe<Scalars['String']>;
  status: Scalars['Int'];
};

export type SetInstallationStatusResult = {
  __typename?: 'SetInstallationStatusResult';
  message?: Maybe<Scalars['String']>;
  result: Scalars['Boolean'];
};

export type SetpointLimits = {
  __typename?: 'SetpointLimits';
  cool: MinMax;
  heat: MinMax;
};

export type SetpointProfile = {
  __typename: 'SetpointProfile';
  _id: Scalars['String'];
  affectedThermostats?: Maybe<Array<Thermostat>>;
  assignedProperties: Array<Maybe<Property>>;
  assignedUnits: Array<Maybe<Unit>>;
  cool?: Maybe<SetpointProfileCool>;
  createdAt?: Maybe<Scalars['Float']>;
  createdBy?: Maybe<Scalars['String']>;
  creator?: Maybe<User>;
  enabledProperties: Array<Maybe<Property>>;
  heat?: Maybe<SetpointProfileHeat>;
  lastUpdatedBy?: Maybe<User>;
  modelChangeOperation?: Maybe<Scalars['String']>;
  modelType?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  propagated?: Maybe<Scalars['Boolean']>;
  properties?: Maybe<Array<Maybe<Scalars['String']>>>;
  type?: Maybe<EnumSetpointProfileType>;
  units?: Maybe<EnumSetpointProfileUnits>;
  updateDescription?: Maybe<Scalars['JSON']>;
  updatedAt?: Maybe<Scalars['Float']>;
  updatedBy?: Maybe<Scalars['String']>;
};

export type SetpointProfileAssignedPropertiesArgs = {
  filter?: InputMaybe<FilterFindManyPropertyInput>;
  limit?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<SortFindManyPropertyInput>;
};

export type SetpointProfileAssignedUnitsArgs = {
  filter?: InputMaybe<FilterFindManyUnitInput>;
  limit?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<SortFindManyUnitInput>;
};

export type SetpointProfileCool = {
  __typename?: 'SetpointProfileCool';
  max?: Maybe<Scalars['Float']>;
  min?: Maybe<Scalars['Float']>;
};

export type SetpointProfileHeat = {
  __typename?: 'SetpointProfileHeat';
  max?: Maybe<Scalars['Float']>;
  min?: Maybe<Scalars['Float']>;
};

/** List of items with pagination. */
export type SetpointProfilePaginatedSetpointProfiles = {
  __typename?: 'SetpointProfilePaginatedSetpointProfiles';
  /** Total object count. */
  count?: Maybe<Scalars['Int']>;
  /** Array of objects. */
  items?: Maybe<Array<SetpointProfile>>;
  /** Information to aid in pagination. */
  pageInfo: PaginationInfo;
};

/** Represents metrics related to a given setpoint profile. */
export type SetpointProfileUpdateVerificationData = {
  __typename?: 'SetpointProfileUpdateVerificationData';
  /** Setpoint Profile ID. */
  _id?: Maybe<Scalars['String']>;
  /** Number of devices in the specified selection set that have been installed. */
  configuredDevices?: Maybe<Scalars['Float']>;
  /** Number of devices in the specified selection set that are currently excluded (use custom setpoint profiles). */
  excludedDevicesCustom?: Maybe<Scalars['Float']>;
  /** Number of devices in the specified selection set that are currently excluded (use unit-level setpoint profiles). */
  excludedDevicesUnit?: Maybe<Scalars['Float']>;
  /** Setpoint Profile Name. */
  name?: Maybe<Scalars['String']>;
  /** Number of devices in the specified selection set that are currently online. */
  onlineDevices?: Maybe<Scalars['Float']>;
  /** Total number of devices in the (possibly filtered) selection set that could be affected by changes to this setpoint profile. */
  totalDevices?: Maybe<Scalars['Float']>;
};

export type SmartPowerOutlet = DeviceInterface & {
  __typename: 'SmartPowerOutlet';
  _id: Scalars['String'];
  activePower?: Maybe<SmartPowerOutletActivePower>;
  adjustedCumulativePower?: Maybe<SmartPowerOutletAdjustedCumulativePower>;
  alertTypes?: Maybe<DeviceAlertTypes>;
  apparentPower?: Maybe<SmartPowerOutletApparentPower>;
  chartTypes: Array<ChartType>;
  controlled?: Maybe<DeviceControlled>;
  cumulativePower?: Maybe<SmartPowerOutletCumulativePower>;
  cumulativePowerOffset?: Maybe<Scalars['Float']>;
  cumulativePowerResetTime?: Maybe<Scalars['Float']>;
  dependentDeviceIds: Array<Maybe<Scalars['String']>>;
  deviceAlerts: Array<Maybe<Alert>>;
  deviceId?: Maybe<Scalars['String']>;
  deviceIdentifier?: Maybe<Scalars['String']>;
  deviceMetrics?: Maybe<Array<Maybe<DeviceMetric>>>;
  displayName?: Maybe<Scalars['String']>;
  hasPendingUpdates: Scalars['Boolean'];
  installation?: Maybe<DeviceInstallation>;
  isConfigured?: Maybe<Scalars['Boolean']>;
  isControlled: Scalars['Boolean'];
  isOn?: Maybe<SmartPowerOutletIsOn>;
  isPoweredOn?: Maybe<Scalars['Boolean']>;
  location?: Maybe<Scalars['String']>;
  meta?: Maybe<DeviceMeta>;
  modelChangeOperation?: Maybe<Scalars['String']>;
  modelType?: Maybe<Scalars['String']>;
  /** The name of the device */
  name?: Maybe<Scalars['String']>;
  panel?: Maybe<Panel>;
  panelId?: Maybe<Scalars['String']>;
  powerFactor?: Maybe<SmartPowerOutletPowerFactor>;
  powerState?: Maybe<DevicePowerState>;
  property?: Maybe<Property>;
  propertyId: Scalars['String'];
  rmsCurrent?: Maybe<SmartPowerOutletRmsCurrent>;
  rmsVoltage?: Maybe<SmartPowerOutletRmsVoltage>;
  source?: Maybe<Source>;
  sourceAlerts: Array<Maybe<Alert>>;
  sourceId?: Maybe<Scalars['String']>;
  timestamp?: Maybe<Scalars['Float']>;
  type?: Maybe<EnumDKeyDeviceType>;
  typeDisplayName: Scalars['String'];
  unit?: Maybe<Unit>;
  unitId: Scalars['String'];
  updateDescription?: Maybe<Scalars['JSON']>;
  updateStatus?: Maybe<Scalars['Boolean']>;
  vpp?: Maybe<VirtualPowerPlant>;
  vppId?: Maybe<Scalars['String']>;
  zone?: Maybe<Zone>;
  zoneId?: Maybe<Scalars['String']>;
};

export type SmartPowerOutletDeviceAlertsArgs = {
  filter?: InputMaybe<FilterFindManyAlertInput>;
  limit?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<SortFindManyAlertInput>;
};

export type SmartPowerOutletSourceAlertsArgs = {
  filter?: InputMaybe<FilterFindManyAlertInput>;
  limit?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<SortFindManyAlertInput>;
};

export type SmartPowerOutletActivePower = {
  __typename?: 'SmartPowerOutletActivePower';
  id?: Maybe<Scalars['String']>;
  observedAt?: Maybe<Scalars['Float']>;
  previousId?: Maybe<Scalars['String']>;
  timestamp?: Maybe<Scalars['Float']>;
  units?: Maybe<Scalars['String']>;
  updatePending?: Maybe<Scalars['Boolean']>;
  value?: Maybe<Scalars['Float']>;
};

export type SmartPowerOutletAdjustedCumulativePower = {
  __typename?: 'SmartPowerOutletAdjustedCumulativePower';
  id?: Maybe<Scalars['String']>;
  previousId?: Maybe<Scalars['String']>;
  timestamp?: Maybe<Scalars['Float']>;
  units?: Maybe<Scalars['String']>;
  updatePending?: Maybe<Scalars['Boolean']>;
  value?: Maybe<Scalars['Float']>;
};

export type SmartPowerOutletAdjustment = AdjustmentInterface & {
  __typename?: 'SmartPowerOutletAdjustment';
  isOn?: Maybe<Scalars['Boolean']>;
  type: Scalars['String'];
};

export type SmartPowerOutletApparentPower = {
  __typename?: 'SmartPowerOutletApparentPower';
  id?: Maybe<Scalars['String']>;
  observedAt?: Maybe<Scalars['Float']>;
  previousId?: Maybe<Scalars['String']>;
  timestamp?: Maybe<Scalars['Float']>;
  units?: Maybe<Scalars['String']>;
  updatePending?: Maybe<Scalars['Boolean']>;
  value?: Maybe<Scalars['Float']>;
};

export type SmartPowerOutletCumulativePower = {
  __typename?: 'SmartPowerOutletCumulativePower';
  id?: Maybe<Scalars['String']>;
  observedAt?: Maybe<Scalars['Float']>;
  previousId?: Maybe<Scalars['String']>;
  timestamp?: Maybe<Scalars['Float']>;
  units?: Maybe<Scalars['String']>;
  updatePending?: Maybe<Scalars['Boolean']>;
  value?: Maybe<Scalars['Float']>;
};

export type SmartPowerOutletIsOn = {
  __typename?: 'SmartPowerOutletIsOn';
  id?: Maybe<Scalars['String']>;
  observedAt?: Maybe<Scalars['Float']>;
  previousId?: Maybe<Scalars['String']>;
  timestamp?: Maybe<Scalars['Float']>;
  units?: Maybe<Scalars['String']>;
  updatePending?: Maybe<Scalars['Boolean']>;
  value?: Maybe<Scalars['Boolean']>;
};

export type SmartPowerOutletPowerFactor = {
  __typename?: 'SmartPowerOutletPowerFactor';
  id?: Maybe<Scalars['String']>;
  observedAt?: Maybe<Scalars['Float']>;
  previousId?: Maybe<Scalars['String']>;
  timestamp?: Maybe<Scalars['Float']>;
  units?: Maybe<Scalars['String']>;
  updatePending?: Maybe<Scalars['Boolean']>;
  value?: Maybe<Scalars['Float']>;
};

export type SmartPowerOutletResetCumulativePowerOptions = {
  revertToRaw?: InputMaybe<Scalars['Boolean']>;
};

export type SmartPowerOutletRmsCurrent = {
  __typename?: 'SmartPowerOutletRmsCurrent';
  id?: Maybe<Scalars['String']>;
  observedAt?: Maybe<Scalars['Float']>;
  previousId?: Maybe<Scalars['String']>;
  timestamp?: Maybe<Scalars['Float']>;
  units?: Maybe<Scalars['String']>;
  updatePending?: Maybe<Scalars['Boolean']>;
  value?: Maybe<Scalars['Float']>;
};

export type SmartPowerOutletRmsVoltage = {
  __typename?: 'SmartPowerOutletRmsVoltage';
  id?: Maybe<Scalars['String']>;
  observedAt?: Maybe<Scalars['Float']>;
  previousId?: Maybe<Scalars['String']>;
  timestamp?: Maybe<Scalars['Float']>;
  units?: Maybe<Scalars['String']>;
  updatePending?: Maybe<Scalars['Boolean']>;
  value?: Maybe<Scalars['Float']>;
};

export type SmartPowerOutletUpdateInput = {
  isOn: Scalars['Boolean'];
};

export type SmartPowerOutletUpdateOptions = {
  forcePush?: InputMaybe<Scalars['Boolean']>;
};

export type SolarManagementSystem = DeviceInterface & {
  __typename: 'SolarManagementSystem';
  _id: Scalars['String'];
  alertTypes?: Maybe<DeviceAlertTypes>;
  azimuth?: Maybe<SolarManagementSystemAzimuth>;
  chartTypes: Array<ChartType>;
  controlled?: Maybe<DeviceControlled>;
  degradationRate?: Maybe<SolarManagementSystemDegradationRate>;
  dependentDeviceIds: Array<Maybe<Scalars['String']>>;
  deviceAlerts: Array<Maybe<Alert>>;
  deviceId?: Maybe<Scalars['String']>;
  deviceIdentifier?: Maybe<Scalars['String']>;
  deviceMetrics?: Maybe<Array<Maybe<DeviceMetric>>>;
  displayName?: Maybe<Scalars['String']>;
  hasPendingUpdates: Scalars['Boolean'];
  installation?: Maybe<DeviceInstallation>;
  isConfigured?: Maybe<Scalars['Boolean']>;
  isControlled: Scalars['Boolean'];
  isPoweredOn?: Maybe<Scalars['Boolean']>;
  isTrackerSystem?: Maybe<SolarManagementSystemIsTrackerSystem>;
  location?: Maybe<Scalars['String']>;
  meta?: Maybe<DeviceMeta>;
  modelChangeOperation?: Maybe<Scalars['String']>;
  modelType?: Maybe<Scalars['String']>;
  /** The name of the device */
  name?: Maybe<Scalars['String']>;
  panel?: Maybe<Panel>;
  panelCurrents?: Maybe<Array<Maybe<SolarManagementSystemPanelCurrents>>>;
  panelId?: Maybe<Scalars['String']>;
  panelTemperature?: Maybe<SolarManagementSystemPanelTemperature>;
  panelVoltages?: Maybe<Array<Maybe<SolarManagementSystemPanelVoltages>>>;
  powerState?: Maybe<DevicePowerState>;
  property?: Maybe<Property>;
  propertyId: Scalars['String'];
  shadingFactor?: Maybe<SolarManagementSystemShadingFactor>;
  solarIrradiance?: Maybe<SolarManagementSystemSolarIrradiance>;
  source?: Maybe<Source>;
  sourceAlerts: Array<Maybe<Alert>>;
  sourceId?: Maybe<Scalars['String']>;
  tiltAngle?: Maybe<SolarManagementSystemTiltAngle>;
  timestamp?: Maybe<Scalars['Float']>;
  type?: Maybe<EnumDKeyDeviceType>;
  typeDisplayName: Scalars['String'];
  unit?: Maybe<Unit>;
  unitId: Scalars['String'];
  updateDescription?: Maybe<Scalars['JSON']>;
  updateStatus?: Maybe<Scalars['Boolean']>;
  vpp?: Maybe<VirtualPowerPlant>;
  vppId?: Maybe<Scalars['String']>;
  zone?: Maybe<Zone>;
  zoneId?: Maybe<Scalars['String']>;
};

export type SolarManagementSystemDeviceAlertsArgs = {
  filter?: InputMaybe<FilterFindManyAlertInput>;
  limit?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<SortFindManyAlertInput>;
};

export type SolarManagementSystemSourceAlertsArgs = {
  filter?: InputMaybe<FilterFindManyAlertInput>;
  limit?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<SortFindManyAlertInput>;
};

export type SolarManagementSystemAzimuth = {
  __typename?: 'SolarManagementSystemAzimuth';
  id?: Maybe<Scalars['String']>;
  observedAt?: Maybe<Scalars['Float']>;
  previousId?: Maybe<Scalars['String']>;
  timestamp?: Maybe<Scalars['Float']>;
  units?: Maybe<Scalars['String']>;
  updatePending?: Maybe<Scalars['Boolean']>;
  value?: Maybe<Scalars['Float']>;
};

export type SolarManagementSystemDegradationRate = {
  __typename?: 'SolarManagementSystemDegradationRate';
  id?: Maybe<Scalars['String']>;
  observedAt?: Maybe<Scalars['Float']>;
  previousId?: Maybe<Scalars['String']>;
  timestamp?: Maybe<Scalars['Float']>;
  units?: Maybe<Scalars['String']>;
  updatePending?: Maybe<Scalars['Boolean']>;
  value?: Maybe<Scalars['Float']>;
};

export type SolarManagementSystemIsTrackerSystem = {
  __typename?: 'SolarManagementSystemIsTrackerSystem';
  id?: Maybe<Scalars['String']>;
  observedAt?: Maybe<Scalars['Float']>;
  previousId?: Maybe<Scalars['String']>;
  timestamp?: Maybe<Scalars['Float']>;
  units?: Maybe<Scalars['String']>;
  updatePending?: Maybe<Scalars['Boolean']>;
  value?: Maybe<Scalars['Boolean']>;
};

export type SolarManagementSystemPanelCurrents = {
  __typename?: 'SolarManagementSystemPanelCurrents';
  id?: Maybe<Scalars['String']>;
  observedAt?: Maybe<Scalars['Float']>;
  previousId?: Maybe<Scalars['String']>;
  timestamp?: Maybe<Scalars['Float']>;
  units?: Maybe<Scalars['String']>;
  updatePending?: Maybe<Scalars['Boolean']>;
  value?: Maybe<Scalars['Float']>;
};

export type SolarManagementSystemPanelTemperature = {
  __typename?: 'SolarManagementSystemPanelTemperature';
  id?: Maybe<Scalars['String']>;
  observedAt?: Maybe<Scalars['Float']>;
  previousId?: Maybe<Scalars['String']>;
  timestamp?: Maybe<Scalars['Float']>;
  units?: Maybe<Scalars['String']>;
  updatePending?: Maybe<Scalars['Boolean']>;
  value?: Maybe<Scalars['Float']>;
};

export type SolarManagementSystemPanelVoltages = {
  __typename?: 'SolarManagementSystemPanelVoltages';
  id?: Maybe<Scalars['String']>;
  observedAt?: Maybe<Scalars['Float']>;
  previousId?: Maybe<Scalars['String']>;
  timestamp?: Maybe<Scalars['Float']>;
  units?: Maybe<Scalars['String']>;
  updatePending?: Maybe<Scalars['Boolean']>;
  value?: Maybe<Scalars['Float']>;
};

export type SolarManagementSystemShadingFactor = {
  __typename?: 'SolarManagementSystemShadingFactor';
  id?: Maybe<Scalars['String']>;
  observedAt?: Maybe<Scalars['Float']>;
  previousId?: Maybe<Scalars['String']>;
  timestamp?: Maybe<Scalars['Float']>;
  units?: Maybe<Scalars['String']>;
  updatePending?: Maybe<Scalars['Boolean']>;
  value?: Maybe<Scalars['Float']>;
};

export type SolarManagementSystemSolarIrradiance = {
  __typename?: 'SolarManagementSystemSolarIrradiance';
  id?: Maybe<Scalars['String']>;
  observedAt?: Maybe<Scalars['Float']>;
  previousId?: Maybe<Scalars['String']>;
  timestamp?: Maybe<Scalars['Float']>;
  units?: Maybe<Scalars['String']>;
  updatePending?: Maybe<Scalars['Boolean']>;
  value?: Maybe<Scalars['Float']>;
};

export type SolarManagementSystemTiltAngle = {
  __typename?: 'SolarManagementSystemTiltAngle';
  id?: Maybe<Scalars['String']>;
  observedAt?: Maybe<Scalars['Float']>;
  previousId?: Maybe<Scalars['String']>;
  timestamp?: Maybe<Scalars['Float']>;
  units?: Maybe<Scalars['String']>;
  updatePending?: Maybe<Scalars['Boolean']>;
  value?: Maybe<Scalars['Float']>;
};

export enum SortFindByIdsActuatorInput {
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC',
}

export enum SortFindByIdsAlertCategoryInput {
  PropertyidAsc = 'PROPERTYID_ASC',
  PropertyidDesc = 'PROPERTYID_DESC',
  PropertyidKeyAsc = 'PROPERTYID__KEY_ASC',
  PropertyidKeyDesc = 'PROPERTYID__KEY_DESC',
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC',
}

export enum SortFindByIdsAlertInput {
  PropertyIdAsc = 'PROPERTY__ID_ASC',
  PropertyIdDesc = 'PROPERTY__ID_DESC',
  UnitIdAsc = 'UNIT__ID_ASC',
  UnitIdDesc = 'UNIT__ID_DESC',
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC',
}

export enum SortFindByIdsAlertNotificationInput {
  AlertidAsc = 'ALERTID_ASC',
  AlertidDesc = 'ALERTID_DESC',
  AlertidRecipientAsc = 'ALERTID__RECIPIENT_ASC',
  AlertidRecipientDesc = 'ALERTID__RECIPIENT_DESC',
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC',
}

export enum SortFindByIdsAlertOptOutInput {
  RecipientAsc = 'RECIPIENT_ASC',
  RecipientDesc = 'RECIPIENT_DESC',
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC',
}

export enum SortFindByIdsAlertSubscriptionInput {
  AlerttriggeridAsc = 'ALERTTRIGGERID_ASC',
  AlerttriggeridDesc = 'ALERTTRIGGERID_DESC',
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC',
}

export enum SortFindByIdsAlertTriggerInput {
  PropertyidAsc = 'PROPERTYID_ASC',
  PropertyidDesc = 'PROPERTYID_DESC',
  PropertyidKeyAsc = 'PROPERTYID__KEY_ASC',
  PropertyidKeyDesc = 'PROPERTYID__KEY_DESC',
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC',
}

export enum SortFindByIdsAuthenticationProfileInput {
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC',
}

export enum SortFindByIdsAuthenticatorDeviceInput {
  UseridAsc = 'USERID_ASC',
  UseridDesc = 'USERID_DESC',
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC',
}

export enum SortFindByIdsAuthorizationProfileInput {
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC',
}

export enum SortFindByIdsBngInput {
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC',
}

export enum SortFindByIdsBatteryManagementSystemInput {
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC',
}

export enum SortFindByIdsBoilerInput {
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC',
}

export enum SortFindByIdsBuildingInput {
  NameAsc = 'NAME_ASC',
  NameDesc = 'NAME_DESC',
  NamePropertyidAsc = 'NAME__PROPERTYID_ASC',
  NamePropertyidDesc = 'NAME__PROPERTYID_DESC',
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC',
}

export enum SortFindByIdsChillerInput {
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC',
}

export enum SortFindByIdsConductorGenericSensorInput {
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC',
}

export enum SortFindByIdsConductorInput {
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC',
}

export enum SortFindByIdsControlGroupInput {
  DevicesDeviceidAsc = 'DEVICES__DEVICEID_ASC',
  DevicesDeviceidDesc = 'DEVICES__DEVICEID_DESC',
  PropertyidAsc = 'PROPERTYID_ASC',
  PropertyidDesc = 'PROPERTYID_DESC',
  UnitidAsc = 'UNITID_ASC',
  UnitidDesc = 'UNITID_DESC',
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC',
}

export enum SortFindByIdsControllerInput {
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC',
}

export enum SortFindByIdsCoreInput {
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC',
}

export enum SortFindByIdsDataExportJobInput {
  PropertyidAsc = 'PROPERTYID_ASC',
  PropertyidDesc = 'PROPERTYID_DESC',
  PropertyidStartdateAsc = 'PROPERTYID__STARTDATE_ASC',
  PropertyidStartdateDesc = 'PROPERTYID__STARTDATE_DESC',
  PropertyidStartdateEnddateAsc = 'PROPERTYID__STARTDATE__ENDDATE_ASC',
  PropertyidStartdateEnddateDesc = 'PROPERTYID__STARTDATE__ENDDATE_DESC',
  RequestedbyuseridAsc = 'REQUESTEDBYUSERID_ASC',
  RequestedbyuseridDesc = 'REQUESTEDBYUSERID_DESC',
  RequestedbyuseridSubmittedatAsc = 'REQUESTEDBYUSERID__SUBMITTEDAT_ASC',
  RequestedbyuseridSubmittedatDesc = 'REQUESTEDBYUSERID__SUBMITTEDAT_DESC',
  StatusAsc = 'STATUS_ASC',
  StatusDesc = 'STATUS_DESC',
  StatusUpdatedatAsc = 'STATUS__UPDATEDAT_ASC',
  StatusUpdatedatDesc = 'STATUS__UPDATEDAT_DESC',
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC',
}

export enum SortFindByIdsDeviceInput {
  NameAsc = 'NAME_ASC',
  NameDesc = 'NAME_DESC',
  PropertyidAsc = 'PROPERTYID_ASC',
  PropertyidDesc = 'PROPERTYID_DESC',
  TypeAsc = 'TYPE_ASC',
  TypeDesc = 'TYPE_DESC',
  UnitidAsc = 'UNITID_ASC',
  UnitidDesc = 'UNITID_DESC',
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC',
}

export enum SortFindByIdsDeviceReadingInput {
  DeviceuidAsc = 'DEVICEUID_ASC',
  DeviceuidDesc = 'DEVICEUID_DESC',
  DeviceuidDatetimeAsc = 'DEVICEUID__DATETIME_ASC',
  DeviceuidDatetimeDesc = 'DEVICEUID__DATETIME_DESC',
  DeviceuidDatetimeMeasurementtypeAsc = 'DEVICEUID__DATETIME__MEASUREMENTTYPE_ASC',
  DeviceuidDatetimeMeasurementtypeDesc = 'DEVICEUID__DATETIME__MEASUREMENTTYPE_DESC',
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC',
}

export enum SortFindByIdsDoorSensorInput {
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC',
}

export enum SortFindByIdsEnergyConsumerBuildingInput {
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC',
}

export enum SortFindByIdsEnergyConsumerTenantInput {
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC',
}

export enum SortFindByIdsEnergyConsumerUtilityInput {
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC',
}

export enum SortFindByIdsEnergyControllerInput {
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC',
}

export enum SortFindByIdsEnergyConverterInput {
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC',
}

export enum SortFindByIdsEnergyInverterInput {
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC',
}

export enum SortFindByIdsEnergyMeterInput {
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC',
}

export enum SortFindByIdsEnergyRectifierInput {
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC',
}

export enum SortFindByIdsEnergyStorageBatterySystemInput {
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC',
}

export enum SortFindByIdsEnergyStorageCoolingSystemInput {
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC',
}

export enum SortFindByIdsEnergyStorageKineticSystemInput {
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC',
}

export enum SortFindByIdsEnergySupplierSolarSystemInput {
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC',
}

export enum SortFindByIdsEnergySupplierUtilityInput {
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC',
}

export enum SortFindByIdsEnergySupplierWindSystemInput {
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC',
}

export enum SortFindByIdsEnergySwitchPanelCircuitInput {
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC',
}

export enum SortFindByIdsEnergySwitchPanelInput {
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC',
}

export enum SortFindByIdsFireSuppressionSystemInput {
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC',
}

export enum SortFindByIdsFloorInput {
  NameAsc = 'NAME_ASC',
  NameDesc = 'NAME_DESC',
  NamePropertyidAsc = 'NAME__PROPERTYID_ASC',
  NamePropertyidDesc = 'NAME__PROPERTYID_DESC',
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC',
}

export enum SortFindByIdsGpioInput {
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC',
}

export enum SortFindByIdsHmmInput {
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC',
}

export enum SortFindByIdsHistoricAlertInput {
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC',
}

export enum SortFindByIdsHistoricReadingInput {
  DeviceidAsc = 'DEVICEID_ASC',
  DeviceidDesc = 'DEVICEID_DESC',
  DeviceidTypeAsc = 'DEVICEID__TYPE_ASC',
  DeviceidTypeDesc = 'DEVICEID__TYPE_DESC',
  DeviceidTypeTimestampAsc = 'DEVICEID__TYPE__TIMESTAMP_ASC',
  DeviceidTypeTimestampDesc = 'DEVICEID__TYPE__TIMESTAMP_DESC',
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC',
}

export enum SortFindByIdsIndoorAirHandlerInput {
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC',
}

export enum SortFindByIdsIndoorSensorInput {
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC',
}

export enum SortFindByIdsIngestionInput {
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC',
}

export enum SortFindByIdsKineticEnergyManagementSystemInput {
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC',
}

export enum SortFindByIdsLeakDetectorInput {
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC',
}

export enum SortFindByIdsLoopInput {
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC',
}

export enum SortFindByIdsModbusAirHandlerInput {
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC',
}

export enum SortFindByIdsOauthAccessTokenInput {
  ClientidAsc = 'CLIENTID_ASC',
  ClientidDesc = 'CLIENTID_DESC',
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC',
}

export enum SortFindByIdsOauthAuthCodeInput {
  ClientidAsc = 'CLIENTID_ASC',
  ClientidDesc = 'CLIENTID_DESC',
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC',
}

export enum SortFindByIdsOauthClientInput {
  ClientidAsc = 'CLIENTID_ASC',
  ClientidDesc = 'CLIENTID_DESC',
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC',
}

export enum SortFindByIdsOccupancySensorInput {
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC',
}

export enum SortFindByIdsOpenWeatherInput {
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC',
}

export enum SortFindByIdsOrganizationInput {
  NameAsc = 'NAME_ASC',
  NameDesc = 'NAME_DESC',
  ParentorganizationidAsc = 'PARENTORGANIZATIONID_ASC',
  ParentorganizationidDesc = 'PARENTORGANIZATIONID_DESC',
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC',
}

export enum SortFindByIdsOutdoorSensorInput {
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC',
}

export enum SortFindByIdsPanelInput {
  PropertyidAsc = 'PROPERTYID_ASC',
  PropertyidDesc = 'PROPERTYID_DESC',
  UnitidAsc = 'UNITID_ASC',
  UnitidDesc = 'UNITID_DESC',
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC',
}

export enum SortFindByIdsPlmContractInput {
  ContractidAsc = 'CONTRACTID_ASC',
  ContractidDesc = 'CONTRACTID_DESC',
  ManageridAsc = 'MANAGERID_ASC',
  ManageridDesc = 'MANAGERID_DESC',
  NotificationemailAsc = 'NOTIFICATIONEMAIL_ASC',
  NotificationemailDesc = 'NOTIFICATIONEMAIL_DESC',
  ProgramidAsc = 'PROGRAMID_ASC',
  ProgramidDesc = 'PROGRAMID_DESC',
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC',
}

export enum SortFindByIdsPlmCurtailmentActionInput {
  DevicetypeAsc = 'DEVICETYPE_ASC',
  DevicetypeDesc = 'DEVICETYPE_DESC',
  EstimatedreductionkwAsc = 'ESTIMATEDREDUCTIONKW_ASC',
  EstimatedreductionkwDesc = 'ESTIMATEDREDUCTIONKW_DESC',
  PlmcurtailmentplanidAsc = 'PLMCURTAILMENTPLANID_ASC',
  PlmcurtailmentplanidDesc = 'PLMCURTAILMENTPLANID_DESC',
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC',
}

export enum SortFindByIdsPlmCurtailmentPlanInput {
  DurationminutesAsc = 'DURATIONMINUTES_ASC',
  DurationminutesDesc = 'DURATIONMINUTES_DESC',
  EstimatedreductionkwAsc = 'ESTIMATEDREDUCTIONKW_ASC',
  EstimatedreductionkwDesc = 'ESTIMATEDREDUCTIONKW_DESC',
  NameAsc = 'NAME_ASC',
  NameDesc = 'NAME_DESC',
  OrganizationidAsc = 'ORGANIZATIONID_ASC',
  OrganizationidDesc = 'ORGANIZATIONID_DESC',
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC',
}

export enum SortFindByIdsPlmCurtailmentTaskInput {
  DeviceidAsc = 'DEVICEID_ASC',
  DeviceidDesc = 'DEVICEID_DESC',
  DeviceidPlmcurtailmentactionidAsc = 'DEVICEID__PLMCURTAILMENTACTIONID_ASC',
  DeviceidPlmcurtailmentactionidDesc = 'DEVICEID__PLMCURTAILMENTACTIONID_DESC',
  DeviceidPlmcurtailmentactionidPlmeventresponseidAsc = 'DEVICEID__PLMCURTAILMENTACTIONID__PLMEVENTRESPONSEID_ASC',
  DeviceidPlmcurtailmentactionidPlmeventresponseidDesc = 'DEVICEID__PLMCURTAILMENTACTIONID__PLMEVENTRESPONSEID_DESC',
  DeviceidPlmcurtailmentactionidPlmeventresponseidBatchidAsc = 'DEVICEID__PLMCURTAILMENTACTIONID__PLMEVENTRESPONSEID__BATCHID_ASC',
  DeviceidPlmcurtailmentactionidPlmeventresponseidBatchidDesc = 'DEVICEID__PLMCURTAILMENTACTIONID__PLMEVENTRESPONSEID__BATCHID_DESC',
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC',
}

export enum SortFindByIdsPlmEventInput {
  ContractidAsc = 'CONTRACTID_ASC',
  ContractidDesc = 'CONTRACTID_DESC',
  ProgramidAsc = 'PROGRAMID_ASC',
  ProgramidDesc = 'PROGRAMID_DESC',
  SourcevendorAsc = 'SOURCEVENDOR_ASC',
  SourcevendorDesc = 'SOURCEVENDOR_DESC',
  SourcevendorSourceexternalidAsc = 'SOURCEVENDOR__SOURCEEXTERNALID_ASC',
  SourcevendorSourceexternalidDesc = 'SOURCEVENDOR__SOURCEEXTERNALID_DESC',
  StarttimeAsc = 'STARTTIME_ASC',
  StarttimeDesc = 'STARTTIME_DESC',
  StatusAsc = 'STATUS_ASC',
  StatusDesc = 'STATUS_DESC',
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC',
}

export enum SortFindByIdsPlmEventResponseInput {
  CurtailmentplanidAsc = 'CURTAILMENTPLANID_ASC',
  CurtailmentplanidDesc = 'CURTAILMENTPLANID_DESC',
  EventidAsc = 'EVENTID_ASC',
  EventidDesc = 'EVENTID_DESC',
  PropertyidAsc = 'PROPERTYID_ASC',
  PropertyidDesc = 'PROPERTYID_DESC',
  ResponsesentatAsc = 'RESPONSESENTAT_ASC',
  ResponsesentatDesc = 'RESPONSESENTAT_DESC',
  ResponsestatusAsc = 'RESPONSESTATUS_ASC',
  ResponsestatusDesc = 'RESPONSESTATUS_DESC',
  ScheduledstartAsc = 'SCHEDULEDSTART_ASC',
  ScheduledstartDesc = 'SCHEDULEDSTART_DESC',
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC',
}

export enum SortFindByIdsPlmExternalMeterMappingInput {
  PropertyidAsc = 'PROPERTYID_ASC',
  PropertyidDesc = 'PROPERTYID_DESC',
  VendorAsc = 'VENDOR_ASC',
  VendorDesc = 'VENDOR_DESC',
  VendorPartneridAsc = 'VENDOR__PARTNERID_ASC',
  VendorPartneridDesc = 'VENDOR__PARTNERID_DESC',
  VendorPartneridPropertyidAsc = 'VENDOR__PARTNERID__PROPERTYID_ASC',
  VendorPartneridPropertyidDesc = 'VENDOR__PARTNERID__PROPERTYID_DESC',
  VendorPartneridPropertyidMeteridAsc = 'VENDOR__PARTNERID__PROPERTYID__METERID_ASC',
  VendorPartneridPropertyidMeteridDesc = 'VENDOR__PARTNERID__PROPERTYID__METERID_DESC',
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC',
}

export enum SortFindByIdsPlmIngressEventInput {
  StatusAsc = 'STATUS_ASC',
  StatusDesc = 'STATUS_DESC',
  StatusReceivedatAsc = 'STATUS__RECEIVEDAT_ASC',
  StatusReceivedatDesc = 'STATUS__RECEIVEDAT_DESC',
  VendorkeyAsc = 'VENDORKEY_ASC',
  VendorkeyDesc = 'VENDORKEY_DESC',
  VendorkeyReceivedatAsc = 'VENDORKEY__RECEIVEDAT_ASC',
  VendorkeyReceivedatDesc = 'VENDORKEY__RECEIVEDAT_DESC',
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC',
}

export enum SortFindByIdsPlmNotificationInput {
  ActivationtimeAsc = 'ACTIVATIONTIME_ASC',
  ActivationtimeDesc = 'ACTIVATIONTIME_DESC',
  ContractidAsc = 'CONTRACTID_ASC',
  ContractidDesc = 'CONTRACTID_DESC',
  PartneridAsc = 'PARTNERID_ASC',
  PartneridDesc = 'PARTNERID_DESC',
  ProgramidAsc = 'PROGRAMID_ASC',
  ProgramidDesc = 'PROGRAMID_DESC',
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC',
}

export enum SortFindByIdsPlmPartnerInput {
  NameAsc = 'NAME_ASC',
  NameDesc = 'NAME_DESC',
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC',
}

export enum SortFindByIdsPlmProgramInput {
  HostpartneridAsc = 'HOSTPARTNERID_ASC',
  HostpartneridDesc = 'HOSTPARTNERID_DESC',
  NameAsc = 'NAME_ASC',
  NameDesc = 'NAME_DESC',
  PartneridAsc = 'PARTNERID_ASC',
  PartneridDesc = 'PARTNERID_DESC',
  ProgramidAsc = 'PROGRAMID_ASC',
  ProgramidDesc = 'PROGRAMID_DESC',
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC',
}

export enum SortFindByIdsPlmUtilityInput {
  NameAsc = 'NAME_ASC',
  NameDesc = 'NAME_DESC',
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC',
}

export enum SortFindByIdsPowerMonitorInput {
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC',
}

export enum SortFindByIdsPressureSensorInput {
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC',
}

export enum SortFindByIdsPropertyInput {
  TitleAsc = 'TITLE_ASC',
  TitleDesc = 'TITLE_DESC',
  UnitssummaryCountAsc = 'UNITSSUMMARY__COUNT_ASC',
  UnitssummaryCountDesc = 'UNITSSUMMARY__COUNT_DESC',
  UnitssummaryMajoralertsAsc = 'UNITSSUMMARY__MAJORALERTS_ASC',
  UnitssummaryMajoralertsDesc = 'UNITSSUMMARY__MAJORALERTS_DESC',
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC',
}

export enum SortFindByIdsRelayDeviceInput {
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC',
}

export enum SortFindByIdsScheduledTaskInput {
  ModelnameAsc = 'MODELNAME_ASC',
  ModelnameDesc = 'MODELNAME_DESC',
  ModelnameInstanceidAsc = 'MODELNAME__INSTANCEID_ASC',
  ModelnameInstanceidDesc = 'MODELNAME__INSTANCEID_DESC',
  PriorityAsc = 'PRIORITY_ASC',
  PriorityDesc = 'PRIORITY_DESC',
  ScheduledatAsc = 'SCHEDULEDAT_ASC',
  ScheduledatDesc = 'SCHEDULEDAT_DESC',
  StatusAsc = 'STATUS_ASC',
  StatusDesc = 'STATUS_DESC',
  StatusScheduledatAsc = 'STATUS__SCHEDULEDAT_ASC',
  StatusScheduledatDesc = 'STATUS__SCHEDULEDAT_DESC',
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC',
}

export enum SortFindByIdsSetpointProfileInput {
  PropertiesAsc = 'PROPERTIES_ASC',
  PropertiesDesc = 'PROPERTIES_DESC',
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC',
}

export enum SortFindByIdsSmartPowerOutletInput {
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC',
}

export enum SortFindByIdsSolarManagementSystemInput {
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC',
}

export enum SortFindByIdsSourceInput {
  NameAsc = 'NAME_ASC',
  NameDesc = 'NAME_DESC',
  NamePropertyidAsc = 'NAME__PROPERTYID_ASC',
  NamePropertyidDesc = 'NAME__PROPERTYID_DESC',
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC',
}

export enum SortFindByIdsSystemNotificationInput {
  CreatedatAsc = 'CREATEDAT_ASC',
  CreatedatDesc = 'CREATEDAT_DESC',
  DisplayendAsc = 'DISPLAYEND_ASC',
  DisplayendDesc = 'DISPLAYEND_DESC',
  DisplaystartAsc = 'DISPLAYSTART_ASC',
  DisplaystartDesc = 'DISPLAYSTART_DESC',
  EntityidAsc = 'ENTITYID_ASC',
  EntityidDesc = 'ENTITYID_DESC',
  EntitytypeAsc = 'ENTITYTYPE_ASC',
  EntitytypeDesc = 'ENTITYTYPE_DESC',
  SeenbyUseridAsc = 'SEENBY__USERID_ASC',
  SeenbyUseridDesc = 'SEENBY__USERID_DESC',
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC',
  IdSeenbyUseridAsc = '_ID__SEENBY__USERID_ASC',
  IdSeenbyUseridDesc = '_ID__SEENBY__USERID_DESC',
}

export enum SortFindByIdsThermistorInput {
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC',
}

export enum SortFindByIdsThermostatInput {
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC',
}

export enum SortFindByIdsThermostatScheduleProfileInput {
  PropertyidAsc = 'PROPERTYID_ASC',
  PropertyidDesc = 'PROPERTYID_DESC',
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC',
}

export enum SortFindByIdsThermostatScheduleTemplateInput {
  PropertyidAsc = 'PROPERTYID_ASC',
  PropertyidDesc = 'PROPERTYID_DESC',
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC',
}

export enum SortFindByIdsUnitInput {
  BuildingidAsc = 'BUILDINGID_ASC',
  BuildingidDesc = 'BUILDINGID_DESC',
  NameAsc = 'NAME_ASC',
  NameDesc = 'NAME_DESC',
  PropertyidAsc = 'PROPERTYID_ASC',
  PropertyidDesc = 'PROPERTYID_DESC',
  PropertyidNameAsc = 'PROPERTYID__NAME_ASC',
  PropertyidNameDesc = 'PROPERTYID__NAME_DESC',
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC',
}

export enum SortFindByIdsUserHistoryInput {
  LastaccessedatAsc = 'LASTACCESSEDAT_ASC',
  LastaccessedatDesc = 'LASTACCESSEDAT_DESC',
  UseridAsc = 'USERID_ASC',
  UseridDesc = 'USERID_DESC',
  UseridDeviceidAsc = 'USERID__DEVICEID_ASC',
  UseridDeviceidDesc = 'USERID__DEVICEID_DESC',
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC',
}

export enum SortFindByIdsUserInput {
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC',
}

export enum SortFindByIdsVsdPumpInput {
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC',
}

export enum SortFindByIdsVirtualPowerPlantInput {
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC',
}

export enum SortFindByIdsWindManagementSystemInput {
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC',
}

export enum SortFindByIdsWindowSensorInput {
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC',
}

export enum SortFindByIdsZ210PumpInput {
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC',
}

export enum SortFindByIdsZoneInput {
  PropertyidAsc = 'PROPERTYID_ASC',
  PropertyidDesc = 'PROPERTYID_DESC',
  PropertyidZonepolicyidAsc = 'PROPERTYID__ZONEPOLICYID_ASC',
  PropertyidZonepolicyidDesc = 'PROPERTYID__ZONEPOLICYID_DESC',
  UnitidAsc = 'UNITID_ASC',
  UnitidDesc = 'UNITID_DESC',
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC',
}

export enum SortFindByIdsZonePolicyInput {
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC',
}

export enum SortFindManyActuatorInput {
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC',
}

export enum SortFindManyAlertCategoryInput {
  PropertyidAsc = 'PROPERTYID_ASC',
  PropertyidDesc = 'PROPERTYID_DESC',
  PropertyidKeyAsc = 'PROPERTYID__KEY_ASC',
  PropertyidKeyDesc = 'PROPERTYID__KEY_DESC',
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC',
}

export enum SortFindManyAlertInput {
  PropertyIdAsc = 'PROPERTY__ID_ASC',
  PropertyIdDesc = 'PROPERTY__ID_DESC',
  UnitIdAsc = 'UNIT__ID_ASC',
  UnitIdDesc = 'UNIT__ID_DESC',
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC',
}

export enum SortFindManyAlertNotificationInput {
  AlertidAsc = 'ALERTID_ASC',
  AlertidDesc = 'ALERTID_DESC',
  AlertidRecipientAsc = 'ALERTID__RECIPIENT_ASC',
  AlertidRecipientDesc = 'ALERTID__RECIPIENT_DESC',
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC',
}

export enum SortFindManyAlertOptOutInput {
  RecipientAsc = 'RECIPIENT_ASC',
  RecipientDesc = 'RECIPIENT_DESC',
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC',
}

export enum SortFindManyAlertSubscriptionInput {
  AlerttriggeridAsc = 'ALERTTRIGGERID_ASC',
  AlerttriggeridDesc = 'ALERTTRIGGERID_DESC',
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC',
}

export enum SortFindManyAlertTriggerInput {
  PropertyidAsc = 'PROPERTYID_ASC',
  PropertyidDesc = 'PROPERTYID_DESC',
  PropertyidKeyAsc = 'PROPERTYID__KEY_ASC',
  PropertyidKeyDesc = 'PROPERTYID__KEY_DESC',
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC',
}

export enum SortFindManyAuthenticationProfileInput {
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC',
}

export enum SortFindManyAuthenticatorDeviceInput {
  UseridAsc = 'USERID_ASC',
  UseridDesc = 'USERID_DESC',
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC',
}

export enum SortFindManyAuthorizationProfileInput {
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC',
}

export enum SortFindManyBngInput {
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC',
}

export enum SortFindManyBatteryManagementSystemInput {
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC',
}

export enum SortFindManyBoilerInput {
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC',
}

export enum SortFindManyBuildingInput {
  NameAsc = 'NAME_ASC',
  NameDesc = 'NAME_DESC',
  NamePropertyidAsc = 'NAME__PROPERTYID_ASC',
  NamePropertyidDesc = 'NAME__PROPERTYID_DESC',
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC',
}

export enum SortFindManyChillerInput {
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC',
}

export enum SortFindManyConductorGenericSensorInput {
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC',
}

export enum SortFindManyConductorInput {
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC',
}

export enum SortFindManyControlGroupInput {
  DevicesDeviceidAsc = 'DEVICES__DEVICEID_ASC',
  DevicesDeviceidDesc = 'DEVICES__DEVICEID_DESC',
  PropertyidAsc = 'PROPERTYID_ASC',
  PropertyidDesc = 'PROPERTYID_DESC',
  UnitidAsc = 'UNITID_ASC',
  UnitidDesc = 'UNITID_DESC',
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC',
}

export enum SortFindManyControllerInput {
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC',
}

export enum SortFindManyCoreInput {
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC',
}

export enum SortFindManyDataExportJobInput {
  PropertyidAsc = 'PROPERTYID_ASC',
  PropertyidDesc = 'PROPERTYID_DESC',
  PropertyidStartdateAsc = 'PROPERTYID__STARTDATE_ASC',
  PropertyidStartdateDesc = 'PROPERTYID__STARTDATE_DESC',
  PropertyidStartdateEnddateAsc = 'PROPERTYID__STARTDATE__ENDDATE_ASC',
  PropertyidStartdateEnddateDesc = 'PROPERTYID__STARTDATE__ENDDATE_DESC',
  RequestedbyuseridAsc = 'REQUESTEDBYUSERID_ASC',
  RequestedbyuseridDesc = 'REQUESTEDBYUSERID_DESC',
  RequestedbyuseridSubmittedatAsc = 'REQUESTEDBYUSERID__SUBMITTEDAT_ASC',
  RequestedbyuseridSubmittedatDesc = 'REQUESTEDBYUSERID__SUBMITTEDAT_DESC',
  StatusAsc = 'STATUS_ASC',
  StatusDesc = 'STATUS_DESC',
  StatusUpdatedatAsc = 'STATUS__UPDATEDAT_ASC',
  StatusUpdatedatDesc = 'STATUS__UPDATEDAT_DESC',
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC',
}

export enum SortFindManyDeviceInput {
  NameAsc = 'NAME_ASC',
  NameDesc = 'NAME_DESC',
  PropertyidAsc = 'PROPERTYID_ASC',
  PropertyidDesc = 'PROPERTYID_DESC',
  TypeAsc = 'TYPE_ASC',
  TypeDesc = 'TYPE_DESC',
  UnitidAsc = 'UNITID_ASC',
  UnitidDesc = 'UNITID_DESC',
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC',
}

export enum SortFindManyDeviceReadingInput {
  DeviceuidAsc = 'DEVICEUID_ASC',
  DeviceuidDesc = 'DEVICEUID_DESC',
  DeviceuidDatetimeAsc = 'DEVICEUID__DATETIME_ASC',
  DeviceuidDatetimeDesc = 'DEVICEUID__DATETIME_DESC',
  DeviceuidDatetimeMeasurementtypeAsc = 'DEVICEUID__DATETIME__MEASUREMENTTYPE_ASC',
  DeviceuidDatetimeMeasurementtypeDesc = 'DEVICEUID__DATETIME__MEASUREMENTTYPE_DESC',
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC',
}

export enum SortFindManyDoorSensorInput {
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC',
}

export enum SortFindManyEnergyConsumerBuildingInput {
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC',
}

export enum SortFindManyEnergyConsumerTenantInput {
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC',
}

export enum SortFindManyEnergyConsumerUtilityInput {
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC',
}

export enum SortFindManyEnergyControllerInput {
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC',
}

export enum SortFindManyEnergyConverterInput {
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC',
}

export enum SortFindManyEnergyInverterInput {
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC',
}

export enum SortFindManyEnergyMeterInput {
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC',
}

export enum SortFindManyEnergyRectifierInput {
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC',
}

export enum SortFindManyEnergyStorageBatterySystemInput {
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC',
}

export enum SortFindManyEnergyStorageCoolingSystemInput {
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC',
}

export enum SortFindManyEnergyStorageKineticSystemInput {
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC',
}

export enum SortFindManyEnergySupplierSolarSystemInput {
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC',
}

export enum SortFindManyEnergySupplierUtilityInput {
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC',
}

export enum SortFindManyEnergySupplierWindSystemInput {
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC',
}

export enum SortFindManyEnergySwitchPanelCircuitInput {
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC',
}

export enum SortFindManyEnergySwitchPanelInput {
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC',
}

export enum SortFindManyFireSuppressionSystemInput {
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC',
}

export enum SortFindManyFloorInput {
  NameAsc = 'NAME_ASC',
  NameDesc = 'NAME_DESC',
  NamePropertyidAsc = 'NAME__PROPERTYID_ASC',
  NamePropertyidDesc = 'NAME__PROPERTYID_DESC',
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC',
}

export enum SortFindManyGpioInput {
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC',
}

export enum SortFindManyHmmInput {
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC',
}

export enum SortFindManyHistoricAlertInput {
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC',
}

export enum SortFindManyHistoricReadingInput {
  DeviceidAsc = 'DEVICEID_ASC',
  DeviceidDesc = 'DEVICEID_DESC',
  DeviceidTypeAsc = 'DEVICEID__TYPE_ASC',
  DeviceidTypeDesc = 'DEVICEID__TYPE_DESC',
  DeviceidTypeTimestampAsc = 'DEVICEID__TYPE__TIMESTAMP_ASC',
  DeviceidTypeTimestampDesc = 'DEVICEID__TYPE__TIMESTAMP_DESC',
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC',
}

export enum SortFindManyIndoorAirHandlerInput {
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC',
}

export enum SortFindManyIndoorSensorInput {
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC',
}

export enum SortFindManyIngestionInput {
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC',
}

export enum SortFindManyKineticEnergyManagementSystemInput {
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC',
}

export enum SortFindManyLeakDetectorInput {
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC',
}

export enum SortFindManyLoopInput {
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC',
}

export enum SortFindManyModbusAirHandlerInput {
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC',
}

export enum SortFindManyOauthAccessTokenInput {
  ClientidAsc = 'CLIENTID_ASC',
  ClientidDesc = 'CLIENTID_DESC',
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC',
}

export enum SortFindManyOauthAuthCodeInput {
  ClientidAsc = 'CLIENTID_ASC',
  ClientidDesc = 'CLIENTID_DESC',
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC',
}

export enum SortFindManyOauthClientInput {
  ClientidAsc = 'CLIENTID_ASC',
  ClientidDesc = 'CLIENTID_DESC',
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC',
}

export enum SortFindManyOccupancySensorInput {
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC',
}

export enum SortFindManyOpenWeatherInput {
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC',
}

export enum SortFindManyOrganizationInput {
  NameAsc = 'NAME_ASC',
  NameDesc = 'NAME_DESC',
  ParentorganizationidAsc = 'PARENTORGANIZATIONID_ASC',
  ParentorganizationidDesc = 'PARENTORGANIZATIONID_DESC',
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC',
}

export enum SortFindManyOutdoorSensorInput {
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC',
}

export enum SortFindManyPanelInput {
  PropertyidAsc = 'PROPERTYID_ASC',
  PropertyidDesc = 'PROPERTYID_DESC',
  UnitidAsc = 'UNITID_ASC',
  UnitidDesc = 'UNITID_DESC',
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC',
}

export enum SortFindManyPlmContractInput {
  ContractidAsc = 'CONTRACTID_ASC',
  ContractidDesc = 'CONTRACTID_DESC',
  ManageridAsc = 'MANAGERID_ASC',
  ManageridDesc = 'MANAGERID_DESC',
  NotificationemailAsc = 'NOTIFICATIONEMAIL_ASC',
  NotificationemailDesc = 'NOTIFICATIONEMAIL_DESC',
  ProgramidAsc = 'PROGRAMID_ASC',
  ProgramidDesc = 'PROGRAMID_DESC',
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC',
}

export enum SortFindManyPlmCurtailmentActionInput {
  DevicetypeAsc = 'DEVICETYPE_ASC',
  DevicetypeDesc = 'DEVICETYPE_DESC',
  EstimatedreductionkwAsc = 'ESTIMATEDREDUCTIONKW_ASC',
  EstimatedreductionkwDesc = 'ESTIMATEDREDUCTIONKW_DESC',
  PlmcurtailmentplanidAsc = 'PLMCURTAILMENTPLANID_ASC',
  PlmcurtailmentplanidDesc = 'PLMCURTAILMENTPLANID_DESC',
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC',
}

export enum SortFindManyPlmCurtailmentPlanInput {
  DurationminutesAsc = 'DURATIONMINUTES_ASC',
  DurationminutesDesc = 'DURATIONMINUTES_DESC',
  EstimatedreductionkwAsc = 'ESTIMATEDREDUCTIONKW_ASC',
  EstimatedreductionkwDesc = 'ESTIMATEDREDUCTIONKW_DESC',
  NameAsc = 'NAME_ASC',
  NameDesc = 'NAME_DESC',
  OrganizationidAsc = 'ORGANIZATIONID_ASC',
  OrganizationidDesc = 'ORGANIZATIONID_DESC',
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC',
}

export enum SortFindManyPlmCurtailmentTaskInput {
  DeviceidAsc = 'DEVICEID_ASC',
  DeviceidDesc = 'DEVICEID_DESC',
  DeviceidPlmcurtailmentactionidAsc = 'DEVICEID__PLMCURTAILMENTACTIONID_ASC',
  DeviceidPlmcurtailmentactionidDesc = 'DEVICEID__PLMCURTAILMENTACTIONID_DESC',
  DeviceidPlmcurtailmentactionidPlmeventresponseidAsc = 'DEVICEID__PLMCURTAILMENTACTIONID__PLMEVENTRESPONSEID_ASC',
  DeviceidPlmcurtailmentactionidPlmeventresponseidDesc = 'DEVICEID__PLMCURTAILMENTACTIONID__PLMEVENTRESPONSEID_DESC',
  DeviceidPlmcurtailmentactionidPlmeventresponseidBatchidAsc = 'DEVICEID__PLMCURTAILMENTACTIONID__PLMEVENTRESPONSEID__BATCHID_ASC',
  DeviceidPlmcurtailmentactionidPlmeventresponseidBatchidDesc = 'DEVICEID__PLMCURTAILMENTACTIONID__PLMEVENTRESPONSEID__BATCHID_DESC',
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC',
}

export enum SortFindManyPlmEventInput {
  ContractidAsc = 'CONTRACTID_ASC',
  ContractidDesc = 'CONTRACTID_DESC',
  ProgramidAsc = 'PROGRAMID_ASC',
  ProgramidDesc = 'PROGRAMID_DESC',
  SourcevendorAsc = 'SOURCEVENDOR_ASC',
  SourcevendorDesc = 'SOURCEVENDOR_DESC',
  SourcevendorSourceexternalidAsc = 'SOURCEVENDOR__SOURCEEXTERNALID_ASC',
  SourcevendorSourceexternalidDesc = 'SOURCEVENDOR__SOURCEEXTERNALID_DESC',
  StarttimeAsc = 'STARTTIME_ASC',
  StarttimeDesc = 'STARTTIME_DESC',
  StatusAsc = 'STATUS_ASC',
  StatusDesc = 'STATUS_DESC',
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC',
}

export enum SortFindManyPlmEventResponseInput {
  CurtailmentplanidAsc = 'CURTAILMENTPLANID_ASC',
  CurtailmentplanidDesc = 'CURTAILMENTPLANID_DESC',
  EventidAsc = 'EVENTID_ASC',
  EventidDesc = 'EVENTID_DESC',
  PropertyidAsc = 'PROPERTYID_ASC',
  PropertyidDesc = 'PROPERTYID_DESC',
  ResponsesentatAsc = 'RESPONSESENTAT_ASC',
  ResponsesentatDesc = 'RESPONSESENTAT_DESC',
  ResponsestatusAsc = 'RESPONSESTATUS_ASC',
  ResponsestatusDesc = 'RESPONSESTATUS_DESC',
  ScheduledstartAsc = 'SCHEDULEDSTART_ASC',
  ScheduledstartDesc = 'SCHEDULEDSTART_DESC',
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC',
}

export enum SortFindManyPlmExternalMeterMappingInput {
  PropertyidAsc = 'PROPERTYID_ASC',
  PropertyidDesc = 'PROPERTYID_DESC',
  VendorAsc = 'VENDOR_ASC',
  VendorDesc = 'VENDOR_DESC',
  VendorPartneridAsc = 'VENDOR__PARTNERID_ASC',
  VendorPartneridDesc = 'VENDOR__PARTNERID_DESC',
  VendorPartneridPropertyidAsc = 'VENDOR__PARTNERID__PROPERTYID_ASC',
  VendorPartneridPropertyidDesc = 'VENDOR__PARTNERID__PROPERTYID_DESC',
  VendorPartneridPropertyidMeteridAsc = 'VENDOR__PARTNERID__PROPERTYID__METERID_ASC',
  VendorPartneridPropertyidMeteridDesc = 'VENDOR__PARTNERID__PROPERTYID__METERID_DESC',
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC',
}

export enum SortFindManyPlmIngressEventInput {
  StatusAsc = 'STATUS_ASC',
  StatusDesc = 'STATUS_DESC',
  StatusReceivedatAsc = 'STATUS__RECEIVEDAT_ASC',
  StatusReceivedatDesc = 'STATUS__RECEIVEDAT_DESC',
  VendorkeyAsc = 'VENDORKEY_ASC',
  VendorkeyDesc = 'VENDORKEY_DESC',
  VendorkeyReceivedatAsc = 'VENDORKEY__RECEIVEDAT_ASC',
  VendorkeyReceivedatDesc = 'VENDORKEY__RECEIVEDAT_DESC',
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC',
}

export enum SortFindManyPlmNotificationInput {
  ActivationtimeAsc = 'ACTIVATIONTIME_ASC',
  ActivationtimeDesc = 'ACTIVATIONTIME_DESC',
  ContractidAsc = 'CONTRACTID_ASC',
  ContractidDesc = 'CONTRACTID_DESC',
  PartneridAsc = 'PARTNERID_ASC',
  PartneridDesc = 'PARTNERID_DESC',
  ProgramidAsc = 'PROGRAMID_ASC',
  ProgramidDesc = 'PROGRAMID_DESC',
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC',
}

export enum SortFindManyPlmPartnerInput {
  NameAsc = 'NAME_ASC',
  NameDesc = 'NAME_DESC',
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC',
}

export enum SortFindManyPlmProgramInput {
  HostpartneridAsc = 'HOSTPARTNERID_ASC',
  HostpartneridDesc = 'HOSTPARTNERID_DESC',
  NameAsc = 'NAME_ASC',
  NameDesc = 'NAME_DESC',
  PartneridAsc = 'PARTNERID_ASC',
  PartneridDesc = 'PARTNERID_DESC',
  ProgramidAsc = 'PROGRAMID_ASC',
  ProgramidDesc = 'PROGRAMID_DESC',
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC',
}

export enum SortFindManyPlmUtilityInput {
  NameAsc = 'NAME_ASC',
  NameDesc = 'NAME_DESC',
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC',
}

export enum SortFindManyPowerMonitorInput {
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC',
}

export enum SortFindManyPressureSensorInput {
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC',
}

export enum SortFindManyPropertyInput {
  TitleAsc = 'TITLE_ASC',
  TitleDesc = 'TITLE_DESC',
  UnitssummaryCountAsc = 'UNITSSUMMARY__COUNT_ASC',
  UnitssummaryCountDesc = 'UNITSSUMMARY__COUNT_DESC',
  UnitssummaryMajoralertsAsc = 'UNITSSUMMARY__MAJORALERTS_ASC',
  UnitssummaryMajoralertsDesc = 'UNITSSUMMARY__MAJORALERTS_DESC',
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC',
}

export enum SortFindManyRelayDeviceInput {
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC',
}

export enum SortFindManyScheduledTaskInput {
  ModelnameAsc = 'MODELNAME_ASC',
  ModelnameDesc = 'MODELNAME_DESC',
  ModelnameInstanceidAsc = 'MODELNAME__INSTANCEID_ASC',
  ModelnameInstanceidDesc = 'MODELNAME__INSTANCEID_DESC',
  PriorityAsc = 'PRIORITY_ASC',
  PriorityDesc = 'PRIORITY_DESC',
  ScheduledatAsc = 'SCHEDULEDAT_ASC',
  ScheduledatDesc = 'SCHEDULEDAT_DESC',
  StatusAsc = 'STATUS_ASC',
  StatusDesc = 'STATUS_DESC',
  StatusScheduledatAsc = 'STATUS__SCHEDULEDAT_ASC',
  StatusScheduledatDesc = 'STATUS__SCHEDULEDAT_DESC',
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC',
}

export enum SortFindManySetpointProfileInput {
  PropertiesAsc = 'PROPERTIES_ASC',
  PropertiesDesc = 'PROPERTIES_DESC',
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC',
}

export enum SortFindManySmartPowerOutletInput {
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC',
}

export enum SortFindManySolarManagementSystemInput {
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC',
}

export enum SortFindManySourceInput {
  NameAsc = 'NAME_ASC',
  NameDesc = 'NAME_DESC',
  NamePropertyidAsc = 'NAME__PROPERTYID_ASC',
  NamePropertyidDesc = 'NAME__PROPERTYID_DESC',
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC',
}

export enum SortFindManySystemNotificationInput {
  CreatedatAsc = 'CREATEDAT_ASC',
  CreatedatDesc = 'CREATEDAT_DESC',
  DisplayendAsc = 'DISPLAYEND_ASC',
  DisplayendDesc = 'DISPLAYEND_DESC',
  DisplaystartAsc = 'DISPLAYSTART_ASC',
  DisplaystartDesc = 'DISPLAYSTART_DESC',
  EntityidAsc = 'ENTITYID_ASC',
  EntityidDesc = 'ENTITYID_DESC',
  EntitytypeAsc = 'ENTITYTYPE_ASC',
  EntitytypeDesc = 'ENTITYTYPE_DESC',
  SeenbyUseridAsc = 'SEENBY__USERID_ASC',
  SeenbyUseridDesc = 'SEENBY__USERID_DESC',
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC',
  IdSeenbyUseridAsc = '_ID__SEENBY__USERID_ASC',
  IdSeenbyUseridDesc = '_ID__SEENBY__USERID_DESC',
}

export enum SortFindManyThermistorInput {
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC',
}

export enum SortFindManyThermostatInput {
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC',
}

export enum SortFindManyThermostatScheduleProfileInput {
  PropertyidAsc = 'PROPERTYID_ASC',
  PropertyidDesc = 'PROPERTYID_DESC',
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC',
}

export enum SortFindManyThermostatScheduleTemplateInput {
  PropertyidAsc = 'PROPERTYID_ASC',
  PropertyidDesc = 'PROPERTYID_DESC',
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC',
}

export enum SortFindManyUnitInput {
  BuildingidAsc = 'BUILDINGID_ASC',
  BuildingidDesc = 'BUILDINGID_DESC',
  NameAsc = 'NAME_ASC',
  NameDesc = 'NAME_DESC',
  PropertyidAsc = 'PROPERTYID_ASC',
  PropertyidDesc = 'PROPERTYID_DESC',
  PropertyidNameAsc = 'PROPERTYID__NAME_ASC',
  PropertyidNameDesc = 'PROPERTYID__NAME_DESC',
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC',
}

export enum SortFindManyUserHistoryInput {
  LastaccessedatAsc = 'LASTACCESSEDAT_ASC',
  LastaccessedatDesc = 'LASTACCESSEDAT_DESC',
  UseridAsc = 'USERID_ASC',
  UseridDesc = 'USERID_DESC',
  UseridDeviceidAsc = 'USERID__DEVICEID_ASC',
  UseridDeviceidDesc = 'USERID__DEVICEID_DESC',
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC',
}

export enum SortFindManyUserInput {
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC',
}

export enum SortFindManyVsdPumpInput {
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC',
}

export enum SortFindManyVirtualPowerPlantInput {
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC',
}

export enum SortFindManyWindManagementSystemInput {
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC',
}

export enum SortFindManyWindowSensorInput {
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC',
}

export enum SortFindManyZ210PumpInput {
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC',
}

export enum SortFindManyZoneInput {
  PropertyidAsc = 'PROPERTYID_ASC',
  PropertyidDesc = 'PROPERTYID_DESC',
  PropertyidZonepolicyidAsc = 'PROPERTYID__ZONEPOLICYID_ASC',
  PropertyidZonepolicyidDesc = 'PROPERTYID__ZONEPOLICYID_DESC',
  UnitidAsc = 'UNITID_ASC',
  UnitidDesc = 'UNITID_DESC',
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC',
}

export enum SortFindManyZonePolicyInput {
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC',
}

export enum SortFindOneActuatorInput {
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC',
}

export enum SortFindOneAlertCategoryInput {
  PropertyidAsc = 'PROPERTYID_ASC',
  PropertyidDesc = 'PROPERTYID_DESC',
  PropertyidKeyAsc = 'PROPERTYID__KEY_ASC',
  PropertyidKeyDesc = 'PROPERTYID__KEY_DESC',
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC',
}

export enum SortFindOneAlertInput {
  PropertyIdAsc = 'PROPERTY__ID_ASC',
  PropertyIdDesc = 'PROPERTY__ID_DESC',
  UnitIdAsc = 'UNIT__ID_ASC',
  UnitIdDesc = 'UNIT__ID_DESC',
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC',
}

export enum SortFindOneAlertNotificationInput {
  AlertidAsc = 'ALERTID_ASC',
  AlertidDesc = 'ALERTID_DESC',
  AlertidRecipientAsc = 'ALERTID__RECIPIENT_ASC',
  AlertidRecipientDesc = 'ALERTID__RECIPIENT_DESC',
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC',
}

export enum SortFindOneAlertOptOutInput {
  RecipientAsc = 'RECIPIENT_ASC',
  RecipientDesc = 'RECIPIENT_DESC',
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC',
}

export enum SortFindOneAlertSubscriptionInput {
  AlerttriggeridAsc = 'ALERTTRIGGERID_ASC',
  AlerttriggeridDesc = 'ALERTTRIGGERID_DESC',
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC',
}

export enum SortFindOneAlertTriggerInput {
  PropertyidAsc = 'PROPERTYID_ASC',
  PropertyidDesc = 'PROPERTYID_DESC',
  PropertyidKeyAsc = 'PROPERTYID__KEY_ASC',
  PropertyidKeyDesc = 'PROPERTYID__KEY_DESC',
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC',
}

export enum SortFindOneAuthenticationProfileInput {
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC',
}

export enum SortFindOneAuthenticatorDeviceInput {
  UseridAsc = 'USERID_ASC',
  UseridDesc = 'USERID_DESC',
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC',
}

export enum SortFindOneAuthorizationProfileInput {
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC',
}

export enum SortFindOneBngInput {
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC',
}

export enum SortFindOneBatteryManagementSystemInput {
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC',
}

export enum SortFindOneBoilerInput {
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC',
}

export enum SortFindOneBuildingInput {
  NameAsc = 'NAME_ASC',
  NameDesc = 'NAME_DESC',
  NamePropertyidAsc = 'NAME__PROPERTYID_ASC',
  NamePropertyidDesc = 'NAME__PROPERTYID_DESC',
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC',
}

export enum SortFindOneChillerInput {
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC',
}

export enum SortFindOneConductorGenericSensorInput {
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC',
}

export enum SortFindOneConductorInput {
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC',
}

export enum SortFindOneControlGroupInput {
  DevicesDeviceidAsc = 'DEVICES__DEVICEID_ASC',
  DevicesDeviceidDesc = 'DEVICES__DEVICEID_DESC',
  PropertyidAsc = 'PROPERTYID_ASC',
  PropertyidDesc = 'PROPERTYID_DESC',
  UnitidAsc = 'UNITID_ASC',
  UnitidDesc = 'UNITID_DESC',
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC',
}

export enum SortFindOneControllerInput {
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC',
}

export enum SortFindOneCoreInput {
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC',
}

export enum SortFindOneDataExportJobInput {
  PropertyidAsc = 'PROPERTYID_ASC',
  PropertyidDesc = 'PROPERTYID_DESC',
  PropertyidStartdateAsc = 'PROPERTYID__STARTDATE_ASC',
  PropertyidStartdateDesc = 'PROPERTYID__STARTDATE_DESC',
  PropertyidStartdateEnddateAsc = 'PROPERTYID__STARTDATE__ENDDATE_ASC',
  PropertyidStartdateEnddateDesc = 'PROPERTYID__STARTDATE__ENDDATE_DESC',
  RequestedbyuseridAsc = 'REQUESTEDBYUSERID_ASC',
  RequestedbyuseridDesc = 'REQUESTEDBYUSERID_DESC',
  RequestedbyuseridSubmittedatAsc = 'REQUESTEDBYUSERID__SUBMITTEDAT_ASC',
  RequestedbyuseridSubmittedatDesc = 'REQUESTEDBYUSERID__SUBMITTEDAT_DESC',
  StatusAsc = 'STATUS_ASC',
  StatusDesc = 'STATUS_DESC',
  StatusUpdatedatAsc = 'STATUS__UPDATEDAT_ASC',
  StatusUpdatedatDesc = 'STATUS__UPDATEDAT_DESC',
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC',
}

export enum SortFindOneDeviceInput {
  NameAsc = 'NAME_ASC',
  NameDesc = 'NAME_DESC',
  PropertyidAsc = 'PROPERTYID_ASC',
  PropertyidDesc = 'PROPERTYID_DESC',
  TypeAsc = 'TYPE_ASC',
  TypeDesc = 'TYPE_DESC',
  UnitidAsc = 'UNITID_ASC',
  UnitidDesc = 'UNITID_DESC',
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC',
}

export enum SortFindOneDeviceReadingInput {
  DeviceuidAsc = 'DEVICEUID_ASC',
  DeviceuidDesc = 'DEVICEUID_DESC',
  DeviceuidDatetimeAsc = 'DEVICEUID__DATETIME_ASC',
  DeviceuidDatetimeDesc = 'DEVICEUID__DATETIME_DESC',
  DeviceuidDatetimeMeasurementtypeAsc = 'DEVICEUID__DATETIME__MEASUREMENTTYPE_ASC',
  DeviceuidDatetimeMeasurementtypeDesc = 'DEVICEUID__DATETIME__MEASUREMENTTYPE_DESC',
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC',
}

export enum SortFindOneDoorSensorInput {
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC',
}

export enum SortFindOneEnergyConsumerBuildingInput {
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC',
}

export enum SortFindOneEnergyConsumerTenantInput {
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC',
}

export enum SortFindOneEnergyConsumerUtilityInput {
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC',
}

export enum SortFindOneEnergyControllerInput {
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC',
}

export enum SortFindOneEnergyConverterInput {
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC',
}

export enum SortFindOneEnergyInverterInput {
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC',
}

export enum SortFindOneEnergyMeterInput {
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC',
}

export enum SortFindOneEnergyRectifierInput {
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC',
}

export enum SortFindOneEnergyStorageBatterySystemInput {
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC',
}

export enum SortFindOneEnergyStorageCoolingSystemInput {
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC',
}

export enum SortFindOneEnergyStorageKineticSystemInput {
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC',
}

export enum SortFindOneEnergySupplierSolarSystemInput {
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC',
}

export enum SortFindOneEnergySupplierUtilityInput {
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC',
}

export enum SortFindOneEnergySupplierWindSystemInput {
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC',
}

export enum SortFindOneEnergySwitchPanelCircuitInput {
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC',
}

export enum SortFindOneEnergySwitchPanelInput {
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC',
}

export enum SortFindOneFireSuppressionSystemInput {
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC',
}

export enum SortFindOneFloorInput {
  NameAsc = 'NAME_ASC',
  NameDesc = 'NAME_DESC',
  NamePropertyidAsc = 'NAME__PROPERTYID_ASC',
  NamePropertyidDesc = 'NAME__PROPERTYID_DESC',
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC',
}

export enum SortFindOneGpioInput {
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC',
}

export enum SortFindOneHmmInput {
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC',
}

export enum SortFindOneHistoricAlertInput {
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC',
}

export enum SortFindOneHistoricReadingInput {
  DeviceidAsc = 'DEVICEID_ASC',
  DeviceidDesc = 'DEVICEID_DESC',
  DeviceidTypeAsc = 'DEVICEID__TYPE_ASC',
  DeviceidTypeDesc = 'DEVICEID__TYPE_DESC',
  DeviceidTypeTimestampAsc = 'DEVICEID__TYPE__TIMESTAMP_ASC',
  DeviceidTypeTimestampDesc = 'DEVICEID__TYPE__TIMESTAMP_DESC',
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC',
}

export enum SortFindOneIndoorAirHandlerInput {
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC',
}

export enum SortFindOneIndoorSensorInput {
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC',
}

export enum SortFindOneIngestionInput {
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC',
}

export enum SortFindOneKineticEnergyManagementSystemInput {
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC',
}

export enum SortFindOneLeakDetectorInput {
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC',
}

export enum SortFindOneLoopInput {
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC',
}

export enum SortFindOneModbusAirHandlerInput {
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC',
}

export enum SortFindOneOauthAccessTokenInput {
  ClientidAsc = 'CLIENTID_ASC',
  ClientidDesc = 'CLIENTID_DESC',
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC',
}

export enum SortFindOneOauthAuthCodeInput {
  ClientidAsc = 'CLIENTID_ASC',
  ClientidDesc = 'CLIENTID_DESC',
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC',
}

export enum SortFindOneOauthClientInput {
  ClientidAsc = 'CLIENTID_ASC',
  ClientidDesc = 'CLIENTID_DESC',
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC',
}

export enum SortFindOneOccupancySensorInput {
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC',
}

export enum SortFindOneOpenWeatherInput {
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC',
}

export enum SortFindOneOrganizationInput {
  NameAsc = 'NAME_ASC',
  NameDesc = 'NAME_DESC',
  ParentorganizationidAsc = 'PARENTORGANIZATIONID_ASC',
  ParentorganizationidDesc = 'PARENTORGANIZATIONID_DESC',
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC',
}

export enum SortFindOneOutdoorSensorInput {
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC',
}

export enum SortFindOnePanelInput {
  PropertyidAsc = 'PROPERTYID_ASC',
  PropertyidDesc = 'PROPERTYID_DESC',
  UnitidAsc = 'UNITID_ASC',
  UnitidDesc = 'UNITID_DESC',
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC',
}

export enum SortFindOnePlmContractInput {
  ContractidAsc = 'CONTRACTID_ASC',
  ContractidDesc = 'CONTRACTID_DESC',
  ManageridAsc = 'MANAGERID_ASC',
  ManageridDesc = 'MANAGERID_DESC',
  NotificationemailAsc = 'NOTIFICATIONEMAIL_ASC',
  NotificationemailDesc = 'NOTIFICATIONEMAIL_DESC',
  ProgramidAsc = 'PROGRAMID_ASC',
  ProgramidDesc = 'PROGRAMID_DESC',
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC',
}

export enum SortFindOnePlmCurtailmentActionInput {
  DevicetypeAsc = 'DEVICETYPE_ASC',
  DevicetypeDesc = 'DEVICETYPE_DESC',
  EstimatedreductionkwAsc = 'ESTIMATEDREDUCTIONKW_ASC',
  EstimatedreductionkwDesc = 'ESTIMATEDREDUCTIONKW_DESC',
  PlmcurtailmentplanidAsc = 'PLMCURTAILMENTPLANID_ASC',
  PlmcurtailmentplanidDesc = 'PLMCURTAILMENTPLANID_DESC',
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC',
}

export enum SortFindOnePlmCurtailmentPlanInput {
  DurationminutesAsc = 'DURATIONMINUTES_ASC',
  DurationminutesDesc = 'DURATIONMINUTES_DESC',
  EstimatedreductionkwAsc = 'ESTIMATEDREDUCTIONKW_ASC',
  EstimatedreductionkwDesc = 'ESTIMATEDREDUCTIONKW_DESC',
  NameAsc = 'NAME_ASC',
  NameDesc = 'NAME_DESC',
  OrganizationidAsc = 'ORGANIZATIONID_ASC',
  OrganizationidDesc = 'ORGANIZATIONID_DESC',
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC',
}

export enum SortFindOnePlmCurtailmentTaskInput {
  DeviceidAsc = 'DEVICEID_ASC',
  DeviceidDesc = 'DEVICEID_DESC',
  DeviceidPlmcurtailmentactionidAsc = 'DEVICEID__PLMCURTAILMENTACTIONID_ASC',
  DeviceidPlmcurtailmentactionidDesc = 'DEVICEID__PLMCURTAILMENTACTIONID_DESC',
  DeviceidPlmcurtailmentactionidPlmeventresponseidAsc = 'DEVICEID__PLMCURTAILMENTACTIONID__PLMEVENTRESPONSEID_ASC',
  DeviceidPlmcurtailmentactionidPlmeventresponseidDesc = 'DEVICEID__PLMCURTAILMENTACTIONID__PLMEVENTRESPONSEID_DESC',
  DeviceidPlmcurtailmentactionidPlmeventresponseidBatchidAsc = 'DEVICEID__PLMCURTAILMENTACTIONID__PLMEVENTRESPONSEID__BATCHID_ASC',
  DeviceidPlmcurtailmentactionidPlmeventresponseidBatchidDesc = 'DEVICEID__PLMCURTAILMENTACTIONID__PLMEVENTRESPONSEID__BATCHID_DESC',
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC',
}

export enum SortFindOnePlmEventInput {
  ContractidAsc = 'CONTRACTID_ASC',
  ContractidDesc = 'CONTRACTID_DESC',
  ProgramidAsc = 'PROGRAMID_ASC',
  ProgramidDesc = 'PROGRAMID_DESC',
  SourcevendorAsc = 'SOURCEVENDOR_ASC',
  SourcevendorDesc = 'SOURCEVENDOR_DESC',
  SourcevendorSourceexternalidAsc = 'SOURCEVENDOR__SOURCEEXTERNALID_ASC',
  SourcevendorSourceexternalidDesc = 'SOURCEVENDOR__SOURCEEXTERNALID_DESC',
  StarttimeAsc = 'STARTTIME_ASC',
  StarttimeDesc = 'STARTTIME_DESC',
  StatusAsc = 'STATUS_ASC',
  StatusDesc = 'STATUS_DESC',
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC',
}

export enum SortFindOnePlmEventResponseInput {
  CurtailmentplanidAsc = 'CURTAILMENTPLANID_ASC',
  CurtailmentplanidDesc = 'CURTAILMENTPLANID_DESC',
  EventidAsc = 'EVENTID_ASC',
  EventidDesc = 'EVENTID_DESC',
  PropertyidAsc = 'PROPERTYID_ASC',
  PropertyidDesc = 'PROPERTYID_DESC',
  ResponsesentatAsc = 'RESPONSESENTAT_ASC',
  ResponsesentatDesc = 'RESPONSESENTAT_DESC',
  ResponsestatusAsc = 'RESPONSESTATUS_ASC',
  ResponsestatusDesc = 'RESPONSESTATUS_DESC',
  ScheduledstartAsc = 'SCHEDULEDSTART_ASC',
  ScheduledstartDesc = 'SCHEDULEDSTART_DESC',
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC',
}

export enum SortFindOnePlmExternalMeterMappingInput {
  PropertyidAsc = 'PROPERTYID_ASC',
  PropertyidDesc = 'PROPERTYID_DESC',
  VendorAsc = 'VENDOR_ASC',
  VendorDesc = 'VENDOR_DESC',
  VendorPartneridAsc = 'VENDOR__PARTNERID_ASC',
  VendorPartneridDesc = 'VENDOR__PARTNERID_DESC',
  VendorPartneridPropertyidAsc = 'VENDOR__PARTNERID__PROPERTYID_ASC',
  VendorPartneridPropertyidDesc = 'VENDOR__PARTNERID__PROPERTYID_DESC',
  VendorPartneridPropertyidMeteridAsc = 'VENDOR__PARTNERID__PROPERTYID__METERID_ASC',
  VendorPartneridPropertyidMeteridDesc = 'VENDOR__PARTNERID__PROPERTYID__METERID_DESC',
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC',
}

export enum SortFindOnePlmIngressEventInput {
  StatusAsc = 'STATUS_ASC',
  StatusDesc = 'STATUS_DESC',
  StatusReceivedatAsc = 'STATUS__RECEIVEDAT_ASC',
  StatusReceivedatDesc = 'STATUS__RECEIVEDAT_DESC',
  VendorkeyAsc = 'VENDORKEY_ASC',
  VendorkeyDesc = 'VENDORKEY_DESC',
  VendorkeyReceivedatAsc = 'VENDORKEY__RECEIVEDAT_ASC',
  VendorkeyReceivedatDesc = 'VENDORKEY__RECEIVEDAT_DESC',
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC',
}

export enum SortFindOnePlmNotificationInput {
  ActivationtimeAsc = 'ACTIVATIONTIME_ASC',
  ActivationtimeDesc = 'ACTIVATIONTIME_DESC',
  ContractidAsc = 'CONTRACTID_ASC',
  ContractidDesc = 'CONTRACTID_DESC',
  PartneridAsc = 'PARTNERID_ASC',
  PartneridDesc = 'PARTNERID_DESC',
  ProgramidAsc = 'PROGRAMID_ASC',
  ProgramidDesc = 'PROGRAMID_DESC',
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC',
}

export enum SortFindOnePlmPartnerInput {
  NameAsc = 'NAME_ASC',
  NameDesc = 'NAME_DESC',
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC',
}

export enum SortFindOnePlmProgramInput {
  HostpartneridAsc = 'HOSTPARTNERID_ASC',
  HostpartneridDesc = 'HOSTPARTNERID_DESC',
  NameAsc = 'NAME_ASC',
  NameDesc = 'NAME_DESC',
  PartneridAsc = 'PARTNERID_ASC',
  PartneridDesc = 'PARTNERID_DESC',
  ProgramidAsc = 'PROGRAMID_ASC',
  ProgramidDesc = 'PROGRAMID_DESC',
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC',
}

export enum SortFindOnePlmUtilityInput {
  NameAsc = 'NAME_ASC',
  NameDesc = 'NAME_DESC',
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC',
}

export enum SortFindOnePowerMonitorInput {
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC',
}

export enum SortFindOnePressureSensorInput {
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC',
}

export enum SortFindOnePropertyInput {
  TitleAsc = 'TITLE_ASC',
  TitleDesc = 'TITLE_DESC',
  UnitssummaryCountAsc = 'UNITSSUMMARY__COUNT_ASC',
  UnitssummaryCountDesc = 'UNITSSUMMARY__COUNT_DESC',
  UnitssummaryMajoralertsAsc = 'UNITSSUMMARY__MAJORALERTS_ASC',
  UnitssummaryMajoralertsDesc = 'UNITSSUMMARY__MAJORALERTS_DESC',
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC',
}

export enum SortFindOneRelayDeviceInput {
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC',
}

export enum SortFindOneScheduledTaskInput {
  ModelnameAsc = 'MODELNAME_ASC',
  ModelnameDesc = 'MODELNAME_DESC',
  ModelnameInstanceidAsc = 'MODELNAME__INSTANCEID_ASC',
  ModelnameInstanceidDesc = 'MODELNAME__INSTANCEID_DESC',
  PriorityAsc = 'PRIORITY_ASC',
  PriorityDesc = 'PRIORITY_DESC',
  ScheduledatAsc = 'SCHEDULEDAT_ASC',
  ScheduledatDesc = 'SCHEDULEDAT_DESC',
  StatusAsc = 'STATUS_ASC',
  StatusDesc = 'STATUS_DESC',
  StatusScheduledatAsc = 'STATUS__SCHEDULEDAT_ASC',
  StatusScheduledatDesc = 'STATUS__SCHEDULEDAT_DESC',
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC',
}

export enum SortFindOneSetpointProfileInput {
  PropertiesAsc = 'PROPERTIES_ASC',
  PropertiesDesc = 'PROPERTIES_DESC',
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC',
}

export enum SortFindOneSmartPowerOutletInput {
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC',
}

export enum SortFindOneSolarManagementSystemInput {
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC',
}

export enum SortFindOneSourceInput {
  NameAsc = 'NAME_ASC',
  NameDesc = 'NAME_DESC',
  NamePropertyidAsc = 'NAME__PROPERTYID_ASC',
  NamePropertyidDesc = 'NAME__PROPERTYID_DESC',
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC',
}

export enum SortFindOneSystemNotificationInput {
  CreatedatAsc = 'CREATEDAT_ASC',
  CreatedatDesc = 'CREATEDAT_DESC',
  DisplayendAsc = 'DISPLAYEND_ASC',
  DisplayendDesc = 'DISPLAYEND_DESC',
  DisplaystartAsc = 'DISPLAYSTART_ASC',
  DisplaystartDesc = 'DISPLAYSTART_DESC',
  EntityidAsc = 'ENTITYID_ASC',
  EntityidDesc = 'ENTITYID_DESC',
  EntitytypeAsc = 'ENTITYTYPE_ASC',
  EntitytypeDesc = 'ENTITYTYPE_DESC',
  SeenbyUseridAsc = 'SEENBY__USERID_ASC',
  SeenbyUseridDesc = 'SEENBY__USERID_DESC',
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC',
  IdSeenbyUseridAsc = '_ID__SEENBY__USERID_ASC',
  IdSeenbyUseridDesc = '_ID__SEENBY__USERID_DESC',
}

export enum SortFindOneThermistorInput {
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC',
}

export enum SortFindOneThermostatInput {
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC',
}

export enum SortFindOneThermostatScheduleProfileInput {
  PropertyidAsc = 'PROPERTYID_ASC',
  PropertyidDesc = 'PROPERTYID_DESC',
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC',
}

export enum SortFindOneThermostatScheduleTemplateInput {
  PropertyidAsc = 'PROPERTYID_ASC',
  PropertyidDesc = 'PROPERTYID_DESC',
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC',
}

export enum SortFindOneUnitInput {
  BuildingidAsc = 'BUILDINGID_ASC',
  BuildingidDesc = 'BUILDINGID_DESC',
  NameAsc = 'NAME_ASC',
  NameDesc = 'NAME_DESC',
  PropertyidAsc = 'PROPERTYID_ASC',
  PropertyidDesc = 'PROPERTYID_DESC',
  PropertyidNameAsc = 'PROPERTYID__NAME_ASC',
  PropertyidNameDesc = 'PROPERTYID__NAME_DESC',
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC',
}

export enum SortFindOneUserHistoryInput {
  LastaccessedatAsc = 'LASTACCESSEDAT_ASC',
  LastaccessedatDesc = 'LASTACCESSEDAT_DESC',
  UseridAsc = 'USERID_ASC',
  UseridDesc = 'USERID_DESC',
  UseridDeviceidAsc = 'USERID__DEVICEID_ASC',
  UseridDeviceidDesc = 'USERID__DEVICEID_DESC',
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC',
}

export enum SortFindOneUserInput {
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC',
}

export enum SortFindOneVsdPumpInput {
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC',
}

export enum SortFindOneVirtualPowerPlantInput {
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC',
}

export enum SortFindOneWindManagementSystemInput {
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC',
}

export enum SortFindOneWindowSensorInput {
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC',
}

export enum SortFindOneZ210PumpInput {
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC',
}

export enum SortFindOneZoneInput {
  PropertyidAsc = 'PROPERTYID_ASC',
  PropertyidDesc = 'PROPERTYID_DESC',
  PropertyidZonepolicyidAsc = 'PROPERTYID__ZONEPOLICYID_ASC',
  PropertyidZonepolicyidDesc = 'PROPERTYID__ZONEPOLICYID_DESC',
  UnitidAsc = 'UNITID_ASC',
  UnitidDesc = 'UNITID_DESC',
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC',
}

export enum SortFindOneZonePolicyInput {
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC',
}

export type Source = SourceInterface & {
  __typename: 'Source';
  _id: Scalars['String'];
  alerts: Array<Maybe<Alert>>;
  /** Returns the authorization profile associated with the user. */
  inUse: Scalars['Boolean'];
  modelChangeOperation?: Maybe<Scalars['String']>;
  modelType?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  panels: Array<Maybe<Panel>>;
  property?: Maybe<Property>;
  propertyId?: Maybe<Scalars['String']>;
  timestamp?: Maybe<Scalars['Float']>;
  type?: Maybe<EnumDKeySourceType>;
  units: Array<Maybe<Unit>>;
  updateDescription?: Maybe<Scalars['JSON']>;
  url?: Maybe<Scalars['String']>;
  zones: Array<Maybe<Zone>>;
};

export type SourceAlertsArgs = {
  filter?: InputMaybe<FilterFindManyAlertInput>;
  limit?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<SortFindManyAlertInput>;
};

export type SourcePanelsArgs = {
  filter?: InputMaybe<FilterFindManyPanelInput>;
  limit?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<SortFindManyPanelInput>;
};

export type SourceUnitsArgs = {
  filter?: InputMaybe<FilterFindManyUnitInput>;
  limit?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<SortFindManyUnitInput>;
};

export type SourceZonesArgs = {
  filter?: InputMaybe<FilterFindManyZoneInput>;
  limit?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<SortFindManyZoneInput>;
};

export type SourceInterface = {
  _id: Scalars['String'];
  alerts: Array<Maybe<Alert>>;
  /** Returns the authorization profile associated with the user. */
  inUse: Scalars['Boolean'];
  modelChangeOperation?: Maybe<Scalars['String']>;
  modelType?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  panels: Array<Maybe<Panel>>;
  property?: Maybe<Property>;
  propertyId?: Maybe<Scalars['String']>;
  timestamp?: Maybe<Scalars['Float']>;
  type?: Maybe<EnumDKeySourceType>;
  units: Array<Maybe<Unit>>;
  updateDescription?: Maybe<Scalars['JSON']>;
  url?: Maybe<Scalars['String']>;
  zones: Array<Maybe<Zone>>;
};

export type SourceInterfaceAlertsArgs = {
  filter?: InputMaybe<FilterFindManyAlertInput>;
  limit?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<SortFindManyAlertInput>;
};

export type SourceInterfacePanelsArgs = {
  filter?: InputMaybe<FilterFindManyPanelInput>;
  limit?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<SortFindManyPanelInput>;
};

export type SourceInterfaceUnitsArgs = {
  filter?: InputMaybe<FilterFindManyUnitInput>;
  limit?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<SortFindManyUnitInput>;
};

export type SourceInterfaceZonesArgs = {
  filter?: InputMaybe<FilterFindManyZoneInput>;
  limit?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<SortFindManyZoneInput>;
};

export type Subscription = {
  __typename?: 'Subscription';
  actuatorCreated?: Maybe<Actuator>;
  actuatorCreatedByIds?: Maybe<Actuator>;
  actuatorDeleted?: Maybe<Actuator>;
  actuatorDeletedByIds?: Maybe<Actuator>;
  actuatorEvents?: Maybe<Actuator>;
  actuatorEventsByIds?: Maybe<Actuator>;
  actuatorReplaced?: Maybe<Actuator>;
  actuatorReplacedByIds?: Maybe<Actuator>;
  actuatorUpdated?: Maybe<Actuator>;
  actuatorUpdatedByIds?: Maybe<Actuator>;
  alertCategoryCreated?: Maybe<AlertCategory>;
  alertCategoryCreatedByIds?: Maybe<AlertCategory>;
  alertCategoryDeleted?: Maybe<AlertCategory>;
  alertCategoryDeletedByIds?: Maybe<AlertCategory>;
  alertCategoryEvents?: Maybe<AlertCategory>;
  alertCategoryEventsByIds?: Maybe<AlertCategory>;
  alertCategoryReplaced?: Maybe<AlertCategory>;
  alertCategoryReplacedByIds?: Maybe<AlertCategory>;
  alertCategoryUpdated?: Maybe<AlertCategory>;
  alertCategoryUpdatedByIds?: Maybe<AlertCategory>;
  alertCreated?: Maybe<Alert>;
  alertCreatedByIds?: Maybe<Alert>;
  alertDeleted?: Maybe<Alert>;
  alertDeletedByIds?: Maybe<Alert>;
  alertEvents?: Maybe<Alert>;
  alertEventsByIds?: Maybe<Alert>;
  alertNotificationByAlertIdCreated?: Maybe<AlertNotification>;
  alertNotificationByAlertIdDeleted?: Maybe<AlertNotification>;
  alertNotificationByAlertIdEvents?: Maybe<AlertNotification>;
  alertNotificationByAlertIdReplaced?: Maybe<AlertNotification>;
  alertNotificationByAlertIdUpdated?: Maybe<AlertNotification>;
  alertNotificationByRecipientCreated?: Maybe<AlertNotification>;
  alertNotificationByRecipientDeleted?: Maybe<AlertNotification>;
  alertNotificationByRecipientEvents?: Maybe<AlertNotification>;
  alertNotificationByRecipientReplaced?: Maybe<AlertNotification>;
  alertNotificationByRecipientUpdated?: Maybe<AlertNotification>;
  alertNotificationCreated?: Maybe<AlertNotification>;
  alertNotificationCreatedByIds?: Maybe<AlertNotification>;
  alertNotificationDeleted?: Maybe<AlertNotification>;
  alertNotificationDeletedByIds?: Maybe<AlertNotification>;
  alertNotificationEvents?: Maybe<AlertNotification>;
  alertNotificationEventsByIds?: Maybe<AlertNotification>;
  alertNotificationReplaced?: Maybe<AlertNotification>;
  alertNotificationReplacedByIds?: Maybe<AlertNotification>;
  alertNotificationUpdated?: Maybe<AlertNotification>;
  alertNotificationUpdatedByIds?: Maybe<AlertNotification>;
  alertOptOutCreated?: Maybe<AlertOptOut>;
  alertOptOutCreatedByIds?: Maybe<AlertOptOut>;
  alertOptOutDeleted?: Maybe<AlertOptOut>;
  alertOptOutDeletedByIds?: Maybe<AlertOptOut>;
  alertOptOutEvents?: Maybe<AlertOptOut>;
  alertOptOutEventsByIds?: Maybe<AlertOptOut>;
  alertOptOutReplaced?: Maybe<AlertOptOut>;
  alertOptOutReplacedByIds?: Maybe<AlertOptOut>;
  alertOptOutUpdated?: Maybe<AlertOptOut>;
  alertOptOutUpdatedByIds?: Maybe<AlertOptOut>;
  alertOptOutsByRecipientCreated?: Maybe<AlertOptOut>;
  alertOptOutsByRecipientDeleted?: Maybe<AlertOptOut>;
  alertOptOutsByRecipientEvents?: Maybe<AlertOptOut>;
  alertOptOutsByRecipientReplaced?: Maybe<AlertOptOut>;
  alertOptOutsByRecipientUpdated?: Maybe<AlertOptOut>;
  alertReplaced?: Maybe<Alert>;
  alertReplacedByIds?: Maybe<Alert>;
  alertSubscriptionCreated?: Maybe<AlertSubscription>;
  alertSubscriptionCreatedByIds?: Maybe<AlertSubscription>;
  alertSubscriptionDeleted?: Maybe<AlertSubscription>;
  alertSubscriptionDeletedByIds?: Maybe<AlertSubscription>;
  alertSubscriptionEvents?: Maybe<AlertSubscription>;
  alertSubscriptionEventsByIds?: Maybe<AlertSubscription>;
  alertSubscriptionReplaced?: Maybe<AlertSubscription>;
  alertSubscriptionReplacedByIds?: Maybe<AlertSubscription>;
  alertSubscriptionUpdated?: Maybe<AlertSubscription>;
  alertSubscriptionUpdatedByIds?: Maybe<AlertSubscription>;
  alertSubscriptionsByUserIdCreated?: Maybe<AlertSubscription>;
  alertSubscriptionsByUserIdDeleted?: Maybe<AlertSubscription>;
  alertSubscriptionsByUserIdEvents?: Maybe<AlertSubscription>;
  alertSubscriptionsByUserIdReplaced?: Maybe<AlertSubscription>;
  alertSubscriptionsByUserIdUpdated?: Maybe<AlertSubscription>;
  alertTriggerCreated?: Maybe<AlertTrigger>;
  alertTriggerCreatedByIds?: Maybe<AlertTrigger>;
  alertTriggerCreatedByPropertyId?: Maybe<AlertTrigger>;
  alertTriggerDeleted?: Maybe<AlertTrigger>;
  alertTriggerDeletedByIds?: Maybe<AlertTrigger>;
  alertTriggerDeletedByPropertyId?: Maybe<AlertTrigger>;
  alertTriggerEvents?: Maybe<AlertTrigger>;
  alertTriggerEventsByIds?: Maybe<AlertTrigger>;
  alertTriggerEventsByPropertyId?: Maybe<AlertTrigger>;
  alertTriggerReplaced?: Maybe<AlertTrigger>;
  alertTriggerReplacedByIds?: Maybe<AlertTrigger>;
  alertTriggerReplacedByPropertyId?: Maybe<AlertTrigger>;
  alertTriggerUpdated?: Maybe<AlertTrigger>;
  alertTriggerUpdatedByIds?: Maybe<AlertTrigger>;
  alertTriggerUpdatedByPropertyId?: Maybe<AlertTrigger>;
  alertUpdated?: Maybe<Alert>;
  alertUpdatedByIds?: Maybe<Alert>;
  alertsByPropertyIdCreated?: Maybe<Alert>;
  alertsByPropertyIdDeleted?: Maybe<Alert>;
  alertsByPropertyIdEvents?: Maybe<Alert>;
  alertsByPropertyIdReplaced?: Maybe<Alert>;
  alertsByPropertyIdUpdated?: Maybe<Alert>;
  alertsByUnitIdCreated?: Maybe<Alert>;
  alertsByUnitIdDeleted?: Maybe<Alert>;
  alertsByUnitIdEvents?: Maybe<Alert>;
  alertsByUnitIdReplaced?: Maybe<Alert>;
  alertsByUnitIdUpdated?: Maybe<Alert>;
  authenticationProfileCreated?: Maybe<AuthenticationProfile>;
  authenticationProfileCreatedByIds?: Maybe<AuthenticationProfile>;
  authenticationProfileDeleted?: Maybe<AuthenticationProfile>;
  authenticationProfileDeletedByIds?: Maybe<AuthenticationProfile>;
  authenticationProfileEvents?: Maybe<AuthenticationProfile>;
  authenticationProfileEventsByIds?: Maybe<AuthenticationProfile>;
  authenticationProfileReplaced?: Maybe<AuthenticationProfile>;
  authenticationProfileReplacedByIds?: Maybe<AuthenticationProfile>;
  authenticationProfileUpdated?: Maybe<AuthenticationProfile>;
  authenticationProfileUpdatedByIds?: Maybe<AuthenticationProfile>;
  authenticatorDeviceCreated?: Maybe<AuthenticatorDevice>;
  authenticatorDeviceCreatedByIds?: Maybe<AuthenticatorDevice>;
  authenticatorDeviceDeleted?: Maybe<AuthenticatorDevice>;
  authenticatorDeviceDeletedByIds?: Maybe<AuthenticatorDevice>;
  authenticatorDeviceEvents?: Maybe<AuthenticatorDevice>;
  authenticatorDeviceEventsByIds?: Maybe<AuthenticatorDevice>;
  authenticatorDeviceReplaced?: Maybe<AuthenticatorDevice>;
  authenticatorDeviceReplacedByIds?: Maybe<AuthenticatorDevice>;
  authenticatorDeviceUpdated?: Maybe<AuthenticatorDevice>;
  authenticatorDeviceUpdatedByIds?: Maybe<AuthenticatorDevice>;
  authorizationProfileCreated?: Maybe<AuthorizationProfile>;
  authorizationProfileCreatedByIds?: Maybe<AuthorizationProfile>;
  authorizationProfileDeleted?: Maybe<AuthorizationProfile>;
  authorizationProfileDeletedByIds?: Maybe<AuthorizationProfile>;
  authorizationProfileEvents?: Maybe<AuthorizationProfile>;
  authorizationProfileEventsByIds?: Maybe<AuthorizationProfile>;
  authorizationProfileReplaced?: Maybe<AuthorizationProfile>;
  authorizationProfileReplacedByIds?: Maybe<AuthorizationProfile>;
  authorizationProfileUpdated?: Maybe<AuthorizationProfile>;
  authorizationProfileUpdatedByIds?: Maybe<AuthorizationProfile>;
  bNGCreated?: Maybe<Bng>;
  bNGCreatedByIds?: Maybe<Bng>;
  bNGDeleted?: Maybe<Bng>;
  bNGDeletedByIds?: Maybe<Bng>;
  bNGEvents?: Maybe<Bng>;
  bNGEventsByIds?: Maybe<Bng>;
  bNGReplaced?: Maybe<Bng>;
  bNGReplacedByIds?: Maybe<Bng>;
  bNGUpdated?: Maybe<Bng>;
  bNGUpdatedByIds?: Maybe<Bng>;
  batteryManagementSystemCreated?: Maybe<BatteryManagementSystem>;
  batteryManagementSystemCreatedByIds?: Maybe<BatteryManagementSystem>;
  batteryManagementSystemDeleted?: Maybe<BatteryManagementSystem>;
  batteryManagementSystemDeletedByIds?: Maybe<BatteryManagementSystem>;
  batteryManagementSystemEvents?: Maybe<BatteryManagementSystem>;
  batteryManagementSystemEventsByIds?: Maybe<BatteryManagementSystem>;
  batteryManagementSystemReplaced?: Maybe<BatteryManagementSystem>;
  batteryManagementSystemReplacedByIds?: Maybe<BatteryManagementSystem>;
  batteryManagementSystemUpdated?: Maybe<BatteryManagementSystem>;
  batteryManagementSystemUpdatedByIds?: Maybe<BatteryManagementSystem>;
  boilerCreated?: Maybe<Boiler>;
  boilerCreatedByIds?: Maybe<Boiler>;
  boilerDeleted?: Maybe<Boiler>;
  boilerDeletedByIds?: Maybe<Boiler>;
  boilerEvents?: Maybe<Boiler>;
  boilerEventsByIds?: Maybe<Boiler>;
  boilerReplaced?: Maybe<Boiler>;
  boilerReplacedByIds?: Maybe<Boiler>;
  boilerUpdated?: Maybe<Boiler>;
  boilerUpdatedByIds?: Maybe<Boiler>;
  buildingCreated?: Maybe<Building>;
  buildingCreatedByIds?: Maybe<Building>;
  buildingDeleted?: Maybe<Building>;
  buildingDeletedByIds?: Maybe<Building>;
  buildingEvents?: Maybe<Building>;
  buildingEventsByIds?: Maybe<Building>;
  buildingReplaced?: Maybe<Building>;
  buildingReplacedByIds?: Maybe<Building>;
  buildingUpdated?: Maybe<Building>;
  buildingUpdatedByIds?: Maybe<Building>;
  buildingsByPropertyIdCreated?: Maybe<Building>;
  buildingsByPropertyIdDeleted?: Maybe<Building>;
  buildingsByPropertyIdEvents?: Maybe<Building>;
  buildingsByPropertyIdReplaced?: Maybe<Building>;
  buildingsByPropertyIdUpdated?: Maybe<Building>;
  bulkConfigProgressUpdate?: Maybe<BulkConfigStatus>;
  chillerCreated?: Maybe<Chiller>;
  chillerCreatedByIds?: Maybe<Chiller>;
  chillerDeleted?: Maybe<Chiller>;
  chillerDeletedByIds?: Maybe<Chiller>;
  chillerEvents?: Maybe<Chiller>;
  chillerEventsByIds?: Maybe<Chiller>;
  chillerReplaced?: Maybe<Chiller>;
  chillerReplacedByIds?: Maybe<Chiller>;
  chillerUpdated?: Maybe<Chiller>;
  chillerUpdatedByIds?: Maybe<Chiller>;
  conductorCreated?: Maybe<Conductor>;
  conductorCreatedByIds?: Maybe<Conductor>;
  conductorDeleted?: Maybe<Conductor>;
  conductorDeletedByIds?: Maybe<Conductor>;
  conductorDiscoveryStatusUpdated?: Maybe<ConductorDiscoveryStatus>;
  conductorEvents?: Maybe<Conductor>;
  conductorEventsByIds?: Maybe<Conductor>;
  conductorGenericSensorCreated?: Maybe<ConductorGenericSensor>;
  conductorGenericSensorCreatedByIds?: Maybe<ConductorGenericSensor>;
  conductorGenericSensorDeleted?: Maybe<ConductorGenericSensor>;
  conductorGenericSensorDeletedByIds?: Maybe<ConductorGenericSensor>;
  conductorGenericSensorEvents?: Maybe<ConductorGenericSensor>;
  conductorGenericSensorEventsByIds?: Maybe<ConductorGenericSensor>;
  conductorGenericSensorReplaced?: Maybe<ConductorGenericSensor>;
  conductorGenericSensorReplacedByIds?: Maybe<ConductorGenericSensor>;
  conductorGenericSensorUpdated?: Maybe<ConductorGenericSensor>;
  conductorGenericSensorUpdatedByIds?: Maybe<ConductorGenericSensor>;
  conductorReplaced?: Maybe<Conductor>;
  conductorReplacedByIds?: Maybe<Conductor>;
  conductorUpdated?: Maybe<Conductor>;
  conductorUpdatedByIds?: Maybe<Conductor>;
  controlGroupCreated?: Maybe<ControlGroup>;
  controlGroupCreatedByIds?: Maybe<ControlGroup>;
  controlGroupDeleted?: Maybe<ControlGroup>;
  controlGroupDeletedByIds?: Maybe<ControlGroup>;
  controlGroupEvents?: Maybe<ControlGroup>;
  controlGroupEventsByIds?: Maybe<ControlGroup>;
  controlGroupReplaced?: Maybe<ControlGroup>;
  controlGroupReplacedByIds?: Maybe<ControlGroup>;
  controlGroupUpdated?: Maybe<ControlGroup>;
  controlGroupUpdatedByIds?: Maybe<ControlGroup>;
  controllerCreated?: Maybe<Controller>;
  controllerCreatedByIds?: Maybe<Controller>;
  controllerDeleted?: Maybe<Controller>;
  controllerDeletedByIds?: Maybe<Controller>;
  controllerEvents?: Maybe<Controller>;
  controllerEventsByIds?: Maybe<Controller>;
  controllerReplaced?: Maybe<Controller>;
  controllerReplacedByIds?: Maybe<Controller>;
  controllerUpdated?: Maybe<Controller>;
  controllerUpdatedByIds?: Maybe<Controller>;
  coreCreated?: Maybe<Core>;
  coreCreatedByIds?: Maybe<Core>;
  coreDeleted?: Maybe<Core>;
  coreDeletedByIds?: Maybe<Core>;
  coreEvents?: Maybe<Core>;
  coreEventsByIds?: Maybe<Core>;
  coreReplaced?: Maybe<Core>;
  coreReplacedByIds?: Maybe<Core>;
  coreUpdated?: Maybe<Core>;
  coreUpdatedByIds?: Maybe<Core>;
  dataExportJobCreated?: Maybe<DataExportJob>;
  dataExportJobCreatedByIds?: Maybe<DataExportJob>;
  dataExportJobDeleted?: Maybe<DataExportJob>;
  dataExportJobDeletedByIds?: Maybe<DataExportJob>;
  dataExportJobEvents?: Maybe<DataExportJob>;
  dataExportJobEventsByIds?: Maybe<DataExportJob>;
  dataExportJobReplaced?: Maybe<DataExportJob>;
  dataExportJobReplacedByIds?: Maybe<DataExportJob>;
  dataExportJobUpdated?: Maybe<DataExportJob>;
  dataExportJobUpdatedByIds?: Maybe<DataExportJob>;
  deviceCreated?: Maybe<Device>;
  deviceCreatedByIds?: Maybe<Device>;
  deviceDeleted?: Maybe<Device>;
  deviceDeletedByIds?: Maybe<Device>;
  deviceEvents?: Maybe<Device>;
  deviceEventsByIds?: Maybe<Device>;
  deviceReadingCreated?: Maybe<DeviceReading>;
  deviceReadingCreatedByIds?: Maybe<DeviceReading>;
  deviceReadingDeleted?: Maybe<DeviceReading>;
  deviceReadingDeletedByIds?: Maybe<DeviceReading>;
  deviceReadingEvents?: Maybe<DeviceReading>;
  deviceReadingEventsByIds?: Maybe<DeviceReading>;
  deviceReadingReplaced?: Maybe<DeviceReading>;
  deviceReadingReplacedByIds?: Maybe<DeviceReading>;
  deviceReadingUpdated?: Maybe<DeviceReading>;
  deviceReadingUpdatedByIds?: Maybe<DeviceReading>;
  deviceReplaced?: Maybe<Device>;
  deviceReplacedByIds?: Maybe<Device>;
  deviceUpdated?: Maybe<Device>;
  deviceUpdatedByIds?: Maybe<Device>;
  doorSensorCreated?: Maybe<DoorSensor>;
  doorSensorCreatedByIds?: Maybe<DoorSensor>;
  doorSensorDeleted?: Maybe<DoorSensor>;
  doorSensorDeletedByIds?: Maybe<DoorSensor>;
  doorSensorEvents?: Maybe<DoorSensor>;
  doorSensorEventsByIds?: Maybe<DoorSensor>;
  doorSensorReplaced?: Maybe<DoorSensor>;
  doorSensorReplacedByIds?: Maybe<DoorSensor>;
  doorSensorUpdated?: Maybe<DoorSensor>;
  doorSensorUpdatedByIds?: Maybe<DoorSensor>;
  energyConsumerBuildingCreated?: Maybe<EnergyConsumerBuilding>;
  energyConsumerBuildingCreatedByIds?: Maybe<EnergyConsumerBuilding>;
  energyConsumerBuildingDeleted?: Maybe<EnergyConsumerBuilding>;
  energyConsumerBuildingDeletedByIds?: Maybe<EnergyConsumerBuilding>;
  energyConsumerBuildingEvents?: Maybe<EnergyConsumerBuilding>;
  energyConsumerBuildingEventsByIds?: Maybe<EnergyConsumerBuilding>;
  energyConsumerBuildingReplaced?: Maybe<EnergyConsumerBuilding>;
  energyConsumerBuildingReplacedByIds?: Maybe<EnergyConsumerBuilding>;
  energyConsumerBuildingUpdated?: Maybe<EnergyConsumerBuilding>;
  energyConsumerBuildingUpdatedByIds?: Maybe<EnergyConsumerBuilding>;
  energyConsumerTenantCreated?: Maybe<EnergyConsumerTenant>;
  energyConsumerTenantCreatedByIds?: Maybe<EnergyConsumerTenant>;
  energyConsumerTenantDeleted?: Maybe<EnergyConsumerTenant>;
  energyConsumerTenantDeletedByIds?: Maybe<EnergyConsumerTenant>;
  energyConsumerTenantEvents?: Maybe<EnergyConsumerTenant>;
  energyConsumerTenantEventsByIds?: Maybe<EnergyConsumerTenant>;
  energyConsumerTenantReplaced?: Maybe<EnergyConsumerTenant>;
  energyConsumerTenantReplacedByIds?: Maybe<EnergyConsumerTenant>;
  energyConsumerTenantUpdated?: Maybe<EnergyConsumerTenant>;
  energyConsumerTenantUpdatedByIds?: Maybe<EnergyConsumerTenant>;
  energyConsumerUtilityCreated?: Maybe<EnergyConsumerUtility>;
  energyConsumerUtilityCreatedByIds?: Maybe<EnergyConsumerUtility>;
  energyConsumerUtilityDeleted?: Maybe<EnergyConsumerUtility>;
  energyConsumerUtilityDeletedByIds?: Maybe<EnergyConsumerUtility>;
  energyConsumerUtilityEvents?: Maybe<EnergyConsumerUtility>;
  energyConsumerUtilityEventsByIds?: Maybe<EnergyConsumerUtility>;
  energyConsumerUtilityReplaced?: Maybe<EnergyConsumerUtility>;
  energyConsumerUtilityReplacedByIds?: Maybe<EnergyConsumerUtility>;
  energyConsumerUtilityUpdated?: Maybe<EnergyConsumerUtility>;
  energyConsumerUtilityUpdatedByIds?: Maybe<EnergyConsumerUtility>;
  energyControllerCreated?: Maybe<EnergyController>;
  energyControllerCreatedByIds?: Maybe<EnergyController>;
  energyControllerDeleted?: Maybe<EnergyController>;
  energyControllerDeletedByIds?: Maybe<EnergyController>;
  energyControllerEvents?: Maybe<EnergyController>;
  energyControllerEventsByIds?: Maybe<EnergyController>;
  energyControllerReplaced?: Maybe<EnergyController>;
  energyControllerReplacedByIds?: Maybe<EnergyController>;
  energyControllerUpdated?: Maybe<EnergyController>;
  energyControllerUpdatedByIds?: Maybe<EnergyController>;
  energyConverterCreated?: Maybe<EnergyConverter>;
  energyConverterCreatedByIds?: Maybe<EnergyConverter>;
  energyConverterDeleted?: Maybe<EnergyConverter>;
  energyConverterDeletedByIds?: Maybe<EnergyConverter>;
  energyConverterEvents?: Maybe<EnergyConverter>;
  energyConverterEventsByIds?: Maybe<EnergyConverter>;
  energyConverterReplaced?: Maybe<EnergyConverter>;
  energyConverterReplacedByIds?: Maybe<EnergyConverter>;
  energyConverterUpdated?: Maybe<EnergyConverter>;
  energyConverterUpdatedByIds?: Maybe<EnergyConverter>;
  energyInverterCreated?: Maybe<EnergyInverter>;
  energyInverterCreatedByIds?: Maybe<EnergyInverter>;
  energyInverterDeleted?: Maybe<EnergyInverter>;
  energyInverterDeletedByIds?: Maybe<EnergyInverter>;
  energyInverterEvents?: Maybe<EnergyInverter>;
  energyInverterEventsByIds?: Maybe<EnergyInverter>;
  energyInverterReplaced?: Maybe<EnergyInverter>;
  energyInverterReplacedByIds?: Maybe<EnergyInverter>;
  energyInverterUpdated?: Maybe<EnergyInverter>;
  energyInverterUpdatedByIds?: Maybe<EnergyInverter>;
  energyMeterCreated?: Maybe<EnergyMeter>;
  energyMeterCreatedByIds?: Maybe<EnergyMeter>;
  energyMeterDeleted?: Maybe<EnergyMeter>;
  energyMeterDeletedByIds?: Maybe<EnergyMeter>;
  energyMeterEvents?: Maybe<EnergyMeter>;
  energyMeterEventsByIds?: Maybe<EnergyMeter>;
  energyMeterReplaced?: Maybe<EnergyMeter>;
  energyMeterReplacedByIds?: Maybe<EnergyMeter>;
  energyMeterUpdated?: Maybe<EnergyMeter>;
  energyMeterUpdatedByIds?: Maybe<EnergyMeter>;
  energyRectifierCreated?: Maybe<EnergyRectifier>;
  energyRectifierCreatedByIds?: Maybe<EnergyRectifier>;
  energyRectifierDeleted?: Maybe<EnergyRectifier>;
  energyRectifierDeletedByIds?: Maybe<EnergyRectifier>;
  energyRectifierEvents?: Maybe<EnergyRectifier>;
  energyRectifierEventsByIds?: Maybe<EnergyRectifier>;
  energyRectifierReplaced?: Maybe<EnergyRectifier>;
  energyRectifierReplacedByIds?: Maybe<EnergyRectifier>;
  energyRectifierUpdated?: Maybe<EnergyRectifier>;
  energyRectifierUpdatedByIds?: Maybe<EnergyRectifier>;
  energyStorageBatterySystemCreated?: Maybe<EnergyStorageBatterySystem>;
  energyStorageBatterySystemCreatedByIds?: Maybe<EnergyStorageBatterySystem>;
  energyStorageBatterySystemDeleted?: Maybe<EnergyStorageBatterySystem>;
  energyStorageBatterySystemDeletedByIds?: Maybe<EnergyStorageBatterySystem>;
  energyStorageBatterySystemEvents?: Maybe<EnergyStorageBatterySystem>;
  energyStorageBatterySystemEventsByIds?: Maybe<EnergyStorageBatterySystem>;
  energyStorageBatterySystemReplaced?: Maybe<EnergyStorageBatterySystem>;
  energyStorageBatterySystemReplacedByIds?: Maybe<EnergyStorageBatterySystem>;
  energyStorageBatterySystemUpdated?: Maybe<EnergyStorageBatterySystem>;
  energyStorageBatterySystemUpdatedByIds?: Maybe<EnergyStorageBatterySystem>;
  energyStorageCoolingSystemCreated?: Maybe<EnergyStorageCoolingSystem>;
  energyStorageCoolingSystemCreatedByIds?: Maybe<EnergyStorageCoolingSystem>;
  energyStorageCoolingSystemDeleted?: Maybe<EnergyStorageCoolingSystem>;
  energyStorageCoolingSystemDeletedByIds?: Maybe<EnergyStorageCoolingSystem>;
  energyStorageCoolingSystemEvents?: Maybe<EnergyStorageCoolingSystem>;
  energyStorageCoolingSystemEventsByIds?: Maybe<EnergyStorageCoolingSystem>;
  energyStorageCoolingSystemReplaced?: Maybe<EnergyStorageCoolingSystem>;
  energyStorageCoolingSystemReplacedByIds?: Maybe<EnergyStorageCoolingSystem>;
  energyStorageCoolingSystemUpdated?: Maybe<EnergyStorageCoolingSystem>;
  energyStorageCoolingSystemUpdatedByIds?: Maybe<EnergyStorageCoolingSystem>;
  energyStorageKineticSystemCreated?: Maybe<EnergyStorageKineticSystem>;
  energyStorageKineticSystemCreatedByIds?: Maybe<EnergyStorageKineticSystem>;
  energyStorageKineticSystemDeleted?: Maybe<EnergyStorageKineticSystem>;
  energyStorageKineticSystemDeletedByIds?: Maybe<EnergyStorageKineticSystem>;
  energyStorageKineticSystemEvents?: Maybe<EnergyStorageKineticSystem>;
  energyStorageKineticSystemEventsByIds?: Maybe<EnergyStorageKineticSystem>;
  energyStorageKineticSystemReplaced?: Maybe<EnergyStorageKineticSystem>;
  energyStorageKineticSystemReplacedByIds?: Maybe<EnergyStorageKineticSystem>;
  energyStorageKineticSystemUpdated?: Maybe<EnergyStorageKineticSystem>;
  energyStorageKineticSystemUpdatedByIds?: Maybe<EnergyStorageKineticSystem>;
  energySupplierSolarSystemCreated?: Maybe<EnergySupplierSolarSystem>;
  energySupplierSolarSystemCreatedByIds?: Maybe<EnergySupplierSolarSystem>;
  energySupplierSolarSystemDeleted?: Maybe<EnergySupplierSolarSystem>;
  energySupplierSolarSystemDeletedByIds?: Maybe<EnergySupplierSolarSystem>;
  energySupplierSolarSystemEvents?: Maybe<EnergySupplierSolarSystem>;
  energySupplierSolarSystemEventsByIds?: Maybe<EnergySupplierSolarSystem>;
  energySupplierSolarSystemReplaced?: Maybe<EnergySupplierSolarSystem>;
  energySupplierSolarSystemReplacedByIds?: Maybe<EnergySupplierSolarSystem>;
  energySupplierSolarSystemUpdated?: Maybe<EnergySupplierSolarSystem>;
  energySupplierSolarSystemUpdatedByIds?: Maybe<EnergySupplierSolarSystem>;
  energySupplierUtilityCreated?: Maybe<EnergySupplierUtility>;
  energySupplierUtilityCreatedByIds?: Maybe<EnergySupplierUtility>;
  energySupplierUtilityDeleted?: Maybe<EnergySupplierUtility>;
  energySupplierUtilityDeletedByIds?: Maybe<EnergySupplierUtility>;
  energySupplierUtilityEvents?: Maybe<EnergySupplierUtility>;
  energySupplierUtilityEventsByIds?: Maybe<EnergySupplierUtility>;
  energySupplierUtilityReplaced?: Maybe<EnergySupplierUtility>;
  energySupplierUtilityReplacedByIds?: Maybe<EnergySupplierUtility>;
  energySupplierUtilityUpdated?: Maybe<EnergySupplierUtility>;
  energySupplierUtilityUpdatedByIds?: Maybe<EnergySupplierUtility>;
  energySupplierWindSystemCreated?: Maybe<EnergySupplierWindSystem>;
  energySupplierWindSystemCreatedByIds?: Maybe<EnergySupplierWindSystem>;
  energySupplierWindSystemDeleted?: Maybe<EnergySupplierWindSystem>;
  energySupplierWindSystemDeletedByIds?: Maybe<EnergySupplierWindSystem>;
  energySupplierWindSystemEvents?: Maybe<EnergySupplierWindSystem>;
  energySupplierWindSystemEventsByIds?: Maybe<EnergySupplierWindSystem>;
  energySupplierWindSystemReplaced?: Maybe<EnergySupplierWindSystem>;
  energySupplierWindSystemReplacedByIds?: Maybe<EnergySupplierWindSystem>;
  energySupplierWindSystemUpdated?: Maybe<EnergySupplierWindSystem>;
  energySupplierWindSystemUpdatedByIds?: Maybe<EnergySupplierWindSystem>;
  energySwitchPanelCircuitCreated?: Maybe<EnergySwitchPanelCircuit>;
  energySwitchPanelCircuitCreatedByIds?: Maybe<EnergySwitchPanelCircuit>;
  energySwitchPanelCircuitDeleted?: Maybe<EnergySwitchPanelCircuit>;
  energySwitchPanelCircuitDeletedByIds?: Maybe<EnergySwitchPanelCircuit>;
  energySwitchPanelCircuitEvents?: Maybe<EnergySwitchPanelCircuit>;
  energySwitchPanelCircuitEventsByIds?: Maybe<EnergySwitchPanelCircuit>;
  energySwitchPanelCircuitReplaced?: Maybe<EnergySwitchPanelCircuit>;
  energySwitchPanelCircuitReplacedByIds?: Maybe<EnergySwitchPanelCircuit>;
  energySwitchPanelCircuitUpdated?: Maybe<EnergySwitchPanelCircuit>;
  energySwitchPanelCircuitUpdatedByIds?: Maybe<EnergySwitchPanelCircuit>;
  energySwitchPanelCreated?: Maybe<EnergySwitchPanel>;
  energySwitchPanelCreatedByIds?: Maybe<EnergySwitchPanel>;
  energySwitchPanelDeleted?: Maybe<EnergySwitchPanel>;
  energySwitchPanelDeletedByIds?: Maybe<EnergySwitchPanel>;
  energySwitchPanelEvents?: Maybe<EnergySwitchPanel>;
  energySwitchPanelEventsByIds?: Maybe<EnergySwitchPanel>;
  energySwitchPanelReplaced?: Maybe<EnergySwitchPanel>;
  energySwitchPanelReplacedByIds?: Maybe<EnergySwitchPanel>;
  energySwitchPanelUpdated?: Maybe<EnergySwitchPanel>;
  energySwitchPanelUpdatedByIds?: Maybe<EnergySwitchPanel>;
  entitySubscribersUpdated?: Maybe<Scalars['JSONObject']>;
  fireSuppressionSystemCreated?: Maybe<FireSuppressionSystem>;
  fireSuppressionSystemCreatedByIds?: Maybe<FireSuppressionSystem>;
  fireSuppressionSystemDeleted?: Maybe<FireSuppressionSystem>;
  fireSuppressionSystemDeletedByIds?: Maybe<FireSuppressionSystem>;
  fireSuppressionSystemEvents?: Maybe<FireSuppressionSystem>;
  fireSuppressionSystemEventsByIds?: Maybe<FireSuppressionSystem>;
  fireSuppressionSystemReplaced?: Maybe<FireSuppressionSystem>;
  fireSuppressionSystemReplacedByIds?: Maybe<FireSuppressionSystem>;
  fireSuppressionSystemUpdated?: Maybe<FireSuppressionSystem>;
  fireSuppressionSystemUpdatedByIds?: Maybe<FireSuppressionSystem>;
  floorCreated?: Maybe<Floor>;
  floorCreatedByIds?: Maybe<Floor>;
  floorDeleted?: Maybe<Floor>;
  floorDeletedByIds?: Maybe<Floor>;
  floorEvents?: Maybe<Floor>;
  floorEventsByIds?: Maybe<Floor>;
  floorReplaced?: Maybe<Floor>;
  floorReplacedByIds?: Maybe<Floor>;
  floorUpdated?: Maybe<Floor>;
  floorUpdatedByIds?: Maybe<Floor>;
  gPIOCreated?: Maybe<Gpio>;
  gPIOCreatedByIds?: Maybe<Gpio>;
  gPIODeleted?: Maybe<Gpio>;
  gPIODeletedByIds?: Maybe<Gpio>;
  gPIOEvents?: Maybe<Gpio>;
  gPIOEventsByIds?: Maybe<Gpio>;
  gPIOReplaced?: Maybe<Gpio>;
  gPIOReplacedByIds?: Maybe<Gpio>;
  gPIOUpdated?: Maybe<Gpio>;
  gPIOUpdatedByIds?: Maybe<Gpio>;
  hMMCreated?: Maybe<Hmm>;
  hMMCreatedByIds?: Maybe<Hmm>;
  hMMDeleted?: Maybe<Hmm>;
  hMMDeletedByIds?: Maybe<Hmm>;
  hMMEvents?: Maybe<Hmm>;
  hMMEventsByIds?: Maybe<Hmm>;
  hMMReplaced?: Maybe<Hmm>;
  hMMReplacedByIds?: Maybe<Hmm>;
  hMMUpdated?: Maybe<Hmm>;
  hMMUpdatedByIds?: Maybe<Hmm>;
  historicAlertCreated?: Maybe<HistoricAlert>;
  historicAlertCreatedByIds?: Maybe<HistoricAlert>;
  historicAlertDeleted?: Maybe<HistoricAlert>;
  historicAlertDeletedByIds?: Maybe<HistoricAlert>;
  historicAlertEvents?: Maybe<HistoricAlert>;
  historicAlertEventsByIds?: Maybe<HistoricAlert>;
  historicAlertReplaced?: Maybe<HistoricAlert>;
  historicAlertReplacedByIds?: Maybe<HistoricAlert>;
  historicAlertUpdated?: Maybe<HistoricAlert>;
  historicAlertUpdatedByIds?: Maybe<HistoricAlert>;
  historicReadingCreated?: Maybe<HistoricReading>;
  historicReadingCreatedByDeviceId?: Maybe<HistoricReading>;
  historicReadingCreatedByIds?: Maybe<HistoricReading>;
  historicReadingDeleted?: Maybe<HistoricReading>;
  historicReadingDeletedByDeviceId?: Maybe<HistoricReading>;
  historicReadingDeletedByIds?: Maybe<HistoricReading>;
  historicReadingEvents?: Maybe<HistoricReading>;
  historicReadingEventsByDeviceId?: Maybe<HistoricReading>;
  historicReadingEventsByIds?: Maybe<HistoricReading>;
  historicReadingReplaced?: Maybe<HistoricReading>;
  historicReadingReplacedByDeviceId?: Maybe<HistoricReading>;
  historicReadingReplacedByIds?: Maybe<HistoricReading>;
  historicReadingUpdated?: Maybe<HistoricReading>;
  historicReadingUpdatedByDeviceId?: Maybe<HistoricReading>;
  historicReadingUpdatedByIds?: Maybe<HistoricReading>;
  indoorAirHandlerCreated?: Maybe<IndoorAirHandler>;
  indoorAirHandlerCreatedByIds?: Maybe<IndoorAirHandler>;
  indoorAirHandlerDeleted?: Maybe<IndoorAirHandler>;
  indoorAirHandlerDeletedByIds?: Maybe<IndoorAirHandler>;
  indoorAirHandlerEvents?: Maybe<IndoorAirHandler>;
  indoorAirHandlerEventsByIds?: Maybe<IndoorAirHandler>;
  indoorAirHandlerReplaced?: Maybe<IndoorAirHandler>;
  indoorAirHandlerReplacedByIds?: Maybe<IndoorAirHandler>;
  indoorAirHandlerUpdated?: Maybe<IndoorAirHandler>;
  indoorAirHandlerUpdatedByIds?: Maybe<IndoorAirHandler>;
  indoorSensorCreated?: Maybe<IndoorSensor>;
  indoorSensorCreatedByIds?: Maybe<IndoorSensor>;
  indoorSensorDeleted?: Maybe<IndoorSensor>;
  indoorSensorDeletedByIds?: Maybe<IndoorSensor>;
  indoorSensorEvents?: Maybe<IndoorSensor>;
  indoorSensorEventsByIds?: Maybe<IndoorSensor>;
  indoorSensorReplaced?: Maybe<IndoorSensor>;
  indoorSensorReplacedByIds?: Maybe<IndoorSensor>;
  indoorSensorUpdated?: Maybe<IndoorSensor>;
  indoorSensorUpdatedByIds?: Maybe<IndoorSensor>;
  ingestionCreated?: Maybe<Ingestion>;
  ingestionCreatedByIds?: Maybe<Ingestion>;
  ingestionDeleted?: Maybe<Ingestion>;
  ingestionDeletedByIds?: Maybe<Ingestion>;
  ingestionEvents?: Maybe<Ingestion>;
  ingestionEventsByIds?: Maybe<Ingestion>;
  ingestionReplaced?: Maybe<Ingestion>;
  ingestionReplacedByIds?: Maybe<Ingestion>;
  ingestionUpdated?: Maybe<Ingestion>;
  ingestionUpdatedByIds?: Maybe<Ingestion>;
  kineticEnergyManagementSystemCreated?: Maybe<KineticEnergyManagementSystem>;
  kineticEnergyManagementSystemCreatedByIds?: Maybe<KineticEnergyManagementSystem>;
  kineticEnergyManagementSystemDeleted?: Maybe<KineticEnergyManagementSystem>;
  kineticEnergyManagementSystemDeletedByIds?: Maybe<KineticEnergyManagementSystem>;
  kineticEnergyManagementSystemEvents?: Maybe<KineticEnergyManagementSystem>;
  kineticEnergyManagementSystemEventsByIds?: Maybe<KineticEnergyManagementSystem>;
  kineticEnergyManagementSystemReplaced?: Maybe<KineticEnergyManagementSystem>;
  kineticEnergyManagementSystemReplacedByIds?: Maybe<KineticEnergyManagementSystem>;
  kineticEnergyManagementSystemUpdated?: Maybe<KineticEnergyManagementSystem>;
  kineticEnergyManagementSystemUpdatedByIds?: Maybe<KineticEnergyManagementSystem>;
  leakDetectorCreated?: Maybe<LeakDetector>;
  leakDetectorCreatedByIds?: Maybe<LeakDetector>;
  leakDetectorDeleted?: Maybe<LeakDetector>;
  leakDetectorDeletedByIds?: Maybe<LeakDetector>;
  leakDetectorEvents?: Maybe<LeakDetector>;
  leakDetectorEventsByIds?: Maybe<LeakDetector>;
  leakDetectorReplaced?: Maybe<LeakDetector>;
  leakDetectorReplacedByIds?: Maybe<LeakDetector>;
  leakDetectorUpdated?: Maybe<LeakDetector>;
  leakDetectorUpdatedByIds?: Maybe<LeakDetector>;
  loopCreated?: Maybe<Loop>;
  loopCreatedByIds?: Maybe<Loop>;
  loopDeleted?: Maybe<Loop>;
  loopDeletedByIds?: Maybe<Loop>;
  loopEvents?: Maybe<Loop>;
  loopEventsByIds?: Maybe<Loop>;
  loopReplaced?: Maybe<Loop>;
  loopReplacedByIds?: Maybe<Loop>;
  loopUpdated?: Maybe<Loop>;
  loopUpdatedByIds?: Maybe<Loop>;
  modbusAirHandlerCreated?: Maybe<ModbusAirHandler>;
  modbusAirHandlerCreatedByIds?: Maybe<ModbusAirHandler>;
  modbusAirHandlerDeleted?: Maybe<ModbusAirHandler>;
  modbusAirHandlerDeletedByIds?: Maybe<ModbusAirHandler>;
  modbusAirHandlerEvents?: Maybe<ModbusAirHandler>;
  modbusAirHandlerEventsByIds?: Maybe<ModbusAirHandler>;
  modbusAirHandlerReplaced?: Maybe<ModbusAirHandler>;
  modbusAirHandlerReplacedByIds?: Maybe<ModbusAirHandler>;
  modbusAirHandlerUpdated?: Maybe<ModbusAirHandler>;
  modbusAirHandlerUpdatedByIds?: Maybe<ModbusAirHandler>;
  oauthAccessTokenCreated?: Maybe<OauthAccessToken>;
  oauthAccessTokenCreatedByIds?: Maybe<OauthAccessToken>;
  oauthAccessTokenDeleted?: Maybe<OauthAccessToken>;
  oauthAccessTokenDeletedByIds?: Maybe<OauthAccessToken>;
  oauthAccessTokenEvents?: Maybe<OauthAccessToken>;
  oauthAccessTokenEventsByIds?: Maybe<OauthAccessToken>;
  oauthAccessTokenReplaced?: Maybe<OauthAccessToken>;
  oauthAccessTokenReplacedByIds?: Maybe<OauthAccessToken>;
  oauthAccessTokenUpdated?: Maybe<OauthAccessToken>;
  oauthAccessTokenUpdatedByIds?: Maybe<OauthAccessToken>;
  oauthAuthCodeCreated?: Maybe<OauthAuthCode>;
  oauthAuthCodeCreatedByIds?: Maybe<OauthAuthCode>;
  oauthAuthCodeDeleted?: Maybe<OauthAuthCode>;
  oauthAuthCodeDeletedByIds?: Maybe<OauthAuthCode>;
  oauthAuthCodeEvents?: Maybe<OauthAuthCode>;
  oauthAuthCodeEventsByIds?: Maybe<OauthAuthCode>;
  oauthAuthCodeReplaced?: Maybe<OauthAuthCode>;
  oauthAuthCodeReplacedByIds?: Maybe<OauthAuthCode>;
  oauthAuthCodeUpdated?: Maybe<OauthAuthCode>;
  oauthAuthCodeUpdatedByIds?: Maybe<OauthAuthCode>;
  oauthClientCreated?: Maybe<OauthClient>;
  oauthClientCreatedByIds?: Maybe<OauthClient>;
  oauthClientDeleted?: Maybe<OauthClient>;
  oauthClientDeletedByIds?: Maybe<OauthClient>;
  oauthClientEvents?: Maybe<OauthClient>;
  oauthClientEventsByIds?: Maybe<OauthClient>;
  oauthClientReplaced?: Maybe<OauthClient>;
  oauthClientReplacedByIds?: Maybe<OauthClient>;
  oauthClientUpdated?: Maybe<OauthClient>;
  oauthClientUpdatedByIds?: Maybe<OauthClient>;
  occupancySensorCreated?: Maybe<OccupancySensor>;
  occupancySensorCreatedByIds?: Maybe<OccupancySensor>;
  occupancySensorDeleted?: Maybe<OccupancySensor>;
  occupancySensorDeletedByIds?: Maybe<OccupancySensor>;
  occupancySensorEvents?: Maybe<OccupancySensor>;
  occupancySensorEventsByIds?: Maybe<OccupancySensor>;
  occupancySensorReplaced?: Maybe<OccupancySensor>;
  occupancySensorReplacedByIds?: Maybe<OccupancySensor>;
  occupancySensorUpdated?: Maybe<OccupancySensor>;
  occupancySensorUpdatedByIds?: Maybe<OccupancySensor>;
  openWeatherCreated?: Maybe<OpenWeather>;
  openWeatherCreatedByIds?: Maybe<OpenWeather>;
  openWeatherDeleted?: Maybe<OpenWeather>;
  openWeatherDeletedByIds?: Maybe<OpenWeather>;
  openWeatherEvents?: Maybe<OpenWeather>;
  openWeatherEventsByIds?: Maybe<OpenWeather>;
  openWeatherReplaced?: Maybe<OpenWeather>;
  openWeatherReplacedByIds?: Maybe<OpenWeather>;
  openWeatherUpdated?: Maybe<OpenWeather>;
  openWeatherUpdatedByIds?: Maybe<OpenWeather>;
  organizationCreated?: Maybe<Organization>;
  organizationCreatedByIds?: Maybe<Organization>;
  organizationDeleted?: Maybe<Organization>;
  organizationDeletedByIds?: Maybe<Organization>;
  organizationEvents?: Maybe<Organization>;
  organizationEventsByIds?: Maybe<Organization>;
  organizationReplaced?: Maybe<Organization>;
  organizationReplacedByIds?: Maybe<Organization>;
  organizationUpdated?: Maybe<Organization>;
  organizationUpdatedByIds?: Maybe<Organization>;
  outdoorSensorCreated?: Maybe<OutdoorSensor>;
  outdoorSensorCreatedByIds?: Maybe<OutdoorSensor>;
  outdoorSensorDeleted?: Maybe<OutdoorSensor>;
  outdoorSensorDeletedByIds?: Maybe<OutdoorSensor>;
  outdoorSensorEvents?: Maybe<OutdoorSensor>;
  outdoorSensorEventsByIds?: Maybe<OutdoorSensor>;
  outdoorSensorReplaced?: Maybe<OutdoorSensor>;
  outdoorSensorReplacedByIds?: Maybe<OutdoorSensor>;
  outdoorSensorUpdated?: Maybe<OutdoorSensor>;
  outdoorSensorUpdatedByIds?: Maybe<OutdoorSensor>;
  panelCreated?: Maybe<Panel>;
  panelCreatedByIds?: Maybe<Panel>;
  panelDeleted?: Maybe<Panel>;
  panelDeletedByIds?: Maybe<Panel>;
  panelEvents?: Maybe<Panel>;
  panelEventsByIds?: Maybe<Panel>;
  panelReplaced?: Maybe<Panel>;
  panelReplacedByIds?: Maybe<Panel>;
  panelUpdated?: Maybe<Panel>;
  panelUpdatedByIds?: Maybe<Panel>;
  plmContractCreated?: Maybe<PlmContract>;
  plmContractCreatedByIds?: Maybe<PlmContract>;
  plmContractDeleted?: Maybe<PlmContract>;
  plmContractDeletedByIds?: Maybe<PlmContract>;
  plmContractEvents?: Maybe<PlmContract>;
  plmContractEventsByIds?: Maybe<PlmContract>;
  plmContractReplaced?: Maybe<PlmContract>;
  plmContractReplacedByIds?: Maybe<PlmContract>;
  plmContractUpdated?: Maybe<PlmContract>;
  plmContractUpdatedByIds?: Maybe<PlmContract>;
  plmCurtailmentActionCreated?: Maybe<PlmCurtailmentAction>;
  plmCurtailmentActionCreatedByIds?: Maybe<PlmCurtailmentAction>;
  plmCurtailmentActionDeleted?: Maybe<PlmCurtailmentAction>;
  plmCurtailmentActionDeletedByIds?: Maybe<PlmCurtailmentAction>;
  plmCurtailmentActionEvents?: Maybe<PlmCurtailmentAction>;
  plmCurtailmentActionEventsByIds?: Maybe<PlmCurtailmentAction>;
  plmCurtailmentActionReplaced?: Maybe<PlmCurtailmentAction>;
  plmCurtailmentActionReplacedByIds?: Maybe<PlmCurtailmentAction>;
  plmCurtailmentActionUpdated?: Maybe<PlmCurtailmentAction>;
  plmCurtailmentActionUpdatedByIds?: Maybe<PlmCurtailmentAction>;
  plmCurtailmentPlanCreated?: Maybe<PlmCurtailmentPlan>;
  plmCurtailmentPlanCreatedByIds?: Maybe<PlmCurtailmentPlan>;
  plmCurtailmentPlanDeleted?: Maybe<PlmCurtailmentPlan>;
  plmCurtailmentPlanDeletedByIds?: Maybe<PlmCurtailmentPlan>;
  plmCurtailmentPlanEvents?: Maybe<PlmCurtailmentPlan>;
  plmCurtailmentPlanEventsByIds?: Maybe<PlmCurtailmentPlan>;
  plmCurtailmentPlanReplaced?: Maybe<PlmCurtailmentPlan>;
  plmCurtailmentPlanReplacedByIds?: Maybe<PlmCurtailmentPlan>;
  plmCurtailmentPlanUpdated?: Maybe<PlmCurtailmentPlan>;
  plmCurtailmentPlanUpdatedByIds?: Maybe<PlmCurtailmentPlan>;
  plmCurtailmentTaskCreated?: Maybe<PlmCurtailmentTask>;
  plmCurtailmentTaskCreatedByIds?: Maybe<PlmCurtailmentTask>;
  plmCurtailmentTaskDeleted?: Maybe<PlmCurtailmentTask>;
  plmCurtailmentTaskDeletedByIds?: Maybe<PlmCurtailmentTask>;
  plmCurtailmentTaskEvents?: Maybe<PlmCurtailmentTask>;
  plmCurtailmentTaskEventsByIds?: Maybe<PlmCurtailmentTask>;
  plmCurtailmentTaskReplaced?: Maybe<PlmCurtailmentTask>;
  plmCurtailmentTaskReplacedByIds?: Maybe<PlmCurtailmentTask>;
  plmCurtailmentTaskUpdated?: Maybe<PlmCurtailmentTask>;
  plmCurtailmentTaskUpdatedByIds?: Maybe<PlmCurtailmentTask>;
  plmCurtailmentTasksByActionIdCreated?: Maybe<PlmCurtailmentTask>;
  plmCurtailmentTasksByActionIdDeleted?: Maybe<PlmCurtailmentTask>;
  plmCurtailmentTasksByActionIdEvents?: Maybe<PlmCurtailmentTask>;
  plmCurtailmentTasksByActionIdReplaced?: Maybe<PlmCurtailmentTask>;
  plmCurtailmentTasksByActionIdUpdated?: Maybe<PlmCurtailmentTask>;
  plmCurtailmentTasksByPropertyIdCreated?: Maybe<PlmCurtailmentTask>;
  plmCurtailmentTasksByPropertyIdDeleted?: Maybe<PlmCurtailmentTask>;
  plmCurtailmentTasksByPropertyIdEvents?: Maybe<PlmCurtailmentTask>;
  plmCurtailmentTasksByPropertyIdReplaced?: Maybe<PlmCurtailmentTask>;
  plmCurtailmentTasksByPropertyIdUpdated?: Maybe<PlmCurtailmentTask>;
  plmCurtailmentTasksByResponseIdCreated?: Maybe<PlmCurtailmentTask>;
  plmCurtailmentTasksByResponseIdDeleted?: Maybe<PlmCurtailmentTask>;
  plmCurtailmentTasksByResponseIdEvents?: Maybe<PlmCurtailmentTask>;
  plmCurtailmentTasksByResponseIdReplaced?: Maybe<PlmCurtailmentTask>;
  plmCurtailmentTasksByResponseIdUpdated?: Maybe<PlmCurtailmentTask>;
  plmEventCreated?: Maybe<PlmEvent>;
  plmEventCreatedByIds?: Maybe<PlmEvent>;
  plmEventDeleted?: Maybe<PlmEvent>;
  plmEventDeletedByIds?: Maybe<PlmEvent>;
  plmEventEvents?: Maybe<PlmEvent>;
  plmEventEventsByIds?: Maybe<PlmEvent>;
  plmEventReplaced?: Maybe<PlmEvent>;
  plmEventReplacedByIds?: Maybe<PlmEvent>;
  plmEventResponseCreated?: Maybe<PlmEventResponse>;
  plmEventResponseCreatedByIds?: Maybe<PlmEventResponse>;
  plmEventResponseDeleted?: Maybe<PlmEventResponse>;
  plmEventResponseDeletedByIds?: Maybe<PlmEventResponse>;
  plmEventResponseEvents?: Maybe<PlmEventResponse>;
  plmEventResponseEventsByIds?: Maybe<PlmEventResponse>;
  plmEventResponseReplaced?: Maybe<PlmEventResponse>;
  plmEventResponseReplacedByIds?: Maybe<PlmEventResponse>;
  plmEventResponseUpdated?: Maybe<PlmEventResponse>;
  plmEventResponseUpdatedByIds?: Maybe<PlmEventResponse>;
  plmEventUpdated?: Maybe<PlmEvent>;
  plmEventUpdatedByIds?: Maybe<PlmEvent>;
  plmExternalMeterMappingCreated?: Maybe<PlmExternalMeterMapping>;
  plmExternalMeterMappingCreatedByIds?: Maybe<PlmExternalMeterMapping>;
  plmExternalMeterMappingDeleted?: Maybe<PlmExternalMeterMapping>;
  plmExternalMeterMappingDeletedByIds?: Maybe<PlmExternalMeterMapping>;
  plmExternalMeterMappingEvents?: Maybe<PlmExternalMeterMapping>;
  plmExternalMeterMappingEventsByIds?: Maybe<PlmExternalMeterMapping>;
  plmExternalMeterMappingReplaced?: Maybe<PlmExternalMeterMapping>;
  plmExternalMeterMappingReplacedByIds?: Maybe<PlmExternalMeterMapping>;
  plmExternalMeterMappingUpdated?: Maybe<PlmExternalMeterMapping>;
  plmExternalMeterMappingUpdatedByIds?: Maybe<PlmExternalMeterMapping>;
  plmIngressEventCreated?: Maybe<PlmIngressEvent>;
  plmIngressEventCreatedByIds?: Maybe<PlmIngressEvent>;
  plmIngressEventDeleted?: Maybe<PlmIngressEvent>;
  plmIngressEventDeletedByIds?: Maybe<PlmIngressEvent>;
  plmIngressEventEvents?: Maybe<PlmIngressEvent>;
  plmIngressEventEventsByIds?: Maybe<PlmIngressEvent>;
  plmIngressEventReplaced?: Maybe<PlmIngressEvent>;
  plmIngressEventReplacedByIds?: Maybe<PlmIngressEvent>;
  plmIngressEventUpdated?: Maybe<PlmIngressEvent>;
  plmIngressEventUpdatedByIds?: Maybe<PlmIngressEvent>;
  plmNotificationCreated?: Maybe<PlmNotification>;
  plmNotificationCreatedByIds?: Maybe<PlmNotification>;
  plmNotificationDeleted?: Maybe<PlmNotification>;
  plmNotificationDeletedByIds?: Maybe<PlmNotification>;
  plmNotificationEvents?: Maybe<PlmNotification>;
  plmNotificationEventsByIds?: Maybe<PlmNotification>;
  plmNotificationReplaced?: Maybe<PlmNotification>;
  plmNotificationReplacedByIds?: Maybe<PlmNotification>;
  plmNotificationUpdated?: Maybe<PlmNotification>;
  plmNotificationUpdatedByIds?: Maybe<PlmNotification>;
  plmPartnerCreated?: Maybe<PlmPartner>;
  plmPartnerCreatedByIds?: Maybe<PlmPartner>;
  plmPartnerDeleted?: Maybe<PlmPartner>;
  plmPartnerDeletedByIds?: Maybe<PlmPartner>;
  plmPartnerEvents?: Maybe<PlmPartner>;
  plmPartnerEventsByIds?: Maybe<PlmPartner>;
  plmPartnerReplaced?: Maybe<PlmPartner>;
  plmPartnerReplacedByIds?: Maybe<PlmPartner>;
  plmPartnerUpdated?: Maybe<PlmPartner>;
  plmPartnerUpdatedByIds?: Maybe<PlmPartner>;
  plmProgramCreated?: Maybe<PlmProgram>;
  plmProgramCreatedByIds?: Maybe<PlmProgram>;
  plmProgramDeleted?: Maybe<PlmProgram>;
  plmProgramDeletedByIds?: Maybe<PlmProgram>;
  plmProgramEvents?: Maybe<PlmProgram>;
  plmProgramEventsByIds?: Maybe<PlmProgram>;
  plmProgramReplaced?: Maybe<PlmProgram>;
  plmProgramReplacedByIds?: Maybe<PlmProgram>;
  plmProgramUpdated?: Maybe<PlmProgram>;
  plmProgramUpdatedByIds?: Maybe<PlmProgram>;
  plmUtilityCreated?: Maybe<PlmUtility>;
  plmUtilityCreatedByIds?: Maybe<PlmUtility>;
  plmUtilityDeleted?: Maybe<PlmUtility>;
  plmUtilityDeletedByIds?: Maybe<PlmUtility>;
  plmUtilityEvents?: Maybe<PlmUtility>;
  plmUtilityEventsByIds?: Maybe<PlmUtility>;
  plmUtilityReplaced?: Maybe<PlmUtility>;
  plmUtilityReplacedByIds?: Maybe<PlmUtility>;
  plmUtilityUpdated?: Maybe<PlmUtility>;
  plmUtilityUpdatedByIds?: Maybe<PlmUtility>;
  powerMonitorCreated?: Maybe<PowerMonitor>;
  powerMonitorCreatedByIds?: Maybe<PowerMonitor>;
  powerMonitorDeleted?: Maybe<PowerMonitor>;
  powerMonitorDeletedByIds?: Maybe<PowerMonitor>;
  powerMonitorEvents?: Maybe<PowerMonitor>;
  powerMonitorEventsByIds?: Maybe<PowerMonitor>;
  powerMonitorReplaced?: Maybe<PowerMonitor>;
  powerMonitorReplacedByIds?: Maybe<PowerMonitor>;
  powerMonitorUpdated?: Maybe<PowerMonitor>;
  powerMonitorUpdatedByIds?: Maybe<PowerMonitor>;
  pressureSensorCreated?: Maybe<PressureSensor>;
  pressureSensorCreatedByIds?: Maybe<PressureSensor>;
  pressureSensorDeleted?: Maybe<PressureSensor>;
  pressureSensorDeletedByIds?: Maybe<PressureSensor>;
  pressureSensorEvents?: Maybe<PressureSensor>;
  pressureSensorEventsByIds?: Maybe<PressureSensor>;
  pressureSensorReplaced?: Maybe<PressureSensor>;
  pressureSensorReplacedByIds?: Maybe<PressureSensor>;
  pressureSensorUpdated?: Maybe<PressureSensor>;
  pressureSensorUpdatedByIds?: Maybe<PressureSensor>;
  propertyCreated?: Maybe<Property>;
  propertyCreatedByIds?: Maybe<Property>;
  propertyDeleted?: Maybe<Property>;
  propertyDeletedByIds?: Maybe<Property>;
  propertyEvents?: Maybe<Property>;
  propertyEventsByIds?: Maybe<Property>;
  propertyReplaced?: Maybe<Property>;
  propertyReplacedByIds?: Maybe<Property>;
  /** @deprecated Extremely computationally expensive. Instead, use the propertySummaryAlerts query and poll for updates */
  propertySummaryAlertsUpdated?: Maybe<PropertySummaryAlerts>;
  /** @deprecated Extremely computationally expensive. Instead, use the propertySummaryDevices query and poll for updates */
  propertySummaryDevicesUpdated?: Maybe<PropertySummaryDevices>;
  /** @deprecated Extremely computationally expensive. Instead, use the propertySummaryStats query and poll for updates */
  propertySummaryStatsUpdated?: Maybe<PropertySummaryStats>;
  propertyUpdated?: Maybe<Property>;
  propertyUpdatedByIds?: Maybe<Property>;
  relayDeviceCreated?: Maybe<RelayDevice>;
  relayDeviceCreatedByIds?: Maybe<RelayDevice>;
  relayDeviceDeleted?: Maybe<RelayDevice>;
  relayDeviceDeletedByIds?: Maybe<RelayDevice>;
  relayDeviceEvents?: Maybe<RelayDevice>;
  relayDeviceEventsByIds?: Maybe<RelayDevice>;
  relayDeviceReplaced?: Maybe<RelayDevice>;
  relayDeviceReplacedByIds?: Maybe<RelayDevice>;
  relayDeviceUpdated?: Maybe<RelayDevice>;
  relayDeviceUpdatedByIds?: Maybe<RelayDevice>;
  /** Subscribe to updates for scheduled notifications based on user authorization */
  scheduledNotificationsUpdated: Array<SystemNotification>;
  /** Subscribe to system notification events in real-time */
  scheduledSystemNotificationEvents?: Maybe<SystemNotification>;
  /** Subscribe to system notification events for specific IDs */
  scheduledSystemNotificationEventsByIds?: Maybe<SystemNotification>;
  scheduledTaskCreated?: Maybe<ScheduledTask>;
  scheduledTaskCreatedByIds?: Maybe<ScheduledTask>;
  scheduledTaskDeleted?: Maybe<ScheduledTask>;
  scheduledTaskDeletedByIds?: Maybe<ScheduledTask>;
  scheduledTaskEvents?: Maybe<ScheduledTask>;
  scheduledTaskEventsByIds?: Maybe<ScheduledTask>;
  scheduledTaskReplaced?: Maybe<ScheduledTask>;
  scheduledTaskReplacedByIds?: Maybe<ScheduledTask>;
  scheduledTaskUpdated?: Maybe<ScheduledTask>;
  scheduledTaskUpdatedByIds?: Maybe<ScheduledTask>;
  setpointProfileCreated?: Maybe<SetpointProfile>;
  setpointProfileCreatedByIds?: Maybe<SetpointProfile>;
  setpointProfileDeleted?: Maybe<SetpointProfile>;
  setpointProfileDeletedByIds?: Maybe<SetpointProfile>;
  setpointProfileEvents?: Maybe<SetpointProfile>;
  setpointProfileEventsByIds?: Maybe<SetpointProfile>;
  setpointProfileReplaced?: Maybe<SetpointProfile>;
  setpointProfileReplacedByIds?: Maybe<SetpointProfile>;
  setpointProfileUpdated?: Maybe<SetpointProfile>;
  setpointProfileUpdatedByIds?: Maybe<SetpointProfile>;
  smartPowerOutletCreated?: Maybe<SmartPowerOutlet>;
  smartPowerOutletCreatedByIds?: Maybe<SmartPowerOutlet>;
  smartPowerOutletDeleted?: Maybe<SmartPowerOutlet>;
  smartPowerOutletDeletedByIds?: Maybe<SmartPowerOutlet>;
  smartPowerOutletEvents?: Maybe<SmartPowerOutlet>;
  smartPowerOutletEventsByIds?: Maybe<SmartPowerOutlet>;
  smartPowerOutletReplaced?: Maybe<SmartPowerOutlet>;
  smartPowerOutletReplacedByIds?: Maybe<SmartPowerOutlet>;
  smartPowerOutletUpdated?: Maybe<SmartPowerOutlet>;
  smartPowerOutletUpdatedByIds?: Maybe<SmartPowerOutlet>;
  solarManagementSystemCreated?: Maybe<SolarManagementSystem>;
  solarManagementSystemCreatedByIds?: Maybe<SolarManagementSystem>;
  solarManagementSystemDeleted?: Maybe<SolarManagementSystem>;
  solarManagementSystemDeletedByIds?: Maybe<SolarManagementSystem>;
  solarManagementSystemEvents?: Maybe<SolarManagementSystem>;
  solarManagementSystemEventsByIds?: Maybe<SolarManagementSystem>;
  solarManagementSystemReplaced?: Maybe<SolarManagementSystem>;
  solarManagementSystemReplacedByIds?: Maybe<SolarManagementSystem>;
  solarManagementSystemUpdated?: Maybe<SolarManagementSystem>;
  solarManagementSystemUpdatedByIds?: Maybe<SolarManagementSystem>;
  sourceCreated?: Maybe<Source>;
  sourceCreatedByIds?: Maybe<Source>;
  sourceDeleted?: Maybe<Source>;
  sourceDeletedByIds?: Maybe<Source>;
  sourceEvents?: Maybe<Source>;
  sourceEventsByIds?: Maybe<Source>;
  sourceReplaced?: Maybe<Source>;
  sourceReplacedByIds?: Maybe<Source>;
  sourceUpdated?: Maybe<Source>;
  sourceUpdatedByIds?: Maybe<Source>;
  /** Subscribe to system commands */
  systemCommandPosted?: Maybe<SystemCommand>;
  /** Test system connectivity */
  systemConnectivityTest?: Maybe<SystemConnectivityStatus>;
  /** Subscribe to system messages */
  systemMessagePosted?: Maybe<SystemMessage>;
  systemNotificationCreated?: Maybe<SystemNotification>;
  systemNotificationCreatedByIds?: Maybe<SystemNotification>;
  systemNotificationDeleted?: Maybe<SystemNotification>;
  systemNotificationDeletedByIds?: Maybe<SystemNotification>;
  systemNotificationEvents?: Maybe<SystemNotification>;
  systemNotificationEventsByIds?: Maybe<SystemNotification>;
  systemNotificationReplaced?: Maybe<SystemNotification>;
  systemNotificationReplacedByIds?: Maybe<SystemNotification>;
  systemNotificationUpdated?: Maybe<SystemNotification>;
  systemNotificationUpdatedByIds?: Maybe<SystemNotification>;
  thermistorCreated?: Maybe<Thermistor>;
  thermistorCreatedByIds?: Maybe<Thermistor>;
  thermistorDeleted?: Maybe<Thermistor>;
  thermistorDeletedByIds?: Maybe<Thermistor>;
  thermistorEvents?: Maybe<Thermistor>;
  thermistorEventsByIds?: Maybe<Thermistor>;
  thermistorReplaced?: Maybe<Thermistor>;
  thermistorReplacedByIds?: Maybe<Thermistor>;
  thermistorUpdated?: Maybe<Thermistor>;
  thermistorUpdatedByIds?: Maybe<Thermistor>;
  thermostatCreated?: Maybe<Thermostat>;
  thermostatCreatedByIds?: Maybe<Thermostat>;
  thermostatDeleted?: Maybe<Thermostat>;
  thermostatDeletedByIds?: Maybe<Thermostat>;
  thermostatEvents?: Maybe<Thermostat>;
  thermostatEventsByIds?: Maybe<Thermostat>;
  thermostatReplaced?: Maybe<Thermostat>;
  thermostatReplacedByIds?: Maybe<Thermostat>;
  thermostatScheduleProfileCreated?: Maybe<ThermostatScheduleProfile>;
  thermostatScheduleProfileCreatedByIds?: Maybe<ThermostatScheduleProfile>;
  thermostatScheduleProfileDeleted?: Maybe<ThermostatScheduleProfile>;
  thermostatScheduleProfileDeletedByIds?: Maybe<ThermostatScheduleProfile>;
  thermostatScheduleProfileEvents?: Maybe<ThermostatScheduleProfile>;
  thermostatScheduleProfileEventsByIds?: Maybe<ThermostatScheduleProfile>;
  thermostatScheduleProfileReplaced?: Maybe<ThermostatScheduleProfile>;
  thermostatScheduleProfileReplacedByIds?: Maybe<ThermostatScheduleProfile>;
  thermostatScheduleProfileUpdated?: Maybe<ThermostatScheduleProfile>;
  thermostatScheduleProfileUpdatedByIds?: Maybe<ThermostatScheduleProfile>;
  thermostatScheduleTemplateCreated?: Maybe<ThermostatScheduleTemplate>;
  thermostatScheduleTemplateCreatedByIds?: Maybe<ThermostatScheduleTemplate>;
  thermostatScheduleTemplateDeleted?: Maybe<ThermostatScheduleTemplate>;
  thermostatScheduleTemplateDeletedByIds?: Maybe<ThermostatScheduleTemplate>;
  thermostatScheduleTemplateEvents?: Maybe<ThermostatScheduleTemplate>;
  thermostatScheduleTemplateEventsByIds?: Maybe<ThermostatScheduleTemplate>;
  thermostatScheduleTemplateReplaced?: Maybe<ThermostatScheduleTemplate>;
  thermostatScheduleTemplateReplacedByIds?: Maybe<ThermostatScheduleTemplate>;
  thermostatScheduleTemplateUpdated?: Maybe<ThermostatScheduleTemplate>;
  thermostatScheduleTemplateUpdatedByIds?: Maybe<ThermostatScheduleTemplate>;
  thermostatUpdated?: Maybe<Thermostat>;
  thermostatUpdatedByIds?: Maybe<Thermostat>;
  unitCreated?: Maybe<Unit>;
  unitCreatedByIds?: Maybe<Unit>;
  unitCreatedByPropertyId?: Maybe<Unit>;
  unitDeleted?: Maybe<Unit>;
  unitDeletedByIds?: Maybe<Unit>;
  unitDeletedByPropertyId?: Maybe<Unit>;
  unitEvents?: Maybe<Unit>;
  unitEventsByIds?: Maybe<Unit>;
  unitEventsByPropertyId?: Maybe<Unit>;
  unitReplaced?: Maybe<Unit>;
  unitReplacedByIds?: Maybe<Unit>;
  unitReplacedByPropertyId?: Maybe<Unit>;
  unitUpdated?: Maybe<Unit>;
  unitUpdatedByIds?: Maybe<Unit>;
  unitUpdatedByPropertyId?: Maybe<Unit>;
  userCreated?: Maybe<User>;
  userCreatedByIds?: Maybe<User>;
  userDeleted?: Maybe<User>;
  userDeletedByIds?: Maybe<User>;
  userEvents?: Maybe<User>;
  userEventsByIds?: Maybe<User>;
  userHistoryCreated?: Maybe<UserHistory>;
  userHistoryCreatedByIds?: Maybe<UserHistory>;
  userHistoryDeleted?: Maybe<UserHistory>;
  userHistoryDeletedByIds?: Maybe<UserHistory>;
  userHistoryEvents?: Maybe<UserHistory>;
  userHistoryEventsByIds?: Maybe<UserHistory>;
  userHistoryReplaced?: Maybe<UserHistory>;
  userHistoryReplacedByIds?: Maybe<UserHistory>;
  userHistoryUpdated?: Maybe<UserHistory>;
  userHistoryUpdatedByIds?: Maybe<UserHistory>;
  userReplaced?: Maybe<User>;
  userReplacedByIds?: Maybe<User>;
  userUpdated?: Maybe<User>;
  userUpdatedByIds?: Maybe<User>;
  vSDPumpCreated?: Maybe<VsdPump>;
  vSDPumpCreatedByIds?: Maybe<VsdPump>;
  vSDPumpDeleted?: Maybe<VsdPump>;
  vSDPumpDeletedByIds?: Maybe<VsdPump>;
  vSDPumpEvents?: Maybe<VsdPump>;
  vSDPumpEventsByIds?: Maybe<VsdPump>;
  vSDPumpReplaced?: Maybe<VsdPump>;
  vSDPumpReplacedByIds?: Maybe<VsdPump>;
  vSDPumpUpdated?: Maybe<VsdPump>;
  vSDPumpUpdatedByIds?: Maybe<VsdPump>;
  virtualPowerPlantCreated?: Maybe<VirtualPowerPlant>;
  virtualPowerPlantCreatedByIds?: Maybe<VirtualPowerPlant>;
  virtualPowerPlantDeleted?: Maybe<VirtualPowerPlant>;
  virtualPowerPlantDeletedByIds?: Maybe<VirtualPowerPlant>;
  virtualPowerPlantEvents?: Maybe<VirtualPowerPlant>;
  virtualPowerPlantEventsByIds?: Maybe<VirtualPowerPlant>;
  virtualPowerPlantReplaced?: Maybe<VirtualPowerPlant>;
  virtualPowerPlantReplacedByIds?: Maybe<VirtualPowerPlant>;
  virtualPowerPlantUpdated?: Maybe<VirtualPowerPlant>;
  virtualPowerPlantUpdatedByIds?: Maybe<VirtualPowerPlant>;
  windManagementSystemCreated?: Maybe<WindManagementSystem>;
  windManagementSystemCreatedByIds?: Maybe<WindManagementSystem>;
  windManagementSystemDeleted?: Maybe<WindManagementSystem>;
  windManagementSystemDeletedByIds?: Maybe<WindManagementSystem>;
  windManagementSystemEvents?: Maybe<WindManagementSystem>;
  windManagementSystemEventsByIds?: Maybe<WindManagementSystem>;
  windManagementSystemReplaced?: Maybe<WindManagementSystem>;
  windManagementSystemReplacedByIds?: Maybe<WindManagementSystem>;
  windManagementSystemUpdated?: Maybe<WindManagementSystem>;
  windManagementSystemUpdatedByIds?: Maybe<WindManagementSystem>;
  windowSensorCreated?: Maybe<WindowSensor>;
  windowSensorCreatedByIds?: Maybe<WindowSensor>;
  windowSensorDeleted?: Maybe<WindowSensor>;
  windowSensorDeletedByIds?: Maybe<WindowSensor>;
  windowSensorEvents?: Maybe<WindowSensor>;
  windowSensorEventsByIds?: Maybe<WindowSensor>;
  windowSensorReplaced?: Maybe<WindowSensor>;
  windowSensorReplacedByIds?: Maybe<WindowSensor>;
  windowSensorUpdated?: Maybe<WindowSensor>;
  windowSensorUpdatedByIds?: Maybe<WindowSensor>;
  z210PumpCreated?: Maybe<Z210Pump>;
  z210PumpCreatedByIds?: Maybe<Z210Pump>;
  z210PumpDeleted?: Maybe<Z210Pump>;
  z210PumpDeletedByIds?: Maybe<Z210Pump>;
  z210PumpEvents?: Maybe<Z210Pump>;
  z210PumpEventsByIds?: Maybe<Z210Pump>;
  z210PumpReplaced?: Maybe<Z210Pump>;
  z210PumpReplacedByIds?: Maybe<Z210Pump>;
  z210PumpUpdated?: Maybe<Z210Pump>;
  z210PumpUpdatedByIds?: Maybe<Z210Pump>;
  zoneCreated?: Maybe<Zone>;
  zoneCreatedByIds?: Maybe<Zone>;
  zoneDeleted?: Maybe<Zone>;
  zoneDeletedByIds?: Maybe<Zone>;
  zoneEvents?: Maybe<Zone>;
  zoneEventsByIds?: Maybe<Zone>;
  zonePolicyCreated?: Maybe<ZonePolicy>;
  zonePolicyCreatedByIds?: Maybe<ZonePolicy>;
  zonePolicyDeleted?: Maybe<ZonePolicy>;
  zonePolicyDeletedByIds?: Maybe<ZonePolicy>;
  zonePolicyEvents?: Maybe<ZonePolicy>;
  zonePolicyEventsByIds?: Maybe<ZonePolicy>;
  zonePolicyReplaced?: Maybe<ZonePolicy>;
  zonePolicyReplacedByIds?: Maybe<ZonePolicy>;
  zonePolicyUpdated?: Maybe<ZonePolicy>;
  zonePolicyUpdatedByIds?: Maybe<ZonePolicy>;
  zoneReplaced?: Maybe<Zone>;
  zoneReplacedByIds?: Maybe<Zone>;
  zoneUpdated?: Maybe<Zone>;
  zoneUpdatedByIds?: Maybe<Zone>;
};

export type SubscriptionActuatorCreatedByIdsArgs = {
  _ids?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type SubscriptionActuatorDeletedByIdsArgs = {
  _ids?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type SubscriptionActuatorEventsByIdsArgs = {
  _ids?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type SubscriptionActuatorReplacedByIdsArgs = {
  _ids?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type SubscriptionActuatorUpdatedByIdsArgs = {
  _ids?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type SubscriptionAlertCategoryCreatedByIdsArgs = {
  _ids?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type SubscriptionAlertCategoryDeletedByIdsArgs = {
  _ids?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type SubscriptionAlertCategoryEventsByIdsArgs = {
  _ids?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type SubscriptionAlertCategoryReplacedByIdsArgs = {
  _ids?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type SubscriptionAlertCategoryUpdatedByIdsArgs = {
  _ids?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type SubscriptionAlertCreatedByIdsArgs = {
  _ids?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type SubscriptionAlertDeletedByIdsArgs = {
  _ids?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type SubscriptionAlertEventsByIdsArgs = {
  _ids?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type SubscriptionAlertNotificationByAlertIdCreatedArgs = {
  alertId: Scalars['String'];
  filter?: InputMaybe<FilteralertNotificationByAlertId>;
  limit?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<SortFindManyAlertNotificationInput>;
};

export type SubscriptionAlertNotificationByAlertIdDeletedArgs = {
  alertId: Scalars['String'];
  filter?: InputMaybe<FilteralertNotificationByAlertId>;
  limit?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<SortFindManyAlertNotificationInput>;
};

export type SubscriptionAlertNotificationByAlertIdEventsArgs = {
  alertId: Scalars['String'];
  filter?: InputMaybe<FilteralertNotificationByAlertId>;
  limit?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<SortFindManyAlertNotificationInput>;
};

export type SubscriptionAlertNotificationByAlertIdReplacedArgs = {
  alertId: Scalars['String'];
  filter?: InputMaybe<FilteralertNotificationByAlertId>;
  limit?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<SortFindManyAlertNotificationInput>;
};

export type SubscriptionAlertNotificationByAlertIdUpdatedArgs = {
  alertId: Scalars['String'];
  filter?: InputMaybe<FilteralertNotificationByAlertId>;
  limit?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<SortFindManyAlertNotificationInput>;
};

export type SubscriptionAlertNotificationByRecipientCreatedArgs = {
  filter?: InputMaybe<FilteralertNotificationByRecipient>;
  limit?: InputMaybe<Scalars['Int']>;
  recipient: Scalars['String'];
  skip?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<SortFindManyAlertNotificationInput>;
};

export type SubscriptionAlertNotificationByRecipientDeletedArgs = {
  filter?: InputMaybe<FilteralertNotificationByRecipient>;
  limit?: InputMaybe<Scalars['Int']>;
  recipient: Scalars['String'];
  skip?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<SortFindManyAlertNotificationInput>;
};

export type SubscriptionAlertNotificationByRecipientEventsArgs = {
  filter?: InputMaybe<FilteralertNotificationByRecipient>;
  limit?: InputMaybe<Scalars['Int']>;
  recipient: Scalars['String'];
  skip?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<SortFindManyAlertNotificationInput>;
};

export type SubscriptionAlertNotificationByRecipientReplacedArgs = {
  filter?: InputMaybe<FilteralertNotificationByRecipient>;
  limit?: InputMaybe<Scalars['Int']>;
  recipient: Scalars['String'];
  skip?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<SortFindManyAlertNotificationInput>;
};

export type SubscriptionAlertNotificationByRecipientUpdatedArgs = {
  filter?: InputMaybe<FilteralertNotificationByRecipient>;
  limit?: InputMaybe<Scalars['Int']>;
  recipient: Scalars['String'];
  skip?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<SortFindManyAlertNotificationInput>;
};

export type SubscriptionAlertNotificationCreatedByIdsArgs = {
  _ids?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type SubscriptionAlertNotificationDeletedByIdsArgs = {
  _ids?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type SubscriptionAlertNotificationEventsByIdsArgs = {
  _ids?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type SubscriptionAlertNotificationReplacedByIdsArgs = {
  _ids?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type SubscriptionAlertNotificationUpdatedByIdsArgs = {
  _ids?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type SubscriptionAlertOptOutCreatedByIdsArgs = {
  _ids?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type SubscriptionAlertOptOutDeletedByIdsArgs = {
  _ids?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type SubscriptionAlertOptOutEventsByIdsArgs = {
  _ids?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type SubscriptionAlertOptOutReplacedByIdsArgs = {
  _ids?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type SubscriptionAlertOptOutUpdatedByIdsArgs = {
  _ids?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type SubscriptionAlertOptOutsByRecipientCreatedArgs = {
  filter?: InputMaybe<FilteralertOptOutsByRecipient>;
  limit?: InputMaybe<Scalars['Int']>;
  recipient: Scalars['String'];
  skip?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<SortFindManyAlertOptOutInput>;
};

export type SubscriptionAlertOptOutsByRecipientDeletedArgs = {
  filter?: InputMaybe<FilteralertOptOutsByRecipient>;
  limit?: InputMaybe<Scalars['Int']>;
  recipient: Scalars['String'];
  skip?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<SortFindManyAlertOptOutInput>;
};

export type SubscriptionAlertOptOutsByRecipientEventsArgs = {
  filter?: InputMaybe<FilteralertOptOutsByRecipient>;
  limit?: InputMaybe<Scalars['Int']>;
  recipient: Scalars['String'];
  skip?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<SortFindManyAlertOptOutInput>;
};

export type SubscriptionAlertOptOutsByRecipientReplacedArgs = {
  filter?: InputMaybe<FilteralertOptOutsByRecipient>;
  limit?: InputMaybe<Scalars['Int']>;
  recipient: Scalars['String'];
  skip?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<SortFindManyAlertOptOutInput>;
};

export type SubscriptionAlertOptOutsByRecipientUpdatedArgs = {
  filter?: InputMaybe<FilteralertOptOutsByRecipient>;
  limit?: InputMaybe<Scalars['Int']>;
  recipient: Scalars['String'];
  skip?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<SortFindManyAlertOptOutInput>;
};

export type SubscriptionAlertReplacedByIdsArgs = {
  _ids?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type SubscriptionAlertSubscriptionCreatedByIdsArgs = {
  _ids?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type SubscriptionAlertSubscriptionDeletedByIdsArgs = {
  _ids?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type SubscriptionAlertSubscriptionEventsByIdsArgs = {
  _ids?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type SubscriptionAlertSubscriptionReplacedByIdsArgs = {
  _ids?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type SubscriptionAlertSubscriptionUpdatedByIdsArgs = {
  _ids?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type SubscriptionAlertSubscriptionsByUserIdCreatedArgs = {
  filter?: InputMaybe<FilteralertSubscriptionsByUserId>;
  limit?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<SortFindManyAlertSubscriptionInput>;
  userId: Scalars['String'];
};

export type SubscriptionAlertSubscriptionsByUserIdDeletedArgs = {
  filter?: InputMaybe<FilteralertSubscriptionsByUserId>;
  limit?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<SortFindManyAlertSubscriptionInput>;
  userId: Scalars['String'];
};

export type SubscriptionAlertSubscriptionsByUserIdEventsArgs = {
  filter?: InputMaybe<FilteralertSubscriptionsByUserId>;
  limit?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<SortFindManyAlertSubscriptionInput>;
  userId: Scalars['String'];
};

export type SubscriptionAlertSubscriptionsByUserIdReplacedArgs = {
  filter?: InputMaybe<FilteralertSubscriptionsByUserId>;
  limit?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<SortFindManyAlertSubscriptionInput>;
  userId: Scalars['String'];
};

export type SubscriptionAlertSubscriptionsByUserIdUpdatedArgs = {
  filter?: InputMaybe<FilteralertSubscriptionsByUserId>;
  limit?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<SortFindManyAlertSubscriptionInput>;
  userId: Scalars['String'];
};

export type SubscriptionAlertTriggerCreatedByIdsArgs = {
  _ids?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type SubscriptionAlertTriggerCreatedByPropertyIdArgs = {
  propertyId?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type SubscriptionAlertTriggerDeletedByIdsArgs = {
  _ids?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type SubscriptionAlertTriggerDeletedByPropertyIdArgs = {
  propertyId?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type SubscriptionAlertTriggerEventsByIdsArgs = {
  _ids?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type SubscriptionAlertTriggerEventsByPropertyIdArgs = {
  propertyId?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type SubscriptionAlertTriggerReplacedByIdsArgs = {
  _ids?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type SubscriptionAlertTriggerReplacedByPropertyIdArgs = {
  propertyId?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type SubscriptionAlertTriggerUpdatedByIdsArgs = {
  _ids?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type SubscriptionAlertTriggerUpdatedByPropertyIdArgs = {
  propertyId?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type SubscriptionAlertUpdatedByIdsArgs = {
  _ids?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type SubscriptionAlertsByPropertyIdCreatedArgs = {
  filter?: InputMaybe<FilteralertsByPropertyId>;
  limit?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<SortFindManyAlertInput>;
};

export type SubscriptionAlertsByPropertyIdDeletedArgs = {
  filter?: InputMaybe<FilteralertsByPropertyId>;
  limit?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<SortFindManyAlertInput>;
};

export type SubscriptionAlertsByPropertyIdEventsArgs = {
  filter?: InputMaybe<FilteralertsByPropertyId>;
  limit?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<SortFindManyAlertInput>;
};

export type SubscriptionAlertsByPropertyIdReplacedArgs = {
  filter?: InputMaybe<FilteralertsByPropertyId>;
  limit?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<SortFindManyAlertInput>;
};

export type SubscriptionAlertsByPropertyIdUpdatedArgs = {
  filter?: InputMaybe<FilteralertsByPropertyId>;
  limit?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<SortFindManyAlertInput>;
};

export type SubscriptionAlertsByUnitIdCreatedArgs = {
  filter?: InputMaybe<FilteralertsByUnitId>;
  limit?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<SortFindManyAlertInput>;
  unitId?: InputMaybe<Scalars['String']>;
};

export type SubscriptionAlertsByUnitIdDeletedArgs = {
  filter?: InputMaybe<FilteralertsByUnitId>;
  limit?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<SortFindManyAlertInput>;
  unitId?: InputMaybe<Scalars['String']>;
};

export type SubscriptionAlertsByUnitIdEventsArgs = {
  filter?: InputMaybe<FilteralertsByUnitId>;
  limit?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<SortFindManyAlertInput>;
  unitId?: InputMaybe<Scalars['String']>;
};

export type SubscriptionAlertsByUnitIdReplacedArgs = {
  filter?: InputMaybe<FilteralertsByUnitId>;
  limit?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<SortFindManyAlertInput>;
  unitId?: InputMaybe<Scalars['String']>;
};

export type SubscriptionAlertsByUnitIdUpdatedArgs = {
  filter?: InputMaybe<FilteralertsByUnitId>;
  limit?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<SortFindManyAlertInput>;
  unitId?: InputMaybe<Scalars['String']>;
};

export type SubscriptionAuthenticationProfileCreatedByIdsArgs = {
  _ids?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type SubscriptionAuthenticationProfileDeletedByIdsArgs = {
  _ids?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type SubscriptionAuthenticationProfileEventsByIdsArgs = {
  _ids?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type SubscriptionAuthenticationProfileReplacedByIdsArgs = {
  _ids?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type SubscriptionAuthenticationProfileUpdatedByIdsArgs = {
  _ids?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type SubscriptionAuthenticatorDeviceCreatedByIdsArgs = {
  _ids?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type SubscriptionAuthenticatorDeviceDeletedByIdsArgs = {
  _ids?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type SubscriptionAuthenticatorDeviceEventsByIdsArgs = {
  _ids?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type SubscriptionAuthenticatorDeviceReplacedByIdsArgs = {
  _ids?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type SubscriptionAuthenticatorDeviceUpdatedByIdsArgs = {
  _ids?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type SubscriptionAuthorizationProfileCreatedByIdsArgs = {
  _ids?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type SubscriptionAuthorizationProfileDeletedByIdsArgs = {
  _ids?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type SubscriptionAuthorizationProfileEventsByIdsArgs = {
  _ids?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type SubscriptionAuthorizationProfileReplacedByIdsArgs = {
  _ids?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type SubscriptionAuthorizationProfileUpdatedByIdsArgs = {
  _ids?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type SubscriptionBNgCreatedByIdsArgs = {
  _ids?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type SubscriptionBNgDeletedByIdsArgs = {
  _ids?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type SubscriptionBNgEventsByIdsArgs = {
  _ids?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type SubscriptionBNgReplacedByIdsArgs = {
  _ids?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type SubscriptionBNgUpdatedByIdsArgs = {
  _ids?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type SubscriptionBatteryManagementSystemCreatedByIdsArgs = {
  _ids?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type SubscriptionBatteryManagementSystemDeletedByIdsArgs = {
  _ids?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type SubscriptionBatteryManagementSystemEventsByIdsArgs = {
  _ids?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type SubscriptionBatteryManagementSystemReplacedByIdsArgs = {
  _ids?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type SubscriptionBatteryManagementSystemUpdatedByIdsArgs = {
  _ids?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type SubscriptionBoilerCreatedByIdsArgs = {
  _ids?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type SubscriptionBoilerDeletedByIdsArgs = {
  _ids?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type SubscriptionBoilerEventsByIdsArgs = {
  _ids?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type SubscriptionBoilerReplacedByIdsArgs = {
  _ids?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type SubscriptionBoilerUpdatedByIdsArgs = {
  _ids?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type SubscriptionBuildingCreatedByIdsArgs = {
  _ids?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type SubscriptionBuildingDeletedByIdsArgs = {
  _ids?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type SubscriptionBuildingEventsByIdsArgs = {
  _ids?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type SubscriptionBuildingReplacedByIdsArgs = {
  _ids?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type SubscriptionBuildingUpdatedByIdsArgs = {
  _ids?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type SubscriptionBuildingsByPropertyIdCreatedArgs = {
  filter?: InputMaybe<FilterbuildingsByPropertyId>;
  limit?: InputMaybe<Scalars['Int']>;
  propertyId: Scalars['String'];
  skip?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<SortFindManyBuildingInput>;
};

export type SubscriptionBuildingsByPropertyIdDeletedArgs = {
  filter?: InputMaybe<FilterbuildingsByPropertyId>;
  limit?: InputMaybe<Scalars['Int']>;
  propertyId: Scalars['String'];
  skip?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<SortFindManyBuildingInput>;
};

export type SubscriptionBuildingsByPropertyIdEventsArgs = {
  filter?: InputMaybe<FilterbuildingsByPropertyId>;
  limit?: InputMaybe<Scalars['Int']>;
  propertyId: Scalars['String'];
  skip?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<SortFindManyBuildingInput>;
};

export type SubscriptionBuildingsByPropertyIdReplacedArgs = {
  filter?: InputMaybe<FilterbuildingsByPropertyId>;
  limit?: InputMaybe<Scalars['Int']>;
  propertyId: Scalars['String'];
  skip?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<SortFindManyBuildingInput>;
};

export type SubscriptionBuildingsByPropertyIdUpdatedArgs = {
  filter?: InputMaybe<FilterbuildingsByPropertyId>;
  limit?: InputMaybe<Scalars['Int']>;
  propertyId: Scalars['String'];
  skip?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<SortFindManyBuildingInput>;
};

export type SubscriptionBulkConfigProgressUpdateArgs = {
  initiatorId: Scalars['String'];
  initiatorType: Scalars['String'];
};

export type SubscriptionChillerCreatedByIdsArgs = {
  _ids?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type SubscriptionChillerDeletedByIdsArgs = {
  _ids?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type SubscriptionChillerEventsByIdsArgs = {
  _ids?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type SubscriptionChillerReplacedByIdsArgs = {
  _ids?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type SubscriptionChillerUpdatedByIdsArgs = {
  _ids?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type SubscriptionConductorCreatedByIdsArgs = {
  _ids?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type SubscriptionConductorDeletedByIdsArgs = {
  _ids?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type SubscriptionConductorDiscoveryStatusUpdatedArgs = {
  runId?: InputMaybe<Scalars['String']>;
  sourceId: Scalars['String'];
};

export type SubscriptionConductorEventsByIdsArgs = {
  _ids?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type SubscriptionConductorGenericSensorCreatedByIdsArgs = {
  _ids?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type SubscriptionConductorGenericSensorDeletedByIdsArgs = {
  _ids?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type SubscriptionConductorGenericSensorEventsByIdsArgs = {
  _ids?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type SubscriptionConductorGenericSensorReplacedByIdsArgs = {
  _ids?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type SubscriptionConductorGenericSensorUpdatedByIdsArgs = {
  _ids?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type SubscriptionConductorReplacedByIdsArgs = {
  _ids?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type SubscriptionConductorUpdatedByIdsArgs = {
  _ids?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type SubscriptionControlGroupCreatedByIdsArgs = {
  _ids?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type SubscriptionControlGroupDeletedByIdsArgs = {
  _ids?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type SubscriptionControlGroupEventsByIdsArgs = {
  _ids?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type SubscriptionControlGroupReplacedByIdsArgs = {
  _ids?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type SubscriptionControlGroupUpdatedByIdsArgs = {
  _ids?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type SubscriptionControllerCreatedByIdsArgs = {
  _ids?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type SubscriptionControllerDeletedByIdsArgs = {
  _ids?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type SubscriptionControllerEventsByIdsArgs = {
  _ids?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type SubscriptionControllerReplacedByIdsArgs = {
  _ids?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type SubscriptionControllerUpdatedByIdsArgs = {
  _ids?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type SubscriptionCoreCreatedByIdsArgs = {
  _ids?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type SubscriptionCoreDeletedByIdsArgs = {
  _ids?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type SubscriptionCoreEventsByIdsArgs = {
  _ids?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type SubscriptionCoreReplacedByIdsArgs = {
  _ids?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type SubscriptionCoreUpdatedByIdsArgs = {
  _ids?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type SubscriptionDataExportJobCreatedByIdsArgs = {
  _ids?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type SubscriptionDataExportJobDeletedByIdsArgs = {
  _ids?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type SubscriptionDataExportJobEventsByIdsArgs = {
  _ids?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type SubscriptionDataExportJobReplacedByIdsArgs = {
  _ids?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type SubscriptionDataExportJobUpdatedByIdsArgs = {
  _ids?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type SubscriptionDeviceCreatedByIdsArgs = {
  _ids?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type SubscriptionDeviceDeletedByIdsArgs = {
  _ids?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type SubscriptionDeviceEventsByIdsArgs = {
  _ids?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type SubscriptionDeviceReadingCreatedByIdsArgs = {
  _ids?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type SubscriptionDeviceReadingDeletedByIdsArgs = {
  _ids?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type SubscriptionDeviceReadingEventsByIdsArgs = {
  _ids?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type SubscriptionDeviceReadingReplacedByIdsArgs = {
  _ids?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type SubscriptionDeviceReadingUpdatedByIdsArgs = {
  _ids?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type SubscriptionDeviceReplacedByIdsArgs = {
  _ids?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type SubscriptionDeviceUpdatedByIdsArgs = {
  _ids?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type SubscriptionDoorSensorCreatedByIdsArgs = {
  _ids?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type SubscriptionDoorSensorDeletedByIdsArgs = {
  _ids?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type SubscriptionDoorSensorEventsByIdsArgs = {
  _ids?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type SubscriptionDoorSensorReplacedByIdsArgs = {
  _ids?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type SubscriptionDoorSensorUpdatedByIdsArgs = {
  _ids?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type SubscriptionEnergyConsumerBuildingCreatedByIdsArgs = {
  _ids?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type SubscriptionEnergyConsumerBuildingDeletedByIdsArgs = {
  _ids?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type SubscriptionEnergyConsumerBuildingEventsByIdsArgs = {
  _ids?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type SubscriptionEnergyConsumerBuildingReplacedByIdsArgs = {
  _ids?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type SubscriptionEnergyConsumerBuildingUpdatedByIdsArgs = {
  _ids?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type SubscriptionEnergyConsumerTenantCreatedByIdsArgs = {
  _ids?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type SubscriptionEnergyConsumerTenantDeletedByIdsArgs = {
  _ids?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type SubscriptionEnergyConsumerTenantEventsByIdsArgs = {
  _ids?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type SubscriptionEnergyConsumerTenantReplacedByIdsArgs = {
  _ids?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type SubscriptionEnergyConsumerTenantUpdatedByIdsArgs = {
  _ids?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type SubscriptionEnergyConsumerUtilityCreatedByIdsArgs = {
  _ids?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type SubscriptionEnergyConsumerUtilityDeletedByIdsArgs = {
  _ids?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type SubscriptionEnergyConsumerUtilityEventsByIdsArgs = {
  _ids?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type SubscriptionEnergyConsumerUtilityReplacedByIdsArgs = {
  _ids?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type SubscriptionEnergyConsumerUtilityUpdatedByIdsArgs = {
  _ids?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type SubscriptionEnergyControllerCreatedByIdsArgs = {
  _ids?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type SubscriptionEnergyControllerDeletedByIdsArgs = {
  _ids?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type SubscriptionEnergyControllerEventsByIdsArgs = {
  _ids?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type SubscriptionEnergyControllerReplacedByIdsArgs = {
  _ids?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type SubscriptionEnergyControllerUpdatedByIdsArgs = {
  _ids?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type SubscriptionEnergyConverterCreatedByIdsArgs = {
  _ids?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type SubscriptionEnergyConverterDeletedByIdsArgs = {
  _ids?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type SubscriptionEnergyConverterEventsByIdsArgs = {
  _ids?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type SubscriptionEnergyConverterReplacedByIdsArgs = {
  _ids?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type SubscriptionEnergyConverterUpdatedByIdsArgs = {
  _ids?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type SubscriptionEnergyInverterCreatedByIdsArgs = {
  _ids?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type SubscriptionEnergyInverterDeletedByIdsArgs = {
  _ids?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type SubscriptionEnergyInverterEventsByIdsArgs = {
  _ids?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type SubscriptionEnergyInverterReplacedByIdsArgs = {
  _ids?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type SubscriptionEnergyInverterUpdatedByIdsArgs = {
  _ids?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type SubscriptionEnergyMeterCreatedByIdsArgs = {
  _ids?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type SubscriptionEnergyMeterDeletedByIdsArgs = {
  _ids?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type SubscriptionEnergyMeterEventsByIdsArgs = {
  _ids?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type SubscriptionEnergyMeterReplacedByIdsArgs = {
  _ids?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type SubscriptionEnergyMeterUpdatedByIdsArgs = {
  _ids?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type SubscriptionEnergyRectifierCreatedByIdsArgs = {
  _ids?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type SubscriptionEnergyRectifierDeletedByIdsArgs = {
  _ids?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type SubscriptionEnergyRectifierEventsByIdsArgs = {
  _ids?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type SubscriptionEnergyRectifierReplacedByIdsArgs = {
  _ids?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type SubscriptionEnergyRectifierUpdatedByIdsArgs = {
  _ids?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type SubscriptionEnergyStorageBatterySystemCreatedByIdsArgs = {
  _ids?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type SubscriptionEnergyStorageBatterySystemDeletedByIdsArgs = {
  _ids?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type SubscriptionEnergyStorageBatterySystemEventsByIdsArgs = {
  _ids?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type SubscriptionEnergyStorageBatterySystemReplacedByIdsArgs = {
  _ids?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type SubscriptionEnergyStorageBatterySystemUpdatedByIdsArgs = {
  _ids?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type SubscriptionEnergyStorageCoolingSystemCreatedByIdsArgs = {
  _ids?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type SubscriptionEnergyStorageCoolingSystemDeletedByIdsArgs = {
  _ids?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type SubscriptionEnergyStorageCoolingSystemEventsByIdsArgs = {
  _ids?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type SubscriptionEnergyStorageCoolingSystemReplacedByIdsArgs = {
  _ids?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type SubscriptionEnergyStorageCoolingSystemUpdatedByIdsArgs = {
  _ids?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type SubscriptionEnergyStorageKineticSystemCreatedByIdsArgs = {
  _ids?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type SubscriptionEnergyStorageKineticSystemDeletedByIdsArgs = {
  _ids?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type SubscriptionEnergyStorageKineticSystemEventsByIdsArgs = {
  _ids?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type SubscriptionEnergyStorageKineticSystemReplacedByIdsArgs = {
  _ids?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type SubscriptionEnergyStorageKineticSystemUpdatedByIdsArgs = {
  _ids?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type SubscriptionEnergySupplierSolarSystemCreatedByIdsArgs = {
  _ids?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type SubscriptionEnergySupplierSolarSystemDeletedByIdsArgs = {
  _ids?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type SubscriptionEnergySupplierSolarSystemEventsByIdsArgs = {
  _ids?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type SubscriptionEnergySupplierSolarSystemReplacedByIdsArgs = {
  _ids?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type SubscriptionEnergySupplierSolarSystemUpdatedByIdsArgs = {
  _ids?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type SubscriptionEnergySupplierUtilityCreatedByIdsArgs = {
  _ids?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type SubscriptionEnergySupplierUtilityDeletedByIdsArgs = {
  _ids?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type SubscriptionEnergySupplierUtilityEventsByIdsArgs = {
  _ids?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type SubscriptionEnergySupplierUtilityReplacedByIdsArgs = {
  _ids?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type SubscriptionEnergySupplierUtilityUpdatedByIdsArgs = {
  _ids?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type SubscriptionEnergySupplierWindSystemCreatedByIdsArgs = {
  _ids?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type SubscriptionEnergySupplierWindSystemDeletedByIdsArgs = {
  _ids?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type SubscriptionEnergySupplierWindSystemEventsByIdsArgs = {
  _ids?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type SubscriptionEnergySupplierWindSystemReplacedByIdsArgs = {
  _ids?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type SubscriptionEnergySupplierWindSystemUpdatedByIdsArgs = {
  _ids?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type SubscriptionEnergySwitchPanelCircuitCreatedByIdsArgs = {
  _ids?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type SubscriptionEnergySwitchPanelCircuitDeletedByIdsArgs = {
  _ids?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type SubscriptionEnergySwitchPanelCircuitEventsByIdsArgs = {
  _ids?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type SubscriptionEnergySwitchPanelCircuitReplacedByIdsArgs = {
  _ids?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type SubscriptionEnergySwitchPanelCircuitUpdatedByIdsArgs = {
  _ids?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type SubscriptionEnergySwitchPanelCreatedByIdsArgs = {
  _ids?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type SubscriptionEnergySwitchPanelDeletedByIdsArgs = {
  _ids?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type SubscriptionEnergySwitchPanelEventsByIdsArgs = {
  _ids?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type SubscriptionEnergySwitchPanelReplacedByIdsArgs = {
  _ids?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type SubscriptionEnergySwitchPanelUpdatedByIdsArgs = {
  _ids?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type SubscriptionFireSuppressionSystemCreatedByIdsArgs = {
  _ids?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type SubscriptionFireSuppressionSystemDeletedByIdsArgs = {
  _ids?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type SubscriptionFireSuppressionSystemEventsByIdsArgs = {
  _ids?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type SubscriptionFireSuppressionSystemReplacedByIdsArgs = {
  _ids?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type SubscriptionFireSuppressionSystemUpdatedByIdsArgs = {
  _ids?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type SubscriptionFloorCreatedByIdsArgs = {
  _ids?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type SubscriptionFloorDeletedByIdsArgs = {
  _ids?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type SubscriptionFloorEventsByIdsArgs = {
  _ids?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type SubscriptionFloorReplacedByIdsArgs = {
  _ids?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type SubscriptionFloorUpdatedByIdsArgs = {
  _ids?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type SubscriptionGPioCreatedByIdsArgs = {
  _ids?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type SubscriptionGPioDeletedByIdsArgs = {
  _ids?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type SubscriptionGPioEventsByIdsArgs = {
  _ids?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type SubscriptionGPioReplacedByIdsArgs = {
  _ids?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type SubscriptionGPioUpdatedByIdsArgs = {
  _ids?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type SubscriptionHMmCreatedByIdsArgs = {
  _ids?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type SubscriptionHMmDeletedByIdsArgs = {
  _ids?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type SubscriptionHMmEventsByIdsArgs = {
  _ids?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type SubscriptionHMmReplacedByIdsArgs = {
  _ids?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type SubscriptionHMmUpdatedByIdsArgs = {
  _ids?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type SubscriptionHistoricAlertCreatedByIdsArgs = {
  _ids?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type SubscriptionHistoricAlertDeletedByIdsArgs = {
  _ids?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type SubscriptionHistoricAlertEventsByIdsArgs = {
  _ids?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type SubscriptionHistoricAlertReplacedByIdsArgs = {
  _ids?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type SubscriptionHistoricAlertUpdatedByIdsArgs = {
  _ids?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type SubscriptionHistoricReadingCreatedByDeviceIdArgs = {
  deviceId?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type SubscriptionHistoricReadingCreatedByIdsArgs = {
  _ids?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type SubscriptionHistoricReadingDeletedByDeviceIdArgs = {
  deviceId?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type SubscriptionHistoricReadingDeletedByIdsArgs = {
  _ids?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type SubscriptionHistoricReadingEventsByDeviceIdArgs = {
  deviceId?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type SubscriptionHistoricReadingEventsByIdsArgs = {
  _ids?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type SubscriptionHistoricReadingReplacedByDeviceIdArgs = {
  deviceId?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type SubscriptionHistoricReadingReplacedByIdsArgs = {
  _ids?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type SubscriptionHistoricReadingUpdatedByDeviceIdArgs = {
  deviceId?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type SubscriptionHistoricReadingUpdatedByIdsArgs = {
  _ids?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type SubscriptionIndoorAirHandlerCreatedByIdsArgs = {
  _ids?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type SubscriptionIndoorAirHandlerDeletedByIdsArgs = {
  _ids?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type SubscriptionIndoorAirHandlerEventsByIdsArgs = {
  _ids?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type SubscriptionIndoorAirHandlerReplacedByIdsArgs = {
  _ids?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type SubscriptionIndoorAirHandlerUpdatedByIdsArgs = {
  _ids?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type SubscriptionIndoorSensorCreatedByIdsArgs = {
  _ids?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type SubscriptionIndoorSensorDeletedByIdsArgs = {
  _ids?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type SubscriptionIndoorSensorEventsByIdsArgs = {
  _ids?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type SubscriptionIndoorSensorReplacedByIdsArgs = {
  _ids?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type SubscriptionIndoorSensorUpdatedByIdsArgs = {
  _ids?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type SubscriptionIngestionCreatedByIdsArgs = {
  _ids?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type SubscriptionIngestionDeletedByIdsArgs = {
  _ids?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type SubscriptionIngestionEventsByIdsArgs = {
  _ids?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type SubscriptionIngestionReplacedByIdsArgs = {
  _ids?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type SubscriptionIngestionUpdatedByIdsArgs = {
  _ids?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type SubscriptionKineticEnergyManagementSystemCreatedByIdsArgs = {
  _ids?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type SubscriptionKineticEnergyManagementSystemDeletedByIdsArgs = {
  _ids?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type SubscriptionKineticEnergyManagementSystemEventsByIdsArgs = {
  _ids?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type SubscriptionKineticEnergyManagementSystemReplacedByIdsArgs = {
  _ids?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type SubscriptionKineticEnergyManagementSystemUpdatedByIdsArgs = {
  _ids?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type SubscriptionLeakDetectorCreatedByIdsArgs = {
  _ids?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type SubscriptionLeakDetectorDeletedByIdsArgs = {
  _ids?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type SubscriptionLeakDetectorEventsByIdsArgs = {
  _ids?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type SubscriptionLeakDetectorReplacedByIdsArgs = {
  _ids?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type SubscriptionLeakDetectorUpdatedByIdsArgs = {
  _ids?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type SubscriptionLoopCreatedByIdsArgs = {
  _ids?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type SubscriptionLoopDeletedByIdsArgs = {
  _ids?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type SubscriptionLoopEventsByIdsArgs = {
  _ids?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type SubscriptionLoopReplacedByIdsArgs = {
  _ids?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type SubscriptionLoopUpdatedByIdsArgs = {
  _ids?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type SubscriptionModbusAirHandlerCreatedByIdsArgs = {
  _ids?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type SubscriptionModbusAirHandlerDeletedByIdsArgs = {
  _ids?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type SubscriptionModbusAirHandlerEventsByIdsArgs = {
  _ids?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type SubscriptionModbusAirHandlerReplacedByIdsArgs = {
  _ids?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type SubscriptionModbusAirHandlerUpdatedByIdsArgs = {
  _ids?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type SubscriptionOauthAccessTokenCreatedByIdsArgs = {
  _ids?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type SubscriptionOauthAccessTokenDeletedByIdsArgs = {
  _ids?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type SubscriptionOauthAccessTokenEventsByIdsArgs = {
  _ids?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type SubscriptionOauthAccessTokenReplacedByIdsArgs = {
  _ids?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type SubscriptionOauthAccessTokenUpdatedByIdsArgs = {
  _ids?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type SubscriptionOauthAuthCodeCreatedByIdsArgs = {
  _ids?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type SubscriptionOauthAuthCodeDeletedByIdsArgs = {
  _ids?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type SubscriptionOauthAuthCodeEventsByIdsArgs = {
  _ids?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type SubscriptionOauthAuthCodeReplacedByIdsArgs = {
  _ids?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type SubscriptionOauthAuthCodeUpdatedByIdsArgs = {
  _ids?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type SubscriptionOauthClientCreatedByIdsArgs = {
  _ids?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type SubscriptionOauthClientDeletedByIdsArgs = {
  _ids?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type SubscriptionOauthClientEventsByIdsArgs = {
  _ids?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type SubscriptionOauthClientReplacedByIdsArgs = {
  _ids?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type SubscriptionOauthClientUpdatedByIdsArgs = {
  _ids?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type SubscriptionOccupancySensorCreatedByIdsArgs = {
  _ids?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type SubscriptionOccupancySensorDeletedByIdsArgs = {
  _ids?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type SubscriptionOccupancySensorEventsByIdsArgs = {
  _ids?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type SubscriptionOccupancySensorReplacedByIdsArgs = {
  _ids?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type SubscriptionOccupancySensorUpdatedByIdsArgs = {
  _ids?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type SubscriptionOpenWeatherCreatedByIdsArgs = {
  _ids?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type SubscriptionOpenWeatherDeletedByIdsArgs = {
  _ids?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type SubscriptionOpenWeatherEventsByIdsArgs = {
  _ids?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type SubscriptionOpenWeatherReplacedByIdsArgs = {
  _ids?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type SubscriptionOpenWeatherUpdatedByIdsArgs = {
  _ids?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type SubscriptionOrganizationCreatedByIdsArgs = {
  _ids?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type SubscriptionOrganizationDeletedByIdsArgs = {
  _ids?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type SubscriptionOrganizationEventsByIdsArgs = {
  _ids?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type SubscriptionOrganizationReplacedByIdsArgs = {
  _ids?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type SubscriptionOrganizationUpdatedByIdsArgs = {
  _ids?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type SubscriptionOutdoorSensorCreatedByIdsArgs = {
  _ids?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type SubscriptionOutdoorSensorDeletedByIdsArgs = {
  _ids?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type SubscriptionOutdoorSensorEventsByIdsArgs = {
  _ids?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type SubscriptionOutdoorSensorReplacedByIdsArgs = {
  _ids?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type SubscriptionOutdoorSensorUpdatedByIdsArgs = {
  _ids?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type SubscriptionPanelCreatedByIdsArgs = {
  _ids?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type SubscriptionPanelDeletedByIdsArgs = {
  _ids?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type SubscriptionPanelEventsByIdsArgs = {
  _ids?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type SubscriptionPanelReplacedByIdsArgs = {
  _ids?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type SubscriptionPanelUpdatedByIdsArgs = {
  _ids?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type SubscriptionPlmContractCreatedByIdsArgs = {
  _ids?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type SubscriptionPlmContractDeletedByIdsArgs = {
  _ids?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type SubscriptionPlmContractEventsByIdsArgs = {
  _ids?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type SubscriptionPlmContractReplacedByIdsArgs = {
  _ids?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type SubscriptionPlmContractUpdatedByIdsArgs = {
  _ids?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type SubscriptionPlmCurtailmentActionCreatedByIdsArgs = {
  _ids?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type SubscriptionPlmCurtailmentActionDeletedByIdsArgs = {
  _ids?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type SubscriptionPlmCurtailmentActionEventsByIdsArgs = {
  _ids?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type SubscriptionPlmCurtailmentActionReplacedByIdsArgs = {
  _ids?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type SubscriptionPlmCurtailmentActionUpdatedByIdsArgs = {
  _ids?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type SubscriptionPlmCurtailmentPlanCreatedByIdsArgs = {
  _ids?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type SubscriptionPlmCurtailmentPlanDeletedByIdsArgs = {
  _ids?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type SubscriptionPlmCurtailmentPlanEventsByIdsArgs = {
  _ids?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type SubscriptionPlmCurtailmentPlanReplacedByIdsArgs = {
  _ids?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type SubscriptionPlmCurtailmentPlanUpdatedByIdsArgs = {
  _ids?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type SubscriptionPlmCurtailmentTaskCreatedByIdsArgs = {
  _ids?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type SubscriptionPlmCurtailmentTaskDeletedByIdsArgs = {
  _ids?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type SubscriptionPlmCurtailmentTaskEventsByIdsArgs = {
  _ids?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type SubscriptionPlmCurtailmentTaskReplacedByIdsArgs = {
  _ids?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type SubscriptionPlmCurtailmentTaskUpdatedByIdsArgs = {
  _ids?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type SubscriptionPlmCurtailmentTasksByActionIdCreatedArgs = {
  filter?: InputMaybe<FilterplmCurtailmentTasksByActionId>;
  limit?: InputMaybe<Scalars['Int']>;
  plmCurtailmentActionId: Scalars['String'];
  skip?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<SortFindManyPlmCurtailmentTaskInput>;
};

export type SubscriptionPlmCurtailmentTasksByActionIdDeletedArgs = {
  filter?: InputMaybe<FilterplmCurtailmentTasksByActionId>;
  limit?: InputMaybe<Scalars['Int']>;
  plmCurtailmentActionId: Scalars['String'];
  skip?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<SortFindManyPlmCurtailmentTaskInput>;
};

export type SubscriptionPlmCurtailmentTasksByActionIdEventsArgs = {
  filter?: InputMaybe<FilterplmCurtailmentTasksByActionId>;
  limit?: InputMaybe<Scalars['Int']>;
  plmCurtailmentActionId: Scalars['String'];
  skip?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<SortFindManyPlmCurtailmentTaskInput>;
};

export type SubscriptionPlmCurtailmentTasksByActionIdReplacedArgs = {
  filter?: InputMaybe<FilterplmCurtailmentTasksByActionId>;
  limit?: InputMaybe<Scalars['Int']>;
  plmCurtailmentActionId: Scalars['String'];
  skip?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<SortFindManyPlmCurtailmentTaskInput>;
};

export type SubscriptionPlmCurtailmentTasksByActionIdUpdatedArgs = {
  filter?: InputMaybe<FilterplmCurtailmentTasksByActionId>;
  limit?: InputMaybe<Scalars['Int']>;
  plmCurtailmentActionId: Scalars['String'];
  skip?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<SortFindManyPlmCurtailmentTaskInput>;
};

export type SubscriptionPlmCurtailmentTasksByPropertyIdCreatedArgs = {
  filter?: InputMaybe<FilterplmCurtailmentTasksByPropertyId>;
  limit?: InputMaybe<Scalars['Int']>;
  propertyId: Scalars['String'];
  skip?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<SortFindManyPlmCurtailmentTaskInput>;
};

export type SubscriptionPlmCurtailmentTasksByPropertyIdDeletedArgs = {
  filter?: InputMaybe<FilterplmCurtailmentTasksByPropertyId>;
  limit?: InputMaybe<Scalars['Int']>;
  propertyId: Scalars['String'];
  skip?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<SortFindManyPlmCurtailmentTaskInput>;
};

export type SubscriptionPlmCurtailmentTasksByPropertyIdEventsArgs = {
  filter?: InputMaybe<FilterplmCurtailmentTasksByPropertyId>;
  limit?: InputMaybe<Scalars['Int']>;
  propertyId: Scalars['String'];
  skip?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<SortFindManyPlmCurtailmentTaskInput>;
};

export type SubscriptionPlmCurtailmentTasksByPropertyIdReplacedArgs = {
  filter?: InputMaybe<FilterplmCurtailmentTasksByPropertyId>;
  limit?: InputMaybe<Scalars['Int']>;
  propertyId: Scalars['String'];
  skip?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<SortFindManyPlmCurtailmentTaskInput>;
};

export type SubscriptionPlmCurtailmentTasksByPropertyIdUpdatedArgs = {
  filter?: InputMaybe<FilterplmCurtailmentTasksByPropertyId>;
  limit?: InputMaybe<Scalars['Int']>;
  propertyId: Scalars['String'];
  skip?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<SortFindManyPlmCurtailmentTaskInput>;
};

export type SubscriptionPlmCurtailmentTasksByResponseIdCreatedArgs = {
  filter?: InputMaybe<FilterplmCurtailmentTasksByResponseId>;
  limit?: InputMaybe<Scalars['Int']>;
  plmEventResponseId: Scalars['String'];
  skip?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<SortFindManyPlmCurtailmentTaskInput>;
};

export type SubscriptionPlmCurtailmentTasksByResponseIdDeletedArgs = {
  filter?: InputMaybe<FilterplmCurtailmentTasksByResponseId>;
  limit?: InputMaybe<Scalars['Int']>;
  plmEventResponseId: Scalars['String'];
  skip?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<SortFindManyPlmCurtailmentTaskInput>;
};

export type SubscriptionPlmCurtailmentTasksByResponseIdEventsArgs = {
  filter?: InputMaybe<FilterplmCurtailmentTasksByResponseId>;
  limit?: InputMaybe<Scalars['Int']>;
  plmEventResponseId: Scalars['String'];
  skip?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<SortFindManyPlmCurtailmentTaskInput>;
};

export type SubscriptionPlmCurtailmentTasksByResponseIdReplacedArgs = {
  filter?: InputMaybe<FilterplmCurtailmentTasksByResponseId>;
  limit?: InputMaybe<Scalars['Int']>;
  plmEventResponseId: Scalars['String'];
  skip?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<SortFindManyPlmCurtailmentTaskInput>;
};

export type SubscriptionPlmCurtailmentTasksByResponseIdUpdatedArgs = {
  filter?: InputMaybe<FilterplmCurtailmentTasksByResponseId>;
  limit?: InputMaybe<Scalars['Int']>;
  plmEventResponseId: Scalars['String'];
  skip?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<SortFindManyPlmCurtailmentTaskInput>;
};

export type SubscriptionPlmEventCreatedByIdsArgs = {
  _ids?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type SubscriptionPlmEventDeletedByIdsArgs = {
  _ids?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type SubscriptionPlmEventEventsByIdsArgs = {
  _ids?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type SubscriptionPlmEventReplacedByIdsArgs = {
  _ids?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type SubscriptionPlmEventResponseCreatedByIdsArgs = {
  _ids?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type SubscriptionPlmEventResponseDeletedByIdsArgs = {
  _ids?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type SubscriptionPlmEventResponseEventsByIdsArgs = {
  _ids?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type SubscriptionPlmEventResponseReplacedByIdsArgs = {
  _ids?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type SubscriptionPlmEventResponseUpdatedByIdsArgs = {
  _ids?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type SubscriptionPlmEventUpdatedByIdsArgs = {
  _ids?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type SubscriptionPlmExternalMeterMappingCreatedByIdsArgs = {
  _ids?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type SubscriptionPlmExternalMeterMappingDeletedByIdsArgs = {
  _ids?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type SubscriptionPlmExternalMeterMappingEventsByIdsArgs = {
  _ids?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type SubscriptionPlmExternalMeterMappingReplacedByIdsArgs = {
  _ids?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type SubscriptionPlmExternalMeterMappingUpdatedByIdsArgs = {
  _ids?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type SubscriptionPlmIngressEventCreatedByIdsArgs = {
  _ids?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type SubscriptionPlmIngressEventDeletedByIdsArgs = {
  _ids?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type SubscriptionPlmIngressEventEventsByIdsArgs = {
  _ids?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type SubscriptionPlmIngressEventReplacedByIdsArgs = {
  _ids?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type SubscriptionPlmIngressEventUpdatedByIdsArgs = {
  _ids?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type SubscriptionPlmNotificationCreatedByIdsArgs = {
  _ids?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type SubscriptionPlmNotificationDeletedByIdsArgs = {
  _ids?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type SubscriptionPlmNotificationEventsByIdsArgs = {
  _ids?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type SubscriptionPlmNotificationReplacedByIdsArgs = {
  _ids?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type SubscriptionPlmNotificationUpdatedByIdsArgs = {
  _ids?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type SubscriptionPlmPartnerCreatedByIdsArgs = {
  _ids?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type SubscriptionPlmPartnerDeletedByIdsArgs = {
  _ids?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type SubscriptionPlmPartnerEventsByIdsArgs = {
  _ids?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type SubscriptionPlmPartnerReplacedByIdsArgs = {
  _ids?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type SubscriptionPlmPartnerUpdatedByIdsArgs = {
  _ids?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type SubscriptionPlmProgramCreatedByIdsArgs = {
  _ids?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type SubscriptionPlmProgramDeletedByIdsArgs = {
  _ids?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type SubscriptionPlmProgramEventsByIdsArgs = {
  _ids?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type SubscriptionPlmProgramReplacedByIdsArgs = {
  _ids?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type SubscriptionPlmProgramUpdatedByIdsArgs = {
  _ids?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type SubscriptionPlmUtilityCreatedByIdsArgs = {
  _ids?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type SubscriptionPlmUtilityDeletedByIdsArgs = {
  _ids?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type SubscriptionPlmUtilityEventsByIdsArgs = {
  _ids?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type SubscriptionPlmUtilityReplacedByIdsArgs = {
  _ids?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type SubscriptionPlmUtilityUpdatedByIdsArgs = {
  _ids?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type SubscriptionPowerMonitorCreatedByIdsArgs = {
  _ids?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type SubscriptionPowerMonitorDeletedByIdsArgs = {
  _ids?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type SubscriptionPowerMonitorEventsByIdsArgs = {
  _ids?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type SubscriptionPowerMonitorReplacedByIdsArgs = {
  _ids?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type SubscriptionPowerMonitorUpdatedByIdsArgs = {
  _ids?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type SubscriptionPressureSensorCreatedByIdsArgs = {
  _ids?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type SubscriptionPressureSensorDeletedByIdsArgs = {
  _ids?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type SubscriptionPressureSensorEventsByIdsArgs = {
  _ids?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type SubscriptionPressureSensorReplacedByIdsArgs = {
  _ids?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type SubscriptionPressureSensorUpdatedByIdsArgs = {
  _ids?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type SubscriptionPropertyCreatedByIdsArgs = {
  _ids?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type SubscriptionPropertyDeletedByIdsArgs = {
  _ids?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type SubscriptionPropertyEventsByIdsArgs = {
  _ids?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type SubscriptionPropertyReplacedByIdsArgs = {
  _ids?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type SubscriptionPropertySummaryAlertsUpdatedArgs = {
  propertyId: Scalars['String'];
};

export type SubscriptionPropertySummaryDevicesUpdatedArgs = {
  propertyId: Scalars['String'];
};

export type SubscriptionPropertySummaryStatsUpdatedArgs = {
  propertyId: Scalars['String'];
};

export type SubscriptionPropertyUpdatedByIdsArgs = {
  _ids?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type SubscriptionRelayDeviceCreatedByIdsArgs = {
  _ids?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type SubscriptionRelayDeviceDeletedByIdsArgs = {
  _ids?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type SubscriptionRelayDeviceEventsByIdsArgs = {
  _ids?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type SubscriptionRelayDeviceReplacedByIdsArgs = {
  _ids?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type SubscriptionRelayDeviceUpdatedByIdsArgs = {
  _ids?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type SubscriptionScheduledSystemNotificationEventsByIdsArgs = {
  _ids: Array<Scalars['String']>;
};

export type SubscriptionScheduledTaskCreatedByIdsArgs = {
  _ids?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type SubscriptionScheduledTaskDeletedByIdsArgs = {
  _ids?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type SubscriptionScheduledTaskEventsByIdsArgs = {
  _ids?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type SubscriptionScheduledTaskReplacedByIdsArgs = {
  _ids?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type SubscriptionScheduledTaskUpdatedByIdsArgs = {
  _ids?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type SubscriptionSetpointProfileCreatedByIdsArgs = {
  _ids?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type SubscriptionSetpointProfileDeletedByIdsArgs = {
  _ids?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type SubscriptionSetpointProfileEventsByIdsArgs = {
  _ids?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type SubscriptionSetpointProfileReplacedByIdsArgs = {
  _ids?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type SubscriptionSetpointProfileUpdatedByIdsArgs = {
  _ids?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type SubscriptionSmartPowerOutletCreatedByIdsArgs = {
  _ids?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type SubscriptionSmartPowerOutletDeletedByIdsArgs = {
  _ids?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type SubscriptionSmartPowerOutletEventsByIdsArgs = {
  _ids?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type SubscriptionSmartPowerOutletReplacedByIdsArgs = {
  _ids?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type SubscriptionSmartPowerOutletUpdatedByIdsArgs = {
  _ids?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type SubscriptionSolarManagementSystemCreatedByIdsArgs = {
  _ids?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type SubscriptionSolarManagementSystemDeletedByIdsArgs = {
  _ids?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type SubscriptionSolarManagementSystemEventsByIdsArgs = {
  _ids?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type SubscriptionSolarManagementSystemReplacedByIdsArgs = {
  _ids?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type SubscriptionSolarManagementSystemUpdatedByIdsArgs = {
  _ids?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type SubscriptionSourceCreatedByIdsArgs = {
  _ids?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type SubscriptionSourceDeletedByIdsArgs = {
  _ids?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type SubscriptionSourceEventsByIdsArgs = {
  _ids?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type SubscriptionSourceReplacedByIdsArgs = {
  _ids?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type SubscriptionSourceUpdatedByIdsArgs = {
  _ids?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type SubscriptionSystemMessagePostedArgs = {
  types?: InputMaybe<Array<InputMaybe<SystemMessageType>>>;
};

export type SubscriptionSystemNotificationCreatedByIdsArgs = {
  _ids?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type SubscriptionSystemNotificationDeletedByIdsArgs = {
  _ids?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type SubscriptionSystemNotificationEventsByIdsArgs = {
  _ids?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type SubscriptionSystemNotificationReplacedByIdsArgs = {
  _ids?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type SubscriptionSystemNotificationUpdatedByIdsArgs = {
  _ids?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type SubscriptionThermistorCreatedByIdsArgs = {
  _ids?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type SubscriptionThermistorDeletedByIdsArgs = {
  _ids?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type SubscriptionThermistorEventsByIdsArgs = {
  _ids?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type SubscriptionThermistorReplacedByIdsArgs = {
  _ids?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type SubscriptionThermistorUpdatedByIdsArgs = {
  _ids?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type SubscriptionThermostatCreatedByIdsArgs = {
  _ids?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type SubscriptionThermostatDeletedByIdsArgs = {
  _ids?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type SubscriptionThermostatEventsByIdsArgs = {
  _ids?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  includeReady?: InputMaybe<Scalars['Boolean']>;
};

export type SubscriptionThermostatReplacedByIdsArgs = {
  _ids?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type SubscriptionThermostatScheduleProfileCreatedByIdsArgs = {
  _ids?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type SubscriptionThermostatScheduleProfileDeletedByIdsArgs = {
  _ids?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type SubscriptionThermostatScheduleProfileEventsByIdsArgs = {
  _ids?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type SubscriptionThermostatScheduleProfileReplacedByIdsArgs = {
  _ids?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type SubscriptionThermostatScheduleProfileUpdatedByIdsArgs = {
  _ids?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type SubscriptionThermostatScheduleTemplateCreatedByIdsArgs = {
  _ids?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type SubscriptionThermostatScheduleTemplateDeletedByIdsArgs = {
  _ids?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type SubscriptionThermostatScheduleTemplateEventsByIdsArgs = {
  _ids?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type SubscriptionThermostatScheduleTemplateReplacedByIdsArgs = {
  _ids?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type SubscriptionThermostatScheduleTemplateUpdatedByIdsArgs = {
  _ids?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type SubscriptionThermostatUpdatedByIdsArgs = {
  _ids?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type SubscriptionUnitCreatedByIdsArgs = {
  _ids?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type SubscriptionUnitCreatedByPropertyIdArgs = {
  propertyId?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type SubscriptionUnitDeletedByIdsArgs = {
  _ids?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type SubscriptionUnitDeletedByPropertyIdArgs = {
  propertyId?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type SubscriptionUnitEventsByIdsArgs = {
  _ids?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type SubscriptionUnitEventsByPropertyIdArgs = {
  propertyId?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type SubscriptionUnitReplacedByIdsArgs = {
  _ids?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type SubscriptionUnitReplacedByPropertyIdArgs = {
  propertyId?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type SubscriptionUnitUpdatedByIdsArgs = {
  _ids?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type SubscriptionUnitUpdatedByPropertyIdArgs = {
  propertyId?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type SubscriptionUserCreatedByIdsArgs = {
  _ids?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type SubscriptionUserDeletedByIdsArgs = {
  _ids?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type SubscriptionUserEventsByIdsArgs = {
  _ids?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type SubscriptionUserHistoryCreatedByIdsArgs = {
  _ids?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type SubscriptionUserHistoryDeletedByIdsArgs = {
  _ids?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type SubscriptionUserHistoryEventsByIdsArgs = {
  _ids?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type SubscriptionUserHistoryReplacedByIdsArgs = {
  _ids?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type SubscriptionUserHistoryUpdatedByIdsArgs = {
  _ids?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type SubscriptionUserReplacedByIdsArgs = {
  _ids?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type SubscriptionUserUpdatedByIdsArgs = {
  _ids?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type SubscriptionVSdPumpCreatedByIdsArgs = {
  _ids?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type SubscriptionVSdPumpDeletedByIdsArgs = {
  _ids?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type SubscriptionVSdPumpEventsByIdsArgs = {
  _ids?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type SubscriptionVSdPumpReplacedByIdsArgs = {
  _ids?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type SubscriptionVSdPumpUpdatedByIdsArgs = {
  _ids?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type SubscriptionVirtualPowerPlantCreatedByIdsArgs = {
  _ids?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type SubscriptionVirtualPowerPlantDeletedByIdsArgs = {
  _ids?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type SubscriptionVirtualPowerPlantEventsByIdsArgs = {
  _ids?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type SubscriptionVirtualPowerPlantReplacedByIdsArgs = {
  _ids?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type SubscriptionVirtualPowerPlantUpdatedByIdsArgs = {
  _ids?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type SubscriptionWindManagementSystemCreatedByIdsArgs = {
  _ids?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type SubscriptionWindManagementSystemDeletedByIdsArgs = {
  _ids?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type SubscriptionWindManagementSystemEventsByIdsArgs = {
  _ids?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type SubscriptionWindManagementSystemReplacedByIdsArgs = {
  _ids?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type SubscriptionWindManagementSystemUpdatedByIdsArgs = {
  _ids?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type SubscriptionWindowSensorCreatedByIdsArgs = {
  _ids?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type SubscriptionWindowSensorDeletedByIdsArgs = {
  _ids?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type SubscriptionWindowSensorEventsByIdsArgs = {
  _ids?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type SubscriptionWindowSensorReplacedByIdsArgs = {
  _ids?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type SubscriptionWindowSensorUpdatedByIdsArgs = {
  _ids?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type SubscriptionZ210PumpCreatedByIdsArgs = {
  _ids?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type SubscriptionZ210PumpDeletedByIdsArgs = {
  _ids?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type SubscriptionZ210PumpEventsByIdsArgs = {
  _ids?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type SubscriptionZ210PumpReplacedByIdsArgs = {
  _ids?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type SubscriptionZ210PumpUpdatedByIdsArgs = {
  _ids?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type SubscriptionZoneCreatedByIdsArgs = {
  _ids?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type SubscriptionZoneDeletedByIdsArgs = {
  _ids?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type SubscriptionZoneEventsByIdsArgs = {
  _ids?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type SubscriptionZonePolicyCreatedByIdsArgs = {
  _ids?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type SubscriptionZonePolicyDeletedByIdsArgs = {
  _ids?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type SubscriptionZonePolicyEventsByIdsArgs = {
  _ids?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type SubscriptionZonePolicyReplacedByIdsArgs = {
  _ids?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type SubscriptionZonePolicyUpdatedByIdsArgs = {
  _ids?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type SubscriptionZoneReplacedByIdsArgs = {
  _ids?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type SubscriptionZoneUpdatedByIdsArgs = {
  _ids?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type SystemCommand = {
  __typename?: 'SystemCommand';
  /** The directive to execute */
  directive?: Maybe<SystemDirective>;
  /** The message associated with the command */
  message: Scalars['String'];
  /** Whether the command has been processed */
  processed?: Maybe<Scalars['Boolean']>;
  /** The timestamp when the command was issued */
  timestamp: Scalars['Float'];
};

export type SystemConnectivityStatus = {
  __typename?: 'SystemConnectivityStatus';
  message?: Maybe<Scalars['String']>;
};

export enum SystemDirective {
  ForcedLogout = 'FORCED_LOGOUT',
  SubscriptionReset = 'SUBSCRIPTION_RESET',
}

export type SystemMessage = {
  __typename?: 'SystemMessage';
  message?: Maybe<Scalars['String']>;
  processed?: Maybe<Scalars['Boolean']>;
  timestamp: Scalars['Float'];
  type?: Maybe<SystemMessageType>;
};

export enum SystemMessageType {
  Error = 'ERROR',
  Info = 'INFO',
  Warning = 'WARNING',
}

export type SystemNotification = {
  __typename: 'SystemNotification';
  _id: Scalars['String'];
  acknowledgedAt?: Maybe<Scalars['Float']>;
  createdAt: Scalars['Float'];
  displayDuration?: Maybe<Scalars['Float']>;
  displayEnd: Scalars['Float'];
  displayStart: Scalars['Float'];
  entityId: Scalars['String'];
  entityType: Scalars['String'];
  link?: Maybe<Scalars['String']>;
  message: Scalars['String'];
  modelChangeOperation?: Maybe<Scalars['String']>;
  modelType?: Maybe<Scalars['String']>;
  relatedEntityName?: Maybe<Scalars['String']>;
  requireAcknowledgement: Scalars['Boolean'];
  seenAt?: Maybe<Scalars['Float']>;
  seenBy?: Maybe<Array<Maybe<SystemNotificationSeenBy>>>;
  updateDescription?: Maybe<Scalars['JSON']>;
};

/** List of items with pagination. */
export type SystemNotificationPaginatedSystemNotifications = {
  __typename?: 'SystemNotificationPaginatedSystemNotifications';
  /** Total object count. */
  count?: Maybe<Scalars['Int']>;
  /** Array of objects. */
  items?: Maybe<Array<SystemNotification>>;
  /** Information to aid in pagination. */
  pageInfo: PaginationInfo;
};

export type SystemNotificationSeenBy = {
  __typename: 'SystemNotificationSeenBy';
  _id?: Maybe<Scalars['MongoID']>;
  seenAt: Scalars['Float'];
  userId: Scalars['String'];
};

export type TargetedAdjustmentsInput = {
  coolSetpoint?: InputMaybe<Scalars['Float']>;
  coolSetpointAdjustmentMode?: InputMaybe<Scalars['String']>;
  fanMode?: InputMaybe<Scalars['String']>;
  fanSpeed?: InputMaybe<Scalars['String']>;
  freshAirSetpoint?: InputMaybe<Scalars['Float']>;
  heatSetpoint?: InputMaybe<Scalars['Float']>;
  heatSetpointAdjustmentMode?: InputMaybe<Scalars['String']>;
  isOn?: InputMaybe<Scalars['Boolean']>;
  keypadLockoutLevel?: InputMaybe<Scalars['String']>;
  maxCoolSetpointLimit?: InputMaybe<Scalars['Float']>;
  maxHeatSetpointLimit?: InputMaybe<Scalars['Float']>;
  minCoolSetpointLimit?: InputMaybe<Scalars['Float']>;
  minHeatSetpointLimit?: InputMaybe<Scalars['Float']>;
  operatingMode?: InputMaybe<Scalars['String']>;
  rhSetpoint?: InputMaybe<Scalars['Float']>;
  type: Scalars['String'];
  ventilationMode?: InputMaybe<Scalars['String']>;
};

export enum TemperatureUnit {
  C = 'C',
  F = 'F',
}

export type Thermistor = DeviceInterface & {
  __typename: 'Thermistor';
  _id: Scalars['String'];
  alertTypes?: Maybe<DeviceAlertTypes>;
  chartTypes: Array<ChartType>;
  controlled?: Maybe<DeviceControlled>;
  dependentDeviceIds: Array<Maybe<Scalars['String']>>;
  deviceAlerts: Array<Maybe<Alert>>;
  deviceId?: Maybe<Scalars['String']>;
  deviceIdentifier?: Maybe<Scalars['String']>;
  deviceMetrics?: Maybe<Array<Maybe<DeviceMetric>>>;
  displayName?: Maybe<Scalars['String']>;
  hasPendingUpdates: Scalars['Boolean'];
  hasTemperature?: Maybe<Scalars['Boolean']>;
  installation?: Maybe<DeviceInstallation>;
  isConfigured?: Maybe<Scalars['Boolean']>;
  isControlled: Scalars['Boolean'];
  isPoweredOn?: Maybe<Scalars['Boolean']>;
  location?: Maybe<Scalars['String']>;
  meta?: Maybe<DeviceMeta>;
  modelChangeOperation?: Maybe<Scalars['String']>;
  modelType?: Maybe<Scalars['String']>;
  /** The name of the device */
  name?: Maybe<Scalars['String']>;
  panel?: Maybe<Panel>;
  panelId?: Maybe<Scalars['String']>;
  powerState?: Maybe<DevicePowerState>;
  property?: Maybe<Property>;
  propertyId: Scalars['String'];
  role?: Maybe<Scalars['String']>;
  source?: Maybe<Source>;
  sourceAlerts: Array<Maybe<Alert>>;
  sourceId?: Maybe<Scalars['String']>;
  temperature?: Maybe<ThermistorTemperature>;
  timestamp?: Maybe<Scalars['Float']>;
  type?: Maybe<EnumDKeyDeviceType>;
  typeDisplayName: Scalars['String'];
  unit?: Maybe<Unit>;
  unitId: Scalars['String'];
  updateDescription?: Maybe<Scalars['JSON']>;
  updateStatus?: Maybe<Scalars['Boolean']>;
  vpp?: Maybe<VirtualPowerPlant>;
  vppId?: Maybe<Scalars['String']>;
  zone?: Maybe<Zone>;
  zoneId?: Maybe<Scalars['String']>;
};

export type ThermistorDeviceAlertsArgs = {
  filter?: InputMaybe<FilterFindManyAlertInput>;
  limit?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<SortFindManyAlertInput>;
};

export type ThermistorSourceAlertsArgs = {
  filter?: InputMaybe<FilterFindManyAlertInput>;
  limit?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<SortFindManyAlertInput>;
};

export type ThermistorTemperature = {
  __typename?: 'ThermistorTemperature';
  id?: Maybe<Scalars['String']>;
  observedAt?: Maybe<Scalars['Float']>;
  previousId?: Maybe<Scalars['String']>;
  timestamp?: Maybe<Scalars['Float']>;
  units?: Maybe<Scalars['String']>;
  updatePending?: Maybe<Scalars['Boolean']>;
  value?: Maybe<Scalars['Float']>;
};

export type Thermostat = DeviceInterface & {
  __typename: 'Thermostat';
  _id: Scalars['String'];
  airDirection?: Maybe<ThermostatAirDirection>;
  alertTypes?: Maybe<DeviceAlertTypes>;
  chartTypes: Array<ChartType>;
  controlled?: Maybe<DeviceControlled>;
  coolSetpoint?: Maybe<ThermostatCoolSetpoint>;
  correctSetpointLimits?: Maybe<SetpointLimits>;
  correctSetpointLimitsAsync: SetpointLimits;
  currentSetpointLimits?: Maybe<SetpointLimits>;
  dependentDeviceIds: Array<Maybe<Scalars['String']>>;
  deviceAlerts: Array<Maybe<Alert>>;
  deviceId?: Maybe<Scalars['String']>;
  deviceIdentifier?: Maybe<Scalars['String']>;
  deviceMetrics?: Maybe<Array<Maybe<DeviceMetric>>>;
  deviceSpec?: Maybe<ThermostatDeviceSpec>;
  fanIconClass?: Maybe<Array<Maybe<Scalars['String']>>>;
  fanIconHelpText?: Maybe<Scalars['String']>;
  fanMode?: Maybe<ThermostatFanMode>;
  fanModeInfo?: Maybe<Scalars['String']>;
  fanSpeed?: Maybe<ThermostatFanSpeed>;
  fanState?: Maybe<ThermostatFanState>;
  getFanState?: Maybe<Scalars['String']>;
  getHoldEnd?: Maybe<Scalars['Float']>;
  getSetpointChangeSource?: Maybe<Scalars['String']>;
  hasCorrectSetpointLimits: Scalars['Boolean'];
  hasCorrectSetpointLimitsAsync?: Maybe<Scalars['Boolean']>;
  hasPendingUpdates: Scalars['Boolean'];
  hasSchedule?: Maybe<Scalars['Boolean']>;
  heatSetpoint?: Maybe<ThermostatHeatSetpoint>;
  holdDuration?: Maybe<ThermostatHoldDuration>;
  holdEnd?: Maybe<ThermostatHoldEnd>;
  holdExpiryTime?: Maybe<ThermostatHoldExpiryTime>;
  holdState?: Maybe<ThermostatHoldState>;
  humidity?: Maybe<ThermostatHumidity>;
  hvacIconClass?: Maybe<Array<Maybe<Scalars['String']>>>;
  hvacIconHelpText?: Maybe<Scalars['String']>;
  installation?: Maybe<DeviceInstallation>;
  isConfigured?: Maybe<Scalars['Boolean']>;
  isControlled: Scalars['Boolean'];
  isFollowingSchedule?: Maybe<Scalars['Boolean']>;
  isHoldForever?: Maybe<Scalars['Boolean']>;
  isMitsubishiThermostat: Scalars['Boolean'];
  isMultiSpeedThermostat?: Maybe<Scalars['Boolean']>;
  isOffSchedule?: Maybe<Scalars['Boolean']>;
  isPairingActive: Scalars['Boolean'];
  isPoweredOn?: Maybe<Scalars['Boolean']>;
  isScheduleEnabled?: Maybe<Scalars['Boolean']>;
  keypadLockoutIconClass?: Maybe<Array<Maybe<Scalars['String']>>>;
  keypadLockoutIconHelpText?: Maybe<Scalars['String']>;
  keypadLockoutLevel?: Maybe<ThermostatKeypadLockoutLevel>;
  keypadLockoutLevelName: ThermostatKeypadLockoutLevelNameType;
  keypadLockoutLevels: Array<Scalars['String']>;
  lastScheduleChange?: Maybe<ThermostatLastScheduleChange>;
  lastSetpointChange?: Maybe<ThermostatLastSetpointChange>;
  lastSetpointChangeValid?: Maybe<Scalars['Boolean']>;
  localControlPermissions?: Maybe<ThermostatLocalControlPermissions>;
  localControlPermissionsV1?: Maybe<ThermostatLocalControlPermissionsV1>;
  location?: Maybe<Scalars['String']>;
  louvreControlV1?: Maybe<ThermostatLouvreControlV1>;
  maxCoolSetpointLimit?: Maybe<ThermostatMaxCoolSetpointLimit>;
  maxHeatSetpointLimit?: Maybe<ThermostatMaxHeatSetpointLimit>;
  maxSetpoint?: Maybe<ThermostatMaxSetpoint>;
  meta?: Maybe<DeviceMeta>;
  minCoolSetpointLimit?: Maybe<ThermostatMinCoolSetpointLimit>;
  minHeatSetpointLimit?: Maybe<ThermostatMinHeatSetpointLimit>;
  minSetpoint?: Maybe<ThermostatMinSetpoint>;
  modbusRTU: Scalars['Boolean'];
  modelChangeOperation?: Maybe<Scalars['String']>;
  modelType?: Maybe<Scalars['String']>;
  /** The name of the device */
  name?: Maybe<Scalars['String']>;
  operatingMode?: Maybe<ThermostatOperatingMode>;
  operatingState?: Maybe<ThermostatOperatingState>;
  pairingState?: Maybe<ThermostatPairingState>;
  panel?: Maybe<Panel>;
  panelId?: Maybe<Scalars['String']>;
  passCode?: Maybe<ThermostatPassCode>;
  pendingSchedule?: Maybe<ThermostatPendingSchedule>;
  powerMode?: Maybe<ThermostatPowerMode>;
  powerState?: Maybe<DevicePowerState>;
  profileIconClass?: Maybe<Array<Maybe<Scalars['String']>>>;
  profileIconHelpText?: Maybe<Scalars['String']>;
  progMode?: Maybe<ThermostatProgMode>;
  property?: Maybe<Property>;
  propertyId: Scalars['String'];
  remoteSensorTempDelta?: Maybe<ThermostatRemoteSensorTempDelta>;
  remoteSensorTempDeltaValue?: Maybe<Scalars['Float']>;
  schedVisibilityMode?: Maybe<ThermostatSchedVisibilityMode>;
  schedule?: Maybe<ThermostatSchedule>;
  scheduleIconClass?: Maybe<Array<Maybe<Scalars['String']>>>;
  scheduleIconHelpText?: Maybe<Scalars['String']>;
  scheduleStatus?: Maybe<Scalars['String']>;
  scheduleType?: Maybe<EnumScheduleType>;
  separatePowerControlV1?: Maybe<ThermostatSeparatePowerControlV1>;
  setpoint?: Maybe<ThermostatSetpoint>;
  setpointChangeSource?: Maybe<ThermostatSetpointChangeSource>;
  setpointProfile?: Maybe<SetpointProfile>;
  setpointProfileAsync?: Maybe<SetpointProfile>;
  showFanButton?: Maybe<ThermostatShowFanButton>;
  source?: Maybe<Source>;
  sourceAlerts: Array<Maybe<Alert>>;
  sourceId?: Maybe<Scalars['String']>;
  supportsAlternateHeatSystemType?: Maybe<Scalars['Boolean']>;
  supportsAutoMode: Scalars['Boolean'];
  supportsDualSetpointAutoMode: Scalars['Boolean'];
  supportsFanOperations?: Maybe<Scalars['Boolean']>;
  supportsFanStateMonitoring?: Maybe<Scalars['Boolean']>;
  supportsHoldExpiryTime?: Maybe<Scalars['Boolean']>;
  supportsHumidityMonitoring?: Maybe<Scalars['Boolean']>;
  supportsLastSetpointChange?: Maybe<Scalars['Boolean']>;
  supportsObservationFreshness?: Maybe<Scalars['Boolean']>;
  supportsPairingState: Scalars['Boolean'];
  supportsPasscode?: Maybe<Scalars['Boolean']>;
  supportsRemoteSensorTempDelta?: Maybe<Scalars['Boolean']>;
  supportsScheduling?: Maybe<Scalars['Boolean']>;
  supportsShowFanButton?: Maybe<Scalars['Boolean']>;
  supportsSingleSetpointAutoMode: Scalars['Boolean'];
  supportsSystemType?: Maybe<Scalars['Boolean']>;
  systemType?: Maybe<ThermostatSystemType>;
  tempDisplayMode?: Maybe<ThermostatTempDisplayMode>;
  temperature?: Maybe<ThermostatTemperature>;
  thermostatScheduleTemplate?: Maybe<ThermostatScheduleTemplate>;
  thermostatScheduleTemplateId?: Maybe<Scalars['String']>;
  timestamp?: Maybe<Scalars['Float']>;
  type?: Maybe<EnumDKeyDeviceType>;
  typeDisplayName: Scalars['String'];
  uiOptions?: Maybe<ThermostatUiOptions>;
  unit?: Maybe<Unit>;
  unitId: Scalars['String'];
  updateDescription?: Maybe<Scalars['JSON']>;
  updateStatus?: Maybe<Scalars['Boolean']>;
  useCustomSchedule?: Maybe<Scalars['Boolean']>;
  useCustomSetpointLimits?: Maybe<Scalars['Boolean']>;
  vpp?: Maybe<VirtualPowerPlant>;
  vppId?: Maybe<Scalars['String']>;
  zone?: Maybe<Zone>;
  zoneId?: Maybe<Scalars['String']>;
};

export type ThermostatDeviceAlertsArgs = {
  filter?: InputMaybe<FilterFindManyAlertInput>;
  limit?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<SortFindManyAlertInput>;
};

export type ThermostatSourceAlertsArgs = {
  filter?: InputMaybe<FilterFindManyAlertInput>;
  limit?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<SortFindManyAlertInput>;
};

export type ThermostatAdjustment = AdjustmentInterface & {
  __typename?: 'ThermostatAdjustment';
  coolSetpoint?: Maybe<Scalars['Float']>;
  coolSetpointAdjustmentMode?: Maybe<Scalars['String']>;
  fanMode?: Maybe<Scalars['String']>;
  fanSpeed?: Maybe<Scalars['String']>;
  heatSetpoint?: Maybe<Scalars['Float']>;
  heatSetpointAdjustmentMode?: Maybe<Scalars['String']>;
  keypadLockoutLevel?: Maybe<Scalars['String']>;
  maxCoolSetpointLimit?: Maybe<Scalars['Float']>;
  maxHeatSetpointLimit?: Maybe<Scalars['Float']>;
  minCoolSetpointLimit?: Maybe<Scalars['Float']>;
  minHeatSetpointLimit?: Maybe<Scalars['Float']>;
  operatingMode?: Maybe<Scalars['String']>;
  type: Scalars['String'];
};

export type ThermostatAirDirection = {
  __typename?: 'ThermostatAirDirection';
  id?: Maybe<Scalars['String']>;
  observedAt?: Maybe<Scalars['Float']>;
  previousId?: Maybe<Scalars['String']>;
  timestamp?: Maybe<Scalars['Float']>;
  units?: Maybe<Scalars['String']>;
  updatePending?: Maybe<Scalars['Boolean']>;
  value?: Maybe<Scalars['String']>;
};

export type ThermostatCoolSetpoint = {
  __typename?: 'ThermostatCoolSetpoint';
  id?: Maybe<Scalars['String']>;
  observedAt?: Maybe<Scalars['Float']>;
  previousId?: Maybe<Scalars['String']>;
  timestamp?: Maybe<Scalars['Float']>;
  units?: Maybe<Scalars['String']>;
  updatePending?: Maybe<Scalars['Boolean']>;
  value?: Maybe<Scalars['Float']>;
};

export type ThermostatDeviceSpec = {
  __typename?: 'ThermostatDeviceSpec';
  thermostat?: Maybe<ThermostatDeviceSpecThermostat>;
  version?: Maybe<Scalars['String']>;
};

export type ThermostatDeviceSpecThermostat = {
  __typename?: 'ThermostatDeviceSpecThermostat';
  controlContract?: Maybe<EnumThermostatDeviceSpecThermostatControlContract>;
  keypadLockoutLevels?: Maybe<Array<Maybe<Scalars['String']>>>;
  modbusRTU?: Maybe<Scalars['Boolean']>;
  numberOfDailyTransitions?: Maybe<Scalars['Float']>;
  numberOfWeeklyTransitions?: Maybe<Scalars['Float']>;
  secondaryHeatSource?: Maybe<ThermostatDeviceSpecThermostatSecondaryHeatSource>;
  setpointLimits?: Maybe<ThermostatDeviceSpecThermostatSetpointLimits>;
  supportedAutoModeType?: Maybe<EnumThermostatDeviceSpecThermostatSupportedAutoModeType>;
  units?: Maybe<Scalars['String']>;
};

export type ThermostatDeviceSpecThermostatSecondaryHeatSource = {
  __typename?: 'ThermostatDeviceSpecThermostatSecondaryHeatSource';
  alternateHeat?: Maybe<Scalars['Boolean']>;
  auxiliaryHeat?: Maybe<Scalars['Boolean']>;
};

export type ThermostatDeviceSpecThermostatSetpointLimits = {
  __typename?: 'ThermostatDeviceSpecThermostatSetpointLimits';
  cool?: Maybe<ThermostatDeviceSpecThermostatSetpointLimitsCool>;
  heat?: Maybe<ThermostatDeviceSpecThermostatSetpointLimitsCool>;
};

export type ThermostatDeviceSpecThermostatSetpointLimitsCool = {
  __typename?: 'ThermostatDeviceSpecThermostatSetpointLimitsCool';
  max?: Maybe<Scalars['Float']>;
  min?: Maybe<Scalars['Float']>;
};

export type ThermostatFanMode = {
  __typename?: 'ThermostatFanMode';
  id?: Maybe<Scalars['String']>;
  observedAt?: Maybe<Scalars['Float']>;
  previousId?: Maybe<Scalars['String']>;
  timestamp?: Maybe<Scalars['Float']>;
  units?: Maybe<Scalars['String']>;
  updatePending?: Maybe<Scalars['Boolean']>;
  value?: Maybe<EnumThermostatFanModeValue>;
};

export type ThermostatFanSpeed = {
  __typename?: 'ThermostatFanSpeed';
  id?: Maybe<Scalars['String']>;
  observedAt?: Maybe<Scalars['Float']>;
  previousId?: Maybe<Scalars['String']>;
  timestamp?: Maybe<Scalars['Float']>;
  units?: Maybe<Scalars['String']>;
  updatePending?: Maybe<Scalars['Boolean']>;
  value?: Maybe<EnumThermostatFanSpeedValue>;
};

export type ThermostatFanState = {
  __typename?: 'ThermostatFanState';
  id?: Maybe<Scalars['String']>;
  observedAt?: Maybe<Scalars['Float']>;
  previousId?: Maybe<Scalars['String']>;
  timestamp?: Maybe<Scalars['Float']>;
  units?: Maybe<Scalars['String']>;
  updatePending?: Maybe<Scalars['Boolean']>;
  value?: Maybe<EnumThermostatFanStateValue>;
};

export type ThermostatHeatSetpoint = {
  __typename?: 'ThermostatHeatSetpoint';
  id?: Maybe<Scalars['String']>;
  observedAt?: Maybe<Scalars['Float']>;
  previousId?: Maybe<Scalars['String']>;
  timestamp?: Maybe<Scalars['Float']>;
  units?: Maybe<Scalars['String']>;
  updatePending?: Maybe<Scalars['Boolean']>;
  value?: Maybe<Scalars['Float']>;
};

export type ThermostatHoldDuration = {
  __typename?: 'ThermostatHoldDuration';
  id?: Maybe<Scalars['String']>;
  observedAt?: Maybe<Scalars['Float']>;
  previousId?: Maybe<Scalars['String']>;
  timestamp?: Maybe<Scalars['Float']>;
  units?: Maybe<Scalars['String']>;
  updatePending?: Maybe<Scalars['Boolean']>;
  value?: Maybe<Scalars['Float']>;
};

export type ThermostatHoldEnd = {
  __typename?: 'ThermostatHoldEnd';
  id?: Maybe<Scalars['String']>;
  observedAt?: Maybe<Scalars['Float']>;
  previousId?: Maybe<Scalars['String']>;
  timestamp?: Maybe<Scalars['Float']>;
  units?: Maybe<Scalars['String']>;
  updatePending?: Maybe<Scalars['Boolean']>;
  value?: Maybe<Scalars['Float']>;
};

export type ThermostatHoldExpiryTime = {
  __typename?: 'ThermostatHoldExpiryTime';
  id?: Maybe<Scalars['String']>;
  observedAt?: Maybe<Scalars['Float']>;
  previousId?: Maybe<Scalars['String']>;
  timestamp?: Maybe<Scalars['Float']>;
  units?: Maybe<Scalars['String']>;
  updatePending?: Maybe<Scalars['Boolean']>;
  value?: Maybe<Scalars['Float']>;
};

export type ThermostatHoldState = {
  __typename?: 'ThermostatHoldState';
  id?: Maybe<Scalars['String']>;
  observedAt?: Maybe<Scalars['Float']>;
  previousId?: Maybe<Scalars['String']>;
  timestamp?: Maybe<Scalars['Float']>;
  units?: Maybe<Scalars['String']>;
  updatePending?: Maybe<Scalars['Boolean']>;
  value?: Maybe<EnumThermostatHoldStateValue>;
};

export type ThermostatHumidity = {
  __typename?: 'ThermostatHumidity';
  id?: Maybe<Scalars['String']>;
  observedAt?: Maybe<Scalars['Float']>;
  previousId?: Maybe<Scalars['String']>;
  timestamp?: Maybe<Scalars['Float']>;
  units?: Maybe<Scalars['String']>;
  updatePending?: Maybe<Scalars['Boolean']>;
  value?: Maybe<Scalars['Float']>;
};

export type ThermostatKeypadLockoutLevel = {
  __typename?: 'ThermostatKeypadLockoutLevel';
  id?: Maybe<Scalars['String']>;
  observedAt?: Maybe<Scalars['Float']>;
  previousId?: Maybe<Scalars['String']>;
  timestamp?: Maybe<Scalars['Float']>;
  units?: Maybe<Scalars['String']>;
  updatePending?: Maybe<Scalars['Boolean']>;
  value?: Maybe<Scalars['String']>;
};

export enum ThermostatKeypadLockoutLevelNameType {
  Locked = 'LOCKED',
  ModeSetpoint = 'MODE_SETPOINT',
  NoRestrictions = 'NO_RESTRICTIONS',
  SetpointOnly = 'SETPOINT_ONLY',
}

export type ThermostatLastScheduleChange = {
  __typename?: 'ThermostatLastScheduleChange';
  id?: Maybe<Scalars['String']>;
  observedAt?: Maybe<Scalars['Float']>;
  previousId?: Maybe<Scalars['String']>;
  timestamp?: Maybe<Scalars['Float']>;
  units?: Maybe<Scalars['String']>;
  updatePending?: Maybe<Scalars['Boolean']>;
  value?: Maybe<Scalars['Float']>;
};

export type ThermostatLastSetpointChange = {
  __typename?: 'ThermostatLastSetpointChange';
  id?: Maybe<Scalars['String']>;
  observedAt?: Maybe<Scalars['Float']>;
  previousId?: Maybe<Scalars['String']>;
  timestamp?: Maybe<Scalars['Float']>;
  units?: Maybe<Scalars['String']>;
  updatePending?: Maybe<Scalars['Boolean']>;
  value?: Maybe<Scalars['Float']>;
};

export type ThermostatLocalControlPermissions = {
  __typename?: 'ThermostatLocalControlPermissions';
  id?: Maybe<Scalars['String']>;
  observedAt?: Maybe<Scalars['Float']>;
  previousId?: Maybe<Scalars['String']>;
  timestamp?: Maybe<Scalars['Float']>;
  units?: Maybe<Scalars['String']>;
  updatePending?: Maybe<Scalars['Boolean']>;
  value?: Maybe<Scalars['JSON']>;
};

export type ThermostatLocalControlPermissionsV1 = {
  __typename?: 'ThermostatLocalControlPermissionsV1';
  canEdit: Scalars['Boolean'];
  observedAt?: Maybe<Scalars['Float']>;
  pending: Scalars['Boolean'];
  value: ThermostatLocalPermissionsValueV1;
};

export type ThermostatLocalPermissionsValueV1 = {
  __typename?: 'ThermostatLocalPermissionsValueV1';
  fanSpeed: Scalars['String'];
  filterReset: Scalars['String'];
  louvre: Scalars['String'];
  operatingMode: Scalars['String'];
  power: Scalars['String'];
  temperature: Scalars['String'];
  timer: Scalars['String'];
};

export type ThermostatLouvreControlV1 = {
  __typename?: 'ThermostatLouvreControlV1';
  airDirection: ThermostatSeparateAirDirectionMetricV1;
  allowedAirDirections: Array<Scalars['String']>;
  canEditAirDirection: Scalars['Boolean'];
  supportsAirDirection: Scalars['Boolean'];
};

export type ThermostatMaxCoolSetpointLimit = {
  __typename?: 'ThermostatMaxCoolSetpointLimit';
  id?: Maybe<Scalars['String']>;
  observedAt?: Maybe<Scalars['Float']>;
  previousId?: Maybe<Scalars['String']>;
  timestamp?: Maybe<Scalars['Float']>;
  units?: Maybe<Scalars['String']>;
  updatePending?: Maybe<Scalars['Boolean']>;
  value?: Maybe<Scalars['Float']>;
};

export type ThermostatMaxHeatSetpointLimit = {
  __typename?: 'ThermostatMaxHeatSetpointLimit';
  id?: Maybe<Scalars['String']>;
  observedAt?: Maybe<Scalars['Float']>;
  previousId?: Maybe<Scalars['String']>;
  timestamp?: Maybe<Scalars['Float']>;
  units?: Maybe<Scalars['String']>;
  updatePending?: Maybe<Scalars['Boolean']>;
  value?: Maybe<Scalars['Float']>;
};

export type ThermostatMaxSetpoint = {
  __typename?: 'ThermostatMaxSetpoint';
  id?: Maybe<Scalars['String']>;
  observedAt?: Maybe<Scalars['Float']>;
  previousId?: Maybe<Scalars['String']>;
  timestamp?: Maybe<Scalars['Float']>;
  units?: Maybe<Scalars['String']>;
  updatePending?: Maybe<Scalars['Boolean']>;
  value?: Maybe<Scalars['Float']>;
};

export type ThermostatMinCoolSetpointLimit = {
  __typename?: 'ThermostatMinCoolSetpointLimit';
  id?: Maybe<Scalars['String']>;
  observedAt?: Maybe<Scalars['Float']>;
  previousId?: Maybe<Scalars['String']>;
  timestamp?: Maybe<Scalars['Float']>;
  units?: Maybe<Scalars['String']>;
  updatePending?: Maybe<Scalars['Boolean']>;
  value?: Maybe<Scalars['Float']>;
};

export type ThermostatMinHeatSetpointLimit = {
  __typename?: 'ThermostatMinHeatSetpointLimit';
  id?: Maybe<Scalars['String']>;
  observedAt?: Maybe<Scalars['Float']>;
  previousId?: Maybe<Scalars['String']>;
  timestamp?: Maybe<Scalars['Float']>;
  units?: Maybe<Scalars['String']>;
  updatePending?: Maybe<Scalars['Boolean']>;
  value?: Maybe<Scalars['Float']>;
};

export type ThermostatMinSetpoint = {
  __typename?: 'ThermostatMinSetpoint';
  id?: Maybe<Scalars['String']>;
  observedAt?: Maybe<Scalars['Float']>;
  previousId?: Maybe<Scalars['String']>;
  timestamp?: Maybe<Scalars['Float']>;
  units?: Maybe<Scalars['String']>;
  updatePending?: Maybe<Scalars['Boolean']>;
  value?: Maybe<Scalars['Float']>;
};

export type ThermostatOperatingMode = {
  __typename?: 'ThermostatOperatingMode';
  id?: Maybe<Scalars['String']>;
  observedAt?: Maybe<Scalars['Float']>;
  previousId?: Maybe<Scalars['String']>;
  timestamp?: Maybe<Scalars['Float']>;
  units?: Maybe<Scalars['String']>;
  updatePending?: Maybe<Scalars['Boolean']>;
  value?: Maybe<EnumThermostatOperatingModeValue>;
};

export type ThermostatOperatingState = {
  __typename?: 'ThermostatOperatingState';
  id?: Maybe<Scalars['String']>;
  observedAt?: Maybe<Scalars['Float']>;
  previousId?: Maybe<Scalars['String']>;
  timestamp?: Maybe<Scalars['Float']>;
  units?: Maybe<Scalars['String']>;
  updatePending?: Maybe<Scalars['Boolean']>;
  value?: Maybe<EnumThermostatOperatingStateValue>;
};

export type ThermostatPairingState = {
  __typename?: 'ThermostatPairingState';
  id?: Maybe<Scalars['String']>;
  observedAt?: Maybe<Scalars['Float']>;
  previousId?: Maybe<Scalars['String']>;
  timestamp?: Maybe<Scalars['Float']>;
  units?: Maybe<Scalars['String']>;
  updatePending?: Maybe<Scalars['Boolean']>;
  value?: Maybe<EnumThermostatPairingStateValue>;
};

export type ThermostatPassCode = {
  __typename?: 'ThermostatPassCode';
  id?: Maybe<Scalars['String']>;
  observedAt?: Maybe<Scalars['Float']>;
  previousId?: Maybe<Scalars['String']>;
  timestamp?: Maybe<Scalars['Float']>;
  units?: Maybe<Scalars['String']>;
  updatePending?: Maybe<Scalars['Boolean']>;
  value?: Maybe<Scalars['Float']>;
};

export type ThermostatPendingSchedule = {
  __typename?: 'ThermostatPendingSchedule';
  id?: Maybe<Scalars['String']>;
  timestamp?: Maybe<Scalars['Float']>;
  units?: Maybe<Scalars['String']>;
  updatePending?: Maybe<Scalars['Boolean']>;
  value?: Maybe<Scalars['JSON']>;
};

export type ThermostatPendingScheduleInput = {
  pendingSchedule?: InputMaybe<Scalars['JSONObject']>;
};

export type ThermostatPowerMode = {
  __typename?: 'ThermostatPowerMode';
  id?: Maybe<Scalars['String']>;
  observedAt?: Maybe<Scalars['Float']>;
  previousId?: Maybe<Scalars['String']>;
  timestamp?: Maybe<Scalars['Float']>;
  units?: Maybe<Scalars['String']>;
  updatePending?: Maybe<Scalars['Boolean']>;
  value?: Maybe<EnumThermostatPowerModeValue>;
};

export type ThermostatProgMode = {
  __typename?: 'ThermostatProgMode';
  id?: Maybe<Scalars['String']>;
  observedAt?: Maybe<Scalars['Float']>;
  previousId?: Maybe<Scalars['String']>;
  timestamp?: Maybe<Scalars['Float']>;
  units?: Maybe<Scalars['String']>;
  updatePending?: Maybe<Scalars['Boolean']>;
  value?: Maybe<EnumThermostatProgModeValue>;
};

export type ThermostatRemoteSensorTempDelta = {
  __typename?: 'ThermostatRemoteSensorTempDelta';
  id?: Maybe<Scalars['String']>;
  observedAt?: Maybe<Scalars['Float']>;
  previousId?: Maybe<Scalars['String']>;
  timestamp?: Maybe<Scalars['Float']>;
  units?: Maybe<Scalars['String']>;
  updatePending?: Maybe<Scalars['Boolean']>;
  value?: Maybe<Scalars['Float']>;
};

export type ThermostatSchedVisibilityMode = {
  __typename?: 'ThermostatSchedVisibilityMode';
  id?: Maybe<Scalars['String']>;
  observedAt?: Maybe<Scalars['Float']>;
  previousId?: Maybe<Scalars['String']>;
  timestamp?: Maybe<Scalars['Float']>;
  units?: Maybe<Scalars['String']>;
  updatePending?: Maybe<Scalars['Boolean']>;
  value?: Maybe<EnumThermostatSchedVisibilityModeValue>;
};

export type ThermostatSchedule = {
  __typename?: 'ThermostatSchedule';
  id?: Maybe<Scalars['String']>;
  timestamp?: Maybe<Scalars['Float']>;
  units?: Maybe<Scalars['String']>;
  updatePending?: Maybe<Scalars['Boolean']>;
  value?: Maybe<Scalars['JSON']>;
};

export type ThermostatScheduleProfile = {
  __typename: 'ThermostatScheduleProfile';
  _id: Scalars['String'];
  modelChangeOperation?: Maybe<Scalars['String']>;
  modelType?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  propertyId: Scalars['String'];
  updateDescription?: Maybe<Scalars['JSON']>;
};

/** List of items with pagination. */
export type ThermostatScheduleProfilePaginatedThermostatScheduleProfiles = {
  __typename?: 'ThermostatScheduleProfilePaginatedThermostatScheduleProfiles';
  /** Total object count. */
  count?: Maybe<Scalars['Int']>;
  /** Array of objects. */
  items?: Maybe<Array<ThermostatScheduleProfile>>;
  /** Information to aid in pagination. */
  pageInfo: PaginationInfo;
};

export type ThermostatScheduleTemplate = {
  __typename: 'ThermostatScheduleTemplate';
  _id: Scalars['String'];
  assignedDeviceCount?: Maybe<Scalars['Float']>;
  assignedUnitCount?: Maybe<Scalars['Float']>;
  isPropertyDefault?: Maybe<Scalars['Boolean']>;
  modelChangeOperation?: Maybe<Scalars['String']>;
  modelType?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  propertyId: Scalars['String'];
  setpointLimitProfileId?: Maybe<Scalars['String']>;
  timestamp?: Maybe<Scalars['Float']>;
  updateDescription?: Maybe<Scalars['JSON']>;
  value: ThermostatScheduleTemplateValue;
};

/** Represents the return data for which the edited template will affect */
export type ThermostatScheduleTemplateEditVerificationData = {
  __typename?: 'ThermostatScheduleTemplateEditVerificationData';
  /** Total number of thermostats that will be affected by the changes to the schedule template. */
  allAffectedThermostats?: Maybe<Scalars['Float']>;
  /** Total number of units that will be affected by the changes to the schedule template. */
  allAffectedUnits?: Maybe<Scalars['Float']>;
  /** Total number of thermostats in a given unit. */
  allThermostats?: Maybe<Scalars['Float']>;
  /** Total number of units in a given property. */
  allUnits?: Maybe<Scalars['Float']>;
};

/** List of items with pagination. */
export type ThermostatScheduleTemplatePaginatedThermostatScheduleTemplates = {
  __typename?: 'ThermostatScheduleTemplatePaginatedThermostatScheduleTemplates';
  /** Total object count. */
  count?: Maybe<Scalars['Int']>;
  /** Array of objects. */
  items?: Maybe<Array<ThermostatScheduleTemplate>>;
  /** Information to aid in pagination. */
  pageInfo: PaginationInfo;
};

/** Represents metrics related to a given thermostat schedule template. */
export type ThermostatScheduleTemplateUpdateVerificationData = {
  __typename?: 'ThermostatScheduleTemplateUpdateVerificationData';
  /** Number of thermostats that have been installed and currently online. */
  installedOnlineThermostats: Array<Maybe<Scalars['String']>>;
  /** Number of installed, online thermostats using device level custom schedule. */
  installedOnlineThermostatsAndUsesCustomSchedule: Array<
    Maybe<Scalars['String']>
  >;
  /** Number of installed, online thermostats using device level custom setpoint limits. */
  installedOnlineThermostatsAndUsesCustomSetpointLimits: Array<
    Maybe<Scalars['String']>
  >;
  /** Installed and online thermostats using a schedule template. */
  installedOnlineThermostatsAndUsesScheduleTemplate: Array<Maybe<Thermostat>>;
  /** Number of thermostats that have been installed. */
  installedThermostats: Scalars['Float'];
  /** Installed and online thermostats using property level schedule template. */
  thermostatsUsingPropertyLevelScheduleTemplate: Array<
    Maybe<Scalars['String']>
  >;
  /** Number of thermostats using unit level schedule template. */
  thermostatsUsingUnitLevelScheduleTemplate: Array<Maybe<Scalars['String']>>;
  /** Total number of thermostats in a given unit. */
  totalThermostats: Scalars['Float'];
  /** Total number of units in a given property. */
  totalUnits: Scalars['Float'];
  /** Number of units with a schedule template applied. */
  unitsWithAppliedThermostatScheduleTemplate: Scalars['Float'];
  /** Number of units without a schedule template applied. */
  unitsWithoutAppliedThermostatScheduleTemplate: Scalars['Float'];
};

export type ThermostatScheduleTemplateValue = {
  __typename?: 'ThermostatScheduleTemplateValue';
  id?: Maybe<Scalars['String']>;
  timestamp?: Maybe<Scalars['Float']>;
  units?: Maybe<Scalars['String']>;
  updatePending?: Maybe<Scalars['Boolean']>;
  value?: Maybe<Scalars['JSON']>;
};

export type ThermostatSeparateAirDirectionMetricV1 = {
  __typename?: 'ThermostatSeparateAirDirectionMetricV1';
  observedAt?: Maybe<Scalars['Float']>;
  pending: Scalars['Boolean'];
  readingId?: Maybe<Scalars['String']>;
  timestamp?: Maybe<Scalars['Float']>;
  value?: Maybe<Scalars['String']>;
};

export type ThermostatSeparateFanSpeedMetricV1 = {
  __typename?: 'ThermostatSeparateFanSpeedMetricV1';
  observedAt?: Maybe<Scalars['Float']>;
  pending: Scalars['Boolean'];
  readingId?: Maybe<Scalars['String']>;
  timestamp?: Maybe<Scalars['Float']>;
  value?: Maybe<Scalars['String']>;
};

export type ThermostatSeparateOperatingModeMetricV1 = {
  __typename?: 'ThermostatSeparateOperatingModeMetricV1';
  observedAt?: Maybe<Scalars['Float']>;
  pending: Scalars['Boolean'];
  readingId?: Maybe<Scalars['String']>;
  timestamp?: Maybe<Scalars['Float']>;
  value?: Maybe<Scalars['String']>;
};

export type ThermostatSeparateOperatingStateMetricV1 = {
  __typename?: 'ThermostatSeparateOperatingStateMetricV1';
  observedAt?: Maybe<Scalars['Float']>;
  pending: Scalars['Boolean'];
  readingId?: Maybe<Scalars['String']>;
  timestamp?: Maybe<Scalars['Float']>;
  value?: Maybe<Scalars['String']>;
};

export type ThermostatSeparatePowerControlV1 = {
  __typename?: 'ThermostatSeparatePowerControlV1';
  airDirection: ThermostatSeparateAirDirectionMetricV1;
  allowedAirDirections: Array<Scalars['String']>;
  allowedFanSpeeds: Array<Scalars['String']>;
  allowedOperatingModes: Array<Scalars['String']>;
  canEditAirDirection: Scalars['Boolean'];
  canEditFanSpeed: Scalars['Boolean'];
  canEditOperatingMode: Scalars['Boolean'];
  canEditPowerMode: Scalars['Boolean'];
  canEditTargets: Scalars['Boolean'];
  controlContract: Scalars['String'];
  fanSpeed: ThermostatSeparateFanSpeedMetricV1;
  operatingMode: ThermostatSeparateOperatingModeMetricV1;
  operatingState: ThermostatSeparateOperatingStateMetricV1;
  powerMode: ThermostatSeparatePowerModeMetricV1;
  powerState: ThermostatSeparatePowerStateMetricV1;
  supportsAirDirection: Scalars['Boolean'];
  targetBlockReason?: Maybe<Scalars['String']>;
};

export type ThermostatSeparatePowerModeMetricV1 = {
  __typename?: 'ThermostatSeparatePowerModeMetricV1';
  observedAt?: Maybe<Scalars['Float']>;
  pending: Scalars['Boolean'];
  readingId?: Maybe<Scalars['String']>;
  timestamp?: Maybe<Scalars['Float']>;
  value?: Maybe<Scalars['String']>;
};

export type ThermostatSeparatePowerStateMetricV1 = {
  __typename?: 'ThermostatSeparatePowerStateMetricV1';
  observedAt?: Maybe<Scalars['Float']>;
  pending: Scalars['Boolean'];
  readingId?: Maybe<Scalars['String']>;
  timestamp?: Maybe<Scalars['Float']>;
  value?: Maybe<Scalars['String']>;
};

export type ThermostatSetpoint = {
  __typename?: 'ThermostatSetpoint';
  id?: Maybe<Scalars['String']>;
  observedAt?: Maybe<Scalars['Float']>;
  previousId?: Maybe<Scalars['String']>;
  timestamp?: Maybe<Scalars['Float']>;
  units?: Maybe<Scalars['String']>;
  updatePending?: Maybe<Scalars['Boolean']>;
  value?: Maybe<Scalars['Float']>;
};

export type ThermostatSetpointChangeSource = {
  __typename?: 'ThermostatSetpointChangeSource';
  id?: Maybe<Scalars['String']>;
  observedAt?: Maybe<Scalars['Float']>;
  previousId?: Maybe<Scalars['String']>;
  timestamp?: Maybe<Scalars['Float']>;
  units?: Maybe<Scalars['String']>;
  updatePending?: Maybe<Scalars['Boolean']>;
  value?: Maybe<EnumThermostatSetpointChangeSourceValue>;
};

export type ThermostatShowFanButton = {
  __typename?: 'ThermostatShowFanButton';
  id?: Maybe<Scalars['String']>;
  observedAt?: Maybe<Scalars['Float']>;
  previousId?: Maybe<Scalars['String']>;
  timestamp?: Maybe<Scalars['Float']>;
  units?: Maybe<Scalars['String']>;
  updatePending?: Maybe<Scalars['Boolean']>;
  value?: Maybe<Scalars['Boolean']>;
};

export type ThermostatSystemType = {
  __typename?: 'ThermostatSystemType';
  id?: Maybe<Scalars['String']>;
  observedAt?: Maybe<Scalars['Float']>;
  previousId?: Maybe<Scalars['String']>;
  timestamp?: Maybe<Scalars['Float']>;
  units?: Maybe<Scalars['String']>;
  updatePending?: Maybe<Scalars['Boolean']>;
  value?: Maybe<EnumThermostatSystemTypeValue>;
};

export type ThermostatTempDisplayMode = {
  __typename?: 'ThermostatTempDisplayMode';
  id?: Maybe<Scalars['String']>;
  observedAt?: Maybe<Scalars['Float']>;
  previousId?: Maybe<Scalars['String']>;
  timestamp?: Maybe<Scalars['Float']>;
  units?: Maybe<Scalars['String']>;
  updatePending?: Maybe<Scalars['Boolean']>;
  value?: Maybe<EnumThermostatTempDisplayModeValue>;
};

export type ThermostatTemperature = {
  __typename?: 'ThermostatTemperature';
  id?: Maybe<Scalars['String']>;
  observedAt?: Maybe<Scalars['Float']>;
  previousId?: Maybe<Scalars['String']>;
  timestamp?: Maybe<Scalars['Float']>;
  units?: Maybe<Scalars['String']>;
  updatePending?: Maybe<Scalars['Boolean']>;
  value?: Maybe<Scalars['Float']>;
};

export type ThermostatUiOptions = {
  __typename?: 'ThermostatUiOptions';
  id?: Maybe<Scalars['String']>;
  observedAt?: Maybe<Scalars['Float']>;
  previousId?: Maybe<Scalars['String']>;
  timestamp?: Maybe<Scalars['Float']>;
  units?: Maybe<Scalars['String']>;
  updatePending?: Maybe<Scalars['Boolean']>;
  value?: Maybe<Scalars['Float']>;
};

export type ThermostatUpdateFields = {
  adjustScheduleToConformToSetpointLimits?: InputMaybe<Scalars['Boolean']>;
  propertyId?: InputMaybe<Scalars['String']>;
  thermostatScheduleTemplateId?: InputMaybe<Scalars['String']>;
  unitId?: InputMaybe<Scalars['String']>;
  useCustomSchedule?: InputMaybe<Scalars['Boolean']>;
  useCustomSetpointLimits?: InputMaybe<Scalars['Boolean']>;
};

export type ThermostatUpdateInput = {
  airDirection?: InputMaybe<Scalars['String']>;
  coolSetpoint?: InputMaybe<Scalars['Float']>;
  fanMode?: InputMaybe<Scalars['String']>;
  fanSpeed?: InputMaybe<Scalars['String']>;
  heatSetpoint?: InputMaybe<Scalars['Float']>;
  holdState?: InputMaybe<Scalars['String']>;
  keypadLockoutLevel?: InputMaybe<Scalars['Int']>;
  localControlPermissions?: InputMaybe<LocalControlPermissionPatchInput>;
  maxCoolSetpointLimit?: InputMaybe<Scalars['Float']>;
  maxHeatSetpointLimit?: InputMaybe<Scalars['Float']>;
  minCoolSetpointLimit?: InputMaybe<Scalars['Float']>;
  minHeatSetpointLimit?: InputMaybe<Scalars['Float']>;
  operatingMode?: InputMaybe<Scalars['String']>;
  powerMode?: InputMaybe<Scalars['String']>;
  progMode?: InputMaybe<Scalars['String']>;
  schedule?: InputMaybe<Scalars['JSONObject']>;
  setpoint?: InputMaybe<Scalars['Float']>;
  showFanButton?: InputMaybe<Scalars['Boolean']>;
  systemType?: InputMaybe<Scalars['String']>;
};

export type ThermostatUpdateOptions = {
  forcePush?: InputMaybe<Scalars['Boolean']>;
  thermostatControlContract?: InputMaybe<Scalars['String']>;
};

export type TieredEntitySelectionCriterionInput = {
  comparator: Scalars['String'];
  displayValues?: InputMaybe<Array<Scalars['String']>>;
  editable?: InputMaybe<Scalars['Boolean']>;
  id: Scalars['String'];
  invert?: InputMaybe<Scalars['Boolean']>;
  selectionPath: Scalars['String'];
  valueDisplayUnits?: InputMaybe<Scalars['String']>;
  valueType: Scalars['String'];
  values?: InputMaybe<Array<Scalars['String']>>;
};

export type TieredEntitySelectionInput = {
  basisName: Scalars['String'];
  id?: InputMaybe<Scalars['String']>;
  selectionCriteria: EntityCriteriaCompoundOperatorInput;
  targetModel: ModelExecutionConfigInput;
  tiers?: InputMaybe<Scalars['Int']>;
};

export type Unit = {
  __typename: 'Unit';
  _id: Scalars['String'];
  alertTypes?: Maybe<UnitAlertTypes>;
  alerts: Array<Maybe<Alert>>;
  assignableSetpointProfiles: Array<Maybe<SetpointProfile>>;
  assignableZonePolicies?: Maybe<Array<ZonePolicy>>;
  availableThermostatScheduleTemplates: Array<
    Maybe<ThermostatScheduleTemplate>
  >;
  building?: Maybe<Building>;
  buildingId: Scalars['String'];
  controlGroups: Array<Maybe<ControlGroup>>;
  coolSetpoint?: Maybe<Scalars['Float']>;
  cuid?: Maybe<Scalars['String']>;
  devices: Array<DeviceInterface>;
  devicesSummary?: Maybe<UnitDevicesSummary>;
  effectiveThermostatScheduleType: Scalars['String'];
  floor?: Maybe<Floor>;
  floorId?: Maybe<Scalars['String']>;
  hasAlerts?: Maybe<Scalars['Boolean']>;
  hasPanels?: Maybe<Scalars['Boolean']>;
  hasResident?: Maybe<Scalars['Boolean']>;
  heatSetpoint?: Maybe<Scalars['Float']>;
  humidity?: Maybe<Scalars['Float']>;
  isConnected?: Maybe<Scalars['Boolean']>;
  loopSupply?: Maybe<Scalars['Float']>;
  modelChangeOperation?: Maybe<Scalars['String']>;
  modelType?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  operatingMode?: Maybe<Scalars['String']>;
  operatingState?: Maybe<Scalars['String']>;
  panels: Array<Maybe<Panel>>;
  property?: Maybe<Property>;
  propertyId: Scalars['String'];
  resident?: Maybe<UnitResident>;
  separatePowerThermostatIds: Array<Scalars['String']>;
  setpoint?: Maybe<Scalars['Float']>;
  setpointLimitProfile?: Maybe<SetpointProfile>;
  setpointProfileId?: Maybe<Scalars['String']>;
  source?: Maybe<Source>;
  sourceId?: Maybe<Scalars['String']>;
  systemNotifications?: Maybe<Array<SystemNotification>>;
  tempDisplayUnits?: Maybe<Scalars['String']>;
  temperature?: Maybe<Scalars['Float']>;
  thermostatScheduleTemplate?: Maybe<ThermostatScheduleTemplate>;
  thermostatScheduleTemplateId?: Maybe<Scalars['String']>;
  type: Scalars['String'];
  updateDescription?: Maybe<Scalars['JSON']>;
  vpps: Array<Maybe<VirtualPowerPlant>>;
  zonePolicyId?: Maybe<Scalars['String']>;
  zones: Array<Maybe<Zone>>;
};

export type UnitAlertsArgs = {
  filter?: InputMaybe<FilterFindManyAlertInput>;
  limit?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<SortFindManyAlertInput>;
};

export type UnitAvailableThermostatScheduleTemplatesArgs = {
  filter?: InputMaybe<FilterFindManyThermostatScheduleTemplateInput>;
  limit?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<SortFindManyThermostatScheduleTemplateInput>;
};

export type UnitControlGroupsArgs = {
  filter?: InputMaybe<FilterFindManyControlGroupInput>;
  limit?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<SortFindManyControlGroupInput>;
};

export type UnitDevicesArgs = {
  filter?: InputMaybe<FilterFindManyDeviceInput>;
  limit?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<SortFindManyDeviceInput>;
};

export type UnitPanelsArgs = {
  filter?: InputMaybe<FilterFindManyPanelInput>;
  limit?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<SortFindManyPanelInput>;
};

export type UnitVppsArgs = {
  filter?: InputMaybe<FilterFindManyVirtualPowerPlantInput>;
  limit?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<SortFindManyVirtualPowerPlantInput>;
};

export type UnitZonesArgs = {
  filter?: InputMaybe<FilterFindManyZoneInput>;
  limit?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<SortFindManyZoneInput>;
};

export type UnitAlertTypes = {
  __typename?: 'UnitAlertTypes';
  deviceAlert?: Maybe<Scalars['Boolean']>;
  deviceMetric?: Maybe<Scalars['Boolean']>;
  deviceOffline?: Maybe<Scalars['Boolean']>;
  equipmentAlarm?: Maybe<Scalars['Boolean']>;
  sourceOffline?: Maybe<Scalars['Boolean']>;
};

export type UnitDevicesSummary = {
  __typename?: 'UnitDevicesSummary';
  count?: Maybe<Scalars['Float']>;
  majorAlerts?: Maybe<Scalars['Float']>;
  minorAlerts?: Maybe<Scalars['Float']>;
  proxy?: Maybe<UnitDevicesSummaryProxy>;
};

export type UnitDevicesSummaryProxy = {
  __typename?: 'UnitDevicesSummaryProxy';
  coolSetpoint?: Maybe<Scalars['Float']>;
  heatSetpoint?: Maybe<Scalars['Float']>;
  humidity?: Maybe<Scalars['Float']>;
  isOffline?: Maybe<Scalars['Boolean']>;
  operatingMode?: Maybe<Scalars['String']>;
  operatingState?: Maybe<Scalars['String']>;
  setpointCoolMin?: Maybe<Scalars['Float']>;
  setpointHeatMax?: Maybe<Scalars['Float']>;
  setpointProfileName?: Maybe<Scalars['String']>;
  setpointProfileType?: Maybe<Scalars['String']>;
  temperature?: Maybe<Scalars['Float']>;
  type?: Maybe<Scalars['String']>;
};

/** List of items with pagination. */
export type UnitPaginatedChildDataLoader = {
  __typename?: 'UnitPaginatedChildDataLoader';
  /** Total object count. */
  count?: Maybe<Scalars['Int']>;
  /** Array of objects. */
  items?: Maybe<Array<Unit>>;
  /** Information to aid in pagination. */
  pageInfo: PaginationInfo;
};

/** List of items with pagination. */
export type UnitPaginatedUnits = {
  __typename?: 'UnitPaginatedUnits';
  /** Total object count. */
  count?: Maybe<Scalars['Int']>;
  /** Array of objects. */
  items?: Maybe<Array<Unit>>;
  /** Information to aid in pagination. */
  pageInfo: PaginationInfo;
};

export type UnitResident = {
  __typename?: 'UnitResident';
  email?: Maybe<Scalars['String']>;
  mobile?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  phone?: Maybe<Scalars['String']>;
};

export type UpdateIngestionInput = {
  date?: InputMaybe<Scalars['Date']>;
  fileName?: InputMaybe<Scalars['String']>;
  s3FileName?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<Scalars['String']>;
  userId?: InputMaybe<Scalars['String']>;
};

export type UpdateOneAlertTriggerInput = {
  alertCategoryId?: InputMaybe<Scalars['String']>;
  editMode?: InputMaybe<Scalars['Float']>;
  enabled?: InputMaybe<Scalars['Boolean']>;
  entityTypes?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  key?: InputMaybe<Scalars['String']>;
  legacyKey?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  propertyId?: InputMaybe<Scalars['String']>;
  triggerCriteria: UpdateOneAlertTriggerTriggerCriteriaInput;
};

export type UpdateOneAlertTriggerTriggerCriteriaInput = {
  basisName?: InputMaybe<Scalars['String']>;
  basisType?: InputMaybe<EnumAlertTriggerTriggerCriteriaBasisType>;
  levels?: InputMaybe<Scalars['Float']>;
  selectionCriteria?: InputMaybe<UpdateOneAlertTriggerTriggerCriteriaSelectionCriteriaInput>;
};

export type UpdateOneAlertTriggerTriggerCriteriaSelectionCriteriaCompoundOperatorInput =
  {
    criteria?: InputMaybe<Scalars['JSON']>;
    id?: InputMaybe<Scalars['String']>;
    operator?: InputMaybe<EnumAlertTriggerTriggerCriteriaSelectionCriteriaCompoundOperatorOperator>;
  };

export type UpdateOneAlertTriggerTriggerCriteriaSelectionCriteriaCriterionInput =
  {
    comparator: EnumAlertTriggerTriggerCriteriaSelectionCriteriaCriterionComparator;
    editable?: InputMaybe<Scalars['Boolean']>;
    id: Scalars['String'];
    legacyPath?: InputMaybe<Scalars['String']>;
    selectionPath: Scalars['String'];
    template?: InputMaybe<Scalars['String']>;
    valueType: EnumAlertTriggerTriggerCriteriaSelectionCriteriaCriterionValueType;
    values: Array<InputMaybe<Scalars['String']>>;
  };

export type UpdateOneAlertTriggerTriggerCriteriaSelectionCriteriaInput = {
  compoundOperator?: InputMaybe<UpdateOneAlertTriggerTriggerCriteriaSelectionCriteriaCompoundOperatorInput>;
  criteria?: InputMaybe<
    Array<
      InputMaybe<UpdateOneAlertTriggerTriggerCriteriaSelectionCriteriaCriterionInput>
    >
  >;
  criterion?: InputMaybe<UpdateOneAlertTriggerTriggerCriteriaSelectionCriteriaCriterionInput>;
  simpleOperator?: InputMaybe<UpdateOneAlertTriggerTriggerCriteriaSelectionCriteriaSimpleOperatorInput>;
};

export type UpdateOneAlertTriggerTriggerCriteriaSelectionCriteriaSimpleOperatorInput =
  {
    criteria?: InputMaybe<
      Array<
        InputMaybe<UpdateOneAlertTriggerTriggerCriteriaSelectionCriteriaCriterionInput>
      >
    >;
    criterion?: InputMaybe<UpdateOneAlertTriggerTriggerCriteriaSelectionCriteriaCriterionInput>;
    id?: InputMaybe<Scalars['String']>;
    operator?: InputMaybe<EnumAlertTriggerTriggerCriteriaSelectionCriteriaSimpleOperatorOperator>;
  };

export type UpdateOneAuthorizationProfileInput = {
  apiToken?: InputMaybe<Scalars['String']>;
  currentChallenge?: InputMaybe<Scalars['String']>;
  currentChallengeExpiration?: InputMaybe<Scalars['Float']>;
  installerProperties?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  isInstaller?: InputMaybe<Scalars['Boolean']>;
  isManager?: InputMaybe<Scalars['Boolean']>;
  isResident?: InputMaybe<Scalars['Boolean']>;
  isSuper?: InputMaybe<Scalars['Boolean']>;
  isViewer?: InputMaybe<Scalars['Boolean']>;
  managerProperties?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  residentProperty?: InputMaybe<Scalars['String']>;
  residentUnit?: InputMaybe<Scalars['String']>;
  viewerProperties?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type UpdateOneBngInput = {
  localUrl: Scalars['String'];
  name: Scalars['String'];
  url: Scalars['String'];
};

export type UpdateOneBuildingInput = {
  name?: InputMaybe<Scalars['String']>;
  number?: InputMaybe<Scalars['Float']>;
  propertyId?: InputMaybe<Scalars['String']>;
};

export type UpdateOneConductorInput = {
  buildingId?: InputMaybe<Scalars['String']>;
  maxReportingTime?: InputMaybe<Scalars['Float']>;
  name: Scalars['String'];
  tolerances?: InputMaybe<CreateOneConductorTolerancesInput>;
  url: Scalars['String'];
};

export type UpdateOneControlGroupGroupedDevicesInput = {
  _id?: InputMaybe<Scalars['String']>;
  deviceId?: InputMaybe<Scalars['String']>;
  displayOrder?: InputMaybe<Scalars['Float']>;
  name?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<Scalars['String']>;
};

export type UpdateOneControlGroupInput = {
  automationEnabled?: InputMaybe<Scalars['Boolean']>;
  groupedDevices?: InputMaybe<
    Array<InputMaybe<UpdateOneControlGroupGroupedDevicesInput>>
  >;
  masterDeviceId?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
};

export type UpdateOneCoreInput = {
  maxReportingTime?: InputMaybe<Scalars['Float']>;
  name: Scalars['String'];
  tolerances?: InputMaybe<CreateOneCoreTolerancesInput>;
  url: Scalars['String'];
};

export type UpdateOneHmmInput = {
  maxReportingTime?: InputMaybe<Scalars['Float']>;
  name: Scalars['String'];
  tolerances?: InputMaybe<CreateOneHmmTolerancesInput>;
  url: Scalars['String'];
};

export type UpdateOneOrganizationHqAddressInput = {
  city?: InputMaybe<Scalars['String']>;
  country?: InputMaybe<Scalars['String']>;
  line1?: InputMaybe<Scalars['String']>;
  line2?: InputMaybe<Scalars['String']>;
  postalCode?: InputMaybe<Scalars['String']>;
  state?: InputMaybe<Scalars['String']>;
};

export type UpdateOneOrganizationInput = {
  description?: InputMaybe<Scalars['String']>;
  hqAddress?: InputMaybe<UpdateOneOrganizationHqAddressInput>;
  hqEmail?: InputMaybe<Scalars['String']>;
  hqPhone?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  parentOrganizationId?: InputMaybe<Scalars['String']>;
};

export type UpdateOnePlmContractInput = {
  baselineMethod?: InputMaybe<EnumPlmContractBaselineMethod>;
  contractId?: InputMaybe<Scalars['String']>;
  dispatcherIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  incentiveDescription?: InputMaybe<Scalars['String']>;
  maximumEventsPerSeason?: InputMaybe<Scalars['Float']>;
  meterIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  minimumReductionKW?: InputMaybe<Scalars['Float']>;
  name?: InputMaybe<Scalars['String']>;
  notificationEmail?: InputMaybe<Scalars['String']>;
  partnerId?: InputMaybe<Scalars['String']>;
  penaltyForNonCompliance?: InputMaybe<Scalars['Float']>;
  programId?: InputMaybe<Scalars['String']>;
  propertyIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  scopeType?: InputMaybe<EnumPlmContractScopeType>;
  status?: InputMaybe<EnumPlmContractStatus>;
  utilityId?: InputMaybe<Scalars['String']>;
};

export type UpdateOnePlmCurtailmentPlanInput = {
  applicableSeasons?: InputMaybe<
    Array<InputMaybe<EnumPlmCurtailmentPlanApplicableSeasons>>
  >;
  description?: InputMaybe<Scalars['String']>;
  durationMinutes?: InputMaybe<Scalars['Float']>;
  estimatedReductionKW?: InputMaybe<Scalars['Float']>;
  name?: InputMaybe<Scalars['String']>;
  organizationId?: InputMaybe<Scalars['String']>;
};

export type UpdateOnePlmCurtailmentTaskCachedDeviceStateInput = {
  coolSetpoint?: InputMaybe<Scalars['Float']>;
  coolSetpointAdjustmentMode?: InputMaybe<EnumPlmCurtailmentTaskCachedDeviceStateCoolSetpointAdjustmentMode>;
  fanMode?: InputMaybe<Scalars['String']>;
  fanSpeed?: InputMaybe<Scalars['String']>;
  freshAirSetpoint?: InputMaybe<Scalars['Float']>;
  heatSetpoint?: InputMaybe<Scalars['Float']>;
  heatSetpointAdjustmentMode?: InputMaybe<EnumPlmCurtailmentTaskCachedDeviceStateHeatSetpointAdjustmentMode>;
  isOn?: InputMaybe<Scalars['Boolean']>;
  keypadLockoutLevel?: InputMaybe<Scalars['String']>;
  maxCoolSetpointLimit?: InputMaybe<Scalars['Float']>;
  maxHeatSetpointLimit?: InputMaybe<Scalars['Float']>;
  minCoolSetpointLimit?: InputMaybe<Scalars['Float']>;
  minHeatSetpointLimit?: InputMaybe<Scalars['Float']>;
  operatingMode?: InputMaybe<Scalars['String']>;
  rhSetpoint?: InputMaybe<Scalars['Float']>;
  type: EnumPlmCurtailmentTaskCachedDeviceStateType;
  ventilationMode?: InputMaybe<Scalars['String']>;
};

export type UpdateOnePlmCurtailmentTaskInput = {
  batchId?: InputMaybe<Scalars['Float']>;
  cachedDeviceState?: InputMaybe<UpdateOnePlmCurtailmentTaskCachedDeviceStateInput>;
  deviceId?: InputMaybe<Scalars['String']>;
  deviceType?: InputMaybe<Scalars['String']>;
  endedAt?: InputMaybe<Scalars['Float']>;
  estimatedReductionKW?: InputMaybe<Scalars['Float']>;
  plmCurtailmentActionId?: InputMaybe<Scalars['String']>;
  plmEventResponseId?: InputMaybe<Scalars['String']>;
  propertyId?: InputMaybe<Scalars['String']>;
  resolvedTargetedAdjustments?: InputMaybe<UpdateOnePlmCurtailmentTaskCachedDeviceStateInput>;
  scheduledEnd?: InputMaybe<Scalars['Float']>;
  scheduledStart?: InputMaybe<Scalars['Float']>;
  startedAt?: InputMaybe<Scalars['Float']>;
  status?: InputMaybe<EnumPlmCurtailmentTaskStatus>;
  statusMessage?: InputMaybe<Scalars['String']>;
  targetedAdjustments?: InputMaybe<UpdateOnePlmCurtailmentTaskCachedDeviceStateInput>;
  unitId?: InputMaybe<Scalars['String']>;
  updateRetryCount?: InputMaybe<Scalars['Float']>;
  verifiedAt?: InputMaybe<Scalars['Float']>;
  verifyAttempts?: InputMaybe<Scalars['Float']>;
};

export type UpdateOnePlmEventInput = {
  contractId?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['Float']>;
  duration?: InputMaybe<Scalars['Float']>;
  notificationHeaders?: InputMaybe<Scalars['JSON']>;
  notificationMethod?: InputMaybe<EnumPlmEventNotificationMethod>;
  notificationPayload?: InputMaybe<Scalars['String']>;
  notificationReceivedAt?: InputMaybe<Scalars['Float']>;
  programId?: InputMaybe<Scalars['String']>;
  reductionTarget?: InputMaybe<Scalars['Float']>;
  sourceExternalId?: InputMaybe<Scalars['String']>;
  sourceVendor?: InputMaybe<Scalars['String']>;
  startTime?: InputMaybe<Scalars['Float']>;
  status?: InputMaybe<EnumPlmEventStatus>;
  updatedAt?: InputMaybe<Scalars['Float']>;
};

export type UpdateOnePlmEventResponseInput = {
  actualEnd?: InputMaybe<Scalars['Float']>;
  actualStart?: InputMaybe<Scalars['Float']>;
  createdAt?: InputMaybe<Scalars['Float']>;
  curtailmentPlanId?: InputMaybe<Scalars['String']>;
  eventId?: InputMaybe<Scalars['String']>;
  responseSentAt?: InputMaybe<Scalars['Float']>;
  responseStatus?: InputMaybe<EnumPlmEventResponseResponseStatus>;
  scheduledEnd?: InputMaybe<Scalars['Float']>;
  scheduledStart?: InputMaybe<Scalars['Float']>;
  updatedAt?: InputMaybe<Scalars['Float']>;
};

export type UpdateOnePlmPartnerContactInput = {
  email?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  phone?: InputMaybe<Scalars['String']>;
};

export type UpdateOnePlmPartnerInput = {
  contact?: InputMaybe<UpdateOnePlmPartnerContactInput>;
  description?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  partnerType?: InputMaybe<EnumPlmPartnerPartnerType>;
};

export type UpdateOnePlmProgramInput = {
  endDate?: InputMaybe<Scalars['Float']>;
  hostPartnerId?: InputMaybe<Scalars['String']>;
  hostUtilityId?: InputMaybe<Scalars['String']>;
  incentiveDescription?: InputMaybe<Scalars['String']>;
  maximumEventDurationMinutes?: InputMaybe<Scalars['Float']>;
  maximumEventsPerSeason?: InputMaybe<Scalars['Float']>;
  maximumNotificationLeadTimeMinutes?: InputMaybe<Scalars['Float']>;
  measurementIntervalMinutes?: InputMaybe<Scalars['Float']>;
  minimumEventDurationMinutes?: InputMaybe<Scalars['Float']>;
  minimumEventsPerSeason?: InputMaybe<Scalars['Float']>;
  name?: InputMaybe<Scalars['String']>;
  notificationLeadTimeMinutes?: InputMaybe<Scalars['Float']>;
  participationType?: InputMaybe<EnumPlmProgramParticipationType>;
  partnerId?: InputMaybe<Scalars['String']>;
  programId?: InputMaybe<Scalars['String']>;
  season?: InputMaybe<EnumPlmProgramSeason>;
  startDate?: InputMaybe<Scalars['Float']>;
  utilityId?: InputMaybe<Scalars['String']>;
};

export type UpdateOnePlmUtilityContactInput = {
  email?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  phone?: InputMaybe<Scalars['String']>;
};

export type UpdateOnePlmUtilityInput = {
  contact?: InputMaybe<UpdateOnePlmUtilityContactInput>;
  description?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
};

export type UpdateOnePropertyAddressInput = {
  city?: InputMaybe<Scalars['String']>;
  line1?: InputMaybe<Scalars['String']>;
  line2?: InputMaybe<Scalars['String']>;
  postalCode?: InputMaybe<Scalars['String']>;
  state?: InputMaybe<Scalars['String']>;
};

export type UpdateOnePropertyAlertLimitsInput = {
  plant?: InputMaybe<UpdateOnePropertyAlertLimitsPlantInput>;
  units?: InputMaybe<UpdateOnePropertyAlertLimitsUnitsInput>;
};

export type UpdateOnePropertyAlertLimitsPlantDhwInput = {
  temperature?: InputMaybe<UpdateOnePropertyAlertLimitsPlantDhwTemperatureInput>;
};

export type UpdateOnePropertyAlertLimitsPlantDhwTemperatureInput = {
  max?: InputMaybe<Scalars['Float']>;
  min?: InputMaybe<Scalars['Float']>;
};

export type UpdateOnePropertyAlertLimitsPlantInput = {
  dhw?: InputMaybe<UpdateOnePropertyAlertLimitsPlantDhwInput>;
  loops?: InputMaybe<UpdateOnePropertyAlertLimitsPlantLoopsInput>;
};

export type UpdateOnePropertyAlertLimitsPlantLoopsInput = {
  pressure?: InputMaybe<UpdateOnePropertyAlertLimitsPlantLoopsPressureInput>;
  temperature?: InputMaybe<UpdateOnePropertyAlertLimitsPlantLoopsTemperatureInput>;
};

export type UpdateOnePropertyAlertLimitsPlantLoopsPressureInput = {
  max?: InputMaybe<Scalars['Float']>;
  min?: InputMaybe<Scalars['Float']>;
};

export type UpdateOnePropertyAlertLimitsPlantLoopsTemperatureInput = {
  max?: InputMaybe<Scalars['Float']>;
  min?: InputMaybe<Scalars['Float']>;
};

export type UpdateOnePropertyAlertLimitsUnitsHumidityInput = {
  max?: InputMaybe<Scalars['Float']>;
  min?: InputMaybe<Scalars['Float']>;
};

export type UpdateOnePropertyAlertLimitsUnitsInput = {
  humidity?: InputMaybe<UpdateOnePropertyAlertLimitsUnitsHumidityInput>;
  temperature?: InputMaybe<UpdateOnePropertyAlertLimitsUnitsTemperatureInput>;
};

export type UpdateOnePropertyAlertLimitsUnitsTemperatureInput = {
  max?: InputMaybe<Scalars['Float']>;
  min?: InputMaybe<Scalars['Float']>;
};

export type UpdateOnePropertyAlertTypesInput = {
  deviceAlert?: InputMaybe<Scalars['Boolean']>;
  deviceMetric?: InputMaybe<Scalars['Boolean']>;
  deviceOffline?: InputMaybe<Scalars['Boolean']>;
  equipmentAlarm?: InputMaybe<Scalars['Boolean']>;
  sourceOffline?: InputMaybe<Scalars['Boolean']>;
};

export type UpdateOnePropertyContactInput = {
  email?: InputMaybe<Scalars['String']>;
  email2?: InputMaybe<Scalars['String']>;
  email3?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  smsNumber?: InputMaybe<Scalars['String']>;
  smsNumber2?: InputMaybe<Scalars['String']>;
  smsNumber3?: InputMaybe<Scalars['String']>;
  smsOptInStatus1?: InputMaybe<EnumPropertyContactSmsOptInStatus1>;
  smsOptInStatus2?: InputMaybe<EnumPropertyContactSmsOptInStatus2>;
  smsOptInStatus3?: InputMaybe<EnumPropertyContactSmsOptInStatus3>;
  smsOptInTimestamp1?: InputMaybe<Scalars['Float']>;
  smsOptInTimestamp2?: InputMaybe<Scalars['Float']>;
  smsOptInTimestamp3?: InputMaybe<Scalars['Float']>;
};

export type UpdateOnePropertyInput = {
  address?: InputMaybe<UpdateOnePropertyAddressInput>;
  alertLimits?: InputMaybe<UpdateOnePropertyAlertLimitsInput>;
  alertTypes?: InputMaybe<UpdateOnePropertyAlertTypesInput>;
  contact?: InputMaybe<UpdateOnePropertyContactInput>;
  floorLabel?: InputMaybe<Scalars['String']>;
  hasSecondaryHeatSource?: InputMaybe<Scalars['Boolean']>;
  imageUrl?: InputMaybe<Scalars['String']>;
  maintMgr?: InputMaybe<UpdateOnePropertyMaintMgrInput>;
  organizationId?: InputMaybe<Scalars['String']>;
  owner?: InputMaybe<UpdateOnePropertyOwnerInput>;
  propMgr?: InputMaybe<UpdateOnePropertyPropMgrInput>;
  tempDisplayUnits?: InputMaybe<Scalars['String']>;
  thermostatScheduleTemplateId?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['String']>;
  title?: InputMaybe<Scalars['String']>;
  unitsSummary?: InputMaybe<UpdateOnePropertyUnitsSummaryInput>;
  zonePolicyId?: InputMaybe<Scalars['String']>;
};

export type UpdateOnePropertyMaintMgrInput = {
  email?: InputMaybe<Scalars['String']>;
  mobile?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
};

export type UpdateOnePropertyOwnerInput = {
  email?: InputMaybe<Scalars['String']>;
  mobile?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  phone?: InputMaybe<Scalars['String']>;
};

export type UpdateOnePropertyPropMgrInput = {
  email?: InputMaybe<Scalars['String']>;
  mobile?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  phone?: InputMaybe<Scalars['String']>;
};

export type UpdateOnePropertyUnitsSummaryInput = {
  count?: InputMaybe<Scalars['Float']>;
  majorAlerts?: InputMaybe<Scalars['Float']>;
  minorAlerts?: InputMaybe<Scalars['Float']>;
};

export type UpdateOneSetpointProfileCoolInput = {
  max?: InputMaybe<Scalars['Float']>;
  min?: InputMaybe<Scalars['Float']>;
};

export type UpdateOneSetpointProfileHeatInput = {
  max?: InputMaybe<Scalars['Float']>;
  min?: InputMaybe<Scalars['Float']>;
};

export type UpdateOneSetpointProfileInput = {
  cool?: InputMaybe<UpdateOneSetpointProfileCoolInput>;
  createdAt?: InputMaybe<Scalars['Float']>;
  createdBy?: InputMaybe<Scalars['String']>;
  heat?: InputMaybe<UpdateOneSetpointProfileHeatInput>;
  name?: InputMaybe<Scalars['String']>;
  propagated?: InputMaybe<Scalars['Boolean']>;
  properties?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  type?: InputMaybe<EnumSetpointProfileType>;
  units?: InputMaybe<EnumSetpointProfileUnits>;
  updatedAt?: InputMaybe<Scalars['Float']>;
  updatedBy?: InputMaybe<Scalars['String']>;
};

export type UpdateOneSystemNotificationInput = {
  acknowledgedAt?: InputMaybe<Scalars['Float']>;
  createdAt?: InputMaybe<Scalars['Float']>;
  displayDuration?: InputMaybe<Scalars['Float']>;
  displayEnd?: InputMaybe<Scalars['Float']>;
  displayStart?: InputMaybe<Scalars['Float']>;
  entityId?: InputMaybe<Scalars['String']>;
  entityType?: InputMaybe<EnumSystemNotificationEntityType>;
  link?: InputMaybe<Scalars['String']>;
  message?: InputMaybe<Scalars['String']>;
  requireAcknowledgement?: InputMaybe<Scalars['Boolean']>;
  seenAt?: InputMaybe<Scalars['Float']>;
  seenBy?: InputMaybe<
    Array<InputMaybe<UpdateOneSystemNotificationSeenByInput>>
  >;
};

export type UpdateOneSystemNotificationSeenByInput = {
  _id?: InputMaybe<Scalars['MongoID']>;
  seenAt?: InputMaybe<Scalars['Float']>;
  userId?: InputMaybe<Scalars['String']>;
};

export type UpdateOneThermostatScheduleTemplateInput = {
  _id?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  propertyId?: InputMaybe<Scalars['String']>;
  setpointLimitProfileId?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<UpdateOneThermostatScheduleTemplateValueInput>;
};

export type UpdateOneThermostatScheduleTemplateValueInput = {
  id?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Float']>;
  units?: InputMaybe<Scalars['String']>;
  updatePending?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<Scalars['JSON']>;
};

export type UpdateOneUnitAlertTypesInput = {
  deviceAlert?: InputMaybe<Scalars['Boolean']>;
  deviceMetric?: InputMaybe<Scalars['Boolean']>;
  deviceOffline?: InputMaybe<Scalars['Boolean']>;
  equipmentAlarm?: InputMaybe<Scalars['Boolean']>;
  sourceOffline?: InputMaybe<Scalars['Boolean']>;
};

export type UpdateOneUnitDevicesSummaryInput = {
  count?: InputMaybe<Scalars['Float']>;
  majorAlerts?: InputMaybe<Scalars['Float']>;
  minorAlerts?: InputMaybe<Scalars['Float']>;
  proxy?: InputMaybe<UpdateOneUnitDevicesSummaryProxyInput>;
};

export type UpdateOneUnitDevicesSummaryProxyInput = {
  coolSetpoint?: InputMaybe<Scalars['Float']>;
  heatSetpoint?: InputMaybe<Scalars['Float']>;
  humidity?: InputMaybe<Scalars['Float']>;
  isOffline?: InputMaybe<Scalars['Boolean']>;
  operatingMode?: InputMaybe<Scalars['String']>;
  operatingState?: InputMaybe<Scalars['String']>;
  setpointCoolMin?: InputMaybe<Scalars['Float']>;
  setpointHeatMax?: InputMaybe<Scalars['Float']>;
  setpointProfileName?: InputMaybe<Scalars['String']>;
  setpointProfileType?: InputMaybe<Scalars['String']>;
  temperature?: InputMaybe<Scalars['Float']>;
  type?: InputMaybe<Scalars['String']>;
};

export type UpdateOneUnitInput = {
  alertTypes?: InputMaybe<UpdateOneUnitAlertTypesInput>;
  buildingId?: InputMaybe<Scalars['String']>;
  cuid?: InputMaybe<Scalars['String']>;
  devicesSummary?: InputMaybe<UpdateOneUnitDevicesSummaryInput>;
  floorId?: InputMaybe<Scalars['String']>;
  hasPanels?: InputMaybe<Scalars['Boolean']>;
  name?: InputMaybe<Scalars['String']>;
  propertyId?: InputMaybe<Scalars['String']>;
  resident?: InputMaybe<UpdateOneUnitResidentInput>;
  sourceId?: InputMaybe<Scalars['String']>;
  tempDisplayUnits?: InputMaybe<Scalars['String']>;
  thermostatScheduleTemplateId?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<Scalars['String']>;
  zonePolicyId?: InputMaybe<Scalars['String']>;
};

export type UpdateOneUnitResidentInput = {
  email?: InputMaybe<Scalars['String']>;
  mobile?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  phone?: InputMaybe<Scalars['String']>;
};

export type UpdateOneUserEmailsInput = {
  address?: InputMaybe<Scalars['String']>;
  externalId?: InputMaybe<Scalars['String']>;
  verified?: InputMaybe<Scalars['Boolean']>;
};

export type UpdateOneUserInput = {
  createdAt?: InputMaybe<Scalars['Date']>;
  emails?: InputMaybe<Array<InputMaybe<UpdateOneUserEmailsInput>>>;
  externalId?: InputMaybe<Scalars['String']>;
  heartbeat?: InputMaybe<Scalars['Date']>;
  mobileSession?: InputMaybe<UpdateOneUserMobileSessionInput>;
  profile?: InputMaybe<UpdateOneUserProfileInput>;
  services?: InputMaybe<UpdateOneUserServicesInput>;
  session?: InputMaybe<UpdateOneUserSessionInput>;
  state?: InputMaybe<Scalars['String']>;
  username?: InputMaybe<Scalars['String']>;
};

export type UpdateOneUserMobileSessionInput = {
  appName?: InputMaybe<Scalars['String']>;
  packageName?: InputMaybe<Scalars['String']>;
  version?: InputMaybe<Scalars['String']>;
  versionCode?: InputMaybe<Scalars['String']>;
};

export type UpdateOneUserProfileInput = {
  emailOptInStatus?: InputMaybe<Scalars['String']>;
  emailOptInStatusTimestamp?: InputMaybe<Scalars['Float']>;
  historyMap?: InputMaybe<Scalars['JSON']>;
  mobile?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  preferredAirFlowUnits?: InputMaybe<EnumUserProfilePreferredAirFlowUnits>;
  preferredUnits?: InputMaybe<EnumUserProfilePreferredUnits>;
  smsOptInStatus?: InputMaybe<Scalars['String']>;
  smsOptInStatusTimestamp?: InputMaybe<Scalars['Float']>;
};

export type UpdateOneUserServicesInput = {
  password?: InputMaybe<UpdateOneUserServicesPasswordInput>;
  resume?: InputMaybe<UpdateOneUserServicesResumeInput>;
};

export type UpdateOneUserServicesPasswordInput = {
  bcrypt?: InputMaybe<Scalars['String']>;
  enroll?: InputMaybe<Scalars['String']>;
  externalId?: InputMaybe<Scalars['String']>;
  reset?: InputMaybe<Scalars['String']>;
};

export type UpdateOneUserServicesResumeInput = {
  loginTokens?: InputMaybe<
    Array<InputMaybe<UpdateOneUserServicesResumeLoginTokensInput>>
  >;
};

export type UpdateOneUserServicesResumeLoginTokensInput = {
  hashedToken?: InputMaybe<Scalars['String']>;
  when?: InputMaybe<Scalars['Date']>;
};

export type UpdateOneUserSessionInput = {
  isMobile?: InputMaybe<Scalars['Boolean']>;
};

export type UpdateOneZonePolicyInput = {
  name?: InputMaybe<Scalars['String']>;
  properties?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  rules?: InputMaybe<Array<InputMaybe<UpdateOneZonePolicyRulesInput>>>;
};

export type UpdateOneZonePolicyRulesInput = {
  source?: InputMaybe<UpdateOneZonePolicyRulesSourceInput>;
  target?: InputMaybe<UpdateOneZonePolicyRulesTargetInput>;
  type?: InputMaybe<EnumZonePolicyRulesType>;
};

export type UpdateOneZonePolicyRulesSourceAttributesInput = {
  contactState?: InputMaybe<Scalars['String']>;
  coolSetpoint?: InputMaybe<Scalars['String']>;
  fanSpeed?: InputMaybe<Scalars['String']>;
  heatSetpoint?: InputMaybe<Scalars['String']>;
  indoorFanStatus?: InputMaybe<Scalars['String']>;
  keypadLockoutLevel?: InputMaybe<Scalars['String']>;
  operatingMode?: InputMaybe<Scalars['String']>;
  operatingState?: InputMaybe<Scalars['String']>;
};

export type UpdateOneZonePolicyRulesSourceInput = {
  attributes?: InputMaybe<UpdateOneZonePolicyRulesSourceAttributesInput>;
  deviceType?: InputMaybe<Scalars['String']>;
  multiplicity?: InputMaybe<EnumZonePolicyRulesSourceMultiplicity>;
};

export type UpdateOneZonePolicyRulesTargetAttributesInput = {
  coolSetpoint?: InputMaybe<Scalars['String']>;
  heatSetpoint?: InputMaybe<Scalars['String']>;
  isOn?: InputMaybe<Scalars['String']>;
  keypadLockoutLevel?: InputMaybe<Scalars['String']>;
  relayState?: InputMaybe<Scalars['String']>;
};

export type UpdateOneZonePolicyRulesTargetInput = {
  attributes?: InputMaybe<UpdateOneZonePolicyRulesTargetAttributesInput>;
  deviceType?: InputMaybe<Scalars['String']>;
  multiplicity?: InputMaybe<EnumZonePolicyRulesTargetMultiplicity>;
};

export type User = {
  __typename: 'User';
  _id: Scalars['String'];
  active?: Maybe<Scalars['String']>;
  alertSubscriptions: Array<Maybe<AlertSubscription>>;
  /** Returns the alertable properties accessible by the user. */
  alertableProperties: Array<Property>;
  authorizationProfile?: Maybe<AuthorizationProfile>;
  createdAt?: Maybe<Scalars['Date']>;
  editableAuthenticationProfile?: Maybe<AuthenticationProfile>;
  email?: Maybe<Scalars['String']>;
  emailOptInStatus?: Maybe<Scalars['String']>;
  emailOptInStatusTimestamp?: Maybe<Scalars['Float']>;
  emails?: Maybe<Array<Maybe<UserEmails>>>;
  externalId?: Maybe<Scalars['String']>;
  hasApiToken: Scalars['Boolean'];
  heartbeat?: Maybe<Scalars['Date']>;
  legacyAuthorizationProfile?: Maybe<AuthorizationProfile>;
  mobile?: Maybe<Scalars['String']>;
  mobileSession?: Maybe<UserMobileSession>;
  modelChangeOperation?: Maybe<Scalars['String']>;
  modelType?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  organization?: Maybe<Organization>;
  plmContracts: Array<Maybe<PlmContract>>;
  preferredAirFlowUnits: AirFlowUnit;
  preferredUnits: TemperatureUnit;
  profile?: Maybe<UserProfile>;
  services?: Maybe<UserServices>;
  session?: Maybe<UserSession>;
  smsOptInStatus?: Maybe<Scalars['String']>;
  smsOptInStatusTimestamp?: Maybe<Scalars['Float']>;
  state?: Maybe<Scalars['String']>;
  systemNotifications?: Maybe<Array<SystemNotification>>;
  updateDescription?: Maybe<Scalars['JSON']>;
  username?: Maybe<Scalars['String']>;
};

export type UserAlertSubscriptionsArgs = {
  filter?: InputMaybe<FilterFindManyAlertSubscriptionInput>;
  limit?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<SortFindManyAlertSubscriptionInput>;
};

export type UserAuthorizationProfileArgs = {
  filter?: InputMaybe<FilterFindManyAuthorizationProfileInput>;
  limit?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<SortFindManyAuthorizationProfileInput>;
};

export type UserPlmContractsArgs = {
  filter?: InputMaybe<FilterFindManyPlmContractInput>;
  limit?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<SortFindManyPlmContractInput>;
};

export type UserAbilities = {
  __typename?: 'UserAbilities';
  rules: Array<AbilityRule>;
};

export type UserEmails = {
  __typename?: 'UserEmails';
  address: Scalars['String'];
  externalId?: Maybe<Scalars['String']>;
  verified?: Maybe<Scalars['Boolean']>;
};

export type UserHistory = {
  __typename: 'UserHistory';
  _id: Scalars['String'];
  currentIndex: Scalars['Float'];
  deviceId: Scalars['String'];
  history?: Maybe<Scalars['JSON']>;
  lastAccessedAt: Scalars['Float'];
  modelChangeOperation?: Maybe<Scalars['String']>;
  modelType?: Maybe<Scalars['String']>;
  updateDescription?: Maybe<Scalars['JSON']>;
  userId: Scalars['String'];
};

/** List of items with pagination. */
export type UserHistoryPaginatedUserHistories = {
  __typename?: 'UserHistoryPaginatedUserHistories';
  /** Total object count. */
  count?: Maybe<Scalars['Int']>;
  /** Array of objects. */
  items?: Maybe<Array<UserHistory>>;
  /** Information to aid in pagination. */
  pageInfo: PaginationInfo;
};

export type UserMobileSession = {
  __typename?: 'UserMobileSession';
  appName?: Maybe<Scalars['String']>;
  packageName?: Maybe<Scalars['String']>;
  version?: Maybe<Scalars['String']>;
  versionCode?: Maybe<Scalars['String']>;
};

/** List of items with pagination. */
export type UserPaginatedUsers = {
  __typename?: 'UserPaginatedUsers';
  /** Total object count. */
  count?: Maybe<Scalars['Int']>;
  /** Array of objects. */
  items?: Maybe<Array<User>>;
  /** Information to aid in pagination. */
  pageInfo: PaginationInfo;
};

export type UserProfile = {
  __typename?: 'UserProfile';
  emailOptInStatus?: Maybe<Scalars['String']>;
  emailOptInStatusTimestamp?: Maybe<Scalars['Float']>;
  /** Legacy: Returns the session history for the user on the current device. */
  history?: Maybe<Scalars['String']>;
  historyMap?: Maybe<Scalars['JSON']>;
  mobile?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  preferredAirFlowUnits?: Maybe<EnumUserProfilePreferredAirFlowUnits>;
  preferredUnits?: Maybe<EnumUserProfilePreferredUnits>;
  smsOptInStatus?: Maybe<Scalars['String']>;
  smsOptInStatusTimestamp?: Maybe<Scalars['Float']>;
};

export type UserServices = {
  __typename?: 'UserServices';
  password?: Maybe<UserServicesPassword>;
  resume?: Maybe<UserServicesResume>;
};

export type UserServicesPassword = {
  __typename?: 'UserServicesPassword';
  bcrypt?: Maybe<Scalars['String']>;
  enroll?: Maybe<Scalars['String']>;
  externalId?: Maybe<Scalars['String']>;
  reset?: Maybe<Scalars['String']>;
};

export type UserServicesResume = {
  __typename?: 'UserServicesResume';
  loginTokens?: Maybe<Array<Maybe<UserServicesResumeLoginTokens>>>;
};

export type UserServicesResumeLoginTokens = {
  __typename?: 'UserServicesResumeLoginTokens';
  hashedToken?: Maybe<Scalars['String']>;
  when?: Maybe<Scalars['Date']>;
};

export type UserSession = {
  __typename?: 'UserSession';
  isMobile?: Maybe<Scalars['Boolean']>;
};

export type VsdPump = DeviceInterface & {
  __typename: 'VSDPump';
  _id: Scalars['String'];
  alertTypes?: Maybe<DeviceAlertTypes>;
  chartTypes: Array<ChartType>;
  controlled?: Maybe<DeviceControlled>;
  currentSpeed?: Maybe<VsdPumpCurrentSpeed>;
  dependentDeviceIds: Array<Maybe<Scalars['String']>>;
  deviceAlerts: Array<Maybe<Alert>>;
  deviceId?: Maybe<Scalars['String']>;
  deviceIdentifier?: Maybe<Scalars['String']>;
  deviceMetrics?: Maybe<Array<Maybe<DeviceMetric>>>;
  displayName?: Maybe<Scalars['String']>;
  driveMode?: Maybe<VsdPumpDriveMode>;
  driveOutputEnergy?: Maybe<VsdPumpDriveOutputEnergy>;
  driveOutputPower?: Maybe<VsdPumpDriveOutputPower>;
  hasCurrentSpeed?: Maybe<Scalars['Boolean']>;
  hasDriveOutputEnergy?: Maybe<Scalars['Boolean']>;
  hasDriveOutputPower?: Maybe<Scalars['Boolean']>;
  hasPendingUpdates: Scalars['Boolean'];
  hasTargetSpeed?: Maybe<Scalars['Boolean']>;
  hmmSupervisorId: Scalars['String'];
  installation?: Maybe<DeviceInstallation>;
  isConfigured?: Maybe<Scalars['Boolean']>;
  isControlled: Scalars['Boolean'];
  isEditable: Scalars['Boolean'];
  isPoweredOn?: Maybe<Scalars['Boolean']>;
  location?: Maybe<Scalars['String']>;
  meta?: Maybe<DeviceMeta>;
  modelChangeOperation?: Maybe<Scalars['String']>;
  modelType?: Maybe<Scalars['String']>;
  /** The name of the device */
  name?: Maybe<Scalars['String']>;
  panel?: Maybe<Panel>;
  panelId?: Maybe<Scalars['String']>;
  powerState?: Maybe<DevicePowerState>;
  property?: Maybe<Property>;
  propertyId: Scalars['String'];
  returnTemperature?: Maybe<VsdPumpReturnTemperature>;
  role?: Maybe<Scalars['String']>;
  source?: Maybe<Source>;
  sourceAlerts: Array<Maybe<Alert>>;
  sourceId?: Maybe<Scalars['String']>;
  stopOrStart?: Maybe<VsdPumpStopOrStart>;
  supplyTemperature?: Maybe<VsdPumpSupplyTemperature>;
  targetSpeed?: Maybe<VsdPumpTargetSpeed>;
  timestamp?: Maybe<Scalars['Float']>;
  type?: Maybe<EnumDKeyDeviceType>;
  typeDisplayName: Scalars['String'];
  unit?: Maybe<Unit>;
  unitId: Scalars['String'];
  updateDescription?: Maybe<Scalars['JSON']>;
  updateStatus?: Maybe<Scalars['Boolean']>;
  vpp?: Maybe<VirtualPowerPlant>;
  vppId?: Maybe<Scalars['String']>;
  zone?: Maybe<Zone>;
  zoneId?: Maybe<Scalars['String']>;
};

export type VsdPumpDeviceAlertsArgs = {
  filter?: InputMaybe<FilterFindManyAlertInput>;
  limit?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<SortFindManyAlertInput>;
};

export type VsdPumpSourceAlertsArgs = {
  filter?: InputMaybe<FilterFindManyAlertInput>;
  limit?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<SortFindManyAlertInput>;
};

export type VsdPumpCurrentSpeed = {
  __typename?: 'VSDPumpCurrentSpeed';
  id?: Maybe<Scalars['String']>;
  observedAt?: Maybe<Scalars['Float']>;
  previousId?: Maybe<Scalars['String']>;
  timestamp?: Maybe<Scalars['Float']>;
  units?: Maybe<Scalars['String']>;
  updatePending?: Maybe<Scalars['Boolean']>;
  value?: Maybe<Scalars['Float']>;
};

export type VsdPumpDriveMode = {
  __typename?: 'VSDPumpDriveMode';
  id?: Maybe<Scalars['String']>;
  observedAt?: Maybe<Scalars['Float']>;
  previousId?: Maybe<Scalars['String']>;
  timestamp?: Maybe<Scalars['Float']>;
  units?: Maybe<Scalars['String']>;
  updatePending?: Maybe<Scalars['Boolean']>;
  value?: Maybe<Scalars['String']>;
};

export type VsdPumpDriveOutputEnergy = {
  __typename?: 'VSDPumpDriveOutputEnergy';
  id?: Maybe<Scalars['String']>;
  observedAt?: Maybe<Scalars['Float']>;
  previousId?: Maybe<Scalars['String']>;
  timestamp?: Maybe<Scalars['Float']>;
  units?: Maybe<Scalars['String']>;
  updatePending?: Maybe<Scalars['Boolean']>;
  value?: Maybe<Scalars['Float']>;
};

export type VsdPumpDriveOutputPower = {
  __typename?: 'VSDPumpDriveOutputPower';
  id?: Maybe<Scalars['String']>;
  observedAt?: Maybe<Scalars['Float']>;
  previousId?: Maybe<Scalars['String']>;
  timestamp?: Maybe<Scalars['Float']>;
  units?: Maybe<Scalars['String']>;
  updatePending?: Maybe<Scalars['Boolean']>;
  value?: Maybe<Scalars['Float']>;
};

export type VsdPumpReturnTemperature = {
  __typename?: 'VSDPumpReturnTemperature';
  id?: Maybe<Scalars['String']>;
  observedAt?: Maybe<Scalars['Float']>;
  previousId?: Maybe<Scalars['String']>;
  timestamp?: Maybe<Scalars['Float']>;
  units?: Maybe<Scalars['String']>;
  updatePending?: Maybe<Scalars['Boolean']>;
  value?: Maybe<Scalars['Float']>;
};

export type VsdPumpStopOrStart = {
  __typename?: 'VSDPumpStopOrStart';
  id?: Maybe<Scalars['String']>;
  observedAt?: Maybe<Scalars['Float']>;
  previousId?: Maybe<Scalars['String']>;
  timestamp?: Maybe<Scalars['Float']>;
  units?: Maybe<Scalars['String']>;
  updatePending?: Maybe<Scalars['Boolean']>;
  value?: Maybe<Scalars['Float']>;
};

export type VsdPumpSupplyTemperature = {
  __typename?: 'VSDPumpSupplyTemperature';
  id?: Maybe<Scalars['String']>;
  observedAt?: Maybe<Scalars['Float']>;
  previousId?: Maybe<Scalars['String']>;
  timestamp?: Maybe<Scalars['Float']>;
  units?: Maybe<Scalars['String']>;
  updatePending?: Maybe<Scalars['Boolean']>;
  value?: Maybe<Scalars['Float']>;
};

export type VsdPumpTargetSpeed = {
  __typename?: 'VSDPumpTargetSpeed';
  id?: Maybe<Scalars['String']>;
  observedAt?: Maybe<Scalars['Float']>;
  previousId?: Maybe<Scalars['String']>;
  timestamp?: Maybe<Scalars['Float']>;
  units?: Maybe<Scalars['String']>;
  updatePending?: Maybe<Scalars['Boolean']>;
  value?: Maybe<Scalars['Float']>;
};

export type VsdPumpUpdateInput = {
  stopOrStart: Scalars['Int'];
};

export type VsdPumpUpdateOptions = {
  forcePush?: InputMaybe<Scalars['Boolean']>;
};

export type ValidationError = ErrorInterface & {
  __typename?: 'ValidationError';
  /** List of validator errors */
  errors?: Maybe<Array<ValidatorError>>;
  /** Combined error message from all validators */
  message?: Maybe<Scalars['String']>;
};

export type ValidatorError = {
  __typename?: 'ValidatorError';
  /** Input record idx in array which occurs the validation error. This `idx` is useful for createMany operation. For singular operations it always be 0. For *Many operations `idx` represents record index in array received from user. */
  idx: Scalars['Int'];
  /** Validation error message */
  message?: Maybe<Scalars['String']>;
  /** Source of the validation error from the model path */
  path?: Maybe<Scalars['String']>;
  /** Field value which occurs the validation error */
  value?: Maybe<Scalars['JSON']>;
};

export type VirtualPowerPlant = {
  __typename: 'VirtualPowerPlant';
  _id: Scalars['String'];
  chartTypes: Array<ChartType>;
  consumerBuildings: Array<Maybe<EnergyConsumerBuilding>>;
  consumerTenants: Array<Maybe<EnergyConsumerTenant>>;
  consumerUtilities: Array<Maybe<EnergyConsumerUtility>>;
  devices: Array<DeviceInterface>;
  displayName?: Maybe<Scalars['String']>;
  inverterId?: Maybe<Scalars['String']>;
  location?: Maybe<Scalars['String']>;
  modelChangeOperation?: Maybe<Scalars['String']>;
  modelType?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  operationalStatus?: Maybe<VirtualPowerPlantOperationalStatus>;
  property?: Maybe<Property>;
  propertyId?: Maybe<Scalars['String']>;
  sourceId?: Maybe<Scalars['String']>;
  storageBatterySystems: Array<Maybe<EnergyStorageBatterySystem>>;
  storageKineticSystems: Array<Maybe<EnergyStorageKineticSystem>>;
  supplierSolarSystems: Array<Maybe<EnergySupplierSolarSystem>>;
  supplierUtilities: Array<Maybe<EnergySupplierUtility>>;
  supplierWindSystems: Array<Maybe<EnergySupplierWindSystem>>;
  switchPanelId?: Maybe<Scalars['String']>;
  timestamp?: Maybe<Scalars['Float']>;
  unit?: Maybe<Unit>;
  unitId?: Maybe<Scalars['String']>;
  updateDescription?: Maybe<Scalars['JSON']>;
  updateStatus?: Maybe<Scalars['Boolean']>;
};

export type VirtualPowerPlantConsumerBuildingsArgs = {
  filter?: InputMaybe<FilterFindManyEnergyConsumerBuildingInput>;
  limit?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<SortFindManyEnergyConsumerBuildingInput>;
};

export type VirtualPowerPlantConsumerTenantsArgs = {
  filter?: InputMaybe<FilterFindManyEnergyConsumerTenantInput>;
  limit?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<SortFindManyEnergyConsumerTenantInput>;
};

export type VirtualPowerPlantConsumerUtilitiesArgs = {
  filter?: InputMaybe<FilterFindManyEnergyConsumerUtilityInput>;
  limit?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<SortFindManyEnergyConsumerUtilityInput>;
};

export type VirtualPowerPlantDevicesArgs = {
  filter?: InputMaybe<FilterFindManyDeviceInput>;
  limit?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<SortFindManyDeviceInput>;
};

export type VirtualPowerPlantStorageBatterySystemsArgs = {
  filter?: InputMaybe<FilterFindManyEnergyStorageBatterySystemInput>;
  limit?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<SortFindManyEnergyStorageBatterySystemInput>;
};

export type VirtualPowerPlantStorageKineticSystemsArgs = {
  filter?: InputMaybe<FilterFindManyEnergyStorageKineticSystemInput>;
  limit?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<SortFindManyEnergyStorageKineticSystemInput>;
};

export type VirtualPowerPlantSupplierSolarSystemsArgs = {
  filter?: InputMaybe<FilterFindManyEnergySupplierSolarSystemInput>;
  limit?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<SortFindManyEnergySupplierSolarSystemInput>;
};

export type VirtualPowerPlantSupplierUtilitiesArgs = {
  filter?: InputMaybe<FilterFindManyEnergySupplierUtilityInput>;
  limit?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<SortFindManyEnergySupplierUtilityInput>;
};

export type VirtualPowerPlantSupplierWindSystemsArgs = {
  filter?: InputMaybe<FilterFindManyEnergySupplierWindSystemInput>;
  limit?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<SortFindManyEnergySupplierWindSystemInput>;
};

export type VirtualPowerPlantOperationalStatus = {
  __typename?: 'VirtualPowerPlantOperationalStatus';
  id?: Maybe<Scalars['String']>;
  observedAt?: Maybe<Scalars['Float']>;
  previousId?: Maybe<Scalars['String']>;
  timestamp?: Maybe<Scalars['Float']>;
  units?: Maybe<Scalars['String']>;
  updatePending?: Maybe<Scalars['Boolean']>;
  value?: Maybe<EnumVirtualPowerPlantOperationalStatusValue>;
};

/** List of items with pagination. */
export type VirtualPowerPlantPaginatedVirtualPowerPlants = {
  __typename?: 'VirtualPowerPlantPaginatedVirtualPowerPlants';
  /** Total object count. */
  count?: Maybe<Scalars['Int']>;
  /** Array of objects. */
  items?: Maybe<Array<VirtualPowerPlant>>;
  /** Information to aid in pagination. */
  pageInfo: PaginationInfo;
};

export type WindManagementSystem = DeviceInterface & {
  __typename: 'WindManagementSystem';
  _id: Scalars['String'];
  alertTypes?: Maybe<DeviceAlertTypes>;
  bladeCondition?: Maybe<WindManagementSystemBladeCondition>;
  brakeStatus?: Maybe<WindManagementSystemBrakeStatus>;
  chartTypes: Array<ChartType>;
  controlled?: Maybe<DeviceControlled>;
  dependentDeviceIds: Array<Maybe<Scalars['String']>>;
  deviceAlerts: Array<Maybe<Alert>>;
  deviceId?: Maybe<Scalars['String']>;
  deviceIdentifier?: Maybe<Scalars['String']>;
  deviceMetrics?: Maybe<Array<Maybe<DeviceMetric>>>;
  displayName?: Maybe<Scalars['String']>;
  generatorTemperature?: Maybe<WindManagementSystemGeneratorTemperature>;
  hasPendingUpdates: Scalars['Boolean'];
  iceDetectionStatus?: Maybe<WindManagementSystemIceDetectionStatus>;
  installation?: Maybe<DeviceInstallation>;
  isConfigured?: Maybe<Scalars['Boolean']>;
  isControlled: Scalars['Boolean'];
  isPoweredOn?: Maybe<Scalars['Boolean']>;
  location?: Maybe<Scalars['String']>;
  meta?: Maybe<DeviceMeta>;
  modelChangeOperation?: Maybe<Scalars['String']>;
  modelType?: Maybe<Scalars['String']>;
  /** The name of the device */
  name?: Maybe<Scalars['String']>;
  panel?: Maybe<Panel>;
  panelId?: Maybe<Scalars['String']>;
  pitchAngle?: Maybe<WindManagementSystemPitchAngle>;
  powerState?: Maybe<DevicePowerState>;
  property?: Maybe<Property>;
  propertyId: Scalars['String'];
  rotorSpeed?: Maybe<WindManagementSystemRotorSpeed>;
  source?: Maybe<Source>;
  sourceAlerts: Array<Maybe<Alert>>;
  sourceId?: Maybe<Scalars['String']>;
  timestamp?: Maybe<Scalars['Float']>;
  type?: Maybe<EnumDKeyDeviceType>;
  typeDisplayName: Scalars['String'];
  unit?: Maybe<Unit>;
  unitId: Scalars['String'];
  updateDescription?: Maybe<Scalars['JSON']>;
  updateStatus?: Maybe<Scalars['Boolean']>;
  vibrationLevel?: Maybe<WindManagementSystemVibrationLevel>;
  vpp?: Maybe<VirtualPowerPlant>;
  vppId?: Maybe<Scalars['String']>;
  windDirection?: Maybe<WindManagementSystemWindDirection>;
  windSpeed?: Maybe<WindManagementSystemWindSpeed>;
  yawControlStatus?: Maybe<WindManagementSystemYawControlStatus>;
  zone?: Maybe<Zone>;
  zoneId?: Maybe<Scalars['String']>;
};

export type WindManagementSystemDeviceAlertsArgs = {
  filter?: InputMaybe<FilterFindManyAlertInput>;
  limit?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<SortFindManyAlertInput>;
};

export type WindManagementSystemSourceAlertsArgs = {
  filter?: InputMaybe<FilterFindManyAlertInput>;
  limit?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<SortFindManyAlertInput>;
};

export type WindManagementSystemBladeCondition = {
  __typename?: 'WindManagementSystemBladeCondition';
  id?: Maybe<Scalars['String']>;
  observedAt?: Maybe<Scalars['Float']>;
  previousId?: Maybe<Scalars['String']>;
  timestamp?: Maybe<Scalars['Float']>;
  units?: Maybe<Scalars['String']>;
  updatePending?: Maybe<Scalars['Boolean']>;
  value?: Maybe<EnumWindManagementSystemBladeConditionValue>;
};

export type WindManagementSystemBrakeStatus = {
  __typename?: 'WindManagementSystemBrakeStatus';
  id?: Maybe<Scalars['String']>;
  observedAt?: Maybe<Scalars['Float']>;
  previousId?: Maybe<Scalars['String']>;
  timestamp?: Maybe<Scalars['Float']>;
  units?: Maybe<Scalars['String']>;
  updatePending?: Maybe<Scalars['Boolean']>;
  value?: Maybe<EnumWindManagementSystemBrakeStatusValue>;
};

export type WindManagementSystemGeneratorTemperature = {
  __typename?: 'WindManagementSystemGeneratorTemperature';
  id?: Maybe<Scalars['String']>;
  observedAt?: Maybe<Scalars['Float']>;
  previousId?: Maybe<Scalars['String']>;
  timestamp?: Maybe<Scalars['Float']>;
  units?: Maybe<Scalars['String']>;
  updatePending?: Maybe<Scalars['Boolean']>;
  value?: Maybe<Scalars['Float']>;
};

export type WindManagementSystemIceDetectionStatus = {
  __typename?: 'WindManagementSystemIceDetectionStatus';
  id?: Maybe<Scalars['String']>;
  observedAt?: Maybe<Scalars['Float']>;
  previousId?: Maybe<Scalars['String']>;
  timestamp?: Maybe<Scalars['Float']>;
  units?: Maybe<Scalars['String']>;
  updatePending?: Maybe<Scalars['Boolean']>;
  value?: Maybe<EnumWindManagementSystemIceDetectionStatusValue>;
};

export type WindManagementSystemPitchAngle = {
  __typename?: 'WindManagementSystemPitchAngle';
  id?: Maybe<Scalars['String']>;
  observedAt?: Maybe<Scalars['Float']>;
  previousId?: Maybe<Scalars['String']>;
  timestamp?: Maybe<Scalars['Float']>;
  units?: Maybe<Scalars['String']>;
  updatePending?: Maybe<Scalars['Boolean']>;
  value?: Maybe<Scalars['Float']>;
};

export type WindManagementSystemRotorSpeed = {
  __typename?: 'WindManagementSystemRotorSpeed';
  id?: Maybe<Scalars['String']>;
  observedAt?: Maybe<Scalars['Float']>;
  previousId?: Maybe<Scalars['String']>;
  timestamp?: Maybe<Scalars['Float']>;
  units?: Maybe<Scalars['String']>;
  updatePending?: Maybe<Scalars['Boolean']>;
  value?: Maybe<Scalars['Float']>;
};

export type WindManagementSystemVibrationLevel = {
  __typename?: 'WindManagementSystemVibrationLevel';
  id?: Maybe<Scalars['String']>;
  observedAt?: Maybe<Scalars['Float']>;
  previousId?: Maybe<Scalars['String']>;
  timestamp?: Maybe<Scalars['Float']>;
  units?: Maybe<Scalars['String']>;
  updatePending?: Maybe<Scalars['Boolean']>;
  value?: Maybe<Scalars['Float']>;
};

export type WindManagementSystemWindDirection = {
  __typename?: 'WindManagementSystemWindDirection';
  id?: Maybe<Scalars['String']>;
  observedAt?: Maybe<Scalars['Float']>;
  previousId?: Maybe<Scalars['String']>;
  timestamp?: Maybe<Scalars['Float']>;
  units?: Maybe<Scalars['String']>;
  updatePending?: Maybe<Scalars['Boolean']>;
  value?: Maybe<Scalars['Float']>;
};

export type WindManagementSystemWindSpeed = {
  __typename?: 'WindManagementSystemWindSpeed';
  id?: Maybe<Scalars['String']>;
  observedAt?: Maybe<Scalars['Float']>;
  previousId?: Maybe<Scalars['String']>;
  timestamp?: Maybe<Scalars['Float']>;
  units?: Maybe<Scalars['String']>;
  updatePending?: Maybe<Scalars['Boolean']>;
  value?: Maybe<Scalars['Float']>;
};

export type WindManagementSystemYawControlStatus = {
  __typename?: 'WindManagementSystemYawControlStatus';
  id?: Maybe<Scalars['String']>;
  observedAt?: Maybe<Scalars['Float']>;
  previousId?: Maybe<Scalars['String']>;
  timestamp?: Maybe<Scalars['Float']>;
  units?: Maybe<Scalars['String']>;
  updatePending?: Maybe<Scalars['Boolean']>;
  value?: Maybe<EnumWindManagementSystemYawControlStatusValue>;
};

export type WindowSensor = DeviceInterface & {
  __typename: 'WindowSensor';
  _id: Scalars['String'];
  alertTypes?: Maybe<DeviceAlertTypes>;
  chartTypes: Array<ChartType>;
  contactState?: Maybe<WindowSensorContactState>;
  controlled?: Maybe<DeviceControlled>;
  dependentDeviceIds: Array<Maybe<Scalars['String']>>;
  deviceAlerts: Array<Maybe<Alert>>;
  deviceId?: Maybe<Scalars['String']>;
  deviceIdentifier?: Maybe<Scalars['String']>;
  deviceMetrics?: Maybe<Array<Maybe<DeviceMetric>>>;
  displayName?: Maybe<Scalars['String']>;
  hasContactState?: Maybe<Scalars['Boolean']>;
  hasPendingUpdates: Scalars['Boolean'];
  installation?: Maybe<DeviceInstallation>;
  isConfigured?: Maybe<Scalars['Boolean']>;
  isControlled: Scalars['Boolean'];
  isPoweredOn?: Maybe<Scalars['Boolean']>;
  location?: Maybe<Scalars['String']>;
  meta?: Maybe<DeviceMeta>;
  modelChangeOperation?: Maybe<Scalars['String']>;
  modelType?: Maybe<Scalars['String']>;
  /** The name of the device */
  name?: Maybe<Scalars['String']>;
  panel?: Maybe<Panel>;
  panelId?: Maybe<Scalars['String']>;
  powerState?: Maybe<DevicePowerState>;
  property?: Maybe<Property>;
  propertyId: Scalars['String'];
  source?: Maybe<Source>;
  sourceAlerts: Array<Maybe<Alert>>;
  sourceId?: Maybe<Scalars['String']>;
  timestamp?: Maybe<Scalars['Float']>;
  type?: Maybe<EnumDKeyDeviceType>;
  typeDisplayName: Scalars['String'];
  unit?: Maybe<Unit>;
  unitId: Scalars['String'];
  updateDescription?: Maybe<Scalars['JSON']>;
  updateStatus?: Maybe<Scalars['Boolean']>;
  voltage?: Maybe<WindowSensorVoltage>;
  vpp?: Maybe<VirtualPowerPlant>;
  vppId?: Maybe<Scalars['String']>;
  zone?: Maybe<Zone>;
  zoneId?: Maybe<Scalars['String']>;
};

export type WindowSensorDeviceAlertsArgs = {
  filter?: InputMaybe<FilterFindManyAlertInput>;
  limit?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<SortFindManyAlertInput>;
};

export type WindowSensorSourceAlertsArgs = {
  filter?: InputMaybe<FilterFindManyAlertInput>;
  limit?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<SortFindManyAlertInput>;
};

export type WindowSensorContactState = {
  __typename?: 'WindowSensorContactState';
  id?: Maybe<Scalars['String']>;
  observedAt?: Maybe<Scalars['Float']>;
  previousId?: Maybe<Scalars['String']>;
  timestamp?: Maybe<Scalars['Float']>;
  units?: Maybe<Scalars['String']>;
  updatePending?: Maybe<Scalars['Boolean']>;
  value?: Maybe<Scalars['String']>;
};

export type WindowSensorVoltage = {
  __typename?: 'WindowSensorVoltage';
  id?: Maybe<Scalars['String']>;
  observedAt?: Maybe<Scalars['Float']>;
  previousId?: Maybe<Scalars['String']>;
  timestamp?: Maybe<Scalars['Float']>;
  units?: Maybe<Scalars['String']>;
  updatePending?: Maybe<Scalars['Boolean']>;
  value?: Maybe<Scalars['Float']>;
};

export type Z210Pump = DeviceInterface & {
  __typename: 'Z210Pump';
  _id: Scalars['String'];
  activePump?: Maybe<Z210PumpActivePump>;
  alertTypes?: Maybe<DeviceAlertTypes>;
  chartTypes: Array<ChartType>;
  controlled?: Maybe<DeviceControlled>;
  currentSpeed?: Maybe<Z210PumpCurrentSpeed>;
  dependentDeviceIds: Array<Maybe<Scalars['String']>>;
  deviceAlerts: Array<Maybe<Alert>>;
  deviceId?: Maybe<Scalars['String']>;
  deviceIdentifier?: Maybe<Scalars['String']>;
  deviceMetrics?: Maybe<Array<Maybe<DeviceMetric>>>;
  displayName?: Maybe<Scalars['String']>;
  hasActivePump?: Maybe<Scalars['Boolean']>;
  hasAutoSwitchoverPeriod?: Maybe<Scalars['Boolean']>;
  hasCurrentSpeed?: Maybe<Scalars['Boolean']>;
  hasOverride?: Maybe<Scalars['Boolean']>;
  hasPendingUpdates: Scalars['Boolean'];
  hasTargetSpeed?: Maybe<Scalars['Boolean']>;
  installation?: Maybe<DeviceInstallation>;
  isConfigured?: Maybe<Scalars['Boolean']>;
  isControlled: Scalars['Boolean'];
  isPoweredOn?: Maybe<Scalars['Boolean']>;
  location?: Maybe<Scalars['String']>;
  meta?: Maybe<DeviceMeta>;
  modelChangeOperation?: Maybe<Scalars['String']>;
  modelType?: Maybe<Scalars['String']>;
  /** The name of the device */
  name?: Maybe<Scalars['String']>;
  panel?: Maybe<Panel>;
  panelId?: Maybe<Scalars['String']>;
  powerState?: Maybe<DevicePowerState>;
  property?: Maybe<Property>;
  propertyId: Scalars['String'];
  role?: Maybe<Scalars['String']>;
  source?: Maybe<Source>;
  sourceAlerts: Array<Maybe<Alert>>;
  sourceId?: Maybe<Scalars['String']>;
  targetSpeed?: Maybe<Z210PumpTargetSpeed>;
  timestamp?: Maybe<Scalars['Float']>;
  type?: Maybe<EnumDKeyDeviceType>;
  typeDisplayName: Scalars['String'];
  unit?: Maybe<Unit>;
  unitId: Scalars['String'];
  updateDescription?: Maybe<Scalars['JSON']>;
  updateStatus?: Maybe<Scalars['Boolean']>;
  vpp?: Maybe<VirtualPowerPlant>;
  vppId?: Maybe<Scalars['String']>;
  zone?: Maybe<Zone>;
  zoneId?: Maybe<Scalars['String']>;
};

export type Z210PumpDeviceAlertsArgs = {
  filter?: InputMaybe<FilterFindManyAlertInput>;
  limit?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<SortFindManyAlertInput>;
};

export type Z210PumpSourceAlertsArgs = {
  filter?: InputMaybe<FilterFindManyAlertInput>;
  limit?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<SortFindManyAlertInput>;
};

export type Z210PumpActivePump = {
  __typename?: 'Z210PumpActivePump';
  id?: Maybe<Scalars['String']>;
  previousId?: Maybe<Scalars['String']>;
  timestamp?: Maybe<Scalars['Float']>;
  units?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['Float']>;
};

export type Z210PumpCurrentSpeed = {
  __typename?: 'Z210PumpCurrentSpeed';
  id?: Maybe<Scalars['String']>;
  observedAt?: Maybe<Scalars['Float']>;
  previousId?: Maybe<Scalars['String']>;
  timestamp?: Maybe<Scalars['Float']>;
  units?: Maybe<Scalars['String']>;
  updatePending?: Maybe<Scalars['Boolean']>;
  value?: Maybe<Scalars['Float']>;
};

export type Z210PumpTargetSpeed = {
  __typename?: 'Z210PumpTargetSpeed';
  id?: Maybe<Scalars['String']>;
  observedAt?: Maybe<Scalars['Float']>;
  previousId?: Maybe<Scalars['String']>;
  timestamp?: Maybe<Scalars['Float']>;
  units?: Maybe<Scalars['String']>;
  updatePending?: Maybe<Scalars['Boolean']>;
  value?: Maybe<Scalars['Float']>;
};

export type Zone = {
  __typename: 'Zone';
  _id: Scalars['String'];
  airHandlerId?: Maybe<Scalars['String']>;
  alerts?: Maybe<Array<Alert>>;
  bngSource?: Maybe<Source>;
  bngSourceId?: Maybe<Scalars['String']>;
  controller?: Maybe<Scalars['String']>;
  devices: Array<DeviceInterface>;
  displayName?: Maybe<Scalars['String']>;
  hasPairedSensor?: Maybe<Scalars['Boolean']>;
  modelChangeOperation?: Maybe<Scalars['String']>;
  modelType?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  pairedSensor?: Maybe<IndoorSensor>;
  pairedSensorId?: Maybe<Scalars['String']>;
  property?: Maybe<Property>;
  propertyId?: Maybe<Scalars['String']>;
  role?: Maybe<Scalars['String']>;
  source?: Maybe<Source>;
  sourceId?: Maybe<Scalars['String']>;
  thermostat?: Maybe<Thermostat>;
  thermostatId?: Maybe<Scalars['String']>;
  unit?: Maybe<Unit>;
  unitId: Scalars['String'];
  updateDescription?: Maybe<Scalars['JSON']>;
  zonePolicy?: Maybe<ZonePolicy>;
  zonePolicyId?: Maybe<Scalars['String']>;
};

export type ZoneDevicesArgs = {
  filter?: InputMaybe<FilterFindManyDeviceInput>;
  limit?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<SortFindManyDeviceInput>;
};

/** List of items with pagination. */
export type ZonePaginatedZones = {
  __typename?: 'ZonePaginatedZones';
  /** Total object count. */
  count?: Maybe<Scalars['Int']>;
  /** Array of objects. */
  items?: Maybe<Array<Zone>>;
  /** Information to aid in pagination. */
  pageInfo: PaginationInfo;
};

export type ZonePolicy = {
  __typename: 'ZonePolicy';
  _id: Scalars['MongoID'];
  assignedProperties: Array<Maybe<Property>>;
  assignedUnits: Array<Maybe<Unit>>;
  enabledProperties: Array<Maybe<Property>>;
  modelChangeOperation?: Maybe<Scalars['String']>;
  modelType?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  properties?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** Array of Property entities associated with this zone policy (same IDs as the scalar "properties" field). */
  propertyRefs: Array<Maybe<Property>>;
  rules?: Maybe<Array<Maybe<ZonePolicyRules>>>;
  updateDescription?: Maybe<Scalars['JSON']>;
  zones?: Maybe<Array<Zone>>;
};

export type ZonePolicyAssignedPropertiesArgs = {
  filter?: InputMaybe<FilterFindManyPropertyInput>;
  limit?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<SortFindManyPropertyInput>;
};

export type ZonePolicyAssignedUnitsArgs = {
  filter?: InputMaybe<FilterFindManyUnitInput>;
  limit?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<SortFindManyUnitInput>;
};

export type ZonePolicyZonesArgs = {
  propertyId: Scalars['String'];
};

/** List of items with pagination. */
export type ZonePolicyPaginatedZonePolicies = {
  __typename?: 'ZonePolicyPaginatedZonePolicies';
  /** Total object count. */
  count?: Maybe<Scalars['Int']>;
  /** Array of objects. */
  items?: Maybe<Array<ZonePolicy>>;
  /** Information to aid in pagination. */
  pageInfo: PaginationInfo;
};

export type ZonePolicyRules = {
  __typename?: 'ZonePolicyRules';
  source?: Maybe<ZonePolicyRulesSource>;
  target?: Maybe<ZonePolicyRulesTarget>;
  type: EnumZonePolicyRulesType;
};

export type ZonePolicyRulesInput = {
  source?: InputMaybe<ZonePolicyRulesSourceInput>;
  target?: InputMaybe<ZonePolicyRulesTargetInput>;
  type: EnumZonePolicyRulesType;
};

export type ZonePolicyRulesSource = {
  __typename?: 'ZonePolicyRulesSource';
  attributes?: Maybe<ZonePolicyRulesSourceAttributes>;
  deviceType: Scalars['String'];
  multiplicity?: Maybe<EnumZonePolicyRulesSourceMultiplicity>;
};

export type ZonePolicyRulesSourceAttributes = {
  __typename?: 'ZonePolicyRulesSourceAttributes';
  contactState?: Maybe<Scalars['String']>;
  coolSetpoint?: Maybe<Scalars['String']>;
  fanSpeed?: Maybe<Scalars['String']>;
  heatSetpoint?: Maybe<Scalars['String']>;
  indoorFanStatus?: Maybe<Scalars['String']>;
  keypadLockoutLevel?: Maybe<Scalars['String']>;
  operatingMode?: Maybe<Scalars['String']>;
  operatingState?: Maybe<Scalars['String']>;
};

export type ZonePolicyRulesSourceAttributesInput = {
  contactState?: InputMaybe<Scalars['String']>;
  coolSetpoint?: InputMaybe<Scalars['String']>;
  fanSpeed?: InputMaybe<Scalars['String']>;
  heatSetpoint?: InputMaybe<Scalars['String']>;
  indoorFanStatus?: InputMaybe<Scalars['String']>;
  keypadLockoutLevel?: InputMaybe<Scalars['String']>;
  operatingMode?: InputMaybe<Scalars['String']>;
  operatingState?: InputMaybe<Scalars['String']>;
};

export type ZonePolicyRulesSourceInput = {
  attributes?: InputMaybe<ZonePolicyRulesSourceAttributesInput>;
  deviceType: Scalars['String'];
  multiplicity?: InputMaybe<EnumZonePolicyRulesSourceMultiplicity>;
};

export type ZonePolicyRulesTarget = {
  __typename?: 'ZonePolicyRulesTarget';
  attributes?: Maybe<ZonePolicyRulesTargetAttributes>;
  deviceType: Scalars['String'];
  multiplicity?: Maybe<EnumZonePolicyRulesTargetMultiplicity>;
};

export type ZonePolicyRulesTargetAttributes = {
  __typename?: 'ZonePolicyRulesTargetAttributes';
  coolSetpoint?: Maybe<Scalars['String']>;
  heatSetpoint?: Maybe<Scalars['String']>;
  isOn?: Maybe<Scalars['String']>;
  keypadLockoutLevel?: Maybe<Scalars['String']>;
  relayState?: Maybe<Scalars['String']>;
};

export type ZonePolicyRulesTargetAttributesInput = {
  coolSetpoint?: InputMaybe<Scalars['String']>;
  heatSetpoint?: InputMaybe<Scalars['String']>;
  isOn?: InputMaybe<Scalars['String']>;
  keypadLockoutLevel?: InputMaybe<Scalars['String']>;
  relayState?: InputMaybe<Scalars['String']>;
};

export type ZonePolicyRulesTargetInput = {
  attributes?: InputMaybe<ZonePolicyRulesTargetAttributesInput>;
  deviceType: Scalars['String'];
  multiplicity?: InputMaybe<EnumZonePolicyRulesTargetMultiplicity>;
};

/** Represents metrics related to a given zone policy. */
export type ZonePolicyUpdateVerificationData = {
  __typename?: 'ZonePolicyUpdateVerificationData';
  /** Zone Policy ID. */
  _id?: Maybe<Scalars['String']>;
  /** Number of zones in the specified selection set that are currently excluded (use a custom zone policy). */
  excludedZones?: Maybe<Scalars['Float']>;
  /** Zone Policy Name. */
  name?: Maybe<Scalars['String']>;
  /** Number of zones in the specified selection set whose source is currently online. */
  onlineZones?: Maybe<Scalars['Float']>;
  /** Total number of zones in the (possibly filtered) selection set that could be affected by changes to this zone policy. */
  totalZones?: Maybe<Scalars['Float']>;
};

export type FilteralertNotificationByAlertId = {
  _id: Scalars['String'];
  alertId: Scalars['String'];
  deliveryAttemptCount: Scalars['Float'];
  externalId?: InputMaybe<Scalars['String']>;
  lastDeliveryAttemptStatus: EnumAlertNotificationLastDeliveryAttemptStatus;
  lastDeliveryAttemptTimestamp?: InputMaybe<Scalars['Float']>;
  notificationMethod: EnumAlertNotificationNotificationMethod;
  notificationType: EnumAlertNotificationNotificationType;
  recipient: Scalars['String'];
  timestamp: Scalars['Float'];
};

export type FilteralertNotificationByRecipient = {
  _id: Scalars['String'];
  alertId: Scalars['String'];
  deliveryAttemptCount: Scalars['Float'];
  externalId?: InputMaybe<Scalars['String']>;
  lastDeliveryAttemptStatus: EnumAlertNotificationLastDeliveryAttemptStatus;
  lastDeliveryAttemptTimestamp?: InputMaybe<Scalars['Float']>;
  notificationMethod: EnumAlertNotificationNotificationMethod;
  notificationType: EnumAlertNotificationNotificationType;
  recipient: Scalars['String'];
  timestamp: Scalars['Float'];
};

export type FilteralertOptOutsByRecipient = {
  _id: Scalars['String'];
  optOutMethod: EnumAlertOptOutOptOutMethod;
  optOutTimestamp: Scalars['Float'];
  recipient: Scalars['String'];
};

export type FilteralertSubscriptionsByUserId = {
  _id: Scalars['String'];
  alertTriggerId: Scalars['String'];
  deviceId?: InputMaybe<Scalars['String']>;
  email?: InputMaybe<Scalars['String']>;
  propertyId?: InputMaybe<Scalars['String']>;
  sms?: InputMaybe<Scalars['String']>;
  unitCategoryId?: InputMaybe<Scalars['String']>;
  unitId?: InputMaybe<Scalars['String']>;
  userId?: InputMaybe<Scalars['String']>;
  viaEmail?: InputMaybe<Scalars['Boolean']>;
  viaSms?: InputMaybe<Scalars['Boolean']>;
};

export type FilteralertsByPropertyId = {
  _id?: InputMaybe<Scalars['String']>;
  alertCategory?: InputMaybe<AlertAlertCategoryInput>;
  alertTrigger?: InputMaybe<AlertAlertTriggerInput>;
  building?: InputMaybe<AlertBuildingInput>;
  device?: InputMaybe<AlertDeviceInput>;
  id?: InputMaybe<Scalars['String']>;
  initiated?: InputMaybe<Scalars['Float']>;
  meta?: InputMaybe<AlertMetaInput>;
  panel?: InputMaybe<AlertPanelInput>;
  property?: InputMaybe<AlertPropertyInput>;
  propertyId?: InputMaybe<Scalars['String']>;
  propertyIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  sourceId?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<AlertTypeInput>;
  unit?: InputMaybe<AlertUnitInput>;
  updated?: InputMaybe<Scalars['Float']>;
  zone?: InputMaybe<AlertZoneInput>;
};

export type FilteralertsByUnitId = {
  _id?: InputMaybe<Scalars['String']>;
  alertCategory?: InputMaybe<AlertAlertCategoryInput>;
  alertTrigger?: InputMaybe<AlertAlertTriggerInput>;
  building?: InputMaybe<AlertBuildingInput>;
  device?: InputMaybe<AlertDeviceInput>;
  id?: InputMaybe<Scalars['String']>;
  initiated?: InputMaybe<Scalars['Float']>;
  meta?: InputMaybe<AlertMetaInput>;
  panel?: InputMaybe<AlertPanelInput>;
  property?: InputMaybe<AlertPropertyInput>;
  sourceId?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<AlertTypeInput>;
  unit?: InputMaybe<AlertUnitInput>;
  updated?: InputMaybe<Scalars['Float']>;
  zone?: InputMaybe<AlertZoneInput>;
};

export type FilterbuildingsByPropertyId = {
  _id: Scalars['String'];
  name: Scalars['String'];
  number?: InputMaybe<Scalars['Float']>;
  propertyId: Scalars['String'];
};

export type FilterplmCurtailmentTasksByActionId = {
  _id?: InputMaybe<Scalars['String']>;
  batchId: Scalars['Float'];
  cachedDeviceState: PlmCurtailmentTaskCachedDeviceStateInput;
  deviceId: Scalars['String'];
  deviceType: Scalars['String'];
  endedAt?: InputMaybe<Scalars['Float']>;
  estimatedReductionKW?: InputMaybe<Scalars['Float']>;
  plmCurtailmentActionId: Scalars['String'];
  plmEventResponseId: Scalars['String'];
  propertyId: Scalars['String'];
  resolvedTargetedAdjustments?: InputMaybe<PlmCurtailmentTaskCachedDeviceStateInput>;
  scheduledEnd: Scalars['Float'];
  scheduledStart: Scalars['Float'];
  startedAt?: InputMaybe<Scalars['Float']>;
  status: EnumPlmCurtailmentTaskStatus;
  statusMessage?: InputMaybe<Scalars['String']>;
  targetedAdjustments: PlmCurtailmentTaskCachedDeviceStateInput;
  unitId: Scalars['String'];
  updateRetryCount?: InputMaybe<Scalars['Float']>;
  verifiedAt?: InputMaybe<Scalars['Float']>;
  verifyAttempts?: InputMaybe<Scalars['Float']>;
};

export type FilterplmCurtailmentTasksByPropertyId = {
  _id?: InputMaybe<Scalars['String']>;
  batchId: Scalars['Float'];
  cachedDeviceState: PlmCurtailmentTaskCachedDeviceStateInput;
  deviceId: Scalars['String'];
  deviceType: Scalars['String'];
  endedAt?: InputMaybe<Scalars['Float']>;
  estimatedReductionKW?: InputMaybe<Scalars['Float']>;
  plmCurtailmentActionId: Scalars['String'];
  plmEventResponseId: Scalars['String'];
  propertyId: Scalars['String'];
  resolvedTargetedAdjustments?: InputMaybe<PlmCurtailmentTaskCachedDeviceStateInput>;
  scheduledEnd: Scalars['Float'];
  scheduledStart: Scalars['Float'];
  startedAt?: InputMaybe<Scalars['Float']>;
  status: EnumPlmCurtailmentTaskStatus;
  statusMessage?: InputMaybe<Scalars['String']>;
  targetedAdjustments: PlmCurtailmentTaskCachedDeviceStateInput;
  unitId: Scalars['String'];
  updateRetryCount?: InputMaybe<Scalars['Float']>;
  verifiedAt?: InputMaybe<Scalars['Float']>;
  verifyAttempts?: InputMaybe<Scalars['Float']>;
};

export type FilterplmCurtailmentTasksByResponseId = {
  _id?: InputMaybe<Scalars['String']>;
  batchId: Scalars['Float'];
  cachedDeviceState: PlmCurtailmentTaskCachedDeviceStateInput;
  deviceId: Scalars['String'];
  deviceType: Scalars['String'];
  endedAt?: InputMaybe<Scalars['Float']>;
  estimatedReductionKW?: InputMaybe<Scalars['Float']>;
  plmCurtailmentActionId: Scalars['String'];
  plmEventResponseId: Scalars['String'];
  propertyId: Scalars['String'];
  resolvedTargetedAdjustments?: InputMaybe<PlmCurtailmentTaskCachedDeviceStateInput>;
  scheduledEnd: Scalars['Float'];
  scheduledStart: Scalars['Float'];
  startedAt?: InputMaybe<Scalars['Float']>;
  status: EnumPlmCurtailmentTaskStatus;
  statusMessage?: InputMaybe<Scalars['String']>;
  targetedAdjustments: PlmCurtailmentTaskCachedDeviceStateInput;
  unitId: Scalars['String'];
  updateRetryCount?: InputMaybe<Scalars['Float']>;
  verifiedAt?: InputMaybe<Scalars['Float']>;
  verifyAttempts?: InputMaybe<Scalars['Float']>;
};

export type AlertsManagerAlertUpdateSubscriptionVariables = Exact<{
  [key: string]: never;
}>;

export type AlertsManagerAlertUpdateSubscription = {
  __typename?: 'Subscription';
  alertEvents?: {
    __typename?: 'Alert';
    modelChangeOperation?: string | null;
    _id: string;
    id?: string | null;
    initiated?: number | null;
    modelType?: string | null;
    severity?: string | null;
    sourceId?: string | null;
    alertCategory?: {
      __typename?: 'AlertCategory';
      _id: string;
      key: string;
      modelType?: string | null;
      name?: string | null;
    } | null;
    alertTrigger?: {
      __typename?: 'AlertTrigger';
      _id: string;
      name: string;
    } | null;
    building?: {
      __typename?: 'AlertBuilding';
      id?: string | null;
      name?: string | null;
    } | null;
    device?: {
      __typename?: 'AlertDevice';
      id: string;
      name?: string | null;
      type: string;
    } | null;
    meta?: {
      __typename?: 'AlertMeta';
      id_str?: string | null;
      limit?: number | null;
      message?: string | null;
      portName?: string | null;
      type?: string | null;
      value?: string | null;
    } | null;
    panel?: {
      __typename?: 'AlertPanel';
      id?: string | null;
      name?: string | null;
    } | null;
    property?: {
      __typename?: 'AlertProperty';
      id?: string | null;
      name?: string | null;
    } | null;
    type?: {
      __typename?: 'AlertType';
      id?: string | null;
      name?: string | null;
    } | null;
    unit?: {
      __typename?: 'AlertUnit';
      id?: string | null;
      name?: string | null;
    } | null;
    zone?: {
      __typename?: 'AlertZone';
      id?: string | null;
      name?: string | null;
    } | null;
  } | null;
};

export type AlertsManagerDeviceUpdateSubscriptionVariables = Exact<{
  [key: string]: never;
}>;

export type AlertsManagerDeviceUpdateSubscription = {
  __typename?: 'Subscription';
  deviceEvents?: {
    __typename?: 'Device';
    modelChangeOperation?: string | null;
    _id: string;
    deviceId?: string | null;
    unitId: string;
    propertyId: string;
    sourceId?: string | null;
  } | null;
};

export type AlertsManagerAlertsQueryVariables = Exact<{ [key: string]: never }>;

export type AlertsManagerAlertsQuery = {
  __typename?: 'Query';
  alerts: Array<{
    __typename?: 'Alert';
    _id: string;
    id?: string | null;
    initiated?: number | null;
    updated?: number | null;
    modelType?: string | null;
    severity?: string | null;
    sourceId?: string | null;
    alertCategory?: {
      __typename?: 'AlertCategory';
      _id: string;
      key: string;
      modelType?: string | null;
      name?: string | null;
    } | null;
    alertTrigger?: {
      __typename?: 'AlertTrigger';
      _id: string;
      name: string;
    } | null;
    building?: {
      __typename?: 'AlertBuilding';
      id?: string | null;
      name?: string | null;
    } | null;
    device?: {
      __typename?: 'AlertDevice';
      id: string;
      name?: string | null;
      type: string;
    } | null;
    meta?: {
      __typename?: 'AlertMeta';
      id_str?: string | null;
      limit?: number | null;
      message?: string | null;
      portName?: string | null;
      type?: string | null;
      value?: string | null;
    } | null;
    panel?: {
      __typename?: 'AlertPanel';
      id?: string | null;
      name?: string | null;
    } | null;
    property?: {
      __typename?: 'AlertProperty';
      id?: string | null;
      name?: string | null;
    } | null;
    type?: {
      __typename?: 'AlertType';
      id?: string | null;
      name?: string | null;
    } | null;
    unit?: {
      __typename?: 'AlertUnit';
      id?: string | null;
      name?: string | null;
    } | null;
    zone?: {
      __typename?: 'AlertZone';
      id?: string | null;
      name?: string | null;
    } | null;
  }>;
};

export type AlertsManagerDevicesQueryVariables = Exact<{
  [key: string]: never;
}>;

export type AlertsManagerDevicesQuery = {
  __typename?: 'Query';
  devices: Array<
    | {
        __typename?: 'Actuator';
        _id: string;
        deviceId?: string | null;
        unitId: string;
        propertyId: string;
        sourceId?: string | null;
      }
    | {
        __typename?: 'BatteryManagementSystem';
        _id: string;
        deviceId?: string | null;
        unitId: string;
        propertyId: string;
        sourceId?: string | null;
      }
    | {
        __typename?: 'Boiler';
        _id: string;
        deviceId?: string | null;
        unitId: string;
        propertyId: string;
        sourceId?: string | null;
      }
    | {
        __typename?: 'Chiller';
        _id: string;
        deviceId?: string | null;
        unitId: string;
        propertyId: string;
        sourceId?: string | null;
      }
    | {
        __typename?: 'ConductorGenericSensor';
        _id: string;
        deviceId?: string | null;
        unitId: string;
        propertyId: string;
        sourceId?: string | null;
      }
    | {
        __typename?: 'Controller';
        _id: string;
        deviceId?: string | null;
        unitId: string;
        propertyId: string;
        sourceId?: string | null;
      }
    | {
        __typename?: 'Device';
        _id: string;
        deviceId?: string | null;
        unitId: string;
        propertyId: string;
        sourceId?: string | null;
      }
    | {
        __typename?: 'DoorSensor';
        _id: string;
        deviceId?: string | null;
        unitId: string;
        propertyId: string;
        sourceId?: string | null;
      }
    | {
        __typename?: 'EnergyController';
        _id: string;
        deviceId?: string | null;
        unitId: string;
        propertyId: string;
        sourceId?: string | null;
      }
    | {
        __typename?: 'EnergyConverter';
        _id: string;
        deviceId?: string | null;
        unitId: string;
        propertyId: string;
        sourceId?: string | null;
      }
    | {
        __typename?: 'EnergyInverter';
        _id: string;
        deviceId?: string | null;
        unitId: string;
        propertyId: string;
        sourceId?: string | null;
      }
    | {
        __typename?: 'EnergyMeter';
        _id: string;
        deviceId?: string | null;
        unitId: string;
        propertyId: string;
        sourceId?: string | null;
      }
    | {
        __typename?: 'EnergyRectifier';
        _id: string;
        deviceId?: string | null;
        unitId: string;
        propertyId: string;
        sourceId?: string | null;
      }
    | {
        __typename?: 'EnergyStorageCoolingSystem';
        _id: string;
        deviceId?: string | null;
        unitId: string;
        propertyId: string;
        sourceId?: string | null;
      }
    | {
        __typename?: 'EnergySwitchPanel';
        _id: string;
        deviceId?: string | null;
        unitId: string;
        propertyId: string;
        sourceId?: string | null;
      }
    | {
        __typename?: 'EnergySwitchPanelCircuit';
        _id: string;
        deviceId?: string | null;
        unitId: string;
        propertyId: string;
        sourceId?: string | null;
      }
    | {
        __typename?: 'FireSuppressionSystem';
        _id: string;
        deviceId?: string | null;
        unitId: string;
        propertyId: string;
        sourceId?: string | null;
      }
    | {
        __typename?: 'GPIO';
        _id: string;
        deviceId?: string | null;
        unitId: string;
        propertyId: string;
        sourceId?: string | null;
      }
    | {
        __typename?: 'IndoorAirHandler';
        _id: string;
        deviceId?: string | null;
        unitId: string;
        propertyId: string;
        sourceId?: string | null;
      }
    | {
        __typename?: 'IndoorSensor';
        _id: string;
        deviceId?: string | null;
        unitId: string;
        propertyId: string;
        sourceId?: string | null;
      }
    | {
        __typename?: 'KineticEnergyManagementSystem';
        _id: string;
        deviceId?: string | null;
        unitId: string;
        propertyId: string;
        sourceId?: string | null;
      }
    | {
        __typename?: 'LeakDetector';
        _id: string;
        deviceId?: string | null;
        unitId: string;
        propertyId: string;
        sourceId?: string | null;
      }
    | {
        __typename?: 'Loop';
        _id: string;
        deviceId?: string | null;
        unitId: string;
        propertyId: string;
        sourceId?: string | null;
      }
    | {
        __typename?: 'ModbusAirHandler';
        _id: string;
        deviceId?: string | null;
        unitId: string;
        propertyId: string;
        sourceId?: string | null;
      }
    | {
        __typename?: 'OccupancySensor';
        _id: string;
        deviceId?: string | null;
        unitId: string;
        propertyId: string;
        sourceId?: string | null;
      }
    | {
        __typename?: 'OpenWeather';
        _id: string;
        deviceId?: string | null;
        unitId: string;
        propertyId: string;
        sourceId?: string | null;
      }
    | {
        __typename?: 'OutdoorSensor';
        _id: string;
        deviceId?: string | null;
        unitId: string;
        propertyId: string;
        sourceId?: string | null;
      }
    | {
        __typename?: 'PowerMonitor';
        _id: string;
        deviceId?: string | null;
        unitId: string;
        propertyId: string;
        sourceId?: string | null;
      }
    | {
        __typename?: 'PressureSensor';
        _id: string;
        deviceId?: string | null;
        unitId: string;
        propertyId: string;
        sourceId?: string | null;
      }
    | {
        __typename?: 'RelayDevice';
        _id: string;
        deviceId?: string | null;
        unitId: string;
        propertyId: string;
        sourceId?: string | null;
      }
    | {
        __typename?: 'SmartPowerOutlet';
        _id: string;
        deviceId?: string | null;
        unitId: string;
        propertyId: string;
        sourceId?: string | null;
      }
    | {
        __typename?: 'SolarManagementSystem';
        _id: string;
        deviceId?: string | null;
        unitId: string;
        propertyId: string;
        sourceId?: string | null;
      }
    | {
        __typename?: 'Thermistor';
        _id: string;
        deviceId?: string | null;
        unitId: string;
        propertyId: string;
        sourceId?: string | null;
      }
    | {
        __typename?: 'Thermostat';
        _id: string;
        deviceId?: string | null;
        unitId: string;
        propertyId: string;
        sourceId?: string | null;
      }
    | {
        __typename?: 'VSDPump';
        _id: string;
        deviceId?: string | null;
        unitId: string;
        propertyId: string;
        sourceId?: string | null;
      }
    | {
        __typename?: 'WindManagementSystem';
        _id: string;
        deviceId?: string | null;
        unitId: string;
        propertyId: string;
        sourceId?: string | null;
      }
    | {
        __typename?: 'WindowSensor';
        _id: string;
        deviceId?: string | null;
        unitId: string;
        propertyId: string;
        sourceId?: string | null;
      }
    | {
        __typename?: 'Z210Pump';
        _id: string;
        deviceId?: string | null;
        unitId: string;
        propertyId: string;
        sourceId?: string | null;
      }
  >;
};

export type ClearOptInViaSmsMutationVariables = Exact<{
  destinationNumber: Scalars['String'];
  contactIndex: Scalars['Int'];
  propertyId: Scalars['String'];
}>;

export type ClearOptInViaSmsMutation = {
  __typename?: 'Mutation';
  clearOptInViaSms?: {
    __typename?: 'Property';
    _id: string;
    contact?: {
      __typename?: 'PropertyContact';
      name?: string | null;
      email?: string | null;
      email2?: string | null;
      email3?: string | null;
      smsNumber?: string | null;
      smsNumber2?: string | null;
      smsNumber3?: string | null;
      smsOptInStatus1?: EnumPropertyContactSmsOptInStatus1 | null;
      smsOptInTimestamp1?: number | null;
      smsOptInStatus2?: EnumPropertyContactSmsOptInStatus2 | null;
      smsOptInTimestamp2?: number | null;
      smsOptInStatus3?: EnumPropertyContactSmsOptInStatus3 | null;
      smsOptInTimestamp3?: number | null;
    } | null;
  } | null;
};

export type CreateAlertTriggerMutationVariables = Exact<{
  alertTrigger: CreateOneAlertTriggerInput;
}>;

export type CreateAlertTriggerMutation = {
  __typename?: 'Mutation';
  createAlertTrigger?: {
    __typename?: 'AlertTrigger';
    _id: string;
    name: string;
    propertyId: string;
    entityTypes: Array<string | null>;
    editMode: number;
  } | null;
};

export type AlertTriggerDetailUpdateSubscriptionVariables = Exact<{
  ids: Array<Scalars['String']> | Scalars['String'];
}>;

export type AlertTriggerDetailUpdateSubscription = {
  __typename?: 'Subscription';
  alertTriggerEventsByIds?: {
    __typename?: 'AlertTrigger';
    modelChangeOperation?: string | null;
    _id: string;
    name: string;
    propertyId: string;
    entityTypes: Array<string | null>;
    editMode: number;
    enabled: boolean;
    triggerCriteria?: {
      __typename?: 'AlertTriggerTriggerCriteria';
      basisType: EnumAlertTriggerTriggerCriteriaBasisType;
      basisName: string;
      levels?: number | null;
      selectionCriteria: {
        __typename?: 'AlertTriggerTriggerCriteriaSelectionCriteria';
        criterion?: {
          __typename?: 'AlertTriggerTriggerCriteriaSelectionCriteriaCriterion';
          id: string;
          selectionPath: string;
          comparator: EnumAlertTriggerTriggerCriteriaSelectionCriteriaCriterionComparator;
          template?: string | null;
          valueType: EnumAlertTriggerTriggerCriteriaSelectionCriteriaCriterionValueType;
          values: Array<string | null>;
          editable?: boolean | null;
          legacyPath?: string | null;
        } | null;
        criteria?: Array<{
          __typename?: 'AlertTriggerTriggerCriteriaSelectionCriteriaCriterion';
          id: string;
          selectionPath: string;
          comparator: EnumAlertTriggerTriggerCriteriaSelectionCriteriaCriterionComparator;
          template?: string | null;
          valueType: EnumAlertTriggerTriggerCriteriaSelectionCriteriaCriterionValueType;
          values: Array<string | null>;
          editable?: boolean | null;
          legacyPath?: string | null;
        } | null> | null;
      };
    } | null;
  } | null;
};

export type AlertTriggerDetailQueryVariables = Exact<{
  id: Scalars['String'];
}>;

export type AlertTriggerDetailQuery = {
  __typename?: 'Query';
  alertTriggerById?: {
    __typename?: 'AlertTrigger';
    _id: string;
    name: string;
    propertyId: string;
    entityTypes: Array<string | null>;
    editMode: number;
    enabled: boolean;
    triggerCriteria?: {
      __typename?: 'AlertTriggerTriggerCriteria';
      basisType: EnumAlertTriggerTriggerCriteriaBasisType;
      basisName: string;
      levels?: number | null;
      selectionCriteria: {
        __typename?: 'AlertTriggerTriggerCriteriaSelectionCriteria';
        criterion?: {
          __typename?: 'AlertTriggerTriggerCriteriaSelectionCriteriaCriterion';
          id: string;
          selectionPath: string;
          comparator: EnumAlertTriggerTriggerCriteriaSelectionCriteriaCriterionComparator;
          template?: string | null;
          valueType: EnumAlertTriggerTriggerCriteriaSelectionCriteriaCriterionValueType;
          values: Array<string | null>;
          editable?: boolean | null;
          legacyPath?: string | null;
        } | null;
        criteria?: Array<{
          __typename?: 'AlertTriggerTriggerCriteriaSelectionCriteriaCriterion';
          id: string;
          selectionPath: string;
          comparator: EnumAlertTriggerTriggerCriteriaSelectionCriteriaCriterionComparator;
          template?: string | null;
          valueType: EnumAlertTriggerTriggerCriteriaSelectionCriteriaCriterionValueType;
          values: Array<string | null>;
          editable?: boolean | null;
          legacyPath?: string | null;
        } | null> | null;
      };
    } | null;
  } | null;
};

export type AlertTriggerListByPropertyIdUpdateSubscriptionVariables = Exact<{
  propertyId: Scalars['String'];
}>;

export type AlertTriggerListByPropertyIdUpdateSubscription = {
  __typename?: 'Subscription';
  alertTriggerEventsByPropertyId?: {
    __typename?: 'AlertTrigger';
    modelChangeOperation?: string | null;
    _id: string;
    name: string;
    propertyId: string;
    entityTypes: Array<string | null>;
    editMode: number;
    enabled: boolean;
    triggerCriteria?: {
      __typename?: 'AlertTriggerTriggerCriteria';
      basisType: EnumAlertTriggerTriggerCriteriaBasisType;
      basisName: string;
      levels?: number | null;
      selectionCriteria: {
        __typename?: 'AlertTriggerTriggerCriteriaSelectionCriteria';
        criterion?: {
          __typename?: 'AlertTriggerTriggerCriteriaSelectionCriteriaCriterion';
          id: string;
          selectionPath: string;
          comparator: EnumAlertTriggerTriggerCriteriaSelectionCriteriaCriterionComparator;
          template?: string | null;
          valueType: EnumAlertTriggerTriggerCriteriaSelectionCriteriaCriterionValueType;
          values: Array<string | null>;
          editable?: boolean | null;
          legacyPath?: string | null;
        } | null;
        criteria?: Array<{
          __typename?: 'AlertTriggerTriggerCriteriaSelectionCriteriaCriterion';
          id: string;
          selectionPath: string;
          comparator: EnumAlertTriggerTriggerCriteriaSelectionCriteriaCriterionComparator;
          template?: string | null;
          valueType: EnumAlertTriggerTriggerCriteriaSelectionCriteriaCriterionValueType;
          values: Array<string | null>;
          editable?: boolean | null;
          legacyPath?: string | null;
        } | null> | null;
      };
    } | null;
  } | null;
};

export type AlertTriggerListByPropertyIdQueryVariables = Exact<{
  propertyId: Scalars['String'];
}>;

export type AlertTriggerListByPropertyIdQuery = {
  __typename?: 'Query';
  alertTriggersByPropertyId: Array<{
    __typename?: 'AlertTrigger';
    _id: string;
    name: string;
    propertyId: string;
    entityTypes: Array<string | null>;
    editMode: number;
    enabled: boolean;
    triggerCriteria?: {
      __typename?: 'AlertTriggerTriggerCriteria';
      basisType: EnumAlertTriggerTriggerCriteriaBasisType;
      basisName: string;
      levels?: number | null;
      selectionCriteria: {
        __typename?: 'AlertTriggerTriggerCriteriaSelectionCriteria';
        criterion?: {
          __typename?: 'AlertTriggerTriggerCriteriaSelectionCriteriaCriterion';
          id: string;
          selectionPath: string;
          comparator: EnumAlertTriggerTriggerCriteriaSelectionCriteriaCriterionComparator;
          template?: string | null;
          valueType: EnumAlertTriggerTriggerCriteriaSelectionCriteriaCriterionValueType;
          values: Array<string | null>;
          editable?: boolean | null;
          legacyPath?: string | null;
        } | null;
        criteria?: Array<{
          __typename?: 'AlertTriggerTriggerCriteriaSelectionCriteriaCriterion';
          id: string;
          selectionPath: string;
          comparator: EnumAlertTriggerTriggerCriteriaSelectionCriteriaCriterionComparator;
          template?: string | null;
          valueType: EnumAlertTriggerTriggerCriteriaSelectionCriteriaCriterionValueType;
          values: Array<string | null>;
          editable?: boolean | null;
          legacyPath?: string | null;
        } | null> | null;
      };
    } | null;
  }>;
};

export type PropertyWideAlertSubscribersSubscriptionVariables = Exact<{
  propertyId?: InputMaybe<Scalars['String']>;
}>;

export type PropertyWideAlertSubscribersSubscription = {
  __typename?: 'Subscription';
  propertyEventsByIds?: {
    __typename?: 'Property';
    modelChangeOperation?: string | null;
    _id: string;
    contact?: {
      __typename?: 'PropertyContact';
      smsNumber?: string | null;
      smsNumber2?: string | null;
      smsNumber3?: string | null;
      smsOptInStatus1?: EnumPropertyContactSmsOptInStatus1 | null;
      smsOptInStatus2?: EnumPropertyContactSmsOptInStatus2 | null;
      smsOptInStatus3?: EnumPropertyContactSmsOptInStatus3 | null;
      smsOptInTimestamp1?: number | null;
      smsOptInTimestamp2?: number | null;
      smsOptInTimestamp3?: number | null;
    } | null;
  } | null;
};

export type RemoveAlertTriggerMutationVariables = Exact<{
  id: Scalars['String'];
}>;

export type RemoveAlertTriggerMutation = {
  __typename?: 'Mutation';
  removeAlertTrigger?: string | null;
};

export type RetrieveSmsNumberQueryVariables = Exact<{ [key: string]: never }>;

export type RetrieveSmsNumberQuery = {
  __typename?: 'Query';
  retrieveSmsNumber?: string | null;
};

export type SendOptInRequestSmsMutationVariables = Exact<{
  destinationNumber: Scalars['String'];
  contactIndex: Scalars['Int'];
  propertyId: Scalars['String'];
}>;

export type SendOptInRequestSmsMutation = {
  __typename?: 'Mutation';
  sendOptInRequestSms?: {
    __typename?: 'Property';
    _id: string;
    contact?: {
      __typename?: 'PropertyContact';
      name?: string | null;
      email?: string | null;
      email2?: string | null;
      email3?: string | null;
      smsNumber?: string | null;
      smsNumber2?: string | null;
      smsNumber3?: string | null;
      smsOptInStatus1?: EnumPropertyContactSmsOptInStatus1 | null;
      smsOptInTimestamp1?: number | null;
      smsOptInStatus2?: EnumPropertyContactSmsOptInStatus2 | null;
      smsOptInTimestamp2?: number | null;
      smsOptInStatus3?: EnumPropertyContactSmsOptInStatus3 | null;
      smsOptInTimestamp3?: number | null;
    } | null;
  } | null;
};

export type SendTestEmailMutationVariables = Exact<{
  destinationEmail: Scalars['String'];
  propertyId: Scalars['String'];
}>;

export type SendTestEmailMutation = {
  __typename?: 'Mutation';
  sendTestEmail?: boolean | null;
};

export type UpdateAlertTriggerMutationVariables = Exact<{
  id: Scalars['String'];
  alertTrigger: UpdateOneAlertTriggerInput;
}>;

export type UpdateAlertTriggerMutation = {
  __typename?: 'Mutation';
  updateAlertTrigger: {
    __typename?: 'AlertTrigger';
    _id: string;
    name: string;
    propertyId: string;
    entityTypes: Array<string | null>;
    editMode: number;
    enabled: boolean;
    triggerCriteria?: {
      __typename?: 'AlertTriggerTriggerCriteria';
      basisType: EnumAlertTriggerTriggerCriteriaBasisType;
      basisName: string;
      selectionCriteria: {
        __typename?: 'AlertTriggerTriggerCriteriaSelectionCriteria';
        criterion?: {
          __typename?: 'AlertTriggerTriggerCriteriaSelectionCriteriaCriterion';
          id: string;
          selectionPath: string;
          comparator: EnumAlertTriggerTriggerCriteriaSelectionCriteriaCriterionComparator;
          template?: string | null;
          valueType: EnumAlertTriggerTriggerCriteriaSelectionCriteriaCriterionValueType;
          values: Array<string | null>;
          editable?: boolean | null;
          legacyPath?: string | null;
        } | null;
        criteria?: Array<{
          __typename?: 'AlertTriggerTriggerCriteriaSelectionCriteriaCriterion';
          id: string;
          selectionPath: string;
          comparator: EnumAlertTriggerTriggerCriteriaSelectionCriteriaCriterionComparator;
          template?: string | null;
          valueType: EnumAlertTriggerTriggerCriteriaSelectionCriteriaCriterionValueType;
          values: Array<string | null>;
          editable?: boolean | null;
          legacyPath?: string | null;
        } | null> | null;
      };
    } | null;
  };
};

export type UpdateUserAlertSubscriptionsMutationVariables = Exact<{
  userId: Scalars['String'];
  propertyId: Scalars['String'];
  alertSubscriptions:
    | Array<AlertSubscriptionSpecification>
    | AlertSubscriptionSpecification;
}>;

export type UpdateUserAlertSubscriptionsMutation = {
  __typename?: 'Mutation';
  updateUserAlertSubscriptions: Array<{
    __typename?: 'AlertSubscription';
    _id: string;
    userId?: string | null;
    propertyId?: string | null;
    viaEmail?: boolean | null;
    viaSms?: boolean | null;
  }>;
};

export type UserProfileAlertSubscriptionUpdatesSubscriptionVariables = Exact<{
  userId: Scalars['String'];
}>;

export type UserProfileAlertSubscriptionUpdatesSubscription = {
  __typename?: 'Subscription';
  alertSubscriptionsByUserIdEvents?: {
    __typename?: 'AlertSubscription';
    modelChangeOperation?: string | null;
    _id: string;
    unitCategoryId?: string | null;
    viaEmail?: boolean | null;
    viaSms?: boolean | null;
    alertTrigger?: {
      __typename?: 'AlertTrigger';
      _id: string;
      name: string;
    } | null;
    property?: { __typename?: 'Property'; _id: string; title: string } | null;
    unit?: { __typename?: 'Unit'; name: string } | null;
    device: { __typename?: 'Device'; name?: string | null };
  } | null;
};

export type UserProfileAlertSubscriptionsQueryVariables = Exact<{
  userId: Scalars['String'];
}>;

export type UserProfileAlertSubscriptionsQuery = {
  __typename?: 'Query';
  alertSubscriptionsByUserId: Array<{
    __typename?: 'AlertSubscription';
    _id: string;
    unitCategoryId?: string | null;
    viaEmail?: boolean | null;
    viaSms?: boolean | null;
    alertTrigger?: {
      __typename?: 'AlertTrigger';
      _id: string;
      name: string;
    } | null;
    property?: { __typename?: 'Property'; _id: string; title: string } | null;
    unit?: { __typename?: 'Unit'; name: string } | null;
    device: { __typename?: 'Device'; name?: string | null };
  }>;
};

export type BuildingDetailEditQueryVariables = Exact<{
  bid: Scalars['String'];
}>;

export type BuildingDetailEditQuery = {
  __typename?: 'Query';
  buildingById?: {
    __typename?: 'Building';
    _id: string;
    name: string;
    number?: number | null;
  } | null;
};

export type BuildingListByPropertyIdUpdateSubscriptionVariables = Exact<{
  propertyId: Scalars['String'];
}>;

export type BuildingListByPropertyIdUpdateSubscription = {
  __typename?: 'Subscription';
  buildingsByPropertyIdEvents?: {
    __typename?: 'Building';
    modelChangeOperation?: string | null;
    _id: string;
    name: string;
    number?: number | null;
    inUse: boolean;
  } | null;
};

export type BuildingListByPropertyIdQueryVariables = Exact<{
  propertyId: Scalars['String'];
}>;

export type BuildingListByPropertyIdQuery = {
  __typename?: 'Query';
  buildingsByPropertyId: Array<{
    __typename?: 'Building';
    _id: string;
    name: string;
    number?: number | null;
    inUse: boolean;
  }>;
};

export type CreateBuildingMutationVariables = Exact<{
  building: CreateOneBuildingInput;
}>;

export type CreateBuildingMutation = {
  __typename?: 'Mutation';
  createBuilding?: {
    __typename?: 'Building';
    _id: string;
    propertyId: string;
    name: string;
    number?: number | null;
  } | null;
};

export type PropertyBuildingsQueryVariables = Exact<{
  id: Scalars['String'];
}>;

export type PropertyBuildingsQuery = {
  __typename?: 'Query';
  propertyById?: {
    __typename?: 'Property';
    _id: string;
    title: string;
    floorLabel?: string | null;
    buildings: Array<{
      __typename?: 'Building';
      _id: string;
      name: string;
      number?: number | null;
      floors: Array<{
        __typename?: 'Floor';
        _id: string;
        name: string;
        number?: number | null;
        buildingId: string;
      } | null>;
    } | null>;
    floors: Array<{
      __typename?: 'Floor';
      _id: string;
      name: string;
      number?: number | null;
      buildingId: string;
    } | null>;
  } | null;
};

export type PropertyDataForBuildingQueryVariables = Exact<{
  id: Scalars['String'];
}>;

export type PropertyDataForBuildingQuery = {
  __typename?: 'Query';
  propertyById?: {
    __typename?: 'Property';
    _id: string;
    title: string;
    thermostatScheduleTemplateId?: string | null;
    setpointProfileId?: string | null;
  } | null;
};

export type RemoveBuildingMutationVariables = Exact<{
  id: Scalars['String'];
}>;

export type RemoveBuildingMutation = {
  __typename?: 'Mutation';
  removeBuilding?: string | null;
};

export type UpdateBuildingMutationVariables = Exact<{
  id: Scalars['String'];
  building: UpdateOneBuildingInput;
}>;

export type UpdateBuildingMutation = {
  __typename?: 'Mutation';
  updateBuilding: {
    __typename?: 'Building';
    _id: string;
    name: string;
    number?: number | null;
  };
};

export type BulkConfigPropertiesQueryVariables = Exact<{
  [key: string]: never;
}>;

export type BulkConfigPropertiesQuery = {
  __typename?: 'Query';
  properties: Array<{
    __typename?: 'Property';
    _id: string;
    title: string;
    floorLabel?: string | null;
    cuGroups?: Array<string> | null;
    address: { __typename?: 'PropertyAddress'; line1: string };
    buildings: Array<{
      __typename?: 'Building';
      _id: string;
      name: string;
      number?: number | null;
      floors: Array<{
        __typename?: 'Floor';
        _id: string;
        name: string;
        buildingId: string;
      } | null>;
    } | null>;
    units: Array<{
      __typename?: 'Unit';
      _id: string;
      name: string;
      type: string;
      buildingId: string;
      floorId?: string | null;
      cuid?: string | null;
    } | null>;
    devices: Array<
      | {
          __typename?: 'Actuator';
          _id: string;
          deviceId?: string | null;
          type?: EnumDKeyDeviceType | null;
          name?: string | null;
          location?: string | null;
          unitId: string;
        }
      | {
          __typename?: 'BatteryManagementSystem';
          _id: string;
          deviceId?: string | null;
          type?: EnumDKeyDeviceType | null;
          name?: string | null;
          location?: string | null;
          unitId: string;
        }
      | {
          __typename?: 'Boiler';
          _id: string;
          deviceId?: string | null;
          type?: EnumDKeyDeviceType | null;
          name?: string | null;
          location?: string | null;
          unitId: string;
        }
      | {
          __typename?: 'Chiller';
          _id: string;
          deviceId?: string | null;
          type?: EnumDKeyDeviceType | null;
          name?: string | null;
          location?: string | null;
          unitId: string;
        }
      | {
          __typename?: 'ConductorGenericSensor';
          _id: string;
          deviceId?: string | null;
          type?: EnumDKeyDeviceType | null;
          name?: string | null;
          location?: string | null;
          unitId: string;
        }
      | {
          __typename?: 'Controller';
          _id: string;
          deviceId?: string | null;
          type?: EnumDKeyDeviceType | null;
          name?: string | null;
          location?: string | null;
          unitId: string;
        }
      | {
          __typename?: 'Device';
          _id: string;
          deviceId?: string | null;
          type?: EnumDKeyDeviceType | null;
          name?: string | null;
          location?: string | null;
          unitId: string;
        }
      | {
          __typename?: 'DoorSensor';
          _id: string;
          deviceId?: string | null;
          type?: EnumDKeyDeviceType | null;
          name?: string | null;
          location?: string | null;
          unitId: string;
        }
      | {
          __typename?: 'EnergyController';
          _id: string;
          deviceId?: string | null;
          type?: EnumDKeyDeviceType | null;
          name?: string | null;
          location?: string | null;
          unitId: string;
        }
      | {
          __typename?: 'EnergyConverter';
          _id: string;
          deviceId?: string | null;
          type?: EnumDKeyDeviceType | null;
          name?: string | null;
          location?: string | null;
          unitId: string;
        }
      | {
          __typename?: 'EnergyInverter';
          _id: string;
          deviceId?: string | null;
          type?: EnumDKeyDeviceType | null;
          name?: string | null;
          location?: string | null;
          unitId: string;
        }
      | {
          __typename?: 'EnergyMeter';
          _id: string;
          deviceId?: string | null;
          type?: EnumDKeyDeviceType | null;
          name?: string | null;
          location?: string | null;
          unitId: string;
        }
      | {
          __typename?: 'EnergyRectifier';
          _id: string;
          deviceId?: string | null;
          type?: EnumDKeyDeviceType | null;
          name?: string | null;
          location?: string | null;
          unitId: string;
        }
      | {
          __typename?: 'EnergyStorageCoolingSystem';
          _id: string;
          deviceId?: string | null;
          type?: EnumDKeyDeviceType | null;
          name?: string | null;
          location?: string | null;
          unitId: string;
        }
      | {
          __typename?: 'EnergySwitchPanel';
          _id: string;
          deviceId?: string | null;
          type?: EnumDKeyDeviceType | null;
          name?: string | null;
          location?: string | null;
          unitId: string;
        }
      | {
          __typename?: 'EnergySwitchPanelCircuit';
          _id: string;
          deviceId?: string | null;
          type?: EnumDKeyDeviceType | null;
          name?: string | null;
          location?: string | null;
          unitId: string;
        }
      | {
          __typename?: 'FireSuppressionSystem';
          _id: string;
          deviceId?: string | null;
          type?: EnumDKeyDeviceType | null;
          name?: string | null;
          location?: string | null;
          unitId: string;
        }
      | {
          __typename?: 'GPIO';
          _id: string;
          deviceId?: string | null;
          type?: EnumDKeyDeviceType | null;
          name?: string | null;
          location?: string | null;
          unitId: string;
        }
      | {
          __typename?: 'IndoorAirHandler';
          _id: string;
          deviceId?: string | null;
          type?: EnumDKeyDeviceType | null;
          name?: string | null;
          location?: string | null;
          unitId: string;
        }
      | {
          __typename?: 'IndoorSensor';
          _id: string;
          deviceId?: string | null;
          type?: EnumDKeyDeviceType | null;
          name?: string | null;
          location?: string | null;
          unitId: string;
        }
      | {
          __typename?: 'KineticEnergyManagementSystem';
          _id: string;
          deviceId?: string | null;
          type?: EnumDKeyDeviceType | null;
          name?: string | null;
          location?: string | null;
          unitId: string;
        }
      | {
          __typename?: 'LeakDetector';
          _id: string;
          deviceId?: string | null;
          type?: EnumDKeyDeviceType | null;
          name?: string | null;
          location?: string | null;
          unitId: string;
        }
      | {
          __typename?: 'Loop';
          _id: string;
          deviceId?: string | null;
          type?: EnumDKeyDeviceType | null;
          name?: string | null;
          location?: string | null;
          unitId: string;
        }
      | {
          __typename?: 'ModbusAirHandler';
          _id: string;
          deviceId?: string | null;
          type?: EnumDKeyDeviceType | null;
          name?: string | null;
          location?: string | null;
          unitId: string;
        }
      | {
          __typename?: 'OccupancySensor';
          _id: string;
          deviceId?: string | null;
          type?: EnumDKeyDeviceType | null;
          name?: string | null;
          location?: string | null;
          unitId: string;
        }
      | {
          __typename?: 'OpenWeather';
          _id: string;
          deviceId?: string | null;
          type?: EnumDKeyDeviceType | null;
          name?: string | null;
          location?: string | null;
          unitId: string;
        }
      | {
          __typename?: 'OutdoorSensor';
          _id: string;
          deviceId?: string | null;
          type?: EnumDKeyDeviceType | null;
          name?: string | null;
          location?: string | null;
          unitId: string;
        }
      | {
          __typename?: 'PowerMonitor';
          _id: string;
          deviceId?: string | null;
          type?: EnumDKeyDeviceType | null;
          name?: string | null;
          location?: string | null;
          unitId: string;
        }
      | {
          __typename?: 'PressureSensor';
          _id: string;
          deviceId?: string | null;
          type?: EnumDKeyDeviceType | null;
          name?: string | null;
          location?: string | null;
          unitId: string;
        }
      | {
          __typename?: 'RelayDevice';
          _id: string;
          deviceId?: string | null;
          type?: EnumDKeyDeviceType | null;
          name?: string | null;
          location?: string | null;
          unitId: string;
        }
      | {
          __typename?: 'SmartPowerOutlet';
          _id: string;
          deviceId?: string | null;
          type?: EnumDKeyDeviceType | null;
          name?: string | null;
          location?: string | null;
          unitId: string;
        }
      | {
          __typename?: 'SolarManagementSystem';
          _id: string;
          deviceId?: string | null;
          type?: EnumDKeyDeviceType | null;
          name?: string | null;
          location?: string | null;
          unitId: string;
        }
      | {
          __typename?: 'Thermistor';
          _id: string;
          deviceId?: string | null;
          type?: EnumDKeyDeviceType | null;
          name?: string | null;
          location?: string | null;
          unitId: string;
        }
      | {
          __typename?: 'Thermostat';
          _id: string;
          deviceId?: string | null;
          type?: EnumDKeyDeviceType | null;
          name?: string | null;
          location?: string | null;
          unitId: string;
        }
      | {
          __typename?: 'VSDPump';
          _id: string;
          deviceId?: string | null;
          type?: EnumDKeyDeviceType | null;
          name?: string | null;
          location?: string | null;
          unitId: string;
        }
      | {
          __typename?: 'WindManagementSystem';
          _id: string;
          deviceId?: string | null;
          type?: EnumDKeyDeviceType | null;
          name?: string | null;
          location?: string | null;
          unitId: string;
        }
      | {
          __typename?: 'WindowSensor';
          _id: string;
          deviceId?: string | null;
          type?: EnumDKeyDeviceType | null;
          name?: string | null;
          location?: string | null;
          unitId: string;
        }
      | {
          __typename?: 'Z210Pump';
          _id: string;
          deviceId?: string | null;
          type?: EnumDKeyDeviceType | null;
          name?: string | null;
          location?: string | null;
          unitId: string;
        }
    >;
  }>;
};

export type GetBulkSetpointLimitsQueryVariables = Exact<{
  input: BulkConfigThermostatsInput;
}>;

export type GetBulkSetpointLimitsQuery = {
  __typename?: 'Query';
  getBulkSetpointLimits?: {
    __typename?: 'SetpointLimits';
    heat: { __typename?: 'MinMax'; min: number; max: number };
    cool: { __typename?: 'MinMax'; min: number; max: number };
  } | null;
};

export type ValidateBulkConfigThermostatsChangesMutationVariables = Exact<{
  input: BulkConfigThermostatsInput;
}>;

export type ValidateBulkConfigThermostatsChangesMutation = {
  __typename?: 'Mutation';
  validateBulkConfigThermostatsChanges: {
    __typename?: 'BulkConfigValidationResult';
    numTStats: number;
    numOnline: number;
    numOffline: number;
    numSupported: number;
    numConfigurable: number;
    deviceIds: Array<string>;
    devices?: Array<{
      __typename?: 'BulkThermostatCompatibility';
      deviceId: string;
      compatible: boolean;
      reason: string;
      autoMode: string;
      sourceType: string;
      previewState: string;
      needsChange: boolean;
    }> | null;
  };
};

export type ValidateBulkConfigSetpointLimitsMutationVariables = Exact<{
  input: BulkConfigSetpointLimitsInput;
}>;

export type ValidateBulkConfigSetpointLimitsMutation = {
  __typename?: 'Mutation';
  validateBulkConfigSetpointLimits: {
    __typename?: 'BulkConfigValidationResult';
    numTStats: number;
    numOnline: number;
    numOffline: number;
    numSupported: number;
    numConfigurable: number;
    deviceIds: Array<string>;
  };
};

export type CommitBulkConfigThermostatsChangesMutationVariables = Exact<{
  deviceId: Scalars['String'];
  input: BulkConfigThermostatsChanges;
}>;

export type CommitBulkConfigThermostatsChangesMutation = {
  __typename?: 'Mutation';
  commitBulkConfigThermostatsChanges: {
    __typename?: 'BulkConfigCommitResult';
    deviceId: string;
  };
};

export type CommitBulkConfigSetpointLimitsMutationVariables = Exact<{
  deviceId: Scalars['String'];
}>;

export type CommitBulkConfigSetpointLimitsMutation = {
  __typename?: 'Mutation';
  commitBulkConfigSetpointLimits: {
    __typename?: 'BulkConfigCommitResult';
    deviceId: string;
  };
};

export type CommitBulkConfigThermostatsBatchMutationVariables = Exact<{
  input: BulkConfigThermostatsInput;
  deviceIds: Array<Scalars['String']> | Scalars['String'];
  excludedDeviceIds: Array<Scalars['String']> | Scalars['String'];
  previewStates: Array<Scalars['String']> | Scalars['String'];
}>;

export type CommitBulkConfigThermostatsBatchMutation = {
  __typename?: 'Mutation';
  commitBulkConfigThermostatsBatch: Array<{
    __typename?: 'BulkThermostatOutcome';
    deviceId: string;
    success: boolean;
    error?: string | null;
  }>;
};

export type BulkConfigProgressUpdateSubscriptionVariables = Exact<{
  initiatorId: Scalars['String'];
  initiatorType: Scalars['String'];
}>;

export type BulkConfigProgressUpdateSubscription = {
  __typename?: 'Subscription';
  bulkConfigProgressUpdate?: {
    __typename?: 'BulkConfigStatus';
    initiatorId?: string | null;
    initiatorType?: string | null;
    totalCount?: number | null;
    errorCount?: number | null;
    completedCount?: number | null;
    isComplete?: boolean | null;
    percentProcessed?: number | null;
    errors: Array<{
      __typename?: 'BulkConfigError';
      deviceType?: string | null;
      deviceName?: string | null;
      deviceId?: string | null;
      message?: string | null;
    } | null>;
  } | null;
};

export type ActuatorDetailUpdateSubscriptionVariables = Exact<{
  ids: Array<Scalars['String']> | Scalars['String'];
}>;

export type ActuatorDetailUpdateSubscription = {
  __typename?: 'Subscription';
  actuatorEventsByIds?: {
    __typename?: 'Actuator';
    modelChangeOperation?: string | null;
    _id: string;
    type?: EnumDKeyDeviceType | null;
    typeDisplayName: string;
    panelId?: string | null;
    name?: string | null;
    deviceId?: string | null;
    propertyId: string;
    unitId: string;
    sourceId?: string | null;
    timestamp?: number | null;
    hasPendingUpdates: boolean;
    isConfigured?: boolean | null;
    meta?: {
      __typename?: 'DeviceMeta';
      name?: string | null;
      model?: string | null;
      modelNumber?: string | null;
      version?: string | null;
      metrics?: any | null;
    } | null;
    panel?: {
      __typename?: 'Panel';
      _id: string;
      sourceId: string;
      name?: string | null;
      role?: string | null;
    } | null;
    source?: { __typename?: 'Source'; _id: string; name: string } | null;
    position?: {
      __typename?: 'ActuatorPosition';
      id?: string | null;
      timestamp?: number | null;
      value?: number | null;
      units?: string | null;
    } | null;
    controlMode?: {
      __typename?: 'ActuatorControlMode';
      id?: string | null;
      timestamp?: number | null;
      value?: EnumActuatorControlModeValue | null;
      units?: string | null;
    } | null;
    defaultPosition?: {
      __typename?: 'ActuatorDefaultPosition';
      id?: string | null;
      timestamp?: number | null;
      value?: number | null;
      units?: string | null;
    } | null;
    deviceAlerts: Array<{
      __typename?: 'Alert';
      _id: string;
      initiated?: number | null;
      updated?: number | null;
      type?: { __typename?: 'AlertType'; name?: string | null } | null;
      device?: {
        __typename?: 'AlertDevice';
        id: string;
        name?: string | null;
        type: string;
      } | null;
    } | null>;
    sourceAlerts: Array<{
      __typename?: 'Alert';
      _id: string;
      initiated?: number | null;
      updated?: number | null;
      type?: { __typename?: 'AlertType'; name?: string | null } | null;
      device?: {
        __typename?: 'AlertDevice';
        id: string;
        name?: string | null;
        type: string;
      } | null;
    } | null>;
    alertTypes?: {
      __typename?: 'DeviceAlertTypes';
      deviceOffline?: boolean | null;
      sourceOffline?: boolean | null;
    } | null;
  } | null;
};

export type ActuatorDetailQueryVariables = Exact<{
  id: Scalars['String'];
}>;

export type ActuatorDetailQuery = {
  __typename?: 'Query';
  actuatorById?: {
    __typename?: 'Actuator';
    _id: string;
    type?: EnumDKeyDeviceType | null;
    typeDisplayName: string;
    panelId?: string | null;
    name?: string | null;
    deviceId?: string | null;
    propertyId: string;
    unitId: string;
    sourceId?: string | null;
    timestamp?: number | null;
    hasPendingUpdates: boolean;
    isConfigured?: boolean | null;
    meta?: {
      __typename?: 'DeviceMeta';
      name?: string | null;
      model?: string | null;
      modelNumber?: string | null;
      version?: string | null;
      metrics?: any | null;
    } | null;
    panel?: {
      __typename?: 'Panel';
      _id: string;
      sourceId: string;
      name?: string | null;
      role?: string | null;
    } | null;
    source?: { __typename?: 'Source'; _id: string; name: string } | null;
    position?: {
      __typename?: 'ActuatorPosition';
      id?: string | null;
      timestamp?: number | null;
      value?: number | null;
      units?: string | null;
    } | null;
    controlMode?: {
      __typename?: 'ActuatorControlMode';
      id?: string | null;
      timestamp?: number | null;
      value?: EnumActuatorControlModeValue | null;
      units?: string | null;
    } | null;
    defaultPosition?: {
      __typename?: 'ActuatorDefaultPosition';
      id?: string | null;
      timestamp?: number | null;
      value?: number | null;
      units?: string | null;
    } | null;
    deviceAlerts: Array<{
      __typename?: 'Alert';
      _id: string;
      initiated?: number | null;
      updated?: number | null;
      type?: { __typename?: 'AlertType'; name?: string | null } | null;
      device?: {
        __typename?: 'AlertDevice';
        id: string;
        name?: string | null;
        type: string;
      } | null;
    } | null>;
    sourceAlerts: Array<{
      __typename?: 'Alert';
      _id: string;
      initiated?: number | null;
      updated?: number | null;
      type?: { __typename?: 'AlertType'; name?: string | null } | null;
      device?: {
        __typename?: 'AlertDevice';
        id: string;
        name?: string | null;
        type: string;
      } | null;
    } | null>;
    alertTypes?: {
      __typename?: 'DeviceAlertTypes';
      deviceOffline?: boolean | null;
      sourceOffline?: boolean | null;
    } | null;
  } | null;
};

export type BoilerDetailQueryVariables = Exact<{
  id: Scalars['String'];
}>;

export type BoilerDetailQuery = {
  __typename?: 'Query';
  boilerById?: {
    __typename?: 'Boiler';
    _id: string;
    type?: EnumDKeyDeviceType | null;
    typeDisplayName: string;
    panelId?: string | null;
    name?: string | null;
    deviceId?: string | null;
    isConfigured?: boolean | null;
    isPoweredOn?: boolean | null;
    timestamp?: number | null;
    role?: string | null;
    hasModules?: boolean | null;
    hasBoilerPumpSpeed?: boolean | null;
    hasFiringRate?: boolean | null;
    hasFlueTemperature?: boolean | null;
    hasInletTemperature?: boolean | null;
    hasOutdoorTemperature?: boolean | null;
    hasOutletTemperature?: boolean | null;
    powerState?: {
      __typename?: 'DevicePowerState';
      timestamp?: number | null;
      units?: string | null;
      value?: EnumDevicePowerStateValue | null;
    } | null;
    meta?: {
      __typename?: 'DeviceMeta';
      name?: string | null;
      model?: string | null;
      modelNumber?: string | null;
      version?: string | null;
    } | null;
    source?: { __typename?: 'Source'; _id: string; name: string } | null;
    deviceMetrics?: Array<{
      __typename?: 'DeviceMetric';
      key: string;
      value: { __typename?: 'DeviceMetricSpec'; readOnly?: boolean | null };
    } | null> | null;
    boilerPumpSpeed?: {
      __typename?: 'BoilerBoilerPumpSpeed';
      timestamp?: number | null;
      units?: string | null;
      value?: number | null;
    } | null;
    boilerPumpSpeed1?: {
      __typename?: 'BoilerBoilerPumpSpeed1';
      timestamp?: number | null;
      units?: string | null;
      value?: number | null;
    } | null;
    boilerPumpSpeed2?: {
      __typename?: 'BoilerBoilerPumpSpeed2';
      timestamp?: number | null;
      units?: string | null;
      value?: number | null;
    } | null;
    firingRate?: {
      __typename?: 'BoilerFiringRate';
      timestamp?: number | null;
      units?: string | null;
      value?: number | null;
    } | null;
    firingRate1?: {
      __typename?: 'BoilerFiringRate1';
      timestamp?: number | null;
      units?: string | null;
      value?: number | null;
    } | null;
    firingRate2?: {
      __typename?: 'BoilerFiringRate2';
      timestamp?: number | null;
      units?: string | null;
      value?: number | null;
    } | null;
    flueTemperature?: {
      __typename?: 'BoilerFlueTemperature';
      timestamp?: number | null;
      units?: string | null;
      value?: number | null;
    } | null;
    flueTemperature1?: {
      __typename?: 'BoilerFlueTemperature1';
      timestamp?: number | null;
      units?: string | null;
      value?: number | null;
    } | null;
    flueTemperature2?: {
      __typename?: 'BoilerFlueTemperature2';
      timestamp?: number | null;
      units?: string | null;
      value?: number | null;
    } | null;
    inletTemperature?: {
      __typename?: 'BoilerInletTemperature';
      timestamp?: number | null;
      units?: string | null;
      value?: number | null;
    } | null;
    inletTemperature1?: {
      __typename?: 'BoilerInletTemperature1';
      timestamp?: number | null;
      units?: string | null;
      value?: number | null;
    } | null;
    inletTemperature2?: {
      __typename?: 'BoilerInletTemperature2';
      timestamp?: number | null;
      units?: string | null;
      value?: number | null;
    } | null;
    outdoorTemperature?: {
      __typename?: 'DeviceReadingNumeric';
      timestamp?: string | null;
      units?: string | null;
      value?: number | null;
    } | null;
    outletTemperature?: {
      __typename?: 'BoilerOutletTemperature';
      timestamp?: number | null;
      units?: string | null;
      value?: number | null;
    } | null;
    outletTemperature1?: {
      __typename?: 'BoilerOutletTemperature1';
      timestamp?: number | null;
      units?: string | null;
      value?: number | null;
    } | null;
    outletTemperature2?: {
      __typename?: 'BoilerOutletTemperature2';
      timestamp?: number | null;
      units?: string | null;
      value?: number | null;
    } | null;
    panel?: {
      __typename?: 'Panel';
      _id: string;
      name?: string | null;
      displayName?: string | null;
      role?: string | null;
      type: EnumPanelType;
      sourceId: string;
      source?: { __typename?: 'Source'; _id: string; name: string } | null;
      alerts?: Array<{
        __typename?: 'Alert';
        _id: string;
        initiated?: number | null;
        updated?: number | null;
        type?: {
          __typename?: 'AlertType';
          id?: string | null;
          name?: string | null;
        } | null;
        panel?: { __typename?: 'AlertPanel'; id?: string | null } | null;
        device?: {
          __typename?: 'AlertDevice';
          id: string;
          name?: string | null;
          type: string;
        } | null;
        affectedSource?: {
          __typename?: 'Source';
          _id: string;
          name: string;
        } | null;
      }> | null;
    } | null;
    deviceAlerts: Array<{
      __typename?: 'Alert';
      _id: string;
      initiated?: number | null;
      updated?: number | null;
      type?: { __typename?: 'AlertType'; name?: string | null } | null;
      device?: {
        __typename?: 'AlertDevice';
        id: string;
        name?: string | null;
        type: string;
      } | null;
    } | null>;
    sourceAlerts: Array<{
      __typename?: 'Alert';
      _id: string;
      initiated?: number | null;
      updated?: number | null;
      type?: { __typename?: 'AlertType'; name?: string | null } | null;
      device?: {
        __typename?: 'AlertDevice';
        id: string;
        name?: string | null;
        type: string;
      } | null;
    } | null>;
  } | null;
};

export type BoilerDetailUpdateSubscriptionVariables = Exact<{
  ids: Array<Scalars['String']> | Scalars['String'];
}>;

export type BoilerDetailUpdateSubscription = {
  __typename?: 'Subscription';
  boilerEventsByIds?: {
    __typename?: 'Boiler';
    modelChangeOperation?: string | null;
    _id: string;
    type?: EnumDKeyDeviceType | null;
    typeDisplayName: string;
    panelId?: string | null;
    name?: string | null;
    deviceId?: string | null;
    isConfigured?: boolean | null;
    isPoweredOn?: boolean | null;
    timestamp?: number | null;
    role?: string | null;
    hasModules?: boolean | null;
    hasBoilerPumpSpeed?: boolean | null;
    hasFiringRate?: boolean | null;
    hasFlueTemperature?: boolean | null;
    hasInletTemperature?: boolean | null;
    hasOutdoorTemperature?: boolean | null;
    hasOutletTemperature?: boolean | null;
    powerState?: {
      __typename?: 'DevicePowerState';
      timestamp?: number | null;
      units?: string | null;
      value?: EnumDevicePowerStateValue | null;
    } | null;
    meta?: {
      __typename?: 'DeviceMeta';
      name?: string | null;
      model?: string | null;
      modelNumber?: string | null;
      version?: string | null;
    } | null;
    boilerPumpSpeed?: {
      __typename?: 'BoilerBoilerPumpSpeed';
      timestamp?: number | null;
      units?: string | null;
      value?: number | null;
    } | null;
    boilerPumpSpeed1?: {
      __typename?: 'BoilerBoilerPumpSpeed1';
      timestamp?: number | null;
      units?: string | null;
      value?: number | null;
    } | null;
    boilerPumpSpeed2?: {
      __typename?: 'BoilerBoilerPumpSpeed2';
      timestamp?: number | null;
      units?: string | null;
      value?: number | null;
    } | null;
    firingRate?: {
      __typename?: 'BoilerFiringRate';
      timestamp?: number | null;
      units?: string | null;
      value?: number | null;
    } | null;
    firingRate1?: {
      __typename?: 'BoilerFiringRate1';
      timestamp?: number | null;
      units?: string | null;
      value?: number | null;
    } | null;
    firingRate2?: {
      __typename?: 'BoilerFiringRate2';
      timestamp?: number | null;
      units?: string | null;
      value?: number | null;
    } | null;
    flueTemperature?: {
      __typename?: 'BoilerFlueTemperature';
      timestamp?: number | null;
      units?: string | null;
      value?: number | null;
    } | null;
    flueTemperature1?: {
      __typename?: 'BoilerFlueTemperature1';
      timestamp?: number | null;
      units?: string | null;
      value?: number | null;
    } | null;
    flueTemperature2?: {
      __typename?: 'BoilerFlueTemperature2';
      timestamp?: number | null;
      units?: string | null;
      value?: number | null;
    } | null;
    inletTemperature?: {
      __typename?: 'BoilerInletTemperature';
      timestamp?: number | null;
      units?: string | null;
      value?: number | null;
    } | null;
    inletTemperature1?: {
      __typename?: 'BoilerInletTemperature1';
      timestamp?: number | null;
      units?: string | null;
      value?: number | null;
    } | null;
    inletTemperature2?: {
      __typename?: 'BoilerInletTemperature2';
      timestamp?: number | null;
      units?: string | null;
      value?: number | null;
    } | null;
    outdoorTemperature?: {
      __typename?: 'DeviceReadingNumeric';
      timestamp?: string | null;
      units?: string | null;
      value?: number | null;
    } | null;
    outletTemperature?: {
      __typename?: 'BoilerOutletTemperature';
      timestamp?: number | null;
      units?: string | null;
      value?: number | null;
    } | null;
    outletTemperature1?: {
      __typename?: 'BoilerOutletTemperature1';
      timestamp?: number | null;
      units?: string | null;
      value?: number | null;
    } | null;
    outletTemperature2?: {
      __typename?: 'BoilerOutletTemperature2';
      timestamp?: number | null;
      units?: string | null;
      value?: number | null;
    } | null;
    panel?: {
      __typename?: 'Panel';
      _id: string;
      name?: string | null;
      displayName?: string | null;
      role?: string | null;
      type: EnumPanelType;
      sourceId: string;
      source?: { __typename?: 'Source'; _id: string; name: string } | null;
      alerts?: Array<{
        __typename?: 'Alert';
        _id: string;
        initiated?: number | null;
        updated?: number | null;
        type?: {
          __typename?: 'AlertType';
          id?: string | null;
          name?: string | null;
        } | null;
        device?: {
          __typename?: 'AlertDevice';
          id: string;
          name?: string | null;
          type: string;
        } | null;
        affectedSource?: {
          __typename?: 'Source';
          _id: string;
          name: string;
        } | null;
      }> | null;
    } | null;
    deviceAlerts: Array<{
      __typename?: 'Alert';
      _id: string;
      initiated?: number | null;
      updated?: number | null;
      type?: { __typename?: 'AlertType'; name?: string | null } | null;
      device?: {
        __typename?: 'AlertDevice';
        id: string;
        name?: string | null;
        type: string;
      } | null;
    } | null>;
    sourceAlerts: Array<{
      __typename?: 'Alert';
      _id: string;
      initiated?: number | null;
      updated?: number | null;
      type?: { __typename?: 'AlertType'; name?: string | null } | null;
      device?: {
        __typename?: 'AlertDevice';
        id: string;
        name?: string | null;
        type: string;
      } | null;
    } | null>;
  } | null;
};

export type ChillerDetailUpdateSubscriptionVariables = Exact<{
  ids: Array<Scalars['String']> | Scalars['String'];
}>;

export type ChillerDetailUpdateSubscription = {
  __typename?: 'Subscription';
  chillerEventsByIds?: {
    __typename?: 'Chiller';
    modelChangeOperation?: string | null;
    _id: string;
    type?: EnumDKeyDeviceType | null;
    typeDisplayName: string;
    panelId?: string | null;
    name?: string | null;
    displayName?: string | null;
    deviceId?: string | null;
    isConfigured?: boolean | null;
    isPoweredOn?: boolean | null;
    hasPendingUpdates: boolean;
    timestamp?: number | null;
    panel?: {
      __typename?: 'Panel';
      _id: string;
      sourceId: string;
      name?: string | null;
      displayName?: string | null;
      type: EnumPanelType;
    } | null;
    powerState?: {
      __typename?: 'DevicePowerState';
      timestamp?: number | null;
      units?: string | null;
      value?: EnumDevicePowerStateValue | null;
      updatePending?: boolean | null;
    } | null;
    meta?: {
      __typename?: 'DeviceMeta';
      name?: string | null;
      model?: string | null;
      modelNumber?: string | null;
      version?: string | null;
    } | null;
    deviceMetrics?: Array<{
      __typename?: 'DeviceMetric';
      key: string;
      value: { __typename?: 'DeviceMetricSpec'; readOnly?: boolean | null };
    } | null> | null;
    source?: { __typename?: 'Source'; _id: string; name: string } | null;
    chilledSupplyTemperature?: {
      __typename?: 'ChillerChilledSupplyTemperature';
      timestamp?: number | null;
      value?: number | null;
      units?: string | null;
    } | null;
    chilledReturnTemperature?: {
      __typename?: 'ChillerChilledReturnTemperature';
      timestamp?: number | null;
      value?: number | null;
      units?: string | null;
    } | null;
    coolSetpoint?: {
      __typename?: 'ChillerCoolSetpoint';
      timestamp?: number | null;
      value?: number | null;
      units?: string | null;
    } | null;
    ambientTemperature?: {
      __typename?: 'ChillerAmbientTemperature';
      timestamp?: number | null;
      value?: number | null;
      units?: string | null;
    } | null;
    deviceAlerts: Array<{
      __typename?: 'Alert';
      _id: string;
      initiated?: number | null;
      updated?: number | null;
      type?: { __typename?: 'AlertType'; name?: string | null } | null;
      device?: {
        __typename?: 'AlertDevice';
        id: string;
        name?: string | null;
        type: string;
      } | null;
    } | null>;
    sourceAlerts: Array<{
      __typename?: 'Alert';
      _id: string;
      initiated?: number | null;
      updated?: number | null;
      type?: { __typename?: 'AlertType'; name?: string | null } | null;
      device?: {
        __typename?: 'AlertDevice';
        id: string;
        name?: string | null;
        type: string;
      } | null;
    } | null>;
  } | null;
};

export type ChillerDetailQueryVariables = Exact<{
  id: Scalars['String'];
}>;

export type ChillerDetailQuery = {
  __typename?: 'Query';
  chillerById?: {
    __typename?: 'Chiller';
    _id: string;
    type?: EnumDKeyDeviceType | null;
    typeDisplayName: string;
    panelId?: string | null;
    name?: string | null;
    displayName?: string | null;
    deviceId?: string | null;
    isConfigured?: boolean | null;
    isPoweredOn?: boolean | null;
    hasPendingUpdates: boolean;
    timestamp?: number | null;
    panel?: {
      __typename?: 'Panel';
      _id: string;
      sourceId: string;
      name?: string | null;
      displayName?: string | null;
      type: EnumPanelType;
    } | null;
    powerState?: {
      __typename?: 'DevicePowerState';
      timestamp?: number | null;
      units?: string | null;
      value?: EnumDevicePowerStateValue | null;
      updatePending?: boolean | null;
    } | null;
    meta?: {
      __typename?: 'DeviceMeta';
      name?: string | null;
      model?: string | null;
      modelNumber?: string | null;
      version?: string | null;
    } | null;
    deviceMetrics?: Array<{
      __typename?: 'DeviceMetric';
      key: string;
      value: { __typename?: 'DeviceMetricSpec'; readOnly?: boolean | null };
    } | null> | null;
    source?: { __typename?: 'Source'; _id: string; name: string } | null;
    chilledSupplyTemperature?: {
      __typename?: 'ChillerChilledSupplyTemperature';
      timestamp?: number | null;
      value?: number | null;
      units?: string | null;
    } | null;
    chilledReturnTemperature?: {
      __typename?: 'ChillerChilledReturnTemperature';
      timestamp?: number | null;
      value?: number | null;
      units?: string | null;
    } | null;
    coolSetpoint?: {
      __typename?: 'ChillerCoolSetpoint';
      timestamp?: number | null;
      value?: number | null;
      units?: string | null;
    } | null;
    ambientTemperature?: {
      __typename?: 'ChillerAmbientTemperature';
      timestamp?: number | null;
      value?: number | null;
      units?: string | null;
    } | null;
    deviceAlerts: Array<{
      __typename?: 'Alert';
      _id: string;
      initiated?: number | null;
      updated?: number | null;
      type?: { __typename?: 'AlertType'; name?: string | null } | null;
      device?: {
        __typename?: 'AlertDevice';
        id: string;
        name?: string | null;
        type: string;
      } | null;
    } | null>;
    sourceAlerts: Array<{
      __typename?: 'Alert';
      _id: string;
      initiated?: number | null;
      updated?: number | null;
      type?: { __typename?: 'AlertType'; name?: string | null } | null;
      device?: {
        __typename?: 'AlertDevice';
        id: string;
        name?: string | null;
        type: string;
      } | null;
    } | null>;
  } | null;
};

export type ControllerDetailUpdateSubscriptionVariables = Exact<{
  ids: Array<Scalars['String']> | Scalars['String'];
}>;

export type ControllerDetailUpdateSubscription = {
  __typename?: 'Subscription';
  controllerEventsByIds?: {
    __typename?: 'Controller';
    modelChangeOperation?: string | null;
    _id: string;
    type?: EnumDKeyDeviceType | null;
    typeDisplayName: string;
    panelId?: string | null;
    name?: string | null;
    deviceId?: string | null;
    sourceId?: string | null;
    timestamp?: number | null;
    isConfigured?: boolean | null;
    displayName?: string | null;
    meta?: {
      __typename?: 'DeviceMeta';
      name?: string | null;
      model?: string | null;
      modelNumber?: string | null;
      version?: string | null;
      metrics?: any | null;
    } | null;
    panel?: {
      __typename?: 'Panel';
      _id: string;
      name?: string | null;
      displayName?: string | null;
      type: EnumPanelType;
      sourceId: string;
    } | null;
    source?: { __typename?: 'Source'; _id: string; name: string } | null;
    communicationState?: {
      __typename?: 'ControllerCommunicationState';
      timestamp?: number | null;
      value?: boolean | null;
      units?: string | null;
    } | null;
    activeAlarmCount?: {
      __typename?: 'ControllerActiveAlarmCount';
      timestamp?: number | null;
      value?: number | null;
      units?: string | null;
    } | null;
    resetCount?: {
      __typename?: 'ControllerResetCount';
      timestamp?: number | null;
      value?: number | null;
      units?: string | null;
    } | null;
  } | null;
};

export type ControllerDetailQueryVariables = Exact<{
  id: Scalars['String'];
}>;

export type ControllerDetailQuery = {
  __typename?: 'Query';
  controllerById?: {
    __typename?: 'Controller';
    _id: string;
    type?: EnumDKeyDeviceType | null;
    typeDisplayName: string;
    panelId?: string | null;
    name?: string | null;
    deviceId?: string | null;
    sourceId?: string | null;
    timestamp?: number | null;
    isConfigured?: boolean | null;
    displayName?: string | null;
    meta?: {
      __typename?: 'DeviceMeta';
      name?: string | null;
      model?: string | null;
      modelNumber?: string | null;
      version?: string | null;
      metrics?: any | null;
    } | null;
    panel?: {
      __typename?: 'Panel';
      _id: string;
      name?: string | null;
      displayName?: string | null;
      type: EnumPanelType;
      sourceId: string;
    } | null;
    source?: { __typename?: 'Source'; _id: string; name: string } | null;
    communicationState?: {
      __typename?: 'ControllerCommunicationState';
      timestamp?: number | null;
      value?: boolean | null;
      units?: string | null;
    } | null;
    activeAlarmCount?: {
      __typename?: 'ControllerActiveAlarmCount';
      timestamp?: number | null;
      value?: number | null;
      units?: string | null;
    } | null;
    resetCount?: {
      __typename?: 'ControllerResetCount';
      timestamp?: number | null;
      value?: number | null;
      units?: string | null;
    } | null;
  } | null;
};

export type GpioDetailUpdateSubscriptionVariables = Exact<{
  ids: Array<Scalars['String']> | Scalars['String'];
}>;

export type GpioDetailUpdateSubscription = {
  __typename?: 'Subscription';
  gPIOEventsByIds?: {
    __typename?: 'GPIO';
    modelChangeOperation?: string | null;
    _id: string;
    type?: EnumDKeyDeviceType | null;
    typeDisplayName: string;
    panelId?: string | null;
    name?: string | null;
    deviceId?: string | null;
    isConfigured?: boolean | null;
    timestamp?: number | null;
    meta?: {
      __typename?: 'DeviceMeta';
      name?: string | null;
      model?: string | null;
      modelNumber?: string | null;
      version?: string | null;
    } | null;
    state?: {
      __typename?: 'GPIOState';
      timestamp?: number | null;
      value?: boolean | null;
      units?: string | null;
    } | null;
    deviceAlerts: Array<{
      __typename?: 'Alert';
      _id: string;
      initiated?: number | null;
      updated?: number | null;
      type?: { __typename?: 'AlertType'; name?: string | null } | null;
      device?: {
        __typename?: 'AlertDevice';
        id: string;
        name?: string | null;
        type: string;
      } | null;
    } | null>;
    sourceAlerts: Array<{
      __typename?: 'Alert';
      _id: string;
      initiated?: number | null;
      updated?: number | null;
      type?: { __typename?: 'AlertType'; name?: string | null } | null;
      device?: {
        __typename?: 'AlertDevice';
        id: string;
        name?: string | null;
        type: string;
      } | null;
    } | null>;
    panel?: {
      __typename?: 'Panel';
      _id: string;
      sourceId: string;
      name?: string | null;
    } | null;
    source?: { __typename?: 'Source'; _id: string; name: string } | null;
  } | null;
};

export type GpioDetailQueryVariables = Exact<{
  id: Scalars['String'];
}>;

export type GpioDetailQuery = {
  __typename?: 'Query';
  gPIOById?: {
    __typename?: 'GPIO';
    _id: string;
    type?: EnumDKeyDeviceType | null;
    typeDisplayName: string;
    panelId?: string | null;
    name?: string | null;
    deviceId?: string | null;
    isConfigured?: boolean | null;
    timestamp?: number | null;
    meta?: {
      __typename?: 'DeviceMeta';
      name?: string | null;
      model?: string | null;
      modelNumber?: string | null;
      version?: string | null;
    } | null;
    panel?: {
      __typename?: 'Panel';
      _id: string;
      sourceId: string;
      name?: string | null;
    } | null;
    source?: { __typename?: 'Source'; _id: string; name: string } | null;
    state?: {
      __typename?: 'GPIOState';
      timestamp?: number | null;
      value?: boolean | null;
      units?: string | null;
    } | null;
    deviceAlerts: Array<{
      __typename?: 'Alert';
      _id: string;
      initiated?: number | null;
      updated?: number | null;
      type?: { __typename?: 'AlertType'; name?: string | null } | null;
      device?: {
        __typename?: 'AlertDevice';
        id: string;
        name?: string | null;
        type: string;
      } | null;
    } | null>;
    sourceAlerts: Array<{
      __typename?: 'Alert';
      _id: string;
      initiated?: number | null;
      updated?: number | null;
      type?: { __typename?: 'AlertType'; name?: string | null } | null;
      device?: {
        __typename?: 'AlertDevice';
        id: string;
        name?: string | null;
        type: string;
      } | null;
    } | null>;
  } | null;
};

export type GpioPanelDetailUpdateSubscriptionVariables = Exact<{
  ids: Array<Scalars['String']> | Scalars['String'];
}>;

export type GpioPanelDetailUpdateSubscription = {
  __typename?: 'Subscription';
  panelEventsByIds?: {
    __typename?: 'Panel';
    modelChangeOperation?: string | null;
    _id: string;
    name?: string | null;
    displayName?: string | null;
    role?: string | null;
    type: EnumPanelType;
    sourceId: string;
    source?: { __typename?: 'Source'; _id: string; name: string } | null;
    alerts?: Array<{
      __typename?: 'Alert';
      _id: string;
      initiated?: number | null;
      updated?: number | null;
      type?: {
        __typename?: 'AlertType';
        id?: string | null;
        name?: string | null;
      } | null;
      panel?: { __typename?: 'AlertPanel'; id?: string | null } | null;
      device?: {
        __typename?: 'AlertDevice';
        id: string;
        name?: string | null;
        type: string;
      } | null;
      affectedSource?: {
        __typename?: 'Source';
        _id: string;
        name: string;
      } | null;
    }> | null;
  } | null;
};

export type GpioPanelDetailQueryVariables = Exact<{
  id: Scalars['String'];
}>;

export type GpioPanelDetailQuery = {
  __typename?: 'Query';
  panel?: {
    __typename?: 'Panel';
    _id: string;
    name?: string | null;
    displayName?: string | null;
    role?: string | null;
    type: EnumPanelType;
    sourceId: string;
    source?: { __typename?: 'Source'; _id: string; name: string } | null;
    devices: Array<
      | {
          __typename?: 'Actuator';
          _id: string;
          type?: EnumDKeyDeviceType | null;
          typeDisplayName: string;
          name?: string | null;
          deviceId?: string | null;
          timestamp?: number | null;
        }
      | {
          __typename?: 'BatteryManagementSystem';
          _id: string;
          type?: EnumDKeyDeviceType | null;
          typeDisplayName: string;
          name?: string | null;
          deviceId?: string | null;
          timestamp?: number | null;
        }
      | {
          __typename?: 'Boiler';
          _id: string;
          type?: EnumDKeyDeviceType | null;
          typeDisplayName: string;
          name?: string | null;
          deviceId?: string | null;
          timestamp?: number | null;
        }
      | {
          __typename?: 'Chiller';
          _id: string;
          type?: EnumDKeyDeviceType | null;
          typeDisplayName: string;
          name?: string | null;
          deviceId?: string | null;
          timestamp?: number | null;
        }
      | {
          __typename?: 'ConductorGenericSensor';
          _id: string;
          type?: EnumDKeyDeviceType | null;
          typeDisplayName: string;
          name?: string | null;
          deviceId?: string | null;
          timestamp?: number | null;
        }
      | {
          __typename?: 'Controller';
          _id: string;
          type?: EnumDKeyDeviceType | null;
          typeDisplayName: string;
          name?: string | null;
          deviceId?: string | null;
          timestamp?: number | null;
        }
      | {
          __typename?: 'Device';
          _id: string;
          type?: EnumDKeyDeviceType | null;
          typeDisplayName: string;
          name?: string | null;
          deviceId?: string | null;
          timestamp?: number | null;
        }
      | {
          __typename?: 'DoorSensor';
          _id: string;
          type?: EnumDKeyDeviceType | null;
          typeDisplayName: string;
          name?: string | null;
          deviceId?: string | null;
          timestamp?: number | null;
        }
      | {
          __typename?: 'EnergyController';
          _id: string;
          type?: EnumDKeyDeviceType | null;
          typeDisplayName: string;
          name?: string | null;
          deviceId?: string | null;
          timestamp?: number | null;
        }
      | {
          __typename?: 'EnergyConverter';
          _id: string;
          type?: EnumDKeyDeviceType | null;
          typeDisplayName: string;
          name?: string | null;
          deviceId?: string | null;
          timestamp?: number | null;
        }
      | {
          __typename?: 'EnergyInverter';
          _id: string;
          type?: EnumDKeyDeviceType | null;
          typeDisplayName: string;
          name?: string | null;
          deviceId?: string | null;
          timestamp?: number | null;
        }
      | {
          __typename?: 'EnergyMeter';
          _id: string;
          type?: EnumDKeyDeviceType | null;
          typeDisplayName: string;
          name?: string | null;
          deviceId?: string | null;
          timestamp?: number | null;
        }
      | {
          __typename?: 'EnergyRectifier';
          _id: string;
          type?: EnumDKeyDeviceType | null;
          typeDisplayName: string;
          name?: string | null;
          deviceId?: string | null;
          timestamp?: number | null;
        }
      | {
          __typename?: 'EnergyStorageCoolingSystem';
          _id: string;
          type?: EnumDKeyDeviceType | null;
          typeDisplayName: string;
          name?: string | null;
          deviceId?: string | null;
          timestamp?: number | null;
        }
      | {
          __typename?: 'EnergySwitchPanel';
          _id: string;
          type?: EnumDKeyDeviceType | null;
          typeDisplayName: string;
          name?: string | null;
          deviceId?: string | null;
          timestamp?: number | null;
        }
      | {
          __typename?: 'EnergySwitchPanelCircuit';
          _id: string;
          type?: EnumDKeyDeviceType | null;
          typeDisplayName: string;
          name?: string | null;
          deviceId?: string | null;
          timestamp?: number | null;
        }
      | {
          __typename?: 'FireSuppressionSystem';
          _id: string;
          type?: EnumDKeyDeviceType | null;
          typeDisplayName: string;
          name?: string | null;
          deviceId?: string | null;
          timestamp?: number | null;
        }
      | {
          __typename?: 'GPIO';
          _id: string;
          type?: EnumDKeyDeviceType | null;
          typeDisplayName: string;
          name?: string | null;
          deviceId?: string | null;
          timestamp?: number | null;
          state?: {
            __typename?: 'GPIOState';
            id?: string | null;
            value?: boolean | null;
          } | null;
        }
      | {
          __typename?: 'IndoorAirHandler';
          _id: string;
          type?: EnumDKeyDeviceType | null;
          typeDisplayName: string;
          name?: string | null;
          deviceId?: string | null;
          timestamp?: number | null;
        }
      | {
          __typename?: 'IndoorSensor';
          _id: string;
          type?: EnumDKeyDeviceType | null;
          typeDisplayName: string;
          name?: string | null;
          deviceId?: string | null;
          timestamp?: number | null;
        }
      | {
          __typename?: 'KineticEnergyManagementSystem';
          _id: string;
          type?: EnumDKeyDeviceType | null;
          typeDisplayName: string;
          name?: string | null;
          deviceId?: string | null;
          timestamp?: number | null;
        }
      | {
          __typename?: 'LeakDetector';
          _id: string;
          type?: EnumDKeyDeviceType | null;
          typeDisplayName: string;
          name?: string | null;
          deviceId?: string | null;
          timestamp?: number | null;
        }
      | {
          __typename?: 'Loop';
          _id: string;
          type?: EnumDKeyDeviceType | null;
          typeDisplayName: string;
          name?: string | null;
          deviceId?: string | null;
          timestamp?: number | null;
        }
      | {
          __typename?: 'ModbusAirHandler';
          _id: string;
          type?: EnumDKeyDeviceType | null;
          typeDisplayName: string;
          name?: string | null;
          deviceId?: string | null;
          timestamp?: number | null;
        }
      | {
          __typename?: 'OccupancySensor';
          _id: string;
          type?: EnumDKeyDeviceType | null;
          typeDisplayName: string;
          name?: string | null;
          deviceId?: string | null;
          timestamp?: number | null;
        }
      | {
          __typename?: 'OpenWeather';
          _id: string;
          type?: EnumDKeyDeviceType | null;
          typeDisplayName: string;
          name?: string | null;
          deviceId?: string | null;
          timestamp?: number | null;
        }
      | {
          __typename?: 'OutdoorSensor';
          _id: string;
          type?: EnumDKeyDeviceType | null;
          typeDisplayName: string;
          name?: string | null;
          deviceId?: string | null;
          timestamp?: number | null;
        }
      | {
          __typename?: 'PowerMonitor';
          _id: string;
          type?: EnumDKeyDeviceType | null;
          typeDisplayName: string;
          name?: string | null;
          deviceId?: string | null;
          timestamp?: number | null;
        }
      | {
          __typename?: 'PressureSensor';
          _id: string;
          type?: EnumDKeyDeviceType | null;
          typeDisplayName: string;
          name?: string | null;
          deviceId?: string | null;
          timestamp?: number | null;
        }
      | {
          __typename?: 'RelayDevice';
          _id: string;
          type?: EnumDKeyDeviceType | null;
          typeDisplayName: string;
          name?: string | null;
          deviceId?: string | null;
          timestamp?: number | null;
        }
      | {
          __typename?: 'SmartPowerOutlet';
          _id: string;
          type?: EnumDKeyDeviceType | null;
          typeDisplayName: string;
          name?: string | null;
          deviceId?: string | null;
          timestamp?: number | null;
        }
      | {
          __typename?: 'SolarManagementSystem';
          _id: string;
          type?: EnumDKeyDeviceType | null;
          typeDisplayName: string;
          name?: string | null;
          deviceId?: string | null;
          timestamp?: number | null;
        }
      | {
          __typename?: 'Thermistor';
          _id: string;
          type?: EnumDKeyDeviceType | null;
          typeDisplayName: string;
          name?: string | null;
          deviceId?: string | null;
          timestamp?: number | null;
        }
      | {
          __typename?: 'Thermostat';
          _id: string;
          type?: EnumDKeyDeviceType | null;
          typeDisplayName: string;
          name?: string | null;
          deviceId?: string | null;
          timestamp?: number | null;
        }
      | {
          __typename?: 'VSDPump';
          _id: string;
          type?: EnumDKeyDeviceType | null;
          typeDisplayName: string;
          name?: string | null;
          deviceId?: string | null;
          timestamp?: number | null;
        }
      | {
          __typename?: 'WindManagementSystem';
          _id: string;
          type?: EnumDKeyDeviceType | null;
          typeDisplayName: string;
          name?: string | null;
          deviceId?: string | null;
          timestamp?: number | null;
        }
      | {
          __typename?: 'WindowSensor';
          _id: string;
          type?: EnumDKeyDeviceType | null;
          typeDisplayName: string;
          name?: string | null;
          deviceId?: string | null;
          timestamp?: number | null;
        }
      | {
          __typename?: 'Z210Pump';
          _id: string;
          type?: EnumDKeyDeviceType | null;
          typeDisplayName: string;
          name?: string | null;
          deviceId?: string | null;
          timestamp?: number | null;
        }
    >;
    alerts?: Array<{
      __typename?: 'Alert';
      _id: string;
      initiated?: number | null;
      updated?: number | null;
      type?: {
        __typename?: 'AlertType';
        id?: string | null;
        name?: string | null;
      } | null;
      panel?: { __typename?: 'AlertPanel'; id?: string | null } | null;
      device?: {
        __typename?: 'AlertDevice';
        id: string;
        name?: string | null;
        type: string;
      } | null;
      affectedSource?: {
        __typename?: 'Source';
        _id: string;
        name: string;
      } | null;
    }> | null;
  } | null;
};

export type LoopDetailUpdateSubscriptionVariables = Exact<{
  ids: Array<Scalars['String']> | Scalars['String'];
}>;

export type LoopDetailUpdateSubscription = {
  __typename?: 'Subscription';
  panelEventsByIds?: {
    __typename?: 'Panel';
    modelChangeOperation?: string | null;
    _id: string;
    name?: string | null;
    displayName?: string | null;
    type: EnumPanelType;
    role?: string | null;
    sourceId: string;
    alerts?: Array<{
      __typename?: 'Alert';
      _id: string;
      initiated?: number | null;
      updated?: number | null;
      type?: {
        __typename?: 'AlertType';
        id?: string | null;
        name?: string | null;
      } | null;
      device?: {
        __typename?: 'AlertDevice';
        id: string;
        name?: string | null;
        type: string;
      } | null;
      affectedSource?: {
        __typename?: 'Source';
        _id: string;
        name: string;
      } | null;
    }> | null;
  } | null;
};

export type LoopDetailQueryVariables = Exact<{
  id: Scalars['String'];
}>;

export type LoopDetailQuery = {
  __typename?: 'Query';
  panel?: {
    __typename?: 'Panel';
    _id: string;
    name?: string | null;
    displayName?: string | null;
    type: EnumPanelType;
    role?: string | null;
    sourceId: string;
    source?: { __typename?: 'Source'; _id: string; name: string } | null;
    alerts?: Array<{
      __typename?: 'Alert';
      _id: string;
      initiated?: number | null;
      updated?: number | null;
      sourceId?: string | null;
      type?: {
        __typename?: 'AlertType';
        id?: string | null;
        name?: string | null;
      } | null;
      panel?: { __typename?: 'AlertPanel'; id?: string | null } | null;
      device?: {
        __typename?: 'AlertDevice';
        id: string;
        name?: string | null;
        type: string;
      } | null;
      affectedSource?: {
        __typename?: 'Source';
        _id: string;
        name: string;
      } | null;
    }> | null;
  } | null;
};

export type LoopPumpsUpdateSubscriptionVariables = Exact<{
  ids: Array<Scalars['String']> | Scalars['String'];
}>;

export type LoopPumpsUpdateSubscription = {
  __typename?: 'Subscription';
  vSDPumpEventsByIds?: {
    __typename?: 'VSDPump';
    modelChangeOperation?: string | null;
    _id: string;
    hasPendingUpdates: boolean;
    alertTypes?: {
      __typename?: 'DeviceAlertTypes';
      deviceOffline?: boolean | null;
      sourceOffline?: boolean | null;
    } | null;
    stopOrStart?: {
      __typename?: 'VSDPumpStopOrStart';
      id?: string | null;
      timestamp?: number | null;
      value?: number | null;
      units?: string | null;
      updatePending?: boolean | null;
    } | null;
  } | null;
};

export type OpenWeatherDetailUpdateSubscriptionVariables = Exact<{
  ids: Array<Scalars['String']> | Scalars['String'];
}>;

export type OpenWeatherDetailUpdateSubscription = {
  __typename?: 'Subscription';
  openWeatherEventsByIds?: {
    __typename?: 'OpenWeather';
    modelChangeOperation?: string | null;
    _id: string;
    type?: EnumDKeyDeviceType | null;
    typeDisplayName: string;
    panelId?: string | null;
    name?: string | null;
    deviceId?: string | null;
    timestamp?: number | null;
    isConfigured?: boolean | null;
    meta?: {
      __typename?: 'DeviceMeta';
      name?: string | null;
      model?: string | null;
      modelNumber?: string | null;
      version?: string | null;
    } | null;
    temperature?: {
      __typename?: 'OpenWeatherTemperature';
      timestamp?: number | null;
      value?: number | null;
      units?: string | null;
    } | null;
    panel?: {
      __typename?: 'Panel';
      _id: string;
      name?: string | null;
      displayName?: string | null;
      role?: string | null;
      type: EnumPanelType;
      sourceId: string;
      alerts?: Array<{
        __typename?: 'Alert';
        _id: string;
        initiated?: number | null;
        updated?: number | null;
        sourceId?: string | null;
        type?: {
          __typename?: 'AlertType';
          id?: string | null;
          name?: string | null;
        } | null;
        panel?: { __typename?: 'AlertPanel'; id?: string | null } | null;
        device?: {
          __typename?: 'AlertDevice';
          id: string;
          name?: string | null;
          type: string;
        } | null;
        affectedSource?: {
          __typename?: 'Source';
          _id: string;
          name: string;
        } | null;
      }> | null;
    } | null;
    deviceAlerts: Array<{
      __typename?: 'Alert';
      _id: string;
      initiated?: number | null;
      updated?: number | null;
      type?: { __typename?: 'AlertType'; name?: string | null } | null;
      device?: {
        __typename?: 'AlertDevice';
        id: string;
        name?: string | null;
        type: string;
      } | null;
    } | null>;
    sourceAlerts: Array<{
      __typename?: 'Alert';
      _id: string;
      initiated?: number | null;
      updated?: number | null;
      type?: { __typename?: 'AlertType'; name?: string | null } | null;
      device?: {
        __typename?: 'AlertDevice';
        id: string;
        name?: string | null;
        type: string;
      } | null;
    } | null>;
  } | null;
};

export type OpenWeatherDetailQueryVariables = Exact<{
  id: Scalars['String'];
}>;

export type OpenWeatherDetailQuery = {
  __typename?: 'Query';
  openWeatherById?: {
    __typename?: 'OpenWeather';
    _id: string;
    type?: EnumDKeyDeviceType | null;
    typeDisplayName: string;
    panelId?: string | null;
    name?: string | null;
    deviceId?: string | null;
    timestamp?: number | null;
    isConfigured?: boolean | null;
    meta?: {
      __typename?: 'DeviceMeta';
      name?: string | null;
      model?: string | null;
      modelNumber?: string | null;
      version?: string | null;
      location?: string | null;
    } | null;
    source?: { __typename?: 'Source'; _id: string; name: string } | null;
    temperature?: {
      __typename?: 'OpenWeatherTemperature';
      timestamp?: number | null;
      value?: number | null;
      units?: string | null;
    } | null;
    panel?: {
      __typename?: 'Panel';
      _id: string;
      name?: string | null;
      displayName?: string | null;
      role?: string | null;
      type: EnumPanelType;
      sourceId: string;
      alerts?: Array<{
        __typename?: 'Alert';
        _id: string;
        initiated?: number | null;
        updated?: number | null;
        sourceId?: string | null;
        type?: {
          __typename?: 'AlertType';
          id?: string | null;
          name?: string | null;
        } | null;
        panel?: { __typename?: 'AlertPanel'; id?: string | null } | null;
        device?: {
          __typename?: 'AlertDevice';
          id: string;
          name?: string | null;
          type: string;
        } | null;
        affectedSource?: {
          __typename?: 'Source';
          _id: string;
          name: string;
        } | null;
      }> | null;
    } | null;
    deviceAlerts: Array<{
      __typename?: 'Alert';
      _id: string;
      initiated?: number | null;
      updated?: number | null;
      type?: { __typename?: 'AlertType'; name?: string | null } | null;
      device?: {
        __typename?: 'AlertDevice';
        id: string;
        name?: string | null;
        type: string;
      } | null;
    } | null>;
    sourceAlerts: Array<{
      __typename?: 'Alert';
      _id: string;
      initiated?: number | null;
      updated?: number | null;
      type?: { __typename?: 'AlertType'; name?: string | null } | null;
      device?: {
        __typename?: 'AlertDevice';
        id: string;
        name?: string | null;
        type: string;
      } | null;
    } | null>;
  } | null;
};

export type OutdoorSensorDetailQueryVariables = Exact<{
  id: Scalars['String'];
}>;

export type OutdoorSensorDetailQuery = {
  __typename?: 'Query';
  outdoorSensorById?: {
    __typename?: 'OutdoorSensor';
    _id: string;
    type?: EnumDKeyDeviceType | null;
    typeDisplayName: string;
    panelId?: string | null;
    name?: string | null;
    deviceId?: string | null;
    timestamp?: number | null;
    isConfigured?: boolean | null;
    meta?: {
      __typename?: 'DeviceMeta';
      name?: string | null;
      model?: string | null;
      modelNumber?: string | null;
      version?: string | null;
    } | null;
    panel?: {
      __typename?: 'Panel';
      _id: string;
      sourceId: string;
      name?: string | null;
      displayName?: string | null;
      role?: string | null;
      type: EnumPanelType;
    } | null;
    source?: { __typename?: 'Source'; _id: string; name: string } | null;
    temperature?: {
      __typename?: 'OutdoorSensorTemperature';
      timestamp?: number | null;
      value?: number | null;
      units?: string | null;
    } | null;
    deviceAlerts: Array<{
      __typename?: 'Alert';
      _id: string;
      initiated?: number | null;
      updated?: number | null;
      type?: { __typename?: 'AlertType'; name?: string | null } | null;
      device?: {
        __typename?: 'AlertDevice';
        id: string;
        name?: string | null;
        type: string;
      } | null;
    } | null>;
    sourceAlerts: Array<{
      __typename?: 'Alert';
      _id: string;
      initiated?: number | null;
      updated?: number | null;
      type?: { __typename?: 'AlertType'; name?: string | null } | null;
      device?: {
        __typename?: 'AlertDevice';
        id: string;
        name?: string | null;
        type: string;
      } | null;
    } | null>;
  } | null;
};

export type PowerMonitorDetailUpdateSubscriptionVariables = Exact<{
  ids: Array<Scalars['String']> | Scalars['String'];
}>;

export type PowerMonitorDetailUpdateSubscription = {
  __typename?: 'Subscription';
  powerMonitorEventsByIds?: {
    __typename?: 'PowerMonitor';
    modelChangeOperation?: string | null;
    _id: string;
    panelId?: string | null;
    name?: string | null;
    type?: EnumDKeyDeviceType | null;
    typeDisplayName: string;
    deviceId?: string | null;
    timestamp?: number | null;
    isConfigured?: boolean | null;
    supportsPhasedFrequencies?: boolean | null;
    supportsTotalFrequency?: boolean | null;
    supportsPhasedPowerFactors?: boolean | null;
    supportsTotalPowerFactor?: boolean | null;
    supportsPhasedActivePower?: boolean | null;
    supportsTotalActivePower?: boolean | null;
    supportsPhasedActiveEnergyFwd?: boolean | null;
    supportsTotalActiveEnergyFwd?: boolean | null;
    supportsPhasedActiveEnergyRev?: boolean | null;
    supportsTotalActiveEnergyRev?: boolean | null;
    meta?: {
      __typename?: 'DeviceMeta';
      name?: string | null;
      model?: string | null;
      modelNumber?: string | null;
      version?: string | null;
    } | null;
    source?: { __typename?: 'Source'; _id: string; name: string } | null;
    panel?: {
      __typename?: 'Panel';
      _id: string;
      sourceId: string;
      name?: string | null;
      displayName?: string | null;
      role?: string | null;
      type: EnumPanelType;
      alerts?: Array<{
        __typename?: 'Alert';
        _id: string;
        initiated?: number | null;
        updated?: number | null;
        sourceId?: string | null;
        type?: {
          __typename?: 'AlertType';
          id?: string | null;
          name?: string | null;
        } | null;
        panel?: { __typename?: 'AlertPanel'; id?: string | null } | null;
        device?: {
          __typename?: 'AlertDevice';
          id: string;
          name?: string | null;
          type: string;
        } | null;
        affectedSource?: {
          __typename?: 'Source';
          _id: string;
          name: string;
        } | null;
      }> | null;
    } | null;
    deviceAlerts: Array<{
      __typename?: 'Alert';
      _id: string;
      initiated?: number | null;
      updated?: number | null;
      type?: { __typename?: 'AlertType'; name?: string | null } | null;
      device?: {
        __typename?: 'AlertDevice';
        id: string;
        name?: string | null;
        type: string;
      } | null;
    } | null>;
    sourceAlerts: Array<{
      __typename?: 'Alert';
      _id: string;
      initiated?: number | null;
      updated?: number | null;
      type?: { __typename?: 'AlertType'; name?: string | null } | null;
      device?: {
        __typename?: 'AlertDevice';
        id: string;
        name?: string | null;
        type: string;
      } | null;
    } | null>;
    frequency?: {
      __typename?: 'PowerMonitorFrequency';
      units?: string | null;
      value?: number | null;
    } | null;
    phaseAFrequency?: {
      __typename?: 'PowerMonitorPhaseAFrequency';
      units?: string | null;
      value?: number | null;
    } | null;
    phaseBFrequency?: {
      __typename?: 'PowerMonitorPhaseBFrequency';
      units?: string | null;
      value?: number | null;
    } | null;
    phaseCFrequency?: {
      __typename?: 'PowerMonitorPhaseCFrequency';
      units?: string | null;
      value?: number | null;
    } | null;
    phaseAActiveEnergyFwd?: {
      __typename?: 'PowerMonitorPhaseAActiveEnergyFwd';
      units?: string | null;
      value?: number | null;
    } | null;
    phaseAActiveEnergyRev?: {
      __typename?: 'PowerMonitorPhaseAActiveEnergyRev';
      units?: string | null;
      value?: number | null;
    } | null;
    phaseAActivePower?: {
      __typename?: 'PowerMonitorPhaseAActivePower';
      units?: string | null;
      value?: number | null;
    } | null;
    phaseACurrent?: {
      __typename?: 'PowerMonitorPhaseACurrent';
      units?: string | null;
      value?: number | null;
    } | null;
    phaseAPowerFactor?: {
      __typename?: 'PowerMonitorPhaseAPowerFactor';
      units?: string | null;
      value?: number | null;
    } | null;
    phaseAVoltage?: {
      __typename?: 'PowerMonitorPhaseAVoltage';
      units?: string | null;
      value?: number | null;
    } | null;
    phaseBActiveEnergyFwd?: {
      __typename?: 'PowerMonitorPhaseBActiveEnergyFwd';
      units?: string | null;
      value?: number | null;
    } | null;
    phaseBActiveEnergyRev?: {
      __typename?: 'PowerMonitorPhaseBActiveEnergyRev';
      units?: string | null;
      value?: number | null;
    } | null;
    phaseBActivePower?: {
      __typename?: 'PowerMonitorPhaseBActivePower';
      units?: string | null;
      value?: number | null;
    } | null;
    phaseBCurrent?: {
      __typename?: 'PowerMonitorPhaseBCurrent';
      units?: string | null;
      value?: number | null;
    } | null;
    phaseBPowerFactor?: {
      __typename?: 'PowerMonitorPhaseBPowerFactor';
      units?: string | null;
      value?: number | null;
    } | null;
    phaseBVoltage?: {
      __typename?: 'PowerMonitorPhaseBVoltage';
      units?: string | null;
      value?: number | null;
    } | null;
    phaseCActiveEnergyFwd?: {
      __typename?: 'PowerMonitorPhaseCActiveEnergyFwd';
      units?: string | null;
      value?: number | null;
    } | null;
    phaseCActiveEnergyRev?: {
      __typename?: 'PowerMonitorPhaseCActiveEnergyRev';
      units?: string | null;
      value?: number | null;
    } | null;
    phaseCActivePower?: {
      __typename?: 'PowerMonitorPhaseCActivePower';
      units?: string | null;
      value?: number | null;
    } | null;
    phaseCCurrent?: {
      __typename?: 'PowerMonitorPhaseCCurrent';
      units?: string | null;
      value?: number | null;
    } | null;
    phaseCPowerFactor?: {
      __typename?: 'PowerMonitorPhaseCPowerFactor';
      units?: string | null;
      value?: number | null;
    } | null;
    phaseCVoltage?: {
      __typename?: 'PowerMonitorPhaseCVoltage';
      units?: string | null;
      value?: number | null;
    } | null;
    totalPowerFactor?: {
      __typename?: 'PowerMonitorTotalPowerFactor';
      units?: string | null;
      value?: number | null;
    } | null;
    totalActivePower?: {
      __typename?: 'PowerMonitorTotalActivePower';
      units?: string | null;
      value?: number | null;
    } | null;
    threePhaseTotalActiveEnergyFwd?: {
      __typename?: 'PowerMonitorThreePhaseTotalActiveEnergyFwd';
      units?: string | null;
      value?: number | null;
    } | null;
    threePhaseTotalActiveEnergyRev?: {
      __typename?: 'PowerMonitorThreePhaseTotalActiveEnergyRev';
      units?: string | null;
      value?: number | null;
    } | null;
  } | null;
};

export type PowerMonitorDetailQueryVariables = Exact<{
  id: Scalars['String'];
}>;

export type PowerMonitorDetailQuery = {
  __typename?: 'Query';
  powerMonitorById?: {
    __typename?: 'PowerMonitor';
    _id: string;
    panelId?: string | null;
    name?: string | null;
    type?: EnumDKeyDeviceType | null;
    typeDisplayName: string;
    deviceId?: string | null;
    timestamp?: number | null;
    isConfigured?: boolean | null;
    supportsPhasedFrequencies?: boolean | null;
    supportsTotalFrequency?: boolean | null;
    supportsPhasedPowerFactors?: boolean | null;
    supportsTotalPowerFactor?: boolean | null;
    supportsPhasedActivePower?: boolean | null;
    supportsTotalActivePower?: boolean | null;
    supportsPhasedActiveEnergyFwd?: boolean | null;
    supportsTotalActiveEnergyFwd?: boolean | null;
    supportsPhasedActiveEnergyRev?: boolean | null;
    supportsTotalActiveEnergyRev?: boolean | null;
    meta?: {
      __typename?: 'DeviceMeta';
      name?: string | null;
      model?: string | null;
      modelNumber?: string | null;
      version?: string | null;
    } | null;
    source?: { __typename?: 'Source'; _id: string; name: string } | null;
    panel?: {
      __typename?: 'Panel';
      _id: string;
      sourceId: string;
      name?: string | null;
      displayName?: string | null;
      role?: string | null;
      type: EnumPanelType;
      alerts?: Array<{
        __typename?: 'Alert';
        _id: string;
        initiated?: number | null;
        updated?: number | null;
        sourceId?: string | null;
        type?: {
          __typename?: 'AlertType';
          id?: string | null;
          name?: string | null;
        } | null;
        panel?: { __typename?: 'AlertPanel'; id?: string | null } | null;
        device?: {
          __typename?: 'AlertDevice';
          id: string;
          name?: string | null;
          type: string;
        } | null;
        affectedSource?: {
          __typename?: 'Source';
          _id: string;
          name: string;
        } | null;
      }> | null;
    } | null;
    deviceAlerts: Array<{
      __typename?: 'Alert';
      _id: string;
      initiated?: number | null;
      updated?: number | null;
      type?: { __typename?: 'AlertType'; name?: string | null } | null;
      device?: {
        __typename?: 'AlertDevice';
        id: string;
        name?: string | null;
        type: string;
      } | null;
    } | null>;
    sourceAlerts: Array<{
      __typename?: 'Alert';
      _id: string;
      initiated?: number | null;
      updated?: number | null;
      type?: { __typename?: 'AlertType'; name?: string | null } | null;
      device?: {
        __typename?: 'AlertDevice';
        id: string;
        name?: string | null;
        type: string;
      } | null;
    } | null>;
    frequency?: {
      __typename?: 'PowerMonitorFrequency';
      units?: string | null;
      value?: number | null;
    } | null;
    phaseAFrequency?: {
      __typename?: 'PowerMonitorPhaseAFrequency';
      units?: string | null;
      value?: number | null;
    } | null;
    phaseBFrequency?: {
      __typename?: 'PowerMonitorPhaseBFrequency';
      units?: string | null;
      value?: number | null;
    } | null;
    phaseCFrequency?: {
      __typename?: 'PowerMonitorPhaseCFrequency';
      units?: string | null;
      value?: number | null;
    } | null;
    phaseAActiveEnergyFwd?: {
      __typename?: 'PowerMonitorPhaseAActiveEnergyFwd';
      units?: string | null;
      value?: number | null;
    } | null;
    phaseAActiveEnergyRev?: {
      __typename?: 'PowerMonitorPhaseAActiveEnergyRev';
      units?: string | null;
      value?: number | null;
    } | null;
    phaseAActivePower?: {
      __typename?: 'PowerMonitorPhaseAActivePower';
      units?: string | null;
      value?: number | null;
    } | null;
    phaseACurrent?: {
      __typename?: 'PowerMonitorPhaseACurrent';
      units?: string | null;
      value?: number | null;
    } | null;
    phaseAPowerFactor?: {
      __typename?: 'PowerMonitorPhaseAPowerFactor';
      units?: string | null;
      value?: number | null;
    } | null;
    phaseAVoltage?: {
      __typename?: 'PowerMonitorPhaseAVoltage';
      units?: string | null;
      value?: number | null;
    } | null;
    phaseBActiveEnergyFwd?: {
      __typename?: 'PowerMonitorPhaseBActiveEnergyFwd';
      units?: string | null;
      value?: number | null;
    } | null;
    phaseBActiveEnergyRev?: {
      __typename?: 'PowerMonitorPhaseBActiveEnergyRev';
      units?: string | null;
      value?: number | null;
    } | null;
    phaseBActivePower?: {
      __typename?: 'PowerMonitorPhaseBActivePower';
      units?: string | null;
      value?: number | null;
    } | null;
    phaseBCurrent?: {
      __typename?: 'PowerMonitorPhaseBCurrent';
      units?: string | null;
      value?: number | null;
    } | null;
    phaseBPowerFactor?: {
      __typename?: 'PowerMonitorPhaseBPowerFactor';
      units?: string | null;
      value?: number | null;
    } | null;
    phaseBVoltage?: {
      __typename?: 'PowerMonitorPhaseBVoltage';
      units?: string | null;
      value?: number | null;
    } | null;
    phaseCActiveEnergyFwd?: {
      __typename?: 'PowerMonitorPhaseCActiveEnergyFwd';
      units?: string | null;
      value?: number | null;
    } | null;
    phaseCActiveEnergyRev?: {
      __typename?: 'PowerMonitorPhaseCActiveEnergyRev';
      units?: string | null;
      value?: number | null;
    } | null;
    phaseCActivePower?: {
      __typename?: 'PowerMonitorPhaseCActivePower';
      units?: string | null;
      value?: number | null;
    } | null;
    phaseCCurrent?: {
      __typename?: 'PowerMonitorPhaseCCurrent';
      units?: string | null;
      value?: number | null;
    } | null;
    phaseCPowerFactor?: {
      __typename?: 'PowerMonitorPhaseCPowerFactor';
      units?: string | null;
      value?: number | null;
    } | null;
    phaseCVoltage?: {
      __typename?: 'PowerMonitorPhaseCVoltage';
      units?: string | null;
      value?: number | null;
    } | null;
    totalPowerFactor?: {
      __typename?: 'PowerMonitorTotalPowerFactor';
      units?: string | null;
      value?: number | null;
    } | null;
    totalActivePower?: {
      __typename?: 'PowerMonitorTotalActivePower';
      units?: string | null;
      value?: number | null;
    } | null;
    threePhaseTotalActiveEnergyFwd?: {
      __typename?: 'PowerMonitorThreePhaseTotalActiveEnergyFwd';
      units?: string | null;
      value?: number | null;
    } | null;
    threePhaseTotalActiveEnergyRev?: {
      __typename?: 'PowerMonitorThreePhaseTotalActiveEnergyRev';
      units?: string | null;
      value?: number | null;
    } | null;
    deviceMetrics?: Array<{
      __typename?: 'DeviceMetric';
      key: string;
      value: {
        __typename?: 'DeviceMetricSpec';
        unit?: string | null;
        units?: string | null;
        valueType?: string | null;
      };
    } | null> | null;
  } | null;
};

export type PressureSensorDetailUpdateSubscriptionVariables = Exact<{
  ids: Array<Scalars['String']> | Scalars['String'];
}>;

export type PressureSensorDetailUpdateSubscription = {
  __typename?: 'Subscription';
  pressureSensorEventsByIds?: {
    __typename?: 'PressureSensor';
    modelChangeOperation?: string | null;
    _id: string;
    type?: EnumDKeyDeviceType | null;
    typeDisplayName: string;
    panelId?: string | null;
    name?: string | null;
    deviceId?: string | null;
    timestamp?: number | null;
    isConfigured?: boolean | null;
    role?: string | null;
    meta?: {
      __typename?: 'DeviceMeta';
      name?: string | null;
      model?: string | null;
      modelNumber?: string | null;
      version?: string | null;
    } | null;
    panel?: {
      __typename?: 'Panel';
      _id: string;
      sourceId: string;
      name?: string | null;
    } | null;
    pressure?: {
      __typename?: 'PressureSensorPressure';
      timestamp?: number | null;
      value?: number | null;
      units?: string | null;
    } | null;
    deviceAlerts: Array<{
      __typename?: 'Alert';
      _id: string;
      initiated?: number | null;
      updated?: number | null;
      type?: { __typename?: 'AlertType'; name?: string | null } | null;
      device?: {
        __typename?: 'AlertDevice';
        id: string;
        name?: string | null;
        type: string;
      } | null;
    } | null>;
    sourceAlerts: Array<{
      __typename?: 'Alert';
      _id: string;
      initiated?: number | null;
      updated?: number | null;
      type?: { __typename?: 'AlertType'; name?: string | null } | null;
      device?: {
        __typename?: 'AlertDevice';
        id: string;
        name?: string | null;
        type: string;
      } | null;
    } | null>;
  } | null;
};

export type PressureSensorDetailQueryVariables = Exact<{
  id: Scalars['String'];
}>;

export type PressureSensorDetailQuery = {
  __typename?: 'Query';
  pressureSensorById?: {
    __typename?: 'PressureSensor';
    _id: string;
    type?: EnumDKeyDeviceType | null;
    typeDisplayName: string;
    panelId?: string | null;
    name?: string | null;
    deviceId?: string | null;
    timestamp?: number | null;
    isConfigured?: boolean | null;
    role?: string | null;
    meta?: {
      __typename?: 'DeviceMeta';
      name?: string | null;
      model?: string | null;
      modelNumber?: string | null;
      version?: string | null;
    } | null;
    panel?: {
      __typename?: 'Panel';
      _id: string;
      sourceId: string;
      name?: string | null;
    } | null;
    source?: { __typename?: 'Source'; _id: string; name: string } | null;
    pressure?: {
      __typename?: 'PressureSensorPressure';
      timestamp?: number | null;
      value?: number | null;
      units?: string | null;
    } | null;
    deviceAlerts: Array<{
      __typename?: 'Alert';
      _id: string;
      initiated?: number | null;
      updated?: number | null;
      type?: { __typename?: 'AlertType'; name?: string | null } | null;
      device?: {
        __typename?: 'AlertDevice';
        id: string;
        name?: string | null;
        type: string;
      } | null;
    } | null>;
    sourceAlerts: Array<{
      __typename?: 'Alert';
      _id: string;
      initiated?: number | null;
      updated?: number | null;
      type?: { __typename?: 'AlertType'; name?: string | null } | null;
      device?: {
        __typename?: 'AlertDevice';
        id: string;
        name?: string | null;
        type: string;
      } | null;
    } | null>;
  } | null;
};

export type SwapPumpsMutationVariables = Exact<{
  primaryPumpId: Scalars['String'];
  secondaryPumpId: Scalars['String'];
}>;

export type SwapPumpsMutation = {
  __typename?: 'Mutation';
  swapVSDPumpOnOffState: Array<{
    __typename?: 'VSDPump';
    _id: string;
    hasPendingUpdates: boolean;
    stopOrStart?: {
      __typename?: 'VSDPumpStopOrStart';
      value?: number | null;
    } | null;
  }>;
};

export type ThermistorDetailUpdateSubscriptionVariables = Exact<{
  ids: Array<Scalars['String']> | Scalars['String'];
}>;

export type ThermistorDetailUpdateSubscription = {
  __typename?: 'Subscription';
  thermistorEventsByIds?: {
    __typename?: 'Thermistor';
    modelChangeOperation?: string | null;
    _id: string;
    type?: EnumDKeyDeviceType | null;
    typeDisplayName: string;
    panelId?: string | null;
    name?: string | null;
    deviceId?: string | null;
    isConfigured?: boolean | null;
    timestamp?: number | null;
    role?: string | null;
    meta?: {
      __typename?: 'DeviceMeta';
      name?: string | null;
      model?: string | null;
      modelNumber?: string | null;
      version?: string | null;
    } | null;
    temperature?: {
      __typename?: 'ThermistorTemperature';
      timestamp?: number | null;
      value?: number | null;
      units?: string | null;
    } | null;
    panel?: {
      __typename?: 'Panel';
      _id: string;
      sourceId: string;
      name?: string | null;
      role?: string | null;
      type: EnumPanelType;
      alerts?: Array<{
        __typename?: 'Alert';
        _id: string;
        initiated?: number | null;
        updated?: number | null;
        sourceId?: string | null;
        type?: {
          __typename?: 'AlertType';
          id?: string | null;
          name?: string | null;
        } | null;
        panel?: { __typename?: 'AlertPanel'; id?: string | null } | null;
        device?: {
          __typename?: 'AlertDevice';
          id: string;
          name?: string | null;
          type: string;
        } | null;
        affectedSource?: {
          __typename?: 'Source';
          _id: string;
          name: string;
        } | null;
      }> | null;
    } | null;
    deviceAlerts: Array<{
      __typename?: 'Alert';
      _id: string;
      initiated?: number | null;
      updated?: number | null;
      type?: { __typename?: 'AlertType'; name?: string | null } | null;
      device?: {
        __typename?: 'AlertDevice';
        id: string;
        name?: string | null;
        type: string;
      } | null;
    } | null>;
    sourceAlerts: Array<{
      __typename?: 'Alert';
      _id: string;
      initiated?: number | null;
      updated?: number | null;
      type?: { __typename?: 'AlertType'; name?: string | null } | null;
      device?: {
        __typename?: 'AlertDevice';
        id: string;
        name?: string | null;
        type: string;
      } | null;
    } | null>;
  } | null;
};

export type ThermistorDetailQueryVariables = Exact<{
  id: Scalars['String'];
}>;

export type ThermistorDetailQuery = {
  __typename?: 'Query';
  thermistorById?: {
    __typename?: 'Thermistor';
    _id: string;
    type?: EnumDKeyDeviceType | null;
    typeDisplayName: string;
    panelId?: string | null;
    name?: string | null;
    deviceId?: string | null;
    isConfigured?: boolean | null;
    timestamp?: number | null;
    role?: string | null;
    meta?: {
      __typename?: 'DeviceMeta';
      name?: string | null;
      model?: string | null;
      modelNumber?: string | null;
      version?: string | null;
    } | null;
    panel?: {
      __typename?: 'Panel';
      _id: string;
      sourceId: string;
      name?: string | null;
      displayName?: string | null;
      type: EnumPanelType;
      role?: string | null;
      alerts?: Array<{
        __typename?: 'Alert';
        _id: string;
        initiated?: number | null;
        updated?: number | null;
        sourceId?: string | null;
        type?: {
          __typename?: 'AlertType';
          id?: string | null;
          name?: string | null;
        } | null;
        panel?: { __typename?: 'AlertPanel'; id?: string | null } | null;
        device?: {
          __typename?: 'AlertDevice';
          id: string;
          name?: string | null;
          type: string;
        } | null;
        affectedSource?: {
          __typename?: 'Source';
          _id: string;
          name: string;
        } | null;
      }> | null;
    } | null;
    source?: { __typename?: 'Source'; _id: string; name: string } | null;
    temperature?: {
      __typename?: 'ThermistorTemperature';
      timestamp?: number | null;
      value?: number | null;
      units?: string | null;
    } | null;
    deviceAlerts: Array<{
      __typename?: 'Alert';
      _id: string;
      initiated?: number | null;
      updated?: number | null;
      type?: { __typename?: 'AlertType'; name?: string | null } | null;
      device?: {
        __typename?: 'AlertDevice';
        id: string;
        name?: string | null;
        type: string;
      } | null;
    } | null>;
    sourceAlerts: Array<{
      __typename?: 'Alert';
      _id: string;
      initiated?: number | null;
      updated?: number | null;
      type?: { __typename?: 'AlertType'; name?: string | null } | null;
      device?: {
        __typename?: 'AlertDevice';
        id: string;
        name?: string | null;
        type: string;
      } | null;
    } | null>;
  } | null;
};

export type ThermistorPairDetailQueryVariables = Exact<{
  ids: Array<Scalars['String']> | Scalars['String'];
}>;

export type ThermistorPairDetailQuery = {
  __typename?: 'Query';
  thermistorsByIds: Array<{
    __typename?: 'Thermistor';
    _id: string;
    type?: EnumDKeyDeviceType | null;
    typeDisplayName: string;
    panelId?: string | null;
    name?: string | null;
    deviceId?: string | null;
    temperature?: {
      __typename?: 'ThermistorTemperature';
      timestamp?: number | null;
      value?: number | null;
      units?: string | null;
    } | null;
  }>;
};

export type UpdateActuatorPositionMutationVariables = Exact<{
  deviceId: Scalars['String'];
  position?: InputMaybe<Scalars['Float']>;
  controlMode?: InputMaybe<Scalars['String']>;
}>;

export type UpdateActuatorPositionMutation = {
  __typename?: 'Mutation';
  updateActuatorPosition: {
    __typename?: 'Actuator';
    _id: string;
    hasPendingUpdates: boolean;
    position?: {
      __typename?: 'ActuatorPosition';
      value?: number | null;
      timestamp?: number | null;
    } | null;
    controlMode?: {
      __typename?: 'ActuatorControlMode';
      value?: EnumActuatorControlModeValue | null;
      timestamp?: number | null;
    } | null;
  };
};

export type UpdatePumpStateMutationVariables = Exact<{
  id: Scalars['String'];
  stopOrStart: Scalars['Int'];
}>;

export type UpdatePumpStateMutation = {
  __typename?: 'Mutation';
  updateVSDPumpOnOffState: {
    __typename?: 'VSDPump';
    _id: string;
    hasPendingUpdates: boolean;
    stopOrStart?: {
      __typename?: 'VSDPumpStopOrStart';
      value?: number | null;
    } | null;
  };
};

export type VsdPumpDetailUpdateSubscriptionVariables = Exact<{
  ids: Array<Scalars['String']> | Scalars['String'];
}>;

export type VsdPumpDetailUpdateSubscription = {
  __typename?: 'Subscription';
  vSDPumpEventsByIds?: {
    __typename?: 'VSDPump';
    modelChangeOperation?: string | null;
    _id: string;
    type?: EnumDKeyDeviceType | null;
    typeDisplayName: string;
    panelId?: string | null;
    name?: string | null;
    deviceId?: string | null;
    role?: string | null;
    timestamp?: number | null;
    hasPendingUpdates: boolean;
    isConfigured?: boolean | null;
    isPoweredOn?: boolean | null;
    alertTypes?: {
      __typename?: 'DeviceAlertTypes';
      deviceOffline?: boolean | null;
      sourceOffline?: boolean | null;
    } | null;
    panel?: {
      __typename?: 'Panel';
      _id: string;
      sourceId: string;
      name?: string | null;
    } | null;
    powerState?: {
      __typename?: 'DevicePowerState';
      timestamp?: number | null;
      units?: string | null;
      value?: EnumDevicePowerStateValue | null;
    } | null;
    meta?: {
      __typename?: 'DeviceMeta';
      name?: string | null;
      model?: string | null;
      modelNumber?: string | null;
      version?: string | null;
    } | null;
    supplyTemperature?: {
      __typename?: 'VSDPumpSupplyTemperature';
      id?: string | null;
      timestamp?: number | null;
      value?: number | null;
      units?: string | null;
    } | null;
    returnTemperature?: {
      __typename?: 'VSDPumpReturnTemperature';
      id?: string | null;
      timestamp?: number | null;
      value?: number | null;
      units?: string | null;
    } | null;
    currentSpeed?: {
      __typename?: 'VSDPumpCurrentSpeed';
      id?: string | null;
      timestamp?: number | null;
      value?: number | null;
      units?: string | null;
    } | null;
    driveOutputPower?: {
      __typename?: 'VSDPumpDriveOutputPower';
      id?: string | null;
      timestamp?: number | null;
      value?: number | null;
      units?: string | null;
    } | null;
    driveOutputEnergy?: {
      __typename?: 'VSDPumpDriveOutputEnergy';
      id?: string | null;
      timestamp?: number | null;
      value?: number | null;
      units?: string | null;
    } | null;
    driveMode?: {
      __typename?: 'VSDPumpDriveMode';
      id?: string | null;
      timestamp?: number | null;
      value?: string | null;
      units?: string | null;
    } | null;
    stopOrStart?: {
      __typename?: 'VSDPumpStopOrStart';
      id?: string | null;
      timestamp?: number | null;
      value?: number | null;
      units?: string | null;
    } | null;
    targetSpeed?: {
      __typename?: 'VSDPumpTargetSpeed';
      id?: string | null;
      timestamp?: number | null;
      value?: number | null;
      units?: string | null;
    } | null;
    deviceAlerts: Array<{
      __typename?: 'Alert';
      _id: string;
      initiated?: number | null;
      updated?: number | null;
      type?: { __typename?: 'AlertType'; name?: string | null } | null;
      device?: {
        __typename?: 'AlertDevice';
        id: string;
        name?: string | null;
        type: string;
      } | null;
    } | null>;
    sourceAlerts: Array<{
      __typename?: 'Alert';
      _id: string;
      initiated?: number | null;
      updated?: number | null;
      type?: { __typename?: 'AlertType'; name?: string | null } | null;
      device?: {
        __typename?: 'AlertDevice';
        id: string;
        name?: string | null;
        type: string;
      } | null;
    } | null>;
  } | null;
};

export type VsdPumpDetailQueryVariables = Exact<{
  id: Scalars['String'];
}>;

export type VsdPumpDetailQuery = {
  __typename?: 'Query';
  vSDPumpById?: {
    __typename?: 'VSDPump';
    _id: string;
    type?: EnumDKeyDeviceType | null;
    typeDisplayName: string;
    panelId?: string | null;
    name?: string | null;
    deviceId?: string | null;
    hasCurrentSpeed?: boolean | null;
    hasDriveOutputEnergy?: boolean | null;
    hasDriveOutputPower?: boolean | null;
    hasTargetSpeed?: boolean | null;
    hasPendingUpdates: boolean;
    role?: string | null;
    timestamp?: number | null;
    isConfigured?: boolean | null;
    isPoweredOn?: boolean | null;
    alertTypes?: {
      __typename?: 'DeviceAlertTypes';
      deviceOffline?: boolean | null;
      sourceOffline?: boolean | null;
    } | null;
    panel?: {
      __typename?: 'Panel';
      _id: string;
      sourceId: string;
      name?: string | null;
    } | null;
    source?: { __typename?: 'Source'; _id: string; name: string } | null;
    powerState?: {
      __typename?: 'DevicePowerState';
      timestamp?: number | null;
      units?: string | null;
      value?: EnumDevicePowerStateValue | null;
    } | null;
    meta?: {
      __typename?: 'DeviceMeta';
      name?: string | null;
      model?: string | null;
      modelNumber?: string | null;
      version?: string | null;
    } | null;
    supplyTemperature?: {
      __typename?: 'VSDPumpSupplyTemperature';
      id?: string | null;
      timestamp?: number | null;
      value?: number | null;
      units?: string | null;
    } | null;
    returnTemperature?: {
      __typename?: 'VSDPumpReturnTemperature';
      id?: string | null;
      timestamp?: number | null;
      value?: number | null;
      units?: string | null;
    } | null;
    currentSpeed?: {
      __typename?: 'VSDPumpCurrentSpeed';
      id?: string | null;
      timestamp?: number | null;
      value?: number | null;
      units?: string | null;
    } | null;
    driveOutputPower?: {
      __typename?: 'VSDPumpDriveOutputPower';
      id?: string | null;
      timestamp?: number | null;
      value?: number | null;
      units?: string | null;
    } | null;
    driveOutputEnergy?: {
      __typename?: 'VSDPumpDriveOutputEnergy';
      id?: string | null;
      timestamp?: number | null;
      value?: number | null;
      units?: string | null;
    } | null;
    driveMode?: {
      __typename?: 'VSDPumpDriveMode';
      id?: string | null;
      timestamp?: number | null;
      value?: string | null;
      units?: string | null;
    } | null;
    stopOrStart?: {
      __typename?: 'VSDPumpStopOrStart';
      id?: string | null;
      timestamp?: number | null;
      value?: number | null;
      units?: string | null;
    } | null;
    targetSpeed?: {
      __typename?: 'VSDPumpTargetSpeed';
      id?: string | null;
      timestamp?: number | null;
      value?: number | null;
      units?: string | null;
    } | null;
    deviceAlerts: Array<{
      __typename?: 'Alert';
      _id: string;
      initiated?: number | null;
      updated?: number | null;
      type?: { __typename?: 'AlertType'; name?: string | null } | null;
      device?: {
        __typename?: 'AlertDevice';
        id: string;
        name?: string | null;
        type: string;
      } | null;
    } | null>;
    sourceAlerts: Array<{
      __typename?: 'Alert';
      _id: string;
      initiated?: number | null;
      updated?: number | null;
      type?: { __typename?: 'AlertType'; name?: string | null } | null;
      device?: {
        __typename?: 'AlertDevice';
        id: string;
        name?: string | null;
        type: string;
      } | null;
    } | null>;
  } | null;
};

export type Z210PumpDetailUpdateSubscriptionVariables = Exact<{
  ids: Array<Scalars['String']> | Scalars['String'];
}>;

export type Z210PumpDetailUpdateSubscription = {
  __typename?: 'Subscription';
  z210PumpEventsByIds?: {
    __typename?: 'Z210Pump';
    modelChangeOperation?: string | null;
    _id: string;
    type?: EnumDKeyDeviceType | null;
    typeDisplayName: string;
    panelId?: string | null;
    name?: string | null;
    role?: string | null;
    deviceId?: string | null;
    isConfigured?: boolean | null;
    hasPendingUpdates: boolean;
    timestamp?: number | null;
    displayName?: string | null;
    hasAutoSwitchoverPeriod?: boolean | null;
    hasOverride?: boolean | null;
    hasActivePump?: boolean | null;
    hasCurrentSpeed?: boolean | null;
    hasTargetSpeed?: boolean | null;
    meta?: {
      __typename?: 'DeviceMeta';
      name?: string | null;
      model?: string | null;
      modelNumber?: string | null;
      version?: string | null;
    } | null;
    panel?: {
      __typename?: 'Panel';
      _id: string;
      sourceId: string;
      name?: string | null;
    } | null;
    activePump?: {
      __typename?: 'Z210PumpActivePump';
      id?: string | null;
      previousId?: string | null;
      timestamp?: number | null;
      value?: number | null;
      units?: string | null;
    } | null;
    currentSpeed?: {
      __typename?: 'Z210PumpCurrentSpeed';
      timestamp?: number | null;
      value?: number | null;
      units?: string | null;
    } | null;
    targetSpeed?: {
      __typename?: 'Z210PumpTargetSpeed';
      timestamp?: number | null;
      value?: number | null;
      units?: string | null;
    } | null;
    deviceAlerts: Array<{
      __typename?: 'Alert';
      _id: string;
      initiated?: number | null;
      updated?: number | null;
      type?: { __typename?: 'AlertType'; name?: string | null } | null;
      device?: {
        __typename?: 'AlertDevice';
        id: string;
        name?: string | null;
        type: string;
      } | null;
    } | null>;
    sourceAlerts: Array<{
      __typename?: 'Alert';
      _id: string;
      initiated?: number | null;
      updated?: number | null;
      type?: { __typename?: 'AlertType'; name?: string | null } | null;
      device?: {
        __typename?: 'AlertDevice';
        id: string;
        name?: string | null;
        type: string;
      } | null;
    } | null>;
  } | null;
};

export type Z210PumpDetailQueryVariables = Exact<{
  id: Scalars['String'];
}>;

export type Z210PumpDetailQuery = {
  __typename?: 'Query';
  z210PumpById?: {
    __typename?: 'Z210Pump';
    _id: string;
    type?: EnumDKeyDeviceType | null;
    typeDisplayName: string;
    panelId?: string | null;
    name?: string | null;
    role?: string | null;
    deviceId?: string | null;
    isConfigured?: boolean | null;
    hasPendingUpdates: boolean;
    timestamp?: number | null;
    displayName?: string | null;
    hasAutoSwitchoverPeriod?: boolean | null;
    hasOverride?: boolean | null;
    hasActivePump?: boolean | null;
    hasCurrentSpeed?: boolean | null;
    hasTargetSpeed?: boolean | null;
    meta?: {
      __typename?: 'DeviceMeta';
      name?: string | null;
      model?: string | null;
      modelNumber?: string | null;
      version?: string | null;
    } | null;
    panel?: {
      __typename?: 'Panel';
      _id: string;
      sourceId: string;
      name?: string | null;
    } | null;
    source?: { __typename?: 'Source'; _id: string; name: string } | null;
    activePump?: {
      __typename?: 'Z210PumpActivePump';
      id?: string | null;
      previousId?: string | null;
      timestamp?: number | null;
      value?: number | null;
      units?: string | null;
    } | null;
    currentSpeed?: {
      __typename?: 'Z210PumpCurrentSpeed';
      timestamp?: number | null;
      value?: number | null;
      units?: string | null;
    } | null;
    targetSpeed?: {
      __typename?: 'Z210PumpTargetSpeed';
      timestamp?: number | null;
      value?: number | null;
      units?: string | null;
    } | null;
    deviceAlerts: Array<{
      __typename?: 'Alert';
      _id: string;
      initiated?: number | null;
      updated?: number | null;
      type?: { __typename?: 'AlertType'; name?: string | null } | null;
      device?: {
        __typename?: 'AlertDevice';
        id: string;
        name?: string | null;
        type: string;
      } | null;
    } | null>;
    sourceAlerts: Array<{
      __typename?: 'Alert';
      _id: string;
      initiated?: number | null;
      updated?: number | null;
      type?: { __typename?: 'AlertType'; name?: string | null } | null;
      device?: {
        __typename?: 'AlertDevice';
        id: string;
        name?: string | null;
        type: string;
      } | null;
    } | null>;
  } | null;
};

export type AlertsListQueryVariables = Exact<{ [key: string]: never }>;

export type AlertsListQuery = {
  __typename?: 'Query';
  alerts: Array<{
    __typename?: 'Alert';
    _id: string;
    severity?: string | null;
    initiated?: number | null;
    property?: {
      __typename?: 'AlertProperty';
      name?: string | null;
      id?: string | null;
    } | null;
    unit?: {
      __typename?: 'AlertUnit';
      name?: string | null;
      id?: string | null;
    } | null;
    type?: { __typename?: 'AlertType'; name?: string | null } | null;
    device?: {
      __typename?: 'AlertDevice';
      type: string;
      name?: string | null;
      id: string;
    } | null;
  }>;
};

export type AlertsListUpdateSubscriptionVariables = Exact<{
  propertyId?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
}>;

export type AlertsListUpdateSubscription = {
  __typename?: 'Subscription';
  alertsByPropertyIdEvents?: {
    __typename?: 'Alert';
    modelChangeOperation?: string | null;
    _id: string;
    severity?: string | null;
    initiated?: number | null;
    property?: {
      __typename?: 'AlertProperty';
      name?: string | null;
      id?: string | null;
    } | null;
    unit?: {
      __typename?: 'AlertUnit';
      name?: string | null;
      id?: string | null;
    } | null;
    type?: { __typename?: 'AlertType'; name?: string | null } | null;
    device?: {
      __typename?: 'AlertDevice';
      type: string;
      name?: string | null;
      id: string;
    } | null;
  } | null;
};

export type AuthorizationOptionsQueryVariables = Exact<{
  [key: string]: never;
}>;

export type AuthorizationOptionsQuery = {
  __typename?: 'Query';
  properties: Array<{
    __typename?: 'Property';
    _id: string;
    title: string;
    units: Array<{
      __typename?: 'Unit';
      _id: string;
      name: string;
      type: string;
      devices: Array<
        | {
            __typename?: 'Actuator';
            _id: string;
            name?: string | null;
            type?: EnumDKeyDeviceType | null;
          }
        | {
            __typename?: 'BatteryManagementSystem';
            _id: string;
            name?: string | null;
            type?: EnumDKeyDeviceType | null;
          }
        | {
            __typename?: 'Boiler';
            _id: string;
            name?: string | null;
            type?: EnumDKeyDeviceType | null;
          }
        | {
            __typename?: 'Chiller';
            _id: string;
            name?: string | null;
            type?: EnumDKeyDeviceType | null;
          }
        | {
            __typename?: 'ConductorGenericSensor';
            _id: string;
            name?: string | null;
            type?: EnumDKeyDeviceType | null;
          }
        | {
            __typename?: 'Controller';
            _id: string;
            name?: string | null;
            type?: EnumDKeyDeviceType | null;
          }
        | {
            __typename?: 'Device';
            _id: string;
            name?: string | null;
            type?: EnumDKeyDeviceType | null;
          }
        | {
            __typename?: 'DoorSensor';
            _id: string;
            name?: string | null;
            type?: EnumDKeyDeviceType | null;
          }
        | {
            __typename?: 'EnergyController';
            _id: string;
            name?: string | null;
            type?: EnumDKeyDeviceType | null;
          }
        | {
            __typename?: 'EnergyConverter';
            _id: string;
            name?: string | null;
            type?: EnumDKeyDeviceType | null;
          }
        | {
            __typename?: 'EnergyInverter';
            _id: string;
            name?: string | null;
            type?: EnumDKeyDeviceType | null;
          }
        | {
            __typename?: 'EnergyMeter';
            _id: string;
            name?: string | null;
            type?: EnumDKeyDeviceType | null;
          }
        | {
            __typename?: 'EnergyRectifier';
            _id: string;
            name?: string | null;
            type?: EnumDKeyDeviceType | null;
          }
        | {
            __typename?: 'EnergyStorageCoolingSystem';
            _id: string;
            name?: string | null;
            type?: EnumDKeyDeviceType | null;
          }
        | {
            __typename?: 'EnergySwitchPanel';
            _id: string;
            name?: string | null;
            type?: EnumDKeyDeviceType | null;
          }
        | {
            __typename?: 'EnergySwitchPanelCircuit';
            _id: string;
            name?: string | null;
            type?: EnumDKeyDeviceType | null;
          }
        | {
            __typename?: 'FireSuppressionSystem';
            _id: string;
            name?: string | null;
            type?: EnumDKeyDeviceType | null;
          }
        | {
            __typename?: 'GPIO';
            _id: string;
            name?: string | null;
            type?: EnumDKeyDeviceType | null;
          }
        | {
            __typename?: 'IndoorAirHandler';
            _id: string;
            name?: string | null;
            type?: EnumDKeyDeviceType | null;
          }
        | {
            __typename?: 'IndoorSensor';
            _id: string;
            name?: string | null;
            type?: EnumDKeyDeviceType | null;
          }
        | {
            __typename?: 'KineticEnergyManagementSystem';
            _id: string;
            name?: string | null;
            type?: EnumDKeyDeviceType | null;
          }
        | {
            __typename?: 'LeakDetector';
            _id: string;
            name?: string | null;
            type?: EnumDKeyDeviceType | null;
          }
        | {
            __typename?: 'Loop';
            _id: string;
            name?: string | null;
            type?: EnumDKeyDeviceType | null;
          }
        | {
            __typename?: 'ModbusAirHandler';
            _id: string;
            name?: string | null;
            type?: EnumDKeyDeviceType | null;
          }
        | {
            __typename?: 'OccupancySensor';
            _id: string;
            name?: string | null;
            type?: EnumDKeyDeviceType | null;
          }
        | {
            __typename?: 'OpenWeather';
            _id: string;
            name?: string | null;
            type?: EnumDKeyDeviceType | null;
          }
        | {
            __typename?: 'OutdoorSensor';
            _id: string;
            name?: string | null;
            type?: EnumDKeyDeviceType | null;
          }
        | {
            __typename?: 'PowerMonitor';
            _id: string;
            name?: string | null;
            type?: EnumDKeyDeviceType | null;
          }
        | {
            __typename?: 'PressureSensor';
            _id: string;
            name?: string | null;
            type?: EnumDKeyDeviceType | null;
          }
        | {
            __typename?: 'RelayDevice';
            _id: string;
            name?: string | null;
            type?: EnumDKeyDeviceType | null;
          }
        | {
            __typename?: 'SmartPowerOutlet';
            _id: string;
            name?: string | null;
            type?: EnumDKeyDeviceType | null;
          }
        | {
            __typename?: 'SolarManagementSystem';
            _id: string;
            name?: string | null;
            type?: EnumDKeyDeviceType | null;
          }
        | {
            __typename?: 'Thermistor';
            _id: string;
            name?: string | null;
            type?: EnumDKeyDeviceType | null;
          }
        | {
            __typename?: 'Thermostat';
            _id: string;
            name?: string | null;
            type?: EnumDKeyDeviceType | null;
          }
        | {
            __typename?: 'VSDPump';
            _id: string;
            name?: string | null;
            type?: EnumDKeyDeviceType | null;
          }
        | {
            __typename?: 'WindManagementSystem';
            _id: string;
            name?: string | null;
            type?: EnumDKeyDeviceType | null;
          }
        | {
            __typename?: 'WindowSensor';
            _id: string;
            name?: string | null;
            type?: EnumDKeyDeviceType | null;
          }
        | {
            __typename?: 'Z210Pump';
            _id: string;
            name?: string | null;
            type?: EnumDKeyDeviceType | null;
          }
      >;
    } | null>;
  }>;
};

export type BoilerListUpdateSubscriptionVariables = Exact<{
  [key: string]: never;
}>;

export type BoilerListUpdateSubscription = {
  __typename?: 'Subscription';
  boilerEvents?: {
    __typename?: 'Boiler';
    _id: string;
    modelChangeOperation?: string | null;
    name?: string | null;
    meta?: { __typename?: 'DeviceMeta'; name?: string | null } | null;
  } | null;
};

export type BoilersQueryVariables = Exact<{ [key: string]: never }>;

export type BoilersQuery = {
  __typename?: 'Query';
  boilers: Array<{
    __typename?: 'Boiler';
    _id: string;
    name?: string | null;
    meta?: { __typename?: 'DeviceMeta'; name?: string | null } | null;
  }>;
};

export type PropertiesQueryVariables = Exact<{ [key: string]: never }>;

export type PropertiesQuery = {
  __typename?: 'Query';
  properties: Array<{
    __typename?: 'Property';
    _id: string;
    title: string;
    imageUrl?: string | null;
    address: {
      __typename?: 'PropertyAddress';
      line1: string;
      city?: string | null;
      state?: string | null;
      postalCode?: string | null;
    };
    owner?: { __typename?: 'PropertyOwner'; name?: string | null } | null;
    propMgr?: {
      __typename?: 'PropertyPropMgr';
      name?: string | null;
      mobile?: string | null;
    } | null;
    units: Array<{
      __typename?: 'Unit';
      name: string;
      _id: string;
      type: string;
      alertTypes?: {
        __typename?: 'UnitAlertTypes';
        sourceOffline?: boolean | null;
        deviceOffline?: boolean | null;
      } | null;
    } | null>;
  }>;
};

export type PropertyAlertSubscriptionUpdatesSubscriptionVariables = Exact<{
  [key: string]: never;
}>;

export type PropertyAlertSubscriptionUpdatesSubscription = {
  __typename?: 'Subscription';
  alertSubscriptionEvents?: {
    __typename?: 'AlertSubscription';
    modelChangeOperation?: string | null;
    _id: string;
    alertTriggerId: string;
    propertyId?: string | null;
    unitId?: string | null;
    unitCategoryId?: string | null;
    deviceId?: string | null;
    viaEmail?: boolean | null;
    viaSms?: boolean | null;
  } | null;
};

export type PropertyAlertsQueryVariables = Exact<{
  propertyId: Scalars['String'];
}>;

export type PropertyAlertsQuery = {
  __typename?: 'Query';
  alerts: Array<{
    __typename?: 'Alert';
    _id: string;
    severity?: string | null;
    initiated?: number | null;
    property?: {
      __typename?: 'AlertProperty';
      name?: string | null;
      id?: string | null;
    } | null;
    unit?: {
      __typename?: 'AlertUnit';
      name?: string | null;
      id?: string | null;
    } | null;
    type?: { __typename?: 'AlertType'; name?: string | null } | null;
    device?: {
      __typename?: 'AlertDevice';
      type: string;
      name?: string | null;
      id: string;
    } | null;
  }>;
};

export type PropertyListUpdateSubscriptionVariables = Exact<{
  _ids?: InputMaybe<
    Array<InputMaybe<Scalars['String']>> | InputMaybe<Scalars['String']>
  >;
}>;

export type PropertyListUpdateSubscription = {
  __typename?: 'Subscription';
  propertyEventsByIds?: {
    __typename?: 'Property';
    _id: string;
    title: string;
    modelChangeOperation?: string | null;
  } | null;
};

export type SourceListQueryVariables = Exact<{ [key: string]: never }>;

export type SourceListQuery = {
  __typename?: 'Query';
  sources: Array<
    | {
        __typename?: 'BNG';
        localUrl?: string | null;
        _id: string;
        name: string;
        type?: EnumDKeySourceType | null;
        url?: string | null;
        timestamp?: number | null;
        inUse: boolean;
      }
    | {
        __typename?: 'Conductor';
        _id: string;
        name: string;
        type?: EnumDKeySourceType | null;
        url?: string | null;
        timestamp?: number | null;
        inUse: boolean;
      }
    | {
        __typename?: 'Core';
        _id: string;
        name: string;
        type?: EnumDKeySourceType | null;
        url?: string | null;
        timestamp?: number | null;
        inUse: boolean;
      }
    | {
        __typename?: 'HMM';
        _id: string;
        name: string;
        type?: EnumDKeySourceType | null;
        url?: string | null;
        timestamp?: number | null;
        inUse: boolean;
      }
    | {
        __typename?: 'Source';
        _id: string;
        name: string;
        type?: EnumDKeySourceType | null;
        url?: string | null;
        timestamp?: number | null;
        inUse: boolean;
      }
  >;
};

export type SourceListBngUpdateSubscriptionVariables = Exact<{
  [key: string]: never;
}>;

export type SourceListBngUpdateSubscription = {
  __typename?: 'Subscription';
  bNGEvents?: {
    __typename?: 'BNG';
    modelChangeOperation?: string | null;
    _id: string;
    localUrl?: string | null;
  } | null;
};

export type SourceListUpdateSubscriptionVariables = Exact<{
  [key: string]: never;
}>;

export type SourceListUpdateSubscription = {
  __typename?: 'Subscription';
  sourceEvents?: {
    __typename?: 'Source';
    modelChangeOperation?: string | null;
    _id: string;
    name: string;
    type?: EnumDKeySourceType | null;
    url?: string | null;
    timestamp?: number | null;
    inUse: boolean;
  } | null;
};

export type EntitySubscriberUpdatesSubscriptionVariables = Exact<{
  [key: string]: never;
}>;

export type EntitySubscriberUpdatesSubscription = {
  __typename?: 'Subscription';
  entitySubscribersUpdated?: any | null;
};

export type EntitySubscribersQueryVariables = Exact<{ [key: string]: never }>;

export type EntitySubscribersQuery = {
  __typename?: 'Query';
  entitySubscribers?: any | null;
};

export type ResetEntitySubscribersMutationVariables = Exact<{
  [key: string]: never;
}>;

export type ResetEntitySubscribersMutation = {
  __typename?: 'Mutation';
  resetEntitySubscribers?: any | null;
};

export type TestBoilersQueryVariables = Exact<{ [key: string]: never }>;

export type TestBoilersQuery = {
  __typename?: 'Query';
  boilers: Array<{
    __typename?: 'Boiler';
    _id: string;
    name?: string | null;
    meta?: { __typename?: 'DeviceMeta'; name?: string | null } | null;
  }>;
};

export type TestBoilerListUpdateSubscriptionVariables = Exact<{
  [key: string]: never;
}>;

export type TestBoilerListUpdateSubscription = {
  __typename?: 'Subscription';
  boilerEvents?: {
    __typename?: 'Boiler';
    _id: string;
    modelChangeOperation?: string | null;
    name?: string | null;
    meta?: { __typename?: 'DeviceMeta'; name?: string | null } | null;
  } | null;
};

export type TestPropertyListUpdateSubscriptionVariables = Exact<{
  _ids?: InputMaybe<
    Array<InputMaybe<Scalars['String']>> | InputMaybe<Scalars['String']>
  >;
}>;

export type TestPropertyListUpdateSubscription = {
  __typename?: 'Subscription';
  propertyEventsByIds?: {
    __typename?: 'Property';
    modelChangeOperation?: string | null;
    _id: string;
    title: string;
  } | null;
};

export type ControlGroupRefreshQueryVariables = Exact<{
  controlGroupId: Scalars['String'];
}>;

export type ControlGroupRefreshQuery = {
  __typename?: 'Query';
  controlGroupById?: {
    __typename?: 'ControlGroup';
    _id: string;
    name: string;
    propertyId: string;
    unitId: string;
    type: string;
    automationEnabled?: boolean | null;
    masterDeviceId?: string | null;
    attributes: any;
    deviceDetails?: any | null;
    masterDevice?: {
      __typename?: 'Device';
      _id: string;
      deviceId?: string | null;
      name?: string | null;
      type?: EnumDKeyDeviceType | null;
    } | null;
    groupedDevices: Array<{
      __typename?: 'ControlGroupGroupedDevices';
      _id: string;
      deviceId: string;
      name: string;
      type: string;
      displayOrder: number;
    } | null>;
    devices: Array<{
      __typename?: 'Device';
      _id: string;
      deviceId?: string | null;
      type?: EnumDKeyDeviceType | null;
    }>;
  } | null;
};

export type UpdateControlGroupMutationVariables = Exact<{
  id: Scalars['String'];
  record: UpdateOneControlGroupInput;
}>;

export type UpdateControlGroupMutation = {
  __typename?: 'Mutation';
  updateControlGroup: {
    __typename?: 'ControlGroup';
    _id: string;
    name: string;
    propertyId: string;
    unitId: string;
    type: string;
    automationEnabled?: boolean | null;
    masterDeviceId?: string | null;
    deviceDetails?: any | null;
    groupedDevices: Array<{
      __typename?: 'ControlGroupGroupedDevices';
      _id: string;
      deviceId: string;
      name: string;
      type: string;
      displayOrder: number;
    } | null>;
  };
};

export type DeleteControlGroupMutationVariables = Exact<{
  id: Scalars['String'];
}>;

export type DeleteControlGroupMutation = {
  __typename?: 'Mutation';
  deleteControlGroup: boolean;
};

export type EditDeviceMutationVariables = Exact<{
  deviceId: Scalars['String'];
  edits: DeviceEditsInput;
}>;

export type EditDeviceMutation = {
  __typename?: 'Mutation';
  editDevice: {
    __typename?: 'Device';
    deviceId?: string | null;
    name?: string | null;
  };
};

export type ToggleControlGroupAutomationMutationVariables = Exact<{
  id: Scalars['String'];
}>;

export type ToggleControlGroupAutomationMutation = {
  __typename?: 'Mutation';
  toggleControlGroupAutomation: {
    __typename?: 'ControlGroup';
    _id: string;
    automationEnabled?: boolean | null;
    name: string;
    propertyId: string;
    unitId: string;
    type: string;
    masterDeviceId?: string | null;
    deviceDetails?: any | null;
  };
};

export type UpdateDevicePowerStateMutationVariables = Exact<{
  deviceId: Scalars['String'];
  poweredOn: Scalars['Boolean'];
}>;

export type UpdateDevicePowerStateMutation = {
  __typename?: 'Mutation';
  updateDevicePowerState: {
    __typename?: 'Device';
    _id: string;
    hasPendingUpdates: boolean;
    powerState?: {
      __typename?: 'DevicePowerState';
      value?: EnumDevicePowerStateValue | null;
      timestamp?: number | null;
    } | null;
  };
};

export type EntitySelectionQueryableRelatedTypesQueryVariables = Exact<{
  modelName: QueryableRelatedTypesModelNameInput;
}>;

export type EntitySelectionQueryableRelatedTypesQuery = {
  __typename?: 'Query';
  queryableRelatedTypes?: any | null;
};

export type EntitySelectionTestQueryVariables = Exact<{
  selection: TieredEntitySelectionInput;
  options?: InputMaybe<QueryExecutionOptionsInput>;
}>;

export type EntitySelectionTestQuery = {
  __typename?: 'Query';
  executeTieredEntitySelection?: any | null;
};

export type QueryableFieldsQueryVariables = Exact<{
  modelName: QueryableModelFieldsModelNameInput;
}>;

export type QueryableFieldsQuery = {
  __typename?: 'Query';
  queryableFields?: any | null;
};

export type IngestionFieldsFragment = {
  __typename?: 'Ingestion';
  _id: string;
  date: any;
  fileName: string;
  s3FileName: string;
  userId: string;
  status: string;
  user?: { __typename?: 'User'; name: string } | null;
};

export type IngestionsQueryVariables = Exact<{ [key: string]: never }>;

export type IngestionsQuery = {
  __typename?: 'Query';
  ingestions: Array<{
    __typename?: 'Ingestion';
    _id: string;
    date: any;
    fileName: string;
    s3FileName: string;
    userId: string;
    status: string;
    user?: { __typename?: 'User'; name: string } | null;
  }>;
};

export type IngestionUpdatesSubscriptionVariables = Exact<{
  [key: string]: never;
}>;

export type IngestionUpdatesSubscription = {
  __typename?: 'Subscription';
  ingestionEvents?: {
    __typename?: 'Ingestion';
    modelChangeOperation?: string | null;
    _id: string;
    date: any;
    fileName: string;
    s3FileName: string;
    userId: string;
    status: string;
    user?: { __typename?: 'User'; name: string } | null;
  } | null;
};

export type IngestionUpdatedSubscriptionVariables = Exact<{
  id: Scalars['String'];
}>;

export type IngestionUpdatedSubscription = {
  __typename?: 'Subscription';
  ingestionUpdatedByIds?: {
    __typename?: 'Ingestion';
    modelChangeOperation?: string | null;
    _id: string;
    date: any;
    fileName: string;
    s3FileName: string;
    userId: string;
    status: string;
    user?: { __typename?: 'User'; name: string } | null;
  } | null;
};

export type GetIngestionUploadInfoQueryVariables = Exact<{
  [key: string]: never;
}>;

export type GetIngestionUploadInfoQuery = {
  __typename?: 'Query';
  getIngestionUploadInfo?: {
    __typename?: 'IngestionUploadInfo';
    credentials: string;
    date: string;
    expiration: string;
    policy: string;
    signature: string;
    url: string;
  } | null;
};

export type CreateIngestionMutationVariables = Exact<{
  record: CreateIngestionInput;
}>;

export type CreateIngestionMutation = {
  __typename?: 'Mutation';
  createIngestion?: {
    __typename?: 'Ingestion';
    _id: string;
    date: any;
    fileName: string;
    s3FileName: string;
    userId: string;
    status: string;
    user?: { __typename?: 'User'; name: string } | null;
  } | null;
};

export type RemoveIngestionMutationVariables = Exact<{
  id: Scalars['String'];
}>;

export type RemoveIngestionMutation = {
  __typename?: 'Mutation';
  removeIngestion: string;
};

export type InstallerDeviceUpdatesSubscriptionVariables = Exact<{
  ids: Array<Scalars['String']> | Scalars['String'];
}>;

export type InstallerDeviceUpdatesSubscription = {
  __typename?: 'Subscription';
  deviceEventsByIds?: {
    __typename?: 'Device';
    modelChangeOperation?: string | null;
    modelType?: string | null;
    _id: string;
    name?: string | null;
    sourceId?: string | null;
    deviceId?: string | null;
    typeDisplayName: string;
    installation?: {
      __typename?: 'DeviceInstallation';
      status: number;
      message?: string | null;
    } | null;
  } | null;
};

export type InstallerDeviceQueryVariables = Exact<{
  id: Scalars['String'];
}>;

export type InstallerDeviceQuery = {
  __typename?: 'Query';
  deviceById?:
    | {
        __typename?: 'Actuator';
        _id: string;
        name?: string | null;
        sourceId?: string | null;
        deviceId?: string | null;
        typeDisplayName: string;
        installation?: {
          __typename?: 'DeviceInstallation';
          status: number;
          message?: string | null;
        } | null;
      }
    | {
        __typename?: 'BatteryManagementSystem';
        _id: string;
        name?: string | null;
        sourceId?: string | null;
        deviceId?: string | null;
        typeDisplayName: string;
        installation?: {
          __typename?: 'DeviceInstallation';
          status: number;
          message?: string | null;
        } | null;
      }
    | {
        __typename?: 'Boiler';
        _id: string;
        name?: string | null;
        sourceId?: string | null;
        deviceId?: string | null;
        typeDisplayName: string;
        installation?: {
          __typename?: 'DeviceInstallation';
          status: number;
          message?: string | null;
        } | null;
      }
    | {
        __typename?: 'Chiller';
        _id: string;
        name?: string | null;
        sourceId?: string | null;
        deviceId?: string | null;
        typeDisplayName: string;
        installation?: {
          __typename?: 'DeviceInstallation';
          status: number;
          message?: string | null;
        } | null;
      }
    | {
        __typename?: 'ConductorGenericSensor';
        _id: string;
        name?: string | null;
        sourceId?: string | null;
        deviceId?: string | null;
        typeDisplayName: string;
        installation?: {
          __typename?: 'DeviceInstallation';
          status: number;
          message?: string | null;
        } | null;
      }
    | {
        __typename?: 'Controller';
        _id: string;
        name?: string | null;
        sourceId?: string | null;
        deviceId?: string | null;
        typeDisplayName: string;
        installation?: {
          __typename?: 'DeviceInstallation';
          status: number;
          message?: string | null;
        } | null;
      }
    | {
        __typename?: 'Device';
        _id: string;
        name?: string | null;
        sourceId?: string | null;
        deviceId?: string | null;
        typeDisplayName: string;
        installation?: {
          __typename?: 'DeviceInstallation';
          status: number;
          message?: string | null;
        } | null;
      }
    | {
        __typename?: 'DoorSensor';
        _id: string;
        name?: string | null;
        sourceId?: string | null;
        deviceId?: string | null;
        typeDisplayName: string;
        installation?: {
          __typename?: 'DeviceInstallation';
          status: number;
          message?: string | null;
        } | null;
      }
    | {
        __typename?: 'EnergyController';
        _id: string;
        name?: string | null;
        sourceId?: string | null;
        deviceId?: string | null;
        typeDisplayName: string;
        installation?: {
          __typename?: 'DeviceInstallation';
          status: number;
          message?: string | null;
        } | null;
      }
    | {
        __typename?: 'EnergyConverter';
        _id: string;
        name?: string | null;
        sourceId?: string | null;
        deviceId?: string | null;
        typeDisplayName: string;
        installation?: {
          __typename?: 'DeviceInstallation';
          status: number;
          message?: string | null;
        } | null;
      }
    | {
        __typename?: 'EnergyInverter';
        _id: string;
        name?: string | null;
        sourceId?: string | null;
        deviceId?: string | null;
        typeDisplayName: string;
        installation?: {
          __typename?: 'DeviceInstallation';
          status: number;
          message?: string | null;
        } | null;
      }
    | {
        __typename?: 'EnergyMeter';
        _id: string;
        name?: string | null;
        sourceId?: string | null;
        deviceId?: string | null;
        typeDisplayName: string;
        installation?: {
          __typename?: 'DeviceInstallation';
          status: number;
          message?: string | null;
        } | null;
      }
    | {
        __typename?: 'EnergyRectifier';
        _id: string;
        name?: string | null;
        sourceId?: string | null;
        deviceId?: string | null;
        typeDisplayName: string;
        installation?: {
          __typename?: 'DeviceInstallation';
          status: number;
          message?: string | null;
        } | null;
      }
    | {
        __typename?: 'EnergyStorageCoolingSystem';
        _id: string;
        name?: string | null;
        sourceId?: string | null;
        deviceId?: string | null;
        typeDisplayName: string;
        installation?: {
          __typename?: 'DeviceInstallation';
          status: number;
          message?: string | null;
        } | null;
      }
    | {
        __typename?: 'EnergySwitchPanel';
        _id: string;
        name?: string | null;
        sourceId?: string | null;
        deviceId?: string | null;
        typeDisplayName: string;
        installation?: {
          __typename?: 'DeviceInstallation';
          status: number;
          message?: string | null;
        } | null;
      }
    | {
        __typename?: 'EnergySwitchPanelCircuit';
        _id: string;
        name?: string | null;
        sourceId?: string | null;
        deviceId?: string | null;
        typeDisplayName: string;
        installation?: {
          __typename?: 'DeviceInstallation';
          status: number;
          message?: string | null;
        } | null;
      }
    | {
        __typename?: 'FireSuppressionSystem';
        _id: string;
        name?: string | null;
        sourceId?: string | null;
        deviceId?: string | null;
        typeDisplayName: string;
        installation?: {
          __typename?: 'DeviceInstallation';
          status: number;
          message?: string | null;
        } | null;
      }
    | {
        __typename?: 'GPIO';
        _id: string;
        name?: string | null;
        sourceId?: string | null;
        deviceId?: string | null;
        typeDisplayName: string;
        installation?: {
          __typename?: 'DeviceInstallation';
          status: number;
          message?: string | null;
        } | null;
      }
    | {
        __typename?: 'IndoorAirHandler';
        _id: string;
        name?: string | null;
        sourceId?: string | null;
        deviceId?: string | null;
        typeDisplayName: string;
        installation?: {
          __typename?: 'DeviceInstallation';
          status: number;
          message?: string | null;
        } | null;
      }
    | {
        __typename?: 'IndoorSensor';
        _id: string;
        name?: string | null;
        sourceId?: string | null;
        deviceId?: string | null;
        typeDisplayName: string;
        installation?: {
          __typename?: 'DeviceInstallation';
          status: number;
          message?: string | null;
        } | null;
      }
    | {
        __typename?: 'KineticEnergyManagementSystem';
        _id: string;
        name?: string | null;
        sourceId?: string | null;
        deviceId?: string | null;
        typeDisplayName: string;
        installation?: {
          __typename?: 'DeviceInstallation';
          status: number;
          message?: string | null;
        } | null;
      }
    | {
        __typename?: 'LeakDetector';
        _id: string;
        name?: string | null;
        sourceId?: string | null;
        deviceId?: string | null;
        typeDisplayName: string;
        installation?: {
          __typename?: 'DeviceInstallation';
          status: number;
          message?: string | null;
        } | null;
      }
    | {
        __typename?: 'Loop';
        _id: string;
        name?: string | null;
        sourceId?: string | null;
        deviceId?: string | null;
        typeDisplayName: string;
        installation?: {
          __typename?: 'DeviceInstallation';
          status: number;
          message?: string | null;
        } | null;
      }
    | {
        __typename?: 'ModbusAirHandler';
        _id: string;
        name?: string | null;
        sourceId?: string | null;
        deviceId?: string | null;
        typeDisplayName: string;
        installation?: {
          __typename?: 'DeviceInstallation';
          status: number;
          message?: string | null;
        } | null;
      }
    | {
        __typename?: 'OccupancySensor';
        _id: string;
        name?: string | null;
        sourceId?: string | null;
        deviceId?: string | null;
        typeDisplayName: string;
        installation?: {
          __typename?: 'DeviceInstallation';
          status: number;
          message?: string | null;
        } | null;
      }
    | {
        __typename?: 'OpenWeather';
        _id: string;
        name?: string | null;
        sourceId?: string | null;
        deviceId?: string | null;
        typeDisplayName: string;
        installation?: {
          __typename?: 'DeviceInstallation';
          status: number;
          message?: string | null;
        } | null;
      }
    | {
        __typename?: 'OutdoorSensor';
        _id: string;
        name?: string | null;
        sourceId?: string | null;
        deviceId?: string | null;
        typeDisplayName: string;
        installation?: {
          __typename?: 'DeviceInstallation';
          status: number;
          message?: string | null;
        } | null;
      }
    | {
        __typename?: 'PowerMonitor';
        _id: string;
        name?: string | null;
        sourceId?: string | null;
        deviceId?: string | null;
        typeDisplayName: string;
        installation?: {
          __typename?: 'DeviceInstallation';
          status: number;
          message?: string | null;
        } | null;
      }
    | {
        __typename?: 'PressureSensor';
        _id: string;
        name?: string | null;
        sourceId?: string | null;
        deviceId?: string | null;
        typeDisplayName: string;
        installation?: {
          __typename?: 'DeviceInstallation';
          status: number;
          message?: string | null;
        } | null;
      }
    | {
        __typename?: 'RelayDevice';
        _id: string;
        name?: string | null;
        sourceId?: string | null;
        deviceId?: string | null;
        typeDisplayName: string;
        installation?: {
          __typename?: 'DeviceInstallation';
          status: number;
          message?: string | null;
        } | null;
      }
    | {
        __typename?: 'SmartPowerOutlet';
        _id: string;
        name?: string | null;
        sourceId?: string | null;
        deviceId?: string | null;
        typeDisplayName: string;
        installation?: {
          __typename?: 'DeviceInstallation';
          status: number;
          message?: string | null;
        } | null;
      }
    | {
        __typename?: 'SolarManagementSystem';
        _id: string;
        name?: string | null;
        sourceId?: string | null;
        deviceId?: string | null;
        typeDisplayName: string;
        installation?: {
          __typename?: 'DeviceInstallation';
          status: number;
          message?: string | null;
        } | null;
      }
    | {
        __typename?: 'Thermistor';
        _id: string;
        name?: string | null;
        sourceId?: string | null;
        deviceId?: string | null;
        typeDisplayName: string;
        installation?: {
          __typename?: 'DeviceInstallation';
          status: number;
          message?: string | null;
        } | null;
      }
    | {
        __typename?: 'Thermostat';
        _id: string;
        name?: string | null;
        sourceId?: string | null;
        deviceId?: string | null;
        typeDisplayName: string;
        installation?: {
          __typename?: 'DeviceInstallation';
          status: number;
          message?: string | null;
        } | null;
      }
    | {
        __typename?: 'VSDPump';
        _id: string;
        name?: string | null;
        sourceId?: string | null;
        deviceId?: string | null;
        typeDisplayName: string;
        installation?: {
          __typename?: 'DeviceInstallation';
          status: number;
          message?: string | null;
        } | null;
      }
    | {
        __typename?: 'WindManagementSystem';
        _id: string;
        name?: string | null;
        sourceId?: string | null;
        deviceId?: string | null;
        typeDisplayName: string;
        installation?: {
          __typename?: 'DeviceInstallation';
          status: number;
          message?: string | null;
        } | null;
      }
    | {
        __typename?: 'WindowSensor';
        _id: string;
        name?: string | null;
        sourceId?: string | null;
        deviceId?: string | null;
        typeDisplayName: string;
        installation?: {
          __typename?: 'DeviceInstallation';
          status: number;
          message?: string | null;
        } | null;
      }
    | {
        __typename?: 'Z210Pump';
        _id: string;
        name?: string | null;
        sourceId?: string | null;
        deviceId?: string | null;
        typeDisplayName: string;
        installation?: {
          __typename?: 'DeviceInstallation';
          status: number;
          message?: string | null;
        } | null;
      }
    | null;
};

export type RegisterDeviceMutationVariables = Exact<{
  id: Scalars['String'];
  euid: Scalars['String'];
}>;

export type RegisterDeviceMutation = {
  __typename?: 'Mutation';
  registerDevice?: string | null;
};

export type SetInstallationStatusMutationVariables = Exact<{
  options: SetInstallationStatusInput;
}>;

export type SetInstallationStatusMutation = {
  __typename?: 'Mutation';
  setInstallationStatus: {
    __typename?: 'SetInstallationStatusResult';
    result: boolean;
    message?: string | null;
  };
};

export type InstallerToolsUpdatesSubscriptionVariables = Exact<{
  ids: Array<Scalars['String']> | Scalars['String'];
}>;

export type InstallerToolsUpdatesSubscription = {
  __typename?: 'Subscription';
  deviceEventsByIds?: {
    __typename?: 'Device';
    modelChangeOperation?: string | null;
    modelType?: string | null;
    _id: string;
    name?: string | null;
    type?: EnumDKeyDeviceType | null;
    propertyId: string;
    unitId: string;
    zoneId?: string | null;
    sourceId?: string | null;
    deviceId?: string | null;
    installation?: {
      __typename?: 'DeviceInstallation';
      status: number;
      count?: number | null;
      message?: string | null;
      paired?: boolean | null;
      pairedTo?: string | null;
      previousStatus?: string | null;
      rawDeviceId?: string | null;
      replacingDeviceId?: string | null;
    } | null;
    alertTypes?: {
      __typename?: 'DeviceAlertTypes';
      deviceOffline?: boolean | null;
      sourceOffline?: boolean | null;
    } | null;
  } | null;
};

export type UnregisterDeviceMutationVariables = Exact<{
  id: Scalars['String'];
}>;

export type UnregisterDeviceMutation = {
  __typename?: 'Mutation';
  unregisterDevice?: boolean | null;
};

export type InstallerToolsQueryVariables = Exact<{
  id: Scalars['String'];
}>;

export type InstallerToolsQuery = {
  __typename?: 'Query';
  deviceById?:
    | {
        __typename?: 'Actuator';
        _id: string;
        name?: string | null;
        type?: EnumDKeyDeviceType | null;
        propertyId: string;
        unitId: string;
        zoneId?: string | null;
        sourceId?: string | null;
        deviceId?: string | null;
        installation?: {
          __typename?: 'DeviceInstallation';
          status: number;
          count?: number | null;
          message?: string | null;
          paired?: boolean | null;
          pairedTo?: string | null;
          previousStatus?: string | null;
          rawDeviceId?: string | null;
          replacingDeviceId?: string | null;
        } | null;
        alertTypes?: {
          __typename?: 'DeviceAlertTypes';
          deviceOffline?: boolean | null;
          sourceOffline?: boolean | null;
        } | null;
        unit?: { __typename?: 'Unit'; _id: string; name: string } | null;
      }
    | {
        __typename?: 'BatteryManagementSystem';
        _id: string;
        name?: string | null;
        type?: EnumDKeyDeviceType | null;
        propertyId: string;
        unitId: string;
        zoneId?: string | null;
        sourceId?: string | null;
        deviceId?: string | null;
        installation?: {
          __typename?: 'DeviceInstallation';
          status: number;
          count?: number | null;
          message?: string | null;
          paired?: boolean | null;
          pairedTo?: string | null;
          previousStatus?: string | null;
          rawDeviceId?: string | null;
          replacingDeviceId?: string | null;
        } | null;
        alertTypes?: {
          __typename?: 'DeviceAlertTypes';
          deviceOffline?: boolean | null;
          sourceOffline?: boolean | null;
        } | null;
        unit?: { __typename?: 'Unit'; _id: string; name: string } | null;
      }
    | {
        __typename?: 'Boiler';
        _id: string;
        name?: string | null;
        type?: EnumDKeyDeviceType | null;
        propertyId: string;
        unitId: string;
        zoneId?: string | null;
        sourceId?: string | null;
        deviceId?: string | null;
        installation?: {
          __typename?: 'DeviceInstallation';
          status: number;
          count?: number | null;
          message?: string | null;
          paired?: boolean | null;
          pairedTo?: string | null;
          previousStatus?: string | null;
          rawDeviceId?: string | null;
          replacingDeviceId?: string | null;
        } | null;
        alertTypes?: {
          __typename?: 'DeviceAlertTypes';
          deviceOffline?: boolean | null;
          sourceOffline?: boolean | null;
        } | null;
        unit?: { __typename?: 'Unit'; _id: string; name: string } | null;
      }
    | {
        __typename?: 'Chiller';
        _id: string;
        name?: string | null;
        type?: EnumDKeyDeviceType | null;
        propertyId: string;
        unitId: string;
        zoneId?: string | null;
        sourceId?: string | null;
        deviceId?: string | null;
        installation?: {
          __typename?: 'DeviceInstallation';
          status: number;
          count?: number | null;
          message?: string | null;
          paired?: boolean | null;
          pairedTo?: string | null;
          previousStatus?: string | null;
          rawDeviceId?: string | null;
          replacingDeviceId?: string | null;
        } | null;
        alertTypes?: {
          __typename?: 'DeviceAlertTypes';
          deviceOffline?: boolean | null;
          sourceOffline?: boolean | null;
        } | null;
        unit?: { __typename?: 'Unit'; _id: string; name: string } | null;
      }
    | {
        __typename?: 'ConductorGenericSensor';
        _id: string;
        name?: string | null;
        type?: EnumDKeyDeviceType | null;
        propertyId: string;
        unitId: string;
        zoneId?: string | null;
        sourceId?: string | null;
        deviceId?: string | null;
        installation?: {
          __typename?: 'DeviceInstallation';
          status: number;
          count?: number | null;
          message?: string | null;
          paired?: boolean | null;
          pairedTo?: string | null;
          previousStatus?: string | null;
          rawDeviceId?: string | null;
          replacingDeviceId?: string | null;
        } | null;
        alertTypes?: {
          __typename?: 'DeviceAlertTypes';
          deviceOffline?: boolean | null;
          sourceOffline?: boolean | null;
        } | null;
        unit?: { __typename?: 'Unit'; _id: string; name: string } | null;
      }
    | {
        __typename?: 'Controller';
        _id: string;
        name?: string | null;
        type?: EnumDKeyDeviceType | null;
        propertyId: string;
        unitId: string;
        zoneId?: string | null;
        sourceId?: string | null;
        deviceId?: string | null;
        installation?: {
          __typename?: 'DeviceInstallation';
          status: number;
          count?: number | null;
          message?: string | null;
          paired?: boolean | null;
          pairedTo?: string | null;
          previousStatus?: string | null;
          rawDeviceId?: string | null;
          replacingDeviceId?: string | null;
        } | null;
        alertTypes?: {
          __typename?: 'DeviceAlertTypes';
          deviceOffline?: boolean | null;
          sourceOffline?: boolean | null;
        } | null;
        unit?: { __typename?: 'Unit'; _id: string; name: string } | null;
      }
    | {
        __typename?: 'Device';
        _id: string;
        name?: string | null;
        type?: EnumDKeyDeviceType | null;
        propertyId: string;
        unitId: string;
        zoneId?: string | null;
        sourceId?: string | null;
        deviceId?: string | null;
        installation?: {
          __typename?: 'DeviceInstallation';
          status: number;
          count?: number | null;
          message?: string | null;
          paired?: boolean | null;
          pairedTo?: string | null;
          previousStatus?: string | null;
          rawDeviceId?: string | null;
          replacingDeviceId?: string | null;
        } | null;
        alertTypes?: {
          __typename?: 'DeviceAlertTypes';
          deviceOffline?: boolean | null;
          sourceOffline?: boolean | null;
        } | null;
        unit?: { __typename?: 'Unit'; _id: string; name: string } | null;
      }
    | {
        __typename?: 'DoorSensor';
        _id: string;
        name?: string | null;
        type?: EnumDKeyDeviceType | null;
        propertyId: string;
        unitId: string;
        zoneId?: string | null;
        sourceId?: string | null;
        deviceId?: string | null;
        installation?: {
          __typename?: 'DeviceInstallation';
          status: number;
          count?: number | null;
          message?: string | null;
          paired?: boolean | null;
          pairedTo?: string | null;
          previousStatus?: string | null;
          rawDeviceId?: string | null;
          replacingDeviceId?: string | null;
        } | null;
        alertTypes?: {
          __typename?: 'DeviceAlertTypes';
          deviceOffline?: boolean | null;
          sourceOffline?: boolean | null;
        } | null;
        unit?: { __typename?: 'Unit'; _id: string; name: string } | null;
      }
    | {
        __typename?: 'EnergyController';
        _id: string;
        name?: string | null;
        type?: EnumDKeyDeviceType | null;
        propertyId: string;
        unitId: string;
        zoneId?: string | null;
        sourceId?: string | null;
        deviceId?: string | null;
        installation?: {
          __typename?: 'DeviceInstallation';
          status: number;
          count?: number | null;
          message?: string | null;
          paired?: boolean | null;
          pairedTo?: string | null;
          previousStatus?: string | null;
          rawDeviceId?: string | null;
          replacingDeviceId?: string | null;
        } | null;
        alertTypes?: {
          __typename?: 'DeviceAlertTypes';
          deviceOffline?: boolean | null;
          sourceOffline?: boolean | null;
        } | null;
        unit?: { __typename?: 'Unit'; _id: string; name: string } | null;
      }
    | {
        __typename?: 'EnergyConverter';
        _id: string;
        name?: string | null;
        type?: EnumDKeyDeviceType | null;
        propertyId: string;
        unitId: string;
        zoneId?: string | null;
        sourceId?: string | null;
        deviceId?: string | null;
        installation?: {
          __typename?: 'DeviceInstallation';
          status: number;
          count?: number | null;
          message?: string | null;
          paired?: boolean | null;
          pairedTo?: string | null;
          previousStatus?: string | null;
          rawDeviceId?: string | null;
          replacingDeviceId?: string | null;
        } | null;
        alertTypes?: {
          __typename?: 'DeviceAlertTypes';
          deviceOffline?: boolean | null;
          sourceOffline?: boolean | null;
        } | null;
        unit?: { __typename?: 'Unit'; _id: string; name: string } | null;
      }
    | {
        __typename?: 'EnergyInverter';
        _id: string;
        name?: string | null;
        type?: EnumDKeyDeviceType | null;
        propertyId: string;
        unitId: string;
        zoneId?: string | null;
        sourceId?: string | null;
        deviceId?: string | null;
        installation?: {
          __typename?: 'DeviceInstallation';
          status: number;
          count?: number | null;
          message?: string | null;
          paired?: boolean | null;
          pairedTo?: string | null;
          previousStatus?: string | null;
          rawDeviceId?: string | null;
          replacingDeviceId?: string | null;
        } | null;
        alertTypes?: {
          __typename?: 'DeviceAlertTypes';
          deviceOffline?: boolean | null;
          sourceOffline?: boolean | null;
        } | null;
        unit?: { __typename?: 'Unit'; _id: string; name: string } | null;
      }
    | {
        __typename?: 'EnergyMeter';
        _id: string;
        name?: string | null;
        type?: EnumDKeyDeviceType | null;
        propertyId: string;
        unitId: string;
        zoneId?: string | null;
        sourceId?: string | null;
        deviceId?: string | null;
        installation?: {
          __typename?: 'DeviceInstallation';
          status: number;
          count?: number | null;
          message?: string | null;
          paired?: boolean | null;
          pairedTo?: string | null;
          previousStatus?: string | null;
          rawDeviceId?: string | null;
          replacingDeviceId?: string | null;
        } | null;
        alertTypes?: {
          __typename?: 'DeviceAlertTypes';
          deviceOffline?: boolean | null;
          sourceOffline?: boolean | null;
        } | null;
        unit?: { __typename?: 'Unit'; _id: string; name: string } | null;
      }
    | {
        __typename?: 'EnergyRectifier';
        _id: string;
        name?: string | null;
        type?: EnumDKeyDeviceType | null;
        propertyId: string;
        unitId: string;
        zoneId?: string | null;
        sourceId?: string | null;
        deviceId?: string | null;
        installation?: {
          __typename?: 'DeviceInstallation';
          status: number;
          count?: number | null;
          message?: string | null;
          paired?: boolean | null;
          pairedTo?: string | null;
          previousStatus?: string | null;
          rawDeviceId?: string | null;
          replacingDeviceId?: string | null;
        } | null;
        alertTypes?: {
          __typename?: 'DeviceAlertTypes';
          deviceOffline?: boolean | null;
          sourceOffline?: boolean | null;
        } | null;
        unit?: { __typename?: 'Unit'; _id: string; name: string } | null;
      }
    | {
        __typename?: 'EnergyStorageCoolingSystem';
        _id: string;
        name?: string | null;
        type?: EnumDKeyDeviceType | null;
        propertyId: string;
        unitId: string;
        zoneId?: string | null;
        sourceId?: string | null;
        deviceId?: string | null;
        installation?: {
          __typename?: 'DeviceInstallation';
          status: number;
          count?: number | null;
          message?: string | null;
          paired?: boolean | null;
          pairedTo?: string | null;
          previousStatus?: string | null;
          rawDeviceId?: string | null;
          replacingDeviceId?: string | null;
        } | null;
        alertTypes?: {
          __typename?: 'DeviceAlertTypes';
          deviceOffline?: boolean | null;
          sourceOffline?: boolean | null;
        } | null;
        unit?: { __typename?: 'Unit'; _id: string; name: string } | null;
      }
    | {
        __typename?: 'EnergySwitchPanel';
        _id: string;
        name?: string | null;
        type?: EnumDKeyDeviceType | null;
        propertyId: string;
        unitId: string;
        zoneId?: string | null;
        sourceId?: string | null;
        deviceId?: string | null;
        installation?: {
          __typename?: 'DeviceInstallation';
          status: number;
          count?: number | null;
          message?: string | null;
          paired?: boolean | null;
          pairedTo?: string | null;
          previousStatus?: string | null;
          rawDeviceId?: string | null;
          replacingDeviceId?: string | null;
        } | null;
        alertTypes?: {
          __typename?: 'DeviceAlertTypes';
          deviceOffline?: boolean | null;
          sourceOffline?: boolean | null;
        } | null;
        unit?: { __typename?: 'Unit'; _id: string; name: string } | null;
      }
    | {
        __typename?: 'EnergySwitchPanelCircuit';
        _id: string;
        name?: string | null;
        type?: EnumDKeyDeviceType | null;
        propertyId: string;
        unitId: string;
        zoneId?: string | null;
        sourceId?: string | null;
        deviceId?: string | null;
        installation?: {
          __typename?: 'DeviceInstallation';
          status: number;
          count?: number | null;
          message?: string | null;
          paired?: boolean | null;
          pairedTo?: string | null;
          previousStatus?: string | null;
          rawDeviceId?: string | null;
          replacingDeviceId?: string | null;
        } | null;
        alertTypes?: {
          __typename?: 'DeviceAlertTypes';
          deviceOffline?: boolean | null;
          sourceOffline?: boolean | null;
        } | null;
        unit?: { __typename?: 'Unit'; _id: string; name: string } | null;
      }
    | {
        __typename?: 'FireSuppressionSystem';
        _id: string;
        name?: string | null;
        type?: EnumDKeyDeviceType | null;
        propertyId: string;
        unitId: string;
        zoneId?: string | null;
        sourceId?: string | null;
        deviceId?: string | null;
        installation?: {
          __typename?: 'DeviceInstallation';
          status: number;
          count?: number | null;
          message?: string | null;
          paired?: boolean | null;
          pairedTo?: string | null;
          previousStatus?: string | null;
          rawDeviceId?: string | null;
          replacingDeviceId?: string | null;
        } | null;
        alertTypes?: {
          __typename?: 'DeviceAlertTypes';
          deviceOffline?: boolean | null;
          sourceOffline?: boolean | null;
        } | null;
        unit?: { __typename?: 'Unit'; _id: string; name: string } | null;
      }
    | {
        __typename?: 'GPIO';
        _id: string;
        name?: string | null;
        type?: EnumDKeyDeviceType | null;
        propertyId: string;
        unitId: string;
        zoneId?: string | null;
        sourceId?: string | null;
        deviceId?: string | null;
        installation?: {
          __typename?: 'DeviceInstallation';
          status: number;
          count?: number | null;
          message?: string | null;
          paired?: boolean | null;
          pairedTo?: string | null;
          previousStatus?: string | null;
          rawDeviceId?: string | null;
          replacingDeviceId?: string | null;
        } | null;
        alertTypes?: {
          __typename?: 'DeviceAlertTypes';
          deviceOffline?: boolean | null;
          sourceOffline?: boolean | null;
        } | null;
        unit?: { __typename?: 'Unit'; _id: string; name: string } | null;
      }
    | {
        __typename?: 'IndoorAirHandler';
        _id: string;
        name?: string | null;
        type?: EnumDKeyDeviceType | null;
        propertyId: string;
        unitId: string;
        zoneId?: string | null;
        sourceId?: string | null;
        deviceId?: string | null;
        installation?: {
          __typename?: 'DeviceInstallation';
          status: number;
          count?: number | null;
          message?: string | null;
          paired?: boolean | null;
          pairedTo?: string | null;
          previousStatus?: string | null;
          rawDeviceId?: string | null;
          replacingDeviceId?: string | null;
        } | null;
        alertTypes?: {
          __typename?: 'DeviceAlertTypes';
          deviceOffline?: boolean | null;
          sourceOffline?: boolean | null;
        } | null;
        unit?: { __typename?: 'Unit'; _id: string; name: string } | null;
      }
    | {
        __typename?: 'IndoorSensor';
        _id: string;
        name?: string | null;
        type?: EnumDKeyDeviceType | null;
        propertyId: string;
        unitId: string;
        zoneId?: string | null;
        sourceId?: string | null;
        deviceId?: string | null;
        installation?: {
          __typename?: 'DeviceInstallation';
          status: number;
          count?: number | null;
          message?: string | null;
          paired?: boolean | null;
          pairedTo?: string | null;
          previousStatus?: string | null;
          rawDeviceId?: string | null;
          replacingDeviceId?: string | null;
        } | null;
        alertTypes?: {
          __typename?: 'DeviceAlertTypes';
          deviceOffline?: boolean | null;
          sourceOffline?: boolean | null;
        } | null;
        unit?: { __typename?: 'Unit'; _id: string; name: string } | null;
      }
    | {
        __typename?: 'KineticEnergyManagementSystem';
        _id: string;
        name?: string | null;
        type?: EnumDKeyDeviceType | null;
        propertyId: string;
        unitId: string;
        zoneId?: string | null;
        sourceId?: string | null;
        deviceId?: string | null;
        installation?: {
          __typename?: 'DeviceInstallation';
          status: number;
          count?: number | null;
          message?: string | null;
          paired?: boolean | null;
          pairedTo?: string | null;
          previousStatus?: string | null;
          rawDeviceId?: string | null;
          replacingDeviceId?: string | null;
        } | null;
        alertTypes?: {
          __typename?: 'DeviceAlertTypes';
          deviceOffline?: boolean | null;
          sourceOffline?: boolean | null;
        } | null;
        unit?: { __typename?: 'Unit'; _id: string; name: string } | null;
      }
    | {
        __typename?: 'LeakDetector';
        _id: string;
        name?: string | null;
        type?: EnumDKeyDeviceType | null;
        propertyId: string;
        unitId: string;
        zoneId?: string | null;
        sourceId?: string | null;
        deviceId?: string | null;
        installation?: {
          __typename?: 'DeviceInstallation';
          status: number;
          count?: number | null;
          message?: string | null;
          paired?: boolean | null;
          pairedTo?: string | null;
          previousStatus?: string | null;
          rawDeviceId?: string | null;
          replacingDeviceId?: string | null;
        } | null;
        alertTypes?: {
          __typename?: 'DeviceAlertTypes';
          deviceOffline?: boolean | null;
          sourceOffline?: boolean | null;
        } | null;
        unit?: { __typename?: 'Unit'; _id: string; name: string } | null;
      }
    | {
        __typename?: 'Loop';
        _id: string;
        name?: string | null;
        type?: EnumDKeyDeviceType | null;
        propertyId: string;
        unitId: string;
        zoneId?: string | null;
        sourceId?: string | null;
        deviceId?: string | null;
        installation?: {
          __typename?: 'DeviceInstallation';
          status: number;
          count?: number | null;
          message?: string | null;
          paired?: boolean | null;
          pairedTo?: string | null;
          previousStatus?: string | null;
          rawDeviceId?: string | null;
          replacingDeviceId?: string | null;
        } | null;
        alertTypes?: {
          __typename?: 'DeviceAlertTypes';
          deviceOffline?: boolean | null;
          sourceOffline?: boolean | null;
        } | null;
        unit?: { __typename?: 'Unit'; _id: string; name: string } | null;
      }
    | {
        __typename?: 'ModbusAirHandler';
        _id: string;
        name?: string | null;
        type?: EnumDKeyDeviceType | null;
        propertyId: string;
        unitId: string;
        zoneId?: string | null;
        sourceId?: string | null;
        deviceId?: string | null;
        installation?: {
          __typename?: 'DeviceInstallation';
          status: number;
          count?: number | null;
          message?: string | null;
          paired?: boolean | null;
          pairedTo?: string | null;
          previousStatus?: string | null;
          rawDeviceId?: string | null;
          replacingDeviceId?: string | null;
        } | null;
        alertTypes?: {
          __typename?: 'DeviceAlertTypes';
          deviceOffline?: boolean | null;
          sourceOffline?: boolean | null;
        } | null;
        unit?: { __typename?: 'Unit'; _id: string; name: string } | null;
      }
    | {
        __typename?: 'OccupancySensor';
        _id: string;
        name?: string | null;
        type?: EnumDKeyDeviceType | null;
        propertyId: string;
        unitId: string;
        zoneId?: string | null;
        sourceId?: string | null;
        deviceId?: string | null;
        installation?: {
          __typename?: 'DeviceInstallation';
          status: number;
          count?: number | null;
          message?: string | null;
          paired?: boolean | null;
          pairedTo?: string | null;
          previousStatus?: string | null;
          rawDeviceId?: string | null;
          replacingDeviceId?: string | null;
        } | null;
        alertTypes?: {
          __typename?: 'DeviceAlertTypes';
          deviceOffline?: boolean | null;
          sourceOffline?: boolean | null;
        } | null;
        unit?: { __typename?: 'Unit'; _id: string; name: string } | null;
      }
    | {
        __typename?: 'OpenWeather';
        _id: string;
        name?: string | null;
        type?: EnumDKeyDeviceType | null;
        propertyId: string;
        unitId: string;
        zoneId?: string | null;
        sourceId?: string | null;
        deviceId?: string | null;
        installation?: {
          __typename?: 'DeviceInstallation';
          status: number;
          count?: number | null;
          message?: string | null;
          paired?: boolean | null;
          pairedTo?: string | null;
          previousStatus?: string | null;
          rawDeviceId?: string | null;
          replacingDeviceId?: string | null;
        } | null;
        alertTypes?: {
          __typename?: 'DeviceAlertTypes';
          deviceOffline?: boolean | null;
          sourceOffline?: boolean | null;
        } | null;
        unit?: { __typename?: 'Unit'; _id: string; name: string } | null;
      }
    | {
        __typename?: 'OutdoorSensor';
        _id: string;
        name?: string | null;
        type?: EnumDKeyDeviceType | null;
        propertyId: string;
        unitId: string;
        zoneId?: string | null;
        sourceId?: string | null;
        deviceId?: string | null;
        installation?: {
          __typename?: 'DeviceInstallation';
          status: number;
          count?: number | null;
          message?: string | null;
          paired?: boolean | null;
          pairedTo?: string | null;
          previousStatus?: string | null;
          rawDeviceId?: string | null;
          replacingDeviceId?: string | null;
        } | null;
        alertTypes?: {
          __typename?: 'DeviceAlertTypes';
          deviceOffline?: boolean | null;
          sourceOffline?: boolean | null;
        } | null;
        unit?: { __typename?: 'Unit'; _id: string; name: string } | null;
      }
    | {
        __typename?: 'PowerMonitor';
        _id: string;
        name?: string | null;
        type?: EnumDKeyDeviceType | null;
        propertyId: string;
        unitId: string;
        zoneId?: string | null;
        sourceId?: string | null;
        deviceId?: string | null;
        installation?: {
          __typename?: 'DeviceInstallation';
          status: number;
          count?: number | null;
          message?: string | null;
          paired?: boolean | null;
          pairedTo?: string | null;
          previousStatus?: string | null;
          rawDeviceId?: string | null;
          replacingDeviceId?: string | null;
        } | null;
        alertTypes?: {
          __typename?: 'DeviceAlertTypes';
          deviceOffline?: boolean | null;
          sourceOffline?: boolean | null;
        } | null;
        unit?: { __typename?: 'Unit'; _id: string; name: string } | null;
      }
    | {
        __typename?: 'PressureSensor';
        _id: string;
        name?: string | null;
        type?: EnumDKeyDeviceType | null;
        propertyId: string;
        unitId: string;
        zoneId?: string | null;
        sourceId?: string | null;
        deviceId?: string | null;
        installation?: {
          __typename?: 'DeviceInstallation';
          status: number;
          count?: number | null;
          message?: string | null;
          paired?: boolean | null;
          pairedTo?: string | null;
          previousStatus?: string | null;
          rawDeviceId?: string | null;
          replacingDeviceId?: string | null;
        } | null;
        alertTypes?: {
          __typename?: 'DeviceAlertTypes';
          deviceOffline?: boolean | null;
          sourceOffline?: boolean | null;
        } | null;
        unit?: { __typename?: 'Unit'; _id: string; name: string } | null;
      }
    | {
        __typename?: 'RelayDevice';
        _id: string;
        name?: string | null;
        type?: EnumDKeyDeviceType | null;
        propertyId: string;
        unitId: string;
        zoneId?: string | null;
        sourceId?: string | null;
        deviceId?: string | null;
        installation?: {
          __typename?: 'DeviceInstallation';
          status: number;
          count?: number | null;
          message?: string | null;
          paired?: boolean | null;
          pairedTo?: string | null;
          previousStatus?: string | null;
          rawDeviceId?: string | null;
          replacingDeviceId?: string | null;
        } | null;
        alertTypes?: {
          __typename?: 'DeviceAlertTypes';
          deviceOffline?: boolean | null;
          sourceOffline?: boolean | null;
        } | null;
        unit?: { __typename?: 'Unit'; _id: string; name: string } | null;
      }
    | {
        __typename?: 'SmartPowerOutlet';
        _id: string;
        name?: string | null;
        type?: EnumDKeyDeviceType | null;
        propertyId: string;
        unitId: string;
        zoneId?: string | null;
        sourceId?: string | null;
        deviceId?: string | null;
        installation?: {
          __typename?: 'DeviceInstallation';
          status: number;
          count?: number | null;
          message?: string | null;
          paired?: boolean | null;
          pairedTo?: string | null;
          previousStatus?: string | null;
          rawDeviceId?: string | null;
          replacingDeviceId?: string | null;
        } | null;
        alertTypes?: {
          __typename?: 'DeviceAlertTypes';
          deviceOffline?: boolean | null;
          sourceOffline?: boolean | null;
        } | null;
        unit?: { __typename?: 'Unit'; _id: string; name: string } | null;
      }
    | {
        __typename?: 'SolarManagementSystem';
        _id: string;
        name?: string | null;
        type?: EnumDKeyDeviceType | null;
        propertyId: string;
        unitId: string;
        zoneId?: string | null;
        sourceId?: string | null;
        deviceId?: string | null;
        installation?: {
          __typename?: 'DeviceInstallation';
          status: number;
          count?: number | null;
          message?: string | null;
          paired?: boolean | null;
          pairedTo?: string | null;
          previousStatus?: string | null;
          rawDeviceId?: string | null;
          replacingDeviceId?: string | null;
        } | null;
        alertTypes?: {
          __typename?: 'DeviceAlertTypes';
          deviceOffline?: boolean | null;
          sourceOffline?: boolean | null;
        } | null;
        unit?: { __typename?: 'Unit'; _id: string; name: string } | null;
      }
    | {
        __typename?: 'Thermistor';
        _id: string;
        name?: string | null;
        type?: EnumDKeyDeviceType | null;
        propertyId: string;
        unitId: string;
        zoneId?: string | null;
        sourceId?: string | null;
        deviceId?: string | null;
        installation?: {
          __typename?: 'DeviceInstallation';
          status: number;
          count?: number | null;
          message?: string | null;
          paired?: boolean | null;
          pairedTo?: string | null;
          previousStatus?: string | null;
          rawDeviceId?: string | null;
          replacingDeviceId?: string | null;
        } | null;
        alertTypes?: {
          __typename?: 'DeviceAlertTypes';
          deviceOffline?: boolean | null;
          sourceOffline?: boolean | null;
        } | null;
        unit?: { __typename?: 'Unit'; _id: string; name: string } | null;
      }
    | {
        __typename?: 'Thermostat';
        _id: string;
        name?: string | null;
        type?: EnumDKeyDeviceType | null;
        propertyId: string;
        unitId: string;
        zoneId?: string | null;
        sourceId?: string | null;
        deviceId?: string | null;
        installation?: {
          __typename?: 'DeviceInstallation';
          status: number;
          count?: number | null;
          message?: string | null;
          paired?: boolean | null;
          pairedTo?: string | null;
          previousStatus?: string | null;
          rawDeviceId?: string | null;
          replacingDeviceId?: string | null;
        } | null;
        alertTypes?: {
          __typename?: 'DeviceAlertTypes';
          deviceOffline?: boolean | null;
          sourceOffline?: boolean | null;
        } | null;
        unit?: { __typename?: 'Unit'; _id: string; name: string } | null;
      }
    | {
        __typename?: 'VSDPump';
        _id: string;
        name?: string | null;
        type?: EnumDKeyDeviceType | null;
        propertyId: string;
        unitId: string;
        zoneId?: string | null;
        sourceId?: string | null;
        deviceId?: string | null;
        installation?: {
          __typename?: 'DeviceInstallation';
          status: number;
          count?: number | null;
          message?: string | null;
          paired?: boolean | null;
          pairedTo?: string | null;
          previousStatus?: string | null;
          rawDeviceId?: string | null;
          replacingDeviceId?: string | null;
        } | null;
        alertTypes?: {
          __typename?: 'DeviceAlertTypes';
          deviceOffline?: boolean | null;
          sourceOffline?: boolean | null;
        } | null;
        unit?: { __typename?: 'Unit'; _id: string; name: string } | null;
      }
    | {
        __typename?: 'WindManagementSystem';
        _id: string;
        name?: string | null;
        type?: EnumDKeyDeviceType | null;
        propertyId: string;
        unitId: string;
        zoneId?: string | null;
        sourceId?: string | null;
        deviceId?: string | null;
        installation?: {
          __typename?: 'DeviceInstallation';
          status: number;
          count?: number | null;
          message?: string | null;
          paired?: boolean | null;
          pairedTo?: string | null;
          previousStatus?: string | null;
          rawDeviceId?: string | null;
          replacingDeviceId?: string | null;
        } | null;
        alertTypes?: {
          __typename?: 'DeviceAlertTypes';
          deviceOffline?: boolean | null;
          sourceOffline?: boolean | null;
        } | null;
        unit?: { __typename?: 'Unit'; _id: string; name: string } | null;
      }
    | {
        __typename?: 'WindowSensor';
        _id: string;
        name?: string | null;
        type?: EnumDKeyDeviceType | null;
        propertyId: string;
        unitId: string;
        zoneId?: string | null;
        sourceId?: string | null;
        deviceId?: string | null;
        installation?: {
          __typename?: 'DeviceInstallation';
          status: number;
          count?: number | null;
          message?: string | null;
          paired?: boolean | null;
          pairedTo?: string | null;
          previousStatus?: string | null;
          rawDeviceId?: string | null;
          replacingDeviceId?: string | null;
        } | null;
        alertTypes?: {
          __typename?: 'DeviceAlertTypes';
          deviceOffline?: boolean | null;
          sourceOffline?: boolean | null;
        } | null;
        unit?: { __typename?: 'Unit'; _id: string; name: string } | null;
      }
    | {
        __typename?: 'Z210Pump';
        _id: string;
        name?: string | null;
        type?: EnumDKeyDeviceType | null;
        propertyId: string;
        unitId: string;
        zoneId?: string | null;
        sourceId?: string | null;
        deviceId?: string | null;
        installation?: {
          __typename?: 'DeviceInstallation';
          status: number;
          count?: number | null;
          message?: string | null;
          paired?: boolean | null;
          pairedTo?: string | null;
          previousStatus?: string | null;
          rawDeviceId?: string | null;
          replacingDeviceId?: string | null;
        } | null;
        alertTypes?: {
          __typename?: 'DeviceAlertTypes';
          deviceOffline?: boolean | null;
          sourceOffline?: boolean | null;
        } | null;
        unit?: { __typename?: 'Unit'; _id: string; name: string } | null;
      }
    | null;
};

export type UnitInstallerDetailQueryVariables = Exact<{
  id: Scalars['String'];
}>;

export type UnitInstallerDetailQuery = {
  __typename?: 'Query';
  unitById?: {
    __typename?: 'Unit';
    _id: string;
    name: string;
    setpointProfileId?: string | null;
    devicesSummary?: {
      __typename?: 'UnitDevicesSummary';
      count?: number | null;
      majorAlerts?: number | null;
      minorAlerts?: number | null;
      proxy?: {
        __typename: 'UnitDevicesSummaryProxy';
        type?: string | null;
        coolSetpoint?: number | null;
        heatSetpoint?: number | null;
        humidity?: number | null;
        isOffline?: boolean | null;
        operatingMode?: string | null;
        operatingState?: string | null;
        setpointCoolMin?: number | null;
        setpointHeatMax?: number | null;
        setpointProfileName?: string | null;
        setpointProfileType?: string | null;
        temperature?: number | null;
      } | null;
    } | null;
    zones: Array<{
      __typename: 'Zone';
      _id: string;
      name: string;
      controller?: string | null;
      thermostatId?: string | null;
      pairedSensorId?: string | null;
      role?: string | null;
      devices: Array<
        | {
            __typename: 'Actuator';
            _id: string;
            deviceId?: string | null;
            name?: string | null;
            type?: EnumDKeyDeviceType | null;
            typeDisplayName: string;
            isConfigured?: boolean | null;
            installation?: {
              __typename?: 'DeviceInstallation';
              status: number;
              count?: number | null;
              message?: string | null;
              paired?: boolean | null;
              pairedTo?: string | null;
              previousStatus?: string | null;
              rawDeviceId?: string | null;
              replacingDeviceId?: string | null;
            } | null;
          }
        | {
            __typename: 'BatteryManagementSystem';
            _id: string;
            deviceId?: string | null;
            name?: string | null;
            type?: EnumDKeyDeviceType | null;
            typeDisplayName: string;
            isConfigured?: boolean | null;
            installation?: {
              __typename?: 'DeviceInstallation';
              status: number;
              count?: number | null;
              message?: string | null;
              paired?: boolean | null;
              pairedTo?: string | null;
              previousStatus?: string | null;
              rawDeviceId?: string | null;
              replacingDeviceId?: string | null;
            } | null;
          }
        | {
            __typename: 'Boiler';
            _id: string;
            deviceId?: string | null;
            name?: string | null;
            type?: EnumDKeyDeviceType | null;
            typeDisplayName: string;
            isConfigured?: boolean | null;
            installation?: {
              __typename?: 'DeviceInstallation';
              status: number;
              count?: number | null;
              message?: string | null;
              paired?: boolean | null;
              pairedTo?: string | null;
              previousStatus?: string | null;
              rawDeviceId?: string | null;
              replacingDeviceId?: string | null;
            } | null;
          }
        | {
            __typename: 'Chiller';
            _id: string;
            deviceId?: string | null;
            name?: string | null;
            type?: EnumDKeyDeviceType | null;
            typeDisplayName: string;
            isConfigured?: boolean | null;
            installation?: {
              __typename?: 'DeviceInstallation';
              status: number;
              count?: number | null;
              message?: string | null;
              paired?: boolean | null;
              pairedTo?: string | null;
              previousStatus?: string | null;
              rawDeviceId?: string | null;
              replacingDeviceId?: string | null;
            } | null;
          }
        | {
            __typename: 'ConductorGenericSensor';
            _id: string;
            deviceId?: string | null;
            name?: string | null;
            type?: EnumDKeyDeviceType | null;
            typeDisplayName: string;
            isConfigured?: boolean | null;
            installation?: {
              __typename?: 'DeviceInstallation';
              status: number;
              count?: number | null;
              message?: string | null;
              paired?: boolean | null;
              pairedTo?: string | null;
              previousStatus?: string | null;
              rawDeviceId?: string | null;
              replacingDeviceId?: string | null;
            } | null;
          }
        | {
            __typename: 'Controller';
            _id: string;
            deviceId?: string | null;
            name?: string | null;
            type?: EnumDKeyDeviceType | null;
            typeDisplayName: string;
            isConfigured?: boolean | null;
            installation?: {
              __typename?: 'DeviceInstallation';
              status: number;
              count?: number | null;
              message?: string | null;
              paired?: boolean | null;
              pairedTo?: string | null;
              previousStatus?: string | null;
              rawDeviceId?: string | null;
              replacingDeviceId?: string | null;
            } | null;
          }
        | {
            __typename: 'Device';
            _id: string;
            deviceId?: string | null;
            name?: string | null;
            type?: EnumDKeyDeviceType | null;
            typeDisplayName: string;
            isConfigured?: boolean | null;
            installation?: {
              __typename?: 'DeviceInstallation';
              status: number;
              count?: number | null;
              message?: string | null;
              paired?: boolean | null;
              pairedTo?: string | null;
              previousStatus?: string | null;
              rawDeviceId?: string | null;
              replacingDeviceId?: string | null;
            } | null;
          }
        | {
            __typename: 'DoorSensor';
            _id: string;
            deviceId?: string | null;
            name?: string | null;
            type?: EnumDKeyDeviceType | null;
            typeDisplayName: string;
            isConfigured?: boolean | null;
            installation?: {
              __typename?: 'DeviceInstallation';
              status: number;
              count?: number | null;
              message?: string | null;
              paired?: boolean | null;
              pairedTo?: string | null;
              previousStatus?: string | null;
              rawDeviceId?: string | null;
              replacingDeviceId?: string | null;
            } | null;
          }
        | {
            __typename: 'EnergyController';
            _id: string;
            deviceId?: string | null;
            name?: string | null;
            type?: EnumDKeyDeviceType | null;
            typeDisplayName: string;
            isConfigured?: boolean | null;
            installation?: {
              __typename?: 'DeviceInstallation';
              status: number;
              count?: number | null;
              message?: string | null;
              paired?: boolean | null;
              pairedTo?: string | null;
              previousStatus?: string | null;
              rawDeviceId?: string | null;
              replacingDeviceId?: string | null;
            } | null;
          }
        | {
            __typename: 'EnergyConverter';
            _id: string;
            deviceId?: string | null;
            name?: string | null;
            type?: EnumDKeyDeviceType | null;
            typeDisplayName: string;
            isConfigured?: boolean | null;
            installation?: {
              __typename?: 'DeviceInstallation';
              status: number;
              count?: number | null;
              message?: string | null;
              paired?: boolean | null;
              pairedTo?: string | null;
              previousStatus?: string | null;
              rawDeviceId?: string | null;
              replacingDeviceId?: string | null;
            } | null;
          }
        | {
            __typename: 'EnergyInverter';
            _id: string;
            deviceId?: string | null;
            name?: string | null;
            type?: EnumDKeyDeviceType | null;
            typeDisplayName: string;
            isConfigured?: boolean | null;
            installation?: {
              __typename?: 'DeviceInstallation';
              status: number;
              count?: number | null;
              message?: string | null;
              paired?: boolean | null;
              pairedTo?: string | null;
              previousStatus?: string | null;
              rawDeviceId?: string | null;
              replacingDeviceId?: string | null;
            } | null;
          }
        | {
            __typename: 'EnergyMeter';
            _id: string;
            deviceId?: string | null;
            name?: string | null;
            type?: EnumDKeyDeviceType | null;
            typeDisplayName: string;
            isConfigured?: boolean | null;
            installation?: {
              __typename?: 'DeviceInstallation';
              status: number;
              count?: number | null;
              message?: string | null;
              paired?: boolean | null;
              pairedTo?: string | null;
              previousStatus?: string | null;
              rawDeviceId?: string | null;
              replacingDeviceId?: string | null;
            } | null;
          }
        | {
            __typename: 'EnergyRectifier';
            _id: string;
            deviceId?: string | null;
            name?: string | null;
            type?: EnumDKeyDeviceType | null;
            typeDisplayName: string;
            isConfigured?: boolean | null;
            installation?: {
              __typename?: 'DeviceInstallation';
              status: number;
              count?: number | null;
              message?: string | null;
              paired?: boolean | null;
              pairedTo?: string | null;
              previousStatus?: string | null;
              rawDeviceId?: string | null;
              replacingDeviceId?: string | null;
            } | null;
          }
        | {
            __typename: 'EnergyStorageCoolingSystem';
            _id: string;
            deviceId?: string | null;
            name?: string | null;
            type?: EnumDKeyDeviceType | null;
            typeDisplayName: string;
            isConfigured?: boolean | null;
            installation?: {
              __typename?: 'DeviceInstallation';
              status: number;
              count?: number | null;
              message?: string | null;
              paired?: boolean | null;
              pairedTo?: string | null;
              previousStatus?: string | null;
              rawDeviceId?: string | null;
              replacingDeviceId?: string | null;
            } | null;
          }
        | {
            __typename: 'EnergySwitchPanel';
            _id: string;
            deviceId?: string | null;
            name?: string | null;
            type?: EnumDKeyDeviceType | null;
            typeDisplayName: string;
            isConfigured?: boolean | null;
            installation?: {
              __typename?: 'DeviceInstallation';
              status: number;
              count?: number | null;
              message?: string | null;
              paired?: boolean | null;
              pairedTo?: string | null;
              previousStatus?: string | null;
              rawDeviceId?: string | null;
              replacingDeviceId?: string | null;
            } | null;
          }
        | {
            __typename: 'EnergySwitchPanelCircuit';
            _id: string;
            deviceId?: string | null;
            name?: string | null;
            type?: EnumDKeyDeviceType | null;
            typeDisplayName: string;
            isConfigured?: boolean | null;
            installation?: {
              __typename?: 'DeviceInstallation';
              status: number;
              count?: number | null;
              message?: string | null;
              paired?: boolean | null;
              pairedTo?: string | null;
              previousStatus?: string | null;
              rawDeviceId?: string | null;
              replacingDeviceId?: string | null;
            } | null;
          }
        | {
            __typename: 'FireSuppressionSystem';
            _id: string;
            deviceId?: string | null;
            name?: string | null;
            type?: EnumDKeyDeviceType | null;
            typeDisplayName: string;
            isConfigured?: boolean | null;
            installation?: {
              __typename?: 'DeviceInstallation';
              status: number;
              count?: number | null;
              message?: string | null;
              paired?: boolean | null;
              pairedTo?: string | null;
              previousStatus?: string | null;
              rawDeviceId?: string | null;
              replacingDeviceId?: string | null;
            } | null;
          }
        | {
            __typename: 'GPIO';
            _id: string;
            deviceId?: string | null;
            name?: string | null;
            type?: EnumDKeyDeviceType | null;
            typeDisplayName: string;
            isConfigured?: boolean | null;
            installation?: {
              __typename?: 'DeviceInstallation';
              status: number;
              count?: number | null;
              message?: string | null;
              paired?: boolean | null;
              pairedTo?: string | null;
              previousStatus?: string | null;
              rawDeviceId?: string | null;
              replacingDeviceId?: string | null;
            } | null;
          }
        | {
            __typename: 'IndoorAirHandler';
            _id: string;
            deviceId?: string | null;
            name?: string | null;
            type?: EnumDKeyDeviceType | null;
            typeDisplayName: string;
            isConfigured?: boolean | null;
            installation?: {
              __typename?: 'DeviceInstallation';
              status: number;
              count?: number | null;
              message?: string | null;
              paired?: boolean | null;
              pairedTo?: string | null;
              previousStatus?: string | null;
              rawDeviceId?: string | null;
              replacingDeviceId?: string | null;
            } | null;
          }
        | {
            __typename: 'IndoorSensor';
            _id: string;
            deviceId?: string | null;
            name?: string | null;
            type?: EnumDKeyDeviceType | null;
            typeDisplayName: string;
            isConfigured?: boolean | null;
            installation?: {
              __typename?: 'DeviceInstallation';
              status: number;
              count?: number | null;
              message?: string | null;
              paired?: boolean | null;
              pairedTo?: string | null;
              previousStatus?: string | null;
              rawDeviceId?: string | null;
              replacingDeviceId?: string | null;
            } | null;
          }
        | {
            __typename: 'KineticEnergyManagementSystem';
            _id: string;
            deviceId?: string | null;
            name?: string | null;
            type?: EnumDKeyDeviceType | null;
            typeDisplayName: string;
            isConfigured?: boolean | null;
            installation?: {
              __typename?: 'DeviceInstallation';
              status: number;
              count?: number | null;
              message?: string | null;
              paired?: boolean | null;
              pairedTo?: string | null;
              previousStatus?: string | null;
              rawDeviceId?: string | null;
              replacingDeviceId?: string | null;
            } | null;
          }
        | {
            __typename: 'LeakDetector';
            _id: string;
            deviceId?: string | null;
            name?: string | null;
            type?: EnumDKeyDeviceType | null;
            typeDisplayName: string;
            isConfigured?: boolean | null;
            installation?: {
              __typename?: 'DeviceInstallation';
              status: number;
              count?: number | null;
              message?: string | null;
              paired?: boolean | null;
              pairedTo?: string | null;
              previousStatus?: string | null;
              rawDeviceId?: string | null;
              replacingDeviceId?: string | null;
            } | null;
          }
        | {
            __typename: 'Loop';
            _id: string;
            deviceId?: string | null;
            name?: string | null;
            type?: EnumDKeyDeviceType | null;
            typeDisplayName: string;
            isConfigured?: boolean | null;
            installation?: {
              __typename?: 'DeviceInstallation';
              status: number;
              count?: number | null;
              message?: string | null;
              paired?: boolean | null;
              pairedTo?: string | null;
              previousStatus?: string | null;
              rawDeviceId?: string | null;
              replacingDeviceId?: string | null;
            } | null;
          }
        | {
            __typename: 'ModbusAirHandler';
            _id: string;
            deviceId?: string | null;
            name?: string | null;
            type?: EnumDKeyDeviceType | null;
            typeDisplayName: string;
            isConfigured?: boolean | null;
            installation?: {
              __typename?: 'DeviceInstallation';
              status: number;
              count?: number | null;
              message?: string | null;
              paired?: boolean | null;
              pairedTo?: string | null;
              previousStatus?: string | null;
              rawDeviceId?: string | null;
              replacingDeviceId?: string | null;
            } | null;
          }
        | {
            __typename: 'OccupancySensor';
            _id: string;
            deviceId?: string | null;
            name?: string | null;
            type?: EnumDKeyDeviceType | null;
            typeDisplayName: string;
            isConfigured?: boolean | null;
            installation?: {
              __typename?: 'DeviceInstallation';
              status: number;
              count?: number | null;
              message?: string | null;
              paired?: boolean | null;
              pairedTo?: string | null;
              previousStatus?: string | null;
              rawDeviceId?: string | null;
              replacingDeviceId?: string | null;
            } | null;
          }
        | {
            __typename: 'OpenWeather';
            _id: string;
            deviceId?: string | null;
            name?: string | null;
            type?: EnumDKeyDeviceType | null;
            typeDisplayName: string;
            isConfigured?: boolean | null;
            installation?: {
              __typename?: 'DeviceInstallation';
              status: number;
              count?: number | null;
              message?: string | null;
              paired?: boolean | null;
              pairedTo?: string | null;
              previousStatus?: string | null;
              rawDeviceId?: string | null;
              replacingDeviceId?: string | null;
            } | null;
          }
        | {
            __typename: 'OutdoorSensor';
            _id: string;
            deviceId?: string | null;
            name?: string | null;
            type?: EnumDKeyDeviceType | null;
            typeDisplayName: string;
            isConfigured?: boolean | null;
            installation?: {
              __typename?: 'DeviceInstallation';
              status: number;
              count?: number | null;
              message?: string | null;
              paired?: boolean | null;
              pairedTo?: string | null;
              previousStatus?: string | null;
              rawDeviceId?: string | null;
              replacingDeviceId?: string | null;
            } | null;
          }
        | {
            __typename: 'PowerMonitor';
            _id: string;
            deviceId?: string | null;
            name?: string | null;
            type?: EnumDKeyDeviceType | null;
            typeDisplayName: string;
            isConfigured?: boolean | null;
            installation?: {
              __typename?: 'DeviceInstallation';
              status: number;
              count?: number | null;
              message?: string | null;
              paired?: boolean | null;
              pairedTo?: string | null;
              previousStatus?: string | null;
              rawDeviceId?: string | null;
              replacingDeviceId?: string | null;
            } | null;
          }
        | {
            __typename: 'PressureSensor';
            _id: string;
            deviceId?: string | null;
            name?: string | null;
            type?: EnumDKeyDeviceType | null;
            typeDisplayName: string;
            isConfigured?: boolean | null;
            installation?: {
              __typename?: 'DeviceInstallation';
              status: number;
              count?: number | null;
              message?: string | null;
              paired?: boolean | null;
              pairedTo?: string | null;
              previousStatus?: string | null;
              rawDeviceId?: string | null;
              replacingDeviceId?: string | null;
            } | null;
          }
        | {
            __typename: 'RelayDevice';
            _id: string;
            deviceId?: string | null;
            name?: string | null;
            type?: EnumDKeyDeviceType | null;
            typeDisplayName: string;
            isConfigured?: boolean | null;
            installation?: {
              __typename?: 'DeviceInstallation';
              status: number;
              count?: number | null;
              message?: string | null;
              paired?: boolean | null;
              pairedTo?: string | null;
              previousStatus?: string | null;
              rawDeviceId?: string | null;
              replacingDeviceId?: string | null;
            } | null;
          }
        | {
            __typename: 'SmartPowerOutlet';
            _id: string;
            deviceId?: string | null;
            name?: string | null;
            type?: EnumDKeyDeviceType | null;
            typeDisplayName: string;
            isConfigured?: boolean | null;
            installation?: {
              __typename?: 'DeviceInstallation';
              status: number;
              count?: number | null;
              message?: string | null;
              paired?: boolean | null;
              pairedTo?: string | null;
              previousStatus?: string | null;
              rawDeviceId?: string | null;
              replacingDeviceId?: string | null;
            } | null;
          }
        | {
            __typename: 'SolarManagementSystem';
            _id: string;
            deviceId?: string | null;
            name?: string | null;
            type?: EnumDKeyDeviceType | null;
            typeDisplayName: string;
            isConfigured?: boolean | null;
            installation?: {
              __typename?: 'DeviceInstallation';
              status: number;
              count?: number | null;
              message?: string | null;
              paired?: boolean | null;
              pairedTo?: string | null;
              previousStatus?: string | null;
              rawDeviceId?: string | null;
              replacingDeviceId?: string | null;
            } | null;
          }
        | {
            __typename: 'Thermistor';
            role?: string | null;
            _id: string;
            deviceId?: string | null;
            name?: string | null;
            type?: EnumDKeyDeviceType | null;
            typeDisplayName: string;
            isConfigured?: boolean | null;
            installation?: {
              __typename?: 'DeviceInstallation';
              status: number;
              count?: number | null;
              message?: string | null;
              paired?: boolean | null;
              pairedTo?: string | null;
              previousStatus?: string | null;
              rawDeviceId?: string | null;
              replacingDeviceId?: string | null;
            } | null;
          }
        | {
            __typename: 'Thermostat';
            _id: string;
            deviceId?: string | null;
            name?: string | null;
            type?: EnumDKeyDeviceType | null;
            typeDisplayName: string;
            isConfigured?: boolean | null;
            installation?: {
              __typename?: 'DeviceInstallation';
              status: number;
              count?: number | null;
              message?: string | null;
              paired?: boolean | null;
              pairedTo?: string | null;
              previousStatus?: string | null;
              rawDeviceId?: string | null;
              replacingDeviceId?: string | null;
            } | null;
          }
        | {
            __typename: 'VSDPump';
            role?: string | null;
            _id: string;
            deviceId?: string | null;
            name?: string | null;
            type?: EnumDKeyDeviceType | null;
            typeDisplayName: string;
            isConfigured?: boolean | null;
            installation?: {
              __typename?: 'DeviceInstallation';
              status: number;
              count?: number | null;
              message?: string | null;
              paired?: boolean | null;
              pairedTo?: string | null;
              previousStatus?: string | null;
              rawDeviceId?: string | null;
              replacingDeviceId?: string | null;
            } | null;
          }
        | {
            __typename: 'WindManagementSystem';
            _id: string;
            deviceId?: string | null;
            name?: string | null;
            type?: EnumDKeyDeviceType | null;
            typeDisplayName: string;
            isConfigured?: boolean | null;
            installation?: {
              __typename?: 'DeviceInstallation';
              status: number;
              count?: number | null;
              message?: string | null;
              paired?: boolean | null;
              pairedTo?: string | null;
              previousStatus?: string | null;
              rawDeviceId?: string | null;
              replacingDeviceId?: string | null;
            } | null;
          }
        | {
            __typename: 'WindowSensor';
            _id: string;
            deviceId?: string | null;
            name?: string | null;
            type?: EnumDKeyDeviceType | null;
            typeDisplayName: string;
            isConfigured?: boolean | null;
            installation?: {
              __typename?: 'DeviceInstallation';
              status: number;
              count?: number | null;
              message?: string | null;
              paired?: boolean | null;
              pairedTo?: string | null;
              previousStatus?: string | null;
              rawDeviceId?: string | null;
              replacingDeviceId?: string | null;
            } | null;
          }
        | {
            __typename: 'Z210Pump';
            _id: string;
            deviceId?: string | null;
            name?: string | null;
            type?: EnumDKeyDeviceType | null;
            typeDisplayName: string;
            isConfigured?: boolean | null;
            installation?: {
              __typename?: 'DeviceInstallation';
              status: number;
              count?: number | null;
              message?: string | null;
              paired?: boolean | null;
              pairedTo?: string | null;
              previousStatus?: string | null;
              rawDeviceId?: string | null;
              replacingDeviceId?: string | null;
            } | null;
          }
      >;
    } | null>;
    panels: Array<{
      __typename: 'Panel';
      _id: string;
      name?: string | null;
      type: EnumPanelType;
      role?: string | null;
      devices: Array<
        | {
            __typename: 'Actuator';
            _id: string;
            deviceId?: string | null;
            name?: string | null;
            type?: EnumDKeyDeviceType | null;
            typeDisplayName: string;
            isConfigured?: boolean | null;
            installation?: {
              __typename?: 'DeviceInstallation';
              status: number;
              count?: number | null;
              message?: string | null;
              paired?: boolean | null;
              pairedTo?: string | null;
              previousStatus?: string | null;
              rawDeviceId?: string | null;
              replacingDeviceId?: string | null;
            } | null;
          }
        | {
            __typename: 'BatteryManagementSystem';
            _id: string;
            deviceId?: string | null;
            name?: string | null;
            type?: EnumDKeyDeviceType | null;
            typeDisplayName: string;
            isConfigured?: boolean | null;
            installation?: {
              __typename?: 'DeviceInstallation';
              status: number;
              count?: number | null;
              message?: string | null;
              paired?: boolean | null;
              pairedTo?: string | null;
              previousStatus?: string | null;
              rawDeviceId?: string | null;
              replacingDeviceId?: string | null;
            } | null;
          }
        | {
            __typename: 'Boiler';
            _id: string;
            deviceId?: string | null;
            name?: string | null;
            type?: EnumDKeyDeviceType | null;
            typeDisplayName: string;
            isConfigured?: boolean | null;
            installation?: {
              __typename?: 'DeviceInstallation';
              status: number;
              count?: number | null;
              message?: string | null;
              paired?: boolean | null;
              pairedTo?: string | null;
              previousStatus?: string | null;
              rawDeviceId?: string | null;
              replacingDeviceId?: string | null;
            } | null;
          }
        | {
            __typename: 'Chiller';
            _id: string;
            deviceId?: string | null;
            name?: string | null;
            type?: EnumDKeyDeviceType | null;
            typeDisplayName: string;
            isConfigured?: boolean | null;
            installation?: {
              __typename?: 'DeviceInstallation';
              status: number;
              count?: number | null;
              message?: string | null;
              paired?: boolean | null;
              pairedTo?: string | null;
              previousStatus?: string | null;
              rawDeviceId?: string | null;
              replacingDeviceId?: string | null;
            } | null;
          }
        | {
            __typename: 'ConductorGenericSensor';
            _id: string;
            deviceId?: string | null;
            name?: string | null;
            type?: EnumDKeyDeviceType | null;
            typeDisplayName: string;
            isConfigured?: boolean | null;
            installation?: {
              __typename?: 'DeviceInstallation';
              status: number;
              count?: number | null;
              message?: string | null;
              paired?: boolean | null;
              pairedTo?: string | null;
              previousStatus?: string | null;
              rawDeviceId?: string | null;
              replacingDeviceId?: string | null;
            } | null;
          }
        | {
            __typename: 'Controller';
            _id: string;
            deviceId?: string | null;
            name?: string | null;
            type?: EnumDKeyDeviceType | null;
            typeDisplayName: string;
            isConfigured?: boolean | null;
            installation?: {
              __typename?: 'DeviceInstallation';
              status: number;
              count?: number | null;
              message?: string | null;
              paired?: boolean | null;
              pairedTo?: string | null;
              previousStatus?: string | null;
              rawDeviceId?: string | null;
              replacingDeviceId?: string | null;
            } | null;
          }
        | {
            __typename: 'Device';
            _id: string;
            deviceId?: string | null;
            name?: string | null;
            type?: EnumDKeyDeviceType | null;
            typeDisplayName: string;
            isConfigured?: boolean | null;
            installation?: {
              __typename?: 'DeviceInstallation';
              status: number;
              count?: number | null;
              message?: string | null;
              paired?: boolean | null;
              pairedTo?: string | null;
              previousStatus?: string | null;
              rawDeviceId?: string | null;
              replacingDeviceId?: string | null;
            } | null;
          }
        | {
            __typename: 'DoorSensor';
            _id: string;
            deviceId?: string | null;
            name?: string | null;
            type?: EnumDKeyDeviceType | null;
            typeDisplayName: string;
            isConfigured?: boolean | null;
            installation?: {
              __typename?: 'DeviceInstallation';
              status: number;
              count?: number | null;
              message?: string | null;
              paired?: boolean | null;
              pairedTo?: string | null;
              previousStatus?: string | null;
              rawDeviceId?: string | null;
              replacingDeviceId?: string | null;
            } | null;
          }
        | {
            __typename: 'EnergyController';
            _id: string;
            deviceId?: string | null;
            name?: string | null;
            type?: EnumDKeyDeviceType | null;
            typeDisplayName: string;
            isConfigured?: boolean | null;
            installation?: {
              __typename?: 'DeviceInstallation';
              status: number;
              count?: number | null;
              message?: string | null;
              paired?: boolean | null;
              pairedTo?: string | null;
              previousStatus?: string | null;
              rawDeviceId?: string | null;
              replacingDeviceId?: string | null;
            } | null;
          }
        | {
            __typename: 'EnergyConverter';
            _id: string;
            deviceId?: string | null;
            name?: string | null;
            type?: EnumDKeyDeviceType | null;
            typeDisplayName: string;
            isConfigured?: boolean | null;
            installation?: {
              __typename?: 'DeviceInstallation';
              status: number;
              count?: number | null;
              message?: string | null;
              paired?: boolean | null;
              pairedTo?: string | null;
              previousStatus?: string | null;
              rawDeviceId?: string | null;
              replacingDeviceId?: string | null;
            } | null;
          }
        | {
            __typename: 'EnergyInverter';
            _id: string;
            deviceId?: string | null;
            name?: string | null;
            type?: EnumDKeyDeviceType | null;
            typeDisplayName: string;
            isConfigured?: boolean | null;
            installation?: {
              __typename?: 'DeviceInstallation';
              status: number;
              count?: number | null;
              message?: string | null;
              paired?: boolean | null;
              pairedTo?: string | null;
              previousStatus?: string | null;
              rawDeviceId?: string | null;
              replacingDeviceId?: string | null;
            } | null;
          }
        | {
            __typename: 'EnergyMeter';
            _id: string;
            deviceId?: string | null;
            name?: string | null;
            type?: EnumDKeyDeviceType | null;
            typeDisplayName: string;
            isConfigured?: boolean | null;
            installation?: {
              __typename?: 'DeviceInstallation';
              status: number;
              count?: number | null;
              message?: string | null;
              paired?: boolean | null;
              pairedTo?: string | null;
              previousStatus?: string | null;
              rawDeviceId?: string | null;
              replacingDeviceId?: string | null;
            } | null;
          }
        | {
            __typename: 'EnergyRectifier';
            _id: string;
            deviceId?: string | null;
            name?: string | null;
            type?: EnumDKeyDeviceType | null;
            typeDisplayName: string;
            isConfigured?: boolean | null;
            installation?: {
              __typename?: 'DeviceInstallation';
              status: number;
              count?: number | null;
              message?: string | null;
              paired?: boolean | null;
              pairedTo?: string | null;
              previousStatus?: string | null;
              rawDeviceId?: string | null;
              replacingDeviceId?: string | null;
            } | null;
          }
        | {
            __typename: 'EnergyStorageCoolingSystem';
            _id: string;
            deviceId?: string | null;
            name?: string | null;
            type?: EnumDKeyDeviceType | null;
            typeDisplayName: string;
            isConfigured?: boolean | null;
            installation?: {
              __typename?: 'DeviceInstallation';
              status: number;
              count?: number | null;
              message?: string | null;
              paired?: boolean | null;
              pairedTo?: string | null;
              previousStatus?: string | null;
              rawDeviceId?: string | null;
              replacingDeviceId?: string | null;
            } | null;
          }
        | {
            __typename: 'EnergySwitchPanel';
            _id: string;
            deviceId?: string | null;
            name?: string | null;
            type?: EnumDKeyDeviceType | null;
            typeDisplayName: string;
            isConfigured?: boolean | null;
            installation?: {
              __typename?: 'DeviceInstallation';
              status: number;
              count?: number | null;
              message?: string | null;
              paired?: boolean | null;
              pairedTo?: string | null;
              previousStatus?: string | null;
              rawDeviceId?: string | null;
              replacingDeviceId?: string | null;
            } | null;
          }
        | {
            __typename: 'EnergySwitchPanelCircuit';
            _id: string;
            deviceId?: string | null;
            name?: string | null;
            type?: EnumDKeyDeviceType | null;
            typeDisplayName: string;
            isConfigured?: boolean | null;
            installation?: {
              __typename?: 'DeviceInstallation';
              status: number;
              count?: number | null;
              message?: string | null;
              paired?: boolean | null;
              pairedTo?: string | null;
              previousStatus?: string | null;
              rawDeviceId?: string | null;
              replacingDeviceId?: string | null;
            } | null;
          }
        | {
            __typename: 'FireSuppressionSystem';
            _id: string;
            deviceId?: string | null;
            name?: string | null;
            type?: EnumDKeyDeviceType | null;
            typeDisplayName: string;
            isConfigured?: boolean | null;
            installation?: {
              __typename?: 'DeviceInstallation';
              status: number;
              count?: number | null;
              message?: string | null;
              paired?: boolean | null;
              pairedTo?: string | null;
              previousStatus?: string | null;
              rawDeviceId?: string | null;
              replacingDeviceId?: string | null;
            } | null;
          }
        | {
            __typename: 'GPIO';
            _id: string;
            deviceId?: string | null;
            name?: string | null;
            type?: EnumDKeyDeviceType | null;
            typeDisplayName: string;
            isConfigured?: boolean | null;
            installation?: {
              __typename?: 'DeviceInstallation';
              status: number;
              count?: number | null;
              message?: string | null;
              paired?: boolean | null;
              pairedTo?: string | null;
              previousStatus?: string | null;
              rawDeviceId?: string | null;
              replacingDeviceId?: string | null;
            } | null;
          }
        | {
            __typename: 'IndoorAirHandler';
            _id: string;
            deviceId?: string | null;
            name?: string | null;
            type?: EnumDKeyDeviceType | null;
            typeDisplayName: string;
            isConfigured?: boolean | null;
            installation?: {
              __typename?: 'DeviceInstallation';
              status: number;
              count?: number | null;
              message?: string | null;
              paired?: boolean | null;
              pairedTo?: string | null;
              previousStatus?: string | null;
              rawDeviceId?: string | null;
              replacingDeviceId?: string | null;
            } | null;
          }
        | {
            __typename: 'IndoorSensor';
            _id: string;
            deviceId?: string | null;
            name?: string | null;
            type?: EnumDKeyDeviceType | null;
            typeDisplayName: string;
            isConfigured?: boolean | null;
            installation?: {
              __typename?: 'DeviceInstallation';
              status: number;
              count?: number | null;
              message?: string | null;
              paired?: boolean | null;
              pairedTo?: string | null;
              previousStatus?: string | null;
              rawDeviceId?: string | null;
              replacingDeviceId?: string | null;
            } | null;
          }
        | {
            __typename: 'KineticEnergyManagementSystem';
            _id: string;
            deviceId?: string | null;
            name?: string | null;
            type?: EnumDKeyDeviceType | null;
            typeDisplayName: string;
            isConfigured?: boolean | null;
            installation?: {
              __typename?: 'DeviceInstallation';
              status: number;
              count?: number | null;
              message?: string | null;
              paired?: boolean | null;
              pairedTo?: string | null;
              previousStatus?: string | null;
              rawDeviceId?: string | null;
              replacingDeviceId?: string | null;
            } | null;
          }
        | {
            __typename: 'LeakDetector';
            _id: string;
            deviceId?: string | null;
            name?: string | null;
            type?: EnumDKeyDeviceType | null;
            typeDisplayName: string;
            isConfigured?: boolean | null;
            installation?: {
              __typename?: 'DeviceInstallation';
              status: number;
              count?: number | null;
              message?: string | null;
              paired?: boolean | null;
              pairedTo?: string | null;
              previousStatus?: string | null;
              rawDeviceId?: string | null;
              replacingDeviceId?: string | null;
            } | null;
          }
        | {
            __typename: 'Loop';
            _id: string;
            deviceId?: string | null;
            name?: string | null;
            type?: EnumDKeyDeviceType | null;
            typeDisplayName: string;
            isConfigured?: boolean | null;
            installation?: {
              __typename?: 'DeviceInstallation';
              status: number;
              count?: number | null;
              message?: string | null;
              paired?: boolean | null;
              pairedTo?: string | null;
              previousStatus?: string | null;
              rawDeviceId?: string | null;
              replacingDeviceId?: string | null;
            } | null;
          }
        | {
            __typename: 'ModbusAirHandler';
            _id: string;
            deviceId?: string | null;
            name?: string | null;
            type?: EnumDKeyDeviceType | null;
            typeDisplayName: string;
            isConfigured?: boolean | null;
            installation?: {
              __typename?: 'DeviceInstallation';
              status: number;
              count?: number | null;
              message?: string | null;
              paired?: boolean | null;
              pairedTo?: string | null;
              previousStatus?: string | null;
              rawDeviceId?: string | null;
              replacingDeviceId?: string | null;
            } | null;
          }
        | {
            __typename: 'OccupancySensor';
            _id: string;
            deviceId?: string | null;
            name?: string | null;
            type?: EnumDKeyDeviceType | null;
            typeDisplayName: string;
            isConfigured?: boolean | null;
            installation?: {
              __typename?: 'DeviceInstallation';
              status: number;
              count?: number | null;
              message?: string | null;
              paired?: boolean | null;
              pairedTo?: string | null;
              previousStatus?: string | null;
              rawDeviceId?: string | null;
              replacingDeviceId?: string | null;
            } | null;
          }
        | {
            __typename: 'OpenWeather';
            _id: string;
            deviceId?: string | null;
            name?: string | null;
            type?: EnumDKeyDeviceType | null;
            typeDisplayName: string;
            isConfigured?: boolean | null;
            installation?: {
              __typename?: 'DeviceInstallation';
              status: number;
              count?: number | null;
              message?: string | null;
              paired?: boolean | null;
              pairedTo?: string | null;
              previousStatus?: string | null;
              rawDeviceId?: string | null;
              replacingDeviceId?: string | null;
            } | null;
          }
        | {
            __typename: 'OutdoorSensor';
            _id: string;
            deviceId?: string | null;
            name?: string | null;
            type?: EnumDKeyDeviceType | null;
            typeDisplayName: string;
            isConfigured?: boolean | null;
            installation?: {
              __typename?: 'DeviceInstallation';
              status: number;
              count?: number | null;
              message?: string | null;
              paired?: boolean | null;
              pairedTo?: string | null;
              previousStatus?: string | null;
              rawDeviceId?: string | null;
              replacingDeviceId?: string | null;
            } | null;
          }
        | {
            __typename: 'PowerMonitor';
            _id: string;
            deviceId?: string | null;
            name?: string | null;
            type?: EnumDKeyDeviceType | null;
            typeDisplayName: string;
            isConfigured?: boolean | null;
            installation?: {
              __typename?: 'DeviceInstallation';
              status: number;
              count?: number | null;
              message?: string | null;
              paired?: boolean | null;
              pairedTo?: string | null;
              previousStatus?: string | null;
              rawDeviceId?: string | null;
              replacingDeviceId?: string | null;
            } | null;
          }
        | {
            __typename: 'PressureSensor';
            _id: string;
            deviceId?: string | null;
            name?: string | null;
            type?: EnumDKeyDeviceType | null;
            typeDisplayName: string;
            isConfigured?: boolean | null;
            installation?: {
              __typename?: 'DeviceInstallation';
              status: number;
              count?: number | null;
              message?: string | null;
              paired?: boolean | null;
              pairedTo?: string | null;
              previousStatus?: string | null;
              rawDeviceId?: string | null;
              replacingDeviceId?: string | null;
            } | null;
          }
        | {
            __typename: 'RelayDevice';
            _id: string;
            deviceId?: string | null;
            name?: string | null;
            type?: EnumDKeyDeviceType | null;
            typeDisplayName: string;
            isConfigured?: boolean | null;
            installation?: {
              __typename?: 'DeviceInstallation';
              status: number;
              count?: number | null;
              message?: string | null;
              paired?: boolean | null;
              pairedTo?: string | null;
              previousStatus?: string | null;
              rawDeviceId?: string | null;
              replacingDeviceId?: string | null;
            } | null;
          }
        | {
            __typename: 'SmartPowerOutlet';
            _id: string;
            deviceId?: string | null;
            name?: string | null;
            type?: EnumDKeyDeviceType | null;
            typeDisplayName: string;
            isConfigured?: boolean | null;
            installation?: {
              __typename?: 'DeviceInstallation';
              status: number;
              count?: number | null;
              message?: string | null;
              paired?: boolean | null;
              pairedTo?: string | null;
              previousStatus?: string | null;
              rawDeviceId?: string | null;
              replacingDeviceId?: string | null;
            } | null;
          }
        | {
            __typename: 'SolarManagementSystem';
            _id: string;
            deviceId?: string | null;
            name?: string | null;
            type?: EnumDKeyDeviceType | null;
            typeDisplayName: string;
            isConfigured?: boolean | null;
            installation?: {
              __typename?: 'DeviceInstallation';
              status: number;
              count?: number | null;
              message?: string | null;
              paired?: boolean | null;
              pairedTo?: string | null;
              previousStatus?: string | null;
              rawDeviceId?: string | null;
              replacingDeviceId?: string | null;
            } | null;
          }
        | {
            __typename: 'Thermistor';
            role?: string | null;
            _id: string;
            deviceId?: string | null;
            name?: string | null;
            type?: EnumDKeyDeviceType | null;
            typeDisplayName: string;
            isConfigured?: boolean | null;
            installation?: {
              __typename?: 'DeviceInstallation';
              status: number;
              count?: number | null;
              message?: string | null;
              paired?: boolean | null;
              pairedTo?: string | null;
              previousStatus?: string | null;
              rawDeviceId?: string | null;
              replacingDeviceId?: string | null;
            } | null;
          }
        | {
            __typename: 'Thermostat';
            _id: string;
            deviceId?: string | null;
            name?: string | null;
            type?: EnumDKeyDeviceType | null;
            typeDisplayName: string;
            isConfigured?: boolean | null;
            installation?: {
              __typename?: 'DeviceInstallation';
              status: number;
              count?: number | null;
              message?: string | null;
              paired?: boolean | null;
              pairedTo?: string | null;
              previousStatus?: string | null;
              rawDeviceId?: string | null;
              replacingDeviceId?: string | null;
            } | null;
          }
        | {
            __typename: 'VSDPump';
            role?: string | null;
            _id: string;
            deviceId?: string | null;
            name?: string | null;
            type?: EnumDKeyDeviceType | null;
            typeDisplayName: string;
            isConfigured?: boolean | null;
            installation?: {
              __typename?: 'DeviceInstallation';
              status: number;
              count?: number | null;
              message?: string | null;
              paired?: boolean | null;
              pairedTo?: string | null;
              previousStatus?: string | null;
              rawDeviceId?: string | null;
              replacingDeviceId?: string | null;
            } | null;
          }
        | {
            __typename: 'WindManagementSystem';
            _id: string;
            deviceId?: string | null;
            name?: string | null;
            type?: EnumDKeyDeviceType | null;
            typeDisplayName: string;
            isConfigured?: boolean | null;
            installation?: {
              __typename?: 'DeviceInstallation';
              status: number;
              count?: number | null;
              message?: string | null;
              paired?: boolean | null;
              pairedTo?: string | null;
              previousStatus?: string | null;
              rawDeviceId?: string | null;
              replacingDeviceId?: string | null;
            } | null;
          }
        | {
            __typename: 'WindowSensor';
            _id: string;
            deviceId?: string | null;
            name?: string | null;
            type?: EnumDKeyDeviceType | null;
            typeDisplayName: string;
            isConfigured?: boolean | null;
            installation?: {
              __typename?: 'DeviceInstallation';
              status: number;
              count?: number | null;
              message?: string | null;
              paired?: boolean | null;
              pairedTo?: string | null;
              previousStatus?: string | null;
              rawDeviceId?: string | null;
              replacingDeviceId?: string | null;
            } | null;
          }
        | {
            __typename: 'Z210Pump';
            _id: string;
            deviceId?: string | null;
            name?: string | null;
            type?: EnumDKeyDeviceType | null;
            typeDisplayName: string;
            isConfigured?: boolean | null;
            installation?: {
              __typename?: 'DeviceInstallation';
              status: number;
              count?: number | null;
              message?: string | null;
              paired?: boolean | null;
              pairedTo?: string | null;
              previousStatus?: string | null;
              rawDeviceId?: string | null;
              replacingDeviceId?: string | null;
            } | null;
          }
      >;
    } | null>;
    setpointLimitProfile?: {
      __typename?: 'SetpointProfile';
      heat?: {
        __typename?: 'SetpointProfileHeat';
        max?: number | null;
        min?: number | null;
      } | null;
      cool?: {
        __typename?: 'SetpointProfileCool';
        max?: number | null;
        min?: number | null;
      } | null;
    } | null;
    property?: {
      __typename?: 'Property';
      _id: string;
      setpointProfileId?: string | null;
      setpointLimitProfile?: {
        __typename?: 'SetpointProfile';
        heat?: {
          __typename?: 'SetpointProfileHeat';
          min?: number | null;
          max?: number | null;
        } | null;
        cool?: {
          __typename?: 'SetpointProfileCool';
          min?: number | null;
          max?: number | null;
        } | null;
      } | null;
    } | null;
  } | null;
};

export type UnitInstallerListByPropertyIdQueryVariables = Exact<{
  propertyId?: InputMaybe<Scalars['String']>;
}>;

export type UnitInstallerListByPropertyIdQuery = {
  __typename?: 'Query';
  unitsByPropertyId: Array<{
    __typename?: 'Unit';
    _id: string;
    name: string;
    type: string;
    isConnected?: boolean | null;
    hasAlerts?: boolean | null;
    hasResident?: boolean | null;
    alertTypes?: {
      __typename?: 'UnitAlertTypes';
      sourceOffline?: boolean | null;
      deviceAlert?: boolean | null;
      deviceMetric?: boolean | null;
      deviceOffline?: boolean | null;
    } | null;
    devicesSummary?: {
      __typename?: 'UnitDevicesSummary';
      count?: number | null;
      majorAlerts?: number | null;
      minorAlerts?: number | null;
      proxy?: {
        __typename?: 'UnitDevicesSummaryProxy';
        coolSetpoint?: number | null;
        heatSetpoint?: number | null;
        humidity?: number | null;
        isOffline?: boolean | null;
        operatingMode?: string | null;
        operatingState?: string | null;
        setpointCoolMin?: number | null;
        setpointHeatMax?: number | null;
        setpointProfileName?: string | null;
        setpointProfileType?: string | null;
        temperature?: number | null;
        type?: string | null;
      } | null;
    } | null;
    devices: Array<
      | {
          __typename?: 'Actuator';
          installation?: {
            __typename?: 'DeviceInstallation';
            status: number;
          } | null;
        }
      | {
          __typename?: 'BatteryManagementSystem';
          installation?: {
            __typename?: 'DeviceInstallation';
            status: number;
          } | null;
        }
      | {
          __typename?: 'Boiler';
          installation?: {
            __typename?: 'DeviceInstallation';
            status: number;
          } | null;
        }
      | {
          __typename?: 'Chiller';
          installation?: {
            __typename?: 'DeviceInstallation';
            status: number;
          } | null;
        }
      | {
          __typename?: 'ConductorGenericSensor';
          installation?: {
            __typename?: 'DeviceInstallation';
            status: number;
          } | null;
        }
      | {
          __typename?: 'Controller';
          installation?: {
            __typename?: 'DeviceInstallation';
            status: number;
          } | null;
        }
      | {
          __typename?: 'Device';
          installation?: {
            __typename?: 'DeviceInstallation';
            status: number;
          } | null;
        }
      | {
          __typename?: 'DoorSensor';
          installation?: {
            __typename?: 'DeviceInstallation';
            status: number;
          } | null;
        }
      | {
          __typename?: 'EnergyController';
          installation?: {
            __typename?: 'DeviceInstallation';
            status: number;
          } | null;
        }
      | {
          __typename?: 'EnergyConverter';
          installation?: {
            __typename?: 'DeviceInstallation';
            status: number;
          } | null;
        }
      | {
          __typename?: 'EnergyInverter';
          installation?: {
            __typename?: 'DeviceInstallation';
            status: number;
          } | null;
        }
      | {
          __typename?: 'EnergyMeter';
          installation?: {
            __typename?: 'DeviceInstallation';
            status: number;
          } | null;
        }
      | {
          __typename?: 'EnergyRectifier';
          installation?: {
            __typename?: 'DeviceInstallation';
            status: number;
          } | null;
        }
      | {
          __typename?: 'EnergyStorageCoolingSystem';
          installation?: {
            __typename?: 'DeviceInstallation';
            status: number;
          } | null;
        }
      | {
          __typename?: 'EnergySwitchPanel';
          installation?: {
            __typename?: 'DeviceInstallation';
            status: number;
          } | null;
        }
      | {
          __typename?: 'EnergySwitchPanelCircuit';
          installation?: {
            __typename?: 'DeviceInstallation';
            status: number;
          } | null;
        }
      | {
          __typename?: 'FireSuppressionSystem';
          installation?: {
            __typename?: 'DeviceInstallation';
            status: number;
          } | null;
        }
      | {
          __typename?: 'GPIO';
          installation?: {
            __typename?: 'DeviceInstallation';
            status: number;
          } | null;
        }
      | {
          __typename?: 'IndoorAirHandler';
          installation?: {
            __typename?: 'DeviceInstallation';
            status: number;
          } | null;
        }
      | {
          __typename?: 'IndoorSensor';
          installation?: {
            __typename?: 'DeviceInstallation';
            status: number;
          } | null;
        }
      | {
          __typename?: 'KineticEnergyManagementSystem';
          installation?: {
            __typename?: 'DeviceInstallation';
            status: number;
          } | null;
        }
      | {
          __typename?: 'LeakDetector';
          installation?: {
            __typename?: 'DeviceInstallation';
            status: number;
          } | null;
        }
      | {
          __typename?: 'Loop';
          installation?: {
            __typename?: 'DeviceInstallation';
            status: number;
          } | null;
        }
      | {
          __typename?: 'ModbusAirHandler';
          installation?: {
            __typename?: 'DeviceInstallation';
            status: number;
          } | null;
        }
      | {
          __typename?: 'OccupancySensor';
          installation?: {
            __typename?: 'DeviceInstallation';
            status: number;
          } | null;
        }
      | {
          __typename?: 'OpenWeather';
          installation?: {
            __typename?: 'DeviceInstallation';
            status: number;
          } | null;
        }
      | {
          __typename?: 'OutdoorSensor';
          installation?: {
            __typename?: 'DeviceInstallation';
            status: number;
          } | null;
        }
      | {
          __typename?: 'PowerMonitor';
          installation?: {
            __typename?: 'DeviceInstallation';
            status: number;
          } | null;
        }
      | {
          __typename?: 'PressureSensor';
          installation?: {
            __typename?: 'DeviceInstallation';
            status: number;
          } | null;
        }
      | {
          __typename?: 'RelayDevice';
          installation?: {
            __typename?: 'DeviceInstallation';
            status: number;
          } | null;
        }
      | {
          __typename?: 'SmartPowerOutlet';
          installation?: {
            __typename?: 'DeviceInstallation';
            status: number;
          } | null;
        }
      | {
          __typename?: 'SolarManagementSystem';
          installation?: {
            __typename?: 'DeviceInstallation';
            status: number;
          } | null;
        }
      | {
          __typename?: 'Thermistor';
          installation?: {
            __typename?: 'DeviceInstallation';
            status: number;
          } | null;
        }
      | {
          __typename?: 'Thermostat';
          installation?: {
            __typename?: 'DeviceInstallation';
            status: number;
          } | null;
        }
      | {
          __typename?: 'VSDPump';
          installation?: {
            __typename?: 'DeviceInstallation';
            status: number;
          } | null;
        }
      | {
          __typename?: 'WindManagementSystem';
          installation?: {
            __typename?: 'DeviceInstallation';
            status: number;
          } | null;
        }
      | {
          __typename?: 'WindowSensor';
          installation?: {
            __typename?: 'DeviceInstallation';
            status: number;
          } | null;
        }
      | {
          __typename?: 'Z210Pump';
          installation?: {
            __typename?: 'DeviceInstallation';
            status: number;
          } | null;
        }
    >;
  }>;
};

export type OrganizationDetailEditSubSubscriptionVariables = Exact<{
  id: Scalars['String'];
}>;

export type OrganizationDetailEditSubSubscription = {
  __typename?: 'Subscription';
  organizationEventsByIds?: {
    __typename?: 'Organization';
    modelChangeOperation?: string | null;
    _id: string;
    name: string;
    description?: string | null;
    hqPhone?: string | null;
    hqEmail?: string | null;
    hqAddress: {
      __typename?: 'OrganizationHqAddress';
      line1: string;
      line2?: string | null;
      city: string;
      state: string;
      postalCode: string;
      country: string;
    };
    parentOrganization?: {
      __typename?: 'Organization';
      _id: string;
      name: string;
    } | null;
  } | null;
};

export type OrganizationDetailEditQueryVariables = Exact<{
  id: Scalars['String'];
}>;

export type OrganizationDetailEditQuery = {
  __typename?: 'Query';
  organizationById?: {
    __typename?: 'Organization';
    _id: string;
    name: string;
    description?: string | null;
    hqPhone?: string | null;
    hqEmail?: string | null;
    hqAddress: {
      __typename?: 'OrganizationHqAddress';
      line1: string;
      line2?: string | null;
      city: string;
      state: string;
      postalCode: string;
      country: string;
    };
    parentOrganization?: {
      __typename?: 'Organization';
      _id: string;
      name: string;
    } | null;
  } | null;
};

export type OrganizationsQueryVariables = Exact<{ [key: string]: never }>;

export type OrganizationsQuery = {
  __typename?: 'Query';
  organizations: Array<{
    __typename?: 'Organization';
    _id: string;
    name: string;
  }>;
};

export type CreateOrganizationMutationVariables = Exact<{
  organization: CreateOneOrganizationInput;
}>;

export type CreateOrganizationMutation = {
  __typename?: 'Mutation';
  createOrganization?: {
    __typename?: 'Organization';
    _id: string;
    name: string;
    description?: string | null;
    hqPhone?: string | null;
    hqEmail?: string | null;
    hqAddress: {
      __typename?: 'OrganizationHqAddress';
      line1: string;
      line2?: string | null;
      city: string;
      state: string;
      postalCode: string;
      country: string;
    };
    parentOrganization?: {
      __typename?: 'Organization';
      _id: string;
      name: string;
    } | null;
  } | null;
};

export type UpdateOrganizationMutationVariables = Exact<{
  id: Scalars['String'];
  organization: UpdateOneOrganizationInput;
}>;

export type UpdateOrganizationMutation = {
  __typename?: 'Mutation';
  updateOrganization?: {
    __typename?: 'Organization';
    _id: string;
    name: string;
    description?: string | null;
    hqPhone?: string | null;
    hqEmail?: string | null;
    hqAddress: {
      __typename?: 'OrganizationHqAddress';
      line1: string;
      line2?: string | null;
      city: string;
      state: string;
      postalCode: string;
      country: string;
    };
    parentOrganization?: {
      __typename?: 'Organization';
      _id: string;
      name: string;
    } | null;
  } | null;
};

export type RemoveOrganizationMutationVariables = Exact<{
  id: Scalars['String'];
}>;

export type RemoveOrganizationMutation = {
  __typename?: 'Mutation';
  deleteOrganization: boolean;
};

export type OrganizationParentOptionsQueryVariables = Exact<{
  excludeId?: InputMaybe<Scalars['String']>;
}>;

export type OrganizationParentOptionsQuery = {
  __typename?: 'Query';
  organizations: Array<{
    __typename?: 'Organization';
    _id: string;
    name: string;
  }>;
};

export type PlmContractDetailEditSubSubscriptionVariables = Exact<{
  id: Scalars['String'];
}>;

export type PlmContractDetailEditSubSubscription = {
  __typename?: 'Subscription';
  plmContractEventsByIds?: {
    __typename?: 'PlmContract';
    modelChangeOperation?: string | null;
    _id: string;
    name: string;
    contractId: string;
    programId: string;
    propertyIds?: Array<string | null> | null;
    scopeType: EnumPlmContractScopeType;
    meterIds?: Array<string | null> | null;
    partnerId: string;
    dispatcherIds?: Array<string | null> | null;
    minimumReductionKW: number;
    maximumEventsPerSeason: number;
    baselineMethod: EnumPlmContractBaselineMethod;
    incentiveDescription?: string | null;
    penaltyForNonCompliance?: number | null;
    status: EnumPlmContractStatus;
    notificationEmail: string;
    program?: {
      __typename?: 'PlmProgram';
      _id: string;
      name: string;
      partner?: { __typename?: 'PlmPartner'; _id: string; name: string } | null;
    } | null;
    properties: Array<{
      __typename?: 'Property';
      _id: string;
      title: string;
    } | null>;
    partner?: { __typename?: 'PlmPartner'; _id: string; name: string } | null;
    dispatchers: Array<{
      __typename?: 'User';
      _id: string;
      name: string;
    } | null>;
  } | null;
};

export type PlmContractDetailEditQueryVariables = Exact<{
  id: Scalars['String'];
}>;

export type PlmContractDetailEditQuery = {
  __typename?: 'Query';
  plmContractById?: {
    __typename?: 'PlmContract';
    _id: string;
    name: string;
    contractId: string;
    programId: string;
    propertyIds?: Array<string | null> | null;
    scopeType: EnumPlmContractScopeType;
    meterIds?: Array<string | null> | null;
    partnerId: string;
    dispatcherIds?: Array<string | null> | null;
    minimumReductionKW: number;
    maximumEventsPerSeason: number;
    baselineMethod: EnumPlmContractBaselineMethod;
    incentiveDescription?: string | null;
    penaltyForNonCompliance?: number | null;
    status: EnumPlmContractStatus;
    notificationEmail: string;
    program?: {
      __typename?: 'PlmProgram';
      _id: string;
      name: string;
      partner?: { __typename?: 'PlmPartner'; _id: string; name: string } | null;
    } | null;
    properties: Array<{
      __typename?: 'Property';
      _id: string;
      title: string;
    } | null>;
    partner?: { __typename?: 'PlmPartner'; _id: string; name: string } | null;
    dispatchers: Array<{
      __typename?: 'User';
      _id: string;
      name: string;
    } | null>;
  } | null;
};

export type PlmContractListSubSubscriptionVariables = Exact<{
  [key: string]: never;
}>;

export type PlmContractListSubSubscription = {
  __typename?: 'Subscription';
  plmContractEvents?: {
    __typename?: 'PlmContract';
    modelChangeOperation?: string | null;
    _id: string;
    name: string;
    contractId: string;
    programId: string;
    propertyIds?: Array<string | null> | null;
    scopeType: EnumPlmContractScopeType;
    meterIds?: Array<string | null> | null;
    minimumReductionKW: number;
    maximumEventsPerSeason: number;
    baselineMethod: EnumPlmContractBaselineMethod;
    incentiveDescription?: string | null;
    penaltyForNonCompliance?: number | null;
    status: EnumPlmContractStatus;
    notificationEmail: string;
    program?: {
      __typename?: 'PlmProgram';
      _id: string;
      name: string;
      partner?: { __typename?: 'PlmPartner'; _id: string; name: string } | null;
    } | null;
    properties: Array<{
      __typename?: 'Property';
      _id: string;
      title: string;
    } | null>;
  } | null;
};

export type PlmContractsQueryVariables = Exact<{ [key: string]: never }>;

export type PlmContractsQuery = {
  __typename?: 'Query';
  plmContracts: Array<{
    __typename?: 'PlmContract';
    _id: string;
    name: string;
    contractId: string;
    programId: string;
    propertyIds?: Array<string | null> | null;
    scopeType: EnumPlmContractScopeType;
    meterIds?: Array<string | null> | null;
    minimumReductionKW: number;
    maximumEventsPerSeason: number;
    baselineMethod: EnumPlmContractBaselineMethod;
    incentiveDescription?: string | null;
    penaltyForNonCompliance?: number | null;
    status: EnumPlmContractStatus;
    notificationEmail: string;
    program?: {
      __typename?: 'PlmProgram';
      _id: string;
      name: string;
      partner?: { __typename?: 'PlmPartner'; _id: string; name: string } | null;
    } | null;
    properties: Array<{
      __typename?: 'Property';
      _id: string;
      title: string;
    } | null>;
  }>;
};

export type CreatePlmContractMutationVariables = Exact<{
  plmContract: CreateOnePlmContractInput;
}>;

export type CreatePlmContractMutation = {
  __typename?: 'Mutation';
  createPlmContract?: {
    __typename?: 'PlmContract';
    _id: string;
    name: string;
    contractId: string;
    programId: string;
    propertyIds?: Array<string | null> | null;
    scopeType: EnumPlmContractScopeType;
    meterIds?: Array<string | null> | null;
    partnerId: string;
    dispatcherIds?: Array<string | null> | null;
    minimumReductionKW: number;
    maximumEventsPerSeason: number;
    baselineMethod: EnumPlmContractBaselineMethod;
    incentiveDescription?: string | null;
    penaltyForNonCompliance?: number | null;
    status: EnumPlmContractStatus;
    notificationEmail: string;
    program?: {
      __typename?: 'PlmProgram';
      _id: string;
      name: string;
      partner?: { __typename?: 'PlmPartner'; _id: string; name: string } | null;
    } | null;
    properties: Array<{
      __typename?: 'Property';
      _id: string;
      title: string;
    } | null>;
    partner?: { __typename?: 'PlmPartner'; _id: string; name: string } | null;
    dispatchers: Array<{
      __typename?: 'User';
      _id: string;
      name: string;
    } | null>;
  } | null;
};

export type UpdatePlmContractMutationVariables = Exact<{
  id: Scalars['String'];
  plmContract: UpdateOnePlmContractInput;
}>;

export type UpdatePlmContractMutation = {
  __typename?: 'Mutation';
  updatePlmContract?: {
    __typename?: 'PlmContract';
    _id: string;
    name: string;
    contractId: string;
    programId: string;
    propertyIds?: Array<string | null> | null;
    scopeType: EnumPlmContractScopeType;
    meterIds?: Array<string | null> | null;
    partnerId: string;
    dispatcherIds?: Array<string | null> | null;
    minimumReductionKW: number;
    maximumEventsPerSeason: number;
    baselineMethod: EnumPlmContractBaselineMethod;
    incentiveDescription?: string | null;
    penaltyForNonCompliance?: number | null;
    status: EnumPlmContractStatus;
    notificationEmail: string;
    program?: {
      __typename?: 'PlmProgram';
      _id: string;
      name: string;
      partner?: { __typename?: 'PlmPartner'; _id: string; name: string } | null;
    } | null;
    properties: Array<{
      __typename?: 'Property';
      _id: string;
      title: string;
    } | null>;
    partner?: { __typename?: 'PlmPartner'; _id: string; name: string } | null;
    dispatchers: Array<{
      __typename?: 'User';
      _id: string;
      name: string;
    } | null>;
  } | null;
};

export type RemovePlmContractMutationVariables = Exact<{
  id: Scalars['String'];
}>;

export type RemovePlmContractMutation = {
  __typename?: 'Mutation';
  deletePlmContract: boolean;
};

export type PlmContractOptionsQueryVariables = Exact<{ [key: string]: never }>;

export type PlmContractOptionsQuery = {
  __typename?: 'Query';
  plmContracts: Array<{
    __typename?: 'PlmContract';
    _id: string;
    name: string;
  }>;
};

export type PlmContractUpdateSubscriptionVariables = Exact<{
  _id?: InputMaybe<Scalars['String']>;
}>;

export type PlmContractUpdateSubscription = {
  __typename?: 'Subscription';
  plmContractEventsByIds?: {
    __typename?: 'PlmContract';
    modelChangeOperation?: string | null;
    _id: string;
    contractId: string;
    programId: string;
    propertyIds?: Array<string | null> | null;
    scopeType: EnumPlmContractScopeType;
    meterIds?: Array<string | null> | null;
    partnerId: string;
    dispatcherIds?: Array<string | null> | null;
    minimumReductionKW: number;
    maximumEventsPerSeason: number;
    baselineMethod: EnumPlmContractBaselineMethod;
    incentiveDescription?: string | null;
    penaltyForNonCompliance?: number | null;
    status: EnumPlmContractStatus;
    notificationEmail: string;
    properties: Array<{
      __typename?: 'Property';
      _id: string;
      title: string;
    } | null>;
    partner?: { __typename?: 'PlmPartner'; _id: string; name: string } | null;
    dispatchers: Array<{
      __typename?: 'User';
      _id: string;
      name: string;
    } | null>;
  } | null;
};

export type PlmContractUserOptionsQueryVariables = Exact<{
  [key: string]: never;
}>;

export type PlmContractUserOptionsQuery = {
  __typename?: 'Query';
  users: Array<{
    __typename?: 'User';
    _id: string;
    name: string;
    email?: string | null;
    authorizationProfile?: {
      __typename?: 'AuthorizationProfile';
      _id: string;
      isSuper?: boolean | null;
      managerProperties: Array<string | null>;
      installerProperties?: Array<string | null> | null;
      viewerProperties?: Array<string | null> | null;
      residentProperty?: string | null;
    } | null;
  }>;
};

export type PlmContractQueryVariables = Exact<{
  _id?: InputMaybe<Scalars['String']>;
}>;

export type PlmContractQuery = {
  __typename?: 'Query';
  plmContract?: {
    __typename?: 'PlmContract';
    _id: string;
    contractId: string;
    programId: string;
    propertyIds?: Array<string | null> | null;
    partnerId: string;
    dispatcherIds?: Array<string | null> | null;
    minimumReductionKW: number;
    maximumEventsPerSeason: number;
    baselineMethod: EnumPlmContractBaselineMethod;
    incentiveDescription?: string | null;
    penaltyForNonCompliance?: number | null;
    status: EnumPlmContractStatus;
    notificationEmail: string;
    properties: Array<{
      __typename?: 'Property';
      _id: string;
      title: string;
    } | null>;
    partner?: { __typename?: 'PlmPartner'; _id: string; name: string } | null;
    dispatchers: Array<{
      __typename?: 'User';
      _id: string;
      name: string;
    } | null>;
  } | null;
};

export type PlmCurtailmentActionDetailQueryVariables = Exact<{
  _id: Scalars['String'];
}>;

export type PlmCurtailmentActionDetailQuery = {
  __typename?: 'Query';
  plmCurtailmentActionById?: {
    __typename?: 'PlmCurtailmentAction';
    _id: string;
    name: string;
    description: string;
    deviceType: EnumPlmCurtailmentActionDeviceType;
    estimatedReductionKW: number;
    targetDevices?: any | null;
    plmCurtailmentPlanId: string;
    startTimeOffset?: number | null;
    autoBatch?: boolean | null;
    batchCount?: number | null;
    batchDuration?: number | null;
    batchStartTimeOffset?: number | null;
    targetedAdjustments?: Array<
      | {
          __typename?: 'ModbusAirHandlerAdjustment';
          freshAirSetpoint?: number | null;
          rhSetpoint?: number | null;
          ventilationMode?: string | null;
          type: string;
        }
      | {
          __typename?: 'SmartPowerOutletAdjustment';
          isOn?: boolean | null;
          type: string;
        }
      | {
          __typename?: 'ThermostatAdjustment';
          maxCoolSetpointLimit?: number | null;
          maxHeatSetpointLimit?: number | null;
          minCoolSetpointLimit?: number | null;
          minHeatSetpointLimit?: number | null;
          coolSetpoint?: number | null;
          coolSetpointAdjustmentMode?: string | null;
          heatSetpoint?: number | null;
          heatSetpointAdjustmentMode?: string | null;
          fanMode?: string | null;
          fanSpeed?: string | null;
          keypadLockoutLevel?: string | null;
          operatingMode?: string | null;
          type: string;
        }
      | null
    > | null;
  } | null;
};

export type CreatePlmCurtailmentActionMutationVariables = Exact<{
  action: PlmCurtailmentActionCreateInput;
}>;

export type CreatePlmCurtailmentActionMutation = {
  __typename?: 'Mutation';
  createPlmCurtailmentAction?: {
    __typename?: 'PlmCurtailmentAction';
    _id: string;
    name: string;
    description: string;
    deviceType: EnumPlmCurtailmentActionDeviceType;
    estimatedReductionKW: number;
    targetDevices?: any | null;
    plmCurtailmentPlanId: string;
    startTimeOffset?: number | null;
    autoBatch?: boolean | null;
    batchCount?: number | null;
    batchDuration?: number | null;
    batchStartTimeOffset?: number | null;
    targetedAdjustments?: Array<
      | { __typename?: 'ModbusAirHandlerAdjustment'; type: string }
      | { __typename?: 'SmartPowerOutletAdjustment'; type: string }
      | {
          __typename?: 'ThermostatAdjustment';
          coolSetpointAdjustmentMode?: string | null;
          heatSetpointAdjustmentMode?: string | null;
          type: string;
        }
      | null
    > | null;
  } | null;
};

export type UpdatePlmCurtailmentActionMutationVariables = Exact<{
  _id: Scalars['String'];
  action: PlmCurtailmentActionUpdateInput;
}>;

export type UpdatePlmCurtailmentActionMutation = {
  __typename?: 'Mutation';
  updatePlmCurtailmentAction?: {
    __typename?: 'PlmCurtailmentAction';
    _id: string;
    name: string;
    description: string;
    deviceType: EnumPlmCurtailmentActionDeviceType;
    estimatedReductionKW: number;
    targetDevices?: any | null;
    plmCurtailmentPlanId: string;
    startTimeOffset?: number | null;
    autoBatch?: boolean | null;
    batchCount?: number | null;
    batchDuration?: number | null;
    batchStartTimeOffset?: number | null;
    targetedAdjustments?: Array<
      | { __typename?: 'ModbusAirHandlerAdjustment'; type: string }
      | { __typename?: 'SmartPowerOutletAdjustment'; type: string }
      | {
          __typename?: 'ThermostatAdjustment';
          coolSetpointAdjustmentMode?: string | null;
          heatSetpointAdjustmentMode?: string | null;
          type: string;
        }
      | null
    > | null;
  } | null;
};

export type RemovePlmCurtailmentActionMutationVariables = Exact<{
  _id: Scalars['String'];
}>;

export type RemovePlmCurtailmentActionMutation = {
  __typename?: 'Mutation';
  removePlmCurtailmentAction: boolean;
};

export type PlmCurtailmentPlanEventsByIdsSubscriptionVariables = Exact<{
  _ids: Array<Scalars['String']> | Scalars['String'];
}>;

export type PlmCurtailmentPlanEventsByIdsSubscription = {
  __typename?: 'Subscription';
  plmCurtailmentPlanEventsByIds?: {
    __typename?: 'PlmCurtailmentPlan';
    modelChangeOperation?: string | null;
    _id: string;
    name: string;
    description: string;
    curtailmentActions: Array<{
      __typename?: 'PlmCurtailmentAction';
      _id: string;
      name: string;
      description: string;
      deviceType: EnumPlmCurtailmentActionDeviceType;
      targetDevices?: any | null;
      estimatedReductionKW: number;
      plmCurtailmentPlanId: string;
      targetedAdjustments?: Array<
        | {
            __typename?: 'ModbusAirHandlerAdjustment';
            freshAirSetpoint?: number | null;
            rhSetpoint?: number | null;
            ventilationMode?: string | null;
            type: string;
          }
        | {
            __typename?: 'SmartPowerOutletAdjustment';
            isOn?: boolean | null;
            type: string;
          }
        | {
            __typename?: 'ThermostatAdjustment';
            maxCoolSetpointLimit?: number | null;
            maxHeatSetpointLimit?: number | null;
            minCoolSetpointLimit?: number | null;
            minHeatSetpointLimit?: number | null;
            coolSetpoint?: number | null;
            coolSetpointAdjustmentMode?: string | null;
            heatSetpoint?: number | null;
            heatSetpointAdjustmentMode?: string | null;
            fanMode?: string | null;
            fanSpeed?: string | null;
            keypadLockoutLevel?: string | null;
            operatingMode?: string | null;
            type: string;
          }
        | null
      > | null;
    } | null>;
  } | null;
};

export type PlmCurtailmentPlanDetailQueryVariables = Exact<{
  _id: Scalars['String'];
}>;

export type PlmCurtailmentPlanDetailQuery = {
  __typename?: 'Query';
  plmCurtailmentPlanById?: {
    __typename?: 'PlmCurtailmentPlan';
    _id: string;
    name: string;
    description: string;
    estimatedReductionKW: number;
    durationMinutes: number;
    applicableSeasons: Array<EnumPlmCurtailmentPlanApplicableSeasons | null>;
    organizationId: string;
    organization?: {
      __typename?: 'Organization';
      _id: string;
      name: string;
    } | null;
    curtailmentActions: Array<{
      __typename?: 'PlmCurtailmentAction';
      _id: string;
      name: string;
      description: string;
      deviceType: EnumPlmCurtailmentActionDeviceType;
      targetDevices?: any | null;
      estimatedReductionKW: number;
      plmCurtailmentPlanId: string;
      targetedAdjustments?: Array<
        | {
            __typename?: 'ModbusAirHandlerAdjustment';
            freshAirSetpoint?: number | null;
            rhSetpoint?: number | null;
            ventilationMode?: string | null;
            type: string;
          }
        | {
            __typename?: 'SmartPowerOutletAdjustment';
            isOn?: boolean | null;
            type: string;
          }
        | {
            __typename?: 'ThermostatAdjustment';
            maxCoolSetpointLimit?: number | null;
            maxHeatSetpointLimit?: number | null;
            minCoolSetpointLimit?: number | null;
            minHeatSetpointLimit?: number | null;
            coolSetpoint?: number | null;
            coolSetpointAdjustmentMode?: string | null;
            heatSetpoint?: number | null;
            heatSetpointAdjustmentMode?: string | null;
            fanMode?: string | null;
            fanSpeed?: string | null;
            keypadLockoutLevel?: string | null;
            operatingMode?: string | null;
            type: string;
          }
        | null
      > | null;
    } | null>;
  } | null;
};

export type PlmCurtailmentPlanListUpdateSubscriptionVariables = Exact<{
  [key: string]: never;
}>;

export type PlmCurtailmentPlanListUpdateSubscription = {
  __typename?: 'Subscription';
  plmCurtailmentPlanEvents?: {
    __typename?: 'PlmCurtailmentPlan';
    modelChangeOperation?: string | null;
    _id: string;
    name: string;
    description: string;
    estimatedReductionKW: number;
    durationMinutes: number;
    applicableSeasons: Array<EnumPlmCurtailmentPlanApplicableSeasons | null>;
    organizationId: string;
    organization?: {
      __typename?: 'Organization';
      _id: string;
      name: string;
    } | null;
    curtailmentActions: Array<{
      __typename?: 'PlmCurtailmentAction';
      modelChangeOperation?: string | null;
      _id: string;
      name: string;
      description: string;
      deviceType: EnumPlmCurtailmentActionDeviceType;
      estimatedReductionKW: number;
      targetDevices?: any | null;
      plmCurtailmentPlanId: string;
      targetedAdjustments?: Array<
        | {
            __typename?: 'ModbusAirHandlerAdjustment';
            freshAirSetpoint?: number | null;
            rhSetpoint?: number | null;
            ventilationMode?: string | null;
            type: string;
          }
        | {
            __typename?: 'SmartPowerOutletAdjustment';
            isOn?: boolean | null;
            type: string;
          }
        | {
            __typename?: 'ThermostatAdjustment';
            maxCoolSetpointLimit?: number | null;
            maxHeatSetpointLimit?: number | null;
            minCoolSetpointLimit?: number | null;
            minHeatSetpointLimit?: number | null;
            coolSetpoint?: number | null;
            coolSetpointAdjustmentMode?: string | null;
            heatSetpoint?: number | null;
            heatSetpointAdjustmentMode?: string | null;
            fanMode?: string | null;
            fanSpeed?: string | null;
            keypadLockoutLevel?: string | null;
            operatingMode?: string | null;
            type: string;
          }
        | null
      > | null;
    } | null>;
  } | null;
};

export type PlmCurtailmentPlanListQueryVariables = Exact<{
  [key: string]: never;
}>;

export type PlmCurtailmentPlanListQuery = {
  __typename?: 'Query';
  plmCurtailmentPlans: Array<{
    __typename?: 'PlmCurtailmentPlan';
    _id: string;
    name: string;
    description: string;
    estimatedReductionKW: number;
    durationMinutes: number;
    applicableSeasons: Array<EnumPlmCurtailmentPlanApplicableSeasons | null>;
    organizationId: string;
    organization?: {
      __typename?: 'Organization';
      _id: string;
      name: string;
    } | null;
    curtailmentActions: Array<{
      __typename?: 'PlmCurtailmentAction';
      _id: string;
      name: string;
      description: string;
      deviceType: EnumPlmCurtailmentActionDeviceType;
      estimatedReductionKW: number;
      targetDevices?: any | null;
      plmCurtailmentPlanId: string;
      targetedAdjustments?: Array<
        | {
            __typename?: 'ModbusAirHandlerAdjustment';
            freshAirSetpoint?: number | null;
            rhSetpoint?: number | null;
            ventilationMode?: string | null;
            type: string;
          }
        | {
            __typename?: 'SmartPowerOutletAdjustment';
            isOn?: boolean | null;
            type: string;
          }
        | {
            __typename?: 'ThermostatAdjustment';
            maxCoolSetpointLimit?: number | null;
            maxHeatSetpointLimit?: number | null;
            minCoolSetpointLimit?: number | null;
            minHeatSetpointLimit?: number | null;
            coolSetpoint?: number | null;
            coolSetpointAdjustmentMode?: string | null;
            heatSetpoint?: number | null;
            heatSetpointAdjustmentMode?: string | null;
            fanMode?: string | null;
            fanSpeed?: string | null;
            keypadLockoutLevel?: string | null;
            operatingMode?: string | null;
            type: string;
          }
        | null
      > | null;
    } | null>;
  }>;
};

export type CreatePlmCurtailmentPlanMutationVariables = Exact<{
  plan: CreateOnePlmCurtailmentPlanInput;
}>;

export type CreatePlmCurtailmentPlanMutation = {
  __typename?: 'Mutation';
  createPlmCurtailmentPlan?: {
    __typename?: 'PlmCurtailmentPlan';
    _id: string;
    name: string;
    description: string;
    estimatedReductionKW: number;
    durationMinutes: number;
    applicableSeasons: Array<EnumPlmCurtailmentPlanApplicableSeasons | null>;
    organizationId: string;
    organization?: {
      __typename?: 'Organization';
      _id: string;
      name: string;
    } | null;
  } | null;
};

export type UpdatePlmCurtailmentPlanMutationVariables = Exact<{
  _id: Scalars['String'];
  plan: UpdateOnePlmCurtailmentPlanInput;
}>;

export type UpdatePlmCurtailmentPlanMutation = {
  __typename?: 'Mutation';
  updatePlmCurtailmentPlan?: {
    __typename?: 'PlmCurtailmentPlan';
    _id: string;
    name: string;
    description: string;
    estimatedReductionKW: number;
    durationMinutes: number;
    applicableSeasons: Array<EnumPlmCurtailmentPlanApplicableSeasons | null>;
    organizationId: string;
    organization?: {
      __typename?: 'Organization';
      _id: string;
      name: string;
    } | null;
  } | null;
};

export type RemovePlmCurtailmentPlanMutationVariables = Exact<{
  _id: Scalars['String'];
}>;

export type RemovePlmCurtailmentPlanMutation = {
  __typename?: 'Mutation';
  removePlmCurtailmentPlan: boolean;
};

export type AbortPlmCurtailmentTaskMutationVariables = Exact<{
  deviceId: Scalars['String'];
  cancelAll?: InputMaybe<Scalars['Boolean']>;
}>;

export type AbortPlmCurtailmentTaskMutation = {
  __typename?: 'Mutation';
  abortPlmCurtailmentTask: boolean;
};

export type GetPlmCurtailmentTasksForDeviceQueryVariables = Exact<{
  deviceId: Scalars['String'];
}>;

export type GetPlmCurtailmentTasksForDeviceQuery = {
  __typename?: 'Query';
  plmCurtailmentTasksForDevice?: Array<{
    __typename?: 'PlmCurtailmentTask';
    _id: string;
    plmCurtailmentActionId: string;
    plmEventResponseId: string;
    batchId: number;
    propertyId: string;
    unitId: string;
    deviceId: string;
    deviceType: string;
    scheduledStart: number;
    scheduledEnd: number;
    startedAt?: number | null;
    verifiedAt?: number | null;
    verifyAttempts?: number | null;
    endedAt?: number | null;
    status: EnumPlmCurtailmentTaskStatus;
    statusMessage?: string | null;
    estimatedReductionKW?: number | null;
  } | null> | null;
};

export type GetPlmCurtailmentTasksByResponseIdSubSubscriptionVariables = Exact<{
  plmEventResponseId: Scalars['String'];
}>;

export type GetPlmCurtailmentTasksByResponseIdSubSubscription = {
  __typename?: 'Subscription';
  plmCurtailmentTasksByResponseIdEvents?: {
    __typename?: 'PlmCurtailmentTask';
    modelChangeOperation?: string | null;
    _id: string;
    plmCurtailmentActionId: string;
    plmEventResponseId: string;
    batchId: number;
    propertyId: string;
    unitId: string;
    deviceId: string;
    deviceType: string;
    scheduledStart: number;
    scheduledEnd: number;
    startedAt?: number | null;
    verifiedAt?: number | null;
    verifyAttempts?: number | null;
    endedAt?: number | null;
    status: EnumPlmCurtailmentTaskStatus;
    statusMessage?: string | null;
    estimatedReductionKW?: number | null;
    device?: {
      __typename?: 'Device';
      _id: string;
      name?: string | null;
      deviceId?: string | null;
      typeDisplayName: string;
      unit?: { __typename?: 'Unit'; _id: string; name: string } | null;
    } | null;
    cachedDeviceState: {
      __typename?: 'PlmCurtailmentTaskCachedDeviceState';
      type: EnumPlmCurtailmentTaskCachedDeviceStateType;
      coolSetpoint?: number | null;
      heatSetpoint?: number | null;
      isOn?: boolean | null;
      operatingMode?: string | null;
      fanMode?: string | null;
    };
    targetedAdjustments: {
      __typename?: 'PlmCurtailmentTaskCachedDeviceState';
      type: EnumPlmCurtailmentTaskCachedDeviceStateType;
      coolSetpoint?: number | null;
      heatSetpoint?: number | null;
      isOn?: boolean | null;
      operatingMode?: string | null;
      fanMode?: string | null;
    };
  } | null;
};

export type GetPlmCurtailmentTasksByResponseIdQueryVariables = Exact<{
  plmEventResponseId: Scalars['String'];
}>;

export type GetPlmCurtailmentTasksByResponseIdQuery = {
  __typename?: 'Query';
  plmCurtailmentTasksByResponseId: Array<{
    __typename?: 'PlmCurtailmentTask';
    _id: string;
    plmCurtailmentActionId: string;
    plmEventResponseId: string;
    batchId: number;
    propertyId: string;
    unitId: string;
    deviceId: string;
    deviceType: string;
    scheduledStart: number;
    scheduledEnd: number;
    startedAt?: number | null;
    verifiedAt?: number | null;
    verifyAttempts?: number | null;
    endedAt?: number | null;
    status: EnumPlmCurtailmentTaskStatus;
    statusMessage?: string | null;
    estimatedReductionKW?: number | null;
    device?: {
      __typename?: 'Device';
      _id: string;
      name?: string | null;
      deviceId?: string | null;
      typeDisplayName: string;
      unit?: { __typename?: 'Unit'; _id: string; name: string } | null;
    } | null;
    cachedDeviceState: {
      __typename?: 'PlmCurtailmentTaskCachedDeviceState';
      type: EnumPlmCurtailmentTaskCachedDeviceStateType;
      coolSetpoint?: number | null;
      heatSetpoint?: number | null;
      isOn?: boolean | null;
      operatingMode?: string | null;
      fanMode?: string | null;
    };
    targetedAdjustments: {
      __typename?: 'PlmCurtailmentTaskCachedDeviceState';
      type: EnumPlmCurtailmentTaskCachedDeviceStateType;
      coolSetpoint?: number | null;
      heatSetpoint?: number | null;
      isOn?: boolean | null;
      operatingMode?: string | null;
      fanMode?: string | null;
    };
  }>;
};

export type PlmCurtailmentTasksByPropertyQueryVariables = Exact<{
  propertyId: Scalars['String'];
}>;

export type PlmCurtailmentTasksByPropertyQuery = {
  __typename?: 'Query';
  plmCurtailmentTasksByProperty?: Array<{
    __typename?: 'PlmCurtailmentTask';
    _id: string;
    plmCurtailmentActionId: string;
    plmEventResponseId: string;
    batchId: number;
    propertyId: string;
    unitId: string;
    deviceId: string;
    deviceType: string;
    scheduledStart: number;
    scheduledEnd: number;
    startedAt?: number | null;
    verifiedAt?: number | null;
    verifyAttempts?: number | null;
    endedAt?: number | null;
    status: EnumPlmCurtailmentTaskStatus;
    statusMessage?: string | null;
    estimatedReductionKW?: number | null;
  } | null> | null;
};

export type PlmCurtailmentTasksByPropertyIdSubscriptionSubscriptionVariables =
  Exact<{
    propertyId: Scalars['String'];
  }>;

export type PlmCurtailmentTasksByPropertyIdSubscriptionSubscription = {
  __typename?: 'Subscription';
  plmCurtailmentTasksByPropertyIdEvents?: {
    __typename?: 'PlmCurtailmentTask';
    modelChangeOperation?: string | null;
    _id: string;
    plmCurtailmentActionId: string;
    plmEventResponseId: string;
    batchId: number;
    propertyId: string;
    unitId: string;
    deviceId: string;
    deviceType: string;
    scheduledStart: number;
    scheduledEnd: number;
    startedAt?: number | null;
    verifiedAt?: number | null;
    verifyAttempts?: number | null;
    endedAt?: number | null;
    status: EnumPlmCurtailmentTaskStatus;
    statusMessage?: string | null;
    estimatedReductionKW?: number | null;
  } | null;
};

export type PlmEventEventsByIdsSubscriptionVariables = Exact<{
  _ids: Array<Scalars['String']> | Scalars['String'];
}>;

export type PlmEventEventsByIdsSubscription = {
  __typename?: 'Subscription';
  plmEventEventsByIds?: {
    __typename?: 'PlmEvent';
    modelChangeOperation?: string | null;
    _id: string;
    programId: string;
    contractId: string;
    startTime: number;
    duration: number;
    reductionTarget?: number | null;
    status: EnumPlmEventStatus;
    createdAt: number;
    updatedAt: number;
    notificationMethod?: EnumPlmEventNotificationMethod | null;
    notificationReceivedAt?: number | null;
    notificationPayload?: string | null;
    program?: { __typename?: 'PlmProgram'; _id: string; name: string } | null;
    contract?: { __typename?: 'PlmContract'; _id: string; name: string } | null;
  } | null;
};

export type PlmEventByIdQueryVariables = Exact<{
  _id: Scalars['String'];
}>;

export type PlmEventByIdQuery = {
  __typename?: 'Query';
  plmEventById?: {
    __typename?: 'PlmEvent';
    _id: string;
    programId: string;
    contractId: string;
    startTime: number;
    duration: number;
    reductionTarget?: number | null;
    status: EnumPlmEventStatus;
    createdAt: number;
    updatedAt: number;
    notificationMethod?: EnumPlmEventNotificationMethod | null;
    notificationReceivedAt?: number | null;
    notificationPayload?: string | null;
    program?: { __typename?: 'PlmProgram'; _id: string; name: string } | null;
    contract?: { __typename?: 'PlmContract'; _id: string; name: string } | null;
    responses: Array<{
      __typename?: 'PlmEventResponse';
      _id: string;
      eventId: string;
      curtailmentPlanId?: string | null;
      scheduledStart: number;
      scheduledEnd: number;
      actualStart?: number | null;
      actualEnd?: number | null;
      responseSentAt: number;
      responseStatus: EnumPlmEventResponseResponseStatus;
      createdAt: number;
      updatedAt: number;
      curtailmentPlan?: {
        __typename?: 'PlmCurtailmentPlan';
        _id: string;
        name: string;
      } | null;
      event?: {
        __typename?: 'PlmEvent';
        _id: string;
        program?: {
          __typename?: 'PlmProgram';
          _id: string;
          name: string;
        } | null;
      } | null;
    } | null>;
  } | null;
};

export type PlmEventEventsSubscriptionVariables = Exact<{
  [key: string]: never;
}>;

export type PlmEventEventsSubscription = {
  __typename?: 'Subscription';
  plmEventEvents?: {
    __typename?: 'PlmEvent';
    modelChangeOperation?: string | null;
    _id: string;
    programId: string;
    contractId: string;
    startTime: number;
    duration: number;
    reductionTarget?: number | null;
    status: EnumPlmEventStatus;
    createdAt: number;
    updatedAt: number;
    notificationMethod?: EnumPlmEventNotificationMethod | null;
    notificationReceivedAt?: number | null;
    notificationPayload?: string | null;
    program?: { __typename?: 'PlmProgram'; _id: string; name: string } | null;
    contract?: { __typename?: 'PlmContract'; _id: string; name: string } | null;
  } | null;
};

export type PlmEventsQueryVariables = Exact<{
  filter?: InputMaybe<FilterFindManyPlmEventInput>;
  sort?: InputMaybe<SortFindManyPlmEventInput>;
  page?: InputMaybe<Scalars['Int']>;
  perPage?: InputMaybe<Scalars['Int']>;
}>;

export type PlmEventsQuery = {
  __typename?: 'Query';
  paginatedPlmEvents?: {
    __typename?: 'PlmEventPaginatedPlmEvents';
    items?: Array<{
      __typename?: 'PlmEvent';
      _id: string;
      programId: string;
      contractId: string;
      startTime: number;
      duration: number;
      reductionTarget?: number | null;
      status: EnumPlmEventStatus;
      createdAt: number;
      updatedAt: number;
      notificationMethod?: EnumPlmEventNotificationMethod | null;
      notificationReceivedAt?: number | null;
      notificationPayload?: string | null;
      program?: { __typename?: 'PlmProgram'; _id: string; name: string } | null;
      contract?: {
        __typename?: 'PlmContract';
        _id: string;
        name: string;
      } | null;
    }> | null;
    pageInfo: {
      __typename?: 'PaginationInfo';
      currentPage: number;
      perPage: number;
      pageCount?: number | null;
      itemCount?: number | null;
      hasNextPage?: boolean | null;
      hasPreviousPage?: boolean | null;
    };
  } | null;
};

export type CreatePlmEventMutationVariables = Exact<{
  record: CreateOnePlmEventInput;
}>;

export type CreatePlmEventMutation = {
  __typename?: 'Mutation';
  createPlmEvent?: {
    __typename?: 'PlmEvent';
    _id: string;
    programId: string;
    contractId: string;
    startTime: number;
    duration: number;
    reductionTarget?: number | null;
    status: EnumPlmEventStatus;
    createdAt: number;
    updatedAt: number;
    notificationMethod?: EnumPlmEventNotificationMethod | null;
    notificationReceivedAt?: number | null;
    notificationPayload?: string | null;
    program?: { __typename?: 'PlmProgram'; _id: string; name: string } | null;
    contract?: { __typename?: 'PlmContract'; _id: string; name: string } | null;
  } | null;
};

export type UpdatePlmEventMutationVariables = Exact<{
  _id: Scalars['String'];
  plmEvent: UpdateOnePlmEventInput;
}>;

export type UpdatePlmEventMutation = {
  __typename?: 'Mutation';
  updatePlmEvent?: {
    __typename?: 'PlmEvent';
    _id: string;
    programId: string;
    contractId: string;
    startTime: number;
    duration: number;
    reductionTarget?: number | null;
    status: EnumPlmEventStatus;
    createdAt: number;
    updatedAt: number;
    notificationMethod?: EnumPlmEventNotificationMethod | null;
    notificationReceivedAt?: number | null;
    notificationPayload?: string | null;
    program?: { __typename?: 'PlmProgram'; _id: string; name: string } | null;
    contract?: { __typename?: 'PlmContract'; _id: string; name: string } | null;
  } | null;
};

export type RemovePlmEventMutationVariables = Exact<{
  id: Scalars['String'];
}>;

export type RemovePlmEventMutation = {
  __typename?: 'Mutation';
  removePlmEvent: boolean;
};

export type PlmEventProgramOptionsQueryVariables = Exact<{
  [key: string]: never;
}>;

export type PlmEventProgramOptionsQuery = {
  __typename?: 'Query';
  plmPrograms: Array<{ __typename?: 'PlmProgram'; _id: string; name: string }>;
};

export type ApprovePlmEventResponseMutationVariables = Exact<{
  _id: Scalars['String'];
}>;

export type ApprovePlmEventResponseMutation = {
  __typename?: 'Mutation';
  approvePlmEventResponse?: {
    __typename?: 'PlmEventResponse';
    _id: string;
    eventId: string;
    curtailmentPlanId?: string | null;
    scheduledStart: number;
    scheduledEnd: number;
    actualStart?: number | null;
    actualEnd?: number | null;
    responseSentAt: number;
    responseStatus: EnumPlmEventResponseResponseStatus;
    createdAt: number;
    updatedAt: number;
  } | null;
};

export type CancelPlmEventResponseMutationVariables = Exact<{
  _id: Scalars['String'];
}>;

export type CancelPlmEventResponseMutation = {
  __typename?: 'Mutation';
  cancelPlmEventResponse?: {
    __typename?: 'PlmEventResponse';
    _id: string;
    responseStatus: EnumPlmEventResponseResponseStatus;
    updatedAt: number;
  } | null;
};

export type PlmCurtailmentPlanOptionsQueryVariables = Exact<{
  [key: string]: never;
}>;

export type PlmCurtailmentPlanOptionsQuery = {
  __typename?: 'Query';
  plmCurtailmentPlans: Array<{
    __typename?: 'PlmCurtailmentPlan';
    _id: string;
    name: string;
    organizationId: string;
  }>;
};

export type PlmEventResponseEventsByIdsSubscriptionVariables = Exact<{
  _ids: Array<Scalars['String']> | Scalars['String'];
}>;

export type PlmEventResponseEventsByIdsSubscription = {
  __typename?: 'Subscription';
  plmEventResponseEventsByIds?: {
    __typename?: 'PlmEventResponse';
    modelChangeOperation?: string | null;
    _id: string;
    eventId: string;
    propertyId?: string | null;
    curtailmentPlanId?: string | null;
    scheduledStart: number;
    scheduledEnd: number;
    actualStart?: number | null;
    actualEnd?: number | null;
    responseSentAt: number;
    responseStatus: EnumPlmEventResponseResponseStatus;
    createdAt: number;
    updatedAt: number;
    event?: {
      __typename?: 'PlmEvent';
      _id: string;
      contractId: string;
      programId: string;
    } | null;
    curtailmentPlan?: {
      __typename?: 'PlmCurtailmentPlan';
      _id: string;
      organizationId: string;
    } | null;
  } | null;
};

export type PlmEventResponseByIdQueryVariables = Exact<{
  _id: Scalars['String'];
}>;

export type PlmEventResponseByIdQuery = {
  __typename?: 'Query';
  plmEventResponseById?: {
    __typename?: 'PlmEventResponse';
    _id: string;
    eventId: string;
    curtailmentPlanId?: string | null;
    scheduledStart: number;
    scheduledEnd: number;
    actualStart?: number | null;
    actualEnd?: number | null;
    responseSentAt: number;
    responseStatus: EnumPlmEventResponseResponseStatus;
    createdAt: number;
    updatedAt: number;
    event?: {
      __typename?: 'PlmEvent';
      _id: string;
      contractId: string;
      programId: string;
    } | null;
    curtailmentPlan?: {
      __typename?: 'PlmCurtailmentPlan';
      _id: string;
      organizationId: string;
    } | null;
  } | null;
};

export type PlmEventOptionsQueryVariables = Exact<{ [key: string]: never }>;

export type PlmEventOptionsQuery = {
  __typename?: 'Query';
  plmEvents: Array<{
    __typename?: 'PlmEvent';
    _id: string;
    contractId: string;
    programId: string;
    startTime: number;
    duration: number;
  }>;
};

export type PlmEventResponseListSubSubscriptionVariables = Exact<{
  [key: string]: never;
}>;

export type PlmEventResponseListSubSubscription = {
  __typename?: 'Subscription';
  plmEventResponseEvents?: {
    __typename?: 'PlmEventResponse';
    modelChangeOperation?: string | null;
    _id: string;
    eventId: string;
    curtailmentPlanId?: string | null;
    scheduledStart: number;
    scheduledEnd: number;
    actualStart?: number | null;
    actualEnd?: number | null;
    responseSentAt: number;
    responseStatus: EnumPlmEventResponseResponseStatus;
    createdAt: number;
    updatedAt: number;
    event?: {
      __typename?: 'PlmEvent';
      _id: string;
      contractId: string;
      programId: string;
    } | null;
    curtailmentPlan?: {
      __typename?: 'PlmCurtailmentPlan';
      _id: string;
      organizationId: string;
    } | null;
  } | null;
};

export type PlmEventResponseListQueryVariables = Exact<{
  [key: string]: never;
}>;

export type PlmEventResponseListQuery = {
  __typename?: 'Query';
  plmEventResponses: Array<{
    __typename?: 'PlmEventResponse';
    _id: string;
    eventId: string;
    curtailmentPlanId?: string | null;
    scheduledStart: number;
    scheduledEnd: number;
    actualStart?: number | null;
    actualEnd?: number | null;
    responseSentAt: number;
    responseStatus: EnumPlmEventResponseResponseStatus;
    createdAt: number;
    updatedAt: number;
    event?: {
      __typename?: 'PlmEvent';
      _id: string;
      contractId: string;
      programId: string;
      program?: { __typename?: 'PlmProgram'; _id: string; name: string } | null;
    } | null;
    curtailmentPlan?: {
      __typename?: 'PlmCurtailmentPlan';
      _id: string;
      name: string;
      organizationId: string;
    } | null;
  }>;
};

export type CreatePlmEventResponseMutationVariables = Exact<{
  record: CreateOnePlmEventResponseInput;
}>;

export type CreatePlmEventResponseMutation = {
  __typename?: 'Mutation';
  createPlmEventResponse?: {
    __typename?: 'PlmEventResponse';
    _id: string;
    eventId: string;
    curtailmentPlanId?: string | null;
    scheduledStart: number;
    scheduledEnd: number;
    actualStart?: number | null;
    actualEnd?: number | null;
    responseSentAt: number;
    responseStatus: EnumPlmEventResponseResponseStatus;
    createdAt: number;
    updatedAt: number;
  } | null;
};

export type UpdatePlmEventResponseMutationVariables = Exact<{
  _id: Scalars['String'];
  plmEventResponse: UpdateOnePlmEventResponseInput;
}>;

export type UpdatePlmEventResponseMutation = {
  __typename?: 'Mutation';
  updatePlmEventResponse?: {
    __typename?: 'PlmEventResponse';
    _id: string;
    eventId: string;
    curtailmentPlanId?: string | null;
    scheduledStart: number;
    scheduledEnd: number;
    actualStart?: number | null;
    actualEnd?: number | null;
    responseSentAt: number;
    responseStatus: EnumPlmEventResponseResponseStatus;
    createdAt: number;
    updatedAt: number;
  } | null;
};

export type RemovePlmEventResponseMutationVariables = Exact<{
  id: Scalars['String'];
}>;

export type RemovePlmEventResponseMutation = {
  __typename?: 'Mutation';
  removePlmEventResponse: boolean;
};

export type PlmNotificationUpdateSubscriptionVariables = Exact<{
  _id: Scalars['String'];
}>;

export type PlmNotificationUpdateSubscription = {
  __typename?: 'Subscription';
  plmNotificationEventsByIds?: {
    __typename?: 'PlmNotification';
    modelChangeOperation?: string | null;
    _id: string;
    programId: string;
    contractId: string;
    partnerId: string;
    activationTime: any;
    deactivationTime: any;
    receivedAt: any;
    participationStatus: EnumPlmNotificationParticipationStatus;
    responseSentAt?: any | null;
    source: EnumPlmNotificationSource;
    payload: string;
  } | null;
};

export type PlmNotificationQueryVariables = Exact<{
  _id: Scalars['String'];
}>;

export type PlmNotificationQuery = {
  __typename?: 'Query';
  plmNotification?: {
    __typename?: 'PlmNotification';
    _id: string;
    programId: string;
    contractId: string;
    partnerId: string;
    activationTime: any;
    deactivationTime: any;
    receivedAt: any;
    participationStatus: EnumPlmNotificationParticipationStatus;
    responseSentAt?: any | null;
    source: EnumPlmNotificationSource;
    payload: string;
  } | null;
};

export type PlmPartnerDetailEditSubSubscriptionVariables = Exact<{
  id: Scalars['String'];
}>;

export type PlmPartnerDetailEditSubSubscription = {
  __typename?: 'Subscription';
  plmPartnerEventsByIds?: {
    __typename?: 'PlmPartner';
    modelChangeOperation?: string | null;
    _id: string;
    name: string;
    description: string;
    partnerType: EnumPlmPartnerPartnerType;
    contact: {
      __typename?: 'PlmPartnerContact';
      name: string;
      email?: string | null;
      phone?: string | null;
    };
  } | null;
};

export type PlmPartnerDetailEditQueryVariables = Exact<{
  id: Scalars['String'];
}>;

export type PlmPartnerDetailEditQuery = {
  __typename?: 'Query';
  plmPartnerById?: {
    __typename?: 'PlmPartner';
    _id: string;
    name: string;
    description: string;
    partnerType: EnumPlmPartnerPartnerType;
    contact: {
      __typename?: 'PlmPartnerContact';
      name: string;
      email?: string | null;
      phone?: string | null;
    };
  } | null;
};

export type PlmPartnerListSubSubscriptionVariables = Exact<{
  [key: string]: never;
}>;

export type PlmPartnerListSubSubscription = {
  __typename?: 'Subscription';
  plmPartnerEvents?: {
    __typename?: 'PlmPartner';
    modelChangeOperation?: string | null;
    _id: string;
    name: string;
    description: string;
    partnerType: EnumPlmPartnerPartnerType;
    contact: {
      __typename?: 'PlmPartnerContact';
      name: string;
      email?: string | null;
      phone?: string | null;
    };
  } | null;
};

export type PlmPartnersQueryVariables = Exact<{ [key: string]: never }>;

export type PlmPartnersQuery = {
  __typename?: 'Query';
  plmPartners: Array<{
    __typename?: 'PlmPartner';
    _id: string;
    name: string;
    description: string;
    partnerType: EnumPlmPartnerPartnerType;
    contact: {
      __typename?: 'PlmPartnerContact';
      name: string;
      email?: string | null;
      phone?: string | null;
    };
  }>;
};

export type CreatePlmPartnerMutationVariables = Exact<{
  plmPartner: CreateOnePlmPartnerInput;
}>;

export type CreatePlmPartnerMutation = {
  __typename?: 'Mutation';
  createPlmPartner?: {
    __typename?: 'PlmPartner';
    _id: string;
    name: string;
    description: string;
    partnerType: EnumPlmPartnerPartnerType;
    contact: {
      __typename?: 'PlmPartnerContact';
      name: string;
      email?: string | null;
      phone?: string | null;
    };
  } | null;
};

export type UpdatePlmPartnerMutationVariables = Exact<{
  id: Scalars['String'];
  plmPartner: UpdateOnePlmPartnerInput;
}>;

export type UpdatePlmPartnerMutation = {
  __typename?: 'Mutation';
  updatePlmPartner?: {
    __typename?: 'PlmPartner';
    _id: string;
    name: string;
    description: string;
    partnerType: EnumPlmPartnerPartnerType;
    contact: {
      __typename?: 'PlmPartnerContact';
      name: string;
      email?: string | null;
      phone?: string | null;
    };
  } | null;
};

export type RemovePlmPartnerMutationVariables = Exact<{
  id: Scalars['String'];
}>;

export type RemovePlmPartnerMutation = {
  __typename?: 'Mutation';
  deletePlmPartner: boolean;
};

export type PlmPartnerOptionsQueryVariables = Exact<{ [key: string]: never }>;

export type PlmPartnerOptionsQuery = {
  __typename?: 'Query';
  plmPartners: Array<{ __typename?: 'PlmPartner'; _id: string; name: string }>;
};

export type PlmPartnerUpdateSubscriptionVariables = Exact<{
  _id?: InputMaybe<Scalars['String']>;
}>;

export type PlmPartnerUpdateSubscription = {
  __typename?: 'Subscription';
  plmPartnerEventsByIds?: {
    __typename?: 'PlmPartner';
    modelChangeOperation?: string | null;
    _id: string;
    name: string;
    description: string;
    partnerType: EnumPlmPartnerPartnerType;
    contact: {
      __typename?: 'PlmPartnerContact';
      name: string;
      email?: string | null;
      phone?: string | null;
    };
  } | null;
};

export type PlmPartnerQueryVariables = Exact<{
  _id?: InputMaybe<Scalars['String']>;
}>;

export type PlmPartnerQuery = {
  __typename?: 'Query';
  plmPartner?: {
    __typename?: 'PlmPartner';
    _id: string;
    name: string;
    description: string;
    partnerType: EnumPlmPartnerPartnerType;
    contact: {
      __typename?: 'PlmPartnerContact';
      name: string;
      email?: string | null;
      phone?: string | null;
    };
  } | null;
};

export type PlmProgramDetailEditSubSubscriptionVariables = Exact<{
  id: Scalars['String'];
}>;

export type PlmProgramDetailEditSubSubscription = {
  __typename?: 'Subscription';
  plmProgramEventsByIds?: {
    __typename?: 'PlmProgram';
    modelChangeOperation?: string | null;
    _id: string;
    programId: string;
    name: string;
    partnerId: string;
    hostPartnerId?: string | null;
    season: EnumPlmProgramSeason;
    startDate: number;
    endDate?: number | null;
    notificationLeadTimeMinutes?: number | null;
    maximumNotificationLeadTimeMinutes?: number | null;
    minimumEventDurationMinutes?: number | null;
    maximumEventDurationMinutes?: number | null;
    minimumEventsPerSeason?: number | null;
    maximumEventsPerSeason?: number | null;
    measurementIntervalMinutes?: number | null;
    participationType: EnumPlmProgramParticipationType;
    incentiveDescription?: string | null;
    partner?: { __typename?: 'PlmPartner'; _id: string; name: string } | null;
    hostPartner?: {
      __typename?: 'PlmPartner';
      _id: string;
      name: string;
    } | null;
  } | null;
};

export type PlmProgramDetailEditQueryVariables = Exact<{
  id: Scalars['String'];
}>;

export type PlmProgramDetailEditQuery = {
  __typename?: 'Query';
  plmProgramById?: {
    __typename?: 'PlmProgram';
    _id: string;
    programId: string;
    name: string;
    partnerId: string;
    hostPartnerId?: string | null;
    season: EnumPlmProgramSeason;
    startDate: number;
    endDate?: number | null;
    notificationLeadTimeMinutes?: number | null;
    maximumNotificationLeadTimeMinutes?: number | null;
    minimumEventDurationMinutes?: number | null;
    maximumEventDurationMinutes?: number | null;
    minimumEventsPerSeason?: number | null;
    maximumEventsPerSeason?: number | null;
    measurementIntervalMinutes?: number | null;
    participationType: EnumPlmProgramParticipationType;
    incentiveDescription?: string | null;
    partner?: { __typename?: 'PlmPartner'; _id: string; name: string } | null;
    hostPartner?: {
      __typename?: 'PlmPartner';
      _id: string;
      name: string;
    } | null;
  } | null;
};

export type PlmProgramListSubSubscriptionVariables = Exact<{
  [key: string]: never;
}>;

export type PlmProgramListSubSubscription = {
  __typename?: 'Subscription';
  plmProgramEvents?: {
    __typename?: 'PlmProgram';
    modelChangeOperation?: string | null;
    _id: string;
    programId: string;
    name: string;
    season: EnumPlmProgramSeason;
    startDate: number;
    endDate?: number | null;
    participationType: EnumPlmProgramParticipationType;
    incentiveDescription?: string | null;
    partner?: { __typename?: 'PlmPartner'; _id: string; name: string } | null;
    hostPartner?: {
      __typename?: 'PlmPartner';
      _id: string;
      name: string;
    } | null;
  } | null;
};

export type PlmProgramsQueryVariables = Exact<{ [key: string]: never }>;

export type PlmProgramsQuery = {
  __typename?: 'Query';
  plmPrograms: Array<{
    __typename?: 'PlmProgram';
    _id: string;
    programId: string;
    name: string;
    season: EnumPlmProgramSeason;
    startDate: number;
    endDate?: number | null;
    participationType: EnumPlmProgramParticipationType;
    incentiveDescription?: string | null;
    partner?: { __typename?: 'PlmPartner'; _id: string; name: string } | null;
    hostPartner?: {
      __typename?: 'PlmPartner';
      _id: string;
      name: string;
    } | null;
  }>;
};

export type CreatePlmProgramMutationVariables = Exact<{
  plmProgram: CreateOnePlmProgramInput;
}>;

export type CreatePlmProgramMutation = {
  __typename?: 'Mutation';
  createPlmProgram?: {
    __typename?: 'PlmProgram';
    _id: string;
    programId: string;
    name: string;
    partnerId: string;
    hostPartnerId?: string | null;
    season: EnumPlmProgramSeason;
    startDate: number;
    endDate?: number | null;
    notificationLeadTimeMinutes?: number | null;
    maximumNotificationLeadTimeMinutes?: number | null;
    minimumEventDurationMinutes?: number | null;
    maximumEventDurationMinutes?: number | null;
    minimumEventsPerSeason?: number | null;
    maximumEventsPerSeason?: number | null;
    measurementIntervalMinutes?: number | null;
    participationType: EnumPlmProgramParticipationType;
    incentiveDescription?: string | null;
    partner?: { __typename?: 'PlmPartner'; _id: string; name: string } | null;
    hostPartner?: {
      __typename?: 'PlmPartner';
      _id: string;
      name: string;
    } | null;
  } | null;
};

export type UpdatePlmProgramMutationVariables = Exact<{
  id: Scalars['String'];
  plmProgram: UpdateOnePlmProgramInput;
}>;

export type UpdatePlmProgramMutation = {
  __typename?: 'Mutation';
  updatePlmProgram?: {
    __typename?: 'PlmProgram';
    _id: string;
    programId: string;
    name: string;
    partnerId: string;
    hostPartnerId?: string | null;
    season: EnumPlmProgramSeason;
    startDate: number;
    endDate?: number | null;
    notificationLeadTimeMinutes?: number | null;
    maximumNotificationLeadTimeMinutes?: number | null;
    minimumEventDurationMinutes?: number | null;
    maximumEventDurationMinutes?: number | null;
    minimumEventsPerSeason?: number | null;
    maximumEventsPerSeason?: number | null;
    measurementIntervalMinutes?: number | null;
    participationType: EnumPlmProgramParticipationType;
    incentiveDescription?: string | null;
    partner?: { __typename?: 'PlmPartner'; _id: string; name: string } | null;
    hostPartner?: {
      __typename?: 'PlmPartner';
      _id: string;
      name: string;
    } | null;
  } | null;
};

export type RemovePlmProgramMutationVariables = Exact<{
  id: Scalars['String'];
}>;

export type RemovePlmProgramMutation = {
  __typename?: 'Mutation';
  deletePlmProgram: boolean;
};

export type PlmProgramOptionsQueryVariables = Exact<{ [key: string]: never }>;

export type PlmProgramOptionsQuery = {
  __typename?: 'Query';
  plmPrograms: Array<{
    __typename?: 'PlmProgram';
    _id: string;
    name: string;
    incentiveDescription?: string | null;
    partner?: { __typename?: 'PlmPartner'; _id: string; name: string } | null;
  }>;
};

export type PlmProgramUpdateSubscriptionVariables = Exact<{
  _id?: InputMaybe<Scalars['String']>;
}>;

export type PlmProgramUpdateSubscription = {
  __typename?: 'Subscription';
  plmProgramEventsByIds?: {
    __typename?: 'PlmProgram';
    modelChangeOperation?: string | null;
    _id: string;
    programId: string;
    name: string;
    partnerId: string;
    season: EnumPlmProgramSeason;
    startDate: number;
    endDate?: number | null;
    notificationLeadTimeMinutes?: number | null;
    maximumNotificationLeadTimeMinutes?: number | null;
    minimumEventDurationMinutes?: number | null;
    maximumEventDurationMinutes?: number | null;
    minimumEventsPerSeason?: number | null;
    maximumEventsPerSeason?: number | null;
    measurementIntervalMinutes?: number | null;
    participationType: EnumPlmProgramParticipationType;
    partner?: { __typename?: 'PlmPartner'; _id: string; name: string } | null;
  } | null;
};

export type PlmProgramQueryVariables = Exact<{
  _id?: InputMaybe<Scalars['String']>;
}>;

export type PlmProgramQuery = {
  __typename?: 'Query';
  plmProgram?: {
    __typename?: 'PlmProgram';
    _id: string;
    programId: string;
    name: string;
    partnerId: string;
    season: EnumPlmProgramSeason;
    startDate: number;
    endDate?: number | null;
    notificationLeadTimeMinutes?: number | null;
    maximumNotificationLeadTimeMinutes?: number | null;
    minimumEventDurationMinutes?: number | null;
    maximumEventDurationMinutes?: number | null;
    minimumEventsPerSeason?: number | null;
    maximumEventsPerSeason?: number | null;
    measurementIntervalMinutes?: number | null;
    participationType: EnumPlmProgramParticipationType;
    partner?: { __typename?: 'PlmPartner'; _id: string; name: string } | null;
  } | null;
};

export type CheckOpenWeatherDevicesQueryVariables = Exact<{
  propertyId: Scalars['String'];
}>;

export type CheckOpenWeatherDevicesQuery = {
  __typename?: 'Query';
  devices: Array<
    | { __typename?: 'Actuator'; _id: string; type?: EnumDKeyDeviceType | null }
    | {
        __typename?: 'BatteryManagementSystem';
        _id: string;
        type?: EnumDKeyDeviceType | null;
      }
    | { __typename?: 'Boiler'; _id: string; type?: EnumDKeyDeviceType | null }
    | { __typename?: 'Chiller'; _id: string; type?: EnumDKeyDeviceType | null }
    | {
        __typename?: 'ConductorGenericSensor';
        _id: string;
        type?: EnumDKeyDeviceType | null;
      }
    | {
        __typename?: 'Controller';
        _id: string;
        type?: EnumDKeyDeviceType | null;
      }
    | { __typename?: 'Device'; _id: string; type?: EnumDKeyDeviceType | null }
    | {
        __typename?: 'DoorSensor';
        _id: string;
        type?: EnumDKeyDeviceType | null;
      }
    | {
        __typename?: 'EnergyController';
        _id: string;
        type?: EnumDKeyDeviceType | null;
      }
    | {
        __typename?: 'EnergyConverter';
        _id: string;
        type?: EnumDKeyDeviceType | null;
      }
    | {
        __typename?: 'EnergyInverter';
        _id: string;
        type?: EnumDKeyDeviceType | null;
      }
    | {
        __typename?: 'EnergyMeter';
        _id: string;
        type?: EnumDKeyDeviceType | null;
      }
    | {
        __typename?: 'EnergyRectifier';
        _id: string;
        type?: EnumDKeyDeviceType | null;
      }
    | {
        __typename?: 'EnergyStorageCoolingSystem';
        _id: string;
        type?: EnumDKeyDeviceType | null;
      }
    | {
        __typename?: 'EnergySwitchPanel';
        _id: string;
        type?: EnumDKeyDeviceType | null;
      }
    | {
        __typename?: 'EnergySwitchPanelCircuit';
        _id: string;
        type?: EnumDKeyDeviceType | null;
      }
    | {
        __typename?: 'FireSuppressionSystem';
        _id: string;
        type?: EnumDKeyDeviceType | null;
      }
    | { __typename?: 'GPIO'; _id: string; type?: EnumDKeyDeviceType | null }
    | {
        __typename?: 'IndoorAirHandler';
        _id: string;
        type?: EnumDKeyDeviceType | null;
      }
    | {
        __typename?: 'IndoorSensor';
        _id: string;
        type?: EnumDKeyDeviceType | null;
      }
    | {
        __typename?: 'KineticEnergyManagementSystem';
        _id: string;
        type?: EnumDKeyDeviceType | null;
      }
    | {
        __typename?: 'LeakDetector';
        _id: string;
        type?: EnumDKeyDeviceType | null;
      }
    | { __typename?: 'Loop'; _id: string; type?: EnumDKeyDeviceType | null }
    | {
        __typename?: 'ModbusAirHandler';
        _id: string;
        type?: EnumDKeyDeviceType | null;
      }
    | {
        __typename?: 'OccupancySensor';
        _id: string;
        type?: EnumDKeyDeviceType | null;
      }
    | {
        __typename?: 'OpenWeather';
        _id: string;
        type?: EnumDKeyDeviceType | null;
      }
    | {
        __typename?: 'OutdoorSensor';
        _id: string;
        type?: EnumDKeyDeviceType | null;
      }
    | {
        __typename?: 'PowerMonitor';
        _id: string;
        type?: EnumDKeyDeviceType | null;
      }
    | {
        __typename?: 'PressureSensor';
        _id: string;
        type?: EnumDKeyDeviceType | null;
      }
    | {
        __typename?: 'RelayDevice';
        _id: string;
        type?: EnumDKeyDeviceType | null;
      }
    | {
        __typename?: 'SmartPowerOutlet';
        _id: string;
        type?: EnumDKeyDeviceType | null;
      }
    | {
        __typename?: 'SolarManagementSystem';
        _id: string;
        type?: EnumDKeyDeviceType | null;
      }
    | {
        __typename?: 'Thermistor';
        _id: string;
        type?: EnumDKeyDeviceType | null;
      }
    | {
        __typename?: 'Thermostat';
        _id: string;
        type?: EnumDKeyDeviceType | null;
      }
    | { __typename?: 'VSDPump'; _id: string; type?: EnumDKeyDeviceType | null }
    | {
        __typename?: 'WindManagementSystem';
        _id: string;
        type?: EnumDKeyDeviceType | null;
      }
    | {
        __typename?: 'WindowSensor';
        _id: string;
        type?: EnumDKeyDeviceType | null;
      }
    | { __typename?: 'Z210Pump'; _id: string; type?: EnumDKeyDeviceType | null }
  >;
};

export type CreatePropertyMutationVariables = Exact<{
  property: CreateOnePropertyInput;
}>;

export type CreatePropertyMutation = {
  __typename?: 'Mutation';
  createProperty?: {
    __typename?: 'Property';
    _id: string;
    title: string;
    imageUrl?: string | null;
    hasSecondaryHeatSource?: boolean | null;
    organizationId?: string | null;
    address: {
      __typename?: 'PropertyAddress';
      line1: string;
      line2?: string | null;
      city?: string | null;
      state?: string | null;
      postalCode?: string | null;
    };
    owner?: {
      __typename?: 'PropertyOwner';
      name?: string | null;
      email?: string | null;
      mobile?: string | null;
      phone?: string | null;
    } | null;
    propMgr?: {
      __typename?: 'PropertyPropMgr';
      name?: string | null;
      email?: string | null;
      mobile?: string | null;
      phone?: string | null;
    } | null;
    contact?: {
      __typename?: 'PropertyContact';
      email?: string | null;
      email2?: string | null;
      email3?: string | null;
      smsNumber?: string | null;
      smsNumber2?: string | null;
      smsNumber3?: string | null;
    } | null;
    alertLimits?: {
      __typename?: 'PropertyAlertLimits';
      units?: {
        __typename?: 'PropertyAlertLimitsUnits';
        temperature?: {
          __typename?: 'PropertyAlertLimitsUnitsTemperature';
          min?: number | null;
          max?: number | null;
        } | null;
        humidity?: {
          __typename?: 'PropertyAlertLimitsUnitsHumidity';
          min?: number | null;
          max?: number | null;
        } | null;
      } | null;
      plant?: {
        __typename?: 'PropertyAlertLimitsPlant';
        loops?: {
          __typename?: 'PropertyAlertLimitsPlantLoops';
          temperature?: {
            __typename?: 'PropertyAlertLimitsPlantLoopsTemperature';
            min?: number | null;
            max?: number | null;
          } | null;
          pressure?: {
            __typename?: 'PropertyAlertLimitsPlantLoopsPressure';
            min?: number | null;
            max?: number | null;
          } | null;
        } | null;
        dhw?: {
          __typename?: 'PropertyAlertLimitsPlantDhw';
          temperature?: {
            __typename?: 'PropertyAlertLimitsPlantDhwTemperature';
            min?: number | null;
            max?: number | null;
          } | null;
        } | null;
      } | null;
    } | null;
  } | null;
};

export type InitializeLocalWeatherDeviceMutationVariables = Exact<{
  propertyId: Scalars['String'];
}>;

export type InitializeLocalWeatherDeviceMutation = {
  __typename?: 'Mutation';
  initializeLocalWeatherDevice: {
    __typename?: 'OpenWeather';
    _id: string;
    deviceId?: string | null;
    type?: EnumDKeyDeviceType | null;
    name?: string | null;
    propertyId: string;
    unitId: string;
    panelId?: string | null;
    meta?: {
      __typename?: 'DeviceMeta';
      name?: string | null;
      location?: string | null;
      type?: string | null;
    } | null;
  };
};

export type PropertyDetailEditQueryVariables = Exact<{
  id: Scalars['String'];
}>;

export type PropertyDetailEditQuery = {
  __typename?: 'Query';
  propertyById?: {
    __typename?: 'Property';
    _id: string;
    title: string;
    imageUrl?: string | null;
    hasSecondaryHeatSource?: boolean | null;
    setpointProfileId?: string | null;
    thermostatScheduleTemplateId?: string | null;
    zonePolicyId?: string | null;
    organizationId?: string | null;
    organization?: {
      __typename?: 'Organization';
      _id: string;
      name: string;
    } | null;
    assignableZonePolicies?: Array<{
      __typename?: 'ZonePolicy';
      _id: any;
      name?: string | null;
      properties?: Array<string | null> | null;
      rules?: Array<{
        __typename?: 'ZonePolicyRules';
        type: EnumZonePolicyRulesType;
        source?: {
          __typename?: 'ZonePolicyRulesSource';
          deviceType: string;
          multiplicity?: EnumZonePolicyRulesSourceMultiplicity | null;
          attributes?: {
            __typename?: 'ZonePolicyRulesSourceAttributes';
            operatingMode?: string | null;
            operatingState?: string | null;
            heatSetpoint?: string | null;
            coolSetpoint?: string | null;
            contactState?: string | null;
            fanSpeed?: string | null;
            indoorFanStatus?: string | null;
            keypadLockoutLevel?: string | null;
          } | null;
        } | null;
        target?: {
          __typename?: 'ZonePolicyRulesTarget';
          deviceType: string;
          multiplicity?: EnumZonePolicyRulesTargetMultiplicity | null;
          attributes?: {
            __typename?: 'ZonePolicyRulesTargetAttributes';
            heatSetpoint?: string | null;
            coolSetpoint?: string | null;
            isOn?: string | null;
            keypadLockoutLevel?: string | null;
          } | null;
        } | null;
      } | null> | null;
    }> | null;
    address: {
      __typename?: 'PropertyAddress';
      line1: string;
      line2?: string | null;
      city?: string | null;
      state?: string | null;
      postalCode?: string | null;
    };
    owner?: {
      __typename?: 'PropertyOwner';
      name?: string | null;
      email?: string | null;
      mobile?: string | null;
      phone?: string | null;
    } | null;
    propMgr?: {
      __typename?: 'PropertyPropMgr';
      name?: string | null;
      email?: string | null;
      mobile?: string | null;
      phone?: string | null;
    } | null;
    maintMgr?: {
      __typename?: 'PropertyMaintMgr';
      name?: string | null;
      email?: string | null;
      mobile?: string | null;
    } | null;
    contact?: {
      __typename?: 'PropertyContact';
      email?: string | null;
      email2?: string | null;
      email3?: string | null;
      smsNumber?: string | null;
      smsNumber2?: string | null;
      smsNumber3?: string | null;
      smsOptInStatus1?: EnumPropertyContactSmsOptInStatus1 | null;
      smsOptInTimestamp1?: number | null;
      smsOptInStatus2?: EnumPropertyContactSmsOptInStatus2 | null;
      smsOptInTimestamp2?: number | null;
      smsOptInStatus3?: EnumPropertyContactSmsOptInStatus3 | null;
      smsOptInTimestamp3?: number | null;
    } | null;
    alertLimits?: {
      __typename?: 'PropertyAlertLimits';
      units?: {
        __typename?: 'PropertyAlertLimitsUnits';
        temperature?: {
          __typename?: 'PropertyAlertLimitsUnitsTemperature';
          min?: number | null;
          max?: number | null;
        } | null;
        humidity?: {
          __typename?: 'PropertyAlertLimitsUnitsHumidity';
          min?: number | null;
          max?: number | null;
        } | null;
      } | null;
      plant?: {
        __typename?: 'PropertyAlertLimitsPlant';
        loops?: {
          __typename?: 'PropertyAlertLimitsPlantLoops';
          temperature?: {
            __typename?: 'PropertyAlertLimitsPlantLoopsTemperature';
            min?: number | null;
            max?: number | null;
          } | null;
          pressure?: {
            __typename?: 'PropertyAlertLimitsPlantLoopsPressure';
            min?: number | null;
            max?: number | null;
          } | null;
        } | null;
        dhw?: {
          __typename?: 'PropertyAlertLimitsPlantDhw';
          temperature?: {
            __typename?: 'PropertyAlertLimitsPlantDhwTemperature';
            min?: number | null;
            max?: number | null;
          } | null;
        } | null;
      } | null;
    } | null;
  } | null;
};

export type PropertyOrganizationOptionsQueryVariables = Exact<{
  [key: string]: never;
}>;

export type PropertyOrganizationOptionsQuery = {
  __typename?: 'Query';
  organizations: Array<{
    __typename?: 'Organization';
    _id: string;
    name: string;
  }>;
};

export type PropertyUpdateSubscriptionVariables = Exact<{
  _id?: InputMaybe<Scalars['String']>;
}>;

export type PropertyUpdateSubscription = {
  __typename?: 'Subscription';
  propertyEventsByIds?: {
    __typename?: 'Property';
    modelChangeOperation?: string | null;
    _id: string;
    title: string;
    imageUrl?: string | null;
    floorLabel?: string | null;
    thermostatScheduleTemplateId?: string | null;
    setpointProfileId?: string | null;
    zonePolicyId?: string | null;
    devices: Array<
      | {
          __typename?: 'Actuator';
          name?: string | null;
          type?: EnumDKeyDeviceType | null;
          _id: string;
        }
      | {
          __typename?: 'BatteryManagementSystem';
          name?: string | null;
          type?: EnumDKeyDeviceType | null;
          _id: string;
        }
      | {
          __typename?: 'Boiler';
          name?: string | null;
          type?: EnumDKeyDeviceType | null;
          _id: string;
        }
      | {
          __typename?: 'Chiller';
          name?: string | null;
          type?: EnumDKeyDeviceType | null;
          _id: string;
        }
      | {
          __typename?: 'ConductorGenericSensor';
          name?: string | null;
          type?: EnumDKeyDeviceType | null;
          _id: string;
        }
      | {
          __typename?: 'Controller';
          name?: string | null;
          type?: EnumDKeyDeviceType | null;
          _id: string;
        }
      | {
          __typename?: 'Device';
          name?: string | null;
          type?: EnumDKeyDeviceType | null;
          _id: string;
        }
      | {
          __typename?: 'DoorSensor';
          name?: string | null;
          type?: EnumDKeyDeviceType | null;
          _id: string;
        }
      | {
          __typename?: 'EnergyController';
          name?: string | null;
          type?: EnumDKeyDeviceType | null;
          _id: string;
        }
      | {
          __typename?: 'EnergyConverter';
          name?: string | null;
          type?: EnumDKeyDeviceType | null;
          _id: string;
        }
      | {
          __typename?: 'EnergyInverter';
          name?: string | null;
          type?: EnumDKeyDeviceType | null;
          _id: string;
        }
      | {
          __typename?: 'EnergyMeter';
          name?: string | null;
          type?: EnumDKeyDeviceType | null;
          _id: string;
        }
      | {
          __typename?: 'EnergyRectifier';
          name?: string | null;
          type?: EnumDKeyDeviceType | null;
          _id: string;
        }
      | {
          __typename?: 'EnergyStorageCoolingSystem';
          name?: string | null;
          type?: EnumDKeyDeviceType | null;
          _id: string;
        }
      | {
          __typename?: 'EnergySwitchPanel';
          name?: string | null;
          type?: EnumDKeyDeviceType | null;
          _id: string;
        }
      | {
          __typename?: 'EnergySwitchPanelCircuit';
          name?: string | null;
          type?: EnumDKeyDeviceType | null;
          _id: string;
        }
      | {
          __typename?: 'FireSuppressionSystem';
          name?: string | null;
          type?: EnumDKeyDeviceType | null;
          _id: string;
        }
      | {
          __typename?: 'GPIO';
          name?: string | null;
          type?: EnumDKeyDeviceType | null;
          _id: string;
        }
      | {
          __typename?: 'IndoorAirHandler';
          name?: string | null;
          type?: EnumDKeyDeviceType | null;
          _id: string;
        }
      | {
          __typename?: 'IndoorSensor';
          name?: string | null;
          type?: EnumDKeyDeviceType | null;
          _id: string;
        }
      | {
          __typename?: 'KineticEnergyManagementSystem';
          name?: string | null;
          type?: EnumDKeyDeviceType | null;
          _id: string;
        }
      | {
          __typename?: 'LeakDetector';
          name?: string | null;
          type?: EnumDKeyDeviceType | null;
          _id: string;
        }
      | {
          __typename?: 'Loop';
          name?: string | null;
          type?: EnumDKeyDeviceType | null;
          _id: string;
        }
      | {
          __typename?: 'ModbusAirHandler';
          name?: string | null;
          type?: EnumDKeyDeviceType | null;
          _id: string;
        }
      | {
          __typename?: 'OccupancySensor';
          name?: string | null;
          type?: EnumDKeyDeviceType | null;
          _id: string;
        }
      | {
          __typename?: 'OpenWeather';
          name?: string | null;
          type?: EnumDKeyDeviceType | null;
          _id: string;
        }
      | {
          __typename?: 'OutdoorSensor';
          name?: string | null;
          type?: EnumDKeyDeviceType | null;
          _id: string;
        }
      | {
          __typename?: 'PowerMonitor';
          name?: string | null;
          type?: EnumDKeyDeviceType | null;
          _id: string;
        }
      | {
          __typename?: 'PressureSensor';
          name?: string | null;
          type?: EnumDKeyDeviceType | null;
          _id: string;
        }
      | {
          __typename?: 'RelayDevice';
          name?: string | null;
          type?: EnumDKeyDeviceType | null;
          _id: string;
        }
      | {
          __typename?: 'SmartPowerOutlet';
          name?: string | null;
          type?: EnumDKeyDeviceType | null;
          _id: string;
        }
      | {
          __typename?: 'SolarManagementSystem';
          name?: string | null;
          type?: EnumDKeyDeviceType | null;
          _id: string;
        }
      | {
          __typename?: 'Thermistor';
          name?: string | null;
          type?: EnumDKeyDeviceType | null;
          _id: string;
        }
      | {
          __typename?: 'Thermostat';
          name?: string | null;
          type?: EnumDKeyDeviceType | null;
          _id: string;
        }
      | {
          __typename?: 'VSDPump';
          name?: string | null;
          type?: EnumDKeyDeviceType | null;
          _id: string;
        }
      | {
          __typename?: 'WindManagementSystem';
          name?: string | null;
          type?: EnumDKeyDeviceType | null;
          _id: string;
        }
      | {
          __typename?: 'WindowSensor';
          name?: string | null;
          type?: EnumDKeyDeviceType | null;
          _id: string;
        }
      | {
          __typename?: 'Z210Pump';
          name?: string | null;
          type?: EnumDKeyDeviceType | null;
          _id: string;
        }
    >;
    address: {
      __typename?: 'PropertyAddress';
      line1: string;
      city?: string | null;
      state?: string | null;
      postalCode?: string | null;
    };
    units: Array<{
      __typename?: 'Unit';
      _id: string;
      name: string;
      type: string;
      devicesSummary?: {
        __typename?: 'UnitDevicesSummary';
        proxy?: {
          __typename?: 'UnitDevicesSummaryProxy';
          isOffline?: boolean | null;
          operatingState?: string | null;
          operatingMode?: string | null;
        } | null;
      } | null;
    } | null>;
    buildings: Array<{
      __typename?: 'Building';
      _id: string;
      name: string;
      number?: number | null;
      inUse: boolean;
      units: Array<{
        __typename?: 'Unit';
        _id: string;
        name: string;
        type: string;
      } | null>;
    } | null>;
    contact?: {
      __typename?: 'PropertyContact';
      email?: string | null;
      email2?: string | null;
      email3?: string | null;
      smsNumber?: string | null;
      smsNumber2?: string | null;
      smsNumber3?: string | null;
    } | null;
    owner?: { __typename?: 'PropertyOwner'; name?: string | null } | null;
    propMgr?: {
      __typename?: 'PropertyPropMgr';
      name?: string | null;
      mobile?: string | null;
    } | null;
    maintMgr?: {
      __typename?: 'PropertyMaintMgr';
      name?: string | null;
      mobile?: string | null;
    } | null;
    assignableZonePolicies?: Array<{
      __typename?: 'ZonePolicy';
      _id: any;
      name?: string | null;
      properties?: Array<string | null> | null;
      rules?: Array<{
        __typename?: 'ZonePolicyRules';
        type: EnumZonePolicyRulesType;
        source?: {
          __typename?: 'ZonePolicyRulesSource';
          deviceType: string;
          multiplicity?: EnumZonePolicyRulesSourceMultiplicity | null;
          attributes?: {
            __typename?: 'ZonePolicyRulesSourceAttributes';
            operatingMode?: string | null;
            operatingState?: string | null;
            heatSetpoint?: string | null;
            coolSetpoint?: string | null;
            contactState?: string | null;
            fanSpeed?: string | null;
            indoorFanStatus?: string | null;
            keypadLockoutLevel?: string | null;
          } | null;
        } | null;
        target?: {
          __typename?: 'ZonePolicyRulesTarget';
          deviceType: string;
          multiplicity?: EnumZonePolicyRulesTargetMultiplicity | null;
          attributes?: {
            __typename?: 'ZonePolicyRulesTargetAttributes';
            heatSetpoint?: string | null;
            coolSetpoint?: string | null;
            isOn?: string | null;
            keypadLockoutLevel?: string | null;
          } | null;
        } | null;
      } | null> | null;
    }> | null;
    authorizedUsers?: Array<{
      __typename?: 'User';
      _id: string;
      name: string;
      email?: string | null;
      authorizationProfile?: {
        __typename?: 'AuthorizationProfile';
        isManager?: boolean | null;
        isInstaller?: boolean | null;
        isViewer?: boolean | null;
      } | null;
    }> | null;
    alertLimits?: {
      __typename?: 'PropertyAlertLimits';
      plant?: {
        __typename?: 'PropertyAlertLimitsPlant';
        dhw?: {
          __typename?: 'PropertyAlertLimitsPlantDhw';
          temperature?: {
            __typename?: 'PropertyAlertLimitsPlantDhwTemperature';
            max?: number | null;
            min?: number | null;
          } | null;
        } | null;
        loops?: {
          __typename?: 'PropertyAlertLimitsPlantLoops';
          temperature?: {
            __typename?: 'PropertyAlertLimitsPlantLoopsTemperature';
            max?: number | null;
            min?: number | null;
          } | null;
          pressure?: {
            __typename?: 'PropertyAlertLimitsPlantLoopsPressure';
            max?: number | null;
            min?: number | null;
          } | null;
        } | null;
      } | null;
      units?: {
        __typename?: 'PropertyAlertLimitsUnits';
        temperature?: {
          __typename?: 'PropertyAlertLimitsUnitsTemperature';
          max?: number | null;
          min?: number | null;
        } | null;
        humidity?: {
          __typename?: 'PropertyAlertLimitsUnitsHumidity';
          max?: number | null;
          min?: number | null;
        } | null;
      } | null;
    } | null;
    assignableSetpointProfiles?: Array<{
      __typename?: 'SetpointProfile';
      _id: string;
      name?: string | null;
      assignedProperties: Array<{ __typename: 'Property'; _id: string } | null>;
      assignedUnits: Array<{ __typename: 'Unit'; _id: string } | null>;
      enabledProperties: Array<{ __typename: 'Property'; _id: string } | null>;
      heat?: {
        __typename?: 'SetpointProfileHeat';
        max?: number | null;
        min?: number | null;
      } | null;
      cool?: {
        __typename?: 'SetpointProfileCool';
        max?: number | null;
        min?: number | null;
      } | null;
    }> | null;
  } | null;
};

export type PropertyQueryVariables = Exact<{
  _id?: InputMaybe<Scalars['String']>;
}>;

export type PropertyQuery = {
  __typename?: 'Query';
  property?: {
    __typename?: 'Property';
    _id: string;
    title: string;
    imageUrl?: string | null;
    floorLabel?: string | null;
    thermostatScheduleTemplateId?: string | null;
    organizationId?: string | null;
    setpointProfileId?: string | null;
    zonePolicyId?: string | null;
    alerts: Array<{
      __typename?: 'Alert';
      type?: {
        __typename?: 'AlertType';
        id?: string | null;
        name?: string | null;
      } | null;
      unit?: {
        __typename?: 'AlertUnit';
        name?: string | null;
        id?: string | null;
      } | null;
      device?: { __typename?: 'AlertDevice'; id: string; type: string } | null;
    } | null>;
    organization?: {
      __typename?: 'Organization';
      _id: string;
      name: string;
    } | null;
    devices: Array<
      | {
          __typename?: 'Actuator';
          name?: string | null;
          type?: EnumDKeyDeviceType | null;
          _id: string;
        }
      | {
          __typename?: 'BatteryManagementSystem';
          name?: string | null;
          type?: EnumDKeyDeviceType | null;
          _id: string;
        }
      | {
          __typename?: 'Boiler';
          name?: string | null;
          type?: EnumDKeyDeviceType | null;
          _id: string;
        }
      | {
          __typename?: 'Chiller';
          name?: string | null;
          type?: EnumDKeyDeviceType | null;
          _id: string;
        }
      | {
          __typename?: 'ConductorGenericSensor';
          name?: string | null;
          type?: EnumDKeyDeviceType | null;
          _id: string;
        }
      | {
          __typename?: 'Controller';
          name?: string | null;
          type?: EnumDKeyDeviceType | null;
          _id: string;
        }
      | {
          __typename?: 'Device';
          name?: string | null;
          type?: EnumDKeyDeviceType | null;
          _id: string;
        }
      | {
          __typename?: 'DoorSensor';
          name?: string | null;
          type?: EnumDKeyDeviceType | null;
          _id: string;
        }
      | {
          __typename?: 'EnergyController';
          name?: string | null;
          type?: EnumDKeyDeviceType | null;
          _id: string;
        }
      | {
          __typename?: 'EnergyConverter';
          name?: string | null;
          type?: EnumDKeyDeviceType | null;
          _id: string;
        }
      | {
          __typename?: 'EnergyInverter';
          name?: string | null;
          type?: EnumDKeyDeviceType | null;
          _id: string;
        }
      | {
          __typename?: 'EnergyMeter';
          name?: string | null;
          type?: EnumDKeyDeviceType | null;
          _id: string;
        }
      | {
          __typename?: 'EnergyRectifier';
          name?: string | null;
          type?: EnumDKeyDeviceType | null;
          _id: string;
        }
      | {
          __typename?: 'EnergyStorageCoolingSystem';
          name?: string | null;
          type?: EnumDKeyDeviceType | null;
          _id: string;
        }
      | {
          __typename?: 'EnergySwitchPanel';
          name?: string | null;
          type?: EnumDKeyDeviceType | null;
          _id: string;
        }
      | {
          __typename?: 'EnergySwitchPanelCircuit';
          name?: string | null;
          type?: EnumDKeyDeviceType | null;
          _id: string;
        }
      | {
          __typename?: 'FireSuppressionSystem';
          name?: string | null;
          type?: EnumDKeyDeviceType | null;
          _id: string;
        }
      | {
          __typename?: 'GPIO';
          name?: string | null;
          type?: EnumDKeyDeviceType | null;
          _id: string;
        }
      | {
          __typename?: 'IndoorAirHandler';
          name?: string | null;
          type?: EnumDKeyDeviceType | null;
          _id: string;
        }
      | {
          __typename?: 'IndoorSensor';
          name?: string | null;
          type?: EnumDKeyDeviceType | null;
          _id: string;
        }
      | {
          __typename?: 'KineticEnergyManagementSystem';
          name?: string | null;
          type?: EnumDKeyDeviceType | null;
          _id: string;
        }
      | {
          __typename?: 'LeakDetector';
          name?: string | null;
          type?: EnumDKeyDeviceType | null;
          _id: string;
        }
      | {
          __typename?: 'Loop';
          name?: string | null;
          type?: EnumDKeyDeviceType | null;
          _id: string;
        }
      | {
          __typename?: 'ModbusAirHandler';
          name?: string | null;
          type?: EnumDKeyDeviceType | null;
          _id: string;
        }
      | {
          __typename?: 'OccupancySensor';
          name?: string | null;
          type?: EnumDKeyDeviceType | null;
          _id: string;
        }
      | {
          __typename?: 'OpenWeather';
          name?: string | null;
          type?: EnumDKeyDeviceType | null;
          _id: string;
        }
      | {
          __typename?: 'OutdoorSensor';
          name?: string | null;
          type?: EnumDKeyDeviceType | null;
          _id: string;
        }
      | {
          __typename?: 'PowerMonitor';
          name?: string | null;
          type?: EnumDKeyDeviceType | null;
          _id: string;
        }
      | {
          __typename?: 'PressureSensor';
          name?: string | null;
          type?: EnumDKeyDeviceType | null;
          _id: string;
        }
      | {
          __typename?: 'RelayDevice';
          name?: string | null;
          type?: EnumDKeyDeviceType | null;
          _id: string;
        }
      | {
          __typename?: 'SmartPowerOutlet';
          name?: string | null;
          type?: EnumDKeyDeviceType | null;
          _id: string;
        }
      | {
          __typename?: 'SolarManagementSystem';
          name?: string | null;
          type?: EnumDKeyDeviceType | null;
          _id: string;
        }
      | {
          __typename?: 'Thermistor';
          name?: string | null;
          type?: EnumDKeyDeviceType | null;
          _id: string;
        }
      | {
          __typename?: 'Thermostat';
          name?: string | null;
          type?: EnumDKeyDeviceType | null;
          _id: string;
        }
      | {
          __typename?: 'VSDPump';
          name?: string | null;
          type?: EnumDKeyDeviceType | null;
          _id: string;
        }
      | {
          __typename?: 'WindManagementSystem';
          name?: string | null;
          type?: EnumDKeyDeviceType | null;
          _id: string;
        }
      | {
          __typename?: 'WindowSensor';
          name?: string | null;
          type?: EnumDKeyDeviceType | null;
          _id: string;
        }
      | {
          __typename?: 'Z210Pump';
          name?: string | null;
          type?: EnumDKeyDeviceType | null;
          _id: string;
        }
    >;
    address: {
      __typename?: 'PropertyAddress';
      line1: string;
      city?: string | null;
      state?: string | null;
      postalCode?: string | null;
    };
    units: Array<{
      __typename?: 'Unit';
      _id: string;
      name: string;
      type: string;
      alertTypes?: {
        __typename?: 'UnitAlertTypes';
        sourceOffline?: boolean | null;
        deviceOffline?: boolean | null;
      } | null;
      devicesSummary?: {
        __typename?: 'UnitDevicesSummary';
        proxy?: {
          __typename?: 'UnitDevicesSummaryProxy';
          isOffline?: boolean | null;
          operatingState?: string | null;
          operatingMode?: string | null;
        } | null;
      } | null;
    } | null>;
    buildings: Array<{
      __typename?: 'Building';
      _id: string;
      name: string;
      number?: number | null;
      inUse: boolean;
      units: Array<{
        __typename?: 'Unit';
        _id: string;
        name: string;
        type: string;
      } | null>;
    } | null>;
    contact?: {
      __typename?: 'PropertyContact';
      email?: string | null;
      email2?: string | null;
      email3?: string | null;
      smsNumber?: string | null;
      smsNumber2?: string | null;
      smsNumber3?: string | null;
    } | null;
    owner?: { __typename?: 'PropertyOwner'; name?: string | null } | null;
    propMgr?: {
      __typename?: 'PropertyPropMgr';
      name?: string | null;
      mobile?: string | null;
    } | null;
    maintMgr?: {
      __typename?: 'PropertyMaintMgr';
      name?: string | null;
      mobile?: string | null;
    } | null;
    assignableZonePolicies?: Array<{
      __typename?: 'ZonePolicy';
      _id: any;
      name?: string | null;
      properties?: Array<string | null> | null;
      rules?: Array<{
        __typename?: 'ZonePolicyRules';
        type: EnumZonePolicyRulesType;
        source?: {
          __typename?: 'ZonePolicyRulesSource';
          deviceType: string;
          multiplicity?: EnumZonePolicyRulesSourceMultiplicity | null;
          attributes?: {
            __typename?: 'ZonePolicyRulesSourceAttributes';
            operatingMode?: string | null;
            operatingState?: string | null;
            heatSetpoint?: string | null;
            coolSetpoint?: string | null;
            contactState?: string | null;
            fanSpeed?: string | null;
            indoorFanStatus?: string | null;
            keypadLockoutLevel?: string | null;
          } | null;
        } | null;
        target?: {
          __typename?: 'ZonePolicyRulesTarget';
          deviceType: string;
          multiplicity?: EnumZonePolicyRulesTargetMultiplicity | null;
          attributes?: {
            __typename?: 'ZonePolicyRulesTargetAttributes';
            isOn?: string | null;
            heatSetpoint?: string | null;
            coolSetpoint?: string | null;
            keypadLockoutLevel?: string | null;
          } | null;
        } | null;
      } | null> | null;
    }> | null;
    authorizedUsers?: Array<{
      __typename?: 'User';
      _id: string;
      name: string;
      email?: string | null;
      authorizationProfile?: {
        __typename?: 'AuthorizationProfile';
        isManager?: boolean | null;
        isInstaller?: boolean | null;
        isViewer?: boolean | null;
      } | null;
    }> | null;
    alertLimits?: {
      __typename?: 'PropertyAlertLimits';
      plant?: {
        __typename?: 'PropertyAlertLimitsPlant';
        dhw?: {
          __typename?: 'PropertyAlertLimitsPlantDhw';
          temperature?: {
            __typename?: 'PropertyAlertLimitsPlantDhwTemperature';
            max?: number | null;
            min?: number | null;
          } | null;
        } | null;
        loops?: {
          __typename?: 'PropertyAlertLimitsPlantLoops';
          temperature?: {
            __typename?: 'PropertyAlertLimitsPlantLoopsTemperature';
            max?: number | null;
            min?: number | null;
          } | null;
          pressure?: {
            __typename?: 'PropertyAlertLimitsPlantLoopsPressure';
            max?: number | null;
            min?: number | null;
          } | null;
        } | null;
      } | null;
      units?: {
        __typename?: 'PropertyAlertLimitsUnits';
        temperature?: {
          __typename?: 'PropertyAlertLimitsUnitsTemperature';
          max?: number | null;
          min?: number | null;
        } | null;
        humidity?: {
          __typename?: 'PropertyAlertLimitsUnitsHumidity';
          max?: number | null;
          min?: number | null;
        } | null;
      } | null;
    } | null;
    assignableSetpointProfiles?: Array<{
      __typename?: 'SetpointProfile';
      _id: string;
      name?: string | null;
      assignedProperties: Array<{ __typename: 'Property'; _id: string } | null>;
      assignedUnits: Array<{ __typename: 'Unit'; _id: string } | null>;
      enabledProperties: Array<{ __typename: 'Property'; _id: string } | null>;
      heat?: {
        __typename?: 'SetpointProfileHeat';
        max?: number | null;
        min?: number | null;
      } | null;
      cool?: {
        __typename?: 'SetpointProfileCool';
        max?: number | null;
        min?: number | null;
      } | null;
    }> | null;
  } | null;
};

export type PropertyScheduleListByPropertyIdQueryVariables = Exact<{
  propertyId?: InputMaybe<Scalars['String']>;
}>;

export type PropertyScheduleListByPropertyIdQuery = {
  __typename?: 'Query';
  unitsByPropertyId: Array<{
    __typename?: 'Unit';
    _id: string;
    name: string;
    type: string;
    effectiveThermostatScheduleType: string;
  }>;
};

export type PropertyListForSourceEditorQueryVariables = Exact<{
  [key: string]: never;
}>;

export type PropertyListForSourceEditorQuery = {
  __typename?: 'Query';
  properties: Array<{ __typename?: 'Property'; _id: string; title: string }>;
};

export type PropertySummaryQueryVariables = Exact<{
  propertyId: Scalars['String'];
}>;

export type PropertySummaryQuery = {
  __typename?: 'Query';
  propertySummary?: {
    __typename?: 'PropertySummary';
    propertyId: string;
    units: {
      __typename?: 'PropertySummaryUnits';
      propertyId: string;
      units: Array<{
        __typename?: 'PropertySummaryListItem';
        label: string;
        count: number;
      }>;
    };
    alerts: {
      __typename?: 'PropertySummaryAlerts';
      propertyId: string;
      alerts: Array<{
        __typename?: 'PropertySummaryListItem';
        label: string;
        count: number;
        color?: string | null;
        action?: string | null;
        options?: Array<string | null> | null;
      }>;
    };
    devices: {
      __typename?: 'PropertySummaryDevices';
      propertyId: string;
      residentialDevices: Array<{
        __typename?: 'PropertySummaryListItem';
        label: string;
        count: number;
      }>;
      centralDevices: Array<{
        __typename?: 'PropertySummaryListItem';
        label: string;
        count: number;
      }>;
    };
    stats: {
      __typename?: 'PropertySummaryStats';
      propertyId: string;
      temperature?: {
        __typename?: 'PropertySummaryStat';
        min: number;
        max: number;
        ave: number;
      } | null;
      humidity?: {
        __typename?: 'PropertySummaryStat';
        min: number;
        max: number;
        ave: number;
      } | null;
    };
  } | null;
};

export type PropertySummaryUnitsQueryVariables = Exact<{
  propertyId: Scalars['String'];
}>;

export type PropertySummaryUnitsQuery = {
  __typename?: 'Query';
  propertySummaryUnits?: {
    __typename?: 'PropertySummaryUnits';
    propertyId: string;
    units: Array<{
      __typename?: 'PropertySummaryListItem';
      label: string;
      count: number;
    }>;
  } | null;
};

export type PropertySummaryAlertsQueryVariables = Exact<{
  propertyId: Scalars['String'];
}>;

export type PropertySummaryAlertsQuery = {
  __typename?: 'Query';
  propertySummaryAlerts?: {
    __typename?: 'PropertySummaryAlerts';
    propertyId: string;
    activeAlertCount: number;
    statusItems: Array<{
      __typename?: 'PropertySummaryListItem';
      label: string;
      count: number;
      total?: number | null;
      group?: string | null;
      color?: string | null;
      action?: string | null;
      options?: Array<string | null> | null;
    }>;
  } | null;
};

export type PropertySummaryDevicesQueryVariables = Exact<{
  propertyId: Scalars['String'];
}>;

export type PropertySummaryDevicesQuery = {
  __typename?: 'Query';
  propertySummaryDevices?: {
    __typename?: 'PropertySummaryDevices';
    propertyId: string;
    residentialDevices: Array<{
      __typename?: 'PropertySummaryListItem';
      label: string;
      count: number;
    }>;
    centralDevices: Array<{
      __typename?: 'PropertySummaryListItem';
      label: string;
      count: number;
    }>;
  } | null;
};

export type PropertySummaryStatsQueryVariables = Exact<{
  propertyId: Scalars['String'];
}>;

export type PropertySummaryStatsQuery = {
  __typename?: 'Query';
  propertySummaryStats?: {
    __typename?: 'PropertySummaryStats';
    propertyId: string;
    temperature?: {
      __typename?: 'PropertySummaryStat';
      min: number;
      max: number;
      ave: number;
    } | null;
    humidity?: {
      __typename?: 'PropertySummaryStat';
      min: number;
      max: number;
      ave: number;
    } | null;
  } | null;
};

export type PropertyPlmSummariesQueryVariables = Exact<{
  ids: Array<Scalars['String']> | Scalars['String'];
}>;

export type PropertyPlmSummariesQuery = {
  __typename?: 'Query';
  propertyPlmSummaries: Array<{
    __typename?: 'PropertyPlmSummary';
    propertyId: string;
    activeCount: number;
    scheduledCount: number;
    nextScheduledStart?: number | null;
    firstActiveResponseId?: string | null;
  }>;
};

export type RemovePropertyMutationVariables = Exact<{
  id: Scalars['String'];
}>;

export type RemovePropertyMutation = {
  __typename?: 'Mutation';
  deleteProperty?: boolean | null;
};

export type UpdatePropertyMutationVariables = Exact<{
  id: Scalars['String'];
  property: UpdateOnePropertyInput;
}>;

export type UpdatePropertyMutation = {
  __typename?: 'Mutation';
  updateProperty: {
    __typename?: 'Property';
    _id: string;
    title: string;
    imageUrl?: string | null;
    hasSecondaryHeatSource?: boolean | null;
    thermostatScheduleTemplateId?: string | null;
    organizationId?: string | null;
    address: {
      __typename?: 'PropertyAddress';
      line1: string;
      line2?: string | null;
      city?: string | null;
      state?: string | null;
      postalCode?: string | null;
    };
    owner?: {
      __typename?: 'PropertyOwner';
      name?: string | null;
      email?: string | null;
      mobile?: string | null;
      phone?: string | null;
    } | null;
    propMgr?: {
      __typename?: 'PropertyPropMgr';
      name?: string | null;
      email?: string | null;
      mobile?: string | null;
      phone?: string | null;
    } | null;
    contact?: {
      __typename?: 'PropertyContact';
      email?: string | null;
      email2?: string | null;
      email3?: string | null;
      smsNumber?: string | null;
      smsNumber2?: string | null;
      smsNumber3?: string | null;
    } | null;
    alertLimits?: {
      __typename?: 'PropertyAlertLimits';
      units?: {
        __typename?: 'PropertyAlertLimitsUnits';
        temperature?: {
          __typename?: 'PropertyAlertLimitsUnitsTemperature';
          min?: number | null;
          max?: number | null;
        } | null;
        humidity?: {
          __typename?: 'PropertyAlertLimitsUnitsHumidity';
          min?: number | null;
          max?: number | null;
        } | null;
      } | null;
      plant?: {
        __typename?: 'PropertyAlertLimitsPlant';
        loops?: {
          __typename?: 'PropertyAlertLimitsPlantLoops';
          temperature?: {
            __typename?: 'PropertyAlertLimitsPlantLoopsTemperature';
            min?: number | null;
            max?: number | null;
          } | null;
          pressure?: {
            __typename?: 'PropertyAlertLimitsPlantLoopsPressure';
            min?: number | null;
            max?: number | null;
          } | null;
        } | null;
        dhw?: {
          __typename?: 'PropertyAlertLimitsPlantDhw';
          temperature?: {
            __typename?: 'PropertyAlertLimitsPlantDhwTemperature';
            min?: number | null;
            max?: number | null;
          } | null;
        } | null;
      } | null;
    } | null;
  };
};

export type QuarterlyReportDataExportJobFieldsFragment = {
  __typename?: 'DataExportJob';
  _id: string;
  requestedByUserId: string;
  propertyId: string;
  propertyTitle: string;
  startDate: any;
  endDate: any;
  reportTypes: Array<string | null>;
  status: EnumDataExportJobStatus;
  progress: number;
  currentStep?: string | null;
  submittedAt: any;
  startedAt?: any | null;
  completedAt?: any | null;
  updatedAt: any;
  s3Bucket?: string | null;
  s3Key?: string | null;
  awsTaskArn?: string | null;
  errorMessage?: string | null;
  errorDetails?: string | null;
  artifacts: Array<{
    __typename?: 'DataExportJobArtifact';
    kind: string;
    bucket: string;
    key: string;
    contentType: string;
  }>;
};

export type QuarterlyReportDataExportJobsQueryVariables = Exact<{
  [key: string]: never;
}>;

export type QuarterlyReportDataExportJobsQuery = {
  __typename?: 'Query';
  quarterlyReportDataExportJobs: Array<{
    __typename?: 'DataExportJob';
    _id: string;
    requestedByUserId: string;
    propertyId: string;
    propertyTitle: string;
    startDate: any;
    endDate: any;
    reportTypes: Array<string | null>;
    status: EnumDataExportJobStatus;
    progress: number;
    currentStep?: string | null;
    submittedAt: any;
    startedAt?: any | null;
    completedAt?: any | null;
    updatedAt: any;
    s3Bucket?: string | null;
    s3Key?: string | null;
    awsTaskArn?: string | null;
    errorMessage?: string | null;
    errorDetails?: string | null;
    artifacts: Array<{
      __typename?: 'DataExportJobArtifact';
      kind: string;
      bucket: string;
      key: string;
      contentType: string;
    }>;
  }>;
};

export type SubmitQuarterlyReportDataExportJobsMutationVariables = Exact<{
  input: QuarterlyReportDataExportSubmitInput;
}>;

export type SubmitQuarterlyReportDataExportJobsMutation = {
  __typename?: 'Mutation';
  submitQuarterlyReportDataExportJobs: Array<{
    __typename?: 'DataExportJob';
    _id: string;
    requestedByUserId: string;
    propertyId: string;
    propertyTitle: string;
    startDate: any;
    endDate: any;
    reportTypes: Array<string | null>;
    status: EnumDataExportJobStatus;
    progress: number;
    currentStep?: string | null;
    submittedAt: any;
    startedAt?: any | null;
    completedAt?: any | null;
    updatedAt: any;
    s3Bucket?: string | null;
    s3Key?: string | null;
    awsTaskArn?: string | null;
    errorMessage?: string | null;
    errorDetails?: string | null;
    artifacts: Array<{
      __typename?: 'DataExportJobArtifact';
      kind: string;
      bucket: string;
      key: string;
      contentType: string;
    }>;
  }>;
};

export type DeleteQuarterlyReportDataExportJobMutationVariables = Exact<{
  id: Scalars['String'];
}>;

export type DeleteQuarterlyReportDataExportJobMutation = {
  __typename?: 'Mutation';
  deleteQuarterlyReportDataExportJob: {
    __typename?: 'DataExportJob';
    _id: string;
    requestedByUserId: string;
    propertyId: string;
    propertyTitle: string;
    startDate: any;
    endDate: any;
    reportTypes: Array<string | null>;
    status: EnumDataExportJobStatus;
    progress: number;
    currentStep?: string | null;
    submittedAt: any;
    startedAt?: any | null;
    completedAt?: any | null;
    updatedAt: any;
    s3Bucket?: string | null;
    s3Key?: string | null;
    awsTaskArn?: string | null;
    errorMessage?: string | null;
    errorDetails?: string | null;
    artifacts: Array<{
      __typename?: 'DataExportJobArtifact';
      kind: string;
      bucket: string;
      key: string;
      contentType: string;
    }>;
  };
};

export type QuarterlyReportDataExportJobDownloadUrlQueryVariables = Exact<{
  id: Scalars['String'];
  artifactKind?: InputMaybe<Scalars['String']>;
}>;

export type QuarterlyReportDataExportJobDownloadUrlQuery = {
  __typename?: 'Query';
  quarterlyReportDataExportJobDownloadUrl: string;
};

export type ClearThermostatUpdateStatusMutationVariables = Exact<{
  deviceId: Scalars['String'];
}>;

export type ClearThermostatUpdateStatusMutation = {
  __typename?: 'Mutation';
  clearThermostatUpdateStatus: {
    __typename?: 'Thermostat';
    _id: string;
    deviceId?: string | null;
    name?: string | null;
    type?: EnumDKeyDeviceType | null;
    hasPendingUpdates: boolean;
    coolSetpoint?: {
      __typename?: 'ThermostatCoolSetpoint';
      timestamp?: number | null;
      value?: number | null;
      units?: string | null;
      updatePending?: boolean | null;
    } | null;
    heatSetpoint?: {
      __typename?: 'ThermostatHeatSetpoint';
      timestamp?: number | null;
      value?: number | null;
      units?: string | null;
      updatePending?: boolean | null;
    } | null;
    fanMode?: {
      __typename?: 'ThermostatFanMode';
      timestamp?: number | null;
      value?: EnumThermostatFanModeValue | null;
      units?: string | null;
      updatePending?: boolean | null;
    } | null;
    fanSpeed?: {
      __typename?: 'ThermostatFanSpeed';
      timestamp?: number | null;
      value?: EnumThermostatFanSpeedValue | null;
      units?: string | null;
      updatePending?: boolean | null;
    } | null;
    fanState?: {
      __typename?: 'ThermostatFanState';
      timestamp?: number | null;
      value?: EnumThermostatFanStateValue | null;
      units?: string | null;
      updatePending?: boolean | null;
    } | null;
    holdDuration?: {
      __typename?: 'ThermostatHoldDuration';
      timestamp?: number | null;
      value?: number | null;
      units?: string | null;
      updatePending?: boolean | null;
    } | null;
    holdEnd?: {
      __typename?: 'ThermostatHoldEnd';
      timestamp?: number | null;
      value?: number | null;
      units?: string | null;
      updatePending?: boolean | null;
    } | null;
    holdExpiryTime?: {
      __typename?: 'ThermostatHoldExpiryTime';
      timestamp?: number | null;
      value?: number | null;
      units?: string | null;
      updatePending?: boolean | null;
    } | null;
    holdState?: {
      __typename?: 'ThermostatHoldState';
      timestamp?: number | null;
      value?: EnumThermostatHoldStateValue | null;
      units?: string | null;
      updatePending?: boolean | null;
    } | null;
    humidity?: {
      __typename?: 'ThermostatHumidity';
      timestamp?: number | null;
      value?: number | null;
      units?: string | null;
      updatePending?: boolean | null;
    } | null;
    keypadLockoutLevel?: {
      __typename?: 'ThermostatKeypadLockoutLevel';
      timestamp?: number | null;
      value?: string | null;
      units?: string | null;
      updatePending?: boolean | null;
    } | null;
    lastScheduleChange?: {
      __typename?: 'ThermostatLastScheduleChange';
      timestamp?: number | null;
      value?: number | null;
      units?: string | null;
      updatePending?: boolean | null;
    } | null;
    lastSetpointChange?: {
      __typename?: 'ThermostatLastSetpointChange';
      timestamp?: number | null;
      value?: number | null;
      units?: string | null;
      updatePending?: boolean | null;
    } | null;
    maxCoolSetpointLimit?: {
      __typename?: 'ThermostatMaxCoolSetpointLimit';
      timestamp?: number | null;
      value?: number | null;
      units?: string | null;
      updatePending?: boolean | null;
    } | null;
    maxHeatSetpointLimit?: {
      __typename?: 'ThermostatMaxHeatSetpointLimit';
      timestamp?: number | null;
      value?: number | null;
      units?: string | null;
      updatePending?: boolean | null;
    } | null;
    minCoolSetpointLimit?: {
      __typename?: 'ThermostatMinCoolSetpointLimit';
      timestamp?: number | null;
      value?: number | null;
      units?: string | null;
      updatePending?: boolean | null;
    } | null;
    minHeatSetpointLimit?: {
      __typename?: 'ThermostatMinHeatSetpointLimit';
      timestamp?: number | null;
      value?: number | null;
      units?: string | null;
      updatePending?: boolean | null;
    } | null;
    operatingMode?: {
      __typename?: 'ThermostatOperatingMode';
      timestamp?: number | null;
      value?: EnumThermostatOperatingModeValue | null;
      units?: string | null;
      updatePending?: boolean | null;
    } | null;
    operatingState?: {
      __typename?: 'ThermostatOperatingState';
      timestamp?: number | null;
      value?: EnumThermostatOperatingStateValue | null;
      units?: string | null;
      updatePending?: boolean | null;
    } | null;
    passCode?: {
      __typename?: 'ThermostatPassCode';
      timestamp?: number | null;
      value?: number | null;
      units?: string | null;
      updatePending?: boolean | null;
    } | null;
    progMode?: {
      __typename?: 'ThermostatProgMode';
      timestamp?: number | null;
      value?: EnumThermostatProgModeValue | null;
      units?: string | null;
      updatePending?: boolean | null;
    } | null;
    pairingState?: {
      __typename?: 'ThermostatPairingState';
      timestamp?: number | null;
      value?: EnumThermostatPairingStateValue | null;
      units?: string | null;
      updatePending?: boolean | null;
    } | null;
    remoteSensorTempDelta?: {
      __typename?: 'ThermostatRemoteSensorTempDelta';
      timestamp?: number | null;
      value?: number | null;
      units?: string | null;
      updatePending?: boolean | null;
    } | null;
    schedVisibilityMode?: {
      __typename?: 'ThermostatSchedVisibilityMode';
      timestamp?: number | null;
      value?: EnumThermostatSchedVisibilityModeValue | null;
      units?: string | null;
      updatePending?: boolean | null;
    } | null;
    setpointChangeSource?: {
      __typename?: 'ThermostatSetpointChangeSource';
      timestamp?: number | null;
      value?: EnumThermostatSetpointChangeSourceValue | null;
      units?: string | null;
      updatePending?: boolean | null;
    } | null;
    showFanButton?: {
      __typename?: 'ThermostatShowFanButton';
      timestamp?: number | null;
      value?: boolean | null;
      units?: string | null;
      updatePending?: boolean | null;
    } | null;
    systemType?: {
      __typename?: 'ThermostatSystemType';
      timestamp?: number | null;
      value?: EnumThermostatSystemTypeValue | null;
      units?: string | null;
      updatePending?: boolean | null;
    } | null;
    tempDisplayMode?: {
      __typename?: 'ThermostatTempDisplayMode';
      timestamp?: number | null;
      value?: EnumThermostatTempDisplayModeValue | null;
      units?: string | null;
      updatePending?: boolean | null;
    } | null;
    temperature?: {
      __typename?: 'ThermostatTemperature';
      timestamp?: number | null;
      value?: number | null;
      units?: string | null;
      updatePending?: boolean | null;
    } | null;
    uiOptions?: {
      __typename?: 'ThermostatUiOptions';
      timestamp?: number | null;
      value?: number | null;
      units?: string | null;
      updatePending?: boolean | null;
    } | null;
  };
};

export type ConductorGenericSensorDetailUpdateSubscriptionVariables = Exact<{
  ids: Array<Scalars['String']> | Scalars['String'];
}>;

export type ConductorGenericSensorDetailUpdateSubscription = {
  __typename?: 'Subscription';
  conductorGenericSensorEventsByIds?: {
    __typename?: 'ConductorGenericSensor';
    modelChangeOperation?: string | null;
    _id: string;
    type?: EnumDKeyDeviceType | null;
    typeDisplayName: string;
    zoneId?: string | null;
    name?: string | null;
    deviceId?: string | null;
    sourceId?: string | null;
    timestamp?: number | null;
    isConfigured?: boolean | null;
    displayName?: string | null;
    supportsResetCounters?: boolean | null;
    meta?: {
      __typename?: 'DeviceMeta';
      name?: string | null;
      model?: string | null;
      modelNumber?: string | null;
      version?: string | null;
      metrics?: any | null;
    } | null;
    zone?: { __typename?: 'Zone'; _id: string; name: string } | null;
    source?: { __typename?: 'Source'; _id: string; name: string } | null;
    counterValue?: {
      __typename?: 'ConductorGenericSensorCounterValue';
      timestamp?: number | null;
      value?: number | null;
      units?: string | null;
    } | null;
    resetCount?: {
      __typename?: 'ConductorGenericSensorResetCount';
      timestamp?: number | null;
      value?: number | null;
      units?: string | null;
    } | null;
    temperature?: {
      __typename?: 'ConductorGenericSensorTemperature';
      timestamp?: number | null;
      value?: number | null;
      units?: string | null;
    } | null;
    humidity?: {
      __typename?: 'ConductorGenericSensorHumidity';
      timestamp?: number | null;
      value?: number | null;
      units?: string | null;
    } | null;
    setpoint?: {
      __typename?: 'ConductorGenericSensorSetpoint';
      timestamp?: number | null;
      value?: number | null;
      units?: string | null;
    } | null;
    systemMode?: {
      __typename?: 'ConductorGenericSensorSystemMode';
      timestamp?: number | null;
      value?: number | null;
      units?: string | null;
    } | null;
    fanSpeed?: {
      __typename?: 'ConductorGenericSensorFanSpeed';
      timestamp?: number | null;
      value?: number | null;
      units?: string | null;
    } | null;
    alarmState?: {
      __typename?: 'ConductorGenericSensorAlarmState';
      timestamp?: number | null;
      value?: boolean | null;
      units?: string | null;
    } | null;
  } | null;
};

export type ConductorGenericSensorDetailQueryVariables = Exact<{
  id: Scalars['String'];
}>;

export type ConductorGenericSensorDetailQuery = {
  __typename?: 'Query';
  conductorGenericSensorById?: {
    __typename?: 'ConductorGenericSensor';
    _id: string;
    type?: EnumDKeyDeviceType | null;
    typeDisplayName: string;
    zoneId?: string | null;
    name?: string | null;
    deviceId?: string | null;
    sourceId?: string | null;
    timestamp?: number | null;
    isConfigured?: boolean | null;
    displayName?: string | null;
    supportsResetCounters?: boolean | null;
    meta?: {
      __typename?: 'DeviceMeta';
      name?: string | null;
      model?: string | null;
      modelNumber?: string | null;
      version?: string | null;
      metrics?: any | null;
    } | null;
    zone?: { __typename?: 'Zone'; _id: string; name: string } | null;
    source?: { __typename?: 'Source'; _id: string; name: string } | null;
    counterValue?: {
      __typename?: 'ConductorGenericSensorCounterValue';
      timestamp?: number | null;
      value?: number | null;
      units?: string | null;
    } | null;
    resetCount?: {
      __typename?: 'ConductorGenericSensorResetCount';
      timestamp?: number | null;
      value?: number | null;
      units?: string | null;
    } | null;
    temperature?: {
      __typename?: 'ConductorGenericSensorTemperature';
      timestamp?: number | null;
      value?: number | null;
      units?: string | null;
    } | null;
    humidity?: {
      __typename?: 'ConductorGenericSensorHumidity';
      timestamp?: number | null;
      value?: number | null;
      units?: string | null;
    } | null;
    setpoint?: {
      __typename?: 'ConductorGenericSensorSetpoint';
      timestamp?: number | null;
      value?: number | null;
      units?: string | null;
    } | null;
    systemMode?: {
      __typename?: 'ConductorGenericSensorSystemMode';
      timestamp?: number | null;
      value?: number | null;
      units?: string | null;
    } | null;
    fanSpeed?: {
      __typename?: 'ConductorGenericSensorFanSpeed';
      timestamp?: number | null;
      value?: number | null;
      units?: string | null;
    } | null;
    alarmState?: {
      __typename?: 'ConductorGenericSensorAlarmState';
      timestamp?: number | null;
      value?: boolean | null;
      units?: string | null;
    } | null;
  } | null;
};

export type ResetConductorGenericSensorCountersMutationVariables = Exact<{
  deviceId: Scalars['String'];
}>;

export type ResetConductorGenericSensorCountersMutation = {
  __typename?: 'Mutation';
  resetConductorGenericSensorCounters: {
    __typename?: 'Device';
    _id: string;
    type?: EnumDKeyDeviceType | null;
  };
};

export type DoorSensorDetailUpdateSubscriptionVariables = Exact<{
  ids: Array<Scalars['String']> | Scalars['String'];
}>;

export type DoorSensorDetailUpdateSubscription = {
  __typename?: 'Subscription';
  doorSensorEventsByIds?: {
    __typename?: 'DoorSensor';
    modelChangeOperation?: string | null;
    _id: string;
    type?: EnumDKeyDeviceType | null;
    typeDisplayName: string;
    zoneId?: string | null;
    name?: string | null;
    deviceId?: string | null;
    isConfigured?: boolean | null;
    timestamp?: number | null;
    hasContactState?: boolean | null;
    meta?: {
      __typename?: 'DeviceMeta';
      name?: string | null;
      model?: string | null;
      modelNumber?: string | null;
      version?: string | null;
    } | null;
    contactState?: {
      __typename?: 'DoorSensorContactState';
      timestamp?: number | null;
      value?: string | null;
      units?: string | null;
    } | null;
    voltage?: {
      __typename?: 'DoorSensorVoltage';
      timestamp?: number | null;
      value?: number | null;
      units?: string | null;
    } | null;
    alertTypes?: {
      __typename?: 'DeviceAlertTypes';
      deviceAlert?: boolean | null;
    } | null;
    deviceAlerts: Array<{
      __typename?: 'Alert';
      _id: string;
      initiated?: number | null;
      updated?: number | null;
      type?: { __typename?: 'AlertType'; name?: string | null } | null;
      device?: {
        __typename?: 'AlertDevice';
        id: string;
        name?: string | null;
        type: string;
      } | null;
    } | null>;
    sourceAlerts: Array<{
      __typename?: 'Alert';
      _id: string;
      initiated?: number | null;
      updated?: number | null;
      type?: { __typename?: 'AlertType'; name?: string | null } | null;
      device?: {
        __typename?: 'AlertDevice';
        id: string;
        name?: string | null;
        type: string;
      } | null;
    } | null>;
  } | null;
};

export type DoorSensorDetailQueryVariables = Exact<{
  id: Scalars['String'];
}>;

export type DoorSensorDetailQuery = {
  __typename?: 'Query';
  doorSensorById?: {
    __typename?: 'DoorSensor';
    _id: string;
    type?: EnumDKeyDeviceType | null;
    typeDisplayName: string;
    zoneId?: string | null;
    name?: string | null;
    deviceId?: string | null;
    isConfigured?: boolean | null;
    timestamp?: number | null;
    hasContactState?: boolean | null;
    meta?: {
      __typename?: 'DeviceMeta';
      name?: string | null;
      model?: string | null;
      modelNumber?: string | null;
      version?: string | null;
    } | null;
    zone?: { __typename?: 'Zone'; _id: string; name: string } | null;
    source?: { __typename?: 'Source'; _id: string; name: string } | null;
    contactState?: {
      __typename?: 'DoorSensorContactState';
      timestamp?: number | null;
      value?: string | null;
      units?: string | null;
    } | null;
    voltage?: {
      __typename?: 'DoorSensorVoltage';
      timestamp?: number | null;
      value?: number | null;
      units?: string | null;
    } | null;
    alertTypes?: {
      __typename?: 'DeviceAlertTypes';
      deviceAlert?: boolean | null;
    } | null;
    deviceAlerts: Array<{
      __typename?: 'Alert';
      _id: string;
      initiated?: number | null;
      updated?: number | null;
      type?: { __typename?: 'AlertType'; name?: string | null } | null;
      device?: {
        __typename?: 'AlertDevice';
        id: string;
        name?: string | null;
        type: string;
      } | null;
    } | null>;
    sourceAlerts: Array<{
      __typename?: 'Alert';
      _id: string;
      initiated?: number | null;
      updated?: number | null;
      type?: { __typename?: 'AlertType'; name?: string | null } | null;
      device?: {
        __typename?: 'AlertDevice';
        id: string;
        name?: string | null;
        type: string;
      } | null;
    } | null>;
  } | null;
};

export type IndoorAirHandlerDetailQueryVariables = Exact<{
  id: Scalars['String'];
}>;

export type IndoorAirHandlerDetailQuery = {
  __typename?: 'Query';
  indoorAirHandlerById?: {
    __typename?: 'IndoorAirHandler';
    _id: string;
    type?: EnumDKeyDeviceType | null;
    typeDisplayName: string;
    panelId?: string | null;
    name?: string | null;
    deviceId?: string | null;
    timestamp?: number | null;
    isConfigured?: boolean | null;
    meta?: {
      __typename?: 'DeviceMeta';
      name?: string | null;
      model?: string | null;
      modelNumber?: string | null;
      version?: string | null;
    } | null;
    zone?: { __typename?: 'Zone'; _id: string; name: string } | null;
    source?: { __typename?: 'Source'; _id: string; name: string } | null;
    fanSpeed?: {
      __typename?: 'IndoorAirHandlerFanSpeed';
      timestamp?: number | null;
      value?: string | null;
      units?: string | null;
    } | null;
    maxCoolSetpointLimit?: {
      __typename?: 'IndoorAirHandlerMaxCoolSetpointLimit';
      timestamp?: number | null;
      value?: number | null;
      units?: string | null;
    } | null;
    maxHeatSetpointLimit?: {
      __typename?: 'IndoorAirHandlerMaxHeatSetpointLimit';
      timestamp?: number | null;
      value?: number | null;
      units?: string | null;
    } | null;
    minCoolSetpointLimit?: {
      __typename?: 'IndoorAirHandlerMinCoolSetpointLimit';
      timestamp?: number | null;
      value?: number | null;
      units?: string | null;
    } | null;
    minHeatSetpointLimit?: {
      __typename?: 'IndoorAirHandlerMinHeatSetpointLimit';
      timestamp?: number | null;
      value?: number | null;
      units?: string | null;
    } | null;
    operatingMode?: {
      __typename?: 'IndoorAirHandlerOperatingMode';
      timestamp?: number | null;
      value?: string | null;
      units?: string | null;
    } | null;
    indoorFanStatus?: {
      __typename?: 'IndoorAirHandlerIndoorFanStatus';
      timestamp?: number | null;
      value?: EnumIndoorAirHandlerIndoorFanStatusValue | null;
      units?: string | null;
    } | null;
    operatingState?: {
      __typename?: 'IndoorAirHandlerOperatingState';
      timestamp?: number | null;
      value?: string | null;
      units?: string | null;
    } | null;
    temperature?: {
      __typename?: 'IndoorAirHandlerTemperature';
      timestamp?: number | null;
      value?: number | null;
      units?: string | null;
    } | null;
    heatSetpoint?: {
      __typename?: 'IndoorAirHandlerHeatSetpoint';
      timestamp?: number | null;
      value?: number | null;
      units?: string | null;
    } | null;
    coolSetpoint?: {
      __typename?: 'IndoorAirHandlerCoolSetpoint';
      timestamp?: number | null;
      value?: number | null;
      units?: string | null;
    } | null;
    deviceAlerts: Array<{
      __typename?: 'Alert';
      _id: string;
      initiated?: number | null;
      updated?: number | null;
      type?: { __typename?: 'AlertType'; name?: string | null } | null;
      device?: {
        __typename?: 'AlertDevice';
        id: string;
        name?: string | null;
        type: string;
      } | null;
    } | null>;
    sourceAlerts: Array<{
      __typename?: 'Alert';
      _id: string;
      initiated?: number | null;
      updated?: number | null;
      type?: { __typename?: 'AlertType'; name?: string | null } | null;
      device?: {
        __typename?: 'AlertDevice';
        id: string;
        name?: string | null;
        type: string;
      } | null;
    } | null>;
  } | null;
};

export type IndoorSensorDetailUpdateSubscriptionVariables = Exact<{
  ids: Array<Scalars['String']> | Scalars['String'];
}>;

export type IndoorSensorDetailUpdateSubscription = {
  __typename?: 'Subscription';
  indoorSensorEventsByIds?: {
    __typename?: 'IndoorSensor';
    modelChangeOperation?: string | null;
    _id: string;
    type?: EnumDKeyDeviceType | null;
    typeDisplayName: string;
    zoneId?: string | null;
    name?: string | null;
    deviceId?: string | null;
    sourceId?: string | null;
    timestamp?: number | null;
    isConfigured?: boolean | null;
    meta?: {
      __typename?: 'DeviceMeta';
      name?: string | null;
      model?: string | null;
      modelNumber?: string | null;
      version?: string | null;
      display?: {
        __typename?: 'DeviceMetaDisplay';
        temperature?: number | null;
        humidity?: number | null;
      } | null;
    } | null;
    temperature?: {
      __typename?: 'IndoorSensorTemperature';
      timestamp?: number | null;
      value?: number | null;
      units?: string | null;
    } | null;
    humidity?: {
      __typename?: 'IndoorSensorHumidity';
      timestamp?: number | null;
      value?: number | null;
      units?: string | null;
    } | null;
    voltage?: {
      __typename?: 'IndoorSensorVoltage';
      timestamp?: number | null;
      value?: number | null;
      units?: string | null;
    } | null;
    deviceAlerts: Array<{
      __typename?: 'Alert';
      _id: string;
      initiated?: number | null;
      updated?: number | null;
      type?: { __typename?: 'AlertType'; name?: string | null } | null;
      device?: {
        __typename?: 'AlertDevice';
        id: string;
        name?: string | null;
        type: string;
      } | null;
    } | null>;
    sourceAlerts: Array<{
      __typename?: 'Alert';
      _id: string;
      initiated?: number | null;
      updated?: number | null;
      type?: { __typename?: 'AlertType'; name?: string | null } | null;
      device?: {
        __typename?: 'AlertDevice';
        id: string;
        name?: string | null;
        type: string;
      } | null;
    } | null>;
  } | null;
};

export type IndoorSensorDetailQueryVariables = Exact<{
  id: Scalars['String'];
}>;

export type IndoorSensorDetailQuery = {
  __typename?: 'Query';
  indoorSensorById?: {
    __typename?: 'IndoorSensor';
    _id: string;
    type?: EnumDKeyDeviceType | null;
    typeDisplayName: string;
    zoneId?: string | null;
    name?: string | null;
    deviceId?: string | null;
    sourceId?: string | null;
    timestamp?: number | null;
    isConfigured?: boolean | null;
    meta?: {
      __typename?: 'DeviceMeta';
      name?: string | null;
      model?: string | null;
      modelNumber?: string | null;
      version?: string | null;
      display?: {
        __typename?: 'DeviceMetaDisplay';
        temperature?: number | null;
        humidity?: number | null;
      } | null;
    } | null;
    zone?: { __typename?: 'Zone'; _id: string; name: string } | null;
    source?: { __typename?: 'Source'; _id: string; name: string } | null;
    temperature?: {
      __typename?: 'IndoorSensorTemperature';
      timestamp?: number | null;
      value?: number | null;
      units?: string | null;
    } | null;
    humidity?: {
      __typename?: 'IndoorSensorHumidity';
      timestamp?: number | null;
      value?: number | null;
      units?: string | null;
    } | null;
    voltage?: {
      __typename?: 'IndoorSensorVoltage';
      timestamp?: number | null;
      value?: number | null;
      units?: string | null;
    } | null;
    deviceAlerts: Array<{
      __typename?: 'Alert';
      _id: string;
      initiated?: number | null;
      updated?: number | null;
      type?: { __typename?: 'AlertType'; name?: string | null } | null;
      device?: {
        __typename?: 'AlertDevice';
        id: string;
        name?: string | null;
        type: string;
      } | null;
    } | null>;
    sourceAlerts: Array<{
      __typename?: 'Alert';
      _id: string;
      initiated?: number | null;
      updated?: number | null;
      type?: { __typename?: 'AlertType'; name?: string | null } | null;
      device?: {
        __typename?: 'AlertDevice';
        id: string;
        name?: string | null;
        type: string;
      } | null;
    } | null>;
  } | null;
};

export type LeakDetectorDetailUpdateSubscriptionVariables = Exact<{
  ids: Array<Scalars['String']> | Scalars['String'];
}>;

export type LeakDetectorDetailUpdateSubscription = {
  __typename?: 'Subscription';
  leakDetectorEventsByIds?: {
    __typename?: 'LeakDetector';
    modelChangeOperation?: string | null;
    _id: string;
    type?: EnumDKeyDeviceType | null;
    typeDisplayName: string;
    panelId?: string | null;
    name?: string | null;
    deviceId?: string | null;
    timestamp?: number | null;
    isConfigured?: boolean | null;
    meta?: {
      __typename?: 'DeviceMeta';
      name?: string | null;
      model?: string | null;
      modelNumber?: string | null;
      version?: string | null;
    } | null;
    batteryVoltageMinThreshold?: {
      __typename?: 'LeakDetectorBatteryVoltageMinThreshold';
      timestamp?: number | null;
      value?: number | null;
      units?: string | null;
    } | null;
    batteryVoltageMinThresholdReached?: {
      __typename?: 'LeakDetectorBatteryVoltageMinThresholdReached';
      timestamp?: number | null;
      value?: boolean | null;
      units?: string | null;
    } | null;
    leakStatus1?: {
      __typename?: 'LeakDetectorLeakStatus1';
      timestamp?: number | null;
      value?: boolean | null;
      units?: string | null;
    } | null;
    leakStatus2?: {
      __typename?: 'LeakDetectorLeakStatus2';
      timestamp?: number | null;
      value?: boolean | null;
      units?: string | null;
    } | null;
    voltage?: {
      __typename?: 'LeakDetectorVoltage';
      timestamp?: number | null;
      value?: number | null;
      units?: string | null;
    } | null;
    deviceAlerts: Array<{
      __typename?: 'Alert';
      _id: string;
      initiated?: number | null;
      updated?: number | null;
      type?: { __typename?: 'AlertType'; name?: string | null } | null;
      device?: {
        __typename?: 'AlertDevice';
        id: string;
        name?: string | null;
        type: string;
      } | null;
    } | null>;
    sourceAlerts: Array<{
      __typename?: 'Alert';
      _id: string;
      initiated?: number | null;
      updated?: number | null;
      type?: { __typename?: 'AlertType'; name?: string | null } | null;
      device?: {
        __typename?: 'AlertDevice';
        id: string;
        name?: string | null;
        type: string;
      } | null;
    } | null>;
  } | null;
};

export type LeakDetectorDetailQueryVariables = Exact<{
  id: Scalars['String'];
}>;

export type LeakDetectorDetailQuery = {
  __typename?: 'Query';
  leakDetectorById?: {
    __typename?: 'LeakDetector';
    _id: string;
    type?: EnumDKeyDeviceType | null;
    typeDisplayName: string;
    panelId?: string | null;
    name?: string | null;
    deviceId?: string | null;
    timestamp?: number | null;
    isConfigured?: boolean | null;
    meta?: {
      __typename?: 'DeviceMeta';
      name?: string | null;
      model?: string | null;
      modelNumber?: string | null;
      version?: string | null;
    } | null;
    zone?: { __typename?: 'Zone'; _id: string; name: string } | null;
    source?: { __typename?: 'Source'; _id: string; name: string } | null;
    batteryVoltageMinThreshold?: {
      __typename?: 'LeakDetectorBatteryVoltageMinThreshold';
      timestamp?: number | null;
      value?: number | null;
      units?: string | null;
    } | null;
    batteryVoltageMinThresholdReached?: {
      __typename?: 'LeakDetectorBatteryVoltageMinThresholdReached';
      timestamp?: number | null;
      value?: boolean | null;
      units?: string | null;
    } | null;
    leakStatus1?: {
      __typename?: 'LeakDetectorLeakStatus1';
      timestamp?: number | null;
      value?: boolean | null;
      units?: string | null;
    } | null;
    leakStatus2?: {
      __typename?: 'LeakDetectorLeakStatus2';
      timestamp?: number | null;
      value?: boolean | null;
      units?: string | null;
    } | null;
    voltage?: {
      __typename?: 'LeakDetectorVoltage';
      timestamp?: number | null;
      value?: number | null;
      units?: string | null;
    } | null;
    deviceAlerts: Array<{
      __typename?: 'Alert';
      _id: string;
      initiated?: number | null;
      updated?: number | null;
      type?: { __typename?: 'AlertType'; name?: string | null } | null;
      device?: {
        __typename?: 'AlertDevice';
        id: string;
        name?: string | null;
        type: string;
      } | null;
    } | null>;
    sourceAlerts: Array<{
      __typename?: 'Alert';
      _id: string;
      initiated?: number | null;
      updated?: number | null;
      type?: { __typename?: 'AlertType'; name?: string | null } | null;
      device?: {
        __typename?: 'AlertDevice';
        id: string;
        name?: string | null;
        type: string;
      } | null;
    } | null>;
  } | null;
};

export type ModbusAirHandlerDetailUpdateSubscriptionVariables = Exact<{
  ids: Array<Scalars['String']> | Scalars['String'];
}>;

export type ModbusAirHandlerDetailUpdateSubscription = {
  __typename?: 'Subscription';
  modbusAirHandlerEventsByIds?: {
    __typename: 'ModbusAirHandler';
    modelChangeOperation?: string | null;
    _id: string;
    zoneId?: string | null;
    panelId?: string | null;
    sourceId?: string | null;
    deviceId?: string | null;
    name?: string | null;
    type?: EnumDKeyDeviceType | null;
    typeDisplayName: string;
    hasPendingUpdates: boolean;
    timestamp?: number | null;
    zone?: {
      __typename?: 'Zone';
      _id: string;
      name: string;
      hasPairedSensor?: boolean | null;
    } | null;
    source?: { __typename?: 'Source'; _id: string; name: string } | null;
    meta?: {
      __typename?: 'DeviceMeta';
      name?: string | null;
      model?: string | null;
      modelNumber?: string | null;
      version?: string | null;
      display?: {
        __typename?: 'DeviceMetaDisplay';
        temperature?: number | null;
        humidity?: number | null;
      } | null;
    } | null;
    deviceMetrics?: Array<{
      __typename?: 'DeviceMetric';
      key: string;
      value: {
        __typename?: 'DeviceMetricSpec';
        defaultValue?: string | null;
        defaultUnit?: string | null;
        readOnly?: boolean | null;
        streamId?: string | null;
        timestamp?: string | null;
        unit?: string | null;
        units?: string | null;
        value?: string | null;
        valueType?: string | null;
        description?: string | null;
      };
    } | null> | null;
    alarmGlobalAlarm?: {
      __typename?: 'ModbusAirHandlerAlarmGlobalAlarm';
      timestamp?: number | null;
      value?: boolean | null;
      units?: string | null;
    } | null;
    alarmLowPressure?: {
      __typename?: 'ModbusAirHandlerAlarmLowPressure';
      timestamp?: number | null;
      value?: boolean | null;
      units?: string | null;
    } | null;
    alarmHighPressure?: {
      __typename?: 'ModbusAirHandlerAlarmHighPressure';
      timestamp?: number | null;
      value?: boolean | null;
      units?: string | null;
    } | null;
    alarmChangeFilters?: {
      __typename?: 'ModbusAirHandlerAlarmChangeFilters';
      timestamp?: number | null;
      value?: boolean | null;
      units?: string | null;
    } | null;
    alarmChangeHepa?: {
      __typename?: 'ModbusAirHandlerAlarmChangeHepa';
      timestamp?: number | null;
      value?: boolean | null;
      units?: string | null;
    } | null;
    alarmAirRestriction?: {
      __typename?: 'ModbusAirHandlerAlarmAirRestriction';
      timestamp?: number | null;
      value?: boolean | null;
      units?: string | null;
    } | null;
    alarmSupplyFanStopped?: {
      __typename?: 'ModbusAirHandlerAlarmSupplyFanStopped';
      timestamp?: number | null;
      value?: boolean | null;
      units?: string | null;
    } | null;
    alarmExhaustFanStopped?: {
      __typename?: 'ModbusAirHandlerAlarmExhaustFanStopped';
      timestamp?: number | null;
      value?: boolean | null;
      units?: string | null;
    } | null;
    alarmRefrigerantLeak?: {
      __typename?: 'ModbusAirHandlerAlarmRefrigerantLeak';
      timestamp?: number | null;
      value?: boolean | null;
      units?: string | null;
    } | null;
    alarmCompressorFail?: {
      __typename?: 'ModbusAirHandlerAlarmCompressorFail';
      timestamp?: number | null;
      value?: boolean | null;
      units?: string | null;
    } | null;
    alarmFanANegPressureOpt1?: {
      __typename?: 'ModbusAirHandlerAlarmFanANegPressureOpt1';
      timestamp?: number | null;
      value?: boolean | null;
      units?: string | null;
    } | null;
    alarmFanANegPressureOpt2?: {
      __typename?: 'ModbusAirHandlerAlarmFanANegPressureOpt2';
      timestamp?: number | null;
      value?: boolean | null;
      units?: string | null;
    } | null;
    alarmFanABReversed?: {
      __typename?: 'ModbusAirHandlerAlarmFanABReversed';
      timestamp?: number | null;
      value?: boolean | null;
      units?: string | null;
    } | null;
    alarmClockBoard?: {
      __typename?: 'ModbusAirHandlerAlarmClockBoard';
      timestamp?: number | null;
      value?: boolean | null;
      units?: string | null;
    } | null;
    alarmExtendedMemory?: {
      __typename?: 'ModbusAirHandlerAlarmExtendedMemory';
      timestamp?: number | null;
      value?: boolean | null;
      units?: string | null;
    } | null;
    alarmB1SensorFail?: {
      __typename?: 'ModbusAirHandlerAlarmB1SensorFail';
      timestamp?: number | null;
      value?: boolean | null;
      units?: string | null;
    } | null;
    alarmB2SensorFail?: {
      __typename?: 'ModbusAirHandlerAlarmB2SensorFail';
      timestamp?: number | null;
      value?: boolean | null;
      units?: string | null;
    } | null;
    alarmB3SensorFail?: {
      __typename?: 'ModbusAirHandlerAlarmB3SensorFail';
      timestamp?: number | null;
      value?: boolean | null;
      units?: string | null;
    } | null;
    alarmB4SensorFail?: {
      __typename?: 'ModbusAirHandlerAlarmB4SensorFail';
      timestamp?: number | null;
      value?: boolean | null;
      units?: string | null;
    } | null;
    alarmB6SensorFail?: {
      __typename?: 'ModbusAirHandlerAlarmB6SensorFail';
      timestamp?: number | null;
      value?: boolean | null;
      units?: string | null;
    } | null;
    zmbGlobalAlarm?: {
      __typename?: 'ModbusAirHandlerZmbGlobalAlarm';
      timestamp?: number | null;
      value?: boolean | null;
      units?: string | null;
    } | null;
    zmbThermostatAlarm?: {
      __typename?: 'ModbusAirHandlerZmbThermostatAlarm';
      timestamp?: number | null;
      value?: boolean | null;
      units?: string | null;
    } | null;
    zmbAirHandlerAlarm?: {
      __typename?: 'ModbusAirHandlerZmbAirHandlerAlarm';
      timestamp?: number | null;
      value?: boolean | null;
      units?: string | null;
    } | null;
    zmbLeakDetected?: {
      __typename?: 'ModbusAirHandlerZmbLeakDetected';
      timestamp?: number | null;
      value?: boolean | null;
      units?: string | null;
    } | null;
    ventilationMode?: {
      __typename?: 'ModbusAirHandlerVentilationMode';
      timestamp?: number | null;
      value?: string | null;
      units?: string | null;
    } | null;
    damperPosition?: {
      __typename?: 'ModbusAirHandlerDamperPosition';
      timestamp?: number | null;
      value?: string | null;
      units?: string | null;
    } | null;
    reversibleValveOnWhen?: {
      __typename?: 'ModbusAirHandlerReversibleValveOnWhen';
      timestamp?: number | null;
      value?: string | null;
      units?: string | null;
    } | null;
    recirculationModeOn?: {
      __typename?: 'ModbusAirHandlerRecirculationModeOn';
      timestamp?: number | null;
      value?: boolean | null;
      units?: string | null;
    } | null;
    airExchangeModeOn?: {
      __typename?: 'ModbusAirHandlerAirExchangeModeOn';
      timestamp?: number | null;
      value?: boolean | null;
      units?: string | null;
    } | null;
    supplyFanOn?: {
      __typename?: 'ModbusAirHandlerSupplyFanOn';
      timestamp?: number | null;
      value?: boolean | null;
      units?: string | null;
    } | null;
    supplyFanAirflow?: {
      __typename?: 'ModbusAirHandlerSupplyFanAirflow';
      timestamp?: number | null;
      value?: number | null;
      units?: string | null;
    } | null;
    supplyFanStaticPressureH2O?: {
      __typename?: 'ModbusAirHandlerSupplyFanStaticPressureH2O';
      timestamp?: number | null;
      value?: number | null;
      units?: string | null;
    } | null;
    exhaustFanOn?: {
      __typename?: 'ModbusAirHandlerExhaustFanOn';
      timestamp?: number | null;
      value?: boolean | null;
      units?: string | null;
    } | null;
    exhaustFanAirflow?: {
      __typename?: 'ModbusAirHandlerExhaustFanAirflow';
      timestamp?: number | null;
      value?: number | null;
      units?: string | null;
    } | null;
    systemOnOff?: {
      __typename?: 'ModbusAirHandlerSystemOnOff';
      timestamp?: number | null;
      value?: string | null;
      units?: string | null;
    } | null;
    systemAutoMode?: {
      __typename?: 'ModbusAirHandlerSystemAutoMode';
      timestamp?: number | null;
      value?: string | null;
      units?: string | null;
    } | null;
    heatPumpModeOn?: {
      __typename?: 'ModbusAirHandlerHeatPumpModeOn';
      timestamp?: number | null;
      value?: boolean | null;
      units?: string | null;
    } | null;
    heatingElementOn?: {
      __typename?: 'ModbusAirHandlerHeatingElementOn';
      timestamp?: number | null;
      value?: boolean | null;
      units?: string | null;
    } | null;
    compressorOn?: {
      __typename?: 'ModbusAirHandlerCompressorOn';
      timestamp?: number | null;
      value?: boolean | null;
      units?: string | null;
    } | null;
    indoorTemperature?: {
      __typename?: 'ModbusAirHandlerIndoorTemperature';
      timestamp?: number | null;
      value?: number | null;
      units?: string | null;
    } | null;
    outsideTemperature?: {
      __typename?: 'ModbusAirHandlerOutsideTemperature';
      timestamp?: number | null;
      value?: number | null;
      units?: string | null;
    } | null;
    indoorRH?: {
      __typename?: 'ModbusAirHandlerIndoorRH';
      timestamp?: number | null;
      value?: number | null;
      units?: string | null;
    } | null;
    defrostTemperature?: {
      __typename?: 'ModbusAirHandlerDefrostTemperature';
      timestamp?: number | null;
      value?: number | null;
      units?: string | null;
    } | null;
    conditionedTemperature?: {
      __typename?: 'ModbusAirHandlerConditionedTemperature';
      timestamp?: number | null;
      value?: number | null;
      units?: string | null;
    } | null;
    ahuCoolSetpoint?: {
      __typename?: 'ModbusAirHandlerAhuCoolSetpoint';
      timestamp?: number | null;
      value?: number | null;
      units?: string | null;
    } | null;
    ahuHeatSetpoint?: {
      __typename?: 'ModbusAirHandlerAhuHeatSetpoint';
      timestamp?: number | null;
      value?: number | null;
      units?: string | null;
    } | null;
    ahuMinCoolSetpointLimit?: {
      __typename?: 'ModbusAirHandlerAhuMinCoolSetpointLimit';
      timestamp?: number | null;
      value?: number | null;
      units?: string | null;
    } | null;
    ahuMaxHeatSetpointLimit?: {
      __typename?: 'ModbusAirHandlerAhuMaxHeatSetpointLimit';
      timestamp?: number | null;
      value?: number | null;
      units?: string | null;
    } | null;
    gTerminalOn?: {
      __typename?: 'ModbusAirHandlerGTerminalOn';
      timestamp?: number | null;
      value?: boolean | null;
      units?: string | null;
    } | null;
    hTerminalOn?: {
      __typename?: 'ModbusAirHandlerHTerminalOn';
      timestamp?: number | null;
      value?: boolean | null;
      units?: string | null;
    } | null;
    wTerminalOn?: {
      __typename?: 'ModbusAirHandlerWTerminalOn';
      timestamp?: number | null;
      value?: boolean | null;
      units?: string | null;
    } | null;
    yTerminalOn?: {
      __typename?: 'ModbusAirHandlerYTerminalOn';
      timestamp?: number | null;
      value?: boolean | null;
      units?: string | null;
    } | null;
    softwareReleaseType?: {
      __typename?: 'ModbusAirHandlerSoftwareReleaseType';
      timestamp?: number | null;
      value?: string | null;
      units?: string | null;
    } | null;
    softwareVersion?: {
      __typename?: 'ModbusAirHandlerSoftwareVersion';
      timestamp?: number | null;
      value?: number | null;
      units?: string | null;
    } | null;
    bootVersion?: {
      __typename?: 'ModbusAirHandlerBootVersion';
      timestamp?: number | null;
      value?: number | null;
      units?: string | null;
    } | null;
    biosVersion?: {
      __typename?: 'ModbusAirHandlerBiosVersion';
      timestamp?: number | null;
      value?: number | null;
      units?: string | null;
    } | null;
    allowTenantOnOff?: {
      __typename?: 'ModbusAirHandlerAllowTenantOnOff';
      timestamp?: number | null;
      value?: boolean | null;
      units?: string | null;
    } | null;
    enableTenantMode?: {
      __typename?: 'ModbusAirHandlerEnableTenantMode';
      timestamp?: number | null;
      value?: boolean | null;
      units?: string | null;
    } | null;
    allowTenantChangeRHSetpoint?: {
      __typename?: 'ModbusAirHandlerAllowTenantChangeRHSetpoint';
      timestamp?: number | null;
      value?: boolean | null;
      units?: string | null;
    } | null;
    allowTenantChangeTempSetpoints?: {
      __typename?: 'ModbusAirHandlerAllowTenantChangeTempSetpoints';
      timestamp?: number | null;
      value?: boolean | null;
      units?: string | null;
    } | null;
    tenantModePassword?: {
      __typename?: 'ModbusAirHandlerTenantModePassword';
      timestamp?: number | null;
      value?: string | null;
      units?: string | null;
    } | null;
    airflowUnits?: {
      __typename?: 'ModbusAirHandlerAirflowUnits';
      timestamp?: number | null;
      value?: string | null;
      units?: string | null;
    } | null;
    ahuModbusId?: {
      __typename?: 'ModbusAirHandlerAhuModbusId';
      timestamp?: number | null;
      value?: number | null;
      units?: string | null;
    } | null;
    altitude?: {
      __typename?: 'ModbusAirHandlerAltitude';
      timestamp?: number | null;
      value?: number | null;
      units?: string | null;
    } | null;
    freshAirSetpoint?: {
      __typename?: 'ModbusAirHandlerFreshAirSetpoint';
      timestamp?: number | null;
      value?: number | null;
      units?: string | null;
    } | null;
    rhSetpoint?: {
      __typename?: 'ModbusAirHandlerRhSetpoint';
      timestamp?: number | null;
      value?: number | null;
      units?: string | null;
    } | null;
    auxCoolingEnabled?: {
      __typename?: 'ModbusAirHandlerAuxCoolingEnabled';
      timestamp?: number | null;
      value?: boolean | null;
      units?: string | null;
    } | null;
    winterRhAdjustEnabled?: {
      __typename?: 'ModbusAirHandlerWinterRhAdjustEnabled';
      timestamp?: number | null;
      value?: boolean | null;
      units?: string | null;
    } | null;
    showerDetectorEnabled?: {
      __typename?: 'ModbusAirHandlerShowerDetectorEnabled';
      timestamp?: number | null;
      value?: boolean | null;
      units?: string | null;
    } | null;
    resetFiltersServiceTime?: {
      __typename?: 'ModbusAirHandlerResetFiltersServiceTime';
      timestamp?: number | null;
      value?: string | null;
      units?: string | null;
    } | null;
    resetHepaServiceTime?: {
      __typename?: 'ModbusAirHandlerResetHepaServiceTime';
      timestamp?: number | null;
      value?: string | null;
      units?: string | null;
    } | null;
    zmbPollingFrequency?: {
      __typename?: 'ModbusAirHandlerZmbPollingFrequency';
      timestamp?: number | null;
      value?: number | null;
      units?: string | null;
    } | null;
    zmbModbusRequestDelay?: {
      __typename?: 'ModbusAirHandlerZmbModbusRequestDelay';
      timestamp?: number | null;
      value?: number | null;
      units?: string | null;
    } | null;
    zmbFirmwareVersion?: {
      __typename?: 'ModbusAirHandlerZmbFirmwareVersion';
      timestamp?: number | null;
      value?: string | null;
      units?: string | null;
    } | null;
    zmbSystemUptime?: {
      __typename?: 'ModbusAirHandlerZmbSystemUptime';
      timestamp?: number | null;
      value?: number | null;
      units?: string | null;
    } | null;
    zmbTstatRequestsRecvd?: {
      __typename?: 'ModbusAirHandlerZmbTstatRequestsRecvd';
      timestamp?: number | null;
      value?: number | null;
      units?: string | null;
    } | null;
    zmbRequestsRecvdInvalid?: {
      __typename?: 'ModbusAirHandlerZmbRequestsRecvdInvalid';
      timestamp?: number | null;
      value?: number | null;
      units?: string | null;
    } | null;
    zmbAhuRequestsSent?: {
      __typename?: 'ModbusAirHandlerZmbAhuRequestsSent';
      timestamp?: number | null;
      value?: number | null;
      units?: string | null;
    } | null;
    zmbAhuRequestsSentFailed?: {
      __typename?: 'ModbusAirHandlerZmbAhuRequestsSentFailed';
      timestamp?: number | null;
      value?: number | null;
      units?: string | null;
    } | null;
    zmbCoreRequestsRecvd?: {
      __typename?: 'ModbusAirHandlerZmbCoreRequestsRecvd';
      timestamp?: number | null;
      value?: number | null;
      units?: string | null;
    } | null;
    zmbLeakDetectorInstalled?: {
      __typename?: 'ModbusAirHandlerZmbLeakDetectorInstalled';
      timestamp?: number | null;
      value?: boolean | null;
      units?: string | null;
    } | null;
    zmbCpuTemperature?: {
      __typename?: 'ModbusAirHandlerZmbCpuTemperature';
      timestamp?: number | null;
      value?: number | null;
      units?: string | null;
    } | null;
    temperatureUnits?: {
      __typename?: 'ModbusAirHandlerTemperatureUnits';
      timestamp?: number | null;
      value?: string | null;
      units?: string | null;
    } | null;
    filtersServiceTime?: {
      __typename?: 'ModbusAirHandlerFiltersServiceTime';
      timestamp?: number | null;
      value?: number | null;
      units?: string | null;
    } | null;
    hepaServiceTime?: {
      __typename?: 'ModbusAirHandlerHepaServiceTime';
      timestamp?: number | null;
      value?: number | null;
      units?: string | null;
    } | null;
    deviceAlerts: Array<{
      __typename?: 'Alert';
      _id: string;
      initiated?: number | null;
      updated?: number | null;
      type?: {
        __typename?: 'AlertType';
        id?: string | null;
        name?: string | null;
      } | null;
      device?: {
        __typename?: 'AlertDevice';
        id: string;
        name?: string | null;
        type: string;
      } | null;
    } | null>;
    sourceAlerts: Array<{
      __typename?: 'Alert';
      _id: string;
      initiated?: number | null;
      updated?: number | null;
      type?: { __typename?: 'AlertType'; name?: string | null } | null;
      device?: {
        __typename?: 'AlertDevice';
        id: string;
        name?: string | null;
        type: string;
      } | null;
    } | null>;
    alertTypes?: {
      __typename?: 'DeviceAlertTypes';
      deviceOffline?: boolean | null;
      sourceOffline?: boolean | null;
    } | null;
  } | null;
};

export type ModbusAirHandlerDetailQueryVariables = Exact<{
  id: Scalars['String'];
}>;

export type ModbusAirHandlerDetailQuery = {
  __typename?: 'Query';
  modbusAirHandlerById?: {
    __typename: 'ModbusAirHandler';
    _id: string;
    zoneId?: string | null;
    panelId?: string | null;
    sourceId?: string | null;
    deviceId?: string | null;
    name?: string | null;
    type?: EnumDKeyDeviceType | null;
    typeDisplayName: string;
    hasPendingUpdates: boolean;
    timestamp?: number | null;
    alarmGlobalAlarm?: {
      __typename?: 'ModbusAirHandlerAlarmGlobalAlarm';
      timestamp?: number | null;
      value?: boolean | null;
      units?: string | null;
    } | null;
    alarmLowPressure?: {
      __typename?: 'ModbusAirHandlerAlarmLowPressure';
      timestamp?: number | null;
      value?: boolean | null;
      units?: string | null;
    } | null;
    alarmHighPressure?: {
      __typename?: 'ModbusAirHandlerAlarmHighPressure';
      timestamp?: number | null;
      value?: boolean | null;
      units?: string | null;
    } | null;
    alarmChangeFilters?: {
      __typename?: 'ModbusAirHandlerAlarmChangeFilters';
      timestamp?: number | null;
      value?: boolean | null;
      units?: string | null;
    } | null;
    alarmChangeHepa?: {
      __typename?: 'ModbusAirHandlerAlarmChangeHepa';
      timestamp?: number | null;
      value?: boolean | null;
      units?: string | null;
    } | null;
    alarmAirRestriction?: {
      __typename?: 'ModbusAirHandlerAlarmAirRestriction';
      timestamp?: number | null;
      value?: boolean | null;
      units?: string | null;
    } | null;
    alarmSupplyFanStopped?: {
      __typename?: 'ModbusAirHandlerAlarmSupplyFanStopped';
      timestamp?: number | null;
      value?: boolean | null;
      units?: string | null;
    } | null;
    alarmExhaustFanStopped?: {
      __typename?: 'ModbusAirHandlerAlarmExhaustFanStopped';
      timestamp?: number | null;
      value?: boolean | null;
      units?: string | null;
    } | null;
    alarmRefrigerantLeak?: {
      __typename?: 'ModbusAirHandlerAlarmRefrigerantLeak';
      timestamp?: number | null;
      value?: boolean | null;
      units?: string | null;
    } | null;
    alarmCompressorFail?: {
      __typename?: 'ModbusAirHandlerAlarmCompressorFail';
      timestamp?: number | null;
      value?: boolean | null;
      units?: string | null;
    } | null;
    alarmFanANegPressureOpt1?: {
      __typename?: 'ModbusAirHandlerAlarmFanANegPressureOpt1';
      timestamp?: number | null;
      value?: boolean | null;
      units?: string | null;
    } | null;
    alarmFanANegPressureOpt2?: {
      __typename?: 'ModbusAirHandlerAlarmFanANegPressureOpt2';
      timestamp?: number | null;
      value?: boolean | null;
      units?: string | null;
    } | null;
    alarmFanABReversed?: {
      __typename?: 'ModbusAirHandlerAlarmFanABReversed';
      timestamp?: number | null;
      value?: boolean | null;
      units?: string | null;
    } | null;
    alarmClockBoard?: {
      __typename?: 'ModbusAirHandlerAlarmClockBoard';
      timestamp?: number | null;
      value?: boolean | null;
      units?: string | null;
    } | null;
    alarmExtendedMemory?: {
      __typename?: 'ModbusAirHandlerAlarmExtendedMemory';
      timestamp?: number | null;
      value?: boolean | null;
      units?: string | null;
    } | null;
    alarmB1SensorFail?: {
      __typename?: 'ModbusAirHandlerAlarmB1SensorFail';
      timestamp?: number | null;
      value?: boolean | null;
      units?: string | null;
    } | null;
    alarmB2SensorFail?: {
      __typename?: 'ModbusAirHandlerAlarmB2SensorFail';
      timestamp?: number | null;
      value?: boolean | null;
      units?: string | null;
    } | null;
    alarmB3SensorFail?: {
      __typename?: 'ModbusAirHandlerAlarmB3SensorFail';
      timestamp?: number | null;
      value?: boolean | null;
      units?: string | null;
    } | null;
    alarmB4SensorFail?: {
      __typename?: 'ModbusAirHandlerAlarmB4SensorFail';
      timestamp?: number | null;
      value?: boolean | null;
      units?: string | null;
    } | null;
    alarmB6SensorFail?: {
      __typename?: 'ModbusAirHandlerAlarmB6SensorFail';
      timestamp?: number | null;
      value?: boolean | null;
      units?: string | null;
    } | null;
    zmbGlobalAlarm?: {
      __typename?: 'ModbusAirHandlerZmbGlobalAlarm';
      timestamp?: number | null;
      value?: boolean | null;
      units?: string | null;
    } | null;
    zmbThermostatAlarm?: {
      __typename?: 'ModbusAirHandlerZmbThermostatAlarm';
      timestamp?: number | null;
      value?: boolean | null;
      units?: string | null;
    } | null;
    zmbAirHandlerAlarm?: {
      __typename?: 'ModbusAirHandlerZmbAirHandlerAlarm';
      timestamp?: number | null;
      value?: boolean | null;
      units?: string | null;
    } | null;
    zmbLeakDetected?: {
      __typename?: 'ModbusAirHandlerZmbLeakDetected';
      timestamp?: number | null;
      value?: boolean | null;
      units?: string | null;
    } | null;
    ventilationMode?: {
      __typename?: 'ModbusAirHandlerVentilationMode';
      timestamp?: number | null;
      value?: string | null;
      units?: string | null;
    } | null;
    damperPosition?: {
      __typename?: 'ModbusAirHandlerDamperPosition';
      timestamp?: number | null;
      value?: string | null;
      units?: string | null;
    } | null;
    reversibleValveOnWhen?: {
      __typename?: 'ModbusAirHandlerReversibleValveOnWhen';
      timestamp?: number | null;
      value?: string | null;
      units?: string | null;
    } | null;
    recirculationModeOn?: {
      __typename?: 'ModbusAirHandlerRecirculationModeOn';
      timestamp?: number | null;
      value?: boolean | null;
      units?: string | null;
    } | null;
    airExchangeModeOn?: {
      __typename?: 'ModbusAirHandlerAirExchangeModeOn';
      timestamp?: number | null;
      value?: boolean | null;
      units?: string | null;
    } | null;
    supplyFanOn?: {
      __typename?: 'ModbusAirHandlerSupplyFanOn';
      timestamp?: number | null;
      value?: boolean | null;
      units?: string | null;
    } | null;
    supplyFanAirflow?: {
      __typename?: 'ModbusAirHandlerSupplyFanAirflow';
      timestamp?: number | null;
      value?: number | null;
      units?: string | null;
    } | null;
    supplyFanStaticPressureH2O?: {
      __typename?: 'ModbusAirHandlerSupplyFanStaticPressureH2O';
      timestamp?: number | null;
      value?: number | null;
      units?: string | null;
    } | null;
    exhaustFanOn?: {
      __typename?: 'ModbusAirHandlerExhaustFanOn';
      timestamp?: number | null;
      value?: boolean | null;
      units?: string | null;
    } | null;
    exhaustFanAirflow?: {
      __typename?: 'ModbusAirHandlerExhaustFanAirflow';
      timestamp?: number | null;
      value?: number | null;
      units?: string | null;
    } | null;
    systemOnOff?: {
      __typename?: 'ModbusAirHandlerSystemOnOff';
      timestamp?: number | null;
      value?: string | null;
      units?: string | null;
    } | null;
    systemAutoMode?: {
      __typename?: 'ModbusAirHandlerSystemAutoMode';
      timestamp?: number | null;
      value?: string | null;
      units?: string | null;
    } | null;
    heatPumpModeOn?: {
      __typename?: 'ModbusAirHandlerHeatPumpModeOn';
      timestamp?: number | null;
      value?: boolean | null;
      units?: string | null;
    } | null;
    heatingElementOn?: {
      __typename?: 'ModbusAirHandlerHeatingElementOn';
      timestamp?: number | null;
      value?: boolean | null;
      units?: string | null;
    } | null;
    compressorOn?: {
      __typename?: 'ModbusAirHandlerCompressorOn';
      timestamp?: number | null;
      value?: boolean | null;
      units?: string | null;
    } | null;
    indoorTemperature?: {
      __typename?: 'ModbusAirHandlerIndoorTemperature';
      timestamp?: number | null;
      value?: number | null;
      units?: string | null;
    } | null;
    outsideTemperature?: {
      __typename?: 'ModbusAirHandlerOutsideTemperature';
      timestamp?: number | null;
      value?: number | null;
      units?: string | null;
    } | null;
    indoorRH?: {
      __typename?: 'ModbusAirHandlerIndoorRH';
      timestamp?: number | null;
      value?: number | null;
      units?: string | null;
    } | null;
    defrostTemperature?: {
      __typename?: 'ModbusAirHandlerDefrostTemperature';
      timestamp?: number | null;
      value?: number | null;
      units?: string | null;
    } | null;
    conditionedTemperature?: {
      __typename?: 'ModbusAirHandlerConditionedTemperature';
      timestamp?: number | null;
      value?: number | null;
      units?: string | null;
    } | null;
    ahuCoolSetpoint?: {
      __typename?: 'ModbusAirHandlerAhuCoolSetpoint';
      timestamp?: number | null;
      value?: number | null;
      units?: string | null;
    } | null;
    ahuHeatSetpoint?: {
      __typename?: 'ModbusAirHandlerAhuHeatSetpoint';
      timestamp?: number | null;
      value?: number | null;
      units?: string | null;
    } | null;
    ahuMinCoolSetpointLimit?: {
      __typename?: 'ModbusAirHandlerAhuMinCoolSetpointLimit';
      timestamp?: number | null;
      value?: number | null;
      units?: string | null;
    } | null;
    ahuMaxHeatSetpointLimit?: {
      __typename?: 'ModbusAirHandlerAhuMaxHeatSetpointLimit';
      timestamp?: number | null;
      value?: number | null;
      units?: string | null;
    } | null;
    gTerminalOn?: {
      __typename?: 'ModbusAirHandlerGTerminalOn';
      timestamp?: number | null;
      value?: boolean | null;
      units?: string | null;
    } | null;
    hTerminalOn?: {
      __typename?: 'ModbusAirHandlerHTerminalOn';
      timestamp?: number | null;
      value?: boolean | null;
      units?: string | null;
    } | null;
    wTerminalOn?: {
      __typename?: 'ModbusAirHandlerWTerminalOn';
      timestamp?: number | null;
      value?: boolean | null;
      units?: string | null;
    } | null;
    yTerminalOn?: {
      __typename?: 'ModbusAirHandlerYTerminalOn';
      timestamp?: number | null;
      value?: boolean | null;
      units?: string | null;
    } | null;
    softwareReleaseType?: {
      __typename?: 'ModbusAirHandlerSoftwareReleaseType';
      timestamp?: number | null;
      value?: string | null;
      units?: string | null;
    } | null;
    softwareVersion?: {
      __typename?: 'ModbusAirHandlerSoftwareVersion';
      timestamp?: number | null;
      value?: number | null;
      units?: string | null;
    } | null;
    bootVersion?: {
      __typename?: 'ModbusAirHandlerBootVersion';
      timestamp?: number | null;
      value?: number | null;
      units?: string | null;
    } | null;
    biosVersion?: {
      __typename?: 'ModbusAirHandlerBiosVersion';
      timestamp?: number | null;
      value?: number | null;
      units?: string | null;
    } | null;
    allowTenantOnOff?: {
      __typename?: 'ModbusAirHandlerAllowTenantOnOff';
      timestamp?: number | null;
      value?: boolean | null;
      units?: string | null;
    } | null;
    enableTenantMode?: {
      __typename?: 'ModbusAirHandlerEnableTenantMode';
      timestamp?: number | null;
      value?: boolean | null;
      units?: string | null;
    } | null;
    allowTenantChangeRHSetpoint?: {
      __typename?: 'ModbusAirHandlerAllowTenantChangeRHSetpoint';
      timestamp?: number | null;
      value?: boolean | null;
      units?: string | null;
    } | null;
    allowTenantChangeTempSetpoints?: {
      __typename?: 'ModbusAirHandlerAllowTenantChangeTempSetpoints';
      timestamp?: number | null;
      value?: boolean | null;
      units?: string | null;
    } | null;
    tenantModePassword?: {
      __typename?: 'ModbusAirHandlerTenantModePassword';
      timestamp?: number | null;
      value?: string | null;
      units?: string | null;
    } | null;
    airflowUnits?: {
      __typename?: 'ModbusAirHandlerAirflowUnits';
      timestamp?: number | null;
      value?: string | null;
      units?: string | null;
    } | null;
    ahuModbusId?: {
      __typename?: 'ModbusAirHandlerAhuModbusId';
      timestamp?: number | null;
      value?: number | null;
      units?: string | null;
    } | null;
    altitude?: {
      __typename?: 'ModbusAirHandlerAltitude';
      timestamp?: number | null;
      value?: number | null;
      units?: string | null;
    } | null;
    freshAirSetpoint?: {
      __typename?: 'ModbusAirHandlerFreshAirSetpoint';
      timestamp?: number | null;
      value?: number | null;
      units?: string | null;
    } | null;
    rhSetpoint?: {
      __typename?: 'ModbusAirHandlerRhSetpoint';
      timestamp?: number | null;
      value?: number | null;
      units?: string | null;
    } | null;
    auxCoolingEnabled?: {
      __typename?: 'ModbusAirHandlerAuxCoolingEnabled';
      timestamp?: number | null;
      value?: boolean | null;
      units?: string | null;
    } | null;
    winterRhAdjustEnabled?: {
      __typename?: 'ModbusAirHandlerWinterRhAdjustEnabled';
      timestamp?: number | null;
      value?: boolean | null;
      units?: string | null;
    } | null;
    showerDetectorEnabled?: {
      __typename?: 'ModbusAirHandlerShowerDetectorEnabled';
      timestamp?: number | null;
      value?: boolean | null;
      units?: string | null;
    } | null;
    resetFiltersServiceTime?: {
      __typename?: 'ModbusAirHandlerResetFiltersServiceTime';
      timestamp?: number | null;
      value?: string | null;
      units?: string | null;
    } | null;
    resetHepaServiceTime?: {
      __typename?: 'ModbusAirHandlerResetHepaServiceTime';
      timestamp?: number | null;
      value?: string | null;
      units?: string | null;
    } | null;
    zmbPollingFrequency?: {
      __typename?: 'ModbusAirHandlerZmbPollingFrequency';
      timestamp?: number | null;
      value?: number | null;
      units?: string | null;
    } | null;
    zmbModbusRequestDelay?: {
      __typename?: 'ModbusAirHandlerZmbModbusRequestDelay';
      timestamp?: number | null;
      value?: number | null;
      units?: string | null;
    } | null;
    zmbFirmwareVersion?: {
      __typename?: 'ModbusAirHandlerZmbFirmwareVersion';
      timestamp?: number | null;
      value?: string | null;
      units?: string | null;
    } | null;
    zmbSystemUptime?: {
      __typename?: 'ModbusAirHandlerZmbSystemUptime';
      timestamp?: number | null;
      value?: number | null;
      units?: string | null;
    } | null;
    zmbTstatRequestsRecvd?: {
      __typename?: 'ModbusAirHandlerZmbTstatRequestsRecvd';
      timestamp?: number | null;
      value?: number | null;
      units?: string | null;
    } | null;
    zmbRequestsRecvdInvalid?: {
      __typename?: 'ModbusAirHandlerZmbRequestsRecvdInvalid';
      timestamp?: number | null;
      value?: number | null;
      units?: string | null;
    } | null;
    zmbAhuRequestsSent?: {
      __typename?: 'ModbusAirHandlerZmbAhuRequestsSent';
      timestamp?: number | null;
      value?: number | null;
      units?: string | null;
    } | null;
    zmbAhuRequestsSentFailed?: {
      __typename?: 'ModbusAirHandlerZmbAhuRequestsSentFailed';
      timestamp?: number | null;
      value?: number | null;
      units?: string | null;
    } | null;
    zmbCoreRequestsRecvd?: {
      __typename?: 'ModbusAirHandlerZmbCoreRequestsRecvd';
      timestamp?: number | null;
      value?: number | null;
      units?: string | null;
    } | null;
    zmbLeakDetectorInstalled?: {
      __typename?: 'ModbusAirHandlerZmbLeakDetectorInstalled';
      timestamp?: number | null;
      value?: boolean | null;
      units?: string | null;
    } | null;
    zmbCpuTemperature?: {
      __typename?: 'ModbusAirHandlerZmbCpuTemperature';
      timestamp?: number | null;
      value?: number | null;
      units?: string | null;
    } | null;
    temperatureUnits?: {
      __typename?: 'ModbusAirHandlerTemperatureUnits';
      timestamp?: number | null;
      value?: string | null;
      units?: string | null;
    } | null;
    filtersServiceTime?: {
      __typename?: 'ModbusAirHandlerFiltersServiceTime';
      timestamp?: number | null;
      value?: number | null;
      units?: string | null;
    } | null;
    hepaServiceTime?: {
      __typename?: 'ModbusAirHandlerHepaServiceTime';
      timestamp?: number | null;
      value?: number | null;
      units?: string | null;
    } | null;
    zone?: {
      __typename?: 'Zone';
      _id: string;
      name: string;
      hasPairedSensor?: boolean | null;
    } | null;
    source?: { __typename?: 'Source'; _id: string; name: string } | null;
    meta?: {
      __typename?: 'DeviceMeta';
      name?: string | null;
      model?: string | null;
      modelNumber?: string | null;
      version?: string | null;
      display?: {
        __typename?: 'DeviceMetaDisplay';
        temperature?: number | null;
        humidity?: number | null;
      } | null;
    } | null;
    deviceMetrics?: Array<{
      __typename?: 'DeviceMetric';
      key: string;
      value: {
        __typename?: 'DeviceMetricSpec';
        defaultValue?: string | null;
        defaultUnit?: string | null;
        readOnly?: boolean | null;
        streamId?: string | null;
        timestamp?: string | null;
        unit?: string | null;
        units?: string | null;
        value?: string | null;
        valueType?: string | null;
        description?: string | null;
      };
    } | null> | null;
    deviceAlerts: Array<{
      __typename?: 'Alert';
      _id: string;
      initiated?: number | null;
      updated?: number | null;
      type?: {
        __typename?: 'AlertType';
        id?: string | null;
        name?: string | null;
      } | null;
      device?: {
        __typename?: 'AlertDevice';
        id: string;
        name?: string | null;
        type: string;
      } | null;
    } | null>;
    sourceAlerts: Array<{
      __typename?: 'Alert';
      _id: string;
      initiated?: number | null;
      updated?: number | null;
      type?: { __typename?: 'AlertType'; name?: string | null } | null;
      device?: {
        __typename?: 'AlertDevice';
        id: string;
        name?: string | null;
        type: string;
      } | null;
    } | null>;
    alertTypes?: {
      __typename?: 'DeviceAlertTypes';
      deviceOffline?: boolean | null;
      sourceOffline?: boolean | null;
    } | null;
  } | null;
};

export type OccupancySensorDetailUpdateSubscriptionVariables = Exact<{
  ids: Array<Scalars['String']> | Scalars['String'];
}>;

export type OccupancySensorDetailUpdateSubscription = {
  __typename?: 'Subscription';
  occupancySensorEventsByIds?: {
    __typename?: 'OccupancySensor';
    modelChangeOperation?: string | null;
    _id: string;
    type?: EnumDKeyDeviceType | null;
    typeDisplayName: string;
    panelId?: string | null;
    name?: string | null;
    deviceId?: string | null;
    timestamp?: number | null;
    isConfigured?: boolean | null;
    meta?: {
      __typename?: 'DeviceMeta';
      name?: string | null;
      model?: string | null;
      modelNumber?: string | null;
      version?: string | null;
      location?: string | null;
    } | null;
    occupancy?: {
      __typename?: 'OccupancySensorOccupancy';
      timestamp?: number | null;
      value?: EnumOccupancySensorOccupancyValue | null;
      units?: string | null;
    } | null;
    voltage?: {
      __typename?: 'OccupancySensorVoltage';
      timestamp?: number | null;
      value?: number | null;
      units?: string | null;
    } | null;
    deviceAlerts: Array<{
      __typename?: 'Alert';
      _id: string;
      initiated?: number | null;
      updated?: number | null;
      type?: { __typename?: 'AlertType'; name?: string | null } | null;
      device?: {
        __typename?: 'AlertDevice';
        id: string;
        name?: string | null;
        type: string;
      } | null;
    } | null>;
    sourceAlerts: Array<{
      __typename?: 'Alert';
      _id: string;
      initiated?: number | null;
      updated?: number | null;
      type?: { __typename?: 'AlertType'; name?: string | null } | null;
      device?: {
        __typename?: 'AlertDevice';
        id: string;
        name?: string | null;
        type: string;
      } | null;
    } | null>;
  } | null;
};

export type OccupancySensorDetailQueryVariables = Exact<{
  id: Scalars['String'];
}>;

export type OccupancySensorDetailQuery = {
  __typename?: 'Query';
  occupancySensorById?: {
    __typename?: 'OccupancySensor';
    _id: string;
    type?: EnumDKeyDeviceType | null;
    typeDisplayName: string;
    panelId?: string | null;
    name?: string | null;
    deviceId?: string | null;
    timestamp?: number | null;
    isConfigured?: boolean | null;
    meta?: {
      __typename?: 'DeviceMeta';
      name?: string | null;
      model?: string | null;
      modelNumber?: string | null;
      version?: string | null;
    } | null;
    zone?: { __typename?: 'Zone'; _id: string; name: string } | null;
    source?: { __typename?: 'Source'; _id: string; name: string } | null;
    occupancy?: {
      __typename?: 'OccupancySensorOccupancy';
      timestamp?: number | null;
      value?: EnumOccupancySensorOccupancyValue | null;
      units?: string | null;
    } | null;
    voltage?: {
      __typename?: 'OccupancySensorVoltage';
      timestamp?: number | null;
      value?: number | null;
      units?: string | null;
    } | null;
    deviceAlerts: Array<{
      __typename?: 'Alert';
      _id: string;
      initiated?: number | null;
      updated?: number | null;
      type?: { __typename?: 'AlertType'; name?: string | null } | null;
      device?: {
        __typename?: 'AlertDevice';
        id: string;
        name?: string | null;
        type: string;
      } | null;
    } | null>;
    sourceAlerts: Array<{
      __typename?: 'Alert';
      _id: string;
      initiated?: number | null;
      updated?: number | null;
      type?: { __typename?: 'AlertType'; name?: string | null } | null;
      device?: {
        __typename?: 'AlertDevice';
        id: string;
        name?: string | null;
        type: string;
      } | null;
    } | null>;
  } | null;
};

export type RelayDeviceDetailUpdateSubscriptionVariables = Exact<{
  ids: Array<Scalars['String']> | Scalars['String'];
}>;

export type RelayDeviceDetailUpdateSubscription = {
  __typename?: 'Subscription';
  relayDeviceEventsByIds?: {
    __typename?: 'RelayDevice';
    modelChangeOperation?: string | null;
    _id: string;
    type?: EnumDKeyDeviceType | null;
    typeDisplayName: string;
    zoneId?: string | null;
    name?: string | null;
    deviceId?: string | null;
    propertyId: string;
    unitId: string;
    sourceId?: string | null;
    timestamp?: number | null;
    hasPendingUpdates: boolean;
    isConfigured?: boolean | null;
    meta?: {
      __typename?: 'DeviceMeta';
      name?: string | null;
      model?: string | null;
      modelNumber?: string | null;
      version?: string | null;
    } | null;
    zone?: { __typename?: 'Zone'; _id: string; name: string } | null;
    source?: { __typename?: 'Source'; _id: string; name: string } | null;
    isOn?: {
      __typename?: 'RelayDeviceIsOn';
      timestamp?: number | null;
      value?: boolean | null;
      units?: string | null;
    } | null;
    deviceAlerts: Array<{
      __typename?: 'Alert';
      _id: string;
      initiated?: number | null;
      updated?: number | null;
      type?: { __typename?: 'AlertType'; name?: string | null } | null;
      device?: {
        __typename?: 'AlertDevice';
        id: string;
        name?: string | null;
        type: string;
      } | null;
    } | null>;
    sourceAlerts: Array<{
      __typename?: 'Alert';
      _id: string;
      initiated?: number | null;
      updated?: number | null;
      type?: { __typename?: 'AlertType'; name?: string | null } | null;
      device?: {
        __typename?: 'AlertDevice';
        id: string;
        name?: string | null;
        type: string;
      } | null;
    } | null>;
    alertTypes?: {
      __typename?: 'DeviceAlertTypes';
      deviceOffline?: boolean | null;
      sourceOffline?: boolean | null;
    } | null;
  } | null;
};

export type RelayDeviceDetailQueryVariables = Exact<{
  id: Scalars['String'];
}>;

export type RelayDeviceDetailQuery = {
  __typename?: 'Query';
  relayDeviceById?: {
    __typename?: 'RelayDevice';
    _id: string;
    type?: EnumDKeyDeviceType | null;
    typeDisplayName: string;
    zoneId?: string | null;
    name?: string | null;
    deviceId?: string | null;
    propertyId: string;
    unitId: string;
    sourceId?: string | null;
    timestamp?: number | null;
    hasPendingUpdates: boolean;
    isConfigured?: boolean | null;
    meta?: {
      __typename?: 'DeviceMeta';
      name?: string | null;
      model?: string | null;
      modelNumber?: string | null;
      version?: string | null;
    } | null;
    zone?: { __typename?: 'Zone'; _id: string; name: string } | null;
    source?: { __typename?: 'Source'; _id: string; name: string } | null;
    isOn?: {
      __typename?: 'RelayDeviceIsOn';
      timestamp?: number | null;
      value?: boolean | null;
      units?: string | null;
    } | null;
    deviceAlerts: Array<{
      __typename?: 'Alert';
      _id: string;
      initiated?: number | null;
      updated?: number | null;
      type?: { __typename?: 'AlertType'; name?: string | null } | null;
      device?: {
        __typename?: 'AlertDevice';
        id: string;
        name?: string | null;
        type: string;
      } | null;
    } | null>;
    sourceAlerts: Array<{
      __typename?: 'Alert';
      _id: string;
      initiated?: number | null;
      updated?: number | null;
      type?: { __typename?: 'AlertType'; name?: string | null } | null;
      device?: {
        __typename?: 'AlertDevice';
        id: string;
        name?: string | null;
        type: string;
      } | null;
    } | null>;
    alertTypes?: {
      __typename?: 'DeviceAlertTypes';
      deviceOffline?: boolean | null;
      sourceOffline?: boolean | null;
    } | null;
  } | null;
};

export type ResetSmartPowerOutletCumulativePowerMutationVariables = Exact<{
  deviceId: Scalars['String'];
  revert?: InputMaybe<Scalars['Boolean']>;
}>;

export type ResetSmartPowerOutletCumulativePowerMutation = {
  __typename?: 'Mutation';
  resetCumulativePower: {
    __typename?: 'SmartPowerOutlet';
    _id: string;
    type?: EnumDKeyDeviceType | null;
    typeDisplayName: string;
    zoneId?: string | null;
    name?: string | null;
    deviceId?: string | null;
    timestamp?: number | null;
    isConfigured?: boolean | null;
    meta?: {
      __typename?: 'DeviceMeta';
      name?: string | null;
      model?: string | null;
      modelNumber?: string | null;
      version?: string | null;
    } | null;
    zone?: { __typename?: 'Zone'; _id: string; name: string } | null;
    source?: { __typename?: 'Source'; _id: string; name: string } | null;
    isOn?: {
      __typename?: 'SmartPowerOutletIsOn';
      timestamp?: number | null;
      value?: boolean | null;
      units?: string | null;
    } | null;
    rmsVoltage?: {
      __typename?: 'SmartPowerOutletRmsVoltage';
      timestamp?: number | null;
      value?: number | null;
      units?: string | null;
    } | null;
    rmsCurrent?: {
      __typename?: 'SmartPowerOutletRmsCurrent';
      timestamp?: number | null;
      value?: number | null;
      units?: string | null;
    } | null;
    apparentPower?: {
      __typename?: 'SmartPowerOutletApparentPower';
      timestamp?: number | null;
      value?: number | null;
      units?: string | null;
    } | null;
    activePower?: {
      __typename?: 'SmartPowerOutletActivePower';
      timestamp?: number | null;
      value?: number | null;
      units?: string | null;
    } | null;
    powerFactor?: {
      __typename?: 'SmartPowerOutletPowerFactor';
      timestamp?: number | null;
      value?: number | null;
      units?: string | null;
    } | null;
    cumulativePower?: {
      __typename?: 'SmartPowerOutletCumulativePower';
      timestamp?: number | null;
      value?: number | null;
      units?: string | null;
    } | null;
    adjustedCumulativePower?: {
      __typename?: 'SmartPowerOutletAdjustedCumulativePower';
      timestamp?: number | null;
      value?: number | null;
      units?: string | null;
    } | null;
    deviceAlerts: Array<{
      __typename?: 'Alert';
      _id: string;
      initiated?: number | null;
      updated?: number | null;
      type?: { __typename?: 'AlertType'; name?: string | null } | null;
      device?: {
        __typename?: 'AlertDevice';
        id: string;
        name?: string | null;
        type: string;
      } | null;
    } | null>;
    sourceAlerts: Array<{
      __typename?: 'Alert';
      _id: string;
      initiated?: number | null;
      updated?: number | null;
      type?: { __typename?: 'AlertType'; name?: string | null } | null;
      device?: {
        __typename?: 'AlertDevice';
        id: string;
        name?: string | null;
        type: string;
      } | null;
    } | null>;
  };
};

export type ResumeThermostatScheduleMutationVariables = Exact<{
  deviceId: Scalars['String'];
}>;

export type ResumeThermostatScheduleMutation = {
  __typename?: 'Mutation';
  resumeThermostatSchedule: {
    __typename?: 'Thermostat';
    deviceId?: string | null;
  };
};

export type SmartPowerOutletDetailQueryVariables = Exact<{
  id: Scalars['String'];
}>;

export type SmartPowerOutletDetailQuery = {
  __typename?: 'Query';
  smartPowerOutletById?: {
    __typename?: 'SmartPowerOutlet';
    _id: string;
    type?: EnumDKeyDeviceType | null;
    typeDisplayName: string;
    zoneId?: string | null;
    name?: string | null;
    deviceId?: string | null;
    timestamp?: number | null;
    hasPendingUpdates: boolean;
    isConfigured?: boolean | null;
    cumulativePowerResetTime?: number | null;
    cumulativePowerOffset?: number | null;
    meta?: {
      __typename?: 'DeviceMeta';
      name?: string | null;
      model?: string | null;
      modelNumber?: string | null;
      version?: string | null;
    } | null;
    zone?: { __typename?: 'Zone'; _id: string; name: string } | null;
    source?: { __typename?: 'Source'; _id: string; name: string } | null;
    isOn?: {
      __typename?: 'SmartPowerOutletIsOn';
      timestamp?: number | null;
      value?: boolean | null;
      units?: string | null;
    } | null;
    rmsVoltage?: {
      __typename?: 'SmartPowerOutletRmsVoltage';
      timestamp?: number | null;
      value?: number | null;
      units?: string | null;
    } | null;
    rmsCurrent?: {
      __typename?: 'SmartPowerOutletRmsCurrent';
      timestamp?: number | null;
      value?: number | null;
      units?: string | null;
    } | null;
    apparentPower?: {
      __typename?: 'SmartPowerOutletApparentPower';
      timestamp?: number | null;
      value?: number | null;
      units?: string | null;
    } | null;
    activePower?: {
      __typename?: 'SmartPowerOutletActivePower';
      timestamp?: number | null;
      value?: number | null;
      units?: string | null;
    } | null;
    powerFactor?: {
      __typename?: 'SmartPowerOutletPowerFactor';
      timestamp?: number | null;
      value?: number | null;
      units?: string | null;
    } | null;
    cumulativePower?: {
      __typename?: 'SmartPowerOutletCumulativePower';
      timestamp?: number | null;
      value?: number | null;
      units?: string | null;
    } | null;
    adjustedCumulativePower?: {
      __typename?: 'SmartPowerOutletAdjustedCumulativePower';
      timestamp?: number | null;
      value?: number | null;
      units?: string | null;
    } | null;
    deviceAlerts: Array<{
      __typename?: 'Alert';
      _id: string;
      initiated?: number | null;
      updated?: number | null;
      type?: { __typename?: 'AlertType'; name?: string | null } | null;
      device?: {
        __typename?: 'AlertDevice';
        id: string;
        name?: string | null;
        type: string;
      } | null;
    } | null>;
    sourceAlerts: Array<{
      __typename?: 'Alert';
      _id: string;
      initiated?: number | null;
      updated?: number | null;
      type?: { __typename?: 'AlertType'; name?: string | null } | null;
      device?: {
        __typename?: 'AlertDevice';
        id: string;
        name?: string | null;
        type: string;
      } | null;
    } | null>;
    alertTypes?: {
      __typename?: 'DeviceAlertTypes';
      deviceOffline?: boolean | null;
      sourceOffline?: boolean | null;
    } | null;
  } | null;
};

export type SmartPowerOutletDetailUpdateSubscriptionVariables = Exact<{
  ids: Array<Scalars['String']> | Scalars['String'];
}>;

export type SmartPowerOutletDetailUpdateSubscription = {
  __typename?: 'Subscription';
  smartPowerOutletEventsByIds?: {
    __typename?: 'SmartPowerOutlet';
    modelChangeOperation?: string | null;
    _id: string;
    type?: EnumDKeyDeviceType | null;
    typeDisplayName: string;
    zoneId?: string | null;
    name?: string | null;
    deviceId?: string | null;
    timestamp?: number | null;
    hasPendingUpdates: boolean;
    isConfigured?: boolean | null;
    cumulativePowerResetTime?: number | null;
    cumulativePowerOffset?: number | null;
    meta?: {
      __typename?: 'DeviceMeta';
      name?: string | null;
      model?: string | null;
      modelNumber?: string | null;
      version?: string | null;
    } | null;
    zone?: { __typename?: 'Zone'; _id: string; name: string } | null;
    source?: { __typename?: 'Source'; _id: string; name: string } | null;
    isOn?: {
      __typename?: 'SmartPowerOutletIsOn';
      timestamp?: number | null;
      value?: boolean | null;
      units?: string | null;
    } | null;
    rmsVoltage?: {
      __typename?: 'SmartPowerOutletRmsVoltage';
      timestamp?: number | null;
      value?: number | null;
      units?: string | null;
    } | null;
    rmsCurrent?: {
      __typename?: 'SmartPowerOutletRmsCurrent';
      timestamp?: number | null;
      value?: number | null;
      units?: string | null;
    } | null;
    apparentPower?: {
      __typename?: 'SmartPowerOutletApparentPower';
      timestamp?: number | null;
      value?: number | null;
      units?: string | null;
    } | null;
    activePower?: {
      __typename?: 'SmartPowerOutletActivePower';
      timestamp?: number | null;
      value?: number | null;
      units?: string | null;
    } | null;
    powerFactor?: {
      __typename?: 'SmartPowerOutletPowerFactor';
      timestamp?: number | null;
      value?: number | null;
      units?: string | null;
    } | null;
    cumulativePower?: {
      __typename?: 'SmartPowerOutletCumulativePower';
      timestamp?: number | null;
      value?: number | null;
      units?: string | null;
    } | null;
    adjustedCumulativePower?: {
      __typename?: 'SmartPowerOutletAdjustedCumulativePower';
      timestamp?: number | null;
      value?: number | null;
      units?: string | null;
    } | null;
    deviceAlerts: Array<{
      __typename?: 'Alert';
      _id: string;
      initiated?: number | null;
      updated?: number | null;
      type?: { __typename?: 'AlertType'; name?: string | null } | null;
      device?: {
        __typename?: 'AlertDevice';
        id: string;
        name?: string | null;
        type: string;
      } | null;
    } | null>;
    sourceAlerts: Array<{
      __typename?: 'Alert';
      _id: string;
      initiated?: number | null;
      updated?: number | null;
      type?: { __typename?: 'AlertType'; name?: string | null } | null;
      device?: {
        __typename?: 'AlertDevice';
        id: string;
        name?: string | null;
        type: string;
      } | null;
    } | null>;
    alertTypes?: {
      __typename?: 'DeviceAlertTypes';
      deviceOffline?: boolean | null;
      sourceOffline?: boolean | null;
    } | null;
  } | null;
};

export type ThermostatDetailUpdateSubscriptionVariables = Exact<{
  ids: Array<Scalars['String']> | Scalars['String'];
}>;

export type ThermostatDetailUpdateSubscription = {
  __typename?: 'Subscription';
  thermostatEventsByIds?: {
    __typename: 'Thermostat';
    modelChangeOperation?: string | null;
    _id: string;
    zoneId?: string | null;
    panelId?: string | null;
    sourceId?: string | null;
    deviceId?: string | null;
    name?: string | null;
    type?: EnumDKeyDeviceType | null;
    typeDisplayName: string;
    hasPendingUpdates: boolean;
    isMitsubishiThermostat: boolean;
    supportsObservationFreshness?: boolean | null;
    supportsAutoMode: boolean;
    supportsSingleSetpointAutoMode: boolean;
    supportsDualSetpointAutoMode: boolean;
    supportsSystemType?: boolean | null;
    supportsAlternateHeatSystemType?: boolean | null;
    supportsPasscode?: boolean | null;
    supportsShowFanButton?: boolean | null;
    supportsRemoteSensorTempDelta?: boolean | null;
    supportsLastSetpointChange?: boolean | null;
    supportsFanOperations?: boolean | null;
    supportsFanStateMonitoring?: boolean | null;
    supportsHoldExpiryTime?: boolean | null;
    supportsHumidityMonitoring?: boolean | null;
    supportsScheduling?: boolean | null;
    getFanState?: string | null;
    fanIconClass?: Array<string | null> | null;
    fanIconHelpText?: string | null;
    fanModeInfo?: string | null;
    getSetpointChangeSource?: string | null;
    hvacIconClass?: Array<string | null> | null;
    hvacIconHelpText?: string | null;
    scheduleStatus?: string | null;
    getHoldEnd?: number | null;
    hasSchedule?: boolean | null;
    isScheduleEnabled?: boolean | null;
    isFollowingSchedule?: boolean | null;
    isOffSchedule?: boolean | null;
    isHoldForever?: boolean | null;
    scheduleType?: EnumScheduleType | null;
    scheduleIconClass?: Array<string | null> | null;
    scheduleIconHelpText?: string | null;
    keypadLockoutIconClass?: Array<string | null> | null;
    keypadLockoutIconHelpText?: string | null;
    profileIconClass?: Array<string | null> | null;
    profileIconHelpText?: string | null;
    isConfigured?: boolean | null;
    isMultiSpeedThermostat?: boolean | null;
    isPairingActive: boolean;
    lastSetpointChangeValid?: boolean | null;
    timestamp?: number | null;
    remoteSensorTempDeltaValue?: number | null;
    modbusRTU: boolean;
    keypadLockoutLevels: Array<string>;
    useCustomSetpointLimits?: boolean | null;
    localControlPermissionsV1?: {
      __typename?: 'ThermostatLocalControlPermissionsV1';
      canEdit: boolean;
      pending: boolean;
      observedAt?: number | null;
      value: {
        __typename?: 'ThermostatLocalPermissionsValueV1';
        power: string;
        operatingMode: string;
        temperature: string;
        fanSpeed: string;
        louvre: string;
        filterReset: string;
        timer: string;
      };
    } | null;
    louvreControlV1?: {
      __typename?: 'ThermostatLouvreControlV1';
      supportsAirDirection: boolean;
      canEditAirDirection: boolean;
      allowedAirDirections: Array<string>;
      airDirection: {
        __typename?: 'ThermostatSeparateAirDirectionMetricV1';
        value?: string | null;
        readingId?: string | null;
        timestamp?: number | null;
        observedAt?: number | null;
        pending: boolean;
      };
    } | null;
    separatePowerControlV1?: {
      __typename?: 'ThermostatSeparatePowerControlV1';
      controlContract: string;
      canEditPowerMode: boolean;
      canEditOperatingMode: boolean;
      supportsAirDirection: boolean;
      canEditAirDirection: boolean;
      allowedAirDirections: Array<string>;
      canEditFanSpeed: boolean;
      allowedFanSpeeds: Array<string>;
      allowedOperatingModes: Array<string>;
      canEditTargets: boolean;
      targetBlockReason?: string | null;
      airDirection: {
        __typename?: 'ThermostatSeparateAirDirectionMetricV1';
        value?: string | null;
        readingId?: string | null;
        timestamp?: number | null;
        observedAt?: number | null;
        pending: boolean;
      };
      fanSpeed: {
        __typename?: 'ThermostatSeparateFanSpeedMetricV1';
        value?: string | null;
        readingId?: string | null;
        timestamp?: number | null;
        observedAt?: number | null;
        pending: boolean;
      };
      powerMode: {
        __typename?: 'ThermostatSeparatePowerModeMetricV1';
        value?: string | null;
        readingId?: string | null;
        timestamp?: number | null;
        observedAt?: number | null;
        pending: boolean;
      };
      powerState: {
        __typename?: 'ThermostatSeparatePowerStateMetricV1';
        value?: string | null;
        readingId?: string | null;
        timestamp?: number | null;
        observedAt?: number | null;
        pending: boolean;
      };
      operatingMode: {
        __typename?: 'ThermostatSeparateOperatingModeMetricV1';
        value?: string | null;
        readingId?: string | null;
        timestamp?: number | null;
        observedAt?: number | null;
        pending: boolean;
      };
      operatingState: {
        __typename?: 'ThermostatSeparateOperatingStateMetricV1';
        value?: string | null;
        readingId?: string | null;
        timestamp?: number | null;
        observedAt?: number | null;
        pending: boolean;
      };
    } | null;
    setpoint?: {
      __typename?: 'ThermostatSetpoint';
      observedAt?: number | null;
      value?: number | null;
      units?: string | null;
      timestamp?: number | null;
      updatePending?: boolean | null;
    } | null;
    minSetpoint?: {
      __typename?: 'ThermostatMinSetpoint';
      value?: number | null;
      units?: string | null;
      timestamp?: number | null;
    } | null;
    maxSetpoint?: {
      __typename?: 'ThermostatMaxSetpoint';
      value?: number | null;
      units?: string | null;
      timestamp?: number | null;
    } | null;
    zone?: {
      __typename?: 'Zone';
      _id: string;
      name: string;
      hasPairedSensor?: boolean | null;
    } | null;
    source?: {
      __typename?: 'Source';
      _id: string;
      name: string;
      type?: EnumDKeySourceType | null;
    } | null;
    meta?: {
      __typename?: 'DeviceMeta';
      name?: string | null;
      model?: string | null;
      modelNumber?: string | null;
      version?: string | null;
      plmActive?: boolean | null;
      display?: {
        __typename?: 'DeviceMetaDisplay';
        temperature?: number | null;
        humidity?: number | null;
      } | null;
    } | null;
    deviceMetrics?: Array<{
      __typename?: 'DeviceMetric';
      key: string;
      value: {
        __typename?: 'DeviceMetricSpec';
        defaultValue?: string | null;
        defaultUnit?: string | null;
        readOnly?: boolean | null;
        streamId?: string | null;
        timestamp?: string | null;
        unit?: string | null;
        units?: string | null;
        value?: string | null;
        valueType?: string | null;
        valueStep?: number | null;
      };
    } | null> | null;
    coolSetpoint?: {
      __typename?: 'ThermostatCoolSetpoint';
      observedAt?: number | null;
      timestamp?: number | null;
      value?: number | null;
    } | null;
    fanMode?: {
      __typename?: 'ThermostatFanMode';
      observedAt?: number | null;
      timestamp?: number | null;
      value?: EnumThermostatFanModeValue | null;
      units?: string | null;
    } | null;
    fanSpeed?: {
      __typename?: 'ThermostatFanSpeed';
      observedAt?: number | null;
      timestamp?: number | null;
      value?: EnumThermostatFanSpeedValue | null;
      units?: string | null;
    } | null;
    fanState?: {
      __typename?: 'ThermostatFanState';
      observedAt?: number | null;
      timestamp?: number | null;
      value?: EnumThermostatFanStateValue | null;
      units?: string | null;
    } | null;
    heatSetpoint?: {
      __typename?: 'ThermostatHeatSetpoint';
      observedAt?: number | null;
      timestamp?: number | null;
      value?: number | null;
    } | null;
    holdDuration?: {
      __typename?: 'ThermostatHoldDuration';
      timestamp?: number | null;
      value?: number | null;
      units?: string | null;
    } | null;
    holdEnd?: {
      __typename?: 'ThermostatHoldEnd';
      timestamp?: number | null;
      value?: number | null;
      units?: string | null;
    } | null;
    holdState?: {
      __typename?: 'ThermostatHoldState';
      timestamp?: number | null;
      value?: EnumThermostatHoldStateValue | null;
      units?: string | null;
    } | null;
    holdExpiryTime?: {
      __typename?: 'ThermostatHoldExpiryTime';
      timestamp?: number | null;
      value?: number | null;
      units?: string | null;
    } | null;
    humidity?: {
      __typename?: 'ThermostatHumidity';
      observedAt?: number | null;
      timestamp?: number | null;
      value?: number | null;
      units?: string | null;
    } | null;
    keypadLockoutLevel?: {
      __typename?: 'ThermostatKeypadLockoutLevel';
      timestamp?: number | null;
      value?: string | null;
      units?: string | null;
    } | null;
    lastScheduleChange?: {
      __typename?: 'ThermostatLastScheduleChange';
      timestamp?: number | null;
      value?: number | null;
      units?: string | null;
    } | null;
    lastSetpointChange?: {
      __typename?: 'ThermostatLastSetpointChange';
      timestamp?: number | null;
      value?: number | null;
      units?: string | null;
    } | null;
    maxCoolSetpointLimit?: {
      __typename?: 'ThermostatMaxCoolSetpointLimit';
      timestamp?: number | null;
      value?: number | null;
      units?: string | null;
    } | null;
    maxHeatSetpointLimit?: {
      __typename?: 'ThermostatMaxHeatSetpointLimit';
      timestamp?: number | null;
      value?: number | null;
      units?: string | null;
    } | null;
    minCoolSetpointLimit?: {
      __typename?: 'ThermostatMinCoolSetpointLimit';
      timestamp?: number | null;
      value?: number | null;
      units?: string | null;
    } | null;
    minHeatSetpointLimit?: {
      __typename?: 'ThermostatMinHeatSetpointLimit';
      timestamp?: number | null;
      value?: number | null;
      units?: string | null;
    } | null;
    operatingMode?: {
      __typename?: 'ThermostatOperatingMode';
      observedAt?: number | null;
      timestamp?: number | null;
      value?: EnumThermostatOperatingModeValue | null;
      units?: string | null;
    } | null;
    operatingState?: {
      __typename?: 'ThermostatOperatingState';
      observedAt?: number | null;
      timestamp?: number | null;
      value?: EnumThermostatOperatingStateValue | null;
      units?: string | null;
    } | null;
    passCode?: {
      __typename?: 'ThermostatPassCode';
      timestamp?: number | null;
      value?: number | null;
      units?: string | null;
    } | null;
    progMode?: {
      __typename?: 'ThermostatProgMode';
      timestamp?: number | null;
      value?: EnumThermostatProgModeValue | null;
      units?: string | null;
    } | null;
    remoteSensorTempDelta?: {
      __typename?: 'ThermostatRemoteSensorTempDelta';
      timestamp?: number | null;
      value?: number | null;
      units?: string | null;
    } | null;
    schedVisibilityMode?: {
      __typename?: 'ThermostatSchedVisibilityMode';
      timestamp?: number | null;
      value?: EnumThermostatSchedVisibilityModeValue | null;
      units?: string | null;
    } | null;
    schedule?: {
      __typename?: 'ThermostatSchedule';
      id?: string | null;
      units?: string | null;
      timestamp?: number | null;
      value?: any | null;
      updatePending?: boolean | null;
    } | null;
    setpointChangeSource?: {
      __typename?: 'ThermostatSetpointChangeSource';
      timestamp?: number | null;
      value?: EnumThermostatSetpointChangeSourceValue | null;
      units?: string | null;
    } | null;
    showFanButton?: {
      __typename?: 'ThermostatShowFanButton';
      timestamp?: number | null;
      value?: boolean | null;
      units?: string | null;
    } | null;
    systemType?: {
      __typename?: 'ThermostatSystemType';
      timestamp?: number | null;
      value?: EnumThermostatSystemTypeValue | null;
      units?: string | null;
    } | null;
    tempDisplayMode?: {
      __typename?: 'ThermostatTempDisplayMode';
      timestamp?: number | null;
      value?: EnumThermostatTempDisplayModeValue | null;
      units?: string | null;
    } | null;
    temperature?: {
      __typename?: 'ThermostatTemperature';
      observedAt?: number | null;
      timestamp?: number | null;
      value?: number | null;
      units?: string | null;
    } | null;
    uiOptions?: {
      __typename?: 'ThermostatUiOptions';
      timestamp?: number | null;
      value?: number | null;
      units?: string | null;
    } | null;
    deviceAlerts: Array<{
      __typename?: 'Alert';
      _id: string;
      initiated?: number | null;
      updated?: number | null;
      type?: { __typename?: 'AlertType'; name?: string | null } | null;
      device?: {
        __typename?: 'AlertDevice';
        id: string;
        name?: string | null;
        type: string;
      } | null;
    } | null>;
    sourceAlerts: Array<{
      __typename?: 'Alert';
      _id: string;
      initiated?: number | null;
      updated?: number | null;
      type?: { __typename?: 'AlertType'; name?: string | null } | null;
      device?: {
        __typename?: 'AlertDevice';
        id: string;
        name?: string | null;
        type: string;
      } | null;
    } | null>;
    alertTypes?: {
      __typename?: 'DeviceAlertTypes';
      deviceOffline?: boolean | null;
      sourceOffline?: boolean | null;
    } | null;
  } | null;
};

export type ThermostatDetailQueryVariables = Exact<{
  id: Scalars['String'];
}>;

export type ThermostatDetailQuery = {
  __typename?: 'Query';
  thermostatById?: {
    __typename: 'Thermostat';
    _id: string;
    zoneId?: string | null;
    panelId?: string | null;
    sourceId?: string | null;
    deviceId?: string | null;
    thermostatScheduleTemplateId?: string | null;
    name?: string | null;
    type?: EnumDKeyDeviceType | null;
    typeDisplayName: string;
    hasPendingUpdates: boolean;
    isMitsubishiThermostat: boolean;
    supportsObservationFreshness?: boolean | null;
    supportsAutoMode: boolean;
    supportsSingleSetpointAutoMode: boolean;
    supportsDualSetpointAutoMode: boolean;
    supportsSystemType?: boolean | null;
    supportsAlternateHeatSystemType?: boolean | null;
    supportsPasscode?: boolean | null;
    supportsShowFanButton?: boolean | null;
    supportsRemoteSensorTempDelta?: boolean | null;
    supportsLastSetpointChange?: boolean | null;
    supportsFanOperations?: boolean | null;
    supportsFanStateMonitoring?: boolean | null;
    supportsHoldExpiryTime?: boolean | null;
    supportsHumidityMonitoring?: boolean | null;
    supportsScheduling?: boolean | null;
    getFanState?: string | null;
    fanIconClass?: Array<string | null> | null;
    fanIconHelpText?: string | null;
    fanModeInfo?: string | null;
    getSetpointChangeSource?: string | null;
    hvacIconClass?: Array<string | null> | null;
    hvacIconHelpText?: string | null;
    scheduleStatus?: string | null;
    getHoldEnd?: number | null;
    hasSchedule?: boolean | null;
    isScheduleEnabled?: boolean | null;
    isFollowingSchedule?: boolean | null;
    isOffSchedule?: boolean | null;
    isHoldForever?: boolean | null;
    scheduleType?: EnumScheduleType | null;
    scheduleIconClass?: Array<string | null> | null;
    scheduleIconHelpText?: string | null;
    keypadLockoutLevelName: ThermostatKeypadLockoutLevelNameType;
    keypadLockoutIconClass?: Array<string | null> | null;
    keypadLockoutIconHelpText?: string | null;
    profileIconClass?: Array<string | null> | null;
    profileIconHelpText?: string | null;
    isConfigured?: boolean | null;
    isMultiSpeedThermostat?: boolean | null;
    isPairingActive: boolean;
    lastSetpointChangeValid?: boolean | null;
    timestamp?: number | null;
    remoteSensorTempDeltaValue?: number | null;
    modbusRTU: boolean;
    keypadLockoutLevels: Array<string>;
    useCustomSetpointLimits?: boolean | null;
    useCustomSchedule?: boolean | null;
    localControlPermissionsV1?: {
      __typename?: 'ThermostatLocalControlPermissionsV1';
      canEdit: boolean;
      pending: boolean;
      observedAt?: number | null;
      value: {
        __typename?: 'ThermostatLocalPermissionsValueV1';
        power: string;
        operatingMode: string;
        temperature: string;
        fanSpeed: string;
        louvre: string;
        filterReset: string;
        timer: string;
      };
    } | null;
    louvreControlV1?: {
      __typename?: 'ThermostatLouvreControlV1';
      supportsAirDirection: boolean;
      canEditAirDirection: boolean;
      allowedAirDirections: Array<string>;
      airDirection: {
        __typename?: 'ThermostatSeparateAirDirectionMetricV1';
        value?: string | null;
        readingId?: string | null;
        timestamp?: number | null;
        observedAt?: number | null;
        pending: boolean;
      };
    } | null;
    separatePowerControlV1?: {
      __typename?: 'ThermostatSeparatePowerControlV1';
      controlContract: string;
      canEditPowerMode: boolean;
      canEditOperatingMode: boolean;
      supportsAirDirection: boolean;
      canEditAirDirection: boolean;
      allowedAirDirections: Array<string>;
      canEditFanSpeed: boolean;
      allowedFanSpeeds: Array<string>;
      allowedOperatingModes: Array<string>;
      canEditTargets: boolean;
      targetBlockReason?: string | null;
      airDirection: {
        __typename?: 'ThermostatSeparateAirDirectionMetricV1';
        value?: string | null;
        readingId?: string | null;
        timestamp?: number | null;
        observedAt?: number | null;
        pending: boolean;
      };
      fanSpeed: {
        __typename?: 'ThermostatSeparateFanSpeedMetricV1';
        value?: string | null;
        readingId?: string | null;
        timestamp?: number | null;
        observedAt?: number | null;
        pending: boolean;
      };
      powerMode: {
        __typename?: 'ThermostatSeparatePowerModeMetricV1';
        value?: string | null;
        readingId?: string | null;
        timestamp?: number | null;
        observedAt?: number | null;
        pending: boolean;
      };
      powerState: {
        __typename?: 'ThermostatSeparatePowerStateMetricV1';
        value?: string | null;
        readingId?: string | null;
        timestamp?: number | null;
        observedAt?: number | null;
        pending: boolean;
      };
      operatingMode: {
        __typename?: 'ThermostatSeparateOperatingModeMetricV1';
        value?: string | null;
        readingId?: string | null;
        timestamp?: number | null;
        observedAt?: number | null;
        pending: boolean;
      };
      operatingState: {
        __typename?: 'ThermostatSeparateOperatingStateMetricV1';
        value?: string | null;
        readingId?: string | null;
        timestamp?: number | null;
        observedAt?: number | null;
        pending: boolean;
      };
    } | null;
    setpoint?: {
      __typename?: 'ThermostatSetpoint';
      observedAt?: number | null;
      value?: number | null;
      units?: string | null;
      timestamp?: number | null;
      updatePending?: boolean | null;
    } | null;
    minSetpoint?: {
      __typename?: 'ThermostatMinSetpoint';
      value?: number | null;
      units?: string | null;
      timestamp?: number | null;
    } | null;
    maxSetpoint?: {
      __typename?: 'ThermostatMaxSetpoint';
      value?: number | null;
      units?: string | null;
      timestamp?: number | null;
    } | null;
    zone?: {
      __typename?: 'Zone';
      _id: string;
      name: string;
      hasPairedSensor?: boolean | null;
    } | null;
    source?: {
      __typename?: 'Source';
      _id: string;
      name: string;
      type?: EnumDKeySourceType | null;
    } | null;
    meta?: {
      __typename?: 'DeviceMeta';
      name?: string | null;
      model?: string | null;
      modelNumber?: string | null;
      version?: string | null;
      plmActive?: boolean | null;
      display?: {
        __typename?: 'DeviceMetaDisplay';
        temperature?: number | null;
        humidity?: number | null;
      } | null;
    } | null;
    deviceMetrics?: Array<{
      __typename?: 'DeviceMetric';
      key: string;
      value: {
        __typename?: 'DeviceMetricSpec';
        defaultValue?: string | null;
        defaultUnit?: string | null;
        readOnly?: boolean | null;
        streamId?: string | null;
        timestamp?: string | null;
        unit?: string | null;
        units?: string | null;
        value?: string | null;
        valueType?: string | null;
        valueStep?: number | null;
      };
    } | null> | null;
    coolSetpoint?: {
      __typename?: 'ThermostatCoolSetpoint';
      observedAt?: number | null;
      timestamp?: number | null;
      value?: number | null;
    } | null;
    fanMode?: {
      __typename?: 'ThermostatFanMode';
      observedAt?: number | null;
      timestamp?: number | null;
      value?: EnumThermostatFanModeValue | null;
      units?: string | null;
    } | null;
    fanSpeed?: {
      __typename?: 'ThermostatFanSpeed';
      observedAt?: number | null;
      timestamp?: number | null;
      value?: EnumThermostatFanSpeedValue | null;
      units?: string | null;
    } | null;
    fanState?: {
      __typename?: 'ThermostatFanState';
      observedAt?: number | null;
      timestamp?: number | null;
      value?: EnumThermostatFanStateValue | null;
      units?: string | null;
    } | null;
    heatSetpoint?: {
      __typename?: 'ThermostatHeatSetpoint';
      observedAt?: number | null;
      timestamp?: number | null;
      value?: number | null;
    } | null;
    holdDuration?: {
      __typename?: 'ThermostatHoldDuration';
      timestamp?: number | null;
      value?: number | null;
      units?: string | null;
    } | null;
    holdEnd?: {
      __typename?: 'ThermostatHoldEnd';
      timestamp?: number | null;
      value?: number | null;
      units?: string | null;
    } | null;
    holdState?: {
      __typename?: 'ThermostatHoldState';
      timestamp?: number | null;
      value?: EnumThermostatHoldStateValue | null;
      units?: string | null;
    } | null;
    holdExpiryTime?: {
      __typename?: 'ThermostatHoldExpiryTime';
      timestamp?: number | null;
      value?: number | null;
      units?: string | null;
    } | null;
    humidity?: {
      __typename?: 'ThermostatHumidity';
      observedAt?: number | null;
      timestamp?: number | null;
      value?: number | null;
      units?: string | null;
    } | null;
    keypadLockoutLevel?: {
      __typename?: 'ThermostatKeypadLockoutLevel';
      timestamp?: number | null;
      value?: string | null;
      units?: string | null;
    } | null;
    lastScheduleChange?: {
      __typename?: 'ThermostatLastScheduleChange';
      timestamp?: number | null;
      value?: number | null;
      units?: string | null;
    } | null;
    lastSetpointChange?: {
      __typename?: 'ThermostatLastSetpointChange';
      timestamp?: number | null;
      value?: number | null;
      units?: string | null;
    } | null;
    maxCoolSetpointLimit?: {
      __typename?: 'ThermostatMaxCoolSetpointLimit';
      timestamp?: number | null;
      value?: number | null;
      units?: string | null;
    } | null;
    maxHeatSetpointLimit?: {
      __typename?: 'ThermostatMaxHeatSetpointLimit';
      timestamp?: number | null;
      value?: number | null;
      units?: string | null;
    } | null;
    minCoolSetpointLimit?: {
      __typename?: 'ThermostatMinCoolSetpointLimit';
      timestamp?: number | null;
      value?: number | null;
      units?: string | null;
    } | null;
    minHeatSetpointLimit?: {
      __typename?: 'ThermostatMinHeatSetpointLimit';
      timestamp?: number | null;
      value?: number | null;
      units?: string | null;
    } | null;
    operatingMode?: {
      __typename?: 'ThermostatOperatingMode';
      observedAt?: number | null;
      timestamp?: number | null;
      value?: EnumThermostatOperatingModeValue | null;
      units?: string | null;
    } | null;
    operatingState?: {
      __typename?: 'ThermostatOperatingState';
      observedAt?: number | null;
      timestamp?: number | null;
      value?: EnumThermostatOperatingStateValue | null;
      units?: string | null;
    } | null;
    passCode?: {
      __typename?: 'ThermostatPassCode';
      timestamp?: number | null;
      value?: number | null;
      units?: string | null;
    } | null;
    progMode?: {
      __typename?: 'ThermostatProgMode';
      timestamp?: number | null;
      value?: EnumThermostatProgModeValue | null;
      units?: string | null;
    } | null;
    remoteSensorTempDelta?: {
      __typename?: 'ThermostatRemoteSensorTempDelta';
      timestamp?: number | null;
      value?: number | null;
      units?: string | null;
    } | null;
    schedVisibilityMode?: {
      __typename?: 'ThermostatSchedVisibilityMode';
      timestamp?: number | null;
      value?: EnumThermostatSchedVisibilityModeValue | null;
      units?: string | null;
    } | null;
    schedule?: {
      __typename?: 'ThermostatSchedule';
      id?: string | null;
      units?: string | null;
      timestamp?: number | null;
      value?: any | null;
      updatePending?: boolean | null;
    } | null;
    pendingSchedule?: {
      __typename?: 'ThermostatPendingSchedule';
      id?: string | null;
      units?: string | null;
      timestamp?: number | null;
      value?: any | null;
    } | null;
    setpointChangeSource?: {
      __typename?: 'ThermostatSetpointChangeSource';
      timestamp?: number | null;
      value?: EnumThermostatSetpointChangeSourceValue | null;
      units?: string | null;
    } | null;
    showFanButton?: {
      __typename?: 'ThermostatShowFanButton';
      timestamp?: number | null;
      value?: boolean | null;
      units?: string | null;
    } | null;
    systemType?: {
      __typename?: 'ThermostatSystemType';
      timestamp?: number | null;
      value?: EnumThermostatSystemTypeValue | null;
      units?: string | null;
    } | null;
    tempDisplayMode?: {
      __typename?: 'ThermostatTempDisplayMode';
      timestamp?: number | null;
      value?: EnumThermostatTempDisplayModeValue | null;
      units?: string | null;
    } | null;
    temperature?: {
      __typename?: 'ThermostatTemperature';
      observedAt?: number | null;
      timestamp?: number | null;
      value?: number | null;
      units?: string | null;
    } | null;
    uiOptions?: {
      __typename?: 'ThermostatUiOptions';
      timestamp?: number | null;
      value?: number | null;
      units?: string | null;
    } | null;
    deviceAlerts: Array<{
      __typename?: 'Alert';
      _id: string;
      initiated?: number | null;
      updated?: number | null;
      type?: { __typename?: 'AlertType'; name?: string | null } | null;
      device?: {
        __typename?: 'AlertDevice';
        id: string;
        name?: string | null;
        type: string;
      } | null;
    } | null>;
    sourceAlerts: Array<{
      __typename?: 'Alert';
      _id: string;
      initiated?: number | null;
      updated?: number | null;
      type?: { __typename?: 'AlertType'; name?: string | null } | null;
      device?: {
        __typename?: 'AlertDevice';
        id: string;
        name?: string | null;
        type: string;
      } | null;
    } | null>;
    alertTypes?: {
      __typename?: 'DeviceAlertTypes';
      deviceOffline?: boolean | null;
      sourceOffline?: boolean | null;
    } | null;
  } | null;
};

export type ThermostatScheduleTemplateDetailQueryVariables = Exact<{
  id: Scalars['String'];
}>;

export type ThermostatScheduleTemplateDetailQuery = {
  __typename?: 'Query';
  thermostatScheduleTemplateById?: {
    __typename?: 'ThermostatScheduleTemplate';
    _id: string;
    name: string;
    isPropertyDefault?: boolean | null;
    assignedUnitCount?: number | null;
    setpointLimitProfileId?: string | null;
    propertyId: string;
    value: {
      __typename?: 'ThermostatScheduleTemplateValue';
      id?: string | null;
      units?: string | null;
      timestamp?: number | null;
      value?: any | null;
      updatePending?: boolean | null;
    };
  } | null;
};

export type ThermostatPendingScheduleUpdateSubscriptionVariables = Exact<{
  id: Scalars['String'];
}>;

export type ThermostatPendingScheduleUpdateSubscription = {
  __typename?: 'Subscription';
  thermostatEventsByIds?: {
    __typename?: 'Thermostat';
    modelChangeOperation?: string | null;
    _id: string;
    deviceId?: string | null;
    name?: string | null;
    type?: EnumDKeyDeviceType | null;
    pendingSchedule?: {
      __typename?: 'ThermostatPendingSchedule';
      id?: string | null;
      units?: string | null;
      timestamp?: number | null;
      value?: any | null;
    } | null;
  } | null;
};

export type ThermostatScheduleTemplateDetailUpdatesSubscriptionVariables =
  Exact<{
    id: Scalars['String'];
  }>;

export type ThermostatScheduleTemplateDetailUpdatesSubscription = {
  __typename?: 'Subscription';
  thermostatScheduleTemplateEventsByIds?: {
    __typename?: 'ThermostatScheduleTemplate';
    modelChangeOperation?: string | null;
    _id: string;
    name: string;
    isPropertyDefault?: boolean | null;
    assignedUnitCount?: number | null;
    setpointLimitProfileId?: string | null;
    propertyId: string;
    value: {
      __typename?: 'ThermostatScheduleTemplateValue';
      id?: string | null;
      units?: string | null;
      timestamp?: number | null;
      value?: any | null;
      updatePending?: boolean | null;
    };
  } | null;
};

export type ThermostatScheduleTemplateEditVerificationQueryVariables = Exact<{
  thermostatScheduleTemplateId?: InputMaybe<Scalars['String']>;
  propertyId?: InputMaybe<Scalars['String']>;
}>;

export type ThermostatScheduleTemplateEditVerificationQuery = {
  __typename?: 'Query';
  thermostatScheduleTemplateEditVerification?: {
    __typename?: 'ThermostatScheduleTemplateEditVerificationData';
    allAffectedThermostats?: number | null;
    allAffectedUnits?: number | null;
    allThermostats?: number | null;
    allUnits?: number | null;
  } | null;
};

export type ThermostatScheduleTemplateUpdateVerificationQueryVariables = Exact<{
  propertyId?: InputMaybe<Scalars['String']>;
  unitId?: InputMaybe<Scalars['String']>;
}>;

export type ThermostatScheduleTemplateUpdateVerificationQuery = {
  __typename?: 'Query';
  thermostatScheduleTemplateUpdateVerification?: {
    __typename?: 'ThermostatScheduleTemplateUpdateVerificationData';
    totalUnits: number;
    thermostatsUsingUnitLevelScheduleTemplate: Array<string | null>;
    totalThermostats: number;
    installedThermostats: number;
    installedOnlineThermostats: Array<string | null>;
    installedOnlineThermostatsAndUsesCustomSchedule: Array<string | null>;
    installedOnlineThermostatsAndUsesCustomSetpointLimits: Array<string | null>;
    thermostatsUsingPropertyLevelScheduleTemplate: Array<string | null>;
    unitsWithAppliedThermostatScheduleTemplate: number;
    unitsWithoutAppliedThermostatScheduleTemplate: number;
    installedOnlineThermostatsAndUsesScheduleTemplate: Array<{
      __typename?: 'Thermostat';
      _id: string;
      thermostatScheduleTemplate?: {
        __typename?: 'ThermostatScheduleTemplate';
        _id: string;
        setpointLimitProfileId?: string | null;
      } | null;
    } | null>;
  } | null;
};

export type TurnRelayDeviceOffMutationVariables = Exact<{
  deviceId: Scalars['String'];
  force?: InputMaybe<Scalars['Boolean']>;
}>;

export type TurnRelayDeviceOffMutation = {
  __typename?: 'Mutation';
  updateRelayDeviceOnOffState: {
    __typename?: 'RelayDevice';
    _id: string;
    type?: EnumDKeyDeviceType | null;
    typeDisplayName: string;
    zoneId?: string | null;
    name?: string | null;
    deviceId?: string | null;
    propertyId: string;
    unitId: string;
    sourceId?: string | null;
    timestamp?: number | null;
    isConfigured?: boolean | null;
    meta?: {
      __typename?: 'DeviceMeta';
      name?: string | null;
      model?: string | null;
      modelNumber?: string | null;
      version?: string | null;
    } | null;
    zone?: { __typename?: 'Zone'; _id: string; name: string } | null;
    source?: { __typename?: 'Source'; _id: string; name: string } | null;
    isOn?: {
      __typename?: 'RelayDeviceIsOn';
      timestamp?: number | null;
      value?: boolean | null;
      units?: string | null;
    } | null;
    deviceAlerts: Array<{
      __typename?: 'Alert';
      _id: string;
      initiated?: number | null;
      updated?: number | null;
      type?: { __typename?: 'AlertType'; name?: string | null } | null;
      device?: {
        __typename?: 'AlertDevice';
        id: string;
        name?: string | null;
        type: string;
      } | null;
    } | null>;
    sourceAlerts: Array<{
      __typename?: 'Alert';
      _id: string;
      initiated?: number | null;
      updated?: number | null;
      type?: { __typename?: 'AlertType'; name?: string | null } | null;
      device?: {
        __typename?: 'AlertDevice';
        id: string;
        name?: string | null;
        type: string;
      } | null;
    } | null>;
  };
};

export type TurnRelayDeviceOnMutationVariables = Exact<{
  deviceId: Scalars['String'];
  force?: InputMaybe<Scalars['Boolean']>;
}>;

export type TurnRelayDeviceOnMutation = {
  __typename?: 'Mutation';
  updateRelayDeviceOnOffState: {
    __typename?: 'RelayDevice';
    _id: string;
    type?: EnumDKeyDeviceType | null;
    typeDisplayName: string;
    zoneId?: string | null;
    name?: string | null;
    deviceId?: string | null;
    propertyId: string;
    unitId: string;
    sourceId?: string | null;
    timestamp?: number | null;
    isConfigured?: boolean | null;
    meta?: {
      __typename?: 'DeviceMeta';
      name?: string | null;
      model?: string | null;
      modelNumber?: string | null;
      version?: string | null;
    } | null;
    zone?: { __typename?: 'Zone'; _id: string; name: string } | null;
    source?: { __typename?: 'Source'; _id: string; name: string } | null;
    isOn?: {
      __typename?: 'RelayDeviceIsOn';
      timestamp?: number | null;
      value?: boolean | null;
      units?: string | null;
    } | null;
    deviceAlerts: Array<{
      __typename?: 'Alert';
      _id: string;
      initiated?: number | null;
      updated?: number | null;
      type?: { __typename?: 'AlertType'; name?: string | null } | null;
      device?: {
        __typename?: 'AlertDevice';
        id: string;
        name?: string | null;
        type: string;
      } | null;
    } | null>;
    sourceAlerts: Array<{
      __typename?: 'Alert';
      _id: string;
      initiated?: number | null;
      updated?: number | null;
      type?: { __typename?: 'AlertType'; name?: string | null } | null;
      device?: {
        __typename?: 'AlertDevice';
        id: string;
        name?: string | null;
        type: string;
      } | null;
    } | null>;
  };
};

export type TurnSmartPowerOutletOffMutationVariables = Exact<{
  deviceId: Scalars['String'];
  force?: InputMaybe<Scalars['Boolean']>;
}>;

export type TurnSmartPowerOutletOffMutation = {
  __typename?: 'Mutation';
  updateSmartOutletOnOffState: {
    __typename?: 'SmartPowerOutlet';
    _id: string;
    type?: EnumDKeyDeviceType | null;
    typeDisplayName: string;
    zoneId?: string | null;
    name?: string | null;
    deviceId?: string | null;
    timestamp?: number | null;
    isConfigured?: boolean | null;
    meta?: {
      __typename?: 'DeviceMeta';
      name?: string | null;
      model?: string | null;
      modelNumber?: string | null;
      version?: string | null;
    } | null;
    zone?: { __typename?: 'Zone'; _id: string; name: string } | null;
    source?: { __typename?: 'Source'; _id: string; name: string } | null;
    isOn?: {
      __typename?: 'SmartPowerOutletIsOn';
      timestamp?: number | null;
      value?: boolean | null;
      units?: string | null;
    } | null;
    rmsVoltage?: {
      __typename?: 'SmartPowerOutletRmsVoltage';
      timestamp?: number | null;
      value?: number | null;
      units?: string | null;
    } | null;
    rmsCurrent?: {
      __typename?: 'SmartPowerOutletRmsCurrent';
      timestamp?: number | null;
      value?: number | null;
      units?: string | null;
    } | null;
    apparentPower?: {
      __typename?: 'SmartPowerOutletApparentPower';
      timestamp?: number | null;
      value?: number | null;
      units?: string | null;
    } | null;
    activePower?: {
      __typename?: 'SmartPowerOutletActivePower';
      timestamp?: number | null;
      value?: number | null;
      units?: string | null;
    } | null;
    powerFactor?: {
      __typename?: 'SmartPowerOutletPowerFactor';
      timestamp?: number | null;
      value?: number | null;
      units?: string | null;
    } | null;
    cumulativePower?: {
      __typename?: 'SmartPowerOutletCumulativePower';
      timestamp?: number | null;
      value?: number | null;
      units?: string | null;
    } | null;
    adjustedCumulativePower?: {
      __typename?: 'SmartPowerOutletAdjustedCumulativePower';
      timestamp?: number | null;
      value?: number | null;
      units?: string | null;
    } | null;
    deviceAlerts: Array<{
      __typename?: 'Alert';
      _id: string;
      initiated?: number | null;
      updated?: number | null;
      type?: { __typename?: 'AlertType'; name?: string | null } | null;
      device?: {
        __typename?: 'AlertDevice';
        id: string;
        name?: string | null;
        type: string;
      } | null;
    } | null>;
    sourceAlerts: Array<{
      __typename?: 'Alert';
      _id: string;
      initiated?: number | null;
      updated?: number | null;
      type?: { __typename?: 'AlertType'; name?: string | null } | null;
      device?: {
        __typename?: 'AlertDevice';
        id: string;
        name?: string | null;
        type: string;
      } | null;
    } | null>;
  };
};

export type TurnSmartPowerOutletOnMutationVariables = Exact<{
  deviceId: Scalars['String'];
  force?: InputMaybe<Scalars['Boolean']>;
}>;

export type TurnSmartPowerOutletOnMutation = {
  __typename?: 'Mutation';
  updateSmartOutletOnOffState: {
    __typename?: 'SmartPowerOutlet';
    _id: string;
    type?: EnumDKeyDeviceType | null;
    typeDisplayName: string;
    zoneId?: string | null;
    name?: string | null;
    deviceId?: string | null;
    timestamp?: number | null;
    isConfigured?: boolean | null;
    meta?: {
      __typename?: 'DeviceMeta';
      name?: string | null;
      model?: string | null;
      modelNumber?: string | null;
      version?: string | null;
    } | null;
    zone?: { __typename?: 'Zone'; _id: string; name: string } | null;
    source?: { __typename?: 'Source'; _id: string; name: string } | null;
    isOn?: {
      __typename?: 'SmartPowerOutletIsOn';
      timestamp?: number | null;
      value?: boolean | null;
      units?: string | null;
    } | null;
    rmsVoltage?: {
      __typename?: 'SmartPowerOutletRmsVoltage';
      timestamp?: number | null;
      value?: number | null;
      units?: string | null;
    } | null;
    rmsCurrent?: {
      __typename?: 'SmartPowerOutletRmsCurrent';
      timestamp?: number | null;
      value?: number | null;
      units?: string | null;
    } | null;
    apparentPower?: {
      __typename?: 'SmartPowerOutletApparentPower';
      timestamp?: number | null;
      value?: number | null;
      units?: string | null;
    } | null;
    activePower?: {
      __typename?: 'SmartPowerOutletActivePower';
      timestamp?: number | null;
      value?: number | null;
      units?: string | null;
    } | null;
    powerFactor?: {
      __typename?: 'SmartPowerOutletPowerFactor';
      timestamp?: number | null;
      value?: number | null;
      units?: string | null;
    } | null;
    cumulativePower?: {
      __typename?: 'SmartPowerOutletCumulativePower';
      timestamp?: number | null;
      value?: number | null;
      units?: string | null;
    } | null;
    adjustedCumulativePower?: {
      __typename?: 'SmartPowerOutletAdjustedCumulativePower';
      timestamp?: number | null;
      value?: number | null;
      units?: string | null;
    } | null;
    deviceAlerts: Array<{
      __typename?: 'Alert';
      _id: string;
      initiated?: number | null;
      updated?: number | null;
      type?: { __typename?: 'AlertType'; name?: string | null } | null;
      device?: {
        __typename?: 'AlertDevice';
        id: string;
        name?: string | null;
        type: string;
      } | null;
    } | null>;
    sourceAlerts: Array<{
      __typename?: 'Alert';
      _id: string;
      initiated?: number | null;
      updated?: number | null;
      type?: { __typename?: 'AlertType'; name?: string | null } | null;
      device?: {
        __typename?: 'AlertDevice';
        id: string;
        name?: string | null;
        type: string;
      } | null;
    } | null>;
  };
};

export type UpdateModbusAirHandlerMutationVariables = Exact<{
  id: Scalars['String'];
  updates: ModbusAirHandlerUpdateInput;
  fields?: InputMaybe<ModbusAirHandlerUpdateFields>;
  options?: InputMaybe<ModbusAirHandlerUpdateOptions>;
}>;

export type UpdateModbusAirHandlerMutation = {
  __typename?: 'Mutation';
  updateModbusAirHandler: {
    __typename?: 'ModbusAirHandler';
    _id: string;
    zoneId?: string | null;
    panelId?: string | null;
    sourceId?: string | null;
    deviceId?: string | null;
    name?: string | null;
    type?: EnumDKeyDeviceType | null;
    hasPendingUpdates: boolean;
    deviceMetrics?: Array<{
      __typename?: 'DeviceMetric';
      key: string;
      value: {
        __typename?: 'DeviceMetricSpec';
        defaultValue?: string | null;
        defaultUnit?: string | null;
        readOnly?: boolean | null;
        streamId?: string | null;
        timestamp?: string | null;
        unit?: string | null;
        units?: string | null;
        value?: string | null;
        valueType?: string | null;
        description?: string | null;
      };
    } | null> | null;
    alarmGlobalAlarm?: {
      __typename?: 'ModbusAirHandlerAlarmGlobalAlarm';
      timestamp?: number | null;
      value?: boolean | null;
      units?: string | null;
    } | null;
    alarmLowPressure?: {
      __typename?: 'ModbusAirHandlerAlarmLowPressure';
      timestamp?: number | null;
      value?: boolean | null;
      units?: string | null;
    } | null;
    alarmHighPressure?: {
      __typename?: 'ModbusAirHandlerAlarmHighPressure';
      timestamp?: number | null;
      value?: boolean | null;
      units?: string | null;
    } | null;
    alarmChangeFilters?: {
      __typename?: 'ModbusAirHandlerAlarmChangeFilters';
      timestamp?: number | null;
      value?: boolean | null;
      units?: string | null;
    } | null;
    alarmChangeHepa?: {
      __typename?: 'ModbusAirHandlerAlarmChangeHepa';
      timestamp?: number | null;
      value?: boolean | null;
      units?: string | null;
    } | null;
    alarmAirRestriction?: {
      __typename?: 'ModbusAirHandlerAlarmAirRestriction';
      timestamp?: number | null;
      value?: boolean | null;
      units?: string | null;
    } | null;
    alarmSupplyFanStopped?: {
      __typename?: 'ModbusAirHandlerAlarmSupplyFanStopped';
      timestamp?: number | null;
      value?: boolean | null;
      units?: string | null;
    } | null;
    alarmExhaustFanStopped?: {
      __typename?: 'ModbusAirHandlerAlarmExhaustFanStopped';
      timestamp?: number | null;
      value?: boolean | null;
      units?: string | null;
    } | null;
    alarmRefrigerantLeak?: {
      __typename?: 'ModbusAirHandlerAlarmRefrigerantLeak';
      timestamp?: number | null;
      value?: boolean | null;
      units?: string | null;
    } | null;
    alarmCompressorFail?: {
      __typename?: 'ModbusAirHandlerAlarmCompressorFail';
      timestamp?: number | null;
      value?: boolean | null;
      units?: string | null;
    } | null;
    alarmFanANegPressureOpt1?: {
      __typename?: 'ModbusAirHandlerAlarmFanANegPressureOpt1';
      timestamp?: number | null;
      value?: boolean | null;
      units?: string | null;
    } | null;
    alarmFanANegPressureOpt2?: {
      __typename?: 'ModbusAirHandlerAlarmFanANegPressureOpt2';
      timestamp?: number | null;
      value?: boolean | null;
      units?: string | null;
    } | null;
    alarmFanABReversed?: {
      __typename?: 'ModbusAirHandlerAlarmFanABReversed';
      timestamp?: number | null;
      value?: boolean | null;
      units?: string | null;
    } | null;
    alarmClockBoard?: {
      __typename?: 'ModbusAirHandlerAlarmClockBoard';
      timestamp?: number | null;
      value?: boolean | null;
      units?: string | null;
    } | null;
    alarmExtendedMemory?: {
      __typename?: 'ModbusAirHandlerAlarmExtendedMemory';
      timestamp?: number | null;
      value?: boolean | null;
      units?: string | null;
    } | null;
    alarmB1SensorFail?: {
      __typename?: 'ModbusAirHandlerAlarmB1SensorFail';
      timestamp?: number | null;
      value?: boolean | null;
      units?: string | null;
    } | null;
    alarmB2SensorFail?: {
      __typename?: 'ModbusAirHandlerAlarmB2SensorFail';
      timestamp?: number | null;
      value?: boolean | null;
      units?: string | null;
    } | null;
    alarmB3SensorFail?: {
      __typename?: 'ModbusAirHandlerAlarmB3SensorFail';
      timestamp?: number | null;
      value?: boolean | null;
      units?: string | null;
    } | null;
    alarmB4SensorFail?: {
      __typename?: 'ModbusAirHandlerAlarmB4SensorFail';
      timestamp?: number | null;
      value?: boolean | null;
      units?: string | null;
    } | null;
    alarmB6SensorFail?: {
      __typename?: 'ModbusAirHandlerAlarmB6SensorFail';
      timestamp?: number | null;
      value?: boolean | null;
      units?: string | null;
    } | null;
    zmbGlobalAlarm?: {
      __typename?: 'ModbusAirHandlerZmbGlobalAlarm';
      timestamp?: number | null;
      value?: boolean | null;
      units?: string | null;
    } | null;
    zmbThermostatAlarm?: {
      __typename?: 'ModbusAirHandlerZmbThermostatAlarm';
      timestamp?: number | null;
      value?: boolean | null;
      units?: string | null;
    } | null;
    zmbAirHandlerAlarm?: {
      __typename?: 'ModbusAirHandlerZmbAirHandlerAlarm';
      timestamp?: number | null;
      value?: boolean | null;
      units?: string | null;
    } | null;
    zmbLeakDetected?: {
      __typename?: 'ModbusAirHandlerZmbLeakDetected';
      timestamp?: number | null;
      value?: boolean | null;
      units?: string | null;
    } | null;
    ventilationMode?: {
      __typename?: 'ModbusAirHandlerVentilationMode';
      timestamp?: number | null;
      value?: string | null;
      units?: string | null;
    } | null;
    damperPosition?: {
      __typename?: 'ModbusAirHandlerDamperPosition';
      timestamp?: number | null;
      value?: string | null;
      units?: string | null;
    } | null;
    reversibleValveOnWhen?: {
      __typename?: 'ModbusAirHandlerReversibleValveOnWhen';
      timestamp?: number | null;
      value?: string | null;
      units?: string | null;
    } | null;
    recirculationModeOn?: {
      __typename?: 'ModbusAirHandlerRecirculationModeOn';
      timestamp?: number | null;
      value?: boolean | null;
      units?: string | null;
    } | null;
    airExchangeModeOn?: {
      __typename?: 'ModbusAirHandlerAirExchangeModeOn';
      timestamp?: number | null;
      value?: boolean | null;
      units?: string | null;
    } | null;
    supplyFanOn?: {
      __typename?: 'ModbusAirHandlerSupplyFanOn';
      timestamp?: number | null;
      value?: boolean | null;
      units?: string | null;
    } | null;
    supplyFanAirflow?: {
      __typename?: 'ModbusAirHandlerSupplyFanAirflow';
      timestamp?: number | null;
      value?: number | null;
      units?: string | null;
    } | null;
    supplyFanStaticPressureH2O?: {
      __typename?: 'ModbusAirHandlerSupplyFanStaticPressureH2O';
      timestamp?: number | null;
      value?: number | null;
      units?: string | null;
    } | null;
    exhaustFanOn?: {
      __typename?: 'ModbusAirHandlerExhaustFanOn';
      timestamp?: number | null;
      value?: boolean | null;
      units?: string | null;
    } | null;
    exhaustFanAirflow?: {
      __typename?: 'ModbusAirHandlerExhaustFanAirflow';
      timestamp?: number | null;
      value?: number | null;
      units?: string | null;
    } | null;
    systemOnOff?: {
      __typename?: 'ModbusAirHandlerSystemOnOff';
      timestamp?: number | null;
      value?: string | null;
      units?: string | null;
    } | null;
    systemAutoMode?: {
      __typename?: 'ModbusAirHandlerSystemAutoMode';
      timestamp?: number | null;
      value?: string | null;
      units?: string | null;
    } | null;
    heatPumpModeOn?: {
      __typename?: 'ModbusAirHandlerHeatPumpModeOn';
      timestamp?: number | null;
      value?: boolean | null;
      units?: string | null;
    } | null;
    heatingElementOn?: {
      __typename?: 'ModbusAirHandlerHeatingElementOn';
      timestamp?: number | null;
      value?: boolean | null;
      units?: string | null;
    } | null;
    compressorOn?: {
      __typename?: 'ModbusAirHandlerCompressorOn';
      timestamp?: number | null;
      value?: boolean | null;
      units?: string | null;
    } | null;
    indoorTemperature?: {
      __typename?: 'ModbusAirHandlerIndoorTemperature';
      timestamp?: number | null;
      value?: number | null;
      units?: string | null;
    } | null;
    outsideTemperature?: {
      __typename?: 'ModbusAirHandlerOutsideTemperature';
      timestamp?: number | null;
      value?: number | null;
      units?: string | null;
    } | null;
    indoorRH?: {
      __typename?: 'ModbusAirHandlerIndoorRH';
      timestamp?: number | null;
      value?: number | null;
      units?: string | null;
    } | null;
    defrostTemperature?: {
      __typename?: 'ModbusAirHandlerDefrostTemperature';
      timestamp?: number | null;
      value?: number | null;
      units?: string | null;
    } | null;
    conditionedTemperature?: {
      __typename?: 'ModbusAirHandlerConditionedTemperature';
      timestamp?: number | null;
      value?: number | null;
      units?: string | null;
    } | null;
    ahuCoolSetpoint?: {
      __typename?: 'ModbusAirHandlerAhuCoolSetpoint';
      timestamp?: number | null;
      value?: number | null;
      units?: string | null;
    } | null;
    ahuHeatSetpoint?: {
      __typename?: 'ModbusAirHandlerAhuHeatSetpoint';
      timestamp?: number | null;
      value?: number | null;
      units?: string | null;
    } | null;
    ahuMinCoolSetpointLimit?: {
      __typename?: 'ModbusAirHandlerAhuMinCoolSetpointLimit';
      timestamp?: number | null;
      value?: number | null;
      units?: string | null;
    } | null;
    ahuMaxHeatSetpointLimit?: {
      __typename?: 'ModbusAirHandlerAhuMaxHeatSetpointLimit';
      timestamp?: number | null;
      value?: number | null;
      units?: string | null;
    } | null;
    gTerminalOn?: {
      __typename?: 'ModbusAirHandlerGTerminalOn';
      timestamp?: number | null;
      value?: boolean | null;
      units?: string | null;
    } | null;
    hTerminalOn?: {
      __typename?: 'ModbusAirHandlerHTerminalOn';
      timestamp?: number | null;
      value?: boolean | null;
      units?: string | null;
    } | null;
    wTerminalOn?: {
      __typename?: 'ModbusAirHandlerWTerminalOn';
      timestamp?: number | null;
      value?: boolean | null;
      units?: string | null;
    } | null;
    yTerminalOn?: {
      __typename?: 'ModbusAirHandlerYTerminalOn';
      timestamp?: number | null;
      value?: boolean | null;
      units?: string | null;
    } | null;
    softwareReleaseType?: {
      __typename?: 'ModbusAirHandlerSoftwareReleaseType';
      timestamp?: number | null;
      value?: string | null;
      units?: string | null;
    } | null;
    softwareVersion?: {
      __typename?: 'ModbusAirHandlerSoftwareVersion';
      timestamp?: number | null;
      value?: number | null;
      units?: string | null;
    } | null;
    bootVersion?: {
      __typename?: 'ModbusAirHandlerBootVersion';
      timestamp?: number | null;
      value?: number | null;
      units?: string | null;
    } | null;
    biosVersion?: {
      __typename?: 'ModbusAirHandlerBiosVersion';
      timestamp?: number | null;
      value?: number | null;
      units?: string | null;
    } | null;
    allowTenantOnOff?: {
      __typename?: 'ModbusAirHandlerAllowTenantOnOff';
      timestamp?: number | null;
      value?: boolean | null;
      units?: string | null;
    } | null;
    enableTenantMode?: {
      __typename?: 'ModbusAirHandlerEnableTenantMode';
      timestamp?: number | null;
      value?: boolean | null;
      units?: string | null;
    } | null;
    allowTenantChangeRHSetpoint?: {
      __typename?: 'ModbusAirHandlerAllowTenantChangeRHSetpoint';
      timestamp?: number | null;
      value?: boolean | null;
      units?: string | null;
    } | null;
    allowTenantChangeTempSetpoints?: {
      __typename?: 'ModbusAirHandlerAllowTenantChangeTempSetpoints';
      timestamp?: number | null;
      value?: boolean | null;
      units?: string | null;
    } | null;
    tenantModePassword?: {
      __typename?: 'ModbusAirHandlerTenantModePassword';
      timestamp?: number | null;
      value?: string | null;
      units?: string | null;
    } | null;
    airflowUnits?: {
      __typename?: 'ModbusAirHandlerAirflowUnits';
      timestamp?: number | null;
      value?: string | null;
      units?: string | null;
    } | null;
    ahuModbusId?: {
      __typename?: 'ModbusAirHandlerAhuModbusId';
      timestamp?: number | null;
      value?: number | null;
      units?: string | null;
    } | null;
    altitude?: {
      __typename?: 'ModbusAirHandlerAltitude';
      timestamp?: number | null;
      value?: number | null;
      units?: string | null;
    } | null;
    freshAirSetpoint?: {
      __typename?: 'ModbusAirHandlerFreshAirSetpoint';
      timestamp?: number | null;
      value?: number | null;
      units?: string | null;
    } | null;
    rhSetpoint?: {
      __typename?: 'ModbusAirHandlerRhSetpoint';
      timestamp?: number | null;
      value?: number | null;
      units?: string | null;
    } | null;
    auxCoolingEnabled?: {
      __typename?: 'ModbusAirHandlerAuxCoolingEnabled';
      timestamp?: number | null;
      value?: boolean | null;
      units?: string | null;
    } | null;
    winterRhAdjustEnabled?: {
      __typename?: 'ModbusAirHandlerWinterRhAdjustEnabled';
      timestamp?: number | null;
      value?: boolean | null;
      units?: string | null;
    } | null;
    showerDetectorEnabled?: {
      __typename?: 'ModbusAirHandlerShowerDetectorEnabled';
      timestamp?: number | null;
      value?: boolean | null;
      units?: string | null;
    } | null;
    resetFiltersServiceTime?: {
      __typename?: 'ModbusAirHandlerResetFiltersServiceTime';
      timestamp?: number | null;
      value?: string | null;
      units?: string | null;
    } | null;
    resetHepaServiceTime?: {
      __typename?: 'ModbusAirHandlerResetHepaServiceTime';
      timestamp?: number | null;
      value?: string | null;
      units?: string | null;
    } | null;
    zmbPollingFrequency?: {
      __typename?: 'ModbusAirHandlerZmbPollingFrequency';
      timestamp?: number | null;
      value?: number | null;
      units?: string | null;
    } | null;
    zmbModbusRequestDelay?: {
      __typename?: 'ModbusAirHandlerZmbModbusRequestDelay';
      timestamp?: number | null;
      value?: number | null;
      units?: string | null;
    } | null;
    zmbFirmwareVersion?: {
      __typename?: 'ModbusAirHandlerZmbFirmwareVersion';
      timestamp?: number | null;
      value?: string | null;
      units?: string | null;
    } | null;
    zmbSystemUptime?: {
      __typename?: 'ModbusAirHandlerZmbSystemUptime';
      timestamp?: number | null;
      value?: number | null;
      units?: string | null;
    } | null;
    zmbTstatRequestsRecvd?: {
      __typename?: 'ModbusAirHandlerZmbTstatRequestsRecvd';
      timestamp?: number | null;
      value?: number | null;
      units?: string | null;
    } | null;
    zmbRequestsRecvdInvalid?: {
      __typename?: 'ModbusAirHandlerZmbRequestsRecvdInvalid';
      timestamp?: number | null;
      value?: number | null;
      units?: string | null;
    } | null;
    zmbAhuRequestsSent?: {
      __typename?: 'ModbusAirHandlerZmbAhuRequestsSent';
      timestamp?: number | null;
      value?: number | null;
      units?: string | null;
    } | null;
    zmbAhuRequestsSentFailed?: {
      __typename?: 'ModbusAirHandlerZmbAhuRequestsSentFailed';
      timestamp?: number | null;
      value?: number | null;
      units?: string | null;
    } | null;
    zmbCoreRequestsRecvd?: {
      __typename?: 'ModbusAirHandlerZmbCoreRequestsRecvd';
      timestamp?: number | null;
      value?: number | null;
      units?: string | null;
    } | null;
    zmbLeakDetectorInstalled?: {
      __typename?: 'ModbusAirHandlerZmbLeakDetectorInstalled';
      timestamp?: number | null;
      value?: boolean | null;
      units?: string | null;
    } | null;
    zmbCpuTemperature?: {
      __typename?: 'ModbusAirHandlerZmbCpuTemperature';
      timestamp?: number | null;
      value?: number | null;
      units?: string | null;
    } | null;
    temperatureUnits?: {
      __typename?: 'ModbusAirHandlerTemperatureUnits';
      timestamp?: number | null;
      value?: string | null;
      units?: string | null;
    } | null;
    filtersServiceTime?: {
      __typename?: 'ModbusAirHandlerFiltersServiceTime';
      timestamp?: number | null;
      value?: number | null;
      units?: string | null;
    } | null;
    hepaServiceTime?: {
      __typename?: 'ModbusAirHandlerHepaServiceTime';
      timestamp?: number | null;
      value?: number | null;
      units?: string | null;
    } | null;
  };
};

export type UpdateThermostatMutationVariables = Exact<{
  id: Scalars['String'];
  updates: ThermostatUpdateInput;
  fields?: InputMaybe<ThermostatUpdateFields>;
  options?: InputMaybe<ThermostatUpdateOptions>;
}>;

export type UpdateThermostatMutation = {
  __typename?: 'Mutation';
  updateThermostat: {
    __typename?: 'Thermostat';
    _id: string;
    zoneId?: string | null;
    panelId?: string | null;
    sourceId?: string | null;
    deviceId?: string | null;
    name?: string | null;
    type?: EnumDKeyDeviceType | null;
    hasPendingUpdates: boolean;
    isMitsubishiThermostat: boolean;
    supportsAutoMode: boolean;
    supportsSingleSetpointAutoMode: boolean;
    supportsDualSetpointAutoMode: boolean;
    thermostatScheduleTemplateId?: string | null;
    modbusRTU: boolean;
    keypadLockoutLevels: Array<string>;
    useCustomSetpointLimits?: boolean | null;
    useCustomSchedule?: boolean | null;
    localControlPermissionsV1?: {
      __typename?: 'ThermostatLocalControlPermissionsV1';
      canEdit: boolean;
      pending: boolean;
      observedAt?: number | null;
      value: {
        __typename?: 'ThermostatLocalPermissionsValueV1';
        power: string;
        operatingMode: string;
        temperature: string;
        fanSpeed: string;
        louvre: string;
        filterReset: string;
        timer: string;
      };
    } | null;
    louvreControlV1?: {
      __typename?: 'ThermostatLouvreControlV1';
      supportsAirDirection: boolean;
      canEditAirDirection: boolean;
      allowedAirDirections: Array<string>;
      airDirection: {
        __typename?: 'ThermostatSeparateAirDirectionMetricV1';
        value?: string | null;
        readingId?: string | null;
        timestamp?: number | null;
        observedAt?: number | null;
        pending: boolean;
      };
    } | null;
    separatePowerControlV1?: {
      __typename?: 'ThermostatSeparatePowerControlV1';
      controlContract: string;
      canEditPowerMode: boolean;
      canEditOperatingMode: boolean;
      supportsAirDirection: boolean;
      canEditAirDirection: boolean;
      allowedAirDirections: Array<string>;
      canEditFanSpeed: boolean;
      allowedFanSpeeds: Array<string>;
      allowedOperatingModes: Array<string>;
      canEditTargets: boolean;
      targetBlockReason?: string | null;
      airDirection: {
        __typename?: 'ThermostatSeparateAirDirectionMetricV1';
        value?: string | null;
        readingId?: string | null;
        timestamp?: number | null;
        observedAt?: number | null;
        pending: boolean;
      };
      fanSpeed: {
        __typename?: 'ThermostatSeparateFanSpeedMetricV1';
        value?: string | null;
        readingId?: string | null;
        timestamp?: number | null;
        observedAt?: number | null;
        pending: boolean;
      };
      powerMode: {
        __typename?: 'ThermostatSeparatePowerModeMetricV1';
        value?: string | null;
        readingId?: string | null;
        timestamp?: number | null;
        observedAt?: number | null;
        pending: boolean;
      };
      powerState: {
        __typename?: 'ThermostatSeparatePowerStateMetricV1';
        value?: string | null;
        readingId?: string | null;
        timestamp?: number | null;
        observedAt?: number | null;
        pending: boolean;
      };
      operatingMode: {
        __typename?: 'ThermostatSeparateOperatingModeMetricV1';
        value?: string | null;
        readingId?: string | null;
        timestamp?: number | null;
        observedAt?: number | null;
        pending: boolean;
      };
      operatingState: {
        __typename?: 'ThermostatSeparateOperatingStateMetricV1';
        value?: string | null;
        readingId?: string | null;
        timestamp?: number | null;
        observedAt?: number | null;
        pending: boolean;
      };
    } | null;
    setpoint?: {
      __typename?: 'ThermostatSetpoint';
      value?: number | null;
      units?: string | null;
      timestamp?: number | null;
      updatePending?: boolean | null;
    } | null;
    minSetpoint?: {
      __typename?: 'ThermostatMinSetpoint';
      value?: number | null;
      units?: string | null;
      timestamp?: number | null;
    } | null;
    maxSetpoint?: {
      __typename?: 'ThermostatMaxSetpoint';
      value?: number | null;
      units?: string | null;
      timestamp?: number | null;
    } | null;
    deviceMetrics?: Array<{
      __typename?: 'DeviceMetric';
      key: string;
      value: {
        __typename?: 'DeviceMetricSpec';
        defaultValue?: string | null;
        defaultUnit?: string | null;
        readOnly?: boolean | null;
        streamId?: string | null;
        timestamp?: string | null;
        unit?: string | null;
        units?: string | null;
        value?: string | null;
        valueType?: string | null;
      };
    } | null> | null;
    fanMode?: {
      __typename?: 'ThermostatFanMode';
      timestamp?: number | null;
      value?: EnumThermostatFanModeValue | null;
      units?: string | null;
    } | null;
    fanSpeed?: {
      __typename?: 'ThermostatFanSpeed';
      timestamp?: number | null;
      value?: EnumThermostatFanSpeedValue | null;
      units?: string | null;
    } | null;
    fanState?: {
      __typename?: 'ThermostatFanState';
      timestamp?: number | null;
      value?: EnumThermostatFanStateValue | null;
      units?: string | null;
    } | null;
    holdDuration?: {
      __typename?: 'ThermostatHoldDuration';
      timestamp?: number | null;
      value?: number | null;
      units?: string | null;
    } | null;
    holdEnd?: {
      __typename?: 'ThermostatHoldEnd';
      timestamp?: number | null;
      value?: number | null;
      units?: string | null;
    } | null;
    holdState?: {
      __typename?: 'ThermostatHoldState';
      timestamp?: number | null;
      value?: EnumThermostatHoldStateValue | null;
      units?: string | null;
    } | null;
    humidity?: {
      __typename?: 'ThermostatHumidity';
      timestamp?: number | null;
      value?: number | null;
      units?: string | null;
    } | null;
    keypadLockoutLevel?: {
      __typename?: 'ThermostatKeypadLockoutLevel';
      timestamp?: number | null;
      value?: string | null;
      units?: string | null;
    } | null;
    lastScheduleChange?: {
      __typename?: 'ThermostatLastScheduleChange';
      timestamp?: number | null;
      value?: number | null;
      units?: string | null;
    } | null;
    lastSetpointChange?: {
      __typename?: 'ThermostatLastSetpointChange';
      timestamp?: number | null;
      value?: number | null;
      units?: string | null;
    } | null;
    maxCoolSetpointLimit?: {
      __typename?: 'ThermostatMaxCoolSetpointLimit';
      timestamp?: number | null;
      value?: number | null;
      units?: string | null;
    } | null;
    maxHeatSetpointLimit?: {
      __typename?: 'ThermostatMaxHeatSetpointLimit';
      timestamp?: number | null;
      value?: number | null;
      units?: string | null;
    } | null;
    minCoolSetpointLimit?: {
      __typename?: 'ThermostatMinCoolSetpointLimit';
      timestamp?: number | null;
      value?: number | null;
      units?: string | null;
    } | null;
    minHeatSetpointLimit?: {
      __typename?: 'ThermostatMinHeatSetpointLimit';
      timestamp?: number | null;
      value?: number | null;
      units?: string | null;
    } | null;
    operatingMode?: {
      __typename?: 'ThermostatOperatingMode';
      timestamp?: number | null;
      value?: EnumThermostatOperatingModeValue | null;
      units?: string | null;
    } | null;
    operatingState?: {
      __typename?: 'ThermostatOperatingState';
      timestamp?: number | null;
      value?: EnumThermostatOperatingStateValue | null;
      units?: string | null;
    } | null;
    passCode?: {
      __typename?: 'ThermostatPassCode';
      timestamp?: number | null;
      value?: number | null;
      units?: string | null;
    } | null;
    progMode?: {
      __typename?: 'ThermostatProgMode';
      timestamp?: number | null;
      value?: EnumThermostatProgModeValue | null;
      units?: string | null;
    } | null;
    remoteSensorTempDelta?: {
      __typename?: 'ThermostatRemoteSensorTempDelta';
      timestamp?: number | null;
      value?: number | null;
      units?: string | null;
    } | null;
    schedVisibilityMode?: {
      __typename?: 'ThermostatSchedVisibilityMode';
      timestamp?: number | null;
      value?: EnumThermostatSchedVisibilityModeValue | null;
      units?: string | null;
    } | null;
    setpointChangeSource?: {
      __typename?: 'ThermostatSetpointChangeSource';
      timestamp?: number | null;
      value?: EnumThermostatSetpointChangeSourceValue | null;
      units?: string | null;
    } | null;
    showFanButton?: {
      __typename?: 'ThermostatShowFanButton';
      timestamp?: number | null;
      value?: boolean | null;
      units?: string | null;
    } | null;
    systemType?: {
      __typename?: 'ThermostatSystemType';
      timestamp?: number | null;
      value?: EnumThermostatSystemTypeValue | null;
      units?: string | null;
    } | null;
    tempDisplayMode?: {
      __typename?: 'ThermostatTempDisplayMode';
      timestamp?: number | null;
      value?: EnumThermostatTempDisplayModeValue | null;
      units?: string | null;
    } | null;
    temperature?: {
      __typename?: 'ThermostatTemperature';
      timestamp?: number | null;
      value?: number | null;
      units?: string | null;
    } | null;
    uiOptions?: {
      __typename?: 'ThermostatUiOptions';
      timestamp?: number | null;
      value?: number | null;
      units?: string | null;
    } | null;
    heatSetpoint?: {
      __typename?: 'ThermostatHeatSetpoint';
      timestamp?: number | null;
      value?: number | null;
    } | null;
    coolSetpoint?: {
      __typename?: 'ThermostatCoolSetpoint';
      timestamp?: number | null;
      value?: number | null;
    } | null;
  };
};

export type UpdateThermostatPendingScheduleMutationVariables = Exact<{
  deviceId: Scalars['String'];
  update: ThermostatPendingScheduleInput;
}>;

export type UpdateThermostatPendingScheduleMutation = {
  __typename?: 'Mutation';
  updateThermostatPendingSchedule: {
    __typename?: 'Thermostat';
    deviceId?: string | null;
  };
};

export type WindowSensorDetailUpdateSubscriptionVariables = Exact<{
  ids: Array<Scalars['String']> | Scalars['String'];
}>;

export type WindowSensorDetailUpdateSubscription = {
  __typename?: 'Subscription';
  windowSensorEventsByIds?: {
    __typename?: 'WindowSensor';
    modelChangeOperation?: string | null;
    _id: string;
    type?: EnumDKeyDeviceType | null;
    typeDisplayName: string;
    zoneId?: string | null;
    name?: string | null;
    deviceId?: string | null;
    timestamp?: number | null;
    isConfigured?: boolean | null;
    hasContactState?: boolean | null;
    meta?: {
      __typename?: 'DeviceMeta';
      name?: string | null;
      model?: string | null;
      modelNumber?: string | null;
      version?: string | null;
    } | null;
    contactState?: {
      __typename?: 'WindowSensorContactState';
      timestamp?: number | null;
      value?: string | null;
      units?: string | null;
    } | null;
    voltage?: {
      __typename?: 'WindowSensorVoltage';
      timestamp?: number | null;
      value?: number | null;
      units?: string | null;
    } | null;
    deviceAlerts: Array<{
      __typename?: 'Alert';
      _id: string;
      initiated?: number | null;
      updated?: number | null;
      type?: { __typename?: 'AlertType'; name?: string | null } | null;
      device?: {
        __typename?: 'AlertDevice';
        id: string;
        name?: string | null;
        type: string;
      } | null;
    } | null>;
    sourceAlerts: Array<{
      __typename?: 'Alert';
      _id: string;
      initiated?: number | null;
      updated?: number | null;
      type?: { __typename?: 'AlertType'; name?: string | null } | null;
      device?: {
        __typename?: 'AlertDevice';
        id: string;
        name?: string | null;
        type: string;
      } | null;
    } | null>;
  } | null;
};

export type WindowSensorDetailQueryVariables = Exact<{
  id: Scalars['String'];
}>;

export type WindowSensorDetailQuery = {
  __typename?: 'Query';
  windowSensorById?: {
    __typename?: 'WindowSensor';
    _id: string;
    type?: EnumDKeyDeviceType | null;
    typeDisplayName: string;
    zoneId?: string | null;
    name?: string | null;
    deviceId?: string | null;
    timestamp?: number | null;
    isConfigured?: boolean | null;
    hasContactState?: boolean | null;
    meta?: {
      __typename?: 'DeviceMeta';
      name?: string | null;
      model?: string | null;
      modelNumber?: string | null;
      version?: string | null;
    } | null;
    zone?: { __typename?: 'Zone'; _id: string; name: string } | null;
    source?: { __typename?: 'Source'; _id: string; name: string } | null;
    contactState?: {
      __typename?: 'WindowSensorContactState';
      timestamp?: number | null;
      value?: string | null;
      units?: string | null;
    } | null;
    voltage?: {
      __typename?: 'WindowSensorVoltage';
      timestamp?: number | null;
      value?: number | null;
      units?: string | null;
    } | null;
    deviceAlerts: Array<{
      __typename?: 'Alert';
      _id: string;
      initiated?: number | null;
      updated?: number | null;
      type?: { __typename?: 'AlertType'; name?: string | null } | null;
      device?: {
        __typename?: 'AlertDevice';
        id: string;
        name?: string | null;
        type: string;
      } | null;
    } | null>;
    sourceAlerts: Array<{
      __typename?: 'Alert';
      _id: string;
      initiated?: number | null;
      updated?: number | null;
      type?: { __typename?: 'AlertType'; name?: string | null } | null;
      device?: {
        __typename?: 'AlertDevice';
        id: string;
        name?: string | null;
        type: string;
      } | null;
    } | null>;
  } | null;
};

export type CreateThermostatScheduleTemplateMutationVariables = Exact<{
  thermostatScheduleTemplate: CreateOneThermostatScheduleTemplateInput;
}>;

export type CreateThermostatScheduleTemplateMutation = {
  __typename?: 'Mutation';
  createThermostatScheduleTemplate: string;
};

export type PropertyDataForScheduleTemplatesUpdatesSubscriptionVariables =
  Exact<{
    id: Scalars['String'];
  }>;

export type PropertyDataForScheduleTemplatesUpdatesSubscription = {
  __typename?: 'Subscription';
  propertyEventsByIds?: {
    __typename?: 'Property';
    modelChangeOperation?: string | null;
    _id: string;
    setpointProfileId?: string | null;
    thermostatScheduleTemplateId?: string | null;
  } | null;
};

export type PropertyDataForScheduleTemplatesQueryVariables = Exact<{
  id: Scalars['String'];
}>;

export type PropertyDataForScheduleTemplatesQuery = {
  __typename?: 'Query';
  propertyById?: {
    __typename?: 'Property';
    _id: string;
    setpointProfileId?: string | null;
    thermostatScheduleTemplateId?: string | null;
  } | null;
};

export type PropertyScheduleTemplateListQueryVariables = Exact<{
  propertyId: Scalars['String'];
}>;

export type PropertyScheduleTemplateListQuery = {
  __typename?: 'Query';
  thermostatScheduleTemplates: Array<{
    __typename?: 'ThermostatScheduleTemplate';
    _id: string;
    propertyId: string;
    assignedUnitCount?: number | null;
    assignedDeviceCount?: number | null;
    setpointLimitProfileId?: string | null;
    isPropertyDefault?: boolean | null;
    name: string;
    value: {
      __typename?: 'ThermostatScheduleTemplateValue';
      id?: string | null;
      units?: string | null;
      timestamp?: number | null;
      value?: any | null;
      updatePending?: boolean | null;
    };
  }>;
};

export type RemoveThermostatScheduleTemplateMutationVariables = Exact<{
  removeThermostatScheduleTemplateId: Scalars['String'];
}>;

export type RemoveThermostatScheduleTemplateMutation = {
  __typename?: 'Mutation';
  removeThermostatScheduleTemplate: string;
};

export type ScheduleTemplateBySetpointProfileIdQueryVariables = Exact<{
  setpointProfileId: Scalars['String'];
}>;

export type ScheduleTemplateBySetpointProfileIdQuery = {
  __typename?: 'Query';
  thermostatScheduleTemplates: Array<{
    __typename?: 'ThermostatScheduleTemplate';
    _id: string;
  }>;
};

export type UnitDataForScheduleTemplatesUpdatesSubscriptionVariables = Exact<{
  id: Scalars['String'];
}>;

export type UnitDataForScheduleTemplatesUpdatesSubscription = {
  __typename?: 'Subscription';
  unitEventsByIds?: {
    __typename?: 'Unit';
    modelChangeOperation?: string | null;
    _id: string;
    setpointProfileId?: string | null;
    thermostatScheduleTemplateId?: string | null;
  } | null;
};

export type UnitDataForScheduleTemplatesQueryVariables = Exact<{
  id: Scalars['String'];
}>;

export type UnitDataForScheduleTemplatesQuery = {
  __typename?: 'Query';
  unitById?: {
    __typename?: 'Unit';
    _id: string;
    setpointProfileId?: string | null;
    thermostatScheduleTemplateId?: string | null;
  } | null;
};

export type UpdatePropertyThermostatScheduleTemplateOverrideMutationVariables =
  Exact<{
    id: Scalars['String'];
    thermostatScheduleTemplateId: Scalars['String'];
    propertyHasIncompatibleScheduleTemplate?: InputMaybe<Scalars['Boolean']>;
    targetThermostatIds?: InputMaybe<
      Array<InputMaybe<Scalars['String']>> | InputMaybe<Scalars['String']>
    >;
    force?: InputMaybe<Scalars['Boolean']>;
  }>;

export type UpdatePropertyThermostatScheduleTemplateOverrideMutation = {
  __typename?: 'Mutation';
  updatePropertyThermostatScheduleTemplateOverride: {
    __typename?: 'Property';
    thermostatScheduleTemplateId?: string | null;
  };
};

export type UpdateThermostatScheduleTemplateMutationVariables = Exact<{
  thermostatScheduleTemplate: UpdateOneThermostatScheduleTemplateInput;
}>;

export type UpdateThermostatScheduleTemplateMutation = {
  __typename?: 'Mutation';
  updateThermostatScheduleTemplate: {
    __typename?: 'ThermostatScheduleTemplate';
    _id: string;
    name: string;
    propertyId: string;
    setpointLimitProfileId?: string | null;
    value: {
      __typename?: 'ThermostatScheduleTemplateValue';
      id?: string | null;
      units?: string | null;
      timestamp?: number | null;
      updatePending?: boolean | null;
      value?: any | null;
    };
  };
};

export type UpdateUnitThermostatScheduleTemplateOverrideMutationVariables =
  Exact<{
    id: Scalars['String'];
    thermostatScheduleTemplateId: Scalars['String'];
    unitHasIncompatibleScheduleTemplate?: InputMaybe<Scalars['Boolean']>;
    targetThermostatIds?: InputMaybe<
      Array<InputMaybe<Scalars['String']>> | InputMaybe<Scalars['String']>
    >;
    force?: InputMaybe<Scalars['Boolean']>;
  }>;

export type UpdateUnitThermostatScheduleTemplateOverrideMutation = {
  __typename?: 'Mutation';
  updateUnitThermostatScheduleTemplateOverride: {
    __typename?: 'Unit';
    thermostatScheduleTemplateId?: string | null;
  };
};

export type ScheduledNotificationsSubscriptionSubscriptionVariables = Exact<{
  [key: string]: never;
}>;

export type ScheduledNotificationsSubscriptionSubscription = {
  __typename?: 'Subscription';
  systemNotificationEvents?: {
    __typename?: 'SystemNotification';
    modelChangeOperation?: string | null;
    _id: string;
    entityId: string;
    entityType: string;
    message: string;
    link?: string | null;
    createdAt: number;
    displayStart: number;
    displayEnd: number;
    acknowledgedAt?: number | null;
    seenAt?: number | null;
    requireAcknowledgement: boolean;
    relatedEntityName?: string | null;
    seenBy?: Array<{
      __typename?: 'SystemNotificationSeenBy';
      userId: string;
      seenAt: number;
    } | null> | null;
  } | null;
};

export type ScheduledNotificationsQueryVariables = Exact<{
  [key: string]: never;
}>;

export type ScheduledNotificationsQuery = {
  __typename?: 'Query';
  systemNotifications: Array<{
    __typename?: 'SystemNotification';
    _id: string;
    entityId: string;
    entityType: string;
    message: string;
    link?: string | null;
    createdAt: number;
    displayStart: number;
    displayEnd: number;
    acknowledgedAt?: number | null;
    seenAt?: number | null;
    requireAcknowledgement: boolean;
    relatedEntityName?: string | null;
    seenBy?: Array<{
      __typename?: 'SystemNotificationSeenBy';
      userId: string;
      seenAt: number;
    } | null> | null;
  }>;
};

export type ScheduleTaskMutationVariables = Exact<{
  modelName: Scalars['String'];
  instanceId: Scalars['String'];
  methodName: Scalars['String'];
  scheduledAt: Scalars['Float'];
  priority?: InputMaybe<Scalars['Int']>;
  maxRetries?: InputMaybe<Scalars['Int']>;
}>;

export type ScheduleTaskMutation = {
  __typename?: 'Mutation';
  scheduleTask?: {
    __typename?: 'ScheduledTask';
    _id: string;
    modelName: string;
    instanceId: string;
    methodName: string;
    scheduledAt: number;
    status: EnumScheduledTaskStatus;
    priority: number;
    maxRetries: number;
    createdAt: number;
    updatedAt: number;
  } | null;
};

export type CancelScheduledTaskMutationVariables = Exact<{
  taskId: Scalars['String'];
}>;

export type CancelScheduledTaskMutation = {
  __typename?: 'Mutation';
  cancelScheduledTask: boolean;
};

export type GetScheduledTasksQueryVariables = Exact<{
  status?: InputMaybe<Scalars['String']>;
  limit?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
}>;

export type GetScheduledTasksQuery = {
  __typename?: 'Query';
  scheduledTasks: Array<{
    __typename?: 'ScheduledTask';
    _id: string;
    modelName: string;
    instanceId: string;
    methodName: string;
    scheduledAt: number;
    startedAt?: number | null;
    completedAt?: number | null;
    executionTimeMs?: number | null;
    status: EnumScheduledTaskStatus;
    errorMessage?: string | null;
    retryCount: number;
    maxRetries: number;
    priority: number;
    createdAt: number;
    updatedAt: number;
  }>;
};

export type GetScheduledTaskByIdQueryVariables = Exact<{
  taskId: Scalars['String'];
}>;

export type GetScheduledTaskByIdQuery = {
  __typename?: 'Query';
  scheduledTaskById?: {
    __typename?: 'ScheduledTask';
    _id: string;
    modelName: string;
    instanceId: string;
    methodName: string;
    scheduledAt: number;
    startedAt?: number | null;
    completedAt?: number | null;
    executionTimeMs?: number | null;
    status: EnumScheduledTaskStatus;
    errorMessage?: string | null;
    retryCount: number;
    maxRetries: number;
    priority: number;
    createdAt: number;
    updatedAt: number;
  } | null;
};

export type CreateSetpointProfileMutationVariables = Exact<{
  profile: CreateOneSetpointProfileInput;
}>;

export type CreateSetpointProfileMutation = {
  __typename?: 'Mutation';
  createSetpointProfile?: {
    __typename?: 'SetpointProfile';
    _id: string;
    name?: string | null;
    properties?: Array<string | null> | null;
    createdAt?: number | null;
    updatedAt?: number | null;
    heat?: {
      __typename?: 'SetpointProfileHeat';
      max?: number | null;
      min?: number | null;
    } | null;
    cool?: {
      __typename?: 'SetpointProfileCool';
      max?: number | null;
      min?: number | null;
    } | null;
    creator?: { __typename?: 'User'; _id: string; name: string } | null;
    lastUpdatedBy?: { __typename?: 'User'; name: string } | null;
  } | null;
};

export type PropertySetpointProfilesQueryVariables = Exact<{
  id: Scalars['String'];
}>;

export type PropertySetpointProfilesQuery = {
  __typename?: 'Query';
  propertyById?: {
    __typename?: 'Property';
    _id: string;
    title: string;
    setpointProfileId?: string | null;
    thermostatScheduleTemplateId?: string | null;
    assignableSetpointProfiles?: Array<{
      __typename?: 'SetpointProfile';
      _id: string;
      name?: string | null;
      properties?: Array<string | null> | null;
      assignedProperties: Array<{ __typename: 'Property'; _id: string } | null>;
      assignedUnits: Array<{ __typename: 'Unit'; _id: string } | null>;
      enabledProperties: Array<{ __typename: 'Property'; _id: string } | null>;
      heat?: {
        __typename?: 'SetpointProfileHeat';
        max?: number | null;
        min?: number | null;
      } | null;
      cool?: {
        __typename?: 'SetpointProfileCool';
        max?: number | null;
        min?: number | null;
      } | null;
    }> | null;
  } | null;
};

export type RemoveSetpointProfileMutationVariables = Exact<{
  id: Scalars['String'];
}>;

export type RemoveSetpointProfileMutation = {
  __typename?: 'Mutation';
  removeSetpointProfile: string;
};

export type SetpointProfileBulkConfigUpdateSubscriptionVariables = Exact<{
  id: Scalars['String'];
}>;

export type SetpointProfileBulkConfigUpdateSubscription = {
  __typename?: 'Subscription';
  bulkConfigProgressUpdate?: {
    __typename?: 'BulkConfigStatus';
    initiatorId?: string | null;
    initiatorType?: string | null;
    totalCount?: number | null;
    errorCount?: number | null;
    completedCount?: number | null;
    errors: Array<{
      __typename?: 'BulkConfigError';
      deviceType?: string | null;
      deviceName?: string | null;
      deviceId?: string | null;
      message?: string | null;
    } | null>;
  } | null;
};

export type SetpointProfileCountQueryVariables = Exact<{
  [key: string]: never;
}>;

export type SetpointProfileCountQuery = {
  __typename?: 'Query';
  setpointProfileCount?: number | null;
};

export type SetpointProfileDetailUpdateSubscriptionVariables = Exact<{
  ids: Array<Scalars['String']> | Scalars['String'];
}>;

export type SetpointProfileDetailUpdateSubscription = {
  __typename?: 'Subscription';
  setpointProfileEventsByIds?: {
    __typename?: 'SetpointProfile';
    modelChangeOperation?: string | null;
    _id: string;
    name?: string | null;
    properties?: Array<string | null> | null;
    units?: EnumSetpointProfileUnits | null;
    heat?: {
      __typename?: 'SetpointProfileHeat';
      max?: number | null;
      min?: number | null;
    } | null;
    cool?: {
      __typename?: 'SetpointProfileCool';
      max?: number | null;
      min?: number | null;
    } | null;
    creator?: { __typename?: 'User'; _id: string; name: string } | null;
    lastUpdatedBy?: { __typename?: 'User'; _id: string; name: string } | null;
  } | null;
};

export type SetpointProfileDetailQueryVariables = Exact<{
  _id: Scalars['String'];
}>;

export type SetpointProfileDetailQuery = {
  __typename?: 'Query';
  setpointProfileById?: {
    __typename?: 'SetpointProfile';
    _id: string;
    name?: string | null;
    properties?: Array<string | null> | null;
    units?: EnumSetpointProfileUnits | null;
    heat?: {
      __typename?: 'SetpointProfileHeat';
      max?: number | null;
      min?: number | null;
    } | null;
    cool?: {
      __typename?: 'SetpointProfileCool';
      max?: number | null;
      min?: number | null;
    } | null;
    creator?: { __typename?: 'User'; _id: string; name: string } | null;
    lastUpdatedBy?: { __typename?: 'User'; _id: string; name: string } | null;
  } | null;
};

export type SetpointProfileDetailBreadcrumbQueryVariables = Exact<{
  id: Scalars['String'];
}>;

export type SetpointProfileDetailBreadcrumbQuery = {
  __typename?: 'Query';
  setpointProfileById?: {
    __typename?: 'SetpointProfile';
    _id: string;
    name?: string | null;
  } | null;
};

export type SetpointProfileListQueryVariables = Exact<{ [key: string]: never }>;

export type SetpointProfileListQuery = {
  __typename?: 'Query';
  setpointProfiles: Array<{
    __typename?: 'SetpointProfile';
    _id: string;
    name?: string | null;
    enabledProperties: Array<{
      __typename?: 'Property';
      _id: string;
      title: string;
    } | null>;
    creator?: { __typename?: 'User'; name: string } | null;
    lastUpdatedBy?: { __typename?: 'User'; name: string } | null;
    assignedProperties: Array<{
      __typename?: 'Property';
      _id: string;
      title: string;
    } | null>;
    assignedUnits: Array<{
      __typename?: 'Unit';
      _id: string;
      name: string;
    } | null>;
  }>;
};

export type SetpointProfileListUpdateSubscriptionVariables = Exact<{
  [key: string]: never;
}>;

export type SetpointProfileListUpdateSubscription = {
  __typename?: 'Subscription';
  setpointProfileEvents?: {
    __typename?: 'SetpointProfile';
    modelChangeOperation?: string | null;
    _id: string;
    name?: string | null;
    creator?: { __typename?: 'User'; name: string } | null;
    lastUpdatedBy?: { __typename?: 'User'; name: string } | null;
    enabledProperties: Array<{
      __typename?: 'Property';
      _id: string;
      title: string;
    } | null>;
    assignedProperties: Array<{
      __typename?: 'Property';
      _id: string;
      title: string;
    } | null>;
    assignedUnits: Array<{
      __typename?: 'Unit';
      _id: string;
      name: string;
    } | null>;
  } | null;
};

export type SetpointProfileUpdateVerificationQueryVariables = Exact<{
  id: Scalars['String'];
  propertyIds?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
  unitId?: InputMaybe<Scalars['String']>;
}>;

export type SetpointProfileUpdateVerificationQuery = {
  __typename?: 'Query';
  setpointProfileUpdateVerification?: {
    __typename?: 'SetpointProfileUpdateVerificationData';
    _id?: string | null;
    name?: string | null;
    totalDevices?: number | null;
    configuredDevices?: number | null;
    onlineDevices?: number | null;
    excludedDevicesCustom?: number | null;
    excludedDevicesUnit?: number | null;
  } | null;
};

export type UnitSetpointProfilesQueryVariables = Exact<{
  id: Scalars['String'];
}>;

export type UnitSetpointProfilesQuery = {
  __typename?: 'Query';
  unitById?: {
    __typename?: 'Unit';
    _id: string;
    name: string;
    type: string;
    setpointProfileId?: string | null;
    thermostatScheduleTemplateId?: string | null;
    assignableSetpointProfiles: Array<{
      __typename?: 'SetpointProfile';
      _id: string;
      name?: string | null;
      properties?: Array<string | null> | null;
      assignedProperties: Array<{ __typename: 'Property'; _id: string } | null>;
      assignedUnits: Array<{ __typename: 'Unit'; _id: string } | null>;
      enabledProperties: Array<{ __typename: 'Property'; _id: string } | null>;
      heat?: {
        __typename?: 'SetpointProfileHeat';
        max?: number | null;
        min?: number | null;
      } | null;
      cool?: {
        __typename?: 'SetpointProfileCool';
        max?: number | null;
        min?: number | null;
      } | null;
    } | null>;
    property?: {
      __typename: 'Property';
      _id: string;
      title: string;
      setpointProfileId?: string | null;
    } | null;
  } | null;
};

export type UpdatePropertySetpointProfileOverrideMutationVariables = Exact<{
  id: Scalars['String'];
  setpointProfileId: Scalars['String'];
  force?: InputMaybe<Scalars['Boolean']>;
}>;

export type UpdatePropertySetpointProfileOverrideMutation = {
  __typename?: 'Mutation';
  updatePropertySetpointLimitProfileOverride: {
    __typename?: 'Property';
    _id: string;
    title: string;
  };
};

export type UpdateSetpointProfileMutationVariables = Exact<{
  id: Scalars['String'];
  profile: UpdateOneSetpointProfileInput;
}>;

export type UpdateSetpointProfileMutation = {
  __typename?: 'Mutation';
  updateSetpointProfile: {
    __typename?: 'SetpointProfile';
    _id: string;
    name?: string | null;
    properties?: Array<string | null> | null;
    createdAt?: number | null;
    updatedAt?: number | null;
    heat?: {
      __typename?: 'SetpointProfileHeat';
      max?: number | null;
      min?: number | null;
    } | null;
    cool?: {
      __typename?: 'SetpointProfileCool';
      max?: number | null;
      min?: number | null;
    } | null;
    creator?: { __typename?: 'User'; _id: string; name: string } | null;
    lastUpdatedBy?: { __typename?: 'User'; name: string } | null;
  };
};

export type UpdateUnitSetpointProfileOverrideMutationVariables = Exact<{
  id: Scalars['String'];
  setpointProfileId: Scalars['String'];
  force?: InputMaybe<Scalars['Boolean']>;
  revert?: InputMaybe<Scalars['Boolean']>;
}>;

export type UpdateUnitSetpointProfileOverrideMutation = {
  __typename?: 'Mutation';
  updateUnitSetpointLimitProfileOverride: {
    __typename?: 'Unit';
    _id: string;
    name: string;
  };
};

export type ConductorCommissioningDraftFieldsFragment = {
  __typename?: 'ConductorCommissioningDraftView';
  _id: string;
  sourceId: string;
  propertyId: string;
  buildingId: string;
  runId: string;
  discoveryFingerprint: string;
  mode: string;
  status: string;
  revision: number;
  needsReview: Array<string>;
  resolvedIds?: any | null;
  resolvedMappings?: any | null;
  acknowledgedAt?: any | null;
  createdAt?: any | null;
  updatedAt?: any | null;
  floors?: Array<{
    __typename?: 'ConductorProposedFloor';
    key: string;
    name: string;
    number?: number | null;
    existingFloorId?: string | null;
    confidence: number;
    evidence?: Array<{
      __typename?: 'ConductorHierarchyEvidence';
      source: string;
      value: string;
    }> | null;
  }> | null;
  units?: Array<{
    __typename?: 'ConductorProposedUnit';
    key: string;
    name: string;
    type: string;
    floorKey?: string | null;
    existingUnitId?: string | null;
    confidence: number;
    evidence?: Array<{
      __typename?: 'ConductorHierarchyEvidence';
      source: string;
      value: string;
    }> | null;
  }> | null;
  devices?: Array<{
    __typename?: 'ConductorProposedDevice';
    key: string;
    discoveredDeviceId: string;
    originalLabel: string;
    proposedName: string;
    unitKey?: string | null;
    deviceType: string;
    supportedMetrics: Array<string>;
    supportedCommands: Array<string>;
    enabledMetrics: Array<string>;
    enabledCommands: Array<string>;
    ignored?: boolean | null;
    confidence: number;
    evidence?: Array<{
      __typename?: 'ConductorHierarchyEvidence';
      source: string;
      value: string;
    }> | null;
  }> | null;
  validationErrors?: Array<{
    __typename?: 'ConductorCommissioningValidationError';
    stage: string;
    key?: string | null;
    field?: string | null;
    message: string;
  }> | null;
};

export type ConductorCommissioningDraftQueryVariables = Exact<{
  sourceId: Scalars['String'];
  runId?: InputMaybe<Scalars['String']>;
}>;

export type ConductorCommissioningDraftQuery = {
  __typename?: 'Query';
  conductorCommissioningDraft?: {
    __typename?: 'ConductorCommissioningDraftView';
    _id: string;
    sourceId: string;
    propertyId: string;
    buildingId: string;
    runId: string;
    discoveryFingerprint: string;
    mode: string;
    status: string;
    revision: number;
    needsReview: Array<string>;
    resolvedIds?: any | null;
    resolvedMappings?: any | null;
    acknowledgedAt?: any | null;
    createdAt?: any | null;
    updatedAt?: any | null;
    floors?: Array<{
      __typename?: 'ConductorProposedFloor';
      key: string;
      name: string;
      number?: number | null;
      existingFloorId?: string | null;
      confidence: number;
      evidence?: Array<{
        __typename?: 'ConductorHierarchyEvidence';
        source: string;
        value: string;
      }> | null;
    }> | null;
    units?: Array<{
      __typename?: 'ConductorProposedUnit';
      key: string;
      name: string;
      type: string;
      floorKey?: string | null;
      existingUnitId?: string | null;
      confidence: number;
      evidence?: Array<{
        __typename?: 'ConductorHierarchyEvidence';
        source: string;
        value: string;
      }> | null;
    }> | null;
    devices?: Array<{
      __typename?: 'ConductorProposedDevice';
      key: string;
      discoveredDeviceId: string;
      originalLabel: string;
      proposedName: string;
      unitKey?: string | null;
      deviceType: string;
      supportedMetrics: Array<string>;
      supportedCommands: Array<string>;
      enabledMetrics: Array<string>;
      enabledCommands: Array<string>;
      ignored?: boolean | null;
      confidence: number;
      evidence?: Array<{
        __typename?: 'ConductorHierarchyEvidence';
        source: string;
        value: string;
      }> | null;
    }> | null;
    validationErrors?: Array<{
      __typename?: 'ConductorCommissioningValidationError';
      stage: string;
      key?: string | null;
      field?: string | null;
      message: string;
    }> | null;
  } | null;
};

export type CreateConductorCommissioningDraftMutationVariables = Exact<{
  sourceId: Scalars['String'];
  runId?: InputMaybe<Scalars['String']>;
  mode?: InputMaybe<Scalars['String']>;
}>;

export type CreateConductorCommissioningDraftMutation = {
  __typename?: 'Mutation';
  createConductorCommissioningDraft: {
    __typename?: 'ConductorCommissioningDraftView';
    _id: string;
    sourceId: string;
    propertyId: string;
    buildingId: string;
    runId: string;
    discoveryFingerprint: string;
    mode: string;
    status: string;
    revision: number;
    needsReview: Array<string>;
    resolvedIds?: any | null;
    resolvedMappings?: any | null;
    acknowledgedAt?: any | null;
    createdAt?: any | null;
    updatedAt?: any | null;
    floors?: Array<{
      __typename?: 'ConductorProposedFloor';
      key: string;
      name: string;
      number?: number | null;
      existingFloorId?: string | null;
      confidence: number;
      evidence?: Array<{
        __typename?: 'ConductorHierarchyEvidence';
        source: string;
        value: string;
      }> | null;
    }> | null;
    units?: Array<{
      __typename?: 'ConductorProposedUnit';
      key: string;
      name: string;
      type: string;
      floorKey?: string | null;
      existingUnitId?: string | null;
      confidence: number;
      evidence?: Array<{
        __typename?: 'ConductorHierarchyEvidence';
        source: string;
        value: string;
      }> | null;
    }> | null;
    devices?: Array<{
      __typename?: 'ConductorProposedDevice';
      key: string;
      discoveredDeviceId: string;
      originalLabel: string;
      proposedName: string;
      unitKey?: string | null;
      deviceType: string;
      supportedMetrics: Array<string>;
      supportedCommands: Array<string>;
      enabledMetrics: Array<string>;
      enabledCommands: Array<string>;
      ignored?: boolean | null;
      confidence: number;
      evidence?: Array<{
        __typename?: 'ConductorHierarchyEvidence';
        source: string;
        value: string;
      }> | null;
    }> | null;
    validationErrors?: Array<{
      __typename?: 'ConductorCommissioningValidationError';
      stage: string;
      key?: string | null;
      field?: string | null;
      message: string;
    }> | null;
  };
};

export type UpdateConductorCommissioningDraftMutationVariables = Exact<{
  sourceId: Scalars['String'];
  draftId: Scalars['String'];
  expectedRevision: Scalars['Float'];
  expectedDiscoveryFingerprint: Scalars['String'];
  patch: ConductorCommissioningDraftPatchInput;
}>;

export type UpdateConductorCommissioningDraftMutation = {
  __typename?: 'Mutation';
  updateConductorCommissioningDraft: {
    __typename?: 'ConductorCommissioningDraftView';
    _id: string;
    sourceId: string;
    propertyId: string;
    buildingId: string;
    runId: string;
    discoveryFingerprint: string;
    mode: string;
    status: string;
    revision: number;
    needsReview: Array<string>;
    resolvedIds?: any | null;
    resolvedMappings?: any | null;
    acknowledgedAt?: any | null;
    createdAt?: any | null;
    updatedAt?: any | null;
    floors?: Array<{
      __typename?: 'ConductorProposedFloor';
      key: string;
      name: string;
      number?: number | null;
      existingFloorId?: string | null;
      confidence: number;
      evidence?: Array<{
        __typename?: 'ConductorHierarchyEvidence';
        source: string;
        value: string;
      }> | null;
    }> | null;
    units?: Array<{
      __typename?: 'ConductorProposedUnit';
      key: string;
      name: string;
      type: string;
      floorKey?: string | null;
      existingUnitId?: string | null;
      confidence: number;
      evidence?: Array<{
        __typename?: 'ConductorHierarchyEvidence';
        source: string;
        value: string;
      }> | null;
    }> | null;
    devices?: Array<{
      __typename?: 'ConductorProposedDevice';
      key: string;
      discoveredDeviceId: string;
      originalLabel: string;
      proposedName: string;
      unitKey?: string | null;
      deviceType: string;
      supportedMetrics: Array<string>;
      supportedCommands: Array<string>;
      enabledMetrics: Array<string>;
      enabledCommands: Array<string>;
      ignored?: boolean | null;
      confidence: number;
      evidence?: Array<{
        __typename?: 'ConductorHierarchyEvidence';
        source: string;
        value: string;
      }> | null;
    }> | null;
    validationErrors?: Array<{
      __typename?: 'ConductorCommissioningValidationError';
      stage: string;
      key?: string | null;
      field?: string | null;
      message: string;
    }> | null;
  };
};

export type FinalizeConductorCommissioningDraftMutationVariables = Exact<{
  sourceId: Scalars['String'];
  draftId: Scalars['String'];
  expectedRevision: Scalars['Float'];
  expectedDiscoveryFingerprint: Scalars['String'];
}>;

export type FinalizeConductorCommissioningDraftMutation = {
  __typename?: 'Mutation';
  finalizeConductorCommissioningDraft?: {
    __typename?: 'ConductorCommissioningDraftView';
    _id: string;
    sourceId: string;
    propertyId: string;
    buildingId: string;
    runId: string;
    discoveryFingerprint: string;
    mode: string;
    status: string;
    revision: number;
    needsReview: Array<string>;
    resolvedIds?: any | null;
    resolvedMappings?: any | null;
    acknowledgedAt?: any | null;
    createdAt?: any | null;
    updatedAt?: any | null;
    floors?: Array<{
      __typename?: 'ConductorProposedFloor';
      key: string;
      name: string;
      number?: number | null;
      existingFloorId?: string | null;
      confidence: number;
      evidence?: Array<{
        __typename?: 'ConductorHierarchyEvidence';
        source: string;
        value: string;
      }> | null;
    }> | null;
    units?: Array<{
      __typename?: 'ConductorProposedUnit';
      key: string;
      name: string;
      type: string;
      floorKey?: string | null;
      existingUnitId?: string | null;
      confidence: number;
      evidence?: Array<{
        __typename?: 'ConductorHierarchyEvidence';
        source: string;
        value: string;
      }> | null;
    }> | null;
    devices?: Array<{
      __typename?: 'ConductorProposedDevice';
      key: string;
      discoveredDeviceId: string;
      originalLabel: string;
      proposedName: string;
      unitKey?: string | null;
      deviceType: string;
      supportedMetrics: Array<string>;
      supportedCommands: Array<string>;
      enabledMetrics: Array<string>;
      enabledCommands: Array<string>;
      ignored?: boolean | null;
      confidence: number;
      evidence?: Array<{
        __typename?: 'ConductorHierarchyEvidence';
        source: string;
        value: string;
      }> | null;
    }> | null;
    validationErrors?: Array<{
      __typename?: 'ConductorCommissioningValidationError';
      stage: string;
      key?: string | null;
      field?: string | null;
      message: string;
    }> | null;
  } | null;
};

export type RetryConductorCommissioningCommitMutationVariables = Exact<{
  sourceId: Scalars['String'];
  draftId: Scalars['String'];
}>;

export type RetryConductorCommissioningCommitMutation = {
  __typename?: 'Mutation';
  retryConductorCommissioningCommit?: {
    __typename?: 'ConductorCommissioningDraftView';
    _id: string;
    sourceId: string;
    propertyId: string;
    buildingId: string;
    runId: string;
    discoveryFingerprint: string;
    mode: string;
    status: string;
    revision: number;
    needsReview: Array<string>;
    resolvedIds?: any | null;
    resolvedMappings?: any | null;
    acknowledgedAt?: any | null;
    createdAt?: any | null;
    updatedAt?: any | null;
    floors?: Array<{
      __typename?: 'ConductorProposedFloor';
      key: string;
      name: string;
      number?: number | null;
      existingFloorId?: string | null;
      confidence: number;
      evidence?: Array<{
        __typename?: 'ConductorHierarchyEvidence';
        source: string;
        value: string;
      }> | null;
    }> | null;
    units?: Array<{
      __typename?: 'ConductorProposedUnit';
      key: string;
      name: string;
      type: string;
      floorKey?: string | null;
      existingUnitId?: string | null;
      confidence: number;
      evidence?: Array<{
        __typename?: 'ConductorHierarchyEvidence';
        source: string;
        value: string;
      }> | null;
    }> | null;
    devices?: Array<{
      __typename?: 'ConductorProposedDevice';
      key: string;
      discoveredDeviceId: string;
      originalLabel: string;
      proposedName: string;
      unitKey?: string | null;
      deviceType: string;
      supportedMetrics: Array<string>;
      supportedCommands: Array<string>;
      enabledMetrics: Array<string>;
      enabledCommands: Array<string>;
      ignored?: boolean | null;
      confidence: number;
      evidence?: Array<{
        __typename?: 'ConductorHierarchyEvidence';
        source: string;
        value: string;
      }> | null;
    }> | null;
    validationErrors?: Array<{
      __typename?: 'ConductorCommissioningValidationError';
      stage: string;
      key?: string | null;
      field?: string | null;
      message: string;
    }> | null;
  } | null;
};

export type ConductorDiscoveryStatusUpdatedSubscriptionVariables = Exact<{
  sourceId: Scalars['String'];
  runId?: InputMaybe<Scalars['String']>;
}>;

export type ConductorDiscoveryStatusUpdatedSubscription = {
  __typename?: 'Subscription';
  conductorDiscoveryStatusUpdated?: {
    __typename?: 'ConductorDiscoveryStatus';
    sourceId: string;
    runId: string;
    status: string;
    message?: string | null;
    progressPercent?: number | null;
    isComplete: boolean;
    results?: any | null;
    proposedMappings?: any | null;
    unallocated?: any | null;
    aiAudit?: any | null;
  } | null;
};

export type ConductorDiscoveryRunQueryVariables = Exact<{
  sourceId: Scalars['String'];
  runId?: InputMaybe<Scalars['String']>;
}>;

export type ConductorDiscoveryRunQuery = {
  __typename?: 'Query';
  conductorDiscoveryRun?: any | null;
};

export type CommitConductorDiscoveryMappingsMutationVariables = Exact<{
  sourceId: Scalars['String'];
  runId: Scalars['String'];
  mappings: Scalars['JSON'];
}>;

export type CommitConductorDiscoveryMappingsMutation = {
  __typename?: 'Mutation';
  commitConductorDiscoveryMappings?: any | null;
};

export type ConductorBuildingUnitsQueryVariables = Exact<{
  buildingId: Scalars['String'];
}>;

export type ConductorBuildingUnitsQuery = {
  __typename?: 'Query';
  units: Array<{
    __typename?: 'Unit';
    _id: string;
    name: string;
    type: string;
    propertyId: string;
    buildingId: string;
    floorId?: string | null;
    building?: { __typename?: 'Building'; name: string } | null;
    floor?: { __typename?: 'Floor'; name: string } | null;
  }>;
};

export type CreateConductorMutationVariables = Exact<{
  conductor: CreateOneConductorInput;
}>;

export type CreateConductorMutation = {
  __typename?: 'Mutation';
  createConductor?: {
    __typename?: 'Conductor';
    _id: string;
    name: string;
    type?: EnumDKeySourceType | null;
    url?: string | null;
    timestamp?: number | null;
    propertyId?: string | null;
    buildingId?: string | null;
    maxReportingTime?: number | null;
    inUse: boolean;
    tolerances?: {
      __typename?: 'ConductorTolerances';
      temperature?: number | null;
      humidity?: number | null;
    } | null;
  } | null;
};

export type UpdateConductorMutationVariables = Exact<{
  id: Scalars['String'];
  conductor: UpdateOneConductorInput;
}>;

export type UpdateConductorMutation = {
  __typename?: 'Mutation';
  updateConductor?: {
    __typename?: 'Conductor';
    _id: string;
    name: string;
    type?: EnumDKeySourceType | null;
    url?: string | null;
    timestamp?: number | null;
    buildingId?: string | null;
    maxReportingTime?: number | null;
    inUse: boolean;
    tolerances?: {
      __typename?: 'ConductorTolerances';
      temperature?: number | null;
      humidity?: number | null;
    } | null;
  } | null;
};

export type RemoveConductorMutationVariables = Exact<{
  id: Scalars['String'];
}>;

export type RemoveConductorMutation = {
  __typename?: 'Mutation';
  removeConductor?: string | null;
};

export type CreateBngMutationVariables = Exact<{
  bng: CreateOneBngInput;
}>;

export type CreateBngMutation = {
  __typename?: 'Mutation';
  createBng?: {
    __typename?: 'BNG';
    _id: string;
    name: string;
    url?: string | null;
    type?: EnumDKeySourceType | null;
    propertyId?: string | null;
    timestamp?: number | null;
    inUse: boolean;
  } | null;
};

export type CreateCoreMutationVariables = Exact<{
  core: CreateOneCoreInput;
}>;

export type CreateCoreMutation = {
  __typename?: 'Mutation';
  createCore?: {
    __typename?: 'Core';
    _id: string;
    name: string;
    url?: string | null;
    type?: EnumDKeySourceType | null;
    timestamp?: number | null;
    propertyId?: string | null;
    maxReportingTime?: number | null;
    inUse: boolean;
    tolerances?: {
      __typename?: 'CoreTolerances';
      temperature?: number | null;
      humidity?: number | null;
      voltage?: number | null;
    } | null;
  } | null;
};

export type CreateHmmMutationVariables = Exact<{
  hmm: CreateOneHmmInput;
}>;

export type CreateHmmMutation = {
  __typename?: 'Mutation';
  createHmm?: {
    __typename?: 'HMM';
    _id: string;
    name: string;
    type?: EnumDKeySourceType | null;
    url?: string | null;
    timestamp?: number | null;
    propertyId?: string | null;
    maxReportingTime?: number | null;
    tolerances?: {
      __typename?: 'HMMTolerances';
      temperature?: number | null;
    } | null;
  } | null;
};

export type InitializeSourceMutationVariables = Exact<{
  id: Scalars['String'];
  options?: InputMaybe<InitializeSourceInput>;
}>;

export type InitializeSourceMutation = {
  __typename?: 'Mutation';
  initializeSource?: { __typename?: 'Source'; _id: string } | null;
};

export type RemoveBngMutationVariables = Exact<{
  id: Scalars['String'];
}>;

export type RemoveBngMutation = {
  __typename?: 'Mutation';
  removeBng?: string | null;
};

export type RemoveCoreMutationVariables = Exact<{
  id: Scalars['String'];
}>;

export type RemoveCoreMutation = {
  __typename?: 'Mutation';
  removeCore?: string | null;
};

export type RemoveHmmMutationVariables = Exact<{
  id: Scalars['String'];
}>;

export type RemoveHmmMutation = {
  __typename?: 'Mutation';
  removeHmm?: string | null;
};

export type RepublishConductorMetadataMutationVariables = Exact<{
  id: Scalars['String'];
}>;

export type RepublishConductorMetadataMutation = {
  __typename?: 'Mutation';
  republishConductorMetadata?: {
    __typename?: 'Conductor';
    _id: string;
    lastDiscoveryStatus?: string | null;
  } | null;
};

export type SourceDetailEditQueryVariables = Exact<{
  id: Scalars['String'];
}>;

export type SourceDetailEditQuery = {
  __typename?: 'Query';
  sourceById?:
    | {
        __typename?: 'BNG';
        localUrl?: string | null;
        _id: string;
        name: string;
        type?: EnumDKeySourceType | null;
        url?: string | null;
        timestamp?: number | null;
        propertyId?: string | null;
        property?: {
          __typename?: 'Property';
          _id: string;
          title: string;
        } | null;
      }
    | {
        __typename?: 'Conductor';
        buildingId?: string | null;
        lastDiscoveryStatus?: string | null;
        maxReportingTime?: number | null;
        _id: string;
        name: string;
        type?: EnumDKeySourceType | null;
        url?: string | null;
        timestamp?: number | null;
        propertyId?: string | null;
        tolerances?: {
          __typename?: 'ConductorTolerances';
          temperature?: number | null;
          humidity?: number | null;
        } | null;
        property?: {
          __typename?: 'Property';
          _id: string;
          title: string;
        } | null;
      }
    | {
        __typename?: 'Core';
        maxReportingTime?: number | null;
        _id: string;
        name: string;
        type?: EnumDKeySourceType | null;
        url?: string | null;
        timestamp?: number | null;
        propertyId?: string | null;
        tolerances?: {
          __typename?: 'CoreTolerances';
          temperature?: number | null;
          humidity?: number | null;
          voltage?: number | null;
        } | null;
        property?: {
          __typename?: 'Property';
          _id: string;
          title: string;
        } | null;
      }
    | {
        __typename?: 'HMM';
        maxReportingTime?: number | null;
        _id: string;
        name: string;
        type?: EnumDKeySourceType | null;
        url?: string | null;
        timestamp?: number | null;
        propertyId?: string | null;
        tolerances?: {
          __typename?: 'HMMTolerances';
          temperature?: number | null;
        } | null;
        property?: {
          __typename?: 'Property';
          _id: string;
          title: string;
        } | null;
      }
    | {
        __typename?: 'Source';
        _id: string;
        name: string;
        type?: EnumDKeySourceType | null;
        url?: string | null;
        timestamp?: number | null;
        propertyId?: string | null;
        property?: {
          __typename?: 'Property';
          _id: string;
          title: string;
        } | null;
      }
    | null;
};

export type SourceStatusQueryVariables = Exact<{ [key: string]: never }>;

export type SourceStatusQuery = {
  __typename?: 'Query';
  cores: Array<{
    __typename?: 'Core';
    _id: string;
    type?: EnumDKeySourceType | null;
    timestamp?: number | null;
  }>;
  hMMs: Array<{
    __typename?: 'HMM';
    _id: string;
    type?: EnumDKeySourceType | null;
    timestamp?: number | null;
  }>;
  bNGs: Array<{
    __typename?: 'BNG';
    _id: string;
    type?: EnumDKeySourceType | null;
    timestamp?: number | null;
  }>;
  conductors: Array<{
    __typename?: 'Conductor';
    _id: string;
    type?: EnumDKeySourceType | null;
    timestamp?: number | null;
  }>;
};

export type CoreStatusUpdatesSubscriptionVariables = Exact<{
  [key: string]: never;
}>;

export type CoreStatusUpdatesSubscription = {
  __typename?: 'Subscription';
  coreEvents?: {
    __typename?: 'Core';
    modelChangeOperation?: string | null;
    _id: string;
    type?: EnumDKeySourceType | null;
    timestamp?: number | null;
  } | null;
};

export type HmmStatusUpdatesSubscriptionVariables = Exact<{
  [key: string]: never;
}>;

export type HmmStatusUpdatesSubscription = {
  __typename?: 'Subscription';
  hMMEvents?: {
    __typename?: 'HMM';
    modelChangeOperation?: string | null;
    _id: string;
    type?: EnumDKeySourceType | null;
    timestamp?: number | null;
  } | null;
};

export type BngStatusUpdatesSubscriptionVariables = Exact<{
  [key: string]: never;
}>;

export type BngStatusUpdatesSubscription = {
  __typename?: 'Subscription';
  bNGEvents?: {
    __typename?: 'BNG';
    modelChangeOperation?: string | null;
    _id: string;
    type?: EnumDKeySourceType | null;
    timestamp?: number | null;
  } | null;
};

export type ConductorStatusUpdatesSubscriptionVariables = Exact<{
  [key: string]: never;
}>;

export type ConductorStatusUpdatesSubscription = {
  __typename?: 'Subscription';
  conductorEvents?: {
    __typename?: 'Conductor';
    modelChangeOperation?: string | null;
    _id: string;
    type?: EnumDKeySourceType | null;
    timestamp?: number | null;
  } | null;
};

export type UpdateBngMutationVariables = Exact<{
  id: Scalars['String'];
  bng: UpdateOneBngInput;
}>;

export type UpdateBngMutation = {
  __typename?: 'Mutation';
  updateBng?: {
    __typename?: 'BNG';
    _id: string;
    name: string;
    type?: EnumDKeySourceType | null;
    url?: string | null;
    timestamp?: number | null;
    inUse: boolean;
  } | null;
};

export type UpdateCoreMutationVariables = Exact<{
  id: Scalars['String'];
  core: UpdateOneCoreInput;
}>;

export type UpdateCoreMutation = {
  __typename?: 'Mutation';
  updateCore?: {
    __typename?: 'Core';
    _id: string;
    name: string;
    type?: EnumDKeySourceType | null;
    url?: string | null;
    timestamp?: number | null;
    inUse: boolean;
    tolerances?: {
      __typename?: 'CoreTolerances';
      temperature?: number | null;
      humidity?: number | null;
      voltage?: number | null;
    } | null;
  } | null;
};

export type UpdateHmmMutationVariables = Exact<{
  id: Scalars['String'];
  hmm: UpdateOneHmmInput;
}>;

export type UpdateHmmMutation = {
  __typename?: 'Mutation';
  updateHmm?: {
    __typename?: 'HMM';
    _id: string;
    name: string;
    type?: EnumDKeySourceType | null;
    url?: string | null;
    timestamp?: number | null;
    inUse: boolean;
    tolerances?: {
      __typename?: 'HMMTolerances';
      temperature?: number | null;
    } | null;
  } | null;
};

export type SystemNotificationBaseByIdSubscriptionSubscriptionVariables =
  Exact<{
    _id: Scalars['String'];
  }>;

export type SystemNotificationBaseByIdSubscriptionSubscription = {
  __typename?: 'Subscription';
  systemNotificationEventsByIds?: {
    __typename?: 'SystemNotification';
    modelChangeOperation?: string | null;
    _id: string;
    entityId: string;
    entityType: string;
    message: string;
    link?: string | null;
    createdAt: number;
    displayStart: number;
    displayEnd: number;
    acknowledgedAt?: number | null;
    seenAt?: number | null;
    requireAcknowledgement: boolean;
    modelType?: string | null;
    updateDescription?: any | null;
    relatedEntityName?: string | null;
  } | null;
};

export type SystemNotificationBaseByIdQueryVariables = Exact<{
  _id: Scalars['String'];
}>;

export type SystemNotificationBaseByIdQuery = {
  __typename?: 'Query';
  systemNotificationById?: {
    __typename?: 'SystemNotification';
    _id: string;
    entityId: string;
    entityType: string;
    message: string;
    link?: string | null;
    createdAt: number;
    displayStart: number;
    displayEnd: number;
    acknowledgedAt?: number | null;
    seenAt?: number | null;
    requireAcknowledgement: boolean;
    modelChangeOperation?: string | null;
    modelType?: string | null;
    updateDescription?: any | null;
    relatedEntityName?: string | null;
  } | null;
};

export type SystemNotificationBaseSubscriptionSubscriptionVariables = Exact<{
  [key: string]: never;
}>;

export type SystemNotificationBaseSubscriptionSubscription = {
  __typename?: 'Subscription';
  systemNotificationEvents?: {
    __typename?: 'SystemNotification';
    modelChangeOperation?: string | null;
    _id: string;
    entityId: string;
    entityType: string;
    message: string;
    link?: string | null;
    createdAt: number;
    displayStart: number;
    displayEnd: number;
    acknowledgedAt?: number | null;
    seenAt?: number | null;
    requireAcknowledgement: boolean;
    modelType?: string | null;
    updateDescription?: any | null;
    relatedEntityName?: string | null;
  } | null;
};

export type SystemNotificationBaseQueryVariables = Exact<{
  [key: string]: never;
}>;

export type SystemNotificationBaseQuery = {
  __typename?: 'Query';
  systemNotifications: Array<{
    __typename?: 'SystemNotification';
    _id: string;
    entityId: string;
    entityType: string;
    message: string;
    link?: string | null;
    createdAt: number;
    displayStart: number;
    displayEnd: number;
    acknowledgedAt?: number | null;
    seenAt?: number | null;
    requireAcknowledgement: boolean;
    modelChangeOperation?: string | null;
    modelType?: string | null;
    updateDescription?: any | null;
    relatedEntityName?: string | null;
  }>;
};

export type SystemNotificationDetailSubscriptionSubscriptionVariables = Exact<{
  _id: Scalars['String'];
}>;

export type SystemNotificationDetailSubscriptionSubscription = {
  __typename?: 'Subscription';
  systemNotificationEventsByIds?: {
    __typename?: 'SystemNotification';
    modelChangeOperation?: string | null;
    _id: string;
    entityId: string;
    entityType: string;
    message: string;
    link?: string | null;
    createdAt: number;
    displayStart: number;
    displayEnd: number;
    acknowledgedAt?: number | null;
    seenAt?: number | null;
    requireAcknowledgement: boolean;
    modelType?: string | null;
    updateDescription?: any | null;
    relatedEntityName?: string | null;
  } | null;
};

export type SystemNotificationDetailQueryVariables = Exact<{
  _id: Scalars['String'];
}>;

export type SystemNotificationDetailQuery = {
  __typename?: 'Query';
  systemNotificationById?: {
    __typename?: 'SystemNotification';
    _id: string;
    entityId: string;
    entityType: string;
    message: string;
    link?: string | null;
    createdAt: number;
    displayStart: number;
    displayEnd: number;
    acknowledgedAt?: number | null;
    seenAt?: number | null;
    requireAcknowledgement: boolean;
    modelChangeOperation?: string | null;
    modelType?: string | null;
    updateDescription?: any | null;
    relatedEntityName?: string | null;
  } | null;
};

export type SystemNotificationListSubscriptionSubscriptionVariables = Exact<{
  [key: string]: never;
}>;

export type SystemNotificationListSubscriptionSubscription = {
  __typename?: 'Subscription';
  systemNotificationEvents?: {
    __typename?: 'SystemNotification';
    modelChangeOperation?: string | null;
    _id: string;
    entityId: string;
    entityType: string;
    message: string;
    link?: string | null;
    createdAt: number;
    displayStart: number;
    displayEnd: number;
    acknowledgedAt?: number | null;
    seenAt?: number | null;
    requireAcknowledgement: boolean;
    relatedEntityName?: string | null;
  } | null;
};

export type SystemNotificationListQueryVariables = Exact<{
  [key: string]: never;
}>;

export type SystemNotificationListQuery = {
  __typename?: 'Query';
  systemNotifications: Array<{
    __typename?: 'SystemNotification';
    _id: string;
    entityId: string;
    entityType: string;
    message: string;
    link?: string | null;
    createdAt: number;
    displayStart: number;
    displayEnd: number;
    acknowledgedAt?: number | null;
    seenAt?: number | null;
    requireAcknowledgement: boolean;
    relatedEntityName?: string | null;
  }>;
};

export type CreateSystemNotificationMutationVariables = Exact<{
  input: CreateOneSystemNotificationInput;
}>;

export type CreateSystemNotificationMutation = {
  __typename?: 'Mutation';
  createSystemNotification?: {
    __typename?: 'SystemNotification';
    _id: string;
    entityId: string;
    entityType: string;
    message: string;
    link?: string | null;
    createdAt: number;
    displayStart: number;
    displayEnd: number;
    acknowledgedAt?: number | null;
    requireAcknowledgement: boolean;
    seenAt?: number | null;
    relatedEntityName?: string | null;
    modelChangeOperation?: string | null;
    modelType?: string | null;
    updateDescription?: any | null;
  } | null;
};

export type UpdateSystemNotificationMutationVariables = Exact<{
  id: Scalars['String'];
  input: UpdateOneSystemNotificationInput;
}>;

export type UpdateSystemNotificationMutation = {
  __typename?: 'Mutation';
  updateSystemNotification?: {
    __typename?: 'SystemNotification';
    _id: string;
    entityId: string;
    entityType: string;
    message: string;
    link?: string | null;
    createdAt: number;
    displayStart: number;
    displayEnd: number;
    acknowledgedAt?: number | null;
    requireAcknowledgement: boolean;
    seenAt?: number | null;
    relatedEntityName?: string | null;
    modelChangeOperation?: string | null;
    modelType?: string | null;
    updateDescription?: any | null;
  } | null;
};

export type MarkSystemNotificationSeenMutationVariables = Exact<{
  id: Scalars['String'];
}>;

export type MarkSystemNotificationSeenMutation = {
  __typename?: 'Mutation';
  markSystemNotificationSeen?: {
    __typename?: 'SystemNotification';
    _id: string;
    entityId: string;
    entityType: string;
    message: string;
    link?: string | null;
    createdAt: number;
    displayStart: number;
    displayEnd: number;
    acknowledgedAt?: number | null;
    requireAcknowledgement: boolean;
    seenAt?: number | null;
    relatedEntityName?: string | null;
    modelChangeOperation?: string | null;
    modelType?: string | null;
    updateDescription?: any | null;
  } | null;
};

export type MarkSystemNotificationAcknowledgedMutationVariables = Exact<{
  id: Scalars['String'];
}>;

export type MarkSystemNotificationAcknowledgedMutation = {
  __typename?: 'Mutation';
  markSystemNotificationAcknowledged?: {
    __typename?: 'SystemNotification';
    _id: string;
    entityId: string;
    entityType: string;
    message: string;
    link?: string | null;
    createdAt: number;
    displayStart: number;
    displayEnd: number;
    acknowledgedAt?: number | null;
    requireAcknowledgement: boolean;
    seenAt?: number | null;
    relatedEntityName?: string | null;
    modelChangeOperation?: string | null;
    modelType?: string | null;
    updateDescription?: any | null;
  } | null;
};

export type DeleteSystemNotificationMutationVariables = Exact<{
  id: Scalars['String'];
}>;

export type DeleteSystemNotificationMutation = {
  __typename?: 'Mutation';
  deleteSystemNotification: boolean;
};

export type ApplicationQueryVariables = Exact<{ [key: string]: never }>;

export type ApplicationQuery = {
  __typename?: 'Query';
  application?: { __typename?: 'Application'; name: string } | null;
};

export type ManagedEntitiesBnGsQueryVariables = Exact<{ [key: string]: never }>;

export type ManagedEntitiesBnGsQuery = {
  __typename?: 'Query';
  bNGs: Array<{
    __typename?: 'BNG';
    _id: string;
    name: string;
    propertyId?: string | null;
    url?: string | null;
    type?: EnumDKeySourceType | null;
    inUse: boolean;
    localUrl?: string | null;
  }>;
};

export type ManagedEntitiesBuildingsByPropertyIdQueryVariables = Exact<{
  propertyId: Scalars['String'];
}>;

export type ManagedEntitiesBuildingsByPropertyIdQuery = {
  __typename?: 'Query';
  buildings: Array<{
    __typename?: 'Building';
    _id: string;
    name: string;
    number?: number | null;
    propertyId: string;
  }>;
};

export type ManagedEntitiesBuildingsQueryVariables = Exact<{
  [key: string]: never;
}>;

export type ManagedEntitiesBuildingsQuery = {
  __typename?: 'Query';
  buildings: Array<{
    __typename?: 'Building';
    _id: string;
    name: string;
    number?: number | null;
    propertyId: string;
  }>;
};

export type ManagedEntitiesConductorsQueryVariables = Exact<{
  [key: string]: never;
}>;

export type ManagedEntitiesConductorsQuery = {
  __typename?: 'Query';
  conductors: Array<{
    __typename?: 'Conductor';
    _id: string;
    name: string;
    propertyId?: string | null;
    url?: string | null;
    type?: EnumDKeySourceType | null;
    inUse: boolean;
  }>;
};

export type ManagedEntitiesCoresQueryVariables = Exact<{
  [key: string]: never;
}>;

export type ManagedEntitiesCoresQuery = {
  __typename?: 'Query';
  cores: Array<{
    __typename?: 'Core';
    _id: string;
    name: string;
    propertyId?: string | null;
    url?: string | null;
    type?: EnumDKeySourceType | null;
    inUse: boolean;
  }>;
};

export type ManagedEntitiesThermostatsQueryVariables = Exact<{
  [key: string]: never;
}>;

export type ManagedEntitiesThermostatsQuery = {
  __typename?: 'Query';
  thermostats: Array<{
    __typename?: 'Thermostat';
    _id: string;
    name?: string | null;
    type?: EnumDKeyDeviceType | null;
    location?: string | null;
    propertyId: string;
    unitId: string;
    sourceId?: string | null;
    installation?: { __typename?: 'DeviceInstallation'; status: number } | null;
  }>;
};

export type ManagedEntitiesFloorsByPropertyIdQueryVariables = Exact<{
  propertyId: Scalars['String'];
}>;

export type ManagedEntitiesFloorsByPropertyIdQuery = {
  __typename?: 'Query';
  floors: Array<{
    __typename?: 'Floor';
    _id: string;
    name: string;
    buildingId: string;
    propertyId: string;
  }>;
};

export type ManagedEntitiesFloorsQueryVariables = Exact<{
  [key: string]: never;
}>;

export type ManagedEntitiesFloorsQuery = {
  __typename?: 'Query';
  floors: Array<{
    __typename?: 'Floor';
    _id: string;
    name: string;
    buildingId: string;
    propertyId: string;
  }>;
};

export type ManagedEntitiesHmMsQueryVariables = Exact<{ [key: string]: never }>;

export type ManagedEntitiesHmMsQuery = {
  __typename?: 'Query';
  hMMs: Array<{
    __typename?: 'HMM';
    _id: string;
    name: string;
    propertyId?: string | null;
    url?: string | null;
    type?: EnumDKeySourceType | null;
    inUse: boolean;
  }>;
};

export type ManagedEntitiesOrganizationsQueryVariables = Exact<{
  [key: string]: never;
}>;

export type ManagedEntitiesOrganizationsQuery = {
  __typename?: 'Query';
  organizations: Array<{
    __typename?: 'Organization';
    _id: string;
    name: string;
    description?: string | null;
    hqPhone?: string | null;
    hqEmail?: string | null;
    hqAddress: {
      __typename?: 'OrganizationHqAddress';
      line1: string;
      line2?: string | null;
      city: string;
      state: string;
      postalCode: string;
      country: string;
    };
    systemNotifications?: Array<{
      __typename?: 'SystemNotification';
      _id: string;
      message: string;
      acknowledgedAt?: number | null;
      requireAcknowledgement: boolean;
      seenAt?: number | null;
    }> | null;
  }>;
};

export type ManagedEntitiesPlmEventResponsesByPropertyIdsQueryVariables =
  Exact<{
    propertyIds?: InputMaybe<
      Array<InputMaybe<Scalars['String']>> | InputMaybe<Scalars['String']>
    >;
  }>;

export type ManagedEntitiesPlmEventResponsesByPropertyIdsQuery = {
  __typename?: 'Query';
  plmEventResponses: Array<{
    __typename?: 'PlmEventResponse';
    _id: string;
    eventId: string;
    propertyId?: string | null;
    curtailmentPlanId?: string | null;
    scheduledStart: number;
    scheduledEnd: number;
    actualStart?: number | null;
    actualEnd?: number | null;
    responseSentAt: number;
    responseStatus: EnumPlmEventResponseResponseStatus;
    createdAt: number;
    updatedAt: number;
    event?: {
      __typename?: 'PlmEvent';
      _id: string;
      programId: string;
      contractId: string;
      startTime: number;
      duration: number;
      reductionTarget?: number | null;
      status: EnumPlmEventStatus;
      notificationMethod?: EnumPlmEventNotificationMethod | null;
      notificationReceivedAt?: number | null;
      notificationPayload?: string | null;
      program?: {
        __typename?: 'PlmProgram';
        _id: string;
        programId: string;
        name: string;
        partnerId: string;
        season: EnumPlmProgramSeason;
        startDate: number;
        endDate?: number | null;
        notificationLeadTimeMinutes?: number | null;
        maximumNotificationLeadTimeMinutes?: number | null;
        minimumEventDurationMinutes?: number | null;
        maximumEventDurationMinutes?: number | null;
        minimumEventsPerSeason?: number | null;
        maximumEventsPerSeason?: number | null;
        measurementIntervalMinutes?: number | null;
        participationType: EnumPlmProgramParticipationType;
        incentiveDescription?: string | null;
        partner?: {
          __typename?: 'PlmPartner';
          _id: string;
          name: string;
          description: string;
        } | null;
      } | null;
      contract?: {
        __typename?: 'PlmContract';
        _id: string;
        name: string;
        contractId: string;
        programId: string;
        propertyIds?: Array<string | null> | null;
        partnerId: string;
        dispatcherIds?: Array<string | null> | null;
        minimumReductionKW: number;
        maximumEventsPerSeason: number;
        baselineMethod: EnumPlmContractBaselineMethod;
        incentiveDescription?: string | null;
        penaltyForNonCompliance?: number | null;
        status: EnumPlmContractStatus;
        notificationEmail: string;
      } | null;
    } | null;
    curtailmentPlan?: {
      __typename?: 'PlmCurtailmentPlan';
      _id: string;
      name: string;
      description: string;
      estimatedReductionKW: number;
      durationMinutes: number;
      applicableSeasons: Array<EnumPlmCurtailmentPlanApplicableSeasons | null>;
      organizationId: string;
    } | null;
  }>;
};

export type ManagedEntitiesPlmEventResponsesQueryVariables = Exact<{
  [key: string]: never;
}>;

export type ManagedEntitiesPlmEventResponsesQuery = {
  __typename?: 'Query';
  plmEventResponses: Array<{
    __typename?: 'PlmEventResponse';
    _id: string;
    eventId: string;
    propertyId?: string | null;
    curtailmentPlanId?: string | null;
    scheduledStart: number;
    scheduledEnd: number;
    actualStart?: number | null;
    actualEnd?: number | null;
    responseSentAt: number;
    responseStatus: EnumPlmEventResponseResponseStatus;
    createdAt: number;
    updatedAt: number;
    event?: {
      __typename?: 'PlmEvent';
      _id: string;
      programId: string;
      contractId: string;
      startTime: number;
      duration: number;
      reductionTarget?: number | null;
      status: EnumPlmEventStatus;
      notificationMethod?: EnumPlmEventNotificationMethod | null;
      notificationReceivedAt?: number | null;
      notificationPayload?: string | null;
      program?: {
        __typename?: 'PlmProgram';
        _id: string;
        programId: string;
        name: string;
        partnerId: string;
        season: EnumPlmProgramSeason;
        startDate: number;
        endDate?: number | null;
        notificationLeadTimeMinutes?: number | null;
        maximumNotificationLeadTimeMinutes?: number | null;
        minimumEventDurationMinutes?: number | null;
        maximumEventDurationMinutes?: number | null;
        minimumEventsPerSeason?: number | null;
        maximumEventsPerSeason?: number | null;
        measurementIntervalMinutes?: number | null;
        participationType: EnumPlmProgramParticipationType;
        incentiveDescription?: string | null;
        partner?: {
          __typename?: 'PlmPartner';
          _id: string;
          name: string;
          description: string;
        } | null;
      } | null;
      contract?: {
        __typename?: 'PlmContract';
        _id: string;
        name: string;
        contractId: string;
        programId: string;
        propertyIds?: Array<string | null> | null;
        partnerId: string;
        dispatcherIds?: Array<string | null> | null;
        minimumReductionKW: number;
        maximumEventsPerSeason: number;
        baselineMethod: EnumPlmContractBaselineMethod;
        incentiveDescription?: string | null;
        penaltyForNonCompliance?: number | null;
        status: EnumPlmContractStatus;
        notificationEmail: string;
      } | null;
    } | null;
    curtailmentPlan?: {
      __typename?: 'PlmCurtailmentPlan';
      _id: string;
      name: string;
      description: string;
      estimatedReductionKW: number;
      durationMinutes: number;
      applicableSeasons: Array<EnumPlmCurtailmentPlanApplicableSeasons | null>;
      organizationId: string;
    } | null;
  }>;
};

export type ManagedEntitiesPropertiesQueryVariables = Exact<{
  [key: string]: never;
}>;

export type ManagedEntitiesPropertiesQuery = {
  __typename?: 'Query';
  properties: Array<{
    __typename?: 'Property';
    _id: string;
    title: string;
    floorLabel?: string | null;
    imageUrl?: string | null;
    address: {
      __typename?: 'PropertyAddress';
      line1: string;
      city?: string | null;
      state?: string | null;
      postalCode?: string | null;
    };
    owner?: { __typename?: 'PropertyOwner'; name?: string | null } | null;
    propMgr?: {
      __typename?: 'PropertyPropMgr';
      name?: string | null;
      mobile?: string | null;
    } | null;
    maintMgr?: {
      __typename?: 'PropertyMaintMgr';
      name?: string | null;
      mobile?: string | null;
    } | null;
    systemNotifications?: Array<{
      __typename?: 'SystemNotification';
      _id: string;
      message: string;
      acknowledgedAt?: number | null;
      requireAcknowledgement: boolean;
      seenAt?: number | null;
    }> | null;
  }>;
};

export type ManagedOrganizationUpdatesSubscriptionVariables = Exact<{
  [key: string]: never;
}>;

export type ManagedOrganizationUpdatesSubscription = {
  __typename?: 'Subscription';
  organizationEvents?: {
    __typename?: 'Organization';
    modelChangeOperation?: string | null;
    _id: string;
    name: string;
    description?: string | null;
    hqPhone?: string | null;
    hqEmail?: string | null;
    hqAddress: {
      __typename?: 'OrganizationHqAddress';
      line1: string;
      line2?: string | null;
      city: string;
      state: string;
      postalCode: string;
      country: string;
    };
  } | null;
};

export type ManagedPropertyUpdatesSubscriptionVariables = Exact<{
  [key: string]: never;
}>;

export type ManagedPropertyUpdatesSubscription = {
  __typename?: 'Subscription';
  propertyEvents?: {
    __typename?: 'Property';
    modelChangeOperation?: string | null;
    _id: string;
    title: string;
    imageUrl?: string | null;
    address: {
      __typename?: 'PropertyAddress';
      line1: string;
      city?: string | null;
      state?: string | null;
      postalCode?: string | null;
    };
    owner?: { __typename?: 'PropertyOwner'; name?: string | null } | null;
    propMgr?: {
      __typename?: 'PropertyPropMgr';
      name?: string | null;
      mobile?: string | null;
    } | null;
    maintMgr?: {
      __typename?: 'PropertyMaintMgr';
      name?: string | null;
      mobile?: string | null;
    } | null;
  } | null;
};

export type ManagedCoreUpdatesSubscriptionVariables = Exact<{
  [key: string]: never;
}>;

export type ManagedCoreUpdatesSubscription = {
  __typename?: 'Subscription';
  coreEvents?: {
    __typename?: 'Core';
    modelChangeOperation?: string | null;
    _id: string;
    name: string;
    type?: EnumDKeySourceType | null;
    url?: string | null;
    inUse: boolean;
  } | null;
};

export type ManagedHmmUpdatesSubscriptionVariables = Exact<{
  [key: string]: never;
}>;

export type ManagedHmmUpdatesSubscription = {
  __typename?: 'Subscription';
  hMMEvents?: {
    __typename?: 'HMM';
    modelChangeOperation?: string | null;
    _id: string;
    name: string;
    type?: EnumDKeySourceType | null;
    url?: string | null;
    inUse: boolean;
  } | null;
};

export type ManagedBngUpdatesSubscriptionVariables = Exact<{
  [key: string]: never;
}>;

export type ManagedBngUpdatesSubscription = {
  __typename?: 'Subscription';
  bNGEvents?: {
    __typename?: 'BNG';
    modelChangeOperation?: string | null;
    _id: string;
    name: string;
    type?: EnumDKeySourceType | null;
    url?: string | null;
    localUrl?: string | null;
    inUse: boolean;
  } | null;
};

export type ManagedConductorUpdatesSubscriptionVariables = Exact<{
  [key: string]: never;
}>;

export type ManagedConductorUpdatesSubscription = {
  __typename?: 'Subscription';
  conductorEvents?: {
    __typename?: 'Conductor';
    modelChangeOperation?: string | null;
    _id: string;
    name: string;
    type?: EnumDKeySourceType | null;
    url?: string | null;
    inUse: boolean;
  } | null;
};

export type ManagedBuildingUpdatesSubscriptionVariables = Exact<{
  [key: string]: never;
}>;

export type ManagedBuildingUpdatesSubscription = {
  __typename?: 'Subscription';
  buildingEvents?: {
    __typename?: 'Building';
    modelChangeOperation?: string | null;
    _id: string;
    name: string;
    number?: number | null;
    propertyId: string;
  } | null;
};

export type ManagedFloorUpdatesSubscriptionVariables = Exact<{
  [key: string]: never;
}>;

export type ManagedFloorUpdatesSubscription = {
  __typename?: 'Subscription';
  floorEvents?: {
    __typename?: 'Floor';
    modelChangeOperation?: string | null;
    _id: string;
    name: string;
    buildingId: string;
    propertyId: string;
  } | null;
};

export type ManagedUnitUpdatesSubscriptionVariables = Exact<{
  [key: string]: never;
}>;

export type ManagedUnitUpdatesSubscription = {
  __typename?: 'Subscription';
  unitEvents?: {
    __typename?: 'Unit';
    modelChangeOperation?: string | null;
    _id: string;
    name: string;
    type: string;
    propertyId: string;
    buildingId: string;
    floorId?: string | null;
    cuid?: string | null;
  } | null;
};

export type ManagedPlmEventResponseUpdatesSubscriptionVariables = Exact<{
  [key: string]: never;
}>;

export type ManagedPlmEventResponseUpdatesSubscription = {
  __typename?: 'Subscription';
  plmEventResponseEvents?: {
    __typename?: 'PlmEventResponse';
    modelChangeOperation?: string | null;
    _id: string;
    eventId: string;
    propertyId?: string | null;
    curtailmentPlanId?: string | null;
    scheduledStart: number;
    scheduledEnd: number;
    actualStart?: number | null;
    actualEnd?: number | null;
    responseSentAt: number;
    responseStatus: EnumPlmEventResponseResponseStatus;
    createdAt: number;
    updatedAt: number;
    event?: {
      __typename?: 'PlmEvent';
      _id: string;
      programId: string;
      contractId: string;
      startTime: number;
      duration: number;
      reductionTarget?: number | null;
      status: EnumPlmEventStatus;
      notificationMethod?: EnumPlmEventNotificationMethod | null;
      notificationReceivedAt?: number | null;
      notificationPayload?: string | null;
      program?: {
        __typename?: 'PlmProgram';
        _id: string;
        programId: string;
        name: string;
        partnerId: string;
        season: EnumPlmProgramSeason;
        startDate: number;
        endDate?: number | null;
        notificationLeadTimeMinutes?: number | null;
        maximumNotificationLeadTimeMinutes?: number | null;
        minimumEventDurationMinutes?: number | null;
        maximumEventDurationMinutes?: number | null;
        minimumEventsPerSeason?: number | null;
        maximumEventsPerSeason?: number | null;
        measurementIntervalMinutes?: number | null;
        participationType: EnumPlmProgramParticipationType;
        incentiveDescription?: string | null;
        partner?: {
          __typename?: 'PlmPartner';
          _id: string;
          name: string;
          description: string;
        } | null;
      } | null;
      contract?: {
        __typename?: 'PlmContract';
        _id: string;
        name: string;
        contractId: string;
        programId: string;
        propertyIds?: Array<string | null> | null;
        partnerId: string;
        dispatcherIds?: Array<string | null> | null;
        minimumReductionKW: number;
        maximumEventsPerSeason: number;
        baselineMethod: EnumPlmContractBaselineMethod;
        incentiveDescription?: string | null;
        penaltyForNonCompliance?: number | null;
        status: EnumPlmContractStatus;
        notificationEmail: string;
      } | null;
    } | null;
    curtailmentPlan?: {
      __typename?: 'PlmCurtailmentPlan';
      _id: string;
      name: string;
      description: string;
      estimatedReductionKW: number;
      durationMinutes: number;
      applicableSeasons: Array<EnumPlmCurtailmentPlanApplicableSeasons | null>;
      organizationId: string;
    } | null;
  } | null;
};

export type ManagedEntitiesThermostatsByPropertyIdQueryVariables = Exact<{
  propertyId: Scalars['String'];
}>;

export type ManagedEntitiesThermostatsByPropertyIdQuery = {
  __typename?: 'Query';
  thermostats: Array<{
    __typename?: 'Thermostat';
    _id: string;
    name?: string | null;
    type?: EnumDKeyDeviceType | null;
    location?: string | null;
    propertyId: string;
    unitId: string;
    sourceId?: string | null;
    installation?: { __typename?: 'DeviceInstallation'; status: number } | null;
  }>;
};

export type ManagedUnitUpdatesByPropertyIdsSubscriptionVariables = Exact<{
  propertyIds?: InputMaybe<
    Array<InputMaybe<Scalars['String']>> | InputMaybe<Scalars['String']>
  >;
}>;

export type ManagedUnitUpdatesByPropertyIdsSubscription = {
  __typename?: 'Subscription';
  unitEventsByPropertyId?: {
    __typename?: 'Unit';
    modelChangeOperation?: string | null;
    _id: string;
    name: string;
    type: string;
    propertyId: string;
    buildingId: string;
    floorId?: string | null;
    cuid?: string | null;
  } | null;
};

export type ManagedEntitiesUnitsByPropertyIdsQueryVariables = Exact<{
  propertyIds?: InputMaybe<
    Array<InputMaybe<Scalars['String']>> | InputMaybe<Scalars['String']>
  >;
}>;

export type ManagedEntitiesUnitsByPropertyIdsQuery = {
  __typename?: 'Query';
  unitsByPropertyId: Array<{
    __typename?: 'Unit';
    _id: string;
    name: string;
    type: string;
    propertyId: string;
    buildingId: string;
    floorId?: string | null;
    cuid?: string | null;
    systemNotifications?: Array<{
      __typename?: 'SystemNotification';
      _id: string;
      message: string;
      acknowledgedAt?: number | null;
      requireAcknowledgement: boolean;
      seenAt?: number | null;
    }> | null;
  }>;
};

export type ManagedEntitiesUnitsQueryVariables = Exact<{
  [key: string]: never;
}>;

export type ManagedEntitiesUnitsQuery = {
  __typename?: 'Query';
  units: Array<{
    __typename?: 'Unit';
    _id: string;
    name: string;
    type: string;
    propertyId: string;
    buildingId: string;
    floorId?: string | null;
    cuid?: string | null;
    systemNotifications?: Array<{
      __typename?: 'SystemNotification';
      _id: string;
      message: string;
      acknowledgedAt?: number | null;
      requireAcknowledgement: boolean;
      seenAt?: number | null;
    }> | null;
  }>;
};

export type ManagedEntitiesQueryVariables = Exact<{ [key: string]: never }>;

export type ManagedEntitiesQuery = {
  __typename?: 'Query';
  organizations: Array<{
    __typename?: 'Organization';
    _id: string;
    name: string;
    description?: string | null;
    hqPhone?: string | null;
    hqEmail?: string | null;
    hqAddress: {
      __typename?: 'OrganizationHqAddress';
      line1: string;
      line2?: string | null;
      city: string;
      state: string;
      postalCode: string;
      country: string;
    };
    systemNotifications?: Array<{
      __typename?: 'SystemNotification';
      _id: string;
      message: string;
      acknowledgedAt?: number | null;
      requireAcknowledgement: boolean;
      seenAt?: number | null;
    }> | null;
  }>;
  properties: Array<{
    __typename?: 'Property';
    _id: string;
    title: string;
    floorLabel?: string | null;
    imageUrl?: string | null;
    address: {
      __typename?: 'PropertyAddress';
      line1: string;
      city?: string | null;
      state?: string | null;
      postalCode?: string | null;
    };
    owner?: { __typename?: 'PropertyOwner'; name?: string | null } | null;
    propMgr?: {
      __typename?: 'PropertyPropMgr';
      name?: string | null;
      mobile?: string | null;
    } | null;
    maintMgr?: {
      __typename?: 'PropertyMaintMgr';
      name?: string | null;
      mobile?: string | null;
    } | null;
    systemNotifications?: Array<{
      __typename?: 'SystemNotification';
      _id: string;
      message: string;
      acknowledgedAt?: number | null;
      requireAcknowledgement: boolean;
      seenAt?: number | null;
    }> | null;
  }>;
  cores: Array<{
    __typename?: 'Core';
    _id: string;
    name: string;
    propertyId?: string | null;
    url?: string | null;
    type?: EnumDKeySourceType | null;
    inUse: boolean;
  }>;
  hMMs: Array<{
    __typename?: 'HMM';
    _id: string;
    name: string;
    propertyId?: string | null;
    url?: string | null;
    type?: EnumDKeySourceType | null;
    inUse: boolean;
  }>;
  bNGs: Array<{
    __typename?: 'BNG';
    _id: string;
    name: string;
    propertyId?: string | null;
    url?: string | null;
    type?: EnumDKeySourceType | null;
    inUse: boolean;
    localUrl?: string | null;
  }>;
  conductors: Array<{
    __typename?: 'Conductor';
    _id: string;
    name: string;
    propertyId?: string | null;
    url?: string | null;
    type?: EnumDKeySourceType | null;
    inUse: boolean;
  }>;
  buildings: Array<{
    __typename?: 'Building';
    _id: string;
    name: string;
    number?: number | null;
    propertyId: string;
  }>;
  floors: Array<{
    __typename?: 'Floor';
    _id: string;
    name: string;
    buildingId: string;
    propertyId: string;
  }>;
  units: Array<{
    __typename?: 'Unit';
    _id: string;
    name: string;
    type: string;
    propertyId: string;
    buildingId: string;
    floorId?: string | null;
    cuid?: string | null;
    systemNotifications?: Array<{
      __typename?: 'SystemNotification';
      _id: string;
      message: string;
      acknowledgedAt?: number | null;
      requireAcknowledgement: boolean;
      seenAt?: number | null;
    }> | null;
  }>;
  plmEventResponses: Array<{
    __typename?: 'PlmEventResponse';
    _id: string;
    eventId: string;
    propertyId?: string | null;
    curtailmentPlanId?: string | null;
    scheduledStart: number;
    scheduledEnd: number;
    actualStart?: number | null;
    actualEnd?: number | null;
    responseSentAt: number;
    responseStatus: EnumPlmEventResponseResponseStatus;
    createdAt: number;
    updatedAt: number;
    event?: {
      __typename?: 'PlmEvent';
      _id: string;
      programId: string;
      contractId: string;
      startTime: number;
      duration: number;
      reductionTarget?: number | null;
      status: EnumPlmEventStatus;
      notificationMethod?: EnumPlmEventNotificationMethod | null;
      notificationReceivedAt?: number | null;
      notificationPayload?: string | null;
      program?: {
        __typename?: 'PlmProgram';
        _id: string;
        programId: string;
        name: string;
        partnerId: string;
        season: EnumPlmProgramSeason;
        startDate: number;
        endDate?: number | null;
        notificationLeadTimeMinutes?: number | null;
        maximumNotificationLeadTimeMinutes?: number | null;
        minimumEventDurationMinutes?: number | null;
        maximumEventDurationMinutes?: number | null;
        minimumEventsPerSeason?: number | null;
        maximumEventsPerSeason?: number | null;
        measurementIntervalMinutes?: number | null;
        participationType: EnumPlmProgramParticipationType;
        incentiveDescription?: string | null;
        partner?: {
          __typename?: 'PlmPartner';
          _id: string;
          name: string;
          description: string;
        } | null;
      } | null;
      contract?: {
        __typename?: 'PlmContract';
        _id: string;
        name: string;
        contractId: string;
        programId: string;
        propertyIds?: Array<string | null> | null;
        partnerId: string;
        dispatcherIds?: Array<string | null> | null;
        minimumReductionKW: number;
        maximumEventsPerSeason: number;
        baselineMethod: EnumPlmContractBaselineMethod;
        incentiveDescription?: string | null;
        penaltyForNonCompliance?: number | null;
        status: EnumPlmContractStatus;
        notificationEmail: string;
      } | null;
    } | null;
    curtailmentPlan?: {
      __typename?: 'PlmCurtailmentPlan';
      _id: string;
      name: string;
      description: string;
      estimatedReductionKW: number;
      durationMinutes: number;
      applicableSeasons: Array<EnumPlmCurtailmentPlanApplicableSeasons | null>;
      organizationId: string;
    } | null;
  }>;
};

export type SystemCommandPostedSubscriptionVariables = Exact<{
  [key: string]: never;
}>;

export type SystemCommandPostedSubscription = {
  __typename?: 'Subscription';
  systemCommandPosted?: {
    __typename?: 'SystemCommand';
    timestamp: number;
    directive?: SystemDirective | null;
    message: string;
  } | null;
};

export type SystemMessagePostedSubscriptionVariables = Exact<{
  types?: InputMaybe<
    Array<InputMaybe<SystemMessageType>> | InputMaybe<SystemMessageType>
  >;
}>;

export type SystemMessagePostedSubscription = {
  __typename?: 'Subscription';
  systemMessagePosted?: {
    __typename?: 'SystemMessage';
    timestamp: number;
    message?: string | null;
    type?: SystemMessageType | null;
  } | null;
};

export type ChartDataQueryVariables = Exact<{
  startDate: Scalars['String'];
  endDate: Scalars['String'];
  deviceIds: Array<Scalars['String']> | Scalars['String'];
  chartTypes: Array<ChartType> | ChartType;
}>;

export type ChartDataQuery = {
  __typename?: 'Query';
  chartData: Array<{
    __typename?: 'ChartData';
    chartType: ChartType;
    visType: ChartVisType;
    series: Array<
      | {
          __typename: 'AggregateCategoricalChartSeries';
          distinctValues: Array<string>;
          aggregateInterval: string;
          readingType: string;
          deviceId: string;
          units?: string | null;
          aggregateCategoricalData: Array<{
            __typename?: 'AggregateCategoricalDatapoint';
            timestamp: string;
            values: any;
          }>;
        }
      | {
          __typename: 'CategoricalChartSeries';
          distinctValues: Array<string>;
          readingType: string;
          deviceId: string;
          units?: string | null;
          categoricalData: Array<{
            __typename?: 'CategoricalDatapoint';
            timestamp: string;
            value: string;
          }>;
        }
      | {
          __typename: 'NumericChartSeries';
          readingType: string;
          deviceId: string;
          units?: string | null;
          numericData: Array<{
            __typename?: 'NumericDatapoint';
            timestamp: string;
            value: number;
          }>;
        }
    >;
  }>;
};

export type CreateUnitMutationVariables = Exact<{
  unit: CreateOneUnitInput;
}>;

export type CreateUnitMutation = {
  __typename?: 'Mutation';
  createUnit?: { __typename?: 'Unit'; _id: string } | null;
};

export type PropertyDataForUnitQueryVariables = Exact<{
  id: Scalars['String'];
}>;

export type PropertyDataForUnitQuery = {
  __typename?: 'Query';
  propertyById?: {
    __typename?: 'Property';
    _id: string;
    title: string;
    setpointProfileId?: string | null;
    buildings: Array<{
      __typename?: 'Building';
      _id: string;
      name: string;
      units: Array<{ __typename?: 'Unit'; _id: string; name: string } | null>;
    } | null>;
    sources: Array<
      | { __typename?: 'BNG'; _id: string; name: string }
      | { __typename?: 'Conductor'; _id: string; name: string }
      | { __typename?: 'Core'; _id: string; name: string }
      | { __typename?: 'HMM'; _id: string; name: string }
      | { __typename?: 'Source'; _id: string; name: string }
    >;
  } | null;
};

export type UnitAndPropertyBasicsQueryVariables = Exact<{
  id: Scalars['String'];
}>;

export type UnitAndPropertyBasicsQuery = {
  __typename?: 'Query';
  unitById?: {
    __typename?: 'Unit';
    _id: string;
    name: string;
    type: string;
    propertyId: string;
    property?: { __typename?: 'Property'; _id: string; title: string } | null;
  } | null;
};

export type UnitDetailUpdateSubscriptionVariables = Exact<{
  ids: Array<Scalars['String']> | Scalars['String'];
}>;

export type UnitDetailUpdateSubscription = {
  __typename?: 'Subscription';
  unitEventsByIds?: {
    __typename?: 'Unit';
    modelChangeOperation?: string | null;
    _id: string;
    name: string;
    propertyId: string;
    separatePowerThermostatIds: Array<string>;
    setpointProfileId?: string | null;
    devicesSummary?: {
      __typename?: 'UnitDevicesSummary';
      count?: number | null;
      majorAlerts?: number | null;
      minorAlerts?: number | null;
      proxy?: {
        __typename: 'UnitDevicesSummaryProxy';
        type?: string | null;
        coolSetpoint?: number | null;
        heatSetpoint?: number | null;
        humidity?: number | null;
        isOffline?: boolean | null;
        operatingMode?: string | null;
        operatingState?: string | null;
        setpointCoolMin?: number | null;
        setpointHeatMax?: number | null;
        setpointProfileName?: string | null;
        setpointProfileType?: string | null;
        temperature?: number | null;
      } | null;
    } | null;
    zones: Array<{
      __typename: 'Zone';
      _id: string;
      sourceId?: string | null;
      name: string;
      controller?: string | null;
      thermostatId?: string | null;
      pairedSensorId?: string | null;
      role?: string | null;
      devices: Array<
        | {
            __typename: 'Actuator';
            _id: string;
            deviceId?: string | null;
            sourceId?: string | null;
            name?: string | null;
            type?: EnumDKeyDeviceType | null;
            typeDisplayName: string;
            isConfigured?: boolean | null;
            timestamp?: number | null;
            isPoweredOn?: boolean | null;
            powerState?: {
              __typename?: 'DevicePowerState';
              value?: EnumDevicePowerStateValue | null;
              timestamp?: number | null;
            } | null;
          }
        | {
            __typename: 'BatteryManagementSystem';
            _id: string;
            deviceId?: string | null;
            sourceId?: string | null;
            name?: string | null;
            type?: EnumDKeyDeviceType | null;
            typeDisplayName: string;
            isConfigured?: boolean | null;
            timestamp?: number | null;
            isPoweredOn?: boolean | null;
            powerState?: {
              __typename?: 'DevicePowerState';
              value?: EnumDevicePowerStateValue | null;
              timestamp?: number | null;
            } | null;
          }
        | {
            __typename: 'Boiler';
            _id: string;
            deviceId?: string | null;
            sourceId?: string | null;
            name?: string | null;
            type?: EnumDKeyDeviceType | null;
            typeDisplayName: string;
            isConfigured?: boolean | null;
            timestamp?: number | null;
            isPoweredOn?: boolean | null;
            powerState?: {
              __typename?: 'DevicePowerState';
              value?: EnumDevicePowerStateValue | null;
              timestamp?: number | null;
            } | null;
          }
        | {
            __typename: 'Chiller';
            _id: string;
            deviceId?: string | null;
            sourceId?: string | null;
            name?: string | null;
            type?: EnumDKeyDeviceType | null;
            typeDisplayName: string;
            isConfigured?: boolean | null;
            timestamp?: number | null;
            isPoweredOn?: boolean | null;
            powerState?: {
              __typename?: 'DevicePowerState';
              value?: EnumDevicePowerStateValue | null;
              timestamp?: number | null;
            } | null;
          }
        | {
            __typename: 'ConductorGenericSensor';
            _id: string;
            deviceId?: string | null;
            sourceId?: string | null;
            name?: string | null;
            type?: EnumDKeyDeviceType | null;
            typeDisplayName: string;
            isConfigured?: boolean | null;
            timestamp?: number | null;
            isPoweredOn?: boolean | null;
            powerState?: {
              __typename?: 'DevicePowerState';
              value?: EnumDevicePowerStateValue | null;
              timestamp?: number | null;
            } | null;
          }
        | {
            __typename: 'Controller';
            _id: string;
            deviceId?: string | null;
            sourceId?: string | null;
            name?: string | null;
            type?: EnumDKeyDeviceType | null;
            typeDisplayName: string;
            isConfigured?: boolean | null;
            timestamp?: number | null;
            isPoweredOn?: boolean | null;
            powerState?: {
              __typename?: 'DevicePowerState';
              value?: EnumDevicePowerStateValue | null;
              timestamp?: number | null;
            } | null;
          }
        | {
            __typename: 'Device';
            _id: string;
            deviceId?: string | null;
            sourceId?: string | null;
            name?: string | null;
            type?: EnumDKeyDeviceType | null;
            typeDisplayName: string;
            isConfigured?: boolean | null;
            timestamp?: number | null;
            isPoweredOn?: boolean | null;
            powerState?: {
              __typename?: 'DevicePowerState';
              value?: EnumDevicePowerStateValue | null;
              timestamp?: number | null;
            } | null;
          }
        | {
            __typename: 'DoorSensor';
            _id: string;
            deviceId?: string | null;
            sourceId?: string | null;
            name?: string | null;
            type?: EnumDKeyDeviceType | null;
            typeDisplayName: string;
            isConfigured?: boolean | null;
            timestamp?: number | null;
            isPoweredOn?: boolean | null;
            powerState?: {
              __typename?: 'DevicePowerState';
              value?: EnumDevicePowerStateValue | null;
              timestamp?: number | null;
            } | null;
          }
        | {
            __typename: 'EnergyController';
            _id: string;
            deviceId?: string | null;
            sourceId?: string | null;
            name?: string | null;
            type?: EnumDKeyDeviceType | null;
            typeDisplayName: string;
            isConfigured?: boolean | null;
            timestamp?: number | null;
            isPoweredOn?: boolean | null;
            powerState?: {
              __typename?: 'DevicePowerState';
              value?: EnumDevicePowerStateValue | null;
              timestamp?: number | null;
            } | null;
          }
        | {
            __typename: 'EnergyConverter';
            _id: string;
            deviceId?: string | null;
            sourceId?: string | null;
            name?: string | null;
            type?: EnumDKeyDeviceType | null;
            typeDisplayName: string;
            isConfigured?: boolean | null;
            timestamp?: number | null;
            isPoweredOn?: boolean | null;
            powerState?: {
              __typename?: 'DevicePowerState';
              value?: EnumDevicePowerStateValue | null;
              timestamp?: number | null;
            } | null;
          }
        | {
            __typename: 'EnergyInverter';
            _id: string;
            deviceId?: string | null;
            sourceId?: string | null;
            name?: string | null;
            type?: EnumDKeyDeviceType | null;
            typeDisplayName: string;
            isConfigured?: boolean | null;
            timestamp?: number | null;
            isPoweredOn?: boolean | null;
            powerState?: {
              __typename?: 'DevicePowerState';
              value?: EnumDevicePowerStateValue | null;
              timestamp?: number | null;
            } | null;
          }
        | {
            __typename: 'EnergyMeter';
            _id: string;
            deviceId?: string | null;
            sourceId?: string | null;
            name?: string | null;
            type?: EnumDKeyDeviceType | null;
            typeDisplayName: string;
            isConfigured?: boolean | null;
            timestamp?: number | null;
            isPoweredOn?: boolean | null;
            powerState?: {
              __typename?: 'DevicePowerState';
              value?: EnumDevicePowerStateValue | null;
              timestamp?: number | null;
            } | null;
          }
        | {
            __typename: 'EnergyRectifier';
            _id: string;
            deviceId?: string | null;
            sourceId?: string | null;
            name?: string | null;
            type?: EnumDKeyDeviceType | null;
            typeDisplayName: string;
            isConfigured?: boolean | null;
            timestamp?: number | null;
            isPoweredOn?: boolean | null;
            powerState?: {
              __typename?: 'DevicePowerState';
              value?: EnumDevicePowerStateValue | null;
              timestamp?: number | null;
            } | null;
          }
        | {
            __typename: 'EnergyStorageCoolingSystem';
            _id: string;
            deviceId?: string | null;
            sourceId?: string | null;
            name?: string | null;
            type?: EnumDKeyDeviceType | null;
            typeDisplayName: string;
            isConfigured?: boolean | null;
            timestamp?: number | null;
            isPoweredOn?: boolean | null;
            powerState?: {
              __typename?: 'DevicePowerState';
              value?: EnumDevicePowerStateValue | null;
              timestamp?: number | null;
            } | null;
          }
        | {
            __typename: 'EnergySwitchPanel';
            _id: string;
            deviceId?: string | null;
            sourceId?: string | null;
            name?: string | null;
            type?: EnumDKeyDeviceType | null;
            typeDisplayName: string;
            isConfigured?: boolean | null;
            timestamp?: number | null;
            isPoweredOn?: boolean | null;
            powerState?: {
              __typename?: 'DevicePowerState';
              value?: EnumDevicePowerStateValue | null;
              timestamp?: number | null;
            } | null;
          }
        | {
            __typename: 'EnergySwitchPanelCircuit';
            _id: string;
            deviceId?: string | null;
            sourceId?: string | null;
            name?: string | null;
            type?: EnumDKeyDeviceType | null;
            typeDisplayName: string;
            isConfigured?: boolean | null;
            timestamp?: number | null;
            isPoweredOn?: boolean | null;
            powerState?: {
              __typename?: 'DevicePowerState';
              value?: EnumDevicePowerStateValue | null;
              timestamp?: number | null;
            } | null;
          }
        | {
            __typename: 'FireSuppressionSystem';
            _id: string;
            deviceId?: string | null;
            sourceId?: string | null;
            name?: string | null;
            type?: EnumDKeyDeviceType | null;
            typeDisplayName: string;
            isConfigured?: boolean | null;
            timestamp?: number | null;
            isPoweredOn?: boolean | null;
            powerState?: {
              __typename?: 'DevicePowerState';
              value?: EnumDevicePowerStateValue | null;
              timestamp?: number | null;
            } | null;
          }
        | {
            __typename: 'GPIO';
            _id: string;
            deviceId?: string | null;
            sourceId?: string | null;
            name?: string | null;
            type?: EnumDKeyDeviceType | null;
            typeDisplayName: string;
            isConfigured?: boolean | null;
            timestamp?: number | null;
            isPoweredOn?: boolean | null;
            powerState?: {
              __typename?: 'DevicePowerState';
              value?: EnumDevicePowerStateValue | null;
              timestamp?: number | null;
            } | null;
          }
        | {
            __typename: 'IndoorAirHandler';
            _id: string;
            deviceId?: string | null;
            sourceId?: string | null;
            name?: string | null;
            type?: EnumDKeyDeviceType | null;
            typeDisplayName: string;
            isConfigured?: boolean | null;
            timestamp?: number | null;
            isPoweredOn?: boolean | null;
            powerState?: {
              __typename?: 'DevicePowerState';
              value?: EnumDevicePowerStateValue | null;
              timestamp?: number | null;
            } | null;
          }
        | {
            __typename: 'IndoorSensor';
            _id: string;
            deviceId?: string | null;
            sourceId?: string | null;
            name?: string | null;
            type?: EnumDKeyDeviceType | null;
            typeDisplayName: string;
            isConfigured?: boolean | null;
            timestamp?: number | null;
            isPoweredOn?: boolean | null;
            powerState?: {
              __typename?: 'DevicePowerState';
              value?: EnumDevicePowerStateValue | null;
              timestamp?: number | null;
            } | null;
          }
        | {
            __typename: 'KineticEnergyManagementSystem';
            _id: string;
            deviceId?: string | null;
            sourceId?: string | null;
            name?: string | null;
            type?: EnumDKeyDeviceType | null;
            typeDisplayName: string;
            isConfigured?: boolean | null;
            timestamp?: number | null;
            isPoweredOn?: boolean | null;
            powerState?: {
              __typename?: 'DevicePowerState';
              value?: EnumDevicePowerStateValue | null;
              timestamp?: number | null;
            } | null;
          }
        | {
            __typename: 'LeakDetector';
            _id: string;
            deviceId?: string | null;
            sourceId?: string | null;
            name?: string | null;
            type?: EnumDKeyDeviceType | null;
            typeDisplayName: string;
            isConfigured?: boolean | null;
            timestamp?: number | null;
            isPoweredOn?: boolean | null;
            powerState?: {
              __typename?: 'DevicePowerState';
              value?: EnumDevicePowerStateValue | null;
              timestamp?: number | null;
            } | null;
          }
        | {
            __typename: 'Loop';
            _id: string;
            deviceId?: string | null;
            sourceId?: string | null;
            name?: string | null;
            type?: EnumDKeyDeviceType | null;
            typeDisplayName: string;
            isConfigured?: boolean | null;
            timestamp?: number | null;
            isPoweredOn?: boolean | null;
            powerState?: {
              __typename?: 'DevicePowerState';
              value?: EnumDevicePowerStateValue | null;
              timestamp?: number | null;
            } | null;
          }
        | {
            __typename: 'ModbusAirHandler';
            _id: string;
            deviceId?: string | null;
            sourceId?: string | null;
            name?: string | null;
            type?: EnumDKeyDeviceType | null;
            typeDisplayName: string;
            isConfigured?: boolean | null;
            timestamp?: number | null;
            isPoweredOn?: boolean | null;
            powerState?: {
              __typename?: 'DevicePowerState';
              value?: EnumDevicePowerStateValue | null;
              timestamp?: number | null;
            } | null;
          }
        | {
            __typename: 'OccupancySensor';
            _id: string;
            deviceId?: string | null;
            sourceId?: string | null;
            name?: string | null;
            type?: EnumDKeyDeviceType | null;
            typeDisplayName: string;
            isConfigured?: boolean | null;
            timestamp?: number | null;
            isPoweredOn?: boolean | null;
            powerState?: {
              __typename?: 'DevicePowerState';
              value?: EnumDevicePowerStateValue | null;
              timestamp?: number | null;
            } | null;
          }
        | {
            __typename: 'OpenWeather';
            _id: string;
            deviceId?: string | null;
            sourceId?: string | null;
            name?: string | null;
            type?: EnumDKeyDeviceType | null;
            typeDisplayName: string;
            isConfigured?: boolean | null;
            timestamp?: number | null;
            isPoweredOn?: boolean | null;
            powerState?: {
              __typename?: 'DevicePowerState';
              value?: EnumDevicePowerStateValue | null;
              timestamp?: number | null;
            } | null;
          }
        | {
            __typename: 'OutdoorSensor';
            _id: string;
            deviceId?: string | null;
            sourceId?: string | null;
            name?: string | null;
            type?: EnumDKeyDeviceType | null;
            typeDisplayName: string;
            isConfigured?: boolean | null;
            timestamp?: number | null;
            isPoweredOn?: boolean | null;
            powerState?: {
              __typename?: 'DevicePowerState';
              value?: EnumDevicePowerStateValue | null;
              timestamp?: number | null;
            } | null;
          }
        | {
            __typename: 'PowerMonitor';
            _id: string;
            deviceId?: string | null;
            sourceId?: string | null;
            name?: string | null;
            type?: EnumDKeyDeviceType | null;
            typeDisplayName: string;
            isConfigured?: boolean | null;
            timestamp?: number | null;
            isPoweredOn?: boolean | null;
            powerState?: {
              __typename?: 'DevicePowerState';
              value?: EnumDevicePowerStateValue | null;
              timestamp?: number | null;
            } | null;
          }
        | {
            __typename: 'PressureSensor';
            _id: string;
            deviceId?: string | null;
            sourceId?: string | null;
            name?: string | null;
            type?: EnumDKeyDeviceType | null;
            typeDisplayName: string;
            isConfigured?: boolean | null;
            timestamp?: number | null;
            isPoweredOn?: boolean | null;
            powerState?: {
              __typename?: 'DevicePowerState';
              value?: EnumDevicePowerStateValue | null;
              timestamp?: number | null;
            } | null;
          }
        | {
            __typename: 'RelayDevice';
            _id: string;
            deviceId?: string | null;
            sourceId?: string | null;
            name?: string | null;
            type?: EnumDKeyDeviceType | null;
            typeDisplayName: string;
            isConfigured?: boolean | null;
            timestamp?: number | null;
            isPoweredOn?: boolean | null;
            powerState?: {
              __typename?: 'DevicePowerState';
              value?: EnumDevicePowerStateValue | null;
              timestamp?: number | null;
            } | null;
          }
        | {
            __typename: 'SmartPowerOutlet';
            _id: string;
            deviceId?: string | null;
            sourceId?: string | null;
            name?: string | null;
            type?: EnumDKeyDeviceType | null;
            typeDisplayName: string;
            isConfigured?: boolean | null;
            timestamp?: number | null;
            isPoweredOn?: boolean | null;
            powerState?: {
              __typename?: 'DevicePowerState';
              value?: EnumDevicePowerStateValue | null;
              timestamp?: number | null;
            } | null;
          }
        | {
            __typename: 'SolarManagementSystem';
            _id: string;
            deviceId?: string | null;
            sourceId?: string | null;
            name?: string | null;
            type?: EnumDKeyDeviceType | null;
            typeDisplayName: string;
            isConfigured?: boolean | null;
            timestamp?: number | null;
            isPoweredOn?: boolean | null;
            powerState?: {
              __typename?: 'DevicePowerState';
              value?: EnumDevicePowerStateValue | null;
              timestamp?: number | null;
            } | null;
          }
        | {
            __typename: 'Thermistor';
            _id: string;
            deviceId?: string | null;
            sourceId?: string | null;
            name?: string | null;
            type?: EnumDKeyDeviceType | null;
            typeDisplayName: string;
            isConfigured?: boolean | null;
            timestamp?: number | null;
            isPoweredOn?: boolean | null;
            powerState?: {
              __typename?: 'DevicePowerState';
              value?: EnumDevicePowerStateValue | null;
              timestamp?: number | null;
            } | null;
          }
        | {
            __typename: 'Thermostat';
            _id: string;
            deviceId?: string | null;
            sourceId?: string | null;
            name?: string | null;
            type?: EnumDKeyDeviceType | null;
            typeDisplayName: string;
            isConfigured?: boolean | null;
            timestamp?: number | null;
            isPoweredOn?: boolean | null;
            powerState?: {
              __typename?: 'DevicePowerState';
              value?: EnumDevicePowerStateValue | null;
              timestamp?: number | null;
            } | null;
          }
        | {
            __typename: 'VSDPump';
            _id: string;
            deviceId?: string | null;
            sourceId?: string | null;
            name?: string | null;
            type?: EnumDKeyDeviceType | null;
            typeDisplayName: string;
            isConfigured?: boolean | null;
            timestamp?: number | null;
            isPoweredOn?: boolean | null;
            powerState?: {
              __typename?: 'DevicePowerState';
              value?: EnumDevicePowerStateValue | null;
              timestamp?: number | null;
            } | null;
          }
        | {
            __typename: 'WindManagementSystem';
            _id: string;
            deviceId?: string | null;
            sourceId?: string | null;
            name?: string | null;
            type?: EnumDKeyDeviceType | null;
            typeDisplayName: string;
            isConfigured?: boolean | null;
            timestamp?: number | null;
            isPoweredOn?: boolean | null;
            powerState?: {
              __typename?: 'DevicePowerState';
              value?: EnumDevicePowerStateValue | null;
              timestamp?: number | null;
            } | null;
          }
        | {
            __typename: 'WindowSensor';
            _id: string;
            deviceId?: string | null;
            sourceId?: string | null;
            name?: string | null;
            type?: EnumDKeyDeviceType | null;
            typeDisplayName: string;
            isConfigured?: boolean | null;
            timestamp?: number | null;
            isPoweredOn?: boolean | null;
            powerState?: {
              __typename?: 'DevicePowerState';
              value?: EnumDevicePowerStateValue | null;
              timestamp?: number | null;
            } | null;
          }
        | {
            __typename: 'Z210Pump';
            _id: string;
            deviceId?: string | null;
            sourceId?: string | null;
            name?: string | null;
            type?: EnumDKeyDeviceType | null;
            typeDisplayName: string;
            isConfigured?: boolean | null;
            timestamp?: number | null;
            isPoweredOn?: boolean | null;
            powerState?: {
              __typename?: 'DevicePowerState';
              value?: EnumDevicePowerStateValue | null;
              timestamp?: number | null;
            } | null;
          }
      >;
    } | null>;
    panels: Array<{
      __typename: 'Panel';
      _id: string;
      sourceId: string;
      name?: string | null;
      displayName?: string | null;
      type: EnumPanelType;
      role?: string | null;
      devices: Array<
        | {
            __typename: 'Actuator';
            _id: string;
            deviceId?: string | null;
            sourceId?: string | null;
            name?: string | null;
            type?: EnumDKeyDeviceType | null;
            typeDisplayName: string;
            isConfigured?: boolean | null;
            timestamp?: number | null;
            isPoweredOn?: boolean | null;
            powerState?: {
              __typename?: 'DevicePowerState';
              value?: EnumDevicePowerStateValue | null;
              timestamp?: number | null;
            } | null;
          }
        | {
            __typename: 'BatteryManagementSystem';
            _id: string;
            deviceId?: string | null;
            sourceId?: string | null;
            name?: string | null;
            type?: EnumDKeyDeviceType | null;
            typeDisplayName: string;
            isConfigured?: boolean | null;
            timestamp?: number | null;
            isPoweredOn?: boolean | null;
            powerState?: {
              __typename?: 'DevicePowerState';
              value?: EnumDevicePowerStateValue | null;
              timestamp?: number | null;
            } | null;
          }
        | {
            __typename: 'Boiler';
            _id: string;
            deviceId?: string | null;
            sourceId?: string | null;
            name?: string | null;
            type?: EnumDKeyDeviceType | null;
            typeDisplayName: string;
            isConfigured?: boolean | null;
            timestamp?: number | null;
            isPoweredOn?: boolean | null;
            powerState?: {
              __typename?: 'DevicePowerState';
              value?: EnumDevicePowerStateValue | null;
              timestamp?: number | null;
            } | null;
          }
        | {
            __typename: 'Chiller';
            _id: string;
            deviceId?: string | null;
            sourceId?: string | null;
            name?: string | null;
            type?: EnumDKeyDeviceType | null;
            typeDisplayName: string;
            isConfigured?: boolean | null;
            timestamp?: number | null;
            isPoweredOn?: boolean | null;
            powerState?: {
              __typename?: 'DevicePowerState';
              value?: EnumDevicePowerStateValue | null;
              timestamp?: number | null;
            } | null;
          }
        | {
            __typename: 'ConductorGenericSensor';
            _id: string;
            deviceId?: string | null;
            sourceId?: string | null;
            name?: string | null;
            type?: EnumDKeyDeviceType | null;
            typeDisplayName: string;
            isConfigured?: boolean | null;
            timestamp?: number | null;
            isPoweredOn?: boolean | null;
            powerState?: {
              __typename?: 'DevicePowerState';
              value?: EnumDevicePowerStateValue | null;
              timestamp?: number | null;
            } | null;
          }
        | {
            __typename: 'Controller';
            _id: string;
            deviceId?: string | null;
            sourceId?: string | null;
            name?: string | null;
            type?: EnumDKeyDeviceType | null;
            typeDisplayName: string;
            isConfigured?: boolean | null;
            timestamp?: number | null;
            isPoweredOn?: boolean | null;
            powerState?: {
              __typename?: 'DevicePowerState';
              value?: EnumDevicePowerStateValue | null;
              timestamp?: number | null;
            } | null;
          }
        | {
            __typename: 'Device';
            _id: string;
            deviceId?: string | null;
            sourceId?: string | null;
            name?: string | null;
            type?: EnumDKeyDeviceType | null;
            typeDisplayName: string;
            isConfigured?: boolean | null;
            timestamp?: number | null;
            isPoweredOn?: boolean | null;
            powerState?: {
              __typename?: 'DevicePowerState';
              value?: EnumDevicePowerStateValue | null;
              timestamp?: number | null;
            } | null;
          }
        | {
            __typename: 'DoorSensor';
            _id: string;
            deviceId?: string | null;
            sourceId?: string | null;
            name?: string | null;
            type?: EnumDKeyDeviceType | null;
            typeDisplayName: string;
            isConfigured?: boolean | null;
            timestamp?: number | null;
            isPoweredOn?: boolean | null;
            powerState?: {
              __typename?: 'DevicePowerState';
              value?: EnumDevicePowerStateValue | null;
              timestamp?: number | null;
            } | null;
          }
        | {
            __typename: 'EnergyController';
            _id: string;
            deviceId?: string | null;
            sourceId?: string | null;
            name?: string | null;
            type?: EnumDKeyDeviceType | null;
            typeDisplayName: string;
            isConfigured?: boolean | null;
            timestamp?: number | null;
            isPoweredOn?: boolean | null;
            powerState?: {
              __typename?: 'DevicePowerState';
              value?: EnumDevicePowerStateValue | null;
              timestamp?: number | null;
            } | null;
          }
        | {
            __typename: 'EnergyConverter';
            _id: string;
            deviceId?: string | null;
            sourceId?: string | null;
            name?: string | null;
            type?: EnumDKeyDeviceType | null;
            typeDisplayName: string;
            isConfigured?: boolean | null;
            timestamp?: number | null;
            isPoweredOn?: boolean | null;
            powerState?: {
              __typename?: 'DevicePowerState';
              value?: EnumDevicePowerStateValue | null;
              timestamp?: number | null;
            } | null;
          }
        | {
            __typename: 'EnergyInverter';
            _id: string;
            deviceId?: string | null;
            sourceId?: string | null;
            name?: string | null;
            type?: EnumDKeyDeviceType | null;
            typeDisplayName: string;
            isConfigured?: boolean | null;
            timestamp?: number | null;
            isPoweredOn?: boolean | null;
            powerState?: {
              __typename?: 'DevicePowerState';
              value?: EnumDevicePowerStateValue | null;
              timestamp?: number | null;
            } | null;
          }
        | {
            __typename: 'EnergyMeter';
            _id: string;
            deviceId?: string | null;
            sourceId?: string | null;
            name?: string | null;
            type?: EnumDKeyDeviceType | null;
            typeDisplayName: string;
            isConfigured?: boolean | null;
            timestamp?: number | null;
            isPoweredOn?: boolean | null;
            powerState?: {
              __typename?: 'DevicePowerState';
              value?: EnumDevicePowerStateValue | null;
              timestamp?: number | null;
            } | null;
          }
        | {
            __typename: 'EnergyRectifier';
            _id: string;
            deviceId?: string | null;
            sourceId?: string | null;
            name?: string | null;
            type?: EnumDKeyDeviceType | null;
            typeDisplayName: string;
            isConfigured?: boolean | null;
            timestamp?: number | null;
            isPoweredOn?: boolean | null;
            powerState?: {
              __typename?: 'DevicePowerState';
              value?: EnumDevicePowerStateValue | null;
              timestamp?: number | null;
            } | null;
          }
        | {
            __typename: 'EnergyStorageCoolingSystem';
            _id: string;
            deviceId?: string | null;
            sourceId?: string | null;
            name?: string | null;
            type?: EnumDKeyDeviceType | null;
            typeDisplayName: string;
            isConfigured?: boolean | null;
            timestamp?: number | null;
            isPoweredOn?: boolean | null;
            powerState?: {
              __typename?: 'DevicePowerState';
              value?: EnumDevicePowerStateValue | null;
              timestamp?: number | null;
            } | null;
          }
        | {
            __typename: 'EnergySwitchPanel';
            _id: string;
            deviceId?: string | null;
            sourceId?: string | null;
            name?: string | null;
            type?: EnumDKeyDeviceType | null;
            typeDisplayName: string;
            isConfigured?: boolean | null;
            timestamp?: number | null;
            isPoweredOn?: boolean | null;
            powerState?: {
              __typename?: 'DevicePowerState';
              value?: EnumDevicePowerStateValue | null;
              timestamp?: number | null;
            } | null;
          }
        | {
            __typename: 'EnergySwitchPanelCircuit';
            _id: string;
            deviceId?: string | null;
            sourceId?: string | null;
            name?: string | null;
            type?: EnumDKeyDeviceType | null;
            typeDisplayName: string;
            isConfigured?: boolean | null;
            timestamp?: number | null;
            isPoweredOn?: boolean | null;
            powerState?: {
              __typename?: 'DevicePowerState';
              value?: EnumDevicePowerStateValue | null;
              timestamp?: number | null;
            } | null;
          }
        | {
            __typename: 'FireSuppressionSystem';
            _id: string;
            deviceId?: string | null;
            sourceId?: string | null;
            name?: string | null;
            type?: EnumDKeyDeviceType | null;
            typeDisplayName: string;
            isConfigured?: boolean | null;
            timestamp?: number | null;
            isPoweredOn?: boolean | null;
            powerState?: {
              __typename?: 'DevicePowerState';
              value?: EnumDevicePowerStateValue | null;
              timestamp?: number | null;
            } | null;
          }
        | {
            __typename: 'GPIO';
            _id: string;
            deviceId?: string | null;
            sourceId?: string | null;
            name?: string | null;
            type?: EnumDKeyDeviceType | null;
            typeDisplayName: string;
            isConfigured?: boolean | null;
            timestamp?: number | null;
            isPoweredOn?: boolean | null;
            powerState?: {
              __typename?: 'DevicePowerState';
              value?: EnumDevicePowerStateValue | null;
              timestamp?: number | null;
            } | null;
          }
        | {
            __typename: 'IndoorAirHandler';
            _id: string;
            deviceId?: string | null;
            sourceId?: string | null;
            name?: string | null;
            type?: EnumDKeyDeviceType | null;
            typeDisplayName: string;
            isConfigured?: boolean | null;
            timestamp?: number | null;
            isPoweredOn?: boolean | null;
            powerState?: {
              __typename?: 'DevicePowerState';
              value?: EnumDevicePowerStateValue | null;
              timestamp?: number | null;
            } | null;
          }
        | {
            __typename: 'IndoorSensor';
            _id: string;
            deviceId?: string | null;
            sourceId?: string | null;
            name?: string | null;
            type?: EnumDKeyDeviceType | null;
            typeDisplayName: string;
            isConfigured?: boolean | null;
            timestamp?: number | null;
            isPoweredOn?: boolean | null;
            powerState?: {
              __typename?: 'DevicePowerState';
              value?: EnumDevicePowerStateValue | null;
              timestamp?: number | null;
            } | null;
          }
        | {
            __typename: 'KineticEnergyManagementSystem';
            _id: string;
            deviceId?: string | null;
            sourceId?: string | null;
            name?: string | null;
            type?: EnumDKeyDeviceType | null;
            typeDisplayName: string;
            isConfigured?: boolean | null;
            timestamp?: number | null;
            isPoweredOn?: boolean | null;
            powerState?: {
              __typename?: 'DevicePowerState';
              value?: EnumDevicePowerStateValue | null;
              timestamp?: number | null;
            } | null;
          }
        | {
            __typename: 'LeakDetector';
            _id: string;
            deviceId?: string | null;
            sourceId?: string | null;
            name?: string | null;
            type?: EnumDKeyDeviceType | null;
            typeDisplayName: string;
            isConfigured?: boolean | null;
            timestamp?: number | null;
            isPoweredOn?: boolean | null;
            powerState?: {
              __typename?: 'DevicePowerState';
              value?: EnumDevicePowerStateValue | null;
              timestamp?: number | null;
            } | null;
          }
        | {
            __typename: 'Loop';
            _id: string;
            deviceId?: string | null;
            sourceId?: string | null;
            name?: string | null;
            type?: EnumDKeyDeviceType | null;
            typeDisplayName: string;
            isConfigured?: boolean | null;
            timestamp?: number | null;
            isPoweredOn?: boolean | null;
            powerState?: {
              __typename?: 'DevicePowerState';
              value?: EnumDevicePowerStateValue | null;
              timestamp?: number | null;
            } | null;
          }
        | {
            __typename: 'ModbusAirHandler';
            _id: string;
            deviceId?: string | null;
            sourceId?: string | null;
            name?: string | null;
            type?: EnumDKeyDeviceType | null;
            typeDisplayName: string;
            isConfigured?: boolean | null;
            timestamp?: number | null;
            isPoweredOn?: boolean | null;
            powerState?: {
              __typename?: 'DevicePowerState';
              value?: EnumDevicePowerStateValue | null;
              timestamp?: number | null;
            } | null;
          }
        | {
            __typename: 'OccupancySensor';
            _id: string;
            deviceId?: string | null;
            sourceId?: string | null;
            name?: string | null;
            type?: EnumDKeyDeviceType | null;
            typeDisplayName: string;
            isConfigured?: boolean | null;
            timestamp?: number | null;
            isPoweredOn?: boolean | null;
            powerState?: {
              __typename?: 'DevicePowerState';
              value?: EnumDevicePowerStateValue | null;
              timestamp?: number | null;
            } | null;
          }
        | {
            __typename: 'OpenWeather';
            _id: string;
            deviceId?: string | null;
            sourceId?: string | null;
            name?: string | null;
            type?: EnumDKeyDeviceType | null;
            typeDisplayName: string;
            isConfigured?: boolean | null;
            timestamp?: number | null;
            isPoweredOn?: boolean | null;
            powerState?: {
              __typename?: 'DevicePowerState';
              value?: EnumDevicePowerStateValue | null;
              timestamp?: number | null;
            } | null;
          }
        | {
            __typename: 'OutdoorSensor';
            _id: string;
            deviceId?: string | null;
            sourceId?: string | null;
            name?: string | null;
            type?: EnumDKeyDeviceType | null;
            typeDisplayName: string;
            isConfigured?: boolean | null;
            timestamp?: number | null;
            isPoweredOn?: boolean | null;
            powerState?: {
              __typename?: 'DevicePowerState';
              value?: EnumDevicePowerStateValue | null;
              timestamp?: number | null;
            } | null;
          }
        | {
            __typename: 'PowerMonitor';
            _id: string;
            deviceId?: string | null;
            sourceId?: string | null;
            name?: string | null;
            type?: EnumDKeyDeviceType | null;
            typeDisplayName: string;
            isConfigured?: boolean | null;
            timestamp?: number | null;
            isPoweredOn?: boolean | null;
            powerState?: {
              __typename?: 'DevicePowerState';
              value?: EnumDevicePowerStateValue | null;
              timestamp?: number | null;
            } | null;
          }
        | {
            __typename: 'PressureSensor';
            role?: string | null;
            _id: string;
            deviceId?: string | null;
            sourceId?: string | null;
            name?: string | null;
            type?: EnumDKeyDeviceType | null;
            typeDisplayName: string;
            isConfigured?: boolean | null;
            timestamp?: number | null;
            isPoweredOn?: boolean | null;
            powerState?: {
              __typename?: 'DevicePowerState';
              value?: EnumDevicePowerStateValue | null;
              timestamp?: number | null;
            } | null;
          }
        | {
            __typename: 'RelayDevice';
            _id: string;
            deviceId?: string | null;
            sourceId?: string | null;
            name?: string | null;
            type?: EnumDKeyDeviceType | null;
            typeDisplayName: string;
            isConfigured?: boolean | null;
            timestamp?: number | null;
            isPoweredOn?: boolean | null;
            powerState?: {
              __typename?: 'DevicePowerState';
              value?: EnumDevicePowerStateValue | null;
              timestamp?: number | null;
            } | null;
          }
        | {
            __typename: 'SmartPowerOutlet';
            _id: string;
            deviceId?: string | null;
            sourceId?: string | null;
            name?: string | null;
            type?: EnumDKeyDeviceType | null;
            typeDisplayName: string;
            isConfigured?: boolean | null;
            timestamp?: number | null;
            isPoweredOn?: boolean | null;
            powerState?: {
              __typename?: 'DevicePowerState';
              value?: EnumDevicePowerStateValue | null;
              timestamp?: number | null;
            } | null;
          }
        | {
            __typename: 'SolarManagementSystem';
            _id: string;
            deviceId?: string | null;
            sourceId?: string | null;
            name?: string | null;
            type?: EnumDKeyDeviceType | null;
            typeDisplayName: string;
            isConfigured?: boolean | null;
            timestamp?: number | null;
            isPoweredOn?: boolean | null;
            powerState?: {
              __typename?: 'DevicePowerState';
              value?: EnumDevicePowerStateValue | null;
              timestamp?: number | null;
            } | null;
          }
        | {
            __typename: 'Thermistor';
            role?: string | null;
            _id: string;
            deviceId?: string | null;
            sourceId?: string | null;
            name?: string | null;
            type?: EnumDKeyDeviceType | null;
            typeDisplayName: string;
            isConfigured?: boolean | null;
            timestamp?: number | null;
            isPoweredOn?: boolean | null;
            powerState?: {
              __typename?: 'DevicePowerState';
              value?: EnumDevicePowerStateValue | null;
              timestamp?: number | null;
            } | null;
          }
        | {
            __typename: 'Thermostat';
            _id: string;
            deviceId?: string | null;
            sourceId?: string | null;
            name?: string | null;
            type?: EnumDKeyDeviceType | null;
            typeDisplayName: string;
            isConfigured?: boolean | null;
            timestamp?: number | null;
            isPoweredOn?: boolean | null;
            powerState?: {
              __typename?: 'DevicePowerState';
              value?: EnumDevicePowerStateValue | null;
              timestamp?: number | null;
            } | null;
          }
        | {
            __typename: 'VSDPump';
            role?: string | null;
            _id: string;
            deviceId?: string | null;
            sourceId?: string | null;
            name?: string | null;
            type?: EnumDKeyDeviceType | null;
            typeDisplayName: string;
            isConfigured?: boolean | null;
            timestamp?: number | null;
            isPoweredOn?: boolean | null;
            powerState?: {
              __typename?: 'DevicePowerState';
              value?: EnumDevicePowerStateValue | null;
              timestamp?: number | null;
            } | null;
          }
        | {
            __typename: 'WindManagementSystem';
            _id: string;
            deviceId?: string | null;
            sourceId?: string | null;
            name?: string | null;
            type?: EnumDKeyDeviceType | null;
            typeDisplayName: string;
            isConfigured?: boolean | null;
            timestamp?: number | null;
            isPoweredOn?: boolean | null;
            powerState?: {
              __typename?: 'DevicePowerState';
              value?: EnumDevicePowerStateValue | null;
              timestamp?: number | null;
            } | null;
          }
        | {
            __typename: 'WindowSensor';
            _id: string;
            deviceId?: string | null;
            sourceId?: string | null;
            name?: string | null;
            type?: EnumDKeyDeviceType | null;
            typeDisplayName: string;
            isConfigured?: boolean | null;
            timestamp?: number | null;
            isPoweredOn?: boolean | null;
            powerState?: {
              __typename?: 'DevicePowerState';
              value?: EnumDevicePowerStateValue | null;
              timestamp?: number | null;
            } | null;
          }
        | {
            __typename: 'Z210Pump';
            role?: string | null;
            _id: string;
            deviceId?: string | null;
            sourceId?: string | null;
            name?: string | null;
            type?: EnumDKeyDeviceType | null;
            typeDisplayName: string;
            isConfigured?: boolean | null;
            timestamp?: number | null;
            isPoweredOn?: boolean | null;
            powerState?: {
              __typename?: 'DevicePowerState';
              value?: EnumDevicePowerStateValue | null;
              timestamp?: number | null;
            } | null;
          }
      >;
    } | null>;
    vpps: Array<{
      __typename: 'VirtualPowerPlant';
      _id: string;
      name?: string | null;
      devices: Array<
        | {
            __typename: 'Actuator';
            _id: string;
            deviceId?: string | null;
            sourceId?: string | null;
            name?: string | null;
            type?: EnumDKeyDeviceType | null;
            typeDisplayName: string;
            isConfigured?: boolean | null;
            meta?: { __typename?: 'DeviceMeta'; model?: string | null } | null;
          }
        | {
            __typename: 'BatteryManagementSystem';
            _id: string;
            deviceId?: string | null;
            sourceId?: string | null;
            name?: string | null;
            type?: EnumDKeyDeviceType | null;
            typeDisplayName: string;
            isConfigured?: boolean | null;
            meta?: { __typename?: 'DeviceMeta'; model?: string | null } | null;
          }
        | {
            __typename: 'Boiler';
            _id: string;
            deviceId?: string | null;
            sourceId?: string | null;
            name?: string | null;
            type?: EnumDKeyDeviceType | null;
            typeDisplayName: string;
            isConfigured?: boolean | null;
            meta?: { __typename?: 'DeviceMeta'; model?: string | null } | null;
          }
        | {
            __typename: 'Chiller';
            _id: string;
            deviceId?: string | null;
            sourceId?: string | null;
            name?: string | null;
            type?: EnumDKeyDeviceType | null;
            typeDisplayName: string;
            isConfigured?: boolean | null;
            meta?: { __typename?: 'DeviceMeta'; model?: string | null } | null;
          }
        | {
            __typename: 'ConductorGenericSensor';
            _id: string;
            deviceId?: string | null;
            sourceId?: string | null;
            name?: string | null;
            type?: EnumDKeyDeviceType | null;
            typeDisplayName: string;
            isConfigured?: boolean | null;
            meta?: { __typename?: 'DeviceMeta'; model?: string | null } | null;
          }
        | {
            __typename: 'Controller';
            _id: string;
            deviceId?: string | null;
            sourceId?: string | null;
            name?: string | null;
            type?: EnumDKeyDeviceType | null;
            typeDisplayName: string;
            isConfigured?: boolean | null;
            meta?: { __typename?: 'DeviceMeta'; model?: string | null } | null;
          }
        | {
            __typename: 'Device';
            _id: string;
            deviceId?: string | null;
            sourceId?: string | null;
            name?: string | null;
            type?: EnumDKeyDeviceType | null;
            typeDisplayName: string;
            isConfigured?: boolean | null;
            meta?: { __typename?: 'DeviceMeta'; model?: string | null } | null;
          }
        | {
            __typename: 'DoorSensor';
            _id: string;
            deviceId?: string | null;
            sourceId?: string | null;
            name?: string | null;
            type?: EnumDKeyDeviceType | null;
            typeDisplayName: string;
            isConfigured?: boolean | null;
            meta?: { __typename?: 'DeviceMeta'; model?: string | null } | null;
          }
        | {
            __typename: 'EnergyController';
            _id: string;
            deviceId?: string | null;
            sourceId?: string | null;
            name?: string | null;
            type?: EnumDKeyDeviceType | null;
            typeDisplayName: string;
            isConfigured?: boolean | null;
            meta?: { __typename?: 'DeviceMeta'; model?: string | null } | null;
          }
        | {
            __typename: 'EnergyConverter';
            _id: string;
            deviceId?: string | null;
            sourceId?: string | null;
            name?: string | null;
            type?: EnumDKeyDeviceType | null;
            typeDisplayName: string;
            isConfigured?: boolean | null;
            meta?: { __typename?: 'DeviceMeta'; model?: string | null } | null;
          }
        | {
            __typename: 'EnergyInverter';
            _id: string;
            deviceId?: string | null;
            sourceId?: string | null;
            name?: string | null;
            type?: EnumDKeyDeviceType | null;
            typeDisplayName: string;
            isConfigured?: boolean | null;
            meta?: { __typename?: 'DeviceMeta'; model?: string | null } | null;
          }
        | {
            __typename: 'EnergyMeter';
            _id: string;
            deviceId?: string | null;
            sourceId?: string | null;
            name?: string | null;
            type?: EnumDKeyDeviceType | null;
            typeDisplayName: string;
            isConfigured?: boolean | null;
            meta?: { __typename?: 'DeviceMeta'; model?: string | null } | null;
          }
        | {
            __typename: 'EnergyRectifier';
            _id: string;
            deviceId?: string | null;
            sourceId?: string | null;
            name?: string | null;
            type?: EnumDKeyDeviceType | null;
            typeDisplayName: string;
            isConfigured?: boolean | null;
            meta?: { __typename?: 'DeviceMeta'; model?: string | null } | null;
          }
        | {
            __typename: 'EnergyStorageCoolingSystem';
            _id: string;
            deviceId?: string | null;
            sourceId?: string | null;
            name?: string | null;
            type?: EnumDKeyDeviceType | null;
            typeDisplayName: string;
            isConfigured?: boolean | null;
            meta?: { __typename?: 'DeviceMeta'; model?: string | null } | null;
          }
        | {
            __typename: 'EnergySwitchPanel';
            _id: string;
            deviceId?: string | null;
            sourceId?: string | null;
            name?: string | null;
            type?: EnumDKeyDeviceType | null;
            typeDisplayName: string;
            isConfigured?: boolean | null;
            meta?: { __typename?: 'DeviceMeta'; model?: string | null } | null;
          }
        | {
            __typename: 'EnergySwitchPanelCircuit';
            _id: string;
            deviceId?: string | null;
            sourceId?: string | null;
            name?: string | null;
            type?: EnumDKeyDeviceType | null;
            typeDisplayName: string;
            isConfigured?: boolean | null;
            meta?: { __typename?: 'DeviceMeta'; model?: string | null } | null;
          }
        | {
            __typename: 'FireSuppressionSystem';
            _id: string;
            deviceId?: string | null;
            sourceId?: string | null;
            name?: string | null;
            type?: EnumDKeyDeviceType | null;
            typeDisplayName: string;
            isConfigured?: boolean | null;
            meta?: { __typename?: 'DeviceMeta'; model?: string | null } | null;
          }
        | {
            __typename: 'GPIO';
            _id: string;
            deviceId?: string | null;
            sourceId?: string | null;
            name?: string | null;
            type?: EnumDKeyDeviceType | null;
            typeDisplayName: string;
            isConfigured?: boolean | null;
            meta?: { __typename?: 'DeviceMeta'; model?: string | null } | null;
          }
        | {
            __typename: 'IndoorAirHandler';
            _id: string;
            deviceId?: string | null;
            sourceId?: string | null;
            name?: string | null;
            type?: EnumDKeyDeviceType | null;
            typeDisplayName: string;
            isConfigured?: boolean | null;
            meta?: { __typename?: 'DeviceMeta'; model?: string | null } | null;
          }
        | {
            __typename: 'IndoorSensor';
            _id: string;
            deviceId?: string | null;
            sourceId?: string | null;
            name?: string | null;
            type?: EnumDKeyDeviceType | null;
            typeDisplayName: string;
            isConfigured?: boolean | null;
            meta?: { __typename?: 'DeviceMeta'; model?: string | null } | null;
          }
        | {
            __typename: 'KineticEnergyManagementSystem';
            _id: string;
            deviceId?: string | null;
            sourceId?: string | null;
            name?: string | null;
            type?: EnumDKeyDeviceType | null;
            typeDisplayName: string;
            isConfigured?: boolean | null;
            meta?: { __typename?: 'DeviceMeta'; model?: string | null } | null;
          }
        | {
            __typename: 'LeakDetector';
            _id: string;
            deviceId?: string | null;
            sourceId?: string | null;
            name?: string | null;
            type?: EnumDKeyDeviceType | null;
            typeDisplayName: string;
            isConfigured?: boolean | null;
            meta?: { __typename?: 'DeviceMeta'; model?: string | null } | null;
          }
        | {
            __typename: 'Loop';
            _id: string;
            deviceId?: string | null;
            sourceId?: string | null;
            name?: string | null;
            type?: EnumDKeyDeviceType | null;
            typeDisplayName: string;
            isConfigured?: boolean | null;
            meta?: { __typename?: 'DeviceMeta'; model?: string | null } | null;
          }
        | {
            __typename: 'ModbusAirHandler';
            _id: string;
            deviceId?: string | null;
            sourceId?: string | null;
            name?: string | null;
            type?: EnumDKeyDeviceType | null;
            typeDisplayName: string;
            isConfigured?: boolean | null;
            meta?: { __typename?: 'DeviceMeta'; model?: string | null } | null;
          }
        | {
            __typename: 'OccupancySensor';
            _id: string;
            deviceId?: string | null;
            sourceId?: string | null;
            name?: string | null;
            type?: EnumDKeyDeviceType | null;
            typeDisplayName: string;
            isConfigured?: boolean | null;
            meta?: { __typename?: 'DeviceMeta'; model?: string | null } | null;
          }
        | {
            __typename: 'OpenWeather';
            _id: string;
            deviceId?: string | null;
            sourceId?: string | null;
            name?: string | null;
            type?: EnumDKeyDeviceType | null;
            typeDisplayName: string;
            isConfigured?: boolean | null;
            meta?: { __typename?: 'DeviceMeta'; model?: string | null } | null;
          }
        | {
            __typename: 'OutdoorSensor';
            _id: string;
            deviceId?: string | null;
            sourceId?: string | null;
            name?: string | null;
            type?: EnumDKeyDeviceType | null;
            typeDisplayName: string;
            isConfigured?: boolean | null;
            meta?: { __typename?: 'DeviceMeta'; model?: string | null } | null;
          }
        | {
            __typename: 'PowerMonitor';
            _id: string;
            deviceId?: string | null;
            sourceId?: string | null;
            name?: string | null;
            type?: EnumDKeyDeviceType | null;
            typeDisplayName: string;
            isConfigured?: boolean | null;
            meta?: { __typename?: 'DeviceMeta'; model?: string | null } | null;
          }
        | {
            __typename: 'PressureSensor';
            _id: string;
            deviceId?: string | null;
            sourceId?: string | null;
            name?: string | null;
            type?: EnumDKeyDeviceType | null;
            typeDisplayName: string;
            isConfigured?: boolean | null;
            meta?: { __typename?: 'DeviceMeta'; model?: string | null } | null;
          }
        | {
            __typename: 'RelayDevice';
            _id: string;
            deviceId?: string | null;
            sourceId?: string | null;
            name?: string | null;
            type?: EnumDKeyDeviceType | null;
            typeDisplayName: string;
            isConfigured?: boolean | null;
            meta?: { __typename?: 'DeviceMeta'; model?: string | null } | null;
          }
        | {
            __typename: 'SmartPowerOutlet';
            _id: string;
            deviceId?: string | null;
            sourceId?: string | null;
            name?: string | null;
            type?: EnumDKeyDeviceType | null;
            typeDisplayName: string;
            isConfigured?: boolean | null;
            meta?: { __typename?: 'DeviceMeta'; model?: string | null } | null;
          }
        | {
            __typename: 'SolarManagementSystem';
            _id: string;
            deviceId?: string | null;
            sourceId?: string | null;
            name?: string | null;
            type?: EnumDKeyDeviceType | null;
            typeDisplayName: string;
            isConfigured?: boolean | null;
            meta?: { __typename?: 'DeviceMeta'; model?: string | null } | null;
          }
        | {
            __typename: 'Thermistor';
            _id: string;
            deviceId?: string | null;
            sourceId?: string | null;
            name?: string | null;
            type?: EnumDKeyDeviceType | null;
            typeDisplayName: string;
            isConfigured?: boolean | null;
            meta?: { __typename?: 'DeviceMeta'; model?: string | null } | null;
          }
        | {
            __typename: 'Thermostat';
            _id: string;
            deviceId?: string | null;
            sourceId?: string | null;
            name?: string | null;
            type?: EnumDKeyDeviceType | null;
            typeDisplayName: string;
            isConfigured?: boolean | null;
            meta?: { __typename?: 'DeviceMeta'; model?: string | null } | null;
          }
        | {
            __typename: 'VSDPump';
            _id: string;
            deviceId?: string | null;
            sourceId?: string | null;
            name?: string | null;
            type?: EnumDKeyDeviceType | null;
            typeDisplayName: string;
            isConfigured?: boolean | null;
            meta?: { __typename?: 'DeviceMeta'; model?: string | null } | null;
          }
        | {
            __typename: 'WindManagementSystem';
            _id: string;
            deviceId?: string | null;
            sourceId?: string | null;
            name?: string | null;
            type?: EnumDKeyDeviceType | null;
            typeDisplayName: string;
            isConfigured?: boolean | null;
            meta?: { __typename?: 'DeviceMeta'; model?: string | null } | null;
          }
        | {
            __typename: 'WindowSensor';
            _id: string;
            deviceId?: string | null;
            sourceId?: string | null;
            name?: string | null;
            type?: EnumDKeyDeviceType | null;
            typeDisplayName: string;
            isConfigured?: boolean | null;
            meta?: { __typename?: 'DeviceMeta'; model?: string | null } | null;
          }
        | {
            __typename: 'Z210Pump';
            _id: string;
            deviceId?: string | null;
            sourceId?: string | null;
            name?: string | null;
            type?: EnumDKeyDeviceType | null;
            typeDisplayName: string;
            isConfigured?: boolean | null;
            meta?: { __typename?: 'DeviceMeta'; model?: string | null } | null;
          }
      >;
    } | null>;
    controlGroups: Array<{
      __typename?: 'ControlGroup';
      _id: string;
      name: string;
      type: string;
      automationEnabled?: boolean | null;
      masterDeviceId?: string | null;
      attributes: any;
      deviceDetails?: any | null;
      masterDevice?: {
        __typename?: 'Device';
        _id: string;
        deviceId?: string | null;
        type?: EnumDKeyDeviceType | null;
      } | null;
      devices: Array<{
        __typename?: 'Device';
        _id: string;
        deviceId?: string | null;
        type?: EnumDKeyDeviceType | null;
      }>;
    } | null>;
    setpointLimitProfile?: {
      __typename?: 'SetpointProfile';
      heat?: {
        __typename?: 'SetpointProfileHeat';
        max?: number | null;
        min?: number | null;
      } | null;
      cool?: {
        __typename?: 'SetpointProfileCool';
        max?: number | null;
        min?: number | null;
      } | null;
    } | null;
    property?: {
      __typename?: 'Property';
      _id: string;
      setpointProfileId?: string | null;
      setpointLimitProfile?: {
        __typename?: 'SetpointProfile';
        heat?: {
          __typename?: 'SetpointProfileHeat';
          min?: number | null;
          max?: number | null;
        } | null;
        cool?: {
          __typename?: 'SetpointProfileCool';
          min?: number | null;
          max?: number | null;
        } | null;
      } | null;
    } | null;
  } | null;
};

export type UnitDetailQueryVariables = Exact<{
  id: Scalars['String'];
}>;

export type UnitDetailQuery = {
  __typename?: 'Query';
  unitById?: {
    __typename?: 'Unit';
    _id: string;
    name: string;
    propertyId: string;
    type: string;
    separatePowerThermostatIds: Array<string>;
    thermostatScheduleTemplateId?: string | null;
    setpointProfileId?: string | null;
    building?: { __typename?: 'Building'; name: string } | null;
    devicesSummary?: {
      __typename?: 'UnitDevicesSummary';
      count?: number | null;
      majorAlerts?: number | null;
      minorAlerts?: number | null;
      proxy?: {
        __typename: 'UnitDevicesSummaryProxy';
        type?: string | null;
        coolSetpoint?: number | null;
        heatSetpoint?: number | null;
        humidity?: number | null;
        isOffline?: boolean | null;
        operatingMode?: string | null;
        operatingState?: string | null;
        setpointCoolMin?: number | null;
        setpointHeatMax?: number | null;
        setpointProfileName?: string | null;
        setpointProfileType?: string | null;
        temperature?: number | null;
      } | null;
    } | null;
    zones: Array<{
      __typename: 'Zone';
      _id: string;
      sourceId?: string | null;
      name: string;
      controller?: string | null;
      thermostatId?: string | null;
      pairedSensorId?: string | null;
      role?: string | null;
      devices: Array<
        | {
            __typename: 'Actuator';
            _id: string;
            deviceId?: string | null;
            sourceId?: string | null;
            name?: string | null;
            type?: EnumDKeyDeviceType | null;
            typeDisplayName: string;
            isConfigured?: boolean | null;
            timestamp?: number | null;
            isPoweredOn?: boolean | null;
            alertTypes?: {
              __typename?: 'DeviceAlertTypes';
              deviceOffline?: boolean | null;
              sourceOffline?: boolean | null;
            } | null;
            zone?: {
              __typename?: 'Zone';
              _id: string;
              name: string;
              sourceId?: string | null;
            } | null;
            powerState?: {
              __typename?: 'DevicePowerState';
              value?: EnumDevicePowerStateValue | null;
              timestamp?: number | null;
            } | null;
            installation?: {
              __typename?: 'DeviceInstallation';
              status: number;
              count?: number | null;
              message?: string | null;
              paired?: boolean | null;
              pairedTo?: string | null;
              previousStatus?: string | null;
              rawDeviceId?: string | null;
              replacingDeviceId?: string | null;
            } | null;
            meta?: {
              __typename?: 'DeviceMeta';
              modelNumber?: string | null;
              version?: string | null;
            } | null;
          }
        | {
            __typename: 'BatteryManagementSystem';
            _id: string;
            deviceId?: string | null;
            sourceId?: string | null;
            name?: string | null;
            type?: EnumDKeyDeviceType | null;
            typeDisplayName: string;
            isConfigured?: boolean | null;
            timestamp?: number | null;
            isPoweredOn?: boolean | null;
            alertTypes?: {
              __typename?: 'DeviceAlertTypes';
              deviceOffline?: boolean | null;
              sourceOffline?: boolean | null;
            } | null;
            zone?: {
              __typename?: 'Zone';
              _id: string;
              name: string;
              sourceId?: string | null;
            } | null;
            powerState?: {
              __typename?: 'DevicePowerState';
              value?: EnumDevicePowerStateValue | null;
              timestamp?: number | null;
            } | null;
            installation?: {
              __typename?: 'DeviceInstallation';
              status: number;
              count?: number | null;
              message?: string | null;
              paired?: boolean | null;
              pairedTo?: string | null;
              previousStatus?: string | null;
              rawDeviceId?: string | null;
              replacingDeviceId?: string | null;
            } | null;
            meta?: {
              __typename?: 'DeviceMeta';
              modelNumber?: string | null;
              version?: string | null;
            } | null;
          }
        | {
            __typename: 'Boiler';
            _id: string;
            deviceId?: string | null;
            sourceId?: string | null;
            name?: string | null;
            type?: EnumDKeyDeviceType | null;
            typeDisplayName: string;
            isConfigured?: boolean | null;
            timestamp?: number | null;
            isPoweredOn?: boolean | null;
            alertTypes?: {
              __typename?: 'DeviceAlertTypes';
              deviceOffline?: boolean | null;
              sourceOffline?: boolean | null;
            } | null;
            zone?: {
              __typename?: 'Zone';
              _id: string;
              name: string;
              sourceId?: string | null;
            } | null;
            powerState?: {
              __typename?: 'DevicePowerState';
              value?: EnumDevicePowerStateValue | null;
              timestamp?: number | null;
            } | null;
            installation?: {
              __typename?: 'DeviceInstallation';
              status: number;
              count?: number | null;
              message?: string | null;
              paired?: boolean | null;
              pairedTo?: string | null;
              previousStatus?: string | null;
              rawDeviceId?: string | null;
              replacingDeviceId?: string | null;
            } | null;
            meta?: {
              __typename?: 'DeviceMeta';
              modelNumber?: string | null;
              version?: string | null;
            } | null;
          }
        | {
            __typename: 'Chiller';
            _id: string;
            deviceId?: string | null;
            sourceId?: string | null;
            name?: string | null;
            type?: EnumDKeyDeviceType | null;
            typeDisplayName: string;
            isConfigured?: boolean | null;
            timestamp?: number | null;
            isPoweredOn?: boolean | null;
            alertTypes?: {
              __typename?: 'DeviceAlertTypes';
              deviceOffline?: boolean | null;
              sourceOffline?: boolean | null;
            } | null;
            zone?: {
              __typename?: 'Zone';
              _id: string;
              name: string;
              sourceId?: string | null;
            } | null;
            powerState?: {
              __typename?: 'DevicePowerState';
              value?: EnumDevicePowerStateValue | null;
              timestamp?: number | null;
            } | null;
            installation?: {
              __typename?: 'DeviceInstallation';
              status: number;
              count?: number | null;
              message?: string | null;
              paired?: boolean | null;
              pairedTo?: string | null;
              previousStatus?: string | null;
              rawDeviceId?: string | null;
              replacingDeviceId?: string | null;
            } | null;
            meta?: {
              __typename?: 'DeviceMeta';
              modelNumber?: string | null;
              version?: string | null;
            } | null;
          }
        | {
            __typename: 'ConductorGenericSensor';
            _id: string;
            deviceId?: string | null;
            sourceId?: string | null;
            name?: string | null;
            type?: EnumDKeyDeviceType | null;
            typeDisplayName: string;
            isConfigured?: boolean | null;
            timestamp?: number | null;
            isPoweredOn?: boolean | null;
            alertTypes?: {
              __typename?: 'DeviceAlertTypes';
              deviceOffline?: boolean | null;
              sourceOffline?: boolean | null;
            } | null;
            zone?: {
              __typename?: 'Zone';
              _id: string;
              name: string;
              sourceId?: string | null;
            } | null;
            powerState?: {
              __typename?: 'DevicePowerState';
              value?: EnumDevicePowerStateValue | null;
              timestamp?: number | null;
            } | null;
            installation?: {
              __typename?: 'DeviceInstallation';
              status: number;
              count?: number | null;
              message?: string | null;
              paired?: boolean | null;
              pairedTo?: string | null;
              previousStatus?: string | null;
              rawDeviceId?: string | null;
              replacingDeviceId?: string | null;
            } | null;
            meta?: {
              __typename?: 'DeviceMeta';
              modelNumber?: string | null;
              version?: string | null;
            } | null;
          }
        | {
            __typename: 'Controller';
            _id: string;
            deviceId?: string | null;
            sourceId?: string | null;
            name?: string | null;
            type?: EnumDKeyDeviceType | null;
            typeDisplayName: string;
            isConfigured?: boolean | null;
            timestamp?: number | null;
            isPoweredOn?: boolean | null;
            alertTypes?: {
              __typename?: 'DeviceAlertTypes';
              deviceOffline?: boolean | null;
              sourceOffline?: boolean | null;
            } | null;
            zone?: {
              __typename?: 'Zone';
              _id: string;
              name: string;
              sourceId?: string | null;
            } | null;
            powerState?: {
              __typename?: 'DevicePowerState';
              value?: EnumDevicePowerStateValue | null;
              timestamp?: number | null;
            } | null;
            installation?: {
              __typename?: 'DeviceInstallation';
              status: number;
              count?: number | null;
              message?: string | null;
              paired?: boolean | null;
              pairedTo?: string | null;
              previousStatus?: string | null;
              rawDeviceId?: string | null;
              replacingDeviceId?: string | null;
            } | null;
            meta?: {
              __typename?: 'DeviceMeta';
              modelNumber?: string | null;
              version?: string | null;
            } | null;
          }
        | {
            __typename: 'Device';
            _id: string;
            deviceId?: string | null;
            sourceId?: string | null;
            name?: string | null;
            type?: EnumDKeyDeviceType | null;
            typeDisplayName: string;
            isConfigured?: boolean | null;
            timestamp?: number | null;
            isPoweredOn?: boolean | null;
            alertTypes?: {
              __typename?: 'DeviceAlertTypes';
              deviceOffline?: boolean | null;
              sourceOffline?: boolean | null;
            } | null;
            zone?: {
              __typename?: 'Zone';
              _id: string;
              name: string;
              sourceId?: string | null;
            } | null;
            powerState?: {
              __typename?: 'DevicePowerState';
              value?: EnumDevicePowerStateValue | null;
              timestamp?: number | null;
            } | null;
            installation?: {
              __typename?: 'DeviceInstallation';
              status: number;
              count?: number | null;
              message?: string | null;
              paired?: boolean | null;
              pairedTo?: string | null;
              previousStatus?: string | null;
              rawDeviceId?: string | null;
              replacingDeviceId?: string | null;
            } | null;
            meta?: {
              __typename?: 'DeviceMeta';
              modelNumber?: string | null;
              version?: string | null;
            } | null;
          }
        | {
            __typename: 'DoorSensor';
            _id: string;
            deviceId?: string | null;
            sourceId?: string | null;
            name?: string | null;
            type?: EnumDKeyDeviceType | null;
            typeDisplayName: string;
            isConfigured?: boolean | null;
            timestamp?: number | null;
            isPoweredOn?: boolean | null;
            alertTypes?: {
              __typename?: 'DeviceAlertTypes';
              deviceOffline?: boolean | null;
              sourceOffline?: boolean | null;
            } | null;
            zone?: {
              __typename?: 'Zone';
              _id: string;
              name: string;
              sourceId?: string | null;
            } | null;
            powerState?: {
              __typename?: 'DevicePowerState';
              value?: EnumDevicePowerStateValue | null;
              timestamp?: number | null;
            } | null;
            installation?: {
              __typename?: 'DeviceInstallation';
              status: number;
              count?: number | null;
              message?: string | null;
              paired?: boolean | null;
              pairedTo?: string | null;
              previousStatus?: string | null;
              rawDeviceId?: string | null;
              replacingDeviceId?: string | null;
            } | null;
            meta?: {
              __typename?: 'DeviceMeta';
              modelNumber?: string | null;
              version?: string | null;
            } | null;
          }
        | {
            __typename: 'EnergyController';
            _id: string;
            deviceId?: string | null;
            sourceId?: string | null;
            name?: string | null;
            type?: EnumDKeyDeviceType | null;
            typeDisplayName: string;
            isConfigured?: boolean | null;
            timestamp?: number | null;
            isPoweredOn?: boolean | null;
            alertTypes?: {
              __typename?: 'DeviceAlertTypes';
              deviceOffline?: boolean | null;
              sourceOffline?: boolean | null;
            } | null;
            zone?: {
              __typename?: 'Zone';
              _id: string;
              name: string;
              sourceId?: string | null;
            } | null;
            powerState?: {
              __typename?: 'DevicePowerState';
              value?: EnumDevicePowerStateValue | null;
              timestamp?: number | null;
            } | null;
            installation?: {
              __typename?: 'DeviceInstallation';
              status: number;
              count?: number | null;
              message?: string | null;
              paired?: boolean | null;
              pairedTo?: string | null;
              previousStatus?: string | null;
              rawDeviceId?: string | null;
              replacingDeviceId?: string | null;
            } | null;
            meta?: {
              __typename?: 'DeviceMeta';
              modelNumber?: string | null;
              version?: string | null;
            } | null;
          }
        | {
            __typename: 'EnergyConverter';
            _id: string;
            deviceId?: string | null;
            sourceId?: string | null;
            name?: string | null;
            type?: EnumDKeyDeviceType | null;
            typeDisplayName: string;
            isConfigured?: boolean | null;
            timestamp?: number | null;
            isPoweredOn?: boolean | null;
            alertTypes?: {
              __typename?: 'DeviceAlertTypes';
              deviceOffline?: boolean | null;
              sourceOffline?: boolean | null;
            } | null;
            zone?: {
              __typename?: 'Zone';
              _id: string;
              name: string;
              sourceId?: string | null;
            } | null;
            powerState?: {
              __typename?: 'DevicePowerState';
              value?: EnumDevicePowerStateValue | null;
              timestamp?: number | null;
            } | null;
            installation?: {
              __typename?: 'DeviceInstallation';
              status: number;
              count?: number | null;
              message?: string | null;
              paired?: boolean | null;
              pairedTo?: string | null;
              previousStatus?: string | null;
              rawDeviceId?: string | null;
              replacingDeviceId?: string | null;
            } | null;
            meta?: {
              __typename?: 'DeviceMeta';
              modelNumber?: string | null;
              version?: string | null;
            } | null;
          }
        | {
            __typename: 'EnergyInverter';
            _id: string;
            deviceId?: string | null;
            sourceId?: string | null;
            name?: string | null;
            type?: EnumDKeyDeviceType | null;
            typeDisplayName: string;
            isConfigured?: boolean | null;
            timestamp?: number | null;
            isPoweredOn?: boolean | null;
            alertTypes?: {
              __typename?: 'DeviceAlertTypes';
              deviceOffline?: boolean | null;
              sourceOffline?: boolean | null;
            } | null;
            zone?: {
              __typename?: 'Zone';
              _id: string;
              name: string;
              sourceId?: string | null;
            } | null;
            powerState?: {
              __typename?: 'DevicePowerState';
              value?: EnumDevicePowerStateValue | null;
              timestamp?: number | null;
            } | null;
            installation?: {
              __typename?: 'DeviceInstallation';
              status: number;
              count?: number | null;
              message?: string | null;
              paired?: boolean | null;
              pairedTo?: string | null;
              previousStatus?: string | null;
              rawDeviceId?: string | null;
              replacingDeviceId?: string | null;
            } | null;
            meta?: {
              __typename?: 'DeviceMeta';
              modelNumber?: string | null;
              version?: string | null;
            } | null;
          }
        | {
            __typename: 'EnergyMeter';
            _id: string;
            deviceId?: string | null;
            sourceId?: string | null;
            name?: string | null;
            type?: EnumDKeyDeviceType | null;
            typeDisplayName: string;
            isConfigured?: boolean | null;
            timestamp?: number | null;
            isPoweredOn?: boolean | null;
            alertTypes?: {
              __typename?: 'DeviceAlertTypes';
              deviceOffline?: boolean | null;
              sourceOffline?: boolean | null;
            } | null;
            zone?: {
              __typename?: 'Zone';
              _id: string;
              name: string;
              sourceId?: string | null;
            } | null;
            powerState?: {
              __typename?: 'DevicePowerState';
              value?: EnumDevicePowerStateValue | null;
              timestamp?: number | null;
            } | null;
            installation?: {
              __typename?: 'DeviceInstallation';
              status: number;
              count?: number | null;
              message?: string | null;
              paired?: boolean | null;
              pairedTo?: string | null;
              previousStatus?: string | null;
              rawDeviceId?: string | null;
              replacingDeviceId?: string | null;
            } | null;
            meta?: {
              __typename?: 'DeviceMeta';
              modelNumber?: string | null;
              version?: string | null;
            } | null;
          }
        | {
            __typename: 'EnergyRectifier';
            _id: string;
            deviceId?: string | null;
            sourceId?: string | null;
            name?: string | null;
            type?: EnumDKeyDeviceType | null;
            typeDisplayName: string;
            isConfigured?: boolean | null;
            timestamp?: number | null;
            isPoweredOn?: boolean | null;
            alertTypes?: {
              __typename?: 'DeviceAlertTypes';
              deviceOffline?: boolean | null;
              sourceOffline?: boolean | null;
            } | null;
            zone?: {
              __typename?: 'Zone';
              _id: string;
              name: string;
              sourceId?: string | null;
            } | null;
            powerState?: {
              __typename?: 'DevicePowerState';
              value?: EnumDevicePowerStateValue | null;
              timestamp?: number | null;
            } | null;
            installation?: {
              __typename?: 'DeviceInstallation';
              status: number;
              count?: number | null;
              message?: string | null;
              paired?: boolean | null;
              pairedTo?: string | null;
              previousStatus?: string | null;
              rawDeviceId?: string | null;
              replacingDeviceId?: string | null;
            } | null;
            meta?: {
              __typename?: 'DeviceMeta';
              modelNumber?: string | null;
              version?: string | null;
            } | null;
          }
        | {
            __typename: 'EnergyStorageCoolingSystem';
            _id: string;
            deviceId?: string | null;
            sourceId?: string | null;
            name?: string | null;
            type?: EnumDKeyDeviceType | null;
            typeDisplayName: string;
            isConfigured?: boolean | null;
            timestamp?: number | null;
            isPoweredOn?: boolean | null;
            alertTypes?: {
              __typename?: 'DeviceAlertTypes';
              deviceOffline?: boolean | null;
              sourceOffline?: boolean | null;
            } | null;
            zone?: {
              __typename?: 'Zone';
              _id: string;
              name: string;
              sourceId?: string | null;
            } | null;
            powerState?: {
              __typename?: 'DevicePowerState';
              value?: EnumDevicePowerStateValue | null;
              timestamp?: number | null;
            } | null;
            installation?: {
              __typename?: 'DeviceInstallation';
              status: number;
              count?: number | null;
              message?: string | null;
              paired?: boolean | null;
              pairedTo?: string | null;
              previousStatus?: string | null;
              rawDeviceId?: string | null;
              replacingDeviceId?: string | null;
            } | null;
            meta?: {
              __typename?: 'DeviceMeta';
              modelNumber?: string | null;
              version?: string | null;
            } | null;
          }
        | {
            __typename: 'EnergySwitchPanel';
            _id: string;
            deviceId?: string | null;
            sourceId?: string | null;
            name?: string | null;
            type?: EnumDKeyDeviceType | null;
            typeDisplayName: string;
            isConfigured?: boolean | null;
            timestamp?: number | null;
            isPoweredOn?: boolean | null;
            alertTypes?: {
              __typename?: 'DeviceAlertTypes';
              deviceOffline?: boolean | null;
              sourceOffline?: boolean | null;
            } | null;
            zone?: {
              __typename?: 'Zone';
              _id: string;
              name: string;
              sourceId?: string | null;
            } | null;
            powerState?: {
              __typename?: 'DevicePowerState';
              value?: EnumDevicePowerStateValue | null;
              timestamp?: number | null;
            } | null;
            installation?: {
              __typename?: 'DeviceInstallation';
              status: number;
              count?: number | null;
              message?: string | null;
              paired?: boolean | null;
              pairedTo?: string | null;
              previousStatus?: string | null;
              rawDeviceId?: string | null;
              replacingDeviceId?: string | null;
            } | null;
            meta?: {
              __typename?: 'DeviceMeta';
              modelNumber?: string | null;
              version?: string | null;
            } | null;
          }
        | {
            __typename: 'EnergySwitchPanelCircuit';
            _id: string;
            deviceId?: string | null;
            sourceId?: string | null;
            name?: string | null;
            type?: EnumDKeyDeviceType | null;
            typeDisplayName: string;
            isConfigured?: boolean | null;
            timestamp?: number | null;
            isPoweredOn?: boolean | null;
            alertTypes?: {
              __typename?: 'DeviceAlertTypes';
              deviceOffline?: boolean | null;
              sourceOffline?: boolean | null;
            } | null;
            zone?: {
              __typename?: 'Zone';
              _id: string;
              name: string;
              sourceId?: string | null;
            } | null;
            powerState?: {
              __typename?: 'DevicePowerState';
              value?: EnumDevicePowerStateValue | null;
              timestamp?: number | null;
            } | null;
            installation?: {
              __typename?: 'DeviceInstallation';
              status: number;
              count?: number | null;
              message?: string | null;
              paired?: boolean | null;
              pairedTo?: string | null;
              previousStatus?: string | null;
              rawDeviceId?: string | null;
              replacingDeviceId?: string | null;
            } | null;
            meta?: {
              __typename?: 'DeviceMeta';
              modelNumber?: string | null;
              version?: string | null;
            } | null;
          }
        | {
            __typename: 'FireSuppressionSystem';
            _id: string;
            deviceId?: string | null;
            sourceId?: string | null;
            name?: string | null;
            type?: EnumDKeyDeviceType | null;
            typeDisplayName: string;
            isConfigured?: boolean | null;
            timestamp?: number | null;
            isPoweredOn?: boolean | null;
            alertTypes?: {
              __typename?: 'DeviceAlertTypes';
              deviceOffline?: boolean | null;
              sourceOffline?: boolean | null;
            } | null;
            zone?: {
              __typename?: 'Zone';
              _id: string;
              name: string;
              sourceId?: string | null;
            } | null;
            powerState?: {
              __typename?: 'DevicePowerState';
              value?: EnumDevicePowerStateValue | null;
              timestamp?: number | null;
            } | null;
            installation?: {
              __typename?: 'DeviceInstallation';
              status: number;
              count?: number | null;
              message?: string | null;
              paired?: boolean | null;
              pairedTo?: string | null;
              previousStatus?: string | null;
              rawDeviceId?: string | null;
              replacingDeviceId?: string | null;
            } | null;
            meta?: {
              __typename?: 'DeviceMeta';
              modelNumber?: string | null;
              version?: string | null;
            } | null;
          }
        | {
            __typename: 'GPIO';
            _id: string;
            deviceId?: string | null;
            sourceId?: string | null;
            name?: string | null;
            type?: EnumDKeyDeviceType | null;
            typeDisplayName: string;
            isConfigured?: boolean | null;
            timestamp?: number | null;
            isPoweredOn?: boolean | null;
            alertTypes?: {
              __typename?: 'DeviceAlertTypes';
              deviceOffline?: boolean | null;
              sourceOffline?: boolean | null;
            } | null;
            zone?: {
              __typename?: 'Zone';
              _id: string;
              name: string;
              sourceId?: string | null;
            } | null;
            powerState?: {
              __typename?: 'DevicePowerState';
              value?: EnumDevicePowerStateValue | null;
              timestamp?: number | null;
            } | null;
            installation?: {
              __typename?: 'DeviceInstallation';
              status: number;
              count?: number | null;
              message?: string | null;
              paired?: boolean | null;
              pairedTo?: string | null;
              previousStatus?: string | null;
              rawDeviceId?: string | null;
              replacingDeviceId?: string | null;
            } | null;
            meta?: {
              __typename?: 'DeviceMeta';
              modelNumber?: string | null;
              version?: string | null;
            } | null;
          }
        | {
            __typename: 'IndoorAirHandler';
            _id: string;
            deviceId?: string | null;
            sourceId?: string | null;
            name?: string | null;
            type?: EnumDKeyDeviceType | null;
            typeDisplayName: string;
            isConfigured?: boolean | null;
            timestamp?: number | null;
            isPoweredOn?: boolean | null;
            alertTypes?: {
              __typename?: 'DeviceAlertTypes';
              deviceOffline?: boolean | null;
              sourceOffline?: boolean | null;
            } | null;
            zone?: {
              __typename?: 'Zone';
              _id: string;
              name: string;
              sourceId?: string | null;
            } | null;
            powerState?: {
              __typename?: 'DevicePowerState';
              value?: EnumDevicePowerStateValue | null;
              timestamp?: number | null;
            } | null;
            installation?: {
              __typename?: 'DeviceInstallation';
              status: number;
              count?: number | null;
              message?: string | null;
              paired?: boolean | null;
              pairedTo?: string | null;
              previousStatus?: string | null;
              rawDeviceId?: string | null;
              replacingDeviceId?: string | null;
            } | null;
            meta?: {
              __typename?: 'DeviceMeta';
              modelNumber?: string | null;
              version?: string | null;
            } | null;
          }
        | {
            __typename: 'IndoorSensor';
            _id: string;
            deviceId?: string | null;
            sourceId?: string | null;
            name?: string | null;
            type?: EnumDKeyDeviceType | null;
            typeDisplayName: string;
            isConfigured?: boolean | null;
            timestamp?: number | null;
            isPoweredOn?: boolean | null;
            alertTypes?: {
              __typename?: 'DeviceAlertTypes';
              deviceOffline?: boolean | null;
              sourceOffline?: boolean | null;
            } | null;
            zone?: {
              __typename?: 'Zone';
              _id: string;
              name: string;
              sourceId?: string | null;
            } | null;
            powerState?: {
              __typename?: 'DevicePowerState';
              value?: EnumDevicePowerStateValue | null;
              timestamp?: number | null;
            } | null;
            installation?: {
              __typename?: 'DeviceInstallation';
              status: number;
              count?: number | null;
              message?: string | null;
              paired?: boolean | null;
              pairedTo?: string | null;
              previousStatus?: string | null;
              rawDeviceId?: string | null;
              replacingDeviceId?: string | null;
            } | null;
            meta?: {
              __typename?: 'DeviceMeta';
              modelNumber?: string | null;
              version?: string | null;
            } | null;
          }
        | {
            __typename: 'KineticEnergyManagementSystem';
            _id: string;
            deviceId?: string | null;
            sourceId?: string | null;
            name?: string | null;
            type?: EnumDKeyDeviceType | null;
            typeDisplayName: string;
            isConfigured?: boolean | null;
            timestamp?: number | null;
            isPoweredOn?: boolean | null;
            alertTypes?: {
              __typename?: 'DeviceAlertTypes';
              deviceOffline?: boolean | null;
              sourceOffline?: boolean | null;
            } | null;
            zone?: {
              __typename?: 'Zone';
              _id: string;
              name: string;
              sourceId?: string | null;
            } | null;
            powerState?: {
              __typename?: 'DevicePowerState';
              value?: EnumDevicePowerStateValue | null;
              timestamp?: number | null;
            } | null;
            installation?: {
              __typename?: 'DeviceInstallation';
              status: number;
              count?: number | null;
              message?: string | null;
              paired?: boolean | null;
              pairedTo?: string | null;
              previousStatus?: string | null;
              rawDeviceId?: string | null;
              replacingDeviceId?: string | null;
            } | null;
            meta?: {
              __typename?: 'DeviceMeta';
              modelNumber?: string | null;
              version?: string | null;
            } | null;
          }
        | {
            __typename: 'LeakDetector';
            _id: string;
            deviceId?: string | null;
            sourceId?: string | null;
            name?: string | null;
            type?: EnumDKeyDeviceType | null;
            typeDisplayName: string;
            isConfigured?: boolean | null;
            timestamp?: number | null;
            isPoweredOn?: boolean | null;
            alertTypes?: {
              __typename?: 'DeviceAlertTypes';
              deviceOffline?: boolean | null;
              sourceOffline?: boolean | null;
            } | null;
            zone?: {
              __typename?: 'Zone';
              _id: string;
              name: string;
              sourceId?: string | null;
            } | null;
            powerState?: {
              __typename?: 'DevicePowerState';
              value?: EnumDevicePowerStateValue | null;
              timestamp?: number | null;
            } | null;
            installation?: {
              __typename?: 'DeviceInstallation';
              status: number;
              count?: number | null;
              message?: string | null;
              paired?: boolean | null;
              pairedTo?: string | null;
              previousStatus?: string | null;
              rawDeviceId?: string | null;
              replacingDeviceId?: string | null;
            } | null;
            meta?: {
              __typename?: 'DeviceMeta';
              modelNumber?: string | null;
              version?: string | null;
            } | null;
          }
        | {
            __typename: 'Loop';
            _id: string;
            deviceId?: string | null;
            sourceId?: string | null;
            name?: string | null;
            type?: EnumDKeyDeviceType | null;
            typeDisplayName: string;
            isConfigured?: boolean | null;
            timestamp?: number | null;
            isPoweredOn?: boolean | null;
            alertTypes?: {
              __typename?: 'DeviceAlertTypes';
              deviceOffline?: boolean | null;
              sourceOffline?: boolean | null;
            } | null;
            zone?: {
              __typename?: 'Zone';
              _id: string;
              name: string;
              sourceId?: string | null;
            } | null;
            powerState?: {
              __typename?: 'DevicePowerState';
              value?: EnumDevicePowerStateValue | null;
              timestamp?: number | null;
            } | null;
            installation?: {
              __typename?: 'DeviceInstallation';
              status: number;
              count?: number | null;
              message?: string | null;
              paired?: boolean | null;
              pairedTo?: string | null;
              previousStatus?: string | null;
              rawDeviceId?: string | null;
              replacingDeviceId?: string | null;
            } | null;
            meta?: {
              __typename?: 'DeviceMeta';
              modelNumber?: string | null;
              version?: string | null;
            } | null;
          }
        | {
            __typename: 'ModbusAirHandler';
            _id: string;
            deviceId?: string | null;
            sourceId?: string | null;
            name?: string | null;
            type?: EnumDKeyDeviceType | null;
            typeDisplayName: string;
            isConfigured?: boolean | null;
            timestamp?: number | null;
            isPoweredOn?: boolean | null;
            alertTypes?: {
              __typename?: 'DeviceAlertTypes';
              deviceOffline?: boolean | null;
              sourceOffline?: boolean | null;
            } | null;
            zone?: {
              __typename?: 'Zone';
              _id: string;
              name: string;
              sourceId?: string | null;
            } | null;
            powerState?: {
              __typename?: 'DevicePowerState';
              value?: EnumDevicePowerStateValue | null;
              timestamp?: number | null;
            } | null;
            installation?: {
              __typename?: 'DeviceInstallation';
              status: number;
              count?: number | null;
              message?: string | null;
              paired?: boolean | null;
              pairedTo?: string | null;
              previousStatus?: string | null;
              rawDeviceId?: string | null;
              replacingDeviceId?: string | null;
            } | null;
            meta?: {
              __typename?: 'DeviceMeta';
              modelNumber?: string | null;
              version?: string | null;
            } | null;
          }
        | {
            __typename: 'OccupancySensor';
            _id: string;
            deviceId?: string | null;
            sourceId?: string | null;
            name?: string | null;
            type?: EnumDKeyDeviceType | null;
            typeDisplayName: string;
            isConfigured?: boolean | null;
            timestamp?: number | null;
            isPoweredOn?: boolean | null;
            alertTypes?: {
              __typename?: 'DeviceAlertTypes';
              deviceOffline?: boolean | null;
              sourceOffline?: boolean | null;
            } | null;
            zone?: {
              __typename?: 'Zone';
              _id: string;
              name: string;
              sourceId?: string | null;
            } | null;
            powerState?: {
              __typename?: 'DevicePowerState';
              value?: EnumDevicePowerStateValue | null;
              timestamp?: number | null;
            } | null;
            installation?: {
              __typename?: 'DeviceInstallation';
              status: number;
              count?: number | null;
              message?: string | null;
              paired?: boolean | null;
              pairedTo?: string | null;
              previousStatus?: string | null;
              rawDeviceId?: string | null;
              replacingDeviceId?: string | null;
            } | null;
            meta?: {
              __typename?: 'DeviceMeta';
              modelNumber?: string | null;
              version?: string | null;
            } | null;
          }
        | {
            __typename: 'OpenWeather';
            _id: string;
            deviceId?: string | null;
            sourceId?: string | null;
            name?: string | null;
            type?: EnumDKeyDeviceType | null;
            typeDisplayName: string;
            isConfigured?: boolean | null;
            timestamp?: number | null;
            isPoweredOn?: boolean | null;
            alertTypes?: {
              __typename?: 'DeviceAlertTypes';
              deviceOffline?: boolean | null;
              sourceOffline?: boolean | null;
            } | null;
            zone?: {
              __typename?: 'Zone';
              _id: string;
              name: string;
              sourceId?: string | null;
            } | null;
            powerState?: {
              __typename?: 'DevicePowerState';
              value?: EnumDevicePowerStateValue | null;
              timestamp?: number | null;
            } | null;
            installation?: {
              __typename?: 'DeviceInstallation';
              status: number;
              count?: number | null;
              message?: string | null;
              paired?: boolean | null;
              pairedTo?: string | null;
              previousStatus?: string | null;
              rawDeviceId?: string | null;
              replacingDeviceId?: string | null;
            } | null;
            meta?: {
              __typename?: 'DeviceMeta';
              modelNumber?: string | null;
              version?: string | null;
            } | null;
          }
        | {
            __typename: 'OutdoorSensor';
            _id: string;
            deviceId?: string | null;
            sourceId?: string | null;
            name?: string | null;
            type?: EnumDKeyDeviceType | null;
            typeDisplayName: string;
            isConfigured?: boolean | null;
            timestamp?: number | null;
            isPoweredOn?: boolean | null;
            alertTypes?: {
              __typename?: 'DeviceAlertTypes';
              deviceOffline?: boolean | null;
              sourceOffline?: boolean | null;
            } | null;
            zone?: {
              __typename?: 'Zone';
              _id: string;
              name: string;
              sourceId?: string | null;
            } | null;
            powerState?: {
              __typename?: 'DevicePowerState';
              value?: EnumDevicePowerStateValue | null;
              timestamp?: number | null;
            } | null;
            installation?: {
              __typename?: 'DeviceInstallation';
              status: number;
              count?: number | null;
              message?: string | null;
              paired?: boolean | null;
              pairedTo?: string | null;
              previousStatus?: string | null;
              rawDeviceId?: string | null;
              replacingDeviceId?: string | null;
            } | null;
            meta?: {
              __typename?: 'DeviceMeta';
              modelNumber?: string | null;
              version?: string | null;
            } | null;
          }
        | {
            __typename: 'PowerMonitor';
            _id: string;
            deviceId?: string | null;
            sourceId?: string | null;
            name?: string | null;
            type?: EnumDKeyDeviceType | null;
            typeDisplayName: string;
            isConfigured?: boolean | null;
            timestamp?: number | null;
            isPoweredOn?: boolean | null;
            alertTypes?: {
              __typename?: 'DeviceAlertTypes';
              deviceOffline?: boolean | null;
              sourceOffline?: boolean | null;
            } | null;
            zone?: {
              __typename?: 'Zone';
              _id: string;
              name: string;
              sourceId?: string | null;
            } | null;
            powerState?: {
              __typename?: 'DevicePowerState';
              value?: EnumDevicePowerStateValue | null;
              timestamp?: number | null;
            } | null;
            installation?: {
              __typename?: 'DeviceInstallation';
              status: number;
              count?: number | null;
              message?: string | null;
              paired?: boolean | null;
              pairedTo?: string | null;
              previousStatus?: string | null;
              rawDeviceId?: string | null;
              replacingDeviceId?: string | null;
            } | null;
            meta?: {
              __typename?: 'DeviceMeta';
              modelNumber?: string | null;
              version?: string | null;
            } | null;
          }
        | {
            __typename: 'PressureSensor';
            _id: string;
            deviceId?: string | null;
            sourceId?: string | null;
            name?: string | null;
            type?: EnumDKeyDeviceType | null;
            typeDisplayName: string;
            isConfigured?: boolean | null;
            timestamp?: number | null;
            isPoweredOn?: boolean | null;
            alertTypes?: {
              __typename?: 'DeviceAlertTypes';
              deviceOffline?: boolean | null;
              sourceOffline?: boolean | null;
            } | null;
            zone?: {
              __typename?: 'Zone';
              _id: string;
              name: string;
              sourceId?: string | null;
            } | null;
            powerState?: {
              __typename?: 'DevicePowerState';
              value?: EnumDevicePowerStateValue | null;
              timestamp?: number | null;
            } | null;
            installation?: {
              __typename?: 'DeviceInstallation';
              status: number;
              count?: number | null;
              message?: string | null;
              paired?: boolean | null;
              pairedTo?: string | null;
              previousStatus?: string | null;
              rawDeviceId?: string | null;
              replacingDeviceId?: string | null;
            } | null;
            meta?: {
              __typename?: 'DeviceMeta';
              modelNumber?: string | null;
              version?: string | null;
            } | null;
          }
        | {
            __typename: 'RelayDevice';
            _id: string;
            deviceId?: string | null;
            sourceId?: string | null;
            name?: string | null;
            type?: EnumDKeyDeviceType | null;
            typeDisplayName: string;
            isConfigured?: boolean | null;
            timestamp?: number | null;
            isPoweredOn?: boolean | null;
            alertTypes?: {
              __typename?: 'DeviceAlertTypes';
              deviceOffline?: boolean | null;
              sourceOffline?: boolean | null;
            } | null;
            zone?: {
              __typename?: 'Zone';
              _id: string;
              name: string;
              sourceId?: string | null;
            } | null;
            powerState?: {
              __typename?: 'DevicePowerState';
              value?: EnumDevicePowerStateValue | null;
              timestamp?: number | null;
            } | null;
            installation?: {
              __typename?: 'DeviceInstallation';
              status: number;
              count?: number | null;
              message?: string | null;
              paired?: boolean | null;
              pairedTo?: string | null;
              previousStatus?: string | null;
              rawDeviceId?: string | null;
              replacingDeviceId?: string | null;
            } | null;
            meta?: {
              __typename?: 'DeviceMeta';
              modelNumber?: string | null;
              version?: string | null;
            } | null;
          }
        | {
            __typename: 'SmartPowerOutlet';
            _id: string;
            deviceId?: string | null;
            sourceId?: string | null;
            name?: string | null;
            type?: EnumDKeyDeviceType | null;
            typeDisplayName: string;
            isConfigured?: boolean | null;
            timestamp?: number | null;
            isPoweredOn?: boolean | null;
            alertTypes?: {
              __typename?: 'DeviceAlertTypes';
              deviceOffline?: boolean | null;
              sourceOffline?: boolean | null;
            } | null;
            zone?: {
              __typename?: 'Zone';
              _id: string;
              name: string;
              sourceId?: string | null;
            } | null;
            powerState?: {
              __typename?: 'DevicePowerState';
              value?: EnumDevicePowerStateValue | null;
              timestamp?: number | null;
            } | null;
            installation?: {
              __typename?: 'DeviceInstallation';
              status: number;
              count?: number | null;
              message?: string | null;
              paired?: boolean | null;
              pairedTo?: string | null;
              previousStatus?: string | null;
              rawDeviceId?: string | null;
              replacingDeviceId?: string | null;
            } | null;
            meta?: {
              __typename?: 'DeviceMeta';
              modelNumber?: string | null;
              version?: string | null;
            } | null;
          }
        | {
            __typename: 'SolarManagementSystem';
            _id: string;
            deviceId?: string | null;
            sourceId?: string | null;
            name?: string | null;
            type?: EnumDKeyDeviceType | null;
            typeDisplayName: string;
            isConfigured?: boolean | null;
            timestamp?: number | null;
            isPoweredOn?: boolean | null;
            alertTypes?: {
              __typename?: 'DeviceAlertTypes';
              deviceOffline?: boolean | null;
              sourceOffline?: boolean | null;
            } | null;
            zone?: {
              __typename?: 'Zone';
              _id: string;
              name: string;
              sourceId?: string | null;
            } | null;
            powerState?: {
              __typename?: 'DevicePowerState';
              value?: EnumDevicePowerStateValue | null;
              timestamp?: number | null;
            } | null;
            installation?: {
              __typename?: 'DeviceInstallation';
              status: number;
              count?: number | null;
              message?: string | null;
              paired?: boolean | null;
              pairedTo?: string | null;
              previousStatus?: string | null;
              rawDeviceId?: string | null;
              replacingDeviceId?: string | null;
            } | null;
            meta?: {
              __typename?: 'DeviceMeta';
              modelNumber?: string | null;
              version?: string | null;
            } | null;
          }
        | {
            __typename: 'Thermistor';
            _id: string;
            deviceId?: string | null;
            sourceId?: string | null;
            name?: string | null;
            type?: EnumDKeyDeviceType | null;
            typeDisplayName: string;
            isConfigured?: boolean | null;
            timestamp?: number | null;
            isPoweredOn?: boolean | null;
            alertTypes?: {
              __typename?: 'DeviceAlertTypes';
              deviceOffline?: boolean | null;
              sourceOffline?: boolean | null;
            } | null;
            zone?: {
              __typename?: 'Zone';
              _id: string;
              name: string;
              sourceId?: string | null;
            } | null;
            powerState?: {
              __typename?: 'DevicePowerState';
              value?: EnumDevicePowerStateValue | null;
              timestamp?: number | null;
            } | null;
            installation?: {
              __typename?: 'DeviceInstallation';
              status: number;
              count?: number | null;
              message?: string | null;
              paired?: boolean | null;
              pairedTo?: string | null;
              previousStatus?: string | null;
              rawDeviceId?: string | null;
              replacingDeviceId?: string | null;
            } | null;
            meta?: {
              __typename?: 'DeviceMeta';
              modelNumber?: string | null;
              version?: string | null;
            } | null;
          }
        | {
            __typename: 'Thermostat';
            isPairingActive: boolean;
            _id: string;
            deviceId?: string | null;
            sourceId?: string | null;
            name?: string | null;
            type?: EnumDKeyDeviceType | null;
            typeDisplayName: string;
            isConfigured?: boolean | null;
            timestamp?: number | null;
            isPoweredOn?: boolean | null;
            alertTypes?: {
              __typename?: 'DeviceAlertTypes';
              deviceOffline?: boolean | null;
              sourceOffline?: boolean | null;
            } | null;
            zone?: {
              __typename?: 'Zone';
              _id: string;
              name: string;
              sourceId?: string | null;
            } | null;
            powerState?: {
              __typename?: 'DevicePowerState';
              value?: EnumDevicePowerStateValue | null;
              timestamp?: number | null;
            } | null;
            installation?: {
              __typename?: 'DeviceInstallation';
              status: number;
              count?: number | null;
              message?: string | null;
              paired?: boolean | null;
              pairedTo?: string | null;
              previousStatus?: string | null;
              rawDeviceId?: string | null;
              replacingDeviceId?: string | null;
            } | null;
            meta?: {
              __typename?: 'DeviceMeta';
              modelNumber?: string | null;
              version?: string | null;
            } | null;
          }
        | {
            __typename: 'VSDPump';
            _id: string;
            deviceId?: string | null;
            sourceId?: string | null;
            name?: string | null;
            type?: EnumDKeyDeviceType | null;
            typeDisplayName: string;
            isConfigured?: boolean | null;
            timestamp?: number | null;
            isPoweredOn?: boolean | null;
            alertTypes?: {
              __typename?: 'DeviceAlertTypes';
              deviceOffline?: boolean | null;
              sourceOffline?: boolean | null;
            } | null;
            zone?: {
              __typename?: 'Zone';
              _id: string;
              name: string;
              sourceId?: string | null;
            } | null;
            powerState?: {
              __typename?: 'DevicePowerState';
              value?: EnumDevicePowerStateValue | null;
              timestamp?: number | null;
            } | null;
            installation?: {
              __typename?: 'DeviceInstallation';
              status: number;
              count?: number | null;
              message?: string | null;
              paired?: boolean | null;
              pairedTo?: string | null;
              previousStatus?: string | null;
              rawDeviceId?: string | null;
              replacingDeviceId?: string | null;
            } | null;
            meta?: {
              __typename?: 'DeviceMeta';
              modelNumber?: string | null;
              version?: string | null;
            } | null;
          }
        | {
            __typename: 'WindManagementSystem';
            _id: string;
            deviceId?: string | null;
            sourceId?: string | null;
            name?: string | null;
            type?: EnumDKeyDeviceType | null;
            typeDisplayName: string;
            isConfigured?: boolean | null;
            timestamp?: number | null;
            isPoweredOn?: boolean | null;
            alertTypes?: {
              __typename?: 'DeviceAlertTypes';
              deviceOffline?: boolean | null;
              sourceOffline?: boolean | null;
            } | null;
            zone?: {
              __typename?: 'Zone';
              _id: string;
              name: string;
              sourceId?: string | null;
            } | null;
            powerState?: {
              __typename?: 'DevicePowerState';
              value?: EnumDevicePowerStateValue | null;
              timestamp?: number | null;
            } | null;
            installation?: {
              __typename?: 'DeviceInstallation';
              status: number;
              count?: number | null;
              message?: string | null;
              paired?: boolean | null;
              pairedTo?: string | null;
              previousStatus?: string | null;
              rawDeviceId?: string | null;
              replacingDeviceId?: string | null;
            } | null;
            meta?: {
              __typename?: 'DeviceMeta';
              modelNumber?: string | null;
              version?: string | null;
            } | null;
          }
        | {
            __typename: 'WindowSensor';
            _id: string;
            deviceId?: string | null;
            sourceId?: string | null;
            name?: string | null;
            type?: EnumDKeyDeviceType | null;
            typeDisplayName: string;
            isConfigured?: boolean | null;
            timestamp?: number | null;
            isPoweredOn?: boolean | null;
            alertTypes?: {
              __typename?: 'DeviceAlertTypes';
              deviceOffline?: boolean | null;
              sourceOffline?: boolean | null;
            } | null;
            zone?: {
              __typename?: 'Zone';
              _id: string;
              name: string;
              sourceId?: string | null;
            } | null;
            powerState?: {
              __typename?: 'DevicePowerState';
              value?: EnumDevicePowerStateValue | null;
              timestamp?: number | null;
            } | null;
            installation?: {
              __typename?: 'DeviceInstallation';
              status: number;
              count?: number | null;
              message?: string | null;
              paired?: boolean | null;
              pairedTo?: string | null;
              previousStatus?: string | null;
              rawDeviceId?: string | null;
              replacingDeviceId?: string | null;
            } | null;
            meta?: {
              __typename?: 'DeviceMeta';
              modelNumber?: string | null;
              version?: string | null;
            } | null;
          }
        | {
            __typename: 'Z210Pump';
            _id: string;
            deviceId?: string | null;
            sourceId?: string | null;
            name?: string | null;
            type?: EnumDKeyDeviceType | null;
            typeDisplayName: string;
            isConfigured?: boolean | null;
            timestamp?: number | null;
            isPoweredOn?: boolean | null;
            alertTypes?: {
              __typename?: 'DeviceAlertTypes';
              deviceOffline?: boolean | null;
              sourceOffline?: boolean | null;
            } | null;
            zone?: {
              __typename?: 'Zone';
              _id: string;
              name: string;
              sourceId?: string | null;
            } | null;
            powerState?: {
              __typename?: 'DevicePowerState';
              value?: EnumDevicePowerStateValue | null;
              timestamp?: number | null;
            } | null;
            installation?: {
              __typename?: 'DeviceInstallation';
              status: number;
              count?: number | null;
              message?: string | null;
              paired?: boolean | null;
              pairedTo?: string | null;
              previousStatus?: string | null;
              rawDeviceId?: string | null;
              replacingDeviceId?: string | null;
            } | null;
            meta?: {
              __typename?: 'DeviceMeta';
              modelNumber?: string | null;
              version?: string | null;
            } | null;
          }
      >;
    } | null>;
    panels: Array<{
      __typename: 'Panel';
      _id: string;
      name?: string | null;
      displayName?: string | null;
      type: EnumPanelType;
      role?: string | null;
      sourceId: string;
      devices: Array<
        | {
            __typename: 'Actuator';
            _id: string;
            deviceId?: string | null;
            sourceId?: string | null;
            name?: string | null;
            type?: EnumDKeyDeviceType | null;
            typeDisplayName: string;
            isConfigured?: boolean | null;
            timestamp?: number | null;
            isPoweredOn?: boolean | null;
            alertTypes?: {
              __typename?: 'DeviceAlertTypes';
              deviceOffline?: boolean | null;
              sourceOffline?: boolean | null;
            } | null;
            powerState?: {
              __typename?: 'DevicePowerState';
              value?: EnumDevicePowerStateValue | null;
              timestamp?: number | null;
            } | null;
            panel?: {
              __typename?: 'Panel';
              _id: string;
              name?: string | null;
              sourceId: string;
            } | null;
            meta?: { __typename?: 'DeviceMeta'; model?: string | null } | null;
          }
        | {
            __typename: 'BatteryManagementSystem';
            _id: string;
            deviceId?: string | null;
            sourceId?: string | null;
            name?: string | null;
            type?: EnumDKeyDeviceType | null;
            typeDisplayName: string;
            isConfigured?: boolean | null;
            timestamp?: number | null;
            isPoweredOn?: boolean | null;
            alertTypes?: {
              __typename?: 'DeviceAlertTypes';
              deviceOffline?: boolean | null;
              sourceOffline?: boolean | null;
            } | null;
            powerState?: {
              __typename?: 'DevicePowerState';
              value?: EnumDevicePowerStateValue | null;
              timestamp?: number | null;
            } | null;
            panel?: {
              __typename?: 'Panel';
              _id: string;
              name?: string | null;
              sourceId: string;
            } | null;
            meta?: { __typename?: 'DeviceMeta'; model?: string | null } | null;
          }
        | {
            __typename: 'Boiler';
            _id: string;
            deviceId?: string | null;
            sourceId?: string | null;
            name?: string | null;
            type?: EnumDKeyDeviceType | null;
            typeDisplayName: string;
            isConfigured?: boolean | null;
            timestamp?: number | null;
            isPoweredOn?: boolean | null;
            alertTypes?: {
              __typename?: 'DeviceAlertTypes';
              deviceOffline?: boolean | null;
              sourceOffline?: boolean | null;
            } | null;
            powerState?: {
              __typename?: 'DevicePowerState';
              value?: EnumDevicePowerStateValue | null;
              timestamp?: number | null;
            } | null;
            panel?: {
              __typename?: 'Panel';
              _id: string;
              name?: string | null;
              sourceId: string;
            } | null;
            meta?: { __typename?: 'DeviceMeta'; model?: string | null } | null;
          }
        | {
            __typename: 'Chiller';
            _id: string;
            deviceId?: string | null;
            sourceId?: string | null;
            name?: string | null;
            type?: EnumDKeyDeviceType | null;
            typeDisplayName: string;
            isConfigured?: boolean | null;
            timestamp?: number | null;
            isPoweredOn?: boolean | null;
            alertTypes?: {
              __typename?: 'DeviceAlertTypes';
              deviceOffline?: boolean | null;
              sourceOffline?: boolean | null;
            } | null;
            powerState?: {
              __typename?: 'DevicePowerState';
              value?: EnumDevicePowerStateValue | null;
              timestamp?: number | null;
            } | null;
            panel?: {
              __typename?: 'Panel';
              _id: string;
              name?: string | null;
              sourceId: string;
            } | null;
            meta?: { __typename?: 'DeviceMeta'; model?: string | null } | null;
          }
        | {
            __typename: 'ConductorGenericSensor';
            _id: string;
            deviceId?: string | null;
            sourceId?: string | null;
            name?: string | null;
            type?: EnumDKeyDeviceType | null;
            typeDisplayName: string;
            isConfigured?: boolean | null;
            timestamp?: number | null;
            isPoweredOn?: boolean | null;
            alertTypes?: {
              __typename?: 'DeviceAlertTypes';
              deviceOffline?: boolean | null;
              sourceOffline?: boolean | null;
            } | null;
            powerState?: {
              __typename?: 'DevicePowerState';
              value?: EnumDevicePowerStateValue | null;
              timestamp?: number | null;
            } | null;
            panel?: {
              __typename?: 'Panel';
              _id: string;
              name?: string | null;
              sourceId: string;
            } | null;
            meta?: { __typename?: 'DeviceMeta'; model?: string | null } | null;
          }
        | {
            __typename: 'Controller';
            _id: string;
            deviceId?: string | null;
            sourceId?: string | null;
            name?: string | null;
            type?: EnumDKeyDeviceType | null;
            typeDisplayName: string;
            isConfigured?: boolean | null;
            timestamp?: number | null;
            isPoweredOn?: boolean | null;
            alertTypes?: {
              __typename?: 'DeviceAlertTypes';
              deviceOffline?: boolean | null;
              sourceOffline?: boolean | null;
            } | null;
            powerState?: {
              __typename?: 'DevicePowerState';
              value?: EnumDevicePowerStateValue | null;
              timestamp?: number | null;
            } | null;
            panel?: {
              __typename?: 'Panel';
              _id: string;
              name?: string | null;
              sourceId: string;
            } | null;
            meta?: { __typename?: 'DeviceMeta'; model?: string | null } | null;
          }
        | {
            __typename: 'Device';
            _id: string;
            deviceId?: string | null;
            sourceId?: string | null;
            name?: string | null;
            type?: EnumDKeyDeviceType | null;
            typeDisplayName: string;
            isConfigured?: boolean | null;
            timestamp?: number | null;
            isPoweredOn?: boolean | null;
            alertTypes?: {
              __typename?: 'DeviceAlertTypes';
              deviceOffline?: boolean | null;
              sourceOffline?: boolean | null;
            } | null;
            powerState?: {
              __typename?: 'DevicePowerState';
              value?: EnumDevicePowerStateValue | null;
              timestamp?: number | null;
            } | null;
            panel?: {
              __typename?: 'Panel';
              _id: string;
              name?: string | null;
              sourceId: string;
            } | null;
            meta?: { __typename?: 'DeviceMeta'; model?: string | null } | null;
          }
        | {
            __typename: 'DoorSensor';
            _id: string;
            deviceId?: string | null;
            sourceId?: string | null;
            name?: string | null;
            type?: EnumDKeyDeviceType | null;
            typeDisplayName: string;
            isConfigured?: boolean | null;
            timestamp?: number | null;
            isPoweredOn?: boolean | null;
            alertTypes?: {
              __typename?: 'DeviceAlertTypes';
              deviceOffline?: boolean | null;
              sourceOffline?: boolean | null;
            } | null;
            powerState?: {
              __typename?: 'DevicePowerState';
              value?: EnumDevicePowerStateValue | null;
              timestamp?: number | null;
            } | null;
            panel?: {
              __typename?: 'Panel';
              _id: string;
              name?: string | null;
              sourceId: string;
            } | null;
            meta?: { __typename?: 'DeviceMeta'; model?: string | null } | null;
          }
        | {
            __typename: 'EnergyController';
            _id: string;
            deviceId?: string | null;
            sourceId?: string | null;
            name?: string | null;
            type?: EnumDKeyDeviceType | null;
            typeDisplayName: string;
            isConfigured?: boolean | null;
            timestamp?: number | null;
            isPoweredOn?: boolean | null;
            alertTypes?: {
              __typename?: 'DeviceAlertTypes';
              deviceOffline?: boolean | null;
              sourceOffline?: boolean | null;
            } | null;
            powerState?: {
              __typename?: 'DevicePowerState';
              value?: EnumDevicePowerStateValue | null;
              timestamp?: number | null;
            } | null;
            panel?: {
              __typename?: 'Panel';
              _id: string;
              name?: string | null;
              sourceId: string;
            } | null;
            meta?: { __typename?: 'DeviceMeta'; model?: string | null } | null;
          }
        | {
            __typename: 'EnergyConverter';
            _id: string;
            deviceId?: string | null;
            sourceId?: string | null;
            name?: string | null;
            type?: EnumDKeyDeviceType | null;
            typeDisplayName: string;
            isConfigured?: boolean | null;
            timestamp?: number | null;
            isPoweredOn?: boolean | null;
            alertTypes?: {
              __typename?: 'DeviceAlertTypes';
              deviceOffline?: boolean | null;
              sourceOffline?: boolean | null;
            } | null;
            powerState?: {
              __typename?: 'DevicePowerState';
              value?: EnumDevicePowerStateValue | null;
              timestamp?: number | null;
            } | null;
            panel?: {
              __typename?: 'Panel';
              _id: string;
              name?: string | null;
              sourceId: string;
            } | null;
            meta?: { __typename?: 'DeviceMeta'; model?: string | null } | null;
          }
        | {
            __typename: 'EnergyInverter';
            _id: string;
            deviceId?: string | null;
            sourceId?: string | null;
            name?: string | null;
            type?: EnumDKeyDeviceType | null;
            typeDisplayName: string;
            isConfigured?: boolean | null;
            timestamp?: number | null;
            isPoweredOn?: boolean | null;
            alertTypes?: {
              __typename?: 'DeviceAlertTypes';
              deviceOffline?: boolean | null;
              sourceOffline?: boolean | null;
            } | null;
            powerState?: {
              __typename?: 'DevicePowerState';
              value?: EnumDevicePowerStateValue | null;
              timestamp?: number | null;
            } | null;
            panel?: {
              __typename?: 'Panel';
              _id: string;
              name?: string | null;
              sourceId: string;
            } | null;
            meta?: { __typename?: 'DeviceMeta'; model?: string | null } | null;
          }
        | {
            __typename: 'EnergyMeter';
            _id: string;
            deviceId?: string | null;
            sourceId?: string | null;
            name?: string | null;
            type?: EnumDKeyDeviceType | null;
            typeDisplayName: string;
            isConfigured?: boolean | null;
            timestamp?: number | null;
            isPoweredOn?: boolean | null;
            alertTypes?: {
              __typename?: 'DeviceAlertTypes';
              deviceOffline?: boolean | null;
              sourceOffline?: boolean | null;
            } | null;
            powerState?: {
              __typename?: 'DevicePowerState';
              value?: EnumDevicePowerStateValue | null;
              timestamp?: number | null;
            } | null;
            panel?: {
              __typename?: 'Panel';
              _id: string;
              name?: string | null;
              sourceId: string;
            } | null;
            meta?: { __typename?: 'DeviceMeta'; model?: string | null } | null;
          }
        | {
            __typename: 'EnergyRectifier';
            _id: string;
            deviceId?: string | null;
            sourceId?: string | null;
            name?: string | null;
            type?: EnumDKeyDeviceType | null;
            typeDisplayName: string;
            isConfigured?: boolean | null;
            timestamp?: number | null;
            isPoweredOn?: boolean | null;
            alertTypes?: {
              __typename?: 'DeviceAlertTypes';
              deviceOffline?: boolean | null;
              sourceOffline?: boolean | null;
            } | null;
            powerState?: {
              __typename?: 'DevicePowerState';
              value?: EnumDevicePowerStateValue | null;
              timestamp?: number | null;
            } | null;
            panel?: {
              __typename?: 'Panel';
              _id: string;
              name?: string | null;
              sourceId: string;
            } | null;
            meta?: { __typename?: 'DeviceMeta'; model?: string | null } | null;
          }
        | {
            __typename: 'EnergyStorageCoolingSystem';
            _id: string;
            deviceId?: string | null;
            sourceId?: string | null;
            name?: string | null;
            type?: EnumDKeyDeviceType | null;
            typeDisplayName: string;
            isConfigured?: boolean | null;
            timestamp?: number | null;
            isPoweredOn?: boolean | null;
            alertTypes?: {
              __typename?: 'DeviceAlertTypes';
              deviceOffline?: boolean | null;
              sourceOffline?: boolean | null;
            } | null;
            powerState?: {
              __typename?: 'DevicePowerState';
              value?: EnumDevicePowerStateValue | null;
              timestamp?: number | null;
            } | null;
            panel?: {
              __typename?: 'Panel';
              _id: string;
              name?: string | null;
              sourceId: string;
            } | null;
            meta?: { __typename?: 'DeviceMeta'; model?: string | null } | null;
          }
        | {
            __typename: 'EnergySwitchPanel';
            _id: string;
            deviceId?: string | null;
            sourceId?: string | null;
            name?: string | null;
            type?: EnumDKeyDeviceType | null;
            typeDisplayName: string;
            isConfigured?: boolean | null;
            timestamp?: number | null;
            isPoweredOn?: boolean | null;
            alertTypes?: {
              __typename?: 'DeviceAlertTypes';
              deviceOffline?: boolean | null;
              sourceOffline?: boolean | null;
            } | null;
            powerState?: {
              __typename?: 'DevicePowerState';
              value?: EnumDevicePowerStateValue | null;
              timestamp?: number | null;
            } | null;
            panel?: {
              __typename?: 'Panel';
              _id: string;
              name?: string | null;
              sourceId: string;
            } | null;
            meta?: { __typename?: 'DeviceMeta'; model?: string | null } | null;
          }
        | {
            __typename: 'EnergySwitchPanelCircuit';
            _id: string;
            deviceId?: string | null;
            sourceId?: string | null;
            name?: string | null;
            type?: EnumDKeyDeviceType | null;
            typeDisplayName: string;
            isConfigured?: boolean | null;
            timestamp?: number | null;
            isPoweredOn?: boolean | null;
            alertTypes?: {
              __typename?: 'DeviceAlertTypes';
              deviceOffline?: boolean | null;
              sourceOffline?: boolean | null;
            } | null;
            powerState?: {
              __typename?: 'DevicePowerState';
              value?: EnumDevicePowerStateValue | null;
              timestamp?: number | null;
            } | null;
            panel?: {
              __typename?: 'Panel';
              _id: string;
              name?: string | null;
              sourceId: string;
            } | null;
            meta?: { __typename?: 'DeviceMeta'; model?: string | null } | null;
          }
        | {
            __typename: 'FireSuppressionSystem';
            _id: string;
            deviceId?: string | null;
            sourceId?: string | null;
            name?: string | null;
            type?: EnumDKeyDeviceType | null;
            typeDisplayName: string;
            isConfigured?: boolean | null;
            timestamp?: number | null;
            isPoweredOn?: boolean | null;
            alertTypes?: {
              __typename?: 'DeviceAlertTypes';
              deviceOffline?: boolean | null;
              sourceOffline?: boolean | null;
            } | null;
            powerState?: {
              __typename?: 'DevicePowerState';
              value?: EnumDevicePowerStateValue | null;
              timestamp?: number | null;
            } | null;
            panel?: {
              __typename?: 'Panel';
              _id: string;
              name?: string | null;
              sourceId: string;
            } | null;
            meta?: { __typename?: 'DeviceMeta'; model?: string | null } | null;
          }
        | {
            __typename: 'GPIO';
            _id: string;
            deviceId?: string | null;
            sourceId?: string | null;
            name?: string | null;
            type?: EnumDKeyDeviceType | null;
            typeDisplayName: string;
            isConfigured?: boolean | null;
            timestamp?: number | null;
            isPoweredOn?: boolean | null;
            alertTypes?: {
              __typename?: 'DeviceAlertTypes';
              deviceOffline?: boolean | null;
              sourceOffline?: boolean | null;
            } | null;
            powerState?: {
              __typename?: 'DevicePowerState';
              value?: EnumDevicePowerStateValue | null;
              timestamp?: number | null;
            } | null;
            panel?: {
              __typename?: 'Panel';
              _id: string;
              name?: string | null;
              sourceId: string;
            } | null;
            meta?: { __typename?: 'DeviceMeta'; model?: string | null } | null;
          }
        | {
            __typename: 'IndoorAirHandler';
            _id: string;
            deviceId?: string | null;
            sourceId?: string | null;
            name?: string | null;
            type?: EnumDKeyDeviceType | null;
            typeDisplayName: string;
            isConfigured?: boolean | null;
            timestamp?: number | null;
            isPoweredOn?: boolean | null;
            alertTypes?: {
              __typename?: 'DeviceAlertTypes';
              deviceOffline?: boolean | null;
              sourceOffline?: boolean | null;
            } | null;
            powerState?: {
              __typename?: 'DevicePowerState';
              value?: EnumDevicePowerStateValue | null;
              timestamp?: number | null;
            } | null;
            panel?: {
              __typename?: 'Panel';
              _id: string;
              name?: string | null;
              sourceId: string;
            } | null;
            meta?: { __typename?: 'DeviceMeta'; model?: string | null } | null;
          }
        | {
            __typename: 'IndoorSensor';
            _id: string;
            deviceId?: string | null;
            sourceId?: string | null;
            name?: string | null;
            type?: EnumDKeyDeviceType | null;
            typeDisplayName: string;
            isConfigured?: boolean | null;
            timestamp?: number | null;
            isPoweredOn?: boolean | null;
            alertTypes?: {
              __typename?: 'DeviceAlertTypes';
              deviceOffline?: boolean | null;
              sourceOffline?: boolean | null;
            } | null;
            powerState?: {
              __typename?: 'DevicePowerState';
              value?: EnumDevicePowerStateValue | null;
              timestamp?: number | null;
            } | null;
            panel?: {
              __typename?: 'Panel';
              _id: string;
              name?: string | null;
              sourceId: string;
            } | null;
            meta?: { __typename?: 'DeviceMeta'; model?: string | null } | null;
          }
        | {
            __typename: 'KineticEnergyManagementSystem';
            _id: string;
            deviceId?: string | null;
            sourceId?: string | null;
            name?: string | null;
            type?: EnumDKeyDeviceType | null;
            typeDisplayName: string;
            isConfigured?: boolean | null;
            timestamp?: number | null;
            isPoweredOn?: boolean | null;
            alertTypes?: {
              __typename?: 'DeviceAlertTypes';
              deviceOffline?: boolean | null;
              sourceOffline?: boolean | null;
            } | null;
            powerState?: {
              __typename?: 'DevicePowerState';
              value?: EnumDevicePowerStateValue | null;
              timestamp?: number | null;
            } | null;
            panel?: {
              __typename?: 'Panel';
              _id: string;
              name?: string | null;
              sourceId: string;
            } | null;
            meta?: { __typename?: 'DeviceMeta'; model?: string | null } | null;
          }
        | {
            __typename: 'LeakDetector';
            _id: string;
            deviceId?: string | null;
            sourceId?: string | null;
            name?: string | null;
            type?: EnumDKeyDeviceType | null;
            typeDisplayName: string;
            isConfigured?: boolean | null;
            timestamp?: number | null;
            isPoweredOn?: boolean | null;
            alertTypes?: {
              __typename?: 'DeviceAlertTypes';
              deviceOffline?: boolean | null;
              sourceOffline?: boolean | null;
            } | null;
            powerState?: {
              __typename?: 'DevicePowerState';
              value?: EnumDevicePowerStateValue | null;
              timestamp?: number | null;
            } | null;
            panel?: {
              __typename?: 'Panel';
              _id: string;
              name?: string | null;
              sourceId: string;
            } | null;
            meta?: { __typename?: 'DeviceMeta'; model?: string | null } | null;
          }
        | {
            __typename: 'Loop';
            _id: string;
            deviceId?: string | null;
            sourceId?: string | null;
            name?: string | null;
            type?: EnumDKeyDeviceType | null;
            typeDisplayName: string;
            isConfigured?: boolean | null;
            timestamp?: number | null;
            isPoweredOn?: boolean | null;
            alertTypes?: {
              __typename?: 'DeviceAlertTypes';
              deviceOffline?: boolean | null;
              sourceOffline?: boolean | null;
            } | null;
            powerState?: {
              __typename?: 'DevicePowerState';
              value?: EnumDevicePowerStateValue | null;
              timestamp?: number | null;
            } | null;
            panel?: {
              __typename?: 'Panel';
              _id: string;
              name?: string | null;
              sourceId: string;
            } | null;
            meta?: { __typename?: 'DeviceMeta'; model?: string | null } | null;
          }
        | {
            __typename: 'ModbusAirHandler';
            _id: string;
            deviceId?: string | null;
            sourceId?: string | null;
            name?: string | null;
            type?: EnumDKeyDeviceType | null;
            typeDisplayName: string;
            isConfigured?: boolean | null;
            timestamp?: number | null;
            isPoweredOn?: boolean | null;
            alertTypes?: {
              __typename?: 'DeviceAlertTypes';
              deviceOffline?: boolean | null;
              sourceOffline?: boolean | null;
            } | null;
            powerState?: {
              __typename?: 'DevicePowerState';
              value?: EnumDevicePowerStateValue | null;
              timestamp?: number | null;
            } | null;
            panel?: {
              __typename?: 'Panel';
              _id: string;
              name?: string | null;
              sourceId: string;
            } | null;
            meta?: { __typename?: 'DeviceMeta'; model?: string | null } | null;
          }
        | {
            __typename: 'OccupancySensor';
            _id: string;
            deviceId?: string | null;
            sourceId?: string | null;
            name?: string | null;
            type?: EnumDKeyDeviceType | null;
            typeDisplayName: string;
            isConfigured?: boolean | null;
            timestamp?: number | null;
            isPoweredOn?: boolean | null;
            alertTypes?: {
              __typename?: 'DeviceAlertTypes';
              deviceOffline?: boolean | null;
              sourceOffline?: boolean | null;
            } | null;
            powerState?: {
              __typename?: 'DevicePowerState';
              value?: EnumDevicePowerStateValue | null;
              timestamp?: number | null;
            } | null;
            panel?: {
              __typename?: 'Panel';
              _id: string;
              name?: string | null;
              sourceId: string;
            } | null;
            meta?: { __typename?: 'DeviceMeta'; model?: string | null } | null;
          }
        | {
            __typename: 'OpenWeather';
            _id: string;
            deviceId?: string | null;
            sourceId?: string | null;
            name?: string | null;
            type?: EnumDKeyDeviceType | null;
            typeDisplayName: string;
            isConfigured?: boolean | null;
            timestamp?: number | null;
            isPoweredOn?: boolean | null;
            alertTypes?: {
              __typename?: 'DeviceAlertTypes';
              deviceOffline?: boolean | null;
              sourceOffline?: boolean | null;
            } | null;
            powerState?: {
              __typename?: 'DevicePowerState';
              value?: EnumDevicePowerStateValue | null;
              timestamp?: number | null;
            } | null;
            panel?: {
              __typename?: 'Panel';
              _id: string;
              name?: string | null;
              sourceId: string;
            } | null;
            meta?: { __typename?: 'DeviceMeta'; model?: string | null } | null;
          }
        | {
            __typename: 'OutdoorSensor';
            _id: string;
            deviceId?: string | null;
            sourceId?: string | null;
            name?: string | null;
            type?: EnumDKeyDeviceType | null;
            typeDisplayName: string;
            isConfigured?: boolean | null;
            timestamp?: number | null;
            isPoweredOn?: boolean | null;
            alertTypes?: {
              __typename?: 'DeviceAlertTypes';
              deviceOffline?: boolean | null;
              sourceOffline?: boolean | null;
            } | null;
            powerState?: {
              __typename?: 'DevicePowerState';
              value?: EnumDevicePowerStateValue | null;
              timestamp?: number | null;
            } | null;
            panel?: {
              __typename?: 'Panel';
              _id: string;
              name?: string | null;
              sourceId: string;
            } | null;
            meta?: { __typename?: 'DeviceMeta'; model?: string | null } | null;
          }
        | {
            __typename: 'PowerMonitor';
            _id: string;
            deviceId?: string | null;
            sourceId?: string | null;
            name?: string | null;
            type?: EnumDKeyDeviceType | null;
            typeDisplayName: string;
            isConfigured?: boolean | null;
            timestamp?: number | null;
            isPoweredOn?: boolean | null;
            alertTypes?: {
              __typename?: 'DeviceAlertTypes';
              deviceOffline?: boolean | null;
              sourceOffline?: boolean | null;
            } | null;
            powerState?: {
              __typename?: 'DevicePowerState';
              value?: EnumDevicePowerStateValue | null;
              timestamp?: number | null;
            } | null;
            panel?: {
              __typename?: 'Panel';
              _id: string;
              name?: string | null;
              sourceId: string;
            } | null;
            meta?: { __typename?: 'DeviceMeta'; model?: string | null } | null;
          }
        | {
            __typename: 'PressureSensor';
            role?: string | null;
            _id: string;
            deviceId?: string | null;
            sourceId?: string | null;
            name?: string | null;
            type?: EnumDKeyDeviceType | null;
            typeDisplayName: string;
            isConfigured?: boolean | null;
            timestamp?: number | null;
            isPoweredOn?: boolean | null;
            alertTypes?: {
              __typename?: 'DeviceAlertTypes';
              deviceOffline?: boolean | null;
              sourceOffline?: boolean | null;
            } | null;
            powerState?: {
              __typename?: 'DevicePowerState';
              value?: EnumDevicePowerStateValue | null;
              timestamp?: number | null;
            } | null;
            panel?: {
              __typename?: 'Panel';
              _id: string;
              name?: string | null;
              sourceId: string;
            } | null;
            meta?: { __typename?: 'DeviceMeta'; model?: string | null } | null;
          }
        | {
            __typename: 'RelayDevice';
            _id: string;
            deviceId?: string | null;
            sourceId?: string | null;
            name?: string | null;
            type?: EnumDKeyDeviceType | null;
            typeDisplayName: string;
            isConfigured?: boolean | null;
            timestamp?: number | null;
            isPoweredOn?: boolean | null;
            alertTypes?: {
              __typename?: 'DeviceAlertTypes';
              deviceOffline?: boolean | null;
              sourceOffline?: boolean | null;
            } | null;
            powerState?: {
              __typename?: 'DevicePowerState';
              value?: EnumDevicePowerStateValue | null;
              timestamp?: number | null;
            } | null;
            panel?: {
              __typename?: 'Panel';
              _id: string;
              name?: string | null;
              sourceId: string;
            } | null;
            meta?: { __typename?: 'DeviceMeta'; model?: string | null } | null;
          }
        | {
            __typename: 'SmartPowerOutlet';
            _id: string;
            deviceId?: string | null;
            sourceId?: string | null;
            name?: string | null;
            type?: EnumDKeyDeviceType | null;
            typeDisplayName: string;
            isConfigured?: boolean | null;
            timestamp?: number | null;
            isPoweredOn?: boolean | null;
            alertTypes?: {
              __typename?: 'DeviceAlertTypes';
              deviceOffline?: boolean | null;
              sourceOffline?: boolean | null;
            } | null;
            powerState?: {
              __typename?: 'DevicePowerState';
              value?: EnumDevicePowerStateValue | null;
              timestamp?: number | null;
            } | null;
            panel?: {
              __typename?: 'Panel';
              _id: string;
              name?: string | null;
              sourceId: string;
            } | null;
            meta?: { __typename?: 'DeviceMeta'; model?: string | null } | null;
          }
        | {
            __typename: 'SolarManagementSystem';
            _id: string;
            deviceId?: string | null;
            sourceId?: string | null;
            name?: string | null;
            type?: EnumDKeyDeviceType | null;
            typeDisplayName: string;
            isConfigured?: boolean | null;
            timestamp?: number | null;
            isPoweredOn?: boolean | null;
            alertTypes?: {
              __typename?: 'DeviceAlertTypes';
              deviceOffline?: boolean | null;
              sourceOffline?: boolean | null;
            } | null;
            powerState?: {
              __typename?: 'DevicePowerState';
              value?: EnumDevicePowerStateValue | null;
              timestamp?: number | null;
            } | null;
            panel?: {
              __typename?: 'Panel';
              _id: string;
              name?: string | null;
              sourceId: string;
            } | null;
            meta?: { __typename?: 'DeviceMeta'; model?: string | null } | null;
          }
        | {
            __typename: 'Thermistor';
            role?: string | null;
            _id: string;
            deviceId?: string | null;
            sourceId?: string | null;
            name?: string | null;
            type?: EnumDKeyDeviceType | null;
            typeDisplayName: string;
            isConfigured?: boolean | null;
            timestamp?: number | null;
            isPoweredOn?: boolean | null;
            alertTypes?: {
              __typename?: 'DeviceAlertTypes';
              deviceOffline?: boolean | null;
              sourceOffline?: boolean | null;
            } | null;
            powerState?: {
              __typename?: 'DevicePowerState';
              value?: EnumDevicePowerStateValue | null;
              timestamp?: number | null;
            } | null;
            panel?: {
              __typename?: 'Panel';
              _id: string;
              name?: string | null;
              sourceId: string;
            } | null;
            meta?: { __typename?: 'DeviceMeta'; model?: string | null } | null;
          }
        | {
            __typename: 'Thermostat';
            _id: string;
            deviceId?: string | null;
            sourceId?: string | null;
            name?: string | null;
            type?: EnumDKeyDeviceType | null;
            typeDisplayName: string;
            isConfigured?: boolean | null;
            timestamp?: number | null;
            isPoweredOn?: boolean | null;
            alertTypes?: {
              __typename?: 'DeviceAlertTypes';
              deviceOffline?: boolean | null;
              sourceOffline?: boolean | null;
            } | null;
            powerState?: {
              __typename?: 'DevicePowerState';
              value?: EnumDevicePowerStateValue | null;
              timestamp?: number | null;
            } | null;
            panel?: {
              __typename?: 'Panel';
              _id: string;
              name?: string | null;
              sourceId: string;
            } | null;
            meta?: { __typename?: 'DeviceMeta'; model?: string | null } | null;
          }
        | {
            __typename: 'VSDPump';
            role?: string | null;
            _id: string;
            deviceId?: string | null;
            sourceId?: string | null;
            name?: string | null;
            type?: EnumDKeyDeviceType | null;
            typeDisplayName: string;
            isConfigured?: boolean | null;
            timestamp?: number | null;
            isPoweredOn?: boolean | null;
            alertTypes?: {
              __typename?: 'DeviceAlertTypes';
              deviceOffline?: boolean | null;
              sourceOffline?: boolean | null;
            } | null;
            powerState?: {
              __typename?: 'DevicePowerState';
              value?: EnumDevicePowerStateValue | null;
              timestamp?: number | null;
            } | null;
            panel?: {
              __typename?: 'Panel';
              _id: string;
              name?: string | null;
              sourceId: string;
            } | null;
            meta?: { __typename?: 'DeviceMeta'; model?: string | null } | null;
          }
        | {
            __typename: 'WindManagementSystem';
            _id: string;
            deviceId?: string | null;
            sourceId?: string | null;
            name?: string | null;
            type?: EnumDKeyDeviceType | null;
            typeDisplayName: string;
            isConfigured?: boolean | null;
            timestamp?: number | null;
            isPoweredOn?: boolean | null;
            alertTypes?: {
              __typename?: 'DeviceAlertTypes';
              deviceOffline?: boolean | null;
              sourceOffline?: boolean | null;
            } | null;
            powerState?: {
              __typename?: 'DevicePowerState';
              value?: EnumDevicePowerStateValue | null;
              timestamp?: number | null;
            } | null;
            panel?: {
              __typename?: 'Panel';
              _id: string;
              name?: string | null;
              sourceId: string;
            } | null;
            meta?: { __typename?: 'DeviceMeta'; model?: string | null } | null;
          }
        | {
            __typename: 'WindowSensor';
            _id: string;
            deviceId?: string | null;
            sourceId?: string | null;
            name?: string | null;
            type?: EnumDKeyDeviceType | null;
            typeDisplayName: string;
            isConfigured?: boolean | null;
            timestamp?: number | null;
            isPoweredOn?: boolean | null;
            alertTypes?: {
              __typename?: 'DeviceAlertTypes';
              deviceOffline?: boolean | null;
              sourceOffline?: boolean | null;
            } | null;
            powerState?: {
              __typename?: 'DevicePowerState';
              value?: EnumDevicePowerStateValue | null;
              timestamp?: number | null;
            } | null;
            panel?: {
              __typename?: 'Panel';
              _id: string;
              name?: string | null;
              sourceId: string;
            } | null;
            meta?: { __typename?: 'DeviceMeta'; model?: string | null } | null;
          }
        | {
            __typename: 'Z210Pump';
            role?: string | null;
            _id: string;
            deviceId?: string | null;
            sourceId?: string | null;
            name?: string | null;
            type?: EnumDKeyDeviceType | null;
            typeDisplayName: string;
            isConfigured?: boolean | null;
            timestamp?: number | null;
            isPoweredOn?: boolean | null;
            alertTypes?: {
              __typename?: 'DeviceAlertTypes';
              deviceOffline?: boolean | null;
              sourceOffline?: boolean | null;
            } | null;
            powerState?: {
              __typename?: 'DevicePowerState';
              value?: EnumDevicePowerStateValue | null;
              timestamp?: number | null;
            } | null;
            panel?: {
              __typename?: 'Panel';
              _id: string;
              name?: string | null;
              sourceId: string;
            } | null;
            meta?: { __typename?: 'DeviceMeta'; model?: string | null } | null;
          }
      >;
    } | null>;
    vpps: Array<{
      __typename: 'VirtualPowerPlant';
      _id: string;
      propertyId?: string | null;
      sourceId?: string | null;
      name?: string | null;
      devices: Array<
        | {
            __typename: 'Actuator';
            _id: string;
            sourceId?: string | null;
            deviceId?: string | null;
            name?: string | null;
            type?: EnumDKeyDeviceType | null;
            typeDisplayName: string;
            isConfigured?: boolean | null;
            meta?: { __typename?: 'DeviceMeta'; model?: string | null } | null;
          }
        | {
            __typename: 'BatteryManagementSystem';
            _id: string;
            sourceId?: string | null;
            deviceId?: string | null;
            name?: string | null;
            type?: EnumDKeyDeviceType | null;
            typeDisplayName: string;
            isConfigured?: boolean | null;
            meta?: { __typename?: 'DeviceMeta'; model?: string | null } | null;
          }
        | {
            __typename: 'Boiler';
            _id: string;
            sourceId?: string | null;
            deviceId?: string | null;
            name?: string | null;
            type?: EnumDKeyDeviceType | null;
            typeDisplayName: string;
            isConfigured?: boolean | null;
            meta?: { __typename?: 'DeviceMeta'; model?: string | null } | null;
          }
        | {
            __typename: 'Chiller';
            _id: string;
            sourceId?: string | null;
            deviceId?: string | null;
            name?: string | null;
            type?: EnumDKeyDeviceType | null;
            typeDisplayName: string;
            isConfigured?: boolean | null;
            meta?: { __typename?: 'DeviceMeta'; model?: string | null } | null;
          }
        | {
            __typename: 'ConductorGenericSensor';
            _id: string;
            sourceId?: string | null;
            deviceId?: string | null;
            name?: string | null;
            type?: EnumDKeyDeviceType | null;
            typeDisplayName: string;
            isConfigured?: boolean | null;
            meta?: { __typename?: 'DeviceMeta'; model?: string | null } | null;
          }
        | {
            __typename: 'Controller';
            _id: string;
            sourceId?: string | null;
            deviceId?: string | null;
            name?: string | null;
            type?: EnumDKeyDeviceType | null;
            typeDisplayName: string;
            isConfigured?: boolean | null;
            meta?: { __typename?: 'DeviceMeta'; model?: string | null } | null;
          }
        | {
            __typename: 'Device';
            _id: string;
            sourceId?: string | null;
            deviceId?: string | null;
            name?: string | null;
            type?: EnumDKeyDeviceType | null;
            typeDisplayName: string;
            isConfigured?: boolean | null;
            meta?: { __typename?: 'DeviceMeta'; model?: string | null } | null;
          }
        | {
            __typename: 'DoorSensor';
            _id: string;
            sourceId?: string | null;
            deviceId?: string | null;
            name?: string | null;
            type?: EnumDKeyDeviceType | null;
            typeDisplayName: string;
            isConfigured?: boolean | null;
            meta?: { __typename?: 'DeviceMeta'; model?: string | null } | null;
          }
        | {
            __typename: 'EnergyController';
            _id: string;
            sourceId?: string | null;
            deviceId?: string | null;
            name?: string | null;
            type?: EnumDKeyDeviceType | null;
            typeDisplayName: string;
            isConfigured?: boolean | null;
            meta?: { __typename?: 'DeviceMeta'; model?: string | null } | null;
          }
        | {
            __typename: 'EnergyConverter';
            _id: string;
            sourceId?: string | null;
            deviceId?: string | null;
            name?: string | null;
            type?: EnumDKeyDeviceType | null;
            typeDisplayName: string;
            isConfigured?: boolean | null;
            meta?: { __typename?: 'DeviceMeta'; model?: string | null } | null;
          }
        | {
            __typename: 'EnergyInverter';
            _id: string;
            sourceId?: string | null;
            deviceId?: string | null;
            name?: string | null;
            type?: EnumDKeyDeviceType | null;
            typeDisplayName: string;
            isConfigured?: boolean | null;
            meta?: { __typename?: 'DeviceMeta'; model?: string | null } | null;
          }
        | {
            __typename: 'EnergyMeter';
            _id: string;
            sourceId?: string | null;
            deviceId?: string | null;
            name?: string | null;
            type?: EnumDKeyDeviceType | null;
            typeDisplayName: string;
            isConfigured?: boolean | null;
            meta?: { __typename?: 'DeviceMeta'; model?: string | null } | null;
          }
        | {
            __typename: 'EnergyRectifier';
            _id: string;
            sourceId?: string | null;
            deviceId?: string | null;
            name?: string | null;
            type?: EnumDKeyDeviceType | null;
            typeDisplayName: string;
            isConfigured?: boolean | null;
            meta?: { __typename?: 'DeviceMeta'; model?: string | null } | null;
          }
        | {
            __typename: 'EnergyStorageCoolingSystem';
            _id: string;
            sourceId?: string | null;
            deviceId?: string | null;
            name?: string | null;
            type?: EnumDKeyDeviceType | null;
            typeDisplayName: string;
            isConfigured?: boolean | null;
            meta?: { __typename?: 'DeviceMeta'; model?: string | null } | null;
          }
        | {
            __typename: 'EnergySwitchPanel';
            _id: string;
            sourceId?: string | null;
            deviceId?: string | null;
            name?: string | null;
            type?: EnumDKeyDeviceType | null;
            typeDisplayName: string;
            isConfigured?: boolean | null;
            meta?: { __typename?: 'DeviceMeta'; model?: string | null } | null;
          }
        | {
            __typename: 'EnergySwitchPanelCircuit';
            _id: string;
            sourceId?: string | null;
            deviceId?: string | null;
            name?: string | null;
            type?: EnumDKeyDeviceType | null;
            typeDisplayName: string;
            isConfigured?: boolean | null;
            meta?: { __typename?: 'DeviceMeta'; model?: string | null } | null;
          }
        | {
            __typename: 'FireSuppressionSystem';
            _id: string;
            sourceId?: string | null;
            deviceId?: string | null;
            name?: string | null;
            type?: EnumDKeyDeviceType | null;
            typeDisplayName: string;
            isConfigured?: boolean | null;
            meta?: { __typename?: 'DeviceMeta'; model?: string | null } | null;
          }
        | {
            __typename: 'GPIO';
            _id: string;
            sourceId?: string | null;
            deviceId?: string | null;
            name?: string | null;
            type?: EnumDKeyDeviceType | null;
            typeDisplayName: string;
            isConfigured?: boolean | null;
            meta?: { __typename?: 'DeviceMeta'; model?: string | null } | null;
          }
        | {
            __typename: 'IndoorAirHandler';
            _id: string;
            sourceId?: string | null;
            deviceId?: string | null;
            name?: string | null;
            type?: EnumDKeyDeviceType | null;
            typeDisplayName: string;
            isConfigured?: boolean | null;
            meta?: { __typename?: 'DeviceMeta'; model?: string | null } | null;
          }
        | {
            __typename: 'IndoorSensor';
            _id: string;
            sourceId?: string | null;
            deviceId?: string | null;
            name?: string | null;
            type?: EnumDKeyDeviceType | null;
            typeDisplayName: string;
            isConfigured?: boolean | null;
            meta?: { __typename?: 'DeviceMeta'; model?: string | null } | null;
          }
        | {
            __typename: 'KineticEnergyManagementSystem';
            _id: string;
            sourceId?: string | null;
            deviceId?: string | null;
            name?: string | null;
            type?: EnumDKeyDeviceType | null;
            typeDisplayName: string;
            isConfigured?: boolean | null;
            meta?: { __typename?: 'DeviceMeta'; model?: string | null } | null;
          }
        | {
            __typename: 'LeakDetector';
            _id: string;
            sourceId?: string | null;
            deviceId?: string | null;
            name?: string | null;
            type?: EnumDKeyDeviceType | null;
            typeDisplayName: string;
            isConfigured?: boolean | null;
            meta?: { __typename?: 'DeviceMeta'; model?: string | null } | null;
          }
        | {
            __typename: 'Loop';
            _id: string;
            sourceId?: string | null;
            deviceId?: string | null;
            name?: string | null;
            type?: EnumDKeyDeviceType | null;
            typeDisplayName: string;
            isConfigured?: boolean | null;
            meta?: { __typename?: 'DeviceMeta'; model?: string | null } | null;
          }
        | {
            __typename: 'ModbusAirHandler';
            _id: string;
            sourceId?: string | null;
            deviceId?: string | null;
            name?: string | null;
            type?: EnumDKeyDeviceType | null;
            typeDisplayName: string;
            isConfigured?: boolean | null;
            meta?: { __typename?: 'DeviceMeta'; model?: string | null } | null;
          }
        | {
            __typename: 'OccupancySensor';
            _id: string;
            sourceId?: string | null;
            deviceId?: string | null;
            name?: string | null;
            type?: EnumDKeyDeviceType | null;
            typeDisplayName: string;
            isConfigured?: boolean | null;
            meta?: { __typename?: 'DeviceMeta'; model?: string | null } | null;
          }
        | {
            __typename: 'OpenWeather';
            _id: string;
            sourceId?: string | null;
            deviceId?: string | null;
            name?: string | null;
            type?: EnumDKeyDeviceType | null;
            typeDisplayName: string;
            isConfigured?: boolean | null;
            meta?: { __typename?: 'DeviceMeta'; model?: string | null } | null;
          }
        | {
            __typename: 'OutdoorSensor';
            _id: string;
            sourceId?: string | null;
            deviceId?: string | null;
            name?: string | null;
            type?: EnumDKeyDeviceType | null;
            typeDisplayName: string;
            isConfigured?: boolean | null;
            meta?: { __typename?: 'DeviceMeta'; model?: string | null } | null;
          }
        | {
            __typename: 'PowerMonitor';
            _id: string;
            sourceId?: string | null;
            deviceId?: string | null;
            name?: string | null;
            type?: EnumDKeyDeviceType | null;
            typeDisplayName: string;
            isConfigured?: boolean | null;
            meta?: { __typename?: 'DeviceMeta'; model?: string | null } | null;
          }
        | {
            __typename: 'PressureSensor';
            _id: string;
            sourceId?: string | null;
            deviceId?: string | null;
            name?: string | null;
            type?: EnumDKeyDeviceType | null;
            typeDisplayName: string;
            isConfigured?: boolean | null;
            meta?: { __typename?: 'DeviceMeta'; model?: string | null } | null;
          }
        | {
            __typename: 'RelayDevice';
            _id: string;
            sourceId?: string | null;
            deviceId?: string | null;
            name?: string | null;
            type?: EnumDKeyDeviceType | null;
            typeDisplayName: string;
            isConfigured?: boolean | null;
            meta?: { __typename?: 'DeviceMeta'; model?: string | null } | null;
          }
        | {
            __typename: 'SmartPowerOutlet';
            _id: string;
            sourceId?: string | null;
            deviceId?: string | null;
            name?: string | null;
            type?: EnumDKeyDeviceType | null;
            typeDisplayName: string;
            isConfigured?: boolean | null;
            meta?: { __typename?: 'DeviceMeta'; model?: string | null } | null;
          }
        | {
            __typename: 'SolarManagementSystem';
            _id: string;
            sourceId?: string | null;
            deviceId?: string | null;
            name?: string | null;
            type?: EnumDKeyDeviceType | null;
            typeDisplayName: string;
            isConfigured?: boolean | null;
            meta?: { __typename?: 'DeviceMeta'; model?: string | null } | null;
          }
        | {
            __typename: 'Thermistor';
            _id: string;
            sourceId?: string | null;
            deviceId?: string | null;
            name?: string | null;
            type?: EnumDKeyDeviceType | null;
            typeDisplayName: string;
            isConfigured?: boolean | null;
            meta?: { __typename?: 'DeviceMeta'; model?: string | null } | null;
          }
        | {
            __typename: 'Thermostat';
            _id: string;
            sourceId?: string | null;
            deviceId?: string | null;
            name?: string | null;
            type?: EnumDKeyDeviceType | null;
            typeDisplayName: string;
            isConfigured?: boolean | null;
            meta?: { __typename?: 'DeviceMeta'; model?: string | null } | null;
          }
        | {
            __typename: 'VSDPump';
            _id: string;
            sourceId?: string | null;
            deviceId?: string | null;
            name?: string | null;
            type?: EnumDKeyDeviceType | null;
            typeDisplayName: string;
            isConfigured?: boolean | null;
            meta?: { __typename?: 'DeviceMeta'; model?: string | null } | null;
          }
        | {
            __typename: 'WindManagementSystem';
            _id: string;
            sourceId?: string | null;
            deviceId?: string | null;
            name?: string | null;
            type?: EnumDKeyDeviceType | null;
            typeDisplayName: string;
            isConfigured?: boolean | null;
            meta?: { __typename?: 'DeviceMeta'; model?: string | null } | null;
          }
        | {
            __typename: 'WindowSensor';
            _id: string;
            sourceId?: string | null;
            deviceId?: string | null;
            name?: string | null;
            type?: EnumDKeyDeviceType | null;
            typeDisplayName: string;
            isConfigured?: boolean | null;
            meta?: { __typename?: 'DeviceMeta'; model?: string | null } | null;
          }
        | {
            __typename: 'Z210Pump';
            _id: string;
            sourceId?: string | null;
            deviceId?: string | null;
            name?: string | null;
            type?: EnumDKeyDeviceType | null;
            typeDisplayName: string;
            isConfigured?: boolean | null;
            meta?: { __typename?: 'DeviceMeta'; model?: string | null } | null;
          }
      >;
    } | null>;
    controlGroups: Array<{
      __typename?: 'ControlGroup';
      _id: string;
      name: string;
      type: string;
      automationEnabled?: boolean | null;
      masterDeviceId?: string | null;
      attributes: any;
      deviceDetails?: any | null;
      masterDevice?: {
        __typename?: 'Device';
        _id: string;
        deviceId?: string | null;
        type?: EnumDKeyDeviceType | null;
      } | null;
      devices: Array<{
        __typename?: 'Device';
        _id: string;
        deviceId?: string | null;
        type?: EnumDKeyDeviceType | null;
      }>;
    } | null>;
    setpointLimitProfile?: {
      __typename?: 'SetpointProfile';
      heat?: {
        __typename?: 'SetpointProfileHeat';
        max?: number | null;
        min?: number | null;
      } | null;
      cool?: {
        __typename?: 'SetpointProfileCool';
        max?: number | null;
        min?: number | null;
      } | null;
    } | null;
    property?: {
      __typename?: 'Property';
      _id: string;
      setpointProfileId?: string | null;
      setpointLimitProfile?: {
        __typename?: 'SetpointProfile';
        heat?: {
          __typename?: 'SetpointProfileHeat';
          min?: number | null;
          max?: number | null;
        } | null;
        cool?: {
          __typename?: 'SetpointProfileCool';
          min?: number | null;
          max?: number | null;
        } | null;
      } | null;
    } | null;
  } | null;
};

export type UnitDetailBreadcrumbQueryVariables = Exact<{
  _id: Scalars['String'];
}>;

export type UnitDetailBreadcrumbQuery = {
  __typename?: 'Query';
  unitById?: { __typename?: 'Unit'; name: string } | null;
};

export type UnitDetailEditQueryVariables = Exact<{
  uid: Scalars['String'];
}>;

export type UnitDetailEditQuery = {
  __typename?: 'Query';
  unitById?: {
    __typename?: 'Unit';
    _id: string;
    name: string;
    type: string;
    buildingId: string;
    sourceId?: string | null;
    setpointProfileId?: string | null;
    zonePolicyId?: string | null;
    thermostatScheduleTemplateId?: string | null;
    property?: {
      __typename?: 'Property';
      setpointProfileId?: string | null;
      zonePolicyId?: string | null;
    } | null;
    building?: { __typename?: 'Building'; name: string } | null;
    assignableSetpointProfiles: Array<{
      __typename?: 'SetpointProfile';
      _id: string;
      name?: string | null;
      heat?: {
        __typename?: 'SetpointProfileHeat';
        max?: number | null;
        min?: number | null;
      } | null;
      cool?: {
        __typename?: 'SetpointProfileCool';
        max?: number | null;
        min?: number | null;
      } | null;
    } | null>;
    assignableZonePolicies?: Array<{
      __typename?: 'ZonePolicy';
      _id: any;
      name?: string | null;
      properties?: Array<string | null> | null;
      rules?: Array<{
        __typename?: 'ZonePolicyRules';
        type: EnumZonePolicyRulesType;
        source?: {
          __typename?: 'ZonePolicyRulesSource';
          deviceType: string;
          multiplicity?: EnumZonePolicyRulesSourceMultiplicity | null;
          attributes?: {
            __typename?: 'ZonePolicyRulesSourceAttributes';
            operatingMode?: string | null;
            operatingState?: string | null;
            heatSetpoint?: string | null;
            coolSetpoint?: string | null;
            contactState?: string | null;
            fanSpeed?: string | null;
            indoorFanStatus?: string | null;
            keypadLockoutLevel?: string | null;
          } | null;
        } | null;
        target?: {
          __typename?: 'ZonePolicyRulesTarget';
          deviceType: string;
          multiplicity?: EnumZonePolicyRulesTargetMultiplicity | null;
          attributes?: {
            __typename?: 'ZonePolicyRulesTargetAttributes';
            heatSetpoint?: string | null;
            coolSetpoint?: string | null;
            isOn?: string | null;
            keypadLockoutLevel?: string | null;
          } | null;
        } | null;
      } | null> | null;
    }> | null;
    resident?: {
      __typename?: 'UnitResident';
      name?: string | null;
      email?: string | null;
      phone?: string | null;
      mobile?: string | null;
    } | null;
  } | null;
};

export type UnitDevicesQueryVariables = Exact<{
  unitId: Scalars['String'];
}>;

export type UnitDevicesQuery = {
  __typename?: 'Query';
  devices: Array<
    | {
        __typename: 'Actuator';
        deviceId?: string | null;
        name?: string | null;
        type?: EnumDKeyDeviceType | null;
        typeDisplayName: string;
        isConfigured?: boolean | null;
        zoneId?: string | null;
        panelId?: string | null;
        vppId?: string | null;
        chartTypes: Array<ChartType>;
        meta?: { __typename?: 'DeviceMeta'; name?: string | null } | null;
        alertTypes?: {
          __typename?: 'DeviceAlertTypes';
          deviceOffline?: boolean | null;
          sourceOffline?: boolean | null;
        } | null;
      }
    | {
        __typename: 'BatteryManagementSystem';
        deviceId?: string | null;
        name?: string | null;
        type?: EnumDKeyDeviceType | null;
        typeDisplayName: string;
        isConfigured?: boolean | null;
        zoneId?: string | null;
        panelId?: string | null;
        vppId?: string | null;
        chartTypes: Array<ChartType>;
        meta?: { __typename?: 'DeviceMeta'; name?: string | null } | null;
        alertTypes?: {
          __typename?: 'DeviceAlertTypes';
          deviceOffline?: boolean | null;
          sourceOffline?: boolean | null;
        } | null;
      }
    | {
        __typename: 'Boiler';
        role?: string | null;
        deviceId?: string | null;
        name?: string | null;
        type?: EnumDKeyDeviceType | null;
        typeDisplayName: string;
        isConfigured?: boolean | null;
        zoneId?: string | null;
        panelId?: string | null;
        vppId?: string | null;
        chartTypes: Array<ChartType>;
        meta?: { __typename?: 'DeviceMeta'; name?: string | null } | null;
        alertTypes?: {
          __typename?: 'DeviceAlertTypes';
          deviceOffline?: boolean | null;
          sourceOffline?: boolean | null;
        } | null;
      }
    | {
        __typename: 'Chiller';
        deviceId?: string | null;
        name?: string | null;
        type?: EnumDKeyDeviceType | null;
        typeDisplayName: string;
        isConfigured?: boolean | null;
        zoneId?: string | null;
        panelId?: string | null;
        vppId?: string | null;
        chartTypes: Array<ChartType>;
        meta?: { __typename?: 'DeviceMeta'; name?: string | null } | null;
        alertTypes?: {
          __typename?: 'DeviceAlertTypes';
          deviceOffline?: boolean | null;
          sourceOffline?: boolean | null;
        } | null;
      }
    | {
        __typename: 'ConductorGenericSensor';
        deviceId?: string | null;
        name?: string | null;
        type?: EnumDKeyDeviceType | null;
        typeDisplayName: string;
        isConfigured?: boolean | null;
        zoneId?: string | null;
        panelId?: string | null;
        vppId?: string | null;
        chartTypes: Array<ChartType>;
        meta?: { __typename?: 'DeviceMeta'; name?: string | null } | null;
        alertTypes?: {
          __typename?: 'DeviceAlertTypes';
          deviceOffline?: boolean | null;
          sourceOffline?: boolean | null;
        } | null;
      }
    | {
        __typename: 'Controller';
        deviceId?: string | null;
        name?: string | null;
        type?: EnumDKeyDeviceType | null;
        typeDisplayName: string;
        isConfigured?: boolean | null;
        zoneId?: string | null;
        panelId?: string | null;
        vppId?: string | null;
        chartTypes: Array<ChartType>;
        meta?: { __typename?: 'DeviceMeta'; name?: string | null } | null;
        alertTypes?: {
          __typename?: 'DeviceAlertTypes';
          deviceOffline?: boolean | null;
          sourceOffline?: boolean | null;
        } | null;
      }
    | {
        __typename: 'Device';
        deviceId?: string | null;
        name?: string | null;
        type?: EnumDKeyDeviceType | null;
        typeDisplayName: string;
        isConfigured?: boolean | null;
        zoneId?: string | null;
        panelId?: string | null;
        vppId?: string | null;
        chartTypes: Array<ChartType>;
        meta?: { __typename?: 'DeviceMeta'; name?: string | null } | null;
        alertTypes?: {
          __typename?: 'DeviceAlertTypes';
          deviceOffline?: boolean | null;
          sourceOffline?: boolean | null;
        } | null;
      }
    | {
        __typename: 'DoorSensor';
        deviceId?: string | null;
        name?: string | null;
        type?: EnumDKeyDeviceType | null;
        typeDisplayName: string;
        isConfigured?: boolean | null;
        zoneId?: string | null;
        panelId?: string | null;
        vppId?: string | null;
        chartTypes: Array<ChartType>;
        meta?: { __typename?: 'DeviceMeta'; name?: string | null } | null;
        alertTypes?: {
          __typename?: 'DeviceAlertTypes';
          deviceOffline?: boolean | null;
          sourceOffline?: boolean | null;
        } | null;
      }
    | {
        __typename: 'EnergyController';
        deviceId?: string | null;
        name?: string | null;
        type?: EnumDKeyDeviceType | null;
        typeDisplayName: string;
        isConfigured?: boolean | null;
        zoneId?: string | null;
        panelId?: string | null;
        vppId?: string | null;
        chartTypes: Array<ChartType>;
        meta?: { __typename?: 'DeviceMeta'; name?: string | null } | null;
        alertTypes?: {
          __typename?: 'DeviceAlertTypes';
          deviceOffline?: boolean | null;
          sourceOffline?: boolean | null;
        } | null;
      }
    | {
        __typename: 'EnergyConverter';
        deviceId?: string | null;
        name?: string | null;
        type?: EnumDKeyDeviceType | null;
        typeDisplayName: string;
        isConfigured?: boolean | null;
        zoneId?: string | null;
        panelId?: string | null;
        vppId?: string | null;
        chartTypes: Array<ChartType>;
        meta?: { __typename?: 'DeviceMeta'; name?: string | null } | null;
        alertTypes?: {
          __typename?: 'DeviceAlertTypes';
          deviceOffline?: boolean | null;
          sourceOffline?: boolean | null;
        } | null;
      }
    | {
        __typename: 'EnergyInverter';
        deviceId?: string | null;
        name?: string | null;
        type?: EnumDKeyDeviceType | null;
        typeDisplayName: string;
        isConfigured?: boolean | null;
        zoneId?: string | null;
        panelId?: string | null;
        vppId?: string | null;
        chartTypes: Array<ChartType>;
        meta?: { __typename?: 'DeviceMeta'; name?: string | null } | null;
        alertTypes?: {
          __typename?: 'DeviceAlertTypes';
          deviceOffline?: boolean | null;
          sourceOffline?: boolean | null;
        } | null;
      }
    | {
        __typename: 'EnergyMeter';
        deviceId?: string | null;
        name?: string | null;
        type?: EnumDKeyDeviceType | null;
        typeDisplayName: string;
        isConfigured?: boolean | null;
        zoneId?: string | null;
        panelId?: string | null;
        vppId?: string | null;
        chartTypes: Array<ChartType>;
        meta?: { __typename?: 'DeviceMeta'; name?: string | null } | null;
        alertTypes?: {
          __typename?: 'DeviceAlertTypes';
          deviceOffline?: boolean | null;
          sourceOffline?: boolean | null;
        } | null;
      }
    | {
        __typename: 'EnergyRectifier';
        deviceId?: string | null;
        name?: string | null;
        type?: EnumDKeyDeviceType | null;
        typeDisplayName: string;
        isConfigured?: boolean | null;
        zoneId?: string | null;
        panelId?: string | null;
        vppId?: string | null;
        chartTypes: Array<ChartType>;
        meta?: { __typename?: 'DeviceMeta'; name?: string | null } | null;
        alertTypes?: {
          __typename?: 'DeviceAlertTypes';
          deviceOffline?: boolean | null;
          sourceOffline?: boolean | null;
        } | null;
      }
    | {
        __typename: 'EnergyStorageCoolingSystem';
        deviceId?: string | null;
        name?: string | null;
        type?: EnumDKeyDeviceType | null;
        typeDisplayName: string;
        isConfigured?: boolean | null;
        zoneId?: string | null;
        panelId?: string | null;
        vppId?: string | null;
        chartTypes: Array<ChartType>;
        meta?: { __typename?: 'DeviceMeta'; name?: string | null } | null;
        alertTypes?: {
          __typename?: 'DeviceAlertTypes';
          deviceOffline?: boolean | null;
          sourceOffline?: boolean | null;
        } | null;
      }
    | {
        __typename: 'EnergySwitchPanel';
        deviceId?: string | null;
        name?: string | null;
        type?: EnumDKeyDeviceType | null;
        typeDisplayName: string;
        isConfigured?: boolean | null;
        zoneId?: string | null;
        panelId?: string | null;
        vppId?: string | null;
        chartTypes: Array<ChartType>;
        meta?: { __typename?: 'DeviceMeta'; name?: string | null } | null;
        alertTypes?: {
          __typename?: 'DeviceAlertTypes';
          deviceOffline?: boolean | null;
          sourceOffline?: boolean | null;
        } | null;
      }
    | {
        __typename: 'EnergySwitchPanelCircuit';
        deviceId?: string | null;
        name?: string | null;
        type?: EnumDKeyDeviceType | null;
        typeDisplayName: string;
        isConfigured?: boolean | null;
        zoneId?: string | null;
        panelId?: string | null;
        vppId?: string | null;
        chartTypes: Array<ChartType>;
        meta?: { __typename?: 'DeviceMeta'; name?: string | null } | null;
        alertTypes?: {
          __typename?: 'DeviceAlertTypes';
          deviceOffline?: boolean | null;
          sourceOffline?: boolean | null;
        } | null;
      }
    | {
        __typename: 'FireSuppressionSystem';
        deviceId?: string | null;
        name?: string | null;
        type?: EnumDKeyDeviceType | null;
        typeDisplayName: string;
        isConfigured?: boolean | null;
        zoneId?: string | null;
        panelId?: string | null;
        vppId?: string | null;
        chartTypes: Array<ChartType>;
        meta?: { __typename?: 'DeviceMeta'; name?: string | null } | null;
        alertTypes?: {
          __typename?: 'DeviceAlertTypes';
          deviceOffline?: boolean | null;
          sourceOffline?: boolean | null;
        } | null;
      }
    | {
        __typename: 'GPIO';
        displayName?: string | null;
        deviceId?: string | null;
        name?: string | null;
        type?: EnumDKeyDeviceType | null;
        typeDisplayName: string;
        isConfigured?: boolean | null;
        zoneId?: string | null;
        panelId?: string | null;
        vppId?: string | null;
        chartTypes: Array<ChartType>;
        meta?: { __typename?: 'DeviceMeta'; name?: string | null } | null;
        alertTypes?: {
          __typename?: 'DeviceAlertTypes';
          deviceOffline?: boolean | null;
          sourceOffline?: boolean | null;
        } | null;
      }
    | {
        __typename: 'IndoorAirHandler';
        deviceId?: string | null;
        name?: string | null;
        type?: EnumDKeyDeviceType | null;
        typeDisplayName: string;
        isConfigured?: boolean | null;
        zoneId?: string | null;
        panelId?: string | null;
        vppId?: string | null;
        chartTypes: Array<ChartType>;
        meta?: { __typename?: 'DeviceMeta'; name?: string | null } | null;
        alertTypes?: {
          __typename?: 'DeviceAlertTypes';
          deviceOffline?: boolean | null;
          sourceOffline?: boolean | null;
        } | null;
      }
    | {
        __typename: 'IndoorSensor';
        deviceId?: string | null;
        name?: string | null;
        type?: EnumDKeyDeviceType | null;
        typeDisplayName: string;
        isConfigured?: boolean | null;
        zoneId?: string | null;
        panelId?: string | null;
        vppId?: string | null;
        chartTypes: Array<ChartType>;
        meta?: { __typename?: 'DeviceMeta'; name?: string | null } | null;
        alertTypes?: {
          __typename?: 'DeviceAlertTypes';
          deviceOffline?: boolean | null;
          sourceOffline?: boolean | null;
        } | null;
      }
    | {
        __typename: 'KineticEnergyManagementSystem';
        deviceId?: string | null;
        name?: string | null;
        type?: EnumDKeyDeviceType | null;
        typeDisplayName: string;
        isConfigured?: boolean | null;
        zoneId?: string | null;
        panelId?: string | null;
        vppId?: string | null;
        chartTypes: Array<ChartType>;
        meta?: { __typename?: 'DeviceMeta'; name?: string | null } | null;
        alertTypes?: {
          __typename?: 'DeviceAlertTypes';
          deviceOffline?: boolean | null;
          sourceOffline?: boolean | null;
        } | null;
      }
    | {
        __typename: 'LeakDetector';
        displayName?: string | null;
        deviceId?: string | null;
        name?: string | null;
        type?: EnumDKeyDeviceType | null;
        typeDisplayName: string;
        isConfigured?: boolean | null;
        zoneId?: string | null;
        panelId?: string | null;
        vppId?: string | null;
        chartTypes: Array<ChartType>;
        meta?: { __typename?: 'DeviceMeta'; name?: string | null } | null;
        alertTypes?: {
          __typename?: 'DeviceAlertTypes';
          deviceOffline?: boolean | null;
          sourceOffline?: boolean | null;
        } | null;
      }
    | {
        __typename: 'Loop';
        role?: string | null;
        deviceId?: string | null;
        name?: string | null;
        type?: EnumDKeyDeviceType | null;
        typeDisplayName: string;
        isConfigured?: boolean | null;
        zoneId?: string | null;
        panelId?: string | null;
        vppId?: string | null;
        chartTypes: Array<ChartType>;
        meta?: { __typename?: 'DeviceMeta'; name?: string | null } | null;
        alertTypes?: {
          __typename?: 'DeviceAlertTypes';
          deviceOffline?: boolean | null;
          sourceOffline?: boolean | null;
        } | null;
      }
    | {
        __typename: 'ModbusAirHandler';
        deviceId?: string | null;
        name?: string | null;
        type?: EnumDKeyDeviceType | null;
        typeDisplayName: string;
        isConfigured?: boolean | null;
        zoneId?: string | null;
        panelId?: string | null;
        vppId?: string | null;
        chartTypes: Array<ChartType>;
        meta?: { __typename?: 'DeviceMeta'; name?: string | null } | null;
        alertTypes?: {
          __typename?: 'DeviceAlertTypes';
          deviceOffline?: boolean | null;
          sourceOffline?: boolean | null;
        } | null;
      }
    | {
        __typename: 'OccupancySensor';
        deviceId?: string | null;
        name?: string | null;
        type?: EnumDKeyDeviceType | null;
        typeDisplayName: string;
        isConfigured?: boolean | null;
        zoneId?: string | null;
        panelId?: string | null;
        vppId?: string | null;
        chartTypes: Array<ChartType>;
        meta?: { __typename?: 'DeviceMeta'; name?: string | null } | null;
        alertTypes?: {
          __typename?: 'DeviceAlertTypes';
          deviceOffline?: boolean | null;
          sourceOffline?: boolean | null;
        } | null;
      }
    | {
        __typename: 'OpenWeather';
        deviceId?: string | null;
        name?: string | null;
        type?: EnumDKeyDeviceType | null;
        typeDisplayName: string;
        isConfigured?: boolean | null;
        zoneId?: string | null;
        panelId?: string | null;
        vppId?: string | null;
        chartTypes: Array<ChartType>;
        meta?: { __typename?: 'DeviceMeta'; name?: string | null } | null;
        alertTypes?: {
          __typename?: 'DeviceAlertTypes';
          deviceOffline?: boolean | null;
          sourceOffline?: boolean | null;
        } | null;
      }
    | {
        __typename: 'OutdoorSensor';
        deviceId?: string | null;
        name?: string | null;
        type?: EnumDKeyDeviceType | null;
        typeDisplayName: string;
        isConfigured?: boolean | null;
        zoneId?: string | null;
        panelId?: string | null;
        vppId?: string | null;
        chartTypes: Array<ChartType>;
        meta?: { __typename?: 'DeviceMeta'; name?: string | null } | null;
        alertTypes?: {
          __typename?: 'DeviceAlertTypes';
          deviceOffline?: boolean | null;
          sourceOffline?: boolean | null;
        } | null;
      }
    | {
        __typename: 'PowerMonitor';
        deviceId?: string | null;
        name?: string | null;
        type?: EnumDKeyDeviceType | null;
        typeDisplayName: string;
        isConfigured?: boolean | null;
        zoneId?: string | null;
        panelId?: string | null;
        vppId?: string | null;
        chartTypes: Array<ChartType>;
        meta?: { __typename?: 'DeviceMeta'; name?: string | null } | null;
        alertTypes?: {
          __typename?: 'DeviceAlertTypes';
          deviceOffline?: boolean | null;
          sourceOffline?: boolean | null;
        } | null;
      }
    | {
        __typename: 'PressureSensor';
        role?: string | null;
        deviceId?: string | null;
        name?: string | null;
        type?: EnumDKeyDeviceType | null;
        typeDisplayName: string;
        isConfigured?: boolean | null;
        zoneId?: string | null;
        panelId?: string | null;
        vppId?: string | null;
        chartTypes: Array<ChartType>;
        meta?: { __typename?: 'DeviceMeta'; name?: string | null } | null;
        alertTypes?: {
          __typename?: 'DeviceAlertTypes';
          deviceOffline?: boolean | null;
          sourceOffline?: boolean | null;
        } | null;
      }
    | {
        __typename: 'RelayDevice';
        deviceId?: string | null;
        name?: string | null;
        type?: EnumDKeyDeviceType | null;
        typeDisplayName: string;
        isConfigured?: boolean | null;
        zoneId?: string | null;
        panelId?: string | null;
        vppId?: string | null;
        chartTypes: Array<ChartType>;
        meta?: { __typename?: 'DeviceMeta'; name?: string | null } | null;
        alertTypes?: {
          __typename?: 'DeviceAlertTypes';
          deviceOffline?: boolean | null;
          sourceOffline?: boolean | null;
        } | null;
      }
    | {
        __typename: 'SmartPowerOutlet';
        deviceId?: string | null;
        name?: string | null;
        type?: EnumDKeyDeviceType | null;
        typeDisplayName: string;
        isConfigured?: boolean | null;
        zoneId?: string | null;
        panelId?: string | null;
        vppId?: string | null;
        chartTypes: Array<ChartType>;
        meta?: { __typename?: 'DeviceMeta'; name?: string | null } | null;
        alertTypes?: {
          __typename?: 'DeviceAlertTypes';
          deviceOffline?: boolean | null;
          sourceOffline?: boolean | null;
        } | null;
      }
    | {
        __typename: 'SolarManagementSystem';
        deviceId?: string | null;
        name?: string | null;
        type?: EnumDKeyDeviceType | null;
        typeDisplayName: string;
        isConfigured?: boolean | null;
        zoneId?: string | null;
        panelId?: string | null;
        vppId?: string | null;
        chartTypes: Array<ChartType>;
        meta?: { __typename?: 'DeviceMeta'; name?: string | null } | null;
        alertTypes?: {
          __typename?: 'DeviceAlertTypes';
          deviceOffline?: boolean | null;
          sourceOffline?: boolean | null;
        } | null;
      }
    | {
        __typename: 'Thermistor';
        role?: string | null;
        deviceId?: string | null;
        name?: string | null;
        type?: EnumDKeyDeviceType | null;
        typeDisplayName: string;
        isConfigured?: boolean | null;
        zoneId?: string | null;
        panelId?: string | null;
        vppId?: string | null;
        chartTypes: Array<ChartType>;
        meta?: { __typename?: 'DeviceMeta'; name?: string | null } | null;
        alertTypes?: {
          __typename?: 'DeviceAlertTypes';
          deviceOffline?: boolean | null;
          sourceOffline?: boolean | null;
        } | null;
      }
    | {
        __typename: 'Thermostat';
        deviceId?: string | null;
        name?: string | null;
        type?: EnumDKeyDeviceType | null;
        typeDisplayName: string;
        isConfigured?: boolean | null;
        zoneId?: string | null;
        panelId?: string | null;
        vppId?: string | null;
        chartTypes: Array<ChartType>;
        meta?: { __typename?: 'DeviceMeta'; name?: string | null } | null;
        alertTypes?: {
          __typename?: 'DeviceAlertTypes';
          deviceOffline?: boolean | null;
          sourceOffline?: boolean | null;
        } | null;
      }
    | {
        __typename: 'VSDPump';
        role?: string | null;
        deviceId?: string | null;
        name?: string | null;
        type?: EnumDKeyDeviceType | null;
        typeDisplayName: string;
        isConfigured?: boolean | null;
        zoneId?: string | null;
        panelId?: string | null;
        vppId?: string | null;
        chartTypes: Array<ChartType>;
        meta?: { __typename?: 'DeviceMeta'; name?: string | null } | null;
        alertTypes?: {
          __typename?: 'DeviceAlertTypes';
          deviceOffline?: boolean | null;
          sourceOffline?: boolean | null;
        } | null;
      }
    | {
        __typename: 'WindManagementSystem';
        deviceId?: string | null;
        name?: string | null;
        type?: EnumDKeyDeviceType | null;
        typeDisplayName: string;
        isConfigured?: boolean | null;
        zoneId?: string | null;
        panelId?: string | null;
        vppId?: string | null;
        chartTypes: Array<ChartType>;
        meta?: { __typename?: 'DeviceMeta'; name?: string | null } | null;
        alertTypes?: {
          __typename?: 'DeviceAlertTypes';
          deviceOffline?: boolean | null;
          sourceOffline?: boolean | null;
        } | null;
      }
    | {
        __typename: 'WindowSensor';
        deviceId?: string | null;
        name?: string | null;
        type?: EnumDKeyDeviceType | null;
        typeDisplayName: string;
        isConfigured?: boolean | null;
        zoneId?: string | null;
        panelId?: string | null;
        vppId?: string | null;
        chartTypes: Array<ChartType>;
        meta?: { __typename?: 'DeviceMeta'; name?: string | null } | null;
        alertTypes?: {
          __typename?: 'DeviceAlertTypes';
          deviceOffline?: boolean | null;
          sourceOffline?: boolean | null;
        } | null;
      }
    | {
        __typename: 'Z210Pump';
        deviceId?: string | null;
        name?: string | null;
        type?: EnumDKeyDeviceType | null;
        typeDisplayName: string;
        isConfigured?: boolean | null;
        zoneId?: string | null;
        panelId?: string | null;
        vppId?: string | null;
        chartTypes: Array<ChartType>;
        meta?: { __typename?: 'DeviceMeta'; name?: string | null } | null;
        alertTypes?: {
          __typename?: 'DeviceAlertTypes';
          deviceOffline?: boolean | null;
          sourceOffline?: boolean | null;
        } | null;
      }
  >;
  unitById?: {
    __typename?: 'Unit';
    _id: string;
    name: string;
    zones: Array<{
      __typename?: 'Zone';
      _id: string;
      name: string;
      role?: string | null;
      displayName?: string | null;
    } | null>;
    panels: Array<{
      __typename?: 'Panel';
      _id: string;
      name?: string | null;
      role?: string | null;
      type: EnumPanelType;
      displayName?: string | null;
    } | null>;
    controlGroups: Array<{
      __typename?: 'ControlGroup';
      _id: string;
      name: string;
      type: string;
      automationEnabled?: boolean | null;
      masterDeviceId?: string | null;
      attributes: any;
      deviceDetails?: any | null;
      masterDevice?: {
        __typename?: 'Device';
        _id: string;
        deviceId?: string | null;
        type?: EnumDKeyDeviceType | null;
      } | null;
      devices: Array<{
        __typename?: 'Device';
        _id: string;
        deviceId?: string | null;
        type?: EnumDKeyDeviceType | null;
      }>;
    } | null>;
  } | null;
};

export type UnitListByPropertyIdQueryVariables = Exact<{
  propertyId?: InputMaybe<Scalars['String']>;
}>;

export type UnitListByPropertyIdQuery = {
  __typename?: 'Query';
  unitsByPropertyId: Array<{
    __typename?: 'Unit';
    _id: string;
    name: string;
    type: string;
    buildingId: string;
    floorId?: string | null;
    isConnected?: boolean | null;
    hasAlerts?: boolean | null;
    hasResident?: boolean | null;
    temperature?: number | null;
    humidity?: number | null;
    coolSetpoint?: number | null;
    heatSetpoint?: number | null;
    setpoint?: number | null;
    operatingMode?: string | null;
    operatingState?: string | null;
    separatePowerThermostatIds: Array<string>;
    building?: { __typename?: 'Building'; name: string } | null;
    floor?: { __typename?: 'Floor'; name: string } | null;
    panels: Array<{
      __typename?: 'Panel';
      _id: string;
      type: EnumPanelType;
    } | null>;
    alertTypes?: {
      __typename?: 'UnitAlertTypes';
      sourceOffline?: boolean | null;
      deviceAlert?: boolean | null;
      deviceMetric?: boolean | null;
      deviceOffline?: boolean | null;
    } | null;
    devicesSummary?: {
      __typename?: 'UnitDevicesSummary';
      count?: number | null;
      majorAlerts?: number | null;
      minorAlerts?: number | null;
      proxy?: {
        __typename?: 'UnitDevicesSummaryProxy';
        coolSetpoint?: number | null;
        heatSetpoint?: number | null;
        humidity?: number | null;
        isOffline?: boolean | null;
        operatingMode?: string | null;
        operatingState?: string | null;
        setpointCoolMin?: number | null;
        setpointHeatMax?: number | null;
        setpointProfileName?: string | null;
        setpointProfileType?: string | null;
        temperature?: number | null;
        type?: string | null;
      } | null;
    } | null;
    devices: Array<
      | {
          __typename?: 'Actuator';
          _id: string;
          type?: EnumDKeyDeviceType | null;
          panelId?: string | null;
          sourceId?: string | null;
          deviceId?: string | null;
          installation?: {
            __typename?: 'DeviceInstallation';
            status: number;
          } | null;
        }
      | {
          __typename?: 'BatteryManagementSystem';
          _id: string;
          type?: EnumDKeyDeviceType | null;
          panelId?: string | null;
          sourceId?: string | null;
          deviceId?: string | null;
          installation?: {
            __typename?: 'DeviceInstallation';
            status: number;
          } | null;
        }
      | {
          __typename?: 'Boiler';
          _id: string;
          type?: EnumDKeyDeviceType | null;
          panelId?: string | null;
          sourceId?: string | null;
          deviceId?: string | null;
          installation?: {
            __typename?: 'DeviceInstallation';
            status: number;
          } | null;
        }
      | {
          __typename?: 'Chiller';
          _id: string;
          type?: EnumDKeyDeviceType | null;
          panelId?: string | null;
          sourceId?: string | null;
          deviceId?: string | null;
          installation?: {
            __typename?: 'DeviceInstallation';
            status: number;
          } | null;
        }
      | {
          __typename?: 'ConductorGenericSensor';
          _id: string;
          type?: EnumDKeyDeviceType | null;
          panelId?: string | null;
          sourceId?: string | null;
          deviceId?: string | null;
          installation?: {
            __typename?: 'DeviceInstallation';
            status: number;
          } | null;
        }
      | {
          __typename?: 'Controller';
          _id: string;
          type?: EnumDKeyDeviceType | null;
          panelId?: string | null;
          sourceId?: string | null;
          deviceId?: string | null;
          installation?: {
            __typename?: 'DeviceInstallation';
            status: number;
          } | null;
        }
      | {
          __typename?: 'Device';
          _id: string;
          type?: EnumDKeyDeviceType | null;
          panelId?: string | null;
          sourceId?: string | null;
          deviceId?: string | null;
          installation?: {
            __typename?: 'DeviceInstallation';
            status: number;
          } | null;
        }
      | {
          __typename?: 'DoorSensor';
          _id: string;
          type?: EnumDKeyDeviceType | null;
          panelId?: string | null;
          sourceId?: string | null;
          deviceId?: string | null;
          installation?: {
            __typename?: 'DeviceInstallation';
            status: number;
          } | null;
        }
      | {
          __typename?: 'EnergyController';
          _id: string;
          type?: EnumDKeyDeviceType | null;
          panelId?: string | null;
          sourceId?: string | null;
          deviceId?: string | null;
          installation?: {
            __typename?: 'DeviceInstallation';
            status: number;
          } | null;
        }
      | {
          __typename?: 'EnergyConverter';
          _id: string;
          type?: EnumDKeyDeviceType | null;
          panelId?: string | null;
          sourceId?: string | null;
          deviceId?: string | null;
          installation?: {
            __typename?: 'DeviceInstallation';
            status: number;
          } | null;
        }
      | {
          __typename?: 'EnergyInverter';
          _id: string;
          type?: EnumDKeyDeviceType | null;
          panelId?: string | null;
          sourceId?: string | null;
          deviceId?: string | null;
          installation?: {
            __typename?: 'DeviceInstallation';
            status: number;
          } | null;
        }
      | {
          __typename?: 'EnergyMeter';
          _id: string;
          type?: EnumDKeyDeviceType | null;
          panelId?: string | null;
          sourceId?: string | null;
          deviceId?: string | null;
          installation?: {
            __typename?: 'DeviceInstallation';
            status: number;
          } | null;
        }
      | {
          __typename?: 'EnergyRectifier';
          _id: string;
          type?: EnumDKeyDeviceType | null;
          panelId?: string | null;
          sourceId?: string | null;
          deviceId?: string | null;
          installation?: {
            __typename?: 'DeviceInstallation';
            status: number;
          } | null;
        }
      | {
          __typename?: 'EnergyStorageCoolingSystem';
          _id: string;
          type?: EnumDKeyDeviceType | null;
          panelId?: string | null;
          sourceId?: string | null;
          deviceId?: string | null;
          installation?: {
            __typename?: 'DeviceInstallation';
            status: number;
          } | null;
        }
      | {
          __typename?: 'EnergySwitchPanel';
          _id: string;
          type?: EnumDKeyDeviceType | null;
          panelId?: string | null;
          sourceId?: string | null;
          deviceId?: string | null;
          installation?: {
            __typename?: 'DeviceInstallation';
            status: number;
          } | null;
        }
      | {
          __typename?: 'EnergySwitchPanelCircuit';
          _id: string;
          type?: EnumDKeyDeviceType | null;
          panelId?: string | null;
          sourceId?: string | null;
          deviceId?: string | null;
          installation?: {
            __typename?: 'DeviceInstallation';
            status: number;
          } | null;
        }
      | {
          __typename?: 'FireSuppressionSystem';
          _id: string;
          type?: EnumDKeyDeviceType | null;
          panelId?: string | null;
          sourceId?: string | null;
          deviceId?: string | null;
          installation?: {
            __typename?: 'DeviceInstallation';
            status: number;
          } | null;
        }
      | {
          __typename?: 'GPIO';
          _id: string;
          type?: EnumDKeyDeviceType | null;
          panelId?: string | null;
          sourceId?: string | null;
          deviceId?: string | null;
          installation?: {
            __typename?: 'DeviceInstallation';
            status: number;
          } | null;
        }
      | {
          __typename?: 'IndoorAirHandler';
          _id: string;
          type?: EnumDKeyDeviceType | null;
          panelId?: string | null;
          sourceId?: string | null;
          deviceId?: string | null;
          installation?: {
            __typename?: 'DeviceInstallation';
            status: number;
          } | null;
        }
      | {
          __typename?: 'IndoorSensor';
          _id: string;
          type?: EnumDKeyDeviceType | null;
          panelId?: string | null;
          sourceId?: string | null;
          deviceId?: string | null;
          installation?: {
            __typename?: 'DeviceInstallation';
            status: number;
          } | null;
        }
      | {
          __typename?: 'KineticEnergyManagementSystem';
          _id: string;
          type?: EnumDKeyDeviceType | null;
          panelId?: string | null;
          sourceId?: string | null;
          deviceId?: string | null;
          installation?: {
            __typename?: 'DeviceInstallation';
            status: number;
          } | null;
        }
      | {
          __typename?: 'LeakDetector';
          _id: string;
          type?: EnumDKeyDeviceType | null;
          panelId?: string | null;
          sourceId?: string | null;
          deviceId?: string | null;
          installation?: {
            __typename?: 'DeviceInstallation';
            status: number;
          } | null;
        }
      | {
          __typename?: 'Loop';
          _id: string;
          type?: EnumDKeyDeviceType | null;
          panelId?: string | null;
          sourceId?: string | null;
          deviceId?: string | null;
          installation?: {
            __typename?: 'DeviceInstallation';
            status: number;
          } | null;
        }
      | {
          __typename?: 'ModbusAirHandler';
          _id: string;
          type?: EnumDKeyDeviceType | null;
          panelId?: string | null;
          sourceId?: string | null;
          deviceId?: string | null;
          installation?: {
            __typename?: 'DeviceInstallation';
            status: number;
          } | null;
        }
      | {
          __typename?: 'OccupancySensor';
          _id: string;
          type?: EnumDKeyDeviceType | null;
          panelId?: string | null;
          sourceId?: string | null;
          deviceId?: string | null;
          installation?: {
            __typename?: 'DeviceInstallation';
            status: number;
          } | null;
        }
      | {
          __typename?: 'OpenWeather';
          _id: string;
          type?: EnumDKeyDeviceType | null;
          panelId?: string | null;
          sourceId?: string | null;
          deviceId?: string | null;
          installation?: {
            __typename?: 'DeviceInstallation';
            status: number;
          } | null;
        }
      | {
          __typename?: 'OutdoorSensor';
          _id: string;
          type?: EnumDKeyDeviceType | null;
          panelId?: string | null;
          sourceId?: string | null;
          deviceId?: string | null;
          installation?: {
            __typename?: 'DeviceInstallation';
            status: number;
          } | null;
        }
      | {
          __typename?: 'PowerMonitor';
          _id: string;
          type?: EnumDKeyDeviceType | null;
          panelId?: string | null;
          sourceId?: string | null;
          deviceId?: string | null;
          installation?: {
            __typename?: 'DeviceInstallation';
            status: number;
          } | null;
        }
      | {
          __typename?: 'PressureSensor';
          _id: string;
          type?: EnumDKeyDeviceType | null;
          panelId?: string | null;
          sourceId?: string | null;
          deviceId?: string | null;
          installation?: {
            __typename?: 'DeviceInstallation';
            status: number;
          } | null;
        }
      | {
          __typename?: 'RelayDevice';
          _id: string;
          type?: EnumDKeyDeviceType | null;
          panelId?: string | null;
          sourceId?: string | null;
          deviceId?: string | null;
          installation?: {
            __typename?: 'DeviceInstallation';
            status: number;
          } | null;
        }
      | {
          __typename?: 'SmartPowerOutlet';
          _id: string;
          type?: EnumDKeyDeviceType | null;
          panelId?: string | null;
          sourceId?: string | null;
          deviceId?: string | null;
          installation?: {
            __typename?: 'DeviceInstallation';
            status: number;
          } | null;
        }
      | {
          __typename?: 'SolarManagementSystem';
          _id: string;
          type?: EnumDKeyDeviceType | null;
          panelId?: string | null;
          sourceId?: string | null;
          deviceId?: string | null;
          installation?: {
            __typename?: 'DeviceInstallation';
            status: number;
          } | null;
        }
      | {
          __typename?: 'Thermistor';
          role?: string | null;
          _id: string;
          type?: EnumDKeyDeviceType | null;
          panelId?: string | null;
          sourceId?: string | null;
          deviceId?: string | null;
          temperature?: {
            __typename?: 'ThermistorTemperature';
            value?: number | null;
          } | null;
          installation?: {
            __typename?: 'DeviceInstallation';
            status: number;
          } | null;
        }
      | {
          __typename?: 'Thermostat';
          _id: string;
          type?: EnumDKeyDeviceType | null;
          panelId?: string | null;
          sourceId?: string | null;
          deviceId?: string | null;
          installation?: {
            __typename?: 'DeviceInstallation';
            status: number;
          } | null;
        }
      | {
          __typename?: 'VSDPump';
          _id: string;
          type?: EnumDKeyDeviceType | null;
          panelId?: string | null;
          sourceId?: string | null;
          deviceId?: string | null;
          installation?: {
            __typename?: 'DeviceInstallation';
            status: number;
          } | null;
        }
      | {
          __typename?: 'WindManagementSystem';
          _id: string;
          type?: EnumDKeyDeviceType | null;
          panelId?: string | null;
          sourceId?: string | null;
          deviceId?: string | null;
          installation?: {
            __typename?: 'DeviceInstallation';
            status: number;
          } | null;
        }
      | {
          __typename?: 'WindowSensor';
          _id: string;
          type?: EnumDKeyDeviceType | null;
          panelId?: string | null;
          sourceId?: string | null;
          deviceId?: string | null;
          installation?: {
            __typename?: 'DeviceInstallation';
            status: number;
          } | null;
        }
      | {
          __typename?: 'Z210Pump';
          _id: string;
          type?: EnumDKeyDeviceType | null;
          panelId?: string | null;
          sourceId?: string | null;
          deviceId?: string | null;
          installation?: {
            __typename?: 'DeviceInstallation';
            status: number;
          } | null;
        }
    >;
  }>;
};

export type UnitListBuildingLoopsQueryVariables = Exact<{
  propertyId: Scalars['String'];
}>;

export type UnitListBuildingLoopsQuery = {
  __typename?: 'Query';
  panels: Array<{
    __typename?: 'Panel';
    _id: string;
    type: EnumPanelType;
    role?: string | null;
    unitId: string;
    devices: Array<
      | {
          __typename: 'Actuator';
          _id: string;
          deviceId?: string | null;
          type?: EnumDKeyDeviceType | null;
        }
      | {
          __typename: 'BatteryManagementSystem';
          _id: string;
          deviceId?: string | null;
          type?: EnumDKeyDeviceType | null;
        }
      | {
          __typename: 'Boiler';
          _id: string;
          deviceId?: string | null;
          type?: EnumDKeyDeviceType | null;
        }
      | {
          __typename: 'Chiller';
          _id: string;
          deviceId?: string | null;
          type?: EnumDKeyDeviceType | null;
        }
      | {
          __typename: 'ConductorGenericSensor';
          _id: string;
          deviceId?: string | null;
          type?: EnumDKeyDeviceType | null;
        }
      | {
          __typename: 'Controller';
          _id: string;
          deviceId?: string | null;
          type?: EnumDKeyDeviceType | null;
        }
      | {
          __typename: 'Device';
          _id: string;
          deviceId?: string | null;
          type?: EnumDKeyDeviceType | null;
        }
      | {
          __typename: 'DoorSensor';
          _id: string;
          deviceId?: string | null;
          type?: EnumDKeyDeviceType | null;
        }
      | {
          __typename: 'EnergyController';
          _id: string;
          deviceId?: string | null;
          type?: EnumDKeyDeviceType | null;
        }
      | {
          __typename: 'EnergyConverter';
          _id: string;
          deviceId?: string | null;
          type?: EnumDKeyDeviceType | null;
        }
      | {
          __typename: 'EnergyInverter';
          _id: string;
          deviceId?: string | null;
          type?: EnumDKeyDeviceType | null;
        }
      | {
          __typename: 'EnergyMeter';
          _id: string;
          deviceId?: string | null;
          type?: EnumDKeyDeviceType | null;
        }
      | {
          __typename: 'EnergyRectifier';
          _id: string;
          deviceId?: string | null;
          type?: EnumDKeyDeviceType | null;
        }
      | {
          __typename: 'EnergyStorageCoolingSystem';
          _id: string;
          deviceId?: string | null;
          type?: EnumDKeyDeviceType | null;
        }
      | {
          __typename: 'EnergySwitchPanel';
          _id: string;
          deviceId?: string | null;
          type?: EnumDKeyDeviceType | null;
        }
      | {
          __typename: 'EnergySwitchPanelCircuit';
          _id: string;
          deviceId?: string | null;
          type?: EnumDKeyDeviceType | null;
        }
      | {
          __typename: 'FireSuppressionSystem';
          _id: string;
          deviceId?: string | null;
          type?: EnumDKeyDeviceType | null;
        }
      | {
          __typename: 'GPIO';
          _id: string;
          deviceId?: string | null;
          type?: EnumDKeyDeviceType | null;
        }
      | {
          __typename: 'IndoorAirHandler';
          _id: string;
          deviceId?: string | null;
          type?: EnumDKeyDeviceType | null;
        }
      | {
          __typename: 'IndoorSensor';
          _id: string;
          deviceId?: string | null;
          type?: EnumDKeyDeviceType | null;
        }
      | {
          __typename: 'KineticEnergyManagementSystem';
          _id: string;
          deviceId?: string | null;
          type?: EnumDKeyDeviceType | null;
        }
      | {
          __typename: 'LeakDetector';
          _id: string;
          deviceId?: string | null;
          type?: EnumDKeyDeviceType | null;
        }
      | {
          __typename: 'Loop';
          _id: string;
          deviceId?: string | null;
          type?: EnumDKeyDeviceType | null;
        }
      | {
          __typename: 'ModbusAirHandler';
          _id: string;
          deviceId?: string | null;
          type?: EnumDKeyDeviceType | null;
        }
      | {
          __typename: 'OccupancySensor';
          _id: string;
          deviceId?: string | null;
          type?: EnumDKeyDeviceType | null;
        }
      | {
          __typename: 'OpenWeather';
          _id: string;
          deviceId?: string | null;
          type?: EnumDKeyDeviceType | null;
        }
      | {
          __typename: 'OutdoorSensor';
          _id: string;
          deviceId?: string | null;
          type?: EnumDKeyDeviceType | null;
        }
      | {
          __typename: 'PowerMonitor';
          _id: string;
          deviceId?: string | null;
          type?: EnumDKeyDeviceType | null;
        }
      | {
          __typename: 'PressureSensor';
          _id: string;
          deviceId?: string | null;
          type?: EnumDKeyDeviceType | null;
        }
      | {
          __typename: 'RelayDevice';
          _id: string;
          deviceId?: string | null;
          type?: EnumDKeyDeviceType | null;
        }
      | {
          __typename: 'SmartPowerOutlet';
          _id: string;
          deviceId?: string | null;
          type?: EnumDKeyDeviceType | null;
        }
      | {
          __typename: 'SolarManagementSystem';
          _id: string;
          deviceId?: string | null;
          type?: EnumDKeyDeviceType | null;
        }
      | {
          __typename: 'Thermistor';
          role?: string | null;
          _id: string;
          deviceId?: string | null;
          type?: EnumDKeyDeviceType | null;
          temperature?: {
            __typename?: 'ThermistorTemperature';
            value?: number | null;
          } | null;
        }
      | {
          __typename: 'Thermostat';
          _id: string;
          deviceId?: string | null;
          type?: EnumDKeyDeviceType | null;
        }
      | {
          __typename: 'VSDPump';
          _id: string;
          deviceId?: string | null;
          type?: EnumDKeyDeviceType | null;
        }
      | {
          __typename: 'WindManagementSystem';
          _id: string;
          deviceId?: string | null;
          type?: EnumDKeyDeviceType | null;
        }
      | {
          __typename: 'WindowSensor';
          _id: string;
          deviceId?: string | null;
          type?: EnumDKeyDeviceType | null;
        }
      | {
          __typename: 'Z210Pump';
          _id: string;
          deviceId?: string | null;
          type?: EnumDKeyDeviceType | null;
        }
    >;
  }>;
};

export type UnitListUpdateSubscriptionVariables = Exact<{
  propertyId: Scalars['String'];
}>;

export type UnitListUpdateSubscription = {
  __typename?: 'Subscription';
  unitEventsByPropertyId?: {
    __typename?: 'Unit';
    modelChangeOperation?: string | null;
    _id: string;
    separatePowerThermostatIds: Array<string>;
    hasAlerts?: boolean | null;
    name: string;
    type: string;
    hasResident?: boolean | null;
    temperature?: number | null;
    humidity?: number | null;
    coolSetpoint?: number | null;
    heatSetpoint?: number | null;
    setpoint?: number | null;
    operatingMode?: string | null;
    operatingState?: string | null;
    devicesSummary?: {
      __typename?: 'UnitDevicesSummary';
      proxy?: {
        __typename?: 'UnitDevicesSummaryProxy';
        coolSetpoint?: number | null;
        heatSetpoint?: number | null;
        humidity?: number | null;
        setpointProfileName?: string | null;
      } | null;
    } | null;
    alertTypes?: {
      __typename?: 'UnitAlertTypes';
      sourceOffline?: boolean | null;
      deviceMetric?: boolean | null;
      deviceOffline?: boolean | null;
      deviceAlert?: boolean | null;
      equipmentAlarm?: boolean | null;
    } | null;
  } | null;
};

export type UnitPowerUpdateSubscriptionVariables = Exact<{
  ids: Array<Scalars['String']> | Scalars['String'];
}>;

export type UnitPowerUpdateSubscription = {
  __typename?: 'Subscription';
  thermostatEventsByIds?: {
    __typename?: 'Thermostat';
    modelChangeOperation?: string | null;
    _id: string;
    updateDescription?: any | null;
    powerState?: {
      __typename?: 'DevicePowerState';
      value?: EnumDevicePowerStateValue | null;
    } | null;
    operatingMode?: {
      __typename?: 'ThermostatOperatingMode';
      value?: EnumThermostatOperatingModeValue | null;
    } | null;
    operatingState?: {
      __typename?: 'ThermostatOperatingState';
      value?: EnumThermostatOperatingStateValue | null;
    } | null;
    setpoint?: {
      __typename?: 'ThermostatSetpoint';
      value?: number | null;
    } | null;
  } | null;
};

export type UnitScheduleDetailUpdateSubscriptionVariables = Exact<{
  ids?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
}>;

export type UnitScheduleDetailUpdateSubscription = {
  __typename?: 'Subscription';
  unitEventsByIds?: {
    __typename?: 'Unit';
    _id: string;
    name: string;
    property?: { __typename?: 'Property'; _id: string; title: string } | null;
    zones: Array<{
      __typename?: 'Zone';
      _id: string;
      name: string;
      thermostat?: {
        __typename?: 'Thermostat';
        name?: string | null;
        deviceId?: string | null;
        _id: string;
        scheduleStatus?: string | null;
        scheduleType?: EnumScheduleType | null;
        thermostatScheduleTemplateId?: string | null;
        schedule?: {
          __typename?: 'ThermostatSchedule';
          id?: string | null;
          timestamp?: number | null;
          value?: any | null;
        } | null;
        pendingSchedule?: {
          __typename?: 'ThermostatPendingSchedule';
          id?: string | null;
          timestamp?: number | null;
          value?: any | null;
        } | null;
      } | null;
    } | null>;
  } | null;
};

export type UnitScheduleDetailQueryVariables = Exact<{
  id: Scalars['String'];
}>;

export type UnitScheduleDetailQuery = {
  __typename?: 'Query';
  unitById?: {
    __typename?: 'Unit';
    _id: string;
    name: string;
    property?: { __typename?: 'Property'; _id: string; title: string } | null;
    zones: Array<{
      __typename?: 'Zone';
      _id: string;
      name: string;
      thermostat?: {
        __typename?: 'Thermostat';
        name?: string | null;
        deviceId?: string | null;
        _id: string;
        scheduleStatus?: string | null;
        scheduleType?: EnumScheduleType | null;
        thermostatScheduleTemplateId?: string | null;
        schedule?: {
          __typename?: 'ThermostatSchedule';
          id?: string | null;
          timestamp?: number | null;
          value?: any | null;
        } | null;
        pendingSchedule?: {
          __typename?: 'ThermostatPendingSchedule';
          id?: string | null;
          timestamp?: number | null;
          value?: any | null;
        } | null;
      } | null;
    } | null>;
  } | null;
};

export type UpdateUnitMutationVariables = Exact<{
  id: Scalars['String'];
  unit: UpdateOneUnitInput;
}>;

export type UpdateUnitMutation = {
  __typename?: 'Mutation';
  updateUnit: {
    __typename?: 'Unit';
    _id: string;
    name: string;
    type: string;
    buildingId: string;
    sourceId?: string | null;
  };
};

export type UpdateDeviceHistoryMutationVariables = Exact<{
  userId: Scalars['String'];
  history: Scalars['JSON'];
}>;

export type UpdateDeviceHistoryMutation = {
  __typename?: 'Mutation';
  updateDeviceHistory?: {
    __typename?: 'UserHistory';
    _id: string;
    currentIndex: number;
    lastAccessedAt: number;
  } | null;
};

export type GetUserAbilitiesQueryVariables = Exact<{ [key: string]: never }>;

export type GetUserAbilitiesQuery = {
  __typename?: 'Query';
  userAbilities: {
    __typename?: 'UserAbilities';
    rules: Array<{
      __typename?: 'AbilityRule';
      action: string;
      subject: string;
      conditions?: any | null;
      inverted: boolean;
      reason?: string | null;
    }>;
  };
};

export type CreateUserApiTokenMutationVariables = Exact<{
  userId: Scalars['String'];
}>;

export type CreateUserApiTokenMutation = {
  __typename?: 'Mutation';
  createUserApiKey?: {
    __typename?: 'User';
    _id: string;
    name: string;
    email?: string | null;
    authorizationProfile?: {
      __typename?: 'AuthorizationProfile';
      _id: string;
      isSuper?: boolean | null;
      isManager?: boolean | null;
      isResident?: boolean | null;
      isInstaller?: boolean | null;
      isViewer?: boolean | null;
      managerProperties: Array<string | null>;
      residentUnit?: string | null;
      residentProperty?: string | null;
      installerProperties?: Array<string | null> | null;
      viewerProperties?: Array<string | null> | null;
      apiToken?: string | null;
    } | null;
  } | null;
};

export type CreateUserMutationVariables = Exact<{
  user: CreateOneUserInput;
  profile: CreateOneAuthorizationProfileInput;
}>;

export type CreateUserMutation = {
  __typename?: 'Mutation';
  createUser?: {
    __typename?: 'User';
    _id: string;
    name: string;
    email?: string | null;
    authorizationProfile?: {
      __typename?: 'AuthorizationProfile';
      _id: string;
      isSuper?: boolean | null;
      isManager?: boolean | null;
      isResident?: boolean | null;
      isInstaller?: boolean | null;
      isViewer?: boolean | null;
      managerProperties: Array<string | null>;
      residentUnit?: string | null;
      residentProperty?: string | null;
      installerProperties?: Array<string | null> | null;
      viewerProperties?: Array<string | null> | null;
      apiToken?: string | null;
    } | null;
  } | null;
};

export type RemoveUserMutationVariables = Exact<{
  userId: Scalars['String'];
}>;

export type RemoveUserMutation = {
  __typename?: 'Mutation';
  removeUser: string;
};

export type RevokeUserApiTokenMutationVariables = Exact<{
  userId: Scalars['String'];
}>;

export type RevokeUserApiTokenMutation = {
  __typename?: 'Mutation';
  revokeUserApiKey?: {
    __typename?: 'User';
    _id: string;
    name: string;
    email?: string | null;
    authorizationProfile?: {
      __typename?: 'AuthorizationProfile';
      _id: string;
      isSuper?: boolean | null;
      isManager?: boolean | null;
      isResident?: boolean | null;
      isInstaller?: boolean | null;
      isViewer?: boolean | null;
      managerProperties: Array<string | null>;
      residentUnit?: string | null;
      residentProperty?: string | null;
      installerProperties?: Array<string | null> | null;
      viewerProperties?: Array<string | null> | null;
      apiToken?: string | null;
    } | null;
  } | null;
};

export type UnlockUserMutationVariables = Exact<{
  userId: Scalars['String'];
}>;

export type UnlockUserMutation = {
  __typename?: 'Mutation';
  unlockUser: boolean;
};

export type UpdateUserMutationVariables = Exact<{
  userId: Scalars['String'];
  user: UpdateOneUserInput;
  profile?: InputMaybe<UpdateOneAuthorizationProfileInput>;
}>;

export type UpdateUserMutation = {
  __typename?: 'Mutation';
  updateUser?: {
    __typename?: 'User';
    _id: string;
    name: string;
    email?: string | null;
    preferredUnits: TemperatureUnit;
    preferredAirFlowUnits: AirFlowUnit;
    authorizationProfile?: {
      __typename?: 'AuthorizationProfile';
      _id: string;
      isSuper?: boolean | null;
      isManager?: boolean | null;
      isResident?: boolean | null;
      isInstaller?: boolean | null;
      isViewer?: boolean | null;
      managerProperties: Array<string | null>;
      residentUnit?: string | null;
      residentProperty?: string | null;
      installerProperties?: Array<string | null> | null;
      viewerProperties?: Array<string | null> | null;
      apiToken?: string | null;
    } | null;
  } | null;
};

export type UpdateUserIdentificationMutationVariables = Exact<{
  userId: Scalars['String'];
  name: Scalars['String'];
  email: Scalars['String'];
  mobile: Scalars['String'];
  preferredUnits: TemperatureUnit;
  preferredAirFlowUnits: AirFlowUnit;
}>;

export type UpdateUserIdentificationMutation = {
  __typename?: 'Mutation';
  updateUserIdentification?: {
    __typename?: 'User';
    _id: string;
    name: string;
    email?: string | null;
    mobile?: string | null;
    preferredUnits: TemperatureUnit;
    preferredAirFlowUnits: AirFlowUnit;
    authorizationProfile?: {
      __typename?: 'AuthorizationProfile';
      _id: string;
      apiToken?: string | null;
    } | null;
    profile?: {
      __typename?: 'UserProfile';
      mobile?: string | null;
      preferredUnits?: EnumUserProfilePreferredUnits | null;
      preferredAirFlowUnits?: EnumUserProfilePreferredAirFlowUnits | null;
      smsOptInStatusTimestamp?: number | null;
      smsOptInStatus?: string | null;
    } | null;
    editableAuthenticationProfile?: {
      __typename?: 'AuthenticationProfile';
      _id: string;
      factors?: Array<{
        __typename?: 'AuthenticationProfileFactors';
        _id?: string | null;
        externalId?: string | null;
        type: EnumAuthenticationProfileFactorsType;
        credentialBoundTo?: string | null;
        name?: string | null;
        value?: string | null;
        preferred?: boolean | null;
        primary?: boolean | null;
        sufficient?: boolean | null;
        order: number;
      } | null> | null;
    } | null;
  } | null;
};

export type UserCountQueryVariables = Exact<{ [key: string]: never }>;

export type UserCountQuery = {
  __typename?: 'Query';
  userCount?: number | null;
};

export type UserDetailQueryVariables = Exact<{
  userId: Scalars['String'];
}>;

export type UserDetailQuery = {
  __typename?: 'Query';
  userById?: {
    __typename?: 'User';
    _id: string;
    email?: string | null;
    mobile?: string | null;
    name: string;
    state?: string | null;
    preferredUnits: TemperatureUnit;
    preferredAirFlowUnits: AirFlowUnit;
    smsOptInStatus?: string | null;
    smsOptInStatusTimestamp?: number | null;
    legacyAuthorizationProfile?: {
      __typename?: 'AuthorizationProfile';
      _id: string;
      isSuper?: boolean | null;
      isManager?: boolean | null;
      isResident?: boolean | null;
      isInstaller?: boolean | null;
      isViewer?: boolean | null;
      managerProperties: Array<string | null>;
      installerProperties?: Array<string | null> | null;
      viewerProperties?: Array<string | null> | null;
      residentProperty?: string | null;
      residentUnit?: string | null;
      apiToken?: string | null;
    } | null;
    editableAuthenticationProfile?: {
      __typename?: 'AuthenticationProfile';
      _id: string;
      userId: string;
      lockedAt?: number | null;
      failedAttempts?: number | null;
    } | null;
  } | null;
};

export type UserDetailBreadcrumbQueryVariables = Exact<{
  id: Scalars['String'];
}>;

export type UserDetailBreadcrumbQuery = {
  __typename?: 'Query';
  userById?: {
    __typename?: 'User';
    _id: string;
    email?: string | null;
    name: string;
    state?: string | null;
  } | null;
};

export type UserListQueryVariables = Exact<{ [key: string]: never }>;

export type UserListQuery = {
  __typename?: 'Query';
  users: Array<{
    __typename?: 'User';
    _id: string;
    email?: string | null;
    name: string;
    state?: string | null;
    preferredUnits: TemperatureUnit;
    preferredAirFlowUnits: AirFlowUnit;
    authorizationProfile?: {
      __typename?: 'AuthorizationProfile';
      _id: string;
      apiToken?: string | null;
    } | null;
  }>;
};

export type UserListUpdateSubscriptionVariables = Exact<{
  [key: string]: never;
}>;

export type UserListUpdateSubscription = {
  __typename?: 'Subscription';
  userEvents?: {
    __typename?: 'User';
    modelChangeOperation?: string | null;
    _id: string;
    email?: string | null;
    name: string;
    state?: string | null;
    preferredUnits: TemperatureUnit;
    preferredAirFlowUnits: AirFlowUnit;
    authorizationProfile?: {
      __typename?: 'AuthorizationProfile';
      _id: string;
      apiToken?: string | null;
    } | null;
  } | null;
};

export type AddPasskeyMutationVariables = Exact<{
  userId: Scalars['String'];
  name: Scalars['String'];
  preferred: Scalars['Boolean'];
  data: Scalars['String'];
  credentialIsExternal: Scalars['Boolean'];
  enforceUserVerification: Scalars['Boolean'];
  credentialOS: Scalars['String'];
  credentialBoundTo: Scalars['String'];
}>;

export type AddPasskeyMutation = {
  __typename?: 'Mutation';
  addPasskey?: {
    __typename: 'AuthenticationProfile';
    _id: string;
    factors?: Array<{
      __typename?: 'AuthenticationProfileFactors';
      name?: string | null;
      _id?: string | null;
      externalId?: string | null;
      type: EnumAuthenticationProfileFactorsType;
      preferred?: boolean | null;
    } | null> | null;
  } | null;
};

export type ChangePasswordMutationVariables = Exact<{
  userId: Scalars['String'];
  oldPassword: Scalars['String'];
  newPassword: Scalars['String'];
  confirmPassword: Scalars['String'];
}>;

export type ChangePasswordMutation = {
  __typename?: 'Mutation';
  changePassword?: {
    __typename?: 'User';
    _id: string;
    name: string;
    email?: string | null;
    authorizationProfile?: {
      __typename?: 'AuthorizationProfile';
      apiToken?: string | null;
    } | null;
    editableAuthenticationProfile?: {
      __typename?: 'AuthenticationProfile';
      _id: string;
      factors?: Array<{
        __typename?: 'AuthenticationProfileFactors';
        _id?: string | null;
        externalId?: string | null;
        type: EnumAuthenticationProfileFactorsType;
        credentialBoundTo?: string | null;
        name?: string | null;
        value?: string | null;
        preferred?: boolean | null;
        primary?: boolean | null;
        sufficient?: boolean | null;
        order: number;
      } | null> | null;
    } | null;
  } | null;
};

export type CurrentUserDetailSubscriptionVariables = Exact<{
  userId: Scalars['String'];
}>;

export type CurrentUserDetailSubscription = {
  __typename?: 'Subscription';
  userEventsByIds?: {
    __typename?: 'User';
    modelChangeOperation?: string | null;
    _id: string;
    email?: string | null;
    mobile?: string | null;
    name: string;
    state?: string | null;
    preferredUnits: TemperatureUnit;
    preferredAirFlowUnits: AirFlowUnit;
    legacyAuthorizationProfile?: {
      __typename?: 'AuthorizationProfile';
      _id: string;
      isSuper?: boolean | null;
      isManager?: boolean | null;
      isResident?: boolean | null;
      isInstaller?: boolean | null;
      isViewer?: boolean | null;
      managerProperties: Array<string | null>;
      installerProperties?: Array<string | null> | null;
      viewerProperties?: Array<string | null> | null;
      residentProperty?: string | null;
      residentUnit?: string | null;
      apiToken?: string | null;
    } | null;
  } | null;
};

export type InitatePasswordResetManagerMutationVariables = Exact<{
  userId: Scalars['String'];
}>;

export type InitatePasswordResetManagerMutation = {
  __typename?: 'Mutation';
  initatePasswordReset: boolean;
};

export type RemovePasskeyMutationVariables = Exact<{
  userId: Scalars['String'];
  factorId: Scalars['String'];
}>;

export type RemovePasskeyMutation = {
  __typename?: 'Mutation';
  removePasskey?: {
    __typename: 'AuthenticationProfile';
    _id: string;
    factors?: Array<{
      __typename?: 'AuthenticationProfileFactors';
      name?: string | null;
      _id?: string | null;
      externalId?: string | null;
      type: EnumAuthenticationProfileFactorsType;
    } | null> | null;
  } | null;
};

export type UpdatePasskeyMutationVariables = Exact<{
  userId: Scalars['String'];
  factorId: Scalars['String'];
  name: Scalars['String'];
  preferred: Scalars['Boolean'];
  enforceUserVerification: Scalars['Boolean'];
}>;

export type UpdatePasskeyMutation = {
  __typename?: 'Mutation';
  updatePasskey?: {
    __typename: 'AuthenticationProfile';
    _id: string;
    factors?: Array<{
      __typename?: 'AuthenticationProfileFactors';
      name?: string | null;
      _id?: string | null;
      externalId?: string | null;
      type: EnumAuthenticationProfileFactorsType;
      preferred?: boolean | null;
    } | null> | null;
  } | null;
};

export type UpdateEmailAuthorizationMutationVariables = Exact<{
  userId: Scalars['String'];
  isAuthorized: Scalars['Boolean'];
}>;

export type UpdateEmailAuthorizationMutation = {
  __typename?: 'Mutation';
  updateEmailAuthorization?: {
    __typename?: 'User';
    _id: string;
    emailOptInStatus?: string | null;
    emailOptInStatusTimestamp?: number | null;
  } | null;
};

export type UpdateSmsAuthorizationMutationVariables = Exact<{
  userId: Scalars['String'];
  smsMobile: Scalars['String'];
  isAuthorized: Scalars['Boolean'];
}>;

export type UpdateSmsAuthorizationMutation = {
  __typename?: 'Mutation';
  updateSmsAuthorization?: {
    __typename?: 'User';
    _id: string;
    mobile?: string | null;
    smsOptInStatus?: string | null;
    smsOptInStatusTimestamp?: number | null;
  } | null;
};

export type UserProfileAlertChangesSubscriptionVariables = Exact<{
  userId: Scalars['String'];
}>;

export type UserProfileAlertChangesSubscription = {
  __typename?: 'Subscription';
  userEventsByIds?: {
    __typename?: 'User';
    modelChangeOperation?: string | null;
    _id: string;
    email?: string | null;
    mobile?: string | null;
    preferredUnits: TemperatureUnit;
    preferredAirFlowUnits: AirFlowUnit;
    name: string;
    state?: string | null;
    emailOptInStatus?: string | null;
    emailOptInStatusTimestamp?: number | null;
    smsOptInStatus?: string | null;
    smsOptInStatusTimestamp?: number | null;
    alertableProperties: Array<{
      __typename?: 'Property';
      _id: string;
      title: string;
      alertTriggers: Array<{
        __typename?: 'AlertTrigger';
        _id: string;
        name: string;
      } | null>;
    }>;
    profile?: {
      __typename?: 'UserProfile';
      mobile?: string | null;
      emailOptInStatus?: string | null;
      emailOptInStatusTimestamp?: number | null;
      smsOptInStatus?: string | null;
      smsOptInStatusTimestamp?: number | null;
      history?: string | null;
    } | null;
  } | null;
};

export type UserProfileQueryVariables = Exact<{
  userId: Scalars['String'];
}>;

export type UserProfileQuery = {
  __typename?: 'Query';
  userById?: {
    __typename?: 'User';
    _id: string;
    email?: string | null;
    mobile?: string | null;
    emailOptInStatus?: string | null;
    emailOptInStatusTimestamp?: number | null;
    smsOptInStatus?: string | null;
    smsOptInStatusTimestamp?: number | null;
    preferredUnits: TemperatureUnit;
    preferredAirFlowUnits: AirFlowUnit;
    name: string;
    state?: string | null;
    alertableProperties: Array<{
      __typename?: 'Property';
      _id: string;
      title: string;
      alertTriggers: Array<{
        __typename?: 'AlertTrigger';
        _id: string;
        name: string;
      } | null>;
    }>;
    editableAuthenticationProfile?: {
      __typename?: 'AuthenticationProfile';
      _id: string;
      factors?: Array<{
        __typename?: 'AuthenticationProfileFactors';
        _id?: string | null;
        externalId?: string | null;
        credentialBoundTo?: string | null;
        type: EnumAuthenticationProfileFactorsType;
        name?: string | null;
        value?: string | null;
        preferred?: boolean | null;
        primary?: boolean | null;
        sufficient?: boolean | null;
        order: number;
      } | null> | null;
      authenticatorDevices: Array<{
        __typename?: 'AuthenticatorDevice';
        _id: string;
        deviceName?: string | null;
        deviceType?: string | null;
        credentialType?: string | null;
        userVerified?: boolean | null;
        enforceUserVerification?: boolean | null;
        credentialIsExternal?: boolean | null;
        credentialOS?: EnumAuthenticatorDeviceCredentialOs | null;
        credentialEcosystem?: EnumAuthenticatorDeviceCredentialEcosystem | null;
        credentialBoundTo?: string | null;
        credentialDeviceType?: string | null;
        credentialBackedUp?: boolean | null;
        transports?: Array<string | null> | null;
        createdAt?: number | null;
        lastUsed?: number | null;
      } | null>;
    } | null;
    authorizationProfile?: {
      __typename?: 'AuthorizationProfile';
      _id: string;
      apiToken?: string | null;
    } | null;
    profile?: {
      __typename?: 'UserProfile';
      mobile?: string | null;
      emailOptInStatus?: string | null;
      emailOptInStatusTimestamp?: number | null;
      smsOptInStatus?: string | null;
      smsOptInStatusTimestamp?: number | null;
      history?: string | null;
    } | null;
  } | null;
};

export type UserProfilePasskeysQueryVariables = Exact<{
  userId: Scalars['String'];
}>;

export type UserProfilePasskeysQuery = {
  __typename?: 'Query';
  userById?: {
    __typename?: 'User';
    _id: string;
    editableAuthenticationProfile?: {
      __typename?: 'AuthenticationProfile';
      _id: string;
      factors?: Array<{
        __typename?: 'AuthenticationProfileFactors';
        _id?: string | null;
        externalId?: string | null;
        type: EnumAuthenticationProfileFactorsType;
        credentialBoundTo?: string | null;
        name?: string | null;
        value?: string | null;
        preferred?: boolean | null;
        primary?: boolean | null;
        sufficient?: boolean | null;
        order: number;
      } | null> | null;
      authenticatorDevices: Array<{
        __typename?: 'AuthenticatorDevice';
        _id: string;
        deviceName?: string | null;
        deviceType?: string | null;
        credentialType?: string | null;
        userVerified?: boolean | null;
        enforceUserVerification?: boolean | null;
        credentialIsExternal?: boolean | null;
        credentialOS?: EnumAuthenticatorDeviceCredentialOs | null;
        credentialEcosystem?: EnumAuthenticatorDeviceCredentialEcosystem | null;
        credentialBoundTo?: string | null;
        credentialDeviceType?: string | null;
        credentialBackedUp?: boolean | null;
        transports?: Array<string | null> | null;
        createdAt?: number | null;
        lastUsed?: number | null;
      } | null>;
    } | null;
  } | null;
};

export type UserProfilePasskeysChangesSubscriptionVariables = Exact<{
  userId: Scalars['String'];
}>;

export type UserProfilePasskeysChangesSubscription = {
  __typename?: 'Subscription';
  userEventsByIds?: {
    __typename?: 'User';
    modelChangeOperation?: string | null;
    _id: string;
    editableAuthenticationProfile?: {
      __typename?: 'AuthenticationProfile';
      _id: string;
      factors?: Array<{
        __typename?: 'AuthenticationProfileFactors';
        _id?: string | null;
        externalId?: string | null;
        type: EnumAuthenticationProfileFactorsType;
        credentialBoundTo?: string | null;
        name?: string | null;
        value?: string | null;
        preferred?: boolean | null;
        primary?: boolean | null;
        sufficient?: boolean | null;
        order: number;
      } | null> | null;
      authenticatorDevices: Array<{
        __typename?: 'AuthenticatorDevice';
        _id: string;
        deviceName?: string | null;
        deviceType?: string | null;
        credentialType?: string | null;
        userVerified?: boolean | null;
        enforceUserVerification?: boolean | null;
        credentialIsExternal?: boolean | null;
        credentialOS?: EnumAuthenticatorDeviceCredentialOs | null;
        credentialEcosystem?: EnumAuthenticatorDeviceCredentialEcosystem | null;
        credentialBoundTo?: string | null;
        credentialDeviceType?: string | null;
        credentialBackedUp?: boolean | null;
        transports?: Array<string | null> | null;
        createdAt?: number | null;
        lastUsed?: number | null;
      } | null>;
    } | null;
  } | null;
};

export type UserHistoryQueryVariables = Exact<{
  userId: Scalars['String'];
}>;

export type UserHistoryQuery = {
  __typename?: 'Query';
  userDeviceHistory?: {
    __typename?: 'UserHistory';
    _id: string;
    userId: string;
    deviceId: string;
    history?: any | null;
    currentIndex: number;
    lastAccessedAt: number;
  } | null;
};

export type UsersOptionsQueryVariables = Exact<{ [key: string]: never }>;

export type UsersOptionsQuery = {
  __typename?: 'Query';
  users: Array<{ __typename?: 'User'; _id: string; name: string }>;
};

export type BatteryManagementSystemDetailUpdatesSubscriptionVariables = Exact<{
  id: Scalars['String'];
}>;

export type BatteryManagementSystemDetailUpdatesSubscription = {
  __typename?: 'Subscription';
  batteryManagementSystemEventsByIds?: {
    __typename?: 'BatteryManagementSystem';
    modelChangeOperation?: string | null;
    _id: string;
    deviceId?: string | null;
    name?: string | null;
    type?: EnumDKeyDeviceType | null;
    location?: string | null;
    propertyId: string;
    unitId: string;
    panelId?: string | null;
    sourceId?: string | null;
    updateStatus?: boolean | null;
    timestamp?: number | null;
    typeDisplayName: string;
    isConfigured?: boolean | null;
    isPoweredOn?: boolean | null;
    deviceIdentifier?: string | null;
    hasPendingUpdates: boolean;
    isControlled: boolean;
    chartTypes: Array<ChartType>;
    inverterId?: string | null;
    meta?: {
      __typename?: 'DeviceMeta';
      name?: string | null;
      metrics?: any | null;
    } | null;
    installation?: {
      __typename?: 'DeviceInstallation';
      status: number;
      message?: string | null;
    } | null;
    powerState?: {
      __typename?: 'DevicePowerState';
      value?: EnumDevicePowerStateValue | null;
      timestamp?: number | null;
    } | null;
    voltage?: {
      __typename?: 'BatteryManagementSystemVoltage';
      value?: number | null;
      timestamp?: number | null;
      units?: string | null;
    } | null;
    current?: {
      __typename?: 'BatteryManagementSystemCurrent';
      value?: number | null;
      timestamp?: number | null;
      units?: string | null;
    } | null;
    temperature?: {
      __typename?: 'BatteryManagementSystemTemperature';
      value?: number | null;
      timestamp?: number | null;
      units?: string | null;
    } | null;
    stateOfCharge?: {
      __typename?: 'BatteryManagementSystemStateOfCharge';
      value?: number | null;
      timestamp?: number | null;
      units?: string | null;
    } | null;
    stateOfHealth?: {
      __typename?: 'BatteryManagementSystemStateOfHealth';
      value?: number | null;
      timestamp?: number | null;
      units?: string | null;
    } | null;
    batteryEfficiency?: {
      __typename?: 'BatteryManagementSystemBatteryEfficiency';
      value?: number | null;
      timestamp?: number | null;
      units?: string | null;
    } | null;
    cellVoltages?: Array<{
      __typename?: 'BatteryManagementSystemCellVoltages';
      value?: number | null;
      timestamp?: number | null;
      units?: string | null;
    } | null> | null;
    cellCurrents?: Array<{
      __typename?: 'BatteryManagementSystemCellCurrents';
      value?: number | null;
      timestamp?: number | null;
      units?: string | null;
    } | null> | null;
    cellTemperatures?: Array<{
      __typename?: 'BatteryManagementSystemCellTemperatures';
      value?: number | null;
      timestamp?: number | null;
      units?: string | null;
    } | null> | null;
    cellCycleCounts?: Array<{
      __typename?: 'BatteryManagementSystemCellCycleCounts';
      value?: number | null;
      timestamp?: number | null;
      units?: string | null;
    } | null> | null;
    property?: { __typename?: 'Property'; _id: string; title: string } | null;
    unit?: { __typename?: 'Unit'; _id: string; name: string } | null;
    panel?: {
      __typename?: 'Panel';
      _id: string;
      name?: string | null;
      displayName?: string | null;
    } | null;
    source?: { __typename?: 'Source'; _id: string; name: string } | null;
  } | null;
};

export type BatteryManagementSystemDetailQueryVariables = Exact<{
  id: Scalars['String'];
}>;

export type BatteryManagementSystemDetailQuery = {
  __typename?: 'Query';
  batteryManagementSystemById?: {
    __typename?: 'BatteryManagementSystem';
    _id: string;
    deviceId?: string | null;
    name?: string | null;
    type?: EnumDKeyDeviceType | null;
    location?: string | null;
    propertyId: string;
    unitId: string;
    panelId?: string | null;
    sourceId?: string | null;
    updateStatus?: boolean | null;
    timestamp?: number | null;
    typeDisplayName: string;
    isConfigured?: boolean | null;
    isPoweredOn?: boolean | null;
    deviceIdentifier?: string | null;
    hasPendingUpdates: boolean;
    isControlled: boolean;
    chartTypes: Array<ChartType>;
    inverterId?: string | null;
    meta?: {
      __typename?: 'DeviceMeta';
      name?: string | null;
      metrics?: any | null;
    } | null;
    installation?: {
      __typename?: 'DeviceInstallation';
      status: number;
      message?: string | null;
    } | null;
    powerState?: {
      __typename?: 'DevicePowerState';
      value?: EnumDevicePowerStateValue | null;
      timestamp?: number | null;
    } | null;
    voltage?: {
      __typename?: 'BatteryManagementSystemVoltage';
      value?: number | null;
      timestamp?: number | null;
      units?: string | null;
    } | null;
    current?: {
      __typename?: 'BatteryManagementSystemCurrent';
      value?: number | null;
      timestamp?: number | null;
      units?: string | null;
    } | null;
    temperature?: {
      __typename?: 'BatteryManagementSystemTemperature';
      value?: number | null;
      timestamp?: number | null;
      units?: string | null;
    } | null;
    stateOfCharge?: {
      __typename?: 'BatteryManagementSystemStateOfCharge';
      value?: number | null;
      timestamp?: number | null;
      units?: string | null;
    } | null;
    stateOfHealth?: {
      __typename?: 'BatteryManagementSystemStateOfHealth';
      value?: number | null;
      timestamp?: number | null;
      units?: string | null;
    } | null;
    batteryEfficiency?: {
      __typename?: 'BatteryManagementSystemBatteryEfficiency';
      value?: number | null;
      timestamp?: number | null;
      units?: string | null;
    } | null;
    cellVoltages?: Array<{
      __typename?: 'BatteryManagementSystemCellVoltages';
      value?: number | null;
      timestamp?: number | null;
      units?: string | null;
    } | null> | null;
    cellCurrents?: Array<{
      __typename?: 'BatteryManagementSystemCellCurrents';
      value?: number | null;
      timestamp?: number | null;
      units?: string | null;
    } | null> | null;
    cellTemperatures?: Array<{
      __typename?: 'BatteryManagementSystemCellTemperatures';
      value?: number | null;
      timestamp?: number | null;
      units?: string | null;
    } | null> | null;
    cellCycleCounts?: Array<{
      __typename?: 'BatteryManagementSystemCellCycleCounts';
      value?: number | null;
      timestamp?: number | null;
      units?: string | null;
    } | null> | null;
    property?: { __typename?: 'Property'; _id: string; title: string } | null;
    unit?: { __typename?: 'Unit'; _id: string; name: string } | null;
    panel?: {
      __typename?: 'Panel';
      _id: string;
      name?: string | null;
      displayName?: string | null;
    } | null;
    source?: { __typename?: 'Source'; _id: string; name: string } | null;
  } | null;
};

export type EnergyConsumerBuildingDetailUpdatesSubscriptionVariables = Exact<{
  id: Scalars['String'];
}>;

export type EnergyConsumerBuildingDetailUpdatesSubscription = {
  __typename?: 'Subscription';
  energyConsumerBuildingEventsByIds?: {
    __typename?: 'EnergyConsumerBuilding';
    modelChangeOperation?: string | null;
    _id: string;
    name?: string | null;
    location?: string | null;
    propertyId?: string | null;
    unitId?: string | null;
    vppId?: string | null;
    updateStatus?: boolean | null;
    timestamp?: number | null;
    energySwitchPanelId?: string | null;
    circuitId?: string | null;
    meterId?: string | null;
    inverterId?: string | null;
    chartTypes: Array<ChartType>;
    powerState?: {
      __typename?: 'EnergyConsumerBuildingPowerState';
      value?: EnumEnergyConsumerBuildingPowerStateValue | null;
      timestamp?: number | null;
      units?: string | null;
    } | null;
    connected?: {
      __typename?: 'EnergyConsumerBuildingConnected';
      value?: boolean | null;
      timestamp?: number | null;
    } | null;
    lastConnectedAt?: {
      __typename?: 'EnergyConsumerBuildingLastConnectedAt';
      value?: number | null;
      timestamp?: number | null;
    } | null;
    disconnectedAt?: {
      __typename?: 'EnergyConsumerBuildingDisconnectedAt';
      value?: number | null;
      timestamp?: number | null;
    } | null;
    tariffRateSell?: {
      __typename?: 'EnergyConsumerBuildingTariffRateSell';
      value?: number | null;
      timestamp?: number | null;
      units?: string | null;
    } | null;
    occupancy?: {
      __typename?: 'EnergyConsumerBuildingOccupancy';
      value?: number | null;
      timestamp?: number | null;
      units?: string | null;
    } | null;
    energyEfficiencyScore?: {
      __typename?: 'EnergyConsumerBuildingEnergyEfficiencyScore';
      value?: number | null;
      timestamp?: number | null;
      units?: string | null;
    } | null;
  } | null;
};

export type EnergyConsumerBuildingDetailQueryVariables = Exact<{
  id: Scalars['String'];
}>;

export type EnergyConsumerBuildingDetailQuery = {
  __typename?: 'Query';
  energyConsumerBuildingById?: {
    __typename?: 'EnergyConsumerBuilding';
    _id: string;
    name?: string | null;
    location?: string | null;
    propertyId?: string | null;
    unitId?: string | null;
    vppId?: string | null;
    updateStatus?: boolean | null;
    timestamp?: number | null;
    energySwitchPanelId?: string | null;
    circuitId?: string | null;
    meterId?: string | null;
    inverterId?: string | null;
    chartTypes: Array<ChartType>;
    powerState?: {
      __typename?: 'EnergyConsumerBuildingPowerState';
      value?: EnumEnergyConsumerBuildingPowerStateValue | null;
      timestamp?: number | null;
      units?: string | null;
    } | null;
    connected?: {
      __typename?: 'EnergyConsumerBuildingConnected';
      value?: boolean | null;
      timestamp?: number | null;
    } | null;
    lastConnectedAt?: {
      __typename?: 'EnergyConsumerBuildingLastConnectedAt';
      value?: number | null;
      timestamp?: number | null;
    } | null;
    disconnectedAt?: {
      __typename?: 'EnergyConsumerBuildingDisconnectedAt';
      value?: number | null;
      timestamp?: number | null;
    } | null;
    tariffRateSell?: {
      __typename?: 'EnergyConsumerBuildingTariffRateSell';
      value?: number | null;
      timestamp?: number | null;
      units?: string | null;
    } | null;
    occupancy?: {
      __typename?: 'EnergyConsumerBuildingOccupancy';
      value?: number | null;
      timestamp?: number | null;
      units?: string | null;
    } | null;
    energyEfficiencyScore?: {
      __typename?: 'EnergyConsumerBuildingEnergyEfficiencyScore';
      value?: number | null;
      timestamp?: number | null;
      units?: string | null;
    } | null;
  } | null;
};

export type EnergyConsumerTenantDetailUpdatesSubscriptionVariables = Exact<{
  id: Scalars['String'];
}>;

export type EnergyConsumerTenantDetailUpdatesSubscription = {
  __typename?: 'Subscription';
  energyConsumerTenantEventsByIds?: {
    __typename?: 'EnergyConsumerTenant';
    modelChangeOperation?: string | null;
    _id: string;
    name?: string | null;
    location?: string | null;
    propertyId?: string | null;
    unitId?: string | null;
    vppId?: string | null;
    updateStatus?: boolean | null;
    timestamp?: number | null;
    energySwitchPanelId?: string | null;
    circuitId?: string | null;
    meterId?: string | null;
    inverterId?: string | null;
    converterId?: string | null;
    contactName?: string | null;
    contactPhone?: string | null;
    buildingId?: string | null;
    chartTypes: Array<ChartType>;
    powerState?: {
      __typename?: 'EnergyConsumerBuildingPowerState';
      value?: EnumEnergyConsumerBuildingPowerStateValue | null;
      timestamp?: number | null;
      units?: string | null;
    } | null;
    connected?: {
      __typename?: 'EnergyConsumerBuildingConnected';
      value?: boolean | null;
      timestamp?: number | null;
    } | null;
    lastConnectedAt?: {
      __typename?: 'EnergyConsumerBuildingLastConnectedAt';
      value?: number | null;
      timestamp?: number | null;
    } | null;
    disconnectedAt?: {
      __typename?: 'EnergyConsumerBuildingDisconnectedAt';
      value?: number | null;
      timestamp?: number | null;
    } | null;
    tariffRateSell?: {
      __typename?: 'EnergyConsumerBuildingTariffRateSell';
      value?: number | null;
      timestamp?: number | null;
      units?: string | null;
    } | null;
    occupancy?: {
      __typename?: 'EnergyConsumerTenantOccupancy';
      value?: number | null;
      timestamp?: number | null;
      units?: string | null;
    } | null;
    energyEfficiencyScore?: {
      __typename?: 'EnergyConsumerTenantEnergyEfficiencyScore';
      value?: number | null;
      timestamp?: number | null;
      units?: string | null;
    } | null;
  } | null;
};

export type EnergyConsumerTenantDetailQueryVariables = Exact<{
  id: Scalars['String'];
}>;

export type EnergyConsumerTenantDetailQuery = {
  __typename?: 'Query';
  energyConsumerTenantById?: {
    __typename?: 'EnergyConsumerTenant';
    _id: string;
    name?: string | null;
    location?: string | null;
    propertyId?: string | null;
    unitId?: string | null;
    vppId?: string | null;
    updateStatus?: boolean | null;
    timestamp?: number | null;
    energySwitchPanelId?: string | null;
    circuitId?: string | null;
    meterId?: string | null;
    inverterId?: string | null;
    converterId?: string | null;
    contactName?: string | null;
    contactPhone?: string | null;
    buildingId?: string | null;
    chartTypes: Array<ChartType>;
    powerState?: {
      __typename?: 'EnergyConsumerBuildingPowerState';
      value?: EnumEnergyConsumerBuildingPowerStateValue | null;
      timestamp?: number | null;
      units?: string | null;
    } | null;
    connected?: {
      __typename?: 'EnergyConsumerBuildingConnected';
      value?: boolean | null;
      timestamp?: number | null;
    } | null;
    lastConnectedAt?: {
      __typename?: 'EnergyConsumerBuildingLastConnectedAt';
      value?: number | null;
      timestamp?: number | null;
    } | null;
    disconnectedAt?: {
      __typename?: 'EnergyConsumerBuildingDisconnectedAt';
      value?: number | null;
      timestamp?: number | null;
    } | null;
    tariffRateSell?: {
      __typename?: 'EnergyConsumerBuildingTariffRateSell';
      value?: number | null;
      timestamp?: number | null;
      units?: string | null;
    } | null;
    occupancy?: {
      __typename?: 'EnergyConsumerTenantOccupancy';
      value?: number | null;
      timestamp?: number | null;
      units?: string | null;
    } | null;
    energyEfficiencyScore?: {
      __typename?: 'EnergyConsumerTenantEnergyEfficiencyScore';
      value?: number | null;
      timestamp?: number | null;
      units?: string | null;
    } | null;
  } | null;
};

export type EnergyConsumerUtilityDetailUpdatesSubscriptionVariables = Exact<{
  id: Scalars['String'];
}>;

export type EnergyConsumerUtilityDetailUpdatesSubscription = {
  __typename?: 'Subscription';
  energyConsumerUtilityEventsByIds?: {
    __typename?: 'EnergyConsumerUtility';
    modelChangeOperation?: string | null;
    _id: string;
    name?: string | null;
    location?: string | null;
    propertyId?: string | null;
    unitId?: string | null;
    vppId?: string | null;
    updateStatus?: boolean | null;
    timestamp?: number | null;
    energySwitchPanelId?: string | null;
    circuitId?: string | null;
    meterId?: string | null;
    inverterId?: string | null;
    converterId?: string | null;
    chartTypes: Array<ChartType>;
    powerState?: {
      __typename?: 'EnergyConsumerBuildingPowerState';
      value?: EnumEnergyConsumerBuildingPowerStateValue | null;
      timestamp?: number | null;
      units?: string | null;
    } | null;
    connected?: {
      __typename?: 'EnergyConsumerBuildingConnected';
      value?: boolean | null;
      timestamp?: number | null;
    } | null;
    lastConnectedAt?: {
      __typename?: 'EnergyConsumerBuildingLastConnectedAt';
      value?: number | null;
      timestamp?: number | null;
    } | null;
    disconnectedAt?: {
      __typename?: 'EnergyConsumerBuildingDisconnectedAt';
      value?: number | null;
      timestamp?: number | null;
    } | null;
    tariffRateSell?: {
      __typename?: 'EnergyConsumerBuildingTariffRateSell';
      value?: number | null;
      timestamp?: number | null;
      units?: string | null;
    } | null;
    gridFrequency?: {
      __typename?: 'EnergyConsumerUtilityGridFrequency';
      value?: number | null;
      timestamp?: number | null;
      units?: string | null;
    } | null;
    interconnectionCapacity?: {
      __typename?: 'EnergyConsumerUtilityInterconnectionCapacity';
      value?: number | null;
      timestamp?: number | null;
      units?: string | null;
    } | null;
    exportAllowance?: {
      __typename?: 'EnergyConsumerUtilityExportAllowance';
      value?: number | null;
      timestamp?: number | null;
      units?: string | null;
    } | null;
    contractStatus?: {
      __typename?: 'EnergyConsumerUtilityContractStatus';
      value?: string | null;
      timestamp?: number | null;
      units?: string | null;
    } | null;
  } | null;
};

export type EnergyConsumerUtilityDetailQueryVariables = Exact<{
  id: Scalars['String'];
}>;

export type EnergyConsumerUtilityDetailQuery = {
  __typename?: 'Query';
  energyConsumerUtilityById?: {
    __typename?: 'EnergyConsumerUtility';
    _id: string;
    name?: string | null;
    location?: string | null;
    propertyId?: string | null;
    unitId?: string | null;
    vppId?: string | null;
    updateStatus?: boolean | null;
    timestamp?: number | null;
    energySwitchPanelId?: string | null;
    circuitId?: string | null;
    meterId?: string | null;
    inverterId?: string | null;
    converterId?: string | null;
    chartTypes: Array<ChartType>;
    powerState?: {
      __typename?: 'EnergyConsumerBuildingPowerState';
      value?: EnumEnergyConsumerBuildingPowerStateValue | null;
      timestamp?: number | null;
      units?: string | null;
    } | null;
    connected?: {
      __typename?: 'EnergyConsumerBuildingConnected';
      value?: boolean | null;
      timestamp?: number | null;
    } | null;
    lastConnectedAt?: {
      __typename?: 'EnergyConsumerBuildingLastConnectedAt';
      value?: number | null;
      timestamp?: number | null;
    } | null;
    disconnectedAt?: {
      __typename?: 'EnergyConsumerBuildingDisconnectedAt';
      value?: number | null;
      timestamp?: number | null;
    } | null;
    tariffRateSell?: {
      __typename?: 'EnergyConsumerBuildingTariffRateSell';
      value?: number | null;
      timestamp?: number | null;
      units?: string | null;
    } | null;
    gridFrequency?: {
      __typename?: 'EnergyConsumerUtilityGridFrequency';
      value?: number | null;
      timestamp?: number | null;
      units?: string | null;
    } | null;
    interconnectionCapacity?: {
      __typename?: 'EnergyConsumerUtilityInterconnectionCapacity';
      value?: number | null;
      timestamp?: number | null;
      units?: string | null;
    } | null;
    exportAllowance?: {
      __typename?: 'EnergyConsumerUtilityExportAllowance';
      value?: number | null;
      timestamp?: number | null;
      units?: string | null;
    } | null;
    contractStatus?: {
      __typename?: 'EnergyConsumerUtilityContractStatus';
      value?: string | null;
      timestamp?: number | null;
      units?: string | null;
    } | null;
  } | null;
};

export type EnergyControllerDetailUpdatesSubscriptionVariables = Exact<{
  id: Scalars['String'];
}>;

export type EnergyControllerDetailUpdatesSubscription = {
  __typename?: 'Subscription';
  energyControllerEventsByIds?: {
    __typename?: 'EnergyController';
    modelChangeOperation?: string | null;
    _id: string;
    deviceId?: string | null;
    name?: string | null;
    type?: EnumDKeyDeviceType | null;
    location?: string | null;
    propertyId: string;
    unitId: string;
    panelId?: string | null;
    sourceId?: string | null;
    updateStatus?: boolean | null;
    timestamp?: number | null;
    typeDisplayName: string;
    isConfigured?: boolean | null;
    isPoweredOn?: boolean | null;
    deviceIdentifier?: string | null;
    hasPendingUpdates: boolean;
    isControlled: boolean;
    rectifierId?: string | null;
    currentPowerOutput?: number | null;
    totalEnergySupplied?: number | null;
    peakPowerOutput?: number | null;
    chartTypes: Array<ChartType>;
    meta?: {
      __typename?: 'DeviceMeta';
      name?: string | null;
      metrics?: any | null;
    } | null;
    installation?: {
      __typename?: 'DeviceInstallation';
      status: number;
      message?: string | null;
    } | null;
    powerState?: {
      __typename?: 'DevicePowerState';
      value?: EnumDevicePowerStateValue | null;
      timestamp?: number | null;
    } | null;
    energyGenerated?: {
      __typename?: 'EnergyControllerEnergyGenerated';
      value?: number | null;
      timestamp?: number | null;
      units?: string | null;
    } | null;
    availabilityStatus?: {
      __typename?: 'EnergyControllerAvailabilityStatus';
      value?: EnumEnergyControllerAvailabilityStatusValue | null;
      timestamp?: number | null;
    } | null;
    voltageAtMpp?: {
      __typename?: 'EnergyControllerVoltageAtMpp';
      value?: number | null;
      timestamp?: number | null;
      units?: string | null;
    } | null;
    currentAtMpp?: {
      __typename?: 'EnergyControllerCurrentAtMpp';
      value?: number | null;
      timestamp?: number | null;
      units?: string | null;
    } | null;
    rotorSpeedAtMPP?: {
      __typename?: 'EnergyControllerRotorSpeedAtMPP';
      value?: number | null;
      timestamp?: number | null;
      units?: string | null;
    } | null;
    chargeRegulationStatus?: {
      __typename?: 'EnergyControllerChargeRegulationStatus';
      value?: EnumEnergyControllerChargeRegulationStatusValue | null;
      timestamp?: number | null;
    } | null;
    property?: { __typename?: 'Property'; _id: string; title: string } | null;
    unit?: { __typename?: 'Unit'; _id: string; name: string } | null;
    panel?: {
      __typename?: 'Panel';
      _id: string;
      name?: string | null;
      displayName?: string | null;
    } | null;
    source?: { __typename?: 'Source'; _id: string; name: string } | null;
  } | null;
};

export type EnergyControllerDetailQueryVariables = Exact<{
  id: Scalars['String'];
}>;

export type EnergyControllerDetailQuery = {
  __typename?: 'Query';
  energyControllerById?: {
    __typename?: 'EnergyController';
    _id: string;
    deviceId?: string | null;
    name?: string | null;
    type?: EnumDKeyDeviceType | null;
    location?: string | null;
    propertyId: string;
    unitId: string;
    panelId?: string | null;
    sourceId?: string | null;
    updateStatus?: boolean | null;
    timestamp?: number | null;
    typeDisplayName: string;
    isConfigured?: boolean | null;
    isPoweredOn?: boolean | null;
    deviceIdentifier?: string | null;
    hasPendingUpdates: boolean;
    isControlled: boolean;
    rectifierId?: string | null;
    currentPowerOutput?: number | null;
    totalEnergySupplied?: number | null;
    peakPowerOutput?: number | null;
    chartTypes: Array<ChartType>;
    meta?: {
      __typename?: 'DeviceMeta';
      name?: string | null;
      metrics?: any | null;
    } | null;
    installation?: {
      __typename?: 'DeviceInstallation';
      status: number;
      message?: string | null;
    } | null;
    powerState?: {
      __typename?: 'DevicePowerState';
      value?: EnumDevicePowerStateValue | null;
      timestamp?: number | null;
    } | null;
    energyGenerated?: {
      __typename?: 'EnergyControllerEnergyGenerated';
      value?: number | null;
      timestamp?: number | null;
      units?: string | null;
    } | null;
    availabilityStatus?: {
      __typename?: 'EnergyControllerAvailabilityStatus';
      value?: EnumEnergyControllerAvailabilityStatusValue | null;
      timestamp?: number | null;
    } | null;
    voltageAtMpp?: {
      __typename?: 'EnergyControllerVoltageAtMpp';
      value?: number | null;
      timestamp?: number | null;
      units?: string | null;
    } | null;
    currentAtMpp?: {
      __typename?: 'EnergyControllerCurrentAtMpp';
      value?: number | null;
      timestamp?: number | null;
      units?: string | null;
    } | null;
    rotorSpeedAtMPP?: {
      __typename?: 'EnergyControllerRotorSpeedAtMPP';
      value?: number | null;
      timestamp?: number | null;
      units?: string | null;
    } | null;
    chargeRegulationStatus?: {
      __typename?: 'EnergyControllerChargeRegulationStatus';
      value?: EnumEnergyControllerChargeRegulationStatusValue | null;
      timestamp?: number | null;
    } | null;
    property?: { __typename?: 'Property'; _id: string; title: string } | null;
    unit?: { __typename?: 'Unit'; _id: string; name: string } | null;
    panel?: {
      __typename?: 'Panel';
      _id: string;
      name?: string | null;
      displayName?: string | null;
    } | null;
    source?: { __typename?: 'Source'; _id: string; name: string } | null;
  } | null;
};

export type EnergyConverterDetailUpdatesSubscriptionVariables = Exact<{
  id: Scalars['String'];
}>;

export type EnergyConverterDetailUpdatesSubscription = {
  __typename?: 'Subscription';
  energyConverterEventsByIds?: {
    __typename?: 'EnergyConverter';
    modelChangeOperation?: string | null;
    _id: string;
    deviceId?: string | null;
    name?: string | null;
    type?: EnumDKeyDeviceType | null;
    location?: string | null;
    propertyId: string;
    unitId: string;
    panelId?: string | null;
    sourceId?: string | null;
    updateStatus?: boolean | null;
    timestamp?: number | null;
    typeDisplayName: string;
    isConfigured?: boolean | null;
    isPoweredOn?: boolean | null;
    deviceIdentifier?: string | null;
    hasPendingUpdates: boolean;
    isControlled: boolean;
    chartTypes: Array<ChartType>;
    meta?: {
      __typename?: 'DeviceMeta';
      name?: string | null;
      metrics?: any | null;
    } | null;
    installation?: {
      __typename?: 'DeviceInstallation';
      status: number;
      message?: string | null;
    } | null;
    powerState?: {
      __typename?: 'DevicePowerState';
      value?: EnumDevicePowerStateValue | null;
      timestamp?: number | null;
    } | null;
    inputVoltage?: {
      __typename?: 'EnergyConverterInputVoltage';
      value?: number | null;
      timestamp?: number | null;
      units?: string | null;
    } | null;
    outputVoltage?: {
      __typename?: 'EnergyConverterOutputVoltage';
      value?: number | null;
      timestamp?: number | null;
      units?: string | null;
    } | null;
    powerOutput?: {
      __typename?: 'EnergyConverterPowerOutput';
      value?: number | null;
      timestamp?: number | null;
      units?: string | null;
    } | null;
    chargeRate?: {
      __typename?: 'EnergyConverterChargeRate';
      value?: number | null;
      timestamp?: number | null;
      units?: string | null;
    } | null;
    dischargeRate?: {
      __typename?: 'EnergyConverterDischargeRate';
      value?: number | null;
      timestamp?: number | null;
      units?: string | null;
    } | null;
    efficiency?: {
      __typename?: 'EnergyConverterEfficiency';
      value?: number | null;
      timestamp?: number | null;
      units?: string | null;
    } | null;
    property?: { __typename?: 'Property'; _id: string; title: string } | null;
    unit?: { __typename?: 'Unit'; _id: string; name: string } | null;
    panel?: {
      __typename?: 'Panel';
      _id: string;
      name?: string | null;
      displayName?: string | null;
    } | null;
    source?: { __typename?: 'Source'; _id: string; name: string } | null;
  } | null;
};

export type EnergyConverterDetailQueryVariables = Exact<{
  id: Scalars['String'];
}>;

export type EnergyConverterDetailQuery = {
  __typename?: 'Query';
  energyConverterById?: {
    __typename?: 'EnergyConverter';
    _id: string;
    deviceId?: string | null;
    name?: string | null;
    type?: EnumDKeyDeviceType | null;
    location?: string | null;
    propertyId: string;
    unitId: string;
    panelId?: string | null;
    sourceId?: string | null;
    updateStatus?: boolean | null;
    timestamp?: number | null;
    typeDisplayName: string;
    isConfigured?: boolean | null;
    isPoweredOn?: boolean | null;
    deviceIdentifier?: string | null;
    hasPendingUpdates: boolean;
    isControlled: boolean;
    chartTypes: Array<ChartType>;
    meta?: {
      __typename?: 'DeviceMeta';
      name?: string | null;
      metrics?: any | null;
    } | null;
    installation?: {
      __typename?: 'DeviceInstallation';
      status: number;
      message?: string | null;
    } | null;
    powerState?: {
      __typename?: 'DevicePowerState';
      value?: EnumDevicePowerStateValue | null;
      timestamp?: number | null;
    } | null;
    inputVoltage?: {
      __typename?: 'EnergyConverterInputVoltage';
      value?: number | null;
      timestamp?: number | null;
      units?: string | null;
    } | null;
    outputVoltage?: {
      __typename?: 'EnergyConverterOutputVoltage';
      value?: number | null;
      timestamp?: number | null;
      units?: string | null;
    } | null;
    powerOutput?: {
      __typename?: 'EnergyConverterPowerOutput';
      value?: number | null;
      timestamp?: number | null;
      units?: string | null;
    } | null;
    chargeRate?: {
      __typename?: 'EnergyConverterChargeRate';
      value?: number | null;
      timestamp?: number | null;
      units?: string | null;
    } | null;
    dischargeRate?: {
      __typename?: 'EnergyConverterDischargeRate';
      value?: number | null;
      timestamp?: number | null;
      units?: string | null;
    } | null;
    efficiency?: {
      __typename?: 'EnergyConverterEfficiency';
      value?: number | null;
      timestamp?: number | null;
      units?: string | null;
    } | null;
    property?: { __typename?: 'Property'; _id: string; title: string } | null;
    unit?: { __typename?: 'Unit'; _id: string; name: string } | null;
    panel?: {
      __typename?: 'Panel';
      _id: string;
      name?: string | null;
      displayName?: string | null;
    } | null;
    source?: { __typename?: 'Source'; _id: string; name: string } | null;
  } | null;
};

export type EnergyInverterDetailUpdatesSubscriptionVariables = Exact<{
  id: Scalars['String'];
}>;

export type EnergyInverterDetailUpdatesSubscription = {
  __typename?: 'Subscription';
  energyInverterEventsByIds?: {
    __typename?: 'EnergyInverter';
    modelChangeOperation?: string | null;
    _id: string;
    deviceId?: string | null;
    name?: string | null;
    type?: EnumDKeyDeviceType | null;
    location?: string | null;
    propertyId: string;
    unitId: string;
    panelId?: string | null;
    sourceId?: string | null;
    updateStatus?: boolean | null;
    timestamp?: number | null;
    typeDisplayName: string;
    isConfigured?: boolean | null;
    isPoweredOn?: boolean | null;
    deviceIdentifier?: string | null;
    hasPendingUpdates: boolean;
    isControlled: boolean;
    controllerId?: string | null;
    rectifierId?: string | null;
    chartTypes: Array<ChartType>;
    meta?: {
      __typename?: 'DeviceMeta';
      name?: string | null;
      metrics?: any | null;
    } | null;
    installation?: {
      __typename?: 'DeviceInstallation';
      status: number;
      message?: string | null;
    } | null;
    powerState?: {
      __typename?: 'DevicePowerState';
      value?: EnumDevicePowerStateValue | null;
      timestamp?: number | null;
    } | null;
    powerRating?: {
      __typename?: 'EnergyInverterPowerRating';
      value?: number | null;
      timestamp?: number | null;
      units?: string | null;
    } | null;
    powerInputBattery?: {
      __typename?: 'EnergyInverterPowerInputBattery';
      value?: number | null;
      timestamp?: number | null;
      units?: string | null;
    } | null;
    powerInputKinetic?: {
      __typename?: 'EnergyInverterPowerInputKinetic';
      value?: number | null;
      timestamp?: number | null;
      units?: string | null;
    } | null;
    powerOutput?: {
      __typename?: 'EnergyInverterPowerOutput';
      value?: number | null;
      timestamp?: number | null;
      units?: string | null;
    } | null;
    reactivePower?: {
      __typename?: 'EnergyInverterReactivePower';
      value?: number | null;
      timestamp?: number | null;
      units?: string | null;
    } | null;
    voltageOutput?: {
      __typename?: 'EnergyInverterVoltageOutput';
      value?: number | null;
      timestamp?: number | null;
      units?: string | null;
    } | null;
    frequency?: {
      __typename?: 'EnergyInverterFrequency';
      value?: number | null;
      timestamp?: number | null;
      units?: string | null;
    } | null;
    efficiency?: {
      __typename?: 'EnergyInverterEfficiency';
      value?: number | null;
      timestamp?: number | null;
      units?: string | null;
    } | null;
    inverterTemperature?: {
      __typename?: 'EnergyInverterInverterTemperature';
      value?: number | null;
      timestamp?: number | null;
      units?: string | null;
    } | null;
    chargeRate?: {
      __typename?: 'EnergyInverterChargeRate';
      value?: number | null;
      timestamp?: number | null;
      units?: string | null;
    } | null;
    dischargeRate?: {
      __typename?: 'EnergyInverterDischargeRate';
      value?: number | null;
      timestamp?: number | null;
      units?: string | null;
    } | null;
    availabilityStatus?: {
      __typename?: 'EnergyInverterAvailabilityStatus';
      value?: EnumEnergyInverterAvailabilityStatusValue | null;
      timestamp?: number | null;
    } | null;
    property?: { __typename?: 'Property'; _id: string; title: string } | null;
    unit?: { __typename?: 'Unit'; _id: string; name: string } | null;
    panel?: {
      __typename?: 'Panel';
      _id: string;
      name?: string | null;
      displayName?: string | null;
    } | null;
    source?: { __typename?: 'Source'; _id: string; name: string } | null;
  } | null;
};

export type EnergyInverterDetailQueryVariables = Exact<{
  id: Scalars['String'];
}>;

export type EnergyInverterDetailQuery = {
  __typename?: 'Query';
  energyInverterById?: {
    __typename?: 'EnergyInverter';
    _id: string;
    deviceId?: string | null;
    name?: string | null;
    type?: EnumDKeyDeviceType | null;
    location?: string | null;
    propertyId: string;
    unitId: string;
    panelId?: string | null;
    sourceId?: string | null;
    updateStatus?: boolean | null;
    timestamp?: number | null;
    typeDisplayName: string;
    isConfigured?: boolean | null;
    isPoweredOn?: boolean | null;
    deviceIdentifier?: string | null;
    hasPendingUpdates: boolean;
    isControlled: boolean;
    controllerId?: string | null;
    rectifierId?: string | null;
    chartTypes: Array<ChartType>;
    meta?: {
      __typename?: 'DeviceMeta';
      name?: string | null;
      metrics?: any | null;
    } | null;
    installation?: {
      __typename?: 'DeviceInstallation';
      status: number;
      message?: string | null;
    } | null;
    powerState?: {
      __typename?: 'DevicePowerState';
      value?: EnumDevicePowerStateValue | null;
      timestamp?: number | null;
    } | null;
    powerRating?: {
      __typename?: 'EnergyInverterPowerRating';
      value?: number | null;
      timestamp?: number | null;
      units?: string | null;
    } | null;
    powerInputBattery?: {
      __typename?: 'EnergyInverterPowerInputBattery';
      value?: number | null;
      timestamp?: number | null;
      units?: string | null;
    } | null;
    powerInputKinetic?: {
      __typename?: 'EnergyInverterPowerInputKinetic';
      value?: number | null;
      timestamp?: number | null;
      units?: string | null;
    } | null;
    powerOutput?: {
      __typename?: 'EnergyInverterPowerOutput';
      value?: number | null;
      timestamp?: number | null;
      units?: string | null;
    } | null;
    reactivePower?: {
      __typename?: 'EnergyInverterReactivePower';
      value?: number | null;
      timestamp?: number | null;
      units?: string | null;
    } | null;
    voltageOutput?: {
      __typename?: 'EnergyInverterVoltageOutput';
      value?: number | null;
      timestamp?: number | null;
      units?: string | null;
    } | null;
    frequency?: {
      __typename?: 'EnergyInverterFrequency';
      value?: number | null;
      timestamp?: number | null;
      units?: string | null;
    } | null;
    efficiency?: {
      __typename?: 'EnergyInverterEfficiency';
      value?: number | null;
      timestamp?: number | null;
      units?: string | null;
    } | null;
    inverterTemperature?: {
      __typename?: 'EnergyInverterInverterTemperature';
      value?: number | null;
      timestamp?: number | null;
      units?: string | null;
    } | null;
    chargeRate?: {
      __typename?: 'EnergyInverterChargeRate';
      value?: number | null;
      timestamp?: number | null;
      units?: string | null;
    } | null;
    dischargeRate?: {
      __typename?: 'EnergyInverterDischargeRate';
      value?: number | null;
      timestamp?: number | null;
      units?: string | null;
    } | null;
    availabilityStatus?: {
      __typename?: 'EnergyInverterAvailabilityStatus';
      value?: EnumEnergyInverterAvailabilityStatusValue | null;
      timestamp?: number | null;
    } | null;
    property?: { __typename?: 'Property'; _id: string; title: string } | null;
    unit?: { __typename?: 'Unit'; _id: string; name: string } | null;
    panel?: {
      __typename?: 'Panel';
      _id: string;
      name?: string | null;
      displayName?: string | null;
    } | null;
    source?: { __typename?: 'Source'; _id: string; name: string } | null;
  } | null;
};

export type EnergyMeterDetailUpdatesSubscriptionVariables = Exact<{
  id: Scalars['String'];
}>;

export type EnergyMeterDetailUpdatesSubscription = {
  __typename?: 'Subscription';
  energyMeterEventsByIds?: {
    __typename?: 'EnergyMeter';
    modelChangeOperation?: string | null;
    _id: string;
    deviceId?: string | null;
    name?: string | null;
    type?: EnumDKeyDeviceType | null;
    location?: string | null;
    propertyId: string;
    unitId: string;
    panelId?: string | null;
    sourceId?: string | null;
    updateStatus?: boolean | null;
    timestamp?: number | null;
    typeDisplayName: string;
    isConfigured?: boolean | null;
    isPoweredOn?: boolean | null;
    deviceIdentifier?: string | null;
    hasPendingUpdates: boolean;
    isControlled: boolean;
    chartTypes: Array<ChartType>;
    meta?: {
      __typename?: 'DeviceMeta';
      name?: string | null;
      metrics?: any | null;
    } | null;
    installation?: {
      __typename?: 'DeviceInstallation';
      status: number;
      message?: string | null;
    } | null;
    powerState?: {
      __typename?: 'DevicePowerState';
      value?: EnumDevicePowerStateValue | null;
      timestamp?: number | null;
    } | null;
    energyConsumed?: {
      __typename?: 'EnergyMeterEnergyConsumed';
      value?: number | null;
      timestamp?: number | null;
      units?: string | null;
    } | null;
    powerDemand?: {
      __typename?: 'EnergyMeterPowerDemand';
      value?: number | null;
      timestamp?: number | null;
      units?: string | null;
    } | null;
    voltage?: {
      __typename?: 'EnergyMeterVoltage';
      value?: number | null;
      timestamp?: number | null;
      units?: string | null;
    } | null;
    current?: {
      __typename?: 'EnergyMeterCurrent';
      value?: number | null;
      timestamp?: number | null;
      units?: string | null;
    } | null;
    powerFactor?: {
      __typename?: 'EnergyMeterPowerFactor';
      value?: number | null;
      timestamp?: number | null;
      units?: string | null;
    } | null;
    frequency?: {
      __typename?: 'EnergyMeterFrequency';
      value?: number | null;
      timestamp?: number | null;
      units?: string | null;
    } | null;
    outputEnabled?: {
      __typename?: 'EnergyMeterOutputEnabled';
      value?: boolean | null;
      timestamp?: number | null;
    } | null;
    property?: { __typename?: 'Property'; _id: string; title: string } | null;
    unit?: { __typename?: 'Unit'; _id: string; name: string } | null;
    panel?: {
      __typename?: 'Panel';
      _id: string;
      name?: string | null;
      displayName?: string | null;
    } | null;
    source?: { __typename?: 'Source'; _id: string; name: string } | null;
  } | null;
};

export type EnergyMeterDetailQueryVariables = Exact<{
  id: Scalars['String'];
}>;

export type EnergyMeterDetailQuery = {
  __typename?: 'Query';
  energyMeterById?: {
    __typename?: 'EnergyMeter';
    _id: string;
    deviceId?: string | null;
    name?: string | null;
    type?: EnumDKeyDeviceType | null;
    location?: string | null;
    propertyId: string;
    unitId: string;
    panelId?: string | null;
    sourceId?: string | null;
    updateStatus?: boolean | null;
    timestamp?: number | null;
    typeDisplayName: string;
    isConfigured?: boolean | null;
    isPoweredOn?: boolean | null;
    deviceIdentifier?: string | null;
    hasPendingUpdates: boolean;
    isControlled: boolean;
    chartTypes: Array<ChartType>;
    meta?: {
      __typename?: 'DeviceMeta';
      name?: string | null;
      metrics?: any | null;
    } | null;
    installation?: {
      __typename?: 'DeviceInstallation';
      status: number;
      message?: string | null;
    } | null;
    powerState?: {
      __typename?: 'DevicePowerState';
      value?: EnumDevicePowerStateValue | null;
      timestamp?: number | null;
    } | null;
    energyConsumed?: {
      __typename?: 'EnergyMeterEnergyConsumed';
      value?: number | null;
      timestamp?: number | null;
      units?: string | null;
    } | null;
    powerDemand?: {
      __typename?: 'EnergyMeterPowerDemand';
      value?: number | null;
      timestamp?: number | null;
      units?: string | null;
    } | null;
    voltage?: {
      __typename?: 'EnergyMeterVoltage';
      value?: number | null;
      timestamp?: number | null;
      units?: string | null;
    } | null;
    current?: {
      __typename?: 'EnergyMeterCurrent';
      value?: number | null;
      timestamp?: number | null;
      units?: string | null;
    } | null;
    powerFactor?: {
      __typename?: 'EnergyMeterPowerFactor';
      value?: number | null;
      timestamp?: number | null;
      units?: string | null;
    } | null;
    frequency?: {
      __typename?: 'EnergyMeterFrequency';
      value?: number | null;
      timestamp?: number | null;
      units?: string | null;
    } | null;
    outputEnabled?: {
      __typename?: 'EnergyMeterOutputEnabled';
      value?: boolean | null;
      timestamp?: number | null;
    } | null;
    property?: { __typename?: 'Property'; _id: string; title: string } | null;
    unit?: { __typename?: 'Unit'; _id: string; name: string } | null;
    panel?: {
      __typename?: 'Panel';
      _id: string;
      name?: string | null;
      displayName?: string | null;
    } | null;
    source?: { __typename?: 'Source'; _id: string; name: string } | null;
  } | null;
};

export type EnergyRectifierDetailUpdatesSubscriptionVariables = Exact<{
  id: Scalars['String'];
}>;

export type EnergyRectifierDetailUpdatesSubscription = {
  __typename?: 'Subscription';
  energyRectifierEventsByIds?: {
    __typename?: 'EnergyRectifier';
    modelChangeOperation?: string | null;
    _id: string;
    deviceId?: string | null;
    name?: string | null;
    type?: EnumDKeyDeviceType | null;
    location?: string | null;
    propertyId: string;
    unitId: string;
    panelId?: string | null;
    sourceId?: string | null;
    updateStatus?: boolean | null;
    timestamp?: number | null;
    typeDisplayName: string;
    isConfigured?: boolean | null;
    isPoweredOn?: boolean | null;
    deviceIdentifier?: string | null;
    hasPendingUpdates: boolean;
    isControlled: boolean;
    chartTypes: Array<ChartType>;
    meta?: {
      __typename?: 'DeviceMeta';
      name?: string | null;
      metrics?: any | null;
    } | null;
    installation?: {
      __typename?: 'DeviceInstallation';
      status: number;
      message?: string | null;
    } | null;
    powerState?: {
      __typename?: 'DevicePowerState';
      value?: EnumDevicePowerStateValue | null;
      timestamp?: number | null;
    } | null;
    outputVoltage?: {
      __typename?: 'EnergyRectifierOutputVoltage';
      value?: number | null;
      timestamp?: number | null;
      units?: string | null;
    } | null;
    rectifierEfficiency?: {
      __typename?: 'EnergyRectifierRectifierEfficiency';
      value?: number | null;
      timestamp?: number | null;
      units?: string | null;
    } | null;
    property?: { __typename?: 'Property'; _id: string; title: string } | null;
    unit?: { __typename?: 'Unit'; _id: string; name: string } | null;
    panel?: {
      __typename?: 'Panel';
      _id: string;
      name?: string | null;
      displayName?: string | null;
    } | null;
    source?: { __typename?: 'Source'; _id: string; name: string } | null;
  } | null;
};

export type EnergyRectifierDetailQueryVariables = Exact<{
  id: Scalars['String'];
}>;

export type EnergyRectifierDetailQuery = {
  __typename?: 'Query';
  energyRectifierById?: {
    __typename?: 'EnergyRectifier';
    _id: string;
    deviceId?: string | null;
    name?: string | null;
    type?: EnumDKeyDeviceType | null;
    location?: string | null;
    propertyId: string;
    unitId: string;
    panelId?: string | null;
    sourceId?: string | null;
    updateStatus?: boolean | null;
    timestamp?: number | null;
    typeDisplayName: string;
    isConfigured?: boolean | null;
    isPoweredOn?: boolean | null;
    deviceIdentifier?: string | null;
    hasPendingUpdates: boolean;
    isControlled: boolean;
    chartTypes: Array<ChartType>;
    meta?: {
      __typename?: 'DeviceMeta';
      name?: string | null;
      metrics?: any | null;
    } | null;
    installation?: {
      __typename?: 'DeviceInstallation';
      status: number;
      message?: string | null;
    } | null;
    powerState?: {
      __typename?: 'DevicePowerState';
      value?: EnumDevicePowerStateValue | null;
      timestamp?: number | null;
    } | null;
    outputVoltage?: {
      __typename?: 'EnergyRectifierOutputVoltage';
      value?: number | null;
      timestamp?: number | null;
      units?: string | null;
    } | null;
    rectifierEfficiency?: {
      __typename?: 'EnergyRectifierRectifierEfficiency';
      value?: number | null;
      timestamp?: number | null;
      units?: string | null;
    } | null;
    property?: { __typename?: 'Property'; _id: string; title: string } | null;
    unit?: { __typename?: 'Unit'; _id: string; name: string } | null;
    panel?: {
      __typename?: 'Panel';
      _id: string;
      name?: string | null;
      displayName?: string | null;
    } | null;
    source?: { __typename?: 'Source'; _id: string; name: string } | null;
  } | null;
};

export type EnergyStorageBatterySystemDetailUpdatesSubscriptionVariables =
  Exact<{
    id: Scalars['String'];
  }>;

export type EnergyStorageBatterySystemDetailUpdatesSubscription = {
  __typename?: 'Subscription';
  energyStorageBatterySystemEventsByIds?: {
    __typename?: 'EnergyStorageBatterySystem';
    modelChangeOperation?: string | null;
    _id: string;
    name?: string | null;
    location?: string | null;
    propertyId?: string | null;
    unitId?: string | null;
    vppId?: string | null;
    updateStatus?: boolean | null;
    timestamp?: number | null;
    batteryManagementSystemId?: string | null;
    chartTypes: Array<ChartType>;
    controllerId?: string | null;
    inverterId?: string | null;
    coolingSystemId?: string | null;
    fireSuppressionSystemId?: string | null;
    converterId?: string | null;
    powerState?: {
      __typename?: 'EnergyConsumerBuildingPowerState';
      value?: EnumEnergyConsumerBuildingPowerStateValue | null;
      timestamp?: number | null;
      units?: string | null;
    } | null;
    connected?: {
      __typename?: 'EnergyConsumerBuildingConnected';
      value?: boolean | null;
      units?: string | null;
      timestamp?: number | null;
    } | null;
    lastConnectedAt?: {
      __typename?: 'EnergyConsumerBuildingLastConnectedAt';
      value?: number | null;
      units?: string | null;
      timestamp?: number | null;
    } | null;
    disconnectedAt?: {
      __typename?: 'EnergyConsumerBuildingDisconnectedAt';
      value?: number | null;
      units?: string | null;
      timestamp?: number | null;
    } | null;
    maximumEnergyCapacity?: {
      __typename?: 'EnergyStorageBatterySystemMaximumEnergyCapacity';
      value?: number | null;
      timestamp?: number | null;
      units?: string | null;
    } | null;
    maintenanceScheduleStatus?: {
      __typename?: 'EnergyStorageBatterySystemMaintenanceScheduleStatus';
      value?: EnumEnergyStorageBatterySystemMaintenanceScheduleStatusValue | null;
      timestamp?: number | null;
      units?: string | null;
    } | null;
  } | null;
};

export type EnergyStorageBatterySystemDetailQueryVariables = Exact<{
  id: Scalars['String'];
}>;

export type EnergyStorageBatterySystemDetailQuery = {
  __typename?: 'Query';
  energyStorageBatterySystemById?: {
    __typename?: 'EnergyStorageBatterySystem';
    _id: string;
    name?: string | null;
    location?: string | null;
    propertyId?: string | null;
    unitId?: string | null;
    vppId?: string | null;
    updateStatus?: boolean | null;
    timestamp?: number | null;
    batteryManagementSystemId?: string | null;
    chartTypes: Array<ChartType>;
    controllerId?: string | null;
    inverterId?: string | null;
    coolingSystemId?: string | null;
    fireSuppressionSystemId?: string | null;
    converterId?: string | null;
    powerState?: {
      __typename?: 'EnergyConsumerBuildingPowerState';
      value?: EnumEnergyConsumerBuildingPowerStateValue | null;
      timestamp?: number | null;
      units?: string | null;
    } | null;
    connected?: {
      __typename?: 'EnergyConsumerBuildingConnected';
      value?: boolean | null;
      units?: string | null;
      timestamp?: number | null;
    } | null;
    lastConnectedAt?: {
      __typename?: 'EnergyConsumerBuildingLastConnectedAt';
      value?: number | null;
      units?: string | null;
      timestamp?: number | null;
    } | null;
    disconnectedAt?: {
      __typename?: 'EnergyConsumerBuildingDisconnectedAt';
      value?: number | null;
      units?: string | null;
      timestamp?: number | null;
    } | null;
    maximumEnergyCapacity?: {
      __typename?: 'EnergyStorageBatterySystemMaximumEnergyCapacity';
      value?: number | null;
      timestamp?: number | null;
      units?: string | null;
    } | null;
    maintenanceScheduleStatus?: {
      __typename?: 'EnergyStorageBatterySystemMaintenanceScheduleStatus';
      value?: EnumEnergyStorageBatterySystemMaintenanceScheduleStatusValue | null;
      timestamp?: number | null;
      units?: string | null;
    } | null;
  } | null;
};

export type EnergyStorageCoolingSystemDetailUpdatesSubscriptionVariables =
  Exact<{
    id: Scalars['String'];
  }>;

export type EnergyStorageCoolingSystemDetailUpdatesSubscription = {
  __typename?: 'Subscription';
  energyStorageCoolingSystemEventsByIds?: {
    __typename?: 'EnergyStorageCoolingSystem';
    modelChangeOperation?: string | null;
    _id: string;
    deviceId?: string | null;
    name?: string | null;
    type?: EnumDKeyDeviceType | null;
    location?: string | null;
    propertyId: string;
    unitId: string;
    panelId?: string | null;
    sourceId?: string | null;
    updateStatus?: boolean | null;
    timestamp?: number | null;
    typeDisplayName: string;
    isConfigured?: boolean | null;
    isPoweredOn?: boolean | null;
    deviceIdentifier?: string | null;
    hasPendingUpdates: boolean;
    isControlled: boolean;
    chartTypes: Array<ChartType>;
    meta?: {
      __typename?: 'DeviceMeta';
      name?: string | null;
      metrics?: any | null;
    } | null;
    installation?: {
      __typename?: 'DeviceInstallation';
      status: number;
      message?: string | null;
    } | null;
    powerState?: {
      __typename?: 'DevicePowerState';
      value?: EnumDevicePowerStateValue | null;
      timestamp?: number | null;
    } | null;
    temperature?: {
      __typename?: 'EnergyStorageCoolingSystemTemperature';
      value?: number | null;
      timestamp?: number | null;
      units?: string | null;
    } | null;
    coolingHeatingStatus?: {
      __typename?: 'EnergyStorageCoolingSystemCoolingHeatingStatus';
      value?: EnumEnergyStorageCoolingSystemCoolingHeatingStatusValue | null;
      timestamp?: number | null;
      units?: string | null;
    } | null;
    property?: { __typename?: 'Property'; _id: string; title: string } | null;
    unit?: { __typename?: 'Unit'; _id: string; name: string } | null;
    panel?: {
      __typename?: 'Panel';
      _id: string;
      name?: string | null;
      displayName?: string | null;
    } | null;
    source?: { __typename?: 'Source'; _id: string; name: string } | null;
  } | null;
};

export type EnergyStorageCoolingSystemDetailQueryVariables = Exact<{
  id: Scalars['String'];
}>;

export type EnergyStorageCoolingSystemDetailQuery = {
  __typename?: 'Query';
  energyStorageCoolingSystemById?: {
    __typename?: 'EnergyStorageCoolingSystem';
    _id: string;
    deviceId?: string | null;
    name?: string | null;
    type?: EnumDKeyDeviceType | null;
    location?: string | null;
    propertyId: string;
    unitId: string;
    panelId?: string | null;
    sourceId?: string | null;
    updateStatus?: boolean | null;
    timestamp?: number | null;
    typeDisplayName: string;
    isConfigured?: boolean | null;
    isPoweredOn?: boolean | null;
    deviceIdentifier?: string | null;
    hasPendingUpdates: boolean;
    isControlled: boolean;
    chartTypes: Array<ChartType>;
    meta?: {
      __typename?: 'DeviceMeta';
      name?: string | null;
      metrics?: any | null;
    } | null;
    installation?: {
      __typename?: 'DeviceInstallation';
      status: number;
      message?: string | null;
    } | null;
    powerState?: {
      __typename?: 'DevicePowerState';
      value?: EnumDevicePowerStateValue | null;
      timestamp?: number | null;
    } | null;
    temperature?: {
      __typename?: 'EnergyStorageCoolingSystemTemperature';
      value?: number | null;
      timestamp?: number | null;
      units?: string | null;
    } | null;
    coolingHeatingStatus?: {
      __typename?: 'EnergyStorageCoolingSystemCoolingHeatingStatus';
      value?: EnumEnergyStorageCoolingSystemCoolingHeatingStatusValue | null;
      timestamp?: number | null;
      units?: string | null;
    } | null;
    property?: { __typename?: 'Property'; _id: string; title: string } | null;
    unit?: { __typename?: 'Unit'; _id: string; name: string } | null;
    panel?: {
      __typename?: 'Panel';
      _id: string;
      name?: string | null;
      displayName?: string | null;
    } | null;
    source?: { __typename?: 'Source'; _id: string; name: string } | null;
  } | null;
};

export type EnergyStorageKineticSystemDetailUpdatesSubscriptionVariables =
  Exact<{
    id: Scalars['String'];
  }>;

export type EnergyStorageKineticSystemDetailUpdatesSubscription = {
  __typename?: 'Subscription';
  energyStorageKineticSystemEventsByIds?: {
    __typename?: 'EnergyStorageKineticSystem';
    modelChangeOperation?: string | null;
    _id: string;
    name?: string | null;
    location?: string | null;
    propertyId?: string | null;
    unitId?: string | null;
    vppId?: string | null;
    updateStatus?: boolean | null;
    timestamp?: number | null;
    chartTypes: Array<ChartType>;
    kemsId?: string | null;
    controllerId?: string | null;
    inverterId?: string | null;
    coolingSystemId?: string | null;
    fireSuppressionSystemId?: string | null;
    converterId?: string | null;
    powerState?: {
      __typename?: 'EnergyConsumerBuildingPowerState';
      value?: EnumEnergyConsumerBuildingPowerStateValue | null;
      timestamp?: number | null;
      units?: string | null;
    } | null;
    connected?: {
      __typename?: 'EnergyConsumerBuildingConnected';
      value?: boolean | null;
      timestamp?: number | null;
    } | null;
    lastConnectedAt?: {
      __typename?: 'EnergyConsumerBuildingLastConnectedAt';
      value?: number | null;
      timestamp?: number | null;
    } | null;
    disconnectedAt?: {
      __typename?: 'EnergyConsumerBuildingDisconnectedAt';
      value?: number | null;
      timestamp?: number | null;
    } | null;
    maximumEnergyCapacity?: {
      __typename?: 'EnergyStorageBatterySystemMaximumEnergyCapacity';
      value?: number | null;
      timestamp?: number | null;
      units?: string | null;
    } | null;
    maintenanceScheduleStatus?: {
      __typename?: 'EnergyStorageBatterySystemMaintenanceScheduleStatus';
      value?: EnumEnergyStorageBatterySystemMaintenanceScheduleStatusValue | null;
      timestamp?: number | null;
      units?: string | null;
    } | null;
  } | null;
};

export type EnergyStorageKineticSystemDetailQueryVariables = Exact<{
  id: Scalars['String'];
}>;

export type EnergyStorageKineticSystemDetailQuery = {
  __typename?: 'Query';
  energyStorageKineticSystemById?: {
    __typename?: 'EnergyStorageKineticSystem';
    _id: string;
    name?: string | null;
    location?: string | null;
    propertyId?: string | null;
    unitId?: string | null;
    vppId?: string | null;
    updateStatus?: boolean | null;
    timestamp?: number | null;
    chartTypes: Array<ChartType>;
    kemsId?: string | null;
    controllerId?: string | null;
    inverterId?: string | null;
    coolingSystemId?: string | null;
    fireSuppressionSystemId?: string | null;
    converterId?: string | null;
    powerState?: {
      __typename?: 'EnergyConsumerBuildingPowerState';
      value?: EnumEnergyConsumerBuildingPowerStateValue | null;
      timestamp?: number | null;
      units?: string | null;
    } | null;
    connected?: {
      __typename?: 'EnergyConsumerBuildingConnected';
      value?: boolean | null;
      timestamp?: number | null;
    } | null;
    lastConnectedAt?: {
      __typename?: 'EnergyConsumerBuildingLastConnectedAt';
      value?: number | null;
      timestamp?: number | null;
    } | null;
    disconnectedAt?: {
      __typename?: 'EnergyConsumerBuildingDisconnectedAt';
      value?: number | null;
      timestamp?: number | null;
    } | null;
    maximumEnergyCapacity?: {
      __typename?: 'EnergyStorageBatterySystemMaximumEnergyCapacity';
      value?: number | null;
      timestamp?: number | null;
      units?: string | null;
    } | null;
    maintenanceScheduleStatus?: {
      __typename?: 'EnergyStorageBatterySystemMaintenanceScheduleStatus';
      value?: EnumEnergyStorageBatterySystemMaintenanceScheduleStatusValue | null;
      timestamp?: number | null;
      units?: string | null;
    } | null;
  } | null;
};

export type EnergySupplierSolarSystemDetailUpdatesSubscriptionVariables =
  Exact<{
    id: Scalars['String'];
  }>;

export type EnergySupplierSolarSystemDetailUpdatesSubscription = {
  __typename?: 'Subscription';
  energySupplierSolarSystemEventsByIds?: {
    __typename?: 'EnergySupplierSolarSystem';
    modelChangeOperation?: string | null;
    _id: string;
    name?: string | null;
    location?: string | null;
    propertyId?: string | null;
    unitId?: string | null;
    vppId?: string | null;
    updateStatus?: boolean | null;
    timestamp?: number | null;
    maximumPowerOutput?: number | null;
    inverterId?: string | null;
    controllerId?: string | null;
    smsId?: string | null;
    chartTypes: Array<ChartType>;
    powerState?: {
      __typename?: 'EnergyConsumerBuildingPowerState';
      value?: EnumEnergyConsumerBuildingPowerStateValue | null;
      timestamp?: number | null;
      units?: string | null;
    } | null;
    connected?: {
      __typename?: 'EnergyConsumerBuildingConnected';
      value?: boolean | null;
      timestamp?: number | null;
    } | null;
    lastConnectedAt?: {
      __typename?: 'EnergyConsumerBuildingLastConnectedAt';
      value?: number | null;
      timestamp?: number | null;
    } | null;
    disconnectedAt?: {
      __typename?: 'EnergyConsumerBuildingDisconnectedAt';
      value?: number | null;
      timestamp?: number | null;
    } | null;
    tiltAngle?: {
      __typename?: 'EnergySupplierSolarSystemTiltAngle';
      value?: number | null;
      timestamp?: number | null;
      units?: string | null;
    } | null;
    azimuth?: {
      __typename?: 'EnergySupplierSolarSystemAzimuth';
      value?: number | null;
      timestamp?: number | null;
      units?: string | null;
    } | null;
  } | null;
};

export type EnergySupplierSolarSystemDetailQueryVariables = Exact<{
  id: Scalars['String'];
}>;

export type EnergySupplierSolarSystemDetailQuery = {
  __typename?: 'Query';
  energySupplierSolarSystemById?: {
    __typename?: 'EnergySupplierSolarSystem';
    _id: string;
    name?: string | null;
    location?: string | null;
    propertyId?: string | null;
    unitId?: string | null;
    vppId?: string | null;
    updateStatus?: boolean | null;
    timestamp?: number | null;
    maximumPowerOutput?: number | null;
    inverterId?: string | null;
    controllerId?: string | null;
    smsId?: string | null;
    chartTypes: Array<ChartType>;
    powerState?: {
      __typename?: 'EnergyConsumerBuildingPowerState';
      value?: EnumEnergyConsumerBuildingPowerStateValue | null;
      timestamp?: number | null;
      units?: string | null;
    } | null;
    connected?: {
      __typename?: 'EnergyConsumerBuildingConnected';
      value?: boolean | null;
      timestamp?: number | null;
    } | null;
    lastConnectedAt?: {
      __typename?: 'EnergyConsumerBuildingLastConnectedAt';
      value?: number | null;
      timestamp?: number | null;
    } | null;
    disconnectedAt?: {
      __typename?: 'EnergyConsumerBuildingDisconnectedAt';
      value?: number | null;
      timestamp?: number | null;
    } | null;
    tiltAngle?: {
      __typename?: 'EnergySupplierSolarSystemTiltAngle';
      value?: number | null;
      timestamp?: number | null;
      units?: string | null;
    } | null;
    azimuth?: {
      __typename?: 'EnergySupplierSolarSystemAzimuth';
      value?: number | null;
      timestamp?: number | null;
      units?: string | null;
    } | null;
  } | null;
};

export type EnergySupplierUtilityDetailUpdatesSubscriptionVariables = Exact<{
  id: Scalars['String'];
}>;

export type EnergySupplierUtilityDetailUpdatesSubscription = {
  __typename?: 'Subscription';
  energySupplierUtilityEventsByIds?: {
    __typename?: 'EnergySupplierUtility';
    modelChangeOperation?: string | null;
    _id: string;
    name?: string | null;
    location?: string | null;
    propertyId?: string | null;
    unitId?: string | null;
    vppId?: string | null;
    updateStatus?: boolean | null;
    timestamp?: number | null;
    maximumPowerOutput?: number | null;
    chartTypes: Array<ChartType>;
    inverterId?: string | null;
    controllerId?: string | null;
    powerState?: {
      __typename?: 'EnergyConsumerBuildingPowerState';
      value?: EnumEnergyConsumerBuildingPowerStateValue | null;
      timestamp?: number | null;
      units?: string | null;
    } | null;
    contractedCapacity?: {
      __typename?: 'EnergySupplierUtilityContractedCapacity';
      value?: number | null;
      timestamp?: number | null;
      units?: string | null;
    } | null;
    tariffRate?: {
      __typename?: 'EnergySupplierUtilityTariffRate';
      value?: number | null;
      timestamp?: number | null;
      units?: string | null;
    } | null;
    meteringAccuracy?: {
      __typename?: 'EnergySupplierUtilityMeteringAccuracy';
      value?: number | null;
      timestamp?: number | null;
      units?: string | null;
    } | null;
    connected?: {
      __typename?: 'EnergyConsumerBuildingConnected';
      value?: boolean | null;
      timestamp?: number | null;
    } | null;
    lastConnectedAt?: {
      __typename?: 'EnergyConsumerBuildingLastConnectedAt';
      value?: number | null;
      timestamp?: number | null;
    } | null;
    disconnectedAt?: {
      __typename?: 'EnergyConsumerBuildingDisconnectedAt';
      value?: number | null;
      timestamp?: number | null;
    } | null;
  } | null;
};

export type EnergySupplierUtilityDetailQueryVariables = Exact<{
  id: Scalars['String'];
}>;

export type EnergySupplierUtilityDetailQuery = {
  __typename?: 'Query';
  energySupplierUtilityById?: {
    __typename?: 'EnergySupplierUtility';
    _id: string;
    name?: string | null;
    location?: string | null;
    propertyId?: string | null;
    unitId?: string | null;
    vppId?: string | null;
    updateStatus?: boolean | null;
    timestamp?: number | null;
    maximumPowerOutput?: number | null;
    chartTypes: Array<ChartType>;
    inverterId?: string | null;
    controllerId?: string | null;
    powerState?: {
      __typename?: 'EnergyConsumerBuildingPowerState';
      value?: EnumEnergyConsumerBuildingPowerStateValue | null;
      timestamp?: number | null;
      units?: string | null;
    } | null;
    contractedCapacity?: {
      __typename?: 'EnergySupplierUtilityContractedCapacity';
      value?: number | null;
      timestamp?: number | null;
      units?: string | null;
    } | null;
    tariffRate?: {
      __typename?: 'EnergySupplierUtilityTariffRate';
      value?: number | null;
      timestamp?: number | null;
      units?: string | null;
    } | null;
    meteringAccuracy?: {
      __typename?: 'EnergySupplierUtilityMeteringAccuracy';
      value?: number | null;
      timestamp?: number | null;
      units?: string | null;
    } | null;
    connected?: {
      __typename?: 'EnergyConsumerBuildingConnected';
      value?: boolean | null;
      timestamp?: number | null;
    } | null;
    lastConnectedAt?: {
      __typename?: 'EnergyConsumerBuildingLastConnectedAt';
      value?: number | null;
      timestamp?: number | null;
    } | null;
    disconnectedAt?: {
      __typename?: 'EnergyConsumerBuildingDisconnectedAt';
      value?: number | null;
      timestamp?: number | null;
    } | null;
  } | null;
};

export type EnergySupplierWindSystemDetailUpdatesSubscriptionVariables = Exact<{
  id: Scalars['String'];
}>;

export type EnergySupplierWindSystemDetailUpdatesSubscription = {
  __typename?: 'Subscription';
  energySupplierWindSystemEventsByIds?: {
    __typename?: 'EnergySupplierWindSystem';
    modelChangeOperation?: string | null;
    _id: string;
    name?: string | null;
    location?: string | null;
    propertyId?: string | null;
    unitId?: string | null;
    vppId?: string | null;
    updateStatus?: boolean | null;
    timestamp?: number | null;
    maximumPowerOutput?: number | null;
    inverterId?: string | null;
    controllerId?: string | null;
    chartTypes: Array<ChartType>;
    wmsId?: string | null;
    rectifierId?: string | null;
    powerState?: {
      __typename?: 'EnergyConsumerBuildingPowerState';
      value?: EnumEnergyConsumerBuildingPowerStateValue | null;
      timestamp?: number | null;
    } | null;
    connected?: {
      __typename?: 'EnergyConsumerBuildingConnected';
      value?: boolean | null;
      timestamp?: number | null;
    } | null;
    lastConnectedAt?: {
      __typename?: 'EnergyConsumerBuildingLastConnectedAt';
      value?: number | null;
      timestamp?: number | null;
    } | null;
    disconnectedAt?: {
      __typename?: 'EnergyConsumerBuildingDisconnectedAt';
      value?: number | null;
      timestamp?: number | null;
    } | null;
    cutInSpeed?: {
      __typename?: 'EnergySupplierWindSystemCutInSpeed';
      value?: number | null;
      timestamp?: number | null;
      units?: string | null;
    } | null;
    cutOutSpeed?: {
      __typename?: 'EnergySupplierWindSystemCutOutSpeed';
      value?: number | null;
      timestamp?: number | null;
      units?: string | null;
    } | null;
    modeOfOperation?: {
      __typename?: 'EnergySupplierWindSystemModeOfOperation';
      value?: EnumEnergySupplierWindSystemModeOfOperationValue | null;
      timestamp?: number | null;
    } | null;
  } | null;
};

export type EnergySupplierWindSystemDetailQueryVariables = Exact<{
  id: Scalars['String'];
}>;

export type EnergySupplierWindSystemDetailQuery = {
  __typename?: 'Query';
  energySupplierWindSystemById?: {
    __typename?: 'EnergySupplierWindSystem';
    _id: string;
    name?: string | null;
    location?: string | null;
    propertyId?: string | null;
    unitId?: string | null;
    vppId?: string | null;
    updateStatus?: boolean | null;
    timestamp?: number | null;
    maximumPowerOutput?: number | null;
    inverterId?: string | null;
    controllerId?: string | null;
    chartTypes: Array<ChartType>;
    wmsId?: string | null;
    rectifierId?: string | null;
    powerState?: {
      __typename?: 'EnergyConsumerBuildingPowerState';
      value?: EnumEnergyConsumerBuildingPowerStateValue | null;
      timestamp?: number | null;
    } | null;
    connected?: {
      __typename?: 'EnergyConsumerBuildingConnected';
      value?: boolean | null;
      timestamp?: number | null;
    } | null;
    lastConnectedAt?: {
      __typename?: 'EnergyConsumerBuildingLastConnectedAt';
      value?: number | null;
      timestamp?: number | null;
    } | null;
    disconnectedAt?: {
      __typename?: 'EnergyConsumerBuildingDisconnectedAt';
      value?: number | null;
      timestamp?: number | null;
    } | null;
    cutInSpeed?: {
      __typename?: 'EnergySupplierWindSystemCutInSpeed';
      value?: number | null;
      timestamp?: number | null;
      units?: string | null;
    } | null;
    cutOutSpeed?: {
      __typename?: 'EnergySupplierWindSystemCutOutSpeed';
      value?: number | null;
      timestamp?: number | null;
      units?: string | null;
    } | null;
    modeOfOperation?: {
      __typename?: 'EnergySupplierWindSystemModeOfOperation';
      value?: EnumEnergySupplierWindSystemModeOfOperationValue | null;
      timestamp?: number | null;
    } | null;
  } | null;
};

export type EnergySwitchPanelCircuitDetailUpdatesSubscriptionVariables = Exact<{
  id: Scalars['String'];
}>;

export type EnergySwitchPanelCircuitDetailUpdatesSubscription = {
  __typename?: 'Subscription';
  energySwitchPanelCircuitEventsByIds?: {
    __typename?: 'EnergySwitchPanelCircuit';
    modelChangeOperation?: string | null;
    _id: string;
    deviceId?: string | null;
    name?: string | null;
    type?: EnumDKeyDeviceType | null;
    location?: string | null;
    propertyId: string;
    unitId: string;
    panelId?: string | null;
    sourceId?: string | null;
    updateStatus?: boolean | null;
    timestamp?: number | null;
    typeDisplayName: string;
    isConfigured?: boolean | null;
    isPoweredOn?: boolean | null;
    deviceIdentifier?: string | null;
    hasPendingUpdates: boolean;
    isControlled: boolean;
    energySwitchPanelId?: string | null;
    chartTypes: Array<ChartType>;
    meta?: {
      __typename?: 'DeviceMeta';
      name?: string | null;
      metrics?: any | null;
    } | null;
    installation?: {
      __typename?: 'DeviceInstallation';
      status: number;
      message?: string | null;
    } | null;
    powerState?: {
      __typename?: 'DevicePowerState';
      value?: EnumDevicePowerStateValue | null;
      timestamp?: number | null;
    } | null;
    energyConsumed?: {
      __typename?: 'EnergySwitchPanelCircuitEnergyConsumed';
      value?: number | null;
      timestamp?: number | null;
      units?: string | null;
    } | null;
    powerDemand?: {
      __typename?: 'EnergySwitchPanelCircuitPowerDemand';
      value?: number | null;
      timestamp?: number | null;
      units?: string | null;
    } | null;
    voltage?: {
      __typename?: 'EnergySwitchPanelCircuitVoltage';
      value?: number | null;
      timestamp?: number | null;
      units?: string | null;
    } | null;
    current?: {
      __typename?: 'EnergySwitchPanelCircuitCurrent';
      value?: number | null;
      timestamp?: number | null;
      units?: string | null;
    } | null;
    powerFactor?: {
      __typename?: 'EnergySwitchPanelCircuitPowerFactor';
      value?: number | null;
      timestamp?: number | null;
      units?: string | null;
    } | null;
    frequency?: {
      __typename?: 'EnergySwitchPanelCircuitFrequency';
      value?: number | null;
      timestamp?: number | null;
      units?: string | null;
    } | null;
    outputEnabled?: {
      __typename?: 'EnergySwitchPanelCircuitOutputEnabled';
      value?: boolean | null;
      timestamp?: number | null;
    } | null;
    property?: { __typename?: 'Property'; _id: string; title: string } | null;
    unit?: { __typename?: 'Unit'; _id: string; name: string } | null;
    panel?: {
      __typename?: 'Panel';
      _id: string;
      name?: string | null;
      displayName?: string | null;
    } | null;
    source?: { __typename?: 'Source'; _id: string; name: string } | null;
  } | null;
};

export type EnergySwitchPanelCircuitDetailQueryVariables = Exact<{
  id: Scalars['String'];
}>;

export type EnergySwitchPanelCircuitDetailQuery = {
  __typename?: 'Query';
  energySwitchPanelCircuitById?: {
    __typename?: 'EnergySwitchPanelCircuit';
    _id: string;
    deviceId?: string | null;
    name?: string | null;
    type?: EnumDKeyDeviceType | null;
    location?: string | null;
    propertyId: string;
    unitId: string;
    panelId?: string | null;
    sourceId?: string | null;
    updateStatus?: boolean | null;
    timestamp?: number | null;
    typeDisplayName: string;
    isConfigured?: boolean | null;
    isPoweredOn?: boolean | null;
    deviceIdentifier?: string | null;
    hasPendingUpdates: boolean;
    isControlled: boolean;
    energySwitchPanelId?: string | null;
    chartTypes: Array<ChartType>;
    meta?: {
      __typename?: 'DeviceMeta';
      name?: string | null;
      metrics?: any | null;
    } | null;
    installation?: {
      __typename?: 'DeviceInstallation';
      status: number;
      message?: string | null;
    } | null;
    powerState?: {
      __typename?: 'DevicePowerState';
      value?: EnumDevicePowerStateValue | null;
      timestamp?: number | null;
    } | null;
    energyConsumed?: {
      __typename?: 'EnergySwitchPanelCircuitEnergyConsumed';
      value?: number | null;
      timestamp?: number | null;
      units?: string | null;
    } | null;
    powerDemand?: {
      __typename?: 'EnergySwitchPanelCircuitPowerDemand';
      value?: number | null;
      timestamp?: number | null;
      units?: string | null;
    } | null;
    voltage?: {
      __typename?: 'EnergySwitchPanelCircuitVoltage';
      value?: number | null;
      timestamp?: number | null;
      units?: string | null;
    } | null;
    current?: {
      __typename?: 'EnergySwitchPanelCircuitCurrent';
      value?: number | null;
      timestamp?: number | null;
      units?: string | null;
    } | null;
    powerFactor?: {
      __typename?: 'EnergySwitchPanelCircuitPowerFactor';
      value?: number | null;
      timestamp?: number | null;
      units?: string | null;
    } | null;
    frequency?: {
      __typename?: 'EnergySwitchPanelCircuitFrequency';
      value?: number | null;
      timestamp?: number | null;
      units?: string | null;
    } | null;
    outputEnabled?: {
      __typename?: 'EnergySwitchPanelCircuitOutputEnabled';
      value?: boolean | null;
      timestamp?: number | null;
    } | null;
    property?: { __typename?: 'Property'; _id: string; title: string } | null;
    unit?: { __typename?: 'Unit'; _id: string; name: string } | null;
    panel?: {
      __typename?: 'Panel';
      _id: string;
      name?: string | null;
      displayName?: string | null;
    } | null;
    source?: { __typename?: 'Source'; _id: string; name: string } | null;
  } | null;
};

export type EnergySwitchPanelDetailUpdatesSubscriptionVariables = Exact<{
  id: Scalars['String'];
}>;

export type EnergySwitchPanelDetailUpdatesSubscription = {
  __typename?: 'Subscription';
  energySwitchPanelEventsByIds?: {
    __typename?: 'EnergySwitchPanel';
    modelChangeOperation?: string | null;
    _id: string;
    deviceId?: string | null;
    name?: string | null;
    type?: EnumDKeyDeviceType | null;
    location?: string | null;
    propertyId: string;
    unitId: string;
    panelId?: string | null;
    sourceId?: string | null;
    updateStatus?: boolean | null;
    timestamp?: number | null;
    typeDisplayName: string;
    isConfigured?: boolean | null;
    isPoweredOn?: boolean | null;
    deviceIdentifier?: string | null;
    hasPendingUpdates: boolean;
    isControlled: boolean;
    maxCircuits?: number | null;
    chartTypes: Array<ChartType>;
    dependentDeviceIds: Array<string | null>;
    meta?: {
      __typename?: 'DeviceMeta';
      name?: string | null;
      metrics?: any | null;
    } | null;
    installation?: {
      __typename?: 'DeviceInstallation';
      status: number;
      message?: string | null;
    } | null;
    powerState?: {
      __typename?: 'DevicePowerState';
      value?: EnumDevicePowerStateValue | null;
      timestamp?: number | null;
    } | null;
    powerInput?: {
      __typename?: 'EnergySwitchPanelPowerInput';
      value?: number | null;
      timestamp?: number | null;
      units?: string | null;
    } | null;
    property?: { __typename?: 'Property'; _id: string; title: string } | null;
    unit?: { __typename?: 'Unit'; _id: string; name: string } | null;
    panel?: {
      __typename?: 'Panel';
      _id: string;
      name?: string | null;
      displayName?: string | null;
    } | null;
    source?: { __typename?: 'Source'; _id: string; name: string } | null;
  } | null;
};

export type EnergySwitchPanelDetailQueryVariables = Exact<{
  id: Scalars['String'];
}>;

export type EnergySwitchPanelDetailQuery = {
  __typename?: 'Query';
  energySwitchPanelById?: {
    __typename?: 'EnergySwitchPanel';
    _id: string;
    deviceId?: string | null;
    name?: string | null;
    type?: EnumDKeyDeviceType | null;
    location?: string | null;
    propertyId: string;
    unitId: string;
    panelId?: string | null;
    sourceId?: string | null;
    updateStatus?: boolean | null;
    timestamp?: number | null;
    typeDisplayName: string;
    isConfigured?: boolean | null;
    isPoweredOn?: boolean | null;
    deviceIdentifier?: string | null;
    hasPendingUpdates: boolean;
    isControlled: boolean;
    maxCircuits?: number | null;
    displayName?: string | null;
    chartTypes: Array<ChartType>;
    dependentDeviceIds: Array<string | null>;
    meta?: {
      __typename?: 'DeviceMeta';
      name?: string | null;
      metrics?: any | null;
    } | null;
    installation?: {
      __typename?: 'DeviceInstallation';
      status: number;
      message?: string | null;
    } | null;
    powerState?: {
      __typename?: 'DevicePowerState';
      value?: EnumDevicePowerStateValue | null;
      timestamp?: number | null;
    } | null;
    powerInput?: {
      __typename?: 'EnergySwitchPanelPowerInput';
      value?: number | null;
      timestamp?: number | null;
      units?: string | null;
    } | null;
    property?: { __typename?: 'Property'; _id: string; title: string } | null;
    unit?: { __typename?: 'Unit'; _id: string; name: string } | null;
    panel?: {
      __typename?: 'Panel';
      _id: string;
      name?: string | null;
      displayName?: string | null;
    } | null;
    source?: { __typename?: 'Source'; _id: string; name: string } | null;
  } | null;
};

export type FireSuppressionSystemDetailUpdatesSubscriptionVariables = Exact<{
  id: Scalars['String'];
}>;

export type FireSuppressionSystemDetailUpdatesSubscription = {
  __typename?: 'Subscription';
  fireSuppressionSystemEventsByIds?: {
    __typename?: 'FireSuppressionSystem';
    modelChangeOperation?: string | null;
    _id: string;
    deviceId?: string | null;
    name?: string | null;
    type?: EnumDKeyDeviceType | null;
    location?: string | null;
    propertyId: string;
    unitId: string;
    panelId?: string | null;
    sourceId?: string | null;
    updateStatus?: boolean | null;
    timestamp?: number | null;
    typeDisplayName: string;
    isConfigured?: boolean | null;
    isPoweredOn?: boolean | null;
    deviceIdentifier?: string | null;
    hasPendingUpdates: boolean;
    isControlled: boolean;
    chartTypes: Array<ChartType>;
    meta?: {
      __typename?: 'DeviceMeta';
      name?: string | null;
      metrics?: any | null;
    } | null;
    installation?: {
      __typename?: 'DeviceInstallation';
      status: number;
      message?: string | null;
    } | null;
    powerState?: {
      __typename?: 'DevicePowerState';
      value?: EnumDevicePowerStateValue | null;
      timestamp?: number | null;
    } | null;
    fireSuppressionStatus?: {
      __typename?: 'FireSuppressionSystemFireSuppressionStatus';
      value?: EnumFireSuppressionSystemFireSuppressionStatusValue | null;
      timestamp?: number | null;
    } | null;
    sensorStatus?: {
      __typename?: 'FireSuppressionSystemSensorStatus';
      value?: EnumFireSuppressionSystemSensorStatusValue | null;
      timestamp?: number | null;
    } | null;
    suppressantLevel?: {
      __typename?: 'FireSuppressionSystemSuppressantLevel';
      value?: number | null;
      timestamp?: number | null;
      units?: string | null;
    } | null;
    property?: { __typename?: 'Property'; _id: string; title: string } | null;
    unit?: { __typename?: 'Unit'; _id: string; name: string } | null;
    panel?: {
      __typename?: 'Panel';
      _id: string;
      name?: string | null;
      displayName?: string | null;
    } | null;
    source?: { __typename?: 'Source'; _id: string; name: string } | null;
  } | null;
};

export type FireSuppressionSystemDetailQueryVariables = Exact<{
  id: Scalars['String'];
}>;

export type FireSuppressionSystemDetailQuery = {
  __typename?: 'Query';
  fireSuppressionSystemById?: {
    __typename?: 'FireSuppressionSystem';
    _id: string;
    deviceId?: string | null;
    name?: string | null;
    type?: EnumDKeyDeviceType | null;
    location?: string | null;
    propertyId: string;
    unitId: string;
    panelId?: string | null;
    sourceId?: string | null;
    updateStatus?: boolean | null;
    timestamp?: number | null;
    typeDisplayName: string;
    isConfigured?: boolean | null;
    isPoweredOn?: boolean | null;
    deviceIdentifier?: string | null;
    hasPendingUpdates: boolean;
    isControlled: boolean;
    chartTypes: Array<ChartType>;
    meta?: {
      __typename?: 'DeviceMeta';
      name?: string | null;
      metrics?: any | null;
    } | null;
    installation?: {
      __typename?: 'DeviceInstallation';
      status: number;
      message?: string | null;
    } | null;
    powerState?: {
      __typename?: 'DevicePowerState';
      value?: EnumDevicePowerStateValue | null;
      timestamp?: number | null;
    } | null;
    fireSuppressionStatus?: {
      __typename?: 'FireSuppressionSystemFireSuppressionStatus';
      value?: EnumFireSuppressionSystemFireSuppressionStatusValue | null;
      timestamp?: number | null;
    } | null;
    sensorStatus?: {
      __typename?: 'FireSuppressionSystemSensorStatus';
      value?: EnumFireSuppressionSystemSensorStatusValue | null;
      timestamp?: number | null;
    } | null;
    suppressantLevel?: {
      __typename?: 'FireSuppressionSystemSuppressantLevel';
      value?: number | null;
      timestamp?: number | null;
      units?: string | null;
    } | null;
    property?: { __typename?: 'Property'; _id: string; title: string } | null;
    unit?: { __typename?: 'Unit'; _id: string; name: string } | null;
    panel?: {
      __typename?: 'Panel';
      _id: string;
      name?: string | null;
      displayName?: string | null;
    } | null;
    source?: { __typename?: 'Source'; _id: string; name: string } | null;
  } | null;
};

export type KineticEnergyManagementSystemDetailUpdatesSubscriptionVariables =
  Exact<{
    id: Scalars['String'];
  }>;

export type KineticEnergyManagementSystemDetailUpdatesSubscription = {
  __typename?: 'Subscription';
  kineticEnergyManagementSystemEventsByIds?: {
    __typename?: 'KineticEnergyManagementSystem';
    modelChangeOperation?: string | null;
    _id: string;
    deviceId?: string | null;
    name?: string | null;
    type?: EnumDKeyDeviceType | null;
    location?: string | null;
    propertyId: string;
    unitId: string;
    panelId?: string | null;
    sourceId?: string | null;
    updateStatus?: boolean | null;
    timestamp?: number | null;
    typeDisplayName: string;
    isConfigured?: boolean | null;
    isPoweredOn?: boolean | null;
    deviceIdentifier?: string | null;
    hasPendingUpdates: boolean;
    isControlled: boolean;
    chartTypes: Array<ChartType>;
    meta?: {
      __typename?: 'DeviceMeta';
      name?: string | null;
      metrics?: any | null;
    } | null;
    installation?: {
      __typename?: 'DeviceInstallation';
      status: number;
      message?: string | null;
    } | null;
    powerState?: {
      __typename?: 'DevicePowerState';
      value?: EnumDevicePowerStateValue | null;
      timestamp?: number | null;
    } | null;
    currentEnergyStored?: {
      __typename?: 'KineticEnergyManagementSystemCurrentEnergyStored';
      value?: number | null;
      timestamp?: number | null;
      units?: string | null;
    } | null;
    rotorSpeed?: {
      __typename?: 'KineticEnergyManagementSystemRotorSpeed';
      value?: number | null;
      timestamp?: number | null;
      units?: string | null;
    } | null;
    spinDownTime?: {
      __typename?: 'KineticEnergyManagementSystemSpinDownTime';
      value?: number | null;
      timestamp?: number | null;
      units?: string | null;
    } | null;
    generatorVoltage?: {
      __typename?: 'KineticEnergyManagementSystemGeneratorVoltage';
      value?: number | null;
      timestamp?: number | null;
      units?: string | null;
    } | null;
    generatorCurrent?: {
      __typename?: 'KineticEnergyManagementSystemGeneratorCurrent';
      value?: number | null;
      timestamp?: number | null;
      units?: string | null;
    } | null;
    bearingTemperature?: {
      __typename?: 'KineticEnergyManagementSystemBearingTemperature';
      value?: number | null;
      timestamp?: number | null;
      units?: string | null;
    } | null;
    stateOfHealth?: {
      __typename?: 'KineticEnergyManagementSystemStateOfHealth';
      value?: number | null;
      timestamp?: number | null;
      units?: string | null;
    } | null;
    systemEfficiency?: {
      __typename?: 'KineticEnergyManagementSystemSystemEfficiency';
      value?: number | null;
      timestamp?: number | null;
      units?: string | null;
    } | null;
    vibrationMetrics?: {
      __typename?: 'KineticEnergyManagementSystemVibrationMetrics';
      value?: number | null;
      timestamp?: number | null;
      units?: string | null;
    } | null;
    cycleCount?: {
      __typename?: 'KineticEnergyManagementSystemCycleCount';
      value?: number | null;
      timestamp?: number | null;
      units?: string | null;
    } | null;
    vacuumPressure?: {
      __typename?: 'KineticEnergyManagementSystemVacuumPressure';
      value?: number | null;
      timestamp?: number | null;
      units?: string | null;
    } | null;
    property?: { __typename?: 'Property'; _id: string; title: string } | null;
    unit?: { __typename?: 'Unit'; _id: string; name: string } | null;
    panel?: {
      __typename?: 'Panel';
      _id: string;
      name?: string | null;
      displayName?: string | null;
    } | null;
    source?: { __typename?: 'Source'; _id: string; name: string } | null;
  } | null;
};

export type KineticEnergyManagementSystemDetailQueryVariables = Exact<{
  id: Scalars['String'];
}>;

export type KineticEnergyManagementSystemDetailQuery = {
  __typename?: 'Query';
  kineticEnergyManagementSystemById?: {
    __typename?: 'KineticEnergyManagementSystem';
    _id: string;
    deviceId?: string | null;
    name?: string | null;
    type?: EnumDKeyDeviceType | null;
    location?: string | null;
    propertyId: string;
    unitId: string;
    panelId?: string | null;
    sourceId?: string | null;
    updateStatus?: boolean | null;
    timestamp?: number | null;
    typeDisplayName: string;
    isConfigured?: boolean | null;
    isPoweredOn?: boolean | null;
    deviceIdentifier?: string | null;
    hasPendingUpdates: boolean;
    isControlled: boolean;
    chartTypes: Array<ChartType>;
    meta?: {
      __typename?: 'DeviceMeta';
      name?: string | null;
      metrics?: any | null;
    } | null;
    installation?: {
      __typename?: 'DeviceInstallation';
      status: number;
      message?: string | null;
    } | null;
    powerState?: {
      __typename?: 'DevicePowerState';
      value?: EnumDevicePowerStateValue | null;
      timestamp?: number | null;
    } | null;
    currentEnergyStored?: {
      __typename?: 'KineticEnergyManagementSystemCurrentEnergyStored';
      value?: number | null;
      timestamp?: number | null;
      units?: string | null;
    } | null;
    rotorSpeed?: {
      __typename?: 'KineticEnergyManagementSystemRotorSpeed';
      value?: number | null;
      timestamp?: number | null;
      units?: string | null;
    } | null;
    spinDownTime?: {
      __typename?: 'KineticEnergyManagementSystemSpinDownTime';
      value?: number | null;
      timestamp?: number | null;
      units?: string | null;
    } | null;
    generatorVoltage?: {
      __typename?: 'KineticEnergyManagementSystemGeneratorVoltage';
      value?: number | null;
      timestamp?: number | null;
      units?: string | null;
    } | null;
    generatorCurrent?: {
      __typename?: 'KineticEnergyManagementSystemGeneratorCurrent';
      value?: number | null;
      timestamp?: number | null;
      units?: string | null;
    } | null;
    bearingTemperature?: {
      __typename?: 'KineticEnergyManagementSystemBearingTemperature';
      value?: number | null;
      timestamp?: number | null;
      units?: string | null;
    } | null;
    stateOfHealth?: {
      __typename?: 'KineticEnergyManagementSystemStateOfHealth';
      value?: number | null;
      timestamp?: number | null;
      units?: string | null;
    } | null;
    systemEfficiency?: {
      __typename?: 'KineticEnergyManagementSystemSystemEfficiency';
      value?: number | null;
      timestamp?: number | null;
      units?: string | null;
    } | null;
    vibrationMetrics?: {
      __typename?: 'KineticEnergyManagementSystemVibrationMetrics';
      value?: number | null;
      timestamp?: number | null;
      units?: string | null;
    } | null;
    cycleCount?: {
      __typename?: 'KineticEnergyManagementSystemCycleCount';
      value?: number | null;
      timestamp?: number | null;
      units?: string | null;
    } | null;
    vacuumPressure?: {
      __typename?: 'KineticEnergyManagementSystemVacuumPressure';
      value?: number | null;
      timestamp?: number | null;
      units?: string | null;
    } | null;
    property?: { __typename?: 'Property'; _id: string; title: string } | null;
    unit?: { __typename?: 'Unit'; _id: string; name: string } | null;
    panel?: {
      __typename?: 'Panel';
      _id: string;
      name?: string | null;
      displayName?: string | null;
    } | null;
    source?: { __typename?: 'Source'; _id: string; name: string } | null;
  } | null;
};

export type SolarManagementSystemDetailUpdatesSubscriptionVariables = Exact<{
  id: Scalars['String'];
}>;

export type SolarManagementSystemDetailUpdatesSubscription = {
  __typename?: 'Subscription';
  solarManagementSystemEventsByIds?: {
    __typename?: 'SolarManagementSystem';
    modelChangeOperation?: string | null;
    _id: string;
    deviceId?: string | null;
    name?: string | null;
    type?: EnumDKeyDeviceType | null;
    location?: string | null;
    propertyId: string;
    unitId: string;
    panelId?: string | null;
    sourceId?: string | null;
    updateStatus?: boolean | null;
    timestamp?: number | null;
    typeDisplayName: string;
    isConfigured?: boolean | null;
    isPoweredOn?: boolean | null;
    deviceIdentifier?: string | null;
    hasPendingUpdates: boolean;
    isControlled: boolean;
    chartTypes: Array<ChartType>;
    meta?: {
      __typename?: 'DeviceMeta';
      name?: string | null;
      metrics?: any | null;
    } | null;
    installation?: {
      __typename?: 'DeviceInstallation';
      status: number;
      message?: string | null;
    } | null;
    powerState?: {
      __typename?: 'DevicePowerState';
      value?: EnumDevicePowerStateValue | null;
      timestamp?: number | null;
    } | null;
    solarIrradiance?: {
      __typename?: 'SolarManagementSystemSolarIrradiance';
      value?: number | null;
      timestamp?: number | null;
      units?: string | null;
    } | null;
    panelTemperature?: {
      __typename?: 'SolarManagementSystemPanelTemperature';
      value?: number | null;
      timestamp?: number | null;
      units?: string | null;
    } | null;
    degradationRate?: {
      __typename?: 'SolarManagementSystemDegradationRate';
      value?: number | null;
      timestamp?: number | null;
      units?: string | null;
    } | null;
    shadingFactor?: {
      __typename?: 'SolarManagementSystemShadingFactor';
      value?: number | null;
      timestamp?: number | null;
      units?: string | null;
    } | null;
    tiltAngle?: {
      __typename?: 'SolarManagementSystemTiltAngle';
      value?: number | null;
      timestamp?: number | null;
      units?: string | null;
    } | null;
    azimuth?: {
      __typename?: 'SolarManagementSystemAzimuth';
      value?: number | null;
      timestamp?: number | null;
      units?: string | null;
    } | null;
    panelVoltages?: Array<{
      __typename?: 'SolarManagementSystemPanelVoltages';
      value?: number | null;
      timestamp?: number | null;
      units?: string | null;
    } | null> | null;
    panelCurrents?: Array<{
      __typename?: 'SolarManagementSystemPanelCurrents';
      value?: number | null;
      timestamp?: number | null;
      units?: string | null;
    } | null> | null;
    isTrackerSystem?: {
      __typename?: 'SolarManagementSystemIsTrackerSystem';
      value?: boolean | null;
      timestamp?: number | null;
    } | null;
    property?: { __typename?: 'Property'; _id: string; title: string } | null;
    panel?: {
      __typename?: 'Panel';
      _id: string;
      name?: string | null;
      displayName?: string | null;
    } | null;
    source?: { __typename?: 'Source'; _id: string; name: string } | null;
  } | null;
};

export type SolarManagementSystemDetailQueryVariables = Exact<{
  id: Scalars['String'];
}>;

export type SolarManagementSystemDetailQuery = {
  __typename?: 'Query';
  solarManagementSystemById?: {
    __typename?: 'SolarManagementSystem';
    _id: string;
    deviceId?: string | null;
    name?: string | null;
    type?: EnumDKeyDeviceType | null;
    location?: string | null;
    propertyId: string;
    unitId: string;
    panelId?: string | null;
    sourceId?: string | null;
    updateStatus?: boolean | null;
    timestamp?: number | null;
    typeDisplayName: string;
    isConfigured?: boolean | null;
    isPoweredOn?: boolean | null;
    deviceIdentifier?: string | null;
    hasPendingUpdates: boolean;
    isControlled: boolean;
    chartTypes: Array<ChartType>;
    meta?: {
      __typename?: 'DeviceMeta';
      name?: string | null;
      metrics?: any | null;
    } | null;
    installation?: {
      __typename?: 'DeviceInstallation';
      status: number;
      message?: string | null;
    } | null;
    powerState?: {
      __typename?: 'DevicePowerState';
      value?: EnumDevicePowerStateValue | null;
      timestamp?: number | null;
    } | null;
    solarIrradiance?: {
      __typename?: 'SolarManagementSystemSolarIrradiance';
      value?: number | null;
      timestamp?: number | null;
      units?: string | null;
    } | null;
    panelTemperature?: {
      __typename?: 'SolarManagementSystemPanelTemperature';
      value?: number | null;
      timestamp?: number | null;
      units?: string | null;
    } | null;
    degradationRate?: {
      __typename?: 'SolarManagementSystemDegradationRate';
      value?: number | null;
      timestamp?: number | null;
      units?: string | null;
    } | null;
    shadingFactor?: {
      __typename?: 'SolarManagementSystemShadingFactor';
      value?: number | null;
      timestamp?: number | null;
      units?: string | null;
    } | null;
    tiltAngle?: {
      __typename?: 'SolarManagementSystemTiltAngle';
      value?: number | null;
      timestamp?: number | null;
      units?: string | null;
    } | null;
    azimuth?: {
      __typename?: 'SolarManagementSystemAzimuth';
      value?: number | null;
      timestamp?: number | null;
      units?: string | null;
    } | null;
    panelVoltages?: Array<{
      __typename?: 'SolarManagementSystemPanelVoltages';
      value?: number | null;
      timestamp?: number | null;
      units?: string | null;
    } | null> | null;
    panelCurrents?: Array<{
      __typename?: 'SolarManagementSystemPanelCurrents';
      value?: number | null;
      timestamp?: number | null;
      units?: string | null;
    } | null> | null;
    isTrackerSystem?: {
      __typename?: 'SolarManagementSystemIsTrackerSystem';
      value?: boolean | null;
      timestamp?: number | null;
    } | null;
    property?: { __typename?: 'Property'; _id: string; title: string } | null;
    panel?: {
      __typename?: 'Panel';
      _id: string;
      name?: string | null;
      displayName?: string | null;
    } | null;
    source?: { __typename?: 'Source'; _id: string; name: string } | null;
  } | null;
};

export type VirtualPowerPlantDetailUpdatesSubscriptionVariables = Exact<{
  id: Scalars['String'];
}>;

export type VirtualPowerPlantDetailUpdatesSubscription = {
  __typename?: 'Subscription';
  virtualPowerPlantEventsByIds?: {
    __typename?: 'VirtualPowerPlant';
    modelChangeOperation?: string | null;
    _id: string;
    name?: string | null;
    location?: string | null;
    propertyId?: string | null;
    unitId?: string | null;
    updateStatus?: boolean | null;
    timestamp?: number | null;
    inverterId?: string | null;
    switchPanelId?: string | null;
    chartTypes: Array<ChartType>;
    operationalStatus?: {
      __typename?: 'VirtualPowerPlantOperationalStatus';
      value?: EnumVirtualPowerPlantOperationalStatusValue | null;
      timestamp?: number | null;
    } | null;
  } | null;
};

export type VirtualPowerPlantDetailQueryVariables = Exact<{
  id: Scalars['String'];
}>;

export type VirtualPowerPlantDetailQuery = {
  __typename?: 'Query';
  virtualPowerPlantById?: {
    __typename?: 'VirtualPowerPlant';
    _id: string;
    name?: string | null;
    location?: string | null;
    propertyId?: string | null;
    unitId?: string | null;
    updateStatus?: boolean | null;
    timestamp?: number | null;
    inverterId?: string | null;
    switchPanelId?: string | null;
    chartTypes: Array<ChartType>;
    operationalStatus?: {
      __typename?: 'VirtualPowerPlantOperationalStatus';
      value?: EnumVirtualPowerPlantOperationalStatusValue | null;
      timestamp?: number | null;
    } | null;
  } | null;
};

export type WindManagementSystemDetailUpdatesSubscriptionVariables = Exact<{
  id: Scalars['String'];
}>;

export type WindManagementSystemDetailUpdatesSubscription = {
  __typename?: 'Subscription';
  windManagementSystemEventsByIds?: {
    __typename?: 'WindManagementSystem';
    modelChangeOperation?: string | null;
    _id: string;
    deviceId?: string | null;
    name?: string | null;
    type?: EnumDKeyDeviceType | null;
    location?: string | null;
    chartTypes: Array<ChartType>;
    powerState?: {
      __typename?: 'DevicePowerState';
      value?: EnumDevicePowerStateValue | null;
      units?: string | null;
      timestamp?: number | null;
    } | null;
    windSpeed?: {
      __typename?: 'WindManagementSystemWindSpeed';
      value?: number | null;
      units?: string | null;
      timestamp?: number | null;
    } | null;
    windDirection?: {
      __typename?: 'WindManagementSystemWindDirection';
      value?: number | null;
      units?: string | null;
      timestamp?: number | null;
    } | null;
    rotorSpeed?: {
      __typename?: 'WindManagementSystemRotorSpeed';
      value?: number | null;
      units?: string | null;
      timestamp?: number | null;
    } | null;
    pitchAngle?: {
      __typename?: 'WindManagementSystemPitchAngle';
      value?: number | null;
      units?: string | null;
      timestamp?: number | null;
    } | null;
    yawControlStatus?: {
      __typename?: 'WindManagementSystemYawControlStatus';
      value?: EnumWindManagementSystemYawControlStatusValue | null;
      timestamp?: number | null;
    } | null;
    vibrationLevel?: {
      __typename?: 'WindManagementSystemVibrationLevel';
      value?: number | null;
      units?: string | null;
      timestamp?: number | null;
    } | null;
    generatorTemperature?: {
      __typename?: 'WindManagementSystemGeneratorTemperature';
      value?: number | null;
      units?: string | null;
      timestamp?: number | null;
    } | null;
    brakeStatus?: {
      __typename?: 'WindManagementSystemBrakeStatus';
      value?: EnumWindManagementSystemBrakeStatusValue | null;
      timestamp?: number | null;
    } | null;
    bladeCondition?: {
      __typename?: 'WindManagementSystemBladeCondition';
      value?: EnumWindManagementSystemBladeConditionValue | null;
      timestamp?: number | null;
    } | null;
    iceDetectionStatus?: {
      __typename?: 'WindManagementSystemIceDetectionStatus';
      value?: EnumWindManagementSystemIceDetectionStatusValue | null;
      timestamp?: number | null;
    } | null;
    property?: { __typename?: 'Property'; _id: string; name: string } | null;
    unit?: { __typename?: 'Unit'; _id: string; name: string } | null;
    panel?: { __typename?: 'Panel'; _id: string; name?: string | null } | null;
    source?: { __typename?: 'Source'; _id: string; name: string } | null;
  } | null;
};

export type WindManagementSystemDetailQueryVariables = Exact<{
  id: Scalars['String'];
}>;

export type WindManagementSystemDetailQuery = {
  __typename?: 'Query';
  windManagementSystemById?: {
    __typename?: 'WindManagementSystem';
    _id: string;
    deviceId?: string | null;
    name?: string | null;
    type?: EnumDKeyDeviceType | null;
    location?: string | null;
    chartTypes: Array<ChartType>;
    powerState?: {
      __typename?: 'DevicePowerState';
      value?: EnumDevicePowerStateValue | null;
      units?: string | null;
      timestamp?: number | null;
    } | null;
    windSpeed?: {
      __typename?: 'WindManagementSystemWindSpeed';
      value?: number | null;
      units?: string | null;
      timestamp?: number | null;
    } | null;
    windDirection?: {
      __typename?: 'WindManagementSystemWindDirection';
      value?: number | null;
      units?: string | null;
      timestamp?: number | null;
    } | null;
    rotorSpeed?: {
      __typename?: 'WindManagementSystemRotorSpeed';
      value?: number | null;
      units?: string | null;
      timestamp?: number | null;
    } | null;
    pitchAngle?: {
      __typename?: 'WindManagementSystemPitchAngle';
      value?: number | null;
      units?: string | null;
      timestamp?: number | null;
    } | null;
    yawControlStatus?: {
      __typename?: 'WindManagementSystemYawControlStatus';
      value?: EnumWindManagementSystemYawControlStatusValue | null;
      timestamp?: number | null;
    } | null;
    vibrationLevel?: {
      __typename?: 'WindManagementSystemVibrationLevel';
      value?: number | null;
      units?: string | null;
      timestamp?: number | null;
    } | null;
    generatorTemperature?: {
      __typename?: 'WindManagementSystemGeneratorTemperature';
      value?: number | null;
      units?: string | null;
      timestamp?: number | null;
    } | null;
    brakeStatus?: {
      __typename?: 'WindManagementSystemBrakeStatus';
      value?: EnumWindManagementSystemBrakeStatusValue | null;
      timestamp?: number | null;
    } | null;
    bladeCondition?: {
      __typename?: 'WindManagementSystemBladeCondition';
      value?: EnumWindManagementSystemBladeConditionValue | null;
      timestamp?: number | null;
    } | null;
    iceDetectionStatus?: {
      __typename?: 'WindManagementSystemIceDetectionStatus';
      value?: EnumWindManagementSystemIceDetectionStatusValue | null;
      timestamp?: number | null;
    } | null;
    property?: { __typename?: 'Property'; _id: string; name: string } | null;
    unit?: { __typename?: 'Unit'; _id: string; name: string } | null;
    panel?: { __typename?: 'Panel'; _id: string; name?: string | null } | null;
    source?: { __typename?: 'Source'; _id: string; name: string } | null;
  } | null;
};

export type CreateZonePolicyMutationVariables = Exact<{
  policy: CreateOneZonePolicyInput;
}>;

export type CreateZonePolicyMutation = {
  __typename?: 'Mutation';
  createZonePolicy?: {
    __typename?: 'ZonePolicy';
    _id: any;
    name?: string | null;
    properties?: Array<string | null> | null;
    rules?: Array<{
      __typename?: 'ZonePolicyRules';
      type: EnumZonePolicyRulesType;
      source?: {
        __typename?: 'ZonePolicyRulesSource';
        deviceType: string;
        multiplicity?: EnumZonePolicyRulesSourceMultiplicity | null;
        attributes?: {
          __typename?: 'ZonePolicyRulesSourceAttributes';
          operatingMode?: string | null;
          operatingState?: string | null;
          heatSetpoint?: string | null;
          coolSetpoint?: string | null;
          contactState?: string | null;
          fanSpeed?: string | null;
          indoorFanStatus?: string | null;
          keypadLockoutLevel?: string | null;
        } | null;
      } | null;
      target?: {
        __typename?: 'ZonePolicyRulesTarget';
        deviceType: string;
        multiplicity?: EnumZonePolicyRulesTargetMultiplicity | null;
        attributes?: {
          __typename?: 'ZonePolicyRulesTargetAttributes';
          isOn?: string | null;
          heatSetpoint?: string | null;
          coolSetpoint?: string | null;
          keypadLockoutLevel?: string | null;
        } | null;
      } | null;
    } | null> | null;
  } | null;
};

export type DeleteZonePolicyMutationVariables = Exact<{
  id: Scalars['String'];
}>;

export type DeleteZonePolicyMutation = {
  __typename?: 'Mutation';
  deleteZonePolicy?: {
    __typename?: 'ZonePolicy';
    _id: any;
    name?: string | null;
    properties?: Array<string | null> | null;
  } | null;
};

export type SyncPropertyZonePoliciesFromCoresQueryVariables = Exact<{
  propertyId: Scalars['String'];
  dryRun: Scalars['Boolean'];
}>;

export type SyncPropertyZonePoliciesFromCoresQuery = {
  __typename?: 'Query';
  syncPropertyZonePoliciesFromCores?: {
    __typename?: 'PropertyZonePolicySyncResult';
    propertyId: string;
    dryRun: boolean;
    coresProcessed: number;
    coresWithErrors: number;
    reportTable: string;
    rows?: any | null;
    applied?: {
      __typename?: 'PropertyZonePolicySyncApplied';
      zonesUpdated: number;
      zonePolicyIdsCleared: number;
      policiesAddedToProperty: number;
    } | null;
  } | null;
};

export type UpdateZonePolicyMutationVariables = Exact<{
  id: Scalars['String'];
  policy: UpdateOneZonePolicyInput;
}>;

export type UpdateZonePolicyMutation = {
  __typename?: 'Mutation';
  updateZonePolicy?: {
    __typename?: 'ZonePolicy';
    _id: any;
    name?: string | null;
    properties?: Array<string | null> | null;
    rules?: Array<{
      __typename?: 'ZonePolicyRules';
      type: EnumZonePolicyRulesType;
      source?: {
        __typename?: 'ZonePolicyRulesSource';
        deviceType: string;
        multiplicity?: EnumZonePolicyRulesSourceMultiplicity | null;
        attributes?: {
          __typename?: 'ZonePolicyRulesSourceAttributes';
          operatingMode?: string | null;
          operatingState?: string | null;
          heatSetpoint?: string | null;
          coolSetpoint?: string | null;
          contactState?: string | null;
          fanSpeed?: string | null;
          indoorFanStatus?: string | null;
          keypadLockoutLevel?: string | null;
        } | null;
      } | null;
      target?: {
        __typename?: 'ZonePolicyRulesTarget';
        deviceType: string;
        multiplicity?: EnumZonePolicyRulesTargetMultiplicity | null;
        attributes?: {
          __typename?: 'ZonePolicyRulesTargetAttributes';
          heatSetpoint?: string | null;
          coolSetpoint?: string | null;
          isOn?: string | null;
          keypadLockoutLevel?: string | null;
        } | null;
      } | null;
    } | null> | null;
  } | null;
};

export type UpdatePropertyZonePolicyOverrideMutationVariables = Exact<{
  id: Scalars['String'];
  zonePolicyId: Scalars['String'];
  force?: InputMaybe<Scalars['Boolean']>;
}>;

export type UpdatePropertyZonePolicyOverrideMutation = {
  __typename?: 'Mutation';
  updatePropertyZonePolicyOverride: {
    __typename?: 'Property';
    _id: string;
    title: string;
  };
};

export type UpdateUnitZonePolicyOverrideMutationVariables = Exact<{
  id: Scalars['String'];
  zonePolicyId: Scalars['String'];
  force?: InputMaybe<Scalars['Boolean']>;
}>;

export type UpdateUnitZonePolicyOverrideMutation = {
  __typename?: 'Mutation';
  updateUnitZonePolicyOverride: {
    __typename?: 'Unit';
    _id: string;
    name: string;
  };
};

export type ZonePolicyCountQueryVariables = Exact<{ [key: string]: never }>;

export type ZonePolicyCountQuery = {
  __typename?: 'Query';
  zonePolicyCount?: number | null;
};

export type ZonePolicyDetailUpdateSubscriptionVariables = Exact<{
  ids: Array<Scalars['String']> | Scalars['String'];
}>;

export type ZonePolicyDetailUpdateSubscription = {
  __typename?: 'Subscription';
  zonePolicyEventsByIds?: {
    __typename?: 'ZonePolicy';
    modelChangeOperation?: string | null;
    _id: any;
    name?: string | null;
    properties?: Array<string | null> | null;
    rules?: Array<{
      __typename?: 'ZonePolicyRules';
      type: EnumZonePolicyRulesType;
      source?: {
        __typename?: 'ZonePolicyRulesSource';
        deviceType: string;
        multiplicity?: EnumZonePolicyRulesSourceMultiplicity | null;
        attributes?: {
          __typename?: 'ZonePolicyRulesSourceAttributes';
          operatingMode?: string | null;
          operatingState?: string | null;
          heatSetpoint?: string | null;
          coolSetpoint?: string | null;
          contactState?: string | null;
          fanSpeed?: string | null;
          indoorFanStatus?: string | null;
          keypadLockoutLevel?: string | null;
        } | null;
      } | null;
      target?: {
        __typename?: 'ZonePolicyRulesTarget';
        deviceType: string;
        multiplicity?: EnumZonePolicyRulesTargetMultiplicity | null;
        attributes?: {
          __typename?: 'ZonePolicyRulesTargetAttributes';
          heatSetpoint?: string | null;
          coolSetpoint?: string | null;
          isOn?: string | null;
          keypadLockoutLevel?: string | null;
        } | null;
      } | null;
    } | null> | null;
  } | null;
};

export type ZonePolicyDetailQueryVariables = Exact<{
  _id: Scalars['MongoID'];
}>;

export type ZonePolicyDetailQuery = {
  __typename?: 'Query';
  zonePolicyById?: {
    __typename?: 'ZonePolicy';
    _id: any;
    name?: string | null;
    properties?: Array<string | null> | null;
    rules?: Array<{
      __typename?: 'ZonePolicyRules';
      type: EnumZonePolicyRulesType;
      source?: {
        __typename?: 'ZonePolicyRulesSource';
        deviceType: string;
        multiplicity?: EnumZonePolicyRulesSourceMultiplicity | null;
        attributes?: {
          __typename?: 'ZonePolicyRulesSourceAttributes';
          operatingMode?: string | null;
          operatingState?: string | null;
          heatSetpoint?: string | null;
          coolSetpoint?: string | null;
          contactState?: string | null;
          fanSpeed?: string | null;
          indoorFanStatus?: string | null;
          keypadLockoutLevel?: string | null;
        } | null;
      } | null;
      target?: {
        __typename?: 'ZonePolicyRulesTarget';
        deviceType: string;
        multiplicity?: EnumZonePolicyRulesTargetMultiplicity | null;
        attributes?: {
          __typename?: 'ZonePolicyRulesTargetAttributes';
          heatSetpoint?: string | null;
          coolSetpoint?: string | null;
          isOn?: string | null;
          keypadLockoutLevel?: string | null;
        } | null;
      } | null;
    } | null> | null;
  } | null;
};

export type ZonePolicyDetailBreadcrumbQueryVariables = Exact<{
  id: Scalars['MongoID'];
}>;

export type ZonePolicyDetailBreadcrumbQuery = {
  __typename?: 'Query';
  zonePolicyById?: {
    __typename?: 'ZonePolicy';
    _id: any;
    name?: string | null;
  } | null;
};

export type ZonePolicyListQueryVariables = Exact<{ [key: string]: never }>;

export type ZonePolicyListQuery = {
  __typename?: 'Query';
  zonePolicies: Array<{
    __typename?: 'ZonePolicy';
    _id: any;
    name?: string | null;
    rules?: Array<{
      __typename?: 'ZonePolicyRules';
      type: EnumZonePolicyRulesType;
      source?: {
        __typename?: 'ZonePolicyRulesSource';
        deviceType: string;
        multiplicity?: EnumZonePolicyRulesSourceMultiplicity | null;
        attributes?: {
          __typename?: 'ZonePolicyRulesSourceAttributes';
          keypadLockoutLevel?: string | null;
          indoorFanStatus?: string | null;
          fanSpeed?: string | null;
          contactState?: string | null;
          coolSetpoint?: string | null;
          operatingMode?: string | null;
          operatingState?: string | null;
          heatSetpoint?: string | null;
        } | null;
      } | null;
      target?: {
        __typename?: 'ZonePolicyRulesTarget';
        deviceType: string;
        multiplicity?: EnumZonePolicyRulesTargetMultiplicity | null;
        attributes?: {
          __typename?: 'ZonePolicyRulesTargetAttributes';
          coolSetpoint?: string | null;
          heatSetpoint?: string | null;
          isOn?: string | null;
          keypadLockoutLevel?: string | null;
        } | null;
      } | null;
    } | null> | null;
    enabledProperties: Array<{
      __typename?: 'Property';
      _id: string;
      title: string;
    } | null>;
    assignedProperties: Array<{
      __typename?: 'Property';
      _id: string;
      title: string;
    } | null>;
    assignedUnits: Array<{
      __typename?: 'Unit';
      _id: string;
      name: string;
    } | null>;
  }>;
};

export type ZonePolicyListUpdateSubscriptionVariables = Exact<{
  [key: string]: never;
}>;

export type ZonePolicyListUpdateSubscription = {
  __typename?: 'Subscription';
  zonePolicyEvents?: {
    __typename?: 'ZonePolicy';
    modelChangeOperation?: string | null;
    _id: any;
    name?: string | null;
    enabledProperties: Array<{
      __typename?: 'Property';
      _id: string;
      title: string;
    } | null>;
    assignedProperties: Array<{
      __typename?: 'Property';
      _id: string;
      title: string;
    } | null>;
    assignedUnits: Array<{
      __typename?: 'Unit';
      _id: string;
      name: string;
    } | null>;
  } | null;
};

export type ZonePolicyUpdateVerificationQueryVariables = Exact<{
  id: Scalars['String'];
  propertyIds?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
  unitId?: InputMaybe<Scalars['String']>;
}>;

export type ZonePolicyUpdateVerificationQuery = {
  __typename?: 'Query';
  zonePolicyUpdateVerification?: {
    __typename?: 'ZonePolicyUpdateVerificationData';
    _id?: string | null;
    name?: string | null;
    totalZones?: number | null;
    onlineZones?: number | null;
    excludedZones?: number | null;
  } | null;
};

export const IngestionFieldsFragmentDoc = gql`
  fragment IngestionFields on Ingestion {
    _id
    date
    fileName
    s3FileName
    userId
    user {
      name
    }
    status
  }
`;
export const QuarterlyReportDataExportJobFieldsFragmentDoc = gql`
  fragment QuarterlyReportDataExportJobFields on DataExportJob {
    _id
    requestedByUserId
    propertyId
    propertyTitle
    startDate
    endDate
    reportTypes
    status
    progress
    currentStep
    submittedAt
    startedAt
    completedAt
    updatedAt
    s3Bucket
    s3Key
    artifacts {
      kind
      bucket
      key
      contentType
    }
    awsTaskArn
    errorMessage
    errorDetails
  }
`;
export const ConductorCommissioningDraftFieldsFragmentDoc = gql`
  fragment ConductorCommissioningDraftFields on ConductorCommissioningDraftView {
    _id
    sourceId
    propertyId
    buildingId
    runId
    discoveryFingerprint
    mode
    status
    revision
    floors {
      key
      name
      number
      existingFloorId
      confidence
      evidence {
        source
        value
      }
    }
    units {
      key
      name
      type
      floorKey
      existingUnitId
      confidence
      evidence {
        source
        value
      }
    }
    devices {
      key
      discoveredDeviceId
      originalLabel
      proposedName
      unitKey
      deviceType
      supportedMetrics
      supportedCommands
      enabledMetrics
      enabledCommands
      ignored
      confidence
      evidence {
        source
        value
      }
    }
    needsReview
    validationErrors {
      stage
      key
      field
      message
    }
    resolvedIds
    resolvedMappings
    acknowledgedAt
    createdAt
    updatedAt
  }
`;
export const AlertsManagerAlertUpdateDocument = gql`
  subscription AlertsManagerAlertUpdate {
    alertEvents {
      modelChangeOperation
      _id
      id
      initiated
      alertCategory {
        _id
        key
        modelType
        name
      }
      alertTrigger {
        _id
        name
      }
      building {
        id
        name
      }
      device {
        id
        name
        type
      }
      meta {
        id_str
        limit
        message
        portName
        type
        value
      }
      modelType
      panel {
        id
        name
      }
      property {
        id
        name
      }
      severity
      sourceId
      type {
        id
        name
      }
      unit {
        id
        name
      }
      zone {
        id
        name
      }
    }
  }
`;

/**
 * __useAlertsManagerAlertUpdateSubscription__
 *
 * To run a query within a React component, call `useAlertsManagerAlertUpdateSubscription` and pass it any options that fit your needs.
 * When your component renders, `useAlertsManagerAlertUpdateSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAlertsManagerAlertUpdateSubscription({
 *   variables: {
 *   },
 * });
 */
export function useAlertsManagerAlertUpdateSubscription(
  baseOptions?: Apollo.SubscriptionHookOptions<
    AlertsManagerAlertUpdateSubscription,
    AlertsManagerAlertUpdateSubscriptionVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useSubscription<
    AlertsManagerAlertUpdateSubscription,
    AlertsManagerAlertUpdateSubscriptionVariables
  >(AlertsManagerAlertUpdateDocument, options);
}
export type AlertsManagerAlertUpdateSubscriptionHookResult = ReturnType<
  typeof useAlertsManagerAlertUpdateSubscription
>;
export type AlertsManagerAlertUpdateSubscriptionResult =
  Apollo.SubscriptionResult<AlertsManagerAlertUpdateSubscription>;
export const AlertsManagerDeviceUpdateDocument = gql`
  subscription AlertsManagerDeviceUpdate {
    deviceEvents {
      modelChangeOperation
      _id
      deviceId
      unitId
      propertyId
      sourceId
    }
  }
`;

/**
 * __useAlertsManagerDeviceUpdateSubscription__
 *
 * To run a query within a React component, call `useAlertsManagerDeviceUpdateSubscription` and pass it any options that fit your needs.
 * When your component renders, `useAlertsManagerDeviceUpdateSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAlertsManagerDeviceUpdateSubscription({
 *   variables: {
 *   },
 * });
 */
export function useAlertsManagerDeviceUpdateSubscription(
  baseOptions?: Apollo.SubscriptionHookOptions<
    AlertsManagerDeviceUpdateSubscription,
    AlertsManagerDeviceUpdateSubscriptionVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useSubscription<
    AlertsManagerDeviceUpdateSubscription,
    AlertsManagerDeviceUpdateSubscriptionVariables
  >(AlertsManagerDeviceUpdateDocument, options);
}
export type AlertsManagerDeviceUpdateSubscriptionHookResult = ReturnType<
  typeof useAlertsManagerDeviceUpdateSubscription
>;
export type AlertsManagerDeviceUpdateSubscriptionResult =
  Apollo.SubscriptionResult<AlertsManagerDeviceUpdateSubscription>;
export const AlertsManagerAlertsDocument = gql`
  query AlertsManagerAlerts {
    alerts(limit: 0) {
      _id
      id
      initiated
      updated
      alertCategory {
        _id
        key
        modelType
        name
      }
      alertTrigger {
        _id
        name
      }
      building {
        id
        name
      }
      device {
        id
        name
        type
      }
      meta {
        id_str
        limit
        message
        portName
        type
        value
      }
      modelType
      panel {
        id
        name
      }
      property {
        id
        name
      }
      severity
      sourceId
      type {
        id
        name
      }
      unit {
        id
        name
      }
      zone {
        id
        name
      }
    }
  }
`;

/**
 * __useAlertsManagerAlertsQuery__
 *
 * To run a query within a React component, call `useAlertsManagerAlertsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAlertsManagerAlertsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAlertsManagerAlertsQuery({
 *   variables: {
 *   },
 * });
 */
export function useAlertsManagerAlertsQuery(
  baseOptions?: Apollo.QueryHookOptions<
    AlertsManagerAlertsQuery,
    AlertsManagerAlertsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    AlertsManagerAlertsQuery,
    AlertsManagerAlertsQueryVariables
  >(AlertsManagerAlertsDocument, options);
}
export function useAlertsManagerAlertsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    AlertsManagerAlertsQuery,
    AlertsManagerAlertsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    AlertsManagerAlertsQuery,
    AlertsManagerAlertsQueryVariables
  >(AlertsManagerAlertsDocument, options);
}
export type AlertsManagerAlertsQueryHookResult = ReturnType<
  typeof useAlertsManagerAlertsQuery
>;
export type AlertsManagerAlertsLazyQueryHookResult = ReturnType<
  typeof useAlertsManagerAlertsLazyQuery
>;
export type AlertsManagerAlertsQueryResult = Apollo.QueryResult<
  AlertsManagerAlertsQuery,
  AlertsManagerAlertsQueryVariables
>;
export const AlertsManagerDevicesDocument = gql`
  query AlertsManagerDevices {
    devices(limit: 0) {
      _id
      deviceId
      unitId
      propertyId
      sourceId
    }
  }
`;

/**
 * __useAlertsManagerDevicesQuery__
 *
 * To run a query within a React component, call `useAlertsManagerDevicesQuery` and pass it any options that fit your needs.
 * When your component renders, `useAlertsManagerDevicesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAlertsManagerDevicesQuery({
 *   variables: {
 *   },
 * });
 */
export function useAlertsManagerDevicesQuery(
  baseOptions?: Apollo.QueryHookOptions<
    AlertsManagerDevicesQuery,
    AlertsManagerDevicesQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    AlertsManagerDevicesQuery,
    AlertsManagerDevicesQueryVariables
  >(AlertsManagerDevicesDocument, options);
}
export function useAlertsManagerDevicesLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    AlertsManagerDevicesQuery,
    AlertsManagerDevicesQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    AlertsManagerDevicesQuery,
    AlertsManagerDevicesQueryVariables
  >(AlertsManagerDevicesDocument, options);
}
export type AlertsManagerDevicesQueryHookResult = ReturnType<
  typeof useAlertsManagerDevicesQuery
>;
export type AlertsManagerDevicesLazyQueryHookResult = ReturnType<
  typeof useAlertsManagerDevicesLazyQuery
>;
export type AlertsManagerDevicesQueryResult = Apollo.QueryResult<
  AlertsManagerDevicesQuery,
  AlertsManagerDevicesQueryVariables
>;
export const ClearOptInViaSmsDocument = gql`
  mutation ClearOptInViaSms(
    $destinationNumber: String!
    $contactIndex: Int!
    $propertyId: String!
  ) {
    clearOptInViaSms(
      destinationNumber: $destinationNumber
      contactIndex: $contactIndex
      propertyId: $propertyId
    ) {
      _id
      contact {
        name
        email
        email2
        email3
        smsNumber
        smsNumber2
        smsNumber3
        smsOptInStatus1
        smsOptInTimestamp1
        smsOptInStatus2
        smsOptInTimestamp2
        smsOptInStatus3
        smsOptInTimestamp3
      }
    }
  }
`;
export type ClearOptInViaSmsMutationFn = Apollo.MutationFunction<
  ClearOptInViaSmsMutation,
  ClearOptInViaSmsMutationVariables
>;

/**
 * __useClearOptInViaSmsMutation__
 *
 * To run a mutation, you first call `useClearOptInViaSmsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useClearOptInViaSmsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [clearOptInViaSmsMutation, { data, loading, error }] = useClearOptInViaSmsMutation({
 *   variables: {
 *      destinationNumber: // value for 'destinationNumber'
 *      contactIndex: // value for 'contactIndex'
 *      propertyId: // value for 'propertyId'
 *   },
 * });
 */
export function useClearOptInViaSmsMutation(
  baseOptions?: Apollo.MutationHookOptions<
    ClearOptInViaSmsMutation,
    ClearOptInViaSmsMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    ClearOptInViaSmsMutation,
    ClearOptInViaSmsMutationVariables
  >(ClearOptInViaSmsDocument, options);
}
export type ClearOptInViaSmsMutationHookResult = ReturnType<
  typeof useClearOptInViaSmsMutation
>;
export type ClearOptInViaSmsMutationResult =
  Apollo.MutationResult<ClearOptInViaSmsMutation>;
export type ClearOptInViaSmsMutationOptions = Apollo.BaseMutationOptions<
  ClearOptInViaSmsMutation,
  ClearOptInViaSmsMutationVariables
>;
export const CreateAlertTriggerDocument = gql`
  mutation CreateAlertTrigger($alertTrigger: CreateOneAlertTriggerInput!) {
    createAlertTrigger(alertTrigger: $alertTrigger) {
      _id
      name
      propertyId
      entityTypes
      editMode
    }
  }
`;
export type CreateAlertTriggerMutationFn = Apollo.MutationFunction<
  CreateAlertTriggerMutation,
  CreateAlertTriggerMutationVariables
>;

/**
 * __useCreateAlertTriggerMutation__
 *
 * To run a mutation, you first call `useCreateAlertTriggerMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateAlertTriggerMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createAlertTriggerMutation, { data, loading, error }] = useCreateAlertTriggerMutation({
 *   variables: {
 *      alertTrigger: // value for 'alertTrigger'
 *   },
 * });
 */
export function useCreateAlertTriggerMutation(
  baseOptions?: Apollo.MutationHookOptions<
    CreateAlertTriggerMutation,
    CreateAlertTriggerMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    CreateAlertTriggerMutation,
    CreateAlertTriggerMutationVariables
  >(CreateAlertTriggerDocument, options);
}
export type CreateAlertTriggerMutationHookResult = ReturnType<
  typeof useCreateAlertTriggerMutation
>;
export type CreateAlertTriggerMutationResult =
  Apollo.MutationResult<CreateAlertTriggerMutation>;
export type CreateAlertTriggerMutationOptions = Apollo.BaseMutationOptions<
  CreateAlertTriggerMutation,
  CreateAlertTriggerMutationVariables
>;
export const AlertTriggerDetailUpdateDocument = gql`
  subscription AlertTriggerDetailUpdate($ids: [String!]!) {
    alertTriggerEventsByIds(_ids: $ids) {
      modelChangeOperation
      _id
      name
      propertyId
      entityTypes
      triggerCriteria {
        basisType
        basisName
        levels
        selectionCriteria {
          criterion {
            id
            selectionPath
            comparator
            template
            valueType
            values
            editable
            legacyPath
          }
          criteria {
            id
            selectionPath
            comparator
            template
            valueType
            values
            editable
            legacyPath
          }
        }
      }
      editMode
      enabled
    }
  }
`;

/**
 * __useAlertTriggerDetailUpdateSubscription__
 *
 * To run a query within a React component, call `useAlertTriggerDetailUpdateSubscription` and pass it any options that fit your needs.
 * When your component renders, `useAlertTriggerDetailUpdateSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAlertTriggerDetailUpdateSubscription({
 *   variables: {
 *      ids: // value for 'ids'
 *   },
 * });
 */
export function useAlertTriggerDetailUpdateSubscription(
  baseOptions: Apollo.SubscriptionHookOptions<
    AlertTriggerDetailUpdateSubscription,
    AlertTriggerDetailUpdateSubscriptionVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useSubscription<
    AlertTriggerDetailUpdateSubscription,
    AlertTriggerDetailUpdateSubscriptionVariables
  >(AlertTriggerDetailUpdateDocument, options);
}
export type AlertTriggerDetailUpdateSubscriptionHookResult = ReturnType<
  typeof useAlertTriggerDetailUpdateSubscription
>;
export type AlertTriggerDetailUpdateSubscriptionResult =
  Apollo.SubscriptionResult<AlertTriggerDetailUpdateSubscription>;
export const AlertTriggerDetailDocument = gql`
  query AlertTriggerDetail($id: String!) {
    alertTriggerById(_id: $id) {
      _id
      name
      propertyId
      entityTypes
      triggerCriteria {
        basisType
        basisName
        levels
        selectionCriteria {
          criterion {
            id
            selectionPath
            comparator
            template
            valueType
            values
            editable
            legacyPath
          }
          criteria {
            id
            selectionPath
            comparator
            template
            valueType
            values
            editable
            legacyPath
          }
        }
      }
      editMode
      enabled
    }
  }
`;

/**
 * __useAlertTriggerDetailQuery__
 *
 * To run a query within a React component, call `useAlertTriggerDetailQuery` and pass it any options that fit your needs.
 * When your component renders, `useAlertTriggerDetailQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAlertTriggerDetailQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useAlertTriggerDetailQuery(
  baseOptions: Apollo.QueryHookOptions<
    AlertTriggerDetailQuery,
    AlertTriggerDetailQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    AlertTriggerDetailQuery,
    AlertTriggerDetailQueryVariables
  >(AlertTriggerDetailDocument, options);
}
export function useAlertTriggerDetailLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    AlertTriggerDetailQuery,
    AlertTriggerDetailQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    AlertTriggerDetailQuery,
    AlertTriggerDetailQueryVariables
  >(AlertTriggerDetailDocument, options);
}
export type AlertTriggerDetailQueryHookResult = ReturnType<
  typeof useAlertTriggerDetailQuery
>;
export type AlertTriggerDetailLazyQueryHookResult = ReturnType<
  typeof useAlertTriggerDetailLazyQuery
>;
export type AlertTriggerDetailQueryResult = Apollo.QueryResult<
  AlertTriggerDetailQuery,
  AlertTriggerDetailQueryVariables
>;
export const AlertTriggerListByPropertyIdUpdateDocument = gql`
  subscription AlertTriggerListByPropertyIdUpdate($propertyId: String!) {
    alertTriggerEventsByPropertyId(propertyId: [$propertyId]) {
      modelChangeOperation
      _id
      name
      propertyId
      entityTypes
      triggerCriteria {
        basisType
        basisName
        levels
        selectionCriteria {
          criterion {
            id
            selectionPath
            comparator
            template
            valueType
            values
            editable
            legacyPath
          }
          criteria {
            id
            selectionPath
            comparator
            template
            valueType
            values
            editable
            legacyPath
          }
        }
      }
      editMode
      enabled
    }
  }
`;

/**
 * __useAlertTriggerListByPropertyIdUpdateSubscription__
 *
 * To run a query within a React component, call `useAlertTriggerListByPropertyIdUpdateSubscription` and pass it any options that fit your needs.
 * When your component renders, `useAlertTriggerListByPropertyIdUpdateSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAlertTriggerListByPropertyIdUpdateSubscription({
 *   variables: {
 *      propertyId: // value for 'propertyId'
 *   },
 * });
 */
export function useAlertTriggerListByPropertyIdUpdateSubscription(
  baseOptions: Apollo.SubscriptionHookOptions<
    AlertTriggerListByPropertyIdUpdateSubscription,
    AlertTriggerListByPropertyIdUpdateSubscriptionVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useSubscription<
    AlertTriggerListByPropertyIdUpdateSubscription,
    AlertTriggerListByPropertyIdUpdateSubscriptionVariables
  >(AlertTriggerListByPropertyIdUpdateDocument, options);
}
export type AlertTriggerListByPropertyIdUpdateSubscriptionHookResult =
  ReturnType<typeof useAlertTriggerListByPropertyIdUpdateSubscription>;
export type AlertTriggerListByPropertyIdUpdateSubscriptionResult =
  Apollo.SubscriptionResult<AlertTriggerListByPropertyIdUpdateSubscription>;
export const AlertTriggerListByPropertyIdDocument = gql`
  query AlertTriggerListByPropertyId($propertyId: String!) {
    alertTriggersByPropertyId(propertyId: [$propertyId]) {
      _id
      name
      propertyId
      entityTypes
      triggerCriteria {
        basisType
        basisName
        levels
        selectionCriteria {
          criterion {
            id
            selectionPath
            comparator
            template
            valueType
            values
            editable
            legacyPath
          }
          criteria {
            id
            selectionPath
            comparator
            template
            valueType
            values
            editable
            legacyPath
          }
        }
      }
      editMode
      enabled
    }
  }
`;

/**
 * __useAlertTriggerListByPropertyIdQuery__
 *
 * To run a query within a React component, call `useAlertTriggerListByPropertyIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useAlertTriggerListByPropertyIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAlertTriggerListByPropertyIdQuery({
 *   variables: {
 *      propertyId: // value for 'propertyId'
 *   },
 * });
 */
export function useAlertTriggerListByPropertyIdQuery(
  baseOptions: Apollo.QueryHookOptions<
    AlertTriggerListByPropertyIdQuery,
    AlertTriggerListByPropertyIdQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    AlertTriggerListByPropertyIdQuery,
    AlertTriggerListByPropertyIdQueryVariables
  >(AlertTriggerListByPropertyIdDocument, options);
}
export function useAlertTriggerListByPropertyIdLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    AlertTriggerListByPropertyIdQuery,
    AlertTriggerListByPropertyIdQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    AlertTriggerListByPropertyIdQuery,
    AlertTriggerListByPropertyIdQueryVariables
  >(AlertTriggerListByPropertyIdDocument, options);
}
export type AlertTriggerListByPropertyIdQueryHookResult = ReturnType<
  typeof useAlertTriggerListByPropertyIdQuery
>;
export type AlertTriggerListByPropertyIdLazyQueryHookResult = ReturnType<
  typeof useAlertTriggerListByPropertyIdLazyQuery
>;
export type AlertTriggerListByPropertyIdQueryResult = Apollo.QueryResult<
  AlertTriggerListByPropertyIdQuery,
  AlertTriggerListByPropertyIdQueryVariables
>;
export const PropertyWideAlertSubscribersDocument = gql`
  subscription PropertyWideAlertSubscribers($propertyId: String) {
    propertyEventsByIds(_ids: [$propertyId]) {
      modelChangeOperation
      _id
      contact {
        smsNumber
        smsNumber2
        smsNumber3
        smsOptInStatus1
        smsOptInStatus2
        smsOptInStatus3
        smsOptInTimestamp1
        smsOptInTimestamp2
        smsOptInTimestamp3
      }
    }
  }
`;

/**
 * __usePropertyWideAlertSubscribersSubscription__
 *
 * To run a query within a React component, call `usePropertyWideAlertSubscribersSubscription` and pass it any options that fit your needs.
 * When your component renders, `usePropertyWideAlertSubscribersSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePropertyWideAlertSubscribersSubscription({
 *   variables: {
 *      propertyId: // value for 'propertyId'
 *   },
 * });
 */
export function usePropertyWideAlertSubscribersSubscription(
  baseOptions?: Apollo.SubscriptionHookOptions<
    PropertyWideAlertSubscribersSubscription,
    PropertyWideAlertSubscribersSubscriptionVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useSubscription<
    PropertyWideAlertSubscribersSubscription,
    PropertyWideAlertSubscribersSubscriptionVariables
  >(PropertyWideAlertSubscribersDocument, options);
}
export type PropertyWideAlertSubscribersSubscriptionHookResult = ReturnType<
  typeof usePropertyWideAlertSubscribersSubscription
>;
export type PropertyWideAlertSubscribersSubscriptionResult =
  Apollo.SubscriptionResult<PropertyWideAlertSubscribersSubscription>;
export const RemoveAlertTriggerDocument = gql`
  mutation RemoveAlertTrigger($id: String!) {
    removeAlertTrigger(_id: $id)
  }
`;
export type RemoveAlertTriggerMutationFn = Apollo.MutationFunction<
  RemoveAlertTriggerMutation,
  RemoveAlertTriggerMutationVariables
>;

/**
 * __useRemoveAlertTriggerMutation__
 *
 * To run a mutation, you first call `useRemoveAlertTriggerMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveAlertTriggerMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeAlertTriggerMutation, { data, loading, error }] = useRemoveAlertTriggerMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useRemoveAlertTriggerMutation(
  baseOptions?: Apollo.MutationHookOptions<
    RemoveAlertTriggerMutation,
    RemoveAlertTriggerMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    RemoveAlertTriggerMutation,
    RemoveAlertTriggerMutationVariables
  >(RemoveAlertTriggerDocument, options);
}
export type RemoveAlertTriggerMutationHookResult = ReturnType<
  typeof useRemoveAlertTriggerMutation
>;
export type RemoveAlertTriggerMutationResult =
  Apollo.MutationResult<RemoveAlertTriggerMutation>;
export type RemoveAlertTriggerMutationOptions = Apollo.BaseMutationOptions<
  RemoveAlertTriggerMutation,
  RemoveAlertTriggerMutationVariables
>;
export const RetrieveSmsNumberDocument = gql`
  query RetrieveSmsNumber {
    retrieveSmsNumber
  }
`;

/**
 * __useRetrieveSmsNumberQuery__
 *
 * To run a query within a React component, call `useRetrieveSmsNumberQuery` and pass it any options that fit your needs.
 * When your component renders, `useRetrieveSmsNumberQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRetrieveSmsNumberQuery({
 *   variables: {
 *   },
 * });
 */
export function useRetrieveSmsNumberQuery(
  baseOptions?: Apollo.QueryHookOptions<
    RetrieveSmsNumberQuery,
    RetrieveSmsNumberQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    RetrieveSmsNumberQuery,
    RetrieveSmsNumberQueryVariables
  >(RetrieveSmsNumberDocument, options);
}
export function useRetrieveSmsNumberLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    RetrieveSmsNumberQuery,
    RetrieveSmsNumberQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    RetrieveSmsNumberQuery,
    RetrieveSmsNumberQueryVariables
  >(RetrieveSmsNumberDocument, options);
}
export type RetrieveSmsNumberQueryHookResult = ReturnType<
  typeof useRetrieveSmsNumberQuery
>;
export type RetrieveSmsNumberLazyQueryHookResult = ReturnType<
  typeof useRetrieveSmsNumberLazyQuery
>;
export type RetrieveSmsNumberQueryResult = Apollo.QueryResult<
  RetrieveSmsNumberQuery,
  RetrieveSmsNumberQueryVariables
>;
export const SendOptInRequestSmsDocument = gql`
  mutation SendOptInRequestSms(
    $destinationNumber: String!
    $contactIndex: Int!
    $propertyId: String!
  ) {
    sendOptInRequestSms(
      destinationNumber: $destinationNumber
      contactIndex: $contactIndex
      propertyId: $propertyId
    ) {
      _id
      contact {
        name
        email
        email2
        email3
        smsNumber
        smsNumber2
        smsNumber3
        smsOptInStatus1
        smsOptInTimestamp1
        smsOptInStatus2
        smsOptInTimestamp2
        smsOptInStatus3
        smsOptInTimestamp3
      }
    }
  }
`;
export type SendOptInRequestSmsMutationFn = Apollo.MutationFunction<
  SendOptInRequestSmsMutation,
  SendOptInRequestSmsMutationVariables
>;

/**
 * __useSendOptInRequestSmsMutation__
 *
 * To run a mutation, you first call `useSendOptInRequestSmsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSendOptInRequestSmsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sendOptInRequestSmsMutation, { data, loading, error }] = useSendOptInRequestSmsMutation({
 *   variables: {
 *      destinationNumber: // value for 'destinationNumber'
 *      contactIndex: // value for 'contactIndex'
 *      propertyId: // value for 'propertyId'
 *   },
 * });
 */
export function useSendOptInRequestSmsMutation(
  baseOptions?: Apollo.MutationHookOptions<
    SendOptInRequestSmsMutation,
    SendOptInRequestSmsMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    SendOptInRequestSmsMutation,
    SendOptInRequestSmsMutationVariables
  >(SendOptInRequestSmsDocument, options);
}
export type SendOptInRequestSmsMutationHookResult = ReturnType<
  typeof useSendOptInRequestSmsMutation
>;
export type SendOptInRequestSmsMutationResult =
  Apollo.MutationResult<SendOptInRequestSmsMutation>;
export type SendOptInRequestSmsMutationOptions = Apollo.BaseMutationOptions<
  SendOptInRequestSmsMutation,
  SendOptInRequestSmsMutationVariables
>;
export const SendTestEmailDocument = gql`
  mutation SendTestEmail($destinationEmail: String!, $propertyId: String!) {
    sendTestEmail(destinationEmail: $destinationEmail, propertyId: $propertyId)
  }
`;
export type SendTestEmailMutationFn = Apollo.MutationFunction<
  SendTestEmailMutation,
  SendTestEmailMutationVariables
>;

/**
 * __useSendTestEmailMutation__
 *
 * To run a mutation, you first call `useSendTestEmailMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSendTestEmailMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sendTestEmailMutation, { data, loading, error }] = useSendTestEmailMutation({
 *   variables: {
 *      destinationEmail: // value for 'destinationEmail'
 *      propertyId: // value for 'propertyId'
 *   },
 * });
 */
export function useSendTestEmailMutation(
  baseOptions?: Apollo.MutationHookOptions<
    SendTestEmailMutation,
    SendTestEmailMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    SendTestEmailMutation,
    SendTestEmailMutationVariables
  >(SendTestEmailDocument, options);
}
export type SendTestEmailMutationHookResult = ReturnType<
  typeof useSendTestEmailMutation
>;
export type SendTestEmailMutationResult =
  Apollo.MutationResult<SendTestEmailMutation>;
export type SendTestEmailMutationOptions = Apollo.BaseMutationOptions<
  SendTestEmailMutation,
  SendTestEmailMutationVariables
>;
export const UpdateAlertTriggerDocument = gql`
  mutation UpdateAlertTrigger(
    $id: String!
    $alertTrigger: UpdateOneAlertTriggerInput!
  ) {
    updateAlertTrigger(id: $id, alertTrigger: $alertTrigger) {
      _id
      name
      propertyId
      entityTypes
      triggerCriteria {
        basisType
        basisName
        selectionCriteria {
          criterion {
            id
            selectionPath
            comparator
            template
            valueType
            values
            editable
            legacyPath
          }
          criteria {
            id
            selectionPath
            comparator
            template
            valueType
            values
            editable
            legacyPath
          }
        }
      }
      editMode
      enabled
    }
  }
`;
export type UpdateAlertTriggerMutationFn = Apollo.MutationFunction<
  UpdateAlertTriggerMutation,
  UpdateAlertTriggerMutationVariables
>;

/**
 * __useUpdateAlertTriggerMutation__
 *
 * To run a mutation, you first call `useUpdateAlertTriggerMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateAlertTriggerMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateAlertTriggerMutation, { data, loading, error }] = useUpdateAlertTriggerMutation({
 *   variables: {
 *      id: // value for 'id'
 *      alertTrigger: // value for 'alertTrigger'
 *   },
 * });
 */
export function useUpdateAlertTriggerMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UpdateAlertTriggerMutation,
    UpdateAlertTriggerMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    UpdateAlertTriggerMutation,
    UpdateAlertTriggerMutationVariables
  >(UpdateAlertTriggerDocument, options);
}
export type UpdateAlertTriggerMutationHookResult = ReturnType<
  typeof useUpdateAlertTriggerMutation
>;
export type UpdateAlertTriggerMutationResult =
  Apollo.MutationResult<UpdateAlertTriggerMutation>;
export type UpdateAlertTriggerMutationOptions = Apollo.BaseMutationOptions<
  UpdateAlertTriggerMutation,
  UpdateAlertTriggerMutationVariables
>;
export const UpdateUserAlertSubscriptionsDocument = gql`
  mutation UpdateUserAlertSubscriptions(
    $userId: String!
    $propertyId: String!
    $alertSubscriptions: [AlertSubscriptionSpecification!]!
  ) {
    updateUserAlertSubscriptions(
      userId: $userId
      propertyId: $propertyId
      alertSubscriptions: $alertSubscriptions
    ) {
      _id
      userId
      propertyId
      viaEmail
      viaSms
    }
  }
`;
export type UpdateUserAlertSubscriptionsMutationFn = Apollo.MutationFunction<
  UpdateUserAlertSubscriptionsMutation,
  UpdateUserAlertSubscriptionsMutationVariables
>;

/**
 * __useUpdateUserAlertSubscriptionsMutation__
 *
 * To run a mutation, you first call `useUpdateUserAlertSubscriptionsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateUserAlertSubscriptionsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateUserAlertSubscriptionsMutation, { data, loading, error }] = useUpdateUserAlertSubscriptionsMutation({
 *   variables: {
 *      userId: // value for 'userId'
 *      propertyId: // value for 'propertyId'
 *      alertSubscriptions: // value for 'alertSubscriptions'
 *   },
 * });
 */
export function useUpdateUserAlertSubscriptionsMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UpdateUserAlertSubscriptionsMutation,
    UpdateUserAlertSubscriptionsMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    UpdateUserAlertSubscriptionsMutation,
    UpdateUserAlertSubscriptionsMutationVariables
  >(UpdateUserAlertSubscriptionsDocument, options);
}
export type UpdateUserAlertSubscriptionsMutationHookResult = ReturnType<
  typeof useUpdateUserAlertSubscriptionsMutation
>;
export type UpdateUserAlertSubscriptionsMutationResult =
  Apollo.MutationResult<UpdateUserAlertSubscriptionsMutation>;
export type UpdateUserAlertSubscriptionsMutationOptions =
  Apollo.BaseMutationOptions<
    UpdateUserAlertSubscriptionsMutation,
    UpdateUserAlertSubscriptionsMutationVariables
  >;
export const UserProfileAlertSubscriptionUpdatesDocument = gql`
  subscription UserProfileAlertSubscriptionUpdates($userId: String!) {
    alertSubscriptionsByUserIdEvents(userId: $userId) {
      modelChangeOperation
      _id
      alertTrigger {
        _id
        name
      }
      property {
        _id
        title
      }
      unit {
        name
      }
      device {
        name
      }
      unitCategoryId
      viaEmail
      viaSms
    }
  }
`;

/**
 * __useUserProfileAlertSubscriptionUpdatesSubscription__
 *
 * To run a query within a React component, call `useUserProfileAlertSubscriptionUpdatesSubscription` and pass it any options that fit your needs.
 * When your component renders, `useUserProfileAlertSubscriptionUpdatesSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUserProfileAlertSubscriptionUpdatesSubscription({
 *   variables: {
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useUserProfileAlertSubscriptionUpdatesSubscription(
  baseOptions: Apollo.SubscriptionHookOptions<
    UserProfileAlertSubscriptionUpdatesSubscription,
    UserProfileAlertSubscriptionUpdatesSubscriptionVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useSubscription<
    UserProfileAlertSubscriptionUpdatesSubscription,
    UserProfileAlertSubscriptionUpdatesSubscriptionVariables
  >(UserProfileAlertSubscriptionUpdatesDocument, options);
}
export type UserProfileAlertSubscriptionUpdatesSubscriptionHookResult =
  ReturnType<typeof useUserProfileAlertSubscriptionUpdatesSubscription>;
export type UserProfileAlertSubscriptionUpdatesSubscriptionResult =
  Apollo.SubscriptionResult<UserProfileAlertSubscriptionUpdatesSubscription>;
export const UserProfileAlertSubscriptionsDocument = gql`
  query UserProfileAlertSubscriptions($userId: String!) {
    alertSubscriptionsByUserId(userId: $userId) {
      _id
      alertTrigger {
        _id
        name
      }
      property {
        _id
        title
      }
      unit {
        name
      }
      device {
        name
      }
      unitCategoryId
      viaEmail
      viaSms
    }
  }
`;

/**
 * __useUserProfileAlertSubscriptionsQuery__
 *
 * To run a query within a React component, call `useUserProfileAlertSubscriptionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserProfileAlertSubscriptionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUserProfileAlertSubscriptionsQuery({
 *   variables: {
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useUserProfileAlertSubscriptionsQuery(
  baseOptions: Apollo.QueryHookOptions<
    UserProfileAlertSubscriptionsQuery,
    UserProfileAlertSubscriptionsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    UserProfileAlertSubscriptionsQuery,
    UserProfileAlertSubscriptionsQueryVariables
  >(UserProfileAlertSubscriptionsDocument, options);
}
export function useUserProfileAlertSubscriptionsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    UserProfileAlertSubscriptionsQuery,
    UserProfileAlertSubscriptionsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    UserProfileAlertSubscriptionsQuery,
    UserProfileAlertSubscriptionsQueryVariables
  >(UserProfileAlertSubscriptionsDocument, options);
}
export type UserProfileAlertSubscriptionsQueryHookResult = ReturnType<
  typeof useUserProfileAlertSubscriptionsQuery
>;
export type UserProfileAlertSubscriptionsLazyQueryHookResult = ReturnType<
  typeof useUserProfileAlertSubscriptionsLazyQuery
>;
export type UserProfileAlertSubscriptionsQueryResult = Apollo.QueryResult<
  UserProfileAlertSubscriptionsQuery,
  UserProfileAlertSubscriptionsQueryVariables
>;
export const BuildingDetailEditDocument = gql`
  query buildingDetailEdit($bid: String!) {
    buildingById(_id: $bid) {
      _id
      name
      number
    }
  }
`;

/**
 * __useBuildingDetailEditQuery__
 *
 * To run a query within a React component, call `useBuildingDetailEditQuery` and pass it any options that fit your needs.
 * When your component renders, `useBuildingDetailEditQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBuildingDetailEditQuery({
 *   variables: {
 *      bid: // value for 'bid'
 *   },
 * });
 */
export function useBuildingDetailEditQuery(
  baseOptions: Apollo.QueryHookOptions<
    BuildingDetailEditQuery,
    BuildingDetailEditQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    BuildingDetailEditQuery,
    BuildingDetailEditQueryVariables
  >(BuildingDetailEditDocument, options);
}
export function useBuildingDetailEditLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    BuildingDetailEditQuery,
    BuildingDetailEditQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    BuildingDetailEditQuery,
    BuildingDetailEditQueryVariables
  >(BuildingDetailEditDocument, options);
}
export type BuildingDetailEditQueryHookResult = ReturnType<
  typeof useBuildingDetailEditQuery
>;
export type BuildingDetailEditLazyQueryHookResult = ReturnType<
  typeof useBuildingDetailEditLazyQuery
>;
export type BuildingDetailEditQueryResult = Apollo.QueryResult<
  BuildingDetailEditQuery,
  BuildingDetailEditQueryVariables
>;
export const BuildingListByPropertyIdUpdateDocument = gql`
  subscription BuildingListByPropertyIdUpdate($propertyId: String!) {
    buildingsByPropertyIdEvents(propertyId: $propertyId) {
      modelChangeOperation
      _id
      name
      number
      inUse
    }
  }
`;

/**
 * __useBuildingListByPropertyIdUpdateSubscription__
 *
 * To run a query within a React component, call `useBuildingListByPropertyIdUpdateSubscription` and pass it any options that fit your needs.
 * When your component renders, `useBuildingListByPropertyIdUpdateSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBuildingListByPropertyIdUpdateSubscription({
 *   variables: {
 *      propertyId: // value for 'propertyId'
 *   },
 * });
 */
export function useBuildingListByPropertyIdUpdateSubscription(
  baseOptions: Apollo.SubscriptionHookOptions<
    BuildingListByPropertyIdUpdateSubscription,
    BuildingListByPropertyIdUpdateSubscriptionVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useSubscription<
    BuildingListByPropertyIdUpdateSubscription,
    BuildingListByPropertyIdUpdateSubscriptionVariables
  >(BuildingListByPropertyIdUpdateDocument, options);
}
export type BuildingListByPropertyIdUpdateSubscriptionHookResult = ReturnType<
  typeof useBuildingListByPropertyIdUpdateSubscription
>;
export type BuildingListByPropertyIdUpdateSubscriptionResult =
  Apollo.SubscriptionResult<BuildingListByPropertyIdUpdateSubscription>;
export const BuildingListByPropertyIdDocument = gql`
  query BuildingListByPropertyId($propertyId: String!) {
    buildingsByPropertyId(propertyId: $propertyId) {
      _id
      name
      number
      inUse
    }
  }
`;

/**
 * __useBuildingListByPropertyIdQuery__
 *
 * To run a query within a React component, call `useBuildingListByPropertyIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useBuildingListByPropertyIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBuildingListByPropertyIdQuery({
 *   variables: {
 *      propertyId: // value for 'propertyId'
 *   },
 * });
 */
export function useBuildingListByPropertyIdQuery(
  baseOptions: Apollo.QueryHookOptions<
    BuildingListByPropertyIdQuery,
    BuildingListByPropertyIdQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    BuildingListByPropertyIdQuery,
    BuildingListByPropertyIdQueryVariables
  >(BuildingListByPropertyIdDocument, options);
}
export function useBuildingListByPropertyIdLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    BuildingListByPropertyIdQuery,
    BuildingListByPropertyIdQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    BuildingListByPropertyIdQuery,
    BuildingListByPropertyIdQueryVariables
  >(BuildingListByPropertyIdDocument, options);
}
export type BuildingListByPropertyIdQueryHookResult = ReturnType<
  typeof useBuildingListByPropertyIdQuery
>;
export type BuildingListByPropertyIdLazyQueryHookResult = ReturnType<
  typeof useBuildingListByPropertyIdLazyQuery
>;
export type BuildingListByPropertyIdQueryResult = Apollo.QueryResult<
  BuildingListByPropertyIdQuery,
  BuildingListByPropertyIdQueryVariables
>;
export const CreateBuildingDocument = gql`
  mutation CreateBuilding($building: CreateOneBuildingInput!) {
    createBuilding(building: $building) {
      _id
      propertyId
      name
      number
    }
  }
`;
export type CreateBuildingMutationFn = Apollo.MutationFunction<
  CreateBuildingMutation,
  CreateBuildingMutationVariables
>;

/**
 * __useCreateBuildingMutation__
 *
 * To run a mutation, you first call `useCreateBuildingMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateBuildingMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createBuildingMutation, { data, loading, error }] = useCreateBuildingMutation({
 *   variables: {
 *      building: // value for 'building'
 *   },
 * });
 */
export function useCreateBuildingMutation(
  baseOptions?: Apollo.MutationHookOptions<
    CreateBuildingMutation,
    CreateBuildingMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    CreateBuildingMutation,
    CreateBuildingMutationVariables
  >(CreateBuildingDocument, options);
}
export type CreateBuildingMutationHookResult = ReturnType<
  typeof useCreateBuildingMutation
>;
export type CreateBuildingMutationResult =
  Apollo.MutationResult<CreateBuildingMutation>;
export type CreateBuildingMutationOptions = Apollo.BaseMutationOptions<
  CreateBuildingMutation,
  CreateBuildingMutationVariables
>;
export const PropertyBuildingsDocument = gql`
  query PropertyBuildings($id: String!) {
    propertyById(_id: $id) {
      _id
      title
      buildings {
        _id
        name
        number
        floors {
          _id
          name
          number
          buildingId
        }
      }
      floors {
        _id
        name
        number
        buildingId
      }
      floorLabel
    }
  }
`;

/**
 * __usePropertyBuildingsQuery__
 *
 * To run a query within a React component, call `usePropertyBuildingsQuery` and pass it any options that fit your needs.
 * When your component renders, `usePropertyBuildingsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePropertyBuildingsQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function usePropertyBuildingsQuery(
  baseOptions: Apollo.QueryHookOptions<
    PropertyBuildingsQuery,
    PropertyBuildingsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    PropertyBuildingsQuery,
    PropertyBuildingsQueryVariables
  >(PropertyBuildingsDocument, options);
}
export function usePropertyBuildingsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    PropertyBuildingsQuery,
    PropertyBuildingsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    PropertyBuildingsQuery,
    PropertyBuildingsQueryVariables
  >(PropertyBuildingsDocument, options);
}
export type PropertyBuildingsQueryHookResult = ReturnType<
  typeof usePropertyBuildingsQuery
>;
export type PropertyBuildingsLazyQueryHookResult = ReturnType<
  typeof usePropertyBuildingsLazyQuery
>;
export type PropertyBuildingsQueryResult = Apollo.QueryResult<
  PropertyBuildingsQuery,
  PropertyBuildingsQueryVariables
>;
export const PropertyDataForBuildingDocument = gql`
  query PropertyDataForBuilding($id: String!) {
    propertyById(_id: $id) {
      _id
      title
      thermostatScheduleTemplateId
      setpointProfileId
    }
  }
`;

/**
 * __usePropertyDataForBuildingQuery__
 *
 * To run a query within a React component, call `usePropertyDataForBuildingQuery` and pass it any options that fit your needs.
 * When your component renders, `usePropertyDataForBuildingQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePropertyDataForBuildingQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function usePropertyDataForBuildingQuery(
  baseOptions: Apollo.QueryHookOptions<
    PropertyDataForBuildingQuery,
    PropertyDataForBuildingQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    PropertyDataForBuildingQuery,
    PropertyDataForBuildingQueryVariables
  >(PropertyDataForBuildingDocument, options);
}
export function usePropertyDataForBuildingLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    PropertyDataForBuildingQuery,
    PropertyDataForBuildingQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    PropertyDataForBuildingQuery,
    PropertyDataForBuildingQueryVariables
  >(PropertyDataForBuildingDocument, options);
}
export type PropertyDataForBuildingQueryHookResult = ReturnType<
  typeof usePropertyDataForBuildingQuery
>;
export type PropertyDataForBuildingLazyQueryHookResult = ReturnType<
  typeof usePropertyDataForBuildingLazyQuery
>;
export type PropertyDataForBuildingQueryResult = Apollo.QueryResult<
  PropertyDataForBuildingQuery,
  PropertyDataForBuildingQueryVariables
>;
export const RemoveBuildingDocument = gql`
  mutation RemoveBuilding($id: String!) {
    removeBuilding(_id: $id)
  }
`;
export type RemoveBuildingMutationFn = Apollo.MutationFunction<
  RemoveBuildingMutation,
  RemoveBuildingMutationVariables
>;

/**
 * __useRemoveBuildingMutation__
 *
 * To run a mutation, you first call `useRemoveBuildingMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveBuildingMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeBuildingMutation, { data, loading, error }] = useRemoveBuildingMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useRemoveBuildingMutation(
  baseOptions?: Apollo.MutationHookOptions<
    RemoveBuildingMutation,
    RemoveBuildingMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    RemoveBuildingMutation,
    RemoveBuildingMutationVariables
  >(RemoveBuildingDocument, options);
}
export type RemoveBuildingMutationHookResult = ReturnType<
  typeof useRemoveBuildingMutation
>;
export type RemoveBuildingMutationResult =
  Apollo.MutationResult<RemoveBuildingMutation>;
export type RemoveBuildingMutationOptions = Apollo.BaseMutationOptions<
  RemoveBuildingMutation,
  RemoveBuildingMutationVariables
>;
export const UpdateBuildingDocument = gql`
  mutation UpdateBuilding($id: String!, $building: UpdateOneBuildingInput!) {
    updateBuilding(id: $id, building: $building) {
      _id
      name
      number
    }
  }
`;
export type UpdateBuildingMutationFn = Apollo.MutationFunction<
  UpdateBuildingMutation,
  UpdateBuildingMutationVariables
>;

/**
 * __useUpdateBuildingMutation__
 *
 * To run a mutation, you first call `useUpdateBuildingMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateBuildingMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateBuildingMutation, { data, loading, error }] = useUpdateBuildingMutation({
 *   variables: {
 *      id: // value for 'id'
 *      building: // value for 'building'
 *   },
 * });
 */
export function useUpdateBuildingMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UpdateBuildingMutation,
    UpdateBuildingMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    UpdateBuildingMutation,
    UpdateBuildingMutationVariables
  >(UpdateBuildingDocument, options);
}
export type UpdateBuildingMutationHookResult = ReturnType<
  typeof useUpdateBuildingMutation
>;
export type UpdateBuildingMutationResult =
  Apollo.MutationResult<UpdateBuildingMutation>;
export type UpdateBuildingMutationOptions = Apollo.BaseMutationOptions<
  UpdateBuildingMutation,
  UpdateBuildingMutationVariables
>;
export const BulkConfigPropertiesDocument = gql`
  query BulkConfigProperties {
    properties(limit: 0) {
      _id
      title
      address {
        line1
      }
      buildings {
        _id
        name
        number
        floors {
          _id
          name
          buildingId
        }
      }
      floorLabel
      cuGroups
      units(limit: 0) {
        _id
        name
        type
        buildingId
        floorId
        cuid
      }
      devices(limit: 0) {
        _id
        deviceId
        type
        name
        location
        unitId
      }
    }
  }
`;

/**
 * __useBulkConfigPropertiesQuery__
 *
 * To run a query within a React component, call `useBulkConfigPropertiesQuery` and pass it any options that fit your needs.
 * When your component renders, `useBulkConfigPropertiesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBulkConfigPropertiesQuery({
 *   variables: {
 *   },
 * });
 */
export function useBulkConfigPropertiesQuery(
  baseOptions?: Apollo.QueryHookOptions<
    BulkConfigPropertiesQuery,
    BulkConfigPropertiesQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    BulkConfigPropertiesQuery,
    BulkConfigPropertiesQueryVariables
  >(BulkConfigPropertiesDocument, options);
}
export function useBulkConfigPropertiesLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    BulkConfigPropertiesQuery,
    BulkConfigPropertiesQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    BulkConfigPropertiesQuery,
    BulkConfigPropertiesQueryVariables
  >(BulkConfigPropertiesDocument, options);
}
export type BulkConfigPropertiesQueryHookResult = ReturnType<
  typeof useBulkConfigPropertiesQuery
>;
export type BulkConfigPropertiesLazyQueryHookResult = ReturnType<
  typeof useBulkConfigPropertiesLazyQuery
>;
export type BulkConfigPropertiesQueryResult = Apollo.QueryResult<
  BulkConfigPropertiesQuery,
  BulkConfigPropertiesQueryVariables
>;
export const GetBulkSetpointLimitsDocument = gql`
  query GetBulkSetpointLimits($input: BulkConfigThermostatsInput!) {
    getBulkSetpointLimits(input: $input) {
      heat {
        min
        max
      }
      cool {
        min
        max
      }
    }
  }
`;

/**
 * __useGetBulkSetpointLimitsQuery__
 *
 * To run a query within a React component, call `useGetBulkSetpointLimitsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetBulkSetpointLimitsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetBulkSetpointLimitsQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetBulkSetpointLimitsQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetBulkSetpointLimitsQuery,
    GetBulkSetpointLimitsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetBulkSetpointLimitsQuery,
    GetBulkSetpointLimitsQueryVariables
  >(GetBulkSetpointLimitsDocument, options);
}
export function useGetBulkSetpointLimitsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetBulkSetpointLimitsQuery,
    GetBulkSetpointLimitsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetBulkSetpointLimitsQuery,
    GetBulkSetpointLimitsQueryVariables
  >(GetBulkSetpointLimitsDocument, options);
}
export type GetBulkSetpointLimitsQueryHookResult = ReturnType<
  typeof useGetBulkSetpointLimitsQuery
>;
export type GetBulkSetpointLimitsLazyQueryHookResult = ReturnType<
  typeof useGetBulkSetpointLimitsLazyQuery
>;
export type GetBulkSetpointLimitsQueryResult = Apollo.QueryResult<
  GetBulkSetpointLimitsQuery,
  GetBulkSetpointLimitsQueryVariables
>;
export const ValidateBulkConfigThermostatsChangesDocument = gql`
  mutation ValidateBulkConfigThermostatsChanges(
    $input: BulkConfigThermostatsInput!
  ) {
    validateBulkConfigThermostatsChanges(input: $input) {
      numTStats
      numOnline
      numOffline
      numSupported
      numConfigurable
      deviceIds
      devices {
        deviceId
        compatible
        reason
        autoMode
        sourceType
        previewState
        needsChange
      }
    }
  }
`;
export type ValidateBulkConfigThermostatsChangesMutationFn =
  Apollo.MutationFunction<
    ValidateBulkConfigThermostatsChangesMutation,
    ValidateBulkConfigThermostatsChangesMutationVariables
  >;

/**
 * __useValidateBulkConfigThermostatsChangesMutation__
 *
 * To run a mutation, you first call `useValidateBulkConfigThermostatsChangesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useValidateBulkConfigThermostatsChangesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [validateBulkConfigThermostatsChangesMutation, { data, loading, error }] = useValidateBulkConfigThermostatsChangesMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useValidateBulkConfigThermostatsChangesMutation(
  baseOptions?: Apollo.MutationHookOptions<
    ValidateBulkConfigThermostatsChangesMutation,
    ValidateBulkConfigThermostatsChangesMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    ValidateBulkConfigThermostatsChangesMutation,
    ValidateBulkConfigThermostatsChangesMutationVariables
  >(ValidateBulkConfigThermostatsChangesDocument, options);
}
export type ValidateBulkConfigThermostatsChangesMutationHookResult = ReturnType<
  typeof useValidateBulkConfigThermostatsChangesMutation
>;
export type ValidateBulkConfigThermostatsChangesMutationResult =
  Apollo.MutationResult<ValidateBulkConfigThermostatsChangesMutation>;
export type ValidateBulkConfigThermostatsChangesMutationOptions =
  Apollo.BaseMutationOptions<
    ValidateBulkConfigThermostatsChangesMutation,
    ValidateBulkConfigThermostatsChangesMutationVariables
  >;
export const ValidateBulkConfigSetpointLimitsDocument = gql`
  mutation ValidateBulkConfigSetpointLimits(
    $input: BulkConfigSetpointLimitsInput!
  ) {
    validateBulkConfigSetpointLimits(input: $input) {
      numTStats
      numOnline
      numOffline
      numSupported
      numConfigurable
      deviceIds
    }
  }
`;
export type ValidateBulkConfigSetpointLimitsMutationFn =
  Apollo.MutationFunction<
    ValidateBulkConfigSetpointLimitsMutation,
    ValidateBulkConfigSetpointLimitsMutationVariables
  >;

/**
 * __useValidateBulkConfigSetpointLimitsMutation__
 *
 * To run a mutation, you first call `useValidateBulkConfigSetpointLimitsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useValidateBulkConfigSetpointLimitsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [validateBulkConfigSetpointLimitsMutation, { data, loading, error }] = useValidateBulkConfigSetpointLimitsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useValidateBulkConfigSetpointLimitsMutation(
  baseOptions?: Apollo.MutationHookOptions<
    ValidateBulkConfigSetpointLimitsMutation,
    ValidateBulkConfigSetpointLimitsMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    ValidateBulkConfigSetpointLimitsMutation,
    ValidateBulkConfigSetpointLimitsMutationVariables
  >(ValidateBulkConfigSetpointLimitsDocument, options);
}
export type ValidateBulkConfigSetpointLimitsMutationHookResult = ReturnType<
  typeof useValidateBulkConfigSetpointLimitsMutation
>;
export type ValidateBulkConfigSetpointLimitsMutationResult =
  Apollo.MutationResult<ValidateBulkConfigSetpointLimitsMutation>;
export type ValidateBulkConfigSetpointLimitsMutationOptions =
  Apollo.BaseMutationOptions<
    ValidateBulkConfigSetpointLimitsMutation,
    ValidateBulkConfigSetpointLimitsMutationVariables
  >;
export const CommitBulkConfigThermostatsChangesDocument = gql`
  mutation CommitBulkConfigThermostatsChanges(
    $deviceId: String!
    $input: BulkConfigThermostatsChanges!
  ) {
    commitBulkConfigThermostatsChanges(deviceId: $deviceId, input: $input) {
      deviceId
    }
  }
`;
export type CommitBulkConfigThermostatsChangesMutationFn =
  Apollo.MutationFunction<
    CommitBulkConfigThermostatsChangesMutation,
    CommitBulkConfigThermostatsChangesMutationVariables
  >;

/**
 * __useCommitBulkConfigThermostatsChangesMutation__
 *
 * To run a mutation, you first call `useCommitBulkConfigThermostatsChangesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCommitBulkConfigThermostatsChangesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [commitBulkConfigThermostatsChangesMutation, { data, loading, error }] = useCommitBulkConfigThermostatsChangesMutation({
 *   variables: {
 *      deviceId: // value for 'deviceId'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCommitBulkConfigThermostatsChangesMutation(
  baseOptions?: Apollo.MutationHookOptions<
    CommitBulkConfigThermostatsChangesMutation,
    CommitBulkConfigThermostatsChangesMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    CommitBulkConfigThermostatsChangesMutation,
    CommitBulkConfigThermostatsChangesMutationVariables
  >(CommitBulkConfigThermostatsChangesDocument, options);
}
export type CommitBulkConfigThermostatsChangesMutationHookResult = ReturnType<
  typeof useCommitBulkConfigThermostatsChangesMutation
>;
export type CommitBulkConfigThermostatsChangesMutationResult =
  Apollo.MutationResult<CommitBulkConfigThermostatsChangesMutation>;
export type CommitBulkConfigThermostatsChangesMutationOptions =
  Apollo.BaseMutationOptions<
    CommitBulkConfigThermostatsChangesMutation,
    CommitBulkConfigThermostatsChangesMutationVariables
  >;
export const CommitBulkConfigSetpointLimitsDocument = gql`
  mutation CommitBulkConfigSetpointLimits($deviceId: String!) {
    commitBulkConfigSetpointLimits(deviceId: $deviceId) {
      deviceId
    }
  }
`;
export type CommitBulkConfigSetpointLimitsMutationFn = Apollo.MutationFunction<
  CommitBulkConfigSetpointLimitsMutation,
  CommitBulkConfigSetpointLimitsMutationVariables
>;

/**
 * __useCommitBulkConfigSetpointLimitsMutation__
 *
 * To run a mutation, you first call `useCommitBulkConfigSetpointLimitsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCommitBulkConfigSetpointLimitsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [commitBulkConfigSetpointLimitsMutation, { data, loading, error }] = useCommitBulkConfigSetpointLimitsMutation({
 *   variables: {
 *      deviceId: // value for 'deviceId'
 *   },
 * });
 */
export function useCommitBulkConfigSetpointLimitsMutation(
  baseOptions?: Apollo.MutationHookOptions<
    CommitBulkConfigSetpointLimitsMutation,
    CommitBulkConfigSetpointLimitsMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    CommitBulkConfigSetpointLimitsMutation,
    CommitBulkConfigSetpointLimitsMutationVariables
  >(CommitBulkConfigSetpointLimitsDocument, options);
}
export type CommitBulkConfigSetpointLimitsMutationHookResult = ReturnType<
  typeof useCommitBulkConfigSetpointLimitsMutation
>;
export type CommitBulkConfigSetpointLimitsMutationResult =
  Apollo.MutationResult<CommitBulkConfigSetpointLimitsMutation>;
export type CommitBulkConfigSetpointLimitsMutationOptions =
  Apollo.BaseMutationOptions<
    CommitBulkConfigSetpointLimitsMutation,
    CommitBulkConfigSetpointLimitsMutationVariables
  >;
export const CommitBulkConfigThermostatsBatchDocument = gql`
  mutation CommitBulkConfigThermostatsBatch(
    $input: BulkConfigThermostatsInput!
    $deviceIds: [String!]!
    $excludedDeviceIds: [String!]!
    $previewStates: [String!]!
  ) {
    commitBulkConfigThermostatsBatch(
      input: $input
      deviceIds: $deviceIds
      excludedDeviceIds: $excludedDeviceIds
      previewStates: $previewStates
    ) {
      deviceId
      success
      error
    }
  }
`;
export type CommitBulkConfigThermostatsBatchMutationFn =
  Apollo.MutationFunction<
    CommitBulkConfigThermostatsBatchMutation,
    CommitBulkConfigThermostatsBatchMutationVariables
  >;

/**
 * __useCommitBulkConfigThermostatsBatchMutation__
 *
 * To run a mutation, you first call `useCommitBulkConfigThermostatsBatchMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCommitBulkConfigThermostatsBatchMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [commitBulkConfigThermostatsBatchMutation, { data, loading, error }] = useCommitBulkConfigThermostatsBatchMutation({
 *   variables: {
 *      input: // value for 'input'
 *      deviceIds: // value for 'deviceIds'
 *      excludedDeviceIds: // value for 'excludedDeviceIds'
 *      previewStates: // value for 'previewStates'
 *   },
 * });
 */
export function useCommitBulkConfigThermostatsBatchMutation(
  baseOptions?: Apollo.MutationHookOptions<
    CommitBulkConfigThermostatsBatchMutation,
    CommitBulkConfigThermostatsBatchMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    CommitBulkConfigThermostatsBatchMutation,
    CommitBulkConfigThermostatsBatchMutationVariables
  >(CommitBulkConfigThermostatsBatchDocument, options);
}
export type CommitBulkConfigThermostatsBatchMutationHookResult = ReturnType<
  typeof useCommitBulkConfigThermostatsBatchMutation
>;
export type CommitBulkConfigThermostatsBatchMutationResult =
  Apollo.MutationResult<CommitBulkConfigThermostatsBatchMutation>;
export type CommitBulkConfigThermostatsBatchMutationOptions =
  Apollo.BaseMutationOptions<
    CommitBulkConfigThermostatsBatchMutation,
    CommitBulkConfigThermostatsBatchMutationVariables
  >;
export const BulkConfigProgressUpdateDocument = gql`
  subscription BulkConfigProgressUpdate(
    $initiatorId: String!
    $initiatorType: String!
  ) {
    bulkConfigProgressUpdate(
      initiatorId: $initiatorId
      initiatorType: $initiatorType
    ) {
      initiatorId
      initiatorType
      totalCount
      errorCount
      completedCount
      isComplete
      percentProcessed
      errors {
        deviceType
        deviceName
        deviceId
        message
      }
    }
  }
`;

/**
 * __useBulkConfigProgressUpdateSubscription__
 *
 * To run a query within a React component, call `useBulkConfigProgressUpdateSubscription` and pass it any options that fit your needs.
 * When your component renders, `useBulkConfigProgressUpdateSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBulkConfigProgressUpdateSubscription({
 *   variables: {
 *      initiatorId: // value for 'initiatorId'
 *      initiatorType: // value for 'initiatorType'
 *   },
 * });
 */
export function useBulkConfigProgressUpdateSubscription(
  baseOptions: Apollo.SubscriptionHookOptions<
    BulkConfigProgressUpdateSubscription,
    BulkConfigProgressUpdateSubscriptionVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useSubscription<
    BulkConfigProgressUpdateSubscription,
    BulkConfigProgressUpdateSubscriptionVariables
  >(BulkConfigProgressUpdateDocument, options);
}
export type BulkConfigProgressUpdateSubscriptionHookResult = ReturnType<
  typeof useBulkConfigProgressUpdateSubscription
>;
export type BulkConfigProgressUpdateSubscriptionResult =
  Apollo.SubscriptionResult<BulkConfigProgressUpdateSubscription>;
export const ActuatorDetailUpdateDocument = gql`
  subscription ActuatorDetailUpdate($ids: [String!]!) {
    actuatorEventsByIds(_ids: $ids) {
      modelChangeOperation
      _id
      type
      typeDisplayName
      panelId
      name
      deviceId
      propertyId
      unitId
      sourceId
      timestamp
      hasPendingUpdates
      isConfigured
      meta {
        name
        model
        modelNumber
        version
        metrics
      }
      panel {
        _id
        sourceId
        name
        role
      }
      source {
        _id
        name
      }
      position {
        id
        timestamp
        value
        units
      }
      controlMode {
        id
        timestamp
        value
        units
      }
      defaultPosition {
        id
        timestamp
        value
        units
      }
      deviceAlerts {
        _id
        type {
          name
        }
        device {
          id
          name
          type
        }
        initiated
        updated
      }
      sourceAlerts {
        _id
        type {
          name
        }
        device {
          id
          name
          type
        }
        initiated
        updated
      }
      alertTypes {
        deviceOffline
        sourceOffline
      }
    }
  }
`;

/**
 * __useActuatorDetailUpdateSubscription__
 *
 * To run a query within a React component, call `useActuatorDetailUpdateSubscription` and pass it any options that fit your needs.
 * When your component renders, `useActuatorDetailUpdateSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useActuatorDetailUpdateSubscription({
 *   variables: {
 *      ids: // value for 'ids'
 *   },
 * });
 */
export function useActuatorDetailUpdateSubscription(
  baseOptions: Apollo.SubscriptionHookOptions<
    ActuatorDetailUpdateSubscription,
    ActuatorDetailUpdateSubscriptionVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useSubscription<
    ActuatorDetailUpdateSubscription,
    ActuatorDetailUpdateSubscriptionVariables
  >(ActuatorDetailUpdateDocument, options);
}
export type ActuatorDetailUpdateSubscriptionHookResult = ReturnType<
  typeof useActuatorDetailUpdateSubscription
>;
export type ActuatorDetailUpdateSubscriptionResult =
  Apollo.SubscriptionResult<ActuatorDetailUpdateSubscription>;
export const ActuatorDetailDocument = gql`
  query ActuatorDetail($id: String!) {
    actuatorById(_id: $id) {
      _id
      type
      typeDisplayName
      panelId
      name
      deviceId
      propertyId
      unitId
      sourceId
      timestamp
      hasPendingUpdates
      isConfigured
      meta {
        name
        model
        modelNumber
        version
        metrics
      }
      panel {
        _id
        sourceId
        name
        role
      }
      source {
        _id
        name
      }
      position {
        id
        timestamp
        value
        units
      }
      controlMode {
        id
        timestamp
        value
        units
      }
      defaultPosition {
        id
        timestamp
        value
        units
      }
      deviceAlerts {
        _id
        type {
          name
        }
        device {
          id
          name
          type
        }
        initiated
        updated
      }
      sourceAlerts {
        _id
        type {
          name
        }
        device {
          id
          name
          type
        }
        initiated
        updated
      }
      alertTypes {
        deviceOffline
        sourceOffline
      }
    }
  }
`;

/**
 * __useActuatorDetailQuery__
 *
 * To run a query within a React component, call `useActuatorDetailQuery` and pass it any options that fit your needs.
 * When your component renders, `useActuatorDetailQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useActuatorDetailQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useActuatorDetailQuery(
  baseOptions: Apollo.QueryHookOptions<
    ActuatorDetailQuery,
    ActuatorDetailQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<ActuatorDetailQuery, ActuatorDetailQueryVariables>(
    ActuatorDetailDocument,
    options,
  );
}
export function useActuatorDetailLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    ActuatorDetailQuery,
    ActuatorDetailQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<ActuatorDetailQuery, ActuatorDetailQueryVariables>(
    ActuatorDetailDocument,
    options,
  );
}
export type ActuatorDetailQueryHookResult = ReturnType<
  typeof useActuatorDetailQuery
>;
export type ActuatorDetailLazyQueryHookResult = ReturnType<
  typeof useActuatorDetailLazyQuery
>;
export type ActuatorDetailQueryResult = Apollo.QueryResult<
  ActuatorDetailQuery,
  ActuatorDetailQueryVariables
>;
export const BoilerDetailDocument = gql`
  query BoilerDetail($id: String!) {
    boilerById(_id: $id) {
      _id
      type
      typeDisplayName
      panelId
      name
      deviceId
      isConfigured
      isPoweredOn
      powerState {
        timestamp
        units
        value
      }
      timestamp
      meta {
        name
        model
        modelNumber
        version
      }
      source {
        _id
        name
      }
      deviceMetrics {
        key
        value {
          readOnly
        }
      }
      boilerPumpSpeed {
        timestamp
        units
        value
      }
      boilerPumpSpeed1 {
        timestamp
        units
        value
      }
      boilerPumpSpeed2 {
        timestamp
        units
        value
      }
      firingRate {
        timestamp
        units
        value
      }
      firingRate1 {
        timestamp
        units
        value
      }
      firingRate2 {
        timestamp
        units
        value
      }
      flueTemperature {
        timestamp
        units
        value
      }
      flueTemperature1 {
        timestamp
        units
        value
      }
      flueTemperature2 {
        timestamp
        units
        value
      }
      inletTemperature {
        timestamp
        units
        value
      }
      inletTemperature1 {
        timestamp
        units
        value
      }
      inletTemperature2 {
        timestamp
        units
        value
      }
      outdoorTemperature {
        timestamp
        units
        value
      }
      outletTemperature {
        timestamp
        units
        value
      }
      outletTemperature1 {
        timestamp
        units
        value
      }
      outletTemperature2 {
        timestamp
        units
        value
      }
      role
      hasModules
      hasBoilerPumpSpeed
      hasFiringRate
      hasFlueTemperature
      hasInletTemperature
      hasOutdoorTemperature
      hasOutletTemperature
      panel {
        _id
        name
        displayName
        role
        type
        sourceId
        source {
          _id
          name
        }
        alerts {
          _id
          type {
            id
            name
          }
          initiated
          updated
          panel {
            id
          }
          device {
            id
            name
            type
          }
          affectedSource {
            _id
            name
          }
        }
      }
      deviceAlerts {
        _id
        type {
          name
        }
        device {
          id
          name
          type
        }
        initiated
        updated
      }
      sourceAlerts {
        _id
        type {
          name
        }
        device {
          id
          name
          type
        }
        initiated
        updated
      }
    }
  }
`;

/**
 * __useBoilerDetailQuery__
 *
 * To run a query within a React component, call `useBoilerDetailQuery` and pass it any options that fit your needs.
 * When your component renders, `useBoilerDetailQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBoilerDetailQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useBoilerDetailQuery(
  baseOptions: Apollo.QueryHookOptions<
    BoilerDetailQuery,
    BoilerDetailQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<BoilerDetailQuery, BoilerDetailQueryVariables>(
    BoilerDetailDocument,
    options,
  );
}
export function useBoilerDetailLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    BoilerDetailQuery,
    BoilerDetailQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<BoilerDetailQuery, BoilerDetailQueryVariables>(
    BoilerDetailDocument,
    options,
  );
}
export type BoilerDetailQueryHookResult = ReturnType<
  typeof useBoilerDetailQuery
>;
export type BoilerDetailLazyQueryHookResult = ReturnType<
  typeof useBoilerDetailLazyQuery
>;
export type BoilerDetailQueryResult = Apollo.QueryResult<
  BoilerDetailQuery,
  BoilerDetailQueryVariables
>;
export const BoilerDetailUpdateDocument = gql`
  subscription BoilerDetailUpdate($ids: [String!]!) {
    boilerEventsByIds(_ids: $ids) {
      modelChangeOperation
      _id
      type
      typeDisplayName
      panelId
      name
      deviceId
      isConfigured
      isPoweredOn
      powerState {
        timestamp
        units
        value
      }
      timestamp
      meta {
        name
        model
        modelNumber
        version
      }
      boilerPumpSpeed {
        timestamp
        units
        value
      }
      boilerPumpSpeed1 {
        timestamp
        units
        value
      }
      boilerPumpSpeed2 {
        timestamp
        units
        value
      }
      firingRate {
        timestamp
        units
        value
      }
      firingRate1 {
        timestamp
        units
        value
      }
      firingRate2 {
        timestamp
        units
        value
      }
      flueTemperature {
        timestamp
        units
        value
      }
      flueTemperature1 {
        timestamp
        units
        value
      }
      flueTemperature2 {
        timestamp
        units
        value
      }
      inletTemperature {
        timestamp
        units
        value
      }
      inletTemperature1 {
        timestamp
        units
        value
      }
      inletTemperature2 {
        timestamp
        units
        value
      }
      outdoorTemperature {
        timestamp
        units
        value
      }
      outletTemperature {
        timestamp
        units
        value
      }
      outletTemperature1 {
        timestamp
        units
        value
      }
      outletTemperature2 {
        timestamp
        units
        value
      }
      role
      hasModules
      hasBoilerPumpSpeed
      hasFiringRate
      hasFlueTemperature
      hasInletTemperature
      hasOutdoorTemperature
      hasOutletTemperature
      panel {
        _id
        name
        displayName
        role
        type
        sourceId
        source {
          _id
          name
        }
        alerts {
          _id
          type {
            id
            name
          }
          initiated
          updated
          device {
            id
            name
            type
          }
          affectedSource {
            _id
            name
          }
        }
      }
      deviceAlerts {
        _id
        type {
          name
        }
        device {
          id
          name
          type
        }
        initiated
        updated
      }
      sourceAlerts {
        _id
        type {
          name
        }
        device {
          id
          name
          type
        }
        initiated
        updated
      }
    }
  }
`;

/**
 * __useBoilerDetailUpdateSubscription__
 *
 * To run a query within a React component, call `useBoilerDetailUpdateSubscription` and pass it any options that fit your needs.
 * When your component renders, `useBoilerDetailUpdateSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBoilerDetailUpdateSubscription({
 *   variables: {
 *      ids: // value for 'ids'
 *   },
 * });
 */
export function useBoilerDetailUpdateSubscription(
  baseOptions: Apollo.SubscriptionHookOptions<
    BoilerDetailUpdateSubscription,
    BoilerDetailUpdateSubscriptionVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useSubscription<
    BoilerDetailUpdateSubscription,
    BoilerDetailUpdateSubscriptionVariables
  >(BoilerDetailUpdateDocument, options);
}
export type BoilerDetailUpdateSubscriptionHookResult = ReturnType<
  typeof useBoilerDetailUpdateSubscription
>;
export type BoilerDetailUpdateSubscriptionResult =
  Apollo.SubscriptionResult<BoilerDetailUpdateSubscription>;
export const ChillerDetailUpdateDocument = gql`
  subscription ChillerDetailUpdate($ids: [String!]!) {
    chillerEventsByIds(_ids: $ids) {
      modelChangeOperation
      _id
      type
      typeDisplayName
      panelId
      name
      displayName
      deviceId
      isConfigured
      isPoweredOn
      hasPendingUpdates
      panel {
        _id
        sourceId
        name
        displayName
        type
      }
      powerState {
        timestamp
        units
        value
        updatePending
      }
      timestamp
      meta {
        name
        model
        modelNumber
        version
      }
      deviceMetrics {
        key
        value {
          readOnly
        }
      }
      panel {
        _id
        name
      }
      source {
        _id
        name
      }
      chilledSupplyTemperature {
        timestamp
        value
        units
      }
      chilledReturnTemperature {
        timestamp
        value
        units
      }
      coolSetpoint {
        timestamp
        value
        units
      }
      ambientTemperature {
        timestamp
        value
        units
      }
      deviceAlerts {
        _id
        type {
          name
        }
        device {
          id
          name
          type
        }
        initiated
        updated
      }
      sourceAlerts {
        _id
        type {
          name
        }
        device {
          id
          name
          type
        }
        initiated
        updated
      }
    }
  }
`;

/**
 * __useChillerDetailUpdateSubscription__
 *
 * To run a query within a React component, call `useChillerDetailUpdateSubscription` and pass it any options that fit your needs.
 * When your component renders, `useChillerDetailUpdateSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useChillerDetailUpdateSubscription({
 *   variables: {
 *      ids: // value for 'ids'
 *   },
 * });
 */
export function useChillerDetailUpdateSubscription(
  baseOptions: Apollo.SubscriptionHookOptions<
    ChillerDetailUpdateSubscription,
    ChillerDetailUpdateSubscriptionVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useSubscription<
    ChillerDetailUpdateSubscription,
    ChillerDetailUpdateSubscriptionVariables
  >(ChillerDetailUpdateDocument, options);
}
export type ChillerDetailUpdateSubscriptionHookResult = ReturnType<
  typeof useChillerDetailUpdateSubscription
>;
export type ChillerDetailUpdateSubscriptionResult =
  Apollo.SubscriptionResult<ChillerDetailUpdateSubscription>;
export const ChillerDetailDocument = gql`
  query ChillerDetail($id: String!) {
    chillerById(_id: $id) {
      _id
      type
      typeDisplayName
      panelId
      name
      displayName
      deviceId
      isConfigured
      isPoweredOn
      hasPendingUpdates
      panel {
        _id
        sourceId
        name
        displayName
        type
      }
      powerState {
        timestamp
        units
        value
        updatePending
      }
      timestamp
      meta {
        name
        model
        modelNumber
        version
      }
      deviceMetrics {
        key
        value {
          readOnly
        }
      }
      panel {
        _id
        name
      }
      source {
        _id
        name
      }
      chilledSupplyTemperature {
        timestamp
        value
        units
      }
      chilledReturnTemperature {
        timestamp
        value
        units
      }
      coolSetpoint {
        timestamp
        value
        units
      }
      ambientTemperature {
        timestamp
        value
        units
      }
      deviceAlerts {
        _id
        type {
          name
        }
        device {
          id
          name
          type
        }
        initiated
        updated
      }
      sourceAlerts {
        _id
        type {
          name
        }
        device {
          id
          name
          type
        }
        initiated
        updated
      }
    }
  }
`;

/**
 * __useChillerDetailQuery__
 *
 * To run a query within a React component, call `useChillerDetailQuery` and pass it any options that fit your needs.
 * When your component renders, `useChillerDetailQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useChillerDetailQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useChillerDetailQuery(
  baseOptions: Apollo.QueryHookOptions<
    ChillerDetailQuery,
    ChillerDetailQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<ChillerDetailQuery, ChillerDetailQueryVariables>(
    ChillerDetailDocument,
    options,
  );
}
export function useChillerDetailLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    ChillerDetailQuery,
    ChillerDetailQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<ChillerDetailQuery, ChillerDetailQueryVariables>(
    ChillerDetailDocument,
    options,
  );
}
export type ChillerDetailQueryHookResult = ReturnType<
  typeof useChillerDetailQuery
>;
export type ChillerDetailLazyQueryHookResult = ReturnType<
  typeof useChillerDetailLazyQuery
>;
export type ChillerDetailQueryResult = Apollo.QueryResult<
  ChillerDetailQuery,
  ChillerDetailQueryVariables
>;
export const ControllerDetailUpdateDocument = gql`
  subscription ControllerDetailUpdate($ids: [String!]!) {
    controllerEventsByIds(_ids: $ids) {
      modelChangeOperation
      _id
      type
      typeDisplayName
      panelId
      name
      deviceId
      sourceId
      timestamp
      isConfigured
      displayName
      meta {
        name
        model
        modelNumber
        version
        metrics
      }
      panel {
        _id
        name
        displayName
        type
        sourceId
      }
      source {
        _id
        name
      }
      communicationState {
        timestamp
        value
        units
      }
      activeAlarmCount {
        timestamp
        value
        units
      }
      resetCount {
        timestamp
        value
        units
      }
    }
  }
`;

/**
 * __useControllerDetailUpdateSubscription__
 *
 * To run a query within a React component, call `useControllerDetailUpdateSubscription` and pass it any options that fit your needs.
 * When your component renders, `useControllerDetailUpdateSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useControllerDetailUpdateSubscription({
 *   variables: {
 *      ids: // value for 'ids'
 *   },
 * });
 */
export function useControllerDetailUpdateSubscription(
  baseOptions: Apollo.SubscriptionHookOptions<
    ControllerDetailUpdateSubscription,
    ControllerDetailUpdateSubscriptionVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useSubscription<
    ControllerDetailUpdateSubscription,
    ControllerDetailUpdateSubscriptionVariables
  >(ControllerDetailUpdateDocument, options);
}
export type ControllerDetailUpdateSubscriptionHookResult = ReturnType<
  typeof useControllerDetailUpdateSubscription
>;
export type ControllerDetailUpdateSubscriptionResult =
  Apollo.SubscriptionResult<ControllerDetailUpdateSubscription>;
export const ControllerDetailDocument = gql`
  query ControllerDetail($id: String!) {
    controllerById(_id: $id) {
      _id
      type
      typeDisplayName
      panelId
      name
      deviceId
      sourceId
      timestamp
      isConfigured
      displayName
      meta {
        name
        model
        modelNumber
        version
        metrics
      }
      panel {
        _id
        name
        displayName
        type
        sourceId
      }
      source {
        _id
        name
      }
      communicationState {
        timestamp
        value
        units
      }
      activeAlarmCount {
        timestamp
        value
        units
      }
      resetCount {
        timestamp
        value
        units
      }
    }
  }
`;

/**
 * __useControllerDetailQuery__
 *
 * To run a query within a React component, call `useControllerDetailQuery` and pass it any options that fit your needs.
 * When your component renders, `useControllerDetailQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useControllerDetailQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useControllerDetailQuery(
  baseOptions: Apollo.QueryHookOptions<
    ControllerDetailQuery,
    ControllerDetailQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<ControllerDetailQuery, ControllerDetailQueryVariables>(
    ControllerDetailDocument,
    options,
  );
}
export function useControllerDetailLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    ControllerDetailQuery,
    ControllerDetailQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    ControllerDetailQuery,
    ControllerDetailQueryVariables
  >(ControllerDetailDocument, options);
}
export type ControllerDetailQueryHookResult = ReturnType<
  typeof useControllerDetailQuery
>;
export type ControllerDetailLazyQueryHookResult = ReturnType<
  typeof useControllerDetailLazyQuery
>;
export type ControllerDetailQueryResult = Apollo.QueryResult<
  ControllerDetailQuery,
  ControllerDetailQueryVariables
>;
export const GpioDetailUpdateDocument = gql`
  subscription GpioDetailUpdate($ids: [String!]!) {
    gPIOEventsByIds(_ids: $ids) {
      modelChangeOperation
      _id
      type
      typeDisplayName
      panelId
      name
      deviceId
      isConfigured
      timestamp
      meta {
        name
        model
        modelNumber
        version
      }
      state {
        timestamp
        value
        units
      }
      deviceAlerts {
        _id
        type {
          name
        }
        device {
          id
          name
          type
        }
        initiated
        updated
      }
      sourceAlerts {
        _id
        type {
          name
        }
        device {
          id
          name
          type
        }
        initiated
        updated
      }
      panel {
        _id
        sourceId
        name
      }
      source {
        _id
        name
      }
    }
  }
`;

/**
 * __useGpioDetailUpdateSubscription__
 *
 * To run a query within a React component, call `useGpioDetailUpdateSubscription` and pass it any options that fit your needs.
 * When your component renders, `useGpioDetailUpdateSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGpioDetailUpdateSubscription({
 *   variables: {
 *      ids: // value for 'ids'
 *   },
 * });
 */
export function useGpioDetailUpdateSubscription(
  baseOptions: Apollo.SubscriptionHookOptions<
    GpioDetailUpdateSubscription,
    GpioDetailUpdateSubscriptionVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useSubscription<
    GpioDetailUpdateSubscription,
    GpioDetailUpdateSubscriptionVariables
  >(GpioDetailUpdateDocument, options);
}
export type GpioDetailUpdateSubscriptionHookResult = ReturnType<
  typeof useGpioDetailUpdateSubscription
>;
export type GpioDetailUpdateSubscriptionResult =
  Apollo.SubscriptionResult<GpioDetailUpdateSubscription>;
export const GpioDetailDocument = gql`
  query GpioDetail($id: String!) {
    gPIOById(_id: $id) {
      _id
      type
      typeDisplayName
      panelId
      name
      deviceId
      isConfigured
      timestamp
      meta {
        name
        model
        modelNumber
        version
      }
      panel {
        _id
        sourceId
        name
      }
      source {
        _id
        name
      }
      state {
        timestamp
        value
        units
      }
      deviceAlerts {
        _id
        type {
          name
        }
        device {
          id
          name
          type
        }
        initiated
        updated
      }
      sourceAlerts {
        _id
        type {
          name
        }
        device {
          id
          name
          type
        }
        initiated
        updated
      }
    }
  }
`;

/**
 * __useGpioDetailQuery__
 *
 * To run a query within a React component, call `useGpioDetailQuery` and pass it any options that fit your needs.
 * When your component renders, `useGpioDetailQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGpioDetailQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGpioDetailQuery(
  baseOptions: Apollo.QueryHookOptions<
    GpioDetailQuery,
    GpioDetailQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GpioDetailQuery, GpioDetailQueryVariables>(
    GpioDetailDocument,
    options,
  );
}
export function useGpioDetailLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GpioDetailQuery,
    GpioDetailQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GpioDetailQuery, GpioDetailQueryVariables>(
    GpioDetailDocument,
    options,
  );
}
export type GpioDetailQueryHookResult = ReturnType<typeof useGpioDetailQuery>;
export type GpioDetailLazyQueryHookResult = ReturnType<
  typeof useGpioDetailLazyQuery
>;
export type GpioDetailQueryResult = Apollo.QueryResult<
  GpioDetailQuery,
  GpioDetailQueryVariables
>;
export const GpioPanelDetailUpdateDocument = gql`
  subscription gpioPanelDetailUpdate($ids: [String!]!) {
    panelEventsByIds(_ids: $ids) {
      modelChangeOperation
      _id
      name
      displayName
      role
      type
      sourceId
      source {
        _id
        name
      }
      alerts {
        _id
        type {
          id
          name
        }
        panel {
          id
        }
        initiated
        updated
        device {
          id
          name
          type
        }
        affectedSource {
          _id
          name
        }
      }
    }
  }
`;

/**
 * __useGpioPanelDetailUpdateSubscription__
 *
 * To run a query within a React component, call `useGpioPanelDetailUpdateSubscription` and pass it any options that fit your needs.
 * When your component renders, `useGpioPanelDetailUpdateSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGpioPanelDetailUpdateSubscription({
 *   variables: {
 *      ids: // value for 'ids'
 *   },
 * });
 */
export function useGpioPanelDetailUpdateSubscription(
  baseOptions: Apollo.SubscriptionHookOptions<
    GpioPanelDetailUpdateSubscription,
    GpioPanelDetailUpdateSubscriptionVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useSubscription<
    GpioPanelDetailUpdateSubscription,
    GpioPanelDetailUpdateSubscriptionVariables
  >(GpioPanelDetailUpdateDocument, options);
}
export type GpioPanelDetailUpdateSubscriptionHookResult = ReturnType<
  typeof useGpioPanelDetailUpdateSubscription
>;
export type GpioPanelDetailUpdateSubscriptionResult =
  Apollo.SubscriptionResult<GpioPanelDetailUpdateSubscription>;
export const GpioPanelDetailDocument = gql`
  query GpioPanelDetail($id: String!) {
    panel(filter: { _id: $id }) {
      _id
      name
      displayName
      role
      type
      sourceId
      source {
        _id
        name
      }
      devices(sort: NAME_ASC) {
        _id
        type
        typeDisplayName
        name
        deviceId
        timestamp
        ... on GPIO {
          state {
            id
            value
          }
        }
      }
      alerts {
        _id
        type {
          id
          name
        }
        initiated
        updated
        panel {
          id
        }
        device {
          id
          name
          type
        }
        affectedSource {
          _id
          name
        }
      }
    }
  }
`;

/**
 * __useGpioPanelDetailQuery__
 *
 * To run a query within a React component, call `useGpioPanelDetailQuery` and pass it any options that fit your needs.
 * When your component renders, `useGpioPanelDetailQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGpioPanelDetailQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGpioPanelDetailQuery(
  baseOptions: Apollo.QueryHookOptions<
    GpioPanelDetailQuery,
    GpioPanelDetailQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GpioPanelDetailQuery, GpioPanelDetailQueryVariables>(
    GpioPanelDetailDocument,
    options,
  );
}
export function useGpioPanelDetailLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GpioPanelDetailQuery,
    GpioPanelDetailQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GpioPanelDetailQuery,
    GpioPanelDetailQueryVariables
  >(GpioPanelDetailDocument, options);
}
export type GpioPanelDetailQueryHookResult = ReturnType<
  typeof useGpioPanelDetailQuery
>;
export type GpioPanelDetailLazyQueryHookResult = ReturnType<
  typeof useGpioPanelDetailLazyQuery
>;
export type GpioPanelDetailQueryResult = Apollo.QueryResult<
  GpioPanelDetailQuery,
  GpioPanelDetailQueryVariables
>;
export const LoopDetailUpdateDocument = gql`
  subscription LoopDetailUpdate($ids: [String!]!) {
    panelEventsByIds(_ids: $ids) {
      modelChangeOperation
      _id
      name
      displayName
      type
      role
      sourceId
      alerts {
        _id
        type {
          id
          name
        }
        initiated
        updated
        device {
          id
          name
          type
        }
        affectedSource {
          _id
          name
        }
      }
    }
  }
`;

/**
 * __useLoopDetailUpdateSubscription__
 *
 * To run a query within a React component, call `useLoopDetailUpdateSubscription` and pass it any options that fit your needs.
 * When your component renders, `useLoopDetailUpdateSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLoopDetailUpdateSubscription({
 *   variables: {
 *      ids: // value for 'ids'
 *   },
 * });
 */
export function useLoopDetailUpdateSubscription(
  baseOptions: Apollo.SubscriptionHookOptions<
    LoopDetailUpdateSubscription,
    LoopDetailUpdateSubscriptionVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useSubscription<
    LoopDetailUpdateSubscription,
    LoopDetailUpdateSubscriptionVariables
  >(LoopDetailUpdateDocument, options);
}
export type LoopDetailUpdateSubscriptionHookResult = ReturnType<
  typeof useLoopDetailUpdateSubscription
>;
export type LoopDetailUpdateSubscriptionResult =
  Apollo.SubscriptionResult<LoopDetailUpdateSubscription>;
export const LoopDetailDocument = gql`
  query LoopDetail($id: String!) {
    panel(filter: { _id: $id }) {
      _id
      name
      displayName
      type
      role
      sourceId
      source {
        _id
        name
      }
      alerts {
        _id
        type {
          id
          name
        }
        initiated
        updated
        panel {
          id
        }
        device {
          id
          name
          type
        }
        sourceId
        affectedSource {
          _id
          name
        }
      }
    }
  }
`;

/**
 * __useLoopDetailQuery__
 *
 * To run a query within a React component, call `useLoopDetailQuery` and pass it any options that fit your needs.
 * When your component renders, `useLoopDetailQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLoopDetailQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useLoopDetailQuery(
  baseOptions: Apollo.QueryHookOptions<
    LoopDetailQuery,
    LoopDetailQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<LoopDetailQuery, LoopDetailQueryVariables>(
    LoopDetailDocument,
    options,
  );
}
export function useLoopDetailLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    LoopDetailQuery,
    LoopDetailQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<LoopDetailQuery, LoopDetailQueryVariables>(
    LoopDetailDocument,
    options,
  );
}
export type LoopDetailQueryHookResult = ReturnType<typeof useLoopDetailQuery>;
export type LoopDetailLazyQueryHookResult = ReturnType<
  typeof useLoopDetailLazyQuery
>;
export type LoopDetailQueryResult = Apollo.QueryResult<
  LoopDetailQuery,
  LoopDetailQueryVariables
>;
export const LoopPumpsUpdateDocument = gql`
  subscription LoopPumpsUpdate($ids: [String!]!) {
    vSDPumpEventsByIds(_ids: $ids) {
      modelChangeOperation
      alertTypes {
        deviceOffline
        sourceOffline
      }
      _id
      hasPendingUpdates
      stopOrStart {
        id
        timestamp
        value
        units
        updatePending
      }
    }
  }
`;

/**
 * __useLoopPumpsUpdateSubscription__
 *
 * To run a query within a React component, call `useLoopPumpsUpdateSubscription` and pass it any options that fit your needs.
 * When your component renders, `useLoopPumpsUpdateSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLoopPumpsUpdateSubscription({
 *   variables: {
 *      ids: // value for 'ids'
 *   },
 * });
 */
export function useLoopPumpsUpdateSubscription(
  baseOptions: Apollo.SubscriptionHookOptions<
    LoopPumpsUpdateSubscription,
    LoopPumpsUpdateSubscriptionVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useSubscription<
    LoopPumpsUpdateSubscription,
    LoopPumpsUpdateSubscriptionVariables
  >(LoopPumpsUpdateDocument, options);
}
export type LoopPumpsUpdateSubscriptionHookResult = ReturnType<
  typeof useLoopPumpsUpdateSubscription
>;
export type LoopPumpsUpdateSubscriptionResult =
  Apollo.SubscriptionResult<LoopPumpsUpdateSubscription>;
export const OpenWeatherDetailUpdateDocument = gql`
  subscription OpenWeatherDetailUpdate($ids: [String!]!) {
    openWeatherEventsByIds(_ids: $ids) {
      modelChangeOperation
      _id
      type
      typeDisplayName
      panelId
      name
      deviceId
      timestamp
      isConfigured
      meta {
        name
        model
        modelNumber
        version
      }
      temperature {
        timestamp
        value
        units
      }
      panel {
        _id
        name
        displayName
        role
        type
        sourceId
        alerts {
          _id
          type {
            id
            name
          }
          initiated
          updated
          panel {
            id
          }
          device {
            id
            name
            type
          }
          sourceId
          affectedSource {
            _id
            name
          }
        }
      }
      deviceAlerts {
        _id
        type {
          name
        }
        device {
          id
          name
          type
        }
        initiated
        updated
      }
      sourceAlerts {
        _id
        type {
          name
        }
        device {
          id
          name
          type
        }
        initiated
        updated
      }
    }
  }
`;

/**
 * __useOpenWeatherDetailUpdateSubscription__
 *
 * To run a query within a React component, call `useOpenWeatherDetailUpdateSubscription` and pass it any options that fit your needs.
 * When your component renders, `useOpenWeatherDetailUpdateSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOpenWeatherDetailUpdateSubscription({
 *   variables: {
 *      ids: // value for 'ids'
 *   },
 * });
 */
export function useOpenWeatherDetailUpdateSubscription(
  baseOptions: Apollo.SubscriptionHookOptions<
    OpenWeatherDetailUpdateSubscription,
    OpenWeatherDetailUpdateSubscriptionVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useSubscription<
    OpenWeatherDetailUpdateSubscription,
    OpenWeatherDetailUpdateSubscriptionVariables
  >(OpenWeatherDetailUpdateDocument, options);
}
export type OpenWeatherDetailUpdateSubscriptionHookResult = ReturnType<
  typeof useOpenWeatherDetailUpdateSubscription
>;
export type OpenWeatherDetailUpdateSubscriptionResult =
  Apollo.SubscriptionResult<OpenWeatherDetailUpdateSubscription>;
export const OpenWeatherDetailDocument = gql`
  query OpenWeatherDetail($id: String!) {
    openWeatherById(_id: $id) {
      _id
      type
      typeDisplayName
      panelId
      name
      deviceId
      timestamp
      isConfigured
      meta {
        name
        model
        modelNumber
        version
        location
      }
      source {
        _id
        name
      }
      temperature {
        timestamp
        value
        units
      }
      panel {
        _id
        name
        displayName
        role
        type
        sourceId
        alerts {
          _id
          type {
            id
            name
          }
          initiated
          updated
          panel {
            id
          }
          device {
            id
            name
            type
          }
          sourceId
          affectedSource {
            _id
            name
          }
        }
      }
      deviceAlerts {
        _id
        type {
          name
        }
        device {
          id
          name
          type
        }
        initiated
        updated
      }
      sourceAlerts {
        _id
        type {
          name
        }
        device {
          id
          name
          type
        }
        initiated
        updated
      }
    }
  }
`;

/**
 * __useOpenWeatherDetailQuery__
 *
 * To run a query within a React component, call `useOpenWeatherDetailQuery` and pass it any options that fit your needs.
 * When your component renders, `useOpenWeatherDetailQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOpenWeatherDetailQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useOpenWeatherDetailQuery(
  baseOptions: Apollo.QueryHookOptions<
    OpenWeatherDetailQuery,
    OpenWeatherDetailQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    OpenWeatherDetailQuery,
    OpenWeatherDetailQueryVariables
  >(OpenWeatherDetailDocument, options);
}
export function useOpenWeatherDetailLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    OpenWeatherDetailQuery,
    OpenWeatherDetailQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    OpenWeatherDetailQuery,
    OpenWeatherDetailQueryVariables
  >(OpenWeatherDetailDocument, options);
}
export type OpenWeatherDetailQueryHookResult = ReturnType<
  typeof useOpenWeatherDetailQuery
>;
export type OpenWeatherDetailLazyQueryHookResult = ReturnType<
  typeof useOpenWeatherDetailLazyQuery
>;
export type OpenWeatherDetailQueryResult = Apollo.QueryResult<
  OpenWeatherDetailQuery,
  OpenWeatherDetailQueryVariables
>;
export const OutdoorSensorDetailDocument = gql`
  query OutdoorSensorDetail($id: String!) {
    outdoorSensorById(_id: $id) {
      _id
      type
      typeDisplayName
      panelId
      name
      deviceId
      timestamp
      isConfigured
      meta {
        name
        model
        modelNumber
        version
      }
      panel {
        _id
        sourceId
        name
        displayName
        role
        type
      }
      source {
        _id
        name
      }
      temperature {
        timestamp
        value
        units
      }
      deviceAlerts {
        _id
        type {
          name
        }
        device {
          id
          name
          type
        }
        initiated
        updated
      }
      sourceAlerts {
        _id
        type {
          name
        }
        device {
          id
          name
          type
        }
        initiated
        updated
      }
    }
  }
`;

/**
 * __useOutdoorSensorDetailQuery__
 *
 * To run a query within a React component, call `useOutdoorSensorDetailQuery` and pass it any options that fit your needs.
 * When your component renders, `useOutdoorSensorDetailQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOutdoorSensorDetailQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useOutdoorSensorDetailQuery(
  baseOptions: Apollo.QueryHookOptions<
    OutdoorSensorDetailQuery,
    OutdoorSensorDetailQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    OutdoorSensorDetailQuery,
    OutdoorSensorDetailQueryVariables
  >(OutdoorSensorDetailDocument, options);
}
export function useOutdoorSensorDetailLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    OutdoorSensorDetailQuery,
    OutdoorSensorDetailQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    OutdoorSensorDetailQuery,
    OutdoorSensorDetailQueryVariables
  >(OutdoorSensorDetailDocument, options);
}
export type OutdoorSensorDetailQueryHookResult = ReturnType<
  typeof useOutdoorSensorDetailQuery
>;
export type OutdoorSensorDetailLazyQueryHookResult = ReturnType<
  typeof useOutdoorSensorDetailLazyQuery
>;
export type OutdoorSensorDetailQueryResult = Apollo.QueryResult<
  OutdoorSensorDetailQuery,
  OutdoorSensorDetailQueryVariables
>;
export const PowerMonitorDetailUpdateDocument = gql`
  subscription PowerMonitorDetailUpdate($ids: [String!]!) {
    powerMonitorEventsByIds(_ids: $ids) {
      modelChangeOperation
      _id
      panelId
      name
      type
      typeDisplayName
      deviceId
      timestamp
      isConfigured
      meta {
        name
        model
        modelNumber
        version
      }
      source {
        _id
        name
      }
      panel {
        _id
        sourceId
        name
        displayName
        role
        type
        alerts {
          _id
          type {
            id
            name
          }
          initiated
          updated
          panel {
            id
          }
          device {
            id
            name
            type
          }
          sourceId
          affectedSource {
            _id
            name
          }
        }
      }
      deviceAlerts {
        _id
        type {
          name
        }
        device {
          id
          name
          type
        }
        initiated
        updated
      }
      sourceAlerts {
        _id
        type {
          name
        }
        device {
          id
          name
          type
        }
        initiated
        updated
      }
      supportsPhasedFrequencies
      supportsTotalFrequency
      supportsPhasedPowerFactors
      supportsTotalPowerFactor
      supportsPhasedActivePower
      supportsTotalActivePower
      supportsPhasedActiveEnergyFwd
      supportsTotalActiveEnergyFwd
      supportsPhasedActiveEnergyRev
      supportsTotalActiveEnergyRev
      frequency {
        units
        value
      }
      phaseAFrequency {
        units
        value
      }
      phaseBFrequency {
        units
        value
      }
      phaseCFrequency {
        units
        value
      }
      phaseAActiveEnergyFwd {
        units
        value
      }
      phaseAActiveEnergyRev {
        units
        value
      }
      phaseAActivePower {
        units
        value
      }
      phaseACurrent {
        units
        value
      }
      phaseAPowerFactor {
        units
        value
      }
      phaseAVoltage {
        units
        value
      }
      phaseBActiveEnergyFwd {
        units
        value
      }
      phaseBActiveEnergyRev {
        units
        value
      }
      phaseBActivePower {
        units
        value
      }
      phaseBCurrent {
        units
        value
      }
      phaseBPowerFactor {
        units
        value
      }
      phaseBVoltage {
        units
        value
      }
      phaseCActiveEnergyFwd {
        units
        value
      }
      phaseCActiveEnergyRev {
        units
        value
      }
      phaseCActivePower {
        units
        value
      }
      phaseCCurrent {
        units
        value
      }
      phaseCPowerFactor {
        units
        value
      }
      phaseCVoltage {
        units
        value
      }
      totalPowerFactor {
        units
        value
      }
      totalActivePower {
        units
        value
      }
      threePhaseTotalActiveEnergyFwd {
        units
        value
      }
      threePhaseTotalActiveEnergyRev {
        units
        value
      }
    }
  }
`;

/**
 * __usePowerMonitorDetailUpdateSubscription__
 *
 * To run a query within a React component, call `usePowerMonitorDetailUpdateSubscription` and pass it any options that fit your needs.
 * When your component renders, `usePowerMonitorDetailUpdateSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePowerMonitorDetailUpdateSubscription({
 *   variables: {
 *      ids: // value for 'ids'
 *   },
 * });
 */
export function usePowerMonitorDetailUpdateSubscription(
  baseOptions: Apollo.SubscriptionHookOptions<
    PowerMonitorDetailUpdateSubscription,
    PowerMonitorDetailUpdateSubscriptionVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useSubscription<
    PowerMonitorDetailUpdateSubscription,
    PowerMonitorDetailUpdateSubscriptionVariables
  >(PowerMonitorDetailUpdateDocument, options);
}
export type PowerMonitorDetailUpdateSubscriptionHookResult = ReturnType<
  typeof usePowerMonitorDetailUpdateSubscription
>;
export type PowerMonitorDetailUpdateSubscriptionResult =
  Apollo.SubscriptionResult<PowerMonitorDetailUpdateSubscription>;
export const PowerMonitorDetailDocument = gql`
  query PowerMonitorDetail($id: String!) {
    powerMonitorById(_id: $id) {
      _id
      panelId
      name
      type
      typeDisplayName
      deviceId
      timestamp
      isConfigured
      meta {
        name
        model
        modelNumber
        version
      }
      source {
        _id
        name
      }
      panel {
        _id
        sourceId
        name
        displayName
        role
        type
        alerts {
          _id
          type {
            id
            name
          }
          initiated
          updated
          panel {
            id
          }
          device {
            id
            name
            type
          }
          sourceId
          affectedSource {
            _id
            name
          }
        }
      }
      deviceAlerts {
        _id
        type {
          name
        }
        device {
          id
          name
          type
        }
        initiated
        updated
      }
      sourceAlerts {
        _id
        type {
          name
        }
        device {
          id
          name
          type
        }
        initiated
        updated
      }
      supportsPhasedFrequencies
      supportsTotalFrequency
      supportsPhasedPowerFactors
      supportsTotalPowerFactor
      supportsPhasedActivePower
      supportsTotalActivePower
      supportsPhasedActiveEnergyFwd
      supportsTotalActiveEnergyFwd
      supportsPhasedActiveEnergyRev
      supportsTotalActiveEnergyRev
      frequency {
        units
        value
      }
      phaseAFrequency {
        units
        value
      }
      phaseBFrequency {
        units
        value
      }
      phaseCFrequency {
        units
        value
      }
      phaseAActiveEnergyFwd {
        units
        value
      }
      phaseAActiveEnergyRev {
        units
        value
      }
      phaseAActivePower {
        units
        value
      }
      phaseACurrent {
        units
        value
      }
      phaseAPowerFactor {
        units
        value
      }
      phaseAVoltage {
        units
        value
      }
      phaseBActiveEnergyFwd {
        units
        value
      }
      phaseBActiveEnergyRev {
        units
        value
      }
      phaseBActivePower {
        units
        value
      }
      phaseBCurrent {
        units
        value
      }
      phaseBPowerFactor {
        units
        value
      }
      phaseBVoltage {
        units
        value
      }
      phaseCActiveEnergyFwd {
        units
        value
      }
      phaseCActiveEnergyRev {
        units
        value
      }
      phaseCActivePower {
        units
        value
      }
      phaseCCurrent {
        units
        value
      }
      phaseCPowerFactor {
        units
        value
      }
      phaseCVoltage {
        units
        value
      }
      totalPowerFactor {
        units
        value
      }
      totalActivePower {
        units
        value
      }
      threePhaseTotalActiveEnergyFwd {
        units
        value
      }
      threePhaseTotalActiveEnergyRev {
        units
        value
      }
      deviceMetrics {
        key
        value {
          unit
          units
          valueType
        }
      }
    }
  }
`;

/**
 * __usePowerMonitorDetailQuery__
 *
 * To run a query within a React component, call `usePowerMonitorDetailQuery` and pass it any options that fit your needs.
 * When your component renders, `usePowerMonitorDetailQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePowerMonitorDetailQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function usePowerMonitorDetailQuery(
  baseOptions: Apollo.QueryHookOptions<
    PowerMonitorDetailQuery,
    PowerMonitorDetailQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    PowerMonitorDetailQuery,
    PowerMonitorDetailQueryVariables
  >(PowerMonitorDetailDocument, options);
}
export function usePowerMonitorDetailLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    PowerMonitorDetailQuery,
    PowerMonitorDetailQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    PowerMonitorDetailQuery,
    PowerMonitorDetailQueryVariables
  >(PowerMonitorDetailDocument, options);
}
export type PowerMonitorDetailQueryHookResult = ReturnType<
  typeof usePowerMonitorDetailQuery
>;
export type PowerMonitorDetailLazyQueryHookResult = ReturnType<
  typeof usePowerMonitorDetailLazyQuery
>;
export type PowerMonitorDetailQueryResult = Apollo.QueryResult<
  PowerMonitorDetailQuery,
  PowerMonitorDetailQueryVariables
>;
export const PressureSensorDetailUpdateDocument = gql`
  subscription PressureSensorDetailUpdate($ids: [String!]!) {
    pressureSensorEventsByIds(_ids: $ids) {
      modelChangeOperation
      _id
      type
      typeDisplayName
      panelId
      name
      deviceId
      timestamp
      isConfigured
      role
      meta {
        name
        model
        modelNumber
        version
      }
      panel {
        _id
        sourceId
        name
      }
      pressure {
        timestamp
        value
        units
      }
      deviceAlerts {
        _id
        type {
          name
        }
        device {
          id
          name
          type
        }
        initiated
        updated
      }
      sourceAlerts {
        _id
        type {
          name
        }
        device {
          id
          name
          type
        }
        initiated
        updated
      }
    }
  }
`;

/**
 * __usePressureSensorDetailUpdateSubscription__
 *
 * To run a query within a React component, call `usePressureSensorDetailUpdateSubscription` and pass it any options that fit your needs.
 * When your component renders, `usePressureSensorDetailUpdateSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePressureSensorDetailUpdateSubscription({
 *   variables: {
 *      ids: // value for 'ids'
 *   },
 * });
 */
export function usePressureSensorDetailUpdateSubscription(
  baseOptions: Apollo.SubscriptionHookOptions<
    PressureSensorDetailUpdateSubscription,
    PressureSensorDetailUpdateSubscriptionVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useSubscription<
    PressureSensorDetailUpdateSubscription,
    PressureSensorDetailUpdateSubscriptionVariables
  >(PressureSensorDetailUpdateDocument, options);
}
export type PressureSensorDetailUpdateSubscriptionHookResult = ReturnType<
  typeof usePressureSensorDetailUpdateSubscription
>;
export type PressureSensorDetailUpdateSubscriptionResult =
  Apollo.SubscriptionResult<PressureSensorDetailUpdateSubscription>;
export const PressureSensorDetailDocument = gql`
  query PressureSensorDetail($id: String!) {
    pressureSensorById(_id: $id) {
      _id
      type
      typeDisplayName
      panelId
      name
      deviceId
      timestamp
      isConfigured
      role
      meta {
        name
        model
        modelNumber
        version
      }
      panel {
        _id
        sourceId
        name
      }
      source {
        _id
        name
      }
      pressure {
        timestamp
        value
        units
      }
      deviceAlerts {
        _id
        type {
          name
        }
        device {
          id
          name
          type
        }
        initiated
        updated
      }
      sourceAlerts {
        _id
        type {
          name
        }
        device {
          id
          name
          type
        }
        initiated
        updated
      }
    }
  }
`;

/**
 * __usePressureSensorDetailQuery__
 *
 * To run a query within a React component, call `usePressureSensorDetailQuery` and pass it any options that fit your needs.
 * When your component renders, `usePressureSensorDetailQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePressureSensorDetailQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function usePressureSensorDetailQuery(
  baseOptions: Apollo.QueryHookOptions<
    PressureSensorDetailQuery,
    PressureSensorDetailQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    PressureSensorDetailQuery,
    PressureSensorDetailQueryVariables
  >(PressureSensorDetailDocument, options);
}
export function usePressureSensorDetailLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    PressureSensorDetailQuery,
    PressureSensorDetailQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    PressureSensorDetailQuery,
    PressureSensorDetailQueryVariables
  >(PressureSensorDetailDocument, options);
}
export type PressureSensorDetailQueryHookResult = ReturnType<
  typeof usePressureSensorDetailQuery
>;
export type PressureSensorDetailLazyQueryHookResult = ReturnType<
  typeof usePressureSensorDetailLazyQuery
>;
export type PressureSensorDetailQueryResult = Apollo.QueryResult<
  PressureSensorDetailQuery,
  PressureSensorDetailQueryVariables
>;
export const SwapPumpsDocument = gql`
  mutation SwapPumps($primaryPumpId: String!, $secondaryPumpId: String!) {
    swapVSDPumpOnOffState(
      deviceId1: $primaryPumpId
      deviceId2: $secondaryPumpId
    ) {
      _id
      stopOrStart {
        value
      }
      hasPendingUpdates
    }
  }
`;
export type SwapPumpsMutationFn = Apollo.MutationFunction<
  SwapPumpsMutation,
  SwapPumpsMutationVariables
>;

/**
 * __useSwapPumpsMutation__
 *
 * To run a mutation, you first call `useSwapPumpsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSwapPumpsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [swapPumpsMutation, { data, loading, error }] = useSwapPumpsMutation({
 *   variables: {
 *      primaryPumpId: // value for 'primaryPumpId'
 *      secondaryPumpId: // value for 'secondaryPumpId'
 *   },
 * });
 */
export function useSwapPumpsMutation(
  baseOptions?: Apollo.MutationHookOptions<
    SwapPumpsMutation,
    SwapPumpsMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<SwapPumpsMutation, SwapPumpsMutationVariables>(
    SwapPumpsDocument,
    options,
  );
}
export type SwapPumpsMutationHookResult = ReturnType<
  typeof useSwapPumpsMutation
>;
export type SwapPumpsMutationResult = Apollo.MutationResult<SwapPumpsMutation>;
export type SwapPumpsMutationOptions = Apollo.BaseMutationOptions<
  SwapPumpsMutation,
  SwapPumpsMutationVariables
>;
export const ThermistorDetailUpdateDocument = gql`
  subscription ThermistorDetailUpdate($ids: [String!]!) {
    thermistorEventsByIds(_ids: $ids) {
      modelChangeOperation
      _id
      type
      typeDisplayName
      panelId
      name
      deviceId
      isConfigured
      timestamp
      role
      meta {
        name
        model
        modelNumber
        version
      }
      temperature {
        timestamp
        value
        units
      }
      panel {
        _id
        sourceId
        name
        role
        type
        alerts {
          _id
          type {
            id
            name
          }
          initiated
          updated
          panel {
            id
          }
          device {
            id
            name
            type
          }
          sourceId
          affectedSource {
            _id
            name
          }
        }
      }
      deviceAlerts {
        _id
        type {
          name
        }
        device {
          id
          name
          type
        }
        initiated
        updated
      }
      sourceAlerts {
        _id
        type {
          name
        }
        device {
          id
          name
          type
        }
        initiated
        updated
      }
    }
  }
`;

/**
 * __useThermistorDetailUpdateSubscription__
 *
 * To run a query within a React component, call `useThermistorDetailUpdateSubscription` and pass it any options that fit your needs.
 * When your component renders, `useThermistorDetailUpdateSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useThermistorDetailUpdateSubscription({
 *   variables: {
 *      ids: // value for 'ids'
 *   },
 * });
 */
export function useThermistorDetailUpdateSubscription(
  baseOptions: Apollo.SubscriptionHookOptions<
    ThermistorDetailUpdateSubscription,
    ThermistorDetailUpdateSubscriptionVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useSubscription<
    ThermistorDetailUpdateSubscription,
    ThermistorDetailUpdateSubscriptionVariables
  >(ThermistorDetailUpdateDocument, options);
}
export type ThermistorDetailUpdateSubscriptionHookResult = ReturnType<
  typeof useThermistorDetailUpdateSubscription
>;
export type ThermistorDetailUpdateSubscriptionResult =
  Apollo.SubscriptionResult<ThermistorDetailUpdateSubscription>;
export const ThermistorDetailDocument = gql`
  query ThermistorDetail($id: String!) {
    thermistorById(_id: $id) {
      _id
      type
      typeDisplayName
      panelId
      name
      deviceId
      isConfigured
      timestamp
      role
      meta {
        name
        model
        modelNumber
        version
      }
      panel {
        _id
        sourceId
        name
        displayName
        type
      }
      source {
        _id
        name
      }
      temperature {
        timestamp
        value
        units
      }
      panel {
        _id
        name
        role
        alerts {
          _id
          type {
            id
            name
          }
          initiated
          updated
          panel {
            id
          }
          device {
            id
            name
            type
          }
          sourceId
          affectedSource {
            _id
            name
          }
        }
      }
      deviceAlerts {
        _id
        type {
          name
        }
        device {
          id
          name
          type
        }
        initiated
        updated
      }
      sourceAlerts {
        _id
        type {
          name
        }
        device {
          id
          name
          type
        }
        initiated
        updated
      }
    }
  }
`;

/**
 * __useThermistorDetailQuery__
 *
 * To run a query within a React component, call `useThermistorDetailQuery` and pass it any options that fit your needs.
 * When your component renders, `useThermistorDetailQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useThermistorDetailQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useThermistorDetailQuery(
  baseOptions: Apollo.QueryHookOptions<
    ThermistorDetailQuery,
    ThermistorDetailQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<ThermistorDetailQuery, ThermistorDetailQueryVariables>(
    ThermistorDetailDocument,
    options,
  );
}
export function useThermistorDetailLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    ThermistorDetailQuery,
    ThermistorDetailQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    ThermistorDetailQuery,
    ThermistorDetailQueryVariables
  >(ThermistorDetailDocument, options);
}
export type ThermistorDetailQueryHookResult = ReturnType<
  typeof useThermistorDetailQuery
>;
export type ThermistorDetailLazyQueryHookResult = ReturnType<
  typeof useThermistorDetailLazyQuery
>;
export type ThermistorDetailQueryResult = Apollo.QueryResult<
  ThermistorDetailQuery,
  ThermistorDetailQueryVariables
>;
export const ThermistorPairDetailDocument = gql`
  query ThermistorPairDetail($ids: [String!]!) {
    thermistorsByIds(_ids: $ids) {
      _id
      type
      typeDisplayName
      panelId
      name
      deviceId
      temperature {
        timestamp
        value
        units
      }
    }
  }
`;

/**
 * __useThermistorPairDetailQuery__
 *
 * To run a query within a React component, call `useThermistorPairDetailQuery` and pass it any options that fit your needs.
 * When your component renders, `useThermistorPairDetailQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useThermistorPairDetailQuery({
 *   variables: {
 *      ids: // value for 'ids'
 *   },
 * });
 */
export function useThermistorPairDetailQuery(
  baseOptions: Apollo.QueryHookOptions<
    ThermistorPairDetailQuery,
    ThermistorPairDetailQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    ThermistorPairDetailQuery,
    ThermistorPairDetailQueryVariables
  >(ThermistorPairDetailDocument, options);
}
export function useThermistorPairDetailLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    ThermistorPairDetailQuery,
    ThermistorPairDetailQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    ThermistorPairDetailQuery,
    ThermistorPairDetailQueryVariables
  >(ThermistorPairDetailDocument, options);
}
export type ThermistorPairDetailQueryHookResult = ReturnType<
  typeof useThermistorPairDetailQuery
>;
export type ThermistorPairDetailLazyQueryHookResult = ReturnType<
  typeof useThermistorPairDetailLazyQuery
>;
export type ThermistorPairDetailQueryResult = Apollo.QueryResult<
  ThermistorPairDetailQuery,
  ThermistorPairDetailQueryVariables
>;
export const UpdateActuatorPositionDocument = gql`
  mutation UpdateActuatorPosition(
    $deviceId: String!
    $position: Float
    $controlMode: String
  ) {
    updateActuatorPosition(
      deviceId: $deviceId
      updates: { position: $position, controlMode: $controlMode }
    ) {
      _id
      position {
        value
        timestamp
      }
      controlMode {
        value
        timestamp
      }
      hasPendingUpdates
    }
  }
`;
export type UpdateActuatorPositionMutationFn = Apollo.MutationFunction<
  UpdateActuatorPositionMutation,
  UpdateActuatorPositionMutationVariables
>;

/**
 * __useUpdateActuatorPositionMutation__
 *
 * To run a mutation, you first call `useUpdateActuatorPositionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateActuatorPositionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateActuatorPositionMutation, { data, loading, error }] = useUpdateActuatorPositionMutation({
 *   variables: {
 *      deviceId: // value for 'deviceId'
 *      position: // value for 'position'
 *      controlMode: // value for 'controlMode'
 *   },
 * });
 */
export function useUpdateActuatorPositionMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UpdateActuatorPositionMutation,
    UpdateActuatorPositionMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    UpdateActuatorPositionMutation,
    UpdateActuatorPositionMutationVariables
  >(UpdateActuatorPositionDocument, options);
}
export type UpdateActuatorPositionMutationHookResult = ReturnType<
  typeof useUpdateActuatorPositionMutation
>;
export type UpdateActuatorPositionMutationResult =
  Apollo.MutationResult<UpdateActuatorPositionMutation>;
export type UpdateActuatorPositionMutationOptions = Apollo.BaseMutationOptions<
  UpdateActuatorPositionMutation,
  UpdateActuatorPositionMutationVariables
>;
export const UpdatePumpStateDocument = gql`
  mutation UpdatePumpState($id: String!, $stopOrStart: Int!) {
    updateVSDPumpOnOffState(
      deviceId: $id
      updates: { stopOrStart: $stopOrStart }
    ) {
      _id
      stopOrStart {
        value
      }
      hasPendingUpdates
    }
  }
`;
export type UpdatePumpStateMutationFn = Apollo.MutationFunction<
  UpdatePumpStateMutation,
  UpdatePumpStateMutationVariables
>;

/**
 * __useUpdatePumpStateMutation__
 *
 * To run a mutation, you first call `useUpdatePumpStateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdatePumpStateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updatePumpStateMutation, { data, loading, error }] = useUpdatePumpStateMutation({
 *   variables: {
 *      id: // value for 'id'
 *      stopOrStart: // value for 'stopOrStart'
 *   },
 * });
 */
export function useUpdatePumpStateMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UpdatePumpStateMutation,
    UpdatePumpStateMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    UpdatePumpStateMutation,
    UpdatePumpStateMutationVariables
  >(UpdatePumpStateDocument, options);
}
export type UpdatePumpStateMutationHookResult = ReturnType<
  typeof useUpdatePumpStateMutation
>;
export type UpdatePumpStateMutationResult =
  Apollo.MutationResult<UpdatePumpStateMutation>;
export type UpdatePumpStateMutationOptions = Apollo.BaseMutationOptions<
  UpdatePumpStateMutation,
  UpdatePumpStateMutationVariables
>;
export const VsdPumpDetailUpdateDocument = gql`
  subscription VsdPumpDetailUpdate($ids: [String!]!) {
    vSDPumpEventsByIds(_ids: $ids) {
      modelChangeOperation
      _id
      type
      typeDisplayName
      panelId
      name
      deviceId
      role
      timestamp
      hasPendingUpdates
      alertTypes {
        deviceOffline
        sourceOffline
      }
      panel {
        _id
        sourceId
        name
      }
      isConfigured
      isPoweredOn
      powerState {
        timestamp
        units
        value
      }
      meta {
        name
        model
        modelNumber
        version
      }
      supplyTemperature {
        id
        timestamp
        value
        units
      }
      returnTemperature {
        id
        timestamp
        value
        units
      }
      currentSpeed {
        id
        timestamp
        value
        units
      }
      driveOutputPower {
        id
        timestamp
        value
        units
      }
      driveOutputEnergy {
        id
        timestamp
        value
        units
      }
      driveMode {
        id
        timestamp
        value
        units
      }
      stopOrStart {
        id
        timestamp
        value
        units
      }
      targetSpeed {
        id
        timestamp
        value
        units
      }
      deviceAlerts {
        _id
        type {
          name
        }
        device {
          id
          name
          type
        }
        initiated
        updated
      }
      sourceAlerts {
        _id
        type {
          name
        }
        device {
          id
          name
          type
        }
        initiated
        updated
      }
    }
  }
`;

/**
 * __useVsdPumpDetailUpdateSubscription__
 *
 * To run a query within a React component, call `useVsdPumpDetailUpdateSubscription` and pass it any options that fit your needs.
 * When your component renders, `useVsdPumpDetailUpdateSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useVsdPumpDetailUpdateSubscription({
 *   variables: {
 *      ids: // value for 'ids'
 *   },
 * });
 */
export function useVsdPumpDetailUpdateSubscription(
  baseOptions: Apollo.SubscriptionHookOptions<
    VsdPumpDetailUpdateSubscription,
    VsdPumpDetailUpdateSubscriptionVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useSubscription<
    VsdPumpDetailUpdateSubscription,
    VsdPumpDetailUpdateSubscriptionVariables
  >(VsdPumpDetailUpdateDocument, options);
}
export type VsdPumpDetailUpdateSubscriptionHookResult = ReturnType<
  typeof useVsdPumpDetailUpdateSubscription
>;
export type VsdPumpDetailUpdateSubscriptionResult =
  Apollo.SubscriptionResult<VsdPumpDetailUpdateSubscription>;
export const VsdPumpDetailDocument = gql`
  query VsdPumpDetail($id: String!) {
    vSDPumpById(_id: $id) {
      _id
      type
      typeDisplayName
      panelId
      name
      deviceId
      hasCurrentSpeed
      hasDriveOutputEnergy
      hasDriveOutputPower
      hasTargetSpeed
      hasPendingUpdates
      alertTypes {
        deviceOffline
        sourceOffline
      }
      panel {
        _id
        sourceId
        name
      }
      source {
        _id
        name
      }
      role
      timestamp
      isConfigured
      isPoweredOn
      powerState {
        timestamp
        units
        value
      }
      meta {
        name
        model
        modelNumber
        version
      }
      supplyTemperature {
        id
        timestamp
        value
        units
      }
      returnTemperature {
        id
        timestamp
        value
        units
      }
      currentSpeed {
        id
        timestamp
        value
        units
      }
      driveOutputPower {
        id
        timestamp
        value
        units
      }
      driveOutputEnergy {
        id
        timestamp
        value
        units
      }
      driveMode {
        id
        timestamp
        value
        units
      }
      stopOrStart {
        id
        timestamp
        value
        units
      }
      targetSpeed {
        id
        timestamp
        value
        units
      }
      deviceAlerts {
        _id
        type {
          name
        }
        device {
          id
          name
          type
        }
        initiated
        updated
      }
      sourceAlerts {
        _id
        type {
          name
        }
        device {
          id
          name
          type
        }
        initiated
        updated
      }
    }
  }
`;

/**
 * __useVsdPumpDetailQuery__
 *
 * To run a query within a React component, call `useVsdPumpDetailQuery` and pass it any options that fit your needs.
 * When your component renders, `useVsdPumpDetailQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useVsdPumpDetailQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useVsdPumpDetailQuery(
  baseOptions: Apollo.QueryHookOptions<
    VsdPumpDetailQuery,
    VsdPumpDetailQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<VsdPumpDetailQuery, VsdPumpDetailQueryVariables>(
    VsdPumpDetailDocument,
    options,
  );
}
export function useVsdPumpDetailLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    VsdPumpDetailQuery,
    VsdPumpDetailQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<VsdPumpDetailQuery, VsdPumpDetailQueryVariables>(
    VsdPumpDetailDocument,
    options,
  );
}
export type VsdPumpDetailQueryHookResult = ReturnType<
  typeof useVsdPumpDetailQuery
>;
export type VsdPumpDetailLazyQueryHookResult = ReturnType<
  typeof useVsdPumpDetailLazyQuery
>;
export type VsdPumpDetailQueryResult = Apollo.QueryResult<
  VsdPumpDetailQuery,
  VsdPumpDetailQueryVariables
>;
export const Z210PumpDetailUpdateDocument = gql`
  subscription Z210PumpDetailUpdate($ids: [String!]!) {
    z210PumpEventsByIds(_ids: $ids) {
      modelChangeOperation
      _id
      type
      typeDisplayName
      panelId
      name
      role
      deviceId
      isConfigured
      hasPendingUpdates
      timestamp
      meta {
        name
        model
        modelNumber
        version
      }
      panel {
        _id
        sourceId
        name
      }
      displayName
      hasAutoSwitchoverPeriod
      hasOverride
      hasActivePump
      hasCurrentSpeed
      hasTargetSpeed
      activePump {
        id
        previousId
        timestamp
        value
        units
      }
      currentSpeed {
        timestamp
        value
        units
      }
      targetSpeed {
        timestamp
        value
        units
      }
      deviceAlerts {
        _id
        type {
          name
        }
        device {
          id
          name
          type
        }
        initiated
        updated
      }
      sourceAlerts {
        _id
        type {
          name
        }
        device {
          id
          name
          type
        }
        initiated
        updated
      }
    }
  }
`;

/**
 * __useZ210PumpDetailUpdateSubscription__
 *
 * To run a query within a React component, call `useZ210PumpDetailUpdateSubscription` and pass it any options that fit your needs.
 * When your component renders, `useZ210PumpDetailUpdateSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useZ210PumpDetailUpdateSubscription({
 *   variables: {
 *      ids: // value for 'ids'
 *   },
 * });
 */
export function useZ210PumpDetailUpdateSubscription(
  baseOptions: Apollo.SubscriptionHookOptions<
    Z210PumpDetailUpdateSubscription,
    Z210PumpDetailUpdateSubscriptionVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useSubscription<
    Z210PumpDetailUpdateSubscription,
    Z210PumpDetailUpdateSubscriptionVariables
  >(Z210PumpDetailUpdateDocument, options);
}
export type Z210PumpDetailUpdateSubscriptionHookResult = ReturnType<
  typeof useZ210PumpDetailUpdateSubscription
>;
export type Z210PumpDetailUpdateSubscriptionResult =
  Apollo.SubscriptionResult<Z210PumpDetailUpdateSubscription>;
export const Z210PumpDetailDocument = gql`
  query Z210PumpDetail($id: String!) {
    z210PumpById(_id: $id) {
      _id
      type
      typeDisplayName
      panelId
      name
      role
      deviceId
      isConfigured
      hasPendingUpdates
      timestamp
      meta {
        name
        model
        modelNumber
        version
      }
      panel {
        _id
        sourceId
        name
      }
      source {
        _id
        name
      }
      displayName
      hasAutoSwitchoverPeriod
      hasOverride
      hasActivePump
      hasCurrentSpeed
      hasTargetSpeed
      activePump {
        id
        previousId
        timestamp
        value
        units
      }
      currentSpeed {
        timestamp
        value
        units
      }
      targetSpeed {
        timestamp
        value
        units
      }
      deviceAlerts {
        _id
        type {
          name
        }
        device {
          id
          name
          type
        }
        initiated
        updated
      }
      sourceAlerts {
        _id
        type {
          name
        }
        device {
          id
          name
          type
        }
        initiated
        updated
      }
    }
  }
`;

/**
 * __useZ210PumpDetailQuery__
 *
 * To run a query within a React component, call `useZ210PumpDetailQuery` and pass it any options that fit your needs.
 * When your component renders, `useZ210PumpDetailQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useZ210PumpDetailQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useZ210PumpDetailQuery(
  baseOptions: Apollo.QueryHookOptions<
    Z210PumpDetailQuery,
    Z210PumpDetailQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<Z210PumpDetailQuery, Z210PumpDetailQueryVariables>(
    Z210PumpDetailDocument,
    options,
  );
}
export function useZ210PumpDetailLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    Z210PumpDetailQuery,
    Z210PumpDetailQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<Z210PumpDetailQuery, Z210PumpDetailQueryVariables>(
    Z210PumpDetailDocument,
    options,
  );
}
export type Z210PumpDetailQueryHookResult = ReturnType<
  typeof useZ210PumpDetailQuery
>;
export type Z210PumpDetailLazyQueryHookResult = ReturnType<
  typeof useZ210PumpDetailLazyQuery
>;
export type Z210PumpDetailQueryResult = Apollo.QueryResult<
  Z210PumpDetailQuery,
  Z210PumpDetailQueryVariables
>;
export const AlertsListDocument = gql`
  query AlertsList {
    alerts(limit: 0) {
      _id
      severity
      property {
        name
        id
      }
      unit {
        name
        id
      }
      initiated
      type {
        name
      }
      device {
        type
        name
        id
      }
    }
  }
`;

/**
 * __useAlertsListQuery__
 *
 * To run a query within a React component, call `useAlertsListQuery` and pass it any options that fit your needs.
 * When your component renders, `useAlertsListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAlertsListQuery({
 *   variables: {
 *   },
 * });
 */
export function useAlertsListQuery(
  baseOptions?: Apollo.QueryHookOptions<
    AlertsListQuery,
    AlertsListQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<AlertsListQuery, AlertsListQueryVariables>(
    AlertsListDocument,
    options,
  );
}
export function useAlertsListLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    AlertsListQuery,
    AlertsListQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<AlertsListQuery, AlertsListQueryVariables>(
    AlertsListDocument,
    options,
  );
}
export type AlertsListQueryHookResult = ReturnType<typeof useAlertsListQuery>;
export type AlertsListLazyQueryHookResult = ReturnType<
  typeof useAlertsListLazyQuery
>;
export type AlertsListQueryResult = Apollo.QueryResult<
  AlertsListQuery,
  AlertsListQueryVariables
>;
export const AlertsListUpdateDocument = gql`
  subscription AlertsListUpdate($propertyId: [String!]) {
    alertsByPropertyIdEvents(filter: { propertyIds: $propertyId }) {
      modelChangeOperation
      _id
      severity
      property {
        name
        id
      }
      unit {
        name
        id
      }
      initiated
      type {
        name
      }
      device {
        type
        name
        id
      }
    }
  }
`;

/**
 * __useAlertsListUpdateSubscription__
 *
 * To run a query within a React component, call `useAlertsListUpdateSubscription` and pass it any options that fit your needs.
 * When your component renders, `useAlertsListUpdateSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAlertsListUpdateSubscription({
 *   variables: {
 *      propertyId: // value for 'propertyId'
 *   },
 * });
 */
export function useAlertsListUpdateSubscription(
  baseOptions?: Apollo.SubscriptionHookOptions<
    AlertsListUpdateSubscription,
    AlertsListUpdateSubscriptionVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useSubscription<
    AlertsListUpdateSubscription,
    AlertsListUpdateSubscriptionVariables
  >(AlertsListUpdateDocument, options);
}
export type AlertsListUpdateSubscriptionHookResult = ReturnType<
  typeof useAlertsListUpdateSubscription
>;
export type AlertsListUpdateSubscriptionResult =
  Apollo.SubscriptionResult<AlertsListUpdateSubscription>;
export const AuthorizationOptionsDocument = gql`
  query AuthorizationOptions {
    properties(sort: TITLE_ASC) {
      _id
      title
      units(sort: NAME_ASC) {
        _id
        name
        type
        devices {
          _id
          name
          type
        }
      }
    }
  }
`;

/**
 * __useAuthorizationOptionsQuery__
 *
 * To run a query within a React component, call `useAuthorizationOptionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAuthorizationOptionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAuthorizationOptionsQuery({
 *   variables: {
 *   },
 * });
 */
export function useAuthorizationOptionsQuery(
  baseOptions?: Apollo.QueryHookOptions<
    AuthorizationOptionsQuery,
    AuthorizationOptionsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    AuthorizationOptionsQuery,
    AuthorizationOptionsQueryVariables
  >(AuthorizationOptionsDocument, options);
}
export function useAuthorizationOptionsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    AuthorizationOptionsQuery,
    AuthorizationOptionsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    AuthorizationOptionsQuery,
    AuthorizationOptionsQueryVariables
  >(AuthorizationOptionsDocument, options);
}
export type AuthorizationOptionsQueryHookResult = ReturnType<
  typeof useAuthorizationOptionsQuery
>;
export type AuthorizationOptionsLazyQueryHookResult = ReturnType<
  typeof useAuthorizationOptionsLazyQuery
>;
export type AuthorizationOptionsQueryResult = Apollo.QueryResult<
  AuthorizationOptionsQuery,
  AuthorizationOptionsQueryVariables
>;
export const BoilerListUpdateDocument = gql`
  subscription BoilerListUpdate {
    boilerEvents {
      _id
      modelChangeOperation
      name
      meta {
        name
      }
    }
  }
`;

/**
 * __useBoilerListUpdateSubscription__
 *
 * To run a query within a React component, call `useBoilerListUpdateSubscription` and pass it any options that fit your needs.
 * When your component renders, `useBoilerListUpdateSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBoilerListUpdateSubscription({
 *   variables: {
 *   },
 * });
 */
export function useBoilerListUpdateSubscription(
  baseOptions?: Apollo.SubscriptionHookOptions<
    BoilerListUpdateSubscription,
    BoilerListUpdateSubscriptionVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useSubscription<
    BoilerListUpdateSubscription,
    BoilerListUpdateSubscriptionVariables
  >(BoilerListUpdateDocument, options);
}
export type BoilerListUpdateSubscriptionHookResult = ReturnType<
  typeof useBoilerListUpdateSubscription
>;
export type BoilerListUpdateSubscriptionResult =
  Apollo.SubscriptionResult<BoilerListUpdateSubscription>;
export const BoilersDocument = gql`
  query boilers {
    boilers(limit: 0) {
      _id
      name
      meta {
        name
      }
    }
  }
`;

/**
 * __useBoilersQuery__
 *
 * To run a query within a React component, call `useBoilersQuery` and pass it any options that fit your needs.
 * When your component renders, `useBoilersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBoilersQuery({
 *   variables: {
 *   },
 * });
 */
export function useBoilersQuery(
  baseOptions?: Apollo.QueryHookOptions<BoilersQuery, BoilersQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<BoilersQuery, BoilersQueryVariables>(
    BoilersDocument,
    options,
  );
}
export function useBoilersLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    BoilersQuery,
    BoilersQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<BoilersQuery, BoilersQueryVariables>(
    BoilersDocument,
    options,
  );
}
export type BoilersQueryHookResult = ReturnType<typeof useBoilersQuery>;
export type BoilersLazyQueryHookResult = ReturnType<typeof useBoilersLazyQuery>;
export type BoilersQueryResult = Apollo.QueryResult<
  BoilersQuery,
  BoilersQueryVariables
>;
export const PropertiesDocument = gql`
  query properties {
    properties(sort: TITLE_ASC, limit: 0) {
      _id
      title
      address {
        line1
        city
        state
        postalCode
      }
      owner {
        name
      }
      propMgr {
        name
        mobile
      }
      imageUrl
      units(limit: 0) {
        name
        _id
        type
        alertTypes {
          sourceOffline
          deviceOffline
        }
      }
    }
  }
`;

/**
 * __usePropertiesQuery__
 *
 * To run a query within a React component, call `usePropertiesQuery` and pass it any options that fit your needs.
 * When your component renders, `usePropertiesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePropertiesQuery({
 *   variables: {
 *   },
 * });
 */
export function usePropertiesQuery(
  baseOptions?: Apollo.QueryHookOptions<
    PropertiesQuery,
    PropertiesQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<PropertiesQuery, PropertiesQueryVariables>(
    PropertiesDocument,
    options,
  );
}
export function usePropertiesLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    PropertiesQuery,
    PropertiesQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<PropertiesQuery, PropertiesQueryVariables>(
    PropertiesDocument,
    options,
  );
}
export type PropertiesQueryHookResult = ReturnType<typeof usePropertiesQuery>;
export type PropertiesLazyQueryHookResult = ReturnType<
  typeof usePropertiesLazyQuery
>;
export type PropertiesQueryResult = Apollo.QueryResult<
  PropertiesQuery,
  PropertiesQueryVariables
>;
export const PropertyAlertSubscriptionUpdatesDocument = gql`
  subscription PropertyAlertSubscriptionUpdates {
    alertSubscriptionEvents {
      modelChangeOperation
      _id
      alertTriggerId
      propertyId
      unitId
      unitCategoryId
      deviceId
      viaEmail
      viaSms
    }
  }
`;

/**
 * __usePropertyAlertSubscriptionUpdatesSubscription__
 *
 * To run a query within a React component, call `usePropertyAlertSubscriptionUpdatesSubscription` and pass it any options that fit your needs.
 * When your component renders, `usePropertyAlertSubscriptionUpdatesSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePropertyAlertSubscriptionUpdatesSubscription({
 *   variables: {
 *   },
 * });
 */
export function usePropertyAlertSubscriptionUpdatesSubscription(
  baseOptions?: Apollo.SubscriptionHookOptions<
    PropertyAlertSubscriptionUpdatesSubscription,
    PropertyAlertSubscriptionUpdatesSubscriptionVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useSubscription<
    PropertyAlertSubscriptionUpdatesSubscription,
    PropertyAlertSubscriptionUpdatesSubscriptionVariables
  >(PropertyAlertSubscriptionUpdatesDocument, options);
}
export type PropertyAlertSubscriptionUpdatesSubscriptionHookResult = ReturnType<
  typeof usePropertyAlertSubscriptionUpdatesSubscription
>;
export type PropertyAlertSubscriptionUpdatesSubscriptionResult =
  Apollo.SubscriptionResult<PropertyAlertSubscriptionUpdatesSubscription>;
export const PropertyAlertsDocument = gql`
  query PropertyAlerts($propertyId: String!) {
    alerts(filter: { property: { id: $propertyId } }, limit: 0) {
      _id
      severity
      property {
        name
        id
      }
      unit {
        name
        id
      }
      initiated
      type {
        name
      }
      device {
        type
        name
        id
      }
    }
  }
`;

/**
 * __usePropertyAlertsQuery__
 *
 * To run a query within a React component, call `usePropertyAlertsQuery` and pass it any options that fit your needs.
 * When your component renders, `usePropertyAlertsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePropertyAlertsQuery({
 *   variables: {
 *      propertyId: // value for 'propertyId'
 *   },
 * });
 */
export function usePropertyAlertsQuery(
  baseOptions: Apollo.QueryHookOptions<
    PropertyAlertsQuery,
    PropertyAlertsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<PropertyAlertsQuery, PropertyAlertsQueryVariables>(
    PropertyAlertsDocument,
    options,
  );
}
export function usePropertyAlertsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    PropertyAlertsQuery,
    PropertyAlertsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<PropertyAlertsQuery, PropertyAlertsQueryVariables>(
    PropertyAlertsDocument,
    options,
  );
}
export type PropertyAlertsQueryHookResult = ReturnType<
  typeof usePropertyAlertsQuery
>;
export type PropertyAlertsLazyQueryHookResult = ReturnType<
  typeof usePropertyAlertsLazyQuery
>;
export type PropertyAlertsQueryResult = Apollo.QueryResult<
  PropertyAlertsQuery,
  PropertyAlertsQueryVariables
>;
export const PropertyListUpdateDocument = gql`
  subscription PropertyListUpdate($_ids: [String]) {
    propertyEventsByIds(_ids: $_ids) {
      _id
      title
      modelChangeOperation
    }
  }
`;

/**
 * __usePropertyListUpdateSubscription__
 *
 * To run a query within a React component, call `usePropertyListUpdateSubscription` and pass it any options that fit your needs.
 * When your component renders, `usePropertyListUpdateSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePropertyListUpdateSubscription({
 *   variables: {
 *      _ids: // value for '_ids'
 *   },
 * });
 */
export function usePropertyListUpdateSubscription(
  baseOptions?: Apollo.SubscriptionHookOptions<
    PropertyListUpdateSubscription,
    PropertyListUpdateSubscriptionVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useSubscription<
    PropertyListUpdateSubscription,
    PropertyListUpdateSubscriptionVariables
  >(PropertyListUpdateDocument, options);
}
export type PropertyListUpdateSubscriptionHookResult = ReturnType<
  typeof usePropertyListUpdateSubscription
>;
export type PropertyListUpdateSubscriptionResult =
  Apollo.SubscriptionResult<PropertyListUpdateSubscription>;
export const SourceListDocument = gql`
  query SourceList {
    sources(limit: 0) {
      _id
      name
      type
      url
      timestamp
      ... on BNG {
        localUrl
      }
      inUse
    }
  }
`;

/**
 * __useSourceListQuery__
 *
 * To run a query within a React component, call `useSourceListQuery` and pass it any options that fit your needs.
 * When your component renders, `useSourceListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSourceListQuery({
 *   variables: {
 *   },
 * });
 */
export function useSourceListQuery(
  baseOptions?: Apollo.QueryHookOptions<
    SourceListQuery,
    SourceListQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<SourceListQuery, SourceListQueryVariables>(
    SourceListDocument,
    options,
  );
}
export function useSourceListLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    SourceListQuery,
    SourceListQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<SourceListQuery, SourceListQueryVariables>(
    SourceListDocument,
    options,
  );
}
export type SourceListQueryHookResult = ReturnType<typeof useSourceListQuery>;
export type SourceListLazyQueryHookResult = ReturnType<
  typeof useSourceListLazyQuery
>;
export type SourceListQueryResult = Apollo.QueryResult<
  SourceListQuery,
  SourceListQueryVariables
>;
export const SourceListBngUpdateDocument = gql`
  subscription SourceListBngUpdate {
    bNGEvents {
      modelChangeOperation
      _id
      localUrl
    }
  }
`;

/**
 * __useSourceListBngUpdateSubscription__
 *
 * To run a query within a React component, call `useSourceListBngUpdateSubscription` and pass it any options that fit your needs.
 * When your component renders, `useSourceListBngUpdateSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSourceListBngUpdateSubscription({
 *   variables: {
 *   },
 * });
 */
export function useSourceListBngUpdateSubscription(
  baseOptions?: Apollo.SubscriptionHookOptions<
    SourceListBngUpdateSubscription,
    SourceListBngUpdateSubscriptionVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useSubscription<
    SourceListBngUpdateSubscription,
    SourceListBngUpdateSubscriptionVariables
  >(SourceListBngUpdateDocument, options);
}
export type SourceListBngUpdateSubscriptionHookResult = ReturnType<
  typeof useSourceListBngUpdateSubscription
>;
export type SourceListBngUpdateSubscriptionResult =
  Apollo.SubscriptionResult<SourceListBngUpdateSubscription>;
export const SourceListUpdateDocument = gql`
  subscription SourceListUpdate {
    sourceEvents {
      modelChangeOperation
      _id
      name
      type
      url
      timestamp
      inUse
    }
  }
`;

/**
 * __useSourceListUpdateSubscription__
 *
 * To run a query within a React component, call `useSourceListUpdateSubscription` and pass it any options that fit your needs.
 * When your component renders, `useSourceListUpdateSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSourceListUpdateSubscription({
 *   variables: {
 *   },
 * });
 */
export function useSourceListUpdateSubscription(
  baseOptions?: Apollo.SubscriptionHookOptions<
    SourceListUpdateSubscription,
    SourceListUpdateSubscriptionVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useSubscription<
    SourceListUpdateSubscription,
    SourceListUpdateSubscriptionVariables
  >(SourceListUpdateDocument, options);
}
export type SourceListUpdateSubscriptionHookResult = ReturnType<
  typeof useSourceListUpdateSubscription
>;
export type SourceListUpdateSubscriptionResult =
  Apollo.SubscriptionResult<SourceListUpdateSubscription>;
export const EntitySubscriberUpdatesDocument = gql`
  subscription EntitySubscriberUpdates {
    entitySubscribersUpdated
  }
`;

/**
 * __useEntitySubscriberUpdatesSubscription__
 *
 * To run a query within a React component, call `useEntitySubscriberUpdatesSubscription` and pass it any options that fit your needs.
 * When your component renders, `useEntitySubscriberUpdatesSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEntitySubscriberUpdatesSubscription({
 *   variables: {
 *   },
 * });
 */
export function useEntitySubscriberUpdatesSubscription(
  baseOptions?: Apollo.SubscriptionHookOptions<
    EntitySubscriberUpdatesSubscription,
    EntitySubscriberUpdatesSubscriptionVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useSubscription<
    EntitySubscriberUpdatesSubscription,
    EntitySubscriberUpdatesSubscriptionVariables
  >(EntitySubscriberUpdatesDocument, options);
}
export type EntitySubscriberUpdatesSubscriptionHookResult = ReturnType<
  typeof useEntitySubscriberUpdatesSubscription
>;
export type EntitySubscriberUpdatesSubscriptionResult =
  Apollo.SubscriptionResult<EntitySubscriberUpdatesSubscription>;
export const EntitySubscribersDocument = gql`
  query EntitySubscribers {
    entitySubscribers
  }
`;

/**
 * __useEntitySubscribersQuery__
 *
 * To run a query within a React component, call `useEntitySubscribersQuery` and pass it any options that fit your needs.
 * When your component renders, `useEntitySubscribersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEntitySubscribersQuery({
 *   variables: {
 *   },
 * });
 */
export function useEntitySubscribersQuery(
  baseOptions?: Apollo.QueryHookOptions<
    EntitySubscribersQuery,
    EntitySubscribersQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    EntitySubscribersQuery,
    EntitySubscribersQueryVariables
  >(EntitySubscribersDocument, options);
}
export function useEntitySubscribersLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    EntitySubscribersQuery,
    EntitySubscribersQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    EntitySubscribersQuery,
    EntitySubscribersQueryVariables
  >(EntitySubscribersDocument, options);
}
export type EntitySubscribersQueryHookResult = ReturnType<
  typeof useEntitySubscribersQuery
>;
export type EntitySubscribersLazyQueryHookResult = ReturnType<
  typeof useEntitySubscribersLazyQuery
>;
export type EntitySubscribersQueryResult = Apollo.QueryResult<
  EntitySubscribersQuery,
  EntitySubscribersQueryVariables
>;
export const ResetEntitySubscribersDocument = gql`
  mutation ResetEntitySubscribers {
    resetEntitySubscribers
  }
`;
export type ResetEntitySubscribersMutationFn = Apollo.MutationFunction<
  ResetEntitySubscribersMutation,
  ResetEntitySubscribersMutationVariables
>;

/**
 * __useResetEntitySubscribersMutation__
 *
 * To run a mutation, you first call `useResetEntitySubscribersMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useResetEntitySubscribersMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [resetEntitySubscribersMutation, { data, loading, error }] = useResetEntitySubscribersMutation({
 *   variables: {
 *   },
 * });
 */
export function useResetEntitySubscribersMutation(
  baseOptions?: Apollo.MutationHookOptions<
    ResetEntitySubscribersMutation,
    ResetEntitySubscribersMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    ResetEntitySubscribersMutation,
    ResetEntitySubscribersMutationVariables
  >(ResetEntitySubscribersDocument, options);
}
export type ResetEntitySubscribersMutationHookResult = ReturnType<
  typeof useResetEntitySubscribersMutation
>;
export type ResetEntitySubscribersMutationResult =
  Apollo.MutationResult<ResetEntitySubscribersMutation>;
export type ResetEntitySubscribersMutationOptions = Apollo.BaseMutationOptions<
  ResetEntitySubscribersMutation,
  ResetEntitySubscribersMutationVariables
>;
export const TestBoilersDocument = gql`
  query TestBoilers {
    boilers(limit: 0) {
      _id
      name
      meta {
        name
      }
    }
  }
`;

/**
 * __useTestBoilersQuery__
 *
 * To run a query within a React component, call `useTestBoilersQuery` and pass it any options that fit your needs.
 * When your component renders, `useTestBoilersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTestBoilersQuery({
 *   variables: {
 *   },
 * });
 */
export function useTestBoilersQuery(
  baseOptions?: Apollo.QueryHookOptions<
    TestBoilersQuery,
    TestBoilersQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<TestBoilersQuery, TestBoilersQueryVariables>(
    TestBoilersDocument,
    options,
  );
}
export function useTestBoilersLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    TestBoilersQuery,
    TestBoilersQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<TestBoilersQuery, TestBoilersQueryVariables>(
    TestBoilersDocument,
    options,
  );
}
export type TestBoilersQueryHookResult = ReturnType<typeof useTestBoilersQuery>;
export type TestBoilersLazyQueryHookResult = ReturnType<
  typeof useTestBoilersLazyQuery
>;
export type TestBoilersQueryResult = Apollo.QueryResult<
  TestBoilersQuery,
  TestBoilersQueryVariables
>;
export const TestBoilerListUpdateDocument = gql`
  subscription TestBoilerListUpdate {
    boilerEvents {
      _id
      modelChangeOperation
      name
      meta {
        name
      }
    }
  }
`;

/**
 * __useTestBoilerListUpdateSubscription__
 *
 * To run a query within a React component, call `useTestBoilerListUpdateSubscription` and pass it any options that fit your needs.
 * When your component renders, `useTestBoilerListUpdateSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTestBoilerListUpdateSubscription({
 *   variables: {
 *   },
 * });
 */
export function useTestBoilerListUpdateSubscription(
  baseOptions?: Apollo.SubscriptionHookOptions<
    TestBoilerListUpdateSubscription,
    TestBoilerListUpdateSubscriptionVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useSubscription<
    TestBoilerListUpdateSubscription,
    TestBoilerListUpdateSubscriptionVariables
  >(TestBoilerListUpdateDocument, options);
}
export type TestBoilerListUpdateSubscriptionHookResult = ReturnType<
  typeof useTestBoilerListUpdateSubscription
>;
export type TestBoilerListUpdateSubscriptionResult =
  Apollo.SubscriptionResult<TestBoilerListUpdateSubscription>;
export const TestPropertyListUpdateDocument = gql`
  subscription TestPropertyListUpdate($_ids: [String]) {
    propertyEventsByIds(_ids: $_ids) {
      modelChangeOperation
      _id
      title
    }
  }
`;

/**
 * __useTestPropertyListUpdateSubscription__
 *
 * To run a query within a React component, call `useTestPropertyListUpdateSubscription` and pass it any options that fit your needs.
 * When your component renders, `useTestPropertyListUpdateSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTestPropertyListUpdateSubscription({
 *   variables: {
 *      _ids: // value for '_ids'
 *   },
 * });
 */
export function useTestPropertyListUpdateSubscription(
  baseOptions?: Apollo.SubscriptionHookOptions<
    TestPropertyListUpdateSubscription,
    TestPropertyListUpdateSubscriptionVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useSubscription<
    TestPropertyListUpdateSubscription,
    TestPropertyListUpdateSubscriptionVariables
  >(TestPropertyListUpdateDocument, options);
}
export type TestPropertyListUpdateSubscriptionHookResult = ReturnType<
  typeof useTestPropertyListUpdateSubscription
>;
export type TestPropertyListUpdateSubscriptionResult =
  Apollo.SubscriptionResult<TestPropertyListUpdateSubscription>;
export const ControlGroupRefreshDocument = gql`
  query ControlGroupRefresh($controlGroupId: String!) {
    controlGroupById(_id: $controlGroupId) {
      _id
      name
      propertyId
      unitId
      type
      automationEnabled
      masterDeviceId
      masterDevice {
        _id
        deviceId
        name
        type
      }
      attributes
      groupedDevices {
        _id
        deviceId
        name
        type
        displayOrder
      }
      devices {
        _id
        deviceId
        type
      }
      deviceDetails
    }
  }
`;

/**
 * __useControlGroupRefreshQuery__
 *
 * To run a query within a React component, call `useControlGroupRefreshQuery` and pass it any options that fit your needs.
 * When your component renders, `useControlGroupRefreshQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useControlGroupRefreshQuery({
 *   variables: {
 *      controlGroupId: // value for 'controlGroupId'
 *   },
 * });
 */
export function useControlGroupRefreshQuery(
  baseOptions: Apollo.QueryHookOptions<
    ControlGroupRefreshQuery,
    ControlGroupRefreshQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    ControlGroupRefreshQuery,
    ControlGroupRefreshQueryVariables
  >(ControlGroupRefreshDocument, options);
}
export function useControlGroupRefreshLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    ControlGroupRefreshQuery,
    ControlGroupRefreshQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    ControlGroupRefreshQuery,
    ControlGroupRefreshQueryVariables
  >(ControlGroupRefreshDocument, options);
}
export type ControlGroupRefreshQueryHookResult = ReturnType<
  typeof useControlGroupRefreshQuery
>;
export type ControlGroupRefreshLazyQueryHookResult = ReturnType<
  typeof useControlGroupRefreshLazyQuery
>;
export type ControlGroupRefreshQueryResult = Apollo.QueryResult<
  ControlGroupRefreshQuery,
  ControlGroupRefreshQueryVariables
>;
export const UpdateControlGroupDocument = gql`
  mutation UpdateControlGroup(
    $id: String!
    $record: UpdateOneControlGroupInput!
  ) {
    updateControlGroup(id: $id, record: $record) {
      _id
      name
      propertyId
      unitId
      type
      automationEnabled
      masterDeviceId
      groupedDevices {
        _id
        deviceId
        name
        type
        displayOrder
      }
      deviceDetails
    }
  }
`;
export type UpdateControlGroupMutationFn = Apollo.MutationFunction<
  UpdateControlGroupMutation,
  UpdateControlGroupMutationVariables
>;

/**
 * __useUpdateControlGroupMutation__
 *
 * To run a mutation, you first call `useUpdateControlGroupMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateControlGroupMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateControlGroupMutation, { data, loading, error }] = useUpdateControlGroupMutation({
 *   variables: {
 *      id: // value for 'id'
 *      record: // value for 'record'
 *   },
 * });
 */
export function useUpdateControlGroupMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UpdateControlGroupMutation,
    UpdateControlGroupMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    UpdateControlGroupMutation,
    UpdateControlGroupMutationVariables
  >(UpdateControlGroupDocument, options);
}
export type UpdateControlGroupMutationHookResult = ReturnType<
  typeof useUpdateControlGroupMutation
>;
export type UpdateControlGroupMutationResult =
  Apollo.MutationResult<UpdateControlGroupMutation>;
export type UpdateControlGroupMutationOptions = Apollo.BaseMutationOptions<
  UpdateControlGroupMutation,
  UpdateControlGroupMutationVariables
>;
export const DeleteControlGroupDocument = gql`
  mutation DeleteControlGroup($id: String!) {
    deleteControlGroup(id: $id)
  }
`;
export type DeleteControlGroupMutationFn = Apollo.MutationFunction<
  DeleteControlGroupMutation,
  DeleteControlGroupMutationVariables
>;

/**
 * __useDeleteControlGroupMutation__
 *
 * To run a mutation, you first call `useDeleteControlGroupMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteControlGroupMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteControlGroupMutation, { data, loading, error }] = useDeleteControlGroupMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteControlGroupMutation(
  baseOptions?: Apollo.MutationHookOptions<
    DeleteControlGroupMutation,
    DeleteControlGroupMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    DeleteControlGroupMutation,
    DeleteControlGroupMutationVariables
  >(DeleteControlGroupDocument, options);
}
export type DeleteControlGroupMutationHookResult = ReturnType<
  typeof useDeleteControlGroupMutation
>;
export type DeleteControlGroupMutationResult =
  Apollo.MutationResult<DeleteControlGroupMutation>;
export type DeleteControlGroupMutationOptions = Apollo.BaseMutationOptions<
  DeleteControlGroupMutation,
  DeleteControlGroupMutationVariables
>;
export const EditDeviceDocument = gql`
  mutation EditDevice($deviceId: String!, $edits: DeviceEditsInput!) {
    editDevice(deviceId: $deviceId, edits: $edits) {
      deviceId
      name
    }
  }
`;
export type EditDeviceMutationFn = Apollo.MutationFunction<
  EditDeviceMutation,
  EditDeviceMutationVariables
>;

/**
 * __useEditDeviceMutation__
 *
 * To run a mutation, you first call `useEditDeviceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEditDeviceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [editDeviceMutation, { data, loading, error }] = useEditDeviceMutation({
 *   variables: {
 *      deviceId: // value for 'deviceId'
 *      edits: // value for 'edits'
 *   },
 * });
 */
export function useEditDeviceMutation(
  baseOptions?: Apollo.MutationHookOptions<
    EditDeviceMutation,
    EditDeviceMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<EditDeviceMutation, EditDeviceMutationVariables>(
    EditDeviceDocument,
    options,
  );
}
export type EditDeviceMutationHookResult = ReturnType<
  typeof useEditDeviceMutation
>;
export type EditDeviceMutationResult =
  Apollo.MutationResult<EditDeviceMutation>;
export type EditDeviceMutationOptions = Apollo.BaseMutationOptions<
  EditDeviceMutation,
  EditDeviceMutationVariables
>;
export const ToggleControlGroupAutomationDocument = gql`
  mutation ToggleControlGroupAutomation($id: String!) {
    toggleControlGroupAutomation(id: $id) {
      _id
      automationEnabled
      name
      propertyId
      unitId
      type
      masterDeviceId
      deviceDetails
    }
  }
`;
export type ToggleControlGroupAutomationMutationFn = Apollo.MutationFunction<
  ToggleControlGroupAutomationMutation,
  ToggleControlGroupAutomationMutationVariables
>;

/**
 * __useToggleControlGroupAutomationMutation__
 *
 * To run a mutation, you first call `useToggleControlGroupAutomationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useToggleControlGroupAutomationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [toggleControlGroupAutomationMutation, { data, loading, error }] = useToggleControlGroupAutomationMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useToggleControlGroupAutomationMutation(
  baseOptions?: Apollo.MutationHookOptions<
    ToggleControlGroupAutomationMutation,
    ToggleControlGroupAutomationMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    ToggleControlGroupAutomationMutation,
    ToggleControlGroupAutomationMutationVariables
  >(ToggleControlGroupAutomationDocument, options);
}
export type ToggleControlGroupAutomationMutationHookResult = ReturnType<
  typeof useToggleControlGroupAutomationMutation
>;
export type ToggleControlGroupAutomationMutationResult =
  Apollo.MutationResult<ToggleControlGroupAutomationMutation>;
export type ToggleControlGroupAutomationMutationOptions =
  Apollo.BaseMutationOptions<
    ToggleControlGroupAutomationMutation,
    ToggleControlGroupAutomationMutationVariables
  >;
export const UpdateDevicePowerStateDocument = gql`
  mutation UpdateDevicePowerState($deviceId: String!, $poweredOn: Boolean!) {
    updateDevicePowerState(deviceId: $deviceId, poweredOn: $poweredOn) {
      _id
      powerState {
        value
        timestamp
      }
      hasPendingUpdates
    }
  }
`;
export type UpdateDevicePowerStateMutationFn = Apollo.MutationFunction<
  UpdateDevicePowerStateMutation,
  UpdateDevicePowerStateMutationVariables
>;

/**
 * __useUpdateDevicePowerStateMutation__
 *
 * To run a mutation, you first call `useUpdateDevicePowerStateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateDevicePowerStateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateDevicePowerStateMutation, { data, loading, error }] = useUpdateDevicePowerStateMutation({
 *   variables: {
 *      deviceId: // value for 'deviceId'
 *      poweredOn: // value for 'poweredOn'
 *   },
 * });
 */
export function useUpdateDevicePowerStateMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UpdateDevicePowerStateMutation,
    UpdateDevicePowerStateMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    UpdateDevicePowerStateMutation,
    UpdateDevicePowerStateMutationVariables
  >(UpdateDevicePowerStateDocument, options);
}
export type UpdateDevicePowerStateMutationHookResult = ReturnType<
  typeof useUpdateDevicePowerStateMutation
>;
export type UpdateDevicePowerStateMutationResult =
  Apollo.MutationResult<UpdateDevicePowerStateMutation>;
export type UpdateDevicePowerStateMutationOptions = Apollo.BaseMutationOptions<
  UpdateDevicePowerStateMutation,
  UpdateDevicePowerStateMutationVariables
>;
export const EntitySelectionQueryableRelatedTypesDocument = gql`
  query EntitySelectionQueryableRelatedTypes(
    $modelName: QueryableRelatedTypesModelNameInput!
  ) {
    queryableRelatedTypes(modelName: $modelName)
  }
`;

/**
 * __useEntitySelectionQueryableRelatedTypesQuery__
 *
 * To run a query within a React component, call `useEntitySelectionQueryableRelatedTypesQuery` and pass it any options that fit your needs.
 * When your component renders, `useEntitySelectionQueryableRelatedTypesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEntitySelectionQueryableRelatedTypesQuery({
 *   variables: {
 *      modelName: // value for 'modelName'
 *   },
 * });
 */
export function useEntitySelectionQueryableRelatedTypesQuery(
  baseOptions: Apollo.QueryHookOptions<
    EntitySelectionQueryableRelatedTypesQuery,
    EntitySelectionQueryableRelatedTypesQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    EntitySelectionQueryableRelatedTypesQuery,
    EntitySelectionQueryableRelatedTypesQueryVariables
  >(EntitySelectionQueryableRelatedTypesDocument, options);
}
export function useEntitySelectionQueryableRelatedTypesLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    EntitySelectionQueryableRelatedTypesQuery,
    EntitySelectionQueryableRelatedTypesQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    EntitySelectionQueryableRelatedTypesQuery,
    EntitySelectionQueryableRelatedTypesQueryVariables
  >(EntitySelectionQueryableRelatedTypesDocument, options);
}
export type EntitySelectionQueryableRelatedTypesQueryHookResult = ReturnType<
  typeof useEntitySelectionQueryableRelatedTypesQuery
>;
export type EntitySelectionQueryableRelatedTypesLazyQueryHookResult =
  ReturnType<typeof useEntitySelectionQueryableRelatedTypesLazyQuery>;
export type EntitySelectionQueryableRelatedTypesQueryResult =
  Apollo.QueryResult<
    EntitySelectionQueryableRelatedTypesQuery,
    EntitySelectionQueryableRelatedTypesQueryVariables
  >;
export const EntitySelectionTestDocument = gql`
  query EntitySelectionTest(
    $selection: TieredEntitySelectionInput!
    $options: QueryExecutionOptionsInput
  ) {
    executeTieredEntitySelection(selection: $selection, options: $options)
  }
`;

/**
 * __useEntitySelectionTestQuery__
 *
 * To run a query within a React component, call `useEntitySelectionTestQuery` and pass it any options that fit your needs.
 * When your component renders, `useEntitySelectionTestQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEntitySelectionTestQuery({
 *   variables: {
 *      selection: // value for 'selection'
 *      options: // value for 'options'
 *   },
 * });
 */
export function useEntitySelectionTestQuery(
  baseOptions: Apollo.QueryHookOptions<
    EntitySelectionTestQuery,
    EntitySelectionTestQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    EntitySelectionTestQuery,
    EntitySelectionTestQueryVariables
  >(EntitySelectionTestDocument, options);
}
export function useEntitySelectionTestLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    EntitySelectionTestQuery,
    EntitySelectionTestQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    EntitySelectionTestQuery,
    EntitySelectionTestQueryVariables
  >(EntitySelectionTestDocument, options);
}
export type EntitySelectionTestQueryHookResult = ReturnType<
  typeof useEntitySelectionTestQuery
>;
export type EntitySelectionTestLazyQueryHookResult = ReturnType<
  typeof useEntitySelectionTestLazyQuery
>;
export type EntitySelectionTestQueryResult = Apollo.QueryResult<
  EntitySelectionTestQuery,
  EntitySelectionTestQueryVariables
>;
export const QueryableFieldsDocument = gql`
  query QueryableFields($modelName: QueryableModelFieldsModelNameInput!) {
    queryableFields(modelName: $modelName)
  }
`;

/**
 * __useQueryableFieldsQuery__
 *
 * To run a query within a React component, call `useQueryableFieldsQuery` and pass it any options that fit your needs.
 * When your component renders, `useQueryableFieldsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useQueryableFieldsQuery({
 *   variables: {
 *      modelName: // value for 'modelName'
 *   },
 * });
 */
export function useQueryableFieldsQuery(
  baseOptions: Apollo.QueryHookOptions<
    QueryableFieldsQuery,
    QueryableFieldsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<QueryableFieldsQuery, QueryableFieldsQueryVariables>(
    QueryableFieldsDocument,
    options,
  );
}
export function useQueryableFieldsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    QueryableFieldsQuery,
    QueryableFieldsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    QueryableFieldsQuery,
    QueryableFieldsQueryVariables
  >(QueryableFieldsDocument, options);
}
export type QueryableFieldsQueryHookResult = ReturnType<
  typeof useQueryableFieldsQuery
>;
export type QueryableFieldsLazyQueryHookResult = ReturnType<
  typeof useQueryableFieldsLazyQuery
>;
export type QueryableFieldsQueryResult = Apollo.QueryResult<
  QueryableFieldsQuery,
  QueryableFieldsQueryVariables
>;
export const IngestionsDocument = gql`
  query Ingestions {
    ingestions(limit: 0) {
      ...IngestionFields
    }
  }
  ${IngestionFieldsFragmentDoc}
`;

/**
 * __useIngestionsQuery__
 *
 * To run a query within a React component, call `useIngestionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useIngestionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useIngestionsQuery({
 *   variables: {
 *   },
 * });
 */
export function useIngestionsQuery(
  baseOptions?: Apollo.QueryHookOptions<
    IngestionsQuery,
    IngestionsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<IngestionsQuery, IngestionsQueryVariables>(
    IngestionsDocument,
    options,
  );
}
export function useIngestionsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    IngestionsQuery,
    IngestionsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<IngestionsQuery, IngestionsQueryVariables>(
    IngestionsDocument,
    options,
  );
}
export type IngestionsQueryHookResult = ReturnType<typeof useIngestionsQuery>;
export type IngestionsLazyQueryHookResult = ReturnType<
  typeof useIngestionsLazyQuery
>;
export type IngestionsQueryResult = Apollo.QueryResult<
  IngestionsQuery,
  IngestionsQueryVariables
>;
export const IngestionUpdatesDocument = gql`
  subscription IngestionUpdates {
    ingestionEvents {
      ...IngestionFields
      modelChangeOperation
    }
  }
  ${IngestionFieldsFragmentDoc}
`;

/**
 * __useIngestionUpdatesSubscription__
 *
 * To run a query within a React component, call `useIngestionUpdatesSubscription` and pass it any options that fit your needs.
 * When your component renders, `useIngestionUpdatesSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useIngestionUpdatesSubscription({
 *   variables: {
 *   },
 * });
 */
export function useIngestionUpdatesSubscription(
  baseOptions?: Apollo.SubscriptionHookOptions<
    IngestionUpdatesSubscription,
    IngestionUpdatesSubscriptionVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useSubscription<
    IngestionUpdatesSubscription,
    IngestionUpdatesSubscriptionVariables
  >(IngestionUpdatesDocument, options);
}
export type IngestionUpdatesSubscriptionHookResult = ReturnType<
  typeof useIngestionUpdatesSubscription
>;
export type IngestionUpdatesSubscriptionResult =
  Apollo.SubscriptionResult<IngestionUpdatesSubscription>;
export const IngestionUpdatedDocument = gql`
  subscription IngestionUpdated($id: String!) {
    ingestionUpdatedByIds(_ids: [$id]) {
      ...IngestionFields
      modelChangeOperation
    }
  }
  ${IngestionFieldsFragmentDoc}
`;

/**
 * __useIngestionUpdatedSubscription__
 *
 * To run a query within a React component, call `useIngestionUpdatedSubscription` and pass it any options that fit your needs.
 * When your component renders, `useIngestionUpdatedSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useIngestionUpdatedSubscription({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useIngestionUpdatedSubscription(
  baseOptions: Apollo.SubscriptionHookOptions<
    IngestionUpdatedSubscription,
    IngestionUpdatedSubscriptionVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useSubscription<
    IngestionUpdatedSubscription,
    IngestionUpdatedSubscriptionVariables
  >(IngestionUpdatedDocument, options);
}
export type IngestionUpdatedSubscriptionHookResult = ReturnType<
  typeof useIngestionUpdatedSubscription
>;
export type IngestionUpdatedSubscriptionResult =
  Apollo.SubscriptionResult<IngestionUpdatedSubscription>;
export const GetIngestionUploadInfoDocument = gql`
  query GetIngestionUploadInfo {
    getIngestionUploadInfo {
      credentials
      date
      expiration
      policy
      signature
      url
    }
  }
`;

/**
 * __useGetIngestionUploadInfoQuery__
 *
 * To run a query within a React component, call `useGetIngestionUploadInfoQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetIngestionUploadInfoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetIngestionUploadInfoQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetIngestionUploadInfoQuery(
  baseOptions?: Apollo.QueryHookOptions<
    GetIngestionUploadInfoQuery,
    GetIngestionUploadInfoQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetIngestionUploadInfoQuery,
    GetIngestionUploadInfoQueryVariables
  >(GetIngestionUploadInfoDocument, options);
}
export function useGetIngestionUploadInfoLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetIngestionUploadInfoQuery,
    GetIngestionUploadInfoQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetIngestionUploadInfoQuery,
    GetIngestionUploadInfoQueryVariables
  >(GetIngestionUploadInfoDocument, options);
}
export type GetIngestionUploadInfoQueryHookResult = ReturnType<
  typeof useGetIngestionUploadInfoQuery
>;
export type GetIngestionUploadInfoLazyQueryHookResult = ReturnType<
  typeof useGetIngestionUploadInfoLazyQuery
>;
export type GetIngestionUploadInfoQueryResult = Apollo.QueryResult<
  GetIngestionUploadInfoQuery,
  GetIngestionUploadInfoQueryVariables
>;
export const CreateIngestionDocument = gql`
  mutation CreateIngestion($record: CreateIngestionInput!) {
    createIngestion(record: $record) {
      ...IngestionFields
    }
  }
  ${IngestionFieldsFragmentDoc}
`;
export type CreateIngestionMutationFn = Apollo.MutationFunction<
  CreateIngestionMutation,
  CreateIngestionMutationVariables
>;

/**
 * __useCreateIngestionMutation__
 *
 * To run a mutation, you first call `useCreateIngestionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateIngestionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createIngestionMutation, { data, loading, error }] = useCreateIngestionMutation({
 *   variables: {
 *      record: // value for 'record'
 *   },
 * });
 */
export function useCreateIngestionMutation(
  baseOptions?: Apollo.MutationHookOptions<
    CreateIngestionMutation,
    CreateIngestionMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    CreateIngestionMutation,
    CreateIngestionMutationVariables
  >(CreateIngestionDocument, options);
}
export type CreateIngestionMutationHookResult = ReturnType<
  typeof useCreateIngestionMutation
>;
export type CreateIngestionMutationResult =
  Apollo.MutationResult<CreateIngestionMutation>;
export type CreateIngestionMutationOptions = Apollo.BaseMutationOptions<
  CreateIngestionMutation,
  CreateIngestionMutationVariables
>;
export const RemoveIngestionDocument = gql`
  mutation RemoveIngestion($id: String!) {
    removeIngestion(id: $id)
  }
`;
export type RemoveIngestionMutationFn = Apollo.MutationFunction<
  RemoveIngestionMutation,
  RemoveIngestionMutationVariables
>;

/**
 * __useRemoveIngestionMutation__
 *
 * To run a mutation, you first call `useRemoveIngestionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveIngestionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeIngestionMutation, { data, loading, error }] = useRemoveIngestionMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useRemoveIngestionMutation(
  baseOptions?: Apollo.MutationHookOptions<
    RemoveIngestionMutation,
    RemoveIngestionMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    RemoveIngestionMutation,
    RemoveIngestionMutationVariables
  >(RemoveIngestionDocument, options);
}
export type RemoveIngestionMutationHookResult = ReturnType<
  typeof useRemoveIngestionMutation
>;
export type RemoveIngestionMutationResult =
  Apollo.MutationResult<RemoveIngestionMutation>;
export type RemoveIngestionMutationOptions = Apollo.BaseMutationOptions<
  RemoveIngestionMutation,
  RemoveIngestionMutationVariables
>;
export const InstallerDeviceUpdatesDocument = gql`
  subscription InstallerDeviceUpdates($ids: [String!]!) {
    deviceEventsByIds(_ids: $ids) {
      modelChangeOperation
      modelType
      _id
      name
      sourceId
      deviceId
      typeDisplayName
      installation {
        status
        message
      }
    }
  }
`;

/**
 * __useInstallerDeviceUpdatesSubscription__
 *
 * To run a query within a React component, call `useInstallerDeviceUpdatesSubscription` and pass it any options that fit your needs.
 * When your component renders, `useInstallerDeviceUpdatesSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useInstallerDeviceUpdatesSubscription({
 *   variables: {
 *      ids: // value for 'ids'
 *   },
 * });
 */
export function useInstallerDeviceUpdatesSubscription(
  baseOptions: Apollo.SubscriptionHookOptions<
    InstallerDeviceUpdatesSubscription,
    InstallerDeviceUpdatesSubscriptionVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useSubscription<
    InstallerDeviceUpdatesSubscription,
    InstallerDeviceUpdatesSubscriptionVariables
  >(InstallerDeviceUpdatesDocument, options);
}
export type InstallerDeviceUpdatesSubscriptionHookResult = ReturnType<
  typeof useInstallerDeviceUpdatesSubscription
>;
export type InstallerDeviceUpdatesSubscriptionResult =
  Apollo.SubscriptionResult<InstallerDeviceUpdatesSubscription>;
export const InstallerDeviceDocument = gql`
  query InstallerDevice($id: String!) {
    deviceById(_id: $id) {
      _id
      name
      sourceId
      deviceId
      typeDisplayName
      installation {
        status
        message
      }
    }
  }
`;

/**
 * __useInstallerDeviceQuery__
 *
 * To run a query within a React component, call `useInstallerDeviceQuery` and pass it any options that fit your needs.
 * When your component renders, `useInstallerDeviceQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useInstallerDeviceQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useInstallerDeviceQuery(
  baseOptions: Apollo.QueryHookOptions<
    InstallerDeviceQuery,
    InstallerDeviceQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<InstallerDeviceQuery, InstallerDeviceQueryVariables>(
    InstallerDeviceDocument,
    options,
  );
}
export function useInstallerDeviceLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    InstallerDeviceQuery,
    InstallerDeviceQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    InstallerDeviceQuery,
    InstallerDeviceQueryVariables
  >(InstallerDeviceDocument, options);
}
export type InstallerDeviceQueryHookResult = ReturnType<
  typeof useInstallerDeviceQuery
>;
export type InstallerDeviceLazyQueryHookResult = ReturnType<
  typeof useInstallerDeviceLazyQuery
>;
export type InstallerDeviceQueryResult = Apollo.QueryResult<
  InstallerDeviceQuery,
  InstallerDeviceQueryVariables
>;
export const RegisterDeviceDocument = gql`
  mutation RegisterDevice($id: String!, $euid: String!) {
    registerDevice(_id: $id, euid: $euid)
  }
`;
export type RegisterDeviceMutationFn = Apollo.MutationFunction<
  RegisterDeviceMutation,
  RegisterDeviceMutationVariables
>;

/**
 * __useRegisterDeviceMutation__
 *
 * To run a mutation, you first call `useRegisterDeviceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRegisterDeviceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [registerDeviceMutation, { data, loading, error }] = useRegisterDeviceMutation({
 *   variables: {
 *      id: // value for 'id'
 *      euid: // value for 'euid'
 *   },
 * });
 */
export function useRegisterDeviceMutation(
  baseOptions?: Apollo.MutationHookOptions<
    RegisterDeviceMutation,
    RegisterDeviceMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    RegisterDeviceMutation,
    RegisterDeviceMutationVariables
  >(RegisterDeviceDocument, options);
}
export type RegisterDeviceMutationHookResult = ReturnType<
  typeof useRegisterDeviceMutation
>;
export type RegisterDeviceMutationResult =
  Apollo.MutationResult<RegisterDeviceMutation>;
export type RegisterDeviceMutationOptions = Apollo.BaseMutationOptions<
  RegisterDeviceMutation,
  RegisterDeviceMutationVariables
>;
export const SetInstallationStatusDocument = gql`
  mutation SetInstallationStatus($options: SetInstallationStatusInput!) {
    setInstallationStatus(options: $options) {
      result
      message
    }
  }
`;
export type SetInstallationStatusMutationFn = Apollo.MutationFunction<
  SetInstallationStatusMutation,
  SetInstallationStatusMutationVariables
>;

/**
 * __useSetInstallationStatusMutation__
 *
 * To run a mutation, you first call `useSetInstallationStatusMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetInstallationStatusMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setInstallationStatusMutation, { data, loading, error }] = useSetInstallationStatusMutation({
 *   variables: {
 *      options: // value for 'options'
 *   },
 * });
 */
export function useSetInstallationStatusMutation(
  baseOptions?: Apollo.MutationHookOptions<
    SetInstallationStatusMutation,
    SetInstallationStatusMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    SetInstallationStatusMutation,
    SetInstallationStatusMutationVariables
  >(SetInstallationStatusDocument, options);
}
export type SetInstallationStatusMutationHookResult = ReturnType<
  typeof useSetInstallationStatusMutation
>;
export type SetInstallationStatusMutationResult =
  Apollo.MutationResult<SetInstallationStatusMutation>;
export type SetInstallationStatusMutationOptions = Apollo.BaseMutationOptions<
  SetInstallationStatusMutation,
  SetInstallationStatusMutationVariables
>;
export const InstallerToolsUpdatesDocument = gql`
  subscription InstallerToolsUpdates($ids: [String!]!) {
    deviceEventsByIds(_ids: $ids) {
      modelChangeOperation
      modelType
      _id
      name
      type
      propertyId
      unitId
      zoneId
      sourceId
      deviceId
      installation {
        status
        count
        message
        paired
        pairedTo
        previousStatus
        rawDeviceId
        replacingDeviceId
      }
      alertTypes {
        deviceOffline
        sourceOffline
      }
    }
  }
`;

/**
 * __useInstallerToolsUpdatesSubscription__
 *
 * To run a query within a React component, call `useInstallerToolsUpdatesSubscription` and pass it any options that fit your needs.
 * When your component renders, `useInstallerToolsUpdatesSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useInstallerToolsUpdatesSubscription({
 *   variables: {
 *      ids: // value for 'ids'
 *   },
 * });
 */
export function useInstallerToolsUpdatesSubscription(
  baseOptions: Apollo.SubscriptionHookOptions<
    InstallerToolsUpdatesSubscription,
    InstallerToolsUpdatesSubscriptionVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useSubscription<
    InstallerToolsUpdatesSubscription,
    InstallerToolsUpdatesSubscriptionVariables
  >(InstallerToolsUpdatesDocument, options);
}
export type InstallerToolsUpdatesSubscriptionHookResult = ReturnType<
  typeof useInstallerToolsUpdatesSubscription
>;
export type InstallerToolsUpdatesSubscriptionResult =
  Apollo.SubscriptionResult<InstallerToolsUpdatesSubscription>;
export const UnregisterDeviceDocument = gql`
  mutation UnregisterDevice($id: String!) {
    unregisterDevice(_id: $id)
  }
`;
export type UnregisterDeviceMutationFn = Apollo.MutationFunction<
  UnregisterDeviceMutation,
  UnregisterDeviceMutationVariables
>;

/**
 * __useUnregisterDeviceMutation__
 *
 * To run a mutation, you first call `useUnregisterDeviceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUnregisterDeviceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [unregisterDeviceMutation, { data, loading, error }] = useUnregisterDeviceMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useUnregisterDeviceMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UnregisterDeviceMutation,
    UnregisterDeviceMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    UnregisterDeviceMutation,
    UnregisterDeviceMutationVariables
  >(UnregisterDeviceDocument, options);
}
export type UnregisterDeviceMutationHookResult = ReturnType<
  typeof useUnregisterDeviceMutation
>;
export type UnregisterDeviceMutationResult =
  Apollo.MutationResult<UnregisterDeviceMutation>;
export type UnregisterDeviceMutationOptions = Apollo.BaseMutationOptions<
  UnregisterDeviceMutation,
  UnregisterDeviceMutationVariables
>;
export const InstallerToolsDocument = gql`
  query InstallerTools($id: String!) {
    deviceById(_id: $id) {
      _id
      name
      type
      propertyId
      unitId
      zoneId
      sourceId
      deviceId
      installation {
        status
        count
        message
        paired
        pairedTo
        previousStatus
        rawDeviceId
        replacingDeviceId
      }
      alertTypes {
        deviceOffline
        sourceOffline
      }
      unit {
        _id
        name
      }
    }
  }
`;

/**
 * __useInstallerToolsQuery__
 *
 * To run a query within a React component, call `useInstallerToolsQuery` and pass it any options that fit your needs.
 * When your component renders, `useInstallerToolsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useInstallerToolsQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useInstallerToolsQuery(
  baseOptions: Apollo.QueryHookOptions<
    InstallerToolsQuery,
    InstallerToolsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<InstallerToolsQuery, InstallerToolsQueryVariables>(
    InstallerToolsDocument,
    options,
  );
}
export function useInstallerToolsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    InstallerToolsQuery,
    InstallerToolsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<InstallerToolsQuery, InstallerToolsQueryVariables>(
    InstallerToolsDocument,
    options,
  );
}
export type InstallerToolsQueryHookResult = ReturnType<
  typeof useInstallerToolsQuery
>;
export type InstallerToolsLazyQueryHookResult = ReturnType<
  typeof useInstallerToolsLazyQuery
>;
export type InstallerToolsQueryResult = Apollo.QueryResult<
  InstallerToolsQuery,
  InstallerToolsQueryVariables
>;
export const UnitInstallerDetailDocument = gql`
  query unitInstallerDetail($id: String!) {
    unitById(_id: $id) {
      _id
      name
      devicesSummary {
        count
        majorAlerts
        minorAlerts
        proxy {
          type
          coolSetpoint
          heatSetpoint
          humidity
          isOffline
          operatingMode
          operatingState
          setpointCoolMin
          setpointHeatMax
          setpointProfileName
          setpointProfileType
          temperature
          __typename
        }
      }
      zones {
        _id
        __typename
        name
        controller
        thermostatId
        pairedSensorId
        role
        devices {
          _id
          deviceId
          name
          type
          typeDisplayName
          __typename
          isConfigured
          installation {
            status
            count
            message
            paired
            pairedTo
            previousStatus
            rawDeviceId
            replacingDeviceId
          }
          ... on VSDPump {
            role
          }
          ... on Thermistor {
            role
          }
        }
      }
      panels {
        _id
        __typename
        name
        type
        role
        devices {
          _id
          deviceId
          name
          type
          typeDisplayName
          __typename
          isConfigured
          installation {
            status
            count
            message
            paired
            pairedTo
            previousStatus
            rawDeviceId
            replacingDeviceId
          }
          ... on VSDPump {
            role
          }
          ... on Thermistor {
            role
          }
        }
      }
      setpointProfileId
      setpointLimitProfile {
        heat {
          max
          min
        }
        cool {
          max
          min
        }
      }
      property {
        _id
        setpointProfileId
        setpointLimitProfile {
          heat {
            min
            max
          }
          cool {
            min
            max
          }
        }
      }
    }
  }
`;

/**
 * __useUnitInstallerDetailQuery__
 *
 * To run a query within a React component, call `useUnitInstallerDetailQuery` and pass it any options that fit your needs.
 * When your component renders, `useUnitInstallerDetailQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUnitInstallerDetailQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useUnitInstallerDetailQuery(
  baseOptions: Apollo.QueryHookOptions<
    UnitInstallerDetailQuery,
    UnitInstallerDetailQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    UnitInstallerDetailQuery,
    UnitInstallerDetailQueryVariables
  >(UnitInstallerDetailDocument, options);
}
export function useUnitInstallerDetailLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    UnitInstallerDetailQuery,
    UnitInstallerDetailQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    UnitInstallerDetailQuery,
    UnitInstallerDetailQueryVariables
  >(UnitInstallerDetailDocument, options);
}
export type UnitInstallerDetailQueryHookResult = ReturnType<
  typeof useUnitInstallerDetailQuery
>;
export type UnitInstallerDetailLazyQueryHookResult = ReturnType<
  typeof useUnitInstallerDetailLazyQuery
>;
export type UnitInstallerDetailQueryResult = Apollo.QueryResult<
  UnitInstallerDetailQuery,
  UnitInstallerDetailQueryVariables
>;
export const UnitInstallerListByPropertyIdDocument = gql`
  query UnitInstallerListByPropertyId($propertyId: String) {
    unitsByPropertyId(propertyId: [$propertyId]) {
      _id
      name
      type
      alertTypes {
        sourceOffline
        deviceAlert
        deviceMetric
        deviceOffline
      }
      isConnected
      hasAlerts
      hasResident
      devicesSummary {
        count
        majorAlerts
        minorAlerts
        proxy {
          coolSetpoint
          heatSetpoint
          humidity
          isOffline
          operatingMode
          operatingState
          setpointCoolMin
          setpointHeatMax
          setpointProfileName
          setpointProfileType
          temperature
          type
        }
      }
      devices(limit: 0) {
        installation {
          status
        }
      }
    }
  }
`;

/**
 * __useUnitInstallerListByPropertyIdQuery__
 *
 * To run a query within a React component, call `useUnitInstallerListByPropertyIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useUnitInstallerListByPropertyIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUnitInstallerListByPropertyIdQuery({
 *   variables: {
 *      propertyId: // value for 'propertyId'
 *   },
 * });
 */
export function useUnitInstallerListByPropertyIdQuery(
  baseOptions?: Apollo.QueryHookOptions<
    UnitInstallerListByPropertyIdQuery,
    UnitInstallerListByPropertyIdQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    UnitInstallerListByPropertyIdQuery,
    UnitInstallerListByPropertyIdQueryVariables
  >(UnitInstallerListByPropertyIdDocument, options);
}
export function useUnitInstallerListByPropertyIdLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    UnitInstallerListByPropertyIdQuery,
    UnitInstallerListByPropertyIdQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    UnitInstallerListByPropertyIdQuery,
    UnitInstallerListByPropertyIdQueryVariables
  >(UnitInstallerListByPropertyIdDocument, options);
}
export type UnitInstallerListByPropertyIdQueryHookResult = ReturnType<
  typeof useUnitInstallerListByPropertyIdQuery
>;
export type UnitInstallerListByPropertyIdLazyQueryHookResult = ReturnType<
  typeof useUnitInstallerListByPropertyIdLazyQuery
>;
export type UnitInstallerListByPropertyIdQueryResult = Apollo.QueryResult<
  UnitInstallerListByPropertyIdQuery,
  UnitInstallerListByPropertyIdQueryVariables
>;
export const OrganizationDetailEditSubDocument = gql`
  subscription OrganizationDetailEditSub($id: String!) {
    organizationEventsByIds(_ids: [$id]) {
      modelChangeOperation
      _id
      name
      description
      hqAddress {
        line1
        line2
        city
        state
        postalCode
        country
      }
      hqPhone
      hqEmail
      parentOrganization {
        _id
        name
      }
    }
  }
`;

/**
 * __useOrganizationDetailEditSubSubscription__
 *
 * To run a query within a React component, call `useOrganizationDetailEditSubSubscription` and pass it any options that fit your needs.
 * When your component renders, `useOrganizationDetailEditSubSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOrganizationDetailEditSubSubscription({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useOrganizationDetailEditSubSubscription(
  baseOptions: Apollo.SubscriptionHookOptions<
    OrganizationDetailEditSubSubscription,
    OrganizationDetailEditSubSubscriptionVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useSubscription<
    OrganizationDetailEditSubSubscription,
    OrganizationDetailEditSubSubscriptionVariables
  >(OrganizationDetailEditSubDocument, options);
}
export type OrganizationDetailEditSubSubscriptionHookResult = ReturnType<
  typeof useOrganizationDetailEditSubSubscription
>;
export type OrganizationDetailEditSubSubscriptionResult =
  Apollo.SubscriptionResult<OrganizationDetailEditSubSubscription>;
export const OrganizationDetailEditDocument = gql`
  query OrganizationDetailEdit($id: String!) {
    organizationById(_id: $id) {
      _id
      name
      description
      hqAddress {
        line1
        line2
        city
        state
        postalCode
        country
      }
      hqPhone
      hqEmail
      parentOrganization {
        _id
        name
      }
    }
  }
`;

/**
 * __useOrganizationDetailEditQuery__
 *
 * To run a query within a React component, call `useOrganizationDetailEditQuery` and pass it any options that fit your needs.
 * When your component renders, `useOrganizationDetailEditQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOrganizationDetailEditQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useOrganizationDetailEditQuery(
  baseOptions: Apollo.QueryHookOptions<
    OrganizationDetailEditQuery,
    OrganizationDetailEditQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    OrganizationDetailEditQuery,
    OrganizationDetailEditQueryVariables
  >(OrganizationDetailEditDocument, options);
}
export function useOrganizationDetailEditLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    OrganizationDetailEditQuery,
    OrganizationDetailEditQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    OrganizationDetailEditQuery,
    OrganizationDetailEditQueryVariables
  >(OrganizationDetailEditDocument, options);
}
export type OrganizationDetailEditQueryHookResult = ReturnType<
  typeof useOrganizationDetailEditQuery
>;
export type OrganizationDetailEditLazyQueryHookResult = ReturnType<
  typeof useOrganizationDetailEditLazyQuery
>;
export type OrganizationDetailEditQueryResult = Apollo.QueryResult<
  OrganizationDetailEditQuery,
  OrganizationDetailEditQueryVariables
>;
export const OrganizationsDocument = gql`
  query Organizations {
    organizations {
      _id
      name
    }
  }
`;

/**
 * __useOrganizationsQuery__
 *
 * To run a query within a React component, call `useOrganizationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useOrganizationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOrganizationsQuery({
 *   variables: {
 *   },
 * });
 */
export function useOrganizationsQuery(
  baseOptions?: Apollo.QueryHookOptions<
    OrganizationsQuery,
    OrganizationsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<OrganizationsQuery, OrganizationsQueryVariables>(
    OrganizationsDocument,
    options,
  );
}
export function useOrganizationsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    OrganizationsQuery,
    OrganizationsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<OrganizationsQuery, OrganizationsQueryVariables>(
    OrganizationsDocument,
    options,
  );
}
export type OrganizationsQueryHookResult = ReturnType<
  typeof useOrganizationsQuery
>;
export type OrganizationsLazyQueryHookResult = ReturnType<
  typeof useOrganizationsLazyQuery
>;
export type OrganizationsQueryResult = Apollo.QueryResult<
  OrganizationsQuery,
  OrganizationsQueryVariables
>;
export const CreateOrganizationDocument = gql`
  mutation CreateOrganization($organization: CreateOneOrganizationInput!) {
    createOrganization(organization: $organization) {
      _id
      name
      description
      hqAddress {
        line1
        line2
        city
        state
        postalCode
        country
      }
      hqPhone
      hqEmail
      parentOrganization {
        _id
        name
      }
    }
  }
`;
export type CreateOrganizationMutationFn = Apollo.MutationFunction<
  CreateOrganizationMutation,
  CreateOrganizationMutationVariables
>;

/**
 * __useCreateOrganizationMutation__
 *
 * To run a mutation, you first call `useCreateOrganizationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateOrganizationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createOrganizationMutation, { data, loading, error }] = useCreateOrganizationMutation({
 *   variables: {
 *      organization: // value for 'organization'
 *   },
 * });
 */
export function useCreateOrganizationMutation(
  baseOptions?: Apollo.MutationHookOptions<
    CreateOrganizationMutation,
    CreateOrganizationMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    CreateOrganizationMutation,
    CreateOrganizationMutationVariables
  >(CreateOrganizationDocument, options);
}
export type CreateOrganizationMutationHookResult = ReturnType<
  typeof useCreateOrganizationMutation
>;
export type CreateOrganizationMutationResult =
  Apollo.MutationResult<CreateOrganizationMutation>;
export type CreateOrganizationMutationOptions = Apollo.BaseMutationOptions<
  CreateOrganizationMutation,
  CreateOrganizationMutationVariables
>;
export const UpdateOrganizationDocument = gql`
  mutation UpdateOrganization(
    $id: String!
    $organization: UpdateOneOrganizationInput!
  ) {
    updateOrganization(_id: $id, organization: $organization) {
      _id
      name
      description
      hqAddress {
        line1
        line2
        city
        state
        postalCode
        country
      }
      hqPhone
      hqEmail
      parentOrganization {
        _id
        name
      }
    }
  }
`;
export type UpdateOrganizationMutationFn = Apollo.MutationFunction<
  UpdateOrganizationMutation,
  UpdateOrganizationMutationVariables
>;

/**
 * __useUpdateOrganizationMutation__
 *
 * To run a mutation, you first call `useUpdateOrganizationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateOrganizationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateOrganizationMutation, { data, loading, error }] = useUpdateOrganizationMutation({
 *   variables: {
 *      id: // value for 'id'
 *      organization: // value for 'organization'
 *   },
 * });
 */
export function useUpdateOrganizationMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UpdateOrganizationMutation,
    UpdateOrganizationMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    UpdateOrganizationMutation,
    UpdateOrganizationMutationVariables
  >(UpdateOrganizationDocument, options);
}
export type UpdateOrganizationMutationHookResult = ReturnType<
  typeof useUpdateOrganizationMutation
>;
export type UpdateOrganizationMutationResult =
  Apollo.MutationResult<UpdateOrganizationMutation>;
export type UpdateOrganizationMutationOptions = Apollo.BaseMutationOptions<
  UpdateOrganizationMutation,
  UpdateOrganizationMutationVariables
>;
export const RemoveOrganizationDocument = gql`
  mutation RemoveOrganization($id: String!) {
    deleteOrganization(_id: $id)
  }
`;
export type RemoveOrganizationMutationFn = Apollo.MutationFunction<
  RemoveOrganizationMutation,
  RemoveOrganizationMutationVariables
>;

/**
 * __useRemoveOrganizationMutation__
 *
 * To run a mutation, you first call `useRemoveOrganizationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveOrganizationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeOrganizationMutation, { data, loading, error }] = useRemoveOrganizationMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useRemoveOrganizationMutation(
  baseOptions?: Apollo.MutationHookOptions<
    RemoveOrganizationMutation,
    RemoveOrganizationMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    RemoveOrganizationMutation,
    RemoveOrganizationMutationVariables
  >(RemoveOrganizationDocument, options);
}
export type RemoveOrganizationMutationHookResult = ReturnType<
  typeof useRemoveOrganizationMutation
>;
export type RemoveOrganizationMutationResult =
  Apollo.MutationResult<RemoveOrganizationMutation>;
export type RemoveOrganizationMutationOptions = Apollo.BaseMutationOptions<
  RemoveOrganizationMutation,
  RemoveOrganizationMutationVariables
>;
export const OrganizationParentOptionsDocument = gql`
  query OrganizationParentOptions($excludeId: String) {
    organizations(
      filter: {
        _operators: {
          _id: { ne: $excludeId }
          parentOrganizationId: { ne: $excludeId }
        }
      }
    ) {
      _id
      name
    }
  }
`;

/**
 * __useOrganizationParentOptionsQuery__
 *
 * To run a query within a React component, call `useOrganizationParentOptionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useOrganizationParentOptionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOrganizationParentOptionsQuery({
 *   variables: {
 *      excludeId: // value for 'excludeId'
 *   },
 * });
 */
export function useOrganizationParentOptionsQuery(
  baseOptions?: Apollo.QueryHookOptions<
    OrganizationParentOptionsQuery,
    OrganizationParentOptionsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    OrganizationParentOptionsQuery,
    OrganizationParentOptionsQueryVariables
  >(OrganizationParentOptionsDocument, options);
}
export function useOrganizationParentOptionsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    OrganizationParentOptionsQuery,
    OrganizationParentOptionsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    OrganizationParentOptionsQuery,
    OrganizationParentOptionsQueryVariables
  >(OrganizationParentOptionsDocument, options);
}
export type OrganizationParentOptionsQueryHookResult = ReturnType<
  typeof useOrganizationParentOptionsQuery
>;
export type OrganizationParentOptionsLazyQueryHookResult = ReturnType<
  typeof useOrganizationParentOptionsLazyQuery
>;
export type OrganizationParentOptionsQueryResult = Apollo.QueryResult<
  OrganizationParentOptionsQuery,
  OrganizationParentOptionsQueryVariables
>;
export const PlmContractDetailEditSubDocument = gql`
  subscription PlmContractDetailEditSub($id: String!) {
    plmContractEventsByIds(_ids: [$id]) {
      modelChangeOperation
      _id
      name
      contractId
      programId
      program {
        _id
        name
        partner {
          _id
          name
        }
      }
      propertyIds
      scopeType
      meterIds
      properties {
        _id
        title
      }
      partnerId
      partner {
        _id
        name
      }
      dispatcherIds
      dispatchers {
        _id
        name
      }
      minimumReductionKW
      maximumEventsPerSeason
      baselineMethod
      incentiveDescription
      penaltyForNonCompliance
      status
      notificationEmail
    }
  }
`;

/**
 * __usePlmContractDetailEditSubSubscription__
 *
 * To run a query within a React component, call `usePlmContractDetailEditSubSubscription` and pass it any options that fit your needs.
 * When your component renders, `usePlmContractDetailEditSubSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePlmContractDetailEditSubSubscription({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function usePlmContractDetailEditSubSubscription(
  baseOptions: Apollo.SubscriptionHookOptions<
    PlmContractDetailEditSubSubscription,
    PlmContractDetailEditSubSubscriptionVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useSubscription<
    PlmContractDetailEditSubSubscription,
    PlmContractDetailEditSubSubscriptionVariables
  >(PlmContractDetailEditSubDocument, options);
}
export type PlmContractDetailEditSubSubscriptionHookResult = ReturnType<
  typeof usePlmContractDetailEditSubSubscription
>;
export type PlmContractDetailEditSubSubscriptionResult =
  Apollo.SubscriptionResult<PlmContractDetailEditSubSubscription>;
export const PlmContractDetailEditDocument = gql`
  query PlmContractDetailEdit($id: String!) {
    plmContractById(_id: $id) {
      _id
      name
      contractId
      programId
      program {
        _id
        name
        partner {
          _id
          name
        }
      }
      propertyIds
      scopeType
      meterIds
      properties {
        _id
        title
      }
      partnerId
      partner {
        _id
        name
      }
      dispatcherIds
      dispatchers {
        _id
        name
      }
      minimumReductionKW
      maximumEventsPerSeason
      baselineMethod
      incentiveDescription
      penaltyForNonCompliance
      status
      notificationEmail
    }
  }
`;

/**
 * __usePlmContractDetailEditQuery__
 *
 * To run a query within a React component, call `usePlmContractDetailEditQuery` and pass it any options that fit your needs.
 * When your component renders, `usePlmContractDetailEditQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePlmContractDetailEditQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function usePlmContractDetailEditQuery(
  baseOptions: Apollo.QueryHookOptions<
    PlmContractDetailEditQuery,
    PlmContractDetailEditQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    PlmContractDetailEditQuery,
    PlmContractDetailEditQueryVariables
  >(PlmContractDetailEditDocument, options);
}
export function usePlmContractDetailEditLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    PlmContractDetailEditQuery,
    PlmContractDetailEditQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    PlmContractDetailEditQuery,
    PlmContractDetailEditQueryVariables
  >(PlmContractDetailEditDocument, options);
}
export type PlmContractDetailEditQueryHookResult = ReturnType<
  typeof usePlmContractDetailEditQuery
>;
export type PlmContractDetailEditLazyQueryHookResult = ReturnType<
  typeof usePlmContractDetailEditLazyQuery
>;
export type PlmContractDetailEditQueryResult = Apollo.QueryResult<
  PlmContractDetailEditQuery,
  PlmContractDetailEditQueryVariables
>;
export const PlmContractListSubDocument = gql`
  subscription PlmContractListSub {
    plmContractEvents {
      modelChangeOperation
      _id
      name
      contractId
      programId
      program {
        _id
        name
        partner {
          _id
          name
        }
      }
      propertyIds
      scopeType
      meterIds
      properties {
        _id
        title
      }
      minimumReductionKW
      maximumEventsPerSeason
      baselineMethod
      incentiveDescription
      penaltyForNonCompliance
      status
      notificationEmail
    }
  }
`;

/**
 * __usePlmContractListSubSubscription__
 *
 * To run a query within a React component, call `usePlmContractListSubSubscription` and pass it any options that fit your needs.
 * When your component renders, `usePlmContractListSubSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePlmContractListSubSubscription({
 *   variables: {
 *   },
 * });
 */
export function usePlmContractListSubSubscription(
  baseOptions?: Apollo.SubscriptionHookOptions<
    PlmContractListSubSubscription,
    PlmContractListSubSubscriptionVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useSubscription<
    PlmContractListSubSubscription,
    PlmContractListSubSubscriptionVariables
  >(PlmContractListSubDocument, options);
}
export type PlmContractListSubSubscriptionHookResult = ReturnType<
  typeof usePlmContractListSubSubscription
>;
export type PlmContractListSubSubscriptionResult =
  Apollo.SubscriptionResult<PlmContractListSubSubscription>;
export const PlmContractsDocument = gql`
  query PlmContracts {
    plmContracts {
      _id
      name
      contractId
      programId
      program {
        _id
        name
        partner {
          _id
          name
        }
      }
      propertyIds
      scopeType
      meterIds
      properties {
        _id
        title
      }
      minimumReductionKW
      maximumEventsPerSeason
      baselineMethod
      incentiveDescription
      penaltyForNonCompliance
      status
      notificationEmail
    }
  }
`;

/**
 * __usePlmContractsQuery__
 *
 * To run a query within a React component, call `usePlmContractsQuery` and pass it any options that fit your needs.
 * When your component renders, `usePlmContractsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePlmContractsQuery({
 *   variables: {
 *   },
 * });
 */
export function usePlmContractsQuery(
  baseOptions?: Apollo.QueryHookOptions<
    PlmContractsQuery,
    PlmContractsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<PlmContractsQuery, PlmContractsQueryVariables>(
    PlmContractsDocument,
    options,
  );
}
export function usePlmContractsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    PlmContractsQuery,
    PlmContractsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<PlmContractsQuery, PlmContractsQueryVariables>(
    PlmContractsDocument,
    options,
  );
}
export type PlmContractsQueryHookResult = ReturnType<
  typeof usePlmContractsQuery
>;
export type PlmContractsLazyQueryHookResult = ReturnType<
  typeof usePlmContractsLazyQuery
>;
export type PlmContractsQueryResult = Apollo.QueryResult<
  PlmContractsQuery,
  PlmContractsQueryVariables
>;
export const CreatePlmContractDocument = gql`
  mutation CreatePlmContract($plmContract: CreateOnePlmContractInput!) {
    createPlmContract(plmContract: $plmContract) {
      _id
      name
      contractId
      programId
      program {
        _id
        name
        partner {
          _id
          name
        }
      }
      propertyIds
      scopeType
      meterIds
      properties {
        _id
        title
      }
      partnerId
      partner {
        _id
        name
      }
      dispatcherIds
      dispatchers {
        _id
        name
      }
      minimumReductionKW
      maximumEventsPerSeason
      baselineMethod
      incentiveDescription
      penaltyForNonCompliance
      status
      notificationEmail
    }
  }
`;
export type CreatePlmContractMutationFn = Apollo.MutationFunction<
  CreatePlmContractMutation,
  CreatePlmContractMutationVariables
>;

/**
 * __useCreatePlmContractMutation__
 *
 * To run a mutation, you first call `useCreatePlmContractMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreatePlmContractMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createPlmContractMutation, { data, loading, error }] = useCreatePlmContractMutation({
 *   variables: {
 *      plmContract: // value for 'plmContract'
 *   },
 * });
 */
export function useCreatePlmContractMutation(
  baseOptions?: Apollo.MutationHookOptions<
    CreatePlmContractMutation,
    CreatePlmContractMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    CreatePlmContractMutation,
    CreatePlmContractMutationVariables
  >(CreatePlmContractDocument, options);
}
export type CreatePlmContractMutationHookResult = ReturnType<
  typeof useCreatePlmContractMutation
>;
export type CreatePlmContractMutationResult =
  Apollo.MutationResult<CreatePlmContractMutation>;
export type CreatePlmContractMutationOptions = Apollo.BaseMutationOptions<
  CreatePlmContractMutation,
  CreatePlmContractMutationVariables
>;
export const UpdatePlmContractDocument = gql`
  mutation UpdatePlmContract(
    $id: String!
    $plmContract: UpdateOnePlmContractInput!
  ) {
    updatePlmContract(_id: $id, plmContract: $plmContract) {
      _id
      name
      contractId
      programId
      program {
        _id
        name
        partner {
          _id
          name
        }
      }
      propertyIds
      scopeType
      meterIds
      properties {
        _id
        title
      }
      partnerId
      partner {
        _id
        name
      }
      dispatcherIds
      dispatchers {
        _id
        name
      }
      minimumReductionKW
      maximumEventsPerSeason
      baselineMethod
      incentiveDescription
      penaltyForNonCompliance
      status
      notificationEmail
    }
  }
`;
export type UpdatePlmContractMutationFn = Apollo.MutationFunction<
  UpdatePlmContractMutation,
  UpdatePlmContractMutationVariables
>;

/**
 * __useUpdatePlmContractMutation__
 *
 * To run a mutation, you first call `useUpdatePlmContractMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdatePlmContractMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updatePlmContractMutation, { data, loading, error }] = useUpdatePlmContractMutation({
 *   variables: {
 *      id: // value for 'id'
 *      plmContract: // value for 'plmContract'
 *   },
 * });
 */
export function useUpdatePlmContractMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UpdatePlmContractMutation,
    UpdatePlmContractMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    UpdatePlmContractMutation,
    UpdatePlmContractMutationVariables
  >(UpdatePlmContractDocument, options);
}
export type UpdatePlmContractMutationHookResult = ReturnType<
  typeof useUpdatePlmContractMutation
>;
export type UpdatePlmContractMutationResult =
  Apollo.MutationResult<UpdatePlmContractMutation>;
export type UpdatePlmContractMutationOptions = Apollo.BaseMutationOptions<
  UpdatePlmContractMutation,
  UpdatePlmContractMutationVariables
>;
export const RemovePlmContractDocument = gql`
  mutation RemovePlmContract($id: String!) {
    deletePlmContract(_id: $id)
  }
`;
export type RemovePlmContractMutationFn = Apollo.MutationFunction<
  RemovePlmContractMutation,
  RemovePlmContractMutationVariables
>;

/**
 * __useRemovePlmContractMutation__
 *
 * To run a mutation, you first call `useRemovePlmContractMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemovePlmContractMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removePlmContractMutation, { data, loading, error }] = useRemovePlmContractMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useRemovePlmContractMutation(
  baseOptions?: Apollo.MutationHookOptions<
    RemovePlmContractMutation,
    RemovePlmContractMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    RemovePlmContractMutation,
    RemovePlmContractMutationVariables
  >(RemovePlmContractDocument, options);
}
export type RemovePlmContractMutationHookResult = ReturnType<
  typeof useRemovePlmContractMutation
>;
export type RemovePlmContractMutationResult =
  Apollo.MutationResult<RemovePlmContractMutation>;
export type RemovePlmContractMutationOptions = Apollo.BaseMutationOptions<
  RemovePlmContractMutation,
  RemovePlmContractMutationVariables
>;
export const PlmContractOptionsDocument = gql`
  query PlmContractOptions {
    plmContracts {
      _id
      name
    }
  }
`;

/**
 * __usePlmContractOptionsQuery__
 *
 * To run a query within a React component, call `usePlmContractOptionsQuery` and pass it any options that fit your needs.
 * When your component renders, `usePlmContractOptionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePlmContractOptionsQuery({
 *   variables: {
 *   },
 * });
 */
export function usePlmContractOptionsQuery(
  baseOptions?: Apollo.QueryHookOptions<
    PlmContractOptionsQuery,
    PlmContractOptionsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    PlmContractOptionsQuery,
    PlmContractOptionsQueryVariables
  >(PlmContractOptionsDocument, options);
}
export function usePlmContractOptionsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    PlmContractOptionsQuery,
    PlmContractOptionsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    PlmContractOptionsQuery,
    PlmContractOptionsQueryVariables
  >(PlmContractOptionsDocument, options);
}
export type PlmContractOptionsQueryHookResult = ReturnType<
  typeof usePlmContractOptionsQuery
>;
export type PlmContractOptionsLazyQueryHookResult = ReturnType<
  typeof usePlmContractOptionsLazyQuery
>;
export type PlmContractOptionsQueryResult = Apollo.QueryResult<
  PlmContractOptionsQuery,
  PlmContractOptionsQueryVariables
>;
export const PlmContractUpdateDocument = gql`
  subscription plmContractUpdate($_id: String) {
    plmContractEventsByIds(_ids: [$_id]) {
      modelChangeOperation
      _id
      contractId
      programId
      propertyIds
      scopeType
      meterIds
      properties {
        _id
        title
      }
      partnerId
      partner {
        _id
        name
      }
      dispatcherIds
      dispatchers {
        _id
        name
      }
      minimumReductionKW
      maximumEventsPerSeason
      baselineMethod
      incentiveDescription
      penaltyForNonCompliance
      status
      notificationEmail
    }
  }
`;

/**
 * __usePlmContractUpdateSubscription__
 *
 * To run a query within a React component, call `usePlmContractUpdateSubscription` and pass it any options that fit your needs.
 * When your component renders, `usePlmContractUpdateSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePlmContractUpdateSubscription({
 *   variables: {
 *      _id: // value for '_id'
 *   },
 * });
 */
export function usePlmContractUpdateSubscription(
  baseOptions?: Apollo.SubscriptionHookOptions<
    PlmContractUpdateSubscription,
    PlmContractUpdateSubscriptionVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useSubscription<
    PlmContractUpdateSubscription,
    PlmContractUpdateSubscriptionVariables
  >(PlmContractUpdateDocument, options);
}
export type PlmContractUpdateSubscriptionHookResult = ReturnType<
  typeof usePlmContractUpdateSubscription
>;
export type PlmContractUpdateSubscriptionResult =
  Apollo.SubscriptionResult<PlmContractUpdateSubscription>;
export const PlmContractUserOptionsDocument = gql`
  query PlmContractUserOptions {
    users(limit: 0) {
      _id
      name
      email
      authorizationProfile {
        _id
        isSuper
        managerProperties
        installerProperties
        viewerProperties
        residentProperty
      }
    }
  }
`;

/**
 * __usePlmContractUserOptionsQuery__
 *
 * To run a query within a React component, call `usePlmContractUserOptionsQuery` and pass it any options that fit your needs.
 * When your component renders, `usePlmContractUserOptionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePlmContractUserOptionsQuery({
 *   variables: {
 *   },
 * });
 */
export function usePlmContractUserOptionsQuery(
  baseOptions?: Apollo.QueryHookOptions<
    PlmContractUserOptionsQuery,
    PlmContractUserOptionsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    PlmContractUserOptionsQuery,
    PlmContractUserOptionsQueryVariables
  >(PlmContractUserOptionsDocument, options);
}
export function usePlmContractUserOptionsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    PlmContractUserOptionsQuery,
    PlmContractUserOptionsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    PlmContractUserOptionsQuery,
    PlmContractUserOptionsQueryVariables
  >(PlmContractUserOptionsDocument, options);
}
export type PlmContractUserOptionsQueryHookResult = ReturnType<
  typeof usePlmContractUserOptionsQuery
>;
export type PlmContractUserOptionsLazyQueryHookResult = ReturnType<
  typeof usePlmContractUserOptionsLazyQuery
>;
export type PlmContractUserOptionsQueryResult = Apollo.QueryResult<
  PlmContractUserOptionsQuery,
  PlmContractUserOptionsQueryVariables
>;
export const PlmContractDocument = gql`
  query plmContract($_id: String) {
    plmContract(filter: { _id: $_id }) {
      _id
      contractId
      programId
      propertyIds
      properties {
        _id
        title
      }
      partnerId
      partner {
        _id
        name
      }
      dispatcherIds
      dispatchers {
        _id
        name
      }
      minimumReductionKW
      maximumEventsPerSeason
      baselineMethod
      incentiveDescription
      penaltyForNonCompliance
      status
      notificationEmail
    }
  }
`;

/**
 * __usePlmContractQuery__
 *
 * To run a query within a React component, call `usePlmContractQuery` and pass it any options that fit your needs.
 * When your component renders, `usePlmContractQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePlmContractQuery({
 *   variables: {
 *      _id: // value for '_id'
 *   },
 * });
 */
export function usePlmContractQuery(
  baseOptions?: Apollo.QueryHookOptions<
    PlmContractQuery,
    PlmContractQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<PlmContractQuery, PlmContractQueryVariables>(
    PlmContractDocument,
    options,
  );
}
export function usePlmContractLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    PlmContractQuery,
    PlmContractQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<PlmContractQuery, PlmContractQueryVariables>(
    PlmContractDocument,
    options,
  );
}
export type PlmContractQueryHookResult = ReturnType<typeof usePlmContractQuery>;
export type PlmContractLazyQueryHookResult = ReturnType<
  typeof usePlmContractLazyQuery
>;
export type PlmContractQueryResult = Apollo.QueryResult<
  PlmContractQuery,
  PlmContractQueryVariables
>;
export const PlmCurtailmentActionDetailDocument = gql`
  query PlmCurtailmentActionDetail($_id: String!) {
    plmCurtailmentActionById(_id: $_id) {
      _id
      name
      description
      deviceType
      estimatedReductionKW
      targetDevices
      plmCurtailmentPlanId
      startTimeOffset
      autoBatch
      batchCount
      batchDuration
      batchStartTimeOffset
      targetedAdjustments {
        type
        ... on ThermostatAdjustment {
          maxCoolSetpointLimit
          maxHeatSetpointLimit
          minCoolSetpointLimit
          minHeatSetpointLimit
          coolSetpoint
          coolSetpointAdjustmentMode
          heatSetpoint
          heatSetpointAdjustmentMode
          fanMode
          fanSpeed
          keypadLockoutLevel
          operatingMode
        }
        ... on SmartPowerOutletAdjustment {
          isOn
        }
        ... on ModbusAirHandlerAdjustment {
          freshAirSetpoint
          rhSetpoint
          ventilationMode
        }
      }
    }
  }
`;

/**
 * __usePlmCurtailmentActionDetailQuery__
 *
 * To run a query within a React component, call `usePlmCurtailmentActionDetailQuery` and pass it any options that fit your needs.
 * When your component renders, `usePlmCurtailmentActionDetailQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePlmCurtailmentActionDetailQuery({
 *   variables: {
 *      _id: // value for '_id'
 *   },
 * });
 */
export function usePlmCurtailmentActionDetailQuery(
  baseOptions: Apollo.QueryHookOptions<
    PlmCurtailmentActionDetailQuery,
    PlmCurtailmentActionDetailQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    PlmCurtailmentActionDetailQuery,
    PlmCurtailmentActionDetailQueryVariables
  >(PlmCurtailmentActionDetailDocument, options);
}
export function usePlmCurtailmentActionDetailLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    PlmCurtailmentActionDetailQuery,
    PlmCurtailmentActionDetailQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    PlmCurtailmentActionDetailQuery,
    PlmCurtailmentActionDetailQueryVariables
  >(PlmCurtailmentActionDetailDocument, options);
}
export type PlmCurtailmentActionDetailQueryHookResult = ReturnType<
  typeof usePlmCurtailmentActionDetailQuery
>;
export type PlmCurtailmentActionDetailLazyQueryHookResult = ReturnType<
  typeof usePlmCurtailmentActionDetailLazyQuery
>;
export type PlmCurtailmentActionDetailQueryResult = Apollo.QueryResult<
  PlmCurtailmentActionDetailQuery,
  PlmCurtailmentActionDetailQueryVariables
>;
export const CreatePlmCurtailmentActionDocument = gql`
  mutation CreatePlmCurtailmentAction(
    $action: PlmCurtailmentActionCreateInput!
  ) {
    createPlmCurtailmentAction(action: $action) {
      _id
      name
      description
      deviceType
      estimatedReductionKW
      targetDevices
      plmCurtailmentPlanId
      startTimeOffset
      autoBatch
      batchCount
      batchDuration
      batchStartTimeOffset
      targetedAdjustments {
        type
        ... on ThermostatAdjustment {
          coolSetpointAdjustmentMode
          heatSetpointAdjustmentMode
        }
      }
    }
  }
`;
export type CreatePlmCurtailmentActionMutationFn = Apollo.MutationFunction<
  CreatePlmCurtailmentActionMutation,
  CreatePlmCurtailmentActionMutationVariables
>;

/**
 * __useCreatePlmCurtailmentActionMutation__
 *
 * To run a mutation, you first call `useCreatePlmCurtailmentActionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreatePlmCurtailmentActionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createPlmCurtailmentActionMutation, { data, loading, error }] = useCreatePlmCurtailmentActionMutation({
 *   variables: {
 *      action: // value for 'action'
 *   },
 * });
 */
export function useCreatePlmCurtailmentActionMutation(
  baseOptions?: Apollo.MutationHookOptions<
    CreatePlmCurtailmentActionMutation,
    CreatePlmCurtailmentActionMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    CreatePlmCurtailmentActionMutation,
    CreatePlmCurtailmentActionMutationVariables
  >(CreatePlmCurtailmentActionDocument, options);
}
export type CreatePlmCurtailmentActionMutationHookResult = ReturnType<
  typeof useCreatePlmCurtailmentActionMutation
>;
export type CreatePlmCurtailmentActionMutationResult =
  Apollo.MutationResult<CreatePlmCurtailmentActionMutation>;
export type CreatePlmCurtailmentActionMutationOptions =
  Apollo.BaseMutationOptions<
    CreatePlmCurtailmentActionMutation,
    CreatePlmCurtailmentActionMutationVariables
  >;
export const UpdatePlmCurtailmentActionDocument = gql`
  mutation UpdatePlmCurtailmentAction(
    $_id: String!
    $action: PlmCurtailmentActionUpdateInput!
  ) {
    updatePlmCurtailmentAction(_id: $_id, action: $action) {
      _id
      name
      description
      deviceType
      estimatedReductionKW
      targetDevices
      plmCurtailmentPlanId
      startTimeOffset
      autoBatch
      batchCount
      batchDuration
      batchStartTimeOffset
      targetedAdjustments {
        type
        ... on ThermostatAdjustment {
          coolSetpointAdjustmentMode
          heatSetpointAdjustmentMode
        }
      }
    }
  }
`;
export type UpdatePlmCurtailmentActionMutationFn = Apollo.MutationFunction<
  UpdatePlmCurtailmentActionMutation,
  UpdatePlmCurtailmentActionMutationVariables
>;

/**
 * __useUpdatePlmCurtailmentActionMutation__
 *
 * To run a mutation, you first call `useUpdatePlmCurtailmentActionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdatePlmCurtailmentActionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updatePlmCurtailmentActionMutation, { data, loading, error }] = useUpdatePlmCurtailmentActionMutation({
 *   variables: {
 *      _id: // value for '_id'
 *      action: // value for 'action'
 *   },
 * });
 */
export function useUpdatePlmCurtailmentActionMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UpdatePlmCurtailmentActionMutation,
    UpdatePlmCurtailmentActionMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    UpdatePlmCurtailmentActionMutation,
    UpdatePlmCurtailmentActionMutationVariables
  >(UpdatePlmCurtailmentActionDocument, options);
}
export type UpdatePlmCurtailmentActionMutationHookResult = ReturnType<
  typeof useUpdatePlmCurtailmentActionMutation
>;
export type UpdatePlmCurtailmentActionMutationResult =
  Apollo.MutationResult<UpdatePlmCurtailmentActionMutation>;
export type UpdatePlmCurtailmentActionMutationOptions =
  Apollo.BaseMutationOptions<
    UpdatePlmCurtailmentActionMutation,
    UpdatePlmCurtailmentActionMutationVariables
  >;
export const RemovePlmCurtailmentActionDocument = gql`
  mutation RemovePlmCurtailmentAction($_id: String!) {
    removePlmCurtailmentAction(_id: $_id)
  }
`;
export type RemovePlmCurtailmentActionMutationFn = Apollo.MutationFunction<
  RemovePlmCurtailmentActionMutation,
  RemovePlmCurtailmentActionMutationVariables
>;

/**
 * __useRemovePlmCurtailmentActionMutation__
 *
 * To run a mutation, you first call `useRemovePlmCurtailmentActionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemovePlmCurtailmentActionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removePlmCurtailmentActionMutation, { data, loading, error }] = useRemovePlmCurtailmentActionMutation({
 *   variables: {
 *      _id: // value for '_id'
 *   },
 * });
 */
export function useRemovePlmCurtailmentActionMutation(
  baseOptions?: Apollo.MutationHookOptions<
    RemovePlmCurtailmentActionMutation,
    RemovePlmCurtailmentActionMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    RemovePlmCurtailmentActionMutation,
    RemovePlmCurtailmentActionMutationVariables
  >(RemovePlmCurtailmentActionDocument, options);
}
export type RemovePlmCurtailmentActionMutationHookResult = ReturnType<
  typeof useRemovePlmCurtailmentActionMutation
>;
export type RemovePlmCurtailmentActionMutationResult =
  Apollo.MutationResult<RemovePlmCurtailmentActionMutation>;
export type RemovePlmCurtailmentActionMutationOptions =
  Apollo.BaseMutationOptions<
    RemovePlmCurtailmentActionMutation,
    RemovePlmCurtailmentActionMutationVariables
  >;
export const PlmCurtailmentPlanEventsByIdsDocument = gql`
  subscription PlmCurtailmentPlanEventsByIds($_ids: [String!]!) {
    plmCurtailmentPlanEventsByIds(_ids: $_ids) {
      modelChangeOperation
      _id
      name
      description
      curtailmentActions {
        _id
        name
        description
        deviceType
        targetDevices
        estimatedReductionKW
        plmCurtailmentPlanId
        targetedAdjustments {
          type
          ... on ThermostatAdjustment {
            maxCoolSetpointLimit
            maxHeatSetpointLimit
            minCoolSetpointLimit
            minHeatSetpointLimit
            coolSetpoint
            coolSetpointAdjustmentMode
            heatSetpoint
            heatSetpointAdjustmentMode
            fanMode
            fanSpeed
            keypadLockoutLevel
            operatingMode
          }
          ... on SmartPowerOutletAdjustment {
            isOn
          }
          ... on ModbusAirHandlerAdjustment {
            freshAirSetpoint
            rhSetpoint
            ventilationMode
          }
        }
      }
    }
  }
`;

/**
 * __usePlmCurtailmentPlanEventsByIdsSubscription__
 *
 * To run a query within a React component, call `usePlmCurtailmentPlanEventsByIdsSubscription` and pass it any options that fit your needs.
 * When your component renders, `usePlmCurtailmentPlanEventsByIdsSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePlmCurtailmentPlanEventsByIdsSubscription({
 *   variables: {
 *      _ids: // value for '_ids'
 *   },
 * });
 */
export function usePlmCurtailmentPlanEventsByIdsSubscription(
  baseOptions: Apollo.SubscriptionHookOptions<
    PlmCurtailmentPlanEventsByIdsSubscription,
    PlmCurtailmentPlanEventsByIdsSubscriptionVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useSubscription<
    PlmCurtailmentPlanEventsByIdsSubscription,
    PlmCurtailmentPlanEventsByIdsSubscriptionVariables
  >(PlmCurtailmentPlanEventsByIdsDocument, options);
}
export type PlmCurtailmentPlanEventsByIdsSubscriptionHookResult = ReturnType<
  typeof usePlmCurtailmentPlanEventsByIdsSubscription
>;
export type PlmCurtailmentPlanEventsByIdsSubscriptionResult =
  Apollo.SubscriptionResult<PlmCurtailmentPlanEventsByIdsSubscription>;
export const PlmCurtailmentPlanDetailDocument = gql`
  query PlmCurtailmentPlanDetail($_id: String!) {
    plmCurtailmentPlanById(_id: $_id) {
      _id
      name
      description
      estimatedReductionKW
      durationMinutes
      applicableSeasons
      organizationId
      organization {
        _id
        name
      }
      curtailmentActions {
        _id
        name
        description
        deviceType
        targetDevices
        estimatedReductionKW
        plmCurtailmentPlanId
        targetedAdjustments {
          type
          ... on ThermostatAdjustment {
            maxCoolSetpointLimit
            maxHeatSetpointLimit
            minCoolSetpointLimit
            minHeatSetpointLimit
            coolSetpoint
            coolSetpointAdjustmentMode
            heatSetpoint
            heatSetpointAdjustmentMode
            fanMode
            fanSpeed
            keypadLockoutLevel
            operatingMode
          }
          ... on SmartPowerOutletAdjustment {
            isOn
          }
          ... on ModbusAirHandlerAdjustment {
            freshAirSetpoint
            rhSetpoint
            ventilationMode
          }
        }
      }
    }
  }
`;

/**
 * __usePlmCurtailmentPlanDetailQuery__
 *
 * To run a query within a React component, call `usePlmCurtailmentPlanDetailQuery` and pass it any options that fit your needs.
 * When your component renders, `usePlmCurtailmentPlanDetailQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePlmCurtailmentPlanDetailQuery({
 *   variables: {
 *      _id: // value for '_id'
 *   },
 * });
 */
export function usePlmCurtailmentPlanDetailQuery(
  baseOptions: Apollo.QueryHookOptions<
    PlmCurtailmentPlanDetailQuery,
    PlmCurtailmentPlanDetailQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    PlmCurtailmentPlanDetailQuery,
    PlmCurtailmentPlanDetailQueryVariables
  >(PlmCurtailmentPlanDetailDocument, options);
}
export function usePlmCurtailmentPlanDetailLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    PlmCurtailmentPlanDetailQuery,
    PlmCurtailmentPlanDetailQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    PlmCurtailmentPlanDetailQuery,
    PlmCurtailmentPlanDetailQueryVariables
  >(PlmCurtailmentPlanDetailDocument, options);
}
export type PlmCurtailmentPlanDetailQueryHookResult = ReturnType<
  typeof usePlmCurtailmentPlanDetailQuery
>;
export type PlmCurtailmentPlanDetailLazyQueryHookResult = ReturnType<
  typeof usePlmCurtailmentPlanDetailLazyQuery
>;
export type PlmCurtailmentPlanDetailQueryResult = Apollo.QueryResult<
  PlmCurtailmentPlanDetailQuery,
  PlmCurtailmentPlanDetailQueryVariables
>;
export const PlmCurtailmentPlanListUpdateDocument = gql`
  subscription PlmCurtailmentPlanListUpdate {
    plmCurtailmentPlanEvents {
      modelChangeOperation
      _id
      name
      description
      estimatedReductionKW
      durationMinutes
      applicableSeasons
      organizationId
      organization {
        _id
        name
      }
      curtailmentActions {
        modelChangeOperation
        _id
        name
        description
        deviceType
        estimatedReductionKW
        targetDevices
        plmCurtailmentPlanId
        targetedAdjustments {
          type
          ... on ThermostatAdjustment {
            maxCoolSetpointLimit
            maxHeatSetpointLimit
            minCoolSetpointLimit
            minHeatSetpointLimit
            coolSetpoint
            coolSetpointAdjustmentMode
            heatSetpoint
            heatSetpointAdjustmentMode
            fanMode
            fanSpeed
            keypadLockoutLevel
            operatingMode
          }
          ... on SmartPowerOutletAdjustment {
            isOn
          }
          ... on ModbusAirHandlerAdjustment {
            freshAirSetpoint
            rhSetpoint
            ventilationMode
          }
        }
      }
    }
  }
`;

/**
 * __usePlmCurtailmentPlanListUpdateSubscription__
 *
 * To run a query within a React component, call `usePlmCurtailmentPlanListUpdateSubscription` and pass it any options that fit your needs.
 * When your component renders, `usePlmCurtailmentPlanListUpdateSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePlmCurtailmentPlanListUpdateSubscription({
 *   variables: {
 *   },
 * });
 */
export function usePlmCurtailmentPlanListUpdateSubscription(
  baseOptions?: Apollo.SubscriptionHookOptions<
    PlmCurtailmentPlanListUpdateSubscription,
    PlmCurtailmentPlanListUpdateSubscriptionVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useSubscription<
    PlmCurtailmentPlanListUpdateSubscription,
    PlmCurtailmentPlanListUpdateSubscriptionVariables
  >(PlmCurtailmentPlanListUpdateDocument, options);
}
export type PlmCurtailmentPlanListUpdateSubscriptionHookResult = ReturnType<
  typeof usePlmCurtailmentPlanListUpdateSubscription
>;
export type PlmCurtailmentPlanListUpdateSubscriptionResult =
  Apollo.SubscriptionResult<PlmCurtailmentPlanListUpdateSubscription>;
export const PlmCurtailmentPlanListDocument = gql`
  query PlmCurtailmentPlanList {
    plmCurtailmentPlans {
      _id
      name
      description
      estimatedReductionKW
      durationMinutes
      applicableSeasons
      organizationId
      organization {
        _id
        name
      }
      curtailmentActions {
        _id
        name
        description
        deviceType
        estimatedReductionKW
        targetDevices
        plmCurtailmentPlanId
        targetedAdjustments {
          type
          ... on ThermostatAdjustment {
            maxCoolSetpointLimit
            maxHeatSetpointLimit
            minCoolSetpointLimit
            minHeatSetpointLimit
            coolSetpoint
            coolSetpointAdjustmentMode
            heatSetpoint
            heatSetpointAdjustmentMode
            fanMode
            fanSpeed
            keypadLockoutLevel
            operatingMode
          }
          ... on SmartPowerOutletAdjustment {
            isOn
          }
          ... on ModbusAirHandlerAdjustment {
            freshAirSetpoint
            rhSetpoint
            ventilationMode
          }
        }
      }
    }
  }
`;

/**
 * __usePlmCurtailmentPlanListQuery__
 *
 * To run a query within a React component, call `usePlmCurtailmentPlanListQuery` and pass it any options that fit your needs.
 * When your component renders, `usePlmCurtailmentPlanListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePlmCurtailmentPlanListQuery({
 *   variables: {
 *   },
 * });
 */
export function usePlmCurtailmentPlanListQuery(
  baseOptions?: Apollo.QueryHookOptions<
    PlmCurtailmentPlanListQuery,
    PlmCurtailmentPlanListQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    PlmCurtailmentPlanListQuery,
    PlmCurtailmentPlanListQueryVariables
  >(PlmCurtailmentPlanListDocument, options);
}
export function usePlmCurtailmentPlanListLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    PlmCurtailmentPlanListQuery,
    PlmCurtailmentPlanListQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    PlmCurtailmentPlanListQuery,
    PlmCurtailmentPlanListQueryVariables
  >(PlmCurtailmentPlanListDocument, options);
}
export type PlmCurtailmentPlanListQueryHookResult = ReturnType<
  typeof usePlmCurtailmentPlanListQuery
>;
export type PlmCurtailmentPlanListLazyQueryHookResult = ReturnType<
  typeof usePlmCurtailmentPlanListLazyQuery
>;
export type PlmCurtailmentPlanListQueryResult = Apollo.QueryResult<
  PlmCurtailmentPlanListQuery,
  PlmCurtailmentPlanListQueryVariables
>;
export const CreatePlmCurtailmentPlanDocument = gql`
  mutation CreatePlmCurtailmentPlan($plan: CreateOnePlmCurtailmentPlanInput!) {
    createPlmCurtailmentPlan(plan: $plan) {
      _id
      name
      description
      estimatedReductionKW
      durationMinutes
      applicableSeasons
      organizationId
      organization {
        _id
        name
      }
    }
  }
`;
export type CreatePlmCurtailmentPlanMutationFn = Apollo.MutationFunction<
  CreatePlmCurtailmentPlanMutation,
  CreatePlmCurtailmentPlanMutationVariables
>;

/**
 * __useCreatePlmCurtailmentPlanMutation__
 *
 * To run a mutation, you first call `useCreatePlmCurtailmentPlanMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreatePlmCurtailmentPlanMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createPlmCurtailmentPlanMutation, { data, loading, error }] = useCreatePlmCurtailmentPlanMutation({
 *   variables: {
 *      plan: // value for 'plan'
 *   },
 * });
 */
export function useCreatePlmCurtailmentPlanMutation(
  baseOptions?: Apollo.MutationHookOptions<
    CreatePlmCurtailmentPlanMutation,
    CreatePlmCurtailmentPlanMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    CreatePlmCurtailmentPlanMutation,
    CreatePlmCurtailmentPlanMutationVariables
  >(CreatePlmCurtailmentPlanDocument, options);
}
export type CreatePlmCurtailmentPlanMutationHookResult = ReturnType<
  typeof useCreatePlmCurtailmentPlanMutation
>;
export type CreatePlmCurtailmentPlanMutationResult =
  Apollo.MutationResult<CreatePlmCurtailmentPlanMutation>;
export type CreatePlmCurtailmentPlanMutationOptions =
  Apollo.BaseMutationOptions<
    CreatePlmCurtailmentPlanMutation,
    CreatePlmCurtailmentPlanMutationVariables
  >;
export const UpdatePlmCurtailmentPlanDocument = gql`
  mutation UpdatePlmCurtailmentPlan(
    $_id: String!
    $plan: UpdateOnePlmCurtailmentPlanInput!
  ) {
    updatePlmCurtailmentPlan(_id: $_id, plan: $plan) {
      _id
      name
      description
      estimatedReductionKW
      durationMinutes
      applicableSeasons
      organizationId
      organization {
        _id
        name
      }
    }
  }
`;
export type UpdatePlmCurtailmentPlanMutationFn = Apollo.MutationFunction<
  UpdatePlmCurtailmentPlanMutation,
  UpdatePlmCurtailmentPlanMutationVariables
>;

/**
 * __useUpdatePlmCurtailmentPlanMutation__
 *
 * To run a mutation, you first call `useUpdatePlmCurtailmentPlanMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdatePlmCurtailmentPlanMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updatePlmCurtailmentPlanMutation, { data, loading, error }] = useUpdatePlmCurtailmentPlanMutation({
 *   variables: {
 *      _id: // value for '_id'
 *      plan: // value for 'plan'
 *   },
 * });
 */
export function useUpdatePlmCurtailmentPlanMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UpdatePlmCurtailmentPlanMutation,
    UpdatePlmCurtailmentPlanMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    UpdatePlmCurtailmentPlanMutation,
    UpdatePlmCurtailmentPlanMutationVariables
  >(UpdatePlmCurtailmentPlanDocument, options);
}
export type UpdatePlmCurtailmentPlanMutationHookResult = ReturnType<
  typeof useUpdatePlmCurtailmentPlanMutation
>;
export type UpdatePlmCurtailmentPlanMutationResult =
  Apollo.MutationResult<UpdatePlmCurtailmentPlanMutation>;
export type UpdatePlmCurtailmentPlanMutationOptions =
  Apollo.BaseMutationOptions<
    UpdatePlmCurtailmentPlanMutation,
    UpdatePlmCurtailmentPlanMutationVariables
  >;
export const RemovePlmCurtailmentPlanDocument = gql`
  mutation RemovePlmCurtailmentPlan($_id: String!) {
    removePlmCurtailmentPlan(_id: $_id)
  }
`;
export type RemovePlmCurtailmentPlanMutationFn = Apollo.MutationFunction<
  RemovePlmCurtailmentPlanMutation,
  RemovePlmCurtailmentPlanMutationVariables
>;

/**
 * __useRemovePlmCurtailmentPlanMutation__
 *
 * To run a mutation, you first call `useRemovePlmCurtailmentPlanMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemovePlmCurtailmentPlanMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removePlmCurtailmentPlanMutation, { data, loading, error }] = useRemovePlmCurtailmentPlanMutation({
 *   variables: {
 *      _id: // value for '_id'
 *   },
 * });
 */
export function useRemovePlmCurtailmentPlanMutation(
  baseOptions?: Apollo.MutationHookOptions<
    RemovePlmCurtailmentPlanMutation,
    RemovePlmCurtailmentPlanMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    RemovePlmCurtailmentPlanMutation,
    RemovePlmCurtailmentPlanMutationVariables
  >(RemovePlmCurtailmentPlanDocument, options);
}
export type RemovePlmCurtailmentPlanMutationHookResult = ReturnType<
  typeof useRemovePlmCurtailmentPlanMutation
>;
export type RemovePlmCurtailmentPlanMutationResult =
  Apollo.MutationResult<RemovePlmCurtailmentPlanMutation>;
export type RemovePlmCurtailmentPlanMutationOptions =
  Apollo.BaseMutationOptions<
    RemovePlmCurtailmentPlanMutation,
    RemovePlmCurtailmentPlanMutationVariables
  >;
export const AbortPlmCurtailmentTaskDocument = gql`
  mutation AbortPlmCurtailmentTask($deviceId: String!, $cancelAll: Boolean) {
    abortPlmCurtailmentTask(deviceId: $deviceId, cancelAll: $cancelAll)
  }
`;
export type AbortPlmCurtailmentTaskMutationFn = Apollo.MutationFunction<
  AbortPlmCurtailmentTaskMutation,
  AbortPlmCurtailmentTaskMutationVariables
>;

/**
 * __useAbortPlmCurtailmentTaskMutation__
 *
 * To run a mutation, you first call `useAbortPlmCurtailmentTaskMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAbortPlmCurtailmentTaskMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [abortPlmCurtailmentTaskMutation, { data, loading, error }] = useAbortPlmCurtailmentTaskMutation({
 *   variables: {
 *      deviceId: // value for 'deviceId'
 *      cancelAll: // value for 'cancelAll'
 *   },
 * });
 */
export function useAbortPlmCurtailmentTaskMutation(
  baseOptions?: Apollo.MutationHookOptions<
    AbortPlmCurtailmentTaskMutation,
    AbortPlmCurtailmentTaskMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    AbortPlmCurtailmentTaskMutation,
    AbortPlmCurtailmentTaskMutationVariables
  >(AbortPlmCurtailmentTaskDocument, options);
}
export type AbortPlmCurtailmentTaskMutationHookResult = ReturnType<
  typeof useAbortPlmCurtailmentTaskMutation
>;
export type AbortPlmCurtailmentTaskMutationResult =
  Apollo.MutationResult<AbortPlmCurtailmentTaskMutation>;
export type AbortPlmCurtailmentTaskMutationOptions = Apollo.BaseMutationOptions<
  AbortPlmCurtailmentTaskMutation,
  AbortPlmCurtailmentTaskMutationVariables
>;
export const GetPlmCurtailmentTasksForDeviceDocument = gql`
  query GetPlmCurtailmentTasksForDevice($deviceId: String!) {
    plmCurtailmentTasksForDevice(deviceId: $deviceId) {
      _id
      plmCurtailmentActionId
      plmEventResponseId
      batchId
      propertyId
      unitId
      deviceId
      deviceType
      scheduledStart
      scheduledEnd
      startedAt
      verifiedAt
      verifyAttempts
      endedAt
      status
      statusMessage
      estimatedReductionKW
    }
  }
`;

/**
 * __useGetPlmCurtailmentTasksForDeviceQuery__
 *
 * To run a query within a React component, call `useGetPlmCurtailmentTasksForDeviceQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPlmCurtailmentTasksForDeviceQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPlmCurtailmentTasksForDeviceQuery({
 *   variables: {
 *      deviceId: // value for 'deviceId'
 *   },
 * });
 */
export function useGetPlmCurtailmentTasksForDeviceQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetPlmCurtailmentTasksForDeviceQuery,
    GetPlmCurtailmentTasksForDeviceQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetPlmCurtailmentTasksForDeviceQuery,
    GetPlmCurtailmentTasksForDeviceQueryVariables
  >(GetPlmCurtailmentTasksForDeviceDocument, options);
}
export function useGetPlmCurtailmentTasksForDeviceLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetPlmCurtailmentTasksForDeviceQuery,
    GetPlmCurtailmentTasksForDeviceQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetPlmCurtailmentTasksForDeviceQuery,
    GetPlmCurtailmentTasksForDeviceQueryVariables
  >(GetPlmCurtailmentTasksForDeviceDocument, options);
}
export type GetPlmCurtailmentTasksForDeviceQueryHookResult = ReturnType<
  typeof useGetPlmCurtailmentTasksForDeviceQuery
>;
export type GetPlmCurtailmentTasksForDeviceLazyQueryHookResult = ReturnType<
  typeof useGetPlmCurtailmentTasksForDeviceLazyQuery
>;
export type GetPlmCurtailmentTasksForDeviceQueryResult = Apollo.QueryResult<
  GetPlmCurtailmentTasksForDeviceQuery,
  GetPlmCurtailmentTasksForDeviceQueryVariables
>;
export const GetPlmCurtailmentTasksByResponseIdSubDocument = gql`
  subscription GetPlmCurtailmentTasksByResponseIdSub(
    $plmEventResponseId: String!
  ) {
    plmCurtailmentTasksByResponseIdEvents(
      plmEventResponseId: $plmEventResponseId
      sort: DEVICEID__PLMCURTAILMENTACTIONID__PLMEVENTRESPONSEID__BATCHID_ASC
    ) {
      modelChangeOperation
      _id
      plmCurtailmentActionId
      plmEventResponseId
      batchId
      propertyId
      unitId
      deviceId
      deviceType
      scheduledStart
      scheduledEnd
      startedAt
      verifiedAt
      verifyAttempts
      endedAt
      status
      statusMessage
      estimatedReductionKW
      device {
        _id
        name
        deviceId
        typeDisplayName
        unit {
          _id
          name
        }
      }
      cachedDeviceState {
        type
        coolSetpoint
        heatSetpoint
        isOn
        operatingMode
        fanMode
      }
      targetedAdjustments {
        type
        coolSetpoint
        heatSetpoint
        isOn
        operatingMode
        fanMode
      }
    }
  }
`;

/**
 * __useGetPlmCurtailmentTasksByResponseIdSubSubscription__
 *
 * To run a query within a React component, call `useGetPlmCurtailmentTasksByResponseIdSubSubscription` and pass it any options that fit your needs.
 * When your component renders, `useGetPlmCurtailmentTasksByResponseIdSubSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPlmCurtailmentTasksByResponseIdSubSubscription({
 *   variables: {
 *      plmEventResponseId: // value for 'plmEventResponseId'
 *   },
 * });
 */
export function useGetPlmCurtailmentTasksByResponseIdSubSubscription(
  baseOptions: Apollo.SubscriptionHookOptions<
    GetPlmCurtailmentTasksByResponseIdSubSubscription,
    GetPlmCurtailmentTasksByResponseIdSubSubscriptionVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useSubscription<
    GetPlmCurtailmentTasksByResponseIdSubSubscription,
    GetPlmCurtailmentTasksByResponseIdSubSubscriptionVariables
  >(GetPlmCurtailmentTasksByResponseIdSubDocument, options);
}
export type GetPlmCurtailmentTasksByResponseIdSubSubscriptionHookResult =
  ReturnType<typeof useGetPlmCurtailmentTasksByResponseIdSubSubscription>;
export type GetPlmCurtailmentTasksByResponseIdSubSubscriptionResult =
  Apollo.SubscriptionResult<GetPlmCurtailmentTasksByResponseIdSubSubscription>;
export const GetPlmCurtailmentTasksByResponseIdDocument = gql`
  query GetPlmCurtailmentTasksByResponseId($plmEventResponseId: String!) {
    plmCurtailmentTasksByResponseId(
      plmEventResponseId: $plmEventResponseId
      sort: DEVICEID__PLMCURTAILMENTACTIONID__PLMEVENTRESPONSEID__BATCHID_ASC
    ) {
      _id
      plmCurtailmentActionId
      plmEventResponseId
      batchId
      propertyId
      unitId
      deviceId
      deviceType
      scheduledStart
      scheduledEnd
      startedAt
      verifiedAt
      verifyAttempts
      endedAt
      status
      statusMessage
      estimatedReductionKW
      device {
        _id
        name
        deviceId
        typeDisplayName
        unit {
          _id
          name
        }
      }
      cachedDeviceState {
        type
        coolSetpoint
        heatSetpoint
        isOn
        operatingMode
        fanMode
      }
      targetedAdjustments {
        type
        coolSetpoint
        heatSetpoint
        isOn
        operatingMode
        fanMode
      }
    }
  }
`;

/**
 * __useGetPlmCurtailmentTasksByResponseIdQuery__
 *
 * To run a query within a React component, call `useGetPlmCurtailmentTasksByResponseIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPlmCurtailmentTasksByResponseIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPlmCurtailmentTasksByResponseIdQuery({
 *   variables: {
 *      plmEventResponseId: // value for 'plmEventResponseId'
 *   },
 * });
 */
export function useGetPlmCurtailmentTasksByResponseIdQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetPlmCurtailmentTasksByResponseIdQuery,
    GetPlmCurtailmentTasksByResponseIdQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetPlmCurtailmentTasksByResponseIdQuery,
    GetPlmCurtailmentTasksByResponseIdQueryVariables
  >(GetPlmCurtailmentTasksByResponseIdDocument, options);
}
export function useGetPlmCurtailmentTasksByResponseIdLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetPlmCurtailmentTasksByResponseIdQuery,
    GetPlmCurtailmentTasksByResponseIdQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetPlmCurtailmentTasksByResponseIdQuery,
    GetPlmCurtailmentTasksByResponseIdQueryVariables
  >(GetPlmCurtailmentTasksByResponseIdDocument, options);
}
export type GetPlmCurtailmentTasksByResponseIdQueryHookResult = ReturnType<
  typeof useGetPlmCurtailmentTasksByResponseIdQuery
>;
export type GetPlmCurtailmentTasksByResponseIdLazyQueryHookResult = ReturnType<
  typeof useGetPlmCurtailmentTasksByResponseIdLazyQuery
>;
export type GetPlmCurtailmentTasksByResponseIdQueryResult = Apollo.QueryResult<
  GetPlmCurtailmentTasksByResponseIdQuery,
  GetPlmCurtailmentTasksByResponseIdQueryVariables
>;
export const PlmCurtailmentTasksByPropertyDocument = gql`
  query PlmCurtailmentTasksByProperty($propertyId: String!) {
    plmCurtailmentTasksByProperty(propertyId: $propertyId) {
      _id
      plmCurtailmentActionId
      plmEventResponseId
      batchId
      propertyId
      unitId
      deviceId
      deviceType
      scheduledStart
      scheduledEnd
      startedAt
      verifiedAt
      verifyAttempts
      endedAt
      status
      statusMessage
      estimatedReductionKW
    }
  }
`;

/**
 * __usePlmCurtailmentTasksByPropertyQuery__
 *
 * To run a query within a React component, call `usePlmCurtailmentTasksByPropertyQuery` and pass it any options that fit your needs.
 * When your component renders, `usePlmCurtailmentTasksByPropertyQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePlmCurtailmentTasksByPropertyQuery({
 *   variables: {
 *      propertyId: // value for 'propertyId'
 *   },
 * });
 */
export function usePlmCurtailmentTasksByPropertyQuery(
  baseOptions: Apollo.QueryHookOptions<
    PlmCurtailmentTasksByPropertyQuery,
    PlmCurtailmentTasksByPropertyQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    PlmCurtailmentTasksByPropertyQuery,
    PlmCurtailmentTasksByPropertyQueryVariables
  >(PlmCurtailmentTasksByPropertyDocument, options);
}
export function usePlmCurtailmentTasksByPropertyLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    PlmCurtailmentTasksByPropertyQuery,
    PlmCurtailmentTasksByPropertyQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    PlmCurtailmentTasksByPropertyQuery,
    PlmCurtailmentTasksByPropertyQueryVariables
  >(PlmCurtailmentTasksByPropertyDocument, options);
}
export type PlmCurtailmentTasksByPropertyQueryHookResult = ReturnType<
  typeof usePlmCurtailmentTasksByPropertyQuery
>;
export type PlmCurtailmentTasksByPropertyLazyQueryHookResult = ReturnType<
  typeof usePlmCurtailmentTasksByPropertyLazyQuery
>;
export type PlmCurtailmentTasksByPropertyQueryResult = Apollo.QueryResult<
  PlmCurtailmentTasksByPropertyQuery,
  PlmCurtailmentTasksByPropertyQueryVariables
>;
export const PlmCurtailmentTasksByPropertyIdSubscriptionDocument = gql`
  subscription PlmCurtailmentTasksByPropertyIdSubscription(
    $propertyId: String!
  ) {
    plmCurtailmentTasksByPropertyIdEvents(propertyId: $propertyId) {
      modelChangeOperation
      _id
      plmCurtailmentActionId
      plmEventResponseId
      batchId
      propertyId
      unitId
      deviceId
      deviceType
      scheduledStart
      scheduledEnd
      startedAt
      verifiedAt
      verifyAttempts
      endedAt
      status
      statusMessage
      estimatedReductionKW
    }
  }
`;

/**
 * __usePlmCurtailmentTasksByPropertyIdSubscriptionSubscription__
 *
 * To run a query within a React component, call `usePlmCurtailmentTasksByPropertyIdSubscriptionSubscription` and pass it any options that fit your needs.
 * When your component renders, `usePlmCurtailmentTasksByPropertyIdSubscriptionSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePlmCurtailmentTasksByPropertyIdSubscriptionSubscription({
 *   variables: {
 *      propertyId: // value for 'propertyId'
 *   },
 * });
 */
export function usePlmCurtailmentTasksByPropertyIdSubscriptionSubscription(
  baseOptions: Apollo.SubscriptionHookOptions<
    PlmCurtailmentTasksByPropertyIdSubscriptionSubscription,
    PlmCurtailmentTasksByPropertyIdSubscriptionSubscriptionVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useSubscription<
    PlmCurtailmentTasksByPropertyIdSubscriptionSubscription,
    PlmCurtailmentTasksByPropertyIdSubscriptionSubscriptionVariables
  >(PlmCurtailmentTasksByPropertyIdSubscriptionDocument, options);
}
export type PlmCurtailmentTasksByPropertyIdSubscriptionSubscriptionHookResult =
  ReturnType<typeof usePlmCurtailmentTasksByPropertyIdSubscriptionSubscription>;
export type PlmCurtailmentTasksByPropertyIdSubscriptionSubscriptionResult =
  Apollo.SubscriptionResult<PlmCurtailmentTasksByPropertyIdSubscriptionSubscription>;
export const PlmEventEventsByIdsDocument = gql`
  subscription PlmEventEventsByIds($_ids: [String!]!) {
    plmEventEventsByIds(_ids: $_ids) {
      modelChangeOperation
      _id
      programId
      contractId
      startTime
      duration
      reductionTarget
      status
      createdAt
      updatedAt
      notificationMethod
      notificationReceivedAt
      notificationPayload
      program {
        _id
        name
      }
      contract {
        _id
        name
      }
    }
  }
`;

/**
 * __usePlmEventEventsByIdsSubscription__
 *
 * To run a query within a React component, call `usePlmEventEventsByIdsSubscription` and pass it any options that fit your needs.
 * When your component renders, `usePlmEventEventsByIdsSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePlmEventEventsByIdsSubscription({
 *   variables: {
 *      _ids: // value for '_ids'
 *   },
 * });
 */
export function usePlmEventEventsByIdsSubscription(
  baseOptions: Apollo.SubscriptionHookOptions<
    PlmEventEventsByIdsSubscription,
    PlmEventEventsByIdsSubscriptionVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useSubscription<
    PlmEventEventsByIdsSubscription,
    PlmEventEventsByIdsSubscriptionVariables
  >(PlmEventEventsByIdsDocument, options);
}
export type PlmEventEventsByIdsSubscriptionHookResult = ReturnType<
  typeof usePlmEventEventsByIdsSubscription
>;
export type PlmEventEventsByIdsSubscriptionResult =
  Apollo.SubscriptionResult<PlmEventEventsByIdsSubscription>;
export const PlmEventByIdDocument = gql`
  query PlmEventById($_id: String!) {
    plmEventById(_id: $_id) {
      _id
      programId
      contractId
      startTime
      duration
      reductionTarget
      status
      createdAt
      updatedAt
      notificationMethod
      notificationReceivedAt
      notificationPayload
      program {
        _id
        name
      }
      contract {
        _id
        name
      }
      responses {
        _id
        eventId
        curtailmentPlanId
        scheduledStart
        scheduledEnd
        actualStart
        actualEnd
        responseSentAt
        responseStatus
        createdAt
        updatedAt
        curtailmentPlan {
          _id
          name
        }
        event {
          _id
          program {
            _id
            name
          }
        }
      }
    }
  }
`;

/**
 * __usePlmEventByIdQuery__
 *
 * To run a query within a React component, call `usePlmEventByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `usePlmEventByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePlmEventByIdQuery({
 *   variables: {
 *      _id: // value for '_id'
 *   },
 * });
 */
export function usePlmEventByIdQuery(
  baseOptions: Apollo.QueryHookOptions<
    PlmEventByIdQuery,
    PlmEventByIdQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<PlmEventByIdQuery, PlmEventByIdQueryVariables>(
    PlmEventByIdDocument,
    options,
  );
}
export function usePlmEventByIdLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    PlmEventByIdQuery,
    PlmEventByIdQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<PlmEventByIdQuery, PlmEventByIdQueryVariables>(
    PlmEventByIdDocument,
    options,
  );
}
export type PlmEventByIdQueryHookResult = ReturnType<
  typeof usePlmEventByIdQuery
>;
export type PlmEventByIdLazyQueryHookResult = ReturnType<
  typeof usePlmEventByIdLazyQuery
>;
export type PlmEventByIdQueryResult = Apollo.QueryResult<
  PlmEventByIdQuery,
  PlmEventByIdQueryVariables
>;
export const PlmEventEventsDocument = gql`
  subscription PlmEventEvents {
    plmEventEvents {
      modelChangeOperation
      _id
      programId
      contractId
      startTime
      duration
      reductionTarget
      status
      createdAt
      updatedAt
      notificationMethod
      notificationReceivedAt
      notificationPayload
      program {
        _id
        name
      }
      contract {
        _id
        name
      }
    }
  }
`;

/**
 * __usePlmEventEventsSubscription__
 *
 * To run a query within a React component, call `usePlmEventEventsSubscription` and pass it any options that fit your needs.
 * When your component renders, `usePlmEventEventsSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePlmEventEventsSubscription({
 *   variables: {
 *   },
 * });
 */
export function usePlmEventEventsSubscription(
  baseOptions?: Apollo.SubscriptionHookOptions<
    PlmEventEventsSubscription,
    PlmEventEventsSubscriptionVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useSubscription<
    PlmEventEventsSubscription,
    PlmEventEventsSubscriptionVariables
  >(PlmEventEventsDocument, options);
}
export type PlmEventEventsSubscriptionHookResult = ReturnType<
  typeof usePlmEventEventsSubscription
>;
export type PlmEventEventsSubscriptionResult =
  Apollo.SubscriptionResult<PlmEventEventsSubscription>;
export const PlmEventsDocument = gql`
  query PlmEvents(
    $filter: FilterFindManyPlmEventInput
    $sort: SortFindManyPlmEventInput
    $page: Int
    $perPage: Int
  ) {
    paginatedPlmEvents(
      filter: $filter
      sort: $sort
      page: $page
      perPage: $perPage
    ) {
      items {
        _id
        programId
        contractId
        startTime
        duration
        reductionTarget
        status
        createdAt
        updatedAt
        notificationMethod
        notificationReceivedAt
        notificationPayload
        program {
          _id
          name
        }
        contract {
          _id
          name
        }
      }
      pageInfo {
        currentPage
        perPage
        pageCount
        itemCount
        hasNextPage
        hasPreviousPage
      }
    }
  }
`;

/**
 * __usePlmEventsQuery__
 *
 * To run a query within a React component, call `usePlmEventsQuery` and pass it any options that fit your needs.
 * When your component renders, `usePlmEventsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePlmEventsQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *      sort: // value for 'sort'
 *      page: // value for 'page'
 *      perPage: // value for 'perPage'
 *   },
 * });
 */
export function usePlmEventsQuery(
  baseOptions?: Apollo.QueryHookOptions<
    PlmEventsQuery,
    PlmEventsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<PlmEventsQuery, PlmEventsQueryVariables>(
    PlmEventsDocument,
    options,
  );
}
export function usePlmEventsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    PlmEventsQuery,
    PlmEventsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<PlmEventsQuery, PlmEventsQueryVariables>(
    PlmEventsDocument,
    options,
  );
}
export type PlmEventsQueryHookResult = ReturnType<typeof usePlmEventsQuery>;
export type PlmEventsLazyQueryHookResult = ReturnType<
  typeof usePlmEventsLazyQuery
>;
export type PlmEventsQueryResult = Apollo.QueryResult<
  PlmEventsQuery,
  PlmEventsQueryVariables
>;
export const CreatePlmEventDocument = gql`
  mutation CreatePlmEvent($record: CreateOnePlmEventInput!) {
    createPlmEvent(record: $record) {
      _id
      programId
      contractId
      startTime
      duration
      reductionTarget
      status
      createdAt
      updatedAt
      notificationMethod
      notificationReceivedAt
      notificationPayload
      program {
        _id
        name
      }
      contract {
        _id
        name
      }
    }
  }
`;
export type CreatePlmEventMutationFn = Apollo.MutationFunction<
  CreatePlmEventMutation,
  CreatePlmEventMutationVariables
>;

/**
 * __useCreatePlmEventMutation__
 *
 * To run a mutation, you first call `useCreatePlmEventMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreatePlmEventMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createPlmEventMutation, { data, loading, error }] = useCreatePlmEventMutation({
 *   variables: {
 *      record: // value for 'record'
 *   },
 * });
 */
export function useCreatePlmEventMutation(
  baseOptions?: Apollo.MutationHookOptions<
    CreatePlmEventMutation,
    CreatePlmEventMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    CreatePlmEventMutation,
    CreatePlmEventMutationVariables
  >(CreatePlmEventDocument, options);
}
export type CreatePlmEventMutationHookResult = ReturnType<
  typeof useCreatePlmEventMutation
>;
export type CreatePlmEventMutationResult =
  Apollo.MutationResult<CreatePlmEventMutation>;
export type CreatePlmEventMutationOptions = Apollo.BaseMutationOptions<
  CreatePlmEventMutation,
  CreatePlmEventMutationVariables
>;
export const UpdatePlmEventDocument = gql`
  mutation UpdatePlmEvent($_id: String!, $plmEvent: UpdateOnePlmEventInput!) {
    updatePlmEvent(_id: $_id, plmEvent: $plmEvent) {
      _id
      programId
      contractId
      startTime
      duration
      reductionTarget
      status
      createdAt
      updatedAt
      notificationMethod
      notificationReceivedAt
      notificationPayload
      program {
        _id
        name
      }
      contract {
        _id
        name
      }
    }
  }
`;
export type UpdatePlmEventMutationFn = Apollo.MutationFunction<
  UpdatePlmEventMutation,
  UpdatePlmEventMutationVariables
>;

/**
 * __useUpdatePlmEventMutation__
 *
 * To run a mutation, you first call `useUpdatePlmEventMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdatePlmEventMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updatePlmEventMutation, { data, loading, error }] = useUpdatePlmEventMutation({
 *   variables: {
 *      _id: // value for '_id'
 *      plmEvent: // value for 'plmEvent'
 *   },
 * });
 */
export function useUpdatePlmEventMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UpdatePlmEventMutation,
    UpdatePlmEventMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    UpdatePlmEventMutation,
    UpdatePlmEventMutationVariables
  >(UpdatePlmEventDocument, options);
}
export type UpdatePlmEventMutationHookResult = ReturnType<
  typeof useUpdatePlmEventMutation
>;
export type UpdatePlmEventMutationResult =
  Apollo.MutationResult<UpdatePlmEventMutation>;
export type UpdatePlmEventMutationOptions = Apollo.BaseMutationOptions<
  UpdatePlmEventMutation,
  UpdatePlmEventMutationVariables
>;
export const RemovePlmEventDocument = gql`
  mutation RemovePlmEvent($id: String!) {
    removePlmEvent(id: $id)
  }
`;
export type RemovePlmEventMutationFn = Apollo.MutationFunction<
  RemovePlmEventMutation,
  RemovePlmEventMutationVariables
>;

/**
 * __useRemovePlmEventMutation__
 *
 * To run a mutation, you first call `useRemovePlmEventMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemovePlmEventMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removePlmEventMutation, { data, loading, error }] = useRemovePlmEventMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useRemovePlmEventMutation(
  baseOptions?: Apollo.MutationHookOptions<
    RemovePlmEventMutation,
    RemovePlmEventMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    RemovePlmEventMutation,
    RemovePlmEventMutationVariables
  >(RemovePlmEventDocument, options);
}
export type RemovePlmEventMutationHookResult = ReturnType<
  typeof useRemovePlmEventMutation
>;
export type RemovePlmEventMutationResult =
  Apollo.MutationResult<RemovePlmEventMutation>;
export type RemovePlmEventMutationOptions = Apollo.BaseMutationOptions<
  RemovePlmEventMutation,
  RemovePlmEventMutationVariables
>;
export const PlmEventProgramOptionsDocument = gql`
  query PlmEventProgramOptions {
    plmPrograms {
      _id
      name
    }
  }
`;

/**
 * __usePlmEventProgramOptionsQuery__
 *
 * To run a query within a React component, call `usePlmEventProgramOptionsQuery` and pass it any options that fit your needs.
 * When your component renders, `usePlmEventProgramOptionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePlmEventProgramOptionsQuery({
 *   variables: {
 *   },
 * });
 */
export function usePlmEventProgramOptionsQuery(
  baseOptions?: Apollo.QueryHookOptions<
    PlmEventProgramOptionsQuery,
    PlmEventProgramOptionsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    PlmEventProgramOptionsQuery,
    PlmEventProgramOptionsQueryVariables
  >(PlmEventProgramOptionsDocument, options);
}
export function usePlmEventProgramOptionsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    PlmEventProgramOptionsQuery,
    PlmEventProgramOptionsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    PlmEventProgramOptionsQuery,
    PlmEventProgramOptionsQueryVariables
  >(PlmEventProgramOptionsDocument, options);
}
export type PlmEventProgramOptionsQueryHookResult = ReturnType<
  typeof usePlmEventProgramOptionsQuery
>;
export type PlmEventProgramOptionsLazyQueryHookResult = ReturnType<
  typeof usePlmEventProgramOptionsLazyQuery
>;
export type PlmEventProgramOptionsQueryResult = Apollo.QueryResult<
  PlmEventProgramOptionsQuery,
  PlmEventProgramOptionsQueryVariables
>;
export const ApprovePlmEventResponseDocument = gql`
  mutation ApprovePlmEventResponse($_id: String!) {
    approvePlmEventResponse(_id: $_id) {
      _id
      eventId
      curtailmentPlanId
      scheduledStart
      scheduledEnd
      actualStart
      actualEnd
      responseSentAt
      responseStatus
      createdAt
      updatedAt
    }
  }
`;
export type ApprovePlmEventResponseMutationFn = Apollo.MutationFunction<
  ApprovePlmEventResponseMutation,
  ApprovePlmEventResponseMutationVariables
>;

/**
 * __useApprovePlmEventResponseMutation__
 *
 * To run a mutation, you first call `useApprovePlmEventResponseMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useApprovePlmEventResponseMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [approvePlmEventResponseMutation, { data, loading, error }] = useApprovePlmEventResponseMutation({
 *   variables: {
 *      _id: // value for '_id'
 *   },
 * });
 */
export function useApprovePlmEventResponseMutation(
  baseOptions?: Apollo.MutationHookOptions<
    ApprovePlmEventResponseMutation,
    ApprovePlmEventResponseMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    ApprovePlmEventResponseMutation,
    ApprovePlmEventResponseMutationVariables
  >(ApprovePlmEventResponseDocument, options);
}
export type ApprovePlmEventResponseMutationHookResult = ReturnType<
  typeof useApprovePlmEventResponseMutation
>;
export type ApprovePlmEventResponseMutationResult =
  Apollo.MutationResult<ApprovePlmEventResponseMutation>;
export type ApprovePlmEventResponseMutationOptions = Apollo.BaseMutationOptions<
  ApprovePlmEventResponseMutation,
  ApprovePlmEventResponseMutationVariables
>;
export const CancelPlmEventResponseDocument = gql`
  mutation CancelPlmEventResponse($_id: String!) {
    cancelPlmEventResponse(_id: $_id) {
      _id
      responseStatus
      updatedAt
    }
  }
`;
export type CancelPlmEventResponseMutationFn = Apollo.MutationFunction<
  CancelPlmEventResponseMutation,
  CancelPlmEventResponseMutationVariables
>;

/**
 * __useCancelPlmEventResponseMutation__
 *
 * To run a mutation, you first call `useCancelPlmEventResponseMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCancelPlmEventResponseMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [cancelPlmEventResponseMutation, { data, loading, error }] = useCancelPlmEventResponseMutation({
 *   variables: {
 *      _id: // value for '_id'
 *   },
 * });
 */
export function useCancelPlmEventResponseMutation(
  baseOptions?: Apollo.MutationHookOptions<
    CancelPlmEventResponseMutation,
    CancelPlmEventResponseMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    CancelPlmEventResponseMutation,
    CancelPlmEventResponseMutationVariables
  >(CancelPlmEventResponseDocument, options);
}
export type CancelPlmEventResponseMutationHookResult = ReturnType<
  typeof useCancelPlmEventResponseMutation
>;
export type CancelPlmEventResponseMutationResult =
  Apollo.MutationResult<CancelPlmEventResponseMutation>;
export type CancelPlmEventResponseMutationOptions = Apollo.BaseMutationOptions<
  CancelPlmEventResponseMutation,
  CancelPlmEventResponseMutationVariables
>;
export const PlmCurtailmentPlanOptionsDocument = gql`
  query PlmCurtailmentPlanOptions {
    plmCurtailmentPlans {
      _id
      name
      organizationId
    }
  }
`;

/**
 * __usePlmCurtailmentPlanOptionsQuery__
 *
 * To run a query within a React component, call `usePlmCurtailmentPlanOptionsQuery` and pass it any options that fit your needs.
 * When your component renders, `usePlmCurtailmentPlanOptionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePlmCurtailmentPlanOptionsQuery({
 *   variables: {
 *   },
 * });
 */
export function usePlmCurtailmentPlanOptionsQuery(
  baseOptions?: Apollo.QueryHookOptions<
    PlmCurtailmentPlanOptionsQuery,
    PlmCurtailmentPlanOptionsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    PlmCurtailmentPlanOptionsQuery,
    PlmCurtailmentPlanOptionsQueryVariables
  >(PlmCurtailmentPlanOptionsDocument, options);
}
export function usePlmCurtailmentPlanOptionsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    PlmCurtailmentPlanOptionsQuery,
    PlmCurtailmentPlanOptionsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    PlmCurtailmentPlanOptionsQuery,
    PlmCurtailmentPlanOptionsQueryVariables
  >(PlmCurtailmentPlanOptionsDocument, options);
}
export type PlmCurtailmentPlanOptionsQueryHookResult = ReturnType<
  typeof usePlmCurtailmentPlanOptionsQuery
>;
export type PlmCurtailmentPlanOptionsLazyQueryHookResult = ReturnType<
  typeof usePlmCurtailmentPlanOptionsLazyQuery
>;
export type PlmCurtailmentPlanOptionsQueryResult = Apollo.QueryResult<
  PlmCurtailmentPlanOptionsQuery,
  PlmCurtailmentPlanOptionsQueryVariables
>;
export const PlmEventResponseEventsByIdsDocument = gql`
  subscription PlmEventResponseEventsByIds($_ids: [String!]!) {
    plmEventResponseEventsByIds(_ids: $_ids) {
      modelChangeOperation
      _id
      eventId
      propertyId
      curtailmentPlanId
      scheduledStart
      scheduledEnd
      actualStart
      actualEnd
      responseSentAt
      responseStatus
      createdAt
      updatedAt
      event {
        _id
        contractId
        programId
      }
      curtailmentPlan {
        _id
        organizationId
      }
    }
  }
`;

/**
 * __usePlmEventResponseEventsByIdsSubscription__
 *
 * To run a query within a React component, call `usePlmEventResponseEventsByIdsSubscription` and pass it any options that fit your needs.
 * When your component renders, `usePlmEventResponseEventsByIdsSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePlmEventResponseEventsByIdsSubscription({
 *   variables: {
 *      _ids: // value for '_ids'
 *   },
 * });
 */
export function usePlmEventResponseEventsByIdsSubscription(
  baseOptions: Apollo.SubscriptionHookOptions<
    PlmEventResponseEventsByIdsSubscription,
    PlmEventResponseEventsByIdsSubscriptionVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useSubscription<
    PlmEventResponseEventsByIdsSubscription,
    PlmEventResponseEventsByIdsSubscriptionVariables
  >(PlmEventResponseEventsByIdsDocument, options);
}
export type PlmEventResponseEventsByIdsSubscriptionHookResult = ReturnType<
  typeof usePlmEventResponseEventsByIdsSubscription
>;
export type PlmEventResponseEventsByIdsSubscriptionResult =
  Apollo.SubscriptionResult<PlmEventResponseEventsByIdsSubscription>;
export const PlmEventResponseByIdDocument = gql`
  query PlmEventResponseById($_id: String!) {
    plmEventResponseById(_id: $_id) {
      _id
      eventId
      curtailmentPlanId
      scheduledStart
      scheduledEnd
      actualStart
      actualEnd
      responseSentAt
      responseStatus
      createdAt
      updatedAt
      event {
        _id
        contractId
        programId
      }
      curtailmentPlan {
        _id
        organizationId
      }
    }
  }
`;

/**
 * __usePlmEventResponseByIdQuery__
 *
 * To run a query within a React component, call `usePlmEventResponseByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `usePlmEventResponseByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePlmEventResponseByIdQuery({
 *   variables: {
 *      _id: // value for '_id'
 *   },
 * });
 */
export function usePlmEventResponseByIdQuery(
  baseOptions: Apollo.QueryHookOptions<
    PlmEventResponseByIdQuery,
    PlmEventResponseByIdQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    PlmEventResponseByIdQuery,
    PlmEventResponseByIdQueryVariables
  >(PlmEventResponseByIdDocument, options);
}
export function usePlmEventResponseByIdLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    PlmEventResponseByIdQuery,
    PlmEventResponseByIdQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    PlmEventResponseByIdQuery,
    PlmEventResponseByIdQueryVariables
  >(PlmEventResponseByIdDocument, options);
}
export type PlmEventResponseByIdQueryHookResult = ReturnType<
  typeof usePlmEventResponseByIdQuery
>;
export type PlmEventResponseByIdLazyQueryHookResult = ReturnType<
  typeof usePlmEventResponseByIdLazyQuery
>;
export type PlmEventResponseByIdQueryResult = Apollo.QueryResult<
  PlmEventResponseByIdQuery,
  PlmEventResponseByIdQueryVariables
>;
export const PlmEventOptionsDocument = gql`
  query PlmEventOptions {
    plmEvents {
      _id
      contractId
      programId
      startTime
      duration
    }
  }
`;

/**
 * __usePlmEventOptionsQuery__
 *
 * To run a query within a React component, call `usePlmEventOptionsQuery` and pass it any options that fit your needs.
 * When your component renders, `usePlmEventOptionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePlmEventOptionsQuery({
 *   variables: {
 *   },
 * });
 */
export function usePlmEventOptionsQuery(
  baseOptions?: Apollo.QueryHookOptions<
    PlmEventOptionsQuery,
    PlmEventOptionsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<PlmEventOptionsQuery, PlmEventOptionsQueryVariables>(
    PlmEventOptionsDocument,
    options,
  );
}
export function usePlmEventOptionsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    PlmEventOptionsQuery,
    PlmEventOptionsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    PlmEventOptionsQuery,
    PlmEventOptionsQueryVariables
  >(PlmEventOptionsDocument, options);
}
export type PlmEventOptionsQueryHookResult = ReturnType<
  typeof usePlmEventOptionsQuery
>;
export type PlmEventOptionsLazyQueryHookResult = ReturnType<
  typeof usePlmEventOptionsLazyQuery
>;
export type PlmEventOptionsQueryResult = Apollo.QueryResult<
  PlmEventOptionsQuery,
  PlmEventOptionsQueryVariables
>;
export const PlmEventResponseListSubDocument = gql`
  subscription PlmEventResponseListSub {
    plmEventResponseEvents {
      modelChangeOperation
      _id
      eventId
      curtailmentPlanId
      scheduledStart
      scheduledEnd
      actualStart
      actualEnd
      responseSentAt
      responseStatus
      createdAt
      updatedAt
      event {
        _id
        contractId
        programId
      }
      curtailmentPlan {
        _id
        organizationId
      }
    }
  }
`;

/**
 * __usePlmEventResponseListSubSubscription__
 *
 * To run a query within a React component, call `usePlmEventResponseListSubSubscription` and pass it any options that fit your needs.
 * When your component renders, `usePlmEventResponseListSubSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePlmEventResponseListSubSubscription({
 *   variables: {
 *   },
 * });
 */
export function usePlmEventResponseListSubSubscription(
  baseOptions?: Apollo.SubscriptionHookOptions<
    PlmEventResponseListSubSubscription,
    PlmEventResponseListSubSubscriptionVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useSubscription<
    PlmEventResponseListSubSubscription,
    PlmEventResponseListSubSubscriptionVariables
  >(PlmEventResponseListSubDocument, options);
}
export type PlmEventResponseListSubSubscriptionHookResult = ReturnType<
  typeof usePlmEventResponseListSubSubscription
>;
export type PlmEventResponseListSubSubscriptionResult =
  Apollo.SubscriptionResult<PlmEventResponseListSubSubscription>;
export const PlmEventResponseListDocument = gql`
  query PlmEventResponseList {
    plmEventResponses {
      _id
      eventId
      curtailmentPlanId
      scheduledStart
      scheduledEnd
      actualStart
      actualEnd
      responseSentAt
      responseStatus
      createdAt
      updatedAt
      event {
        _id
        contractId
        programId
        program {
          _id
          name
        }
      }
      curtailmentPlan {
        _id
        name
        organizationId
      }
    }
  }
`;

/**
 * __usePlmEventResponseListQuery__
 *
 * To run a query within a React component, call `usePlmEventResponseListQuery` and pass it any options that fit your needs.
 * When your component renders, `usePlmEventResponseListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePlmEventResponseListQuery({
 *   variables: {
 *   },
 * });
 */
export function usePlmEventResponseListQuery(
  baseOptions?: Apollo.QueryHookOptions<
    PlmEventResponseListQuery,
    PlmEventResponseListQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    PlmEventResponseListQuery,
    PlmEventResponseListQueryVariables
  >(PlmEventResponseListDocument, options);
}
export function usePlmEventResponseListLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    PlmEventResponseListQuery,
    PlmEventResponseListQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    PlmEventResponseListQuery,
    PlmEventResponseListQueryVariables
  >(PlmEventResponseListDocument, options);
}
export type PlmEventResponseListQueryHookResult = ReturnType<
  typeof usePlmEventResponseListQuery
>;
export type PlmEventResponseListLazyQueryHookResult = ReturnType<
  typeof usePlmEventResponseListLazyQuery
>;
export type PlmEventResponseListQueryResult = Apollo.QueryResult<
  PlmEventResponseListQuery,
  PlmEventResponseListQueryVariables
>;
export const CreatePlmEventResponseDocument = gql`
  mutation CreatePlmEventResponse($record: CreateOnePlmEventResponseInput!) {
    createPlmEventResponse(record: $record) {
      _id
      eventId
      curtailmentPlanId
      scheduledStart
      scheduledEnd
      actualStart
      actualEnd
      responseSentAt
      responseStatus
      createdAt
      updatedAt
    }
  }
`;
export type CreatePlmEventResponseMutationFn = Apollo.MutationFunction<
  CreatePlmEventResponseMutation,
  CreatePlmEventResponseMutationVariables
>;

/**
 * __useCreatePlmEventResponseMutation__
 *
 * To run a mutation, you first call `useCreatePlmEventResponseMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreatePlmEventResponseMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createPlmEventResponseMutation, { data, loading, error }] = useCreatePlmEventResponseMutation({
 *   variables: {
 *      record: // value for 'record'
 *   },
 * });
 */
export function useCreatePlmEventResponseMutation(
  baseOptions?: Apollo.MutationHookOptions<
    CreatePlmEventResponseMutation,
    CreatePlmEventResponseMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    CreatePlmEventResponseMutation,
    CreatePlmEventResponseMutationVariables
  >(CreatePlmEventResponseDocument, options);
}
export type CreatePlmEventResponseMutationHookResult = ReturnType<
  typeof useCreatePlmEventResponseMutation
>;
export type CreatePlmEventResponseMutationResult =
  Apollo.MutationResult<CreatePlmEventResponseMutation>;
export type CreatePlmEventResponseMutationOptions = Apollo.BaseMutationOptions<
  CreatePlmEventResponseMutation,
  CreatePlmEventResponseMutationVariables
>;
export const UpdatePlmEventResponseDocument = gql`
  mutation UpdatePlmEventResponse(
    $_id: String!
    $plmEventResponse: UpdateOnePlmEventResponseInput!
  ) {
    updatePlmEventResponse(_id: $_id, plmEventResponse: $plmEventResponse) {
      _id
      eventId
      curtailmentPlanId
      scheduledStart
      scheduledEnd
      actualStart
      actualEnd
      responseSentAt
      responseStatus
      createdAt
      updatedAt
    }
  }
`;
export type UpdatePlmEventResponseMutationFn = Apollo.MutationFunction<
  UpdatePlmEventResponseMutation,
  UpdatePlmEventResponseMutationVariables
>;

/**
 * __useUpdatePlmEventResponseMutation__
 *
 * To run a mutation, you first call `useUpdatePlmEventResponseMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdatePlmEventResponseMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updatePlmEventResponseMutation, { data, loading, error }] = useUpdatePlmEventResponseMutation({
 *   variables: {
 *      _id: // value for '_id'
 *      plmEventResponse: // value for 'plmEventResponse'
 *   },
 * });
 */
export function useUpdatePlmEventResponseMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UpdatePlmEventResponseMutation,
    UpdatePlmEventResponseMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    UpdatePlmEventResponseMutation,
    UpdatePlmEventResponseMutationVariables
  >(UpdatePlmEventResponseDocument, options);
}
export type UpdatePlmEventResponseMutationHookResult = ReturnType<
  typeof useUpdatePlmEventResponseMutation
>;
export type UpdatePlmEventResponseMutationResult =
  Apollo.MutationResult<UpdatePlmEventResponseMutation>;
export type UpdatePlmEventResponseMutationOptions = Apollo.BaseMutationOptions<
  UpdatePlmEventResponseMutation,
  UpdatePlmEventResponseMutationVariables
>;
export const RemovePlmEventResponseDocument = gql`
  mutation RemovePlmEventResponse($id: String!) {
    removePlmEventResponse(id: $id)
  }
`;
export type RemovePlmEventResponseMutationFn = Apollo.MutationFunction<
  RemovePlmEventResponseMutation,
  RemovePlmEventResponseMutationVariables
>;

/**
 * __useRemovePlmEventResponseMutation__
 *
 * To run a mutation, you first call `useRemovePlmEventResponseMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemovePlmEventResponseMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removePlmEventResponseMutation, { data, loading, error }] = useRemovePlmEventResponseMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useRemovePlmEventResponseMutation(
  baseOptions?: Apollo.MutationHookOptions<
    RemovePlmEventResponseMutation,
    RemovePlmEventResponseMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    RemovePlmEventResponseMutation,
    RemovePlmEventResponseMutationVariables
  >(RemovePlmEventResponseDocument, options);
}
export type RemovePlmEventResponseMutationHookResult = ReturnType<
  typeof useRemovePlmEventResponseMutation
>;
export type RemovePlmEventResponseMutationResult =
  Apollo.MutationResult<RemovePlmEventResponseMutation>;
export type RemovePlmEventResponseMutationOptions = Apollo.BaseMutationOptions<
  RemovePlmEventResponseMutation,
  RemovePlmEventResponseMutationVariables
>;
export const PlmNotificationUpdateDocument = gql`
  subscription plmNotificationUpdate($_id: String!) {
    plmNotificationEventsByIds(_ids: [$_id]) {
      modelChangeOperation
      _id
      programId
      contractId
      partnerId
      activationTime
      deactivationTime
      receivedAt
      participationStatus
      responseSentAt
      source
      payload
    }
  }
`;

/**
 * __usePlmNotificationUpdateSubscription__
 *
 * To run a query within a React component, call `usePlmNotificationUpdateSubscription` and pass it any options that fit your needs.
 * When your component renders, `usePlmNotificationUpdateSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePlmNotificationUpdateSubscription({
 *   variables: {
 *      _id: // value for '_id'
 *   },
 * });
 */
export function usePlmNotificationUpdateSubscription(
  baseOptions: Apollo.SubscriptionHookOptions<
    PlmNotificationUpdateSubscription,
    PlmNotificationUpdateSubscriptionVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useSubscription<
    PlmNotificationUpdateSubscription,
    PlmNotificationUpdateSubscriptionVariables
  >(PlmNotificationUpdateDocument, options);
}
export type PlmNotificationUpdateSubscriptionHookResult = ReturnType<
  typeof usePlmNotificationUpdateSubscription
>;
export type PlmNotificationUpdateSubscriptionResult =
  Apollo.SubscriptionResult<PlmNotificationUpdateSubscription>;
export const PlmNotificationDocument = gql`
  query plmNotification($_id: String!) {
    plmNotification(filter: { _id: $_id }) {
      _id
      programId
      contractId
      partnerId
      activationTime
      deactivationTime
      receivedAt
      participationStatus
      responseSentAt
      source
      payload
    }
  }
`;

/**
 * __usePlmNotificationQuery__
 *
 * To run a query within a React component, call `usePlmNotificationQuery` and pass it any options that fit your needs.
 * When your component renders, `usePlmNotificationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePlmNotificationQuery({
 *   variables: {
 *      _id: // value for '_id'
 *   },
 * });
 */
export function usePlmNotificationQuery(
  baseOptions: Apollo.QueryHookOptions<
    PlmNotificationQuery,
    PlmNotificationQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<PlmNotificationQuery, PlmNotificationQueryVariables>(
    PlmNotificationDocument,
    options,
  );
}
export function usePlmNotificationLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    PlmNotificationQuery,
    PlmNotificationQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    PlmNotificationQuery,
    PlmNotificationQueryVariables
  >(PlmNotificationDocument, options);
}
export type PlmNotificationQueryHookResult = ReturnType<
  typeof usePlmNotificationQuery
>;
export type PlmNotificationLazyQueryHookResult = ReturnType<
  typeof usePlmNotificationLazyQuery
>;
export type PlmNotificationQueryResult = Apollo.QueryResult<
  PlmNotificationQuery,
  PlmNotificationQueryVariables
>;
export const PlmPartnerDetailEditSubDocument = gql`
  subscription PlmPartnerDetailEditSub($id: String!) {
    plmPartnerEventsByIds(_ids: [$id]) {
      modelChangeOperation
      _id
      name
      description
      partnerType
      contact {
        name
        email
        phone
      }
    }
  }
`;

/**
 * __usePlmPartnerDetailEditSubSubscription__
 *
 * To run a query within a React component, call `usePlmPartnerDetailEditSubSubscription` and pass it any options that fit your needs.
 * When your component renders, `usePlmPartnerDetailEditSubSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePlmPartnerDetailEditSubSubscription({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function usePlmPartnerDetailEditSubSubscription(
  baseOptions: Apollo.SubscriptionHookOptions<
    PlmPartnerDetailEditSubSubscription,
    PlmPartnerDetailEditSubSubscriptionVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useSubscription<
    PlmPartnerDetailEditSubSubscription,
    PlmPartnerDetailEditSubSubscriptionVariables
  >(PlmPartnerDetailEditSubDocument, options);
}
export type PlmPartnerDetailEditSubSubscriptionHookResult = ReturnType<
  typeof usePlmPartnerDetailEditSubSubscription
>;
export type PlmPartnerDetailEditSubSubscriptionResult =
  Apollo.SubscriptionResult<PlmPartnerDetailEditSubSubscription>;
export const PlmPartnerDetailEditDocument = gql`
  query PlmPartnerDetailEdit($id: String!) {
    plmPartnerById(_id: $id) {
      _id
      name
      description
      partnerType
      contact {
        name
        email
        phone
      }
    }
  }
`;

/**
 * __usePlmPartnerDetailEditQuery__
 *
 * To run a query within a React component, call `usePlmPartnerDetailEditQuery` and pass it any options that fit your needs.
 * When your component renders, `usePlmPartnerDetailEditQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePlmPartnerDetailEditQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function usePlmPartnerDetailEditQuery(
  baseOptions: Apollo.QueryHookOptions<
    PlmPartnerDetailEditQuery,
    PlmPartnerDetailEditQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    PlmPartnerDetailEditQuery,
    PlmPartnerDetailEditQueryVariables
  >(PlmPartnerDetailEditDocument, options);
}
export function usePlmPartnerDetailEditLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    PlmPartnerDetailEditQuery,
    PlmPartnerDetailEditQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    PlmPartnerDetailEditQuery,
    PlmPartnerDetailEditQueryVariables
  >(PlmPartnerDetailEditDocument, options);
}
export type PlmPartnerDetailEditQueryHookResult = ReturnType<
  typeof usePlmPartnerDetailEditQuery
>;
export type PlmPartnerDetailEditLazyQueryHookResult = ReturnType<
  typeof usePlmPartnerDetailEditLazyQuery
>;
export type PlmPartnerDetailEditQueryResult = Apollo.QueryResult<
  PlmPartnerDetailEditQuery,
  PlmPartnerDetailEditQueryVariables
>;
export const PlmPartnerListSubDocument = gql`
  subscription PlmPartnerListSub {
    plmPartnerEvents {
      modelChangeOperation
      _id
      name
      description
      partnerType
      contact {
        name
        email
        phone
      }
    }
  }
`;

/**
 * __usePlmPartnerListSubSubscription__
 *
 * To run a query within a React component, call `usePlmPartnerListSubSubscription` and pass it any options that fit your needs.
 * When your component renders, `usePlmPartnerListSubSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePlmPartnerListSubSubscription({
 *   variables: {
 *   },
 * });
 */
export function usePlmPartnerListSubSubscription(
  baseOptions?: Apollo.SubscriptionHookOptions<
    PlmPartnerListSubSubscription,
    PlmPartnerListSubSubscriptionVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useSubscription<
    PlmPartnerListSubSubscription,
    PlmPartnerListSubSubscriptionVariables
  >(PlmPartnerListSubDocument, options);
}
export type PlmPartnerListSubSubscriptionHookResult = ReturnType<
  typeof usePlmPartnerListSubSubscription
>;
export type PlmPartnerListSubSubscriptionResult =
  Apollo.SubscriptionResult<PlmPartnerListSubSubscription>;
export const PlmPartnersDocument = gql`
  query PlmPartners {
    plmPartners {
      _id
      name
      description
      partnerType
      contact {
        name
        email
        phone
      }
    }
  }
`;

/**
 * __usePlmPartnersQuery__
 *
 * To run a query within a React component, call `usePlmPartnersQuery` and pass it any options that fit your needs.
 * When your component renders, `usePlmPartnersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePlmPartnersQuery({
 *   variables: {
 *   },
 * });
 */
export function usePlmPartnersQuery(
  baseOptions?: Apollo.QueryHookOptions<
    PlmPartnersQuery,
    PlmPartnersQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<PlmPartnersQuery, PlmPartnersQueryVariables>(
    PlmPartnersDocument,
    options,
  );
}
export function usePlmPartnersLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    PlmPartnersQuery,
    PlmPartnersQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<PlmPartnersQuery, PlmPartnersQueryVariables>(
    PlmPartnersDocument,
    options,
  );
}
export type PlmPartnersQueryHookResult = ReturnType<typeof usePlmPartnersQuery>;
export type PlmPartnersLazyQueryHookResult = ReturnType<
  typeof usePlmPartnersLazyQuery
>;
export type PlmPartnersQueryResult = Apollo.QueryResult<
  PlmPartnersQuery,
  PlmPartnersQueryVariables
>;
export const CreatePlmPartnerDocument = gql`
  mutation CreatePlmPartner($plmPartner: CreateOnePlmPartnerInput!) {
    createPlmPartner(plmPartner: $plmPartner) {
      _id
      name
      description
      partnerType
      contact {
        name
        email
        phone
      }
    }
  }
`;
export type CreatePlmPartnerMutationFn = Apollo.MutationFunction<
  CreatePlmPartnerMutation,
  CreatePlmPartnerMutationVariables
>;

/**
 * __useCreatePlmPartnerMutation__
 *
 * To run a mutation, you first call `useCreatePlmPartnerMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreatePlmPartnerMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createPlmPartnerMutation, { data, loading, error }] = useCreatePlmPartnerMutation({
 *   variables: {
 *      plmPartner: // value for 'plmPartner'
 *   },
 * });
 */
export function useCreatePlmPartnerMutation(
  baseOptions?: Apollo.MutationHookOptions<
    CreatePlmPartnerMutation,
    CreatePlmPartnerMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    CreatePlmPartnerMutation,
    CreatePlmPartnerMutationVariables
  >(CreatePlmPartnerDocument, options);
}
export type CreatePlmPartnerMutationHookResult = ReturnType<
  typeof useCreatePlmPartnerMutation
>;
export type CreatePlmPartnerMutationResult =
  Apollo.MutationResult<CreatePlmPartnerMutation>;
export type CreatePlmPartnerMutationOptions = Apollo.BaseMutationOptions<
  CreatePlmPartnerMutation,
  CreatePlmPartnerMutationVariables
>;
export const UpdatePlmPartnerDocument = gql`
  mutation UpdatePlmPartner(
    $id: String!
    $plmPartner: UpdateOnePlmPartnerInput!
  ) {
    updatePlmPartner(_id: $id, plmPartner: $plmPartner) {
      _id
      name
      description
      partnerType
      contact {
        name
        email
        phone
      }
    }
  }
`;
export type UpdatePlmPartnerMutationFn = Apollo.MutationFunction<
  UpdatePlmPartnerMutation,
  UpdatePlmPartnerMutationVariables
>;

/**
 * __useUpdatePlmPartnerMutation__
 *
 * To run a mutation, you first call `useUpdatePlmPartnerMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdatePlmPartnerMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updatePlmPartnerMutation, { data, loading, error }] = useUpdatePlmPartnerMutation({
 *   variables: {
 *      id: // value for 'id'
 *      plmPartner: // value for 'plmPartner'
 *   },
 * });
 */
export function useUpdatePlmPartnerMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UpdatePlmPartnerMutation,
    UpdatePlmPartnerMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    UpdatePlmPartnerMutation,
    UpdatePlmPartnerMutationVariables
  >(UpdatePlmPartnerDocument, options);
}
export type UpdatePlmPartnerMutationHookResult = ReturnType<
  typeof useUpdatePlmPartnerMutation
>;
export type UpdatePlmPartnerMutationResult =
  Apollo.MutationResult<UpdatePlmPartnerMutation>;
export type UpdatePlmPartnerMutationOptions = Apollo.BaseMutationOptions<
  UpdatePlmPartnerMutation,
  UpdatePlmPartnerMutationVariables
>;
export const RemovePlmPartnerDocument = gql`
  mutation RemovePlmPartner($id: String!) {
    deletePlmPartner(_id: $id)
  }
`;
export type RemovePlmPartnerMutationFn = Apollo.MutationFunction<
  RemovePlmPartnerMutation,
  RemovePlmPartnerMutationVariables
>;

/**
 * __useRemovePlmPartnerMutation__
 *
 * To run a mutation, you first call `useRemovePlmPartnerMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemovePlmPartnerMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removePlmPartnerMutation, { data, loading, error }] = useRemovePlmPartnerMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useRemovePlmPartnerMutation(
  baseOptions?: Apollo.MutationHookOptions<
    RemovePlmPartnerMutation,
    RemovePlmPartnerMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    RemovePlmPartnerMutation,
    RemovePlmPartnerMutationVariables
  >(RemovePlmPartnerDocument, options);
}
export type RemovePlmPartnerMutationHookResult = ReturnType<
  typeof useRemovePlmPartnerMutation
>;
export type RemovePlmPartnerMutationResult =
  Apollo.MutationResult<RemovePlmPartnerMutation>;
export type RemovePlmPartnerMutationOptions = Apollo.BaseMutationOptions<
  RemovePlmPartnerMutation,
  RemovePlmPartnerMutationVariables
>;
export const PlmPartnerOptionsDocument = gql`
  query PlmPartnerOptions {
    plmPartners {
      _id
      name
    }
  }
`;

/**
 * __usePlmPartnerOptionsQuery__
 *
 * To run a query within a React component, call `usePlmPartnerOptionsQuery` and pass it any options that fit your needs.
 * When your component renders, `usePlmPartnerOptionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePlmPartnerOptionsQuery({
 *   variables: {
 *   },
 * });
 */
export function usePlmPartnerOptionsQuery(
  baseOptions?: Apollo.QueryHookOptions<
    PlmPartnerOptionsQuery,
    PlmPartnerOptionsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    PlmPartnerOptionsQuery,
    PlmPartnerOptionsQueryVariables
  >(PlmPartnerOptionsDocument, options);
}
export function usePlmPartnerOptionsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    PlmPartnerOptionsQuery,
    PlmPartnerOptionsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    PlmPartnerOptionsQuery,
    PlmPartnerOptionsQueryVariables
  >(PlmPartnerOptionsDocument, options);
}
export type PlmPartnerOptionsQueryHookResult = ReturnType<
  typeof usePlmPartnerOptionsQuery
>;
export type PlmPartnerOptionsLazyQueryHookResult = ReturnType<
  typeof usePlmPartnerOptionsLazyQuery
>;
export type PlmPartnerOptionsQueryResult = Apollo.QueryResult<
  PlmPartnerOptionsQuery,
  PlmPartnerOptionsQueryVariables
>;
export const PlmPartnerUpdateDocument = gql`
  subscription plmPartnerUpdate($_id: String) {
    plmPartnerEventsByIds(_ids: [$_id]) {
      modelChangeOperation
      _id
      name
      description
      partnerType
      contact {
        name
        email
        phone
      }
    }
  }
`;

/**
 * __usePlmPartnerUpdateSubscription__
 *
 * To run a query within a React component, call `usePlmPartnerUpdateSubscription` and pass it any options that fit your needs.
 * When your component renders, `usePlmPartnerUpdateSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePlmPartnerUpdateSubscription({
 *   variables: {
 *      _id: // value for '_id'
 *   },
 * });
 */
export function usePlmPartnerUpdateSubscription(
  baseOptions?: Apollo.SubscriptionHookOptions<
    PlmPartnerUpdateSubscription,
    PlmPartnerUpdateSubscriptionVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useSubscription<
    PlmPartnerUpdateSubscription,
    PlmPartnerUpdateSubscriptionVariables
  >(PlmPartnerUpdateDocument, options);
}
export type PlmPartnerUpdateSubscriptionHookResult = ReturnType<
  typeof usePlmPartnerUpdateSubscription
>;
export type PlmPartnerUpdateSubscriptionResult =
  Apollo.SubscriptionResult<PlmPartnerUpdateSubscription>;
export const PlmPartnerDocument = gql`
  query plmPartner($_id: String) {
    plmPartner(filter: { _id: $_id }) {
      _id
      name
      description
      partnerType
      contact {
        name
        email
        phone
      }
    }
  }
`;

/**
 * __usePlmPartnerQuery__
 *
 * To run a query within a React component, call `usePlmPartnerQuery` and pass it any options that fit your needs.
 * When your component renders, `usePlmPartnerQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePlmPartnerQuery({
 *   variables: {
 *      _id: // value for '_id'
 *   },
 * });
 */
export function usePlmPartnerQuery(
  baseOptions?: Apollo.QueryHookOptions<
    PlmPartnerQuery,
    PlmPartnerQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<PlmPartnerQuery, PlmPartnerQueryVariables>(
    PlmPartnerDocument,
    options,
  );
}
export function usePlmPartnerLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    PlmPartnerQuery,
    PlmPartnerQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<PlmPartnerQuery, PlmPartnerQueryVariables>(
    PlmPartnerDocument,
    options,
  );
}
export type PlmPartnerQueryHookResult = ReturnType<typeof usePlmPartnerQuery>;
export type PlmPartnerLazyQueryHookResult = ReturnType<
  typeof usePlmPartnerLazyQuery
>;
export type PlmPartnerQueryResult = Apollo.QueryResult<
  PlmPartnerQuery,
  PlmPartnerQueryVariables
>;
export const PlmProgramDetailEditSubDocument = gql`
  subscription PlmProgramDetailEditSub($id: String!) {
    plmProgramEventsByIds(_ids: [$id]) {
      modelChangeOperation
      _id
      programId
      name
      partnerId
      partner {
        _id
        name
      }
      hostPartnerId
      hostPartner {
        _id
        name
      }
      season
      startDate
      endDate
      notificationLeadTimeMinutes
      maximumNotificationLeadTimeMinutes
      minimumEventDurationMinutes
      maximumEventDurationMinutes
      minimumEventsPerSeason
      maximumEventsPerSeason
      measurementIntervalMinutes
      participationType
      incentiveDescription
    }
  }
`;

/**
 * __usePlmProgramDetailEditSubSubscription__
 *
 * To run a query within a React component, call `usePlmProgramDetailEditSubSubscription` and pass it any options that fit your needs.
 * When your component renders, `usePlmProgramDetailEditSubSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePlmProgramDetailEditSubSubscription({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function usePlmProgramDetailEditSubSubscription(
  baseOptions: Apollo.SubscriptionHookOptions<
    PlmProgramDetailEditSubSubscription,
    PlmProgramDetailEditSubSubscriptionVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useSubscription<
    PlmProgramDetailEditSubSubscription,
    PlmProgramDetailEditSubSubscriptionVariables
  >(PlmProgramDetailEditSubDocument, options);
}
export type PlmProgramDetailEditSubSubscriptionHookResult = ReturnType<
  typeof usePlmProgramDetailEditSubSubscription
>;
export type PlmProgramDetailEditSubSubscriptionResult =
  Apollo.SubscriptionResult<PlmProgramDetailEditSubSubscription>;
export const PlmProgramDetailEditDocument = gql`
  query PlmProgramDetailEdit($id: String!) {
    plmProgramById(_id: $id) {
      _id
      programId
      name
      partnerId
      partner {
        _id
        name
      }
      hostPartnerId
      hostPartner {
        _id
        name
      }
      season
      startDate
      endDate
      notificationLeadTimeMinutes
      maximumNotificationLeadTimeMinutes
      minimumEventDurationMinutes
      maximumEventDurationMinutes
      minimumEventsPerSeason
      maximumEventsPerSeason
      measurementIntervalMinutes
      participationType
      incentiveDescription
    }
  }
`;

/**
 * __usePlmProgramDetailEditQuery__
 *
 * To run a query within a React component, call `usePlmProgramDetailEditQuery` and pass it any options that fit your needs.
 * When your component renders, `usePlmProgramDetailEditQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePlmProgramDetailEditQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function usePlmProgramDetailEditQuery(
  baseOptions: Apollo.QueryHookOptions<
    PlmProgramDetailEditQuery,
    PlmProgramDetailEditQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    PlmProgramDetailEditQuery,
    PlmProgramDetailEditQueryVariables
  >(PlmProgramDetailEditDocument, options);
}
export function usePlmProgramDetailEditLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    PlmProgramDetailEditQuery,
    PlmProgramDetailEditQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    PlmProgramDetailEditQuery,
    PlmProgramDetailEditQueryVariables
  >(PlmProgramDetailEditDocument, options);
}
export type PlmProgramDetailEditQueryHookResult = ReturnType<
  typeof usePlmProgramDetailEditQuery
>;
export type PlmProgramDetailEditLazyQueryHookResult = ReturnType<
  typeof usePlmProgramDetailEditLazyQuery
>;
export type PlmProgramDetailEditQueryResult = Apollo.QueryResult<
  PlmProgramDetailEditQuery,
  PlmProgramDetailEditQueryVariables
>;
export const PlmProgramListSubDocument = gql`
  subscription PlmProgramListSub {
    plmProgramEvents {
      modelChangeOperation
      _id
      programId
      name
      partner {
        _id
        name
      }
      hostPartner {
        _id
        name
      }
      season
      startDate
      endDate
      participationType
      incentiveDescription
    }
  }
`;

/**
 * __usePlmProgramListSubSubscription__
 *
 * To run a query within a React component, call `usePlmProgramListSubSubscription` and pass it any options that fit your needs.
 * When your component renders, `usePlmProgramListSubSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePlmProgramListSubSubscription({
 *   variables: {
 *   },
 * });
 */
export function usePlmProgramListSubSubscription(
  baseOptions?: Apollo.SubscriptionHookOptions<
    PlmProgramListSubSubscription,
    PlmProgramListSubSubscriptionVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useSubscription<
    PlmProgramListSubSubscription,
    PlmProgramListSubSubscriptionVariables
  >(PlmProgramListSubDocument, options);
}
export type PlmProgramListSubSubscriptionHookResult = ReturnType<
  typeof usePlmProgramListSubSubscription
>;
export type PlmProgramListSubSubscriptionResult =
  Apollo.SubscriptionResult<PlmProgramListSubSubscription>;
export const PlmProgramsDocument = gql`
  query PlmPrograms {
    plmPrograms {
      _id
      programId
      name
      partner {
        _id
        name
      }
      hostPartner {
        _id
        name
      }
      season
      startDate
      endDate
      participationType
      incentiveDescription
    }
  }
`;

/**
 * __usePlmProgramsQuery__
 *
 * To run a query within a React component, call `usePlmProgramsQuery` and pass it any options that fit your needs.
 * When your component renders, `usePlmProgramsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePlmProgramsQuery({
 *   variables: {
 *   },
 * });
 */
export function usePlmProgramsQuery(
  baseOptions?: Apollo.QueryHookOptions<
    PlmProgramsQuery,
    PlmProgramsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<PlmProgramsQuery, PlmProgramsQueryVariables>(
    PlmProgramsDocument,
    options,
  );
}
export function usePlmProgramsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    PlmProgramsQuery,
    PlmProgramsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<PlmProgramsQuery, PlmProgramsQueryVariables>(
    PlmProgramsDocument,
    options,
  );
}
export type PlmProgramsQueryHookResult = ReturnType<typeof usePlmProgramsQuery>;
export type PlmProgramsLazyQueryHookResult = ReturnType<
  typeof usePlmProgramsLazyQuery
>;
export type PlmProgramsQueryResult = Apollo.QueryResult<
  PlmProgramsQuery,
  PlmProgramsQueryVariables
>;
export const CreatePlmProgramDocument = gql`
  mutation CreatePlmProgram($plmProgram: CreateOnePlmProgramInput!) {
    createPlmProgram(plmProgram: $plmProgram) {
      _id
      programId
      name
      partnerId
      partner {
        _id
        name
      }
      hostPartnerId
      hostPartner {
        _id
        name
      }
      season
      startDate
      endDate
      notificationLeadTimeMinutes
      maximumNotificationLeadTimeMinutes
      minimumEventDurationMinutes
      maximumEventDurationMinutes
      minimumEventsPerSeason
      maximumEventsPerSeason
      measurementIntervalMinutes
      participationType
      incentiveDescription
    }
  }
`;
export type CreatePlmProgramMutationFn = Apollo.MutationFunction<
  CreatePlmProgramMutation,
  CreatePlmProgramMutationVariables
>;

/**
 * __useCreatePlmProgramMutation__
 *
 * To run a mutation, you first call `useCreatePlmProgramMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreatePlmProgramMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createPlmProgramMutation, { data, loading, error }] = useCreatePlmProgramMutation({
 *   variables: {
 *      plmProgram: // value for 'plmProgram'
 *   },
 * });
 */
export function useCreatePlmProgramMutation(
  baseOptions?: Apollo.MutationHookOptions<
    CreatePlmProgramMutation,
    CreatePlmProgramMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    CreatePlmProgramMutation,
    CreatePlmProgramMutationVariables
  >(CreatePlmProgramDocument, options);
}
export type CreatePlmProgramMutationHookResult = ReturnType<
  typeof useCreatePlmProgramMutation
>;
export type CreatePlmProgramMutationResult =
  Apollo.MutationResult<CreatePlmProgramMutation>;
export type CreatePlmProgramMutationOptions = Apollo.BaseMutationOptions<
  CreatePlmProgramMutation,
  CreatePlmProgramMutationVariables
>;
export const UpdatePlmProgramDocument = gql`
  mutation UpdatePlmProgram(
    $id: String!
    $plmProgram: UpdateOnePlmProgramInput!
  ) {
    updatePlmProgram(_id: $id, plmProgram: $plmProgram) {
      _id
      programId
      name
      partnerId
      partner {
        _id
        name
      }
      hostPartnerId
      hostPartner {
        _id
        name
      }
      season
      startDate
      endDate
      notificationLeadTimeMinutes
      maximumNotificationLeadTimeMinutes
      minimumEventDurationMinutes
      maximumEventDurationMinutes
      minimumEventsPerSeason
      maximumEventsPerSeason
      measurementIntervalMinutes
      participationType
      incentiveDescription
    }
  }
`;
export type UpdatePlmProgramMutationFn = Apollo.MutationFunction<
  UpdatePlmProgramMutation,
  UpdatePlmProgramMutationVariables
>;

/**
 * __useUpdatePlmProgramMutation__
 *
 * To run a mutation, you first call `useUpdatePlmProgramMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdatePlmProgramMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updatePlmProgramMutation, { data, loading, error }] = useUpdatePlmProgramMutation({
 *   variables: {
 *      id: // value for 'id'
 *      plmProgram: // value for 'plmProgram'
 *   },
 * });
 */
export function useUpdatePlmProgramMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UpdatePlmProgramMutation,
    UpdatePlmProgramMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    UpdatePlmProgramMutation,
    UpdatePlmProgramMutationVariables
  >(UpdatePlmProgramDocument, options);
}
export type UpdatePlmProgramMutationHookResult = ReturnType<
  typeof useUpdatePlmProgramMutation
>;
export type UpdatePlmProgramMutationResult =
  Apollo.MutationResult<UpdatePlmProgramMutation>;
export type UpdatePlmProgramMutationOptions = Apollo.BaseMutationOptions<
  UpdatePlmProgramMutation,
  UpdatePlmProgramMutationVariables
>;
export const RemovePlmProgramDocument = gql`
  mutation RemovePlmProgram($id: String!) {
    deletePlmProgram(_id: $id)
  }
`;
export type RemovePlmProgramMutationFn = Apollo.MutationFunction<
  RemovePlmProgramMutation,
  RemovePlmProgramMutationVariables
>;

/**
 * __useRemovePlmProgramMutation__
 *
 * To run a mutation, you first call `useRemovePlmProgramMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemovePlmProgramMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removePlmProgramMutation, { data, loading, error }] = useRemovePlmProgramMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useRemovePlmProgramMutation(
  baseOptions?: Apollo.MutationHookOptions<
    RemovePlmProgramMutation,
    RemovePlmProgramMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    RemovePlmProgramMutation,
    RemovePlmProgramMutationVariables
  >(RemovePlmProgramDocument, options);
}
export type RemovePlmProgramMutationHookResult = ReturnType<
  typeof useRemovePlmProgramMutation
>;
export type RemovePlmProgramMutationResult =
  Apollo.MutationResult<RemovePlmProgramMutation>;
export type RemovePlmProgramMutationOptions = Apollo.BaseMutationOptions<
  RemovePlmProgramMutation,
  RemovePlmProgramMutationVariables
>;
export const PlmProgramOptionsDocument = gql`
  query PlmProgramOptions {
    plmPrograms {
      _id
      name
      partner {
        _id
        name
      }
      incentiveDescription
    }
  }
`;

/**
 * __usePlmProgramOptionsQuery__
 *
 * To run a query within a React component, call `usePlmProgramOptionsQuery` and pass it any options that fit your needs.
 * When your component renders, `usePlmProgramOptionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePlmProgramOptionsQuery({
 *   variables: {
 *   },
 * });
 */
export function usePlmProgramOptionsQuery(
  baseOptions?: Apollo.QueryHookOptions<
    PlmProgramOptionsQuery,
    PlmProgramOptionsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    PlmProgramOptionsQuery,
    PlmProgramOptionsQueryVariables
  >(PlmProgramOptionsDocument, options);
}
export function usePlmProgramOptionsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    PlmProgramOptionsQuery,
    PlmProgramOptionsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    PlmProgramOptionsQuery,
    PlmProgramOptionsQueryVariables
  >(PlmProgramOptionsDocument, options);
}
export type PlmProgramOptionsQueryHookResult = ReturnType<
  typeof usePlmProgramOptionsQuery
>;
export type PlmProgramOptionsLazyQueryHookResult = ReturnType<
  typeof usePlmProgramOptionsLazyQuery
>;
export type PlmProgramOptionsQueryResult = Apollo.QueryResult<
  PlmProgramOptionsQuery,
  PlmProgramOptionsQueryVariables
>;
export const PlmProgramUpdateDocument = gql`
  subscription plmProgramUpdate($_id: String) {
    plmProgramEventsByIds(_ids: [$_id]) {
      modelChangeOperation
      _id
      programId
      name
      partnerId
      partner {
        _id
        name
      }
      season
      startDate
      endDate
      notificationLeadTimeMinutes
      maximumNotificationLeadTimeMinutes
      minimumEventDurationMinutes
      maximumEventDurationMinutes
      minimumEventsPerSeason
      maximumEventsPerSeason
      measurementIntervalMinutes
      participationType
    }
  }
`;

/**
 * __usePlmProgramUpdateSubscription__
 *
 * To run a query within a React component, call `usePlmProgramUpdateSubscription` and pass it any options that fit your needs.
 * When your component renders, `usePlmProgramUpdateSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePlmProgramUpdateSubscription({
 *   variables: {
 *      _id: // value for '_id'
 *   },
 * });
 */
export function usePlmProgramUpdateSubscription(
  baseOptions?: Apollo.SubscriptionHookOptions<
    PlmProgramUpdateSubscription,
    PlmProgramUpdateSubscriptionVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useSubscription<
    PlmProgramUpdateSubscription,
    PlmProgramUpdateSubscriptionVariables
  >(PlmProgramUpdateDocument, options);
}
export type PlmProgramUpdateSubscriptionHookResult = ReturnType<
  typeof usePlmProgramUpdateSubscription
>;
export type PlmProgramUpdateSubscriptionResult =
  Apollo.SubscriptionResult<PlmProgramUpdateSubscription>;
export const PlmProgramDocument = gql`
  query plmProgram($_id: String) {
    plmProgram(filter: { _id: $_id }) {
      _id
      programId
      name
      partnerId
      partner {
        _id
        name
      }
      season
      startDate
      endDate
      notificationLeadTimeMinutes
      maximumNotificationLeadTimeMinutes
      minimumEventDurationMinutes
      maximumEventDurationMinutes
      minimumEventsPerSeason
      maximumEventsPerSeason
      measurementIntervalMinutes
      participationType
    }
  }
`;

/**
 * __usePlmProgramQuery__
 *
 * To run a query within a React component, call `usePlmProgramQuery` and pass it any options that fit your needs.
 * When your component renders, `usePlmProgramQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePlmProgramQuery({
 *   variables: {
 *      _id: // value for '_id'
 *   },
 * });
 */
export function usePlmProgramQuery(
  baseOptions?: Apollo.QueryHookOptions<
    PlmProgramQuery,
    PlmProgramQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<PlmProgramQuery, PlmProgramQueryVariables>(
    PlmProgramDocument,
    options,
  );
}
export function usePlmProgramLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    PlmProgramQuery,
    PlmProgramQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<PlmProgramQuery, PlmProgramQueryVariables>(
    PlmProgramDocument,
    options,
  );
}
export type PlmProgramQueryHookResult = ReturnType<typeof usePlmProgramQuery>;
export type PlmProgramLazyQueryHookResult = ReturnType<
  typeof usePlmProgramLazyQuery
>;
export type PlmProgramQueryResult = Apollo.QueryResult<
  PlmProgramQuery,
  PlmProgramQueryVariables
>;
export const CheckOpenWeatherDevicesDocument = gql`
  query CheckOpenWeatherDevices($propertyId: String!) {
    devices(filter: { propertyId: $propertyId, type: OpenWeather }, limit: 1) {
      _id
      type
    }
  }
`;

/**
 * __useCheckOpenWeatherDevicesQuery__
 *
 * To run a query within a React component, call `useCheckOpenWeatherDevicesQuery` and pass it any options that fit your needs.
 * When your component renders, `useCheckOpenWeatherDevicesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCheckOpenWeatherDevicesQuery({
 *   variables: {
 *      propertyId: // value for 'propertyId'
 *   },
 * });
 */
export function useCheckOpenWeatherDevicesQuery(
  baseOptions: Apollo.QueryHookOptions<
    CheckOpenWeatherDevicesQuery,
    CheckOpenWeatherDevicesQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    CheckOpenWeatherDevicesQuery,
    CheckOpenWeatherDevicesQueryVariables
  >(CheckOpenWeatherDevicesDocument, options);
}
export function useCheckOpenWeatherDevicesLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    CheckOpenWeatherDevicesQuery,
    CheckOpenWeatherDevicesQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    CheckOpenWeatherDevicesQuery,
    CheckOpenWeatherDevicesQueryVariables
  >(CheckOpenWeatherDevicesDocument, options);
}
export type CheckOpenWeatherDevicesQueryHookResult = ReturnType<
  typeof useCheckOpenWeatherDevicesQuery
>;
export type CheckOpenWeatherDevicesLazyQueryHookResult = ReturnType<
  typeof useCheckOpenWeatherDevicesLazyQuery
>;
export type CheckOpenWeatherDevicesQueryResult = Apollo.QueryResult<
  CheckOpenWeatherDevicesQuery,
  CheckOpenWeatherDevicesQueryVariables
>;
export const CreatePropertyDocument = gql`
  mutation CreateProperty($property: CreateOnePropertyInput!) {
    createProperty(property: $property) {
      _id
      title
      imageUrl
      hasSecondaryHeatSource
      organizationId
      address {
        line1
        line2
        city
        state
        postalCode
      }
      owner {
        name
        email
        mobile
        phone
      }
      propMgr {
        name
        email
        mobile
        phone
      }
      contact {
        email
        email2
        email3
        smsNumber
        smsNumber2
        smsNumber3
      }
      alertLimits {
        units {
          temperature {
            min
            max
          }
          humidity {
            min
            max
          }
        }
        plant {
          loops {
            temperature {
              min
              max
            }
            pressure {
              min
              max
            }
          }
          dhw {
            temperature {
              min
              max
            }
          }
        }
      }
    }
  }
`;
export type CreatePropertyMutationFn = Apollo.MutationFunction<
  CreatePropertyMutation,
  CreatePropertyMutationVariables
>;

/**
 * __useCreatePropertyMutation__
 *
 * To run a mutation, you first call `useCreatePropertyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreatePropertyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createPropertyMutation, { data, loading, error }] = useCreatePropertyMutation({
 *   variables: {
 *      property: // value for 'property'
 *   },
 * });
 */
export function useCreatePropertyMutation(
  baseOptions?: Apollo.MutationHookOptions<
    CreatePropertyMutation,
    CreatePropertyMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    CreatePropertyMutation,
    CreatePropertyMutationVariables
  >(CreatePropertyDocument, options);
}
export type CreatePropertyMutationHookResult = ReturnType<
  typeof useCreatePropertyMutation
>;
export type CreatePropertyMutationResult =
  Apollo.MutationResult<CreatePropertyMutation>;
export type CreatePropertyMutationOptions = Apollo.BaseMutationOptions<
  CreatePropertyMutation,
  CreatePropertyMutationVariables
>;
export const InitializeLocalWeatherDeviceDocument = gql`
  mutation InitializeLocalWeatherDevice($propertyId: String!) {
    initializeLocalWeatherDevice(propertyId: $propertyId) {
      _id
      deviceId
      type
      name
      propertyId
      unitId
      panelId
      meta {
        name
        location
        type
      }
    }
  }
`;
export type InitializeLocalWeatherDeviceMutationFn = Apollo.MutationFunction<
  InitializeLocalWeatherDeviceMutation,
  InitializeLocalWeatherDeviceMutationVariables
>;

/**
 * __useInitializeLocalWeatherDeviceMutation__
 *
 * To run a mutation, you first call `useInitializeLocalWeatherDeviceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useInitializeLocalWeatherDeviceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [initializeLocalWeatherDeviceMutation, { data, loading, error }] = useInitializeLocalWeatherDeviceMutation({
 *   variables: {
 *      propertyId: // value for 'propertyId'
 *   },
 * });
 */
export function useInitializeLocalWeatherDeviceMutation(
  baseOptions?: Apollo.MutationHookOptions<
    InitializeLocalWeatherDeviceMutation,
    InitializeLocalWeatherDeviceMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    InitializeLocalWeatherDeviceMutation,
    InitializeLocalWeatherDeviceMutationVariables
  >(InitializeLocalWeatherDeviceDocument, options);
}
export type InitializeLocalWeatherDeviceMutationHookResult = ReturnType<
  typeof useInitializeLocalWeatherDeviceMutation
>;
export type InitializeLocalWeatherDeviceMutationResult =
  Apollo.MutationResult<InitializeLocalWeatherDeviceMutation>;
export type InitializeLocalWeatherDeviceMutationOptions =
  Apollo.BaseMutationOptions<
    InitializeLocalWeatherDeviceMutation,
    InitializeLocalWeatherDeviceMutationVariables
  >;
export const PropertyDetailEditDocument = gql`
  query PropertyDetailEdit($id: String!) {
    propertyById(_id: $id) {
      _id
      title
      imageUrl
      hasSecondaryHeatSource
      setpointProfileId
      thermostatScheduleTemplateId
      zonePolicyId
      organizationId
      organization {
        _id
        name
      }
      assignableZonePolicies {
        _id
        name
        properties
        rules {
          type
          source {
            deviceType
            multiplicity
            attributes {
              operatingMode
              operatingState
              heatSetpoint
              coolSetpoint
              contactState
              fanSpeed
              indoorFanStatus
              keypadLockoutLevel
            }
          }
          target {
            deviceType
            multiplicity
            attributes {
              heatSetpoint
              coolSetpoint
              isOn
              keypadLockoutLevel
            }
          }
        }
      }
      address {
        line1
        line2
        city
        state
        postalCode
      }
      owner {
        name
        email
        mobile
        phone
      }
      propMgr {
        name
        email
        mobile
        phone
      }
      maintMgr {
        name
        email
        mobile
      }
      contact {
        email
        email2
        email3
        smsNumber
        smsNumber2
        smsNumber3
        smsOptInStatus1
        smsOptInTimestamp1
        smsOptInStatus2
        smsOptInTimestamp2
        smsOptInStatus3
        smsOptInTimestamp3
      }
      alertLimits {
        units {
          temperature {
            min
            max
          }
          humidity {
            min
            max
          }
        }
        plant {
          loops {
            temperature {
              min
              max
            }
            pressure {
              min
              max
            }
          }
          dhw {
            temperature {
              min
              max
            }
          }
        }
      }
    }
  }
`;

/**
 * __usePropertyDetailEditQuery__
 *
 * To run a query within a React component, call `usePropertyDetailEditQuery` and pass it any options that fit your needs.
 * When your component renders, `usePropertyDetailEditQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePropertyDetailEditQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function usePropertyDetailEditQuery(
  baseOptions: Apollo.QueryHookOptions<
    PropertyDetailEditQuery,
    PropertyDetailEditQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    PropertyDetailEditQuery,
    PropertyDetailEditQueryVariables
  >(PropertyDetailEditDocument, options);
}
export function usePropertyDetailEditLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    PropertyDetailEditQuery,
    PropertyDetailEditQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    PropertyDetailEditQuery,
    PropertyDetailEditQueryVariables
  >(PropertyDetailEditDocument, options);
}
export type PropertyDetailEditQueryHookResult = ReturnType<
  typeof usePropertyDetailEditQuery
>;
export type PropertyDetailEditLazyQueryHookResult = ReturnType<
  typeof usePropertyDetailEditLazyQuery
>;
export type PropertyDetailEditQueryResult = Apollo.QueryResult<
  PropertyDetailEditQuery,
  PropertyDetailEditQueryVariables
>;
export const PropertyOrganizationOptionsDocument = gql`
  query PropertyOrganizationOptions {
    organizations {
      _id
      name
    }
  }
`;

/**
 * __usePropertyOrganizationOptionsQuery__
 *
 * To run a query within a React component, call `usePropertyOrganizationOptionsQuery` and pass it any options that fit your needs.
 * When your component renders, `usePropertyOrganizationOptionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePropertyOrganizationOptionsQuery({
 *   variables: {
 *   },
 * });
 */
export function usePropertyOrganizationOptionsQuery(
  baseOptions?: Apollo.QueryHookOptions<
    PropertyOrganizationOptionsQuery,
    PropertyOrganizationOptionsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    PropertyOrganizationOptionsQuery,
    PropertyOrganizationOptionsQueryVariables
  >(PropertyOrganizationOptionsDocument, options);
}
export function usePropertyOrganizationOptionsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    PropertyOrganizationOptionsQuery,
    PropertyOrganizationOptionsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    PropertyOrganizationOptionsQuery,
    PropertyOrganizationOptionsQueryVariables
  >(PropertyOrganizationOptionsDocument, options);
}
export type PropertyOrganizationOptionsQueryHookResult = ReturnType<
  typeof usePropertyOrganizationOptionsQuery
>;
export type PropertyOrganizationOptionsLazyQueryHookResult = ReturnType<
  typeof usePropertyOrganizationOptionsLazyQuery
>;
export type PropertyOrganizationOptionsQueryResult = Apollo.QueryResult<
  PropertyOrganizationOptionsQuery,
  PropertyOrganizationOptionsQueryVariables
>;
export const PropertyUpdateDocument = gql`
  subscription propertyUpdate($_id: String) {
    propertyEventsByIds(_ids: [$_id]) {
      modelChangeOperation
      _id
      title
      imageUrl
      floorLabel
      thermostatScheduleTemplateId
      devices {
        name
        type
        _id
      }
      address {
        line1
        city
        state
        postalCode
      }
      units {
        _id
        name
        type
        devicesSummary {
          proxy {
            isOffline
            operatingState
            operatingMode
          }
        }
      }
      buildings {
        _id
        name
        number
        units {
          _id
          name
          type
        }
        inUse
      }
      contact {
        email
        email2
        email3
        smsNumber
        smsNumber2
        smsNumber3
      }
      owner {
        name
      }
      propMgr {
        name
        mobile
      }
      maintMgr {
        name
        mobile
      }
      setpointProfileId
      zonePolicyId
      assignableZonePolicies {
        _id
        name
        properties
        rules {
          type
          source {
            deviceType
            multiplicity
            attributes {
              operatingMode
              operatingState
              heatSetpoint
              coolSetpoint
              contactState
              fanSpeed
              indoorFanStatus
              keypadLockoutLevel
            }
          }
          target {
            deviceType
            multiplicity
            attributes {
              heatSetpoint
              coolSetpoint
              isOn
              keypadLockoutLevel
            }
          }
        }
      }
      authorizedUsers {
        _id
        name
        email
        authorizationProfile {
          isManager
          isInstaller
          isViewer
        }
      }
      alertLimits {
        plant {
          dhw {
            temperature {
              max
              min
            }
          }
          loops {
            temperature {
              max
              min
            }
            pressure {
              max
              min
            }
          }
        }
        units {
          temperature {
            max
            min
          }
          humidity {
            max
            min
          }
        }
      }
      assignableSetpointProfiles {
        _id
        name
        assignedProperties {
          _id
          __typename
        }
        assignedUnits {
          _id
          __typename
        }
        enabledProperties {
          _id
          __typename
        }
        heat {
          max
          min
        }
        cool {
          max
          min
        }
      }
    }
  }
`;

/**
 * __usePropertyUpdateSubscription__
 *
 * To run a query within a React component, call `usePropertyUpdateSubscription` and pass it any options that fit your needs.
 * When your component renders, `usePropertyUpdateSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePropertyUpdateSubscription({
 *   variables: {
 *      _id: // value for '_id'
 *   },
 * });
 */
export function usePropertyUpdateSubscription(
  baseOptions?: Apollo.SubscriptionHookOptions<
    PropertyUpdateSubscription,
    PropertyUpdateSubscriptionVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useSubscription<
    PropertyUpdateSubscription,
    PropertyUpdateSubscriptionVariables
  >(PropertyUpdateDocument, options);
}
export type PropertyUpdateSubscriptionHookResult = ReturnType<
  typeof usePropertyUpdateSubscription
>;
export type PropertyUpdateSubscriptionResult =
  Apollo.SubscriptionResult<PropertyUpdateSubscription>;
export const PropertyDocument = gql`
  query property($_id: String) {
    property(filter: { _id: $_id }) {
      _id
      title
      imageUrl
      floorLabel
      thermostatScheduleTemplateId
      alerts {
        type {
          id
          name
        }
        unit {
          name
          id
        }
        device {
          id
          type
        }
      }
      organizationId
      organization {
        _id
        name
      }
      devices {
        name
        type
        _id
      }
      address {
        line1
        city
        state
        postalCode
      }
      units {
        _id
        name
        type
        alertTypes {
          sourceOffline
          deviceOffline
        }
        devicesSummary {
          proxy {
            isOffline
            operatingState
            operatingMode
          }
        }
      }
      buildings {
        _id
        name
        number
        units {
          _id
          name
          type
        }
        inUse
      }
      contact {
        email
        email2
        email3
        smsNumber
        smsNumber2
        smsNumber3
      }
      owner {
        name
      }
      propMgr {
        name
        mobile
      }
      maintMgr {
        name
        mobile
      }
      setpointProfileId
      zonePolicyId
      assignableZonePolicies {
        _id
        name
        properties
        rules {
          type
          source {
            deviceType
            multiplicity
            attributes {
              operatingMode
              operatingState
              heatSetpoint
              coolSetpoint
              contactState
              fanSpeed
              indoorFanStatus
              keypadLockoutLevel
            }
          }
          target {
            deviceType
            multiplicity
            attributes {
              isOn
              heatSetpoint
              coolSetpoint
              keypadLockoutLevel
            }
          }
        }
      }
      authorizedUsers {
        _id
        name
        email
        authorizationProfile {
          isManager
          isInstaller
          isViewer
        }
      }
      alertLimits {
        plant {
          dhw {
            temperature {
              max
              min
            }
          }
          loops {
            temperature {
              max
              min
            }
            pressure {
              max
              min
            }
          }
        }
        units {
          temperature {
            max
            min
          }
          humidity {
            max
            min
          }
        }
      }
      assignableSetpointProfiles {
        _id
        name
        assignedProperties {
          _id
          __typename
        }
        assignedUnits {
          _id
          __typename
        }
        enabledProperties {
          _id
          __typename
        }
        heat {
          max
          min
        }
        cool {
          max
          min
        }
      }
    }
  }
`;

/**
 * __usePropertyQuery__
 *
 * To run a query within a React component, call `usePropertyQuery` and pass it any options that fit your needs.
 * When your component renders, `usePropertyQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePropertyQuery({
 *   variables: {
 *      _id: // value for '_id'
 *   },
 * });
 */
export function usePropertyQuery(
  baseOptions?: Apollo.QueryHookOptions<PropertyQuery, PropertyQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<PropertyQuery, PropertyQueryVariables>(
    PropertyDocument,
    options,
  );
}
export function usePropertyLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    PropertyQuery,
    PropertyQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<PropertyQuery, PropertyQueryVariables>(
    PropertyDocument,
    options,
  );
}
export type PropertyQueryHookResult = ReturnType<typeof usePropertyQuery>;
export type PropertyLazyQueryHookResult = ReturnType<
  typeof usePropertyLazyQuery
>;
export type PropertyQueryResult = Apollo.QueryResult<
  PropertyQuery,
  PropertyQueryVariables
>;
export const PropertyScheduleListByPropertyIdDocument = gql`
  query PropertyScheduleListByPropertyId($propertyId: String) {
    unitsByPropertyId(propertyId: [$propertyId]) {
      _id
      name
      type
      effectiveThermostatScheduleType
    }
  }
`;

/**
 * __usePropertyScheduleListByPropertyIdQuery__
 *
 * To run a query within a React component, call `usePropertyScheduleListByPropertyIdQuery` and pass it any options that fit your needs.
 * When your component renders, `usePropertyScheduleListByPropertyIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePropertyScheduleListByPropertyIdQuery({
 *   variables: {
 *      propertyId: // value for 'propertyId'
 *   },
 * });
 */
export function usePropertyScheduleListByPropertyIdQuery(
  baseOptions?: Apollo.QueryHookOptions<
    PropertyScheduleListByPropertyIdQuery,
    PropertyScheduleListByPropertyIdQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    PropertyScheduleListByPropertyIdQuery,
    PropertyScheduleListByPropertyIdQueryVariables
  >(PropertyScheduleListByPropertyIdDocument, options);
}
export function usePropertyScheduleListByPropertyIdLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    PropertyScheduleListByPropertyIdQuery,
    PropertyScheduleListByPropertyIdQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    PropertyScheduleListByPropertyIdQuery,
    PropertyScheduleListByPropertyIdQueryVariables
  >(PropertyScheduleListByPropertyIdDocument, options);
}
export type PropertyScheduleListByPropertyIdQueryHookResult = ReturnType<
  typeof usePropertyScheduleListByPropertyIdQuery
>;
export type PropertyScheduleListByPropertyIdLazyQueryHookResult = ReturnType<
  typeof usePropertyScheduleListByPropertyIdLazyQuery
>;
export type PropertyScheduleListByPropertyIdQueryResult = Apollo.QueryResult<
  PropertyScheduleListByPropertyIdQuery,
  PropertyScheduleListByPropertyIdQueryVariables
>;
export const PropertyListForSourceEditorDocument = gql`
  query PropertyListForSourceEditor {
    properties(limit: 0) {
      _id
      title
    }
  }
`;

/**
 * __usePropertyListForSourceEditorQuery__
 *
 * To run a query within a React component, call `usePropertyListForSourceEditorQuery` and pass it any options that fit your needs.
 * When your component renders, `usePropertyListForSourceEditorQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePropertyListForSourceEditorQuery({
 *   variables: {
 *   },
 * });
 */
export function usePropertyListForSourceEditorQuery(
  baseOptions?: Apollo.QueryHookOptions<
    PropertyListForSourceEditorQuery,
    PropertyListForSourceEditorQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    PropertyListForSourceEditorQuery,
    PropertyListForSourceEditorQueryVariables
  >(PropertyListForSourceEditorDocument, options);
}
export function usePropertyListForSourceEditorLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    PropertyListForSourceEditorQuery,
    PropertyListForSourceEditorQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    PropertyListForSourceEditorQuery,
    PropertyListForSourceEditorQueryVariables
  >(PropertyListForSourceEditorDocument, options);
}
export type PropertyListForSourceEditorQueryHookResult = ReturnType<
  typeof usePropertyListForSourceEditorQuery
>;
export type PropertyListForSourceEditorLazyQueryHookResult = ReturnType<
  typeof usePropertyListForSourceEditorLazyQuery
>;
export type PropertyListForSourceEditorQueryResult = Apollo.QueryResult<
  PropertyListForSourceEditorQuery,
  PropertyListForSourceEditorQueryVariables
>;
export const PropertySummaryDocument = gql`
  query PropertySummary($propertyId: String!) {
    propertySummary(propertyId: $propertyId) {
      propertyId
      units {
        propertyId
        units {
          label
          count
        }
      }
      alerts {
        propertyId
        alerts {
          label
          count
          color
          action
          options
        }
      }
      devices {
        propertyId
        residentialDevices {
          label
          count
        }
        centralDevices {
          label
          count
        }
      }
      stats {
        propertyId
        temperature {
          min
          max
          ave
        }
        humidity {
          min
          max
          ave
        }
      }
    }
  }
`;

/**
 * __usePropertySummaryQuery__
 *
 * To run a query within a React component, call `usePropertySummaryQuery` and pass it any options that fit your needs.
 * When your component renders, `usePropertySummaryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePropertySummaryQuery({
 *   variables: {
 *      propertyId: // value for 'propertyId'
 *   },
 * });
 */
export function usePropertySummaryQuery(
  baseOptions: Apollo.QueryHookOptions<
    PropertySummaryQuery,
    PropertySummaryQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<PropertySummaryQuery, PropertySummaryQueryVariables>(
    PropertySummaryDocument,
    options,
  );
}
export function usePropertySummaryLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    PropertySummaryQuery,
    PropertySummaryQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    PropertySummaryQuery,
    PropertySummaryQueryVariables
  >(PropertySummaryDocument, options);
}
export type PropertySummaryQueryHookResult = ReturnType<
  typeof usePropertySummaryQuery
>;
export type PropertySummaryLazyQueryHookResult = ReturnType<
  typeof usePropertySummaryLazyQuery
>;
export type PropertySummaryQueryResult = Apollo.QueryResult<
  PropertySummaryQuery,
  PropertySummaryQueryVariables
>;
export const PropertySummaryUnitsDocument = gql`
  query PropertySummaryUnits($propertyId: String!) {
    propertySummaryUnits(propertyId: $propertyId) {
      propertyId
      units {
        label
        count
      }
    }
  }
`;

/**
 * __usePropertySummaryUnitsQuery__
 *
 * To run a query within a React component, call `usePropertySummaryUnitsQuery` and pass it any options that fit your needs.
 * When your component renders, `usePropertySummaryUnitsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePropertySummaryUnitsQuery({
 *   variables: {
 *      propertyId: // value for 'propertyId'
 *   },
 * });
 */
export function usePropertySummaryUnitsQuery(
  baseOptions: Apollo.QueryHookOptions<
    PropertySummaryUnitsQuery,
    PropertySummaryUnitsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    PropertySummaryUnitsQuery,
    PropertySummaryUnitsQueryVariables
  >(PropertySummaryUnitsDocument, options);
}
export function usePropertySummaryUnitsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    PropertySummaryUnitsQuery,
    PropertySummaryUnitsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    PropertySummaryUnitsQuery,
    PropertySummaryUnitsQueryVariables
  >(PropertySummaryUnitsDocument, options);
}
export type PropertySummaryUnitsQueryHookResult = ReturnType<
  typeof usePropertySummaryUnitsQuery
>;
export type PropertySummaryUnitsLazyQueryHookResult = ReturnType<
  typeof usePropertySummaryUnitsLazyQuery
>;
export type PropertySummaryUnitsQueryResult = Apollo.QueryResult<
  PropertySummaryUnitsQuery,
  PropertySummaryUnitsQueryVariables
>;
export const PropertySummaryAlertsDocument = gql`
  query PropertySummaryAlerts($propertyId: String!) {
    propertySummaryAlerts(propertyId: $propertyId) {
      propertyId
      activeAlertCount
      statusItems {
        label
        count
        total
        group
        color
        action
        options
      }
    }
  }
`;

/**
 * __usePropertySummaryAlertsQuery__
 *
 * To run a query within a React component, call `usePropertySummaryAlertsQuery` and pass it any options that fit your needs.
 * When your component renders, `usePropertySummaryAlertsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePropertySummaryAlertsQuery({
 *   variables: {
 *      propertyId: // value for 'propertyId'
 *   },
 * });
 */
export function usePropertySummaryAlertsQuery(
  baseOptions: Apollo.QueryHookOptions<
    PropertySummaryAlertsQuery,
    PropertySummaryAlertsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    PropertySummaryAlertsQuery,
    PropertySummaryAlertsQueryVariables
  >(PropertySummaryAlertsDocument, options);
}
export function usePropertySummaryAlertsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    PropertySummaryAlertsQuery,
    PropertySummaryAlertsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    PropertySummaryAlertsQuery,
    PropertySummaryAlertsQueryVariables
  >(PropertySummaryAlertsDocument, options);
}
export type PropertySummaryAlertsQueryHookResult = ReturnType<
  typeof usePropertySummaryAlertsQuery
>;
export type PropertySummaryAlertsLazyQueryHookResult = ReturnType<
  typeof usePropertySummaryAlertsLazyQuery
>;
export type PropertySummaryAlertsQueryResult = Apollo.QueryResult<
  PropertySummaryAlertsQuery,
  PropertySummaryAlertsQueryVariables
>;
export const PropertySummaryDevicesDocument = gql`
  query PropertySummaryDevices($propertyId: String!) {
    propertySummaryDevices(propertyId: $propertyId) {
      propertyId
      residentialDevices {
        label
        count
      }
      centralDevices {
        label
        count
      }
    }
  }
`;

/**
 * __usePropertySummaryDevicesQuery__
 *
 * To run a query within a React component, call `usePropertySummaryDevicesQuery` and pass it any options that fit your needs.
 * When your component renders, `usePropertySummaryDevicesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePropertySummaryDevicesQuery({
 *   variables: {
 *      propertyId: // value for 'propertyId'
 *   },
 * });
 */
export function usePropertySummaryDevicesQuery(
  baseOptions: Apollo.QueryHookOptions<
    PropertySummaryDevicesQuery,
    PropertySummaryDevicesQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    PropertySummaryDevicesQuery,
    PropertySummaryDevicesQueryVariables
  >(PropertySummaryDevicesDocument, options);
}
export function usePropertySummaryDevicesLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    PropertySummaryDevicesQuery,
    PropertySummaryDevicesQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    PropertySummaryDevicesQuery,
    PropertySummaryDevicesQueryVariables
  >(PropertySummaryDevicesDocument, options);
}
export type PropertySummaryDevicesQueryHookResult = ReturnType<
  typeof usePropertySummaryDevicesQuery
>;
export type PropertySummaryDevicesLazyQueryHookResult = ReturnType<
  typeof usePropertySummaryDevicesLazyQuery
>;
export type PropertySummaryDevicesQueryResult = Apollo.QueryResult<
  PropertySummaryDevicesQuery,
  PropertySummaryDevicesQueryVariables
>;
export const PropertySummaryStatsDocument = gql`
  query PropertySummaryStats($propertyId: String!) {
    propertySummaryStats(propertyId: $propertyId) {
      propertyId
      temperature {
        min
        max
        ave
      }
      humidity {
        min
        max
        ave
      }
    }
  }
`;

/**
 * __usePropertySummaryStatsQuery__
 *
 * To run a query within a React component, call `usePropertySummaryStatsQuery` and pass it any options that fit your needs.
 * When your component renders, `usePropertySummaryStatsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePropertySummaryStatsQuery({
 *   variables: {
 *      propertyId: // value for 'propertyId'
 *   },
 * });
 */
export function usePropertySummaryStatsQuery(
  baseOptions: Apollo.QueryHookOptions<
    PropertySummaryStatsQuery,
    PropertySummaryStatsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    PropertySummaryStatsQuery,
    PropertySummaryStatsQueryVariables
  >(PropertySummaryStatsDocument, options);
}
export function usePropertySummaryStatsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    PropertySummaryStatsQuery,
    PropertySummaryStatsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    PropertySummaryStatsQuery,
    PropertySummaryStatsQueryVariables
  >(PropertySummaryStatsDocument, options);
}
export type PropertySummaryStatsQueryHookResult = ReturnType<
  typeof usePropertySummaryStatsQuery
>;
export type PropertySummaryStatsLazyQueryHookResult = ReturnType<
  typeof usePropertySummaryStatsLazyQuery
>;
export type PropertySummaryStatsQueryResult = Apollo.QueryResult<
  PropertySummaryStatsQuery,
  PropertySummaryStatsQueryVariables
>;
export const PropertyPlmSummariesDocument = gql`
  query PropertyPlmSummaries($ids: [String!]!) {
    propertyPlmSummaries(ids: $ids) {
      propertyId
      activeCount
      scheduledCount
      nextScheduledStart
      firstActiveResponseId
    }
  }
`;

/**
 * __usePropertyPlmSummariesQuery__
 *
 * To run a query within a React component, call `usePropertyPlmSummariesQuery` and pass it any options that fit your needs.
 * When your component renders, `usePropertyPlmSummariesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePropertyPlmSummariesQuery({
 *   variables: {
 *      ids: // value for 'ids'
 *   },
 * });
 */
export function usePropertyPlmSummariesQuery(
  baseOptions: Apollo.QueryHookOptions<
    PropertyPlmSummariesQuery,
    PropertyPlmSummariesQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    PropertyPlmSummariesQuery,
    PropertyPlmSummariesQueryVariables
  >(PropertyPlmSummariesDocument, options);
}
export function usePropertyPlmSummariesLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    PropertyPlmSummariesQuery,
    PropertyPlmSummariesQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    PropertyPlmSummariesQuery,
    PropertyPlmSummariesQueryVariables
  >(PropertyPlmSummariesDocument, options);
}
export type PropertyPlmSummariesQueryHookResult = ReturnType<
  typeof usePropertyPlmSummariesQuery
>;
export type PropertyPlmSummariesLazyQueryHookResult = ReturnType<
  typeof usePropertyPlmSummariesLazyQuery
>;
export type PropertyPlmSummariesQueryResult = Apollo.QueryResult<
  PropertyPlmSummariesQuery,
  PropertyPlmSummariesQueryVariables
>;
export const RemovePropertyDocument = gql`
  mutation RemoveProperty($id: String!) {
    deleteProperty(_id: $id)
  }
`;
export type RemovePropertyMutationFn = Apollo.MutationFunction<
  RemovePropertyMutation,
  RemovePropertyMutationVariables
>;

/**
 * __useRemovePropertyMutation__
 *
 * To run a mutation, you first call `useRemovePropertyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemovePropertyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removePropertyMutation, { data, loading, error }] = useRemovePropertyMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useRemovePropertyMutation(
  baseOptions?: Apollo.MutationHookOptions<
    RemovePropertyMutation,
    RemovePropertyMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    RemovePropertyMutation,
    RemovePropertyMutationVariables
  >(RemovePropertyDocument, options);
}
export type RemovePropertyMutationHookResult = ReturnType<
  typeof useRemovePropertyMutation
>;
export type RemovePropertyMutationResult =
  Apollo.MutationResult<RemovePropertyMutation>;
export type RemovePropertyMutationOptions = Apollo.BaseMutationOptions<
  RemovePropertyMutation,
  RemovePropertyMutationVariables
>;
export const UpdatePropertyDocument = gql`
  mutation UpdateProperty($id: String!, $property: UpdateOnePropertyInput!) {
    updateProperty(id: $id, property: $property) {
      _id
      title
      imageUrl
      hasSecondaryHeatSource
      thermostatScheduleTemplateId
      organizationId
      address {
        line1
        line2
        city
        state
        postalCode
      }
      owner {
        name
        email
        mobile
        phone
      }
      propMgr {
        name
        email
        mobile
        phone
      }
      contact {
        email
        email2
        email3
        smsNumber
        smsNumber2
        smsNumber3
      }
      alertLimits {
        units {
          temperature {
            min
            max
          }
          humidity {
            min
            max
          }
        }
        plant {
          loops {
            temperature {
              min
              max
            }
            pressure {
              min
              max
            }
          }
          dhw {
            temperature {
              min
              max
            }
          }
        }
      }
    }
  }
`;
export type UpdatePropertyMutationFn = Apollo.MutationFunction<
  UpdatePropertyMutation,
  UpdatePropertyMutationVariables
>;

/**
 * __useUpdatePropertyMutation__
 *
 * To run a mutation, you first call `useUpdatePropertyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdatePropertyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updatePropertyMutation, { data, loading, error }] = useUpdatePropertyMutation({
 *   variables: {
 *      id: // value for 'id'
 *      property: // value for 'property'
 *   },
 * });
 */
export function useUpdatePropertyMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UpdatePropertyMutation,
    UpdatePropertyMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    UpdatePropertyMutation,
    UpdatePropertyMutationVariables
  >(UpdatePropertyDocument, options);
}
export type UpdatePropertyMutationHookResult = ReturnType<
  typeof useUpdatePropertyMutation
>;
export type UpdatePropertyMutationResult =
  Apollo.MutationResult<UpdatePropertyMutation>;
export type UpdatePropertyMutationOptions = Apollo.BaseMutationOptions<
  UpdatePropertyMutation,
  UpdatePropertyMutationVariables
>;
export const QuarterlyReportDataExportJobsDocument = gql`
  query QuarterlyReportDataExportJobs {
    quarterlyReportDataExportJobs {
      ...QuarterlyReportDataExportJobFields
    }
  }
  ${QuarterlyReportDataExportJobFieldsFragmentDoc}
`;

/**
 * __useQuarterlyReportDataExportJobsQuery__
 *
 * To run a query within a React component, call `useQuarterlyReportDataExportJobsQuery` and pass it any options that fit your needs.
 * When your component renders, `useQuarterlyReportDataExportJobsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useQuarterlyReportDataExportJobsQuery({
 *   variables: {
 *   },
 * });
 */
export function useQuarterlyReportDataExportJobsQuery(
  baseOptions?: Apollo.QueryHookOptions<
    QuarterlyReportDataExportJobsQuery,
    QuarterlyReportDataExportJobsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    QuarterlyReportDataExportJobsQuery,
    QuarterlyReportDataExportJobsQueryVariables
  >(QuarterlyReportDataExportJobsDocument, options);
}
export function useQuarterlyReportDataExportJobsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    QuarterlyReportDataExportJobsQuery,
    QuarterlyReportDataExportJobsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    QuarterlyReportDataExportJobsQuery,
    QuarterlyReportDataExportJobsQueryVariables
  >(QuarterlyReportDataExportJobsDocument, options);
}
export type QuarterlyReportDataExportJobsQueryHookResult = ReturnType<
  typeof useQuarterlyReportDataExportJobsQuery
>;
export type QuarterlyReportDataExportJobsLazyQueryHookResult = ReturnType<
  typeof useQuarterlyReportDataExportJobsLazyQuery
>;
export type QuarterlyReportDataExportJobsQueryResult = Apollo.QueryResult<
  QuarterlyReportDataExportJobsQuery,
  QuarterlyReportDataExportJobsQueryVariables
>;
export const SubmitQuarterlyReportDataExportJobsDocument = gql`
  mutation SubmitQuarterlyReportDataExportJobs(
    $input: QuarterlyReportDataExportSubmitInput!
  ) {
    submitQuarterlyReportDataExportJobs(input: $input) {
      ...QuarterlyReportDataExportJobFields
    }
  }
  ${QuarterlyReportDataExportJobFieldsFragmentDoc}
`;
export type SubmitQuarterlyReportDataExportJobsMutationFn =
  Apollo.MutationFunction<
    SubmitQuarterlyReportDataExportJobsMutation,
    SubmitQuarterlyReportDataExportJobsMutationVariables
  >;

/**
 * __useSubmitQuarterlyReportDataExportJobsMutation__
 *
 * To run a mutation, you first call `useSubmitQuarterlyReportDataExportJobsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSubmitQuarterlyReportDataExportJobsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [submitQuarterlyReportDataExportJobsMutation, { data, loading, error }] = useSubmitQuarterlyReportDataExportJobsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSubmitQuarterlyReportDataExportJobsMutation(
  baseOptions?: Apollo.MutationHookOptions<
    SubmitQuarterlyReportDataExportJobsMutation,
    SubmitQuarterlyReportDataExportJobsMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    SubmitQuarterlyReportDataExportJobsMutation,
    SubmitQuarterlyReportDataExportJobsMutationVariables
  >(SubmitQuarterlyReportDataExportJobsDocument, options);
}
export type SubmitQuarterlyReportDataExportJobsMutationHookResult = ReturnType<
  typeof useSubmitQuarterlyReportDataExportJobsMutation
>;
export type SubmitQuarterlyReportDataExportJobsMutationResult =
  Apollo.MutationResult<SubmitQuarterlyReportDataExportJobsMutation>;
export type SubmitQuarterlyReportDataExportJobsMutationOptions =
  Apollo.BaseMutationOptions<
    SubmitQuarterlyReportDataExportJobsMutation,
    SubmitQuarterlyReportDataExportJobsMutationVariables
  >;
export const DeleteQuarterlyReportDataExportJobDocument = gql`
  mutation DeleteQuarterlyReportDataExportJob($id: String!) {
    deleteQuarterlyReportDataExportJob(id: $id) {
      ...QuarterlyReportDataExportJobFields
    }
  }
  ${QuarterlyReportDataExportJobFieldsFragmentDoc}
`;
export type DeleteQuarterlyReportDataExportJobMutationFn =
  Apollo.MutationFunction<
    DeleteQuarterlyReportDataExportJobMutation,
    DeleteQuarterlyReportDataExportJobMutationVariables
  >;

/**
 * __useDeleteQuarterlyReportDataExportJobMutation__
 *
 * To run a mutation, you first call `useDeleteQuarterlyReportDataExportJobMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteQuarterlyReportDataExportJobMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteQuarterlyReportDataExportJobMutation, { data, loading, error }] = useDeleteQuarterlyReportDataExportJobMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteQuarterlyReportDataExportJobMutation(
  baseOptions?: Apollo.MutationHookOptions<
    DeleteQuarterlyReportDataExportJobMutation,
    DeleteQuarterlyReportDataExportJobMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    DeleteQuarterlyReportDataExportJobMutation,
    DeleteQuarterlyReportDataExportJobMutationVariables
  >(DeleteQuarterlyReportDataExportJobDocument, options);
}
export type DeleteQuarterlyReportDataExportJobMutationHookResult = ReturnType<
  typeof useDeleteQuarterlyReportDataExportJobMutation
>;
export type DeleteQuarterlyReportDataExportJobMutationResult =
  Apollo.MutationResult<DeleteQuarterlyReportDataExportJobMutation>;
export type DeleteQuarterlyReportDataExportJobMutationOptions =
  Apollo.BaseMutationOptions<
    DeleteQuarterlyReportDataExportJobMutation,
    DeleteQuarterlyReportDataExportJobMutationVariables
  >;
export const QuarterlyReportDataExportJobDownloadUrlDocument = gql`
  query QuarterlyReportDataExportJobDownloadUrl(
    $id: String!
    $artifactKind: String
  ) {
    quarterlyReportDataExportJobDownloadUrl(
      id: $id
      artifactKind: $artifactKind
    )
  }
`;

/**
 * __useQuarterlyReportDataExportJobDownloadUrlQuery__
 *
 * To run a query within a React component, call `useQuarterlyReportDataExportJobDownloadUrlQuery` and pass it any options that fit your needs.
 * When your component renders, `useQuarterlyReportDataExportJobDownloadUrlQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useQuarterlyReportDataExportJobDownloadUrlQuery({
 *   variables: {
 *      id: // value for 'id'
 *      artifactKind: // value for 'artifactKind'
 *   },
 * });
 */
export function useQuarterlyReportDataExportJobDownloadUrlQuery(
  baseOptions: Apollo.QueryHookOptions<
    QuarterlyReportDataExportJobDownloadUrlQuery,
    QuarterlyReportDataExportJobDownloadUrlQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    QuarterlyReportDataExportJobDownloadUrlQuery,
    QuarterlyReportDataExportJobDownloadUrlQueryVariables
  >(QuarterlyReportDataExportJobDownloadUrlDocument, options);
}
export function useQuarterlyReportDataExportJobDownloadUrlLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    QuarterlyReportDataExportJobDownloadUrlQuery,
    QuarterlyReportDataExportJobDownloadUrlQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    QuarterlyReportDataExportJobDownloadUrlQuery,
    QuarterlyReportDataExportJobDownloadUrlQueryVariables
  >(QuarterlyReportDataExportJobDownloadUrlDocument, options);
}
export type QuarterlyReportDataExportJobDownloadUrlQueryHookResult = ReturnType<
  typeof useQuarterlyReportDataExportJobDownloadUrlQuery
>;
export type QuarterlyReportDataExportJobDownloadUrlLazyQueryHookResult =
  ReturnType<typeof useQuarterlyReportDataExportJobDownloadUrlLazyQuery>;
export type QuarterlyReportDataExportJobDownloadUrlQueryResult =
  Apollo.QueryResult<
    QuarterlyReportDataExportJobDownloadUrlQuery,
    QuarterlyReportDataExportJobDownloadUrlQueryVariables
  >;
export const ClearThermostatUpdateStatusDocument = gql`
  mutation ClearThermostatUpdateStatus($deviceId: String!) {
    clearThermostatUpdateStatus(deviceId: $deviceId) {
      _id
      deviceId
      name
      type
      hasPendingUpdates
      coolSetpoint {
        timestamp
        value
        units
        updatePending
      }
      heatSetpoint {
        timestamp
        value
        units
        updatePending
      }
      fanMode {
        timestamp
        value
        units
        updatePending
      }
      fanSpeed {
        timestamp
        value
        units
        updatePending
      }
      fanState {
        timestamp
        value
        units
        updatePending
      }
      holdDuration {
        timestamp
        value
        units
        updatePending
      }
      holdEnd {
        timestamp
        value
        units
        updatePending
      }
      holdExpiryTime {
        timestamp
        value
        units
        updatePending
      }
      holdState {
        timestamp
        value
        units
        updatePending
      }
      humidity {
        timestamp
        value
        units
        updatePending
      }
      keypadLockoutLevel {
        timestamp
        value
        units
        updatePending
      }
      lastScheduleChange {
        timestamp
        value
        units
        updatePending
      }
      lastSetpointChange {
        timestamp
        value
        units
        updatePending
      }
      maxCoolSetpointLimit {
        timestamp
        value
        units
        updatePending
      }
      maxHeatSetpointLimit {
        timestamp
        value
        units
        updatePending
      }
      minCoolSetpointLimit {
        timestamp
        value
        units
        updatePending
      }
      minHeatSetpointLimit {
        timestamp
        value
        units
        updatePending
      }
      operatingMode {
        timestamp
        value
        units
        updatePending
      }
      operatingState {
        timestamp
        value
        units
        updatePending
      }
      passCode {
        timestamp
        value
        units
        updatePending
      }
      progMode {
        timestamp
        value
        units
        updatePending
      }
      pairingState {
        timestamp
        value
        units
        updatePending
      }
      remoteSensorTempDelta {
        timestamp
        value
        units
        updatePending
      }
      schedVisibilityMode {
        timestamp
        value
        units
        updatePending
      }
      setpointChangeSource {
        timestamp
        value
        units
        updatePending
      }
      showFanButton {
        timestamp
        value
        units
        updatePending
      }
      systemType {
        timestamp
        value
        units
        updatePending
      }
      tempDisplayMode {
        timestamp
        value
        units
        updatePending
      }
      temperature {
        timestamp
        value
        units
        updatePending
      }
      uiOptions {
        timestamp
        value
        units
        updatePending
      }
    }
  }
`;
export type ClearThermostatUpdateStatusMutationFn = Apollo.MutationFunction<
  ClearThermostatUpdateStatusMutation,
  ClearThermostatUpdateStatusMutationVariables
>;

/**
 * __useClearThermostatUpdateStatusMutation__
 *
 * To run a mutation, you first call `useClearThermostatUpdateStatusMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useClearThermostatUpdateStatusMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [clearThermostatUpdateStatusMutation, { data, loading, error }] = useClearThermostatUpdateStatusMutation({
 *   variables: {
 *      deviceId: // value for 'deviceId'
 *   },
 * });
 */
export function useClearThermostatUpdateStatusMutation(
  baseOptions?: Apollo.MutationHookOptions<
    ClearThermostatUpdateStatusMutation,
    ClearThermostatUpdateStatusMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    ClearThermostatUpdateStatusMutation,
    ClearThermostatUpdateStatusMutationVariables
  >(ClearThermostatUpdateStatusDocument, options);
}
export type ClearThermostatUpdateStatusMutationHookResult = ReturnType<
  typeof useClearThermostatUpdateStatusMutation
>;
export type ClearThermostatUpdateStatusMutationResult =
  Apollo.MutationResult<ClearThermostatUpdateStatusMutation>;
export type ClearThermostatUpdateStatusMutationOptions =
  Apollo.BaseMutationOptions<
    ClearThermostatUpdateStatusMutation,
    ClearThermostatUpdateStatusMutationVariables
  >;
export const ConductorGenericSensorDetailUpdateDocument = gql`
  subscription ConductorGenericSensorDetailUpdate($ids: [String!]!) {
    conductorGenericSensorEventsByIds(_ids: $ids) {
      modelChangeOperation
      _id
      type
      typeDisplayName
      zoneId
      name
      deviceId
      sourceId
      timestamp
      isConfigured
      displayName
      supportsResetCounters
      meta {
        name
        model
        modelNumber
        version
        metrics
      }
      zone {
        _id
        name
      }
      source {
        _id
        name
      }
      counterValue {
        timestamp
        value
        units
      }
      resetCount {
        timestamp
        value
        units
      }
      temperature {
        timestamp
        value
        units
      }
      humidity {
        timestamp
        value
        units
      }
      setpoint {
        timestamp
        value
        units
      }
      systemMode {
        timestamp
        value
        units
      }
      fanSpeed {
        timestamp
        value
        units
      }
      alarmState {
        timestamp
        value
        units
      }
    }
  }
`;

/**
 * __useConductorGenericSensorDetailUpdateSubscription__
 *
 * To run a query within a React component, call `useConductorGenericSensorDetailUpdateSubscription` and pass it any options that fit your needs.
 * When your component renders, `useConductorGenericSensorDetailUpdateSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useConductorGenericSensorDetailUpdateSubscription({
 *   variables: {
 *      ids: // value for 'ids'
 *   },
 * });
 */
export function useConductorGenericSensorDetailUpdateSubscription(
  baseOptions: Apollo.SubscriptionHookOptions<
    ConductorGenericSensorDetailUpdateSubscription,
    ConductorGenericSensorDetailUpdateSubscriptionVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useSubscription<
    ConductorGenericSensorDetailUpdateSubscription,
    ConductorGenericSensorDetailUpdateSubscriptionVariables
  >(ConductorGenericSensorDetailUpdateDocument, options);
}
export type ConductorGenericSensorDetailUpdateSubscriptionHookResult =
  ReturnType<typeof useConductorGenericSensorDetailUpdateSubscription>;
export type ConductorGenericSensorDetailUpdateSubscriptionResult =
  Apollo.SubscriptionResult<ConductorGenericSensorDetailUpdateSubscription>;
export const ConductorGenericSensorDetailDocument = gql`
  query ConductorGenericSensorDetail($id: String!) {
    conductorGenericSensorById(_id: $id) {
      _id
      type
      typeDisplayName
      zoneId
      name
      deviceId
      sourceId
      timestamp
      isConfigured
      displayName
      supportsResetCounters
      meta {
        name
        model
        modelNumber
        version
        metrics
      }
      zone {
        _id
        name
      }
      source {
        _id
        name
      }
      counterValue {
        timestamp
        value
        units
      }
      resetCount {
        timestamp
        value
        units
      }
      temperature {
        timestamp
        value
        units
      }
      humidity {
        timestamp
        value
        units
      }
      setpoint {
        timestamp
        value
        units
      }
      systemMode {
        timestamp
        value
        units
      }
      fanSpeed {
        timestamp
        value
        units
      }
      alarmState {
        timestamp
        value
        units
      }
    }
  }
`;

/**
 * __useConductorGenericSensorDetailQuery__
 *
 * To run a query within a React component, call `useConductorGenericSensorDetailQuery` and pass it any options that fit your needs.
 * When your component renders, `useConductorGenericSensorDetailQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useConductorGenericSensorDetailQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useConductorGenericSensorDetailQuery(
  baseOptions: Apollo.QueryHookOptions<
    ConductorGenericSensorDetailQuery,
    ConductorGenericSensorDetailQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    ConductorGenericSensorDetailQuery,
    ConductorGenericSensorDetailQueryVariables
  >(ConductorGenericSensorDetailDocument, options);
}
export function useConductorGenericSensorDetailLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    ConductorGenericSensorDetailQuery,
    ConductorGenericSensorDetailQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    ConductorGenericSensorDetailQuery,
    ConductorGenericSensorDetailQueryVariables
  >(ConductorGenericSensorDetailDocument, options);
}
export type ConductorGenericSensorDetailQueryHookResult = ReturnType<
  typeof useConductorGenericSensorDetailQuery
>;
export type ConductorGenericSensorDetailLazyQueryHookResult = ReturnType<
  typeof useConductorGenericSensorDetailLazyQuery
>;
export type ConductorGenericSensorDetailQueryResult = Apollo.QueryResult<
  ConductorGenericSensorDetailQuery,
  ConductorGenericSensorDetailQueryVariables
>;
export const ResetConductorGenericSensorCountersDocument = gql`
  mutation ResetConductorGenericSensorCounters($deviceId: String!) {
    resetConductorGenericSensorCounters(deviceId: $deviceId) {
      _id
      type
    }
  }
`;
export type ResetConductorGenericSensorCountersMutationFn =
  Apollo.MutationFunction<
    ResetConductorGenericSensorCountersMutation,
    ResetConductorGenericSensorCountersMutationVariables
  >;

/**
 * __useResetConductorGenericSensorCountersMutation__
 *
 * To run a mutation, you first call `useResetConductorGenericSensorCountersMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useResetConductorGenericSensorCountersMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [resetConductorGenericSensorCountersMutation, { data, loading, error }] = useResetConductorGenericSensorCountersMutation({
 *   variables: {
 *      deviceId: // value for 'deviceId'
 *   },
 * });
 */
export function useResetConductorGenericSensorCountersMutation(
  baseOptions?: Apollo.MutationHookOptions<
    ResetConductorGenericSensorCountersMutation,
    ResetConductorGenericSensorCountersMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    ResetConductorGenericSensorCountersMutation,
    ResetConductorGenericSensorCountersMutationVariables
  >(ResetConductorGenericSensorCountersDocument, options);
}
export type ResetConductorGenericSensorCountersMutationHookResult = ReturnType<
  typeof useResetConductorGenericSensorCountersMutation
>;
export type ResetConductorGenericSensorCountersMutationResult =
  Apollo.MutationResult<ResetConductorGenericSensorCountersMutation>;
export type ResetConductorGenericSensorCountersMutationOptions =
  Apollo.BaseMutationOptions<
    ResetConductorGenericSensorCountersMutation,
    ResetConductorGenericSensorCountersMutationVariables
  >;
export const DoorSensorDetailUpdateDocument = gql`
  subscription DoorSensorDetailUpdate($ids: [String!]!) {
    doorSensorEventsByIds(_ids: $ids) {
      modelChangeOperation
      _id
      type
      typeDisplayName
      zoneId
      name
      deviceId
      isConfigured
      timestamp
      meta {
        name
        model
        modelNumber
        version
      }
      contactState {
        timestamp
        value
        units
      }
      voltage {
        timestamp
        value
        units
      }
      alertTypes {
        deviceAlert
      }
      hasContactState
      deviceAlerts {
        _id
        type {
          name
        }
        device {
          id
          name
          type
        }
        initiated
        updated
      }
      sourceAlerts {
        _id
        type {
          name
        }
        device {
          id
          name
          type
        }
        initiated
        updated
      }
    }
  }
`;

/**
 * __useDoorSensorDetailUpdateSubscription__
 *
 * To run a query within a React component, call `useDoorSensorDetailUpdateSubscription` and pass it any options that fit your needs.
 * When your component renders, `useDoorSensorDetailUpdateSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDoorSensorDetailUpdateSubscription({
 *   variables: {
 *      ids: // value for 'ids'
 *   },
 * });
 */
export function useDoorSensorDetailUpdateSubscription(
  baseOptions: Apollo.SubscriptionHookOptions<
    DoorSensorDetailUpdateSubscription,
    DoorSensorDetailUpdateSubscriptionVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useSubscription<
    DoorSensorDetailUpdateSubscription,
    DoorSensorDetailUpdateSubscriptionVariables
  >(DoorSensorDetailUpdateDocument, options);
}
export type DoorSensorDetailUpdateSubscriptionHookResult = ReturnType<
  typeof useDoorSensorDetailUpdateSubscription
>;
export type DoorSensorDetailUpdateSubscriptionResult =
  Apollo.SubscriptionResult<DoorSensorDetailUpdateSubscription>;
export const DoorSensorDetailDocument = gql`
  query DoorSensorDetail($id: String!) {
    doorSensorById(_id: $id) {
      _id
      type
      typeDisplayName
      zoneId
      name
      deviceId
      isConfigured
      timestamp
      meta {
        name
        model
        modelNumber
        version
      }
      zone {
        _id
        name
      }
      source {
        _id
        name
      }
      contactState {
        timestamp
        value
        units
      }
      voltage {
        timestamp
        value
        units
      }
      alertTypes {
        deviceAlert
      }
      hasContactState
      deviceAlerts {
        _id
        type {
          name
        }
        device {
          id
          name
          type
        }
        initiated
        updated
      }
      sourceAlerts {
        _id
        type {
          name
        }
        device {
          id
          name
          type
        }
        initiated
        updated
      }
    }
  }
`;

/**
 * __useDoorSensorDetailQuery__
 *
 * To run a query within a React component, call `useDoorSensorDetailQuery` and pass it any options that fit your needs.
 * When your component renders, `useDoorSensorDetailQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDoorSensorDetailQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDoorSensorDetailQuery(
  baseOptions: Apollo.QueryHookOptions<
    DoorSensorDetailQuery,
    DoorSensorDetailQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<DoorSensorDetailQuery, DoorSensorDetailQueryVariables>(
    DoorSensorDetailDocument,
    options,
  );
}
export function useDoorSensorDetailLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    DoorSensorDetailQuery,
    DoorSensorDetailQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    DoorSensorDetailQuery,
    DoorSensorDetailQueryVariables
  >(DoorSensorDetailDocument, options);
}
export type DoorSensorDetailQueryHookResult = ReturnType<
  typeof useDoorSensorDetailQuery
>;
export type DoorSensorDetailLazyQueryHookResult = ReturnType<
  typeof useDoorSensorDetailLazyQuery
>;
export type DoorSensorDetailQueryResult = Apollo.QueryResult<
  DoorSensorDetailQuery,
  DoorSensorDetailQueryVariables
>;
export const IndoorAirHandlerDetailDocument = gql`
  query IndoorAirHandlerDetail($id: String!) {
    indoorAirHandlerById(_id: $id) {
      _id
      type
      typeDisplayName
      panelId
      name
      deviceId
      timestamp
      isConfigured
      meta {
        name
        model
        modelNumber
        version
      }
      zone {
        _id
        name
      }
      source {
        _id
        name
      }
      fanSpeed {
        timestamp
        value
        units
      }
      maxCoolSetpointLimit {
        timestamp
        value
        units
      }
      maxHeatSetpointLimit {
        timestamp
        value
        units
      }
      minCoolSetpointLimit {
        timestamp
        value
        units
      }
      minHeatSetpointLimit {
        timestamp
        value
        units
      }
      operatingMode {
        timestamp
        value
        units
      }
      indoorFanStatus {
        timestamp
        value
        units
      }
      operatingState {
        timestamp
        value
        units
      }
      temperature {
        timestamp
        value
        units
      }
      heatSetpoint {
        timestamp
        value
        units
      }
      coolSetpoint {
        timestamp
        value
        units
      }
      deviceAlerts {
        _id
        type {
          name
        }
        device {
          id
          name
          type
        }
        initiated
        updated
      }
      sourceAlerts {
        _id
        type {
          name
        }
        device {
          id
          name
          type
        }
        initiated
        updated
      }
    }
  }
`;

/**
 * __useIndoorAirHandlerDetailQuery__
 *
 * To run a query within a React component, call `useIndoorAirHandlerDetailQuery` and pass it any options that fit your needs.
 * When your component renders, `useIndoorAirHandlerDetailQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useIndoorAirHandlerDetailQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useIndoorAirHandlerDetailQuery(
  baseOptions: Apollo.QueryHookOptions<
    IndoorAirHandlerDetailQuery,
    IndoorAirHandlerDetailQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    IndoorAirHandlerDetailQuery,
    IndoorAirHandlerDetailQueryVariables
  >(IndoorAirHandlerDetailDocument, options);
}
export function useIndoorAirHandlerDetailLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    IndoorAirHandlerDetailQuery,
    IndoorAirHandlerDetailQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    IndoorAirHandlerDetailQuery,
    IndoorAirHandlerDetailQueryVariables
  >(IndoorAirHandlerDetailDocument, options);
}
export type IndoorAirHandlerDetailQueryHookResult = ReturnType<
  typeof useIndoorAirHandlerDetailQuery
>;
export type IndoorAirHandlerDetailLazyQueryHookResult = ReturnType<
  typeof useIndoorAirHandlerDetailLazyQuery
>;
export type IndoorAirHandlerDetailQueryResult = Apollo.QueryResult<
  IndoorAirHandlerDetailQuery,
  IndoorAirHandlerDetailQueryVariables
>;
export const IndoorSensorDetailUpdateDocument = gql`
  subscription IndoorSensorDetailUpdate($ids: [String!]!) {
    indoorSensorEventsByIds(_ids: $ids) {
      modelChangeOperation
      _id
      type
      typeDisplayName
      zoneId
      name
      deviceId
      sourceId
      timestamp
      isConfigured
      meta {
        name
        model
        modelNumber
        version
        display {
          temperature
          humidity
        }
      }
      temperature {
        timestamp
        value
        units
      }
      humidity {
        timestamp
        value
        units
      }
      voltage {
        timestamp
        value
        units
      }
      deviceAlerts {
        _id
        type {
          name
        }
        device {
          id
          name
          type
        }
        initiated
        updated
      }
      sourceAlerts {
        _id
        type {
          name
        }
        device {
          id
          name
          type
        }
        initiated
        updated
      }
    }
  }
`;

/**
 * __useIndoorSensorDetailUpdateSubscription__
 *
 * To run a query within a React component, call `useIndoorSensorDetailUpdateSubscription` and pass it any options that fit your needs.
 * When your component renders, `useIndoorSensorDetailUpdateSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useIndoorSensorDetailUpdateSubscription({
 *   variables: {
 *      ids: // value for 'ids'
 *   },
 * });
 */
export function useIndoorSensorDetailUpdateSubscription(
  baseOptions: Apollo.SubscriptionHookOptions<
    IndoorSensorDetailUpdateSubscription,
    IndoorSensorDetailUpdateSubscriptionVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useSubscription<
    IndoorSensorDetailUpdateSubscription,
    IndoorSensorDetailUpdateSubscriptionVariables
  >(IndoorSensorDetailUpdateDocument, options);
}
export type IndoorSensorDetailUpdateSubscriptionHookResult = ReturnType<
  typeof useIndoorSensorDetailUpdateSubscription
>;
export type IndoorSensorDetailUpdateSubscriptionResult =
  Apollo.SubscriptionResult<IndoorSensorDetailUpdateSubscription>;
export const IndoorSensorDetailDocument = gql`
  query IndoorSensorDetail($id: String!) {
    indoorSensorById(_id: $id) {
      _id
      type
      typeDisplayName
      zoneId
      name
      deviceId
      sourceId
      timestamp
      isConfigured
      meta {
        name
        model
        modelNumber
        version
        display {
          temperature
          humidity
        }
      }
      zone {
        _id
        name
      }
      source {
        _id
        name
      }
      temperature {
        timestamp
        value
        units
      }
      humidity {
        timestamp
        value
        units
      }
      voltage {
        timestamp
        value
        units
      }
      deviceAlerts {
        _id
        type {
          name
        }
        device {
          id
          name
          type
        }
        initiated
        updated
      }
      sourceAlerts {
        _id
        type {
          name
        }
        device {
          id
          name
          type
        }
        initiated
        updated
      }
    }
  }
`;

/**
 * __useIndoorSensorDetailQuery__
 *
 * To run a query within a React component, call `useIndoorSensorDetailQuery` and pass it any options that fit your needs.
 * When your component renders, `useIndoorSensorDetailQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useIndoorSensorDetailQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useIndoorSensorDetailQuery(
  baseOptions: Apollo.QueryHookOptions<
    IndoorSensorDetailQuery,
    IndoorSensorDetailQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    IndoorSensorDetailQuery,
    IndoorSensorDetailQueryVariables
  >(IndoorSensorDetailDocument, options);
}
export function useIndoorSensorDetailLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    IndoorSensorDetailQuery,
    IndoorSensorDetailQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    IndoorSensorDetailQuery,
    IndoorSensorDetailQueryVariables
  >(IndoorSensorDetailDocument, options);
}
export type IndoorSensorDetailQueryHookResult = ReturnType<
  typeof useIndoorSensorDetailQuery
>;
export type IndoorSensorDetailLazyQueryHookResult = ReturnType<
  typeof useIndoorSensorDetailLazyQuery
>;
export type IndoorSensorDetailQueryResult = Apollo.QueryResult<
  IndoorSensorDetailQuery,
  IndoorSensorDetailQueryVariables
>;
export const LeakDetectorDetailUpdateDocument = gql`
  subscription LeakDetectorDetailUpdate($ids: [String!]!) {
    leakDetectorEventsByIds(_ids: $ids) {
      modelChangeOperation
      _id
      type
      typeDisplayName
      panelId
      name
      deviceId
      timestamp
      isConfigured
      meta {
        name
        model
        modelNumber
        version
      }
      batteryVoltageMinThreshold {
        timestamp
        value
        units
      }
      batteryVoltageMinThresholdReached {
        timestamp
        value
        units
      }
      leakStatus1 {
        timestamp
        value
        units
      }
      leakStatus2 {
        timestamp
        value
        units
      }
      voltage {
        timestamp
        value
        units
      }
      deviceAlerts {
        _id
        type {
          name
        }
        device {
          id
          name
          type
        }
        initiated
        updated
      }
      sourceAlerts {
        _id
        type {
          name
        }
        device {
          id
          name
          type
        }
        initiated
        updated
      }
    }
  }
`;

/**
 * __useLeakDetectorDetailUpdateSubscription__
 *
 * To run a query within a React component, call `useLeakDetectorDetailUpdateSubscription` and pass it any options that fit your needs.
 * When your component renders, `useLeakDetectorDetailUpdateSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLeakDetectorDetailUpdateSubscription({
 *   variables: {
 *      ids: // value for 'ids'
 *   },
 * });
 */
export function useLeakDetectorDetailUpdateSubscription(
  baseOptions: Apollo.SubscriptionHookOptions<
    LeakDetectorDetailUpdateSubscription,
    LeakDetectorDetailUpdateSubscriptionVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useSubscription<
    LeakDetectorDetailUpdateSubscription,
    LeakDetectorDetailUpdateSubscriptionVariables
  >(LeakDetectorDetailUpdateDocument, options);
}
export type LeakDetectorDetailUpdateSubscriptionHookResult = ReturnType<
  typeof useLeakDetectorDetailUpdateSubscription
>;
export type LeakDetectorDetailUpdateSubscriptionResult =
  Apollo.SubscriptionResult<LeakDetectorDetailUpdateSubscription>;
export const LeakDetectorDetailDocument = gql`
  query LeakDetectorDetail($id: String!) {
    leakDetectorById(_id: $id) {
      _id
      type
      typeDisplayName
      panelId
      name
      deviceId
      timestamp
      isConfigured
      meta {
        name
        model
        modelNumber
        version
      }
      zone {
        _id
        name
      }
      source {
        _id
        name
      }
      batteryVoltageMinThreshold {
        timestamp
        value
        units
      }
      batteryVoltageMinThresholdReached {
        timestamp
        value
        units
      }
      leakStatus1 {
        timestamp
        value
        units
      }
      leakStatus2 {
        timestamp
        value
        units
      }
      voltage {
        timestamp
        value
        units
      }
      deviceAlerts {
        _id
        type {
          name
        }
        device {
          id
          name
          type
        }
        initiated
        updated
      }
      sourceAlerts {
        _id
        type {
          name
        }
        device {
          id
          name
          type
        }
        initiated
        updated
      }
    }
  }
`;

/**
 * __useLeakDetectorDetailQuery__
 *
 * To run a query within a React component, call `useLeakDetectorDetailQuery` and pass it any options that fit your needs.
 * When your component renders, `useLeakDetectorDetailQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLeakDetectorDetailQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useLeakDetectorDetailQuery(
  baseOptions: Apollo.QueryHookOptions<
    LeakDetectorDetailQuery,
    LeakDetectorDetailQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    LeakDetectorDetailQuery,
    LeakDetectorDetailQueryVariables
  >(LeakDetectorDetailDocument, options);
}
export function useLeakDetectorDetailLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    LeakDetectorDetailQuery,
    LeakDetectorDetailQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    LeakDetectorDetailQuery,
    LeakDetectorDetailQueryVariables
  >(LeakDetectorDetailDocument, options);
}
export type LeakDetectorDetailQueryHookResult = ReturnType<
  typeof useLeakDetectorDetailQuery
>;
export type LeakDetectorDetailLazyQueryHookResult = ReturnType<
  typeof useLeakDetectorDetailLazyQuery
>;
export type LeakDetectorDetailQueryResult = Apollo.QueryResult<
  LeakDetectorDetailQuery,
  LeakDetectorDetailQueryVariables
>;
export const ModbusAirHandlerDetailUpdateDocument = gql`
  subscription ModbusAirHandlerDetailUpdate($ids: [String!]!) {
    modbusAirHandlerEventsByIds(_ids: $ids) {
      modelChangeOperation
      _id
      __typename
      zoneId
      panelId
      sourceId
      deviceId
      name
      type
      typeDisplayName
      hasPendingUpdates
      timestamp
      zone {
        _id
        name
        hasPairedSensor
      }
      source {
        _id
        name
      }
      meta {
        name
        model
        modelNumber
        version
        display {
          temperature
          humidity
        }
      }
      deviceMetrics {
        key
        value {
          defaultValue
          defaultUnit
          readOnly
          streamId
          timestamp
          unit
          units
          value
          valueType
          description
        }
      }
      alarmGlobalAlarm {
        timestamp
        value
        units
      }
      alarmLowPressure {
        timestamp
        value
        units
      }
      alarmHighPressure {
        timestamp
        value
        units
      }
      alarmChangeFilters {
        timestamp
        value
        units
      }
      alarmChangeHepa {
        timestamp
        value
        units
      }
      alarmAirRestriction {
        timestamp
        value
        units
      }
      alarmSupplyFanStopped {
        timestamp
        value
        units
      }
      alarmExhaustFanStopped {
        timestamp
        value
        units
      }
      alarmRefrigerantLeak {
        timestamp
        value
        units
      }
      alarmCompressorFail {
        timestamp
        value
        units
      }
      alarmFanANegPressureOpt1 {
        timestamp
        value
        units
      }
      alarmFanANegPressureOpt2 {
        timestamp
        value
        units
      }
      alarmFanABReversed {
        timestamp
        value
        units
      }
      alarmClockBoard {
        timestamp
        value
        units
      }
      alarmExtendedMemory {
        timestamp
        value
        units
      }
      alarmB1SensorFail {
        timestamp
        value
        units
      }
      alarmB2SensorFail {
        timestamp
        value
        units
      }
      alarmB3SensorFail {
        timestamp
        value
        units
      }
      alarmB4SensorFail {
        timestamp
        value
        units
      }
      alarmB6SensorFail {
        timestamp
        value
        units
      }
      zmbGlobalAlarm {
        timestamp
        value
        units
      }
      zmbThermostatAlarm {
        timestamp
        value
        units
      }
      zmbAirHandlerAlarm {
        timestamp
        value
        units
      }
      zmbLeakDetected {
        timestamp
        value
        units
      }
      ventilationMode {
        timestamp
        value
        units
      }
      damperPosition {
        timestamp
        value
        units
      }
      reversibleValveOnWhen {
        timestamp
        value
        units
      }
      recirculationModeOn {
        timestamp
        value
        units
      }
      airExchangeModeOn {
        timestamp
        value
        units
      }
      supplyFanOn {
        timestamp
        value
        units
      }
      supplyFanAirflow {
        timestamp
        value
        units
      }
      supplyFanStaticPressureH2O {
        timestamp
        value
        units
      }
      exhaustFanOn {
        timestamp
        value
        units
      }
      exhaustFanAirflow {
        timestamp
        value
        units
      }
      systemOnOff {
        timestamp
        value
        units
      }
      systemAutoMode {
        timestamp
        value
        units
      }
      heatPumpModeOn {
        timestamp
        value
        units
      }
      heatingElementOn {
        timestamp
        value
        units
      }
      compressorOn {
        timestamp
        value
        units
      }
      indoorTemperature {
        timestamp
        value
        units
      }
      outsideTemperature {
        timestamp
        value
        units
      }
      indoorRH {
        timestamp
        value
        units
      }
      defrostTemperature {
        timestamp
        value
        units
      }
      conditionedTemperature {
        timestamp
        value
        units
      }
      ahuCoolSetpoint {
        timestamp
        value
        units
      }
      ahuHeatSetpoint {
        timestamp
        value
        units
      }
      ahuMinCoolSetpointLimit {
        timestamp
        value
        units
      }
      ahuMaxHeatSetpointLimit {
        timestamp
        value
        units
      }
      gTerminalOn {
        timestamp
        value
        units
      }
      hTerminalOn {
        timestamp
        value
        units
      }
      wTerminalOn {
        timestamp
        value
        units
      }
      yTerminalOn {
        timestamp
        value
        units
      }
      softwareReleaseType {
        timestamp
        value
        units
      }
      softwareVersion {
        timestamp
        value
        units
      }
      bootVersion {
        timestamp
        value
        units
      }
      biosVersion {
        timestamp
        value
        units
      }
      allowTenantOnOff {
        timestamp
        value
        units
      }
      enableTenantMode {
        timestamp
        value
        units
      }
      allowTenantChangeRHSetpoint {
        timestamp
        value
        units
      }
      allowTenantChangeTempSetpoints {
        timestamp
        value
        units
      }
      tenantModePassword {
        timestamp
        value
        units
      }
      airflowUnits {
        timestamp
        value
        units
      }
      ahuModbusId {
        timestamp
        value
        units
      }
      altitude {
        timestamp
        value
        units
      }
      freshAirSetpoint {
        timestamp
        value
        units
      }
      rhSetpoint {
        timestamp
        value
        units
      }
      auxCoolingEnabled {
        timestamp
        value
        units
      }
      winterRhAdjustEnabled {
        timestamp
        value
        units
      }
      showerDetectorEnabled {
        timestamp
        value
        units
      }
      resetFiltersServiceTime {
        timestamp
        value
        units
      }
      resetHepaServiceTime {
        timestamp
        value
        units
      }
      zmbPollingFrequency {
        timestamp
        value
        units
      }
      zmbModbusRequestDelay {
        timestamp
        value
        units
      }
      zmbPollingFrequency {
        timestamp
        value
        units
      }
      zmbModbusRequestDelay {
        timestamp
        value
        units
      }
      zmbFirmwareVersion {
        timestamp
        value
        units
      }
      zmbSystemUptime {
        timestamp
        value
        units
      }
      zmbTstatRequestsRecvd {
        timestamp
        value
        units
      }
      zmbRequestsRecvdInvalid {
        timestamp
        value
        units
      }
      zmbAhuRequestsSent {
        timestamp
        value
        units
      }
      zmbAhuRequestsSentFailed {
        timestamp
        value
        units
      }
      zmbCoreRequestsRecvd {
        timestamp
        value
        units
      }
      zmbLeakDetectorInstalled {
        timestamp
        value
        units
      }
      zmbCpuTemperature {
        timestamp
        value
        units
      }
      temperatureUnits {
        timestamp
        value
        units
      }
      filtersServiceTime {
        timestamp
        value
        units
      }
      hepaServiceTime {
        timestamp
        value
        units
      }
      deviceAlerts {
        _id
        type {
          id
          name
        }
        device {
          id
          name
          type
        }
        initiated
        updated
      }
      sourceAlerts {
        _id
        type {
          name
        }
        device {
          id
          name
          type
        }
        initiated
        updated
      }
      alertTypes {
        deviceOffline
        sourceOffline
      }
    }
  }
`;

/**
 * __useModbusAirHandlerDetailUpdateSubscription__
 *
 * To run a query within a React component, call `useModbusAirHandlerDetailUpdateSubscription` and pass it any options that fit your needs.
 * When your component renders, `useModbusAirHandlerDetailUpdateSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useModbusAirHandlerDetailUpdateSubscription({
 *   variables: {
 *      ids: // value for 'ids'
 *   },
 * });
 */
export function useModbusAirHandlerDetailUpdateSubscription(
  baseOptions: Apollo.SubscriptionHookOptions<
    ModbusAirHandlerDetailUpdateSubscription,
    ModbusAirHandlerDetailUpdateSubscriptionVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useSubscription<
    ModbusAirHandlerDetailUpdateSubscription,
    ModbusAirHandlerDetailUpdateSubscriptionVariables
  >(ModbusAirHandlerDetailUpdateDocument, options);
}
export type ModbusAirHandlerDetailUpdateSubscriptionHookResult = ReturnType<
  typeof useModbusAirHandlerDetailUpdateSubscription
>;
export type ModbusAirHandlerDetailUpdateSubscriptionResult =
  Apollo.SubscriptionResult<ModbusAirHandlerDetailUpdateSubscription>;
export const ModbusAirHandlerDetailDocument = gql`
  query ModbusAirHandlerDetail($id: String!) {
    modbusAirHandlerById(_id: $id) {
      _id
      __typename
      zoneId
      panelId
      sourceId
      deviceId
      name
      type
      typeDisplayName
      hasPendingUpdates
      alarmGlobalAlarm {
        timestamp
        value
        units
      }
      alarmLowPressure {
        timestamp
        value
        units
      }
      alarmHighPressure {
        timestamp
        value
        units
      }
      alarmChangeFilters {
        timestamp
        value
        units
      }
      alarmChangeHepa {
        timestamp
        value
        units
      }
      alarmAirRestriction {
        timestamp
        value
        units
      }
      alarmSupplyFanStopped {
        timestamp
        value
        units
      }
      alarmExhaustFanStopped {
        timestamp
        value
        units
      }
      alarmRefrigerantLeak {
        timestamp
        value
        units
      }
      alarmCompressorFail {
        timestamp
        value
        units
      }
      alarmFanANegPressureOpt1 {
        timestamp
        value
        units
      }
      alarmFanANegPressureOpt2 {
        timestamp
        value
        units
      }
      alarmFanABReversed {
        timestamp
        value
        units
      }
      alarmClockBoard {
        timestamp
        value
        units
      }
      alarmExtendedMemory {
        timestamp
        value
        units
      }
      alarmB1SensorFail {
        timestamp
        value
        units
      }
      alarmB2SensorFail {
        timestamp
        value
        units
      }
      alarmB3SensorFail {
        timestamp
        value
        units
      }
      alarmB4SensorFail {
        timestamp
        value
        units
      }
      alarmB6SensorFail {
        timestamp
        value
        units
      }
      zmbGlobalAlarm {
        timestamp
        value
        units
      }
      zmbThermostatAlarm {
        timestamp
        value
        units
      }
      zmbAirHandlerAlarm {
        timestamp
        value
        units
      }
      zmbLeakDetected {
        timestamp
        value
        units
      }
      ventilationMode {
        timestamp
        value
        units
      }
      damperPosition {
        timestamp
        value
        units
      }
      reversibleValveOnWhen {
        timestamp
        value
        units
      }
      recirculationModeOn {
        timestamp
        value
        units
      }
      airExchangeModeOn {
        timestamp
        value
        units
      }
      supplyFanOn {
        timestamp
        value
        units
      }
      supplyFanAirflow {
        timestamp
        value
        units
      }
      supplyFanStaticPressureH2O {
        timestamp
        value
        units
      }
      exhaustFanOn {
        timestamp
        value
        units
      }
      exhaustFanAirflow {
        timestamp
        value
        units
      }
      systemOnOff {
        timestamp
        value
        units
      }
      systemAutoMode {
        timestamp
        value
        units
      }
      heatPumpModeOn {
        timestamp
        value
        units
      }
      heatingElementOn {
        timestamp
        value
        units
      }
      compressorOn {
        timestamp
        value
        units
      }
      indoorTemperature {
        timestamp
        value
        units
      }
      outsideTemperature {
        timestamp
        value
        units
      }
      indoorRH {
        timestamp
        value
        units
      }
      defrostTemperature {
        timestamp
        value
        units
      }
      conditionedTemperature {
        timestamp
        value
        units
      }
      ahuCoolSetpoint {
        timestamp
        value
        units
      }
      ahuHeatSetpoint {
        timestamp
        value
        units
      }
      ahuMinCoolSetpointLimit {
        timestamp
        value
        units
      }
      ahuMaxHeatSetpointLimit {
        timestamp
        value
        units
      }
      gTerminalOn {
        timestamp
        value
        units
      }
      hTerminalOn {
        timestamp
        value
        units
      }
      wTerminalOn {
        timestamp
        value
        units
      }
      yTerminalOn {
        timestamp
        value
        units
      }
      softwareReleaseType {
        timestamp
        value
        units
      }
      softwareVersion {
        timestamp
        value
        units
      }
      bootVersion {
        timestamp
        value
        units
      }
      biosVersion {
        timestamp
        value
        units
      }
      allowTenantOnOff {
        timestamp
        value
        units
      }
      enableTenantMode {
        timestamp
        value
        units
      }
      allowTenantChangeRHSetpoint {
        timestamp
        value
        units
      }
      allowTenantChangeTempSetpoints {
        timestamp
        value
        units
      }
      tenantModePassword {
        timestamp
        value
        units
      }
      airflowUnits {
        timestamp
        value
        units
      }
      ahuModbusId {
        timestamp
        value
        units
      }
      altitude {
        timestamp
        value
        units
      }
      freshAirSetpoint {
        timestamp
        value
        units
      }
      rhSetpoint {
        timestamp
        value
        units
      }
      auxCoolingEnabled {
        timestamp
        value
        units
      }
      winterRhAdjustEnabled {
        timestamp
        value
        units
      }
      showerDetectorEnabled {
        timestamp
        value
        units
      }
      resetFiltersServiceTime {
        timestamp
        value
        units
      }
      resetHepaServiceTime {
        timestamp
        value
        units
      }
      zmbPollingFrequency {
        timestamp
        value
        units
      }
      zmbModbusRequestDelay {
        timestamp
        value
        units
      }
      zmbPollingFrequency {
        timestamp
        value
        units
      }
      zmbModbusRequestDelay {
        timestamp
        value
        units
      }
      zmbFirmwareVersion {
        timestamp
        value
        units
      }
      zmbSystemUptime {
        timestamp
        value
        units
      }
      zmbTstatRequestsRecvd {
        timestamp
        value
        units
      }
      zmbRequestsRecvdInvalid {
        timestamp
        value
        units
      }
      zmbAhuRequestsSent {
        timestamp
        value
        units
      }
      zmbAhuRequestsSentFailed {
        timestamp
        value
        units
      }
      zmbCoreRequestsRecvd {
        timestamp
        value
        units
      }
      zmbLeakDetectorInstalled {
        timestamp
        value
        units
      }
      zmbCpuTemperature {
        timestamp
        value
        units
      }
      temperatureUnits {
        timestamp
        value
        units
      }
      filtersServiceTime {
        timestamp
        value
        units
      }
      hepaServiceTime {
        timestamp
        value
        units
      }
      timestamp
      zone {
        _id
        name
        hasPairedSensor
      }
      source {
        _id
        name
      }
      meta {
        name
        model
        modelNumber
        version
        display {
          temperature
          humidity
        }
      }
      deviceMetrics {
        key
        value {
          defaultValue
          defaultUnit
          readOnly
          streamId
          timestamp
          unit
          units
          value
          valueType
          description
        }
      }
      deviceAlerts {
        _id
        type {
          id
          name
        }
        device {
          id
          name
          type
        }
        initiated
        updated
      }
      sourceAlerts {
        _id
        type {
          name
        }
        device {
          id
          name
          type
        }
        initiated
        updated
      }
      alertTypes {
        deviceOffline
        sourceOffline
      }
    }
  }
`;

/**
 * __useModbusAirHandlerDetailQuery__
 *
 * To run a query within a React component, call `useModbusAirHandlerDetailQuery` and pass it any options that fit your needs.
 * When your component renders, `useModbusAirHandlerDetailQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useModbusAirHandlerDetailQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useModbusAirHandlerDetailQuery(
  baseOptions: Apollo.QueryHookOptions<
    ModbusAirHandlerDetailQuery,
    ModbusAirHandlerDetailQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    ModbusAirHandlerDetailQuery,
    ModbusAirHandlerDetailQueryVariables
  >(ModbusAirHandlerDetailDocument, options);
}
export function useModbusAirHandlerDetailLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    ModbusAirHandlerDetailQuery,
    ModbusAirHandlerDetailQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    ModbusAirHandlerDetailQuery,
    ModbusAirHandlerDetailQueryVariables
  >(ModbusAirHandlerDetailDocument, options);
}
export type ModbusAirHandlerDetailQueryHookResult = ReturnType<
  typeof useModbusAirHandlerDetailQuery
>;
export type ModbusAirHandlerDetailLazyQueryHookResult = ReturnType<
  typeof useModbusAirHandlerDetailLazyQuery
>;
export type ModbusAirHandlerDetailQueryResult = Apollo.QueryResult<
  ModbusAirHandlerDetailQuery,
  ModbusAirHandlerDetailQueryVariables
>;
export const OccupancySensorDetailUpdateDocument = gql`
  subscription OccupancySensorDetailUpdate($ids: [String!]!) {
    occupancySensorEventsByIds(_ids: $ids) {
      modelChangeOperation
      _id
      type
      typeDisplayName
      panelId
      name
      deviceId
      timestamp
      isConfigured
      meta {
        name
        model
        modelNumber
        version
        location
      }
      occupancy {
        timestamp
        value
        units
      }
      voltage {
        timestamp
        value
        units
      }
      deviceAlerts {
        _id
        type {
          name
        }
        device {
          id
          name
          type
        }
        initiated
        updated
      }
      sourceAlerts {
        _id
        type {
          name
        }
        device {
          id
          name
          type
        }
        initiated
        updated
      }
    }
  }
`;

/**
 * __useOccupancySensorDetailUpdateSubscription__
 *
 * To run a query within a React component, call `useOccupancySensorDetailUpdateSubscription` and pass it any options that fit your needs.
 * When your component renders, `useOccupancySensorDetailUpdateSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOccupancySensorDetailUpdateSubscription({
 *   variables: {
 *      ids: // value for 'ids'
 *   },
 * });
 */
export function useOccupancySensorDetailUpdateSubscription(
  baseOptions: Apollo.SubscriptionHookOptions<
    OccupancySensorDetailUpdateSubscription,
    OccupancySensorDetailUpdateSubscriptionVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useSubscription<
    OccupancySensorDetailUpdateSubscription,
    OccupancySensorDetailUpdateSubscriptionVariables
  >(OccupancySensorDetailUpdateDocument, options);
}
export type OccupancySensorDetailUpdateSubscriptionHookResult = ReturnType<
  typeof useOccupancySensorDetailUpdateSubscription
>;
export type OccupancySensorDetailUpdateSubscriptionResult =
  Apollo.SubscriptionResult<OccupancySensorDetailUpdateSubscription>;
export const OccupancySensorDetailDocument = gql`
  query OccupancySensorDetail($id: String!) {
    occupancySensorById(_id: $id) {
      _id
      type
      typeDisplayName
      panelId
      name
      deviceId
      timestamp
      isConfigured
      meta {
        name
        model
        modelNumber
        version
      }
      zone {
        _id
        name
      }
      source {
        _id
        name
      }
      occupancy {
        timestamp
        value
        units
      }
      voltage {
        timestamp
        value
        units
      }
      deviceAlerts {
        _id
        type {
          name
        }
        device {
          id
          name
          type
        }
        initiated
        updated
      }
      sourceAlerts {
        _id
        type {
          name
        }
        device {
          id
          name
          type
        }
        initiated
        updated
      }
    }
  }
`;

/**
 * __useOccupancySensorDetailQuery__
 *
 * To run a query within a React component, call `useOccupancySensorDetailQuery` and pass it any options that fit your needs.
 * When your component renders, `useOccupancySensorDetailQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOccupancySensorDetailQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useOccupancySensorDetailQuery(
  baseOptions: Apollo.QueryHookOptions<
    OccupancySensorDetailQuery,
    OccupancySensorDetailQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    OccupancySensorDetailQuery,
    OccupancySensorDetailQueryVariables
  >(OccupancySensorDetailDocument, options);
}
export function useOccupancySensorDetailLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    OccupancySensorDetailQuery,
    OccupancySensorDetailQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    OccupancySensorDetailQuery,
    OccupancySensorDetailQueryVariables
  >(OccupancySensorDetailDocument, options);
}
export type OccupancySensorDetailQueryHookResult = ReturnType<
  typeof useOccupancySensorDetailQuery
>;
export type OccupancySensorDetailLazyQueryHookResult = ReturnType<
  typeof useOccupancySensorDetailLazyQuery
>;
export type OccupancySensorDetailQueryResult = Apollo.QueryResult<
  OccupancySensorDetailQuery,
  OccupancySensorDetailQueryVariables
>;
export const RelayDeviceDetailUpdateDocument = gql`
  subscription RelayDeviceDetailUpdate($ids: [String!]!) {
    relayDeviceEventsByIds(_ids: $ids) {
      modelChangeOperation
      _id
      type
      typeDisplayName
      zoneId
      name
      deviceId
      propertyId
      unitId
      sourceId
      timestamp
      hasPendingUpdates
      isConfigured
      meta {
        name
        model
        modelNumber
        version
      }
      zone {
        _id
        name
      }
      source {
        _id
        name
      }
      isOn {
        timestamp
        value
        units
      }
      deviceAlerts {
        _id
        type {
          name
        }
        device {
          id
          name
          type
        }
        initiated
        updated
      }
      sourceAlerts {
        _id
        type {
          name
        }
        device {
          id
          name
          type
        }
        initiated
        updated
      }
      alertTypes {
        deviceOffline
        sourceOffline
      }
    }
  }
`;

/**
 * __useRelayDeviceDetailUpdateSubscription__
 *
 * To run a query within a React component, call `useRelayDeviceDetailUpdateSubscription` and pass it any options that fit your needs.
 * When your component renders, `useRelayDeviceDetailUpdateSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRelayDeviceDetailUpdateSubscription({
 *   variables: {
 *      ids: // value for 'ids'
 *   },
 * });
 */
export function useRelayDeviceDetailUpdateSubscription(
  baseOptions: Apollo.SubscriptionHookOptions<
    RelayDeviceDetailUpdateSubscription,
    RelayDeviceDetailUpdateSubscriptionVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useSubscription<
    RelayDeviceDetailUpdateSubscription,
    RelayDeviceDetailUpdateSubscriptionVariables
  >(RelayDeviceDetailUpdateDocument, options);
}
export type RelayDeviceDetailUpdateSubscriptionHookResult = ReturnType<
  typeof useRelayDeviceDetailUpdateSubscription
>;
export type RelayDeviceDetailUpdateSubscriptionResult =
  Apollo.SubscriptionResult<RelayDeviceDetailUpdateSubscription>;
export const RelayDeviceDetailDocument = gql`
  query RelayDeviceDetail($id: String!) {
    relayDeviceById(_id: $id) {
      _id
      type
      typeDisplayName
      zoneId
      name
      deviceId
      propertyId
      unitId
      sourceId
      timestamp
      hasPendingUpdates
      isConfigured
      meta {
        name
        model
        modelNumber
        version
      }
      zone {
        _id
        name
      }
      source {
        _id
        name
      }
      isOn {
        timestamp
        value
        units
      }
      deviceAlerts {
        _id
        type {
          name
        }
        device {
          id
          name
          type
        }
        initiated
        updated
      }
      sourceAlerts {
        _id
        type {
          name
        }
        device {
          id
          name
          type
        }
        initiated
        updated
      }
      alertTypes {
        deviceOffline
        sourceOffline
      }
    }
  }
`;

/**
 * __useRelayDeviceDetailQuery__
 *
 * To run a query within a React component, call `useRelayDeviceDetailQuery` and pass it any options that fit your needs.
 * When your component renders, `useRelayDeviceDetailQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRelayDeviceDetailQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useRelayDeviceDetailQuery(
  baseOptions: Apollo.QueryHookOptions<
    RelayDeviceDetailQuery,
    RelayDeviceDetailQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    RelayDeviceDetailQuery,
    RelayDeviceDetailQueryVariables
  >(RelayDeviceDetailDocument, options);
}
export function useRelayDeviceDetailLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    RelayDeviceDetailQuery,
    RelayDeviceDetailQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    RelayDeviceDetailQuery,
    RelayDeviceDetailQueryVariables
  >(RelayDeviceDetailDocument, options);
}
export type RelayDeviceDetailQueryHookResult = ReturnType<
  typeof useRelayDeviceDetailQuery
>;
export type RelayDeviceDetailLazyQueryHookResult = ReturnType<
  typeof useRelayDeviceDetailLazyQuery
>;
export type RelayDeviceDetailQueryResult = Apollo.QueryResult<
  RelayDeviceDetailQuery,
  RelayDeviceDetailQueryVariables
>;
export const ResetSmartPowerOutletCumulativePowerDocument = gql`
  mutation ResetSmartPowerOutletCumulativePower(
    $deviceId: String!
    $revert: Boolean
  ) {
    resetCumulativePower(
      deviceId: $deviceId
      options: { revertToRaw: $revert }
    ) {
      _id
      type
      typeDisplayName
      zoneId
      name
      deviceId
      timestamp
      isConfigured
      meta {
        name
        model
        modelNumber
        version
      }
      zone {
        _id
        name
      }
      source {
        _id
        name
      }
      isOn {
        timestamp
        value
        units
      }
      rmsVoltage {
        timestamp
        value
        units
      }
      rmsCurrent {
        timestamp
        value
        units
      }
      apparentPower {
        timestamp
        value
        units
      }
      activePower {
        timestamp
        value
        units
      }
      powerFactor {
        timestamp
        value
        units
      }
      cumulativePower {
        timestamp
        value
        units
      }
      adjustedCumulativePower {
        timestamp
        value
        units
      }
      deviceAlerts {
        _id
        type {
          name
        }
        device {
          id
          name
          type
        }
        initiated
        updated
      }
      sourceAlerts {
        _id
        type {
          name
        }
        device {
          id
          name
          type
        }
        initiated
        updated
      }
    }
  }
`;
export type ResetSmartPowerOutletCumulativePowerMutationFn =
  Apollo.MutationFunction<
    ResetSmartPowerOutletCumulativePowerMutation,
    ResetSmartPowerOutletCumulativePowerMutationVariables
  >;

/**
 * __useResetSmartPowerOutletCumulativePowerMutation__
 *
 * To run a mutation, you first call `useResetSmartPowerOutletCumulativePowerMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useResetSmartPowerOutletCumulativePowerMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [resetSmartPowerOutletCumulativePowerMutation, { data, loading, error }] = useResetSmartPowerOutletCumulativePowerMutation({
 *   variables: {
 *      deviceId: // value for 'deviceId'
 *      revert: // value for 'revert'
 *   },
 * });
 */
export function useResetSmartPowerOutletCumulativePowerMutation(
  baseOptions?: Apollo.MutationHookOptions<
    ResetSmartPowerOutletCumulativePowerMutation,
    ResetSmartPowerOutletCumulativePowerMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    ResetSmartPowerOutletCumulativePowerMutation,
    ResetSmartPowerOutletCumulativePowerMutationVariables
  >(ResetSmartPowerOutletCumulativePowerDocument, options);
}
export type ResetSmartPowerOutletCumulativePowerMutationHookResult = ReturnType<
  typeof useResetSmartPowerOutletCumulativePowerMutation
>;
export type ResetSmartPowerOutletCumulativePowerMutationResult =
  Apollo.MutationResult<ResetSmartPowerOutletCumulativePowerMutation>;
export type ResetSmartPowerOutletCumulativePowerMutationOptions =
  Apollo.BaseMutationOptions<
    ResetSmartPowerOutletCumulativePowerMutation,
    ResetSmartPowerOutletCumulativePowerMutationVariables
  >;
export const ResumeThermostatScheduleDocument = gql`
  mutation ResumeThermostatSchedule($deviceId: String!) {
    resumeThermostatSchedule(deviceId: $deviceId) {
      deviceId
    }
  }
`;
export type ResumeThermostatScheduleMutationFn = Apollo.MutationFunction<
  ResumeThermostatScheduleMutation,
  ResumeThermostatScheduleMutationVariables
>;

/**
 * __useResumeThermostatScheduleMutation__
 *
 * To run a mutation, you first call `useResumeThermostatScheduleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useResumeThermostatScheduleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [resumeThermostatScheduleMutation, { data, loading, error }] = useResumeThermostatScheduleMutation({
 *   variables: {
 *      deviceId: // value for 'deviceId'
 *   },
 * });
 */
export function useResumeThermostatScheduleMutation(
  baseOptions?: Apollo.MutationHookOptions<
    ResumeThermostatScheduleMutation,
    ResumeThermostatScheduleMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    ResumeThermostatScheduleMutation,
    ResumeThermostatScheduleMutationVariables
  >(ResumeThermostatScheduleDocument, options);
}
export type ResumeThermostatScheduleMutationHookResult = ReturnType<
  typeof useResumeThermostatScheduleMutation
>;
export type ResumeThermostatScheduleMutationResult =
  Apollo.MutationResult<ResumeThermostatScheduleMutation>;
export type ResumeThermostatScheduleMutationOptions =
  Apollo.BaseMutationOptions<
    ResumeThermostatScheduleMutation,
    ResumeThermostatScheduleMutationVariables
  >;
export const SmartPowerOutletDetailDocument = gql`
  query SmartPowerOutletDetail($id: String!) {
    smartPowerOutletById(_id: $id) {
      _id
      type
      typeDisplayName
      zoneId
      name
      deviceId
      timestamp
      hasPendingUpdates
      isConfigured
      meta {
        name
        model
        modelNumber
        version
      }
      zone {
        _id
        name
      }
      source {
        _id
        name
      }
      isOn {
        timestamp
        value
        units
      }
      rmsVoltage {
        timestamp
        value
        units
      }
      rmsCurrent {
        timestamp
        value
        units
      }
      apparentPower {
        timestamp
        value
        units
      }
      activePower {
        timestamp
        value
        units
      }
      powerFactor {
        timestamp
        value
        units
      }
      cumulativePower {
        timestamp
        value
        units
      }
      adjustedCumulativePower {
        timestamp
        value
        units
      }
      cumulativePowerResetTime
      cumulativePowerOffset
      deviceAlerts {
        _id
        type {
          name
        }
        device {
          id
          name
          type
        }
        initiated
        updated
      }
      sourceAlerts {
        _id
        type {
          name
        }
        device {
          id
          name
          type
        }
        initiated
        updated
      }
      alertTypes {
        deviceOffline
        sourceOffline
      }
    }
  }
`;

/**
 * __useSmartPowerOutletDetailQuery__
 *
 * To run a query within a React component, call `useSmartPowerOutletDetailQuery` and pass it any options that fit your needs.
 * When your component renders, `useSmartPowerOutletDetailQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSmartPowerOutletDetailQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useSmartPowerOutletDetailQuery(
  baseOptions: Apollo.QueryHookOptions<
    SmartPowerOutletDetailQuery,
    SmartPowerOutletDetailQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    SmartPowerOutletDetailQuery,
    SmartPowerOutletDetailQueryVariables
  >(SmartPowerOutletDetailDocument, options);
}
export function useSmartPowerOutletDetailLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    SmartPowerOutletDetailQuery,
    SmartPowerOutletDetailQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    SmartPowerOutletDetailQuery,
    SmartPowerOutletDetailQueryVariables
  >(SmartPowerOutletDetailDocument, options);
}
export type SmartPowerOutletDetailQueryHookResult = ReturnType<
  typeof useSmartPowerOutletDetailQuery
>;
export type SmartPowerOutletDetailLazyQueryHookResult = ReturnType<
  typeof useSmartPowerOutletDetailLazyQuery
>;
export type SmartPowerOutletDetailQueryResult = Apollo.QueryResult<
  SmartPowerOutletDetailQuery,
  SmartPowerOutletDetailQueryVariables
>;
export const SmartPowerOutletDetailUpdateDocument = gql`
  subscription SmartPowerOutletDetailUpdate($ids: [String!]!) {
    smartPowerOutletEventsByIds(_ids: $ids) {
      modelChangeOperation
      _id
      type
      typeDisplayName
      zoneId
      name
      deviceId
      timestamp
      hasPendingUpdates
      isConfigured
      meta {
        name
        model
        modelNumber
        version
      }
      zone {
        _id
        name
      }
      source {
        _id
        name
      }
      isOn {
        timestamp
        value
        units
      }
      rmsVoltage {
        timestamp
        value
        units
      }
      rmsCurrent {
        timestamp
        value
        units
      }
      apparentPower {
        timestamp
        value
        units
      }
      activePower {
        timestamp
        value
        units
      }
      powerFactor {
        timestamp
        value
        units
      }
      cumulativePower {
        timestamp
        value
        units
      }
      adjustedCumulativePower {
        timestamp
        value
        units
      }
      cumulativePowerResetTime
      cumulativePowerOffset
      deviceAlerts {
        _id
        type {
          name
        }
        device {
          id
          name
          type
        }
        initiated
        updated
      }
      sourceAlerts {
        _id
        type {
          name
        }
        device {
          id
          name
          type
        }
        initiated
        updated
      }
      alertTypes {
        deviceOffline
        sourceOffline
      }
    }
  }
`;

/**
 * __useSmartPowerOutletDetailUpdateSubscription__
 *
 * To run a query within a React component, call `useSmartPowerOutletDetailUpdateSubscription` and pass it any options that fit your needs.
 * When your component renders, `useSmartPowerOutletDetailUpdateSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSmartPowerOutletDetailUpdateSubscription({
 *   variables: {
 *      ids: // value for 'ids'
 *   },
 * });
 */
export function useSmartPowerOutletDetailUpdateSubscription(
  baseOptions: Apollo.SubscriptionHookOptions<
    SmartPowerOutletDetailUpdateSubscription,
    SmartPowerOutletDetailUpdateSubscriptionVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useSubscription<
    SmartPowerOutletDetailUpdateSubscription,
    SmartPowerOutletDetailUpdateSubscriptionVariables
  >(SmartPowerOutletDetailUpdateDocument, options);
}
export type SmartPowerOutletDetailUpdateSubscriptionHookResult = ReturnType<
  typeof useSmartPowerOutletDetailUpdateSubscription
>;
export type SmartPowerOutletDetailUpdateSubscriptionResult =
  Apollo.SubscriptionResult<SmartPowerOutletDetailUpdateSubscription>;
export const ThermostatDetailUpdateDocument = gql`
  subscription ThermostatDetailUpdate($ids: [String!]!) {
    thermostatEventsByIds(_ids: $ids) {
      modelChangeOperation
      _id
      __typename
      zoneId
      panelId
      sourceId
      deviceId
      name
      type
      typeDisplayName
      hasPendingUpdates
      isMitsubishiThermostat
      localControlPermissionsV1 {
        value {
          power
          operatingMode
          temperature
          fanSpeed
          louvre
          filterReset
          timer
        }
        canEdit
        pending
        observedAt
      }
      louvreControlV1 {
        supportsAirDirection
        canEditAirDirection
        allowedAirDirections
        airDirection {
          value
          readingId
          timestamp
          observedAt
          pending
        }
      }
      separatePowerControlV1 {
        controlContract
        canEditPowerMode
        canEditOperatingMode
        supportsAirDirection
        canEditAirDirection
        allowedAirDirections
        airDirection {
          value
          readingId
          timestamp
          observedAt
          pending
        }
        canEditFanSpeed
        allowedFanSpeeds
        fanSpeed {
          value
          readingId
          timestamp
          observedAt
          pending
        }
        allowedOperatingModes
        canEditTargets
        targetBlockReason
        powerMode {
          value
          readingId
          timestamp
          observedAt
          pending
        }
        powerState {
          value
          readingId
          timestamp
          observedAt
          pending
        }
        operatingMode {
          value
          readingId
          timestamp
          observedAt
          pending
        }
        operatingState {
          value
          readingId
          timestamp
          observedAt
          pending
        }
      }
      supportsObservationFreshness
      supportsAutoMode
      supportsSingleSetpointAutoMode
      supportsDualSetpointAutoMode
      setpoint {
        observedAt
        value
        units
        timestamp
        updatePending
      }
      minSetpoint {
        value
        units
        timestamp
      }
      maxSetpoint {
        value
        units
        timestamp
      }
      supportsSystemType
      supportsAlternateHeatSystemType
      supportsPasscode
      supportsShowFanButton
      supportsRemoteSensorTempDelta
      supportsLastSetpointChange
      supportsFanOperations
      supportsFanStateMonitoring
      supportsHoldExpiryTime
      supportsHumidityMonitoring
      supportsScheduling
      getFanState
      fanIconClass
      fanIconHelpText
      fanModeInfo
      getSetpointChangeSource
      hvacIconClass
      hvacIconHelpText
      scheduleStatus
      getHoldEnd
      hasSchedule
      isScheduleEnabled
      isFollowingSchedule
      isOffSchedule
      isHoldForever
      scheduleType
      scheduleIconClass
      scheduleIconHelpText
      keypadLockoutIconClass
      keypadLockoutIconHelpText
      profileIconClass
      profileIconHelpText
      isConfigured
      isMultiSpeedThermostat
      isPairingActive
      lastSetpointChangeValid
      timestamp
      zone {
        _id
        name
        hasPairedSensor
      }
      source {
        _id
        name
        type
      }
      meta {
        name
        model
        modelNumber
        version
        display {
          temperature
          humidity
        }
        plmActive
      }
      deviceMetrics {
        key
        value {
          defaultValue
          defaultUnit
          readOnly
          streamId
          timestamp
          unit
          units
          value
          valueType
          valueStep
        }
      }
      coolSetpoint {
        observedAt
        timestamp
        value
      }
      fanMode {
        observedAt
        timestamp
        value
        units
      }
      fanSpeed {
        observedAt
        timestamp
        value
        units
      }
      fanState {
        observedAt
        timestamp
        value
        units
      }
      heatSetpoint {
        observedAt
        timestamp
        value
      }
      holdDuration {
        timestamp
        value
        units
      }
      holdEnd {
        timestamp
        value
        units
      }
      holdState {
        timestamp
        value
        units
      }
      holdExpiryTime {
        timestamp
        value
        units
      }
      humidity {
        observedAt
        timestamp
        value
        units
      }
      keypadLockoutLevel {
        timestamp
        value
        units
      }
      lastScheduleChange {
        timestamp
        value
        units
      }
      lastSetpointChange {
        timestamp
        value
        units
      }
      maxCoolSetpointLimit {
        timestamp
        value
        units
      }
      maxHeatSetpointLimit {
        timestamp
        value
        units
      }
      minCoolSetpointLimit {
        timestamp
        value
        units
      }
      minHeatSetpointLimit {
        timestamp
        value
        units
      }
      operatingMode {
        observedAt
        timestamp
        value
        units
      }
      operatingState {
        observedAt
        timestamp
        value
        units
      }
      passCode {
        timestamp
        value
        units
      }
      progMode {
        timestamp
        value
        units
      }
      remoteSensorTempDelta {
        timestamp
        value
        units
      }
      remoteSensorTempDeltaValue
      schedVisibilityMode {
        timestamp
        value
        units
      }
      schedule {
        id
        units
        timestamp
        value
        updatePending
      }
      setpointChangeSource {
        timestamp
        value
        units
      }
      showFanButton {
        timestamp
        value
        units
      }
      systemType {
        timestamp
        value
        units
      }
      tempDisplayMode {
        timestamp
        value
        units
      }
      temperature {
        observedAt
        timestamp
        value
        units
      }
      modbusRTU
      keypadLockoutLevels
      uiOptions {
        timestamp
        value
        units
      }
      useCustomSetpointLimits
      deviceAlerts {
        _id
        type {
          name
        }
        device {
          id
          name
          type
        }
        initiated
        updated
      }
      sourceAlerts {
        _id
        type {
          name
        }
        device {
          id
          name
          type
        }
        initiated
        updated
      }
      alertTypes {
        deviceOffline
        sourceOffline
      }
    }
  }
`;

/**
 * __useThermostatDetailUpdateSubscription__
 *
 * To run a query within a React component, call `useThermostatDetailUpdateSubscription` and pass it any options that fit your needs.
 * When your component renders, `useThermostatDetailUpdateSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useThermostatDetailUpdateSubscription({
 *   variables: {
 *      ids: // value for 'ids'
 *   },
 * });
 */
export function useThermostatDetailUpdateSubscription(
  baseOptions: Apollo.SubscriptionHookOptions<
    ThermostatDetailUpdateSubscription,
    ThermostatDetailUpdateSubscriptionVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useSubscription<
    ThermostatDetailUpdateSubscription,
    ThermostatDetailUpdateSubscriptionVariables
  >(ThermostatDetailUpdateDocument, options);
}
export type ThermostatDetailUpdateSubscriptionHookResult = ReturnType<
  typeof useThermostatDetailUpdateSubscription
>;
export type ThermostatDetailUpdateSubscriptionResult =
  Apollo.SubscriptionResult<ThermostatDetailUpdateSubscription>;
export const ThermostatDetailDocument = gql`
  query ThermostatDetail($id: String!) {
    thermostatById(_id: $id) {
      _id
      __typename
      zoneId
      panelId
      sourceId
      deviceId
      thermostatScheduleTemplateId
      name
      type
      typeDisplayName
      hasPendingUpdates
      isMitsubishiThermostat
      localControlPermissionsV1 {
        value {
          power
          operatingMode
          temperature
          fanSpeed
          louvre
          filterReset
          timer
        }
        canEdit
        pending
        observedAt
      }
      louvreControlV1 {
        supportsAirDirection
        canEditAirDirection
        allowedAirDirections
        airDirection {
          value
          readingId
          timestamp
          observedAt
          pending
        }
      }
      separatePowerControlV1 {
        controlContract
        canEditPowerMode
        canEditOperatingMode
        supportsAirDirection
        canEditAirDirection
        allowedAirDirections
        airDirection {
          value
          readingId
          timestamp
          observedAt
          pending
        }
        canEditFanSpeed
        allowedFanSpeeds
        fanSpeed {
          value
          readingId
          timestamp
          observedAt
          pending
        }
        allowedOperatingModes
        canEditTargets
        targetBlockReason
        powerMode {
          value
          readingId
          timestamp
          observedAt
          pending
        }
        powerState {
          value
          readingId
          timestamp
          observedAt
          pending
        }
        operatingMode {
          value
          readingId
          timestamp
          observedAt
          pending
        }
        operatingState {
          value
          readingId
          timestamp
          observedAt
          pending
        }
      }
      supportsObservationFreshness
      supportsAutoMode
      supportsSingleSetpointAutoMode
      supportsDualSetpointAutoMode
      setpoint {
        observedAt
        value
        units
        timestamp
        updatePending
      }
      minSetpoint {
        value
        units
        timestamp
      }
      maxSetpoint {
        value
        units
        timestamp
      }
      supportsSystemType
      supportsAlternateHeatSystemType
      supportsPasscode
      supportsShowFanButton
      supportsRemoteSensorTempDelta
      supportsLastSetpointChange
      supportsFanOperations
      supportsFanStateMonitoring
      supportsHoldExpiryTime
      supportsHumidityMonitoring
      supportsScheduling
      getFanState
      fanIconClass
      fanIconHelpText
      fanModeInfo
      getSetpointChangeSource
      hvacIconClass
      hvacIconHelpText
      scheduleStatus
      getHoldEnd
      hasSchedule
      isScheduleEnabled
      isFollowingSchedule
      isOffSchedule
      isHoldForever
      scheduleType
      scheduleIconClass
      scheduleIconHelpText
      keypadLockoutLevelName
      keypadLockoutIconClass
      keypadLockoutIconHelpText
      profileIconClass
      profileIconHelpText
      isConfigured
      isMultiSpeedThermostat
      isPairingActive
      lastSetpointChangeValid
      timestamp
      zone {
        _id
        name
        hasPairedSensor
      }
      source {
        _id
        name
        type
      }
      meta {
        name
        model
        modelNumber
        version
        display {
          temperature
          humidity
        }
        plmActive
      }
      deviceMetrics {
        key
        value {
          defaultValue
          defaultUnit
          readOnly
          streamId
          timestamp
          unit
          units
          value
          valueType
          valueStep
        }
      }
      coolSetpoint {
        observedAt
        timestamp
        value
      }
      fanMode {
        observedAt
        timestamp
        value
        units
      }
      fanSpeed {
        observedAt
        timestamp
        value
        units
      }
      fanState {
        observedAt
        timestamp
        value
        units
      }
      heatSetpoint {
        observedAt
        timestamp
        value
      }
      holdDuration {
        timestamp
        value
        units
      }
      holdEnd {
        timestamp
        value
        units
      }
      holdState {
        timestamp
        value
        units
      }
      holdExpiryTime {
        timestamp
        value
        units
      }
      humidity {
        observedAt
        timestamp
        value
        units
      }
      keypadLockoutLevel {
        timestamp
        value
        units
      }
      lastScheduleChange {
        timestamp
        value
        units
      }
      lastSetpointChange {
        timestamp
        value
        units
      }
      maxCoolSetpointLimit {
        timestamp
        value
        units
      }
      maxHeatSetpointLimit {
        timestamp
        value
        units
      }
      minCoolSetpointLimit {
        timestamp
        value
        units
      }
      minHeatSetpointLimit {
        timestamp
        value
        units
      }
      operatingMode {
        observedAt
        timestamp
        value
        units
      }
      operatingState {
        observedAt
        timestamp
        value
        units
      }
      passCode {
        timestamp
        value
        units
      }
      progMode {
        timestamp
        value
        units
      }
      remoteSensorTempDelta {
        timestamp
        value
        units
      }
      remoteSensorTempDeltaValue
      schedVisibilityMode {
        timestamp
        value
        units
      }
      schedule {
        id
        units
        timestamp
        value
        updatePending
      }
      pendingSchedule {
        id
        units
        timestamp
        value
      }
      setpointChangeSource {
        timestamp
        value
        units
      }
      showFanButton {
        timestamp
        value
        units
      }
      systemType {
        timestamp
        value
        units
      }
      tempDisplayMode {
        timestamp
        value
        units
      }
      temperature {
        observedAt
        timestamp
        value
        units
      }
      modbusRTU
      keypadLockoutLevels
      uiOptions {
        timestamp
        value
        units
      }
      useCustomSetpointLimits
      useCustomSchedule
      deviceAlerts {
        _id
        type {
          name
        }
        device {
          id
          name
          type
        }
        initiated
        updated
      }
      sourceAlerts {
        _id
        type {
          name
        }
        device {
          id
          name
          type
        }
        initiated
        updated
      }
      alertTypes {
        deviceOffline
        sourceOffline
      }
    }
  }
`;

/**
 * __useThermostatDetailQuery__
 *
 * To run a query within a React component, call `useThermostatDetailQuery` and pass it any options that fit your needs.
 * When your component renders, `useThermostatDetailQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useThermostatDetailQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useThermostatDetailQuery(
  baseOptions: Apollo.QueryHookOptions<
    ThermostatDetailQuery,
    ThermostatDetailQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<ThermostatDetailQuery, ThermostatDetailQueryVariables>(
    ThermostatDetailDocument,
    options,
  );
}
export function useThermostatDetailLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    ThermostatDetailQuery,
    ThermostatDetailQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    ThermostatDetailQuery,
    ThermostatDetailQueryVariables
  >(ThermostatDetailDocument, options);
}
export type ThermostatDetailQueryHookResult = ReturnType<
  typeof useThermostatDetailQuery
>;
export type ThermostatDetailLazyQueryHookResult = ReturnType<
  typeof useThermostatDetailLazyQuery
>;
export type ThermostatDetailQueryResult = Apollo.QueryResult<
  ThermostatDetailQuery,
  ThermostatDetailQueryVariables
>;
export const ThermostatScheduleTemplateDetailDocument = gql`
  query ThermostatScheduleTemplateDetail($id: String!) {
    thermostatScheduleTemplateById(_id: $id) {
      _id
      name
      isPropertyDefault
      assignedUnitCount
      setpointLimitProfileId
      value {
        id
        units
        timestamp
        value
        updatePending
      }
      propertyId
    }
  }
`;

/**
 * __useThermostatScheduleTemplateDetailQuery__
 *
 * To run a query within a React component, call `useThermostatScheduleTemplateDetailQuery` and pass it any options that fit your needs.
 * When your component renders, `useThermostatScheduleTemplateDetailQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useThermostatScheduleTemplateDetailQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useThermostatScheduleTemplateDetailQuery(
  baseOptions: Apollo.QueryHookOptions<
    ThermostatScheduleTemplateDetailQuery,
    ThermostatScheduleTemplateDetailQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    ThermostatScheduleTemplateDetailQuery,
    ThermostatScheduleTemplateDetailQueryVariables
  >(ThermostatScheduleTemplateDetailDocument, options);
}
export function useThermostatScheduleTemplateDetailLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    ThermostatScheduleTemplateDetailQuery,
    ThermostatScheduleTemplateDetailQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    ThermostatScheduleTemplateDetailQuery,
    ThermostatScheduleTemplateDetailQueryVariables
  >(ThermostatScheduleTemplateDetailDocument, options);
}
export type ThermostatScheduleTemplateDetailQueryHookResult = ReturnType<
  typeof useThermostatScheduleTemplateDetailQuery
>;
export type ThermostatScheduleTemplateDetailLazyQueryHookResult = ReturnType<
  typeof useThermostatScheduleTemplateDetailLazyQuery
>;
export type ThermostatScheduleTemplateDetailQueryResult = Apollo.QueryResult<
  ThermostatScheduleTemplateDetailQuery,
  ThermostatScheduleTemplateDetailQueryVariables
>;
export const ThermostatPendingScheduleUpdateDocument = gql`
  subscription ThermostatPendingScheduleUpdate($id: String!) {
    thermostatEventsByIds(_ids: [$id]) {
      modelChangeOperation
      _id
      deviceId
      name
      type
      pendingSchedule {
        id
        units
        timestamp
        value
      }
    }
  }
`;

/**
 * __useThermostatPendingScheduleUpdateSubscription__
 *
 * To run a query within a React component, call `useThermostatPendingScheduleUpdateSubscription` and pass it any options that fit your needs.
 * When your component renders, `useThermostatPendingScheduleUpdateSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useThermostatPendingScheduleUpdateSubscription({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useThermostatPendingScheduleUpdateSubscription(
  baseOptions: Apollo.SubscriptionHookOptions<
    ThermostatPendingScheduleUpdateSubscription,
    ThermostatPendingScheduleUpdateSubscriptionVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useSubscription<
    ThermostatPendingScheduleUpdateSubscription,
    ThermostatPendingScheduleUpdateSubscriptionVariables
  >(ThermostatPendingScheduleUpdateDocument, options);
}
export type ThermostatPendingScheduleUpdateSubscriptionHookResult = ReturnType<
  typeof useThermostatPendingScheduleUpdateSubscription
>;
export type ThermostatPendingScheduleUpdateSubscriptionResult =
  Apollo.SubscriptionResult<ThermostatPendingScheduleUpdateSubscription>;
export const ThermostatScheduleTemplateDetailUpdatesDocument = gql`
  subscription ThermostatScheduleTemplateDetailUpdates($id: String!) {
    thermostatScheduleTemplateEventsByIds(_ids: [$id]) {
      modelChangeOperation
      _id
      name
      isPropertyDefault
      assignedUnitCount
      setpointLimitProfileId
      value {
        id
        units
        timestamp
        value
        updatePending
      }
      propertyId
    }
  }
`;

/**
 * __useThermostatScheduleTemplateDetailUpdatesSubscription__
 *
 * To run a query within a React component, call `useThermostatScheduleTemplateDetailUpdatesSubscription` and pass it any options that fit your needs.
 * When your component renders, `useThermostatScheduleTemplateDetailUpdatesSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useThermostatScheduleTemplateDetailUpdatesSubscription({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useThermostatScheduleTemplateDetailUpdatesSubscription(
  baseOptions: Apollo.SubscriptionHookOptions<
    ThermostatScheduleTemplateDetailUpdatesSubscription,
    ThermostatScheduleTemplateDetailUpdatesSubscriptionVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useSubscription<
    ThermostatScheduleTemplateDetailUpdatesSubscription,
    ThermostatScheduleTemplateDetailUpdatesSubscriptionVariables
  >(ThermostatScheduleTemplateDetailUpdatesDocument, options);
}
export type ThermostatScheduleTemplateDetailUpdatesSubscriptionHookResult =
  ReturnType<typeof useThermostatScheduleTemplateDetailUpdatesSubscription>;
export type ThermostatScheduleTemplateDetailUpdatesSubscriptionResult =
  Apollo.SubscriptionResult<ThermostatScheduleTemplateDetailUpdatesSubscription>;
export const ThermostatScheduleTemplateEditVerificationDocument = gql`
  query ThermostatScheduleTemplateEditVerification(
    $thermostatScheduleTemplateId: String
    $propertyId: String
  ) {
    thermostatScheduleTemplateEditVerification(
      thermostatScheduleTemplateId: $thermostatScheduleTemplateId
      propertyId: $propertyId
    ) {
      allAffectedThermostats
      allAffectedUnits
      allThermostats
      allUnits
    }
  }
`;

/**
 * __useThermostatScheduleTemplateEditVerificationQuery__
 *
 * To run a query within a React component, call `useThermostatScheduleTemplateEditVerificationQuery` and pass it any options that fit your needs.
 * When your component renders, `useThermostatScheduleTemplateEditVerificationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useThermostatScheduleTemplateEditVerificationQuery({
 *   variables: {
 *      thermostatScheduleTemplateId: // value for 'thermostatScheduleTemplateId'
 *      propertyId: // value for 'propertyId'
 *   },
 * });
 */
export function useThermostatScheduleTemplateEditVerificationQuery(
  baseOptions?: Apollo.QueryHookOptions<
    ThermostatScheduleTemplateEditVerificationQuery,
    ThermostatScheduleTemplateEditVerificationQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    ThermostatScheduleTemplateEditVerificationQuery,
    ThermostatScheduleTemplateEditVerificationQueryVariables
  >(ThermostatScheduleTemplateEditVerificationDocument, options);
}
export function useThermostatScheduleTemplateEditVerificationLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    ThermostatScheduleTemplateEditVerificationQuery,
    ThermostatScheduleTemplateEditVerificationQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    ThermostatScheduleTemplateEditVerificationQuery,
    ThermostatScheduleTemplateEditVerificationQueryVariables
  >(ThermostatScheduleTemplateEditVerificationDocument, options);
}
export type ThermostatScheduleTemplateEditVerificationQueryHookResult =
  ReturnType<typeof useThermostatScheduleTemplateEditVerificationQuery>;
export type ThermostatScheduleTemplateEditVerificationLazyQueryHookResult =
  ReturnType<typeof useThermostatScheduleTemplateEditVerificationLazyQuery>;
export type ThermostatScheduleTemplateEditVerificationQueryResult =
  Apollo.QueryResult<
    ThermostatScheduleTemplateEditVerificationQuery,
    ThermostatScheduleTemplateEditVerificationQueryVariables
  >;
export const ThermostatScheduleTemplateUpdateVerificationDocument = gql`
  query ThermostatScheduleTemplateUpdateVerification(
    $propertyId: String
    $unitId: String
  ) {
    thermostatScheduleTemplateUpdateVerification(
      propertyId: $propertyId
      unitId: $unitId
    ) {
      totalUnits
      thermostatsUsingUnitLevelScheduleTemplate
      totalThermostats
      installedThermostats
      installedOnlineThermostats
      installedOnlineThermostatsAndUsesCustomSchedule
      installedOnlineThermostatsAndUsesCustomSetpointLimits
      thermostatsUsingPropertyLevelScheduleTemplate
      installedOnlineThermostatsAndUsesScheduleTemplate {
        _id
        thermostatScheduleTemplate {
          _id
          setpointLimitProfileId
        }
      }
      unitsWithAppliedThermostatScheduleTemplate
      unitsWithoutAppliedThermostatScheduleTemplate
    }
  }
`;

/**
 * __useThermostatScheduleTemplateUpdateVerificationQuery__
 *
 * To run a query within a React component, call `useThermostatScheduleTemplateUpdateVerificationQuery` and pass it any options that fit your needs.
 * When your component renders, `useThermostatScheduleTemplateUpdateVerificationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useThermostatScheduleTemplateUpdateVerificationQuery({
 *   variables: {
 *      propertyId: // value for 'propertyId'
 *      unitId: // value for 'unitId'
 *   },
 * });
 */
export function useThermostatScheduleTemplateUpdateVerificationQuery(
  baseOptions?: Apollo.QueryHookOptions<
    ThermostatScheduleTemplateUpdateVerificationQuery,
    ThermostatScheduleTemplateUpdateVerificationQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    ThermostatScheduleTemplateUpdateVerificationQuery,
    ThermostatScheduleTemplateUpdateVerificationQueryVariables
  >(ThermostatScheduleTemplateUpdateVerificationDocument, options);
}
export function useThermostatScheduleTemplateUpdateVerificationLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    ThermostatScheduleTemplateUpdateVerificationQuery,
    ThermostatScheduleTemplateUpdateVerificationQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    ThermostatScheduleTemplateUpdateVerificationQuery,
    ThermostatScheduleTemplateUpdateVerificationQueryVariables
  >(ThermostatScheduleTemplateUpdateVerificationDocument, options);
}
export type ThermostatScheduleTemplateUpdateVerificationQueryHookResult =
  ReturnType<typeof useThermostatScheduleTemplateUpdateVerificationQuery>;
export type ThermostatScheduleTemplateUpdateVerificationLazyQueryHookResult =
  ReturnType<typeof useThermostatScheduleTemplateUpdateVerificationLazyQuery>;
export type ThermostatScheduleTemplateUpdateVerificationQueryResult =
  Apollo.QueryResult<
    ThermostatScheduleTemplateUpdateVerificationQuery,
    ThermostatScheduleTemplateUpdateVerificationQueryVariables
  >;
export const TurnRelayDeviceOffDocument = gql`
  mutation TurnRelayDeviceOff($deviceId: String!, $force: Boolean) {
    updateRelayDeviceOnOffState(
      deviceId: $deviceId
      updates: { isOn: false }
      options: { forcePush: $force }
    ) {
      _id
      type
      typeDisplayName
      zoneId
      name
      deviceId
      propertyId
      unitId
      sourceId
      timestamp
      isConfigured
      meta {
        name
        model
        modelNumber
        version
      }
      zone {
        _id
        name
      }
      source {
        _id
        name
      }
      isOn {
        timestamp
        value
        units
      }
      deviceAlerts {
        _id
        type {
          name
        }
        device {
          id
          name
          type
        }
        initiated
        updated
      }
      sourceAlerts {
        _id
        type {
          name
        }
        device {
          id
          name
          type
        }
        initiated
        updated
      }
    }
  }
`;
export type TurnRelayDeviceOffMutationFn = Apollo.MutationFunction<
  TurnRelayDeviceOffMutation,
  TurnRelayDeviceOffMutationVariables
>;

/**
 * __useTurnRelayDeviceOffMutation__
 *
 * To run a mutation, you first call `useTurnRelayDeviceOffMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useTurnRelayDeviceOffMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [turnRelayDeviceOffMutation, { data, loading, error }] = useTurnRelayDeviceOffMutation({
 *   variables: {
 *      deviceId: // value for 'deviceId'
 *      force: // value for 'force'
 *   },
 * });
 */
export function useTurnRelayDeviceOffMutation(
  baseOptions?: Apollo.MutationHookOptions<
    TurnRelayDeviceOffMutation,
    TurnRelayDeviceOffMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    TurnRelayDeviceOffMutation,
    TurnRelayDeviceOffMutationVariables
  >(TurnRelayDeviceOffDocument, options);
}
export type TurnRelayDeviceOffMutationHookResult = ReturnType<
  typeof useTurnRelayDeviceOffMutation
>;
export type TurnRelayDeviceOffMutationResult =
  Apollo.MutationResult<TurnRelayDeviceOffMutation>;
export type TurnRelayDeviceOffMutationOptions = Apollo.BaseMutationOptions<
  TurnRelayDeviceOffMutation,
  TurnRelayDeviceOffMutationVariables
>;
export const TurnRelayDeviceOnDocument = gql`
  mutation TurnRelayDeviceOn($deviceId: String!, $force: Boolean) {
    updateRelayDeviceOnOffState(
      deviceId: $deviceId
      updates: { isOn: true }
      options: { forcePush: $force }
    ) {
      _id
      type
      typeDisplayName
      zoneId
      name
      deviceId
      propertyId
      unitId
      sourceId
      timestamp
      isConfigured
      meta {
        name
        model
        modelNumber
        version
      }
      zone {
        _id
        name
      }
      source {
        _id
        name
      }
      isOn {
        timestamp
        value
        units
      }
      deviceAlerts {
        _id
        type {
          name
        }
        device {
          id
          name
          type
        }
        initiated
        updated
      }
      sourceAlerts {
        _id
        type {
          name
        }
        device {
          id
          name
          type
        }
        initiated
        updated
      }
    }
  }
`;
export type TurnRelayDeviceOnMutationFn = Apollo.MutationFunction<
  TurnRelayDeviceOnMutation,
  TurnRelayDeviceOnMutationVariables
>;

/**
 * __useTurnRelayDeviceOnMutation__
 *
 * To run a mutation, you first call `useTurnRelayDeviceOnMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useTurnRelayDeviceOnMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [turnRelayDeviceOnMutation, { data, loading, error }] = useTurnRelayDeviceOnMutation({
 *   variables: {
 *      deviceId: // value for 'deviceId'
 *      force: // value for 'force'
 *   },
 * });
 */
export function useTurnRelayDeviceOnMutation(
  baseOptions?: Apollo.MutationHookOptions<
    TurnRelayDeviceOnMutation,
    TurnRelayDeviceOnMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    TurnRelayDeviceOnMutation,
    TurnRelayDeviceOnMutationVariables
  >(TurnRelayDeviceOnDocument, options);
}
export type TurnRelayDeviceOnMutationHookResult = ReturnType<
  typeof useTurnRelayDeviceOnMutation
>;
export type TurnRelayDeviceOnMutationResult =
  Apollo.MutationResult<TurnRelayDeviceOnMutation>;
export type TurnRelayDeviceOnMutationOptions = Apollo.BaseMutationOptions<
  TurnRelayDeviceOnMutation,
  TurnRelayDeviceOnMutationVariables
>;
export const TurnSmartPowerOutletOffDocument = gql`
  mutation TurnSmartPowerOutletOff($deviceId: String!, $force: Boolean) {
    updateSmartOutletOnOffState(
      deviceId: $deviceId
      updates: { isOn: false }
      options: { forcePush: $force }
    ) {
      _id
      type
      typeDisplayName
      zoneId
      name
      deviceId
      timestamp
      isConfigured
      meta {
        name
        model
        modelNumber
        version
      }
      zone {
        _id
        name
      }
      source {
        _id
        name
      }
      isOn {
        timestamp
        value
        units
      }
      rmsVoltage {
        timestamp
        value
        units
      }
      rmsCurrent {
        timestamp
        value
        units
      }
      apparentPower {
        timestamp
        value
        units
      }
      activePower {
        timestamp
        value
        units
      }
      powerFactor {
        timestamp
        value
        units
      }
      cumulativePower {
        timestamp
        value
        units
      }
      adjustedCumulativePower {
        timestamp
        value
        units
      }
      deviceAlerts {
        _id
        type {
          name
        }
        device {
          id
          name
          type
        }
        initiated
        updated
      }
      sourceAlerts {
        _id
        type {
          name
        }
        device {
          id
          name
          type
        }
        initiated
        updated
      }
    }
  }
`;
export type TurnSmartPowerOutletOffMutationFn = Apollo.MutationFunction<
  TurnSmartPowerOutletOffMutation,
  TurnSmartPowerOutletOffMutationVariables
>;

/**
 * __useTurnSmartPowerOutletOffMutation__
 *
 * To run a mutation, you first call `useTurnSmartPowerOutletOffMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useTurnSmartPowerOutletOffMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [turnSmartPowerOutletOffMutation, { data, loading, error }] = useTurnSmartPowerOutletOffMutation({
 *   variables: {
 *      deviceId: // value for 'deviceId'
 *      force: // value for 'force'
 *   },
 * });
 */
export function useTurnSmartPowerOutletOffMutation(
  baseOptions?: Apollo.MutationHookOptions<
    TurnSmartPowerOutletOffMutation,
    TurnSmartPowerOutletOffMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    TurnSmartPowerOutletOffMutation,
    TurnSmartPowerOutletOffMutationVariables
  >(TurnSmartPowerOutletOffDocument, options);
}
export type TurnSmartPowerOutletOffMutationHookResult = ReturnType<
  typeof useTurnSmartPowerOutletOffMutation
>;
export type TurnSmartPowerOutletOffMutationResult =
  Apollo.MutationResult<TurnSmartPowerOutletOffMutation>;
export type TurnSmartPowerOutletOffMutationOptions = Apollo.BaseMutationOptions<
  TurnSmartPowerOutletOffMutation,
  TurnSmartPowerOutletOffMutationVariables
>;
export const TurnSmartPowerOutletOnDocument = gql`
  mutation TurnSmartPowerOutletOn($deviceId: String!, $force: Boolean) {
    updateSmartOutletOnOffState(
      deviceId: $deviceId
      updates: { isOn: true }
      options: { forcePush: $force }
    ) {
      _id
      type
      typeDisplayName
      zoneId
      name
      deviceId
      timestamp
      isConfigured
      meta {
        name
        model
        modelNumber
        version
      }
      zone {
        _id
        name
      }
      source {
        _id
        name
      }
      isOn {
        timestamp
        value
        units
      }
      rmsVoltage {
        timestamp
        value
        units
      }
      rmsCurrent {
        timestamp
        value
        units
      }
      apparentPower {
        timestamp
        value
        units
      }
      activePower {
        timestamp
        value
        units
      }
      powerFactor {
        timestamp
        value
        units
      }
      cumulativePower {
        timestamp
        value
        units
      }
      adjustedCumulativePower {
        timestamp
        value
        units
      }
      deviceAlerts {
        _id
        type {
          name
        }
        device {
          id
          name
          type
        }
        initiated
        updated
      }
      sourceAlerts {
        _id
        type {
          name
        }
        device {
          id
          name
          type
        }
        initiated
        updated
      }
    }
  }
`;
export type TurnSmartPowerOutletOnMutationFn = Apollo.MutationFunction<
  TurnSmartPowerOutletOnMutation,
  TurnSmartPowerOutletOnMutationVariables
>;

/**
 * __useTurnSmartPowerOutletOnMutation__
 *
 * To run a mutation, you first call `useTurnSmartPowerOutletOnMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useTurnSmartPowerOutletOnMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [turnSmartPowerOutletOnMutation, { data, loading, error }] = useTurnSmartPowerOutletOnMutation({
 *   variables: {
 *      deviceId: // value for 'deviceId'
 *      force: // value for 'force'
 *   },
 * });
 */
export function useTurnSmartPowerOutletOnMutation(
  baseOptions?: Apollo.MutationHookOptions<
    TurnSmartPowerOutletOnMutation,
    TurnSmartPowerOutletOnMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    TurnSmartPowerOutletOnMutation,
    TurnSmartPowerOutletOnMutationVariables
  >(TurnSmartPowerOutletOnDocument, options);
}
export type TurnSmartPowerOutletOnMutationHookResult = ReturnType<
  typeof useTurnSmartPowerOutletOnMutation
>;
export type TurnSmartPowerOutletOnMutationResult =
  Apollo.MutationResult<TurnSmartPowerOutletOnMutation>;
export type TurnSmartPowerOutletOnMutationOptions = Apollo.BaseMutationOptions<
  TurnSmartPowerOutletOnMutation,
  TurnSmartPowerOutletOnMutationVariables
>;
export const UpdateModbusAirHandlerDocument = gql`
  mutation UpdateModbusAirHandler(
    $id: String!
    $updates: ModbusAirHandlerUpdateInput!
    $fields: ModbusAirHandlerUpdateFields
    $options: ModbusAirHandlerUpdateOptions
  ) {
    updateModbusAirHandler(
      deviceId: $id
      updates: $updates
      fields: $fields
      options: $options
    ) {
      _id
      zoneId
      panelId
      sourceId
      deviceId
      name
      type
      hasPendingUpdates
      deviceMetrics {
        key
        value {
          defaultValue
          defaultUnit
          readOnly
          streamId
          timestamp
          unit
          units
          value
          valueType
          description
        }
      }
      alarmGlobalAlarm {
        timestamp
        value
        units
      }
      alarmLowPressure {
        timestamp
        value
        units
      }
      alarmHighPressure {
        timestamp
        value
        units
      }
      alarmChangeFilters {
        timestamp
        value
        units
      }
      alarmChangeHepa {
        timestamp
        value
        units
      }
      alarmAirRestriction {
        timestamp
        value
        units
      }
      alarmSupplyFanStopped {
        timestamp
        value
        units
      }
      alarmExhaustFanStopped {
        timestamp
        value
        units
      }
      alarmRefrigerantLeak {
        timestamp
        value
        units
      }
      alarmCompressorFail {
        timestamp
        value
        units
      }
      alarmFanANegPressureOpt1 {
        timestamp
        value
        units
      }
      alarmFanANegPressureOpt2 {
        timestamp
        value
        units
      }
      alarmFanABReversed {
        timestamp
        value
        units
      }
      alarmClockBoard {
        timestamp
        value
        units
      }
      alarmExtendedMemory {
        timestamp
        value
        units
      }
      alarmB1SensorFail {
        timestamp
        value
        units
      }
      alarmB2SensorFail {
        timestamp
        value
        units
      }
      alarmB3SensorFail {
        timestamp
        value
        units
      }
      alarmB4SensorFail {
        timestamp
        value
        units
      }
      alarmB6SensorFail {
        timestamp
        value
        units
      }
      zmbGlobalAlarm {
        timestamp
        value
        units
      }
      zmbThermostatAlarm {
        timestamp
        value
        units
      }
      zmbAirHandlerAlarm {
        timestamp
        value
        units
      }
      zmbLeakDetected {
        timestamp
        value
        units
      }
      ventilationMode {
        timestamp
        value
        units
      }
      damperPosition {
        timestamp
        value
        units
      }
      reversibleValveOnWhen {
        timestamp
        value
        units
      }
      recirculationModeOn {
        timestamp
        value
        units
      }
      airExchangeModeOn {
        timestamp
        value
        units
      }
      supplyFanOn {
        timestamp
        value
        units
      }
      supplyFanAirflow {
        timestamp
        value
        units
      }
      supplyFanStaticPressureH2O {
        timestamp
        value
        units
      }
      exhaustFanOn {
        timestamp
        value
        units
      }
      exhaustFanAirflow {
        timestamp
        value
        units
      }
      systemOnOff {
        timestamp
        value
        units
      }
      systemAutoMode {
        timestamp
        value
        units
      }
      heatPumpModeOn {
        timestamp
        value
        units
      }
      heatingElementOn {
        timestamp
        value
        units
      }
      compressorOn {
        timestamp
        value
        units
      }
      indoorTemperature {
        timestamp
        value
        units
      }
      outsideTemperature {
        timestamp
        value
        units
      }
      indoorRH {
        timestamp
        value
        units
      }
      defrostTemperature {
        timestamp
        value
        units
      }
      conditionedTemperature {
        timestamp
        value
        units
      }
      ahuCoolSetpoint {
        timestamp
        value
        units
      }
      ahuHeatSetpoint {
        timestamp
        value
        units
      }
      ahuMinCoolSetpointLimit {
        timestamp
        value
        units
      }
      ahuMaxHeatSetpointLimit {
        timestamp
        value
        units
      }
      gTerminalOn {
        timestamp
        value
        units
      }
      hTerminalOn {
        timestamp
        value
        units
      }
      wTerminalOn {
        timestamp
        value
        units
      }
      yTerminalOn {
        timestamp
        value
        units
      }
      softwareReleaseType {
        timestamp
        value
        units
      }
      softwareVersion {
        timestamp
        value
        units
      }
      bootVersion {
        timestamp
        value
        units
      }
      biosVersion {
        timestamp
        value
        units
      }
      allowTenantOnOff {
        timestamp
        value
        units
      }
      enableTenantMode {
        timestamp
        value
        units
      }
      allowTenantChangeRHSetpoint {
        timestamp
        value
        units
      }
      allowTenantChangeTempSetpoints {
        timestamp
        value
        units
      }
      tenantModePassword {
        timestamp
        value
        units
      }
      airflowUnits {
        timestamp
        value
        units
      }
      ahuModbusId {
        timestamp
        value
        units
      }
      altitude {
        timestamp
        value
        units
      }
      freshAirSetpoint {
        timestamp
        value
        units
      }
      rhSetpoint {
        timestamp
        value
        units
      }
      auxCoolingEnabled {
        timestamp
        value
        units
      }
      winterRhAdjustEnabled {
        timestamp
        value
        units
      }
      showerDetectorEnabled {
        timestamp
        value
        units
      }
      resetFiltersServiceTime {
        timestamp
        value
        units
      }
      resetHepaServiceTime {
        timestamp
        value
        units
      }
      zmbPollingFrequency {
        timestamp
        value
        units
      }
      zmbModbusRequestDelay {
        timestamp
        value
        units
      }
      zmbPollingFrequency {
        timestamp
        value
        units
      }
      zmbModbusRequestDelay {
        timestamp
        value
        units
      }
      zmbFirmwareVersion {
        timestamp
        value
        units
      }
      zmbSystemUptime {
        timestamp
        value
        units
      }
      zmbTstatRequestsRecvd {
        timestamp
        value
        units
      }
      zmbRequestsRecvdInvalid {
        timestamp
        value
        units
      }
      zmbAhuRequestsSent {
        timestamp
        value
        units
      }
      zmbAhuRequestsSentFailed {
        timestamp
        value
        units
      }
      zmbCoreRequestsRecvd {
        timestamp
        value
        units
      }
      zmbLeakDetectorInstalled {
        timestamp
        value
        units
      }
      zmbCpuTemperature {
        timestamp
        value
        units
      }
      temperatureUnits {
        timestamp
        value
        units
      }
      filtersServiceTime {
        timestamp
        value
        units
      }
      hepaServiceTime {
        timestamp
        value
        units
      }
    }
  }
`;
export type UpdateModbusAirHandlerMutationFn = Apollo.MutationFunction<
  UpdateModbusAirHandlerMutation,
  UpdateModbusAirHandlerMutationVariables
>;

/**
 * __useUpdateModbusAirHandlerMutation__
 *
 * To run a mutation, you first call `useUpdateModbusAirHandlerMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateModbusAirHandlerMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateModbusAirHandlerMutation, { data, loading, error }] = useUpdateModbusAirHandlerMutation({
 *   variables: {
 *      id: // value for 'id'
 *      updates: // value for 'updates'
 *      fields: // value for 'fields'
 *      options: // value for 'options'
 *   },
 * });
 */
export function useUpdateModbusAirHandlerMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UpdateModbusAirHandlerMutation,
    UpdateModbusAirHandlerMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    UpdateModbusAirHandlerMutation,
    UpdateModbusAirHandlerMutationVariables
  >(UpdateModbusAirHandlerDocument, options);
}
export type UpdateModbusAirHandlerMutationHookResult = ReturnType<
  typeof useUpdateModbusAirHandlerMutation
>;
export type UpdateModbusAirHandlerMutationResult =
  Apollo.MutationResult<UpdateModbusAirHandlerMutation>;
export type UpdateModbusAirHandlerMutationOptions = Apollo.BaseMutationOptions<
  UpdateModbusAirHandlerMutation,
  UpdateModbusAirHandlerMutationVariables
>;
export const UpdateThermostatDocument = gql`
  mutation UpdateThermostat(
    $id: String!
    $updates: ThermostatUpdateInput!
    $fields: ThermostatUpdateFields
    $options: ThermostatUpdateOptions
  ) {
    updateThermostat(
      deviceId: $id
      updates: $updates
      fields: $fields
      options: $options
    ) {
      _id
      zoneId
      panelId
      sourceId
      deviceId
      name
      type
      hasPendingUpdates
      isMitsubishiThermostat
      localControlPermissionsV1 {
        value {
          power
          operatingMode
          temperature
          fanSpeed
          louvre
          filterReset
          timer
        }
        canEdit
        pending
        observedAt
      }
      louvreControlV1 {
        supportsAirDirection
        canEditAirDirection
        allowedAirDirections
        airDirection {
          value
          readingId
          timestamp
          observedAt
          pending
        }
      }
      separatePowerControlV1 {
        controlContract
        canEditPowerMode
        canEditOperatingMode
        supportsAirDirection
        canEditAirDirection
        allowedAirDirections
        airDirection {
          value
          readingId
          timestamp
          observedAt
          pending
        }
        canEditFanSpeed
        allowedFanSpeeds
        fanSpeed {
          value
          readingId
          timestamp
          observedAt
          pending
        }
        allowedOperatingModes
        canEditTargets
        targetBlockReason
        powerMode {
          value
          readingId
          timestamp
          observedAt
          pending
        }
        powerState {
          value
          readingId
          timestamp
          observedAt
          pending
        }
        operatingMode {
          value
          readingId
          timestamp
          observedAt
          pending
        }
        operatingState {
          value
          readingId
          timestamp
          observedAt
          pending
        }
      }
      setpoint {
        value
        units
        timestamp
        updatePending
      }
      minSetpoint {
        value
        units
        timestamp
      }
      maxSetpoint {
        value
        units
        timestamp
      }
      supportsAutoMode
      supportsSingleSetpointAutoMode
      supportsDualSetpointAutoMode
      thermostatScheduleTemplateId
      deviceMetrics {
        key
        value {
          defaultValue
          defaultUnit
          readOnly
          streamId
          timestamp
          unit
          units
          value
          valueType
        }
      }
      fanMode {
        timestamp
        value
        units
      }
      fanSpeed {
        timestamp
        value
        units
      }
      fanState {
        timestamp
        value
        units
      }
      holdDuration {
        timestamp
        value
        units
      }
      holdEnd {
        timestamp
        value
        units
      }
      holdState {
        timestamp
        value
        units
      }
      humidity {
        timestamp
        value
        units
      }
      keypadLockoutLevel {
        timestamp
        value
        units
      }
      lastScheduleChange {
        timestamp
        value
        units
      }
      lastSetpointChange {
        timestamp
        value
        units
      }
      maxCoolSetpointLimit {
        timestamp
        value
        units
      }
      maxHeatSetpointLimit {
        timestamp
        value
        units
      }
      minCoolSetpointLimit {
        timestamp
        value
        units
      }
      minHeatSetpointLimit {
        timestamp
        value
        units
      }
      operatingMode {
        timestamp
        value
        units
      }
      operatingState {
        timestamp
        value
        units
      }
      passCode {
        timestamp
        value
        units
      }
      progMode {
        timestamp
        value
        units
      }
      remoteSensorTempDelta {
        timestamp
        value
        units
      }
      schedVisibilityMode {
        timestamp
        value
        units
      }
      setpointChangeSource {
        timestamp
        value
        units
      }
      showFanButton {
        timestamp
        value
        units
      }
      systemType {
        timestamp
        value
        units
      }
      tempDisplayMode {
        timestamp
        value
        units
      }
      temperature {
        timestamp
        value
        units
      }
      modbusRTU
      keypadLockoutLevels
      uiOptions {
        timestamp
        value
        units
      }
      heatSetpoint {
        timestamp
        value
      }
      coolSetpoint {
        timestamp
        value
      }
      useCustomSetpointLimits
      useCustomSchedule
    }
  }
`;
export type UpdateThermostatMutationFn = Apollo.MutationFunction<
  UpdateThermostatMutation,
  UpdateThermostatMutationVariables
>;

/**
 * __useUpdateThermostatMutation__
 *
 * To run a mutation, you first call `useUpdateThermostatMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateThermostatMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateThermostatMutation, { data, loading, error }] = useUpdateThermostatMutation({
 *   variables: {
 *      id: // value for 'id'
 *      updates: // value for 'updates'
 *      fields: // value for 'fields'
 *      options: // value for 'options'
 *   },
 * });
 */
export function useUpdateThermostatMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UpdateThermostatMutation,
    UpdateThermostatMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    UpdateThermostatMutation,
    UpdateThermostatMutationVariables
  >(UpdateThermostatDocument, options);
}
export type UpdateThermostatMutationHookResult = ReturnType<
  typeof useUpdateThermostatMutation
>;
export type UpdateThermostatMutationResult =
  Apollo.MutationResult<UpdateThermostatMutation>;
export type UpdateThermostatMutationOptions = Apollo.BaseMutationOptions<
  UpdateThermostatMutation,
  UpdateThermostatMutationVariables
>;
export const UpdateThermostatPendingScheduleDocument = gql`
  mutation UpdateThermostatPendingSchedule(
    $deviceId: String!
    $update: ThermostatPendingScheduleInput!
  ) {
    updateThermostatPendingSchedule(deviceId: $deviceId, update: $update) {
      deviceId
    }
  }
`;
export type UpdateThermostatPendingScheduleMutationFn = Apollo.MutationFunction<
  UpdateThermostatPendingScheduleMutation,
  UpdateThermostatPendingScheduleMutationVariables
>;

/**
 * __useUpdateThermostatPendingScheduleMutation__
 *
 * To run a mutation, you first call `useUpdateThermostatPendingScheduleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateThermostatPendingScheduleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateThermostatPendingScheduleMutation, { data, loading, error }] = useUpdateThermostatPendingScheduleMutation({
 *   variables: {
 *      deviceId: // value for 'deviceId'
 *      update: // value for 'update'
 *   },
 * });
 */
export function useUpdateThermostatPendingScheduleMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UpdateThermostatPendingScheduleMutation,
    UpdateThermostatPendingScheduleMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    UpdateThermostatPendingScheduleMutation,
    UpdateThermostatPendingScheduleMutationVariables
  >(UpdateThermostatPendingScheduleDocument, options);
}
export type UpdateThermostatPendingScheduleMutationHookResult = ReturnType<
  typeof useUpdateThermostatPendingScheduleMutation
>;
export type UpdateThermostatPendingScheduleMutationResult =
  Apollo.MutationResult<UpdateThermostatPendingScheduleMutation>;
export type UpdateThermostatPendingScheduleMutationOptions =
  Apollo.BaseMutationOptions<
    UpdateThermostatPendingScheduleMutation,
    UpdateThermostatPendingScheduleMutationVariables
  >;
export const WindowSensorDetailUpdateDocument = gql`
  subscription WindowSensorDetailUpdate($ids: [String!]!) {
    windowSensorEventsByIds(_ids: $ids) {
      modelChangeOperation
      _id
      type
      typeDisplayName
      zoneId
      name
      deviceId
      timestamp
      isConfigured
      meta {
        name
        model
        modelNumber
        version
      }
      contactState {
        timestamp
        value
        units
      }
      voltage {
        timestamp
        value
        units
      }
      hasContactState
      deviceAlerts {
        _id
        type {
          name
        }
        device {
          id
          name
          type
        }
        initiated
        updated
      }
      sourceAlerts {
        _id
        type {
          name
        }
        device {
          id
          name
          type
        }
        initiated
        updated
      }
    }
  }
`;

/**
 * __useWindowSensorDetailUpdateSubscription__
 *
 * To run a query within a React component, call `useWindowSensorDetailUpdateSubscription` and pass it any options that fit your needs.
 * When your component renders, `useWindowSensorDetailUpdateSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useWindowSensorDetailUpdateSubscription({
 *   variables: {
 *      ids: // value for 'ids'
 *   },
 * });
 */
export function useWindowSensorDetailUpdateSubscription(
  baseOptions: Apollo.SubscriptionHookOptions<
    WindowSensorDetailUpdateSubscription,
    WindowSensorDetailUpdateSubscriptionVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useSubscription<
    WindowSensorDetailUpdateSubscription,
    WindowSensorDetailUpdateSubscriptionVariables
  >(WindowSensorDetailUpdateDocument, options);
}
export type WindowSensorDetailUpdateSubscriptionHookResult = ReturnType<
  typeof useWindowSensorDetailUpdateSubscription
>;
export type WindowSensorDetailUpdateSubscriptionResult =
  Apollo.SubscriptionResult<WindowSensorDetailUpdateSubscription>;
export const WindowSensorDetailDocument = gql`
  query WindowSensorDetail($id: String!) {
    windowSensorById(_id: $id) {
      _id
      type
      typeDisplayName
      zoneId
      name
      deviceId
      timestamp
      isConfigured
      meta {
        name
        model
        modelNumber
        version
      }
      zone {
        _id
        name
      }
      source {
        _id
        name
      }
      contactState {
        timestamp
        value
        units
      }
      voltage {
        timestamp
        value
        units
      }
      hasContactState
      deviceAlerts {
        _id
        type {
          name
        }
        device {
          id
          name
          type
        }
        initiated
        updated
      }
      sourceAlerts {
        _id
        type {
          name
        }
        device {
          id
          name
          type
        }
        initiated
        updated
      }
    }
  }
`;

/**
 * __useWindowSensorDetailQuery__
 *
 * To run a query within a React component, call `useWindowSensorDetailQuery` and pass it any options that fit your needs.
 * When your component renders, `useWindowSensorDetailQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useWindowSensorDetailQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useWindowSensorDetailQuery(
  baseOptions: Apollo.QueryHookOptions<
    WindowSensorDetailQuery,
    WindowSensorDetailQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    WindowSensorDetailQuery,
    WindowSensorDetailQueryVariables
  >(WindowSensorDetailDocument, options);
}
export function useWindowSensorDetailLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    WindowSensorDetailQuery,
    WindowSensorDetailQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    WindowSensorDetailQuery,
    WindowSensorDetailQueryVariables
  >(WindowSensorDetailDocument, options);
}
export type WindowSensorDetailQueryHookResult = ReturnType<
  typeof useWindowSensorDetailQuery
>;
export type WindowSensorDetailLazyQueryHookResult = ReturnType<
  typeof useWindowSensorDetailLazyQuery
>;
export type WindowSensorDetailQueryResult = Apollo.QueryResult<
  WindowSensorDetailQuery,
  WindowSensorDetailQueryVariables
>;
export const CreateThermostatScheduleTemplateDocument = gql`
  mutation CreateThermostatScheduleTemplate(
    $thermostatScheduleTemplate: CreateOneThermostatScheduleTemplateInput!
  ) {
    createThermostatScheduleTemplate(
      thermostatScheduleTemplate: $thermostatScheduleTemplate
    )
  }
`;
export type CreateThermostatScheduleTemplateMutationFn =
  Apollo.MutationFunction<
    CreateThermostatScheduleTemplateMutation,
    CreateThermostatScheduleTemplateMutationVariables
  >;

/**
 * __useCreateThermostatScheduleTemplateMutation__
 *
 * To run a mutation, you first call `useCreateThermostatScheduleTemplateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateThermostatScheduleTemplateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createThermostatScheduleTemplateMutation, { data, loading, error }] = useCreateThermostatScheduleTemplateMutation({
 *   variables: {
 *      thermostatScheduleTemplate: // value for 'thermostatScheduleTemplate'
 *   },
 * });
 */
export function useCreateThermostatScheduleTemplateMutation(
  baseOptions?: Apollo.MutationHookOptions<
    CreateThermostatScheduleTemplateMutation,
    CreateThermostatScheduleTemplateMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    CreateThermostatScheduleTemplateMutation,
    CreateThermostatScheduleTemplateMutationVariables
  >(CreateThermostatScheduleTemplateDocument, options);
}
export type CreateThermostatScheduleTemplateMutationHookResult = ReturnType<
  typeof useCreateThermostatScheduleTemplateMutation
>;
export type CreateThermostatScheduleTemplateMutationResult =
  Apollo.MutationResult<CreateThermostatScheduleTemplateMutation>;
export type CreateThermostatScheduleTemplateMutationOptions =
  Apollo.BaseMutationOptions<
    CreateThermostatScheduleTemplateMutation,
    CreateThermostatScheduleTemplateMutationVariables
  >;
export const PropertyDataForScheduleTemplatesUpdatesDocument = gql`
  subscription PropertyDataForScheduleTemplatesUpdates($id: String!) {
    propertyEventsByIds(_ids: [$id]) {
      modelChangeOperation
      _id
      setpointProfileId
      thermostatScheduleTemplateId
    }
  }
`;

/**
 * __usePropertyDataForScheduleTemplatesUpdatesSubscription__
 *
 * To run a query within a React component, call `usePropertyDataForScheduleTemplatesUpdatesSubscription` and pass it any options that fit your needs.
 * When your component renders, `usePropertyDataForScheduleTemplatesUpdatesSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePropertyDataForScheduleTemplatesUpdatesSubscription({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function usePropertyDataForScheduleTemplatesUpdatesSubscription(
  baseOptions: Apollo.SubscriptionHookOptions<
    PropertyDataForScheduleTemplatesUpdatesSubscription,
    PropertyDataForScheduleTemplatesUpdatesSubscriptionVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useSubscription<
    PropertyDataForScheduleTemplatesUpdatesSubscription,
    PropertyDataForScheduleTemplatesUpdatesSubscriptionVariables
  >(PropertyDataForScheduleTemplatesUpdatesDocument, options);
}
export type PropertyDataForScheduleTemplatesUpdatesSubscriptionHookResult =
  ReturnType<typeof usePropertyDataForScheduleTemplatesUpdatesSubscription>;
export type PropertyDataForScheduleTemplatesUpdatesSubscriptionResult =
  Apollo.SubscriptionResult<PropertyDataForScheduleTemplatesUpdatesSubscription>;
export const PropertyDataForScheduleTemplatesDocument = gql`
  query PropertyDataForScheduleTemplates($id: String!) {
    propertyById(_id: $id) {
      _id
      setpointProfileId
      thermostatScheduleTemplateId
    }
  }
`;

/**
 * __usePropertyDataForScheduleTemplatesQuery__
 *
 * To run a query within a React component, call `usePropertyDataForScheduleTemplatesQuery` and pass it any options that fit your needs.
 * When your component renders, `usePropertyDataForScheduleTemplatesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePropertyDataForScheduleTemplatesQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function usePropertyDataForScheduleTemplatesQuery(
  baseOptions: Apollo.QueryHookOptions<
    PropertyDataForScheduleTemplatesQuery,
    PropertyDataForScheduleTemplatesQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    PropertyDataForScheduleTemplatesQuery,
    PropertyDataForScheduleTemplatesQueryVariables
  >(PropertyDataForScheduleTemplatesDocument, options);
}
export function usePropertyDataForScheduleTemplatesLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    PropertyDataForScheduleTemplatesQuery,
    PropertyDataForScheduleTemplatesQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    PropertyDataForScheduleTemplatesQuery,
    PropertyDataForScheduleTemplatesQueryVariables
  >(PropertyDataForScheduleTemplatesDocument, options);
}
export type PropertyDataForScheduleTemplatesQueryHookResult = ReturnType<
  typeof usePropertyDataForScheduleTemplatesQuery
>;
export type PropertyDataForScheduleTemplatesLazyQueryHookResult = ReturnType<
  typeof usePropertyDataForScheduleTemplatesLazyQuery
>;
export type PropertyDataForScheduleTemplatesQueryResult = Apollo.QueryResult<
  PropertyDataForScheduleTemplatesQuery,
  PropertyDataForScheduleTemplatesQueryVariables
>;
export const PropertyScheduleTemplateListDocument = gql`
  query PropertyScheduleTemplateList($propertyId: String!) {
    thermostatScheduleTemplates(filter: { propertyId: $propertyId }) {
      _id
      propertyId
      assignedUnitCount
      assignedDeviceCount
      setpointLimitProfileId
      isPropertyDefault
      name
      value {
        id
        units
        timestamp
        value
        updatePending
      }
    }
  }
`;

/**
 * __usePropertyScheduleTemplateListQuery__
 *
 * To run a query within a React component, call `usePropertyScheduleTemplateListQuery` and pass it any options that fit your needs.
 * When your component renders, `usePropertyScheduleTemplateListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePropertyScheduleTemplateListQuery({
 *   variables: {
 *      propertyId: // value for 'propertyId'
 *   },
 * });
 */
export function usePropertyScheduleTemplateListQuery(
  baseOptions: Apollo.QueryHookOptions<
    PropertyScheduleTemplateListQuery,
    PropertyScheduleTemplateListQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    PropertyScheduleTemplateListQuery,
    PropertyScheduleTemplateListQueryVariables
  >(PropertyScheduleTemplateListDocument, options);
}
export function usePropertyScheduleTemplateListLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    PropertyScheduleTemplateListQuery,
    PropertyScheduleTemplateListQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    PropertyScheduleTemplateListQuery,
    PropertyScheduleTemplateListQueryVariables
  >(PropertyScheduleTemplateListDocument, options);
}
export type PropertyScheduleTemplateListQueryHookResult = ReturnType<
  typeof usePropertyScheduleTemplateListQuery
>;
export type PropertyScheduleTemplateListLazyQueryHookResult = ReturnType<
  typeof usePropertyScheduleTemplateListLazyQuery
>;
export type PropertyScheduleTemplateListQueryResult = Apollo.QueryResult<
  PropertyScheduleTemplateListQuery,
  PropertyScheduleTemplateListQueryVariables
>;
export const RemoveThermostatScheduleTemplateDocument = gql`
  mutation RemoveThermostatScheduleTemplate(
    $removeThermostatScheduleTemplateId: String!
  ) {
    removeThermostatScheduleTemplate(id: $removeThermostatScheduleTemplateId)
  }
`;
export type RemoveThermostatScheduleTemplateMutationFn =
  Apollo.MutationFunction<
    RemoveThermostatScheduleTemplateMutation,
    RemoveThermostatScheduleTemplateMutationVariables
  >;

/**
 * __useRemoveThermostatScheduleTemplateMutation__
 *
 * To run a mutation, you first call `useRemoveThermostatScheduleTemplateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveThermostatScheduleTemplateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeThermostatScheduleTemplateMutation, { data, loading, error }] = useRemoveThermostatScheduleTemplateMutation({
 *   variables: {
 *      removeThermostatScheduleTemplateId: // value for 'removeThermostatScheduleTemplateId'
 *   },
 * });
 */
export function useRemoveThermostatScheduleTemplateMutation(
  baseOptions?: Apollo.MutationHookOptions<
    RemoveThermostatScheduleTemplateMutation,
    RemoveThermostatScheduleTemplateMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    RemoveThermostatScheduleTemplateMutation,
    RemoveThermostatScheduleTemplateMutationVariables
  >(RemoveThermostatScheduleTemplateDocument, options);
}
export type RemoveThermostatScheduleTemplateMutationHookResult = ReturnType<
  typeof useRemoveThermostatScheduleTemplateMutation
>;
export type RemoveThermostatScheduleTemplateMutationResult =
  Apollo.MutationResult<RemoveThermostatScheduleTemplateMutation>;
export type RemoveThermostatScheduleTemplateMutationOptions =
  Apollo.BaseMutationOptions<
    RemoveThermostatScheduleTemplateMutation,
    RemoveThermostatScheduleTemplateMutationVariables
  >;
export const ScheduleTemplateBySetpointProfileIdDocument = gql`
  query ScheduleTemplateBySetpointProfileId($setpointProfileId: String!) {
    thermostatScheduleTemplates(
      filter: { setpointLimitProfileId: $setpointProfileId }
    ) {
      _id
    }
  }
`;

/**
 * __useScheduleTemplateBySetpointProfileIdQuery__
 *
 * To run a query within a React component, call `useScheduleTemplateBySetpointProfileIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useScheduleTemplateBySetpointProfileIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useScheduleTemplateBySetpointProfileIdQuery({
 *   variables: {
 *      setpointProfileId: // value for 'setpointProfileId'
 *   },
 * });
 */
export function useScheduleTemplateBySetpointProfileIdQuery(
  baseOptions: Apollo.QueryHookOptions<
    ScheduleTemplateBySetpointProfileIdQuery,
    ScheduleTemplateBySetpointProfileIdQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    ScheduleTemplateBySetpointProfileIdQuery,
    ScheduleTemplateBySetpointProfileIdQueryVariables
  >(ScheduleTemplateBySetpointProfileIdDocument, options);
}
export function useScheduleTemplateBySetpointProfileIdLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    ScheduleTemplateBySetpointProfileIdQuery,
    ScheduleTemplateBySetpointProfileIdQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    ScheduleTemplateBySetpointProfileIdQuery,
    ScheduleTemplateBySetpointProfileIdQueryVariables
  >(ScheduleTemplateBySetpointProfileIdDocument, options);
}
export type ScheduleTemplateBySetpointProfileIdQueryHookResult = ReturnType<
  typeof useScheduleTemplateBySetpointProfileIdQuery
>;
export type ScheduleTemplateBySetpointProfileIdLazyQueryHookResult = ReturnType<
  typeof useScheduleTemplateBySetpointProfileIdLazyQuery
>;
export type ScheduleTemplateBySetpointProfileIdQueryResult = Apollo.QueryResult<
  ScheduleTemplateBySetpointProfileIdQuery,
  ScheduleTemplateBySetpointProfileIdQueryVariables
>;
export const UnitDataForScheduleTemplatesUpdatesDocument = gql`
  subscription UnitDataForScheduleTemplatesUpdates($id: String!) {
    unitEventsByIds(_ids: [$id]) {
      modelChangeOperation
      _id
      setpointProfileId
      thermostatScheduleTemplateId
    }
  }
`;

/**
 * __useUnitDataForScheduleTemplatesUpdatesSubscription__
 *
 * To run a query within a React component, call `useUnitDataForScheduleTemplatesUpdatesSubscription` and pass it any options that fit your needs.
 * When your component renders, `useUnitDataForScheduleTemplatesUpdatesSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUnitDataForScheduleTemplatesUpdatesSubscription({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useUnitDataForScheduleTemplatesUpdatesSubscription(
  baseOptions: Apollo.SubscriptionHookOptions<
    UnitDataForScheduleTemplatesUpdatesSubscription,
    UnitDataForScheduleTemplatesUpdatesSubscriptionVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useSubscription<
    UnitDataForScheduleTemplatesUpdatesSubscription,
    UnitDataForScheduleTemplatesUpdatesSubscriptionVariables
  >(UnitDataForScheduleTemplatesUpdatesDocument, options);
}
export type UnitDataForScheduleTemplatesUpdatesSubscriptionHookResult =
  ReturnType<typeof useUnitDataForScheduleTemplatesUpdatesSubscription>;
export type UnitDataForScheduleTemplatesUpdatesSubscriptionResult =
  Apollo.SubscriptionResult<UnitDataForScheduleTemplatesUpdatesSubscription>;
export const UnitDataForScheduleTemplatesDocument = gql`
  query UnitDataForScheduleTemplates($id: String!) {
    unitById(_id: $id) {
      _id
      setpointProfileId
      thermostatScheduleTemplateId
    }
  }
`;

/**
 * __useUnitDataForScheduleTemplatesQuery__
 *
 * To run a query within a React component, call `useUnitDataForScheduleTemplatesQuery` and pass it any options that fit your needs.
 * When your component renders, `useUnitDataForScheduleTemplatesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUnitDataForScheduleTemplatesQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useUnitDataForScheduleTemplatesQuery(
  baseOptions: Apollo.QueryHookOptions<
    UnitDataForScheduleTemplatesQuery,
    UnitDataForScheduleTemplatesQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    UnitDataForScheduleTemplatesQuery,
    UnitDataForScheduleTemplatesQueryVariables
  >(UnitDataForScheduleTemplatesDocument, options);
}
export function useUnitDataForScheduleTemplatesLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    UnitDataForScheduleTemplatesQuery,
    UnitDataForScheduleTemplatesQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    UnitDataForScheduleTemplatesQuery,
    UnitDataForScheduleTemplatesQueryVariables
  >(UnitDataForScheduleTemplatesDocument, options);
}
export type UnitDataForScheduleTemplatesQueryHookResult = ReturnType<
  typeof useUnitDataForScheduleTemplatesQuery
>;
export type UnitDataForScheduleTemplatesLazyQueryHookResult = ReturnType<
  typeof useUnitDataForScheduleTemplatesLazyQuery
>;
export type UnitDataForScheduleTemplatesQueryResult = Apollo.QueryResult<
  UnitDataForScheduleTemplatesQuery,
  UnitDataForScheduleTemplatesQueryVariables
>;
export const UpdatePropertyThermostatScheduleTemplateOverrideDocument = gql`
  mutation UpdatePropertyThermostatScheduleTemplateOverride(
    $id: String!
    $thermostatScheduleTemplateId: String!
    $propertyHasIncompatibleScheduleTemplate: Boolean
    $targetThermostatIds: [String]
    $force: Boolean
  ) {
    updatePropertyThermostatScheduleTemplateOverride(
      id: $id
      thermostatScheduleTemplateId: $thermostatScheduleTemplateId
      propertyHasIncompatibleScheduleTemplate: $propertyHasIncompatibleScheduleTemplate
      targetThermostatIds: $targetThermostatIds
      force: $force
    ) {
      thermostatScheduleTemplateId
    }
  }
`;
export type UpdatePropertyThermostatScheduleTemplateOverrideMutationFn =
  Apollo.MutationFunction<
    UpdatePropertyThermostatScheduleTemplateOverrideMutation,
    UpdatePropertyThermostatScheduleTemplateOverrideMutationVariables
  >;

/**
 * __useUpdatePropertyThermostatScheduleTemplateOverrideMutation__
 *
 * To run a mutation, you first call `useUpdatePropertyThermostatScheduleTemplateOverrideMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdatePropertyThermostatScheduleTemplateOverrideMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updatePropertyThermostatScheduleTemplateOverrideMutation, { data, loading, error }] = useUpdatePropertyThermostatScheduleTemplateOverrideMutation({
 *   variables: {
 *      id: // value for 'id'
 *      thermostatScheduleTemplateId: // value for 'thermostatScheduleTemplateId'
 *      propertyHasIncompatibleScheduleTemplate: // value for 'propertyHasIncompatibleScheduleTemplate'
 *      targetThermostatIds: // value for 'targetThermostatIds'
 *      force: // value for 'force'
 *   },
 * });
 */
export function useUpdatePropertyThermostatScheduleTemplateOverrideMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UpdatePropertyThermostatScheduleTemplateOverrideMutation,
    UpdatePropertyThermostatScheduleTemplateOverrideMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    UpdatePropertyThermostatScheduleTemplateOverrideMutation,
    UpdatePropertyThermostatScheduleTemplateOverrideMutationVariables
  >(UpdatePropertyThermostatScheduleTemplateOverrideDocument, options);
}
export type UpdatePropertyThermostatScheduleTemplateOverrideMutationHookResult =
  ReturnType<
    typeof useUpdatePropertyThermostatScheduleTemplateOverrideMutation
  >;
export type UpdatePropertyThermostatScheduleTemplateOverrideMutationResult =
  Apollo.MutationResult<UpdatePropertyThermostatScheduleTemplateOverrideMutation>;
export type UpdatePropertyThermostatScheduleTemplateOverrideMutationOptions =
  Apollo.BaseMutationOptions<
    UpdatePropertyThermostatScheduleTemplateOverrideMutation,
    UpdatePropertyThermostatScheduleTemplateOverrideMutationVariables
  >;
export const UpdateThermostatScheduleTemplateDocument = gql`
  mutation UpdateThermostatScheduleTemplate(
    $thermostatScheduleTemplate: UpdateOneThermostatScheduleTemplateInput!
  ) {
    updateThermostatScheduleTemplate(
      thermostatScheduleTemplate: $thermostatScheduleTemplate
    ) {
      _id
      name
      propertyId
      setpointLimitProfileId
      value {
        id
        units
        timestamp
        updatePending
        value
      }
    }
  }
`;
export type UpdateThermostatScheduleTemplateMutationFn =
  Apollo.MutationFunction<
    UpdateThermostatScheduleTemplateMutation,
    UpdateThermostatScheduleTemplateMutationVariables
  >;

/**
 * __useUpdateThermostatScheduleTemplateMutation__
 *
 * To run a mutation, you first call `useUpdateThermostatScheduleTemplateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateThermostatScheduleTemplateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateThermostatScheduleTemplateMutation, { data, loading, error }] = useUpdateThermostatScheduleTemplateMutation({
 *   variables: {
 *      thermostatScheduleTemplate: // value for 'thermostatScheduleTemplate'
 *   },
 * });
 */
export function useUpdateThermostatScheduleTemplateMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UpdateThermostatScheduleTemplateMutation,
    UpdateThermostatScheduleTemplateMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    UpdateThermostatScheduleTemplateMutation,
    UpdateThermostatScheduleTemplateMutationVariables
  >(UpdateThermostatScheduleTemplateDocument, options);
}
export type UpdateThermostatScheduleTemplateMutationHookResult = ReturnType<
  typeof useUpdateThermostatScheduleTemplateMutation
>;
export type UpdateThermostatScheduleTemplateMutationResult =
  Apollo.MutationResult<UpdateThermostatScheduleTemplateMutation>;
export type UpdateThermostatScheduleTemplateMutationOptions =
  Apollo.BaseMutationOptions<
    UpdateThermostatScheduleTemplateMutation,
    UpdateThermostatScheduleTemplateMutationVariables
  >;
export const UpdateUnitThermostatScheduleTemplateOverrideDocument = gql`
  mutation UpdateUnitThermostatScheduleTemplateOverride(
    $id: String!
    $thermostatScheduleTemplateId: String!
    $unitHasIncompatibleScheduleTemplate: Boolean
    $targetThermostatIds: [String]
    $force: Boolean
  ) {
    updateUnitThermostatScheduleTemplateOverride(
      id: $id
      thermostatScheduleTemplateId: $thermostatScheduleTemplateId
      unitHasIncompatibleScheduleTemplate: $unitHasIncompatibleScheduleTemplate
      targetThermostatIds: $targetThermostatIds
      force: $force
    ) {
      thermostatScheduleTemplateId
    }
  }
`;
export type UpdateUnitThermostatScheduleTemplateOverrideMutationFn =
  Apollo.MutationFunction<
    UpdateUnitThermostatScheduleTemplateOverrideMutation,
    UpdateUnitThermostatScheduleTemplateOverrideMutationVariables
  >;

/**
 * __useUpdateUnitThermostatScheduleTemplateOverrideMutation__
 *
 * To run a mutation, you first call `useUpdateUnitThermostatScheduleTemplateOverrideMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateUnitThermostatScheduleTemplateOverrideMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateUnitThermostatScheduleTemplateOverrideMutation, { data, loading, error }] = useUpdateUnitThermostatScheduleTemplateOverrideMutation({
 *   variables: {
 *      id: // value for 'id'
 *      thermostatScheduleTemplateId: // value for 'thermostatScheduleTemplateId'
 *      unitHasIncompatibleScheduleTemplate: // value for 'unitHasIncompatibleScheduleTemplate'
 *      targetThermostatIds: // value for 'targetThermostatIds'
 *      force: // value for 'force'
 *   },
 * });
 */
export function useUpdateUnitThermostatScheduleTemplateOverrideMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UpdateUnitThermostatScheduleTemplateOverrideMutation,
    UpdateUnitThermostatScheduleTemplateOverrideMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    UpdateUnitThermostatScheduleTemplateOverrideMutation,
    UpdateUnitThermostatScheduleTemplateOverrideMutationVariables
  >(UpdateUnitThermostatScheduleTemplateOverrideDocument, options);
}
export type UpdateUnitThermostatScheduleTemplateOverrideMutationHookResult =
  ReturnType<typeof useUpdateUnitThermostatScheduleTemplateOverrideMutation>;
export type UpdateUnitThermostatScheduleTemplateOverrideMutationResult =
  Apollo.MutationResult<UpdateUnitThermostatScheduleTemplateOverrideMutation>;
export type UpdateUnitThermostatScheduleTemplateOverrideMutationOptions =
  Apollo.BaseMutationOptions<
    UpdateUnitThermostatScheduleTemplateOverrideMutation,
    UpdateUnitThermostatScheduleTemplateOverrideMutationVariables
  >;
export const ScheduledNotificationsSubscriptionDocument = gql`
  subscription ScheduledNotificationsSubscription {
    systemNotificationEvents {
      modelChangeOperation
      _id
      entityId
      entityType
      message
      link
      createdAt
      displayStart
      displayEnd
      acknowledgedAt
      seenAt
      requireAcknowledgement
      relatedEntityName
      seenBy {
        userId
        seenAt
      }
    }
  }
`;

/**
 * __useScheduledNotificationsSubscriptionSubscription__
 *
 * To run a query within a React component, call `useScheduledNotificationsSubscriptionSubscription` and pass it any options that fit your needs.
 * When your component renders, `useScheduledNotificationsSubscriptionSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useScheduledNotificationsSubscriptionSubscription({
 *   variables: {
 *   },
 * });
 */
export function useScheduledNotificationsSubscriptionSubscription(
  baseOptions?: Apollo.SubscriptionHookOptions<
    ScheduledNotificationsSubscriptionSubscription,
    ScheduledNotificationsSubscriptionSubscriptionVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useSubscription<
    ScheduledNotificationsSubscriptionSubscription,
    ScheduledNotificationsSubscriptionSubscriptionVariables
  >(ScheduledNotificationsSubscriptionDocument, options);
}
export type ScheduledNotificationsSubscriptionSubscriptionHookResult =
  ReturnType<typeof useScheduledNotificationsSubscriptionSubscription>;
export type ScheduledNotificationsSubscriptionSubscriptionResult =
  Apollo.SubscriptionResult<ScheduledNotificationsSubscriptionSubscription>;
export const ScheduledNotificationsDocument = gql`
  query ScheduledNotifications {
    systemNotifications {
      _id
      entityId
      entityType
      message
      link
      createdAt
      displayStart
      displayEnd
      acknowledgedAt
      seenAt
      requireAcknowledgement
      relatedEntityName
      seenBy {
        userId
        seenAt
      }
    }
  }
`;

/**
 * __useScheduledNotificationsQuery__
 *
 * To run a query within a React component, call `useScheduledNotificationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useScheduledNotificationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useScheduledNotificationsQuery({
 *   variables: {
 *   },
 * });
 */
export function useScheduledNotificationsQuery(
  baseOptions?: Apollo.QueryHookOptions<
    ScheduledNotificationsQuery,
    ScheduledNotificationsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    ScheduledNotificationsQuery,
    ScheduledNotificationsQueryVariables
  >(ScheduledNotificationsDocument, options);
}
export function useScheduledNotificationsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    ScheduledNotificationsQuery,
    ScheduledNotificationsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    ScheduledNotificationsQuery,
    ScheduledNotificationsQueryVariables
  >(ScheduledNotificationsDocument, options);
}
export type ScheduledNotificationsQueryHookResult = ReturnType<
  typeof useScheduledNotificationsQuery
>;
export type ScheduledNotificationsLazyQueryHookResult = ReturnType<
  typeof useScheduledNotificationsLazyQuery
>;
export type ScheduledNotificationsQueryResult = Apollo.QueryResult<
  ScheduledNotificationsQuery,
  ScheduledNotificationsQueryVariables
>;
export const ScheduleTaskDocument = gql`
  mutation ScheduleTask(
    $modelName: String!
    $instanceId: String!
    $methodName: String!
    $scheduledAt: Float!
    $priority: Int
    $maxRetries: Int
  ) {
    scheduleTask(
      modelName: $modelName
      instanceId: $instanceId
      methodName: $methodName
      scheduledAt: $scheduledAt
      priority: $priority
      maxRetries: $maxRetries
    ) {
      _id
      modelName
      instanceId
      methodName
      scheduledAt
      status
      priority
      maxRetries
      createdAt
      updatedAt
    }
  }
`;
export type ScheduleTaskMutationFn = Apollo.MutationFunction<
  ScheduleTaskMutation,
  ScheduleTaskMutationVariables
>;

/**
 * __useScheduleTaskMutation__
 *
 * To run a mutation, you first call `useScheduleTaskMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useScheduleTaskMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [scheduleTaskMutation, { data, loading, error }] = useScheduleTaskMutation({
 *   variables: {
 *      modelName: // value for 'modelName'
 *      instanceId: // value for 'instanceId'
 *      methodName: // value for 'methodName'
 *      scheduledAt: // value for 'scheduledAt'
 *      priority: // value for 'priority'
 *      maxRetries: // value for 'maxRetries'
 *   },
 * });
 */
export function useScheduleTaskMutation(
  baseOptions?: Apollo.MutationHookOptions<
    ScheduleTaskMutation,
    ScheduleTaskMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    ScheduleTaskMutation,
    ScheduleTaskMutationVariables
  >(ScheduleTaskDocument, options);
}
export type ScheduleTaskMutationHookResult = ReturnType<
  typeof useScheduleTaskMutation
>;
export type ScheduleTaskMutationResult =
  Apollo.MutationResult<ScheduleTaskMutation>;
export type ScheduleTaskMutationOptions = Apollo.BaseMutationOptions<
  ScheduleTaskMutation,
  ScheduleTaskMutationVariables
>;
export const CancelScheduledTaskDocument = gql`
  mutation CancelScheduledTask($taskId: String!) {
    cancelScheduledTask(taskId: $taskId)
  }
`;
export type CancelScheduledTaskMutationFn = Apollo.MutationFunction<
  CancelScheduledTaskMutation,
  CancelScheduledTaskMutationVariables
>;

/**
 * __useCancelScheduledTaskMutation__
 *
 * To run a mutation, you first call `useCancelScheduledTaskMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCancelScheduledTaskMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [cancelScheduledTaskMutation, { data, loading, error }] = useCancelScheduledTaskMutation({
 *   variables: {
 *      taskId: // value for 'taskId'
 *   },
 * });
 */
export function useCancelScheduledTaskMutation(
  baseOptions?: Apollo.MutationHookOptions<
    CancelScheduledTaskMutation,
    CancelScheduledTaskMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    CancelScheduledTaskMutation,
    CancelScheduledTaskMutationVariables
  >(CancelScheduledTaskDocument, options);
}
export type CancelScheduledTaskMutationHookResult = ReturnType<
  typeof useCancelScheduledTaskMutation
>;
export type CancelScheduledTaskMutationResult =
  Apollo.MutationResult<CancelScheduledTaskMutation>;
export type CancelScheduledTaskMutationOptions = Apollo.BaseMutationOptions<
  CancelScheduledTaskMutation,
  CancelScheduledTaskMutationVariables
>;
export const GetScheduledTasksDocument = gql`
  query GetScheduledTasks($status: String, $limit: Int, $skip: Int) {
    scheduledTasks(status: $status, limit: $limit, skip: $skip) {
      _id
      modelName
      instanceId
      methodName
      scheduledAt
      startedAt
      completedAt
      executionTimeMs
      status
      errorMessage
      retryCount
      maxRetries
      priority
      createdAt
      updatedAt
    }
  }
`;

/**
 * __useGetScheduledTasksQuery__
 *
 * To run a query within a React component, call `useGetScheduledTasksQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetScheduledTasksQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetScheduledTasksQuery({
 *   variables: {
 *      status: // value for 'status'
 *      limit: // value for 'limit'
 *      skip: // value for 'skip'
 *   },
 * });
 */
export function useGetScheduledTasksQuery(
  baseOptions?: Apollo.QueryHookOptions<
    GetScheduledTasksQuery,
    GetScheduledTasksQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetScheduledTasksQuery,
    GetScheduledTasksQueryVariables
  >(GetScheduledTasksDocument, options);
}
export function useGetScheduledTasksLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetScheduledTasksQuery,
    GetScheduledTasksQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetScheduledTasksQuery,
    GetScheduledTasksQueryVariables
  >(GetScheduledTasksDocument, options);
}
export type GetScheduledTasksQueryHookResult = ReturnType<
  typeof useGetScheduledTasksQuery
>;
export type GetScheduledTasksLazyQueryHookResult = ReturnType<
  typeof useGetScheduledTasksLazyQuery
>;
export type GetScheduledTasksQueryResult = Apollo.QueryResult<
  GetScheduledTasksQuery,
  GetScheduledTasksQueryVariables
>;
export const GetScheduledTaskByIdDocument = gql`
  query GetScheduledTaskById($taskId: String!) {
    scheduledTaskById(taskId: $taskId) {
      _id
      modelName
      instanceId
      methodName
      scheduledAt
      startedAt
      completedAt
      executionTimeMs
      status
      errorMessage
      retryCount
      maxRetries
      priority
      createdAt
      updatedAt
    }
  }
`;

/**
 * __useGetScheduledTaskByIdQuery__
 *
 * To run a query within a React component, call `useGetScheduledTaskByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetScheduledTaskByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetScheduledTaskByIdQuery({
 *   variables: {
 *      taskId: // value for 'taskId'
 *   },
 * });
 */
export function useGetScheduledTaskByIdQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetScheduledTaskByIdQuery,
    GetScheduledTaskByIdQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetScheduledTaskByIdQuery,
    GetScheduledTaskByIdQueryVariables
  >(GetScheduledTaskByIdDocument, options);
}
export function useGetScheduledTaskByIdLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetScheduledTaskByIdQuery,
    GetScheduledTaskByIdQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetScheduledTaskByIdQuery,
    GetScheduledTaskByIdQueryVariables
  >(GetScheduledTaskByIdDocument, options);
}
export type GetScheduledTaskByIdQueryHookResult = ReturnType<
  typeof useGetScheduledTaskByIdQuery
>;
export type GetScheduledTaskByIdLazyQueryHookResult = ReturnType<
  typeof useGetScheduledTaskByIdLazyQuery
>;
export type GetScheduledTaskByIdQueryResult = Apollo.QueryResult<
  GetScheduledTaskByIdQuery,
  GetScheduledTaskByIdQueryVariables
>;
export const CreateSetpointProfileDocument = gql`
  mutation CreateSetpointProfile($profile: CreateOneSetpointProfileInput!) {
    createSetpointProfile(profile: $profile) {
      _id
      name
      heat {
        max
        min
      }
      cool {
        max
        min
      }
      properties
      creator {
        _id
        name
      }
      lastUpdatedBy {
        name
      }
      createdAt
      updatedAt
    }
  }
`;
export type CreateSetpointProfileMutationFn = Apollo.MutationFunction<
  CreateSetpointProfileMutation,
  CreateSetpointProfileMutationVariables
>;

/**
 * __useCreateSetpointProfileMutation__
 *
 * To run a mutation, you first call `useCreateSetpointProfileMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateSetpointProfileMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createSetpointProfileMutation, { data, loading, error }] = useCreateSetpointProfileMutation({
 *   variables: {
 *      profile: // value for 'profile'
 *   },
 * });
 */
export function useCreateSetpointProfileMutation(
  baseOptions?: Apollo.MutationHookOptions<
    CreateSetpointProfileMutation,
    CreateSetpointProfileMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    CreateSetpointProfileMutation,
    CreateSetpointProfileMutationVariables
  >(CreateSetpointProfileDocument, options);
}
export type CreateSetpointProfileMutationHookResult = ReturnType<
  typeof useCreateSetpointProfileMutation
>;
export type CreateSetpointProfileMutationResult =
  Apollo.MutationResult<CreateSetpointProfileMutation>;
export type CreateSetpointProfileMutationOptions = Apollo.BaseMutationOptions<
  CreateSetpointProfileMutation,
  CreateSetpointProfileMutationVariables
>;
export const PropertySetpointProfilesDocument = gql`
  query PropertySetpointProfiles($id: String!) {
    propertyById(_id: $id) {
      _id
      title
      setpointProfileId
      thermostatScheduleTemplateId
      assignableSetpointProfiles {
        _id
        name
        assignedProperties {
          _id
          __typename
        }
        assignedUnits {
          _id
          __typename
        }
        enabledProperties {
          _id
          __typename
        }
        heat {
          max
          min
        }
        cool {
          max
          min
        }
        properties
      }
    }
  }
`;

/**
 * __usePropertySetpointProfilesQuery__
 *
 * To run a query within a React component, call `usePropertySetpointProfilesQuery` and pass it any options that fit your needs.
 * When your component renders, `usePropertySetpointProfilesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePropertySetpointProfilesQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function usePropertySetpointProfilesQuery(
  baseOptions: Apollo.QueryHookOptions<
    PropertySetpointProfilesQuery,
    PropertySetpointProfilesQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    PropertySetpointProfilesQuery,
    PropertySetpointProfilesQueryVariables
  >(PropertySetpointProfilesDocument, options);
}
export function usePropertySetpointProfilesLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    PropertySetpointProfilesQuery,
    PropertySetpointProfilesQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    PropertySetpointProfilesQuery,
    PropertySetpointProfilesQueryVariables
  >(PropertySetpointProfilesDocument, options);
}
export type PropertySetpointProfilesQueryHookResult = ReturnType<
  typeof usePropertySetpointProfilesQuery
>;
export type PropertySetpointProfilesLazyQueryHookResult = ReturnType<
  typeof usePropertySetpointProfilesLazyQuery
>;
export type PropertySetpointProfilesQueryResult = Apollo.QueryResult<
  PropertySetpointProfilesQuery,
  PropertySetpointProfilesQueryVariables
>;
export const RemoveSetpointProfileDocument = gql`
  mutation RemoveSetpointProfile($id: String!) {
    removeSetpointProfile(id: $id)
  }
`;
export type RemoveSetpointProfileMutationFn = Apollo.MutationFunction<
  RemoveSetpointProfileMutation,
  RemoveSetpointProfileMutationVariables
>;

/**
 * __useRemoveSetpointProfileMutation__
 *
 * To run a mutation, you first call `useRemoveSetpointProfileMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveSetpointProfileMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeSetpointProfileMutation, { data, loading, error }] = useRemoveSetpointProfileMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useRemoveSetpointProfileMutation(
  baseOptions?: Apollo.MutationHookOptions<
    RemoveSetpointProfileMutation,
    RemoveSetpointProfileMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    RemoveSetpointProfileMutation,
    RemoveSetpointProfileMutationVariables
  >(RemoveSetpointProfileDocument, options);
}
export type RemoveSetpointProfileMutationHookResult = ReturnType<
  typeof useRemoveSetpointProfileMutation
>;
export type RemoveSetpointProfileMutationResult =
  Apollo.MutationResult<RemoveSetpointProfileMutation>;
export type RemoveSetpointProfileMutationOptions = Apollo.BaseMutationOptions<
  RemoveSetpointProfileMutation,
  RemoveSetpointProfileMutationVariables
>;
export const SetpointProfileBulkConfigUpdateDocument = gql`
  subscription SetpointProfileBulkConfigUpdate($id: String!) {
    bulkConfigProgressUpdate(
      initiatorId: $id
      initiatorType: "SetpointProfile"
    ) {
      initiatorId
      initiatorType
      totalCount
      errorCount
      completedCount
      errors {
        deviceType
        deviceName
        deviceId
        message
      }
    }
  }
`;

/**
 * __useSetpointProfileBulkConfigUpdateSubscription__
 *
 * To run a query within a React component, call `useSetpointProfileBulkConfigUpdateSubscription` and pass it any options that fit your needs.
 * When your component renders, `useSetpointProfileBulkConfigUpdateSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSetpointProfileBulkConfigUpdateSubscription({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useSetpointProfileBulkConfigUpdateSubscription(
  baseOptions: Apollo.SubscriptionHookOptions<
    SetpointProfileBulkConfigUpdateSubscription,
    SetpointProfileBulkConfigUpdateSubscriptionVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useSubscription<
    SetpointProfileBulkConfigUpdateSubscription,
    SetpointProfileBulkConfigUpdateSubscriptionVariables
  >(SetpointProfileBulkConfigUpdateDocument, options);
}
export type SetpointProfileBulkConfigUpdateSubscriptionHookResult = ReturnType<
  typeof useSetpointProfileBulkConfigUpdateSubscription
>;
export type SetpointProfileBulkConfigUpdateSubscriptionResult =
  Apollo.SubscriptionResult<SetpointProfileBulkConfigUpdateSubscription>;
export const SetpointProfileCountDocument = gql`
  query SetpointProfileCount {
    setpointProfileCount
  }
`;

/**
 * __useSetpointProfileCountQuery__
 *
 * To run a query within a React component, call `useSetpointProfileCountQuery` and pass it any options that fit your needs.
 * When your component renders, `useSetpointProfileCountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSetpointProfileCountQuery({
 *   variables: {
 *   },
 * });
 */
export function useSetpointProfileCountQuery(
  baseOptions?: Apollo.QueryHookOptions<
    SetpointProfileCountQuery,
    SetpointProfileCountQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    SetpointProfileCountQuery,
    SetpointProfileCountQueryVariables
  >(SetpointProfileCountDocument, options);
}
export function useSetpointProfileCountLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    SetpointProfileCountQuery,
    SetpointProfileCountQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    SetpointProfileCountQuery,
    SetpointProfileCountQueryVariables
  >(SetpointProfileCountDocument, options);
}
export type SetpointProfileCountQueryHookResult = ReturnType<
  typeof useSetpointProfileCountQuery
>;
export type SetpointProfileCountLazyQueryHookResult = ReturnType<
  typeof useSetpointProfileCountLazyQuery
>;
export type SetpointProfileCountQueryResult = Apollo.QueryResult<
  SetpointProfileCountQuery,
  SetpointProfileCountQueryVariables
>;
export const SetpointProfileDetailUpdateDocument = gql`
  subscription SetpointProfileDetailUpdate($ids: [String!]!) {
    setpointProfileEventsByIds(_ids: $ids) {
      modelChangeOperation
      _id
      name
      properties
      heat {
        max
        min
      }
      cool {
        max
        min
      }
      creator {
        _id
        name
      }
      lastUpdatedBy {
        _id
        name
      }
      units
    }
  }
`;

/**
 * __useSetpointProfileDetailUpdateSubscription__
 *
 * To run a query within a React component, call `useSetpointProfileDetailUpdateSubscription` and pass it any options that fit your needs.
 * When your component renders, `useSetpointProfileDetailUpdateSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSetpointProfileDetailUpdateSubscription({
 *   variables: {
 *      ids: // value for 'ids'
 *   },
 * });
 */
export function useSetpointProfileDetailUpdateSubscription(
  baseOptions: Apollo.SubscriptionHookOptions<
    SetpointProfileDetailUpdateSubscription,
    SetpointProfileDetailUpdateSubscriptionVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useSubscription<
    SetpointProfileDetailUpdateSubscription,
    SetpointProfileDetailUpdateSubscriptionVariables
  >(SetpointProfileDetailUpdateDocument, options);
}
export type SetpointProfileDetailUpdateSubscriptionHookResult = ReturnType<
  typeof useSetpointProfileDetailUpdateSubscription
>;
export type SetpointProfileDetailUpdateSubscriptionResult =
  Apollo.SubscriptionResult<SetpointProfileDetailUpdateSubscription>;
export const SetpointProfileDetailDocument = gql`
  query SetpointProfileDetail($_id: String!) {
    setpointProfileById(_id: $_id) {
      _id
      name
      properties
      heat {
        max
        min
      }
      cool {
        max
        min
      }
      creator {
        _id
        name
      }
      lastUpdatedBy {
        _id
        name
      }
      units
    }
  }
`;

/**
 * __useSetpointProfileDetailQuery__
 *
 * To run a query within a React component, call `useSetpointProfileDetailQuery` and pass it any options that fit your needs.
 * When your component renders, `useSetpointProfileDetailQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSetpointProfileDetailQuery({
 *   variables: {
 *      _id: // value for '_id'
 *   },
 * });
 */
export function useSetpointProfileDetailQuery(
  baseOptions: Apollo.QueryHookOptions<
    SetpointProfileDetailQuery,
    SetpointProfileDetailQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    SetpointProfileDetailQuery,
    SetpointProfileDetailQueryVariables
  >(SetpointProfileDetailDocument, options);
}
export function useSetpointProfileDetailLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    SetpointProfileDetailQuery,
    SetpointProfileDetailQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    SetpointProfileDetailQuery,
    SetpointProfileDetailQueryVariables
  >(SetpointProfileDetailDocument, options);
}
export type SetpointProfileDetailQueryHookResult = ReturnType<
  typeof useSetpointProfileDetailQuery
>;
export type SetpointProfileDetailLazyQueryHookResult = ReturnType<
  typeof useSetpointProfileDetailLazyQuery
>;
export type SetpointProfileDetailQueryResult = Apollo.QueryResult<
  SetpointProfileDetailQuery,
  SetpointProfileDetailQueryVariables
>;
export const SetpointProfileDetailBreadcrumbDocument = gql`
  query SetpointProfileDetailBreadcrumb($id: String!) {
    setpointProfileById(_id: $id) {
      _id
      name
    }
  }
`;

/**
 * __useSetpointProfileDetailBreadcrumbQuery__
 *
 * To run a query within a React component, call `useSetpointProfileDetailBreadcrumbQuery` and pass it any options that fit your needs.
 * When your component renders, `useSetpointProfileDetailBreadcrumbQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSetpointProfileDetailBreadcrumbQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useSetpointProfileDetailBreadcrumbQuery(
  baseOptions: Apollo.QueryHookOptions<
    SetpointProfileDetailBreadcrumbQuery,
    SetpointProfileDetailBreadcrumbQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    SetpointProfileDetailBreadcrumbQuery,
    SetpointProfileDetailBreadcrumbQueryVariables
  >(SetpointProfileDetailBreadcrumbDocument, options);
}
export function useSetpointProfileDetailBreadcrumbLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    SetpointProfileDetailBreadcrumbQuery,
    SetpointProfileDetailBreadcrumbQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    SetpointProfileDetailBreadcrumbQuery,
    SetpointProfileDetailBreadcrumbQueryVariables
  >(SetpointProfileDetailBreadcrumbDocument, options);
}
export type SetpointProfileDetailBreadcrumbQueryHookResult = ReturnType<
  typeof useSetpointProfileDetailBreadcrumbQuery
>;
export type SetpointProfileDetailBreadcrumbLazyQueryHookResult = ReturnType<
  typeof useSetpointProfileDetailBreadcrumbLazyQuery
>;
export type SetpointProfileDetailBreadcrumbQueryResult = Apollo.QueryResult<
  SetpointProfileDetailBreadcrumbQuery,
  SetpointProfileDetailBreadcrumbQueryVariables
>;
export const SetpointProfileListDocument = gql`
  query SetpointProfileList {
    setpointProfiles(limit: 0) {
      _id
      name
      enabledProperties {
        _id
        title
      }
      creator {
        name
      }
      lastUpdatedBy {
        name
      }
      assignedProperties {
        _id
        title
      }
      assignedUnits {
        _id
        name
      }
    }
  }
`;

/**
 * __useSetpointProfileListQuery__
 *
 * To run a query within a React component, call `useSetpointProfileListQuery` and pass it any options that fit your needs.
 * When your component renders, `useSetpointProfileListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSetpointProfileListQuery({
 *   variables: {
 *   },
 * });
 */
export function useSetpointProfileListQuery(
  baseOptions?: Apollo.QueryHookOptions<
    SetpointProfileListQuery,
    SetpointProfileListQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    SetpointProfileListQuery,
    SetpointProfileListQueryVariables
  >(SetpointProfileListDocument, options);
}
export function useSetpointProfileListLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    SetpointProfileListQuery,
    SetpointProfileListQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    SetpointProfileListQuery,
    SetpointProfileListQueryVariables
  >(SetpointProfileListDocument, options);
}
export type SetpointProfileListQueryHookResult = ReturnType<
  typeof useSetpointProfileListQuery
>;
export type SetpointProfileListLazyQueryHookResult = ReturnType<
  typeof useSetpointProfileListLazyQuery
>;
export type SetpointProfileListQueryResult = Apollo.QueryResult<
  SetpointProfileListQuery,
  SetpointProfileListQueryVariables
>;
export const SetpointProfileListUpdateDocument = gql`
  subscription SetpointProfileListUpdate {
    setpointProfileEvents {
      modelChangeOperation
      _id
      name
      creator {
        name
      }
      lastUpdatedBy {
        name
      }
      enabledProperties {
        _id
        title
      }
      assignedProperties {
        _id
        title
      }
      assignedUnits {
        _id
        name
      }
    }
  }
`;

/**
 * __useSetpointProfileListUpdateSubscription__
 *
 * To run a query within a React component, call `useSetpointProfileListUpdateSubscription` and pass it any options that fit your needs.
 * When your component renders, `useSetpointProfileListUpdateSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSetpointProfileListUpdateSubscription({
 *   variables: {
 *   },
 * });
 */
export function useSetpointProfileListUpdateSubscription(
  baseOptions?: Apollo.SubscriptionHookOptions<
    SetpointProfileListUpdateSubscription,
    SetpointProfileListUpdateSubscriptionVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useSubscription<
    SetpointProfileListUpdateSubscription,
    SetpointProfileListUpdateSubscriptionVariables
  >(SetpointProfileListUpdateDocument, options);
}
export type SetpointProfileListUpdateSubscriptionHookResult = ReturnType<
  typeof useSetpointProfileListUpdateSubscription
>;
export type SetpointProfileListUpdateSubscriptionResult =
  Apollo.SubscriptionResult<SetpointProfileListUpdateSubscription>;
export const SetpointProfileUpdateVerificationDocument = gql`
  query SetpointProfileUpdateVerification(
    $id: String!
    $propertyIds: [String!]
    $unitId: String
  ) {
    setpointProfileUpdateVerification(
      id: $id
      propertyIds: $propertyIds
      unitId: $unitId
    ) {
      _id
      name
      totalDevices
      configuredDevices
      onlineDevices
      excludedDevicesCustom
      excludedDevicesUnit
    }
  }
`;

/**
 * __useSetpointProfileUpdateVerificationQuery__
 *
 * To run a query within a React component, call `useSetpointProfileUpdateVerificationQuery` and pass it any options that fit your needs.
 * When your component renders, `useSetpointProfileUpdateVerificationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSetpointProfileUpdateVerificationQuery({
 *   variables: {
 *      id: // value for 'id'
 *      propertyIds: // value for 'propertyIds'
 *      unitId: // value for 'unitId'
 *   },
 * });
 */
export function useSetpointProfileUpdateVerificationQuery(
  baseOptions: Apollo.QueryHookOptions<
    SetpointProfileUpdateVerificationQuery,
    SetpointProfileUpdateVerificationQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    SetpointProfileUpdateVerificationQuery,
    SetpointProfileUpdateVerificationQueryVariables
  >(SetpointProfileUpdateVerificationDocument, options);
}
export function useSetpointProfileUpdateVerificationLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    SetpointProfileUpdateVerificationQuery,
    SetpointProfileUpdateVerificationQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    SetpointProfileUpdateVerificationQuery,
    SetpointProfileUpdateVerificationQueryVariables
  >(SetpointProfileUpdateVerificationDocument, options);
}
export type SetpointProfileUpdateVerificationQueryHookResult = ReturnType<
  typeof useSetpointProfileUpdateVerificationQuery
>;
export type SetpointProfileUpdateVerificationLazyQueryHookResult = ReturnType<
  typeof useSetpointProfileUpdateVerificationLazyQuery
>;
export type SetpointProfileUpdateVerificationQueryResult = Apollo.QueryResult<
  SetpointProfileUpdateVerificationQuery,
  SetpointProfileUpdateVerificationQueryVariables
>;
export const UnitSetpointProfilesDocument = gql`
  query UnitSetpointProfiles($id: String!) {
    unitById(_id: $id) {
      _id
      name
      type
      setpointProfileId
      thermostatScheduleTemplateId
      assignableSetpointProfiles {
        _id
        name
        assignedProperties {
          _id
          __typename
        }
        assignedUnits {
          _id
          __typename
        }
        enabledProperties {
          _id
          __typename
        }
        heat {
          max
          min
        }
        cool {
          max
          min
        }
        properties
      }
      property {
        _id
        __typename
        title
        setpointProfileId
      }
    }
  }
`;

/**
 * __useUnitSetpointProfilesQuery__
 *
 * To run a query within a React component, call `useUnitSetpointProfilesQuery` and pass it any options that fit your needs.
 * When your component renders, `useUnitSetpointProfilesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUnitSetpointProfilesQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useUnitSetpointProfilesQuery(
  baseOptions: Apollo.QueryHookOptions<
    UnitSetpointProfilesQuery,
    UnitSetpointProfilesQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    UnitSetpointProfilesQuery,
    UnitSetpointProfilesQueryVariables
  >(UnitSetpointProfilesDocument, options);
}
export function useUnitSetpointProfilesLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    UnitSetpointProfilesQuery,
    UnitSetpointProfilesQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    UnitSetpointProfilesQuery,
    UnitSetpointProfilesQueryVariables
  >(UnitSetpointProfilesDocument, options);
}
export type UnitSetpointProfilesQueryHookResult = ReturnType<
  typeof useUnitSetpointProfilesQuery
>;
export type UnitSetpointProfilesLazyQueryHookResult = ReturnType<
  typeof useUnitSetpointProfilesLazyQuery
>;
export type UnitSetpointProfilesQueryResult = Apollo.QueryResult<
  UnitSetpointProfilesQuery,
  UnitSetpointProfilesQueryVariables
>;
export const UpdatePropertySetpointProfileOverrideDocument = gql`
  mutation UpdatePropertySetpointProfileOverride(
    $id: String!
    $setpointProfileId: String!
    $force: Boolean
  ) {
    updatePropertySetpointLimitProfileOverride(
      id: $id
      setpointProfileId: $setpointProfileId
      force: $force
    ) {
      _id
      title
    }
  }
`;
export type UpdatePropertySetpointProfileOverrideMutationFn =
  Apollo.MutationFunction<
    UpdatePropertySetpointProfileOverrideMutation,
    UpdatePropertySetpointProfileOverrideMutationVariables
  >;

/**
 * __useUpdatePropertySetpointProfileOverrideMutation__
 *
 * To run a mutation, you first call `useUpdatePropertySetpointProfileOverrideMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdatePropertySetpointProfileOverrideMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updatePropertySetpointProfileOverrideMutation, { data, loading, error }] = useUpdatePropertySetpointProfileOverrideMutation({
 *   variables: {
 *      id: // value for 'id'
 *      setpointProfileId: // value for 'setpointProfileId'
 *      force: // value for 'force'
 *   },
 * });
 */
export function useUpdatePropertySetpointProfileOverrideMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UpdatePropertySetpointProfileOverrideMutation,
    UpdatePropertySetpointProfileOverrideMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    UpdatePropertySetpointProfileOverrideMutation,
    UpdatePropertySetpointProfileOverrideMutationVariables
  >(UpdatePropertySetpointProfileOverrideDocument, options);
}
export type UpdatePropertySetpointProfileOverrideMutationHookResult =
  ReturnType<typeof useUpdatePropertySetpointProfileOverrideMutation>;
export type UpdatePropertySetpointProfileOverrideMutationResult =
  Apollo.MutationResult<UpdatePropertySetpointProfileOverrideMutation>;
export type UpdatePropertySetpointProfileOverrideMutationOptions =
  Apollo.BaseMutationOptions<
    UpdatePropertySetpointProfileOverrideMutation,
    UpdatePropertySetpointProfileOverrideMutationVariables
  >;
export const UpdateSetpointProfileDocument = gql`
  mutation UpdateSetpointProfile(
    $id: String!
    $profile: UpdateOneSetpointProfileInput!
  ) {
    updateSetpointProfile(id: $id, profile: $profile) {
      _id
      name
      heat {
        max
        min
      }
      cool {
        max
        min
      }
      properties
      creator {
        _id
        name
      }
      lastUpdatedBy {
        name
      }
      createdAt
      updatedAt
    }
  }
`;
export type UpdateSetpointProfileMutationFn = Apollo.MutationFunction<
  UpdateSetpointProfileMutation,
  UpdateSetpointProfileMutationVariables
>;

/**
 * __useUpdateSetpointProfileMutation__
 *
 * To run a mutation, you first call `useUpdateSetpointProfileMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateSetpointProfileMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateSetpointProfileMutation, { data, loading, error }] = useUpdateSetpointProfileMutation({
 *   variables: {
 *      id: // value for 'id'
 *      profile: // value for 'profile'
 *   },
 * });
 */
export function useUpdateSetpointProfileMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UpdateSetpointProfileMutation,
    UpdateSetpointProfileMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    UpdateSetpointProfileMutation,
    UpdateSetpointProfileMutationVariables
  >(UpdateSetpointProfileDocument, options);
}
export type UpdateSetpointProfileMutationHookResult = ReturnType<
  typeof useUpdateSetpointProfileMutation
>;
export type UpdateSetpointProfileMutationResult =
  Apollo.MutationResult<UpdateSetpointProfileMutation>;
export type UpdateSetpointProfileMutationOptions = Apollo.BaseMutationOptions<
  UpdateSetpointProfileMutation,
  UpdateSetpointProfileMutationVariables
>;
export const UpdateUnitSetpointProfileOverrideDocument = gql`
  mutation UpdateUnitSetpointProfileOverride(
    $id: String!
    $setpointProfileId: String!
    $force: Boolean
    $revert: Boolean
  ) {
    updateUnitSetpointLimitProfileOverride(
      id: $id
      setpointProfileId: $setpointProfileId
      force: $force
      revert: $revert
    ) {
      _id
      name
    }
  }
`;
export type UpdateUnitSetpointProfileOverrideMutationFn =
  Apollo.MutationFunction<
    UpdateUnitSetpointProfileOverrideMutation,
    UpdateUnitSetpointProfileOverrideMutationVariables
  >;

/**
 * __useUpdateUnitSetpointProfileOverrideMutation__
 *
 * To run a mutation, you first call `useUpdateUnitSetpointProfileOverrideMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateUnitSetpointProfileOverrideMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateUnitSetpointProfileOverrideMutation, { data, loading, error }] = useUpdateUnitSetpointProfileOverrideMutation({
 *   variables: {
 *      id: // value for 'id'
 *      setpointProfileId: // value for 'setpointProfileId'
 *      force: // value for 'force'
 *      revert: // value for 'revert'
 *   },
 * });
 */
export function useUpdateUnitSetpointProfileOverrideMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UpdateUnitSetpointProfileOverrideMutation,
    UpdateUnitSetpointProfileOverrideMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    UpdateUnitSetpointProfileOverrideMutation,
    UpdateUnitSetpointProfileOverrideMutationVariables
  >(UpdateUnitSetpointProfileOverrideDocument, options);
}
export type UpdateUnitSetpointProfileOverrideMutationHookResult = ReturnType<
  typeof useUpdateUnitSetpointProfileOverrideMutation
>;
export type UpdateUnitSetpointProfileOverrideMutationResult =
  Apollo.MutationResult<UpdateUnitSetpointProfileOverrideMutation>;
export type UpdateUnitSetpointProfileOverrideMutationOptions =
  Apollo.BaseMutationOptions<
    UpdateUnitSetpointProfileOverrideMutation,
    UpdateUnitSetpointProfileOverrideMutationVariables
  >;
export const ConductorCommissioningDraftDocument = gql`
  query ConductorCommissioningDraft($sourceId: String!, $runId: String) {
    conductorCommissioningDraft(sourceId: $sourceId, runId: $runId) {
      ...ConductorCommissioningDraftFields
    }
  }
  ${ConductorCommissioningDraftFieldsFragmentDoc}
`;

/**
 * __useConductorCommissioningDraftQuery__
 *
 * To run a query within a React component, call `useConductorCommissioningDraftQuery` and pass it any options that fit your needs.
 * When your component renders, `useConductorCommissioningDraftQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useConductorCommissioningDraftQuery({
 *   variables: {
 *      sourceId: // value for 'sourceId'
 *      runId: // value for 'runId'
 *   },
 * });
 */
export function useConductorCommissioningDraftQuery(
  baseOptions: Apollo.QueryHookOptions<
    ConductorCommissioningDraftQuery,
    ConductorCommissioningDraftQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    ConductorCommissioningDraftQuery,
    ConductorCommissioningDraftQueryVariables
  >(ConductorCommissioningDraftDocument, options);
}
export function useConductorCommissioningDraftLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    ConductorCommissioningDraftQuery,
    ConductorCommissioningDraftQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    ConductorCommissioningDraftQuery,
    ConductorCommissioningDraftQueryVariables
  >(ConductorCommissioningDraftDocument, options);
}
export type ConductorCommissioningDraftQueryHookResult = ReturnType<
  typeof useConductorCommissioningDraftQuery
>;
export type ConductorCommissioningDraftLazyQueryHookResult = ReturnType<
  typeof useConductorCommissioningDraftLazyQuery
>;
export type ConductorCommissioningDraftQueryResult = Apollo.QueryResult<
  ConductorCommissioningDraftQuery,
  ConductorCommissioningDraftQueryVariables
>;
export const CreateConductorCommissioningDraftDocument = gql`
  mutation CreateConductorCommissioningDraft(
    $sourceId: String!
    $runId: String
    $mode: String
  ) {
    createConductorCommissioningDraft(
      sourceId: $sourceId
      runId: $runId
      mode: $mode
    ) {
      ...ConductorCommissioningDraftFields
    }
  }
  ${ConductorCommissioningDraftFieldsFragmentDoc}
`;
export type CreateConductorCommissioningDraftMutationFn =
  Apollo.MutationFunction<
    CreateConductorCommissioningDraftMutation,
    CreateConductorCommissioningDraftMutationVariables
  >;

/**
 * __useCreateConductorCommissioningDraftMutation__
 *
 * To run a mutation, you first call `useCreateConductorCommissioningDraftMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateConductorCommissioningDraftMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createConductorCommissioningDraftMutation, { data, loading, error }] = useCreateConductorCommissioningDraftMutation({
 *   variables: {
 *      sourceId: // value for 'sourceId'
 *      runId: // value for 'runId'
 *      mode: // value for 'mode'
 *   },
 * });
 */
export function useCreateConductorCommissioningDraftMutation(
  baseOptions?: Apollo.MutationHookOptions<
    CreateConductorCommissioningDraftMutation,
    CreateConductorCommissioningDraftMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    CreateConductorCommissioningDraftMutation,
    CreateConductorCommissioningDraftMutationVariables
  >(CreateConductorCommissioningDraftDocument, options);
}
export type CreateConductorCommissioningDraftMutationHookResult = ReturnType<
  typeof useCreateConductorCommissioningDraftMutation
>;
export type CreateConductorCommissioningDraftMutationResult =
  Apollo.MutationResult<CreateConductorCommissioningDraftMutation>;
export type CreateConductorCommissioningDraftMutationOptions =
  Apollo.BaseMutationOptions<
    CreateConductorCommissioningDraftMutation,
    CreateConductorCommissioningDraftMutationVariables
  >;
export const UpdateConductorCommissioningDraftDocument = gql`
  mutation UpdateConductorCommissioningDraft(
    $sourceId: String!
    $draftId: String!
    $expectedRevision: Float!
    $expectedDiscoveryFingerprint: String!
    $patch: ConductorCommissioningDraftPatchInput!
  ) {
    updateConductorCommissioningDraft(
      sourceId: $sourceId
      draftId: $draftId
      expectedRevision: $expectedRevision
      expectedDiscoveryFingerprint: $expectedDiscoveryFingerprint
      patch: $patch
    ) {
      ...ConductorCommissioningDraftFields
    }
  }
  ${ConductorCommissioningDraftFieldsFragmentDoc}
`;
export type UpdateConductorCommissioningDraftMutationFn =
  Apollo.MutationFunction<
    UpdateConductorCommissioningDraftMutation,
    UpdateConductorCommissioningDraftMutationVariables
  >;

/**
 * __useUpdateConductorCommissioningDraftMutation__
 *
 * To run a mutation, you first call `useUpdateConductorCommissioningDraftMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateConductorCommissioningDraftMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateConductorCommissioningDraftMutation, { data, loading, error }] = useUpdateConductorCommissioningDraftMutation({
 *   variables: {
 *      sourceId: // value for 'sourceId'
 *      draftId: // value for 'draftId'
 *      expectedRevision: // value for 'expectedRevision'
 *      expectedDiscoveryFingerprint: // value for 'expectedDiscoveryFingerprint'
 *      patch: // value for 'patch'
 *   },
 * });
 */
export function useUpdateConductorCommissioningDraftMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UpdateConductorCommissioningDraftMutation,
    UpdateConductorCommissioningDraftMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    UpdateConductorCommissioningDraftMutation,
    UpdateConductorCommissioningDraftMutationVariables
  >(UpdateConductorCommissioningDraftDocument, options);
}
export type UpdateConductorCommissioningDraftMutationHookResult = ReturnType<
  typeof useUpdateConductorCommissioningDraftMutation
>;
export type UpdateConductorCommissioningDraftMutationResult =
  Apollo.MutationResult<UpdateConductorCommissioningDraftMutation>;
export type UpdateConductorCommissioningDraftMutationOptions =
  Apollo.BaseMutationOptions<
    UpdateConductorCommissioningDraftMutation,
    UpdateConductorCommissioningDraftMutationVariables
  >;
export const FinalizeConductorCommissioningDraftDocument = gql`
  mutation FinalizeConductorCommissioningDraft(
    $sourceId: String!
    $draftId: String!
    $expectedRevision: Float!
    $expectedDiscoveryFingerprint: String!
  ) {
    finalizeConductorCommissioningDraft(
      sourceId: $sourceId
      draftId: $draftId
      expectedRevision: $expectedRevision
      expectedDiscoveryFingerprint: $expectedDiscoveryFingerprint
    ) {
      ...ConductorCommissioningDraftFields
    }
  }
  ${ConductorCommissioningDraftFieldsFragmentDoc}
`;
export type FinalizeConductorCommissioningDraftMutationFn =
  Apollo.MutationFunction<
    FinalizeConductorCommissioningDraftMutation,
    FinalizeConductorCommissioningDraftMutationVariables
  >;

/**
 * __useFinalizeConductorCommissioningDraftMutation__
 *
 * To run a mutation, you first call `useFinalizeConductorCommissioningDraftMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useFinalizeConductorCommissioningDraftMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [finalizeConductorCommissioningDraftMutation, { data, loading, error }] = useFinalizeConductorCommissioningDraftMutation({
 *   variables: {
 *      sourceId: // value for 'sourceId'
 *      draftId: // value for 'draftId'
 *      expectedRevision: // value for 'expectedRevision'
 *      expectedDiscoveryFingerprint: // value for 'expectedDiscoveryFingerprint'
 *   },
 * });
 */
export function useFinalizeConductorCommissioningDraftMutation(
  baseOptions?: Apollo.MutationHookOptions<
    FinalizeConductorCommissioningDraftMutation,
    FinalizeConductorCommissioningDraftMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    FinalizeConductorCommissioningDraftMutation,
    FinalizeConductorCommissioningDraftMutationVariables
  >(FinalizeConductorCommissioningDraftDocument, options);
}
export type FinalizeConductorCommissioningDraftMutationHookResult = ReturnType<
  typeof useFinalizeConductorCommissioningDraftMutation
>;
export type FinalizeConductorCommissioningDraftMutationResult =
  Apollo.MutationResult<FinalizeConductorCommissioningDraftMutation>;
export type FinalizeConductorCommissioningDraftMutationOptions =
  Apollo.BaseMutationOptions<
    FinalizeConductorCommissioningDraftMutation,
    FinalizeConductorCommissioningDraftMutationVariables
  >;
export const RetryConductorCommissioningCommitDocument = gql`
  mutation RetryConductorCommissioningCommit(
    $sourceId: String!
    $draftId: String!
  ) {
    retryConductorCommissioningCommit(sourceId: $sourceId, draftId: $draftId) {
      ...ConductorCommissioningDraftFields
    }
  }
  ${ConductorCommissioningDraftFieldsFragmentDoc}
`;
export type RetryConductorCommissioningCommitMutationFn =
  Apollo.MutationFunction<
    RetryConductorCommissioningCommitMutation,
    RetryConductorCommissioningCommitMutationVariables
  >;

/**
 * __useRetryConductorCommissioningCommitMutation__
 *
 * To run a mutation, you first call `useRetryConductorCommissioningCommitMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRetryConductorCommissioningCommitMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [retryConductorCommissioningCommitMutation, { data, loading, error }] = useRetryConductorCommissioningCommitMutation({
 *   variables: {
 *      sourceId: // value for 'sourceId'
 *      draftId: // value for 'draftId'
 *   },
 * });
 */
export function useRetryConductorCommissioningCommitMutation(
  baseOptions?: Apollo.MutationHookOptions<
    RetryConductorCommissioningCommitMutation,
    RetryConductorCommissioningCommitMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    RetryConductorCommissioningCommitMutation,
    RetryConductorCommissioningCommitMutationVariables
  >(RetryConductorCommissioningCommitDocument, options);
}
export type RetryConductorCommissioningCommitMutationHookResult = ReturnType<
  typeof useRetryConductorCommissioningCommitMutation
>;
export type RetryConductorCommissioningCommitMutationResult =
  Apollo.MutationResult<RetryConductorCommissioningCommitMutation>;
export type RetryConductorCommissioningCommitMutationOptions =
  Apollo.BaseMutationOptions<
    RetryConductorCommissioningCommitMutation,
    RetryConductorCommissioningCommitMutationVariables
  >;
export const ConductorDiscoveryStatusUpdatedDocument = gql`
  subscription ConductorDiscoveryStatusUpdated(
    $sourceId: String!
    $runId: String
  ) {
    conductorDiscoveryStatusUpdated(sourceId: $sourceId, runId: $runId) {
      sourceId
      runId
      status
      message
      progressPercent
      isComplete
      results
      proposedMappings
      unallocated
      aiAudit
    }
  }
`;

/**
 * __useConductorDiscoveryStatusUpdatedSubscription__
 *
 * To run a query within a React component, call `useConductorDiscoveryStatusUpdatedSubscription` and pass it any options that fit your needs.
 * When your component renders, `useConductorDiscoveryStatusUpdatedSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useConductorDiscoveryStatusUpdatedSubscription({
 *   variables: {
 *      sourceId: // value for 'sourceId'
 *      runId: // value for 'runId'
 *   },
 * });
 */
export function useConductorDiscoveryStatusUpdatedSubscription(
  baseOptions: Apollo.SubscriptionHookOptions<
    ConductorDiscoveryStatusUpdatedSubscription,
    ConductorDiscoveryStatusUpdatedSubscriptionVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useSubscription<
    ConductorDiscoveryStatusUpdatedSubscription,
    ConductorDiscoveryStatusUpdatedSubscriptionVariables
  >(ConductorDiscoveryStatusUpdatedDocument, options);
}
export type ConductorDiscoveryStatusUpdatedSubscriptionHookResult = ReturnType<
  typeof useConductorDiscoveryStatusUpdatedSubscription
>;
export type ConductorDiscoveryStatusUpdatedSubscriptionResult =
  Apollo.SubscriptionResult<ConductorDiscoveryStatusUpdatedSubscription>;
export const ConductorDiscoveryRunDocument = gql`
  query ConductorDiscoveryRun($sourceId: String!, $runId: String) {
    conductorDiscoveryRun(sourceId: $sourceId, runId: $runId)
  }
`;

/**
 * __useConductorDiscoveryRunQuery__
 *
 * To run a query within a React component, call `useConductorDiscoveryRunQuery` and pass it any options that fit your needs.
 * When your component renders, `useConductorDiscoveryRunQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useConductorDiscoveryRunQuery({
 *   variables: {
 *      sourceId: // value for 'sourceId'
 *      runId: // value for 'runId'
 *   },
 * });
 */
export function useConductorDiscoveryRunQuery(
  baseOptions: Apollo.QueryHookOptions<
    ConductorDiscoveryRunQuery,
    ConductorDiscoveryRunQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    ConductorDiscoveryRunQuery,
    ConductorDiscoveryRunQueryVariables
  >(ConductorDiscoveryRunDocument, options);
}
export function useConductorDiscoveryRunLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    ConductorDiscoveryRunQuery,
    ConductorDiscoveryRunQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    ConductorDiscoveryRunQuery,
    ConductorDiscoveryRunQueryVariables
  >(ConductorDiscoveryRunDocument, options);
}
export type ConductorDiscoveryRunQueryHookResult = ReturnType<
  typeof useConductorDiscoveryRunQuery
>;
export type ConductorDiscoveryRunLazyQueryHookResult = ReturnType<
  typeof useConductorDiscoveryRunLazyQuery
>;
export type ConductorDiscoveryRunQueryResult = Apollo.QueryResult<
  ConductorDiscoveryRunQuery,
  ConductorDiscoveryRunQueryVariables
>;
export const CommitConductorDiscoveryMappingsDocument = gql`
  mutation CommitConductorDiscoveryMappings(
    $sourceId: String!
    $runId: String!
    $mappings: JSON!
  ) {
    commitConductorDiscoveryMappings(
      sourceId: $sourceId
      runId: $runId
      mappings: $mappings
    )
  }
`;
export type CommitConductorDiscoveryMappingsMutationFn =
  Apollo.MutationFunction<
    CommitConductorDiscoveryMappingsMutation,
    CommitConductorDiscoveryMappingsMutationVariables
  >;

/**
 * __useCommitConductorDiscoveryMappingsMutation__
 *
 * To run a mutation, you first call `useCommitConductorDiscoveryMappingsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCommitConductorDiscoveryMappingsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [commitConductorDiscoveryMappingsMutation, { data, loading, error }] = useCommitConductorDiscoveryMappingsMutation({
 *   variables: {
 *      sourceId: // value for 'sourceId'
 *      runId: // value for 'runId'
 *      mappings: // value for 'mappings'
 *   },
 * });
 */
export function useCommitConductorDiscoveryMappingsMutation(
  baseOptions?: Apollo.MutationHookOptions<
    CommitConductorDiscoveryMappingsMutation,
    CommitConductorDiscoveryMappingsMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    CommitConductorDiscoveryMappingsMutation,
    CommitConductorDiscoveryMappingsMutationVariables
  >(CommitConductorDiscoveryMappingsDocument, options);
}
export type CommitConductorDiscoveryMappingsMutationHookResult = ReturnType<
  typeof useCommitConductorDiscoveryMappingsMutation
>;
export type CommitConductorDiscoveryMappingsMutationResult =
  Apollo.MutationResult<CommitConductorDiscoveryMappingsMutation>;
export type CommitConductorDiscoveryMappingsMutationOptions =
  Apollo.BaseMutationOptions<
    CommitConductorDiscoveryMappingsMutation,
    CommitConductorDiscoveryMappingsMutationVariables
  >;
export const ConductorBuildingUnitsDocument = gql`
  query ConductorBuildingUnits($buildingId: String!) {
    units(filter: { buildingId: $buildingId }, limit: 0) {
      _id
      name
      type
      propertyId
      buildingId
      floorId
      building {
        name
      }
      floor {
        name
      }
    }
  }
`;

/**
 * __useConductorBuildingUnitsQuery__
 *
 * To run a query within a React component, call `useConductorBuildingUnitsQuery` and pass it any options that fit your needs.
 * When your component renders, `useConductorBuildingUnitsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useConductorBuildingUnitsQuery({
 *   variables: {
 *      buildingId: // value for 'buildingId'
 *   },
 * });
 */
export function useConductorBuildingUnitsQuery(
  baseOptions: Apollo.QueryHookOptions<
    ConductorBuildingUnitsQuery,
    ConductorBuildingUnitsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    ConductorBuildingUnitsQuery,
    ConductorBuildingUnitsQueryVariables
  >(ConductorBuildingUnitsDocument, options);
}
export function useConductorBuildingUnitsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    ConductorBuildingUnitsQuery,
    ConductorBuildingUnitsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    ConductorBuildingUnitsQuery,
    ConductorBuildingUnitsQueryVariables
  >(ConductorBuildingUnitsDocument, options);
}
export type ConductorBuildingUnitsQueryHookResult = ReturnType<
  typeof useConductorBuildingUnitsQuery
>;
export type ConductorBuildingUnitsLazyQueryHookResult = ReturnType<
  typeof useConductorBuildingUnitsLazyQuery
>;
export type ConductorBuildingUnitsQueryResult = Apollo.QueryResult<
  ConductorBuildingUnitsQuery,
  ConductorBuildingUnitsQueryVariables
>;
export const CreateConductorDocument = gql`
  mutation CreateConductor($conductor: CreateOneConductorInput!) {
    createConductor(conductor: $conductor) {
      _id
      name
      type
      url
      timestamp
      propertyId
      buildingId
      maxReportingTime
      tolerances {
        temperature
        humidity
      }
      inUse
    }
  }
`;
export type CreateConductorMutationFn = Apollo.MutationFunction<
  CreateConductorMutation,
  CreateConductorMutationVariables
>;

/**
 * __useCreateConductorMutation__
 *
 * To run a mutation, you first call `useCreateConductorMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateConductorMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createConductorMutation, { data, loading, error }] = useCreateConductorMutation({
 *   variables: {
 *      conductor: // value for 'conductor'
 *   },
 * });
 */
export function useCreateConductorMutation(
  baseOptions?: Apollo.MutationHookOptions<
    CreateConductorMutation,
    CreateConductorMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    CreateConductorMutation,
    CreateConductorMutationVariables
  >(CreateConductorDocument, options);
}
export type CreateConductorMutationHookResult = ReturnType<
  typeof useCreateConductorMutation
>;
export type CreateConductorMutationResult =
  Apollo.MutationResult<CreateConductorMutation>;
export type CreateConductorMutationOptions = Apollo.BaseMutationOptions<
  CreateConductorMutation,
  CreateConductorMutationVariables
>;
export const UpdateConductorDocument = gql`
  mutation UpdateConductor($id: String!, $conductor: UpdateOneConductorInput!) {
    updateConductor(_id: $id, conductor: $conductor) {
      _id
      name
      type
      url
      timestamp
      buildingId
      maxReportingTime
      tolerances {
        temperature
        humidity
      }
      inUse
    }
  }
`;
export type UpdateConductorMutationFn = Apollo.MutationFunction<
  UpdateConductorMutation,
  UpdateConductorMutationVariables
>;

/**
 * __useUpdateConductorMutation__
 *
 * To run a mutation, you first call `useUpdateConductorMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateConductorMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateConductorMutation, { data, loading, error }] = useUpdateConductorMutation({
 *   variables: {
 *      id: // value for 'id'
 *      conductor: // value for 'conductor'
 *   },
 * });
 */
export function useUpdateConductorMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UpdateConductorMutation,
    UpdateConductorMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    UpdateConductorMutation,
    UpdateConductorMutationVariables
  >(UpdateConductorDocument, options);
}
export type UpdateConductorMutationHookResult = ReturnType<
  typeof useUpdateConductorMutation
>;
export type UpdateConductorMutationResult =
  Apollo.MutationResult<UpdateConductorMutation>;
export type UpdateConductorMutationOptions = Apollo.BaseMutationOptions<
  UpdateConductorMutation,
  UpdateConductorMutationVariables
>;
export const RemoveConductorDocument = gql`
  mutation RemoveConductor($id: String!) {
    removeConductor(_id: $id)
  }
`;
export type RemoveConductorMutationFn = Apollo.MutationFunction<
  RemoveConductorMutation,
  RemoveConductorMutationVariables
>;

/**
 * __useRemoveConductorMutation__
 *
 * To run a mutation, you first call `useRemoveConductorMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveConductorMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeConductorMutation, { data, loading, error }] = useRemoveConductorMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useRemoveConductorMutation(
  baseOptions?: Apollo.MutationHookOptions<
    RemoveConductorMutation,
    RemoveConductorMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    RemoveConductorMutation,
    RemoveConductorMutationVariables
  >(RemoveConductorDocument, options);
}
export type RemoveConductorMutationHookResult = ReturnType<
  typeof useRemoveConductorMutation
>;
export type RemoveConductorMutationResult =
  Apollo.MutationResult<RemoveConductorMutation>;
export type RemoveConductorMutationOptions = Apollo.BaseMutationOptions<
  RemoveConductorMutation,
  RemoveConductorMutationVariables
>;
export const CreateBngDocument = gql`
  mutation CreateBng($bng: CreateOneBngInput!) {
    createBng(bng: $bng) {
      _id
      name
      url
      type
      propertyId
      timestamp
      inUse
    }
  }
`;
export type CreateBngMutationFn = Apollo.MutationFunction<
  CreateBngMutation,
  CreateBngMutationVariables
>;

/**
 * __useCreateBngMutation__
 *
 * To run a mutation, you first call `useCreateBngMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateBngMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createBngMutation, { data, loading, error }] = useCreateBngMutation({
 *   variables: {
 *      bng: // value for 'bng'
 *   },
 * });
 */
export function useCreateBngMutation(
  baseOptions?: Apollo.MutationHookOptions<
    CreateBngMutation,
    CreateBngMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<CreateBngMutation, CreateBngMutationVariables>(
    CreateBngDocument,
    options,
  );
}
export type CreateBngMutationHookResult = ReturnType<
  typeof useCreateBngMutation
>;
export type CreateBngMutationResult = Apollo.MutationResult<CreateBngMutation>;
export type CreateBngMutationOptions = Apollo.BaseMutationOptions<
  CreateBngMutation,
  CreateBngMutationVariables
>;
export const CreateCoreDocument = gql`
  mutation CreateCore($core: CreateOneCoreInput!) {
    createCore(core: $core) {
      _id
      name
      url
      type
      timestamp
      propertyId
      maxReportingTime
      tolerances {
        temperature
        humidity
        voltage
      }
      inUse
    }
  }
`;
export type CreateCoreMutationFn = Apollo.MutationFunction<
  CreateCoreMutation,
  CreateCoreMutationVariables
>;

/**
 * __useCreateCoreMutation__
 *
 * To run a mutation, you first call `useCreateCoreMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateCoreMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createCoreMutation, { data, loading, error }] = useCreateCoreMutation({
 *   variables: {
 *      core: // value for 'core'
 *   },
 * });
 */
export function useCreateCoreMutation(
  baseOptions?: Apollo.MutationHookOptions<
    CreateCoreMutation,
    CreateCoreMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<CreateCoreMutation, CreateCoreMutationVariables>(
    CreateCoreDocument,
    options,
  );
}
export type CreateCoreMutationHookResult = ReturnType<
  typeof useCreateCoreMutation
>;
export type CreateCoreMutationResult =
  Apollo.MutationResult<CreateCoreMutation>;
export type CreateCoreMutationOptions = Apollo.BaseMutationOptions<
  CreateCoreMutation,
  CreateCoreMutationVariables
>;
export const CreateHmmDocument = gql`
  mutation CreateHmm($hmm: CreateOneHmmInput!) {
    createHmm(hmm: $hmm) {
      _id
      name
      type
      url
      timestamp
      propertyId
      maxReportingTime
      tolerances {
        temperature
      }
    }
  }
`;
export type CreateHmmMutationFn = Apollo.MutationFunction<
  CreateHmmMutation,
  CreateHmmMutationVariables
>;

/**
 * __useCreateHmmMutation__
 *
 * To run a mutation, you first call `useCreateHmmMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateHmmMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createHmmMutation, { data, loading, error }] = useCreateHmmMutation({
 *   variables: {
 *      hmm: // value for 'hmm'
 *   },
 * });
 */
export function useCreateHmmMutation(
  baseOptions?: Apollo.MutationHookOptions<
    CreateHmmMutation,
    CreateHmmMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<CreateHmmMutation, CreateHmmMutationVariables>(
    CreateHmmDocument,
    options,
  );
}
export type CreateHmmMutationHookResult = ReturnType<
  typeof useCreateHmmMutation
>;
export type CreateHmmMutationResult = Apollo.MutationResult<CreateHmmMutation>;
export type CreateHmmMutationOptions = Apollo.BaseMutationOptions<
  CreateHmmMutation,
  CreateHmmMutationVariables
>;
export const InitializeSourceDocument = gql`
  mutation InitializeSource($id: String!, $options: InitializeSourceInput) {
    initializeSource(id: $id, options: $options) {
      _id
    }
  }
`;
export type InitializeSourceMutationFn = Apollo.MutationFunction<
  InitializeSourceMutation,
  InitializeSourceMutationVariables
>;

/**
 * __useInitializeSourceMutation__
 *
 * To run a mutation, you first call `useInitializeSourceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useInitializeSourceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [initializeSourceMutation, { data, loading, error }] = useInitializeSourceMutation({
 *   variables: {
 *      id: // value for 'id'
 *      options: // value for 'options'
 *   },
 * });
 */
export function useInitializeSourceMutation(
  baseOptions?: Apollo.MutationHookOptions<
    InitializeSourceMutation,
    InitializeSourceMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    InitializeSourceMutation,
    InitializeSourceMutationVariables
  >(InitializeSourceDocument, options);
}
export type InitializeSourceMutationHookResult = ReturnType<
  typeof useInitializeSourceMutation
>;
export type InitializeSourceMutationResult =
  Apollo.MutationResult<InitializeSourceMutation>;
export type InitializeSourceMutationOptions = Apollo.BaseMutationOptions<
  InitializeSourceMutation,
  InitializeSourceMutationVariables
>;
export const RemoveBngDocument = gql`
  mutation RemoveBng($id: String!) {
    removeBng(_id: $id)
  }
`;
export type RemoveBngMutationFn = Apollo.MutationFunction<
  RemoveBngMutation,
  RemoveBngMutationVariables
>;

/**
 * __useRemoveBngMutation__
 *
 * To run a mutation, you first call `useRemoveBngMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveBngMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeBngMutation, { data, loading, error }] = useRemoveBngMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useRemoveBngMutation(
  baseOptions?: Apollo.MutationHookOptions<
    RemoveBngMutation,
    RemoveBngMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<RemoveBngMutation, RemoveBngMutationVariables>(
    RemoveBngDocument,
    options,
  );
}
export type RemoveBngMutationHookResult = ReturnType<
  typeof useRemoveBngMutation
>;
export type RemoveBngMutationResult = Apollo.MutationResult<RemoveBngMutation>;
export type RemoveBngMutationOptions = Apollo.BaseMutationOptions<
  RemoveBngMutation,
  RemoveBngMutationVariables
>;
export const RemoveCoreDocument = gql`
  mutation RemoveCore($id: String!) {
    removeCore(_id: $id)
  }
`;
export type RemoveCoreMutationFn = Apollo.MutationFunction<
  RemoveCoreMutation,
  RemoveCoreMutationVariables
>;

/**
 * __useRemoveCoreMutation__
 *
 * To run a mutation, you first call `useRemoveCoreMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveCoreMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeCoreMutation, { data, loading, error }] = useRemoveCoreMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useRemoveCoreMutation(
  baseOptions?: Apollo.MutationHookOptions<
    RemoveCoreMutation,
    RemoveCoreMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<RemoveCoreMutation, RemoveCoreMutationVariables>(
    RemoveCoreDocument,
    options,
  );
}
export type RemoveCoreMutationHookResult = ReturnType<
  typeof useRemoveCoreMutation
>;
export type RemoveCoreMutationResult =
  Apollo.MutationResult<RemoveCoreMutation>;
export type RemoveCoreMutationOptions = Apollo.BaseMutationOptions<
  RemoveCoreMutation,
  RemoveCoreMutationVariables
>;
export const RemoveHmmDocument = gql`
  mutation RemoveHmm($id: String!) {
    removeHmm(_id: $id)
  }
`;
export type RemoveHmmMutationFn = Apollo.MutationFunction<
  RemoveHmmMutation,
  RemoveHmmMutationVariables
>;

/**
 * __useRemoveHmmMutation__
 *
 * To run a mutation, you first call `useRemoveHmmMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveHmmMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeHmmMutation, { data, loading, error }] = useRemoveHmmMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useRemoveHmmMutation(
  baseOptions?: Apollo.MutationHookOptions<
    RemoveHmmMutation,
    RemoveHmmMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<RemoveHmmMutation, RemoveHmmMutationVariables>(
    RemoveHmmDocument,
    options,
  );
}
export type RemoveHmmMutationHookResult = ReturnType<
  typeof useRemoveHmmMutation
>;
export type RemoveHmmMutationResult = Apollo.MutationResult<RemoveHmmMutation>;
export type RemoveHmmMutationOptions = Apollo.BaseMutationOptions<
  RemoveHmmMutation,
  RemoveHmmMutationVariables
>;
export const RepublishConductorMetadataDocument = gql`
  mutation RepublishConductorMetadata($id: String!) {
    republishConductorMetadata(id: $id) {
      _id
      lastDiscoveryStatus
    }
  }
`;
export type RepublishConductorMetadataMutationFn = Apollo.MutationFunction<
  RepublishConductorMetadataMutation,
  RepublishConductorMetadataMutationVariables
>;

/**
 * __useRepublishConductorMetadataMutation__
 *
 * To run a mutation, you first call `useRepublishConductorMetadataMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRepublishConductorMetadataMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [republishConductorMetadataMutation, { data, loading, error }] = useRepublishConductorMetadataMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useRepublishConductorMetadataMutation(
  baseOptions?: Apollo.MutationHookOptions<
    RepublishConductorMetadataMutation,
    RepublishConductorMetadataMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    RepublishConductorMetadataMutation,
    RepublishConductorMetadataMutationVariables
  >(RepublishConductorMetadataDocument, options);
}
export type RepublishConductorMetadataMutationHookResult = ReturnType<
  typeof useRepublishConductorMetadataMutation
>;
export type RepublishConductorMetadataMutationResult =
  Apollo.MutationResult<RepublishConductorMetadataMutation>;
export type RepublishConductorMetadataMutationOptions =
  Apollo.BaseMutationOptions<
    RepublishConductorMetadataMutation,
    RepublishConductorMetadataMutationVariables
  >;
export const SourceDetailEditDocument = gql`
  query SourceDetailEdit($id: String!) {
    sourceById(_id: $id) {
      _id
      name
      type
      url
      timestamp
      propertyId
      property {
        _id
        title
      }
      ... on Core {
        tolerances {
          temperature
          humidity
          voltage
        }
        maxReportingTime
      }
      ... on HMM {
        tolerances {
          temperature
        }
        maxReportingTime
      }
      ... on Conductor {
        buildingId
        lastDiscoveryStatus
        tolerances {
          temperature
          humidity
        }
        maxReportingTime
      }
      ... on BNG {
        localUrl
      }
    }
  }
`;

/**
 * __useSourceDetailEditQuery__
 *
 * To run a query within a React component, call `useSourceDetailEditQuery` and pass it any options that fit your needs.
 * When your component renders, `useSourceDetailEditQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSourceDetailEditQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useSourceDetailEditQuery(
  baseOptions: Apollo.QueryHookOptions<
    SourceDetailEditQuery,
    SourceDetailEditQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<SourceDetailEditQuery, SourceDetailEditQueryVariables>(
    SourceDetailEditDocument,
    options,
  );
}
export function useSourceDetailEditLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    SourceDetailEditQuery,
    SourceDetailEditQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    SourceDetailEditQuery,
    SourceDetailEditQueryVariables
  >(SourceDetailEditDocument, options);
}
export type SourceDetailEditQueryHookResult = ReturnType<
  typeof useSourceDetailEditQuery
>;
export type SourceDetailEditLazyQueryHookResult = ReturnType<
  typeof useSourceDetailEditLazyQuery
>;
export type SourceDetailEditQueryResult = Apollo.QueryResult<
  SourceDetailEditQuery,
  SourceDetailEditQueryVariables
>;
export const SourceStatusDocument = gql`
  query SourceStatus {
    cores(limit: 0) {
      _id
      type
      timestamp
    }
    hMMs(limit: 0) {
      _id
      type
      timestamp
    }
    bNGs(limit: 0) {
      _id
      type
      timestamp
    }
    conductors(limit: 0) {
      _id
      type
      timestamp
    }
  }
`;

/**
 * __useSourceStatusQuery__
 *
 * To run a query within a React component, call `useSourceStatusQuery` and pass it any options that fit your needs.
 * When your component renders, `useSourceStatusQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSourceStatusQuery({
 *   variables: {
 *   },
 * });
 */
export function useSourceStatusQuery(
  baseOptions?: Apollo.QueryHookOptions<
    SourceStatusQuery,
    SourceStatusQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<SourceStatusQuery, SourceStatusQueryVariables>(
    SourceStatusDocument,
    options,
  );
}
export function useSourceStatusLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    SourceStatusQuery,
    SourceStatusQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<SourceStatusQuery, SourceStatusQueryVariables>(
    SourceStatusDocument,
    options,
  );
}
export type SourceStatusQueryHookResult = ReturnType<
  typeof useSourceStatusQuery
>;
export type SourceStatusLazyQueryHookResult = ReturnType<
  typeof useSourceStatusLazyQuery
>;
export type SourceStatusQueryResult = Apollo.QueryResult<
  SourceStatusQuery,
  SourceStatusQueryVariables
>;
export const CoreStatusUpdatesDocument = gql`
  subscription CoreStatusUpdates {
    coreEvents {
      modelChangeOperation
      _id
      type
      timestamp
    }
  }
`;

/**
 * __useCoreStatusUpdatesSubscription__
 *
 * To run a query within a React component, call `useCoreStatusUpdatesSubscription` and pass it any options that fit your needs.
 * When your component renders, `useCoreStatusUpdatesSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCoreStatusUpdatesSubscription({
 *   variables: {
 *   },
 * });
 */
export function useCoreStatusUpdatesSubscription(
  baseOptions?: Apollo.SubscriptionHookOptions<
    CoreStatusUpdatesSubscription,
    CoreStatusUpdatesSubscriptionVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useSubscription<
    CoreStatusUpdatesSubscription,
    CoreStatusUpdatesSubscriptionVariables
  >(CoreStatusUpdatesDocument, options);
}
export type CoreStatusUpdatesSubscriptionHookResult = ReturnType<
  typeof useCoreStatusUpdatesSubscription
>;
export type CoreStatusUpdatesSubscriptionResult =
  Apollo.SubscriptionResult<CoreStatusUpdatesSubscription>;
export const HmmStatusUpdatesDocument = gql`
  subscription HMMStatusUpdates {
    hMMEvents {
      modelChangeOperation
      _id
      type
      timestamp
    }
  }
`;

/**
 * __useHmmStatusUpdatesSubscription__
 *
 * To run a query within a React component, call `useHmmStatusUpdatesSubscription` and pass it any options that fit your needs.
 * When your component renders, `useHmmStatusUpdatesSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useHmmStatusUpdatesSubscription({
 *   variables: {
 *   },
 * });
 */
export function useHmmStatusUpdatesSubscription(
  baseOptions?: Apollo.SubscriptionHookOptions<
    HmmStatusUpdatesSubscription,
    HmmStatusUpdatesSubscriptionVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useSubscription<
    HmmStatusUpdatesSubscription,
    HmmStatusUpdatesSubscriptionVariables
  >(HmmStatusUpdatesDocument, options);
}
export type HmmStatusUpdatesSubscriptionHookResult = ReturnType<
  typeof useHmmStatusUpdatesSubscription
>;
export type HmmStatusUpdatesSubscriptionResult =
  Apollo.SubscriptionResult<HmmStatusUpdatesSubscription>;
export const BngStatusUpdatesDocument = gql`
  subscription BNGStatusUpdates {
    bNGEvents {
      modelChangeOperation
      _id
      type
      timestamp
    }
  }
`;

/**
 * __useBngStatusUpdatesSubscription__
 *
 * To run a query within a React component, call `useBngStatusUpdatesSubscription` and pass it any options that fit your needs.
 * When your component renders, `useBngStatusUpdatesSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBngStatusUpdatesSubscription({
 *   variables: {
 *   },
 * });
 */
export function useBngStatusUpdatesSubscription(
  baseOptions?: Apollo.SubscriptionHookOptions<
    BngStatusUpdatesSubscription,
    BngStatusUpdatesSubscriptionVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useSubscription<
    BngStatusUpdatesSubscription,
    BngStatusUpdatesSubscriptionVariables
  >(BngStatusUpdatesDocument, options);
}
export type BngStatusUpdatesSubscriptionHookResult = ReturnType<
  typeof useBngStatusUpdatesSubscription
>;
export type BngStatusUpdatesSubscriptionResult =
  Apollo.SubscriptionResult<BngStatusUpdatesSubscription>;
export const ConductorStatusUpdatesDocument = gql`
  subscription ConductorStatusUpdates {
    conductorEvents {
      modelChangeOperation
      _id
      type
      timestamp
    }
  }
`;

/**
 * __useConductorStatusUpdatesSubscription__
 *
 * To run a query within a React component, call `useConductorStatusUpdatesSubscription` and pass it any options that fit your needs.
 * When your component renders, `useConductorStatusUpdatesSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useConductorStatusUpdatesSubscription({
 *   variables: {
 *   },
 * });
 */
export function useConductorStatusUpdatesSubscription(
  baseOptions?: Apollo.SubscriptionHookOptions<
    ConductorStatusUpdatesSubscription,
    ConductorStatusUpdatesSubscriptionVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useSubscription<
    ConductorStatusUpdatesSubscription,
    ConductorStatusUpdatesSubscriptionVariables
  >(ConductorStatusUpdatesDocument, options);
}
export type ConductorStatusUpdatesSubscriptionHookResult = ReturnType<
  typeof useConductorStatusUpdatesSubscription
>;
export type ConductorStatusUpdatesSubscriptionResult =
  Apollo.SubscriptionResult<ConductorStatusUpdatesSubscription>;
export const UpdateBngDocument = gql`
  mutation UpdateBng($id: String!, $bng: UpdateOneBngInput!) {
    updateBng(_id: $id, bng: $bng) {
      _id
      name
      type
      url
      timestamp
      inUse
    }
  }
`;
export type UpdateBngMutationFn = Apollo.MutationFunction<
  UpdateBngMutation,
  UpdateBngMutationVariables
>;

/**
 * __useUpdateBngMutation__
 *
 * To run a mutation, you first call `useUpdateBngMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateBngMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateBngMutation, { data, loading, error }] = useUpdateBngMutation({
 *   variables: {
 *      id: // value for 'id'
 *      bng: // value for 'bng'
 *   },
 * });
 */
export function useUpdateBngMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UpdateBngMutation,
    UpdateBngMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<UpdateBngMutation, UpdateBngMutationVariables>(
    UpdateBngDocument,
    options,
  );
}
export type UpdateBngMutationHookResult = ReturnType<
  typeof useUpdateBngMutation
>;
export type UpdateBngMutationResult = Apollo.MutationResult<UpdateBngMutation>;
export type UpdateBngMutationOptions = Apollo.BaseMutationOptions<
  UpdateBngMutation,
  UpdateBngMutationVariables
>;
export const UpdateCoreDocument = gql`
  mutation UpdateCore($id: String!, $core: UpdateOneCoreInput!) {
    updateCore(_id: $id, core: $core) {
      _id
      name
      type
      url
      timestamp
      tolerances {
        temperature
        humidity
        voltage
      }
      inUse
    }
  }
`;
export type UpdateCoreMutationFn = Apollo.MutationFunction<
  UpdateCoreMutation,
  UpdateCoreMutationVariables
>;

/**
 * __useUpdateCoreMutation__
 *
 * To run a mutation, you first call `useUpdateCoreMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCoreMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCoreMutation, { data, loading, error }] = useUpdateCoreMutation({
 *   variables: {
 *      id: // value for 'id'
 *      core: // value for 'core'
 *   },
 * });
 */
export function useUpdateCoreMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UpdateCoreMutation,
    UpdateCoreMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<UpdateCoreMutation, UpdateCoreMutationVariables>(
    UpdateCoreDocument,
    options,
  );
}
export type UpdateCoreMutationHookResult = ReturnType<
  typeof useUpdateCoreMutation
>;
export type UpdateCoreMutationResult =
  Apollo.MutationResult<UpdateCoreMutation>;
export type UpdateCoreMutationOptions = Apollo.BaseMutationOptions<
  UpdateCoreMutation,
  UpdateCoreMutationVariables
>;
export const UpdateHmmDocument = gql`
  mutation UpdateHmm($id: String!, $hmm: UpdateOneHmmInput!) {
    updateHmm(_id: $id, hmm: $hmm) {
      _id
      name
      type
      url
      timestamp
      tolerances {
        temperature
      }
      inUse
    }
  }
`;
export type UpdateHmmMutationFn = Apollo.MutationFunction<
  UpdateHmmMutation,
  UpdateHmmMutationVariables
>;

/**
 * __useUpdateHmmMutation__
 *
 * To run a mutation, you first call `useUpdateHmmMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateHmmMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateHmmMutation, { data, loading, error }] = useUpdateHmmMutation({
 *   variables: {
 *      id: // value for 'id'
 *      hmm: // value for 'hmm'
 *   },
 * });
 */
export function useUpdateHmmMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UpdateHmmMutation,
    UpdateHmmMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<UpdateHmmMutation, UpdateHmmMutationVariables>(
    UpdateHmmDocument,
    options,
  );
}
export type UpdateHmmMutationHookResult = ReturnType<
  typeof useUpdateHmmMutation
>;
export type UpdateHmmMutationResult = Apollo.MutationResult<UpdateHmmMutation>;
export type UpdateHmmMutationOptions = Apollo.BaseMutationOptions<
  UpdateHmmMutation,
  UpdateHmmMutationVariables
>;
export const SystemNotificationBaseByIdSubscriptionDocument = gql`
  subscription SystemNotificationBaseByIdSubscription($_id: String!) {
    systemNotificationEventsByIds(_ids: [$_id]) {
      modelChangeOperation
      _id
      entityId
      entityType
      message
      link
      createdAt
      displayStart
      displayEnd
      acknowledgedAt
      seenAt
      requireAcknowledgement
      modelChangeOperation
      modelType
      updateDescription
      relatedEntityName
    }
  }
`;

/**
 * __useSystemNotificationBaseByIdSubscriptionSubscription__
 *
 * To run a query within a React component, call `useSystemNotificationBaseByIdSubscriptionSubscription` and pass it any options that fit your needs.
 * When your component renders, `useSystemNotificationBaseByIdSubscriptionSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSystemNotificationBaseByIdSubscriptionSubscription({
 *   variables: {
 *      _id: // value for '_id'
 *   },
 * });
 */
export function useSystemNotificationBaseByIdSubscriptionSubscription(
  baseOptions: Apollo.SubscriptionHookOptions<
    SystemNotificationBaseByIdSubscriptionSubscription,
    SystemNotificationBaseByIdSubscriptionSubscriptionVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useSubscription<
    SystemNotificationBaseByIdSubscriptionSubscription,
    SystemNotificationBaseByIdSubscriptionSubscriptionVariables
  >(SystemNotificationBaseByIdSubscriptionDocument, options);
}
export type SystemNotificationBaseByIdSubscriptionSubscriptionHookResult =
  ReturnType<typeof useSystemNotificationBaseByIdSubscriptionSubscription>;
export type SystemNotificationBaseByIdSubscriptionSubscriptionResult =
  Apollo.SubscriptionResult<SystemNotificationBaseByIdSubscriptionSubscription>;
export const SystemNotificationBaseByIdDocument = gql`
  query SystemNotificationBaseById($_id: String!) {
    systemNotificationById(_id: $_id) {
      _id
      entityId
      entityType
      message
      link
      createdAt
      displayStart
      displayEnd
      acknowledgedAt
      seenAt
      requireAcknowledgement
      modelChangeOperation
      modelType
      updateDescription
      relatedEntityName
    }
  }
`;

/**
 * __useSystemNotificationBaseByIdQuery__
 *
 * To run a query within a React component, call `useSystemNotificationBaseByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useSystemNotificationBaseByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSystemNotificationBaseByIdQuery({
 *   variables: {
 *      _id: // value for '_id'
 *   },
 * });
 */
export function useSystemNotificationBaseByIdQuery(
  baseOptions: Apollo.QueryHookOptions<
    SystemNotificationBaseByIdQuery,
    SystemNotificationBaseByIdQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    SystemNotificationBaseByIdQuery,
    SystemNotificationBaseByIdQueryVariables
  >(SystemNotificationBaseByIdDocument, options);
}
export function useSystemNotificationBaseByIdLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    SystemNotificationBaseByIdQuery,
    SystemNotificationBaseByIdQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    SystemNotificationBaseByIdQuery,
    SystemNotificationBaseByIdQueryVariables
  >(SystemNotificationBaseByIdDocument, options);
}
export type SystemNotificationBaseByIdQueryHookResult = ReturnType<
  typeof useSystemNotificationBaseByIdQuery
>;
export type SystemNotificationBaseByIdLazyQueryHookResult = ReturnType<
  typeof useSystemNotificationBaseByIdLazyQuery
>;
export type SystemNotificationBaseByIdQueryResult = Apollo.QueryResult<
  SystemNotificationBaseByIdQuery,
  SystemNotificationBaseByIdQueryVariables
>;
export const SystemNotificationBaseSubscriptionDocument = gql`
  subscription SystemNotificationBaseSubscription {
    systemNotificationEvents {
      modelChangeOperation
      _id
      entityId
      entityType
      message
      link
      createdAt
      displayStart
      displayEnd
      acknowledgedAt
      seenAt
      requireAcknowledgement
      modelChangeOperation
      modelType
      updateDescription
      relatedEntityName
    }
  }
`;

/**
 * __useSystemNotificationBaseSubscriptionSubscription__
 *
 * To run a query within a React component, call `useSystemNotificationBaseSubscriptionSubscription` and pass it any options that fit your needs.
 * When your component renders, `useSystemNotificationBaseSubscriptionSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSystemNotificationBaseSubscriptionSubscription({
 *   variables: {
 *   },
 * });
 */
export function useSystemNotificationBaseSubscriptionSubscription(
  baseOptions?: Apollo.SubscriptionHookOptions<
    SystemNotificationBaseSubscriptionSubscription,
    SystemNotificationBaseSubscriptionSubscriptionVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useSubscription<
    SystemNotificationBaseSubscriptionSubscription,
    SystemNotificationBaseSubscriptionSubscriptionVariables
  >(SystemNotificationBaseSubscriptionDocument, options);
}
export type SystemNotificationBaseSubscriptionSubscriptionHookResult =
  ReturnType<typeof useSystemNotificationBaseSubscriptionSubscription>;
export type SystemNotificationBaseSubscriptionSubscriptionResult =
  Apollo.SubscriptionResult<SystemNotificationBaseSubscriptionSubscription>;
export const SystemNotificationBaseDocument = gql`
  query SystemNotificationBase {
    systemNotifications {
      _id
      entityId
      entityType
      message
      link
      createdAt
      displayStart
      displayEnd
      acknowledgedAt
      seenAt
      requireAcknowledgement
      modelChangeOperation
      modelType
      updateDescription
      relatedEntityName
    }
  }
`;

/**
 * __useSystemNotificationBaseQuery__
 *
 * To run a query within a React component, call `useSystemNotificationBaseQuery` and pass it any options that fit your needs.
 * When your component renders, `useSystemNotificationBaseQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSystemNotificationBaseQuery({
 *   variables: {
 *   },
 * });
 */
export function useSystemNotificationBaseQuery(
  baseOptions?: Apollo.QueryHookOptions<
    SystemNotificationBaseQuery,
    SystemNotificationBaseQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    SystemNotificationBaseQuery,
    SystemNotificationBaseQueryVariables
  >(SystemNotificationBaseDocument, options);
}
export function useSystemNotificationBaseLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    SystemNotificationBaseQuery,
    SystemNotificationBaseQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    SystemNotificationBaseQuery,
    SystemNotificationBaseQueryVariables
  >(SystemNotificationBaseDocument, options);
}
export type SystemNotificationBaseQueryHookResult = ReturnType<
  typeof useSystemNotificationBaseQuery
>;
export type SystemNotificationBaseLazyQueryHookResult = ReturnType<
  typeof useSystemNotificationBaseLazyQuery
>;
export type SystemNotificationBaseQueryResult = Apollo.QueryResult<
  SystemNotificationBaseQuery,
  SystemNotificationBaseQueryVariables
>;
export const SystemNotificationDetailSubscriptionDocument = gql`
  subscription SystemNotificationDetailSubscription($_id: String!) {
    systemNotificationEventsByIds(_ids: [$_id]) {
      modelChangeOperation
      _id
      entityId
      entityType
      message
      link
      createdAt
      displayStart
      displayEnd
      acknowledgedAt
      seenAt
      requireAcknowledgement
      modelChangeOperation
      modelType
      updateDescription
      relatedEntityName
    }
  }
`;

/**
 * __useSystemNotificationDetailSubscriptionSubscription__
 *
 * To run a query within a React component, call `useSystemNotificationDetailSubscriptionSubscription` and pass it any options that fit your needs.
 * When your component renders, `useSystemNotificationDetailSubscriptionSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSystemNotificationDetailSubscriptionSubscription({
 *   variables: {
 *      _id: // value for '_id'
 *   },
 * });
 */
export function useSystemNotificationDetailSubscriptionSubscription(
  baseOptions: Apollo.SubscriptionHookOptions<
    SystemNotificationDetailSubscriptionSubscription,
    SystemNotificationDetailSubscriptionSubscriptionVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useSubscription<
    SystemNotificationDetailSubscriptionSubscription,
    SystemNotificationDetailSubscriptionSubscriptionVariables
  >(SystemNotificationDetailSubscriptionDocument, options);
}
export type SystemNotificationDetailSubscriptionSubscriptionHookResult =
  ReturnType<typeof useSystemNotificationDetailSubscriptionSubscription>;
export type SystemNotificationDetailSubscriptionSubscriptionResult =
  Apollo.SubscriptionResult<SystemNotificationDetailSubscriptionSubscription>;
export const SystemNotificationDetailDocument = gql`
  query SystemNotificationDetail($_id: String!) {
    systemNotificationById(_id: $_id) {
      _id
      entityId
      entityType
      message
      link
      createdAt
      displayStart
      displayEnd
      acknowledgedAt
      seenAt
      requireAcknowledgement
      modelChangeOperation
      modelType
      updateDescription
      relatedEntityName
    }
  }
`;

/**
 * __useSystemNotificationDetailQuery__
 *
 * To run a query within a React component, call `useSystemNotificationDetailQuery` and pass it any options that fit your needs.
 * When your component renders, `useSystemNotificationDetailQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSystemNotificationDetailQuery({
 *   variables: {
 *      _id: // value for '_id'
 *   },
 * });
 */
export function useSystemNotificationDetailQuery(
  baseOptions: Apollo.QueryHookOptions<
    SystemNotificationDetailQuery,
    SystemNotificationDetailQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    SystemNotificationDetailQuery,
    SystemNotificationDetailQueryVariables
  >(SystemNotificationDetailDocument, options);
}
export function useSystemNotificationDetailLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    SystemNotificationDetailQuery,
    SystemNotificationDetailQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    SystemNotificationDetailQuery,
    SystemNotificationDetailQueryVariables
  >(SystemNotificationDetailDocument, options);
}
export type SystemNotificationDetailQueryHookResult = ReturnType<
  typeof useSystemNotificationDetailQuery
>;
export type SystemNotificationDetailLazyQueryHookResult = ReturnType<
  typeof useSystemNotificationDetailLazyQuery
>;
export type SystemNotificationDetailQueryResult = Apollo.QueryResult<
  SystemNotificationDetailQuery,
  SystemNotificationDetailQueryVariables
>;
export const SystemNotificationListSubscriptionDocument = gql`
  subscription SystemNotificationListSubscription {
    systemNotificationEvents {
      modelChangeOperation
      _id
      entityId
      entityType
      message
      link
      createdAt
      displayStart
      displayEnd
      acknowledgedAt
      seenAt
      requireAcknowledgement
      relatedEntityName
    }
  }
`;

/**
 * __useSystemNotificationListSubscriptionSubscription__
 *
 * To run a query within a React component, call `useSystemNotificationListSubscriptionSubscription` and pass it any options that fit your needs.
 * When your component renders, `useSystemNotificationListSubscriptionSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSystemNotificationListSubscriptionSubscription({
 *   variables: {
 *   },
 * });
 */
export function useSystemNotificationListSubscriptionSubscription(
  baseOptions?: Apollo.SubscriptionHookOptions<
    SystemNotificationListSubscriptionSubscription,
    SystemNotificationListSubscriptionSubscriptionVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useSubscription<
    SystemNotificationListSubscriptionSubscription,
    SystemNotificationListSubscriptionSubscriptionVariables
  >(SystemNotificationListSubscriptionDocument, options);
}
export type SystemNotificationListSubscriptionSubscriptionHookResult =
  ReturnType<typeof useSystemNotificationListSubscriptionSubscription>;
export type SystemNotificationListSubscriptionSubscriptionResult =
  Apollo.SubscriptionResult<SystemNotificationListSubscriptionSubscription>;
export const SystemNotificationListDocument = gql`
  query SystemNotificationList {
    systemNotifications {
      _id
      entityId
      entityType
      message
      link
      createdAt
      displayStart
      displayEnd
      acknowledgedAt
      seenAt
      requireAcknowledgement
      relatedEntityName
    }
  }
`;

/**
 * __useSystemNotificationListQuery__
 *
 * To run a query within a React component, call `useSystemNotificationListQuery` and pass it any options that fit your needs.
 * When your component renders, `useSystemNotificationListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSystemNotificationListQuery({
 *   variables: {
 *   },
 * });
 */
export function useSystemNotificationListQuery(
  baseOptions?: Apollo.QueryHookOptions<
    SystemNotificationListQuery,
    SystemNotificationListQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    SystemNotificationListQuery,
    SystemNotificationListQueryVariables
  >(SystemNotificationListDocument, options);
}
export function useSystemNotificationListLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    SystemNotificationListQuery,
    SystemNotificationListQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    SystemNotificationListQuery,
    SystemNotificationListQueryVariables
  >(SystemNotificationListDocument, options);
}
export type SystemNotificationListQueryHookResult = ReturnType<
  typeof useSystemNotificationListQuery
>;
export type SystemNotificationListLazyQueryHookResult = ReturnType<
  typeof useSystemNotificationListLazyQuery
>;
export type SystemNotificationListQueryResult = Apollo.QueryResult<
  SystemNotificationListQuery,
  SystemNotificationListQueryVariables
>;
export const CreateSystemNotificationDocument = gql`
  mutation CreateSystemNotification($input: CreateOneSystemNotificationInput!) {
    createSystemNotification(input: $input) {
      _id
      entityId
      entityType
      message
      link
      createdAt
      displayStart
      displayEnd
      acknowledgedAt
      requireAcknowledgement
      seenAt
      relatedEntityName
      modelChangeOperation
      modelType
      updateDescription
    }
  }
`;
export type CreateSystemNotificationMutationFn = Apollo.MutationFunction<
  CreateSystemNotificationMutation,
  CreateSystemNotificationMutationVariables
>;

/**
 * __useCreateSystemNotificationMutation__
 *
 * To run a mutation, you first call `useCreateSystemNotificationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateSystemNotificationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createSystemNotificationMutation, { data, loading, error }] = useCreateSystemNotificationMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateSystemNotificationMutation(
  baseOptions?: Apollo.MutationHookOptions<
    CreateSystemNotificationMutation,
    CreateSystemNotificationMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    CreateSystemNotificationMutation,
    CreateSystemNotificationMutationVariables
  >(CreateSystemNotificationDocument, options);
}
export type CreateSystemNotificationMutationHookResult = ReturnType<
  typeof useCreateSystemNotificationMutation
>;
export type CreateSystemNotificationMutationResult =
  Apollo.MutationResult<CreateSystemNotificationMutation>;
export type CreateSystemNotificationMutationOptions =
  Apollo.BaseMutationOptions<
    CreateSystemNotificationMutation,
    CreateSystemNotificationMutationVariables
  >;
export const UpdateSystemNotificationDocument = gql`
  mutation UpdateSystemNotification(
    $id: String!
    $input: UpdateOneSystemNotificationInput!
  ) {
    updateSystemNotification(_id: $id, input: $input) {
      _id
      entityId
      entityType
      message
      link
      createdAt
      displayStart
      displayEnd
      acknowledgedAt
      requireAcknowledgement
      seenAt
      relatedEntityName
      modelChangeOperation
      modelType
      updateDescription
    }
  }
`;
export type UpdateSystemNotificationMutationFn = Apollo.MutationFunction<
  UpdateSystemNotificationMutation,
  UpdateSystemNotificationMutationVariables
>;

/**
 * __useUpdateSystemNotificationMutation__
 *
 * To run a mutation, you first call `useUpdateSystemNotificationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateSystemNotificationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateSystemNotificationMutation, { data, loading, error }] = useUpdateSystemNotificationMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateSystemNotificationMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UpdateSystemNotificationMutation,
    UpdateSystemNotificationMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    UpdateSystemNotificationMutation,
    UpdateSystemNotificationMutationVariables
  >(UpdateSystemNotificationDocument, options);
}
export type UpdateSystemNotificationMutationHookResult = ReturnType<
  typeof useUpdateSystemNotificationMutation
>;
export type UpdateSystemNotificationMutationResult =
  Apollo.MutationResult<UpdateSystemNotificationMutation>;
export type UpdateSystemNotificationMutationOptions =
  Apollo.BaseMutationOptions<
    UpdateSystemNotificationMutation,
    UpdateSystemNotificationMutationVariables
  >;
export const MarkSystemNotificationSeenDocument = gql`
  mutation MarkSystemNotificationSeen($id: String!) {
    markSystemNotificationSeen(_id: $id) {
      _id
      entityId
      entityType
      message
      link
      createdAt
      displayStart
      displayEnd
      acknowledgedAt
      requireAcknowledgement
      seenAt
      relatedEntityName
      modelChangeOperation
      modelType
      updateDescription
    }
  }
`;
export type MarkSystemNotificationSeenMutationFn = Apollo.MutationFunction<
  MarkSystemNotificationSeenMutation,
  MarkSystemNotificationSeenMutationVariables
>;

/**
 * __useMarkSystemNotificationSeenMutation__
 *
 * To run a mutation, you first call `useMarkSystemNotificationSeenMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMarkSystemNotificationSeenMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [markSystemNotificationSeenMutation, { data, loading, error }] = useMarkSystemNotificationSeenMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useMarkSystemNotificationSeenMutation(
  baseOptions?: Apollo.MutationHookOptions<
    MarkSystemNotificationSeenMutation,
    MarkSystemNotificationSeenMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    MarkSystemNotificationSeenMutation,
    MarkSystemNotificationSeenMutationVariables
  >(MarkSystemNotificationSeenDocument, options);
}
export type MarkSystemNotificationSeenMutationHookResult = ReturnType<
  typeof useMarkSystemNotificationSeenMutation
>;
export type MarkSystemNotificationSeenMutationResult =
  Apollo.MutationResult<MarkSystemNotificationSeenMutation>;
export type MarkSystemNotificationSeenMutationOptions =
  Apollo.BaseMutationOptions<
    MarkSystemNotificationSeenMutation,
    MarkSystemNotificationSeenMutationVariables
  >;
export const MarkSystemNotificationAcknowledgedDocument = gql`
  mutation MarkSystemNotificationAcknowledged($id: String!) {
    markSystemNotificationAcknowledged(_id: $id) {
      _id
      entityId
      entityType
      message
      link
      createdAt
      displayStart
      displayEnd
      acknowledgedAt
      requireAcknowledgement
      seenAt
      relatedEntityName
      modelChangeOperation
      modelType
      updateDescription
    }
  }
`;
export type MarkSystemNotificationAcknowledgedMutationFn =
  Apollo.MutationFunction<
    MarkSystemNotificationAcknowledgedMutation,
    MarkSystemNotificationAcknowledgedMutationVariables
  >;

/**
 * __useMarkSystemNotificationAcknowledgedMutation__
 *
 * To run a mutation, you first call `useMarkSystemNotificationAcknowledgedMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMarkSystemNotificationAcknowledgedMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [markSystemNotificationAcknowledgedMutation, { data, loading, error }] = useMarkSystemNotificationAcknowledgedMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useMarkSystemNotificationAcknowledgedMutation(
  baseOptions?: Apollo.MutationHookOptions<
    MarkSystemNotificationAcknowledgedMutation,
    MarkSystemNotificationAcknowledgedMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    MarkSystemNotificationAcknowledgedMutation,
    MarkSystemNotificationAcknowledgedMutationVariables
  >(MarkSystemNotificationAcknowledgedDocument, options);
}
export type MarkSystemNotificationAcknowledgedMutationHookResult = ReturnType<
  typeof useMarkSystemNotificationAcknowledgedMutation
>;
export type MarkSystemNotificationAcknowledgedMutationResult =
  Apollo.MutationResult<MarkSystemNotificationAcknowledgedMutation>;
export type MarkSystemNotificationAcknowledgedMutationOptions =
  Apollo.BaseMutationOptions<
    MarkSystemNotificationAcknowledgedMutation,
    MarkSystemNotificationAcknowledgedMutationVariables
  >;
export const DeleteSystemNotificationDocument = gql`
  mutation DeleteSystemNotification($id: String!) {
    deleteSystemNotification(_id: $id)
  }
`;
export type DeleteSystemNotificationMutationFn = Apollo.MutationFunction<
  DeleteSystemNotificationMutation,
  DeleteSystemNotificationMutationVariables
>;

/**
 * __useDeleteSystemNotificationMutation__
 *
 * To run a mutation, you first call `useDeleteSystemNotificationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteSystemNotificationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteSystemNotificationMutation, { data, loading, error }] = useDeleteSystemNotificationMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteSystemNotificationMutation(
  baseOptions?: Apollo.MutationHookOptions<
    DeleteSystemNotificationMutation,
    DeleteSystemNotificationMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    DeleteSystemNotificationMutation,
    DeleteSystemNotificationMutationVariables
  >(DeleteSystemNotificationDocument, options);
}
export type DeleteSystemNotificationMutationHookResult = ReturnType<
  typeof useDeleteSystemNotificationMutation
>;
export type DeleteSystemNotificationMutationResult =
  Apollo.MutationResult<DeleteSystemNotificationMutation>;
export type DeleteSystemNotificationMutationOptions =
  Apollo.BaseMutationOptions<
    DeleteSystemNotificationMutation,
    DeleteSystemNotificationMutationVariables
  >;
export const ApplicationDocument = gql`
  query Application {
    application {
      name
    }
  }
`;

/**
 * __useApplicationQuery__
 *
 * To run a query within a React component, call `useApplicationQuery` and pass it any options that fit your needs.
 * When your component renders, `useApplicationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useApplicationQuery({
 *   variables: {
 *   },
 * });
 */
export function useApplicationQuery(
  baseOptions?: Apollo.QueryHookOptions<
    ApplicationQuery,
    ApplicationQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<ApplicationQuery, ApplicationQueryVariables>(
    ApplicationDocument,
    options,
  );
}
export function useApplicationLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    ApplicationQuery,
    ApplicationQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<ApplicationQuery, ApplicationQueryVariables>(
    ApplicationDocument,
    options,
  );
}
export type ApplicationQueryHookResult = ReturnType<typeof useApplicationQuery>;
export type ApplicationLazyQueryHookResult = ReturnType<
  typeof useApplicationLazyQuery
>;
export type ApplicationQueryResult = Apollo.QueryResult<
  ApplicationQuery,
  ApplicationQueryVariables
>;
export const ManagedEntitiesBnGsDocument = gql`
  query ManagedEntitiesBNGs {
    bNGs(limit: 0) {
      _id
      name
      propertyId
      url
      type
      inUse
      localUrl
    }
  }
`;

/**
 * __useManagedEntitiesBnGsQuery__
 *
 * To run a query within a React component, call `useManagedEntitiesBnGsQuery` and pass it any options that fit your needs.
 * When your component renders, `useManagedEntitiesBnGsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useManagedEntitiesBnGsQuery({
 *   variables: {
 *   },
 * });
 */
export function useManagedEntitiesBnGsQuery(
  baseOptions?: Apollo.QueryHookOptions<
    ManagedEntitiesBnGsQuery,
    ManagedEntitiesBnGsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    ManagedEntitiesBnGsQuery,
    ManagedEntitiesBnGsQueryVariables
  >(ManagedEntitiesBnGsDocument, options);
}
export function useManagedEntitiesBnGsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    ManagedEntitiesBnGsQuery,
    ManagedEntitiesBnGsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    ManagedEntitiesBnGsQuery,
    ManagedEntitiesBnGsQueryVariables
  >(ManagedEntitiesBnGsDocument, options);
}
export type ManagedEntitiesBnGsQueryHookResult = ReturnType<
  typeof useManagedEntitiesBnGsQuery
>;
export type ManagedEntitiesBnGsLazyQueryHookResult = ReturnType<
  typeof useManagedEntitiesBnGsLazyQuery
>;
export type ManagedEntitiesBnGsQueryResult = Apollo.QueryResult<
  ManagedEntitiesBnGsQuery,
  ManagedEntitiesBnGsQueryVariables
>;
export const ManagedEntitiesBuildingsByPropertyIdDocument = gql`
  query ManagedEntitiesBuildingsByPropertyId($propertyId: String!) {
    buildings(filter: { propertyId: $propertyId }, sort: NAME_ASC, limit: 0) {
      _id
      name
      number
      propertyId
    }
  }
`;

/**
 * __useManagedEntitiesBuildingsByPropertyIdQuery__
 *
 * To run a query within a React component, call `useManagedEntitiesBuildingsByPropertyIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useManagedEntitiesBuildingsByPropertyIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useManagedEntitiesBuildingsByPropertyIdQuery({
 *   variables: {
 *      propertyId: // value for 'propertyId'
 *   },
 * });
 */
export function useManagedEntitiesBuildingsByPropertyIdQuery(
  baseOptions: Apollo.QueryHookOptions<
    ManagedEntitiesBuildingsByPropertyIdQuery,
    ManagedEntitiesBuildingsByPropertyIdQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    ManagedEntitiesBuildingsByPropertyIdQuery,
    ManagedEntitiesBuildingsByPropertyIdQueryVariables
  >(ManagedEntitiesBuildingsByPropertyIdDocument, options);
}
export function useManagedEntitiesBuildingsByPropertyIdLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    ManagedEntitiesBuildingsByPropertyIdQuery,
    ManagedEntitiesBuildingsByPropertyIdQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    ManagedEntitiesBuildingsByPropertyIdQuery,
    ManagedEntitiesBuildingsByPropertyIdQueryVariables
  >(ManagedEntitiesBuildingsByPropertyIdDocument, options);
}
export type ManagedEntitiesBuildingsByPropertyIdQueryHookResult = ReturnType<
  typeof useManagedEntitiesBuildingsByPropertyIdQuery
>;
export type ManagedEntitiesBuildingsByPropertyIdLazyQueryHookResult =
  ReturnType<typeof useManagedEntitiesBuildingsByPropertyIdLazyQuery>;
export type ManagedEntitiesBuildingsByPropertyIdQueryResult =
  Apollo.QueryResult<
    ManagedEntitiesBuildingsByPropertyIdQuery,
    ManagedEntitiesBuildingsByPropertyIdQueryVariables
  >;
export const ManagedEntitiesBuildingsDocument = gql`
  query ManagedEntitiesBuildings {
    buildings(sort: NAME_ASC, limit: 0) {
      _id
      name
      number
      propertyId
    }
  }
`;

/**
 * __useManagedEntitiesBuildingsQuery__
 *
 * To run a query within a React component, call `useManagedEntitiesBuildingsQuery` and pass it any options that fit your needs.
 * When your component renders, `useManagedEntitiesBuildingsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useManagedEntitiesBuildingsQuery({
 *   variables: {
 *   },
 * });
 */
export function useManagedEntitiesBuildingsQuery(
  baseOptions?: Apollo.QueryHookOptions<
    ManagedEntitiesBuildingsQuery,
    ManagedEntitiesBuildingsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    ManagedEntitiesBuildingsQuery,
    ManagedEntitiesBuildingsQueryVariables
  >(ManagedEntitiesBuildingsDocument, options);
}
export function useManagedEntitiesBuildingsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    ManagedEntitiesBuildingsQuery,
    ManagedEntitiesBuildingsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    ManagedEntitiesBuildingsQuery,
    ManagedEntitiesBuildingsQueryVariables
  >(ManagedEntitiesBuildingsDocument, options);
}
export type ManagedEntitiesBuildingsQueryHookResult = ReturnType<
  typeof useManagedEntitiesBuildingsQuery
>;
export type ManagedEntitiesBuildingsLazyQueryHookResult = ReturnType<
  typeof useManagedEntitiesBuildingsLazyQuery
>;
export type ManagedEntitiesBuildingsQueryResult = Apollo.QueryResult<
  ManagedEntitiesBuildingsQuery,
  ManagedEntitiesBuildingsQueryVariables
>;
export const ManagedEntitiesConductorsDocument = gql`
  query ManagedEntitiesConductors {
    conductors(limit: 0) {
      _id
      name
      propertyId
      url
      type
      inUse
    }
  }
`;

/**
 * __useManagedEntitiesConductorsQuery__
 *
 * To run a query within a React component, call `useManagedEntitiesConductorsQuery` and pass it any options that fit your needs.
 * When your component renders, `useManagedEntitiesConductorsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useManagedEntitiesConductorsQuery({
 *   variables: {
 *   },
 * });
 */
export function useManagedEntitiesConductorsQuery(
  baseOptions?: Apollo.QueryHookOptions<
    ManagedEntitiesConductorsQuery,
    ManagedEntitiesConductorsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    ManagedEntitiesConductorsQuery,
    ManagedEntitiesConductorsQueryVariables
  >(ManagedEntitiesConductorsDocument, options);
}
export function useManagedEntitiesConductorsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    ManagedEntitiesConductorsQuery,
    ManagedEntitiesConductorsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    ManagedEntitiesConductorsQuery,
    ManagedEntitiesConductorsQueryVariables
  >(ManagedEntitiesConductorsDocument, options);
}
export type ManagedEntitiesConductorsQueryHookResult = ReturnType<
  typeof useManagedEntitiesConductorsQuery
>;
export type ManagedEntitiesConductorsLazyQueryHookResult = ReturnType<
  typeof useManagedEntitiesConductorsLazyQuery
>;
export type ManagedEntitiesConductorsQueryResult = Apollo.QueryResult<
  ManagedEntitiesConductorsQuery,
  ManagedEntitiesConductorsQueryVariables
>;
export const ManagedEntitiesCoresDocument = gql`
  query ManagedEntitiesCores {
    cores(limit: 0) {
      _id
      name
      propertyId
      url
      type
      inUse
    }
  }
`;

/**
 * __useManagedEntitiesCoresQuery__
 *
 * To run a query within a React component, call `useManagedEntitiesCoresQuery` and pass it any options that fit your needs.
 * When your component renders, `useManagedEntitiesCoresQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useManagedEntitiesCoresQuery({
 *   variables: {
 *   },
 * });
 */
export function useManagedEntitiesCoresQuery(
  baseOptions?: Apollo.QueryHookOptions<
    ManagedEntitiesCoresQuery,
    ManagedEntitiesCoresQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    ManagedEntitiesCoresQuery,
    ManagedEntitiesCoresQueryVariables
  >(ManagedEntitiesCoresDocument, options);
}
export function useManagedEntitiesCoresLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    ManagedEntitiesCoresQuery,
    ManagedEntitiesCoresQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    ManagedEntitiesCoresQuery,
    ManagedEntitiesCoresQueryVariables
  >(ManagedEntitiesCoresDocument, options);
}
export type ManagedEntitiesCoresQueryHookResult = ReturnType<
  typeof useManagedEntitiesCoresQuery
>;
export type ManagedEntitiesCoresLazyQueryHookResult = ReturnType<
  typeof useManagedEntitiesCoresLazyQuery
>;
export type ManagedEntitiesCoresQueryResult = Apollo.QueryResult<
  ManagedEntitiesCoresQuery,
  ManagedEntitiesCoresQueryVariables
>;
export const ManagedEntitiesThermostatsDocument = gql`
  query ManagedEntitiesThermostats {
    thermostats(limit: 0) {
      _id
      name
      type
      location
      propertyId
      unitId
      sourceId
      installation {
        status
      }
    }
  }
`;

/**
 * __useManagedEntitiesThermostatsQuery__
 *
 * To run a query within a React component, call `useManagedEntitiesThermostatsQuery` and pass it any options that fit your needs.
 * When your component renders, `useManagedEntitiesThermostatsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useManagedEntitiesThermostatsQuery({
 *   variables: {
 *   },
 * });
 */
export function useManagedEntitiesThermostatsQuery(
  baseOptions?: Apollo.QueryHookOptions<
    ManagedEntitiesThermostatsQuery,
    ManagedEntitiesThermostatsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    ManagedEntitiesThermostatsQuery,
    ManagedEntitiesThermostatsQueryVariables
  >(ManagedEntitiesThermostatsDocument, options);
}
export function useManagedEntitiesThermostatsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    ManagedEntitiesThermostatsQuery,
    ManagedEntitiesThermostatsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    ManagedEntitiesThermostatsQuery,
    ManagedEntitiesThermostatsQueryVariables
  >(ManagedEntitiesThermostatsDocument, options);
}
export type ManagedEntitiesThermostatsQueryHookResult = ReturnType<
  typeof useManagedEntitiesThermostatsQuery
>;
export type ManagedEntitiesThermostatsLazyQueryHookResult = ReturnType<
  typeof useManagedEntitiesThermostatsLazyQuery
>;
export type ManagedEntitiesThermostatsQueryResult = Apollo.QueryResult<
  ManagedEntitiesThermostatsQuery,
  ManagedEntitiesThermostatsQueryVariables
>;
export const ManagedEntitiesFloorsByPropertyIdDocument = gql`
  query ManagedEntitiesFloorsByPropertyId($propertyId: String!) {
    floors(filter: { propertyId: $propertyId }, sort: NAME_ASC, limit: 0) {
      _id
      name
      buildingId
      propertyId
    }
  }
`;

/**
 * __useManagedEntitiesFloorsByPropertyIdQuery__
 *
 * To run a query within a React component, call `useManagedEntitiesFloorsByPropertyIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useManagedEntitiesFloorsByPropertyIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useManagedEntitiesFloorsByPropertyIdQuery({
 *   variables: {
 *      propertyId: // value for 'propertyId'
 *   },
 * });
 */
export function useManagedEntitiesFloorsByPropertyIdQuery(
  baseOptions: Apollo.QueryHookOptions<
    ManagedEntitiesFloorsByPropertyIdQuery,
    ManagedEntitiesFloorsByPropertyIdQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    ManagedEntitiesFloorsByPropertyIdQuery,
    ManagedEntitiesFloorsByPropertyIdQueryVariables
  >(ManagedEntitiesFloorsByPropertyIdDocument, options);
}
export function useManagedEntitiesFloorsByPropertyIdLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    ManagedEntitiesFloorsByPropertyIdQuery,
    ManagedEntitiesFloorsByPropertyIdQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    ManagedEntitiesFloorsByPropertyIdQuery,
    ManagedEntitiesFloorsByPropertyIdQueryVariables
  >(ManagedEntitiesFloorsByPropertyIdDocument, options);
}
export type ManagedEntitiesFloorsByPropertyIdQueryHookResult = ReturnType<
  typeof useManagedEntitiesFloorsByPropertyIdQuery
>;
export type ManagedEntitiesFloorsByPropertyIdLazyQueryHookResult = ReturnType<
  typeof useManagedEntitiesFloorsByPropertyIdLazyQuery
>;
export type ManagedEntitiesFloorsByPropertyIdQueryResult = Apollo.QueryResult<
  ManagedEntitiesFloorsByPropertyIdQuery,
  ManagedEntitiesFloorsByPropertyIdQueryVariables
>;
export const ManagedEntitiesFloorsDocument = gql`
  query ManagedEntitiesFloors {
    floors(sort: NAME_ASC, limit: 0) {
      _id
      name
      buildingId
      propertyId
    }
  }
`;

/**
 * __useManagedEntitiesFloorsQuery__
 *
 * To run a query within a React component, call `useManagedEntitiesFloorsQuery` and pass it any options that fit your needs.
 * When your component renders, `useManagedEntitiesFloorsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useManagedEntitiesFloorsQuery({
 *   variables: {
 *   },
 * });
 */
export function useManagedEntitiesFloorsQuery(
  baseOptions?: Apollo.QueryHookOptions<
    ManagedEntitiesFloorsQuery,
    ManagedEntitiesFloorsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    ManagedEntitiesFloorsQuery,
    ManagedEntitiesFloorsQueryVariables
  >(ManagedEntitiesFloorsDocument, options);
}
export function useManagedEntitiesFloorsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    ManagedEntitiesFloorsQuery,
    ManagedEntitiesFloorsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    ManagedEntitiesFloorsQuery,
    ManagedEntitiesFloorsQueryVariables
  >(ManagedEntitiesFloorsDocument, options);
}
export type ManagedEntitiesFloorsQueryHookResult = ReturnType<
  typeof useManagedEntitiesFloorsQuery
>;
export type ManagedEntitiesFloorsLazyQueryHookResult = ReturnType<
  typeof useManagedEntitiesFloorsLazyQuery
>;
export type ManagedEntitiesFloorsQueryResult = Apollo.QueryResult<
  ManagedEntitiesFloorsQuery,
  ManagedEntitiesFloorsQueryVariables
>;
export const ManagedEntitiesHmMsDocument = gql`
  query ManagedEntitiesHMMs {
    hMMs(limit: 0) {
      _id
      name
      propertyId
      url
      type
      inUse
    }
  }
`;

/**
 * __useManagedEntitiesHmMsQuery__
 *
 * To run a query within a React component, call `useManagedEntitiesHmMsQuery` and pass it any options that fit your needs.
 * When your component renders, `useManagedEntitiesHmMsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useManagedEntitiesHmMsQuery({
 *   variables: {
 *   },
 * });
 */
export function useManagedEntitiesHmMsQuery(
  baseOptions?: Apollo.QueryHookOptions<
    ManagedEntitiesHmMsQuery,
    ManagedEntitiesHmMsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    ManagedEntitiesHmMsQuery,
    ManagedEntitiesHmMsQueryVariables
  >(ManagedEntitiesHmMsDocument, options);
}
export function useManagedEntitiesHmMsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    ManagedEntitiesHmMsQuery,
    ManagedEntitiesHmMsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    ManagedEntitiesHmMsQuery,
    ManagedEntitiesHmMsQueryVariables
  >(ManagedEntitiesHmMsDocument, options);
}
export type ManagedEntitiesHmMsQueryHookResult = ReturnType<
  typeof useManagedEntitiesHmMsQuery
>;
export type ManagedEntitiesHmMsLazyQueryHookResult = ReturnType<
  typeof useManagedEntitiesHmMsLazyQuery
>;
export type ManagedEntitiesHmMsQueryResult = Apollo.QueryResult<
  ManagedEntitiesHmMsQuery,
  ManagedEntitiesHmMsQueryVariables
>;
export const ManagedEntitiesOrganizationsDocument = gql`
  query ManagedEntitiesOrganizations {
    organizations(sort: NAME_ASC, limit: 0) {
      _id
      name
      description
      hqAddress {
        line1
        line2
        city
        state
        postalCode
        country
      }
      hqPhone
      hqEmail
      systemNotifications {
        _id
        message
        acknowledgedAt
        requireAcknowledgement
        seenAt
      }
    }
  }
`;

/**
 * __useManagedEntitiesOrganizationsQuery__
 *
 * To run a query within a React component, call `useManagedEntitiesOrganizationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useManagedEntitiesOrganizationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useManagedEntitiesOrganizationsQuery({
 *   variables: {
 *   },
 * });
 */
export function useManagedEntitiesOrganizationsQuery(
  baseOptions?: Apollo.QueryHookOptions<
    ManagedEntitiesOrganizationsQuery,
    ManagedEntitiesOrganizationsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    ManagedEntitiesOrganizationsQuery,
    ManagedEntitiesOrganizationsQueryVariables
  >(ManagedEntitiesOrganizationsDocument, options);
}
export function useManagedEntitiesOrganizationsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    ManagedEntitiesOrganizationsQuery,
    ManagedEntitiesOrganizationsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    ManagedEntitiesOrganizationsQuery,
    ManagedEntitiesOrganizationsQueryVariables
  >(ManagedEntitiesOrganizationsDocument, options);
}
export type ManagedEntitiesOrganizationsQueryHookResult = ReturnType<
  typeof useManagedEntitiesOrganizationsQuery
>;
export type ManagedEntitiesOrganizationsLazyQueryHookResult = ReturnType<
  typeof useManagedEntitiesOrganizationsLazyQuery
>;
export type ManagedEntitiesOrganizationsQueryResult = Apollo.QueryResult<
  ManagedEntitiesOrganizationsQuery,
  ManagedEntitiesOrganizationsQueryVariables
>;
export const ManagedEntitiesPlmEventResponsesByPropertyIdsDocument = gql`
  query ManagedEntitiesPlmEventResponsesByPropertyIds($propertyIds: [String]) {
    plmEventResponses(
      filter: { _operators: { propertyId: { in: $propertyIds } } }
      limit: 0
    ) {
      _id
      eventId
      propertyId
      curtailmentPlanId
      scheduledStart
      scheduledEnd
      actualStart
      actualEnd
      responseSentAt
      responseStatus
      createdAt
      updatedAt
      event {
        _id
        programId
        contractId
        startTime
        duration
        reductionTarget
        status
        notificationMethod
        notificationReceivedAt
        notificationPayload
        program {
          _id
          programId
          name
          partnerId
          season
          startDate
          endDate
          notificationLeadTimeMinutes
          maximumNotificationLeadTimeMinutes
          minimumEventDurationMinutes
          maximumEventDurationMinutes
          minimumEventsPerSeason
          maximumEventsPerSeason
          measurementIntervalMinutes
          participationType
          incentiveDescription
          partner {
            _id
            name
            description
          }
        }
        contract {
          _id
          name
          contractId
          programId
          propertyIds
          partnerId
          dispatcherIds
          minimumReductionKW
          maximumEventsPerSeason
          baselineMethod
          incentiveDescription
          penaltyForNonCompliance
          status
          notificationEmail
        }
      }
      curtailmentPlan {
        _id
        name
        description
        estimatedReductionKW
        durationMinutes
        applicableSeasons
        organizationId
      }
    }
  }
`;

/**
 * __useManagedEntitiesPlmEventResponsesByPropertyIdsQuery__
 *
 * To run a query within a React component, call `useManagedEntitiesPlmEventResponsesByPropertyIdsQuery` and pass it any options that fit your needs.
 * When your component renders, `useManagedEntitiesPlmEventResponsesByPropertyIdsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useManagedEntitiesPlmEventResponsesByPropertyIdsQuery({
 *   variables: {
 *      propertyIds: // value for 'propertyIds'
 *   },
 * });
 */
export function useManagedEntitiesPlmEventResponsesByPropertyIdsQuery(
  baseOptions?: Apollo.QueryHookOptions<
    ManagedEntitiesPlmEventResponsesByPropertyIdsQuery,
    ManagedEntitiesPlmEventResponsesByPropertyIdsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    ManagedEntitiesPlmEventResponsesByPropertyIdsQuery,
    ManagedEntitiesPlmEventResponsesByPropertyIdsQueryVariables
  >(ManagedEntitiesPlmEventResponsesByPropertyIdsDocument, options);
}
export function useManagedEntitiesPlmEventResponsesByPropertyIdsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    ManagedEntitiesPlmEventResponsesByPropertyIdsQuery,
    ManagedEntitiesPlmEventResponsesByPropertyIdsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    ManagedEntitiesPlmEventResponsesByPropertyIdsQuery,
    ManagedEntitiesPlmEventResponsesByPropertyIdsQueryVariables
  >(ManagedEntitiesPlmEventResponsesByPropertyIdsDocument, options);
}
export type ManagedEntitiesPlmEventResponsesByPropertyIdsQueryHookResult =
  ReturnType<typeof useManagedEntitiesPlmEventResponsesByPropertyIdsQuery>;
export type ManagedEntitiesPlmEventResponsesByPropertyIdsLazyQueryHookResult =
  ReturnType<typeof useManagedEntitiesPlmEventResponsesByPropertyIdsLazyQuery>;
export type ManagedEntitiesPlmEventResponsesByPropertyIdsQueryResult =
  Apollo.QueryResult<
    ManagedEntitiesPlmEventResponsesByPropertyIdsQuery,
    ManagedEntitiesPlmEventResponsesByPropertyIdsQueryVariables
  >;
export const ManagedEntitiesPlmEventResponsesDocument = gql`
  query ManagedEntitiesPlmEventResponses {
    plmEventResponses(limit: 0) {
      _id
      eventId
      propertyId
      curtailmentPlanId
      scheduledStart
      scheduledEnd
      actualStart
      actualEnd
      responseSentAt
      responseStatus
      createdAt
      updatedAt
      event {
        _id
        programId
        contractId
        startTime
        duration
        reductionTarget
        status
        notificationMethod
        notificationReceivedAt
        notificationPayload
        program {
          _id
          programId
          name
          partnerId
          season
          startDate
          endDate
          notificationLeadTimeMinutes
          maximumNotificationLeadTimeMinutes
          minimumEventDurationMinutes
          maximumEventDurationMinutes
          minimumEventsPerSeason
          maximumEventsPerSeason
          measurementIntervalMinutes
          participationType
          incentiveDescription
          partner {
            _id
            name
            description
          }
        }
        contract {
          _id
          name
          contractId
          programId
          propertyIds
          partnerId
          dispatcherIds
          minimumReductionKW
          maximumEventsPerSeason
          baselineMethod
          incentiveDescription
          penaltyForNonCompliance
          status
          notificationEmail
        }
      }
      curtailmentPlan {
        _id
        name
        description
        estimatedReductionKW
        durationMinutes
        applicableSeasons
        organizationId
      }
    }
  }
`;

/**
 * __useManagedEntitiesPlmEventResponsesQuery__
 *
 * To run a query within a React component, call `useManagedEntitiesPlmEventResponsesQuery` and pass it any options that fit your needs.
 * When your component renders, `useManagedEntitiesPlmEventResponsesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useManagedEntitiesPlmEventResponsesQuery({
 *   variables: {
 *   },
 * });
 */
export function useManagedEntitiesPlmEventResponsesQuery(
  baseOptions?: Apollo.QueryHookOptions<
    ManagedEntitiesPlmEventResponsesQuery,
    ManagedEntitiesPlmEventResponsesQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    ManagedEntitiesPlmEventResponsesQuery,
    ManagedEntitiesPlmEventResponsesQueryVariables
  >(ManagedEntitiesPlmEventResponsesDocument, options);
}
export function useManagedEntitiesPlmEventResponsesLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    ManagedEntitiesPlmEventResponsesQuery,
    ManagedEntitiesPlmEventResponsesQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    ManagedEntitiesPlmEventResponsesQuery,
    ManagedEntitiesPlmEventResponsesQueryVariables
  >(ManagedEntitiesPlmEventResponsesDocument, options);
}
export type ManagedEntitiesPlmEventResponsesQueryHookResult = ReturnType<
  typeof useManagedEntitiesPlmEventResponsesQuery
>;
export type ManagedEntitiesPlmEventResponsesLazyQueryHookResult = ReturnType<
  typeof useManagedEntitiesPlmEventResponsesLazyQuery
>;
export type ManagedEntitiesPlmEventResponsesQueryResult = Apollo.QueryResult<
  ManagedEntitiesPlmEventResponsesQuery,
  ManagedEntitiesPlmEventResponsesQueryVariables
>;
export const ManagedEntitiesPropertiesDocument = gql`
  query ManagedEntitiesProperties {
    properties(sort: TITLE_ASC, limit: 0) {
      _id
      title
      floorLabel
      address {
        line1
        city
        state
        postalCode
      }
      owner {
        name
      }
      propMgr {
        name
        mobile
      }
      maintMgr {
        name
        mobile
      }
      imageUrl
      systemNotifications {
        _id
        message
        acknowledgedAt
        requireAcknowledgement
        seenAt
      }
    }
  }
`;

/**
 * __useManagedEntitiesPropertiesQuery__
 *
 * To run a query within a React component, call `useManagedEntitiesPropertiesQuery` and pass it any options that fit your needs.
 * When your component renders, `useManagedEntitiesPropertiesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useManagedEntitiesPropertiesQuery({
 *   variables: {
 *   },
 * });
 */
export function useManagedEntitiesPropertiesQuery(
  baseOptions?: Apollo.QueryHookOptions<
    ManagedEntitiesPropertiesQuery,
    ManagedEntitiesPropertiesQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    ManagedEntitiesPropertiesQuery,
    ManagedEntitiesPropertiesQueryVariables
  >(ManagedEntitiesPropertiesDocument, options);
}
export function useManagedEntitiesPropertiesLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    ManagedEntitiesPropertiesQuery,
    ManagedEntitiesPropertiesQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    ManagedEntitiesPropertiesQuery,
    ManagedEntitiesPropertiesQueryVariables
  >(ManagedEntitiesPropertiesDocument, options);
}
export type ManagedEntitiesPropertiesQueryHookResult = ReturnType<
  typeof useManagedEntitiesPropertiesQuery
>;
export type ManagedEntitiesPropertiesLazyQueryHookResult = ReturnType<
  typeof useManagedEntitiesPropertiesLazyQuery
>;
export type ManagedEntitiesPropertiesQueryResult = Apollo.QueryResult<
  ManagedEntitiesPropertiesQuery,
  ManagedEntitiesPropertiesQueryVariables
>;
export const ManagedOrganizationUpdatesDocument = gql`
  subscription ManagedOrganizationUpdates {
    organizationEvents {
      modelChangeOperation
      _id
      name
      description
      hqAddress {
        line1
        line2
        city
        state
        postalCode
        country
      }
      hqPhone
      hqEmail
    }
  }
`;

/**
 * __useManagedOrganizationUpdatesSubscription__
 *
 * To run a query within a React component, call `useManagedOrganizationUpdatesSubscription` and pass it any options that fit your needs.
 * When your component renders, `useManagedOrganizationUpdatesSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useManagedOrganizationUpdatesSubscription({
 *   variables: {
 *   },
 * });
 */
export function useManagedOrganizationUpdatesSubscription(
  baseOptions?: Apollo.SubscriptionHookOptions<
    ManagedOrganizationUpdatesSubscription,
    ManagedOrganizationUpdatesSubscriptionVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useSubscription<
    ManagedOrganizationUpdatesSubscription,
    ManagedOrganizationUpdatesSubscriptionVariables
  >(ManagedOrganizationUpdatesDocument, options);
}
export type ManagedOrganizationUpdatesSubscriptionHookResult = ReturnType<
  typeof useManagedOrganizationUpdatesSubscription
>;
export type ManagedOrganizationUpdatesSubscriptionResult =
  Apollo.SubscriptionResult<ManagedOrganizationUpdatesSubscription>;
export const ManagedPropertyUpdatesDocument = gql`
  subscription ManagedPropertyUpdates {
    propertyEvents {
      modelChangeOperation
      _id
      title
      address {
        line1
        city
        state
        postalCode
      }
      owner {
        name
      }
      propMgr {
        name
        mobile
      }
      maintMgr {
        name
        mobile
      }
      imageUrl
    }
  }
`;

/**
 * __useManagedPropertyUpdatesSubscription__
 *
 * To run a query within a React component, call `useManagedPropertyUpdatesSubscription` and pass it any options that fit your needs.
 * When your component renders, `useManagedPropertyUpdatesSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useManagedPropertyUpdatesSubscription({
 *   variables: {
 *   },
 * });
 */
export function useManagedPropertyUpdatesSubscription(
  baseOptions?: Apollo.SubscriptionHookOptions<
    ManagedPropertyUpdatesSubscription,
    ManagedPropertyUpdatesSubscriptionVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useSubscription<
    ManagedPropertyUpdatesSubscription,
    ManagedPropertyUpdatesSubscriptionVariables
  >(ManagedPropertyUpdatesDocument, options);
}
export type ManagedPropertyUpdatesSubscriptionHookResult = ReturnType<
  typeof useManagedPropertyUpdatesSubscription
>;
export type ManagedPropertyUpdatesSubscriptionResult =
  Apollo.SubscriptionResult<ManagedPropertyUpdatesSubscription>;
export const ManagedCoreUpdatesDocument = gql`
  subscription ManagedCoreUpdates {
    coreEvents {
      modelChangeOperation
      _id
      name
      type
      url
      inUse
    }
  }
`;

/**
 * __useManagedCoreUpdatesSubscription__
 *
 * To run a query within a React component, call `useManagedCoreUpdatesSubscription` and pass it any options that fit your needs.
 * When your component renders, `useManagedCoreUpdatesSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useManagedCoreUpdatesSubscription({
 *   variables: {
 *   },
 * });
 */
export function useManagedCoreUpdatesSubscription(
  baseOptions?: Apollo.SubscriptionHookOptions<
    ManagedCoreUpdatesSubscription,
    ManagedCoreUpdatesSubscriptionVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useSubscription<
    ManagedCoreUpdatesSubscription,
    ManagedCoreUpdatesSubscriptionVariables
  >(ManagedCoreUpdatesDocument, options);
}
export type ManagedCoreUpdatesSubscriptionHookResult = ReturnType<
  typeof useManagedCoreUpdatesSubscription
>;
export type ManagedCoreUpdatesSubscriptionResult =
  Apollo.SubscriptionResult<ManagedCoreUpdatesSubscription>;
export const ManagedHmmUpdatesDocument = gql`
  subscription ManagedHMMUpdates {
    hMMEvents {
      modelChangeOperation
      _id
      name
      type
      url
      inUse
    }
  }
`;

/**
 * __useManagedHmmUpdatesSubscription__
 *
 * To run a query within a React component, call `useManagedHmmUpdatesSubscription` and pass it any options that fit your needs.
 * When your component renders, `useManagedHmmUpdatesSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useManagedHmmUpdatesSubscription({
 *   variables: {
 *   },
 * });
 */
export function useManagedHmmUpdatesSubscription(
  baseOptions?: Apollo.SubscriptionHookOptions<
    ManagedHmmUpdatesSubscription,
    ManagedHmmUpdatesSubscriptionVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useSubscription<
    ManagedHmmUpdatesSubscription,
    ManagedHmmUpdatesSubscriptionVariables
  >(ManagedHmmUpdatesDocument, options);
}
export type ManagedHmmUpdatesSubscriptionHookResult = ReturnType<
  typeof useManagedHmmUpdatesSubscription
>;
export type ManagedHmmUpdatesSubscriptionResult =
  Apollo.SubscriptionResult<ManagedHmmUpdatesSubscription>;
export const ManagedBngUpdatesDocument = gql`
  subscription ManagedBNGUpdates {
    bNGEvents {
      modelChangeOperation
      _id
      name
      type
      url
      localUrl
      inUse
    }
  }
`;

/**
 * __useManagedBngUpdatesSubscription__
 *
 * To run a query within a React component, call `useManagedBngUpdatesSubscription` and pass it any options that fit your needs.
 * When your component renders, `useManagedBngUpdatesSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useManagedBngUpdatesSubscription({
 *   variables: {
 *   },
 * });
 */
export function useManagedBngUpdatesSubscription(
  baseOptions?: Apollo.SubscriptionHookOptions<
    ManagedBngUpdatesSubscription,
    ManagedBngUpdatesSubscriptionVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useSubscription<
    ManagedBngUpdatesSubscription,
    ManagedBngUpdatesSubscriptionVariables
  >(ManagedBngUpdatesDocument, options);
}
export type ManagedBngUpdatesSubscriptionHookResult = ReturnType<
  typeof useManagedBngUpdatesSubscription
>;
export type ManagedBngUpdatesSubscriptionResult =
  Apollo.SubscriptionResult<ManagedBngUpdatesSubscription>;
export const ManagedConductorUpdatesDocument = gql`
  subscription ManagedConductorUpdates {
    conductorEvents {
      modelChangeOperation
      _id
      name
      type
      url
      inUse
    }
  }
`;

/**
 * __useManagedConductorUpdatesSubscription__
 *
 * To run a query within a React component, call `useManagedConductorUpdatesSubscription` and pass it any options that fit your needs.
 * When your component renders, `useManagedConductorUpdatesSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useManagedConductorUpdatesSubscription({
 *   variables: {
 *   },
 * });
 */
export function useManagedConductorUpdatesSubscription(
  baseOptions?: Apollo.SubscriptionHookOptions<
    ManagedConductorUpdatesSubscription,
    ManagedConductorUpdatesSubscriptionVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useSubscription<
    ManagedConductorUpdatesSubscription,
    ManagedConductorUpdatesSubscriptionVariables
  >(ManagedConductorUpdatesDocument, options);
}
export type ManagedConductorUpdatesSubscriptionHookResult = ReturnType<
  typeof useManagedConductorUpdatesSubscription
>;
export type ManagedConductorUpdatesSubscriptionResult =
  Apollo.SubscriptionResult<ManagedConductorUpdatesSubscription>;
export const ManagedBuildingUpdatesDocument = gql`
  subscription ManagedBuildingUpdates {
    buildingEvents {
      modelChangeOperation
      _id
      name
      number
      propertyId
    }
  }
`;

/**
 * __useManagedBuildingUpdatesSubscription__
 *
 * To run a query within a React component, call `useManagedBuildingUpdatesSubscription` and pass it any options that fit your needs.
 * When your component renders, `useManagedBuildingUpdatesSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useManagedBuildingUpdatesSubscription({
 *   variables: {
 *   },
 * });
 */
export function useManagedBuildingUpdatesSubscription(
  baseOptions?: Apollo.SubscriptionHookOptions<
    ManagedBuildingUpdatesSubscription,
    ManagedBuildingUpdatesSubscriptionVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useSubscription<
    ManagedBuildingUpdatesSubscription,
    ManagedBuildingUpdatesSubscriptionVariables
  >(ManagedBuildingUpdatesDocument, options);
}
export type ManagedBuildingUpdatesSubscriptionHookResult = ReturnType<
  typeof useManagedBuildingUpdatesSubscription
>;
export type ManagedBuildingUpdatesSubscriptionResult =
  Apollo.SubscriptionResult<ManagedBuildingUpdatesSubscription>;
export const ManagedFloorUpdatesDocument = gql`
  subscription ManagedFloorUpdates {
    floorEvents {
      modelChangeOperation
      _id
      name
      buildingId
      propertyId
    }
  }
`;

/**
 * __useManagedFloorUpdatesSubscription__
 *
 * To run a query within a React component, call `useManagedFloorUpdatesSubscription` and pass it any options that fit your needs.
 * When your component renders, `useManagedFloorUpdatesSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useManagedFloorUpdatesSubscription({
 *   variables: {
 *   },
 * });
 */
export function useManagedFloorUpdatesSubscription(
  baseOptions?: Apollo.SubscriptionHookOptions<
    ManagedFloorUpdatesSubscription,
    ManagedFloorUpdatesSubscriptionVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useSubscription<
    ManagedFloorUpdatesSubscription,
    ManagedFloorUpdatesSubscriptionVariables
  >(ManagedFloorUpdatesDocument, options);
}
export type ManagedFloorUpdatesSubscriptionHookResult = ReturnType<
  typeof useManagedFloorUpdatesSubscription
>;
export type ManagedFloorUpdatesSubscriptionResult =
  Apollo.SubscriptionResult<ManagedFloorUpdatesSubscription>;
export const ManagedUnitUpdatesDocument = gql`
  subscription ManagedUnitUpdates {
    unitEvents {
      modelChangeOperation
      _id
      name
      type
      propertyId
      buildingId
      floorId
      cuid
    }
  }
`;

/**
 * __useManagedUnitUpdatesSubscription__
 *
 * To run a query within a React component, call `useManagedUnitUpdatesSubscription` and pass it any options that fit your needs.
 * When your component renders, `useManagedUnitUpdatesSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useManagedUnitUpdatesSubscription({
 *   variables: {
 *   },
 * });
 */
export function useManagedUnitUpdatesSubscription(
  baseOptions?: Apollo.SubscriptionHookOptions<
    ManagedUnitUpdatesSubscription,
    ManagedUnitUpdatesSubscriptionVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useSubscription<
    ManagedUnitUpdatesSubscription,
    ManagedUnitUpdatesSubscriptionVariables
  >(ManagedUnitUpdatesDocument, options);
}
export type ManagedUnitUpdatesSubscriptionHookResult = ReturnType<
  typeof useManagedUnitUpdatesSubscription
>;
export type ManagedUnitUpdatesSubscriptionResult =
  Apollo.SubscriptionResult<ManagedUnitUpdatesSubscription>;
export const ManagedPlmEventResponseUpdatesDocument = gql`
  subscription ManagedPlmEventResponseUpdates {
    plmEventResponseEvents {
      modelChangeOperation
      _id
      eventId
      propertyId
      curtailmentPlanId
      scheduledStart
      scheduledEnd
      actualStart
      actualEnd
      responseSentAt
      responseStatus
      createdAt
      updatedAt
      event {
        _id
        programId
        contractId
        startTime
        duration
        reductionTarget
        status
        notificationMethod
        notificationReceivedAt
        notificationPayload
        program {
          _id
          programId
          name
          partnerId
          season
          startDate
          endDate
          notificationLeadTimeMinutes
          maximumNotificationLeadTimeMinutes
          minimumEventDurationMinutes
          maximumEventDurationMinutes
          minimumEventsPerSeason
          maximumEventsPerSeason
          measurementIntervalMinutes
          participationType
          incentiveDescription
          partner {
            _id
            name
            description
          }
        }
        contract {
          _id
          name
          contractId
          programId
          propertyIds
          partnerId
          dispatcherIds
          minimumReductionKW
          maximumEventsPerSeason
          baselineMethod
          incentiveDescription
          penaltyForNonCompliance
          status
          notificationEmail
        }
      }
      curtailmentPlan {
        _id
        name
        description
        estimatedReductionKW
        durationMinutes
        applicableSeasons
        organizationId
      }
    }
  }
`;

/**
 * __useManagedPlmEventResponseUpdatesSubscription__
 *
 * To run a query within a React component, call `useManagedPlmEventResponseUpdatesSubscription` and pass it any options that fit your needs.
 * When your component renders, `useManagedPlmEventResponseUpdatesSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useManagedPlmEventResponseUpdatesSubscription({
 *   variables: {
 *   },
 * });
 */
export function useManagedPlmEventResponseUpdatesSubscription(
  baseOptions?: Apollo.SubscriptionHookOptions<
    ManagedPlmEventResponseUpdatesSubscription,
    ManagedPlmEventResponseUpdatesSubscriptionVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useSubscription<
    ManagedPlmEventResponseUpdatesSubscription,
    ManagedPlmEventResponseUpdatesSubscriptionVariables
  >(ManagedPlmEventResponseUpdatesDocument, options);
}
export type ManagedPlmEventResponseUpdatesSubscriptionHookResult = ReturnType<
  typeof useManagedPlmEventResponseUpdatesSubscription
>;
export type ManagedPlmEventResponseUpdatesSubscriptionResult =
  Apollo.SubscriptionResult<ManagedPlmEventResponseUpdatesSubscription>;
export const ManagedEntitiesThermostatsByPropertyIdDocument = gql`
  query ManagedEntitiesThermostatsByPropertyId($propertyId: String!) {
    thermostats(filter: { propertyId: $propertyId }, limit: 0) {
      _id
      name
      type
      location
      propertyId
      unitId
      sourceId
      installation {
        status
      }
    }
  }
`;

/**
 * __useManagedEntitiesThermostatsByPropertyIdQuery__
 *
 * To run a query within a React component, call `useManagedEntitiesThermostatsByPropertyIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useManagedEntitiesThermostatsByPropertyIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useManagedEntitiesThermostatsByPropertyIdQuery({
 *   variables: {
 *      propertyId: // value for 'propertyId'
 *   },
 * });
 */
export function useManagedEntitiesThermostatsByPropertyIdQuery(
  baseOptions: Apollo.QueryHookOptions<
    ManagedEntitiesThermostatsByPropertyIdQuery,
    ManagedEntitiesThermostatsByPropertyIdQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    ManagedEntitiesThermostatsByPropertyIdQuery,
    ManagedEntitiesThermostatsByPropertyIdQueryVariables
  >(ManagedEntitiesThermostatsByPropertyIdDocument, options);
}
export function useManagedEntitiesThermostatsByPropertyIdLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    ManagedEntitiesThermostatsByPropertyIdQuery,
    ManagedEntitiesThermostatsByPropertyIdQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    ManagedEntitiesThermostatsByPropertyIdQuery,
    ManagedEntitiesThermostatsByPropertyIdQueryVariables
  >(ManagedEntitiesThermostatsByPropertyIdDocument, options);
}
export type ManagedEntitiesThermostatsByPropertyIdQueryHookResult = ReturnType<
  typeof useManagedEntitiesThermostatsByPropertyIdQuery
>;
export type ManagedEntitiesThermostatsByPropertyIdLazyQueryHookResult =
  ReturnType<typeof useManagedEntitiesThermostatsByPropertyIdLazyQuery>;
export type ManagedEntitiesThermostatsByPropertyIdQueryResult =
  Apollo.QueryResult<
    ManagedEntitiesThermostatsByPropertyIdQuery,
    ManagedEntitiesThermostatsByPropertyIdQueryVariables
  >;
export const ManagedUnitUpdatesByPropertyIdsDocument = gql`
  subscription ManagedUnitUpdatesByPropertyIds($propertyIds: [String]) {
    unitEventsByPropertyId(propertyId: $propertyIds) {
      modelChangeOperation
      _id
      name
      type
      propertyId
      buildingId
      floorId
      cuid
    }
  }
`;

/**
 * __useManagedUnitUpdatesByPropertyIdsSubscription__
 *
 * To run a query within a React component, call `useManagedUnitUpdatesByPropertyIdsSubscription` and pass it any options that fit your needs.
 * When your component renders, `useManagedUnitUpdatesByPropertyIdsSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useManagedUnitUpdatesByPropertyIdsSubscription({
 *   variables: {
 *      propertyIds: // value for 'propertyIds'
 *   },
 * });
 */
export function useManagedUnitUpdatesByPropertyIdsSubscription(
  baseOptions?: Apollo.SubscriptionHookOptions<
    ManagedUnitUpdatesByPropertyIdsSubscription,
    ManagedUnitUpdatesByPropertyIdsSubscriptionVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useSubscription<
    ManagedUnitUpdatesByPropertyIdsSubscription,
    ManagedUnitUpdatesByPropertyIdsSubscriptionVariables
  >(ManagedUnitUpdatesByPropertyIdsDocument, options);
}
export type ManagedUnitUpdatesByPropertyIdsSubscriptionHookResult = ReturnType<
  typeof useManagedUnitUpdatesByPropertyIdsSubscription
>;
export type ManagedUnitUpdatesByPropertyIdsSubscriptionResult =
  Apollo.SubscriptionResult<ManagedUnitUpdatesByPropertyIdsSubscription>;
export const ManagedEntitiesUnitsByPropertyIdsDocument = gql`
  query ManagedEntitiesUnitsByPropertyIds($propertyIds: [String]) {
    unitsByPropertyId(propertyId: $propertyIds) {
      _id
      name
      type
      propertyId
      buildingId
      floorId
      cuid
      systemNotifications {
        _id
        message
        acknowledgedAt
        requireAcknowledgement
        seenAt
      }
    }
  }
`;

/**
 * __useManagedEntitiesUnitsByPropertyIdsQuery__
 *
 * To run a query within a React component, call `useManagedEntitiesUnitsByPropertyIdsQuery` and pass it any options that fit your needs.
 * When your component renders, `useManagedEntitiesUnitsByPropertyIdsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useManagedEntitiesUnitsByPropertyIdsQuery({
 *   variables: {
 *      propertyIds: // value for 'propertyIds'
 *   },
 * });
 */
export function useManagedEntitiesUnitsByPropertyIdsQuery(
  baseOptions?: Apollo.QueryHookOptions<
    ManagedEntitiesUnitsByPropertyIdsQuery,
    ManagedEntitiesUnitsByPropertyIdsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    ManagedEntitiesUnitsByPropertyIdsQuery,
    ManagedEntitiesUnitsByPropertyIdsQueryVariables
  >(ManagedEntitiesUnitsByPropertyIdsDocument, options);
}
export function useManagedEntitiesUnitsByPropertyIdsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    ManagedEntitiesUnitsByPropertyIdsQuery,
    ManagedEntitiesUnitsByPropertyIdsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    ManagedEntitiesUnitsByPropertyIdsQuery,
    ManagedEntitiesUnitsByPropertyIdsQueryVariables
  >(ManagedEntitiesUnitsByPropertyIdsDocument, options);
}
export type ManagedEntitiesUnitsByPropertyIdsQueryHookResult = ReturnType<
  typeof useManagedEntitiesUnitsByPropertyIdsQuery
>;
export type ManagedEntitiesUnitsByPropertyIdsLazyQueryHookResult = ReturnType<
  typeof useManagedEntitiesUnitsByPropertyIdsLazyQuery
>;
export type ManagedEntitiesUnitsByPropertyIdsQueryResult = Apollo.QueryResult<
  ManagedEntitiesUnitsByPropertyIdsQuery,
  ManagedEntitiesUnitsByPropertyIdsQueryVariables
>;
export const ManagedEntitiesUnitsDocument = gql`
  query ManagedEntitiesUnits {
    units(sort: NAME_ASC, limit: 0) {
      _id
      name
      type
      propertyId
      buildingId
      floorId
      cuid
      systemNotifications {
        _id
        message
        acknowledgedAt
        requireAcknowledgement
        seenAt
      }
    }
  }
`;

/**
 * __useManagedEntitiesUnitsQuery__
 *
 * To run a query within a React component, call `useManagedEntitiesUnitsQuery` and pass it any options that fit your needs.
 * When your component renders, `useManagedEntitiesUnitsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useManagedEntitiesUnitsQuery({
 *   variables: {
 *   },
 * });
 */
export function useManagedEntitiesUnitsQuery(
  baseOptions?: Apollo.QueryHookOptions<
    ManagedEntitiesUnitsQuery,
    ManagedEntitiesUnitsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    ManagedEntitiesUnitsQuery,
    ManagedEntitiesUnitsQueryVariables
  >(ManagedEntitiesUnitsDocument, options);
}
export function useManagedEntitiesUnitsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    ManagedEntitiesUnitsQuery,
    ManagedEntitiesUnitsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    ManagedEntitiesUnitsQuery,
    ManagedEntitiesUnitsQueryVariables
  >(ManagedEntitiesUnitsDocument, options);
}
export type ManagedEntitiesUnitsQueryHookResult = ReturnType<
  typeof useManagedEntitiesUnitsQuery
>;
export type ManagedEntitiesUnitsLazyQueryHookResult = ReturnType<
  typeof useManagedEntitiesUnitsLazyQuery
>;
export type ManagedEntitiesUnitsQueryResult = Apollo.QueryResult<
  ManagedEntitiesUnitsQuery,
  ManagedEntitiesUnitsQueryVariables
>;
export const ManagedEntitiesDocument = gql`
  query ManagedEntities {
    organizations(sort: NAME_ASC, limit: 0) {
      _id
      name
      description
      hqAddress {
        line1
        line2
        city
        state
        postalCode
        country
      }
      hqPhone
      hqEmail
      systemNotifications {
        _id
        message
        acknowledgedAt
        requireAcknowledgement
        seenAt
      }
    }
    properties(sort: TITLE_ASC, limit: 0) {
      _id
      title
      floorLabel
      address {
        line1
        city
        state
        postalCode
      }
      owner {
        name
      }
      propMgr {
        name
        mobile
      }
      maintMgr {
        name
        mobile
      }
      imageUrl
      systemNotifications {
        _id
        message
        acknowledgedAt
        requireAcknowledgement
        seenAt
      }
    }
    cores(limit: 0) {
      _id
      name
      propertyId
      url
      type
      inUse
    }
    hMMs(limit: 0) {
      _id
      name
      propertyId
      url
      type
      inUse
    }
    bNGs(limit: 0) {
      _id
      name
      propertyId
      url
      type
      inUse
      localUrl
    }
    conductors(limit: 0) {
      _id
      name
      propertyId
      url
      type
      inUse
    }
    buildings(sort: NAME_ASC, limit: 0) {
      _id
      name
      number
      propertyId
    }
    floors(sort: NAME_ASC, limit: 0) {
      _id
      name
      buildingId
      propertyId
    }
    units(sort: NAME_ASC, limit: 0) {
      _id
      name
      type
      propertyId
      buildingId
      floorId
      cuid
      systemNotifications {
        _id
        message
        acknowledgedAt
        requireAcknowledgement
        seenAt
      }
    }
    plmEventResponses(limit: 0) {
      _id
      eventId
      propertyId
      curtailmentPlanId
      scheduledStart
      scheduledEnd
      actualStart
      actualEnd
      responseSentAt
      responseStatus
      createdAt
      updatedAt
      event {
        _id
        programId
        contractId
        startTime
        duration
        reductionTarget
        status
        notificationMethod
        notificationReceivedAt
        notificationPayload
        program {
          _id
          programId
          name
          partnerId
          season
          startDate
          endDate
          notificationLeadTimeMinutes
          maximumNotificationLeadTimeMinutes
          minimumEventDurationMinutes
          maximumEventDurationMinutes
          minimumEventsPerSeason
          maximumEventsPerSeason
          measurementIntervalMinutes
          participationType
          incentiveDescription
          partner {
            _id
            name
            description
          }
        }
        contract {
          _id
          name
          contractId
          programId
          propertyIds
          partnerId
          dispatcherIds
          minimumReductionKW
          maximumEventsPerSeason
          baselineMethod
          incentiveDescription
          penaltyForNonCompliance
          status
          notificationEmail
        }
      }
      curtailmentPlan {
        _id
        name
        description
        estimatedReductionKW
        durationMinutes
        applicableSeasons
        organizationId
      }
    }
  }
`;

/**
 * __useManagedEntitiesQuery__
 *
 * To run a query within a React component, call `useManagedEntitiesQuery` and pass it any options that fit your needs.
 * When your component renders, `useManagedEntitiesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useManagedEntitiesQuery({
 *   variables: {
 *   },
 * });
 */
export function useManagedEntitiesQuery(
  baseOptions?: Apollo.QueryHookOptions<
    ManagedEntitiesQuery,
    ManagedEntitiesQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<ManagedEntitiesQuery, ManagedEntitiesQueryVariables>(
    ManagedEntitiesDocument,
    options,
  );
}
export function useManagedEntitiesLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    ManagedEntitiesQuery,
    ManagedEntitiesQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    ManagedEntitiesQuery,
    ManagedEntitiesQueryVariables
  >(ManagedEntitiesDocument, options);
}
export type ManagedEntitiesQueryHookResult = ReturnType<
  typeof useManagedEntitiesQuery
>;
export type ManagedEntitiesLazyQueryHookResult = ReturnType<
  typeof useManagedEntitiesLazyQuery
>;
export type ManagedEntitiesQueryResult = Apollo.QueryResult<
  ManagedEntitiesQuery,
  ManagedEntitiesQueryVariables
>;
export const SystemCommandPostedDocument = gql`
  subscription SystemCommandPosted {
    systemCommandPosted {
      timestamp
      directive
      message
    }
  }
`;

/**
 * __useSystemCommandPostedSubscription__
 *
 * To run a query within a React component, call `useSystemCommandPostedSubscription` and pass it any options that fit your needs.
 * When your component renders, `useSystemCommandPostedSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSystemCommandPostedSubscription({
 *   variables: {
 *   },
 * });
 */
export function useSystemCommandPostedSubscription(
  baseOptions?: Apollo.SubscriptionHookOptions<
    SystemCommandPostedSubscription,
    SystemCommandPostedSubscriptionVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useSubscription<
    SystemCommandPostedSubscription,
    SystemCommandPostedSubscriptionVariables
  >(SystemCommandPostedDocument, options);
}
export type SystemCommandPostedSubscriptionHookResult = ReturnType<
  typeof useSystemCommandPostedSubscription
>;
export type SystemCommandPostedSubscriptionResult =
  Apollo.SubscriptionResult<SystemCommandPostedSubscription>;
export const SystemMessagePostedDocument = gql`
  subscription SystemMessagePosted($types: [SystemMessageType]) {
    systemMessagePosted(types: $types) {
      timestamp
      message
      type
    }
  }
`;

/**
 * __useSystemMessagePostedSubscription__
 *
 * To run a query within a React component, call `useSystemMessagePostedSubscription` and pass it any options that fit your needs.
 * When your component renders, `useSystemMessagePostedSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSystemMessagePostedSubscription({
 *   variables: {
 *      types: // value for 'types'
 *   },
 * });
 */
export function useSystemMessagePostedSubscription(
  baseOptions?: Apollo.SubscriptionHookOptions<
    SystemMessagePostedSubscription,
    SystemMessagePostedSubscriptionVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useSubscription<
    SystemMessagePostedSubscription,
    SystemMessagePostedSubscriptionVariables
  >(SystemMessagePostedDocument, options);
}
export type SystemMessagePostedSubscriptionHookResult = ReturnType<
  typeof useSystemMessagePostedSubscription
>;
export type SystemMessagePostedSubscriptionResult =
  Apollo.SubscriptionResult<SystemMessagePostedSubscription>;
export const ChartDataDocument = gql`
  query ChartData(
    $startDate: String!
    $endDate: String!
    $deviceIds: [String!]!
    $chartTypes: [ChartType!]!
  ) {
    chartData(
      startDate: $startDate
      endDate: $endDate
      deviceIds: $deviceIds
      chartTypes: $chartTypes
    ) {
      chartType
      visType
      series {
        __typename
        readingType
        deviceId
        units
        ... on NumericChartSeries {
          numericData: data {
            timestamp
            value
          }
        }
        ... on CategoricalChartSeries {
          categoricalData: data {
            timestamp
            value
          }
          distinctValues
        }
        ... on AggregateCategoricalChartSeries {
          aggregateCategoricalData: data {
            timestamp
            values
          }
          distinctValues
          aggregateInterval
        }
      }
    }
  }
`;

/**
 * __useChartDataQuery__
 *
 * To run a query within a React component, call `useChartDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useChartDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useChartDataQuery({
 *   variables: {
 *      startDate: // value for 'startDate'
 *      endDate: // value for 'endDate'
 *      deviceIds: // value for 'deviceIds'
 *      chartTypes: // value for 'chartTypes'
 *   },
 * });
 */
export function useChartDataQuery(
  baseOptions: Apollo.QueryHookOptions<ChartDataQuery, ChartDataQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<ChartDataQuery, ChartDataQueryVariables>(
    ChartDataDocument,
    options,
  );
}
export function useChartDataLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    ChartDataQuery,
    ChartDataQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<ChartDataQuery, ChartDataQueryVariables>(
    ChartDataDocument,
    options,
  );
}
export type ChartDataQueryHookResult = ReturnType<typeof useChartDataQuery>;
export type ChartDataLazyQueryHookResult = ReturnType<
  typeof useChartDataLazyQuery
>;
export type ChartDataQueryResult = Apollo.QueryResult<
  ChartDataQuery,
  ChartDataQueryVariables
>;
export const CreateUnitDocument = gql`
  mutation CreateUnit($unit: CreateOneUnitInput!) {
    createUnit(unit: $unit) {
      _id
    }
  }
`;
export type CreateUnitMutationFn = Apollo.MutationFunction<
  CreateUnitMutation,
  CreateUnitMutationVariables
>;

/**
 * __useCreateUnitMutation__
 *
 * To run a mutation, you first call `useCreateUnitMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateUnitMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createUnitMutation, { data, loading, error }] = useCreateUnitMutation({
 *   variables: {
 *      unit: // value for 'unit'
 *   },
 * });
 */
export function useCreateUnitMutation(
  baseOptions?: Apollo.MutationHookOptions<
    CreateUnitMutation,
    CreateUnitMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<CreateUnitMutation, CreateUnitMutationVariables>(
    CreateUnitDocument,
    options,
  );
}
export type CreateUnitMutationHookResult = ReturnType<
  typeof useCreateUnitMutation
>;
export type CreateUnitMutationResult =
  Apollo.MutationResult<CreateUnitMutation>;
export type CreateUnitMutationOptions = Apollo.BaseMutationOptions<
  CreateUnitMutation,
  CreateUnitMutationVariables
>;
export const PropertyDataForUnitDocument = gql`
  query PropertyDataForUnit($id: String!) {
    propertyById(_id: $id) {
      _id
      title
      setpointProfileId
      buildings {
        _id
        name
        units {
          _id
          name
        }
      }
      sources {
        _id
        name
      }
    }
  }
`;

/**
 * __usePropertyDataForUnitQuery__
 *
 * To run a query within a React component, call `usePropertyDataForUnitQuery` and pass it any options that fit your needs.
 * When your component renders, `usePropertyDataForUnitQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePropertyDataForUnitQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function usePropertyDataForUnitQuery(
  baseOptions: Apollo.QueryHookOptions<
    PropertyDataForUnitQuery,
    PropertyDataForUnitQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    PropertyDataForUnitQuery,
    PropertyDataForUnitQueryVariables
  >(PropertyDataForUnitDocument, options);
}
export function usePropertyDataForUnitLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    PropertyDataForUnitQuery,
    PropertyDataForUnitQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    PropertyDataForUnitQuery,
    PropertyDataForUnitQueryVariables
  >(PropertyDataForUnitDocument, options);
}
export type PropertyDataForUnitQueryHookResult = ReturnType<
  typeof usePropertyDataForUnitQuery
>;
export type PropertyDataForUnitLazyQueryHookResult = ReturnType<
  typeof usePropertyDataForUnitLazyQuery
>;
export type PropertyDataForUnitQueryResult = Apollo.QueryResult<
  PropertyDataForUnitQuery,
  PropertyDataForUnitQueryVariables
>;
export const UnitAndPropertyBasicsDocument = gql`
  query UnitAndPropertyBasics($id: String!) {
    unitById(_id: $id) {
      _id
      name
      type
      propertyId
      property {
        _id
        title
      }
    }
  }
`;

/**
 * __useUnitAndPropertyBasicsQuery__
 *
 * To run a query within a React component, call `useUnitAndPropertyBasicsQuery` and pass it any options that fit your needs.
 * When your component renders, `useUnitAndPropertyBasicsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUnitAndPropertyBasicsQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useUnitAndPropertyBasicsQuery(
  baseOptions: Apollo.QueryHookOptions<
    UnitAndPropertyBasicsQuery,
    UnitAndPropertyBasicsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    UnitAndPropertyBasicsQuery,
    UnitAndPropertyBasicsQueryVariables
  >(UnitAndPropertyBasicsDocument, options);
}
export function useUnitAndPropertyBasicsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    UnitAndPropertyBasicsQuery,
    UnitAndPropertyBasicsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    UnitAndPropertyBasicsQuery,
    UnitAndPropertyBasicsQueryVariables
  >(UnitAndPropertyBasicsDocument, options);
}
export type UnitAndPropertyBasicsQueryHookResult = ReturnType<
  typeof useUnitAndPropertyBasicsQuery
>;
export type UnitAndPropertyBasicsLazyQueryHookResult = ReturnType<
  typeof useUnitAndPropertyBasicsLazyQuery
>;
export type UnitAndPropertyBasicsQueryResult = Apollo.QueryResult<
  UnitAndPropertyBasicsQuery,
  UnitAndPropertyBasicsQueryVariables
>;
export const UnitDetailUpdateDocument = gql`
  subscription unitDetailUpdate($ids: [String!]!) {
    unitEventsByIds(_ids: $ids) {
      modelChangeOperation
      _id
      name
      propertyId
      separatePowerThermostatIds
      devicesSummary {
        count
        majorAlerts
        minorAlerts
        proxy {
          type
          coolSetpoint
          heatSetpoint
          humidity
          isOffline
          operatingMode
          operatingState
          setpointCoolMin
          setpointHeatMax
          setpointProfileName
          setpointProfileType
          temperature
          __typename
        }
      }
      zones {
        _id
        __typename
        sourceId
        name
        controller
        thermostatId
        pairedSensorId
        role
        devices {
          _id
          deviceId
          sourceId
          name
          type
          typeDisplayName
          __typename
          isConfigured
          timestamp
          isPoweredOn
          powerState {
            value
            timestamp
          }
        }
      }
      panels(limit: 100) {
        _id
        __typename
        sourceId
        name
        displayName
        type
        role
        devices {
          _id
          deviceId
          sourceId
          name
          type
          typeDisplayName
          __typename
          isConfigured
          timestamp
          isPoweredOn
          powerState {
            value
            timestamp
          }
          ... on VSDPump {
            role
          }
          ... on Z210Pump {
            role
          }
          ... on Thermistor {
            role
          }
          ... on PressureSensor {
            role
          }
        }
      }
      vpps {
        _id
        __typename
        name
        devices {
          _id
          deviceId
          sourceId
          name
          type
          typeDisplayName
          __typename
          isConfigured
          meta {
            model
          }
        }
      }
      controlGroups {
        _id
        name
        type
        automationEnabled
        masterDeviceId
        masterDevice {
          _id
          deviceId
          type
        }
        attributes
        devices {
          _id
          deviceId
          type
        }
        deviceDetails
      }
      setpointProfileId
      setpointLimitProfile {
        heat {
          max
          min
        }
        cool {
          max
          min
        }
      }
      propertyId
      property {
        _id
        setpointProfileId
        setpointLimitProfile {
          heat {
            min
            max
          }
          cool {
            min
            max
          }
        }
      }
    }
  }
`;

/**
 * __useUnitDetailUpdateSubscription__
 *
 * To run a query within a React component, call `useUnitDetailUpdateSubscription` and pass it any options that fit your needs.
 * When your component renders, `useUnitDetailUpdateSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUnitDetailUpdateSubscription({
 *   variables: {
 *      ids: // value for 'ids'
 *   },
 * });
 */
export function useUnitDetailUpdateSubscription(
  baseOptions: Apollo.SubscriptionHookOptions<
    UnitDetailUpdateSubscription,
    UnitDetailUpdateSubscriptionVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useSubscription<
    UnitDetailUpdateSubscription,
    UnitDetailUpdateSubscriptionVariables
  >(UnitDetailUpdateDocument, options);
}
export type UnitDetailUpdateSubscriptionHookResult = ReturnType<
  typeof useUnitDetailUpdateSubscription
>;
export type UnitDetailUpdateSubscriptionResult =
  Apollo.SubscriptionResult<UnitDetailUpdateSubscription>;
export const UnitDetailDocument = gql`
  query unitDetail($id: String!) {
    unitById(_id: $id) {
      _id
      name
      propertyId
      type
      separatePowerThermostatIds
      building {
        name
      }
      devicesSummary {
        count
        majorAlerts
        minorAlerts
        proxy {
          type
          coolSetpoint
          heatSetpoint
          humidity
          isOffline
          operatingMode
          operatingState
          setpointCoolMin
          setpointHeatMax
          setpointProfileName
          setpointProfileType
          temperature
          __typename
        }
      }
      zones {
        _id
        __typename
        sourceId
        name
        controller
        thermostatId
        pairedSensorId
        role
        devices {
          _id
          deviceId
          sourceId
          name
          type
          typeDisplayName
          __typename
          isConfigured
          alertTypes {
            deviceOffline
            sourceOffline
          }
          zone {
            _id
            name
            sourceId
          }
          timestamp
          isPoweredOn
          powerState {
            value
            timestamp
          }
          installation {
            status
            count
            message
            paired
            pairedTo
            previousStatus
            rawDeviceId
            replacingDeviceId
          }
          meta {
            modelNumber
            version
          }
          ... on Thermostat {
            isPairingActive
          }
        }
      }
      panels(limit: 100) {
        _id
        __typename
        name
        displayName
        type
        role
        sourceId
        devices {
          _id
          deviceId
          sourceId
          name
          type
          typeDisplayName
          __typename
          isConfigured
          alertTypes {
            deviceOffline
            sourceOffline
          }
          timestamp
          isPoweredOn
          powerState {
            value
            timestamp
          }
          panel {
            _id
            name
            sourceId
          }
          meta {
            model
          }
          ... on VSDPump {
            role
          }
          ... on Z210Pump {
            role
          }
          ... on Thermistor {
            role
          }
          ... on PressureSensor {
            role
          }
        }
      }
      vpps {
        _id
        __typename
        propertyId
        sourceId
        name
        devices {
          _id
          sourceId
          deviceId
          sourceId
          name
          type
          typeDisplayName
          __typename
          isConfigured
          meta {
            model
          }
        }
      }
      controlGroups {
        _id
        name
        type
        automationEnabled
        masterDeviceId
        masterDevice {
          _id
          deviceId
          type
        }
        attributes
        devices {
          _id
          deviceId
          type
        }
        deviceDetails
      }
      thermostatScheduleTemplateId
      setpointProfileId
      setpointLimitProfile {
        heat {
          max
          min
        }
        cool {
          max
          min
        }
      }
      propertyId
      property {
        _id
        setpointProfileId
        setpointLimitProfile {
          heat {
            min
            max
          }
          cool {
            min
            max
          }
        }
      }
    }
  }
`;

/**
 * __useUnitDetailQuery__
 *
 * To run a query within a React component, call `useUnitDetailQuery` and pass it any options that fit your needs.
 * When your component renders, `useUnitDetailQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUnitDetailQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useUnitDetailQuery(
  baseOptions: Apollo.QueryHookOptions<
    UnitDetailQuery,
    UnitDetailQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<UnitDetailQuery, UnitDetailQueryVariables>(
    UnitDetailDocument,
    options,
  );
}
export function useUnitDetailLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    UnitDetailQuery,
    UnitDetailQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<UnitDetailQuery, UnitDetailQueryVariables>(
    UnitDetailDocument,
    options,
  );
}
export type UnitDetailQueryHookResult = ReturnType<typeof useUnitDetailQuery>;
export type UnitDetailLazyQueryHookResult = ReturnType<
  typeof useUnitDetailLazyQuery
>;
export type UnitDetailQueryResult = Apollo.QueryResult<
  UnitDetailQuery,
  UnitDetailQueryVariables
>;
export const UnitDetailBreadcrumbDocument = gql`
  query UnitDetailBreadcrumb($_id: String!) {
    unitById(_id: $_id) {
      name
    }
  }
`;

/**
 * __useUnitDetailBreadcrumbQuery__
 *
 * To run a query within a React component, call `useUnitDetailBreadcrumbQuery` and pass it any options that fit your needs.
 * When your component renders, `useUnitDetailBreadcrumbQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUnitDetailBreadcrumbQuery({
 *   variables: {
 *      _id: // value for '_id'
 *   },
 * });
 */
export function useUnitDetailBreadcrumbQuery(
  baseOptions: Apollo.QueryHookOptions<
    UnitDetailBreadcrumbQuery,
    UnitDetailBreadcrumbQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    UnitDetailBreadcrumbQuery,
    UnitDetailBreadcrumbQueryVariables
  >(UnitDetailBreadcrumbDocument, options);
}
export function useUnitDetailBreadcrumbLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    UnitDetailBreadcrumbQuery,
    UnitDetailBreadcrumbQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    UnitDetailBreadcrumbQuery,
    UnitDetailBreadcrumbQueryVariables
  >(UnitDetailBreadcrumbDocument, options);
}
export type UnitDetailBreadcrumbQueryHookResult = ReturnType<
  typeof useUnitDetailBreadcrumbQuery
>;
export type UnitDetailBreadcrumbLazyQueryHookResult = ReturnType<
  typeof useUnitDetailBreadcrumbLazyQuery
>;
export type UnitDetailBreadcrumbQueryResult = Apollo.QueryResult<
  UnitDetailBreadcrumbQuery,
  UnitDetailBreadcrumbQueryVariables
>;
export const UnitDetailEditDocument = gql`
  query unitDetailEdit($uid: String!) {
    unitById(_id: $uid) {
      _id
      name
      type
      buildingId
      sourceId
      setpointProfileId
      zonePolicyId
      thermostatScheduleTemplateId
      property {
        setpointProfileId
        zonePolicyId
      }
      building {
        name
      }
      assignableSetpointProfiles {
        _id
        name
        heat {
          max
          min
        }
        cool {
          max
          min
        }
      }
      assignableZonePolicies {
        _id
        name
        properties
        rules {
          type
          source {
            deviceType
            multiplicity
            attributes {
              operatingMode
              operatingState
              heatSetpoint
              coolSetpoint
              contactState
              fanSpeed
              indoorFanStatus
              keypadLockoutLevel
            }
          }
          target {
            deviceType
            multiplicity
            attributes {
              heatSetpoint
              coolSetpoint
              isOn
              keypadLockoutLevel
            }
          }
        }
      }
      resident {
        name
        email
        phone
        mobile
      }
    }
  }
`;

/**
 * __useUnitDetailEditQuery__
 *
 * To run a query within a React component, call `useUnitDetailEditQuery` and pass it any options that fit your needs.
 * When your component renders, `useUnitDetailEditQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUnitDetailEditQuery({
 *   variables: {
 *      uid: // value for 'uid'
 *   },
 * });
 */
export function useUnitDetailEditQuery(
  baseOptions: Apollo.QueryHookOptions<
    UnitDetailEditQuery,
    UnitDetailEditQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<UnitDetailEditQuery, UnitDetailEditQueryVariables>(
    UnitDetailEditDocument,
    options,
  );
}
export function useUnitDetailEditLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    UnitDetailEditQuery,
    UnitDetailEditQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<UnitDetailEditQuery, UnitDetailEditQueryVariables>(
    UnitDetailEditDocument,
    options,
  );
}
export type UnitDetailEditQueryHookResult = ReturnType<
  typeof useUnitDetailEditQuery
>;
export type UnitDetailEditLazyQueryHookResult = ReturnType<
  typeof useUnitDetailEditLazyQuery
>;
export type UnitDetailEditQueryResult = Apollo.QueryResult<
  UnitDetailEditQuery,
  UnitDetailEditQueryVariables
>;
export const UnitDevicesDocument = gql`
  query UnitDevices($unitId: String!) {
    devices(filter: { unitId: $unitId }) {
      __typename
      deviceId
      name
      type
      typeDisplayName
      isConfigured
      meta {
        name
      }
      zoneId
      panelId
      vppId
      chartTypes
      alertTypes {
        deviceOffline
        sourceOffline
      }
      ... on Boiler {
        role
      }
      ... on Loop {
        role
      }
      ... on VSDPump {
        role
      }
      ... on Thermistor {
        role
      }
      ... on PressureSensor {
        role
      }
      ... on GPIO {
        displayName
      }
      ... on LeakDetector {
        displayName
      }
    }
    unitById(_id: $unitId) {
      _id
      name
      zones {
        _id
        name
        role
        displayName
      }
      panels(limit: 100) {
        _id
        name
        role
        type
        displayName
      }
      controlGroups {
        _id
        name
        type
        automationEnabled
        masterDeviceId
        masterDevice {
          _id
          deviceId
          type
        }
        attributes
        devices {
          _id
          deviceId
          type
        }
        deviceDetails
      }
    }
  }
`;

/**
 * __useUnitDevicesQuery__
 *
 * To run a query within a React component, call `useUnitDevicesQuery` and pass it any options that fit your needs.
 * When your component renders, `useUnitDevicesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUnitDevicesQuery({
 *   variables: {
 *      unitId: // value for 'unitId'
 *   },
 * });
 */
export function useUnitDevicesQuery(
  baseOptions: Apollo.QueryHookOptions<
    UnitDevicesQuery,
    UnitDevicesQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<UnitDevicesQuery, UnitDevicesQueryVariables>(
    UnitDevicesDocument,
    options,
  );
}
export function useUnitDevicesLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    UnitDevicesQuery,
    UnitDevicesQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<UnitDevicesQuery, UnitDevicesQueryVariables>(
    UnitDevicesDocument,
    options,
  );
}
export type UnitDevicesQueryHookResult = ReturnType<typeof useUnitDevicesQuery>;
export type UnitDevicesLazyQueryHookResult = ReturnType<
  typeof useUnitDevicesLazyQuery
>;
export type UnitDevicesQueryResult = Apollo.QueryResult<
  UnitDevicesQuery,
  UnitDevicesQueryVariables
>;
export const UnitListByPropertyIdDocument = gql`
  query UnitListByPropertyId($propertyId: String) {
    unitsByPropertyId(propertyId: [$propertyId]) {
      _id
      name
      type
      buildingId
      floorId
      building {
        name
      }
      floor {
        name
      }
      isConnected
      hasAlerts
      hasResident
      temperature
      humidity
      coolSetpoint
      heatSetpoint
      setpoint
      operatingMode
      operatingState
      separatePowerThermostatIds
      panels {
        _id
        type
      }
      alertTypes {
        sourceOffline
        deviceAlert
        deviceMetric
        deviceOffline
      }
      devicesSummary {
        count
        majorAlerts
        minorAlerts
        proxy {
          coolSetpoint
          heatSetpoint
          humidity
          isOffline
          operatingMode
          operatingState
          setpointCoolMin
          setpointHeatMax
          setpointProfileName
          setpointProfileType
          temperature
          type
        }
      }
      devices(limit: 0) {
        _id
        type
        panelId
        sourceId
        deviceId
        installation {
          status
        }
        ... on Thermistor {
          role
          temperature {
            value
          }
        }
      }
    }
  }
`;

/**
 * __useUnitListByPropertyIdQuery__
 *
 * To run a query within a React component, call `useUnitListByPropertyIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useUnitListByPropertyIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUnitListByPropertyIdQuery({
 *   variables: {
 *      propertyId: // value for 'propertyId'
 *   },
 * });
 */
export function useUnitListByPropertyIdQuery(
  baseOptions?: Apollo.QueryHookOptions<
    UnitListByPropertyIdQuery,
    UnitListByPropertyIdQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    UnitListByPropertyIdQuery,
    UnitListByPropertyIdQueryVariables
  >(UnitListByPropertyIdDocument, options);
}
export function useUnitListByPropertyIdLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    UnitListByPropertyIdQuery,
    UnitListByPropertyIdQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    UnitListByPropertyIdQuery,
    UnitListByPropertyIdQueryVariables
  >(UnitListByPropertyIdDocument, options);
}
export type UnitListByPropertyIdQueryHookResult = ReturnType<
  typeof useUnitListByPropertyIdQuery
>;
export type UnitListByPropertyIdLazyQueryHookResult = ReturnType<
  typeof useUnitListByPropertyIdLazyQuery
>;
export type UnitListByPropertyIdQueryResult = Apollo.QueryResult<
  UnitListByPropertyIdQuery,
  UnitListByPropertyIdQueryVariables
>;
export const UnitListBuildingLoopsDocument = gql`
  query UnitListBuildingLoops($propertyId: String!) {
    panels(filter: { propertyId: $propertyId, type: Loop, role: "Building" }) {
      _id
      type
      role
      unitId
      devices {
        _id
        deviceId
        __typename
        type
        ... on Thermistor {
          role
          temperature {
            value
          }
        }
      }
    }
  }
`;

/**
 * __useUnitListBuildingLoopsQuery__
 *
 * To run a query within a React component, call `useUnitListBuildingLoopsQuery` and pass it any options that fit your needs.
 * When your component renders, `useUnitListBuildingLoopsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUnitListBuildingLoopsQuery({
 *   variables: {
 *      propertyId: // value for 'propertyId'
 *   },
 * });
 */
export function useUnitListBuildingLoopsQuery(
  baseOptions: Apollo.QueryHookOptions<
    UnitListBuildingLoopsQuery,
    UnitListBuildingLoopsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    UnitListBuildingLoopsQuery,
    UnitListBuildingLoopsQueryVariables
  >(UnitListBuildingLoopsDocument, options);
}
export function useUnitListBuildingLoopsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    UnitListBuildingLoopsQuery,
    UnitListBuildingLoopsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    UnitListBuildingLoopsQuery,
    UnitListBuildingLoopsQueryVariables
  >(UnitListBuildingLoopsDocument, options);
}
export type UnitListBuildingLoopsQueryHookResult = ReturnType<
  typeof useUnitListBuildingLoopsQuery
>;
export type UnitListBuildingLoopsLazyQueryHookResult = ReturnType<
  typeof useUnitListBuildingLoopsLazyQuery
>;
export type UnitListBuildingLoopsQueryResult = Apollo.QueryResult<
  UnitListBuildingLoopsQuery,
  UnitListBuildingLoopsQueryVariables
>;
export const UnitListUpdateDocument = gql`
  subscription UnitListUpdate($propertyId: String!) {
    unitEventsByPropertyId(propertyId: [$propertyId]) {
      modelChangeOperation
      _id
      separatePowerThermostatIds
      devicesSummary {
        proxy {
          coolSetpoint
          heatSetpoint
          humidity
          setpointProfileName
        }
      }
      alertTypes {
        sourceOffline
        deviceMetric
        deviceOffline
        deviceAlert
        equipmentAlarm
      }
      hasAlerts
      name
      type
      hasResident
      temperature
      humidity
      coolSetpoint
      heatSetpoint
      setpoint
      operatingMode
      operatingState
    }
  }
`;

/**
 * __useUnitListUpdateSubscription__
 *
 * To run a query within a React component, call `useUnitListUpdateSubscription` and pass it any options that fit your needs.
 * When your component renders, `useUnitListUpdateSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUnitListUpdateSubscription({
 *   variables: {
 *      propertyId: // value for 'propertyId'
 *   },
 * });
 */
export function useUnitListUpdateSubscription(
  baseOptions: Apollo.SubscriptionHookOptions<
    UnitListUpdateSubscription,
    UnitListUpdateSubscriptionVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useSubscription<
    UnitListUpdateSubscription,
    UnitListUpdateSubscriptionVariables
  >(UnitListUpdateDocument, options);
}
export type UnitListUpdateSubscriptionHookResult = ReturnType<
  typeof useUnitListUpdateSubscription
>;
export type UnitListUpdateSubscriptionResult =
  Apollo.SubscriptionResult<UnitListUpdateSubscription>;
export const UnitPowerUpdateDocument = gql`
  subscription UnitPowerUpdate($ids: [String!]!) {
    thermostatEventsByIds(_ids: $ids, includeReady: true) {
      modelChangeOperation
      _id
      updateDescription
      powerState {
        value
      }
      operatingMode {
        value
      }
      operatingState {
        value
      }
      setpoint {
        value
      }
    }
  }
`;

/**
 * __useUnitPowerUpdateSubscription__
 *
 * To run a query within a React component, call `useUnitPowerUpdateSubscription` and pass it any options that fit your needs.
 * When your component renders, `useUnitPowerUpdateSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUnitPowerUpdateSubscription({
 *   variables: {
 *      ids: // value for 'ids'
 *   },
 * });
 */
export function useUnitPowerUpdateSubscription(
  baseOptions: Apollo.SubscriptionHookOptions<
    UnitPowerUpdateSubscription,
    UnitPowerUpdateSubscriptionVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useSubscription<
    UnitPowerUpdateSubscription,
    UnitPowerUpdateSubscriptionVariables
  >(UnitPowerUpdateDocument, options);
}
export type UnitPowerUpdateSubscriptionHookResult = ReturnType<
  typeof useUnitPowerUpdateSubscription
>;
export type UnitPowerUpdateSubscriptionResult =
  Apollo.SubscriptionResult<UnitPowerUpdateSubscription>;
export const UnitScheduleDetailUpdateDocument = gql`
  subscription UnitScheduleDetailUpdate($ids: [String!]) {
    unitEventsByIds(_ids: $ids) {
      _id
      name
      property {
        _id
        title
      }
      zones {
        _id
        name
        thermostat {
          name
          deviceId
          _id
          schedule {
            id
            timestamp
            value
          }
          pendingSchedule {
            id
            timestamp
            value
          }
          scheduleStatus
          scheduleType
          thermostatScheduleTemplateId
        }
      }
    }
  }
`;

/**
 * __useUnitScheduleDetailUpdateSubscription__
 *
 * To run a query within a React component, call `useUnitScheduleDetailUpdateSubscription` and pass it any options that fit your needs.
 * When your component renders, `useUnitScheduleDetailUpdateSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUnitScheduleDetailUpdateSubscription({
 *   variables: {
 *      ids: // value for 'ids'
 *   },
 * });
 */
export function useUnitScheduleDetailUpdateSubscription(
  baseOptions?: Apollo.SubscriptionHookOptions<
    UnitScheduleDetailUpdateSubscription,
    UnitScheduleDetailUpdateSubscriptionVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useSubscription<
    UnitScheduleDetailUpdateSubscription,
    UnitScheduleDetailUpdateSubscriptionVariables
  >(UnitScheduleDetailUpdateDocument, options);
}
export type UnitScheduleDetailUpdateSubscriptionHookResult = ReturnType<
  typeof useUnitScheduleDetailUpdateSubscription
>;
export type UnitScheduleDetailUpdateSubscriptionResult =
  Apollo.SubscriptionResult<UnitScheduleDetailUpdateSubscription>;
export const UnitScheduleDetailDocument = gql`
  query unitScheduleDetail($id: String!) {
    unitById(_id: $id) {
      _id
      name
      property {
        _id
        title
      }
      zones {
        _id
        name
        thermostat {
          name
          deviceId
          _id
          schedule {
            id
            timestamp
            value
          }
          pendingSchedule {
            id
            timestamp
            value
          }
          scheduleStatus
          scheduleType
          thermostatScheduleTemplateId
        }
      }
    }
  }
`;

/**
 * __useUnitScheduleDetailQuery__
 *
 * To run a query within a React component, call `useUnitScheduleDetailQuery` and pass it any options that fit your needs.
 * When your component renders, `useUnitScheduleDetailQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUnitScheduleDetailQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useUnitScheduleDetailQuery(
  baseOptions: Apollo.QueryHookOptions<
    UnitScheduleDetailQuery,
    UnitScheduleDetailQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    UnitScheduleDetailQuery,
    UnitScheduleDetailQueryVariables
  >(UnitScheduleDetailDocument, options);
}
export function useUnitScheduleDetailLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    UnitScheduleDetailQuery,
    UnitScheduleDetailQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    UnitScheduleDetailQuery,
    UnitScheduleDetailQueryVariables
  >(UnitScheduleDetailDocument, options);
}
export type UnitScheduleDetailQueryHookResult = ReturnType<
  typeof useUnitScheduleDetailQuery
>;
export type UnitScheduleDetailLazyQueryHookResult = ReturnType<
  typeof useUnitScheduleDetailLazyQuery
>;
export type UnitScheduleDetailQueryResult = Apollo.QueryResult<
  UnitScheduleDetailQuery,
  UnitScheduleDetailQueryVariables
>;
export const UpdateUnitDocument = gql`
  mutation UpdateUnit($id: String!, $unit: UpdateOneUnitInput!) {
    updateUnit(id: $id, unit: $unit) {
      _id
      name
      type
      buildingId
      sourceId
    }
  }
`;
export type UpdateUnitMutationFn = Apollo.MutationFunction<
  UpdateUnitMutation,
  UpdateUnitMutationVariables
>;

/**
 * __useUpdateUnitMutation__
 *
 * To run a mutation, you first call `useUpdateUnitMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateUnitMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateUnitMutation, { data, loading, error }] = useUpdateUnitMutation({
 *   variables: {
 *      id: // value for 'id'
 *      unit: // value for 'unit'
 *   },
 * });
 */
export function useUpdateUnitMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UpdateUnitMutation,
    UpdateUnitMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<UpdateUnitMutation, UpdateUnitMutationVariables>(
    UpdateUnitDocument,
    options,
  );
}
export type UpdateUnitMutationHookResult = ReturnType<
  typeof useUpdateUnitMutation
>;
export type UpdateUnitMutationResult =
  Apollo.MutationResult<UpdateUnitMutation>;
export type UpdateUnitMutationOptions = Apollo.BaseMutationOptions<
  UpdateUnitMutation,
  UpdateUnitMutationVariables
>;
export const UpdateDeviceHistoryDocument = gql`
  mutation UpdateDeviceHistory($userId: String!, $history: JSON!) {
    updateDeviceHistory(userId: $userId, history: $history) {
      _id
      currentIndex
      lastAccessedAt
    }
  }
`;
export type UpdateDeviceHistoryMutationFn = Apollo.MutationFunction<
  UpdateDeviceHistoryMutation,
  UpdateDeviceHistoryMutationVariables
>;

/**
 * __useUpdateDeviceHistoryMutation__
 *
 * To run a mutation, you first call `useUpdateDeviceHistoryMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateDeviceHistoryMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateDeviceHistoryMutation, { data, loading, error }] = useUpdateDeviceHistoryMutation({
 *   variables: {
 *      userId: // value for 'userId'
 *      history: // value for 'history'
 *   },
 * });
 */
export function useUpdateDeviceHistoryMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UpdateDeviceHistoryMutation,
    UpdateDeviceHistoryMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    UpdateDeviceHistoryMutation,
    UpdateDeviceHistoryMutationVariables
  >(UpdateDeviceHistoryDocument, options);
}
export type UpdateDeviceHistoryMutationHookResult = ReturnType<
  typeof useUpdateDeviceHistoryMutation
>;
export type UpdateDeviceHistoryMutationResult =
  Apollo.MutationResult<UpdateDeviceHistoryMutation>;
export type UpdateDeviceHistoryMutationOptions = Apollo.BaseMutationOptions<
  UpdateDeviceHistoryMutation,
  UpdateDeviceHistoryMutationVariables
>;
export const GetUserAbilitiesDocument = gql`
  query GetUserAbilities {
    userAbilities {
      rules {
        action
        subject
        conditions
        inverted
        reason
      }
    }
  }
`;

/**
 * __useGetUserAbilitiesQuery__
 *
 * To run a query within a React component, call `useGetUserAbilitiesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUserAbilitiesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUserAbilitiesQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetUserAbilitiesQuery(
  baseOptions?: Apollo.QueryHookOptions<
    GetUserAbilitiesQuery,
    GetUserAbilitiesQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetUserAbilitiesQuery, GetUserAbilitiesQueryVariables>(
    GetUserAbilitiesDocument,
    options,
  );
}
export function useGetUserAbilitiesLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetUserAbilitiesQuery,
    GetUserAbilitiesQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetUserAbilitiesQuery,
    GetUserAbilitiesQueryVariables
  >(GetUserAbilitiesDocument, options);
}
export type GetUserAbilitiesQueryHookResult = ReturnType<
  typeof useGetUserAbilitiesQuery
>;
export type GetUserAbilitiesLazyQueryHookResult = ReturnType<
  typeof useGetUserAbilitiesLazyQuery
>;
export type GetUserAbilitiesQueryResult = Apollo.QueryResult<
  GetUserAbilitiesQuery,
  GetUserAbilitiesQueryVariables
>;
export const CreateUserApiTokenDocument = gql`
  mutation CreateUserApiToken($userId: String!) {
    createUserApiKey(userId: $userId) {
      _id
      name
      email
      authorizationProfile {
        _id
        isSuper
        isManager
        isResident
        isInstaller
        isViewer
        managerProperties
        residentUnit
        residentProperty
        installerProperties
        viewerProperties
        apiToken
      }
    }
  }
`;
export type CreateUserApiTokenMutationFn = Apollo.MutationFunction<
  CreateUserApiTokenMutation,
  CreateUserApiTokenMutationVariables
>;

/**
 * __useCreateUserApiTokenMutation__
 *
 * To run a mutation, you first call `useCreateUserApiTokenMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateUserApiTokenMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createUserApiTokenMutation, { data, loading, error }] = useCreateUserApiTokenMutation({
 *   variables: {
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useCreateUserApiTokenMutation(
  baseOptions?: Apollo.MutationHookOptions<
    CreateUserApiTokenMutation,
    CreateUserApiTokenMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    CreateUserApiTokenMutation,
    CreateUserApiTokenMutationVariables
  >(CreateUserApiTokenDocument, options);
}
export type CreateUserApiTokenMutationHookResult = ReturnType<
  typeof useCreateUserApiTokenMutation
>;
export type CreateUserApiTokenMutationResult =
  Apollo.MutationResult<CreateUserApiTokenMutation>;
export type CreateUserApiTokenMutationOptions = Apollo.BaseMutationOptions<
  CreateUserApiTokenMutation,
  CreateUserApiTokenMutationVariables
>;
export const CreateUserDocument = gql`
  mutation CreateUser(
    $user: CreateOneUserInput!
    $profile: CreateOneAuthorizationProfileInput!
  ) {
    createUser(user: $user, authorizationProfile: $profile) {
      _id
      name
      email
      authorizationProfile {
        _id
        isSuper
        isManager
        isResident
        isInstaller
        isViewer
        managerProperties
        residentUnit
        residentProperty
        installerProperties
        viewerProperties
        apiToken
      }
    }
  }
`;
export type CreateUserMutationFn = Apollo.MutationFunction<
  CreateUserMutation,
  CreateUserMutationVariables
>;

/**
 * __useCreateUserMutation__
 *
 * To run a mutation, you first call `useCreateUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createUserMutation, { data, loading, error }] = useCreateUserMutation({
 *   variables: {
 *      user: // value for 'user'
 *      profile: // value for 'profile'
 *   },
 * });
 */
export function useCreateUserMutation(
  baseOptions?: Apollo.MutationHookOptions<
    CreateUserMutation,
    CreateUserMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<CreateUserMutation, CreateUserMutationVariables>(
    CreateUserDocument,
    options,
  );
}
export type CreateUserMutationHookResult = ReturnType<
  typeof useCreateUserMutation
>;
export type CreateUserMutationResult =
  Apollo.MutationResult<CreateUserMutation>;
export type CreateUserMutationOptions = Apollo.BaseMutationOptions<
  CreateUserMutation,
  CreateUserMutationVariables
>;
export const RemoveUserDocument = gql`
  mutation RemoveUser($userId: String!) {
    removeUser(userId: $userId)
  }
`;
export type RemoveUserMutationFn = Apollo.MutationFunction<
  RemoveUserMutation,
  RemoveUserMutationVariables
>;

/**
 * __useRemoveUserMutation__
 *
 * To run a mutation, you first call `useRemoveUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeUserMutation, { data, loading, error }] = useRemoveUserMutation({
 *   variables: {
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useRemoveUserMutation(
  baseOptions?: Apollo.MutationHookOptions<
    RemoveUserMutation,
    RemoveUserMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<RemoveUserMutation, RemoveUserMutationVariables>(
    RemoveUserDocument,
    options,
  );
}
export type RemoveUserMutationHookResult = ReturnType<
  typeof useRemoveUserMutation
>;
export type RemoveUserMutationResult =
  Apollo.MutationResult<RemoveUserMutation>;
export type RemoveUserMutationOptions = Apollo.BaseMutationOptions<
  RemoveUserMutation,
  RemoveUserMutationVariables
>;
export const RevokeUserApiTokenDocument = gql`
  mutation RevokeUserApiToken($userId: String!) {
    revokeUserApiKey(userId: $userId) {
      _id
      name
      email
      authorizationProfile {
        _id
        isSuper
        isManager
        isResident
        isInstaller
        isViewer
        managerProperties
        residentUnit
        residentProperty
        installerProperties
        viewerProperties
        apiToken
      }
    }
  }
`;
export type RevokeUserApiTokenMutationFn = Apollo.MutationFunction<
  RevokeUserApiTokenMutation,
  RevokeUserApiTokenMutationVariables
>;

/**
 * __useRevokeUserApiTokenMutation__
 *
 * To run a mutation, you first call `useRevokeUserApiTokenMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRevokeUserApiTokenMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [revokeUserApiTokenMutation, { data, loading, error }] = useRevokeUserApiTokenMutation({
 *   variables: {
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useRevokeUserApiTokenMutation(
  baseOptions?: Apollo.MutationHookOptions<
    RevokeUserApiTokenMutation,
    RevokeUserApiTokenMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    RevokeUserApiTokenMutation,
    RevokeUserApiTokenMutationVariables
  >(RevokeUserApiTokenDocument, options);
}
export type RevokeUserApiTokenMutationHookResult = ReturnType<
  typeof useRevokeUserApiTokenMutation
>;
export type RevokeUserApiTokenMutationResult =
  Apollo.MutationResult<RevokeUserApiTokenMutation>;
export type RevokeUserApiTokenMutationOptions = Apollo.BaseMutationOptions<
  RevokeUserApiTokenMutation,
  RevokeUserApiTokenMutationVariables
>;
export const UnlockUserDocument = gql`
  mutation UnlockUser($userId: String!) {
    unlockUser(userId: $userId)
  }
`;
export type UnlockUserMutationFn = Apollo.MutationFunction<
  UnlockUserMutation,
  UnlockUserMutationVariables
>;

/**
 * __useUnlockUserMutation__
 *
 * To run a mutation, you first call `useUnlockUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUnlockUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [unlockUserMutation, { data, loading, error }] = useUnlockUserMutation({
 *   variables: {
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useUnlockUserMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UnlockUserMutation,
    UnlockUserMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<UnlockUserMutation, UnlockUserMutationVariables>(
    UnlockUserDocument,
    options,
  );
}
export type UnlockUserMutationHookResult = ReturnType<
  typeof useUnlockUserMutation
>;
export type UnlockUserMutationResult =
  Apollo.MutationResult<UnlockUserMutation>;
export type UnlockUserMutationOptions = Apollo.BaseMutationOptions<
  UnlockUserMutation,
  UnlockUserMutationVariables
>;
export const UpdateUserDocument = gql`
  mutation UpdateUser(
    $userId: String!
    $user: UpdateOneUserInput!
    $profile: UpdateOneAuthorizationProfileInput
  ) {
    updateUser(userId: $userId, user: $user, authorizationProfile: $profile) {
      _id
      name
      email
      preferredUnits
      preferredAirFlowUnits
      authorizationProfile {
        _id
        isSuper
        isManager
        isResident
        isInstaller
        isViewer
        managerProperties
        residentUnit
        residentProperty
        installerProperties
        viewerProperties
        apiToken
      }
    }
  }
`;
export type UpdateUserMutationFn = Apollo.MutationFunction<
  UpdateUserMutation,
  UpdateUserMutationVariables
>;

/**
 * __useUpdateUserMutation__
 *
 * To run a mutation, you first call `useUpdateUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateUserMutation, { data, loading, error }] = useUpdateUserMutation({
 *   variables: {
 *      userId: // value for 'userId'
 *      user: // value for 'user'
 *      profile: // value for 'profile'
 *   },
 * });
 */
export function useUpdateUserMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UpdateUserMutation,
    UpdateUserMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<UpdateUserMutation, UpdateUserMutationVariables>(
    UpdateUserDocument,
    options,
  );
}
export type UpdateUserMutationHookResult = ReturnType<
  typeof useUpdateUserMutation
>;
export type UpdateUserMutationResult =
  Apollo.MutationResult<UpdateUserMutation>;
export type UpdateUserMutationOptions = Apollo.BaseMutationOptions<
  UpdateUserMutation,
  UpdateUserMutationVariables
>;
export const UpdateUserIdentificationDocument = gql`
  mutation UpdateUserIdentification(
    $userId: String!
    $name: String!
    $email: String!
    $mobile: String!
    $preferredUnits: TemperatureUnit!
    $preferredAirFlowUnits: AirFlowUnit!
  ) {
    updateUserIdentification(
      userId: $userId
      name: $name
      email: $email
      mobile: $mobile
      preferredUnits: $preferredUnits
      preferredAirFlowUnits: $preferredAirFlowUnits
    ) {
      _id
      name
      email
      mobile
      preferredUnits
      preferredAirFlowUnits
      authorizationProfile {
        _id
        apiToken
      }
      profile {
        mobile
        preferredUnits
        preferredAirFlowUnits
        smsOptInStatusTimestamp
        smsOptInStatus
      }
      editableAuthenticationProfile {
        _id
        factors {
          _id
          externalId
          type
          credentialBoundTo
          name
          value
          preferred
          primary
          sufficient
          order
        }
      }
    }
  }
`;
export type UpdateUserIdentificationMutationFn = Apollo.MutationFunction<
  UpdateUserIdentificationMutation,
  UpdateUserIdentificationMutationVariables
>;

/**
 * __useUpdateUserIdentificationMutation__
 *
 * To run a mutation, you first call `useUpdateUserIdentificationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateUserIdentificationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateUserIdentificationMutation, { data, loading, error }] = useUpdateUserIdentificationMutation({
 *   variables: {
 *      userId: // value for 'userId'
 *      name: // value for 'name'
 *      email: // value for 'email'
 *      mobile: // value for 'mobile'
 *      preferredUnits: // value for 'preferredUnits'
 *      preferredAirFlowUnits: // value for 'preferredAirFlowUnits'
 *   },
 * });
 */
export function useUpdateUserIdentificationMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UpdateUserIdentificationMutation,
    UpdateUserIdentificationMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    UpdateUserIdentificationMutation,
    UpdateUserIdentificationMutationVariables
  >(UpdateUserIdentificationDocument, options);
}
export type UpdateUserIdentificationMutationHookResult = ReturnType<
  typeof useUpdateUserIdentificationMutation
>;
export type UpdateUserIdentificationMutationResult =
  Apollo.MutationResult<UpdateUserIdentificationMutation>;
export type UpdateUserIdentificationMutationOptions =
  Apollo.BaseMutationOptions<
    UpdateUserIdentificationMutation,
    UpdateUserIdentificationMutationVariables
  >;
export const UserCountDocument = gql`
  query UserCount {
    userCount
  }
`;

/**
 * __useUserCountQuery__
 *
 * To run a query within a React component, call `useUserCountQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserCountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUserCountQuery({
 *   variables: {
 *   },
 * });
 */
export function useUserCountQuery(
  baseOptions?: Apollo.QueryHookOptions<
    UserCountQuery,
    UserCountQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<UserCountQuery, UserCountQueryVariables>(
    UserCountDocument,
    options,
  );
}
export function useUserCountLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    UserCountQuery,
    UserCountQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<UserCountQuery, UserCountQueryVariables>(
    UserCountDocument,
    options,
  );
}
export type UserCountQueryHookResult = ReturnType<typeof useUserCountQuery>;
export type UserCountLazyQueryHookResult = ReturnType<
  typeof useUserCountLazyQuery
>;
export type UserCountQueryResult = Apollo.QueryResult<
  UserCountQuery,
  UserCountQueryVariables
>;
export const UserDetailDocument = gql`
  query UserDetail($userId: String!) {
    userById(_id: $userId) {
      _id
      email
      mobile
      name
      state
      preferredUnits
      preferredAirFlowUnits
      smsOptInStatus
      smsOptInStatusTimestamp
      legacyAuthorizationProfile {
        _id
        isSuper
        isManager
        isResident
        isInstaller
        isViewer
        managerProperties
        installerProperties
        viewerProperties
        residentProperty
        residentUnit
        apiToken
      }
      editableAuthenticationProfile {
        _id
        userId
        lockedAt
        failedAttempts
      }
    }
  }
`;

/**
 * __useUserDetailQuery__
 *
 * To run a query within a React component, call `useUserDetailQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserDetailQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUserDetailQuery({
 *   variables: {
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useUserDetailQuery(
  baseOptions: Apollo.QueryHookOptions<
    UserDetailQuery,
    UserDetailQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<UserDetailQuery, UserDetailQueryVariables>(
    UserDetailDocument,
    options,
  );
}
export function useUserDetailLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    UserDetailQuery,
    UserDetailQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<UserDetailQuery, UserDetailQueryVariables>(
    UserDetailDocument,
    options,
  );
}
export type UserDetailQueryHookResult = ReturnType<typeof useUserDetailQuery>;
export type UserDetailLazyQueryHookResult = ReturnType<
  typeof useUserDetailLazyQuery
>;
export type UserDetailQueryResult = Apollo.QueryResult<
  UserDetailQuery,
  UserDetailQueryVariables
>;
export const UserDetailBreadcrumbDocument = gql`
  query UserDetailBreadcrumb($id: String!) {
    userById(_id: $id) {
      _id
      email
      name
      state
    }
  }
`;

/**
 * __useUserDetailBreadcrumbQuery__
 *
 * To run a query within a React component, call `useUserDetailBreadcrumbQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserDetailBreadcrumbQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUserDetailBreadcrumbQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useUserDetailBreadcrumbQuery(
  baseOptions: Apollo.QueryHookOptions<
    UserDetailBreadcrumbQuery,
    UserDetailBreadcrumbQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    UserDetailBreadcrumbQuery,
    UserDetailBreadcrumbQueryVariables
  >(UserDetailBreadcrumbDocument, options);
}
export function useUserDetailBreadcrumbLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    UserDetailBreadcrumbQuery,
    UserDetailBreadcrumbQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    UserDetailBreadcrumbQuery,
    UserDetailBreadcrumbQueryVariables
  >(UserDetailBreadcrumbDocument, options);
}
export type UserDetailBreadcrumbQueryHookResult = ReturnType<
  typeof useUserDetailBreadcrumbQuery
>;
export type UserDetailBreadcrumbLazyQueryHookResult = ReturnType<
  typeof useUserDetailBreadcrumbLazyQuery
>;
export type UserDetailBreadcrumbQueryResult = Apollo.QueryResult<
  UserDetailBreadcrumbQuery,
  UserDetailBreadcrumbQueryVariables
>;
export const UserListDocument = gql`
  query UserList {
    users(limit: 0) {
      _id
      email
      name
      state
      preferredUnits
      preferredAirFlowUnits
      authorizationProfile {
        _id
        apiToken
      }
    }
  }
`;

/**
 * __useUserListQuery__
 *
 * To run a query within a React component, call `useUserListQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUserListQuery({
 *   variables: {
 *   },
 * });
 */
export function useUserListQuery(
  baseOptions?: Apollo.QueryHookOptions<UserListQuery, UserListQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<UserListQuery, UserListQueryVariables>(
    UserListDocument,
    options,
  );
}
export function useUserListLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    UserListQuery,
    UserListQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<UserListQuery, UserListQueryVariables>(
    UserListDocument,
    options,
  );
}
export type UserListQueryHookResult = ReturnType<typeof useUserListQuery>;
export type UserListLazyQueryHookResult = ReturnType<
  typeof useUserListLazyQuery
>;
export type UserListQueryResult = Apollo.QueryResult<
  UserListQuery,
  UserListQueryVariables
>;
export const UserListUpdateDocument = gql`
  subscription UserListUpdate {
    userEvents {
      modelChangeOperation
      _id
      email
      name
      state
      preferredUnits
      preferredAirFlowUnits
      authorizationProfile {
        _id
        apiToken
      }
      modelChangeOperation
    }
  }
`;

/**
 * __useUserListUpdateSubscription__
 *
 * To run a query within a React component, call `useUserListUpdateSubscription` and pass it any options that fit your needs.
 * When your component renders, `useUserListUpdateSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUserListUpdateSubscription({
 *   variables: {
 *   },
 * });
 */
export function useUserListUpdateSubscription(
  baseOptions?: Apollo.SubscriptionHookOptions<
    UserListUpdateSubscription,
    UserListUpdateSubscriptionVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useSubscription<
    UserListUpdateSubscription,
    UserListUpdateSubscriptionVariables
  >(UserListUpdateDocument, options);
}
export type UserListUpdateSubscriptionHookResult = ReturnType<
  typeof useUserListUpdateSubscription
>;
export type UserListUpdateSubscriptionResult =
  Apollo.SubscriptionResult<UserListUpdateSubscription>;
export const AddPasskeyDocument = gql`
  mutation AddPasskey(
    $userId: String!
    $name: String!
    $preferred: Boolean!
    $data: String!
    $credentialIsExternal: Boolean!
    $enforceUserVerification: Boolean!
    $credentialOS: String!
    $credentialBoundTo: String!
  ) {
    addPasskey(
      userId: $userId
      name: $name
      preferred: $preferred
      data: $data
      credentialIsExternal: $credentialIsExternal
      enforceUserVerification: $enforceUserVerification
      credentialOS: $credentialOS
      credentialBoundTo: $credentialBoundTo
    ) {
      _id
      __typename
      factors {
        name
        _id
        externalId
        type
        preferred
      }
    }
  }
`;
export type AddPasskeyMutationFn = Apollo.MutationFunction<
  AddPasskeyMutation,
  AddPasskeyMutationVariables
>;

/**
 * __useAddPasskeyMutation__
 *
 * To run a mutation, you first call `useAddPasskeyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddPasskeyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addPasskeyMutation, { data, loading, error }] = useAddPasskeyMutation({
 *   variables: {
 *      userId: // value for 'userId'
 *      name: // value for 'name'
 *      preferred: // value for 'preferred'
 *      data: // value for 'data'
 *      credentialIsExternal: // value for 'credentialIsExternal'
 *      enforceUserVerification: // value for 'enforceUserVerification'
 *      credentialOS: // value for 'credentialOS'
 *      credentialBoundTo: // value for 'credentialBoundTo'
 *   },
 * });
 */
export function useAddPasskeyMutation(
  baseOptions?: Apollo.MutationHookOptions<
    AddPasskeyMutation,
    AddPasskeyMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<AddPasskeyMutation, AddPasskeyMutationVariables>(
    AddPasskeyDocument,
    options,
  );
}
export type AddPasskeyMutationHookResult = ReturnType<
  typeof useAddPasskeyMutation
>;
export type AddPasskeyMutationResult =
  Apollo.MutationResult<AddPasskeyMutation>;
export type AddPasskeyMutationOptions = Apollo.BaseMutationOptions<
  AddPasskeyMutation,
  AddPasskeyMutationVariables
>;
export const ChangePasswordDocument = gql`
  mutation ChangePassword(
    $userId: String!
    $oldPassword: String!
    $newPassword: String!
    $confirmPassword: String!
  ) {
    changePassword(
      userId: $userId
      oldPassword: $oldPassword
      newPassword: $newPassword
      confirmPassword: $confirmPassword
    ) {
      _id
      name
      email
      authorizationProfile {
        apiToken
      }
      editableAuthenticationProfile {
        _id
        factors {
          _id
          externalId
          type
          credentialBoundTo
          name
          value
          preferred
          primary
          sufficient
          order
        }
      }
    }
  }
`;
export type ChangePasswordMutationFn = Apollo.MutationFunction<
  ChangePasswordMutation,
  ChangePasswordMutationVariables
>;

/**
 * __useChangePasswordMutation__
 *
 * To run a mutation, you first call `useChangePasswordMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useChangePasswordMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [changePasswordMutation, { data, loading, error }] = useChangePasswordMutation({
 *   variables: {
 *      userId: // value for 'userId'
 *      oldPassword: // value for 'oldPassword'
 *      newPassword: // value for 'newPassword'
 *      confirmPassword: // value for 'confirmPassword'
 *   },
 * });
 */
export function useChangePasswordMutation(
  baseOptions?: Apollo.MutationHookOptions<
    ChangePasswordMutation,
    ChangePasswordMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    ChangePasswordMutation,
    ChangePasswordMutationVariables
  >(ChangePasswordDocument, options);
}
export type ChangePasswordMutationHookResult = ReturnType<
  typeof useChangePasswordMutation
>;
export type ChangePasswordMutationResult =
  Apollo.MutationResult<ChangePasswordMutation>;
export type ChangePasswordMutationOptions = Apollo.BaseMutationOptions<
  ChangePasswordMutation,
  ChangePasswordMutationVariables
>;
export const CurrentUserDetailDocument = gql`
  subscription CurrentUserDetail($userId: String!) {
    userEventsByIds(_ids: [$userId]) {
      modelChangeOperation
      _id
      email
      mobile
      name
      state
      preferredUnits
      preferredAirFlowUnits
      legacyAuthorizationProfile {
        _id
        isSuper
        isManager
        isResident
        isInstaller
        isViewer
        managerProperties
        installerProperties
        viewerProperties
        residentProperty
        residentUnit
        apiToken
      }
    }
  }
`;

/**
 * __useCurrentUserDetailSubscription__
 *
 * To run a query within a React component, call `useCurrentUserDetailSubscription` and pass it any options that fit your needs.
 * When your component renders, `useCurrentUserDetailSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCurrentUserDetailSubscription({
 *   variables: {
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useCurrentUserDetailSubscription(
  baseOptions: Apollo.SubscriptionHookOptions<
    CurrentUserDetailSubscription,
    CurrentUserDetailSubscriptionVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useSubscription<
    CurrentUserDetailSubscription,
    CurrentUserDetailSubscriptionVariables
  >(CurrentUserDetailDocument, options);
}
export type CurrentUserDetailSubscriptionHookResult = ReturnType<
  typeof useCurrentUserDetailSubscription
>;
export type CurrentUserDetailSubscriptionResult =
  Apollo.SubscriptionResult<CurrentUserDetailSubscription>;
export const InitatePasswordResetManagerDocument = gql`
  mutation InitatePasswordResetManager($userId: String!) {
    initatePasswordReset(userId: $userId)
  }
`;
export type InitatePasswordResetManagerMutationFn = Apollo.MutationFunction<
  InitatePasswordResetManagerMutation,
  InitatePasswordResetManagerMutationVariables
>;

/**
 * __useInitatePasswordResetManagerMutation__
 *
 * To run a mutation, you first call `useInitatePasswordResetManagerMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useInitatePasswordResetManagerMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [initatePasswordResetManagerMutation, { data, loading, error }] = useInitatePasswordResetManagerMutation({
 *   variables: {
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useInitatePasswordResetManagerMutation(
  baseOptions?: Apollo.MutationHookOptions<
    InitatePasswordResetManagerMutation,
    InitatePasswordResetManagerMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    InitatePasswordResetManagerMutation,
    InitatePasswordResetManagerMutationVariables
  >(InitatePasswordResetManagerDocument, options);
}
export type InitatePasswordResetManagerMutationHookResult = ReturnType<
  typeof useInitatePasswordResetManagerMutation
>;
export type InitatePasswordResetManagerMutationResult =
  Apollo.MutationResult<InitatePasswordResetManagerMutation>;
export type InitatePasswordResetManagerMutationOptions =
  Apollo.BaseMutationOptions<
    InitatePasswordResetManagerMutation,
    InitatePasswordResetManagerMutationVariables
  >;
export const RemovePasskeyDocument = gql`
  mutation RemovePasskey($userId: String!, $factorId: String!) {
    removePasskey(userId: $userId, factorId: $factorId) {
      _id
      __typename
      factors {
        name
        _id
        externalId
        type
      }
    }
  }
`;
export type RemovePasskeyMutationFn = Apollo.MutationFunction<
  RemovePasskeyMutation,
  RemovePasskeyMutationVariables
>;

/**
 * __useRemovePasskeyMutation__
 *
 * To run a mutation, you first call `useRemovePasskeyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemovePasskeyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removePasskeyMutation, { data, loading, error }] = useRemovePasskeyMutation({
 *   variables: {
 *      userId: // value for 'userId'
 *      factorId: // value for 'factorId'
 *   },
 * });
 */
export function useRemovePasskeyMutation(
  baseOptions?: Apollo.MutationHookOptions<
    RemovePasskeyMutation,
    RemovePasskeyMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    RemovePasskeyMutation,
    RemovePasskeyMutationVariables
  >(RemovePasskeyDocument, options);
}
export type RemovePasskeyMutationHookResult = ReturnType<
  typeof useRemovePasskeyMutation
>;
export type RemovePasskeyMutationResult =
  Apollo.MutationResult<RemovePasskeyMutation>;
export type RemovePasskeyMutationOptions = Apollo.BaseMutationOptions<
  RemovePasskeyMutation,
  RemovePasskeyMutationVariables
>;
export const UpdatePasskeyDocument = gql`
  mutation UpdatePasskey(
    $userId: String!
    $factorId: String!
    $name: String!
    $preferred: Boolean!
    $enforceUserVerification: Boolean!
  ) {
    updatePasskey(
      userId: $userId
      factorId: $factorId
      name: $name
      preferred: $preferred
      enforceUserVerification: $enforceUserVerification
    ) {
      _id
      __typename
      factors {
        name
        _id
        externalId
        type
        preferred
      }
    }
  }
`;
export type UpdatePasskeyMutationFn = Apollo.MutationFunction<
  UpdatePasskeyMutation,
  UpdatePasskeyMutationVariables
>;

/**
 * __useUpdatePasskeyMutation__
 *
 * To run a mutation, you first call `useUpdatePasskeyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdatePasskeyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updatePasskeyMutation, { data, loading, error }] = useUpdatePasskeyMutation({
 *   variables: {
 *      userId: // value for 'userId'
 *      factorId: // value for 'factorId'
 *      name: // value for 'name'
 *      preferred: // value for 'preferred'
 *      enforceUserVerification: // value for 'enforceUserVerification'
 *   },
 * });
 */
export function useUpdatePasskeyMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UpdatePasskeyMutation,
    UpdatePasskeyMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    UpdatePasskeyMutation,
    UpdatePasskeyMutationVariables
  >(UpdatePasskeyDocument, options);
}
export type UpdatePasskeyMutationHookResult = ReturnType<
  typeof useUpdatePasskeyMutation
>;
export type UpdatePasskeyMutationResult =
  Apollo.MutationResult<UpdatePasskeyMutation>;
export type UpdatePasskeyMutationOptions = Apollo.BaseMutationOptions<
  UpdatePasskeyMutation,
  UpdatePasskeyMutationVariables
>;
export const UpdateEmailAuthorizationDocument = gql`
  mutation UpdateEmailAuthorization($userId: String!, $isAuthorized: Boolean!) {
    updateEmailAuthorization(userId: $userId, isAuthorized: $isAuthorized) {
      _id
      emailOptInStatus
      emailOptInStatusTimestamp
    }
  }
`;
export type UpdateEmailAuthorizationMutationFn = Apollo.MutationFunction<
  UpdateEmailAuthorizationMutation,
  UpdateEmailAuthorizationMutationVariables
>;

/**
 * __useUpdateEmailAuthorizationMutation__
 *
 * To run a mutation, you first call `useUpdateEmailAuthorizationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateEmailAuthorizationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateEmailAuthorizationMutation, { data, loading, error }] = useUpdateEmailAuthorizationMutation({
 *   variables: {
 *      userId: // value for 'userId'
 *      isAuthorized: // value for 'isAuthorized'
 *   },
 * });
 */
export function useUpdateEmailAuthorizationMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UpdateEmailAuthorizationMutation,
    UpdateEmailAuthorizationMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    UpdateEmailAuthorizationMutation,
    UpdateEmailAuthorizationMutationVariables
  >(UpdateEmailAuthorizationDocument, options);
}
export type UpdateEmailAuthorizationMutationHookResult = ReturnType<
  typeof useUpdateEmailAuthorizationMutation
>;
export type UpdateEmailAuthorizationMutationResult =
  Apollo.MutationResult<UpdateEmailAuthorizationMutation>;
export type UpdateEmailAuthorizationMutationOptions =
  Apollo.BaseMutationOptions<
    UpdateEmailAuthorizationMutation,
    UpdateEmailAuthorizationMutationVariables
  >;
export const UpdateSmsAuthorizationDocument = gql`
  mutation UpdateSmsAuthorization(
    $userId: String!
    $smsMobile: String!
    $isAuthorized: Boolean!
  ) {
    updateSmsAuthorization(
      userId: $userId
      smsMobile: $smsMobile
      isAuthorized: $isAuthorized
    ) {
      _id
      mobile
      smsOptInStatus
      smsOptInStatusTimestamp
    }
  }
`;
export type UpdateSmsAuthorizationMutationFn = Apollo.MutationFunction<
  UpdateSmsAuthorizationMutation,
  UpdateSmsAuthorizationMutationVariables
>;

/**
 * __useUpdateSmsAuthorizationMutation__
 *
 * To run a mutation, you first call `useUpdateSmsAuthorizationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateSmsAuthorizationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateSmsAuthorizationMutation, { data, loading, error }] = useUpdateSmsAuthorizationMutation({
 *   variables: {
 *      userId: // value for 'userId'
 *      smsMobile: // value for 'smsMobile'
 *      isAuthorized: // value for 'isAuthorized'
 *   },
 * });
 */
export function useUpdateSmsAuthorizationMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UpdateSmsAuthorizationMutation,
    UpdateSmsAuthorizationMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    UpdateSmsAuthorizationMutation,
    UpdateSmsAuthorizationMutationVariables
  >(UpdateSmsAuthorizationDocument, options);
}
export type UpdateSmsAuthorizationMutationHookResult = ReturnType<
  typeof useUpdateSmsAuthorizationMutation
>;
export type UpdateSmsAuthorizationMutationResult =
  Apollo.MutationResult<UpdateSmsAuthorizationMutation>;
export type UpdateSmsAuthorizationMutationOptions = Apollo.BaseMutationOptions<
  UpdateSmsAuthorizationMutation,
  UpdateSmsAuthorizationMutationVariables
>;
export const UserProfileAlertChangesDocument = gql`
  subscription UserProfileAlertChanges($userId: String!) {
    userEventsByIds(_ids: [$userId]) {
      modelChangeOperation
      _id
      email
      mobile
      preferredUnits
      preferredAirFlowUnits
      name
      state
      emailOptInStatus
      emailOptInStatusTimestamp
      smsOptInStatus
      smsOptInStatusTimestamp
      alertableProperties {
        _id
        title
        alertTriggers {
          _id
          name
        }
      }
      profile {
        mobile
        emailOptInStatus
        emailOptInStatusTimestamp
        smsOptInStatus
        smsOptInStatusTimestamp
        history
      }
    }
  }
`;

/**
 * __useUserProfileAlertChangesSubscription__
 *
 * To run a query within a React component, call `useUserProfileAlertChangesSubscription` and pass it any options that fit your needs.
 * When your component renders, `useUserProfileAlertChangesSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUserProfileAlertChangesSubscription({
 *   variables: {
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useUserProfileAlertChangesSubscription(
  baseOptions: Apollo.SubscriptionHookOptions<
    UserProfileAlertChangesSubscription,
    UserProfileAlertChangesSubscriptionVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useSubscription<
    UserProfileAlertChangesSubscription,
    UserProfileAlertChangesSubscriptionVariables
  >(UserProfileAlertChangesDocument, options);
}
export type UserProfileAlertChangesSubscriptionHookResult = ReturnType<
  typeof useUserProfileAlertChangesSubscription
>;
export type UserProfileAlertChangesSubscriptionResult =
  Apollo.SubscriptionResult<UserProfileAlertChangesSubscription>;
export const UserProfileDocument = gql`
  query UserProfile($userId: String!) {
    userById(_id: $userId) {
      _id
      email
      mobile
      emailOptInStatus
      emailOptInStatusTimestamp
      smsOptInStatus
      smsOptInStatusTimestamp
      preferredUnits
      preferredAirFlowUnits
      name
      state
      alertableProperties {
        _id
        title
        alertTriggers {
          _id
          name
        }
      }
      editableAuthenticationProfile {
        _id
        factors {
          _id
          externalId
          credentialBoundTo
          type
          name
          value
          preferred
          primary
          sufficient
          order
        }
        authenticatorDevices {
          _id
          deviceName
          deviceType
          credentialType
          userVerified
          enforceUserVerification
          credentialIsExternal
          credentialOS
          credentialEcosystem
          credentialBoundTo
          credentialDeviceType
          credentialBackedUp
          transports
          createdAt
          lastUsed
        }
      }
      authorizationProfile {
        _id
        apiToken
      }
      profile {
        mobile
        emailOptInStatus
        emailOptInStatusTimestamp
        smsOptInStatus
        smsOptInStatusTimestamp
        history
      }
    }
  }
`;

/**
 * __useUserProfileQuery__
 *
 * To run a query within a React component, call `useUserProfileQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserProfileQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUserProfileQuery({
 *   variables: {
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useUserProfileQuery(
  baseOptions: Apollo.QueryHookOptions<
    UserProfileQuery,
    UserProfileQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<UserProfileQuery, UserProfileQueryVariables>(
    UserProfileDocument,
    options,
  );
}
export function useUserProfileLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    UserProfileQuery,
    UserProfileQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<UserProfileQuery, UserProfileQueryVariables>(
    UserProfileDocument,
    options,
  );
}
export type UserProfileQueryHookResult = ReturnType<typeof useUserProfileQuery>;
export type UserProfileLazyQueryHookResult = ReturnType<
  typeof useUserProfileLazyQuery
>;
export type UserProfileQueryResult = Apollo.QueryResult<
  UserProfileQuery,
  UserProfileQueryVariables
>;
export const UserProfilePasskeysDocument = gql`
  query UserProfilePasskeys($userId: String!) {
    userById(_id: $userId) {
      _id
      editableAuthenticationProfile {
        _id
        factors {
          _id
          externalId
          type
          credentialBoundTo
          name
          value
          preferred
          primary
          sufficient
          order
        }
        authenticatorDevices {
          _id
          deviceName
          deviceType
          credentialType
          userVerified
          enforceUserVerification
          credentialIsExternal
          credentialOS
          credentialEcosystem
          credentialBoundTo
          credentialDeviceType
          credentialBackedUp
          transports
          createdAt
          lastUsed
        }
      }
    }
  }
`;

/**
 * __useUserProfilePasskeysQuery__
 *
 * To run a query within a React component, call `useUserProfilePasskeysQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserProfilePasskeysQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUserProfilePasskeysQuery({
 *   variables: {
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useUserProfilePasskeysQuery(
  baseOptions: Apollo.QueryHookOptions<
    UserProfilePasskeysQuery,
    UserProfilePasskeysQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    UserProfilePasskeysQuery,
    UserProfilePasskeysQueryVariables
  >(UserProfilePasskeysDocument, options);
}
export function useUserProfilePasskeysLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    UserProfilePasskeysQuery,
    UserProfilePasskeysQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    UserProfilePasskeysQuery,
    UserProfilePasskeysQueryVariables
  >(UserProfilePasskeysDocument, options);
}
export type UserProfilePasskeysQueryHookResult = ReturnType<
  typeof useUserProfilePasskeysQuery
>;
export type UserProfilePasskeysLazyQueryHookResult = ReturnType<
  typeof useUserProfilePasskeysLazyQuery
>;
export type UserProfilePasskeysQueryResult = Apollo.QueryResult<
  UserProfilePasskeysQuery,
  UserProfilePasskeysQueryVariables
>;
export const UserProfilePasskeysChangesDocument = gql`
  subscription UserProfilePasskeysChanges($userId: String!) {
    userEventsByIds(_ids: [$userId]) {
      modelChangeOperation
      _id
      editableAuthenticationProfile {
        _id
        factors {
          _id
          externalId
          type
          credentialBoundTo
          name
          value
          preferred
          primary
          sufficient
          order
        }
        authenticatorDevices {
          _id
          deviceName
          deviceType
          credentialType
          userVerified
          enforceUserVerification
          credentialIsExternal
          credentialOS
          credentialEcosystem
          credentialBoundTo
          credentialDeviceType
          credentialBackedUp
          transports
          createdAt
          lastUsed
        }
      }
    }
  }
`;

/**
 * __useUserProfilePasskeysChangesSubscription__
 *
 * To run a query within a React component, call `useUserProfilePasskeysChangesSubscription` and pass it any options that fit your needs.
 * When your component renders, `useUserProfilePasskeysChangesSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUserProfilePasskeysChangesSubscription({
 *   variables: {
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useUserProfilePasskeysChangesSubscription(
  baseOptions: Apollo.SubscriptionHookOptions<
    UserProfilePasskeysChangesSubscription,
    UserProfilePasskeysChangesSubscriptionVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useSubscription<
    UserProfilePasskeysChangesSubscription,
    UserProfilePasskeysChangesSubscriptionVariables
  >(UserProfilePasskeysChangesDocument, options);
}
export type UserProfilePasskeysChangesSubscriptionHookResult = ReturnType<
  typeof useUserProfilePasskeysChangesSubscription
>;
export type UserProfilePasskeysChangesSubscriptionResult =
  Apollo.SubscriptionResult<UserProfilePasskeysChangesSubscription>;
export const UserHistoryDocument = gql`
  query UserHistory($userId: String!) {
    userDeviceHistory(userId: $userId) {
      _id
      userId
      deviceId
      history
      currentIndex
      lastAccessedAt
    }
  }
`;

/**
 * __useUserHistoryQuery__
 *
 * To run a query within a React component, call `useUserHistoryQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserHistoryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUserHistoryQuery({
 *   variables: {
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useUserHistoryQuery(
  baseOptions: Apollo.QueryHookOptions<
    UserHistoryQuery,
    UserHistoryQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<UserHistoryQuery, UserHistoryQueryVariables>(
    UserHistoryDocument,
    options,
  );
}
export function useUserHistoryLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    UserHistoryQuery,
    UserHistoryQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<UserHistoryQuery, UserHistoryQueryVariables>(
    UserHistoryDocument,
    options,
  );
}
export type UserHistoryQueryHookResult = ReturnType<typeof useUserHistoryQuery>;
export type UserHistoryLazyQueryHookResult = ReturnType<
  typeof useUserHistoryLazyQuery
>;
export type UserHistoryQueryResult = Apollo.QueryResult<
  UserHistoryQuery,
  UserHistoryQueryVariables
>;
export const UsersOptionsDocument = gql`
  query UsersOptions {
    users(limit: 0) {
      _id
      name
    }
  }
`;

/**
 * __useUsersOptionsQuery__
 *
 * To run a query within a React component, call `useUsersOptionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useUsersOptionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUsersOptionsQuery({
 *   variables: {
 *   },
 * });
 */
export function useUsersOptionsQuery(
  baseOptions?: Apollo.QueryHookOptions<
    UsersOptionsQuery,
    UsersOptionsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<UsersOptionsQuery, UsersOptionsQueryVariables>(
    UsersOptionsDocument,
    options,
  );
}
export function useUsersOptionsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    UsersOptionsQuery,
    UsersOptionsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<UsersOptionsQuery, UsersOptionsQueryVariables>(
    UsersOptionsDocument,
    options,
  );
}
export type UsersOptionsQueryHookResult = ReturnType<
  typeof useUsersOptionsQuery
>;
export type UsersOptionsLazyQueryHookResult = ReturnType<
  typeof useUsersOptionsLazyQuery
>;
export type UsersOptionsQueryResult = Apollo.QueryResult<
  UsersOptionsQuery,
  UsersOptionsQueryVariables
>;
export const BatteryManagementSystemDetailUpdatesDocument = gql`
  subscription BatteryManagementSystemDetailUpdates($id: String!) {
    batteryManagementSystemEventsByIds(_ids: [$id]) {
      modelChangeOperation
      _id
      deviceId
      name
      type
      location
      propertyId
      unitId
      panelId
      sourceId
      updateStatus
      timestamp
      meta {
        name
        metrics
      }
      installation {
        status
        message
      }
      powerState {
        value
        timestamp
      }
      typeDisplayName
      isConfigured
      isPoweredOn
      deviceIdentifier
      hasPendingUpdates
      isControlled
      voltage {
        value
        timestamp
        units
      }
      current {
        value
        timestamp
        units
      }
      temperature {
        value
        timestamp
        units
      }
      stateOfCharge {
        value
        timestamp
        units
      }
      stateOfHealth {
        value
        timestamp
        units
      }
      batteryEfficiency {
        value
        timestamp
        units
      }
      cellVoltages {
        value
        timestamp
        units
      }
      cellCurrents {
        value
        timestamp
        units
      }
      cellTemperatures {
        value
        timestamp
        units
      }
      cellCycleCounts {
        value
        timestamp
        units
      }
      chartTypes
      property {
        _id
        title
      }
      unit {
        _id
        name
      }
      panel {
        _id
        name
        displayName
      }
      source {
        _id
        name
      }
      inverterId
    }
  }
`;

/**
 * __useBatteryManagementSystemDetailUpdatesSubscription__
 *
 * To run a query within a React component, call `useBatteryManagementSystemDetailUpdatesSubscription` and pass it any options that fit your needs.
 * When your component renders, `useBatteryManagementSystemDetailUpdatesSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBatteryManagementSystemDetailUpdatesSubscription({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useBatteryManagementSystemDetailUpdatesSubscription(
  baseOptions: Apollo.SubscriptionHookOptions<
    BatteryManagementSystemDetailUpdatesSubscription,
    BatteryManagementSystemDetailUpdatesSubscriptionVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useSubscription<
    BatteryManagementSystemDetailUpdatesSubscription,
    BatteryManagementSystemDetailUpdatesSubscriptionVariables
  >(BatteryManagementSystemDetailUpdatesDocument, options);
}
export type BatteryManagementSystemDetailUpdatesSubscriptionHookResult =
  ReturnType<typeof useBatteryManagementSystemDetailUpdatesSubscription>;
export type BatteryManagementSystemDetailUpdatesSubscriptionResult =
  Apollo.SubscriptionResult<BatteryManagementSystemDetailUpdatesSubscription>;
export const BatteryManagementSystemDetailDocument = gql`
  query BatteryManagementSystemDetail($id: String!) {
    batteryManagementSystemById(_id: $id) {
      _id
      deviceId
      name
      type
      location
      propertyId
      unitId
      panelId
      sourceId
      updateStatus
      timestamp
      meta {
        name
        metrics
      }
      installation {
        status
        message
      }
      powerState {
        value
        timestamp
      }
      typeDisplayName
      isConfigured
      isPoweredOn
      deviceIdentifier
      hasPendingUpdates
      isControlled
      voltage {
        value
        timestamp
        units
      }
      current {
        value
        timestamp
        units
      }
      temperature {
        value
        timestamp
        units
      }
      stateOfCharge {
        value
        timestamp
        units
      }
      stateOfHealth {
        value
        timestamp
        units
      }
      batteryEfficiency {
        value
        timestamp
        units
      }
      cellVoltages {
        value
        timestamp
        units
      }
      cellCurrents {
        value
        timestamp
        units
      }
      cellTemperatures {
        value
        timestamp
        units
      }
      cellCycleCounts {
        value
        timestamp
        units
      }
      chartTypes
      property {
        _id
        title
      }
      unit {
        _id
        name
      }
      panel {
        _id
        name
        displayName
      }
      source {
        _id
        name
      }
      inverterId
    }
  }
`;

/**
 * __useBatteryManagementSystemDetailQuery__
 *
 * To run a query within a React component, call `useBatteryManagementSystemDetailQuery` and pass it any options that fit your needs.
 * When your component renders, `useBatteryManagementSystemDetailQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBatteryManagementSystemDetailQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useBatteryManagementSystemDetailQuery(
  baseOptions: Apollo.QueryHookOptions<
    BatteryManagementSystemDetailQuery,
    BatteryManagementSystemDetailQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    BatteryManagementSystemDetailQuery,
    BatteryManagementSystemDetailQueryVariables
  >(BatteryManagementSystemDetailDocument, options);
}
export function useBatteryManagementSystemDetailLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    BatteryManagementSystemDetailQuery,
    BatteryManagementSystemDetailQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    BatteryManagementSystemDetailQuery,
    BatteryManagementSystemDetailQueryVariables
  >(BatteryManagementSystemDetailDocument, options);
}
export type BatteryManagementSystemDetailQueryHookResult = ReturnType<
  typeof useBatteryManagementSystemDetailQuery
>;
export type BatteryManagementSystemDetailLazyQueryHookResult = ReturnType<
  typeof useBatteryManagementSystemDetailLazyQuery
>;
export type BatteryManagementSystemDetailQueryResult = Apollo.QueryResult<
  BatteryManagementSystemDetailQuery,
  BatteryManagementSystemDetailQueryVariables
>;
export const EnergyConsumerBuildingDetailUpdatesDocument = gql`
  subscription EnergyConsumerBuildingDetailUpdates($id: String!) {
    energyConsumerBuildingEventsByIds(_ids: [$id]) {
      modelChangeOperation
      _id
      name
      location
      propertyId
      unitId
      vppId
      updateStatus
      timestamp
      powerState {
        value
        timestamp
        units
      }
      connected {
        value
        timestamp
      }
      lastConnectedAt {
        value
        timestamp
      }
      disconnectedAt {
        value
        timestamp
      }
      tariffRateSell {
        value
        timestamp
        units
      }
      energySwitchPanelId
      circuitId
      meterId
      inverterId
      occupancy {
        value
        timestamp
        units
      }
      energyEfficiencyScore {
        value
        timestamp
        units
      }
      chartTypes
    }
  }
`;

/**
 * __useEnergyConsumerBuildingDetailUpdatesSubscription__
 *
 * To run a query within a React component, call `useEnergyConsumerBuildingDetailUpdatesSubscription` and pass it any options that fit your needs.
 * When your component renders, `useEnergyConsumerBuildingDetailUpdatesSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEnergyConsumerBuildingDetailUpdatesSubscription({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useEnergyConsumerBuildingDetailUpdatesSubscription(
  baseOptions: Apollo.SubscriptionHookOptions<
    EnergyConsumerBuildingDetailUpdatesSubscription,
    EnergyConsumerBuildingDetailUpdatesSubscriptionVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useSubscription<
    EnergyConsumerBuildingDetailUpdatesSubscription,
    EnergyConsumerBuildingDetailUpdatesSubscriptionVariables
  >(EnergyConsumerBuildingDetailUpdatesDocument, options);
}
export type EnergyConsumerBuildingDetailUpdatesSubscriptionHookResult =
  ReturnType<typeof useEnergyConsumerBuildingDetailUpdatesSubscription>;
export type EnergyConsumerBuildingDetailUpdatesSubscriptionResult =
  Apollo.SubscriptionResult<EnergyConsumerBuildingDetailUpdatesSubscription>;
export const EnergyConsumerBuildingDetailDocument = gql`
  query EnergyConsumerBuildingDetail($id: String!) {
    energyConsumerBuildingById(_id: $id) {
      _id
      name
      location
      propertyId
      unitId
      vppId
      updateStatus
      timestamp
      powerState {
        value
        timestamp
        units
      }
      connected {
        value
        timestamp
      }
      lastConnectedAt {
        value
        timestamp
      }
      disconnectedAt {
        value
        timestamp
      }
      tariffRateSell {
        value
        timestamp
        units
      }
      energySwitchPanelId
      circuitId
      meterId
      inverterId
      occupancy {
        value
        timestamp
        units
      }
      energyEfficiencyScore {
        value
        timestamp
        units
      }
      chartTypes
    }
  }
`;

/**
 * __useEnergyConsumerBuildingDetailQuery__
 *
 * To run a query within a React component, call `useEnergyConsumerBuildingDetailQuery` and pass it any options that fit your needs.
 * When your component renders, `useEnergyConsumerBuildingDetailQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEnergyConsumerBuildingDetailQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useEnergyConsumerBuildingDetailQuery(
  baseOptions: Apollo.QueryHookOptions<
    EnergyConsumerBuildingDetailQuery,
    EnergyConsumerBuildingDetailQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    EnergyConsumerBuildingDetailQuery,
    EnergyConsumerBuildingDetailQueryVariables
  >(EnergyConsumerBuildingDetailDocument, options);
}
export function useEnergyConsumerBuildingDetailLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    EnergyConsumerBuildingDetailQuery,
    EnergyConsumerBuildingDetailQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    EnergyConsumerBuildingDetailQuery,
    EnergyConsumerBuildingDetailQueryVariables
  >(EnergyConsumerBuildingDetailDocument, options);
}
export type EnergyConsumerBuildingDetailQueryHookResult = ReturnType<
  typeof useEnergyConsumerBuildingDetailQuery
>;
export type EnergyConsumerBuildingDetailLazyQueryHookResult = ReturnType<
  typeof useEnergyConsumerBuildingDetailLazyQuery
>;
export type EnergyConsumerBuildingDetailQueryResult = Apollo.QueryResult<
  EnergyConsumerBuildingDetailQuery,
  EnergyConsumerBuildingDetailQueryVariables
>;
export const EnergyConsumerTenantDetailUpdatesDocument = gql`
  subscription EnergyConsumerTenantDetailUpdates($id: String!) {
    energyConsumerTenantEventsByIds(_ids: [$id]) {
      modelChangeOperation
      _id
      name
      location
      propertyId
      unitId
      vppId
      updateStatus
      timestamp
      powerState {
        value
        timestamp
        units
      }
      connected {
        value
        timestamp
      }
      lastConnectedAt {
        value
        timestamp
      }
      disconnectedAt {
        value
        timestamp
      }
      tariffRateSell {
        value
        timestamp
        units
      }
      energySwitchPanelId
      circuitId
      meterId
      inverterId
      converterId
      contactName
      contactPhone
      buildingId
      occupancy {
        value
        timestamp
        units
      }
      energyEfficiencyScore {
        value
        timestamp
        units
      }
      chartTypes
    }
  }
`;

/**
 * __useEnergyConsumerTenantDetailUpdatesSubscription__
 *
 * To run a query within a React component, call `useEnergyConsumerTenantDetailUpdatesSubscription` and pass it any options that fit your needs.
 * When your component renders, `useEnergyConsumerTenantDetailUpdatesSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEnergyConsumerTenantDetailUpdatesSubscription({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useEnergyConsumerTenantDetailUpdatesSubscription(
  baseOptions: Apollo.SubscriptionHookOptions<
    EnergyConsumerTenantDetailUpdatesSubscription,
    EnergyConsumerTenantDetailUpdatesSubscriptionVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useSubscription<
    EnergyConsumerTenantDetailUpdatesSubscription,
    EnergyConsumerTenantDetailUpdatesSubscriptionVariables
  >(EnergyConsumerTenantDetailUpdatesDocument, options);
}
export type EnergyConsumerTenantDetailUpdatesSubscriptionHookResult =
  ReturnType<typeof useEnergyConsumerTenantDetailUpdatesSubscription>;
export type EnergyConsumerTenantDetailUpdatesSubscriptionResult =
  Apollo.SubscriptionResult<EnergyConsumerTenantDetailUpdatesSubscription>;
export const EnergyConsumerTenantDetailDocument = gql`
  query EnergyConsumerTenantDetail($id: String!) {
    energyConsumerTenantById(_id: $id) {
      _id
      name
      location
      propertyId
      unitId
      vppId
      updateStatus
      timestamp
      powerState {
        value
        timestamp
        units
      }
      connected {
        value
        timestamp
      }
      lastConnectedAt {
        value
        timestamp
      }
      disconnectedAt {
        value
        timestamp
      }
      tariffRateSell {
        value
        timestamp
        units
      }
      energySwitchPanelId
      circuitId
      meterId
      inverterId
      converterId
      contactName
      contactPhone
      buildingId
      occupancy {
        value
        timestamp
        units
      }
      energyEfficiencyScore {
        value
        timestamp
        units
      }
      chartTypes
    }
  }
`;

/**
 * __useEnergyConsumerTenantDetailQuery__
 *
 * To run a query within a React component, call `useEnergyConsumerTenantDetailQuery` and pass it any options that fit your needs.
 * When your component renders, `useEnergyConsumerTenantDetailQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEnergyConsumerTenantDetailQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useEnergyConsumerTenantDetailQuery(
  baseOptions: Apollo.QueryHookOptions<
    EnergyConsumerTenantDetailQuery,
    EnergyConsumerTenantDetailQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    EnergyConsumerTenantDetailQuery,
    EnergyConsumerTenantDetailQueryVariables
  >(EnergyConsumerTenantDetailDocument, options);
}
export function useEnergyConsumerTenantDetailLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    EnergyConsumerTenantDetailQuery,
    EnergyConsumerTenantDetailQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    EnergyConsumerTenantDetailQuery,
    EnergyConsumerTenantDetailQueryVariables
  >(EnergyConsumerTenantDetailDocument, options);
}
export type EnergyConsumerTenantDetailQueryHookResult = ReturnType<
  typeof useEnergyConsumerTenantDetailQuery
>;
export type EnergyConsumerTenantDetailLazyQueryHookResult = ReturnType<
  typeof useEnergyConsumerTenantDetailLazyQuery
>;
export type EnergyConsumerTenantDetailQueryResult = Apollo.QueryResult<
  EnergyConsumerTenantDetailQuery,
  EnergyConsumerTenantDetailQueryVariables
>;
export const EnergyConsumerUtilityDetailUpdatesDocument = gql`
  subscription EnergyConsumerUtilityDetailUpdates($id: String!) {
    energyConsumerUtilityEventsByIds(_ids: [$id]) {
      modelChangeOperation
      _id
      name
      location
      propertyId
      unitId
      vppId
      updateStatus
      timestamp
      powerState {
        value
        timestamp
        units
      }
      connected {
        value
        timestamp
      }
      lastConnectedAt {
        value
        timestamp
      }
      disconnectedAt {
        value
        timestamp
      }
      tariffRateSell {
        value
        timestamp
        units
      }
      energySwitchPanelId
      circuitId
      meterId
      inverterId
      converterId
      gridFrequency {
        value
        timestamp
        units
      }
      interconnectionCapacity {
        value
        timestamp
        units
      }
      exportAllowance {
        value
        timestamp
        units
      }
      contractStatus {
        value
        timestamp
        units
      }
      chartTypes
    }
  }
`;

/**
 * __useEnergyConsumerUtilityDetailUpdatesSubscription__
 *
 * To run a query within a React component, call `useEnergyConsumerUtilityDetailUpdatesSubscription` and pass it any options that fit your needs.
 * When your component renders, `useEnergyConsumerUtilityDetailUpdatesSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEnergyConsumerUtilityDetailUpdatesSubscription({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useEnergyConsumerUtilityDetailUpdatesSubscription(
  baseOptions: Apollo.SubscriptionHookOptions<
    EnergyConsumerUtilityDetailUpdatesSubscription,
    EnergyConsumerUtilityDetailUpdatesSubscriptionVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useSubscription<
    EnergyConsumerUtilityDetailUpdatesSubscription,
    EnergyConsumerUtilityDetailUpdatesSubscriptionVariables
  >(EnergyConsumerUtilityDetailUpdatesDocument, options);
}
export type EnergyConsumerUtilityDetailUpdatesSubscriptionHookResult =
  ReturnType<typeof useEnergyConsumerUtilityDetailUpdatesSubscription>;
export type EnergyConsumerUtilityDetailUpdatesSubscriptionResult =
  Apollo.SubscriptionResult<EnergyConsumerUtilityDetailUpdatesSubscription>;
export const EnergyConsumerUtilityDetailDocument = gql`
  query EnergyConsumerUtilityDetail($id: String!) {
    energyConsumerUtilityById(_id: $id) {
      _id
      name
      location
      propertyId
      unitId
      vppId
      updateStatus
      timestamp
      powerState {
        value
        timestamp
        units
      }
      connected {
        value
        timestamp
      }
      lastConnectedAt {
        value
        timestamp
      }
      disconnectedAt {
        value
        timestamp
      }
      tariffRateSell {
        value
        timestamp
        units
      }
      energySwitchPanelId
      circuitId
      meterId
      inverterId
      converterId
      gridFrequency {
        value
        timestamp
        units
      }
      interconnectionCapacity {
        value
        timestamp
        units
      }
      exportAllowance {
        value
        timestamp
        units
      }
      contractStatus {
        value
        timestamp
        units
      }
      chartTypes
    }
  }
`;

/**
 * __useEnergyConsumerUtilityDetailQuery__
 *
 * To run a query within a React component, call `useEnergyConsumerUtilityDetailQuery` and pass it any options that fit your needs.
 * When your component renders, `useEnergyConsumerUtilityDetailQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEnergyConsumerUtilityDetailQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useEnergyConsumerUtilityDetailQuery(
  baseOptions: Apollo.QueryHookOptions<
    EnergyConsumerUtilityDetailQuery,
    EnergyConsumerUtilityDetailQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    EnergyConsumerUtilityDetailQuery,
    EnergyConsumerUtilityDetailQueryVariables
  >(EnergyConsumerUtilityDetailDocument, options);
}
export function useEnergyConsumerUtilityDetailLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    EnergyConsumerUtilityDetailQuery,
    EnergyConsumerUtilityDetailQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    EnergyConsumerUtilityDetailQuery,
    EnergyConsumerUtilityDetailQueryVariables
  >(EnergyConsumerUtilityDetailDocument, options);
}
export type EnergyConsumerUtilityDetailQueryHookResult = ReturnType<
  typeof useEnergyConsumerUtilityDetailQuery
>;
export type EnergyConsumerUtilityDetailLazyQueryHookResult = ReturnType<
  typeof useEnergyConsumerUtilityDetailLazyQuery
>;
export type EnergyConsumerUtilityDetailQueryResult = Apollo.QueryResult<
  EnergyConsumerUtilityDetailQuery,
  EnergyConsumerUtilityDetailQueryVariables
>;
export const EnergyControllerDetailUpdatesDocument = gql`
  subscription EnergyControllerDetailUpdates($id: String!) {
    energyControllerEventsByIds(_ids: [$id]) {
      modelChangeOperation
      _id
      deviceId
      name
      type
      location
      propertyId
      unitId
      panelId
      sourceId
      updateStatus
      timestamp
      meta {
        name
        metrics
      }
      installation {
        status
        message
      }
      powerState {
        value
        timestamp
      }
      typeDisplayName
      isConfigured
      isPoweredOn
      deviceIdentifier
      hasPendingUpdates
      isControlled
      energyGenerated {
        value
        timestamp
        units
      }
      availabilityStatus {
        value
        timestamp
      }
      voltageAtMpp {
        value
        timestamp
        units
      }
      currentAtMpp {
        value
        timestamp
        units
      }
      rotorSpeedAtMPP {
        value
        timestamp
        units
      }
      chargeRegulationStatus {
        value
        timestamp
      }
      rectifierId
      currentPowerOutput
      totalEnergySupplied
      peakPowerOutput
      chartTypes
      property {
        _id
        title
      }
      unit {
        _id
        name
      }
      panel {
        _id
        name
        displayName
      }
      source {
        _id
        name
      }
    }
  }
`;

/**
 * __useEnergyControllerDetailUpdatesSubscription__
 *
 * To run a query within a React component, call `useEnergyControllerDetailUpdatesSubscription` and pass it any options that fit your needs.
 * When your component renders, `useEnergyControllerDetailUpdatesSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEnergyControllerDetailUpdatesSubscription({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useEnergyControllerDetailUpdatesSubscription(
  baseOptions: Apollo.SubscriptionHookOptions<
    EnergyControllerDetailUpdatesSubscription,
    EnergyControllerDetailUpdatesSubscriptionVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useSubscription<
    EnergyControllerDetailUpdatesSubscription,
    EnergyControllerDetailUpdatesSubscriptionVariables
  >(EnergyControllerDetailUpdatesDocument, options);
}
export type EnergyControllerDetailUpdatesSubscriptionHookResult = ReturnType<
  typeof useEnergyControllerDetailUpdatesSubscription
>;
export type EnergyControllerDetailUpdatesSubscriptionResult =
  Apollo.SubscriptionResult<EnergyControllerDetailUpdatesSubscription>;
export const EnergyControllerDetailDocument = gql`
  query EnergyControllerDetail($id: String!) {
    energyControllerById(_id: $id) {
      _id
      deviceId
      name
      type
      location
      propertyId
      unitId
      panelId
      sourceId
      updateStatus
      timestamp
      meta {
        name
        metrics
      }
      installation {
        status
        message
      }
      powerState {
        value
        timestamp
      }
      typeDisplayName
      isConfigured
      isPoweredOn
      deviceIdentifier
      hasPendingUpdates
      isControlled
      energyGenerated {
        value
        timestamp
        units
      }
      availabilityStatus {
        value
        timestamp
      }
      voltageAtMpp {
        value
        timestamp
        units
      }
      currentAtMpp {
        value
        timestamp
        units
      }
      rotorSpeedAtMPP {
        value
        timestamp
        units
      }
      chargeRegulationStatus {
        value
        timestamp
      }
      rectifierId
      currentPowerOutput
      totalEnergySupplied
      peakPowerOutput
      chartTypes
      property {
        _id
        title
      }
      unit {
        _id
        name
      }
      panel {
        _id
        name
        displayName
      }
      source {
        _id
        name
      }
    }
  }
`;

/**
 * __useEnergyControllerDetailQuery__
 *
 * To run a query within a React component, call `useEnergyControllerDetailQuery` and pass it any options that fit your needs.
 * When your component renders, `useEnergyControllerDetailQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEnergyControllerDetailQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useEnergyControllerDetailQuery(
  baseOptions: Apollo.QueryHookOptions<
    EnergyControllerDetailQuery,
    EnergyControllerDetailQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    EnergyControllerDetailQuery,
    EnergyControllerDetailQueryVariables
  >(EnergyControllerDetailDocument, options);
}
export function useEnergyControllerDetailLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    EnergyControllerDetailQuery,
    EnergyControllerDetailQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    EnergyControllerDetailQuery,
    EnergyControllerDetailQueryVariables
  >(EnergyControllerDetailDocument, options);
}
export type EnergyControllerDetailQueryHookResult = ReturnType<
  typeof useEnergyControllerDetailQuery
>;
export type EnergyControllerDetailLazyQueryHookResult = ReturnType<
  typeof useEnergyControllerDetailLazyQuery
>;
export type EnergyControllerDetailQueryResult = Apollo.QueryResult<
  EnergyControllerDetailQuery,
  EnergyControllerDetailQueryVariables
>;
export const EnergyConverterDetailUpdatesDocument = gql`
  subscription EnergyConverterDetailUpdates($id: String!) {
    energyConverterEventsByIds(_ids: [$id]) {
      modelChangeOperation
      _id
      deviceId
      name
      type
      location
      propertyId
      unitId
      panelId
      sourceId
      updateStatus
      timestamp
      meta {
        name
        metrics
      }
      installation {
        status
        message
      }
      powerState {
        value
        timestamp
      }
      typeDisplayName
      isConfigured
      isPoweredOn
      deviceIdentifier
      hasPendingUpdates
      isControlled
      inputVoltage {
        value
        timestamp
        units
      }
      outputVoltage {
        value
        timestamp
        units
      }
      powerOutput {
        value
        timestamp
        units
      }
      chargeRate {
        value
        timestamp
        units
      }
      dischargeRate {
        value
        timestamp
        units
      }
      efficiency {
        value
        timestamp
        units
      }
      chartTypes
      property {
        _id
        title
      }
      unit {
        _id
        name
      }
      panel {
        _id
        name
        displayName
      }
      source {
        _id
        name
      }
    }
  }
`;

/**
 * __useEnergyConverterDetailUpdatesSubscription__
 *
 * To run a query within a React component, call `useEnergyConverterDetailUpdatesSubscription` and pass it any options that fit your needs.
 * When your component renders, `useEnergyConverterDetailUpdatesSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEnergyConverterDetailUpdatesSubscription({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useEnergyConverterDetailUpdatesSubscription(
  baseOptions: Apollo.SubscriptionHookOptions<
    EnergyConverterDetailUpdatesSubscription,
    EnergyConverterDetailUpdatesSubscriptionVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useSubscription<
    EnergyConverterDetailUpdatesSubscription,
    EnergyConverterDetailUpdatesSubscriptionVariables
  >(EnergyConverterDetailUpdatesDocument, options);
}
export type EnergyConverterDetailUpdatesSubscriptionHookResult = ReturnType<
  typeof useEnergyConverterDetailUpdatesSubscription
>;
export type EnergyConverterDetailUpdatesSubscriptionResult =
  Apollo.SubscriptionResult<EnergyConverterDetailUpdatesSubscription>;
export const EnergyConverterDetailDocument = gql`
  query EnergyConverterDetail($id: String!) {
    energyConverterById(_id: $id) {
      _id
      deviceId
      name
      type
      location
      propertyId
      unitId
      panelId
      sourceId
      updateStatus
      timestamp
      meta {
        name
        metrics
      }
      installation {
        status
        message
      }
      powerState {
        value
        timestamp
      }
      typeDisplayName
      isConfigured
      isPoweredOn
      deviceIdentifier
      hasPendingUpdates
      isControlled
      inputVoltage {
        value
        timestamp
        units
      }
      outputVoltage {
        value
        timestamp
        units
      }
      powerOutput {
        value
        timestamp
        units
      }
      chargeRate {
        value
        timestamp
        units
      }
      dischargeRate {
        value
        timestamp
        units
      }
      efficiency {
        value
        timestamp
        units
      }
      chartTypes
      property {
        _id
        title
      }
      unit {
        _id
        name
      }
      panel {
        _id
        name
        displayName
      }
      source {
        _id
        name
      }
    }
  }
`;

/**
 * __useEnergyConverterDetailQuery__
 *
 * To run a query within a React component, call `useEnergyConverterDetailQuery` and pass it any options that fit your needs.
 * When your component renders, `useEnergyConverterDetailQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEnergyConverterDetailQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useEnergyConverterDetailQuery(
  baseOptions: Apollo.QueryHookOptions<
    EnergyConverterDetailQuery,
    EnergyConverterDetailQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    EnergyConverterDetailQuery,
    EnergyConverterDetailQueryVariables
  >(EnergyConverterDetailDocument, options);
}
export function useEnergyConverterDetailLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    EnergyConverterDetailQuery,
    EnergyConverterDetailQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    EnergyConverterDetailQuery,
    EnergyConverterDetailQueryVariables
  >(EnergyConverterDetailDocument, options);
}
export type EnergyConverterDetailQueryHookResult = ReturnType<
  typeof useEnergyConverterDetailQuery
>;
export type EnergyConverterDetailLazyQueryHookResult = ReturnType<
  typeof useEnergyConverterDetailLazyQuery
>;
export type EnergyConverterDetailQueryResult = Apollo.QueryResult<
  EnergyConverterDetailQuery,
  EnergyConverterDetailQueryVariables
>;
export const EnergyInverterDetailUpdatesDocument = gql`
  subscription EnergyInverterDetailUpdates($id: String!) {
    energyInverterEventsByIds(_ids: [$id]) {
      modelChangeOperation
      _id
      deviceId
      name
      type
      location
      propertyId
      unitId
      panelId
      sourceId
      updateStatus
      timestamp
      meta {
        name
        metrics
      }
      installation {
        status
        message
      }
      powerState {
        value
        timestamp
      }
      typeDisplayName
      isConfigured
      isPoweredOn
      deviceIdentifier
      hasPendingUpdates
      isControlled
      powerRating {
        value
        timestamp
        units
      }
      powerInputBattery {
        value
        timestamp
        units
      }
      powerInputKinetic {
        value
        timestamp
        units
      }
      powerOutput {
        value
        timestamp
        units
      }
      reactivePower {
        value
        timestamp
        units
      }
      voltageOutput {
        value
        timestamp
        units
      }
      frequency {
        value
        timestamp
        units
      }
      efficiency {
        value
        timestamp
        units
      }
      inverterTemperature {
        value
        timestamp
        units
      }
      chargeRate {
        value
        timestamp
        units
      }
      dischargeRate {
        value
        timestamp
        units
      }
      availabilityStatus {
        value
        timestamp
      }
      controllerId
      rectifierId
      chartTypes
      property {
        _id
        title
      }
      unit {
        _id
        name
      }
      panel {
        _id
        name
        displayName
      }
      source {
        _id
        name
      }
    }
  }
`;

/**
 * __useEnergyInverterDetailUpdatesSubscription__
 *
 * To run a query within a React component, call `useEnergyInverterDetailUpdatesSubscription` and pass it any options that fit your needs.
 * When your component renders, `useEnergyInverterDetailUpdatesSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEnergyInverterDetailUpdatesSubscription({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useEnergyInverterDetailUpdatesSubscription(
  baseOptions: Apollo.SubscriptionHookOptions<
    EnergyInverterDetailUpdatesSubscription,
    EnergyInverterDetailUpdatesSubscriptionVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useSubscription<
    EnergyInverterDetailUpdatesSubscription,
    EnergyInverterDetailUpdatesSubscriptionVariables
  >(EnergyInverterDetailUpdatesDocument, options);
}
export type EnergyInverterDetailUpdatesSubscriptionHookResult = ReturnType<
  typeof useEnergyInverterDetailUpdatesSubscription
>;
export type EnergyInverterDetailUpdatesSubscriptionResult =
  Apollo.SubscriptionResult<EnergyInverterDetailUpdatesSubscription>;
export const EnergyInverterDetailDocument = gql`
  query EnergyInverterDetail($id: String!) {
    energyInverterById(_id: $id) {
      _id
      deviceId
      name
      type
      location
      propertyId
      unitId
      panelId
      sourceId
      updateStatus
      timestamp
      meta {
        name
        metrics
      }
      installation {
        status
        message
      }
      powerState {
        value
        timestamp
      }
      typeDisplayName
      isConfigured
      isPoweredOn
      deviceIdentifier
      hasPendingUpdates
      isControlled
      powerRating {
        value
        timestamp
        units
      }
      powerInputBattery {
        value
        timestamp
        units
      }
      powerInputKinetic {
        value
        timestamp
        units
      }
      powerOutput {
        value
        timestamp
        units
      }
      reactivePower {
        value
        timestamp
        units
      }
      voltageOutput {
        value
        timestamp
        units
      }
      frequency {
        value
        timestamp
        units
      }
      efficiency {
        value
        timestamp
        units
      }
      inverterTemperature {
        value
        timestamp
        units
      }
      chargeRate {
        value
        timestamp
        units
      }
      dischargeRate {
        value
        timestamp
        units
      }
      availabilityStatus {
        value
        timestamp
      }
      controllerId
      rectifierId
      chartTypes
      property {
        _id
        title
      }
      unit {
        _id
        name
      }
      panel {
        _id
        name
        displayName
      }
      source {
        _id
        name
      }
    }
  }
`;

/**
 * __useEnergyInverterDetailQuery__
 *
 * To run a query within a React component, call `useEnergyInverterDetailQuery` and pass it any options that fit your needs.
 * When your component renders, `useEnergyInverterDetailQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEnergyInverterDetailQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useEnergyInverterDetailQuery(
  baseOptions: Apollo.QueryHookOptions<
    EnergyInverterDetailQuery,
    EnergyInverterDetailQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    EnergyInverterDetailQuery,
    EnergyInverterDetailQueryVariables
  >(EnergyInverterDetailDocument, options);
}
export function useEnergyInverterDetailLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    EnergyInverterDetailQuery,
    EnergyInverterDetailQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    EnergyInverterDetailQuery,
    EnergyInverterDetailQueryVariables
  >(EnergyInverterDetailDocument, options);
}
export type EnergyInverterDetailQueryHookResult = ReturnType<
  typeof useEnergyInverterDetailQuery
>;
export type EnergyInverterDetailLazyQueryHookResult = ReturnType<
  typeof useEnergyInverterDetailLazyQuery
>;
export type EnergyInverterDetailQueryResult = Apollo.QueryResult<
  EnergyInverterDetailQuery,
  EnergyInverterDetailQueryVariables
>;
export const EnergyMeterDetailUpdatesDocument = gql`
  subscription EnergyMeterDetailUpdates($id: String!) {
    energyMeterEventsByIds(_ids: [$id]) {
      modelChangeOperation
      _id
      deviceId
      name
      type
      location
      propertyId
      unitId
      panelId
      sourceId
      updateStatus
      timestamp
      meta {
        name
        metrics
      }
      installation {
        status
        message
      }
      powerState {
        value
        timestamp
      }
      typeDisplayName
      isConfigured
      isPoweredOn
      deviceIdentifier
      hasPendingUpdates
      isControlled
      energyConsumed {
        value
        timestamp
        units
      }
      powerDemand {
        value
        timestamp
        units
      }
      voltage {
        value
        timestamp
        units
      }
      current {
        value
        timestamp
        units
      }
      powerFactor {
        value
        timestamp
        units
      }
      frequency {
        value
        timestamp
        units
      }
      outputEnabled {
        value
        timestamp
      }
      chartTypes
      property {
        _id
        title
      }
      unit {
        _id
        name
      }
      panel {
        _id
        name
        displayName
      }
      source {
        _id
        name
      }
    }
  }
`;

/**
 * __useEnergyMeterDetailUpdatesSubscription__
 *
 * To run a query within a React component, call `useEnergyMeterDetailUpdatesSubscription` and pass it any options that fit your needs.
 * When your component renders, `useEnergyMeterDetailUpdatesSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEnergyMeterDetailUpdatesSubscription({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useEnergyMeterDetailUpdatesSubscription(
  baseOptions: Apollo.SubscriptionHookOptions<
    EnergyMeterDetailUpdatesSubscription,
    EnergyMeterDetailUpdatesSubscriptionVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useSubscription<
    EnergyMeterDetailUpdatesSubscription,
    EnergyMeterDetailUpdatesSubscriptionVariables
  >(EnergyMeterDetailUpdatesDocument, options);
}
export type EnergyMeterDetailUpdatesSubscriptionHookResult = ReturnType<
  typeof useEnergyMeterDetailUpdatesSubscription
>;
export type EnergyMeterDetailUpdatesSubscriptionResult =
  Apollo.SubscriptionResult<EnergyMeterDetailUpdatesSubscription>;
export const EnergyMeterDetailDocument = gql`
  query EnergyMeterDetail($id: String!) {
    energyMeterById(_id: $id) {
      _id
      deviceId
      name
      type
      location
      propertyId
      unitId
      panelId
      sourceId
      updateStatus
      timestamp
      meta {
        name
        metrics
      }
      installation {
        status
        message
      }
      powerState {
        value
        timestamp
      }
      typeDisplayName
      isConfigured
      isPoweredOn
      deviceIdentifier
      hasPendingUpdates
      isControlled
      energyConsumed {
        value
        timestamp
        units
      }
      powerDemand {
        value
        timestamp
        units
      }
      voltage {
        value
        timestamp
        units
      }
      current {
        value
        timestamp
        units
      }
      powerFactor {
        value
        timestamp
        units
      }
      frequency {
        value
        timestamp
        units
      }
      outputEnabled {
        value
        timestamp
      }
      chartTypes
      property {
        _id
        title
      }
      unit {
        _id
        name
      }
      panel {
        _id
        name
        displayName
      }
      source {
        _id
        name
      }
    }
  }
`;

/**
 * __useEnergyMeterDetailQuery__
 *
 * To run a query within a React component, call `useEnergyMeterDetailQuery` and pass it any options that fit your needs.
 * When your component renders, `useEnergyMeterDetailQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEnergyMeterDetailQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useEnergyMeterDetailQuery(
  baseOptions: Apollo.QueryHookOptions<
    EnergyMeterDetailQuery,
    EnergyMeterDetailQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    EnergyMeterDetailQuery,
    EnergyMeterDetailQueryVariables
  >(EnergyMeterDetailDocument, options);
}
export function useEnergyMeterDetailLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    EnergyMeterDetailQuery,
    EnergyMeterDetailQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    EnergyMeterDetailQuery,
    EnergyMeterDetailQueryVariables
  >(EnergyMeterDetailDocument, options);
}
export type EnergyMeterDetailQueryHookResult = ReturnType<
  typeof useEnergyMeterDetailQuery
>;
export type EnergyMeterDetailLazyQueryHookResult = ReturnType<
  typeof useEnergyMeterDetailLazyQuery
>;
export type EnergyMeterDetailQueryResult = Apollo.QueryResult<
  EnergyMeterDetailQuery,
  EnergyMeterDetailQueryVariables
>;
export const EnergyRectifierDetailUpdatesDocument = gql`
  subscription EnergyRectifierDetailUpdates($id: String!) {
    energyRectifierEventsByIds(_ids: [$id]) {
      modelChangeOperation
      _id
      deviceId
      name
      type
      location
      propertyId
      unitId
      panelId
      sourceId
      updateStatus
      timestamp
      meta {
        name
        metrics
      }
      installation {
        status
        message
      }
      powerState {
        value
        timestamp
      }
      powerState {
        value
        timestamp
      }
      typeDisplayName
      isConfigured
      isPoweredOn
      deviceIdentifier
      hasPendingUpdates
      isControlled
      outputVoltage {
        value
        timestamp
        units
      }
      rectifierEfficiency {
        value
        timestamp
        units
      }
      chartTypes
      property {
        _id
        title
      }
      unit {
        _id
        name
      }
      panel {
        _id
        name
        displayName
      }
      source {
        _id
        name
      }
    }
  }
`;

/**
 * __useEnergyRectifierDetailUpdatesSubscription__
 *
 * To run a query within a React component, call `useEnergyRectifierDetailUpdatesSubscription` and pass it any options that fit your needs.
 * When your component renders, `useEnergyRectifierDetailUpdatesSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEnergyRectifierDetailUpdatesSubscription({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useEnergyRectifierDetailUpdatesSubscription(
  baseOptions: Apollo.SubscriptionHookOptions<
    EnergyRectifierDetailUpdatesSubscription,
    EnergyRectifierDetailUpdatesSubscriptionVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useSubscription<
    EnergyRectifierDetailUpdatesSubscription,
    EnergyRectifierDetailUpdatesSubscriptionVariables
  >(EnergyRectifierDetailUpdatesDocument, options);
}
export type EnergyRectifierDetailUpdatesSubscriptionHookResult = ReturnType<
  typeof useEnergyRectifierDetailUpdatesSubscription
>;
export type EnergyRectifierDetailUpdatesSubscriptionResult =
  Apollo.SubscriptionResult<EnergyRectifierDetailUpdatesSubscription>;
export const EnergyRectifierDetailDocument = gql`
  query EnergyRectifierDetail($id: String!) {
    energyRectifierById(_id: $id) {
      _id
      deviceId
      name
      type
      location
      propertyId
      unitId
      panelId
      sourceId
      updateStatus
      timestamp
      meta {
        name
        metrics
      }
      installation {
        status
        message
      }
      powerState {
        value
        timestamp
      }
      powerState {
        value
        timestamp
      }
      typeDisplayName
      isConfigured
      isPoweredOn
      deviceIdentifier
      hasPendingUpdates
      isControlled
      outputVoltage {
        value
        timestamp
        units
      }
      rectifierEfficiency {
        value
        timestamp
        units
      }
      chartTypes
      property {
        _id
        title
      }
      unit {
        _id
        name
      }
      panel {
        _id
        name
        displayName
      }
      source {
        _id
        name
      }
    }
  }
`;

/**
 * __useEnergyRectifierDetailQuery__
 *
 * To run a query within a React component, call `useEnergyRectifierDetailQuery` and pass it any options that fit your needs.
 * When your component renders, `useEnergyRectifierDetailQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEnergyRectifierDetailQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useEnergyRectifierDetailQuery(
  baseOptions: Apollo.QueryHookOptions<
    EnergyRectifierDetailQuery,
    EnergyRectifierDetailQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    EnergyRectifierDetailQuery,
    EnergyRectifierDetailQueryVariables
  >(EnergyRectifierDetailDocument, options);
}
export function useEnergyRectifierDetailLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    EnergyRectifierDetailQuery,
    EnergyRectifierDetailQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    EnergyRectifierDetailQuery,
    EnergyRectifierDetailQueryVariables
  >(EnergyRectifierDetailDocument, options);
}
export type EnergyRectifierDetailQueryHookResult = ReturnType<
  typeof useEnergyRectifierDetailQuery
>;
export type EnergyRectifierDetailLazyQueryHookResult = ReturnType<
  typeof useEnergyRectifierDetailLazyQuery
>;
export type EnergyRectifierDetailQueryResult = Apollo.QueryResult<
  EnergyRectifierDetailQuery,
  EnergyRectifierDetailQueryVariables
>;
export const EnergyStorageBatterySystemDetailUpdatesDocument = gql`
  subscription EnergyStorageBatterySystemDetailUpdates($id: String!) {
    energyStorageBatterySystemEventsByIds(_ids: [$id]) {
      modelChangeOperation
      _id
      name
      location
      propertyId
      unitId
      vppId
      updateStatus
      timestamp
      powerState {
        value
        timestamp
        units
      }
      connected {
        value
        units
        timestamp
      }
      lastConnectedAt {
        value
        units
        timestamp
      }
      disconnectedAt {
        value
        units
        timestamp
      }
      maximumEnergyCapacity {
        value
        timestamp
        units
      }
      maintenanceScheduleStatus {
        value
        timestamp
        units
      }
      batteryManagementSystemId
      chartTypes
      controllerId
      inverterId
      coolingSystemId
      fireSuppressionSystemId
      converterId
    }
  }
`;

/**
 * __useEnergyStorageBatterySystemDetailUpdatesSubscription__
 *
 * To run a query within a React component, call `useEnergyStorageBatterySystemDetailUpdatesSubscription` and pass it any options that fit your needs.
 * When your component renders, `useEnergyStorageBatterySystemDetailUpdatesSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEnergyStorageBatterySystemDetailUpdatesSubscription({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useEnergyStorageBatterySystemDetailUpdatesSubscription(
  baseOptions: Apollo.SubscriptionHookOptions<
    EnergyStorageBatterySystemDetailUpdatesSubscription,
    EnergyStorageBatterySystemDetailUpdatesSubscriptionVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useSubscription<
    EnergyStorageBatterySystemDetailUpdatesSubscription,
    EnergyStorageBatterySystemDetailUpdatesSubscriptionVariables
  >(EnergyStorageBatterySystemDetailUpdatesDocument, options);
}
export type EnergyStorageBatterySystemDetailUpdatesSubscriptionHookResult =
  ReturnType<typeof useEnergyStorageBatterySystemDetailUpdatesSubscription>;
export type EnergyStorageBatterySystemDetailUpdatesSubscriptionResult =
  Apollo.SubscriptionResult<EnergyStorageBatterySystemDetailUpdatesSubscription>;
export const EnergyStorageBatterySystemDetailDocument = gql`
  query EnergyStorageBatterySystemDetail($id: String!) {
    energyStorageBatterySystemById(_id: $id) {
      _id
      name
      location
      propertyId
      unitId
      vppId
      updateStatus
      timestamp
      powerState {
        value
        timestamp
        units
      }
      connected {
        value
        units
        timestamp
      }
      lastConnectedAt {
        value
        units
        timestamp
      }
      disconnectedAt {
        value
        units
        timestamp
      }
      maximumEnergyCapacity {
        value
        timestamp
        units
      }
      maintenanceScheduleStatus {
        value
        timestamp
        units
      }
      batteryManagementSystemId
      chartTypes
      controllerId
      inverterId
      coolingSystemId
      fireSuppressionSystemId
      converterId
    }
  }
`;

/**
 * __useEnergyStorageBatterySystemDetailQuery__
 *
 * To run a query within a React component, call `useEnergyStorageBatterySystemDetailQuery` and pass it any options that fit your needs.
 * When your component renders, `useEnergyStorageBatterySystemDetailQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEnergyStorageBatterySystemDetailQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useEnergyStorageBatterySystemDetailQuery(
  baseOptions: Apollo.QueryHookOptions<
    EnergyStorageBatterySystemDetailQuery,
    EnergyStorageBatterySystemDetailQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    EnergyStorageBatterySystemDetailQuery,
    EnergyStorageBatterySystemDetailQueryVariables
  >(EnergyStorageBatterySystemDetailDocument, options);
}
export function useEnergyStorageBatterySystemDetailLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    EnergyStorageBatterySystemDetailQuery,
    EnergyStorageBatterySystemDetailQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    EnergyStorageBatterySystemDetailQuery,
    EnergyStorageBatterySystemDetailQueryVariables
  >(EnergyStorageBatterySystemDetailDocument, options);
}
export type EnergyStorageBatterySystemDetailQueryHookResult = ReturnType<
  typeof useEnergyStorageBatterySystemDetailQuery
>;
export type EnergyStorageBatterySystemDetailLazyQueryHookResult = ReturnType<
  typeof useEnergyStorageBatterySystemDetailLazyQuery
>;
export type EnergyStorageBatterySystemDetailQueryResult = Apollo.QueryResult<
  EnergyStorageBatterySystemDetailQuery,
  EnergyStorageBatterySystemDetailQueryVariables
>;
export const EnergyStorageCoolingSystemDetailUpdatesDocument = gql`
  subscription EnergyStorageCoolingSystemDetailUpdates($id: String!) {
    energyStorageCoolingSystemEventsByIds(_ids: [$id]) {
      modelChangeOperation
      _id
      deviceId
      name
      type
      location
      propertyId
      unitId
      panelId
      sourceId
      updateStatus
      timestamp
      meta {
        name
        metrics
      }
      installation {
        status
        message
      }
      powerState {
        value
        timestamp
      }
      typeDisplayName
      isConfigured
      isPoweredOn
      deviceIdentifier
      hasPendingUpdates
      isControlled
      temperature {
        value
        timestamp
        units
      }
      coolingHeatingStatus {
        value
        timestamp
        units
      }
      chartTypes
      property {
        _id
        title
      }
      unit {
        _id
        name
      }
      panel {
        _id
        name
        displayName
      }
      source {
        _id
        name
      }
    }
  }
`;

/**
 * __useEnergyStorageCoolingSystemDetailUpdatesSubscription__
 *
 * To run a query within a React component, call `useEnergyStorageCoolingSystemDetailUpdatesSubscription` and pass it any options that fit your needs.
 * When your component renders, `useEnergyStorageCoolingSystemDetailUpdatesSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEnergyStorageCoolingSystemDetailUpdatesSubscription({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useEnergyStorageCoolingSystemDetailUpdatesSubscription(
  baseOptions: Apollo.SubscriptionHookOptions<
    EnergyStorageCoolingSystemDetailUpdatesSubscription,
    EnergyStorageCoolingSystemDetailUpdatesSubscriptionVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useSubscription<
    EnergyStorageCoolingSystemDetailUpdatesSubscription,
    EnergyStorageCoolingSystemDetailUpdatesSubscriptionVariables
  >(EnergyStorageCoolingSystemDetailUpdatesDocument, options);
}
export type EnergyStorageCoolingSystemDetailUpdatesSubscriptionHookResult =
  ReturnType<typeof useEnergyStorageCoolingSystemDetailUpdatesSubscription>;
export type EnergyStorageCoolingSystemDetailUpdatesSubscriptionResult =
  Apollo.SubscriptionResult<EnergyStorageCoolingSystemDetailUpdatesSubscription>;
export const EnergyStorageCoolingSystemDetailDocument = gql`
  query EnergyStorageCoolingSystemDetail($id: String!) {
    energyStorageCoolingSystemById(_id: $id) {
      _id
      deviceId
      name
      type
      location
      propertyId
      unitId
      panelId
      sourceId
      updateStatus
      timestamp
      meta {
        name
        metrics
      }
      installation {
        status
        message
      }
      powerState {
        value
        timestamp
      }
      typeDisplayName
      isConfigured
      isPoweredOn
      deviceIdentifier
      hasPendingUpdates
      isControlled
      temperature {
        value
        timestamp
        units
      }
      coolingHeatingStatus {
        value
        timestamp
        units
      }
      chartTypes
      property {
        _id
        title
      }
      unit {
        _id
        name
      }
      panel {
        _id
        name
        displayName
      }
      source {
        _id
        name
      }
    }
  }
`;

/**
 * __useEnergyStorageCoolingSystemDetailQuery__
 *
 * To run a query within a React component, call `useEnergyStorageCoolingSystemDetailQuery` and pass it any options that fit your needs.
 * When your component renders, `useEnergyStorageCoolingSystemDetailQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEnergyStorageCoolingSystemDetailQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useEnergyStorageCoolingSystemDetailQuery(
  baseOptions: Apollo.QueryHookOptions<
    EnergyStorageCoolingSystemDetailQuery,
    EnergyStorageCoolingSystemDetailQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    EnergyStorageCoolingSystemDetailQuery,
    EnergyStorageCoolingSystemDetailQueryVariables
  >(EnergyStorageCoolingSystemDetailDocument, options);
}
export function useEnergyStorageCoolingSystemDetailLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    EnergyStorageCoolingSystemDetailQuery,
    EnergyStorageCoolingSystemDetailQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    EnergyStorageCoolingSystemDetailQuery,
    EnergyStorageCoolingSystemDetailQueryVariables
  >(EnergyStorageCoolingSystemDetailDocument, options);
}
export type EnergyStorageCoolingSystemDetailQueryHookResult = ReturnType<
  typeof useEnergyStorageCoolingSystemDetailQuery
>;
export type EnergyStorageCoolingSystemDetailLazyQueryHookResult = ReturnType<
  typeof useEnergyStorageCoolingSystemDetailLazyQuery
>;
export type EnergyStorageCoolingSystemDetailQueryResult = Apollo.QueryResult<
  EnergyStorageCoolingSystemDetailQuery,
  EnergyStorageCoolingSystemDetailQueryVariables
>;
export const EnergyStorageKineticSystemDetailUpdatesDocument = gql`
  subscription EnergyStorageKineticSystemDetailUpdates($id: String!) {
    energyStorageKineticSystemEventsByIds(_ids: [$id]) {
      modelChangeOperation
      _id
      name
      location
      propertyId
      unitId
      vppId
      updateStatus
      timestamp
      powerState {
        value
        timestamp
        units
      }
      connected {
        value
        timestamp
      }
      lastConnectedAt {
        value
        timestamp
      }
      disconnectedAt {
        value
        timestamp
      }
      chartTypes
      maximumEnergyCapacity {
        value
        timestamp
        units
      }
      maintenanceScheduleStatus {
        value
        timestamp
        units
      }
      kemsId
      controllerId
      inverterId
      coolingSystemId
      fireSuppressionSystemId
      converterId
    }
  }
`;

/**
 * __useEnergyStorageKineticSystemDetailUpdatesSubscription__
 *
 * To run a query within a React component, call `useEnergyStorageKineticSystemDetailUpdatesSubscription` and pass it any options that fit your needs.
 * When your component renders, `useEnergyStorageKineticSystemDetailUpdatesSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEnergyStorageKineticSystemDetailUpdatesSubscription({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useEnergyStorageKineticSystemDetailUpdatesSubscription(
  baseOptions: Apollo.SubscriptionHookOptions<
    EnergyStorageKineticSystemDetailUpdatesSubscription,
    EnergyStorageKineticSystemDetailUpdatesSubscriptionVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useSubscription<
    EnergyStorageKineticSystemDetailUpdatesSubscription,
    EnergyStorageKineticSystemDetailUpdatesSubscriptionVariables
  >(EnergyStorageKineticSystemDetailUpdatesDocument, options);
}
export type EnergyStorageKineticSystemDetailUpdatesSubscriptionHookResult =
  ReturnType<typeof useEnergyStorageKineticSystemDetailUpdatesSubscription>;
export type EnergyStorageKineticSystemDetailUpdatesSubscriptionResult =
  Apollo.SubscriptionResult<EnergyStorageKineticSystemDetailUpdatesSubscription>;
export const EnergyStorageKineticSystemDetailDocument = gql`
  query EnergyStorageKineticSystemDetail($id: String!) {
    energyStorageKineticSystemById(_id: $id) {
      _id
      name
      location
      propertyId
      unitId
      vppId
      updateStatus
      timestamp
      powerState {
        value
        timestamp
        units
      }
      connected {
        value
        timestamp
      }
      lastConnectedAt {
        value
        timestamp
      }
      disconnectedAt {
        value
        timestamp
      }
      chartTypes
      maximumEnergyCapacity {
        value
        timestamp
        units
      }
      maintenanceScheduleStatus {
        value
        timestamp
        units
      }
      kemsId
      controllerId
      inverterId
      coolingSystemId
      fireSuppressionSystemId
      converterId
    }
  }
`;

/**
 * __useEnergyStorageKineticSystemDetailQuery__
 *
 * To run a query within a React component, call `useEnergyStorageKineticSystemDetailQuery` and pass it any options that fit your needs.
 * When your component renders, `useEnergyStorageKineticSystemDetailQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEnergyStorageKineticSystemDetailQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useEnergyStorageKineticSystemDetailQuery(
  baseOptions: Apollo.QueryHookOptions<
    EnergyStorageKineticSystemDetailQuery,
    EnergyStorageKineticSystemDetailQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    EnergyStorageKineticSystemDetailQuery,
    EnergyStorageKineticSystemDetailQueryVariables
  >(EnergyStorageKineticSystemDetailDocument, options);
}
export function useEnergyStorageKineticSystemDetailLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    EnergyStorageKineticSystemDetailQuery,
    EnergyStorageKineticSystemDetailQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    EnergyStorageKineticSystemDetailQuery,
    EnergyStorageKineticSystemDetailQueryVariables
  >(EnergyStorageKineticSystemDetailDocument, options);
}
export type EnergyStorageKineticSystemDetailQueryHookResult = ReturnType<
  typeof useEnergyStorageKineticSystemDetailQuery
>;
export type EnergyStorageKineticSystemDetailLazyQueryHookResult = ReturnType<
  typeof useEnergyStorageKineticSystemDetailLazyQuery
>;
export type EnergyStorageKineticSystemDetailQueryResult = Apollo.QueryResult<
  EnergyStorageKineticSystemDetailQuery,
  EnergyStorageKineticSystemDetailQueryVariables
>;
export const EnergySupplierSolarSystemDetailUpdatesDocument = gql`
  subscription EnergySupplierSolarSystemDetailUpdates($id: String!) {
    energySupplierSolarSystemEventsByIds(_ids: [$id]) {
      modelChangeOperation
      _id
      name
      location
      propertyId
      unitId
      vppId
      updateStatus
      timestamp
      powerState {
        value
        timestamp
        units
      }
      connected {
        value
        timestamp
      }
      lastConnectedAt {
        value
        timestamp
      }
      disconnectedAt {
        value
        timestamp
      }
      maximumPowerOutput
      inverterId
      controllerId
      smsId
      tiltAngle {
        value
        timestamp
        units
      }
      azimuth {
        value
        timestamp
        units
      }
      chartTypes
    }
  }
`;

/**
 * __useEnergySupplierSolarSystemDetailUpdatesSubscription__
 *
 * To run a query within a React component, call `useEnergySupplierSolarSystemDetailUpdatesSubscription` and pass it any options that fit your needs.
 * When your component renders, `useEnergySupplierSolarSystemDetailUpdatesSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEnergySupplierSolarSystemDetailUpdatesSubscription({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useEnergySupplierSolarSystemDetailUpdatesSubscription(
  baseOptions: Apollo.SubscriptionHookOptions<
    EnergySupplierSolarSystemDetailUpdatesSubscription,
    EnergySupplierSolarSystemDetailUpdatesSubscriptionVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useSubscription<
    EnergySupplierSolarSystemDetailUpdatesSubscription,
    EnergySupplierSolarSystemDetailUpdatesSubscriptionVariables
  >(EnergySupplierSolarSystemDetailUpdatesDocument, options);
}
export type EnergySupplierSolarSystemDetailUpdatesSubscriptionHookResult =
  ReturnType<typeof useEnergySupplierSolarSystemDetailUpdatesSubscription>;
export type EnergySupplierSolarSystemDetailUpdatesSubscriptionResult =
  Apollo.SubscriptionResult<EnergySupplierSolarSystemDetailUpdatesSubscription>;
export const EnergySupplierSolarSystemDetailDocument = gql`
  query EnergySupplierSolarSystemDetail($id: String!) {
    energySupplierSolarSystemById(_id: $id) {
      _id
      name
      location
      propertyId
      unitId
      vppId
      updateStatus
      timestamp
      powerState {
        value
        timestamp
        units
      }
      connected {
        value
        timestamp
      }
      lastConnectedAt {
        value
        timestamp
      }
      disconnectedAt {
        value
        timestamp
      }
      maximumPowerOutput
      inverterId
      controllerId
      smsId
      tiltAngle {
        value
        timestamp
        units
      }
      azimuth {
        value
        timestamp
        units
      }
      chartTypes
    }
  }
`;

/**
 * __useEnergySupplierSolarSystemDetailQuery__
 *
 * To run a query within a React component, call `useEnergySupplierSolarSystemDetailQuery` and pass it any options that fit your needs.
 * When your component renders, `useEnergySupplierSolarSystemDetailQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEnergySupplierSolarSystemDetailQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useEnergySupplierSolarSystemDetailQuery(
  baseOptions: Apollo.QueryHookOptions<
    EnergySupplierSolarSystemDetailQuery,
    EnergySupplierSolarSystemDetailQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    EnergySupplierSolarSystemDetailQuery,
    EnergySupplierSolarSystemDetailQueryVariables
  >(EnergySupplierSolarSystemDetailDocument, options);
}
export function useEnergySupplierSolarSystemDetailLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    EnergySupplierSolarSystemDetailQuery,
    EnergySupplierSolarSystemDetailQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    EnergySupplierSolarSystemDetailQuery,
    EnergySupplierSolarSystemDetailQueryVariables
  >(EnergySupplierSolarSystemDetailDocument, options);
}
export type EnergySupplierSolarSystemDetailQueryHookResult = ReturnType<
  typeof useEnergySupplierSolarSystemDetailQuery
>;
export type EnergySupplierSolarSystemDetailLazyQueryHookResult = ReturnType<
  typeof useEnergySupplierSolarSystemDetailLazyQuery
>;
export type EnergySupplierSolarSystemDetailQueryResult = Apollo.QueryResult<
  EnergySupplierSolarSystemDetailQuery,
  EnergySupplierSolarSystemDetailQueryVariables
>;
export const EnergySupplierUtilityDetailUpdatesDocument = gql`
  subscription EnergySupplierUtilityDetailUpdates($id: String!) {
    energySupplierUtilityEventsByIds(_ids: [$id]) {
      modelChangeOperation
      _id
      name
      location
      propertyId
      unitId
      vppId
      updateStatus
      timestamp
      powerState {
        value
        timestamp
        units
      }
      contractedCapacity {
        value
        timestamp
        units
      }
      tariffRate {
        value
        timestamp
        units
      }
      meteringAccuracy {
        value
        timestamp
        units
      }
      connected {
        value
        timestamp
      }
      lastConnectedAt {
        value
        timestamp
      }
      disconnectedAt {
        value
        timestamp
      }
      maximumPowerOutput
      chartTypes
      inverterId
      controllerId
    }
  }
`;

/**
 * __useEnergySupplierUtilityDetailUpdatesSubscription__
 *
 * To run a query within a React component, call `useEnergySupplierUtilityDetailUpdatesSubscription` and pass it any options that fit your needs.
 * When your component renders, `useEnergySupplierUtilityDetailUpdatesSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEnergySupplierUtilityDetailUpdatesSubscription({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useEnergySupplierUtilityDetailUpdatesSubscription(
  baseOptions: Apollo.SubscriptionHookOptions<
    EnergySupplierUtilityDetailUpdatesSubscription,
    EnergySupplierUtilityDetailUpdatesSubscriptionVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useSubscription<
    EnergySupplierUtilityDetailUpdatesSubscription,
    EnergySupplierUtilityDetailUpdatesSubscriptionVariables
  >(EnergySupplierUtilityDetailUpdatesDocument, options);
}
export type EnergySupplierUtilityDetailUpdatesSubscriptionHookResult =
  ReturnType<typeof useEnergySupplierUtilityDetailUpdatesSubscription>;
export type EnergySupplierUtilityDetailUpdatesSubscriptionResult =
  Apollo.SubscriptionResult<EnergySupplierUtilityDetailUpdatesSubscription>;
export const EnergySupplierUtilityDetailDocument = gql`
  query EnergySupplierUtilityDetail($id: String!) {
    energySupplierUtilityById(_id: $id) {
      _id
      name
      location
      propertyId
      unitId
      vppId
      updateStatus
      timestamp
      powerState {
        value
        timestamp
        units
      }
      contractedCapacity {
        value
        timestamp
        units
      }
      tariffRate {
        value
        timestamp
        units
      }
      meteringAccuracy {
        value
        timestamp
        units
      }
      connected {
        value
        timestamp
      }
      lastConnectedAt {
        value
        timestamp
      }
      disconnectedAt {
        value
        timestamp
      }
      maximumPowerOutput
      chartTypes
      inverterId
      controllerId
    }
  }
`;

/**
 * __useEnergySupplierUtilityDetailQuery__
 *
 * To run a query within a React component, call `useEnergySupplierUtilityDetailQuery` and pass it any options that fit your needs.
 * When your component renders, `useEnergySupplierUtilityDetailQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEnergySupplierUtilityDetailQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useEnergySupplierUtilityDetailQuery(
  baseOptions: Apollo.QueryHookOptions<
    EnergySupplierUtilityDetailQuery,
    EnergySupplierUtilityDetailQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    EnergySupplierUtilityDetailQuery,
    EnergySupplierUtilityDetailQueryVariables
  >(EnergySupplierUtilityDetailDocument, options);
}
export function useEnergySupplierUtilityDetailLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    EnergySupplierUtilityDetailQuery,
    EnergySupplierUtilityDetailQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    EnergySupplierUtilityDetailQuery,
    EnergySupplierUtilityDetailQueryVariables
  >(EnergySupplierUtilityDetailDocument, options);
}
export type EnergySupplierUtilityDetailQueryHookResult = ReturnType<
  typeof useEnergySupplierUtilityDetailQuery
>;
export type EnergySupplierUtilityDetailLazyQueryHookResult = ReturnType<
  typeof useEnergySupplierUtilityDetailLazyQuery
>;
export type EnergySupplierUtilityDetailQueryResult = Apollo.QueryResult<
  EnergySupplierUtilityDetailQuery,
  EnergySupplierUtilityDetailQueryVariables
>;
export const EnergySupplierWindSystemDetailUpdatesDocument = gql`
  subscription EnergySupplierWindSystemDetailUpdates($id: String!) {
    energySupplierWindSystemEventsByIds(_ids: [$id]) {
      modelChangeOperation
      _id
      name
      location
      propertyId
      unitId
      vppId
      updateStatus
      timestamp
      powerState {
        value
        timestamp
      }
      connected {
        value
        timestamp
      }
      lastConnectedAt {
        value
        timestamp
      }
      disconnectedAt {
        value
        timestamp
      }
      maximumPowerOutput
      inverterId
      controllerId
      cutInSpeed {
        value
        timestamp
        units
      }
      cutOutSpeed {
        value
        timestamp
        units
      }
      modeOfOperation {
        value
        timestamp
      }
      chartTypes
      wmsId
      rectifierId
    }
  }
`;

/**
 * __useEnergySupplierWindSystemDetailUpdatesSubscription__
 *
 * To run a query within a React component, call `useEnergySupplierWindSystemDetailUpdatesSubscription` and pass it any options that fit your needs.
 * When your component renders, `useEnergySupplierWindSystemDetailUpdatesSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEnergySupplierWindSystemDetailUpdatesSubscription({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useEnergySupplierWindSystemDetailUpdatesSubscription(
  baseOptions: Apollo.SubscriptionHookOptions<
    EnergySupplierWindSystemDetailUpdatesSubscription,
    EnergySupplierWindSystemDetailUpdatesSubscriptionVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useSubscription<
    EnergySupplierWindSystemDetailUpdatesSubscription,
    EnergySupplierWindSystemDetailUpdatesSubscriptionVariables
  >(EnergySupplierWindSystemDetailUpdatesDocument, options);
}
export type EnergySupplierWindSystemDetailUpdatesSubscriptionHookResult =
  ReturnType<typeof useEnergySupplierWindSystemDetailUpdatesSubscription>;
export type EnergySupplierWindSystemDetailUpdatesSubscriptionResult =
  Apollo.SubscriptionResult<EnergySupplierWindSystemDetailUpdatesSubscription>;
export const EnergySupplierWindSystemDetailDocument = gql`
  query EnergySupplierWindSystemDetail($id: String!) {
    energySupplierWindSystemById(_id: $id) {
      _id
      name
      location
      propertyId
      unitId
      vppId
      updateStatus
      timestamp
      powerState {
        value
        timestamp
      }
      connected {
        value
        timestamp
      }
      lastConnectedAt {
        value
        timestamp
      }
      disconnectedAt {
        value
        timestamp
      }
      maximumPowerOutput
      inverterId
      controllerId
      cutInSpeed {
        value
        timestamp
        units
      }
      cutOutSpeed {
        value
        timestamp
        units
      }
      modeOfOperation {
        value
        timestamp
      }
      chartTypes
      wmsId
      rectifierId
    }
  }
`;

/**
 * __useEnergySupplierWindSystemDetailQuery__
 *
 * To run a query within a React component, call `useEnergySupplierWindSystemDetailQuery` and pass it any options that fit your needs.
 * When your component renders, `useEnergySupplierWindSystemDetailQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEnergySupplierWindSystemDetailQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useEnergySupplierWindSystemDetailQuery(
  baseOptions: Apollo.QueryHookOptions<
    EnergySupplierWindSystemDetailQuery,
    EnergySupplierWindSystemDetailQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    EnergySupplierWindSystemDetailQuery,
    EnergySupplierWindSystemDetailQueryVariables
  >(EnergySupplierWindSystemDetailDocument, options);
}
export function useEnergySupplierWindSystemDetailLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    EnergySupplierWindSystemDetailQuery,
    EnergySupplierWindSystemDetailQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    EnergySupplierWindSystemDetailQuery,
    EnergySupplierWindSystemDetailQueryVariables
  >(EnergySupplierWindSystemDetailDocument, options);
}
export type EnergySupplierWindSystemDetailQueryHookResult = ReturnType<
  typeof useEnergySupplierWindSystemDetailQuery
>;
export type EnergySupplierWindSystemDetailLazyQueryHookResult = ReturnType<
  typeof useEnergySupplierWindSystemDetailLazyQuery
>;
export type EnergySupplierWindSystemDetailQueryResult = Apollo.QueryResult<
  EnergySupplierWindSystemDetailQuery,
  EnergySupplierWindSystemDetailQueryVariables
>;
export const EnergySwitchPanelCircuitDetailUpdatesDocument = gql`
  subscription EnergySwitchPanelCircuitDetailUpdates($id: String!) {
    energySwitchPanelCircuitEventsByIds(_ids: [$id]) {
      modelChangeOperation
      _id
      deviceId
      name
      type
      location
      propertyId
      unitId
      panelId
      sourceId
      updateStatus
      timestamp
      meta {
        name
        metrics
      }
      installation {
        status
        message
      }
      powerState {
        value
        timestamp
      }
      typeDisplayName
      isConfigured
      isPoweredOn
      deviceIdentifier
      hasPendingUpdates
      isControlled
      energySwitchPanelId
      energyConsumed {
        value
        timestamp
        units
      }
      powerDemand {
        value
        timestamp
        units
      }
      voltage {
        value
        timestamp
        units
      }
      current {
        value
        timestamp
        units
      }
      powerFactor {
        value
        timestamp
        units
      }
      frequency {
        value
        timestamp
        units
      }
      outputEnabled {
        value
        timestamp
      }
      chartTypes
      property {
        _id
        title
      }
      unit {
        _id
        name
      }
      panel {
        _id
        name
        displayName
      }
      source {
        _id
        name
      }
    }
  }
`;

/**
 * __useEnergySwitchPanelCircuitDetailUpdatesSubscription__
 *
 * To run a query within a React component, call `useEnergySwitchPanelCircuitDetailUpdatesSubscription` and pass it any options that fit your needs.
 * When your component renders, `useEnergySwitchPanelCircuitDetailUpdatesSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEnergySwitchPanelCircuitDetailUpdatesSubscription({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useEnergySwitchPanelCircuitDetailUpdatesSubscription(
  baseOptions: Apollo.SubscriptionHookOptions<
    EnergySwitchPanelCircuitDetailUpdatesSubscription,
    EnergySwitchPanelCircuitDetailUpdatesSubscriptionVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useSubscription<
    EnergySwitchPanelCircuitDetailUpdatesSubscription,
    EnergySwitchPanelCircuitDetailUpdatesSubscriptionVariables
  >(EnergySwitchPanelCircuitDetailUpdatesDocument, options);
}
export type EnergySwitchPanelCircuitDetailUpdatesSubscriptionHookResult =
  ReturnType<typeof useEnergySwitchPanelCircuitDetailUpdatesSubscription>;
export type EnergySwitchPanelCircuitDetailUpdatesSubscriptionResult =
  Apollo.SubscriptionResult<EnergySwitchPanelCircuitDetailUpdatesSubscription>;
export const EnergySwitchPanelCircuitDetailDocument = gql`
  query EnergySwitchPanelCircuitDetail($id: String!) {
    energySwitchPanelCircuitById(_id: $id) {
      _id
      deviceId
      name
      type
      location
      propertyId
      unitId
      panelId
      sourceId
      updateStatus
      timestamp
      meta {
        name
        metrics
      }
      installation {
        status
        message
      }
      powerState {
        value
        timestamp
      }
      typeDisplayName
      isConfigured
      isPoweredOn
      deviceIdentifier
      hasPendingUpdates
      isControlled
      energySwitchPanelId
      energyConsumed {
        value
        timestamp
        units
      }
      powerDemand {
        value
        timestamp
        units
      }
      voltage {
        value
        timestamp
        units
      }
      current {
        value
        timestamp
        units
      }
      powerFactor {
        value
        timestamp
        units
      }
      frequency {
        value
        timestamp
        units
      }
      outputEnabled {
        value
        timestamp
      }
      chartTypes
      property {
        _id
        title
      }
      unit {
        _id
        name
      }
      panel {
        _id
        name
        displayName
      }
      source {
        _id
        name
      }
    }
  }
`;

/**
 * __useEnergySwitchPanelCircuitDetailQuery__
 *
 * To run a query within a React component, call `useEnergySwitchPanelCircuitDetailQuery` and pass it any options that fit your needs.
 * When your component renders, `useEnergySwitchPanelCircuitDetailQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEnergySwitchPanelCircuitDetailQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useEnergySwitchPanelCircuitDetailQuery(
  baseOptions: Apollo.QueryHookOptions<
    EnergySwitchPanelCircuitDetailQuery,
    EnergySwitchPanelCircuitDetailQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    EnergySwitchPanelCircuitDetailQuery,
    EnergySwitchPanelCircuitDetailQueryVariables
  >(EnergySwitchPanelCircuitDetailDocument, options);
}
export function useEnergySwitchPanelCircuitDetailLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    EnergySwitchPanelCircuitDetailQuery,
    EnergySwitchPanelCircuitDetailQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    EnergySwitchPanelCircuitDetailQuery,
    EnergySwitchPanelCircuitDetailQueryVariables
  >(EnergySwitchPanelCircuitDetailDocument, options);
}
export type EnergySwitchPanelCircuitDetailQueryHookResult = ReturnType<
  typeof useEnergySwitchPanelCircuitDetailQuery
>;
export type EnergySwitchPanelCircuitDetailLazyQueryHookResult = ReturnType<
  typeof useEnergySwitchPanelCircuitDetailLazyQuery
>;
export type EnergySwitchPanelCircuitDetailQueryResult = Apollo.QueryResult<
  EnergySwitchPanelCircuitDetailQuery,
  EnergySwitchPanelCircuitDetailQueryVariables
>;
export const EnergySwitchPanelDetailUpdatesDocument = gql`
  subscription EnergySwitchPanelDetailUpdates($id: String!) {
    energySwitchPanelEventsByIds(_ids: [$id]) {
      modelChangeOperation
      _id
      deviceId
      name
      type
      location
      propertyId
      unitId
      panelId
      sourceId
      updateStatus
      timestamp
      meta {
        name
        metrics
      }
      installation {
        status
        message
      }
      powerState {
        value
        timestamp
      }
      typeDisplayName
      isConfigured
      isPoweredOn
      deviceIdentifier
      hasPendingUpdates
      isControlled
      powerInput {
        value
        timestamp
        units
      }
      maxCircuits
      chartTypes
      property {
        _id
        title
      }
      unit {
        _id
        name
      }
      panel {
        _id
        name
        displayName
      }
      source {
        _id
        name
      }
      dependentDeviceIds
    }
  }
`;

/**
 * __useEnergySwitchPanelDetailUpdatesSubscription__
 *
 * To run a query within a React component, call `useEnergySwitchPanelDetailUpdatesSubscription` and pass it any options that fit your needs.
 * When your component renders, `useEnergySwitchPanelDetailUpdatesSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEnergySwitchPanelDetailUpdatesSubscription({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useEnergySwitchPanelDetailUpdatesSubscription(
  baseOptions: Apollo.SubscriptionHookOptions<
    EnergySwitchPanelDetailUpdatesSubscription,
    EnergySwitchPanelDetailUpdatesSubscriptionVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useSubscription<
    EnergySwitchPanelDetailUpdatesSubscription,
    EnergySwitchPanelDetailUpdatesSubscriptionVariables
  >(EnergySwitchPanelDetailUpdatesDocument, options);
}
export type EnergySwitchPanelDetailUpdatesSubscriptionHookResult = ReturnType<
  typeof useEnergySwitchPanelDetailUpdatesSubscription
>;
export type EnergySwitchPanelDetailUpdatesSubscriptionResult =
  Apollo.SubscriptionResult<EnergySwitchPanelDetailUpdatesSubscription>;
export const EnergySwitchPanelDetailDocument = gql`
  query EnergySwitchPanelDetail($id: String!) {
    energySwitchPanelById(_id: $id) {
      _id
      deviceId
      name
      type
      location
      propertyId
      unitId
      panelId
      sourceId
      updateStatus
      timestamp
      meta {
        name
        metrics
      }
      installation {
        status
        message
      }
      powerState {
        value
        timestamp
      }
      typeDisplayName
      isConfigured
      isPoweredOn
      deviceIdentifier
      hasPendingUpdates
      isControlled
      powerInput {
        value
        timestamp
        units
      }
      maxCircuits
      displayName
      chartTypes
      property {
        _id
        title
      }
      unit {
        _id
        name
      }
      panel {
        _id
        name
        displayName
      }
      source {
        _id
        name
      }
      dependentDeviceIds
    }
  }
`;

/**
 * __useEnergySwitchPanelDetailQuery__
 *
 * To run a query within a React component, call `useEnergySwitchPanelDetailQuery` and pass it any options that fit your needs.
 * When your component renders, `useEnergySwitchPanelDetailQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEnergySwitchPanelDetailQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useEnergySwitchPanelDetailQuery(
  baseOptions: Apollo.QueryHookOptions<
    EnergySwitchPanelDetailQuery,
    EnergySwitchPanelDetailQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    EnergySwitchPanelDetailQuery,
    EnergySwitchPanelDetailQueryVariables
  >(EnergySwitchPanelDetailDocument, options);
}
export function useEnergySwitchPanelDetailLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    EnergySwitchPanelDetailQuery,
    EnergySwitchPanelDetailQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    EnergySwitchPanelDetailQuery,
    EnergySwitchPanelDetailQueryVariables
  >(EnergySwitchPanelDetailDocument, options);
}
export type EnergySwitchPanelDetailQueryHookResult = ReturnType<
  typeof useEnergySwitchPanelDetailQuery
>;
export type EnergySwitchPanelDetailLazyQueryHookResult = ReturnType<
  typeof useEnergySwitchPanelDetailLazyQuery
>;
export type EnergySwitchPanelDetailQueryResult = Apollo.QueryResult<
  EnergySwitchPanelDetailQuery,
  EnergySwitchPanelDetailQueryVariables
>;
export const FireSuppressionSystemDetailUpdatesDocument = gql`
  subscription FireSuppressionSystemDetailUpdates($id: String!) {
    fireSuppressionSystemEventsByIds(_ids: [$id]) {
      modelChangeOperation
      _id
      deviceId
      name
      type
      location
      propertyId
      unitId
      panelId
      sourceId
      updateStatus
      timestamp
      meta {
        name
        metrics
      }
      installation {
        status
        message
      }
      powerState {
        value
        timestamp
      }
      typeDisplayName
      isConfigured
      isPoweredOn
      deviceIdentifier
      hasPendingUpdates
      isControlled
      fireSuppressionStatus {
        value
        timestamp
      }
      sensorStatus {
        value
        timestamp
      }
      suppressantLevel {
        value
        timestamp
        units
      }
      chartTypes
      property {
        _id
        title
      }
      unit {
        _id
        name
      }
      panel {
        _id
        name
        displayName
      }
      source {
        _id
        name
      }
    }
  }
`;

/**
 * __useFireSuppressionSystemDetailUpdatesSubscription__
 *
 * To run a query within a React component, call `useFireSuppressionSystemDetailUpdatesSubscription` and pass it any options that fit your needs.
 * When your component renders, `useFireSuppressionSystemDetailUpdatesSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFireSuppressionSystemDetailUpdatesSubscription({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useFireSuppressionSystemDetailUpdatesSubscription(
  baseOptions: Apollo.SubscriptionHookOptions<
    FireSuppressionSystemDetailUpdatesSubscription,
    FireSuppressionSystemDetailUpdatesSubscriptionVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useSubscription<
    FireSuppressionSystemDetailUpdatesSubscription,
    FireSuppressionSystemDetailUpdatesSubscriptionVariables
  >(FireSuppressionSystemDetailUpdatesDocument, options);
}
export type FireSuppressionSystemDetailUpdatesSubscriptionHookResult =
  ReturnType<typeof useFireSuppressionSystemDetailUpdatesSubscription>;
export type FireSuppressionSystemDetailUpdatesSubscriptionResult =
  Apollo.SubscriptionResult<FireSuppressionSystemDetailUpdatesSubscription>;
export const FireSuppressionSystemDetailDocument = gql`
  query FireSuppressionSystemDetail($id: String!) {
    fireSuppressionSystemById(_id: $id) {
      _id
      deviceId
      name
      type
      location
      propertyId
      unitId
      panelId
      sourceId
      updateStatus
      timestamp
      meta {
        name
        metrics
      }
      installation {
        status
        message
      }
      powerState {
        value
        timestamp
      }
      typeDisplayName
      isConfigured
      isPoweredOn
      deviceIdentifier
      hasPendingUpdates
      isControlled
      fireSuppressionStatus {
        value
        timestamp
      }
      sensorStatus {
        value
        timestamp
      }
      suppressantLevel {
        value
        timestamp
        units
      }
      chartTypes
      property {
        _id
        title
      }
      unit {
        _id
        name
      }
      panel {
        _id
        name
        displayName
      }
      source {
        _id
        name
      }
    }
  }
`;

/**
 * __useFireSuppressionSystemDetailQuery__
 *
 * To run a query within a React component, call `useFireSuppressionSystemDetailQuery` and pass it any options that fit your needs.
 * When your component renders, `useFireSuppressionSystemDetailQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFireSuppressionSystemDetailQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useFireSuppressionSystemDetailQuery(
  baseOptions: Apollo.QueryHookOptions<
    FireSuppressionSystemDetailQuery,
    FireSuppressionSystemDetailQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    FireSuppressionSystemDetailQuery,
    FireSuppressionSystemDetailQueryVariables
  >(FireSuppressionSystemDetailDocument, options);
}
export function useFireSuppressionSystemDetailLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    FireSuppressionSystemDetailQuery,
    FireSuppressionSystemDetailQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    FireSuppressionSystemDetailQuery,
    FireSuppressionSystemDetailQueryVariables
  >(FireSuppressionSystemDetailDocument, options);
}
export type FireSuppressionSystemDetailQueryHookResult = ReturnType<
  typeof useFireSuppressionSystemDetailQuery
>;
export type FireSuppressionSystemDetailLazyQueryHookResult = ReturnType<
  typeof useFireSuppressionSystemDetailLazyQuery
>;
export type FireSuppressionSystemDetailQueryResult = Apollo.QueryResult<
  FireSuppressionSystemDetailQuery,
  FireSuppressionSystemDetailQueryVariables
>;
export const KineticEnergyManagementSystemDetailUpdatesDocument = gql`
  subscription KineticEnergyManagementSystemDetailUpdates($id: String!) {
    kineticEnergyManagementSystemEventsByIds(_ids: [$id]) {
      modelChangeOperation
      _id
      deviceId
      name
      type
      location
      propertyId
      unitId
      panelId
      sourceId
      updateStatus
      timestamp
      meta {
        name
        metrics
      }
      installation {
        status
        message
      }
      powerState {
        value
        timestamp
      }
      typeDisplayName
      isConfigured
      isPoweredOn
      deviceIdentifier
      hasPendingUpdates
      isControlled
      currentEnergyStored {
        value
        timestamp
        units
      }
      rotorSpeed {
        value
        timestamp
        units
      }
      spinDownTime {
        value
        timestamp
        units
      }
      generatorVoltage {
        value
        timestamp
        units
      }
      generatorCurrent {
        value
        timestamp
        units
      }
      bearingTemperature {
        value
        timestamp
        units
      }
      stateOfHealth {
        value
        timestamp
        units
      }
      systemEfficiency {
        value
        timestamp
        units
      }
      vibrationMetrics {
        value
        timestamp
        units
      }
      cycleCount {
        value
        timestamp
        units
      }
      vacuumPressure {
        value
        timestamp
        units
      }
      chartTypes
      property {
        _id
        title
      }
      unit {
        _id
        name
      }
      panel {
        _id
        name
        displayName
      }
      source {
        _id
        name
      }
    }
  }
`;

/**
 * __useKineticEnergyManagementSystemDetailUpdatesSubscription__
 *
 * To run a query within a React component, call `useKineticEnergyManagementSystemDetailUpdatesSubscription` and pass it any options that fit your needs.
 * When your component renders, `useKineticEnergyManagementSystemDetailUpdatesSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useKineticEnergyManagementSystemDetailUpdatesSubscription({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useKineticEnergyManagementSystemDetailUpdatesSubscription(
  baseOptions: Apollo.SubscriptionHookOptions<
    KineticEnergyManagementSystemDetailUpdatesSubscription,
    KineticEnergyManagementSystemDetailUpdatesSubscriptionVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useSubscription<
    KineticEnergyManagementSystemDetailUpdatesSubscription,
    KineticEnergyManagementSystemDetailUpdatesSubscriptionVariables
  >(KineticEnergyManagementSystemDetailUpdatesDocument, options);
}
export type KineticEnergyManagementSystemDetailUpdatesSubscriptionHookResult =
  ReturnType<typeof useKineticEnergyManagementSystemDetailUpdatesSubscription>;
export type KineticEnergyManagementSystemDetailUpdatesSubscriptionResult =
  Apollo.SubscriptionResult<KineticEnergyManagementSystemDetailUpdatesSubscription>;
export const KineticEnergyManagementSystemDetailDocument = gql`
  query KineticEnergyManagementSystemDetail($id: String!) {
    kineticEnergyManagementSystemById(_id: $id) {
      _id
      deviceId
      name
      type
      location
      propertyId
      unitId
      panelId
      sourceId
      updateStatus
      timestamp
      meta {
        name
        metrics
      }
      installation {
        status
        message
      }
      powerState {
        value
        timestamp
      }
      typeDisplayName
      isConfigured
      isPoweredOn
      deviceIdentifier
      hasPendingUpdates
      isControlled
      currentEnergyStored {
        value
        timestamp
        units
      }
      rotorSpeed {
        value
        timestamp
        units
      }
      spinDownTime {
        value
        timestamp
        units
      }
      generatorVoltage {
        value
        timestamp
        units
      }
      generatorCurrent {
        value
        timestamp
        units
      }
      bearingTemperature {
        value
        timestamp
        units
      }
      stateOfHealth {
        value
        timestamp
        units
      }
      systemEfficiency {
        value
        timestamp
        units
      }
      vibrationMetrics {
        value
        timestamp
        units
      }
      cycleCount {
        value
        timestamp
        units
      }
      vacuumPressure {
        value
        timestamp
        units
      }
      chartTypes
      property {
        _id
        title
      }
      unit {
        _id
        name
      }
      panel {
        _id
        name
        displayName
      }
      source {
        _id
        name
      }
    }
  }
`;

/**
 * __useKineticEnergyManagementSystemDetailQuery__
 *
 * To run a query within a React component, call `useKineticEnergyManagementSystemDetailQuery` and pass it any options that fit your needs.
 * When your component renders, `useKineticEnergyManagementSystemDetailQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useKineticEnergyManagementSystemDetailQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useKineticEnergyManagementSystemDetailQuery(
  baseOptions: Apollo.QueryHookOptions<
    KineticEnergyManagementSystemDetailQuery,
    KineticEnergyManagementSystemDetailQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    KineticEnergyManagementSystemDetailQuery,
    KineticEnergyManagementSystemDetailQueryVariables
  >(KineticEnergyManagementSystemDetailDocument, options);
}
export function useKineticEnergyManagementSystemDetailLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    KineticEnergyManagementSystemDetailQuery,
    KineticEnergyManagementSystemDetailQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    KineticEnergyManagementSystemDetailQuery,
    KineticEnergyManagementSystemDetailQueryVariables
  >(KineticEnergyManagementSystemDetailDocument, options);
}
export type KineticEnergyManagementSystemDetailQueryHookResult = ReturnType<
  typeof useKineticEnergyManagementSystemDetailQuery
>;
export type KineticEnergyManagementSystemDetailLazyQueryHookResult = ReturnType<
  typeof useKineticEnergyManagementSystemDetailLazyQuery
>;
export type KineticEnergyManagementSystemDetailQueryResult = Apollo.QueryResult<
  KineticEnergyManagementSystemDetailQuery,
  KineticEnergyManagementSystemDetailQueryVariables
>;
export const SolarManagementSystemDetailUpdatesDocument = gql`
  subscription SolarManagementSystemDetailUpdates($id: String!) {
    solarManagementSystemEventsByIds(_ids: [$id]) {
      modelChangeOperation
      _id
      deviceId
      name
      type
      location
      propertyId
      unitId
      panelId
      sourceId
      updateStatus
      timestamp
      meta {
        name
        metrics
      }
      installation {
        status
        message
      }
      powerState {
        value
        timestamp
      }
      typeDisplayName
      isConfigured
      isPoweredOn
      deviceIdentifier
      hasPendingUpdates
      isControlled
      solarIrradiance {
        value
        timestamp
        units
      }
      panelTemperature {
        value
        timestamp
        units
      }
      degradationRate {
        value
        timestamp
        units
      }
      shadingFactor {
        value
        timestamp
        units
      }
      tiltAngle {
        value
        timestamp
        units
      }
      azimuth {
        value
        timestamp
        units
      }
      panelVoltages {
        value
        timestamp
        units
      }
      panelCurrents {
        value
        timestamp
        units
      }
      isTrackerSystem {
        value
        timestamp
      }
      chartTypes
      property {
        _id
        title
      }
      panel {
        _id
        name
        displayName
      }
      source {
        _id
        name
      }
    }
  }
`;

/**
 * __useSolarManagementSystemDetailUpdatesSubscription__
 *
 * To run a query within a React component, call `useSolarManagementSystemDetailUpdatesSubscription` and pass it any options that fit your needs.
 * When your component renders, `useSolarManagementSystemDetailUpdatesSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSolarManagementSystemDetailUpdatesSubscription({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useSolarManagementSystemDetailUpdatesSubscription(
  baseOptions: Apollo.SubscriptionHookOptions<
    SolarManagementSystemDetailUpdatesSubscription,
    SolarManagementSystemDetailUpdatesSubscriptionVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useSubscription<
    SolarManagementSystemDetailUpdatesSubscription,
    SolarManagementSystemDetailUpdatesSubscriptionVariables
  >(SolarManagementSystemDetailUpdatesDocument, options);
}
export type SolarManagementSystemDetailUpdatesSubscriptionHookResult =
  ReturnType<typeof useSolarManagementSystemDetailUpdatesSubscription>;
export type SolarManagementSystemDetailUpdatesSubscriptionResult =
  Apollo.SubscriptionResult<SolarManagementSystemDetailUpdatesSubscription>;
export const SolarManagementSystemDetailDocument = gql`
  query SolarManagementSystemDetail($id: String!) {
    solarManagementSystemById(_id: $id) {
      _id
      deviceId
      name
      type
      location
      propertyId
      unitId
      panelId
      sourceId
      updateStatus
      timestamp
      meta {
        name
        metrics
      }
      installation {
        status
        message
      }
      powerState {
        value
        timestamp
      }
      typeDisplayName
      isConfigured
      isPoweredOn
      deviceIdentifier
      hasPendingUpdates
      isControlled
      solarIrradiance {
        value
        timestamp
        units
      }
      panelTemperature {
        value
        timestamp
        units
      }
      degradationRate {
        value
        timestamp
        units
      }
      shadingFactor {
        value
        timestamp
        units
      }
      tiltAngle {
        value
        timestamp
        units
      }
      azimuth {
        value
        timestamp
        units
      }
      panelVoltages {
        value
        timestamp
        units
      }
      panelCurrents {
        value
        timestamp
        units
      }
      isTrackerSystem {
        value
        timestamp
      }
      chartTypes
      property {
        _id
        title
      }
      panel {
        _id
        name
        displayName
      }
      source {
        _id
        name
      }
    }
  }
`;

/**
 * __useSolarManagementSystemDetailQuery__
 *
 * To run a query within a React component, call `useSolarManagementSystemDetailQuery` and pass it any options that fit your needs.
 * When your component renders, `useSolarManagementSystemDetailQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSolarManagementSystemDetailQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useSolarManagementSystemDetailQuery(
  baseOptions: Apollo.QueryHookOptions<
    SolarManagementSystemDetailQuery,
    SolarManagementSystemDetailQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    SolarManagementSystemDetailQuery,
    SolarManagementSystemDetailQueryVariables
  >(SolarManagementSystemDetailDocument, options);
}
export function useSolarManagementSystemDetailLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    SolarManagementSystemDetailQuery,
    SolarManagementSystemDetailQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    SolarManagementSystemDetailQuery,
    SolarManagementSystemDetailQueryVariables
  >(SolarManagementSystemDetailDocument, options);
}
export type SolarManagementSystemDetailQueryHookResult = ReturnType<
  typeof useSolarManagementSystemDetailQuery
>;
export type SolarManagementSystemDetailLazyQueryHookResult = ReturnType<
  typeof useSolarManagementSystemDetailLazyQuery
>;
export type SolarManagementSystemDetailQueryResult = Apollo.QueryResult<
  SolarManagementSystemDetailQuery,
  SolarManagementSystemDetailQueryVariables
>;
export const VirtualPowerPlantDetailUpdatesDocument = gql`
  subscription VirtualPowerPlantDetailUpdates($id: String!) {
    virtualPowerPlantEventsByIds(_ids: [$id]) {
      modelChangeOperation
      _id
      name
      location
      propertyId
      unitId
      updateStatus
      timestamp
      inverterId
      switchPanelId
      operationalStatus {
        value
        timestamp
      }
      chartTypes
    }
  }
`;

/**
 * __useVirtualPowerPlantDetailUpdatesSubscription__
 *
 * To run a query within a React component, call `useVirtualPowerPlantDetailUpdatesSubscription` and pass it any options that fit your needs.
 * When your component renders, `useVirtualPowerPlantDetailUpdatesSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useVirtualPowerPlantDetailUpdatesSubscription({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useVirtualPowerPlantDetailUpdatesSubscription(
  baseOptions: Apollo.SubscriptionHookOptions<
    VirtualPowerPlantDetailUpdatesSubscription,
    VirtualPowerPlantDetailUpdatesSubscriptionVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useSubscription<
    VirtualPowerPlantDetailUpdatesSubscription,
    VirtualPowerPlantDetailUpdatesSubscriptionVariables
  >(VirtualPowerPlantDetailUpdatesDocument, options);
}
export type VirtualPowerPlantDetailUpdatesSubscriptionHookResult = ReturnType<
  typeof useVirtualPowerPlantDetailUpdatesSubscription
>;
export type VirtualPowerPlantDetailUpdatesSubscriptionResult =
  Apollo.SubscriptionResult<VirtualPowerPlantDetailUpdatesSubscription>;
export const VirtualPowerPlantDetailDocument = gql`
  query VirtualPowerPlantDetail($id: String!) {
    virtualPowerPlantById(_id: $id) {
      _id
      name
      location
      propertyId
      unitId
      updateStatus
      timestamp
      inverterId
      switchPanelId
      operationalStatus {
        value
        timestamp
      }
      chartTypes
    }
  }
`;

/**
 * __useVirtualPowerPlantDetailQuery__
 *
 * To run a query within a React component, call `useVirtualPowerPlantDetailQuery` and pass it any options that fit your needs.
 * When your component renders, `useVirtualPowerPlantDetailQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useVirtualPowerPlantDetailQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useVirtualPowerPlantDetailQuery(
  baseOptions: Apollo.QueryHookOptions<
    VirtualPowerPlantDetailQuery,
    VirtualPowerPlantDetailQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    VirtualPowerPlantDetailQuery,
    VirtualPowerPlantDetailQueryVariables
  >(VirtualPowerPlantDetailDocument, options);
}
export function useVirtualPowerPlantDetailLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    VirtualPowerPlantDetailQuery,
    VirtualPowerPlantDetailQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    VirtualPowerPlantDetailQuery,
    VirtualPowerPlantDetailQueryVariables
  >(VirtualPowerPlantDetailDocument, options);
}
export type VirtualPowerPlantDetailQueryHookResult = ReturnType<
  typeof useVirtualPowerPlantDetailQuery
>;
export type VirtualPowerPlantDetailLazyQueryHookResult = ReturnType<
  typeof useVirtualPowerPlantDetailLazyQuery
>;
export type VirtualPowerPlantDetailQueryResult = Apollo.QueryResult<
  VirtualPowerPlantDetailQuery,
  VirtualPowerPlantDetailQueryVariables
>;
export const WindManagementSystemDetailUpdatesDocument = gql`
  subscription WindManagementSystemDetailUpdates($id: String!) {
    windManagementSystemEventsByIds(_ids: [$id]) {
      modelChangeOperation
      _id
      deviceId
      name
      type
      location
      powerState {
        value
        units
        timestamp
      }
      windSpeed {
        value
        units
        timestamp
      }
      windDirection {
        value
        units
        timestamp
      }
      rotorSpeed {
        value
        units
        timestamp
      }
      pitchAngle {
        value
        units
        timestamp
      }
      yawControlStatus {
        value
        timestamp
      }
      vibrationLevel {
        value
        units
        timestamp
      }
      generatorTemperature {
        value
        units
        timestamp
      }
      brakeStatus {
        value
        timestamp
      }
      bladeCondition {
        value
        timestamp
      }
      iceDetectionStatus {
        value
        timestamp
      }
      chartTypes
      property {
        _id
        name
      }
      unit {
        _id
        name
      }
      panel {
        _id
        name
      }
      source {
        _id
        name
      }
    }
  }
`;

/**
 * __useWindManagementSystemDetailUpdatesSubscription__
 *
 * To run a query within a React component, call `useWindManagementSystemDetailUpdatesSubscription` and pass it any options that fit your needs.
 * When your component renders, `useWindManagementSystemDetailUpdatesSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useWindManagementSystemDetailUpdatesSubscription({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useWindManagementSystemDetailUpdatesSubscription(
  baseOptions: Apollo.SubscriptionHookOptions<
    WindManagementSystemDetailUpdatesSubscription,
    WindManagementSystemDetailUpdatesSubscriptionVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useSubscription<
    WindManagementSystemDetailUpdatesSubscription,
    WindManagementSystemDetailUpdatesSubscriptionVariables
  >(WindManagementSystemDetailUpdatesDocument, options);
}
export type WindManagementSystemDetailUpdatesSubscriptionHookResult =
  ReturnType<typeof useWindManagementSystemDetailUpdatesSubscription>;
export type WindManagementSystemDetailUpdatesSubscriptionResult =
  Apollo.SubscriptionResult<WindManagementSystemDetailUpdatesSubscription>;
export const WindManagementSystemDetailDocument = gql`
  query WindManagementSystemDetail($id: String!) {
    windManagementSystemById(_id: $id) {
      _id
      deviceId
      name
      type
      location
      powerState {
        value
        units
        timestamp
      }
      windSpeed {
        value
        units
        timestamp
      }
      windDirection {
        value
        units
        timestamp
      }
      rotorSpeed {
        value
        units
        timestamp
      }
      pitchAngle {
        value
        units
        timestamp
      }
      yawControlStatus {
        value
        timestamp
      }
      vibrationLevel {
        value
        units
        timestamp
      }
      generatorTemperature {
        value
        units
        timestamp
      }
      brakeStatus {
        value
        timestamp
      }
      bladeCondition {
        value
        timestamp
      }
      iceDetectionStatus {
        value
        timestamp
      }
      chartTypes
      property {
        _id
        name
      }
      unit {
        _id
        name
      }
      panel {
        _id
        name
      }
      source {
        _id
        name
      }
    }
  }
`;

/**
 * __useWindManagementSystemDetailQuery__
 *
 * To run a query within a React component, call `useWindManagementSystemDetailQuery` and pass it any options that fit your needs.
 * When your component renders, `useWindManagementSystemDetailQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useWindManagementSystemDetailQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useWindManagementSystemDetailQuery(
  baseOptions: Apollo.QueryHookOptions<
    WindManagementSystemDetailQuery,
    WindManagementSystemDetailQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    WindManagementSystemDetailQuery,
    WindManagementSystemDetailQueryVariables
  >(WindManagementSystemDetailDocument, options);
}
export function useWindManagementSystemDetailLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    WindManagementSystemDetailQuery,
    WindManagementSystemDetailQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    WindManagementSystemDetailQuery,
    WindManagementSystemDetailQueryVariables
  >(WindManagementSystemDetailDocument, options);
}
export type WindManagementSystemDetailQueryHookResult = ReturnType<
  typeof useWindManagementSystemDetailQuery
>;
export type WindManagementSystemDetailLazyQueryHookResult = ReturnType<
  typeof useWindManagementSystemDetailLazyQuery
>;
export type WindManagementSystemDetailQueryResult = Apollo.QueryResult<
  WindManagementSystemDetailQuery,
  WindManagementSystemDetailQueryVariables
>;
export const CreateZonePolicyDocument = gql`
  mutation CreateZonePolicy($policy: CreateOneZonePolicyInput!) {
    createZonePolicy(policy: $policy) {
      _id
      name
      properties
      rules {
        type
        source {
          deviceType
          multiplicity
          attributes {
            operatingMode
            operatingState
            heatSetpoint
            coolSetpoint
            contactState
            fanSpeed
            indoorFanStatus
            keypadLockoutLevel
          }
        }
        target {
          deviceType
          multiplicity
          attributes {
            isOn
            heatSetpoint
            coolSetpoint
            keypadLockoutLevel
          }
        }
      }
    }
  }
`;
export type CreateZonePolicyMutationFn = Apollo.MutationFunction<
  CreateZonePolicyMutation,
  CreateZonePolicyMutationVariables
>;

/**
 * __useCreateZonePolicyMutation__
 *
 * To run a mutation, you first call `useCreateZonePolicyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateZonePolicyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createZonePolicyMutation, { data, loading, error }] = useCreateZonePolicyMutation({
 *   variables: {
 *      policy: // value for 'policy'
 *   },
 * });
 */
export function useCreateZonePolicyMutation(
  baseOptions?: Apollo.MutationHookOptions<
    CreateZonePolicyMutation,
    CreateZonePolicyMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    CreateZonePolicyMutation,
    CreateZonePolicyMutationVariables
  >(CreateZonePolicyDocument, options);
}
export type CreateZonePolicyMutationHookResult = ReturnType<
  typeof useCreateZonePolicyMutation
>;
export type CreateZonePolicyMutationResult =
  Apollo.MutationResult<CreateZonePolicyMutation>;
export type CreateZonePolicyMutationOptions = Apollo.BaseMutationOptions<
  CreateZonePolicyMutation,
  CreateZonePolicyMutationVariables
>;
export const DeleteZonePolicyDocument = gql`
  mutation DeleteZonePolicy($id: String!) {
    deleteZonePolicy(id: $id) {
      _id
      name
      properties
    }
  }
`;
export type DeleteZonePolicyMutationFn = Apollo.MutationFunction<
  DeleteZonePolicyMutation,
  DeleteZonePolicyMutationVariables
>;

/**
 * __useDeleteZonePolicyMutation__
 *
 * To run a mutation, you first call `useDeleteZonePolicyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteZonePolicyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteZonePolicyMutation, { data, loading, error }] = useDeleteZonePolicyMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteZonePolicyMutation(
  baseOptions?: Apollo.MutationHookOptions<
    DeleteZonePolicyMutation,
    DeleteZonePolicyMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    DeleteZonePolicyMutation,
    DeleteZonePolicyMutationVariables
  >(DeleteZonePolicyDocument, options);
}
export type DeleteZonePolicyMutationHookResult = ReturnType<
  typeof useDeleteZonePolicyMutation
>;
export type DeleteZonePolicyMutationResult =
  Apollo.MutationResult<DeleteZonePolicyMutation>;
export type DeleteZonePolicyMutationOptions = Apollo.BaseMutationOptions<
  DeleteZonePolicyMutation,
  DeleteZonePolicyMutationVariables
>;
export const SyncPropertyZonePoliciesFromCoresDocument = gql`
  query SyncPropertyZonePoliciesFromCores(
    $propertyId: String!
    $dryRun: Boolean!
  ) {
    syncPropertyZonePoliciesFromCores(
      propertyId: $propertyId
      dryRun: $dryRun
    ) {
      propertyId
      dryRun
      coresProcessed
      coresWithErrors
      reportTable
      rows
      applied {
        zonesUpdated
        zonePolicyIdsCleared
        policiesAddedToProperty
      }
    }
  }
`;

/**
 * __useSyncPropertyZonePoliciesFromCoresQuery__
 *
 * To run a query within a React component, call `useSyncPropertyZonePoliciesFromCoresQuery` and pass it any options that fit your needs.
 * When your component renders, `useSyncPropertyZonePoliciesFromCoresQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSyncPropertyZonePoliciesFromCoresQuery({
 *   variables: {
 *      propertyId: // value for 'propertyId'
 *      dryRun: // value for 'dryRun'
 *   },
 * });
 */
export function useSyncPropertyZonePoliciesFromCoresQuery(
  baseOptions: Apollo.QueryHookOptions<
    SyncPropertyZonePoliciesFromCoresQuery,
    SyncPropertyZonePoliciesFromCoresQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    SyncPropertyZonePoliciesFromCoresQuery,
    SyncPropertyZonePoliciesFromCoresQueryVariables
  >(SyncPropertyZonePoliciesFromCoresDocument, options);
}
export function useSyncPropertyZonePoliciesFromCoresLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    SyncPropertyZonePoliciesFromCoresQuery,
    SyncPropertyZonePoliciesFromCoresQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    SyncPropertyZonePoliciesFromCoresQuery,
    SyncPropertyZonePoliciesFromCoresQueryVariables
  >(SyncPropertyZonePoliciesFromCoresDocument, options);
}
export type SyncPropertyZonePoliciesFromCoresQueryHookResult = ReturnType<
  typeof useSyncPropertyZonePoliciesFromCoresQuery
>;
export type SyncPropertyZonePoliciesFromCoresLazyQueryHookResult = ReturnType<
  typeof useSyncPropertyZonePoliciesFromCoresLazyQuery
>;
export type SyncPropertyZonePoliciesFromCoresQueryResult = Apollo.QueryResult<
  SyncPropertyZonePoliciesFromCoresQuery,
  SyncPropertyZonePoliciesFromCoresQueryVariables
>;
export const UpdateZonePolicyDocument = gql`
  mutation UpdateZonePolicy($id: String!, $policy: UpdateOneZonePolicyInput!) {
    updateZonePolicy(id: $id, policy: $policy) {
      _id
      name
      properties
      rules {
        type
        source {
          deviceType
          multiplicity
          attributes {
            operatingMode
            operatingState
            heatSetpoint
            coolSetpoint
            contactState
            fanSpeed
            indoorFanStatus
            keypadLockoutLevel
          }
        }
        target {
          deviceType
          multiplicity
          attributes {
            heatSetpoint
            coolSetpoint
            isOn
            keypadLockoutLevel
          }
        }
      }
    }
  }
`;
export type UpdateZonePolicyMutationFn = Apollo.MutationFunction<
  UpdateZonePolicyMutation,
  UpdateZonePolicyMutationVariables
>;

/**
 * __useUpdateZonePolicyMutation__
 *
 * To run a mutation, you first call `useUpdateZonePolicyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateZonePolicyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateZonePolicyMutation, { data, loading, error }] = useUpdateZonePolicyMutation({
 *   variables: {
 *      id: // value for 'id'
 *      policy: // value for 'policy'
 *   },
 * });
 */
export function useUpdateZonePolicyMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UpdateZonePolicyMutation,
    UpdateZonePolicyMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    UpdateZonePolicyMutation,
    UpdateZonePolicyMutationVariables
  >(UpdateZonePolicyDocument, options);
}
export type UpdateZonePolicyMutationHookResult = ReturnType<
  typeof useUpdateZonePolicyMutation
>;
export type UpdateZonePolicyMutationResult =
  Apollo.MutationResult<UpdateZonePolicyMutation>;
export type UpdateZonePolicyMutationOptions = Apollo.BaseMutationOptions<
  UpdateZonePolicyMutation,
  UpdateZonePolicyMutationVariables
>;
export const UpdatePropertyZonePolicyOverrideDocument = gql`
  mutation UpdatePropertyZonePolicyOverride(
    $id: String!
    $zonePolicyId: String!
    $force: Boolean
  ) {
    updatePropertyZonePolicyOverride(
      id: $id
      zonePolicyId: $zonePolicyId
      force: $force
    ) {
      _id
      title
    }
  }
`;
export type UpdatePropertyZonePolicyOverrideMutationFn =
  Apollo.MutationFunction<
    UpdatePropertyZonePolicyOverrideMutation,
    UpdatePropertyZonePolicyOverrideMutationVariables
  >;

/**
 * __useUpdatePropertyZonePolicyOverrideMutation__
 *
 * To run a mutation, you first call `useUpdatePropertyZonePolicyOverrideMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdatePropertyZonePolicyOverrideMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updatePropertyZonePolicyOverrideMutation, { data, loading, error }] = useUpdatePropertyZonePolicyOverrideMutation({
 *   variables: {
 *      id: // value for 'id'
 *      zonePolicyId: // value for 'zonePolicyId'
 *      force: // value for 'force'
 *   },
 * });
 */
export function useUpdatePropertyZonePolicyOverrideMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UpdatePropertyZonePolicyOverrideMutation,
    UpdatePropertyZonePolicyOverrideMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    UpdatePropertyZonePolicyOverrideMutation,
    UpdatePropertyZonePolicyOverrideMutationVariables
  >(UpdatePropertyZonePolicyOverrideDocument, options);
}
export type UpdatePropertyZonePolicyOverrideMutationHookResult = ReturnType<
  typeof useUpdatePropertyZonePolicyOverrideMutation
>;
export type UpdatePropertyZonePolicyOverrideMutationResult =
  Apollo.MutationResult<UpdatePropertyZonePolicyOverrideMutation>;
export type UpdatePropertyZonePolicyOverrideMutationOptions =
  Apollo.BaseMutationOptions<
    UpdatePropertyZonePolicyOverrideMutation,
    UpdatePropertyZonePolicyOverrideMutationVariables
  >;
export const UpdateUnitZonePolicyOverrideDocument = gql`
  mutation UpdateUnitZonePolicyOverride(
    $id: String!
    $zonePolicyId: String!
    $force: Boolean
  ) {
    updateUnitZonePolicyOverride(
      id: $id
      zonePolicyId: $zonePolicyId
      force: $force
    ) {
      _id
      name
    }
  }
`;
export type UpdateUnitZonePolicyOverrideMutationFn = Apollo.MutationFunction<
  UpdateUnitZonePolicyOverrideMutation,
  UpdateUnitZonePolicyOverrideMutationVariables
>;

/**
 * __useUpdateUnitZonePolicyOverrideMutation__
 *
 * To run a mutation, you first call `useUpdateUnitZonePolicyOverrideMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateUnitZonePolicyOverrideMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateUnitZonePolicyOverrideMutation, { data, loading, error }] = useUpdateUnitZonePolicyOverrideMutation({
 *   variables: {
 *      id: // value for 'id'
 *      zonePolicyId: // value for 'zonePolicyId'
 *      force: // value for 'force'
 *   },
 * });
 */
export function useUpdateUnitZonePolicyOverrideMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UpdateUnitZonePolicyOverrideMutation,
    UpdateUnitZonePolicyOverrideMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    UpdateUnitZonePolicyOverrideMutation,
    UpdateUnitZonePolicyOverrideMutationVariables
  >(UpdateUnitZonePolicyOverrideDocument, options);
}
export type UpdateUnitZonePolicyOverrideMutationHookResult = ReturnType<
  typeof useUpdateUnitZonePolicyOverrideMutation
>;
export type UpdateUnitZonePolicyOverrideMutationResult =
  Apollo.MutationResult<UpdateUnitZonePolicyOverrideMutation>;
export type UpdateUnitZonePolicyOverrideMutationOptions =
  Apollo.BaseMutationOptions<
    UpdateUnitZonePolicyOverrideMutation,
    UpdateUnitZonePolicyOverrideMutationVariables
  >;
export const ZonePolicyCountDocument = gql`
  query ZonePolicyCount {
    zonePolicyCount
  }
`;

/**
 * __useZonePolicyCountQuery__
 *
 * To run a query within a React component, call `useZonePolicyCountQuery` and pass it any options that fit your needs.
 * When your component renders, `useZonePolicyCountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useZonePolicyCountQuery({
 *   variables: {
 *   },
 * });
 */
export function useZonePolicyCountQuery(
  baseOptions?: Apollo.QueryHookOptions<
    ZonePolicyCountQuery,
    ZonePolicyCountQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<ZonePolicyCountQuery, ZonePolicyCountQueryVariables>(
    ZonePolicyCountDocument,
    options,
  );
}
export function useZonePolicyCountLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    ZonePolicyCountQuery,
    ZonePolicyCountQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    ZonePolicyCountQuery,
    ZonePolicyCountQueryVariables
  >(ZonePolicyCountDocument, options);
}
export type ZonePolicyCountQueryHookResult = ReturnType<
  typeof useZonePolicyCountQuery
>;
export type ZonePolicyCountLazyQueryHookResult = ReturnType<
  typeof useZonePolicyCountLazyQuery
>;
export type ZonePolicyCountQueryResult = Apollo.QueryResult<
  ZonePolicyCountQuery,
  ZonePolicyCountQueryVariables
>;
export const ZonePolicyDetailUpdateDocument = gql`
  subscription ZonePolicyDetailUpdate($ids: [String!]!) {
    zonePolicyEventsByIds(_ids: $ids) {
      modelChangeOperation
      _id
      name
      properties
      rules {
        type
        source {
          deviceType
          multiplicity
          attributes {
            operatingMode
            operatingState
            heatSetpoint
            coolSetpoint
            contactState
            fanSpeed
            indoorFanStatus
            keypadLockoutLevel
          }
        }
        target {
          deviceType
          multiplicity
          attributes {
            heatSetpoint
            coolSetpoint
            isOn
            keypadLockoutLevel
          }
        }
      }
    }
  }
`;

/**
 * __useZonePolicyDetailUpdateSubscription__
 *
 * To run a query within a React component, call `useZonePolicyDetailUpdateSubscription` and pass it any options that fit your needs.
 * When your component renders, `useZonePolicyDetailUpdateSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useZonePolicyDetailUpdateSubscription({
 *   variables: {
 *      ids: // value for 'ids'
 *   },
 * });
 */
export function useZonePolicyDetailUpdateSubscription(
  baseOptions: Apollo.SubscriptionHookOptions<
    ZonePolicyDetailUpdateSubscription,
    ZonePolicyDetailUpdateSubscriptionVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useSubscription<
    ZonePolicyDetailUpdateSubscription,
    ZonePolicyDetailUpdateSubscriptionVariables
  >(ZonePolicyDetailUpdateDocument, options);
}
export type ZonePolicyDetailUpdateSubscriptionHookResult = ReturnType<
  typeof useZonePolicyDetailUpdateSubscription
>;
export type ZonePolicyDetailUpdateSubscriptionResult =
  Apollo.SubscriptionResult<ZonePolicyDetailUpdateSubscription>;
export const ZonePolicyDetailDocument = gql`
  query ZonePolicyDetail($_id: MongoID!) {
    zonePolicyById(_id: $_id) {
      _id
      name
      properties
      rules {
        type
        source {
          deviceType
          multiplicity
          attributes {
            operatingMode
            operatingState
            heatSetpoint
            coolSetpoint
            contactState
            fanSpeed
            indoorFanStatus
            keypadLockoutLevel
          }
        }
        target {
          deviceType
          multiplicity
          attributes {
            heatSetpoint
            coolSetpoint
            isOn
            keypadLockoutLevel
          }
        }
      }
    }
  }
`;

/**
 * __useZonePolicyDetailQuery__
 *
 * To run a query within a React component, call `useZonePolicyDetailQuery` and pass it any options that fit your needs.
 * When your component renders, `useZonePolicyDetailQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useZonePolicyDetailQuery({
 *   variables: {
 *      _id: // value for '_id'
 *   },
 * });
 */
export function useZonePolicyDetailQuery(
  baseOptions: Apollo.QueryHookOptions<
    ZonePolicyDetailQuery,
    ZonePolicyDetailQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<ZonePolicyDetailQuery, ZonePolicyDetailQueryVariables>(
    ZonePolicyDetailDocument,
    options,
  );
}
export function useZonePolicyDetailLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    ZonePolicyDetailQuery,
    ZonePolicyDetailQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    ZonePolicyDetailQuery,
    ZonePolicyDetailQueryVariables
  >(ZonePolicyDetailDocument, options);
}
export type ZonePolicyDetailQueryHookResult = ReturnType<
  typeof useZonePolicyDetailQuery
>;
export type ZonePolicyDetailLazyQueryHookResult = ReturnType<
  typeof useZonePolicyDetailLazyQuery
>;
export type ZonePolicyDetailQueryResult = Apollo.QueryResult<
  ZonePolicyDetailQuery,
  ZonePolicyDetailQueryVariables
>;
export const ZonePolicyDetailBreadcrumbDocument = gql`
  query ZonePolicyDetailBreadcrumb($id: MongoID!) {
    zonePolicyById(_id: $id) {
      _id
      name
    }
  }
`;

/**
 * __useZonePolicyDetailBreadcrumbQuery__
 *
 * To run a query within a React component, call `useZonePolicyDetailBreadcrumbQuery` and pass it any options that fit your needs.
 * When your component renders, `useZonePolicyDetailBreadcrumbQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useZonePolicyDetailBreadcrumbQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useZonePolicyDetailBreadcrumbQuery(
  baseOptions: Apollo.QueryHookOptions<
    ZonePolicyDetailBreadcrumbQuery,
    ZonePolicyDetailBreadcrumbQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    ZonePolicyDetailBreadcrumbQuery,
    ZonePolicyDetailBreadcrumbQueryVariables
  >(ZonePolicyDetailBreadcrumbDocument, options);
}
export function useZonePolicyDetailBreadcrumbLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    ZonePolicyDetailBreadcrumbQuery,
    ZonePolicyDetailBreadcrumbQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    ZonePolicyDetailBreadcrumbQuery,
    ZonePolicyDetailBreadcrumbQueryVariables
  >(ZonePolicyDetailBreadcrumbDocument, options);
}
export type ZonePolicyDetailBreadcrumbQueryHookResult = ReturnType<
  typeof useZonePolicyDetailBreadcrumbQuery
>;
export type ZonePolicyDetailBreadcrumbLazyQueryHookResult = ReturnType<
  typeof useZonePolicyDetailBreadcrumbLazyQuery
>;
export type ZonePolicyDetailBreadcrumbQueryResult = Apollo.QueryResult<
  ZonePolicyDetailBreadcrumbQuery,
  ZonePolicyDetailBreadcrumbQueryVariables
>;
export const ZonePolicyListDocument = gql`
  query ZonePolicyList {
    zonePolicies(limit: 0) {
      _id
      name
      rules {
        source {
          attributes {
            keypadLockoutLevel
            indoorFanStatus
            fanSpeed
            contactState
            coolSetpoint
            operatingMode
            operatingState
            heatSetpoint
          }
          deviceType
          multiplicity
        }
        target {
          attributes {
            coolSetpoint
            heatSetpoint
            isOn
            keypadLockoutLevel
          }
          deviceType
          multiplicity
        }
        type
      }
      enabledProperties {
        _id
        title
      }
      assignedProperties {
        _id
        title
      }
      assignedUnits {
        _id
        name
      }
    }
  }
`;

/**
 * __useZonePolicyListQuery__
 *
 * To run a query within a React component, call `useZonePolicyListQuery` and pass it any options that fit your needs.
 * When your component renders, `useZonePolicyListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useZonePolicyListQuery({
 *   variables: {
 *   },
 * });
 */
export function useZonePolicyListQuery(
  baseOptions?: Apollo.QueryHookOptions<
    ZonePolicyListQuery,
    ZonePolicyListQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<ZonePolicyListQuery, ZonePolicyListQueryVariables>(
    ZonePolicyListDocument,
    options,
  );
}
export function useZonePolicyListLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    ZonePolicyListQuery,
    ZonePolicyListQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<ZonePolicyListQuery, ZonePolicyListQueryVariables>(
    ZonePolicyListDocument,
    options,
  );
}
export type ZonePolicyListQueryHookResult = ReturnType<
  typeof useZonePolicyListQuery
>;
export type ZonePolicyListLazyQueryHookResult = ReturnType<
  typeof useZonePolicyListLazyQuery
>;
export type ZonePolicyListQueryResult = Apollo.QueryResult<
  ZonePolicyListQuery,
  ZonePolicyListQueryVariables
>;
export const ZonePolicyListUpdateDocument = gql`
  subscription ZonePolicyListUpdate {
    zonePolicyEvents {
      modelChangeOperation
      _id
      name
      enabledProperties {
        _id
        title
      }
      assignedProperties {
        _id
        title
      }
      assignedUnits {
        _id
        name
      }
    }
  }
`;

/**
 * __useZonePolicyListUpdateSubscription__
 *
 * To run a query within a React component, call `useZonePolicyListUpdateSubscription` and pass it any options that fit your needs.
 * When your component renders, `useZonePolicyListUpdateSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useZonePolicyListUpdateSubscription({
 *   variables: {
 *   },
 * });
 */
export function useZonePolicyListUpdateSubscription(
  baseOptions?: Apollo.SubscriptionHookOptions<
    ZonePolicyListUpdateSubscription,
    ZonePolicyListUpdateSubscriptionVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useSubscription<
    ZonePolicyListUpdateSubscription,
    ZonePolicyListUpdateSubscriptionVariables
  >(ZonePolicyListUpdateDocument, options);
}
export type ZonePolicyListUpdateSubscriptionHookResult = ReturnType<
  typeof useZonePolicyListUpdateSubscription
>;
export type ZonePolicyListUpdateSubscriptionResult =
  Apollo.SubscriptionResult<ZonePolicyListUpdateSubscription>;
export const ZonePolicyUpdateVerificationDocument = gql`
  query ZonePolicyUpdateVerification(
    $id: String!
    $propertyIds: [String!]
    $unitId: String
  ) {
    zonePolicyUpdateVerification(
      id: $id
      propertyIds: $propertyIds
      unitId: $unitId
    ) {
      _id
      name
      totalZones
      onlineZones
      excludedZones
    }
  }
`;

/**
 * __useZonePolicyUpdateVerificationQuery__
 *
 * To run a query within a React component, call `useZonePolicyUpdateVerificationQuery` and pass it any options that fit your needs.
 * When your component renders, `useZonePolicyUpdateVerificationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useZonePolicyUpdateVerificationQuery({
 *   variables: {
 *      id: // value for 'id'
 *      propertyIds: // value for 'propertyIds'
 *      unitId: // value for 'unitId'
 *   },
 * });
 */
export function useZonePolicyUpdateVerificationQuery(
  baseOptions: Apollo.QueryHookOptions<
    ZonePolicyUpdateVerificationQuery,
    ZonePolicyUpdateVerificationQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    ZonePolicyUpdateVerificationQuery,
    ZonePolicyUpdateVerificationQueryVariables
  >(ZonePolicyUpdateVerificationDocument, options);
}
export function useZonePolicyUpdateVerificationLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    ZonePolicyUpdateVerificationQuery,
    ZonePolicyUpdateVerificationQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    ZonePolicyUpdateVerificationQuery,
    ZonePolicyUpdateVerificationQueryVariables
  >(ZonePolicyUpdateVerificationDocument, options);
}
export type ZonePolicyUpdateVerificationQueryHookResult = ReturnType<
  typeof useZonePolicyUpdateVerificationQuery
>;
export type ZonePolicyUpdateVerificationLazyQueryHookResult = ReturnType<
  typeof useZonePolicyUpdateVerificationLazyQuery
>;
export type ZonePolicyUpdateVerificationQueryResult = Apollo.QueryResult<
  ZonePolicyUpdateVerificationQuery,
  ZonePolicyUpdateVerificationQueryVariables
>;
